{
  "manifest": {
    "sourceName": "United States International Trade Commission Harmonized Tariff Schedule",
    "revisionLabel": "2026 HTS Revision 7",
    "releaseDate": "2026-04-30",
    "archiveUrl": "https://www.usitc.gov/harmonized_tariff_information/hts/archive/list",
    "jsonDownloadUrl": "Local source import from htsdata.json"
  },
  "records": [
    {
      "htsCode": "0101",
      "rawHtsCode": "0101",
      "superior": null,
      "indent": "0",
      "description": "Live horses, asses, mules and hinnies:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0101.21.00",
      "rawHtsCode": "0101.21.00",
      "superior": null,
      "indent": "2",
      "description": "Purebred breeding animals",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0101.21.0010",
      "rawHtsCode": "0101.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Males",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0101.21.0020",
      "rawHtsCode": "0101.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Females",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0101.29.00",
      "rawHtsCode": "0101.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0101.29.0010",
      "rawHtsCode": "0101.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Imported for immediate slaughter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0101.29.0090",
      "rawHtsCode": "0101.29.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0101.30.0000",
      "rawHtsCode": "0101.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Asses",
      "units": [
        "No."
      ],
      "generalRate": "6.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0101.90",
      "rawHtsCode": "0101.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0101.90.3000",
      "rawHtsCode": "0101.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Imported for immediate slaughter",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0101.90.4000",
      "rawHtsCode": "0101.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0102",
      "rawHtsCode": "0102",
      "superior": null,
      "indent": "0",
      "description": "Live bovine animals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.21.00",
      "rawHtsCode": "0102.21.00",
      "superior": null,
      "indent": "2",
      "description": "Purebred breeding animals",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0102.21.0010",
      "rawHtsCode": "0102.21.00.10",
      "superior": null,
      "indent": "4",
      "description": "Male",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.21.0020",
      "rawHtsCode": "0102.21.00.20",
      "superior": null,
      "indent": "4",
      "description": "Female",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.21.0030",
      "rawHtsCode": "0102.21.00.30",
      "superior": null,
      "indent": "4",
      "description": "Male",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.21.0050",
      "rawHtsCode": "0102.21.00.50",
      "superior": null,
      "indent": "4",
      "description": "Female",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29",
      "rawHtsCode": "0102.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.20",
      "rawHtsCode": "0102.29.20",
      "superior": null,
      "indent": "3",
      "description": "Cows imported specially for dairy purposes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0102.29.2011",
      "rawHtsCode": "0102.29.20.11",
      "superior": null,
      "indent": "4",
      "description": "Weighing less than 90 kg each",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.2012",
      "rawHtsCode": "0102.29.20.12",
      "superior": null,
      "indent": "4",
      "description": "Weighing 90 kg or more each",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.40",
      "rawHtsCode": "0102.29.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0102.29.4024",
      "rawHtsCode": "0102.29.40.24",
      "superior": null,
      "indent": "5",
      "description": "Male",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4028",
      "rawHtsCode": "0102.29.40.28",
      "superior": null,
      "indent": "5",
      "description": "Female",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4034",
      "rawHtsCode": "0102.29.40.34",
      "superior": null,
      "indent": "5",
      "description": "Male",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4038",
      "rawHtsCode": "0102.29.40.38",
      "superior": null,
      "indent": "5",
      "description": "Female",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4054",
      "rawHtsCode": "0102.29.40.54",
      "superior": null,
      "indent": "5",
      "description": "Male",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4058",
      "rawHtsCode": "0102.29.40.58",
      "superior": null,
      "indent": "5",
      "description": "Female",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4062",
      "rawHtsCode": "0102.29.40.62",
      "superior": null,
      "indent": "6",
      "description": "Steers",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4064",
      "rawHtsCode": "0102.29.40.64",
      "superior": null,
      "indent": "6",
      "description": "Bulls",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4066",
      "rawHtsCode": "0102.29.40.66",
      "superior": null,
      "indent": "6",
      "description": "Cows",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4068",
      "rawHtsCode": "0102.29.40.68",
      "superior": null,
      "indent": "6",
      "description": "Heifers",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4072",
      "rawHtsCode": "0102.29.40.72",
      "superior": null,
      "indent": "6",
      "description": "Male",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4074",
      "rawHtsCode": "0102.29.40.74",
      "superior": null,
      "indent": "6",
      "description": "Female",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4082",
      "rawHtsCode": "0102.29.40.82",
      "superior": null,
      "indent": "6",
      "description": "Male",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.29.4084",
      "rawHtsCode": "0102.29.40.84",
      "superior": null,
      "indent": "6",
      "description": "Female",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.31.00",
      "rawHtsCode": "0102.31.00",
      "superior": null,
      "indent": "2",
      "description": "Purebred breeding animals",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0102.31.0010",
      "rawHtsCode": "0102.31.00.10",
      "superior": null,
      "indent": "3",
      "description": "Male",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.31.0020",
      "rawHtsCode": "0102.31.00.20",
      "superior": null,
      "indent": "3",
      "description": "Female",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.39.00",
      "rawHtsCode": "0102.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0102.39.0010",
      "rawHtsCode": "0102.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Bison",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.39.0024",
      "rawHtsCode": "0102.39.00.24",
      "superior": null,
      "indent": "5",
      "description": "Male",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.39.0028",
      "rawHtsCode": "0102.39.00.28",
      "superior": null,
      "indent": "5",
      "description": "Female",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.39.0034",
      "rawHtsCode": "0102.39.00.34",
      "superior": null,
      "indent": "5",
      "description": "Male",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.39.0038",
      "rawHtsCode": "0102.39.00.38",
      "superior": null,
      "indent": "5",
      "description": "Female",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.39.0054",
      "rawHtsCode": "0102.39.00.54",
      "superior": null,
      "indent": "5",
      "description": "Male",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.39.0058",
      "rawHtsCode": "0102.39.00.58",
      "superior": null,
      "indent": "5",
      "description": "Female",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.39.0061",
      "rawHtsCode": "0102.39.00.61",
      "superior": null,
      "indent": "5",
      "description": "For immediate slaughter",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.39.0072",
      "rawHtsCode": "0102.39.00.72",
      "superior": null,
      "indent": "6",
      "description": "Male",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.39.0074",
      "rawHtsCode": "0102.39.00.74",
      "superior": null,
      "indent": "6",
      "description": "Female",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.39.0082",
      "rawHtsCode": "0102.39.00.82",
      "superior": null,
      "indent": "6",
      "description": "Male",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.39.0084",
      "rawHtsCode": "0102.39.00.84",
      "superior": null,
      "indent": "6",
      "description": "Female",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0102.90.0000",
      "rawHtsCode": "0102.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0103",
      "rawHtsCode": "0103",
      "superior": null,
      "indent": "0",
      "description": "Live swine:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0103.10.0000",
      "rawHtsCode": "0103.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Purebred breeding animals",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0103.91.00",
      "rawHtsCode": "0103.91.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing less than 50 kg each",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0103.91.0010",
      "rawHtsCode": "0103.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Weighing less than 7 kg each",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0103.91.0020",
      "rawHtsCode": "0103.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Weighing 7 kg or more but less than 23 kg each",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0103.91.0030",
      "rawHtsCode": "0103.91.00.30",
      "superior": null,
      "indent": "3",
      "description": "Weighing 23 kg or more but less than 50 kg each",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0103.92.00",
      "rawHtsCode": "0103.92.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing 50 kg or more each",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0103.92.0010",
      "rawHtsCode": "0103.92.00.10",
      "superior": null,
      "indent": "3",
      "description": "Imported for immediate slaughter",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0103.92.0020",
      "rawHtsCode": "0103.92.00.20",
      "superior": null,
      "indent": "3",
      "description": "Breeding animals other than purebred breeding animals",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0103.92.0091",
      "rawHtsCode": "0103.92.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0104",
      "rawHtsCode": "0104",
      "superior": null,
      "indent": "0",
      "description": "Live sheep and goats:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0104.10.0000",
      "rawHtsCode": "0104.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sheep",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$3/head",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0104.20.0000",
      "rawHtsCode": "0104.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Goats",
      "units": [
        "No."
      ],
      "generalRate": "68¢/head",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "$3/head",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0105",
      "rawHtsCode": "0105",
      "superior": null,
      "indent": "0",
      "description": "Live poultry of the following kinds: Chickens, ducks, geese, turkeys and guineas:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0105.11.00",
      "rawHtsCode": "0105.11.00",
      "superior": null,
      "indent": "2",
      "description": "Chickens",
      "units": [],
      "generalRate": "0.9¢ each",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "4¢ each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0105.11.0010",
      "rawHtsCode": "0105.11.00.10",
      "superior": null,
      "indent": "4",
      "description": "Layer-type (egg-type)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0105.11.0020",
      "rawHtsCode": "0105.11.00.20",
      "superior": null,
      "indent": "4",
      "description": "Broiler-type (meat-type)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0105.11.0040",
      "rawHtsCode": "0105.11.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0105.12.0000",
      "rawHtsCode": "0105.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Turkeys",
      "units": [
        "No."
      ],
      "generalRate": "0.9¢ each",
      "specialRate": "Free (A+,AU,BH, CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "4¢ each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0105.13.0000",
      "rawHtsCode": "0105.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ducks",
      "units": [
        "No."
      ],
      "generalRate": "0.9¢ each",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4¢ each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0105.14.0000",
      "rawHtsCode": "0105.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Geese",
      "units": [
        "No."
      ],
      "generalRate": "0.9¢ each",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "4¢ each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0105.15.0000",
      "rawHtsCode": "0105.15.00.00",
      "superior": null,
      "indent": "2",
      "description": "Guinea fowls",
      "units": [
        "No."
      ],
      "generalRate": "0.9¢ each",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "4¢ each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0105.94.0000",
      "rawHtsCode": "0105.94.00.00",
      "superior": null,
      "indent": "2",
      "description": "Chickens",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0105.99.0000",
      "rawHtsCode": "0105.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0106",
      "rawHtsCode": "0106",
      "superior": null,
      "indent": "0",
      "description": "Other live animals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0106.11.0000",
      "rawHtsCode": "0106.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Primates",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0106.12.0100",
      "rawHtsCode": "0106.12.01.00",
      "superior": null,
      "indent": "2",
      "description": "Whales, dolphins and porpoises (mammals of the order Cetacea); manatees and dugongs (mammals of the order Sirenia); seals, sea lions and walruses (mammals of the suborder Pinnipedia)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0106.13.0000",
      "rawHtsCode": "0106.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Camels and other camelids (Camelidae)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0106.14.0000",
      "rawHtsCode": "0106.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Rabbits and hares",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0106.19",
      "rawHtsCode": "0106.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0106.19.3000",
      "rawHtsCode": "0106.19.30.00",
      "superior": null,
      "indent": "3",
      "description": "Foxes",
      "units": [
        "No."
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0106.19.91",
      "rawHtsCode": "0106.19.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0106.19.9120",
      "rawHtsCode": "0106.19.91.20",
      "superior": null,
      "indent": "4",
      "description": "Dogs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0106.19.9195",
      "rawHtsCode": "0106.19.91.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0106.20.0000",
      "rawHtsCode": "0106.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Reptiles (including snakes and turtles)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0106.31.0000",
      "rawHtsCode": "0106.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Birds of prey",
      "units": [
        "No."
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0106.32.0000",
      "rawHtsCode": "0106.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Psittaciformes (including parrots, parakeets, macaws and cockatoos)",
      "units": [
        "No."
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0106.33.0000",
      "rawHtsCode": "0106.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ostriches; emus (Dromaius novaehollandiae)",
      "units": [
        "No."
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0106.39.0100",
      "rawHtsCode": "0106.39.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0106.41.0000",
      "rawHtsCode": "0106.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Bees",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0106.49.00",
      "rawHtsCode": "0106.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0106.49.0010",
      "rawHtsCode": "0106.49.00.10",
      "superior": null,
      "indent": "3",
      "description": "Leaf cutter bee larvae",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0106.49.0090",
      "rawHtsCode": "0106.49.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0106.90.01",
      "rawHtsCode": "0106.90.01",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0106.90.0110",
      "rawHtsCode": "0106.90.01.10",
      "superior": null,
      "indent": "2",
      "description": "Worms",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0106.90.0120",
      "rawHtsCode": "0106.90.01.20",
      "superior": null,
      "indent": "2",
      "description": "Bait (other than worms)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0106.90.0180",
      "rawHtsCode": "0106.90.01.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201",
      "rawHtsCode": "0201",
      "superior": null,
      "indent": "0",
      "description": "Meat of bovine animals, fresh or chilled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.10",
      "rawHtsCode": "0201.10",
      "superior": null,
      "indent": "1",
      "description": "Carcasses and half-carcasses:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.10.05",
      "rawHtsCode": "0201.10.05",
      "superior": null,
      "indent": "2",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.10.0510",
      "rawHtsCode": "0201.10.05.10",
      "superior": null,
      "indent": "3",
      "description": "Veal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.10.0590",
      "rawHtsCode": "0201.10.05.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.10.10",
      "rawHtsCode": "0201.10.10",
      "superior": null,
      "indent": "2",
      "description": "Described in additional U.S. note 3 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.10.1010",
      "rawHtsCode": "0201.10.10.10",
      "superior": null,
      "indent": "3",
      "description": "Veal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.10.1090",
      "rawHtsCode": "0201.10.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.10.50",
      "rawHtsCode": "0201.10.50",
      "superior": null,
      "indent": "2",
      "description": "Other ",
      "units": [],
      "generalRate": "26.4%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PE,S,SG) See 9822.04.01-9822.04.03 (AU) See 9919.02.01-9919.02.02 (PA)",
      "otherRate": "31.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.02.01-9904.02.37. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.10.5010",
      "rawHtsCode": "0201.10.50.10",
      "superior": null,
      "indent": "3",
      "description": "Veal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.10.5090",
      "rawHtsCode": "0201.10.50.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.20",
      "rawHtsCode": "0201.20",
      "superior": null,
      "indent": "1",
      "description": "Other cuts with bone in:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.20.0200",
      "rawHtsCode": "0201.20.02.00",
      "superior": null,
      "indent": "4",
      "description": "High-quality beef cuts",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.20.0400",
      "rawHtsCode": "0201.20.04.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.20.0600",
      "rawHtsCode": "0201.20.06.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.20.1000",
      "rawHtsCode": "0201.20.10.00",
      "superior": null,
      "indent": "4",
      "description": "High-quality beef cuts",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.20.3000",
      "rawHtsCode": "0201.20.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.20.50",
      "rawHtsCode": "0201.20.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.20.5015",
      "rawHtsCode": "0201.20.50.15",
      "superior": null,
      "indent": "4",
      "description": "Fresh or chilled bone in veal cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.20.5025",
      "rawHtsCode": "0201.20.50.25",
      "superior": null,
      "indent": "5",
      "description": "Rib cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.20.5035",
      "rawHtsCode": "0201.20.50.35",
      "superior": null,
      "indent": "5",
      "description": "Chuck cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.20.5045",
      "rawHtsCode": "0201.20.50.45",
      "superior": null,
      "indent": "5",
      "description": "Loin cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.20.5065",
      "rawHtsCode": "0201.20.50.65",
      "superior": null,
      "indent": "5",
      "description": "Hip cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.20.5075",
      "rawHtsCode": "0201.20.50.75",
      "superior": null,
      "indent": "5",
      "description": "Flank or plate cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.20.5091",
      "rawHtsCode": "0201.20.50.91",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.20.80",
      "rawHtsCode": "0201.20.80",
      "superior": null,
      "indent": "2",
      "description": "Other ",
      "units": [],
      "generalRate": "26.4%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PE,S,SG) See 9822.04.01-9822.04.03 (AU) See 9919.02.01-9919.02.02 (PA)",
      "otherRate": "31.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.02.01-9904.02.37. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.20.8010",
      "rawHtsCode": "0201.20.80.10",
      "superior": null,
      "indent": "3",
      "description": "Bison",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.20.8090",
      "rawHtsCode": "0201.20.80.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.30",
      "rawHtsCode": "0201.30",
      "superior": null,
      "indent": "1",
      "description": "Boneless:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.30.0200",
      "rawHtsCode": "0201.30.02.00",
      "superior": null,
      "indent": "4",
      "description": "High-quality beef cuts",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM, P,PA, PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.30.0400",
      "rawHtsCode": "0201.30.04.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.30.0600",
      "rawHtsCode": "0201.30.06.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.30.1000",
      "rawHtsCode": "0201.30.10.00",
      "superior": null,
      "indent": "4",
      "description": "High-quality beef cuts",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.30.3000",
      "rawHtsCode": "0201.30.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.30.50",
      "rawHtsCode": "0201.30.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.30.5015",
      "rawHtsCode": "0201.30.50.15",
      "superior": null,
      "indent": "4",
      "description": "Fresh or chilled boneless veal cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.30.5025",
      "rawHtsCode": "0201.30.50.25",
      "superior": null,
      "indent": "5",
      "description": "Rib cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.30.5035",
      "rawHtsCode": "0201.30.50.35",
      "superior": null,
      "indent": "5",
      "description": "Chuck cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.30.5045",
      "rawHtsCode": "0201.30.50.45",
      "superior": null,
      "indent": "5",
      "description": "Loin cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.30.5055",
      "rawHtsCode": "0201.30.50.55",
      "superior": null,
      "indent": "5",
      "description": "Brisket cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.30.5065",
      "rawHtsCode": "0201.30.50.65",
      "superior": null,
      "indent": "5",
      "description": "Hip cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.30.5075",
      "rawHtsCode": "0201.30.50.75",
      "superior": null,
      "indent": "5",
      "description": "Flank or plate cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.30.5091",
      "rawHtsCode": "0201.30.50.91",
      "superior": null,
      "indent": "6",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.30.5097",
      "rawHtsCode": "0201.30.50.97",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.30.80",
      "rawHtsCode": "0201.30.80",
      "superior": null,
      "indent": "2",
      "description": "Other ",
      "units": [],
      "generalRate": "26.4%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PE,S,SG) See 9822.04.01-9822.04.03 (AU) See 9919.02.01-9919.02.02 (PA)",
      "otherRate": "31.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.02.01-9904.02.37. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0201.30.8010",
      "rawHtsCode": "0201.30.80.10",
      "superior": null,
      "indent": "3",
      "description": "Bison",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0201.30.8090",
      "rawHtsCode": "0201.30.80.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202",
      "rawHtsCode": "0202",
      "superior": null,
      "indent": "0",
      "description": "Meat of bovine animals, frozen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.10",
      "rawHtsCode": "0202.10",
      "superior": null,
      "indent": "1",
      "description": "Carcasses and half-carcasses:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.10.05",
      "rawHtsCode": "0202.10.05",
      "superior": null,
      "indent": "2",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.10.0510",
      "rawHtsCode": "0202.10.05.10",
      "superior": null,
      "indent": "3",
      "description": "Veal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.10.0590",
      "rawHtsCode": "0202.10.05.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.10.10",
      "rawHtsCode": "0202.10.10",
      "superior": null,
      "indent": "2",
      "description": "Described in additional U.S. note 3 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.10.1010",
      "rawHtsCode": "0202.10.10.10",
      "superior": null,
      "indent": "3",
      "description": "Veal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.10.1090",
      "rawHtsCode": "0202.10.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.10.50",
      "rawHtsCode": "0202.10.50",
      "superior": null,
      "indent": "2",
      "description": "Other ",
      "units": [],
      "generalRate": "26.4%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PE,S,SG) See 9822.04.01-9822.04.03 (AU) See 9919.02.01-9919.02.02 (PA)",
      "otherRate": "31.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.02.01-9904.02.37. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.10.5010",
      "rawHtsCode": "0202.10.50.10",
      "superior": null,
      "indent": "3",
      "description": "Veal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.10.5090",
      "rawHtsCode": "0202.10.50.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.20",
      "rawHtsCode": "0202.20",
      "superior": null,
      "indent": "1",
      "description": "Other cuts with bone in:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.20.0200",
      "rawHtsCode": "0202.20.02.00",
      "superior": null,
      "indent": "4",
      "description": "High-quality beef cuts",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.20.0400",
      "rawHtsCode": "0202.20.04.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.20.0600",
      "rawHtsCode": "0202.20.06.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.20.1000",
      "rawHtsCode": "0202.20.10.00",
      "superior": null,
      "indent": "4",
      "description": "High-quality beef cuts",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.20.3000",
      "rawHtsCode": "0202.20.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.20.50",
      "rawHtsCode": "0202.20.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.20.5025",
      "rawHtsCode": "0202.20.50.25",
      "superior": null,
      "indent": "4",
      "description": "Rib cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.20.5035",
      "rawHtsCode": "0202.20.50.35",
      "superior": null,
      "indent": "4",
      "description": "Chuck cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.20.5045",
      "rawHtsCode": "0202.20.50.45",
      "superior": null,
      "indent": "4",
      "description": "Loin cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.20.5090",
      "rawHtsCode": "0202.20.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.20.8000",
      "rawHtsCode": "0202.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other ",
      "units": [
        "kg"
      ],
      "generalRate": "26.4%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PE,S,SG) See 9822.04.01-9822.04.03 (AU) See 9919.02.01-9919.02.02 (PA)",
      "otherRate": "31.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.02.01-9904.02.37. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.30",
      "rawHtsCode": "0202.30",
      "superior": null,
      "indent": "1",
      "description": "Boneless:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.30.0200",
      "rawHtsCode": "0202.30.02.00",
      "superior": null,
      "indent": "4",
      "description": "High-quality beef cuts",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.30.0400",
      "rawHtsCode": "0202.30.04.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.30.0600",
      "rawHtsCode": "0202.30.06.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.30.1000",
      "rawHtsCode": "0202.30.10.00",
      "superior": null,
      "indent": "4",
      "description": "High-quality beef cuts",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.30.3000",
      "rawHtsCode": "0202.30.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.30.50",
      "rawHtsCode": "0202.30.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.30.5015",
      "rawHtsCode": "0202.30.50.15",
      "superior": null,
      "indent": "4",
      "description": "Frozen boneless veal cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.30.5025",
      "rawHtsCode": "0202.30.50.25",
      "superior": null,
      "indent": "5",
      "description": "Rib cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.30.5035",
      "rawHtsCode": "0202.30.50.35",
      "superior": null,
      "indent": "5",
      "description": "Chuck cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.30.5045",
      "rawHtsCode": "0202.30.50.45",
      "superior": null,
      "indent": "5",
      "description": "Loin cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.30.5055",
      "rawHtsCode": "0202.30.50.55",
      "superior": null,
      "indent": "5",
      "description": "Brisket cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.30.5065",
      "rawHtsCode": "0202.30.50.65",
      "superior": null,
      "indent": "5",
      "description": "Hip cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.30.5075",
      "rawHtsCode": "0202.30.50.75",
      "superior": null,
      "indent": "5",
      "description": "Flank or plate cuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.30.5091",
      "rawHtsCode": "0202.30.50.91",
      "superior": null,
      "indent": "6",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.30.5097",
      "rawHtsCode": "0202.30.50.97",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.30.80",
      "rawHtsCode": "0202.30.80",
      "superior": null,
      "indent": "2",
      "description": "Other ",
      "units": [],
      "generalRate": "26.4%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PE,S,SG) See 9822.04.01-9822.04.03 (AU) See 9919.02.01-9919.02.02 (PA)",
      "otherRate": "31.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.02.01-9904.02.37. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0202.30.8015",
      "rawHtsCode": "0202.30.80.15",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0202.30.8025",
      "rawHtsCode": "0202.30.80.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203",
      "rawHtsCode": "0203",
      "superior": null,
      "indent": "0",
      "description": "Meat of swine, fresh, chilled, or frozen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.11.0000",
      "rawHtsCode": "0203.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Carcasses and half-carcasses",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0203.12",
      "rawHtsCode": "0203.12",
      "superior": null,
      "indent": "2",
      "description": "Hams, shoulders and cuts thereof, with bone in:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.12.10",
      "rawHtsCode": "0203.12.10",
      "superior": null,
      "indent": "3",
      "description": "Processed",
      "units": [],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "7.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0203.12.1010",
      "rawHtsCode": "0203.12.10.10",
      "superior": null,
      "indent": "4",
      "description": "Hams and cuts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.12.1020",
      "rawHtsCode": "0203.12.10.20",
      "superior": null,
      "indent": "4",
      "description": "Shoulders and cuts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.12.90",
      "rawHtsCode": "0203.12.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0203.12.9010",
      "rawHtsCode": "0203.12.90.10",
      "superior": null,
      "indent": "4",
      "description": "Hams and cuts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.12.9020",
      "rawHtsCode": "0203.12.90.20",
      "superior": null,
      "indent": "4",
      "description": "Shoulders and cuts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.19",
      "rawHtsCode": "0203.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.19.20",
      "rawHtsCode": "0203.19.20",
      "superior": null,
      "indent": "3",
      "description": "Processed",
      "units": [],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "7.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0203.19.2010",
      "rawHtsCode": "0203.19.20.10",
      "superior": null,
      "indent": "4",
      "description": "Spare ribs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.19.2090",
      "rawHtsCode": "0203.19.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.19.40",
      "rawHtsCode": "0203.19.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0203.19.4010",
      "rawHtsCode": "0203.19.40.10",
      "superior": null,
      "indent": "4",
      "description": "Bellies",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.19.4090",
      "rawHtsCode": "0203.19.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.21.0000",
      "rawHtsCode": "0203.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Carcasses and half-carcasses",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0203.22",
      "rawHtsCode": "0203.22",
      "superior": null,
      "indent": "2",
      "description": "Hams, shoulders and cuts thereof, with bone in:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.22.1000",
      "rawHtsCode": "0203.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Processed",
      "units": [
        "kg"
      ],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0203.22.9000",
      "rawHtsCode": "0203.22.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0203.29",
      "rawHtsCode": "0203.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0203.29.2000",
      "rawHtsCode": "0203.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Processed",
      "units": [
        "kg"
      ],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0203.29.4000",
      "rawHtsCode": "0203.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0204",
      "rawHtsCode": "0204",
      "superior": null,
      "indent": "0",
      "description": "Meat of sheep or goats, fresh, chilled or frozen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.10.0000",
      "rawHtsCode": "0204.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Carcasses and half-carcasses of lamb, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "0.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0204.21.0000",
      "rawHtsCode": "0204.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Carcasses and half-carcasses ",
      "units": [
        "kg"
      ],
      "generalRate": "2.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR, MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheading 9904.02.60. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0204.22",
      "rawHtsCode": "0204.22",
      "superior": null,
      "indent": "2",
      "description": "Other cuts with bone in:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.22.20",
      "rawHtsCode": "0204.22.20",
      "superior": null,
      "indent": "3",
      "description": "Lamb",
      "units": [],
      "generalRate": "0.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0204.22.2010",
      "rawHtsCode": "0204.22.20.10",
      "superior": null,
      "indent": "4",
      "description": "Shoulders",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.22.2020",
      "rawHtsCode": "0204.22.20.20",
      "superior": null,
      "indent": "4",
      "description": "Legs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.22.2030",
      "rawHtsCode": "0204.22.20.30",
      "superior": null,
      "indent": "4",
      "description": "Loins",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.22.2090",
      "rawHtsCode": "0204.22.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.22.4000",
      "rawHtsCode": "0204.22.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other ",
      "units": [
        "kg"
      ],
      "generalRate": "2.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheading 9904.02.60. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0204.23",
      "rawHtsCode": "0204.23",
      "superior": null,
      "indent": "2",
      "description": "Boneless:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.23.2000",
      "rawHtsCode": "0204.23.20.00",
      "superior": null,
      "indent": "3",
      "description": "Lamb",
      "units": [
        "kg"
      ],
      "generalRate": "0.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0204.23.4000",
      "rawHtsCode": "0204.23.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other ",
      "units": [
        "kg"
      ],
      "generalRate": "2.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheading 9904.02.60. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0204.30.0000",
      "rawHtsCode": "0204.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Carcasses and half-carcasses of lamb, frozen",
      "units": [
        "kg"
      ],
      "generalRate": "0.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0204.41.0000",
      "rawHtsCode": "0204.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Carcasses and half-carcasses ",
      "units": [
        "kg"
      ],
      "generalRate": "2.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheading 9904.02.60. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0204.42",
      "rawHtsCode": "0204.42",
      "superior": null,
      "indent": "2",
      "description": "Other cuts with bone in:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.42.20",
      "rawHtsCode": "0204.42.20",
      "superior": null,
      "indent": "3",
      "description": "Lamb",
      "units": [],
      "generalRate": "0.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0204.42.2010",
      "rawHtsCode": "0204.42.20.10",
      "superior": null,
      "indent": "4",
      "description": "Shoulders",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.42.2020",
      "rawHtsCode": "0204.42.20.20",
      "superior": null,
      "indent": "4",
      "description": "Legs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.42.2030",
      "rawHtsCode": "0204.42.20.30",
      "superior": null,
      "indent": "4",
      "description": "Loins",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.42.2090",
      "rawHtsCode": "0204.42.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.42.4000",
      "rawHtsCode": "0204.42.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other ",
      "units": [
        "kg"
      ],
      "generalRate": "2.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheading 9904.02.60. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0204.43",
      "rawHtsCode": "0204.43",
      "superior": null,
      "indent": "2",
      "description": "Boneless:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0204.43.2000",
      "rawHtsCode": "0204.43.20.00",
      "superior": null,
      "indent": "3",
      "description": "Lamb",
      "units": [
        "kg"
      ],
      "generalRate": "0.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0204.43.4000",
      "rawHtsCode": "0204.43.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other ",
      "units": [
        "kg"
      ],
      "generalRate": "2.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheading 9904.02.60. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0204.50.0000",
      "rawHtsCode": "0204.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Meat of goats",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0205.00.0000",
      "rawHtsCode": "0205.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Meat of horses, asses, mules or hinnies, fresh, chilled or frozen",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0206",
      "rawHtsCode": "0206",
      "superior": null,
      "indent": "0",
      "description": "Edible offal of bovine animals, swine, sheep, goats, horses, asses, mules or hinnies, fresh, chilled or frozen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0206.10.0000",
      "rawHtsCode": "0206.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of bovine animals, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0206.21.0000",
      "rawHtsCode": "0206.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tongues",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0206.22.0000",
      "rawHtsCode": "0206.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Livers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0206.29.0000",
      "rawHtsCode": "0206.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0206.30.0000",
      "rawHtsCode": "0206.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of swine, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0206.41.0000",
      "rawHtsCode": "0206.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Livers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0206.49.0000",
      "rawHtsCode": "0206.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0206.80.0000",
      "rawHtsCode": "0206.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0206.90.00",
      "rawHtsCode": "0206.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other, frozen",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0206.90.0020",
      "rawHtsCode": "0206.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Of sheep (including lamb)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0206.90.0040",
      "rawHtsCode": "0206.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Of goats, horses, asses, mules or hinnies",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207",
      "rawHtsCode": "0207",
      "superior": null,
      "indent": "0",
      "description": "Meat and edible offal, of the poultry of heading 0105, fresh, chilled or frozen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.11.00",
      "rawHtsCode": "0207.11.00",
      "superior": null,
      "indent": "2",
      "description": "Not cut in pieces, fresh or chilled",
      "units": [],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.11.0020",
      "rawHtsCode": "0207.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Young (broilers, fryers, roasters and capons)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.11.0040",
      "rawHtsCode": "0207.11.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.12.00",
      "rawHtsCode": "0207.12.00",
      "superior": null,
      "indent": "2",
      "description": "Not cut in pieces, frozen",
      "units": [],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.12.0020",
      "rawHtsCode": "0207.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Young (broilers, fryers, roasters and capons)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.12.0040",
      "rawHtsCode": "0207.12.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.13.0000",
      "rawHtsCode": "0207.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cuts and offal, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.14.00",
      "rawHtsCode": "0207.14.00",
      "superior": null,
      "indent": "2",
      "description": "Cuts and offal, frozen",
      "units": [],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.14.0020",
      "rawHtsCode": "0207.14.00.20",
      "superior": null,
      "indent": "3",
      "description": "Livers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.14.0040",
      "rawHtsCode": "0207.14.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.24.0000",
      "rawHtsCode": "0207.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not cut in pieces, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "15¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.25",
      "rawHtsCode": "0207.25",
      "superior": null,
      "indent": "2",
      "description": "Not cut in pieces, frozen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.25.2000",
      "rawHtsCode": "0207.25.20.00",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 88¢/kg",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.25.4000",
      "rawHtsCode": "0207.25.40.00",
      "superior": null,
      "indent": "3",
      "description": "Valued 88¢ or more per kg",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.26.0000",
      "rawHtsCode": "0207.26.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cuts and offal, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.27.00",
      "rawHtsCode": "0207.27.00",
      "superior": null,
      "indent": "2",
      "description": "Cuts and offal, frozen",
      "units": [],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.27.0020",
      "rawHtsCode": "0207.27.00.20",
      "superior": null,
      "indent": "3",
      "description": "Livers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.27.0040",
      "rawHtsCode": "0207.27.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.41.0000",
      "rawHtsCode": "0207.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not cut in pieces, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.42.0000",
      "rawHtsCode": "0207.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not cut in pieces, frozen",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.43.0000",
      "rawHtsCode": "0207.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fatty livers, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.44.0000",
      "rawHtsCode": "0207.44.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.45.00",
      "rawHtsCode": "0207.45.00",
      "superior": null,
      "indent": "2",
      "description": "Other, frozen",
      "units": [],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.45.0020",
      "rawHtsCode": "0207.45.00.20",
      "superior": null,
      "indent": "3",
      "description": "Livers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.45.0040",
      "rawHtsCode": "0207.45.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.51.0000",
      "rawHtsCode": "0207.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not cut in pieces, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.52.0000",
      "rawHtsCode": "0207.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not cut in pieces, frozen",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.53.0000",
      "rawHtsCode": "0207.53.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fatty livers, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.54.0000",
      "rawHtsCode": "0207.54.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.55.00",
      "rawHtsCode": "0207.55.00",
      "superior": null,
      "indent": "2",
      "description": "Other, frozen",
      "units": [],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.55.0020",
      "rawHtsCode": "0207.55.00.20",
      "superior": null,
      "indent": "3",
      "description": "Livers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.55.0040",
      "rawHtsCode": "0207.55.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.60",
      "rawHtsCode": "0207.60",
      "superior": null,
      "indent": "1",
      "description": "Of guinea fowls:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.60.1000",
      "rawHtsCode": "0207.60.10.00",
      "superior": null,
      "indent": "2",
      "description": "Not cut in pieces, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.60.2000",
      "rawHtsCode": "0207.60.20.00",
      "superior": null,
      "indent": "2",
      "description": "Not cut in pieces, frozen",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.60.3000",
      "rawHtsCode": "0207.60.30.00",
      "superior": null,
      "indent": "2",
      "description": "Fatty livers, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.60.4000",
      "rawHtsCode": "0207.60.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.60.60",
      "rawHtsCode": "0207.60.60",
      "superior": null,
      "indent": "2",
      "description": "Other, frozen",
      "units": [],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0207.60.6020",
      "rawHtsCode": "0207.60.60.20",
      "superior": null,
      "indent": "3",
      "description": "Livers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0207.60.6040",
      "rawHtsCode": "0207.60.60.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0208",
      "rawHtsCode": "0208",
      "superior": null,
      "indent": "0",
      "description": "Other meat and edible meat offal, fresh, chilled or frozen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0208.10.0000",
      "rawHtsCode": "0208.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of rabbits or hares",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0208.30.0000",
      "rawHtsCode": "0208.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of primates",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0208.40.0100",
      "rawHtsCode": "0208.40.01.00",
      "superior": null,
      "indent": "1",
      "description": "Of whales, dolphins and porpoises (mammals of the order Cetacea); of manatees and dugongs (mammals of the order Sirenia); of seals, sea lions and walruses (mammals of the suborder Pinnipedia).",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0208.50.0000",
      "rawHtsCode": "0208.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of reptiles (including snakes and turtles)",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0208.60.0000",
      "rawHtsCode": "0208.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of camels and other camelids (<i>Camelidae</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0208.90",
      "rawHtsCode": "0208.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0208.90.2000",
      "rawHtsCode": "0208.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Deer",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0208.90.2500",
      "rawHtsCode": "0208.90.25.00",
      "superior": null,
      "indent": "2",
      "description": "Frogsʼ legs",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0208.90.3000",
      "rawHtsCode": "0208.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Quail, eviscerated, not in pieces",
      "units": [
        "kg"
      ],
      "generalRate": "7¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0208.90.9100",
      "rawHtsCode": "0208.90.91.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0209",
      "rawHtsCode": "0209",
      "superior": null,
      "indent": "0",
      "description": "Pig fat, free of lean meat, and poultry fat, not rendered or otherwise extracted, fresh, chilled, frozen, salted, in brine, dried or smoked:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0209.10.0000",
      "rawHtsCode": "0209.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of pigs",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0209.90.0000",
      "rawHtsCode": "0209.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0210",
      "rawHtsCode": "0210",
      "superior": null,
      "indent": "0",
      "description": "Meat and edible meat offal, salted, in brine, dried or smoked; edible flours and meals of meat or meat offal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0210.11.00",
      "rawHtsCode": "0210.11.00",
      "superior": null,
      "indent": "2",
      "description": "Hams, shoulders and cuts thereof, with bone in",
      "units": [],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "7.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0210.11.0010",
      "rawHtsCode": "0210.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Hams and cuts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0210.11.0020",
      "rawHtsCode": "0210.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Shoulders and cuts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0210.12.00",
      "rawHtsCode": "0210.12.00",
      "superior": null,
      "indent": "2",
      "description": "Bellies (streaky) and cuts thereof",
      "units": [],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0210.12.0020",
      "rawHtsCode": "0210.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Bacon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0210.12.0040",
      "rawHtsCode": "0210.12.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0210.19.00",
      "rawHtsCode": "0210.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "7.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0210.19.0010",
      "rawHtsCode": "0210.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Canadian style bacon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0210.19.0090",
      "rawHtsCode": "0210.19.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0210.20.0000",
      "rawHtsCode": "0210.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Meat of bovine animals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0210.91.0000",
      "rawHtsCode": "0210.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of primates",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0210.92.0100",
      "rawHtsCode": "0210.92.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of whales, dolphins and porpoises (mammals of the order Cetacea); of manatees and dugongs (mammals of the order Sirenia); of seals, sea lions and walruses (mammals of the suborder Pinnipedia)",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0210.93.0000",
      "rawHtsCode": "0210.93.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of reptiles (including snakes and turtles)",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0210.99",
      "rawHtsCode": "0210.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0210.99.2000",
      "rawHtsCode": "0210.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Meat of poultry of heading 0105",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0210.99.9100",
      "rawHtsCode": "0210.99.91.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0301",
      "rawHtsCode": "0301",
      "superior": null,
      "indent": "0",
      "description": "Live fish:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0301.11.00",
      "rawHtsCode": "0301.11.00",
      "superior": null,
      "indent": "2",
      "description": "Freshwater",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0301.11.0010",
      "rawHtsCode": "0301.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Koi (common) carp (<i>Cyprinus carpio</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0301.11.0020",
      "rawHtsCode": "0301.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Goldfish( <i>Carassius auratus</i>), Crucian carp (<i>Carassius carassius</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0301.11.0090",
      "rawHtsCode": "0301.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0301.19.0000",
      "rawHtsCode": "0301.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0301.91.0000",
      "rawHtsCode": "0301.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Trout (<i>Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache </i>and<i> Oncorhynchus chrysogaster</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0301.92.0000",
      "rawHtsCode": "0301.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Eels (<i>Anguilla spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0301.93.02",
      "rawHtsCode": "0301.93.02",
      "superior": null,
      "indent": "2",
      "description": "Carp (<i>Cyprinus spp</i>., <i>Carassius spp</i>., <i>Ctenopharyngodon</i> <i>idellus</i>, <i>Hypophthalmichthys spp</i>., <i>Cirrhinus spp</i>., <i>Mylopharyngodon piceus</i>, <i>Catla catla</i>, <i>Labeo spp</i>., <i>Osteochilus hasselti</i>, <i>Leptobarbus hoeveni</i>, <i>Megalobrama spp</i>.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0301.93.0210",
      "rawHtsCode": "0301.93.02.10",
      "superior": null,
      "indent": "3",
      "description": "Grass carp (<i>Ctenopharyngodon idellus</i>), silver carp (<i>Hypophthalmichthys molitrix</i>) and bighead carp (<i>Aristichthys nobilis</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0301.93.0290",
      "rawHtsCode": "0301.93.02.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0301.94.0100",
      "rawHtsCode": "0301.94.01.00",
      "superior": null,
      "indent": "2",
      "description": "Atlantic and Pacific bluefin tunas (<i>Thunnus thynnus, Thunnus orientalis</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0301.95.0000",
      "rawHtsCode": "0301.95.00.00",
      "superior": null,
      "indent": "2",
      "description": "Southern Bluefin tunas (<i>Thunnus maccoyii</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0301.99.03",
      "rawHtsCode": "0301.99.03",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0301.99.0310",
      "rawHtsCode": "0301.99.03.10",
      "superior": null,
      "indent": "3",
      "description": "Tench (<i>Tinca tinca</i>), sheatfish (<i>Silurus glanis</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0301.99.0315",
      "rawHtsCode": "0301.99.03.15",
      "superior": null,
      "indent": "3",
      "description": "Bighead carp (<i>Aristichthys nobilis</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0301.99.0390",
      "rawHtsCode": "0301.99.03.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302",
      "rawHtsCode": "0302",
      "superior": null,
      "indent": "0",
      "description": "Fish, fresh or chilled, excluding fish fillets and other fish meat of heading 0304:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.11.00",
      "rawHtsCode": "0302.11.00",
      "superior": null,
      "indent": "2",
      "description": "Trout (<i>Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache </i> <i><i>and </i></i><i>Oncorhynchus chrysogaster</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.11.0010",
      "rawHtsCode": "0302.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Rainbow trout (<i>Salmo gairdneri</i>), farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.11.0090",
      "rawHtsCode": "0302.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.13.00",
      "rawHtsCode": "0302.13.00",
      "superior": null,
      "indent": "2",
      "description": "Pacific salmon (<i>Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou</i> and <i>Oncorhynchus rhodurus</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.13.0013",
      "rawHtsCode": "0302.13.00.13",
      "superior": null,
      "indent": "4",
      "description": "Farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.13.0014",
      "rawHtsCode": "0302.13.00.14",
      "superior": null,
      "indent": "4",
      "description": "Not farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.13.0022",
      "rawHtsCode": "0302.13.00.22",
      "superior": null,
      "indent": "3",
      "description": "Chum (dog)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.13.0032",
      "rawHtsCode": "0302.13.00.32",
      "superior": null,
      "indent": "3",
      "description": "Pink (humpie)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.13.0042",
      "rawHtsCode": "0302.13.00.42",
      "superior": null,
      "indent": "3",
      "description": "Sockeye (red)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.13.0053",
      "rawHtsCode": "0302.13.00.53",
      "superior": null,
      "indent": "4",
      "description": "Farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.13.0054",
      "rawHtsCode": "0302.13.00.54",
      "superior": null,
      "indent": "4",
      "description": "Not farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.13.0062",
      "rawHtsCode": "0302.13.00.62",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.14.00",
      "rawHtsCode": "0302.14.00",
      "superior": null,
      "indent": "2",
      "description": "Atlantic salmon (<i>Salmo salar</i>) and Danube salmon (<i>Hucho hucho</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.14.0003",
      "rawHtsCode": "0302.14.00.03",
      "superior": null,
      "indent": "4",
      "description": "Farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.14.0004",
      "rawHtsCode": "0302.14.00.04",
      "superior": null,
      "indent": "4",
      "description": "Not farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.14.0062",
      "rawHtsCode": "0302.14.00.62",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.19.0000",
      "rawHtsCode": "0302.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.21.00",
      "rawHtsCode": "0302.21.00",
      "superior": null,
      "indent": "2",
      "description": "Halibut and Greenland turbot (<i>Reinhardtius hippoglossoides, Hippoglossus hippoglossus, Hippoglossus stenolepis</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.21.0010",
      "rawHtsCode": "0302.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Atlantic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.21.0020",
      "rawHtsCode": "0302.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Pacific",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.21.0090",
      "rawHtsCode": "0302.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (including Greenland)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.22.0000",
      "rawHtsCode": "0302.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Plaice (<i>Pleuronectes platessa</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.23.0000",
      "rawHtsCode": "0302.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sole (<i>Solea spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "1.1¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.24.0000",
      "rawHtsCode": "0302.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Turbots (<i>Psetta maxima</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.29.01",
      "rawHtsCode": "0302.29.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.29.0110",
      "rawHtsCode": "0302.29.01.10",
      "superior": null,
      "indent": "3",
      "description": "Flounder",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.29.0190",
      "rawHtsCode": "0302.29.01.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.31.0000",
      "rawHtsCode": "0302.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Albacore or longfinned tunas (Thunnus alalunga)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0302.32.0000",
      "rawHtsCode": "0302.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Yellowfin tunas (<i>Thunnus albacares</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.33.0000",
      "rawHtsCode": "0302.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Skipjack tuna (stripe-bellied bonito) (<i>Katsuwonus pelamis</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0302.34.0000",
      "rawHtsCode": "0302.34.00.00",
      "superior": null,
      "indent": "2",
      "description": "Bigeye tunas (<i>Thunnus obesus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.35.0100",
      "rawHtsCode": "0302.35.01.00",
      "superior": null,
      "indent": "2",
      "description": "Atlantic and Pacific bluefin tunas (<i>Thunnus thynnus, Thunnus orientalis</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.36.0000",
      "rawHtsCode": "0302.36.00.00",
      "superior": null,
      "indent": "2",
      "description": "Southern bluefin tunas (<i>Thunnus maccoyii</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.39.0200",
      "rawHtsCode": "0302.39.02.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.41.0000",
      "rawHtsCode": "0302.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Herrings (<i>Clupea harengus, Clupea pallasii</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.42.0000",
      "rawHtsCode": "0302.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Anchovies (<i>Engraulis spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.43.0000",
      "rawHtsCode": "0302.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sardines (<i>Sardina pilchardus, Sardinops spp.</i>), sardinella (<i>Sardinella spp.</i>), brisling or sprats (<i>Sprattus sprattus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.44.0000",
      "rawHtsCode": "0302.44.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mackerel (<i>Scomber scombrus, Scomber australasicus, Scomber japonicus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.45",
      "rawHtsCode": "0302.45",
      "superior": null,
      "indent": "2",
      "description": "Jack and horse mackerel (<i>Trachurus spp</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.45.1100",
      "rawHtsCode": "0302.45.11.00",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been removed, but not otherwise processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.45.5000",
      "rawHtsCode": "0302.45.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.46",
      "rawHtsCode": "0302.46",
      "superior": null,
      "indent": "2",
      "description": "Cobia (<i>Rachycentron canadum</i>) :",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.46.1100",
      "rawHtsCode": "0302.46.11.00",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been removed, but not otherwise processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.46.5000",
      "rawHtsCode": "0302.46.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.47.00",
      "rawHtsCode": "0302.47.00",
      "superior": null,
      "indent": "2",
      "description": "Swordfish (<i>Xiphias gladius</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.47.0010",
      "rawHtsCode": "0302.47.00.10",
      "superior": null,
      "indent": "3",
      "description": "Steaks",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.47.0090",
      "rawHtsCode": "0302.47.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.49.0000",
      "rawHtsCode": "0302.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.51.00",
      "rawHtsCode": "0302.51.00",
      "superior": null,
      "indent": "2",
      "description": "Cod (<i>Gadus morhua, Gadus ogac, Gadus macrocephalus</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.51.0010",
      "rawHtsCode": "0302.51.00.10",
      "superior": null,
      "indent": "3",
      "description": "Atlantic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.51.0090",
      "rawHtsCode": "0302.51.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.52.0000",
      "rawHtsCode": "0302.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "Haddock (<i>Melanogrammus aeglefinus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.53.0000",
      "rawHtsCode": "0302.53.00.00",
      "superior": null,
      "indent": "2",
      "description": "Coalfish (<i>Pollachius virens</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.54",
      "rawHtsCode": "0302.54",
      "superior": null,
      "indent": "2",
      "description": "Hake (<i>Merluccius spp., Urophycis spp.</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.54.1100",
      "rawHtsCode": "0302.54.11.00",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been removed, but not otherwise processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.54.5000",
      "rawHtsCode": "0302.54.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.55",
      "rawHtsCode": "0302.55",
      "superior": null,
      "indent": "2",
      "description": "Alaska pollock (<i>Theragra chalcogramma</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.55.1100",
      "rawHtsCode": "0302.55.11.00",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been removed, but not otherwise processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.55.5000",
      "rawHtsCode": "0302.55.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.56",
      "rawHtsCode": "0302.56",
      "superior": null,
      "indent": "2",
      "description": "Blue whitings (<i>Micromesistius poutassou, Micromesistius australis</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.56.1100",
      "rawHtsCode": "0302.56.11.00",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been removed, but not otherwise processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.56.5000",
      "rawHtsCode": "0302.56.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.59",
      "rawHtsCode": "0302.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.59.1100",
      "rawHtsCode": "0302.59.11.00",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been removed, but not otherwise processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.59.50",
      "rawHtsCode": "0302.59.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.59.5010",
      "rawHtsCode": "0302.59.50.10",
      "superior": null,
      "indent": "4",
      "description": "Pollock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.59.5090",
      "rawHtsCode": "0302.59.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.71",
      "rawHtsCode": "0302.71",
      "superior": null,
      "indent": "2",
      "description": "Tilapias (<i>Oreochromis spp</i>.):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.71.1100",
      "rawHtsCode": "0302.71.11.00",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been removed, but not otherwise processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.71.5000",
      "rawHtsCode": "0302.71.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.72",
      "rawHtsCode": "0302.72",
      "superior": null,
      "indent": "2",
      "description": "Catfish (<i>Pangasius spp., Silurus spp., Clarias spp., Ictalurus spp.</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.72.1100",
      "rawHtsCode": "0302.72.11.00",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been removed, but not otherwise processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.72.50",
      "rawHtsCode": "0302.72.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.72.5001",
      "rawHtsCode": "0302.72.50.01",
      "superior": null,
      "indent": "4",
      "description": "<i>Ictalurus spp.</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.72.5004",
      "rawHtsCode": "0302.72.50.04",
      "superior": null,
      "indent": "4",
      "description": "<i>Pangasius spp</i>. including basa and tra",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.72.5034",
      "rawHtsCode": "0302.72.50.34",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.73",
      "rawHtsCode": "0302.73",
      "superior": null,
      "indent": "2",
      "description": "Carp (<i>Cyprinus spp</i>., <i>Carassius spp</i>., <i>Ctenopharyngodon idellus</i>, <i>Hypophthalmichthys spp</i>., <i>Cirrhinus spp</i>., <i>Mylopharyngodon piceus</i>, <i>Catla catla</i>, <i>Labeo spp</i>., <i>Osteochilus hasselti</i>, <i>Leptobarbus hoeveni</i>, <i>Megalobrama spp</i>.):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.73.1100",
      "rawHtsCode": "0302.73.11.00",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been removed, but not otherwise processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.73.5000",
      "rawHtsCode": "0302.73.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.74.0000",
      "rawHtsCode": "0302.74.00.00",
      "superior": null,
      "indent": "2",
      "description": "Eels (<i>Anguilla spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.79",
      "rawHtsCode": "0302.79",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.79.1100",
      "rawHtsCode": "0302.79.11.00",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been removed, but not otherwise processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.79.50",
      "rawHtsCode": "0302.79.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.79.5025",
      "rawHtsCode": "0302.79.50.25",
      "superior": null,
      "indent": "4",
      "description": "Nile perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.79.5076",
      "rawHtsCode": "0302.79.50.76",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.81.00",
      "rawHtsCode": "0302.81.00",
      "superior": null,
      "indent": "2",
      "description": "Dogfish and other sharks",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.81.0011",
      "rawHtsCode": "0302.81.00.11",
      "superior": null,
      "indent": "3",
      "description": "Dogfish (<u><i>Squalus</i></u> <i>spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.81.0091",
      "rawHtsCode": "0302.81.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.82.0000",
      "rawHtsCode": "0302.82.00.00",
      "superior": null,
      "indent": "2",
      "description": "Rays and skates (<i>Rajidae</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.83.0000",
      "rawHtsCode": "0302.83.00.00",
      "superior": null,
      "indent": "2",
      "description": "Toothfish (<i>Dissostichus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.84",
      "rawHtsCode": "0302.84",
      "superior": null,
      "indent": "2",
      "description": "Seabass (<i>Dicentrarchus spp.</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.84.1100",
      "rawHtsCode": "0302.84.11.00",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been removed, but not otherwise processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.84.5000",
      "rawHtsCode": "0302.84.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.85",
      "rawHtsCode": "0302.85",
      "superior": null,
      "indent": "2",
      "description": "Seabream (<i>Sparidae</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.85.1100",
      "rawHtsCode": "0302.85.11.00",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been removed, but not otherwise processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.85.5000",
      "rawHtsCode": "0302.85.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.89",
      "rawHtsCode": "0302.89",
      "superior": null,
      "indent": "2",
      "description": "Other :",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.11",
      "rawHtsCode": "0302.89.11",
      "superior": null,
      "indent": "3",
      "description": "Scaled (whether or not heads, viscera and/or fins have been processed), in immediate containers weighing with their contents <il>6.8 kg</il> or less",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.89.1120",
      "rawHtsCode": "0302.89.11.20",
      "superior": null,
      "indent": "4",
      "description": "Sable fish (<i>Anoplopoma fimbria</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.1140",
      "rawHtsCode": "0302.89.11.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.50",
      "rawHtsCode": "0302.89.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.89.5007",
      "rawHtsCode": "0302.89.50.07",
      "superior": null,
      "indent": "5",
      "description": "Pike",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5010",
      "rawHtsCode": "0302.89.50.10",
      "superior": null,
      "indent": "5",
      "description": "Pickerel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5013",
      "rawHtsCode": "0302.89.50.13",
      "superior": null,
      "indent": "6",
      "description": "Pike perch (including yellow pike)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5025",
      "rawHtsCode": "0302.89.50.25",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5028",
      "rawHtsCode": "0302.89.50.28",
      "superior": null,
      "indent": "5",
      "description": "Bass",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5031",
      "rawHtsCode": "0302.89.50.31",
      "superior": null,
      "indent": "5",
      "description": "Whitefish",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5034",
      "rawHtsCode": "0302.89.50.34",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5037",
      "rawHtsCode": "0302.89.50.37",
      "superior": null,
      "indent": "4",
      "description": "Smelts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5040",
      "rawHtsCode": "0302.89.50.40",
      "superior": null,
      "indent": "4",
      "description": "Cusk",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5049",
      "rawHtsCode": "0302.89.50.49",
      "superior": null,
      "indent": "4",
      "description": "Shad and sturgeon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5052",
      "rawHtsCode": "0302.89.50.52",
      "superior": null,
      "indent": "4",
      "description": "Sable fish (<i>Anoplopoma fimbria</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5055",
      "rawHtsCode": "0302.89.50.55",
      "superior": null,
      "indent": "4",
      "description": "Ocean perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5058",
      "rawHtsCode": "0302.89.50.58",
      "superior": null,
      "indent": "4",
      "description": "Snapper (<i>Lutjanidae</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5061",
      "rawHtsCode": "0302.89.50.61",
      "superior": null,
      "indent": "4",
      "description": "Grouper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5064",
      "rawHtsCode": "0302.89.50.64",
      "superior": null,
      "indent": "4",
      "description": "Lingcod (<i>Ophiodon elongatus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5067",
      "rawHtsCode": "0302.89.50.67",
      "superior": null,
      "indent": "4",
      "description": "Monkfish (<i>Lophius spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5070",
      "rawHtsCode": "0302.89.50.70",
      "superior": null,
      "indent": "4",
      "description": "Atka mackerel (Atkafish) (<i>Pleurogrammus monopterygius</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5072",
      "rawHtsCode": "0302.89.50.72",
      "superior": null,
      "indent": "4",
      "description": "Dolphin fish (mahi mahi) (<i><u>Coryphaena</u></i> <i><u>spp.</u></i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.89.5077",
      "rawHtsCode": "0302.89.50.77",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.91",
      "rawHtsCode": "0302.91",
      "superior": null,
      "indent": "2",
      "description": "Livers, roes and milt:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.91.2000",
      "rawHtsCode": "0302.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "Sturgeon roe",
      "units": [
        "kg"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0302.91.40",
      "rawHtsCode": "0302.91.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "44¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.91.4010",
      "rawHtsCode": "0302.91.40.10",
      "superior": null,
      "indent": "4",
      "description": "Mullet roe",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.91.4090",
      "rawHtsCode": "0302.91.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0302.92.0000",
      "rawHtsCode": "0302.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Shark fins",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0302.99.0000",
      "rawHtsCode": "0302.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "44¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303",
      "rawHtsCode": "0303",
      "superior": null,
      "indent": "0",
      "description": "Fish, frozen, excluding fish fillets and other fish meat of heading 0304:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.11.0000",
      "rawHtsCode": "0303.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sockeye salmon (red salmon) (<i>Oncorhynchus nerka</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.12.00",
      "rawHtsCode": "0303.12.00",
      "superior": null,
      "indent": "2",
      "description": "Other Pacific salmon (<i>Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou</i> and <i>Oncorhynchus rhodurus</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.12.0012",
      "rawHtsCode": "0303.12.00.12",
      "superior": null,
      "indent": "3",
      "description": "Chinook (king)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.12.0022",
      "rawHtsCode": "0303.12.00.22",
      "superior": null,
      "indent": "3",
      "description": "Chum (dog)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.12.0032",
      "rawHtsCode": "0303.12.00.32",
      "superior": null,
      "indent": "3",
      "description": "Pink (humpie)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.12.0052",
      "rawHtsCode": "0303.12.00.52",
      "superior": null,
      "indent": "3",
      "description": "Coho (silver)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.12.0062",
      "rawHtsCode": "0303.12.00.62",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.13.0000",
      "rawHtsCode": "0303.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Atlantic salmon (<i>Salmo salar</i>) and Danube salmon (<i>Hucho hucho</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.14.0000",
      "rawHtsCode": "0303.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Trout (<i>Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache and Oncorhynchus chrysogaster</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.19.0100",
      "rawHtsCode": "0303.19.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.23.0000",
      "rawHtsCode": "0303.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tilapias (<i>Oreochromis spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.24.00",
      "rawHtsCode": "0303.24.00",
      "superior": null,
      "indent": "2",
      "description": "Catfish (<i>Pangasius spp., Silurus spp., Clarias spp., Ictalurus spp.</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.24.0010",
      "rawHtsCode": "0303.24.00.10",
      "superior": null,
      "indent": "3",
      "description": "<i>Ictalurus spp.</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.24.0020",
      "rawHtsCode": "0303.24.00.20",
      "superior": null,
      "indent": "3",
      "description": "<i>Pangasius spp</i>. including basa and tra",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.24.0050",
      "rawHtsCode": "0303.24.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.25.0100",
      "rawHtsCode": "0303.25.01.00",
      "superior": null,
      "indent": "2",
      "description": "Carp (<i>Cyprinus spp</i>., <i>Carassius spp</i>., <i>Ctenopharyngodon idellus</i>, <i>Hypophthalmichthys spp</i>., <i>Cirrhinus spp</i>., <i>Mylopharyngodon piceus</i>, <i>Catla catla</i>, <i>Labeo spp</i>., <i>Osteochilus hasselti</i>, <i>Leptobarbus hoeveni</i>, <i>Megalobrama spp</i>.)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.26.0000",
      "rawHtsCode": "0303.26.00.00",
      "superior": null,
      "indent": "2",
      "description": "Eels (<i>Anguilla spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.29.01",
      "rawHtsCode": "0303.29.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.29.0110",
      "rawHtsCode": "0303.29.01.10",
      "superior": null,
      "indent": "3",
      "description": "Nile perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.29.0150",
      "rawHtsCode": "0303.29.01.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.31.00",
      "rawHtsCode": "0303.31.00",
      "superior": null,
      "indent": "2",
      "description": "Halibut and Greenland turbot (<i>Reinhardtius hippoglossoides, Hippoglossus hippoglossus, Hippoglossus stenolepis</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.31.0010",
      "rawHtsCode": "0303.31.00.10",
      "superior": null,
      "indent": "3",
      "description": "Atlantic halibut (<i>Hippoglossus hippoglossus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.31.0020",
      "rawHtsCode": "0303.31.00.20",
      "superior": null,
      "indent": "3",
      "description": "Pacific halibut (<i>Hippoglossus stenolepis</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.31.0030",
      "rawHtsCode": "0303.31.00.30",
      "superior": null,
      "indent": "3",
      "description": "Greenland turbot (Greenland halibut) (<i>Reinhardtius hippoglossoides</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.32.0000",
      "rawHtsCode": "0303.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Plaice (<i>Pleuronectes platessa</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.33.0000",
      "rawHtsCode": "0303.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sole (<i>Solea spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "1.1¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0303.34.0000",
      "rawHtsCode": "0303.34.00.00",
      "superior": null,
      "indent": "2",
      "description": "Turbots (<i>Psetta maxima</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "1.1¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0303.39.01",
      "rawHtsCode": "0303.39.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "1.1¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0303.39.0110",
      "rawHtsCode": "0303.39.01.10",
      "superior": null,
      "indent": "3",
      "description": "Flounder",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.39.0120",
      "rawHtsCode": "0303.39.01.20",
      "superior": null,
      "indent": "3",
      "description": "Rock sole (<i>Pleuronectes bilineatus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.39.0130",
      "rawHtsCode": "0303.39.01.30",
      "superior": null,
      "indent": "3",
      "description": "Yellowfin sole (<i>Pleuronectes asper</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.39.0195",
      "rawHtsCode": "0303.39.01.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.41.0000",
      "rawHtsCode": "0303.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Albacore or longfinned tunas (<i>Thunnus alalunga</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0303.42.00",
      "rawHtsCode": "0303.42.00",
      "superior": null,
      "indent": "2",
      "description": "Yellowfin tunas (<i>Thunnus albacares</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.42.0020",
      "rawHtsCode": "0303.42.00.20",
      "superior": null,
      "indent": "3",
      "description": "Whole fish",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.42.0040",
      "rawHtsCode": "0303.42.00.40",
      "superior": null,
      "indent": "4",
      "description": "Head-on",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.42.0060",
      "rawHtsCode": "0303.42.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.43.0000",
      "rawHtsCode": "0303.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "Skipjack tuna (stripe-bellied bonito) (<i>Katsuwonus pelamis</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0303.44.0000",
      "rawHtsCode": "0303.44.00.00",
      "superior": null,
      "indent": "2",
      "description": "Bigeye tunas (<i>Thunnus obesus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.45.01",
      "rawHtsCode": "0303.45.01",
      "superior": null,
      "indent": "2",
      "description": "Atlantic and Pacific bluefin tunas (<i>Thunnus thynnus, Thunnus orientalis</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.45.0110",
      "rawHtsCode": "0303.45.01.10",
      "superior": null,
      "indent": "3",
      "description": "<i>Thunnus thynnus</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.45.0150",
      "rawHtsCode": "0303.45.01.50",
      "superior": null,
      "indent": "3",
      "description": "<i>Thunnus orientalis</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.46.0000",
      "rawHtsCode": "0303.46.00.00",
      "superior": null,
      "indent": "2",
      "description": "Southern bluefin tunas (<i>Thunnus maccoyii</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.49.0200",
      "rawHtsCode": "0303.49.02.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.51.0000",
      "rawHtsCode": "0303.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Herrings (<i>Clupea harengus, Clupea pallasii</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.53.0000",
      "rawHtsCode": "0303.53.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sardines (<i>Sardina pilchardus, Sardinops spp.</i>), sardinella (<i>Sardinella spp.</i>), brisling or sprats (<i>Sprattus sprattus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "1.1¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0303.54.0000",
      "rawHtsCode": "0303.54.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mackerel (<i>Scomber scombrus, Scomber australasicus, Scomber japonicus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.55.0000",
      "rawHtsCode": "0303.55.00.00",
      "superior": null,
      "indent": "2",
      "description": "Jack and horse mackerel (<i>Trachurus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.56.0000",
      "rawHtsCode": "0303.56.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cobia (<i>Rachycentron canadum</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.57.00",
      "rawHtsCode": "0303.57.00",
      "superior": null,
      "indent": "2",
      "description": "Swordfish (<i>Xiphias gladius</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.57.0010",
      "rawHtsCode": "0303.57.00.10",
      "superior": null,
      "indent": "3",
      "description": "Steaks",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.57.0090",
      "rawHtsCode": "0303.57.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.59.0000",
      "rawHtsCode": "0303.59.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.63.00",
      "rawHtsCode": "0303.63.00",
      "superior": null,
      "indent": "2",
      "description": "Cod (<i>Gadus morhua, Gadus ogac, Gadus macrocephalus</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.63.0010",
      "rawHtsCode": "0303.63.00.10",
      "superior": null,
      "indent": "3",
      "description": "Atlantic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.63.0090",
      "rawHtsCode": "0303.63.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.64.0000",
      "rawHtsCode": "0303.64.00.00",
      "superior": null,
      "indent": "2",
      "description": "Haddock (<i>Melanogrammus aeglefinus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.65.0000",
      "rawHtsCode": "0303.65.00.00",
      "superior": null,
      "indent": "2",
      "description": "Coalfish (<i>Pollachius virens</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.66.0000",
      "rawHtsCode": "0303.66.00.00",
      "superior": null,
      "indent": "2",
      "description": "Hake (<i>Merluccius spp., Urophycis spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.67.0000",
      "rawHtsCode": "0303.67.00.00",
      "superior": null,
      "indent": "2",
      "description": "Alaska pollock (<i>Theragra chalcogramma</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.68.0000",
      "rawHtsCode": "0303.68.00.00",
      "superior": null,
      "indent": "2",
      "description": "Blue whitings (<i>Micromesistius poutassou, Micromesistius australis</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.69.0000",
      "rawHtsCode": "0303.69.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.81.00",
      "rawHtsCode": "0303.81.00",
      "superior": null,
      "indent": "2",
      "description": "Dogfish and other sharks",
      "units": [],
      "generalRate": "1.1¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0303.81.0011",
      "rawHtsCode": "0303.81.00.11",
      "superior": null,
      "indent": "3",
      "description": "Dogfish (<i>Squalus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.81.0091",
      "rawHtsCode": "0303.81.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.82.0000",
      "rawHtsCode": "0303.82.00.00",
      "superior": null,
      "indent": "2",
      "description": "Rays and skates (<i>Rajidae</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.83.0000",
      "rawHtsCode": "0303.83.00.00",
      "superior": null,
      "indent": "2",
      "description": "Toothfish (<i>Dissostichus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.84.0000",
      "rawHtsCode": "0303.84.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sea Bass (<i>Dicentrachus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.89.00",
      "rawHtsCode": "0303.89.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.89.0001",
      "rawHtsCode": "0303.89.00.01",
      "superior": null,
      "indent": "4",
      "description": "Sea smelts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0004",
      "rawHtsCode": "0303.89.00.04",
      "superior": null,
      "indent": "4",
      "description": "Other smelts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0010",
      "rawHtsCode": "0303.89.00.10",
      "superior": null,
      "indent": "3",
      "description": "Cusk",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0013",
      "rawHtsCode": "0303.89.00.13",
      "superior": null,
      "indent": "3",
      "description": "Shad and sturgeon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0028",
      "rawHtsCode": "0303.89.00.28",
      "superior": null,
      "indent": "4",
      "description": "Pike and pickerel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0031",
      "rawHtsCode": "0303.89.00.31",
      "superior": null,
      "indent": "4",
      "description": "Perch and pike perch (including yellow pike)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0034",
      "rawHtsCode": "0303.89.00.34",
      "superior": null,
      "indent": "4",
      "description": "Sauger",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0037",
      "rawHtsCode": "0303.89.00.37",
      "superior": null,
      "indent": "4",
      "description": "Whitefish",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0040",
      "rawHtsCode": "0303.89.00.40",
      "superior": null,
      "indent": "4",
      "description": "Tilapias, other than <i>Oreochromis spp.</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0043",
      "rawHtsCode": "0303.89.00.43",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0046",
      "rawHtsCode": "0303.89.00.46",
      "superior": null,
      "indent": "3",
      "description": "Atka mackerel (Atkafish) (<i>Pleurogrammus monopterygius</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0049",
      "rawHtsCode": "0303.89.00.49",
      "superior": null,
      "indent": "3",
      "description": "Mullet",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0052",
      "rawHtsCode": "0303.89.00.52",
      "superior": null,
      "indent": "3",
      "description": "Monkfish (<i>Lophius spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0055",
      "rawHtsCode": "0303.89.00.55",
      "superior": null,
      "indent": "3",
      "description": "Butterfish",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0058",
      "rawHtsCode": "0303.89.00.58",
      "superior": null,
      "indent": "3",
      "description": "Capelin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0061",
      "rawHtsCode": "0303.89.00.61",
      "superior": null,
      "indent": "3",
      "description": "Sable fish (<i>Anoplopoma fimbria</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0064",
      "rawHtsCode": "0303.89.00.64",
      "superior": null,
      "indent": "3",
      "description": "Ocean perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0067",
      "rawHtsCode": "0303.89.00.67",
      "superior": null,
      "indent": "3",
      "description": "Snapper (<i>Lutjanidae spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0070",
      "rawHtsCode": "0303.89.00.70",
      "superior": null,
      "indent": "3",
      "description": "Grouper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.89.0080",
      "rawHtsCode": "0303.89.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.91",
      "rawHtsCode": "0303.91",
      "superior": null,
      "indent": "2",
      "description": "Livers, roes and milt:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.91.2000",
      "rawHtsCode": "0303.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "Sturgeon roe",
      "units": [
        "kg"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0303.91.40",
      "rawHtsCode": "0303.91.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "44¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0303.91.4020",
      "rawHtsCode": "0303.91.40.20",
      "superior": null,
      "indent": "4",
      "description": "Herring roe",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.91.4040",
      "rawHtsCode": "0303.91.40.40",
      "superior": null,
      "indent": "4",
      "description": "Salmon roe",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.91.4050",
      "rawHtsCode": "0303.91.40.50",
      "superior": null,
      "indent": "4",
      "description": "Alaska pollock (<i>Theragra chalcogramma) </i>roe",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.91.4060",
      "rawHtsCode": "0303.91.40.60",
      "superior": null,
      "indent": "4",
      "description": "Mullet roe",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.91.4095",
      "rawHtsCode": "0303.91.40.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0303.92.0000",
      "rawHtsCode": "0303.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Shark fins",
      "units": [
        "kg"
      ],
      "generalRate": "1.1¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0303.99.0000",
      "rawHtsCode": "0303.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "44¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304",
      "rawHtsCode": "0304",
      "superior": null,
      "indent": "0",
      "description": "Fish fillets and other fish meat (whether or not minced), fresh, chilled or frozen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.31.0000",
      "rawHtsCode": "0304.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tilapias (<i>Oreochromis spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.32.00",
      "rawHtsCode": "0304.32.00",
      "superior": null,
      "indent": "2",
      "description": "Catfish (<i>Pangasius spp., Silurus spp., Clarias spp., Ictalurus spp.</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.32.0010",
      "rawHtsCode": "0304.32.00.10",
      "superior": null,
      "indent": "3",
      "description": "<i>Ictalurus spp.</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.32.0020",
      "rawHtsCode": "0304.32.00.20",
      "superior": null,
      "indent": "3",
      "description": "<i>Pangasius spp.</i> including basa and tra",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.32.0090",
      "rawHtsCode": "0304.32.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.33.0000",
      "rawHtsCode": "0304.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Nile perch (<i>Lates niloticus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.39.0000",
      "rawHtsCode": "0304.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other<i></i><i></i>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.41.00",
      "rawHtsCode": "0304.41.00",
      "superior": null,
      "indent": "2",
      "description": "Pacific salmon (<i>Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou</i> and <i>Oncorhynchus rhodurus</i>) Atlantic Salmon (<i>Salmo salar</i>) and Danube salmon (<i>Hucho hucho</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.41.0010",
      "rawHtsCode": "0304.41.00.10",
      "superior": null,
      "indent": "4",
      "description": "Farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.41.0020",
      "rawHtsCode": "0304.41.00.20",
      "superior": null,
      "indent": "4",
      "description": "Not Farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.41.0090",
      "rawHtsCode": "0304.41.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.42.0000",
      "rawHtsCode": "0304.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Trout (<i>Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae Oncorhynchus apache,</i> and <i>Oncorhynchus chrysogaster</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.43.00",
      "rawHtsCode": "0304.43.00",
      "superior": null,
      "indent": "2",
      "description": "Flat Fish (<i>Pleuronectidae, Bothidae, Cynoglossidae, Soleidae, Scophthalmidae,</i> and <i>Citharidae</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.43.0010",
      "rawHtsCode": "0304.43.00.10",
      "superior": null,
      "indent": "3",
      "description": "Sole",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.43.0015",
      "rawHtsCode": "0304.43.00.15",
      "superior": null,
      "indent": "3",
      "description": "Paice",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.43.0020",
      "rawHtsCode": "0304.43.00.20",
      "superior": null,
      "indent": "3",
      "description": "Flounder",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.43.0025",
      "rawHtsCode": "0304.43.00.25",
      "superior": null,
      "indent": "3",
      "description": "Greenland turbot (Greenland halibut), (<i>Reinhardtius hippoglossoides</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.43.0090",
      "rawHtsCode": "0304.43.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.44.00",
      "rawHtsCode": "0304.44.00",
      "superior": null,
      "indent": "2",
      "description": "Fish of the families <i>Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae</i> and <i>Muraenolepididae</i>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.44.0010",
      "rawHtsCode": "0304.44.00.10",
      "superior": null,
      "indent": "4",
      "description": "Atlantic Cod",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.44.0015",
      "rawHtsCode": "0304.44.00.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.44.0020",
      "rawHtsCode": "0304.44.00.20",
      "superior": null,
      "indent": "3",
      "description": "Haddock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.44.0025",
      "rawHtsCode": "0304.44.00.25",
      "superior": null,
      "indent": "3",
      "description": "Pollock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.44.0030",
      "rawHtsCode": "0304.44.00.30",
      "superior": null,
      "indent": "3",
      "description": "Hake",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.44.0090",
      "rawHtsCode": "0304.44.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.45.0000",
      "rawHtsCode": "0304.45.00.00",
      "superior": null,
      "indent": "2",
      "description": "Swordfish (<i>Xiphias gladius</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.46.0000",
      "rawHtsCode": "0304.46.00.00",
      "superior": null,
      "indent": "2",
      "description": "Toothfish (<i>Dissostichus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.47.0000",
      "rawHtsCode": "0304.47.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dogfish and other sharks",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.48.0000",
      "rawHtsCode": "0304.48.00.00",
      "superior": null,
      "indent": "2",
      "description": "Rays and skates (<i>Rajidae)</i>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.49.01",
      "rawHtsCode": "0304.49.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.49.0103",
      "rawHtsCode": "0304.49.01.03",
      "superior": null,
      "indent": "4",
      "description": "Pike",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.49.0106",
      "rawHtsCode": "0304.49.01.06",
      "superior": null,
      "indent": "4",
      "description": "Pickerel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.49.0109",
      "rawHtsCode": "0304.49.01.09",
      "superior": null,
      "indent": "4",
      "description": "Whitefish",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.49.0112",
      "rawHtsCode": "0304.49.01.12",
      "superior": null,
      "indent": "4",
      "description": "Tilapia, other than <i>Oreochromis spp.</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.49.0115",
      "rawHtsCode": "0304.49.01.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.49.0120",
      "rawHtsCode": "0304.49.01.20",
      "superior": null,
      "indent": "3",
      "description": "Atlantic ocean perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.49.0125",
      "rawHtsCode": "0304.49.01.25",
      "superior": null,
      "indent": "3",
      "description": "Cusk",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.49.0190",
      "rawHtsCode": "0304.49.01.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.51.01",
      "rawHtsCode": "0304.51.01",
      "superior": null,
      "indent": "2",
      "description": "Tilapias (<i>Oreochromis spp</i>.), catfish (<i>Pangasius spp</i>., <i>Silurus spp</i>., <i>Clarias</i> <i>spp</i>., <i>Ictalurus spp</i>.), carp (<i>Cyprinus spp</i>., <i>Carassius spp</i>., <i>Ctenopharyngodon idellus</i>, <i>Hypophthalmichthys spp</i>., <i>Cirrhinus spp</i>., <i>Mylopharyngodon piceus</i>, <i>Catla catla</i>, <i>Labeo spp</i>., <i>Osteochilus hasselti</i>, <i>Leptobarbus hoeveni</i>, <i>Megalobrama spp</i>.), eels (<i>Anguilla spp</i>.), Nile perch (<i>Lates niloticus</i>) and snakeheads (<i>Channa spp</i>.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.51.0110",
      "rawHtsCode": "0304.51.01.10",
      "superior": null,
      "indent": "3",
      "description": "<i>Ictalurus spp.</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.51.0115",
      "rawHtsCode": "0304.51.01.15",
      "superior": null,
      "indent": "3",
      "description": "<i>Pangasius spp.</i>, including basa and tra",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.51.0120",
      "rawHtsCode": "0304.51.01.20",
      "superior": null,
      "indent": "3",
      "description": "Nile Perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.51.0125",
      "rawHtsCode": "0304.51.01.25",
      "superior": null,
      "indent": "3",
      "description": "Tilapias (<i>Oreochromis spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.51.0190",
      "rawHtsCode": "0304.51.01.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.52.00",
      "rawHtsCode": "0304.52.00",
      "superior": null,
      "indent": "2",
      "description": "Salmonidae",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.52.0010",
      "rawHtsCode": "0304.52.00.10",
      "superior": null,
      "indent": "4",
      "description": "Farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.52.0015",
      "rawHtsCode": "0304.52.00.15",
      "superior": null,
      "indent": "4",
      "description": "Not farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.52.0020",
      "rawHtsCode": "0304.52.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other salmon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.52.0090",
      "rawHtsCode": "0304.52.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.53.00",
      "rawHtsCode": "0304.53.00",
      "superior": null,
      "indent": "2",
      "description": "Fish of the families <i>Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae</i> and <i>Muraenolepididae</i>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.53.0010",
      "rawHtsCode": "0304.53.00.10",
      "superior": null,
      "indent": "4",
      "description": "Atlantic Cod",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.53.0015",
      "rawHtsCode": "0304.53.00.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.53.0020",
      "rawHtsCode": "0304.53.00.20",
      "superior": null,
      "indent": "3",
      "description": "Haddock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.53.0025",
      "rawHtsCode": "0304.53.00.25",
      "superior": null,
      "indent": "3",
      "description": "Pollock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.53.0030",
      "rawHtsCode": "0304.53.00.30",
      "superior": null,
      "indent": "3",
      "description": "Hake",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.53.0090",
      "rawHtsCode": "0304.53.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.54.0000",
      "rawHtsCode": "0304.54.00.00",
      "superior": null,
      "indent": "2",
      "description": "Swordfish (<i>Xiphias gladius</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.55.0000",
      "rawHtsCode": "0304.55.00.00",
      "superior": null,
      "indent": "2",
      "description": "Toothfish (<i>Dissostichus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.56.0000",
      "rawHtsCode": "0304.56.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dogfish and other sharks",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.57.0000",
      "rawHtsCode": "0304.57.00.00",
      "superior": null,
      "indent": "2",
      "description": "Rays and skates (<i>Rajidae)</i>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.59.00",
      "rawHtsCode": "0304.59.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.59.0003",
      "rawHtsCode": "0304.59.00.03",
      "superior": null,
      "indent": "5",
      "description": "Yellow perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0006",
      "rawHtsCode": "0304.59.00.06",
      "superior": null,
      "indent": "5",
      "description": "Pike perch (including yellow pike)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0009",
      "rawHtsCode": "0304.59.00.09",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0015",
      "rawHtsCode": "0304.59.00.15",
      "superior": null,
      "indent": "4",
      "description": "Pike",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0020",
      "rawHtsCode": "0304.59.00.20",
      "superior": null,
      "indent": "4",
      "description": "Pickerel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0025",
      "rawHtsCode": "0304.59.00.25",
      "superior": null,
      "indent": "4",
      "description": "Whitefish",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0030",
      "rawHtsCode": "0304.59.00.30",
      "superior": null,
      "indent": "4",
      "description": "Tilapia other than <i>Oreochromis spp.</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0036",
      "rawHtsCode": "0304.59.00.36",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0040",
      "rawHtsCode": "0304.59.00.40",
      "superior": null,
      "indent": "4",
      "description": "Sole",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0045",
      "rawHtsCode": "0304.59.00.45",
      "superior": null,
      "indent": "4",
      "description": "Plaice",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0050",
      "rawHtsCode": "0304.59.00.50",
      "superior": null,
      "indent": "4",
      "description": "Flounder",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0055",
      "rawHtsCode": "0304.59.00.55",
      "superior": null,
      "indent": "4",
      "description": "Greenland turbot (Greenland halibut), (<i>Reinhardtius hippoglossoides</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0061",
      "rawHtsCode": "0304.59.00.61",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0065",
      "rawHtsCode": "0304.59.00.65",
      "superior": null,
      "indent": "3",
      "description": "Atlantic ocean perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0070",
      "rawHtsCode": "0304.59.00.70",
      "superior": null,
      "indent": "3",
      "description": "Cusk",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.59.0091",
      "rawHtsCode": "0304.59.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.61.0000",
      "rawHtsCode": "0304.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tilapias (<i>Oreochromis spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0304.62.00",
      "rawHtsCode": "0304.62.00",
      "superior": null,
      "indent": "2",
      "description": "Catfish (<i>Pangasius spp., Silurus spp., Clarias spp., Ictalurus spp.</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.62.0010",
      "rawHtsCode": "0304.62.00.10",
      "superior": null,
      "indent": "3",
      "description": "<i>Ictalurus spp.</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.62.0020",
      "rawHtsCode": "0304.62.00.20",
      "superior": null,
      "indent": "3",
      "description": "<i>Pangasius spp</i>. (including basa and tra)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.62.0030",
      "rawHtsCode": "0304.62.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other Siluriformes",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.62.0090",
      "rawHtsCode": "0304.62.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.63.0000",
      "rawHtsCode": "0304.63.00.00",
      "superior": null,
      "indent": "2",
      "description": "Nile perch (<i>Lates niloticus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.69.0000",
      "rawHtsCode": "0304.69.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.71",
      "rawHtsCode": "0304.71",
      "superior": null,
      "indent": "2",
      "description": "Cod (<i>Gadus morhua, Gadus ogac,Gadus macrocephalus</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.71.1000",
      "rawHtsCode": "0304.71.10.00",
      "superior": null,
      "indent": "3",
      "description": "Skinned, whether or not divided into pieces, and frozen into blocks each weighing over 4.5 kg, imported to be minced, ground or cut into pieces of uniform weights and dimensions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.71.5000",
      "rawHtsCode": "0304.71.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.72",
      "rawHtsCode": "0304.72",
      "superior": null,
      "indent": "2",
      "description": "Haddock (<i>Melanogrammus aeglefinus</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.72.1000",
      "rawHtsCode": "0304.72.10.00",
      "superior": null,
      "indent": "3",
      "description": "Skinned, whether or not divided into pieces, and frozen into blocks each weighing over 4.5 kg, imported to be minced, ground or cut into pieces of uniform weights and dimensions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.72.5000",
      "rawHtsCode": "0304.72.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        " See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "0304.73",
      "rawHtsCode": "0304.73",
      "superior": null,
      "indent": "2",
      "description": "Coalfish (<i>Pollachius virens</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.73.1000",
      "rawHtsCode": "0304.73.10.00",
      "superior": null,
      "indent": "3",
      "description": "Skinned, whether or not divided into pieces, and frozen into blocks each weighing over 4.5 kg, imported to be minced, ground or cut into pieces of uniform weights and dimensions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.73.5000",
      "rawHtsCode": "0304.73.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.74",
      "rawHtsCode": "0304.74",
      "superior": null,
      "indent": "2",
      "description": "Hake (<i>Merluccius spp., Urophycis spp.</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.74.1000",
      "rawHtsCode": "0304.74.10.00",
      "superior": null,
      "indent": "3",
      "description": "Skinned, whether or not divided into pieces, and frozen into blocks each weighing over 4.5 kg, imported to be minced, ground or cut into pieces of uniform weights and dimensions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.74.5000",
      "rawHtsCode": "0304.74.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.75",
      "rawHtsCode": "0304.75",
      "superior": null,
      "indent": "2",
      "description": "Alaska pollock (<i>Theragra chalcogramma</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.75.1000",
      "rawHtsCode": "0304.75.10.00",
      "superior": null,
      "indent": "3",
      "description": "Skinned, whether or not divided into pieces, and frozen into blocks each weighing over 4.5 kg, imported to be minced, ground or cut into pieces of uniform weights and dimensions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.75.5000",
      "rawHtsCode": "0304.75.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.79",
      "rawHtsCode": "0304.79",
      "superior": null,
      "indent": "2",
      "description": "Other<i></i>:<i></i>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.79.10",
      "rawHtsCode": "0304.79.10",
      "superior": null,
      "indent": "3",
      "description": "Skinned, whether or not divided into pieces, and frozen into blocks each weighing over 4.5 kg, imported to be minced, ground or cut into pieces of uniform weights and dimensions",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.79.1010",
      "rawHtsCode": "0304.79.10.10",
      "superior": null,
      "indent": "4",
      "description": "Pollock other than Alaska pollock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.79.1015",
      "rawHtsCode": "0304.79.10.15",
      "superior": null,
      "indent": "4",
      "description": "Whiting (<i>Merluccius spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.79.1090",
      "rawHtsCode": "0304.79.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.79.5000",
      "rawHtsCode": "0304.79.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.81",
      "rawHtsCode": "0304.81",
      "superior": null,
      "indent": "2",
      "description": "Pacific salmon (<i>Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou</i> and <i>Oncorhynchus rhodurus</i>) Atlantic Salmon (<i>Salmo salar</i>) and Danube salmon (<i>Hucho hucho</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.81.1000",
      "rawHtsCode": "0304.81.10.00",
      "superior": null,
      "indent": "3",
      "description": "Skinned, whether or not divided into pieces, and frozen into blocks each weighing over 4.5 kg, imported to be minced, ground or cut into pieces of uniform weights and dimensions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.81.50",
      "rawHtsCode": "0304.81.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.81.5010",
      "rawHtsCode": "0304.81.50.10",
      "superior": null,
      "indent": "4",
      "description": "Atlantic salmon (<i>Salmo salar</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.81.5090",
      "rawHtsCode": "0304.81.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.82",
      "rawHtsCode": "0304.82",
      "superior": null,
      "indent": "2",
      "description": "Trout (<i>Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae Oncorhynchus apache</i> and <i>Oncorhynchus chrysogaster</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.82.1000",
      "rawHtsCode": "0304.82.10.00",
      "superior": null,
      "indent": "3",
      "description": "Skinned, whether or not divided into pieces, and frozen into blocks each weighing over 4.5 kg, imported to be minced, ground or cut into pieces of uniform weights and dimensions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.82.5000",
      "rawHtsCode": "0304.82.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.83",
      "rawHtsCode": "0304.83",
      "superior": null,
      "indent": "2",
      "description": "Flat fish (<i>Pleuronectidae, Bothidae, Cynoglossidae, Soleidae, Scophthalmidae</i>, and <i>Citharidae</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.83.10",
      "rawHtsCode": "0304.83.10",
      "superior": null,
      "indent": "3",
      "description": "Skinned, whether or not divided into pieces, and frozen into blocks each weighing over 4.5 kg, imported to be minced, ground or cut into pieces of uniform weights and dimensions",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.83.1010",
      "rawHtsCode": "0304.83.10.10",
      "superior": null,
      "indent": "4",
      "description": "Greenland turbot (Greenland halibut) (<i>Reinhardtius hippoglossoides</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.83.1015",
      "rawHtsCode": "0304.83.10.15",
      "superior": null,
      "indent": "4",
      "description": "Sole",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "0304.83.1020",
      "rawHtsCode": "0304.83.10.20",
      "superior": null,
      "indent": "4",
      "description": "Flounder",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "0304.83.1025",
      "rawHtsCode": "0304.83.10.25",
      "superior": null,
      "indent": "5",
      "description": "Halibut",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.83.1030",
      "rawHtsCode": "0304.83.10.30",
      "superior": null,
      "indent": "5",
      "description": "Turbot",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.83.1090",
      "rawHtsCode": "0304.83.10.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.83.50",
      "rawHtsCode": "0304.83.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.83.5010",
      "rawHtsCode": "0304.83.50.10",
      "superior": null,
      "indent": "4",
      "description": "Greenland turbot (Greenland halibut) (<i>Reinhardtius hippoglossoides</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.83.5015",
      "rawHtsCode": "0304.83.50.15",
      "superior": null,
      "indent": "4",
      "description": "Sole",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "0304.83.5020",
      "rawHtsCode": "0304.83.50.20",
      "superior": null,
      "indent": "4",
      "description": "Flounder",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "0304.83.5025",
      "rawHtsCode": "0304.83.50.25",
      "superior": null,
      "indent": "5",
      "description": "Halibut",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.83.5030",
      "rawHtsCode": "0304.83.50.30",
      "superior": null,
      "indent": "5",
      "description": "Turbot",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.83.5090",
      "rawHtsCode": "0304.83.50.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "0304.84.0000",
      "rawHtsCode": "0304.84.00.00",
      "superior": null,
      "indent": "2",
      "description": "Swordfish (<i>Xiphias gladius</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.85.0000",
      "rawHtsCode": "0304.85.00.00",
      "superior": null,
      "indent": "2",
      "description": "Toothfish (<i>Dissostichus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.86.0000",
      "rawHtsCode": "0304.86.00.00",
      "superior": null,
      "indent": "2",
      "description": "Herrings (<i>Clupea harengus, Clupea pallasii</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.87.0000",
      "rawHtsCode": "0304.87.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tunas (of the genus <i>Thunnus</i>), skipjack tuna (stripe-bellied bonito) (<i>Katsuwonus pelamis</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0304.88.0000",
      "rawHtsCode": "0304.88.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dogfish, other sharks, rays and skates (Rajidae)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.89",
      "rawHtsCode": "0304.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.10",
      "rawHtsCode": "0304.89.10",
      "superior": null,
      "indent": "3",
      "description": "Skinned, whether or not divided into pieces, and frozen into blocks each weighing over 4.5 kg, imported to be minced, ground or cut into pieces of uniform weights and dimensions",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.89.1010",
      "rawHtsCode": "0304.89.10.10",
      "superior": null,
      "indent": "4",
      "description": "Ocean catfish (wolf fish)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.1015",
      "rawHtsCode": "0304.89.10.15",
      "superior": null,
      "indent": "4",
      "description": "Pickerel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.1020",
      "rawHtsCode": "0304.89.10.20",
      "superior": null,
      "indent": "4",
      "description": "Sauger",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.1025",
      "rawHtsCode": "0304.89.10.25",
      "superior": null,
      "indent": "5",
      "description": "Atlantic ocean perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.1030",
      "rawHtsCode": "0304.89.10.30",
      "superior": null,
      "indent": "5",
      "description": "Other ocean perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.1035",
      "rawHtsCode": "0304.89.10.35",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.1090",
      "rawHtsCode": "0304.89.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.50",
      "rawHtsCode": "0304.89.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.89.5003",
      "rawHtsCode": "0304.89.50.03",
      "superior": null,
      "indent": "6",
      "description": "Yellow perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5006",
      "rawHtsCode": "0304.89.50.06",
      "superior": null,
      "indent": "6",
      "description": "Pike perch (including yellow pike)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5009",
      "rawHtsCode": "0304.89.50.09",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5015",
      "rawHtsCode": "0304.89.50.15",
      "superior": null,
      "indent": "5",
      "description": "Pickerel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5020",
      "rawHtsCode": "0304.89.50.20",
      "superior": null,
      "indent": "5",
      "description": "Pike",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5025",
      "rawHtsCode": "0304.89.50.25",
      "superior": null,
      "indent": "5",
      "description": "Sauger",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5030",
      "rawHtsCode": "0304.89.50.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5035",
      "rawHtsCode": "0304.89.50.35",
      "superior": null,
      "indent": "4",
      "description": "Atlantic ocean perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5040",
      "rawHtsCode": "0304.89.50.40",
      "superior": null,
      "indent": "4",
      "description": "Other ocean perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5045",
      "rawHtsCode": "0304.89.50.45",
      "superior": null,
      "indent": "4",
      "description": "Ocean catfish (wolf fish)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5050",
      "rawHtsCode": "0304.89.50.50",
      "superior": null,
      "indent": "4",
      "description": "Orange roughy (<i>Hoplostethus atlanticus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5055",
      "rawHtsCode": "0304.89.50.55",
      "superior": null,
      "indent": "4",
      "description": "Dolphin (Mahi mahi) (<i>Coryphaena spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5060",
      "rawHtsCode": "0304.89.50.60",
      "superior": null,
      "indent": "4",
      "description": "Cusk",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.89.5091",
      "rawHtsCode": "0304.89.50.91",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.91",
      "rawHtsCode": "0304.91",
      "superior": null,
      "indent": "2",
      "description": "Swordfish (<i>Xiphias gladius</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.91.1000",
      "rawHtsCode": "0304.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "In bulk or in immediate containers weighing with their contents over <il>6.8 kg</il> each",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.91.9000",
      "rawHtsCode": "0304.91.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0304.92",
      "rawHtsCode": "0304.92",
      "superior": null,
      "indent": "2",
      "description": "Toothfish (<i>Dissostichus spp.</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.92.1000",
      "rawHtsCode": "0304.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "In bulk or in immediate containers weighing with their contents over <il>6.8 kg</il> each",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.92.9000",
      "rawHtsCode": "0304.92.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0304.93",
      "rawHtsCode": "0304.93",
      "superior": null,
      "indent": "2",
      "description": "Tilapias (<i>Oreochromis spp</i>.), catfish (<i>Pangasius spp</i>., <i>Silurus spp</i>., <i>Clarias</i> <i>spp</i>., <i>Ictalurus spp</i>.), carp (<i>Cyprinus spp</i>., <i>Carassius spp</i>., <i>Ctenopharyngodon idellus</i>, <i>Hypophthalmichthys spp</i>., <i>Cirrhinus spp</i>., <i>Mylopharyngodon piceus</i>, <i>Catla catla</i>, <i>Labeo spp</i>., <i>Osteochilus hasselti</i>, <i>Leptobarbus hoeveni</i>, <i>Megalobrama spp</i>.), eels (<i>Anguilla spp</i>.), Nile perch (<i>Lates niloticus</i>) and snakeheads (<i>Channa spp</i>.):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.93.10",
      "rawHtsCode": "0304.93.10",
      "superior": null,
      "indent": "3",
      "description": "In bulk or in immediate containers weighing with their contents over <il>6.8 kg</il> each",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.93.1005",
      "rawHtsCode": "0304.93.10.05",
      "superior": null,
      "indent": "5",
      "description": "Surimi",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.93.1010",
      "rawHtsCode": "0304.93.10.10",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.93.1090",
      "rawHtsCode": "0304.93.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.93.9000",
      "rawHtsCode": "0304.93.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0304.94",
      "rawHtsCode": "0304.94",
      "superior": null,
      "indent": "2",
      "description": "Alaska pollock (<i>Theragra chalcogramma</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.94.10",
      "rawHtsCode": "0304.94.10",
      "superior": null,
      "indent": "3",
      "description": "In bulk or in immediate containers weighing with their contents over <il>6.8 kg</il> each",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.94.1005",
      "rawHtsCode": "0304.94.10.05",
      "superior": null,
      "indent": "5",
      "description": "Surimi",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.94.1010",
      "rawHtsCode": "0304.94.10.10",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.94.1090",
      "rawHtsCode": "0304.94.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.94.9000",
      "rawHtsCode": "0304.94.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0304.95",
      "rawHtsCode": "0304.95",
      "superior": null,
      "indent": "2",
      "description": "Fish of the families <i>Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae</i> and <i>Muraenolepididae</i>, other than Alaska Pollock (<i>Theragra chalcogramma</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.95.10",
      "rawHtsCode": "0304.95.10",
      "superior": null,
      "indent": "3",
      "description": "In bulk or in immediate containers weighing with their contents over <il>6.8 kg</il> each",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.95.1005",
      "rawHtsCode": "0304.95.10.05",
      "superior": null,
      "indent": "5",
      "description": "Surimi",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.95.1010",
      "rawHtsCode": "0304.95.10.10",
      "superior": null,
      "indent": "6",
      "description": "Cod",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.95.1015",
      "rawHtsCode": "0304.95.10.15",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.95.1020",
      "rawHtsCode": "0304.95.10.20",
      "superior": null,
      "indent": "5",
      "description": "Cod",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.95.1025",
      "rawHtsCode": "0304.95.10.25",
      "superior": null,
      "indent": "5",
      "description": "Haddock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.95.1030",
      "rawHtsCode": "0304.95.10.30",
      "superior": null,
      "indent": "5",
      "description": "Pollock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.95.1090",
      "rawHtsCode": "0304.95.10.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.95.9000",
      "rawHtsCode": "0304.95.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0304.96.0000",
      "rawHtsCode": "0304.96.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dogfish and other sharks",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0304.97.0000",
      "rawHtsCode": "0304.97.00.00",
      "superior": null,
      "indent": "2",
      "description": "Rays and skates (<i>Rajidae)</i>",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0304.99",
      "rawHtsCode": "0304.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.99.11",
      "rawHtsCode": "0304.99.11",
      "superior": null,
      "indent": "3",
      "description": "In bulk or in immediate containers weighing with their contents over <il>6.8 kg</il> each",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0304.99.1104",
      "rawHtsCode": "0304.99.11.04",
      "superior": null,
      "indent": "5",
      "description": "Surimi",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.99.1109",
      "rawHtsCode": "0304.99.11.09",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.99.1150",
      "rawHtsCode": "0304.99.11.50",
      "superior": null,
      "indent": "5",
      "description": "Sole",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.99.1160",
      "rawHtsCode": "0304.99.11.60",
      "superior": null,
      "indent": "5",
      "description": "Greenland turbot (Greenland halibut) (<i>Reinhardtius hippoglossoides</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.99.1170",
      "rawHtsCode": "0304.99.11.70",
      "superior": null,
      "indent": "5",
      "description": "Ocean perch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.99.1182",
      "rawHtsCode": "0304.99.11.82",
      "superior": null,
      "indent": "5",
      "description": "Pike",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.99.1183",
      "rawHtsCode": "0304.99.11.83",
      "superior": null,
      "indent": "5",
      "description": "Whitefish",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.99.1184",
      "rawHtsCode": "0304.99.11.84",
      "superior": null,
      "indent": "6",
      "description": "Fresh-water",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.99.1190",
      "rawHtsCode": "0304.99.11.90",
      "superior": null,
      "indent": "6",
      "description": "Tuna [of genus <i>Thunnus</i> and of fish of the genus <i>Euthynnus</i><i>(Katsuwonus) pelamis</i>]",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.99.1194",
      "rawHtsCode": "0304.99.11.94",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.99.91",
      "rawHtsCode": "0304.99.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0304.99.9190",
      "rawHtsCode": "0304.99.91.90",
      "superior": null,
      "indent": "4",
      "description": "Ocean",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0304.99.9192",
      "rawHtsCode": "0304.99.91.92",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305",
      "rawHtsCode": "0305",
      "superior": null,
      "indent": "0",
      "description": "Fish, dried, salted or in brine; smoked fish, whether or not cooked before or during the smoking process:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.20",
      "rawHtsCode": "0305.20",
      "superior": null,
      "indent": "1",
      "description": "Livers, roes and milt of fish, dried, smoked, salted or in brine:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.20.2000",
      "rawHtsCode": "0305.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Sturgeon roe",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0305.20.40",
      "rawHtsCode": "0305.20.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "44¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.20.4020",
      "rawHtsCode": "0305.20.40.20",
      "superior": null,
      "indent": "3",
      "description": "Salmon roe",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.20.4040",
      "rawHtsCode": "0305.20.40.40",
      "superior": null,
      "indent": "3",
      "description": "Herring roe",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.20.4065",
      "rawHtsCode": "0305.20.40.65",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.31.0100",
      "rawHtsCode": "0305.31.01.00",
      "superior": null,
      "indent": "2",
      "description": "Tilapias (<i>Oreochromis spp</i>.), catfish (<i>Pangasius spp</i>., <i>Silurus sp</i>p., <i>Clarias spp</i>., I<i>ctalurus spp</i>.), carp (<i>Cyprinus spp</i>., <i>Carassius spp</i>., <i>Ctenopharyngodon idellus</i>, <i>Hypophthalmichthys spp</i>., <i>Cirrhinus spp</i>., <i>Mylopharyngodon piceus</i>, <i>Catla catla</i>, <i>Labeo spp</i>., <i>Osteochilus hasselti</i>, <i>Leptobarbus hoeveni</i>, <i>Megalobrama spp</i>.), eels (<i>Anguilla spp</i>.), Nile perch (<i>Lates niloticus</i>) and snakeheads (<i>Channa spp</i>.)  ",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.32.00",
      "rawHtsCode": "0305.32.00",
      "superior": null,
      "indent": "2",
      "description": "Fish of the families <i>Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae</i> and <i>Muraenolepididae</i>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.32.0010",
      "rawHtsCode": "0305.32.00.10",
      "superior": null,
      "indent": "3",
      "description": "Cod",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.32.0090",
      "rawHtsCode": "0305.32.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.39",
      "rawHtsCode": "0305.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.39.2000",
      "rawHtsCode": "0305.39.20.00",
      "superior": null,
      "indent": "3",
      "description": "Herrings, in immediate containers weighing with their contents 6.8 kg or less each",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0305.39.4000",
      "rawHtsCode": "0305.39.40.00",
      "superior": null,
      "indent": "3",
      "description": "Mackerel, in immediate containers weighing with their contents 6.8 kg or less each",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0305.39.61",
      "rawHtsCode": "0305.39.61",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.39.6110",
      "rawHtsCode": "0305.39.61.10",
      "superior": null,
      "indent": "4",
      "description": "Herring",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.39.6180",
      "rawHtsCode": "0305.39.61.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.41.0000",
      "rawHtsCode": "0305.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Pacific salmon (<i>Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou</i> and <i>Oncorhynchus rhodurus</i>),Atlantic salmon (<i>Salmo salar</i>) and Danube salmon (<i>Hucho hucho</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0305.42.00",
      "rawHtsCode": "0305.42.00",
      "superior": null,
      "indent": "2",
      "description": "Herrings (<i>Clupea harengus, Clupea pallasii</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.42.0020",
      "rawHtsCode": "0305.42.00.20",
      "superior": null,
      "indent": "3",
      "description": "Whole or beheaded but not otherwise processed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.42.0050",
      "rawHtsCode": "0305.42.00.50",
      "superior": null,
      "indent": "4",
      "description": "Boneless",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.42.0060",
      "rawHtsCode": "0305.42.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.43.0000",
      "rawHtsCode": "0305.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "Trout (<i>Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache</i> and <i>Oncorhynchus chrysogaster</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.44.0100",
      "rawHtsCode": "0305.44.01.00",
      "superior": null,
      "indent": "2",
      "description": "Tilapias (<i>Oreochromis spp</i>.), catfish (<i>Pangasius spp</i>., <i>Silurus spp</i>., <i>Clarias spp</i>.,<i> Ictalurus spp</i>.), carp (<i>Cyprinus spp</i>., <i>Carassius spp</i>., <i>Ctenopharyngodon idellus</i>, <i>Hypophthalmichthys spp</i>., <i>Cirrhinus spp</i>., <i>Mylopharyngodon piceus</i>, <i>Catla catla</i>, <i>Labeo spp</i>., <i>Osteochilus hasselti</i>, <i>Leptobarbus hoeveni</i>, <i>Megalobrama spp</i>.), eels <i>(Anguilla</i> <i>spp</i>.), Nile perch (<i>Lates niloticus</i>) and snakeheads <i>(Channa spp</i>.)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.49",
      "rawHtsCode": "0305.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.49.2000",
      "rawHtsCode": "0305.49.20.00",
      "superior": null,
      "indent": "3",
      "description": "Mackerel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.49.40",
      "rawHtsCode": "0305.49.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.49.4020",
      "rawHtsCode": "0305.49.40.20",
      "superior": null,
      "indent": "4",
      "description": "Cod, cusk, haddock, hake (<i>Urophycis spp.</i>) and pollock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.49.4045",
      "rawHtsCode": "0305.49.40.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.51.0000",
      "rawHtsCode": "0305.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cod (<i>Gadus morhua, Gadus ogac, Gadus macrocephalus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.52.0000",
      "rawHtsCode": "0305.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tilapias (<i>Oreochromis spp</i>.), catfish (<i>Pangasius spp</i>., <i>Silurus spp</i>., <i>Clarias</i> <i>spp</i>., <i>Ictalurus spp</i>.), carp (<i>Cyprinus spp</i>., <i>Carassius spp</i>., <i>Ctenopharyngodon idellus</i>, <i>Hypophthalmichthys spp</i>., <i>Cirrhinus spp</i>., <i>Mylopharyngodon piceus</i>, <i>Catla catla</i>, <i>Labeo spp</i>., <i>Osteochilus hasselti</i>, <i>Leptobarbus hoeveni</i>, <i>Megalobrama spp</i>.), eels (<i>Anguilla spp</i>.), Nile perch (<i>Lates niloticus</i>) and snakeheads (<i>Channa spp</i>.)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.53.0000",
      "rawHtsCode": "0305.53.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fish of the families <i>Bregmacerotidae</i>,<i> Euclichthyidae</i>, <i>Gadidae</i>, <i>Macrouridae</i>,<i>Melanonidae</i>, <i>Merlucciidae</i>, <i>Moridae</i> and<i> Muraenolepididae</i>, other than cod (<i>Gadus morhua</i>, <i>Gadus ogac</i>, <i>Gadus macrocephalus</i>). ",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.54.0000",
      "rawHtsCode": "0305.54.00.00",
      "superior": null,
      "indent": "2",
      "description": "Herrings (<i>Clupea harengus</i>, <i>Clupea pallasii</i>), anchovies (<i>Engraulis</i> <i>spp</i>.), sardines (<i>Sardina pilchardus</i>, <i>Sardinops spp</i>.), <i>sardinella</i> (<i>Sardinella spp</i>.), brisling or sprats (<i>Sprattus sprattus</i>), mackerel (<i>Scomber scombrus</i>, <i>Scomber australasicus</i>, <i>Scomber japonicus</i>), Indian mackerels (<i>Rastrelliger spp</i>.), seerfishes (<i>Scomberomorus</i> <i>spp</i>.), jack and horse mackerel (<i>Trachurus spp</i>.), jacks, crevalles (<i>Caranx spp</i>.), cobia (<i>Rachycentron canadum</i>), silver pomfrets (<i>Pampus spp</i>.), Pacific saury (<i>Cololabis saira</i>), scads (<i>Decapterus</i> <i>spp</i>.), capelin (<i>Mallotus villosus</i>), swordfish (<i>Xiphias gladius</i>), Kawakawa (<i>Euthynnus affinis</i>), bonitos (<i>Sarda spp</i>.), marlins, sailfishes, spearfish (<i>Istiophoridae</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.59.0001",
      "rawHtsCode": "0305.59.00.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.61",
      "rawHtsCode": "0305.61",
      "superior": null,
      "indent": "2",
      "description": "Herrings (<i>Clupea harengus, Clupea pallasii</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.61.2000",
      "rawHtsCode": "0305.61.20.00",
      "superior": null,
      "indent": "3",
      "description": "In immediate containers weighing with their contents 6.8 kg or less each",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0305.61.4000",
      "rawHtsCode": "0305.61.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.62.00",
      "rawHtsCode": "0305.62.00",
      "superior": null,
      "indent": "2",
      "description": "Cod (<i>Gadus morhua, Gadus ogac, Gadus macrocephalus</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.62.0010",
      "rawHtsCode": "0305.62.00.10",
      "superior": null,
      "indent": "4",
      "description": "Having a moisture content by weight over 50 percent",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.62.0025",
      "rawHtsCode": "0305.62.00.25",
      "superior": null,
      "indent": "4",
      "description": "Having a moisture content by weight over 45 percent but not over 50 percent",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.62.0030",
      "rawHtsCode": "0305.62.00.30",
      "superior": null,
      "indent": "4",
      "description": "Having a moisture content by weight over 43 percent but not over 45 percent",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.62.0045",
      "rawHtsCode": "0305.62.00.45",
      "superior": null,
      "indent": "4",
      "description": "Having a moisture content by weight not over 43 percent",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.62.0050",
      "rawHtsCode": "0305.62.00.50",
      "superior": null,
      "indent": "4",
      "description": "Having a moisture content by weight over 50 percent",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.62.0060",
      "rawHtsCode": "0305.62.00.60",
      "superior": null,
      "indent": "4",
      "description": "Having a moisture content by weight over 45 percent but not over 50 percent",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.62.0070",
      "rawHtsCode": "0305.62.00.70",
      "superior": null,
      "indent": "4",
      "description": "Having a moisture content by weight over 43 percent but not over 45 percent",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.62.0080",
      "rawHtsCode": "0305.62.00.80",
      "superior": null,
      "indent": "4",
      "description": "Having a moisture content by weight not over 43 percent",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.63",
      "rawHtsCode": "0305.63",
      "superior": null,
      "indent": "2",
      "description": "Anchovies (<i>Engraulis spp.</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.63.2000",
      "rawHtsCode": "0305.63.20.00",
      "superior": null,
      "indent": "4",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0305.63.4000",
      "rawHtsCode": "0305.63.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.63.6000",
      "rawHtsCode": "0305.63.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.64",
      "rawHtsCode": "0305.64",
      "superior": null,
      "indent": "2",
      "description": "Tilapias (<i>Oreochromis spp</i>.), catfish (<i>Pangasius spp</i>., <i>Silurus spp</i>., <i>Clarias</i> <i>spp</i>., <i>Ictalurus spp</i>.), carp (<i>Cyprinus spp</i>., <i>Carassius spp</i>., <i>Ctenopharyngodon idellus</i>, <i>Hypophthalmichthys spp</i>., <i>Cirrhinus spp</i>., <i>Mylopharyngodon piceus</i>, <i>Catla catla</i>, <i>Labeo spp</i>., <i>Osteochilus hasselti</i>, <i>Leptobarbus hoeveni</i>, <i>Megalobrama spp</i>.), eels (<i>Anguilla spp</i>.), Nile perch (<i>Lates niloticus</i>) and snakeheads (<i>Channa spp</i>.):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.64.1000",
      "rawHtsCode": "0305.64.10.00",
      "superior": null,
      "indent": "3",
      "description": "In immediate containers weighing with their contents 6.8 kg or less each",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.64.5000",
      "rawHtsCode": "0305.64.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0305.69",
      "rawHtsCode": "0305.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.69.10",
      "rawHtsCode": "0305.69.10",
      "superior": null,
      "indent": "3",
      "description": "Cusk, haddock, hake (<i>Urophycis spp.</i>) and pollock",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.69.1021",
      "rawHtsCode": "0305.69.10.21",
      "superior": null,
      "indent": "5",
      "description": "Hake",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.69.1022",
      "rawHtsCode": "0305.69.10.22",
      "superior": null,
      "indent": "5",
      "description": "Pollock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.69.1029",
      "rawHtsCode": "0305.69.10.29",
      "superior": null,
      "indent": "5",
      "description": "Haddock and cusk",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.69.1041",
      "rawHtsCode": "0305.69.10.41",
      "superior": null,
      "indent": "5",
      "description": "Hake",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.69.1042",
      "rawHtsCode": "0305.69.10.42",
      "superior": null,
      "indent": "5",
      "description": "Pollock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.69.1049",
      "rawHtsCode": "0305.69.10.49",
      "superior": null,
      "indent": "5",
      "description": "Haddock and cusk",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0305.69.2000",
      "rawHtsCode": "0305.69.20.00",
      "superior": null,
      "indent": "4",
      "description": "In immediate containers weighing with their contents 6.8 kg or less each",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0305.69.3000",
      "rawHtsCode": "0305.69.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.69.4000",
      "rawHtsCode": "0305.69.40.00",
      "superior": null,
      "indent": "3",
      "description": "Salmon",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0305.69.5001",
      "rawHtsCode": "0305.69.50.01",
      "superior": null,
      "indent": "4",
      "description": "In immediate containers weighing with their contents 6.8 kg or less each",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.69.6001",
      "rawHtsCode": "0305.69.60.01",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0305.71.0000",
      "rawHtsCode": "0305.71.00.00",
      "superior": null,
      "indent": "2",
      "description": "Shark fins",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.72.0000",
      "rawHtsCode": "0305.72.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fish heads, tails and maws",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0305.79.0000",
      "rawHtsCode": "0305.79.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306",
      "rawHtsCode": "0306",
      "superior": null,
      "indent": "0",
      "description": "Crustaceans, whether in shell or not, live, fresh, chilled, frozen, dried, salted or in brine; smoked crustaceans, whether in shell or not, whether or not cooked before or during the smoking process; crustaceans, in shell, cooked by steaming or by boiling in water, whether or not chilled, frozen, dried, salted or in brine:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.11.00",
      "rawHtsCode": "0306.11.00",
      "superior": null,
      "indent": "2",
      "description": "Rock lobster and other sea crawfish (<i>Palinurus spp., Panulirus spp., Jasus spp.</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.11.0010",
      "rawHtsCode": "0306.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Caribbean spiny lobster (<i>Panulirus argus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.11.0020",
      "rawHtsCode": "0306.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.12.00",
      "rawHtsCode": "0306.12.00",
      "superior": null,
      "indent": "2",
      "description": "Lobsters (<i>Homarus spp.</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.12.0010",
      "rawHtsCode": "0306.12.00.10",
      "superior": null,
      "indent": "4",
      "description": "In brine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.12.0030",
      "rawHtsCode": "0306.12.00.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.12.0050",
      "rawHtsCode": "0306.12.00.50",
      "superior": null,
      "indent": "4",
      "description": "In brine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.12.0070",
      "rawHtsCode": "0306.12.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.14",
      "rawHtsCode": "0306.14",
      "superior": null,
      "indent": "2",
      "description": "Crabs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.14.2000",
      "rawHtsCode": "0306.14.20.00",
      "superior": null,
      "indent": "3",
      "description": "Crabmeat",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0306.14.40",
      "rawHtsCode": "0306.14.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.14.4003",
      "rawHtsCode": "0306.14.40.03",
      "superior": null,
      "indent": "5",
      "description": "Red king crab (<i>Paralithodes camtschaticus)</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.14.4006",
      "rawHtsCode": "0306.14.40.06",
      "superior": null,
      "indent": "5",
      "description": "Blue king crab (<i>Paralithodes platypus)</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.14.4009",
      "rawHtsCode": "0306.14.40.09",
      "superior": null,
      "indent": "5",
      "description": "Golden/brown king crab (<i>Lithodes aequispinus)</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.14.4012",
      "rawHtsCode": "0306.14.40.12",
      "superior": null,
      "indent": "5",
      "description": "Southern red santolla king crab (<i>Lithodes santolla formerly L. antarcticus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.14.4015",
      "rawHtsCode": "0306.14.40.15",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.14.4020",
      "rawHtsCode": "0306.14.40.20",
      "superior": null,
      "indent": "4",
      "description": "Snow crab",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.14.4030",
      "rawHtsCode": "0306.14.40.30",
      "superior": null,
      "indent": "4",
      "description": "Dungeness crab",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.14.4090",
      "rawHtsCode": "0306.14.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.15.0000",
      "rawHtsCode": "0306.15.00.00",
      "superior": null,
      "indent": "2",
      "description": "Norway lobsters (<i>Nephrops norvegicus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.16.00",
      "rawHtsCode": "0306.16.00",
      "superior": null,
      "indent": "2",
      "description": "Cold-water shrimps and prawns (<i>Pandalus spp., Crangon crangon</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.16.0003",
      "rawHtsCode": "0306.16.00.03",
      "superior": null,
      "indent": "4",
      "description": "Count size (headless weight) less than 33 per kg (15s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.16.0006",
      "rawHtsCode": "0306.16.00.06",
      "superior": null,
      "indent": "4",
      "description": "Count size (headless weight) 33-45 per kg (15-20s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.16.0009",
      "rawHtsCode": "0306.16.00.09",
      "superior": null,
      "indent": "4",
      "description": "Count size (headless weight) 46-55 per kg (21-25s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.16.0012",
      "rawHtsCode": "0306.16.00.12",
      "superior": null,
      "indent": "4",
      "description": "Count size (headless weight) 56-66 per kg (26-30s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.16.0015",
      "rawHtsCode": "0306.16.00.15",
      "superior": null,
      "indent": "4",
      "description": "Count size (headless weight) 67-88 per kg (31-40s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.16.0018",
      "rawHtsCode": "0306.16.00.18",
      "superior": null,
      "indent": "4",
      "description": "Count size (headless weight) 89-110 per kg (41-50s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.16.0021",
      "rawHtsCode": "0306.16.00.21",
      "superior": null,
      "indent": "4",
      "description": "Count size (headless weight) 111-132 per kg (51-60s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.16.0024",
      "rawHtsCode": "0306.16.00.24",
      "superior": null,
      "indent": "4",
      "description": "Count size (headless weight) 133-154 per kg (61-70s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.16.0027",
      "rawHtsCode": "0306.16.00.27",
      "superior": null,
      "indent": "4",
      "description": "Count size (headless weight) more than 154 per kg (70s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.16.0040",
      "rawHtsCode": "0306.16.00.40",
      "superior": null,
      "indent": "3",
      "description": "Peeled, imported in accordance with statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.00",
      "rawHtsCode": "0306.17.00",
      "superior": null,
      "indent": "2",
      "description": "Other shrimps and prawns",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.17.0004",
      "rawHtsCode": "0306.17.00.04",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) less than 33 per kg (15s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0005",
      "rawHtsCode": "0306.17.00.05",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 33-45 per kg (15-20s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0007",
      "rawHtsCode": "0306.17.00.07",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 46-55 per kg (21-25s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0008",
      "rawHtsCode": "0306.17.00.08",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 56-66 per kg (26-30s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0010",
      "rawHtsCode": "0306.17.00.10",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 67-88 per kg (31-40s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0011",
      "rawHtsCode": "0306.17.00.11",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 89-110 per kg (41-50s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0013",
      "rawHtsCode": "0306.17.00.13",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 111-132 per kg (51-60s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0014",
      "rawHtsCode": "0306.17.00.14",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 133-154 per kg (61-70s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0016",
      "rawHtsCode": "0306.17.00.16",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) more than 154 per kg (70s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0017",
      "rawHtsCode": "0306.17.00.17",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) less than 33 per kg (15s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0019",
      "rawHtsCode": "0306.17.00.19",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 33-45 per kg (15-20s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0020",
      "rawHtsCode": "0306.17.00.20",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 46-55 per kg (21-25s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0022",
      "rawHtsCode": "0306.17.00.22",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 56-66 per kg (26-30s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0023",
      "rawHtsCode": "0306.17.00.23",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 67-88 per kg (31-40s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0025",
      "rawHtsCode": "0306.17.00.25",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 89-110 per kg (41-50s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0026",
      "rawHtsCode": "0306.17.00.26",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 111-132 per kg (51-60s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0028",
      "rawHtsCode": "0306.17.00.28",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) 133-154 per kg (61-70s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0029",
      "rawHtsCode": "0306.17.00.29",
      "superior": null,
      "indent": "5",
      "description": "Count size (headless weight) more than 154 per kg (70s)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0041",
      "rawHtsCode": "0306.17.00.41",
      "superior": null,
      "indent": "4",
      "description": "Farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.17.0042",
      "rawHtsCode": "0306.17.00.42",
      "superior": null,
      "indent": "4",
      "description": "Not farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.19.01",
      "rawHtsCode": "0306.19.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0306.19.0110",
      "rawHtsCode": "0306.19.01.10",
      "superior": null,
      "indent": "3",
      "description": "Freshwater crawfish",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.19.0130",
      "rawHtsCode": "0306.19.01.30",
      "superior": null,
      "indent": "3",
      "description": "Antarctic krill (<i>Euphausia superba</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.19.0161",
      "rawHtsCode": "0306.19.01.61",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.31.0000",
      "rawHtsCode": "0306.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Rock lobster and other sea crawfish (<i>Palinurus spp., Panulirus spp., Jasus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.32.00",
      "rawHtsCode": "0306.32.00",
      "superior": null,
      "indent": "2",
      "description": "Lobsters (<i>Homarus spp.</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.32.0010",
      "rawHtsCode": "0306.32.00.10",
      "superior": null,
      "indent": "3",
      "description": "Live",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.32.0090",
      "rawHtsCode": "0306.32.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.33",
      "rawHtsCode": "0306.33",
      "superior": null,
      "indent": "2",
      "description": "Crabs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.33.2000",
      "rawHtsCode": "0306.33.20.00",
      "superior": null,
      "indent": "3",
      "description": "Crabmeat",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0306.33.4000",
      "rawHtsCode": "0306.33.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.34.0000",
      "rawHtsCode": "0306.34.00.00",
      "superior": null,
      "indent": "2",
      "description": "Norway lobsters (<i>Nephrops norvegicus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.35.00",
      "rawHtsCode": "0306.35.00",
      "superior": null,
      "indent": "2",
      "description": "Cold-water shrimps and prawns (<i>Pandalus spp., Crangon crangon</i>)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.35.0020",
      "rawHtsCode": "0306.35.00.20",
      "superior": null,
      "indent": "3",
      "description": "Shell-on, imported in accordance with statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.35.0040",
      "rawHtsCode": "0306.35.00.40",
      "superior": null,
      "indent": "3",
      "description": "Peeled, imported in accordance with statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.36.00",
      "rawHtsCode": "0306.36.00",
      "superior": null,
      "indent": "2",
      "description": "Other shrimps and prawns",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.36.0020",
      "rawHtsCode": "0306.36.00.20",
      "superior": null,
      "indent": "3",
      "description": "Shell-on, imported in accordance with statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.36.0040",
      "rawHtsCode": "0306.36.00.40",
      "superior": null,
      "indent": "3",
      "description": "Peeled, imported in accordance with statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.39.0100",
      "rawHtsCode": "0306.39.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0306.91.0000",
      "rawHtsCode": "0306.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Rock lobster and other sea crawfish (<i>Palinurus spp., Panulirus spp., Jasus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.92.0000",
      "rawHtsCode": "0306.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Lobsters (<i>Homarus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.93",
      "rawHtsCode": "0306.93",
      "superior": null,
      "indent": "2",
      "description": "Crabs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.93.2000",
      "rawHtsCode": "0306.93.20.00",
      "superior": null,
      "indent": "3",
      "description": "Crabmeat",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0306.93.4000",
      "rawHtsCode": "0306.93.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.94.0000",
      "rawHtsCode": "0306.94.00.00",
      "superior": null,
      "indent": "2",
      "description": "Norway lobsters (<i>Nephrops norvegicus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.95.00",
      "rawHtsCode": "0306.95.00",
      "superior": null,
      "indent": "2",
      "description": "Shrimps and prawns",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0306.95.0020",
      "rawHtsCode": "0306.95.00.20",
      "superior": null,
      "indent": "3",
      "description": "Shell-on, imported in accordance with statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.95.0040",
      "rawHtsCode": "0306.95.00.40",
      "superior": null,
      "indent": "3",
      "description": "Peeled, imported in accordance with statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0306.99.0100",
      "rawHtsCode": "0306.99.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0307",
      "rawHtsCode": "0307",
      "superior": null,
      "indent": "0",
      "description": "Molluscs, whether in shell or not, live, fresh, chilled, frozen, dried, salted or in brine; smoked molluscs, whether in shell or not, whether or not cooked before or during the smoking process:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.11.00",
      "rawHtsCode": "0307.11.00",
      "superior": null,
      "indent": "2",
      "description": "Live, fresh or chilled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.11.0020",
      "rawHtsCode": "0307.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Seed oysters",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.11.0060",
      "rawHtsCode": "0307.11.00.60",
      "superior": null,
      "indent": "4",
      "description": "Farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.11.0080",
      "rawHtsCode": "0307.11.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.12.00",
      "rawHtsCode": "0307.12.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.12.0060",
      "rawHtsCode": "0307.12.00.60",
      "superior": null,
      "indent": "3",
      "description": "Farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.12.0080",
      "rawHtsCode": "0307.12.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.19.01",
      "rawHtsCode": "0307.19.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.19.0160",
      "rawHtsCode": "0307.19.01.60",
      "superior": null,
      "indent": "3",
      "description": "Farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.19.0180",
      "rawHtsCode": "0307.19.01.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.21.0000",
      "rawHtsCode": "0307.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Live, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0307.22.0000",
      "rawHtsCode": "0307.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.29.0100",
      "rawHtsCode": "0307.29.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.31.00",
      "rawHtsCode": "0307.31.00",
      "superior": null,
      "indent": "2",
      "description": "Live, fresh or chilled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.31.0010",
      "rawHtsCode": "0307.31.00.10",
      "superior": null,
      "indent": "3",
      "description": "Farmed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.31.0090",
      "rawHtsCode": "0307.31.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.32.0000",
      "rawHtsCode": "0307.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.39.0100",
      "rawHtsCode": "0307.39.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.42.00",
      "rawHtsCode": "0307.42.00",
      "superior": null,
      "indent": "2",
      "description": "Live, fresh or chilled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.42.0020",
      "rawHtsCode": "0307.42.00.20",
      "superior": null,
      "indent": "4",
      "description": "Loligo",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.42.0040",
      "rawHtsCode": "0307.42.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.42.0060",
      "rawHtsCode": "0307.42.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.43.00",
      "rawHtsCode": "0307.43.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.43.0010",
      "rawHtsCode": "0307.43.00.10",
      "superior": null,
      "indent": "4",
      "description": "Fillets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.43.0022",
      "rawHtsCode": "0307.43.00.22",
      "superior": null,
      "indent": "6",
      "description": "<i>Loligo opalescens</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.43.0024",
      "rawHtsCode": "0307.43.00.24",
      "superior": null,
      "indent": "6",
      "description": "<i>Loligo pealei</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.43.0029",
      "rawHtsCode": "0307.43.00.29",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.43.0050",
      "rawHtsCode": "0307.43.00.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.43.0060",
      "rawHtsCode": "0307.43.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.49.01",
      "rawHtsCode": "0307.49.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.49.0122",
      "rawHtsCode": "0307.49.01.22",
      "superior": null,
      "indent": "5",
      "description": "<i>Loligo opalescens</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.49.0124",
      "rawHtsCode": "0307.49.01.24",
      "superior": null,
      "indent": "5",
      "description": "<i>Loligo pealei</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.49.0129",
      "rawHtsCode": "0307.49.01.29",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.49.0150",
      "rawHtsCode": "0307.49.01.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.49.0160",
      "rawHtsCode": "0307.49.01.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.51.0000",
      "rawHtsCode": "0307.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Live, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.52.0000",
      "rawHtsCode": "0307.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.59.0100",
      "rawHtsCode": "0307.59.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.60.0000",
      "rawHtsCode": "0307.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Snails, other than sea snails",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0307.71.00",
      "rawHtsCode": "0307.71.00",
      "superior": null,
      "indent": "2",
      "description": "Live, fresh or chilled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.71.0050",
      "rawHtsCode": "0307.71.00.50",
      "superior": null,
      "indent": "4",
      "description": "Geoduck",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.71.0070",
      "rawHtsCode": "0307.71.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.71.0090",
      "rawHtsCode": "0307.71.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.72.00",
      "rawHtsCode": "0307.72.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.72.0030",
      "rawHtsCode": "0307.72.00.30",
      "superior": null,
      "indent": "4",
      "description": "Geoduck",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.72.0051",
      "rawHtsCode": "0307.72.00.51",
      "superior": null,
      "indent": "4",
      "description": "Stimsonʼs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.72.0055",
      "rawHtsCode": "0307.72.00.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.72.0060",
      "rawHtsCode": "0307.72.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.79.01",
      "rawHtsCode": "0307.79.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.79.0130",
      "rawHtsCode": "0307.79.01.30",
      "superior": null,
      "indent": "4",
      "description": "Geoduck",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.79.0151",
      "rawHtsCode": "0307.79.01.51",
      "superior": null,
      "indent": "4",
      "description": "Stimsonʼs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.79.0155",
      "rawHtsCode": "0307.79.01.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.79.0160",
      "rawHtsCode": "0307.79.01.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.81.0000",
      "rawHtsCode": "0307.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "Live, fresh or chilled abalone (<i>Haliotis spp.)</i>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.82.0000",
      "rawHtsCode": "0307.82.00.00",
      "superior": null,
      "indent": "2",
      "description": "Live, fresh or chilled stromboid conchs (<i>Strombus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.83.0000",
      "rawHtsCode": "0307.83.00.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen abalone (<i>Haliotis spp.)</i>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.84.0000",
      "rawHtsCode": "0307.84.00.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen stromboid conchs (<i>Strombus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.87.0000",
      "rawHtsCode": "0307.87.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other abalone (<i>Haliotis spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.88.0000",
      "rawHtsCode": "0307.88.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other stromboid conchs (<i>Strombus spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0307.91.03",
      "rawHtsCode": "0307.91.03",
      "superior": null,
      "indent": "2",
      "description": "Live, fresh or chilled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0307.91.0330",
      "rawHtsCode": "0307.91.03.30",
      "superior": null,
      "indent": "3",
      "description": "Conch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.91.0390",
      "rawHtsCode": "0307.91.03.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.92.01",
      "rawHtsCode": "0307.92.01",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0307.92.0130",
      "rawHtsCode": "0307.92.01.30",
      "superior": null,
      "indent": "3",
      "description": "Conch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.92.0190",
      "rawHtsCode": "0307.92.01.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0307.99.0300",
      "rawHtsCode": "0307.99.03.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0308",
      "rawHtsCode": "0308",
      "superior": null,
      "indent": "0",
      "description": "Aquatic invertebrates other than crustaceans and molluscs, live, fresh, chilled, frozen, dried, salted or in brine; smoked aquatic invertebrates other than crustaceans and molluscs, whether or not cooked before or during the smoking process:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0308.11.0000",
      "rawHtsCode": "0308.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Live, fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0308.12.0000",
      "rawHtsCode": "0308.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0308.19.0100",
      "rawHtsCode": "0308.19.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0308.21.00",
      "rawHtsCode": "0308.21.00",
      "superior": null,
      "indent": "2",
      "description": "Live, fresh or chilled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0308.21.0021",
      "rawHtsCode": "0308.21.00.21",
      "superior": null,
      "indent": "3",
      "description": "Roe",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0308.21.0029",
      "rawHtsCode": "0308.21.00.29",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0308.22.0000",
      "rawHtsCode": "0308.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0308.29.0100",
      "rawHtsCode": "0308.29.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0308.30.0000",
      "rawHtsCode": "0308.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Jellyfish (<i>Rhopilema spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0308.90.0100",
      "rawHtsCode": "0308.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0309",
      "rawHtsCode": "0309",
      "superior": null,
      "indent": "0",
      "description": "Flours, meals and pellets of fish, crustaceans, molluscs and other aquatic invertebrates, fit for human consumption:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0309.10",
      "rawHtsCode": "0309.10",
      "superior": null,
      "indent": "1",
      "description": "Of fish:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0309.10.0500",
      "rawHtsCode": "0309.10.05.00",
      "superior": null,
      "indent": "2",
      "description": "In bulk or in immediate containers weighing with their contents over 6.8 kg each",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0309.10.9000",
      "rawHtsCode": "0309.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0309.90",
      "rawHtsCode": "0309.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0309.90.10",
      "rawHtsCode": "0309.90.10",
      "superior": null,
      "indent": "3",
      "description": "Frozen",
      "units": [
        ""
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0309.90.1010",
      "rawHtsCode": "0309.90.10.10",
      "superior": null,
      "indent": "4",
      "description": "Freshwater crawfish",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0309.90.1030",
      "rawHtsCode": "0309.90.10.30",
      "superior": null,
      "indent": "4",
      "description": "Antarctic krill",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0309.90.1061",
      "rawHtsCode": "0309.90.10.61",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0309.90.2000",
      "rawHtsCode": "0309.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Live, fresh, or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0309.90.3000",
      "rawHtsCode": "0309.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0309.90.40",
      "rawHtsCode": "0309.90.40",
      "superior": null,
      "indent": "3",
      "description": "Live, fresh or chilled",
      "units": [
        ""
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0309.90.4030",
      "rawHtsCode": "0309.90.40.30",
      "superior": null,
      "indent": "4",
      "description": "Conch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0309.90.4090",
      "rawHtsCode": "0309.90.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0309.90.50",
      "rawHtsCode": "0309.90.50",
      "superior": null,
      "indent": "3",
      "description": "Frozen",
      "units": [
        ""
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0309.90.5030",
      "rawHtsCode": "0309.90.50.30",
      "superior": null,
      "indent": "4",
      "description": "Conch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0309.90.5090",
      "rawHtsCode": "0309.90.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0309.90.6000",
      "rawHtsCode": "0309.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0309.90.9000",
      "rawHtsCode": "0309.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0401",
      "rawHtsCode": "0401",
      "superior": null,
      "indent": "0",
      "description": "Milk and cream, not concentrated nor containing added sugar or other sweetening matter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0401.10.0000",
      "rawHtsCode": "0401.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of a fat content, by weight, not exceeding 1 percent",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "0.34¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.5¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0401.20",
      "rawHtsCode": "0401.20",
      "superior": null,
      "indent": "1",
      "description": "Of a fat content, by weight, exceeding 1 percent but not exceeding 6 percent:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0401.20.2000",
      "rawHtsCode": "0401.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "For not over 11,356,236 liters entered in any calendar year",
      "units": [
        "liters",
        "kg cmsc"
      ],
      "generalRate": "0.43¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.7¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0401.20.4000",
      "rawHtsCode": "0401.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters",
        "kg cmsc"
      ],
      "generalRate": "1.5¢/liter",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.7¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0401.40",
      "rawHtsCode": "0401.40",
      "superior": null,
      "indent": "1",
      "description": "Of a fat content, by weight, exceeding 6 percent but not exceeding 10 percent:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0401.40.0200",
      "rawHtsCode": "0401.40.02.00",
      "superior": null,
      "indent": "2",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "liters"
      ],
      "generalRate": "3.2¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0401.40.0500",
      "rawHtsCode": "0401.40.05.00",
      "superior": null,
      "indent": "2",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [
        "liters",
        "kg cmsc"
      ],
      "generalRate": "3.2¢/liter",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0401.40.2500",
      "rawHtsCode": "0401.40.25.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters",
        "kg cmsc"
      ],
      "generalRate": "77.2¢/liter",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,P+,PA,PE,SG) See 9822.04.05 (AU) See 9823.01.01-9823.01.07 (S+)",
      "otherRate": "90.8¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.01-9904.04.08. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0401.50",
      "rawHtsCode": "0401.50",
      "superior": null,
      "indent": "1",
      "description": "Of a fat content, by weight, exceeding 10 percent:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0401.50.0200",
      "rawHtsCode": "0401.50.02.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "liters"
      ],
      "generalRate": "3.2¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0401.50.0500",
      "rawHtsCode": "0401.50.05.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [
        "liters",
        "kg cmsc"
      ],
      "generalRate": "3.2¢/liter",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0401.50.2500",
      "rawHtsCode": "0401.50.25.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "liters",
        "kg cmsc"
      ],
      "generalRate": "77.2¢/liter",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,P+,PA,PE,SG) See 9822.04.05 (AU) See 9823.01.01-9823.01.07 (S+)",
      "otherRate": "90.8¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.01-9904.04.08. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0401.50.4200",
      "rawHtsCode": "0401.50.42.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "12.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0401.50.5000",
      "rawHtsCode": "0401.50.50.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 6 to this chapter and entered pursuant to its provisions",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "12.3¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0401.50.7500",
      "rawHtsCode": "0401.50.75.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "$1.646/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,P+,PA,PE,SG) See 9822.04.10 (AU) See 9823.03.01-9823.03.12 (S+) See 9908.04.01 (IL)",
      "otherRate": "$1.936/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.09-9904.04.21. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402",
      "rawHtsCode": "0402",
      "superior": null,
      "indent": "0",
      "description": "Milk and cream, concentrated or containing added sugar or other sweetening matter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0402.10",
      "rawHtsCode": "0402.10",
      "superior": null,
      "indent": "1",
      "description": "In powder, granules or other solid forms, of a fat content, by weight, not exceeding 1.5 percent:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0402.10.0500",
      "rawHtsCode": "0402.10.05.00",
      "superior": null,
      "indent": "2",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.10.1000",
      "rawHtsCode": "0402.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Described in additional U.S. note 7 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "3.3¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.10.5000",
      "rawHtsCode": "0402.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "86.5¢/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.15 (AU) See 9823.02.01-9823.02.04 (S+) See 9908.04.03 (IL)",
      "otherRate": "$1.018/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.22-9904.04.30. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.21",
      "rawHtsCode": "0402.21",
      "superior": null,
      "indent": "2",
      "description": "Not containing added sugar or other sweetening matter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0402.21.0200",
      "rawHtsCode": "0402.21.02.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.21.0500",
      "rawHtsCode": "0402.21.05.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 7 to this chapterand entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "3.3¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.21.2500",
      "rawHtsCode": "0402.21.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "86.5¢/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.15 (AU) See 9823.02.01-9823.02.04 (S+) See 9908.04.03 (IL)",
      "otherRate": "$1.018/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.22-9904.04.30. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.21.2700",
      "rawHtsCode": "0402.21.27.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.21.3000",
      "rawHtsCode": "0402.21.30.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 8 to this chapterand entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "6.8¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.21.5000",
      "rawHtsCode": "0402.21.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.092/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.20 (AU) See 9823.05.01-9823.05.06 (S+)",
      "otherRate": "$1.285/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.31-9904.04.39. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.21.7300",
      "rawHtsCode": "0402.21.73.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "13.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.21.7500",
      "rawHtsCode": "0402.21.75.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 9 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "13.7¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.21.9000",
      "rawHtsCode": "0402.21.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.556/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.10 (AU) See 9823.03.01-9823.03.12 (S+)",
      "otherRate": "$1.831/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.40-9904.04.49. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.29",
      "rawHtsCode": "0402.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0402.29.0500",
      "rawHtsCode": "0402.29.05.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.29.1000",
      "rawHtsCode": "0402.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 10 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.29.5000",
      "rawHtsCode": "0402.29.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.104/kg + 14.9%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.05.01-9823.05.06 (S+) See 9918.04.60, 9918.04.61 (CO)",
      "otherRate": "$1.299/kg + 17.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.91",
      "rawHtsCode": "0402.91",
      "superior": null,
      "indent": "2",
      "description": "Not containing added sugar or other sweetening matter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0402.91.0300",
      "rawHtsCode": "0402.91.03.00",
      "superior": null,
      "indent": "4",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "2.2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.91.0600",
      "rawHtsCode": "0402.91.06.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "5.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.91.1000",
      "rawHtsCode": "0402.91.10.00",
      "superior": null,
      "indent": "4",
      "description": "In airtight containers",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "2.2¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.91.3000",
      "rawHtsCode": "0402.91.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "3.3¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.91.7000",
      "rawHtsCode": "0402.91.70.00",
      "superior": null,
      "indent": "4",
      "description": "In airtight containers",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "31.3¢/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PE,SG) See 9822.04.30 (AU) See 9823.07.01-9823.07.07 (S+) See 9919.04.10, 9919.04.11, 9919.04.13 (PA)",
      "otherRate": "36.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.02-9904.05.19. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.91.9000",
      "rawHtsCode": "0402.91.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "31.3¢/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PE,SG) See 9822.04.30 (AU) See 9823.07.01-9823.07.07 (S+) See 9919.04.10, 9919.04.11, 9919.04.13 (PA)",
      "otherRate": "36.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.02-9904.05.19. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.99",
      "rawHtsCode": "0402.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0402.99.0300",
      "rawHtsCode": "0402.99.03.00",
      "superior": null,
      "indent": "5",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "3.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.99.0600",
      "rawHtsCode": "0402.99.06.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.99.1000",
      "rawHtsCode": "0402.99.10.00",
      "superior": null,
      "indent": "5",
      "description": "In airtight containers",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "3.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.99.3000",
      "rawHtsCode": "0402.99.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "3.3¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.99.4500",
      "rawHtsCode": "0402.99.45.00",
      "superior": null,
      "indent": "5",
      "description": "In airtight containers",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "49.6¢/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PE,SG) See 9822.04.30 (AU) See 9823.07.01-9823.07.07 (S+) See 9919.04.10, 9919.04.12, 99.19.04.14 (PA)",
      "otherRate": "58.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.02-9904.05.19. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.99.5500",
      "rawHtsCode": "0402.99.55.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "49.6¢/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PE,SG) See 9822.04.30 (AU) See 9823.07.01-9823.07.07 (S+) See 9919.04.10, 9919.04.12, 99.19.04.14 (PA)",
      "otherRate": "58.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.02-9904.05.19. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.99.6800",
      "rawHtsCode": "0402.99.68.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.99.7000",
      "rawHtsCode": "0402.99.70.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 10 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0402.99.9000",
      "rawHtsCode": "0402.99.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "46.3¢/kg + 14.9%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.07.01-9823.07.07 (S+) See 9918.04.60, 9918.04.62 (CO)",
      "otherRate": "54.5¢/kg + 17.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403",
      "rawHtsCode": "0403",
      "superior": null,
      "indent": "0",
      "description": "Yogurt; buttermilk, curdled milk and cream, kephir and other fermented or acidified milk and cream, whether or not concentrated or containing added sugar or other sweetening matter or flavored or containing added fruit, nuts or cocoa:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0403.20",
      "rawHtsCode": "0403.20",
      "superior": null,
      "indent": "1",
      "description": "Yogurt:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0403.20.0500",
      "rawHtsCode": "0403.20.05.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions. ",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.20.1000",
      "rawHtsCode": "0403.20.10.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 10 to this chapter and entered pursuant to its provisions ",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.20.5000",
      "rawHtsCode": "0403.20.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.035/kg + 17%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.06.01-9823.06.09 (S+) See 9918.04.60, 9918.04.63 (CO)",
      "otherRate": "$1.217/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.20.9000",
      "rawHtsCode": "0403.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "17%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90",
      "rawHtsCode": "0403.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0403.90.0200",
      "rawHtsCode": "0403.90.02.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "liters"
      ],
      "generalRate": "3.2¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.0400",
      "rawHtsCode": "0403.90.04.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [
        "liters",
        "kg cmsc"
      ],
      "generalRate": "3.2¢/liter",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.1600",
      "rawHtsCode": "0403.90.16.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "liters",
        "kg cmsc"
      ],
      "generalRate": "77.2¢/liter",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.05 (AU) See 9823.01.01-9823.01.07 (S+)",
      "otherRate": "90.8¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.01-9904.04.08. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.2000",
      "rawHtsCode": "0403.90.20.00",
      "superior": null,
      "indent": "4",
      "description": "Buttermilk",
      "units": [
        "liters",
        "kg cmsc"
      ],
      "generalRate": "0.34¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "0.5¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.3700",
      "rawHtsCode": "0403.90.37.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.41",
      "rawHtsCode": "0403.90.41",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 12 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "3.3¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.4110",
      "rawHtsCode": "0403.90.41.10",
      "superior": null,
      "indent": "6",
      "description": "Articles for which an import license is required",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0403.90.4190",
      "rawHtsCode": "0403.90.41.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0403.90.4500",
      "rawHtsCode": "0403.90.45.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "87.6¢/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.20 (AU) See 9823.06.01-9823.06.09 (S+)",
      "otherRate": "$1.03/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.20-9904.05.36. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.4700",
      "rawHtsCode": "0403.90.47.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "13.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.5100",
      "rawHtsCode": "0403.90.51.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 8 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "6.8¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.5500",
      "rawHtsCode": "0403.90.55.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.092/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.20 (AU) See 9823.06.01-9823.06.09 (S+)",
      "otherRate": "$1.285/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.31-9904.04.39. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.5700",
      "rawHtsCode": "0403.90.57.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "13.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.6100",
      "rawHtsCode": "0403.90.61.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 9 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "13.7¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.6500",
      "rawHtsCode": "0403.90.65.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.556/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.10 (AU) See 9823.03.01-9823.03.12 (S+)",
      "otherRate": "$1.831/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.40-9904.04.49. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.7200",
      "rawHtsCode": "0403.90.72.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "12.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.7400",
      "rawHtsCode": "0403.90.74.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 6 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "12.3¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.7800",
      "rawHtsCode": "0403.90.78.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.646/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.10 (AU) See 9823.03.01-9823.03.12 (S+) See 9908.04.01 (IL)",
      "otherRate": "$1.936/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.09-9904.04.21. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.8500",
      "rawHtsCode": "0403.90.85.00",
      "superior": null,
      "indent": "3",
      "description": "Fermented milk other than dried fermented milk or other than dried milk with added lactic ferments",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "17%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.8700",
      "rawHtsCode": "0403.90.87.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.9000",
      "rawHtsCode": "0403.90.90.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 10 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0403.90.9500",
      "rawHtsCode": "0403.90.95.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.034/kg + 17%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,SG) See 9822.04.25 (AU) See 9823.06.01-9823.06.09 (S+) See 9918.04.60, 9918.04.64 (CO)",
      "otherRate": "$1.217/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404",
      "rawHtsCode": "0404",
      "superior": null,
      "indent": "0",
      "description": "Whey, whether or not concentrated or containing added sugar or other sweetening matter; products consisting of natural milk constituents, whether or not containing added sugar or other sweetening matter, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0404.10",
      "rawHtsCode": "0404.10",
      "superior": null,
      "indent": "1",
      "description": "Whey and modified whey, whether or not concentrated or containing added sugar or other sweetening matter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0404.10.0500",
      "rawHtsCode": "0404.10.05.00",
      "superior": null,
      "indent": "3",
      "description": "Whey protein concentrates",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404.10.0800",
      "rawHtsCode": "0404.10.08.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "13%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404.10.1100",
      "rawHtsCode": "0404.10.11.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 10 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "13%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404.10.1500",
      "rawHtsCode": "0404.10.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.035/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.06.01-9823.06.09 (S+) See 9918.04.60, 9918.04.65 (CO)",
      "otherRate": "$1.217/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404.10.2000",
      "rawHtsCode": "0404.10.20.00",
      "superior": null,
      "indent": "3",
      "description": "Fluid",
      "units": [
        "liters",
        "kg cmsc"
      ],
      "generalRate": "0.34¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "0.5¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404.10.4800",
      "rawHtsCode": "0404.10.48.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404.10.50",
      "rawHtsCode": "0404.10.50",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 12 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "3.3¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404.10.5010",
      "rawHtsCode": "0404.10.50.10",
      "superior": null,
      "indent": "5",
      "description": "Articles for which an import license is required",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0404.10.5090",
      "rawHtsCode": "0404.10.50.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0404.10.9000",
      "rawHtsCode": "0404.10.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "87.6¢/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.20 (AU) See 9823.06.01-9823.06.09 (S+)",
      "otherRate": "$1.03/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.20-9904.05.36. ",
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404.90",
      "rawHtsCode": "0404.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0404.90.1000",
      "rawHtsCode": "0404.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Milk protein concentrates",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "0.37¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404.90.2800",
      "rawHtsCode": "0404.90.28.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "14.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404.90.3000",
      "rawHtsCode": "0404.90.30.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 10 to this chapterand entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "14.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404.90.5000",
      "rawHtsCode": "0404.90.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.189/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.06.01-9823.06.09 (S+) See 9918.04.60, 9918.04.66 (CO)",
      "otherRate": "$1.399/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0404.90.7000",
      "rawHtsCode": "0404.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405",
      "rawHtsCode": "0405",
      "superior": null,
      "indent": "0",
      "description": "Butter and other fats and oils derived from milk; dairy spreads:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0405.10",
      "rawHtsCode": "0405.10",
      "superior": null,
      "indent": "1",
      "description": "Butter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0405.10.0500",
      "rawHtsCode": "0405.10.05.00",
      "superior": null,
      "indent": "2",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "12.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "30.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.10.1000",
      "rawHtsCode": "0405.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Described in additional U.S. note 6 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "12.3¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.10.2000",
      "rawHtsCode": "0405.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.541/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.10 (AU) See 9823.03.01-9823.03.12 (S+) See 9908.04.01 (IL)",
      "otherRate": "$1.813/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.09-9904.04.21. ",
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.20",
      "rawHtsCode": "0405.20",
      "superior": null,
      "indent": "1",
      "description": "Dairy spreads:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0405.20.1000",
      "rawHtsCode": "0405.20.10.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "15.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.20.2000",
      "rawHtsCode": "0405.20.20.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 14 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "15.4¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.20.3000",
      "rawHtsCode": "0405.20.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.996/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.10 (AU) See 9823.03.01-9823.03.12 (S+)",
      "otherRate": "$2.348/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.37-9904.05.47. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.20.4000",
      "rawHtsCode": "0405.20.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "13.1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.20.5000",
      "rawHtsCode": "0405.20.50.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.20.6000",
      "rawHtsCode": "0405.20.60.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 10 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.20.7000",
      "rawHtsCode": "0405.20.70.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "70.4¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.03.01-9823.03.12 (S+) See 9918.04.60, 9918.04.67 (CO)",
      "otherRate": "82.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.20.8000",
      "rawHtsCode": "0405.20.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.90",
      "rawHtsCode": "0405.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0405.90.05",
      "rawHtsCode": "0405.90.05",
      "superior": null,
      "indent": "2",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.90.0520",
      "rawHtsCode": "0405.90.05.20",
      "superior": null,
      "indent": "3",
      "description": "Anhydrous milk fat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0405.90.0540",
      "rawHtsCode": "0405.90.05.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0405.90.10",
      "rawHtsCode": "0405.90.10",
      "superior": null,
      "indent": "2",
      "description": "Described in additional U.S. note 14 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.90.1020",
      "rawHtsCode": "0405.90.10.20",
      "superior": null,
      "indent": "3",
      "description": "Anhydrous milk fat",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0405.90.1040",
      "rawHtsCode": "0405.90.10.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0405.90.20",
      "rawHtsCode": "0405.90.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "$1.865/kg + 8.5%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.10 (AU) See 9823.03.01-9823.03.12 (S+)",
      "otherRate": "$2.194/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.37-9904.05.47. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0405.90.2020",
      "rawHtsCode": "0405.90.20.20",
      "superior": null,
      "indent": "3",
      "description": "Anhydrous milk fat",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0405.90.2040",
      "rawHtsCode": "0405.90.20.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0406",
      "rawHtsCode": "0406",
      "superior": null,
      "indent": "0",
      "description": "Cheese and curd:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0406.10",
      "rawHtsCode": "0406.10",
      "superior": null,
      "indent": "1",
      "description": "Fresh (unripened or uncured) cheese, including whey cheese, and curd:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0406.10.0200",
      "rawHtsCode": "0406.10.02.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.0400",
      "rawHtsCode": "0406.10.04.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S.note 16 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.0800",
      "rawHtsCode": "0406.10.08.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.509/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,SG) See 9822.04.35 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.51 (CO) See 9919.04.40, 9919.04.41-9919.04.42 (PA)",
      "otherRate": "$1.775/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.38-9904.06.49. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.1200",
      "rawHtsCode": "0406.10.12.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.1400",
      "rawHtsCode": "0406.10.14.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 17 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.1800",
      "rawHtsCode": "0406.10.18.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.269/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.52 (CO) See 9919.04.50, 9919.04.51, 9919.04.61 (PA)",
      "otherRate": "$2.67/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.48-9904.05.58. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.2400",
      "rawHtsCode": "0406.10.24.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 18 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.2800",
      "rawHtsCode": "0406.10.28.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.227/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.45 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.53 (CO) See 9919.04.50, 9919.04.52, 9919.04.62 (PA)",
      "otherRate": "$1.443/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.59-9904.05.73. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.3400",
      "rawHtsCode": "0406.10.34.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 19 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.3800",
      "rawHtsCode": "0406.10.38.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.055/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.50 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.54 (CO) See 9919.04.50, 9919.04.53, 9919.04.63 (PA)",
      "otherRate": "$1.241/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.74-9904.05.82. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.4400",
      "rawHtsCode": "0406.10.44.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 20 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.4800",
      "rawHtsCode": "0406.10.48.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.803/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.55 (CO) See 9919.04.50, 9919.04.54, 9919.04.64 (PA)",
      "otherRate": "$2.121/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.83-9904.05.94. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.5400",
      "rawHtsCode": "0406.10.54.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 21 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.5800",
      "rawHtsCode": "0406.10.58.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.146/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.56 (CO) See 9919.04.50, 9919.04.55, 9919.04.65 (PA)",
      "otherRate": "$2.525/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.95-9904.06.05. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.6400",
      "rawHtsCode": "0406.10.64.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 22 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.6800",
      "rawHtsCode": "0406.10.68.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.386/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.57 (CO) See 9919.04.50, 9919.04.56, 9919.04.66 (PA)",
      "otherRate": "$1.631/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.19-9904.06.28. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.7400",
      "rawHtsCode": "0406.10.74.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 23 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.7800",
      "rawHtsCode": "0406.10.78.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.128/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.58 (CO) See 9919.04.50, 9919.04.57, 9919.04.67 (PA)",
      "otherRate": "$1.328/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.29-9904.06.37. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.8400",
      "rawHtsCode": "0406.10.84.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 16 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.8800",
      "rawHtsCode": "0406.10.88.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.509/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.35 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.51 (CO) See 9919.04.40, 9919.04.41-9919.04.42 (PA)",
      "otherRate": "$1.775/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.38-9904.06.49. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.10.9500",
      "rawHtsCode": "0406.10.95.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20",
      "rawHtsCode": "0406.20",
      "superior": null,
      "indent": "1",
      "description": "Grated or powdered cheese, of all kinds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0406.20.1000",
      "rawHtsCode": "0406.20.10.00",
      "superior": null,
      "indent": "3",
      "description": "Roquefort cheese",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.1500",
      "rawHtsCode": "0406.20.15.00",
      "superior": null,
      "indent": "3",
      "description": "Stilton cheese described in additional U.S. note 24 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "17%",
      "specialRate": "Free (CO,JO,KR,OM,PA,PE,S)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.2200",
      "rawHtsCode": "0406.20.22.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.2400",
      "rawHtsCode": "0406.20.24.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 17 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.2800",
      "rawHtsCode": "0406.20.28.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.269/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.52 (CO) See 9919.04.50, 9919.04.51, 9919.04.61 (PA)",
      "otherRate": "$2.67/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.48-9904.05.58. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.2900",
      "rawHtsCode": "0406.20.29.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.31",
      "rawHtsCode": "0406.20.31",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S.note 18 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.3110",
      "rawHtsCode": "0406.20.31.10",
      "superior": null,
      "indent": "4",
      "description": "Produced in Canada and not subject to licensing requirements",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0406.20.3190",
      "rawHtsCode": "0406.20.31.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0406.20.3300",
      "rawHtsCode": "0406.20.33.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.227/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.45 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.53 (CO) See 9919.04.50, 9919.04.52, 9919.04.62 (PA)",
      "otherRate": "$1.443/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.59-9904.05.73. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.3400",
      "rawHtsCode": "0406.20.34.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.3600",
      "rawHtsCode": "0406.20.36.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S.note 19 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.3900",
      "rawHtsCode": "0406.20.39.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.055/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.50 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.54 (CO) See 9919.04.50, 9919.04.53, 9919.04.63 (PA)",
      "otherRate": "$1.241/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.74-9904.05.82. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.4300",
      "rawHtsCode": "0406.20.43.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.4400",
      "rawHtsCode": "0406.20.44.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 20 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.4800",
      "rawHtsCode": "0406.20.48.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.803/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.55 (CO) See 9919.04.50, 9919.04.54, 9919.04.64 (PA)",
      "otherRate": "$2.121/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.83-9904.05.94. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.4900",
      "rawHtsCode": "0406.20.49.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.5100",
      "rawHtsCode": "0406.20.51.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 21 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.5300",
      "rawHtsCode": "0406.20.53.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.146/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.56 (CO) See 9919.04.50, 9919.04.55, 9919.04.65 (PA)",
      "otherRate": "$2.525/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.95-9904.06.05. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.5400",
      "rawHtsCode": "0406.20.54.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.5500",
      "rawHtsCode": "0406.20.55.00",
      "superior": null,
      "indent": "3",
      "description": "Cheeses made from sheep's milk",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.5600",
      "rawHtsCode": "0406.20.56.00",
      "superior": null,
      "indent": "3",
      "description": "Other, described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.5700",
      "rawHtsCode": "0406.20.57.00",
      "superior": null,
      "indent": "4",
      "description": "Containing, or processed from, Bryndza, Gjetost, Gammelost, Nokkelost or Roquefort cheeses",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.6100",
      "rawHtsCode": "0406.20.61.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 17 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.6300",
      "rawHtsCode": "0406.20.63.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.269/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.52 (CO) See 9919.04.50, 9919.04.51, 9919.04.61 (PA)",
      "otherRate": "$2.67/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.48-9904.05.58. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.6500",
      "rawHtsCode": "0406.20.65.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 18 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.6700",
      "rawHtsCode": "0406.20.67.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.227/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.45 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.53 (CO) See 9919.04.50, 9919.04.52, 9919.04.62 (PA)",
      "otherRate": "$1.443/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.59-9904.05.73. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.6900",
      "rawHtsCode": "0406.20.69.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S.note 19 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.7100",
      "rawHtsCode": "0406.20.71.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.055/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.50 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.54 (CO) See 9919.04.50, 9919.04.53, 9919.04.63 (PA)",
      "otherRate": "$1.241/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.74-9904.05.82. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.7300",
      "rawHtsCode": "0406.20.73.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 20 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.7500",
      "rawHtsCode": "0406.20.75.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.803/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.55 (CO) See 9919.04.50, 9919.04.54, 9919.04.64 (PA)",
      "otherRate": "$2.121/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.83-9904.05.94. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.7700",
      "rawHtsCode": "0406.20.77.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 21 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.7900",
      "rawHtsCode": "0406.20.79.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.146/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.56 (CO) See 9919.04.50, 9919.04.55, 9919.04.65 (PA)",
      "otherRate": "$2.525/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.95-9904.06.05. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.8100",
      "rawHtsCode": "0406.20.81.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 22 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.8300",
      "rawHtsCode": "0406.20.83.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.386/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.57 (CO) See 9919.04.50, 9919.04.56, 9919.04.66 (PA)",
      "otherRate": "$1.631/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.19-9904.06.28. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.8500",
      "rawHtsCode": "0406.20.85.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 23 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.8700",
      "rawHtsCode": "0406.20.87.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.128/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.58 (CO) See 9919.04.50, 9919.04.57, 9919.04.67 (PA)",
      "otherRate": "$1.328/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.29-9904.06.37. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.8900",
      "rawHtsCode": "0406.20.89.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 16 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.9100",
      "rawHtsCode": "0406.20.91.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.509/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.35 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.51 (CO) See 9919.04.40, 9919.04.41-9919.04.42 (PA)",
      "otherRate": "$1.775/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.38-9904.06.49. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.20.9500",
      "rawHtsCode": "0406.20.95.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30",
      "rawHtsCode": "0406.30",
      "superior": null,
      "indent": "1",
      "description": "Processed (process) cheese, not grated or powdered:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0406.30.0500",
      "rawHtsCode": "0406.30.05.00",
      "superior": null,
      "indent": "3",
      "description": "Stilton cheese described in additional U.S. note 24 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "17%",
      "specialRate": "Free (CO,JO,KR,OM,PA,PE,S)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.1200",
      "rawHtsCode": "0406.30.12.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.1400",
      "rawHtsCode": "0406.30.14.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 17 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.1800",
      "rawHtsCode": "0406.30.18.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.269/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.52 (CO) See 9919.04.50, 9919.04.51, 9919.04.61 (PA)",
      "otherRate": "$2.67/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.48-9904.05.58. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.2200",
      "rawHtsCode": "0406.30.22.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.2400",
      "rawHtsCode": "0406.30.24.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S.note 18 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.2800",
      "rawHtsCode": "0406.30.28.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.227/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.45 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.53 (CO) See 9919.04.50, 9919.04.52, 9919.04.62 (PA)",
      "otherRate": "$1.443/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.59-9904.05.73. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.3200",
      "rawHtsCode": "0406.30.32.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.3400",
      "rawHtsCode": "0406.30.34.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 19 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.3800",
      "rawHtsCode": "0406.30.38.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.055/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.50 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.54 (CO) See 9919.04.50, 9919.04.53, 9919.04.63 (PA)",
      "otherRate": "$1.241/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.74-9904.05.82. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.4200",
      "rawHtsCode": "0406.30.42.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.4400",
      "rawHtsCode": "0406.30.44.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 20 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.4800",
      "rawHtsCode": "0406.30.48.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.803/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.55 (CO) See 9919.04.50, 9919.04.54, 9919.04.64 (PA)",
      "otherRate": "$2.121/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.83-9904.05.94. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.4900",
      "rawHtsCode": "0406.30.49.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.5100",
      "rawHtsCode": "0406.30.51.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 22 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.5300",
      "rawHtsCode": "0406.30.53.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.386/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.57 (CO) See 9919.04.50, 9919.04.56, 9919.04.66 (PA)",
      "otherRate": "$1.631/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.19-9904.06.28. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.5500",
      "rawHtsCode": "0406.30.55.00",
      "superior": null,
      "indent": "3",
      "description": "Cheeses made from sheep's milk",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.5600",
      "rawHtsCode": "0406.30.56.00",
      "superior": null,
      "indent": "3",
      "description": "Other, described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.5700",
      "rawHtsCode": "0406.30.57.00",
      "superior": null,
      "indent": "4",
      "description": "Containing, or processed from, Bryndza, Gjetost, Gammelost, Nokkelost or Roquefort cheeses",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.6100",
      "rawHtsCode": "0406.30.61.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 17 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.6300",
      "rawHtsCode": "0406.30.63.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.269/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.52 (CO) See 9919.04.50, 9919.04.51, 9919.04.61 (PA)",
      "otherRate": "$2.67/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.48-9904.05.58. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.6500",
      "rawHtsCode": "0406.30.65.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 18 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.6700",
      "rawHtsCode": "0406.30.67.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.227/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.45 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.53 (CO) See 9919.04.50, 9919.04.52, 9919.04.62 (PA)",
      "otherRate": "$1.443/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.59-9904.05.73. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.6900",
      "rawHtsCode": "0406.30.69.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 19 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.7100",
      "rawHtsCode": "0406.30.71.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.055/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.50 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.54 (CO) See 9919.04.50, 9919.04.53, 9919.04.63 (PA)",
      "otherRate": "$1.241/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.74-9904.05.82. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.7300",
      "rawHtsCode": "0406.30.73.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 20 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.7500",
      "rawHtsCode": "0406.30.75.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.803/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.55 (CO) See 9919.04.50, 9919.04.54, 9919.04.64 (PA)",
      "otherRate": "$2.121/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.83-9904.05.94. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.7700",
      "rawHtsCode": "0406.30.77.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 21 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.7900",
      "rawHtsCode": "0406.30.79.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.146/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.56 (CO) See 9919.04.50, 9919.04.55, 9919.04.65 (PA)",
      "otherRate": "$2.525/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.95-9904.06.05. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.8100",
      "rawHtsCode": "0406.30.81.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 22 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.8300",
      "rawHtsCode": "0406.30.83.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.386/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.57 (CO) See 9919.04.50, 9919.04.56, 9919.04.66 (PA)",
      "otherRate": "$1.631/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.19-9904.06.28. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.8500",
      "rawHtsCode": "0406.30.85.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 23 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.8700",
      "rawHtsCode": "0406.30.87.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.128/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.58 (CO) See 9919.04.50, 9919.04.57, 9919.04.67 (PA)",
      "otherRate": "$1.328/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.29-9904.06.37. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.8900",
      "rawHtsCode": "0406.30.89.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 16 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.9100",
      "rawHtsCode": "0406.30.91.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.509/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.35 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.51 (CO) See 9919.04.40, 9919.04.41-9919.04.42 (PA)",
      "otherRate": "$1.775/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.38-9904.06.49. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.30.9500",
      "rawHtsCode": "0406.30.95.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.40",
      "rawHtsCode": "0406.40",
      "superior": null,
      "indent": "1",
      "description": "Blue-veined cheese and other cheese containing veins produced by <u>Penicillium roqueforti</u> :",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0406.40.2000",
      "rawHtsCode": "0406.40.20.00",
      "superior": null,
      "indent": "3",
      "description": "In original loaves",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.40.4000",
      "rawHtsCode": "0406.40.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.40.4400",
      "rawHtsCode": "0406.40.44.00",
      "superior": null,
      "indent": "3",
      "description": "In original loaves",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "12.8%",
      "specialRate": "Free (CO,JO,KR,OM,PA,PE,S)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.40.4800",
      "rawHtsCode": "0406.40.48.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "17%",
      "specialRate": "Free (CO,JO,KR,OM,PA,PE,S)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.40.5100",
      "rawHtsCode": "0406.40.51.00",
      "superior": null,
      "indent": "4",
      "description": "In original loaves",
      "units": [
        "kg"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.40.5200",
      "rawHtsCode": "0406.40.52.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.40.5400",
      "rawHtsCode": "0406.40.54.00",
      "superior": null,
      "indent": "4",
      "description": "In original loaves",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.40.5800",
      "rawHtsCode": "0406.40.58.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.40.7000",
      "rawHtsCode": "0406.40.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.269/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.52 (CO) See 9919.04.50, 9919.04.51, 9919.04.61 (PA)",
      "otherRate": "$2.67/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.48-9904.05.58. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90",
      "rawHtsCode": "0406.90",
      "superior": null,
      "indent": "1",
      "description": "Other cheese:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0406.90.0500",
      "rawHtsCode": "0406.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "Bryndza cheese",
      "units": [
        "kg"
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.0600",
      "rawHtsCode": "0406.90.06.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.08",
      "rawHtsCode": "0406.90.08",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 18 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.0810",
      "rawHtsCode": "0406.90.08.10",
      "superior": null,
      "indent": "4",
      "description": "Produced in Canada and not subject to licensing requirements",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0406.90.0890",
      "rawHtsCode": "0406.90.08.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0406.90.1200",
      "rawHtsCode": "0406.90.12.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.227/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.45 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.53 (CO) See 9919.04.50, 9919.04.52, 9919.04.62 (PA)",
      "otherRate": "$1.443/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.59-9904.05.73. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.1400",
      "rawHtsCode": "0406.90.14.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.1600",
      "rawHtsCode": "0406.90.16.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 20 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.1800",
      "rawHtsCode": "0406.90.18.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.803/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.55 (CO) See 9919.04.50, 9919.04.54, 9919.04.64 (PA)",
      "otherRate": "$2.121/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.83-9904.05.94. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.2000",
      "rawHtsCode": "0406.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Made from goat's milk whey or from whey obtained from a mixture of goat's milk and not more than 20 percent by weight of cow's milk",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.2500",
      "rawHtsCode": "0406.90.25.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.2800",
      "rawHtsCode": "0406.90.28.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.3100",
      "rawHtsCode": "0406.90.31.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 21 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "25%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.3200",
      "rawHtsCode": "0406.90.32.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.146/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.56 (CO) See 9919.04.50, 9919.04.55, 9919.04.65 (PA)",
      "otherRate": "$2.525/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.95-9904.06.05. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.3300",
      "rawHtsCode": "0406.90.33.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "21.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.3400",
      "rawHtsCode": "0406.90.34.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "19%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.3600",
      "rawHtsCode": "0406.90.36.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 21 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "19%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.3700",
      "rawHtsCode": "0406.90.37.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.146/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.56 (CO) See 9919.04.50, 9919.04.55, 9919.04.65 (PA)",
      "otherRate": "$2.525/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.95-9904.06.05. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.3800",
      "rawHtsCode": "0406.90.38.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "12.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.3900",
      "rawHtsCode": "0406.90.39.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.4100",
      "rawHtsCode": "0406.90.41.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 21 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.4200",
      "rawHtsCode": "0406.90.42.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.146/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.56 (CO) See 9919.04.50, 9919.04.55, 9919.04.65 (PA)",
      "otherRate": "$2.525/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.95-9904.06.05. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.4300",
      "rawHtsCode": "0406.90.43.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.4400",
      "rawHtsCode": "0406.90.44.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.4600",
      "rawHtsCode": "0406.90.46.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 25 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.4800",
      "rawHtsCode": "0406.90.48.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.877/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.65 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.59 (CO) See 9919.04.50, 9919.04.58, 9919.04.68 (PA)",
      "otherRate": "$2.208/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.06-9904.06.18. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.4900",
      "rawHtsCode": "0406.90.49.00",
      "superior": null,
      "indent": "2",
      "description": "Gammelost and Nokkelost cheeses",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "5.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.5100",
      "rawHtsCode": "0406.90.51.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.5200",
      "rawHtsCode": "0406.90.52.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 19 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.5400",
      "rawHtsCode": "0406.90.54.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.055/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.50 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.54 (CO) See 9919.04.50, 9919.04.53, 9919.04.63 (PA)",
      "otherRate": "$1.241/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.74-9904.05.82. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.5600",
      "rawHtsCode": "0406.90.56.00",
      "superior": null,
      "indent": "4",
      "description": "In original loaves and suitable for grating",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0406.90.5700",
      "rawHtsCode": "0406.90.57.00",
      "superior": null,
      "indent": "4",
      "description": "Pecorino, in original loaves, not suitable for grating",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0406.90.5900",
      "rawHtsCode": "0406.90.59.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.6100",
      "rawHtsCode": "0406.90.61.00",
      "superior": null,
      "indent": "4",
      "description": "Containing Romano, Reggiano, Parmesan, Provolone, Provoletti, Sbrinz or Goya, all the foregoing made from cow's milk",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.6300",
      "rawHtsCode": "0406.90.63.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.6600",
      "rawHtsCode": "0406.90.66.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 21 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.6800",
      "rawHtsCode": "0406.90.68.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.146/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.56 (CO) See 9919.04.50, 9919.04.55, 9919.04.65 (PA)",
      "otherRate": "$2.525/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.95-9904.06.05. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.7200",
      "rawHtsCode": "0406.90.72.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 17 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.7400",
      "rawHtsCode": "0406.90.74.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$2.269/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.52 (CO) See 9919.04.50, 9919.04.51, 9919.04.61 (PA)",
      "otherRate": "$2.67/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.48-9904.05.58. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.7600",
      "rawHtsCode": "0406.90.76.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 18 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.7800",
      "rawHtsCode": "0406.90.78.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.227/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.45 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.53 (CO) See 9919.04.50, 9919.04.52, 9919.04.62 (PA)",
      "otherRate": "$1.443/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.59-9904.05.73. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.8200",
      "rawHtsCode": "0406.90.82.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 19 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.8400",
      "rawHtsCode": "0406.90.84.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.055/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.50 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.54 (CO) See 9919.04.50, 9919.04.53, 9919.04.63 (PA)",
      "otherRate": "$1.241/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.74-9904.05.82. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.8600",
      "rawHtsCode": "0406.90.86.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 20 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.8800",
      "rawHtsCode": "0406.90.88.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.803/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.55 (CO) See 9919.04.50, 9919.04.54, 9919.04.64 (PA)",
      "otherRate": "$2.121/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.05.83-9904.05.94. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.9000",
      "rawHtsCode": "0406.90.90.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 22 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.9200",
      "rawHtsCode": "0406.90.92.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.386/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.40 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.57 (CO) See 9919.04.50, 9919.04.56, 9919.04.66 (PA)",
      "otherRate": "$1.631/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.19-9904.06.28. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.9300",
      "rawHtsCode": "0406.90.93.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 23 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.9400",
      "rawHtsCode": "0406.90.94.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.128/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.58 (CO) See 9919.04.50, 9919.04.57, 9919.04.67 (PA (PA)",
      "otherRate": "$1.328/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.29-9904.06.37. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.9500",
      "rawHtsCode": "0406.90.95.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 16 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.9700",
      "rawHtsCode": "0406.90.97.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.509/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9822.04.35 (AU) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50, 9918.04.51 (CO) See 9919.04.40, 9919.04.41-9919.04.42 (PA)",
      "otherRate": "$1.775/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.38-9904.06.49. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0406.90.9900",
      "rawHtsCode": "0406.90.99.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0407",
      "rawHtsCode": "0407",
      "superior": null,
      "indent": "0",
      "description": "Birds' eggs, in shell, fresh, preserved or cooked:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0407.11.0000",
      "rawHtsCode": "0407.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of fowls of the species <i>Gallus domesticus</i>",
      "units": [
        "doz."
      ],
      "generalRate": "2.8¢/doz.",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10¢/doz.",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0407.19.0000",
      "rawHtsCode": "0407.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "doz."
      ],
      "generalRate": "2.8¢/doz.",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10¢/doz.",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0407.21.00",
      "rawHtsCode": "0407.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of fowls of the species <i>Gallus domesticus</i>",
      "units": [],
      "generalRate": "2.8¢/doz.",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10¢/doz.",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0407.21.0030",
      "rawHtsCode": "0407.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Fresh table eggs (consumer grades)",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0407.21.0090",
      "rawHtsCode": "0407.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0407.29.0000",
      "rawHtsCode": "0407.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "doz."
      ],
      "generalRate": "2.8¢/doz.",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10¢/doz.",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0407.90.0000",
      "rawHtsCode": "0407.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "doz."
      ],
      "generalRate": "2.8¢/doz.",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10¢/doz.",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0408",
      "rawHtsCode": "0408",
      "superior": null,
      "indent": "0",
      "description": "Birds' eggs, not in shell, and egg yolks, fresh, dried, cooked by steaming or by boiling in water, molded, frozen or otherwise preserved, whether or not containing added sugar or other sweetening matter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0408.11.0000",
      "rawHtsCode": "0408.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dried",
      "units": [
        "kg"
      ],
      "generalRate": "47.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "59.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0408.19.0000",
      "rawHtsCode": "0408.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "9.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0408.91.0000",
      "rawHtsCode": "0408.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dried",
      "units": [
        "kg"
      ],
      "generalRate": "47.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "59.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0408.99.0000",
      "rawHtsCode": "0408.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "9.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0409.00.00",
      "rawHtsCode": "0409.00.00",
      "superior": null,
      "indent": "0",
      "description": "Natural honey",
      "units": [],
      "generalRate": "1.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0409.00.0005",
      "rawHtsCode": "0409.00.00.05",
      "superior": null,
      "indent": "1",
      "description": "Certified Organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0409.00.0010",
      "rawHtsCode": "0409.00.00.10",
      "superior": null,
      "indent": "2",
      "description": "Comb honey and honey packaged for retail sale",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0409.00.0035",
      "rawHtsCode": "0409.00.00.35",
      "superior": null,
      "indent": "3",
      "description": "White or lighter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0409.00.0045",
      "rawHtsCode": "0409.00.00.45",
      "superior": null,
      "indent": "3",
      "description": "Extra light amber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0409.00.0056",
      "rawHtsCode": "0409.00.00.56",
      "superior": null,
      "indent": "3",
      "description": "Light amber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0409.00.0065",
      "rawHtsCode": "0409.00.00.65",
      "superior": null,
      "indent": "3",
      "description": "Amber or darker",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0410",
      "rawHtsCode": "0410",
      "superior": null,
      "indent": "0",
      "description": "Insects and other edible products of animal origin, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0410.10.0000",
      "rawHtsCode": "0410.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Insects",
      "units": [
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0410.90.0000",
      "rawHtsCode": "0410.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A,AU, BH,CL,CO,D, E,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0501.00.0000",
      "rawHtsCode": "0501.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Human hair, unworked, whether or not washed or scoured; waste of human hair",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0502",
      "rawHtsCode": "0502",
      "superior": null,
      "indent": "0",
      "description": "Pigs', hogs' or boars' bristles and hair; badger hair and other brushmaking hair; waste of such bristles or hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0502.10.0000",
      "rawHtsCode": "0502.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Pigs', hogs' or boars' bristles and hair and waste thereof",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0502.90.0000",
      "rawHtsCode": "0502.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0504.00.00",
      "rawHtsCode": "0504.00.00",
      "superior": null,
      "indent": "0",
      "description": "Guts, bladders and stomachs of animals (other than fish), whole and pieces thereof, fresh, chilled, frozen, salted, in brine, dried or smoked",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0504.00.0020",
      "rawHtsCode": "0504.00.00.20",
      "superior": null,
      "indent": "2",
      "description": "Hog",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0504.00.0040",
      "rawHtsCode": "0504.00.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0504.00.0060",
      "rawHtsCode": "0504.00.00.60",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0505",
      "rawHtsCode": "0505",
      "superior": null,
      "indent": "0",
      "description": "Skins and other parts of birds, with their feathers or down,<br /> feathers and parts of feathers (whether or not with trimmed<br /> edges) and down, not further worked than cleaned,<br /> disinfected or treated for preservation; powder and waste<br /> of feathers or parts of feathers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0505.10.00",
      "rawHtsCode": "0505.10.00",
      "superior": null,
      "indent": "1",
      "description": "Feathers of a kind used for stuffing; down",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0505.10.0050",
      "rawHtsCode": "0505.10.00.50",
      "superior": null,
      "indent": "3",
      "description": "Feathers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "0505.10.0055",
      "rawHtsCode": "0505.10.00.55",
      "superior": null,
      "indent": "3",
      "description": "Down",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "0505.10.0060",
      "rawHtsCode": "0505.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Feathers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0505.10.0065",
      "rawHtsCode": "0505.10.00.65",
      "superior": null,
      "indent": "3",
      "description": "Down",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0505.90",
      "rawHtsCode": "0505.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0505.90.20",
      "rawHtsCode": "0505.90.20",
      "superior": null,
      "indent": "2",
      "description": "Feather meal and waste",
      "units": [],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0505.90.2020",
      "rawHtsCode": "0505.90.20.20",
      "superior": null,
      "indent": "3",
      "description": "Feather meal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0505.90.2040",
      "rawHtsCode": "0505.90.20.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0505.90.6000",
      "rawHtsCode": "0505.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0506",
      "rawHtsCode": "0506",
      "superior": null,
      "indent": "0",
      "description": "Bones and horn-cores, unworked, defatted, simply prepared (but not cut to shape), treated with acid or degelatinized; powder and waste of these products:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0506.10.0000",
      "rawHtsCode": "0506.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ossein and bones treated with acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0506.90.00",
      "rawHtsCode": "0506.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0506.90.0020",
      "rawHtsCode": "0506.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Bones, crude, steamed or ground",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0506.90.0040",
      "rawHtsCode": "0506.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0507",
      "rawHtsCode": "0507",
      "superior": null,
      "indent": "0",
      "description": "Ivory, tortoise-shell, whalebone and whalebone hair, horns, antlers, hooves, nails, claws and beaks, unworked or simply prepared but not cut to shape; powder and waste of these products:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0507.10.0000",
      "rawHtsCode": "0507.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ivory; ivory powder and waste",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0507.90.00",
      "rawHtsCode": "0507.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0507.90.0010",
      "rawHtsCode": "0507.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Velvet antler",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0507.90.0090",
      "rawHtsCode": "0507.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0508.00.0000",
      "rawHtsCode": "0508.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Coral and similar materials, unworked or simply prepared but not otherwise worked; shells of molluscs, crustaceans or echinoderms and cuttlebone, unworked or simply prepared but not cut to shape, powder and waste thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0510.00",
      "rawHtsCode": "0510.00",
      "superior": null,
      "indent": "0",
      "description": "Ambergris, castoreum, civet and musk; cantharides; bile, whether or not dried; glands and other animal products used in the preparation of pharmaceutical products, fresh, chilled, frozen or otherwise provisionally preserved:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0510.00.2000",
      "rawHtsCode": "0510.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Ambergris, castoreum, civet and musk",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0510.00.40",
      "rawHtsCode": "0510.00.40",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0510.00.4010",
      "rawHtsCode": "0510.00.40.10",
      "superior": null,
      "indent": "2",
      "description": "Pancreas glands",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0510.00.4020",
      "rawHtsCode": "0510.00.40.20",
      "superior": null,
      "indent": "2",
      "description": "Bile and other animal secretions",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0510.00.4040",
      "rawHtsCode": "0510.00.40.40",
      "superior": null,
      "indent": "2",
      "description": "Cantharides; glands (other than pancreas), organs and other animal products used in the preparation of pharmaceutical products",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511",
      "rawHtsCode": "0511",
      "superior": null,
      "indent": "0",
      "description": "Animal products not elsewhere specified or included; dead animals of chapter 1 or 3, unfit for human consumption:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511.10.00",
      "rawHtsCode": "0511.10.00",
      "superior": null,
      "indent": "1",
      "description": "Bovine semen",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0511.10.0010",
      "rawHtsCode": "0511.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Dairy",
      "units": [
        "doses"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511.10.0090",
      "rawHtsCode": "0511.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "doses"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511.91.00",
      "rawHtsCode": "0511.91.00",
      "superior": null,
      "indent": "2",
      "description": "Products of fish or crustaceans, molluscs or other aquatic invertebrates; dead animals of chapter 3",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0511.91.0010",
      "rawHtsCode": "0511.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Fertilized fish eggs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511.91.0090",
      "rawHtsCode": "0511.91.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511.99",
      "rawHtsCode": "0511.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511.99.2000",
      "rawHtsCode": "0511.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Parings and similar waste of raw hides or skins; glue stock not elsewhere specified or included",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0511.99.30",
      "rawHtsCode": "0511.99.30",
      "superior": null,
      "indent": "3",
      "description": "Products chiefly used as food for animals or as ingredients in such food",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0511.99.3030",
      "rawHtsCode": "0511.99.30.30",
      "superior": null,
      "indent": "4",
      "description": "Antarctic krill (\n<u>Euphausia</u> <u>superba</u>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511.99.3060",
      "rawHtsCode": "0511.99.30.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511.99.3300",
      "rawHtsCode": "0511.99.33.00",
      "superior": null,
      "indent": "3",
      "description": "Horsehair and horsehair waste, whether or not put up as a layer with or without supporting material",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0511.99.3600",
      "rawHtsCode": "0511.99.36.00",
      "superior": null,
      "indent": "3",
      "description": "Natural sponges of animal origin",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0511.99.40",
      "rawHtsCode": "0511.99.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "1.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0511.99.4024",
      "rawHtsCode": "0511.99.40.24",
      "superior": null,
      "indent": "5",
      "description": "Dairy cattle",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511.99.4028",
      "rawHtsCode": "0511.99.40.28",
      "superior": null,
      "indent": "5",
      "description": "Other cattle",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511.99.4030",
      "rawHtsCode": "0511.99.40.30",
      "superior": null,
      "indent": "4",
      "description": "Dried blood",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511.99.4040",
      "rawHtsCode": "0511.99.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other animal semen",
      "units": [
        "doses"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0511.99.4070",
      "rawHtsCode": "0511.99.40.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0601",
      "rawHtsCode": "0601",
      "superior": null,
      "indent": "0",
      "description": "Bulbs, tubers, tuberous roots, corms, crowns and rhizomes, dormant, in growth or in flower; chicory plants and roots other than roots of heading 1212:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0601.10",
      "rawHtsCode": "0601.10",
      "superior": null,
      "indent": "1",
      "description": "Bulbs, tubers, tuberous roots, corms, crowns and rhizomes, dormant:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0601.10.1500",
      "rawHtsCode": "0601.10.15.00",
      "superior": null,
      "indent": "2",
      "description": "Tulip bulbs",
      "units": [
        "No."
      ],
      "generalRate": "89.6¢/1000",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$6/1000",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0601.10.3000",
      "rawHtsCode": "0601.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Hyacinth bulbs",
      "units": [
        "No."
      ],
      "generalRate": "38.4¢/1000",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "$4/1000",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0601.10.4500",
      "rawHtsCode": "0601.10.45.00",
      "superior": null,
      "indent": "2",
      "description": "Lily bulbs",
      "units": [
        "No."
      ],
      "generalRate": "55.7¢/1000",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$6/1000",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0601.10.6000",
      "rawHtsCode": "0601.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Narcissus bulbs",
      "units": [
        "No."
      ],
      "generalRate": "$1.34/1000",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$6/1000",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0601.10.7500",
      "rawHtsCode": "0601.10.75.00",
      "superior": null,
      "indent": "2",
      "description": "Crocus corms",
      "units": [
        "No."
      ],
      "generalRate": "19.2¢/1000",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$2/1000",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0601.10.8500",
      "rawHtsCode": "0601.10.85.00",
      "superior": null,
      "indent": "2",
      "description": "Lily of the valley pips",
      "units": [
        "No."
      ],
      "generalRate": "$1.44/1000",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "$6/1000",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0601.10.90",
      "rawHtsCode": "0601.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0601.10.9020",
      "rawHtsCode": "0601.10.90.20",
      "superior": null,
      "indent": "3",
      "description": "Iris bulbs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0601.10.9040",
      "rawHtsCode": "0601.10.90.40",
      "superior": null,
      "indent": "3",
      "description": "Gladiolus corms",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0601.10.9060",
      "rawHtsCode": "0601.10.90.60",
      "superior": null,
      "indent": "3",
      "description": "Begonia (tuberous) tubers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0601.10.9080",
      "rawHtsCode": "0601.10.90.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0601.20",
      "rawHtsCode": "0601.20",
      "superior": null,
      "indent": "1",
      "description": "Bulbs, tubers, tuberous roots, corms, crowns and rhizomes, in growth or in flower; chicory plants and roots:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0601.20.1000",
      "rawHtsCode": "0601.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Hyacinth bulbs, without soil attached",
      "units": [
        "No."
      ],
      "generalRate": "38.4¢/1000",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "$4/1000",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0601.20.9000",
      "rawHtsCode": "0601.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0602",
      "rawHtsCode": "0602",
      "superior": null,
      "indent": "0",
      "description": "Other live plants (including their roots), cuttings and slips; mushroom spawn:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0602.10.0000",
      "rawHtsCode": "0602.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Unrooted cuttings and slips",
      "units": [
        "No."
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0602.20.0000",
      "rawHtsCode": "0602.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Trees, shrubs and bushes, grafted or not, of kinds which bear edible fruit or nuts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0602.30.0000",
      "rawHtsCode": "0602.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Rhododendrons and azaleas, grafted or not",
      "units": [
        "No."
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0602.40.0000",
      "rawHtsCode": "0602.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Roses, grafted or not",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4¢ each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0602.90",
      "rawHtsCode": "0602.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0602.90.2000",
      "rawHtsCode": "0602.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Orchid plants",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0602.90.30",
      "rawHtsCode": "0602.90.30",
      "superior": null,
      "indent": "4",
      "description": "With soil attached to roots",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0602.90.3010",
      "rawHtsCode": "0602.90.30.10",
      "superior": null,
      "indent": "5",
      "description": "Chrysanthemums",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0602.90.3090",
      "rawHtsCode": "0602.90.30.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0602.90.4000",
      "rawHtsCode": "0602.90.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0602.90.5000",
      "rawHtsCode": "0602.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Mushroom spawn",
      "units": [
        "kg"
      ],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0602.90.60",
      "rawHtsCode": "0602.90.60",
      "superior": null,
      "indent": "4",
      "description": "With soil attached to roots",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0602.90.6010",
      "rawHtsCode": "0602.90.60.10",
      "superior": null,
      "indent": "5",
      "description": "Trees and shrubs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0602.90.6020",
      "rawHtsCode": "0602.90.60.20",
      "superior": null,
      "indent": "5",
      "description": "Poinsettias",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0602.90.6090",
      "rawHtsCode": "0602.90.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0602.90.90",
      "rawHtsCode": "0602.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0602.90.9010",
      "rawHtsCode": "0602.90.90.10",
      "superior": null,
      "indent": "5",
      "description": "Trees and shrubs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0602.90.9090",
      "rawHtsCode": "0602.90.90.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0603",
      "rawHtsCode": "0603",
      "superior": null,
      "indent": "0",
      "description": "Cut flowers and flower buds of a kind suitable for bouquets or for ornamental purposes, fresh, dried, dyed, bleached, impregnated or otherwise prepared:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0603.11.00",
      "rawHtsCode": "0603.11.00",
      "superior": null,
      "indent": "2",
      "description": "Roses",
      "units": [],
      "generalRate": "6.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0603.11.0030",
      "rawHtsCode": "0603.11.00.30",
      "superior": null,
      "indent": "3",
      "description": "Spray",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems."
      ],
      "flags": []
    },
    {
      "htsCode": "0603.11.0050",
      "rawHtsCode": "0603.11.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.12",
      "rawHtsCode": "0603.12",
      "superior": null,
      "indent": "2",
      "description": "Carnations:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0603.12.3000",
      "rawHtsCode": "0603.12.30.00",
      "superior": null,
      "indent": "3",
      "description": "Miniature (spray) carnations",
      "units": [
        "No."
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0603.12.7000",
      "rawHtsCode": "0603.12.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.2% (JP)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0603.13.00",
      "rawHtsCode": "0603.13.00",
      "superior": null,
      "indent": "2",
      "description": "Orchids",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.2% (JP)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0603.13.0050",
      "rawHtsCode": "0603.13.00.50",
      "superior": null,
      "indent": "3",
      "description": "Dendrobium",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems."
      ],
      "flags": []
    },
    {
      "htsCode": "0603.13.0060",
      "rawHtsCode": "0603.13.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems."
      ],
      "flags": []
    },
    {
      "htsCode": "0603.14.00",
      "rawHtsCode": "0603.14.00",
      "superior": null,
      "indent": "2",
      "description": "Chrysanthemums",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.2% (JP)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0603.14.0010",
      "rawHtsCode": "0603.14.00.10",
      "superior": null,
      "indent": "4",
      "description": "Pom Pom",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems."
      ],
      "flags": []
    },
    {
      "htsCode": "0603.14.0020",
      "rawHtsCode": "0603.14.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems."
      ],
      "flags": []
    },
    {
      "htsCode": "0603.15.0000",
      "rawHtsCode": "0603.15.00.00",
      "superior": null,
      "indent": "2",
      "description": "Lilies (<i>Lillium spp.</i>)",
      "units": [
        "No."
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.2% (JP)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0603.19.01",
      "rawHtsCode": "0603.19.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.2% (JP)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0603.19.0105",
      "rawHtsCode": "0603.19.01.05",
      "superior": null,
      "indent": "3",
      "description": "Anthuriums",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems."
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0107",
      "rawHtsCode": "0603.19.01.07",
      "superior": null,
      "indent": "3",
      "description": "Alstroemeria",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0109",
      "rawHtsCode": "0603.19.01.09",
      "superior": null,
      "indent": "3",
      "description": "Aster",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0111",
      "rawHtsCode": "0603.19.01.11",
      "superior": null,
      "indent": "3",
      "description": "Bells of Ireland",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0113",
      "rawHtsCode": "0603.19.01.13",
      "superior": null,
      "indent": "3",
      "description": "Bird of Paradise",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0114",
      "rawHtsCode": "0603.19.01.14",
      "superior": null,
      "indent": "3",
      "description": "Calla lilies",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0115",
      "rawHtsCode": "0603.19.01.15",
      "superior": null,
      "indent": "3",
      "description": "Daffodils",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0116",
      "rawHtsCode": "0603.19.01.16",
      "superior": null,
      "indent": "3",
      "description": "Delphinium",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0117",
      "rawHtsCode": "0603.19.01.17",
      "superior": null,
      "indent": "3",
      "description": "Freesia",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0118",
      "rawHtsCode": "0603.19.01.18",
      "superior": null,
      "indent": "3",
      "description": "Gerbera",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0119",
      "rawHtsCode": "0603.19.01.19",
      "superior": null,
      "indent": "3",
      "description": "Gladiolus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0120",
      "rawHtsCode": "0603.19.01.20",
      "superior": null,
      "indent": "3",
      "description": "Gypsophila",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems."
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0125",
      "rawHtsCode": "0603.19.01.25",
      "superior": null,
      "indent": "3",
      "description": "Hydrangea",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0127",
      "rawHtsCode": "0603.19.01.27",
      "superior": null,
      "indent": "3",
      "description": "Hypericum",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0129",
      "rawHtsCode": "0603.19.01.29",
      "superior": null,
      "indent": "3",
      "description": "Lisianthus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0131",
      "rawHtsCode": "0603.19.01.31",
      "superior": null,
      "indent": "3",
      "description": "Peony",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0135",
      "rawHtsCode": "0603.19.01.35",
      "superior": null,
      "indent": "3",
      "description": "Ranunculus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0137",
      "rawHtsCode": "0603.19.01.37",
      "superior": null,
      "indent": "3",
      "description": "Scabiosa",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0140",
      "rawHtsCode": "0603.19.01.40",
      "superior": null,
      "indent": "3",
      "description": "Snapdragons",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems."
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0141",
      "rawHtsCode": "0603.19.01.41",
      "superior": null,
      "indent": "3",
      "description": "Statice",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0142",
      "rawHtsCode": "0603.19.01.42",
      "superior": null,
      "indent": "3",
      "description": "Stock",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0143",
      "rawHtsCode": "0603.19.01.43",
      "superior": null,
      "indent": "3",
      "description": "Sunflowers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0145",
      "rawHtsCode": "0603.19.01.45",
      "superior": null,
      "indent": "3",
      "description": "Tulips",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0155",
      "rawHtsCode": "0603.19.01.55",
      "superior": null,
      "indent": "3",
      "description": "Campanula",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.19.0197",
      "rawHtsCode": "0603.19.01.97",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report the number of stems. "
      ],
      "flags": []
    },
    {
      "htsCode": "0603.90.0000",
      "rawHtsCode": "0603.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0604",
      "rawHtsCode": "0604",
      "superior": null,
      "indent": "0",
      "description": "Foliage, branches and other parts of plants, without flowers or flower buds, and grasses, mosses and lichens, being goods of a kind suitable for bouquets or for ornamental purposes, fresh, dried, dyed, bleached, impregnated or otherwise prepared:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.00",
      "rawHtsCode": "0604.20.00",
      "superior": null,
      "indent": "1",
      "description": "Fresh",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0604.20.0005",
      "rawHtsCode": "0604.20.00.05",
      "superior": null,
      "indent": "2",
      "description": "Aralia",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0011",
      "rawHtsCode": "0604.20.00.11",
      "superior": null,
      "indent": "2",
      "description": "Aspidistra",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0015",
      "rawHtsCode": "0604.20.00.15",
      "superior": null,
      "indent": "2",
      "description": "Eucalyptus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0020",
      "rawHtsCode": "0604.20.00.20",
      "superior": null,
      "indent": "3",
      "description": "Douglas fir",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0040",
      "rawHtsCode": "0604.20.00.40",
      "superior": null,
      "indent": "3",
      "description": "Fir except Douglas fir",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0060",
      "rawHtsCode": "0604.20.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0065",
      "rawHtsCode": "0604.20.00.65",
      "superior": null,
      "indent": "3",
      "description": "Leather leaf",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0070",
      "rawHtsCode": "0604.20.00.70",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0072",
      "rawHtsCode": "0604.20.00.72",
      "superior": null,
      "indent": "2",
      "description": "Mosses and lichens",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0074",
      "rawHtsCode": "0604.20.00.74",
      "superior": null,
      "indent": "3",
      "description": "Chamadorea",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0078",
      "rawHtsCode": "0604.20.00.78",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0082",
      "rawHtsCode": "0604.20.00.82",
      "superior": null,
      "indent": "2",
      "description": "Pittosporum",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0084",
      "rawHtsCode": "0604.20.00.84",
      "superior": null,
      "indent": "2",
      "description": "Ruscus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.20.0086",
      "rawHtsCode": "0604.20.00.86",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.90",
      "rawHtsCode": "0604.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0604.90.1000",
      "rawHtsCode": "0604.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Mosses and lichens",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0604.90.3000",
      "rawHtsCode": "0604.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Dried or bleached",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0604.90.6000",
      "rawHtsCode": "0604.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0701",
      "rawHtsCode": "0701",
      "superior": null,
      "indent": "0",
      "description": "Potatoes, fresh or chilled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.10.00",
      "rawHtsCode": "0701.10.00",
      "superior": null,
      "indent": "1",
      "description": "Seed",
      "units": [],
      "generalRate": "0.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0701.10.0020",
      "rawHtsCode": "0701.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "In immediate containers of not over 45 kg net weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.10.0040",
      "rawHtsCode": "0701.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90",
      "rawHtsCode": "0701.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90.10",
      "rawHtsCode": "0701.90.10",
      "superior": null,
      "indent": "2",
      "description": "Yellow (Solano) potatoes",
      "units": [
        ""
      ],
      "generalRate": "0.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0701.90.1010",
      "rawHtsCode": "0701.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90.1060",
      "rawHtsCode": "0701.90.10.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90.50",
      "rawHtsCode": "0701.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "0.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "1.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0701.90.5005",
      "rawHtsCode": "0701.90.50.05",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90.5017",
      "rawHtsCode": "0701.90.50.17",
      "superior": null,
      "indent": "4",
      "description": "Russet or netted gem varieties",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90.5021",
      "rawHtsCode": "0701.90.50.21",
      "superior": null,
      "indent": "4",
      "description": "Red skin varieties",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90.5037",
      "rawHtsCode": "0701.90.50.37",
      "superior": null,
      "indent": "4",
      "description": "White varieties",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90.5041",
      "rawHtsCode": "0701.90.50.41",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90.5043",
      "rawHtsCode": "0701.90.50.43",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90.5046",
      "rawHtsCode": "0701.90.50.46",
      "superior": null,
      "indent": "4",
      "description": "Russet or netted gem varieties",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90.5056",
      "rawHtsCode": "0701.90.50.56",
      "superior": null,
      "indent": "4",
      "description": "Red skin varieties",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90.5066",
      "rawHtsCode": "0701.90.50.66",
      "superior": null,
      "indent": "4",
      "description": "White varieties",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0701.90.5076",
      "rawHtsCode": "0701.90.50.76",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00",
      "rawHtsCode": "0702.00",
      "superior": null,
      "indent": "0",
      "description": "Tomatoes, fresh or chilled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.20",
      "rawHtsCode": "0702.00.20",
      "superior": null,
      "indent": "1",
      "description": "If entered during the period from March 1 to July 14, inclusive, or the period from September 1 to November 14, inclusive, in any year",
      "units": [],
      "generalRate": "3.9¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0702.00.2002",
      "rawHtsCode": "0702.00.20.02",
      "superior": null,
      "indent": "4",
      "description": "Grape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2004",
      "rawHtsCode": "0702.00.20.04",
      "superior": null,
      "indent": "4",
      "description": "Roma (plum type)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2006",
      "rawHtsCode": "0702.00.20.06",
      "superior": null,
      "indent": "4",
      "description": "Round, of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2008",
      "rawHtsCode": "0702.00.20.08",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2019",
      "rawHtsCode": "0702.00.20.19",
      "superior": null,
      "indent": "4",
      "description": "Cherry",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2026",
      "rawHtsCode": "0702.00.20.26",
      "superior": null,
      "indent": "4",
      "description": "Grape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2032",
      "rawHtsCode": "0702.00.20.32",
      "superior": null,
      "indent": "4",
      "description": "Roma (plum type)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2036",
      "rawHtsCode": "0702.00.20.36",
      "superior": null,
      "indent": "4",
      "description": "Round, of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2042",
      "rawHtsCode": "0702.00.20.42",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2043",
      "rawHtsCode": "0702.00.20.43",
      "superior": null,
      "indent": "4",
      "description": "Grape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2044",
      "rawHtsCode": "0702.00.20.44",
      "superior": null,
      "indent": "4",
      "description": "Roma (plum type)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2048",
      "rawHtsCode": "0702.00.20.48",
      "superior": null,
      "indent": "4",
      "description": "Round, of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2050",
      "rawHtsCode": "0702.00.20.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2052",
      "rawHtsCode": "0702.00.20.52",
      "superior": null,
      "indent": "4",
      "description": "Cherry",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2062",
      "rawHtsCode": "0702.00.20.62",
      "superior": null,
      "indent": "4",
      "description": "Grape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2066",
      "rawHtsCode": "0702.00.20.66",
      "superior": null,
      "indent": "4",
      "description": "Roma (plum type)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2081",
      "rawHtsCode": "0702.00.20.81",
      "superior": null,
      "indent": "4",
      "description": "Round, of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.2092",
      "rawHtsCode": "0702.00.20.92",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.40",
      "rawHtsCode": "0702.00.40",
      "superior": null,
      "indent": "1",
      "description": "If entered during the period from July 15 to August 31, inclusive, in any year",
      "units": [],
      "generalRate": "2.8¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0702.00.4002",
      "rawHtsCode": "0702.00.40.02",
      "superior": null,
      "indent": "4",
      "description": "Grape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4004",
      "rawHtsCode": "0702.00.40.04",
      "superior": null,
      "indent": "4",
      "description": "Roma (plum type)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4006",
      "rawHtsCode": "0702.00.40.06",
      "superior": null,
      "indent": "4",
      "description": "Round, of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4008",
      "rawHtsCode": "0702.00.40.08",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4019",
      "rawHtsCode": "0702.00.40.19",
      "superior": null,
      "indent": "4",
      "description": "Cherry",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4021",
      "rawHtsCode": "0702.00.40.21",
      "superior": null,
      "indent": "4",
      "description": "Grape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4023",
      "rawHtsCode": "0702.00.40.23",
      "superior": null,
      "indent": "4",
      "description": "Roma (plum type)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4027",
      "rawHtsCode": "0702.00.40.27",
      "superior": null,
      "indent": "4",
      "description": "Round, of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4032",
      "rawHtsCode": "0702.00.40.32",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4037",
      "rawHtsCode": "0702.00.40.37",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4041",
      "rawHtsCode": "0702.00.40.41",
      "superior": null,
      "indent": "4",
      "description": "Cherry",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4047",
      "rawHtsCode": "0702.00.40.47",
      "superior": null,
      "indent": "4",
      "description": "Grape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4066",
      "rawHtsCode": "0702.00.40.66",
      "superior": null,
      "indent": "4",
      "description": "Roma (plum type)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4081",
      "rawHtsCode": "0702.00.40.81",
      "superior": null,
      "indent": "4",
      "description": "Round, of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.4092",
      "rawHtsCode": "0702.00.40.92",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.60",
      "rawHtsCode": "0702.00.60",
      "superior": null,
      "indent": "1",
      "description": "If entered during the period from November 15, in any year, to the last day of the following February, inclusive",
      "units": [],
      "generalRate": "2.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0702.00.6002",
      "rawHtsCode": "0702.00.60.02",
      "superior": null,
      "indent": "4",
      "description": "Grape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6004",
      "rawHtsCode": "0702.00.60.04",
      "superior": null,
      "indent": "4",
      "description": "Roma (plum type)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6006",
      "rawHtsCode": "0702.00.60.06",
      "superior": null,
      "indent": "4",
      "description": "Round, of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6008",
      "rawHtsCode": "0702.00.60.08",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6019",
      "rawHtsCode": "0702.00.60.19",
      "superior": null,
      "indent": "4",
      "description": "Cherry",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6021",
      "rawHtsCode": "0702.00.60.21",
      "superior": null,
      "indent": "4",
      "description": "Grape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6023",
      "rawHtsCode": "0702.00.60.23",
      "superior": null,
      "indent": "4",
      "description": "Roma (plum type)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6027",
      "rawHtsCode": "0702.00.60.27",
      "superior": null,
      "indent": "4",
      "description": "Round, of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6032",
      "rawHtsCode": "0702.00.60.32",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6033",
      "rawHtsCode": "0702.00.60.33",
      "superior": null,
      "indent": "4",
      "description": "Grape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6034",
      "rawHtsCode": "0702.00.60.34",
      "superior": null,
      "indent": "4",
      "description": "Roma (plum type)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6037",
      "rawHtsCode": "0702.00.60.37",
      "superior": null,
      "indent": "4",
      "description": "Round, of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6038",
      "rawHtsCode": "0702.00.60.38",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6039",
      "rawHtsCode": "0702.00.60.39",
      "superior": null,
      "indent": "4",
      "description": "Cherry",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6046",
      "rawHtsCode": "0702.00.60.46",
      "superior": null,
      "indent": "4",
      "description": "Grape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6066",
      "rawHtsCode": "0702.00.60.66",
      "superior": null,
      "indent": "4",
      "description": "Roma (plum type)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6081",
      "rawHtsCode": "0702.00.60.81",
      "superior": null,
      "indent": "4",
      "description": "Round, of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0702.00.6092",
      "rawHtsCode": "0702.00.60.92",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703",
      "rawHtsCode": "0703",
      "superior": null,
      "indent": "0",
      "description": "Onions, shallots, garlic, leeks and other alliaceous vegetables, fresh or chilled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.10",
      "rawHtsCode": "0703.10",
      "superior": null,
      "indent": "1",
      "description": "Onions and shallots:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.10.2000",
      "rawHtsCode": "0703.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Onion sets",
      "units": [
        "kg"
      ],
      "generalRate": "0.83¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0703.10.3000",
      "rawHtsCode": "0703.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Pearl onions not over 16 mm in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "0.96¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0703.10.40",
      "rawHtsCode": "0703.10.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.1¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0703.10.4025",
      "rawHtsCode": "0703.10.40.25",
      "superior": null,
      "indent": "5",
      "description": "Onions",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.10.4045",
      "rawHtsCode": "0703.10.40.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.10.4055",
      "rawHtsCode": "0703.10.40.55",
      "superior": null,
      "indent": "6",
      "description": "Red varieties",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.10.4060",
      "rawHtsCode": "0703.10.40.60",
      "superior": null,
      "indent": "6",
      "description": "White varieties",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.10.4064",
      "rawHtsCode": "0703.10.40.64",
      "superior": null,
      "indent": "6",
      "description": "Yellow varieties, not marked sweet",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.10.4066",
      "rawHtsCode": "0703.10.40.66",
      "superior": null,
      "indent": "6",
      "description": "Yellow varieties, marked sweet",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.10.4068",
      "rawHtsCode": "0703.10.40.68",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.10.4070",
      "rawHtsCode": "0703.10.40.70",
      "superior": null,
      "indent": "5",
      "description": "Shallots",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.10.4075",
      "rawHtsCode": "0703.10.40.75",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.20.00",
      "rawHtsCode": "0703.20.00",
      "superior": null,
      "indent": "1",
      "description": "Garlic",
      "units": [],
      "generalRate": "0.43¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0703.20.0005",
      "rawHtsCode": "0703.20.00.05",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.20.0015",
      "rawHtsCode": "0703.20.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.20.0020",
      "rawHtsCode": "0703.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Fresh whole peeled cloves",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.20.0090",
      "rawHtsCode": "0703.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.90.00",
      "rawHtsCode": "0703.90.00",
      "superior": null,
      "indent": "1",
      "description": "Leeks and other alliaceous vegetables",
      "units": [],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0703.90.0020",
      "rawHtsCode": "0703.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Green onions of a species other than <i>Allium cepa</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0703.90.0040",
      "rawHtsCode": "0703.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0704",
      "rawHtsCode": "0704",
      "superior": null,
      "indent": "0",
      "description": "Cabbages, cauliflower, kohlrabi, kale and similar edible brassicas, fresh or chilled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0704.10",
      "rawHtsCode": "0704.10",
      "superior": null,
      "indent": "1",
      "description": "Cauliflowers and broccoli (<i>Brassica oleracea</i> var. <i>botrytis</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0704.10.2000",
      "rawHtsCode": "0704.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "If entered during the period from June 5 to October 15, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0704.10.4000",
      "rawHtsCode": "0704.10.40.00",
      "superior": null,
      "indent": "3",
      "description": "Not reduced in size",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0704.10.6000",
      "rawHtsCode": "0704.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Cut, sliced or otherwise reduced in size",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0704.20.0000",
      "rawHtsCode": "0704.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Brussels sprouts",
      "units": [
        "kg"
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0704.90",
      "rawHtsCode": "0704.90",
      "superior": null,
      "indent": "1",
      "description": "Other (including sprouting broccoli (<i>Brassica oleracea</i> var. <i>italica</i>)):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0704.90.2000",
      "rawHtsCode": "0704.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Cabbage",
      "units": [
        "kg"
      ],
      "generalRate": "0.54¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0704.90.40",
      "rawHtsCode": "0704.90.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0704.90.4015",
      "rawHtsCode": "0704.90.40.15",
      "superior": null,
      "indent": "3",
      "description": "Bok choy",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0704.90.4022",
      "rawHtsCode": "0704.90.40.22",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0704.90.4024",
      "rawHtsCode": "0704.90.40.24",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0704.90.4028",
      "rawHtsCode": "0704.90.40.28",
      "superior": null,
      "indent": "3",
      "description": "Collards",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0704.90.4035",
      "rawHtsCode": "0704.90.40.35",
      "superior": null,
      "indent": "3",
      "description": "Kale",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0704.90.4045",
      "rawHtsCode": "0704.90.40.45",
      "superior": null,
      "indent": "3",
      "description": "Napa cabbage",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0704.90.4055",
      "rawHtsCode": "0704.90.40.55",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0705",
      "rawHtsCode": "0705",
      "superior": null,
      "indent": "0",
      "description": "Lettuce (<i>Lactuca sativa</i>) and chicory (<i>Cichorium</i> spp.), fresh or chilled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0705.11",
      "rawHtsCode": "0705.11",
      "superior": null,
      "indent": "2",
      "description": "Head lettuce (cabbage lettuce):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0705.11.2000",
      "rawHtsCode": "0705.11.20.00",
      "superior": null,
      "indent": "3",
      "description": "If entered in the period from June 1 to October 31, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "0.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0705.11.4000",
      "rawHtsCode": "0705.11.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0705.19",
      "rawHtsCode": "0705.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0705.19.20",
      "rawHtsCode": "0705.19.20",
      "superior": null,
      "indent": "3",
      "description": "If entered in the period from June 1 to October 31, inclusive, in any year",
      "units": [],
      "generalRate": "0.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0705.19.2020",
      "rawHtsCode": "0705.19.20.20",
      "superior": null,
      "indent": "4",
      "description": "Romaine lettuce",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0705.19.2040",
      "rawHtsCode": "0705.19.20.40",
      "superior": null,
      "indent": "4",
      "description": "Butterhead lettuce",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0705.19.2060",
      "rawHtsCode": "0705.19.20.60",
      "superior": null,
      "indent": "4",
      "description": "Red and green leaf lettuce",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0705.19.2080",
      "rawHtsCode": "0705.19.20.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0705.19.40",
      "rawHtsCode": "0705.19.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0705.19.4020",
      "rawHtsCode": "0705.19.40.20",
      "superior": null,
      "indent": "4",
      "description": "Romaine lettuce",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0705.19.4040",
      "rawHtsCode": "0705.19.40.40",
      "superior": null,
      "indent": "4",
      "description": "Butterhead lettuce",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0705.19.4060",
      "rawHtsCode": "0705.19.40.60",
      "superior": null,
      "indent": "4",
      "description": "Red and green leaf lettuce",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0705.19.4080",
      "rawHtsCode": "0705.19.40.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0705.21.0000",
      "rawHtsCode": "0705.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Witloof chicory (<i>Cichorium intybus</i> var. <i>foliosum</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "0.15¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0705.29.0000",
      "rawHtsCode": "0705.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.15¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0706",
      "rawHtsCode": "0706",
      "superior": null,
      "indent": "0",
      "description": "Carrots, turnips, salad beets (salad beetroot), salsify, celeriac, radishes and similar edible roots, fresh or chilled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0706.10",
      "rawHtsCode": "0706.10",
      "superior": null,
      "indent": "1",
      "description": "Carrots and turnips:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0706.10.0500",
      "rawHtsCode": "0706.10.05.00",
      "superior": null,
      "indent": "3",
      "description": "Reduced in size",
      "units": [
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0706.10.1000",
      "rawHtsCode": "0706.10.10.00",
      "superior": null,
      "indent": "4",
      "description": "Under 10 cm in length",
      "units": [
        "kg"
      ],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0706.10.2000",
      "rawHtsCode": "0706.10.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "8.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0706.10.4000",
      "rawHtsCode": "0706.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Turnips",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0706.90",
      "rawHtsCode": "0706.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0706.90.2000",
      "rawHtsCode": "0706.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Radishes",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0706.90.3000",
      "rawHtsCode": "0706.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Beets and horseradish",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0706.90.40",
      "rawHtsCode": "0706.90.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0706.90.4020",
      "rawHtsCode": "0706.90.40.20",
      "superior": null,
      "indent": "3",
      "description": "Celeriac",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0706.90.4040",
      "rawHtsCode": "0706.90.40.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00",
      "rawHtsCode": "0707.00",
      "superior": null,
      "indent": "0",
      "description": "Cucumbers, including gherkins, fresh or chilled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.20",
      "rawHtsCode": "0707.00.20",
      "superior": null,
      "indent": "1",
      "description": "If entered during the period from December 1 in any year to the last day of the following February, inclusive",
      "units": [],
      "generalRate": "4.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0707.00.2015",
      "rawHtsCode": "0707.00.20.15",
      "superior": null,
      "indent": "2",
      "description": "Gherkins",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.2037",
      "rawHtsCode": "0707.00.20.37",
      "superior": null,
      "indent": "5",
      "description": "Persian",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.2040",
      "rawHtsCode": "0707.00.20.40",
      "superior": null,
      "indent": "5",
      "description": "Long seedless",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.2045",
      "rawHtsCode": "0707.00.20.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.2050",
      "rawHtsCode": "0707.00.20.50",
      "superior": null,
      "indent": "5",
      "description": "Persian",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.2060",
      "rawHtsCode": "0707.00.20.60",
      "superior": null,
      "indent": "5",
      "description": "Long seedless",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.2070",
      "rawHtsCode": "0707.00.20.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.2080",
      "rawHtsCode": "0707.00.20.80",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.2090",
      "rawHtsCode": "0707.00.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.40",
      "rawHtsCode": "0707.00.40",
      "superior": null,
      "indent": "1",
      "description": "If entered during the period from March 1 to April 30, inclusive, in any year",
      "units": [],
      "generalRate": "5.6¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0707.00.4015",
      "rawHtsCode": "0707.00.40.15",
      "superior": null,
      "indent": "2",
      "description": "Gherkins",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.4037",
      "rawHtsCode": "0707.00.40.37",
      "superior": null,
      "indent": "5",
      "description": "Persian",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.4040",
      "rawHtsCode": "0707.00.40.40",
      "superior": null,
      "indent": "5",
      "description": "Long seedless",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.4045",
      "rawHtsCode": "0707.00.40.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.4050",
      "rawHtsCode": "0707.00.40.50",
      "superior": null,
      "indent": "5",
      "description": "Persian",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.4060",
      "rawHtsCode": "0707.00.40.60",
      "superior": null,
      "indent": "5",
      "description": "Long seedless",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.4070",
      "rawHtsCode": "0707.00.40.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.4080",
      "rawHtsCode": "0707.00.40.80",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.4090",
      "rawHtsCode": "0707.00.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.50",
      "rawHtsCode": "0707.00.50",
      "superior": null,
      "indent": "1",
      "description": "If entered during the period from May 1 to June 30, inclusive, or the period from September 1 to November 30, inclusive, in any year",
      "units": [],
      "generalRate": "5.6¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0707.00.5005",
      "rawHtsCode": "0707.00.50.05",
      "superior": null,
      "indent": "2",
      "description": "Gherkins",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.5022",
      "rawHtsCode": "0707.00.50.22",
      "superior": null,
      "indent": "5",
      "description": "Persian",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.5024",
      "rawHtsCode": "0707.00.50.24",
      "superior": null,
      "indent": "5",
      "description": "Long seedless",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.5026",
      "rawHtsCode": "0707.00.50.26",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.5030",
      "rawHtsCode": "0707.00.50.30",
      "superior": null,
      "indent": "5",
      "description": "Persian",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.5050",
      "rawHtsCode": "0707.00.50.50",
      "superior": null,
      "indent": "5",
      "description": "Long seedless",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.5060",
      "rawHtsCode": "0707.00.50.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.5070",
      "rawHtsCode": "0707.00.50.70",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.5085",
      "rawHtsCode": "0707.00.50.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.60",
      "rawHtsCode": "0707.00.60",
      "superior": null,
      "indent": "1",
      "description": "If entered during the period from July 1 to August 31, inclusive, in any year",
      "units": [],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0707.00.6005",
      "rawHtsCode": "0707.00.60.05",
      "superior": null,
      "indent": "2",
      "description": "Gherkins",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.6013",
      "rawHtsCode": "0707.00.60.13",
      "superior": null,
      "indent": "5",
      "description": "Persian",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.6017",
      "rawHtsCode": "0707.00.60.17",
      "superior": null,
      "indent": "5",
      "description": "Long seedless",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.6021",
      "rawHtsCode": "0707.00.60.21",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.6024",
      "rawHtsCode": "0707.00.60.24",
      "superior": null,
      "indent": "5",
      "description": "Persian",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.6026",
      "rawHtsCode": "0707.00.60.26",
      "superior": null,
      "indent": "5",
      "description": "Long seedless",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.6028",
      "rawHtsCode": "0707.00.60.28",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.6030",
      "rawHtsCode": "0707.00.60.30",
      "superior": null,
      "indent": "4",
      "description": "Not exceeding 15 cm (6 inches) in length and presented in bulk quantities of 453.6 kg (1,000 lbs) or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.6060",
      "rawHtsCode": "0707.00.60.60",
      "superior": null,
      "indent": "5",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0707.00.6075",
      "rawHtsCode": "0707.00.60.75",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708",
      "rawHtsCode": "0708",
      "superior": null,
      "indent": "0",
      "description": "Leguminous vegetables, shelled or unshelled, fresh or chilled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.10",
      "rawHtsCode": "0708.10",
      "superior": null,
      "indent": "1",
      "description": "Peas (<i>Pisum sativum</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.10.20",
      "rawHtsCode": "0708.10.20",
      "superior": null,
      "indent": "2",
      "description": "If entered during the period from July 1 to September 30, inclusive, in any year",
      "units": [],
      "generalRate": "0.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0708.10.2020",
      "rawHtsCode": "0708.10.20.20",
      "superior": null,
      "indent": "3",
      "description": "Snow peas",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.10.2040",
      "rawHtsCode": "0708.10.20.40",
      "superior": null,
      "indent": "3",
      "description": "Sugar snap peas",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.10.2060",
      "rawHtsCode": "0708.10.20.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.10.40",
      "rawHtsCode": "0708.10.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0708.10.4020",
      "rawHtsCode": "0708.10.40.20",
      "superior": null,
      "indent": "3",
      "description": "Snow peas",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.10.4040",
      "rawHtsCode": "0708.10.40.40",
      "superior": null,
      "indent": "3",
      "description": "Sugar snap peas",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.10.4060",
      "rawHtsCode": "0708.10.40.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.20",
      "rawHtsCode": "0708.20",
      "superior": null,
      "indent": "1",
      "description": "Beans (<i>Vigna spp., Phaseolus spp.</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.20.1000",
      "rawHtsCode": "0708.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Lima beans, if entered during the period from November 1 in any year to the following May 31, inclusive",
      "units": [
        "kg"
      ],
      "generalRate": "2.3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0708.20.20",
      "rawHtsCode": "0708.20.20",
      "superior": null,
      "indent": "2",
      "description": "Cowpeas (other than black-eye peas)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0708.20.2005",
      "rawHtsCode": "0708.20.20.05",
      "superior": null,
      "indent": "3",
      "description": "Yard-long beans (<i>Vigna unguiculata</i> subsp., <i>Sesquipedalis</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.20.2010",
      "rawHtsCode": "0708.20.20.10",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.20.90",
      "rawHtsCode": "0708.20.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0708.20.9005",
      "rawHtsCode": "0708.20.90.05",
      "superior": null,
      "indent": "3",
      "description": "Other beans of the genus<i>Vigna</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.20.9020",
      "rawHtsCode": "0708.20.90.20",
      "superior": null,
      "indent": "4",
      "description": "French style",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.20.9040",
      "rawHtsCode": "0708.20.90.40",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.20.9060",
      "rawHtsCode": "0708.20.90.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.90",
      "rawHtsCode": "0708.90",
      "superior": null,
      "indent": "1",
      "description": "Other leguminous vegetables:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0708.90.0500",
      "rawHtsCode": "0708.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "Chickpeas (garbanzos)",
      "units": [
        "kg"
      ],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0708.90.1500",
      "rawHtsCode": "0708.90.15.00",
      "superior": null,
      "indent": "2",
      "description": "Lentils",
      "units": [
        "kg"
      ],
      "generalRate": "0.1¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0708.90.2500",
      "rawHtsCode": "0708.90.25.00",
      "superior": null,
      "indent": "3",
      "description": "If entered during the period from July 1 to September 30, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0708.90.3000",
      "rawHtsCode": "0708.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0708.90.4000",
      "rawHtsCode": "0708.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709",
      "rawHtsCode": "0709",
      "superior": null,
      "indent": "0",
      "description": "Other vegetables, fresh or chilled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.20",
      "rawHtsCode": "0709.20",
      "superior": null,
      "indent": "1",
      "description": "Asparagus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.20.10",
      "rawHtsCode": "0709.20.10",
      "superior": null,
      "indent": "2",
      "description": "Not reduced in size, entered during the period from September 15 to November 15, inclusive, in any year, and transported to the United States by air",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.20.1010",
      "rawHtsCode": "0709.20.10.10",
      "superior": null,
      "indent": "3",
      "description": "White",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.20.1090",
      "rawHtsCode": "0709.20.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.20.90",
      "rawHtsCode": "0709.20.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "21.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.20.9010",
      "rawHtsCode": "0709.20.90.10",
      "superior": null,
      "indent": "3",
      "description": "White",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.20.9040",
      "rawHtsCode": "0709.20.90.40",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.20.9070",
      "rawHtsCode": "0709.20.90.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.30",
      "rawHtsCode": "0709.30",
      "superior": null,
      "indent": "1",
      "description": "Eggplants (aubergines):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.30.20",
      "rawHtsCode": "0709.30.20",
      "superior": null,
      "indent": "2",
      "description": "If entered during the period from April 1 to November 30, inclusive, in any year",
      "units": [],
      "generalRate": "2.6¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.30.2020",
      "rawHtsCode": "0709.30.20.20",
      "superior": null,
      "indent": "3",
      "description": "Chinese",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.30.2040",
      "rawHtsCode": "0709.30.20.40",
      "superior": null,
      "indent": "3",
      "description": "Italian",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.30.2060",
      "rawHtsCode": "0709.30.20.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.30.40",
      "rawHtsCode": "0709.30.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "1.9¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.30.4020",
      "rawHtsCode": "0709.30.40.20",
      "superior": null,
      "indent": "3",
      "description": "Chinese",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.30.4040",
      "rawHtsCode": "0709.30.40.40",
      "superior": null,
      "indent": "3",
      "description": "Italian",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.30.4060",
      "rawHtsCode": "0709.30.40.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.40",
      "rawHtsCode": "0709.40",
      "superior": null,
      "indent": "1",
      "description": "Celery other than celeriac:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.40.2000",
      "rawHtsCode": "0709.40.20.00",
      "superior": null,
      "indent": "2",
      "description": "Reduced in size",
      "units": [
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.40.40",
      "rawHtsCode": "0709.40.40",
      "superior": null,
      "indent": "3",
      "description": "If imported and entered during the period from April 15 to July 31, inclusive, in any year",
      "units": [],
      "generalRate": "0.25¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.40.4020",
      "rawHtsCode": "0709.40.40.20",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.40.4040",
      "rawHtsCode": "0709.40.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.40.60",
      "rawHtsCode": "0709.40.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "1.9¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.40.6020",
      "rawHtsCode": "0709.40.60.20",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.40.6040",
      "rawHtsCode": "0709.40.60.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.51.01",
      "rawHtsCode": "0709.51.01",
      "superior": null,
      "indent": "2",
      "description": "Mushrooms of the genus <i>Agaricus</i>",
      "units": [],
      "generalRate": "8.8¢/kg + 20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.51.0110",
      "rawHtsCode": "0709.51.01.10",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.51.0150",
      "rawHtsCode": "0709.51.01.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.52.0500",
      "rawHtsCode": "0709.52.05.00",
      "superior": null,
      "indent": "2",
      "description": "Mushrooms of the genus <i>Boletus</i>",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg + 20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.53.0000",
      "rawHtsCode": "0709.53.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mushrooms of the genus <i>Cantharellus</i>",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg + 20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.54.0000",
      "rawHtsCode": "0709.54.00.00",
      "superior": null,
      "indent": "2",
      "description": "Shiitake (<i>Lentinus edodes</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg + 20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.55.0000",
      "rawHtsCode": "0709.55.00.00",
      "superior": null,
      "indent": "2",
      "description": "Matsutake (<i>Tricholoma matsutake, Tricholoma magnivelare, Tricholoma anatolicum, Tricholoma dulciolens, Tricholoma caligatum</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg + 20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.56.0000",
      "rawHtsCode": "0709.56.00.00",
      "superior": null,
      "indent": "2",
      "description": "Truffles (<i>Tuber spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0709.59",
      "rawHtsCode": "0709.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.59.1100",
      "rawHtsCode": "0709.59.11.00",
      "superior": null,
      "indent": "3",
      "description": "Truffles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0709.59.9100",
      "rawHtsCode": "0709.59.91.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg + 20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.60",
      "rawHtsCode": "0709.60",
      "superior": null,
      "indent": "1",
      "description": "Fruits of the genus <i>Capsicum</i> (peppers) or of the genus <i>Pimenta</i> (e.g., allspice):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.20",
      "rawHtsCode": "0709.60.20",
      "superior": null,
      "indent": "2",
      "description": "Chili peppers",
      "units": [],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.60.2010",
      "rawHtsCode": "0709.60.20.10",
      "superior": null,
      "indent": "3",
      "description": "Greenhouse",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.2020",
      "rawHtsCode": "0709.60.20.20",
      "superior": null,
      "indent": "4",
      "description": "Jalapeno",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.2030",
      "rawHtsCode": "0709.60.20.30",
      "superior": null,
      "indent": "4",
      "description": "Mini sweet peppers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.2040",
      "rawHtsCode": "0709.60.20.40",
      "superior": null,
      "indent": "4",
      "description": "Anaheim",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.2050",
      "rawHtsCode": "0709.60.20.50",
      "superior": null,
      "indent": "4",
      "description": "Poblano",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.2060",
      "rawHtsCode": "0709.60.20.60",
      "superior": null,
      "indent": "4",
      "description": "Serrano",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.2070",
      "rawHtsCode": "0709.60.20.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.40",
      "rawHtsCode": "0709.60.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.7¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.60.4005",
      "rawHtsCode": "0709.60.40.05",
      "superior": null,
      "indent": "6",
      "description": "Green",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4007",
      "rawHtsCode": "0709.60.40.07",
      "superior": null,
      "indent": "6",
      "description": "Red",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4009",
      "rawHtsCode": "0709.60.40.09",
      "superior": null,
      "indent": "6",
      "description": "Yellow",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4011",
      "rawHtsCode": "0709.60.40.11",
      "superior": null,
      "indent": "6",
      "description": "Orange",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4013",
      "rawHtsCode": "0709.60.40.13",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4017",
      "rawHtsCode": "0709.60.40.17",
      "superior": null,
      "indent": "6",
      "description": "Green",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4022",
      "rawHtsCode": "0709.60.40.22",
      "superior": null,
      "indent": "6",
      "description": "Red",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4027",
      "rawHtsCode": "0709.60.40.27",
      "superior": null,
      "indent": "6",
      "description": "Yellow",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4032",
      "rawHtsCode": "0709.60.40.32",
      "superior": null,
      "indent": "6",
      "description": "Orange",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4037",
      "rawHtsCode": "0709.60.40.37",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4055",
      "rawHtsCode": "0709.60.40.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4060",
      "rawHtsCode": "0709.60.40.60",
      "superior": null,
      "indent": "6",
      "description": "Green",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4063",
      "rawHtsCode": "0709.60.40.63",
      "superior": null,
      "indent": "6",
      "description": "Red",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4066",
      "rawHtsCode": "0709.60.40.66",
      "superior": null,
      "indent": "6",
      "description": "Yellow",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4069",
      "rawHtsCode": "0709.60.40.69",
      "superior": null,
      "indent": "6",
      "description": "Orange",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4072",
      "rawHtsCode": "0709.60.40.72",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4074",
      "rawHtsCode": "0709.60.40.74",
      "superior": null,
      "indent": "6",
      "description": "Of a kind for processing as described in statistical note 3 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4078",
      "rawHtsCode": "0709.60.40.78",
      "superior": null,
      "indent": "7",
      "description": "Green",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4081",
      "rawHtsCode": "0709.60.40.81",
      "superior": null,
      "indent": "7",
      "description": "Red",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4084",
      "rawHtsCode": "0709.60.40.84",
      "superior": null,
      "indent": "7",
      "description": "Yellow",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4087",
      "rawHtsCode": "0709.60.40.87",
      "superior": null,
      "indent": "7",
      "description": "Orange",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4091",
      "rawHtsCode": "0709.60.40.91",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.60.4095",
      "rawHtsCode": "0709.60.40.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.70.00",
      "rawHtsCode": "0709.70.00",
      "superior": null,
      "indent": "1",
      "description": "Spinach, New Zealand spinach and orache spinach (garden spinach)",
      "units": [],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.70.0010",
      "rawHtsCode": "0709.70.00.10",
      "superior": null,
      "indent": "2",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.70.0050",
      "rawHtsCode": "0709.70.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.91.0000",
      "rawHtsCode": "0709.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Globe artichokes",
      "units": [
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.92.0000",
      "rawHtsCode": "0709.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Olives",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.93",
      "rawHtsCode": "0709.93",
      "superior": null,
      "indent": "2",
      "description": "Pumpkins, squash and gourds (<i>Cucurbita</i> spp.):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.1000",
      "rawHtsCode": "0709.93.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pumpkins",
      "units": [
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.93.20",
      "rawHtsCode": "0709.93.20",
      "superior": null,
      "indent": "3",
      "description": "Squash",
      "units": [],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.93.2020",
      "rawHtsCode": "0709.93.20.20",
      "superior": null,
      "indent": "5",
      "description": "Zucchini",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2022",
      "rawHtsCode": "0709.93.20.22",
      "superior": null,
      "indent": "5",
      "description": "Butternut",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2025",
      "rawHtsCode": "0709.93.20.25",
      "superior": null,
      "indent": "5",
      "description": "Grey",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2028",
      "rawHtsCode": "0709.93.20.28",
      "superior": null,
      "indent": "5",
      "description": "Spaghetti",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2030",
      "rawHtsCode": "0709.93.20.30",
      "superior": null,
      "indent": "5",
      "description": "Yellow straightneck",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2032",
      "rawHtsCode": "0709.93.20.32",
      "superior": null,
      "indent": "5",
      "description": "Kabocha",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2035",
      "rawHtsCode": "0709.93.20.35",
      "superior": null,
      "indent": "5",
      "description": "Acorn",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2038",
      "rawHtsCode": "0709.93.20.38",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2055",
      "rawHtsCode": "0709.93.20.55",
      "superior": null,
      "indent": "5",
      "description": "Zucchini",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2060",
      "rawHtsCode": "0709.93.20.60",
      "superior": null,
      "indent": "5",
      "description": "Butternut",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2065",
      "rawHtsCode": "0709.93.20.65",
      "superior": null,
      "indent": "5",
      "description": "Grey",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2070",
      "rawHtsCode": "0709.93.20.70",
      "superior": null,
      "indent": "5",
      "description": "Spaghetti",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2075",
      "rawHtsCode": "0709.93.20.75",
      "superior": null,
      "indent": "5",
      "description": "Yellow straightneck",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2080",
      "rawHtsCode": "0709.93.20.80",
      "superior": null,
      "indent": "5",
      "description": "Kabocha",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2085",
      "rawHtsCode": "0709.93.20.85",
      "superior": null,
      "indent": "5",
      "description": "Acorn",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.2090",
      "rawHtsCode": "0709.93.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.93.3000",
      "rawHtsCode": "0709.93.30.00",
      "superior": null,
      "indent": "3",
      "description": "Gourds (<i>Cucurbita</i> spp.)",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.99",
      "rawHtsCode": "0709.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.99.0500",
      "rawHtsCode": "0709.99.05.00",
      "superior": null,
      "indent": "3",
      "description": "Jicamas, and breadfruit",
      "units": [
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.99.1000",
      "rawHtsCode": "0709.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Chayote (<i>Sechium edule</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.99.1400",
      "rawHtsCode": "0709.99.14.00",
      "superior": null,
      "indent": "3",
      "description": "Okra",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.99.3000",
      "rawHtsCode": "0709.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "Fiddlehead greens",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.99.4500",
      "rawHtsCode": "0709.99.45.00",
      "superior": null,
      "indent": "3",
      "description": "Sweet corn",
      "units": [
        "kg"
      ],
      "generalRate": "21.3%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.99.90",
      "rawHtsCode": "0709.99.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0709.99.9005",
      "rawHtsCode": "0709.99.90.05",
      "superior": null,
      "indent": "4",
      "description": "Bitter melon (<i>Momordica charantia</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.99.9010",
      "rawHtsCode": "0709.99.90.10",
      "superior": null,
      "indent": "4",
      "description": "Cilantro",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.99.9030",
      "rawHtsCode": "0709.99.90.30",
      "superior": null,
      "indent": "4",
      "description": "Cactus leaves",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0709.99.9085",
      "rawHtsCode": "0709.99.90.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710",
      "rawHtsCode": "0710",
      "superior": null,
      "indent": "0",
      "description": "Vegetables (uncooked or cooked by steaming or boiling in water), frozen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.10.0000",
      "rawHtsCode": "0710.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Potatoes",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.21",
      "rawHtsCode": "0710.21",
      "superior": null,
      "indent": "2",
      "description": "Peas (<i>Pisum sativum</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.21.2000",
      "rawHtsCode": "0710.21.20.00",
      "superior": null,
      "indent": "3",
      "description": "If entered during the period from July 1 to September 30, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.21.4000",
      "rawHtsCode": "0710.21.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.22",
      "rawHtsCode": "0710.22",
      "superior": null,
      "indent": "2",
      "description": "Beans (<i>Vigna spp.</i>, <i>Phaseolus</i> spp.):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.22.1000",
      "rawHtsCode": "0710.22.10.00",
      "superior": null,
      "indent": "5",
      "description": "If entered during the period from November 1 in any year to the following May 31, inclusive",
      "units": [
        "kg"
      ],
      "generalRate": "2.3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.22.1500",
      "rawHtsCode": "0710.22.15.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.9¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.22.2000",
      "rawHtsCode": "0710.22.20.00",
      "superior": null,
      "indent": "4",
      "description": "Cowpeas (other than black-eye peas)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0710.22.2500",
      "rawHtsCode": "0710.22.25.00",
      "superior": null,
      "indent": "4",
      "description": "String beans (snap beans)",
      "units": [
        "kg"
      ],
      "generalRate": "4.9¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.22.3700",
      "rawHtsCode": "0710.22.37.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR, MA,OM,P,PA,PE,S, SG)",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.22.40",
      "rawHtsCode": "0710.22.40",
      "superior": null,
      "indent": "3",
      "description": "Reduced in size",
      "units": [],
      "generalRate": "11.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.22.4010",
      "rawHtsCode": "0710.22.40.10",
      "superior": null,
      "indent": "4",
      "description": "Green and wax",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.22.4090",
      "rawHtsCode": "0710.22.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.29",
      "rawHtsCode": "0710.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.29.0500",
      "rawHtsCode": "0710.29.05.00",
      "superior": null,
      "indent": "3",
      "description": "Chickpeas (garbanzos)",
      "units": [
        "kg"
      ],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.29.1500",
      "rawHtsCode": "0710.29.15.00",
      "superior": null,
      "indent": "3",
      "description": "Lentils",
      "units": [
        "kg"
      ],
      "generalRate": "0.1¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.29.2500",
      "rawHtsCode": "0710.29.25.00",
      "superior": null,
      "indent": "4",
      "description": "If entered during the period from July 1 to September 30, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0710.29.3000",
      "rawHtsCode": "0710.29.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.29.4000",
      "rawHtsCode": "0710.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.30.0000",
      "rawHtsCode": "0710.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Spinach, New Zealand spinach and orache spinach (garden spinach)",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.40.0000",
      "rawHtsCode": "0710.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sweet corn",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.80",
      "rawHtsCode": "0710.80",
      "superior": null,
      "indent": "1",
      "description": "Other vegetables:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.80.1500",
      "rawHtsCode": "0710.80.15.00",
      "superior": null,
      "indent": "2",
      "description": "Bamboo shoots and water chestnuts, other than Chinese water chestnuts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0710.80.2000",
      "rawHtsCode": "0710.80.20.00",
      "superior": null,
      "indent": "2",
      "description": "Mushrooms",
      "units": [
        "kg"
      ],
      "generalRate": "5.7¢/kg + 8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.80.4000",
      "rawHtsCode": "0710.80.40.00",
      "superior": null,
      "indent": "3",
      "description": "If entered during the period from March 1 to July 14, inclusive, or the period from September 1 to November 14, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "2.9¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.80.4500",
      "rawHtsCode": "0710.80.45.00",
      "superior": null,
      "indent": "3",
      "description": "If entered during the period from July 15 to August 31, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "2.1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.80.5000",
      "rawHtsCode": "0710.80.50.00",
      "superior": null,
      "indent": "3",
      "description": "If entered during the period from November 15 in any year to the last day of the following February, inclusive",
      "units": [
        "kg"
      ],
      "generalRate": "2.1¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.80.6000",
      "rawHtsCode": "0710.80.60.00",
      "superior": null,
      "indent": "4",
      "description": "Fiddlehead greens",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.80.6500",
      "rawHtsCode": "0710.80.65.00",
      "superior": null,
      "indent": "4",
      "description": "Brussels sprouts",
      "units": [
        "kg"
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.80.70",
      "rawHtsCode": "0710.80.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "11.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.80.7040",
      "rawHtsCode": "0710.80.70.40",
      "superior": null,
      "indent": "5",
      "description": "Carrots",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.80.7060",
      "rawHtsCode": "0710.80.70.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.80.8500",
      "rawHtsCode": "0710.80.85.00",
      "superior": null,
      "indent": "4",
      "description": "Brussels sprouts",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.80.9300",
      "rawHtsCode": "0710.80.93.00",
      "superior": null,
      "indent": "4",
      "description": "Okra",
      "units": [
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.80.97",
      "rawHtsCode": "0710.80.97",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.80.9710",
      "rawHtsCode": "0710.80.97.10",
      "superior": null,
      "indent": "5",
      "description": "Asparagus",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.80.9722",
      "rawHtsCode": "0710.80.97.22",
      "superior": null,
      "indent": "6",
      "description": "Spears",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.80.9723",
      "rawHtsCode": "0710.80.97.23",
      "superior": null,
      "indent": "8",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.80.9725",
      "rawHtsCode": "0710.80.97.25",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.80.9726",
      "rawHtsCode": "0710.80.97.26",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.80.9730",
      "rawHtsCode": "0710.80.97.30",
      "superior": null,
      "indent": "5",
      "description": "Cauliflower",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.80.9755",
      "rawHtsCode": "0710.80.97.55",
      "superior": null,
      "indent": "5",
      "description": "Garlic, reduced in size beyond the clove, whether or not individually quick frozen",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.80.9765",
      "rawHtsCode": "0710.80.97.65",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.90",
      "rawHtsCode": "0710.90",
      "superior": null,
      "indent": "1",
      "description": "Mixtures of vegetables:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0710.90.1100",
      "rawHtsCode": "0710.90.11.00",
      "superior": null,
      "indent": "2",
      "description": "Mixtures of pea pods and water chestnuts, other than Chinese water chestnuts",
      "units": [
        "kg"
      ],
      "generalRate": "7.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0710.90.9100",
      "rawHtsCode": "0710.90.91.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A,AU,BH, CL,CO,D,E,IL, JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0711",
      "rawHtsCode": "0711",
      "superior": null,
      "indent": "0",
      "description": "Vegetables provisionally preserved, but unsuitable in that state for immediate consumption:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0711.20",
      "rawHtsCode": "0711.20",
      "superior": null,
      "indent": "1",
      "description": "Olives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0711.20.1800",
      "rawHtsCode": "0711.20.18.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.7¢/kg on drained weight",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.4¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0711.20.2800",
      "rawHtsCode": "0711.20.28.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.9¢/kg on drained weight",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.4¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0711.20.3800",
      "rawHtsCode": "0711.20.38.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.9¢/kg on drained weight",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "7.4¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0711.20.4000",
      "rawHtsCode": "0711.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Pitted or stuffed",
      "units": [
        "kg"
      ],
      "generalRate": "8.6¢/kg on drained weight",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM, P,PA, PE,S,SG)",
      "otherRate": "10.8¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0711.40.0000",
      "rawHtsCode": "0711.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cucumbers including gherkins",
      "units": [
        "kg"
      ],
      "generalRate": "7.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0711.51.0000",
      "rawHtsCode": "0711.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mushrooms of the genus <i>Agaricus</i>",
      "units": [
        "kg"
      ],
      "generalRate": "5.7¢/kg on drained weight + 8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg on drained weight+45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0711.59",
      "rawHtsCode": "0711.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0711.59.1000",
      "rawHtsCode": "0711.59.10.00",
      "superior": null,
      "indent": "3",
      "description": "Mushrooms",
      "units": [
        "kg"
      ],
      "generalRate": "5.7¢/kg on drained weight +8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg on drained weight+45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0711.59.9000",
      "rawHtsCode": "0711.59.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "7.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0711.90",
      "rawHtsCode": "0711.90",
      "superior": null,
      "indent": "1",
      "description": "Other vegetables; mixtures of vegetables:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0711.90.2000",
      "rawHtsCode": "0711.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Leguminous vegetables",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0711.90.3000",
      "rawHtsCode": "0711.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Capers",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0711.90.5000",
      "rawHtsCode": "0711.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Onions",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0711.90.6500",
      "rawHtsCode": "0711.90.65.00",
      "superior": null,
      "indent": "2",
      "description": "Other vegetables; mixtures of vegetables",
      "units": [
        "kg"
      ],
      "generalRate": "7.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712",
      "rawHtsCode": "0712",
      "superior": null,
      "indent": "0",
      "description": "Dried vegetables, whole, cut, sliced, broken or in powder, but not further prepared:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.20",
      "rawHtsCode": "0712.20",
      "superior": null,
      "indent": "1",
      "description": "Onions:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.20.2000",
      "rawHtsCode": "0712.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Powder or flour",
      "units": [
        "kg"
      ],
      "generalRate": "29.8%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.20.4000",
      "rawHtsCode": "0712.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "21.3%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.31",
      "rawHtsCode": "0712.31",
      "superior": null,
      "indent": "2",
      "description": "Mushrooms of the genus <em style=\"color: rgb(51, 51, 51); font-family: sans-serif, Arial, Verdana, 'Trebuchet MS'; background-color: rgb(255, 255, 255);\">Agaricus</em><em style=\"color: rgb(51, 51, 51); font-family: sans-serif, Arial, Verdana, 'Trebuchet MS'; background-color: rgb(255, 255, 255);\">: </em>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.31.1000",
      "rawHtsCode": "0712.31.10.00",
      "superior": null,
      "indent": "3",
      "description": "Air dried or sun dried",
      "units": [
        "kg"
      ],
      "generalRate": "1.3¢/kg + 1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.31.2000",
      "rawHtsCode": "0712.31.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.9¢/kg + 2.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.32.0000",
      "rawHtsCode": "0712.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Wood ears (<i>Auricularia spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "8.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.33.0000",
      "rawHtsCode": "0712.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Jelly fungi (<i>Tremella spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "8.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.34",
      "rawHtsCode": "0712.34",
      "superior": null,
      "indent": "2",
      "description": "Shiitake (<i>Lentinus edodes</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.34.1000",
      "rawHtsCode": "0712.34.10.00",
      "superior": null,
      "indent": "3",
      "description": "Air dried or sun dried",
      "units": [
        "kg"
      ],
      "generalRate": "1.3¢/kg + 1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.34.2000",
      "rawHtsCode": "0712.34.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.9¢/kg + 2.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.39",
      "rawHtsCode": "0712.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.39.1100",
      "rawHtsCode": "0712.39.11.00",
      "superior": null,
      "indent": "4",
      "description": "Air dried or sun dried",
      "units": [
        "kg"
      ],
      "generalRate": "1.3¢/kg + 1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.39.2100",
      "rawHtsCode": "0712.39.21.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.9¢/kg + 2.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.39.4000",
      "rawHtsCode": "0712.39.40.00",
      "superior": null,
      "indent": "3",
      "description": "Truffles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0712.90",
      "rawHtsCode": "0712.90",
      "superior": null,
      "indent": "1",
      "description": "Other vegetables; mixtures of vegetables:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.90.1000",
      "rawHtsCode": "0712.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Carrots",
      "units": [
        "kg"
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.90.1500",
      "rawHtsCode": "0712.90.15.00",
      "superior": null,
      "indent": "3",
      "description": "Not ripe",
      "units": [
        "kg"
      ],
      "generalRate": "5.5¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.90.2000",
      "rawHtsCode": "0712.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Ripe",
      "units": [
        "kg"
      ],
      "generalRate": "2.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.90.3000",
      "rawHtsCode": "0712.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Potatoes whether or not cut or sliced but not further prepared",
      "units": [
        "kg"
      ],
      "generalRate": "2.3¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.90.40",
      "rawHtsCode": "0712.90.40",
      "superior": null,
      "indent": "2",
      "description": "Garlic",
      "units": [],
      "generalRate": "29.8%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.90.4020",
      "rawHtsCode": "0712.90.40.20",
      "superior": null,
      "indent": "3",
      "description": "Powder or flour",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.90.4040",
      "rawHtsCode": "0712.90.40.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.90.6000",
      "rawHtsCode": "0712.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Crude or not manufactured",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0712.90.6500",
      "rawHtsCode": "0712.90.65.00",
      "superior": null,
      "indent": "4",
      "description": "Parsley",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.90.7000",
      "rawHtsCode": "0712.90.70.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.90.7400",
      "rawHtsCode": "0712.90.74.00",
      "superior": null,
      "indent": "3",
      "description": "In powder",
      "units": [
        "kg"
      ],
      "generalRate": "8.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.90.7800",
      "rawHtsCode": "0712.90.78.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.90.85",
      "rawHtsCode": "0712.90.85",
      "superior": null,
      "indent": "2",
      "description": "Other vegetables; mixtures of vegetables",
      "units": [],
      "generalRate": "8.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0712.90.8510",
      "rawHtsCode": "0712.90.85.10",
      "superior": null,
      "indent": "3",
      "description": "Broccoli",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.90.8520",
      "rawHtsCode": "0712.90.85.20",
      "superior": null,
      "indent": "3",
      "description": "Celery stalks",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.90.8530",
      "rawHtsCode": "0712.90.85.30",
      "superior": null,
      "indent": "3",
      "description": "Leeks",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.90.8540",
      "rawHtsCode": "0712.90.85.40",
      "superior": null,
      "indent": "3",
      "description": "Spinach",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.90.8550",
      "rawHtsCode": "0712.90.85.50",
      "superior": null,
      "indent": "3",
      "description": "Sweet corn seeds of a kind used for sowing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0712.90.8580",
      "rawHtsCode": "0712.90.85.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713",
      "rawHtsCode": "0713",
      "superior": null,
      "indent": "0",
      "description": "Dried leguminous vegetables, shelled, whether or not skinned or split:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.10",
      "rawHtsCode": "0713.10",
      "superior": null,
      "indent": "1",
      "description": "Peas (<i>Pisum sativum</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.10.1000",
      "rawHtsCode": "0713.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Seeds of a kind used for sowing",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.10.2000",
      "rawHtsCode": "0713.10.20.00",
      "superior": null,
      "indent": "3",
      "description": "Split peas",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0713.10.40",
      "rawHtsCode": "0713.10.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "0.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.10.4005",
      "rawHtsCode": "0713.10.40.05",
      "superior": null,
      "indent": "5",
      "description": "Certified Organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.10.4015",
      "rawHtsCode": "0713.10.40.15",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.10.4020",
      "rawHtsCode": "0713.10.40.20",
      "superior": null,
      "indent": "4",
      "description": "Green peas",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.10.4060",
      "rawHtsCode": "0713.10.40.60",
      "superior": null,
      "indent": "4",
      "description": "Austrian winter peas",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.10.4080",
      "rawHtsCode": "0713.10.40.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.20",
      "rawHtsCode": "0713.20",
      "superior": null,
      "indent": "1",
      "description": "Chickpeas (garbanzos):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.20.1000",
      "rawHtsCode": "0713.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Seeds of a kind used for sowing",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.20.20",
      "rawHtsCode": "0713.20.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.20.2015",
      "rawHtsCode": "0713.20.20.15",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.20.2025",
      "rawHtsCode": "0713.20.20.25",
      "superior": null,
      "indent": "4",
      "description": "Kabuli chickpeas",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.20.2075",
      "rawHtsCode": "0713.20.20.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.31",
      "rawHtsCode": "0713.31",
      "superior": null,
      "indent": "2",
      "description": "Beans of the species <i>Vigna mungo</i> (<i>L.</i>) <i>Hepper</i> or <i>Vigna radiata</i> (<i>L.</i>)<i>Wilczek</i><i>: </i>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.31.1000",
      "rawHtsCode": "0713.31.10.00",
      "superior": null,
      "indent": "3",
      "description": "Seeds of a kind used for sowing",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.31.2000",
      "rawHtsCode": "0713.31.20.00",
      "superior": null,
      "indent": "4",
      "description": "If entered for consumption during the period from May 1 to August 31, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0713.31.4000",
      "rawHtsCode": "0713.31.40.00",
      "superior": null,
      "indent": "4",
      "description": "If entered for consumption outside the above stated period, or if withdrawn for consumption at any time",
      "units": [
        "kg"
      ],
      "generalRate": "0.3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.32",
      "rawHtsCode": "0713.32",
      "superior": null,
      "indent": "2",
      "description": "Small red (adzuki) beans (<i>Phaseolus</i> or <i>Vigna angularis</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.32.1000",
      "rawHtsCode": "0713.32.10.00",
      "superior": null,
      "indent": "3",
      "description": "Seeds of a kind used for sowing",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.32.2000",
      "rawHtsCode": "0713.32.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.33",
      "rawHtsCode": "0713.33",
      "superior": null,
      "indent": "2",
      "description": "Kidney beans, including white pea beans (<i>Phaseolus vulgaris</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.33.10",
      "rawHtsCode": "0713.33.10",
      "superior": null,
      "indent": "3",
      "description": "Seeds of a kind used for sowing",
      "units": [],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.33.1020",
      "rawHtsCode": "0713.33.10.20",
      "superior": null,
      "indent": "4",
      "description": "Navy or pea beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.33.1040",
      "rawHtsCode": "0713.33.10.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.33.20",
      "rawHtsCode": "0713.33.20",
      "superior": null,
      "indent": "4",
      "description": "If entered for consumption during the period from May 1 to August 31, inclusive, in any year",
      "units": [],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.33.2020",
      "rawHtsCode": "0713.33.20.20",
      "superior": null,
      "indent": "5",
      "description": "Navy or pea beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.33.2030",
      "rawHtsCode": "0713.33.20.30",
      "superior": null,
      "indent": "5",
      "description": "Dark red beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.33.2050",
      "rawHtsCode": "0713.33.20.50",
      "superior": null,
      "indent": "5",
      "description": "Light red beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.33.2090",
      "rawHtsCode": "0713.33.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.33.40",
      "rawHtsCode": "0713.33.40",
      "superior": null,
      "indent": "4",
      "description": "If entered for consumption outside the above stated period, or if withdrawn for consumption at any time",
      "units": [],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.33.4020",
      "rawHtsCode": "0713.33.40.20",
      "superior": null,
      "indent": "5",
      "description": "Navy or pea beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.33.4030",
      "rawHtsCode": "0713.33.40.30",
      "superior": null,
      "indent": "5",
      "description": "Dark red beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.33.4050",
      "rawHtsCode": "0713.33.40.50",
      "superior": null,
      "indent": "5",
      "description": "Light red beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.33.4090",
      "rawHtsCode": "0713.33.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.34",
      "rawHtsCode": "0713.34",
      "superior": null,
      "indent": "2",
      "description": "Bambara beans (<i>Vigna subterranea </i>or<i>Voandzeia subterranea</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.34.1000",
      "rawHtsCode": "0713.34.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used for sowing",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.34.2000",
      "rawHtsCode": "0713.34.20.00",
      "superior": null,
      "indent": "4",
      "description": "If entered for consumption during the period from May 1 to August 31, Inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.34.4000",
      "rawHtsCode": "0713.34.40.00",
      "superior": null,
      "indent": "4",
      "description": "If entered for consumption outside the above stated period, or if withdrawn for consumption at any time",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.35.0000",
      "rawHtsCode": "0713.35.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cowpeas (<i>Vigna unguiculata</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0713.39",
      "rawHtsCode": "0713.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.11",
      "rawHtsCode": "0713.39.11",
      "superior": null,
      "indent": "3",
      "description": "Seeds of a kind used for sowing",
      "units": [],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.39.1110",
      "rawHtsCode": "0713.39.11.10",
      "superior": null,
      "indent": "4",
      "description": "Cranberry beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.1190",
      "rawHtsCode": "0713.39.11.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.21",
      "rawHtsCode": "0713.39.21",
      "superior": null,
      "indent": "4",
      "description": "If entered for consumption during the period from May 1 to August 31, inclusive, in any year",
      "units": [],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.39.2110",
      "rawHtsCode": "0713.39.21.10",
      "superior": null,
      "indent": "5",
      "description": "Black beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.2120",
      "rawHtsCode": "0713.39.21.20",
      "superior": null,
      "indent": "5",
      "description": "Great Northern beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.2130",
      "rawHtsCode": "0713.39.21.30",
      "superior": null,
      "indent": "5",
      "description": "Baby lima beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.2140",
      "rawHtsCode": "0713.39.21.40",
      "superior": null,
      "indent": "5",
      "description": "Other lima beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.2150",
      "rawHtsCode": "0713.39.21.50",
      "superior": null,
      "indent": "5",
      "description": "Pinto beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.2160",
      "rawHtsCode": "0713.39.21.60",
      "superior": null,
      "indent": "5",
      "description": "Other white beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.2170",
      "rawHtsCode": "0713.39.21.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.41",
      "rawHtsCode": "0713.39.41",
      "superior": null,
      "indent": "4",
      "description": "If entered for consumption outside the above stated period, or if withdrawn for consumption at any time",
      "units": [],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.39.4110",
      "rawHtsCode": "0713.39.41.10",
      "superior": null,
      "indent": "5",
      "description": "Black beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.4120",
      "rawHtsCode": "0713.39.41.20",
      "superior": null,
      "indent": "5",
      "description": "Great Northern beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.4130",
      "rawHtsCode": "0713.39.41.30",
      "superior": null,
      "indent": "5",
      "description": "Baby lima beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.4140",
      "rawHtsCode": "0713.39.41.40",
      "superior": null,
      "indent": "5",
      "description": "Other lima beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.4150",
      "rawHtsCode": "0713.39.41.50",
      "superior": null,
      "indent": "5",
      "description": "Pinto beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.4160",
      "rawHtsCode": "0713.39.41.60",
      "superior": null,
      "indent": "5",
      "description": "Other white beans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.39.4170",
      "rawHtsCode": "0713.39.41.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.40",
      "rawHtsCode": "0713.40",
      "superior": null,
      "indent": "1",
      "description": "Lentils:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.40.1000",
      "rawHtsCode": "0713.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Seeds of a kind used for sowing",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.40.20",
      "rawHtsCode": "0713.40.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "0.15¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.40.2015",
      "rawHtsCode": "0713.40.20.15",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.40.2020",
      "rawHtsCode": "0713.40.20.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.40.2035",
      "rawHtsCode": "0713.40.20.35",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.40.2050",
      "rawHtsCode": "0713.40.20.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.40.2065",
      "rawHtsCode": "0713.40.20.65",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.40.2085",
      "rawHtsCode": "0713.40.20.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.50",
      "rawHtsCode": "0713.50",
      "superior": null,
      "indent": "1",
      "description": "Broad beans (<i>Vicia</i> <i>faba</i> var. <i>major</i>) and horse beans (<i>Vicia</i> <i>faba</i> var. <i>equina</i> and <i>Vicia</i> <i>faba</i> var. <i>minor</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.50.1000",
      "rawHtsCode": "0713.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Seeds of a kind used for sowing",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.50.2000",
      "rawHtsCode": "0713.50.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.60",
      "rawHtsCode": "0713.60",
      "superior": null,
      "indent": "1",
      "description": "Pigeon peas (<i>Cajanus cajan</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.60.1000",
      "rawHtsCode": "0713.60.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used for sowing",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.60.6000",
      "rawHtsCode": "0713.60.60.00",
      "superior": null,
      "indent": "3",
      "description": "If entered for consumption during the period from May 1 to August 31, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.60.8000",
      "rawHtsCode": "0713.60.80.00",
      "superior": null,
      "indent": "3",
      "description": "If entered for consumption outside the above stated period, or if withdrawn for consumption at any time",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.90",
      "rawHtsCode": "0713.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0713.90.1100",
      "rawHtsCode": "0713.90.11.00",
      "superior": null,
      "indent": "2",
      "description": "Seeds of a kind used for sowing",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.90.5000",
      "rawHtsCode": "0713.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Guar seeds",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0713.90.6100",
      "rawHtsCode": "0713.90.61.00",
      "superior": null,
      "indent": "4",
      "description": "If entered for consumption during the period from May 1 to August 31, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0713.90.8100",
      "rawHtsCode": "0713.90.81.00",
      "superior": null,
      "indent": "4",
      "description": "If entered for consumption outside the above stated period, or if withdrawn for consumption at any time",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714",
      "rawHtsCode": "0714",
      "superior": null,
      "indent": "0",
      "description": "Cassava (manioc), arrowroot, salep, Jerusalem artichokes, sweet potatoes and similar roots and tubers with high starch or inulin content, fresh, chilled, frozen or dried, whether or not sliced or in the form of pellets; sago pith:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0714.10",
      "rawHtsCode": "0714.10",
      "superior": null,
      "indent": "1",
      "description": "Cassava (manioc):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0714.10.1000",
      "rawHtsCode": "0714.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "7.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.10.2000",
      "rawHtsCode": "0714.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.20",
      "rawHtsCode": "0714.20",
      "superior": null,
      "indent": "1",
      "description": "Sweet potatoes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0714.20.1000",
      "rawHtsCode": "0714.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.20.2000",
      "rawHtsCode": "0714.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.30",
      "rawHtsCode": "0714.30",
      "superior": null,
      "indent": "1",
      "description": "Yams (<i>Dioscorea</i> spp.):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0714.30.1000",
      "rawHtsCode": "0714.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.2% (JP)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.30.2000",
      "rawHtsCode": "0714.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.30.5000",
      "rawHtsCode": "0714.30.50.00",
      "superior": null,
      "indent": "3",
      "description": "In the form of pellets",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0714.30.6000",
      "rawHtsCode": "0714.30.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 4.15% (JP)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.40",
      "rawHtsCode": "0714.40",
      "superior": null,
      "indent": "1",
      "description": "Taro (<i>Colocasia</i> spp.):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0714.40.1001",
      "rawHtsCode": "0714.40.10.01",
      "superior": null,
      "indent": "2",
      "description": "Fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.40.2000",
      "rawHtsCode": "0714.40.20.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.40.5000",
      "rawHtsCode": "0714.40.50.00",
      "superior": null,
      "indent": "3",
      "description": "In the form of pellets",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0714.40.6000",
      "rawHtsCode": "0714.40.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.50",
      "rawHtsCode": "0714.50",
      "superior": null,
      "indent": "1",
      "description": "Yautia (<i>Xanthosoma</i> spp.):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0714.50.1000",
      "rawHtsCode": "0714.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fresh or chilled",
      "units": [
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.50.2000",
      "rawHtsCode": "0714.50.20.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.50.5000",
      "rawHtsCode": "0714.50.50.00",
      "superior": null,
      "indent": "3",
      "description": "In the form of pellets",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0714.50.6000",
      "rawHtsCode": "0714.50.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.90",
      "rawHtsCode": "0714.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0714.90.0500",
      "rawHtsCode": "0714.90.05.00",
      "superior": null,
      "indent": "3",
      "description": "Chinese water chestnuts",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.90.3900",
      "rawHtsCode": "0714.90.39.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.90.4100",
      "rawHtsCode": "0714.90.41.00",
      "superior": null,
      "indent": "3",
      "description": "Mixtures of pea pods and Chinese water chestnuts",
      "units": [
        "kg"
      ],
      "generalRate": "7.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.90.4200",
      "rawHtsCode": "0714.90.42.00",
      "superior": null,
      "indent": "3",
      "description": "Other mixtures of Chinese water chestnuts",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.90.4400",
      "rawHtsCode": "0714.90.44.00",
      "superior": null,
      "indent": "3",
      "description": "Chinese water chestnuts, not mixed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0714.90.4600",
      "rawHtsCode": "0714.90.46.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.90.4800",
      "rawHtsCode": "0714.90.48.00",
      "superior": null,
      "indent": "3",
      "description": "Chinese water chestnuts",
      "units": [
        "kg"
      ],
      "generalRate": "8.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0714.90.5100",
      "rawHtsCode": "0714.90.51.00",
      "superior": null,
      "indent": "4",
      "description": "In the form of pellets",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0714.90.6100",
      "rawHtsCode": "0714.90.61.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0801",
      "rawHtsCode": "0801",
      "superior": null,
      "indent": "0",
      "description": "Coconuts, Brazil nuts and cashew nuts, fresh or dried, whether or not shelled or peeled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0801.11.0000",
      "rawHtsCode": "0801.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Desiccated",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0801.12.0000",
      "rawHtsCode": "0801.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "In the inner shell (endocarp)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0801.19.01",
      "rawHtsCode": "0801.19.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0801.19.0120",
      "rawHtsCode": "0801.19.01.20",
      "superior": null,
      "indent": "3",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0801.19.0140",
      "rawHtsCode": "0801.19.01.40",
      "superior": null,
      "indent": "3",
      "description": "Shelled",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0801.21.0000",
      "rawHtsCode": "0801.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "9.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0801.22.0000",
      "rawHtsCode": "0801.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Shelled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "9.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0801.31.0000",
      "rawHtsCode": "0801.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0801.32.0000",
      "rawHtsCode": "0801.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Shelled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0802",
      "rawHtsCode": "0802",
      "superior": null,
      "indent": "0",
      "description": "Other nuts, fresh or dried, whether or not shelled or peeled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0802.11.0000",
      "rawHtsCode": "0802.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "7.7¢/kg",
      "specialRate": "Free (A+,AU,BH, CL,CO,D,E,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "12.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.12.00",
      "rawHtsCode": "0802.12.00",
      "superior": null,
      "indent": "2",
      "description": "Shelled",
      "units": [],
      "generalRate": "24¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "40.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.12.0005",
      "rawHtsCode": "0802.12.00.05",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0802.12.0015",
      "rawHtsCode": "0802.12.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0802.21.0000",
      "rawHtsCode": "0802.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.22.0000",
      "rawHtsCode": "0802.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Shelled",
      "units": [
        "kg"
      ],
      "generalRate": "14.1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.31.0000",
      "rawHtsCode": "0802.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "7¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.32.0000",
      "rawHtsCode": "0802.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Shelled",
      "units": [
        "kg"
      ],
      "generalRate": "26.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.41.0000",
      "rawHtsCode": "0802.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0802.42.0000",
      "rawHtsCode": "0802.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Shelled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0802.51.0000",
      "rawHtsCode": "0802.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "0.9¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.52.0000",
      "rawHtsCode": "0802.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "Shelled",
      "units": [
        "kg"
      ],
      "generalRate": "1.9¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.61.0000",
      "rawHtsCode": "0802.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "1.3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.62.0000",
      "rawHtsCode": "0802.62.00.00",
      "superior": null,
      "indent": "2",
      "description": "Shelled",
      "units": [
        "kg"
      ],
      "generalRate": "5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.70.1000",
      "rawHtsCode": "0802.70.10.00",
      "superior": null,
      "indent": "2",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "1.3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.70.2000",
      "rawHtsCode": "0802.70.20.00",
      "superior": null,
      "indent": "2",
      "description": "Shelled",
      "units": [
        "kg"
      ],
      "generalRate": "5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.80.1000",
      "rawHtsCode": "0802.80.10.00",
      "superior": null,
      "indent": "2",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "1.3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.80.2000",
      "rawHtsCode": "0802.80.20.00",
      "superior": null,
      "indent": "2",
      "description": "Shelled",
      "units": [
        "kg"
      ],
      "generalRate": "5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.91",
      "rawHtsCode": "0802.91",
      "superior": null,
      "indent": "2",
      "description": "Pine nuts, in shell:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0802.91.1000",
      "rawHtsCode": "0802.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pignolia",
      "units": [
        "kg"
      ],
      "generalRate": "0.7¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.91.9000",
      "rawHtsCode": "0802.91.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.92",
      "rawHtsCode": "0802.92",
      "superior": null,
      "indent": "2",
      "description": "Pine nuts, shelled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0802.92.1000",
      "rawHtsCode": "0802.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pignolia",
      "units": [
        "kg"
      ],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.92.9000",
      "rawHtsCode": "0802.92.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.99",
      "rawHtsCode": "0802.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0802.99.1000",
      "rawHtsCode": "0802.99.10.00",
      "superior": null,
      "indent": "4",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.99.1500",
      "rawHtsCode": "0802.99.15.00",
      "superior": null,
      "indent": "4",
      "description": "Shelled",
      "units": [
        "kg"
      ],
      "generalRate": "17.6¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.99.8200",
      "rawHtsCode": "0802.99.82.00",
      "superior": null,
      "indent": "4",
      "description": "In shell",
      "units": [
        "kg"
      ],
      "generalRate": "1.3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0802.99.9800",
      "rawHtsCode": "0802.99.98.00",
      "superior": null,
      "indent": "4",
      "description": "Shelled",
      "units": [
        "kg"
      ],
      "generalRate": "5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0803",
      "rawHtsCode": "0803",
      "superior": null,
      "indent": "0",
      "description": "Bananas and plantains, fresh or dried:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0803.10",
      "rawHtsCode": "0803.10",
      "superior": null,
      "indent": "1",
      "description": "Plantains:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0803.10.1000",
      "rawHtsCode": "0803.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fresh",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0803.10.2000",
      "rawHtsCode": "0803.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Dried",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0803.90.00",
      "rawHtsCode": "0803.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "0803.90.0025",
      "rawHtsCode": "0803.90.00.25",
      "superior": null,
      "indent": "2",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0803.90.0035",
      "rawHtsCode": "0803.90.00.35",
      "superior": null,
      "indent": "3",
      "description": "Fresh",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0803.90.0045",
      "rawHtsCode": "0803.90.00.45",
      "superior": null,
      "indent": "3",
      "description": "Dried",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804",
      "rawHtsCode": "0804",
      "superior": null,
      "indent": "0",
      "description": "Dates, figs, pineapples, avocados, guavas, mangoes and mangosteens, fresh or dried:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.10",
      "rawHtsCode": "0804.10",
      "superior": null,
      "indent": "1",
      "description": "Dates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.10.20",
      "rawHtsCode": "0804.10.20",
      "superior": null,
      "indent": "3",
      "description": "Packed in units weighing (with the immediate container, if any) not more than 4.6 kg",
      "units": [],
      "generalRate": "13.2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "16.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.10.2010",
      "rawHtsCode": "0804.10.20.10",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.10.2090",
      "rawHtsCode": "0804.10.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.10.4000",
      "rawHtsCode": "0804.10.40.00",
      "superior": null,
      "indent": "4",
      "description": "With pits",
      "units": [
        "kg"
      ],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A,AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.10.6000",
      "rawHtsCode": "0804.10.60.00",
      "superior": null,
      "indent": "4",
      "description": "With pits removed",
      "units": [
        "kg"
      ],
      "generalRate": "2.8¢/kg",
      "specialRate": "Free (A,AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.10.8000",
      "rawHtsCode": "0804.10.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "29.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.20",
      "rawHtsCode": "0804.20",
      "superior": null,
      "indent": "1",
      "description": "Figs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.20.4000",
      "rawHtsCode": "0804.20.40.00",
      "superior": null,
      "indent": "3",
      "description": "In immediate containers weighing with their contents over 0.5 kg each",
      "units": [
        "kg"
      ],
      "generalRate": "7.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.20.6000",
      "rawHtsCode": "0804.20.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.20.8000",
      "rawHtsCode": "0804.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.30",
      "rawHtsCode": "0804.30",
      "superior": null,
      "indent": "1",
      "description": "Pineapples:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.30.2000",
      "rawHtsCode": "0804.30.20.00",
      "superior": null,
      "indent": "3",
      "description": "In bulk",
      "units": [
        "kg"
      ],
      "generalRate": "0.51¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "0.64¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.30.40",
      "rawHtsCode": "0804.30.40",
      "superior": null,
      "indent": "3",
      "description": "In crates or other packages",
      "units": [],
      "generalRate": "1.1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "2.11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.30.4010",
      "rawHtsCode": "0804.30.40.10",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.30.4090",
      "rawHtsCode": "0804.30.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.30.60",
      "rawHtsCode": "0804.30.60",
      "superior": null,
      "indent": "2",
      "description": "Reduced in size",
      "units": [],
      "generalRate": "0.44¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.30.6010",
      "rawHtsCode": "0804.30.60.10",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.30.6090",
      "rawHtsCode": "0804.30.60.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.40.00",
      "rawHtsCode": "0804.40.00",
      "superior": null,
      "indent": "1",
      "description": "Avocados",
      "units": [],
      "generalRate": "11.2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.40.0020",
      "rawHtsCode": "0804.40.00.20",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.40.0040",
      "rawHtsCode": "0804.40.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.40.0090",
      "rawHtsCode": "0804.40.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.50",
      "rawHtsCode": "0804.50",
      "superior": null,
      "indent": "1",
      "description": "Guavas, mangoes and mangosteens:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.50.40",
      "rawHtsCode": "0804.50.40",
      "superior": null,
      "indent": "3",
      "description": "If entered during the period from September 1, in any year, to the following May 31, inclusive",
      "units": [],
      "generalRate": "6.6¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.50.4045",
      "rawHtsCode": "0804.50.40.45",
      "superior": null,
      "indent": "5",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.50.4055",
      "rawHtsCode": "0804.50.40.55",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.50.4065",
      "rawHtsCode": "0804.50.40.65",
      "superior": null,
      "indent": "4",
      "description": "Mangosteens",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.50.4075",
      "rawHtsCode": "0804.50.40.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.50.60",
      "rawHtsCode": "0804.50.60",
      "superior": null,
      "indent": "3",
      "description": "If entered at any other time",
      "units": [],
      "generalRate": "6.6¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.50.6045",
      "rawHtsCode": "0804.50.60.45",
      "superior": null,
      "indent": "5",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.50.6055",
      "rawHtsCode": "0804.50.60.55",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.50.6065",
      "rawHtsCode": "0804.50.60.65",
      "superior": null,
      "indent": "4",
      "description": "Mangosteens",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.50.6075",
      "rawHtsCode": "0804.50.60.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.50.80",
      "rawHtsCode": "0804.50.80",
      "superior": null,
      "indent": "2",
      "description": "Dried",
      "units": [],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0804.50.8020",
      "rawHtsCode": "0804.50.80.20",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.50.8040",
      "rawHtsCode": "0804.50.80.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0804.50.8090",
      "rawHtsCode": "0804.50.80.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805",
      "rawHtsCode": "0805",
      "superior": null,
      "indent": "0",
      "description": "Citrus fruit, fresh or dried:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.10.00",
      "rawHtsCode": "0805.10.00",
      "superior": null,
      "indent": "1",
      "description": "Oranges",
      "units": [],
      "generalRate": "1.9¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0805.10.0020",
      "rawHtsCode": "0805.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Temple oranges",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.10.0050",
      "rawHtsCode": "0805.10.00.50",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.10.0060",
      "rawHtsCode": "0805.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.21.00",
      "rawHtsCode": "0805.21.00",
      "superior": null,
      "indent": "2",
      "description": "Mandarins (including tangerines and satsumas)",
      "units": [],
      "generalRate": "1.9¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg ",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0805.21.0010",
      "rawHtsCode": "0805.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Tangerines",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.21.0090",
      "rawHtsCode": "0805.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.22.0000",
      "rawHtsCode": "0805.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Clementines",
      "units": [
        "kg"
      ],
      "generalRate": "1.9¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg ",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0805.29.0000",
      "rawHtsCode": "0805.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.9¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg ",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0805.40",
      "rawHtsCode": "0805.40",
      "superior": null,
      "indent": "1",
      "description": "Grapefruit and pomelos:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.40.40",
      "rawHtsCode": "0805.40.40",
      "superior": null,
      "indent": "2",
      "description": "If entered during the period from August 1 to September 30, inclusive, in any year",
      "units": [],
      "generalRate": "1.9¢/kg",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0805.40.4010",
      "rawHtsCode": "0805.40.40.10",
      "superior": null,
      "indent": "3",
      "description": "Grapefruit",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.40.4090",
      "rawHtsCode": "0805.40.40.90",
      "superior": null,
      "indent": "3",
      "description": "Pomelo",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.40.6000",
      "rawHtsCode": "0805.40.60.00",
      "superior": null,
      "indent": "2",
      "description": "If entered during the month of October",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0805.40.80",
      "rawHtsCode": "0805.40.80",
      "superior": null,
      "indent": "2",
      "description": "If entered at any other time",
      "units": [],
      "generalRate": "2.5¢/kg",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0805.40.8010",
      "rawHtsCode": "0805.40.80.10",
      "superior": null,
      "indent": "3",
      "description": "Grapefruit",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.40.8090",
      "rawHtsCode": "0805.40.80.90",
      "superior": null,
      "indent": "3",
      "description": "Pomelo",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.50",
      "rawHtsCode": "0805.50",
      "superior": null,
      "indent": "1",
      "description": "Lemons (<i>Citrus limon, Citrus limonum</i>) and limes (<i>Citrus aurantifolia, Citrus latifolia</i>):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.50.20",
      "rawHtsCode": "0805.50.20",
      "superior": null,
      "indent": "2",
      "description": "Lemons",
      "units": [],
      "generalRate": "2.2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0805.50.2010",
      "rawHtsCode": "0805.50.20.10",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.50.2050",
      "rawHtsCode": "0805.50.20.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.50.30",
      "rawHtsCode": "0805.50.30",
      "superior": null,
      "indent": "3",
      "description": "Tahitian limes, Persian limes and other limes of the <i>Citrus latifolia</i> variety",
      "units": [
        "kg"
      ],
      "generalRate": "0.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0805.50.3020",
      "rawHtsCode": "0805.50.30.20",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.50.3040",
      "rawHtsCode": "0805.50.30.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0805.50.4000",
      "rawHtsCode": "0805.50.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0805.90.0100",
      "rawHtsCode": "0805.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other, including kumquats, citrons and bergamots",
      "units": [
        "kg"
      ],
      "generalRate": "0.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0806",
      "rawHtsCode": "0806",
      "superior": null,
      "indent": "0",
      "description": "Grapes, fresh or dried:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10",
      "rawHtsCode": "0806.10",
      "superior": null,
      "indent": "1",
      "description": "Fresh:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.20",
      "rawHtsCode": "0806.10.20",
      "superior": null,
      "indent": "2",
      "description": "If entered during the period from February 15 to March 31, inclusive, in any year",
      "units": [],
      "generalRate": "$1.13/m<sup>3</sup>",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "$8.83/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0806.10.2005",
      "rawHtsCode": "0806.10.20.05",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.2015",
      "rawHtsCode": "0806.10.20.15",
      "superior": null,
      "indent": "4",
      "description": "Red varieties",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.2025",
      "rawHtsCode": "0806.10.20.25",
      "superior": null,
      "indent": "4",
      "description": "White varieties",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.2035",
      "rawHtsCode": "0806.10.20.35",
      "superior": null,
      "indent": "4",
      "description": "Black varieties",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.2045",
      "rawHtsCode": "0806.10.20.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.40",
      "rawHtsCode": "0806.10.40",
      "superior": null,
      "indent": "2",
      "description": "If entered during the period from April 1 to June 30, inclusive, in any year",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$8.83/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0806.10.4005",
      "rawHtsCode": "0806.10.40.05",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.4015",
      "rawHtsCode": "0806.10.40.15",
      "superior": null,
      "indent": "4",
      "description": "Red varieties",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.4025",
      "rawHtsCode": "0806.10.40.25",
      "superior": null,
      "indent": "4",
      "description": "White varieties",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.4035",
      "rawHtsCode": "0806.10.40.35",
      "superior": null,
      "indent": "4",
      "description": "Black varieties",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.4045",
      "rawHtsCode": "0806.10.40.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.60",
      "rawHtsCode": "0806.10.60",
      "superior": null,
      "indent": "2",
      "description": "If entered at any other time",
      "units": [],
      "generalRate": "$1.80/m<sup>3</sup>",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "$8.83/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0806.10.6005",
      "rawHtsCode": "0806.10.60.05",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.6015",
      "rawHtsCode": "0806.10.60.15",
      "superior": null,
      "indent": "4",
      "description": "Red varieties",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.6025",
      "rawHtsCode": "0806.10.60.25",
      "superior": null,
      "indent": "4",
      "description": "White varieties",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.6035",
      "rawHtsCode": "0806.10.60.35",
      "superior": null,
      "indent": "4",
      "description": "Black varieties",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.10.6045",
      "rawHtsCode": "0806.10.60.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.20",
      "rawHtsCode": "0806.20",
      "superior": null,
      "indent": "1",
      "description": "Dried:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.20.10",
      "rawHtsCode": "0806.20.10",
      "superior": null,
      "indent": "3",
      "description": "Made from seedless grapes",
      "units": [],
      "generalRate": "1.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0806.20.1010",
      "rawHtsCode": "0806.20.10.10",
      "superior": null,
      "indent": "4",
      "description": "Currants",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.20.1020",
      "rawHtsCode": "0806.20.10.20",
      "superior": null,
      "indent": "4",
      "description": "Sultanas",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.20.1090",
      "rawHtsCode": "0806.20.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0806.20.2000",
      "rawHtsCode": "0806.20.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other raisins",
      "units": [
        "kg"
      ],
      "generalRate": "2.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0806.20.9000",
      "rawHtsCode": "0806.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other dried grapes",
      "units": [
        "kg"
      ],
      "generalRate": "3.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0807",
      "rawHtsCode": "0807",
      "superior": null,
      "indent": "0",
      "description": "Melons (including watermelons) and papayas (papaws), fresh:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.11",
      "rawHtsCode": "0807.11",
      "superior": null,
      "indent": "2",
      "description": "Watermelons:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.11.30",
      "rawHtsCode": "0807.11.30",
      "superior": null,
      "indent": "3",
      "description": "If entered during the period from December 1, in any year, to the following March 31, inclusive",
      "units": [],
      "generalRate": "9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 4.5% (JP)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0807.11.3020",
      "rawHtsCode": "0807.11.30.20",
      "superior": null,
      "indent": "6",
      "description": "Miniature type of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.11.3040",
      "rawHtsCode": "0807.11.30.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.11.3060",
      "rawHtsCode": "0807.11.30.60",
      "superior": null,
      "indent": "6",
      "description": "Miniature type of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.11.3080",
      "rawHtsCode": "0807.11.30.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.11.3090",
      "rawHtsCode": "0807.11.30.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.11.40",
      "rawHtsCode": "0807.11.40",
      "superior": null,
      "indent": "3",
      "description": "If entered at any other time",
      "units": [],
      "generalRate": "17%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0807.11.4020",
      "rawHtsCode": "0807.11.40.20",
      "superior": null,
      "indent": "6",
      "description": "Miniature type of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.11.4040",
      "rawHtsCode": "0807.11.40.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.11.4060",
      "rawHtsCode": "0807.11.40.60",
      "superior": null,
      "indent": "6",
      "description": "Miniature type of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.11.4080",
      "rawHtsCode": "0807.11.40.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.11.4090",
      "rawHtsCode": "0807.11.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.19",
      "rawHtsCode": "0807.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.19.1000",
      "rawHtsCode": "0807.19.10.00",
      "superior": null,
      "indent": "4",
      "description": "If entered during the period from August 1 to September 15, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "12.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 6.4% (JP)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0807.19.2000",
      "rawHtsCode": "0807.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "If entered at any other time",
      "units": [
        "kg"
      ],
      "generalRate": "29.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0807.19.5000",
      "rawHtsCode": "0807.19.50.00",
      "superior": null,
      "indent": "4",
      "description": "If entered during the period from December 1, in any year, to the following May 31, inclusive",
      "units": [
        "kg"
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0807.19.6000",
      "rawHtsCode": "0807.19.60.00",
      "superior": null,
      "indent": "4",
      "description": "If entered at any other time",
      "units": [
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.15% (JP)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0807.19.70",
      "rawHtsCode": "0807.19.70",
      "superior": null,
      "indent": "4",
      "description": "If entered during the period from December 1, in any year, to the following May 31, inclusive",
      "units": [
        "kg"
      ],
      "generalRate": "5.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)2.7% (JP)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0807.19.7020",
      "rawHtsCode": "0807.19.70.20",
      "superior": null,
      "indent": "5",
      "description": "Honeydew melons",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.19.7040",
      "rawHtsCode": "0807.19.70.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.19.80",
      "rawHtsCode": "0807.19.80",
      "superior": null,
      "indent": "4",
      "description": "If entered at any other time",
      "units": [
        "kg"
      ],
      "generalRate": "28%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 14% (JP)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0807.19.8020",
      "rawHtsCode": "0807.19.80.20",
      "superior": null,
      "indent": "5",
      "description": "Honeydew melons",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.19.8040",
      "rawHtsCode": "0807.19.80.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0807.20.0000",
      "rawHtsCode": "0807.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Papayas (papaws)",
      "units": [
        "kg"
      ],
      "generalRate": "5.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0808",
      "rawHtsCode": "0808",
      "superior": null,
      "indent": "0",
      "description": "Apples, pears and quinces, fresh:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.10.00",
      "rawHtsCode": "0808.10.00",
      "superior": null,
      "indent": "1",
      "description": "Apples",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0808.10.0030",
      "rawHtsCode": "0808.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Valued not over 22¢ per kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.10.0045",
      "rawHtsCode": "0808.10.00.45",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.10.0065",
      "rawHtsCode": "0808.10.00.65",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.30",
      "rawHtsCode": "0808.30",
      "superior": null,
      "indent": "1",
      "description": "Pears:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.30.20",
      "rawHtsCode": "0808.30.20",
      "superior": null,
      "indent": "2",
      "description": "If entered during the period from April 1 to June 30, inclusive, in any year",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0808.30.2015",
      "rawHtsCode": "0808.30.20.15",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.30.2035",
      "rawHtsCode": "0808.30.20.35",
      "superior": null,
      "indent": "4",
      "description": "Asian pears (<i>Pyrus pyrifolia</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.30.2045",
      "rawHtsCode": "0808.30.20.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.30.40",
      "rawHtsCode": "0808.30.40",
      "superior": null,
      "indent": "2",
      "description": "If entered at any other time",
      "units": [],
      "generalRate": "0.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0808.30.4015",
      "rawHtsCode": "0808.30.40.15",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.30.4035",
      "rawHtsCode": "0808.30.40.35",
      "superior": null,
      "indent": "4",
      "description": "Asian pears (<i>Pyrus pyrifolia</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.30.4045",
      "rawHtsCode": "0808.30.40.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.40",
      "rawHtsCode": "0808.40",
      "superior": null,
      "indent": "1",
      "description": "Quinces:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.40.20",
      "rawHtsCode": "0808.40.20",
      "superior": null,
      "indent": "2",
      "description": "If entered during the period from April 1 to June 30, inclusive, in any year",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0808.40.2015",
      "rawHtsCode": "0808.40.20.15",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.40.2025",
      "rawHtsCode": "0808.40.20.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.40.40",
      "rawHtsCode": "0808.40.40",
      "superior": null,
      "indent": "2",
      "description": "If entered at any other time",
      "units": [],
      "generalRate": "0.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0808.40.4015",
      "rawHtsCode": "0808.40.40.15",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0808.40.4025",
      "rawHtsCode": "0808.40.40.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0809",
      "rawHtsCode": "0809",
      "superior": null,
      "indent": "0",
      "description": "Apricots, cherries, peaches (including nectarines), plums (including prune plums) and sloes, fresh:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0809.10.0000",
      "rawHtsCode": "0809.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Apricots",
      "units": [
        "kg"
      ],
      "generalRate": "0.2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0809.21.0000",
      "rawHtsCode": "0809.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sour cherries (<i>Prunus cerasus</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0809.29.0000",
      "rawHtsCode": "0809.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0809.30",
      "rawHtsCode": "0809.30",
      "superior": null,
      "indent": "1",
      "description": "Peaches, including nectarines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0809.30.2000",
      "rawHtsCode": "0809.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "If entered during the period from June 1 to November 30, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "0.2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0809.30.40",
      "rawHtsCode": "0809.30.40",
      "superior": null,
      "indent": "2",
      "description": "If entered at any other time",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0809.30.4010",
      "rawHtsCode": "0809.30.40.10",
      "superior": null,
      "indent": "3",
      "description": "Peaches",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0809.30.4090",
      "rawHtsCode": "0809.30.40.90",
      "superior": null,
      "indent": "3",
      "description": "Nectarines",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0809.40",
      "rawHtsCode": "0809.40",
      "superior": null,
      "indent": "1",
      "description": "Plums (including prune plums) and sloes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0809.40.2000",
      "rawHtsCode": "0809.40.20.00",
      "superior": null,
      "indent": "2",
      "description": "If entered during the period from January 1 to May 31, inclusive, in any year",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.   "
      ],
      "flags": []
    },
    {
      "htsCode": "0809.40.4000",
      "rawHtsCode": "0809.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "If entered at any other time",
      "units": [
        "kg"
      ],
      "generalRate": "0.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0810",
      "rawHtsCode": "0810",
      "superior": null,
      "indent": "0",
      "description": "Other fruit, fresh:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.10",
      "rawHtsCode": "0810.10",
      "superior": null,
      "indent": "1",
      "description": "Strawberries:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.10.20",
      "rawHtsCode": "0810.10.20",
      "superior": null,
      "indent": "2",
      "description": "If entered during the period from June 15 to September 15, inclusive, in any year",
      "units": [],
      "generalRate": "0.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0810.10.2020",
      "rawHtsCode": "0810.10.20.20",
      "superior": null,
      "indent": "4",
      "description": "Of a kind for processing as described in statistical note 3 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.10.2040",
      "rawHtsCode": "0810.10.20.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.10.2060",
      "rawHtsCode": "0810.10.20.60",
      "superior": null,
      "indent": "4",
      "description": "Of a kind for processing as described in statistical note 3 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.10.2080",
      "rawHtsCode": "0810.10.20.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.10.40",
      "rawHtsCode": "0810.10.40",
      "superior": null,
      "indent": "2",
      "description": "If entered at any other time",
      "units": [],
      "generalRate": "1.1¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0810.10.4020",
      "rawHtsCode": "0810.10.40.20",
      "superior": null,
      "indent": "4",
      "description": "Of a kind for processing as described in statistical note 3 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.10.4040",
      "rawHtsCode": "0810.10.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.10.4060",
      "rawHtsCode": "0810.10.40.60",
      "superior": null,
      "indent": "4",
      "description": "Of a kind for processing as described in statistical note 3 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.10.4080",
      "rawHtsCode": "0810.10.40.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.20",
      "rawHtsCode": "0810.20",
      "superior": null,
      "indent": "1",
      "description": "Raspberries, blackberries, mulberries and loganberries:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.20.10",
      "rawHtsCode": "0810.20.10",
      "superior": null,
      "indent": "2",
      "description": "Raspberries and loganberries entered during the period from September 1 in any year to June 30 of the following year",
      "units": [],
      "generalRate": "0.18¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0810.20.1023",
      "rawHtsCode": "0810.20.10.23",
      "superior": null,
      "indent": "5",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.20.1028",
      "rawHtsCode": "0810.20.10.28",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.20.1030",
      "rawHtsCode": "0810.20.10.30",
      "superior": null,
      "indent": "5",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.20.1035",
      "rawHtsCode": "0810.20.10.35",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.20.1040",
      "rawHtsCode": "0810.20.10.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.20.90",
      "rawHtsCode": "0810.20.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0810.20.9022",
      "rawHtsCode": "0810.20.90.22",
      "superior": null,
      "indent": "4",
      "description": "Raspberries packed in units weighing (with the immediate container, if any) not more than 5.0 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.20.9024",
      "rawHtsCode": "0810.20.90.24",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.20.9045",
      "rawHtsCode": "0810.20.90.45",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.20.9060",
      "rawHtsCode": "0810.20.90.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.20.9090",
      "rawHtsCode": "0810.20.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.30.0000",
      "rawHtsCode": "0810.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Black, white or red currants and gooseberries (other than kiwifruit)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0810.40.00",
      "rawHtsCode": "0810.40.00",
      "superior": null,
      "indent": "1",
      "description": "Cranberries, blueberries and other fruits of the genus <i>Vaccinium</i>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0810.40.0024",
      "rawHtsCode": "0810.40.00.24",
      "superior": null,
      "indent": "3",
      "description": "Wild",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.40.0026",
      "rawHtsCode": "0810.40.00.26",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.40.0029",
      "rawHtsCode": "0810.40.00.29",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.40.0030",
      "rawHtsCode": "0810.40.00.30",
      "superior": null,
      "indent": "2",
      "description": "Cranberries",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.40.0040",
      "rawHtsCode": "0810.40.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.50.00",
      "rawHtsCode": "0810.50.00",
      "superior": null,
      "indent": "1",
      "description": "Kiwifruit",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0810.50.0010",
      "rawHtsCode": "0810.50.00.10",
      "superior": null,
      "indent": "2",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.50.0090",
      "rawHtsCode": "0810.50.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.60.0000",
      "rawHtsCode": "0810.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Durians",
      "units": [
        "kg"
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0810.70.0000",
      "rawHtsCode": "0810.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Persimmons",
      "units": [
        "kg"
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0810.90",
      "rawHtsCode": "0810.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.90.27",
      "rawHtsCode": "0810.90.27",
      "superior": null,
      "indent": "2",
      "description": "Other berries; tamarinds",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0810.90.2730",
      "rawHtsCode": "0810.90.27.30",
      "superior": null,
      "indent": "3",
      "description": "Tamarinds",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.90.2760",
      "rawHtsCode": "0810.90.27.60",
      "superior": null,
      "indent": "3",
      "description": "Berries",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.90.46",
      "rawHtsCode": "0810.90.46",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0810.90.4620",
      "rawHtsCode": "0810.90.46.20",
      "superior": null,
      "indent": "3",
      "description": "Cactus pears",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.90.4630",
      "rawHtsCode": "0810.90.46.30",
      "superior": null,
      "indent": "3",
      "description": "Dragon fruit",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.90.4640",
      "rawHtsCode": "0810.90.46.40",
      "superior": null,
      "indent": "3",
      "description": "Jackfruit",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.90.4650",
      "rawHtsCode": "0810.90.46.50",
      "superior": null,
      "indent": "3",
      "description": "Lychee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.90.4660",
      "rawHtsCode": "0810.90.46.60",
      "superior": null,
      "indent": "3",
      "description": "Pomegranates",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.90.4670",
      "rawHtsCode": "0810.90.46.70",
      "superior": null,
      "indent": "3",
      "description": "Rambutan",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.90.4675",
      "rawHtsCode": "0810.90.46.75",
      "superior": null,
      "indent": "3",
      "description": "Tomatillos",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0810.90.4680",
      "rawHtsCode": "0810.90.46.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811",
      "rawHtsCode": "0811",
      "superior": null,
      "indent": "0",
      "description": "Fruit and nuts, uncooked or cooked by steaming or boiling in water, frozen, whether or not containing added sugar or other sweetening matter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.10.00",
      "rawHtsCode": "0811.10.00",
      "superior": null,
      "indent": "1",
      "description": "Strawberries",
      "units": [],
      "generalRate": "11.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0811.10.0020",
      "rawHtsCode": "0811.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "In immediate containers each holding not more than 1.2 liters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.10.0050",
      "rawHtsCode": "0811.10.00.50",
      "superior": null,
      "indent": "4",
      "description": "Not more than 25 percent by weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.10.0060",
      "rawHtsCode": "0811.10.00.60",
      "superior": null,
      "indent": "4",
      "description": "More than 25 percent by weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.10.0075",
      "rawHtsCode": "0811.10.00.75",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.10.0085",
      "rawHtsCode": "0811.10.00.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.20",
      "rawHtsCode": "0811.20",
      "superior": null,
      "indent": "1",
      "description": "Raspberries, blackberries, mulberries, loganberries, black, white or red currants and gooseberries (other than kiwi fruit):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.20.20",
      "rawHtsCode": "0811.20.20",
      "superior": null,
      "indent": "2",
      "description": "Raspberries, loganberries, black currants and gooseberries (other than kiwi fruit)",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0811.20.2025",
      "rawHtsCode": "0811.20.20.25",
      "superior": null,
      "indent": "4",
      "description": "Red Raspberries",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.20.2035",
      "rawHtsCode": "0811.20.20.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.20.2040",
      "rawHtsCode": "0811.20.20.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.20.40",
      "rawHtsCode": "0811.20.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0811.20.4030",
      "rawHtsCode": "0811.20.40.30",
      "superior": null,
      "indent": "3",
      "description": "Blackberries",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.20.4090",
      "rawHtsCode": "0811.20.40.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90",
      "rawHtsCode": "0811.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.1000",
      "rawHtsCode": "0811.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Bananas and plantains",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0811.90.20",
      "rawHtsCode": "0811.90.20",
      "superior": null,
      "indent": "2",
      "description": "Blueberries",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0811.90.2025",
      "rawHtsCode": "0811.90.20.25",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.2027",
      "rawHtsCode": "0811.90.20.27",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.2030",
      "rawHtsCode": "0811.90.20.30",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.2040",
      "rawHtsCode": "0811.90.20.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.2200",
      "rawHtsCode": "0811.90.22.00",
      "superior": null,
      "indent": "2",
      "description": "Boysenberries",
      "units": [
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0811.90.2500",
      "rawHtsCode": "0811.90.25.00",
      "superior": null,
      "indent": "2",
      "description": "Cashew apples, mameyes colorados, sapodillas, soursops and sweetsops",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0811.90.3000",
      "rawHtsCode": "0811.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Coconut meat",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0811.90.3500",
      "rawHtsCode": "0811.90.35.00",
      "superior": null,
      "indent": "2",
      "description": "Cranberries (<i>Vaccinium macrocarpum</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0811.90.4000",
      "rawHtsCode": "0811.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Papayas",
      "units": [
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0811.90.50",
      "rawHtsCode": "0811.90.50",
      "superior": null,
      "indent": "2",
      "description": "Pineapples",
      "units": [],
      "generalRate": "0.25¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0811.90.5010",
      "rawHtsCode": "0811.90.50.10",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.5090",
      "rawHtsCode": "0811.90.50.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.52",
      "rawHtsCode": "0811.90.52",
      "superior": null,
      "indent": "2",
      "description": "Mangoes",
      "units": [],
      "generalRate": "10.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0811.90.5210",
      "rawHtsCode": "0811.90.52.10",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.5290",
      "rawHtsCode": "0811.90.52.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.5500",
      "rawHtsCode": "0811.90.55.00",
      "superior": null,
      "indent": "2",
      "description": "Melons",
      "units": [
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0811.90.80",
      "rawHtsCode": "0811.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "14.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0811.90.8040",
      "rawHtsCode": "0811.90.80.40",
      "superior": null,
      "indent": "4",
      "description": "Sweet varieties",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.8060",
      "rawHtsCode": "0811.90.80.60",
      "superior": null,
      "indent": "4",
      "description": "Tart varieties",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.8085",
      "rawHtsCode": "0811.90.80.85",
      "superior": null,
      "indent": "3",
      "description": "Frozen mixes only of combinations of strawberries, blueberries, red raspberries or blackberries",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.8090",
      "rawHtsCode": "0811.90.80.90",
      "superior": null,
      "indent": "3",
      "description": "Peaches",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0811.90.8097",
      "rawHtsCode": "0811.90.80.97",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0812",
      "rawHtsCode": "0812",
      "superior": null,
      "indent": "0",
      "description": "Fruit and nuts provisionally preserved, but unsuitable in that state for immediate consumption:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0812.10.0000",
      "rawHtsCode": "0812.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cherries",
      "units": [
        "kg"
      ],
      "generalRate": "13.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0812.90",
      "rawHtsCode": "0812.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0812.90.1000",
      "rawHtsCode": "0812.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Mixtures of two or more fruits",
      "units": [
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0812.90.2000",
      "rawHtsCode": "0812.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Citrus",
      "units": [
        "kg"
      ],
      "generalRate": "1.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0812.90.3000",
      "rawHtsCode": "0812.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Figs",
      "units": [
        "kg"
      ],
      "generalRate": "2.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0812.90.4000",
      "rawHtsCode": "0812.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Pineapples",
      "units": [
        "kg"
      ],
      "generalRate": "0.25¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0812.90.5000",
      "rawHtsCode": "0812.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Strawberries",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0812.90.9000",
      "rawHtsCode": "0812.90.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813",
      "rawHtsCode": "0813",
      "superior": null,
      "indent": "0",
      "description": "Fruit, dried, other than that of headings 0801 to 0806; mixtures of nuts or dried fruits of this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0813.10.0000",
      "rawHtsCode": "0813.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Apricots",
      "units": [
        "kg"
      ],
      "generalRate": "1.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813.20",
      "rawHtsCode": "0813.20",
      "superior": null,
      "indent": "1",
      "description": "Prunes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0813.20.1000",
      "rawHtsCode": "0813.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Soaked in brine and dried",
      "units": [
        "kg"
      ],
      "generalRate": "2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813.20.20",
      "rawHtsCode": "0813.20.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813.20.2010",
      "rawHtsCode": "0813.20.20.10",
      "superior": null,
      "indent": "3",
      "description": "Dried, whether or not pitted",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0813.20.2090",
      "rawHtsCode": "0813.20.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0813.30.0000",
      "rawHtsCode": "0813.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Apples",
      "units": [
        "kg"
      ],
      "generalRate": "0.74¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813.40",
      "rawHtsCode": "0813.40",
      "superior": null,
      "indent": "1",
      "description": "Other fruit:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0813.40.1000",
      "rawHtsCode": "0813.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Papayas",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813.40.1500",
      "rawHtsCode": "0813.40.15.00",
      "superior": null,
      "indent": "3",
      "description": "Barberries",
      "units": [
        "kg"
      ],
      "generalRate": "3.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813.40.20",
      "rawHtsCode": "0813.40.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813.40.2010",
      "rawHtsCode": "0813.40.20.10",
      "superior": null,
      "indent": "4",
      "description": "Wild blueberries",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0813.40.2020",
      "rawHtsCode": "0813.40.20.20",
      "superior": null,
      "indent": "4",
      "description": "Cultivated (including highbush) blueberries",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0813.40.2060",
      "rawHtsCode": "0813.40.20.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0813.40.30",
      "rawHtsCode": "0813.40.30",
      "superior": null,
      "indent": "2",
      "description": "Cherries",
      "units": [],
      "generalRate": "10.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813.40.3010",
      "rawHtsCode": "0813.40.30.10",
      "superior": null,
      "indent": "3",
      "description": "Tart varieties<i>(Prunus cerasus)</i>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0813.40.3090",
      "rawHtsCode": "0813.40.30.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0813.40.4000",
      "rawHtsCode": "0813.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "Peaches",
      "units": [
        "kg"
      ],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813.40.8000",
      "rawHtsCode": "0813.40.80.00",
      "superior": null,
      "indent": "2",
      "description": "Tamarinds",
      "units": [
        "kg"
      ],
      "generalRate": "6.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813.40.9000",
      "rawHtsCode": "0813.40.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813.50.00",
      "rawHtsCode": "0813.50.00",
      "superior": null,
      "indent": "1",
      "description": "Mixtures of nuts or dried fruits of this chapter",
      "units": [],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0813.50.0020",
      "rawHtsCode": "0813.50.00.20",
      "superior": null,
      "indent": "2",
      "description": "Containing only fruit",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0813.50.0040",
      "rawHtsCode": "0813.50.00.40",
      "superior": null,
      "indent": "2",
      "description": "Containing only nuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0813.50.0060",
      "rawHtsCode": "0813.50.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0814.00",
      "rawHtsCode": "0814.00",
      "superior": null,
      "indent": "0",
      "description": "Peel of citrus fruit or melons (including watermelons), fresh, frozen, dried or provisionally preserved in brine, in sulfur water or in other preservative solutions:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0814.00.1000",
      "rawHtsCode": "0814.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Orange or citron",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "0814.00.4000",
      "rawHtsCode": "0814.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Lime",
      "units": [
        "kg"
      ],
      "generalRate": "1.6¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0814.00.8000",
      "rawHtsCode": "0814.00.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0901",
      "rawHtsCode": "0901",
      "superior": null,
      "indent": "0",
      "description": "Coffee, whether or not roasted or decaffeinated; coffee husks and skins; coffee substitutes containing coffee in any proportion:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.11.00",
      "rawHtsCode": "0901.11.00",
      "superior": null,
      "indent": "2",
      "description": "Not decaffeinated",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0901.11.0015",
      "rawHtsCode": "0901.11.00.15",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.11.0025",
      "rawHtsCode": "0901.11.00.25",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.11.0035",
      "rawHtsCode": "0901.11.00.35",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.11.0040",
      "rawHtsCode": "0901.11.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.11.0050",
      "rawHtsCode": "0901.11.00.50",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.11.0065",
      "rawHtsCode": "0901.11.00.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.12.00",
      "rawHtsCode": "0901.12.00",
      "superior": null,
      "indent": "2",
      "description": "Decaffeinated",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0901.12.0020",
      "rawHtsCode": "0901.12.00.20",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.12.0035",
      "rawHtsCode": "0901.12.00.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.12.0040",
      "rawHtsCode": "0901.12.00.40",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.12.0055",
      "rawHtsCode": "0901.12.00.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.12.0060",
      "rawHtsCode": "0901.12.00.60",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.12.0075",
      "rawHtsCode": "0901.12.00.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.21.00",
      "rawHtsCode": "0901.21.00",
      "superior": null,
      "indent": "2",
      "description": "Not decaffeinated",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0901.21.0015",
      "rawHtsCode": "0901.21.00.15",
      "superior": null,
      "indent": "5",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.21.0020",
      "rawHtsCode": "0901.21.00.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.21.0025",
      "rawHtsCode": "0901.21.00.25",
      "superior": null,
      "indent": "5",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.21.0029",
      "rawHtsCode": "0901.21.00.29",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.21.0040",
      "rawHtsCode": "0901.21.00.40",
      "superior": null,
      "indent": "5",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.21.0049",
      "rawHtsCode": "0901.21.00.49",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.21.0055",
      "rawHtsCode": "0901.21.00.55",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.21.0065",
      "rawHtsCode": "0901.21.00.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.22.00",
      "rawHtsCode": "0901.22.00",
      "superior": null,
      "indent": "2",
      "description": "Decaffeinated",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0901.22.0035",
      "rawHtsCode": "0901.22.00.35",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.22.0040",
      "rawHtsCode": "0901.22.00.40",
      "superior": null,
      "indent": "5",
      "description": "Arabica",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.22.0050",
      "rawHtsCode": "0901.22.00.50",
      "superior": null,
      "indent": "5",
      "description": "Robusta",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.22.0055",
      "rawHtsCode": "0901.22.00.55",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.22.0065",
      "rawHtsCode": "0901.22.00.65",
      "superior": null,
      "indent": "5",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.22.0070",
      "rawHtsCode": "0901.22.00.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.22.0075",
      "rawHtsCode": "0901.22.00.75",
      "superior": null,
      "indent": "5",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.22.0080",
      "rawHtsCode": "0901.22.00.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.22.0090",
      "rawHtsCode": "0901.22.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.90",
      "rawHtsCode": "0901.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0901.90.1000",
      "rawHtsCode": "0901.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Coffee husks and skins",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0901.90.2000",
      "rawHtsCode": "0901.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Coffee substitutes containing coffee",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0902",
      "rawHtsCode": "0902",
      "superior": null,
      "indent": "0",
      "description": "Tea, whether or not flavored:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0902.10",
      "rawHtsCode": "0902.10",
      "superior": null,
      "indent": "1",
      "description": "Green tea (not fermented) in immediate packings of a content not exceeding 3 kg:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0902.10.10",
      "rawHtsCode": "0902.10.10",
      "superior": null,
      "indent": "2",
      "description": "Flavored",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.2% (JP)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0902.10.1015",
      "rawHtsCode": "0902.10.10.15",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0902.10.1050",
      "rawHtsCode": "0902.10.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0902.10.90",
      "rawHtsCode": "0902.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0902.10.9015",
      "rawHtsCode": "0902.10.90.15",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0902.10.9050",
      "rawHtsCode": "0902.10.90.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0902.20",
      "rawHtsCode": "0902.20",
      "superior": null,
      "indent": "1",
      "description": "Other green tea (not fermented):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0902.20.1000",
      "rawHtsCode": "0902.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Flavored",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.2% (JP)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0902.20.90",
      "rawHtsCode": "0902.20.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0902.20.9015",
      "rawHtsCode": "0902.20.90.15",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0902.20.9050",
      "rawHtsCode": "0902.20.90.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0902.30.00",
      "rawHtsCode": "0902.30.00",
      "superior": null,
      "indent": "1",
      "description": "Black tea (fermented) and partly fermented tea, in immediate packings of a content not exceeding 3 kg",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0902.30.0015",
      "rawHtsCode": "0902.30.00.15",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0902.30.0050",
      "rawHtsCode": "0902.30.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0902.30.0090",
      "rawHtsCode": "0902.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0902.40.0000",
      "rawHtsCode": "0902.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other black tea (fermented) and other partly fermented tea",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0903.00.0000",
      "rawHtsCode": "0903.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Maté",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0904",
      "rawHtsCode": "0904",
      "superior": null,
      "indent": "0",
      "description": "Pepper of the genus <i>Piper</i>; dried or crushed or ground fruits of the genus <i>Capsicum</i> (peppers) or of the genus <i>Pimenta</i> (e.g., allspice): <i></i><i> </i>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0904.11.00",
      "rawHtsCode": "0904.11.00",
      "superior": null,
      "indent": "2",
      "description": "Neither crushed nor ground",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0904.11.0020",
      "rawHtsCode": "0904.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Black",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0904.11.0040",
      "rawHtsCode": "0904.11.00.40",
      "superior": null,
      "indent": "3",
      "description": "White",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0904.12.0000",
      "rawHtsCode": "0904.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crushed or ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0904.21",
      "rawHtsCode": "0904.21",
      "superior": null,
      "indent": "2",
      "description": "Dried, neither crushed nor ground:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0904.21.2000",
      "rawHtsCode": "0904.21.20.00",
      "superior": null,
      "indent": "4",
      "description": "Paprika",
      "units": [
        "kg"
      ],
      "generalRate": "3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0904.21.4000",
      "rawHtsCode": "0904.21.40.00",
      "superior": null,
      "indent": "4",
      "description": "Anaheim and ancho pepper",
      "units": [
        "kg"
      ],
      "generalRate": "5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0904.21.60",
      "rawHtsCode": "0904.21.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0904.21.6010",
      "rawHtsCode": "0904.21.60.10",
      "superior": null,
      "indent": "5",
      "description": "Bell peppers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0904.21.6020",
      "rawHtsCode": "0904.21.60.20",
      "superior": null,
      "indent": "5",
      "description": "Jalapeno peppers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0904.21.6090",
      "rawHtsCode": "0904.21.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0904.21.8000",
      "rawHtsCode": "0904.21.80.00",
      "superior": null,
      "indent": "3",
      "description": "Of the genus <i>Pimenta</i> (including allspice)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0904.22",
      "rawHtsCode": "0904.22",
      "superior": null,
      "indent": "2",
      "description": "Crushed or ground:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0904.22.2000",
      "rawHtsCode": "0904.22.20.00",
      "superior": null,
      "indent": "4",
      "description": "Paprika",
      "units": [
        "kg"
      ],
      "generalRate": "3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0904.22.4000",
      "rawHtsCode": "0904.22.40.00",
      "superior": null,
      "indent": "4",
      "description": "Anaheim and ancho pepper",
      "units": [
        "kg"
      ],
      "generalRate": "5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0904.22.7300",
      "rawHtsCode": "0904.22.73.00",
      "superior": null,
      "indent": "4",
      "description": "Mixtures of mashed or macerated hot red peppers and salt",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "17.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0904.22.7600",
      "rawHtsCode": "0904.22.76.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0904.22.8000",
      "rawHtsCode": "0904.22.80.00",
      "superior": null,
      "indent": "3",
      "description": "Of the genus <i>Pimenta</i> (including allspice)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0905",
      "rawHtsCode": "0905",
      "superior": null,
      "indent": "0",
      "description": "Vanilla:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0905.10.0000",
      "rawHtsCode": "0905.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Neither crushed nor ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "66¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0905.20.0000",
      "rawHtsCode": "0905.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Crushed or ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "66¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0906",
      "rawHtsCode": "0906",
      "superior": null,
      "indent": "0",
      "description": "Cinnamon and cinnamon-tree flowers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0906.11.0000",
      "rawHtsCode": "0906.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cinnamon (<i>Cinnamomum zeylanicum Blume</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0906.19.0000",
      "rawHtsCode": "0906.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0906.20.0000",
      "rawHtsCode": "0906.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Crushed or ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0907",
      "rawHtsCode": "0907",
      "superior": null,
      "indent": "0",
      "description": "Cloves (whole fruit, cloves and stems):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0907.10.0000",
      "rawHtsCode": "0907.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Neither crushed nor ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0907.20.0000",
      "rawHtsCode": "0907.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Crushed or ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0908",
      "rawHtsCode": "0908",
      "superior": null,
      "indent": "0",
      "description": "Nutmeg, mace and cardamoms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0908.11.0000",
      "rawHtsCode": "0908.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Neither crushed nor ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0908.12.0000",
      "rawHtsCode": "0908.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crushed or ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0908.21.0000",
      "rawHtsCode": "0908.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Neither crushed nor ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0908.22",
      "rawHtsCode": "0908.22",
      "superior": null,
      "indent": "2",
      "description": "Crushed or ground:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0908.22.2000",
      "rawHtsCode": "0908.22.20.00",
      "superior": null,
      "indent": "3",
      "description": "Bombay or wild mace, ground",
      "units": [
        "kg"
      ],
      "generalRate": "7.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "49¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0908.22.4000",
      "rawHtsCode": "0908.22.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0908.31.0000",
      "rawHtsCode": "0908.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Neither crushed nor ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0908.32.0000",
      "rawHtsCode": "0908.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crushed or ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0909",
      "rawHtsCode": "0909",
      "superior": null,
      "indent": "0",
      "description": "Seeds of anise, badian, fennel, coriander, cumin or caraway; juniper berries:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0909.21.0000",
      "rawHtsCode": "0909.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Neither crushed nor ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0909.22.0000",
      "rawHtsCode": "0909.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crushed or ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0909.31.0000",
      "rawHtsCode": "0909.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Neither crushed nor ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0909.32.0000",
      "rawHtsCode": "0909.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crushed or ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0909.61.0000",
      "rawHtsCode": "0909.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Neither crushed nor ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0909.62.0000",
      "rawHtsCode": "0909.62.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crushed or ground",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0910",
      "rawHtsCode": "0910",
      "superior": null,
      "indent": "0",
      "description": "Ginger, saffron, turmeric (curcuma), thyme, bay leaves, curry and other spices:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0910.11.00",
      "rawHtsCode": "0910.11.00",
      "superior": null,
      "indent": "2",
      "description": "Neither crushed nor ground",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0910.11.0010",
      "rawHtsCode": "0910.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0910.11.0015",
      "rawHtsCode": "0910.11.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0910.12.0000",
      "rawHtsCode": "0910.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crushed or ground",
      "units": [
        "kg"
      ],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0910.20.0000",
      "rawHtsCode": "0910.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Saffron",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0910.30.0000",
      "rawHtsCode": "0910.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Turmeric (curcuma)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0910.91.0000",
      "rawHtsCode": "0910.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mixtures referred to in note 1(b) to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0910.99",
      "rawHtsCode": "0910.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "0910.99.0500",
      "rawHtsCode": "0910.99.05.00",
      "superior": null,
      "indent": "4",
      "description": "Crude or not manufactured",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0910.99.0600",
      "rawHtsCode": "0910.99.06.00",
      "superior": null,
      "indent": "5",
      "description": "Thyme",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0910.99.0700",
      "rawHtsCode": "0910.99.07.00",
      "superior": null,
      "indent": "5",
      "description": "Bay leaves",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0910.99.1000",
      "rawHtsCode": "0910.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Curry",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0910.99.2000",
      "rawHtsCode": "0910.99.20.00",
      "superior": null,
      "indent": "4",
      "description": "Crude or not manufactured",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0910.99.4000",
      "rawHtsCode": "0910.99.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "0910.99.5000",
      "rawHtsCode": "0910.99.50.00",
      "superior": null,
      "indent": "4",
      "description": "Dill",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "0910.99.6000",
      "rawHtsCode": "0910.99.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1001",
      "rawHtsCode": "1001",
      "superior": null,
      "indent": "0",
      "description": "Wheat and meslin:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.11.0000",
      "rawHtsCode": "1001.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Seed",
      "units": [
        "kg"
      ],
      "generalRate": "0.65¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1001.19.00",
      "rawHtsCode": "1001.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "0.65¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1001.19.0025",
      "rawHtsCode": "1001.19.00.25",
      "superior": null,
      "indent": "3",
      "description": "Certified Organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.19.0051",
      "rawHtsCode": "1001.19.00.51",
      "superior": null,
      "indent": "4",
      "description": "Grade 1",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.19.0053",
      "rawHtsCode": "1001.19.00.53",
      "superior": null,
      "indent": "4",
      "description": " Grade 2",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.19.0069",
      "rawHtsCode": "1001.19.00.69",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.91.0000",
      "rawHtsCode": "1001.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Seed",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1001.99.00",
      "rawHtsCode": "1001.99.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "0.35¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1001.99.0005",
      "rawHtsCode": "1001.99.00.05",
      "superior": null,
      "indent": "3",
      "description": "Canadian western extra strong hard red spring (CWES/HRS) wheat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0007",
      "rawHtsCode": "1001.99.00.07",
      "superior": null,
      "indent": "5",
      "description": "Red spring wheat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0009",
      "rawHtsCode": "1001.99.00.09",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0010",
      "rawHtsCode": "1001.99.00.10",
      "superior": null,
      "indent": "7",
      "description": "Having a specified protein content not exceeding 12.9% by weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0017",
      "rawHtsCode": "1001.99.00.17",
      "superior": null,
      "indent": "7",
      "description": "Having a specified protein content exceeding 12.9% but not exceeding 13.9% by weight.",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0018",
      "rawHtsCode": "1001.99.00.18",
      "superior": null,
      "indent": "7",
      "description": "Having a specified protein content exceeding 13.9% by weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0027",
      "rawHtsCode": "1001.99.00.27",
      "superior": null,
      "indent": "7",
      "description": "Having a specified protein content not exceeding 12.9% by weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0030",
      "rawHtsCode": "1001.99.00.30",
      "superior": null,
      "indent": "7",
      "description": "Having a specified protein content exceeding 12.9% but not exceeding 13.9% by weight.",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0033",
      "rawHtsCode": "1001.99.00.33",
      "superior": null,
      "indent": "7",
      "description": "Having a specified protein content exceeding 13.9% by weight.",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0036",
      "rawHtsCode": "1001.99.00.36",
      "superior": null,
      "indent": "6",
      "description": "Other red spring wheat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0045",
      "rawHtsCode": "1001.99.00.45",
      "superior": null,
      "indent": "5",
      "description": "White winter wheat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0055",
      "rawHtsCode": "1001.99.00.55",
      "superior": null,
      "indent": "5",
      "description": "\"Canadian\" western red winter wheat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0065",
      "rawHtsCode": "1001.99.00.65",
      "superior": null,
      "indent": "5",
      "description": "Soft white spring wheat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1001.99.0097",
      "rawHtsCode": "1001.99.00.97",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1002",
      "rawHtsCode": "1002",
      "superior": null,
      "indent": "0",
      "description": "Rye:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1002.10.00",
      "rawHtsCode": "1002.10.00",
      "superior": null,
      "indent": "1",
      "description": "Seed",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.59¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1002.10.0010",
      "rawHtsCode": "1002.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Seeds of a kind used for sowing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1002.10.0090",
      "rawHtsCode": "1002.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1002.90.0000",
      "rawHtsCode": "1002.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.59¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1003",
      "rawHtsCode": "1003",
      "superior": null,
      "indent": "0",
      "description": "Barley:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1003.10.0000",
      "rawHtsCode": "1003.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Seed",
      "units": [
        "kg"
      ],
      "generalRate": "0.15¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "0.92¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1003.90",
      "rawHtsCode": "1003.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1003.90.2000",
      "rawHtsCode": "1003.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "For malting purposes",
      "units": [
        "kg"
      ],
      "generalRate": "0.1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "0.92¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1003.90.40",
      "rawHtsCode": "1003.90.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "0.15¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "0.92¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1003.90.4020",
      "rawHtsCode": "1003.90.40.20",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1003.90.4030",
      "rawHtsCode": "1003.90.40.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1004",
      "rawHtsCode": "1004",
      "superior": null,
      "indent": "0",
      "description": "Oats:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1004.10.0000",
      "rawHtsCode": "1004.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Seed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1004.90.00",
      "rawHtsCode": "1004.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1004.90.0010",
      "rawHtsCode": "1004.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1004.90.0090",
      "rawHtsCode": "1004.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1005",
      "rawHtsCode": "1005",
      "superior": null,
      "indent": "0",
      "description": "Corn (maize):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1005.10.00",
      "rawHtsCode": "1005.10.00",
      "superior": null,
      "indent": "1",
      "description": "Seed",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.98¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1005.10.0010",
      "rawHtsCode": "1005.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Yellow corn",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1005.10.0090",
      "rawHtsCode": "1005.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1005.90",
      "rawHtsCode": "1005.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1005.90.20",
      "rawHtsCode": "1005.90.20",
      "superior": null,
      "indent": "2",
      "description": "Yellow dent corn",
      "units": [],
      "generalRate": "0.05¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.98¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1005.90.2015",
      "rawHtsCode": "1005.90.20.15",
      "superior": null,
      "indent": "3",
      "description": "Certified Organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1005.90.2025",
      "rawHtsCode": "1005.90.20.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1005.90.40",
      "rawHtsCode": "1005.90.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "0.25¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.98¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1005.90.4040",
      "rawHtsCode": "1005.90.40.40",
      "superior": null,
      "indent": "3",
      "description": "Popcorn",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1005.90.4060",
      "rawHtsCode": "1005.90.40.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006",
      "rawHtsCode": "1006",
      "superior": null,
      "indent": "0",
      "description": "Rice:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.10.0000",
      "rawHtsCode": "1006.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Rice in the husk (paddy or rough)",
      "units": [
        "kg"
      ],
      "generalRate": "1.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1006.20",
      "rawHtsCode": "1006.20",
      "superior": null,
      "indent": "1",
      "description": "Husked (brown) rice:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.20.20",
      "rawHtsCode": "1006.20.20",
      "superior": null,
      "indent": "2",
      "description": "Basmati",
      "units": [],
      "generalRate": "0.83¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1006.20.2010",
      "rawHtsCode": "1006.20.20.10",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.20.2090",
      "rawHtsCode": "1006.20.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.20.40",
      "rawHtsCode": "1006.20.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1006.20.4025",
      "rawHtsCode": "1006.20.40.25",
      "superior": null,
      "indent": "4",
      "description": "Jasmine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.20.4035",
      "rawHtsCode": "1006.20.40.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.20.4040",
      "rawHtsCode": "1006.20.40.40",
      "superior": null,
      "indent": "3",
      "description": "Medium grain",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.20.4060",
      "rawHtsCode": "1006.20.40.60",
      "superior": null,
      "indent": "3",
      "description": "Short grain",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.20.4080",
      "rawHtsCode": "1006.20.40.80",
      "superior": null,
      "indent": "3",
      "description": "Mixtures of any of the above",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.30",
      "rawHtsCode": "1006.30",
      "superior": null,
      "indent": "1",
      "description": "Semi-milled or wholly milled rice, whether or not polished or glazed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.30.10",
      "rawHtsCode": "1006.30.10",
      "superior": null,
      "indent": "2",
      "description": "Parboiled",
      "units": [],
      "generalRate": "11.2%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1006.30.1020",
      "rawHtsCode": "1006.30.10.20",
      "superior": null,
      "indent": "3",
      "description": "Long grain",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.30.1040",
      "rawHtsCode": "1006.30.10.40",
      "superior": null,
      "indent": "3",
      "description": "Other, including mixtures",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.30.90",
      "rawHtsCode": "1006.30.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1006.30.9015",
      "rawHtsCode": "1006.30.90.15",
      "superior": null,
      "indent": "3",
      "description": "Certified Organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.30.9057",
      "rawHtsCode": "1006.30.90.57",
      "superior": null,
      "indent": "5",
      "description": "Jasmine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.30.9059",
      "rawHtsCode": "1006.30.90.59",
      "superior": null,
      "indent": "5",
      "description": "Basmati",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.30.9061",
      "rawHtsCode": "1006.30.90.61",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.30.9065",
      "rawHtsCode": "1006.30.90.65",
      "superior": null,
      "indent": "4",
      "description": "Medium grain",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.30.9075",
      "rawHtsCode": "1006.30.90.75",
      "superior": null,
      "indent": "4",
      "description": "Short grain",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.30.9085",
      "rawHtsCode": "1006.30.90.85",
      "superior": null,
      "indent": "4",
      "description": "Mixtures of any of the above",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1006.40.0000",
      "rawHtsCode": "1006.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Broken rice",
      "units": [
        "kg"
      ],
      "generalRate": "0.44¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1007",
      "rawHtsCode": "1007",
      "superior": null,
      "indent": "0",
      "description": "Grain sorghum:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1007.10.0000",
      "rawHtsCode": "1007.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Seed",
      "units": [
        "kg"
      ],
      "generalRate": "0.22¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1007.90.0000",
      "rawHtsCode": "1007.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.22¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1008",
      "rawHtsCode": "1008",
      "superior": null,
      "indent": "0",
      "description": "Buckwheat, millet and canary seeds; other cereals (including wild rice):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1008.10.0000",
      "rawHtsCode": "1008.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Buckwheat",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.55¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1008.21.0000",
      "rawHtsCode": "1008.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Seed",
      "units": [
        "kg"
      ],
      "generalRate": "0.32¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1008.29.0000",
      "rawHtsCode": "1008.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.32¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1008.30.0000",
      "rawHtsCode": "1008.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Canary seeds",
      "units": [
        "kg"
      ],
      "generalRate": "0.12¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1008.40.0000",
      "rawHtsCode": "1008.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Fonio (<i>Digitaria spp.</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1008.50.00",
      "rawHtsCode": "1008.50.00",
      "superior": null,
      "indent": "1",
      "description": "Quinoa (<i>Chenopodium quinoa</i>)",
      "units": [],
      "generalRate": "1.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1008.50.0010",
      "rawHtsCode": "1008.50.00.10",
      "superior": null,
      "indent": "2",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1008.50.0090",
      "rawHtsCode": "1008.50.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1008.60.0000",
      "rawHtsCode": "1008.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Triticale",
      "units": [
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1008.90.01",
      "rawHtsCode": "1008.90.01",
      "superior": null,
      "indent": "1",
      "description": "Other cereals (including wild rice)",
      "units": [],
      "generalRate": "1.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1008.90.0120",
      "rawHtsCode": "1008.90.01.20",
      "superior": null,
      "indent": "2",
      "description": "Wild rice",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1008.90.0140",
      "rawHtsCode": "1008.90.01.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1101.00.00",
      "rawHtsCode": "1101.00.00",
      "superior": null,
      "indent": "0",
      "description": "Wheat or meslin flour",
      "units": [],
      "generalRate": "0.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "2.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1101.00.0010",
      "rawHtsCode": "1101.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Hard spring wheat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1101.00.0020",
      "rawHtsCode": "1101.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Durum wheat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1101.00.0030",
      "rawHtsCode": "1101.00.00.30",
      "superior": null,
      "indent": "1",
      "description": "White winter wheat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1101.00.0050",
      "rawHtsCode": "1101.00.00.50",
      "superior": null,
      "indent": "2",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1101.00.0060",
      "rawHtsCode": "1101.00.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1102",
      "rawHtsCode": "1102",
      "superior": null,
      "indent": "0",
      "description": "Cereal flours other than of wheat or meslin:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1102.20.0000",
      "rawHtsCode": "1102.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Corn (maize) flour",
      "units": [
        "kg"
      ],
      "generalRate": "0.3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1102.90",
      "rawHtsCode": "1102.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1102.90.2000",
      "rawHtsCode": "1102.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Buckwheat flour",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1102.90.2500",
      "rawHtsCode": "1102.90.25.00",
      "superior": null,
      "indent": "2",
      "description": "Rice flour",
      "units": [
        "kg"
      ],
      "generalRate": "0.09¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1102.90.2700",
      "rawHtsCode": "1102.90.27.00",
      "superior": null,
      "indent": "2",
      "description": "Rye flour",
      "units": [
        "kg"
      ],
      "generalRate": "0.23¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1102.90.3000",
      "rawHtsCode": "1102.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Mixtures",
      "units": [
        "kg"
      ],
      "generalRate": "12.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1102.90.6000",
      "rawHtsCode": "1102.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1103",
      "rawHtsCode": "1103",
      "superior": null,
      "indent": "0",
      "description": "Cereal groats, meal and pellets:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1103.11.00",
      "rawHtsCode": "1103.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of wheat",
      "units": [],
      "generalRate": "0.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "2.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1103.11.0020",
      "rawHtsCode": "1103.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Semolina",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1103.11.0040",
      "rawHtsCode": "1103.11.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1103.13.00",
      "rawHtsCode": "1103.13.00",
      "superior": null,
      "indent": "2",
      "description": "Of corn (maize)",
      "units": [],
      "generalRate": "0.3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1103.13.0020",
      "rawHtsCode": "1103.13.00.20",
      "superior": null,
      "indent": "3",
      "description": "Cornmeal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1103.13.0060",
      "rawHtsCode": "1103.13.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1103.19",
      "rawHtsCode": "1103.19",
      "superior": null,
      "indent": "2",
      "description": "Of other cereals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1103.19.1200",
      "rawHtsCode": "1103.19.12.00",
      "superior": null,
      "indent": "3",
      "description": "Of oats",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1103.19.1400",
      "rawHtsCode": "1103.19.14.00",
      "superior": null,
      "indent": "3",
      "description": "Of rice",
      "units": [
        "kg"
      ],
      "generalRate": "0.09¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1103.19.9000",
      "rawHtsCode": "1103.19.90.00",
      "superior": null,
      "indent": "3",
      "description": "Of other cereals",
      "units": [
        "kg"
      ],
      "generalRate": "9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1103.20.00",
      "rawHtsCode": "1103.20.00",
      "superior": null,
      "indent": "1",
      "description": "Pellets",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1103.20.0010",
      "rawHtsCode": "1103.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of wheat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1103.20.0090",
      "rawHtsCode": "1103.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Of other cereals",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1104",
      "rawHtsCode": "1104",
      "superior": null,
      "indent": "0",
      "description": "Cereal grains otherwise worked (for example, hulled, rolled, flaked, pearled, sliced or kibbled), except rice of heading 1006; germ of cereals, whole, rolled, flaked or ground:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1104.12.00",
      "rawHtsCode": "1104.12.00",
      "superior": null,
      "indent": "2",
      "description": "Of oats",
      "units": [],
      "generalRate": "1.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1104.12.0010",
      "rawHtsCode": "1104.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1104.12.0090",
      "rawHtsCode": "1104.12.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1104.19",
      "rawHtsCode": "1104.19",
      "superior": null,
      "indent": "2",
      "description": "Of other cereals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1104.19.1000",
      "rawHtsCode": "1104.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of barley",
      "units": [
        "kg"
      ],
      "generalRate": "2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1104.19.9000",
      "rawHtsCode": "1104.19.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.45¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1104.22.0000",
      "rawHtsCode": "1104.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of oats",
      "units": [
        "kg"
      ],
      "generalRate": "0.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1104.23.0000",
      "rawHtsCode": "1104.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of corn (maize)",
      "units": [
        "kg"
      ],
      "generalRate": "0.45¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1104.29",
      "rawHtsCode": "1104.29",
      "superior": null,
      "indent": "2",
      "description": "Of other cereals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1104.29.1000",
      "rawHtsCode": "1104.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of barley",
      "units": [
        "kg"
      ],
      "generalRate": "1.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "17%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1104.29.9000",
      "rawHtsCode": "1104.29.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1104.30.0000",
      "rawHtsCode": "1104.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Germ of cereals, whole, rolled, flaked or ground",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1105",
      "rawHtsCode": "1105",
      "superior": null,
      "indent": "0",
      "description": "Flour, meal, powder, flakes, granules and pellets of potatoes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1105.10.0000",
      "rawHtsCode": "1105.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Flour, meal and powder",
      "units": [
        "kg"
      ],
      "generalRate": "1.7¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1105.20.0000",
      "rawHtsCode": "1105.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Flakes, granules and pellets",
      "units": [
        "kg"
      ],
      "generalRate": "1.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "6.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1106",
      "rawHtsCode": "1106",
      "superior": null,
      "indent": "0",
      "description": "Flour, meal and powder of the dried leguminous vegetables of heading 0713, of sago or of roots or tubers of heading 0714 or of the products of chapter 8:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1106.10.0000",
      "rawHtsCode": "1106.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of the dried leguminous vegetables of heading 0713",
      "units": [
        "kg"
      ],
      "generalRate": "8.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1106.20",
      "rawHtsCode": "1106.20",
      "superior": null,
      "indent": "1",
      "description": "Of sago or of roots or tubers of heading 0714:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1106.20.1000",
      "rawHtsCode": "1106.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of Chinese water chestnuts",
      "units": [
        "kg"
      ],
      "generalRate": "8.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1106.20.9000",
      "rawHtsCode": "1106.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1106.30",
      "rawHtsCode": "1106.30",
      "superior": null,
      "indent": "1",
      "description": "Of the products of chapter 8:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1106.30.2000",
      "rawHtsCode": "1106.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Banana and plantain",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1106.30.4000",
      "rawHtsCode": "1106.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1107",
      "rawHtsCode": "1107",
      "superior": null,
      "indent": "0",
      "description": "Malt, whether or not roasted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1107.10.0000",
      "rawHtsCode": "1107.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Not roasted",
      "units": [
        "kg"
      ],
      "generalRate": "0.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "0.88¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1107.20.0000",
      "rawHtsCode": "1107.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Roasted",
      "units": [
        "kg"
      ],
      "generalRate": "0.42¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "0.88¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1108",
      "rawHtsCode": "1108",
      "superior": null,
      "indent": "0",
      "description": "Starches; inulin:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1108.11.00",
      "rawHtsCode": "1108.11.00",
      "superior": null,
      "indent": "2",
      "description": "Wheat starch",
      "units": [],
      "generalRate": "0.54¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1108.11.0010",
      "rawHtsCode": "1108.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "For food use",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1108.11.0090",
      "rawHtsCode": "1108.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1108.12.00",
      "rawHtsCode": "1108.12.00",
      "superior": null,
      "indent": "2",
      "description": "Corn (maize) starch",
      "units": [],
      "generalRate": "0.54¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1108.12.0010",
      "rawHtsCode": "1108.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "For food use",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1108.12.0090",
      "rawHtsCode": "1108.12.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1108.13.00",
      "rawHtsCode": "1108.13.00",
      "superior": null,
      "indent": "2",
      "description": "Potato starch",
      "units": [],
      "generalRate": "0.56¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1108.13.0010",
      "rawHtsCode": "1108.13.00.10",
      "superior": null,
      "indent": "3",
      "description": "For human consumption",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1108.13.0090",
      "rawHtsCode": "1108.13.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1108.14.0000",
      "rawHtsCode": "1108.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cassava (manioc) starch",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1108.19.00",
      "rawHtsCode": "1108.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other starches",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1108.19.0010",
      "rawHtsCode": "1108.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Cereal starches for non-food use",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1108.19.0090",
      "rawHtsCode": "1108.19.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1108.20.0000",
      "rawHtsCode": "1108.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Inulin",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1109.00",
      "rawHtsCode": "1109.00",
      "superior": null,
      "indent": "0",
      "description": "Wheat gluten, whether or not dried:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1109.00.1000",
      "rawHtsCode": "1109.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "To be used as animal feed",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1109.00.90",
      "rawHtsCode": "1109.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1109.00.9010",
      "rawHtsCode": "1109.00.90.10",
      "superior": null,
      "indent": "2",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1109.00.9020",
      "rawHtsCode": "1109.00.90.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1201",
      "rawHtsCode": "1201",
      "superior": null,
      "indent": "0",
      "description": "Soybeans, whether or not broken:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1201.10.0000",
      "rawHtsCode": "1201.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Seed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1201.90.00",
      "rawHtsCode": "1201.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1201.90.0005",
      "rawHtsCode": "1201.90.00.05",
      "superior": null,
      "indent": "2",
      "description": "Seeds of a kind used as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1201.90.0010",
      "rawHtsCode": "1201.90.00.10",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1201.90.0090",
      "rawHtsCode": "1201.90.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202",
      "rawHtsCode": "1202",
      "superior": null,
      "indent": "0",
      "description": "Peanuts (ground-nuts), not roasted or otherwise cooked, whether or not shelled or broken:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.30",
      "rawHtsCode": "1202.30",
      "superior": null,
      "indent": "1",
      "description": "Seed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.30.0500",
      "rawHtsCode": "1202.30.05.00",
      "superior": null,
      "indent": "2",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1202.30.4000",
      "rawHtsCode": "1202.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Described in additional U.S. note 2 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6.6¢/kg",
      "specialRate": "Free (A*,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1202.30.8000",
      "rawHtsCode": "1202.30.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "131.8%",
      "specialRate": "Free (AU,BH,CL,CO,JO,KR,MA,OM,P,P+,PA,PE,S,SG) See 9908.12.01 (IL)",
      "otherRate": "155%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.12.01-9904.12.19. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1202.41",
      "rawHtsCode": "1202.41",
      "superior": null,
      "indent": "2",
      "description": "In shell:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.41.05",
      "rawHtsCode": "1202.41.05",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [],
      "generalRate": "9.35¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9.35¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1202.41.0520",
      "rawHtsCode": "1202.41.05.20",
      "superior": null,
      "indent": "4",
      "description": "For use as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.41.0540",
      "rawHtsCode": "1202.41.05.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.41.40",
      "rawHtsCode": "1202.41.40",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 2 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "9.35¢/kg",
      "specialRate": "Free (A*,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9.35¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1202.41.4020",
      "rawHtsCode": "1202.41.40.20",
      "superior": null,
      "indent": "4",
      "description": "For use as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.41.4040",
      "rawHtsCode": "1202.41.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.41.80",
      "rawHtsCode": "1202.41.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "163.8%",
      "specialRate": "Free (AU,BH,CL,CO,JO,KR,MA,OM,P,P+,PA,PE,S,SG) See 9908.12.01 (IL)",
      "otherRate": "192.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.12.01-9904.12.19. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1202.41.8020",
      "rawHtsCode": "1202.41.80.20",
      "superior": null,
      "indent": "4",
      "description": "For use as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.41.8040",
      "rawHtsCode": "1202.41.80.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42",
      "rawHtsCode": "1202.42",
      "superior": null,
      "indent": "2",
      "description": "Shelled, whether or not broken:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42.10",
      "rawHtsCode": "1202.42.10",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [],
      "generalRate": "6.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1202.42.1020",
      "rawHtsCode": "1202.42.10.20",
      "superior": null,
      "indent": "5",
      "description": "For use as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42.1040",
      "rawHtsCode": "1202.42.10.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42.15",
      "rawHtsCode": "1202.42.15",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 2 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "6.6¢/kg",
      "specialRate": "Free (A*,BH,CA,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1202.42.1520",
      "rawHtsCode": "1202.42.15.20",
      "superior": null,
      "indent": "5",
      "description": "For use as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42.1540",
      "rawHtsCode": "1202.42.15.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42.20",
      "rawHtsCode": "1202.42.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "131.8%",
      "specialRate": "Free (AU,BH,CL,CO,JO,KR,MA,OM,P,PA,PE,S,SG) See 9908.12.01 (IL)",
      "otherRate": "155%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.12.01-9904.12.19. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1202.42.2020",
      "rawHtsCode": "1202.42.20.20",
      "superior": null,
      "indent": "5",
      "description": "For use as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42.2040",
      "rawHtsCode": "1202.42.20.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42.50",
      "rawHtsCode": "1202.42.50",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [],
      "generalRate": "6.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1202.42.5020",
      "rawHtsCode": "1202.42.50.20",
      "superior": null,
      "indent": "5",
      "description": "For use as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42.5040",
      "rawHtsCode": "1202.42.50.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42.60",
      "rawHtsCode": "1202.42.60",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 2 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "6.6¢/kg",
      "specialRate": "Free (A*,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1202.42.6020",
      "rawHtsCode": "1202.42.60.20",
      "superior": null,
      "indent": "5",
      "description": "For use as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42.6040",
      "rawHtsCode": "1202.42.60.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42.90",
      "rawHtsCode": "1202.42.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "131.8%",
      "specialRate": "Free (AU,BH,CL,CO,JO,KR,MA,OM,P,PA,PE,S,SG) See 9908.12.01 (IL)",
      "otherRate": "155%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.12.01-9904.12.19. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1202.42.9020",
      "rawHtsCode": "1202.42.90.20",
      "superior": null,
      "indent": "5",
      "description": "For use as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1202.42.9040",
      "rawHtsCode": "1202.42.90.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1203.00.0000",
      "rawHtsCode": "1203.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Copra",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1204.00.00",
      "rawHtsCode": "1204.00.00",
      "superior": null,
      "indent": "0",
      "description": "Flaxseed (linseed), whether or not broken",
      "units": [],
      "generalRate": "0.39¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "2.55¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1204.00.0010",
      "rawHtsCode": "1204.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "For sowing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1204.00.0025",
      "rawHtsCode": "1204.00.00.25",
      "superior": null,
      "indent": "2",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1204.00.0035",
      "rawHtsCode": "1204.00.00.35",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1204.00.0055",
      "rawHtsCode": "1204.00.00.55",
      "superior": null,
      "indent": "2",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1204.00.0075",
      "rawHtsCode": "1204.00.00.75",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1205",
      "rawHtsCode": "1205",
      "superior": null,
      "indent": "0",
      "description": "Rape or colza seeds, whether or not broken:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1205.10.00",
      "rawHtsCode": "1205.10.00",
      "superior": null,
      "indent": "1",
      "description": "Low erucic acid rape or colza seeds",
      "units": [],
      "generalRate": "0.58¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1205.10.0010",
      "rawHtsCode": "1205.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "For sowing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1205.10.0020",
      "rawHtsCode": "1205.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "For use as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1205.10.0090",
      "rawHtsCode": "1205.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1205.90.00",
      "rawHtsCode": "1205.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "0.58¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1205.90.0010",
      "rawHtsCode": "1205.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "For sowing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1205.90.0020",
      "rawHtsCode": "1205.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "For use as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1205.90.0090",
      "rawHtsCode": "1205.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1206.00.00",
      "rawHtsCode": "1206.00.00",
      "superior": null,
      "indent": "0",
      "description": "Sunflower seeds, whether or not broken",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1206.00.0020",
      "rawHtsCode": "1206.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "For use as oil stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1206.00.0031",
      "rawHtsCode": "1206.00.00.31",
      "superior": null,
      "indent": "1",
      "description": "For sowing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1206.00.0065",
      "rawHtsCode": "1206.00.00.65",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1206.00.0070",
      "rawHtsCode": "1206.00.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1206.00.0075",
      "rawHtsCode": "1206.00.00.75",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1206.00.0080",
      "rawHtsCode": "1206.00.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1206.00.0090",
      "rawHtsCode": "1206.00.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1207",
      "rawHtsCode": "1207",
      "superior": null,
      "indent": "0",
      "description": "Other oil seeds and oleaginous fruits, whether or not broken:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1207.10.0000",
      "rawHtsCode": "1207.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Palm nuts and kernels",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1207.21.0000",
      "rawHtsCode": "1207.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Seed",
      "units": [
        "kg"
      ],
      "generalRate": "0.47¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "0.73¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1207.29.0000",
      "rawHtsCode": "1207.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.47¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "0.73¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1207.30.0000",
      "rawHtsCode": "1207.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Castor oil seeds",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1207.40.00",
      "rawHtsCode": "1207.40.00",
      "superior": null,
      "indent": "1",
      "description": "Sesame seeds",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1207.40.0010",
      "rawHtsCode": "1207.40.00.10",
      "superior": null,
      "indent": "2",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1207.40.0090",
      "rawHtsCode": "1207.40.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1207.50.0000",
      "rawHtsCode": "1207.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mustard seeds",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1207.60.0000",
      "rawHtsCode": "1207.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Safflower (<u>Carthamus</u> <u>tinctorius</u>) seeds",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1207.70.00",
      "rawHtsCode": "1207.70.00",
      "superior": null,
      "indent": "1",
      "description": "Melon seeds",
      "units": [],
      "generalRate": "0.83¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1207.70.0020",
      "rawHtsCode": "1207.70.00.20",
      "superior": null,
      "indent": "2",
      "description": "Cantaloupe",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1207.70.0040",
      "rawHtsCode": "1207.70.00.40",
      "superior": null,
      "indent": "2",
      "description": "Watermelon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1207.70.0075",
      "rawHtsCode": "1207.70.00.75",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1207.91.0000",
      "rawHtsCode": "1207.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Poppy seeds",
      "units": [
        "kg"
      ],
      "generalRate": "0.06¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1207.99.03",
      "rawHtsCode": "1207.99.03",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1207.99.0310",
      "rawHtsCode": "1207.99.03.10",
      "superior": null,
      "indent": "3",
      "description": "Niger seed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1207.99.0340",
      "rawHtsCode": "1207.99.03.40",
      "superior": null,
      "indent": "4",
      "description": "For sowing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1207.99.0360",
      "rawHtsCode": "1207.99.03.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1207.99.0391",
      "rawHtsCode": "1207.99.03.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1208",
      "rawHtsCode": "1208",
      "superior": null,
      "indent": "0",
      "description": "Flours and meals of oil seeds or oleaginous fruits, other than those of mustard:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1208.10.00",
      "rawHtsCode": "1208.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of soybeans",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1208.10.0010",
      "rawHtsCode": "1208.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1208.10.0090",
      "rawHtsCode": "1208.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1208.90.0000",
      "rawHtsCode": "1208.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1209",
      "rawHtsCode": "1209",
      "superior": null,
      "indent": "0",
      "description": "Seeds, fruits and spores of a kind used for sowing:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.10.0000",
      "rawHtsCode": "1209.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sugar beet seeds",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1209.21.00",
      "rawHtsCode": "1209.21.00",
      "superior": null,
      "indent": "2",
      "description": "Alfalfa (lucerne) seeds",
      "units": [],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1209.21.0020",
      "rawHtsCode": "1209.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Certified",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.21.0040",
      "rawHtsCode": "1209.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.22",
      "rawHtsCode": "1209.22",
      "superior": null,
      "indent": "2",
      "description": "Clover (<u>Trifolium</u> spp.) seeds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.22.2000",
      "rawHtsCode": "1209.22.20.00",
      "superior": null,
      "indent": "3",
      "description": "White and ladino",
      "units": [
        "kg"
      ],
      "generalRate": "1.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "13¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1209.22.40",
      "rawHtsCode": "1209.22.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "18¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1209.22.4020",
      "rawHtsCode": "1209.22.40.20",
      "superior": null,
      "indent": "4",
      "description": "Alsike",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.22.4030",
      "rawHtsCode": "1209.22.40.30",
      "superior": null,
      "indent": "4",
      "description": "Crimson",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.22.4041",
      "rawHtsCode": "1209.22.40.41",
      "superior": null,
      "indent": "5",
      "description": "Double cut",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.22.4049",
      "rawHtsCode": "1209.22.40.49",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.22.4060",
      "rawHtsCode": "1209.22.40.60",
      "superior": null,
      "indent": "4",
      "description": "Sweet",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.22.4095",
      "rawHtsCode": "1209.22.40.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.23.00",
      "rawHtsCode": "1209.23.00",
      "superior": null,
      "indent": "2",
      "description": "Fescue seeds",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1209.23.0020",
      "rawHtsCode": "1209.23.00.20",
      "superior": null,
      "indent": "3",
      "description": "Tall",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.23.0031",
      "rawHtsCode": "1209.23.00.31",
      "superior": null,
      "indent": "4",
      "description": "Certified",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.23.0039",
      "rawHtsCode": "1209.23.00.39",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.23.0060",
      "rawHtsCode": "1209.23.00.60",
      "superior": null,
      "indent": "3",
      "description": "Meadow",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.23.0090",
      "rawHtsCode": "1209.23.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.24.0000",
      "rawHtsCode": "1209.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Kentucky blue grass (<u>Poa</u> <u>pratensis</u> <u>L</u>.) seeds",
      "units": [
        "kg"
      ],
      "generalRate": "1.2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1209.25.00",
      "rawHtsCode": "1209.25.00",
      "superior": null,
      "indent": "2",
      "description": "Rye grass (<u>Lolium</u> <u>multiflorium</u> <u>Lam</u>., <u>Lolium</u> <u>perenne</u> <u>L</u>.) seeds",
      "units": [],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1209.25.0020",
      "rawHtsCode": "1209.25.00.20",
      "superior": null,
      "indent": "3",
      "description": "Annual",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.25.0040",
      "rawHtsCode": "1209.25.00.40",
      "superior": null,
      "indent": "3",
      "description": "Perennial",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29",
      "rawHtsCode": "1209.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.1000",
      "rawHtsCode": "1209.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Beet",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1209.29.91",
      "rawHtsCode": "1209.29.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1209.29.9120",
      "rawHtsCode": "1209.29.91.20",
      "superior": null,
      "indent": "4",
      "description": "Bent grass (genus <u><i>Agrostis</i></u>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9125",
      "rawHtsCode": "1209.29.91.25",
      "superior": null,
      "indent": "5",
      "description": "Husked",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9126",
      "rawHtsCode": "1209.29.91.26",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9130",
      "rawHtsCode": "1209.29.91.30",
      "superior": null,
      "indent": "4",
      "description": "Birdsfoot trefoil",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9136",
      "rawHtsCode": "1209.29.91.36",
      "superior": null,
      "indent": "5",
      "description": "Meadow",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9137",
      "rawHtsCode": "1209.29.91.37",
      "superior": null,
      "indent": "5",
      "description": "Smooth",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9138",
      "rawHtsCode": "1209.29.91.38",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9140",
      "rawHtsCode": "1209.29.91.40",
      "superior": null,
      "indent": "4",
      "description": "Orchard grass",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9160",
      "rawHtsCode": "1209.29.91.60",
      "superior": null,
      "indent": "4",
      "description": "Sudan grass",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9171",
      "rawHtsCode": "1209.29.91.71",
      "superior": null,
      "indent": "5",
      "description": "Crested",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9174",
      "rawHtsCode": "1209.29.91.74",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9176",
      "rawHtsCode": "1209.29.91.76",
      "superior": null,
      "indent": "4",
      "description": "Wild rye",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9179",
      "rawHtsCode": "1209.29.91.79",
      "superior": null,
      "indent": "4",
      "description": "Other grass",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.29.9196",
      "rawHtsCode": "1209.29.91.96",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.30.00",
      "rawHtsCode": "1209.30.00",
      "superior": null,
      "indent": "1",
      "description": "Seeds of herbaceous plants cultivated principally for their flowers",
      "units": [],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1209.30.0010",
      "rawHtsCode": "1209.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Petunia",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.30.0090",
      "rawHtsCode": "1209.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91",
      "rawHtsCode": "1209.91",
      "superior": null,
      "indent": "2",
      "description": "Vegetable seeds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.1000",
      "rawHtsCode": "1209.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cauliflower",
      "units": [
        "kg"
      ],
      "generalRate": "5.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "55¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1209.91.2000",
      "rawHtsCode": "1209.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "Celery",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1209.91.4000",
      "rawHtsCode": "1209.91.40.00",
      "superior": null,
      "indent": "3",
      "description": "Onion",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1209.91.5000",
      "rawHtsCode": "1209.91.50.00",
      "superior": null,
      "indent": "3",
      "description": "Parsley",
      "units": [
        "kg"
      ],
      "generalRate": "0.68¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1209.91.60",
      "rawHtsCode": "1209.91.60",
      "superior": null,
      "indent": "3",
      "description": "Pepper",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1209.91.6010",
      "rawHtsCode": "1209.91.60.10",
      "superior": null,
      "indent": "4",
      "description": "Sweet pepper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.6090",
      "rawHtsCode": "1209.91.60.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.80",
      "rawHtsCode": "1209.91.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1209.91.8005",
      "rawHtsCode": "1209.91.80.05",
      "superior": null,
      "indent": "4",
      "description": "Broccoli",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8008",
      "rawHtsCode": "1209.91.80.08",
      "superior": null,
      "indent": "5",
      "description": "Green cabbage",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8009",
      "rawHtsCode": "1209.91.80.09",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8010",
      "rawHtsCode": "1209.91.80.10",
      "superior": null,
      "indent": "4",
      "description": "Carrot",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8020",
      "rawHtsCode": "1209.91.80.20",
      "superior": null,
      "indent": "4",
      "description": "Radish",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8030",
      "rawHtsCode": "1209.91.80.30",
      "superior": null,
      "indent": "4",
      "description": "Spinach",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8040",
      "rawHtsCode": "1209.91.80.40",
      "superior": null,
      "indent": "4",
      "description": "Cucumber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8045",
      "rawHtsCode": "1209.91.80.45",
      "superior": null,
      "indent": "4",
      "description": "Kale",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8047",
      "rawHtsCode": "1209.91.80.47",
      "superior": null,
      "indent": "4",
      "description": "Kohlrabi",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8050",
      "rawHtsCode": "1209.91.80.50",
      "superior": null,
      "indent": "4",
      "description": "Lettuce",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8054",
      "rawHtsCode": "1209.91.80.54",
      "superior": null,
      "indent": "4",
      "description": "Parsnip",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8055",
      "rawHtsCode": "1209.91.80.55",
      "superior": null,
      "indent": "4",
      "description": "Pumpkin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8060",
      "rawHtsCode": "1209.91.80.60",
      "superior": null,
      "indent": "4",
      "description": "Squash",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8070",
      "rawHtsCode": "1209.91.80.70",
      "superior": null,
      "indent": "4",
      "description": "Tomato",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8074",
      "rawHtsCode": "1209.91.80.74",
      "superior": null,
      "indent": "4",
      "description": "Turnip",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.91.8090",
      "rawHtsCode": "1209.91.80.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.99",
      "rawHtsCode": "1209.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.99.2000",
      "rawHtsCode": "1209.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Tree and shrub",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "17.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1209.99.41",
      "rawHtsCode": "1209.99.41",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "0.83¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1209.99.4170",
      "rawHtsCode": "1209.99.41.70",
      "superior": null,
      "indent": "4",
      "description": "Tobacco",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1209.99.4190",
      "rawHtsCode": "1209.99.41.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1210",
      "rawHtsCode": "1210",
      "superior": null,
      "indent": "0",
      "description": "Hop cones, fresh or dried, whether or not ground, powdered or in the form of pellets; lupulin:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1210.10.0000",
      "rawHtsCode": "1210.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hop cones, neither ground nor powdered nor in the form of pellets",
      "units": [
        "kg"
      ],
      "generalRate": "13.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "53¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1210.20.00",
      "rawHtsCode": "1210.20.00",
      "superior": null,
      "indent": "1",
      "description": "Hop cones, ground, powdered or in the form of pellets; lupulin",
      "units": [],
      "generalRate": "13.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "53¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1210.20.0020",
      "rawHtsCode": "1210.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Hop cone pellets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1210.20.0040",
      "rawHtsCode": "1210.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211",
      "rawHtsCode": "1211",
      "superior": null,
      "indent": "0",
      "description": "Plants and parts of plants (including seeds and fruits), of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.20",
      "rawHtsCode": "1211.20",
      "superior": null,
      "indent": "1",
      "description": "Ginseng roots:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.20.10",
      "rawHtsCode": "1211.20.10",
      "superior": null,
      "indent": "2",
      "description": "Fresh or dried",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1211.20.1020",
      "rawHtsCode": "1211.20.10.20",
      "superior": null,
      "indent": "3",
      "description": "Cultivated",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.20.1090",
      "rawHtsCode": "1211.20.10.90",
      "superior": null,
      "indent": "3",
      "description": "Wild",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.20.1500",
      "rawHtsCode": "1211.20.15.00",
      "superior": null,
      "indent": "2",
      "description": "Chilled or frozen",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1211.30.0000",
      "rawHtsCode": "1211.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Coca leaf",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1211.40.0000",
      "rawHtsCode": "1211.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Poppy straw",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1211.50.0000",
      "rawHtsCode": "1211.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ephedra",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1211.60.0000",
      "rawHtsCode": "1211.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Bark of African cherry (<i>Prunus Africana</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1211.90",
      "rawHtsCode": "1211.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.90.2000",
      "rawHtsCode": "1211.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Crude or not manufactured",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1211.90.40",
      "rawHtsCode": "1211.90.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1211.90.4020",
      "rawHtsCode": "1211.90.40.20",
      "superior": null,
      "indent": "4",
      "description": "Herbal teas and herbal infusions (single species, unmixed)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.90.4040",
      "rawHtsCode": "1211.90.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.90.6000",
      "rawHtsCode": "1211.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Tonka beans",
      "units": [
        "kg"
      ],
      "generalRate": "6.6¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1211.90.89",
      "rawHtsCode": "1211.90.89",
      "superior": null,
      "indent": "3",
      "description": "Fresh or dried",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1211.90.8920",
      "rawHtsCode": "1211.90.89.20",
      "superior": null,
      "indent": "5",
      "description": "Psyllium seed husks",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.90.8931",
      "rawHtsCode": "1211.90.89.31",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.90.8940",
      "rawHtsCode": "1211.90.89.40",
      "superior": null,
      "indent": "4",
      "description": "Basil",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.90.8950",
      "rawHtsCode": "1211.90.89.50",
      "superior": null,
      "indent": "4",
      "description": "Sage",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.90.8980",
      "rawHtsCode": "1211.90.89.80",
      "superior": null,
      "indent": "5",
      "description": "Herbal teas and herbal infusions (single species, unmixed)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.90.8990",
      "rawHtsCode": "1211.90.89.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1211.90.9300",
      "rawHtsCode": "1211.90.93.00",
      "superior": null,
      "indent": "3",
      "description": "Chilled or frozen",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1212",
      "rawHtsCode": "1212",
      "superior": null,
      "indent": "0",
      "description": "Locust beans, seaweeds and other algae, sugar beet and sugar cane, fresh, chilled, frozen or dried, whether or not ground; fruit stones and kernels and other vegetable products (including unroasted chicory roots of the variety <u>Cichorium</u> <u>intybus</u> <u>sativum</u>) of a kind used primarily for human consumption, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1212.21.0000",
      "rawHtsCode": "1212.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fit for human consumption",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1212.29.0000",
      "rawHtsCode": "1212.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1212.91.0000",
      "rawHtsCode": "1212.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sugar beet",
      "units": [
        "t"
      ],
      "generalRate": "39.7¢/t",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "88.2¢/t",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1212.92.0000",
      "rawHtsCode": "1212.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Locust beans (carob)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1212.93.0000",
      "rawHtsCode": "1212.93.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sugar cane",
      "units": [
        "t"
      ],
      "generalRate": "$1.24/t",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$2.76/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1212.94.0000",
      "rawHtsCode": "1212.94.00.00",
      "superior": null,
      "indent": "2",
      "description": "Chicory roots",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1212.99",
      "rawHtsCode": "1212.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1212.99.2000",
      "rawHtsCode": "1212.99.20.00",
      "superior": null,
      "indent": "4",
      "description": "Nectarine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1212.99.3000",
      "rawHtsCode": "1212.99.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1212.99.9200",
      "rawHtsCode": "1212.99.92.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1213.00.0000",
      "rawHtsCode": "1213.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Cereal straw and husks, unprepared, whether or not chopped, ground, pressed or in the form of pellets",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.65/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1214",
      "rawHtsCode": "1214",
      "superior": null,
      "indent": "0",
      "description": "Rutabagas (swedes), mangolds, fodder roots, hay, alfalfa (lucerne), clover, sainfoin, forage kale, lupines, vetches and similar forage products, whether or not in the form of pellets:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1214.10.00",
      "rawHtsCode": "1214.10.00",
      "superior": null,
      "indent": "1",
      "description": "Alfalfa (lucerne) meal and pellets",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1214.10.0010",
      "rawHtsCode": "1214.10.00.10",
      "superior": null,
      "indent": "3",
      "description": "Cubes",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1214.10.0015",
      "rawHtsCode": "1214.10.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1214.10.0030",
      "rawHtsCode": "1214.10.00.30",
      "superior": null,
      "indent": "4",
      "description": "Cubes",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1214.10.0050",
      "rawHtsCode": "1214.10.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1214.10.0060",
      "rawHtsCode": "1214.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1214.90.00",
      "rawHtsCode": "1214.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$5.51/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1214.90.0010",
      "rawHtsCode": "1214.90.00.10",
      "superior": null,
      "indent": "3",
      "description": "Alfalfa, whether or not double compressed",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1214.90.0018",
      "rawHtsCode": "1214.90.00.18",
      "superior": null,
      "indent": "3",
      "description": "Timothy",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1214.90.0025",
      "rawHtsCode": "1214.90.00.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1214.90.0030",
      "rawHtsCode": "1214.90.00.30",
      "superior": null,
      "indent": "2",
      "description": "Clover",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1214.90.0090",
      "rawHtsCode": "1214.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1301",
      "rawHtsCode": "1301",
      "superior": null,
      "indent": "0",
      "description": "Lac; natural gums, resins, gum-resins and oleoresins (for example, balsams):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1301.20.0000",
      "rawHtsCode": "1301.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Gum Arabic",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1301.90",
      "rawHtsCode": "1301.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1301.90.4000",
      "rawHtsCode": "1301.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Turpentine gum (oleoresinous exudate from living trees)",
      "units": [
        "kg"
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1301.90.91",
      "rawHtsCode": "1301.90.91",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1301.90.9105",
      "rawHtsCode": "1301.90.91.05",
      "superior": null,
      "indent": "3",
      "description": "Balsams",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1301.90.9110",
      "rawHtsCode": "1301.90.91.10",
      "superior": null,
      "indent": "3",
      "description": "Bleached shellac",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1301.90.9120",
      "rawHtsCode": "1301.90.91.20",
      "superior": null,
      "indent": "3",
      "description": "Seed lac",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1301.90.9130",
      "rawHtsCode": "1301.90.91.30",
      "superior": null,
      "indent": "3",
      "description": "Tragacanth",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1301.90.9140",
      "rawHtsCode": "1301.90.91.40",
      "superior": null,
      "indent": "3",
      "description": "Karaya",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1301.90.9190",
      "rawHtsCode": "1301.90.91.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1302",
      "rawHtsCode": "1302",
      "superior": null,
      "indent": "0",
      "description": "Vegetable saps and extracts; pectic substances, pectinates and pectates; agar-agar and other mucilages and thickeners, whether or not modified, derived from vegetable products:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1302.11.0000",
      "rawHtsCode": "1302.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Opium",
      "units": [
        "kg amc"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$40/kg of anhydrous morphine content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1302.12.0000",
      "rawHtsCode": "1302.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of licorice",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1302.13.0000",
      "rawHtsCode": "1302.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of hops",
      "units": [
        "kg"
      ],
      "generalRate": "89¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "$5.29/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1302.14.0100",
      "rawHtsCode": "1302.14.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of ephedra",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1302.19",
      "rawHtsCode": "1302.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1302.19.2100",
      "rawHtsCode": "1302.19.21.00",
      "superior": null,
      "indent": "4",
      "description": "Poppy straw extract",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1302.19.41",
      "rawHtsCode": "1302.19.41",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1302.19.4120",
      "rawHtsCode": "1302.19.41.20",
      "superior": null,
      "indent": "5",
      "description": "Ginseng",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1302.19.4140",
      "rawHtsCode": "1302.19.41.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1302.19.91",
      "rawHtsCode": "1302.19.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1302.19.9120",
      "rawHtsCode": "1302.19.91.20",
      "superior": null,
      "indent": "4",
      "description": "Cashew nut shell liquid",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1302.19.9140",
      "rawHtsCode": "1302.19.91.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1302.20.0000",
      "rawHtsCode": "1302.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Pectic substances, pectinates and pectates",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1302.31.0000",
      "rawHtsCode": "1302.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Agar-agar",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1302.32.00",
      "rawHtsCode": "1302.32.00",
      "superior": null,
      "indent": "2",
      "description": "Mucilages and thickeners, whether or not modified, derived from locust beans, locust bean seeds or guar seeds",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1302.32.0020",
      "rawHtsCode": "1302.32.00.20",
      "superior": null,
      "indent": "3",
      "description": "Guar",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1302.32.0040",
      "rawHtsCode": "1302.32.00.40",
      "superior": null,
      "indent": "3",
      "description": "Locust bean",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1302.39.00",
      "rawHtsCode": "1302.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1302.39.0010",
      "rawHtsCode": "1302.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Carrageenan",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1302.39.0090",
      "rawHtsCode": "1302.39.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1401",
      "rawHtsCode": "1401",
      "superior": null,
      "indent": "0",
      "description": "Vegetable materials of a kind used primarily for plaiting (for example, bamboos, rattans, reeds, rushes, osier, raffia, cleaned, bleached or dyed cereal straw, and lime bark):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1401.10.0000",
      "rawHtsCode": "1401.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Bamboos",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1401.20",
      "rawHtsCode": "1401.20",
      "superior": null,
      "indent": "1",
      "description": "Rattans:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1401.20.20",
      "rawHtsCode": "1401.20.20",
      "superior": null,
      "indent": "2",
      "description": "In the rough or cut transversely into sections",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1401.20.2010",
      "rawHtsCode": "1401.20.20.10",
      "superior": null,
      "indent": "3",
      "description": "In the rough, 4 meters or more in length",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1401.20.2090",
      "rawHtsCode": "1401.20.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1401.20.4000",
      "rawHtsCode": "1401.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1401.90",
      "rawHtsCode": "1401.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1401.90.2000",
      "rawHtsCode": "1401.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Willow (osier)",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1401.90.4000",
      "rawHtsCode": "1401.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1404",
      "rawHtsCode": "1404",
      "superior": null,
      "indent": "0",
      "description": "Vegetable products not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1404.20.0000",
      "rawHtsCode": "1404.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cotton linters",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1404.90",
      "rawHtsCode": "1404.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1404.90.1000",
      "rawHtsCode": "1404.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Vegetable hair",
      "units": [
        "kg"
      ],
      "generalRate": "0.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1404.90.2000",
      "rawHtsCode": "1404.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Broomcorn (<i>Sorghum vulgare</i> var. <i>technicum</i>)",
      "units": [
        "t"
      ],
      "generalRate": "$4.95/t",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "$22/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1404.90.3000",
      "rawHtsCode": "1404.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Istle",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1404.90.4000",
      "rawHtsCode": "1404.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1404.90.90",
      "rawHtsCode": "1404.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1404.90.9020",
      "rawHtsCode": "1404.90.90.20",
      "superior": null,
      "indent": "4",
      "description": "Canaigre, chestnut, curupay, divi-divi, eucalyptus, gall nuts, hemlock, larch, mangrove, myrobalan, oak, quebracho, sumac, tara, urunday, valonia, wattle and other materials of a kind used primarily in tanning",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1404.90.9040",
      "rawHtsCode": "1404.90.90.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1404.90.9090",
      "rawHtsCode": "1404.90.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Under this provision, imports of cigarette wrappers or tubes composed primarily of non-pulped vegetable materials may be subject to Federal Excise Tax (26 U.S.C. 5701)."
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "1501",
      "rawHtsCode": "1501",
      "superior": null,
      "indent": "0",
      "description": "Pig fat (including lard) and poultry fat, other than that of heading 0209 or 1503:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1501.10.0000",
      "rawHtsCode": "1501.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Lard",
      "units": [
        "kg"
      ],
      "generalRate": "3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1501.20.00",
      "rawHtsCode": "1501.20.00",
      "superior": null,
      "indent": "1",
      "description": "Other pig fat",
      "units": [],
      "generalRate": "3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1501.20.0040",
      "rawHtsCode": "1501.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Choice white grease",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1501.20.0060",
      "rawHtsCode": "1501.20.00.60",
      "superior": null,
      "indent": "2",
      "description": "Yellow grease",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1501.20.0080",
      "rawHtsCode": "1501.20.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1501.90.0000",
      "rawHtsCode": "1501.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1502",
      "rawHtsCode": "1502",
      "superior": null,
      "indent": "0",
      "description": "Fats of bovine animals, sheep or goats, other than those of heading 1503:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1502.10.00",
      "rawHtsCode": "1502.10.00",
      "superior": null,
      "indent": "1",
      "description": "Tallow",
      "units": [],
      "generalRate": "0.43¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1502.10.0020",
      "rawHtsCode": "1502.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Edible",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1502.10.0040",
      "rawHtsCode": "1502.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Inedible",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1502.90.0000",
      "rawHtsCode": "1502.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.43¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "7.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1503.00.0000",
      "rawHtsCode": "1503.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Lard stearin, lard oil, oleostearin, oleo-oil and tallow oil, not emulsified or mixed or otherwise prepared",
      "units": [
        "kg"
      ],
      "generalRate": "2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1504",
      "rawHtsCode": "1504",
      "superior": null,
      "indent": "0",
      "description": "Fats and oils and their fractions, of fish or marine mammals, whether or not refined, but not chemically modified:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1504.10",
      "rawHtsCode": "1504.10",
      "superior": null,
      "indent": "1",
      "description": "Fish-liver oils and their fractions:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1504.10.2000",
      "rawHtsCode": "1504.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Cod",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1504.10.4000",
      "rawHtsCode": "1504.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "6.6¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1504.20",
      "rawHtsCode": "1504.20",
      "superior": null,
      "indent": "1",
      "description": "Fats and oils and their fractions, of fish, other than liver oils:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1504.20.2000",
      "rawHtsCode": "1504.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Cod",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1504.20.4000",
      "rawHtsCode": "1504.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Herring",
      "units": [
        "kg"
      ],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1504.20.60",
      "rawHtsCode": "1504.20.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "1.5¢/kg + 5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1504.20.6020",
      "rawHtsCode": "1504.20.60.20",
      "superior": null,
      "indent": "3",
      "description": "Menhaden",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1504.20.6040",
      "rawHtsCode": "1504.20.60.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1504.30.0000",
      "rawHtsCode": "1504.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Fats and oils and their fractions, of marine mammals",
      "units": [
        "kg"
      ],
      "generalRate": "1.7¢/kg + 5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1505.00",
      "rawHtsCode": "1505.00",
      "superior": null,
      "indent": "0",
      "description": "Wool grease and fatty substances derived therefrom (including lanolin):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1505.00.1000",
      "rawHtsCode": "1505.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Wool grease, crude",
      "units": [
        "kg"
      ],
      "generalRate": "1.3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1505.00.9000",
      "rawHtsCode": "1505.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1506.00.0000",
      "rawHtsCode": "1506.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Other animal fats and oils and their fractions, whether or not refined, but not chemically modified",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1507",
      "rawHtsCode": "1507",
      "superior": null,
      "indent": "0",
      "description": "Soybean oil and its fractions, whether or not refined, but not chemically modified:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1507.10.0000",
      "rawHtsCode": "1507.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Crude oil, whether or not degummed",
      "units": [
        "kg"
      ],
      "generalRate": "19.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1507.90",
      "rawHtsCode": "1507.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1507.90.2000",
      "rawHtsCode": "1507.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Pharmaceutical Grade meeting FDA requirements for use in intravenous fat emulsions, valued over $5/kg",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1507.90.40",
      "rawHtsCode": "1507.90.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "19.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1507.90.4020",
      "rawHtsCode": "1507.90.40.20",
      "superior": null,
      "indent": "3",
      "description": "Once-refined (subjected to alkali or caustic wash, but not bleached or deodorized)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1507.90.4040",
      "rawHtsCode": "1507.90.40.40",
      "superior": null,
      "indent": "3",
      "description": "Other (fully refined, washed, bleached or deodorized)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1508",
      "rawHtsCode": "1508",
      "superior": null,
      "indent": "0",
      "description": "Peanut (ground-nut) oil and its fractions, whether or not refined, but not chemically modified:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1508.10.0000",
      "rawHtsCode": "1508.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Crude oil",
      "units": [
        "kg"
      ],
      "generalRate": "7.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1508.90.0000",
      "rawHtsCode": "1508.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "7.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1509",
      "rawHtsCode": "1509",
      "superior": null,
      "indent": "0",
      "description": "Olive oil and its fractions, whether or not refined, but not chemically modified:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.20",
      "rawHtsCode": "1509.20",
      "superior": null,
      "indent": "1",
      "description": "Extra virgin olive oil:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.20.20",
      "rawHtsCode": "1509.20.20",
      "superior": null,
      "indent": "2",
      "description": "Weighing with the immediate container under 18 kg",
      "units": [],
      "generalRate": "5¢/kg on contents and container",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg on contents and container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1509.20.2030",
      "rawHtsCode": "1509.20.20.30",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.20.2090",
      "rawHtsCode": "1509.20.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.20.90",
      "rawHtsCode": "1509.20.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "14.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1509.20.9030",
      "rawHtsCode": "1509.20.90.30",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.20.9090",
      "rawHtsCode": "1509.20.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.30",
      "rawHtsCode": "1509.30",
      "superior": null,
      "indent": "1",
      "description": "Virgin olive oil:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.30.20",
      "rawHtsCode": "1509.30.20",
      "superior": null,
      "indent": "2",
      "description": "Weighing with the immediate container under 18 kg",
      "units": [],
      "generalRate": "5¢/kg on contents and container",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg on contents and container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1509.30.2030",
      "rawHtsCode": "1509.30.20.30",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.30.2090",
      "rawHtsCode": "1509.30.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.30.90",
      "rawHtsCode": "1509.30.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "14.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1509.30.9030",
      "rawHtsCode": "1509.30.90.30",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.30.9090",
      "rawHtsCode": "1509.30.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.40",
      "rawHtsCode": "1509.40",
      "superior": null,
      "indent": "1",
      "description": "Other virgin olive oils:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.40.20",
      "rawHtsCode": "1509.40.20",
      "superior": null,
      "indent": "2",
      "description": "Weighing with the immediate container under 18 kg",
      "units": [],
      "generalRate": "5¢/kg on contents and container",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg on contents and container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1509.40.2030",
      "rawHtsCode": "1509.40.20.30",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.40.2090",
      "rawHtsCode": "1509.40.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.40.90",
      "rawHtsCode": "1509.40.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "14.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1509.40.9030",
      "rawHtsCode": "1509.40.90.30",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.40.9090",
      "rawHtsCode": "1509.40.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.90",
      "rawHtsCode": "1509.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1509.90.2000",
      "rawHtsCode": "1509.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing with the immediate container under 18 kg",
      "units": [
        "kg"
      ],
      "generalRate": "5¢/kg on contents and container",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg on contents and container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1509.90.4000",
      "rawHtsCode": "1509.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "14.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1510",
      "rawHtsCode": "1510",
      "superior": null,
      "indent": "0",
      "description": "Other oils and their fractions, obtained solely from olives, whether or not refined, but not chemically modified, including blends of these oils and fractions with oils or fractions of heading 1509:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1510.10",
      "rawHtsCode": "1510.10",
      "superior": null,
      "indent": "1",
      "description": "Crude olive pomace oil:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1510.10.1000",
      "rawHtsCode": "1510.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing with the immediate container under 18 kg",
      "units": [
        "kg"
      ],
      "generalRate": "5¢/kg on contents and container",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg on contents and container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1510.10.9000",
      "rawHtsCode": "1510.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "14.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1510.90",
      "rawHtsCode": "1510.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1510.90.1000",
      "rawHtsCode": "1510.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Rendered unfit for use as food",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1510.90.2000",
      "rawHtsCode": "1510.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Weighing with the immediate container under 18 kg",
      "units": [
        "kg"
      ],
      "generalRate": "5¢/kg on contents and container",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg on contents and container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1510.90.9000",
      "rawHtsCode": "1510.90.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "14.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1511",
      "rawHtsCode": "1511",
      "superior": null,
      "indent": "0",
      "description": "Palm oil and its fractions, whether or not refined, but not chemically modified:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1511.10.0000",
      "rawHtsCode": "1511.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Crude oil",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1511.90.0000",
      "rawHtsCode": "1511.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1512",
      "rawHtsCode": "1512",
      "superior": null,
      "indent": "0",
      "description": "Sunflower-seed, safflower or cottonseed oil, and fractions thereof, whether or not refined, but not chemically modified:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1512.11.00",
      "rawHtsCode": "1512.11.00",
      "superior": null,
      "indent": "2",
      "description": "Crude oil",
      "units": [],
      "generalRate": "1.7¢/kg + 3.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9.9¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1512.11.0025",
      "rawHtsCode": "1512.11.00.25",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1512.11.0035",
      "rawHtsCode": "1512.11.00.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1512.11.0040",
      "rawHtsCode": "1512.11.00.40",
      "superior": null,
      "indent": "3",
      "description": "Safflower oil",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1512.19.00",
      "rawHtsCode": "1512.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "1.7¢/kg + 3.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "9.9¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1512.19.0025",
      "rawHtsCode": "1512.19.00.25",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1512.19.0035",
      "rawHtsCode": "1512.19.00.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1512.19.0040",
      "rawHtsCode": "1512.19.00.40",
      "superior": null,
      "indent": "3",
      "description": "Safflower oil",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1512.21.0000",
      "rawHtsCode": "1512.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crude oil, whether or not gossypol has been removed",
      "units": [
        "kg"
      ],
      "generalRate": "5.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1512.29.00",
      "rawHtsCode": "1512.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1512.29.0020",
      "rawHtsCode": "1512.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Once-refined (subjected to alkalai or caustic wash, but not bleached or deodorized)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1512.29.0040",
      "rawHtsCode": "1512.29.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other (fully refined, washed, bleached or deodorized)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1513",
      "rawHtsCode": "1513",
      "superior": null,
      "indent": "0",
      "description": "Coconut (copra), palm kernel or babassu oil, and fractions thereof, whether or not refined, but not chemically modified:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1513.11.0000",
      "rawHtsCode": "1513.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crude oil",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1513.19.00",
      "rawHtsCode": "1513.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1513.19.0030",
      "rawHtsCode": "1513.19.00.30",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1513.19.0090",
      "rawHtsCode": "1513.19.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1513.21.0000",
      "rawHtsCode": "1513.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crude oil",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1513.29.0000",
      "rawHtsCode": "1513.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1514",
      "rawHtsCode": "1514",
      "superior": null,
      "indent": "0",
      "description": "Rapeseed, colza or mustard oil, and fractions thereof, whether or not refined, but not chemically modified:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1514.11.0000",
      "rawHtsCode": "1514.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crude oil",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1514.19.0000",
      "rawHtsCode": "1514.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1514.91",
      "rawHtsCode": "1514.91",
      "superior": null,
      "indent": "2",
      "description": "Crude oil:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1514.91.1000",
      "rawHtsCode": "1514.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Imported to be used in the manufacture of rubber substitutes or lubricating oil",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1514.91.90",
      "rawHtsCode": "1514.91.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1514.91.9010",
      "rawHtsCode": "1514.91.90.10",
      "superior": null,
      "indent": "4",
      "description": "Rape or colza oil and its fractions",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1514.91.9020",
      "rawHtsCode": "1514.91.90.20",
      "superior": null,
      "indent": "4",
      "description": "Mustard seed oil and its fractions",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1514.99",
      "rawHtsCode": "1514.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1514.99.1000",
      "rawHtsCode": "1514.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Imported to be used in the manufacture of rubber substitutes or lubricating oil",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1514.99.50",
      "rawHtsCode": "1514.99.50",
      "superior": null,
      "indent": "4",
      "description": "Denatured",
      "units": [],
      "generalRate": "1.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "9.92¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1514.99.5010",
      "rawHtsCode": "1514.99.50.10",
      "superior": null,
      "indent": "5",
      "description": "Rape or colza oil and its fractions",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1514.99.5020",
      "rawHtsCode": "1514.99.50.20",
      "superior": null,
      "indent": "5",
      "description": "Mustard seed oil and its fractions",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1514.99.90",
      "rawHtsCode": "1514.99.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1514.99.9010",
      "rawHtsCode": "1514.99.90.10",
      "superior": null,
      "indent": "5",
      "description": "Rape or colza oil and its fractions",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1514.99.9020",
      "rawHtsCode": "1514.99.90.20",
      "superior": null,
      "indent": "5",
      "description": "Mustard seed oil and its fractions",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1515",
      "rawHtsCode": "1515",
      "superior": null,
      "indent": "0",
      "description": "Other fixed vegetable or microbial fats and oils (including jojoba oil) and their fractions, whether or not refined, but not chemically modified:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1515.11.0000",
      "rawHtsCode": "1515.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crude oil",
      "units": [
        "kg"
      ],
      "generalRate": "6.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1515.19.0000",
      "rawHtsCode": "1515.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1515.21.0000",
      "rawHtsCode": "1515.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crude oil",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1515.29.00",
      "rawHtsCode": "1515.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1515.29.0020",
      "rawHtsCode": "1515.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Once-refined (subjected to alkalai or caustic wash, but not bleached or deodorized)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1515.29.0040",
      "rawHtsCode": "1515.29.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other (fully refined, washed, bleached or deodorized)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1515.30.0000",
      "rawHtsCode": "1515.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Castor oil and its fractions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1515.50.0000",
      "rawHtsCode": "1515.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sesame oil and its fractions",
      "units": [
        "kg"
      ],
      "generalRate": "0.68¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1515.60.0500",
      "rawHtsCode": "1515.60.05.00",
      "superior": null,
      "indent": "1",
      "description": "Microbial fats and oils and their fractions",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1515.90",
      "rawHtsCode": "1515.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1515.90.2100",
      "rawHtsCode": "1515.90.21.00",
      "superior": null,
      "indent": "2",
      "description": "Nut oils",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1515.90.6000",
      "rawHtsCode": "1515.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Jojoba oil and its fractions",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1515.90.81",
      "rawHtsCode": "1515.90.81",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1515.90.8110",
      "rawHtsCode": "1515.90.81.10",
      "superior": null,
      "indent": "3",
      "description": "Hemp oil",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1515.90.8190",
      "rawHtsCode": "1515.90.81.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1516",
      "rawHtsCode": "1516",
      "superior": null,
      "indent": "0",
      "description": "Animal, vegetable or microbial fats and oils and their fractions, partly or wholly hydrogenated, inter-esterified, re-esterified or elaidinized, whether or not refined, but not further prepared:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1516.10.0000",
      "rawHtsCode": "1516.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Animal fats and oils and their fractions",
      "units": [
        "kg"
      ],
      "generalRate": "7¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1516.20",
      "rawHtsCode": "1516.20",
      "superior": null,
      "indent": "1",
      "description": "Vegetable fats and oils and their fractions:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1516.20.1000",
      "rawHtsCode": "1516.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Rapeseed oil",
      "units": [
        "kg"
      ],
      "generalRate": "7.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1516.20.9100",
      "rawHtsCode": "1516.20.91.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1516.30.0000",
      "rawHtsCode": "1516.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Microbial fats and oils and their fractions",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1517",
      "rawHtsCode": "1517",
      "superior": null,
      "indent": "0",
      "description": "Margarine; edible mixtures or preparations of animal, vegetable or microbial fats or oils or of fractions of different fats or oils of this chapter, other than edible fats or oils or their fractions of heading 1516:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.10.0000",
      "rawHtsCode": "1517.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Margarine, excluding liquid margarine",
      "units": [
        "kg"
      ],
      "generalRate": "12.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1517.90",
      "rawHtsCode": "1517.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.90.10",
      "rawHtsCode": "1517.90.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 5 percent or more by weight of soybean oil or any fraction thereof",
      "units": [],
      "generalRate": "18%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1517.90.1020",
      "rawHtsCode": "1517.90.10.20",
      "superior": null,
      "indent": "4",
      "description": "Salad and cooking oils",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.90.1040",
      "rawHtsCode": "1517.90.10.40",
      "superior": null,
      "indent": "5",
      "description": "Wholly of vegetable oils",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.90.1060",
      "rawHtsCode": "1517.90.10.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.90.1080",
      "rawHtsCode": "1517.90.10.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.90.20",
      "rawHtsCode": "1517.90.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1517.90.2020",
      "rawHtsCode": "1517.90.20.20",
      "superior": null,
      "indent": "4",
      "description": "Salad and cooking oils",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.90.2040",
      "rawHtsCode": "1517.90.20.40",
      "superior": null,
      "indent": "5",
      "description": "Wholly of vegetable oils",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.90.2060",
      "rawHtsCode": "1517.90.20.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.90.2080",
      "rawHtsCode": "1517.90.20.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.90.4500",
      "rawHtsCode": "1517.90.45.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "11¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1517.90.5000",
      "rawHtsCode": "1517.90.50.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "11¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1517.90.6000",
      "rawHtsCode": "1517.90.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "34.2¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,S,SG) See 9822.04.25 (AU) See 9918.04.60, 9918.04.68 (CO)",
      "otherRate": "40.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1517.90.90",
      "rawHtsCode": "1517.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1517.90.9015",
      "rawHtsCode": "1517.90.90.15",
      "superior": null,
      "indent": "4",
      "description": "Partially hydrogenated salad and cooking oil",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.90.9025",
      "rawHtsCode": "1517.90.90.25",
      "superior": null,
      "indent": "4",
      "description": "Soybean oil, wholly hydrogenated",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.90.9085",
      "rawHtsCode": "1517.90.90.85",
      "superior": null,
      "indent": "4",
      "description": "Cottonseed oil, wholly hydrogenated",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1517.90.9090",
      "rawHtsCode": "1517.90.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1518.00",
      "rawHtsCode": "1518.00",
      "superior": null,
      "indent": "0",
      "description": "Animal, vegetable or microbial fats and oils and their fractions, boiled, oxidized, dehydrated, sulfurized, blown, polymerized by heat in vacuum or in inert gas or otherwise chemically modified, excluding those of heading 1516; inedible mixtures or preparations of animal, vegetable or microbial fats or oils or of fractions of different fats or oils of this chapter, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1518.00.2000",
      "rawHtsCode": "1518.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of linseed or flaxseed oil",
      "units": [
        "kg"
      ],
      "generalRate": "6.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "9.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1518.00.4000",
      "rawHtsCode": "1518.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1520.00.0000",
      "rawHtsCode": "1520.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Glycerol, crude; glycerol waters and glycerol lyes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1521",
      "rawHtsCode": "1521",
      "superior": null,
      "indent": "0",
      "description": "Vegetable waxes (other than triglycerides), beeswax, other insect waxes and spermaceti, whether or not refined or colored:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1521.10.00",
      "rawHtsCode": "1521.10.00",
      "superior": null,
      "indent": "1",
      "description": "Vegetable waxes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1521.10.0020",
      "rawHtsCode": "1521.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Candelilla",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1521.10.0040",
      "rawHtsCode": "1521.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Carnauba",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1521.10.0060",
      "rawHtsCode": "1521.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1521.90",
      "rawHtsCode": "1521.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1521.90.2000",
      "rawHtsCode": "1521.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Bleached beeswax",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1521.90.4000",
      "rawHtsCode": "1521.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1522.00.0000",
      "rawHtsCode": "1522.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Degras; residues resulting from the treatment of fatty substances or animal or vegetable waxes",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1601.00",
      "rawHtsCode": "1601.00",
      "superior": null,
      "indent": "0",
      "description": "Sausages and similar products, of meat, meat offal, blood or insects; food preparations based on these products:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1601.00.20",
      "rawHtsCode": "1601.00.20",
      "superior": null,
      "indent": "1",
      "description": "Pork",
      "units": [],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1601.00.2010",
      "rawHtsCode": "1601.00.20.10",
      "superior": null,
      "indent": "2",
      "description": "Canned",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1601.00.2090",
      "rawHtsCode": "1601.00.20.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1601.00.40",
      "rawHtsCode": "1601.00.40",
      "superior": null,
      "indent": "2",
      "description": "Beef in airtight containers",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1601.00.4010",
      "rawHtsCode": "1601.00.40.10",
      "superior": null,
      "indent": "3",
      "description": "Canned",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1601.00.4090",
      "rawHtsCode": "1601.00.40.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1601.00.60",
      "rawHtsCode": "1601.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1601.00.6020",
      "rawHtsCode": "1601.00.60.20",
      "superior": null,
      "indent": "3",
      "description": "Beef",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1601.00.6060",
      "rawHtsCode": "1601.00.60.60",
      "superior": null,
      "indent": "4",
      "description": "Canned",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1601.00.6080",
      "rawHtsCode": "1601.00.60.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602",
      "rawHtsCode": "1602",
      "superior": null,
      "indent": "0",
      "description": "Other prepared or preserved meat, meat offal, blood or insects:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.10",
      "rawHtsCode": "1602.10",
      "superior": null,
      "indent": "1",
      "description": "Homogenized preparations:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.10.1000",
      "rawHtsCode": "1602.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Put up for retail sale as food suitable for infants or for dietetic purposes",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.10.50",
      "rawHtsCode": "1602.10.50",
      "superior": null,
      "indent": "2",
      "description": "Put up for retail sale as food suitable for young children",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.10.5060",
      "rawHtsCode": "1602.10.50.60",
      "superior": null,
      "indent": "3",
      "description": "Canned",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.10.5080",
      "rawHtsCode": "1602.10.50.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.20",
      "rawHtsCode": "1602.20",
      "superior": null,
      "indent": "1",
      "description": "Of liver of any animal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.20.2000",
      "rawHtsCode": "1602.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of goose",
      "units": [
        "kg"
      ],
      "generalRate": "4.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.20.4000",
      "rawHtsCode": "1602.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.31.00",
      "rawHtsCode": "1602.31.00",
      "superior": null,
      "indent": "2",
      "description": "Of turkeys",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.31.0020",
      "rawHtsCode": "1602.31.00.20",
      "superior": null,
      "indent": "3",
      "description": "Prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.31.0040",
      "rawHtsCode": "1602.31.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.32.00",
      "rawHtsCode": "1602.32.00",
      "superior": null,
      "indent": "2",
      "description": "Of chickens",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.32.0010",
      "rawHtsCode": "1602.32.00.10",
      "superior": null,
      "indent": "4",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.32.0030",
      "rawHtsCode": "1602.32.00.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.32.0040",
      "rawHtsCode": "1602.32.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.39.00",
      "rawHtsCode": "1602.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.39.0015",
      "rawHtsCode": "1602.39.00.15",
      "superior": null,
      "indent": "4",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.39.0035",
      "rawHtsCode": "1602.39.00.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.39.0045",
      "rawHtsCode": "1602.39.00.45",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.41",
      "rawHtsCode": "1602.41",
      "superior": null,
      "indent": "2",
      "description": "Hams and cuts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.41.1000",
      "rawHtsCode": "1602.41.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing cereals or vegetables",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.41.20",
      "rawHtsCode": "1602.41.20",
      "superior": null,
      "indent": "4",
      "description": "Boned and cooked and packed in airtight containers",
      "units": [],
      "generalRate": "5.3¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.41.2020",
      "rawHtsCode": "1602.41.20.20",
      "superior": null,
      "indent": "5",
      "description": "In containers holding less than 1 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.41.2040",
      "rawHtsCode": "1602.41.20.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.41.9000",
      "rawHtsCode": "1602.41.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "7.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.42",
      "rawHtsCode": "1602.42",
      "superior": null,
      "indent": "2",
      "description": "Shoulders and cuts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.42.20",
      "rawHtsCode": "1602.42.20",
      "superior": null,
      "indent": "3",
      "description": "Boned and cooked and packed in airtight containers",
      "units": [],
      "generalRate": "4.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.42.2020",
      "rawHtsCode": "1602.42.20.20",
      "superior": null,
      "indent": "4",
      "description": "In containers holding less than 1 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.42.2040",
      "rawHtsCode": "1602.42.20.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.42.4000",
      "rawHtsCode": "1602.42.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "7.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.49",
      "rawHtsCode": "1602.49",
      "superior": null,
      "indent": "2",
      "description": "Other, including mixtures:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.49.1000",
      "rawHtsCode": "1602.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Offal",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.49.2000",
      "rawHtsCode": "1602.49.20.00",
      "superior": null,
      "indent": "5",
      "description": "Boned and cooked and packed in air- tight containers",
      "units": [
        "kg"
      ],
      "generalRate": "4.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.49.4000",
      "rawHtsCode": "1602.49.40.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.49.6000",
      "rawHtsCode": "1602.49.60.00",
      "superior": null,
      "indent": "5",
      "description": "Mixtures of pork and beef",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.49.9000",
      "rawHtsCode": "1602.49.90.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.50",
      "rawHtsCode": "1602.50",
      "superior": null,
      "indent": "1",
      "description": "Of bovine animals :",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.50.0500",
      "rawHtsCode": "1602.50.05.00",
      "superior": null,
      "indent": "2",
      "description": "Offal",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.50.07",
      "rawHtsCode": "1602.50.07",
      "superior": null,
      "indent": "5",
      "description": "Corned beef in airtight containers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1602.50.0720",
      "rawHtsCode": "1602.50.07.20",
      "superior": null,
      "indent": "6",
      "description": "In containers holding less than 1 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.50.0740",
      "rawHtsCode": "1602.50.07.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.50.0800",
      "rawHtsCode": "1602.50.08.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.50.21",
      "rawHtsCode": "1602.50.21",
      "superior": null,
      "indent": "5",
      "description": "In airtight containers",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.50.2120",
      "rawHtsCode": "1602.50.21.20",
      "superior": null,
      "indent": "6",
      "description": "In containers holding less than 1 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.50.2140",
      "rawHtsCode": "1602.50.21.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.50.6000",
      "rawHtsCode": "1602.50.60.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.50.90",
      "rawHtsCode": "1602.50.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.50.9020",
      "rawHtsCode": "1602.50.90.20",
      "superior": null,
      "indent": "4",
      "description": "Prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.50.9040",
      "rawHtsCode": "1602.50.90.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.90",
      "rawHtsCode": "1602.90",
      "superior": null,
      "indent": "1",
      "description": "Other, including preparations of blood of any animal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.90.1000",
      "rawHtsCode": "1602.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Frog meat",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.90.91",
      "rawHtsCode": "1602.90.91",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1602.90.9160",
      "rawHtsCode": "1602.90.91.60",
      "superior": null,
      "indent": "3",
      "description": "Canned",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1602.90.9180",
      "rawHtsCode": "1602.90.91.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1603.00",
      "rawHtsCode": "1603.00",
      "superior": null,
      "indent": "0",
      "description": "Extracts and juices of meat, fish or crustaceans, molluscs or other aquatic invertebrates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1603.00.1000",
      "rawHtsCode": "1603.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Clam juice",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1603.00.90",
      "rawHtsCode": "1603.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "13%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1603.00.9010",
      "rawHtsCode": "1603.00.90.10",
      "superior": null,
      "indent": "2",
      "description": "Of meat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1603.00.9090",
      "rawHtsCode": "1603.00.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604",
      "rawHtsCode": "1604",
      "superior": null,
      "indent": "0",
      "description": "Prepared or preserved fish; caviar and caviar substitutes prepared from fish eggs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.11",
      "rawHtsCode": "1604.11",
      "superior": null,
      "indent": "2",
      "description": "Salmon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.11.20",
      "rawHtsCode": "1604.11.20",
      "superior": null,
      "indent": "3",
      "description": "In oil, in airtight containers",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.11.2020",
      "rawHtsCode": "1604.11.20.20",
      "superior": null,
      "indent": "4",
      "description": "Pink (humpie)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.11.2030",
      "rawHtsCode": "1604.11.20.30",
      "superior": null,
      "indent": "4",
      "description": "Sockeye",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.11.2090",
      "rawHtsCode": "1604.11.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.11.40",
      "rawHtsCode": "1604.11.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.11.4010",
      "rawHtsCode": "1604.11.40.10",
      "superior": null,
      "indent": "5",
      "description": "Chum (dog)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.11.4020",
      "rawHtsCode": "1604.11.40.20",
      "superior": null,
      "indent": "5",
      "description": "Pink (humpie)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.11.4030",
      "rawHtsCode": "1604.11.40.30",
      "superior": null,
      "indent": "5",
      "description": "Sockeye",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.11.4040",
      "rawHtsCode": "1604.11.40.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.11.4050",
      "rawHtsCode": "1604.11.40.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.12",
      "rawHtsCode": "1604.12",
      "superior": null,
      "indent": "2",
      "description": "Herrings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.12.2000",
      "rawHtsCode": "1604.12.20.00",
      "superior": null,
      "indent": "3",
      "description": "In oil, in airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.12.4000",
      "rawHtsCode": "1604.12.40.00",
      "superior": null,
      "indent": "4",
      "description": "In tomato sauce, smoked or kippered, and in immediate containers weighing with their contents over 0.45 kg each",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.12.60",
      "rawHtsCode": "1604.12.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.12.6010",
      "rawHtsCode": "1604.12.60.10",
      "superior": null,
      "indent": "6",
      "description": "Fillets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.12.6030",
      "rawHtsCode": "1604.12.60.30",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.12.6050",
      "rawHtsCode": "1604.12.60.50",
      "superior": null,
      "indent": "6",
      "description": "Kipper snacks",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.12.6090",
      "rawHtsCode": "1604.12.60.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.13",
      "rawHtsCode": "1604.13",
      "superior": null,
      "indent": "2",
      "description": "Sardines, sardinella and brisling or sprats:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.13.1000",
      "rawHtsCode": "1604.13.10.00",
      "superior": null,
      "indent": "4",
      "description": "Smoked sardines, neither skinned nor boned, valued $1 or more per kg in tin- plate containers, or $1.10 or more per kg in other containers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.13.2000",
      "rawHtsCode": "1604.13.20.00",
      "superior": null,
      "indent": "5",
      "description": "Neither skinned nor boned",
      "units": [
        "kg"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.13.3000",
      "rawHtsCode": "1604.13.30.00",
      "superior": null,
      "indent": "5",
      "description": "Skinned or boned",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.13.4000",
      "rawHtsCode": "1604.13.40.00",
      "superior": null,
      "indent": "4",
      "description": "In immediate containers weighing with their contents under 225 grams each",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.13.9000",
      "rawHtsCode": "1604.13.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.14",
      "rawHtsCode": "1604.14",
      "superior": null,
      "indent": "2",
      "description": "Tunas, skipjack tuna and bonito (<i>Sarda spp</i>.):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.14.10",
      "rawHtsCode": "1604.14.10",
      "superior": null,
      "indent": "5",
      "description": "In oil",
      "units": [],
      "generalRate": "35%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.14.1010",
      "rawHtsCode": "1604.14.10.10",
      "superior": null,
      "indent": "6",
      "description": "In foil or other flexible containers weighing with their contents not more than 6.8 kg each",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.14.1091",
      "rawHtsCode": "1604.14.10.91",
      "superior": null,
      "indent": "7",
      "description": "Albacore",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.14.1099",
      "rawHtsCode": "1604.14.10.99",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.14.22",
      "rawHtsCode": "1604.14.22",
      "superior": null,
      "indent": "6",
      "description": "In containers weighing with their contents not over 7 kg each, and not the product of any insular possession of the United States, for an aggregate quantity entered in any calendar year not to exceed 4.8 percent of apparent United States consumption of tuna in airtight containers during the immediately preceding year, as reported by the National Marine Fisheries Service",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.14.2251",
      "rawHtsCode": "1604.14.22.51",
      "superior": null,
      "indent": "8",
      "description": "In foil or other flexible con- tainers weighing with their contents not more than <il>6.8 kg each</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.14.2259",
      "rawHtsCode": "1604.14.22.59",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.14.2291",
      "rawHtsCode": "1604.14.22.91",
      "superior": null,
      "indent": "8",
      "description": "In foil or other flexible con- tainers weighing with their contents not more than 6.8 kg each",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.14.2299",
      "rawHtsCode": "1604.14.22.99",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.14.30",
      "rawHtsCode": "1604.14.30",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.14.3051",
      "rawHtsCode": "1604.14.30.51",
      "superior": null,
      "indent": "8",
      "description": "In foil or other flexible con- tainers weighing with their contents not more than 6.8 kg each",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.14.3059",
      "rawHtsCode": "1604.14.30.59",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.14.3091",
      "rawHtsCode": "1604.14.30.91",
      "superior": null,
      "indent": "8",
      "description": "In foil or other flexible con- tainers weighing with their contents not more than 6.8 kg each",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.14.3099",
      "rawHtsCode": "1604.14.30.99",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.14.4000",
      "rawHtsCode": "1604.14.40.00",
      "superior": null,
      "indent": "5",
      "description": "In bulk or in immediate containers weighing with their contents over <il>6.8 kg</il> each, not in oil",
      "units": [
        "kg"
      ],
      "generalRate": "1.1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.14.5000",
      "rawHtsCode": "1604.14.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.14.7000",
      "rawHtsCode": "1604.14.70.00",
      "superior": null,
      "indent": "4",
      "description": "In oil",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.14.8000",
      "rawHtsCode": "1604.14.80.00",
      "superior": null,
      "indent": "4",
      "description": "Not in oil",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.15.0000",
      "rawHtsCode": "1604.15.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mackerel",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.16",
      "rawHtsCode": "1604.16",
      "superior": null,
      "indent": "2",
      "description": "Anchovies:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.16.2000",
      "rawHtsCode": "1604.16.20.00",
      "superior": null,
      "indent": "3",
      "description": "In oil, in airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.16.4000",
      "rawHtsCode": "1604.16.40.00",
      "superior": null,
      "indent": "4",
      "description": "In immediate containers weighing with their contents 6.8 kg or less each",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.16.6000",
      "rawHtsCode": "1604.16.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.17",
      "rawHtsCode": "1604.17",
      "superior": null,
      "indent": "2",
      "description": "Eels:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.17.1000",
      "rawHtsCode": "1604.17.10.00",
      "superior": null,
      "indent": "3",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.17.4000",
      "rawHtsCode": "1604.17.40.00",
      "superior": null,
      "indent": "5",
      "description": "Neither cooked nor in oil",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.17.5000",
      "rawHtsCode": "1604.17.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.17.6000",
      "rawHtsCode": "1604.17.60.00",
      "superior": null,
      "indent": "5",
      "description": "In oil and in bulk or in immediate containers over 7 kg each",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.17.8000",
      "rawHtsCode": "1604.17.80.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.18",
      "rawHtsCode": "1604.18",
      "superior": null,
      "indent": "2",
      "description": "Shark fins:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.18.1000",
      "rawHtsCode": "1604.18.10.00",
      "superior": null,
      "indent": "3",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.18.9000",
      "rawHtsCode": "1604.18.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.19",
      "rawHtsCode": "1604.19",
      "superior": null,
      "indent": "2",
      "description": "Other (including yellowtail):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.19.1000",
      "rawHtsCode": "1604.19.10.00",
      "superior": null,
      "indent": "5",
      "description": "Bonito, yellowtail and pollock",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.19.2200",
      "rawHtsCode": "1604.19.22.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.19.2500",
      "rawHtsCode": "1604.19.25.00",
      "superior": null,
      "indent": "5",
      "description": "Bonito, yellowtail and pollock",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.19.3200",
      "rawHtsCode": "1604.19.32.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.19.4100",
      "rawHtsCode": "1604.19.41.00",
      "superior": null,
      "indent": "5",
      "description": "Neither cooked nor in oil",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.19.5100",
      "rawHtsCode": "1604.19.51.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.19.6100",
      "rawHtsCode": "1604.19.61.00",
      "superior": null,
      "indent": "5",
      "description": "In oil and in bulk or in immediate containers weighing with their contents over <il>7 kg</il> each",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.19.8200",
      "rawHtsCode": "1604.19.82.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.20",
      "rawHtsCode": "1604.20",
      "superior": null,
      "indent": "1",
      "description": "Other prepared or preserved fish:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.20.05",
      "rawHtsCode": "1604.20.05",
      "superior": null,
      "indent": "2",
      "description": "Products containing meat of crustaceans, molluscs or other aquatic invertebrates; prepared meals",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.20.0510",
      "rawHtsCode": "1604.20.05.10",
      "superior": null,
      "indent": "3",
      "description": "Prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.20.0590",
      "rawHtsCode": "1604.20.05.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.20.1000",
      "rawHtsCode": "1604.20.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pastes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.20.1500",
      "rawHtsCode": "1604.20.15.00",
      "superior": null,
      "indent": "4",
      "description": "In oil",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.20.2000",
      "rawHtsCode": "1604.20.20.00",
      "superior": null,
      "indent": "6",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.20.2500",
      "rawHtsCode": "1604.20.25.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.20.3000",
      "rawHtsCode": "1604.20.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.20.4000",
      "rawHtsCode": "1604.20.40.00",
      "superior": null,
      "indent": "4",
      "description": "Neither cooked nor in oil",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.20.50",
      "rawHtsCode": "1604.20.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.20.5010",
      "rawHtsCode": "1604.20.50.10",
      "superior": null,
      "indent": "5",
      "description": "Pre-cooked and frozen",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.20.5090",
      "rawHtsCode": "1604.20.50.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.20.60",
      "rawHtsCode": "1604.20.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.20.6010",
      "rawHtsCode": "1604.20.60.10",
      "superior": null,
      "indent": "4",
      "description": "Pre-cooked and frozen",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.20.6090",
      "rawHtsCode": "1604.20.60.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.31.0000",
      "rawHtsCode": "1604.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Caviar",
      "units": [
        "kg"
      ],
      "generalRate": "15%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1604.32",
      "rawHtsCode": "1604.32",
      "superior": null,
      "indent": "2",
      "description": "Caviar substitutes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1604.32.3000",
      "rawHtsCode": "1604.32.30.00",
      "superior": null,
      "indent": "3",
      "description": "Boiled and in airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1604.32.4000",
      "rawHtsCode": "1604.32.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "44¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605",
      "rawHtsCode": "1605",
      "superior": null,
      "indent": "0",
      "description": "Crustaceans, molluscs and other aquatic invertebrates, prepared or preserved:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10",
      "rawHtsCode": "1605.10",
      "superior": null,
      "indent": "1",
      "description": "Crab:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.05",
      "rawHtsCode": "1605.10.05",
      "superior": null,
      "indent": "2",
      "description": "Products containing fish meat; prepared meals",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1605.10.0510",
      "rawHtsCode": "1605.10.05.10",
      "superior": null,
      "indent": "3",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.0590",
      "rawHtsCode": "1605.10.05.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.20",
      "rawHtsCode": "1605.10.20",
      "superior": null,
      "indent": "4",
      "description": "In airtight containers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "22.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.10.2010",
      "rawHtsCode": "1605.10.20.10",
      "superior": null,
      "indent": "5",
      "description": "King crab",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.10.2022",
      "rawHtsCode": "1605.10.20.22",
      "superior": null,
      "indent": "6",
      "description": "<u>C.</u> <u>opilio</u> (small)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.10.2025",
      "rawHtsCode": "1605.10.20.25",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.2030",
      "rawHtsCode": "1605.10.20.30",
      "superior": null,
      "indent": "5",
      "description": "Dungeness",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.10.2051",
      "rawHtsCode": "1605.10.20.51",
      "superior": null,
      "indent": "6",
      "description": "<u>Callinectes</u> <i>spp</i>., including blue crabs (<u>C</u>. <u>sapidus</u>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.2059",
      "rawHtsCode": "1605.10.20.59",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.2090",
      "rawHtsCode": "1605.10.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69.           "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.10.40",
      "rawHtsCode": "1605.10.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1605.10.4002",
      "rawHtsCode": "1605.10.40.02",
      "superior": null,
      "indent": "6",
      "description": "King crab",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.4005",
      "rawHtsCode": "1605.10.40.05",
      "superior": null,
      "indent": "7",
      "description": "<u>C.</u> <u>opilio</u> (small)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.4010",
      "rawHtsCode": "1605.10.40.10",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.4015",
      "rawHtsCode": "1605.10.40.15",
      "superior": null,
      "indent": "6",
      "description": "Dungeness",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.4025",
      "rawHtsCode": "1605.10.40.25",
      "superior": null,
      "indent": "7",
      "description": "<u>Callinectes</u> <i>spp</i>., including blue crabs (<u>C</u>. <u>sapidus</u>)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.4030",
      "rawHtsCode": "1605.10.40.30",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.4035",
      "rawHtsCode": "1605.10.40.35",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.4040",
      "rawHtsCode": "1605.10.40.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.60",
      "rawHtsCode": "1605.10.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.10.6010",
      "rawHtsCode": "1605.10.60.10",
      "superior": null,
      "indent": "4",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.10.6090",
      "rawHtsCode": "1605.10.60.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.21",
      "rawHtsCode": "1605.21",
      "superior": null,
      "indent": "2",
      "description": "Not in airtight containers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.21.0500",
      "rawHtsCode": "1605.21.05.00",
      "superior": null,
      "indent": "3",
      "description": "Products containing fish meat; prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1605.21.10",
      "rawHtsCode": "1605.21.10",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.21.1020",
      "rawHtsCode": "1605.21.10.20",
      "superior": null,
      "indent": "5",
      "description": "Breaded",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.21.1030",
      "rawHtsCode": "1605.21.10.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.21.1050",
      "rawHtsCode": "1605.21.10.50",
      "superior": null,
      "indent": "4",
      "description": "Other, imported in accordance with statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.29",
      "rawHtsCode": "1605.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.29.0500",
      "rawHtsCode": "1605.29.05.00",
      "superior": null,
      "indent": "3",
      "description": "Products containing fish meat; prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1605.29.10",
      "rawHtsCode": "1605.29.10",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.29.1010",
      "rawHtsCode": "1605.29.10.10",
      "superior": null,
      "indent": "4",
      "description": "Frozen, imported in accordance with statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.29.1040",
      "rawHtsCode": "1605.29.10.40",
      "superior": null,
      "indent": "4",
      "description": "Other, imported in accordance with statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.30",
      "rawHtsCode": "1605.30",
      "superior": null,
      "indent": "1",
      "description": "Lobster:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.30.05",
      "rawHtsCode": "1605.30.05",
      "superior": null,
      "indent": "2",
      "description": "Products containing fish meat; prepared meals",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1605.30.0510",
      "rawHtsCode": "1605.30.05.10",
      "superior": null,
      "indent": "3",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.30.0590",
      "rawHtsCode": "1605.30.05.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.30.10",
      "rawHtsCode": "1605.30.10",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.30.1010",
      "rawHtsCode": "1605.30.10.10",
      "superior": null,
      "indent": "4",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.30.1030",
      "rawHtsCode": "1605.30.10.30",
      "superior": null,
      "indent": "4",
      "description": "Not frozen",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.30.1050",
      "rawHtsCode": "1605.30.10.50",
      "superior": null,
      "indent": "4",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.30.1090",
      "rawHtsCode": "1605.30.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.40",
      "rawHtsCode": "1605.40",
      "superior": null,
      "indent": "1",
      "description": "Other crustaceans:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.40.0500",
      "rawHtsCode": "1605.40.05.00",
      "superior": null,
      "indent": "2",
      "description": "Products containing fish meat; prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.40.10",
      "rawHtsCode": "1605.40.10",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.40.1010",
      "rawHtsCode": "1605.40.10.10",
      "superior": null,
      "indent": "3",
      "description": "Peeled freshwater crawfish tail meat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.40.1090",
      "rawHtsCode": "1605.40.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.51",
      "rawHtsCode": "1605.51",
      "superior": null,
      "indent": "2",
      "description": "Oysters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.51.0500",
      "rawHtsCode": "1605.51.05.00",
      "superior": null,
      "indent": "3",
      "description": "Products containing fish meat; prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.51.4000",
      "rawHtsCode": "1605.51.40.00",
      "superior": null,
      "indent": "4",
      "description": "Smoked",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "7.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.51.5000",
      "rawHtsCode": "1605.51.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1605.52",
      "rawHtsCode": "1605.52",
      "superior": null,
      "indent": "2",
      "description": "Scallops, including queen scallops:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.52.0500",
      "rawHtsCode": "1605.52.05.00",
      "superior": null,
      "indent": "3",
      "description": "Products containing fish meat; prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.52.6000",
      "rawHtsCode": "1605.52.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.53",
      "rawHtsCode": "1605.53",
      "superior": null,
      "indent": "2",
      "description": "Mussels:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.53.0500",
      "rawHtsCode": "1605.53.05.00",
      "superior": null,
      "indent": "3",
      "description": "Products containing fish meat; prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.53.6000",
      "rawHtsCode": "1605.53.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.54",
      "rawHtsCode": "1605.54",
      "superior": null,
      "indent": "2",
      "description": "Cuttle fish and squid:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.54.0500",
      "rawHtsCode": "1605.54.05.00",
      "superior": null,
      "indent": "3",
      "description": "Products containing fish meat; prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.54.60",
      "rawHtsCode": "1605.54.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.54.6010",
      "rawHtsCode": "1605.54.60.10",
      "superior": null,
      "indent": "4",
      "description": "Cuttle fish",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.54.6020",
      "rawHtsCode": "1605.54.60.20",
      "superior": null,
      "indent": "5",
      "description": "Loligo",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.54.6030",
      "rawHtsCode": "1605.54.60.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.55",
      "rawHtsCode": "1605.55",
      "superior": null,
      "indent": "2",
      "description": "Octopus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.55.0500",
      "rawHtsCode": "1605.55.05.00",
      "superior": null,
      "indent": "3",
      "description": "Products containing fish meat; prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.55.6000",
      "rawHtsCode": "1605.55.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.56",
      "rawHtsCode": "1605.56",
      "superior": null,
      "indent": "2",
      "description": "Clams, cockles and arkshells:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.56.0500",
      "rawHtsCode": "1605.56.05.00",
      "superior": null,
      "indent": "3",
      "description": "Products containing fish meat; prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.56.1000",
      "rawHtsCode": "1605.56.10.00",
      "superior": null,
      "indent": "6",
      "description": "Razor clams (<u>Siliqua</u> <u>patula</u>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "23%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.56.1500",
      "rawHtsCode": "1605.56.15.00",
      "superior": null,
      "indent": "7",
      "description": "Boiled clams, whether whole, minced or chopped, and whether or not salted, but not otherwise prepared or preserved, in immediate containers, the contents of each container not exceeding 680 grams gross weight",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1605.56.2000",
      "rawHtsCode": "1605.56.20.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.56.3000",
      "rawHtsCode": "1605.56.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.56.6000",
      "rawHtsCode": "1605.56.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.57",
      "rawHtsCode": "1605.57",
      "superior": null,
      "indent": "2",
      "description": "Abalone:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.57.0500",
      "rawHtsCode": "1605.57.05.00",
      "superior": null,
      "indent": "3",
      "description": "Products containing fish meat; prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.57.6000",
      "rawHtsCode": "1605.57.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.58",
      "rawHtsCode": "1605.58",
      "superior": null,
      "indent": "2",
      "description": "Snails, other than sea snails:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.58.0500",
      "rawHtsCode": "1605.58.05.00",
      "superior": null,
      "indent": "3",
      "description": "Products containing fish meat; prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.58.5500",
      "rawHtsCode": "1605.58.55.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1605.59",
      "rawHtsCode": "1605.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1605.59.0500",
      "rawHtsCode": "1605.59.05.00",
      "superior": null,
      "indent": "3",
      "description": "Products containing fish meat; prepared meals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.59.6000",
      "rawHtsCode": "1605.59.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1605.61.0000",
      "rawHtsCode": "1605.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sea cucumbers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.62.0000",
      "rawHtsCode": "1605.62.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sea urchins",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.63.0000",
      "rawHtsCode": "1605.63.00.00",
      "superior": null,
      "indent": "2",
      "description": "Jellyfish",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1605.69.0000",
      "rawHtsCode": "1605.69.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1701",
      "rawHtsCode": "1701",
      "superior": null,
      "indent": "0",
      "description": "Cane or beet sugar and chemically pure sucrose, in solid form:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.12",
      "rawHtsCode": "1701.12",
      "superior": null,
      "indent": "2",
      "description": "Beet sugar:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.12.0500",
      "rawHtsCode": "1701.12.05.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.6606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 3.143854¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.58170¢/kg less 0.0622005¢ /kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 5.031562¢ /kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.12.1000",
      "rawHtsCode": "1701.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.6606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 3.143854¢/kg",
      "specialRate": "Free (A*,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG) See 9822.05.15 (P+)",
      "otherRate": "6.58170¢/kg less 0.0622005¢ /kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 5.031562¢ /kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.12.5000",
      "rawHtsCode": "1701.12.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "35.74¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.09.01-9823.09.09 (S+) See 9822.03.01(MA)",
      "otherRate": "42.05¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.08-9904.17.16. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.13",
      "rawHtsCode": "1701.13",
      "superior": null,
      "indent": "2",
      "description": "Cane sugar specified in subheading note 2 to this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.13.0500",
      "rawHtsCode": "1701.13.05.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "1.4606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 0.943854¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.3817¢/kg less 0.0622005¢ /kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 2.831562¢ /kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.13.1000",
      "rawHtsCode": "1701.13.10.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "1.4606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 0.943854¢/kg",
      "specialRate": "Free (A*,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG) See 9822.05.15 (P+)",
      "otherRate": "4.3817¢/kg less 0.0622005¢ /kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less 2.831562¢ /kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.13.2000",
      "rawHtsCode": "1701.13.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other sugar to be used for the production (other than by distillation) of polyhydric alcohols, except polyhydric alcohols for use as a substitute for sugar in human food consumption, or to be refined and re-exported in refined form or in sugar-containing products, or to be substituted for domestically produced raw cane sugar that has been or will be exported",
      "units": [
        "kg"
      ],
      "generalRate": "1.4606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 0.943854¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.3817¢/kg less 0.0622005¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 2.831562¢ /kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.13.5000",
      "rawHtsCode": "1701.13.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "33.87¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.09.01-9823.09.09 (S+) See 9822.03.01(MA)",
      "otherRate": "39.85¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.01-9904.17.07. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.14",
      "rawHtsCode": "1701.14",
      "superior": null,
      "indent": "2",
      "description": "Other cane sugar:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.14.0500",
      "rawHtsCode": "1701.14.05.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "1.4606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 0.943854¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.3817¢/kg less 0.0622005¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 2.831562¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.14.10",
      "rawHtsCode": "1701.14.10",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "1.4606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 0.943854¢/kg",
      "specialRate": "Free (A*,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG) See 9822.05.15 (P+)",
      "otherRate": "4.3817¢/kg less 0.0622005¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 2.831562¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.14.1020",
      "rawHtsCode": "1701.14.10.20",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.14.1040",
      "rawHtsCode": "1701.14.10.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.14.2000",
      "rawHtsCode": "1701.14.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other sugar to be used for the production (other than by distillation) of polyhydric alcohols, except polyhydric alcohols for use as a substitute for sugar in human food consumption, or to be refined and re-exported in refined form or in sugar-containing products, or to be substituted for domestically produced raw cane sugar that has been or will be exported",
      "units": [
        "kg"
      ],
      "generalRate": "1.4606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 0.943854¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.3817¢/kg less 0.0622005¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 2.831562¢ /kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.14.5000",
      "rawHtsCode": "1701.14.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "33.87¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.09.01-9823.09.09 (S+) See 9822.03.01 (MA)",
      "otherRate": "39.85¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.01-9904.17.07. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.91",
      "rawHtsCode": "1701.91",
      "superior": null,
      "indent": "2",
      "description": "Containing added flavoring or coloring matter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.91.0500",
      "rawHtsCode": "1701.91.05.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.6606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 3.143854¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.58170¢/kg less 0.0622005¢ /kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 5.031562¢ /kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.91.1000",
      "rawHtsCode": "1701.91.10.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.6606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 3.143854¢/kg",
      "specialRate": "Free (A*,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG) See 9822.05.15 (P+)",
      "otherRate": "6.58170¢/kg less 0.0622005¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 5.031562¢ /kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.91.3000",
      "rawHtsCode": "1701.91.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "35.74¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.09.01-9823.09.09 (S+) See 9822.03.01(MA)",
      "otherRate": "42.05¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.08-9904.17.16. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.91.4200",
      "rawHtsCode": "1701.91.42.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.91.4400",
      "rawHtsCode": "1701.91.44.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 7 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (OM,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.91.4800",
      "rawHtsCode": "1701.91.48.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "33.9¢/kg + 5.1%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "39.9¢/kg +6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.91.5200",
      "rawHtsCode": "1701.91.52.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.91.5400",
      "rawHtsCode": "1701.91.54.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 8 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.91.5800",
      "rawHtsCode": "1701.91.58.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "33.9¢/kg + 5.1%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "39.9¢/kg +6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.49-9904.17.65. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.91.8000",
      "rawHtsCode": "1701.91.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.99",
      "rawHtsCode": "1701.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.99.0500",
      "rawHtsCode": "1701.99.05.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.6606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 3.143854¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.58170¢/kg less 0.0622005¢ /kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 5.031562¢ /kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.99.10",
      "rawHtsCode": "1701.99.10",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "3.6606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 3.143854¢/kg",
      "specialRate": "Free (A*,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG) See 9822.05.15 (P+)",
      "otherRate": "6.58170¢/kg less 0.0622005¢ /kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 5.031562¢ /kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.99.1015",
      "rawHtsCode": "1701.99.10.15",
      "superior": null,
      "indent": "5",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.99.1017",
      "rawHtsCode": "1701.99.10.17",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.99.1025",
      "rawHtsCode": "1701.99.10.25",
      "superior": null,
      "indent": "5",
      "description": "Sugar not for further processing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.99.1050",
      "rawHtsCode": "1701.99.10.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.99.50",
      "rawHtsCode": "1701.99.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "35.74¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.09.01-9823.09.09 (S+) See 9822.03.01(MA)",
      "otherRate": "42.05¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.08-9904.17.16. ",
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1701.99.5015",
      "rawHtsCode": "1701.99.50.15",
      "superior": null,
      "indent": "5",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.99.5017",
      "rawHtsCode": "1701.99.50.17",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.99.5025",
      "rawHtsCode": "1701.99.50.25",
      "superior": null,
      "indent": "5",
      "description": "Sugar not for further processing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1701.99.5050",
      "rawHtsCode": "1701.99.50.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702",
      "rawHtsCode": "1702",
      "superior": null,
      "indent": "0",
      "description": "Other sugars, including chemically pure lactose, maltose, glucose and fructose, in solid form; sugar syrups not containing added flavoring or coloring matter; artificial honey, whether or not mixed with natural honey; caramel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.11.0000",
      "rawHtsCode": "1702.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight 99 percent or more lactose, expressed as anhydrous lactose, calculated on the dry matter",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.19.0000",
      "rawHtsCode": "1702.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.20",
      "rawHtsCode": "1702.20",
      "superior": null,
      "indent": "1",
      "description": "Maple sugar and maple syrup:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.20.22",
      "rawHtsCode": "1702.20.22",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.20.2210",
      "rawHtsCode": "1702.20.22.10",
      "superior": null,
      "indent": "4",
      "description": "Maple sugar",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.20.2290",
      "rawHtsCode": "1702.20.22.90",
      "superior": null,
      "indent": "4",
      "description": "Maple syrup",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.20.24",
      "rawHtsCode": "1702.20.24",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 9 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (OM,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.20.2410",
      "rawHtsCode": "1702.20.24.10",
      "superior": null,
      "indent": "4",
      "description": "Maple sugar",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.20.2490",
      "rawHtsCode": "1702.20.24.90",
      "superior": null,
      "indent": "4",
      "description": "Maple syrup",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.20.28",
      "rawHtsCode": "1702.20.28",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "16.9¢/kg of total sugars + 5.1%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01 (MA)",
      "otherRate": "19.9¢/kg of total sugars + 6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.66-9904.17.84. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.20.2810",
      "rawHtsCode": "1702.20.28.10",
      "superior": null,
      "indent": "4",
      "description": "Maple sugar",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.20.2890",
      "rawHtsCode": "1702.20.28.90",
      "superior": null,
      "indent": "4",
      "description": "Maple syrup",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.20.40",
      "rawHtsCode": "1702.20.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1702.20.4010",
      "rawHtsCode": "1702.20.40.10",
      "superior": null,
      "indent": "3",
      "description": "Maple sugar",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.20.4040",
      "rawHtsCode": "1702.20.40.40",
      "superior": null,
      "indent": "5",
      "description": "In containers over 5 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.20.4050",
      "rawHtsCode": "1702.20.40.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.20.4060",
      "rawHtsCode": "1702.20.40.60",
      "superior": null,
      "indent": "5",
      "description": "In containers over 5 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.20.4070",
      "rawHtsCode": "1702.20.40.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.30",
      "rawHtsCode": "1702.30",
      "superior": null,
      "indent": "1",
      "description": "Glucose and glucose syrup, not containing fructose or containing in the dry state less than 20 percent by weight of fructose:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.30.2200",
      "rawHtsCode": "1702.30.22.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.30.2400",
      "rawHtsCode": "1702.30.24.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 9 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (OM,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.30.2800",
      "rawHtsCode": "1702.30.28.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "16.9¢/kg of total sugars + 5.1%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "19.9¢/kg of total sugars + 6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.66-9904.17.84. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.30.40",
      "rawHtsCode": "1702.30.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.30.4045",
      "rawHtsCode": "1702.30.40.45",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.30.4065",
      "rawHtsCode": "1702.30.40.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.30.4075",
      "rawHtsCode": "1702.30.40.75",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.30.4085",
      "rawHtsCode": "1702.30.40.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.40",
      "rawHtsCode": "1702.40",
      "superior": null,
      "indent": "1",
      "description": "Glucose and glucose syrup, containing in the dry state at least 20 percent but less than 50 percent by weight of fructose, excluding invert sugar:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.40.2200",
      "rawHtsCode": "1702.40.22.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.40.2400",
      "rawHtsCode": "1702.40.24.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 9 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (OM,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.40.2800",
      "rawHtsCode": "1702.40.28.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "33.9¢/kg of total sugars + 5.1%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "39.9¢/kg of total sugars + 6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.66-9904.17.84. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.40.4000",
      "rawHtsCode": "1702.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.50.0000",
      "rawHtsCode": "1702.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Chemically pure fructose",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.60",
      "rawHtsCode": "1702.60",
      "superior": null,
      "indent": "1",
      "description": "Other fructose and fructose syrup, containing in the dry state more than 50 percent by weight of fructose, excluding invert sugar:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.60.2200",
      "rawHtsCode": "1702.60.22.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.60.2400",
      "rawHtsCode": "1702.60.24.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 9 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (OM,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.60.2800",
      "rawHtsCode": "1702.60.28.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "33.9¢/kg of total sugars + 5.1%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "39.9¢/kg of total sugars+ 6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.66-9904.17.84. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.60.40",
      "rawHtsCode": "1702.60.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.60.4030",
      "rawHtsCode": "1702.60.40.30",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.60.4050",
      "rawHtsCode": "1702.60.40.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.60.4090",
      "rawHtsCode": "1702.60.40.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.90",
      "rawHtsCode": "1702.90",
      "superior": null,
      "indent": "1",
      "description": "Other, including invert sugar and other sugar and sugar syrup blends containing in the dry state 50 percent by weight of fructose:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1702.90.0500",
      "rawHtsCode": "1702.90.05.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.6606¢/kg of total sugars",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.58170¢/kg of total sugars",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.90.1000",
      "rawHtsCode": "1702.90.10.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 5 to this chapterand entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.6606¢/kg of total sugars",
      "specialRate": "Free (A*,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG) See 9822.05.15 (P+)",
      "otherRate": "6.58170¢/kg of total sugars",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.90.2000",
      "rawHtsCode": "1702.90.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "35.74¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.09.01-9823.09.09 (S+) See 9822.03.01(MA)",
      "otherRate": "42.05¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.08-9904.17.16. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.90.3500",
      "rawHtsCode": "1702.90.35.00",
      "superior": null,
      "indent": "4",
      "description": "Invert molasses",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "0.35¢/liter",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.8¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.90.4000",
      "rawHtsCode": "1702.90.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "0.35¢/liter",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.8¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.90.5200",
      "rawHtsCode": "1702.90.52.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.90.5400",
      "rawHtsCode": "1702.90.54.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 9 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (OM,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.90.5800",
      "rawHtsCode": "1702.90.58.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "33.9¢/kg of total sugars + 5.1%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "39.9¢/kg of total sugars + 6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.66-9904.17.84. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.90.6400",
      "rawHtsCode": "1702.90.64.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 7 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (OM,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.90.6800",
      "rawHtsCode": "1702.90.68.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "33.9¢/kg + 5.1%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "39.9¢/kg + 6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1702.90.9000",
      "rawHtsCode": "1702.90.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1703",
      "rawHtsCode": "1703",
      "superior": null,
      "indent": "0",
      "description": "Molasses resulting from the extraction or refining of sugar:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1703.10",
      "rawHtsCode": "1703.10",
      "superior": null,
      "indent": "1",
      "description": "Cane molasses:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1703.10.3000",
      "rawHtsCode": "1703.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Imported for (a) the commercial extraction of sugar or (b) human consumption",
      "units": [
        "liters"
      ],
      "generalRate": "0.35¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.8¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Report liters of dried molasses on the basis of 0.72 kg/liter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1703.10.5000",
      "rawHtsCode": "1703.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters",
        "kg ttl sug"
      ],
      "generalRate": "0.01¢/kg of total sugars",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.07¢/kg of total sugars",
      "quotaQuantity": null,
      "footnotesText": [
        "Report liters of dried molasses on the basis of 0.72 kg/liter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1703.90",
      "rawHtsCode": "1703.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1703.90.3000",
      "rawHtsCode": "1703.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Imported for (a) the commercial extraction of sugar or (b) human consumption",
      "units": [
        "liters"
      ],
      "generalRate": "0.35¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.8¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Report liters of dried molasses on the basis of 0.72 kg/liter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1703.90.5000",
      "rawHtsCode": "1703.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters",
        "kg ttl sug"
      ],
      "generalRate": "0.01¢/kg of total sugars",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.07¢/kg of total sugars",
      "quotaQuantity": null,
      "footnotesText": [
        "Report liters of dried molasses on the basis of 0.72 kg/liter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1704",
      "rawHtsCode": "1704",
      "superior": null,
      "indent": "0",
      "description": "Sugar confectionery (including white chocolate), not containing cocoa:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1704.10.0000",
      "rawHtsCode": "1704.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Chewing gum, whether or not sugar-coated",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 1.2% (JP)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1704.90",
      "rawHtsCode": "1704.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1704.90.1000",
      "rawHtsCode": "1704.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Candied nuts",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 1.35% (JP)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1704.90.2500",
      "rawHtsCode": "1704.90.25.00",
      "superior": null,
      "indent": "4",
      "description": "Cough drops",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1704.90.35",
      "rawHtsCode": "1704.90.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.8% (JP)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1704.90.3520",
      "rawHtsCode": "1704.90.35.20",
      "superior": null,
      "indent": "6",
      "description": "Containing peanuts, peanut butter or peanut paste",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1704.90.3550",
      "rawHtsCode": "1704.90.35.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1704.90.3590",
      "rawHtsCode": "1704.90.35.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1704.90.5200",
      "rawHtsCode": "1704.90.52.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "12.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 6.1% (JP)",
      "otherRate": "12.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1704.90.5400",
      "rawHtsCode": "1704.90.54.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "12.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1704.90.5800",
      "rawHtsCode": "1704.90.58.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "40¢/kg +10.4%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60, 9918.04.69 (CO)",
      "otherRate": "47.4¢/kg + 12.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1704.90.6400",
      "rawHtsCode": "1704.90.64.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 7 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "12.2%",
      "specialRate": "Free (OM,PE,S)",
      "otherRate": "12.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1704.90.6800",
      "rawHtsCode": "1704.90.68.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "40¢/kg + 10.4%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "47.4¢/kg + 12.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1704.90.7400",
      "rawHtsCode": "1704.90.74.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 8 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "12.2%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1704.90.7800",
      "rawHtsCode": "1704.90.78.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "40¢/kg + 10.4%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "47.4¢/kg + 12.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.49-9904.17.65. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1704.90.9000",
      "rawHtsCode": "1704.90.90.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "10.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1801.00.00",
      "rawHtsCode": "1801.00.00",
      "superior": null,
      "indent": "0",
      "description": "Cocoa beans, whole or broken, raw or roasted",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1801.00.0010",
      "rawHtsCode": "1801.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1801.00.0090",
      "rawHtsCode": "1801.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1802.00.0000",
      "rawHtsCode": "1802.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Cocoa shells, husks, skins and other cocoa waste",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1803",
      "rawHtsCode": "1803",
      "superior": null,
      "indent": "0",
      "description": "Cocoa paste, whether or not defatted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1803.10.0000",
      "rawHtsCode": "1803.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Not defatted",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1803.20.0000",
      "rawHtsCode": "1803.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Wholly or partly defatted",
      "units": [
        "kg"
      ],
      "generalRate": "0.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1804.00.0000",
      "rawHtsCode": "1804.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Cocoa butter, fat and oil",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1805.00.0000",
      "rawHtsCode": "1805.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Cocoa powder, not containing added sugar or other sweetening matter",
      "units": [
        "kg"
      ],
      "generalRate": "0.52¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806",
      "rawHtsCode": "1806",
      "superior": null,
      "indent": "0",
      "description": "Chocolate and other food preparations containing cocoa:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1806.10",
      "rawHtsCode": "1806.10",
      "superior": null,
      "indent": "1",
      "description": "Cocoa powder, containing added sugar or other sweetening matter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1806.10.0500",
      "rawHtsCode": "1806.10.05.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1806.10.1000",
      "rawHtsCode": "1806.10.10.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 1 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1806.10.1500",
      "rawHtsCode": "1806.10.15.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "21.7¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "25.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.01-9904.18.08. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.10.2200",
      "rawHtsCode": "1806.10.22.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.10.2400",
      "rawHtsCode": "1806.10.24.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 7 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.10.2800",
      "rawHtsCode": "1806.10.28.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "33.6¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "39.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.10.3400",
      "rawHtsCode": "1806.10.34.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 1 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.10.3800",
      "rawHtsCode": "1806.10.38.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "33.6¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "39.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.01-9904.18.08. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.10.4300",
      "rawHtsCode": "1806.10.43.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.10.4500",
      "rawHtsCode": "1806.10.45.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 7 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.10.5500",
      "rawHtsCode": "1806.10.55.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "33.6¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "39.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.10.6500",
      "rawHtsCode": "1806.10.65.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 1 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.10.7500",
      "rawHtsCode": "1806.10.75.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "33.6¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "39.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.01-9904.18.08. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20",
      "rawHtsCode": "1806.20",
      "superior": null,
      "indent": "1",
      "description": "Other preparations in blocks, slabs or bars, weighing more than 2 kg or in liquid, paste, powder, granular or other bulk form in containers or immediate packings, of a content exceeding 2 kg:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1806.20.20",
      "rawHtsCode": "1806.20.20",
      "superior": null,
      "indent": "3",
      "description": "In blocks or slabs weighing 4.5 kg or more each",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1806.20.2010",
      "rawHtsCode": "1806.20.20.10",
      "superior": null,
      "indent": "4",
      "description": "Not containing butterfat or other milk solids",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1806.20.2090",
      "rawHtsCode": "1806.20.20.90",
      "superior": null,
      "indent": "4",
      "description": "Containing butterfat or other milk solids",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1806.20.2200",
      "rawHtsCode": "1806.20.22.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.2400",
      "rawHtsCode": "1806.20.24.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 2 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.2600",
      "rawHtsCode": "1806.20.26.00",
      "superior": null,
      "indent": "7",
      "description": "Containing less than 21 percent by weight of milk solids",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "37.2¢/kg + 4.3%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "43.8¢/kg + 5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.09-9904.18.18. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.2800",
      "rawHtsCode": "1806.20.28.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "52.8¢/kg + 4.3%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "62.1¢/kg + 5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.09-9904.18.18. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.3400",
      "rawHtsCode": "1806.20.34.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 3 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.3600",
      "rawHtsCode": "1806.20.36.00",
      "superior": null,
      "indent": "7",
      "description": "Containing less than 21 percent by weight of milk solids",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "37.2¢/kg + 4.3%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "43.8¢/kg + 5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.19-9904.18.30. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.3800",
      "rawHtsCode": "1806.20.38.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "52.8¢/kg + 4.3%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "62.1¢/kg + 5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.19-9904.18.30. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.5000",
      "rawHtsCode": "1806.20.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.6000",
      "rawHtsCode": "1806.20.60.00",
      "superior": null,
      "indent": "2",
      "description": "Confectioners' coatings and other products (except confectionery) containing by weight not less than 6.8 percent non-fat solids of the cocoa bean nib and not less than 15 percent of vegetable fats other than cocoa butter",
      "units": [
        "kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.6700",
      "rawHtsCode": "1806.20.67.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 5% (JP)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.7100",
      "rawHtsCode": "1806.20.71.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 7 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.7300",
      "rawHtsCode": "1806.20.73.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "30.5¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "35.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.7500",
      "rawHtsCode": "1806.20.75.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 8 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.7700",
      "rawHtsCode": "1806.20.77.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "30.5¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "35.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.49-9904.17.65. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.7800",
      "rawHtsCode": "1806.20.78.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.7900",
      "rawHtsCode": "1806.20.79.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 5% (JP)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.8100",
      "rawHtsCode": "1806.20.81.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.8200",
      "rawHtsCode": "1806.20.82.00",
      "superior": null,
      "indent": "7",
      "description": "Containing less than 21 percent by weight of milk solids",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "37.2¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "43.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.8300",
      "rawHtsCode": "1806.20.83.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "52.8¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "62.1¢/kg +10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.8500",
      "rawHtsCode": "1806.20.85.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 3 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.8700",
      "rawHtsCode": "1806.20.87.00",
      "superior": null,
      "indent": "7",
      "description": "Containing less than 21 percent by weight of milk solids",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "37.2¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "43.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.19-9904.18.30. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.8900",
      "rawHtsCode": "1806.20.89.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "52.8¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "62.1¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.19-9904.18.30. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.9100",
      "rawHtsCode": "1806.20.91.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 9 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.9400",
      "rawHtsCode": "1806.20.94.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "37.2¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "43.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.66-9904.17.84. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.9500",
      "rawHtsCode": "1806.20.95.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 8 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.9800",
      "rawHtsCode": "1806.20.98.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "37.2¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01 (MA)",
      "otherRate": "43.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.49-9904.17.65. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.20.9900",
      "rawHtsCode": "1806.20.99.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.31.00",
      "rawHtsCode": "1806.31.00",
      "superior": null,
      "indent": "2",
      "description": "Filled",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.8% (JP)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.31.0041",
      "rawHtsCode": "1806.31.00.41",
      "superior": null,
      "indent": "4",
      "description": "Containing peanuts, peanut butter or peanut paste",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1806.31.0049",
      "rawHtsCode": "1806.31.00.49",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1806.31.0080",
      "rawHtsCode": "1806.31.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1806.32",
      "rawHtsCode": "1806.32",
      "superior": null,
      "indent": "2",
      "description": "Not filled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1806.32.0100",
      "rawHtsCode": "1806.32.01.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.32.0400",
      "rawHtsCode": "1806.32.04.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 2 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.32.0600",
      "rawHtsCode": "1806.32.06.00",
      "superior": null,
      "indent": "7",
      "description": "Containing less than 21 percent by weight of milk solids",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "37.2¢/kg + 4.3%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "43.8¢/kg + 5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.09-9904.18.18. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.32.0800",
      "rawHtsCode": "1806.32.08.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "52.8¢/kg + 4.3%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "62.1¢/kg + 5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.09-9904.18.18. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.32.1400",
      "rawHtsCode": "1806.32.14.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 3 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.32.1600",
      "rawHtsCode": "1806.32.16.00",
      "superior": null,
      "indent": "7",
      "description": "Containing less than 21 percent by weight of milk solids",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "37.2¢/kg + 4.3%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "43.8¢/kg + 5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.19-9904.18.30. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.32.1800",
      "rawHtsCode": "1806.32.18.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "52.8¢/kg + 4.3%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "62.1¢/kg + 5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.19-9904.18.30. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.32.3000",
      "rawHtsCode": "1806.32.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.32.5500",
      "rawHtsCode": "1806.32.55.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.5% (JP)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.32.6000",
      "rawHtsCode": "1806.32.60.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.32.7000",
      "rawHtsCode": "1806.32.70.00",
      "superior": null,
      "indent": "6",
      "description": "Containing less than 21 percent by weight of milk solids",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "37.2¢/kg + 6%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "43.8¢/kg +7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.32.8000",
      "rawHtsCode": "1806.32.80.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "52.8¢/kg + 6%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "62.1¢/kg +7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.32.9000",
      "rawHtsCode": "1806.32.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90",
      "rawHtsCode": "1806.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1806.90.0100",
      "rawHtsCode": "1806.90.01.00",
      "superior": null,
      "indent": "2",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.0500",
      "rawHtsCode": "1806.90.05.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.0800",
      "rawHtsCode": "1806.90.08.00",
      "superior": null,
      "indent": "5",
      "description": "Containing less than 21 percent by weight of milk solids",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "37.2¢/kg + 6%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "43.8¢/kg + 7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.1000",
      "rawHtsCode": "1806.90.10.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "52.8¢/kg + 6%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "62.1¢/kg +7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.1500",
      "rawHtsCode": "1806.90.15.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 2 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.1800",
      "rawHtsCode": "1806.90.18.00",
      "superior": null,
      "indent": "7",
      "description": "Containing less than 21 percent by weight of milk solids",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "37.2¢/kg + 6%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "43.8¢/kg + 7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.09-9904.18.18. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.2000",
      "rawHtsCode": "1806.90.20.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "52.8¢/kg + 6%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "62.1¢/kg +7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.09-9904.18.18. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.2500",
      "rawHtsCode": "1806.90.25.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 3 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.2800",
      "rawHtsCode": "1806.90.28.00",
      "superior": null,
      "indent": "7",
      "description": "Containing less than 21 percent by weight of milk solids",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "37.2¢/kg + 6%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "43.8¢/kg + 7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.19-9904.18.30. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.3000",
      "rawHtsCode": "1806.90.30.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "52.8¢/kg + 6%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+)",
      "otherRate": "62.1¢/kg + 7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.18.19-9904.18.30. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.3500",
      "rawHtsCode": "1806.90.35.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 9 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.3900",
      "rawHtsCode": "1806.90.39.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "37.2¢/kg + 6%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "43.8¢/kg + 7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.66-9904.17.84. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.4500",
      "rawHtsCode": "1806.90.45.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 7 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.4900",
      "rawHtsCode": "1806.90.49.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "37.2¢/kg + 6%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "43.8¢/kg + 7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.5500",
      "rawHtsCode": "1806.90.55.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 8 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.5900",
      "rawHtsCode": "1806.90.59.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "37.2¢/kg + 6%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "43.8¢/kg + 7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.49-9904.17.65. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.90",
      "rawHtsCode": "1806.90.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1806.90.9011",
      "rawHtsCode": "1806.90.90.11",
      "superior": null,
      "indent": "7",
      "description": "Containing peanuts or peanut products",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1806.90.9019",
      "rawHtsCode": "1806.90.90.19",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1806.90.9090",
      "rawHtsCode": "1806.90.90.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1901",
      "rawHtsCode": "1901",
      "superior": null,
      "indent": "0",
      "description": "Malt extract; food preparations of flour, groats, meal, starch or malt extract, not containing cocoa or containing less than 40 percent by weight of cocoa calculated on a totally defatted basis, not elsewhere specified or included; food preparations of goods of headings 0401 to 0404, not containing cocoa or containing less than 5 percent by weight of cocoa calculated on a totally defatted basis, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1901.10",
      "rawHtsCode": "1901.10",
      "superior": null,
      "indent": "1",
      "description": "Preparations suitable for infants or young children, put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1901.10.0500",
      "rawHtsCode": "1901.10.05.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.1100",
      "rawHtsCode": "1901.10.11.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 2 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.1600",
      "rawHtsCode": "1901.10.16.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.035/kg + 14.9%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "$1.217/kg + 17.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.19.01-9904.19.10. ",
        "See 9903.19.19 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.2100",
      "rawHtsCode": "1901.10.21.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.2600",
      "rawHtsCode": "1901.10.26.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.035/kg + 14.9%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "$1.217/kg + 17.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.19.19 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.2900",
      "rawHtsCode": "1901.10.29.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.19.20 and  9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.3100",
      "rawHtsCode": "1901.10.31.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.3300",
      "rawHtsCode": "1901.10.33.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 2 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.3600",
      "rawHtsCode": "1901.10.36.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "$1.035/kg + 14.9%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "$1.217/kg + 17.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.19.01-9904.19.10. ",
        "See 9903.19.19 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.4100",
      "rawHtsCode": "1901.10.41.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.4400",
      "rawHtsCode": "1901.10.44.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "$1.035/kg + 14.9%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "$1.217/kg + 17.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.19.19 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.4900",
      "rawHtsCode": "1901.10.49.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.19.20 and  9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.5200",
      "rawHtsCode": "1901.10.52.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.5400",
      "rawHtsCode": "1901.10.54.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.5600",
      "rawHtsCode": "1901.10.56.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.035/kg +13.6%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "$1.217/kg + 16%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.6200",
      "rawHtsCode": "1901.10.62.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.6400",
      "rawHtsCode": "1901.10.64.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.6600",
      "rawHtsCode": "1901.10.66.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "$1.035/kg + 13.6%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "$1.217/kg + 16%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.7200",
      "rawHtsCode": "1901.10.72.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.7400",
      "rawHtsCode": "1901.10.74.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 8 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.7600",
      "rawHtsCode": "1901.10.76.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "23.7¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.03.01 (MA) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+)",
      "otherRate": "27.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.17.49-9904.17.65. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.10.9100",
      "rawHtsCode": "1901.10.91.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20",
      "rawHtsCode": "1901.20",
      "superior": null,
      "indent": "1",
      "description": "Mixes and doughs for the preparation of bakers' wares of heading 1905:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1901.20.0200",
      "rawHtsCode": "1901.20.02.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.0500",
      "rawHtsCode": "1901.20.05.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.1500",
      "rawHtsCode": "1901.20.15.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "42.3¢/kg +8.5%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "49.8¢/kg +10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.2000",
      "rawHtsCode": "1901.20.20.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 7 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.2500",
      "rawHtsCode": "1901.20.25.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "42.3¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "49.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.3000",
      "rawHtsCode": "1901.20.30.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 3 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.3500",
      "rawHtsCode": "1901.20.35.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "42.3¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "49.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.19.11-9904.19.19. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.4000",
      "rawHtsCode": "1901.20.40.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.4200",
      "rawHtsCode": "1901.20.42.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.4500",
      "rawHtsCode": "1901.20.45.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.5000",
      "rawHtsCode": "1901.20.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "42.3¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "49.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.5500",
      "rawHtsCode": "1901.20.55.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 7 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.6000",
      "rawHtsCode": "1901.20.60.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "42.3¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "49.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.6500",
      "rawHtsCode": "1901.20.65.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 3 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.7000",
      "rawHtsCode": "1901.20.70.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "42.3¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "49.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.19.11-9904.19.19. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.20.8000",
      "rawHtsCode": "1901.20.80.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90",
      "rawHtsCode": "1901.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1901.90.1000",
      "rawHtsCode": "1901.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Fluid",
      "units": [
        "liters"
      ],
      "generalRate": "3.2¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "26¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.2000",
      "rawHtsCode": "1901.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Solid or condensed",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.2500",
      "rawHtsCode": "1901.90.25.00",
      "superior": null,
      "indent": "2",
      "description": "Puddings ready for immediate consumption without further preparation",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1901.90.2800",
      "rawHtsCode": "1901.90.28.00",
      "superior": null,
      "indent": "2",
      "description": "Dry mixtures containing less than 31 percent by weight of butterfat and consisting of not less than 17.5 percent by weight each of sodium caseinate, butterfat, whey solids containing over 5.5 percent by weight of butterfat, and dried whole milk, but not containing dried milk, dried whey or dried buttermilk any of which contain 5.5 percent or less by weight of butterfat",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "0.37¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.3200",
      "rawHtsCode": "1901.90.32.00",
      "superior": null,
      "indent": "2",
      "description": "Cajeta not made from cow's milk",
      "units": [
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.3300",
      "rawHtsCode": "1901.90.33.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.3400",
      "rawHtsCode": "1901.90.34.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 23 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.3600",
      "rawHtsCode": "1901.90.36.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.128/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PE,SG) See 9823.04.01-9823.04.54 (S+) See 9908.04.05 (IL) See 9918.04.50-9918.04.59 (CO) See 9919.04.50, 9919.04.57, 9919.04.67 (PA)",
      "otherRate": "$1.328/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.06.29-9904.06.37. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.6000",
      "rawHtsCode": "1901.90.60.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.6100",
      "rawHtsCode": "1901.90.61.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.6200",
      "rawHtsCode": "1901.90.62.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.035/kg +13.6%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "$1.217/kg + 16%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.19.23 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.6300",
      "rawHtsCode": "1901.90.63.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.6400",
      "rawHtsCode": "1901.90.64.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.6500",
      "rawHtsCode": "1901.90.65.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "$1.035/kg + 13.6%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "$1.217/kg + 16%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.6600",
      "rawHtsCode": "1901.90.66.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.6700",
      "rawHtsCode": "1901.90.67.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 7 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.6800",
      "rawHtsCode": "1901.90.68.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "23.7¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "27.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.6900",
      "rawHtsCode": "1901.90.69.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 8 to chapter pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.7100",
      "rawHtsCode": "1901.90.71.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "23.7¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "27.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.17.49-9904.17.65. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.7200",
      "rawHtsCode": "1901.90.72.00",
      "superior": null,
      "indent": "6",
      "description": "Containing over 5.5 percent by weight of butterfat and not packaged for retail sale",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR ,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.91",
      "rawHtsCode": "1901.90.91",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1901.90.9182",
      "rawHtsCode": "1901.90.91.82",
      "superior": null,
      "indent": "7",
      "description": "Corn-soya milk blends",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1901.90.9185",
      "rawHtsCode": "1901.90.91.85",
      "superior": null,
      "indent": "7",
      "description": "Wheat-flour-soya blends",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1901.90.9195",
      "rawHtsCode": "1901.90.91.95",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902",
      "rawHtsCode": "1902",
      "superior": null,
      "indent": "0",
      "description": "Pasta, whether or not cooked or stuffed (with meat or other substances) or otherwise prepared, such as spaghetti, macaroni, noodles, lasagna, gnocchi, ravioli, cannelloni; couscous, whether or not prepared:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.11",
      "rawHtsCode": "1902.11",
      "superior": null,
      "indent": "2",
      "description": "Containing eggs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.11.20",
      "rawHtsCode": "1902.11.20",
      "superior": null,
      "indent": "3",
      "description": "Exclusively pasta",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1902.11.2010",
      "rawHtsCode": "1902.11.20.10",
      "superior": null,
      "indent": "5",
      "description": "Subject to the Inward Processing Regime (IPR)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.11.2020",
      "rawHtsCode": "1902.11.20.20",
      "superior": null,
      "indent": "5",
      "description": "Subject to the EU reduced export refund in accordance with the US-EU Pasta agreement",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.11.2030",
      "rawHtsCode": "1902.11.20.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.11.2090",
      "rawHtsCode": "1902.11.20.90",
      "superior": null,
      "indent": "4",
      "description": "Product of a country other than an EU country",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.11.4000",
      "rawHtsCode": "1902.11.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other, including pasta packaged with sauce preparations",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1902.19",
      "rawHtsCode": "1902.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.19.20",
      "rawHtsCode": "1902.19.20",
      "superior": null,
      "indent": "3",
      "description": "Exclusively pasta",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "1902.19.2010",
      "rawHtsCode": "1902.19.20.10",
      "superior": null,
      "indent": "5",
      "description": "Subject to the Inward Processing Regime (IPR)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.19.2020",
      "rawHtsCode": "1902.19.20.20",
      "superior": null,
      "indent": "5",
      "description": "Subject to the EU reduced export refund in accordance with the US-EU Pasta agreement",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.19.2030",
      "rawHtsCode": "1902.19.20.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.19.2090",
      "rawHtsCode": "1902.19.20.90",
      "superior": null,
      "indent": "4",
      "description": "Product of a country other than an EU country",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.19.4000",
      "rawHtsCode": "1902.19.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other, including pasta packaged with sauce preparations",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1902.20.00",
      "rawHtsCode": "1902.20.00",
      "superior": null,
      "indent": "1",
      "description": "Stuffed pasta, whether or not cooked or otherwise prepared",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1902.20.0020",
      "rawHtsCode": "1902.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Canned",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.20.0040",
      "rawHtsCode": "1902.20.00.40",
      "superior": null,
      "indent": "3",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.20.0060",
      "rawHtsCode": "1902.20.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.30.00",
      "rawHtsCode": "1902.30.00",
      "superior": null,
      "indent": "1",
      "description": "Other pasta",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1902.30.0020",
      "rawHtsCode": "1902.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "Canned",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.30.0040",
      "rawHtsCode": "1902.30.00.40",
      "superior": null,
      "indent": "3",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.30.0060",
      "rawHtsCode": "1902.30.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1902.40.0000",
      "rawHtsCode": "1902.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Couscous",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1903.00",
      "rawHtsCode": "1903.00",
      "superior": null,
      "indent": "0",
      "description": "Tapioca and substitutes therefor prepared from starch, in the form of flakes, grains, pearls, siftings or in similar forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1903.00.2000",
      "rawHtsCode": "1903.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of arrowroot, cassava or sago",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1903.00.4000",
      "rawHtsCode": "1903.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1904",
      "rawHtsCode": "1904",
      "superior": null,
      "indent": "0",
      "description": "Prepared foods obtained by the swelling or roasting of cereals or cereal products (for example, cornflakes); cereals (other than corn (maize)) in grain form or in the form of flakes or other worked grains (except flour, groats and meal), pre-cooked or otherwise prepared, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1904.10.00",
      "rawHtsCode": "1904.10.00",
      "superior": null,
      "indent": "1",
      "description": "Prepared foods obtained by the swelling or roasting of cereals or cereal products",
      "units": [],
      "generalRate": "1.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1904.10.0040",
      "rawHtsCode": "1904.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Containing cane and/or beet sugar",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1904.10.0080",
      "rawHtsCode": "1904.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1904.20",
      "rawHtsCode": "1904.20",
      "superior": null,
      "indent": "1",
      "description": "Prepared foods obtained from unroasted cereal flakes or from mixtures of unroasted cereal flakes and roasted cereal flakes or swelled cereals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1904.20.1000",
      "rawHtsCode": "1904.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "In airtight containers and not containing apricots, citrus fruits, peaches or pears",
      "units": [
        "kg"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1904.20.9000",
      "rawHtsCode": "1904.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1904.30.0000",
      "rawHtsCode": "1904.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Bulgur wheat",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1904.90.01",
      "rawHtsCode": "1904.90.01",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "14%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1904.90.0120",
      "rawHtsCode": "1904.90.01.20",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1904.90.0140",
      "rawHtsCode": "1904.90.01.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905",
      "rawHtsCode": "1905",
      "superior": null,
      "indent": "0",
      "description": "Bread, pastry, cakes, biscuits and other bakers' wares, whether or not containing cocoa; communion wafers, empty capsules of a kind suitable for pharmaceutical use, sealing wafers, rice paper and similar products:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.10.0000",
      "rawHtsCode": "1905.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Crispbread",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1905.20.0000",
      "rawHtsCode": "1905.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Gingerbread and the like",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1905.31.00",
      "rawHtsCode": "1905.31.00",
      "superior": null,
      "indent": "2",
      "description": "Sweet biscuits",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1905.31.0021",
      "rawHtsCode": "1905.31.00.21",
      "superior": null,
      "indent": "4",
      "description": "Containing peanuts or peanut products",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.31.0029",
      "rawHtsCode": "1905.31.00.29",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.31.0041",
      "rawHtsCode": "1905.31.00.41",
      "superior": null,
      "indent": "4",
      "description": "Containing peanuts or peanut products",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.31.0049",
      "rawHtsCode": "1905.31.00.49",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.32.00",
      "rawHtsCode": "1905.32.00",
      "superior": null,
      "indent": "2",
      "description": "Waffles and wafers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1905.32.0021",
      "rawHtsCode": "1905.32.00.21",
      "superior": null,
      "indent": "4",
      "description": "Containing peanuts or peanut products",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.32.0029",
      "rawHtsCode": "1905.32.00.29",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.32.0041",
      "rawHtsCode": "1905.32.00.41",
      "superior": null,
      "indent": "4",
      "description": "Containing peanuts or peanut products",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.32.0049",
      "rawHtsCode": "1905.32.00.49",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.40.0000",
      "rawHtsCode": "1905.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Rusks, toasted bread and similar toasted products",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "1905.90",
      "rawHtsCode": "1905.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.90.10",
      "rawHtsCode": "1905.90.10",
      "superior": null,
      "indent": "2",
      "description": "Bread, pastry, cakes, biscuits and similar baked products, and puddings, whether or not containing chocolate, fruit, nuts or confectionery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "1905.90.1041",
      "rawHtsCode": "1905.90.10.41",
      "superior": null,
      "indent": "4",
      "description": "Pastries, cakes and similar sweet baked products; puddings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.90.1049",
      "rawHtsCode": "1905.90.10.49",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.90.1050",
      "rawHtsCode": "1905.90.10.50",
      "superior": null,
      "indent": "4",
      "description": "Pastries, cakes and similar sweet baked products; puddings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.90.1070",
      "rawHtsCode": "1905.90.10.70",
      "superior": null,
      "indent": "4",
      "description": "Bread",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.90.1090",
      "rawHtsCode": "1905.90.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.90.90",
      "rawHtsCode": "1905.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "1905.90.9030",
      "rawHtsCode": "1905.90.90.30",
      "superior": null,
      "indent": "3",
      "description": "Corn chips and similar crisp savory snack foods",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.90.9060",
      "rawHtsCode": "1905.90.90.60",
      "superior": null,
      "indent": "3",
      "description": "Pizza and quiche",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "1905.90.9090",
      "rawHtsCode": "1905.90.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2001",
      "rawHtsCode": "2001",
      "superior": null,
      "indent": "0",
      "description": "Vegetables, fruit, nuts and other edible parts of plants, prepared or preserved by vinegar or acetic acid:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2001.10.0000",
      "rawHtsCode": "2001.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cucumbers including gherkins",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90",
      "rawHtsCode": "2001.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2001.90.1000",
      "rawHtsCode": "2001.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "In immediate containers holding more than 3.4 kg",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90.2000",
      "rawHtsCode": "2001.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90.2500",
      "rawHtsCode": "2001.90.25.00",
      "superior": null,
      "indent": "4",
      "description": "Artichokes",
      "units": [
        "kg"
      ],
      "generalRate": "10.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90.3000",
      "rawHtsCode": "2001.90.30.00",
      "superior": null,
      "indent": "4",
      "description": "Beans",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90.3300",
      "rawHtsCode": "2001.90.33.00",
      "superior": null,
      "indent": "4",
      "description": "Nopalitos",
      "units": [
        "kg"
      ],
      "generalRate": "7.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90.3400",
      "rawHtsCode": "2001.90.34.00",
      "superior": null,
      "indent": "4",
      "description": "Onions",
      "units": [
        "kg"
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90.3500",
      "rawHtsCode": "2001.90.35.00",
      "superior": null,
      "indent": "4",
      "description": "Pimientos (<u><i>Capsicum</i></u> <u><i>anuum</i></u>)",
      "units": [
        "kg"
      ],
      "generalRate": "8.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90.3800",
      "rawHtsCode": "2001.90.38.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90.4200",
      "rawHtsCode": "2001.90.42.00",
      "superior": null,
      "indent": "3",
      "description": "Chestnuts, other than Chinese water chestnuts",
      "units": [
        "kg"
      ],
      "generalRate": "4.9¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90.4500",
      "rawHtsCode": "2001.90.45.00",
      "superior": null,
      "indent": "3",
      "description": "Mangoes",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90.4800",
      "rawHtsCode": "2001.90.48.00",
      "superior": null,
      "indent": "3",
      "description": "Chinese water chestnuts",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90.5000",
      "rawHtsCode": "2001.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Walnuts",
      "units": [
        "kg"
      ],
      "generalRate": "7¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2001.90.6000",
      "rawHtsCode": "2001.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2002",
      "rawHtsCode": "2002",
      "superior": null,
      "indent": "0",
      "description": "Tomatoes prepared or preserved otherwise than by vinegar or acetic acid:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2002.10.00",
      "rawHtsCode": "2002.10.00",
      "superior": null,
      "indent": "1",
      "description": "Tomatoes, whole or in pieces",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2002.10.0020",
      "rawHtsCode": "2002.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "In containers holding less than 1.4 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2002.10.0080",
      "rawHtsCode": "2002.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2002.90",
      "rawHtsCode": "2002.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2002.90.4000",
      "rawHtsCode": "2002.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "In powder",
      "units": [
        "kg"
      ],
      "generalRate": "11.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2002.90.80",
      "rawHtsCode": "2002.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "11.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2002.90.8010",
      "rawHtsCode": "2002.90.80.10",
      "superior": null,
      "indent": "4",
      "description": "In containers holding less than 1.4 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2002.90.8020",
      "rawHtsCode": "2002.90.80.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2002.90.8030",
      "rawHtsCode": "2002.90.80.30",
      "superior": null,
      "indent": "4",
      "description": "In containers holding less than 1.4 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2002.90.8040",
      "rawHtsCode": "2002.90.80.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2002.90.8050",
      "rawHtsCode": "2002.90.80.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2003",
      "rawHtsCode": "2003",
      "superior": null,
      "indent": "0",
      "description": "Mushrooms and truffles, prepared or preserved otherwise than by vinegar or acetic acid:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2003.10.01",
      "rawHtsCode": "2003.10.01",
      "superior": null,
      "indent": "1",
      "description": "Mushrooms of the genus <i>Agaricus</i>",
      "units": [],
      "generalRate": "6¢/kg on drained weight + 8.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg on drained weight + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2003.10.0127",
      "rawHtsCode": "2003.10.01.27",
      "superior": null,
      "indent": "3",
      "description": "Whole (including buttons)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2003.10.0131",
      "rawHtsCode": "2003.10.01.31",
      "superior": null,
      "indent": "3",
      "description": "Sliced",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2003.10.0137",
      "rawHtsCode": "2003.10.01.37",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2003.10.0143",
      "rawHtsCode": "2003.10.01.43",
      "superior": null,
      "indent": "3",
      "description": "Whole (including buttons)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2003.10.0147",
      "rawHtsCode": "2003.10.01.47",
      "superior": null,
      "indent": "3",
      "description": "Sliced",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2003.10.0153",
      "rawHtsCode": "2003.10.01.53",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2003.90",
      "rawHtsCode": "2003.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2003.90.1000",
      "rawHtsCode": "2003.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Truffles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2003.90.80",
      "rawHtsCode": "2003.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6¢/kg on drained weight + 8.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg on drained weight + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2003.90.8010",
      "rawHtsCode": "2003.90.80.10",
      "superior": null,
      "indent": "3",
      "description": "Straw mushrooms",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2003.90.8090",
      "rawHtsCode": "2003.90.80.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2004",
      "rawHtsCode": "2004",
      "superior": null,
      "indent": "0",
      "description": "Other vegetables prepared or preserved otherwise than by vinegar or acetic acid, frozen, other than products of heading 2006:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2004.10",
      "rawHtsCode": "2004.10",
      "superior": null,
      "indent": "1",
      "description": "Potatoes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2004.10.4000",
      "rawHtsCode": "2004.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Yellow (Solano) potatoes",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2004.10.80",
      "rawHtsCode": "2004.10.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2004.10.8020",
      "rawHtsCode": "2004.10.80.20",
      "superior": null,
      "indent": "3",
      "description": "French fries",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2004.10.8040",
      "rawHtsCode": "2004.10.80.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2004.90",
      "rawHtsCode": "2004.90",
      "superior": null,
      "indent": "1",
      "description": "Other vegetables and mixtures of vegetables:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2004.90.1000",
      "rawHtsCode": "2004.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Antipasto",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2004.90.8000",
      "rawHtsCode": "2004.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Beans",
      "units": [
        "kg"
      ],
      "generalRate": "2.1¢/kg on entire contents of container",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg on entire contents of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2004.90.85",
      "rawHtsCode": "2004.90.85",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "11.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2004.90.8520",
      "rawHtsCode": "2004.90.85.20",
      "superior": null,
      "indent": "3",
      "description": "Carrots",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2004.90.8540",
      "rawHtsCode": "2004.90.85.40",
      "superior": null,
      "indent": "3",
      "description": "Sweet corn",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2004.90.8560",
      "rawHtsCode": "2004.90.85.60",
      "superior": null,
      "indent": "3",
      "description": "Peas",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2004.90.8565",
      "rawHtsCode": "2004.90.85.65",
      "superior": null,
      "indent": "4",
      "description": "Peeled clove garlic, whether or not individually quick frozen",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2004.90.8575",
      "rawHtsCode": "2004.90.85.75",
      "superior": null,
      "indent": "4",
      "description": "Garlic, reduced in size beyond the clove, whether or not individually quick frozen",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2004.90.8585",
      "rawHtsCode": "2004.90.85.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2004.90.8595",
      "rawHtsCode": "2004.90.85.95",
      "superior": null,
      "indent": "3",
      "description": "Other, including mixtures",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005",
      "rawHtsCode": "2005",
      "superior": null,
      "indent": "0",
      "description": "Other vegetables prepared or preserved otherwise than by vinegar or acetic acid, not frozen, other than products of heading 2006:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.10.0000",
      "rawHtsCode": "2005.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Homogenized vegetables",
      "units": [
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.20.00",
      "rawHtsCode": "2005.20.00",
      "superior": null,
      "indent": "1",
      "description": "Potatoes",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.20.0020",
      "rawHtsCode": "2005.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Potato chips",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.20.0040",
      "rawHtsCode": "2005.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Potato granules",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.20.0070",
      "rawHtsCode": "2005.20.00.70",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.40.0000",
      "rawHtsCode": "2005.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Peas (<i>Pisum sativum</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg on entire contents of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2005.51",
      "rawHtsCode": "2005.51",
      "superior": null,
      "indent": "2",
      "description": "Beans, shelled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.51.20",
      "rawHtsCode": "2005.51.20",
      "superior": null,
      "indent": "3",
      "description": "Black-eye cowpeas",
      "units": [],
      "generalRate": "1.5¢/kg on entire contents of container",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "6.6¢/kg on entire contents of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.51.2020",
      "rawHtsCode": "2005.51.20.20",
      "superior": null,
      "indent": "4",
      "description": "Canned dried",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.51.2040",
      "rawHtsCode": "2005.51.20.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.51.40",
      "rawHtsCode": "2005.51.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.1¢/kg on entire contents of container",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg on entire contents of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.51.4020",
      "rawHtsCode": "2005.51.40.20",
      "superior": null,
      "indent": "4",
      "description": "Canned dried",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.51.4040",
      "rawHtsCode": "2005.51.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.59.0000",
      "rawHtsCode": "2005.59.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg on entire contents of container",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg on entire contents of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.60.0000",
      "rawHtsCode": "2005.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Asparagus",
      "units": [
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70",
      "rawHtsCode": "2005.70",
      "superior": null,
      "indent": "1",
      "description": "Olives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.02",
      "rawHtsCode": "2005.70.02",
      "superior": null,
      "indent": "6",
      "description": "In an aggregate quantity not to exceed 730 metric tons entered in any calendar year",
      "units": [],
      "generalRate": "5.4¢/kg on drained weight",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.4¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.0230",
      "rawHtsCode": "2005.70.02.30",
      "superior": null,
      "indent": "7",
      "description": "In containers each holding more than 8 kg, drained weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.0260",
      "rawHtsCode": "2005.70.02.60",
      "superior": null,
      "indent": "7",
      "description": "In containers each holding 8 kg or less drained weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.04",
      "rawHtsCode": "2005.70.04",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "3.7¢/kg on drained weight",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.4¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.0430",
      "rawHtsCode": "2005.70.04.30",
      "superior": null,
      "indent": "7",
      "description": "In containers each holding more than 8 kg, drained weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.0460",
      "rawHtsCode": "2005.70.04.60",
      "superior": null,
      "indent": "7",
      "description": "In containers each holding 8 kg or less, drained weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.0600",
      "rawHtsCode": "2005.70.06.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 4 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.7¢/kg on drained weight",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.4¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.0800",
      "rawHtsCode": "2005.70.08.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7¢/kg on drained weight",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.4¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.1200",
      "rawHtsCode": "2005.70.12.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7¢/kg on drained weight",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.4¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.1600",
      "rawHtsCode": "2005.70.16.00",
      "superior": null,
      "indent": "7",
      "description": "In an aggregate quantity not to exceed 2,700 metric tons in any calendar year",
      "units": [
        "kg"
      ],
      "generalRate": "5.4¢/kg on drained weight",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10.8¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.1800",
      "rawHtsCode": "2005.70.18.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.9¢/kg on drained weight",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10.8¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.2300",
      "rawHtsCode": "2005.70.23.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.9¢/kg on drained weight",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10.8¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.25",
      "rawHtsCode": "2005.70.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "8.6¢/kg on drained weight",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10.8¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.2510",
      "rawHtsCode": "2005.70.25.10",
      "superior": null,
      "indent": "7",
      "description": "Whole pitted",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.2520",
      "rawHtsCode": "2005.70.25.20",
      "superior": null,
      "indent": "7",
      "description": "Whole stuffed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.2530",
      "rawHtsCode": "2005.70.25.30",
      "superior": null,
      "indent": "7",
      "description": "Other, including broken, sliced or salad style",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.2542",
      "rawHtsCode": "2005.70.25.42",
      "superior": null,
      "indent": "8",
      "description": "Spanish style of a kind described in statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.2546",
      "rawHtsCode": "2005.70.25.46",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.2550",
      "rawHtsCode": "2005.70.25.50",
      "superior": null,
      "indent": "7",
      "description": "Whole stuffed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.2570",
      "rawHtsCode": "2005.70.25.70",
      "superior": null,
      "indent": "8",
      "description": "Spanish style of a kind described in statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.2580",
      "rawHtsCode": "2005.70.25.80",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.50",
      "rawHtsCode": "2005.70.50",
      "superior": null,
      "indent": "5",
      "description": "Not pitted",
      "units": [],
      "generalRate": "9.3¢/kg on drained weight",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11.6¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.5030",
      "rawHtsCode": "2005.70.50.30",
      "superior": null,
      "indent": "6",
      "description": "In containers each holding more than 0.3 kg, drained weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.5060",
      "rawHtsCode": "2005.70.50.60",
      "superior": null,
      "indent": "6",
      "description": "In containers each holding 0.3 kg or less, drained weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.60",
      "rawHtsCode": "2005.70.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "10.1¢/kg on drained weight",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11.9¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.6020",
      "rawHtsCode": "2005.70.60.20",
      "superior": null,
      "indent": "7",
      "description": "In containers each holding more than 0.3 kg, drained weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.6030",
      "rawHtsCode": "2005.70.60.30",
      "superior": null,
      "indent": "7",
      "description": "In containers each holding 0.3 kg or less, drained weight",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.6050",
      "rawHtsCode": "2005.70.60.50",
      "superior": null,
      "indent": "6",
      "description": "Sliced",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.6060",
      "rawHtsCode": "2005.70.60.60",
      "superior": null,
      "indent": "6",
      "description": "Chopped or minced",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.6070",
      "rawHtsCode": "2005.70.60.70",
      "superior": null,
      "indent": "6",
      "description": "Other, including wedged or broken",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.7000",
      "rawHtsCode": "2005.70.70.00",
      "superior": null,
      "indent": "5",
      "description": "In airtight containers of glass or metal",
      "units": [
        "kg"
      ],
      "generalRate": "9.9¢/kg on drained weight",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11.6¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.75",
      "rawHtsCode": "2005.70.75",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        ""
      ],
      "generalRate": "4.3¢/kg on drained weight",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.7510",
      "rawHtsCode": "2005.70.75.10",
      "superior": null,
      "indent": "6",
      "description": "Whole pitted",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.7515",
      "rawHtsCode": "2005.70.75.15",
      "superior": null,
      "indent": "6",
      "description": "Sliced",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.7520",
      "rawHtsCode": "2005.70.75.20",
      "superior": null,
      "indent": "6",
      "description": "Chopped or minced",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.7525",
      "rawHtsCode": "2005.70.75.25",
      "superior": null,
      "indent": "6",
      "description": "Other, including wedged or broken",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.70.9100",
      "rawHtsCode": "2005.70.91.00",
      "superior": null,
      "indent": "4",
      "description": "In an aggregate quantity not to exceed 550 metric tons in any calendar year",
      "units": [
        "kg"
      ],
      "generalRate": "5.5¢/kg on drained weight",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.9300",
      "rawHtsCode": "2005.70.93.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg on drained weight",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.70.9700",
      "rawHtsCode": "2005.70.97.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.8¢/kg on drained weight",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "11¢/kg on drained weight",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.80.0000",
      "rawHtsCode": "2005.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sweet corn (<i>Zea mays var. saccharata</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.91",
      "rawHtsCode": "2005.91",
      "superior": null,
      "indent": "2",
      "description": "Bamboo Shoots:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.91.6000",
      "rawHtsCode": "2005.91.60.00",
      "superior": null,
      "indent": "3",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2005.91.9700",
      "rawHtsCode": "2005.91.97.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.99",
      "rawHtsCode": "2005.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.99.1000",
      "rawHtsCode": "2005.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Carrots in airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.99.2000",
      "rawHtsCode": "2005.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Onions",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.99.3000",
      "rawHtsCode": "2005.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "Sauerkraut",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.99.41",
      "rawHtsCode": "2005.99.41",
      "superior": null,
      "indent": "3",
      "description": "Water chestnuts, other than Chinese water chestnuts",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2005.99.4110",
      "rawHtsCode": "2005.99.41.10",
      "superior": null,
      "indent": "4",
      "description": "Sliced",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.99.4120",
      "rawHtsCode": "2005.99.41.20",
      "superior": null,
      "indent": "4",
      "description": "Whole",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.99.50",
      "rawHtsCode": "2005.99.50",
      "superior": null,
      "indent": "4",
      "description": "Pimientos (<i>Capsicum anuum</i>)",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.99.5020",
      "rawHtsCode": "2005.99.50.20",
      "superior": null,
      "indent": "5",
      "description": "In containers each holding not more than 227 g",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.99.5040",
      "rawHtsCode": "2005.99.50.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.99.55",
      "rawHtsCode": "2005.99.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.99.5510",
      "rawHtsCode": "2005.99.55.10",
      "superior": null,
      "indent": "5",
      "description": "Sweet bell-type peppers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.99.5590",
      "rawHtsCode": "2005.99.55.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2005.99.8000",
      "rawHtsCode": "2005.99.80.00",
      "superior": null,
      "indent": "3",
      "description": "Artichokes",
      "units": [
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.99.8500",
      "rawHtsCode": "2005.99.85.00",
      "superior": null,
      "indent": "3",
      "description": "Chickpeas (garbanzos)",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg on entire contents of container",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg on entire contents of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2005.99.9700",
      "rawHtsCode": "2005.99.97.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2006.00",
      "rawHtsCode": "2006.00",
      "superior": null,
      "indent": "0",
      "description": "Vegetables, fruit, nuts, fruit-peel and other parts of plants preserved by sugar (drained, glacé or crystallized):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2006.00.2000",
      "rawHtsCode": "2006.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Cherries",
      "units": [
        "kg"
      ],
      "generalRate": "9.9¢/kg + 6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.9¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2006.00.3000",
      "rawHtsCode": "2006.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Ginger root",
      "units": [
        "kg"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2006.00.4000",
      "rawHtsCode": "2006.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Pineapples",
      "units": [
        "kg"
      ],
      "generalRate": "2.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2006.00.5000",
      "rawHtsCode": "2006.00.50.00",
      "superior": null,
      "indent": "2",
      "description": "Mixtures",
      "units": [
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2006.00.6000",
      "rawHtsCode": "2006.00.60.00",
      "superior": null,
      "indent": "3",
      "description": "Citrus fruit; peel of citrus or other fruit",
      "units": [
        "kg"
      ],
      "generalRate": "6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "17.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2006.00.7000",
      "rawHtsCode": "2006.00.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other fruit and nuts",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2006.00.9000",
      "rawHtsCode": "2006.00.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007",
      "rawHtsCode": "2007",
      "superior": null,
      "indent": "0",
      "description": "Jams, fruit jellies, marmalades, fruit or nut pureé and fruit or nut pastes, obtained by cooking, whether or not containing added sugar or other sweetening matter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2007.10.0000",
      "rawHtsCode": "2007.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Homogenized preparations",
      "units": [
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.91",
      "rawHtsCode": "2007.91",
      "superior": null,
      "indent": "2",
      "description": "Citrus fruit:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2007.91.1000",
      "rawHtsCode": "2007.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pastes and pureés",
      "units": [
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.91.4000",
      "rawHtsCode": "2007.91.40.00",
      "superior": null,
      "indent": "3",
      "description": "Orange marmalade",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.91.9000",
      "rawHtsCode": "2007.91.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99",
      "rawHtsCode": "2007.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2007.99.0500",
      "rawHtsCode": "2007.99.05.00",
      "superior": null,
      "indent": "4",
      "description": "Lingonberry and raspberry",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.1000",
      "rawHtsCode": "2007.99.10.00",
      "superior": null,
      "indent": "4",
      "description": "Strawberry",
      "units": [
        "kg"
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.1500",
      "rawHtsCode": "2007.99.15.00",
      "superior": null,
      "indent": "4",
      "description": "Currant and other berry",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.2000",
      "rawHtsCode": "2007.99.20.00",
      "superior": null,
      "indent": "4",
      "description": "Apricot",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.2500",
      "rawHtsCode": "2007.99.25.00",
      "superior": null,
      "indent": "4",
      "description": "Cherry",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.9¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.3000",
      "rawHtsCode": "2007.99.30.00",
      "superior": null,
      "indent": "4",
      "description": "Guava",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2007.99.3500",
      "rawHtsCode": "2007.99.35.00",
      "superior": null,
      "indent": "4",
      "description": "Peach",
      "units": [
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.4000",
      "rawHtsCode": "2007.99.40.00",
      "superior": null,
      "indent": "4",
      "description": "Pineapple",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.4500",
      "rawHtsCode": "2007.99.45.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.4800",
      "rawHtsCode": "2007.99.48.00",
      "superior": null,
      "indent": "4",
      "description": "Apple, quince and pear",
      "units": [
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.50",
      "rawHtsCode": "2007.99.50",
      "superior": null,
      "indent": "4",
      "description": "Guava and mango",
      "units": [],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.5010",
      "rawHtsCode": "2007.99.50.10",
      "superior": null,
      "indent": "5",
      "description": "Guava",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2007.99.5020",
      "rawHtsCode": "2007.99.50.20",
      "superior": null,
      "indent": "5",
      "description": "Mango",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2007.99.5500",
      "rawHtsCode": "2007.99.55.00",
      "superior": null,
      "indent": "4",
      "description": "Papaya",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.6000",
      "rawHtsCode": "2007.99.60.00",
      "superior": null,
      "indent": "4",
      "description": "Strawberry",
      "units": [
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.65",
      "rawHtsCode": "2007.99.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.6510",
      "rawHtsCode": "2007.99.65.10",
      "superior": null,
      "indent": "5",
      "description": "Red Raspberry",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2007.99.6525",
      "rawHtsCode": "2007.99.65.25",
      "superior": null,
      "indent": "5",
      "description": "Peach",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2007.99.6535",
      "rawHtsCode": "2007.99.65.35",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2007.99.7000",
      "rawHtsCode": "2007.99.70.00",
      "superior": null,
      "indent": "4",
      "description": "Currant and berry",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2007.99.7500",
      "rawHtsCode": "2007.99.75.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008",
      "rawHtsCode": "2008",
      "superior": null,
      "indent": "0",
      "description": "Fruit, nuts and other edible parts of plants, otherwise prepared or preserved, whether or not containing added sugar or other sweetening matter or spirit, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.11",
      "rawHtsCode": "2008.11",
      "superior": null,
      "indent": "2",
      "description": "Peanuts (ground-nuts):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.11.0200",
      "rawHtsCode": "2008.11.02.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2008.11.0500",
      "rawHtsCode": "2008.11.05.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2008.11.1500",
      "rawHtsCode": "2008.11.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "131.8%",
      "specialRate": "Free (AU,BH,CL,CO,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "155%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.20.01-9904.20.10. ",
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.11.4300",
      "rawHtsCode": "2008.11.43.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "15¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.11.4600",
      "rawHtsCode": "2008.11.46.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 2 to chapter 12 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "6.6¢/kg",
      "specialRate": "Free (A*,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.11.6100",
      "rawHtsCode": "2008.11.61.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "131.8%",
      "specialRate": "Free (AU,BH,CL,CO,JO,KR,MA,OM,P,PA,PE,S,SG) See 9908.12.01 (IL)",
      "otherRate": "155%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.12.01-9904.12.19. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.19",
      "rawHtsCode": "2008.19",
      "superior": null,
      "indent": "2",
      "description": "Other, including mixtures:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.19.10",
      "rawHtsCode": "2008.19.10",
      "superior": null,
      "indent": "3",
      "description": "Brazil nuts and cashews",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2008.19.1020",
      "rawHtsCode": "2008.19.10.20",
      "superior": null,
      "indent": "4",
      "description": "Brazil nuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.19.1040",
      "rawHtsCode": "2008.19.10.40",
      "superior": null,
      "indent": "4",
      "description": "Cashews",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.19.1500",
      "rawHtsCode": "2008.19.15.00",
      "superior": null,
      "indent": "3",
      "description": "Coconuts",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.19.2000",
      "rawHtsCode": "2008.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Filberts",
      "units": [
        "kg"
      ],
      "generalRate": "11.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.19.2500",
      "rawHtsCode": "2008.19.25.00",
      "superior": null,
      "indent": "3",
      "description": "Pecans",
      "units": [
        "kg"
      ],
      "generalRate": "9.9¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.19.30",
      "rawHtsCode": "2008.19.30",
      "superior": null,
      "indent": "3",
      "description": "Pignolia and pistachios",
      "units": [],
      "generalRate": "1¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.19.3010",
      "rawHtsCode": "2008.19.30.10",
      "superior": null,
      "indent": "4",
      "description": "Pignolia",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.19.3020",
      "rawHtsCode": "2008.19.30.20",
      "superior": null,
      "indent": "4",
      "description": "Pistachios",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.19.4000",
      "rawHtsCode": "2008.19.40.00",
      "superior": null,
      "indent": "3",
      "description": "Almonds",
      "units": [
        "kg"
      ],
      "generalRate": "32.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.19.5000",
      "rawHtsCode": "2008.19.50.00",
      "superior": null,
      "indent": "3",
      "description": "Watermelon seeds",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.19.8500",
      "rawHtsCode": "2008.19.85.00",
      "superior": null,
      "indent": "4",
      "description": "Mixtures",
      "units": [
        "kg"
      ],
      "generalRate": "22.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.19.90",
      "rawHtsCode": "2008.19.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "17.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.19.9010",
      "rawHtsCode": "2008.19.90.10",
      "superior": null,
      "indent": "5",
      "description": "Macadamia nuts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.19.9090",
      "rawHtsCode": "2008.19.90.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.20.00",
      "rawHtsCode": "2008.20.00",
      "superior": null,
      "indent": "1",
      "description": "Pineapples",
      "units": [],
      "generalRate": "0.35¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.20.0010",
      "rawHtsCode": "2008.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Containing cane and/or beet sugar",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.20.0090",
      "rawHtsCode": "2008.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.30",
      "rawHtsCode": "2008.30",
      "superior": null,
      "indent": "1",
      "description": "Citrus fruit:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.30.1000",
      "rawHtsCode": "2008.30.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of oranges, mandarins (including tangerines and satsumas), clementines, wilkings and similar citrus hybrids",
      "units": [
        "kg"
      ],
      "generalRate": "2¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.2000",
      "rawHtsCode": "2008.30.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of lemons",
      "units": [
        "kg"
      ],
      "generalRate": "4.2¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "17.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.3000",
      "rawHtsCode": "2008.30.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "11.3¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.3500",
      "rawHtsCode": "2008.30.35.00",
      "superior": null,
      "indent": "3",
      "description": "Orange",
      "units": [
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.3700",
      "rawHtsCode": "2008.30.37.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.4000",
      "rawHtsCode": "2008.30.40.00",
      "superior": null,
      "indent": "3",
      "description": "Oranges",
      "units": [
        "kg"
      ],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.42",
      "rawHtsCode": "2008.30.42",
      "superior": null,
      "indent": "6",
      "description": "For an aggregate quantity entered in any calendar year not to exceed 40,000 metric tons",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2008.30.4210",
      "rawHtsCode": "2008.30.42.10",
      "superior": null,
      "indent": "7",
      "description": "Containing cane and/or beet sugar",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.30.4290",
      "rawHtsCode": "2008.30.42.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.30.4600",
      "rawHtsCode": "2008.30.46.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.28¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.4800",
      "rawHtsCode": "2008.30.48.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.28¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.5500",
      "rawHtsCode": "2008.30.55.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.4¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.6000",
      "rawHtsCode": "2008.30.60.00",
      "superior": null,
      "indent": "4",
      "description": "Lemons",
      "units": [
        "kg"
      ],
      "generalRate": "0.8¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.6600",
      "rawHtsCode": "2008.30.66.00",
      "superior": null,
      "indent": "4",
      "description": "Limes",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.7000",
      "rawHtsCode": "2008.30.70.00",
      "superior": null,
      "indent": "3",
      "description": "Grapefruit",
      "units": [
        "kg"
      ],
      "generalRate": "1.1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.8000",
      "rawHtsCode": "2008.30.80.00",
      "superior": null,
      "indent": "3",
      "description": "Kumquats",
      "units": [
        "kg"
      ],
      "generalRate": "0.55¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.8500",
      "rawHtsCode": "2008.30.85.00",
      "superior": null,
      "indent": "3",
      "description": "Citron",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.30.9600",
      "rawHtsCode": "2008.30.96.00",
      "superior": null,
      "indent": "3",
      "description": "Other, including bergamots",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.40.00",
      "rawHtsCode": "2008.40.00",
      "superior": null,
      "indent": "1",
      "description": "Pears",
      "units": [],
      "generalRate": "15.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR, MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.40.0020",
      "rawHtsCode": "2008.40.00.20",
      "superior": null,
      "indent": "2",
      "description": "In containers each holding less than 1.4 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.40.0040",
      "rawHtsCode": "2008.40.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.50",
      "rawHtsCode": "2008.50",
      "superior": null,
      "indent": "1",
      "description": "Apricots:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.50.2000",
      "rawHtsCode": "2008.50.20.00",
      "superior": null,
      "indent": "2",
      "description": "Pulp",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.50.4000",
      "rawHtsCode": "2008.50.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "29.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.60.00",
      "rawHtsCode": "2008.60.00",
      "superior": null,
      "indent": "1",
      "description": "Cherries",
      "units": [],
      "generalRate": "6.9¢/kg + 4.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "21¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.60.0020",
      "rawHtsCode": "2008.60.00.20",
      "superior": null,
      "indent": "2",
      "description": "Maraschino",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.60.0040",
      "rawHtsCode": "2008.60.00.40",
      "superior": null,
      "indent": "3",
      "description": "Sweet varieties",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.60.0060",
      "rawHtsCode": "2008.60.00.60",
      "superior": null,
      "indent": "3",
      "description": "Tart varieties",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.70",
      "rawHtsCode": "2008.70",
      "superior": null,
      "indent": "1",
      "description": "Peaches, including nectarines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.70.10",
      "rawHtsCode": "2008.70.10",
      "superior": null,
      "indent": "2",
      "description": "Nectarines",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.70.1020",
      "rawHtsCode": "2008.70.10.20",
      "superior": null,
      "indent": "3",
      "description": "In containers each holding less than 1.4 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.70.1040",
      "rawHtsCode": "2008.70.10.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.70.20",
      "rawHtsCode": "2008.70.20",
      "superior": null,
      "indent": "2",
      "description": "Other peaches",
      "units": [],
      "generalRate": "17%",
      "specialRate": "Free (A+,AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.70.2020",
      "rawHtsCode": "2008.70.20.20",
      "superior": null,
      "indent": "3",
      "description": "In containers each holding less than 1.4 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.70.2040",
      "rawHtsCode": "2008.70.20.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.80.0000",
      "rawHtsCode": "2008.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Strawberries",
      "units": [
        "kg"
      ],
      "generalRate": "11.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.91.0000",
      "rawHtsCode": "2008.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Palm hearts",
      "units": [
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.93.0000",
      "rawHtsCode": "2008.93.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cranberries (<i>Vaccinium macrocarpon, Vaccinium oxycoccos); lingonberries (Vaccinium, vitis-idaea</i>)",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.97",
      "rawHtsCode": "2008.97",
      "superior": null,
      "indent": "2",
      "description": "Mixtures:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.97.10",
      "rawHtsCode": "2008.97.10",
      "superior": null,
      "indent": "3",
      "description": "In airtight containers and not containing apricots, citrus fruits, peaches or pears",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.97.1020",
      "rawHtsCode": "2008.97.10.20",
      "superior": null,
      "indent": "4",
      "description": "Prepared cereal products",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.97.1040",
      "rawHtsCode": "2008.97.10.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.97.90",
      "rawHtsCode": "2008.97.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.97.9030",
      "rawHtsCode": "2008.97.90.30",
      "superior": null,
      "indent": "6",
      "description": "In containers each holding less than 1.4 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.97.9035",
      "rawHtsCode": "2008.97.90.35",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.97.9040",
      "rawHtsCode": "2008.97.90.40",
      "superior": null,
      "indent": "6",
      "description": "Containing oranges or grapefruit",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.97.9050",
      "rawHtsCode": "2008.97.90.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.97.9092",
      "rawHtsCode": "2008.97.90.92",
      "superior": null,
      "indent": "5",
      "description": "Prepared cereal products",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.97.9094",
      "rawHtsCode": "2008.97.90.94",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99",
      "rawHtsCode": "2008.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99.0500",
      "rawHtsCode": "2008.99.05.00",
      "superior": null,
      "indent": "3",
      "description": "Apples",
      "units": [
        "kg"
      ],
      "generalRate": "0.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.10",
      "rawHtsCode": "2008.99.10",
      "superior": null,
      "indent": "3",
      "description": "Avocados",
      "units": [],
      "generalRate": "10.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.1010",
      "rawHtsCode": "2008.99.10.10",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99.1090",
      "rawHtsCode": "2008.99.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99.1300",
      "rawHtsCode": "2008.99.13.00",
      "superior": null,
      "indent": "4",
      "description": "Pulp",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.1500",
      "rawHtsCode": "2008.99.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.18",
      "rawHtsCode": "2008.99.18",
      "superior": null,
      "indent": "4",
      "description": "Blueberries",
      "units": [],
      "generalRate": "2.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.1810",
      "rawHtsCode": "2008.99.18.10",
      "superior": null,
      "indent": "5",
      "description": "Wild blueberries, canned",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99.1890",
      "rawHtsCode": "2008.99.18.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99.21",
      "rawHtsCode": "2008.99.21",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.2120",
      "rawHtsCode": "2008.99.21.20",
      "superior": null,
      "indent": "5",
      "description": "Red Raspberries",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99.2140",
      "rawHtsCode": "2008.99.21.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99.2300",
      "rawHtsCode": "2008.99.23.00",
      "superior": null,
      "indent": "3",
      "description": "Cashew apples, mameyes colorados, sapodillas, soursops and sweetsops",
      "units": [
        "kg"
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.2500",
      "rawHtsCode": "2008.99.25.00",
      "superior": null,
      "indent": "3",
      "description": "Dates",
      "units": [
        "kg"
      ],
      "generalRate": "22.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.2800",
      "rawHtsCode": "2008.99.28.00",
      "superior": null,
      "indent": "3",
      "description": "Figs",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.2900",
      "rawHtsCode": "2008.99.29.00",
      "superior": null,
      "indent": "3",
      "description": "Grapes",
      "units": [
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.3000",
      "rawHtsCode": "2008.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "Guavas",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2008.99.3500",
      "rawHtsCode": "2008.99.35.00",
      "superior": null,
      "indent": "3",
      "description": "Lychees and longans",
      "units": [
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.4000",
      "rawHtsCode": "2008.99.40.00",
      "superior": null,
      "indent": "3",
      "description": "Mangoes",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.4500",
      "rawHtsCode": "2008.99.45.00",
      "superior": null,
      "indent": "4",
      "description": "Pulp",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.5000",
      "rawHtsCode": "2008.99.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.6000",
      "rawHtsCode": "2008.99.60.00",
      "superior": null,
      "indent": "3",
      "description": "Plums (including prune plums and sloes)",
      "units": [
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.6100",
      "rawHtsCode": "2008.99.61.00",
      "superior": null,
      "indent": "3",
      "description": "Soybeans",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.6300",
      "rawHtsCode": "2008.99.63.00",
      "superior": null,
      "indent": "3",
      "description": "Sweet ginger",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.6500",
      "rawHtsCode": "2008.99.65.00",
      "superior": null,
      "indent": "3",
      "description": "Cassava (manioc)",
      "units": [
        "kg"
      ],
      "generalRate": "7.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.7000",
      "rawHtsCode": "2008.99.70.00",
      "superior": null,
      "indent": "4",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.71",
      "rawHtsCode": "2008.99.71",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2008.99.7110",
      "rawHtsCode": "2008.99.71.10",
      "superior": null,
      "indent": "5",
      "description": "Sliced",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99.7120",
      "rawHtsCode": "2008.99.71.20",
      "superior": null,
      "indent": "5",
      "description": "Whole",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99.8000",
      "rawHtsCode": "2008.99.80.00",
      "superior": null,
      "indent": "4",
      "description": "Pulp",
      "units": [
        "kg"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.91",
      "rawHtsCode": "2008.99.91",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2008.99.9110",
      "rawHtsCode": "2008.99.91.10",
      "superior": null,
      "indent": "5",
      "description": "Bean cake, bean stick, miso and similar products",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99.9150",
      "rawHtsCode": "2008.99.91.50",
      "superior": null,
      "indent": "6",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99.9155",
      "rawHtsCode": "2008.99.91.55",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2008.99.9195",
      "rawHtsCode": "2008.99.91.95",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009",
      "rawHtsCode": "2009",
      "superior": null,
      "indent": "0",
      "description": "Fruit or nut juices (including grape must and coconut water) and vegetable juices, unfermented and not containing added spirit, whether or not containing added sugar or other sweetening matter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.11.00",
      "rawHtsCode": "2009.11.00",
      "superior": null,
      "indent": "2",
      "description": "Frozen",
      "units": [],
      "generalRate": "7.85¢/liter",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.11.0020",
      "rawHtsCode": "2009.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "In containers each holding less than 0.946 liter",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.11.0040",
      "rawHtsCode": "2009.11.00.40",
      "superior": null,
      "indent": "3",
      "description": "In containers each holding 0.946 liter or more but not more than 3.785 liters",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.11.0060",
      "rawHtsCode": "2009.11.00.60",
      "superior": null,
      "indent": "3",
      "description": "In containers of more than 3.785 liters",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.12",
      "rawHtsCode": "2009.12",
      "superior": null,
      "indent": "2",
      "description": "Not frozen, of a Brix value not exceeding 20:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.12.2500",
      "rawHtsCode": "2009.12.25.00",
      "superior": null,
      "indent": "3",
      "description": "Not concentrated and not made from a juice having a degree of concentration of 1.5 or more (as determined before correction to the nearest 0.5 degree)",
      "units": [
        "liters"
      ],
      "generalRate": "4.5¢/liter",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.12.4500",
      "rawHtsCode": "2009.12.45.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "7.85¢/liter",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.19.0000",
      "rawHtsCode": "2009.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "7.85¢/liter",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.21",
      "rawHtsCode": "2009.21",
      "superior": null,
      "indent": "2",
      "description": "Of a Brix value not exceeding 20:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.21.2000",
      "rawHtsCode": "2009.21.20.00",
      "superior": null,
      "indent": "3",
      "description": "Not concentrated and not made from a juice having a degree of concentration of 1.5 or more (as determined before correction to the nearest 0.5 degree)",
      "units": [
        "liters"
      ],
      "generalRate": "4.5¢/ liter",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.21.40",
      "rawHtsCode": "2009.21.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.9¢/liter",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.21.4020",
      "rawHtsCode": "2009.21.40.20",
      "superior": null,
      "indent": "4",
      "description": "Frozen",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.21.4040",
      "rawHtsCode": "2009.21.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.29.00",
      "rawHtsCode": "2009.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "7.9¢/liter",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.29.0020",
      "rawHtsCode": "2009.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Frozen",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.29.0040",
      "rawHtsCode": "2009.29.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.31",
      "rawHtsCode": "2009.31",
      "superior": null,
      "indent": "2",
      "description": "Of a Brix value not exceeding 20:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.31.10",
      "rawHtsCode": "2009.31.10",
      "superior": null,
      "indent": "4",
      "description": "Unfit for beverage purposes",
      "units": [],
      "generalRate": "1.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.31.1020",
      "rawHtsCode": "2009.31.10.20",
      "superior": null,
      "indent": "5",
      "description": "Not concentrated",
      "units": [
        "kg",
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.31.1040",
      "rawHtsCode": "2009.31.10.40",
      "superior": null,
      "indent": "5",
      "description": "Concentrated",
      "units": [
        "kg",
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.31.20",
      "rawHtsCode": "2009.31.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "1.7¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.31.2020",
      "rawHtsCode": "2009.31.20.20",
      "superior": null,
      "indent": "5",
      "description": "Not concentrated",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.31.2040",
      "rawHtsCode": "2009.31.20.40",
      "superior": null,
      "indent": "5",
      "description": "Concentrated",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.31.4000",
      "rawHtsCode": "2009.31.40.00",
      "superior": null,
      "indent": "4",
      "description": "Not concentrated",
      "units": [
        "liters"
      ],
      "generalRate": "3.4¢/liter",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.31.60",
      "rawHtsCode": "2009.31.60",
      "superior": null,
      "indent": "4",
      "description": "Concentrated",
      "units": [],
      "generalRate": "7.9¢/liter",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.31.6020",
      "rawHtsCode": "2009.31.60.20",
      "superior": null,
      "indent": "6",
      "description": "Frozen",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.31.6040",
      "rawHtsCode": "2009.31.60.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.31.6060",
      "rawHtsCode": "2009.31.60.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.39",
      "rawHtsCode": "2009.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.39.1000",
      "rawHtsCode": "2009.39.10.00",
      "superior": null,
      "indent": "4",
      "description": "Unfit for beverage purposes",
      "units": [
        "kg",
        "liters"
      ],
      "generalRate": "1.8¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.39.2000",
      "rawHtsCode": "2009.39.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "1.7¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.39.60",
      "rawHtsCode": "2009.39.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.9¢/liter",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.39.6020",
      "rawHtsCode": "2009.39.60.20",
      "superior": null,
      "indent": "5",
      "description": "Frozen",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.39.6040",
      "rawHtsCode": "2009.39.60.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.39.6060",
      "rawHtsCode": "2009.39.60.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.41",
      "rawHtsCode": "2009.41",
      "superior": null,
      "indent": "2",
      "description": "Of a Brix value not exceeding 20:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.41.2000",
      "rawHtsCode": "2009.41.20.00",
      "superior": null,
      "indent": "3",
      "description": "Not concentrated, or having a degree of concentration of not more than 3.5 (as determined before correction to the nearest 0.5 degree)",
      "units": [
        "liters"
      ],
      "generalRate": "4.2¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.41.40",
      "rawHtsCode": "2009.41.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "1¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.41.4020",
      "rawHtsCode": "2009.41.40.20",
      "superior": null,
      "indent": "4",
      "description": "Frozen",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.41.4040",
      "rawHtsCode": "2009.41.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.49",
      "rawHtsCode": "2009.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.49.2000",
      "rawHtsCode": "2009.49.20.00",
      "superior": null,
      "indent": "3",
      "description": "Not concentrated, or having a degree of concentration of not more than 3.5 (as determined before correction to the nearest 0.5 degree)",
      "units": [
        "liters"
      ],
      "generalRate": "4.2¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.49.40",
      "rawHtsCode": "2009.49.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "1¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.49.4020",
      "rawHtsCode": "2009.49.40.20",
      "superior": null,
      "indent": "4",
      "description": "Frozen",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.49.4040",
      "rawHtsCode": "2009.49.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.50.00",
      "rawHtsCode": "2009.50.00",
      "superior": null,
      "indent": "1",
      "description": "Tomato juice",
      "units": [],
      "generalRate": "0.14¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.50.0010",
      "rawHtsCode": "2009.50.00.10",
      "superior": null,
      "indent": "2",
      "description": "In airtight containers",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.50.0090",
      "rawHtsCode": "2009.50.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.61.00",
      "rawHtsCode": "2009.61.00",
      "superior": null,
      "indent": "2",
      "description": "Of a Brix value not exceeding 30",
      "units": [],
      "generalRate": "4.4¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "26¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.61.0020",
      "rawHtsCode": "2009.61.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not concentrated",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.61.0040",
      "rawHtsCode": "2009.61.00.40",
      "superior": null,
      "indent": "4",
      "description": "Frozen",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.61.0060",
      "rawHtsCode": "2009.61.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.69.00",
      "rawHtsCode": "2009.69.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "26¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.69.0040",
      "rawHtsCode": "2009.69.00.40",
      "superior": null,
      "indent": "3",
      "description": "Frozen",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.69.0060",
      "rawHtsCode": "2009.69.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.71.0000",
      "rawHtsCode": "2009.71.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a Brix value not exceeding 20",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.3¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2009.79.00",
      "rawHtsCode": "2009.79.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.3¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2009.79.0015",
      "rawHtsCode": "2009.79.00.15",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.79.0017",
      "rawHtsCode": "2009.79.00.17",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.79.0040",
      "rawHtsCode": "2009.79.00.40",
      "superior": null,
      "indent": "4",
      "description": "Certified organic",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.79.0060",
      "rawHtsCode": "2009.79.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.81.0000",
      "rawHtsCode": "2009.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cranberry (<i>Vaccinium macrocarpon, Vaccinium oxycoccos) juice; lingonberry (Vaccinium, vitis-idaea</i>) juice",
      "units": [
        "liters"
      ],
      "generalRate": "0.5¢/liter",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.89",
      "rawHtsCode": "2009.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.2000",
      "rawHtsCode": "2009.89.20.00",
      "superior": null,
      "indent": "4",
      "description": "Pear juice",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.3¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2009.89.4000",
      "rawHtsCode": "2009.89.40.00",
      "superior": null,
      "indent": "4",
      "description": "Prune juice",
      "units": [
        "liters"
      ],
      "generalRate": "0.64¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.89.65",
      "rawHtsCode": "2009.89.65",
      "superior": null,
      "indent": "4",
      "description": "Cherry Juice",
      "units": [],
      "generalRate": "0.5¢/liter",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.89.6515",
      "rawHtsCode": "2009.89.65.15",
      "superior": null,
      "indent": "6",
      "description": "Certified organic",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.6520",
      "rawHtsCode": "2009.89.65.20",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.6530",
      "rawHtsCode": "2009.89.65.30",
      "superior": null,
      "indent": "6",
      "description": "Certified organic",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.6540",
      "rawHtsCode": "2009.89.65.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.6550",
      "rawHtsCode": "2009.89.65.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.70",
      "rawHtsCode": "2009.89.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "0.5¢/liter",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.89.7031",
      "rawHtsCode": "2009.89.70.31",
      "superior": null,
      "indent": "6",
      "description": "Blueberry juice, including concentrate",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.7055",
      "rawHtsCode": "2009.89.70.55",
      "superior": null,
      "indent": "6",
      "description": "Red raspberry juice, including concentrate",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.7065",
      "rawHtsCode": "2009.89.70.65",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.7070",
      "rawHtsCode": "2009.89.70.70",
      "superior": null,
      "indent": "5",
      "description": "Mango Juice",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.7095",
      "rawHtsCode": "2009.89.70.95",
      "superior": null,
      "indent": "6",
      "description": "Certified organic",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.7097",
      "rawHtsCode": "2009.89.70.97",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.7099",
      "rawHtsCode": "2009.89.70.99",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.80",
      "rawHtsCode": "2009.89.80",
      "superior": null,
      "indent": "3",
      "description": "Vegetable juice",
      "units": [],
      "generalRate": "0.2¢/liter",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.89.8031",
      "rawHtsCode": "2009.89.80.31",
      "superior": null,
      "indent": "4",
      "description": "In airtight containers",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.89.8039",
      "rawHtsCode": "2009.89.80.39",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.90",
      "rawHtsCode": "2009.90",
      "superior": null,
      "indent": "1",
      "description": "Mixtures of juices:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2009.90.2000",
      "rawHtsCode": "2009.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Vegetable",
      "units": [
        "liters"
      ],
      "generalRate": "0.2¢/liter",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2009.90.4000",
      "rawHtsCode": "2009.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "7.4¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101",
      "rawHtsCode": "2101",
      "superior": null,
      "indent": "0",
      "description": "Extracts, essences and concentrates, of coffee, tea or maté and preparations with a basis of these products or with a basis of coffee, tea or maté; roasted chicory and other roasted coffee substitutes, and extracts, essences and concentrates thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2101.11",
      "rawHtsCode": "2101.11",
      "superior": null,
      "indent": "2",
      "description": "Extracts, essences and concentrates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2101.11.21",
      "rawHtsCode": "2101.11.21",
      "superior": null,
      "indent": "3",
      "description": "Instant coffee, not flavored",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2101.11.2126",
      "rawHtsCode": "2101.11.21.26",
      "superior": null,
      "indent": "5",
      "description": "Packaged for retail sale",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2101.11.2129",
      "rawHtsCode": "2101.11.21.29",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2101.11.2131",
      "rawHtsCode": "2101.11.21.31",
      "superior": null,
      "indent": "5",
      "description": "Packaged for retail sale",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2101.11.2139",
      "rawHtsCode": "2101.11.21.39",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2101.11.29",
      "rawHtsCode": "2101.11.29",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2101.11.2941",
      "rawHtsCode": "2101.11.29.41",
      "superior": null,
      "indent": "4",
      "description": "Packaged for retail sale",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2101.11.2949",
      "rawHtsCode": "2101.11.29.49",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2101.12",
      "rawHtsCode": "2101.12",
      "superior": null,
      "indent": "2",
      "description": "Preparations with a basis of extracts, essences or concentrates or with a basis of coffee:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2101.12.3200",
      "rawHtsCode": "2101.12.32.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.12.3400",
      "rawHtsCode": "2101.12.34.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 9 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.12.3800",
      "rawHtsCode": "2101.12.38.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "30.5¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "35.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.66-9904.17.84. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.12.4400",
      "rawHtsCode": "2101.12.44.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 7 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.12.4800",
      "rawHtsCode": "2101.12.48.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "30.5¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "35.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.12.5400",
      "rawHtsCode": "2101.12.54.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 8 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.12.5800",
      "rawHtsCode": "2101.12.58.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "30.5¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "35.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.49-9904.17.65. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.12.9000",
      "rawHtsCode": "2101.12.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.20",
      "rawHtsCode": "2101.20",
      "superior": null,
      "indent": "1",
      "description": "Extracts, essences and concentrates, of tea or maté, and preparations with a basis of these extracts, essences or concentrates or with a basis of tea or maté:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2101.20.20",
      "rawHtsCode": "2101.20.20",
      "superior": null,
      "indent": "2",
      "description": "Extracts, essences and concentrates",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2101.20.2010",
      "rawHtsCode": "2101.20.20.10",
      "superior": null,
      "indent": "3",
      "description": "Instant tea",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2101.20.2090",
      "rawHtsCode": "2101.20.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2101.20.3200",
      "rawHtsCode": "2101.20.32.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.20.3400",
      "rawHtsCode": "2101.20.34.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 9 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.20.3800",
      "rawHtsCode": "2101.20.38.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "30.5¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "35.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.66-9904.17.84. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.20.4400",
      "rawHtsCode": "2101.20.44.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 7 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.20.4800",
      "rawHtsCode": "2101.20.48.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "30.5¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "35.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.20.5400",
      "rawHtsCode": "2101.20.54.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 8 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.20.5800",
      "rawHtsCode": "2101.20.58.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "30.5¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "35.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.49-9904.17.65. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.20.9000",
      "rawHtsCode": "2101.20.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2101.30.0000",
      "rawHtsCode": "2101.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Roasted chicory and other roasted coffee substitutes and extracts, essences and concentrates thereof",
      "units": [
        "kg"
      ],
      "generalRate": "2.1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2102",
      "rawHtsCode": "2102",
      "superior": null,
      "indent": "0",
      "description": "Yeasts (active or inactive); other single-cell microorganisms, dead (but not including vaccines of heading 3002); prepared baking powders:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2102.10.0000",
      "rawHtsCode": "2102.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Active yeasts",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2102.20",
      "rawHtsCode": "2102.20",
      "superior": null,
      "indent": "1",
      "description": "Inactive yeasts; other single-cell microorganisms, dead:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2102.20.2000",
      "rawHtsCode": "2102.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Yeasts (except dried brewers' yeast)",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2102.20.4000",
      "rawHtsCode": "2102.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Dried brewers' yeast, crude",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2102.20.6000",
      "rawHtsCode": "2102.20.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2102.30.0000",
      "rawHtsCode": "2102.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Prepared baking powders",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2103",
      "rawHtsCode": "2103",
      "superior": null,
      "indent": "0",
      "description": "Sauces and preparations therefore; mixed condiments and mixed seasonings; mustard flour and meal and prepared mustard:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2103.10.0000",
      "rawHtsCode": "2103.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Soy sauce",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2103.20",
      "rawHtsCode": "2103.20",
      "superior": null,
      "indent": "1",
      "description": "Tomato ketchup and other tomato sauces:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2103.20.2000",
      "rawHtsCode": "2103.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Tomato ketchup",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2103.20.40",
      "rawHtsCode": "2103.20.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "11.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2103.20.4020",
      "rawHtsCode": "2103.20.40.20",
      "superior": null,
      "indent": "3",
      "description": "In containers holding less than 1.4 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2103.20.4040",
      "rawHtsCode": "2103.20.40.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2103.30",
      "rawHtsCode": "2103.30",
      "superior": null,
      "indent": "1",
      "description": "Mustard flour and meal and prepared mustard:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2103.30.2000",
      "rawHtsCode": "2103.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Mustard flour and meal",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2103.30.4000",
      "rawHtsCode": "2103.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Prepared mustard",
      "units": [
        "kg"
      ],
      "generalRate": "2.8¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2103.90",
      "rawHtsCode": "2103.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2103.90.2000",
      "rawHtsCode": "2103.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Sauces derived or prepared from fish",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2103.90.4000",
      "rawHtsCode": "2103.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Nonalcoholic preparations of yeast extract (other than sauces)",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2103.90.7200",
      "rawHtsCode": "2103.90.72.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.75% (JP)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2103.90.7400",
      "rawHtsCode": "2103.90.74.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 4 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2103.90.7800",
      "rawHtsCode": "2103.90.78.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "30.5¢/kg + 6.4%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "35.9¢/kg + 7.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.21.01-9904.21.09. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2103.90.8000",
      "rawHtsCode": "2103.90.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2103.90.90",
      "rawHtsCode": "2103.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2103.90.9020",
      "rawHtsCode": "2103.90.90.20",
      "superior": null,
      "indent": "4",
      "description": "Mayonnaise",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2103.90.9040",
      "rawHtsCode": "2103.90.90.40",
      "superior": null,
      "indent": "4",
      "description": "Other salad dressings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2103.90.9051",
      "rawHtsCode": "2103.90.90.51",
      "superior": null,
      "indent": "5",
      "description": "In containers holding less than 1.4 kg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2103.90.9059",
      "rawHtsCode": "2103.90.90.59",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2103.90.9091",
      "rawHtsCode": "2103.90.90.91",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2104",
      "rawHtsCode": "2104",
      "superior": null,
      "indent": "0",
      "description": "Soups and broths and preparations therefor; homogenized composite food preparations:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2104.10.00",
      "rawHtsCode": "2104.10.00",
      "superior": null,
      "indent": "1",
      "description": "Soups and broths and preparations therefor",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2104.10.0020",
      "rawHtsCode": "2104.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Dried",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2104.10.0040",
      "rawHtsCode": "2104.10.00.40",
      "superior": null,
      "indent": "3",
      "description": "Based on fish or other seafood",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2104.10.0060",
      "rawHtsCode": "2104.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2104.20",
      "rawHtsCode": "2104.20",
      "superior": null,
      "indent": "1",
      "description": "Homogenized composite food preparations:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2104.20.1000",
      "rawHtsCode": "2104.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Put up for retail sale as food suitable for infants or for dietetic purposes",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2104.20.5000",
      "rawHtsCode": "2104.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Put up for retail sale as food suitable for young children",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2105.00",
      "rawHtsCode": "2105.00",
      "superior": null,
      "indent": "0",
      "description": "Ice cream and other edible ice, whether or not containing cocoa:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2105.00.0500",
      "rawHtsCode": "2105.00.05.00",
      "superior": null,
      "indent": "2",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 10% (JP)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2105.00.1000",
      "rawHtsCode": "2105.00.10.00",
      "superior": null,
      "indent": "2",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg",
        "liters"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2105.00.2000",
      "rawHtsCode": "2105.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg",
        "liters"
      ],
      "generalRate": "50.2¢/kg + 17%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PE,SG) See 9822.04.05 (AU) See 9823.01.01-9823.01.07 (S+) See 9908.21.01 (IL) See 9919.21.10, 9919.21.11-9919.21.12 (PA)",
      "otherRate": "59¢/kg +20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.21.10-9904.21.18. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2105.00.2500",
      "rawHtsCode": "2105.00.25.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 10% (JP)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2105.00.3000",
      "rawHtsCode": "2105.00.30.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2105.00.4000",
      "rawHtsCode": "2105.00.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "50.2¢/kg + 17%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "59¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2105.00.5000",
      "rawHtsCode": "2105.00.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "17%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106",
      "rawHtsCode": "2106",
      "superior": null,
      "indent": "0",
      "description": "Food preparations not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.10.0000",
      "rawHtsCode": "2106.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Protein concentrates and textured protein substances",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90",
      "rawHtsCode": "2106.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.0300",
      "rawHtsCode": "2106.90.03.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "2.9¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.0600",
      "rawHtsCode": "2106.90.06.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "2.9¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.0900",
      "rawHtsCode": "2106.90.09.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "86.2¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60-9918.04.80 (CO)",
      "otherRate": "$1.014/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.1200",
      "rawHtsCode": "2106.90.12.00",
      "superior": null,
      "indent": "3",
      "description": "Containing not over 20 percent of alcohol by weight",
      "units": [
        "kg"
      ],
      "generalRate": "4.2¢/kg + 1.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "44¢/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001 or 26 U.S.C. 5041).  ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.1500",
      "rawHtsCode": "2106.90.15.00",
      "superior": null,
      "indent": "3",
      "description": "Containing over 20 percent but not over 50 percent of alcohol by weight",
      "units": [
        "kg"
      ],
      "generalRate": "8.4¢/kg + 1.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "88¢/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001 or 26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.1800",
      "rawHtsCode": "2106.90.18.00",
      "superior": null,
      "indent": "3",
      "description": "Containing over 50 percent of alcohol by weight",
      "units": [
        "kg"
      ],
      "generalRate": "17¢/kg + 1.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.76/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001 or 26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.2200",
      "rawHtsCode": "2106.90.22.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "15.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.2400",
      "rawHtsCode": "2106.90.24.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 14 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "15.4¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.2600",
      "rawHtsCode": "2106.90.26.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.996/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.10 (AU) See 9823.03.01-9823.03.12 (S+)",
      "otherRate": "$2.348/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.05.37-9904.05.47. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.2800",
      "rawHtsCode": "2106.90.28.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "13.1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.3200",
      "rawHtsCode": "2106.90.32.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "15.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.3400",
      "rawHtsCode": "2106.90.34.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 14 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "15.4¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.3600",
      "rawHtsCode": "2106.90.36.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "$1.996/kg",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.10 (AU) See 9823.03.01-9823.03.12 (S+)",
      "otherRate": "$2.348/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.05.37-9904.05.47. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.3800",
      "rawHtsCode": "2106.90.38.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "13.1¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.3900",
      "rawHtsCode": "2106.90.39.00",
      "superior": null,
      "indent": "2",
      "description": "Artificially sweetened cough drops",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.4200",
      "rawHtsCode": "2106.90.42.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.6606¢/kg of total sugars",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.58170¢/kg of total sugars",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.4400",
      "rawHtsCode": "2106.90.44.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 5 to chapter 17 andentered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "3.6606¢/kg of total sugars",
      "specialRate": "Free (A*,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG) See 9822.05.15 (P+)",
      "otherRate": "6.58170¢/kg of total sugars",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.4600",
      "rawHtsCode": "2106.90.46.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "35.74¢/kg",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "42.05¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.08-9904.17.16. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.4800",
      "rawHtsCode": "2106.90.48.00",
      "superior": null,
      "indent": "3",
      "description": "Orange juice",
      "units": [
        "liters"
      ],
      "generalRate": "7.85¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.5200",
      "rawHtsCode": "2106.90.52.00",
      "superior": null,
      "indent": "4",
      "description": "Juice of any single fruit or vegetable",
      "units": [
        "liters"
      ],
      "generalRate": "The rate applicable to the natural juice in heading 2009",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)The rate applicable to the natural juice in heading 2009 (A*,D)",
      "otherRate": "The rate applicable to the natural juice in heading 2009",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.5400",
      "rawHtsCode": "2106.90.54.00",
      "superior": null,
      "indent": "4",
      "description": "Mixtures of juices",
      "units": [
        "liters"
      ],
      "generalRate": "The rate applicable to the natural juice in heading 2009",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)The rate applicable to the natural juice in heading 2009 (A*,D)",
      "otherRate": "The rate applicable to the natural juice in heading 2009",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.58",
      "rawHtsCode": "2106.90.58",
      "superior": null,
      "indent": "3",
      "description": "Of gelatin",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.5830",
      "rawHtsCode": "2106.90.58.30",
      "superior": null,
      "indent": "5",
      "description": "Containing sugar derived from sugar cane or sugar beets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.5850",
      "rawHtsCode": "2106.90.58.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.5870",
      "rawHtsCode": "2106.90.58.70",
      "superior": null,
      "indent": "5",
      "description": "Containing sugar derived from sugar cane or sugar beets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.5890",
      "rawHtsCode": "2106.90.58.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.6200",
      "rawHtsCode": "2106.90.62.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.6400",
      "rawHtsCode": "2106.90.64.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.6600",
      "rawHtsCode": "2106.90.66.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "70.4¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60, 9918.04.67 (CO)",
      "otherRate": "82.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.6800",
      "rawHtsCode": "2106.90.68.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 9 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.7200",
      "rawHtsCode": "2106.90.72.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "70.4¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "82.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.66-9904.17.84. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.7400",
      "rawHtsCode": "2106.90.74.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 7 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.7600",
      "rawHtsCode": "2106.90.76.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "70.4¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "82.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.7800",
      "rawHtsCode": "2106.90.78.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 8 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.8000",
      "rawHtsCode": "2106.90.80.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "70.4¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "82.8¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.49-9904.17.65. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.8200",
      "rawHtsCode": "2106.90.82.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "kg cmsc"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.8300",
      "rawHtsCode": "2106.90.83.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.8500",
      "rawHtsCode": "2106.90.85.00",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.8700",
      "rawHtsCode": "2106.90.87.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "28.8¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.08.01-9823.08.38 (S+) See 9918.04.60, 9918.04.79 (CO)",
      "otherRate": "33.9¢/kg +10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.8900",
      "rawHtsCode": "2106.90.89.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 9 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.9100",
      "rawHtsCode": "2106.90.91.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "28.8¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "33.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.66-9904.17.84. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.9200",
      "rawHtsCode": "2106.90.92.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 7 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (CO,KR,OM,PA,PE,S)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.9400",
      "rawHtsCode": "2106.90.94.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "28.8¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "33.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.17-9904.17.48. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.9500",
      "rawHtsCode": "2106.90.95.00",
      "superior": null,
      "indent": "7",
      "description": "Described in additional U.S. note 8 to chapter 17 and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.9700",
      "rawHtsCode": "2106.90.97.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "28.8¢/kg + 8.5%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01(MA)",
      "otherRate": "33.9¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.49-9904.17.65. ",
        "See 9903.19.21 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.99",
      "rawHtsCode": "2106.90.99",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.19.22 and  9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2106.90.9971",
      "rawHtsCode": "2106.90.99.71",
      "superior": null,
      "indent": "8",
      "description": "Containing high-intensity sweeteners (e.g., aspartame and/or saccharin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.9972",
      "rawHtsCode": "2106.90.99.72",
      "superior": null,
      "indent": "8",
      "description": "Containing sugar derived from sugar cane and/or sugar beets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.9973",
      "rawHtsCode": "2106.90.99.73",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.9975",
      "rawHtsCode": "2106.90.99.75",
      "superior": null,
      "indent": "7",
      "description": "Non-dairy coffee whiteners",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.9980",
      "rawHtsCode": "2106.90.99.80",
      "superior": null,
      "indent": "7",
      "description": "Other cream or milk substitutes",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.9985",
      "rawHtsCode": "2106.90.99.85",
      "superior": null,
      "indent": "7",
      "description": "Confectionery (including gum) containing synthetic sweetening agents (e.g., saccharin) instead of sugar",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.9987",
      "rawHtsCode": "2106.90.99.87",
      "superior": null,
      "indent": "7",
      "description": "Herbal teas and herbal infusions comprising mixed herbs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.9988",
      "rawHtsCode": "2106.90.99.88",
      "superior": null,
      "indent": "7",
      "description": "Flavored honey",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.9990",
      "rawHtsCode": "2106.90.99.90",
      "superior": null,
      "indent": "8",
      "description": "Canned",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.9995",
      "rawHtsCode": "2106.90.99.95",
      "superior": null,
      "indent": "9",
      "description": "Frozen",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.9997",
      "rawHtsCode": "2106.90.99.97",
      "superior": null,
      "indent": "10",
      "description": "Containing sugar derived from sugar cane and/or sugar beets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2106.90.9998",
      "rawHtsCode": "2106.90.99.98",
      "superior": null,
      "indent": "10",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2201",
      "rawHtsCode": "2201",
      "superior": null,
      "indent": "0",
      "description": "Waters, including natural or artificial mineral waters and aerated waters, not containing added sugar or other sweetening matter nor flavored; ice and snow:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2201.10.0000",
      "rawHtsCode": "2201.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mineral waters and aerated waters",
      "units": [
        "liters"
      ],
      "generalRate": "0.26¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.6¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2201.90.0000",
      "rawHtsCode": "2201.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2202",
      "rawHtsCode": "2202",
      "superior": null,
      "indent": "0",
      "description": "Waters, including mineral waters and aerated waters, containing added sugar or other sweetening matter or flavored, and other non-alcoholic beverages, not including fruit, nut or vegetable juices of heading 2009:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2202.10.00",
      "rawHtsCode": "2202.10.00",
      "superior": null,
      "indent": "1",
      "description": "Waters, including mineral waters and aerated waters, containing added sugar or other sweetening matter or flavored",
      "units": [],
      "generalRate": "0.2¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2202.10.0020",
      "rawHtsCode": "2202.10.00.20",
      "superior": null,
      "indent": "3",
      "description": "Containing high-intensity sweeteners (e.g., aspartame and/or saccharin)",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2202.10.0045",
      "rawHtsCode": "2202.10.00.45",
      "superior": null,
      "indent": "4",
      "description": "In aluminum containers",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2202.10.0055",
      "rawHtsCode": "2202.10.00.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2202.10.0065",
      "rawHtsCode": "2202.10.00.65",
      "superior": null,
      "indent": "3",
      "description": "In aluminum containers",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2202.10.0075",
      "rawHtsCode": "2202.10.00.75",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2202.91.00",
      "rawHtsCode": "2202.91.00",
      "superior": null,
      "indent": "2",
      "description": "Non-alcoholic beer",
      "units": [],
      "generalRate": "0.2¢/liter",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2202.91.0010",
      "rawHtsCode": "2202.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "In aluminum containers",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2202.91.0020",
      "rawHtsCode": "2202.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2202.99",
      "rawHtsCode": "2202.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2202.99.1000",
      "rawHtsCode": "2202.99.10.00",
      "superior": null,
      "indent": "4",
      "description": "Chocolate milk drink",
      "units": [
        "liters",
        "kg cmsc"
      ],
      "generalRate": "17%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2202.99.2200",
      "rawHtsCode": "2202.99.22.00",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2202.99.2400",
      "rawHtsCode": "2202.99.24.00",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 10 to chapter 4 and entered pursuant to its provisions",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2202.99.2800",
      "rawHtsCode": "2202.99.28.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "23.5¢/liter + 14.9%",
      "specialRate": "Free (BH,CL,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.25 (AU) See 9823.01.01-9823.01.07 (S+) See 9918.04.60, 9918.04.80 (CO)",
      "otherRate": "27.6¢/liter+ 17.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.04.50-9904.05.01. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2202.99.3000",
      "rawHtsCode": "2202.99.30.00",
      "superior": null,
      "indent": "5",
      "description": "Not made from a juice having a degree of concentration of 1.5 or more (as determined before correction to the nearest 0.5 degree)",
      "units": [
        "liters"
      ],
      "generalRate": "4.5¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2202.99.3500",
      "rawHtsCode": "2202.99.35.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "7.85¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2202.99.3600",
      "rawHtsCode": "2202.99.36.00",
      "superior": null,
      "indent": "5",
      "description": "Juice of any single fruit or vegetable",
      "units": [
        "liters"
      ],
      "generalRate": "The rate applicable to the natural juice in heading 2009",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)The rate applicable to the natural juice in heading 2009(A*)",
      "otherRate": "The rate applicable to the natural juice in heading 2009",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2202.99.3700",
      "rawHtsCode": "2202.99.37.00",
      "superior": null,
      "indent": "5",
      "description": "Mixtures of juices",
      "units": [
        "liters"
      ],
      "generalRate": "The rate applicable to the natural juice in heading 2009",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) The rate applicable to the natural juice in heading 2009 (A*)",
      "otherRate": "The rate applicable to the natural juice in heading 2009",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2202.99.91",
      "rawHtsCode": "2202.99.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "0.2¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2202.99.9110",
      "rawHtsCode": "2202.99.91.10",
      "superior": null,
      "indent": "4",
      "description": "In aluminum containers",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2202.99.9130",
      "rawHtsCode": "2202.99.91.30",
      "superior": null,
      "indent": "6",
      "description": "Certified organic",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2202.99.9135",
      "rawHtsCode": "2202.99.91.35",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2202.99.9190",
      "rawHtsCode": "2202.99.91.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2203.00.00",
      "rawHtsCode": "2203.00.00",
      "superior": null,
      "indent": "0",
      "description": "Beer made from malt",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "13.2¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5051).",
        "See 9903.88.03."
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2203.00.0030",
      "rawHtsCode": "2203.00.00.30",
      "superior": null,
      "indent": "2",
      "description": "In glass containers",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2203.00.0060",
      "rawHtsCode": "2203.00.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2203.00.0090",
      "rawHtsCode": "2203.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "In containers each holding over 4 liters",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204",
      "rawHtsCode": "2204",
      "superior": null,
      "indent": "0",
      "description": "Wine of fresh grapes, including fortified wines; grape must other than that of heading 2009:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.10.00",
      "rawHtsCode": "2204.10.00",
      "superior": null,
      "indent": "1",
      "description": "Sparkling wine",
      "units": [],
      "generalRate": "19.8¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)8.8¢/liter(JO)",
      "otherRate": "$1.59/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.03. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2204.10.0030",
      "rawHtsCode": "2204.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Valued not over $1.59/liter",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.10.0065",
      "rawHtsCode": "2204.10.00.65",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.10.0075",
      "rawHtsCode": "2204.10.00.75",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.21",
      "rawHtsCode": "2204.21",
      "superior": null,
      "indent": "2",
      "description": "In containers holding 2 liters or less:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.21.2000",
      "rawHtsCode": "2204.21.20.00",
      "superior": null,
      "indent": "3",
      "description": "Effervescent wine",
      "units": [
        "liters"
      ],
      "generalRate": "19.8¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 8.8¢/liter (JO)",
      "otherRate": "$1.59/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.03. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2204.21.3000",
      "rawHtsCode": "2204.21.30.00",
      "superior": null,
      "indent": "5",
      "description": "If entitled under regulations of the United States Internal Revenue Service to a type designation which includes the name \"Tokay\" and if so designated on the approved label",
      "units": [
        "liters"
      ],
      "generalRate": "6.3¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)2.8¢/liter(JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.03. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2204.21.50",
      "rawHtsCode": "2204.21.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "6.3¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 2.8¢/liter (JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.03. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2204.21.5005",
      "rawHtsCode": "2204.21.50.05",
      "superior": null,
      "indent": "7",
      "description": "Red",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.21.5015",
      "rawHtsCode": "2204.21.50.15",
      "superior": null,
      "indent": "7",
      "description": "White",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.21.5025",
      "rawHtsCode": "2204.21.50.25",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.21.5028",
      "rawHtsCode": "2204.21.50.28",
      "superior": null,
      "indent": "7",
      "description": "Icewine",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.21.5035",
      "rawHtsCode": "2204.21.50.35",
      "superior": null,
      "indent": "9",
      "description": "Certified organic",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.21.5040",
      "rawHtsCode": "2204.21.50.40",
      "superior": null,
      "indent": "9",
      "description": "Not certified organic",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.21.5050",
      "rawHtsCode": "2204.21.50.50",
      "superior": null,
      "indent": "9",
      "description": "Certified organic",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.21.5055",
      "rawHtsCode": "2204.21.50.55",
      "superior": null,
      "indent": "9",
      "description": "Not certified organic",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.21.5060",
      "rawHtsCode": "2204.21.50.60",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.21.6000",
      "rawHtsCode": "2204.21.60.00",
      "superior": null,
      "indent": "5",
      "description": "If entitled under regulations of the United States Internal Revenue Service to a type designation which includes the name \"Marsala\" and if so designated on the approved label",
      "units": [
        "liters"
      ],
      "generalRate": "5.3¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)2.3¢/liter(JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.03. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2204.21.80",
      "rawHtsCode": "2204.21.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "16.9¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)7.5¢/liter(JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.03. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2204.21.8030",
      "rawHtsCode": "2204.21.80.30",
      "superior": null,
      "indent": "6",
      "description": "Sherry",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.21.8060",
      "rawHtsCode": "2204.21.80.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.22",
      "rawHtsCode": "2204.22",
      "superior": null,
      "indent": "2",
      "description": "In containers holding more than 2 liters but not more than 10 liters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.22.20",
      "rawHtsCode": "2204.22.20",
      "superior": null,
      "indent": "4",
      "description": "Of an alcoholic strength by volume not over 14 percent vol",
      "units": [],
      "generalRate": "8.4¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 3.7¢/liter (JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2204.22.2005",
      "rawHtsCode": "2204.22.20.05",
      "superior": null,
      "indent": "6",
      "description": "Red",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.22.2015",
      "rawHtsCode": "2204.22.20.15",
      "superior": null,
      "indent": "6",
      "description": "White",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.22.2025",
      "rawHtsCode": "2204.22.20.25",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.22.2030",
      "rawHtsCode": "2204.22.20.30",
      "superior": null,
      "indent": "6",
      "description": "Red",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.22.2045",
      "rawHtsCode": "2204.22.20.45",
      "superior": null,
      "indent": "6",
      "description": "White",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.22.2060",
      "rawHtsCode": "2204.22.20.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.22.4000",
      "rawHtsCode": "2204.22.40.00",
      "superior": null,
      "indent": "4",
      "description": "Of an alcoholic strength by volume over 14 percent vol",
      "units": [
        "liters"
      ],
      "generalRate": "22.4¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 9.9¢/liter (JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2204.22.6000",
      "rawHtsCode": "2204.22.60.00",
      "superior": null,
      "indent": "4",
      "description": "Of an alcoholic strength by volume not over 14 percent vol.",
      "units": [
        "liters"
      ],
      "generalRate": "14¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 6.2¢/liter (JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2204.22.8000",
      "rawHtsCode": "2204.22.80.00",
      "superior": null,
      "indent": "4",
      "description": "Of an alcoholic strength by volume over 14 percent vol",
      "units": [
        "liters"
      ],
      "generalRate": "22.4¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 9.9¢/liter (JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2204.29",
      "rawHtsCode": "2204.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2204.29.6100",
      "rawHtsCode": "2204.29.61.00",
      "superior": null,
      "indent": "3",
      "description": "Of an alcoholic strength by volume not over 14 percent vol.",
      "units": [
        "liters"
      ],
      "generalRate": "14¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 6.2¢/liter (JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2204.29.8100",
      "rawHtsCode": "2204.29.81.00",
      "superior": null,
      "indent": "3",
      "description": "Of an alcoholic strength by volume over 14 percent vol",
      "units": [
        "liters"
      ],
      "generalRate": "22.4¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 9.9¢/liter (JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2204.30.0000",
      "rawHtsCode": "2204.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other grape must",
      "units": [
        "liters",
        "pf.liters"
      ],
      "generalRate": "4.4¢/liter + 31.4¢/pf. liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 1.9¢/liter + 13.9¢/pf. liter (JO)",
      "otherRate": "18.5¢/liter + $1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2205",
      "rawHtsCode": "2205",
      "superior": null,
      "indent": "0",
      "description": "Vermouth and other wine of fresh grapes flavored with plants or aromatic substances:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2205.10",
      "rawHtsCode": "2205.10",
      "superior": null,
      "indent": "1",
      "description": "In containers holding 2 liters or less:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2205.10.3000",
      "rawHtsCode": "2205.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Vermouth",
      "units": [
        "liters"
      ],
      "generalRate": "3.5¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)1.5¢/liter(JO)",
      "otherRate": "33¢/ liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2205.10.6000",
      "rawHtsCode": "2205.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "4.2¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)1.8¢/liter(JO)",
      "otherRate": "33¢/ liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2205.90",
      "rawHtsCode": "2205.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2205.90.2000",
      "rawHtsCode": "2205.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "In containers each holding over 2 liters but not over 4 liters",
      "units": [
        "liters"
      ],
      "generalRate": "3.5¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)1.5¢/liter(JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2205.90.4000",
      "rawHtsCode": "2205.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "In containers each holding over 4 liters",
      "units": [
        "liters"
      ],
      "generalRate": "3.8¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 1.6¢/liter (JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2205.90.6000",
      "rawHtsCode": "2205.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "4.2¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)1.8¢/liter(JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5041). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2206.00",
      "rawHtsCode": "2206.00",
      "superior": null,
      "indent": "0",
      "description": "Other fermented beverages (for example, cider, perry, mead, sakè); mixtures of fermented beverages and mixtures of fermented beverages and non-alcoholic beverages, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2206.00.15",
      "rawHtsCode": "2206.00.15",
      "superior": null,
      "indent": "1",
      "description": "Cider, whether still or sparkling",
      "units": [],
      "generalRate": "0.4¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)0.1¢/liter(JO)",
      "otherRate": "1.3¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2206.00.1510",
      "rawHtsCode": "2206.00.15.10",
      "superior": null,
      "indent": "2",
      "description": "Hard cider as described in statistical note 3 to this chapter",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2206.00.1520",
      "rawHtsCode": "2206.00.15.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2206.00.3000",
      "rawHtsCode": "2206.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Prune wine",
      "units": [
        "liters",
        "pf.liters"
      ],
      "generalRate": "3.1¢/liter + 22.1¢/pf. liter on ethyl alcohol content",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,KR,MA, OM,P,PA,PE,S, SG) 1.3¢/liter + 9.8¢/pf. liter on ethyl alcohol content (JO)",
      "otherRate": "18.5¢/ liter + $1.32/pf. liter on ethyl alcohol content",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2206.00.4500",
      "rawHtsCode": "2206.00.45.00",
      "superior": null,
      "indent": "1",
      "description": "Rice wine or sakè",
      "units": [
        "liters"
      ],
      "generalRate": "3¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)1.3¢/liter(JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051).",
        "See 9903.88.03."
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2206.00.6000",
      "rawHtsCode": "2206.00.60.00",
      "superior": null,
      "indent": "2",
      "description": "Effervescent wine",
      "units": [
        "liters"
      ],
      "generalRate": "13.9¢/liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 6.1¢/liter (JO)",
      "otherRate": "$1.59/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2206.00.90",
      "rawHtsCode": "2206.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.2¢/liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)1.8¢/liter(JO)",
      "otherRate": "33¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.03. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2206.00.9015",
      "rawHtsCode": "2206.00.90.15",
      "superior": null,
      "indent": "4",
      "description": "In aluminum containers",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2206.00.9025",
      "rawHtsCode": "2206.00.90.25",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2206.00.9030",
      "rawHtsCode": "2206.00.90.30",
      "superior": null,
      "indent": "4",
      "description": "In aluminum containers",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2206.00.9040",
      "rawHtsCode": "2206.00.90.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2207",
      "rawHtsCode": "2207",
      "superior": null,
      "indent": "0",
      "description": "Undenatured ethyl alcohol of an alcoholic strength by volume of 80 percent vol. or higher; ethyl alcohol and other spirits, denatured, of any strength:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2207.10",
      "rawHtsCode": "2207.10",
      "superior": null,
      "indent": "1",
      "description": "Undenatured ethyl alcohol of an alcoholic strength by volume of 80 percent vol. or higher:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2207.10.3000",
      "rawHtsCode": "2207.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "For beverage purposes",
      "units": [
        "pf.liters"
      ],
      "generalRate": "18.9¢/pf.liter",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051).",
        "See 9903.88.03."
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2207.10.60",
      "rawHtsCode": "2207.10.60",
      "superior": null,
      "indent": "2",
      "description": "For nonbeverage purposes",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PE,S,SG) See 9822.09.22-9822.09.24 (PA)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.03. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2207.10.6010",
      "rawHtsCode": "2207.10.60.10",
      "superior": null,
      "indent": "3",
      "description": "For fuel use",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2207.10.6090",
      "rawHtsCode": "2207.10.60.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2207.20.00",
      "rawHtsCode": "2207.20.00",
      "superior": null,
      "indent": "1",
      "description": "Ethyl alcohol and other spirits, denatured, of any strength",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PE,S,SG) See 9822.09.22-9822.09.24 (PA)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "For ethyl alcohol or a mixture thereof from CBERA beneficiaries, see section 423 of the Tax Reform Act of 1986, as amended (19 U.S.C. 2703,note); for ethyl alcohol or a mixture thereof from DR-CAFTA beneficiaries, see section 201 (a)(3)(B)(ii) of the DR-CAFTA Implementation Act (19 U.S.C. 4031 (a)(3)(B)(ii) ).” ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2207.20.0010",
      "rawHtsCode": "2207.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "For fuel use",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2207.20.0090",
      "rawHtsCode": "2207.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208",
      "rawHtsCode": "2208",
      "superior": null,
      "indent": "0",
      "description": "Undenatured ethyl alcohol of an alcoholic strength by volume of less than 80 percent vol.; spirits, liqueurs and other spirituous beverages:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.20",
      "rawHtsCode": "2208.20",
      "superior": null,
      "indent": "1",
      "description": "Spirits obtained by distilling grape wine or grape marc (grape brandy):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.20.1000",
      "rawHtsCode": "2208.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Pisco and singani",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.78/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.20.2000",
      "rawHtsCode": "2208.20.20.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $2.38/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.35/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.20.3000",
      "rawHtsCode": "2208.20.30.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $2.38 but not over $3.43/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.35/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.20.4000",
      "rawHtsCode": "2208.20.40.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $3.43/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.35/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.20.5000",
      "rawHtsCode": "2208.20.50.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $2.38/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.20.6000",
      "rawHtsCode": "2208.20.60.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $2.38/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.30",
      "rawHtsCode": "2208.30",
      "superior": null,
      "indent": "1",
      "description": "Whiskies:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.30.30",
      "rawHtsCode": "2208.30.30",
      "superior": null,
      "indent": "2",
      "description": "Irish and Scotch",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.99/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.30.3030",
      "rawHtsCode": "2208.30.30.30",
      "superior": null,
      "indent": "3",
      "description": "In containers each holding not over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.30.3060",
      "rawHtsCode": "2208.30.30.60",
      "superior": null,
      "indent": "3",
      "description": "In containers each holding over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.30.60",
      "rawHtsCode": "2208.30.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.04/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001, 26 U.S.C. 5041 or 26 U.S.C. 5051). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.30.6020",
      "rawHtsCode": "2208.30.60.20",
      "superior": null,
      "indent": "4",
      "description": "In containers each holding not over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.30.6040",
      "rawHtsCode": "2208.30.60.40",
      "superior": null,
      "indent": "4",
      "description": "In containers each holding over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.30.6055",
      "rawHtsCode": "2208.30.60.55",
      "superior": null,
      "indent": "5",
      "description": "Rye",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.30.6065",
      "rawHtsCode": "2208.30.60.65",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.30.6075",
      "rawHtsCode": "2208.30.60.75",
      "superior": null,
      "indent": "5",
      "description": "Rye",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.30.6085",
      "rawHtsCode": "2208.30.60.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.40",
      "rawHtsCode": "2208.40",
      "superior": null,
      "indent": "1",
      "description": "Rum and other spirits obtained by distilling fermented sugar-cane products:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.40.2000",
      "rawHtsCode": "2208.40.20.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $3 per proof liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "23.7¢/pf.liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 10.5¢/pf. liter (JO)",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2208.40.4000",
      "rawHtsCode": "2208.40.40.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $3 per proof liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.40.6000",
      "rawHtsCode": "2208.40.60.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over 69¢ per proof liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "23.7¢/pf.liter",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG) 10.5¢/pf.liter (JO)",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2208.40.8000",
      "rawHtsCode": "2208.40.80.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over 69¢ per proof liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.50.00",
      "rawHtsCode": "2208.50.00",
      "superior": null,
      "indent": "1",
      "description": "Gin and Geneve",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.99/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.50.0030",
      "rawHtsCode": "2208.50.00.30",
      "superior": null,
      "indent": "2",
      "description": "In containers each holding not over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.50.0060",
      "rawHtsCode": "2208.50.00.60",
      "superior": null,
      "indent": "2",
      "description": "In containers each holding over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.60",
      "rawHtsCode": "2208.60",
      "superior": null,
      "indent": "1",
      "description": "Vodka:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.60.1000",
      "rawHtsCode": "2208.60.10.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $2.05/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.78/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.60.2000",
      "rawHtsCode": "2208.60.20.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $2.05/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.78/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.60.5000",
      "rawHtsCode": "2208.60.50.00",
      "superior": null,
      "indent": "2",
      "description": "In containers each holding over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.70.00",
      "rawHtsCode": "2208.70.00",
      "superior": null,
      "indent": "1",
      "description": "Liqueurs and cordials",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$3.08/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.70.0030",
      "rawHtsCode": "2208.70.00.30",
      "superior": null,
      "indent": "2",
      "description": "In containers each holding not over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.70.0060",
      "rawHtsCode": "2208.70.00.60",
      "superior": null,
      "indent": "2",
      "description": "In containers each holding over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.90",
      "rawHtsCode": "2208.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.90.0100",
      "rawHtsCode": "2208.90.01.00",
      "superior": null,
      "indent": "2",
      "description": "Aquavit",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.99/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.0500",
      "rawHtsCode": "2208.90.05.00",
      "superior": null,
      "indent": "3",
      "description": "Not fit for use as beverages",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.1000",
      "rawHtsCode": "2208.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Fit for use as beverages",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.1200",
      "rawHtsCode": "2208.90.12.00",
      "superior": null,
      "indent": "5",
      "description": "In containers each holding not over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.35/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.1400",
      "rawHtsCode": "2208.90.14.00",
      "superior": null,
      "indent": "5",
      "description": "In containers each holding over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.1500",
      "rawHtsCode": "2208.90.15.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $3.43/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.35/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.2000",
      "rawHtsCode": "2208.90.20.00",
      "superior": null,
      "indent": "5",
      "description": "Valued not over $2.38/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.35/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.2500",
      "rawHtsCode": "2208.90.25.00",
      "superior": null,
      "indent": "5",
      "description": "Valued over $2.38 but not over $3.43/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.35/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.3000",
      "rawHtsCode": "2208.90.30.00",
      "superior": null,
      "indent": "5",
      "description": "Valued over $3.43/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.35/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.3500",
      "rawHtsCode": "2208.90.35.00",
      "superior": null,
      "indent": "5",
      "description": "Valued not over $2.38/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.4000",
      "rawHtsCode": "2208.90.40.00",
      "superior": null,
      "indent": "5",
      "description": "Valued over $2.38/liter",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.46",
      "rawHtsCode": "2208.90.46",
      "superior": null,
      "indent": "2",
      "description": "Kirschwasser and ratafia",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$3.08/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.4630",
      "rawHtsCode": "2208.90.46.30",
      "superior": null,
      "indent": "3",
      "description": "In containers each holding not over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.90.4660",
      "rawHtsCode": "2208.90.46.60",
      "superior": null,
      "indent": "3",
      "description": "In containers each holding over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.90.5000",
      "rawHtsCode": "2208.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "In containers each holding not over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.68/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.5500",
      "rawHtsCode": "2208.90.55.00",
      "superior": null,
      "indent": "3",
      "description": "In containers each holding over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.7100",
      "rawHtsCode": "2208.90.71.00",
      "superior": null,
      "indent": "2",
      "description": "Imitations of brandy and other spirituous beverages",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.35/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.7200",
      "rawHtsCode": "2208.90.72.00",
      "superior": null,
      "indent": "4",
      "description": "Mezcal in containers each holding not over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.78/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.7500",
      "rawHtsCode": "2208.90.75.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "pf.liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.78/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2208.90.80",
      "rawHtsCode": "2208.90.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "21.1¢/pf.liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)9.3¢/pf.liter(JO)",
      "otherRate": "$4.05/pf. liter",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this subheading may be subject to Federal Excise Tax (26 U.S.C. 5001). "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2208.90.8010",
      "rawHtsCode": "2208.90.80.10",
      "superior": null,
      "indent": "4",
      "description": "Premixed cocktails or other mixed beverages, ready to consume as packaged, in containers each holding not over 4 liters",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2208.90.8020",
      "rawHtsCode": "2208.90.80.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "pf.liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2209.00.0000",
      "rawHtsCode": "2209.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Vinegar and substitutes for vinegar obtained from acetic acid",
      "units": [
        "pf.liters",
        "liters"
      ],
      "generalRate": "0.5¢/pf.liter",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.1¢/pf.liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2301",
      "rawHtsCode": "2301",
      "superior": null,
      "indent": "0",
      "description": "Flours, meals and pellets, of meat or meat offal, of fish or of crustaceans, molluscs or other aquatic invertebrates, unfit for human consumption; greaves (cracklings):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2301.10.0000",
      "rawHtsCode": "2301.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Flours, meals and pellets, of meat or meat offal; greaves (cracklings)",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2301.20.00",
      "rawHtsCode": "2301.20.00",
      "superior": null,
      "indent": "1",
      "description": "Flours, meals and pellets, of fish or of crustaceans, molluscs or other aquatic invertebrates",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2301.20.0010",
      "rawHtsCode": "2301.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Herring meal; pilchard meal",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2301.20.0090",
      "rawHtsCode": "2301.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2302",
      "rawHtsCode": "2302",
      "superior": null,
      "indent": "0",
      "description": "Bran, sharps (middlings) and other residues, whether or not in the form of pellets, derived from the sifting, milling or other working of cereals or of leguminous plants:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2302.10.0000",
      "rawHtsCode": "2302.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of corn (maize)",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2302.30.00",
      "rawHtsCode": "2302.30.00",
      "superior": null,
      "indent": "1",
      "description": "Of wheat",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2302.30.0010",
      "rawHtsCode": "2302.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Bran, shorts and middlings",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2302.30.0090",
      "rawHtsCode": "2302.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2302.40.01",
      "rawHtsCode": "2302.40.01",
      "superior": null,
      "indent": "1",
      "description": "Of other cereals",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2302.40.0105",
      "rawHtsCode": "2302.40.01.05",
      "superior": null,
      "indent": "2",
      "description": "Of rice",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2302.40.0110",
      "rawHtsCode": "2302.40.01.10",
      "superior": null,
      "indent": "2",
      "description": "Of other single cereal grains, chopped, crushed or ground",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2302.40.0120",
      "rawHtsCode": "2302.40.01.20",
      "superior": null,
      "indent": "3",
      "description": "Pelletized screenings (clearings)",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2302.40.0190",
      "rawHtsCode": "2302.40.01.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2302.50.0000",
      "rawHtsCode": "2302.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of leguminous plants",
      "units": [
        "t"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2303",
      "rawHtsCode": "2303",
      "superior": null,
      "indent": "0",
      "description": "Residues of starch manufacture and similar residues, beet-pulp, bagasse and other waste of sugar manufacture, brewing or distilling dregs and waste, whether or not in the form of pellets:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2303.10.00",
      "rawHtsCode": "2303.10.00",
      "superior": null,
      "indent": "1",
      "description": "Residues of starch manufacture and similar residues",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2303.10.0010",
      "rawHtsCode": "2303.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Corn gluten feed",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2303.10.0020",
      "rawHtsCode": "2303.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Corn gluten meal",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2303.10.0040",
      "rawHtsCode": "2303.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2303.20.00",
      "rawHtsCode": "2303.20.00",
      "superior": null,
      "indent": "1",
      "description": "Beet-pulp, bagasse and other waste of sugar manufacture",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$4.91/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2303.20.0020",
      "rawHtsCode": "2303.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Dried beet-pulp",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2303.20.0040",
      "rawHtsCode": "2303.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2303.30.0000",
      "rawHtsCode": "2303.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Brewing or distilling dregs and waste",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$4.91/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2304.00.00",
      "rawHtsCode": "2304.00.00",
      "superior": null,
      "indent": "0",
      "description": "Oilcake and other solid residues, whether or not ground or in the form of pellets, resulting from the extraction of soybean oil",
      "units": [],
      "generalRate": "0.45¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "0.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2304.00.0010",
      "rawHtsCode": "2304.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2304.00.0090",
      "rawHtsCode": "2304.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2305.00.0000",
      "rawHtsCode": "2305.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Oilcake and other solid residues, whether or not ground or in the form of pellets, resulting from the extraction of peanut (ground-nut) oil",
      "units": [
        "kg"
      ],
      "generalRate": "0.32¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2306",
      "rawHtsCode": "2306",
      "superior": null,
      "indent": "0",
      "description": "Oilcake and other solid residues, whether or not ground or in the form of pellets, resulting from the extraction of vegetable or microbial fats or oils, other than those of heading 2304 or 2305:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2306.10.0000",
      "rawHtsCode": "2306.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of cotton seeds",
      "units": [
        "kg"
      ],
      "generalRate": "0.56¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "0.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2306.20.0000",
      "rawHtsCode": "2306.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of linseed",
      "units": [
        "kg"
      ],
      "generalRate": "0.12¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2306.30.0000",
      "rawHtsCode": "2306.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of sunflower seeds",
      "units": [
        "kg"
      ],
      "generalRate": "0.45¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2306.41.0000",
      "rawHtsCode": "2306.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of low euricic acid rape or colza seeds",
      "units": [
        "kg"
      ],
      "generalRate": "0.17¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2306.49.0000",
      "rawHtsCode": "2306.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.17¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2306.50.0000",
      "rawHtsCode": "2306.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of coconut or copra",
      "units": [
        "kg"
      ],
      "generalRate": "0.45¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2306.60.0000",
      "rawHtsCode": "2306.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of palm nuts or kernels",
      "units": [
        "kg"
      ],
      "generalRate": "0.32¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2306.90.01",
      "rawHtsCode": "2306.90.01",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "0.32¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2306.90.0120",
      "rawHtsCode": "2306.90.01.20",
      "superior": null,
      "indent": "2",
      "description": "Of corn",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2306.90.0130",
      "rawHtsCode": "2306.90.01.30",
      "superior": null,
      "indent": "2",
      "description": "Of hemp seeds",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2306.90.0150",
      "rawHtsCode": "2306.90.01.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2307.00.0000",
      "rawHtsCode": "2307.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Wine lees; argol",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2308.00",
      "rawHtsCode": "2308.00",
      "superior": null,
      "indent": "0",
      "description": "Vegetable materials and vegetable waste, vegetable residues and byproducts, whether or not in the form of pellets, of a kind used in animal feeding, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2308.00.1000",
      "rawHtsCode": "2308.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Acorns and horse-chestnuts",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2308.00.9300",
      "rawHtsCode": "2308.00.93.00",
      "superior": null,
      "indent": "1",
      "description": "Screenings, scalpings, chaff or scourings, ground, or not ground, of flaxseed (linseed)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2308.00.9500",
      "rawHtsCode": "2308.00.95.00",
      "superior": null,
      "indent": "1",
      "description": "Dehydrated marigolds",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2308.00.98",
      "rawHtsCode": "2308.00.98",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2308.00.9820",
      "rawHtsCode": "2308.00.98.20",
      "superior": null,
      "indent": "2",
      "description": "Citrus pulp pellets",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2308.00.9890",
      "rawHtsCode": "2308.00.98.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309",
      "rawHtsCode": "2309",
      "superior": null,
      "indent": "0",
      "description": "Preparations of a kind used in animal feeding:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.10.00",
      "rawHtsCode": "2309.10.00",
      "superior": null,
      "indent": "1",
      "description": "Dog or cat food, put up for retail sale",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2309.10.0010",
      "rawHtsCode": "2309.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "In airtight containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.10.0090",
      "rawHtsCode": "2309.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90",
      "rawHtsCode": "2309.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.10",
      "rawHtsCode": "2309.90.10",
      "superior": null,
      "indent": "2",
      "description": "Mixed feeds or mixed feed ingredients",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2309.90.1005",
      "rawHtsCode": "2309.90.10.05",
      "superior": null,
      "indent": "3",
      "description": "Bird seed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.1015",
      "rawHtsCode": "2309.90.10.15",
      "superior": null,
      "indent": "3",
      "description": "Other pet food, put up for retail sale",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.1020",
      "rawHtsCode": "2309.90.10.20",
      "superior": null,
      "indent": "3",
      "description": "Poultry feeds, prepared",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.1030",
      "rawHtsCode": "2309.90.10.30",
      "superior": null,
      "indent": "3",
      "description": "Dairy cattle feed, prepared",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.1032",
      "rawHtsCode": "2309.90.10.32",
      "superior": null,
      "indent": "3",
      "description": "Other cattle feed, prepared",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.1035",
      "rawHtsCode": "2309.90.10.35",
      "superior": null,
      "indent": "3",
      "description": "Swine feed, prepared",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.1045",
      "rawHtsCode": "2309.90.10.45",
      "superior": null,
      "indent": "3",
      "description": "Other livestock feed, prepared",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.1050",
      "rawHtsCode": "2309.90.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.22",
      "rawHtsCode": "2309.90.22",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2309.90.2210",
      "rawHtsCode": "2309.90.22.10",
      "superior": null,
      "indent": "6",
      "description": "Milk replacer",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.2290",
      "rawHtsCode": "2309.90.22.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.24",
      "rawHtsCode": "2309.90.24",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 2 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2309.90.2410",
      "rawHtsCode": "2309.90.24.10",
      "superior": null,
      "indent": "6",
      "description": "Milk replacer",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.2490",
      "rawHtsCode": "2309.90.24.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.28",
      "rawHtsCode": "2309.90.28",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "80.4¢/kg + 6.4%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.20 (AU) See 9823.05.01-9823.05.06 (S+)",
      "otherRate": "94.6¢/kg + 7.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.23.01-9904.23.09. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2309.90.2810",
      "rawHtsCode": "2309.90.28.10",
      "superior": null,
      "indent": "6",
      "description": "Milk replacer",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.2890",
      "rawHtsCode": "2309.90.28.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.42",
      "rawHtsCode": "2309.90.42",
      "superior": null,
      "indent": "5",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2309.90.4210",
      "rawHtsCode": "2309.90.42.10",
      "superior": null,
      "indent": "6",
      "description": "Milk replacer",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.4290",
      "rawHtsCode": "2309.90.42.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.44",
      "rawHtsCode": "2309.90.44",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 2 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2309.90.4410",
      "rawHtsCode": "2309.90.44.10",
      "superior": null,
      "indent": "6",
      "description": "Milk replacer",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.4490",
      "rawHtsCode": "2309.90.44.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.48",
      "rawHtsCode": "2309.90.48",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "80.4¢/kg + 6.4%",
      "specialRate": "Free (BH,CL,CO,JO,KR,MA,OM,P,PA,PE,SG) See 9822.04.20 (AU) See 9823.05.01-9823.05.06 (S+)",
      "otherRate": "94.6¢/kg + 7.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See subheadings 9904.23.01-9904.23.09. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2309.90.4810",
      "rawHtsCode": "2309.90.48.10",
      "superior": null,
      "indent": "6",
      "description": "Milk replacer",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.4890",
      "rawHtsCode": "2309.90.48.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2309.90.6000",
      "rawHtsCode": "2309.90.60.00",
      "superior": null,
      "indent": "4",
      "description": "Animal feeds containing egg",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2309.90.7000",
      "rawHtsCode": "2309.90.70.00",
      "superior": null,
      "indent": "5",
      "description": "Preparations, with a basis of vitamin B<sub>12</sub>, for supplementing animal feed",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2309.90.9500",
      "rawHtsCode": "2309.90.95.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401",
      "rawHtsCode": "2401",
      "superior": null,
      "indent": "0",
      "description": "Unmanufactured tobacco (whether or not threshed or similarly processed); tobacco refuse:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10",
      "rawHtsCode": "2401.10",
      "superior": null,
      "indent": "1",
      "description": "Tobacco, not stemmed/stripped:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.21",
      "rawHtsCode": "2401.10.21",
      "superior": null,
      "indent": "3",
      "description": "Wrapper tobacco",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$5.02/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2401.10.2120",
      "rawHtsCode": "2401.10.21.20",
      "superior": null,
      "indent": "4",
      "description": "Connecticut shade",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.2140",
      "rawHtsCode": "2401.10.21.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.29",
      "rawHtsCode": "2401.10.29",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$5.02/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2401.10.2920",
      "rawHtsCode": "2401.10.29.20",
      "superior": null,
      "indent": "4",
      "description": "Connecticut shade",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.2940",
      "rawHtsCode": "2401.10.29.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.4400",
      "rawHtsCode": "2401.10.44.00",
      "superior": null,
      "indent": "4",
      "description": "Cigarette leaf",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "77.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.10.4800",
      "rawHtsCode": "2401.10.48.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "85¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2401.10.53",
      "rawHtsCode": "2401.10.53",
      "superior": null,
      "indent": "3",
      "description": "Cigar binder and filler",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "85¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2401.10.5340",
      "rawHtsCode": "2401.10.53.40",
      "superior": null,
      "indent": "4",
      "description": "Binder",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.5350",
      "rawHtsCode": "2401.10.53.50",
      "superior": null,
      "indent": "4",
      "description": "Filler",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.61",
      "rawHtsCode": "2401.10.61",
      "superior": null,
      "indent": "5",
      "description": "To be used in products other than cigarettes",
      "units": [],
      "generalRate": "23.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "77.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.10.6130",
      "rawHtsCode": "2401.10.61.30",
      "superior": null,
      "indent": "6",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.6160",
      "rawHtsCode": "2401.10.61.60",
      "superior": null,
      "indent": "6",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.6180",
      "rawHtsCode": "2401.10.61.80",
      "superior": null,
      "indent": "6",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.6190",
      "rawHtsCode": "2401.10.61.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.63",
      "rawHtsCode": "2401.10.63",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "23.9¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "77.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.10.6330",
      "rawHtsCode": "2401.10.63.30",
      "superior": null,
      "indent": "7",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.6360",
      "rawHtsCode": "2401.10.63.60",
      "superior": null,
      "indent": "7",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.6380",
      "rawHtsCode": "2401.10.63.80",
      "superior": null,
      "indent": "7",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.6390",
      "rawHtsCode": "2401.10.63.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.65",
      "rawHtsCode": "2401.10.65",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "350%",
      "specialRate": "Free (AU,BH,CL,IL,KR,MA,OM,P,PA,PE,S,SG) See 9918.24.10-9918.24.11 (CO)",
      "otherRate": "350%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.10.6530",
      "rawHtsCode": "2401.10.65.30",
      "superior": null,
      "indent": "7",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.6560",
      "rawHtsCode": "2401.10.65.60",
      "superior": null,
      "indent": "7",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.6580",
      "rawHtsCode": "2401.10.65.80",
      "superior": null,
      "indent": "7",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.6590",
      "rawHtsCode": "2401.10.65.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.95",
      "rawHtsCode": "2401.10.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "32.7¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "85¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.10.9510",
      "rawHtsCode": "2401.10.95.10",
      "superior": null,
      "indent": "5",
      "description": "Fire-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.9515",
      "rawHtsCode": "2401.10.95.15",
      "superior": null,
      "indent": "5",
      "description": "Dark-air cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.9520",
      "rawHtsCode": "2401.10.95.20",
      "superior": null,
      "indent": "5",
      "description": "Virginia fire-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.9525",
      "rawHtsCode": "2401.10.95.25",
      "superior": null,
      "indent": "5",
      "description": "Virginia sun-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.9530",
      "rawHtsCode": "2401.10.95.30",
      "superior": null,
      "indent": "5",
      "description": "Blackfat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.10.9560",
      "rawHtsCode": "2401.10.95.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20",
      "rawHtsCode": "2401.20",
      "superior": null,
      "indent": "1",
      "description": "Tobacco, partly or wholly stemmed/stripped:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.0500",
      "rawHtsCode": "2401.20.05.00",
      "superior": null,
      "indent": "3",
      "description": "Leaf tobacco, the product of two or more countries or dependencies, when mixed or packed together",
      "units": [
        "kg"
      ],
      "generalRate": "$5.48/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$6.45/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.20.14",
      "rawHtsCode": "2401.20.14",
      "superior": null,
      "indent": "5",
      "description": "Wrapper tobacco",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$6.45/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.20.1420",
      "rawHtsCode": "2401.20.14.20",
      "superior": null,
      "indent": "6",
      "description": "Connecticut shade",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.1440",
      "rawHtsCode": "2401.20.14.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.1800",
      "rawHtsCode": "2401.20.18.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$6.45/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.20.2300",
      "rawHtsCode": "2401.20.23.00",
      "superior": null,
      "indent": "6",
      "description": "Cigarette leaf",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.20.2600",
      "rawHtsCode": "2401.20.26.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.15/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.20.29",
      "rawHtsCode": "2401.20.29",
      "superior": null,
      "indent": "5",
      "description": "Cigar binder and filler",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.15/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.20.2970",
      "rawHtsCode": "2401.20.29.70",
      "superior": null,
      "indent": "6",
      "description": "Binder",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.2990",
      "rawHtsCode": "2401.20.29.90",
      "superior": null,
      "indent": "6",
      "description": "Filler",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.31",
      "rawHtsCode": "2401.20.31",
      "superior": null,
      "indent": "7",
      "description": "To be used in products other than cigarettes",
      "units": [],
      "generalRate": "40.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.20.3110",
      "rawHtsCode": "2401.20.31.10",
      "superior": null,
      "indent": "8",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.3120",
      "rawHtsCode": "2401.20.31.20",
      "superior": null,
      "indent": "8",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.3130",
      "rawHtsCode": "2401.20.31.30",
      "superior": null,
      "indent": "8",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.3140",
      "rawHtsCode": "2401.20.31.40",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.33",
      "rawHtsCode": "2401.20.33",
      "superior": null,
      "indent": "8",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "40.9¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.20.3310",
      "rawHtsCode": "2401.20.33.10",
      "superior": null,
      "indent": "9",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.3320",
      "rawHtsCode": "2401.20.33.20",
      "superior": null,
      "indent": "9",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.3330",
      "rawHtsCode": "2401.20.33.30",
      "superior": null,
      "indent": "9",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.3340",
      "rawHtsCode": "2401.20.33.40",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.35",
      "rawHtsCode": "2401.20.35",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [],
      "generalRate": "350%",
      "specialRate": "Free (AU,BH,CL,IL,KR,MA,OM,P,PA,PE,S,SG) See 9918.24.10-9918.24.11 (CO)",
      "otherRate": "350%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.20.3510",
      "rawHtsCode": "2401.20.35.10",
      "superior": null,
      "indent": "9",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.3520",
      "rawHtsCode": "2401.20.35.20",
      "superior": null,
      "indent": "9",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.3530",
      "rawHtsCode": "2401.20.35.30",
      "superior": null,
      "indent": "9",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.3540",
      "rawHtsCode": "2401.20.35.40",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.57",
      "rawHtsCode": "2401.20.57",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "39.7¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.15/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.20.5710",
      "rawHtsCode": "2401.20.57.10",
      "superior": null,
      "indent": "7",
      "description": "Fire-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.5715",
      "rawHtsCode": "2401.20.57.15",
      "superior": null,
      "indent": "7",
      "description": "Dark-air cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.5720",
      "rawHtsCode": "2401.20.57.20",
      "superior": null,
      "indent": "7",
      "description": "Virginia fire-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.5725",
      "rawHtsCode": "2401.20.57.25",
      "superior": null,
      "indent": "7",
      "description": "Virginia sun-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.5730",
      "rawHtsCode": "2401.20.57.30",
      "superior": null,
      "indent": "7",
      "description": "Blackfat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.5740",
      "rawHtsCode": "2401.20.57.40",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.60",
      "rawHtsCode": "2401.20.60",
      "superior": null,
      "indent": "3",
      "description": "From cigar leaf",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "77.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.20.6020",
      "rawHtsCode": "2401.20.60.20",
      "superior": null,
      "indent": "4",
      "description": "Connecticut shade",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.6040",
      "rawHtsCode": "2401.20.60.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.7500",
      "rawHtsCode": "2401.20.75.00",
      "superior": null,
      "indent": "4",
      "description": "Oriental or Turkish type",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.10/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.20.83",
      "rawHtsCode": "2401.20.83",
      "superior": null,
      "indent": "5",
      "description": "To be used in products other than cigarettes",
      "units": [],
      "generalRate": "37.5¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.20.8310",
      "rawHtsCode": "2401.20.83.10",
      "superior": null,
      "indent": "6",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8320",
      "rawHtsCode": "2401.20.83.20",
      "superior": null,
      "indent": "6",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8330",
      "rawHtsCode": "2401.20.83.30",
      "superior": null,
      "indent": "6",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8335",
      "rawHtsCode": "2401.20.83.35",
      "superior": null,
      "indent": "6",
      "description": "Fire-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8340",
      "rawHtsCode": "2401.20.83.40",
      "superior": null,
      "indent": "6",
      "description": "Dark-air cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8350",
      "rawHtsCode": "2401.20.83.50",
      "superior": null,
      "indent": "6",
      "description": "Virginia fire-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8355",
      "rawHtsCode": "2401.20.83.55",
      "superior": null,
      "indent": "6",
      "description": "Virginia sun-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8360",
      "rawHtsCode": "2401.20.83.60",
      "superior": null,
      "indent": "6",
      "description": "Blackfat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8390",
      "rawHtsCode": "2401.20.83.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.85",
      "rawHtsCode": "2401.20.85",
      "superior": null,
      "indent": "6",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "37.5¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.20.8510",
      "rawHtsCode": "2401.20.85.10",
      "superior": null,
      "indent": "7",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8520",
      "rawHtsCode": "2401.20.85.20",
      "superior": null,
      "indent": "7",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8530",
      "rawHtsCode": "2401.20.85.30",
      "superior": null,
      "indent": "7",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8535",
      "rawHtsCode": "2401.20.85.35",
      "superior": null,
      "indent": "7",
      "description": "Fire-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8540",
      "rawHtsCode": "2401.20.85.40",
      "superior": null,
      "indent": "7",
      "description": "Dark-air cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8550",
      "rawHtsCode": "2401.20.85.50",
      "superior": null,
      "indent": "7",
      "description": "Virginia fire-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8555",
      "rawHtsCode": "2401.20.85.55",
      "superior": null,
      "indent": "7",
      "description": "Virginia sun-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8560",
      "rawHtsCode": "2401.20.85.60",
      "superior": null,
      "indent": "7",
      "description": "Blackfat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8590",
      "rawHtsCode": "2401.20.85.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.87",
      "rawHtsCode": "2401.20.87",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "350%",
      "specialRate": "Free (AU,BH,CL,IL,KR,MA,OM,P,PA,PE,S,SG) See 9918.24.10-9918.24.11 (CO)",
      "otherRate": "350%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.20.8710",
      "rawHtsCode": "2401.20.87.10",
      "superior": null,
      "indent": "7",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8720",
      "rawHtsCode": "2401.20.87.20",
      "superior": null,
      "indent": "7",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8730",
      "rawHtsCode": "2401.20.87.30",
      "superior": null,
      "indent": "7",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8735",
      "rawHtsCode": "2401.20.87.35",
      "superior": null,
      "indent": "7",
      "description": "Fire-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8740",
      "rawHtsCode": "2401.20.87.40",
      "superior": null,
      "indent": "7",
      "description": "Dark-air cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8750",
      "rawHtsCode": "2401.20.87.50",
      "superior": null,
      "indent": "7",
      "description": "Virginia fire-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8755",
      "rawHtsCode": "2401.20.87.55",
      "superior": null,
      "indent": "7",
      "description": "Virginia sun-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8760",
      "rawHtsCode": "2401.20.87.60",
      "superior": null,
      "indent": "7",
      "description": "Blackfat",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.20.8790",
      "rawHtsCode": "2401.20.87.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30",
      "rawHtsCode": "2401.30",
      "superior": null,
      "indent": "1",
      "description": "Tobacco refuse:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.0300",
      "rawHtsCode": "2401.30.03.00",
      "superior": null,
      "indent": "4",
      "description": "Not cut, not ground and not pulverized",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.30.0600",
      "rawHtsCode": "2401.30.06.00",
      "superior": null,
      "indent": "4",
      "description": "Cut, ground or pulverized",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.30.0900",
      "rawHtsCode": "2401.30.09.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "77.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.30.1300",
      "rawHtsCode": "2401.30.13.00",
      "superior": null,
      "indent": "4",
      "description": "Not cut, not ground and not pulverized",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.30.1600",
      "rawHtsCode": "2401.30.16.00",
      "superior": null,
      "indent": "4",
      "description": "Cut, ground or pulverized",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.30.1900",
      "rawHtsCode": "2401.30.19.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "77.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.30.23",
      "rawHtsCode": "2401.30.23",
      "superior": null,
      "indent": "5",
      "description": "Not cut, not ground and not pulverized",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.30.2310",
      "rawHtsCode": "2401.30.23.10",
      "superior": null,
      "indent": "6",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2320",
      "rawHtsCode": "2401.30.23.20",
      "superior": null,
      "indent": "6",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2335",
      "rawHtsCode": "2401.30.23.35",
      "superior": null,
      "indent": "6",
      "description": "Fire-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2340",
      "rawHtsCode": "2401.30.23.40",
      "superior": null,
      "indent": "6",
      "description": "Dark air-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2350",
      "rawHtsCode": "2401.30.23.50",
      "superior": null,
      "indent": "6",
      "description": "Virginia fire-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2360",
      "rawHtsCode": "2401.30.23.60",
      "superior": null,
      "indent": "6",
      "description": "Virginia sun-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2390",
      "rawHtsCode": "2401.30.23.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.25",
      "rawHtsCode": "2401.30.25",
      "superior": null,
      "indent": "5",
      "description": "Cut, ground or pulverized",
      "units": [],
      "generalRate": "97¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.30.2510",
      "rawHtsCode": "2401.30.25.10",
      "superior": null,
      "indent": "6",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2520",
      "rawHtsCode": "2401.30.25.20",
      "superior": null,
      "indent": "6",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2535",
      "rawHtsCode": "2401.30.25.35",
      "superior": null,
      "indent": "6",
      "description": "Fire-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2540",
      "rawHtsCode": "2401.30.25.40",
      "superior": null,
      "indent": "6",
      "description": "Dark air-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2550",
      "rawHtsCode": "2401.30.25.50",
      "superior": null,
      "indent": "6",
      "description": "Virginia fire-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2560",
      "rawHtsCode": "2401.30.25.60",
      "superior": null,
      "indent": "6",
      "description": "Virginia sun-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2590",
      "rawHtsCode": "2401.30.25.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.27",
      "rawHtsCode": "2401.30.27",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "28.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "77.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.30.2710",
      "rawHtsCode": "2401.30.27.10",
      "superior": null,
      "indent": "5",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2720",
      "rawHtsCode": "2401.30.27.20",
      "superior": null,
      "indent": "5",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2735",
      "rawHtsCode": "2401.30.27.35",
      "superior": null,
      "indent": "5",
      "description": "Fire-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2740",
      "rawHtsCode": "2401.30.27.40",
      "superior": null,
      "indent": "5",
      "description": "Dark air-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2750",
      "rawHtsCode": "2401.30.27.50",
      "superior": null,
      "indent": "5",
      "description": "Virginia fire-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2760",
      "rawHtsCode": "2401.30.27.60",
      "superior": null,
      "indent": "5",
      "description": "Virginia sun-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.2790",
      "rawHtsCode": "2401.30.27.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.33",
      "rawHtsCode": "2401.30.33",
      "superior": null,
      "indent": "6",
      "description": "Not cut, not ground and not pulverized",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2401.30.3310",
      "rawHtsCode": "2401.30.33.10",
      "superior": null,
      "indent": "7",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3320",
      "rawHtsCode": "2401.30.33.20",
      "superior": null,
      "indent": "7",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3335",
      "rawHtsCode": "2401.30.33.35",
      "superior": null,
      "indent": "7",
      "description": "Fire-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3340",
      "rawHtsCode": "2401.30.33.40",
      "superior": null,
      "indent": "7",
      "description": "Dark air-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3350",
      "rawHtsCode": "2401.30.33.50",
      "superior": null,
      "indent": "7",
      "description": "Virginia fire-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3360",
      "rawHtsCode": "2401.30.33.60",
      "superior": null,
      "indent": "7",
      "description": "Virginia sun-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3390",
      "rawHtsCode": "2401.30.33.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.35",
      "rawHtsCode": "2401.30.35",
      "superior": null,
      "indent": "6",
      "description": "Cut, ground or pulverized",
      "units": [],
      "generalRate": "97¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.30.3510",
      "rawHtsCode": "2401.30.35.10",
      "superior": null,
      "indent": "7",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3520",
      "rawHtsCode": "2401.30.35.20",
      "superior": null,
      "indent": "7",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3535",
      "rawHtsCode": "2401.30.35.35",
      "superior": null,
      "indent": "7",
      "description": "Fire-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3540",
      "rawHtsCode": "2401.30.35.40",
      "superior": null,
      "indent": "7",
      "description": "Dark air-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3550",
      "rawHtsCode": "2401.30.35.50",
      "superior": null,
      "indent": "7",
      "description": "Virginia fire-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3560",
      "rawHtsCode": "2401.30.35.60",
      "superior": null,
      "indent": "7",
      "description": "Virginia sun-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3590",
      "rawHtsCode": "2401.30.35.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.37",
      "rawHtsCode": "2401.30.37",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "28.4¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "77.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.30.3710",
      "rawHtsCode": "2401.30.37.10",
      "superior": null,
      "indent": "6",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3720",
      "rawHtsCode": "2401.30.37.20",
      "superior": null,
      "indent": "6",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3735",
      "rawHtsCode": "2401.30.37.35",
      "superior": null,
      "indent": "6",
      "description": "Fire-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3740",
      "rawHtsCode": "2401.30.37.40",
      "superior": null,
      "indent": "6",
      "description": "Dark air-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3750",
      "rawHtsCode": "2401.30.37.50",
      "superior": null,
      "indent": "6",
      "description": "Virginia fire-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3760",
      "rawHtsCode": "2401.30.37.60",
      "superior": null,
      "indent": "6",
      "description": "Virginia sun-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.3790",
      "rawHtsCode": "2401.30.37.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.70",
      "rawHtsCode": "2401.30.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "350%",
      "specialRate": "Free (AU,BH,CL,IL,KR,MA,OM,P,PA,PE,S,SG) See 9918.24.10-9918.24.11 (CO)",
      "otherRate": "350%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2401.30.7010",
      "rawHtsCode": "2401.30.70.10",
      "superior": null,
      "indent": "5",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.7020",
      "rawHtsCode": "2401.30.70.20",
      "superior": null,
      "indent": "5",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.7035",
      "rawHtsCode": "2401.30.70.35",
      "superior": null,
      "indent": "5",
      "description": "Fire-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.7040",
      "rawHtsCode": "2401.30.70.40",
      "superior": null,
      "indent": "5",
      "description": "Dark air-cured Kentucky and Tennessee",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.7050",
      "rawHtsCode": "2401.30.70.50",
      "superior": null,
      "indent": "5",
      "description": "Virginia fire-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.7060",
      "rawHtsCode": "2401.30.70.60",
      "superior": null,
      "indent": "5",
      "description": "Virginia sun-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2401.30.7090",
      "rawHtsCode": "2401.30.70.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2402",
      "rawHtsCode": "2402",
      "superior": null,
      "indent": "0",
      "description": "Cigars, cheroots, cigarillos and cigarettes, of tobacco or of tobacco substitutes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2402.10",
      "rawHtsCode": "2402.10",
      "superior": null,
      "indent": "1",
      "description": "Cigars, cheroots and cigarillos, containing tobacco:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2402.10.30",
      "rawHtsCode": "2402.10.30",
      "superior": null,
      "indent": "2",
      "description": "Each valued less than 15¢",
      "units": [],
      "generalRate": "$1.89/kg + 4.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$9.92/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5701).",
        "See 9903.88.03."
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2402.10.3030",
      "rawHtsCode": "2402.10.30.30",
      "superior": null,
      "indent": "3",
      "description": "Small cigars, cheroots and cigarillos (weighing not more than 1.36 kg/1000)",
      "units": [
        "thousands",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2402.10.3070",
      "rawHtsCode": "2402.10.30.70",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "thousands",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2402.10.6000",
      "rawHtsCode": "2402.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Each valued 15¢ or over but less than 23¢",
      "units": [
        "thousands",
        "kg"
      ],
      "generalRate": "57¢/kg + 1.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,KR,MA, OM,P,PA,PE,S, SG)",
      "otherRate": "$9.92/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5701).",
        "See 9903.88.03."
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2402.10.80",
      "rawHtsCode": "2402.10.80",
      "superior": null,
      "indent": "2",
      "description": "Each valued 23¢ or over",
      "units": [],
      "generalRate": "57¢/kg + 1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$9.92/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5701).",
        "See 9903.88.03."
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2402.10.8030",
      "rawHtsCode": "2402.10.80.30",
      "superior": null,
      "indent": "3",
      "description": "Small cigars, cheroots and cigarillos (weighing not more than 1.36 kg/1000)",
      "units": [
        "thousands",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2402.10.8050",
      "rawHtsCode": "2402.10.80.50",
      "superior": null,
      "indent": "3",
      "description": "Other, each valued 23¢ or more but not more than 76¢",
      "units": [
        "thousands",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2402.10.8080",
      "rawHtsCode": "2402.10.80.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "thousands",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2402.20",
      "rawHtsCode": "2402.20",
      "superior": null,
      "indent": "1",
      "description": "Cigarettes containing tobacco:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2402.20.1000",
      "rawHtsCode": "2402.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing clove",
      "units": [
        "thousands",
        "kg"
      ],
      "generalRate": "41.7¢/kg + 0.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$9.92/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5701).",
        "See 9903.88.03."
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2402.20.8000",
      "rawHtsCode": "2402.20.80.00",
      "superior": null,
      "indent": "3",
      "description": "Paper-wrapped",
      "units": [
        "thousands",
        "kg"
      ],
      "generalRate": "$1.05/kg + 2.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$9.92/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5701).",
        "See 9903.88.03."
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2402.20.9000",
      "rawHtsCode": "2402.20.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "thousands",
        "kg"
      ],
      "generalRate": "$1.50/kg + 3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$9.92/kg+ 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5701).",
        "See 9903.88.03."
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2402.90.0000",
      "rawHtsCode": "2402.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "thousands",
        "kg"
      ],
      "generalRate": "$1.05/kg + 2.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$9.92/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403",
      "rawHtsCode": "2403",
      "superior": null,
      "indent": "0",
      "description": "Other manufactured tobacco and manufactured tobacco substitutes; \"homogenized\" or \"reconstituted\" tobacco; tobacco extracts and essences:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.11.0000",
      "rawHtsCode": "2403.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Water pipe tobacco, specified in subheading note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "32.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5701).",
        "See 9903.88.03."
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.19",
      "rawHtsCode": "2403.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.20",
      "rawHtsCode": "2403.19.20",
      "superior": null,
      "indent": "3",
      "description": "Prepared for marketing to the ultimate consumer in the identical form and package in which imported",
      "units": [],
      "generalRate": "32.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5701).",
        "See 9903.88.03."
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.19.2020",
      "rawHtsCode": "2403.19.20.20",
      "superior": null,
      "indent": "4",
      "description": "Pipe tobacco",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.2050",
      "rawHtsCode": "2403.19.20.50",
      "superior": null,
      "indent": "4",
      "description": "Roll-your-own tobacco for making cigarettes",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.2080",
      "rawHtsCode": "2403.19.20.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.30",
      "rawHtsCode": "2403.19.30",
      "superior": null,
      "indent": "4",
      "description": "To be used in products other than cigarettes",
      "units": [],
      "generalRate": "32.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.19.3050",
      "rawHtsCode": "2403.19.30.50",
      "superior": null,
      "indent": "5",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.3060",
      "rawHtsCode": "2403.19.30.60",
      "superior": null,
      "indent": "5",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.3080",
      "rawHtsCode": "2403.19.30.80",
      "superior": null,
      "indent": "5",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.3090",
      "rawHtsCode": "2403.19.30.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.60",
      "rawHtsCode": "2403.19.60",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "32.8¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.19.6050",
      "rawHtsCode": "2403.19.60.50",
      "superior": null,
      "indent": "6",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.6060",
      "rawHtsCode": "2403.19.60.60",
      "superior": null,
      "indent": "6",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.6080",
      "rawHtsCode": "2403.19.60.80",
      "superior": null,
      "indent": "6",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.6090",
      "rawHtsCode": "2403.19.60.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.90",
      "rawHtsCode": "2403.19.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "350%",
      "specialRate": "Free (AU,BH,CL,IL,KR,MA,OM,P,PA,PE,S,SG) See 9918.24.10-9918.24.11 (CO)",
      "otherRate": "350%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.19.9050",
      "rawHtsCode": "2403.19.90.50",
      "superior": null,
      "indent": "6",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.9060",
      "rawHtsCode": "2403.19.90.60",
      "superior": null,
      "indent": "6",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.9080",
      "rawHtsCode": "2403.19.90.80",
      "superior": null,
      "indent": "6",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.19.9090",
      "rawHtsCode": "2403.19.90.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91",
      "rawHtsCode": "2403.91",
      "superior": null,
      "indent": "2",
      "description": "\"Homogenized\" or \"reconstituted\" tobacco:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91.2000",
      "rawHtsCode": "2403.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "Suitable for use as wrapper tobacco",
      "units": [
        "kg"
      ],
      "generalRate": "62¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$6.45/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.91.43",
      "rawHtsCode": "2403.91.43",
      "superior": null,
      "indent": "4",
      "description": "To be used in products other than cigarettes",
      "units": [],
      "generalRate": "19.9¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.91.4350",
      "rawHtsCode": "2403.91.43.50",
      "superior": null,
      "indent": "5",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91.4360",
      "rawHtsCode": "2403.91.43.60",
      "superior": null,
      "indent": "5",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91.4380",
      "rawHtsCode": "2403.91.43.80",
      "superior": null,
      "indent": "5",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91.4390",
      "rawHtsCode": "2403.91.43.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91.45",
      "rawHtsCode": "2403.91.45",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "19.9¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.91.4550",
      "rawHtsCode": "2403.91.45.50",
      "superior": null,
      "indent": "6",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91.4560",
      "rawHtsCode": "2403.91.45.60",
      "superior": null,
      "indent": "6",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91.4580",
      "rawHtsCode": "2403.91.45.80",
      "superior": null,
      "indent": "6",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91.4590",
      "rawHtsCode": "2403.91.45.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91.47",
      "rawHtsCode": "2403.91.47",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "350%",
      "specialRate": "Free (AU,BH,CL,IL,KR,MA,OM,P,PA,PE,S,SG) See 9918.24.10-9918.24.11 (CO)",
      "otherRate": "350%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.91.4750",
      "rawHtsCode": "2403.91.47.50",
      "superior": null,
      "indent": "6",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91.4760",
      "rawHtsCode": "2403.91.47.60",
      "superior": null,
      "indent": "6",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91.4780",
      "rawHtsCode": "2403.91.47.80",
      "superior": null,
      "indent": "6",
      "description": "Maryland",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.91.4790",
      "rawHtsCode": "2403.91.47.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99",
      "rawHtsCode": "2403.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.21",
      "rawHtsCode": "2403.99.21",
      "superior": null,
      "indent": "3",
      "description": "Prepared for marketing to the ultimate consumer in the identical form and package in which imported",
      "units": [],
      "generalRate": "24.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.99.2130",
      "rawHtsCode": "2403.99.21.30",
      "superior": null,
      "indent": "4",
      "description": "Chewing tobacco",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5701). "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2403.99.2140",
      "rawHtsCode": "2403.99.21.40",
      "superior": null,
      "indent": "4",
      "description": "Snuff and snuff flours of a kind described in statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5701). "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "2403.99.2190",
      "rawHtsCode": "2403.99.21.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.31",
      "rawHtsCode": "2403.99.31",
      "superior": null,
      "indent": "4",
      "description": "To be used in products other than cigarettes",
      "units": [],
      "generalRate": "24.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.99.3150",
      "rawHtsCode": "2403.99.31.50",
      "superior": null,
      "indent": "5",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.3160",
      "rawHtsCode": "2403.99.31.60",
      "superior": null,
      "indent": "5",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.3165",
      "rawHtsCode": "2403.99.31.65",
      "superior": null,
      "indent": "6",
      "description": "Partially manufactured, blended or mixed tobacco",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.3170",
      "rawHtsCode": "2403.99.31.70",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.60",
      "rawHtsCode": "2403.99.60",
      "superior": null,
      "indent": "5",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "24.7¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,D,E,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.99.6050",
      "rawHtsCode": "2403.99.60.50",
      "superior": null,
      "indent": "6",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.6060",
      "rawHtsCode": "2403.99.60.60",
      "superior": null,
      "indent": "6",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.6065",
      "rawHtsCode": "2403.99.60.65",
      "superior": null,
      "indent": "7",
      "description": "Partially manufactured, blended or mixed tobacco",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.6070",
      "rawHtsCode": "2403.99.60.70",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.90",
      "rawHtsCode": "2403.99.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "350%",
      "specialRate": "Free (AU,BH,CL,IL,KR,MA,OM,P,PA,PE,S,SG) See 9918.24.10-9918.24.11 (CO)",
      "otherRate": "350%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2403.99.9050",
      "rawHtsCode": "2403.99.90.50",
      "superior": null,
      "indent": "6",
      "description": "Flue-cured",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.9060",
      "rawHtsCode": "2403.99.90.60",
      "superior": null,
      "indent": "6",
      "description": "Burley",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.9065",
      "rawHtsCode": "2403.99.90.65",
      "superior": null,
      "indent": "7",
      "description": "Partially manufactured, blended or mixed tobacco",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2403.99.9070",
      "rawHtsCode": "2403.99.90.70",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2404",
      "rawHtsCode": "2404",
      "superior": null,
      "indent": "0",
      "description": "Products containing tobacco, reconstituted tobacco, nicotine, or tobacco or nicotine substitutes, intended for inhalation without combustion; other nicotine containing products intended for the intake of nicotine into the human body:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2404.11.0000",
      "rawHtsCode": "2404.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing tobacco or reconstituted tobacco",
      "units": [
        "kg"
      ],
      "generalRate": "24.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2404.12",
      "rawHtsCode": "2404.12",
      "superior": null,
      "indent": "2",
      "description": "Other, containing nicotine:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2404.12.05",
      "rawHtsCode": "2404.12.05",
      "superior": null,
      "indent": "4",
      "description": "Mixtures containing 5 percent or more by weight of one or more aromatic or modified aromatic substances",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E, IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2404.12.0510",
      "rawHtsCode": "2404.12.05.10",
      "superior": null,
      "indent": "5",
      "description": "Disposable electronic cigarettes (e-cigarettes) and similar disposable personal electronic vaporizing devices containing nicotine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2404.12.0590",
      "rawHtsCode": "2404.12.05.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2404.12.10",
      "rawHtsCode": "2404.12.10",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2404.12.1010",
      "rawHtsCode": "2404.12.10.10",
      "superior": null,
      "indent": "5",
      "description": "Disposable electronic cigarettes (e-cigarettes) and similar disposable personal electronic vaporizing devices containing nicotine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2404.12.1090",
      "rawHtsCode": "2404.12.10.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2404.12.9000",
      "rawHtsCode": "2404.12.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E, IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2404.19",
      "rawHtsCode": "2404.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2404.19.05",
      "rawHtsCode": "2404.19.05",
      "superior": null,
      "indent": "4",
      "description": "Mixtures containing 5 percent or more by weight of one or more aromatic or modified aromatic substances",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E, IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2404.19.0510",
      "rawHtsCode": "2404.19.05.10",
      "superior": null,
      "indent": "5",
      "description": "Disposable electronic cigarettes (e-cigarettes) and similar disposable personal electronic vaporizing devices without nicotine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2404.19.0590",
      "rawHtsCode": "2404.19.05.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2404.19.10",
      "rawHtsCode": "2404.19.10",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2404.19.1010",
      "rawHtsCode": "2404.19.10.10",
      "superior": null,
      "indent": "5",
      "description": "Disposable electronic cigarettes (e-cigarettes) and similar disposable personal electronic vaporizing devices without nicotine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2404.19.1090",
      "rawHtsCode": "2404.19.10.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2404.19.9000",
      "rawHtsCode": "2404.19.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "24.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.21/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2404.91.0000",
      "rawHtsCode": "2404.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "For oral application",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E, IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2404.92.0000",
      "rawHtsCode": "2404.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "For transdermal application",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2404.99.0000",
      "rawHtsCode": "2404.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2501.00.0000",
      "rawHtsCode": "2501.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Salt (including table salt and denatured salt) and pure sodium chloride, whether or not in aqueous solution or containing added anti-caking or free-flowing agents; sea water",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2502.00.0000",
      "rawHtsCode": "2502.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Unroasted iron pyrites",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2503.00.00",
      "rawHtsCode": "2503.00.00",
      "superior": null,
      "indent": "0",
      "description": "Sulfur of all kinds, other than sublimed sulfur, precipitated sulfur and colloidal sulfur",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2503.00.0010",
      "rawHtsCode": "2503.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Crude or unrefined sulfur",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2503.00.0090",
      "rawHtsCode": "2503.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2504",
      "rawHtsCode": "2504",
      "superior": null,
      "indent": "0",
      "description": "Natural graphite:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2504.10",
      "rawHtsCode": "2504.10",
      "superior": null,
      "indent": "1",
      "description": "In powder or in flakes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2504.10.1000",
      "rawHtsCode": "2504.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Crystalline flake (not including flake dust)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.06. "
      ],
      "flags": []
    },
    {
      "htsCode": "2504.10.5000",
      "rawHtsCode": "2504.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.06. "
      ],
      "flags": []
    },
    {
      "htsCode": "2504.90.0000",
      "rawHtsCode": "2504.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.06. "
      ],
      "flags": []
    },
    {
      "htsCode": "2505",
      "rawHtsCode": "2505",
      "superior": null,
      "indent": "0",
      "description": "Natural sands of all kinds, whether or not colored, other than metalbearing sands of chapter 26:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2505.10",
      "rawHtsCode": "2505.10",
      "superior": null,
      "indent": "1",
      "description": "Silica sands and quartz sands:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2505.10.1000",
      "rawHtsCode": "2505.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Sand containing by weight 95 percent or more of silica and not more than 0.6 percent of oxide of iron",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.97/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2505.10.5000",
      "rawHtsCode": "2505.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2505.90.0000",
      "rawHtsCode": "2505.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2506",
      "rawHtsCode": "2506",
      "superior": null,
      "indent": "0",
      "description": "Quartz (other than natural sands); quartzite, whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2506.10.00",
      "rawHtsCode": "2506.10.00",
      "superior": null,
      "indent": "1",
      "description": "Quartz",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2506.10.0010",
      "rawHtsCode": "2506.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Sands (other than natural) containing by weight 95 percent or more of silica and not more than 0.6 percent of oxide of iron",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2506.10.0050",
      "rawHtsCode": "2506.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2506.20.00",
      "rawHtsCode": "2506.20.00",
      "superior": null,
      "indent": "1",
      "description": "Quartzite",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2506.20.0010",
      "rawHtsCode": "2506.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Crude or roughly trimmed",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2506.20.0080",
      "rawHtsCode": "2506.20.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2507.00.0000",
      "rawHtsCode": "2507.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Kaolin and other kaolinic clays, whether or not calcined",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.46/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2508",
      "rawHtsCode": "2508",
      "superior": null,
      "indent": "0",
      "description": "Other clays (not including expanded clays of heading 6806), andalusite, kyanite and sillimanite, whether or not calcined; mullite; chamotte or dinas earths:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2508.10.0000",
      "rawHtsCode": "2508.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Bentonite",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$3.20/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2508.30.0000",
      "rawHtsCode": "2508.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Fire-clay",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.97/t",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2508.40.01",
      "rawHtsCode": "2508.40.01",
      "superior": null,
      "indent": "1",
      "description": "Other clays",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.97/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2508.40.0110",
      "rawHtsCode": "2508.40.01.10",
      "superior": null,
      "indent": "2",
      "description": "Common blue clay and other ball clays",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2508.40.0120",
      "rawHtsCode": "2508.40.01.20",
      "superior": null,
      "indent": "2",
      "description": "Decolorizing earths and fuller's earth",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2508.40.0150",
      "rawHtsCode": "2508.40.01.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2508.50.0000",
      "rawHtsCode": "2508.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Andalusite, kyanite and sillimanite",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2508.60.0000",
      "rawHtsCode": "2508.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mullite",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2508.70.0000",
      "rawHtsCode": "2508.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Chamotte or dinas earth",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2509.00",
      "rawHtsCode": "2509.00",
      "superior": null,
      "indent": "0",
      "description": "Chalk:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2509.00.1000",
      "rawHtsCode": "2509.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Crude",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2509.00.2000",
      "rawHtsCode": "2509.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "13%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2510",
      "rawHtsCode": "2510",
      "superior": null,
      "indent": "0",
      "description": "Natural calcium phosphates, natural aluminum calcium phosphates and phosphatic chalk:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2510.10.0000",
      "rawHtsCode": "2510.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Unground",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2510.20.0000",
      "rawHtsCode": "2510.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ground",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2511",
      "rawHtsCode": "2511",
      "superior": null,
      "indent": "0",
      "description": "Natural barium sulfate (barytes); natural barium carbonate (witherite), whether or not calcined, other than barium oxide of heading 2816:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2511.10",
      "rawHtsCode": "2511.10",
      "superior": null,
      "indent": "1",
      "description": "Natural barium sulfate (barytes):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2511.10.1000",
      "rawHtsCode": "2511.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Ground",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$7.38/t",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2511.10.5000",
      "rawHtsCode": "2511.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "$1.25/t",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$3.94/t",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2511.20.0000",
      "rawHtsCode": "2511.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Natural barium carbonate (witherite)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2512.00.0000",
      "rawHtsCode": "2512.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Siliceous fossil meals (for example, kieselguhr, tripolite and diatomite) and similar siliceous earths, whether or not calcined, of an apparent specific gravity of 1 or less",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2513",
      "rawHtsCode": "2513",
      "superior": null,
      "indent": "0",
      "description": "Pumice; emery; natural corundum, natural garnet and other natural abrasives, whether or not heat-treated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2513.10.00",
      "rawHtsCode": "2513.10.00",
      "superior": null,
      "indent": "1",
      "description": "Pumice stone",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2513.10.0010",
      "rawHtsCode": "2513.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Crude or in irregular pieces, including crushed pumice",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2513.10.0080",
      "rawHtsCode": "2513.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2513.20",
      "rawHtsCode": "2513.20",
      "superior": null,
      "indent": "1",
      "description": "Emery, natural corundum, natural garnet and other natural abrasives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2513.20.1000",
      "rawHtsCode": "2513.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Crude or in irregular pieces",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2513.20.9000",
      "rawHtsCode": "2513.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2514.00.0000",
      "rawHtsCode": "2514.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Slate, whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2515",
      "rawHtsCode": "2515",
      "superior": null,
      "indent": "0",
      "description": "Marble, travertine and other calcareous monumental or building stone of an apparent specific gravity of 2.5 or more, and alabaster, whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2515.11.0000",
      "rawHtsCode": "2515.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crude or roughly trimmed",
      "units": [
        "m<sup>3</sup>",
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$22.95/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2515.12",
      "rawHtsCode": "2515.12",
      "superior": null,
      "indent": "2",
      "description": "Merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2515.12.1000",
      "rawHtsCode": "2515.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "Marble",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "13%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2515.12.2000",
      "rawHtsCode": "2515.12.20.00",
      "superior": null,
      "indent": "3",
      "description": "Travertine",
      "units": [
        "t"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2515.20.0000",
      "rawHtsCode": "2515.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other calcareous monumental or building stone; alabaster",
      "units": [
        "t"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2516",
      "rawHtsCode": "2516",
      "superior": null,
      "indent": "0",
      "description": "Granite, porphyry, basalt, sandstone and other monumental or building stone, whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2516.11.0000",
      "rawHtsCode": "2516.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crude or roughly trimmed",
      "units": [
        "m<sup>3</sup>",
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$8.83/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2516.12.00",
      "rawHtsCode": "2516.12.00",
      "superior": null,
      "indent": "2",
      "description": "Merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2516.12.0030",
      "rawHtsCode": "2516.12.00.30",
      "superior": null,
      "indent": "3",
      "description": "Having a thickness of 7.5 cm or more",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2516.12.0060",
      "rawHtsCode": "2516.12.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2516.20",
      "rawHtsCode": "2516.20",
      "superior": null,
      "indent": "1",
      "description": "Sandstone:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2516.20.1000",
      "rawHtsCode": "2516.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Crude or roughly trimmed",
      "units": [
        "m<sup>3</sup>",
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$5.30/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2516.20.2000",
      "rawHtsCode": "2516.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
      "units": [
        "t"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2516.90.00",
      "rawHtsCode": "2516.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other monumental or building stone",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2516.90.0030",
      "rawHtsCode": "2516.90.00.30",
      "superior": null,
      "indent": "2",
      "description": "Having a thickness of 7.5 cm or more",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2516.90.0060",
      "rawHtsCode": "2516.90.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2517",
      "rawHtsCode": "2517",
      "superior": null,
      "indent": "0",
      "description": "Pebbles, gravel, broken or crushed stone, of a kind commonly used for concrete aggregates, for road metalling, or for railway or other ballast; shingle and flint, whether or not heat-treated; macadam of slag, dross or similar industrial waste, whether or not incorporating the materials cited in the first part of the heading; tarred macadam; granules, chippings and powder, of stones of heading 2515 or 2516, whether or not heat-treated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2517.10.00",
      "rawHtsCode": "2517.10.00",
      "superior": null,
      "indent": "1",
      "description": "Pebbles, gravel, broken or crushed stone, of a kind commonly used for concrete aggregates, for road metalling, or for railway or other ballast, shingle and flint, whether or not heat-treated",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2517.10.0015",
      "rawHtsCode": "2517.10.00.15",
      "superior": null,
      "indent": "2",
      "description": "Pebbles and gravel",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2517.10.0020",
      "rawHtsCode": "2517.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Limestone, except pebbles and gravel",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2517.10.0055",
      "rawHtsCode": "2517.10.00.55",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2517.20.0000",
      "rawHtsCode": "2517.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Macadam of slag, dross or similar industrial waste, whether or not incorporating the materials cited in subheading 2517.10",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2517.30.0000",
      "rawHtsCode": "2517.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tarred macadam",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2517.41.0000",
      "rawHtsCode": "2517.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of marble",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2517.49.0000",
      "rawHtsCode": "2517.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.10/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2518",
      "rawHtsCode": "2518",
      "superior": null,
      "indent": "0",
      "description": "Dolomite, whether or not calcined or sintered, including dolomite roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2518.10.0000",
      "rawHtsCode": "2518.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Dolomite, not calcined or sintered",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2518.20.0000",
      "rawHtsCode": "2518.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Calcined or sintered dolomite",
      "units": [
        "t"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2519",
      "rawHtsCode": "2519",
      "superior": null,
      "indent": "0",
      "description": "Natural magnesium carbonate (magnesite); fused magnesia; dead-burned (sintered) magnesia, whether or not containing small quantities of other oxides added before sintering; other magnesium oxide, whether or not pure:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2519.10.0000",
      "rawHtsCode": "2519.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Natural magnesium carbonate (magnesite)",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$10.33/t",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2519.90",
      "rawHtsCode": "2519.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2519.90.1000",
      "rawHtsCode": "2519.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fused magnesia and dead-burned (sintered) magnesia",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2519.90.2000",
      "rawHtsCode": "2519.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Caustic calcined magnesite",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$20.70/t",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2519.90.5000",
      "rawHtsCode": "2519.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2520",
      "rawHtsCode": "2520",
      "superior": null,
      "indent": "0",
      "description": "Gypsum; anhydrite; plasters (consisting of calcined gypsum or calcium sulfate) whether or not colored, with or without small quantities of accelerators or retarders:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2520.10.0000",
      "rawHtsCode": "2520.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Gypsum; anhydrite",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2520.20.0000",
      "rawHtsCode": "2520.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Plasters",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.38/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2521.00.0000",
      "rawHtsCode": "2521.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Limestone flux; limestone and other calcareous stone, of a kind used for the manufacture of lime or cement",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2522",
      "rawHtsCode": "2522",
      "superior": null,
      "indent": "0",
      "description": "Quicklime, slaked lime and hydraulic lime, other than calcium oxide and hydroxide of heading 2825:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2522.10.0000",
      "rawHtsCode": "2522.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Quicklime",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.2¢/kg, including weight of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2522.20.0000",
      "rawHtsCode": "2522.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Slaked lime",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.3¢/kg, including weight of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2522.30.0000",
      "rawHtsCode": "2522.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hydraulic lime",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.2¢/kg, including weight of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2523",
      "rawHtsCode": "2523",
      "superior": null,
      "indent": "0",
      "description": "Portland cement, aluminous cement, slag cement, supersulfate cement and similar hydraulic cements, whether or not colored or in the form of clinkers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2523.10.0000",
      "rawHtsCode": "2523.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cement clinkers",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/t, including weight of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2523.21.0000",
      "rawHtsCode": "2523.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "White cement, whether or not artificially colored",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.76/t, including weight of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2523.29.0000",
      "rawHtsCode": "2523.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/t, including weight of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2523.30.0000",
      "rawHtsCode": "2523.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Aluminous cement",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/t, including weight of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2523.90.0000",
      "rawHtsCode": "2523.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other hydraulic cements",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.32/t, including weight of container",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2524",
      "rawHtsCode": "2524",
      "superior": null,
      "indent": "0",
      "description": "Asbestos:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2524.10.0000",
      "rawHtsCode": "2524.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Crocidolite (Blue)",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2524.90.00",
      "rawHtsCode": "2524.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2524.90.0010",
      "rawHtsCode": "2524.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Amosite",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2524.90.0030",
      "rawHtsCode": "2524.90.00.30",
      "superior": null,
      "indent": "3",
      "description": "Crudes",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2524.90.0040",
      "rawHtsCode": "2524.90.00.40",
      "superior": null,
      "indent": "3",
      "description": "Milled fibers, group 3 grades (spinning fibers or equivalent)",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2524.90.0045",
      "rawHtsCode": "2524.90.00.45",
      "superior": null,
      "indent": "3",
      "description": "Milled fibers, group 4 and 5 grades",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2524.90.0055",
      "rawHtsCode": "2524.90.00.55",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2524.90.0060",
      "rawHtsCode": "2524.90.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2525",
      "rawHtsCode": "2525",
      "superior": null,
      "indent": "0",
      "description": "Mica, including splittings; mica waste:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2525.10.00",
      "rawHtsCode": "2525.10.00",
      "superior": null,
      "indent": "1",
      "description": "Crude mica and mica rifted into sheets or splittings",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2525.10.0010",
      "rawHtsCode": "2525.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Split block mica",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2525.10.0020",
      "rawHtsCode": "2525.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Mica splittings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2525.10.0050",
      "rawHtsCode": "2525.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2525.20.0000",
      "rawHtsCode": "2525.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mica powder",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2525.30.0000",
      "rawHtsCode": "2525.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mica waste",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.8¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2526",
      "rawHtsCode": "2526",
      "superior": null,
      "indent": "0",
      "description": "Natural steatite, whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape; talc:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2526.10.0000",
      "rawHtsCode": "2526.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Not crushed, not powdered",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2526.20.0000",
      "rawHtsCode": "2526.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Crushed or powdered",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2528.00.00",
      "rawHtsCode": "2528.00.00",
      "superior": null,
      "indent": "0",
      "description": "Natural borates and concentrates thereof (whether or not calcined), but not including borates separated from natural brine; natural boric acid containing not more than 85 percent of H<sub>3</sub>BO<sub>3</sub> calculated on the dry weight",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2528.00.0005",
      "rawHtsCode": "2528.00.00.05",
      "superior": null,
      "indent": "1",
      "description": "Natural sodium borates and concentrates thereof (whether or not calcined)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2528.00.0010",
      "rawHtsCode": "2528.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Natural calcium borates",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2528.00.0050",
      "rawHtsCode": "2528.00.00.50",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2529",
      "rawHtsCode": "2529",
      "superior": null,
      "indent": "0",
      "description": "Feldspar; leucite, nepheline and nepheline syenite; fluorspar:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2529.10.0000",
      "rawHtsCode": "2529.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Feldspar",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "49¢/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2529.21.0000",
      "rawHtsCode": "2529.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight 97 percent or less of calcium fluoride",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "13.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2529.22.0000",
      "rawHtsCode": "2529.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight more than 97 percent of calcium fluoride",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$5.51/t",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2529.30.00",
      "rawHtsCode": "2529.30.00",
      "superior": null,
      "indent": "1",
      "description": "Leucite; nepheline and nepheline syenite",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2529.30.0010",
      "rawHtsCode": "2529.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Nepheline syenite",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2529.30.0050",
      "rawHtsCode": "2529.30.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2530",
      "rawHtsCode": "2530",
      "superior": null,
      "indent": "0",
      "description": "Mineral substances not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2530.10.0000",
      "rawHtsCode": "2530.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Vermiculite, perlite and chlorites, unexpanded",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2530.20",
      "rawHtsCode": "2530.20",
      "superior": null,
      "indent": "1",
      "description": "Kieserite, epsom salts (natural magnesium sulfates):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2530.20.1000",
      "rawHtsCode": "2530.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Kieserite",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2530.20.2000",
      "rawHtsCode": "2530.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Epsom salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2530.90",
      "rawHtsCode": "2530.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2530.90.1000",
      "rawHtsCode": "2530.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Natural cryolite; natural chiolite",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2530.90.2000",
      "rawHtsCode": "2530.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Natural micaceous iron oxides",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2530.90.80",
      "rawHtsCode": "2530.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2530.90.8010",
      "rawHtsCode": "2530.90.80.10",
      "superior": null,
      "indent": "3",
      "description": "Celestite",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2530.90.8015",
      "rawHtsCode": "2530.90.80.15",
      "superior": null,
      "indent": "3",
      "description": "Earth colors",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2530.90.8050",
      "rawHtsCode": "2530.90.80.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2601",
      "rawHtsCode": "2601",
      "superior": null,
      "indent": "0",
      "description": "Iron ores and concentrates, including roasted iron pyrites:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2601.11.00",
      "rawHtsCode": "2601.11.00",
      "superior": null,
      "indent": "2",
      "description": "Non-agglomerated",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2601.11.0030",
      "rawHtsCode": "2601.11.00.30",
      "superior": null,
      "indent": "3",
      "description": "Concentrates",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2601.11.0060",
      "rawHtsCode": "2601.11.00.60",
      "superior": null,
      "indent": "4",
      "description": "Coarse",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2601.11.0090",
      "rawHtsCode": "2601.11.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2601.12.00",
      "rawHtsCode": "2601.12.00",
      "superior": null,
      "indent": "2",
      "description": "Agglomerated",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2601.12.0030",
      "rawHtsCode": "2601.12.00.30",
      "superior": null,
      "indent": "3",
      "description": "Pellets",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2601.12.0060",
      "rawHtsCode": "2601.12.00.60",
      "superior": null,
      "indent": "3",
      "description": "Briquettes",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2601.12.0090",
      "rawHtsCode": "2601.12.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2601.20.0000",
      "rawHtsCode": "2601.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Roasted iron pyrites",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2602.00.00",
      "rawHtsCode": "2602.00.00",
      "superior": null,
      "indent": "0",
      "description": "Manganese ores and concentrates, including ferruginous manganese ores and concentrates with a manganese content of 20 percent or more, calculated on the dry weight",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg on manganese content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2602.00.0040",
      "rawHtsCode": "2602.00.00.40",
      "superior": null,
      "indent": "1",
      "description": "Containing less than 47 percent by weight of manganese",
      "units": [
        "kg",
        "Mn kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2602.00.0060",
      "rawHtsCode": "2602.00.00.60",
      "superior": null,
      "indent": "1",
      "description": "Containing 47 percent or more by weight of manganese",
      "units": [
        "kg",
        "Mn kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2603.00.00",
      "rawHtsCode": "2603.00.00",
      "superior": null,
      "indent": "0",
      "description": "Copper ores and concentrates",
      "units": [],
      "generalRate": "1.7¢/kg on lead content",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.8¢/kg on copper content + 3.3¢/kg on lead content + 3.7¢/kg on zinc content",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2603.00.0010",
      "rawHtsCode": "2603.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Copper content",
      "units": [
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2603.00.0020",
      "rawHtsCode": "2603.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Lead content",
      "units": [
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2603.00.0030",
      "rawHtsCode": "2603.00.00.30",
      "superior": null,
      "indent": "1",
      "description": "Zinc content",
      "units": [
        "Zn kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2603.00.0040",
      "rawHtsCode": "2603.00.00.40",
      "superior": null,
      "indent": "1",
      "description": "Silver content",
      "units": [
        "Ag g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2603.00.0050",
      "rawHtsCode": "2603.00.00.50",
      "superior": null,
      "indent": "1",
      "description": "Gold content",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2604.00.00",
      "rawHtsCode": "2604.00.00",
      "superior": null,
      "indent": "0",
      "description": "Nickel ores and concentrates",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2604.00.0040",
      "rawHtsCode": "2604.00.00.40",
      "superior": null,
      "indent": "1",
      "description": "Nickel content",
      "units": [
        "Ni kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2604.00.0080",
      "rawHtsCode": "2604.00.00.80",
      "superior": null,
      "indent": "1",
      "description": "Other metal content",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2605.00.0000",
      "rawHtsCode": "2605.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Cobalt ores and concentrates",
      "units": [
        "kg",
        "Co kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2606.00.00",
      "rawHtsCode": "2606.00.00",
      "superior": null,
      "indent": "0",
      "description": "Aluminum ores and concentrates",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2606.00.0030",
      "rawHtsCode": "2606.00.00.30",
      "superior": null,
      "indent": "2",
      "description": "Refractory grade",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2606.00.0060",
      "rawHtsCode": "2606.00.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2606.00.0090",
      "rawHtsCode": "2606.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2607.00.00",
      "rawHtsCode": "2607.00.00",
      "superior": null,
      "indent": "0",
      "description": "Lead ores and concentrates",
      "units": [],
      "generalRate": "1.1¢/kg on lead content",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.8¢/kg on copper content + 3.3¢/kg on lead content + 3.7¢/kg on zinc content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2607.00.0010",
      "rawHtsCode": "2607.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Copper content",
      "units": [
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2607.00.0020",
      "rawHtsCode": "2607.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Lead content",
      "units": [
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2607.00.0030",
      "rawHtsCode": "2607.00.00.30",
      "superior": null,
      "indent": "1",
      "description": "Zinc content",
      "units": [
        "Zn kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2607.00.0040",
      "rawHtsCode": "2607.00.00.40",
      "superior": null,
      "indent": "1",
      "description": "Silver content",
      "units": [
        "Ag g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2607.00.0050",
      "rawHtsCode": "2607.00.00.50",
      "superior": null,
      "indent": "1",
      "description": "Gold content",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2608.00.00",
      "rawHtsCode": "2608.00.00",
      "superior": null,
      "indent": "0",
      "description": "Zinc ores and concentrates",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.8¢/kg on copper content + 3.3¢/kg on lead content + 3.7¢/kg on zinc content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2608.00.0010",
      "rawHtsCode": "2608.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Copper content",
      "units": [
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2608.00.0020",
      "rawHtsCode": "2608.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Lead content",
      "units": [
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2608.00.0030",
      "rawHtsCode": "2608.00.00.30",
      "superior": null,
      "indent": "1",
      "description": "Zinc content",
      "units": [
        "Zn kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2608.00.0040",
      "rawHtsCode": "2608.00.00.40",
      "superior": null,
      "indent": "1",
      "description": "Silver content",
      "units": [
        "Ag g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2608.00.0050",
      "rawHtsCode": "2608.00.00.50",
      "superior": null,
      "indent": "1",
      "description": "Gold content",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2609.00.0000",
      "rawHtsCode": "2609.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Tin ores and concentrates",
      "units": [
        "t",
        "Sn t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2610.00.00",
      "rawHtsCode": "2610.00.00",
      "superior": null,
      "indent": "0",
      "description": "Chromium ores and concentrates",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2610.00.0020",
      "rawHtsCode": "2610.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Having a chromium content equivalent to not more than 40 percent chromic oxide (Cr<sub>2</sub>O<sub>3</sub>)",
      "units": [
        "t",
        "Cr<sub>2</sub>O<sub>3</sub> t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2610.00.0040",
      "rawHtsCode": "2610.00.00.40",
      "superior": null,
      "indent": "1",
      "description": "Having a chromium content equivalent to more than 40 percent but less than 46 percent chromic oxide (Cr<sub>2</sub>O<sub>3</sub>)",
      "units": [
        "t",
        "Cr<sub>2</sub>O<sub>3</sub> t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2610.00.0060",
      "rawHtsCode": "2610.00.00.60",
      "superior": null,
      "indent": "1",
      "description": "Having a chromium content equivalent to 46 percent or more chromic oxide (Cr<sub>2</sub>O<sub>3</sub>)",
      "units": [
        "t",
        "Cr<sub>2</sub>O<sub>3</sub> t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2611.00",
      "rawHtsCode": "2611.00",
      "superior": null,
      "indent": "0",
      "description": "Tungsten ores and concentrates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2611.00.3000",
      "rawHtsCode": "2611.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Ores",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.10/kg on tungsten content",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2611.00.6000",
      "rawHtsCode": "2611.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Concentrates",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "37.5¢/kg on tungsten content",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg on tungsten content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2612",
      "rawHtsCode": "2612",
      "superior": null,
      "indent": "0",
      "description": "Uranium or thorium ores and concentrates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2612.10.0000",
      "rawHtsCode": "2612.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Uranium ores and concentrates",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2612.20.0000",
      "rawHtsCode": "2612.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Thorium ores and concentrates",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2613",
      "rawHtsCode": "2613",
      "superior": null,
      "indent": "0",
      "description": "Molybdenum ores and concentrates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2613.10.0000",
      "rawHtsCode": "2613.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Roasted",
      "units": [
        "kg",
        "Mo kg"
      ],
      "generalRate": "12.8¢/kg on molybdenum content + 1.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg on molybdenum content + 15%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2613.90.0000",
      "rawHtsCode": "2613.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg",
        "Mo kg"
      ],
      "generalRate": "17.8¢/kg on molybdenum content",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "77.2¢/kg on molybdenum content",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2614.00",
      "rawHtsCode": "2614.00",
      "superior": null,
      "indent": "0",
      "description": "Titanium ores and concentrates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2614.00.3000",
      "rawHtsCode": "2614.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Synthetic rutile",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2614.00.60",
      "rawHtsCode": "2614.00.60",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2614.00.6020",
      "rawHtsCode": "2614.00.60.20",
      "superior": null,
      "indent": "2",
      "description": "Ilmenite and ilmenite sand",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2614.00.6040",
      "rawHtsCode": "2614.00.60.40",
      "superior": null,
      "indent": "2",
      "description": "Other (including rutile and rutile sand)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2615",
      "rawHtsCode": "2615",
      "superior": null,
      "indent": "0",
      "description": "Niobium (columbium), tantalum, vanadium or zirconium ores and concentrates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2615.10.0000",
      "rawHtsCode": "2615.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Zirconium ores and concentrates",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2615.90",
      "rawHtsCode": "2615.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2615.90.3000",
      "rawHtsCode": "2615.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Synthetic tantalum-niobium (columbium) concentrates",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2615.90.60",
      "rawHtsCode": "2615.90.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2615.90.6030",
      "rawHtsCode": "2615.90.60.30",
      "superior": null,
      "indent": "3",
      "description": "Niobium (columbium) ores and concentrates",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2615.90.6060",
      "rawHtsCode": "2615.90.60.60",
      "superior": null,
      "indent": "3",
      "description": "Tantalum ores and concentrates",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2615.90.6090",
      "rawHtsCode": "2615.90.60.90",
      "superior": null,
      "indent": "3",
      "description": "Vanadium ores and concentrates",
      "units": [
        "kg",
        "V<sub>2</sub>O<sub>5</sub> kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2616",
      "rawHtsCode": "2616",
      "superior": null,
      "indent": "0",
      "description": "Precious metal ores and concentrates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2616.10.00",
      "rawHtsCode": "2616.10.00",
      "superior": null,
      "indent": "1",
      "description": "Silver ores and concentrates",
      "units": [],
      "generalRate": "0.8¢/kg on lead content",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "8.8¢/kg on copper content + 3.3¢/kg on lead content + 3.7¢/kg on zinc content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2616.10.0010",
      "rawHtsCode": "2616.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Copper content",
      "units": [
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2616.10.0020",
      "rawHtsCode": "2616.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Lead content",
      "units": [
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2616.10.0030",
      "rawHtsCode": "2616.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Zinc content",
      "units": [
        "Zn kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2616.10.0040",
      "rawHtsCode": "2616.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Silver content",
      "units": [
        "Ag g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2616.10.0080",
      "rawHtsCode": "2616.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Gold content",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2616.90.00",
      "rawHtsCode": "2616.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "1.7¢/kg on lead content",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "8.8¢/kg on copper content + 3.3¢/kg on lead content + 3.7¢/kg on zinc content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2616.90.0010",
      "rawHtsCode": "2616.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Copper content",
      "units": [
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2616.90.0020",
      "rawHtsCode": "2616.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Lead content",
      "units": [
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2616.90.0030",
      "rawHtsCode": "2616.90.00.30",
      "superior": null,
      "indent": "2",
      "description": "Zinc content",
      "units": [
        "Zn kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2616.90.0040",
      "rawHtsCode": "2616.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Gold content",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2616.90.0050",
      "rawHtsCode": "2616.90.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other precious metal content",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2617",
      "rawHtsCode": "2617",
      "superior": null,
      "indent": "0",
      "description": "Other ores and concentrates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2617.10.0000",
      "rawHtsCode": "2617.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Antimony ores and concentrates",
      "units": [
        "kg",
        "Sb kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2617.90.00",
      "rawHtsCode": "2617.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2617.90.0030",
      "rawHtsCode": "2617.90.00.30",
      "superior": null,
      "indent": "2",
      "description": "Beryllium ores and concentrates",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2617.90.0060",
      "rawHtsCode": "2617.90.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2618.00.0000",
      "rawHtsCode": "2618.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Granulated slag (slag sand) from the manufacture of iron or steel",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2619.00",
      "rawHtsCode": "2619.00",
      "superior": null,
      "indent": "0",
      "description": "Slag, dross (other than granulated slag), scalings and other waste from the manufacture of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2619.00.3000",
      "rawHtsCode": "2619.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Ferrous scale",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "73.8¢/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2619.00.9000",
      "rawHtsCode": "2619.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2620",
      "rawHtsCode": "2620",
      "superior": null,
      "indent": "0",
      "description": "Slag, ash and residues (other than from the manufacture of iron or steel), containing arsenic, metals or their compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2620.11.0000",
      "rawHtsCode": "2620.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Hard zinc spelter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.19",
      "rawHtsCode": "2620.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2620.19.3000",
      "rawHtsCode": "2620.19.30.00",
      "superior": null,
      "indent": "3",
      "description": "Zinc dross and zinc skimmings",
      "units": [
        "kg",
        "Zn kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.19.60",
      "rawHtsCode": "2620.19.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "0.7¢/kg on copper content + 0.7¢/kg on lead content",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.8¢/kg on copper content + 3.3¢/kg on lead content + 3.7¢/kg on zinc content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2620.19.6010",
      "rawHtsCode": "2620.19.60.10",
      "superior": null,
      "indent": "4",
      "description": "Copper content",
      "units": [
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.19.6020",
      "rawHtsCode": "2620.19.60.20",
      "superior": null,
      "indent": "4",
      "description": "Lead content",
      "units": [
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.19.6030",
      "rawHtsCode": "2620.19.60.30",
      "superior": null,
      "indent": "4",
      "description": "Zinc content",
      "units": [
        "Zn kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.19.6040",
      "rawHtsCode": "2620.19.60.40",
      "superior": null,
      "indent": "4",
      "description": "Silver content",
      "units": [
        "Ag g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.19.6050",
      "rawHtsCode": "2620.19.60.50",
      "superior": null,
      "indent": "4",
      "description": "Gold content",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.21.00",
      "rawHtsCode": "2620.21.00",
      "superior": null,
      "indent": "2",
      "description": "Leaded gasoline sludges and leaded anti-knock compound sludges",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.8¢/kg on copper content + 3.3¢/kg on lead content + 3.7¢/kg on zinc content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.21.0010",
      "rawHtsCode": "2620.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Copper content",
      "units": [
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content. "
      ],
      "flags": []
    },
    {
      "htsCode": "2620.21.0020",
      "rawHtsCode": "2620.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Lead content",
      "units": [
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.21.0030",
      "rawHtsCode": "2620.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Zinc content",
      "units": [
        "Zn kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.21.0040",
      "rawHtsCode": "2620.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Silver content",
      "units": [
        "Ag g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.21.0050",
      "rawHtsCode": "2620.21.00.50",
      "superior": null,
      "indent": "3",
      "description": "Gold content",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.29.00",
      "rawHtsCode": "2620.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.8¢/kg on copper content + 3.3¢/kg on lead content + 3.7¢/kg on zinc content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.29.0010",
      "rawHtsCode": "2620.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Copper content",
      "units": [
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.29.0020",
      "rawHtsCode": "2620.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Lead content",
      "units": [
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.29.0030",
      "rawHtsCode": "2620.29.00.30",
      "superior": null,
      "indent": "3",
      "description": "Zinc content",
      "units": [
        "Zn kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.29.0040",
      "rawHtsCode": "2620.29.00.40",
      "superior": null,
      "indent": "3",
      "description": "Silver content",
      "units": [
        "Ag g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.29.0050",
      "rawHtsCode": "2620.29.00.50",
      "superior": null,
      "indent": "3",
      "description": "Gold content",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.30.00",
      "rawHtsCode": "2620.30.00",
      "superior": null,
      "indent": "1",
      "description": "Containing mainly copper",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.8¢/kg on copper content + 3.3¢/kg on lead content + 3.7¢/kg on zinc content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.30.0010",
      "rawHtsCode": "2620.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Copper content",
      "units": [
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.30.0020",
      "rawHtsCode": "2620.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "Lead content",
      "units": [
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.30.0030",
      "rawHtsCode": "2620.30.00.30",
      "superior": null,
      "indent": "2",
      "description": "Zinc content",
      "units": [
        "Zn kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.30.0040",
      "rawHtsCode": "2620.30.00.40",
      "superior": null,
      "indent": "2",
      "description": "Silver content",
      "units": [
        "Ag g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.30.0050",
      "rawHtsCode": "2620.30.00.50",
      "superior": null,
      "indent": "2",
      "description": "Gold content",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.40.00",
      "rawHtsCode": "2620.40.00",
      "superior": null,
      "indent": "1",
      "description": "Containing mainly aluminum",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2620.40.0030",
      "rawHtsCode": "2620.40.00.30",
      "superior": null,
      "indent": "2",
      "description": "Vanadium bearing materials",
      "units": [
        "kg",
        "V<sub>2</sub>O<sub>5</sub> kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2620.40.0060",
      "rawHtsCode": "2620.40.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2620.60",
      "rawHtsCode": "2620.60",
      "superior": null,
      "indent": "1",
      "description": "Containing arsenic, mercury, thallium or their mixtures, of a kind used for the extraction of arsenic or those metalsor for the manufacture of their chemical compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2620.60.1000",
      "rawHtsCode": "2620.60.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used only for the extraction of arsenic or the manufacture of its chemical compounds",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2620.60.9000",
      "rawHtsCode": "2620.60.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.91.0000",
      "rawHtsCode": "2620.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing antimony, beryllium, cadmium, chromium or their mixtures",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.99",
      "rawHtsCode": "2620.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2620.99.1000",
      "rawHtsCode": "2620.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing mainly vanadium",
      "units": [
        "kg",
        "V<sub>2</sub>O<sub>5</sub> kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.99.2000",
      "rawHtsCode": "2620.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Containing mainly tungsten",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "17.6¢/kg on tungsten content + 3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.32/kg on tungsten content + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2620.99.3000",
      "rawHtsCode": "2620.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "Materials not provided for elsewhere in this heading containing by weight over 10 percent nickel",
      "units": [
        "kg",
        "Ni kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.99.5000",
      "rawHtsCode": "2620.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Slag containing by weight over 40 percent titanium, and which if containing over 2 percent by weight of copper, lead, or zinc is not to be treated for the recovery thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.99.75",
      "rawHtsCode": "2620.99.75",
      "superior": null,
      "indent": "3",
      "description": "Other materials which are residues not advanced in value or condition by any means, and which if containing over 2 percent by weight of copper, lead or zinc are not to be treated for the recovery thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.99.7520",
      "rawHtsCode": "2620.99.75.20",
      "superior": null,
      "indent": "5",
      "description": "Vanadium bearing materials",
      "units": [
        "kg",
        "V<sub>2</sub>O<sub>5</sub> kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2620.99.7560",
      "rawHtsCode": "2620.99.75.60",
      "superior": null,
      "indent": "5",
      "description": "Other materials containing silver",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.99.7580",
      "rawHtsCode": "2620.99.75.80",
      "superior": null,
      "indent": "5",
      "description": "Other materials containing gold",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Report value only of stated metal content."
      ],
      "flags": []
    },
    {
      "htsCode": "2620.99.7590",
      "rawHtsCode": "2620.99.75.90",
      "superior": null,
      "indent": "5",
      "description": "Other materials that do not contain vanadium, silver or gold",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2620.99.8500",
      "rawHtsCode": "2620.99.85.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2621",
      "rawHtsCode": "2621",
      "superior": null,
      "indent": "0",
      "description": "Other slag and ash, including seaweed ash (kelp); ash and residues from the incineration of municipal waste:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2621.10.0000",
      "rawHtsCode": "2621.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ash and residues from the incineration of municipal waste",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2621.90.0000",
      "rawHtsCode": "2621.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2701",
      "rawHtsCode": "2701",
      "superior": null,
      "indent": "0",
      "description": "Coal; briquettes, ovoids and similar solid fuels manufactured from coal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2701.11.0000",
      "rawHtsCode": "2701.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Anthracite",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2701.12.00",
      "rawHtsCode": "2701.12.00",
      "superior": null,
      "indent": "2",
      "description": "Bituminous coal",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2701.12.0010",
      "rawHtsCode": "2701.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Metallurgical coal",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2701.12.0050",
      "rawHtsCode": "2701.12.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2701.19.00",
      "rawHtsCode": "2701.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other coal",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2701.19.0010",
      "rawHtsCode": "2701.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Sub-bituminous coal",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2701.19.0050",
      "rawHtsCode": "2701.19.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2701.20.0000",
      "rawHtsCode": "2701.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Briquettes, ovoids and similar solid fuels manufactured from coal",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2702",
      "rawHtsCode": "2702",
      "superior": null,
      "indent": "0",
      "description": "Lignite, whether or not agglomerated, excluding jet:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2702.10.0000",
      "rawHtsCode": "2702.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Lignite, whether or not pulverized, but not agglomerated",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2702.20.0000",
      "rawHtsCode": "2702.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Agglomerated lignite",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2703.00.0000",
      "rawHtsCode": "2703.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Peat (including peat litter), whether or not agglomerated",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2704.00.00",
      "rawHtsCode": "2704.00.00",
      "superior": null,
      "indent": "0",
      "description": "Coke and semicoke of coal, of lignite or of peat, whether or not agglomerated; retort carbon",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2704.00.0011",
      "rawHtsCode": "2704.00.00.11",
      "superior": null,
      "indent": "2",
      "description": "Coke larger than 100 mm (4 inches) in maximum diameter and at least 50 percent of which is retained on a 100-mm (4-inch) sieve after drop shatter testing pursuant to ASTM D 3038, of a kind used in foundries",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2704.00.0025",
      "rawHtsCode": "2704.00.00.25",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2704.00.0050",
      "rawHtsCode": "2704.00.00.50",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2705.00.0000",
      "rawHtsCode": "2705.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Coal gas, water gas, producer gas and similar gases, other than petroleum gases and other gaseous hydrocarbons",
      "units": [
        "thousand m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2706.00.0000",
      "rawHtsCode": "2706.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Tar distilled from coal, from lignite or from peat, and other mineral tars, whether or not dehydrated or partially distilled, including reconstituted tars",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2707",
      "rawHtsCode": "2707",
      "superior": null,
      "indent": "0",
      "description": "Oils and other products of the distillation of high temperature coal tar; similar products in which the weight of the aromatic constituents exceeds that of the nonaromatic constituents:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2707.10.0000",
      "rawHtsCode": "2707.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Benzene",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2707.20.0000",
      "rawHtsCode": "2707.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Toluene",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2707.30.00",
      "rawHtsCode": "2707.30.00",
      "superior": null,
      "indent": "1",
      "description": "Xylenes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2707.30.0010",
      "rawHtsCode": "2707.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "m-Xylene",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2707.30.0020",
      "rawHtsCode": "2707.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "o-Xylene",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2707.30.0030",
      "rawHtsCode": "2707.30.00.30",
      "superior": null,
      "indent": "2",
      "description": "p-Xylene",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2707.30.0040",
      "rawHtsCode": "2707.30.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2707.40.0000",
      "rawHtsCode": "2707.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Naphthalene",
      "units": [
        "kg",
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2707.50.0000",
      "rawHtsCode": "2707.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other aromatic hydrocarbon mixtures of which 65 percent or more by volume (including losses) distills at 250˚C by the ISO 3405 method (equivalent to the ASTM D 86 method)",
      "units": [
        "kg",
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2707.91.0000",
      "rawHtsCode": "2707.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Creosote oils",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2707.99",
      "rawHtsCode": "2707.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2707.99.1000",
      "rawHtsCode": "2707.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Light oil",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2707.99.2000",
      "rawHtsCode": "2707.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Picolines",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2707.99.4000",
      "rawHtsCode": "2707.99.40.00",
      "superior": null,
      "indent": "3",
      "description": "Carbazole having a purity of 65 percent or more by weight",
      "units": [
        "kg"
      ],
      "generalRate": "0.9¢/kg + 3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2707.99.5100",
      "rawHtsCode": "2707.99.51.00",
      "superior": null,
      "indent": "4",
      "description": "Containing more than 50 percent by weight of hydroxybenzene",
      "units": [
        "kg"
      ],
      "generalRate": "2.9¢/kg + 12.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.7¢/kg + 29.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2707.99.5500",
      "rawHtsCode": "2707.99.55.00",
      "superior": null,
      "indent": "4",
      "description": "Metacresol, orthocresol, paracresol and metaparacresol, all the foregoing having a purity of 75 percent or more by weight",
      "units": [
        "kg"
      ],
      "generalRate": "0.9¢/kg + 3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 42.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2707.99.5900",
      "rawHtsCode": "2707.99.59.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2707.99.90",
      "rawHtsCode": "2707.99.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2707.99.9010",
      "rawHtsCode": "2707.99.90.10",
      "superior": null,
      "indent": "4",
      "description": "Carbon black feedstocks",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2707.99.9090",
      "rawHtsCode": "2707.99.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2708",
      "rawHtsCode": "2708",
      "superior": null,
      "indent": "0",
      "description": "Pitch and pitch coke, obtained from coal tar or from other mineral tars:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2708.10.0000",
      "rawHtsCode": "2708.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Pitch",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2708.20.0000",
      "rawHtsCode": "2708.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Pitch coke",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2709.00",
      "rawHtsCode": "2709.00",
      "superior": null,
      "indent": "0",
      "description": "Petroleum oils and oils obtained from bituminous minerals, crude:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2709.00.1000",
      "rawHtsCode": "2709.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Testing under 25 degrees A.P.I.",
      "units": [
        "bbl"
      ],
      "generalRate": "5.25¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE,R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2709.00.20",
      "rawHtsCode": "2709.00.20",
      "superior": null,
      "indent": "1",
      "description": "Testing 25 degrees A.P.I. or more",
      "units": [],
      "generalRate": "10.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2709.00.2010",
      "rawHtsCode": "2709.00.20.10",
      "superior": null,
      "indent": "2",
      "description": "Condensate derived wholly from natural gas",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2709.00.2090",
      "rawHtsCode": "2709.00.20.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710",
      "rawHtsCode": "2710",
      "superior": null,
      "indent": "0",
      "description": "Petroleum oils and oils obtained from bituminous minerals, other than crude; preparations not elsewhere specified or included, containing by weight 70 percent or more of petroleum oils or of oils obtained from bituminous minerals, these oils being the basic constituents of the preparations; waste oils:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.12",
      "rawHtsCode": "2710.12",
      "superior": null,
      "indent": "2",
      "description": "Light oils and preparations:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.12.15",
      "rawHtsCode": "2710.12.15",
      "superior": null,
      "indent": "3",
      "description": "Motor fuel",
      "units": [],
      "generalRate": "52.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.05/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.12.1510",
      "rawHtsCode": "2710.12.15.10",
      "superior": null,
      "indent": "5",
      "description": "Leaded",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.12.1514",
      "rawHtsCode": "2710.12.15.14",
      "superior": null,
      "indent": "6",
      "description": "Reformulated",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.12.1519",
      "rawHtsCode": "2710.12.15.19",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.12.1520",
      "rawHtsCode": "2710.12.15.20",
      "superior": null,
      "indent": "4",
      "description": "Jet fuel, naphtha-type",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.12.1550",
      "rawHtsCode": "2710.12.15.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.12.18",
      "rawHtsCode": "2710.12.18",
      "superior": null,
      "indent": "3",
      "description": "Motor fuel blending stock",
      "units": [],
      "generalRate": "52.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.05/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.12.1805",
      "rawHtsCode": "2710.12.18.05",
      "superior": null,
      "indent": "4",
      "description": "Reformulated blendstock for oxygenate blending (RBOB)",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.12.1890",
      "rawHtsCode": "2710.12.18.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.12.2500",
      "rawHtsCode": "2710.12.25.00",
      "superior": null,
      "indent": "3",
      "description": "Naphthas (except motor fuel or motor fuel blending stock)",
      "units": [
        "bbl"
      ],
      "generalRate": "10.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.12.45",
      "rawHtsCode": "2710.12.45",
      "superior": null,
      "indent": "4",
      "description": "Mixtures of hydrocarbons not elsewhere specified or included, which contain by weight not over 50 percent of any single hydrocarbon compound",
      "units": [],
      "generalRate": "10.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.12.4545",
      "rawHtsCode": "2710.12.45.45",
      "superior": null,
      "indent": "5",
      "description": "Insulating or transformer oils",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.12.4560",
      "rawHtsCode": "2710.12.45.60",
      "superior": null,
      "indent": "5",
      "description": "Renewable fuels blends containing not less than 51 percent by volume of biofuel, as described in statistical note 1 to this chapter",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.12.4595",
      "rawHtsCode": "2710.12.45.95",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.12.9000",
      "rawHtsCode": "2710.12.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "liters"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "For ethyl alcohol or a mixture thereof from CBERA beneficiaries, see section 423 of the Tax Reform Act of 1986, as amended (19 U.S.C. 2703 note); for ethyl alcohol or a mixture thereof from DR-CAFTA beneficiaries, see section 201(a)(3)(B)(ii) of the DR-CAFTA Implementation Act (19 U.S.C. 4031(a)(3)(B)(ii)). ",
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.19",
      "rawHtsCode": "2710.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.06",
      "rawHtsCode": "2710.19.06",
      "superior": null,
      "indent": "4",
      "description": "Testing under 25 degrees A.P.I.",
      "units": [],
      "generalRate": "5.25¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.19.0605",
      "rawHtsCode": "2710.19.06.05",
      "superior": null,
      "indent": "6",
      "description": "Containing not more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.0615",
      "rawHtsCode": "2710.19.06.15",
      "superior": null,
      "indent": "6",
      "description": "Containing more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.0625",
      "rawHtsCode": "2710.19.06.25",
      "superior": null,
      "indent": "6",
      "description": "Fuel oil No. 5",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.0630",
      "rawHtsCode": "2710.19.06.30",
      "superior": null,
      "indent": "6",
      "description": "Fuel oil No. 6",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.0635",
      "rawHtsCode": "2710.19.06.35",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.0650",
      "rawHtsCode": "2710.19.06.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.11",
      "rawHtsCode": "2710.19.11",
      "superior": null,
      "indent": "4",
      "description": "Testing 25 degrees A.P.I. or more",
      "units": [],
      "generalRate": "10.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.19.1102",
      "rawHtsCode": "2710.19.11.02",
      "superior": null,
      "indent": "8",
      "description": "Containing not more than 15 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.1103",
      "rawHtsCode": "2710.19.11.03",
      "superior": null,
      "indent": "8",
      "description": "Containing more than 15 ppm but not more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.1104",
      "rawHtsCode": "2710.19.11.04",
      "superior": null,
      "indent": "8",
      "description": "Containing more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.1105",
      "rawHtsCode": "2710.19.11.05",
      "superior": null,
      "indent": "8",
      "description": "Containing not more than 15 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.1107",
      "rawHtsCode": "2710.19.11.07",
      "superior": null,
      "indent": "8",
      "description": "Containing more than 15 ppm but not more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.1108",
      "rawHtsCode": "2710.19.11.08",
      "superior": null,
      "indent": "8",
      "description": "Containing more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.1111",
      "rawHtsCode": "2710.19.11.11",
      "superior": null,
      "indent": "7",
      "description": "Containing not more than 15 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.1113",
      "rawHtsCode": "2710.19.11.13",
      "superior": null,
      "indent": "7",
      "description": "Containing more than 15 ppm but not more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.1114",
      "rawHtsCode": "2710.19.11.14",
      "superior": null,
      "indent": "7",
      "description": "Containing more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.1115",
      "rawHtsCode": "2710.19.11.15",
      "superior": null,
      "indent": "6",
      "description": "Containing not more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.1125",
      "rawHtsCode": "2710.19.11.25",
      "superior": null,
      "indent": "6",
      "description": "Containing more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.1150",
      "rawHtsCode": "2710.19.11.50",
      "superior": null,
      "indent": "5",
      "description": "Having a Saybolt Universal viscosity at 37.8˚C of more than 125 seconds (heavy fuel oils)",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.1600",
      "rawHtsCode": "2710.19.16.00",
      "superior": null,
      "indent": "3",
      "description": "Kerosene-type jet fuel",
      "units": [
        "bbl"
      ],
      "generalRate": "52.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.05/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.19.2400",
      "rawHtsCode": "2710.19.24.00",
      "superior": null,
      "indent": "4",
      "description": "Motor fuel",
      "units": [
        "bbl"
      ],
      "generalRate": "52.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.05/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.19.2500",
      "rawHtsCode": "2710.19.25.00",
      "superior": null,
      "indent": "4",
      "description": "Motor fuel blending stock",
      "units": [
        "bbl"
      ],
      "generalRate": "52.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.05/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.19.2600",
      "rawHtsCode": "2710.19.26.00",
      "superior": null,
      "indent": "4",
      "description": "Kerosene (except kerosene-type jet fuel",
      "units": [
        "bbl"
      ],
      "generalRate": "10.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.19.30",
      "rawHtsCode": "2710.19.30",
      "superior": null,
      "indent": "4",
      "description": "Oils",
      "units": [],
      "generalRate": "84¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.68/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.19.3010",
      "rawHtsCode": "2710.19.30.10",
      "superior": null,
      "indent": "5",
      "description": "Aviation engine lubricating oils",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.3020",
      "rawHtsCode": "2710.19.30.20",
      "superior": null,
      "indent": "5",
      "description": "Automotive, diesel or marine engine lubricating oils",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.3030",
      "rawHtsCode": "2710.19.30.30",
      "superior": null,
      "indent": "5",
      "description": "Turbine lubricating oil, including marine",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.3040",
      "rawHtsCode": "2710.19.30.40",
      "superior": null,
      "indent": "5",
      "description": "Automotive gear oils",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.3050",
      "rawHtsCode": "2710.19.30.50",
      "superior": null,
      "indent": "5",
      "description": "Steam cylinder oils",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.3070",
      "rawHtsCode": "2710.19.30.70",
      "superior": null,
      "indent": "5",
      "description": "Quenching or cutting oils",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.3080",
      "rawHtsCode": "2710.19.30.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.3500",
      "rawHtsCode": "2710.19.35.00",
      "superior": null,
      "indent": "5",
      "description": "Containing not over 10 percent by weight of salts of fatty acids of animal (including marine animal) or vegetable origin",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.19.4000",
      "rawHtsCode": "2710.19.40.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.3¢/kg + 5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "4.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.19.45",
      "rawHtsCode": "2710.19.45",
      "superior": null,
      "indent": "4",
      "description": "Mixtures of hydrocarbons not elsewhere specified or included, which contain by weight not over 50 percent of any single hydrocarbon compound",
      "units": [],
      "generalRate": "10.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.19.4530",
      "rawHtsCode": "2710.19.45.30",
      "superior": null,
      "indent": "6",
      "description": "Medicinal grade",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.4540",
      "rawHtsCode": "2710.19.45.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.4545",
      "rawHtsCode": "2710.19.45.45",
      "superior": null,
      "indent": "5",
      "description": "Insulating or transformer oils",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.4590",
      "rawHtsCode": "2710.19.45.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.19.9000",
      "rawHtsCode": "2710.19.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "liters"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.20",
      "rawHtsCode": "2710.20",
      "superior": null,
      "indent": "1",
      "description": "Petroleum oils and oils obtained from bituminous minerals (other than crude) and preparations not elsewhere specified or included containing by weight 70 percent or more of petroleum oils or of oils obtained from bituminous minerals, these oils being the basic constituents of the preparations, containing biodiesel, other than waste oils:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.05",
      "rawHtsCode": "2710.20.05",
      "superior": null,
      "indent": "3",
      "description": "Testing under 25 degrees A.P.I.",
      "units": [],
      "generalRate": "5.25¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.20.0510",
      "rawHtsCode": "2710.20.05.10",
      "superior": null,
      "indent": "4",
      "description": "Having a Saybolt Universal viscosity at 37.8˚C of 45 seconds or more but not more than 125 seconds (No. 4-type fuel oils)",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.0520",
      "rawHtsCode": "2710.20.05.20",
      "superior": null,
      "indent": "4",
      "description": "Having a Saybolt Universal viscosity at 37.8˚C of more than 125 seconds (heavy fuel oils)",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.0550",
      "rawHtsCode": "2710.20.05.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.10",
      "rawHtsCode": "2710.20.10",
      "superior": null,
      "indent": "3",
      "description": "Testing 25 degrees A.P.I. or more",
      "units": [],
      "generalRate": "10.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.20.1002",
      "rawHtsCode": "2710.20.10.02",
      "superior": null,
      "indent": "7",
      "description": "Containing not more than 15 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.1003",
      "rawHtsCode": "2710.20.10.03",
      "superior": null,
      "indent": "7",
      "description": "Containing more than 15 ppm but not more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.1004",
      "rawHtsCode": "2710.20.10.04",
      "superior": null,
      "indent": "7",
      "description": "Containing more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.1005",
      "rawHtsCode": "2710.20.10.05",
      "superior": null,
      "indent": "7",
      "description": "Containing not more than 15 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.1007",
      "rawHtsCode": "2710.20.10.07",
      "superior": null,
      "indent": "7",
      "description": "Containing more than 15 ppm but not more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.1008",
      "rawHtsCode": "2710.20.10.08",
      "superior": null,
      "indent": "7",
      "description": "Containing more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.1011",
      "rawHtsCode": "2710.20.10.11",
      "superior": null,
      "indent": "6",
      "description": "Containing not more than 15 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.1013",
      "rawHtsCode": "2710.20.10.13",
      "superior": null,
      "indent": "6",
      "description": "Containing more than 15 ppm but not more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.1014",
      "rawHtsCode": "2710.20.10.14",
      "superior": null,
      "indent": "6",
      "description": "Containing more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.1015",
      "rawHtsCode": "2710.20.10.15",
      "superior": null,
      "indent": "5",
      "description": "Containing not more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.1025",
      "rawHtsCode": "2710.20.10.25",
      "superior": null,
      "indent": "5",
      "description": "Containing more than 500 ppm of sulfur",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.1050",
      "rawHtsCode": "2710.20.10.50",
      "superior": null,
      "indent": "4",
      "description": "Having a Saybolt Universal viscosity at 37.8˚C of more than 125 seconds (heavy fuel oils)",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.20.1500",
      "rawHtsCode": "2710.20.15.00",
      "superior": null,
      "indent": "2",
      "description": "Kerosene-type jet fuel, motor fuel or motor fuel blending stock",
      "units": [
        "bbl"
      ],
      "generalRate": "52.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.05/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.20.2500",
      "rawHtsCode": "2710.20.25.00",
      "superior": null,
      "indent": "2",
      "description": "Kerosene (except kerosene-type jet fuel, motor fuel or motor fuel blending stock)",
      "units": [
        "bbl"
      ],
      "generalRate": "10.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, IL,JO, KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.91.00",
      "rawHtsCode": "2710.91.00",
      "superior": null,
      "indent": "2",
      "description": "Containing polychlorinated biphenyls (PCBs), polychlorinated terphenyls (PCTs) or polybrominated biphenyls (PBBs)",
      "units": [],
      "generalRate": "10.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.91.0010",
      "rawHtsCode": "2710.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Containing polychlorinated biphenyls (PCBs) at a concentration level of 50 mg/kg or more",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.91.0050",
      "rawHtsCode": "2710.91.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other, containing polychlorinated terphenyls (PCTs) or polybrominated biphenyls (PBBs), whether or not also containing polychlorinated biphenyls (PCBs) at a concentration level of less than 50 mg/kg",
      "units": [
        "bbl"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.99",
      "rawHtsCode": "2710.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2710.99.0500",
      "rawHtsCode": "2710.99.05.00",
      "superior": null,
      "indent": "4",
      "description": "Testing under 25 degrees A.P.I.",
      "units": [
        "bbl"
      ],
      "generalRate": "5.25¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.99.1000",
      "rawHtsCode": "2710.99.10.00",
      "superior": null,
      "indent": "4",
      "description": "Testing 25 degrees A.P.I. or more",
      "units": [
        "bbl"
      ],
      "generalRate": "10.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.99.1600",
      "rawHtsCode": "2710.99.16.00",
      "superior": null,
      "indent": "3",
      "description": "Wastes of motor fuel or of motor fuel blending stock",
      "units": [
        "bbl"
      ],
      "generalRate": "52.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$1.05/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.99.2100",
      "rawHtsCode": "2710.99.21.00",
      "superior": null,
      "indent": "3",
      "description": "Wastes of kerosene or naphthas",
      "units": [
        "bbl"
      ],
      "generalRate": "10.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.99.3100",
      "rawHtsCode": "2710.99.31.00",
      "superior": null,
      "indent": "4",
      "description": "Of oils",
      "units": [
        "bbl"
      ],
      "generalRate": "84¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$1.68/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.99.3200",
      "rawHtsCode": "2710.99.32.00",
      "superior": null,
      "indent": "5",
      "description": "Containing not over 10 percent by weight of salts of fatty acids of animal (including marine animal) or vegetable origin",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.99.3900",
      "rawHtsCode": "2710.99.39.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.3¢/kg + 5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "4.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.99.4500",
      "rawHtsCode": "2710.99.45.00",
      "superior": null,
      "indent": "4",
      "description": "Mixtures of hydrocarbons not elsewhere specified or included, which contain not over 50 percent of any single hydrocarbon compound",
      "units": [
        "bbl"
      ],
      "generalRate": "10.5¢/bbl",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "21¢/bbl",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2710.99.9000",
      "rawHtsCode": "2710.99.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "liters"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2711",
      "rawHtsCode": "2711",
      "superior": null,
      "indent": "0",
      "description": "Petroleum gases and other gaseous hydrocarbons:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.11.0000",
      "rawHtsCode": "2711.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Natural gas",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2711.12.00",
      "rawHtsCode": "2711.12.00",
      "superior": null,
      "indent": "2",
      "description": "Propane",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2711.12.0010",
      "rawHtsCode": "2711.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Propane with a minimum purity of 90 liquid volume percent",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.12.0020",
      "rawHtsCode": "2711.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.13.00",
      "rawHtsCode": "2711.13.00",
      "superior": null,
      "indent": "2",
      "description": "Butanes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2711.13.0010",
      "rawHtsCode": "2711.13.00.10",
      "superior": null,
      "indent": "3",
      "description": "Butanes with a purity of 90 liquid volume percent or more, but less than 95 liquid volume percent",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.13.0020",
      "rawHtsCode": "2711.13.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.14.00",
      "rawHtsCode": "2711.14.00",
      "superior": null,
      "indent": "2",
      "description": "Ethylene, propylene, butylene and butadiene",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2711.14.0010",
      "rawHtsCode": "2711.14.00.10",
      "superior": null,
      "indent": "3",
      "description": "Ethylene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.14.0020",
      "rawHtsCode": "2711.14.00.20",
      "superior": null,
      "indent": "3",
      "description": "Propylene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.14.0030",
      "rawHtsCode": "2711.14.00.30",
      "superior": null,
      "indent": "3",
      "description": "Butylene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.14.0040",
      "rawHtsCode": "2711.14.00.40",
      "superior": null,
      "indent": "3",
      "description": "Butadiene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.19.00",
      "rawHtsCode": "2711.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2711.19.0010",
      "rawHtsCode": "2711.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Ethane",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.19.0020",
      "rawHtsCode": "2711.19.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.21.0000",
      "rawHtsCode": "2711.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Natural gas",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2711.29.00",
      "rawHtsCode": "2711.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2711.29.0010",
      "rawHtsCode": "2711.29.00.10",
      "superior": null,
      "indent": "4",
      "description": "Propane with a minimum purity of 90 liquid volume percent",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.29.0015",
      "rawHtsCode": "2711.29.00.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.29.0020",
      "rawHtsCode": "2711.29.00.20",
      "superior": null,
      "indent": "4",
      "description": "Butanes with a purity of 90 liquid volume percent or more, but less than 95 liquid volume percent",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.29.0025",
      "rawHtsCode": "2711.29.00.25",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2711.29.0060",
      "rawHtsCode": "2711.29.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2712",
      "rawHtsCode": "2712",
      "superior": null,
      "indent": "0",
      "description": "Petroleum jelly; paraffin wax, microcrystalline petroleum wax, slack wax, ozokerite, lignite wax, peat wax, other mineral waxes and similar products obtained by synthesis or by other processes, whether or not colored:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2712.10.0000",
      "rawHtsCode": "2712.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Petroleum jelly",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2712.20.0000",
      "rawHtsCode": "2712.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Paraffin wax containing by weight less than 0.75 percent of oil",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2712.90",
      "rawHtsCode": "2712.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2712.90.1000",
      "rawHtsCode": "2712.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Montan wax",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2712.90.2000",
      "rawHtsCode": "2712.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2713",
      "rawHtsCode": "2713",
      "superior": null,
      "indent": "0",
      "description": "Petroleum coke, petroleum bitumen and other residues of petroleum oils or of oils obtained from bituminous minerals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2713.11.0000",
      "rawHtsCode": "2713.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not calcined",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2713.12.0000",
      "rawHtsCode": "2713.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Calcined",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2713.20.0000",
      "rawHtsCode": "2713.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Petroleum bitumen",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2713.90.0000",
      "rawHtsCode": "2713.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other residues of petroleum oils or of oils obtained from bituminous materials",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2714",
      "rawHtsCode": "2714",
      "superior": null,
      "indent": "0",
      "description": "Bitumen and asphalt, natural; bituminous or oil shale and tar sands; asphaltites and asphaltic rocks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2714.10.0000",
      "rawHtsCode": "2714.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Bituminous or oil shale and tar sands",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2714.90.0000",
      "rawHtsCode": "2714.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2715.00.0000",
      "rawHtsCode": "2715.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Bituminous mixtures based on natural asphalt, on natural bitumen, on petroleum bitumen, on mineral tar or on mineral tar pitch (for example, bituminous mastics, cut-backs)",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2716.00.0000",
      "rawHtsCode": "2716.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Electrical energy",
      "units": [
        "MWh"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2801",
      "rawHtsCode": "2801",
      "superior": null,
      "indent": "0",
      "description": "Fluorine, chlorine, bromine and iodine:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2801.10.0000",
      "rawHtsCode": "2801.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Chlorine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2801.20.0000",
      "rawHtsCode": "2801.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Iodine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2801.30",
      "rawHtsCode": "2801.30",
      "superior": null,
      "indent": "1",
      "description": "Fluorine; bromine:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2801.30.1000",
      "rawHtsCode": "2801.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fluorine",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2801.30.2000",
      "rawHtsCode": "2801.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Bromine",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S, SG)",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2802.00.0000",
      "rawHtsCode": "2802.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Sulfur, sublimed or precipitated; colloidal sulfur",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2803.00.00",
      "rawHtsCode": "2803.00.00",
      "superior": null,
      "indent": "0",
      "description": "Carbon (carbon blacks and other forms of carbon not elsewhere specified or included)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2803.00.0010",
      "rawHtsCode": "2803.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Carbon black",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2803.00.0050",
      "rawHtsCode": "2803.00.00.50",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2804",
      "rawHtsCode": "2804",
      "superior": null,
      "indent": "0",
      "description": "Hydrogen, rare gases and other nonmetals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2804.10.0000",
      "rawHtsCode": "2804.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hydrogen",
      "units": [
        "thousand m<sup>3</sup>"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2804.21.0000",
      "rawHtsCode": "2804.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Argon",
      "units": [
        "thousand m<sup>3</sup>"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2804.29.00",
      "rawHtsCode": "2804.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2804.29.0010",
      "rawHtsCode": "2804.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Helium",
      "units": [
        "thousand m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2804.29.0020",
      "rawHtsCode": "2804.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Neon",
      "units": [
        "thousand m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2804.29.0030",
      "rawHtsCode": "2804.29.00.30",
      "superior": null,
      "indent": "3",
      "description": "Isotopically pure rare gases having a purity of 99 percent or more by volume",
      "units": [
        "thousand m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2804.29.0055",
      "rawHtsCode": "2804.29.00.55",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "thousand m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2804.30.0000",
      "rawHtsCode": "2804.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Nitrogen",
      "units": [
        "thousand m<sup>3</sup>"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2804.40.0000",
      "rawHtsCode": "2804.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Oxygen",
      "units": [
        "thousand m<sup>3</sup>"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2804.50.00",
      "rawHtsCode": "2804.50.00",
      "superior": null,
      "indent": "1",
      "description": "Boron; tellurium",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2804.50.0010",
      "rawHtsCode": "2804.50.00.10",
      "superior": null,
      "indent": "2",
      "description": "Boron",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2804.50.0020",
      "rawHtsCode": "2804.50.00.20",
      "superior": null,
      "indent": "2",
      "description": "Tellurium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2804.61.0000",
      "rawHtsCode": "2804.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight not less than 99.99 percent of silicon",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "2804.69",
      "rawHtsCode": "2804.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2804.69.1000",
      "rawHtsCode": "2804.69.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight less than 99.99 percent but not less than 99 percent of silicon",
      "units": [
        "kg",
        "Si kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "21%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2804.69.5000",
      "rawHtsCode": "2804.69.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "Si kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2804.70.0000",
      "rawHtsCode": "2804.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Phosphorus",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "17.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2804.80.0000",
      "rawHtsCode": "2804.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Arsenic",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "13.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2804.90.0000",
      "rawHtsCode": "2804.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Selenium",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "2805",
      "rawHtsCode": "2805",
      "superior": null,
      "indent": "0",
      "description": "Alkali or alkaline-earth metals; rare-earth metals, scandium and yttrium, whether or not intermixed or interalloyed; mercury:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2805.11.0000",
      "rawHtsCode": "2805.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sodium",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2805.12.0000",
      "rawHtsCode": "2805.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Calcium",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2805.19",
      "rawHtsCode": "2805.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2805.19.1000",
      "rawHtsCode": "2805.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Strontium",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2805.19.2000",
      "rawHtsCode": "2805.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Barium",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2805.19.90",
      "rawHtsCode": "2805.19.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2805.19.9010",
      "rawHtsCode": "2805.19.90.10",
      "superior": null,
      "indent": "4",
      "description": "Lithium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2805.19.9090",
      "rawHtsCode": "2805.19.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2805.30.00",
      "rawHtsCode": "2805.30.00",
      "superior": null,
      "indent": "1",
      "description": "Rare-earth metals, scandium and yttrium, whether or not intermixed or interalloyed",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "31.3%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2805.30.0005",
      "rawHtsCode": "2805.30.00.05",
      "superior": null,
      "indent": "3",
      "description": "Lanthanum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2805.30.0010",
      "rawHtsCode": "2805.30.00.10",
      "superior": null,
      "indent": "3",
      "description": "Cerium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2805.30.0015",
      "rawHtsCode": "2805.30.00.15",
      "superior": null,
      "indent": "3",
      "description": "Praseodymium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2805.30.0020",
      "rawHtsCode": "2805.30.00.20",
      "superior": null,
      "indent": "3",
      "description": "Neodymium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2805.30.0050",
      "rawHtsCode": "2805.30.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2805.30.0090",
      "rawHtsCode": "2805.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2805.40.0000",
      "rawHtsCode": "2805.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mercury",
      "units": [
        "kg"
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2806",
      "rawHtsCode": "2806",
      "superior": null,
      "indent": "0",
      "description": "Hydrogen chloride (Hydrochloric acid); chlorosulfuric acid:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2806.10.0000",
      "rawHtsCode": "2806.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hydrogen chloride (Hydrochloric acid)",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2806.20.0000",
      "rawHtsCode": "2806.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Chlorosulfuric acid",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2807.00.0000",
      "rawHtsCode": "2807.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Sulfuric acid; oleum",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2808.00.00",
      "rawHtsCode": "2808.00.00",
      "superior": null,
      "indent": "0",
      "description": "Nitric acid; sulfonitric acids",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2808.00.0010",
      "rawHtsCode": "2808.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Nitric acid",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2808.00.0020",
      "rawHtsCode": "2808.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Sulfonitric acids",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2809",
      "rawHtsCode": "2809",
      "superior": null,
      "indent": "0",
      "description": "Diphosphorus pentaoxide; phosphoric acid;polyphosphoric acids, whether or not chemically defined:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2809.10.0000",
      "rawHtsCode": "2809.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Diphosphorus pentaoxide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2809.20.00",
      "rawHtsCode": "2809.20.00",
      "superior": null,
      "indent": "1",
      "description": "Phosphoric acid and polyphosphoric acids",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2809.20.0010",
      "rawHtsCode": "2809.20.00.10",
      "superior": null,
      "indent": "4",
      "description": "Containing less than 65 percent available diphosphorus pentaoxide (P<sub>2</sub>O<sub>5</sub>) equivalents",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2809.20.0020",
      "rawHtsCode": "2809.20.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2809.20.0030",
      "rawHtsCode": "2809.20.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2809.20.0040",
      "rawHtsCode": "2809.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Polyphosphoric acids",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2810.00.0000",
      "rawHtsCode": "2810.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Oxides of boron; boric acids",
      "units": [
        "t"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2811",
      "rawHtsCode": "2811",
      "superior": null,
      "indent": "0",
      "description": "Other inorganic acids and other inorganic oxygen compounds of nonmetals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2811.11.0000",
      "rawHtsCode": "2811.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Hydrogen fluoride (Hydrofluoric acid)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2811.12.0000",
      "rawHtsCode": "2811.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Hydrogen cyanide (hydrocyanic acid)",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2811.19",
      "rawHtsCode": "2811.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2811.19.1000",
      "rawHtsCode": "2811.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Arsenic acid",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2811.19.3000",
      "rawHtsCode": "2811.19.30.00",
      "superior": null,
      "indent": "3",
      "description": "Hydrobromic acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2811.19.61",
      "rawHtsCode": "2811.19.61",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2811.19.6110",
      "rawHtsCode": "2811.19.61.10",
      "superior": null,
      "indent": "4",
      "description": "Sulfamic acid",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2811.19.6190",
      "rawHtsCode": "2811.19.61.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2811.21.0000",
      "rawHtsCode": "2811.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Carbon dioxide",
      "units": [
        "t"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2811.22",
      "rawHtsCode": "2811.22",
      "superior": null,
      "indent": "2",
      "description": "Silicon dioxide:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2811.22.1000",
      "rawHtsCode": "2811.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Synthetic silica gel",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2811.22.5000",
      "rawHtsCode": "2811.22.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2811.29",
      "rawHtsCode": "2811.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2811.29.1000",
      "rawHtsCode": "2811.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Arsenic trioxide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2811.29.2000",
      "rawHtsCode": "2811.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Selenium dioxide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2811.29.3000",
      "rawHtsCode": "2811.29.30.00",
      "superior": null,
      "indent": "3",
      "description": "Sulfur dioxide",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2811.29.5000",
      "rawHtsCode": "2811.29.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2812",
      "rawHtsCode": "2812",
      "superior": null,
      "indent": "0",
      "description": "Halides and halide oxides of nonmetals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2812.11.0000",
      "rawHtsCode": "2812.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Carbonyl dichloride (phosgene)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2812.12.0000",
      "rawHtsCode": "2812.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Phosphorous oxychloride",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2812.13.0000",
      "rawHtsCode": "2812.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Phosphorous trichloride",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2812.14.0000",
      "rawHtsCode": "2812.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Phosphorous pentachloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2812.15.0000",
      "rawHtsCode": "2812.15.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sulfur monochloride",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2812.16.0000",
      "rawHtsCode": "2812.16.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sulfur dichloride",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2812.17.0000",
      "rawHtsCode": "2812.17.00.00",
      "superior": null,
      "indent": "2",
      "description": "Thionyl chloride",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2812.19.00",
      "rawHtsCode": "2812.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2812.19.0010",
      "rawHtsCode": "2812.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Arsenic trichloride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2812.19.0090",
      "rawHtsCode": "2812.19.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2812.90.00",
      "rawHtsCode": "2812.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2812.90.0010",
      "rawHtsCode": "2812.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Sulfur hexafluoride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2812.90.0090",
      "rawHtsCode": "2812.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2813",
      "rawHtsCode": "2813",
      "superior": null,
      "indent": "0",
      "description": "Sulfides of nonmetals; commercial phosphorus trisulfide:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2813.10.0000",
      "rawHtsCode": "2813.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Carbon disulfide",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2813.90",
      "rawHtsCode": "2813.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2813.90.1000",
      "rawHtsCode": "2813.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of arsenic",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2813.90.2000",
      "rawHtsCode": "2813.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of phosphorus",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2813.90.5000",
      "rawHtsCode": "2813.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2814",
      "rawHtsCode": "2814",
      "superior": null,
      "indent": "0",
      "description": "Ammonia, anhydrous or in aqueous solution:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2814.10.0000",
      "rawHtsCode": "2814.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Anhydrous ammonia",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2814.20.0000",
      "rawHtsCode": "2814.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ammonia in aqueous solution",
      "units": [
        "t",
        "NH<sub>3</sub> t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2815",
      "rawHtsCode": "2815",
      "superior": null,
      "indent": "0",
      "description": "Sodium hydroxide (Caustic soda); potassium hydroxide (Caustic potash); peroxides of sodium or potassium:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2815.11.0000",
      "rawHtsCode": "2815.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Solid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2815.12.0000",
      "rawHtsCode": "2815.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "In aqueous solution (Soda lye or liquid soda)",
      "units": [
        "kg",
        "NaOH kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2815.20.00",
      "rawHtsCode": "2815.20.00",
      "superior": null,
      "indent": "1",
      "description": "Potassium hydroxide (Caustic potash)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2815.20.0050",
      "rawHtsCode": "2815.20.00.50",
      "superior": null,
      "indent": "2",
      "description": "In solid form",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2815.20.0090",
      "rawHtsCode": "2815.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2815.30.0000",
      "rawHtsCode": "2815.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Peroxides of sodium or potassium",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2816",
      "rawHtsCode": "2816",
      "superior": null,
      "indent": "0",
      "description": "Hydroxide and peroxide of magnesium; oxides, hydroxides and peroxides, of strontium or barium:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2816.10.0000",
      "rawHtsCode": "2816.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hydroxide and peroxide of magnesium",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2816.40",
      "rawHtsCode": "2816.40",
      "superior": null,
      "indent": "1",
      "description": "Oxides, hydroxides and peroxides, of strontium or barium:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2816.40.1000",
      "rawHtsCode": "2816.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of strontium",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2816.40.2000",
      "rawHtsCode": "2816.40.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of barium",
      "units": [
        "kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2817.00.0000",
      "rawHtsCode": "2817.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Zinc oxide; zinc peroxide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2818",
      "rawHtsCode": "2818",
      "superior": null,
      "indent": "0",
      "description": "Artificial corundum, whether or not chemically defined; aluminum oxide; aluminum hydroxide:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2818.10",
      "rawHtsCode": "2818.10",
      "superior": null,
      "indent": "1",
      "description": "Artificial corundum, whether or not chemically defined:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2818.10.1000",
      "rawHtsCode": "2818.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Crude",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2818.10.20",
      "rawHtsCode": "2818.10.20",
      "superior": null,
      "indent": "2",
      "description": "In grains, or ground, pulverized or refined",
      "units": [],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2818.10.2010",
      "rawHtsCode": "2818.10.20.10",
      "superior": null,
      "indent": "3",
      "description": "White, pink or ruby, containing more than 97.5 percent by weight of aluminum oxide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2818.10.2090",
      "rawHtsCode": "2818.10.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2818.20.0000",
      "rawHtsCode": "2818.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Aluminum oxide, other than artificial corundum",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2818.30.0000",
      "rawHtsCode": "2818.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Aluminum hydroxide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2819",
      "rawHtsCode": "2819",
      "superior": null,
      "indent": "0",
      "description": "Chromium oxides and hydroxides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2819.10.0000",
      "rawHtsCode": "2819.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Chromium trioxide",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2819.90.0000",
      "rawHtsCode": "2819.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2820",
      "rawHtsCode": "2820",
      "superior": null,
      "indent": "0",
      "description": "Manganese oxides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2820.10.0000",
      "rawHtsCode": "2820.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Manganese dioxide",
      "units": [
        "kg"
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2820.90.0000",
      "rawHtsCode": "2820.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2821",
      "rawHtsCode": "2821",
      "superior": null,
      "indent": "0",
      "description": "Iron oxides and hydroxides; earth colors containing 70 percent or more by weight of combined iron evaluated as Fe<sub>2</sub>O<sub>3</sub>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2821.10.00",
      "rawHtsCode": "2821.10.00",
      "superior": null,
      "indent": "1",
      "description": "Iron oxides and hydroxides",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2821.10.0010",
      "rawHtsCode": "2821.10.00.10",
      "superior": null,
      "indent": "3",
      "description": "Black",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2821.10.0020",
      "rawHtsCode": "2821.10.00.20",
      "superior": null,
      "indent": "3",
      "description": "Red",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2821.10.0030",
      "rawHtsCode": "2821.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "Yellow",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2821.10.0040",
      "rawHtsCode": "2821.10.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2821.10.0050",
      "rawHtsCode": "2821.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2821.20.0000",
      "rawHtsCode": "2821.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Earth colors",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2822.00.00",
      "rawHtsCode": "2822.00.00",
      "superior": null,
      "indent": "0",
      "description": "Cobalt oxides and hydroxides; commercial cobalt oxides",
      "units": [],
      "generalRate": "0.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2822.00.0010",
      "rawHtsCode": "2822.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Cobalt(II, III) oxide (cobalt tetroxide)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2822.00.0090",
      "rawHtsCode": "2822.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2823.00.0000",
      "rawHtsCode": "2823.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Titanium oxides",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2824",
      "rawHtsCode": "2824",
      "superior": null,
      "indent": "0",
      "description": "Lead oxides; red lead and orange lead:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2824.10.0000",
      "rawHtsCode": "2824.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Lead monoxide (litharge, massicot)",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2824.90",
      "rawHtsCode": "2824.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2824.90.1000",
      "rawHtsCode": "2824.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Lead suboxide (leady litharge)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2824.90.2000",
      "rawHtsCode": "2824.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Red lead and orange lead",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2824.90.5000",
      "rawHtsCode": "2824.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825",
      "rawHtsCode": "2825",
      "superior": null,
      "indent": "0",
      "description": "Hydrazine and hydroxylamine and their inorganic salts; other inorganic bases; other metal oxides, hydroxides and peroxides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2825.10.0000",
      "rawHtsCode": "2825.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hydrazine and hydroxylamine and their inorganic salts",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825.20.0000",
      "rawHtsCode": "2825.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Lithium oxide and hydroxide",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825.30.00",
      "rawHtsCode": "2825.30.00",
      "superior": null,
      "indent": "1",
      "description": "Vanadium oxides and hydroxides",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825.30.0010",
      "rawHtsCode": "2825.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Vanadium pentoxide (anhydride)",
      "units": [
        "kg",
        "V kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2825.30.0050",
      "rawHtsCode": "2825.30.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg",
        "V kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2825.40.0000",
      "rawHtsCode": "2825.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Nickel oxides and hydroxides",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2825.50",
      "rawHtsCode": "2825.50",
      "superior": null,
      "indent": "1",
      "description": "Copper oxides and hydroxides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2825.50.1000",
      "rawHtsCode": "2825.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Cupric oxide",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825.50.2000",
      "rawHtsCode": "2825.50.20.00",
      "superior": null,
      "indent": "2",
      "description": "Cuprous oxide",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825.50.3000",
      "rawHtsCode": "2825.50.30.00",
      "superior": null,
      "indent": "2",
      "description": "Copper hydroxides",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "32.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825.60.00",
      "rawHtsCode": "2825.60.00",
      "superior": null,
      "indent": "1",
      "description": "Germanium oxides and zirconium dioxide",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825.60.0010",
      "rawHtsCode": "2825.60.00.10",
      "superior": null,
      "indent": "2",
      "description": "Germanium dioxide",
      "units": [
        "kg"
      ],
      "generalRate": " ",
      "specialRate": " ",
      "otherRate": " ",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2825.60.0020",
      "rawHtsCode": "2825.60.00.20",
      "superior": null,
      "indent": "2",
      "description": "Zirconium dioxide ",
      "units": [
        "kg"
      ],
      "generalRate": " ",
      "specialRate": " ",
      "otherRate": " ",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2825.60.0050",
      "rawHtsCode": "2825.60.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": " ",
      "specialRate": " ",
      "otherRate": " ",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2825.70.0000",
      "rawHtsCode": "2825.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Molybdenum oxides and hydroxides",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825.80.0000",
      "rawHtsCode": "2825.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Antimony oxides",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2825.90",
      "rawHtsCode": "2825.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2825.90.1000",
      "rawHtsCode": "2825.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Beryllium oxide and hydroxide",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825.90.1500",
      "rawHtsCode": "2825.90.15.00",
      "superior": null,
      "indent": "2",
      "description": "Niobium oxide",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825.90.2000",
      "rawHtsCode": "2825.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Tin oxides",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825.90.3000",
      "rawHtsCode": "2825.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Tungsten oxides",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P, PA,PE,S,SG)",
      "otherRate": "45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2825.90.7500",
      "rawHtsCode": "2825.90.75.00",
      "superior": null,
      "indent": "2",
      "description": "Cadmium oxide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2825.90.9000",
      "rawHtsCode": "2825.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2826",
      "rawHtsCode": "2826",
      "superior": null,
      "indent": "0",
      "description": "Fluorides; fluorosilicates, fluoroaluminates and other complex fluorine salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2826.12.0000",
      "rawHtsCode": "2826.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of aluminum",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2826.19",
      "rawHtsCode": "2826.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2826.19.1000",
      "rawHtsCode": "2826.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of ammonium",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2826.19.2000",
      "rawHtsCode": "2826.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of sodium",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2826.19.9000",
      "rawHtsCode": "2826.19.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2826.30.0000",
      "rawHtsCode": "2826.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sodium hexafluoroaluminate (Synthetic cryolite)",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2826.90",
      "rawHtsCode": "2826.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2826.90.1000",
      "rawHtsCode": "2826.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fluorosilicates of sodium or of potassium",
      "units": [
        "kg"
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "62.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2826.90.90",
      "rawHtsCode": "2826.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2826.90.9010",
      "rawHtsCode": "2826.90.90.10",
      "superior": null,
      "indent": "4",
      "description": "Lithium hexafluorophosphate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2826.90.9090",
      "rawHtsCode": "2826.90.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2827",
      "rawHtsCode": "2827",
      "superior": null,
      "indent": "0",
      "description": "Chlorides, chloride oxides and chloride hydroxides; bromides and bromide oxides; iodides and iodide oxides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2827.10.0000",
      "rawHtsCode": "2827.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ammonium chloride",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.20.0000",
      "rawHtsCode": "2827.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Calcium chloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2827.31.0000",
      "rawHtsCode": "2827.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of magnesium",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.32.0000",
      "rawHtsCode": "2827.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of aluminum",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2827.35.0000",
      "rawHtsCode": "2827.35.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.39",
      "rawHtsCode": "2827.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2827.39.1000",
      "rawHtsCode": "2827.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of vanadium",
      "units": [
        "kg",
        "V kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.39.2500",
      "rawHtsCode": "2827.39.25.00",
      "superior": null,
      "indent": "3",
      "description": "Of tin",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.39.3000",
      "rawHtsCode": "2827.39.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of titanium",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.39.4000",
      "rawHtsCode": "2827.39.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of tungsten",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P, PA,PE,S,SG)",
      "otherRate": "45.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.39.4500",
      "rawHtsCode": "2827.39.45.00",
      "superior": null,
      "indent": "3",
      "description": "Of barium",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "28.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.39.5500",
      "rawHtsCode": "2827.39.55.00",
      "superior": null,
      "indent": "3",
      "description": "Of iron",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.39.6000",
      "rawHtsCode": "2827.39.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of cobalt",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.39.6500",
      "rawHtsCode": "2827.39.65.00",
      "superior": null,
      "indent": "3",
      "description": "Of zinc",
      "units": [
        "kg"
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.39.90",
      "rawHtsCode": "2827.39.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.39.9010",
      "rawHtsCode": "2827.39.90.10",
      "superior": null,
      "indent": "4",
      "description": "Of lithium",
      "units": [
        "kg"
      ],
      "generalRate": " ",
      "specialRate": " ",
      "otherRate": " ",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2827.39.9050",
      "rawHtsCode": "2827.39.90.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": " ",
      "specialRate": " ",
      "otherRate": " ",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2827.41.0000",
      "rawHtsCode": "2827.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of copper",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "32.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.49",
      "rawHtsCode": "2827.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2827.49.1000",
      "rawHtsCode": "2827.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of vanadium",
      "units": [
        "kg",
        "V kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.49.5000",
      "rawHtsCode": "2827.49.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.51.0000",
      "rawHtsCode": "2827.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Bromides of sodium or of potassium",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2827.59",
      "rawHtsCode": "2827.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2827.59.2500",
      "rawHtsCode": "2827.59.25.00",
      "superior": null,
      "indent": "3",
      "description": "Of ammonium, of calcium or of zinc",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2827.59.5100",
      "rawHtsCode": "2827.59.51.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.60",
      "rawHtsCode": "2827.60",
      "superior": null,
      "indent": "1",
      "description": "Iodides and iodide oxides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2827.60.1000",
      "rawHtsCode": "2827.60.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of calcium or of copper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2827.60.2000",
      "rawHtsCode": "2827.60.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of potassium",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2827.60.5100",
      "rawHtsCode": "2827.60.51.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2828",
      "rawHtsCode": "2828",
      "superior": null,
      "indent": "0",
      "description": "Hypochlorites; commercial calcium hypochlorite; chlorites; hypobromites:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2828.10.0000",
      "rawHtsCode": "2828.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Commercial calcium hypochlorite and other calcium hypochlorites",
      "units": [
        "kg"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2828.90.0000",
      "rawHtsCode": "2828.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2829",
      "rawHtsCode": "2829",
      "superior": null,
      "indent": "0",
      "description": "Chlorates and perchlorates; bromates and perbromates; iodates and periodates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2829.11.0000",
      "rawHtsCode": "2829.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of sodium",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "13%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2829.19.0100",
      "rawHtsCode": "2829.19.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2829.90",
      "rawHtsCode": "2829.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2829.90.0500",
      "rawHtsCode": "2829.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "Potassium bromate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2829.90.2500",
      "rawHtsCode": "2829.90.25.00",
      "superior": null,
      "indent": "2",
      "description": "Sodium bromate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2829.90.4000",
      "rawHtsCode": "2829.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of potassium",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2829.90.6100",
      "rawHtsCode": "2829.90.61.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2830",
      "rawHtsCode": "2830",
      "superior": null,
      "indent": "0",
      "description": "Sulfides; polysulfides, whether or not chemically defined:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2830.10.0000",
      "rawHtsCode": "2830.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sodium sulfides",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2830.90",
      "rawHtsCode": "2830.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2830.90.1000",
      "rawHtsCode": "2830.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Zinc sulfide, luminescent grade having a purity of 99.99 percent or more by weight",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2830.90.1500",
      "rawHtsCode": "2830.90.15.00",
      "superior": null,
      "indent": "2",
      "description": "Other zinc sulfide",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2830.90.2000",
      "rawHtsCode": "2830.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Cadmium sulfide",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2830.90.9000",
      "rawHtsCode": "2830.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2831",
      "rawHtsCode": "2831",
      "superior": null,
      "indent": "0",
      "description": "Dithionites and sulfoxylates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2831.10",
      "rawHtsCode": "2831.10",
      "superior": null,
      "indent": "1",
      "description": "Of sodium:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2831.10.1000",
      "rawHtsCode": "2831.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Sodium formaldehyde sulfoxylate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2831.10.5000",
      "rawHtsCode": "2831.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2831.90.0000",
      "rawHtsCode": "2831.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2832",
      "rawHtsCode": "2832",
      "superior": null,
      "indent": "0",
      "description": "Sulfites; thiosulfates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2832.10.0000",
      "rawHtsCode": "2832.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sodium sulfites",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2832.20.0000",
      "rawHtsCode": "2832.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other sulfites",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2832.30",
      "rawHtsCode": "2832.30",
      "superior": null,
      "indent": "1",
      "description": "Thiosulfates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2832.30.1000",
      "rawHtsCode": "2832.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Sodium thiosulfate",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2832.30.5000",
      "rawHtsCode": "2832.30.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833",
      "rawHtsCode": "2833",
      "superior": null,
      "indent": "0",
      "description": "Sulfates; alums; peroxosulfates (persulfates):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2833.11",
      "rawHtsCode": "2833.11",
      "superior": null,
      "indent": "2",
      "description": "Disodium sulfate:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2833.11.1000",
      "rawHtsCode": "2833.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Salt cake",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2833.11.50",
      "rawHtsCode": "2833.11.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "0.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.11.5010",
      "rawHtsCode": "2833.11.50.10",
      "superior": null,
      "indent": "4",
      "description": "Anhydrous",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2833.11.5050",
      "rawHtsCode": "2833.11.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2833.19.0000",
      "rawHtsCode": "2833.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2833.21.0000",
      "rawHtsCode": "2833.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of magnesium",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.22.0000",
      "rawHtsCode": "2833.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of aluminum",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2833.24.0000",
      "rawHtsCode": "2833.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.25.0000",
      "rawHtsCode": "2833.25.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of copper",
      "units": [
        "kg",
        "Cu kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.27.0000",
      "rawHtsCode": "2833.27.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of barium",
      "units": [
        "kg"
      ],
      "generalRate": "0.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.29",
      "rawHtsCode": "2833.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2833.29.1000",
      "rawHtsCode": "2833.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of cobalt",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.29.2000",
      "rawHtsCode": "2833.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of iron",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2833.29.3000",
      "rawHtsCode": "2833.29.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of vanadium",
      "units": [
        "kg",
        "V kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.29.4000",
      "rawHtsCode": "2833.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of chromium",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.29.4500",
      "rawHtsCode": "2833.29.45.00",
      "superior": null,
      "indent": "3",
      "description": "Of zinc",
      "units": [
        "kg"
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.29.51",
      "rawHtsCode": "2833.29.51",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.29.5110",
      "rawHtsCode": "2833.29.51.10",
      "superior": null,
      "indent": "4",
      "description": "Of manganese",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2833.29.5190",
      "rawHtsCode": "2833.29.51.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2833.30.0000",
      "rawHtsCode": "2833.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Alums",
      "units": [
        "kg"
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.40",
      "rawHtsCode": "2833.40",
      "superior": null,
      "indent": "1",
      "description": "Peroxosulfates (persulfates):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2833.40.2000",
      "rawHtsCode": "2833.40.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of sodium",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.40.60",
      "rawHtsCode": "2833.40.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2833.40.6010",
      "rawHtsCode": "2833.40.60.10",
      "superior": null,
      "indent": "3",
      "description": "Of potassium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2833.40.6020",
      "rawHtsCode": "2833.40.60.20",
      "superior": null,
      "indent": "3",
      "description": "Of ammonium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2833.40.6050",
      "rawHtsCode": "2833.40.60.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2834",
      "rawHtsCode": "2834",
      "superior": null,
      "indent": "0",
      "description": "Nitrites; nitrates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2834.10",
      "rawHtsCode": "2834.10",
      "superior": null,
      "indent": "1",
      "description": "Nitrites:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2834.10.1000",
      "rawHtsCode": "2834.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of sodium",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2834.10.5000",
      "rawHtsCode": "2834.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2834.21.0000",
      "rawHtsCode": "2834.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of potassium",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2834.29",
      "rawHtsCode": "2834.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2834.29.0500",
      "rawHtsCode": "2834.29.05.00",
      "superior": null,
      "indent": "3",
      "description": "Of bismuth",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2834.29.1000",
      "rawHtsCode": "2834.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of calcium",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "2834.29.2000",
      "rawHtsCode": "2834.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of strontium",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2834.29.5100",
      "rawHtsCode": "2834.29.51.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2835",
      "rawHtsCode": "2835",
      "superior": null,
      "indent": "0",
      "description": "Phosphinates (hypophosphites), phosphonates (phosphites) and phosphates; polyphosphates, whether or not chemically defined:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2835.10.0000",
      "rawHtsCode": "2835.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Phosphinates (hypophosphites) and phosphonates (phosphites)",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2835.22.0000",
      "rawHtsCode": "2835.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of mono- or disodium",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2835.24.0000",
      "rawHtsCode": "2835.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of potassium",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2835.25.0000",
      "rawHtsCode": "2835.25.00.00",
      "superior": null,
      "indent": "2",
      "description": "Calcium hydrogenorthophosphate (\"Dicalcium phosphate\")",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2835.26.0000",
      "rawHtsCode": "2835.26.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other phosphates of calcium",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2835.29",
      "rawHtsCode": "2835.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2835.29.1000",
      "rawHtsCode": "2835.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of aluminum",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2835.29.2000",
      "rawHtsCode": "2835.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of triammonium",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2835.29.3000",
      "rawHtsCode": "2835.29.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of trisodium",
      "units": [
        "kg"
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2835.29.5100",
      "rawHtsCode": "2835.29.51.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2835.31.0000",
      "rawHtsCode": "2835.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sodium triphosphate (Sodium tripolyphosphate)",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2835.39",
      "rawHtsCode": "2835.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2835.39.1000",
      "rawHtsCode": "2835.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of potassium",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2835.39.5000",
      "rawHtsCode": "2835.39.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2836",
      "rawHtsCode": "2836",
      "superior": null,
      "indent": "0",
      "description": "Carbonates; peroxocarbonates (percarbonates); commercial ammonium carbonate containing ammonium carbamate:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2836.20.0000",
      "rawHtsCode": "2836.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Disodium carbonate",
      "units": [
        "kg"
      ],
      "generalRate": "1.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2836.30.0000",
      "rawHtsCode": "2836.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sodium hydrogencarbonate (Sodium bicarbonate)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2836.40",
      "rawHtsCode": "2836.40",
      "superior": null,
      "indent": "1",
      "description": "Potassium carbonates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2836.40.1000",
      "rawHtsCode": "2836.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Dipotassium carbonate",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2836.40.2000",
      "rawHtsCode": "2836.40.20.00",
      "superior": null,
      "indent": "2",
      "description": "Potassium hydrogencarbonate (Potassium bicarbonate)",
      "units": [
        "kg"
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2836.50.0000",
      "rawHtsCode": "2836.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Calcium carbonate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2836.60.0000",
      "rawHtsCode": "2836.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Barium carbonate",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2836.91.00",
      "rawHtsCode": "2836.91.00",
      "superior": null,
      "indent": "2",
      "description": "Lithium carbonates",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2836.91.0010",
      "rawHtsCode": "2836.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "U.S.P. grade",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2836.91.0050",
      "rawHtsCode": "2836.91.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2836.92.0000",
      "rawHtsCode": "2836.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Strontium carbonate",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2836.99",
      "rawHtsCode": "2836.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2836.99.1000",
      "rawHtsCode": "2836.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cobalt carbonates",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2836.99.2000",
      "rawHtsCode": "2836.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Bismuth carbonate",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2836.99.3000",
      "rawHtsCode": "2836.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "Commercial ammonium carbonate and other ammonium carbonates",
      "units": [
        "kg"
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "16%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2836.99.4000",
      "rawHtsCode": "2836.99.40.00",
      "superior": null,
      "indent": "3",
      "description": "Lead carbonates",
      "units": [
        "kg"
      ],
      "generalRate": "0.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2836.99.50",
      "rawHtsCode": "2836.99.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2836.99.5010",
      "rawHtsCode": "2836.99.50.10",
      "superior": null,
      "indent": "4",
      "description": "Zirconium carbonates",
      "units": [
        "kg"
      ],
      "generalRate": " ",
      "specialRate": " ",
      "otherRate": " ",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2836.99.5050",
      "rawHtsCode": "2836.99.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": " ",
      "specialRate": " ",
      "otherRate": " ",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2837",
      "rawHtsCode": "2837",
      "superior": null,
      "indent": "0",
      "description": "Cyanides, cyanide oxides and complex cyanides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2837.11.0000",
      "rawHtsCode": "2837.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of sodium",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2837.19.01",
      "rawHtsCode": "2837.19.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2837.19.0110",
      "rawHtsCode": "2837.19.01.10",
      "superior": null,
      "indent": "3",
      "description": "Potassium cyanide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2837.19.0115",
      "rawHtsCode": "2837.19.01.15",
      "superior": null,
      "indent": "3",
      "description": "Calcium cyanide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2837.19.0125",
      "rawHtsCode": "2837.19.01.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2837.20",
      "rawHtsCode": "2837.20",
      "superior": null,
      "indent": "1",
      "description": "Complex cyanides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2837.20.1000",
      "rawHtsCode": "2837.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Potassium ferricyanide",
      "units": [
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2837.20.5100",
      "rawHtsCode": "2837.20.51.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2839",
      "rawHtsCode": "2839",
      "superior": null,
      "indent": "0",
      "description": "Silicates; commercial alkali metal silicates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2839.11.0000",
      "rawHtsCode": "2839.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sodium metasilicates",
      "units": [
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2839.19.0000",
      "rawHtsCode": "2839.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2839.90",
      "rawHtsCode": "2839.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2839.90.1000",
      "rawHtsCode": "2839.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of potassium",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2839.90.5000",
      "rawHtsCode": "2839.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2840",
      "rawHtsCode": "2840",
      "superior": null,
      "indent": "0",
      "description": "Borates; peroxoborates (perborates):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2840.11.0000",
      "rawHtsCode": "2840.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Anhydrous",
      "units": [
        "kg"
      ],
      "generalRate": "0.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2840.19.0000",
      "rawHtsCode": "2840.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "0.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2840.20.0000",
      "rawHtsCode": "2840.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other borates",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2840.30.00",
      "rawHtsCode": "2840.30.00",
      "superior": null,
      "indent": "1",
      "description": "Peroxoborates (perborates)",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2840.30.0010",
      "rawHtsCode": "2840.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Sodium perborate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2840.30.0050",
      "rawHtsCode": "2840.30.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2841",
      "rawHtsCode": "2841",
      "superior": null,
      "indent": "0",
      "description": "Salts of oxometallic or peroxometallic acids:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2841.30.0000",
      "rawHtsCode": "2841.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sodium dichromate",
      "units": [
        "kg"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.50",
      "rawHtsCode": "2841.50",
      "superior": null,
      "indent": "1",
      "description": "Other chromates and dichromates; peroxochromates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2841.50.1000",
      "rawHtsCode": "2841.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Potassium dichromate",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.50.9100",
      "rawHtsCode": "2841.50.91.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.61.0000",
      "rawHtsCode": "2841.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Potassium permanganate",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "23%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.69.00",
      "rawHtsCode": "2841.69.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "23%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.69.0010",
      "rawHtsCode": "2841.69.00.10",
      "superior": null,
      "indent": "3",
      "description": "Sodium permanganate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2841.69.0090",
      "rawHtsCode": "2841.69.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2841.70",
      "rawHtsCode": "2841.70",
      "superior": null,
      "indent": "1",
      "description": "Molybdates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2841.70.1000",
      "rawHtsCode": "2841.70.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of ammonium",
      "units": [
        "kg",
        "Mo kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.70.5000",
      "rawHtsCode": "2841.70.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg",
        "Mo kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.80.00",
      "rawHtsCode": "2841.80.00",
      "superior": null,
      "indent": "1",
      "description": "Tungstates (wolframates)",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P, PA,PE,S,SG)",
      "otherRate": "49.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.80.0010",
      "rawHtsCode": "2841.80.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of ammonium",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2841.80.0020",
      "rawHtsCode": "2841.80.00.20",
      "superior": null,
      "indent": "2",
      "description": "Of calcium",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2841.80.0050",
      "rawHtsCode": "2841.80.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2841.90",
      "rawHtsCode": "2841.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2841.90.1000",
      "rawHtsCode": "2841.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Vanadates",
      "units": [
        "kg",
        "V kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.90.2000",
      "rawHtsCode": "2841.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Ammonium perrhenate",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.90.3000",
      "rawHtsCode": "2841.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Potassium stannate",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.90.4000",
      "rawHtsCode": "2841.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Aluminates",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.90.4500",
      "rawHtsCode": "2841.90.45.00",
      "superior": null,
      "indent": "2",
      "description": "Chromates of zinc or of lead",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2841.90.5000",
      "rawHtsCode": "2841.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2842",
      "rawHtsCode": "2842",
      "superior": null,
      "indent": "0",
      "description": "Other salts of inorganic acids or peroxoacids (including aluminosilicates whether or not chemically defined), other than azides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2842.10.0000",
      "rawHtsCode": "2842.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Double or complex silicates, including aluminosilicates whether or not chemically defined",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2842.90",
      "rawHtsCode": "2842.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2842.90.1000",
      "rawHtsCode": "2842.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fulminates, cyanates and thiocyanates",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2842.90.90",
      "rawHtsCode": "2842.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2842.90.9010",
      "rawHtsCode": "2842.90.90.10",
      "superior": null,
      "indent": "3",
      "description": "Selenides and tellurides",
      "units": [
        "kg"
      ],
      "generalRate": " ",
      "specialRate": " ",
      "otherRate": " ",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2842.90.9050",
      "rawHtsCode": "2842.90.90.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": " ",
      "specialRate": " ",
      "otherRate": " ",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2843",
      "rawHtsCode": "2843",
      "superior": null,
      "indent": "0",
      "description": "Colloidal precious metals; inorganic or organic compounds of precious metals, whether or not chemically defined; amalgams of precious metals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2843.10.0000",
      "rawHtsCode": "2843.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Colloidal precious metals",
      "units": [
        "g"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2843.21.0000",
      "rawHtsCode": "2843.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Silver nitrate",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2843.29.0100",
      "rawHtsCode": "2843.29.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2843.30.0000",
      "rawHtsCode": "2843.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Gold compounds",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2843.90.0000",
      "rawHtsCode": "2843.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other compounds; amalgams",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2844",
      "rawHtsCode": "2844",
      "superior": null,
      "indent": "0",
      "description": "Radioactive chemical elements and radioactive isotopes (including the fissile or fertile chemical elements and isotopes) and their compounds; mixtures and residues containing these products:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.10",
      "rawHtsCode": "2844.10",
      "superior": null,
      "indent": "1",
      "description": "Natural uranium and its compounds; alloys, dispersions (including cermets), ceramic products and mixtures containing natural uranium or natural uranium compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.10.1000",
      "rawHtsCode": "2844.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Uranium metal",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2844.10.20",
      "rawHtsCode": "2844.10.20",
      "superior": null,
      "indent": "2",
      "description": "Uranium compounds",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2844.10.2010",
      "rawHtsCode": "2844.10.20.10",
      "superior": null,
      "indent": "3",
      "description": "Oxide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.10.2025",
      "rawHtsCode": "2844.10.20.25",
      "superior": null,
      "indent": "3",
      "description": "Hexafluoride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.10.2055",
      "rawHtsCode": "2844.10.20.55",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.10.5000",
      "rawHtsCode": "2844.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2844.20.00",
      "rawHtsCode": "2844.20.00",
      "superior": null,
      "indent": "1",
      "description": "Uranium enriched in U235 and its compounds; plutonium and its compounds; alloys, dispersions (including cermets), ceramic products and mixtures containing uranium enriched in U235, plutonium or compounds of these products",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2844.20.0010",
      "rawHtsCode": "2844.20.00.10",
      "superior": null,
      "indent": "3",
      "description": "Oxide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.20.0020",
      "rawHtsCode": "2844.20.00.20",
      "superior": null,
      "indent": "3",
      "description": "Fluorides",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.20.0030",
      "rawHtsCode": "2844.20.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.20.0050",
      "rawHtsCode": "2844.20.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.30",
      "rawHtsCode": "2844.30",
      "superior": null,
      "indent": "1",
      "description": "Uranium depleted in U235 and its compounds; thorium and its compounds; alloys, dispersions (including cermets), ceramic products and mixtures containing uranium depleted in U235, thorium, or compounds of these products:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.30.1000",
      "rawHtsCode": "2844.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Thorium compounds",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2844.30.20",
      "rawHtsCode": "2844.30.20",
      "superior": null,
      "indent": "2",
      "description": "Uranium compounds",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.30.2010",
      "rawHtsCode": "2844.30.20.10",
      "superior": null,
      "indent": "3",
      "description": "Oxide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.30.2020",
      "rawHtsCode": "2844.30.20.20",
      "superior": null,
      "indent": "3",
      "description": "Fluorides",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.30.2050",
      "rawHtsCode": "2844.30.20.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.30.50",
      "rawHtsCode": "2844.30.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2844.30.5010",
      "rawHtsCode": "2844.30.50.10",
      "superior": null,
      "indent": "3",
      "description": "Uranium metal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.30.5050",
      "rawHtsCode": "2844.30.50.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.41.0000",
      "rawHtsCode": "2844.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tritium and its compounds; alloys, dispersions (including cermets), ceramic products and mixtures containing tritium or its compounds",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2844.42.0000",
      "rawHtsCode": "2844.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Actinium-225, actinium-227, californium-253, curium-240, curium-241, curium-242, curium-243, curium-244, einsteinium-253, einsteinium-254, gadolinium-148, polonium-208, polonium-209, polonium-210, radium-223, uranium-230 or uranium-232, and their compounds; alloys, dispersions (including cermets), ceramic products and mixtures containing these elements or compounds",
      "units": [
        "GBq"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2844.43.00",
      "rawHtsCode": "2844.43.00",
      "superior": null,
      "indent": "2",
      "description": "Other radioactive elements and isotopes and compounds; other alloys, dispersions (including cermets), ceramic products and mixtures containing these elements, isotopes or compounds",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2844.43.0010",
      "rawHtsCode": "2844.43.00.10",
      "superior": null,
      "indent": "3",
      "description": "Elements, isotopes and compounds with cobalt-60 radioactivity only",
      "units": [
        "GBq"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.43.0021",
      "rawHtsCode": "2844.43.00.21",
      "superior": null,
      "indent": "4",
      "description": "Americium-241, californium-252, cesium-137, gadolinium-153, idium-192, promethium-147, radium-226, selenium-75, or ytterbium-169",
      "units": [
        "GBq"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.43.0028",
      "rawHtsCode": "2844.43.00.28",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "GBq"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.43.0050",
      "rawHtsCode": "2844.43.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2844.44.0000",
      "rawHtsCode": "2844.44.00.00",
      "superior": null,
      "indent": "2",
      "description": "Radioactive residues",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2844.50.0000",
      "rawHtsCode": "2844.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Spent (irradiated) fuel elements (cartridges) of nuclear reactors",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2845",
      "rawHtsCode": "2845",
      "superior": null,
      "indent": "0",
      "description": "Isotopes other than those of heading 2844; compounds, inorganic or organic, of such isotopes, whether or not chemically defined:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2845.10.0000",
      "rawHtsCode": "2845.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Heavy water (Deuterium oxide)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2845.20.0000",
      "rawHtsCode": "2845.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Boron enriched in boron-10 and its compounds",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2845.30.0000",
      "rawHtsCode": "2845.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Lithium enriched in lithium-6 and its compounds",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2845.40.0000",
      "rawHtsCode": "2845.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Helium-3",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2845.90.0100",
      "rawHtsCode": "2845.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "2846",
      "rawHtsCode": "2846",
      "superior": null,
      "indent": "0",
      "description": "Compounds, inorganic or organic, of rare-earth metals, of yttrium or of scandium, or of mixtures of these metals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2846.10.00",
      "rawHtsCode": "2846.10.00",
      "superior": null,
      "indent": "1",
      "description": "Cerium compounds",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2846.10.0010",
      "rawHtsCode": "2846.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Cerium oxides",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2846.10.0050",
      "rawHtsCode": "2846.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2846.90",
      "rawHtsCode": "2846.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2846.90.20",
      "rawHtsCode": "2846.90.20",
      "superior": null,
      "indent": "2",
      "description": "Mixtures of rare-earth oxides or of rare-earth chlorides",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "2846.90.2005",
      "rawHtsCode": "2846.90.20.05",
      "superior": null,
      "indent": "4",
      "description": "Containing lanthanum as the predominant metal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2846.90.2015",
      "rawHtsCode": "2846.90.20.15",
      "superior": null,
      "indent": "4",
      "description": "Containing yttrium or scandium as the predominant metal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2846.90.2040",
      "rawHtsCode": "2846.90.20.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2846.90.2082",
      "rawHtsCode": "2846.90.20.82",
      "superior": null,
      "indent": "4",
      "description": "Containing yttrium or scandium as the predominant metal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2846.90.2084",
      "rawHtsCode": "2846.90.20.84",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2846.90.4000",
      "rawHtsCode": "2846.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Yttrium bearing materials and compounds containing by weight more than 19 percent but less than 85 percent yttrium oxide equivalent",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "2846.90.80",
      "rawHtsCode": "2846.90.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2846.90.8070",
      "rawHtsCode": "2846.90.80.70",
      "superior": null,
      "indent": "5",
      "description": "Containing lanthanum as the predominant metal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2846.90.8075",
      "rawHtsCode": "2846.90.80.75",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2846.90.8090",
      "rawHtsCode": "2846.90.80.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2847.00.0000",
      "rawHtsCode": "2847.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Hydrogen peroxide, whether or not solidified with urea",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2849",
      "rawHtsCode": "2849",
      "superior": null,
      "indent": "0",
      "description": "Carbides, whether or not chemically defined:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2849.10.0000",
      "rawHtsCode": "2849.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of calcium",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2849.20",
      "rawHtsCode": "2849.20",
      "superior": null,
      "indent": "1",
      "description": "Of silicon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2849.20.1000",
      "rawHtsCode": "2849.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Crude",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2849.20.2000",
      "rawHtsCode": "2849.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "In grains, or ground, pulverized or refined",
      "units": [
        "kg"
      ],
      "generalRate": "0.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2849.90",
      "rawHtsCode": "2849.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2849.90.1000",
      "rawHtsCode": "2849.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of boron",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2849.90.2000",
      "rawHtsCode": "2849.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of chromium",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2849.90.3000",
      "rawHtsCode": "2849.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of tungsten",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P, PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2849.90.5000",
      "rawHtsCode": "2849.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2850.00",
      "rawHtsCode": "2850.00",
      "superior": null,
      "indent": "0",
      "description": "Hydrides, nitrides, azides, silicides and borides, whether or not chemically defined, other than compounds which are also carbides of heading 2849:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2850.00.0500",
      "rawHtsCode": "2850.00.05.00",
      "superior": null,
      "indent": "1",
      "description": "Of calcium",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2850.00.0700",
      "rawHtsCode": "2850.00.07.00",
      "superior": null,
      "indent": "1",
      "description": "Of titanium",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2850.00.1000",
      "rawHtsCode": "2850.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of tungsten",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P, PA,PE,S,SG)",
      "otherRate": "45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2850.00.2000",
      "rawHtsCode": "2850.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of vanadium",
      "units": [
        "kg",
        "V kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2850.00.5000",
      "rawHtsCode": "2850.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2852",
      "rawHtsCode": "2852",
      "superior": null,
      "indent": "0",
      "description": "Inorganic or organic compounds of mercury, whether or not chemically defined, excluding amalgams:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2852.10",
      "rawHtsCode": "2852.10",
      "superior": null,
      "indent": "1",
      "description": "Chemically defined:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2852.10.1000",
      "rawHtsCode": "2852.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Mercuric oxide, mercuric cyanide, mercuric oxycyanide and mercuric potassium cyanide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2852.10.9000",
      "rawHtsCode": "2852.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2852.90",
      "rawHtsCode": "2852.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2852.90.0500",
      "rawHtsCode": "2852.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "Albuminates, tannates and phosphides of mercury",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2852.90.9000",
      "rawHtsCode": "2852.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2853",
      "rawHtsCode": "2853",
      "superior": null,
      "indent": "0",
      "description": "Phosphides, whether or not chemically defined, excluding ferrophosphorous; other inorganic compounds (including distilled or conductivity water and water of similar purity); liquid air (whether or not rare gases have  been removed); compressed air; amalgams, other than amalgams of precious metals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2853.10.0000",
      "rawHtsCode": "2853.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cyanogen chloride (chloorcyan)",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2853.90",
      "rawHtsCode": "2853.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2853.90.1000",
      "rawHtsCode": "2853.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of copper (phosphor copper), containing more than 15 percent by weight of phosphorous",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "32.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2853.90.5000",
      "rawHtsCode": "2853.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Of other metals or nonmetals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2853.90.90",
      "rawHtsCode": "2853.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2853.90.9010",
      "rawHtsCode": "2853.90.90.10",
      "superior": null,
      "indent": "3",
      "description": "Gallium arsenide wafers, undoped",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2853.90.9090",
      "rawHtsCode": "2853.90.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2901",
      "rawHtsCode": "2901",
      "superior": null,
      "indent": "0",
      "description": "Acyclic hydrocarbons:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2901.10",
      "rawHtsCode": "2901.10",
      "superior": null,
      "indent": "1",
      "description": "Saturated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2901.10.1000",
      "rawHtsCode": "2901.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Ethane and butane",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2901.10.3000",
      "rawHtsCode": "2901.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "<i>n</i>-Pentane and isopentane",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2901.10.4000",
      "rawHtsCode": "2901.10.40.00",
      "superior": null,
      "indent": "3",
      "description": "Derived in whole or in part from petroleum, shale oil or natural gas",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2901.10.5000",
      "rawHtsCode": "2901.10.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2901.21.0000",
      "rawHtsCode": "2901.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ethylene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2901.22.0000",
      "rawHtsCode": "2901.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Propene (Propylene)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2901.23.0000",
      "rawHtsCode": "2901.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Butene (Butylene) and isomers thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2901.24",
      "rawHtsCode": "2901.24",
      "superior": null,
      "indent": "2",
      "description": "Buta-1,3-diene and isoprene:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2901.24.1000",
      "rawHtsCode": "2901.24.10.00",
      "superior": null,
      "indent": "3",
      "description": "Buta-1,3-diene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2901.24.2000",
      "rawHtsCode": "2901.24.20.00",
      "superior": null,
      "indent": "4",
      "description": "Having a purity of 95 percent or more by weight",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2901.24.5000",
      "rawHtsCode": "2901.24.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2901.29",
      "rawHtsCode": "2901.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2901.29.10",
      "rawHtsCode": "2901.29.10",
      "superior": null,
      "indent": "3",
      "description": "Derived in whole or in part from petroleum, shale oil or natural gas",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2901.29.1010",
      "rawHtsCode": "2901.29.10.10",
      "superior": null,
      "indent": "4",
      "description": "Linear <i>α</i>-olefins (C<sub>6</sub>-C<sub>30</sub>), unmixed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2901.29.1050",
      "rawHtsCode": "2901.29.10.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2901.29.5000",
      "rawHtsCode": "2901.29.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2902",
      "rawHtsCode": "2902",
      "superior": null,
      "indent": "0",
      "description": "Cyclic hydrocarbons:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2902.11.0000",
      "rawHtsCode": "2902.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cyclohexane",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2902.19.00",
      "rawHtsCode": "2902.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2902.19.0010",
      "rawHtsCode": "2902.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Dicyclopentadiene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2902.19.0050",
      "rawHtsCode": "2902.19.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2902.20.0000",
      "rawHtsCode": "2902.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Benzene",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2902.30.0000",
      "rawHtsCode": "2902.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Toluene",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2902.41.0000",
      "rawHtsCode": "2902.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "<i>o</i>-Xylene",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2902.42.0000",
      "rawHtsCode": "2902.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "<i>m</i>-Xylene",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2902.43.0000",
      "rawHtsCode": "2902.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "<i>p</i>-Xylene",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2902.44.0000",
      "rawHtsCode": "2902.44.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mixed xylene isomers",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2902.50.0000",
      "rawHtsCode": "2902.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Styrene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2902.60.0000",
      "rawHtsCode": "2902.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ethylbenzene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2902.70.0000",
      "rawHtsCode": "2902.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cumene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2902.90",
      "rawHtsCode": "2902.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2902.90.1000",
      "rawHtsCode": "2902.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Pseudocumene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2902.90.2000",
      "rawHtsCode": "2902.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Acenaphthene, chrysene, cymene, dimethylnaphthalenes, fluoranthene, fluorene, indene, mesitylene, methylanthracene, methylnaphthalene, phenanthrene and pyrene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2902.90.30",
      "rawHtsCode": "2902.90.30",
      "superior": null,
      "indent": "2",
      "description": "Alkylbenzenes and polyalkylbenzenes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2902.90.3010",
      "rawHtsCode": "2902.90.30.10",
      "superior": null,
      "indent": "3",
      "description": "Dodecylbenzene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2902.90.3050",
      "rawHtsCode": "2902.90.30.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2902.90.4000",
      "rawHtsCode": "2902.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Anthracene; and 1,4-Di-(2-methylstyryl)benzene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2902.90.6000",
      "rawHtsCode": "2902.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Biphenyl (Diphenyl), in flakes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2902.90.9000",
      "rawHtsCode": "2902.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2903",
      "rawHtsCode": "2903",
      "superior": null,
      "indent": "0",
      "description": "Halogenated derivatives of hydrocarbons:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.11.00",
      "rawHtsCode": "2903.11.00",
      "superior": null,
      "indent": "2",
      "description": "Chloromethane (Methyl chloride) and chloroethane (Ethyl chloride)",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "125%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.11.0010",
      "rawHtsCode": "2903.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Chloromethane (Methyl chloride)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.11.0020",
      "rawHtsCode": "2903.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Chloroethane (Ethyl chloride)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.12.0000",
      "rawHtsCode": "2903.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dichloromethane (Methylene chloride)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.13.0000",
      "rawHtsCode": "2903.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Chloroform (Trichloromethane)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "32%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.14.0000",
      "rawHtsCode": "2903.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Carbon tetrachloride",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.15.0000",
      "rawHtsCode": "2903.15.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ethylene dichloride (ISO) (1,2-dichloroethane)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "88%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.19",
      "rawHtsCode": "2903.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.19.0500",
      "rawHtsCode": "2903.19.05.00",
      "superior": null,
      "indent": "3",
      "description": "1,2-Dichloropropane (Propylene dichloride) and dichlorobutanes",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.19.1000",
      "rawHtsCode": "2903.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Hexachloroethane and tetrachloroethane",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.19.3000",
      "rawHtsCode": "2903.19.30.00",
      "superior": null,
      "indent": "3",
      "description": "<i>sec</i>-Butyl chloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "114.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2903.19.60",
      "rawHtsCode": "2903.19.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "114.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.19.6010",
      "rawHtsCode": "2903.19.60.10",
      "superior": null,
      "indent": "4",
      "description": "Methylchloroform (1,1,1-Trichloroethane)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.19.6050",
      "rawHtsCode": "2903.19.60.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.21.0000",
      "rawHtsCode": "2903.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Vinyl chloride (Chloroethylene)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.22.0000",
      "rawHtsCode": "2903.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Trichloroethylene",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.23.0000",
      "rawHtsCode": "2903.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tetrachloroethylene (Perchloroethylene)",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.29.0000",
      "rawHtsCode": "2903.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "114.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.41.1000",
      "rawHtsCode": "2903.41.10.00",
      "superior": null,
      "indent": "2",
      "description": "Trifluoromethane (HFC-23)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free  (A, AU, BH,CL, CO, D, E, IL, JO, K,KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.42.1000",
      "rawHtsCode": "2903.42.10.00",
      "superior": null,
      "indent": "2",
      "description": "Difluoromethane (HFC-32)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH,CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.43.1000",
      "rawHtsCode": "2903.43.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fluoromethane (HFC-41), 1,2-difluoroethane (HFC-152) and 1,1-difluoroethane (HFC-152a)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH,CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.44.10",
      "rawHtsCode": "2903.44.10",
      "superior": null,
      "indent": "2",
      "description": "Pentafluoroethane (HFC-125), 1,1,1-trifluoroethane (HFC-143a) and 1,1,2-trifluoroethane (HFC-143)",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH,CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.44.1010",
      "rawHtsCode": "2903.44.10.10",
      "superior": null,
      "indent": "3",
      "description": "1,1,1,2,2-Pentafluoroethane (HFC-125)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.44.1020",
      "rawHtsCode": "2903.44.10.20",
      "superior": null,
      "indent": "3",
      "description": "1,1,1-Trifluoroethane (HFC-143a)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.44.1030",
      "rawHtsCode": "2903.44.10.30",
      "superior": null,
      "indent": "3",
      "description": "1,1,2-trifluoroethane (HFC-143)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.45.1000",
      "rawHtsCode": "2903.45.10.00",
      "superior": null,
      "indent": "2",
      "description": "1,1,1,2-Tetrafluoroethane (HFC-134a) and 1,1,2,2-tetrafluoroethane (HFC-134)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH,CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.46.1000",
      "rawHtsCode": "2903.46.10.00",
      "superior": null,
      "indent": "2",
      "description": "1,1,1,2,3,3,3-Heptafluoropropane (HFC-227ea),1,1,1,2,2,3-hexafluoropropane (HFC-236cb),1,1,1,2,3,3-hexafluoropropane (HFC-236ea) and 1,1,1,3,3,3-hexafluoropropane (HFC-236fa)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free  (A, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.47.1000",
      "rawHtsCode": "2903.47.10.00",
      "superior": null,
      "indent": "2",
      "description": "1,1,1,3,3-Pentafluoropropane (HFC-245fa) and 1,1,2,2,3-pentafluoropropane (HFC-245ca)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH,CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.48.0000",
      "rawHtsCode": "2903.48.00.00",
      "superior": null,
      "indent": "2",
      "description": "1,1,1,3,3-Pentafluorobutane (HFC-365mfc) and 1,1,1,2,2,3,4,5,5,5-decafluoropentane (HFC-4310mee)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH,CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.49.0000",
      "rawHtsCode": "2903.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other ",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH,CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.51.1000",
      "rawHtsCode": "2903.51.10.00",
      "superior": null,
      "indent": "2",
      "description": "2,3,3,3-Tetrafluoropropene (HFO-1234yf),1,3,3,3-tetrafluoropropene (HFO-1234ze) and (Z)-1,1,1,4,4,4-hexafluoro-2-butene (HFO-1336mzz)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH,CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.59",
      "rawHtsCode": "2903.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "\n",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.59.1010",
      "rawHtsCode": "2903.59.10.10",
      "superior": null,
      "indent": "3",
      "description": "1,1,3,3,3-Pentafluoro-2-(trifluoromethyl)-prop-1-ene",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH,CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.59.9000",
      "rawHtsCode": "2903.59.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH,CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.61.0000",
      "rawHtsCode": "2903.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Methyl bromide (bromomethane)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": " ",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2903.62.1000",
      "rawHtsCode": "2903.62.10.00",
      "superior": null,
      "indent": "2",
      "description": "Ethylene dibromide (ISO) (1,2-dibromoethane)",
      "units": [
        "kg"
      ],
      "generalRate": "5.4%",
      "specialRate": "Free \n(A+, AU, BH,CL, CO, D, E, IL,JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "46.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.69",
      "rawHtsCode": "2903.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "\n",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.69.1000",
      "rawHtsCode": "2903.69.10.00",
      "superior": null,
      "indent": "3",
      "description": "Acetylene tetrabromide; alkyl bromides, other than methyl bromide (bromomethane); methylene dibromide; and vinyl bromide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": " ",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2903.69.9000",
      "rawHtsCode": "2903.69.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.71.0100",
      "rawHtsCode": "2903.71.01.00",
      "superior": null,
      "indent": "2",
      "description": "Chlorodifluoromethane (HCFC-22)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.72.0100",
      "rawHtsCode": "2903.72.01.00",
      "superior": null,
      "indent": "2",
      "description": "Dichlorotrifluoroethanes (HCFC-123)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.73.0100",
      "rawHtsCode": "2903.73.01.00",
      "superior": null,
      "indent": "2",
      "description": "Dichlorofluoroethanes (HCFC-141, 141b)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.74.0100",
      "rawHtsCode": "2903.74.01.00",
      "superior": null,
      "indent": "2",
      "description": "Chlorodifluoroethanes (HCFC-142, 142b)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.     "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.75.0100",
      "rawHtsCode": "2903.75.01.00",
      "superior": null,
      "indent": "2",
      "description": "Dichloropentafluoropropanes (HCFC-225, 225ca, 225cb)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.76.0100",
      "rawHtsCode": "2903.76.01.00",
      "superior": null,
      "indent": "2",
      "description": "Bromochlorodifluoromethane (Halon-1211), bromotrifluoromethane (Halon-1301) and dibromotetrafluoroethanes (Halon-2402)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free(A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.77.00",
      "rawHtsCode": "2903.77.00",
      "superior": null,
      "indent": "2",
      "description": "Other, perhalogenated only with fluorine and chlorine",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.77.0010",
      "rawHtsCode": "2903.77.00.10",
      "superior": null,
      "indent": "3",
      "description": "Trichlorofluoromethane",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.77.0020",
      "rawHtsCode": "2903.77.00.20",
      "superior": null,
      "indent": "3",
      "description": "Trichlorotrifluoroethanes",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.77.0030",
      "rawHtsCode": "2903.77.00.30",
      "superior": null,
      "indent": "3",
      "description": "Dichlorotetrafluoroethane (CFC-114)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.77.0040",
      "rawHtsCode": "2903.77.00.40",
      "superior": null,
      "indent": "3",
      "description": "Monochloropentafluoroethane (CFC-115)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.77.0050",
      "rawHtsCode": "2903.77.00.50",
      "superior": null,
      "indent": "3",
      "description": "Dichlorodifluoromethane",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.77.0080",
      "rawHtsCode": "2903.77.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.78.0000",
      "rawHtsCode": "2903.78.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other perhalogenated derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.79",
      "rawHtsCode": "2903.79",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.79.1000",
      "rawHtsCode": "2903.79.10.00",
      "superior": null,
      "indent": "3",
      "description": "Bromochloromethane",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.  "
      ],
      "flags": []
    },
    {
      "htsCode": "2903.79.90",
      "rawHtsCode": "2903.79.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.79.9030",
      "rawHtsCode": "2903.79.90.30",
      "superior": null,
      "indent": "4",
      "description": "Monochlorotetrafluoroethane (HCFC-124)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.79.9070",
      "rawHtsCode": "2903.79.90.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.81.0000",
      "rawHtsCode": "2903.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "1,2,3,4,5,6-Hexachlorocyclohexane (HCH (ISO)), including lindane (ISO, INN)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.82.0000",
      "rawHtsCode": "2903.82.00.00",
      "superior": null,
      "indent": "2",
      "description": "Aldrin (ISO), chlordane (ISO) and heptachlor (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.83.0000",
      "rawHtsCode": "2903.83.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mirex (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "114.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.89",
      "rawHtsCode": "2903.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.89.0500",
      "rawHtsCode": "2903.89.05.00",
      "superior": null,
      "indent": "4",
      "description": "Dibromoethyldibromocyclohexane",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2903.89.1100",
      "rawHtsCode": "2903.89.11.00",
      "superior": null,
      "indent": "5",
      "description": "Pesticides",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.89.1500",
      "rawHtsCode": "2903.89.15.00",
      "superior": null,
      "indent": "6",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.89.2000",
      "rawHtsCode": "2903.89.20.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.89.3100",
      "rawHtsCode": "2903.89.31.00",
      "superior": null,
      "indent": "4",
      "description": "Chlorinated, but not otherwise halogenated",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "114.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.89.4000",
      "rawHtsCode": "2903.89.40.00",
      "superior": null,
      "indent": "5",
      "description": "1,3,5,7,9,11-Hexabromocyclododecane",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.89.6000",
      "rawHtsCode": "2903.89.60.00",
      "superior": null,
      "indent": "5",
      "description": "Tetrabromocyclooctane",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2903.89.70",
      "rawHtsCode": "2903.89.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.89.7010",
      "rawHtsCode": "2903.89.70.10",
      "superior": null,
      "indent": "6",
      "description": "Other hexabromocyclododecanes (HBCDs)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.89.7090",
      "rawHtsCode": "2903.89.70.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.91",
      "rawHtsCode": "2903.91",
      "superior": null,
      "indent": "2",
      "description": "Chlorobenzene, <i>o</i>-dichlorobenzene and <i>p</i>-dichlorobenzene:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.91.1000",
      "rawHtsCode": "2903.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Chlorobenzene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 91.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.91.2000",
      "rawHtsCode": "2903.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "<i>o</i>-Dichlorobenzene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 84%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.91.3000",
      "rawHtsCode": "2903.91.30.00",
      "superior": null,
      "indent": "3",
      "description": "<i>p</i>-Dichlorobenzene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.92.0000",
      "rawHtsCode": "2903.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Hexachlorobenzene (ISO) and DDT (ISO) (clofenotane (INN)), (1,1,1-trichloro-2,2- bis(<i>p</i>-chlorophenyl)ethane)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 71%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.93.0000",
      "rawHtsCode": "2903.93.00.00",
      "superior": null,
      "indent": "2",
      "description": "Pentachlorobenzene (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 71%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.94.0000",
      "rawHtsCode": "2903.94.00.00",
      "superior": null,
      "indent": "2",
      "description": "Hexabromobiphenyls",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 71%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.99",
      "rawHtsCode": "2903.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2903.99.0500",
      "rawHtsCode": "2903.99.05.00",
      "superior": null,
      "indent": "3",
      "description": "3-Bromo-<i>α</i>,<i>α</i>,<i>α</i>-trifluorotoluene; 2-Chloro-5-bromo-α,α,α-trifluorotoluene; and<i>α</i>-Chloro-3-methyltoluene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 71%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.99.0800",
      "rawHtsCode": "2903.99.08.00",
      "superior": null,
      "indent": "3",
      "description": "<i>p</i>-Chlorobenzotrifluoride; and 3,4-Dichlorobenzotrifluoride",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 71%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.99.1000",
      "rawHtsCode": "2903.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "<i>m</i>-Dichlorobenzene; 1,1-Dichloro-2,2-bis(<i>p</i>-ethylphenyl)ethane; and Trichlorobenzenes",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.99.1500",
      "rawHtsCode": "2903.99.15.00",
      "superior": null,
      "indent": "3",
      "description": "Triphenylmethyl chloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 71%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2903.99.2000",
      "rawHtsCode": "2903.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Benzyl chloride (<i>α</i>-Chlorotoluene); and Benzotrichloride (<i>α</i>,<i>α</i>,<i>α</i>-Trichlorotoluene)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.99.2300",
      "rawHtsCode": "2903.99.23.00",
      "superior": null,
      "indent": "3",
      "description": "Pentabromoethylbenzene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 71%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2903.99.2700",
      "rawHtsCode": "2903.99.27.00",
      "superior": null,
      "indent": "3",
      "description": "Tribromocumene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 71%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.99.3000",
      "rawHtsCode": "2903.99.30.00",
      "superior": null,
      "indent": "4",
      "description": "Pesticides",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2903.99.8001",
      "rawHtsCode": "2903.99.80.01",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 71%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904",
      "rawHtsCode": "2904",
      "superior": null,
      "indent": "0",
      "description": "Sulfonated, nitrated or nitrosated derivatives of hydrocarbons, whether or not halogenated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2904.10",
      "rawHtsCode": "2904.10",
      "superior": null,
      "indent": "1",
      "description": "Derivatives containing only sulfo groups, their salts and ethyl esters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2904.10.0400",
      "rawHtsCode": "2904.10.04.00",
      "superior": null,
      "indent": "2",
      "description": "2-Anthracenesulfonic acid",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.10.0800",
      "rawHtsCode": "2904.10.08.00",
      "superior": null,
      "indent": "2",
      "description": "Benzenesulfonyl chloride",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.10.1000",
      "rawHtsCode": "2904.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "<i>m</i>-Benzenedisulfonic acid, sodium salt; 1,5-Naphthalenedisulfonic acid; and<i>p</i>-Toluenesulfonyl chloride",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 41.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.10.1500",
      "rawHtsCode": "2904.10.15.00",
      "superior": null,
      "indent": "2",
      "description": "Mixtures of 1,3,6-naphthalenetrisulfonic acid and 1,3,7-naphthalenetrisulfonic acid",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.10.3200",
      "rawHtsCode": "2904.10.32.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.10.3700",
      "rawHtsCode": "2904.10.37.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.10.5000",
      "rawHtsCode": "2904.10.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.20",
      "rawHtsCode": "2904.20",
      "superior": null,
      "indent": "1",
      "description": "Derivatives containing only nitro or only nitroso groups:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2904.20.1000",
      "rawHtsCode": "2904.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "<i>p</i>-Nitrotoluene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.20.1500",
      "rawHtsCode": "2904.20.15.00",
      "superior": null,
      "indent": "2",
      "description": "<i>p</i>-Nitro-o-xylene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 41.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.20.2000",
      "rawHtsCode": "2904.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Trinitrotoluene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2904.20.3000",
      "rawHtsCode": "2904.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "5-<i>tert</i>-Butyl-2,4,6-trinitro-<i>m</i>-xylene (Musk xylol) and other artificial musks",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.20.3500",
      "rawHtsCode": "2904.20.35.00",
      "superior": null,
      "indent": "2",
      "description": "Nitrated benzene, nitrated toluene (except <i>p</i>-nitrotoluene), or nitrated naphthalene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.20.4000",
      "rawHtsCode": "2904.20.40.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.20.4500",
      "rawHtsCode": "2904.20.45.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.20.5000",
      "rawHtsCode": "2904.20.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.31.0000",
      "rawHtsCode": "2904.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Perfluorooctane sulfonic acid",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.32.0000",
      "rawHtsCode": "2904.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ammonium perfluorooctane sulfonate",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.33.0000",
      "rawHtsCode": "2904.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Lithium perfluorooctane sulfonate",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.34.0000",
      "rawHtsCode": "2904.34.00.00",
      "superior": null,
      "indent": "2",
      "description": "Potassium perfluorooctane sulfonate",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.35.0000",
      "rawHtsCode": "2904.35.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other salts of perfluorooctane sulfonic acid",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.36.0000",
      "rawHtsCode": "2904.36.00.00",
      "superior": null,
      "indent": "2",
      "description": "Perfluorooctane sulfonyl fluoride",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.91.0000",
      "rawHtsCode": "2904.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Trichloronitromethane (chloropicrin)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.99",
      "rawHtsCode": "2904.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2904.99.0400",
      "rawHtsCode": "2904.99.04.00",
      "superior": null,
      "indent": "4",
      "description": "<i>o</i>-Nitrochlorobenzene; and<i>p</i>-Nitrochlorobenzene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +59%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.99.0800",
      "rawHtsCode": "2904.99.08.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P ,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 59%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.99.1500",
      "rawHtsCode": "2904.99.15.00",
      "superior": null,
      "indent": "3",
      "description": "4-Chloro-3-nitro-<i>α</i>,<i>α</i>,<i>α</i>-trifluorotoluene; 2-Chloro-5-nitro-<i>α</i>,<i>α</i>,<i>α</i>-trifluorotoluene; and 4-Chloro-3,5-dinitro-<i>α</i>,<i>α</i>,<i>α</i>-trifluorotoluene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.99.2000",
      "rawHtsCode": "2904.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Nitrotoluenesulfonic acids",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 74.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.99.3000",
      "rawHtsCode": "2904.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "1-Bromo-2-nitrobenzene; 1,2-Dichloro-4-nitrobenzene and o-Fluoronitrobenzene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P ,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.99.3500",
      "rawHtsCode": "2904.99.35.00",
      "superior": null,
      "indent": "3",
      "description": "4,4'-Dinitrostilbene-2,2'-disulfonic acid",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.99.4000",
      "rawHtsCode": "2904.99.40.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.99.4700",
      "rawHtsCode": "2904.99.47.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2904.99.5000",
      "rawHtsCode": "2904.99.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905",
      "rawHtsCode": "2905",
      "superior": null,
      "indent": "0",
      "description": "Acyclic alcohols and their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.11",
      "rawHtsCode": "2905.11",
      "superior": null,
      "indent": "2",
      "description": "Methanol (Methyl alcohol):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.11.1000",
      "rawHtsCode": "2905.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Imported only for use in producing synthetic natural gas (SNG) or for direct use as a fuel",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.8¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2905.11.20",
      "rawHtsCode": "2905.11.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.11.2010",
      "rawHtsCode": "2905.11.20.10",
      "superior": null,
      "indent": "4",
      "description": "Imported for use in chemical production, including production of aldehydes, plastics, olefins and resins",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.11.2015",
      "rawHtsCode": "2905.11.20.15",
      "superior": null,
      "indent": "4",
      "description": "For use in wastewater treatment",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.11.2085",
      "rawHtsCode": "2905.11.20.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.12.00",
      "rawHtsCode": "2905.12.00",
      "superior": null,
      "indent": "2",
      "description": "Propan-1-ol (Propyl alcohol) and propan-2-ol (Isopropyl alcohol)",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.12.0010",
      "rawHtsCode": "2905.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Propan-1-ol",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.12.0050",
      "rawHtsCode": "2905.12.00.50",
      "superior": null,
      "indent": "3",
      "description": "Propan-2-ol",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.13.0000",
      "rawHtsCode": "2905.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Butan-1-ol (<i>n</i>-Butyl alcohol)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.14",
      "rawHtsCode": "2905.14",
      "superior": null,
      "indent": "2",
      "description": "Other butanols:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.14.1000",
      "rawHtsCode": "2905.14.10.00",
      "superior": null,
      "indent": "3",
      "description": "<i>tert</i>-Butyl alcohol, having a purity of less than 99 percent by weight",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2905.14.50",
      "rawHtsCode": "2905.14.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.14.5010",
      "rawHtsCode": "2905.14.50.10",
      "superior": null,
      "indent": "4",
      "description": "2-Methylpropan-1-ol (Isobutyl alcohol)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.14.5050",
      "rawHtsCode": "2905.14.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.16.00",
      "rawHtsCode": "2905.16.00",
      "superior": null,
      "indent": "2",
      "description": "Octanol (Octyl alcohol) and isomers thereof",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.16.0010",
      "rawHtsCode": "2905.16.00.10",
      "superior": null,
      "indent": "3",
      "description": "2-Ethylhexan-1-ol",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.16.0050",
      "rawHtsCode": "2905.16.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.17.0000",
      "rawHtsCode": "2905.17.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dodecan-1-ol (Lauryl alcohol), hexadecan-1-ol (Cetyl alcohol) and octadecan-1-ol (Stearyl alcohol)",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.19",
      "rawHtsCode": "2905.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.19.1000",
      "rawHtsCode": "2905.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pentanol (Amyl alcohol) and isomers thereof",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.19.90",
      "rawHtsCode": "2905.19.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.19.9005",
      "rawHtsCode": "2905.19.90.05",
      "superior": null,
      "indent": "4",
      "description": "3,3-Dimethylbutan-2-ol (pinacolyl alcohol)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.19.9010",
      "rawHtsCode": "2905.19.90.10",
      "superior": null,
      "indent": "4",
      "description": "Decyl alcohol and isomers thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.19.9020",
      "rawHtsCode": "2905.19.90.20",
      "superior": null,
      "indent": "4",
      "description": "Hexyl alcohol and isomers thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.19.9090",
      "rawHtsCode": "2905.19.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.22",
      "rawHtsCode": "2905.22",
      "superior": null,
      "indent": "2",
      "description": "Acyclic terpene alcohols:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.22.1000",
      "rawHtsCode": "2905.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Geraniol",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.22.2000",
      "rawHtsCode": "2905.22.20.00",
      "superior": null,
      "indent": "3",
      "description": "Isophytol",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.22.50",
      "rawHtsCode": "2905.22.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.8% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.22.5010",
      "rawHtsCode": "2905.22.50.10",
      "superior": null,
      "indent": "4",
      "description": "Citronellol",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.22.5050",
      "rawHtsCode": "2905.22.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.29",
      "rawHtsCode": "2905.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.29.1000",
      "rawHtsCode": "2905.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Allyl alcohol",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.29.9000",
      "rawHtsCode": "2905.29.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.31.0000",
      "rawHtsCode": "2905.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ethylene glycol (Ethanediol)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "63%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.32.0000",
      "rawHtsCode": "2905.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Propylene glycol (Propane-1,2-diol)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.39",
      "rawHtsCode": "2905.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.39.1000",
      "rawHtsCode": "2905.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Butylene glycol",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.39.2000",
      "rawHtsCode": "2905.39.20.00",
      "superior": null,
      "indent": "3",
      "description": "Neopentyl glycol",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.39.6000",
      "rawHtsCode": "2905.39.60.00",
      "superior": null,
      "indent": "3",
      "description": "Hexylene glycol",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2905.39.9000",
      "rawHtsCode": "2905.39.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.41.0000",
      "rawHtsCode": "2905.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "2-Ethyl-2-(hydroxymethyl)propane-1,3-diol (Trimethylolpropane)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.42.0000",
      "rawHtsCode": "2905.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Pentaerythritol",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.43.0000",
      "rawHtsCode": "2905.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mannitol",
      "units": [
        "kg"
      ],
      "generalRate": "4.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.44.0000",
      "rawHtsCode": "2905.44.00.00",
      "superior": null,
      "indent": "2",
      "description": "<i>D</i>-Glucitol (Sorbitol)",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.45.0000",
      "rawHtsCode": "2905.45.00.00",
      "superior": null,
      "indent": "2",
      "description": "Glycerol",
      "units": [
        "kg"
      ],
      "generalRate": "0.5¢/kg",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.49",
      "rawHtsCode": "2905.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.49.1000",
      "rawHtsCode": "2905.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Triols and tetrols",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.49.2000",
      "rawHtsCode": "2905.49.20.00",
      "superior": null,
      "indent": "3",
      "description": "Esters of glycerol formed with acids of heading 2904",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.49.3000",
      "rawHtsCode": "2905.49.30.00",
      "superior": null,
      "indent": "5",
      "description": "Xylitol",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2905.49.4000",
      "rawHtsCode": "2905.49.40.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.49.5001",
      "rawHtsCode": "2905.49.50.01",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.51.0000",
      "rawHtsCode": "2905.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ethchlorvynol (INN)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "39%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.59",
      "rawHtsCode": "2905.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2905.59.1000",
      "rawHtsCode": "2905.59.10.00",
      "superior": null,
      "indent": "3",
      "description": "Derivatives of monohydric alcohols",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "39%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2905.59.3000",
      "rawHtsCode": "2905.59.30.00",
      "superior": null,
      "indent": "3",
      "description": "Dibromoneopentylglycol",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2905.59.9000",
      "rawHtsCode": "2905.59.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2906",
      "rawHtsCode": "2906",
      "superior": null,
      "indent": "0",
      "description": "Cyclic alcohols and their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2906.11.0000",
      "rawHtsCode": "2906.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Menthol",
      "units": [
        "kg"
      ],
      "generalRate": "2.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2906.12.0000",
      "rawHtsCode": "2906.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cyclohexanol, methylcyclohexanols and dimethylcyclohexanols",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2906.13",
      "rawHtsCode": "2906.13",
      "superior": null,
      "indent": "2",
      "description": "Sterols and inositols:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2906.13.1000",
      "rawHtsCode": "2906.13.10.00",
      "superior": null,
      "indent": "3",
      "description": "Inositols",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2906.13.5000",
      "rawHtsCode": "2906.13.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2906.19",
      "rawHtsCode": "2906.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2906.19.1000",
      "rawHtsCode": "2906.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "4,4'-Isopropylidenedicyclohexanol; and mixtures containing not less than 90 percent by weight of stereoisomers of 2-isopropyl- 5-methylcyclohexanol, but containing not more than 30 percent by weight of any one such stereoisomer",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2906.19.3000",
      "rawHtsCode": "2906.19.30.00",
      "superior": null,
      "indent": "3",
      "description": "Terpineols",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2906.19.5000",
      "rawHtsCode": "2906.19.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2906.21.0000",
      "rawHtsCode": "2906.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Benzyl alcohol",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2906.29",
      "rawHtsCode": "2906.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2906.29.1000",
      "rawHtsCode": "2906.29.10.00",
      "superior": null,
      "indent": "4",
      "description": "Phenethyl alcohol",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 77%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2906.29.2000",
      "rawHtsCode": "2906.29.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2906.29.3000",
      "rawHtsCode": "2906.29.30.00",
      "superior": null,
      "indent": "4",
      "description": "1,1-Bis(4-chlorophenyl)- 2,2,2-trichloro-ethanol (Dicofol); and<i>p</i>-Nitrobenzyl alcohol",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2906.29.6000",
      "rawHtsCode": "2906.29.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907",
      "rawHtsCode": "2907",
      "superior": null,
      "indent": "0",
      "description": "Phenols; phenol-alcohols:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2907.11.0000",
      "rawHtsCode": "2907.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Phenol (Hydroxybenzene) and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 44%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.12.0000",
      "rawHtsCode": "2907.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cresols and their salts",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.13.0000",
      "rawHtsCode": "2907.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Octylphenol, nonylphenol and their isomers; salts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.15",
      "rawHtsCode": "2907.15",
      "superior": null,
      "indent": "2",
      "description": "Naphthols and their salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2907.15.1000",
      "rawHtsCode": "2907.15.10.00",
      "superior": null,
      "indent": "3",
      "description": "<i>α</i>-Naphthol",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +73%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.15.3000",
      "rawHtsCode": "2907.15.30.00",
      "superior": null,
      "indent": "3",
      "description": "<i>β</i>-Naphthol (2-Naphthol)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 73%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2907.15.6000",
      "rawHtsCode": "2907.15.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 73%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.19",
      "rawHtsCode": "2907.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2907.19.1000",
      "rawHtsCode": "2907.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Alkylcresols",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.19.2000",
      "rawHtsCode": "2907.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Alkylphenols",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.19.4000",
      "rawHtsCode": "2907.19.40.00",
      "superior": null,
      "indent": "3",
      "description": "Thymol",
      "units": [
        "kg"
      ],
      "generalRate": "4.2% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.19.6100",
      "rawHtsCode": "2907.19.61.00",
      "superior": null,
      "indent": "4",
      "description": "2-<i>tert</i>-Butylethylphenol; 6-<i>tert</i>-Butyl-2,4-xylenol; and Xylenols and their salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 44%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2907.19.8000",
      "rawHtsCode": "2907.19.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 44%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.21.0000",
      "rawHtsCode": "2907.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Resorcinol and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.22",
      "rawHtsCode": "2907.22",
      "superior": null,
      "indent": "2",
      "description": "Hydroquinone (Quinol) and its salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2907.22.1000",
      "rawHtsCode": "2907.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Photographic grade",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.22.5000",
      "rawHtsCode": "2907.22.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 44%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.23.0000",
      "rawHtsCode": "2907.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "4,4'-Isopropylidenediphenol (Bisphenol A, Diphenylolpropane) and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 44%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.29",
      "rawHtsCode": "2907.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2907.29.0500",
      "rawHtsCode": "2907.29.05.00",
      "superior": null,
      "indent": "3",
      "description": "Phenol-alcohols",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 44%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.29.1000",
      "rawHtsCode": "2907.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pyrogallic acid",
      "units": [
        "kg"
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.29.1500",
      "rawHtsCode": "2907.29.15.00",
      "superior": null,
      "indent": "3",
      "description": "4,4'-Biphenol",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 44%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2907.29.2500",
      "rawHtsCode": "2907.29.25.00",
      "superior": null,
      "indent": "3",
      "description": "<i>tert</i>-Butylhydroquinone",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 44%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2907.29.9000",
      "rawHtsCode": "2907.29.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 44%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908",
      "rawHtsCode": "2908",
      "superior": null,
      "indent": "0",
      "description": "Halogenated, sulfonated, nitrated or nitrosated derivatives of phenols or phenol-alcohols:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2908.11.0000",
      "rawHtsCode": "2908.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Pentachlorophenol (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.19",
      "rawHtsCode": "2908.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2908.19.0500",
      "rawHtsCode": "2908.19.05.00",
      "superior": null,
      "indent": "3",
      "description": "2,2-Bis(4-hydroxyphenyl)-1,1,1,3,3,3-hexafluoro- propane",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 62%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2908.19.1000",
      "rawHtsCode": "2908.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "6-Chloro-<i>m</i>-cresol [OH=1];<i>m</i>-Chlorophenol; and Chlorothymol",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 67.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.19.1500",
      "rawHtsCode": "2908.19.15.00",
      "superior": null,
      "indent": "3",
      "description": "3-Hydroxy-<i>α</i>,<i>α</i>,<i>α</i>-trifluorotoluene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +62%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.19.2000",
      "rawHtsCode": "2908.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Salts of pentachlorophenol; and 2,4,5-Trichlorophenol and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.19.2500",
      "rawHtsCode": "2908.19.25.00",
      "superior": null,
      "indent": "3",
      "description": "Tetrabromobisphenol A",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 62%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.19.3500",
      "rawHtsCode": "2908.19.35.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 62%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.19.6000",
      "rawHtsCode": "2908.19.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 62%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.91.0000",
      "rawHtsCode": "2908.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dinoseb (ISO) and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,L,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.92.0000",
      "rawHtsCode": "2908.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "4,6-Dinitro-<i>o</i>-cresol (DNOC) (ISO) and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.99",
      "rawHtsCode": "2908.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2908.99.0300",
      "rawHtsCode": "2908.99.03.00",
      "superior": null,
      "indent": "4",
      "description": "2,5-Dihydroxybenzenesulfonic acid, potassium salt; 3,6-Dihydroxy-2,7-naphthalenedisulfonic acid; 3,6-Dihydroxy-2,7-naphthalenedisulfonic acid, sodium salt; 4-Hydroxy-1-naphthalenesulfonic acid, sodium salt; 1-Naphthol-3,6-disulfonic acid; and 2-Naphthol-3,6-disulfonic acid and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.99.0600",
      "rawHtsCode": "2908.99.06.00",
      "superior": null,
      "indent": "4",
      "description": "4-Hydroxy-1-naphthalenesulfonic acid (1-Naphthol-4-sulfonic acid)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2908.99.0900",
      "rawHtsCode": "2908.99.09.00",
      "superior": null,
      "indent": "4",
      "description": "1,8-Dihydroxynaphthalene-3,6-disulfonic acid and its disodium salt",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +62%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.99.1200",
      "rawHtsCode": "2908.99.12.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 62%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.99.1500",
      "rawHtsCode": "2908.99.15.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 62%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.99.2000",
      "rawHtsCode": "2908.99.20.00",
      "superior": null,
      "indent": "4",
      "description": "<i>p</i>-Nitrophenol",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.99.2500",
      "rawHtsCode": "2908.99.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other nitrophenols",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.99.3300",
      "rawHtsCode": "2908.99.33.00",
      "superior": null,
      "indent": "4",
      "description": "Dinitro-<i>o</i>-cresols (other than 4,6-dinitro-<i>o</i>-cresol) and 4-nitro-<i>m</i>-cresol",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.99.4000",
      "rawHtsCode": "2908.99.40.00",
      "superior": null,
      "indent": "4",
      "description": "Dinitrobutylphenol and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.99.8000",
      "rawHtsCode": "2908.99.80.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 62%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2908.99.9000",
      "rawHtsCode": "2908.99.90.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 62%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909",
      "rawHtsCode": "2909",
      "superior": null,
      "indent": "0",
      "description": "Ethers, ether-alcohols, ether-phenols, ether-alcohol- phenols, alcohol peroxides, ether peroxides, acetal and hemiacetal peroxides, ketone peroxides (whether or not chemically defined), and their halogenated, sulfonated, nitrated or nitrosated derivatives",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2909.11.0000",
      "rawHtsCode": "2909.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Diethyl ether",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.19",
      "rawHtsCode": "2909.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2909.19.1400",
      "rawHtsCode": "2909.19.14.00",
      "superior": null,
      "indent": "4",
      "description": "Methyl tertiary-butyl ether (MTBE)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.19.1800",
      "rawHtsCode": "2909.19.18.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.19.3000",
      "rawHtsCode": "2909.19.30.00",
      "superior": null,
      "indent": "4",
      "description": "Triethylene glycol dichloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2909.19.6000",
      "rawHtsCode": "2909.19.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.20.0000",
      "rawHtsCode": "2909.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cyclanic, cyclenic or cycloterpenic ethers and their halogenated, sulfonated, nitrated or nitrosated derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.30",
      "rawHtsCode": "2909.30",
      "superior": null,
      "indent": "1",
      "description": "Aromatic ethers and their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2909.30.0500",
      "rawHtsCode": "2909.30.05.00",
      "superior": null,
      "indent": "2",
      "description": "5-Chloro-2-nitroanisole; 6-Chloro-3-nitro-p-dimethoxybenzene; and Dimethyl diphenyl ether",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.30.0700",
      "rawHtsCode": "2909.30.07.00",
      "superior": null,
      "indent": "2",
      "description": "Decabromodiphenyl oxide; and Octabromodiphenyl oxide",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 70.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.30.0900",
      "rawHtsCode": "2909.30.09.00",
      "superior": null,
      "indent": "2",
      "description": "Bis(tribromophenoxy)ethane; Pentabromodiphenyl oxide; and Tetra decabromodiphenoxy benzene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 70.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2909.30.1000",
      "rawHtsCode": "2909.30.10.00",
      "superior": null,
      "indent": "4",
      "description": "6-<i>tert</i>-Butyl-3-methyl-2,4-dinitroanisole (Musk ambrette) and other artificial musks",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +57%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.30.2000",
      "rawHtsCode": "2909.30.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.30.3000",
      "rawHtsCode": "2909.30.30.00",
      "superior": null,
      "indent": "3",
      "description": "Pesticides",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +48.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.30.4000",
      "rawHtsCode": "2909.30.40.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 70.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.30.6000",
      "rawHtsCode": "2909.30.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 70.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.41.0000",
      "rawHtsCode": "2909.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "2,2'-Oxydiethanol (Diethylene glycol, Digol)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.43.0000",
      "rawHtsCode": "2909.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "Monobutyl ethers of ethylene glycol or of diethylene glycol",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.44.01",
      "rawHtsCode": "2909.44.01",
      "superior": null,
      "indent": "2",
      "description": "Other monoalkyl ethers of ethylene glycol or of diethylene glycol",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.44.0110",
      "rawHtsCode": "2909.44.01.10",
      "superior": null,
      "indent": "3",
      "description": "Monomethyl ethers of ethylene glycol or of diethylene glycol",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2909.44.0150",
      "rawHtsCode": "2909.44.01.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2909.49",
      "rawHtsCode": "2909.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2909.49.0500",
      "rawHtsCode": "2909.49.05.00",
      "superior": null,
      "indent": "4",
      "description": "Guaifenesin",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 79%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2909.49.1000",
      "rawHtsCode": "2909.49.10.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 70.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.49.1500",
      "rawHtsCode": "2909.49.15.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 70.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.49.2000",
      "rawHtsCode": "2909.49.20.00",
      "superior": null,
      "indent": "4",
      "description": "Glycerol ethers",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.49.3000",
      "rawHtsCode": "2909.49.30.00",
      "superior": null,
      "indent": "4",
      "description": "Dipentaerythritol having a purity of 94 percent or more by weight",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2909.49.6000",
      "rawHtsCode": "2909.49.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.50",
      "rawHtsCode": "2909.50",
      "superior": null,
      "indent": "1",
      "description": "Ether-phenols, ether-alcohol-phenols and their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2909.50.1000",
      "rawHtsCode": "2909.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "4-Ethylguaiacol",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.50.2000",
      "rawHtsCode": "2909.50.20.00",
      "superior": null,
      "indent": "2",
      "description": "Guaiacol and its derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +79%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.50.40",
      "rawHtsCode": "2909.50.40",
      "superior": null,
      "indent": "3",
      "description": "Odoriferous or flavoring compounds",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.50.4010",
      "rawHtsCode": "2909.50.40.10",
      "superior": null,
      "indent": "4",
      "description": "Eugenol and isoeugenol",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2909.50.4050",
      "rawHtsCode": "2909.50.40.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2909.50.4500",
      "rawHtsCode": "2909.50.45.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 70.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.50.5000",
      "rawHtsCode": "2909.50.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 70.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.60",
      "rawHtsCode": "2909.60",
      "superior": null,
      "indent": "1",
      "description": "Alcohol peroxides, ether peroxides, acetal and hemiacetal peroxides, ketone peroxides and their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2909.60.1000",
      "rawHtsCode": "2909.60.10.00",
      "superior": null,
      "indent": "3",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 70.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.60.2000",
      "rawHtsCode": "2909.60.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 70.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2909.60.5000",
      "rawHtsCode": "2909.60.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2910",
      "rawHtsCode": "2910",
      "superior": null,
      "indent": "0",
      "description": "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers, with a three-membered ring, and their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2910.10.0000",
      "rawHtsCode": "2910.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Oxirane (Ethylene oxide)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2910.20.0000",
      "rawHtsCode": "2910.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Methyloxirane (Propylene oxide)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2910.30.0000",
      "rawHtsCode": "2910.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "1-Chloro-2,3-epoxypropane (Epichlorohydrin)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2910.40.0000",
      "rawHtsCode": "2910.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Dieldrin (ISO, INN)",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2910.50.0000",
      "rawHtsCode": "2910.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Endrin",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2910.90",
      "rawHtsCode": "2910.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2910.90.1000",
      "rawHtsCode": "2910.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Butylene oxide",
      "units": [
        "kg"
      ],
      "generalRate": "4.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2910.90.2000",
      "rawHtsCode": "2910.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2910.90.9100",
      "rawHtsCode": "2910.90.91.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2911.00",
      "rawHtsCode": "2911.00",
      "superior": null,
      "indent": "0",
      "description": "Acetals and hemiacetals, whether or not with other oxygen function, and their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2911.00.1000",
      "rawHtsCode": "2911.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "1,1-Bis(1-methylethoxy)cyclohexane",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "36.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2911.00.5000",
      "rawHtsCode": "2911.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "36.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912",
      "rawHtsCode": "2912",
      "superior": null,
      "indent": "0",
      "description": "Aldehydes, whether or not with other oxygen function; cyclic polymers of aldehydes; paraformaldehyde:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2912.11.0000",
      "rawHtsCode": "2912.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Methanal (Formaldehyde)",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.12.0000",
      "rawHtsCode": "2912.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ethanal (Acetaldehyde)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "71%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.19",
      "rawHtsCode": "2912.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2912.19.1000",
      "rawHtsCode": "2912.19.10.00",
      "superior": null,
      "indent": "4",
      "description": "Citral",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.19.2000",
      "rawHtsCode": "2912.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.19.2500",
      "rawHtsCode": "2912.19.25.00",
      "superior": null,
      "indent": "4",
      "description": "Butanal (Butyraldehyde, normal isomer)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.19.3000",
      "rawHtsCode": "2912.19.30.00",
      "superior": null,
      "indent": "4",
      "description": "Glyoxal",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.19.4000",
      "rawHtsCode": "2912.19.40.00",
      "superior": null,
      "indent": "4",
      "description": "Isobutanal",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.19.5000",
      "rawHtsCode": "2912.19.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.21.0000",
      "rawHtsCode": "2912.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Benzaldehyde",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.29",
      "rawHtsCode": "2912.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2912.29.1000",
      "rawHtsCode": "2912.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Phenylacetaldehyde",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.29.3000",
      "rawHtsCode": "2912.29.30.00",
      "superior": null,
      "indent": "3",
      "description": "3,4-Dimethylbenzaldehyde; Paraldehyde, USP grade; and<i>p</i>-Tolualdehyde",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2912.29.60",
      "rawHtsCode": "2912.29.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.29.6010",
      "rawHtsCode": "2912.29.60.10",
      "superior": null,
      "indent": "4",
      "description": "Odoriferous or flavoring compounds",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2912.29.6090",
      "rawHtsCode": "2912.29.60.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2912.41.0000",
      "rawHtsCode": "2912.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Vanillin (4-Hydroxy-3-methoxybenzaldehyde)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.42.0000",
      "rawHtsCode": "2912.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ethylvanillin (3-Ethoxy-4-hydroxybenzaldehyde)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.49",
      "rawHtsCode": "2912.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2912.49.1000",
      "rawHtsCode": "2912.49.10.00",
      "superior": null,
      "indent": "4",
      "description": "<i>p</i>-Anisaldehyde",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.49.1500",
      "rawHtsCode": "2912.49.15.00",
      "superior": null,
      "indent": "4",
      "description": "<i>p</i>-Hydroxybenzaldehyde",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2912.49.2600",
      "rawHtsCode": "2912.49.26.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.49.5500",
      "rawHtsCode": "2912.49.55.00",
      "superior": null,
      "indent": "5",
      "description": "Hydroxycitronellal",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.49.6000",
      "rawHtsCode": "2912.49.60.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.49.9000",
      "rawHtsCode": "2912.49.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.50",
      "rawHtsCode": "2912.50",
      "superior": null,
      "indent": "1",
      "description": "Cyclic polymers of aldehydes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2912.50.1000",
      "rawHtsCode": "2912.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Metaldehyde",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2912.50.5000",
      "rawHtsCode": "2912.50.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2912.60.0000",
      "rawHtsCode": "2912.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Paraformaldehyde",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "32.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2913.00",
      "rawHtsCode": "2913.00",
      "superior": null,
      "indent": "0",
      "description": "Halogenated, sulfonated, nitrated or nitrosated derivatives of products of heading 2912:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2913.00.2000",
      "rawHtsCode": "2913.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "4-Fluoro-3-phenoxybenzaldehyde",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 77.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2913.00.4000",
      "rawHtsCode": "2913.00.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 77.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2913.00.5000",
      "rawHtsCode": "2913.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914",
      "rawHtsCode": "2914",
      "superior": null,
      "indent": "0",
      "description": "Ketones and quinones, whether or not with other oxygen function, and their halogenated, sulfonated, nitrated, or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2914.11",
      "rawHtsCode": "2914.11",
      "superior": null,
      "indent": "2",
      "description": "Acetone:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2914.11.1000",
      "rawHtsCode": "2914.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Derived in whole or in part from cumene",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.11.5000",
      "rawHtsCode": "2914.11.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2914.12.0000",
      "rawHtsCode": "2914.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Butanone (Methyl ethyl ketone)",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.13.0000",
      "rawHtsCode": "2914.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "4-Methylpentan-2-one (Methyl isobutyl ketone)",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.19.0000",
      "rawHtsCode": "2914.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.22",
      "rawHtsCode": "2914.22",
      "superior": null,
      "indent": "2",
      "description": "Cyclohexanone and methylcyclohexanones:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2914.22.1000",
      "rawHtsCode": "2914.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cyclohexanone",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.22.2000",
      "rawHtsCode": "2914.22.20.00",
      "superior": null,
      "indent": "3",
      "description": "Methylcyclohexanones",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.23.0000",
      "rawHtsCode": "2914.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ionones and methylionones",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.29",
      "rawHtsCode": "2914.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2914.29.1000",
      "rawHtsCode": "2914.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Isophorone",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.29.3000",
      "rawHtsCode": "2914.29.30.00",
      "superior": null,
      "indent": "4",
      "description": "Natural",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2914.29.3100",
      "rawHtsCode": "2914.29.31.00",
      "superior": null,
      "indent": "4",
      "description": "Synthetic",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.29.5000",
      "rawHtsCode": "2914.29.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.8% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.31.0000",
      "rawHtsCode": "2914.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Phenylacetone (Phenylpropan-2-one)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.39",
      "rawHtsCode": "2914.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2914.39.1000",
      "rawHtsCode": "2914.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "7-Acetyl-1,1,3,4,4,6-hexamethyl-tetra hydro naphthalene; 1-(2-Naphthalenyl) ethanone; and 6-Acetyl-1,1,2,3,3,5-hexamethylindan",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2914.39.9000",
      "rawHtsCode": "2914.39.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.40",
      "rawHtsCode": "2914.40",
      "superior": null,
      "indent": "1",
      "description": "Ketone-alcohols and ketone-aldehydes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2914.40.1000",
      "rawHtsCode": "2914.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "4-Hydroxy-4-methylpentan-2-one (Diacetone alcohol)",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.40.2000",
      "rawHtsCode": "2914.40.20.00",
      "superior": null,
      "indent": "4",
      "description": "1,2,3-Indantrione monohydrate (Ninhydrin)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.40.4000",
      "rawHtsCode": "2914.40.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.40.6000",
      "rawHtsCode": "2914.40.60.00",
      "superior": null,
      "indent": "4",
      "description": "1,3-Dihydroxyacetone",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2914.40.9000",
      "rawHtsCode": "2914.40.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.50",
      "rawHtsCode": "2914.50",
      "superior": null,
      "indent": "1",
      "description": "Ketone-phenols and ketones with other oxygen function:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2914.50.1000",
      "rawHtsCode": "2914.50.10.00",
      "superior": null,
      "indent": "3",
      "description": "5-Benzoyl-4-hydroxy-2-methoxybenzene-sulfonic acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2914.50.3000",
      "rawHtsCode": "2914.50.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.50.5000",
      "rawHtsCode": "2914.50.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.61.0000",
      "rawHtsCode": "2914.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Anthraquinone",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2914.62.0000",
      "rawHtsCode": "2914.62.00.00",
      "superior": null,
      "indent": "2",
      "description": "Coenzyme Q10 (ubidecarenone (INN)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR, L, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.69",
      "rawHtsCode": "2914.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2914.69.1000",
      "rawHtsCode": "2914.69.10.00",
      "superior": null,
      "indent": "3",
      "description": "Photographic chemicals",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.69.2100",
      "rawHtsCode": "2914.69.21.00",
      "superior": null,
      "indent": "3",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.69.6000",
      "rawHtsCode": "2914.69.60.00",
      "superior": null,
      "indent": "4",
      "description": "1,4-Dihydroxyanthraquinone; and 2-Ethylanthraquinone",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 42%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2914.69.9000",
      "rawHtsCode": "2914.69.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 42%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.71.0000",
      "rawHtsCode": "2914.71.00.00",
      "superior": null,
      "indent": "2",
      "description": "Chlordecone (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.79",
      "rawHtsCode": "2914.79",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2914.79.1000",
      "rawHtsCode": "2914.79.10.00",
      "superior": null,
      "indent": "4",
      "description": "2,3-Dichloro-1,4-naphthoquinone 1,8-Dihydroxy-4,5-dinitroanthraquinone; and 4-tert-Butyl-2,6-dimethyl-3,5-dinitroacetophenone (Musk ketone) and other artificial musks",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.79.3000",
      "rawHtsCode": "2914.79.30.00",
      "superior": null,
      "indent": "4",
      "description": "Anthraquinone disulfonic acid, sodium salt; and 4-(3,4-Dichlorophenyl)-1-tetralone",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2914.79.4000",
      "rawHtsCode": "2914.79.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2914.79.6000",
      "rawHtsCode": "2914.79.60.00",
      "superior": null,
      "indent": "4",
      "description": "1-Chloro-5-hexanone",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2914.79.9000",
      "rawHtsCode": "2914.79.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915",
      "rawHtsCode": "2915",
      "superior": null,
      "indent": "0",
      "description": "Saturated acyclic monocarboxylic acids and their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.11.0000",
      "rawHtsCode": "2915.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Formic acid",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.12.0000",
      "rawHtsCode": "2915.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Salts of formic acid",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.13",
      "rawHtsCode": "2915.13",
      "superior": null,
      "indent": "2",
      "description": "Esters of formic acid:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.13.1000",
      "rawHtsCode": "2915.13.10.00",
      "superior": null,
      "indent": "3",
      "description": "Aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.13.5000",
      "rawHtsCode": "2915.13.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.21.0000",
      "rawHtsCode": "2915.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Acetic acid",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "16%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.24.0000",
      "rawHtsCode": "2915.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Acetic anhydride",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.29",
      "rawHtsCode": "2915.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.29.1000",
      "rawHtsCode": "2915.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cupric acetate monohydrate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2915.29.2000",
      "rawHtsCode": "2915.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Sodium acetate",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.29.3000",
      "rawHtsCode": "2915.29.30.00",
      "superior": null,
      "indent": "3",
      "description": "Cobalt acetates",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.29.5000",
      "rawHtsCode": "2915.29.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.31.0000",
      "rawHtsCode": "2915.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ethyl acetate",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.32.0000",
      "rawHtsCode": "2915.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Vinyl acetate",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.33.0000",
      "rawHtsCode": "2915.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "<i>n</i>-Butyl acetate",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.36.0000",
      "rawHtsCode": "2915.36.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dinoseb (ISO) acetate",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.39",
      "rawHtsCode": "2915.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.39.1000",
      "rawHtsCode": "2915.39.10.00",
      "superior": null,
      "indent": "5",
      "description": "Benzyl acetate",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 104.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.39.2000",
      "rawHtsCode": "2915.39.20.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.39.3100",
      "rawHtsCode": "2915.39.31.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.39.3500",
      "rawHtsCode": "2915.39.35.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.39.4000",
      "rawHtsCode": "2915.39.40.00",
      "superior": null,
      "indent": "5",
      "description": "Linalyl acetate",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.39.45",
      "rawHtsCode": "2915.39.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "4.8% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.39.4510",
      "rawHtsCode": "2915.39.45.10",
      "superior": null,
      "indent": "6",
      "description": "<i>n</i>-Propyl acetate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.39.4550",
      "rawHtsCode": "2915.39.45.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.39.4700",
      "rawHtsCode": "2915.39.47.00",
      "superior": null,
      "indent": "5",
      "description": "Acetates of polyhydric alcohols or of polyhydric alcohol ethers",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.39.6000",
      "rawHtsCode": "2915.39.60.00",
      "superior": null,
      "indent": "6",
      "description": "Bis(bromoacetoxy)butene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2915.39.7000",
      "rawHtsCode": "2915.39.70.00",
      "superior": null,
      "indent": "6",
      "description": "Isobutyl acetate",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.39.8000",
      "rawHtsCode": "2915.39.80.00",
      "superior": null,
      "indent": "6",
      "description": "2-Ethoxyethyl acetate (Ethylene glycol, monoethyl ether acetate)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.39.9000",
      "rawHtsCode": "2915.39.90.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.40",
      "rawHtsCode": "2915.40",
      "superior": null,
      "indent": "1",
      "description": "Mono-, di- or trichloroacetic acids, their salts and esters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.40.1000",
      "rawHtsCode": "2915.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Chloroacetic acids",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.40.2000",
      "rawHtsCode": "2915.40.20.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.40.3000",
      "rawHtsCode": "2915.40.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.40.50",
      "rawHtsCode": "2915.40.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.40.5010",
      "rawHtsCode": "2915.40.50.10",
      "superior": null,
      "indent": "4",
      "description": "Sodium chloroacetate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.40.5050",
      "rawHtsCode": "2915.40.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.50",
      "rawHtsCode": "2915.50",
      "superior": null,
      "indent": "1",
      "description": "Propionic acid, its salts and esters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.50.1000",
      "rawHtsCode": "2915.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Propionic acid",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.50.2000",
      "rawHtsCode": "2915.50.20.00",
      "superior": null,
      "indent": "3",
      "description": "Aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.50.5000",
      "rawHtsCode": "2915.50.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.60",
      "rawHtsCode": "2915.60",
      "superior": null,
      "indent": "1",
      "description": "Butanoic acids, pentanoic acids, their salts and esters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.60.1000",
      "rawHtsCode": "2915.60.10.00",
      "superior": null,
      "indent": "2",
      "description": "Aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.60.5000",
      "rawHtsCode": "2915.60.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.70.01",
      "rawHtsCode": "2915.70.01",
      "superior": null,
      "indent": "1",
      "description": "Palmitic acid, stearic acid, their salts and esters",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "29.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.70.0110",
      "rawHtsCode": "2915.70.01.10",
      "superior": null,
      "indent": "2",
      "description": "Palmitic acid",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.70.0120",
      "rawHtsCode": "2915.70.01.20",
      "superior": null,
      "indent": "2",
      "description": "Stearic acid",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.70.0150",
      "rawHtsCode": "2915.70.01.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.90",
      "rawHtsCode": "2915.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.90.10",
      "rawHtsCode": "2915.90.10",
      "superior": null,
      "indent": "3",
      "description": "Fatty acids of animal or vegetable origin",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.90.1010",
      "rawHtsCode": "2915.90.10.10",
      "superior": null,
      "indent": "4",
      "description": "Lauric acid",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.90.1050",
      "rawHtsCode": "2915.90.10.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.90.1400",
      "rawHtsCode": "2915.90.14.00",
      "superior": null,
      "indent": "4",
      "description": "Valproic acid",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.90.18",
      "rawHtsCode": "2915.90.18",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.90.1810",
      "rawHtsCode": "2915.90.18.10",
      "superior": null,
      "indent": "5",
      "description": "Perfluorooctanoic acids and their salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.90.1890",
      "rawHtsCode": "2915.90.18.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.90.2000",
      "rawHtsCode": "2915.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.90.50",
      "rawHtsCode": "2915.90.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2915.90.5010",
      "rawHtsCode": "2915.90.50.10",
      "superior": null,
      "indent": "4",
      "description": "Acid chlorides",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2915.90.5050",
      "rawHtsCode": "2915.90.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916",
      "rawHtsCode": "2916",
      "superior": null,
      "indent": "0",
      "description": "Unsaturated acyclic monocarboxylic acids, cyclic monocarboxylic acids, their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.11.0000",
      "rawHtsCode": "2916.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Acrylic acid and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.12",
      "rawHtsCode": "2916.12",
      "superior": null,
      "indent": "2",
      "description": "Esters of acrylic acid:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.12.1000",
      "rawHtsCode": "2916.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "Aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.12.50",
      "rawHtsCode": "2916.12.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.12.5010",
      "rawHtsCode": "2916.12.50.10",
      "superior": null,
      "indent": "4",
      "description": "Ethyl acrylate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.12.5020",
      "rawHtsCode": "2916.12.50.20",
      "superior": null,
      "indent": "4",
      "description": "Methyl acrylate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.12.5030",
      "rawHtsCode": "2916.12.50.30",
      "superior": null,
      "indent": "4",
      "description": "Butyl acrylate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.12.5040",
      "rawHtsCode": "2916.12.50.40",
      "superior": null,
      "indent": "4",
      "description": "2-Ethyl-1-hexyl acrylate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.12.5050",
      "rawHtsCode": "2916.12.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.13.0000",
      "rawHtsCode": "2916.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Methacrylic acid and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.14",
      "rawHtsCode": "2916.14",
      "superior": null,
      "indent": "2",
      "description": "Esters of methacrylic acid:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.14.1000",
      "rawHtsCode": "2916.14.10.00",
      "superior": null,
      "indent": "3",
      "description": "Dicyclopentenyloxyethyl methacrylate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2916.14.20",
      "rawHtsCode": "2916.14.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.14.2010",
      "rawHtsCode": "2916.14.20.10",
      "superior": null,
      "indent": "4",
      "description": "Ethyl methacrylate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.14.2020",
      "rawHtsCode": "2916.14.20.20",
      "superior": null,
      "indent": "4",
      "description": "Methyl methacrylate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.14.2050",
      "rawHtsCode": "2916.14.20.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.15",
      "rawHtsCode": "2916.15",
      "superior": null,
      "indent": "2",
      "description": "Oleic, linoleic or linolenic acids, their salts and esters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.15.1000",
      "rawHtsCode": "2916.15.10.00",
      "superior": null,
      "indent": "3",
      "description": "Oleic, linoleic or linolenic acids",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "35.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.15.5100",
      "rawHtsCode": "2916.15.51.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.16.0000",
      "rawHtsCode": "2916.16.00.00",
      "superior": null,
      "indent": "2",
      "description": "Binapacryl (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.19",
      "rawHtsCode": "2916.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.19.1000",
      "rawHtsCode": "2916.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Potassium sorbate",
      "units": [
        "kg"
      ],
      "generalRate": "3.1% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.19.2000",
      "rawHtsCode": "2916.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Sorbic acid",
      "units": [
        "kg"
      ],
      "generalRate": "4.2% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.19.3000",
      "rawHtsCode": "2916.19.30.00",
      "superior": null,
      "indent": "4",
      "description": "Acids",
      "units": [
        "kg"
      ],
      "generalRate": "6.1% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "24.4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.19.5000",
      "rawHtsCode": "2916.19.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.20",
      "rawHtsCode": "2916.20",
      "superior": null,
      "indent": "1",
      "description": "Cyclanic, cyclenic or cycloterpenic monocarboxylic acids, their anhydrides, halides, peroxides, peroxyacids and their derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.20.1000",
      "rawHtsCode": "2916.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "(2,3,5,6-Tetrafluoro-4-methylphenyl)methyl- (1<i>α</i>-3<i>α</i>)-(Z)-(±)-3-(2-chloro-3,3,3-trifluoro-1- propenyl-2,2-dimethylcyclopropanecarboxylate) (Tefluthrin)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2916.20.5000",
      "rawHtsCode": "2916.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.31",
      "rawHtsCode": "2916.31",
      "superior": null,
      "indent": "2",
      "description": "Benzoic acid, its salts and esters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.31.11",
      "rawHtsCode": "2916.31.11",
      "superior": null,
      "indent": "3",
      "description": "Benzoic acid and its salts",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.31.1105",
      "rawHtsCode": "2916.31.11.05",
      "superior": null,
      "indent": "4",
      "description": "Benzoic acid",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.31.1170",
      "rawHtsCode": "2916.31.11.70",
      "superior": null,
      "indent": "4",
      "description": "Sodium benzoate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.31.1190",
      "rawHtsCode": "2916.31.11.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.31.2000",
      "rawHtsCode": "2916.31.20.00",
      "superior": null,
      "indent": "4",
      "description": "Odoriferous or flavoring compounds",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.31.3000",
      "rawHtsCode": "2916.31.30.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.31.5000",
      "rawHtsCode": "2916.31.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.32",
      "rawHtsCode": "2916.32",
      "superior": null,
      "indent": "2",
      "description": "Benzoyl peroxide and benzoyl chloride:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.32.1000",
      "rawHtsCode": "2916.32.10.00",
      "superior": null,
      "indent": "3",
      "description": "Benzoyl peroxide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.32.2000",
      "rawHtsCode": "2916.32.20.00",
      "superior": null,
      "indent": "3",
      "description": "Benzoyl chloride",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 44%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.34",
      "rawHtsCode": "2916.34",
      "superior": null,
      "indent": "2",
      "description": "Phenylacetic acid and its salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.34.1000",
      "rawHtsCode": "2916.34.10.00",
      "superior": null,
      "indent": "3",
      "description": "Phenylacetic acid (<i>α</i>-Toluic acid)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.34.1500",
      "rawHtsCode": "2916.34.15.00",
      "superior": null,
      "indent": "4",
      "description": "Odoriferous or flavoring compounds",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.34.2500",
      "rawHtsCode": "2916.34.25.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.34.5500",
      "rawHtsCode": "2916.34.55.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2916.39",
      "rawHtsCode": "2916.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2916.39.0300",
      "rawHtsCode": "2916.39.03.00",
      "superior": null,
      "indent": "3",
      "description": "Benzoic anhydride;<i>tert</i>-Butyl peroxybenzoate;<i>p</i>-Nitrobenzoyl chloride; 2-Nitro-<i>m</i>-toluic acid; and 3-Nitro-<i>o</i>-toluic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.39.0400",
      "rawHtsCode": "2916.39.04.00",
      "superior": null,
      "indent": "3",
      "description": "<i>m</i>-Chloroperoxybenzoic acid; and<i>p</i>-Sulfobenzoic acid, potassium salt",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2916.39.0600",
      "rawHtsCode": "2916.39.06.00",
      "superior": null,
      "indent": "3",
      "description": "Cinnamic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.39.0800",
      "rawHtsCode": "2916.39.08.00",
      "superior": null,
      "indent": "3",
      "description": "4-Chloro-3-nitrobenzoic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.39.1200",
      "rawHtsCode": "2916.39.12.00",
      "superior": null,
      "indent": "3",
      "description": "4-Chloro-3,5-dinitrobenzoic acid and its esters",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.39.1500",
      "rawHtsCode": "2916.39.15.00",
      "superior": null,
      "indent": "3",
      "description": "Ibuprofen",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 47.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.39.1600",
      "rawHtsCode": "2916.39.16.00",
      "superior": null,
      "indent": "3",
      "description": "4-Chlorobenzoic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.39.1700",
      "rawHtsCode": "2916.39.17.00",
      "superior": null,
      "indent": "3",
      "description": "2,2-Dichlorophenylacetic acid, ethyl ester; and<i>m</i>-Toluic acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2916.39.2100",
      "rawHtsCode": "2916.39.21.00",
      "superior": null,
      "indent": "4",
      "description": "Odoriferous or flavoring compounds",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.39.4600",
      "rawHtsCode": "2916.39.46.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2916.39.7700",
      "rawHtsCode": "2916.39.77.00",
      "superior": null,
      "indent": "6",
      "description": "Esters of phenylacetic acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2916.39.7900",
      "rawHtsCode": "2916.39.79.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917",
      "rawHtsCode": "2917",
      "superior": null,
      "indent": "0",
      "description": "Polycarboxylic acids, their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.11.0000",
      "rawHtsCode": "2917.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Oxalic acid, its salts and esters",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "34.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.12",
      "rawHtsCode": "2917.12",
      "superior": null,
      "indent": "2",
      "description": "Adipic acid, its salts and esters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.12.1000",
      "rawHtsCode": "2917.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "Adipic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 63%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.12.2000",
      "rawHtsCode": "2917.12.20.00",
      "superior": null,
      "indent": "4",
      "description": "Plasticizers",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.12.5000",
      "rawHtsCode": "2917.12.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.13.00",
      "rawHtsCode": "2917.13.00",
      "superior": null,
      "indent": "2",
      "description": "Azelaic acid, sebacic acid, their salts and esters",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.13.0030",
      "rawHtsCode": "2917.13.00.30",
      "superior": null,
      "indent": "3",
      "description": "Sebacic acid",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.13.0090",
      "rawHtsCode": "2917.13.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.14",
      "rawHtsCode": "2917.14",
      "superior": null,
      "indent": "2",
      "description": "Maleic anhydride:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.14.1000",
      "rawHtsCode": "2917.14.10.00",
      "superior": null,
      "indent": "3",
      "description": "Derived in whole or in part from benzene or other aromatic hydrocarbons",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.14.5000",
      "rawHtsCode": "2917.14.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.19",
      "rawHtsCode": "2917.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.19.1000",
      "rawHtsCode": "2917.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Ferrous fumarate",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.19.1500",
      "rawHtsCode": "2917.19.15.00",
      "superior": null,
      "indent": "4",
      "description": "Derived in whole or in part from aromatic hydrocarbons",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 87%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.19.1700",
      "rawHtsCode": "2917.19.17.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.19.2000",
      "rawHtsCode": "2917.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.19.2300",
      "rawHtsCode": "2917.19.23.00",
      "superior": null,
      "indent": "5",
      "description": "Maleic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.19.2700",
      "rawHtsCode": "2917.19.27.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.19.3000",
      "rawHtsCode": "2917.19.30.00",
      "superior": null,
      "indent": "3",
      "description": "Ethylene brassylate",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.19.3500",
      "rawHtsCode": "2917.19.35.00",
      "superior": null,
      "indent": "3",
      "description": "Malonic acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2917.19.4000",
      "rawHtsCode": "2917.19.40.00",
      "superior": null,
      "indent": "4",
      "description": "Derived in whole or in part from aromatic hydrocarbons",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.19.70",
      "rawHtsCode": "2917.19.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.19.7020",
      "rawHtsCode": "2917.19.70.20",
      "superior": null,
      "indent": "5",
      "description": "Plasticizers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.19.7050",
      "rawHtsCode": "2917.19.70.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.20.0000",
      "rawHtsCode": "2917.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cyclanic, cyclenic or cycloterpenic polycarboxylic acids, their anhydrides, halides, peroxides, peroxyacids and their derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "4.2% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.32.0000",
      "rawHtsCode": "2917.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dioctyl orthophthalates",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.33.00",
      "rawHtsCode": "2917.33.00",
      "superior": null,
      "indent": "2",
      "description": "Dinonyl or didecyl orthophthalates",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.33.0010",
      "rawHtsCode": "2917.33.00.10",
      "superior": null,
      "indent": "3",
      "description": "Diisodecyl orthophthalate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.33.0050",
      "rawHtsCode": "2917.33.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.34.01",
      "rawHtsCode": "2917.34.01",
      "superior": null,
      "indent": "2",
      "description": "Other esters of orthophthalic acid",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.34.0110",
      "rawHtsCode": "2917.34.01.10",
      "superior": null,
      "indent": "3",
      "description": "Dibutyl orthophthalate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.34.0150",
      "rawHtsCode": "2917.34.01.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.35.0000",
      "rawHtsCode": "2917.35.00.00",
      "superior": null,
      "indent": "2",
      "description": "Phthalic anhydride",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.36.0000",
      "rawHtsCode": "2917.36.00.00",
      "superior": null,
      "indent": "2",
      "description": "Terephthalic acid and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.37.0000",
      "rawHtsCode": "2917.37.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dimethyl terephthalate",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.39",
      "rawHtsCode": "2917.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.39.0400",
      "rawHtsCode": "2917.39.04.00",
      "superior": null,
      "indent": "3",
      "description": "1,2,4-Benzenetricarboxylic acid, 1,2-dianhydride (Trimellitic anhydride); Phthalic acid; and 4-Sulfo-1,8-naphthalic anhydride",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.39.0800",
      "rawHtsCode": "2917.39.08.00",
      "superior": null,
      "indent": "3",
      "description": "Naphthalic anhydride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 37%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2917.39.1200",
      "rawHtsCode": "2917.39.12.00",
      "superior": null,
      "indent": "3",
      "description": "4,4'-(Hexafluoroisopropylidene)bis(phthalic anhydride)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 73%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2917.39.1500",
      "rawHtsCode": "2917.39.15.00",
      "superior": null,
      "indent": "3",
      "description": "Isophthalic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.39.1700",
      "rawHtsCode": "2917.39.17.00",
      "superior": null,
      "indent": "3",
      "description": "Tetrabromophthalic anhydride",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 73%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.39.2000",
      "rawHtsCode": "2917.39.20.00",
      "superior": null,
      "indent": "4",
      "description": "Plasticizers",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.39.3000",
      "rawHtsCode": "2917.39.30.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 73%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2917.39.7000",
      "rawHtsCode": "2917.39.70.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 73%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918",
      "rawHtsCode": "2918",
      "superior": null,
      "indent": "0",
      "description": "Carboxylic acids with additional oxygen function and their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.11",
      "rawHtsCode": "2918.11",
      "superior": null,
      "indent": "2",
      "description": "Lactic acid, its salts and esters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.11.1000",
      "rawHtsCode": "2918.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Lactic acid",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.11.5100",
      "rawHtsCode": "2918.11.51.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.12.0000",
      "rawHtsCode": "2918.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tartaric acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "17%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2918.13",
      "rawHtsCode": "2918.13",
      "superior": null,
      "indent": "2",
      "description": "Salts and esters of tartaric acid:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.13.1000",
      "rawHtsCode": "2918.13.10.00",
      "superior": null,
      "indent": "3",
      "description": "Potassium antimony tartrate (Tartar emetic)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2918.13.2000",
      "rawHtsCode": "2918.13.20.00",
      "superior": null,
      "indent": "3",
      "description": "Potassium bitartrate (Cream of tartar)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2918.13.3000",
      "rawHtsCode": "2918.13.30.00",
      "superior": null,
      "indent": "3",
      "description": "Potassium sodium tartrate (Rochelle salts)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2918.13.5000",
      "rawHtsCode": "2918.13.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.14.0000",
      "rawHtsCode": "2918.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Citric acid",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.15",
      "rawHtsCode": "2918.15",
      "superior": null,
      "indent": "2",
      "description": "Salts and esters of citric acid:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.15.1000",
      "rawHtsCode": "2918.15.10.00",
      "superior": null,
      "indent": "3",
      "description": "Sodium citrate",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.15.5000",
      "rawHtsCode": "2918.15.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.16",
      "rawHtsCode": "2918.16",
      "superior": null,
      "indent": "2",
      "description": "Gluconic acid, its salts and esters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.16.1000",
      "rawHtsCode": "2918.16.10.00",
      "superior": null,
      "indent": "3",
      "description": "Gluconic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.16.50",
      "rawHtsCode": "2918.16.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.16.5010",
      "rawHtsCode": "2918.16.50.10",
      "superior": null,
      "indent": "4",
      "description": "Sodium gluconate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.16.5020",
      "rawHtsCode": "2918.16.50.20",
      "superior": null,
      "indent": "4",
      "description": "Calcium gluconate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.16.5090",
      "rawHtsCode": "2918.16.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.17.0001",
      "rawHtsCode": "2918.17.00.01",
      "superior": null,
      "indent": "2",
      "description": "2,2-Diphenyl-2-hydroxyacetic acid (benzilic acid)",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.18.0000",
      "rawHtsCode": "2918.18.00.00",
      "superior": null,
      "indent": "2",
      "description": "Chlorobenzilate (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.19",
      "rawHtsCode": "2918.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.19.1100",
      "rawHtsCode": "2918.19.11.00",
      "superior": null,
      "indent": "4",
      "description": "Benzilic acid, methyl ester",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.19.1200",
      "rawHtsCode": "2918.19.12.00",
      "superior": null,
      "indent": "5",
      "description": "Mandelic acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 67.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2918.19.1500",
      "rawHtsCode": "2918.19.15.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 67.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.19.2000",
      "rawHtsCode": "2918.19.20.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.19.3100",
      "rawHtsCode": "2918.19.31.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.19.6000",
      "rawHtsCode": "2918.19.60.00",
      "superior": null,
      "indent": "4",
      "description": "Malic acid",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.19.9000",
      "rawHtsCode": "2918.19.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.21",
      "rawHtsCode": "2918.21",
      "superior": null,
      "indent": "2",
      "description": "Salicylic acid and its salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.21.1000",
      "rawHtsCode": "2918.21.10.00",
      "superior": null,
      "indent": "3",
      "description": "Suitable for medicinal use",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.21.5000",
      "rawHtsCode": "2918.21.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.22",
      "rawHtsCode": "2918.22",
      "superior": null,
      "indent": "2",
      "description": "<i>O</i>-Acetylsalicylic acid, its salts and esters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.22.1000",
      "rawHtsCode": "2918.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "<i>O</i>-Acetylsalicylic acid (Aspirin)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 82%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.22.5000",
      "rawHtsCode": "2918.22.50.00",
      "superior": null,
      "indent": "3",
      "description": "Salts and esters of <i>O</i>-acetylsalicylic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 47.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.23",
      "rawHtsCode": "2918.23",
      "superior": null,
      "indent": "2",
      "description": "Other esters of salicylic acid and their salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.23.1000",
      "rawHtsCode": "2918.23.10.00",
      "superior": null,
      "indent": "3",
      "description": "Salol (Phenyl salicylate) suitable for medicinal use",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.23.2000",
      "rawHtsCode": "2918.23.20.00",
      "superior": null,
      "indent": "4",
      "description": "Odoriferous or flavoring compounds",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.23.3000",
      "rawHtsCode": "2918.23.30.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.23.5000",
      "rawHtsCode": "2918.23.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.29",
      "rawHtsCode": "2918.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.29.0400",
      "rawHtsCode": "2918.29.04.00",
      "superior": null,
      "indent": "3",
      "description": "2,3-Cresotic acid; 2-Hydroxybenzoic acid, calcium salt; 1-Hydroxy-2-naphthoic acid; 2-Hydroxy-1-naphthoic acid; 1-Hydroxy-2-naphthoic acid, phenyl ester;<i>α</i>-Resorcylic acid;<i>γ</i>-Resorcylic acid; and 5-Sulfosalicylic acid",
      "units": [
        "kg"
      ],
      "generalRate": "5.8% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.29.0600",
      "rawHtsCode": "2918.29.06.00",
      "superior": null,
      "indent": "3",
      "description": "1,6-Hexanediol bis(3,5-dibutyl-4-hydroxyphenyl)propionate)",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.29.0800",
      "rawHtsCode": "2918.29.08.00",
      "superior": null,
      "indent": "3",
      "description": "m-Hydroxybenzoic acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2918.29.2000",
      "rawHtsCode": "2918.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Gentisic acid; and Hydroxycinnamic acid and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.29.2200",
      "rawHtsCode": "2918.29.22.00",
      "superior": null,
      "indent": "3",
      "description": "<i>p</i>-Hydroxybenzoic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.29.2500",
      "rawHtsCode": "2918.29.25.00",
      "superior": null,
      "indent": "3",
      "description": "3-Hydroxy-2-naphthoic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.29.3000",
      "rawHtsCode": "2918.29.30.00",
      "superior": null,
      "indent": "3",
      "description": "Gallic acid",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.29.3900",
      "rawHtsCode": "2918.29.39.00",
      "superior": null,
      "indent": "3",
      "description": "4,4-Bis(4-hydroxyphenyl) pentanoic acid; and 3,5,6-Trichlorosalicylic acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2918.29.6500",
      "rawHtsCode": "2918.29.65.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.29.7500",
      "rawHtsCode": "2918.29.75.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.30",
      "rawHtsCode": "2918.30",
      "superior": null,
      "indent": "1",
      "description": "Carboxylic acids with aldehyde or ketone function but without other oxygen function, their anhydrides, halides, peroxides, peroxyacids and their derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.30.1000",
      "rawHtsCode": "2918.30.10.00",
      "superior": null,
      "indent": "3",
      "description": "1-Formylphenylacetic acid, methyl ester",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.30.1500",
      "rawHtsCode": "2918.30.15.00",
      "superior": null,
      "indent": "3",
      "description": "2-Chloro-4,5-difluoro-<i>ß</i>-oxobenzenepropanoic acid, ethyl ester; and Ethyl 2-keto-4-phenylbutanoate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2918.30.2500",
      "rawHtsCode": "2918.30.25.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.30.3000",
      "rawHtsCode": "2918.30.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.30.7000",
      "rawHtsCode": "2918.30.70.00",
      "superior": null,
      "indent": "3",
      "description": "Dimethyl acetyl succinate; Oxalacetic acid diethyl ester, sodium salt; 4,4,4-Trifluoro-3-oxobutanoic acid, ethyl ester; and 4,4,4-Trifluoro-3-oxobutanoic acid, methyl ester",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2918.30.9000",
      "rawHtsCode": "2918.30.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.91.0000",
      "rawHtsCode": "2918.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "2,4,5-T (ISO) (2,4,5-trichlorophenoxyacetic acid), its salts and esters",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.99",
      "rawHtsCode": "2918.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.99.0500",
      "rawHtsCode": "2918.99.05.00",
      "superior": null,
      "indent": "4",
      "description": "<i>p</i>-Anisic acid; Clofibrate; and 3-Phenoxybenzoic acid",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.99.0600",
      "rawHtsCode": "2918.99.06.00",
      "superior": null,
      "indent": "4",
      "description": "1-Hydroxy-6-octadecyloxy-2-naphthalene- carboxylic acid; and 1-Hydroxy-6-docosyloxy-2-naphthalene- carboxylic acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.99.1400",
      "rawHtsCode": "2918.99.14.00",
      "superior": null,
      "indent": "4",
      "description": "2-(4-Chloro-2-methylphenoxy)propionic acid and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.99.1800",
      "rawHtsCode": "2918.99.18.00",
      "superior": null,
      "indent": "6",
      "description": "4-(4-Chloro-2-methylphenoxy) butyric acid;<i>p</i>-Chlorophenoxyacetic acid; and 2-(2,4-Dichlorophenoxy) propionic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.99.20",
      "rawHtsCode": "2918.99.20",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.99.2010",
      "rawHtsCode": "2918.99.20.10",
      "superior": null,
      "indent": "7",
      "description": "2,4-Dichlorophenoxyacetic acid, its salts and esters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.99.2015",
      "rawHtsCode": "2918.99.20.15",
      "superior": null,
      "indent": "7",
      "description": "2-Methyl-4-chlorophenoxyacetic acid",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.99.2050",
      "rawHtsCode": "2918.99.20.50",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2918.99.3000",
      "rawHtsCode": "2918.99.30.00",
      "superior": null,
      "indent": "5",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 47.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.99.3500",
      "rawHtsCode": "2918.99.35.00",
      "superior": null,
      "indent": "5",
      "description": "Odoriferous or flavoring compounds",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.99.4300",
      "rawHtsCode": "2918.99.43.00",
      "superior": null,
      "indent": "6",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.99.4700",
      "rawHtsCode": "2918.99.47.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2918.99.5000",
      "rawHtsCode": "2918.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2919",
      "rawHtsCode": "2919",
      "superior": null,
      "indent": "0",
      "description": "Phosphoric esters and their salts, including lactophosphates; their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2919.10.0000",
      "rawHtsCode": "2919.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tris(2,3-dibromopropyl phosphate)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2919.90",
      "rawHtsCode": "2919.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2919.90.1500",
      "rawHtsCode": "2919.90.15.00",
      "superior": null,
      "indent": "4",
      "description": "Triphenyl phosphate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2919.90.2500",
      "rawHtsCode": "2919.90.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2919.90.3000",
      "rawHtsCode": "2919.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 43%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2919.90.50",
      "rawHtsCode": "2919.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2919.90.5010",
      "rawHtsCode": "2919.90.50.10",
      "superior": null,
      "indent": "3",
      "description": "Plasticizers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2919.90.5050",
      "rawHtsCode": "2919.90.50.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2920",
      "rawHtsCode": "2920",
      "superior": null,
      "indent": "0",
      "description": "Esters of other inorganic acids of nonmetals (excluding esters of hydrogen halides) and their salts; their halogenated, sulfonated, nitrated or nitrosated derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2920.11.0000",
      "rawHtsCode": "2920.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Parathion (ISO) and parathion-methyl (ISO) (methyl-parathion)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2920.19",
      "rawHtsCode": "2920.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2920.19.1000",
      "rawHtsCode": "2920.19.10.00",
      "superior": null,
      "indent": "4",
      "description": "<i>O</i>,<i>O</i>-Dimethyl-<i>O</i>-(4-nitro-m-tolyl)phosphoro- thioate (Fenitrothion)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 41%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2920.19.4000",
      "rawHtsCode": "2920.19.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2920.19.5000",
      "rawHtsCode": "2920.19.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2920.21.0000",
      "rawHtsCode": "2920.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dimethyl phosphite",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2920.22.0000",
      "rawHtsCode": "2920.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Diethyl phosphite",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2920.23.0000",
      "rawHtsCode": "2920.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Trimethyl phosphite",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2920.24.0000",
      "rawHtsCode": "2920.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Triethyl phosphite",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2920.29.0000",
      "rawHtsCode": "2920.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2920.30.0000",
      "rawHtsCode": "2920.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Endosulfan (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2920.90",
      "rawHtsCode": "2920.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2920.90.1000",
      "rawHtsCode": "2920.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pesticides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2920.90.2000",
      "rawHtsCode": "2920.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2920.90.5100",
      "rawHtsCode": "2920.90.51.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921",
      "rawHtsCode": "2921",
      "superior": null,
      "indent": "0",
      "description": "Amine-function compounds",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.11.0000",
      "rawHtsCode": "2921.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Methylamine, di- or trimethylamine and their salts",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.12.0100",
      "rawHtsCode": "2921.12.01.00",
      "superior": null,
      "indent": "2",
      "description": "2-(N,N-Dimethylamino)ethyl chloride hydrochloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2921.13.0000",
      "rawHtsCode": "2921.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "2-(N,N-Diethylamino)ethyl chloride hydrochloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2921.14.0000",
      "rawHtsCode": "2921.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "2-(N,N,-Diisopropylamino)ethyl chloride hydrochloride",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.19",
      "rawHtsCode": "2921.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.19.1100",
      "rawHtsCode": "2921.19.11.00",
      "superior": null,
      "indent": "3",
      "description": "Mono-, di- and triethylamines;mono-, di-, and tri-(propyl- and butyl-)monoamines; salts of any of the foregoing",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.19.3100",
      "rawHtsCode": "2921.19.31.00",
      "superior": null,
      "indent": "3",
      "description": "3-Amino-3-methyl-1-butyne; (Dimethylamino)isopropyl chloride hydrochloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2921.19.61",
      "rawHtsCode": "2921.19.61",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.19.6110",
      "rawHtsCode": "2921.19.61.10",
      "superior": null,
      "indent": "4",
      "description": "<i>N</i>,<i>N</i>-Dialkyl (methyl, ethyl or <i>n</i>-propyl)-2-chloroethylamines and their protonated salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.19.6120",
      "rawHtsCode": "2921.19.61.20",
      "superior": null,
      "indent": "4",
      "description": "Bis(2-chloroethyl)ethylamine) ",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.19.6130",
      "rawHtsCode": "2921.19.61.30",
      "superior": null,
      "indent": "4",
      "description": "Chlormethine (INN) (bis(2-chloroethyl)methylamine) ",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.19.6140",
      "rawHtsCode": "2921.19.61.40",
      "superior": null,
      "indent": "4",
      "description": "Trichlormethine (INN) (tris(2-chloroethyl)amine) ",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.19.6195",
      "rawHtsCode": "2921.19.61.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.21.0000",
      "rawHtsCode": "2921.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ethylenediamine and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "39%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.22",
      "rawHtsCode": "2921.22",
      "superior": null,
      "indent": "2",
      "description": "Hexamethylenediamine and its salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.22.0500",
      "rawHtsCode": "2921.22.05.00",
      "superior": null,
      "indent": "3",
      "description": "Hexamethylenediamine adipate (Nylon salt)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.22.1000",
      "rawHtsCode": "2921.22.10.00",
      "superior": null,
      "indent": "4",
      "description": "Derived in whole or in part from adipic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 66.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.22.5000",
      "rawHtsCode": "2921.22.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.29.00",
      "rawHtsCode": "2921.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.29.0010",
      "rawHtsCode": "2921.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Tetraethylene pentamine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.29.0020",
      "rawHtsCode": "2921.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Triethylenetetramine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.29.0030",
      "rawHtsCode": "2921.29.00.30",
      "superior": null,
      "indent": "3",
      "description": "Diethylenetriamine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.29.0055",
      "rawHtsCode": "2921.29.00.55",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.30",
      "rawHtsCode": "2921.30",
      "superior": null,
      "indent": "1",
      "description": "Cyclanic, cyclenic or cycloterpenic mono- or polyamines, and their derivatives; salts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.30.0500",
      "rawHtsCode": "2921.30.05.00",
      "superior": null,
      "indent": "3",
      "description": "1,3-Bis(aminoethyl)cyclohexane",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2921.30.1000",
      "rawHtsCode": "2921.30.10.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.30.3000",
      "rawHtsCode": "2921.30.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.30.5000",
      "rawHtsCode": "2921.30.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.41",
      "rawHtsCode": "2921.41",
      "superior": null,
      "indent": "2",
      "description": "Aniline and its salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.41.1000",
      "rawHtsCode": "2921.41.10.00",
      "superior": null,
      "indent": "3",
      "description": "Aniline",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.41.2000",
      "rawHtsCode": "2921.41.20.00",
      "superior": null,
      "indent": "3",
      "description": "Aniline salts",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.42",
      "rawHtsCode": "2921.42",
      "superior": null,
      "indent": "2",
      "description": "Aniline derivatives and their salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.42.1000",
      "rawHtsCode": "2921.42.10.00",
      "superior": null,
      "indent": "3",
      "description": "<i>N</i>,<i>N</i>-Dimethylaniline",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.42.1500",
      "rawHtsCode": "2921.42.15.00",
      "superior": null,
      "indent": "3",
      "description": "<i>N</i>-Ethylaniline; and<i>N</i>,<i>N</i>-Diethylaniline",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.42.1600",
      "rawHtsCode": "2921.42.16.00",
      "superior": null,
      "indent": "3",
      "description": "2,4,5-Trichloroaniline",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2921.42.1800",
      "rawHtsCode": "2921.42.18.00",
      "superior": null,
      "indent": "3",
      "description": "<i>o</i>-Aminobenzenesulfonic acid (Orthanilic acid); 6-Chlorometanilic acid; 2-Chloro-5-nitroaniline; 4-Chloro-3-nitroaniline; 2,3-Dichloroaniline; 2,4-Dichloroaniline; 2,5-Dichloroaniline; 3,5-Dichloroaniline;<i>N</i>,<i>N</i>-Diethylmetanilic acid;<i>N</i>,<i>N</i>-Diethylmetanilic acid, sodium salt; 2,4-Difluoroaniline;<i>p</i>-Fluoroaniline;<i>N</i>-Methylaniline; and<i>m</i>-Nitroaniline",
      "units": [
        "kg"
      ],
      "generalRate": "5.8% ",
      "specialRate": "Free(A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE, S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.42.2100",
      "rawHtsCode": "2921.42.21.00",
      "superior": null,
      "indent": "3",
      "description": "Metanilic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.42.2200",
      "rawHtsCode": "2921.42.22.00",
      "superior": null,
      "indent": "3",
      "description": "Sulfanilic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.42.2300",
      "rawHtsCode": "2921.42.23.00",
      "superior": null,
      "indent": "3",
      "description": "3,4-Dichloroaniline",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.42.3600",
      "rawHtsCode": "2921.42.36.00",
      "superior": null,
      "indent": "3",
      "description": "<i>m</i>-Chloroaniline; 2-Chloro-4-nitroaniline; 2,5-Dichloroaniline-4-sulfonic acid and its monosodium salt; 2,4-Dinitroaniline;<i>o</i>-Nitroaniline-<i>p</i>-sulfonic acid, sodium salt; and 2,3,4-Trifluoroaniline",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2921.42.5500",
      "rawHtsCode": "2921.42.55.00",
      "superior": null,
      "indent": "4",
      "description": "Fast color bases",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.42.6500",
      "rawHtsCode": "2921.42.65.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.42.9000",
      "rawHtsCode": "2921.42.90.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.43",
      "rawHtsCode": "2921.43",
      "superior": null,
      "indent": "2",
      "description": "Toluidines and their derivatives; salts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.43.0400",
      "rawHtsCode": "2921.43.04.00",
      "superior": null,
      "indent": "3",
      "description": "3-Chloro-<i>o</i>-toluidine; and 6-Chloro-<i>o</i>-toluidine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2921.43.0800",
      "rawHtsCode": "2921.43.08.00",
      "superior": null,
      "indent": "3",
      "description": "4-Chloro-<i>o</i>-toluidine and hydrochloride; 5-Chloro-<i>o</i>-toluidine; 6-Chloro-2-toluidine-4-sulfonic acid; 4-Chloro-<i>α</i>,<i>α</i>,<i>α</i>-trifluoro-<i>o</i>- toluidine; 2,6-Dichloro-<i>m</i>-toluidine;<i>N</i>,<i>N</i>- Dimethyl-<i>p</i>-toluidine;<i></i><i>N</i>-Ethyl-<i>N</i>-benzyl-<i>m</i>-toluidine; and<i>N</i>-Ethyl-<i>o</i>-toluidine",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.43.1500",
      "rawHtsCode": "2921.43.15.00",
      "superior": null,
      "indent": "3",
      "description": "<i>α</i>,<i>α</i>,<i>α</i>-Trifluoro-2,6-dinitro-<i>N</i>,<i>N</i>-dipropyl-<i>p</i>- toluidine (Trifluralin)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.43.1900",
      "rawHtsCode": "2921.43.19.00",
      "superior": null,
      "indent": "3",
      "description": "<i>α</i>,<i>α</i>,<i>α</i>-Trifluoro-<i>o</i>-toluidine; and<i>α</i>,<i>α</i>,<i>α</i>-Trifluoro-6-chloro-<i>m</i>-toluidine",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.43.2200",
      "rawHtsCode": "2921.43.22.00",
      "superior": null,
      "indent": "3",
      "description": "<i>N</i>-Ethyl-<i>N</i>-(2-methyl-2-propenyl)-2,6- dinitro-4-(trifluoromethyl)benzenamine",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.43.2400",
      "rawHtsCode": "2921.43.24.00",
      "superior": null,
      "indent": "3",
      "description": "2-Amino-5-chloro-4-ethyl benzenesulfonic acid; 2-Amino-5-chloro-<i>p</i>-toluenesulfonic acid;<i>p</i>-Nitro-<i>o</i>-toluidine; and 3-(Trifluoromethyl) aniline (<i>m</i>-Aminobenzotrifluoride)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2921.43.4000",
      "rawHtsCode": "2921.43.40.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.43.90",
      "rawHtsCode": "2921.43.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.43.9020",
      "rawHtsCode": "2921.43.90.20",
      "superior": null,
      "indent": "5",
      "description": "2-Chloro-<i>p</i>-toluidine-5-sulfonic acid (CAS No. 88-51-7)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.43.9040",
      "rawHtsCode": "2921.43.90.40",
      "superior": null,
      "indent": "5",
      "description": "<i>p</i>-Toluidine-<i>m</i>-sulfonic acid (CAS No. 88-44-8)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.43.9090",
      "rawHtsCode": "2921.43.90.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.44",
      "rawHtsCode": "2921.44",
      "superior": null,
      "indent": "2",
      "description": "Diphenylamine and its derivatives; salts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.44.0500",
      "rawHtsCode": "2921.44.05.00",
      "superior": null,
      "indent": "3",
      "description": "4,4'-Bis (<i>α</i>,<i>α</i>-dimethylbenzyl) diphenylamine; and<i>N</i>-Nitrosodiphenylamine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2921.44.1000",
      "rawHtsCode": "2921.44.10.00",
      "superior": null,
      "indent": "3",
      "description": "Nitrodiphenylamine",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.44.2000",
      "rawHtsCode": "2921.44.20.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.44.7000",
      "rawHtsCode": "2921.44.70.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.45",
      "rawHtsCode": "2921.45",
      "superior": null,
      "indent": "2",
      "description": "1-Naphthylamine (<i>α</i>-Naphthylamine), 2-Naphthylamine (<i>β</i>-Naphthylamine), and their derivatives; salts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.45.1000",
      "rawHtsCode": "2921.45.10.00",
      "superior": null,
      "indent": "3",
      "description": "7-Amino-1,3-naphthalenedisulfonic acid and its salts; 5-Amino-2-naphthalenesulfonic acid and its salts; 8-Amino-1-naphthalenesulfonic acid and its salts; and<i>N</i>-Phenyl-2-naphthylamine",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.45.2000",
      "rawHtsCode": "2921.45.20.00",
      "superior": null,
      "indent": "3",
      "description": "3-Amino-2,7-naphthalenedisulfonic acid; 4-Amino-1-naphthalenesulfonic acid, sodium salt; 5-Amino-1-naphthalenesulfonic acid (Laurent's acid); 8-Amino-2-naphthalenesulfonic acid and its salts; 7-Amino-1,3,6-naphthalenetrisulfonic acid; 8-Anilino-1-naphthalenesulfonic acid (Phenyl Peri acid) and its salts; and<i>N</i>-Ethyl-1-naphthylamine",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.45.2500",
      "rawHtsCode": "2921.45.25.00",
      "superior": null,
      "indent": "3",
      "description": "Mixtures of 5- and 8-amino-2-naphthalene- sulfonic acid; 2-Naphthylamine-6-sulfonic acid; and<i>o</i>-Naphthionic acid (1-amino- 2-naphthalene- sulfonic acid)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2921.45.6000",
      "rawHtsCode": "2921.45.60.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.45.90",
      "rawHtsCode": "2921.45.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.45.9010",
      "rawHtsCode": "2921.45.90.10",
      "superior": null,
      "indent": "5",
      "description": "2-Amino-1-naphthalenesulfonic acid (Tobias acid)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.45.9090",
      "rawHtsCode": "2921.45.90.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.46.0000",
      "rawHtsCode": "2921.46.00.00",
      "superior": null,
      "indent": "2",
      "description": "Amfetamine (INN), benzfetamine (INN), dexamfetamine (INN), etilamfetamine (INN), fencamfamin (INN), lefetamine (INN), levamfetamine (INN), mefenorex (INN) and phentermine (INN); salts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 149.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.49",
      "rawHtsCode": "2921.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.49.1000",
      "rawHtsCode": "2921.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "4-Amino-2-stilbenesulfonic acid and its salts;<i>p</i>-Ethylaniline; 2,4,6-Trimethylaniline (Mesidine); 2,3-Xylidine; 2,4-Xylidine; 2,5-Xylidine; and 3,4-Xylidine",
      "units": [
        "kg"
      ],
      "generalRate": "5.8% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.49.1500",
      "rawHtsCode": "2921.49.15.00",
      "superior": null,
      "indent": "3",
      "description": "<i>m</i>-Nitro-<i>p</i>-toluidine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 53%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2921.49.3200",
      "rawHtsCode": "2921.49.32.00",
      "superior": null,
      "indent": "4",
      "description": "Fast color bases",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.49.3800",
      "rawHtsCode": "2921.49.38.00",
      "superior": null,
      "indent": "5",
      "description": "Antidepressants, tranquilizers and other psychotherapeutic agents",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 149.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.49.4300",
      "rawHtsCode": "2921.49.43.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 71.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.49.4500",
      "rawHtsCode": "2921.49.45.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.49.5000",
      "rawHtsCode": "2921.49.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.51",
      "rawHtsCode": "2921.51",
      "superior": null,
      "indent": "2",
      "description": "<i>o</i>-, <i>m</i>-, <i>p</i>-Phenylenediamine, diaminotoluenes, and their derivatives; salts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.51.1000",
      "rawHtsCode": "2921.51.10.00",
      "superior": null,
      "indent": "3",
      "description": "4-Amino-2-(<i>N</i>,<i>N</i>-diethylamino) toluene hydrochloride;<i>m</i>-Phenylenediamine;<i>o</i>-Phenylenediamine; Toluene-2,4-diamine; Toluene-2,5-diamine; and Toluene-2,5-diamine sulfate",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.51.2000",
      "rawHtsCode": "2921.51.20.00",
      "superior": null,
      "indent": "4",
      "description": "Photographic chemicals",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.51.3000",
      "rawHtsCode": "2921.51.30.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.51.5000",
      "rawHtsCode": "2921.51.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.59",
      "rawHtsCode": "2921.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.59.0400",
      "rawHtsCode": "2921.59.04.00",
      "superior": null,
      "indent": "3",
      "description": "1,8-Diaminonaphthalene (1,8-Naphthalenediamine)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2921.59.0800",
      "rawHtsCode": "2921.59.08.00",
      "superior": null,
      "indent": "3",
      "description": "5-Amino-2-(<i>p</i>-aminoanilino) benzenesulfonic acid; 4,4'-Diamino-3-biphenylsulfonic acid (3-Benzidinesulfonic acid); 3,3'-Dimethylbenzidine (<i>o</i>-Tolidine); 3,3'-Dimethylbenzidine hydrochloride; Ethyl-(2-dimethylaminoethyl) aniline;<i>N</i>-Ethyl-<i>N</i>,<i>N</i>'-dimethyl-<i>N</i>'-phenylethylene- diamine; and 4,4'-Methylenebis(2-chloroaniline)",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.59.1700",
      "rawHtsCode": "2921.59.17.00",
      "superior": null,
      "indent": "3",
      "description": "4,4'-Benzidine-2,2'-disulfonic acid; 1,4-Diaminobenzene-2-sulfonic acid; 4,4'-Methylene bis ((3-chloro-2,6-diethylaniline); 4,4'-Methylene bis(2,6-diethylaniline); 4,4'-Methylene bis (2,6-diisopropylaniline);<i>m</i>-Xylene diamine; and 3,3'-Diaminobenzidine (tetraaminobiphenyl)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2921.59.2000",
      "rawHtsCode": "2921.59.20.00",
      "superior": null,
      "indent": "3",
      "description": "4,4'-Diamino-2,2'-stilbenedisulfonic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.59.3000",
      "rawHtsCode": "2921.59.30.00",
      "superior": null,
      "indent": "3",
      "description": "4,4'-Methylenedianiline",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.59.4000",
      "rawHtsCode": "2921.59.40.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.59.80",
      "rawHtsCode": "2921.59.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2921.59.8010",
      "rawHtsCode": "2921.59.80.10",
      "superior": null,
      "indent": "5",
      "description": "3,3'-Dichlorobenzidine dihydrochloride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2921.59.8090",
      "rawHtsCode": "2921.59.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922",
      "rawHtsCode": "2922",
      "superior": null,
      "indent": "0",
      "description": "Oxygen-function amino-compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.11.0000",
      "rawHtsCode": "2922.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Monoethanolamine and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.12.0001",
      "rawHtsCode": "2922.12.00.01",
      "superior": null,
      "indent": "2",
      "description": "Diethanolamine and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.14.0000",
      "rawHtsCode": "2922.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dextropropoxyphene (INN) and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 119.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.15.0000",
      "rawHtsCode": "2922.15.00.00",
      "superior": null,
      "indent": "2",
      "description": "Triethanolamine",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.16.0000",
      "rawHtsCode": "2922.16.00.00",
      "superior": null,
      "indent": "2",
      "description": "Diethylammonium perfluorooctane sulfonate",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.17.0000",
      "rawHtsCode": "2922.17.00.00",
      "superior": null,
      "indent": "2",
      "description": "Methyldiethanolamine and ethyldiethanolamine",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.18.0000",
      "rawHtsCode": "2922.18.00.00",
      "superior": null,
      "indent": "2",
      "description": "2-(N,N-Diisopropylamino)ethanol",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.19",
      "rawHtsCode": "2922.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.19.0900",
      "rawHtsCode": "2922.19.09.00",
      "superior": null,
      "indent": "4",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.19.2000",
      "rawHtsCode": "2922.19.20.00",
      "superior": null,
      "indent": "5",
      "description": "4,4'-Bis(dimethylamino) benzhydrol (Michler's hydrol); 5'-[3'-(Dimethylamino) propyl]-10',11'- dihydro-5<i>H</i>'-dibenzo [<i>a</i>,<i>b</i>] cyclohept- en-5'-ol (Dibenzcarbinol); and 1-(<i>p</i>-Nitrophenyl)-2-amino-1,3- propanediol",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.19.3300",
      "rawHtsCode": "2922.19.33.00",
      "superior": null,
      "indent": "5",
      "description": "<i>N</i>1-(2-Hydroxyethyl)-2-nitro-1,4- phenylenediamine;<i>N1</i>,<i>N4</i>,<i>N4</i>- Tris(2-hydroxyethyl)-2- nitro-1,4- phenylenediamine;<i>N</i>1,<i>N</i>4-Dimethyl-<i>N</i>1- (2-hydroxyethyl)-3-nitro-1,4- phenylene- diamine;<i>N</i>1,<i>N</i>4-Dimethyl-<i>N</i>1-(2,3-dihydroxy- propyl)-3-nitro-1,4- phenylenediamine; and<i>N</i>1-(2-Hydroxyethyl)-3-nitro-1,4- phenylenediamine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.19.6000",
      "rawHtsCode": "2922.19.60.00",
      "superior": null,
      "indent": "6",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.19.7000",
      "rawHtsCode": "2922.19.70.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.19.9000",
      "rawHtsCode": "2922.19.90.00",
      "superior": null,
      "indent": "4",
      "description": "Salts of triethanolamine",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.19.96",
      "rawHtsCode": "2922.19.96",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.19.9610",
      "rawHtsCode": "2922.19.96.10",
      "superior": null,
      "indent": "6",
      "description": "N,N-Dimethyl-2-aminoethanol, N,N-diethyl-2-aminoethanol and their protonated salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.19.9619",
      "rawHtsCode": "2922.19.96.19",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.19.9690",
      "rawHtsCode": "2922.19.96.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.21",
      "rawHtsCode": "2922.21",
      "superior": null,
      "indent": "2",
      "description": "Aminohydroxynaphthalenesulfonic acids and their salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.21.1000",
      "rawHtsCode": "2922.21.10.00",
      "superior": null,
      "indent": "3",
      "description": "1-Amino-8-hydroxy-3,6-naphthalenedisulfonic acid; 4-Amino-5-hydroxy-1,3-naphthalenedisulfonic acid (Chicago acid); 4-Amino-5-hydroxy-1,3-naphthalenedisulfonic acid, potassium salt; 4-Amino-5-hydroxy-1,3-naphthalenedisulfonic acid, sodium salt; 4-Amino-5-hydroxy-2,7-naphthalenedisulfonic acid, monosodium salt (H acid, monosodium salt); 4-Amino-5-hydroxy-2,7-naphthalenedisulfonic acid, potassium salt (H acid, monopotassium salt); 4-Amino-3-hydroxy-1-naphthalenesulfonic acid; 6-Amino-1-naphthol-3-sulfonic acid and its salts; and 8-Amino-1-naphthol-5-sulfonic acid and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.21.2500",
      "rawHtsCode": "2922.21.25.00",
      "superior": null,
      "indent": "3",
      "description": "1-Amino-8-hydroxy-4,6-naphthalenedisulfonic acid, monosodium salt",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2922.21.4000",
      "rawHtsCode": "2922.21.40.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.21.5000",
      "rawHtsCode": "2922.21.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.29",
      "rawHtsCode": "2922.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.29.0300",
      "rawHtsCode": "2922.29.03.00",
      "superior": null,
      "indent": "3",
      "description": "<i>o</i>-Anisidine;<i>p</i>-Anisidine; and<i>p</i>-Phenetidine",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.29.0600",
      "rawHtsCode": "2922.29.06.00",
      "superior": null,
      "indent": "4",
      "description": "Fast color bases",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.29.0800",
      "rawHtsCode": "2922.29.08.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2922.29.1000",
      "rawHtsCode": "2922.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "2-Amino-6-chloro-4-nitrophenol; 2-Amino-4-chlorophenol; 2-Amino-4-chlorophenol hydrochloride; 2-Amino-<i>p</i>-cresol; 4-Amino-<i>o</i>-cresol; 6-Amino-2,4-dichloro-3-methylphenol; 2-(3-Amino-4-hydroxyphenylsulfonyl)ethanol; 2-Amino-4-nitrophenol; 2-Amino-4-nitrophenol, sodium salt; 2-Amino-5-nitrophenol;<i>m</i>-Aminophenol; 2-(4'-Aminophenoxy)ethylsulfate; 5-Chloro-2-(2',4'-dichlorophenoxy)aniline; 3,4-Dimethoxyphenethylamine (Homoveratrylamine); 2-Hydroxy-5-nitrometanilic acid; 4-Methoxymetanilic acid; 6-Methoxymetanilic acid; 4-Methoxy-<i>m</i>-phenylenediamine; 5-Methoxy-<i>m</i>-phenylenediamine sulfate; 6-(Methylamino)-1-naphthol-3-sulfonic acid; 7-(Methylamino)-1-naphthol-3-sulfonic acid; and 2-Methyl-<i>p</i>-anisidine",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.29.1300",
      "rawHtsCode": "2922.29.13.00",
      "superior": null,
      "indent": "3",
      "description": "<i>o</i>-Aminophenol; and 2,2-Bis[4-(4-aminophenoxy)phenyl]propane",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2922.29.1500",
      "rawHtsCode": "2922.29.15.00",
      "superior": null,
      "indent": "3",
      "description": "<i>m</i>-Diethylaminophenol;<i>m</i>-Dimethylaminophenol; 3-Ethylamino-<i>p</i>-cresol; and 5-Methoxy-<i>m</i>-phenylenediamine",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.29.2000",
      "rawHtsCode": "2922.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "4-Chloro-2,5-dimethoxyaniline; and 2,4-Dimethoxyaniline",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 41.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2922.29.2600",
      "rawHtsCode": "2922.29.26.00",
      "superior": null,
      "indent": "4",
      "description": "Fast color bases",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.29.2700",
      "rawHtsCode": "2922.29.27.00",
      "superior": null,
      "indent": "4",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 71.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.29.2900",
      "rawHtsCode": "2922.29.29.00",
      "superior": null,
      "indent": "4",
      "description": "Photographic chemicals",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.29.6100",
      "rawHtsCode": "2922.29.61.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.29.81",
      "rawHtsCode": "2922.29.81",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.29.8110",
      "rawHtsCode": "2922.29.81.10",
      "superior": null,
      "indent": "6",
      "description": "<i>p</i>-Nitro-<i>o</i>-anisidine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.29.8190",
      "rawHtsCode": "2922.29.81.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.31.0000",
      "rawHtsCode": "2922.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Amfepramone (INN), methadone (INN) and normethadone (INN); salts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.39",
      "rawHtsCode": "2922.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.39.0500",
      "rawHtsCode": "2922.39.05.00",
      "superior": null,
      "indent": "4",
      "description": "1-Amino-2,4-dibromoanthraquinone; and 2-Amino-5-chlorobenzophenone",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2922.39.1000",
      "rawHtsCode": "2922.39.10.00",
      "superior": null,
      "indent": "4",
      "description": "2'-Amino aceto phenone; 3'-Amino aceto phenone; 1-Amino-4-bromo-2-methyl anthra quinone; 1,4-Bis [1-anthra quinonyl amino] anthra- quinone; 1,4-Di mesi dino anthra quinone; 4-Dimethyl amino benzaldehyde; and Imino di anthra quinone",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.39.1400",
      "rawHtsCode": "2922.39.14.00",
      "superior": null,
      "indent": "4",
      "description": "2-Aminoanthraquinone",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.39.1700",
      "rawHtsCode": "2922.39.17.00",
      "superior": null,
      "indent": "4",
      "description": "1-Aminoanthraquinone",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2922.39.2500",
      "rawHtsCode": "2922.39.25.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.39.4500",
      "rawHtsCode": "2922.39.45.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.39.5000",
      "rawHtsCode": "2922.39.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.41.00",
      "rawHtsCode": "2922.41.00",
      "superior": null,
      "indent": "2",
      "description": "Lysine and its esters; salts thereof",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.41.0010",
      "rawHtsCode": "2922.41.00.10",
      "superior": null,
      "indent": "3",
      "description": "Meeting requirements of Food Chemical Codex, Codex Alimentarius or United States Pharmacopeia",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.41.0090",
      "rawHtsCode": "2922.41.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.42",
      "rawHtsCode": "2922.42",
      "superior": null,
      "indent": "2",
      "description": "Glutamic acid and its salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.42.1000",
      "rawHtsCode": "2922.42.10.00",
      "superior": null,
      "indent": "3",
      "description": "Monosodium glutamate",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.42.5000",
      "rawHtsCode": "2922.42.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.43",
      "rawHtsCode": "2922.43",
      "superior": null,
      "indent": "2",
      "description": "Anthranilic acid and its salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.43.1000",
      "rawHtsCode": "2922.43.10.00",
      "superior": null,
      "indent": "3",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.43.5000",
      "rawHtsCode": "2922.43.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.44.0000",
      "rawHtsCode": "2922.44.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tilidine (INN) and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.49",
      "rawHtsCode": "2922.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.49.0500",
      "rawHtsCode": "2922.49.05.00",
      "superior": null,
      "indent": "4",
      "description": "(R)-<i>α</i>-Aminobenzeneacetic acid; 2-Amino-3-chlorobenzoic acid, methyl ester",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2922.49.1000",
      "rawHtsCode": "2922.49.10.00",
      "superior": null,
      "indent": "4",
      "description": "<i>m</i>-Aminobenzoic acid, technical;<i>p</i>-Aminobenzoic acid; 3,5-Diaminobenzoic acid; 2-Ethylamino-5-sulfobenzoic acid; 3-(<i>N</i>-Ethylanilino)propionic acid, methyl ester;<i>β</i>-(<i>β</i>-Methoxyethoxyethyl)-4-aminobenzoate; Methyl anthranilate; and<i>l</i>-Phenylalanine",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.49.2600",
      "rawHtsCode": "2922.49.26.00",
      "superior": null,
      "indent": "5",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.49.3000",
      "rawHtsCode": "2922.49.30.00",
      "superior": null,
      "indent": "6",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.49.3700",
      "rawHtsCode": "2922.49.37.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.49.4300",
      "rawHtsCode": "2922.49.43.00",
      "superior": null,
      "indent": "5",
      "description": "Glycine (Aminoacetic acid)",
      "units": [
        "kg"
      ],
      "generalRate": "4.2% ",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.49.49",
      "rawHtsCode": "2922.49.49",
      "superior": null,
      "indent": "5",
      "description": "Other amino acids",
      "units": [],
      "generalRate": "4.2% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.49.4910",
      "rawHtsCode": "2922.49.49.10",
      "superior": null,
      "indent": "6",
      "description": "Alanine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.49.4915",
      "rawHtsCode": "2922.49.49.15",
      "superior": null,
      "indent": "6",
      "description": "<i>l</i>-Aspartic acid",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.49.4950",
      "rawHtsCode": "2922.49.49.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.49.6000",
      "rawHtsCode": "2922.49.60.00",
      "superior": null,
      "indent": "5",
      "description": "3-Aminocrotonic acid, methyl ester; and (R)-<i>α</i>-Amino-1,4-cyclohexadiene-1- acetic acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2922.49.8000",
      "rawHtsCode": "2922.49.80.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.50",
      "rawHtsCode": "2922.50",
      "superior": null,
      "indent": "1",
      "description": "Amino-alcohol-phenols, amino-acid-phenols and other amino-compounds with oxygen function:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.50.0700",
      "rawHtsCode": "2922.50.07.00",
      "superior": null,
      "indent": "3",
      "description": "3,4-Diaminophenetole dihydrogen sulfate; 2-Nitro-5-[(2,3-dihydroxy) propoxy]-<i>N</i>- methyl aniline; 2-Nitro-5-(2-hydroxy ethoxy)-<i>N</i>-methyl aniline; 4-(2-Hydroethoxy)-1,3-phenylene diamine dihydro chloride; 3-Methoxy-4-[(2-hydroxy ethyl) amino] nitro- benzene; 4-[(2-Hydroxy ethyl) amino]-3-nitro phenol; and (R)-<i>α</i>-Amino-4-hydroxy benzene acetic acid (<i>d</i>(-)-<i>p</i>-Hydroxy phenyl glycine)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.50.1000",
      "rawHtsCode": "2922.50.10.00",
      "superior": null,
      "indent": "3",
      "description": "<i>dl</i>-3-(3,4-Di hydroxy phenyl) alanine;<i>N</i>-Ethyl-<i>N</i>-(2-methoxy carbonyl ethyl) aniline;<i>dl</i>-Phenyl ephrine base; and Carbonic acid, methyl ester, diester with 2,2'-(<i>m</i>-tolyl amino) diethanol (Toluidine carbonate)",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.50.1100",
      "rawHtsCode": "2922.50.11.00",
      "superior": null,
      "indent": "3",
      "description": "Salts of <i>d</i>(-)-<i>p</i>-Hydroxyphenylglycine ((R)- <i>α</i>-Amino-4-hydroxybenzeneacetic acid)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.50.1300",
      "rawHtsCode": "2922.50.13.00",
      "superior": null,
      "indent": "5",
      "description": "Isoetharine hydrochloride; Isoxsuprine hydrochloride; Nylidrin hydrochloride; Phenylephrine hydrochloride; Salbutamol (Albuterol); and Terbutaline sulfate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 47%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2922.50.1400",
      "rawHtsCode": "2922.50.14.00",
      "superior": null,
      "indent": "6",
      "description": "Cardiovascular drugs",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.50.1700",
      "rawHtsCode": "2922.50.17.00",
      "superior": null,
      "indent": "6",
      "description": "Dermatological agents and local anesthetics",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.50.1900",
      "rawHtsCode": "2922.50.19.00",
      "superior": null,
      "indent": "6",
      "description": "Guaiacol derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 79%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.50.2500",
      "rawHtsCode": "2922.50.25.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 82%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.50.3500",
      "rawHtsCode": "2922.50.35.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.50.4000",
      "rawHtsCode": "2922.50.40.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2922.50.5000",
      "rawHtsCode": "2922.50.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2923",
      "rawHtsCode": "2923",
      "superior": null,
      "indent": "0",
      "description": "Quaternary ammonium salts and hydroxides; lecithins and other phosphoaminolipids, whether or not chemically defined:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2923.10.0000",
      "rawHtsCode": "2923.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Choline and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2923.20",
      "rawHtsCode": "2923.20",
      "superior": null,
      "indent": "1",
      "description": "Lecithins and other phosphoaminolipids:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2923.20.1000",
      "rawHtsCode": "2923.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Purified egg phospholipids, pharmaceutical grade meeting requirements of the U.S. Food and Drug Administration, for use in intravenous fat emulsion",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "16.5¢/kg + 30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2923.20.20",
      "rawHtsCode": "2923.20.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33.4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2923.20.2010",
      "rawHtsCode": "2923.20.20.10",
      "superior": null,
      "indent": "3",
      "description": "Certified organic lecithins",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2923.20.2050",
      "rawHtsCode": "2923.20.20.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2923.30.0000",
      "rawHtsCode": "2923.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tetraethylammonium perfluorooctane sulfonate",
      "units": [
        "kg"
      ],
      "generalRate": "6.2% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2923.40.0000",
      "rawHtsCode": "2923.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Didecylmethylammonium perfluorooctane sulfonate",
      "units": [
        "kg"
      ],
      "generalRate": "6.2% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2923.90.0100",
      "rawHtsCode": "2923.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.2% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924",
      "rawHtsCode": "2924",
      "superior": null,
      "indent": "0",
      "description": "Carboxyamide-function compounds; amide-function compounds of carbonic acid:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.11.0000",
      "rawHtsCode": "2924.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Meprobamate (INN)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.12.0000",
      "rawHtsCode": "2924.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fluoroacetamide (ISO), monocrotophos (ISO) and phosphamidon (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.19",
      "rawHtsCode": "2924.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.19.11",
      "rawHtsCode": "2924.19.11",
      "superior": null,
      "indent": "3",
      "description": "Amides",
      "units": [],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.19.1110",
      "rawHtsCode": "2924.19.11.10",
      "superior": null,
      "indent": "4",
      "description": "Acrylamide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.19.1120",
      "rawHtsCode": "2924.19.11.20",
      "superior": null,
      "indent": "4",
      "description": "Dimethylformamide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.19.1130",
      "rawHtsCode": "2924.19.11.30",
      "superior": null,
      "indent": "4",
      "description": "Methacrylamide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.19.1150",
      "rawHtsCode": "2924.19.11.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.19.8000",
      "rawHtsCode": "2924.19.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.21",
      "rawHtsCode": "2924.21",
      "superior": null,
      "indent": "2",
      "description": "Ureines and their derivatives; salts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.21.0400",
      "rawHtsCode": "2924.21.04.00",
      "superior": null,
      "indent": "5",
      "description": "3-(<i>p</i>-Chlorophenyl)-1,1-dimethylurea (Monuron)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.21.0800",
      "rawHtsCode": "2924.21.08.00",
      "superior": null,
      "indent": "5",
      "description": "1,1-Dimethyl-3-(<i>α</i>,<i>α</i>,<i>α</i>-trifluoro-<i>m</i>- tolyl)urea (Fluometuron)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2924.21.1200",
      "rawHtsCode": "2924.21.12.00",
      "superior": null,
      "indent": "5",
      "description": "1-(2-Methylcyclohexyl)-3-phenylurea",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2924.21.1600",
      "rawHtsCode": "2924.21.16.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.21.1800",
      "rawHtsCode": "2924.21.18.00",
      "superior": null,
      "indent": "5",
      "description": "<i>sym</i>-Diethyldiphenylurea",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.21.2000",
      "rawHtsCode": "2924.21.20.00",
      "superior": null,
      "indent": "6",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.21.4500",
      "rawHtsCode": "2924.21.45.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.21.5000",
      "rawHtsCode": "2924.21.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.23",
      "rawHtsCode": "2924.23",
      "superior": null,
      "indent": "2",
      "description": "2-Acetamidobenzoic acid (<i>N</i>-acetylanthranilic acid) and its salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.23.1000",
      "rawHtsCode": "2924.23.10.00",
      "superior": null,
      "indent": "3",
      "description": "2-Acetamidobenzoic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.23.7000",
      "rawHtsCode": "2924.23.70.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.23.7500",
      "rawHtsCode": "2924.23.75.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.24.0000",
      "rawHtsCode": "2924.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ethinamate (INN)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.25.0000",
      "rawHtsCode": "2924.25.00.00",
      "superior": null,
      "indent": "2",
      "description": "Alachlor (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29",
      "rawHtsCode": "2924.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.29.0100",
      "rawHtsCode": "2924.29.01.00",
      "superior": null,
      "indent": "4",
      "description": "<i>p</i>-Acetanisidide;<i>p</i>-Acetoacetotoluidide; 4'-Amino-<i>N</i>-methylacetanilide; 2,5-Dimethoxyacetanilide; and<i>N</i>-(7-Hydroxy-1-naphthyl)acetamide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2924.29.0300",
      "rawHtsCode": "2924.29.03.00",
      "superior": null,
      "indent": "4",
      "description": "3,5-Dinitro-<i>o</i>-toluamide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 47.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.29.0500",
      "rawHtsCode": "2924.29.05.00",
      "superior": null,
      "indent": "4",
      "description": "Biligrafin acid; 3,5-Diacetamido-2,4,6-triiodobenzoic acid; and Metrizoic acid",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 34%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29.1000",
      "rawHtsCode": "2924.29.10.00",
      "superior": null,
      "indent": "4",
      "description": "Acetanilide;<i>N</i>-Acetylsulfanilyl chloride; Aspartame; and 2-Methoxy-5-acetamino-<i>N</i>,<i>N</i>- bis(2-acetoxyethyl)aniline",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29.2000",
      "rawHtsCode": "2924.29.20.00",
      "superior": null,
      "indent": "4",
      "description": "2-Acetamido-3-chloro anthra quinone;<i>o</i>-Aceto acetanisidide;<i>o</i>-Acetoacetotoluidide; 2',4'-Acetoacetoxylidide; and 1-Amino-5-benzamido anthra quinone",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29.2300",
      "rawHtsCode": "2924.29.23.00",
      "superior": null,
      "indent": "4",
      "description": "4-Amino acetanilide; 2,2'-Oxamido bis [ethyl-3-(3,5-di-tert-butyl- 4-hydroxyphenyl) propionate]; Aceto acetsulfanilic acid, potassium salt; and N-(2,3-Dihydroxy propyl)-5-<i>N</i>-(2,3-dihydroxy- propyl) acetamido-<i>N</i>'-(2-hydroxyethyl)- 2,4,6-triiodoisophthalamide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.29.2600",
      "rawHtsCode": "2924.29.26.00",
      "superior": null,
      "indent": "4",
      "description": "3-Aminomethoxybenzanilide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.29.2800",
      "rawHtsCode": "2924.29.28.00",
      "superior": null,
      "indent": "4",
      "description": "<i>N</i>-[[(4-Chlorophenyl)amino]carbonyl]-2,6- difluorobenzamide; and 3,5-Dichloro-N-(1,1-dimethyl-2-propynyl)- benzamide (Pronamide)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2924.29.3100",
      "rawHtsCode": "2924.29.31.00",
      "superior": null,
      "indent": "4",
      "description": "4-Acetamido-2-amino phenol;<i>p</i>-Acetamino benz aldehyde; Aceto acet benzyl amide; Aceto acet-5-chloro-2-toluidide;<i>p</i>-Aceto aceto phenetidide;<i>N</i>-Acetyl-2,6-xylidine (<i>N</i>-Acetyl-2,6- dimethyl aniline);<i>p</i>-Amino benzoic acid iso octyl amide;<i>p</i>-Amino benzoyl amino naphthalene sulfonic acid; 2-Amino-4-chloro benzamide; 3-Amino-4-chloro benzamide; 4-Amino hippuric acid;<i>p</i>-Amino phenyl urethane; 1-Benzamido-4-chloro anthra quinone; 1-Benzamido-5-chloro anthra quinone; Benzanilide; 4'-Chloro aceto acetanilide; 3-(<i>N</i>,<i>N</i>-Dihydroxy ethyl amino) benzanilide; 2,5-Dihydroxy-<i>N</i>-(2-hydroxyethyl)- benzamide; Gentisamide;<i>N</i>,<i>N</i>'-Hexa methylene bis(3,5-di-tert-butyl- 4-hydroxy hydrocinnamamide); 2-(<i>m</i>-Hydroxyanilino) acetamide; Nitra acid amide (1-Amino-9,10-dihydro-<i>N</i>- (3-methoxy propyl)-4-nitro-9,10-dioxo-2- anthramide); Phenacetin, technical; and<i>β</i>-Resorcyl amide",
      "units": [
        "kg"
      ],
      "generalRate": "5.8% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29.3300",
      "rawHtsCode": "2924.29.33.00",
      "superior": null,
      "indent": "5",
      "description": "3-Hydroxy-2-naphthanilide; 3-Hydroxy-2-naphtho-<i>o</i>-toluidide; 3-Hydroxy-2-naphtho-<i>o</i>-anisidine; 3-Hydroxy-2-naphtho-<i>o</i>-phenetidide; 3-Hydroxy-2-naphtho-4-chloro-2,5- dimethoxyanilide; 3-Hydroxy-3'-nitro-2-naphthanilide; and<i>N</i>,<i>N</i>'-Bis(acetoacetyl-<i>o</i>-toluidine)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2924.29.3600",
      "rawHtsCode": "2924.29.36.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29.4300",
      "rawHtsCode": "2924.29.43.00",
      "superior": null,
      "indent": "6",
      "description": "3-Ethoxy carbonyl amino phenyl-<i>N</i>-phenyl carbamate (Desmedipham); and Isopropyl-<i>N</i>-(3-chlorophenyl) car-bamate (CIPC)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29.4700",
      "rawHtsCode": "2924.29.47.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29.5200",
      "rawHtsCode": "2924.29.52.00",
      "superior": null,
      "indent": "5",
      "description": "Fast color bases",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29.5700",
      "rawHtsCode": "2924.29.57.00",
      "superior": null,
      "indent": "6",
      "description": "Diethylaminoacetoxylidide (Lidocaine)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 101.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.29.62",
      "rawHtsCode": "2924.29.62",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 47.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29.6210",
      "rawHtsCode": "2924.29.62.10",
      "superior": null,
      "indent": "7",
      "description": "Acetaminophen",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.29.6220",
      "rawHtsCode": "2924.29.62.20",
      "superior": null,
      "indent": "7",
      "description": "Acetophenetidin (Phenacetin)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.29.6250",
      "rawHtsCode": "2924.29.62.50",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.29.6500",
      "rawHtsCode": "2924.29.65.00",
      "superior": null,
      "indent": "6",
      "description": "5-Bromoacetyl-2-salicylamide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29.7100",
      "rawHtsCode": "2924.29.71.00",
      "superior": null,
      "indent": "7",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29.77",
      "rawHtsCode": "2924.29.77",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2924.29.7710",
      "rawHtsCode": "2924.29.77.10",
      "superior": null,
      "indent": "8",
      "description": "Acetoacetanilide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.29.7720",
      "rawHtsCode": "2924.29.77.20",
      "superior": null,
      "indent": "8",
      "description": "Acetoacet-2,5-dimethoxy-4- chloroanilide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.29.7730",
      "rawHtsCode": "2924.29.77.30",
      "superior": null,
      "indent": "8",
      "description": "<i>p</i>-Aminobenzamide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.29.7790",
      "rawHtsCode": "2924.29.77.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2924.29.8000",
      "rawHtsCode": "2924.29.80.00",
      "superior": null,
      "indent": "4",
      "description": "2,2-Dimethylcyclopropylcarboxamide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2924.29.9500",
      "rawHtsCode": "2924.29.95.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2925",
      "rawHtsCode": "2925",
      "superior": null,
      "indent": "0",
      "description": "Carboxyimide-function compounds (including saccharin and its salts) and imine-function compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2925.11.0000",
      "rawHtsCode": "2925.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Saccharin and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 61%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2925.12.0000",
      "rawHtsCode": "2925.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Glutethimide (INN)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 61%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2925.19",
      "rawHtsCode": "2925.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2925.19.1000",
      "rawHtsCode": "2925.19.10.00",
      "superior": null,
      "indent": "4",
      "description": "Ethylenebistetrabromophthalimide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 61%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2925.19.3000",
      "rawHtsCode": "2925.19.30.00",
      "superior": null,
      "indent": "4",
      "description": "Bis(<i>o</i>-tolyl)carbodiimide; and 2,2',6,6'-Tetra isopropyl diphenyl carbodiimide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 61%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2925.19.4200",
      "rawHtsCode": "2925.19.42.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 61%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2925.19.7000",
      "rawHtsCode": "2925.19.70.00",
      "superior": null,
      "indent": "4",
      "description": "<i>N</i>-Chlorosuccinimide; and<i>N</i>,<i>N</i>'-Ethylene bis (5,6-dibromo-2,3- norbornane dicarboximide)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2925.19.9100",
      "rawHtsCode": "2925.19.91.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2925.21.0000",
      "rawHtsCode": "2925.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Chlordimeform (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 61%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2925.29",
      "rawHtsCode": "2925.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2925.29.1000",
      "rawHtsCode": "2925.29.10.00",
      "superior": null,
      "indent": "4",
      "description": "<i>N</i>'-(4-Chloro-<i>o</i>-tolyl)-<i>N</i>,<i>N</i>- diemthylformamidine; Bunamidine hydrochloride; and Pentamidine",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 41%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2925.29.1800",
      "rawHtsCode": "2925.29.18.00",
      "superior": null,
      "indent": "4",
      "description": "<i>N</i>,<i>N</i>'-Diphenylguanidine; 3-Dimethyl amino methyleneiminophenol hydrochloride; 1,3-Di-<i>o</i>-tolylguanidine; and<i>N</i>,<i>N</i>-Dimethyl-<i>N</i>'-[3-[[(methylamino) carbonyl]- oxy] phenyl] methanimidamide monohydro- chloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 61%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2925.29.2000",
      "rawHtsCode": "2925.29.20.00",
      "superior": null,
      "indent": "5",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 67.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2925.29.6000",
      "rawHtsCode": "2925.29.60.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 61%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2925.29.7000",
      "rawHtsCode": "2925.29.70.00",
      "superior": null,
      "indent": "4",
      "description": "Tetramethylguanidine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2925.29.9000",
      "rawHtsCode": "2925.29.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926",
      "rawHtsCode": "2926",
      "superior": null,
      "indent": "0",
      "description": "Nitrile-function compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2926.10.0000",
      "rawHtsCode": "2926.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Acrylonitrile",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "56.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.20.0000",
      "rawHtsCode": "2926.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "1-Cyanoguanidine (Dicyandiamide)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2926.30",
      "rawHtsCode": "2926.30",
      "superior": null,
      "indent": "1",
      "description": "Fenproporex (INN) and its salts; Methadone (INN) intermediate (4-cyano-2-dimethylamino-4,4- diphenylbutane):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2926.30.1000",
      "rawHtsCode": "2926.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fenproporex (INN) and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 65.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2926.30.2000",
      "rawHtsCode": "2926.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "4-Cyano-2-dimethylamino-4,4-diphenylbutane",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 65.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.40.0000",
      "rawHtsCode": "2926.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "alpha-Phenylacetoacetonitrile",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 65.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.90",
      "rawHtsCode": "2926.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2926.90.0100",
      "rawHtsCode": "2926.90.01.00",
      "superior": null,
      "indent": "3",
      "description": "2-Cyano-4-nitroaniline",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 41%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2926.90.0500",
      "rawHtsCode": "2926.90.05.00",
      "superior": null,
      "indent": "3",
      "description": "2-Amino-4-chlorobenzonitrile (5-Chloro-2- cyanoaniline); 2-Amino-5-chlorobenzonitrile; 4-Amino-2-chlorobenzonitrile; (Cyanoethyl)(hydroxyethyl)-<i>m</i>-toluidine;<i>p</i>-Cyanophenyl acetate; Phthalonitrile; and Tetrachloro-3-cyanobenzoic acid, methyl ester",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 41%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.90.0800",
      "rawHtsCode": "2926.90.08.00",
      "superior": null,
      "indent": "3",
      "description": "Benzonitrile",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 41%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.90.1100",
      "rawHtsCode": "2926.90.11.00",
      "superior": null,
      "indent": "4",
      "description": "2,6-Dichlorobenzonitrile",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 41%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2926.90.1200",
      "rawHtsCode": "2926.90.12.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 41%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.90.1400",
      "rawHtsCode": "2926.90.14.00",
      "superior": null,
      "indent": "3",
      "description": "<i>p</i>-Chlorobenzonitrile; and Verapamil hydrochloride",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 65.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.90.1600",
      "rawHtsCode": "2926.90.16.00",
      "superior": null,
      "indent": "3",
      "description": "[1<i>α</i>(S*),3<i>α</i>(Z)]-(±)-Cyano(3-phenoxyphenyl)- methyl 3-(2-chloro-3,3,3-trifluoro-1-propenyl)- 2,2-dimethylcyclopropanecarboxylate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2926.90.1700",
      "rawHtsCode": "2926.90.17.00",
      "superior": null,
      "indent": "3",
      "description": "<i>o</i>-Chlorobenzonitrile",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 65.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.90.1900",
      "rawHtsCode": "2926.90.19.00",
      "superior": null,
      "indent": "3",
      "description": "<i>N</i>,<i>N</i>-Bis(2-cyanoethyl) aniline; and 2,6-Difluorobenzonitrile",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 65.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2926.90.2100",
      "rawHtsCode": "2926.90.21.00",
      "superior": null,
      "indent": "5",
      "description": "Fungicides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.90.2300",
      "rawHtsCode": "2926.90.23.00",
      "superior": null,
      "indent": "6",
      "description": "3,5-Dibromo-4-hydroxybenzonitrile (Bromoxynil)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.90.2500",
      "rawHtsCode": "2926.90.25.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.90.3000",
      "rawHtsCode": "2926.90.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.90.4300",
      "rawHtsCode": "2926.90.43.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 65.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.90.4801",
      "rawHtsCode": "2926.90.48.01",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 65.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2926.90.50",
      "rawHtsCode": "2926.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "2926.90.5010",
      "rawHtsCode": "2926.90.50.10",
      "superior": null,
      "indent": "3",
      "description": "Malononitrile",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2926.90.5050",
      "rawHtsCode": "2926.90.50.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2927.00",
      "rawHtsCode": "2927.00",
      "superior": null,
      "indent": "0",
      "description": "Diazo-, azo- or azoxy-compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2927.00.0300",
      "rawHtsCode": "2927.00.03.00",
      "superior": null,
      "indent": "1",
      "description": "4-Aminoazobenzenedisulfonic acid, monosodium salt",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2927.00.0600",
      "rawHtsCode": "2927.00.06.00",
      "superior": null,
      "indent": "1",
      "description": "<i>p</i>-Aminoazobenzenedisulfonic acid; and Diazoaminobenzene (1,3-Diphenyltriazene)",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2927.00.1500",
      "rawHtsCode": "2927.00.15.00",
      "superior": null,
      "indent": "1",
      "description": "1,1'-Azobisformamide",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2927.00.1800",
      "rawHtsCode": "2927.00.18.00",
      "superior": null,
      "indent": "1",
      "description": "1-Naphthalenesulfonic acid, 6-diazo-5,6-dihydro-5-oxo, ester with phenyl(2,3,4-trihydroxyphenyl)methanone; 1-Naphthalenesulfonic acid, 3-diazo-3,4-dihydro-4- oxo-ar'-(1-methylethyl) [1,1'-biphenyl]-4-yl ester; 1-Napthanlenesulfonic acid, 6-diazo-5,6-dihydro-5- oxo-,(octahydro-4,7-methano-1<i>H</i>-indene-2,5-diyl) bis- (methylene) ester; and 1-Naphthalenesulfonic acid, 6-diazo-5,6-dihydro-5- oxo-, 4-benzoyl-1,2,3-benzenetriyl ester",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2927.00.2500",
      "rawHtsCode": "2927.00.25.00",
      "superior": null,
      "indent": "2",
      "description": "Photographic chemicals",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2927.00.3000",
      "rawHtsCode": "2927.00.30.00",
      "superior": null,
      "indent": "2",
      "description": "Fast color bases and fast color salts",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2927.00.4000",
      "rawHtsCode": "2927.00.40.00",
      "superior": null,
      "indent": "3",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 63.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2927.00.5000",
      "rawHtsCode": "2927.00.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 63.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2928.00",
      "rawHtsCode": "2928.00",
      "superior": null,
      "indent": "0",
      "description": "Organic derivatives of hydrazine or of hydroxylamine:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2928.00.1000",
      "rawHtsCode": "2928.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Methyl ethyl ketoxime",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2928.00.1500",
      "rawHtsCode": "2928.00.15.00",
      "superior": null,
      "indent": "1",
      "description": "Phenylhydrazine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2928.00.2500",
      "rawHtsCode": "2928.00.25.00",
      "superior": null,
      "indent": "2",
      "description": "Aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2928.00.3000",
      "rawHtsCode": "2928.00.30.00",
      "superior": null,
      "indent": "3",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2928.00.5000",
      "rawHtsCode": "2928.00.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2929",
      "rawHtsCode": "2929",
      "superior": null,
      "indent": "0",
      "description": "Compounds with other nitrogen function:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2929.10",
      "rawHtsCode": "2929.10",
      "superior": null,
      "indent": "1",
      "description": "Isocyanates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2929.10.1000",
      "rawHtsCode": "2929.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Toluenediisocyanates (unmixed)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2929.10.1500",
      "rawHtsCode": "2929.10.15.00",
      "superior": null,
      "indent": "2",
      "description": "Mixtures of 2,4- and 2,6-toluenediisocyanates",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2929.10.2000",
      "rawHtsCode": "2929.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Bitolylene diisocyanate (TODI);<i>o</i>-Isocyanic acid, <i>o</i>-tolyl ester; and Xylene diisocyanate",
      "units": [
        "kg"
      ],
      "generalRate": "5.8% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2929.10.2700",
      "rawHtsCode": "2929.10.27.00",
      "superior": null,
      "indent": "2",
      "description": "<i>N</i>-Butylisocyanate; Cyclohexyl isocyanate; 1-Isocyanato-3-(trifluoromethyl) benzene; 1,5-Naphthalene diisocyanate; and Octadecyl isocyanate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2929.10.3000",
      "rawHtsCode": "2929.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "3,4-Dichlorophenylisocyanate",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2929.10.3500",
      "rawHtsCode": "2929.10.35.00",
      "superior": null,
      "indent": "2",
      "description": "1,6-Hexamethylene diisocyanate",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2929.10.5500",
      "rawHtsCode": "2929.10.55.00",
      "superior": null,
      "indent": "3",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2929.10.80",
      "rawHtsCode": "2929.10.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2929.10.8010",
      "rawHtsCode": "2929.10.80.10",
      "superior": null,
      "indent": "4",
      "description": "Methylenedi-<i>p</i>-phenylene isocyanate (MDI)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2929.10.8090",
      "rawHtsCode": "2929.10.80.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2929.90",
      "rawHtsCode": "2929.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2929.90.0500",
      "rawHtsCode": "2929.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "2,2'-Bis(4-cyanatophenyl)-1,1,1,3,3,3-hexafluoro- propane; 2,2-Bis((4-cyanatophenyl) propane; 1,1-Ethylidenebis (phenyl-4-cyanate); 4,4'-Methylene bis(2,6-dimethylphenylcyanate); and 1,3-Phenylenebis (1-methylethylidenebis) cyanic acid, 1,4-phenylene ester",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2929.90.1500",
      "rawHtsCode": "2929.90.15.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2929.90.2000",
      "rawHtsCode": "2929.90.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2929.90.50",
      "rawHtsCode": "2929.90.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2929.90.5015",
      "rawHtsCode": "2929.90.50.15",
      "superior": null,
      "indent": "5",
      "description": "<i>N</i>,<i>N-</i>Dimethylphosphoramidic dichloride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2929.90.5018",
      "rawHtsCode": "2929.90.50.18",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2929.90.5020",
      "rawHtsCode": "2929.90.50.20",
      "superior": null,
      "indent": "4",
      "description": "Dialkyl (methyl, ethyl, <i>n</i>-propyl or isopropyl)-<i>N</i>,<i>N</i>-dialkyl (methyl, ethyl, <i>n</i>-propyl or isopropyl) phosphoramidates",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2929.90.5030",
      "rawHtsCode": "2929.90.50.30",
      "superior": null,
      "indent": "4",
      "description": "<i>N</i>-(Dialkyl (≤C<sub>10</sub>, incl. cycloalkyl) amino))alkylidene (H or ≤C<sub>10</sub>, incl. cycloalkyl) phosphonamidic fluorides and corresponding alkylated or protonated salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2929.90.5040",
      "rawHtsCode": "2929.90.50.40",
      "superior": null,
      "indent": "4",
      "description": "<i>O-</i>Alkyl (H or ≤C<sub>10</sub>, incl. cycloalkyl) <i>N</i>-(dialkyl (≤C<sub>10</sub>, incl. cycloalkyl) amino))alkylidene (H or ≤C<sub>10</sub>, incl. cycloalkyl) phosphoramidofluoridates and corresponding alkylated or protonated salts ",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2929.90.5095",
      "rawHtsCode": "2929.90.50.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "2930",
      "rawHtsCode": "2930",
      "superior": null,
      "indent": "0",
      "description": "Organo-sulfur compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.10.0100",
      "rawHtsCode": "2930.10.01.00",
      "superior": null,
      "indent": "1",
      "description": "2-(N,N-Dimethylamino) ethanethiol",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A, AU, BH, CL, CO, D, E, IL, JO, K, KR, L, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.20",
      "rawHtsCode": "2930.20",
      "superior": null,
      "indent": "1",
      "description": "Thiocarbamates and dithiocarbamates:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.20.1000",
      "rawHtsCode": "2930.20.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pesticides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.20.20",
      "rawHtsCode": "2930.20.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.20.2010",
      "rawHtsCode": "2930.20.20.10",
      "superior": null,
      "indent": "4",
      "description": "Products used principally for rubber processing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.20.2050",
      "rawHtsCode": "2930.20.20.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.20.7000",
      "rawHtsCode": "2930.20.70.00",
      "superior": null,
      "indent": "3",
      "description": "S-(2,3,3'-trichloroallyl)diisopropylthiocarbamate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.20.90",
      "rawHtsCode": "2930.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.20.9010",
      "rawHtsCode": "2930.20.90.10",
      "superior": null,
      "indent": "4",
      "description": "Pesticides",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.20.9020",
      "rawHtsCode": "2930.20.90.20",
      "superior": null,
      "indent": "4",
      "description": "Products used principally for rubber processing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.20.9050",
      "rawHtsCode": "2930.20.90.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.30",
      "rawHtsCode": "2930.30",
      "superior": null,
      "indent": "1",
      "description": "Thiuram mono-, di- or tetrasulfides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.30.3000",
      "rawHtsCode": "2930.30.30.00",
      "superior": null,
      "indent": "2",
      "description": "Tetramethylthiuram monosulfide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.30.6000",
      "rawHtsCode": "2930.30.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.40.0000",
      "rawHtsCode": "2930.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Methionine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2930.60.0000",
      "rawHtsCode": "2930.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "2-(N,N-Diethylamino)ethanethiol",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.70.0000",
      "rawHtsCode": "2930.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Bis(2-hydroxyethyl)sulfide (thiodiglycol (INN))",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.80.0000",
      "rawHtsCode": "2930.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Aldicarb (ISO), captafol (ISO) and methamidophos (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.90",
      "rawHtsCode": "2930.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.1000",
      "rawHtsCode": "2930.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pesticides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.90.2400",
      "rawHtsCode": "2930.90.24.00",
      "superior": null,
      "indent": "4",
      "description": "<i>N</i>-Cyclohexylthiophthalimide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.90.2600",
      "rawHtsCode": "2930.90.26.00",
      "superior": null,
      "indent": "4",
      "description": "3-(4'-Aminobenzamido)phenyl-<i>ß</i>-hydroxy- ethylsulfone; 2-[(4-Aminophenyl)sulfonyl] ethanol, hydrogen sulfate ester; Diphenylthiourea;<i>N</i>,<i>N</i>'-(Dithiodi-2,1-phenylene) bisbenzamide; Pentachlorothiophenol; and 4,4'-Thiodiphenyl cyanate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2930.90.2900",
      "rawHtsCode": "2930.90.29.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.90.3000",
      "rawHtsCode": "2930.90.30.00",
      "superior": null,
      "indent": "4",
      "description": "Thiocyanates, thiurams and isothiocyanates",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.90.4200",
      "rawHtsCode": "2930.90.42.00",
      "superior": null,
      "indent": "5",
      "description": "<i>O</i>,<i>O</i>-Dimethyl-S-methyl carbamoyl- methyl phosphorodithioate; and Malathion",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2930.90.43",
      "rawHtsCode": "2930.90.43",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.90.4310",
      "rawHtsCode": "2930.90.43.10",
      "superior": null,
      "indent": "6",
      "description": "<i>O</i>-Ethyl-<i>S</i>-phenylethylphosphono- thiolothionate (fonofos)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.4315",
      "rawHtsCode": "2930.90.43.15",
      "superior": null,
      "indent": "6",
      "description": "Phorate (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.4320",
      "rawHtsCode": "2930.90.43.20",
      "superior": null,
      "indent": "6",
      "description": "Compounds containing a phosphorus atom to which is bonded one methyl, ethyl, <i>n</i>-propyl or isopropyl group, but no other carbon atoms",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.4330",
      "rawHtsCode": "2930.90.43.30",
      "superior": null,
      "indent": "6",
      "description": "Terbufos (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.4390",
      "rawHtsCode": "2930.90.43.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.4600",
      "rawHtsCode": "2930.90.46.00",
      "superior": null,
      "indent": "5",
      "description": "<i>dl</i>-Hydroxy analogue of <i>dl</i>-methionine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2930.90.49",
      "rawHtsCode": "2930.90.49",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.90.4910",
      "rawHtsCode": "2930.90.49.10",
      "superior": null,
      "indent": "6",
      "description": "Thioglycolic acid",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.4920",
      "rawHtsCode": "2930.90.49.20",
      "superior": null,
      "indent": "6",
      "description": "Mercaptocarboxylic acids",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.4950",
      "rawHtsCode": "2930.90.49.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.7100",
      "rawHtsCode": "2930.90.71.00",
      "superior": null,
      "indent": "5",
      "description": "Dibutylthiourea",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2930.90.92",
      "rawHtsCode": "2930.90.92",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2930.90.9208",
      "rawHtsCode": "2930.90.92.08",
      "superior": null,
      "indent": "6",
      "description": "<i>O</i>,<i>O</i>-Diethyl <i>S</i>-[2-(diethylamino)- ethyl] phosphorothioate and its alkylated or protonated salts; and Thiodiglycol (INN) (bis(2-hydroxy- ethyl) sulfide)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.9210",
      "rawHtsCode": "2930.90.92.10",
      "superior": null,
      "indent": "6",
      "description": "Cysteine hydrochloride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.9212",
      "rawHtsCode": "2930.90.92.12",
      "superior": null,
      "indent": "6",
      "description": "2-Ethylhexyl mercaptoacetate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.9222",
      "rawHtsCode": "2930.90.92.22",
      "superior": null,
      "indent": "6",
      "description": "<i>N,N</i>-Dialkyl (methyl, ethyl, <i>n</i>-propyl or isopropyl) aminoethane-2-thiols and their protonated salts, except for 2-(<i>N,N</i>- dimethylamino)ethanethiol and 2-(<i>N,N</i>- diethylamino)ethanethiol",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.9225",
      "rawHtsCode": "2930.90.92.25",
      "superior": null,
      "indent": "6",
      "description": "Other compounds containing a phosphorus atom to which is bonded one methyl, ethyl, <i>n</i>-propyl or isopropyl group, but no other carbon atoms",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.9231",
      "rawHtsCode": "2930.90.92.31",
      "superior": null,
      "indent": "7",
      "description": "Products used principally for rubber processing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.9235",
      "rawHtsCode": "2930.90.92.35",
      "superior": null,
      "indent": "7",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2930.90.9251",
      "rawHtsCode": "2930.90.92.51",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931",
      "rawHtsCode": "2931",
      "superior": null,
      "indent": "0",
      "description": "Other organo-inorganic compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.10.0000",
      "rawHtsCode": "2931.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tetramethyl lead and tetraethyl lead",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.20.0000",
      "rawHtsCode": "2931.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tributyltin compounds",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.41.0000",
      "rawHtsCode": "2931.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dimethyl methylphosphonate",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.42.0000",
      "rawHtsCode": "2931.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dimethyl propylphosphonate",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.43.0000",
      "rawHtsCode": "2931.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "Diethyl ethylphosphonate",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.44.0000",
      "rawHtsCode": "2931.44.00.00",
      "superior": null,
      "indent": "2",
      "description": "Methylphosphonic acid",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.45.0000",
      "rawHtsCode": "2931.45.00.00",
      "superior": null,
      "indent": "2",
      "description": "Salt of methylphosphonic acid and (aminoiminomethyl)urea (1:1)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.46.0000",
      "rawHtsCode": "2931.46.00.00",
      "superior": null,
      "indent": "2",
      "description": "2,4,6-Tripropyl-1,3,5,2,4,6-trioxatriphosphinane 2,4,6-trioxide",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.47.0000",
      "rawHtsCode": "2931.47.00.00",
      "superior": null,
      "indent": "2",
      "description": "(5-Ethyl-2-methyl-2-oxido-1,3,2-dioxaphosphinan-5-yl) methyl methyl methylphosphonate",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.48.0000",
      "rawHtsCode": "2931.48.00.00",
      "superior": null,
      "indent": "2",
      "description": "3,9-Dimethyl-2,4,8,10-tetraoxa-3,9-diphosphaspiro [5.5] undecane 3,9-dioxide",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.49.00",
      "rawHtsCode": "2931.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.49.0005",
      "rawHtsCode": "2931.49.00.05",
      "superior": null,
      "indent": "3",
      "description": "<i>O</i>-Alkyl (≤C<sub>10</sub>, including cycloalkyl) <i>N,N</i>-dialkyl (methyl, ethyl, <i>n</i>-propyl or isopropyl) phosphoramidocyanidates",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.49.0008",
      "rawHtsCode": "2931.49.00.08",
      "superior": null,
      "indent": "3",
      "description": "[<i>O</i>-2-(Dialkyl (methyl, ethyl, <i>n</i>-propyl or isopropyl) amino)ethyl] hydrogen alkyl (methyl, ethyl, <i>n</i>-propyl or isopropyl) phosphonites and their <i>O</i>-alkyl (≤C<sub>10</sub>, including cycloalkyl) esters; alkylated or protonated salts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.49.0010",
      "rawHtsCode": "2931.49.00.10",
      "superior": null,
      "indent": "3",
      "description": "2-Amino-4-[hydroxy(methyl)phosphonoyl] butanoic acid (glufosinate) and its salts and esters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.49.0015",
      "rawHtsCode": "2931.49.00.15",
      "superior": null,
      "indent": "3",
      "description": "Butyl methylphosphinate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.49.0020",
      "rawHtsCode": "2931.49.00.20",
      "superior": null,
      "indent": "3",
      "description": "<i>N</i>-(Phosphonomethyl) glycine (glyphosate) and its salts and esters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.49.0025",
      "rawHtsCode": "2931.49.00.25",
      "superior": null,
      "indent": "3",
      "description": "Bis(1-methylpentyl) methylphosphonate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.49.0055",
      "rawHtsCode": "2931.49.00.55",
      "superior": null,
      "indent": "4",
      "description": "Containing a phosphorus atom to which one methyl, ethyl, <i>n</i>-propyl or isopropyl group is bonded but no further carbon atoms",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.49.0080",
      "rawHtsCode": "2931.49.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.51.0000",
      "rawHtsCode": "2931.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Methylphosphonic dichloride",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.52.0000",
      "rawHtsCode": "2931.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "Propylphosphonic dichloride",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.53.0000",
      "rawHtsCode": "2931.53.00.00",
      "superior": null,
      "indent": "2",
      "description": "O-(3-chloropropyl) O-[4-nitro-3-(trifluoromethyl)phenyl] methylphosphonothionate",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.54.0000",
      "rawHtsCode": "2931.54.00.00",
      "superior": null,
      "indent": "2",
      "description": "Trichlorfon (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.59.00",
      "rawHtsCode": "2931.59.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.59.0010",
      "rawHtsCode": "2931.59.00.10",
      "superior": null,
      "indent": "3",
      "description": "<i>O</i>-Alkyl (≤ C<sub>10</sub>, including cycloalkyl) alkyl (methyl, ethyl,<i>n</i>- propyl or isopropyl) phosphonofluoridates",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.59.0015",
      "rawHtsCode": "2931.59.00.15",
      "superior": null,
      "indent": "3",
      "description": "Alkyl (methyl, ethyl, <i>n</i>-propyl or isopropyl) phosphonyl difluorides",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.59.0020",
      "rawHtsCode": "2931.59.00.20",
      "superior": null,
      "indent": "3",
      "description": "<i>O</i>-Isopropyl methylphosphonochloridate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.59.0025",
      "rawHtsCode": "2931.59.00.25",
      "superior": null,
      "indent": "3",
      "description": "<i>O</i>-Pinacolyl methylphosphonochloridate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.59.0030",
      "rawHtsCode": "2931.59.00.30",
      "superior": null,
      "indent": "3",
      "description": "<i>P</i>-Alkyl (≤ C<sub>10</sub>, incl. cycloalkyl) <i>N</i>-(1-(dialkyl (≤ C<sub>10</sub>, incl. cycloalkyl) amino))alkylidene (H or ≤C<sub>10</sub>, incl. cycloalkyl) phosphonamidic fluorides and corresponding alkylated or protonated salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.59.0035",
      "rawHtsCode": "2931.59.00.35",
      "superior": null,
      "indent": "3",
      "description": "Methyl- bis(diethylamino)methylene)phosphonamidofluoridate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.59.0060",
      "rawHtsCode": "2931.59.00.60",
      "superior": null,
      "indent": "3",
      "description": "Containing a phosphorus atom to which one methyl, ethyl, <i>n</i>-propyl or isopropyl group is bonded but no further carbon atoms",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.59.0080",
      "rawHtsCode": "2931.59.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.90",
      "rawHtsCode": "2931.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.90.0500",
      "rawHtsCode": "2931.90.05.00",
      "superior": null,
      "indent": "3",
      "description": "Diphenyldichlorosilane; and phenyltrichlorosilane",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.90.1000",
      "rawHtsCode": "2931.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "4,4'-Diphenylbisphosphonous acid, di(2',2\",4',4\"-di-<i>tert</i>-butyl)phenyl ester",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free \n(A+, AU, BH, CL,CO,D, E, IL, JO, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.90.1500",
      "rawHtsCode": "2931.90.15.00",
      "superior": null,
      "indent": "3",
      "description": "Sodium tetraphenylboron",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free  (A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.90.2200",
      "rawHtsCode": "2931.90.22.00",
      "superior": null,
      "indent": "4",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 67.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.90.2600",
      "rawHtsCode": "2931.90.26.00",
      "superior": null,
      "indent": "4",
      "description": "Pesticides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.90.3000",
      "rawHtsCode": "2931.90.30.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.90.6000",
      "rawHtsCode": "2931.90.60.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.90.7000",
      "rawHtsCode": "2931.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "<i>N</i>,<i>N</i>'-Bis(trimethylsilyl) urea; 3-(Hydroxymethylphosphinyl)-1-propanoic acid, 2-hydroxyethyl ester; and 2-Phosphonobutane-1,2,4-tricarboxylic acid and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2931.90.90",
      "rawHtsCode": "2931.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Pursuant to U.S. note 20(g) to subchapter III, chapter 99, heading 9903.88.04 covers certain goods of this rate line, as indicated by the footnote; please note that statistical reporting descriptions without a footnote are not covered by that heading. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2931.90.9010",
      "rawHtsCode": "2931.90.90.10",
      "superior": null,
      "indent": "4",
      "description": "Organo-silicon compounds",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Pursuant to U.S. note 20(g) to subchapter III, chapter 99, heading 9903.88.04 covers certain goods of this rate line, as indicated by the footnote; please note that statistical reporting descriptions without a footnote are not covered by that heading."
      ],
      "flags": []
    },
    {
      "htsCode": "2931.90.9021",
      "rawHtsCode": "2931.90.90.21",
      "superior": null,
      "indent": "5",
      "description": "Dibutyltin oxide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Pursuant to U.S. note 20(g) to subchapter III, chapter 99, heading 9903.88.04 covers certain goods of this rate line, as indicated by the footnote; please note that statistical reporting descriptions without a footnote are not covered by that heading."
      ],
      "flags": []
    },
    {
      "htsCode": "2931.90.9025",
      "rawHtsCode": "2931.90.90.25",
      "superior": null,
      "indent": "5",
      "description": "Tetrabutyltin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Pursuant to U.S. note 20(g) to subchapter III, chapter 99, heading 9903.88.04 covers certain goods of this rate line, as indicated by the footnote; please note that statistical reporting descriptions without a footnote are not covered by that heading."
      ],
      "flags": []
    },
    {
      "htsCode": "2931.90.9029",
      "rawHtsCode": "2931.90.90.29",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "Pursuant to U.S. note 20(g) to subchapter III, chapter 99, heading 9903.88.04 covers certain goods of this rate line, as indicated by the footnote; please note that statistical reporting descriptions without a footnote are not covered by that heading."
      ],
      "flags": []
    },
    {
      "htsCode": "2931.90.9030",
      "rawHtsCode": "2931.90.90.30",
      "superior": null,
      "indent": "4",
      "description": "2-Chlorovinyldichloroarsine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.90.9035",
      "rawHtsCode": "2931.90.90.35",
      "superior": null,
      "indent": "4",
      "description": "Bis(2-chlorovinyl)chloroarsine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.90.9040",
      "rawHtsCode": "2931.90.90.40",
      "superior": null,
      "indent": "4",
      "description": "Tris(2-chlorovinyl)arsine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2931.90.9052",
      "rawHtsCode": "2931.90.90.52",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2932",
      "rawHtsCode": "2932",
      "superior": null,
      "indent": "0",
      "description": "Heterocyclic compounds with oxygen hetero-atom(s) only:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2932.11.0000",
      "rawHtsCode": "2932.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tetrahydrofuran",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.12.0000",
      "rawHtsCode": "2932.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "2-Furaldehyde (Furfuraldehyde)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2932.13.0000",
      "rawHtsCode": "2932.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Furfuryl alcohol and tetrahydrofurfuryl alcohol",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.14.0000",
      "rawHtsCode": "2932.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sucralose",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.19",
      "rawHtsCode": "2932.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2932.19.1000",
      "rawHtsCode": "2932.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.19.5100",
      "rawHtsCode": "2932.19.51.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.20",
      "rawHtsCode": "2932.20",
      "superior": null,
      "indent": "1",
      "description": "Lactones:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2932.20.0500",
      "rawHtsCode": "2932.20.05.00",
      "superior": null,
      "indent": "2",
      "description": "Coumarin, methylcoumarins and ethylcoumarins",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.20.1000",
      "rawHtsCode": "2932.20.10.00",
      "superior": null,
      "indent": "4",
      "description": "Pesticides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.20.2000",
      "rawHtsCode": "2932.20.20.00",
      "superior": null,
      "indent": "4",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.20.2500",
      "rawHtsCode": "2932.20.25.00",
      "superior": null,
      "indent": "5",
      "description": "4-Hydroxycoumarin",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.20.3000",
      "rawHtsCode": "2932.20.30.00",
      "superior": null,
      "indent": "6",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.20.4500",
      "rawHtsCode": "2932.20.45.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.20.50",
      "rawHtsCode": "2932.20.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.20.5010",
      "rawHtsCode": "2932.20.50.10",
      "superior": null,
      "indent": "4",
      "description": "Butyrolactone",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2932.20.5020",
      "rawHtsCode": "2932.20.50.20",
      "superior": null,
      "indent": "4",
      "description": "Glucono-<i>δ</i>-lactone",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2932.20.5030",
      "rawHtsCode": "2932.20.50.30",
      "superior": null,
      "indent": "4",
      "description": "Sodium erythorbate (Sodium isoascorbate)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2932.20.5050",
      "rawHtsCode": "2932.20.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2932.91.0000",
      "rawHtsCode": "2932.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Isosafrole",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.92.0000",
      "rawHtsCode": "2932.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "1-(1,3-Benzodioxol-5-yl)propan-2-one",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.93.0000",
      "rawHtsCode": "2932.93.00.00",
      "superior": null,
      "indent": "2",
      "description": "Piperonal (heliotropin)",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.94.0000",
      "rawHtsCode": "2932.94.00.00",
      "superior": null,
      "indent": "2",
      "description": "Safrole",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.95.0000",
      "rawHtsCode": "2932.95.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tetrahydrocannabinols (all isomers)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2932.96.0000",
      "rawHtsCode": "2932.96.00.00",
      "superior": null,
      "indent": "2",
      "description": "Carbofuran (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.99",
      "rawHtsCode": "2932.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2932.99.0400",
      "rawHtsCode": "2932.99.04.00",
      "superior": null,
      "indent": "5",
      "description": "2,2-Dimethyl-1,3-benzodioxol-4-yl methylcarbamate (Bendiocarb)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2932.99.0800",
      "rawHtsCode": "2932.99.08.00",
      "superior": null,
      "indent": "5",
      "description": "2-Ethoxy-2,3-dihydro-3,3-dimethyl-5- benzofuranylmethanesulfonate",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.99.2100",
      "rawHtsCode": "2932.99.21.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.99.3200",
      "rawHtsCode": "2932.99.32.00",
      "superior": null,
      "indent": "4",
      "description": "Benzofuran (Coumarone); and Dibenzofuran (Diphenylene oxide)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2932.99.3500",
      "rawHtsCode": "2932.99.35.00",
      "superior": null,
      "indent": "4",
      "description": "2-Hydroxy-3-dibenzofurancarboxylic acid",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 66.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.99.3900",
      "rawHtsCode": "2932.99.39.00",
      "superior": null,
      "indent": "4",
      "description": "Benzoin tetrahydropyranyl ester; and Xanthen-9-one",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.99.5500",
      "rawHtsCode": "2932.99.55.00",
      "superior": null,
      "indent": "4",
      "description": "Bis-<i>O</i>-[(4-methylphenyl)methylene]-<i>D</i>- glucitol (Dimethyl benzylidene sorbitol); and Rhodamine 2C base",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2932.99.6100",
      "rawHtsCode": "2932.99.61.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.99.7000",
      "rawHtsCode": "2932.99.70.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.99.90",
      "rawHtsCode": "2932.99.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2932.99.9010",
      "rawHtsCode": "2932.99.90.10",
      "superior": null,
      "indent": "4",
      "description": "Glucosamine and its salts and esters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2932.99.9090",
      "rawHtsCode": "2932.99.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933",
      "rawHtsCode": "2933",
      "superior": null,
      "indent": "0",
      "description": "Heterocyclic compounds with nitrogen hetero-atom(s) only:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.11.0000",
      "rawHtsCode": "2933.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Phenazone (Antipyrine) and its derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 49.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.19",
      "rawHtsCode": "2933.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.19.0400",
      "rawHtsCode": "2933.19.04.00",
      "superior": null,
      "indent": "4",
      "description": "Aminomethylphenylpyrazole (Phenylmethylaminopyrazole); and 3-Methyl-1-(<i>p</i>-tolyl)-2-pyrazolin-5-one (<i>p</i>-Tolyl methyl pyrazolone)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "2933.19.0800",
      "rawHtsCode": "2933.19.08.00",
      "superior": null,
      "indent": "4",
      "description": "3-(5-Amino-3-methyl-1<i>H</i>-pyrazol-1-yl)- benzenesulfonic acid; Amino-J-pyrazolone; 3-Amino-1-(2,4,6-trichlorophenyl)-5- pyrazolone; 3-Carboxy-1,4-sulfophenylpyrazol-5-one; 4-Chloro-3-(3-methyl-5-oxo-2-pyrazolin-1- yl)benzenesulfonic acid; 1-(<i>m</i>-Chlorophenyl)-3-methyl-2-pyrazolin- 5-one;<i>p</i>-Chloropyrazolone; 1-(2',5'-Dichlorophenyl)-3-methyl-2- pyrazolin-5-one; 1-(<i>o</i>-Ethylphenyl)-3-methyl-2-pyrazolin- 5-one; 5-Imino-3-methyl-1-phenylpyrazole; 5-Imino-3-methyl-1-(<i>m</i>-sulfophenyl)- pyrazole; 2,4-Methylcarboxypyrazolic acid; Methylphenylpyrazolone; and Sulfinpyrazone",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.19.1500",
      "rawHtsCode": "2933.19.15.00",
      "superior": null,
      "indent": "4",
      "description": "1,2-Dimethyl-3,5-diphenyl-1<i>H</i>-pyrazolium methyl sulfate (Difenzoquat methyl sulfate)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2933.19.1800",
      "rawHtsCode": "2933.19.18.00",
      "superior": null,
      "indent": "4",
      "description": "2-Chloro-5-sulfophenylmethylpyrazolone; 2,5-Dichloro-4-(3-methyl-5-oxo-2- pyrazolin-1-yl) benzenesulfonic acid; Phenyl carbethoxypyrazolone;<i>m</i>-Sulfaminopyrazolone (<i>m</i>-Sulfamido- phenyl methyl pyrazolone); and 1-(<i>p</i>-Sulfophenyl)-3-methyl pyrazolone",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2933.19.2300",
      "rawHtsCode": "2933.19.23.00",
      "superior": null,
      "indent": "5",
      "description": "Pesticides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.19.30",
      "rawHtsCode": "2933.19.30",
      "superior": null,
      "indent": "5",
      "description": "Photographic chemicals",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.19.3010",
      "rawHtsCode": "2933.19.30.10",
      "superior": null,
      "indent": "6",
      "description": "Couplers, for use in color negative photographic paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.19.3095",
      "rawHtsCode": "2933.19.30.95",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.19.3500",
      "rawHtsCode": "2933.19.35.00",
      "superior": null,
      "indent": "5",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 47.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.19.3700",
      "rawHtsCode": "2933.19.37.00",
      "superior": null,
      "indent": "6",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.19.4300",
      "rawHtsCode": "2933.19.43.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.19.4500",
      "rawHtsCode": "2933.19.45.00",
      "superior": null,
      "indent": "4",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.19.7000",
      "rawHtsCode": "2933.19.70.00",
      "superior": null,
      "indent": "5",
      "description": "3-Methyl-5-pyrazolone",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2933.19.9000",
      "rawHtsCode": "2933.19.90.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.21.0000",
      "rawHtsCode": "2933.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Hydantoin and its derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 63%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.29",
      "rawHtsCode": "2933.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.29.0500",
      "rawHtsCode": "2933.29.05.00",
      "superior": null,
      "indent": "4",
      "description": "1-[1-((4-Chloro-2-(trifluoromethyl)phenyl)- imino)-2-propoxyethyl]-1<i>H</i>-imidazole (Triflumizole); and Ethylene thiourea",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2933.29.1000",
      "rawHtsCode": "2933.29.10.00",
      "superior": null,
      "indent": "4",
      "description": "2-Phenylimidazole",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.29.2000",
      "rawHtsCode": "2933.29.20.00",
      "superior": null,
      "indent": "5",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.29.3500",
      "rawHtsCode": "2933.29.35.00",
      "superior": null,
      "indent": "6",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.29.4300",
      "rawHtsCode": "2933.29.43.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.29.4500",
      "rawHtsCode": "2933.29.45.00",
      "superior": null,
      "indent": "4",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.29.6000",
      "rawHtsCode": "2933.29.60.00",
      "superior": null,
      "indent": "5",
      "description": "Imidazole",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2933.29.9000",
      "rawHtsCode": "2933.29.90.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.31.0000",
      "rawHtsCode": "2933.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Pyridine and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2933.32",
      "rawHtsCode": "2933.32",
      "superior": null,
      "indent": "2",
      "description": "Piperidine and its salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.32.1000",
      "rawHtsCode": "2933.32.10.00",
      "superior": null,
      "indent": "3",
      "description": "Piperidine",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.32.5000",
      "rawHtsCode": "2933.32.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.33.0100",
      "rawHtsCode": "2933.33.01.00",
      "superior": null,
      "indent": "2",
      "description": "Alfentanil (INN), anileridine (INN), bezitramide (INN), bromazepam (INN), carfentanil (INN), difenoxin (INN), diphenoxylate (INN), dipipanone (INN), fentanyl (INN), ketobemidone (INN), methylphenidate (INN), pentazocine (INN), pethidine (INN), pethidine (INN) intermediate A, phencyclidine (INN) (PCP), phenoperidine (INN), pipradrol (INN), piritramide (INN), propiram (INN), remifentanil (INN) and trimeperidine (INN); salts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 149.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.34.0000",
      "rawHtsCode": "2933.34.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other fentanyls and their derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.35.0000",
      "rawHtsCode": "2933.35.00.00",
      "superior": null,
      "indent": "2",
      "description": "3-Quinuclidinol",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.36.0000",
      "rawHtsCode": "2933.36.00.00",
      "superior": null,
      "indent": "2",
      "description": "4-Anilino-N-phenethylpiperidine (ANPP)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.37.0000",
      "rawHtsCode": "2933.37.00.00",
      "superior": null,
      "indent": "2",
      "description": "N-Phenethyl-4-piperidone (NPP)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.39",
      "rawHtsCode": "2933.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.39.0800",
      "rawHtsCode": "2933.39.08.00",
      "superior": null,
      "indent": "3",
      "description": "1-(3-Sulfo propyl) pyridinium hydroxide;<i>N</i>,<i>N</i>'-Bis (2,2,6,6-tetra methyl-4-piperidinyl)-1,6- hexane diamine; 3,5-Dimethyl-2-hydroxy methyl-4-methoxy- pyridine (pyrmethyl alcohol); Dipenta methylene thiuram tetra sulfide; 2<i>H</i>-Indol-2-one,1,3-dihydro-1-phenyl-3-(4- pyridinyl methylene); 4-Picolyl chloride hydro chloride; and Piperidino ethyl chloride hydro chloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.39.1000",
      "rawHtsCode": "2933.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Collidines, lutidines and picolines",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.39.2000",
      "rawHtsCode": "2933.39.20.00",
      "superior": null,
      "indent": "3",
      "description": "p-Chloro-2-benzylpyridine; 4-Chloro-1-methylpiperidine hydrochloride; 1,4-Dimethyl-6-hydroxy-3-cyanopyrid-2-one; Di-(2,2,6,6-tetramethyl-4-hydroxy- piperidine)sebacate; 2-Methyl-5-ethylpyridine; 4-Phenylpropylpyridine; α-Phenylpyridylacetic acid, methyl ester; Picolinic acid; 2-Pyridinecarboxaldehyde; and 2,5-Pyridinedicarboxylic acid",
      "units": [
        "kg"
      ],
      "generalRate": "5.8% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.39.2100",
      "rawHtsCode": "2933.39.21.00",
      "superior": null,
      "indent": "5",
      "description": "Fungicides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.39.2300",
      "rawHtsCode": "2933.39.23.00",
      "superior": null,
      "indent": "6",
      "description": "<i>o</i>-Paraquat dichloride",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.39.2500",
      "rawHtsCode": "2933.39.25.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.39.2700",
      "rawHtsCode": "2933.39.27.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.39.3100",
      "rawHtsCode": "2933.39.31.00",
      "superior": null,
      "indent": "5",
      "description": "Antidepressants, tranquilizers and other psychotherapeutic agents",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 149.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.39.4100",
      "rawHtsCode": "2933.39.41.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.39.61",
      "rawHtsCode": "2933.39.61",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.39.6110",
      "rawHtsCode": "2933.39.61.10",
      "superior": null,
      "indent": "6",
      "description": "3-Quinuclidinyl benzilate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.39.6120",
      "rawHtsCode": "2933.39.61.20",
      "superior": null,
      "indent": "6",
      "description": "1-[<i>N,N</i>-Dialkyl (≤C<sub>10</sub>)-<i>N</i>-(<i>n</i>-(hydroxyl, cyano, acetoxy)alkyl (≤C<sub>10</sub>)) ammonio]-<i>n-n</i>-[<i>N</i>-(3- dimethylcarbamoxy-α-picolinyl)-<i>N,N</i>-dialkyl (≤C<sub>10</sub>) ammonio]decane dibromide (<i>n</i>=1-8)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.39.6130",
      "rawHtsCode": "2933.39.61.30",
      "superior": null,
      "indent": "6",
      "description": "1,<i>n</i>-Bis[<i>N</i>-(3-dimethylcarbamoxy-α-picolyl)- <i>N,N</i>-dialkyl (≤ C<sub>10</sub>) ammonio]-alkane-(2,(<i>n</i>-1)- dione) dibromide (<i>n</i>=2-12) ",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.39.6191",
      "rawHtsCode": "2933.39.61.91",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.39.9200",
      "rawHtsCode": "2933.39.92.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.41.0000",
      "rawHtsCode": "2933.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Levorphanol (INN) and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 67.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.49",
      "rawHtsCode": "2933.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.49.0800",
      "rawHtsCode": "2933.49.08.00",
      "superior": null,
      "indent": "3",
      "description": "4,7-Dichloroquinoline",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.49.1000",
      "rawHtsCode": "2933.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Ethoxyquin (1,2-Dihydro-6-ethoxy-2,2,4- trimethylquinoline)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.49.1500",
      "rawHtsCode": "2933.49.15.00",
      "superior": null,
      "indent": "3",
      "description": "8-Methylquinoline and Isoquinoline",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.49.1700",
      "rawHtsCode": "2933.49.17.00",
      "superior": null,
      "indent": "3",
      "description": "Ethyl ethyl-6,7,8-trifluoro-1,4-dihydro-4-oxo-3- quinolinecarboxylate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.49.2000",
      "rawHtsCode": "2933.49.20.00",
      "superior": null,
      "indent": "5",
      "description": "5-Chloro-7-iodo-8-quinolinol (Iodo chlo rhydroxy quin); Deco quinate; Diiodo hydroxy quin; and Oxy quinoline sulfate",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 46%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.49.2600",
      "rawHtsCode": "2933.49.26.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 67.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.49.3000",
      "rawHtsCode": "2933.49.30.00",
      "superior": null,
      "indent": "4",
      "description": "Pesticides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.49.6000",
      "rawHtsCode": "2933.49.60.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.49.7000",
      "rawHtsCode": "2933.49.70.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.52",
      "rawHtsCode": "2933.52",
      "superior": null,
      "indent": "2",
      "description": "Malonylurea (Barbituric acid) and its salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.52.1000",
      "rawHtsCode": "2933.52.10.00",
      "superior": null,
      "indent": "3",
      "description": "Malonylurea (barbituric acid)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.52.9000",
      "rawHtsCode": "2933.52.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.53.0000",
      "rawHtsCode": "2933.53.00.00",
      "superior": null,
      "indent": "2",
      "description": "Allobarbital (INN), amobarbital (INN), barbital (INN), butalbital (INN), butobarbital, cyclobarbital (INN), methylphenobarbital (INN), pentobarbital (INN), phenobarbital (INN), secbutabarbital (INN), secobarbital (INN) and vinylbital (INN); salts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.54.0000",
      "rawHtsCode": "2933.54.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other derivatives of malonylurea (barbituric acid); salts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,K,KR, L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.55.0000",
      "rawHtsCode": "2933.55.00.00",
      "superior": null,
      "indent": "2",
      "description": "Loprazolam (INN), mecloqualone (INN), methaqualone (INN) and zipeprol (INN); salts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 149.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.59",
      "rawHtsCode": "2933.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.59.1000",
      "rawHtsCode": "2933.59.10.00",
      "superior": null,
      "indent": "5",
      "description": "Herbicides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.59.1500",
      "rawHtsCode": "2933.59.15.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.59.1800",
      "rawHtsCode": "2933.59.18.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.59.2100",
      "rawHtsCode": "2933.59.21.00",
      "superior": null,
      "indent": "5",
      "description": "Antihistamines, including those principally used as anti-nauseants",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 82%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.59.2200",
      "rawHtsCode": "2933.59.22.00",
      "superior": null,
      "indent": "6",
      "description": "Nicarbazin; and Trimethoprim",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 46%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.59.3600",
      "rawHtsCode": "2933.59.36.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 67.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.59.4600",
      "rawHtsCode": "2933.59.46.00",
      "superior": null,
      "indent": "5",
      "description": "Antidepressants, tranquilizers and other psychotherapeutic agents",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 149.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.59.5300",
      "rawHtsCode": "2933.59.53.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.59.5900",
      "rawHtsCode": "2933.59.59.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.59.7000",
      "rawHtsCode": "2933.59.70.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.59.8000",
      "rawHtsCode": "2933.59.80.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.59.8500",
      "rawHtsCode": "2933.59.85.00",
      "superior": null,
      "indent": "5",
      "description": "2-Amino-4-chloro-6-methoxy pyrimidine; 2-Amino-4,6-di methoxy pyrimidine; and 6-Methyl uracil",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.59.9500",
      "rawHtsCode": "2933.59.95.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.61.0000",
      "rawHtsCode": "2933.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Melamine",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.69",
      "rawHtsCode": "2933.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.69.2000",
      "rawHtsCode": "2933.69.20.00",
      "superior": null,
      "indent": "3",
      "description": "2,4-Diamino-6-phenyl-1,3,5-triazine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2933.69.5000",
      "rawHtsCode": "2933.69.50.00",
      "superior": null,
      "indent": "3",
      "description": "Hexamethylenetetramine",
      "units": [
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.69.60",
      "rawHtsCode": "2933.69.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.69.6010",
      "rawHtsCode": "2933.69.60.10",
      "superior": null,
      "indent": "4",
      "description": "Cyanuric chloride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.69.6015",
      "rawHtsCode": "2933.69.60.15",
      "superior": null,
      "indent": "5",
      "description": "Sodium dichloroisocyanurate and trichloroisocyanuric acid",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.69.6021",
      "rawHtsCode": "2933.69.60.21",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.69.6030",
      "rawHtsCode": "2933.69.60.30",
      "superior": null,
      "indent": "4",
      "description": "Products used principally for rubber processing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.69.6050",
      "rawHtsCode": "2933.69.60.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.71.0000",
      "rawHtsCode": "2933.71.00.00",
      "superior": null,
      "indent": "2",
      "description": "6-Hexanelactam (ε-Caprolactam)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.72.0000",
      "rawHtsCode": "2933.72.00.00",
      "superior": null,
      "indent": "2",
      "description": "Clobazam (INN) and methyprylon (INN)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.79",
      "rawHtsCode": "2933.79",
      "superior": null,
      "indent": "2",
      "description": "Other lactams:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.79.0400",
      "rawHtsCode": "2933.79.04.00",
      "superior": null,
      "indent": "4",
      "description": "2,5-Dihydro-3,6-diphenylpyrrolo-(3,4-<i>c</i>)- pyrrole-1,4-dione",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2933.79.0800",
      "rawHtsCode": "2933.79.08.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.79.1500",
      "rawHtsCode": "2933.79.15.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.79.2000",
      "rawHtsCode": "2933.79.20.00",
      "superior": null,
      "indent": "4",
      "description": "<i>N</i>-Methyl-2-pyrrolidone; and 2-Pyrrolidone",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.79.3000",
      "rawHtsCode": "2933.79.30.00",
      "superior": null,
      "indent": "4",
      "description": "<i>N</i>-Vinyl-2-pyrrolidone, monomer",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.79.4000",
      "rawHtsCode": "2933.79.40.00",
      "superior": null,
      "indent": "4",
      "description": "12-Aminododecanoic acid lactam",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2933.79.8500",
      "rawHtsCode": "2933.79.85.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.91.00",
      "rawHtsCode": "2933.91.00",
      "superior": null,
      "indent": "2",
      "description": "Alprazolam (INN), camazepam (INN), chlordiazepoxide (INN), clonazepam (INN), clorazepate, delorazepam (INN), diazepam (INN), estazolam (INN), ethyl loflazepate (INN), fludiazepam (INN), flunitrazepam (INN), flurazepam (INN), halazepam (INN), lorazepam (INN), lormetazepam (INN), mazindol (INN), medazepam (INN), midazolam (INN), nimetazepam (INN), nitrazepam (INN), nordazepam (INN), oxazepam (INN), pinazepam (INN), prazepam (INN), pyrovalerone (INN), temazepam (INN), tetrazepam (INN) and triazolam (INN); salts thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 149.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.91.0010",
      "rawHtsCode": "2933.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Lorazepam (INN); salts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.91.0050",
      "rawHtsCode": "2933.91.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.92.0000",
      "rawHtsCode": "2933.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Azinphos-methyl",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2933.99",
      "rawHtsCode": "2933.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.0100",
      "rawHtsCode": "2933.99.01.00",
      "superior": null,
      "indent": "4",
      "description": "Butyl (<i>R</i>)-2-[4-(5-trifluoromethyl-2- pyridinyloxy)phenoxy]propanoate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.0200",
      "rawHtsCode": "2933.99.02.00",
      "superior": null,
      "indent": "4",
      "description": "2-[4-[(6-Chloro-2-quinoxalinyl)oxy]phenoxy]- propionic acid, ethyl ester",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.0500",
      "rawHtsCode": "2933.99.05.00",
      "superior": null,
      "indent": "4",
      "description": "Acridine and indole",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.0600",
      "rawHtsCode": "2933.99.06.00",
      "superior": null,
      "indent": "4",
      "description": "<i>α</i>-Butyl-<i>α</i>-(4-chlorophenyl)-1<i>H</i>-1,2,4- triazole-1- propanenitrile (Myclobutanil); and<i>α</i>-[2-(4-Chlorophenyl)ethyl]-<i>α</i>-phenyl-1<i>H</i>- 1,2,4-triazole-1-propanenitrile (Fenbuconazole)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.0800",
      "rawHtsCode": "2933.99.08.00",
      "superior": null,
      "indent": "4",
      "description": "Aceto acetyl-5-amino benz imidazolone; 3-(2<i>H</i>-Benzo triazol-2-yl)-5-(<i>tert</i>-butyl)-4- hydroxy benzene propanoic acid, C7-C9 branched or linear alkyl esters; 2-(2<i>H</i>-Benzotriazol-2-yl)-6-dodecyl-4- methyl phenol, in liquid form, branched and linear; and 1,3,3-Trimethyl-2-methyleneindoline",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.1100",
      "rawHtsCode": "2933.99.11.00",
      "superior": null,
      "indent": "4",
      "description": "Carbazole",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.1200",
      "rawHtsCode": "2933.99.12.00",
      "superior": null,
      "indent": "4",
      "description": "6-Bromo-5-methyl-1<i>H</i>-imidazo[4,5-<i>b</i>]- pyridine; 2-<i>sec</i>-Butyl-4-<i>tert</i>-butyl-6-(benzotriazol-2- yl)phenol; 2-<i>tert</i>-Butyl-4-methyl-6-(5-chlorobenzotri- azol-2-yl)phenol; 2,4-Di-<i>tert</i>-butyl-6-(benzotriazol-2-yl)phenol; 2,4-Di-<i>tert</i>-butyl-6-(5-chlorobenzotriazol-2- yl)phenol; 2,3-Dichloro-6-quinoxalinecarbonyl chloride; 1-Hydroxy-2-carbazolecarboxylic acid; 2-Hydroxy-3-carbazolecarboxylic acid; 2-Hydroxy-3-carbazolecarboxylic acid, sodium salt; Iminodibenzyl(10,11-dihydro-5<i>H</i>-dibenz- [<i>b</i>,f]azepine); Indoline; 3-Methylbenzo[f]quinoline; 2-Methylindoline; 2-Methylmercaptobenzimidazole; 1-Methyl-2-phenylindole; 1-Methylpyrazine; 2,4-Methylpyrazolic acid; 2-Phenylbenzimidazole; 2-Phenylindole; Tetramethylpyrazine; 2,3,5-Triphenyltetrazolium chloride;<i>dl</i>-Tryptophan; and Vinylcarbazole, monomer",
      "units": [
        "kg"
      ],
      "generalRate": "5.8% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.1400",
      "rawHtsCode": "2933.99.14.00",
      "superior": null,
      "indent": "6",
      "description": "5-Amino-4-chloro-<i>α</i>-phenyl-3- pyridazinone",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.1600",
      "rawHtsCode": "2933.99.16.00",
      "superior": null,
      "indent": "6",
      "description": "<i>o</i>-Diquat dibromide (1,1'-Ethylene- 2,2'-dipyridylium dibromide)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.1701",
      "rawHtsCode": "2933.99.17.01",
      "superior": null,
      "indent": "7",
      "description": "Insecticides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.2200",
      "rawHtsCode": "2933.99.22.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.2400",
      "rawHtsCode": "2933.99.24.00",
      "superior": null,
      "indent": "5",
      "description": "Photographic chemicals",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.2600",
      "rawHtsCode": "2933.99.26.00",
      "superior": null,
      "indent": "6",
      "description": "Antihistamines",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.4200",
      "rawHtsCode": "2933.99.42.00",
      "superior": null,
      "indent": "7",
      "description": "Acriflavine; Acriflavine hydrochloride; Carbadox; and Pyrazinamide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 46%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.4600",
      "rawHtsCode": "2933.99.46.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 67.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.5100",
      "rawHtsCode": "2933.99.51.00",
      "superior": null,
      "indent": "7",
      "description": "Hydralazine hydrochloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 47.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.5300",
      "rawHtsCode": "2933.99.53.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.55",
      "rawHtsCode": "2933.99.55",
      "superior": null,
      "indent": "7",
      "description": "Analgesics, antipyretics and nonhormonal anti-inflammatory agents",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +47.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.5510",
      "rawHtsCode": "2933.99.55.10",
      "superior": null,
      "indent": "8",
      "description": "Tolmetin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.5520",
      "rawHtsCode": "2933.99.55.20",
      "superior": null,
      "indent": "8",
      "description": "Tolmetin sodium dihydrate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.5530",
      "rawHtsCode": "2933.99.55.30",
      "superior": null,
      "indent": "8",
      "description": "Tolmetin sodium (anhydrous)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.5590",
      "rawHtsCode": "2933.99.55.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.5800",
      "rawHtsCode": "2933.99.58.00",
      "superior": null,
      "indent": "8",
      "description": "Droperidol; and Imipramine hydrochloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.6100",
      "rawHtsCode": "2933.99.61.00",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 149.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.6500",
      "rawHtsCode": "2933.99.65.00",
      "superior": null,
      "indent": "7",
      "description": "Anticonvulsants, hypnotics and sedatives",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.7000",
      "rawHtsCode": "2933.99.70.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.7500",
      "rawHtsCode": "2933.99.75.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.7900",
      "rawHtsCode": "2933.99.79.00",
      "superior": null,
      "indent": "6",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.82",
      "rawHtsCode": "2933.99.82",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.8210",
      "rawHtsCode": "2933.99.82.10",
      "superior": null,
      "indent": "7",
      "description": "Benzotriazole (CAS No. 95-14-7)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.8220",
      "rawHtsCode": "2933.99.82.20",
      "superior": null,
      "indent": "7",
      "description": "Tolyltriazole (CAS No. 29385-43-1)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.8290",
      "rawHtsCode": "2933.99.82.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.8500",
      "rawHtsCode": "2933.99.85.00",
      "superior": null,
      "indent": "4",
      "description": "3-Amino-1,2,4-triazole",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.8900",
      "rawHtsCode": "2933.99.89.00",
      "superior": null,
      "indent": "4",
      "description": "Hexamethyleneimine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2933.99.9000",
      "rawHtsCode": "2933.99.90.00",
      "superior": null,
      "indent": "5",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2933.99.9701",
      "rawHtsCode": "2933.99.97.01",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934",
      "rawHtsCode": "2934",
      "superior": null,
      "indent": "0",
      "description": "Nucleic acids and their salts, whether or not chemically defined; other heterocyclic compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.10",
      "rawHtsCode": "2934.10",
      "superior": null,
      "indent": "1",
      "description": "Compounds containing an unfused thiazole ring (whether or not hydrogenated) in the structure:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.10.1000",
      "rawHtsCode": "2934.10.10.00",
      "superior": null,
      "indent": "3",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG) 3.25% (JP)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.10.2000",
      "rawHtsCode": "2934.10.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.10.7000",
      "rawHtsCode": "2934.10.70.00",
      "superior": null,
      "indent": "3",
      "description": "4,5-Dichloro-2-<i>n</i>-octyl-4-isothiazolin-3-one; Ethyl 2-(2-aminothiazol-4-yl)-2- hydroxyiminoacetate; Ethyl 2-(2-aminothiazol-4-yl)-2- methoxyiminoacetate; 2-Methyl-4-isothiazolin- 3-one; 2-<i>n</i>-Octyl-4-isothiazolin-3-one; and Thiothiamine hydrochloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.10.9000",
      "rawHtsCode": "2934.10.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG) 3.25% (JP)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.20",
      "rawHtsCode": "2934.20",
      "superior": null,
      "indent": "1",
      "description": "Compounds containing in the structure a benzothiazole ring-system (whether or not hydrogenated), not further fused:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.20.0500",
      "rawHtsCode": "2934.20.05.00",
      "superior": null,
      "indent": "2",
      "description": "<i>N</i>-<i>tert</i>-Butyl-2-benzothiazolesulfenamide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.20.1000",
      "rawHtsCode": "2934.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "2,2'-Dithiobisbenzothiazole",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.20.1500",
      "rawHtsCode": "2934.20.15.00",
      "superior": null,
      "indent": "2",
      "description": "2-Mercaptobenzothiazole; and<i>N</i>-(Oxydiethylene)benzothiazole-2-sulfenamide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.20.2000",
      "rawHtsCode": "2934.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "2-Mercaptobenzothiazole, sodium salt (2-Benzothiazolethiol, sodium salt)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.20.2500",
      "rawHtsCode": "2934.20.25.00",
      "superior": null,
      "indent": "2",
      "description": "2-Amino-5,6-dichloro benzo thiazole; 2-(4-Amino phenyl)-6-methyl benzo thiazole-7- sulfonic acid; 2-Amino-6-nitro benzo thiazole; and<i>N</i>,<i>N</i>-Di cyclo hexyl-2-benzo thiazole sulfenamide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "2934.20.3000",
      "rawHtsCode": "2934.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "2-Amino-6-methoxy benzo thiazole; 2-Amino-6-methyl benzo thiazole; 6-Ethoxy-2-benzo thiazo lethiol; 3-Methyl benzo thiazole-2-hydrazone; and Primuline base",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,KR, L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.20.3500",
      "rawHtsCode": "2934.20.35.00",
      "superior": null,
      "indent": "3",
      "description": "Pesticides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.20.4000",
      "rawHtsCode": "2934.20.40.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.20.8000",
      "rawHtsCode": "2934.20.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.30",
      "rawHtsCode": "2934.30",
      "superior": null,
      "indent": "1",
      "description": "Compounds containing in the structure a phenothiazine ring-system (whether or not hydrogenated), not further fused:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.30.1200",
      "rawHtsCode": "2934.30.12.00",
      "superior": null,
      "indent": "2",
      "description": "2-(Trifluoromethyl)phenothiazine",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.30.1800",
      "rawHtsCode": "2934.30.18.00",
      "superior": null,
      "indent": "2",
      "description": "Ethyl (1<i>H</i>-phenothiazin-2,4,1)carbamate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.30.2300",
      "rawHtsCode": "2934.30.23.00",
      "superior": null,
      "indent": "4",
      "description": "Antidepressants, tranquilizers and other psychotherapeutic agents",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 149.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.30.2700",
      "rawHtsCode": "2934.30.27.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.30.4300",
      "rawHtsCode": "2934.30.43.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.30.5000",
      "rawHtsCode": "2934.30.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.91.0000",
      "rawHtsCode": "2934.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Aminorex (INN), brotizolam (INN), clotiazepam (INN), cloxazolam (INN), dextromoramide (INN), haloxazolam (INN), ketazolam (INN), mesocarb (INN), oxazolam (INN), pemoline (INN), phendimetrazine (INN), phenmetrazine (INN) and sufentanil (INN); salts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.92.0000",
      "rawHtsCode": "2934.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other fentanyls and their derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99",
      "rawHtsCode": "2934.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.99.0100",
      "rawHtsCode": "2934.99.01.00",
      "superior": null,
      "indent": "4",
      "description": "Mycophenolate mofetil",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.99.0300",
      "rawHtsCode": "2934.99.03.00",
      "superior": null,
      "indent": "4",
      "description": "2-Acetylbenzo(<i>b</i>)thiophene; 3-Methylene-7-(2-phenoxyacetamido)- cephan-4-carboxylic acid, <i>p</i>-nitrobenzyl ester, 1-oxide; and Naphth[1,2-<i>d</i>]-[1,2,3]-oxadiazole-5-sulfonic acid and its sodium salt",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.99.0500",
      "rawHtsCode": "2934.99.05.00",
      "superior": null,
      "indent": "4",
      "description": "5-Amino-3-phenyl-1,2,4-thiadiazole (3-Phenyl-5-amino-1,2,4-thiadiazole); 2-Hydroxybenzoxazole (Benzoxazolone); 4-Phenylmorpholine; 1,9-Thianthrenedicarboxylic acid; and Thioxanthene-9-one (Thioxanthone)",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 39.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.0600",
      "rawHtsCode": "2934.99.06.00",
      "superior": null,
      "indent": "4",
      "description": "7-Nitronaphth[1,2]oxadiazole-5-sulfonic acid and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 66.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.0700",
      "rawHtsCode": "2934.99.07.00",
      "superior": null,
      "indent": "4",
      "description": "Ethyl 2-[4-[(6-chloro-2-benzoxazolyl)oxy]- phenoxy]propanoate (Fenoxaprop-ethyl)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.99.0800",
      "rawHtsCode": "2934.99.08.00",
      "superior": null,
      "indent": "4",
      "description": "2,5-Diphenyloxazole",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.0900",
      "rawHtsCode": "2934.99.09.00",
      "superior": null,
      "indent": "4",
      "description": "1,2-Benzisothiazolin-3-one",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.99.1100",
      "rawHtsCode": "2934.99.11.00",
      "superior": null,
      "indent": "6",
      "description": "2-<i>tert</i>-Butyl-4-(2,4-dichloro-5- isopropoxyphenyl)-Δ²-1,3,4- oxadiazolin-5-one; 3-Isopropyl-1<i>H</i>-2,1,3- benzothiadiazin-4-(3<i>H</i>)-one-2,2- dioxide (Bentazon); and<i>O</i>,<i>O</i>-Diethyl-S-[(6-chloro-2- oxobenzoxazolin-3-yl)methyl]- phosphorodithioate (Phosalone)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.1200",
      "rawHtsCode": "2934.99.12.00",
      "superior": null,
      "indent": "7",
      "description": "Fungicides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.1500",
      "rawHtsCode": "2934.99.15.00",
      "superior": null,
      "indent": "7",
      "description": "Herbicides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.25% (JP)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.1600",
      "rawHtsCode": "2934.99.16.00",
      "superior": null,
      "indent": "7",
      "description": "Insecticides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 64.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.1800",
      "rawHtsCode": "2934.99.18.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.2000",
      "rawHtsCode": "2934.99.20.00",
      "superior": null,
      "indent": "5",
      "description": "Photographic chemicals",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.3000",
      "rawHtsCode": "2934.99.30.00",
      "superior": null,
      "indent": "5",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.3900",
      "rawHtsCode": "2934.99.39.00",
      "superior": null,
      "indent": "6",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.4400",
      "rawHtsCode": "2934.99.44.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.4700",
      "rawHtsCode": "2934.99.47.00",
      "superior": null,
      "indent": "4",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2934.99.7000",
      "rawHtsCode": "2934.99.70.00",
      "superior": null,
      "indent": "5",
      "description": "Morpholinoethyl chloride hydrochloride; 2-Methyl-2,5-dioxo-1-oxa-2-phospholan; and (6<i>R</i>-trans)-7-Amino-3-methyl-8-oxo-5- thia-1-azabicyclo[4.2.0]-oct-2-ene-2- carboxylic acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2934.99.9001",
      "rawHtsCode": "2934.99.90.01",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935",
      "rawHtsCode": "2935",
      "superior": null,
      "indent": "0",
      "description": "Sulfonamides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2935.10.0000",
      "rawHtsCode": "2935.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "N-Methyl perfluorooctane sulfonamide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.20.0000",
      "rawHtsCode": "2935.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "N-Ethyl perfluorooctane sulfonamide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.30.0000",
      "rawHtsCode": "2935.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "N-Ethyl -N-(2-hydroxyethyl)perfluorooctane sulfonamide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.40.0000",
      "rawHtsCode": "2935.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "N-(2-hydroxyethyl)-N-methyl perfluorooctane sulfonamide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.50.0000",
      "rawHtsCode": "2935.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other perfluorooctane sulfonamides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.90",
      "rawHtsCode": "2935.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2935.90.0600",
      "rawHtsCode": "2935.90.06.00",
      "superior": null,
      "indent": "2",
      "description": "4-Amino-6-chloro-<i>m</i>-benzenedisulfonamide and <newline></newline>Methyl-4-aminobenzenesulfonylcarbamate (Asulam)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 41%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.90.1000",
      "rawHtsCode": "2935.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "2-Amino-<i>N</i>-ethylbenzenesulfonanilide; <newline></newline>5-Amino-<i>α</i>,<i>α</i>,<i>α</i>-trifluorotoluene-2,4-disulfonamide; <newline></newline>Benzenesulfonamide; <newline></newline>Benzenesulfonyl hydrazide; <newline></newline>2-Chloro-4-amino-5-hydroxybenzenesulfonamide; <newline></newline>2,5-Dimethoxysulfanilanilide; and <newline></newline>Metanilamide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 41%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.90.1300",
      "rawHtsCode": "2935.90.13.00",
      "superior": null,
      "indent": "2",
      "description": "(5‐[2‐Chloro‐4‐ (trifluoromethyl)phenoxy]‐N‐ (methylsulfonyl)‐2‐nitrobenzamide) (Fomesafen); N‐(2,6‐Dichloro‐3‐ methylphenyl)‐5‐ amino‐1,3,4‐triazole‐2‐sulfonamide; 2,4‐Dichloro‐5‐ sulfamoylbenzoic acid; N‐Ethyl‐o‐ toluenesulfonamide; N‐Ethyl‐p‐toluenesulfonamide; 7-(Hexadecylsulfonylamino) ‐1H‐indole; Methyl 5‐{[(4,6‐dimethoxy‐2‐pyrimidinyl)amino]‐ carbonylaminosulfonyl} ‐3‐chloro‐1‐methyl‐1H‐pyrazole‐4‐carboxylate (Halosulfuron methyl); and Mixtures of ortho‐ and para-toluenesulfonamides",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 57.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2935.90.1500",
      "rawHtsCode": "2935.90.15.00",
      "superior": null,
      "indent": "2",
      "description": "<i>o</i>-Toluenesulfonamide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.90.2000",
      "rawHtsCode": "2935.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Fast color bases and fast color salts",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.90.2900",
      "rawHtsCode": "2935.90.29.00",
      "superior": null,
      "indent": "5",
      "description": "Acetylsulfaguanidine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 96%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2935.90.3000",
      "rawHtsCode": "2935.90.30.00",
      "superior": null,
      "indent": "5",
      "description": "Sulfamethazine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2935.90.3200",
      "rawHtsCode": "2935.90.32.00",
      "superior": null,
      "indent": "5",
      "description": "Acetylsulfisoxazole; Sulfacetamide, sodium; and Sulfamethazine, sodium",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 96%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.90.3300",
      "rawHtsCode": "2935.90.33.00",
      "superior": null,
      "indent": "5",
      "description": "Sulfathiazole and Sulfathiazole, sodium",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 133%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2935.90.4200",
      "rawHtsCode": "2935.90.42.00",
      "superior": null,
      "indent": "5",
      "description": "Salicylazosulfapyridine (Sulfasalazine); Sulfadiazine; Sulfaguanidine; Sulfamerizine; and Sulfapyridine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 128.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2935.90.4800",
      "rawHtsCode": "2935.90.48.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 96%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.90.6000",
      "rawHtsCode": "2935.90.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.90.7500",
      "rawHtsCode": "2935.90.75.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,L,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2935.90.9500",
      "rawHtsCode": "2935.90.95.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2936",
      "rawHtsCode": "2936",
      "superior": null,
      "indent": "0",
      "description": "Provitamins and vitamins, natural or reproduced by synthesis (including natural concentrates), derivatives thereof used primarily as vitamins, and intermixtures of the foregoing, whether or not in any solvent:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.21.0000",
      "rawHtsCode": "2936.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Vitamins A and their derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.22.0000",
      "rawHtsCode": "2936.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Vitamin B<sub>1</sub> (Thiamine) and its derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.23.0000",
      "rawHtsCode": "2936.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Vitamin B<sub>2</sub> (Riboflavin) and its derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 62%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.24.0100",
      "rawHtsCode": "2936.24.01.00",
      "superior": null,
      "indent": "2",
      "description": "D- or DL-Pantothenic acid (Vitamin B<sub>5</sub>) and its derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.25.0000",
      "rawHtsCode": "2936.25.00.00",
      "superior": null,
      "indent": "2",
      "description": "Vitamin B<sub>6</sub> (Pyridoxine and related compounds with Vitamin B<sub>6</sub> activity) and its derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.26.0000",
      "rawHtsCode": "2936.26.00.00",
      "superior": null,
      "indent": "2",
      "description": "Vitamin B<sub>12</sub> (Cyanocobalamin and related compounds with Vitamin B<sub>12</sub> activity) and its derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 145.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.27.0000",
      "rawHtsCode": "2936.27.00.00",
      "superior": null,
      "indent": "2",
      "description": "Vitamin C (Ascorbic acid) and its derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.28.0000",
      "rawHtsCode": "2936.28.00.00",
      "superior": null,
      "indent": "2",
      "description": "Vitamin E (Tocopherols and related compounds with Vitamin E activity) and its derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 63.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.29",
      "rawHtsCode": "2936.29",
      "superior": null,
      "indent": "2",
      "description": "Other vitamins and their derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.29.1000",
      "rawHtsCode": "2936.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Folic acid",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.29.16",
      "rawHtsCode": "2936.29.16",
      "superior": null,
      "indent": "3",
      "description": "Niacin and niacinamide",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.29.1610",
      "rawHtsCode": "2936.29.16.10",
      "superior": null,
      "indent": "5",
      "description": "Pharmaceutical grade",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.29.1620",
      "rawHtsCode": "2936.29.16.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.29.1630",
      "rawHtsCode": "2936.29.16.30",
      "superior": null,
      "indent": "4",
      "description": "Niacinamide",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.29.2000",
      "rawHtsCode": "2936.29.20.00",
      "superior": null,
      "indent": "4",
      "description": "Aromatic or modified aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.29.50",
      "rawHtsCode": "2936.29.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.29.5020",
      "rawHtsCode": "2936.29.50.20",
      "superior": null,
      "indent": "5",
      "description": "Vitamins D and their derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.29.5030",
      "rawHtsCode": "2936.29.50.30",
      "superior": null,
      "indent": "5",
      "description": "Biotin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.29.5050",
      "rawHtsCode": "2936.29.50.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.90.01",
      "rawHtsCode": "2936.90.01",
      "superior": null,
      "indent": "1",
      "description": "Other, including provitamins and natural concentrates",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.90.0110",
      "rawHtsCode": "2936.90.01.10",
      "superior": null,
      "indent": "2",
      "description": "Provitamins",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2936.90.0150",
      "rawHtsCode": "2936.90.01.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937",
      "rawHtsCode": "2937",
      "superior": null,
      "indent": "0",
      "description": "Hormones, prostaglandins, thromboxanes and leukotrienes, natural or reproduced by synthesis; derivatives and structural analogues thereof, including chain modified polypeptides, used primarily as hormones:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.11.0000",
      "rawHtsCode": "2937.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Somatotropin, its derivatives and structural analogues",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.12.0000",
      "rawHtsCode": "2937.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Insulin and its salts",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.19.0000",
      "rawHtsCode": "2937.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.21.00",
      "rawHtsCode": "2937.21.00",
      "superior": null,
      "indent": "2",
      "description": "Cortisone, hydrocortisone, prednisone (dehydrocortisone), and prednisolone (dehydrohydrocortisone)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.21.0010",
      "rawHtsCode": "2937.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Cortisone",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.21.0020",
      "rawHtsCode": "2937.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Hydrocortisone",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.21.0030",
      "rawHtsCode": "2937.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Prednisone",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.21.0040",
      "rawHtsCode": "2937.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Prednisolone",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.22.0000",
      "rawHtsCode": "2937.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Halogenated derivatives of adrenal cortical hormones",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.23",
      "rawHtsCode": "2937.23",
      "superior": null,
      "indent": "2",
      "description": "Estrogens and progestins:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.23.10",
      "rawHtsCode": "2937.23.10",
      "superior": null,
      "indent": "3",
      "description": "Obtained directly or indirectly from animal or vegetable materials",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.23.1010",
      "rawHtsCode": "2937.23.10.10",
      "superior": null,
      "indent": "4",
      "description": "Estrogens",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.23.1020",
      "rawHtsCode": "2937.23.10.20",
      "superior": null,
      "indent": "5",
      "description": "Progesterone",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.23.1050",
      "rawHtsCode": "2937.23.10.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.23.2500",
      "rawHtsCode": "2937.23.25.00",
      "superior": null,
      "indent": "4",
      "description": "Estradiol benzoate; and Estradiol cyclopentylpropionate (Estradiol cypionate)",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.23.50",
      "rawHtsCode": "2937.23.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 78.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.23.5010",
      "rawHtsCode": "2937.23.50.10",
      "superior": null,
      "indent": "5",
      "description": "Estrogens",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.23.5020",
      "rawHtsCode": "2937.23.50.20",
      "superior": null,
      "indent": "6",
      "description": "Progesterone",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.23.5050",
      "rawHtsCode": "2937.23.50.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.29",
      "rawHtsCode": "2937.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.29.1000",
      "rawHtsCode": "2937.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Desonide; andNandrolone phenproprionate",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.29.90",
      "rawHtsCode": "2937.29.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.29.9020",
      "rawHtsCode": "2937.29.90.20",
      "superior": null,
      "indent": "4",
      "description": "Salts and esters of hydrocortisone",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.29.9030",
      "rawHtsCode": "2937.29.90.30",
      "superior": null,
      "indent": "4",
      "description": "Salts and esters of prednisone",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.29.9040",
      "rawHtsCode": "2937.29.90.40",
      "superior": null,
      "indent": "4",
      "description": "Salts and esters of prednisolone",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.29.9050",
      "rawHtsCode": "2937.29.90.50",
      "superior": null,
      "indent": "4",
      "description": "Anabolic agents and androgens",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.29.9095",
      "rawHtsCode": "2937.29.90.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.50.0000",
      "rawHtsCode": "2937.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Prostaglandins, thromboxanes and leukotrienes, their derivatives and structural analogues",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.90",
      "rawHtsCode": "2937.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.90.0500",
      "rawHtsCode": "2937.90.05.00",
      "superior": null,
      "indent": "3",
      "description": "Epinephrine",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.90.1000",
      "rawHtsCode": "2937.90.10.00",
      "superior": null,
      "indent": "4",
      "description": "Epinephrine hydrochloride",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.90.2000",
      "rawHtsCode": "2937.90.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.90.4000",
      "rawHtsCode": "2937.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "<i>l</i>-Thyroxine (Levothyroxine), sodium",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.90.4500",
      "rawHtsCode": "2937.90.45.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2937.90.9000",
      "rawHtsCode": "2937.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2938",
      "rawHtsCode": "2938",
      "superior": null,
      "indent": "0",
      "description": "Glycosides, natural or reproduced by synthesis, and their salts, ethers, esters and other derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2938.10.0000",
      "rawHtsCode": "2938.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Rutoside (Rutin) and its derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2938.90.0000",
      "rawHtsCode": "2938.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2939",
      "rawHtsCode": "2939",
      "superior": null,
      "indent": "0",
      "description": "Alkaloids, natural or reproduced by synthesis, and their salts, ethers, esters and other derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.11.0000",
      "rawHtsCode": "2939.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Concentrates of poppy straw; buprenorphine (INN); codeine, dihydrocodeine (INN), ethylmorphine, etorphine (INN), heroin, hydrocodone (INN), hydromorphone (INN), morphine, nicomorphine (INN), oxycodone (INN), oxymorphone (INN), pholcodine (INN), thebacon (INN) and thebaine; salts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.19",
      "rawHtsCode": "2939.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.19.1000",
      "rawHtsCode": "2939.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Papaverine and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 104%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.19.2000",
      "rawHtsCode": "2939.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "Synthetic",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.19.5000",
      "rawHtsCode": "2939.19.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10.6¢/g",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.20.00",
      "rawHtsCode": "2939.20.00",
      "superior": null,
      "indent": "1",
      "description": "Alkaloids of cinchona and their derivatives; salts thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.20.0010",
      "rawHtsCode": "2939.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Quinine and its salts",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.20.0050",
      "rawHtsCode": "2939.20.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.30.0000",
      "rawHtsCode": "2939.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Caffeine and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "59%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.41.0000",
      "rawHtsCode": "2939.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ephedrine and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 59%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.42.0000",
      "rawHtsCode": "2939.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Pseudoephedrine (INN) and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 59%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.43.0000",
      "rawHtsCode": "2939.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cathine (INN) and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 59%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.44.0000",
      "rawHtsCode": "2939.44.00.00",
      "superior": null,
      "indent": "2",
      "description": "Norephedrine and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 59%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.45.0000",
      "rawHtsCode": "2939.45.00.00",
      "superior": null,
      "indent": "2",
      "description": "Levometamfetamine, metamfetamine (INN), metamfetamine racemate and their salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.49.0300",
      "rawHtsCode": "2939.49.03.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 59%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.51.0000",
      "rawHtsCode": "2939.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fenetylline (INN) and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.59.0000",
      "rawHtsCode": "2939.59.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.61.0000",
      "rawHtsCode": "2939.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ergometrine and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.62.0000",
      "rawHtsCode": "2939.62.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ergotamine and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.63.0000",
      "rawHtsCode": "2939.63.00.00",
      "superior": null,
      "indent": "2",
      "description": "Lysergic acid and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.69.0000",
      "rawHtsCode": "2939.69.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.72.0000",
      "rawHtsCode": "2939.72.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cocaine, ecgonine; salts, esters and other derivatives thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.79.0000",
      "rawHtsCode": "2939.79.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.80.00",
      "rawHtsCode": "2939.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "6.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2939.80.0010",
      "rawHtsCode": "2939.80.00.10",
      "superior": null,
      "indent": "2",
      "description": "Saxitoxin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2939.80.0050",
      "rawHtsCode": "2939.80.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2940.00",
      "rawHtsCode": "2940.00",
      "superior": null,
      "indent": "0",
      "description": "Sugars, chemically pure, other than sucrose, lactose, maltose, glucose and fructose; sugar ethers, sugar acetals and sugar esters, and their salts, other than products of heading 2937, 2938 or 2939:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2940.00.2000",
      "rawHtsCode": "2940.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "<i>D</i>-Arabinose",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2940.00.6000",
      "rawHtsCode": "2940.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.8% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2941",
      "rawHtsCode": "2941",
      "superior": null,
      "indent": "0",
      "description": "Antibiotics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.10",
      "rawHtsCode": "2941.10",
      "superior": null,
      "indent": "1",
      "description": "Penicillins and their derivatives with a penicillanic acid structure; salts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.10.1000",
      "rawHtsCode": "2941.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Ampicillin and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.10.2000",
      "rawHtsCode": "2941.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Penicillin G salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.10.3000",
      "rawHtsCode": "2941.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Carfecillin, sodium; Cloxacillin, sodium; Dicloxacillin, sodium; Flucloxacillin (Floxacillin); and Oxacillin, sodium",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.10.5000",
      "rawHtsCode": "2941.10.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 56.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.20",
      "rawHtsCode": "2941.20",
      "superior": null,
      "indent": "1",
      "description": "Streptomycins and their derivatives; salts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.20.1000",
      "rawHtsCode": "2941.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Dihydrostreptomycin and its derivatives; salts thereof",
      "units": [
        "g"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2941.20.5000",
      "rawHtsCode": "2941.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.30.0000",
      "rawHtsCode": "2941.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tetracyclines and their derivatives; salts thereof",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.40.0000",
      "rawHtsCode": "2941.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Chloramphenicol and its derivatives; salts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.50.0000",
      "rawHtsCode": "2941.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Erythromycin and its derivatives; salts thereof",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.90",
      "rawHtsCode": "2941.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.90.10",
      "rawHtsCode": "2941.90.10",
      "superior": null,
      "indent": "2",
      "description": "Natural",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.90.1010",
      "rawHtsCode": "2941.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Aminoglycoside antibiotics",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.90.1050",
      "rawHtsCode": "2941.90.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.90.3000",
      "rawHtsCode": "2941.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Aromatic or modified aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2941.90.5000",
      "rawHtsCode": "2941.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2942.00",
      "rawHtsCode": "2942.00",
      "superior": null,
      "indent": "0",
      "description": "Other organic compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "2942.00.0300",
      "rawHtsCode": "2942.00.03.00",
      "superior": null,
      "indent": "2",
      "description": "[2,2'-Thiobis(4-(1,1,3,3-tetramethyl-<i>n</i>-butyl)- phenolato)(2,1)]-<i>O</i>,<i>O</i>',<i>S</i>-(1-butanamine), nickel II",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 46.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "2942.00.0500",
      "rawHtsCode": "2942.00.05.00",
      "superior": null,
      "indent": "3",
      "description": "Drugs",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2942.00.1000",
      "rawHtsCode": "2942.00.10.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 46.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2942.00.3500",
      "rawHtsCode": "2942.00.35.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO,K, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 46.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "2942.00.5000",
      "rawHtsCode": "2942.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3001",
      "rawHtsCode": "3001",
      "superior": null,
      "indent": "0",
      "description": "Glands and other organs for organotherapeutic uses, dried, whether or not powdered; extracts of glands or other organs or of their secretions for organotherapeutic uses; heparin and its salts; other human or animal substances prepared for therapeutic or prophylactic uses, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3001.20.0000",
      "rawHtsCode": "3001.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Extracts of glands or other organs or of their secretions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3001.90.01",
      "rawHtsCode": "3001.90.01",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3001.90.0110",
      "rawHtsCode": "3001.90.01.10",
      "superior": null,
      "indent": "3",
      "description": "Liver",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3001.90.0150",
      "rawHtsCode": "3001.90.01.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3001.90.0165",
      "rawHtsCode": "3001.90.01.65",
      "superior": null,
      "indent": "3",
      "description": "Heparin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3001.90.0195",
      "rawHtsCode": "3001.90.01.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002",
      "rawHtsCode": "3002",
      "superior": null,
      "indent": "0",
      "description": "Human blood; animal blood prepared for therapeutic, prophylactic or diagnostic uses; antisera, other blood fractions and immunological products, whether or not modified or obtained by means of biotechnological processes; vaccines, toxins, cultures of micro-organisms (excluding yeasts) and similar products; cell cultures, whether or not modified:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.12.00",
      "rawHtsCode": "3002.12.00",
      "superior": null,
      "indent": "2",
      "description": "Antisera and other blood fractions",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.12.0010",
      "rawHtsCode": "3002.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Human blood plasma",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.12.0020",
      "rawHtsCode": "3002.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Normal human blood sera, whether or not freeze-dried",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.12.0030",
      "rawHtsCode": "3002.12.00.30",
      "superior": null,
      "indent": "3",
      "description": "Human immune blood sera",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.12.0040",
      "rawHtsCode": "3002.12.00.40",
      "superior": null,
      "indent": "3",
      "description": "Fetal Bovine Serum (FBS)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.12.0090",
      "rawHtsCode": "3002.12.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.13.00",
      "rawHtsCode": "3002.13.00",
      "superior": null,
      "indent": "2",
      "description": "Immunological products, unmixed, not put up in measured doses or in forms or packings for retail sale",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.13.0010",
      "rawHtsCode": "3002.13.00.10",
      "superior": null,
      "indent": "3",
      "description": "Monoclonal antibodies",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.13.0090",
      "rawHtsCode": "3002.13.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.14.00",
      "rawHtsCode": "3002.14.00",
      "superior": null,
      "indent": "2",
      "description": "Immunological products, mixed, not put up in measured doses or in forms or packings for retail sale",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.14.0010",
      "rawHtsCode": "3002.14.00.10",
      "superior": null,
      "indent": "3",
      "description": "Containing monoclonal antibodies",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.14.0090",
      "rawHtsCode": "3002.14.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.15.00",
      "rawHtsCode": "3002.15.00",
      "superior": null,
      "indent": "2",
      "description": "Immunological products, put up in measured doses or in forms or packings for retail sale",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.15.0011",
      "rawHtsCode": "3002.15.00.11",
      "superior": null,
      "indent": "3",
      "description": "Containing monoclonal antibodies",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.15.0091",
      "rawHtsCode": "3002.15.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.41.0000",
      "rawHtsCode": "3002.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Vaccines for human medicine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.42.0000",
      "rawHtsCode": "3002.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Vaccines for veterinary medicine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.49.00",
      "rawHtsCode": "3002.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.49.0010",
      "rawHtsCode": "3002.49.00.10",
      "superior": null,
      "indent": "3",
      "description": "Ricin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.49.0050",
      "rawHtsCode": "3002.49.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.51.0000",
      "rawHtsCode": "3002.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cell therapy products",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.59.0000",
      "rawHtsCode": "3002.59.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.90",
      "rawHtsCode": "3002.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.90.1000",
      "rawHtsCode": "3002.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Ferments",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.90.52",
      "rawHtsCode": "3002.90.52",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.90.5210",
      "rawHtsCode": "3002.90.52.10",
      "superior": null,
      "indent": "3",
      "description": "Whole human blood",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.90.5220",
      "rawHtsCode": "3002.90.52.20",
      "superior": null,
      "indent": "3",
      "description": "Antiallergenic preparations",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3002.90.5250",
      "rawHtsCode": "3002.90.52.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003",
      "rawHtsCode": "3003",
      "superior": null,
      "indent": "0",
      "description": "Medicaments (excluding goods of heading 3002, 3005 or 3006) consisting of two or more constituents which have been mixed together for therapeutic or prophylactic uses, not put up in measured doses or in forms or packings for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.10.0000",
      "rawHtsCode": "3003.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Containing penicillins or derivatives thereof, with a penicillanic acid structure, or streptomycins or their derivatives",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.20.0000",
      "rawHtsCode": "3003.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other, containing antibiotics",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.31.0000",
      "rawHtsCode": "3003.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing insulin",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.39",
      "rawHtsCode": "3003.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.39.1000",
      "rawHtsCode": "3003.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Artificial mixtures of natural hormones",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.39.5000",
      "rawHtsCode": "3003.39.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.41.0000",
      "rawHtsCode": "3003.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing ephedrine or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.42.0000",
      "rawHtsCode": "3003.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing pseudoephedrine (INN) or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.43.0000",
      "rawHtsCode": "3003.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing norephedrine or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.49.0000",
      "rawHtsCode": "3003.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.60.0000",
      "rawHtsCode": "3003.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other, containing antimalarial active principles described in subheading note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.90.01",
      "rawHtsCode": "3003.90.01",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.90.0120",
      "rawHtsCode": "3003.90.01.20",
      "superior": null,
      "indent": "3",
      "description": "Antivirals",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.90.0140",
      "rawHtsCode": "3003.90.01.40",
      "superior": null,
      "indent": "3",
      "description": "Antifungals",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.90.0160",
      "rawHtsCode": "3003.90.01.60",
      "superior": null,
      "indent": "3",
      "description": "Antiprotozoals (excluding goods described in subheading note 2 to this chapter)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.90.0180",
      "rawHtsCode": "3003.90.01.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3003.90.0190",
      "rawHtsCode": "3003.90.01.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004",
      "rawHtsCode": "3004",
      "superior": null,
      "indent": "0",
      "description": "Medicaments (excluding goods of heading 3002, 3005 or 3006) consisting of mixed or unmixed products for therapeutic or prophylactic uses, put up in measured doses (including those in the form of transdermal administration systems) or in forms or packings for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.10",
      "rawHtsCode": "3004.10",
      "superior": null,
      "indent": "1",
      "description": "Containing penicillins or derivatives thereof, with a penicillanic acid structure, or streptomycins or their derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.10.10",
      "rawHtsCode": "3004.10.10",
      "superior": null,
      "indent": "2",
      "description": "Containing penicillin G salts",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.10.1010",
      "rawHtsCode": "3004.10.10.10",
      "superior": null,
      "indent": "3",
      "description": "For veterinary use",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.10.1020",
      "rawHtsCode": "3004.10.10.20",
      "superior": null,
      "indent": "4",
      "description": "Singles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.10.1045",
      "rawHtsCode": "3004.10.10.45",
      "superior": null,
      "indent": "4",
      "description": "Combination antibiotics",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.10.50",
      "rawHtsCode": "3004.10.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.10.5010",
      "rawHtsCode": "3004.10.50.10",
      "superior": null,
      "indent": "3",
      "description": "For veterinary use",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.10.5048",
      "rawHtsCode": "3004.10.50.48",
      "superior": null,
      "indent": "5",
      "description": "Containing piperacillin and tazobactam or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.10.5049",
      "rawHtsCode": "3004.10.50.49",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.10.5055",
      "rawHtsCode": "3004.10.50.55",
      "superior": null,
      "indent": "6",
      "description": "For oral suspension",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.10.5065",
      "rawHtsCode": "3004.10.50.65",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.10.5075",
      "rawHtsCode": "3004.10.50.75",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.00",
      "rawHtsCode": "3004.20.00",
      "superior": null,
      "indent": "1",
      "description": "Other, containing antibiotics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.0010",
      "rawHtsCode": "3004.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "For veterinary use",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.0020",
      "rawHtsCode": "3004.20.00.20",
      "superior": null,
      "indent": "3",
      "description": "Erythromycin, singles or in combination with other antibiotics",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.0030",
      "rawHtsCode": "3004.20.00.30",
      "superior": null,
      "indent": "3",
      "description": "Tetracycline, singles or in combination with other antibiotics",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.0045",
      "rawHtsCode": "3004.20.00.45",
      "superior": null,
      "indent": "4",
      "description": "Containing azithromycin or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.0055",
      "rawHtsCode": "3004.20.00.55",
      "superior": null,
      "indent": "4",
      "description": "Containing clindamycin or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.0065",
      "rawHtsCode": "3004.20.00.65",
      "superior": null,
      "indent": "4",
      "description": "Containing doxycycline or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.0070",
      "rawHtsCode": "3004.20.00.70",
      "superior": null,
      "indent": "4",
      "description": "Containing cefdinir or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.0071",
      "rawHtsCode": "3004.20.00.71",
      "superior": null,
      "indent": "4",
      "description": "Containing cefepime or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.0072",
      "rawHtsCode": "3004.20.00.72",
      "superior": null,
      "indent": "4",
      "description": "Containing ceftazidime or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.0076",
      "rawHtsCode": "3004.20.00.76",
      "superior": null,
      "indent": "4",
      "description": "Containing meropenem or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.0080",
      "rawHtsCode": "3004.20.00.80",
      "superior": null,
      "indent": "4",
      "description": "Containing vancomycin or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.20.0083",
      "rawHtsCode": "3004.20.00.83",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.31.0000",
      "rawHtsCode": "3004.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing insulin",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.32.00",
      "rawHtsCode": "3004.32.00",
      "superior": null,
      "indent": "2",
      "description": "Containing corticosteroid hormones their derivatives or structural analogues",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.32.0010",
      "rawHtsCode": "3004.32.00.10",
      "superior": null,
      "indent": "3",
      "description": "Containing dexamethasone or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.32.0040",
      "rawHtsCode": "3004.32.00.40",
      "superior": null,
      "indent": "3",
      "description": "Containing methylprednisolone or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.32.0060",
      "rawHtsCode": "3004.32.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.39.00",
      "rawHtsCode": "3004.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.39.0010",
      "rawHtsCode": "3004.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "For veterinary use",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.39.0020",
      "rawHtsCode": "3004.39.00.20",
      "superior": null,
      "indent": "4",
      "description": "Containing epinephrine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.39.0030",
      "rawHtsCode": "3004.39.00.30",
      "superior": null,
      "indent": "4",
      "description": "Containing levothyroxine or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.39.0040",
      "rawHtsCode": "3004.39.00.40",
      "superior": null,
      "indent": "4",
      "description": "Containing norepinephrine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.39.0045",
      "rawHtsCode": "3004.39.00.45",
      "superior": null,
      "indent": "4",
      "description": "Containing vasopressin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.39.0055",
      "rawHtsCode": "3004.39.00.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.41.0000",
      "rawHtsCode": "3004.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing ephedrine or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.42.0000",
      "rawHtsCode": "3004.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing pseudoephedrine (INN) or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.43.0000",
      "rawHtsCode": "3004.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing norephedrine or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.49.00",
      "rawHtsCode": "3004.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.49.0005",
      "rawHtsCode": "3004.49.00.05",
      "superior": null,
      "indent": "3",
      "description": "For veterinary use",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.49.0010",
      "rawHtsCode": "3004.49.00.10",
      "superior": null,
      "indent": "4",
      "description": "Cardiovascular medicaments",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.49.0020",
      "rawHtsCode": "3004.49.00.20",
      "superior": null,
      "indent": "5",
      "description": "Anticonvulsants, hypnotics, and sedatives",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.49.0030",
      "rawHtsCode": "3004.49.00.30",
      "superior": null,
      "indent": "5",
      "description": "Antidepressants, tranquilizers and other psychotherapeutic agents",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.49.0040",
      "rawHtsCode": "3004.49.00.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.49.0050",
      "rawHtsCode": "3004.49.00.50",
      "superior": null,
      "indent": "4",
      "description": "Dermatological agents and local anesthetics",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.49.0060",
      "rawHtsCode": "3004.49.00.60",
      "superior": null,
      "indent": "4",
      "description": "Medicaments primarily affecting the eyes, ears or respiratory system",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.49.0070",
      "rawHtsCode": "3004.49.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.50",
      "rawHtsCode": "3004.50",
      "superior": null,
      "indent": "2",
      "description": "Containing vitamins synthesized wholly or in part from aromatic or modified aromatic industrial organic compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.50.1000",
      "rawHtsCode": "3004.50.10.00",
      "superior": null,
      "indent": "3",
      "description": "Vitamin B<sub>2</sub>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 62%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.50.2000",
      "rawHtsCode": "3004.50.20.00",
      "superior": null,
      "indent": "3",
      "description": "Vitamin B<sub>12</sub>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 145.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.50.3000",
      "rawHtsCode": "3004.50.30.00",
      "superior": null,
      "indent": "3",
      "description": "Vitamin E",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 63.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.50.4000",
      "rawHtsCode": "3004.50.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.50.50",
      "rawHtsCode": "3004.50.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.50.5005",
      "rawHtsCode": "3004.50.50.05",
      "superior": null,
      "indent": "3",
      "description": "For veterinary use",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.50.5010",
      "rawHtsCode": "3004.50.50.10",
      "superior": null,
      "indent": "5",
      "description": "Combined with minerals or other nutrients",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.50.5020",
      "rawHtsCode": "3004.50.50.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.50.5030",
      "rawHtsCode": "3004.50.50.30",
      "superior": null,
      "indent": "5",
      "description": "Combined with minerals or other nutrients",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.50.5040",
      "rawHtsCode": "3004.50.50.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.60.0000",
      "rawHtsCode": "3004.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other, containing antimalarial active principles described in subheading note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90",
      "rawHtsCode": "3004.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.1000",
      "rawHtsCode": "3004.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing antigens or hyaluronic acid or its sodium salt",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.92",
      "rawHtsCode": "3004.90.92",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9201",
      "rawHtsCode": "3004.90.92.01",
      "superior": null,
      "indent": "3",
      "description": "For veterinary use",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9203",
      "rawHtsCode": "3004.90.92.03",
      "superior": null,
      "indent": "6",
      "description": "Containing acyclovir or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9204",
      "rawHtsCode": "3004.90.92.04",
      "superior": null,
      "indent": "6",
      "description": "Containing oseltamivir or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9205",
      "rawHtsCode": "3004.90.92.05",
      "superior": null,
      "indent": "6",
      "description": "Containing valganciclovir, peramivir or their salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9206",
      "rawHtsCode": "3004.90.92.06",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9207",
      "rawHtsCode": "3004.90.92.07",
      "superior": null,
      "indent": "6",
      "description": "Containing fluconazole or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9208",
      "rawHtsCode": "3004.90.92.08",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9209",
      "rawHtsCode": "3004.90.92.09",
      "superior": null,
      "indent": "6",
      "description": "Containing metronidazole or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9210",
      "rawHtsCode": "3004.90.92.10",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9211",
      "rawHtsCode": "3004.90.92.11",
      "superior": null,
      "indent": "5",
      "description": "Sulfonamides",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9212",
      "rawHtsCode": "3004.90.92.12",
      "superior": null,
      "indent": "6",
      "description": "Containing levofloxacin or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9213",
      "rawHtsCode": "3004.90.92.13",
      "superior": null,
      "indent": "6",
      "description": "Containing linezolid or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9215",
      "rawHtsCode": "3004.90.92.15",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9216",
      "rawHtsCode": "3004.90.92.16",
      "superior": null,
      "indent": "4",
      "description": "Antineoplastic and immunosuppressive medicaments",
      "units": [
        "kg"
      ],
      "generalRate": "\n",
      "specialRate": "",
      "otherRate": "\n",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9217",
      "rawHtsCode": "3004.90.92.17",
      "superior": null,
      "indent": "5",
      "description": "Containing metoprolol or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9218",
      "rawHtsCode": "3004.90.92.18",
      "superior": null,
      "indent": "5",
      "description": "Containing amiodarone or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9219",
      "rawHtsCode": "3004.90.92.19",
      "superior": null,
      "indent": "5",
      "description": "Containing diltiazem or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9220",
      "rawHtsCode": "3004.90.92.20",
      "superior": null,
      "indent": "5",
      "description": "Containing hydralazine or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9222",
      "rawHtsCode": "3004.90.92.22",
      "superior": null,
      "indent": "5",
      "description": "Containing enoxaparin or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9223",
      "rawHtsCode": "3004.90.92.23",
      "superior": null,
      "indent": "5",
      "description": "Containing labetalol or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9224",
      "rawHtsCode": "3004.90.92.24",
      "superior": null,
      "indent": "5",
      "description": "Containing argatroban, adenosine, amlodipine, esmolol, dobutamine, phenoxybenzamine or their salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9225",
      "rawHtsCode": "3004.90.92.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9226",
      "rawHtsCode": "3004.90.92.26",
      "superior": null,
      "indent": "6",
      "description": "Tolmetin",
      "units": [
        "kg"
      ],
      "generalRate": "\n",
      "specialRate": "",
      "otherRate": "\n",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9227",
      "rawHtsCode": "3004.90.92.27",
      "superior": null,
      "indent": "6",
      "description": "Tolmetin sodium dihydrate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9228",
      "rawHtsCode": "3004.90.92.28",
      "superior": null,
      "indent": "6",
      "description": "Tolmetin sodium (anhydrous)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9229",
      "rawHtsCode": "3004.90.92.29",
      "superior": null,
      "indent": "7",
      "description": "For oral suspension",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9230",
      "rawHtsCode": "3004.90.92.30",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9232",
      "rawHtsCode": "3004.90.92.32",
      "superior": null,
      "indent": "7",
      "description": "For oral suspension",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9233",
      "rawHtsCode": "3004.90.92.33",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9234",
      "rawHtsCode": "3004.90.92.34",
      "superior": null,
      "indent": "6",
      "description": "Containing O-Acetylsalicylic acid (Aspirin)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9235",
      "rawHtsCode": "3004.90.92.35",
      "superior": null,
      "indent": "6",
      "description": "Containing tramadol",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9236",
      "rawHtsCode": "3004.90.92.36",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9237",
      "rawHtsCode": "3004.90.92.37",
      "superior": null,
      "indent": "6",
      "description": "Containing dexmedetomidine, etomidate, midazolam, propofol or their salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9238",
      "rawHtsCode": "3004.90.92.38",
      "superior": null,
      "indent": "6",
      "description": "Containing midazolam or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9239",
      "rawHtsCode": "3004.90.92.39",
      "superior": null,
      "indent": "6",
      "description": "Containing phenytoin or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9240",
      "rawHtsCode": "3004.90.92.40",
      "superior": null,
      "indent": "6",
      "description": "Containing propofol or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9241",
      "rawHtsCode": "3004.90.92.41",
      "superior": null,
      "indent": "6",
      "description": "Containing levetiracetam, phenytoin or their salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9242",
      "rawHtsCode": "3004.90.92.42",
      "superior": null,
      "indent": "6",
      "description": "Containing etomidate or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9243",
      "rawHtsCode": "3004.90.92.43",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9244",
      "rawHtsCode": "3004.90.92.44",
      "superior": null,
      "indent": "6",
      "description": "Containing lorazepam or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9245",
      "rawHtsCode": "3004.90.92.45",
      "superior": null,
      "indent": "6",
      "description": "Containing olanzapine or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9246",
      "rawHtsCode": "3004.90.92.46",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9247",
      "rawHtsCode": "3004.90.92.47",
      "superior": null,
      "indent": "6",
      "description": "Containing rocuronium or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9248",
      "rawHtsCode": "3004.90.92.48",
      "superior": null,
      "indent": "6",
      "description": "Containing succinylcholine or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9249",
      "rawHtsCode": "3004.90.92.49",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9250",
      "rawHtsCode": "3004.90.92.50",
      "superior": null,
      "indent": "5",
      "description": "Containing lidocaine or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9251",
      "rawHtsCode": "3004.90.92.51",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9252",
      "rawHtsCode": "3004.90.92.52",
      "superior": null,
      "indent": "5",
      "description": "Laxatives",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9253",
      "rawHtsCode": "3004.90.92.53",
      "superior": null,
      "indent": "5",
      "description": "Antacids",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9254",
      "rawHtsCode": "3004.90.92.54",
      "superior": null,
      "indent": "5",
      "description": "Containing famotidine or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9255",
      "rawHtsCode": "3004.90.92.55",
      "superior": null,
      "indent": "5",
      "description": "Containing pantoprazole or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9256",
      "rawHtsCode": "3004.90.92.56",
      "superior": null,
      "indent": "5",
      "description": "Containing ondansetron or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9257",
      "rawHtsCode": "3004.90.92.57",
      "superior": null,
      "indent": "5",
      "description": "Containing glycopyrrolate or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9258",
      "rawHtsCode": "3004.90.92.58",
      "superior": null,
      "indent": "5",
      "description": "Containing loperamide or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9260",
      "rawHtsCode": "3004.90.92.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9261",
      "rawHtsCode": "3004.90.92.61",
      "superior": null,
      "indent": "6",
      "description": "Containing furosemide and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9262",
      "rawHtsCode": "3004.90.92.62",
      "superior": null,
      "indent": "6",
      "description": "Containing hydrochlorothiazide or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9263",
      "rawHtsCode": "3004.90.92.63",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9264",
      "rawHtsCode": "3004.90.92.64",
      "superior": null,
      "indent": "6",
      "description": "Containing calcium gluconate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9265",
      "rawHtsCode": "3004.90.92.65",
      "superior": null,
      "indent": "6",
      "description": "Containing potassium chloride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9266",
      "rawHtsCode": "3004.90.92.66",
      "superior": null,
      "indent": "6",
      "description": "Containing sodium bicarbonate, in injection form",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9267",
      "rawHtsCode": "3004.90.92.67",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9268",
      "rawHtsCode": "3004.90.92.68",
      "superior": null,
      "indent": "5",
      "description": "Cough and cold preparations",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9269",
      "rawHtsCode": "3004.90.92.69",
      "superior": null,
      "indent": "7",
      "description": "Containing diphenhydramine or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9270",
      "rawHtsCode": "3004.90.92.70",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9271",
      "rawHtsCode": "3004.90.92.71",
      "superior": null,
      "indent": "6",
      "description": "Containing albuterol sulfate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9272",
      "rawHtsCode": "3004.90.92.72",
      "superior": null,
      "indent": "7",
      "description": "Containing timolol maleate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9273",
      "rawHtsCode": "3004.90.92.73",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9274",
      "rawHtsCode": "3004.90.92.74",
      "superior": null,
      "indent": "5",
      "description": "Containing heparin sodium or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9275",
      "rawHtsCode": "3004.90.92.75",
      "superior": null,
      "indent": "5",
      "description": "Containing zoledronic acid or its salts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3004.90.9276",
      "rawHtsCode": "3004.90.92.76",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3005",
      "rawHtsCode": "3005",
      "superior": null,
      "indent": "0",
      "description": "Wadding, gauze, bandages and similar articles (for example, dressings, adhesive plasters, poultices), impregnated or coated with pharmaceutical substances or put up in forms or packings for retail sale for medical, surgical, dental or veterinary purposes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3005.10",
      "rawHtsCode": "3005.10",
      "superior": null,
      "indent": "1",
      "description": "Adhesive dressings and other articles having an adhesive layer:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3005.10.1000",
      "rawHtsCode": "3005.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Coated or impregnated with pharmaceutical substances",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3005.10.5000",
      "rawHtsCode": "3005.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3005.90",
      "rawHtsCode": "3005.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3005.90.1000",
      "rawHtsCode": "3005.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Coated or impregnated with pharmaceutical substances",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3005.90.50",
      "rawHtsCode": "3005.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3005.90.5010",
      "rawHtsCode": "3005.90.50.10",
      "superior": null,
      "indent": "3",
      "description": "Laparotomy sponges",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3005.90.5090",
      "rawHtsCode": "3005.90.50.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3006",
      "rawHtsCode": "3006",
      "superior": null,
      "indent": "0",
      "description": "Pharmaceutical goods specified in note 4 to this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3006.10.0100",
      "rawHtsCode": "3006.10.01.00",
      "superior": null,
      "indent": "1",
      "description": "Sterile surgical catgut, similar sterile suture materials (including sterile absorbable surgical or dental yarns) and sterile tissue adhesives for surgical wound closure; sterile laminaria and sterile laminaria tents; sterile absorbable surgical or dental hemostatics; sterile surgical or dental adhesion barriers, whether or not absorbable",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3006.30",
      "rawHtsCode": "3006.30",
      "superior": null,
      "indent": "1",
      "description": "Opacifying preparations for X-ray examinations; diagnostic reagents designed to be administered to the patient:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3006.30.1000",
      "rawHtsCode": "3006.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing antigens or antisera",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3006.30.5000",
      "rawHtsCode": "3006.30.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3006.40.0000",
      "rawHtsCode": "3006.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Dental cements and other dental fillings; bone reconstruction cements",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3006.50.0000",
      "rawHtsCode": "3006.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "First-aid boxes and kits",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3006.60.0000",
      "rawHtsCode": "3006.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Chemical contraceptive preparations based on hormones, on other products of heading 2937 or on spermicides",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3006.70.0000",
      "rawHtsCode": "3006.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Gel preparations designed to be used in human or veterinary medicine as a lubricant for parts of the body for surgical operations or physical examinations or as a coupling agent between the body and medical instruments",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,K,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3006.91.0000",
      "rawHtsCode": "3006.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Appliances identifiable for ostomy use",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3006.92.0000",
      "rawHtsCode": "3006.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Waste pharmaceuticals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3006.93",
      "rawHtsCode": "3006.93",
      "superior": null,
      "indent": "2",
      "description": "Placebos and blinded (or double-blinded) clinical trial kits for a recognized clinical trial, put up in measured doses:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3006.93.1000",
      "rawHtsCode": "3006.93.10.00",
      "superior": null,
      "indent": "3",
      "description": "Packaged with medicinal preparations",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3006.93.2000",
      "rawHtsCode": "3006.93.20.00",
      "superior": null,
      "indent": "3",
      "description": "Containing over 10 percent by dry weight of sugar",
      "units": [
        "kg"
      ],
      "generalRate": "40¢/kg + 10.4%",
      "specialRate": "Free (BH,CL,JO,KR,OM,SG) See 9822.05.20 (P+) See 9822.06.10 (PE) See 9822.08.01 (CO) See 9822.09.17 (PA) See 9823.10.01-9823.10.45 (S+) See 9822.03.01 (MA)",
      "otherRate": "47.4¢/kg +12.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9904.17.49-9904.17.65. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3006.93.5000",
      "rawHtsCode": "3006.93.50.00",
      "superior": null,
      "indent": "3",
      "description": "Containing ingredients having nutritional value, in which starch or other foodstuff predominates by weight",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free  (A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3006.93.6000",
      "rawHtsCode": "3006.93.60.00",
      "superior": null,
      "indent": "3",
      "description": "In liquid form for oral intake",
      "units": [
        "liters"
      ],
      "generalRate": "0.2¢/liter",
      "specialRate": "Free  (A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "4¢/liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3006.93.8000",
      "rawHtsCode": "3006.93.80.00",
      "superior": null,
      "indent": "3",
      "description": "Placebos and clinical trial kits containing other chemicals other than medicaments",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free  (A+, AU, BH, CL, CO, D, E, IL, JO, JP, K, KR, MA,OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3101.00.0000",
      "rawHtsCode": "3101.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Animal or vegetable fertilizers, whether or not mixed together or chemically treated; fertilizers produced by the mixing or chemical treatment of animal or vegetable products",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3102",
      "rawHtsCode": "3102",
      "superior": null,
      "indent": "0",
      "description": "Mineral or chemical fertilizers, nitrogenous:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3102.10.00",
      "rawHtsCode": "3102.10.00",
      "superior": null,
      "indent": "1",
      "description": "Urea, whether or not in aqueous solution",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3102.10.0010",
      "rawHtsCode": "3102.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Solid urea",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3102.10.0030",
      "rawHtsCode": "3102.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "Diesel exhaust fluid (DEF) of a kind meeting ISO 22241",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3102.10.0050",
      "rawHtsCode": "3102.10.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3102.21.0000",
      "rawHtsCode": "3102.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ammonium sulfate",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3102.29.0000",
      "rawHtsCode": "3102.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3102.30.0000",
      "rawHtsCode": "3102.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ammonium nitrate, whether or not in aqueous solution",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3102.40.0000",
      "rawHtsCode": "3102.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mixtures of ammonium nitrate with calcium carbonate or other inorganic nonfertilizing substances",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3102.50.0000",
      "rawHtsCode": "3102.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sodium nitrate",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3102.60.0000",
      "rawHtsCode": "3102.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Double salts and mixtures of calcium nitrate and ammonium nitrate",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3102.80.0000",
      "rawHtsCode": "3102.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mixtures of urea and ammonium nitrate in aqueous or ammoniacal solution",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3102.90.0100",
      "rawHtsCode": "3102.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other, including mixtures not specified in the foregoing subheadings",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3103",
      "rawHtsCode": "3103",
      "superior": null,
      "indent": "0",
      "description": "Mineral or chemical fertilizers, phosphatic:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3103.11.0000",
      "rawHtsCode": "3103.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight 35 percent or more of diphosphorous pentaoxide (P<sub>2</sub>O<sub>5</sub>)",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3103.19.0000",
      "rawHtsCode": "3103.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3103.90.0100",
      "rawHtsCode": "3103.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3104",
      "rawHtsCode": "3104",
      "superior": null,
      "indent": "0",
      "description": "Mineral or chemical fertilizers, potassic:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3104.20.00",
      "rawHtsCode": "3104.20.00",
      "superior": null,
      "indent": "1",
      "description": "Potassium chloride",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3104.20.0010",
      "rawHtsCode": "3104.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Containing not more than 62 percent by weight of potassium oxide (K<sub style=\"font-size: 9.75px;\">2</sub>O)",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3104.20.0050",
      "rawHtsCode": "3104.20.00.50",
      "superior": null,
      "indent": "2",
      "description": "Containing more than 62 percent by weight of potassium oxide (K<sub style=\"font-size: 9.75px;\">2</sub>O)",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3104.30.0000",
      "rawHtsCode": "3104.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Potassium sulfate",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3104.90.0100",
      "rawHtsCode": "3104.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3105",
      "rawHtsCode": "3105",
      "superior": null,
      "indent": "0",
      "description": "Mineral or chemical fertilizers containing two or three of the fertilizing elements nitrogen, phosphorus and potassium; other fertilizers; goods of this chapter in tablets or similar forms or in packages of a gross weight not exceeding 10 kg:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3105.10.0000",
      "rawHtsCode": "3105.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Products of this chapter in tablets or similar forms or in packages of a gross weight not exceeding 10 kg",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3105.20.0000",
      "rawHtsCode": "3105.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mineral or chemical fertilizers containing the three fertilizing elements nitrogen, phosphorus and potassium",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3105.30.0000",
      "rawHtsCode": "3105.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Diammonium hydrogenorthophosphate (Diammonium phosphate)",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3105.40.00",
      "rawHtsCode": "3105.40.00",
      "superior": null,
      "indent": "1",
      "description": "Ammonium dihydrogenorthophosphate (Monoammonium phosphate) and mixtures thereof with diammonium hydrogenorthophosphate (Diammonium phosphate)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3105.40.0010",
      "rawHtsCode": "3105.40.00.10",
      "superior": null,
      "indent": "2",
      "description": "Ammonium dihydrogenorthophosphate (Monoammonium phosphate)",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3105.40.0050",
      "rawHtsCode": "3105.40.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3105.51.0000",
      "rawHtsCode": "3105.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing nitrates and phosphates",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3105.59.0000",
      "rawHtsCode": "3105.59.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3105.60.0000",
      "rawHtsCode": "3105.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mineral or chemical fertilizers containing the two fertilizing elements phosphorus and potassium",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3105.90.00",
      "rawHtsCode": "3105.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3105.90.0010",
      "rawHtsCode": "3105.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Potassium nitrate-sodium nitrate mixtures",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3105.90.0050",
      "rawHtsCode": "3105.90.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3201",
      "rawHtsCode": "3201",
      "superior": null,
      "indent": "0",
      "description": "Tanning extracts of vegetable origin; tannins and their salts, ethers, esters and other derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3201.10.0000",
      "rawHtsCode": "3201.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Quebracho extract",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3201.20.0000",
      "rawHtsCode": "3201.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Wattle extract",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3201.90",
      "rawHtsCode": "3201.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3201.90.1000",
      "rawHtsCode": "3201.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Tannic acid, containing by weight 50 percent or more of tannic acid",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3201.90.2500",
      "rawHtsCode": "3201.90.25.00",
      "superior": null,
      "indent": "2",
      "description": "Extracts of canaigre, chestnut, curupay, divi-divi, eucalyptus, gambier, hemlock, larch, mangrove, myrobalan, oak, sumac, tara, urunday or valonia",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3201.90.5000",
      "rawHtsCode": "3201.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3202",
      "rawHtsCode": "3202",
      "superior": null,
      "indent": "0",
      "description": "Synthetic organic tanning substances; inorganic tanning substances; tanning preparations, whether or not containing natural tanning substances; enzymatic preparations for pre-tanning:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3202.10",
      "rawHtsCode": "3202.10",
      "superior": null,
      "indent": "1",
      "description": "Synthetic organic tanning substances:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3202.10.1000",
      "rawHtsCode": "3202.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Aromatic or modified aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3202.10.5000",
      "rawHtsCode": "3202.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "41.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3202.90",
      "rawHtsCode": "3202.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3202.90.1000",
      "rawHtsCode": "3202.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Consisting wholly of inorganic subtances",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3202.90.5000",
      "rawHtsCode": "3202.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3203.00",
      "rawHtsCode": "3203.00",
      "superior": null,
      "indent": "0",
      "description": "Coloring matter of vegetable or animal origin (including dyeing extracts but excluding animal black), whether or not chemically defined; preparations as specified in note 3 to this chapter based on coloring matter of vegetable or animal origin:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3203.00.1000",
      "rawHtsCode": "3203.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Annato, archil, cochineal, cudbear, litmus, logwood and marigold meal",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3203.00.3000",
      "rawHtsCode": "3203.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Mixtures of 3,4-dihydroxyphenyl-2,4,6-trihydroxy- phenylmethanone and 2-(2,4-dihydroxyphenyl)-3,5,7- trihydroxy-4H-1-benzopyran-4-one",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3203.00.8000",
      "rawHtsCode": "3203.00.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204",
      "rawHtsCode": "3204",
      "superior": null,
      "indent": "0",
      "description": "Synthetic organic coloring matter, whether or not chemically defined; preparations as specified in note 3 to this chapter based on synthetic organic coloring matter; synthetic organic products of a kind used as fluorescent brightening agents or as luminophores, whether or not chemically defined:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.11",
      "rawHtsCode": "3204.11",
      "superior": null,
      "indent": "2",
      "description": "Disperse dyes and preparations based thereon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.11.1000",
      "rawHtsCode": "3204.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Disperse blue 19, 26, 26:1, 35, 55, 56, 58, 72, 73, 79, 83, 84, 93, 95, 122, 125, 126, 128, 148, 154, 165, 180, 183, 185, 200, 284, 285, 288, 289, 295, 296; Disperse brown 19; Disperse green 9; Disperse orange 7, 13, 20, 31, 32, 42, 47, 48, 54, 56, 60, 63, 70, 80, 96, 127, 137, 139; Disperse red 44, 46, 72, 73, 90, 93, 107, 118, 121, 122, 131, 133, 134,151, 169, 184, 185, 202, 203, 224, 277, 278, 279, 282, 288, 303, 310; Disperse violet 23, 33, 35, 48, 57, 63; Disperse yellow 13, 44, 58, 63, 65, 82, 85, 91, 107, 119, 122, 124, 126, 139, 182, 183, 184, 202, 204; Dyes containing, by weight-- 12.7 percent Disperse Yellow 1, 32.3 percent Disperse Orange 1, 19.8 percent Disperse Blue 35, and 35.2 percent Disperse Blue 3; Dyes containing, by weight-- 39.0 percent Disperse Yellow 39, 28.0 percent Disperse Orange 25, and 33.0 percent Disperse Violet 27; Dyes containing, by weight-- 89.4 percent Disperse Violet 27, and 10.6 percent Disperse Green 9; Dyes containing, by weight-- 67.7 percent Disperse Blue 35, 14.2 percent Disperse Yellow 1, and 18.1 percent Disperse Orange 1; Dyes containing, by weight-- 74.3 percent Disperse Blue 285, 18.0 percent Disperse Brown 19, and 7.7 percent Disperse Yellow 126",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "52.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.11.1500",
      "rawHtsCode": "3204.11.15.00",
      "superior": null,
      "indent": "3",
      "description": "Disperse blue 30",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM, P, PA,PE,S,SG)",
      "otherRate": "51.9%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.11.1800",
      "rawHtsCode": "3204.11.18.00",
      "superior": null,
      "indent": "3",
      "description": "N-[2-[(2,6-Dicyano-4-methylphenylazo]-5- (diethylamino)-phenyl] methanesulfonamide; and N-[2-[2,6-Dicyano-4-methylphenylazo]-5- (di-1-propylamino) phenyl]methanesulfonamide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "63.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3204.11.3500",
      "rawHtsCode": "3204.11.35.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM, P, PA,PE,S,SG)",
      "otherRate": "63.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.11.5000",
      "rawHtsCode": "3204.11.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM, P, PA,PE,S,SG)",
      "otherRate": "63.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.12",
      "rawHtsCode": "3204.12",
      "superior": null,
      "indent": "2",
      "description": "Acid dyes, whether or not premetallized, and preparations based thereon; mordant dyes and preparations based thereon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.12.0500",
      "rawHtsCode": "3204.12.05.00",
      "superior": null,
      "indent": "3",
      "description": "Acid black 210 powder and presscake",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3204.12.1300",
      "rawHtsCode": "3204.12.13.00",
      "superior": null,
      "indent": "3",
      "description": "Acid violet 19",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3204.12.1700",
      "rawHtsCode": "3204.12.17.00",
      "superior": null,
      "indent": "3",
      "description": "Acid black 31, 50, 94, 129; Acid blue 54, 127, 129, 143; Acid brown 44, 46, 48, 58, 188, 189; Acid green 40; Acid red 130, 145, 174, 211; Acid violet 31, 41, 48; Acid yellow 2, 75; Mordant black 8; Mordant green 47; andMordant red 17, 27",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM, P, PA,PE,S,SG)",
      "otherRate": "51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.12.2000",
      "rawHtsCode": "3204.12.20.00",
      "superior": null,
      "indent": "3",
      "description": "Acid black 61, 63, 76, 83, 117, 127, 131, 132, 139, 164, 170, 177, 183, 188, 194, 199, 211; Acid blue 1, 47, 60, 61, 66, 72, 81, 82, 83, 90, 98, 102, 112, 123, 126, 127:1, 130, 133, 140, 142, 147, 151, 172, 175, 182, 185, 193, 204, 205, 208, 209, 221, 225, 229, 239, 242, 247, 250, 252, 254, 260, 261, 264, 266, 268, 280, 284, 288, 290, 296, 312, 317, 318; Acid brown 10, 11, 12, 30, 33, 45, 50, 52, 68, 83, 85, 100, 101, 103, 104, 105, 106, 126, 127, 147, 158, 160, 161, 162, 163, 165, 180, 191, 224, 226, 227, 235, 237, 239, 248, 266, 267, 270, 276, 282, 283, 289, 290, 291, 298, 304, 311, 314, 315, 321, 322, 324, 325, 330, 331, 355, 357, 358, 359, 360, 361, 362, 384; Acid green 9, 26, 28, 41, 43, 60, 68, 70, 71, 73, 80, 82, 84, 89, 92, 93, 94, 108, 112; Acid orange 3, 19, 28, 33, 43, 47, 61, 86, 89, 92, 94, 102, 107, 126, 135, 142, 144; Acid red 37, 42, 48, 52, 57, 58, 92, 111, 118, 127, 131, 138, 143, 155, 161, 183, 199, 213, 215, 216, 226, 227, 228, 249, 252, 257, 259, 260, 261, 263, 274, 281, 282, 283, 301, 303, 310, 315, 330, 331, 332, 336, 347, 357, 359, 360, 361, 362, 380, 392, 394, 396; Acid violet 9, 34, 36, 47, 66, 75, 80, 90, 103, 109, 111, 121; Acid yellow 7, 35, 64, 70, 72, 96, 98, 111, 127, 136, 155, 167, 183, 184, 194, 195, 199, 218, 221, 223, 227; Copper phthalocyanine-3,3',4,4'-tetrasulfonic acid; Copper phthalocyanine-4,4ʻ,4'',4'''-tetrasulfonic acid; Dyes containing, by weight--24.2 percent Acid Yellow 135,  21.7 percent Acid Orange 51, and  54.1 percent Acid Blue 113; Dyes containing, by weight--  10.1 percent Acid Yellow 64,  11.6 percent Acid Orange 51,  26.3 percent Acid Blue 113,  50.5 percent Acid Black 172, and 1.5 percent Acid Green 25",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "53.4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.12.3000",
      "rawHtsCode": "3204.12.30.00",
      "superior": null,
      "indent": "3",
      "description": "Mordant black 75; Mordant blue 1; Mordant brown 79; and Mordant red 81, 84",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.12.4500",
      "rawHtsCode": "3204.12.45.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.12.50",
      "rawHtsCode": "3204.12.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.12.5010",
      "rawHtsCode": "3204.12.50.10",
      "superior": null,
      "indent": "5",
      "description": "FD&C red 40 (CAS No. 25956-17-6)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.12.5020",
      "rawHtsCode": "3204.12.50.20",
      "superior": null,
      "indent": "5",
      "description": "FD&C yellow 5 (CAS No. 1934-21-0)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.12.5030",
      "rawHtsCode": "3204.12.50.30",
      "superior": null,
      "indent": "5",
      "description": "FD&C yellow 6 (CAS No. 2783-94-0)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.12.5090",
      "rawHtsCode": "3204.12.50.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.13",
      "rawHtsCode": "3204.13",
      "superior": null,
      "indent": "2",
      "description": "Basic dyes and preparations based thereon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.13.1000",
      "rawHtsCode": "3204.13.10.00",
      "superior": null,
      "indent": "3",
      "description": "Basic black 7; Basic blue 41, 45, 48, 55, 62, 66, 70, 71, 78, 80, 81, 120, 141; Basic green 6, 8; Basic orange 30, 35, 36, 37, 43, 44, 48; Basic red 22, 23, 28, 29, 43, 44, 46, 58, 75, 100; Basic violet 2, 22, 25, 37, 38; and Basic yellow 19, 23, 24, 25, 39, 40, 45, 54, 56, 63, 70, 77",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "52.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.13.2000",
      "rawHtsCode": "3204.13.20.00",
      "superior": null,
      "indent": "3",
      "description": "Basic orange 22 and Basic red 13",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.13.2500",
      "rawHtsCode": "3204.13.25.00",
      "superior": null,
      "indent": "3",
      "description": "Basic blue 3; Basic red 14; and Basic yellow 1, 11, 13",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65.4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.13.4500",
      "rawHtsCode": "3204.13.45.00",
      "superior": null,
      "indent": "3",
      "description": "3,7-Bis(dimethylamino) phenazathionium chloride (Methylene blue); and Basic blue 147",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "71.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3204.13.6000",
      "rawHtsCode": "3204.13.60.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,K,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "71.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.13.8000",
      "rawHtsCode": "3204.13.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,K,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "71.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.14",
      "rawHtsCode": "3204.14",
      "superior": null,
      "indent": "2",
      "description": "Direct dyes and preparations based thereon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.14.1000",
      "rawHtsCode": "3204.14.10.00",
      "superior": null,
      "indent": "3",
      "description": "Direct black 62, 91; Direct blue 92, 106, 108, 109, 160, 172; Direct brown 103, 115, 116; Direct green 5, 29, 31; and Direct orange 37",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.14.2000",
      "rawHtsCode": "3204.14.20.00",
      "superior": null,
      "indent": "3",
      "description": "Direct black 51, 69, 112, 114, 118, 122; Direct blue 74, 77, 85, 90, 156, 158, 158:1, 207, 211, 225, 244, 267; Direct brown 97, 113, 157, 169, 170, 200, 212, 214; Direct green 33, 59, 67, 68; Direct orange 17, 60, 105, 106, 107, 118; Direct red 9, 89, 92, 95, 111, 127, 173, 207, 221; Direct violet 47, 93; and Direct yellow 27, 39, 68, 93, 95, 96, 98, 109, 110, 133, 134",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "54.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.14.2500",
      "rawHtsCode": "3204.14.25.00",
      "superior": null,
      "indent": "3",
      "description": "Direct blue 86; Direct red 83; and Direct yellow 28",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "67.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.14.3000",
      "rawHtsCode": "3204.14.30.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "67.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.14.5000",
      "rawHtsCode": "3204.14.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "67.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.15",
      "rawHtsCode": "3204.15",
      "superior": null,
      "indent": "2",
      "description": "Vat dyes (including those usable in that state as pigments) and preparations based thereon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.15.1000",
      "rawHtsCode": "3204.15.10.00",
      "superior": null,
      "indent": "3",
      "description": "Vat blue 1 (synthetic indigo),\"Colour Index No. 73000\"",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg + 29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.15.2000",
      "rawHtsCode": "3204.15.20.00",
      "superior": null,
      "indent": "3",
      "description": "Vat brown 3; Vat orange 2, 7; and Vat violet 9, 13",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.15.2500",
      "rawHtsCode": "3204.15.25.00",
      "superior": null,
      "indent": "3",
      "description": "Vat red 1",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3204.15.3000",
      "rawHtsCode": "3204.15.30.00",
      "superior": null,
      "indent": "3",
      "description": "Solubilized vat blue 5; Solubilized vat orange 1; Solubilized vat yellow 7, 45, 47; Vat black 19, 30, 31; Vat blue 5, 16, 19, 21, 66, 67; Vat brown 33, 50, 57; Vat green 28, 48; Vat orange 5, 13; Vat red 10, 15, 32, 41; and Vat yellow 46",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "48.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.15.3500",
      "rawHtsCode": "3204.15.35.00",
      "superior": null,
      "indent": "3",
      "description": "Solubilized vat orange 3; Vat blue 2; Vat red 44; and Vat yellow 4, 20",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "52.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.15.4000",
      "rawHtsCode": "3204.15.40.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "75.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.15.8000",
      "rawHtsCode": "3204.15.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "75.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.16",
      "rawHtsCode": "3204.16",
      "superior": null,
      "indent": "2",
      "description": "Reactive dyes and preparations based thereon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.16.1000",
      "rawHtsCode": "3204.16.10.00",
      "superior": null,
      "indent": "3",
      "description": "Reactive black 1; Reactive blue 1, 2, 4; Reactive orange 1; Reactive red 1, 2, 3, 5, 6; and Reactive yellow 1",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50.8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.16.2000",
      "rawHtsCode": "3204.16.20.00",
      "superior": null,
      "indent": "3",
      "description": "Dyes containing, by weight-- 71.0 percent Reactive Yellow 85, and 29.0 percent Reactive Orange 13; Dyes containing, by weight--50.0 percent Reactive Red 120, and 50.0 percent Reactive Yellow 84; Dyes containing, by weight-- 50.0 percent Reactive Blue 74, and 50.0 percent Reactive Blue 63; Dyes containing, by weight--66.7 percent Reactive Orange 12, and 33.3 percent Reactive Red 32; Dyes containing, by weight-- 57.9 percent Reactive Blue 13, and 42.1 percent Reactive Black 41; Reactive black 4, 10, 13, 21, 23, 26, 34, 35, 41; Reactive blue 6, 7, 8, 10, 13, 18, 19, 21, 22, 23, 24, 26, 27, 29, 34, 38, 39, 40, 41, 42, 43, 44, 50, 51, 52, 63, 65, 66, 67, 69, 73, 74, 75, 77, 78, 79, 82, 94, 99, 103, 104, 114, 116, 118, 136, 137, 139, 140, 156, 157, 160, 162, 163, 167, 170; Reactive brown 2, 5, 7, 12, 16, 18, 19, 23, 26; Reactive green 5, 6, 8, 12, 15, 16, 19; Reactive orange 3, 5, 9, 10, 11, 15, 20, 29, 33, 34, 35, 41, 42, 44, 45, 62, 64, 67, 68, 69, 70, 71, 82, 84, 89; Reactive red 4, 7, 8, 10, 12, 13, 16, 17, 19, 21, 24, 29, 30, 32, 40, 42, 44, 45, 49, 55, 56, 66, 78, 80, 82, 83, 84, 85, 86, 99, 104, 116, 118, 119, 121, 122, 123, 124, 132, 134, 141, 151, 152, 159, 179; Reactive violet 3, 6, 12, 23, 24; and Reactive yellow 2, 4, 5, 6, 11, 12, 15, 25, 27, 29, 35, 37, 39, 41, 42, 52, 57, 58, 64, 81, 82, 85, 87, 110, 125, 135",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "47.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.16.3000",
      "rawHtsCode": "3204.16.30.00",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "63.8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.16.5000",
      "rawHtsCode": "3204.16.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "63.8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.17",
      "rawHtsCode": "3204.17",
      "superior": null,
      "indent": "2",
      "description": "Pigments and preparations based thereon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.04",
      "rawHtsCode": "3204.17.04",
      "superior": null,
      "indent": "3",
      "description": "Pigment black 1; Pigment blue 16, 18; Pigment brown 22, 23, 25, 32; Pigment green 8; Pigment orange 31, 34, 36, 51; Pigment red 9, 14, 34, 48:3, 52, 68, 112, 139, 144, 146, 151, 166, 169,170, 171, 175, 176, 177, 180, 185, 188, 192, 199, 208, 209, 216, 220, 221; Pigment violet 32; and Pigment yellow 16, 24, 49, 62:1, 81, 93, 95, 97, 108, 109, 110, 113, 117, 127, 153",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "46.8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.17.0405",
      "rawHtsCode": "3204.17.04.05",
      "superior": null,
      "indent": "4",
      "description": "Pigment blue 16",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.0415",
      "rawHtsCode": "3204.17.04.15",
      "superior": null,
      "indent": "4",
      "description": "Pigment orange 31",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.0420",
      "rawHtsCode": "3204.17.04.20",
      "superior": null,
      "indent": "4",
      "description": "Pigment orange 36",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.0425",
      "rawHtsCode": "3204.17.04.25",
      "superior": null,
      "indent": "4",
      "description": "Pigment red 144",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.0430",
      "rawHtsCode": "3204.17.04.30",
      "superior": null,
      "indent": "4",
      "description": "Pigment red 166",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.0435",
      "rawHtsCode": "3204.17.04.35",
      "superior": null,
      "indent": "4",
      "description": "Pigment red 177",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.0485",
      "rawHtsCode": "3204.17.04.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.0800",
      "rawHtsCode": "3204.17.08.00",
      "superior": null,
      "indent": "3",
      "description": "Pigment red 178; Pigment yellow 101, 138",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "46.8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3204.17.2000",
      "rawHtsCode": "3204.17.20.00",
      "superior": null,
      "indent": "3",
      "description": "Copper phthalocyanine ([Phthalocyanato(2-)]- copper), not ready for use as a pigment",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.17.40",
      "rawHtsCode": "3204.17.40",
      "superior": null,
      "indent": "3",
      "description": "Isoindolenine red pigment; Pigment red 214, 242, 254; Pigment red 149 dry and pigment red 149 presscake; and Pigment yellow 155, 183",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3204.17.4015",
      "rawHtsCode": "3204.17.40.15",
      "superior": null,
      "indent": "4",
      "description": "Pigment red 149",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.4030",
      "rawHtsCode": "3204.17.40.30",
      "superior": null,
      "indent": "4",
      "description": "Pigment red 214",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.4090",
      "rawHtsCode": "3204.17.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.60",
      "rawHtsCode": "3204.17.60",
      "superior": null,
      "indent": "4",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.17.6005",
      "rawHtsCode": "3204.17.60.05",
      "superior": null,
      "indent": "5",
      "description": "Pigment blue 15",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.6010",
      "rawHtsCode": "3204.17.60.10",
      "superior": null,
      "indent": "5",
      "description": "Pigment blue 15:1",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.6015",
      "rawHtsCode": "3204.17.60.15",
      "superior": null,
      "indent": "5",
      "description": "Pigment blue 15:2",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.6020",
      "rawHtsCode": "3204.17.60.20",
      "superior": null,
      "indent": "5",
      "description": "Pigment blue 15:4",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.6085",
      "rawHtsCode": "3204.17.60.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.90",
      "rawHtsCode": "3204.17.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.17.9002",
      "rawHtsCode": "3204.17.90.02",
      "superior": null,
      "indent": "5",
      "description": "Pigment blue 15:3, dry, presscake or aqueous slurry",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9003",
      "rawHtsCode": "3204.17.90.03",
      "superior": null,
      "indent": "5",
      "description": "Preparations based on pigment blue 15:3",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9006",
      "rawHtsCode": "3204.17.90.06",
      "superior": null,
      "indent": "5",
      "description": "Pigment blue 61",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9010",
      "rawHtsCode": "3204.17.90.10",
      "superior": null,
      "indent": "5",
      "description": "Pigment green 7",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9015",
      "rawHtsCode": "3204.17.90.15",
      "superior": null,
      "indent": "5",
      "description": "Pigment green 36",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9018",
      "rawHtsCode": "3204.17.90.18",
      "superior": null,
      "indent": "5",
      "description": "Pigment red 57:1, dry, presscake or aqueous slurry",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9019",
      "rawHtsCode": "3204.17.90.19",
      "superior": null,
      "indent": "5",
      "description": "Preparations based on pigment <il>red 57:1</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9021",
      "rawHtsCode": "3204.17.90.21",
      "superior": null,
      "indent": "5",
      "description": "Pigment red 122",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9025",
      "rawHtsCode": "3204.17.90.25",
      "superior": null,
      "indent": "5",
      "description": "Pigment red 149",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9030",
      "rawHtsCode": "3204.17.90.30",
      "superior": null,
      "indent": "5",
      "description": "Pigment red 179",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9035",
      "rawHtsCode": "3204.17.90.35",
      "superior": null,
      "indent": "5",
      "description": "Pigment violet 19",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9040",
      "rawHtsCode": "3204.17.90.40",
      "superior": null,
      "indent": "5",
      "description": "Pigment violet 23",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9046",
      "rawHtsCode": "3204.17.90.46",
      "superior": null,
      "indent": "5",
      "description": "Pigment yellow 12, dry, presscake or aqueous slurry",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9047",
      "rawHtsCode": "3204.17.90.47",
      "superior": null,
      "indent": "5",
      "description": "Preparations based on pigment <il>yellow 12</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9050",
      "rawHtsCode": "3204.17.90.50",
      "superior": null,
      "indent": "5",
      "description": "Pigment yellow 13",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9055",
      "rawHtsCode": "3204.17.90.55",
      "superior": null,
      "indent": "5",
      "description": "Pigment yellow 74",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9060",
      "rawHtsCode": "3204.17.90.60",
      "superior": null,
      "indent": "5",
      "description": "Pigment yellow 75",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.17.9086",
      "rawHtsCode": "3204.17.90.86",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.18.0000",
      "rawHtsCode": "3204.18.00.00",
      "superior": null,
      "indent": "2",
      "description": "Carotenoid coloring matters and preparations based thereon",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free \n(A, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.19",
      "rawHtsCode": "3204.19",
      "superior": null,
      "indent": "2",
      "description": "Other, including mixtures of coloring matter of two or more of the subheadings 3204.11 to 3204.19:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.19.0600",
      "rawHtsCode": "3204.19.06.00",
      "superior": null,
      "indent": "4",
      "description": "Solvent yellow 43, 44, 85, 172",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "64.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3204.19.1100",
      "rawHtsCode": "3204.19.11.00",
      "superior": null,
      "indent": "4",
      "description": "Solvent black 2, 3, 27, 28, 29, 34, 35; Solvent blue 45, 49, 51, 53, 56, 67, 97; Solvent brown 1, 28, 42, 43, 44; Solvent green 4, 5, 7, 19, 27, 28; Solvent orange 45, 54, 59, 62, 63, 67; Solvent red 7, 18, 19, 23, 27, 35, 89, 92, 100, 110, 118, 119, 124, 125, 127, 129, 130, 131, 132, 160, 162; Solvent violet 2, 23, 24; and Solvent yellow 1, 30, 32, 48, 64, 89, 93, 98, 160",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.19.20",
      "rawHtsCode": "3204.19.20",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "64.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.19.2020",
      "rawHtsCode": "3204.19.20.20",
      "superior": null,
      "indent": "6",
      "description": "Solvent red 179",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.19.2040",
      "rawHtsCode": "3204.19.20.40",
      "superior": null,
      "indent": "6",
      "description": "Solvent yellow 163",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.19.2090",
      "rawHtsCode": "3204.19.20.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.19.25",
      "rawHtsCode": "3204.19.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "64.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.19.2520",
      "rawHtsCode": "3204.19.25.20",
      "superior": null,
      "indent": "6",
      "description": "Solvent red 135",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.19.2540",
      "rawHtsCode": "3204.19.25.40",
      "superior": null,
      "indent": "6",
      "description": "Solvent orange 60",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.19.2560",
      "rawHtsCode": "3204.19.25.60",
      "superior": null,
      "indent": "6",
      "description": "Solvent yellow 33",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.19.2595",
      "rawHtsCode": "3204.19.25.95",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.19.3000",
      "rawHtsCode": "3204.19.30.00",
      "superior": null,
      "indent": "4",
      "description": "Sulfur black, \"Colour Index Nos. 53185, 53190, and 53195\"",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg + 28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.19.4000",
      "rawHtsCode": "3204.19.40.00",
      "superior": null,
      "indent": "5",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.19.5000",
      "rawHtsCode": "3204.19.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.20",
      "rawHtsCode": "3204.20",
      "superior": null,
      "indent": "1",
      "description": "Synthetic organic products of a kind used as fluorescent brightening agents:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.20.1000",
      "rawHtsCode": "3204.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fluorescent brightening agent 32",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "64.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.20.4000",
      "rawHtsCode": "3204.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Benzoxazol",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "44.1%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3204.20.8000",
      "rawHtsCode": "3204.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "44.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3204.90.0000",
      "rawHtsCode": "3204.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50.8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3205.00",
      "rawHtsCode": "3205.00",
      "superior": null,
      "indent": "0",
      "description": "Color lakes; preparations as specified in note 3 to this chapter based on color lakes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3205.00.0500",
      "rawHtsCode": "3205.00.05.00",
      "superior": null,
      "indent": "2",
      "description": "Food coloring solutions, containing cochineal carmine lake and paprika oleo resins, but not including any synthetic organic coloring matter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3205.00.1500",
      "rawHtsCode": "3205.00.15.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3205.00.40",
      "rawHtsCode": "3205.00.40",
      "superior": null,
      "indent": "2",
      "description": "Products described in additional U.S. note 3 to section VI",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3205.00.4010",
      "rawHtsCode": "3205.00.40.10",
      "superior": null,
      "indent": "3",
      "description": "Yellow",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3205.00.4020",
      "rawHtsCode": "3205.00.40.20",
      "superior": null,
      "indent": "3",
      "description": "Red",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3205.00.4040",
      "rawHtsCode": "3205.00.40.40",
      "superior": null,
      "indent": "3",
      "description": "Blue",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3205.00.4055",
      "rawHtsCode": "3205.00.40.55",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3205.00.50",
      "rawHtsCode": "3205.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3205.00.5010",
      "rawHtsCode": "3205.00.50.10",
      "superior": null,
      "indent": "3",
      "description": "Yellow",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3205.00.5020",
      "rawHtsCode": "3205.00.50.20",
      "superior": null,
      "indent": "3",
      "description": "Red",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3205.00.5030",
      "rawHtsCode": "3205.00.50.30",
      "superior": null,
      "indent": "3",
      "description": "Violet",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3205.00.5040",
      "rawHtsCode": "3205.00.50.40",
      "superior": null,
      "indent": "3",
      "description": "Blue",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3205.00.5050",
      "rawHtsCode": "3205.00.50.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3206",
      "rawHtsCode": "3206",
      "superior": null,
      "indent": "0",
      "description": "Other coloring matter; preparations as specified in note 3 to this chapter, other than those of heading 3203, 3204 or 3205; inorganic products of a kind used as luminophores, whether or not chemically defined:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3206.11.0000",
      "rawHtsCode": "3206.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 80 percent or more by weight of titanium dioxide calculated on the dry matter",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3206.19.0000",
      "rawHtsCode": "3206.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3206.20.00",
      "rawHtsCode": "3206.20.00",
      "superior": null,
      "indent": "1",
      "description": "Pigments and preparations based on chromium compounds",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3206.20.0010",
      "rawHtsCode": "3206.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Chrome yellow",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3206.20.0020",
      "rawHtsCode": "3206.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Molybdenum orange",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3206.20.0030",
      "rawHtsCode": "3206.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Zinc yellow",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3206.20.0050",
      "rawHtsCode": "3206.20.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3206.41.0000",
      "rawHtsCode": "3206.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ultramarine and preparations based thereon",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3206.42.0000",
      "rawHtsCode": "3206.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Lithopone and other pigments and preparations based on zinc sulfide",
      "units": [
        "kg"
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3206.49",
      "rawHtsCode": "3206.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3206.49.1000",
      "rawHtsCode": "3206.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Concentrated dispersions of pigments in plastics materials",
      "units": [
        "kg"
      ],
      "generalRate": "5.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3206.49.2000",
      "rawHtsCode": "3206.49.20.00",
      "superior": null,
      "indent": "3",
      "description": "Preparations based on iron oxides",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3206.49.3000",
      "rawHtsCode": "3206.49.30.00",
      "superior": null,
      "indent": "3",
      "description": "Preparations based on zinc oxides",
      "units": [
        "kg"
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "4.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3206.49.4000",
      "rawHtsCode": "3206.49.40.00",
      "superior": null,
      "indent": "3",
      "description": "Preparations based on carbon black",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3206.49.5500",
      "rawHtsCode": "3206.49.55.00",
      "superior": null,
      "indent": "3",
      "description": "Pigments and preparations based on hexacyanoferrates (ferrocyanides and ferricyanides)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3206.49.60",
      "rawHtsCode": "3206.49.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3206.49.6010",
      "rawHtsCode": "3206.49.60.10",
      "superior": null,
      "indent": "4",
      "description": "Pigments and preparations based on cadmium compounds",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3206.49.6050",
      "rawHtsCode": "3206.49.60.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3206.50.0000",
      "rawHtsCode": "3206.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Inorganic products of a kind used as luminophores",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3207",
      "rawHtsCode": "3207",
      "superior": null,
      "indent": "0",
      "description": "Prepared pigments, prepared opacifiers and prepared colors, vitrifiable enamels and glazes, engobes (slips), liquid lustres and similar preparations, of a kind used in the ceramic, enamelling or glass industry; glass frit and other glass, in the form of powder, granules or flakes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3207.10.0000",
      "rawHtsCode": "3207.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Prepared pigments, prepared opacifiers, prepared colors and similar preparations",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3207.20.0000",
      "rawHtsCode": "3207.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Vitrifiable enamels and glazes, engobes (slips) and similar preparations",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3207.30.0000",
      "rawHtsCode": "3207.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Liquid lustres and similar preparations",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3207.40",
      "rawHtsCode": "3207.40",
      "superior": null,
      "indent": "1",
      "description": "Glass frit and other glass, in the form of powder, granules or flakes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3207.40.1000",
      "rawHtsCode": "3207.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Ground or pulverized",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3207.40.5000",
      "rawHtsCode": "3207.40.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3208",
      "rawHtsCode": "3208",
      "superior": null,
      "indent": "0",
      "description": "Paints and varnishes (including enamels and lacquers) based on synthetic polymers or chemically modified natural polymers, dispersed or dissolved in a nonaqueous medium; solutions as defined in note 4 to this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3208.10.0000",
      "rawHtsCode": "3208.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Based on polyesters",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg +46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3208.20.0000",
      "rawHtsCode": "3208.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Based on acrylic or vinyl polymers",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3208.90.0000",
      "rawHtsCode": "3208.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3209",
      "rawHtsCode": "3209",
      "superior": null,
      "indent": "0",
      "description": "Paints and varnishes (including enamels and lacquers) based on synthetic polymers or chemically modified natural polymers, dispersed or dissolved in an aqueous medium:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3209.10.0000",
      "rawHtsCode": "3209.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Based on acrylic or vinyl polymers",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3209.90.0000",
      "rawHtsCode": "3209.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "5.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3210.00.0000",
      "rawHtsCode": "3210.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Other paints and varnishes (including enamels, lacquers and distempers); prepared water pigments of a kind used for finishing leather",
      "units": [
        "liters",
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3211.00.0000",
      "rawHtsCode": "3211.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Prepared driers",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3212",
      "rawHtsCode": "3212",
      "superior": null,
      "indent": "0",
      "description": "Pigments (including metallic powders and flakes) dispersed in nonaqueous media, in liquid or paste form, of a kind used in the manufacture of paints (including enamels); stamping foils; dyes and other coloring matter put up in forms or packings for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3212.10.0000",
      "rawHtsCode": "3212.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Stamping foils",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3212.90.00",
      "rawHtsCode": "3212.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3212.90.0010",
      "rawHtsCode": "3212.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Metallic aluminum pigments",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3212.90.0050",
      "rawHtsCode": "3212.90.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3213",
      "rawHtsCode": "3213",
      "superior": null,
      "indent": "0",
      "description": "Artists', students' or signboard painters' colors, modifying tints, amusement colors and the like, in tablets, tubes, jars, bottles, pans or in similar forms or packings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3213.10.0000",
      "rawHtsCode": "3213.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Colors in sets",
      "units": [
        "pcs"
      ],
      "generalRate": "6.5% on the entire set",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "70% on the entire set",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3213.90.0000",
      "rawHtsCode": "3213.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48.6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3214",
      "rawHtsCode": "3214",
      "superior": null,
      "indent": "0",
      "description": "Glaziers' putty, grafting putty, resin cements, caulking compounds and other mastics; painters' fillings; nonrefractory surfacing preparations for facades, indoor walls, floors, ceilings or the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3214.10.00",
      "rawHtsCode": "3214.10.00",
      "superior": null,
      "indent": "1",
      "description": "Glazier's putty, grafting putty, resin cements, caulking compounds and other mastics; painters' fillings",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3214.10.0010",
      "rawHtsCode": "3214.10.00.10",
      "superior": null,
      "indent": "3",
      "description": "Caulking compounds",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3214.10.0020",
      "rawHtsCode": "3214.10.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3214.10.0090",
      "rawHtsCode": "3214.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Painters' fillings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3214.90",
      "rawHtsCode": "3214.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3214.90.1000",
      "rawHtsCode": "3214.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Based on rubber",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3214.90.5000",
      "rawHtsCode": "3214.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.25%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3215",
      "rawHtsCode": "3215",
      "superior": null,
      "indent": "0",
      "description": "Printing ink, writing or drawing ink and other inks, whether or not concentrated or solid:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.11",
      "rawHtsCode": "3215.11",
      "superior": null,
      "indent": "2",
      "description": "Black:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.11.1000",
      "rawHtsCode": "3215.11.10.00",
      "superior": null,
      "indent": "4",
      "description": "In engineered shapes, for insertion into apparatus of subheadings 8443.31, 8443.32 or 8443.39",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3215.11.3000",
      "rawHtsCode": "3215.11.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3215.11.90",
      "rawHtsCode": "3215.11.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3215.11.9010",
      "rawHtsCode": "3215.11.90.10",
      "superior": null,
      "indent": "4",
      "description": "News",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.11.9020",
      "rawHtsCode": "3215.11.90.20",
      "superior": null,
      "indent": "5",
      "description": "Flexographic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.11.9030",
      "rawHtsCode": "3215.11.90.30",
      "superior": null,
      "indent": "5",
      "description": "Gravure",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.11.9040",
      "rawHtsCode": "3215.11.90.40",
      "superior": null,
      "indent": "5",
      "description": "Letterpress",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.11.9050",
      "rawHtsCode": "3215.11.90.50",
      "superior": null,
      "indent": "5",
      "description": "Offset Lithographic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.11.9060",
      "rawHtsCode": "3215.11.90.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.19",
      "rawHtsCode": "3215.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.19.1000",
      "rawHtsCode": "3215.19.10.00",
      "superior": null,
      "indent": "4",
      "description": "In engineered shapes, for insertion into apparatus of subheadings 8443.31, 8443.32 or 8443.39",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3215.19.3000",
      "rawHtsCode": "3215.19.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3215.19.90",
      "rawHtsCode": "3215.19.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3215.19.9010",
      "rawHtsCode": "3215.19.90.10",
      "superior": null,
      "indent": "4",
      "description": "News",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.19.9020",
      "rawHtsCode": "3215.19.90.20",
      "superior": null,
      "indent": "5",
      "description": "Flexographic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.19.9030",
      "rawHtsCode": "3215.19.90.30",
      "superior": null,
      "indent": "5",
      "description": "Gravure",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.19.9040",
      "rawHtsCode": "3215.19.90.40",
      "superior": null,
      "indent": "5",
      "description": "Letterpress",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.19.9050",
      "rawHtsCode": "3215.19.90.50",
      "superior": null,
      "indent": "5",
      "description": "Offset lithographic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.19.9060",
      "rawHtsCode": "3215.19.90.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.90",
      "rawHtsCode": "3215.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3215.90.1000",
      "rawHtsCode": "3215.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Drawing ink",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3215.90.5000",
      "rawHtsCode": "3215.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3301",
      "rawHtsCode": "3301",
      "superior": null,
      "indent": "0",
      "description": "Essential oils (terpeneless or not), including concretes and absolutes; resinoids; extracted oleoresins; concentrates of essential oils in fats, in fixed oils, in waxes or the like, obtained by enfleurage or maceration; terpenic by products of the deterpenation of essential oils; aqueous distillates and aqueous solutions of essential oils:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.12.0000",
      "rawHtsCode": "3301.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of orange",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3301.13.0000",
      "rawHtsCode": "3301.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of lemon",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3301.19",
      "rawHtsCode": "3301.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.19.1000",
      "rawHtsCode": "3301.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of grapefruit",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3301.19.51",
      "rawHtsCode": "3301.19.51",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3301.19.5110",
      "rawHtsCode": "3301.19.51.10",
      "superior": null,
      "indent": "4",
      "description": "Bergamot",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.19.5120",
      "rawHtsCode": "3301.19.51.20",
      "superior": null,
      "indent": "4",
      "description": "Lime",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.19.5150",
      "rawHtsCode": "3301.19.51.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.24.0000",
      "rawHtsCode": "3301.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of peppermint (<u>Mentha piperita</u>)     ",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3301.25.00",
      "rawHtsCode": "3301.25.00",
      "superior": null,
      "indent": "2",
      "description": "Of other mints",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3301.25.0010",
      "rawHtsCode": "3301.25.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of cornmint, including \"peppermint\" derived from <u>Mentha arvensis</u>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.25.0020",
      "rawHtsCode": "3301.25.00.20",
      "superior": null,
      "indent": "3",
      "description": "Of spearmint",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.25.0050",
      "rawHtsCode": "3301.25.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29",
      "rawHtsCode": "3301.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.1000",
      "rawHtsCode": "3301.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of eucalyptus",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3301.29.2000",
      "rawHtsCode": "3301.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of orris",
      "units": [
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3301.29.51",
      "rawHtsCode": "3301.29.51",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3301.29.5103",
      "rawHtsCode": "3301.29.51.03",
      "superior": null,
      "indent": "4",
      "description": "Of anise",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5105",
      "rawHtsCode": "3301.29.51.05",
      "superior": null,
      "indent": "4",
      "description": "Of caraway",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5107",
      "rawHtsCode": "3301.29.51.07",
      "superior": null,
      "indent": "4",
      "description": "Of cassia",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5109",
      "rawHtsCode": "3301.29.51.09",
      "superior": null,
      "indent": "4",
      "description": "Of cedarwood",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5111",
      "rawHtsCode": "3301.29.51.11",
      "superior": null,
      "indent": "4",
      "description": "Of citronella",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5113",
      "rawHtsCode": "3301.29.51.13",
      "superior": null,
      "indent": "4",
      "description": "Of clove",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5115",
      "rawHtsCode": "3301.29.51.15",
      "superior": null,
      "indent": "4",
      "description": "Of garlic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5116",
      "rawHtsCode": "3301.29.51.16",
      "superior": null,
      "indent": "4",
      "description": "Of geranium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5117",
      "rawHtsCode": "3301.29.51.17",
      "superior": null,
      "indent": "4",
      "description": "Of jasmine",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5118",
      "rawHtsCode": "3301.29.51.18",
      "superior": null,
      "indent": "4",
      "description": "Of lavender or lavandin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5119",
      "rawHtsCode": "3301.29.51.19",
      "superior": null,
      "indent": "4",
      "description": "Of lemongrass",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5121",
      "rawHtsCode": "3301.29.51.21",
      "superior": null,
      "indent": "4",
      "description": "Of linaloe or bois de rose",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5125",
      "rawHtsCode": "3301.29.51.25",
      "superior": null,
      "indent": "4",
      "description": "Of nutmeg",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5128",
      "rawHtsCode": "3301.29.51.28",
      "superior": null,
      "indent": "4",
      "description": "Of onion",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5129",
      "rawHtsCode": "3301.29.51.29",
      "superior": null,
      "indent": "4",
      "description": "Of patchouli",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5133",
      "rawHtsCode": "3301.29.51.33",
      "superior": null,
      "indent": "4",
      "description": "Of petitgrain",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5135",
      "rawHtsCode": "3301.29.51.35",
      "superior": null,
      "indent": "4",
      "description": "Of rose (attar of roses)",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5137",
      "rawHtsCode": "3301.29.51.37",
      "superior": null,
      "indent": "4",
      "description": "Of rosemary",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5139",
      "rawHtsCode": "3301.29.51.39",
      "superior": null,
      "indent": "4",
      "description": "Of sandalwood",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5141",
      "rawHtsCode": "3301.29.51.41",
      "superior": null,
      "indent": "4",
      "description": "Of sassafras including <u>Ocotea</u> <u>cymbarum</u>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5142",
      "rawHtsCode": "3301.29.51.42",
      "superior": null,
      "indent": "4",
      "description": "Of vetiver",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5143",
      "rawHtsCode": "3301.29.51.43",
      "superior": null,
      "indent": "4",
      "description": "Of ylang ylang or cananga",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.29.5150",
      "rawHtsCode": "3301.29.51.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.30.0000",
      "rawHtsCode": "3301.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Resinoids",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3301.90",
      "rawHtsCode": "3301.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.90.10",
      "rawHtsCode": "3301.90.10",
      "superior": null,
      "indent": "2",
      "description": "Extracted oleoresins",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3301.90.1010",
      "rawHtsCode": "3301.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Paprika",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.90.1020",
      "rawHtsCode": "3301.90.10.20",
      "superior": null,
      "indent": "3",
      "description": "Black pepper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.90.1050",
      "rawHtsCode": "3301.90.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3301.90.5000",
      "rawHtsCode": "3301.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3302",
      "rawHtsCode": "3302",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of odoriferous substances and mixtures (including alcoholic solutions) with a basis of one or more of these substances, of a kind used as raw materials in industry; other preparations based on odoriferous substances, of a kind used for the manufacture of beverages:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3302.10",
      "rawHtsCode": "3302.10",
      "superior": null,
      "indent": "1",
      "description": "Of a kind used in the food or drink industries:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3302.10.1000",
      "rawHtsCode": "3302.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Not containing alcohol",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3302.10.2000",
      "rawHtsCode": "3302.10.20.00",
      "superior": null,
      "indent": "3",
      "description": "Containing not over 20 percent of alcohol by weight",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "44¢/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "3302.10.4000",
      "rawHtsCode": "3302.10.40.00",
      "superior": null,
      "indent": "5",
      "description": "Containing over 20 percent but not over 50 percent of alcohol by weight",
      "units": [
        "kg"
      ],
      "generalRate": "8.4¢/kg + 1.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "88¢/kg +25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3302.10.5000",
      "rawHtsCode": "3302.10.50.00",
      "superior": null,
      "indent": "5",
      "description": "Containing over 50 percent of alcohol by weight",
      "units": [
        "kg"
      ],
      "generalRate": "17¢/kg + 1.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.76/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5001). ",
        "See 9903.88.15. "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE",
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3302.10.9000",
      "rawHtsCode": "3302.10.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3302.90",
      "rawHtsCode": "3302.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3302.90.10",
      "rawHtsCode": "3302.90.10",
      "superior": null,
      "indent": "2",
      "description": "Containing no alcohol or not over 10 percent of alcohol by weight",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "88¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.  "
      ],
      "flags": []
    },
    {
      "htsCode": "3302.90.1010",
      "rawHtsCode": "3302.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Perfume oil mixtures and blends, consisting of products ready for use as finished perfume bases",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3302.90.1050",
      "rawHtsCode": "3302.90.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3302.90.20",
      "rawHtsCode": "3302.90.20",
      "superior": null,
      "indent": "2",
      "description": "Containing over 10 percent of alcohol by weight",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "88¢/kg + 75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3302.90.2010",
      "rawHtsCode": "3302.90.20.10",
      "superior": null,
      "indent": "3",
      "description": "Perfume oil mixtures and blends, consisting of products ready for use as finished perfume bases",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3302.90.2050",
      "rawHtsCode": "3302.90.20.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3303.00",
      "rawHtsCode": "3303.00",
      "superior": null,
      "indent": "0",
      "description": "Perfumes and toilet waters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3303.00.1000",
      "rawHtsCode": "3303.00.10.00",
      "superior": null,
      "indent": "2",
      "description": "Floral or flower waters",
      "units": [
        "liters"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3303.00.2000",
      "rawHtsCode": "3303.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3303.00.3000",
      "rawHtsCode": "3303.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Containing alcohol",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "88¢/kg + 75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3304",
      "rawHtsCode": "3304",
      "superior": null,
      "indent": "0",
      "description": "Beauty or make-up preparations and preparations for the care of the skin (other than medicaments), including sunscreen or sun tan preparations; manicure or pedicure preparations:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3304.10.0000",
      "rawHtsCode": "3304.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Lip make-up preparations",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3304.20.0000",
      "rawHtsCode": "3304.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Eye make-up preparations",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3304.30.0000",
      "rawHtsCode": "3304.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Manicure or pedicure preparations",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3304.91.00",
      "rawHtsCode": "3304.91.00",
      "superior": null,
      "indent": "2",
      "description": "Powders, whether or not compressed",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3304.91.0010",
      "rawHtsCode": "3304.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Rouges",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3304.91.0050",
      "rawHtsCode": "3304.91.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3304.99.1000",
      "rawHtsCode": "3304.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Petroleum jelly put up for retail sale",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3304.99.5000",
      "rawHtsCode": "3304.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3305",
      "rawHtsCode": "3305",
      "superior": null,
      "indent": "0",
      "description": "Preparations for use on the hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3305.10.0000",
      "rawHtsCode": "3305.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Shampoos",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3305.20.0000",
      "rawHtsCode": "3305.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Preparations for permanent waving or straightening",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3305.30.0000",
      "rawHtsCode": "3305.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hair lacquers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "88¢/kg + 75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3305.90.0000",
      "rawHtsCode": "3305.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "88¢/kg + 75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3306",
      "rawHtsCode": "3306",
      "superior": null,
      "indent": "0",
      "description": "Preparations for oral or dental hygiene, including denture fixative pastes and powders; yarn used to clean between the teeth (dental floss), in individual retail packages:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3306.10.0000",
      "rawHtsCode": "3306.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Dentifrices",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3306.20.0000",
      "rawHtsCode": "3306.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Yarn used to clean between the teeth (dental floss)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "88¢/kg + 75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3306.90.0000",
      "rawHtsCode": "3306.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "88¢/kg + 75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3307",
      "rawHtsCode": "3307",
      "superior": null,
      "indent": "0",
      "description": "Pre-shave, shaving or after-shave preparations, personal deodorants, bath preparations, depilatories and other perfumery, cosmetic or toilet preparations, not elsewhere specified or included; prepared room deodorizers, whether or not perfumed or having disinfectant properties:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3307.10",
      "rawHtsCode": "3307.10",
      "superior": null,
      "indent": "1",
      "description": "Pre-shave, shaving or after-shave preparations:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3307.10.1000",
      "rawHtsCode": "3307.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Not containing alcohol",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3307.10.2000",
      "rawHtsCode": "3307.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Containing alcohol",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3307.20.0000",
      "rawHtsCode": "3307.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Personal deodorants and antiperspirants",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3307.30",
      "rawHtsCode": "3307.30",
      "superior": null,
      "indent": "1",
      "description": "Perfumed bath salts and other bath preparations:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3307.30.1000",
      "rawHtsCode": "3307.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Bath salts, whether or not perfumed",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3307.30.5000",
      "rawHtsCode": "3307.30.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3307.41.0000",
      "rawHtsCode": "3307.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "\"Agarbatti\" and other odoriferous preparations which operate by burning",
      "units": [
        "kg"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3307.49.0000",
      "rawHtsCode": "3307.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "73.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3307.90.0000",
      "rawHtsCode": "3307.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3401",
      "rawHtsCode": "3401",
      "superior": null,
      "indent": "0",
      "description": "Soap; organic surface-active products and preparations for use as soap, in the form of bars, cakes, molded pieces or shapes, whether or not containing soap; organic surface-active products and preparations for washing the skin, in the form of liquid or cream and put up for retail sale, whether or not containing soap; paper, wadding, felt and nonwovens, impregnated, coated or covered with soap or detergent:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3401.11",
      "rawHtsCode": "3401.11",
      "superior": null,
      "indent": "2",
      "description": "For toilet use (including medicated products):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3401.11.1000",
      "rawHtsCode": "3401.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Castile soap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3401.11.5000",
      "rawHtsCode": "3401.11.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg + 30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3401.19.0000",
      "rawHtsCode": "3401.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg + 15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "3401.20.0000",
      "rawHtsCode": "3401.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Soap in other forms",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg + 30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3401.30",
      "rawHtsCode": "3401.30",
      "superior": null,
      "indent": "1",
      "description": "Organic surface-active products and preparations for washing the skin, in the form of liquid or cream and put up for retail sale, whether or not containing soap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3401.30.1000",
      "rawHtsCode": "3401.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing any aromatic or modified aromatic surface-active agent",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3401.30.5000",
      "rawHtsCode": "3401.30.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3402",
      "rawHtsCode": "3402",
      "superior": null,
      "indent": "0",
      "description": "Organic surface-active agents (other than soap); surface-active preparations, washing preparations (including auxiliary washing preparations) and cleaning preparations, whether or not containing soap, other than those of heading 3401:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.31",
      "rawHtsCode": "3402.31",
      "superior": null,
      "indent": "2",
      "description": "Linear alkylbenzene sulfonic acids and their salts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.31.1000",
      "rawHtsCode": "3402.31.10.00",
      "superior": null,
      "indent": "3",
      "description": "Aromatic or modified aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free\n(A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "15.4¢/kg + 52.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.31.9000",
      "rawHtsCode": "3402.31.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A, AU, BH, CL,CO, D, E, IL, JO, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.39",
      "rawHtsCode": "3402.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.39.1000",
      "rawHtsCode": "3402.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Aromatic or modified aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free \n(A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.39.90",
      "rawHtsCode": "3402.39.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.39.9010",
      "rawHtsCode": "3402.39.90.10",
      "superior": null,
      "indent": "4",
      "description": "Salts of sulfated alcohols",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.39.9020",
      "rawHtsCode": "3402.39.90.20",
      "superior": null,
      "indent": "4",
      "description": "Salts of sulfated polyethers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.39.9050",
      "rawHtsCode": "3402.39.90.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.41",
      "rawHtsCode": "3402.41",
      "superior": null,
      "indent": "2",
      "description": "Cationic:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.41.1000",
      "rawHtsCode": "3402.41.10.00",
      "superior": null,
      "indent": "3",
      "description": "Aromatic or modified aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A, AU, BH, CL, CO, D,E, IL, JO, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.41.9000",
      "rawHtsCode": "3402.41.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "16.5¢/kg + 30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.42",
      "rawHtsCode": "3402.42",
      "superior": null,
      "indent": "2",
      "description": "Non-ionic:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.42.1000",
      "rawHtsCode": "3402.42.10.00",
      "superior": null,
      "indent": "3",
      "description": "Aromatic or modified aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.42.20",
      "rawHtsCode": "3402.42.20",
      "superior": null,
      "indent": "4",
      "description": "Fatty substances of animal, vegetable or microbial origin",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "16.5¢/kg + 30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.42.2010",
      "rawHtsCode": "3402.42.20.10",
      "superior": null,
      "indent": "5",
      "description": "Polyethers ",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.42.2020",
      "rawHtsCode": "3402.42.20.20",
      "superior": null,
      "indent": "5",
      "description": "Esters and ether-esters of polyhydric alcohols",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.42.2050",
      "rawHtsCode": "3402.42.20.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.42.9000",
      "rawHtsCode": "3402.42.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.49",
      "rawHtsCode": "3402.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.49.1000",
      "rawHtsCode": "3402.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Aromatic or modified aromatic",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free  (A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.49.9000",
      "rawHtsCode": "3402.49.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free  (A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.50",
      "rawHtsCode": "3402.50",
      "superior": null,
      "indent": "1",
      "description": "Preparations put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.50.1100",
      "rawHtsCode": "3402.50.11.00",
      "superior": null,
      "indent": "2",
      "description": "Containing any aromatic or modified aromatic surface-active agent",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free  (A, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.50.5100",
      "rawHtsCode": "3402.50.51.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3402.90",
      "rawHtsCode": "3402.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.90.1000",
      "rawHtsCode": "3402.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Synthetic detergents",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 53.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.90.3000",
      "rawHtsCode": "3402.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Containing any aromatic or modified aromatic surface-active agent",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 44.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.90.50",
      "rawHtsCode": "3402.90.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,L,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3402.90.5010",
      "rawHtsCode": "3402.90.50.10",
      "superior": null,
      "indent": "4",
      "description": "Washing preparations",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.90.5030",
      "rawHtsCode": "3402.90.50.30",
      "superior": null,
      "indent": "4",
      "description": "Cleaning preparations",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3402.90.5050",
      "rawHtsCode": "3402.90.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3403",
      "rawHtsCode": "3403",
      "superior": null,
      "indent": "0",
      "description": "Lubricating preparations (including cutting-oil preparations, bolt or nut release preparations, antirust or anticorrosion preparations and mold release preparations, based on lubricants) and preparations of a kind used for the oil or grease treatment of textile materials, leather, furskins or other materials, but excluding preparations containing, as basic constituents, 70 percent or more by weight of petroleum oils or oils obtained from bituminous minerals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3403.11",
      "rawHtsCode": "3403.11",
      "superior": null,
      "indent": "2",
      "description": "Preparations for the treatment of textile materials, leather, furskins or other materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3403.11.2000",
      "rawHtsCode": "3403.11.20.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 50 percent or more by weight of petroleum oils or of oils obtained from bituminous minerals",
      "units": [
        "liters"
      ],
      "generalRate": "0.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "0.4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3403.11.4000",
      "rawHtsCode": "3403.11.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 49.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3403.11.5000",
      "rawHtsCode": "3403.11.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3403.19",
      "rawHtsCode": "3403.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3403.19.1000",
      "rawHtsCode": "3403.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 50 percent or more by weight of petroleum oils or of oils obtained from bituminous minerals",
      "units": [
        "liters"
      ],
      "generalRate": "0.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO, JP, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "0.4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3403.19.5000",
      "rawHtsCode": "3403.19.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.9%(JP)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3403.91",
      "rawHtsCode": "3403.91",
      "superior": null,
      "indent": "2",
      "description": "Preparations for the treatment of textile materials, leather, furskins or other materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3403.91.1000",
      "rawHtsCode": "3403.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Preparations for the treatment of textile materials",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3%(JP)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3403.91.5000",
      "rawHtsCode": "3403.91.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.25% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3403.99.0000",
      "rawHtsCode": "3403.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.25% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3404",
      "rawHtsCode": "3404",
      "superior": null,
      "indent": "0",
      "description": "Artificial waxes and prepared waxes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3404.20.0000",
      "rawHtsCode": "3404.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of poly(oxyethylene) (polyethylene glycol)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3404.90",
      "rawHtsCode": "3404.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3404.90.1000",
      "rawHtsCode": "3404.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing bleached beeswax",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3404.90.51",
      "rawHtsCode": "3404.90.51",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3404.90.5110",
      "rawHtsCode": "3404.90.51.10",
      "superior": null,
      "indent": "3",
      "description": "Of chemically modified lignite",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3404.90.5150",
      "rawHtsCode": "3404.90.51.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3405",
      "rawHtsCode": "3405",
      "superior": null,
      "indent": "0",
      "description": "Polishes and creams, for footwear, furniture, floors, coachwork, glass or metal, scouring pastes and powders and similar preparations (whether or not in the form of paper, wadding, felt, nonwovens, cellular plastics or cellular rubber, impregnated, coated or covered with such preparations), excluding waxes of heading 3404:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3405.10.0000",
      "rawHtsCode": "3405.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Polishes, creams and similar preparations for footwear or leather",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3405.20.0000",
      "rawHtsCode": "3405.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Polishes, creams and similar preparations for the maintenance of wooden furniture, floors or other woodwork",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3405.30.0000",
      "rawHtsCode": "3405.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Polishes and similar preparations for coachwork, other than metal polishes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3405.40.0000",
      "rawHtsCode": "3405.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Scouring pastes and powders and other scouring preparations",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg + 15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3405.90.0000",
      "rawHtsCode": "3405.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3406.00.0000",
      "rawHtsCode": "3406.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Candles, tapers and the like",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3407",
      "rawHtsCode": "3407",
      "superior": null,
      "indent": "0",
      "description": "Modeling pastes, including those put up for children's amusement; preparations known as \"dental wax\" or as \"dental impression compounds\", put up in sets, in packings for retail sale or in plates, horseshoe shapes, sticks or similar forms; other preparations for use in dentistry, with a basis of plaster (of calcined gypsum or calcium sulfate):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3407.00.2000",
      "rawHtsCode": "3407.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Modeling pastes, including those put up for children's amusement",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3407.00.4000",
      "rawHtsCode": "3407.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3501",
      "rawHtsCode": "3501",
      "superior": null,
      "indent": "0",
      "description": "Casein, caseinates and other casein derivatives; casein glues:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3501.10",
      "rawHtsCode": "3501.10",
      "superior": null,
      "indent": "1",
      "description": "Casein:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3501.10.1000",
      "rawHtsCode": "3501.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Milk protein concentrate",
      "units": [
        "kg",
        "kg msc"
      ],
      "generalRate": "0.37¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3501.10.5000",
      "rawHtsCode": "3501.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg",
        "kg msc"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3501.90",
      "rawHtsCode": "3501.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3501.90.2000",
      "rawHtsCode": "3501.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Casein glues",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3501.90.6000",
      "rawHtsCode": "3501.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg",
        "kg msc"
      ],
      "generalRate": "0.37¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3502",
      "rawHtsCode": "3502",
      "superior": null,
      "indent": "0",
      "description": "Albumins (including concentrates of two or more whey proteins, containing by weight more than 80 percent whey proteins, calculated on the dry matter), albuminates and other albumin derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3502.11.0000",
      "rawHtsCode": "3502.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dried",
      "units": [
        "kg"
      ],
      "generalRate": "47.6¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "59.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3502.19.0000",
      "rawHtsCode": "3502.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "9.7¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "24.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3502.20.0000",
      "rawHtsCode": "3502.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Milk albumin, including concentrates of two or more whey proteins",
      "units": [
        "kg",
        "kg msc"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3502.90.0000",
      "rawHtsCode": "3502.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3503.00",
      "rawHtsCode": "3503.00",
      "superior": null,
      "indent": "0",
      "description": "Gelatin (including gelatin in rectangular (including square) sheets, whether or not surfaceworked or colored) and gelatin derivatives; isinglass; other glues of animal origin, excluding casein glues of heading 3501:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3503.00.1000",
      "rawHtsCode": "3503.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Fish glue",
      "units": [
        "kg"
      ],
      "generalRate": "1.2¢/kg + 1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3503.00.2000",
      "rawHtsCode": "3503.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "Valued under 88 cents per kg",
      "units": [
        "kg"
      ],
      "generalRate": "1.2¢/kg + 3.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "5.5¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3503.00.4000",
      "rawHtsCode": "3503.00.40.00",
      "superior": null,
      "indent": "2",
      "description": "Valued 88 cents or more per kg",
      "units": [
        "kg"
      ],
      "generalRate": "2.8¢/kg + 3.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM, P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3503.00.55",
      "rawHtsCode": "3503.00.55",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "2.8¢/kg + 3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3503.00.5510",
      "rawHtsCode": "3503.00.55.10",
      "superior": null,
      "indent": "2",
      "description": "Edible gelatin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3503.00.5520",
      "rawHtsCode": "3503.00.55.20",
      "superior": null,
      "indent": "2",
      "description": "Photographic gelatin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3503.00.5550",
      "rawHtsCode": "3503.00.55.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3504.00",
      "rawHtsCode": "3504.00",
      "superior": null,
      "indent": "0",
      "description": "Peptones and their derivatives; other protein substances and their derivatives, not elsewhere specified or included; hide powder, whether or not chromed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3504.00.1000",
      "rawHtsCode": "3504.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Protein isolates",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3504.00.50",
      "rawHtsCode": "3504.00.50",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3504.00.5010",
      "rawHtsCode": "3504.00.50.10",
      "superior": null,
      "indent": "3",
      "description": "Certified organic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3504.00.5050",
      "rawHtsCode": "3504.00.50.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3504.00.5080",
      "rawHtsCode": "3504.00.50.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3505",
      "rawHtsCode": "3505",
      "superior": null,
      "indent": "0",
      "description": "Dextrins and other modified starches (for example, pregelatinized or esterified starches); glues based on starches, or on dextrins or other modified starches:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3505.10.00",
      "rawHtsCode": "3505.10.00",
      "superior": null,
      "indent": "1",
      "description": "Dextrins and other modified starches",
      "units": [],
      "generalRate": "0.7¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3505.10.0015",
      "rawHtsCode": "3505.10.00.15",
      "superior": null,
      "indent": "3",
      "description": "Derived from potato starch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3505.10.0020",
      "rawHtsCode": "3505.10.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3505.10.0040",
      "rawHtsCode": "3505.10.00.40",
      "superior": null,
      "indent": "3",
      "description": "Derived from corn (maize) starch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3505.10.0045",
      "rawHtsCode": "3505.10.00.45",
      "superior": null,
      "indent": "3",
      "description": "Derived from potato starch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3505.10.0092",
      "rawHtsCode": "3505.10.00.92",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3505.20.0000",
      "rawHtsCode": "3505.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Glues",
      "units": [
        "kg"
      ],
      "generalRate": "2.1¢/kg + 2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3506",
      "rawHtsCode": "3506",
      "superior": null,
      "indent": "0",
      "description": "Prepared glues and other prepared adhesives, not elsewhere specified or included; products suitable for use as glues or adhesives, put up for retail sale as glues or adhesives, not exceeding a net weight of 1 kg:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3506.10",
      "rawHtsCode": "3506.10",
      "superior": null,
      "indent": "1",
      "description": "Products suitable for use as glues or adhesives, put up for retail sale as glues or adhesives, not exceeding a net weight of 1 kg:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3506.10.1000",
      "rawHtsCode": "3506.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Animal glue, including casein glue, but not including fish glue",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3506.10.5000",
      "rawHtsCode": "3506.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3506.91",
      "rawHtsCode": "3506.91",
      "superior": null,
      "indent": "2",
      "description": "Adhesives based on polymers of headings 3901 to 3913 or on rubber:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3506.91.1000",
      "rawHtsCode": "3506.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Optically clear free-film adhesives and optically clear curable liquid adhesives of a kind used solely or principally for the manufacture of flat panel displays or touch-sensitive screen panels",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3506.91.5000",
      "rawHtsCode": "3506.91.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3506.99.0000",
      "rawHtsCode": "3506.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3507",
      "rawHtsCode": "3507",
      "superior": null,
      "indent": "0",
      "description": "Enzymes; prepared enzymes not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3507.10.0000",
      "rawHtsCode": "3507.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Rennet and concentrates thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3507.90",
      "rawHtsCode": "3507.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3507.90.2000",
      "rawHtsCode": "3507.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Pencillin G amidase",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3507.90.7000",
      "rawHtsCode": "3507.90.70.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3601.00.0000",
      "rawHtsCode": "3601.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Propellant powders",
      "units": [
        "kg"
      ],
      "generalRate": "3.25%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3602.00.00",
      "rawHtsCode": "3602.00.00",
      "superior": null,
      "indent": "0",
      "description": "Prepared explosives, other than propellant powders",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3602.00.0030",
      "rawHtsCode": "3602.00.00.30",
      "superior": null,
      "indent": "1",
      "description": "Dynamite and other high explosives, put up in cartridges, sticks or other forms, suitable for blasting",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3602.00.0060",
      "rawHtsCode": "3602.00.00.60",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3603",
      "rawHtsCode": "3603",
      "superior": null,
      "indent": "0",
      "description": "Safety fuses; detonating cords; percussion or detonating caps; igniters; electric detonators:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3603.10.0000",
      "rawHtsCode": "3603.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Safety fuses",
      "units": [
        "thousand m"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3603.20.0000",
      "rawHtsCode": "3603.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Detonating cords",
      "units": [
        "thousand m"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3603.30.0000",
      "rawHtsCode": "3603.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Percussion caps",
      "units": [
        "thousands"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3603.40.0000",
      "rawHtsCode": "3603.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Detonating caps",
      "units": [
        "No."
      ],
      "generalRate": "0.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3603.50.0000",
      "rawHtsCode": "3603.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Igniters",
      "units": [
        "No."
      ],
      "generalRate": "0.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3603.60.0000",
      "rawHtsCode": "3603.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Electric detonators",
      "units": [
        "No."
      ],
      "generalRate": "0.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3604",
      "rawHtsCode": "3604",
      "superior": null,
      "indent": "0",
      "description": "Fireworks, signaling flares, rain rockets, fog signals and other pyrotechnic articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3604.10",
      "rawHtsCode": "3604.10",
      "superior": null,
      "indent": "1",
      "description": "Fireworks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3604.10.1000",
      "rawHtsCode": "3604.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Display or special fireworks (Class 1.3G)",
      "units": [
        "kg"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3604.10.90",
      "rawHtsCode": "3604.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other (including Class 1.4G)",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3604.10.9010",
      "rawHtsCode": "3604.10.90.10",
      "superior": null,
      "indent": "3",
      "description": "Class 1.4G (Class C)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3604.10.9050",
      "rawHtsCode": "3604.10.90.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3604.90.0000",
      "rawHtsCode": "3604.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3605.00.00",
      "rawHtsCode": "3605.00.00",
      "superior": null,
      "indent": "0",
      "description": "Matches, other than pyrotechnic articles of heading 3604",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20¢/gross of immediate containers",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3605.00.0030",
      "rawHtsCode": "3605.00.00.30",
      "superior": null,
      "indent": "1",
      "description": "Matches with natural wood stems",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3605.00.0060",
      "rawHtsCode": "3605.00.00.60",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3606",
      "rawHtsCode": "3606",
      "superior": null,
      "indent": "0",
      "description": "Ferrocerium and other pyrophoric alloys in all forms; articles of combustible materials as specified in note 2 to this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3606.10.0000",
      "rawHtsCode": "3606.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Liquid or liquefied-gas fuels in containers of a kind used for filling or refilling cigarette or similar lighters and of a capacity not exceeding 300 cm<sup>3</sup>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3606.90",
      "rawHtsCode": "3606.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3606.90.3000",
      "rawHtsCode": "3606.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Ferrocerium and other pyrophoric alloys",
      "units": [
        "kg"
      ],
      "generalRate": "5.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "56.7%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3606.90.4000",
      "rawHtsCode": "3606.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Metaldehyde",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3606.90.8000",
      "rawHtsCode": "3606.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3701",
      "rawHtsCode": "3701",
      "superior": null,
      "indent": "0",
      "description": "Photographic plates and film in the flat, sensitized, unexposed, of any material other than paper, paperboard or textiles; instant print film in the flat, sensitized, unexposed, whether or not in packs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3701.10.00",
      "rawHtsCode": "3701.10.00",
      "superior": null,
      "indent": "1",
      "description": "For X-ray",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3701.10.0030",
      "rawHtsCode": "3701.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Medical, other than dental",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3701.10.0060",
      "rawHtsCode": "3701.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3701.20.00",
      "rawHtsCode": "3701.20.00",
      "superior": null,
      "indent": "1",
      "description": "Instant print film",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3701.20.0030",
      "rawHtsCode": "3701.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "For color photography (polychrome)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3701.20.0060",
      "rawHtsCode": "3701.20.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3701.30.0000",
      "rawHtsCode": "3701.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other plates and film, with any side exceeding 255 mm",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3701.91.00",
      "rawHtsCode": "3701.91.00",
      "superior": null,
      "indent": "2",
      "description": "For color photography (polychrome)",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3701.91.0030",
      "rawHtsCode": "3701.91.00.30",
      "superior": null,
      "indent": "3",
      "description": "Disc film",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3701.91.0060",
      "rawHtsCode": "3701.91.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3701.99",
      "rawHtsCode": "3701.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3701.99.3000",
      "rawHtsCode": "3701.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "Dry plates",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3701.99.60",
      "rawHtsCode": "3701.99.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3701.99.6030",
      "rawHtsCode": "3701.99.60.30",
      "superior": null,
      "indent": "4",
      "description": "Graphic arts film",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3701.99.6060",
      "rawHtsCode": "3701.99.60.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702",
      "rawHtsCode": "3702",
      "superior": null,
      "indent": "0",
      "description": "Photographic film in rolls, sensitized, unexposed, of any material other than paper, paperboard or textiles; instant print film in rolls, sensitized, unexposed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.10.00",
      "rawHtsCode": "3702.10.00",
      "superior": null,
      "indent": "1",
      "description": "For X-ray",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3702.10.0030",
      "rawHtsCode": "3702.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Medical, other than dental",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.10.0060",
      "rawHtsCode": "3702.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.31.0100",
      "rawHtsCode": "3702.31.01.00",
      "superior": null,
      "indent": "2",
      "description": "For color photography (polychrome)",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3702.32.01",
      "rawHtsCode": "3702.32.01",
      "superior": null,
      "indent": "2",
      "description": "Other, with silver halide emulsion",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3702.32.0130",
      "rawHtsCode": "3702.32.01.30",
      "superior": null,
      "indent": "3",
      "description": "Microfilm",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.32.0160",
      "rawHtsCode": "3702.32.01.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.39.0100",
      "rawHtsCode": "3702.39.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3702.41.0100",
      "rawHtsCode": "3702.41.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of a width exceeding 610 mm and of a length exceeding 200 m, for color photography (polychrome)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3702.42.0100",
      "rawHtsCode": "3702.42.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of a width exceeding 610 mm and of a length exceeding 200 m, other than for color photography",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3702.43.0100",
      "rawHtsCode": "3702.43.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of a width exceeding 610 mm and of a length not exceeding 200 m",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3702.44.01",
      "rawHtsCode": "3702.44.01",
      "superior": null,
      "indent": "2",
      "description": "Of a width exceeding 105 mm but not exceeding <il>610 mm</il>",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3702.44.0130",
      "rawHtsCode": "3702.44.01.30",
      "superior": null,
      "indent": "3",
      "description": "Graphic arts film",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.44.0160",
      "rawHtsCode": "3702.44.01.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.52.01",
      "rawHtsCode": "3702.52.01",
      "superior": null,
      "indent": "2",
      "description": "Of a width not exceeding 16 mm",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3702.52.0130",
      "rawHtsCode": "3702.52.01.30",
      "superior": null,
      "indent": "3",
      "description": "Reversal color film",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.52.0160",
      "rawHtsCode": "3702.52.01.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.53.00",
      "rawHtsCode": "3702.53.00",
      "superior": null,
      "indent": "2",
      "description": "Of a width exceeding 16 mm but not exceeding 35 mm and of a length not exceeding 30 m, for slides",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3702.53.0030",
      "rawHtsCode": "3702.53.00.30",
      "superior": null,
      "indent": "3",
      "description": "35 mm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.53.0060",
      "rawHtsCode": "3702.53.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.54.00",
      "rawHtsCode": "3702.54.00",
      "superior": null,
      "indent": "2",
      "description": "Of a width exceeding 16 mm but not exceeding 35 mm and of a length not exceeding 30 m, other than for slides",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3702.54.0030",
      "rawHtsCode": "3702.54.00.30",
      "superior": null,
      "indent": "3",
      "description": "35 mm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.54.0060",
      "rawHtsCode": "3702.54.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.55.00",
      "rawHtsCode": "3702.55.00",
      "superior": null,
      "indent": "2",
      "description": "Of a width exceeding 16 mm but not exceeding 35 mm and of a length exceeding 30 m",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "38¢/m<sup>2</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3702.55.0030",
      "rawHtsCode": "3702.55.00.30",
      "superior": null,
      "indent": "3",
      "description": "Reversal color film",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.55.0060",
      "rawHtsCode": "3702.55.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.56.00",
      "rawHtsCode": "3702.56.00",
      "superior": null,
      "indent": "2",
      "description": "Of a width exceeding 35 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "38¢/m<sup>2</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3702.56.0030",
      "rawHtsCode": "3702.56.00.30",
      "superior": null,
      "indent": "3",
      "description": "Motion-picture film",
      "units": [
        "m",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.56.0060",
      "rawHtsCode": "3702.56.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3702.96.0000",
      "rawHtsCode": "3702.96.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a width not exceeding <il>35 mm</il> and of a length not exceeding 30 m",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3702.97.0000",
      "rawHtsCode": "3702.97.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a width not exceeding <il>35 mm</il> and of a length exceeding <il>30 m</il>",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "38¢/m<sup>2</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3702.98.0000",
      "rawHtsCode": "3702.98.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a width exceeding <il>35 mm</il>",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3703",
      "rawHtsCode": "3703",
      "superior": null,
      "indent": "0",
      "description": "Photographic paper, paperboard and textiles, sensitized, unexposed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3703.10",
      "rawHtsCode": "3703.10",
      "superior": null,
      "indent": "1",
      "description": "In rolls of a width exceeding 610 mm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3703.10.30",
      "rawHtsCode": "3703.10.30",
      "superior": null,
      "indent": "2",
      "description": "Silver halide papers",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3703.10.3030",
      "rawHtsCode": "3703.10.30.30",
      "superior": null,
      "indent": "4",
      "description": "For color photography (polychrome)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3703.10.3060",
      "rawHtsCode": "3703.10.30.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3703.10.3090",
      "rawHtsCode": "3703.10.30.90",
      "superior": null,
      "indent": "3",
      "description": "Other (line reproduction)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3703.10.6000",
      "rawHtsCode": "3703.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3703.20",
      "rawHtsCode": "3703.20",
      "superior": null,
      "indent": "1",
      "description": "Other, for color photography (polychrome):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3703.20.30",
      "rawHtsCode": "3703.20.30",
      "superior": null,
      "indent": "2",
      "description": "Silver halide papers",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3703.20.3030",
      "rawHtsCode": "3703.20.30.30",
      "superior": null,
      "indent": "3",
      "description": "For pictorial use (continuous tone)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3703.20.3060",
      "rawHtsCode": "3703.20.30.60",
      "superior": null,
      "indent": "3",
      "description": "Other (line reproduction)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3703.20.6000",
      "rawHtsCode": "3703.20.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3703.90",
      "rawHtsCode": "3703.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3703.90.30",
      "rawHtsCode": "3703.90.30",
      "superior": null,
      "indent": "2",
      "description": "Silver halide papers",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3703.90.3030",
      "rawHtsCode": "3703.90.30.30",
      "superior": null,
      "indent": "4",
      "description": "In sheets",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3703.90.3060",
      "rawHtsCode": "3703.90.30.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3703.90.3090",
      "rawHtsCode": "3703.90.30.90",
      "superior": null,
      "indent": "3",
      "description": "Other (line reproduction)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3703.90.6000",
      "rawHtsCode": "3703.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3704.00.0000",
      "rawHtsCode": "3704.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Photographic plates, film, paper, paperboard and textiles, exposed but not developed",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$3.88/m<sup>2</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3705.00.0000",
      "rawHtsCode": "3705.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Photographic plates and film, exposed and developed, other than cinematographic film",
      "units": [
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3706",
      "rawHtsCode": "3706",
      "superior": null,
      "indent": "0",
      "description": "Motion-picture film, exposed and developed, whether or not incorporating sound track or consisting only of sound track:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3706.10",
      "rawHtsCode": "3706.10",
      "superior": null,
      "indent": "1",
      "description": "Of a width of 35 mm or more:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3706.10.3000",
      "rawHtsCode": "3706.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Sound recordings on motion-picture film suitable for use in connection with motion-picture exhibits",
      "units": [
        "m"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3706.10.60",
      "rawHtsCode": "3706.10.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10¢/m",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3706.10.6030",
      "rawHtsCode": "3706.10.60.30",
      "superior": null,
      "indent": "4",
      "description": "Positive release prints",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3706.10.6060",
      "rawHtsCode": "3706.10.60.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3706.10.6090",
      "rawHtsCode": "3706.10.60.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3706.90.00",
      "rawHtsCode": "3706.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10¢/m",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3706.90.0030",
      "rawHtsCode": "3706.90.00.30",
      "superior": null,
      "indent": "2",
      "description": "Positive release prints",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3706.90.0060",
      "rawHtsCode": "3706.90.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3707",
      "rawHtsCode": "3707",
      "superior": null,
      "indent": "0",
      "description": "Chemical preparations for photographic uses (other than varnishes, glues, adhesives and similar preparations); unmixed products for photographic uses, put up in measured portions or put up for retail sale in a form ready for use:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3707.10.00",
      "rawHtsCode": "3707.10.00",
      "superior": null,
      "indent": "1",
      "description": "Sensitizing emulsions",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3707.10.0005",
      "rawHtsCode": "3707.10.00.05",
      "superior": null,
      "indent": "2",
      "description": "For use in color negative photographic paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3707.10.0090",
      "rawHtsCode": "3707.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3707.90",
      "rawHtsCode": "3707.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3707.90.3100",
      "rawHtsCode": "3707.90.31.00",
      "superior": null,
      "indent": "3",
      "description": "Acid violet 19",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9817.29.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "3707.90.32",
      "rawHtsCode": "3707.90.32",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg +50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9817.29.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "3707.90.3210",
      "rawHtsCode": "3707.90.32.10",
      "superior": null,
      "indent": "4",
      "description": "Unsensitized emulsions, for use in color negative photographic paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3707.90.3220",
      "rawHtsCode": "3707.90.32.20",
      "superior": null,
      "indent": "4",
      "description": "Couplers, for use in color negative photographic paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3707.90.3230",
      "rawHtsCode": "3707.90.32.30",
      "superior": null,
      "indent": "4",
      "description": "Coupler dispersions, for use in color negative photographic paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3707.90.3290",
      "rawHtsCode": "3707.90.32.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3707.90.6000",
      "rawHtsCode": "3707.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Unmixed products for photographic uses, put up in measured portions or put up for retail sale in a form ready for use",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9817.29.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "3801",
      "rawHtsCode": "3801",
      "superior": null,
      "indent": "0",
      "description": "Artificial graphite; colloidal or semi-colloidal graphite; preparations based on graphite or other carbon in the form of pastes, blocks, plates or other semimanufactures:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3801.10",
      "rawHtsCode": "3801.10",
      "superior": null,
      "indent": "1",
      "description": "Artificial graphite:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3801.10.1000",
      "rawHtsCode": "3801.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Plates, rods, powder and other forms, wholly or partly manufactured, for manufacturing into brushes for electric generators, motors or other machines or appliances",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3801.10.50",
      "rawHtsCode": "3801.10.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3801.10.5010",
      "rawHtsCode": "3801.10.50.10",
      "superior": null,
      "indent": "3",
      "description": "Surface-modified spherical graphite",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3801.10.5090",
      "rawHtsCode": "3801.10.50.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3801.20.0000",
      "rawHtsCode": "3801.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Colloidal or semi-colloidal graphite",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3801.30.0000",
      "rawHtsCode": "3801.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Carbonaceous pastes for electrodes and similar pastes for furnace linings",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3801.90.00",
      "rawHtsCode": "3801.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3801.90.0010",
      "rawHtsCode": "3801.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Active anode material containing silicon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3801.90.0050",
      "rawHtsCode": "3801.90.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3802",
      "rawHtsCode": "3802",
      "superior": null,
      "indent": "0",
      "description": "Activated carbon; activated natural mineral products; animal black, including spent animal black:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3802.10.00",
      "rawHtsCode": "3802.10.00",
      "superior": null,
      "indent": "1",
      "description": "Activated carbon",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3802.10.0010",
      "rawHtsCode": "3802.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Derived from coal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3802.10.0020",
      "rawHtsCode": "3802.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Derived from coconut",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3802.10.0050",
      "rawHtsCode": "3802.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3802.90",
      "rawHtsCode": "3802.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3802.90.1000",
      "rawHtsCode": "3802.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Bone black",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3802.90.2000",
      "rawHtsCode": "3802.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Activated clays and activated earths",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.6¢/kg +30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3802.90.5000",
      "rawHtsCode": "3802.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3803.00.0000",
      "rawHtsCode": "3803.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Tall oil, whether or not refined",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3804.00",
      "rawHtsCode": "3804.00",
      "superior": null,
      "indent": "0",
      "description": "Residual lyes from the manufacture of wood pulp, whether or not concentrated, desugared or chemically treated, including lignin sulfonates, but excluding tall oil of heading 3803:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3804.00.1000",
      "rawHtsCode": "3804.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Lignin sulfonic acid and its salts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3804.00.5000",
      "rawHtsCode": "3804.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3805",
      "rawHtsCode": "3805",
      "superior": null,
      "indent": "0",
      "description": "Gum, wood or sulfate turpentine and other terpenic oils produced by the distillation or other treatment of coniferous woods; crude dipentene; sulfite turpentine and other crude para-cymene; pine oil containing alpha-terpineol as the main constituent:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3805.10.0000",
      "rawHtsCode": "3805.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Gum, wood or sulfate turpentine oils",
      "units": [
        "liters"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3805.90",
      "rawHtsCode": "3805.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3805.90.1000",
      "rawHtsCode": "3805.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Pine oil",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3805.90.5000",
      "rawHtsCode": "3805.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3806",
      "rawHtsCode": "3806",
      "superior": null,
      "indent": "0",
      "description": "Rosin and resin acids, and derivatives thereof; rosin spirit and rosin oils; run gums:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3806.10.00",
      "rawHtsCode": "3806.10.00",
      "superior": null,
      "indent": "1",
      "description": "Rosin and resin acids",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3806.10.0010",
      "rawHtsCode": "3806.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Gum rosin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3806.10.0050",
      "rawHtsCode": "3806.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3806.20.0000",
      "rawHtsCode": "3806.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Salts of rosin, of resin acids or of derivatives of rosin or resin acids, other than salts of rosin adducts",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3806.30.0000",
      "rawHtsCode": "3806.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ester gums",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3806.90.0000",
      "rawHtsCode": "3806.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3807.00.0000",
      "rawHtsCode": "3807.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Wood tar; wood tar oils; wood creosote; wood naphtha; vegetable pitch; brewers' pitch and similar preparations based on rosin, resin acids or on vegetable pitch",
      "units": [
        "kg"
      ],
      "generalRate": "0.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "0.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808",
      "rawHtsCode": "3808",
      "superior": null,
      "indent": "0",
      "description": "Insecticides, rodenticides, fungicides, herbicides, antisprouting products and plant-growth regulators, disinfectants and similar products, put up in forms or packings for retail sale or as preparations or articles (for example, sulfur-treated bands, wicks and candles, and flypapers):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.52.0000",
      "rawHtsCode": "3808.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "DDT (ISO) (clofenatone (INN)), in packings of a net weight content not exceeding 300 g",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.59",
      "rawHtsCode": "3808.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.59.1000",
      "rawHtsCode": "3808.59.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing any aromatic or modified aromatic pesticide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.59.4000",
      "rawHtsCode": "3808.59.40.00",
      "superior": null,
      "indent": "4",
      "description": "Disinfectants",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH, CL,CO,D,E,IL, JO,K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.59.5000",
      "rawHtsCode": "3808.59.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.61",
      "rawHtsCode": "3808.61",
      "superior": null,
      "indent": "2",
      "description": "In packings of a net weight content not exceeding 300 g:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.61.1000",
      "rawHtsCode": "3808.61.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing any aromatic or modified aromatic pesticide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.61.5000",
      "rawHtsCode": "3808.61.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.62",
      "rawHtsCode": "3808.62",
      "superior": null,
      "indent": "2",
      "description": "In packings of a net weight content exceeding 300 g but not exceeding 7.5 kg:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.62.1000",
      "rawHtsCode": "3808.62.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing any aromatic or modified aromatic pesticide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.62.5000",
      "rawHtsCode": "3808.62.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.69",
      "rawHtsCode": "3808.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.69.1000",
      "rawHtsCode": "3808.69.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing any aromatic or modified aromatic pesticide",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.69.5000",
      "rawHtsCode": "3808.69.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.91",
      "rawHtsCode": "3808.91",
      "superior": null,
      "indent": "2",
      "description": "Insecticides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.91.1000",
      "rawHtsCode": "3808.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Fly ribbons (ribbon fly catchers)",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.91.1500",
      "rawHtsCode": "3808.91.15.00",
      "superior": null,
      "indent": "5",
      "description": "Mixtures of <i>N</i>-[[(4-chlorophenyl)amino]- carbonyl]-2,6-difluorobenzamide and inert substances",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3808.91.2501",
      "rawHtsCode": "3808.91.25.01",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.91.3000",
      "rawHtsCode": "3808.91.30.00",
      "superior": null,
      "indent": "4",
      "description": "Containing an inorganic substance",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.91.5001",
      "rawHtsCode": "3808.91.50.01",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.92",
      "rawHtsCode": "3808.92",
      "superior": null,
      "indent": "2",
      "description": "Fungicides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.92.0500",
      "rawHtsCode": "3808.92.05.00",
      "superior": null,
      "indent": "4",
      "description": "Mixtures of dinocap and application adjuvants",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3808.92.1500",
      "rawHtsCode": "3808.92.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.92.2400",
      "rawHtsCode": "3808.92.24.00",
      "superior": null,
      "indent": "5",
      "description": "Maneb; Zineb; Mancozeb; and Metiram",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3808.92.2800",
      "rawHtsCode": "3808.92.28.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.92.3000",
      "rawHtsCode": "3808.92.30.00",
      "superior": null,
      "indent": "5",
      "description": "Containing an inorganic substance",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.92.50",
      "rawHtsCode": "3808.92.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.92.5040",
      "rawHtsCode": "3808.92.50.40",
      "superior": null,
      "indent": "6",
      "description": "Formulated fungicides containing any 3-iodoprop-2-yn-1-yl butylcarbamate(IPBC)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.92.5080",
      "rawHtsCode": "3808.92.50.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.93",
      "rawHtsCode": "3808.93",
      "superior": null,
      "indent": "2",
      "description": "Herbicides, anti-sprouting products and plant-growth regulators:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.93.0500",
      "rawHtsCode": "3808.93.05.00",
      "superior": null,
      "indent": "4",
      "description": "Mixtures of 2,6-dichlorobenzonitrile and inerts; Mixtures of 3,5-dichloro-N-(1,1-dimethyl-2- propynyl) benzamide (Pronamide) and application adjuvants; Mixtures of 2-[(1-ethoxyimino)butyl]-5-[2- ethylthiopropyl]-3-hydroxy-2-cyclohexen-1- one (Sethoxydim) and application adjuvants; Mixtures of ethyl 2-[4-[(6-chloro-2- benzoxazolyl)oxy]phenoxy]propanoate (Fenoxaprop-ethyl) and isooctyl 2,4-dichlorophenoxyacetate; Mixtures of isooctyl 2-methyl-4-chlorophen- oxyacetate and application adjuvants",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3808.93.1500",
      "rawHtsCode": "3808.93.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.93.2000",
      "rawHtsCode": "3808.93.20.00",
      "superior": null,
      "indent": "4",
      "description": "Containing an inorganic substance",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.93.50",
      "rawHtsCode": "3808.93.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.93.5010",
      "rawHtsCode": "3808.93.50.10",
      "superior": null,
      "indent": "5",
      "description": "Mixtures of 2-amino-4-[hydroxy(methyl)phosphonoyl] butanoic acid (glufosinate) or its salts or esters and application adjuvants",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.93.5020",
      "rawHtsCode": "3808.93.50.20",
      "superior": null,
      "indent": "5",
      "description": "Mixtures of N-(phosphonomethyl) glycine (glyphosate) or its salts or esters and application adjuvants",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.93.5040",
      "rawHtsCode": "3808.93.50.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.94",
      "rawHtsCode": "3808.94",
      "superior": null,
      "indent": "2",
      "description": "Disinfectants:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.94.1000",
      "rawHtsCode": "3808.94.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing any aromatic or modified aromatic disinfectant",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.94.50",
      "rawHtsCode": "3808.94.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.94.5010",
      "rawHtsCode": "3808.94.50.10",
      "superior": null,
      "indent": "4",
      "description": "Wipes, other than paper wipes or nonwoven wipes, impregnated with alcohol or other disinfectants",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "3808.94.5050",
      "rawHtsCode": "3808.94.50.50",
      "superior": null,
      "indent": "4",
      "description": "Hydrogen peroxide put up in disinfectant preparations for sanitizing or disinfecting surfaces.",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.94.5080",
      "rawHtsCode": "3808.94.50.80",
      "superior": null,
      "indent": "4",
      "description": "Alcohol-based hand sanitizer containing 60 percent or more by weight of ethanol, of a kind described in statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.94.5095",
      "rawHtsCode": "3808.94.50.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.99",
      "rawHtsCode": "3808.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3808.99.0400",
      "rawHtsCode": "3808.99.04.00",
      "superior": null,
      "indent": "4",
      "description": "Mixtures of 1,1-bis(4-chlorophenyl)-2,2,2- trichloroethanol (Dicofol) and application adjuvants",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3808.99.0800",
      "rawHtsCode": "3808.99.08.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 31%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.99.3000",
      "rawHtsCode": "3808.99.30.00",
      "superior": null,
      "indent": "4",
      "description": "Formulated biocides based on 2-methyl-4-isothiazolin-3-one, or 2-n-octyl-4-isothiazolin-3-one, or 4,5-dichloro-2-n-octyl-4-isothiazolin-3-one, or mixtures of 5-chloro-2-methyl-4- isothiazolin-3-one and 2-methyl-4- isothiazolin-3-one; and Metaldehyde",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3808.99.7000",
      "rawHtsCode": "3808.99.70.00",
      "superior": null,
      "indent": "5",
      "description": "Containing an inorganic substance",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3808.99.9501",
      "rawHtsCode": "3808.99.95.01",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3809",
      "rawHtsCode": "3809",
      "superior": null,
      "indent": "0",
      "description": "Finishing agents, dye carriers to accelerate the dyeing or fixing of dyestuffs and other products and preparations (for example, dressings and mordants), of a kind used in the textile, paper, leather or like industries, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3809.10.0000",
      "rawHtsCode": "3809.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "With a basis of amylaceous substances",
      "units": [
        "kg"
      ],
      "generalRate": "2.2¢/kg + 3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.6¢/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3809.91.0000",
      "rawHtsCode": "3809.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used in the textile or like industries",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3% (JP)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3809.92",
      "rawHtsCode": "3809.92",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used in the paper or like industries:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3809.92.1000",
      "rawHtsCode": "3809.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 5 percent or more by weight of one or more aromatic or modified aromatic substances",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3809.92.5000",
      "rawHtsCode": "3809.92.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3809.93",
      "rawHtsCode": "3809.93",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used in the leather or like industries:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3809.93.1000",
      "rawHtsCode": "3809.93.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 5 percent or more by weight of one or more aromatic or modified aromatic substances",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3809.93.5000",
      "rawHtsCode": "3809.93.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3810",
      "rawHtsCode": "3810",
      "superior": null,
      "indent": "0",
      "description": "Pickling preparations for metal surfaces; fluxes and other auxiliary preparations for soldering, brazing or welding; soldering, brazing or welding powders and pastes consisting of metal and other materials; preparations of a kind used as cores or coatings for welding electrodes or rods:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3810.10.0000",
      "rawHtsCode": "3810.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Pickling preparations for metal surfaces; soldering, brazing or welding powders and pastes consisting of metal and other materials",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3810.90",
      "rawHtsCode": "3810.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3810.90.1000",
      "rawHtsCode": "3810.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 5 percent or more by weight of one or more aromatic or modified aromatic substances",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3810.90.2000",
      "rawHtsCode": "3810.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Consisting wholly of inorganic substances",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3810.90.5000",
      "rawHtsCode": "3810.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3811",
      "rawHtsCode": "3811",
      "superior": null,
      "indent": "0",
      "description": "Antiknock preparations, oxidation inhibitors, gum inhibitors, viscosity improvers, anti-corrosive preparations and other prepared additives, for mineral oils (including gasoline) or for other liquids used for the same purposes as mineral oils:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3811.11",
      "rawHtsCode": "3811.11",
      "superior": null,
      "indent": "2",
      "description": "Based on lead compounds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3811.11.1000",
      "rawHtsCode": "3811.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Based on tetraethyl lead or on a mixture of tetraethyl lead and tetramethyl lead",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3811.11.5000",
      "rawHtsCode": "3811.11.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3811.19.0000",
      "rawHtsCode": "3811.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3811.21.0000",
      "rawHtsCode": "3811.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing petroleum oils or oils obtained from bituminous minerals",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3811.29.0000",
      "rawHtsCode": "3811.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3811.90.0000",
      "rawHtsCode": "3811.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3812",
      "rawHtsCode": "3812",
      "superior": null,
      "indent": "0",
      "description": "Prepared rubber accelerators; compound plasticizers for rubber or plastics, not elsewhere specified or included; antioxidizing preparations and other compound stabilizers for rubber or plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3812.10",
      "rawHtsCode": "3812.10",
      "superior": null,
      "indent": "1",
      "description": "Prepared rubber accelerators:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3812.10.1000",
      "rawHtsCode": "3812.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing any aromatic or modified aromatic rubber accelerator",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3812.10.5000",
      "rawHtsCode": "3812.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3812.20",
      "rawHtsCode": "3812.20",
      "superior": null,
      "indent": "1",
      "description": "Compound plasticizers for rubber or plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3812.20.1000",
      "rawHtsCode": "3812.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing any aromatic or modified aromatic plasticizer",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3812.20.5000",
      "rawHtsCode": "3812.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3812.31.0000",
      "rawHtsCode": "3812.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mixtures of oligomers of 2,2,4-trimethyl-1,2-dihydroquinoline (TMQ)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3812.39",
      "rawHtsCode": "3812.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3812.39.2000",
      "rawHtsCode": "3812.39.20.00",
      "superior": null,
      "indent": "4",
      "description": "Mixtures of N,N'-diaryl-p-phenylenediamines",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3812.39.3000",
      "rawHtsCode": "3812.39.30.00",
      "superior": null,
      "indent": "4",
      "description": "Master batches of poly[nitrilomethanetetraaryl- nitrilo[2,4,6- tris(1-methylethyl)-1,3- phenylene]]-2,6-bis(1-methylethyl)phenyl]-ω- [[[[2,6-bis(1-methylethyl)phenyl]amino]- methylene]amino]carbodiimide or 2,4-diisocyanate-1,3,5-tris(1-methylethyl)- benzene homopolymer with polyethylene, polyethylene terephthalate, or thermoplastic polyurethanes;Master batches of 3-(2H-benzotriazol-2-yl)-5- (tert-butyl)-4-hydroxybenzenepropanoic acid, C<sub>7</sub>-C<sub>9 </sub>branched or linear alkyl esters; andMaster batches of α-[3-[3-(2H-benzotriazol-2- yl)-5-(1,1-dimethylethyl)-4-hydroxyphenyl]-1- oxopropyl-ω-[3-[3-(2H-benzotriazol-2-yl)-5- (1,1-dimethylethyl)-4-hydroxyphenyl]-1-oxo- propyl] poly(oxyethylene)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3812.39.6000",
      "rawHtsCode": "3812.39.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3812.39.7000",
      "rawHtsCode": "3812.39.70.00",
      "superior": null,
      "indent": "4",
      "description": "Bis(1,2,2,6,6-pentamethyl-4-piperidinyl) sebacate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3812.39.9000",
      "rawHtsCode": "3812.39.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3813.00",
      "rawHtsCode": "3813.00",
      "superior": null,
      "indent": "0",
      "description": "Preparations and charges for fire extinguishers; charged fire-extinguishing grenades:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3813.00.1000",
      "rawHtsCode": "3813.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Consisting wholly of inorganic substances",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3813.00.5000",
      "rawHtsCode": "3813.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3814.00",
      "rawHtsCode": "3814.00",
      "superior": null,
      "indent": "0",
      "description": "Organic composite solvents and thinners, not elsewhere specified or included; prepared paint or varnish removers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3814.00.1000",
      "rawHtsCode": "3814.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Containing 5 percent or more but not more than 25 percent by weight of one or more aromatic or modified aromatic substances",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3814.00.2000",
      "rawHtsCode": "3814.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Containing more than 25 percent by weight of one or more aromatic or modified aromatic substances",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3814.00.50",
      "rawHtsCode": "3814.00.50",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3814.00.5010",
      "rawHtsCode": "3814.00.50.10",
      "superior": null,
      "indent": "2",
      "description": "Containing methyl chloroform (1,1,1-trichloro- ethane) or carbon tetrachloride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3814.00.5090",
      "rawHtsCode": "3814.00.50.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3815",
      "rawHtsCode": "3815",
      "superior": null,
      "indent": "0",
      "description": "Reaction initiators, reaction accelerators and catalytic preparations, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3815.11.0000",
      "rawHtsCode": "3815.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "With nickel or nickel compounds as the active substance",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "3815.12.00",
      "rawHtsCode": "3815.12.00",
      "superior": null,
      "indent": "2",
      "description": "With precious metal or precious metal compounds as the active substance",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3815.12.0010",
      "rawHtsCode": "3815.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "With platinum group metals as the active substance",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3815.12.0090",
      "rawHtsCode": "3815.12.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3815.19.0000",
      "rawHtsCode": "3815.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3815.90",
      "rawHtsCode": "3815.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3815.90.1000",
      "rawHtsCode": "3815.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of bismuth, of tungsten or of vanadium",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3815.90.2000",
      "rawHtsCode": "3815.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of mercury or of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3815.90.3000",
      "rawHtsCode": "3815.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3815.90.5000",
      "rawHtsCode": "3815.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3816",
      "rawHtsCode": "3816",
      "superior": null,
      "indent": "0",
      "description": "Refractory cements, mortars, concretes and similar compositions, including dolomite ramming mix, other than products of heading 3801:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3816.00.1000",
      "rawHtsCode": "3816.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Dolomite ramming mix",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3816.00.20",
      "rawHtsCode": "3816.00.20",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free \n(A, AU, BH, CL, CO,D,E, IL, JO, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3816.00.2010",
      "rawHtsCode": "3816.00.20.10",
      "superior": null,
      "indent": "2",
      "description": "Clay",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3816.00.2050",
      "rawHtsCode": "3816.00.20.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3817",
      "rawHtsCode": "3817",
      "superior": null,
      "indent": "0",
      "description": "Mixed alkylbenzenes and mixed alkylnaphthalenes, other than those of heading 2707 or 2902:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3817.00.1000",
      "rawHtsCode": "3817.00.10.00",
      "superior": null,
      "indent": "2",
      "description": "Mixed linear alkylbenzenes",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3817.00.1500",
      "rawHtsCode": "3817.00.15.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3817.00.2000",
      "rawHtsCode": "3817.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Mixed alkylnaphthalenes",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3818.00.00",
      "rawHtsCode": "3818.00.00",
      "superior": null,
      "indent": "0",
      "description": "Chemical elements doped for use in electronics, in the form of discs, wafers or similar forms; chemical compounds doped for use in electronics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3818.00.0010",
      "rawHtsCode": "3818.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Gallium arsenide wafers, doped",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3818.00.0020",
      "rawHtsCode": "3818.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Polycrystalline silicon wafers, doped",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3818.00.0030",
      "rawHtsCode": "3818.00.00.30",
      "superior": null,
      "indent": "1",
      "description": "Silicon carbide wafers, doped",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3818.00.0095",
      "rawHtsCode": "3818.00.00.95",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3819.00.00",
      "rawHtsCode": "3819.00.00",
      "superior": null,
      "indent": "0",
      "description": "Hydraulic brake fluids and other prepared liquids for hydraulic transmission, not containing or containing less than 70 percent by weight of petroleum oils or oils obtained from bituminous minerals",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3819.00.0010",
      "rawHtsCode": "3819.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Hydraulic brake fluids",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3819.00.0090",
      "rawHtsCode": "3819.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3820.00.0000",
      "rawHtsCode": "3820.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Antifreezing preparations and prepared deicing fluids",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "63%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3821.00.00",
      "rawHtsCode": "3821.00.00",
      "superior": null,
      "indent": "0",
      "description": "Prepared culture media for development or maintenance of micro-organisms (including viruses and the like) or of plant, human or animal cells",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3821.00.0010",
      "rawHtsCode": "3821.00.00.10",
      "superior": null,
      "indent": "2",
      "description": "Viral transport media",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3821.00.0090",
      "rawHtsCode": "3821.00.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3822",
      "rawHtsCode": "3822",
      "superior": null,
      "indent": "0",
      "description": "Diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, whether or not put up in the form of kits, other than those of heading 3006; certified reference materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3822.11.0000",
      "rawHtsCode": "3822.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "For malaria",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3822.12.0000",
      "rawHtsCode": "3822.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "For Zika and other diseases transmitted by mosquitoes of the genus <i>Aedes</i>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3822.13.0000",
      "rawHtsCode": "3822.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "For blood-grouping ",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3822.19.00",
      "rawHtsCode": "3822.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3822.19.0010",
      "rawHtsCode": "3822.19.00.10",
      "superior": null,
      "indent": "4",
      "description": "Containing methyl chloroform (1,1,1-trichloroethane) or carbon tetrachloride ",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3822.19.0030",
      "rawHtsCode": "3822.19.00.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3822.19.0040",
      "rawHtsCode": "3822.19.00.40",
      "superior": null,
      "indent": "4",
      "description": "Containing methyl chloroform (1,1,1-trichloroethane) or carbon tetrachloride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3822.19.0080",
      "rawHtsCode": "3822.19.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3822.90.0000",
      "rawHtsCode": "3822.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Certified reference materials",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3823",
      "rawHtsCode": "3823",
      "superior": null,
      "indent": "0",
      "description": "Industrial monocarboxylic fatty acids; acid oils from refining; industrial fatty alcohols:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3823.11.0000",
      "rawHtsCode": "3823.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Stearic acid",
      "units": [
        "kg"
      ],
      "generalRate": "2.1¢/kg + 3.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3823.12.0000",
      "rawHtsCode": "3823.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Oleic acid",
      "units": [
        "kg"
      ],
      "generalRate": "2.1¢/kg + 3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3823.13.00",
      "rawHtsCode": "3823.13.00",
      "superior": null,
      "indent": "2",
      "description": "Tall oil fatty acids",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3823.13.0020",
      "rawHtsCode": "3823.13.00.20",
      "superior": null,
      "indent": "3",
      "description": "Containing less than two percent rosin",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3823.13.0040",
      "rawHtsCode": "3823.13.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3823.19",
      "rawHtsCode": "3823.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3823.19.2000",
      "rawHtsCode": "3823.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Derived from coconut, palm-kernel or palm oil",
      "units": [
        "kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3823.19.4000",
      "rawHtsCode": "3823.19.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3823.70",
      "rawHtsCode": "3823.70",
      "superior": null,
      "indent": "1",
      "description": "Industrial fatty alcohols:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3823.70.2000",
      "rawHtsCode": "3823.70.20.00",
      "superior": null,
      "indent": "3",
      "description": "Oleyl",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3823.70.4000",
      "rawHtsCode": "3823.70.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3823.70.6000",
      "rawHtsCode": "3823.70.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824",
      "rawHtsCode": "3824",
      "superior": null,
      "indent": "0",
      "description": "Prepared binders for foundry molds or cores; chemical products and preparations of the chemical or allied industries (including those consisting of mixtures of natural products), not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.10.0000",
      "rawHtsCode": "3824.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Prepared binders for foundry molds or cores",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.30.0000",
      "rawHtsCode": "3824.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Nonagglomerated metal carbides mixed together or with metallic binders",
      "units": [
        "kg"
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.40",
      "rawHtsCode": "3824.40",
      "superior": null,
      "indent": "1",
      "description": "Prepared additives for cements, mortars or concretes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.40.1000",
      "rawHtsCode": "3824.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 5 percent or more by weight of one or more aromatic or modified aromatic substances",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.40.2000",
      "rawHtsCode": "3824.40.20.00",
      "superior": null,
      "indent": "2",
      "description": "Consisting wholly of inorganic substances",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3824.40.5000",
      "rawHtsCode": "3824.40.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.50.00",
      "rawHtsCode": "3824.50.00",
      "superior": null,
      "indent": "1",
      "description": "Nonrefractory mortars and concretes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3824.50.0010",
      "rawHtsCode": "3824.50.00.10",
      "superior": null,
      "indent": "2",
      "description": "Wet",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.50.0050",
      "rawHtsCode": "3824.50.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.60.0000",
      "rawHtsCode": "3824.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sorbitol other than that of subheading 2905.44",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.81.0000",
      "rawHtsCode": "3824.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing oxirane (ethylene oxide)",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.82",
      "rawHtsCode": "3824.82",
      "superior": null,
      "indent": "2",
      "description": "Containing polychlorinated biphenyls (PCBs), polychlorinated terphenyls ({PCTs) or polybrominated biphenyls (PBBs):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.82.1000",
      "rawHtsCode": "3824.82.10.00",
      "superior": null,
      "indent": "3",
      "description": "Chlorinated but not otherwise halogenated",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "114.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.82.9000",
      "rawHtsCode": "3824.82.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.83.0000",
      "rawHtsCode": "3824.83.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing tris(2,3-dibromopropyl) phospate",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.84.0000",
      "rawHtsCode": "3824.84.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing aldrin (ISO), camphechlor (ISO) (toxaphene), chlordane (ISO), chlordecone (ISO), DDT (ISO) (clofenatone (INN)), 1,1,1-trichloro-2,2-bis(p-chlorophenyl)ethane), dieldrin (ISO INN), endosulfan (ISO), endrin (ISO), heptachlor (ISO) or mirex (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "114.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.85.0000",
      "rawHtsCode": "3824.85.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 1,2,3,4,5,6-hexachlorocyclohexane (HCH (ISO)), including lindane (ISO,INN)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "114.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.86.0000",
      "rawHtsCode": "3824.86.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing pentachlorobenzene (ISO) or hexachlorobenzene (ISO)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.87.0000",
      "rawHtsCode": "3824.87.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing perfluorooctane sulfonic acid, its salts, perfluorooctane sulfonamides, or perfluorooctane sulfonyl fluoride",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.88.0000",
      "rawHtsCode": "3824.88.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing tetra-, penta-, hexa-, hepta-, or octabromodiphenyl ethers",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.89.0000",
      "rawHtsCode": "3824.89.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing short-chain chlorinated paraffins",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.91.0000",
      "rawHtsCode": "3824.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mixtures and preparations consisting mainly of (5-ethyl-2-methyl-2-oxido3,2-dioxaphosphinan-5-yl)methyl methylphosphonate and bis(5-ethyl-2-methyl-2-oxido-1,3,2-dioxaphosphinan-5-yl)methyl methylphosphonate",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.92.0000",
      "rawHtsCode": "3824.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Polyglycol esters of methylphosphonic acid.",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,JP,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99",
      "rawHtsCode": "3824.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.99.1100",
      "rawHtsCode": "3824.99.11.00",
      "superior": null,
      "indent": "4",
      "description": "In the form of ingots",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3824.99.1900",
      "rawHtsCode": "3824.99.19.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.2100",
      "rawHtsCode": "3824.99.21.00",
      "superior": null,
      "indent": "5",
      "description": "Consisting wholly of substances found naturally in coal tar, whether obtained from coal tar or other source",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3824.99.2500",
      "rawHtsCode": "3824.99.25.00",
      "superior": null,
      "indent": "5",
      "description": "Aqueous mixtures of triphenyl sulfonium chloride, diphenyl (4-phenylthio)phenyl sulfonium chloride and (thiodi-4,1- phenylene)bis(diphenyl sulfonium) dichloride",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.2600",
      "rawHtsCode": "3824.99.26.00",
      "superior": null,
      "indent": "5",
      "description": "Benzene, 2,4-diisocyanate-1,3,5-tris(1- methylethyl) homopolymer; 5-Fluoro-2-methyl-1-[[4-(methylsulfinyl)- phenyl]methylene]-1H-indene;Mixtures of dimethyl phthalate, t-butanol, hydrogen peroxide, and sodium salicylate; andMixtures containing derivatives of N-[4-(2- hydroxy-3-phenoxypropoxy)phenyl]- acetamide",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3824.99.2900",
      "rawHtsCode": "3824.99.29.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.7¢/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.3100",
      "rawHtsCode": "3824.99.31.00",
      "superior": null,
      "indent": "5",
      "description": "Of bismuth",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.3200",
      "rawHtsCode": "3824.99.32.00",
      "superior": null,
      "indent": "5",
      "description": "Of hydrosulfite compounds, of sulfoxylate compounds, or of both",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.3300",
      "rawHtsCode": "3824.99.33.00",
      "superior": null,
      "indent": "5",
      "description": "Of mercury",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "26.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.3400",
      "rawHtsCode": "3824.99.34.00",
      "superior": null,
      "indent": "5",
      "description": "Of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.3500",
      "rawHtsCode": "3824.99.35.00",
      "superior": null,
      "indent": "5",
      "description": "Of tungsten",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.3600",
      "rawHtsCode": "3824.99.36.00",
      "superior": null,
      "indent": "5",
      "description": "Of vanadium",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.39",
      "rawHtsCode": "3824.99.39",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3824.99.3910",
      "rawHtsCode": "3824.99.39.10",
      "superior": null,
      "indent": "6",
      "description": "Of lithium nickel cobalt manganese oxides",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.99.3990",
      "rawHtsCode": "3824.99.39.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.99.41",
      "rawHtsCode": "3824.99.41",
      "superior": null,
      "indent": "4",
      "description": "Fatty substances of animal or vegetable origin and mixtures thereof",
      "units": [],
      "generalRate": "4.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "16.5¢/kg + 30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.4140",
      "rawHtsCode": "3824.99.41.40",
      "superior": null,
      "indent": "5",
      "description": "Mixtures of fatty acid esters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.99.4190",
      "rawHtsCode": "3824.99.41.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.99.4900",
      "rawHtsCode": "3824.99.49.00",
      "superior": null,
      "indent": "5",
      "description": "Mixtures that are in whole or in part of hydrocarbons derived in whole or in part from petroleum, shale oil or natural gas",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.5000",
      "rawHtsCode": "3824.99.50.00",
      "superior": null,
      "indent": "6",
      "description": "Chlorinated but not otherwise halogenated",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "114.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.5500",
      "rawHtsCode": "3824.99.55.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.7000",
      "rawHtsCode": "3824.99.70.00",
      "superior": null,
      "indent": "6",
      "description": "Mixtures of dibromo neopentyl glycol; Polydibromophenylene oxide; Tetrabromobisphenol-A-carbonate oligomers; and Electroplating chemical and electroless plating solutions and other materials for printed circuit boards, plastics and metal finishings",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3824.99.75",
      "rawHtsCode": "3824.99.75",
      "superior": null,
      "indent": "6",
      "description": "Naphthenic acids, their water-insoluble salts and their esters",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.7510",
      "rawHtsCode": "3824.99.75.10",
      "superior": null,
      "indent": "7",
      "description": "Naphthenic acids",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.99.7550",
      "rawHtsCode": "3824.99.75.50",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.99.93",
      "rawHtsCode": "3824.99.93",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,JP,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3824.99.9310",
      "rawHtsCode": "3824.99.93.10",
      "superior": null,
      "indent": "8",
      "description": "Containing C<sub>11</sub> or lower alcohols only",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.99.9320",
      "rawHtsCode": "3824.99.93.20",
      "superior": null,
      "indent": "8",
      "description": "Containing C<sub>12</sub> or higher alcohols only",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.99.9330",
      "rawHtsCode": "3824.99.93.30",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.99.9361",
      "rawHtsCode": "3824.99.93.61",
      "superior": null,
      "indent": "7",
      "description": "Mixtures consisting mainly of chemicals containing a phosphorus atom to which is bonded one methyl, ethyl, <i>n</i>-propyl or isopropyl group, but no other carbon atoms",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.99.9386",
      "rawHtsCode": "3824.99.93.86",
      "superior": null,
      "indent": "7",
      "description": "Mixtures of a kind containing magnesium used as a desulfurization reagent",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3824.99.9397",
      "rawHtsCode": "3824.99.93.97",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3825",
      "rawHtsCode": "3825",
      "superior": null,
      "indent": "0",
      "description": "Residual products of the chemical or allied industries, not elsewhere specified or included; municipal waste; sewage sludge; other wastes specified in note 6 to this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3825.10.0100",
      "rawHtsCode": "3825.10.01.00",
      "superior": null,
      "indent": "1",
      "description": "Municipal waste",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3825.20.0000",
      "rawHtsCode": "3825.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sewage sludge",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3825.30.0000",
      "rawHtsCode": "3825.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Clinical waste",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "3825.41.0000",
      "rawHtsCode": "3825.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Halogenated",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3825.49.0000",
      "rawHtsCode": "3825.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3825.50.0000",
      "rawHtsCode": "3825.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Wastes of metal-pickling liquors, hydraulic fluids, brake fluids and anti-freeze fluids",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3825.61.0000",
      "rawHtsCode": "3825.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mainly containing organic constituents",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3825.69.0000",
      "rawHtsCode": "3825.69.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3825.90.0100",
      "rawHtsCode": "3825.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3826.00",
      "rawHtsCode": "3826.00",
      "superior": null,
      "indent": "0",
      "description": "Biodiesel and mixtures thereof, not containing or containing less than 70 percent by weight of petroleum oils or oils obtained from bituminous materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3826.00.1000",
      "rawHtsCode": "3826.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Biodiesel not containing petroleum oils or oils obtained from bituminous materials (B100)",
      "units": [
        "kg"
      ],
      "generalRate": "4.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "16.5¢/kg + 30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3826.00.3000",
      "rawHtsCode": "3826.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO, K,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827",
      "rawHtsCode": "3827",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing halogenated derivatives of methane, ethane or propane, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": " ",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3827.11.0000",
      "rawHtsCode": "3827.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing chlorofluorocarbons (CFCs), whether or not containing hydrochlorofluorocarbons (HCFCs), perfluorocarbons (PFCs) or hydrofluorocarbons (HFCs)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free  (A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.12.0000",
      "rawHtsCode": "3827.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing hydrobromofluorocarbons (HBFCs)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.13.0000",
      "rawHtsCode": "3827.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing carbon tetrachloride",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free \n(A, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "114.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.14.0000",
      "rawHtsCode": "3827.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 1,1,1-trichloroethane (methyl chloroform)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free \n(A, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "114.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.20.0000",
      "rawHtsCode": "3827.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Containing bromochlorodifluoromethane (Halon-1211), bromotrifluoromethane (Halon-1301) or dibromotetrafluoroethanes (Halon-2402)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free  (A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.31.0000",
      "rawHtsCode": "3827.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing substances of subheadings 2903.41 to 2903.48",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free  (A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.32.0000",
      "rawHtsCode": "3827.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, containing substances of subheadings 2903.71 to 2903.75",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free  (A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.39.0000",
      "rawHtsCode": "3827.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free  (A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.40.0000",
      "rawHtsCode": "3827.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Containing methyl bromide (bromomethane) or bromochloromethane",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A+, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA,OM, P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.51.0000",
      "rawHtsCode": "3827.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing trifluoromethane (HFC-23)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.59.0000",
      "rawHtsCode": "3827.59.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.61.0000",
      "rawHtsCode": "3827.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 15 percent or more by mass of 1,1,1-trifluoroethane (HFC-143a)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.62.0000",
      "rawHtsCode": "3827.62.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, not included in the subheading above, containing 55 percent or more by mass of pentafluoroethane (HFC- 125) but not containing unsaturated fluorinated derivatives of acyclic hydrocarbons (HFOs)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free  (A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.63.0000",
      "rawHtsCode": "3827.63.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, not included in the subheadings above, containing 40 percent or more by mass of pentafluoroethane (HFC-125)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.64.0000",
      "rawHtsCode": "3827.64.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, not included in the subheadings above, containing 30 percent or more by mass of 1,1,1,2-tetrafluoroethane (HFC-134a) but not containing unsaturated fluorinated derivatives of acyclic hydrocarbons (HFOs)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.65.0000",
      "rawHtsCode": "3827.65.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, not included in the subheadings above, containing 20 percent or more by mass of difluoromethane (HFC-32) and 20 percent or more by mass of pentafluoroethane (HFC-125)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.68.0000",
      "rawHtsCode": "3827.68.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, not included in the subheadings above, containing substances of subheadings 2903.41 to 2903.48",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.69.0000",
      "rawHtsCode": "3827.69.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.90",
      "rawHtsCode": "3827.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "\n",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3827.90.1000",
      "rawHtsCode": "3827.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Chlorinated but not otherwise halogenated",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free \n(A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "114.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3827.90.9000",
      "rawHtsCode": "3827.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free \n(A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3901",
      "rawHtsCode": "3901",
      "superior": null,
      "indent": "0",
      "description": "Polymers of ethylene, in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3901.10",
      "rawHtsCode": "3901.10",
      "superior": null,
      "indent": "1",
      "description": "Polyethylene having a specific gravity of less than 0.94:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3901.10.1000",
      "rawHtsCode": "3901.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Having a relative viscosity of 1.44 or more",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3901.10.50",
      "rawHtsCode": "3901.10.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3901.10.5010",
      "rawHtsCode": "3901.10.50.10",
      "superior": null,
      "indent": "3",
      "description": "Linear low density polyethylene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3901.10.5020",
      "rawHtsCode": "3901.10.50.20",
      "superior": null,
      "indent": "3",
      "description": "Low density polyethylene, except linear low density polyethylene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3901.10.5030",
      "rawHtsCode": "3901.10.50.30",
      "superior": null,
      "indent": "3",
      "description": "Medium density polyethylene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3901.20",
      "rawHtsCode": "3901.20",
      "superior": null,
      "indent": "1",
      "description": "Polyethylene having a specific gravity of 0.94 or more:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3901.20.1000",
      "rawHtsCode": "3901.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Having a relative viscosity of 1.44 or more",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL, JO,KR,MA, OM,P, PA,PE,S,SG)",
      "otherRate": "43%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3901.20.5000",
      "rawHtsCode": "3901.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3901.30",
      "rawHtsCode": "3901.30",
      "superior": null,
      "indent": "1",
      "description": "Ethylene-vinyl acetate copolymers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3901.30.2000",
      "rawHtsCode": "3901.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Vinyl acetate-vinyl chloride-ethylene terpolymers, containing by weight less than 50 percent derivatives of vinyl acetate, except those polymerized from aromatic or modified aromatic monomers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3901.30.6000",
      "rawHtsCode": "3901.30.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3901.40.0000",
      "rawHtsCode": "3901.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ethylene-alpha-olefin copolymers, having a specific gravity of less than 0.94",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3901.90",
      "rawHtsCode": "3901.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3901.90.1000",
      "rawHtsCode": "3901.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Elastomeric",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "3901.90.5501",
      "rawHtsCode": "3901.90.55.01",
      "superior": null,
      "indent": "3",
      "description": "Ethylene copolymers",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3901.90.9000",
      "rawHtsCode": "3901.90.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg +33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3902",
      "rawHtsCode": "3902",
      "superior": null,
      "indent": "0",
      "description": "Polymers of propylene or of other olefins, in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3902.10.0000",
      "rawHtsCode": "3902.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Polypropylene",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3902.20",
      "rawHtsCode": "3902.20",
      "superior": null,
      "indent": "1",
      "description": "Polyisobutylene:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3902.20.1000",
      "rawHtsCode": "3902.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Elastomeric",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3902.20.5000",
      "rawHtsCode": "3902.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3902.30.0000",
      "rawHtsCode": "3902.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Propylene copolymers",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3902.90.00",
      "rawHtsCode": "3902.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3902.90.0010",
      "rawHtsCode": "3902.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Polybutylene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3902.90.0050",
      "rawHtsCode": "3902.90.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3903",
      "rawHtsCode": "3903",
      "superior": null,
      "indent": "0",
      "description": "Polymers of styrene, in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3903.11.0000",
      "rawHtsCode": "3903.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Expandable",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3903.19.0000",
      "rawHtsCode": "3903.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3903.20.0000",
      "rawHtsCode": "3903.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Styrene-acrylonitrile (SAN) copolymers",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3903.30.0000",
      "rawHtsCode": "3903.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Acrylonitrile-butadiene-styrene (ABS) copolymers",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,D,E,IL,J,JO,KR,MA,OM,P,PE,S,SG)",
      "otherRate": "15.4¢/kg + 47%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3903.90",
      "rawHtsCode": "3903.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3903.90.1000",
      "rawHtsCode": "3903.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Methyl methacrylate-butadiene-styrene (MBS) copolymers",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 67.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3903.90.5000",
      "rawHtsCode": "3903.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3904",
      "rawHtsCode": "3904",
      "superior": null,
      "indent": "0",
      "description": "Polymers of vinyl chloride or of other halogenated olefins, in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3904.10.0000",
      "rawHtsCode": "3904.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Poly(vinyl chloride), not mixed with any other substances",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3904.21.0000",
      "rawHtsCode": "3904.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Nonplasticized",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3904.22.0000",
      "rawHtsCode": "3904.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Plasticized",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3904.30",
      "rawHtsCode": "3904.30",
      "superior": null,
      "indent": "1",
      "description": "Vinyl chloride-vinyl acetate copolymers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3904.30.2000",
      "rawHtsCode": "3904.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Vinyl acetate-vinyl chloride-ethylene terpolymers, containing by weight less than 50 percent derivatives of vinyl acetate, except those polymerized from aromatic or modified aromatic monomers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3904.30.6000",
      "rawHtsCode": "3904.30.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3904.40.0000",
      "rawHtsCode": "3904.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other vinyl chloride copolymers",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3904.50.0000",
      "rawHtsCode": "3904.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Vinylidene chloride polymers",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3904.61.00",
      "rawHtsCode": "3904.61.00",
      "superior": null,
      "indent": "2",
      "description": "Polytetrafluoroethylene (PTFE)",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "34.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3904.61.0010",
      "rawHtsCode": "3904.61.00.10",
      "superior": null,
      "indent": "3",
      "description": "Granular, whether or not filled or compounded (see statistical note 1 to this chapter)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3904.61.0090",
      "rawHtsCode": "3904.61.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3904.69",
      "rawHtsCode": "3904.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3904.69.1000",
      "rawHtsCode": "3904.69.10.00",
      "superior": null,
      "indent": "3",
      "description": "Elastomeric",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3904.69.5000",
      "rawHtsCode": "3904.69.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3904.90",
      "rawHtsCode": "3904.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3904.90.1000",
      "rawHtsCode": "3904.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Elastomeric",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3904.90.5000",
      "rawHtsCode": "3904.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3905",
      "rawHtsCode": "3905",
      "superior": null,
      "indent": "0",
      "description": "Polymers of vinyl acetate or of other vinyl esters, in primary forms; other vinyl polymers in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3905.12.0000",
      "rawHtsCode": "3905.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "In aqueous dispersion",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3905.19.0000",
      "rawHtsCode": "3905.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3905.21.0000",
      "rawHtsCode": "3905.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "In aqueous dispersion",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3905.29.0000",
      "rawHtsCode": "3905.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3905.30.0000",
      "rawHtsCode": "3905.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Poly(vinyl alcohol), whether or not containing unhydrolyzed acetate groups",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3905.91",
      "rawHtsCode": "3905.91",
      "superior": null,
      "indent": "2",
      "description": "Copolymers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3905.91.1000",
      "rawHtsCode": "3905.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight 50 percent or more of derivatives of vinyl acetate",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3905.91.5000",
      "rawHtsCode": "3905.91.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3905.99",
      "rawHtsCode": "3905.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3905.99.3000",
      "rawHtsCode": "3905.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "Polyvinyl carbazole (including adjuvants)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3905.99.8000",
      "rawHtsCode": "3905.99.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3906",
      "rawHtsCode": "3906",
      "superior": null,
      "indent": "0",
      "description": "Acrylic polymers in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3906.10.0000",
      "rawHtsCode": "3906.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Poly(methyl methacrylate)",
      "units": [
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3906.90",
      "rawHtsCode": "3906.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3906.90.1000",
      "rawHtsCode": "3906.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Elastomeric",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3906.90.2000",
      "rawHtsCode": "3906.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Plastics",
      "units": [
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3906.90.5000",
      "rawHtsCode": "3906.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.88.69. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907",
      "rawHtsCode": "3907",
      "superior": null,
      "indent": "0",
      "description": "Polyacetals, other polyethers and epoxide resins, in primary forms; polycarbonates, alkyd resins, polyallyl esters and other polyesters, in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3907.10.0000",
      "rawHtsCode": "3907.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Polyacetals",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907.21.0000",
      "rawHtsCode": "3907.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Bis(polyoxyethylene) methylphosphonate",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free  (A, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907.29.0000",
      "rawHtsCode": "3907.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free(A, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907.30.0000",
      "rawHtsCode": "3907.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Epoxide resins",
      "units": [
        "kg"
      ],
      "generalRate": "6.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG) ",
      "otherRate": "15.4¢/kg + 47%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907.40.0000",
      "rawHtsCode": "3907.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Polycarbonates",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907.50.0000",
      "rawHtsCode": "3907.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Alkyd resins",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907.61.00",
      "rawHtsCode": "3907.61.00",
      "superior": null,
      "indent": "2",
      "description": "Having a viscosity number of 78 ml/g or higher",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907.61.0010",
      "rawHtsCode": "3907.61.00.10",
      "superior": null,
      "indent": "4",
      "description": "Having a viscosity number of 78 ml/g or more but not more than 88 ml/g",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3907.61.0050",
      "rawHtsCode": "3907.61.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3907.69.00",
      "rawHtsCode": "3907.69.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907.69.0010",
      "rawHtsCode": "3907.69.00.10",
      "superior": null,
      "indent": "4",
      "description": "Having a viscosity number of 70 ml/g or more but less than 78 ml/g",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3907.69.0050",
      "rawHtsCode": "3907.69.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3907.70.0000",
      "rawHtsCode": "3907.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Poly(lactic acid)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907.91",
      "rawHtsCode": "3907.91",
      "superior": null,
      "indent": "2",
      "description": "Unsaturated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3907.91.2000",
      "rawHtsCode": "3907.91.20.00",
      "superior": null,
      "indent": "4",
      "description": "Allyl resins, uncompounded",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3907.91.4000",
      "rawHtsCode": "3907.91.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907.91.5000",
      "rawHtsCode": "3907.91.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907.99",
      "rawHtsCode": "3907.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3907.99.2000",
      "rawHtsCode": "3907.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Thermoplastic liquid crystal aromatic polyester copolymers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "3907.99.50",
      "rawHtsCode": "3907.99.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3907.99.5010",
      "rawHtsCode": "3907.99.50.10",
      "superior": null,
      "indent": "4",
      "description": "Polybutylene terephthalate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3907.99.5050",
      "rawHtsCode": "3907.99.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3908",
      "rawHtsCode": "3908",
      "superior": null,
      "indent": "0",
      "description": "Polyamides in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3908.10.0000",
      "rawHtsCode": "3908.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Polyamide-6, -11, -12, -6,6, -6,9, -6,10 or -6,12",
      "units": [
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3908.90",
      "rawHtsCode": "3908.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3908.90.2000",
      "rawHtsCode": "3908.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Bis(4-amino-3-methylcyclohexyl)methane- isophthalic acid-laurolactam copolymer",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3908.90.7000",
      "rawHtsCode": "3908.90.70.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3909",
      "rawHtsCode": "3909",
      "superior": null,
      "indent": "0",
      "description": "Amino-resins, phenolic resins and polyurethanes, in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3909.10.0000",
      "rawHtsCode": "3909.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Urea resins; thiourea resins",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "41.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3909.20.0000",
      "rawHtsCode": "3909.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Melamine resins",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "41.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3909.31.0000",
      "rawHtsCode": "3909.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Poly(methylene phenyl isocyanate) (crude MDI, polymeric MDI)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "41.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3909.39.0000",
      "rawHtsCode": "3909.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "41.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3909.40.0000",
      "rawHtsCode": "3909.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Phenolic resins",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3909.50",
      "rawHtsCode": "3909.50",
      "superior": null,
      "indent": "1",
      "description": "Polyurethanes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3909.50.1000",
      "rawHtsCode": "3909.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Elastomeric",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3909.50.2000",
      "rawHtsCode": "3909.50.20.00",
      "superior": null,
      "indent": "2",
      "description": "Cements",
      "units": [
        "kg"
      ],
      "generalRate": "2.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3909.50.5000",
      "rawHtsCode": "3909.50.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3910.00.0000",
      "rawHtsCode": "3910.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Silicones in primary forms",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3911",
      "rawHtsCode": "3911",
      "superior": null,
      "indent": "0",
      "description": "Petroleum resins, coumarone-indene resins, polyterpenes, polysulfides, polysulfones and other products specified in note 3 to this chapter, not elsewhere specified or included, in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3911.10.0000",
      "rawHtsCode": "3911.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Petroleum resins, coumarone, indene or coumarone-indene resins; polyterpenes",
      "units": [
        "kg"
      ],
      "generalRate": "6.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3911.20.0000",
      "rawHtsCode": "3911.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Poly(1,3-phenylene methylphosphonate)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free \n(A, AU, BH, CL, CO, D, E, IL, JO, K, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "2.2¢/kg  +  33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3911.90",
      "rawHtsCode": "3911.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3911.90.1000",
      "rawHtsCode": "3911.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Elastomeric",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3911.90.1500",
      "rawHtsCode": "3911.90.15.00",
      "superior": null,
      "indent": "5",
      "description": "Poly(nitrilomethanetetraarylnitrilo- [2,4,6-tris-(1-methyethyl)-1,3- phenylene]]-2,6-bis(1-methylethyl)- phenyl]-ω-[[[2,6-bis(1-methylethyl)- phenyl]amino]methylene]amino carbodiimide or 2,4-diisocyanate-1,3,5-tris(1-methyl- ethyl) homopolymer with polyethylene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3911.90.2500",
      "rawHtsCode": "3911.90.25.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3911.90.3500",
      "rawHtsCode": "3911.90.35.00",
      "superior": null,
      "indent": "5",
      "description": "1,1'-Bis(methylenedi-4,1-phenylene)- 1H-pyrrole-2,5-dione, copolymer with 4,4'-methylenebis(benzeneamine); and Hydrocarbon novolac cyanate ester",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3911.90.4500",
      "rawHtsCode": "3911.90.45.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3911.90.7000",
      "rawHtsCode": "3911.90.70.00",
      "superior": null,
      "indent": "4",
      "description": "Chlorinated synthetic rubber",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3911.90.91",
      "rawHtsCode": "3911.90.91",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3911.90.9110",
      "rawHtsCode": "3911.90.91.10",
      "superior": null,
      "indent": "5",
      "description": "Thermoplastic",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3911.90.9150",
      "rawHtsCode": "3911.90.91.50",
      "superior": null,
      "indent": "5",
      "description": "Thermosetting",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3912",
      "rawHtsCode": "3912",
      "superior": null,
      "indent": "0",
      "description": "Cellulose and its chemical derivatives, not elsewhere specified or included, in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3912.11.0000",
      "rawHtsCode": "3912.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Nonplasticized",
      "units": [
        "kg"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "73.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3912.12.0000",
      "rawHtsCode": "3912.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Plasticized",
      "units": [
        "kg"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "73.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3912.20.0000",
      "rawHtsCode": "3912.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cellulose nitrates (including collodions)",
      "units": [
        "kg"
      ],
      "generalRate": "5.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E, IL,JO,K,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "34.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3912.31.00",
      "rawHtsCode": "3912.31.00",
      "superior": null,
      "indent": "2",
      "description": "Carboxymethylcellulose and its salts",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3912.31.0010",
      "rawHtsCode": "3912.31.00.10",
      "superior": null,
      "indent": "3",
      "description": "Containing not less than 90 percent by weight of carboxymethylcellulose",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3912.31.0090",
      "rawHtsCode": "3912.31.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3912.39.0000",
      "rawHtsCode": "3912.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3912.90.00",
      "rawHtsCode": "3912.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "5.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "34.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3912.90.0010",
      "rawHtsCode": "3912.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "α-Cellulose in granular, microcrystalline or powdered forms",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3912.90.0090",
      "rawHtsCode": "3912.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3913",
      "rawHtsCode": "3913",
      "superior": null,
      "indent": "0",
      "description": "Natural polymers (for example, alginic acid) and modified natural polymers (for example, hardened proteins, chemical derivatives of natural rubber), not elsewhere specified or included, in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3913.10.0000",
      "rawHtsCode": "3913.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Alginic acid, its salts and esters",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3913.90",
      "rawHtsCode": "3913.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3913.90.1000",
      "rawHtsCode": "3913.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Chemical derivatives of natural rubber",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3913.90.20",
      "rawHtsCode": "3913.90.20",
      "superior": null,
      "indent": "2",
      "description": "Polysaccharides and their derivatives",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3913.90.2015",
      "rawHtsCode": "3913.90.20.15",
      "superior": null,
      "indent": "3",
      "description": "Xanthan gum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3913.90.2090",
      "rawHtsCode": "3913.90.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3913.90.5000",
      "rawHtsCode": "3913.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2.2¢/kg + 33.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3914.00",
      "rawHtsCode": "3914.00",
      "superior": null,
      "indent": "0",
      "description": "Ion-exchangers based on polymers of headings 3901 to 3913, in primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3914.00.2000",
      "rawHtsCode": "3914.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Cross-linked polyvinylbenzyltrimethylammonium chloride (Cholestyramine resin USP)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3914.00.6000",
      "rawHtsCode": "3914.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,K,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3915",
      "rawHtsCode": "3915",
      "superior": null,
      "indent": "0",
      "description": "Waste, parings and scrap, of plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3915.10.0000",
      "rawHtsCode": "3915.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of polymers of ethylene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3915.20.0000",
      "rawHtsCode": "3915.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of polymers of styrene",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3915.30.0000",
      "rawHtsCode": "3915.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of polymers of vinyl chloride",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3915.90.00",
      "rawHtsCode": "3915.90.00",
      "superior": null,
      "indent": "1",
      "description": "Of other plastics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3915.90.0010",
      "rawHtsCode": "3915.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of polyethylene terephthalate (PET) plastics",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3915.90.0090",
      "rawHtsCode": "3915.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3916",
      "rawHtsCode": "3916",
      "superior": null,
      "indent": "0",
      "description": "Monofilament of which any cross-sectional dimension exceeds 1 mm, rods, sticks and profile shapes, whether or not surface-worked but not otherwise worked, of plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3916.10.0000",
      "rawHtsCode": "3916.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of polymers of ethylene",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02.",
        "See additional U.S. note 2 to this chapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3916.20.00",
      "rawHtsCode": "3916.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of polymers of vinyl chloride",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3916.20.0010",
      "rawHtsCode": "3916.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Siding for house or building exterior",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3916.20.0020",
      "rawHtsCode": "3916.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Window, door, decking or railing profiles",
      "units": [
        "m",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3916.20.0091",
      "rawHtsCode": "3916.20.00.91",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3916.90",
      "rawHtsCode": "3916.90",
      "superior": null,
      "indent": "1",
      "description": "Of other plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3916.90.1000",
      "rawHtsCode": "3916.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of acrylic polymers",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40.6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3916.90.2000",
      "rawHtsCode": "3916.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Racket strings",
      "units": [
        "m"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3916.90.3000",
      "rawHtsCode": "3916.90.30.00",
      "superior": null,
      "indent": "4",
      "description": "Monofilament",
      "units": [
        "m"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3916.90.5000",
      "rawHtsCode": "3916.90.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See additional U.S. note 2 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3917",
      "rawHtsCode": "3917",
      "superior": null,
      "indent": "0",
      "description": "Tubes, pipes and hoses and fittings therefor (for example, joints, elbows, flanges), of plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.10",
      "rawHtsCode": "3917.10",
      "superior": null,
      "indent": "1",
      "description": "Artificial guts (sausage casings) of hardened protein or of cellulosic plastics materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.10.1000",
      "rawHtsCode": "3917.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of cellulosic plastics materials",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3917.10.6000",
      "rawHtsCode": "3917.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of collagen",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3917.10.9000",
      "rawHtsCode": "3917.10.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3917.21.0000",
      "rawHtsCode": "3917.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of polymers of ethylene",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02.",
        "See additional U.S. note 3 to this chapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3917.22.0000",
      "rawHtsCode": "3917.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of polymers of propylene",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02.",
        "See additional U.S. note 3 to this chapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3917.23.0000",
      "rawHtsCode": "3917.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of polymers of vinyl chloride",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See additional U.S. note 3 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3917.29.00",
      "rawHtsCode": "3917.29.00",
      "superior": null,
      "indent": "2",
      "description": "Of other plastics",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See additional U.S. note 3 to this chapter. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3917.29.0050",
      "rawHtsCode": "3917.29.00.50",
      "superior": null,
      "indent": "3",
      "description": "Less than 200 mm in length",
      "units": [
        "thousands",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.29.0090",
      "rawHtsCode": "3917.29.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.31.0000",
      "rawHtsCode": "3917.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Flexible tubes, pipes and hoses, having a minimum burst pressure of 27.6 MPa",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02.",
        "See additional U.S. note 3 to this chapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3917.32.00",
      "rawHtsCode": "3917.32.00",
      "superior": null,
      "indent": "2",
      "description": "Other, not reinforced or otherwise combined with other materials, without fittings",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3917.32.0010",
      "rawHtsCode": "3917.32.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of polyvinyl chloride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.32.0020",
      "rawHtsCode": "3917.32.00.20",
      "superior": null,
      "indent": "3",
      "description": "Of polyethylene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.32.0050",
      "rawHtsCode": "3917.32.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.33.0000",
      "rawHtsCode": "3917.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, not reinforced or otherwise combined with other materials, with fittings",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See additional U.S. note 3 to this chapter. ",
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3917.39.00",
      "rawHtsCode": "3917.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See additional U.S. note 3 to this chapter. ",
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3917.39.0010",
      "rawHtsCode": "3917.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Reinforced with metal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.39.0020",
      "rawHtsCode": "3917.39.00.20",
      "superior": null,
      "indent": "4",
      "description": "Of polyvinyl chloride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.39.0050",
      "rawHtsCode": "3917.39.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.40.00",
      "rawHtsCode": "3917.40.00",
      "superior": null,
      "indent": "1",
      "description": "Fittings",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See additional U.S. note 3 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3917.40.0010",
      "rawHtsCode": "3917.40.00.10",
      "superior": null,
      "indent": "2",
      "description": "For brake hoses for the vehicles of subheadings 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or headings 8702, 8703, 8704, 8705 or 8711",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.40.0020",
      "rawHtsCode": "3917.40.00.20",
      "superior": null,
      "indent": "3",
      "description": "Of polyvinyl chloride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.40.0030",
      "rawHtsCode": "3917.40.00.30",
      "superior": null,
      "indent": "3",
      "description": "Of acrylonitrile-butadiene-styrene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.40.0050",
      "rawHtsCode": "3917.40.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.40.0060",
      "rawHtsCode": "3917.40.00.60",
      "superior": null,
      "indent": "3",
      "description": "Of polyvinyl chloride",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.40.0080",
      "rawHtsCode": "3917.40.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3917.40.0095",
      "rawHtsCode": "3917.40.00.95",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918",
      "rawHtsCode": "3918",
      "superior": null,
      "indent": "0",
      "description": "Floor coverings of plastics, whether or not self-adhesive, in rolls or in the form of tiles; wall or ceiling coverings of plastics, as defined in note 9 to this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918.10",
      "rawHtsCode": "3918.10",
      "superior": null,
      "indent": "1",
      "description": "Of polymers of vinyl chloride:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918.10.10",
      "rawHtsCode": "3918.10.10",
      "superior": null,
      "indent": "3",
      "description": "Vinyl tile",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3918.10.1020",
      "rawHtsCode": "3918.10.10.20",
      "superior": null,
      "indent": "4",
      "description": "Vinyl tile consisting of a rigid solid polymer core",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918.10.1030",
      "rawHtsCode": "3918.10.10.30",
      "superior": null,
      "indent": "4",
      "description": "Vinyl tile consisting of a rigid expanded polymer core of a kind described in statistical note 2 to this chapter",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918.10.1040",
      "rawHtsCode": "3918.10.10.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918.10.2000",
      "rawHtsCode": "3918.10.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3918.10.31",
      "rawHtsCode": "3918.10.31",
      "superior": null,
      "indent": "5",
      "description": "Over 70 percent by weight of plastics",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3918.10.3110",
      "rawHtsCode": "3918.10.31.10",
      "superior": null,
      "indent": "6",
      "description": "Woven",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918.10.3150",
      "rawHtsCode": "3918.10.31.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918.10.32",
      "rawHtsCode": "3918.10.32",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "84.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3918.10.3210",
      "rawHtsCode": "3918.10.32.10",
      "superior": null,
      "indent": "6",
      "description": "Woven",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918.10.3250",
      "rawHtsCode": "3918.10.32.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918.10.40",
      "rawHtsCode": "3918.10.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3918.10.4010",
      "rawHtsCode": "3918.10.40.10",
      "superior": null,
      "indent": "5",
      "description": "Woven",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918.10.4050",
      "rawHtsCode": "3918.10.40.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918.10.5000",
      "rawHtsCode": "3918.10.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3918.90",
      "rawHtsCode": "3918.90",
      "superior": null,
      "indent": "1",
      "description": "Of other plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3918.90.1000",
      "rawHtsCode": "3918.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Floor coverings",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3918.90.2000",
      "rawHtsCode": "3918.90.20.00",
      "superior": null,
      "indent": "4",
      "description": "With a backing of man-made fibers",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "84.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3918.90.3000",
      "rawHtsCode": "3918.90.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3918.90.5000",
      "rawHtsCode": "3918.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3919",
      "rawHtsCode": "3919",
      "superior": null,
      "indent": "0",
      "description": "Self-adhesive plates, sheets, film, foil, tape, strip and other flat shapes, of plastics, whether or not in rolls:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3919.10",
      "rawHtsCode": "3919.10",
      "superior": null,
      "indent": "1",
      "description": "In rolls of a width not exceeding 20 cm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3919.10.10",
      "rawHtsCode": "3919.10.10",
      "superior": null,
      "indent": "2",
      "description": "Having a light-reflecting surface produced in whole or in part by glass grains (ballotini)",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3919.10.1010",
      "rawHtsCode": "3919.10.10.10",
      "superior": null,
      "indent": "3",
      "description": "Pavement marking tape",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3919.10.1050",
      "rawHtsCode": "3919.10.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3919.10.20",
      "rawHtsCode": "3919.10.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3919.10.2010",
      "rawHtsCode": "3919.10.20.10",
      "superior": null,
      "indent": "3",
      "description": "Filament reinforced tape",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3919.10.2020",
      "rawHtsCode": "3919.10.20.20",
      "superior": null,
      "indent": "3",
      "description": "Electrical tape",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3919.10.2030",
      "rawHtsCode": "3919.10.20.30",
      "superior": null,
      "indent": "5",
      "description": "Not exceeding 5 cm in width",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3919.10.2040",
      "rawHtsCode": "3919.10.20.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3919.10.2055",
      "rawHtsCode": "3919.10.20.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "3919.90",
      "rawHtsCode": "3919.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3919.90.1000",
      "rawHtsCode": "3919.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Having a light-reflecting surface produced in whole or in part by glass grains (ballotini)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3919.90.50",
      "rawHtsCode": "3919.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3919.90.5010",
      "rawHtsCode": "3919.90.50.10",
      "superior": null,
      "indent": "3",
      "description": "Reflectorized sheeting",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3919.90.5020",
      "rawHtsCode": "3919.90.50.20",
      "superior": null,
      "indent": "3",
      "description": "Filament reinforced tape",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3919.90.5030",
      "rawHtsCode": "3919.90.50.30",
      "superior": null,
      "indent": "3",
      "description": "Electrical tape",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3919.90.5040",
      "rawHtsCode": "3919.90.50.40",
      "superior": null,
      "indent": "3",
      "description": "Transparent tape",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "3919.90.5060",
      "rawHtsCode": "3919.90.50.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "3920",
      "rawHtsCode": "3920",
      "superior": null,
      "indent": "0",
      "description": "Other plates, sheets, film, foil and strip, of plastics, noncellular and not reinforced, laminated, supported or similarly combined with other materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.10.0000",
      "rawHtsCode": "3920.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of polymers of ethylene",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.20.00",
      "rawHtsCode": "3920.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of polymers of propylene",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.20.0015",
      "rawHtsCode": "3920.20.00.15",
      "superior": null,
      "indent": "2",
      "description": "Strip put up in packaging for use as decorative or gift-wrapping ribbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.20.0020",
      "rawHtsCode": "3920.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Gift wrap",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.20.0055",
      "rawHtsCode": "3920.20.00.55",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.30.0000",
      "rawHtsCode": "3920.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of polymers of styrene",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.43",
      "rawHtsCode": "3920.43",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight not less than 6 percent of plasticizers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.43.1000",
      "rawHtsCode": "3920.43.10.00",
      "superior": null,
      "indent": "3",
      "description": "Made in imitation of patent leather",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.43.5000",
      "rawHtsCode": "3920.43.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.49.0000",
      "rawHtsCode": "3920.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.51",
      "rawHtsCode": "3920.51",
      "superior": null,
      "indent": "2",
      "description": "Of poly(methyl methacrylate):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.51.1000",
      "rawHtsCode": "3920.51.10.00",
      "superior": null,
      "indent": "3",
      "description": "Flexible",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.51.50",
      "rawHtsCode": "3920.51.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.51.5050",
      "rawHtsCode": "3920.51.50.50",
      "superior": null,
      "indent": "4",
      "description": "Sheets, not flexible, containing flame retardant",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.51.5090",
      "rawHtsCode": "3920.51.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.59",
      "rawHtsCode": "3920.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.59.1000",
      "rawHtsCode": "3920.59.10.00",
      "superior": null,
      "indent": "3",
      "description": "Flexible",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.59.4000",
      "rawHtsCode": "3920.59.40.00",
      "superior": null,
      "indent": "4",
      "description": "Transparent sheeting containing 30 percent or more by weight of lead",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "51.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "3920.59.8000",
      "rawHtsCode": "3920.59.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "51.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.61.0000",
      "rawHtsCode": "3920.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of polycarbonates",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.62.00",
      "rawHtsCode": "3920.62.00",
      "superior": null,
      "indent": "2",
      "description": "Of poly(ethylene terephthalate)",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.62.0020",
      "rawHtsCode": "3920.62.00.20",
      "superior": null,
      "indent": "4",
      "description": "Gift wrap",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.62.0050",
      "rawHtsCode": "3920.62.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.62.0090",
      "rawHtsCode": "3920.62.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "3920.63",
      "rawHtsCode": "3920.63",
      "superior": null,
      "indent": "2",
      "description": "Of unsaturated polyesters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.63.1000",
      "rawHtsCode": "3920.63.10.00",
      "superior": null,
      "indent": "3",
      "description": "Flexible",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.63.2000",
      "rawHtsCode": "3920.63.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.69.0000",
      "rawHtsCode": "3920.69.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of other polyesters",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.71.0000",
      "rawHtsCode": "3920.71.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of regenerated cellulose",
      "units": [
        "kg"
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.73.0000",
      "rawHtsCode": "3920.73.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of cellulose acetate",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.79",
      "rawHtsCode": "3920.79",
      "superior": null,
      "indent": "2",
      "description": "Of other cellulose derivatives:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.79.0500",
      "rawHtsCode": "3920.79.05.00",
      "superior": null,
      "indent": "3",
      "description": "Of vulcanized fiber",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.79.1000",
      "rawHtsCode": "3920.79.10.00",
      "superior": null,
      "indent": "4",
      "description": "Film, strip and sheets, not over 0.076 mm in thickness",
      "units": [
        "kg"
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.79.5000",
      "rawHtsCode": "3920.79.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "28.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.91.0000",
      "rawHtsCode": "3920.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of poly(vinyl butyral)",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.92.0000",
      "rawHtsCode": "3920.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of polyamides",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.93.0000",
      "rawHtsCode": "3920.93.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of amino-resins",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.94.0000",
      "rawHtsCode": "3920.94.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of phenolic resins",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.99",
      "rawHtsCode": "3920.99",
      "superior": null,
      "indent": "2",
      "description": "Of other plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3920.99.1000",
      "rawHtsCode": "3920.99.10.00",
      "superior": null,
      "indent": "4",
      "description": "Over 0.152 mm in thickness, and not in rolls",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.99.2000",
      "rawHtsCode": "3920.99.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3920.99.5000",
      "rawHtsCode": "3920.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921",
      "rawHtsCode": "3921",
      "superior": null,
      "indent": "0",
      "description": "Other plates, sheets, film, foil and strip, of plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.11.0000",
      "rawHtsCode": "3921.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of polymers of styrene",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.12",
      "rawHtsCode": "3921.12",
      "superior": null,
      "indent": "2",
      "description": "Of polymers of vinyl chloride:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.12.1100",
      "rawHtsCode": "3921.12.11.00",
      "superior": null,
      "indent": "5",
      "description": "Over 70 percent by weight of plastics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.12.1500",
      "rawHtsCode": "3921.12.15.00",
      "superior": null,
      "indent": "5",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,B,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "84.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.12.19",
      "rawHtsCode": "3921.12.19",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,J,JO,KR,MA,OM,P,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.12.1910",
      "rawHtsCode": "3921.12.19.10",
      "superior": null,
      "indent": "5",
      "description": "Products with textile components in which vegetable fibers predominate by weight over any other single textile fiber",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.12.1950",
      "rawHtsCode": "3921.12.19.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.12.5000",
      "rawHtsCode": "3921.12.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.13",
      "rawHtsCode": "3921.13",
      "superior": null,
      "indent": "2",
      "description": "Of polyurethanes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.13.1100",
      "rawHtsCode": "3921.13.11.00",
      "superior": null,
      "indent": "5",
      "description": "Over 70 percent by weight of plastics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.13.1500",
      "rawHtsCode": "3921.13.15.00",
      "superior": null,
      "indent": "5",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,B,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "84.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.13.19",
      "rawHtsCode": "3921.13.19",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.13.1910",
      "rawHtsCode": "3921.13.19.10",
      "superior": null,
      "indent": "5",
      "description": "Products with textile components in which vegetable fibers predominate by weight over any other single textile fiber",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.13.1950",
      "rawHtsCode": "3921.13.19.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.13.5000",
      "rawHtsCode": "3921.13.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.14.0000",
      "rawHtsCode": "3921.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of regenerated cellulose",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.19.00",
      "rawHtsCode": "3921.19.00",
      "superior": null,
      "indent": "2",
      "description": "Of other plastics",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.19.0010",
      "rawHtsCode": "3921.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Microporous sheets of polyethylene or polypropylene film",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.19.0090",
      "rawHtsCode": "3921.19.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.90",
      "rawHtsCode": "3921.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.90.1100",
      "rawHtsCode": "3921.90.11.00",
      "superior": null,
      "indent": "4",
      "description": "Over 70 percent by weight of plastics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.90.1500",
      "rawHtsCode": "3921.90.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,B,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "84.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.90.19",
      "rawHtsCode": "3921.90.19",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.90.1910",
      "rawHtsCode": "3921.90.19.10",
      "superior": null,
      "indent": "4",
      "description": "Products with textile components in which vegetable fibers predominate by weight over any other single textile fiber",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.90.1950",
      "rawHtsCode": "3921.90.19.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.90.2100",
      "rawHtsCode": "3921.90.21.00",
      "superior": null,
      "indent": "3",
      "description": "Products with textile components in which cotton predominates by weight over any other single textile fiber",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.90.25",
      "rawHtsCode": "3921.90.25",
      "superior": null,
      "indent": "3",
      "description": "Products with textile components in which man-made fibers predominate by weight over any other single textile fiber",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH,CL,E*,IL,J*,JO,KR,MA,OM,P,PE,S,SG)",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.90.2510",
      "rawHtsCode": "3921.90.25.10",
      "superior": null,
      "indent": "4",
      "description": "Over 70 percent by weight of plastics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.90.2550",
      "rawHtsCode": "3921.90.25.50",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.90.2900",
      "rawHtsCode": "3921.90.29.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.90.40",
      "rawHtsCode": "3921.90.40",
      "superior": null,
      "indent": "3",
      "description": "Flexible",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See additional U.S. note 4 to this chapter.",
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.90.4010",
      "rawHtsCode": "3921.90.40.10",
      "superior": null,
      "indent": "4",
      "description": "Reinforced with paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.90.4090",
      "rawHtsCode": "3921.90.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.90.50",
      "rawHtsCode": "3921.90.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "42.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See additional U.S. note 4 to this chapter.",
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3921.90.5010",
      "rawHtsCode": "3921.90.50.10",
      "superior": null,
      "indent": "4",
      "description": "High pressure paper reinforced decorative laminates",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3921.90.5050",
      "rawHtsCode": "3921.90.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3922",
      "rawHtsCode": "3922",
      "superior": null,
      "indent": "0",
      "description": "Baths, shower baths, sinks, washbasins, bidets, lavatory pans, seats and covers, flushing cisterns and similar sanitary ware, of plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3922.10.0000",
      "rawHtsCode": "3922.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Baths, shower baths, sinks and washbasins",
      "units": [
        "No. and kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "56%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3922.20.0000",
      "rawHtsCode": "3922.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Lavatory seats and covers",
      "units": [
        "No."
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "56%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3922.90.0000",
      "rawHtsCode": "3922.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No. and kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "56%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3923",
      "rawHtsCode": "3923",
      "superior": null,
      "indent": "0",
      "description": "Articles for the conveyance or packing of goods, of plastics; stoppers, lids, caps and other closures, of plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.10",
      "rawHtsCode": "3923.10",
      "superior": null,
      "indent": "1",
      "description": "Boxes, cases, crates and similar articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.10.2000",
      "rawHtsCode": "3923.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Specially shaped or fitted for the conveyance or packing of semiconductor wafers, masks or reticles of subheadings 3923.10 or 8486.90",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3923.10.9000",
      "rawHtsCode": "3923.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3923.21.00",
      "rawHtsCode": "3923.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of polymers of ethylene",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3923.21.0011",
      "rawHtsCode": "3923.21.00.11",
      "superior": null,
      "indent": "4",
      "description": "With no single side exceeding 75 mm in length",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.21.0020",
      "rawHtsCode": "3923.21.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other, with sliders that open or close the seal",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.21.0030",
      "rawHtsCode": "3923.21.00.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.21.0080",
      "rawHtsCode": "3923.21.00.80",
      "superior": null,
      "indent": "4",
      "description": "With no single side exceeding 75 mm in length",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.21.0085",
      "rawHtsCode": "3923.21.00.85",
      "superior": null,
      "indent": "4",
      "description": "Polyethylene retail carrier bags (PRCBs) with handles (including drawstrings), with no length or width shorter than 6 inches (152.4 mm) or longer than 40 inches (1,016 mm)",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.21.0095",
      "rawHtsCode": "3923.21.00.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "3923.29.0000",
      "rawHtsCode": "3923.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of other plastics",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3923.30.00",
      "rawHtsCode": "3923.30.00",
      "superior": null,
      "indent": "1",
      "description": "Carboys, bottles, flasks and similar articles",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3923.30.0010",
      "rawHtsCode": "3923.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of a capacity not exceeding 50 ml",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.30.0090",
      "rawHtsCode": "3923.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.40.00",
      "rawHtsCode": "3923.40.00",
      "superior": null,
      "indent": "1",
      "description": "Spools, cops, bobbins and similar supports",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3923.40.0010",
      "rawHtsCode": "3923.40.00.10",
      "superior": null,
      "indent": "2",
      "description": "Photographic film reels and reel cans",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.40.0050",
      "rawHtsCode": "3923.40.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.50.0000",
      "rawHtsCode": "3923.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Stoppers, lids, caps and other closures",
      "units": [
        "No. and kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3923.90.00",
      "rawHtsCode": "3923.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3923.90.0012",
      "rawHtsCode": "3923.90.00.12",
      "superior": null,
      "indent": "3",
      "description": "Less than 11.36 liters (3 gallons)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.90.0014",
      "rawHtsCode": "3923.90.00.14",
      "superior": null,
      "indent": "3",
      "description": "11.36 liters (3 gallons) or more, but not more than 22.71 liters (6 gallons)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.90.0016",
      "rawHtsCode": "3923.90.00.16",
      "superior": null,
      "indent": "3",
      "description": "22.71 liters (6 gallons) or more",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3923.90.0080",
      "rawHtsCode": "3923.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No. and kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3924",
      "rawHtsCode": "3924",
      "superior": null,
      "indent": "0",
      "description": "Tableware, kitchenware, other household articles and hygienic or toilet articles, of plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3924.10",
      "rawHtsCode": "3924.10",
      "superior": null,
      "indent": "1",
      "description": "Tableware and kitchenware:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3924.10.1000",
      "rawHtsCode": "3924.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Salt, pepper, mustard and ketchup dispensers and similar dispensers",
      "units": [
        "No. and kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3924.10.2000",
      "rawHtsCode": "3924.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Plates, cups, saucers, soup bowls, cereal bowls, sugar bowls, creamers, gravy boats, serving dishes and platters",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "84.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3924.10.3000",
      "rawHtsCode": "3924.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Trays",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3924.10.4000",
      "rawHtsCode": "3924.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No. and kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3924.90",
      "rawHtsCode": "3924.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3924.90.0500",
      "rawHtsCode": "3924.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "Nursing nipples and finger cots",
      "units": [
        "gross"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3924.90.10",
      "rawHtsCode": "3924.90.10",
      "superior": null,
      "indent": "2",
      "description": "Curtains and drapes, including panels and valances; napkins, table covers, mats, scarves, runners, doilies, centerpieces, antimacassars and furniture slipcovers; and like furnishings",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3924.90.1010",
      "rawHtsCode": "3924.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Curtains and drapes",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3924.90.1050",
      "rawHtsCode": "3924.90.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No. and kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3924.90.2000",
      "rawHtsCode": "3924.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Picture frames",
      "units": [
        "No. and kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3924.90.56",
      "rawHtsCode": "3924.90.56",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3924.90.5610",
      "rawHtsCode": "3924.90.56.10",
      "superior": null,
      "indent": "3",
      "description": "Gates for confining children or pets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3924.90.5650",
      "rawHtsCode": "3924.90.56.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No. and kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3925",
      "rawHtsCode": "3925",
      "superior": null,
      "indent": "0",
      "description": "Builders' ware of plastics, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3925.10.0000",
      "rawHtsCode": "3925.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Reservoirs, tanks, vats and similar containers, of a capacity exceeding 300 liters",
      "units": [
        "No. and kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "56%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3925.20.00",
      "rawHtsCode": "3925.20.00",
      "superior": null,
      "indent": "1",
      "description": "Doors, windows and their frames and thresholds for doors",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3925.20.0010",
      "rawHtsCode": "3925.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Doors and door frames",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3925.20.0020",
      "rawHtsCode": "3925.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Windows and window frames",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3925.20.0091",
      "rawHtsCode": "3925.20.00.91",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No. and kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3925.30",
      "rawHtsCode": "3925.30",
      "superior": null,
      "indent": "1",
      "description": "Shutters, blinds (including venetian blinds) and similar articles and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3925.30.1000",
      "rawHtsCode": "3925.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Blinds (including venetian blinds)",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3925.30.5000",
      "rawHtsCode": "3925.30.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No. and kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3925.90.0000",
      "rawHtsCode": "3925.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No. and kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926",
      "rawHtsCode": "3926",
      "superior": null,
      "indent": "0",
      "description": "Other articles of plastics and articles of other materials of headings 3901 to 3914:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.10.0000",
      "rawHtsCode": "3926.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Office or school supplies",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.20",
      "rawHtsCode": "3926.20",
      "superior": null,
      "indent": "1",
      "description": "Articles of apparel and clothing accessories (including gloves, mittens and mitts):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.20.10",
      "rawHtsCode": "3926.20.10",
      "superior": null,
      "indent": "3",
      "description": "Seamless",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.20.1010",
      "rawHtsCode": "3926.20.10.10",
      "superior": null,
      "indent": "4",
      "description": "Surgical and medical",
      "units": [
        "doz. prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.20.1020",
      "rawHtsCode": "3926.20.10.20",
      "superior": null,
      "indent": "5",
      "description": "Disposable",
      "units": [
        "doz. prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.20.1050",
      "rawHtsCode": "3926.20.10.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "doz. prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.20.2000",
      "rawHtsCode": "3926.20.20.00",
      "superior": null,
      "indent": "5",
      "description": "Baseball and softball gloves and mitts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3926.20.3000",
      "rawHtsCode": "3926.20.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.20.40",
      "rawHtsCode": "3926.20.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.20.4010",
      "rawHtsCode": "3926.20.40.10",
      "superior": null,
      "indent": "5",
      "description": "Disposable",
      "units": [
        "doz. prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.20.4050",
      "rawHtsCode": "3926.20.40.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "doz. prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.20.6000",
      "rawHtsCode": "3926.20.60.00",
      "superior": null,
      "indent": "3",
      "description": "Plastic rainwear, including jackets, coats, ponchos, parkas and slickers, featuring an outer shell of polyvinyl chloride plastic with or without attached hoods, valued not over $10 per unit",
      "units": [
        "doz."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "3926.20.90",
      "rawHtsCode": "3926.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.20.9010",
      "rawHtsCode": "3926.20.90.10",
      "superior": null,
      "indent": "4",
      "description": "Aprons",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.20.9050",
      "rawHtsCode": "3926.20.90.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.30",
      "rawHtsCode": "3926.30",
      "superior": null,
      "indent": "1",
      "description": "Fittings for furniture, coachwork or the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.30.1000",
      "rawHtsCode": "3926.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Handles and knobs",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.25% (JP)",
      "otherRate": "57.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.30.5000",
      "rawHtsCode": "3926.30.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.65% (JP)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.40.00",
      "rawHtsCode": "3926.40.00",
      "superior": null,
      "indent": "1",
      "description": "Statuettes and other ornamental articles",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.40.0010",
      "rawHtsCode": "3926.40.00.10",
      "superior": null,
      "indent": "2",
      "description": "Bows and similar products for decorative purposes including gift-packaging and the like",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.40.0090",
      "rawHtsCode": "3926.40.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90",
      "rawHtsCode": "3926.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.1000",
      "rawHtsCode": "3926.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Buckets and pails",
      "units": [
        "No."
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.1600",
      "rawHtsCode": "3926.90.16.00",
      "superior": null,
      "indent": "2",
      "description": "Pacifiers",
      "units": [
        "gross"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.2100",
      "rawHtsCode": "3926.90.21.00",
      "superior": null,
      "indent": "2",
      "description": "Ice bags; douche bags, enema bags, hot water bottles, and fittings therefor; invalid and similar nursing cushions; dress shields; pessaries; prophylactics; bulbs for syringes; syringes (other than hypodermic syringes) and fittings therefor, not in part of glass or metal",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.2500",
      "rawHtsCode": "3926.90.25.00",
      "superior": null,
      "indent": "2",
      "description": "Handles and knobs, not elsewhere specified or included, of plastics",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "57.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.3000",
      "rawHtsCode": "3926.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Parts for yachts or pleasure boats of heading 8903; parts of canoes, racing shells, pneumatic craft and pleasure boats which are not of a type designed to be principally used with motors or sails",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.3300",
      "rawHtsCode": "3926.90.33.00",
      "superior": null,
      "indent": "3",
      "description": "Handbags",
      "units": [
        "No."
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.3500",
      "rawHtsCode": "3926.90.35.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.4000",
      "rawHtsCode": "3926.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Imitation gemstones",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.45",
      "rawHtsCode": "3926.90.45",
      "superior": null,
      "indent": "2",
      "description": "Gaskets, washers and other seals",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.4510",
      "rawHtsCode": "3926.90.45.10",
      "superior": null,
      "indent": "3",
      "description": "O-Rings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.4590",
      "rawHtsCode": "3926.90.45.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.4800",
      "rawHtsCode": "3926.90.48.00",
      "superior": null,
      "indent": "2",
      "description": "Photo albums",
      "units": [
        "No."
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.5000",
      "rawHtsCode": "3926.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Frames or mounts for photographic slides",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.5500",
      "rawHtsCode": "3926.90.55.00",
      "superior": null,
      "indent": "4",
      "description": "V-belts",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.5600",
      "rawHtsCode": "3926.90.56.00",
      "superior": null,
      "indent": "5",
      "description": "With textile components in which vegetable fibers predominate by weight over any other textile fiber",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.5700",
      "rawHtsCode": "3926.90.57.00",
      "superior": null,
      "indent": "5",
      "description": "With textile components in which man-made fibers predominate by weight over any other textile fiber",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.5900",
      "rawHtsCode": "3926.90.59.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.60",
      "rawHtsCode": "3926.90.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.6010",
      "rawHtsCode": "3926.90.60.10",
      "superior": null,
      "indent": "4",
      "description": "Synchronous belts",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.6090",
      "rawHtsCode": "3926.90.60.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.65",
      "rawHtsCode": "3926.90.65",
      "superior": null,
      "indent": "3",
      "description": "Spring type",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8.4%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.6510",
      "rawHtsCode": "3926.90.65.10",
      "superior": null,
      "indent": "4",
      "description": "Valued not over 80 cents per gross",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.6520",
      "rawHtsCode": "3926.90.65.20",
      "superior": null,
      "indent": "4",
      "description": "Valued over 80 cents but not over $1.35 per gross",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.6530",
      "rawHtsCode": "3926.90.65.30",
      "superior": null,
      "indent": "4",
      "description": "Valued over $1.35 but not over $1.70 per gross",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.6550",
      "rawHtsCode": "3926.90.65.50",
      "superior": null,
      "indent": "4",
      "description": "Valued over $1.70 per gross",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.7000",
      "rawHtsCode": "3926.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.7500",
      "rawHtsCode": "3926.90.75.00",
      "superior": null,
      "indent": "2",
      "description": "Pneumatic mattresses and other inflatable articles, not elsewhere specified or included",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.7700",
      "rawHtsCode": "3926.90.77.00",
      "superior": null,
      "indent": "2",
      "description": "Waterbed mattresses and liners, and parts of the foregoing",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.8300",
      "rawHtsCode": "3926.90.83.00",
      "superior": null,
      "indent": "2",
      "description": "Empty cartridges and cassettes for typewriter and machine ribbons",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.8500",
      "rawHtsCode": "3926.90.85.00",
      "superior": null,
      "indent": "2",
      "description": "Fasteners, in clips suitable for use in a mechanical attaching device",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.8700",
      "rawHtsCode": "3926.90.87.00",
      "superior": null,
      "indent": "2",
      "description": "Flexible plastic document binders with tabs, rolled or flat",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.9400",
      "rawHtsCode": "3926.90.94.00",
      "superior": null,
      "indent": "2",
      "description": "Cards, not punched, suitable for use as, or in making, jacquard cards; Jacquard cards and jacquard heads for power-driven weaving machines, and parts thereof; and Transparent sheeting of plastics containing 30 percent or more by weight of lead",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "3926.90.9600",
      "rawHtsCode": "3926.90.96.00",
      "superior": null,
      "indent": "2",
      "description": "Casing for bicycle derailleur cables; and casing for cable or inner wire for caliper and cantilever brakes, whether or not cut to length",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "3926.90.99",
      "rawHtsCode": "3926.90.99",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "3926.90.9905",
      "rawHtsCode": "3926.90.99.05",
      "superior": null,
      "indent": "3",
      "description": "Elastic bands made wholly of plastics",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.9910",
      "rawHtsCode": "3926.90.99.10",
      "superior": null,
      "indent": "3",
      "description": "Laboratory ware",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "3926.90.9925",
      "rawHtsCode": "3926.90.99.25",
      "superior": null,
      "indent": "3",
      "description": "Reflective triangular warning signs for road use",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.9930",
      "rawHtsCode": "3926.90.99.30",
      "superior": null,
      "indent": "3",
      "description": "Ladders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.9940",
      "rawHtsCode": "3926.90.99.40",
      "superior": null,
      "indent": "3",
      "description": "Covers, rings and frames for manholes; catch basins; drainage gates and frames thereof; cleanout covers and frames thereof; valve, service and meter boxes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.9950",
      "rawHtsCode": "3926.90.99.50",
      "superior": null,
      "indent": "3",
      "description": "Face masks and shields, medical positioning or transport pads, medical waste containers or disinfectant wipes dispensers",
      "units": [
        "No. and kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.9987",
      "rawHtsCode": "3926.90.99.87",
      "superior": null,
      "indent": "3",
      "description": "Rigid tubes or pipes suitable for use as electrical conduit",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "3926.90.9989",
      "rawHtsCode": "3926.90.99.89",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No. and kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "4001",
      "rawHtsCode": "4001",
      "superior": null,
      "indent": "0",
      "description": "Natural rubber, balata, gutta-percha, guayule, chicle and similar natural gums, in primary forms or in plates, sheets or strip:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.10.0000",
      "rawHtsCode": "4001.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Natural rubber latex, whether or not pre-vulcanized",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "Kilograms dry rubber content.",
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4001.21.00",
      "rawHtsCode": "4001.21.00",
      "superior": null,
      "indent": "2",
      "description": "Smoked sheets",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4001.21.0010",
      "rawHtsCode": "4001.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Grade 1",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.21.0020",
      "rawHtsCode": "4001.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Grade 2",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.21.0030",
      "rawHtsCode": "4001.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Grade 3",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.21.0050",
      "rawHtsCode": "4001.21.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.22.00",
      "rawHtsCode": "4001.22.00",
      "superior": null,
      "indent": "2",
      "description": "Technically specified natural rubber (TSNR)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4001.22.0005",
      "rawHtsCode": "4001.22.00.05",
      "superior": null,
      "indent": "3",
      "description": "Grade 5",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.22.0010",
      "rawHtsCode": "4001.22.00.10",
      "superior": null,
      "indent": "3",
      "description": "Grade CV",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.22.0015",
      "rawHtsCode": "4001.22.00.15",
      "superior": null,
      "indent": "3",
      "description": "Grade L",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.22.0020",
      "rawHtsCode": "4001.22.00.20",
      "superior": null,
      "indent": "3",
      "description": "Grade 10",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.22.0025",
      "rawHtsCode": "4001.22.00.25",
      "superior": null,
      "indent": "3",
      "description": "Grade 20",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.22.0050",
      "rawHtsCode": "4001.22.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.29.0000",
      "rawHtsCode": "4001.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4001.30.00",
      "rawHtsCode": "4001.30.00",
      "superior": null,
      "indent": "1",
      "description": "Balata, gutta-percha, guayule, chicle and similar natural gums",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4001.30.0005",
      "rawHtsCode": "4001.30.00.05",
      "superior": null,
      "indent": "2",
      "description": "Balata",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.30.0010",
      "rawHtsCode": "4001.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Gutta-percha and guttas, not elsewhere specified or included",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.30.0020",
      "rawHtsCode": "4001.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "Chicle",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4001.30.0055",
      "rawHtsCode": "4001.30.00.55",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4002",
      "rawHtsCode": "4002",
      "superior": null,
      "indent": "0",
      "description": "Synthetic rubber and factice derived from oils, in primary forms or in plates, sheets or strip; mixtures of any product of heading 4001 with any product of this heading, in primary forms or in plates, sheets or strip:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4002.11.0000",
      "rawHtsCode": "4002.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Latex",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4002.19.00",
      "rawHtsCode": "4002.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4002.19.0014",
      "rawHtsCode": "4002.19.00.14",
      "superior": null,
      "indent": "4",
      "description": "Styrene-butadiene-styrene block co- polymers produced by solution polymerization (SBS, thermoplastic elastormers), in granules, crumbs or powders",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4002.19.0015",
      "rawHtsCode": "4002.19.00.15",
      "superior": null,
      "indent": "4",
      "description": "Styrene-butadiene rubber produced by emulsion polymerization (E-SBR) in bales",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4002.19.0016",
      "rawHtsCode": "4002.19.00.16",
      "superior": null,
      "indent": "4",
      "description": "Styrene-butadiene rubber produced by solution polymerization (S-SBR) in bales",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4002.19.0019",
      "rawHtsCode": "4002.19.00.19",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4002.19.0020",
      "rawHtsCode": "4002.19.00.20",
      "superior": null,
      "indent": "3",
      "description": "Containing over 50 percent styrene by weight of the dry polymer",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4002.20.0000",
      "rawHtsCode": "4002.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Butadiene rubber (BR)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4002.31.0000",
      "rawHtsCode": "4002.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Isobutene-isoprene (butyl) rubber (IIR)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4002.39.0000",
      "rawHtsCode": "4002.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4002.41.0000",
      "rawHtsCode": "4002.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Latex",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4002.49.0000",
      "rawHtsCode": "4002.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4002.51.0000",
      "rawHtsCode": "4002.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Latex",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4002.59.0000",
      "rawHtsCode": "4002.59.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4002.60.0000",
      "rawHtsCode": "4002.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Isoprene rubber (IR)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4002.70.0000",
      "rawHtsCode": "4002.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ethylene-propylene-nonconjugated diene rubber (EPDM)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4002.80.0000",
      "rawHtsCode": "4002.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mixtures of any product of heading 4001 with any product of this heading",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4002.91.0000",
      "rawHtsCode": "4002.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Latex",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4002.99.0000",
      "rawHtsCode": "4002.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4003.00.0000",
      "rawHtsCode": "4003.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Reclaimed rubber in primary forms or in plates, sheets or strip",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4004.00.0000",
      "rawHtsCode": "4004.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Waste, parings and scrap of rubber (other than hard rubber) and powders and granules obtained therefrom",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4005",
      "rawHtsCode": "4005",
      "superior": null,
      "indent": "0",
      "description": "Compounded rubber, unvulcanized, in primary forms or in plates, sheets or strip:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4005.10.0000",
      "rawHtsCode": "4005.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Compounded with carbon black or silica",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4005.20.0000",
      "rawHtsCode": "4005.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Solutions; dispersions other than those of subheading 4005.10",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4005.91.0000",
      "rawHtsCode": "4005.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Plates, sheets, and strip",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4005.99.0000",
      "rawHtsCode": "4005.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4006",
      "rawHtsCode": "4006",
      "superior": null,
      "indent": "0",
      "description": "Other forms (for example, rods, tubes and profile shapes) and articles (for example, discs and rings), of unvulcanized rubber:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4006.10.0000",
      "rawHtsCode": "4006.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "\"Camel-back\" strips for retreading rubber tires",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4006.90",
      "rawHtsCode": "4006.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4006.90.1000",
      "rawHtsCode": "4006.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of natural rubber",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4006.90.5000",
      "rawHtsCode": "4006.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4007.00.0000",
      "rawHtsCode": "4007.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Vulcanized rubber thread and cord",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4008",
      "rawHtsCode": "4008",
      "superior": null,
      "indent": "0",
      "description": "Plates, sheets, strip, rods and profile shapes, of vulcanized rubber other than hard rubber:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4008.11",
      "rawHtsCode": "4008.11",
      "superior": null,
      "indent": "2",
      "description": "Plates, sheets and strip:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4008.11.1000",
      "rawHtsCode": "4008.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of natural rubber",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4008.11.5000",
      "rawHtsCode": "4008.11.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4008.19",
      "rawHtsCode": "4008.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4008.19.2000",
      "rawHtsCode": "4008.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "Profile shapes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4008.19.4000",
      "rawHtsCode": "4008.19.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4008.19.6000",
      "rawHtsCode": "4008.19.60.00",
      "superior": null,
      "indent": "4",
      "description": "Profile shapes",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4008.19.8000",
      "rawHtsCode": "4008.19.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4008.21.0000",
      "rawHtsCode": "4008.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Plates, sheets and strip",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4008.29",
      "rawHtsCode": "4008.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4008.29.2000",
      "rawHtsCode": "4008.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Profile shapes",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.",
        "See additional U.S. note 1 to this chapter.",
        "See additional U.S. note 2 to this chapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4008.29.4000",
      "rawHtsCode": "4008.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.",
        "See additional U.S. note 1 to this chapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4009",
      "rawHtsCode": "4009",
      "superior": null,
      "indent": "0",
      "description": "Tubes, pipes and hoses, of vulcanized rubber other than hard rubber, with or without their fittings (for example, joints, elbows, flanges):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4009.11.0000",
      "rawHtsCode": "4009.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Without fittings",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4009.12.00",
      "rawHtsCode": "4009.12.00",
      "superior": null,
      "indent": "2",
      "description": "With fittings",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4009.12.0020",
      "rawHtsCode": "4009.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Brake hoses for the vehicles of subheadings 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or headings 8702, 8703, 8704, 8705 or 8711",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4009.12.0050",
      "rawHtsCode": "4009.12.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4009.21.0000",
      "rawHtsCode": "4009.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Without fittings",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4009.22.00",
      "rawHtsCode": "4009.22.00",
      "superior": null,
      "indent": "2",
      "description": "With fittings",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4009.22.0020",
      "rawHtsCode": "4009.22.00.20",
      "superior": null,
      "indent": "3",
      "description": "Brake hoses for the vehicles of subheadings 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or headings 8702, 8703, 8704, 8705 or 8711",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4009.22.0050",
      "rawHtsCode": "4009.22.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4009.31.0000",
      "rawHtsCode": "4009.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Without fittings",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4009.32.00",
      "rawHtsCode": "4009.32.00",
      "superior": null,
      "indent": "2",
      "description": "With fittings",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4009.32.0020",
      "rawHtsCode": "4009.32.00.20",
      "superior": null,
      "indent": "3",
      "description": "Brake hoses for the vehicles of subheadings 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or headings 8702, 8703, 8704, 8705 or 8711",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4009.32.0050",
      "rawHtsCode": "4009.32.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4009.41.0000",
      "rawHtsCode": "4009.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Without fittings",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4009.42.00",
      "rawHtsCode": "4009.42.00",
      "superior": null,
      "indent": "2",
      "description": "With fittings",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4009.42.0020",
      "rawHtsCode": "4009.42.00.20",
      "superior": null,
      "indent": "3",
      "description": "Brake hoses for the vehicles of subheadings 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or headings 8702, 8703, 8704, 8705 or 8711",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4009.42.0050",
      "rawHtsCode": "4009.42.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4010",
      "rawHtsCode": "4010",
      "superior": null,
      "indent": "0",
      "description": "Conveyor or transmission belts or belting, of vulcanized rubber:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4010.11.0000",
      "rawHtsCode": "4010.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Reinforced only with metal",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.12",
      "rawHtsCode": "4010.12",
      "superior": null,
      "indent": "2",
      "description": "Reinforced only with textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4010.12.1000",
      "rawHtsCode": "4010.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "With textile components in which vegetable fibers predominate by weight over any other single textile fiber",
      "units": [
        "kg"
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.12.5000",
      "rawHtsCode": "4010.12.50.00",
      "superior": null,
      "indent": "4",
      "description": "Of a width exceeding 20 cm",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.12.5500",
      "rawHtsCode": "4010.12.55.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.12.9000",
      "rawHtsCode": "4010.12.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.19",
      "rawHtsCode": "4010.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4010.19.1000",
      "rawHtsCode": "4010.19.10.00",
      "superior": null,
      "indent": "4",
      "description": "With textile components in which vegetable fibers predominate by weight over any other single textile fiber",
      "units": [
        "kg"
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.19.5000",
      "rawHtsCode": "4010.19.50.00",
      "superior": null,
      "indent": "5",
      "description": "Of a width exceeding 20 cm",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.19.5500",
      "rawHtsCode": "4010.19.55.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.19.8000",
      "rawHtsCode": "4010.19.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.19.9100",
      "rawHtsCode": "4010.19.91.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.31",
      "rawHtsCode": "4010.31",
      "superior": null,
      "indent": "2",
      "description": "Endless transmission belts of trapezoidal cross section (V-belts),V-ribbed, of an outside circumference exceeding 60 cm but not exceeding 180 cm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4010.31.3000",
      "rawHtsCode": "4010.31.30.00",
      "superior": null,
      "indent": "3",
      "description": "Combined with textile materials",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.31.6000",
      "rawHtsCode": "4010.31.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.32",
      "rawHtsCode": "4010.32",
      "superior": null,
      "indent": "2",
      "description": "Endless transmission belts of trapezoidal cross section (V-belts), other than V-ribbed, of an outside circumference exceeding 60 cm but not exceeding 180 cm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4010.32.3000",
      "rawHtsCode": "4010.32.30.00",
      "superior": null,
      "indent": "3",
      "description": "Combined with textile materials",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.32.6000",
      "rawHtsCode": "4010.32.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.33",
      "rawHtsCode": "4010.33",
      "superior": null,
      "indent": "2",
      "description": "Endless transmission belts of trapezoidal cross section (V-belts), V-ribbed, of an outside circumference exceeding 180 cm but not exceeding 240 cm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4010.33.3000",
      "rawHtsCode": "4010.33.30.00",
      "superior": null,
      "indent": "3",
      "description": "Combined with textile materials",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.33.6000",
      "rawHtsCode": "4010.33.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.34",
      "rawHtsCode": "4010.34",
      "superior": null,
      "indent": "2",
      "description": "Endless transmission belts of trapezoidal cross section (V-belts), other thanV-ribbed, of an outside circumference exceeding 180 cm but not exceeding 240 cm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4010.34.3000",
      "rawHtsCode": "4010.34.30.00",
      "superior": null,
      "indent": "3",
      "description": "Combined with textile materials",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.34.6000",
      "rawHtsCode": "4010.34.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.35",
      "rawHtsCode": "4010.35",
      "superior": null,
      "indent": "2",
      "description": "Endless synchronous belts of an outside circumference exceeding 60 cm but not exceeding 150 cm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4010.35.3000",
      "rawHtsCode": "4010.35.30.00",
      "superior": null,
      "indent": "4",
      "description": "With textile components in which vegetable fibers predominate by weight over any other single textile fiber",
      "units": [
        "kg"
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.35.4100",
      "rawHtsCode": "4010.35.41.00",
      "superior": null,
      "indent": "5",
      "description": "Of a width exceeding 20 cm",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.35.4500",
      "rawHtsCode": "4010.35.45.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.35.5000",
      "rawHtsCode": "4010.35.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.35.9000",
      "rawHtsCode": "4010.35.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.36",
      "rawHtsCode": "4010.36",
      "superior": null,
      "indent": "2",
      "description": "Endless synchronous belts of an outside circumference exceeding 150 cm but not exceeding 198 cm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4010.36.3000",
      "rawHtsCode": "4010.36.30.00",
      "superior": null,
      "indent": "4",
      "description": "With textile components in which vegetable fibers predominate by weight over any other single textile fiber",
      "units": [
        "kg"
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.36.4100",
      "rawHtsCode": "4010.36.41.00",
      "superior": null,
      "indent": "5",
      "description": "Of a width exceeding 20 cm",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.36.4500",
      "rawHtsCode": "4010.36.45.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.36.5000",
      "rawHtsCode": "4010.36.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.36.9000",
      "rawHtsCode": "4010.36.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.39",
      "rawHtsCode": "4010.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4010.39.1000",
      "rawHtsCode": "4010.39.10.00",
      "superior": null,
      "indent": "4",
      "description": "Combined with textile materials:",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.39.2000",
      "rawHtsCode": "4010.39.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.39.3000",
      "rawHtsCode": "4010.39.30.00",
      "superior": null,
      "indent": "5",
      "description": "With textile components in which vegetable fibers predominate by weight over any other single textile fiber",
      "units": [
        "kg"
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.39.4100",
      "rawHtsCode": "4010.39.41.00",
      "superior": null,
      "indent": "6",
      "description": "Of a width exceeding 20 cm",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.39.4500",
      "rawHtsCode": "4010.39.45.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.39.5000",
      "rawHtsCode": "4010.39.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4010.39.9000",
      "rawHtsCode": "4010.39.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4011",
      "rawHtsCode": "4011",
      "superior": null,
      "indent": "0",
      "description": "New pneumatic tires, of rubber:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.10",
      "rawHtsCode": "4011.10",
      "superior": null,
      "indent": "1",
      "description": "Of a kind used on motor cars (including station wagons and racing cars):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.10.10",
      "rawHtsCode": "4011.10.10",
      "superior": null,
      "indent": "2",
      "description": "Radial",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4011.10.1010",
      "rawHtsCode": "4011.10.10.10",
      "superior": null,
      "indent": "3",
      "description": "Having a rim diameter of 33.02 cm (13 inches) or less",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.10.1020",
      "rawHtsCode": "4011.10.10.20",
      "superior": null,
      "indent": "3",
      "description": "Having a rim diameter greater than <il>33.02 cm (13 inches)</il> but not more than <il>35.56 cm (14 inches)</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.10.1030",
      "rawHtsCode": "4011.10.10.30",
      "superior": null,
      "indent": "3",
      "description": "Having a rim diameter greater than <il>35.56 cm (14 inches)</il> but not more than <il>38.10 cm (15 inches)</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.10.1040",
      "rawHtsCode": "4011.10.10.40",
      "superior": null,
      "indent": "3",
      "description": "Having a rim diameter greater than <il>38.10 cm (15 inches)</il> but not more than <il>40.64 cm (16 inches)</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.10.1050",
      "rawHtsCode": "4011.10.10.50",
      "superior": null,
      "indent": "3",
      "description": "Having a rim diameter greater than <il>40.64 cm (16 inches)</il> but not more than <il>43.18 cm (17 inches)</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.10.1060",
      "rawHtsCode": "4011.10.10.60",
      "superior": null,
      "indent": "3",
      "description": "Having a rim diameter greater than <il>43.18 cm (17 inches)</il> but not more than <il>45.72 cm (18 inches)</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.10.1070",
      "rawHtsCode": "4011.10.10.70",
      "superior": null,
      "indent": "3",
      "description": "Having a rim diameter greater than <il>45.72 cm (18 inches)</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.10.5000",
      "rawHtsCode": "4011.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4011.20",
      "rawHtsCode": "4011.20",
      "superior": null,
      "indent": "1",
      "description": "Of a kind used on buses or trucks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.20.10",
      "rawHtsCode": "4011.20.10",
      "superior": null,
      "indent": "2",
      "description": "Radial",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4011.20.1005",
      "rawHtsCode": "4011.20.10.05",
      "superior": null,
      "indent": "4",
      "description": "Light truck",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.20.1015",
      "rawHtsCode": "4011.20.10.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.20.1025",
      "rawHtsCode": "4011.20.10.25",
      "superior": null,
      "indent": "4",
      "description": "For use on a rim measuring 40.6 cm or more in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.20.1035",
      "rawHtsCode": "4011.20.10.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.20.50",
      "rawHtsCode": "4011.20.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4011.20.5010",
      "rawHtsCode": "4011.20.50.10",
      "superior": null,
      "indent": "4",
      "description": "Light truck",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.20.5020",
      "rawHtsCode": "4011.20.50.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.20.5030",
      "rawHtsCode": "4011.20.50.30",
      "superior": null,
      "indent": "4",
      "description": "For use on a rim measuring <il>40.6 cm</il> or more in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.20.5050",
      "rawHtsCode": "4011.20.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.30.00",
      "rawHtsCode": "4011.30.00",
      "superior": null,
      "indent": "1",
      "description": "Of a kind used on aircraft",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4011.30.0010",
      "rawHtsCode": "4011.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.30.0050",
      "rawHtsCode": "4011.30.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.40.0000",
      "rawHtsCode": "4011.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of a kind used on motorcycles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4011.50.0000",
      "rawHtsCode": "4011.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of a kind used on bicycles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4011.70.00",
      "rawHtsCode": "4011.70.00",
      "superior": null,
      "indent": "1",
      "description": "Of a kind used on agricultural or forestry vehicles and machines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4011.70.0010",
      "rawHtsCode": "4011.70.00.10",
      "superior": null,
      "indent": "2",
      "description": "Having a \"herring-bone\" or similar tread",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.70.0050",
      "rawHtsCode": "4011.70.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.80",
      "rawHtsCode": "4011.80",
      "superior": null,
      "indent": "1",
      "description": "Of a kind used on construction, mining or industrial handling vehicles and machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.80.10",
      "rawHtsCode": "4011.80.10",
      "superior": null,
      "indent": "2",
      "description": "Having a \"herring-bone\" or similar tread",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4011.80.1010",
      "rawHtsCode": "4011.80.10.10",
      "superior": null,
      "indent": "3",
      "description": "Having a rim size not exceeding 61 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.80.1020",
      "rawHtsCode": "4011.80.10.20",
      "superior": null,
      "indent": "3",
      "description": "Having a rim size exceeding 61 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.80.20",
      "rawHtsCode": "4011.80.20",
      "superior": null,
      "indent": "3",
      "description": "Radial",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4011.80.2010",
      "rawHtsCode": "4011.80.20.10",
      "superior": null,
      "indent": "4",
      "description": "Having a rim size not exceeding 61 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.80.2020",
      "rawHtsCode": "4011.80.20.20",
      "superior": null,
      "indent": "4",
      "description": "Having a rim size exceeding 61 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.80.80",
      "rawHtsCode": "4011.80.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4011.80.8010",
      "rawHtsCode": "4011.80.80.10",
      "superior": null,
      "indent": "4",
      "description": "Having a rim size not exceeding 61 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.80.8020",
      "rawHtsCode": "4011.80.80.20",
      "superior": null,
      "indent": "4",
      "description": "Having a rim size exceeding 61 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.90",
      "rawHtsCode": "4011.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.90.10",
      "rawHtsCode": "4011.90.10",
      "superior": null,
      "indent": "2",
      "description": "Having a \"herring-bone\" or similar tread",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4011.90.1010",
      "rawHtsCode": "4011.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used on golf carts, all-terrain vehicles, and for turf, lawn and garden, and trailer applications",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.90.1050",
      "rawHtsCode": "4011.90.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.90.20",
      "rawHtsCode": "4011.90.20",
      "superior": null,
      "indent": "2",
      "description": "Radial",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4011.90.2010",
      "rawHtsCode": "4011.90.20.10",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used on golf carts, all-terrain vehicles, and for turf, lawn and garden, and trailer applications",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.90.2050",
      "rawHtsCode": "4011.90.20.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.90.80",
      "rawHtsCode": "4011.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4011.90.8010",
      "rawHtsCode": "4011.90.80.10",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used on golf carts, all-terrain vehicles, and for turf, lawn and garden, and trailer applications",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4011.90.8050",
      "rawHtsCode": "4011.90.80.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012",
      "rawHtsCode": "4012",
      "superior": null,
      "indent": "0",
      "description": "Retreaded or used pneumatic tires of rubber; solid or cushion tires, tire treads and tire flaps, of rubber:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.11",
      "rawHtsCode": "4012.11",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used on motor cars (including station wagons and racing cars):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.11.4000",
      "rawHtsCode": "4012.11.40.00",
      "superior": null,
      "indent": "3",
      "description": "Radial",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4012.11.8000",
      "rawHtsCode": "4012.11.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4012.12",
      "rawHtsCode": "4012.12",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used on buses or trucks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.12.40",
      "rawHtsCode": "4012.12.40",
      "superior": null,
      "indent": "3",
      "description": "Radial",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4012.12.4015",
      "rawHtsCode": "4012.12.40.15",
      "superior": null,
      "indent": "5",
      "description": "Light truck",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.12.4025",
      "rawHtsCode": "4012.12.40.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.12.4035",
      "rawHtsCode": "4012.12.40.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.12.80",
      "rawHtsCode": "4012.12.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4012.12.8019",
      "rawHtsCode": "4012.12.80.19",
      "superior": null,
      "indent": "5",
      "description": "Light truck",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.12.8029",
      "rawHtsCode": "4012.12.80.29",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.12.8050",
      "rawHtsCode": "4012.12.80.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.13.00",
      "rawHtsCode": "4012.13.00",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used on aircraft",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "4012.13.0010",
      "rawHtsCode": "4012.13.00.10",
      "superior": null,
      "indent": "3",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.13.0050",
      "rawHtsCode": "4012.13.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.19",
      "rawHtsCode": "4012.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.19.2000",
      "rawHtsCode": "4012.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Designed for tractors provided for in subheadings 8701.91.10, 8701.92.10, 8701.93.10, 8701.94.10 or 8701.95.10 or for agricultural or horticultural machinery or implements provided for in chapter 84 or in subheading 8716.80.10",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4012.19.4000",
      "rawHtsCode": "4012.19.40.00",
      "superior": null,
      "indent": "4",
      "description": "Radial",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4012.19.8000",
      "rawHtsCode": "4012.19.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4012.20",
      "rawHtsCode": "4012.20",
      "superior": null,
      "indent": "1",
      "description": "Used pneumatic tires:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.20.10",
      "rawHtsCode": "4012.20.10",
      "superior": null,
      "indent": "2",
      "description": "Aircraft",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4012.20.1010",
      "rawHtsCode": "4012.20.10.10",
      "superior": null,
      "indent": "3",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.20.1050",
      "rawHtsCode": "4012.20.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.20.1500",
      "rawHtsCode": "4012.20.15.00",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used on vehicles, including tractors, for the on-highway transport of passengers or goods",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4012.20.4500",
      "rawHtsCode": "4012.20.45.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4012.20.6000",
      "rawHtsCode": "4012.20.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used on vehicles, including tractors, for the on-highway transport of passengers or goods, or on vehicles of heading 8705",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4012.20.8000",
      "rawHtsCode": "4012.20.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4012.90",
      "rawHtsCode": "4012.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4012.90.1000",
      "rawHtsCode": "4012.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Solid or cushion tires",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4012.90.3000",
      "rawHtsCode": "4012.90.30.00",
      "superior": null,
      "indent": "4",
      "description": "Bicycle rim strips",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4012.90.4500",
      "rawHtsCode": "4012.90.45.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4012.90.7000",
      "rawHtsCode": "4012.90.70.00",
      "superior": null,
      "indent": "4",
      "description": "Bicycle rim strips",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4012.90.9000",
      "rawHtsCode": "4012.90.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4013",
      "rawHtsCode": "4013",
      "superior": null,
      "indent": "0",
      "description": "Inner tubes, of rubber:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4013.10.00",
      "rawHtsCode": "4013.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of a kind used on motor cars (including station wagons and racing cars), buses or trucks",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4013.10.0010",
      "rawHtsCode": "4013.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Motor car",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4013.10.0020",
      "rawHtsCode": "4013.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Truck and bus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4013.20.0000",
      "rawHtsCode": "4013.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of a kind used on bicycles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4013.90",
      "rawHtsCode": "4013.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4013.90.1000",
      "rawHtsCode": "4013.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Designed for tires provided for in subheadings 4011.70.00, 4012.19.20, 4012.20.15 and 4012.20.45",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4013.90.50",
      "rawHtsCode": "4013.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4013.90.5010",
      "rawHtsCode": "4013.90.50.10",
      "superior": null,
      "indent": "3",
      "description": "Motorcycle (including moped)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4013.90.5050",
      "rawHtsCode": "4013.90.50.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4014",
      "rawHtsCode": "4014",
      "superior": null,
      "indent": "0",
      "description": "Hygienic or pharmaceutical articles (including nursing nipples), of vulcanized rubber other than hard rubber, with or without fittings of hard rubber:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4014.10.0000",
      "rawHtsCode": "4014.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sheath contraceptives",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4014.90",
      "rawHtsCode": "4014.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4014.90.1000",
      "rawHtsCode": "4014.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Nursing nipples",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4014.90.5000",
      "rawHtsCode": "4014.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4015",
      "rawHtsCode": "4015",
      "superior": null,
      "indent": "0",
      "description": "Articles of apparel and clothing accessories (including gloves, mittens and mitts), for all purposes, of vulcanized rubber other than hard rubber:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4015.12",
      "rawHtsCode": "4015.12",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used for medical, surgical, dental or veterinary purposes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4015.12.10",
      "rawHtsCode": "4015.12.10",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used for medical or surgical purposes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4015.12.1010",
      "rawHtsCode": "4015.12.10.10",
      "superior": null,
      "indent": "4",
      "description": "Medical gloves, mittens and mitts",
      "units": [
        "doz. prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4015.12.1020",
      "rawHtsCode": "4015.12.10.20",
      "superior": null,
      "indent": "4",
      "description": "Surgical gloves, mittens and mitts",
      "units": [
        "doz. prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4015.12.9000",
      "rawHtsCode": "4015.12.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "doz. prs."
      ],
      "generalRate": "14%",
      "specialRate": "Free  (A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4015.19",
      "rawHtsCode": "4015.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4015.19.11",
      "rawHtsCode": "4015.19.11",
      "superior": null,
      "indent": "3",
      "description": "Seamless",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free \n(A, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM, P,PA, PE, S, SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4015.19.1110",
      "rawHtsCode": "4015.19.11.10",
      "superior": null,
      "indent": "4",
      "description": "Disposable",
      "units": [
        "doz. prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4015.19.1150",
      "rawHtsCode": "4015.19.11.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "doz. prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4015.19.5100",
      "rawHtsCode": "4015.19.51.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "doz. prs."
      ],
      "generalRate": "14%",
      "specialRate": "Free(A+, AU, BH, CL, CO, D, E, IL, JO, KR, MA, OM,P, PA, PE, S, SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4015.90.00",
      "rawHtsCode": "4015.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4015.90.0010",
      "rawHtsCode": "4015.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Aprons",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4015.90.0050",
      "rawHtsCode": "4015.90.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016",
      "rawHtsCode": "4016",
      "superior": null,
      "indent": "0",
      "description": "Other articles of vulcanized rubber other than hard rubber:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016.10.0000",
      "rawHtsCode": "4016.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of cellular rubber",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4016.91.0000",
      "rawHtsCode": "4016.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Floor coverings and mats",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.92.0000",
      "rawHtsCode": "4016.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Erasers",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.93",
      "rawHtsCode": "4016.93",
      "superior": null,
      "indent": "2",
      "description": "Gaskets, washers and other seals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016.93.10",
      "rawHtsCode": "4016.93.10",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used in the automotive goods of chapter 87",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.93.1010",
      "rawHtsCode": "4016.93.10.10",
      "superior": null,
      "indent": "4",
      "description": "O-Rings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016.93.1020",
      "rawHtsCode": "4016.93.10.20",
      "superior": null,
      "indent": "4",
      "description": "Oil seals",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016.93.1050",
      "rawHtsCode": "4016.93.10.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016.93.50",
      "rawHtsCode": "4016.93.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.93.5010",
      "rawHtsCode": "4016.93.50.10",
      "superior": null,
      "indent": "4",
      "description": "O-Rings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016.93.5020",
      "rawHtsCode": "4016.93.50.20",
      "superior": null,
      "indent": "4",
      "description": "Oil seals",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016.93.5050",
      "rawHtsCode": "4016.93.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016.94.0000",
      "rawHtsCode": "4016.94.00.00",
      "superior": null,
      "indent": "2",
      "description": "Boat or dock fenders, whether or not inflatable",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.95.0000",
      "rawHtsCode": "4016.95.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other inflatable articles",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.99",
      "rawHtsCode": "4016.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016.99.0300",
      "rawHtsCode": "4016.99.03.00",
      "superior": null,
      "indent": "3",
      "description": "Containers, with or without their closures, of a kind used for the packing, transporting or marketing of merchandise",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.99.0500",
      "rawHtsCode": "4016.99.05.00",
      "superior": null,
      "indent": "3",
      "description": "Household articles not elsewhere specified or included",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.99.1000",
      "rawHtsCode": "4016.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Handles and knobs",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "57.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.99.1500",
      "rawHtsCode": "4016.99.15.00",
      "superior": null,
      "indent": "3",
      "description": "Caps, lids, seals, stoppers and other closures",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.99.2000",
      "rawHtsCode": "4016.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Toys for pets",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.99.3000",
      "rawHtsCode": "4016.99.30.00",
      "superior": null,
      "indent": "5",
      "description": "Vibration control goods of a kind used in the vehicles of headings 8701 through 8705",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4016.99.35",
      "rawHtsCode": "4016.99.35",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4016.99.3510",
      "rawHtsCode": "4016.99.35.10",
      "superior": null,
      "indent": "6",
      "description": "Rubber bands",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016.99.3550",
      "rawHtsCode": "4016.99.35.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016.99.5500",
      "rawHtsCode": "4016.99.55.00",
      "superior": null,
      "indent": "5",
      "description": "Vibration control goods of a kind used in the vehicles of headings 8701 through 8705",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.99.60",
      "rawHtsCode": "4016.99.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4016.99.6010",
      "rawHtsCode": "4016.99.60.10",
      "superior": null,
      "indent": "6",
      "description": "Mechanical articles for motor vehicles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4016.99.6050",
      "rawHtsCode": "4016.99.60.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4017.00.0000",
      "rawHtsCode": "4017.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Hard rubber (for example, ebonite) in all forms, including waste and scrap; articles of hard rubber",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See additional U.S. note 3 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101",
      "rawHtsCode": "4101",
      "superior": null,
      "indent": "0",
      "description": "Raw hides and skins of bovine (including buffalo) or equine animals (fresh, or salted, dried, limed, pickled or otherwise preserved, but not tanned, parchment-dressed or further prepared), whether or not dehaired or split:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.20",
      "rawHtsCode": "4101.20",
      "superior": null,
      "indent": "1",
      "description": "Whole hides and skins, unsplit, of a weight per skin not exceeding 8 kg when simply dried, 10 kg when dry-salted, or 16 kg when fresh, wet-salted or otherwise preserved:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.20.10",
      "rawHtsCode": "4101.20.10",
      "superior": null,
      "indent": "2",
      "description": "Not pretanned",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4101.20.1010",
      "rawHtsCode": "4101.20.10.10",
      "superior": null,
      "indent": "3",
      "description": "Of bovine animals",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.20.1020",
      "rawHtsCode": "4101.20.10.20",
      "superior": null,
      "indent": "3",
      "description": "Of equine animals",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.20.2000",
      "rawHtsCode": "4101.20.20.00",
      "superior": null,
      "indent": "5",
      "description": "Upper and lining",
      "units": [
        "pcs"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4101.20.3000",
      "rawHtsCode": "4101.20.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.20.3500",
      "rawHtsCode": "4101.20.35.00",
      "superior": null,
      "indent": "5",
      "description": "Of buffalo",
      "units": [
        "pcs"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.20.4000",
      "rawHtsCode": "4101.20.40.00",
      "superior": null,
      "indent": "6",
      "description": "Vegetable pretanned",
      "units": [
        "pcs"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.20.5000",
      "rawHtsCode": "4101.20.50.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.20.7000",
      "rawHtsCode": "4101.20.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.50",
      "rawHtsCode": "4101.50",
      "superior": null,
      "indent": "1",
      "description": "Whole hides and skins, of a weight exceeding 16 kg:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.50.10",
      "rawHtsCode": "4101.50.10",
      "superior": null,
      "indent": "2",
      "description": "Not pretanned",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4101.50.1010",
      "rawHtsCode": "4101.50.10.10",
      "superior": null,
      "indent": "4",
      "description": "Cattle",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.50.1020",
      "rawHtsCode": "4101.50.10.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.50.1091",
      "rawHtsCode": "4101.50.10.91",
      "superior": null,
      "indent": "3",
      "description": "Of equine animals",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.50.2000",
      "rawHtsCode": "4101.50.20.00",
      "superior": null,
      "indent": "5",
      "description": "Upper and lining",
      "units": [
        "pcs"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4101.50.3000",
      "rawHtsCode": "4101.50.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.50.3500",
      "rawHtsCode": "4101.50.35.00",
      "superior": null,
      "indent": "5",
      "description": "Of buffalo",
      "units": [
        "pcs"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.50.4000",
      "rawHtsCode": "4101.50.40.00",
      "superior": null,
      "indent": "6",
      "description": "Vegetable pretanned",
      "units": [
        "pcs"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.50.5000",
      "rawHtsCode": "4101.50.50.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.50.7000",
      "rawHtsCode": "4101.50.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.90",
      "rawHtsCode": "4101.90",
      "superior": null,
      "indent": "1",
      "description": "Other, including butts, bends and bellies:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.90.10",
      "rawHtsCode": "4101.90.10",
      "superior": null,
      "indent": "2",
      "description": "Not pretanned",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4101.90.1010",
      "rawHtsCode": "4101.90.10.10",
      "superior": null,
      "indent": "5",
      "description": "Butts and bends",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.90.1020",
      "rawHtsCode": "4101.90.10.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.90.1030",
      "rawHtsCode": "4101.90.10.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.90.1040",
      "rawHtsCode": "4101.90.10.40",
      "superior": null,
      "indent": "3",
      "description": "Of equine animals",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4101.90.3500",
      "rawHtsCode": "4101.90.35.00",
      "superior": null,
      "indent": "4",
      "description": "Of buffalo",
      "units": [
        "pcs"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.90.4000",
      "rawHtsCode": "4101.90.40.00",
      "superior": null,
      "indent": "5",
      "description": "Vegetable pretanned",
      "units": [
        "pcs"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.90.5000",
      "rawHtsCode": "4101.90.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4101.90.7000",
      "rawHtsCode": "4101.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4102",
      "rawHtsCode": "4102",
      "superior": null,
      "indent": "0",
      "description": "Raw skins of sheep or lambs (fresh, or salted, dried, limed, pickled or otherwise preserved, but not tanned, parchment- dressed or further prepared), whether or not with wool on or split, other than those excluded by note 1(c) to this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4102.10",
      "rawHtsCode": "4102.10",
      "superior": null,
      "indent": "1",
      "description": "With wool on:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4102.10.1000",
      "rawHtsCode": "4102.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Not pretanned",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4102.10.2000",
      "rawHtsCode": "4102.10.20.00",
      "superior": null,
      "indent": "3",
      "description": "Vegetable pretanned",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4102.10.3000",
      "rawHtsCode": "4102.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4102.21.00",
      "rawHtsCode": "4102.21.00",
      "superior": null,
      "indent": "2",
      "description": "Pickled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4102.21.0065",
      "rawHtsCode": "4102.21.00.65",
      "superior": null,
      "indent": "3",
      "description": "Not split",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4102.21.0095",
      "rawHtsCode": "4102.21.00.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4102.29",
      "rawHtsCode": "4102.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4102.29.10",
      "rawHtsCode": "4102.29.10",
      "superior": null,
      "indent": "3",
      "description": "Not pretanned",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4102.29.1010",
      "rawHtsCode": "4102.29.10.10",
      "superior": null,
      "indent": "4",
      "description": "Hair sheep and cabretta skins",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4102.29.1090",
      "rawHtsCode": "4102.29.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4102.29.2000",
      "rawHtsCode": "4102.29.20.00",
      "superior": null,
      "indent": "4",
      "description": "Vegetable pretanned",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4102.29.3000",
      "rawHtsCode": "4102.29.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4103",
      "rawHtsCode": "4103",
      "superior": null,
      "indent": "0",
      "description": "Other raw hides and skins (fresh, or salted, dried, limed, pickled or otherwise preserved, but not tanned, parchment-dressed or further prepared), whether or not dehaired or split, other than those excluded by note 1(b) or 1(c) to this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4103.20",
      "rawHtsCode": "4103.20",
      "superior": null,
      "indent": "1",
      "description": "Of reptiles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4103.20.1000",
      "rawHtsCode": "4103.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Not pretanned",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4103.20.2000",
      "rawHtsCode": "4103.20.20.00",
      "superior": null,
      "indent": "3",
      "description": "Vegetable pretanned",
      "units": [
        "pcs"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4103.20.3000",
      "rawHtsCode": "4103.20.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4103.30",
      "rawHtsCode": "4103.30",
      "superior": null,
      "indent": "1",
      "description": "Of swine:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4103.30.1000",
      "rawHtsCode": "4103.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Not pretanned",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4103.30.2000",
      "rawHtsCode": "4103.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4103.90",
      "rawHtsCode": "4103.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4103.90.11",
      "rawHtsCode": "4103.90.11",
      "superior": null,
      "indent": "2",
      "description": "Not pretanned",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4103.90.1130",
      "rawHtsCode": "4103.90.11.30",
      "superior": null,
      "indent": "3",
      "description": "Deer",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4103.90.1140",
      "rawHtsCode": "4103.90.11.40",
      "superior": null,
      "indent": "3",
      "description": "Of goats or kids",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4103.90.1190",
      "rawHtsCode": "4103.90.11.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4103.90.1200",
      "rawHtsCode": "4103.90.12.00",
      "superior": null,
      "indent": "4",
      "description": "Vegetable pretanned",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4103.90.1300",
      "rawHtsCode": "4103.90.13.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4103.90.2000",
      "rawHtsCode": "4103.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104",
      "rawHtsCode": "4104",
      "superior": null,
      "indent": "0",
      "description": "Tanned or crust hides and skins of bovine (including buffalo) or equine animals, without hair on, whether or not split, but not further prepared:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.11",
      "rawHtsCode": "4104.11",
      "superior": null,
      "indent": "2",
      "description": "Full grains, unsplit; grain splits:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.11.10",
      "rawHtsCode": "4104.11.10",
      "superior": null,
      "indent": "4",
      "description": "Upper leather; lining leather",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4104.11.1020",
      "rawHtsCode": "4104.11.10.20",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.11.1040",
      "rawHtsCode": "4104.11.10.40",
      "superior": null,
      "indent": "5",
      "description": "Lining leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.11.2000",
      "rawHtsCode": "4104.11.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.11.30",
      "rawHtsCode": "4104.11.30",
      "superior": null,
      "indent": "4",
      "description": "Buffalo",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.11.3010",
      "rawHtsCode": "4104.11.30.10",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.11.3060",
      "rawHtsCode": "4104.11.30.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.11.40",
      "rawHtsCode": "4104.11.40",
      "superior": null,
      "indent": "5",
      "description": "Upper leather; sole leather",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.11.4010",
      "rawHtsCode": "4104.11.40.10",
      "superior": null,
      "indent": "6",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.11.4060",
      "rawHtsCode": "4104.11.40.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.11.50",
      "rawHtsCode": "4104.11.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.11.5030",
      "rawHtsCode": "4104.11.50.30",
      "superior": null,
      "indent": "7",
      "description": "Not split",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.11.5040",
      "rawHtsCode": "4104.11.50.40",
      "superior": null,
      "indent": "8",
      "description": "Grains",
      "units": [
        "pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.11.5070",
      "rawHtsCode": "4104.11.50.70",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.11.5080",
      "rawHtsCode": "4104.11.50.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.19",
      "rawHtsCode": "4104.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.19.10",
      "rawHtsCode": "4104.19.10",
      "superior": null,
      "indent": "4",
      "description": "Upper leather; lining leather",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4104.19.1020",
      "rawHtsCode": "4104.19.10.20",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.19.1040",
      "rawHtsCode": "4104.19.10.40",
      "superior": null,
      "indent": "5",
      "description": "Lining leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.19.2000",
      "rawHtsCode": "4104.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.19.3000",
      "rawHtsCode": "4104.19.30.00",
      "superior": null,
      "indent": "4",
      "description": "Buffalo",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.19.40",
      "rawHtsCode": "4104.19.40",
      "superior": null,
      "indent": "5",
      "description": "Upper leather; sole leather",
      "units": [],
      "generalRate": "5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.19.4010",
      "rawHtsCode": "4104.19.40.10",
      "superior": null,
      "indent": "6",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.19.4060",
      "rawHtsCode": "4104.19.40.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.19.50",
      "rawHtsCode": "4104.19.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.3% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.19.5030",
      "rawHtsCode": "4104.19.50.30",
      "superior": null,
      "indent": "7",
      "description": "Not split",
      "units": [
        "pcs",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.19.5040",
      "rawHtsCode": "4104.19.50.40",
      "superior": null,
      "indent": "8",
      "description": "Grains",
      "units": [
        "pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.19.5070",
      "rawHtsCode": "4104.19.50.70",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.19.5080",
      "rawHtsCode": "4104.19.50.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.41",
      "rawHtsCode": "4104.41",
      "superior": null,
      "indent": "2",
      "description": "Full grains, unsplit; grain splits:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.41.10",
      "rawHtsCode": "4104.41.10",
      "superior": null,
      "indent": "4",
      "description": "Upper leather; lining leather",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4104.41.1020",
      "rawHtsCode": "4104.41.10.20",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.41.1040",
      "rawHtsCode": "4104.41.10.40",
      "superior": null,
      "indent": "5",
      "description": "Lining leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.41.2000",
      "rawHtsCode": "4104.41.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.41.30",
      "rawHtsCode": "4104.41.30",
      "superior": null,
      "indent": "4",
      "description": "Buffalo",
      "units": [],
      "generalRate": "2.4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.41.3010",
      "rawHtsCode": "4104.41.30.10",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.41.3060",
      "rawHtsCode": "4104.41.30.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.41.40",
      "rawHtsCode": "4104.41.40",
      "superior": null,
      "indent": "5",
      "description": "Upper leather; sole leather",
      "units": [],
      "generalRate": "5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.41.4010",
      "rawHtsCode": "4104.41.40.10",
      "superior": null,
      "indent": "6",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.41.4060",
      "rawHtsCode": "4104.41.40.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.41.5000",
      "rawHtsCode": "4104.41.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.3% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.49",
      "rawHtsCode": "4104.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.49.10",
      "rawHtsCode": "4104.49.10",
      "superior": null,
      "indent": "4",
      "description": "Upper leather; lining leather",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4104.49.1020",
      "rawHtsCode": "4104.49.10.20",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.49.1040",
      "rawHtsCode": "4104.49.10.40",
      "superior": null,
      "indent": "5",
      "description": "Lining leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.49.2000",
      "rawHtsCode": "4104.49.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.49.30",
      "rawHtsCode": "4104.49.30",
      "superior": null,
      "indent": "4",
      "description": "Buffalo",
      "units": [],
      "generalRate": "2.4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.49.3010",
      "rawHtsCode": "4104.49.30.10",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.49.3060",
      "rawHtsCode": "4104.49.30.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.49.40",
      "rawHtsCode": "4104.49.40",
      "superior": null,
      "indent": "5",
      "description": "Upper leather; sole leather",
      "units": [],
      "generalRate": "5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4104.49.4010",
      "rawHtsCode": "4104.49.40.10",
      "superior": null,
      "indent": "6",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.49.4060",
      "rawHtsCode": "4104.49.40.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4104.49.5000",
      "rawHtsCode": "4104.49.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.3% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4105",
      "rawHtsCode": "4105",
      "superior": null,
      "indent": "0",
      "description": "Tanned or crust skins of sheep or lambs, without wool on, whether or not split, but not further prepared:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4105.10",
      "rawHtsCode": "4105.10",
      "superior": null,
      "indent": "1",
      "description": "In the wet state (including wet-blue):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4105.10.1000",
      "rawHtsCode": "4105.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Wet blues",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4105.10.9000",
      "rawHtsCode": "4105.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4105.30.0000",
      "rawHtsCode": "4105.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "In the dry state (crust)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4106",
      "rawHtsCode": "4106",
      "superior": null,
      "indent": "0",
      "description": "Tanned or crust skins of other animals, without wool or hair on, whether or not split, but not further prepared:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4106.21",
      "rawHtsCode": "4106.21",
      "superior": null,
      "indent": "2",
      "description": "In the wet state (including wet-blue):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4106.21.1000",
      "rawHtsCode": "4106.21.10.00",
      "superior": null,
      "indent": "3",
      "description": "Wet blues",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4106.21.9000",
      "rawHtsCode": "4106.21.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4106.22.0000",
      "rawHtsCode": "4106.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "In the dry state (crust)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4106.31",
      "rawHtsCode": "4106.31",
      "superior": null,
      "indent": "2",
      "description": "In the wet state (including wet-blue):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4106.31.1000",
      "rawHtsCode": "4106.31.10.00",
      "superior": null,
      "indent": "3",
      "description": "Wet blues",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4106.31.9000",
      "rawHtsCode": "4106.31.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4106.32.0000",
      "rawHtsCode": "4106.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "In the dry state (crust)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4106.40.0000",
      "rawHtsCode": "4106.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of reptiles",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4106.91.0000",
      "rawHtsCode": "4106.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "In the wet state (including wet-blue)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4106.92.0000",
      "rawHtsCode": "4106.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "In the dry state (crust)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107",
      "rawHtsCode": "4107",
      "superior": null,
      "indent": "0",
      "description": "Leather further prepared after tanning or crusting, including parchment-dressed leather, of bovine (including buffalo) or equine animals, without hair on, whether or not split, other than leather of heading 4114:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.11",
      "rawHtsCode": "4107.11",
      "superior": null,
      "indent": "2",
      "description": "Full grains, unsplit:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.11.10",
      "rawHtsCode": "4107.11.10",
      "superior": null,
      "indent": "4",
      "description": "Upper leather; lining leather",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4107.11.1020",
      "rawHtsCode": "4107.11.10.20",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.11.1040",
      "rawHtsCode": "4107.11.10.40",
      "superior": null,
      "indent": "5",
      "description": "Lining leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.11.2000",
      "rawHtsCode": "4107.11.20.00",
      "superior": null,
      "indent": "5",
      "description": "Not fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.11.3000",
      "rawHtsCode": "4107.11.30.00",
      "superior": null,
      "indent": "5",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.6% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.11.4000",
      "rawHtsCode": "4107.11.40.00",
      "superior": null,
      "indent": "4",
      "description": "Buffalo",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.11.5000",
      "rawHtsCode": "4107.11.50.00",
      "superior": null,
      "indent": "5",
      "description": "Upholstery leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.8% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.11.60",
      "rawHtsCode": "4107.11.60",
      "superior": null,
      "indent": "5",
      "description": "Upper leather; sole leather",
      "units": [],
      "generalRate": "3.3% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.11.6010",
      "rawHtsCode": "4107.11.60.10",
      "superior": null,
      "indent": "6",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.11.6060",
      "rawHtsCode": "4107.11.60.60",
      "superior": null,
      "indent": "6",
      "description": "Sole leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.11.70",
      "rawHtsCode": "4107.11.70",
      "superior": null,
      "indent": "6",
      "description": "Not fancy",
      "units": [],
      "generalRate": "5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.11.7030",
      "rawHtsCode": "4107.11.70.30",
      "superior": null,
      "indent": "7",
      "description": "Belting",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.11.7040",
      "rawHtsCode": "4107.11.70.40",
      "superior": null,
      "indent": "7",
      "description": "Glove and garment",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.11.7050",
      "rawHtsCode": "4107.11.70.50",
      "superior": null,
      "indent": "7",
      "description": "Bag, case, strap and collar",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.11.7090",
      "rawHtsCode": "4107.11.70.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.11.8000",
      "rawHtsCode": "4107.11.80.00",
      "superior": null,
      "indent": "6",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.12",
      "rawHtsCode": "4107.12",
      "superior": null,
      "indent": "2",
      "description": "Grain splits:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.12.10",
      "rawHtsCode": "4107.12.10",
      "superior": null,
      "indent": "4",
      "description": "Upper leather; lining leather",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4107.12.1020",
      "rawHtsCode": "4107.12.10.20",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.12.1040",
      "rawHtsCode": "4107.12.10.40",
      "superior": null,
      "indent": "5",
      "description": "Lining leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.12.2000",
      "rawHtsCode": "4107.12.20.00",
      "superior": null,
      "indent": "5",
      "description": "Not fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.12.3000",
      "rawHtsCode": "4107.12.30.00",
      "superior": null,
      "indent": "5",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.6% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.12.4000",
      "rawHtsCode": "4107.12.40.00",
      "superior": null,
      "indent": "4",
      "description": "Buffalo",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.12.5000",
      "rawHtsCode": "4107.12.50.00",
      "superior": null,
      "indent": "5",
      "description": "Upholstery leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.8% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.12.60",
      "rawHtsCode": "4107.12.60",
      "superior": null,
      "indent": "5",
      "description": "Upper leather; sole leather",
      "units": [],
      "generalRate": "3.3% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.12.6010",
      "rawHtsCode": "4107.12.60.10",
      "superior": null,
      "indent": "6",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.12.6060",
      "rawHtsCode": "4107.12.60.60",
      "superior": null,
      "indent": "6",
      "description": "Sole leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.12.70",
      "rawHtsCode": "4107.12.70",
      "superior": null,
      "indent": "6",
      "description": "Not fancy",
      "units": [],
      "generalRate": "5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.12.7030",
      "rawHtsCode": "4107.12.70.30",
      "superior": null,
      "indent": "7",
      "description": "Belting",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.12.7040",
      "rawHtsCode": "4107.12.70.40",
      "superior": null,
      "indent": "7",
      "description": "Glove and garment",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.12.7050",
      "rawHtsCode": "4107.12.70.50",
      "superior": null,
      "indent": "7",
      "description": "Bag, case, strap and collar",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.12.7090",
      "rawHtsCode": "4107.12.70.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.12.8000",
      "rawHtsCode": "4107.12.80.00",
      "superior": null,
      "indent": "6",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.19",
      "rawHtsCode": "4107.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.19.10",
      "rawHtsCode": "4107.19.10",
      "superior": null,
      "indent": "4",
      "description": "Upper leather; lining leather",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4107.19.1020",
      "rawHtsCode": "4107.19.10.20",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.19.1040",
      "rawHtsCode": "4107.19.10.40",
      "superior": null,
      "indent": "5",
      "description": "Lining leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.19.2000",
      "rawHtsCode": "4107.19.20.00",
      "superior": null,
      "indent": "5",
      "description": "Not fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.19.3000",
      "rawHtsCode": "4107.19.30.00",
      "superior": null,
      "indent": "5",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.6% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.19.4000",
      "rawHtsCode": "4107.19.40.00",
      "superior": null,
      "indent": "4",
      "description": "Buffalo",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.19.5000",
      "rawHtsCode": "4107.19.50.00",
      "superior": null,
      "indent": "5",
      "description": "Upholstery leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.8% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.19.60",
      "rawHtsCode": "4107.19.60",
      "superior": null,
      "indent": "5",
      "description": "Upper leather; sole leather",
      "units": [],
      "generalRate": "5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.19.6010",
      "rawHtsCode": "4107.19.60.10",
      "superior": null,
      "indent": "6",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.19.6050",
      "rawHtsCode": "4107.19.60.50",
      "superior": null,
      "indent": "6",
      "description": "Sole leather",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.19.70",
      "rawHtsCode": "4107.19.70",
      "superior": null,
      "indent": "6",
      "description": "Not fancy",
      "units": [],
      "generalRate": "5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.19.7030",
      "rawHtsCode": "4107.19.70.30",
      "superior": null,
      "indent": "7",
      "description": "Belting",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.19.7040",
      "rawHtsCode": "4107.19.70.40",
      "superior": null,
      "indent": "7",
      "description": "Glove and garment",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.19.7050",
      "rawHtsCode": "4107.19.70.50",
      "superior": null,
      "indent": "7",
      "description": "Bag, case, strap and collar",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.19.7090",
      "rawHtsCode": "4107.19.70.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.19.8000",
      "rawHtsCode": "4107.19.80.00",
      "superior": null,
      "indent": "6",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.91",
      "rawHtsCode": "4107.91",
      "superior": null,
      "indent": "2",
      "description": "Full grains, unsplit:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.91.4000",
      "rawHtsCode": "4107.91.40.00",
      "superior": null,
      "indent": "3",
      "description": "Buffalo",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.91.5000",
      "rawHtsCode": "4107.91.50.00",
      "superior": null,
      "indent": "4",
      "description": "Upholstery leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.8% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.91.60",
      "rawHtsCode": "4107.91.60",
      "superior": null,
      "indent": "4",
      "description": "Upper leather; sole leather",
      "units": [],
      "generalRate": "3.3% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.91.6010",
      "rawHtsCode": "4107.91.60.10",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.91.6050",
      "rawHtsCode": "4107.91.60.50",
      "superior": null,
      "indent": "5",
      "description": "Sole leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.91.70",
      "rawHtsCode": "4107.91.70",
      "superior": null,
      "indent": "5",
      "description": "Not fancy",
      "units": [],
      "generalRate": "5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.91.7030",
      "rawHtsCode": "4107.91.70.30",
      "superior": null,
      "indent": "6",
      "description": "Belting",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.91.7040",
      "rawHtsCode": "4107.91.70.40",
      "superior": null,
      "indent": "6",
      "description": "Glove and garment",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.91.7050",
      "rawHtsCode": "4107.91.70.50",
      "superior": null,
      "indent": "6",
      "description": "Bag, case, strap and collar",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.91.7090",
      "rawHtsCode": "4107.91.70.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.91.8000",
      "rawHtsCode": "4107.91.80.00",
      "superior": null,
      "indent": "5",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.92",
      "rawHtsCode": "4107.92",
      "superior": null,
      "indent": "2",
      "description": "Grain splits:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.92.4000",
      "rawHtsCode": "4107.92.40.00",
      "superior": null,
      "indent": "3",
      "description": "Buffalo",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.92.5000",
      "rawHtsCode": "4107.92.50.00",
      "superior": null,
      "indent": "4",
      "description": "Upholstery leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.8% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.92.60",
      "rawHtsCode": "4107.92.60",
      "superior": null,
      "indent": "4",
      "description": "Upper leather; sole leather",
      "units": [],
      "generalRate": "3.3% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.92.6010",
      "rawHtsCode": "4107.92.60.10",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.92.6050",
      "rawHtsCode": "4107.92.60.50",
      "superior": null,
      "indent": "5",
      "description": "Sole leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.92.70",
      "rawHtsCode": "4107.92.70",
      "superior": null,
      "indent": "5",
      "description": "Not fancy",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.92.7030",
      "rawHtsCode": "4107.92.70.30",
      "superior": null,
      "indent": "6",
      "description": "Belting",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.92.7040",
      "rawHtsCode": "4107.92.70.40",
      "superior": null,
      "indent": "6",
      "description": "Glove and garment",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.92.7050",
      "rawHtsCode": "4107.92.70.50",
      "superior": null,
      "indent": "6",
      "description": "Bag, case, strap and collar",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.92.7090",
      "rawHtsCode": "4107.92.70.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.92.8000",
      "rawHtsCode": "4107.92.80.00",
      "superior": null,
      "indent": "5",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.99",
      "rawHtsCode": "4107.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.99.4000",
      "rawHtsCode": "4107.99.40.00",
      "superior": null,
      "indent": "3",
      "description": "Buffalo",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.99.5000",
      "rawHtsCode": "4107.99.50.00",
      "superior": null,
      "indent": "4",
      "description": "Upholstery leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.8% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.99.60",
      "rawHtsCode": "4107.99.60",
      "superior": null,
      "indent": "4",
      "description": "Upper leather; sole leather",
      "units": [],
      "generalRate": "5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.99.6010",
      "rawHtsCode": "4107.99.60.10",
      "superior": null,
      "indent": "5",
      "description": "Upper leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.99.6050",
      "rawHtsCode": "4107.99.60.50",
      "superior": null,
      "indent": "5",
      "description": "Sole leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.99.70",
      "rawHtsCode": "4107.99.70",
      "superior": null,
      "indent": "5",
      "description": "Not fancy",
      "units": [],
      "generalRate": "5% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4107.99.7030",
      "rawHtsCode": "4107.99.70.30",
      "superior": null,
      "indent": "6",
      "description": "Belting",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.99.7040",
      "rawHtsCode": "4107.99.70.40",
      "superior": null,
      "indent": "6",
      "description": "Glove and garment",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.99.7050",
      "rawHtsCode": "4107.99.70.50",
      "superior": null,
      "indent": "6",
      "description": "Bag, case, strap and collar",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.99.7090",
      "rawHtsCode": "4107.99.70.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4107.99.8000",
      "rawHtsCode": "4107.99.80.00",
      "superior": null,
      "indent": "5",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4% ",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4112.00",
      "rawHtsCode": "4112.00",
      "superior": null,
      "indent": "0",
      "description": "Leather further prepared after tanning or crusting, including parchment-dressed leather, of sheep or lamb, without wool on, whether or not split, other than leather of heading 4114:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4112.00.30",
      "rawHtsCode": "4112.00.30",
      "superior": null,
      "indent": "1",
      "description": "Not fancy",
      "units": [],
      "generalRate": "2% ",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4112.00.3030",
      "rawHtsCode": "4112.00.30.30",
      "superior": null,
      "indent": "2",
      "description": "Garment",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4112.00.3060",
      "rawHtsCode": "4112.00.30.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4112.00.6000",
      "rawHtsCode": "4112.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4113",
      "rawHtsCode": "4113",
      "superior": null,
      "indent": "0",
      "description": "Leather further prepared after tanning or crusting, including parchment-dressed leather, of other animals, without wool or hair on, whether or not split, other than leather of heading 4114:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4113.10",
      "rawHtsCode": "4113.10",
      "superior": null,
      "indent": "1",
      "description": "Of goats or kids:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4113.10.3000",
      "rawHtsCode": "4113.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Not fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.4% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4113.10.6000",
      "rawHtsCode": "4113.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.8% ",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See U.S. note 3 to subchapter III, chapter 99, 9903.41.05 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4113.20.0000",
      "rawHtsCode": "4113.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of swine",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4113.30",
      "rawHtsCode": "4113.30",
      "superior": null,
      "indent": "1",
      "description": "Of reptiles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4113.30.3000",
      "rawHtsCode": "4113.30.30.00",
      "superior": null,
      "indent": "2",
      "description": "Not fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4113.30.6000",
      "rawHtsCode": "4113.30.60.00",
      "superior": null,
      "indent": "2",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4113.90",
      "rawHtsCode": "4113.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4113.90.3000",
      "rawHtsCode": "4113.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Not fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4113.90.6000",
      "rawHtsCode": "4113.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Fancy",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4114",
      "rawHtsCode": "4114",
      "superior": null,
      "indent": "0",
      "description": "Chamois (including combination chamois) leather; patent leather and patent laminated leather; metallized leather:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4114.10.0000",
      "rawHtsCode": "4114.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Chamois (including combination chamois) leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4114.20",
      "rawHtsCode": "4114.20",
      "superior": null,
      "indent": "1",
      "description": "Patent leather and patent laminated leather; metallized leather:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4114.20.3000",
      "rawHtsCode": "4114.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "Patent leather",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4114.20.4000",
      "rawHtsCode": "4114.20.40.00",
      "superior": null,
      "indent": "3",
      "description": "Calf and kip",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4114.20.7000",
      "rawHtsCode": "4114.20.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4115",
      "rawHtsCode": "4115",
      "superior": null,
      "indent": "0",
      "description": "Composition leather with a basis of leather or leather fiber, in slabs, sheets or strip, whether or not in rolls; parings and other waste of leather or of composition leather, not suitable for the manufacture of leather articles; leather dust, powder and flour:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4115.10.0000",
      "rawHtsCode": "4115.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Composition leather with a basis of leather or leather fiber, in slabs, sheets or strip, whether or not in rolls",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4115.20.0000",
      "rawHtsCode": "4115.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parings and other waste of leather or of composition leather, not suitable for the manufacture of leather articles; leather dust, powder and flour",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4201.00",
      "rawHtsCode": "4201.00",
      "superior": null,
      "indent": "0",
      "description": "Saddlery and harness for any animal (including traces, leads, knee pads, muzzles, saddle cloths, saddle bags, dog coats and the like), of any material:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4201.00.3000",
      "rawHtsCode": "4201.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Dog leashes, collars, muzzles, harnesses and similar dog equipment",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4201.00.6000",
      "rawHtsCode": "4201.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202",
      "rawHtsCode": "4202",
      "superior": null,
      "indent": "0",
      "description": "Trunks, suitcases, vanity cases, attache cases, briefcases, school satchels, spectacle cases, binocular cases, camera cases, musical instrument cases, gun cases, holsters and similar containers; traveling bags, insulated food or beverage bags, toiletry bags, knapsacks and backpacks, handbags, shopping bags, wallets, purses, map cases, cigarette cases, tobacco pouches, tool bags, sports bags, bottle cases, jewelry boxes, powder cases, cutlery cases and similar containers, of leather or of composition leather, of sheeting of plastics, of textile materials, of vulcanized fiber or of paperboard, or wholly or mainly covered with such materials or with paper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.11.00",
      "rawHtsCode": "4202.11.00",
      "superior": null,
      "indent": "2",
      "description": "With outer surface of leather or of composition leather",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR,MA,NP,OM,P,PA,PE,R,S,SG) 6.4% (E)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.11.0030",
      "rawHtsCode": "4202.11.00.30",
      "superior": null,
      "indent": "3",
      "description": "Attache cases, briefcases, school satchels, occupational luggage cases and similar containers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.11.0090",
      "rawHtsCode": "4202.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12",
      "rawHtsCode": "4202.12",
      "superior": null,
      "indent": "2",
      "description": "With outer surface of plastics or of textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.21",
      "rawHtsCode": "4202.12.21",
      "superior": null,
      "indent": "4",
      "description": "Trunks, suitcases, vanity cases and similar containers",
      "units": [],
      "generalRate": "20%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR,MA,NP,OM,P,PA,PE,R,S,SG) 17.5% (E)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.12.2120",
      "rawHtsCode": "4202.12.21.20",
      "superior": null,
      "indent": "5",
      "description": "Structured, rigid on all sides",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.2150",
      "rawHtsCode": "4202.12.21.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.29",
      "rawHtsCode": "4202.12.29",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "20%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,NP, OM,P,PA,PE,R,S,SG) 17.5% (E)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.12.2910",
      "rawHtsCode": "4202.12.29.10",
      "superior": null,
      "indent": "6",
      "description": "Attache cases, briefcases and similar containers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.2925",
      "rawHtsCode": "4202.12.29.25",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.2935",
      "rawHtsCode": "4202.12.29.35",
      "superior": null,
      "indent": "6",
      "description": "Attache cases, briefcases and similar containers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.2985",
      "rawHtsCode": "4202.12.29.85",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.4000",
      "rawHtsCode": "4202.12.40.00",
      "superior": null,
      "indent": "5",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 4.9% (E)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.12.6000",
      "rawHtsCode": "4202.12.60.00",
      "superior": null,
      "indent": "5",
      "description": "Other (870)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,NP, OM,P,PA,PE,S,SG) 4.4% (E)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.12.81",
      "rawHtsCode": "4202.12.81",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "17.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.12.8130",
      "rawHtsCode": "4202.12.81.30",
      "superior": null,
      "indent": "5",
      "description": "Attache cases, briefcases, school satchels, occupational luggage cases and similar containers (670)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.8170",
      "rawHtsCode": "4202.12.81.70",
      "superior": null,
      "indent": "5",
      "description": "Other (670)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.89",
      "rawHtsCode": "4202.12.89",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "17.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,NP, OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.12.8910",
      "rawHtsCode": "4202.12.89.10",
      "superior": null,
      "indent": "6",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.8920",
      "rawHtsCode": "4202.12.89.20",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.8940",
      "rawHtsCode": "4202.12.89.40",
      "superior": null,
      "indent": "6",
      "description": "Other (870)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.8950",
      "rawHtsCode": "4202.12.89.50",
      "superior": null,
      "indent": "6",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.8960",
      "rawHtsCode": "4202.12.89.60",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.12.8980",
      "rawHtsCode": "4202.12.89.80",
      "superior": null,
      "indent": "6",
      "description": "Other (870)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.19.0000",
      "rawHtsCode": "4202.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "20%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA, OM,P,PA,PE,R,S,SG) 17.5% (E)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.21",
      "rawHtsCode": "4202.21",
      "superior": null,
      "indent": "2",
      "description": "With outer surface of leather or of composition leather:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.21.3000",
      "rawHtsCode": "4202.21.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of reptile leather",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE,R,S, SG) 4.2% (E)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.21.6000",
      "rawHtsCode": "4202.21.60.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $20 each",
      "units": [
        "No."
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL, JO,KR,MA,NP,OM,P,PA,PE,R,S,SG) 8% (E)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.21.9000",
      "rawHtsCode": "4202.21.90.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $20 each",
      "units": [
        "No."
      ],
      "generalRate": "9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL, JO,KR,MA,NP,OM,P,PA,PE,R,S,SG) 7.2% (E)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.22",
      "rawHtsCode": "4202.22",
      "superior": null,
      "indent": "2",
      "description": "With outer surface of sheeting of plastics or of textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.22.1500",
      "rawHtsCode": "4202.22.15.00",
      "superior": null,
      "indent": "3",
      "description": "With outer surface of sheeting of plastics",
      "units": [
        "No."
      ],
      "generalRate": "16%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL, JO,KR,MA,NP,OM,P,PA,PE,R,S,SG) 15% (E)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.22.3500",
      "rawHtsCode": "4202.22.35.00",
      "superior": null,
      "indent": "5",
      "description": "Of abaca",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "8.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.22.40",
      "rawHtsCode": "4202.22.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO, KR,MA,NP,OM,P,PA,PE,S,SG) 5.7% (E)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.22.4010",
      "rawHtsCode": "4202.22.40.10",
      "superior": null,
      "indent": "6",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.22.4020",
      "rawHtsCode": "4202.22.40.20",
      "superior": null,
      "indent": "7",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        " <u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.22.4030",
      "rawHtsCode": "4202.22.40.30",
      "superior": null,
      "indent": "7",
      "description": "Of man-made fibers (670)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.22.4040",
      "rawHtsCode": "4202.22.40.40",
      "superior": null,
      "indent": "7",
      "description": "Other (871)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.22.4500",
      "rawHtsCode": "4202.22.45.00",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,BH,CL,CO, D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 4.9% (E)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.22.6000",
      "rawHtsCode": "4202.22.60.00",
      "superior": null,
      "indent": "6",
      "description": "Other (871)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA, NP,OM,P,PA,PE,S,SG) 4.4% (E)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.22.7000",
      "rawHtsCode": "4202.22.70.00",
      "superior": null,
      "indent": "6",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.22.8100",
      "rawHtsCode": "4202.22.81.00",
      "superior": null,
      "indent": "6",
      "description": "Of man-made fibers (670)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "17.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.22.89",
      "rawHtsCode": "4202.22.89",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "17.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,NP, OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.22.8930",
      "rawHtsCode": "4202.22.89.30",
      "superior": null,
      "indent": "7",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.22.8970",
      "rawHtsCode": "4202.22.89.70",
      "superior": null,
      "indent": "7",
      "description": "Of paper yarn",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.22.8980",
      "rawHtsCode": "4202.22.89.80",
      "superior": null,
      "indent": "7",
      "description": "Other (871)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.29",
      "rawHtsCode": "4202.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.29.1000",
      "rawHtsCode": "4202.29.10.00",
      "superior": null,
      "indent": "4",
      "description": "Of plastics",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.29.2000",
      "rawHtsCode": "4202.29.20.00",
      "superior": null,
      "indent": "4",
      "description": "Of wood",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.29.5000",
      "rawHtsCode": "4202.29.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA, NP,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.29.9000",
      "rawHtsCode": "4202.29.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "20%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,NP,OM,P,PA,PE,R,S,SG) 17.5% (E)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.31",
      "rawHtsCode": "4202.31",
      "superior": null,
      "indent": "2",
      "description": "With outer surface of leather or of composition leather:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.31.3000",
      "rawHtsCode": "4202.31.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of reptile leather",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.31.6000",
      "rawHtsCode": "4202.31.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH, CL,CO,D,IL, JO,KR,MA,NP,OM,P,PA,PE,R,S,SG) 6.4% (E)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.32",
      "rawHtsCode": "4202.32",
      "superior": null,
      "indent": "2",
      "description": "With outer surface of sheeting of plastics or of textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.32.1000",
      "rawHtsCode": "4202.32.10.00",
      "superior": null,
      "indent": "4",
      "description": "Of reinforced or laminated plastics",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "12.1¢/kg + 4.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.32.2000",
      "rawHtsCode": "4202.32.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "20%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.32.4000",
      "rawHtsCode": "4202.32.40.00",
      "superior": null,
      "indent": "5",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 4.9% (E)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.32.8000",
      "rawHtsCode": "4202.32.80.00",
      "superior": null,
      "indent": "5",
      "description": "Other (871)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO, KR,MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.32.8500",
      "rawHtsCode": "4202.32.85.00",
      "superior": null,
      "indent": "5",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4202.32.9100",
      "rawHtsCode": "4202.32.91.00",
      "superior": null,
      "indent": "5",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "17.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.32.9300",
      "rawHtsCode": "4202.32.93.00",
      "superior": null,
      "indent": "5",
      "description": "Of man-made fibers (670)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "17.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.32.9900",
      "rawHtsCode": "4202.32.99.00",
      "superior": null,
      "indent": "5",
      "description": "Other (871)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "17.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.39",
      "rawHtsCode": "4202.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.39.1000",
      "rawHtsCode": "4202.39.10.00",
      "superior": null,
      "indent": "4",
      "description": "Of plastics",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.39.2000",
      "rawHtsCode": "4202.39.20.00",
      "superior": null,
      "indent": "4",
      "description": "Of wood",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.39.5000",
      "rawHtsCode": "4202.39.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.39.9000",
      "rawHtsCode": "4202.39.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.91",
      "rawHtsCode": "4202.91",
      "superior": null,
      "indent": "2",
      "description": "With outer surface of leather or of composition leather:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.91.1000",
      "rawHtsCode": "4202.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Golf bags",
      "units": [
        "No."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 3.5% (E)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.91.90",
      "rawHtsCode": "4202.91.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 3.5% (E)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.91.9030",
      "rawHtsCode": "4202.91.90.30",
      "superior": null,
      "indent": "4",
      "description": "Travel, sports and similar bags",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.91.9090",
      "rawHtsCode": "4202.91.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92",
      "rawHtsCode": "4202.92",
      "superior": null,
      "indent": "2",
      "description": "With outer surface of sheeting of plastics or of textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.0400",
      "rawHtsCode": "4202.92.04.00",
      "superior": null,
      "indent": "5",
      "description": "Beverage bags whose interior incorporates only a flexible plastic container of a kind for storing and dispensing potable beverages through attached flexible tubing",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.08",
      "rawHtsCode": "4202.92.08",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO, KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.0805",
      "rawHtsCode": "4202.92.08.05",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.0807",
      "rawHtsCode": "4202.92.08.07",
      "superior": null,
      "indent": "6",
      "description": "Of man-made fibers (670)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.0809",
      "rawHtsCode": "4202.92.08.09",
      "superior": null,
      "indent": "6",
      "description": "Other (870)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.1000",
      "rawHtsCode": "4202.92.10.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.1500",
      "rawHtsCode": "4202.92.15.00",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 4.9% (E)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.2000",
      "rawHtsCode": "4202.92.20.00",
      "superior": null,
      "indent": "6",
      "description": "Other (870)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 4.4% (E)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.31",
      "rawHtsCode": "4202.92.31",
      "superior": null,
      "indent": "5",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "17.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.3120",
      "rawHtsCode": "4202.92.31.20",
      "superior": null,
      "indent": "6",
      "description": "Backpacks (670)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "4202.92.3131",
      "rawHtsCode": "4202.92.31.31",
      "superior": null,
      "indent": "6",
      "description": "Other (670)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.33",
      "rawHtsCode": "4202.92.33",
      "superior": null,
      "indent": "5",
      "description": "Of paper yarn or of cotton; containing 85 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "17.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.3305",
      "rawHtsCode": "4202.92.33.05",
      "superior": null,
      "indent": "6",
      "description": "Of paper yarn",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.3310",
      "rawHtsCode": "4202.92.33.10",
      "superior": null,
      "indent": "6",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.3316",
      "rawHtsCode": "4202.92.33.16",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.3900",
      "rawHtsCode": "4202.92.39.00",
      "superior": null,
      "indent": "5",
      "description": "Other (870)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "17.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.4500",
      "rawHtsCode": "4202.92.45.00",
      "superior": null,
      "indent": "4",
      "description": "Other ",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL, JO,KR,MA,NP,OM,P,PA,PE,R,S, SG) 17.5% (E)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.5000",
      "rawHtsCode": "4202.92.50.00",
      "superior": null,
      "indent": "3",
      "description": "Musical instrument cases",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.60",
      "rawHtsCode": "4202.92.60",
      "superior": null,
      "indent": "4",
      "description": "Of cotton",
      "units": [],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 4.9% (E)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.6010",
      "rawHtsCode": "4202.92.60.10",
      "superior": null,
      "indent": "5",
      "description": "Jewelry boxes, and similar containers of a kind normally sold at retail with their contents",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.6091",
      "rawHtsCode": "4202.92.60.91",
      "superior": null,
      "indent": "5",
      "description": "Other (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.9100",
      "rawHtsCode": "4202.92.91.00",
      "superior": null,
      "indent": "6",
      "description": "Of man-made fibers (except jewelry boxes of a kind normally sold at retail with their contents) (670)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "17.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.93",
      "rawHtsCode": "4202.92.93",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "17.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.9310",
      "rawHtsCode": "4202.92.93.10",
      "superior": null,
      "indent": "7",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.9315",
      "rawHtsCode": "4202.92.93.15",
      "superior": null,
      "indent": "7",
      "description": "Other, jewelry boxes of a kind normally sold at retail with their contents",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.9336",
      "rawHtsCode": "4202.92.93.36",
      "superior": null,
      "indent": "7",
      "description": "Other (870)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.92.9400",
      "rawHtsCode": "4202.92.94.00",
      "superior": null,
      "indent": "6",
      "description": "Cases designed to protect and transport compact disks (CD's), CD Rom disks, CD players, cassette players, and/or cassettes",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "17.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.92.9700",
      "rawHtsCode": "4202.92.97.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "17.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR, MA,NP,OM,P,PA,PE,S,SG) 16.6% (E)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.99",
      "rawHtsCode": "4202.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4202.99.1000",
      "rawHtsCode": "4202.99.10.00",
      "superior": null,
      "indent": "4",
      "description": "Of plastics",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.99.2000",
      "rawHtsCode": "4202.99.20.00",
      "superior": null,
      "indent": "5",
      "description": "Not lined with textile fabrics",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.99.3000",
      "rawHtsCode": "4202.99.30.00",
      "superior": null,
      "indent": "5",
      "description": "Lined with textile fabrics",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11¢/kg +20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4202.99.5000",
      "rawHtsCode": "4202.99.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4202.99.9000",
      "rawHtsCode": "4202.99.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "20%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL, JO,KR,MA,NP,OM,P,PA,PE,R,S,SG) 17.5% (E)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203",
      "rawHtsCode": "4203",
      "superior": null,
      "indent": "0",
      "description": "Articles of apparel and clothing accessories, of leather or of composition leather:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.10",
      "rawHtsCode": "4203.10",
      "superior": null,
      "indent": "1",
      "description": "Articles of apparel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.10.2000",
      "rawHtsCode": "4203.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of reptile leather",
      "units": [
        "No."
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.10.40",
      "rawHtsCode": "4203.10.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG) 4.8% (E)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.10.4010",
      "rawHtsCode": "4203.10.40.10",
      "superior": null,
      "indent": "4",
      "description": "Anoraks",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.10.4030",
      "rawHtsCode": "4203.10.40.30",
      "superior": null,
      "indent": "5",
      "description": "Men's and boys'",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.10.4060",
      "rawHtsCode": "4203.10.40.60",
      "superior": null,
      "indent": "5",
      "description": "Women's, girls' and infants'",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.10.4085",
      "rawHtsCode": "4203.10.40.85",
      "superior": null,
      "indent": "4",
      "description": "Men's and boys'",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.10.4095",
      "rawHtsCode": "4203.10.40.95",
      "superior": null,
      "indent": "4",
      "description": "Women's, girls' and infants'",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.21",
      "rawHtsCode": "4203.21",
      "superior": null,
      "indent": "2",
      "description": "Specially designed for use in sports:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.21.2000",
      "rawHtsCode": "4203.21.20.00",
      "superior": null,
      "indent": "4",
      "description": "Batting gloves",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.21.4000",
      "rawHtsCode": "4203.21.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4203.21.5500",
      "rawHtsCode": "4203.21.55.00",
      "superior": null,
      "indent": "4",
      "description": "Cross-country ski gloves, mittens and mitts",
      "units": [
        "prs."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.21.6000",
      "rawHtsCode": "4203.21.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.21.7000",
      "rawHtsCode": "4203.21.70.00",
      "superior": null,
      "indent": "3",
      "description": "Ice hockey gloves",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4203.21.80",
      "rawHtsCode": "4203.21.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.21.8030",
      "rawHtsCode": "4203.21.80.30",
      "superior": null,
      "indent": "4",
      "description": "Golf gloves",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.21.8060",
      "rawHtsCode": "4203.21.80.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.29",
      "rawHtsCode": "4203.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.29.0500",
      "rawHtsCode": "4203.29.05.00",
      "superior": null,
      "indent": "5",
      "description": "With fourchettes or sidewalls which, at a minimum, extend from fingertip to fingertip between each of the four fingers",
      "units": [
        "<il>doz. prs.</il>"
      ],
      "generalRate": "12.6%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.29.0800",
      "rawHtsCode": "4203.29.08.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "<il>doz. prs.</il>"
      ],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG) 11.5% (E)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.29.1500",
      "rawHtsCode": "4203.29.15.00",
      "superior": null,
      "indent": "5",
      "description": "With fourchettes or sidewalls which, at a minimum, extend from fingertip to fingertip between each of the four fingers",
      "units": [
        "<il>doz. prs.</il>"
      ],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.29.1800",
      "rawHtsCode": "4203.29.18.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "<il>doz. prs.</il>"
      ],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG) 11.5% (E)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.29.2000",
      "rawHtsCode": "4203.29.20.00",
      "superior": null,
      "indent": "4",
      "description": "Not seamed",
      "units": [
        "<il>doz. prs.</il>"
      ],
      "generalRate": "12.6%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.29.30",
      "rawHtsCode": "4203.29.30",
      "superior": null,
      "indent": "5",
      "description": "Men's",
      "units": [],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.29.3010",
      "rawHtsCode": "4203.29.30.10",
      "superior": null,
      "indent": "6",
      "description": "Not lined",
      "units": [
        "doz. prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.29.3020",
      "rawHtsCode": "4203.29.30.20",
      "superior": null,
      "indent": "6",
      "description": "Lined",
      "units": [
        "doz. prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.29.4000",
      "rawHtsCode": "4203.29.40.00",
      "superior": null,
      "indent": "6",
      "description": "Not lined",
      "units": [
        "<il>doz. prs.</il>"
      ],
      "generalRate": "12.6%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.29.5000",
      "rawHtsCode": "4203.29.50.00",
      "superior": null,
      "indent": "6",
      "description": "Lined",
      "units": [
        "<il>doz. prs.</il>"
      ],
      "generalRate": "12.6%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.30.0000",
      "rawHtsCode": "4203.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Belts and bandoliers with or without buckles",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.40",
      "rawHtsCode": "4203.40",
      "superior": null,
      "indent": "1",
      "description": "Other clothing accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4203.40.3000",
      "rawHtsCode": "4203.40.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of reptile leather",
      "units": [
        "No."
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4203.40.6000",
      "rawHtsCode": "4203.40.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4205.00",
      "rawHtsCode": "4205.00",
      "superior": null,
      "indent": "0",
      "description": "Other articles of leather or of composition leather:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4205.00.0500",
      "rawHtsCode": "4205.00.05.00",
      "superior": null,
      "indent": "2",
      "description": "Belting leather cut or wholly or partly manufactured into forms or shapes suitable for conversion into belting",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4205.00.1000",
      "rawHtsCode": "4205.00.10.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4205.00.2000",
      "rawHtsCode": "4205.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "Shoelaces",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4205.00.4000",
      "rawHtsCode": "4205.00.40.00",
      "superior": null,
      "indent": "2",
      "description": "Straps and strops",
      "units": [
        "kg"
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4205.00.6000",
      "rawHtsCode": "4205.00.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of reptile leather",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4205.00.8000",
      "rawHtsCode": "4205.00.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4206.00",
      "rawHtsCode": "4206.00",
      "superior": null,
      "indent": "0",
      "description": "Articles of gut (other than silkworm gut), of goldbeater's skin, of bladders or of tendons:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4206.00.1300",
      "rawHtsCode": "4206.00.13.00",
      "superior": null,
      "indent": "2",
      "description": "If imported for use in the manufacture of sterile surgical sutures",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4206.00.19",
      "rawHtsCode": "4206.00.19",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4206.00.1910",
      "rawHtsCode": "4206.00.19.10",
      "superior": null,
      "indent": "3",
      "description": "Racquet strings",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4206.00.1930",
      "rawHtsCode": "4206.00.19.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4206.00.9000",
      "rawHtsCode": "4206.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301",
      "rawHtsCode": "4301",
      "superior": null,
      "indent": "0",
      "description": "Raw furskins (including heads, tails, paws and other pieces or cuttings, suitable for furriers' use), other than raw hides and skins of heading 4101, 4102 or 4103:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.10.00",
      "rawHtsCode": "4301.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of mink, whole, with or without head, tail or paws",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4301.10.0010",
      "rawHtsCode": "4301.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Wild",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.10.0020",
      "rawHtsCode": "4301.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.30.0000",
      "rawHtsCode": "4301.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of lamb, the following: Astrakhan, Broadtail, Caracul, Persian and similar lamb, Indian, Chinese, Mongolian or Tibetan lamb, whole, with or without head, tail or paws",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.60",
      "rawHtsCode": "4301.60",
      "superior": null,
      "indent": "1",
      "description": "Of fox, whole, with or without head, tail or paws:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.60.3000",
      "rawHtsCode": "4301.60.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of silver, black or platinum fox (including those of any fox which is a mutation, or type developed, from silver, black or platinum foxes)",
      "units": [
        "No."
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4301.60.6000",
      "rawHtsCode": "4301.60.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4301.80.02",
      "rawHtsCode": "4301.80.02",
      "superior": null,
      "indent": "1",
      "description": "Other furskins, whole, with or without head, tail or paws",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4301.80.0201",
      "rawHtsCode": "4301.80.02.01",
      "superior": null,
      "indent": "2",
      "description": "Of hare",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.80.0202",
      "rawHtsCode": "4301.80.02.02",
      "superior": null,
      "indent": "2",
      "description": "Of rabbit",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.80.0203",
      "rawHtsCode": "4301.80.02.03",
      "superior": null,
      "indent": "2",
      "description": "Of beaver",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.80.0204",
      "rawHtsCode": "4301.80.02.04",
      "superior": null,
      "indent": "2",
      "description": "Of muskrat",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.80.0210",
      "rawHtsCode": "4301.80.02.10",
      "superior": null,
      "indent": "2",
      "description": "Of nutria",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.80.0220",
      "rawHtsCode": "4301.80.02.20",
      "superior": null,
      "indent": "2",
      "description": "Of lynx",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.80.0240",
      "rawHtsCode": "4301.80.02.40",
      "superior": null,
      "indent": "2",
      "description": "Of marten",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.80.0260",
      "rawHtsCode": "4301.80.02.60",
      "superior": null,
      "indent": "2",
      "description": "Of sable",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.80.0270",
      "rawHtsCode": "4301.80.02.70",
      "superior": null,
      "indent": "2",
      "description": "Of fisher",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.80.0275",
      "rawHtsCode": "4301.80.02.75",
      "superior": null,
      "indent": "2",
      "description": "Of racoon",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.80.0280",
      "rawHtsCode": "4301.80.02.80",
      "superior": null,
      "indent": "2",
      "description": "Of seal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.80.0290",
      "rawHtsCode": "4301.80.02.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4301.90.0000",
      "rawHtsCode": "4301.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Heads, tails, paws and other pieces or cuttings, suitable for furriers' use",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4302",
      "rawHtsCode": "4302",
      "superior": null,
      "indent": "0",
      "description": "Tanned or dressed furskins (including heads, tails, paws and other pieces or cuttings), unassembled, or assembled (without the addition of other materials) other than those of heading 4303:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4302.11.00",
      "rawHtsCode": "4302.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of mink",
      "units": [],
      "generalRate": "2.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4302.11.0010",
      "rawHtsCode": "4302.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Kolinsky",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4302.11.0020",
      "rawHtsCode": "4302.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4302.19",
      "rawHtsCode": "4302.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4302.19.1300",
      "rawHtsCode": "4302.19.13.00",
      "superior": null,
      "indent": "3",
      "description": "Of lamb, the following: Astrakhan, Broadtail, Caracul, Persian and similar lamb, Indian, Chinese, Mongolian or Tibetan lamb",
      "units": [
        "No."
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4302.19.1500",
      "rawHtsCode": "4302.19.15.00",
      "superior": null,
      "indent": "4",
      "description": "Of silver, black or platinum fox (including those of any fox which is a mutation, or type developed, from silver, black or platinum foxes)",
      "units": [
        "No."
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4302.19.30",
      "rawHtsCode": "4302.19.30",
      "superior": null,
      "indent": "5",
      "description": "Not dyed",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4302.19.3030",
      "rawHtsCode": "4302.19.30.30",
      "superior": null,
      "indent": "6",
      "description": "Fox",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4302.19.3040",
      "rawHtsCode": "4302.19.30.40",
      "superior": null,
      "indent": "6",
      "description": "Racoon",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4302.19.3070",
      "rawHtsCode": "4302.19.30.70",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4302.19.45",
      "rawHtsCode": "4302.19.45",
      "superior": null,
      "indent": "5",
      "description": "Dyed",
      "units": [],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4302.19.4530",
      "rawHtsCode": "4302.19.45.30",
      "superior": null,
      "indent": "6",
      "description": "Fox",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4302.19.4540",
      "rawHtsCode": "4302.19.45.40",
      "superior": null,
      "indent": "6",
      "description": "Racoon",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4302.19.4570",
      "rawHtsCode": "4302.19.45.70",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4302.19.5500",
      "rawHtsCode": "4302.19.55.00",
      "superior": null,
      "indent": "3",
      "description": "Of rabbit or hare",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4302.19.6000",
      "rawHtsCode": "4302.19.60.00",
      "superior": null,
      "indent": "4",
      "description": "Not dyed",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4302.19.7500",
      "rawHtsCode": "4302.19.75.00",
      "superior": null,
      "indent": "4",
      "description": "Dyed",
      "units": [
        "No."
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4302.20",
      "rawHtsCode": "4302.20",
      "superior": null,
      "indent": "1",
      "description": "Heads, tails, paws and other pieces or cuttings, not assembled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4302.20.3000",
      "rawHtsCode": "4302.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of beaver, Caracul or Persian lamb, chinchilla, ermine, fisher, fitch, fox, Kolinsky, leopard, lynx, marten, mink, nutria, ocelot, otter, pony, racoon, sable or wolf",
      "units": [
        "kg"
      ],
      "generalRate": "2.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4302.20.6000",
      "rawHtsCode": "4302.20.60.00",
      "superior": null,
      "indent": "3",
      "description": "Not dyed",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4302.20.9000",
      "rawHtsCode": "4302.20.90.00",
      "superior": null,
      "indent": "3",
      "description": "Dyed",
      "units": [
        "kg"
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4302.30.0000",
      "rawHtsCode": "4302.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Whole skins and pieces or cuttings thereof, assembled",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4303",
      "rawHtsCode": "4303",
      "superior": null,
      "indent": "0",
      "description": "Articles of apparel, clothing accessories and other articles of furskin:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4303.10.00",
      "rawHtsCode": "4303.10.00",
      "superior": null,
      "indent": "1",
      "description": "Articles of apparel and clothing accessories",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4303.10.0030",
      "rawHtsCode": "4303.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Of mink",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4303.10.0060",
      "rawHtsCode": "4303.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4303.90.0000",
      "rawHtsCode": "4303.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4304.00.0000",
      "rawHtsCode": "4304.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Artificial fur and articles thereof",
      "units": [
        "No."
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4401",
      "rawHtsCode": "4401",
      "superior": null,
      "indent": "0",
      "description": "Fuel wood, in logs, in billets, in twigs, in faggots or in similar forms; wood in chips or particles; sawdust and wood waste and scrap, whether or not agglomerated in logs, briquettes, pellets or similar forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4401.11.0000",
      "rawHtsCode": "4401.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Coniferous",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4401.12.0000",
      "rawHtsCode": "4401.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Nonconiferous",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%<il></il>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4401.21.0000",
      "rawHtsCode": "4401.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Coniferous",
      "units": [
        "t dwb"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4401.22.0000",
      "rawHtsCode": "4401.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Nonconiferous",
      "units": [
        "t dwb"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4401.31.0000",
      "rawHtsCode": "4401.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Wood pellets",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4401.32.0000",
      "rawHtsCode": "4401.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Wood briquettes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4401.39",
      "rawHtsCode": "4401.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4401.39.2000",
      "rawHtsCode": "4401.39.20.00",
      "superior": null,
      "indent": "3",
      "description": "Artificial fire logs composed of wax and sawdust, with or without added materials ",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4401.39.42",
      "rawHtsCode": "4401.39.42",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4401.39.4210",
      "rawHtsCode": "4401.39.42.10",
      "superior": null,
      "indent": "4",
      "description": "Sawdust",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4401.39.4220",
      "rawHtsCode": "4401.39.42.20",
      "superior": null,
      "indent": "4",
      "description": "Shavings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4401.39.4290",
      "rawHtsCode": "4401.39.42.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4401.41.0000",
      "rawHtsCode": "4401.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sawdust",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4401.49.00",
      "rawHtsCode": "4401.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4401.49.0020",
      "rawHtsCode": "4401.49.00.20",
      "superior": null,
      "indent": "3",
      "description": "Shavings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4401.49.0090",
      "rawHtsCode": "4401.49.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4402",
      "rawHtsCode": "4402",
      "superior": null,
      "indent": "0",
      "description": "Wood charcoal (including shell or nut charcoal), whether or not agglomerated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4402.10.0000",
      "rawHtsCode": "4402.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of bamboo",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4402.20.0000",
      "rawHtsCode": "4402.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of shell or nut",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4402.90.0100",
      "rawHtsCode": "4402.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403",
      "rawHtsCode": "4403",
      "superior": null,
      "indent": "0",
      "description": "Wood in the rough, whether or not stripped of bark or sap- wood, or roughly squared:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.11.00",
      "rawHtsCode": "4403.11.00",
      "superior": null,
      "indent": "2",
      "description": "Coniferous",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4403.11.0020",
      "rawHtsCode": "4403.11.00.20",
      "superior": null,
      "indent": "4",
      "description": "Telephone, telegraph and electrical power poles",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.11.0040",
      "rawHtsCode": "4403.11.00.40",
      "superior": null,
      "indent": "4",
      "description": "Fence posts",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.11.0050",
      "rawHtsCode": "4403.11.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.11.0060",
      "rawHtsCode": "4403.11.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.12.00",
      "rawHtsCode": "4403.12.00",
      "superior": null,
      "indent": "2",
      "description": "Nonconiferous",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4403.12.0020",
      "rawHtsCode": "4403.12.00.20",
      "superior": null,
      "indent": "4",
      "description": "Telephone, telegraph and electrical power poles",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.12.0040",
      "rawHtsCode": "4403.12.00.40",
      "superior": null,
      "indent": "4",
      "description": "Fence posts",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.12.0050",
      "rawHtsCode": "4403.12.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.12.0060",
      "rawHtsCode": "4403.12.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.21.01",
      "rawHtsCode": "4403.21.01",
      "superior": null,
      "indent": "2",
      "description": "Of pine <u>(Pinus</u> spp.), of which the smallest cross-sectional dimension is 15 cm or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403.21.0112",
      "rawHtsCode": "4403.21.01.12",
      "superior": null,
      "indent": "4",
      "description": "Telephone, telegraph and electrical power poles",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.21.0115",
      "rawHtsCode": "4403.21.01.15",
      "superior": null,
      "indent": "4",
      "description": "Fence posts",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.21.0116",
      "rawHtsCode": "4403.21.01.16",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.21.0120",
      "rawHtsCode": "4403.21.01.20",
      "superior": null,
      "indent": "4",
      "description": "Southern yellow pine (Loblolly pine (<u>Pinus</u> <u>taeda</u>)), long leaf pine (<u>Pinus</u> <u>palustris</u>), pitch pine (<u>Pinus</u> <u>rigida</u>), short leaf pine (<u>Pinus</u> <u>echinata</u>), slash pine (<u>Pinus</u> <u>elliottii</u>) and Virginia pine (<u>Pinus</u> <u>virginiana</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.21.0125",
      "rawHtsCode": "4403.21.01.25",
      "superior": null,
      "indent": "4",
      "description": "Ponderosa pine (<u>Pinus</u> <u>ponderosa</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.21.0130",
      "rawHtsCode": "4403.21.01.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.21.0165",
      "rawHtsCode": "4403.21.01.65",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.22.01",
      "rawHtsCode": "4403.22.01",
      "superior": null,
      "indent": "2",
      "description": "Of pine <u>(Pinus</u> spp.), other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403.22.0108",
      "rawHtsCode": "4403.22.01.08",
      "superior": null,
      "indent": "3",
      "description": "Pulpwood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.22.0112",
      "rawHtsCode": "4403.22.01.12",
      "superior": null,
      "indent": "4",
      "description": "Telephone, telegraph and electrical power poles",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.22.0115",
      "rawHtsCode": "4403.22.01.15",
      "superior": null,
      "indent": "4",
      "description": "Fence posts",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.22.0116",
      "rawHtsCode": "4403.22.01.16",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.22.0120",
      "rawHtsCode": "4403.22.01.20",
      "superior": null,
      "indent": "4",
      "description": "Southern yellow pine (Loblolly pine (<u>Pinus</u> <u>taeda</u>)), long leaf pine (<u>Pinus</u> <u>palustris</u>), pitch pine (<u>Pinus</u> <u>rigida</u>), short leaf pine (<u>Pinus</u> <u>echinata</u>), slash pine (<u>Pinus</u> <u>elliottii</u>) and Virginia pine (<u>Pinus</u> <u>virginiana</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.22.0125",
      "rawHtsCode": "4403.22.01.25",
      "superior": null,
      "indent": "4",
      "description": "Ponderosa pine (<u>Pinus</u> <u>ponderosa</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.22.0130",
      "rawHtsCode": "4403.22.01.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.22.0165",
      "rawHtsCode": "4403.22.01.65",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.23.01",
      "rawHtsCode": "4403.23.01",
      "superior": null,
      "indent": "2",
      "description": "Of fir (<u>Abies</u> spp.) and spruce (<u>Picea</u> spp.), of which the smallest cross-sectional dimension is 15 cm or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403.23.0112",
      "rawHtsCode": "4403.23.01.12",
      "superior": null,
      "indent": "4",
      "description": "Telephone, telegraph and electrical power poles",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.23.0115",
      "rawHtsCode": "4403.23.01.15",
      "superior": null,
      "indent": "4",
      "description": "Fence posts",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.23.0116",
      "rawHtsCode": "4403.23.01.16",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.23.0135",
      "rawHtsCode": "4403.23.01.35",
      "superior": null,
      "indent": "4",
      "description": "Spruce (<u>Picea</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.23.0142",
      "rawHtsCode": "4403.23.01.42",
      "superior": null,
      "indent": "4",
      "description": "Other fir; balsam",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.23.0165",
      "rawHtsCode": "4403.23.01.65",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.24.01",
      "rawHtsCode": "4403.24.01",
      "superior": null,
      "indent": "2",
      "description": "Of fir (<u>Abies</u> spp.) and spruce (<u>Picea</u> spp.), other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403.24.0104",
      "rawHtsCode": "4403.24.01.04",
      "superior": null,
      "indent": "3",
      "description": "Pulpwood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.24.0112",
      "rawHtsCode": "4403.24.01.12",
      "superior": null,
      "indent": "4",
      "description": "Telephone, telegraph and electrical power poles",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.24.0115",
      "rawHtsCode": "4403.24.01.15",
      "superior": null,
      "indent": "4",
      "description": "Fence posts",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.24.0116",
      "rawHtsCode": "4403.24.01.16",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.24.0135",
      "rawHtsCode": "4403.24.01.35",
      "superior": null,
      "indent": "4",
      "description": "Spruce (<u>Picea</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.24.0142",
      "rawHtsCode": "4403.24.01.42",
      "superior": null,
      "indent": "4",
      "description": "Other fir; balsam",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.24.0165",
      "rawHtsCode": "4403.24.01.65",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.25.01",
      "rawHtsCode": "4403.25.01",
      "superior": null,
      "indent": "2",
      "description": "Other, of which the smallest cross-sectional dimension is 15 cm or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403.25.0112",
      "rawHtsCode": "4403.25.01.12",
      "superior": null,
      "indent": "4",
      "description": "Telephone, telegraph and electrical power poles",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.25.0115",
      "rawHtsCode": "4403.25.01.15",
      "superior": null,
      "indent": "4",
      "description": "Fence posts",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.25.0116",
      "rawHtsCode": "4403.25.01.16",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.25.0140",
      "rawHtsCode": "4403.25.01.40",
      "superior": null,
      "indent": "4",
      "description": "Douglas-fir (<u>Pseudotsuga</u> <u>menziesii</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.25.0150",
      "rawHtsCode": "4403.25.01.50",
      "superior": null,
      "indent": "4",
      "description": "Western hemlock (<u>Tsuga</u> <u>heterophylla</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.25.0152",
      "rawHtsCode": "4403.25.01.52",
      "superior": null,
      "indent": "4",
      "description": "Other hemlock",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.25.0155",
      "rawHtsCode": "4403.25.01.55",
      "superior": null,
      "indent": "4",
      "description": "Western red cedar (<u>Thuja</u> <u>plicata</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.25.0157",
      "rawHtsCode": "4403.25.01.57",
      "superior": null,
      "indent": "4",
      "description": "Other cedar",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.25.0164",
      "rawHtsCode": "4403.25.01.64",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.25.0165",
      "rawHtsCode": "4403.25.01.65",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.26.01",
      "rawHtsCode": "4403.26.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403.26.0108",
      "rawHtsCode": "4403.26.01.08",
      "superior": null,
      "indent": "3",
      "description": "Pulpwood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.26.0112",
      "rawHtsCode": "4403.26.01.12",
      "superior": null,
      "indent": "4",
      "description": "Telephone, telegraph and electrical power poles",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.26.0115",
      "rawHtsCode": "4403.26.01.15",
      "superior": null,
      "indent": "4",
      "description": "Fence posts",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.26.0116",
      "rawHtsCode": "4403.26.01.16",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.26.0140",
      "rawHtsCode": "4403.26.01.40",
      "superior": null,
      "indent": "4",
      "description": "Douglas-fir (<u>Pseudotsuga</u> <u>menziesii</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.26.0150",
      "rawHtsCode": "4403.26.01.50",
      "superior": null,
      "indent": "4",
      "description": "Western hemlock (<u>Tsuga</u> <u>heterophylla</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.26.0152",
      "rawHtsCode": "4403.26.01.52",
      "superior": null,
      "indent": "4",
      "description": "Other hemlock",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.26.0155",
      "rawHtsCode": "4403.26.01.55",
      "superior": null,
      "indent": "4",
      "description": "Western red cedar (<u>Thuja</u> <u>plicata</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.26.0157",
      "rawHtsCode": "4403.26.01.57",
      "superior": null,
      "indent": "4",
      "description": "Other cedar",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.26.0164",
      "rawHtsCode": "4403.26.01.64",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.26.0165",
      "rawHtsCode": "4403.26.01.65",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.41.0000",
      "rawHtsCode": "4403.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dark Red Meranti, Light Red Meranti and Meranti Bakau",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4403.42.0000",
      "rawHtsCode": "4403.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Teak",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403.49.0200",
      "rawHtsCode": "4403.49.02.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403.91.00",
      "rawHtsCode": "4403.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of oak (<u>Quercus</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4403.91.0020",
      "rawHtsCode": "4403.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Of red oak",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.91.0040",
      "rawHtsCode": "4403.91.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.93.0100",
      "rawHtsCode": "4403.93.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of beech (<u>Fagus</u> spp.), of which the smallest cross-sectional dimension is 15 cm or more",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403.94.0100",
      "rawHtsCode": "4403.94.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of beech (<u>Fagus</u> spp.), other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403.95.01",
      "rawHtsCode": "4403.95.01",
      "superior": null,
      "indent": "2",
      "description": "Of birch (<u>Betula</u> spp.), of which the smallest cross-sectional dimension is 15 cm or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403.95.0127",
      "rawHtsCode": "4403.95.01.27",
      "superior": null,
      "indent": "3",
      "description": "Poles, piles and posts",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.95.0130",
      "rawHtsCode": "4403.95.01.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.96.01",
      "rawHtsCode": "4403.96.01",
      "superior": null,
      "indent": "2",
      "description": "Of birch (<u>Betula</u> spp.), other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4403.96.0123",
      "rawHtsCode": "4403.96.01.23",
      "superior": null,
      "indent": "3",
      "description": "Pulpwood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.96.0127",
      "rawHtsCode": "4403.96.01.27",
      "superior": null,
      "indent": "3",
      "description": "Poles, piles and posts",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.96.0130",
      "rawHtsCode": "4403.96.01.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.97.00",
      "rawHtsCode": "4403.97.00",
      "superior": null,
      "indent": "2",
      "description": "Of poplar and aspen (<u>Populus</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4403.97.0022",
      "rawHtsCode": "4403.97.00.22",
      "superior": null,
      "indent": "3",
      "description": "Pulpwood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.97.0026",
      "rawHtsCode": "4403.97.00.26",
      "superior": null,
      "indent": "3",
      "description": "Poles, piles and posts",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.97.0065",
      "rawHtsCode": "4403.97.00.65",
      "superior": null,
      "indent": "4",
      "description": "Of yellow poplar (<u>Liriodendron</u> <u>tulipifera</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.97.0067",
      "rawHtsCode": "4403.97.00.67",
      "superior": null,
      "indent": "4",
      "description": "Of other poplar; of aspen or cottonwood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.98.00",
      "rawHtsCode": "4403.98.00",
      "superior": null,
      "indent": "2",
      "description": "Of eucalyptus (<u>Eucalyptus</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4403.98.0023",
      "rawHtsCode": "4403.98.00.23",
      "superior": null,
      "indent": "3",
      "description": "Pulpwood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.98.0028",
      "rawHtsCode": "4403.98.00.28",
      "superior": null,
      "indent": "3",
      "description": "Poles, piles and posts",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.98.0095",
      "rawHtsCode": "4403.98.00.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.99.01",
      "rawHtsCode": "4403.99.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4403.99.0123",
      "rawHtsCode": "4403.99.01.23",
      "superior": null,
      "indent": "3",
      "description": "Pulpwood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.99.0128",
      "rawHtsCode": "4403.99.01.28",
      "superior": null,
      "indent": "3",
      "description": "Poles, piles and posts",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.99.0140",
      "rawHtsCode": "4403.99.01.40",
      "superior": null,
      "indent": "4",
      "description": "Of ash (<u>Fraxinus</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.99.0150",
      "rawHtsCode": "4403.99.01.50",
      "superior": null,
      "indent": "4",
      "description": "Of western red alder (<u>Alnus</u> <u>rubra</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.99.0155",
      "rawHtsCode": "4403.99.01.55",
      "superior": null,
      "indent": "4",
      "description": "Of cherry (<u>Prunus</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.99.0160",
      "rawHtsCode": "4403.99.01.60",
      "superior": null,
      "indent": "4",
      "description": "Of maple (<u>Acer</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.99.0170",
      "rawHtsCode": "4403.99.01.70",
      "superior": null,
      "indent": "4",
      "description": "Of walnut (<u>Juglans</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.99.0175",
      "rawHtsCode": "4403.99.01.75",
      "superior": null,
      "indent": "4",
      "description": "Of paulownia (<u>Paulownia</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4403.99.0195",
      "rawHtsCode": "4403.99.01.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4404",
      "rawHtsCode": "4404",
      "superior": null,
      "indent": "0",
      "description": "Hoopwood; split poles; piles, pickets and stakes of wood, pointed but not sawn lengthwise; wooden sticks, roughly trimmed but not turned, bent or otherwise worked, suitable for the manufacture of walking-sticks, umbrellas, tool handles or the like; chipwood and the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4404.10.00",
      "rawHtsCode": "4404.10.00",
      "superior": null,
      "indent": "1",
      "description": "Coniferous",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4404.10.0040",
      "rawHtsCode": "4404.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Fence pickets, palings and rails",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4404.10.0080",
      "rawHtsCode": "4404.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Poles, piles and posts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4404.10.0090",
      "rawHtsCode": "4404.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4404.20.00",
      "rawHtsCode": "4404.20.00",
      "superior": null,
      "indent": "1",
      "description": "Nonconiferous",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4404.20.0040",
      "rawHtsCode": "4404.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Fence pickets, palings and rails",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4404.20.0080",
      "rawHtsCode": "4404.20.00.80",
      "superior": null,
      "indent": "2",
      "description": "Poles, piles and posts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4404.20.0090",
      "rawHtsCode": "4404.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4405.00.0000",
      "rawHtsCode": "4405.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Wood wool (excelsior); wood flour",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4406",
      "rawHtsCode": "4406",
      "superior": null,
      "indent": "0",
      "description": "Railway or tramway sleepers (cross-ties) of wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4406.11.0000",
      "rawHtsCode": "4406.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Coniferous",
      "units": [
        "m<sup>3</sup>",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4406.12.0000",
      "rawHtsCode": "4406.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Nonconiferous",
      "units": [
        "m<sup>3</sup>",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4406.91.0000",
      "rawHtsCode": "4406.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Coniferous",
      "units": [
        "m<sup>3</sup>",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4406.92.0000",
      "rawHtsCode": "4406.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Nonconiferous",
      "units": [
        "m<sup>3</sup>",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4407",
      "rawHtsCode": "4407",
      "superior": null,
      "indent": "0",
      "description": "Wood sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, of a thickness exceeding 6 mm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.11.00",
      "rawHtsCode": "4407.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of pine (<u>Pinus</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.70/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4407.11.0001",
      "rawHtsCode": "4407.11.00.01",
      "superior": null,
      "indent": "3",
      "description": "Finger-jointed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.11.0002",
      "rawHtsCode": "4407.11.00.02",
      "superior": null,
      "indent": "4",
      "description": "Treated with paint, stain, creosote or other preservative",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.11.0042",
      "rawHtsCode": "4407.11.00.42",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.11.0043",
      "rawHtsCode": "4407.11.00.43",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.11.0044",
      "rawHtsCode": "4407.11.00.44",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.11.0045",
      "rawHtsCode": "4407.11.00.45",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.11.0046",
      "rawHtsCode": "4407.11.00.46",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.11.0047",
      "rawHtsCode": "4407.11.00.47",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.11.0048",
      "rawHtsCode": "4407.11.00.48",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.11.0049",
      "rawHtsCode": "4407.11.00.49",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.11.0052",
      "rawHtsCode": "4407.11.00.52",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.11.0053",
      "rawHtsCode": "4407.11.00.53",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.12.00",
      "rawHtsCode": "4407.12.00",
      "superior": null,
      "indent": "2",
      "description": "Of fir (<u>Abies</u> spp.) and spruce (<u>Picea</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.70/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4407.12.0001",
      "rawHtsCode": "4407.12.00.01",
      "superior": null,
      "indent": "3",
      "description": "Finger-jointed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.12.0002",
      "rawHtsCode": "4407.12.00.02",
      "superior": null,
      "indent": "4",
      "description": "Treated with paint, stain, creosote or other preservative",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.12.0017",
      "rawHtsCode": "4407.12.00.17",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.12.0018",
      "rawHtsCode": "4407.12.00.18",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.12.0019",
      "rawHtsCode": "4407.12.00.19",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.12.0020",
      "rawHtsCode": "4407.12.00.20",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.12.0058",
      "rawHtsCode": "4407.12.00.58",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.12.0059",
      "rawHtsCode": "4407.12.00.59",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.13.0000",
      "rawHtsCode": "4407.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of S-P-F (spruce (<u>Picea</u> spp.), pine (<u>Pinus</u> spp.) and fir (<u>Abies</u> spp.))",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.70/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4407.14.0000",
      "rawHtsCode": "4407.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of Hem-fir (Western hemlock (<u>Tsuga</u> <u>heterophylla</u>) and fir (<u>Abies</u> spp.))",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.70/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4407.19.00",
      "rawHtsCode": "4407.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.70/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4407.19.0001",
      "rawHtsCode": "4407.19.00.01",
      "superior": null,
      "indent": "3",
      "description": "Finger-jointed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0002",
      "rawHtsCode": "4407.19.00.02",
      "superior": null,
      "indent": "4",
      "description": "Treated with paint, stain, creosote or other preservative",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0054",
      "rawHtsCode": "4407.19.00.54",
      "superior": null,
      "indent": "7",
      "description": "Having a minimum dimension less than 5.1 cm",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0055",
      "rawHtsCode": "4407.19.00.55",
      "superior": null,
      "indent": "7",
      "description": "Having a minimum dimension 5.1 cm or more but less than 12.7 cm",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0056",
      "rawHtsCode": "4407.19.00.56",
      "superior": null,
      "indent": "7",
      "description": "Having a minimum dimension 12.7 cm or more",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0057",
      "rawHtsCode": "4407.19.00.57",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0064",
      "rawHtsCode": "4407.19.00.64",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0065",
      "rawHtsCode": "4407.19.00.65",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0066",
      "rawHtsCode": "4407.19.00.66",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0067",
      "rawHtsCode": "4407.19.00.67",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0068",
      "rawHtsCode": "4407.19.00.68",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0069",
      "rawHtsCode": "4407.19.00.69",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0074",
      "rawHtsCode": "4407.19.00.74",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0075",
      "rawHtsCode": "4407.19.00.75",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0076",
      "rawHtsCode": "4407.19.00.76",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0077",
      "rawHtsCode": "4407.19.00.77",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0082",
      "rawHtsCode": "4407.19.00.82",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0083",
      "rawHtsCode": "4407.19.00.83",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0092",
      "rawHtsCode": "4407.19.00.92",
      "superior": null,
      "indent": "6",
      "description": "Rough",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.19.0093",
      "rawHtsCode": "4407.19.00.93",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.21.0000",
      "rawHtsCode": "4407.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mahogany (<u>Swietenia</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4407.22.00",
      "rawHtsCode": "4407.22.00",
      "superior": null,
      "indent": "2",
      "description": "Virola, Imbuia and Balsa",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4407.22.0006",
      "rawHtsCode": "4407.22.00.06",
      "superior": null,
      "indent": "3",
      "description": "Balsa (<u>Ochroma</u> <u>lagopus</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.22.0091",
      "rawHtsCode": "4407.22.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.23.0100",
      "rawHtsCode": "4407.23.01.00",
      "superior": null,
      "indent": "2",
      "description": "Teak",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4407.25.0000",
      "rawHtsCode": "4407.25.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dark Red Meranti, Light Red Meranti and Meranti Bakau",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4407.26.0000",
      "rawHtsCode": "4407.26.00.00",
      "superior": null,
      "indent": "2",
      "description": "White Lauan, White Meranti, White Seraya, Yellow Meranti and Alan",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4407.27.0000",
      "rawHtsCode": "4407.27.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sapelli",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4407.28.0000",
      "rawHtsCode": "4407.28.00.00",
      "superior": null,
      "indent": "2",
      "description": "Iroko",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4407.29.02",
      "rawHtsCode": "4407.29.02",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4407.29.0206",
      "rawHtsCode": "4407.29.02.06",
      "superior": null,
      "indent": "3",
      "description": "Acajou d'Afrique (<u>Khaya</u> spp.), also known as African mahogany",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.29.0211",
      "rawHtsCode": "4407.29.02.11",
      "superior": null,
      "indent": "3",
      "description": "Anigre (Aningeria spp.), also known as Aningre, Aniegre or Anegre",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.29.0216",
      "rawHtsCode": "4407.29.02.16",
      "superior": null,
      "indent": "3",
      "description": "Keruing (<u>Dipterocarpus</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.29.0220",
      "rawHtsCode": "4407.29.02.20",
      "superior": null,
      "indent": "3",
      "description": "Ipé (Tabebuia spp. or Handroanthus spp.), also known as Tahibo or Taheebo, LaPacho or Lapacho, Brazilian walnut and Patagonian walnut",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.29.0240",
      "rawHtsCode": "4407.29.02.40",
      "superior": null,
      "indent": "3",
      "description": "Andiroba (<u>Carapa</u> <u>guianensis</u> and <u>C.</u> <u>procera)</u>, Padauk (<u>Pterocarpus</u> spp.), also known as Padouk",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.29.0260",
      "rawHtsCode": "4407.29.02.60",
      "superior": null,
      "indent": "3",
      "description": "Cedro (<u>Cedrela</u> spp.), also known as Spanish Cedar",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.29.0285",
      "rawHtsCode": "4407.29.02.85",
      "superior": null,
      "indent": "3",
      "description": "Jatoba (<u>Hymenaea</u> spp.), also known as Brazilian Cherry",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.29.0296",
      "rawHtsCode": "4407.29.02.96",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.91.00",
      "rawHtsCode": "4407.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of oak (<u>Quercus</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4407.91.0022",
      "rawHtsCode": "4407.91.00.22",
      "superior": null,
      "indent": "3",
      "description": "Red oak",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.91.0063",
      "rawHtsCode": "4407.91.00.63",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.92.0000",
      "rawHtsCode": "4407.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of beech (<u>Fagus</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4407.93.00",
      "rawHtsCode": "4407.93.00",
      "superior": null,
      "indent": "2",
      "description": "Of maple (<u>Acer</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4407.93.0010",
      "rawHtsCode": "4407.93.00.10",
      "superior": null,
      "indent": "3",
      "description": "Hard maple",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.93.0020",
      "rawHtsCode": "4407.93.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.94.0000",
      "rawHtsCode": "4407.94.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of cherry (<u>Prunus </u>spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4407.95.0000",
      "rawHtsCode": "4407.95.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of ash (<u>Fraxinus </u>spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4407.96.00",
      "rawHtsCode": "4407.96.00",
      "superior": null,
      "indent": "2",
      "description": "Of birch (<u>Betula</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4407.96.0011",
      "rawHtsCode": "4407.96.00.11",
      "superior": null,
      "indent": "3",
      "description": "North American (Betula alleghaniensis, Betula papyrifera, Betula lenta, Betula nigra)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.96.0013",
      "rawHtsCode": "4407.96.00.13",
      "superior": null,
      "indent": "3",
      "description": "European (Betula pendula, Betula pubescens), also known as Baltic, Russian or Chinese birch",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.96.0019",
      "rawHtsCode": "4407.96.00.19",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.97.00",
      "rawHtsCode": "4407.97.00",
      "superior": null,
      "indent": "2",
      "description": "Of poplar and aspen (<u>Populus</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4407.97.0072",
      "rawHtsCode": "4407.97.00.72",
      "superior": null,
      "indent": "3",
      "description": "Yellow poplar (<u>Liriodendron</u> <u>tulipifera</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.97.0079",
      "rawHtsCode": "4407.97.00.79",
      "superior": null,
      "indent": "3",
      "description": "Other poplar; aspen; cottonwood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.99.02",
      "rawHtsCode": "4407.99.02",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.27/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4407.99.0242",
      "rawHtsCode": "4407.99.02.42",
      "superior": null,
      "indent": "3",
      "description": "Hickory (<u>Carya</u> spp.) and pecan (<u>Carya</u> <u>illinoensis</u>, <u>Carya</u> <u>pecan</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.99.0261",
      "rawHtsCode": "4407.99.02.61",
      "superior": null,
      "indent": "3",
      "description": "Walnut (<u>Juglans</u> spp)<u></u>",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.99.0263",
      "rawHtsCode": "4407.99.02.63",
      "superior": null,
      "indent": "3",
      "description": "Western red alder (<u>Alnus</u> <u>rubra</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4407.99.0295",
      "rawHtsCode": "4407.99.02.95",
      "superior": null,
      "indent": "3",
      "description": "Other nonconiferous",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408",
      "rawHtsCode": "4408",
      "superior": null,
      "indent": "0",
      "description": "Sheets for veneering (including those obtained by slicing laminated wood), for plywood or for similar laminated wood and other wood, sawn lengthwise, sliced or peeled, whether or not planed, sanded, spliced or end-jointed, of a thickness not exceeding 6 mm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.10.01",
      "rawHtsCode": "4408.10.01",
      "superior": null,
      "indent": "1",
      "description": "Coniferous",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4408.10.0125",
      "rawHtsCode": "4408.10.01.25",
      "superior": null,
      "indent": "2",
      "description": "Douglas fir",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.10.0145",
      "rawHtsCode": "4408.10.01.45",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.31.0100",
      "rawHtsCode": "4408.31.01.00",
      "superior": null,
      "indent": "2",
      "description": "Dark Red Meranti, Light Red Meranti and Meranti Bakau",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4408.39.02",
      "rawHtsCode": "4408.39.02",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4408.39.0210",
      "rawHtsCode": "4408.39.02.10",
      "superior": null,
      "indent": "3",
      "description": "Spliced or end-jointed",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.39.0220",
      "rawHtsCode": "4408.39.02.20",
      "superior": null,
      "indent": "4",
      "description": "Acajou or Acajou d'Afrique (<u>Khaya</u> spp.), also known as African mahogany",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.39.0230",
      "rawHtsCode": "4408.39.02.30",
      "superior": null,
      "indent": "4",
      "description": "Anigre (<u>Aningeria</u> spp.), also known as Aningre, Aniegre or Anegre",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.39.0240",
      "rawHtsCode": "4408.39.02.40",
      "superior": null,
      "indent": "4",
      "description": "Ceiba (<u>Ceiba</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.39.0250",
      "rawHtsCode": "4408.39.02.50",
      "superior": null,
      "indent": "4",
      "description": "Obeche (<u>Triplochiton</u> spp.), also known as Ayous",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.39.0260",
      "rawHtsCode": "4408.39.02.60",
      "superior": null,
      "indent": "4",
      "description": "Okoume (<u>Aucoumea</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.39.0270",
      "rawHtsCode": "4408.39.02.70",
      "superior": null,
      "indent": "4",
      "description": "Sapele (Sapelli), Sipo or Utile (<u>Entandrophragma</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.39.0291",
      "rawHtsCode": "4408.39.02.91",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.01",
      "rawHtsCode": "4408.90.01",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4408.90.0105",
      "rawHtsCode": "4408.90.01.05",
      "superior": null,
      "indent": "3",
      "description": "Ash (<u>Fraxinus</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0110",
      "rawHtsCode": "4408.90.01.10",
      "superior": null,
      "indent": "3",
      "description": "Birch (<u>Betula</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0115",
      "rawHtsCode": "4408.90.01.15",
      "superior": null,
      "indent": "3",
      "description": "Cherry (<u>Prunus</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0121",
      "rawHtsCode": "4408.90.01.21",
      "superior": null,
      "indent": "3",
      "description": "Maple (<u>Acer</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0131",
      "rawHtsCode": "4408.90.01.31",
      "superior": null,
      "indent": "4",
      "description": "Red",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0137",
      "rawHtsCode": "4408.90.01.37",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0145",
      "rawHtsCode": "4408.90.01.45",
      "superior": null,
      "indent": "3",
      "description": "Walnut (<u>Juglans</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0151",
      "rawHtsCode": "4408.90.01.51",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0156",
      "rawHtsCode": "4408.90.01.56",
      "superior": null,
      "indent": "3",
      "description": "Ash (<u>Fraxinus</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0161",
      "rawHtsCode": "4408.90.01.61",
      "superior": null,
      "indent": "3",
      "description": "Birch (<u>Betula</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0166",
      "rawHtsCode": "4408.90.01.66",
      "superior": null,
      "indent": "3",
      "description": "Cherry (<u>Prunus</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0171",
      "rawHtsCode": "4408.90.01.71",
      "superior": null,
      "indent": "3",
      "description": "Maple (<u>Acer</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0176",
      "rawHtsCode": "4408.90.01.76",
      "superior": null,
      "indent": "4",
      "description": "Red",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0181",
      "rawHtsCode": "4408.90.01.81",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0187",
      "rawHtsCode": "4408.90.01.87",
      "superior": null,
      "indent": "3",
      "description": "Walnut (<u>Juglans</u> spp.)",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4408.90.0197",
      "rawHtsCode": "4408.90.01.97",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409",
      "rawHtsCode": "4409",
      "superior": null,
      "indent": "0",
      "description": "Wood (including strips and friezes for parquet flooring, not assembled) continuously shaped (tongued, grooved, rebated, chamfered, V-jointed, beaded, molded, rounded or the like) along any of its edges, ends or faces, whether or not planed, sanded or end-jointed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.10",
      "rawHtsCode": "4409.10",
      "superior": null,
      "indent": "1",
      "description": "Coniferous:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.10.0500",
      "rawHtsCode": "4409.10.05.00",
      "superior": null,
      "indent": "2",
      "description": "Wood continuously shaped along any of its ends, whether or not also continuously shaped along any of its edges or faces, all the foregoing whether or not planed, sanded or end-jointed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4409.10.10",
      "rawHtsCode": "4409.10.10",
      "superior": null,
      "indent": "3",
      "description": "Wood siding",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/m<sup>2</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4409.10.1020",
      "rawHtsCode": "4409.10.10.20",
      "superior": null,
      "indent": "5",
      "description": "Western red cedar",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.10.1040",
      "rawHtsCode": "4409.10.10.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.10.1060",
      "rawHtsCode": "4409.10.10.60",
      "superior": null,
      "indent": "5",
      "description": "Western red cedar",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.10.1080",
      "rawHtsCode": "4409.10.10.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.10.2000",
      "rawHtsCode": "4409.10.20.00",
      "superior": null,
      "indent": "3",
      "description": "Wood flooring",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4409.10.40",
      "rawHtsCode": "4409.10.40",
      "superior": null,
      "indent": "5",
      "description": "Pine (<u>Pinus</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4409.10.4010",
      "rawHtsCode": "4409.10.40.10",
      "superior": null,
      "indent": "6",
      "description": "End-jointed",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.10.4090",
      "rawHtsCode": "4409.10.40.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.10.4500",
      "rawHtsCode": "4409.10.45.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4409.10.5000",
      "rawHtsCode": "4409.10.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4409.10.6000",
      "rawHtsCode": "4409.10.60.00",
      "superior": null,
      "indent": "4",
      "description": "Plain",
      "units": [
        "m",
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4409.10.6500",
      "rawHtsCode": "4409.10.65.00",
      "superior": null,
      "indent": "4",
      "description": "Sanded, grooved, or otherwise advanced in condition",
      "units": [
        "m",
        "m<sup>3</sup>"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4409.10.90",
      "rawHtsCode": "4409.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.70/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4409.10.9020",
      "rawHtsCode": "4409.10.90.20",
      "superior": null,
      "indent": "4",
      "description": "Western red cedar",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.10.9040",
      "rawHtsCode": "4409.10.90.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.21",
      "rawHtsCode": "4409.21",
      "superior": null,
      "indent": "2",
      "description": "Of bamboo:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.21.0500",
      "rawHtsCode": "4409.21.05.00",
      "superior": null,
      "indent": "3",
      "description": "Wood continuously shaped along any of its ends, whether or not also continuously shaped along any of its edges or faces, all the foregoing whether or not planed, sanded or end-jointed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4409.21.9000",
      "rawHtsCode": "4409.21.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.70/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4409.22",
      "rawHtsCode": "4409.22",
      "superior": null,
      "indent": "2",
      "description": "Of tropical wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.05",
      "rawHtsCode": "4409.22.05",
      "superior": null,
      "indent": "3",
      "description": "Wood continuously shaped along any of its ends, whether or not also continuously shaped along any of its edges or faces, all the foregoing whether or not planed, sanded or end-jointed",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4409.22.0515",
      "rawHtsCode": "4409.22.05.15",
      "superior": null,
      "indent": "5",
      "description": "Jatoba (<u>Hymenaea</u> spp.), also known as Brazilian Cherry",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.0520",
      "rawHtsCode": "4409.22.05.20",
      "superior": null,
      "indent": "5",
      "description": "Ipé (<u>Tabebuia</u> spp. or <u>Handroanthus</u> spp.), also known as Tahibo or Taheebo, LaPacho or Lapacho, Brazilian walnut, and Patagonian walnut",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.0535",
      "rawHtsCode": "4409.22.05.35",
      "superior": null,
      "indent": "5",
      "description": "Santos mahogany (<u>Myroxylon</u> <u>balsamum</u>), also known as Cabreuva",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.0545",
      "rawHtsCode": "4409.22.05.45",
      "superior": null,
      "indent": "5",
      "description": "Cumaru (<u>Dipteryx</u> spp.), also known as Brazilian teak",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.0560",
      "rawHtsCode": "4409.22.05.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.0590",
      "rawHtsCode": "4409.22.05.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.1000",
      "rawHtsCode": "4409.22.10.00",
      "superior": null,
      "indent": "4",
      "description": "Wood siding",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.3¢/m<sup>2</sup><il></il><il></il><il></il>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4409.22.2500",
      "rawHtsCode": "4409.22.25.00",
      "superior": null,
      "indent": "4",
      "description": "Wood flooring",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4409.22.4000",
      "rawHtsCode": "4409.22.40.00",
      "superior": null,
      "indent": "5",
      "description": "Standard wood moldings",
      "units": [
        "m"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4409.22.50",
      "rawHtsCode": "4409.22.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4409.22.5020",
      "rawHtsCode": "4409.22.50.20",
      "superior": null,
      "indent": "6",
      "description": "Durian (<u>Durio</u> spp.)",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.5040",
      "rawHtsCode": "4409.22.50.40",
      "superior": null,
      "indent": "6",
      "description": "Jelutong (<u>Dyera</u> spp.)",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.5060",
      "rawHtsCode": "4409.22.50.60",
      "superior": null,
      "indent": "6",
      "description": "Obeche (<u>Triplochiton</u> spp.), also known as Ayous",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.5090",
      "rawHtsCode": "4409.22.50.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.6000",
      "rawHtsCode": "4409.22.60.00",
      "superior": null,
      "indent": "5",
      "description": "Plain",
      "units": [
        "m"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4409.22.6500",
      "rawHtsCode": "4409.22.65.00",
      "superior": null,
      "indent": "5",
      "description": "Sanded, grooved or otherwise advanced in condition",
      "units": [
        "m"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4409.22.90",
      "rawHtsCode": "4409.22.90",
      "superior": null,
      "indent": "4",
      "description": "Other<il></il><il></il><il></il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.70/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4409.22.9020",
      "rawHtsCode": "4409.22.90.20",
      "superior": null,
      "indent": "5",
      "description": "Cumaru (<u>Dipteryx</u> spp.), also known as Brazilian teak",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.9030",
      "rawHtsCode": "4409.22.90.30",
      "superior": null,
      "indent": "5",
      "description": "Ipé (<u>Tabebuia</u> spp. or <u>Handroanthus</u> spp.), also known as Tahibo or Taheebo, LaPacho or Lapacho, Brazilian walnut and Patagonian walnut<il></il>",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.9045",
      "rawHtsCode": "4409.22.90.45",
      "superior": null,
      "indent": "5",
      "description": "Keruing (<u>Dipterocarpus</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.9060",
      "rawHtsCode": "4409.22.90.60",
      "superior": null,
      "indent": "5",
      "description": "Padauk (Padouk) or Narra (<u>Pterocarpus</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.22.9090",
      "rawHtsCode": "4409.22.90.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.29",
      "rawHtsCode": "4409.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.29.06",
      "rawHtsCode": "4409.29.06",
      "superior": null,
      "indent": "3",
      "description": "Wood continuously shaped along any of its ends, whether or not also continuously shaped along any of its edges or faces, all the foregoing whether or not planed, sanded or end-jointed",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4409.29.0655",
      "rawHtsCode": "4409.29.06.55",
      "superior": null,
      "indent": "4",
      "description": "Wood flooring (end-matched)",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.29.0665",
      "rawHtsCode": "4409.29.06.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.29.1100",
      "rawHtsCode": "4409.29.11.00",
      "superior": null,
      "indent": "4",
      "description": "Wood siding",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.3¢/m<sup>2</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4409.29.26",
      "rawHtsCode": "4409.29.26",
      "superior": null,
      "indent": "4",
      "description": "Wood flooring",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4409.29.2630",
      "rawHtsCode": "4409.29.26.30",
      "superior": null,
      "indent": "5",
      "description": "Maple (<u>Acer</u> spp.)",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.29.2650",
      "rawHtsCode": "4409.29.26.50",
      "superior": null,
      "indent": "5",
      "description": "Birch (<u>Betula</u> spp.) and beech (<u>Fagus</u> spp.)",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.29.2660",
      "rawHtsCode": "4409.29.26.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4409.29.4100",
      "rawHtsCode": "4409.29.41.00",
      "superior": null,
      "indent": "5",
      "description": "Standard wood moldings",
      "units": [
        "m"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4409.29.5100",
      "rawHtsCode": "4409.29.51.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4409.29.6100",
      "rawHtsCode": "4409.29.61.00",
      "superior": null,
      "indent": "5",
      "description": "Plain",
      "units": [
        "m"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4409.29.6600",
      "rawHtsCode": "4409.29.66.00",
      "superior": null,
      "indent": "5",
      "description": "Sanded, grooved or otherwise advanced in condition",
      "units": [
        "m"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4409.29.9100",
      "rawHtsCode": "4409.29.91.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.70/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4410",
      "rawHtsCode": "4410",
      "superior": null,
      "indent": "0",
      "description": "Particle board, oriented strand board (OSB) and similar board (for example, waferboard) of wood or other ligneous materials, whether or not agglomerated with resins or other organic binding substances:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4410.11.00",
      "rawHtsCode": "4410.11.00",
      "superior": null,
      "indent": "2",
      "description": "Particle board",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4410.11.0010",
      "rawHtsCode": "4410.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Unworked or not further worked than sanded",
      "units": [
        "m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4410.11.0020",
      "rawHtsCode": "4410.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Surface-covered with melamine-impregnated paper",
      "units": [
        "m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4410.11.0030",
      "rawHtsCode": "4410.11.00.30",
      "superior": null,
      "indent": "3",
      "description": "Surface-covered with decorative laminates of plastic",
      "units": [
        "m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4410.11.0060",
      "rawHtsCode": "4410.11.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4410.12.00",
      "rawHtsCode": "4410.12.00",
      "superior": null,
      "indent": "2",
      "description": "Oriented strand board (OSB)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4410.12.0010",
      "rawHtsCode": "4410.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Unworked or not further worked than sanded",
      "units": [
        "m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4410.12.0020",
      "rawHtsCode": "4410.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4410.19.00",
      "rawHtsCode": "4410.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4410.19.0010",
      "rawHtsCode": "4410.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Unworked or not further worked than sanded",
      "units": [
        "m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4410.19.0020",
      "rawHtsCode": "4410.19.00.20",
      "superior": null,
      "indent": "3",
      "description": "Surface-covered with melamine-impregnated paper",
      "units": [
        "m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4410.19.0030",
      "rawHtsCode": "4410.19.00.30",
      "superior": null,
      "indent": "3",
      "description": "Surface-covered with decorative laminates of plastic",
      "units": [
        "m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4410.19.0060",
      "rawHtsCode": "4410.19.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4410.90.0000",
      "rawHtsCode": "4410.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411",
      "rawHtsCode": "4411",
      "superior": null,
      "indent": "0",
      "description": "Fiberboard of wood or other ligneous materials, whether or not bonded with resins or other organic substances:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.12",
      "rawHtsCode": "4411.12",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness not exceeding 5 mm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.12.1000",
      "rawHtsCode": "4411.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "Not mechanically worked or surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.12.2000",
      "rawHtsCode": "4411.12.20.00",
      "superior": null,
      "indent": "5",
      "description": "Laminated boards bonded in whole or in part, or impregnated, with synthetic resins",
      "units": [
        "kg",
        "m<sup>3</sup>"
      ],
      "generalRate": "1.9¢/kg + 1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33¢/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4411.12.3000",
      "rawHtsCode": "4411.12.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.12.6000",
      "rawHtsCode": "4411.12.60.00",
      "superior": null,
      "indent": "5",
      "description": "Not surface covered (except for oil treatment)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.12.90",
      "rawHtsCode": "4411.12.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4411.12.9010",
      "rawHtsCode": "4411.12.90.10",
      "superior": null,
      "indent": "6",
      "description": "Standard wood molding",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.12.9090",
      "rawHtsCode": "4411.12.90.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.13",
      "rawHtsCode": "4411.13",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness exceeding 5 mm but not exceeding 9 mm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.13.1000",
      "rawHtsCode": "4411.13.10.00",
      "superior": null,
      "indent": "3",
      "description": "Not mechanically worked or surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.13.2000",
      "rawHtsCode": "4411.13.20.00",
      "superior": null,
      "indent": "5",
      "description": "Laminated boards bonded in whole or in part, or impregnated, with synthetic resins",
      "units": [
        "kg",
        "m<sup>3</sup>"
      ],
      "generalRate": "1.9¢/kg + 1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33¢/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4411.13.3000",
      "rawHtsCode": "4411.13.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.13.6000",
      "rawHtsCode": "4411.13.60.00",
      "superior": null,
      "indent": "5",
      "description": "Not surface covered (except for oil treatment)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.13.90",
      "rawHtsCode": "4411.13.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4411.13.9010",
      "rawHtsCode": "4411.13.90.10",
      "superior": null,
      "indent": "6",
      "description": "Standard wood molding",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.13.9090",
      "rawHtsCode": "4411.13.90.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.14",
      "rawHtsCode": "4411.14",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness exceeding 9 mm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.14.1000",
      "rawHtsCode": "4411.14.10.00",
      "superior": null,
      "indent": "3",
      "description": "Not mechanically worked or surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4411.14.2000",
      "rawHtsCode": "4411.14.20.00",
      "superior": null,
      "indent": "5",
      "description": "Laminated boards bonded in whole or in part, or impregnated, with synthetic resins",
      "units": [
        "kg",
        "m<sup>3</sup>"
      ],
      "generalRate": "1.9¢/kg + 1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33¢/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4411.14.3000",
      "rawHtsCode": "4411.14.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.14.6000",
      "rawHtsCode": "4411.14.60.00",
      "superior": null,
      "indent": "5",
      "description": "Not surface covered (except for oil treatment)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4411.14.90",
      "rawHtsCode": "4411.14.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4411.14.9010",
      "rawHtsCode": "4411.14.90.10",
      "superior": null,
      "indent": "6",
      "description": "Standard wood molding",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.14.9090",
      "rawHtsCode": "4411.14.90.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.92",
      "rawHtsCode": "4411.92",
      "superior": null,
      "indent": "2",
      "description": "Of a density exceeding 0.8 g/cm<sup>3</sup> :",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.92.1000",
      "rawHtsCode": "4411.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "Not mechanically worked or surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4411.92.2000",
      "rawHtsCode": "4411.92.20.00",
      "superior": null,
      "indent": "4",
      "description": "Not surface covered (except for oil treatment)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.92.3000",
      "rawHtsCode": "4411.92.30.00",
      "superior": null,
      "indent": "5",
      "description": "Tileboard which has been continuously worked along any of its edges and is dedicated for use in the construction of walls, ceilings or other parts of buildings",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.92.4000",
      "rawHtsCode": "4411.92.40.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4411.93",
      "rawHtsCode": "4411.93",
      "superior": null,
      "indent": "2",
      "description": "Of a density exceeding 0.5 g/cm<sup>3</sup> but not exceeding 0.8 g/cm<sup>3</sup> :",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.93.1000",
      "rawHtsCode": "4411.93.10.00",
      "superior": null,
      "indent": "3",
      "description": "Not mechanically worked or surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.93.2000",
      "rawHtsCode": "4411.93.20.00",
      "superior": null,
      "indent": "5",
      "description": "Laminated boards bonded in whole or in part, or impregnated, with synthetic resins",
      "units": [
        "kg",
        "m<sup>3</sup>"
      ],
      "generalRate": "1.9¢/kg + 1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33¢/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4411.93.3000",
      "rawHtsCode": "4411.93.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.93.6000",
      "rawHtsCode": "4411.93.60.00",
      "superior": null,
      "indent": "5",
      "description": "Not surface covered (except for oil treatment)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.93.90",
      "rawHtsCode": "4411.93.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4411.93.9010",
      "rawHtsCode": "4411.93.90.10",
      "superior": null,
      "indent": "6",
      "description": "Standard wood molding",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.93.9090",
      "rawHtsCode": "4411.93.90.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.94.00",
      "rawHtsCode": "4411.94.00",
      "superior": null,
      "indent": "2",
      "description": "Of a density not exceeding 0.5 g/cm<sup>3</sup>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4411.94.0010",
      "rawHtsCode": "4411.94.00.10",
      "superior": null,
      "indent": "5",
      "description": "Impregnated with bitumen",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.94.0020",
      "rawHtsCode": "4411.94.00.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.94.0030",
      "rawHtsCode": "4411.94.00.30",
      "superior": null,
      "indent": "5",
      "description": "Impregnated with bitumen",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.94.0040",
      "rawHtsCode": "4411.94.00.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.94.0050",
      "rawHtsCode": "4411.94.00.50",
      "superior": null,
      "indent": "5",
      "description": "Impregnated with bitumen",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.94.0060",
      "rawHtsCode": "4411.94.00.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.94.0070",
      "rawHtsCode": "4411.94.00.70",
      "superior": null,
      "indent": "5",
      "description": "Impregnated with bitumen",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4411.94.0080",
      "rawHtsCode": "4411.94.00.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412",
      "rawHtsCode": "4412",
      "superior": null,
      "indent": "0",
      "description": "Plywood, veneered panels and similar laminated wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.10",
      "rawHtsCode": "4412.10",
      "superior": null,
      "indent": "1",
      "description": "Of bamboo:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.10.0500",
      "rawHtsCode": "4412.10.05.00",
      "superior": null,
      "indent": "2",
      "description": "Plywood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.10.9000",
      "rawHtsCode": "4412.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.31",
      "rawHtsCode": "4412.31",
      "superior": null,
      "indent": "2",
      "description": "With at least one outer ply of tropical wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.06",
      "rawHtsCode": "4412.31.06",
      "superior": null,
      "indent": "4",
      "description": "With a face ply of birch (<u>Betula</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4412.31.0620",
      "rawHtsCode": "4412.31.06.20",
      "superior": null,
      "indent": "5",
      "description": "Panels not exceeding in any dimension 3.6 mm in thickness, 1.2 m in width and 2.2 m in length",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.0640",
      "rawHtsCode": "4412.31.06.40",
      "superior": null,
      "indent": "6",
      "description": "Not surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.0660",
      "rawHtsCode": "4412.31.06.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.26",
      "rawHtsCode": "4412.31.26",
      "superior": null,
      "indent": "4",
      "description": "With a face ply of Spanish cedar (<u>Cedrela</u> spp.) or walnut (<u>Juglans</u> spp)",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.31.2610",
      "rawHtsCode": "4412.31.26.10",
      "superior": null,
      "indent": "5",
      "description": "With a face ply of Spanish cedar (<u>Cedrela</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.2620",
      "rawHtsCode": "4412.31.26.20",
      "superior": null,
      "indent": "5",
      "description": "With a face ply of walnut (<u>Juglans</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.4200",
      "rawHtsCode": "4412.31.42.00",
      "superior": null,
      "indent": "6",
      "description": "With a face ply of mahogany (<u>Swietenia</u> spp. or <u>Khaya</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.31.4500",
      "rawHtsCode": "4412.31.45.00",
      "superior": null,
      "indent": "6",
      "description": "Panels not exceeding 3.6 mm in thickness and exceeding 1.2 m in width and 2.2 m in length",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.31.48",
      "rawHtsCode": "4412.31.48",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.31.4850",
      "rawHtsCode": "4412.31.48.50",
      "superior": null,
      "indent": "7",
      "description": "Panels not exceeding 3.6 mm in thickness and not exceeding 1.2 m in width and 2.2 m in length",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.4860",
      "rawHtsCode": "4412.31.48.60",
      "superior": null,
      "indent": "9",
      "description": "Dark Red Meranti, Light Red Meranti or White Lauan (Luan) (<u>Shorea</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.4863",
      "rawHtsCode": "4412.31.48.63",
      "superior": null,
      "indent": "9",
      "description": "Limba (<u>Terminalia</u> spp.), also known as Terminalia and Nargusta",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.4866",
      "rawHtsCode": "4412.31.48.66",
      "superior": null,
      "indent": "9",
      "description": "Virola (<u>Virola</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.4869",
      "rawHtsCode": "4412.31.48.69",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.4875",
      "rawHtsCode": "4412.31.48.75",
      "superior": null,
      "indent": "9",
      "description": "Wood flooring",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.4880",
      "rawHtsCode": "4412.31.48.80",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.52",
      "rawHtsCode": "4412.31.52",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.31.5225",
      "rawHtsCode": "4412.31.52.25",
      "superior": null,
      "indent": "6",
      "description": "Wood flooring",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.5235",
      "rawHtsCode": "4412.31.52.35",
      "superior": null,
      "indent": "7",
      "description": "With a face ply of sen (<u>Kalopanax</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.5255",
      "rawHtsCode": "4412.31.52.55",
      "superior": null,
      "indent": "8",
      "description": "Panels not exceeding in any dimension 3.6 mm in thickness, 1.2 m in width and 2.2 m in length",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.5260",
      "rawHtsCode": "4412.31.52.60",
      "superior": null,
      "indent": "10",
      "description": "Albizia (<u>Albizia</u> spp.), also known as Falcata, Batai and Suar wood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.5262",
      "rawHtsCode": "4412.31.52.62",
      "superior": null,
      "indent": "10",
      "description": "Bintangor (<u>Calophyllum</u> spp.)",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.5264",
      "rawHtsCode": "4412.31.52.64",
      "superior": null,
      "indent": "10",
      "description": "Mersawa (<u>Anisoptera</u> spp.)",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.5266",
      "rawHtsCode": "4412.31.52.66",
      "superior": null,
      "indent": "10",
      "description": "Parica (<u>Schizolobium</u> spp.), also known as Pinho Cuiabano, Firetree and Guapuruvu",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.5268",
      "rawHtsCode": "4412.31.52.68",
      "superior": null,
      "indent": "10",
      "description": "Pencil cedar, Nyatoh (<u>Palaquium</u> spp.)",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.5270",
      "rawHtsCode": "4412.31.52.70",
      "superior": null,
      "indent": "10",
      "description": "Other",
      "units": [
        "m<sup style=\"font-size: 9.75px;\">3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.5275",
      "rawHtsCode": "4412.31.52.75",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.31.6100",
      "rawHtsCode": "4412.31.61.00",
      "superior": null,
      "indent": "4",
      "description": "With at least one outer ply of the following tropical woods: Dark Red Meranti, Light Red Meranti, White Lauan, Sipo, Limba, Okoumé, Obeche, Acajou d'Afrique, Sapelli, Virola, Mahogany, Palissandre de Para, Palissandre de Rio or Palissandre de Rose",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.31.9200",
      "rawHtsCode": "4412.31.92.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.33",
      "rawHtsCode": "4412.33",
      "superior": null,
      "indent": "2",
      "description": "Other, with at least one outer ply of nonconiferous wood of the species alder (<u>Alnus</u> spp.), ash (<u>Fraxinus</u> spp.), beech (<u>Fagus</u> spp.), birch (<u>Betula</u> spp.), cherry (<u>Prunus</u> spp.), chestnut (<u>Castanea</u> spp.), elm (<u>Ulmus</u> spp.), eucalyptus (<u>Eucalyptus</u> spp.), hickory (<u>Carya</u> spp.), horse chestnut (<u>Aesculus</u> spp.), lime (<u>Tilia</u> spp.), maple (<u>Acer</u> spp.), oak (<u>Quercus</u> spp.), plane tree (<u>Platanus</u> spp.), poplar and aspen (<u>Populus</u> spp.), robinia (<u>Robinia</u> spp.), tulipwood (<u>Liriodendron</u> spp.) or walnut (<u>Juglans</u> spp.):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.06",
      "rawHtsCode": "4412.33.06",
      "superior": null,
      "indent": "4",
      "description": "With a face ply of birch (<u>Betula</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4412.33.0620",
      "rawHtsCode": "4412.33.06.20",
      "superior": null,
      "indent": "5",
      "description": "Panels not exceeding in any dimension 3.6 mm in thickness, 1.2 m in width and 2.2 m in length",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.0640",
      "rawHtsCode": "4412.33.06.40",
      "superior": null,
      "indent": "6",
      "description": "Not surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.0665",
      "rawHtsCode": "4412.33.06.65",
      "superior": null,
      "indent": "7",
      "description": "Wood flooring",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.0670",
      "rawHtsCode": "4412.33.06.70",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.26",
      "rawHtsCode": "4412.33.26",
      "superior": null,
      "indent": "4",
      "description": "With a face ply of walnut (<u>Juglans</u> spp.)",
      "units": [],
      "generalRate": "5.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.33.2625",
      "rawHtsCode": "4412.33.26.25",
      "superior": null,
      "indent": "5",
      "description": "Wood flooring",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.2630",
      "rawHtsCode": "4412.33.26.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.32",
      "rawHtsCode": "4412.33.32",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.33.3225",
      "rawHtsCode": "4412.33.32.25",
      "superior": null,
      "indent": "5",
      "description": "Wood flooring",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.3235",
      "rawHtsCode": "4412.33.32.35",
      "superior": null,
      "indent": "6",
      "description": "With a face ply of sen (<u>Kalopanax</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.3255",
      "rawHtsCode": "4412.33.32.55",
      "superior": null,
      "indent": "6",
      "description": "With a face ply of mahogany (<u>Swietenia</u> spp. or <u>Khaya</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.3265",
      "rawHtsCode": "4412.33.32.65",
      "superior": null,
      "indent": "7",
      "description": "Panels not exceeding in any dimension 3.6 mm in thickness, 1.2 m in width and 2.2 m in length",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.3275",
      "rawHtsCode": "4412.33.32.75",
      "superior": null,
      "indent": "8",
      "description": "Not surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.3285",
      "rawHtsCode": "4412.33.32.85",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.33.5700",
      "rawHtsCode": "4412.33.57.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.34",
      "rawHtsCode": "4412.34",
      "superior": null,
      "indent": "2",
      "description": "Other, with at least one outer ply of nonconiferous wood not specified under subheading 4412.33:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.34.2600",
      "rawHtsCode": "4412.34.26.00",
      "superior": null,
      "indent": "4",
      "description": "With a face ply of Spanish cedar (<u>Cedrela</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.34.32",
      "rawHtsCode": "4412.34.32",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.34.3225",
      "rawHtsCode": "4412.34.32.25",
      "superior": null,
      "indent": "5",
      "description": "Wood flooring",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.34.3235",
      "rawHtsCode": "4412.34.32.35",
      "superior": null,
      "indent": "6",
      "description": "With a face ply of sen (<u>Kalopanax</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.34.3255",
      "rawHtsCode": "4412.34.32.55",
      "superior": null,
      "indent": "6",
      "description": "With a face ply of mahogany (<u>Swietenia</u> spp. or <u>Khaya</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.34.3265",
      "rawHtsCode": "4412.34.32.65",
      "superior": null,
      "indent": "7",
      "description": "Panels not exceeding in any dimension 3.6 mm in thickness, 1.2 m in width and 2.2 m in length",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.34.3275",
      "rawHtsCode": "4412.34.32.75",
      "superior": null,
      "indent": "8",
      "description": "Not surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.34.3285",
      "rawHtsCode": "4412.34.32.85",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.34.5700",
      "rawHtsCode": "4412.34.57.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.39",
      "rawHtsCode": "4412.39",
      "superior": null,
      "indent": "2",
      "description": "Other, with both outer plies of coniferous wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.1000",
      "rawHtsCode": "4412.39.10.00",
      "superior": null,
      "indent": "4",
      "description": "With a face ply of Parana pine (<u>Araucaria</u> <u>angustifolia</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4412.39.3000",
      "rawHtsCode": "4412.39.30.00",
      "superior": null,
      "indent": "4",
      "description": "With a face ply of European red pine (<u>Pinus</u> <u>silvestris</u>)    ",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.39.40",
      "rawHtsCode": "4412.39.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.39.4011",
      "rawHtsCode": "4412.39.40.11",
      "superior": null,
      "indent": "6",
      "description": "Rough, or touch sanded for sizing purposes, but not further processed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.4012",
      "rawHtsCode": "4412.39.40.12",
      "superior": null,
      "indent": "6",
      "description": "Fully sanded on at least one face, but not further processed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.4019",
      "rawHtsCode": "4412.39.40.19",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.4031",
      "rawHtsCode": "4412.39.40.31",
      "superior": null,
      "indent": "6",
      "description": "Rough, or touch sanded for sizing purposes, but not further processed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.4032",
      "rawHtsCode": "4412.39.40.32",
      "superior": null,
      "indent": "6",
      "description": "Fully sanded on at least one face, but not further processed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.4039",
      "rawHtsCode": "4412.39.40.39",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.4051",
      "rawHtsCode": "4412.39.40.51",
      "superior": null,
      "indent": "6",
      "description": "Rough, or touch sanded for sizing purposes, but not further processed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.4052",
      "rawHtsCode": "4412.39.40.52",
      "superior": null,
      "indent": "6",
      "description": "Fully sanded on at least one face, but not further processed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.4059",
      "rawHtsCode": "4412.39.40.59",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.4061",
      "rawHtsCode": "4412.39.40.61",
      "superior": null,
      "indent": "6",
      "description": "Rough, or touch sanded for sizing purposes, but not further processed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.4062",
      "rawHtsCode": "4412.39.40.62",
      "superior": null,
      "indent": "6",
      "description": "Fully sanded on at least one face, but not further processed",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.4069",
      "rawHtsCode": "4412.39.40.69",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.50",
      "rawHtsCode": "4412.39.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.39.5010",
      "rawHtsCode": "4412.39.50.10",
      "superior": null,
      "indent": "4",
      "description": "With at least one outer ply of Douglas fir (<u>Pseudotsuga</u> <u>menziesii</u>) ",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.5030",
      "rawHtsCode": "4412.39.50.30",
      "superior": null,
      "indent": "4",
      "description": "With at least one outer ply of long leaf pine (<u>Pinus</u> <u>palustris</u>), short leaf pine (<u>Pinus</u> <u>echinata</u>), southern yellow pine (loblolly pine) (<u>Pinus</u> <u>taeda</u>), slash pine (<u>Pinus</u> <u>elliotti</u>), pitch pine (<u>Pinus</u> <u>rigida</u>) or Virginia pine (<u>Pinus</u> <u>virginiana</u>) ",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.39.5050",
      "rawHtsCode": "4412.39.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.41.0000",
      "rawHtsCode": "4412.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "With at least one outer ply of tropical wood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.42.0000",
      "rawHtsCode": "4412.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, with at least one outer ply of nonconiferous wood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.49.0000",
      "rawHtsCode": "4412.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, with both outer plies of coniferous wood",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.51",
      "rawHtsCode": "4412.51",
      "superior": null,
      "indent": "2",
      "description": "With at least one outer ply of tropical wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.51.10",
      "rawHtsCode": "4412.51.10",
      "superior": null,
      "indent": "5",
      "description": "With a face ply of birch (<u>Betula</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.51.1030",
      "rawHtsCode": "4412.51.10.30",
      "superior": null,
      "indent": "6",
      "description": "Not surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.51.1050",
      "rawHtsCode": "4412.51.10.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.51.31",
      "rawHtsCode": "4412.51.31",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.51.3105",
      "rawHtsCode": "4412.51.31.05",
      "superior": null,
      "indent": "6",
      "description": "Wood flooring",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.51.3111",
      "rawHtsCode": "4412.51.31.11",
      "superior": null,
      "indent": "7",
      "description": "With a face ply of Spanish cedar (<u>Cedrela</u> spp.)  ",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.51.3121",
      "rawHtsCode": "4412.51.31.21",
      "superior": null,
      "indent": "7",
      "description": "With a face ply of walnut (<u>Juglans</u> spp.)  ",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.51.3141",
      "rawHtsCode": "4412.51.31.41",
      "superior": null,
      "indent": "7",
      "description": "With a face ply of mahogany (<u>Swietenia</u> spp. or <u>Khaya</u> spp.)",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.51.3161",
      "rawHtsCode": "4412.51.31.61",
      "superior": null,
      "indent": "8",
      "description": "Not surface covered",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.51.3175",
      "rawHtsCode": "4412.51.31.75",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.51.4100",
      "rawHtsCode": "4412.51.41.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.51.5100",
      "rawHtsCode": "4412.51.51.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.52",
      "rawHtsCode": "4412.52",
      "superior": null,
      "indent": "2",
      "description": "Other, with at least one outer ply of nonconiferous wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.52.10",
      "rawHtsCode": "4412.52.10",
      "superior": null,
      "indent": "5",
      "description": "With a face ply of birch (<u>Betula</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.52.1030",
      "rawHtsCode": "4412.52.10.30",
      "superior": null,
      "indent": "6",
      "description": "Not surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.52.1050",
      "rawHtsCode": "4412.52.10.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.52.31",
      "rawHtsCode": "4412.52.31",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.52.3105",
      "rawHtsCode": "4412.52.31.05",
      "superior": null,
      "indent": "6",
      "description": "Wood flooring",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.52.3121",
      "rawHtsCode": "4412.52.31.21",
      "superior": null,
      "indent": "7",
      "description": "With a face ply of walnut (<u>Juglans</u> spp.)  ",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.52.3161",
      "rawHtsCode": "4412.52.31.61",
      "superior": null,
      "indent": "8",
      "description": "Not surface covered",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.52.3175",
      "rawHtsCode": "4412.52.31.75",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.52.4100",
      "rawHtsCode": "4412.52.41.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.52.5100",
      "rawHtsCode": "4412.52.51.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.59",
      "rawHtsCode": "4412.59",
      "superior": null,
      "indent": "2",
      "description": "Other, with both outer plies of coniferous wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.59.6000",
      "rawHtsCode": "4412.59.60.00",
      "superior": null,
      "indent": "5",
      "description": "With a face ply of Parana pine (<u>Araucaria</u> <u>angustifolia</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.59.7000",
      "rawHtsCode": "4412.59.70.00",
      "superior": null,
      "indent": "5",
      "description": "With a face ply of European red pine (<u>Pinus silvestris</u>)    ",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.59.8000",
      "rawHtsCode": "4412.59.80.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.59.9000",
      "rawHtsCode": "4412.59.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.59.9500",
      "rawHtsCode": "4412.59.95.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.91",
      "rawHtsCode": "4412.91",
      "superior": null,
      "indent": "2",
      "description": "With at least one outer ply of tropical wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.91.0600",
      "rawHtsCode": "4412.91.06.00",
      "superior": null,
      "indent": "3",
      "description": "Containing at least one layer of particle board",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.91.10",
      "rawHtsCode": "4412.91.10",
      "superior": null,
      "indent": "6",
      "description": "With a face ply of birch (<u>Betula</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.91.1020",
      "rawHtsCode": "4412.91.10.20",
      "superior": null,
      "indent": "7",
      "description": "Panels not exceeding in any dimension 3.6 mm in thickness, 1.2 m in width and 2.2 m in length",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.91.1030",
      "rawHtsCode": "4412.91.10.30",
      "superior": null,
      "indent": "8",
      "description": "Not surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.91.1040",
      "rawHtsCode": "4412.91.10.40",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.91.31",
      "rawHtsCode": "4412.91.31",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.91.3110",
      "rawHtsCode": "4412.91.31.10",
      "superior": null,
      "indent": "7",
      "description": "With a face ply of Spanish cedar (<u>Cedrela</u> spp.) ",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.91.3120",
      "rawHtsCode": "4412.91.31.20",
      "superior": null,
      "indent": "7",
      "description": "With a face ply of walnut (<u>Juglans</u> spp.) ",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.91.3130",
      "rawHtsCode": "4412.91.31.30",
      "superior": null,
      "indent": "7",
      "description": "With a face ply of sen (<u>Kalopanax</u> spp.) ",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.91.3140",
      "rawHtsCode": "4412.91.31.40",
      "superior": null,
      "indent": "7",
      "description": "With a face ply of mahogany (<u>Swietenia</u> spp. or <u>Khaya</u> spp.)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.91.3150",
      "rawHtsCode": "4412.91.31.50",
      "superior": null,
      "indent": "8",
      "description": "Panels not exceeding in any dimension 3.6 mm in thickness, 1.2 m in width, and 2.2 m in length",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.91.3160",
      "rawHtsCode": "4412.91.31.60",
      "superior": null,
      "indent": "8",
      "description": "Other, not surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.91.3170",
      "rawHtsCode": "4412.91.31.70",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.91.4100",
      "rawHtsCode": "4412.91.41.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.91.51",
      "rawHtsCode": "4412.91.51",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.91.5105",
      "rawHtsCode": "4412.91.51.05",
      "superior": null,
      "indent": "5",
      "description": "Wood flooring",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.91.5115",
      "rawHtsCode": "4412.91.51.15",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.92",
      "rawHtsCode": "4412.92",
      "superior": null,
      "indent": "2",
      "description": "Other, with at least one outer ply of nonconiferous wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.92.0700",
      "rawHtsCode": "4412.92.07.00",
      "superior": null,
      "indent": "3",
      "description": "Containing at least one layer of particle board",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.92.11",
      "rawHtsCode": "4412.92.11",
      "superior": null,
      "indent": "6",
      "description": "With a face ply of birch (<u>Betula</u> spp.)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.92.1120",
      "rawHtsCode": "4412.92.11.20",
      "superior": null,
      "indent": "7",
      "description": "Panels not exceeding in any dimension 3.6 mm in thickness, 1.2 m in width and 2.2 m in length",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.92.1130",
      "rawHtsCode": "4412.92.11.30",
      "superior": null,
      "indent": "8",
      "description": "Not surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.92.1140",
      "rawHtsCode": "4412.92.11.40",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.92.31",
      "rawHtsCode": "4412.92.31",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.92.3120",
      "rawHtsCode": "4412.92.31.20",
      "superior": null,
      "indent": "7",
      "description": "With a face ply of walnut (<u>Juglans</u> spp.) ",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.92.3150",
      "rawHtsCode": "4412.92.31.50",
      "superior": null,
      "indent": "8",
      "description": "Panels not exceeding in any dimension 3.6 mm in thickness, 1.2 m in width, and 2.2 m in length",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.92.3160",
      "rawHtsCode": "4412.92.31.60",
      "superior": null,
      "indent": "8",
      "description": "Other, not surface covered",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.92.3170",
      "rawHtsCode": "4412.92.31.70",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.92.4200",
      "rawHtsCode": "4412.92.42.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.92.52",
      "rawHtsCode": "4412.92.52",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.92.5205",
      "rawHtsCode": "4412.92.52.05",
      "superior": null,
      "indent": "5",
      "description": "Wood flooring",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.92.5215",
      "rawHtsCode": "4412.92.52.15",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.99",
      "rawHtsCode": "4412.99",
      "superior": null,
      "indent": "2",
      "description": "Other, with both outer plies of coniferous wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4412.99.5800",
      "rawHtsCode": "4412.99.58.00",
      "superior": null,
      "indent": "3",
      "description": "Containing at least one layer of particle board",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.99.6100",
      "rawHtsCode": "4412.99.61.00",
      "superior": null,
      "indent": "6",
      "description": "With a face ply of Parana pine (<u>Araucaria</u> <u>angustifolia</u>)",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4412.99.7100",
      "rawHtsCode": "4412.99.71.00",
      "superior": null,
      "indent": "6",
      "description": "With a face ply of European red pine (<u>Pinus silvestris</u>)    ",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.99.8100",
      "rawHtsCode": "4412.99.81.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.99.9100",
      "rawHtsCode": "4412.99.91.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4412.99.9700",
      "rawHtsCode": "4412.99.97.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4413.00.0000",
      "rawHtsCode": "4413.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Densified wood, in blocks, plates, strips or profile shapes",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4414",
      "rawHtsCode": "4414",
      "superior": null,
      "indent": "0",
      "description": "Wooden frames for paintings, photographs, mirrors or similar objects:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4414.10.0000",
      "rawHtsCode": "4414.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of tropical wood",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4414.90.0000",
      "rawHtsCode": "4414.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4415",
      "rawHtsCode": "4415",
      "superior": null,
      "indent": "0",
      "description": "Packing cases, boxes, crates, drums and similar packings, of wood; cable-drums, of wood; pallets, box-pallets and other load boards, of wood; pallet collars of wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4415.10",
      "rawHtsCode": "4415.10",
      "superior": null,
      "indent": "1",
      "description": "Cases, boxes, crates, drums and similar packings; cable-drums:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4415.10.3000",
      "rawHtsCode": "4415.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Packing boxes and cases with solid sides, lids and bottoms",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4415.10.6000",
      "rawHtsCode": "4415.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Containers designed for use in the harvesting of fruits and vegetables",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4415.10.9000",
      "rawHtsCode": "4415.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "10.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4415.20",
      "rawHtsCode": "4415.20",
      "superior": null,
      "indent": "1",
      "description": "Pallets, box-pallets and other load boards; pallet collars:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4415.20.4000",
      "rawHtsCode": "4415.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Containers designed for use in the harvesting of fruits and vegetables",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4415.20.8000",
      "rawHtsCode": "4415.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "10.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4416.00",
      "rawHtsCode": "4416.00",
      "superior": null,
      "indent": "0",
      "description": "Casks, barrels, vats, tubs and other coopers' products and parts thereof, of wood, including staves:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4416.00.30",
      "rawHtsCode": "4416.00.30",
      "superior": null,
      "indent": "1",
      "description": "Casks, barrels and hogsheads",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4416.00.3010",
      "rawHtsCode": "4416.00.30.10",
      "superior": null,
      "indent": "2",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4416.00.3020",
      "rawHtsCode": "4416.00.30.20",
      "superior": null,
      "indent": "3",
      "description": "Assembled (set up)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4416.00.3030",
      "rawHtsCode": "4416.00.30.30",
      "superior": null,
      "indent": "3",
      "description": "Unassembled (knocked down)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4416.00.60",
      "rawHtsCode": "4416.00.60",
      "superior": null,
      "indent": "1",
      "description": "Staves and hoops; tight barrelheads of softwood",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4416.00.6010",
      "rawHtsCode": "4416.00.60.10",
      "superior": null,
      "indent": "3",
      "description": "Staves",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4416.00.6020",
      "rawHtsCode": "4416.00.60.20",
      "superior": null,
      "indent": "3",
      "description": "Hoops",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4416.00.6030",
      "rawHtsCode": "4416.00.60.30",
      "superior": null,
      "indent": "3",
      "description": "Tight barrelheads",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4416.00.6040",
      "rawHtsCode": "4416.00.60.40",
      "superior": null,
      "indent": "3",
      "description": "Staves",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4416.00.6050",
      "rawHtsCode": "4416.00.60.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4416.00.90",
      "rawHtsCode": "4416.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4416.00.9020",
      "rawHtsCode": "4416.00.90.20",
      "superior": null,
      "indent": "2",
      "description": "New",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4416.00.9040",
      "rawHtsCode": "4416.00.90.40",
      "superior": null,
      "indent": "2",
      "description": "Used",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4417.00",
      "rawHtsCode": "4417.00",
      "superior": null,
      "indent": "0",
      "description": "Tools, tool bodies, tool handles, broom or brush bodies and handles, of wood; boot or shoe lasts and trees, of wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4417.00.2000",
      "rawHtsCode": "4417.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Broom and mop handles, 1.9 cm or more in diameter and 97 cm or more in length",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4417.00.4000",
      "rawHtsCode": "4417.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Paint brush and paint roller handles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4417.00.6000",
      "rawHtsCode": "4417.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Brush backs",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4417.00.80",
      "rawHtsCode": "4417.00.80",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "5.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4417.00.8010",
      "rawHtsCode": "4417.00.80.10",
      "superior": null,
      "indent": "2",
      "description": "Tool handles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4417.00.8090",
      "rawHtsCode": "4417.00.80.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418",
      "rawHtsCode": "4418",
      "superior": null,
      "indent": "0",
      "description": "Builders' joinery and carpentry of wood, including cellular wood panels and assembled flooring panels; shingles and shakes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.11.0000",
      "rawHtsCode": "4418.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of tropical wood",
      "units": [
        "No."
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.19.0000",
      "rawHtsCode": "4418.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.21",
      "rawHtsCode": "4418.21",
      "superior": null,
      "indent": "2",
      "description": "Of tropical wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.21.4000",
      "rawHtsCode": "4418.21.40.00",
      "superior": null,
      "indent": "3",
      "description": "French doors",
      "units": [
        "No."
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.21.80",
      "rawHtsCode": "4418.21.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.21.8030",
      "rawHtsCode": "4418.21.80.30",
      "superior": null,
      "indent": "4",
      "description": "Flush doors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.21.8060",
      "rawHtsCode": "4418.21.80.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.29",
      "rawHtsCode": "4418.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.29.4000",
      "rawHtsCode": "4418.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "French doors",
      "units": [
        "No."
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.29.80",
      "rawHtsCode": "4418.29.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.29.8030",
      "rawHtsCode": "4418.29.80.30",
      "superior": null,
      "indent": "4",
      "description": "Flush doors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.29.8060",
      "rawHtsCode": "4418.29.80.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.30.0100",
      "rawHtsCode": "4418.30.01.00",
      "superior": null,
      "indent": "1",
      "description": "Posts and beams other than products of subheadings 4418.81 to 4418.89",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.40.0000",
      "rawHtsCode": "4418.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Formwork (shuttering) for concrete constructional work",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.50.00",
      "rawHtsCode": "4418.50.00",
      "superior": null,
      "indent": "1",
      "description": "Shingles and shakes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4418.50.0010",
      "rawHtsCode": "4418.50.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of western red cedar",
      "units": [
        "square",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.50.0030",
      "rawHtsCode": "4418.50.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "square",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.50.0050",
      "rawHtsCode": "4418.50.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "square",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.73",
      "rawHtsCode": "4418.73",
      "superior": null,
      "indent": "2",
      "description": "Of bamboo or with at least the top layer (wear layer) of bamboo:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.73.1000",
      "rawHtsCode": "4418.73.10.00",
      "superior": null,
      "indent": "4",
      "description": "Solid",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4418.73.2000",
      "rawHtsCode": "4418.73.20.00",
      "superior": null,
      "indent": "5",
      "description": "Having a face ply more than 6 mm in thickness",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4418.73.3000",
      "rawHtsCode": "4418.73.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.73.4000",
      "rawHtsCode": "4418.73.40.00",
      "superior": null,
      "indent": "4",
      "description": "Having a face ply more than 6 mm in thickness",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.73.6000",
      "rawHtsCode": "4418.73.60.00",
      "superior": null,
      "indent": "5",
      "description": "Of unidirectional bamboo",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4418.73.7000",
      "rawHtsCode": "4418.73.70.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.73.9000",
      "rawHtsCode": "4418.73.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.74",
      "rawHtsCode": "4418.74",
      "superior": null,
      "indent": "2",
      "description": "Other, for mosaic floors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.74.1000",
      "rawHtsCode": "4418.74.10.00",
      "superior": null,
      "indent": "3",
      "description": "Solid",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4418.74.2000",
      "rawHtsCode": "4418.74.20.00",
      "superior": null,
      "indent": "4",
      "description": "Having a face ply more than 6 mm in thickness",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4418.74.9000",
      "rawHtsCode": "4418.74.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.75",
      "rawHtsCode": "4418.75",
      "superior": null,
      "indent": "2",
      "description": "Other, multilayer:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.75.4000",
      "rawHtsCode": "4418.75.40.00",
      "superior": null,
      "indent": "3",
      "description": "Having a face ply more than 6 mm in thickness",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.75.7000",
      "rawHtsCode": "4418.75.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.79.0100",
      "rawHtsCode": "4418.79.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.81.0000",
      "rawHtsCode": "4418.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "Glue-laminated timber (glulam)",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.82.0000",
      "rawHtsCode": "4418.82.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cross-laminated timber (CLT or X-lam)",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.83.0000",
      "rawHtsCode": "4418.83.00.00",
      "superior": null,
      "indent": "2",
      "description": "I-beams",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.89.0000",
      "rawHtsCode": "4418.89.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.91",
      "rawHtsCode": "4418.91",
      "superior": null,
      "indent": "2",
      "description": "Of bamboo:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.91.1000",
      "rawHtsCode": "4418.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Drilled or notched lumber studs",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.70/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4418.91.91",
      "rawHtsCode": "4418.91.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.91.9105",
      "rawHtsCode": "4418.91.91.05",
      "superior": null,
      "indent": "4",
      "description": "Wood flooring",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.91.9110",
      "rawHtsCode": "4418.91.91.10",
      "superior": null,
      "indent": "5",
      "description": "Arches, laminated",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.91.9120",
      "rawHtsCode": "4418.91.91.20",
      "superior": null,
      "indent": "5",
      "description": "Roof trusses",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.91.9140",
      "rawHtsCode": "4418.91.91.40",
      "superior": null,
      "indent": "5",
      "description": "Other fabricated structural wood members",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.91.9150",
      "rawHtsCode": "4418.91.91.50",
      "superior": null,
      "indent": "5",
      "description": "Prefabricated partitions and panels for buildings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.91.9195",
      "rawHtsCode": "4418.91.91.95",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.92.0000",
      "rawHtsCode": "4418.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cellular wood panels",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.99",
      "rawHtsCode": "4418.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.99.1000",
      "rawHtsCode": "4418.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Drilled or notched lumber studs",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.70/m<sup>3</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4418.99.91",
      "rawHtsCode": "4418.99.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4418.99.9105",
      "rawHtsCode": "4418.99.91.05",
      "superior": null,
      "indent": "4",
      "description": "Wood flooring",
      "units": [
        "m<sup>2</sup>",
        "m<sup>3</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.99.9110",
      "rawHtsCode": "4418.99.91.10",
      "superior": null,
      "indent": "5",
      "description": "Arches, laminated",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.99.9120",
      "rawHtsCode": "4418.99.91.20",
      "superior": null,
      "indent": "5",
      "description": "Roof trusses",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.99.9140",
      "rawHtsCode": "4418.99.91.40",
      "superior": null,
      "indent": "5",
      "description": "Other fabricated structural wood members",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.99.9150",
      "rawHtsCode": "4418.99.91.50",
      "superior": null,
      "indent": "5",
      "description": "Prefabricated partitions and panels for buildings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4418.99.9195",
      "rawHtsCode": "4418.99.91.95",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4419",
      "rawHtsCode": "4419",
      "superior": null,
      "indent": "0",
      "description": "Tableware and kitchenware, of wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4419.11.0000",
      "rawHtsCode": "4419.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Bread boards, chopping boards and similar boards",
      "units": [
        "No."
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) ",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4419.12.0000",
      "rawHtsCode": "4419.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Chopsticks",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) ",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4419.19",
      "rawHtsCode": "4419.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4419.19.1000",
      "rawHtsCode": "4419.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Forks and spoons",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4419.19.9000",
      "rawHtsCode": "4419.19.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4419.20",
      "rawHtsCode": "4419.20",
      "superior": null,
      "indent": "1",
      "description": "Of tropical wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4419.20.1000",
      "rawHtsCode": "4419.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Forks and spoons",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4419.20.9000",
      "rawHtsCode": "4419.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4419.90",
      "rawHtsCode": "4419.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4419.90.1100",
      "rawHtsCode": "4419.90.11.00",
      "superior": null,
      "indent": "2",
      "description": "Forks and spoons",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4419.90.9100",
      "rawHtsCode": "4419.90.91.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4420",
      "rawHtsCode": "4420",
      "superior": null,
      "indent": "0",
      "description": "Wood marquetry and inlaid wood; caskets and cases for jewelry or cutlery and similar articles, of wood; statuettes and other ornaments, of wood; wooden articles of furniture not falling within chapter 94:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4420.11.00",
      "rawHtsCode": "4420.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of tropical wood",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4420.11.0010",
      "rawHtsCode": "4420.11.00.10",
      "superior": null,
      "indent": "4",
      "description": "Of mango wood (<i>Mangifera spp.)</i>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4420.11.0030",
      "rawHtsCode": "4420.11.00.30",
      "superior": null,
      "indent": "4",
      "description": "Of teak (<i>Tectona spp.</i>)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4420.11.0090",
      "rawHtsCode": "4420.11.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4420.19.0000",
      "rawHtsCode": "4420.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4420.90",
      "rawHtsCode": "4420.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4420.90.2000",
      "rawHtsCode": "4420.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Cigar and cigarette boxes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4420.90.4500",
      "rawHtsCode": "4420.90.45.00",
      "superior": null,
      "indent": "4",
      "description": "Not lined with textile fabrics",
      "units": [
        "No."
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4420.90.6500",
      "rawHtsCode": "4420.90.65.00",
      "superior": null,
      "indent": "4",
      "description": "Lined with textile fabrics",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4420.90.8000",
      "rawHtsCode": "4420.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421",
      "rawHtsCode": "4421",
      "superior": null,
      "indent": "0",
      "description": "Other articles of wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.10.0000",
      "rawHtsCode": "4421.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Clothes hangers",
      "units": [
        "hundreds"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.20",
      "rawHtsCode": "4421.20",
      "superior": null,
      "indent": "1",
      "description": "Coffins:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.20.1000",
      "rawHtsCode": "4421.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of bamboo",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.20.2000",
      "rawHtsCode": "4421.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.91",
      "rawHtsCode": "4421.91",
      "superior": null,
      "indent": "2",
      "description": "Of bamboo:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.91.1000",
      "rawHtsCode": "4421.91.10.00",
      "superior": null,
      "indent": "4",
      "description": "Plain",
      "units": [
        "m"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4421.91.2000",
      "rawHtsCode": "4421.91.20.00",
      "superior": null,
      "indent": "4",
      "description": "Sanded, grooved or otherwise advanced in condition",
      "units": [
        "m"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.91.3000",
      "rawHtsCode": "4421.91.30.00",
      "superior": null,
      "indent": "4",
      "description": "Consisting of wooden frames in the center of which are fixed louver boards or slats, with or without their hardware",
      "units": [
        "No."
      ],
      "generalRate": "10.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.91.4000",
      "rawHtsCode": "4421.91.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.91.5000",
      "rawHtsCode": "4421.91.50.00",
      "superior": null,
      "indent": "4",
      "description": "Toothpicks",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.91.6000",
      "rawHtsCode": "4421.91.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.91.70",
      "rawHtsCode": "4421.91.70",
      "superior": null,
      "indent": "3",
      "description": "Pickets, palings, posts and rails, the foregoing which are sawn; assembled fence sections",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4421.91.7020",
      "rawHtsCode": "4421.91.70.20",
      "superior": null,
      "indent": "4",
      "description": "Assembled fence sections",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.91.7040",
      "rawHtsCode": "4421.91.70.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.91.80",
      "rawHtsCode": "4421.91.80",
      "superior": null,
      "indent": "4",
      "description": "Spring-type",
      "units": [],
      "generalRate": "6.5¢/gross<il></il>",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20¢/gross",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.91.8024",
      "rawHtsCode": "4421.91.80.24",
      "superior": null,
      "indent": "5",
      "description": "Valued not over 80¢/gross",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.91.8027",
      "rawHtsCode": "4421.91.80.27",
      "superior": null,
      "indent": "5",
      "description": "Valued over 80¢ but not over $1.35/gross",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.91.8030",
      "rawHtsCode": "4421.91.80.30",
      "superior": null,
      "indent": "5",
      "description": "Valued over $1.35 but not over $1.70/gross",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.91.8033",
      "rawHtsCode": "4421.91.80.33",
      "superior": null,
      "indent": "5",
      "description": "Valued over $1.70/gross",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.91.8500",
      "rawHtsCode": "4421.91.85.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.91.8800",
      "rawHtsCode": "4421.91.88.00",
      "superior": null,
      "indent": "3",
      "description": "Canoe paddles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.91.9300",
      "rawHtsCode": "4421.91.93.00",
      "superior": null,
      "indent": "4",
      "description": "Theatrical, ballet, and operatic scenery and properties, including sets ",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4421.91.9400",
      "rawHtsCode": "4421.91.94.00",
      "superior": null,
      "indent": "4",
      "description": "Edge-glued lumber",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4421.91.98",
      "rawHtsCode": "4421.91.98",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.91.9820",
      "rawHtsCode": "4421.91.98.20",
      "superior": null,
      "indent": "5",
      "description": "Pencil slats",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.91.9870",
      "rawHtsCode": "4421.91.98.70",
      "superior": null,
      "indent": "5",
      "description": "Gates for confining children or pets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.91.9880",
      "rawHtsCode": "4421.91.98.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.99",
      "rawHtsCode": "4421.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.99.1000",
      "rawHtsCode": "4421.99.10.00",
      "superior": null,
      "indent": "5",
      "description": "Coniferous",
      "units": [
        "m"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4421.99.1500",
      "rawHtsCode": "4421.99.15.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4421.99.2000",
      "rawHtsCode": "4421.99.20.00",
      "superior": null,
      "indent": "4",
      "description": "Sanded, grooved or otherwise advanced in condition",
      "units": [
        "m"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.99.3000",
      "rawHtsCode": "4421.99.30.00",
      "superior": null,
      "indent": "4",
      "description": "Consisting of wooden frames in the center of which are fixed louver boards or slats, with or without their hardware",
      "units": [
        "No."
      ],
      "generalRate": "10.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.99.4000",
      "rawHtsCode": "4421.99.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.99.5000",
      "rawHtsCode": "4421.99.50.00",
      "superior": null,
      "indent": "4",
      "description": "Toothpicks",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.99.6000",
      "rawHtsCode": "4421.99.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.99.70",
      "rawHtsCode": "4421.99.70",
      "superior": null,
      "indent": "3",
      "description": "Pickets, palings, posts and rails, the foregoing which are sawn; assembled fence sections",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4421.99.7020",
      "rawHtsCode": "4421.99.70.20",
      "superior": null,
      "indent": "4",
      "description": "Assembled fence sections",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.99.7040",
      "rawHtsCode": "4421.99.70.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.99.80",
      "rawHtsCode": "4421.99.80",
      "superior": null,
      "indent": "4",
      "description": "Spring-type",
      "units": [],
      "generalRate": "6.5¢/gross",
      "specialRate": "Free (A+,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20¢/gross",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.99.8024",
      "rawHtsCode": "4421.99.80.24",
      "superior": null,
      "indent": "5",
      "description": "Valued not over 80¢/gross",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.99.8027",
      "rawHtsCode": "4421.99.80.27",
      "superior": null,
      "indent": "5",
      "description": "Valued over 80¢ but not over $1.35/gross",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.99.8030",
      "rawHtsCode": "4421.99.80.30",
      "superior": null,
      "indent": "5",
      "description": "Valued over $1.35 but not over $1.70/gross",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.99.8033",
      "rawHtsCode": "4421.99.80.33",
      "superior": null,
      "indent": "5",
      "description": "Valued over $1.70/gross",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.99.8500",
      "rawHtsCode": "4421.99.85.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.99.8800",
      "rawHtsCode": "4421.99.88.00",
      "superior": null,
      "indent": "3",
      "description": "Canoe paddles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4421.99.9300",
      "rawHtsCode": "4421.99.93.00",
      "superior": null,
      "indent": "4",
      "description": "Theatrical, ballet, and operatic scenery and properties, including sets ",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4421.99.9400",
      "rawHtsCode": "4421.99.94.00",
      "superior": null,
      "indent": "4",
      "description": "Edge-glued lumber",
      "units": [
        "m<sup>3</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4421.99.98",
      "rawHtsCode": "4421.99.98",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4421.99.9820",
      "rawHtsCode": "4421.99.98.20",
      "superior": null,
      "indent": "5",
      "description": "Pencil slats",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.99.9870",
      "rawHtsCode": "4421.99.98.70",
      "superior": null,
      "indent": "5",
      "description": "Gates for confining children or pets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4421.99.9880",
      "rawHtsCode": "4421.99.98.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4501",
      "rawHtsCode": "4501",
      "superior": null,
      "indent": "0",
      "description": "Natural cork, raw or simply prepared; waste cork; crushed, granulated or ground cork:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4501.10.0000",
      "rawHtsCode": "4501.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Natural cork, raw or simply prepared",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4501.90",
      "rawHtsCode": "4501.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4501.90.2000",
      "rawHtsCode": "4501.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Waste cork",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4501.90.4000",
      "rawHtsCode": "4501.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Crushed, granulated or ground cork",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4502.00.0000",
      "rawHtsCode": "4502.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Natural cork, debacked or roughly squared, or in rectangular (including square) blocks, plates, sheets or strip (including sharp-edged blanks for corks or stoppers)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4503",
      "rawHtsCode": "4503",
      "superior": null,
      "indent": "0",
      "description": "Articles of natural cork:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4503.10",
      "rawHtsCode": "4503.10",
      "superior": null,
      "indent": "1",
      "description": "Corks and stoppers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4503.10.2000",
      "rawHtsCode": "4503.10.20.00",
      "superior": null,
      "indent": "3",
      "description": "With maximum diameter not over 19 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "68¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4503.10.3000",
      "rawHtsCode": "4503.10.30.00",
      "superior": null,
      "indent": "4",
      "description": "Wholly of cork, of a thickness (or length) greater than the maximum diameter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4503.10.4000",
      "rawHtsCode": "4503.10.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4503.10.6000",
      "rawHtsCode": "4503.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4503.90",
      "rawHtsCode": "4503.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4503.90.2000",
      "rawHtsCode": "4503.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Disks, wafers and washers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4503.90.4000",
      "rawHtsCode": "4503.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Wallcoverings, backed with paper or otherwise reinforced",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.3¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4503.90.6000",
      "rawHtsCode": "4503.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4504",
      "rawHtsCode": "4504",
      "superior": null,
      "indent": "0",
      "description": "Agglomerated cork (with or without a binding substance) and articles of agglomerated cork:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4504.10",
      "rawHtsCode": "4504.10",
      "superior": null,
      "indent": "1",
      "description": "Blocks, plates, sheets and strip; tiles of any shape; solid cylinders, including disks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4504.10.1000",
      "rawHtsCode": "4504.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Vulcanized sheets and slabs wholly of ground or pulverized cork and rubber",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4504.10.2000",
      "rawHtsCode": "4504.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Insulation, coated or not coated, of compressed cork",
      "units": [
        "m<sup>3</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4504.10.3000",
      "rawHtsCode": "4504.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Floor coverings",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "22¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4504.10.4000",
      "rawHtsCode": "4504.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Wallcoverings, backed with paper or otherwise reinforced",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.3¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4504.10.4500",
      "rawHtsCode": "4504.10.45.00",
      "superior": null,
      "indent": "3",
      "description": "Stoppers, not tapered, wholly of cork, of a thickness (or length) greater than the maximum diameter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4504.10.4700",
      "rawHtsCode": "4504.10.47.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4504.10.5000",
      "rawHtsCode": "4504.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4504.90.0000",
      "rawHtsCode": "4504.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4601",
      "rawHtsCode": "4601",
      "superior": null,
      "indent": "0",
      "description": "Plaits and similar products of plaiting materials, whether or not assembled into strips; plaiting materials, plaits and similar products of plaiting materials, bound together in parallel strands or woven, in sheet form, whether or not being finished articles (for example, mats, matting, screens):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4601.21",
      "rawHtsCode": "4601.21",
      "superior": null,
      "indent": "2",
      "description": "Of bamboo:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4601.21.4000",
      "rawHtsCode": "4601.21.40.00",
      "superior": null,
      "indent": "3",
      "description": "Woven or partly assembled",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.21.8000",
      "rawHtsCode": "4601.21.80.00",
      "superior": null,
      "indent": "4",
      "description": "Floor coverings",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4601.21.9000",
      "rawHtsCode": "4601.21.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.22",
      "rawHtsCode": "4601.22",
      "superior": null,
      "indent": "2",
      "description": "Of rattan:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4601.22.4000",
      "rawHtsCode": "4601.22.40.00",
      "superior": null,
      "indent": "3",
      "description": "Woven or partly assembled",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.22.8000",
      "rawHtsCode": "4601.22.80.00",
      "superior": null,
      "indent": "4",
      "description": "Floor coverings",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4601.22.9000",
      "rawHtsCode": "4601.22.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.29",
      "rawHtsCode": "4601.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4601.29.4000",
      "rawHtsCode": "4601.29.40.00",
      "superior": null,
      "indent": "4",
      "description": "Of willow",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.29.6000",
      "rawHtsCode": "4601.29.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.29.8000",
      "rawHtsCode": "4601.29.80.00",
      "superior": null,
      "indent": "4",
      "description": "Floor coverings",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4601.29.9000",
      "rawHtsCode": "4601.29.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.92",
      "rawHtsCode": "4601.92",
      "superior": null,
      "indent": "2",
      "description": "Of bamboo:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4601.92.0500",
      "rawHtsCode": "4601.92.05.00",
      "superior": null,
      "indent": "3",
      "description": "Plaits and similar products of plaiting materials, whether or not assembled into strips",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.92.2000",
      "rawHtsCode": "4601.92.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.93",
      "rawHtsCode": "4601.93",
      "superior": null,
      "indent": "2",
      "description": "Of rattan:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4601.93.0100",
      "rawHtsCode": "4601.93.01.00",
      "superior": null,
      "indent": "3",
      "description": "Webbing",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4601.93.0500",
      "rawHtsCode": "4601.93.05.00",
      "superior": null,
      "indent": "3",
      "description": "Plaits and similar products of plaiting materials, whether or not assembled into strips",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.93.2000",
      "rawHtsCode": "4601.93.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.94",
      "rawHtsCode": "4601.94",
      "superior": null,
      "indent": "2",
      "description": "Of other vegetable materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4601.94.0500",
      "rawHtsCode": "4601.94.05.00",
      "superior": null,
      "indent": "3",
      "description": "Plaits and similar products of plaiting materials, whether or not assembled into strips",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.94.2000",
      "rawHtsCode": "4601.94.20.00",
      "superior": null,
      "indent": "4",
      "description": "Of willow or wood",
      "units": [
        "kg"
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.94.4000",
      "rawHtsCode": "4601.94.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4601.99",
      "rawHtsCode": "4601.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4601.99.0500",
      "rawHtsCode": "4601.99.05.00",
      "superior": null,
      "indent": "3",
      "description": "Plaits and similar products of plaiting materials, whether or not assembled into strips",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4601.99.9000",
      "rawHtsCode": "4601.99.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602",
      "rawHtsCode": "4602",
      "superior": null,
      "indent": "0",
      "description": "Basketwork, wickerwork and other articles, made directly to shape from plaiting materials or made up from articles of heading 4601; articles of loofah:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4602.11",
      "rawHtsCode": "4602.11",
      "superior": null,
      "indent": "2",
      "description": "Of bamboo:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4602.11.0500",
      "rawHtsCode": "4602.11.05.00",
      "superior": null,
      "indent": "3",
      "description": "Fishing baskets or creels",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.11.0700",
      "rawHtsCode": "4602.11.07.00",
      "superior": null,
      "indent": "4",
      "description": "Wickerwork",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4602.11.0900",
      "rawHtsCode": "4602.11.09.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.11.2100",
      "rawHtsCode": "4602.11.21.00",
      "superior": null,
      "indent": "3",
      "description": "Luggage, handbags and flatgoods, whether or not lined",
      "units": [
        "No."
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE,R,S, SG) 5.2% (E)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.11.3500",
      "rawHtsCode": "4602.11.35.00",
      "superior": null,
      "indent": "4",
      "description": "Wickerwork",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4602.11.4500",
      "rawHtsCode": "4602.11.45.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.12",
      "rawHtsCode": "4602.12",
      "superior": null,
      "indent": "2",
      "description": "Of rattan:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4602.12.0500",
      "rawHtsCode": "4602.12.05.00",
      "superior": null,
      "indent": "3",
      "description": "Fishing baskets or creels",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.12.1400",
      "rawHtsCode": "4602.12.14.00",
      "superior": null,
      "indent": "4",
      "description": "Wickerwork",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4602.12.1600",
      "rawHtsCode": "4602.12.16.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.12.2300",
      "rawHtsCode": "4602.12.23.00",
      "superior": null,
      "indent": "4",
      "description": "Articles of a kind normally carried in the pocket or in the handbag",
      "units": [
        "No."
      ],
      "generalRate": "9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.12.2500",
      "rawHtsCode": "4602.12.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "18%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG) 15.5% (E)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.12.3500",
      "rawHtsCode": "4602.12.35.00",
      "superior": null,
      "indent": "4",
      "description": "Wickerwork",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4602.12.4500",
      "rawHtsCode": "4602.12.45.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.19",
      "rawHtsCode": "4602.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4602.19.0500",
      "rawHtsCode": "4602.19.05.00",
      "superior": null,
      "indent": "3",
      "description": "Fishing baskets or creels",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.19.1200",
      "rawHtsCode": "4602.19.12.00",
      "superior": null,
      "indent": "4",
      "description": "Of willow",
      "units": [
        "No."
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,R,S, SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.19.1400",
      "rawHtsCode": "4602.19.14.00",
      "superior": null,
      "indent": "5",
      "description": "Wickerwork",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4602.19.1600",
      "rawHtsCode": "4602.19.16.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.19.1700",
      "rawHtsCode": "4602.19.17.00",
      "superior": null,
      "indent": "5",
      "description": "Wickerwork",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4602.19.1800",
      "rawHtsCode": "4602.19.18.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.19.2200",
      "rawHtsCode": "4602.19.22.00",
      "superior": null,
      "indent": "4",
      "description": "Of willow",
      "units": [
        "No."
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE,R,S, SG) 4.6% (E)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.19.2300",
      "rawHtsCode": "4602.19.23.00",
      "superior": null,
      "indent": "5",
      "description": "Articles of a kind normally carried in the pocket or in the handbag",
      "units": [
        "No."
      ],
      "generalRate": "9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.19.2500",
      "rawHtsCode": "4602.19.25.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "18%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG) 15.5% (E)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.19.29",
      "rawHtsCode": "4602.19.29",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE,R,S, SG) 4.2% (E)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.19.2920",
      "rawHtsCode": "4602.19.29.20",
      "superior": null,
      "indent": "5",
      "description": "Handbags",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4602.19.2940",
      "rawHtsCode": "4602.19.29.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4602.19.3500",
      "rawHtsCode": "4602.19.35.00",
      "superior": null,
      "indent": "5",
      "description": "Wickerwork",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4602.19.4500",
      "rawHtsCode": "4602.19.45.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.19.6000",
      "rawHtsCode": "4602.19.60.00",
      "superior": null,
      "indent": "5",
      "description": "Wickerwork",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4602.19.8000",
      "rawHtsCode": "4602.19.80.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4602.90.0000",
      "rawHtsCode": "4602.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "4701.00.0000",
      "rawHtsCode": "4701.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Mechanical woodpulp",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4702.00.00",
      "rawHtsCode": "4702.00.00",
      "superior": null,
      "indent": "0",
      "description": "Chemical woodpulp, dissolving grades",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4702.00.0020",
      "rawHtsCode": "4702.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Sulfite",
      "units": [
        "t adw"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4702.00.0040",
      "rawHtsCode": "4702.00.00.40",
      "superior": null,
      "indent": "1",
      "description": "Sulfate or soda",
      "units": [
        "t adw"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4703",
      "rawHtsCode": "4703",
      "superior": null,
      "indent": "0",
      "description": "Chemical woodpulp, soda or sulfate, other than dissolving grades:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4703.11.0000",
      "rawHtsCode": "4703.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Coniferous",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4703.19.0000",
      "rawHtsCode": "4703.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Nonconiferous",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4703.21.00",
      "rawHtsCode": "4703.21.00",
      "superior": null,
      "indent": "2",
      "description": "Coniferous",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4703.21.0020",
      "rawHtsCode": "4703.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Semibleached",
      "units": [
        "t adw"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4703.21.0040",
      "rawHtsCode": "4703.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Bleached",
      "units": [
        "t adw"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4703.29.00",
      "rawHtsCode": "4703.29.00",
      "superior": null,
      "indent": "2",
      "description": "Nonconiferous",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4703.29.0020",
      "rawHtsCode": "4703.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Semibleached",
      "units": [
        "t adw"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4703.29.0040",
      "rawHtsCode": "4703.29.00.40",
      "superior": null,
      "indent": "3",
      "description": "Bleached",
      "units": [
        "t adw"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4704",
      "rawHtsCode": "4704",
      "superior": null,
      "indent": "0",
      "description": "Chemical woodpulp, sulfite, other than dissolving grades:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4704.11.0000",
      "rawHtsCode": "4704.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Coniferous",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4704.19.0000",
      "rawHtsCode": "4704.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Nonconiferous",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4704.21.0000",
      "rawHtsCode": "4704.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Coniferous",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4704.29.0000",
      "rawHtsCode": "4704.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Nonconiferous",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4705.00.0000",
      "rawHtsCode": "4705.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Wood pulp obtained by a combination of mechanical and chemical pulping processes",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4706",
      "rawHtsCode": "4706",
      "superior": null,
      "indent": "0",
      "description": "Pulps of fibers derived from recovered (waste and scrap) paper or paperboard or of other fibrous cellulosic material:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4706.10.0000",
      "rawHtsCode": "4706.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cotton linters pulp",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4706.20.0000",
      "rawHtsCode": "4706.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Pulps of fibers derived from recovered (waste and scrap) paper or paperboard",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4706.30.0000",
      "rawHtsCode": "4706.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other, of bamboo",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4706.91.0000",
      "rawHtsCode": "4706.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mechanical",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4706.92.0100",
      "rawHtsCode": "4706.92.01.00",
      "superior": null,
      "indent": "2",
      "description": "Chemical",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4706.93.0100",
      "rawHtsCode": "4706.93.01.00",
      "superior": null,
      "indent": "2",
      "description": "Obtained by a combination of mechanical and chemical processes",
      "units": [
        "t adw"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4707",
      "rawHtsCode": "4707",
      "superior": null,
      "indent": "0",
      "description": "Recovered (waste and scrap) paper and paperboard:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4707.10.0000",
      "rawHtsCode": "4707.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Unbleached kraft paper or paperboard or corrugated paper or paperboard",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4707.20.00",
      "rawHtsCode": "4707.20.00",
      "superior": null,
      "indent": "1",
      "description": "Other paper or paperboard, made mainly of bleached chemical pulp, not colored in the mass",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4707.20.0020",
      "rawHtsCode": "4707.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "High-grade deinking paper and paperboard",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4707.20.0040",
      "rawHtsCode": "4707.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4707.30.00",
      "rawHtsCode": "4707.30.00",
      "superior": null,
      "indent": "1",
      "description": "Paper or paperboard made mainly of mechanical pulp (for example, newspapers, journals and similar printed matter)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4707.30.0020",
      "rawHtsCode": "4707.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "Newsprint",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4707.30.0040",
      "rawHtsCode": "4707.30.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4707.90.0000",
      "rawHtsCode": "4707.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other, including unsorted waste and scrap",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4801.00.01",
      "rawHtsCode": "4801.00.01",
      "superior": null,
      "indent": "0",
      "description": "Newsprint, in rolls or sheets",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4801.00.0120",
      "rawHtsCode": "4801.00.01.20",
      "superior": null,
      "indent": "1",
      "description": "Standard newsprint paper",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4801.00.0140",
      "rawHtsCode": "4801.00.01.40",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802",
      "rawHtsCode": "4802",
      "superior": null,
      "indent": "0",
      "description": "Uncoated paper and paperboard, of a kind used for writing, printing or other graphic purposes, and non perforated punch-cards and punch tape paper, in rolls or rectangular (including square) sheets, of any size, other than paper of heading 4801 or 4803; hand-made paper and paperboard:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.10.0000",
      "rawHtsCode": "4802.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Handmade paper and paperboard",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "17.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.20",
      "rawHtsCode": "4802.20",
      "superior": null,
      "indent": "1",
      "description": "Paper and paperboard of a kind used as a base for photo-sensitive, heat-sensitive or electro-sensitive paper or paperboard:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.20.1000",
      "rawHtsCode": "4802.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "In strips or rolls of a width exceeding <il>15 cm</il> or in rectangular (including square) sheets with one side exceeding <il>36 cm</il> and the other side exceeding <il>15 cm</il> in the unfolded state",
      "units": [
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.20.2000",
      "rawHtsCode": "4802.20.20.00",
      "superior": null,
      "indent": "3",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4802.20.40",
      "rawHtsCode": "4802.20.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.20.4020",
      "rawHtsCode": "4802.20.40.20",
      "superior": null,
      "indent": "4",
      "description": "Containing by weight 25 percent or more cotton fiber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.20.4040",
      "rawHtsCode": "4802.20.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.40.0000",
      "rawHtsCode": "4802.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Wallpaper base (hanging paper)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.54",
      "rawHtsCode": "4802.54",
      "superior": null,
      "indent": "2",
      "description": "Weighing less than <il>40 g/m²:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.54.1000",
      "rawHtsCode": "4802.54.10.00",
      "superior": null,
      "indent": "4",
      "description": "Writing paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.54.2000",
      "rawHtsCode": "4802.54.20.00",
      "superior": null,
      "indent": "4",
      "description": "India and bible paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "18%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.54.3100",
      "rawHtsCode": "4802.54.31.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.54.5000",
      "rawHtsCode": "4802.54.50.00",
      "superior": null,
      "indent": "4",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [
        "kg",
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.54.6100",
      "rawHtsCode": "4802.54.61.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.55",
      "rawHtsCode": "4802.55",
      "superior": null,
      "indent": "2",
      "description": "Weighing <il>40 g/m²</il> or more but not more than <il>150 g/m²</il>, in rolls:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.55.1000",
      "rawHtsCode": "4802.55.10.00",
      "superior": null,
      "indent": "4",
      "description": "Writing and cover paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.55.2000",
      "rawHtsCode": "4802.55.20.00",
      "superior": null,
      "indent": "4",
      "description": "Drawing paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.55.3000",
      "rawHtsCode": "4802.55.30.00",
      "superior": null,
      "indent": "4",
      "description": "India and bible paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "18%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.55.4000",
      "rawHtsCode": "4802.55.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.55.6000",
      "rawHtsCode": "4802.55.60.00",
      "superior": null,
      "indent": "4",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.55.70",
      "rawHtsCode": "4802.55.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.55.7020",
      "rawHtsCode": "4802.55.70.20",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight 25 percent or more cotton fiber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.55.7040",
      "rawHtsCode": "4802.55.70.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.56",
      "rawHtsCode": "4802.56",
      "superior": null,
      "indent": "2",
      "description": "Weighing <il>40 g/m²</il> or more but not more than <il>150 g/m²</il>, in sheets with one side not exceeding <il>435 mm</il> and the other side not exceeding <il>297 mm</il> in the unfolded state:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.56.1000",
      "rawHtsCode": "4802.56.10.00",
      "superior": null,
      "indent": "4",
      "description": "Writing and cover paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.56.2000",
      "rawHtsCode": "4802.56.20.00",
      "superior": null,
      "indent": "4",
      "description": "Drawing paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.56.3000",
      "rawHtsCode": "4802.56.30.00",
      "superior": null,
      "indent": "4",
      "description": "India and bible paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "18%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.56.4000",
      "rawHtsCode": "4802.56.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.56.6000",
      "rawHtsCode": "4802.56.60.00",
      "superior": null,
      "indent": "4",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.56.70",
      "rawHtsCode": "4802.56.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.56.7020",
      "rawHtsCode": "4802.56.70.20",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight <il>25 percent</il> or more cotton fiber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.56.7050",
      "rawHtsCode": "4802.56.70.50",
      "superior": null,
      "indent": "6",
      "description": "Writing and cover paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.56.7090",
      "rawHtsCode": "4802.56.70.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.57",
      "rawHtsCode": "4802.57",
      "superior": null,
      "indent": "2",
      "description": "Other, weighing <il>40 g/m²</il> or more but not more than <il>150 g/m²:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.57.10",
      "rawHtsCode": "4802.57.10",
      "superior": null,
      "indent": "3",
      "description": "Writing and cover paper",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4802.57.1040",
      "rawHtsCode": "4802.57.10.40",
      "superior": null,
      "indent": "4",
      "description": "With one side equal to 965 mm and the other side equal to 635 mm in the unfolded state",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.57.1085",
      "rawHtsCode": "4802.57.10.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.57.2000",
      "rawHtsCode": "4802.57.20.00",
      "superior": null,
      "indent": "3",
      "description": "Drawing paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.57.3000",
      "rawHtsCode": "4802.57.30.00",
      "superior": null,
      "indent": "3",
      "description": "India and bible paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "18%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.57.40",
      "rawHtsCode": "4802.57.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4802.57.4040",
      "rawHtsCode": "4802.57.40.40",
      "superior": null,
      "indent": "4",
      "description": "With one side equal to 965 mm and the other side equal to 635 mm in the unfolded state",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.57.4085",
      "rawHtsCode": "4802.57.40.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.58",
      "rawHtsCode": "4802.58",
      "superior": null,
      "indent": "2",
      "description": "Weighing more than <il>150 g/m²:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.58.1000",
      "rawHtsCode": "4802.58.10.00",
      "superior": null,
      "indent": "4",
      "description": "Writing and cover paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.58.20",
      "rawHtsCode": "4802.58.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "24.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.58.2020",
      "rawHtsCode": "4802.58.20.20",
      "superior": null,
      "indent": "5",
      "description": "Drawing paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.58.2040",
      "rawHtsCode": "4802.58.20.40",
      "superior": null,
      "indent": "5",
      "description": "Bristols",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.58.2080",
      "rawHtsCode": "4802.58.20.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.58.5000",
      "rawHtsCode": "4802.58.50.00",
      "superior": null,
      "indent": "4",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.58.60",
      "rawHtsCode": "4802.58.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.58.6020",
      "rawHtsCode": "4802.58.60.20",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight <il>25 percent</il> or more cotton fiber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.58.6040",
      "rawHtsCode": "4802.58.60.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.61",
      "rawHtsCode": "4802.61",
      "superior": null,
      "indent": "2",
      "description": "In rolls:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.61.1000",
      "rawHtsCode": "4802.61.10.00",
      "superior": null,
      "indent": "4",
      "description": "Writing and cover paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.61.2000",
      "rawHtsCode": "4802.61.20.00",
      "superior": null,
      "indent": "4",
      "description": "Drawing paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.61.31",
      "rawHtsCode": "4802.61.31",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.61.3110",
      "rawHtsCode": "4802.61.31.10",
      "superior": null,
      "indent": "5",
      "description": "Weighing less than 40 g/m<sup>2</sup>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.61.3135",
      "rawHtsCode": "4802.61.31.35",
      "superior": null,
      "indent": "6",
      "description": "Supercalendered",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.61.3191",
      "rawHtsCode": "4802.61.31.91",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.61.5000",
      "rawHtsCode": "4802.61.50.00",
      "superior": null,
      "indent": "4",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.61.60",
      "rawHtsCode": "4802.61.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.61.6020",
      "rawHtsCode": "4802.61.60.20",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight 25 percent or more cotton fiber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.61.6040",
      "rawHtsCode": "4802.61.60.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.62",
      "rawHtsCode": "4802.62",
      "superior": null,
      "indent": "2",
      "description": "In sheets with one side not exceeding <il>435 mm</il> and the other side not exceeding <il>297 mm</il> in the unfolded state:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.62.1000",
      "rawHtsCode": "4802.62.10.00",
      "superior": null,
      "indent": "4",
      "description": "Writing and cover paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.62.2000",
      "rawHtsCode": "4802.62.20.00",
      "superior": null,
      "indent": "4",
      "description": "Drawing paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.62.3000",
      "rawHtsCode": "4802.62.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.62.5000",
      "rawHtsCode": "4802.62.50.00",
      "superior": null,
      "indent": "4",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.62.61",
      "rawHtsCode": "4802.62.61",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.62.6120",
      "rawHtsCode": "4802.62.61.20",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight 25 percent or more cotton fiber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.62.6140",
      "rawHtsCode": "4802.62.61.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.69",
      "rawHtsCode": "4802.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4802.69.1000",
      "rawHtsCode": "4802.69.10.00",
      "superior": null,
      "indent": "3",
      "description": "Writing and cover paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.69.2000",
      "rawHtsCode": "4802.69.20.00",
      "superior": null,
      "indent": "3",
      "description": "Drawing paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4802.69.3000",
      "rawHtsCode": "4802.69.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4803.00",
      "rawHtsCode": "4803.00",
      "superior": null,
      "indent": "0",
      "description": "Toilet or facial tissue stock, towel or napkin stock and similar paper of a kind used for household or sanitary purposes, cellulose wadding and webs of cellulose fibers, whether or not creped, crinkled, embossed, perforated, surface-colored, surface decorated or printed, in rolls or sheets:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4803.00.2000",
      "rawHtsCode": "4803.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Cellulose wadding",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "24%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4803.00.4000",
      "rawHtsCode": "4803.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804",
      "rawHtsCode": "4804",
      "superior": null,
      "indent": "0",
      "description": "Uncoated kraft paper and paperboard, in rolls or sheets, other than that of heading 4802 or 4803:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.11.0000",
      "rawHtsCode": "4804.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.19.0000",
      "rawHtsCode": "4804.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4804.21.0000",
      "rawHtsCode": "4804.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4804.29.0000",
      "rawHtsCode": "4804.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.31",
      "rawHtsCode": "4804.31",
      "superior": null,
      "indent": "2",
      "description": "Unbleached:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.31.1000",
      "rawHtsCode": "4804.31.10.00",
      "superior": null,
      "indent": "4",
      "description": "Weighing over <il>15 g/m²</il> but not over <il>30 g/m²</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.31.2000",
      "rawHtsCode": "4804.31.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.31.40",
      "rawHtsCode": "4804.31.40",
      "superior": null,
      "indent": "3",
      "description": "Wrapping paper",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.31.4020",
      "rawHtsCode": "4804.31.40.20",
      "superior": null,
      "indent": "4",
      "description": "Bag or sack paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.31.4040",
      "rawHtsCode": "4804.31.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.31.6000",
      "rawHtsCode": "4804.31.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.39",
      "rawHtsCode": "4804.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.39.2000",
      "rawHtsCode": "4804.39.20.00",
      "superior": null,
      "indent": "3",
      "description": "Condenser paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.39.40",
      "rawHtsCode": "4804.39.40",
      "superior": null,
      "indent": "3",
      "description": "Wrapping paper",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.39.4020",
      "rawHtsCode": "4804.39.40.20",
      "superior": null,
      "indent": "4",
      "description": "Bag or sack paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.39.4041",
      "rawHtsCode": "4804.39.40.41",
      "superior": null,
      "indent": "5",
      "description": "Tissue paper having a basis weight not exceeding <il>29 g/m²</il>, in sheets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.39.4049",
      "rawHtsCode": "4804.39.40.49",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.39.60",
      "rawHtsCode": "4804.39.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.39.6020",
      "rawHtsCode": "4804.39.60.20",
      "superior": null,
      "indent": "4",
      "description": "Base stock for trays, dishes, plates, cups and the like",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.39.6040",
      "rawHtsCode": "4804.39.60.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.41",
      "rawHtsCode": "4804.41",
      "superior": null,
      "indent": "2",
      "description": "Unbleached:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.41.2000",
      "rawHtsCode": "4804.41.20.00",
      "superior": null,
      "indent": "3",
      "description": "Wrapping paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.41.4000",
      "rawHtsCode": "4804.41.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.42.00",
      "rawHtsCode": "4804.42.00",
      "superior": null,
      "indent": "2",
      "description": "Bleached uniformly throughout the mass and of which more than 95 percent by weight of the total fiber content consists of wood fibers obtained by a chemical process",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.42.0010",
      "rawHtsCode": "4804.42.00.10",
      "superior": null,
      "indent": "3",
      "description": "Base stock for milk cartons and other beverage containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.42.0020",
      "rawHtsCode": "4804.42.00.20",
      "superior": null,
      "indent": "4",
      "description": "Folding carton stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.42.0030",
      "rawHtsCode": "4804.42.00.30",
      "superior": null,
      "indent": "4",
      "description": "Base stock for trays, dishes, plates, cups and the like",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.42.0040",
      "rawHtsCode": "4804.42.00.40",
      "superior": null,
      "indent": "5",
      "description": "Base stock for packaging",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.42.0050",
      "rawHtsCode": "4804.42.00.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.49.0000",
      "rawHtsCode": "4804.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.51.0000",
      "rawHtsCode": "4804.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.52.00",
      "rawHtsCode": "4804.52.00",
      "superior": null,
      "indent": "2",
      "description": "Bleached uniformly throughout the mass and of which more than 95 percent by weight of the total fiber content consists of wood fibers obtained by a chemical process",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4804.52.0010",
      "rawHtsCode": "4804.52.00.10",
      "superior": null,
      "indent": "3",
      "description": "Base stock for milk cartons and other beverage containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.52.0020",
      "rawHtsCode": "4804.52.00.20",
      "superior": null,
      "indent": "4",
      "description": "Folding carton stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.52.0030",
      "rawHtsCode": "4804.52.00.30",
      "superior": null,
      "indent": "4",
      "description": "Base stock for trays, dishes, plates, cups and the like",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.52.0040",
      "rawHtsCode": "4804.52.00.40",
      "superior": null,
      "indent": "5",
      "description": "Base stock for packaging",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.52.0050",
      "rawHtsCode": "4804.52.00.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4804.59.0000",
      "rawHtsCode": "4804.59.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805",
      "rawHtsCode": "4805",
      "superior": null,
      "indent": "0",
      "description": "Other uncoated paper and paperboard, in rolls or sheets, not further worked or processed than as specified in note 3 to this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.11.0000",
      "rawHtsCode": "4805.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Semichemical fluting paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4805.12",
      "rawHtsCode": "4805.12",
      "superior": null,
      "indent": "2",
      "description": "Straw fluting paper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.12.1000",
      "rawHtsCode": "4805.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "Weighing <il>150 g/m²</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.12.2000",
      "rawHtsCode": "4805.12.20.00",
      "superior": null,
      "indent": "3",
      "description": "Weighing over <il>150 g/m²</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.19",
      "rawHtsCode": "4805.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.19.1000",
      "rawHtsCode": "4805.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Weighing <il>150 g/m²</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4805.19.2000",
      "rawHtsCode": "4805.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Weighing over <il>150 g/m²</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4805.24",
      "rawHtsCode": "4805.24",
      "superior": null,
      "indent": "2",
      "description": "Weighing <il>150 g/m²</il> or less:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.24.5000",
      "rawHtsCode": "4805.24.50.00",
      "superior": null,
      "indent": "3",
      "description": "Weighing not over <il>15 g/m²</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.24.7000",
      "rawHtsCode": "4805.24.70.00",
      "superior": null,
      "indent": "3",
      "description": "Weighing over <il>15 g/m²</il> but not over <il>30 g/m²</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11¢/kg + 15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.24.9000",
      "rawHtsCode": "4805.24.90.00",
      "superior": null,
      "indent": "3",
      "description": "Weighing over <il>30 g/m²</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.25.0000",
      "rawHtsCode": "4805.25.00.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing more than <il>150 g/m²</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4805.30.0000",
      "rawHtsCode": "4805.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sulfite wrapping paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.40.0000",
      "rawHtsCode": "4805.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Filter paper and paperboard",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11¢/kg + 15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.50.0000",
      "rawHtsCode": "4805.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Felt paper and paperboard",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.91",
      "rawHtsCode": "4805.91",
      "superior": null,
      "indent": "2",
      "description": "Weighing <il>150 g/m²</il> or less:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.91.10",
      "rawHtsCode": "4805.91.10",
      "superior": null,
      "indent": "3",
      "description": "Multi-ply paper and paperboard; bibulous and wrapping paper",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.91.1010",
      "rawHtsCode": "4805.91.10.10",
      "superior": null,
      "indent": "4",
      "description": "Folding carton board",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.91.1090",
      "rawHtsCode": "4805.91.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.91.2000",
      "rawHtsCode": "4805.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "Condenser paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.91.5000",
      "rawHtsCode": "4805.91.50.00",
      "superior": null,
      "indent": "4",
      "description": "Weighing not over <il>15 g/m²</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.91.7000",
      "rawHtsCode": "4805.91.70.00",
      "superior": null,
      "indent": "4",
      "description": "Weighing over <il>15 g/m²</il> but not over <il>30 g/m²</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11¢/kg + 15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.91.9000",
      "rawHtsCode": "4805.91.90.00",
      "superior": null,
      "indent": "4",
      "description": "Weighing over <il>30 g/m²</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.92",
      "rawHtsCode": "4805.92",
      "superior": null,
      "indent": "2",
      "description": "Weighing more than <il>150 g/m²</il> but less than <il>225 g/m²:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.92.2000",
      "rawHtsCode": "4805.92.20.00",
      "superior": null,
      "indent": "3",
      "description": "Pressboard",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.92.40",
      "rawHtsCode": "4805.92.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4805.92.4010",
      "rawHtsCode": "4805.92.40.10",
      "superior": null,
      "indent": "4",
      "description": "Folding carton board",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.92.4020",
      "rawHtsCode": "4805.92.40.20",
      "superior": null,
      "indent": "4",
      "description": "Construction paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.92.4030",
      "rawHtsCode": "4805.92.40.30",
      "superior": null,
      "indent": "4",
      "description": "Linerboard containing by weight less than 80 percent chemical sulfate wood pulp",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.92.4040",
      "rawHtsCode": "4805.92.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.93",
      "rawHtsCode": "4805.93",
      "superior": null,
      "indent": "2",
      "description": "Weighing <il>225 g/m²</il> or more:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.93.2000",
      "rawHtsCode": "4805.93.20.00",
      "superior": null,
      "indent": "3",
      "description": "Pressboard",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.93.40",
      "rawHtsCode": "4805.93.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4805.93.4010",
      "rawHtsCode": "4805.93.40.10",
      "superior": null,
      "indent": "4",
      "description": "Folding carton board",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.93.4015",
      "rawHtsCode": "4805.93.40.15",
      "superior": null,
      "indent": "4",
      "description": "Wet machine board",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.93.4020",
      "rawHtsCode": "4805.93.40.20",
      "superior": null,
      "indent": "4",
      "description": "Construction paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.93.4030",
      "rawHtsCode": "4805.93.40.30",
      "superior": null,
      "indent": "4",
      "description": "Linerboard containing by weight less than 80 percent chemical sulfate wood pulp",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.93.4050",
      "rawHtsCode": "4805.93.40.50",
      "superior": null,
      "indent": "4",
      "description": "Tube and core board",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4805.93.4060",
      "rawHtsCode": "4805.93.40.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4806",
      "rawHtsCode": "4806",
      "superior": null,
      "indent": "0",
      "description": "Vegetable parchment, greaseproof papers, tracing papers and glassine and other glazed transparent or translucent papers, in rolls or sheets:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4806.10.0000",
      "rawHtsCode": "4806.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Vegetable parchment",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "19%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4806.20.0000",
      "rawHtsCode": "4806.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Greaseproof papers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "7¢/kg + 15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4806.30.0000",
      "rawHtsCode": "4806.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tracing papers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "7¢/kg + 15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4806.40.0000",
      "rawHtsCode": "4806.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Glassine and other glazed transparent or translucent papers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "7¢/kg + 15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4807.00",
      "rawHtsCode": "4807.00",
      "superior": null,
      "indent": "0",
      "description": "Composite paper and paperboard (made by sticking flat layers of paper or paperboard together with an adhesive), not surface-coated or impregnated, whether or not internally reinforced, in rolls or sheets:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4807.00.1000",
      "rawHtsCode": "4807.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Paper and paperboard, laminated internally with bitumen, tar or asphalt",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4807.00.9100",
      "rawHtsCode": "4807.00.91.00",
      "superior": null,
      "indent": "2",
      "description": "Straw paper and paperboard, whether or not covered with paper other than straw paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4807.00.9200",
      "rawHtsCode": "4807.00.92.00",
      "superior": null,
      "indent": "3",
      "description": "Cloth-lined or reinforced paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "22.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4807.00.9400",
      "rawHtsCode": "4807.00.94.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4808",
      "rawHtsCode": "4808",
      "superior": null,
      "indent": "0",
      "description": "Paper and paperboard, corrugated (with or without glued flat surface sheets), creped, crinkled, embossed or perforated, in rolls or sheets, other than paper of the kind described in heading 4803:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4808.10.0000",
      "rawHtsCode": "4808.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Corrugated paper and paperboard, whether or not perforated",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4808.40.0000",
      "rawHtsCode": "4808.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Kraft paper, creped or crinkled, whether or not embossed or perforated",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4808.90",
      "rawHtsCode": "4808.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4808.90.2000",
      "rawHtsCode": "4808.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Creped or crinkled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4808.90.4000",
      "rawHtsCode": "4808.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Embossed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "18.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4808.90.6000",
      "rawHtsCode": "4808.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4809",
      "rawHtsCode": "4809",
      "superior": null,
      "indent": "0",
      "description": "Carbon paper, self-copy paper and other copying or transfer papers (including coated or impregnated paper for duplicator stencils or offset plates), whether or not printed, in rolls or sheets:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4809.20",
      "rawHtsCode": "4809.20",
      "superior": null,
      "indent": "1",
      "description": "Self-copy paper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4809.20.2000",
      "rawHtsCode": "4809.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Writing paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4809.20.4000",
      "rawHtsCode": "4809.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4809.90",
      "rawHtsCode": "4809.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4809.90.2000",
      "rawHtsCode": "4809.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Stereotype-matrix board and mat",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4809.90.4000",
      "rawHtsCode": "4809.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Simplex",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4809.90.6000",
      "rawHtsCode": "4809.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Duplex",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4809.90.7100",
      "rawHtsCode": "4809.90.71.00",
      "superior": null,
      "indent": "3",
      "description": "Impregnated, coated or both, but not otherwise treated",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4809.90.8000",
      "rawHtsCode": "4809.90.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810",
      "rawHtsCode": "4810",
      "superior": null,
      "indent": "0",
      "description": "Paper and paperboard, coated on one or both sides with kaolin (China clay) or other inorganic substances, with or without a binder, and with no other coating, whether or not surface-colored, surface-decorated or printed, in rolls or rectangular (including square) sheets, of any size:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.13",
      "rawHtsCode": "4810.13",
      "superior": null,
      "indent": "2",
      "description": "In rolls:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.13.11",
      "rawHtsCode": "4810.13.11",
      "superior": null,
      "indent": "5",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.13.1120",
      "rawHtsCode": "4810.13.11.20",
      "superior": null,
      "indent": "6",
      "description": "Baryta coated",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.13.1140",
      "rawHtsCode": "4810.13.11.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.13.1300",
      "rawHtsCode": "4810.13.13.00",
      "superior": null,
      "indent": "5",
      "description": "India or bible paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "24%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.13.1900",
      "rawHtsCode": "4810.13.19.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.13.20",
      "rawHtsCode": "4810.13.20",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than <il>150 g/m²</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.13.2010",
      "rawHtsCode": "4810.13.20.10",
      "superior": null,
      "indent": "5",
      "description": "Coated on one side only",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.13.2090",
      "rawHtsCode": "4810.13.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.13.5000",
      "rawHtsCode": "4810.13.50.00",
      "superior": null,
      "indent": "4",
      "description": "Printed, embossed or perforated",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.13.6000",
      "rawHtsCode": "4810.13.60.00",
      "superior": null,
      "indent": "5",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.13.70",
      "rawHtsCode": "4810.13.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.13.7020",
      "rawHtsCode": "4810.13.70.20",
      "superior": null,
      "indent": "6",
      "description": "Containing by weight 25 percent or more cotton fiber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.13.7040",
      "rawHtsCode": "4810.13.70.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.14",
      "rawHtsCode": "4810.14",
      "superior": null,
      "indent": "2",
      "description": "In sheets with one side not exceeding <il>435 mm</il> and the other side not exceeding <il>297 mm</il> in the unfolded state:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.14.11",
      "rawHtsCode": "4810.14.11",
      "superior": null,
      "indent": "5",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.14.1120",
      "rawHtsCode": "4810.14.11.20",
      "superior": null,
      "indent": "6",
      "description": "Baryta coated",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.14.1140",
      "rawHtsCode": "4810.14.11.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.14.1300",
      "rawHtsCode": "4810.14.13.00",
      "superior": null,
      "indent": "5",
      "description": "India or bible paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "24%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.14.1900",
      "rawHtsCode": "4810.14.19.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.14.20",
      "rawHtsCode": "4810.14.20",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than <il>150 g/m²</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.14.2010",
      "rawHtsCode": "4810.14.20.10",
      "superior": null,
      "indent": "5",
      "description": "Coated on one side only",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.14.2090",
      "rawHtsCode": "4810.14.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.14.5000",
      "rawHtsCode": "4810.14.50.00",
      "superior": null,
      "indent": "4",
      "description": "Printed, embossed or perforated",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.14.6000",
      "rawHtsCode": "4810.14.60.00",
      "superior": null,
      "indent": "5",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.14.70",
      "rawHtsCode": "4810.14.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.14.7020",
      "rawHtsCode": "4810.14.70.20",
      "superior": null,
      "indent": "6",
      "description": "Containing by weight 25 percent or more cotton fiber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.14.7040",
      "rawHtsCode": "4810.14.70.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.19",
      "rawHtsCode": "4810.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.19.1100",
      "rawHtsCode": "4810.19.11.00",
      "superior": null,
      "indent": "4",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.19.1300",
      "rawHtsCode": "4810.19.13.00",
      "superior": null,
      "indent": "4",
      "description": "India or bible paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "24%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.19.1900",
      "rawHtsCode": "4810.19.19.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.19.20",
      "rawHtsCode": "4810.19.20",
      "superior": null,
      "indent": "3",
      "description": "Weighing more than <il>150 g/m²</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.19.2010",
      "rawHtsCode": "4810.19.20.10",
      "superior": null,
      "indent": "4",
      "description": "Coated on one side only",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.19.2090",
      "rawHtsCode": "4810.19.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.22",
      "rawHtsCode": "4810.22",
      "superior": null,
      "indent": "2",
      "description": "Light-weight coated paper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.22.1000",
      "rawHtsCode": "4810.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "In strips or rolls of a width exceeding <il>15 cm</il> or in rectangular (including square) sheets with one side exceeding <il>36 cm</il> and the other side exceeding <il>15 cm</il> in the unfolded state",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.22.50",
      "rawHtsCode": "4810.22.50",
      "superior": null,
      "indent": "4",
      "description": "Printed, embossed or perforated",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.22.5044",
      "rawHtsCode": "4810.22.50.44",
      "superior": null,
      "indent": "5",
      "description": "Hole-punched looseleaf paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.22.5080",
      "rawHtsCode": "4810.22.50.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.22.6000",
      "rawHtsCode": "4810.22.60.00",
      "superior": null,
      "indent": "5",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.22.70",
      "rawHtsCode": "4810.22.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.22.7020",
      "rawHtsCode": "4810.22.70.20",
      "superior": null,
      "indent": "6",
      "description": "Containing by weight 25 percent or more cotton fiber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.22.7040",
      "rawHtsCode": "4810.22.70.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.29",
      "rawHtsCode": "4810.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.29.10",
      "rawHtsCode": "4810.29.10",
      "superior": null,
      "indent": "3",
      "description": "In strips or rolls of a width exceeding <il>15 cm</il> or in rectangular (including square) sheets with one side exceeding <il>36 cm</il> and the other side exceeding <il>15 cm</il> in the unfolded state",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.29.1025",
      "rawHtsCode": "4810.29.10.25",
      "superior": null,
      "indent": "4",
      "description": "In rolls",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.29.1035",
      "rawHtsCode": "4810.29.10.35",
      "superior": null,
      "indent": "4",
      "description": "In sheets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.29.5000",
      "rawHtsCode": "4810.29.50.00",
      "superior": null,
      "indent": "4",
      "description": "Printed, embossed or perforated",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.29.6000",
      "rawHtsCode": "4810.29.60.00",
      "superior": null,
      "indent": "5",
      "description": "Basic paper to be sensitized for use in photography",
      "units": [
        "kg",
        "m²"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.29.70",
      "rawHtsCode": "4810.29.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.29.7020",
      "rawHtsCode": "4810.29.70.20",
      "superior": null,
      "indent": "6",
      "description": "Containing by weight 25 percent or more cotton fiber",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.29.7025",
      "rawHtsCode": "4810.29.70.25",
      "superior": null,
      "indent": "7",
      "description": "In rolls",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.29.7035",
      "rawHtsCode": "4810.29.70.35",
      "superior": null,
      "indent": "7",
      "description": "In sheets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.31",
      "rawHtsCode": "4810.31",
      "superior": null,
      "indent": "2",
      "description": "Bleached uniformly throughout the mass and of which more than 95 percent by weight of the total fiber content consists of wood fibers obtained by a chemical process and weighing <il>150 g/m²</il> or less:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.31.10",
      "rawHtsCode": "4810.31.10",
      "superior": null,
      "indent": "3",
      "description": "In strips or rolls of a width exceeding <il>15 cm</il> or in rectangular (including square) sheets with one side exceeding <il>36 cm</il> and the other side exceeding <il>15 cm</il> in the unfolded state",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.31.1020",
      "rawHtsCode": "4810.31.10.20",
      "superior": null,
      "indent": "4",
      "description": "Folding carton stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.31.1040",
      "rawHtsCode": "4810.31.10.40",
      "superior": null,
      "indent": "4",
      "description": "Base stock for trays, dishes, plates, cups and the like",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.31.1050",
      "rawHtsCode": "4810.31.10.50",
      "superior": null,
      "indent": "5",
      "description": "Gift wrap",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.31.1080",
      "rawHtsCode": "4810.31.10.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.31.3000",
      "rawHtsCode": "4810.31.30.00",
      "superior": null,
      "indent": "4",
      "description": "Cards, not punched, for punchcard machines, whether or not in strips",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.31.6500",
      "rawHtsCode": "4810.31.65.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.32",
      "rawHtsCode": "4810.32",
      "superior": null,
      "indent": "2",
      "description": "Bleached uniformly throughout the mass and of which more than 95 percent by weight of the total fiber content consists of wood fibers obtained by a chemical process and weighing more than <il>150 g/m²:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.32.10",
      "rawHtsCode": "4810.32.10",
      "superior": null,
      "indent": "3",
      "description": "In strips or rolls of a width exceeding <il>15 cm</il> or in rectangular (including square) sheets with one side exceeding <il>36 cm</il> and the other side exceeding <il>15 cm</il> in the unfolded state",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.32.1020",
      "rawHtsCode": "4810.32.10.20",
      "superior": null,
      "indent": "4",
      "description": "Folding carton stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.32.1040",
      "rawHtsCode": "4810.32.10.40",
      "superior": null,
      "indent": "4",
      "description": "Base stock for trays, dishes, plates, cups and the like",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.32.1060",
      "rawHtsCode": "4810.32.10.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.32.3000",
      "rawHtsCode": "4810.32.30.00",
      "superior": null,
      "indent": "4",
      "description": "Cards, not punched, for punchcard machines, whether or not in strips",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.32.6500",
      "rawHtsCode": "4810.32.65.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.39",
      "rawHtsCode": "4810.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.39.1200",
      "rawHtsCode": "4810.39.12.00",
      "superior": null,
      "indent": "4",
      "description": "Whether or not impregnated, but not otherwise treated",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.39.1400",
      "rawHtsCode": "4810.39.14.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.39.3000",
      "rawHtsCode": "4810.39.30.00",
      "superior": null,
      "indent": "4",
      "description": "Cards, not punched, for punchcard machines, whether or not in strips",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.39.6500",
      "rawHtsCode": "4810.39.65.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.92",
      "rawHtsCode": "4810.92",
      "superior": null,
      "indent": "2",
      "description": "Multi-ply:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.92.12",
      "rawHtsCode": "4810.92.12",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than <il>150 g/m²</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.92.1225",
      "rawHtsCode": "4810.92.12.25",
      "superior": null,
      "indent": "5",
      "description": "In rolls",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.92.1235",
      "rawHtsCode": "4810.92.12.35",
      "superior": null,
      "indent": "5",
      "description": "In sheets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.92.14",
      "rawHtsCode": "4810.92.14",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.92.1425",
      "rawHtsCode": "4810.92.14.25",
      "superior": null,
      "indent": "5",
      "description": "In rolls",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.92.1435",
      "rawHtsCode": "4810.92.14.35",
      "superior": null,
      "indent": "5",
      "description": "In sheets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.92.3000",
      "rawHtsCode": "4810.92.30.00",
      "superior": null,
      "indent": "4",
      "description": "Cards, not punched, for punch card machines, whether or not in strips",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.92.65",
      "rawHtsCode": "4810.92.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.92.6525",
      "rawHtsCode": "4810.92.65.25",
      "superior": null,
      "indent": "5",
      "description": "In rolls",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.92.6535",
      "rawHtsCode": "4810.92.65.35",
      "superior": null,
      "indent": "5",
      "description": "In sheets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.99",
      "rawHtsCode": "4810.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.99.10",
      "rawHtsCode": "4810.99.10",
      "superior": null,
      "indent": "3",
      "description": "In strips or rolls of a width exceeding <il>15 cm</il> or in rectangular (including square) sheets with one side exceeding <il>36 cm</il> and the other side exceeding <il>15 cm</il> in the unfolded state",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.99.1010",
      "rawHtsCode": "4810.99.10.10",
      "superior": null,
      "indent": "4",
      "description": "Gift wrap paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.99.1050",
      "rawHtsCode": "4810.99.10.50",
      "superior": null,
      "indent": "4",
      "description": "Folding Carton",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.99.1060",
      "rawHtsCode": "4810.99.10.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4810.99.3000",
      "rawHtsCode": "4810.99.30.00",
      "superior": null,
      "indent": "4",
      "description": "Cards, not punched, for punch card machines, whether or not in strips",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4810.99.6500",
      "rawHtsCode": "4810.99.65.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811",
      "rawHtsCode": "4811",
      "superior": null,
      "indent": "0",
      "description": "Paper, paperboard, cellulose wadding and webs of cellulose fibers, coated, impregnated, covered, surface-colored, surface-decorated or printed, in rolls or rectangular (including square) sheets, of any size, other than goods of the kind described in heading 4803, 4809 or 4810:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.10",
      "rawHtsCode": "4811.10",
      "superior": null,
      "indent": "1",
      "description": "Tarred, bituminized or asphalted paper and paperboard:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.10.1100",
      "rawHtsCode": "4811.10.11.00",
      "superior": null,
      "indent": "2",
      "description": "In strips or rolls of a width exceeding <il>15 cm</il> or in rectangular (including square) sheets with one side exceeding <il>36 cm</il> and the other side exceeding <il>15 cm</il> in the unfolded state",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.10.2100",
      "rawHtsCode": "4811.10.21.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.41",
      "rawHtsCode": "4811.41",
      "superior": null,
      "indent": "2",
      "description": "Self-adhesive:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.41.1000",
      "rawHtsCode": "4811.41.10.00",
      "superior": null,
      "indent": "3",
      "description": "In strips or rolls of a width exceeding <il>15 cm</il> or in rectangular (including square) sheets with one side exceeding <il>36 cm</il> and the other side exceeding <il>15 cm</il> in the unfolded state",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.41.2100",
      "rawHtsCode": "4811.41.21.00",
      "superior": null,
      "indent": "4",
      "description": "In strips or rolls",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.41.3000",
      "rawHtsCode": "4811.41.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.49",
      "rawHtsCode": "4811.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.49.1000",
      "rawHtsCode": "4811.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "In strips or rolls of a width exceeding <il>15 cm</il> or in rectangular (including square) sheets with one side exceeding <il>36 cm</il> and the other side exceeding <il>15 cm</il> in the unfolded state",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "14%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.49.2100",
      "rawHtsCode": "4811.49.21.00",
      "superior": null,
      "indent": "4",
      "description": "In strips or rolls",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.49.3000",
      "rawHtsCode": "4811.49.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.51",
      "rawHtsCode": "4811.51",
      "superior": null,
      "indent": "2",
      "description": "Bleached, weighing more than <il>150 g/m²:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.51.20",
      "rawHtsCode": "4811.51.20",
      "superior": null,
      "indent": "4",
      "description": "<il>0.3 mm</il> or more in thickness",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.51.2010",
      "rawHtsCode": "4811.51.20.10",
      "superior": null,
      "indent": "5",
      "description": "Base stock for milk cartons and other beverage containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.51.2020",
      "rawHtsCode": "4811.51.20.20",
      "superior": null,
      "indent": "6",
      "description": "Folding carton stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.51.2030",
      "rawHtsCode": "4811.51.20.30",
      "superior": null,
      "indent": "6",
      "description": "Base stock for trays, dishes, plates, cups and the like",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.51.2040",
      "rawHtsCode": "4811.51.20.40",
      "superior": null,
      "indent": "7",
      "description": "Base stock for packaging",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.51.2050",
      "rawHtsCode": "4811.51.20.50",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.51.4000",
      "rawHtsCode": "4811.51.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4811.51.6000",
      "rawHtsCode": "4811.51.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4811.59",
      "rawHtsCode": "4811.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.59.2000",
      "rawHtsCode": "4811.59.20.00",
      "superior": null,
      "indent": "4",
      "description": "Printing paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.59.40",
      "rawHtsCode": "4811.59.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4811.59.4020",
      "rawHtsCode": "4811.59.40.20",
      "superior": null,
      "indent": "5",
      "description": "Folding carton stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.59.4040",
      "rawHtsCode": "4811.59.40.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.59.6000",
      "rawHtsCode": "4811.59.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.60",
      "rawHtsCode": "4811.60",
      "superior": null,
      "indent": "1",
      "description": "Paper and paperboard, coated, impregnated or covered with wax, paraffin, stearin, oil or glycerol:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.60.4000",
      "rawHtsCode": "4811.60.40.00",
      "superior": null,
      "indent": "2",
      "description": "In strips or rolls of a width exceeding <il>15 cm</il> or in rectangular (including square) sheets with one side exceeding <il>36 cm</il> and the other side exceeding <il>15 cm</il> in the unfolded state",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "17.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.60.6000",
      "rawHtsCode": "4811.60.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.90",
      "rawHtsCode": "4811.90",
      "superior": null,
      "indent": "1",
      "description": "Other paper, paperboard, cellulose wadding and webs of cellulose fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.90.1000",
      "rawHtsCode": "4811.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Handmade paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.90.2000",
      "rawHtsCode": "4811.90.20.00",
      "superior": null,
      "indent": "4",
      "description": "Wholly or partly covered with flock, gelatin, metal or metal solutions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "22.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.90.3000",
      "rawHtsCode": "4811.90.30.00",
      "superior": null,
      "indent": "5",
      "description": "Impregnated with latex",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.90.40",
      "rawHtsCode": "4811.90.40",
      "superior": null,
      "indent": "6",
      "description": "Weighing not over <il>15 g/m²</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.90.4010",
      "rawHtsCode": "4811.90.40.10",
      "superior": null,
      "indent": "7",
      "description": "Tissue papers, in sheets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.90.4090",
      "rawHtsCode": "4811.90.40.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.90.60",
      "rawHtsCode": "4811.90.60",
      "superior": null,
      "indent": "6",
      "description": "Weighing over <il>15 g/m²</il> but not over <il>30 g/m²</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.90.6010",
      "rawHtsCode": "4811.90.60.10",
      "superior": null,
      "indent": "7",
      "description": "Tissue papers having a basis weight not exceeding <il>29 g/m²</il>, in sheets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.90.6090",
      "rawHtsCode": "4811.90.60.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.90.80",
      "rawHtsCode": "4811.90.80",
      "superior": null,
      "indent": "6",
      "description": "Weighing over <il>30 g/m²</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "18.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.90.8020",
      "rawHtsCode": "4811.90.80.20",
      "superior": null,
      "indent": "7",
      "description": "Gift Wrap (other than tissue)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.90.8030",
      "rawHtsCode": "4811.90.80.30",
      "superior": null,
      "indent": "7",
      "description": "Direct thermal coated paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.90.8050",
      "rawHtsCode": "4811.90.80.50",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.90.90",
      "rawHtsCode": "4811.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4811.90.9010",
      "rawHtsCode": "4811.90.90.10",
      "superior": null,
      "indent": "3",
      "description": "Tissue papers having a basis weight not exceeding <il>29 g/m²</il>, in sheets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.90.9030",
      "rawHtsCode": "4811.90.90.30",
      "superior": null,
      "indent": "3",
      "description": "Direct thermal coated paper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.90.9035",
      "rawHtsCode": "4811.90.90.35",
      "superior": null,
      "indent": "3",
      "description": "Paper in sheets, lined or ruled, having a width of 152.4 to <il>360 mm</il> inclusive and a length of 225.25 to <il>360 mm</il> inclusive",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4811.90.9080",
      "rawHtsCode": "4811.90.90.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4812.00.0000",
      "rawHtsCode": "4812.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Filter blocks, slabs and plates, of paper pulp",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4813",
      "rawHtsCode": "4813",
      "superior": null,
      "indent": "0",
      "description": "Cigarette paper, whether or not cut to size or in the form of booklets or tubes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4813.10.0000",
      "rawHtsCode": "4813.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "In the form of booklets or tubes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "Imports under this provision may be subject to Federal Excise Tax (26 U.S.C. 5701). "
      ],
      "flags": [
        "IRC_TAX_APPLICABLE"
      ]
    },
    {
      "htsCode": "4813.20.0000",
      "rawHtsCode": "4813.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "In rolls of a width not exceeding <il>5 cm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4813.90.0000",
      "rawHtsCode": "4813.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4814",
      "rawHtsCode": "4814",
      "superior": null,
      "indent": "0",
      "description": "Wallpaper and similar wallcoverings; window transparencies of paper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4814.20.0000",
      "rawHtsCode": "4814.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Wallpaper and similar wallcoverings, consisting of paper coated or covered, on the face side, with a grained, embossed, colored, design-printed or otherwise decorated layer of plastics",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.3¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4814.90.0200",
      "rawHtsCode": "4814.90.02.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.3¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4816",
      "rawHtsCode": "4816",
      "superior": null,
      "indent": "0",
      "description": "Carbon paper, self-copy paper and other copying or transfer papers (other than those of heading 4809), duplicator stencils and offset plates, of paper, whether or not put up in boxes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4816.20.0000",
      "rawHtsCode": "4816.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Self-copy paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4816.90.0100",
      "rawHtsCode": "4816.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4817",
      "rawHtsCode": "4817",
      "superior": null,
      "indent": "0",
      "description": "Envelopes, letter cards, plain postcards and correspondence cards, of paper or paperboard; boxes, pouches, wallets and writing compendiums, of paper or paperboard, containing an assortment of paper stationery:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4817.10.0000",
      "rawHtsCode": "4817.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Envelopes",
      "units": [
        "thousands"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4817.20",
      "rawHtsCode": "4817.20",
      "superior": null,
      "indent": "1",
      "description": "Letter cards, plain postcards and correspondence cards:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4817.20.2000",
      "rawHtsCode": "4817.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Sheets of writing paper, with border gummed or perforated, with or without inserts, prepared for use as combination sheets and envelopes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4817.20.4000",
      "rawHtsCode": "4817.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4817.30.0000",
      "rawHtsCode": "4817.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Boxes, pouches, wallets and writing compendiums, of paper or paperboard, containing an assortment of paper stationery",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4818",
      "rawHtsCode": "4818",
      "superior": null,
      "indent": "0",
      "description": "Toilet paper and similar paper, cellulose wadding or webs of cellulose fibers, of a kind used for household or sanitary purposes, in rolls of a width not exceeding <il>36 cm</il>, or cut to size or shape; handkerchiefs, cleansing tissues, towels, tablecloths, table napkins, bed sheets and similar household, sanitary or hospital articles, articles of apparel and clothing accessories, of paper pulp, paper, cellulose wadding or webs of cellulose fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4818.10.0000",
      "rawHtsCode": "4818.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Toilet paper",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4818.20.00",
      "rawHtsCode": "4818.20.00",
      "superior": null,
      "indent": "1",
      "description": "Handkerchiefs, cleansing or facial tissues and towels",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4818.20.0020",
      "rawHtsCode": "4818.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Towels",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4818.20.0040",
      "rawHtsCode": "4818.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4818.30.0000",
      "rawHtsCode": "4818.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tablecloths and table napkins",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4818.50.00",
      "rawHtsCode": "4818.50.00",
      "superior": null,
      "indent": "1",
      "description": "Articles of apparel and clothing accessories",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4818.50.0020",
      "rawHtsCode": "4818.50.00.20",
      "superior": null,
      "indent": "2",
      "description": "Hospital/medical gowns or scrubs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4818.50.0080",
      "rawHtsCode": "4818.50.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4818.90.00",
      "rawHtsCode": "4818.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4818.90.0020",
      "rawHtsCode": "4818.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Face masks",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4818.90.0080",
      "rawHtsCode": "4818.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819",
      "rawHtsCode": "4819",
      "superior": null,
      "indent": "0",
      "description": "Cartons, boxes, cases, bags and other packing containers, of paper, paperboard, cellulose wadding or webs of cellulose fibers; box files, letter trays and similar articles, of paper or paperboard of a kind used in offices, shops or the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.10.00",
      "rawHtsCode": "4819.10.00",
      "superior": null,
      "indent": "1",
      "description": "Cartons, boxes and cases, of corrugated paper or paperboard",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4819.10.0020",
      "rawHtsCode": "4819.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Sanitary food and beverage containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.10.0040",
      "rawHtsCode": "4819.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.20.00",
      "rawHtsCode": "4819.20.00",
      "superior": null,
      "indent": "1",
      "description": "Folding cartons, boxes and cases, of non-corrugated paper or paperboard",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4819.20.0020",
      "rawHtsCode": "4819.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Sanitary food and beverage containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.20.0040",
      "rawHtsCode": "4819.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.30.00",
      "rawHtsCode": "4819.30.00",
      "superior": null,
      "indent": "1",
      "description": "Sacks and bags, having a base of a width of <il>40 cm</il> or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4819.30.0020",
      "rawHtsCode": "4819.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "Shipping sacks and multiwall bags, other than grocers' bags",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.30.0040",
      "rawHtsCode": "4819.30.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.40.00",
      "rawHtsCode": "4819.40.00",
      "superior": null,
      "indent": "1",
      "description": "Other sacks and bags, including cones",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4819.40.0020",
      "rawHtsCode": "4819.40.00.20",
      "superior": null,
      "indent": "2",
      "description": "Shipping sacks and multiwall bags, other than grocers' bags",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.40.0040",
      "rawHtsCode": "4819.40.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.50",
      "rawHtsCode": "4819.50",
      "superior": null,
      "indent": "1",
      "description": "Other packing containers, including record sleeves:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.50.2000",
      "rawHtsCode": "4819.50.20.00",
      "superior": null,
      "indent": "2",
      "description": "Sanitary food and beverage containers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4819.50.3000",
      "rawHtsCode": "4819.50.30.00",
      "superior": null,
      "indent": "2",
      "description": "Record sleeves",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "19.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4819.50.40",
      "rawHtsCode": "4819.50.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4819.50.4020",
      "rawHtsCode": "4819.50.40.20",
      "superior": null,
      "indent": "3",
      "description": "Fiber drums, cans, tubes and similar containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.50.4040",
      "rawHtsCode": "4819.50.40.40",
      "superior": null,
      "indent": "4",
      "description": "Rigid boxes and cartons",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.50.4060",
      "rawHtsCode": "4819.50.40.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4819.60.0000",
      "rawHtsCode": "4819.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Box files, letter trays, storage boxes and similar articles, of a kind used in offices, shops or the like",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4820",
      "rawHtsCode": "4820",
      "superior": null,
      "indent": "0",
      "description": "Registers, account books, notebooks, order books, receipt books, letter pads, memorandum pads, diaries and similar articles, exercise books, blotting pads, binders (looseleaf or other), folders, file covers, manifold business forms, interleaved carbon sets and other articles of stationery, of paper or paperboard; albums for samples or for collections and book covers (including cover boards and book jackets) of paper or paperboard:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4820.10",
      "rawHtsCode": "4820.10",
      "superior": null,
      "indent": "1",
      "description": "Registers, account books, notebooks, order books, receipt books, letter pads, memorandum pads, diaries and similar articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4820.10.20",
      "rawHtsCode": "4820.10.20",
      "superior": null,
      "indent": "2",
      "description": "Diaries, notebooks and address books, bound; memorandum pads, letter pads and similar articles",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4820.10.2010",
      "rawHtsCode": "4820.10.20.10",
      "superior": null,
      "indent": "3",
      "description": "Diaries and address books",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4820.10.2020",
      "rawHtsCode": "4820.10.20.20",
      "superior": null,
      "indent": "3",
      "description": "Memorandum pads, letter pads and similar articles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4820.10.2030",
      "rawHtsCode": "4820.10.20.30",
      "superior": null,
      "indent": "3",
      "description": "Sewn composition books with dimensions of <il>152.4-381 mm (6\" - 15\")</il>, inclusive (small side) X 222.5-<il>381 mm (8.75\" -15\")</il>, inclusive (large side)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4820.10.2040",
      "rawHtsCode": "4820.10.20.40",
      "superior": null,
      "indent": "3",
      "description": "Other note books with dimensions of <il>152.4-381 mm (6\" - 15\")</il>, inclusive (small side) X 222.5-<il>381 mm (8.75\" -15\")</il>, inclusive (large side)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4820.10.2060",
      "rawHtsCode": "4820.10.20.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4820.10.4000",
      "rawHtsCode": "4820.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4820.20.0000",
      "rawHtsCode": "4820.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Exercise books",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4820.30.00",
      "rawHtsCode": "4820.30.00",
      "superior": null,
      "indent": "1",
      "description": "Binders (other than book covers), folders and file covers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4820.30.0020",
      "rawHtsCode": "4820.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "Looseleaf binders",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4820.30.0040",
      "rawHtsCode": "4820.30.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4820.40.0000",
      "rawHtsCode": "4820.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Manifold business forms and interleaved carbon sets",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4820.50.0000",
      "rawHtsCode": "4820.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Albums for samples or for collections",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4820.90.0000",
      "rawHtsCode": "4820.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4821",
      "rawHtsCode": "4821",
      "superior": null,
      "indent": "0",
      "description": "Paper and paperboard labels of all kinds, whether or not printed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4821.10",
      "rawHtsCode": "4821.10",
      "superior": null,
      "indent": "1",
      "description": "Printed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4821.10.2000",
      "rawHtsCode": "4821.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Printed in whole or in part by a lithographic process",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "88¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4821.10.4000",
      "rawHtsCode": "4821.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4821.90",
      "rawHtsCode": "4821.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4821.90.2000",
      "rawHtsCode": "4821.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Self-adhesive",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4821.90.4000",
      "rawHtsCode": "4821.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4822",
      "rawHtsCode": "4822",
      "superior": null,
      "indent": "0",
      "description": "Bobbins, spools, cops and similar supports of paper pulp, paper or paperboard (whether or not perforated or hardened):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4822.10.0000",
      "rawHtsCode": "4822.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of a kind used for winding textile yarn",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "43%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4822.90.0000",
      "rawHtsCode": "4822.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823",
      "rawHtsCode": "4823",
      "superior": null,
      "indent": "0",
      "description": "Other paper, paperboard, cellulose wadding and webs of cellulose fibers, cut to size or shape; other articles of paper pulp, paper, paperboard, cellulose wadding or webs of cellulose fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4823.20",
      "rawHtsCode": "4823.20",
      "superior": null,
      "indent": "1",
      "description": "Filter paper and paperboard:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4823.20.1000",
      "rawHtsCode": "4823.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Paint filters and strainers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.20.9000",
      "rawHtsCode": "4823.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.40.0000",
      "rawHtsCode": "4823.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Rolls, sheets and dials, printed for self-recording apparatus",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.61.00",
      "rawHtsCode": "4823.61.00",
      "superior": null,
      "indent": "2",
      "description": "Of bamboo",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.61.0020",
      "rawHtsCode": "4823.61.00.20",
      "superior": null,
      "indent": "3",
      "description": "Cups and round nested food containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4823.61.0040",
      "rawHtsCode": "4823.61.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4823.69.00",
      "rawHtsCode": "4823.69.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.69.0020",
      "rawHtsCode": "4823.69.00.20",
      "superior": null,
      "indent": "3",
      "description": "Cups and round nested food containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4823.69.0040",
      "rawHtsCode": "4823.69.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4823.70.00",
      "rawHtsCode": "4823.70.00",
      "superior": null,
      "indent": "1",
      "description": "Molded or pressed articles of paper pulp",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4823.70.0020",
      "rawHtsCode": "4823.70.00.20",
      "superior": null,
      "indent": "2",
      "description": "Plates, bowls or cups",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4823.70.0040",
      "rawHtsCode": "4823.70.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4823.90",
      "rawHtsCode": "4823.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4823.90.1000",
      "rawHtsCode": "4823.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of paper pulp",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.90.2000",
      "rawHtsCode": "4823.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of papier-mâché",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.90.3100",
      "rawHtsCode": "4823.90.31.00",
      "superior": null,
      "indent": "3",
      "description": "Cards, not punched, for punchcard machines, whether or not in strips",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.90.4000",
      "rawHtsCode": "4823.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Frames or mounts for photographic slides",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.90.5000",
      "rawHtsCode": "4823.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Hand fans",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.90.6000",
      "rawHtsCode": "4823.90.60.00",
      "superior": null,
      "indent": "5",
      "description": "Gaskets, washers and other seals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.90.6700",
      "rawHtsCode": "4823.90.67.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.90.7000",
      "rawHtsCode": "4823.90.70.00",
      "superior": null,
      "indent": "4",
      "description": "Of cellulose wadding",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "19.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.90.8000",
      "rawHtsCode": "4823.90.80.00",
      "superior": null,
      "indent": "5",
      "description": "Gaskets, washers and other seals",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "4823.90.86",
      "rawHtsCode": "4823.90.86",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "4823.90.8620",
      "rawHtsCode": "4823.90.86.20",
      "superior": null,
      "indent": "6",
      "description": "Shoe covers (booties) of a kind described in statistical note 2 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4823.90.8680",
      "rawHtsCode": "4823.90.86.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901",
      "rawHtsCode": "4901",
      "superior": null,
      "indent": "0",
      "description": "Printed books, brochures, leaflets and similar printed matter, whether or not in single sheets:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.10.00",
      "rawHtsCode": "4901.10.00",
      "superior": null,
      "indent": "1",
      "description": "In single sheets, whether or not folded",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4901.10.0020",
      "rawHtsCode": "4901.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Reproduction proofs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.10.0040",
      "rawHtsCode": "4901.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.91.00",
      "rawHtsCode": "4901.91.00",
      "superior": null,
      "indent": "2",
      "description": "Dictionaries and encyclopedias, and serial installments thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4901.91.0020",
      "rawHtsCode": "4901.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Dictionaries (including thesauruses)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.91.0040",
      "rawHtsCode": "4901.91.00.40",
      "superior": null,
      "indent": "3",
      "description": "Encyclopedias",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.99.00",
      "rawHtsCode": "4901.99.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4901.99.0010",
      "rawHtsCode": "4901.99.00.10",
      "superior": null,
      "indent": "3",
      "description": "Textbooks",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.99.0020",
      "rawHtsCode": "4901.99.00.20",
      "superior": null,
      "indent": "3",
      "description": "Bound newspapers, journals and periodicals provided for in Legal Note 3 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.99.0030",
      "rawHtsCode": "4901.99.00.30",
      "superior": null,
      "indent": "3",
      "description": "Directories",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.99.0040",
      "rawHtsCode": "4901.99.00.40",
      "superior": null,
      "indent": "4",
      "description": "Bibles, testaments, prayer books and other religious books",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.99.0050",
      "rawHtsCode": "4901.99.00.50",
      "superior": null,
      "indent": "4",
      "description": "Technical, scientific and professional books",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.99.0060",
      "rawHtsCode": "4901.99.00.60",
      "superior": null,
      "indent": "5",
      "description": "Valued under $5 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.99.0065",
      "rawHtsCode": "4901.99.00.65",
      "superior": null,
      "indent": "5",
      "description": "Valued $5 or more each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.99.0070",
      "rawHtsCode": "4901.99.00.70",
      "superior": null,
      "indent": "5",
      "description": "Hardbound books",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.99.0075",
      "rawHtsCode": "4901.99.00.75",
      "superior": null,
      "indent": "5",
      "description": "Rack size paperbound books",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.99.0091",
      "rawHtsCode": "4901.99.00.91",
      "superior": null,
      "indent": "6",
      "description": "Containing not more than 4 pages each (excluding covers)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.99.0092",
      "rawHtsCode": "4901.99.00.92",
      "superior": null,
      "indent": "6",
      "description": "Containing 5 or more pages each, but not more than 48 pages each (excluding covers)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4901.99.0093",
      "rawHtsCode": "4901.99.00.93",
      "superior": null,
      "indent": "6",
      "description": "Containing 49 or more pages each (excluding covers)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4902",
      "rawHtsCode": "4902",
      "superior": null,
      "indent": "0",
      "description": "Newspapers, journals and periodicals, whether or not illustrated or containing advertising material:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4902.10.0000",
      "rawHtsCode": "4902.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Appearing at least four times a week",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4902.90",
      "rawHtsCode": "4902.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4902.90.1000",
      "rawHtsCode": "4902.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Newspaper supplements printed by a gravure process",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4902.90.20",
      "rawHtsCode": "4902.90.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4902.90.2020",
      "rawHtsCode": "4902.90.20.20",
      "superior": null,
      "indent": "3",
      "description": "Newspapers appearing less than four times per week",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4902.90.2040",
      "rawHtsCode": "4902.90.20.40",
      "superior": null,
      "indent": "3",
      "description": "Other business and professional journals and periodicals (including single issues tied together for shipping purposes)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4902.90.2060",
      "rawHtsCode": "4902.90.20.60",
      "superior": null,
      "indent": "3",
      "description": "Other (including single issues tied together for shipping purposes)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4903.00.0000",
      "rawHtsCode": "4903.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Children's picture, drawing or coloring books",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4904.00.00",
      "rawHtsCode": "4904.00.00",
      "superior": null,
      "indent": "0",
      "description": "Music, printed or in manuscript, whether or not bound or illustrated",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4904.00.0020",
      "rawHtsCode": "4904.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Sheet music, whether or not stapled or folded, but not otherwise bound",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4904.00.0040",
      "rawHtsCode": "4904.00.00.40",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4905",
      "rawHtsCode": "4905",
      "superior": null,
      "indent": "0",
      "description": "Maps and hydrographic or similar charts of all kinds, including atlases, wall maps, topographical plans and globes, printed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4905.20.0000",
      "rawHtsCode": "4905.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "In book form",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4905.90",
      "rawHtsCode": "4905.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4905.90.2000",
      "rawHtsCode": "4905.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Globes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4905.90.6000",
      "rawHtsCode": "4905.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4906.00.0000",
      "rawHtsCode": "4906.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Plans and drawings for architectural, engineering, industrial, commercial, topographical or similar purposes, being originals drawn by hand; handwritten texts; photographic reproductions on sensitized paper and carbon copies of the foregoing",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4907.00.0000",
      "rawHtsCode": "4907.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Unused postage, revenue or similar stamps of current or new issue in the country in which they have, or will have, a recognized face value; stamp-impressed paper; banknotes; check forms; stock, share or bond certificates and similar documents of title",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "66¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4908",
      "rawHtsCode": "4908",
      "superior": null,
      "indent": "0",
      "description": "Transfers (decalcomanias):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4908.10.0000",
      "rawHtsCode": "4908.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Transfers (decalcomanias), vitrifiable",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "66¢/kg + 15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4908.90.0000",
      "rawHtsCode": "4908.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "88¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4909.00",
      "rawHtsCode": "4909.00",
      "superior": null,
      "indent": "0",
      "description": "Printed or illustrated postcards; printed cards bearing personal greetings, messages or announcements, whether or not illustrated, with or without envelopes or trimmings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4909.00.2000",
      "rawHtsCode": "4909.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Postcards",
      "units": [
        "thousands"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4909.00.4000",
      "rawHtsCode": "4909.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4910.00",
      "rawHtsCode": "4910.00",
      "superior": null,
      "indent": "0",
      "description": "Calendars of any kind, printed, including calendar blocks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4910.00.2000",
      "rawHtsCode": "4910.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "Not over 0.51 mm in thickness",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "66¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4910.00.4000",
      "rawHtsCode": "4910.00.40.00",
      "superior": null,
      "indent": "2",
      "description": "Over 0.51 mm in thickness",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "19¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4910.00.6000",
      "rawHtsCode": "4910.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4911",
      "rawHtsCode": "4911",
      "superior": null,
      "indent": "0",
      "description": "Other printed matter, including printed pictures and photographs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.10.00",
      "rawHtsCode": "4911.10.00",
      "superior": null,
      "indent": "1",
      "description": "Trade advertising material, commercial catalogs and the like",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4911.10.0020",
      "rawHtsCode": "4911.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Printed catalogs relating principally to current offers for the sale of United States products",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.10.0040",
      "rawHtsCode": "4911.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Printed catalogs, price lists or trade notices, relating to offers, by a person whose principal place of business or bonafide residence is in a foreign country, to sell or rent products of a foreign country or to furnish foreign or international transportation or commercial insurance services",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.10.0060",
      "rawHtsCode": "4911.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Tourist and other literature (including posters), containing geographic, historical, hotel, institutional, timetable, travel or similar information, principally with respect to places, travel facilities or educational opportunities outside the customs territory of the United States",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.10.0080",
      "rawHtsCode": "4911.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.91",
      "rawHtsCode": "4911.91",
      "superior": null,
      "indent": "2",
      "description": "Pictures, designs and photographs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.91.1000",
      "rawHtsCode": "4911.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Printed over 20 years at time of importation",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4911.91.1500",
      "rawHtsCode": "4911.91.15.00",
      "superior": null,
      "indent": "4",
      "description": "Suitable for use in the production of articles of heading 4901",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4911.91.20",
      "rawHtsCode": "4911.91.20",
      "superior": null,
      "indent": "6",
      "description": "Not over 0.51 mm in thickness",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "66¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.91.2020",
      "rawHtsCode": "4911.91.20.20",
      "superior": null,
      "indent": "7",
      "description": "Posters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.91.2040",
      "rawHtsCode": "4911.91.20.40",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.91.3000",
      "rawHtsCode": "4911.91.30.00",
      "superior": null,
      "indent": "6",
      "description": "Over 0.51 mm in thickness",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "19.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.91.40",
      "rawHtsCode": "4911.91.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "4911.91.4020",
      "rawHtsCode": "4911.91.40.20",
      "superior": null,
      "indent": "6",
      "description": "Posters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.91.4040",
      "rawHtsCode": "4911.91.40.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.99",
      "rawHtsCode": "4911.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "4911.99.2000",
      "rawHtsCode": "4911.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "International customs forms (carnets) and parts thereof, in English or French (whether or not in additional languages)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4911.99.6000",
      "rawHtsCode": "4911.99.60.00",
      "superior": null,
      "indent": "4",
      "description": "Printed on paper in whole or in part by a lithographic process",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "66¢/kg + 0.4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "4911.99.8000",
      "rawHtsCode": "4911.99.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "5001.00.0000",
      "rawHtsCode": "5001.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Silkworm cocoons suitable for reeling",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5002.00.0000",
      "rawHtsCode": "5002.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Raw silk (not thrown)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5003.00",
      "rawHtsCode": "5003.00",
      "superior": null,
      "indent": "0",
      "description": "Silk waste (including cocoons unsuitable for reeling, yarn waste and garnetted stock):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5003.00.1000",
      "rawHtsCode": "5003.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Not carded or combed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5003.00.9000",
      "rawHtsCode": "5003.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5004.00.0000",
      "rawHtsCode": "5004.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Silk yarn (other than yarn spun from silk waste) not put up for retail sale",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5005.00.00",
      "rawHtsCode": "5005.00.00",
      "superior": null,
      "indent": "0",
      "description": "Yarn spun from silk waste, not put up for retail sale",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5005.00.0010",
      "rawHtsCode": "5005.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5005.00.0090",
      "rawHtsCode": "5005.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other (800)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5006.00",
      "rawHtsCode": "5006.00",
      "superior": null,
      "indent": "0",
      "description": "Silk yarn and yarn spun from silk waste, put up for retail sale; silkworm gut:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5006.00.1000",
      "rawHtsCode": "5006.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5006.00.9000",
      "rawHtsCode": "5006.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other (800)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5007",
      "rawHtsCode": "5007",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of silk or of silk waste:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.10",
      "rawHtsCode": "5007.10",
      "superior": null,
      "indent": "1",
      "description": "Fabrics of noil silk:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.10.30",
      "rawHtsCode": "5007.10.30",
      "superior": null,
      "indent": "2",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "0.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5007.10.3020",
      "rawHtsCode": "5007.10.30.20",
      "superior": null,
      "indent": "4",
      "description": "More than 127 cm in width",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.10.3040",
      "rawHtsCode": "5007.10.30.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.10.3090",
      "rawHtsCode": "5007.10.30.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.10.60",
      "rawHtsCode": "5007.10.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5007.10.6010",
      "rawHtsCode": "5007.10.60.10",
      "superior": null,
      "indent": "4",
      "description": "Of yarns of different colors (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.10.6020",
      "rawHtsCode": "5007.10.60.20",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.10.6030",
      "rawHtsCode": "5007.10.60.30",
      "superior": null,
      "indent": "3",
      "description": "Subject to wool restraints (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.10.6090",
      "rawHtsCode": "5007.10.60.90",
      "superior": null,
      "indent": "3",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.20.00",
      "rawHtsCode": "5007.20.00",
      "superior": null,
      "indent": "1",
      "description": "Other fabrics, containing 85 percent or more by weight of silk or of silk waste other than noil silk",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5007.20.0015",
      "rawHtsCode": "5007.20.00.15",
      "superior": null,
      "indent": "3",
      "description": "Measuring less than 77 cm in width or less than 77 cm between selvages, with more than 47 warp yarns per cm, of a kind for use in the manufacture of neckties",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.20.0025",
      "rawHtsCode": "5007.20.00.25",
      "superior": null,
      "indent": "4",
      "description": "More than 127 cm in width",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.20.0035",
      "rawHtsCode": "5007.20.00.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.20.0055",
      "rawHtsCode": "5007.20.00.55",
      "superior": null,
      "indent": "3",
      "description": "Measuring less than 77 cm in width or less than 77 cm between selvages, with more than 47 warp yarns per cm, of a kind for use in the manufacture of neckties",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.20.0065",
      "rawHtsCode": "5007.20.00.65",
      "superior": null,
      "indent": "5",
      "description": "More than 127 cm in width",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "5007.20.0085",
      "rawHtsCode": "5007.20.00.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "5007.20.0095",
      "rawHtsCode": "5007.20.00.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.90",
      "rawHtsCode": "5007.90",
      "superior": null,
      "indent": "1",
      "description": "Other fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.90.30",
      "rawHtsCode": "5007.90.30",
      "superior": null,
      "indent": "2",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "0.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5007.90.3020",
      "rawHtsCode": "5007.90.30.20",
      "superior": null,
      "indent": "4",
      "description": "More than 127 cm in width",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.90.3040",
      "rawHtsCode": "5007.90.30.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.90.3090",
      "rawHtsCode": "5007.90.30.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.90.60",
      "rawHtsCode": "5007.90.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5007.90.6010",
      "rawHtsCode": "5007.90.60.10",
      "superior": null,
      "indent": "4",
      "description": "Of yarns of different colors (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.90.6020",
      "rawHtsCode": "5007.90.60.20",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.90.6030",
      "rawHtsCode": "5007.90.60.30",
      "superior": null,
      "indent": "3",
      "description": "Subject to wool restraints (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5007.90.6090",
      "rawHtsCode": "5007.90.60.90",
      "superior": null,
      "indent": "3",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101",
      "rawHtsCode": "5101",
      "superior": null,
      "indent": "0",
      "description": "Wool, not carded or combed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.11",
      "rawHtsCode": "5101.11",
      "superior": null,
      "indent": "2",
      "description": "Shorn wool:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.11.1000",
      "rawHtsCode": "5101.11.10.00",
      "superior": null,
      "indent": "4",
      "description": "Wool for special uses",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free, under bond",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.11.2000",
      "rawHtsCode": "5101.11.20.00",
      "superior": null,
      "indent": "5",
      "description": "Unimproved wool; other wool, not finer than 40s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55.1¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.11.4000",
      "rawHtsCode": "5101.11.40.00",
      "superior": null,
      "indent": "5",
      "description": "Other wool, finer than 40s but not finer than 44s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "66.1¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.11.5000",
      "rawHtsCode": "5101.11.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other wool, finer than 44s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "77.2¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.11.60",
      "rawHtsCode": "5101.11.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "18.7¢/clean kg",
      "specialRate": "Free (AU,BH, CL,CO,E,IL, JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.2¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5101.11.6030",
      "rawHtsCode": "5101.11.60.30",
      "superior": null,
      "indent": "4",
      "description": "Not finer than 58s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.11.6060",
      "rawHtsCode": "5101.11.60.60",
      "superior": null,
      "indent": "4",
      "description": "Finer than 58s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.19",
      "rawHtsCode": "5101.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.19.1000",
      "rawHtsCode": "5101.19.10.00",
      "superior": null,
      "indent": "4",
      "description": "Wool for special uses",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free, under bond",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.19.2000",
      "rawHtsCode": "5101.19.20.00",
      "superior": null,
      "indent": "5",
      "description": "Unimproved wool; other wool, not finer than 40s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55.1¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.19.4000",
      "rawHtsCode": "5101.19.40.00",
      "superior": null,
      "indent": "5",
      "description": "Other wool, finer than 40s but not finer than 44s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "66.1¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.19.5000",
      "rawHtsCode": "5101.19.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other wool, finer than 44s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "77.2¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.19.60",
      "rawHtsCode": "5101.19.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "18.7¢/clean kg",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "77.2¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5101.19.6030",
      "rawHtsCode": "5101.19.60.30",
      "superior": null,
      "indent": "4",
      "description": "Not finer than 58s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.19.6060",
      "rawHtsCode": "5101.19.60.60",
      "superior": null,
      "indent": "4",
      "description": "Finer than 58s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.21",
      "rawHtsCode": "5101.21",
      "superior": null,
      "indent": "2",
      "description": "Shorn wool:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.21.1000",
      "rawHtsCode": "5101.21.10.00",
      "superior": null,
      "indent": "5",
      "description": "Wool for special uses",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free, under bond",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.21.1500",
      "rawHtsCode": "5101.21.15.00",
      "superior": null,
      "indent": "6",
      "description": "Unimproved wool; other wool, not finer than 40s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "59.5¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.21.3000",
      "rawHtsCode": "5101.21.30.00",
      "superior": null,
      "indent": "6",
      "description": "Other wool, finer than 40s but not finer than 44s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "70.6¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.21.3500",
      "rawHtsCode": "5101.21.35.00",
      "superior": null,
      "indent": "6",
      "description": "Other wool, finer than 44s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "81.6¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.21.40",
      "rawHtsCode": "5101.21.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "20.6¢/clean kg",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81.6¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5101.21.4030",
      "rawHtsCode": "5101.21.40.30",
      "superior": null,
      "indent": "5",
      "description": "Not finer than 58s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.21.4060",
      "rawHtsCode": "5101.21.40.60",
      "superior": null,
      "indent": "5",
      "description": "Finer than 58s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.21.6500",
      "rawHtsCode": "5101.21.65.00",
      "superior": null,
      "indent": "4",
      "description": "Unimproved wool; other wool, not finer than 46s.",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "81.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.21.7000",
      "rawHtsCode": "5101.21.70.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5¢/kg + 5.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5101.29",
      "rawHtsCode": "5101.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.29.1000",
      "rawHtsCode": "5101.29.10.00",
      "superior": null,
      "indent": "5",
      "description": "Wool for special uses",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free, under bond",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.29.1500",
      "rawHtsCode": "5101.29.15.00",
      "superior": null,
      "indent": "6",
      "description": "Unimproved wool; other wool, not finer than 40s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "59.6¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.29.3000",
      "rawHtsCode": "5101.29.30.00",
      "superior": null,
      "indent": "6",
      "description": "Other wool, finer than 40s but not finer than 44s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "70.6¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.29.3500",
      "rawHtsCode": "5101.29.35.00",
      "superior": null,
      "indent": "6",
      "description": "Other wool, finer than 44s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "81.6¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.29.40",
      "rawHtsCode": "5101.29.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "20.6¢/clean kg",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81.6¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5101.29.4030",
      "rawHtsCode": "5101.29.40.30",
      "superior": null,
      "indent": "5",
      "description": "Not finer than 58s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.29.4060",
      "rawHtsCode": "5101.29.40.60",
      "superior": null,
      "indent": "5",
      "description": "Finer than 58s",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.29.6500",
      "rawHtsCode": "5101.29.65.00",
      "superior": null,
      "indent": "4",
      "description": "Unimproved wool; other wool, not finer than 46s",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "81.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.29.7000",
      "rawHtsCode": "5101.29.70.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5¢/kg + 5.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5101.30",
      "rawHtsCode": "5101.30",
      "superior": null,
      "indent": "1",
      "description": "Carbonized:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5101.30.1000",
      "rawHtsCode": "5101.30.10.00",
      "superior": null,
      "indent": "3",
      "description": "Unimproved wool; other wool, not finer than 40s",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.30.1500",
      "rawHtsCode": "5101.30.15.00",
      "superior": null,
      "indent": "3",
      "description": "Other wool, finer than 40s but not finer than 44s",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "86.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.30.3000",
      "rawHtsCode": "5101.30.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other wool, finer than 44s but not finer than 46s",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "97¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.30.4000",
      "rawHtsCode": "5101.30.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "24.4¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "97¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5101.30.6500",
      "rawHtsCode": "5101.30.65.00",
      "superior": null,
      "indent": "3",
      "description": "Unimproved wool; other wool, not finer than 46s",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "81.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5101.30.7000",
      "rawHtsCode": "5101.30.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.5¢/kg + 5.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5102",
      "rawHtsCode": "5102",
      "superior": null,
      "indent": "0",
      "description": "Fine or coarse animal hair, not carded or combed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5102.11",
      "rawHtsCode": "5102.11",
      "superior": null,
      "indent": "2",
      "description": "Of Kashmir (cashmere) goats:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5102.11.1000",
      "rawHtsCode": "5102.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Not processed in any manner beyond the degreased or carbonized condition",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "5.1¢/clean kg",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "46.3¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5102.11.9000",
      "rawHtsCode": "5102.11.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "4.9¢/kg + 4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5102.19",
      "rawHtsCode": "5102.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5102.19.2000",
      "rawHtsCode": "5102.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "Hair of the camel",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "5¢/clean kg",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "55¢/clean kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5102.19.60",
      "rawHtsCode": "5102.19.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "0.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5102.19.6030",
      "rawHtsCode": "5102.19.60.30",
      "superior": null,
      "indent": "5",
      "description": "Hair of the Angora goat",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5102.19.6060",
      "rawHtsCode": "5102.19.60.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "cy kg",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5102.19.8000",
      "rawHtsCode": "5102.19.80.00",
      "superior": null,
      "indent": "4",
      "description": "Fur, prepared for hatters' use",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5102.19.9000",
      "rawHtsCode": "5102.19.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.9¢/kg + 4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5102.20.0000",
      "rawHtsCode": "5102.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Coarse animal hair",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5103",
      "rawHtsCode": "5103",
      "superior": null,
      "indent": "0",
      "description": "Waste of wool or of fine or coarse animal hair, including yarn waste but excluding garnetted stock:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5103.10.0000",
      "rawHtsCode": "5103.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Noils of wool or of fine animal hair",
      "units": [
        "kg"
      ],
      "generalRate": "2.6¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5103.20.0000",
      "rawHtsCode": "5103.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other waste of wool or of fine animal hair",
      "units": [
        "kg"
      ],
      "generalRate": "2.6¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5103.30.0000",
      "rawHtsCode": "5103.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Waste of coarse animal hair",
      "units": [
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5104.00.0000",
      "rawHtsCode": "5104.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Garnetted stock of wool or of fine or coarse animal hair",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "57.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5105",
      "rawHtsCode": "5105",
      "superior": null,
      "indent": "0",
      "description": "Wool and fine or coarse animal hair, carded or combed (including combed wool in fragments):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5105.10.0000",
      "rawHtsCode": "5105.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Carded wool (400)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5¢/kg + 5.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5105.21.0000",
      "rawHtsCode": "5105.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Combed wool in fragments (400)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7¢/kg + 3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5105.29.0000",
      "rawHtsCode": "5105.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other (400)",
      "units": [
        "kg"
      ],
      "generalRate": "3.9¢/kg + 3.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5105.31.0000",
      "rawHtsCode": "5105.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of Kashmir (cashmere) goats (400)",
      "units": [
        "kg"
      ],
      "generalRate": "6.8¢/kg + 5.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81.6¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5105.39.0000",
      "rawHtsCode": "5105.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other (400)",
      "units": [
        "kg"
      ],
      "generalRate": "6.8¢/kg + 5.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81.6¢/kg +20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5105.40.0000",
      "rawHtsCode": "5105.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Coarse animal hair, carded or combed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5106",
      "rawHtsCode": "5106",
      "superior": null,
      "indent": "0",
      "description": "Yarn of carded wool, not put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5106.10.00",
      "rawHtsCode": "5106.10.00",
      "superior": null,
      "indent": "1",
      "description": "Containing 85 percent or more by weight of wool",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5106.10.0010",
      "rawHtsCode": "5106.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of which the average fiber diameter is not less than 34.40 microns (400)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5106.10.0090",
      "rawHtsCode": "5106.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other (400)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5106.20.0000",
      "rawHtsCode": "5106.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Containing less than 85 percent by weight of wool (400)",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5107",
      "rawHtsCode": "5107",
      "superior": null,
      "indent": "0",
      "description": "Yarn of combed wool, not put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5107.10",
      "rawHtsCode": "5107.10",
      "superior": null,
      "indent": "1",
      "description": "Containing 85 percent or more by weight of wool:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5107.10.3000",
      "rawHtsCode": "5107.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool fiber with an average fiber diameter of 18.5 microns or less (400)",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5107.10.6000",
      "rawHtsCode": "5107.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other (400)",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5107.20",
      "rawHtsCode": "5107.20",
      "superior": null,
      "indent": "1",
      "description": "Containing less than 85 percent by weight of wool:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5107.20.3000",
      "rawHtsCode": "5107.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool fiber with an average fiber diameter of 18.5 microns or less (400)",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5107.20.6000",
      "rawHtsCode": "5107.20.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other (400)",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5108",
      "rawHtsCode": "5108",
      "superior": null,
      "indent": "0",
      "description": "Yarn of fine animal hair (carded or combed), not put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5108.10",
      "rawHtsCode": "5108.10",
      "superior": null,
      "indent": "1",
      "description": "Carded:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5108.10.3000",
      "rawHtsCode": "5108.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of Angora rabbit hair (400)",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5108.10.4000",
      "rawHtsCode": "5108.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of mohair (400)",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5108.10.8000",
      "rawHtsCode": "5108.10.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other (400)",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5108.20",
      "rawHtsCode": "5108.20",
      "superior": null,
      "indent": "1",
      "description": "Combed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5108.20.3000",
      "rawHtsCode": "5108.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of Angora rabbit hair (400)",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5108.20.4000",
      "rawHtsCode": "5108.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of mohair (400)",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5108.20.8000",
      "rawHtsCode": "5108.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other (400)",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5109",
      "rawHtsCode": "5109",
      "superior": null,
      "indent": "0",
      "description": "Yarn of wool or of fine animal hair, put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5109.10",
      "rawHtsCode": "5109.10",
      "superior": null,
      "indent": "1",
      "description": "Containing 85 percent or more by weight of wool or of fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5109.10.2000",
      "rawHtsCode": "5109.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Yarn of wool, colored (dyed or printed) and cut into uniform lengths of not over 8 cm (400)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5109.10.4000",
      "rawHtsCode": "5109.10.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of Angora rabbit hair (400)",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5109.10.8000",
      "rawHtsCode": "5109.10.80.00",
      "superior": null,
      "indent": "4",
      "description": "Of wool fiber with an average fiber diameter of 18.5 microns or less (400)",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5109.10.9000",
      "rawHtsCode": "5109.10.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other (400)",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5109.90",
      "rawHtsCode": "5109.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5109.90.2000",
      "rawHtsCode": "5109.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Yarn of wool, colored (dyed or printed) and cut into uniform lengths of not over 8 cm (400)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5109.90.4000",
      "rawHtsCode": "5109.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of Angora rabbit hair (400)",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5109.90.8000",
      "rawHtsCode": "5109.90.80.00",
      "superior": null,
      "indent": "4",
      "description": "Of wool fiber with an average fiber diameter of 18.5 microns or less (400)",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5109.90.9000",
      "rawHtsCode": "5109.90.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other (400)",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5110.00.0000",
      "rawHtsCode": "5110.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Yarn of coarse animal hair or of horsehair (including gimped horsehair yarn), whether or not put up for retail sale",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5111",
      "rawHtsCode": "5111",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of carded wool or of carded fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5111.11",
      "rawHtsCode": "5111.11",
      "superior": null,
      "indent": "2",
      "description": "Of a weight not exceeding 300 g/m<sup>2</sup>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5111.11.2000",
      "rawHtsCode": "5111.11.20.00",
      "superior": null,
      "indent": "3",
      "description": "Tapestry fabrics and upholstery fabrics of a weight not exceeding 140 g/m<sup>2</sup> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.11.3000",
      "rawHtsCode": "5111.11.30.00",
      "superior": null,
      "indent": "4",
      "description": "Hand-woven, with a loom width of less than <il>76 cm</il> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.11.70",
      "rawHtsCode": "5111.11.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.11.7030",
      "rawHtsCode": "5111.11.70.30",
      "superior": null,
      "indent": "5",
      "description": "Wholly or in part of fine animal hair (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5111.11.7060",
      "rawHtsCode": "5111.11.70.60",
      "superior": null,
      "indent": "5",
      "description": "Other (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5111.19",
      "rawHtsCode": "5111.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5111.19.1000",
      "rawHtsCode": "5111.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Tapestry fabrics and upholstery fabrics (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.19.2000",
      "rawHtsCode": "5111.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "Hand-woven, with a loom width of less than <il>76 cm</il> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.19.60",
      "rawHtsCode": "5111.19.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.19.6020",
      "rawHtsCode": "5111.19.60.20",
      "superior": null,
      "indent": "6",
      "description": "Weighing not more than <il>400 g/m<sup>2</sup></il> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5111.19.6040",
      "rawHtsCode": "5111.19.60.40",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than <il>400 g/m<sup>2</sup></il> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5111.19.6060",
      "rawHtsCode": "5111.19.60.60",
      "superior": null,
      "indent": "6",
      "description": "Weighing not more than 400 g/m<sup>2</sup> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5111.19.6080",
      "rawHtsCode": "5111.19.60.80",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than 400 g/m<sup>2</sup> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5111.20",
      "rawHtsCode": "5111.20",
      "superior": null,
      "indent": "1",
      "description": "Other, mixed mainly or solely with man-made filaments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5111.20.0500",
      "rawHtsCode": "5111.20.05.00",
      "superior": null,
      "indent": "2",
      "description": "Tapestry fabrics and upholstery fabrics of a weight exceeding <il>300 g/m<sup>2</sup></il> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.20.1000",
      "rawHtsCode": "5111.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Tapestry fabrics and upholstery fabrics of a weight not exceeding <il>140 g/m<sup>2</sup></il> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.20.9000",
      "rawHtsCode": "5111.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.30",
      "rawHtsCode": "5111.30",
      "superior": null,
      "indent": "1",
      "description": "Other, mixed mainly or solely with man-made staple fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5111.30.0500",
      "rawHtsCode": "5111.30.05.00",
      "superior": null,
      "indent": "2",
      "description": "Tapestry fabrics and upholstery fabrics of a weight exceeding <il>300 g/m<sup>2</sup></il> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.30.1000",
      "rawHtsCode": "5111.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Tapestry fabrics and upholstery fabrics of a weight not exceeding <il>140 g/m<sup>2</sup></il> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.30.9000",
      "rawHtsCode": "5111.30.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.90",
      "rawHtsCode": "5111.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5111.90.3000",
      "rawHtsCode": "5111.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 30 percent or more by weight of silk or silk waste, valued over <il>$33/kg</il> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "6.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.90.4000",
      "rawHtsCode": "5111.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Tapestry fabrics and upholstery fabrics of a weight exceeding <il>300 g/m<sup>2</sup></il> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.90.5000",
      "rawHtsCode": "5111.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Tapestry fabrics and upholstery fabrics of a weight not exceeding <il>140 g/m<sup>2</sup></il> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5111.90.9000",
      "rawHtsCode": "5111.90.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112",
      "rawHtsCode": "5112",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of combed wool or of combed fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.11",
      "rawHtsCode": "5112.11",
      "superior": null,
      "indent": "2",
      "description": "Of a weight not exceeding <il>200g/m<sup>2</sup>:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.11.1000",
      "rawHtsCode": "5112.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Tapestry fabrics and upholstery fabrics of a weight not exceeding <il>140 g/m<sup>2</sup></il> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.11.30",
      "rawHtsCode": "5112.11.30",
      "superior": null,
      "indent": "4",
      "description": "Of wool yarns with an average fiber diameter of 18.5 microns or less",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.11.3030",
      "rawHtsCode": "5112.11.30.30",
      "superior": null,
      "indent": "5",
      "description": "Containing fine animal hair (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.11.3060",
      "rawHtsCode": "5112.11.30.60",
      "superior": null,
      "indent": "5",
      "description": "Other (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.11.60",
      "rawHtsCode": "5112.11.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.11.6030",
      "rawHtsCode": "5112.11.60.30",
      "superior": null,
      "indent": "5",
      "description": "Wholly or in part of fine animal hair (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.11.6060",
      "rawHtsCode": "5112.11.60.60",
      "superior": null,
      "indent": "5",
      "description": "Other (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19",
      "rawHtsCode": "5112.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19.2000",
      "rawHtsCode": "5112.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Tapestry fabrics and upholstery fabrics (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.19.60",
      "rawHtsCode": "5112.19.60",
      "superior": null,
      "indent": "4",
      "description": "Of wool yarns with an average fiber diameter of 18.5 microns or less",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.19.6010",
      "rawHtsCode": "5112.19.60.10",
      "superior": null,
      "indent": "6",
      "description": "Weighing not more than <il>270 g/m<sup>2</sup></il> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19.6020",
      "rawHtsCode": "5112.19.60.20",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than <il>270 g/m<sup>2</sup></il> but not more than <il>340 g/m<sup>2</sup></il> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19.6030",
      "rawHtsCode": "5112.19.60.30",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than <il>340 g/m<sup>2</sup></il> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19.6040",
      "rawHtsCode": "5112.19.60.40",
      "superior": null,
      "indent": "6",
      "description": "Weighing not more than <il>270 g/m<sup>2</sup></il> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19.6050",
      "rawHtsCode": "5112.19.60.50",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than <il>270 g/m<sup>2</sup></il> but not more than <il>340 g/m<sup>2</sup></il> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19.6060",
      "rawHtsCode": "5112.19.60.60",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than 340 g/m<sup>2</sup> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19.95",
      "rawHtsCode": "5112.19.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.19.9510",
      "rawHtsCode": "5112.19.95.10",
      "superior": null,
      "indent": "6",
      "description": "Weighing not more than <il>270 g/m<sup>2</sup></il> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19.9520",
      "rawHtsCode": "5112.19.95.20",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than 270 g/m<sup>2</sup> but not more than 340 g/m<sup>2</sup> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19.9530",
      "rawHtsCode": "5112.19.95.30",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than 340 g/m<sup>2</sup> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19.9540",
      "rawHtsCode": "5112.19.95.40",
      "superior": null,
      "indent": "6",
      "description": "Weighing not more than 270 g/m<sup>2</sup> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19.9550",
      "rawHtsCode": "5112.19.95.50",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than 270 g/m<sup>2</sup> but not more than 340 g/m<sup>2</sup> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.19.9560",
      "rawHtsCode": "5112.19.95.60",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than 340 g/m<sup>2</sup> (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.20",
      "rawHtsCode": "5112.20",
      "superior": null,
      "indent": "1",
      "description": "Other, mixed mainly or solely with man-made filaments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.20.1000",
      "rawHtsCode": "5112.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Tapestry fabrics and upholstery fabrics of a weight exceeding 300 g/m<sup>2</sup> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.20.2000",
      "rawHtsCode": "5112.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Tapestry fabrics and upholstery fabrics of a weight not exceeding 140 g/m<sup>2</sup> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.20.3000",
      "rawHtsCode": "5112.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "Other (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.30",
      "rawHtsCode": "5112.30",
      "superior": null,
      "indent": "1",
      "description": "Other, mixed mainly or solely with man-made staple fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.30.1000",
      "rawHtsCode": "5112.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Tapestry fabrics and upholstery fabrics of a weight exceeding 300 g/m<sup>2</sup> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.30.2000",
      "rawHtsCode": "5112.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Tapestry fabrics and upholstery fabrics of a weight not exceeding 140 g/m<sup>2</sup> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.30.3000",
      "rawHtsCode": "5112.30.30.00",
      "superior": null,
      "indent": "2",
      "description": "Other (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.90",
      "rawHtsCode": "5112.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.90.3000",
      "rawHtsCode": "5112.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 30 percent or more by weight of silk or silk waste, valued over $33/kg (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "6.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.90.4000",
      "rawHtsCode": "5112.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Tapestry fabrics and upholstery fabrics of a weight exceeding 300 g/m<sup>2</sup> (414)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.90.5000",
      "rawHtsCode": "5112.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Tapestry fabrics and upholstery fabrics of a weight not exceeding 140 g/m<sup>2</sup> (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.90.90",
      "rawHtsCode": "5112.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5112.90.9010",
      "rawHtsCode": "5112.90.90.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with cotton (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5112.90.9090",
      "rawHtsCode": "5112.90.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5113.00.0000",
      "rawHtsCode": "5113.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of coarse animal hair or of horsehair",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5201.00",
      "rawHtsCode": "5201.00",
      "superior": null,
      "indent": "0",
      "description": "Cotton, not carded or combed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.52.00 through 9903.52.26 and 9904.52.01 through 9904.52.34."
      ],
      "flags": []
    },
    {
      "htsCode": "5201.00.0500",
      "rawHtsCode": "5201.00.05.00",
      "superior": null,
      "indent": "2",
      "description": "Harsh or rough, having a staple length under <il>19.05 mm</il> (3/4 inch)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5201.00.1200",
      "rawHtsCode": "5201.00.12.00",
      "superior": null,
      "indent": "3",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5201.00.1400",
      "rawHtsCode": "5201.00.14.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 5 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5201.00.1800",
      "rawHtsCode": "5201.00.18.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "31.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "36.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5201.00.2200",
      "rawHtsCode": "5201.00.22.00",
      "superior": null,
      "indent": "2",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5201.00.2400",
      "rawHtsCode": "5201.00.24.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 6 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5201.00.2800",
      "rawHtsCode": "5201.00.28.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "31.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "36.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5201.00.3400",
      "rawHtsCode": "5201.00.34.00",
      "superior": null,
      "indent": "3",
      "description": "Described in additional U.S. note 7 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "4.4¢/kg",
      "specialRate": "Free (A+,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5201.00.3800",
      "rawHtsCode": "5201.00.38.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "31.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "36.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5201.00.5500",
      "rawHtsCode": "5201.00.55.00",
      "superior": null,
      "indent": "2",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5201.00.6000",
      "rawHtsCode": "5201.00.60.00",
      "superior": null,
      "indent": "2",
      "description": "Described in additional U.S. note 8 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg",
      "specialRate": "Free (BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5201.00.8000",
      "rawHtsCode": "5201.00.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "31.4¢/kg",
      "specialRate": "Free (AU,BH,CL,CO,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "36.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5202",
      "rawHtsCode": "5202",
      "superior": null,
      "indent": "0",
      "description": "Cotton waste (including yarn waste and garnetted stock):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.52.00 through 9903.52.26 and 9904.52.35 through 9904.52.50."
      ],
      "flags": []
    },
    {
      "htsCode": "5202.10.0000",
      "rawHtsCode": "5202.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Yarn waste (including thread waste)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5202.91.0000",
      "rawHtsCode": "5202.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Garnetted stock",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5202.99",
      "rawHtsCode": "5202.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5202.99.0500",
      "rawHtsCode": "5202.99.05.00",
      "superior": null,
      "indent": "4",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5202.99.1000",
      "rawHtsCode": "5202.99.10.00",
      "superior": null,
      "indent": "4",
      "description": "Described in additional U.S. note 9 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5202.99.3000",
      "rawHtsCode": "5202.99.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "7.8¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5202.99.5000",
      "rawHtsCode": "5202.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5203.00",
      "rawHtsCode": "5203.00",
      "superior": null,
      "indent": "0",
      "description": "Cotton, carded or combed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.52.00 through 9903.52.26 and 9904.52.35 through 9904.52.50."
      ],
      "flags": []
    },
    {
      "htsCode": "5203.00.0500",
      "rawHtsCode": "5203.00.05.00",
      "superior": null,
      "indent": "2",
      "description": "Described in general note 15 of the tariff schedule and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5203.00.1000",
      "rawHtsCode": "5203.00.10.00",
      "superior": null,
      "indent": "2",
      "description": "Described in additional U.S. note 10 to this chapter and entered pursuant to its provisions",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5203.00.3000",
      "rawHtsCode": "5203.00.30.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "31.4¢/kg",
      "specialRate": "Free (A+,AU,BH,CL,CO,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "36.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5203.00.5000",
      "rawHtsCode": "5203.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5204",
      "rawHtsCode": "5204",
      "superior": null,
      "indent": "0",
      "description": "Cotton sewing thread, whether or not put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5204.11.0000",
      "rawHtsCode": "5204.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 85 percent or more by weight of cotton (200)",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5204.19.0000",
      "rawHtsCode": "5204.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other (200)",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5204.20.0000",
      "rawHtsCode": "5204.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Put up for retail sale (200)",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205",
      "rawHtsCode": "5205",
      "superior": null,
      "indent": "0",
      "description": "Cotton yarn (other than sewing thread), containing 85 percent or more by weight of cotton, not put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.11",
      "rawHtsCode": "5205.11",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 14 nm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.11.1000",
      "rawHtsCode": "5205.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Unbleached, not mercerized (300)",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "6.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.11.2000",
      "rawHtsCode": "5205.11.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (300)",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "11.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.12",
      "rawHtsCode": "5205.12",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 14 nm but not exceeding 43 nm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.12.1000",
      "rawHtsCode": "5205.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "Unbleached, not mercerized (300)",
      "units": [
        "kg"
      ],
      "generalRate": "5.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "10.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.12.2000",
      "rawHtsCode": "5205.12.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (300)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "15.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.13",
      "rawHtsCode": "5205.13",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 43 nm but not exceeding 52 nm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.13.1000",
      "rawHtsCode": "5205.13.10.00",
      "superior": null,
      "indent": "3",
      "description": "Unbleached, not mercerized (300)",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "13.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.13.2000",
      "rawHtsCode": "5205.13.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (300)",
      "units": [
        "kg"
      ],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "18.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.14",
      "rawHtsCode": "5205.14",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 52 nm but not exceeding 80 nm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.14.1000",
      "rawHtsCode": "5205.14.10.00",
      "superior": null,
      "indent": "3",
      "description": "Unbleached, not mercerized (300)",
      "units": [
        "kg"
      ],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "17.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.14.2000",
      "rawHtsCode": "5205.14.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (300)",
      "units": [
        "kg"
      ],
      "generalRate": "8.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "22.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.15",
      "rawHtsCode": "5205.15",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 80 nm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.15.1000",
      "rawHtsCode": "5205.15.10.00",
      "superior": null,
      "indent": "3",
      "description": "Unbleached, not mercerized (300)",
      "units": [
        "kg"
      ],
      "generalRate": "9.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "29.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.15.2000",
      "rawHtsCode": "5205.15.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (300)",
      "units": [
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "34.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.21.00",
      "rawHtsCode": "5205.21.00",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 14 nm",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.21.0020",
      "rawHtsCode": "5205.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Ring spun (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.21.0090",
      "rawHtsCode": "5205.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.22.00",
      "rawHtsCode": "5205.22.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 14 nm but not exceeding 43 nm",
      "units": [],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.22.0020",
      "rawHtsCode": "5205.22.00.20",
      "superior": null,
      "indent": "3",
      "description": "Ring spun (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.22.0090",
      "rawHtsCode": "5205.22.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.23.00",
      "rawHtsCode": "5205.23.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 43 nm but not exceeding 52 nm",
      "units": [],
      "generalRate": "8.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.23.0020",
      "rawHtsCode": "5205.23.00.20",
      "superior": null,
      "indent": "3",
      "description": "Ring spun (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.23.0090",
      "rawHtsCode": "5205.23.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.24.00",
      "rawHtsCode": "5205.24.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 52 nm but not exceeding 80 nm",
      "units": [],
      "generalRate": "9.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.24.0020",
      "rawHtsCode": "5205.24.00.20",
      "superior": null,
      "indent": "3",
      "description": "Ring spun (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.24.0090",
      "rawHtsCode": "5205.24.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.26.00",
      "rawHtsCode": "5205.26.00",
      "superior": null,
      "indent": "2",
      "description": "Measuring less than 125 decitex but not less than 106.38 decitex (exceeding 80 metric number but not exceeding 94 metric number)",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "34.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.26.0020",
      "rawHtsCode": "5205.26.00.20",
      "superior": null,
      "indent": "3",
      "description": "Ring spun (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.26.0090",
      "rawHtsCode": "5205.26.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.27.00",
      "rawHtsCode": "5205.27.00",
      "superior": null,
      "indent": "2",
      "description": "Measuring less than 106.38 decitex but not less than 83.33 decitex (exceeding 94 metric number but not exceeding 120 metric number)",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "34.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.27.0020",
      "rawHtsCode": "5205.27.00.20",
      "superior": null,
      "indent": "3",
      "description": "Ring spun (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.27.0090",
      "rawHtsCode": "5205.27.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.28.00",
      "rawHtsCode": "5205.28.00",
      "superior": null,
      "indent": "2",
      "description": "Measuring less than 83.33 decitex (exceeding 120 metric number)",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "34.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.28.0020",
      "rawHtsCode": "5205.28.00.20",
      "superior": null,
      "indent": "3",
      "description": "Ring spun (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.28.0090",
      "rawHtsCode": "5205.28.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.31.0000",
      "rawHtsCode": "5205.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 14 nm per single yarn (300)",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "11.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.32.0000",
      "rawHtsCode": "5205.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 14 nm but not exceeding 43 nm per single yarn (300)",
      "units": [
        "kg"
      ],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "15.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.33.0000",
      "rawHtsCode": "5205.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 43 nm but not exceeding 52 nm per single yarn (300)",
      "units": [
        "kg"
      ],
      "generalRate": "8.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "18.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.34.0000",
      "rawHtsCode": "5205.34.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 52 nm but not exceeding 80 nm per single yarn (300)",
      "units": [
        "kg"
      ],
      "generalRate": "9.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "22.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.35.0000",
      "rawHtsCode": "5205.35.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 80 nm per single yarn (300)",
      "units": [
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "34.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.41.00",
      "rawHtsCode": "5205.41.00",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 14 nm per single yarn",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.41.0020",
      "rawHtsCode": "5205.41.00.20",
      "superior": null,
      "indent": "3",
      "description": "Ring spun (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.41.0090",
      "rawHtsCode": "5205.41.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.42.00",
      "rawHtsCode": "5205.42.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 14 nm but not exceeding 43 nm per single yarn",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.42.0021",
      "rawHtsCode": "5205.42.00.21",
      "superior": null,
      "indent": "4",
      "description": "Compact, exceeding 41 nm (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.42.0029",
      "rawHtsCode": "5205.42.00.29",
      "superior": null,
      "indent": "4",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.42.0090",
      "rawHtsCode": "5205.42.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.43.00",
      "rawHtsCode": "5205.43.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 43 nm but not exceeding 52 nm per single yarn",
      "units": [],
      "generalRate": "8.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.43.0021",
      "rawHtsCode": "5205.43.00.21",
      "superior": null,
      "indent": "4",
      "description": "Compact (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.43.0029",
      "rawHtsCode": "5205.43.00.29",
      "superior": null,
      "indent": "4",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.43.0090",
      "rawHtsCode": "5205.43.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.44.00",
      "rawHtsCode": "5205.44.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 52 nm but not exceeding <il>80 nm</il> per single yarn",
      "units": [],
      "generalRate": "9.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.44.0021",
      "rawHtsCode": "5205.44.00.21",
      "superior": null,
      "indent": "4",
      "description": "Compact (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.44.0029",
      "rawHtsCode": "5205.44.00.29",
      "superior": null,
      "indent": "4",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.44.0090",
      "rawHtsCode": "5205.44.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.46.00",
      "rawHtsCode": "5205.46.00",
      "superior": null,
      "indent": "2",
      "description": "Measuring per single yarn less than 125 decitex but not less than 106.38 decitex (exceeding 80 metric number but not exceeding 94 metric number)",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "34.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.46.0021",
      "rawHtsCode": "5205.46.00.21",
      "superior": null,
      "indent": "4",
      "description": "Compact (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.46.0029",
      "rawHtsCode": "5205.46.00.29",
      "superior": null,
      "indent": "4",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.46.0090",
      "rawHtsCode": "5205.46.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.47.00",
      "rawHtsCode": "5205.47.00",
      "superior": null,
      "indent": "2",
      "description": "Measuring per single yarn less than 106.38 decitex but not less than 83.33 decitex (exceeding 94 metric number but not exceeding 120 metric number)",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "34.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.47.0021",
      "rawHtsCode": "5205.47.00.21",
      "superior": null,
      "indent": "4",
      "description": "Compact, not exceeding 102 nm (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.47.0029",
      "rawHtsCode": "5205.47.00.29",
      "superior": null,
      "indent": "4",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.47.0090",
      "rawHtsCode": "5205.47.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.48.00",
      "rawHtsCode": "5205.48.00",
      "superior": null,
      "indent": "2",
      "description": "Measuring per single yarn less than 83.33 decitex (exceeding 120 metric number)",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "34.1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5205.48.0020",
      "rawHtsCode": "5205.48.00.20",
      "superior": null,
      "indent": "3",
      "description": "Ring spun (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5205.48.0090",
      "rawHtsCode": "5205.48.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (301)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5206",
      "rawHtsCode": "5206",
      "superior": null,
      "indent": "0",
      "description": "Cotton yarn (other than sewing thread), containing less than 85 percent by weight of cotton, not put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5206.11.0000",
      "rawHtsCode": "5206.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 14 nm (300)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.12.0000",
      "rawHtsCode": "5206.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 14 nm but not exceeding 43 nm (300)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.13.0000",
      "rawHtsCode": "5206.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 43 nm but not exceeding 52 nm (300)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.14.0000",
      "rawHtsCode": "5206.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 52 nm but not exceeding 80 nm (300)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.15.0000",
      "rawHtsCode": "5206.15.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 80 nm (300)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.21.0000",
      "rawHtsCode": "5206.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 14 nm (301)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.22.0000",
      "rawHtsCode": "5206.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 14 nm but not exceeding 43 nm (301)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.23.0000",
      "rawHtsCode": "5206.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 43 nm but not exceeding 52 nm (301)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.24.0000",
      "rawHtsCode": "5206.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 52 nm but not exceeding 80 nm (301)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.25.0000",
      "rawHtsCode": "5206.25.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 80 nm (301)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.31.0000",
      "rawHtsCode": "5206.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 14 nm per single yarn (300)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.32.0000",
      "rawHtsCode": "5206.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 14 nm but not exceeding 43 nm per single yarn (300)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.33.0000",
      "rawHtsCode": "5206.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 43 nm but not exceeding 52 nm per single yarn (300)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.34.0000",
      "rawHtsCode": "5206.34.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 52 nm but not exceeding 80 nm per single yarn (300)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.35.0000",
      "rawHtsCode": "5206.35.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 80 nm per single yarn (300)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.41.0000",
      "rawHtsCode": "5206.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 14 nm per single yarn (301)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.42.0000",
      "rawHtsCode": "5206.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 14 nm but not exceeding 43 nm per single yarn (301)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.43.0000",
      "rawHtsCode": "5206.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 43 nm but not exceeding 52 nm per single yarn (301)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.44.0000",
      "rawHtsCode": "5206.44.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 52 nm but not exceeding 80 nm per single yarn (301)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5206.45.0000",
      "rawHtsCode": "5206.45.00.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 80 nm per single yarn (301)",
      "units": [
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5207",
      "rawHtsCode": "5207",
      "superior": null,
      "indent": "0",
      "description": "Cotton yarn (other than sewing thread) put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5207.10.0000",
      "rawHtsCode": "5207.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Containing 85 percent or more by weight of cotton (200)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5207.90.0000",
      "rawHtsCode": "5207.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other (200)",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208",
      "rawHtsCode": "5208",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of cotton, containing 85 percent or more by weight of cotton, weighing not more than 200 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.11",
      "rawHtsCode": "5208.11",
      "superior": null,
      "indent": "2",
      "description": "Plain weave, weighing not more than 100 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.11.20",
      "rawHtsCode": "5208.11.20",
      "superior": null,
      "indent": "3",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "16.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.11.2020",
      "rawHtsCode": "5208.11.20.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.11.2040",
      "rawHtsCode": "5208.11.20.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.11.2090",
      "rawHtsCode": "5208.11.20.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.11.40",
      "rawHtsCode": "5208.11.40",
      "superior": null,
      "indent": "3",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "21.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.11.4020",
      "rawHtsCode": "5208.11.40.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.11.4040",
      "rawHtsCode": "5208.11.40.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.11.4060",
      "rawHtsCode": "5208.11.40.60",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.11.4090",
      "rawHtsCode": "5208.11.40.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.11.6000",
      "rawHtsCode": "5208.11.60.00",
      "superior": null,
      "indent": "4",
      "description": "Suitable for making typewriter ribbon, containing yarns the average number of which exceeds 85 but not 237, the total thread count (treating multiple (folded) or cabled yarns as single threads) per square centimeter is not less than 94 and not more than 134, and in which the thread count of either the warp or filling does not exceed 60 percent of the total thread count of the warp and filling (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "22¢/kg + 41.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5208.11.80",
      "rawHtsCode": "5208.11.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "10.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "32.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.11.8020",
      "rawHtsCode": "5208.11.80.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.11.8090",
      "rawHtsCode": "5208.11.80.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.12",
      "rawHtsCode": "5208.12",
      "superior": null,
      "indent": "2",
      "description": "Plain weave, weighing more than 100 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.12.40",
      "rawHtsCode": "5208.12.40",
      "superior": null,
      "indent": "3",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "16.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.12.4020",
      "rawHtsCode": "5208.12.40.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.12.4040",
      "rawHtsCode": "5208.12.40.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.12.4090",
      "rawHtsCode": "5208.12.40.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.12.60",
      "rawHtsCode": "5208.12.60",
      "superior": null,
      "indent": "3",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "21.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.12.6020",
      "rawHtsCode": "5208.12.60.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.12.6040",
      "rawHtsCode": "5208.12.60.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.12.6060",
      "rawHtsCode": "5208.12.60.60",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.12.6090",
      "rawHtsCode": "5208.12.60.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.12.80",
      "rawHtsCode": "5208.12.80",
      "superior": null,
      "indent": "3",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "10.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "32.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.12.8020",
      "rawHtsCode": "5208.12.80.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.12.8090",
      "rawHtsCode": "5208.12.80.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.13.0000",
      "rawHtsCode": "5208.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "7.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.19",
      "rawHtsCode": "5208.19",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.19.20",
      "rawHtsCode": "5208.19.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave",
      "units": [],
      "generalRate": "7.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "18.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.19.2020",
      "rawHtsCode": "5208.19.20.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.19.2090",
      "rawHtsCode": "5208.19.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.19.40",
      "rawHtsCode": "5208.19.40",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "16.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.19.4020",
      "rawHtsCode": "5208.19.40.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.19.4090",
      "rawHtsCode": "5208.19.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.19.60",
      "rawHtsCode": "5208.19.60",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "21.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.19.6020",
      "rawHtsCode": "5208.19.60.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.19.6090",
      "rawHtsCode": "5208.19.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.19.80",
      "rawHtsCode": "5208.19.80",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "10.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "32.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.19.8020",
      "rawHtsCode": "5208.19.80.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.19.8090",
      "rawHtsCode": "5208.19.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.21",
      "rawHtsCode": "5208.21",
      "superior": null,
      "indent": "2",
      "description": "Plain weave, weighing not more than <il>100 g/m²:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.21.20",
      "rawHtsCode": "5208.21.20",
      "superior": null,
      "indent": "3",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "19.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.21.2020",
      "rawHtsCode": "5208.21.20.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.21.2040",
      "rawHtsCode": "5208.21.20.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.21.2090",
      "rawHtsCode": "5208.21.20.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.21.40",
      "rawHtsCode": "5208.21.40",
      "superior": null,
      "indent": "3",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "10.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.21.4020",
      "rawHtsCode": "5208.21.40.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.21.4040",
      "rawHtsCode": "5208.21.40.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.21.4060",
      "rawHtsCode": "5208.21.40.60",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.21.4090",
      "rawHtsCode": "5208.21.40.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.21.60",
      "rawHtsCode": "5208.21.60",
      "superior": null,
      "indent": "3",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "11.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.21.6020",
      "rawHtsCode": "5208.21.60.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.21.6090",
      "rawHtsCode": "5208.21.60.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.22",
      "rawHtsCode": "5208.22",
      "superior": null,
      "indent": "2",
      "description": "Plain weave, weighing more than 100 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.22.40",
      "rawHtsCode": "5208.22.40",
      "superior": null,
      "indent": "3",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "19.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.22.4020",
      "rawHtsCode": "5208.22.40.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.22.4040",
      "rawHtsCode": "5208.22.40.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.22.4090",
      "rawHtsCode": "5208.22.40.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.22.60",
      "rawHtsCode": "5208.22.60",
      "superior": null,
      "indent": "3",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "8.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.22.6020",
      "rawHtsCode": "5208.22.60.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.22.6040",
      "rawHtsCode": "5208.22.60.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.22.6060",
      "rawHtsCode": "5208.22.60.60",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.22.6090",
      "rawHtsCode": "5208.22.60.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.22.80",
      "rawHtsCode": "5208.22.80",
      "superior": null,
      "indent": "3",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "11.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.22.8020",
      "rawHtsCode": "5208.22.80.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.22.8090",
      "rawHtsCode": "5208.22.80.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.23.0000",
      "rawHtsCode": "5208.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "9.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "21.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.29",
      "rawHtsCode": "5208.29",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.29.20",
      "rawHtsCode": "5208.29.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave",
      "units": [],
      "generalRate": "7.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "21.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.29.2020",
      "rawHtsCode": "5208.29.20.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.29.2090",
      "rawHtsCode": "5208.29.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.29.40",
      "rawHtsCode": "5208.29.40",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "19.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.29.4020",
      "rawHtsCode": "5208.29.40.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.29.4090",
      "rawHtsCode": "5208.29.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.29.60",
      "rawHtsCode": "5208.29.60",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "10.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "24.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.29.6020",
      "rawHtsCode": "5208.29.60.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.29.6090",
      "rawHtsCode": "5208.29.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.29.80",
      "rawHtsCode": "5208.29.80",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "13.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.29.8020",
      "rawHtsCode": "5208.29.80.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.29.8090",
      "rawHtsCode": "5208.29.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.31",
      "rawHtsCode": "5208.31",
      "superior": null,
      "indent": "2",
      "description": "Plain weave, weighing not more than 100 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.31.2000",
      "rawHtsCode": "5208.31.20.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed fabrics",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.31.40",
      "rawHtsCode": "5208.31.40",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.31.4020",
      "rawHtsCode": "5208.31.40.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.31.4040",
      "rawHtsCode": "5208.31.40.40",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.31.4090",
      "rawHtsCode": "5208.31.40.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.31.60",
      "rawHtsCode": "5208.31.60",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "9.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.31.6020",
      "rawHtsCode": "5208.31.60.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.31.6040",
      "rawHtsCode": "5208.31.60.40",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.31.6060",
      "rawHtsCode": "5208.31.60.60",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.31.6090",
      "rawHtsCode": "5208.31.60.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.31.80",
      "rawHtsCode": "5208.31.80",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.31.8020",
      "rawHtsCode": "5208.31.80.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.31.8090",
      "rawHtsCode": "5208.31.80.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.32",
      "rawHtsCode": "5208.32",
      "superior": null,
      "indent": "2",
      "description": "Plain weave, weighing more than 100 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.32.1000",
      "rawHtsCode": "5208.32.10.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed fabrics",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.32.30",
      "rawHtsCode": "5208.32.30",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.32.3020",
      "rawHtsCode": "5208.32.30.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.32.3040",
      "rawHtsCode": "5208.32.30.40",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.32.3090",
      "rawHtsCode": "5208.32.30.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.32.40",
      "rawHtsCode": "5208.32.40",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "9.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.32.4020",
      "rawHtsCode": "5208.32.40.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.32.4040",
      "rawHtsCode": "5208.32.40.40",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.32.4060",
      "rawHtsCode": "5208.32.40.60",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.32.4090",
      "rawHtsCode": "5208.32.40.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.32.50",
      "rawHtsCode": "5208.32.50",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.32.5020",
      "rawHtsCode": "5208.32.50.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.32.5090",
      "rawHtsCode": "5208.32.50.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.33.0000",
      "rawHtsCode": "5208.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "10.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.39",
      "rawHtsCode": "5208.39",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.39.20",
      "rawHtsCode": "5208.39.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave",
      "units": [],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.39.2020",
      "rawHtsCode": "5208.39.20.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.39.2090",
      "rawHtsCode": "5208.39.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.39.40",
      "rawHtsCode": "5208.39.40",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "22.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.39.4020",
      "rawHtsCode": "5208.39.40.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.39.4090",
      "rawHtsCode": "5208.39.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.39.60",
      "rawHtsCode": "5208.39.60",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "9.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "27.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.39.6020",
      "rawHtsCode": "5208.39.60.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.39.6090",
      "rawHtsCode": "5208.39.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.39.80",
      "rawHtsCode": "5208.39.80",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.39.8020",
      "rawHtsCode": "5208.39.80.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.39.8090",
      "rawHtsCode": "5208.39.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.41",
      "rawHtsCode": "5208.41",
      "superior": null,
      "indent": "2",
      "description": "Plain weave, weighing not more than 100 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.41.2000",
      "rawHtsCode": "5208.41.20.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed fabrics",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.41.4000",
      "rawHtsCode": "5208.41.40.00",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "22.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.41.6000",
      "rawHtsCode": "5208.41.60.00",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68 (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "27.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.41.8000",
      "rawHtsCode": "5208.41.80.00",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.42",
      "rawHtsCode": "5208.42",
      "superior": null,
      "indent": "2",
      "description": "Plain weave, weighing more than 100 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.42.1000",
      "rawHtsCode": "5208.42.10.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed fabrics",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.42.3000",
      "rawHtsCode": "5208.42.30.00",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "22.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.42.4000",
      "rawHtsCode": "5208.42.40.00",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68 (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "27.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.42.5000",
      "rawHtsCode": "5208.42.50.00",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.43.0000",
      "rawHtsCode": "5208.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "24.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5208.49",
      "rawHtsCode": "5208.49",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.49.2000",
      "rawHtsCode": "5208.49.20.00",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "24.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5208.49.40",
      "rawHtsCode": "5208.49.40",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "22.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.49.4010",
      "rawHtsCode": "5208.49.40.10",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.49.4020",
      "rawHtsCode": "5208.49.40.20",
      "superior": null,
      "indent": "5",
      "description": "Jacquard woven (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.49.4090",
      "rawHtsCode": "5208.49.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.49.60",
      "rawHtsCode": "5208.49.60",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "9.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "27.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.49.6010",
      "rawHtsCode": "5208.49.60.10",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.49.6020",
      "rawHtsCode": "5208.49.60.20",
      "superior": null,
      "indent": "6",
      "description": "Of a width exceeding 127 cm (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.49.6030",
      "rawHtsCode": "5208.49.60.30",
      "superior": null,
      "indent": "6",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.49.6090",
      "rawHtsCode": "5208.49.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.49.80",
      "rawHtsCode": "5208.49.80",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "14.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.49.8020",
      "rawHtsCode": "5208.49.80.20",
      "superior": null,
      "indent": "5",
      "description": "Jacquard woven (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.49.8090",
      "rawHtsCode": "5208.49.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.51",
      "rawHtsCode": "5208.51",
      "superior": null,
      "indent": "2",
      "description": "Plain weave, weighing not more than 100 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.51.2000",
      "rawHtsCode": "5208.51.20.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed fabrics",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.51.40",
      "rawHtsCode": "5208.51.40",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.51.4020",
      "rawHtsCode": "5208.51.40.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.51.4040",
      "rawHtsCode": "5208.51.40.40",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.51.4090",
      "rawHtsCode": "5208.51.40.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.51.60",
      "rawHtsCode": "5208.51.60",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.51.6020",
      "rawHtsCode": "5208.51.60.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.51.6040",
      "rawHtsCode": "5208.51.60.40",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.51.6060",
      "rawHtsCode": "5208.51.60.60",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.51.6090",
      "rawHtsCode": "5208.51.60.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.51.80",
      "rawHtsCode": "5208.51.80",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.51.8020",
      "rawHtsCode": "5208.51.80.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.51.8090",
      "rawHtsCode": "5208.51.80.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52",
      "rawHtsCode": "5208.52",
      "superior": null,
      "indent": "2",
      "description": "Plain weave, weighing more than 100 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52.1000",
      "rawHtsCode": "5208.52.10.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed fabrics",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.52.30",
      "rawHtsCode": "5208.52.30",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.52.3020",
      "rawHtsCode": "5208.52.30.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52.3035",
      "rawHtsCode": "5208.52.30.35",
      "superior": null,
      "indent": "6",
      "description": "Discharge printed (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52.3045",
      "rawHtsCode": "5208.52.30.45",
      "superior": null,
      "indent": "6",
      "description": "Other (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52.3090",
      "rawHtsCode": "5208.52.30.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52.40",
      "rawHtsCode": "5208.52.40",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.52.4020",
      "rawHtsCode": "5208.52.40.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52.4035",
      "rawHtsCode": "5208.52.40.35",
      "superior": null,
      "indent": "6",
      "description": "Discharge printed (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52.4045",
      "rawHtsCode": "5208.52.40.45",
      "superior": null,
      "indent": "6",
      "description": "Other (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52.4055",
      "rawHtsCode": "5208.52.40.55",
      "superior": null,
      "indent": "6",
      "description": "Discharge printed (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52.4065",
      "rawHtsCode": "5208.52.40.65",
      "superior": null,
      "indent": "6",
      "description": "Other (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52.4090",
      "rawHtsCode": "5208.52.40.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52.50",
      "rawHtsCode": "5208.52.50",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.52.5020",
      "rawHtsCode": "5208.52.50.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.52.5090",
      "rawHtsCode": "5208.52.50.90",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth; lawns,voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.59",
      "rawHtsCode": "5208.59",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.59.1000",
      "rawHtsCode": "5208.59.10.00",
      "superior": null,
      "indent": "3",
      "description": "3-thread or 4-thread twill, including cross twill (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.59.20",
      "rawHtsCode": "5208.59.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave, other than 3-thread or 4-thread twill or cross twill",
      "units": [],
      "generalRate": "10.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.59.2015",
      "rawHtsCode": "5208.59.20.15",
      "superior": null,
      "indent": "5",
      "description": "Discharge printed (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.59.2025",
      "rawHtsCode": "5208.59.20.25",
      "superior": null,
      "indent": "5",
      "description": "Other (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.59.2085",
      "rawHtsCode": "5208.59.20.85",
      "superior": null,
      "indent": "5",
      "description": "Discharge printed (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.59.2095",
      "rawHtsCode": "5208.59.20.95",
      "superior": null,
      "indent": "5",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.59.40",
      "rawHtsCode": "5208.59.40",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.59.4020",
      "rawHtsCode": "5208.59.40.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.59.4090",
      "rawHtsCode": "5208.59.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.59.60",
      "rawHtsCode": "5208.59.60",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "9.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.59.6020",
      "rawHtsCode": "5208.59.60.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.59.6090",
      "rawHtsCode": "5208.59.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.59.80",
      "rawHtsCode": "5208.59.80",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5208.59.8020",
      "rawHtsCode": "5208.59.80.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5208.59.8090",
      "rawHtsCode": "5208.59.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209",
      "rawHtsCode": "5209",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of cotton, containing 85 percent or more by weight of cotton, weighing more than 200 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.11.00",
      "rawHtsCode": "5209.11.00",
      "superior": null,
      "indent": "2",
      "description": "Plain weave",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "14.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.11.0020",
      "rawHtsCode": "5209.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.11.0025",
      "rawHtsCode": "5209.11.00.25",
      "superior": null,
      "indent": "5",
      "description": "Osnaburg (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.11.0035",
      "rawHtsCode": "5209.11.00.35",
      "superior": null,
      "indent": "5",
      "description": "Other (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.11.0050",
      "rawHtsCode": "5209.11.00.50",
      "superior": null,
      "indent": "4",
      "description": "Napped (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.11.0090",
      "rawHtsCode": "5209.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Plain weave duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.12.00",
      "rawHtsCode": "5209.12.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "14.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.12.0020",
      "rawHtsCode": "5209.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.12.0040",
      "rawHtsCode": "5209.12.00.40",
      "superior": null,
      "indent": "3",
      "description": "Napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.19.00",
      "rawHtsCode": "5209.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "14.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.19.0020",
      "rawHtsCode": "5209.19.00.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.19.0040",
      "rawHtsCode": "5209.19.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.19.0060",
      "rawHtsCode": "5209.19.00.60",
      "superior": null,
      "indent": "3",
      "description": "Duck, except plain weave (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.19.0090",
      "rawHtsCode": "5209.19.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.21.00",
      "rawHtsCode": "5209.21.00",
      "superior": null,
      "indent": "2",
      "description": "Plain weave",
      "units": [],
      "generalRate": "7.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.21.0020",
      "rawHtsCode": "5209.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.21.0025",
      "rawHtsCode": "5209.21.00.25",
      "superior": null,
      "indent": "5",
      "description": "Osnaburg (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.21.0035",
      "rawHtsCode": "5209.21.00.35",
      "superior": null,
      "indent": "5",
      "description": "Other (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.21.0050",
      "rawHtsCode": "5209.21.00.50",
      "superior": null,
      "indent": "4",
      "description": "Napped (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.21.0090",
      "rawHtsCode": "5209.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Plain weave duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.22.00",
      "rawHtsCode": "5209.22.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill",
      "units": [],
      "generalRate": "7.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.22.0020",
      "rawHtsCode": "5209.22.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.22.0040",
      "rawHtsCode": "5209.22.00.40",
      "superior": null,
      "indent": "3",
      "description": "Napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.29.00",
      "rawHtsCode": "5209.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics",
      "units": [],
      "generalRate": "7.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.29.0020",
      "rawHtsCode": "5209.29.00.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.29.0040",
      "rawHtsCode": "5209.29.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.29.0060",
      "rawHtsCode": "5209.29.00.60",
      "superior": null,
      "indent": "3",
      "description": "Duck, except plain weave (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.29.0090",
      "rawHtsCode": "5209.29.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.31",
      "rawHtsCode": "5209.31",
      "superior": null,
      "indent": "2",
      "description": "Plain weave:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.31.3000",
      "rawHtsCode": "5209.31.30.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed fabrics",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.31.60",
      "rawHtsCode": "5209.31.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.31.6020",
      "rawHtsCode": "5209.31.60.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.31.6025",
      "rawHtsCode": "5209.31.60.25",
      "superior": null,
      "indent": "6",
      "description": "Osnaburg (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.31.6035",
      "rawHtsCode": "5209.31.60.35",
      "superior": null,
      "indent": "6",
      "description": "Other (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.31.6050",
      "rawHtsCode": "5209.31.60.50",
      "superior": null,
      "indent": "5",
      "description": "Napped (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.31.6090",
      "rawHtsCode": "5209.31.60.90",
      "superior": null,
      "indent": "4",
      "description": "Plain weave duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.32.00",
      "rawHtsCode": "5209.32.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.32.0020",
      "rawHtsCode": "5209.32.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.32.0040",
      "rawHtsCode": "5209.32.00.40",
      "superior": null,
      "indent": "3",
      "description": "Napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.39.00",
      "rawHtsCode": "5209.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.39.0020",
      "rawHtsCode": "5209.39.00.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.39.0040",
      "rawHtsCode": "5209.39.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.39.0060",
      "rawHtsCode": "5209.39.00.60",
      "superior": null,
      "indent": "3",
      "description": "Duck, except plain weave (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.39.0080",
      "rawHtsCode": "5209.39.00.80",
      "superior": null,
      "indent": "4",
      "description": "Of a width exceeding 127 cm (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.39.0090",
      "rawHtsCode": "5209.39.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.41",
      "rawHtsCode": "5209.41",
      "superior": null,
      "indent": "2",
      "description": "Plain weave:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.41.3000",
      "rawHtsCode": "5209.41.30.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed fabrics",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.41.60",
      "rawHtsCode": "5209.41.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.41.6020",
      "rawHtsCode": "5209.41.60.20",
      "superior": null,
      "indent": "4",
      "description": "Not napped (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.41.6040",
      "rawHtsCode": "5209.41.60.40",
      "superior": null,
      "indent": "4",
      "description": "Napped (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.42.00",
      "rawHtsCode": "5209.42.00",
      "superior": null,
      "indent": "2",
      "description": "Denim",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.42.0020",
      "rawHtsCode": "5209.42.00.20",
      "superior": null,
      "indent": "4",
      "description": "Weighing not more than 360 g/m² (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.42.0040",
      "rawHtsCode": "5209.42.00.40",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 360 g/m²(225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.42.0060",
      "rawHtsCode": "5209.42.00.60",
      "superior": null,
      "indent": "4",
      "description": "Weighing not more than 360 g/m² (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.42.0080",
      "rawHtsCode": "5209.42.00.80",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 360 g/m² (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.43.00",
      "rawHtsCode": "5209.43.00",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics of 3-thread or 4-thread twill, including cross twill",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.43.0030",
      "rawHtsCode": "5209.43.00.30",
      "superior": null,
      "indent": "3",
      "description": "Not napped (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.43.0050",
      "rawHtsCode": "5209.43.00.50",
      "superior": null,
      "indent": "3",
      "description": "Napped (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.49.00",
      "rawHtsCode": "5209.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.49.0020",
      "rawHtsCode": "5209.49.00.20",
      "superior": null,
      "indent": "4",
      "description": "Of a width exceeding 127 cm (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.49.0040",
      "rawHtsCode": "5209.49.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.49.0090",
      "rawHtsCode": "5209.49.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.51",
      "rawHtsCode": "5209.51",
      "superior": null,
      "indent": "2",
      "description": "Plain weave:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.51.3000",
      "rawHtsCode": "5209.51.30.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed fabrics",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.51.60",
      "rawHtsCode": "5209.51.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.51.6015",
      "rawHtsCode": "5209.51.60.15",
      "superior": null,
      "indent": "5",
      "description": "Discharge printed (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.51.6025",
      "rawHtsCode": "5209.51.60.25",
      "superior": null,
      "indent": "5",
      "description": "Other (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.51.6032",
      "rawHtsCode": "5209.51.60.32",
      "superior": null,
      "indent": "6",
      "description": "Discharge printed (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.51.6035",
      "rawHtsCode": "5209.51.60.35",
      "superior": null,
      "indent": "6",
      "description": "Other (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.51.6050",
      "rawHtsCode": "5209.51.60.50",
      "superior": null,
      "indent": "5",
      "description": "Napped (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.51.6090",
      "rawHtsCode": "5209.51.60.90",
      "superior": null,
      "indent": "4",
      "description": "Plain weave duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.52.00",
      "rawHtsCode": "5209.52.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.52.0020",
      "rawHtsCode": "5209.52.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.52.0040",
      "rawHtsCode": "5209.52.00.40",
      "superior": null,
      "indent": "3",
      "description": "Napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.59.00",
      "rawHtsCode": "5209.59.00",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5209.59.0015",
      "rawHtsCode": "5209.59.00.15",
      "superior": null,
      "indent": "5",
      "description": "Discharge printed (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.59.0025",
      "rawHtsCode": "5209.59.00.25",
      "superior": null,
      "indent": "5",
      "description": "Other (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.59.0040",
      "rawHtsCode": "5209.59.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.59.0060",
      "rawHtsCode": "5209.59.00.60",
      "superior": null,
      "indent": "3",
      "description": "Duck, except plain weave (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5209.59.0090",
      "rawHtsCode": "5209.59.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210",
      "rawHtsCode": "5210",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of cotton, containing less than 85 percent by weight of cotton, mixed mainly or solely with man-made fibers, weighing not more than 200 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.11",
      "rawHtsCode": "5210.11",
      "superior": null,
      "indent": "2",
      "description": "Plain weave:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.11.40",
      "rawHtsCode": "5210.11.40",
      "superior": null,
      "indent": "3",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "21.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.11.4020",
      "rawHtsCode": "5210.11.40.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.11.4040",
      "rawHtsCode": "5210.11.40.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.11.4090",
      "rawHtsCode": "5210.11.40.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.11.60",
      "rawHtsCode": "5210.11.60",
      "superior": null,
      "indent": "3",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "10.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "26.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.11.6020",
      "rawHtsCode": "5210.11.60.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.11.6040",
      "rawHtsCode": "5210.11.60.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.11.6060",
      "rawHtsCode": "5210.11.60.60",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.11.6090",
      "rawHtsCode": "5210.11.60.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.11.80",
      "rawHtsCode": "5210.11.80",
      "superior": null,
      "indent": "3",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "13.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.11.8020",
      "rawHtsCode": "5210.11.80.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.11.8090",
      "rawHtsCode": "5210.11.80.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.19",
      "rawHtsCode": "5210.19",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.19.1000",
      "rawHtsCode": "5210.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "3-thread or 4-thread twill, including cross twill (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "9.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "23.7%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.19.20",
      "rawHtsCode": "5210.19.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave, other than 3-thread or 4-thread twill or cross twill",
      "units": [],
      "generalRate": "9.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "23.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.19.2020",
      "rawHtsCode": "5210.19.20.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.19.2090",
      "rawHtsCode": "5210.19.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.19.40",
      "rawHtsCode": "5210.19.40",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "21.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.19.4020",
      "rawHtsCode": "5210.19.40.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.19.4090",
      "rawHtsCode": "5210.19.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.19.60",
      "rawHtsCode": "5210.19.60",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "8.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "26.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.19.6020",
      "rawHtsCode": "5210.19.60.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.19.6090",
      "rawHtsCode": "5210.19.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.19.80",
      "rawHtsCode": "5210.19.80",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "10.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.19.8020",
      "rawHtsCode": "5210.19.80.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.19.8090",
      "rawHtsCode": "5210.19.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.21",
      "rawHtsCode": "5210.21",
      "superior": null,
      "indent": "2",
      "description": "Plain weave:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.21.40",
      "rawHtsCode": "5210.21.40",
      "superior": null,
      "indent": "3",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.21.4020",
      "rawHtsCode": "5210.21.40.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.21.4040",
      "rawHtsCode": "5210.21.40.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.21.4090",
      "rawHtsCode": "5210.21.40.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.21.60",
      "rawHtsCode": "5210.21.60",
      "superior": null,
      "indent": "3",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "29.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.21.6020",
      "rawHtsCode": "5210.21.60.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.21.6040",
      "rawHtsCode": "5210.21.60.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.21.6060",
      "rawHtsCode": "5210.21.60.60",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.21.6090",
      "rawHtsCode": "5210.21.60.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.21.80",
      "rawHtsCode": "5210.21.80",
      "superior": null,
      "indent": "3",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.21.8020",
      "rawHtsCode": "5210.21.80.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.21.8090",
      "rawHtsCode": "5210.21.80.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.29",
      "rawHtsCode": "5210.29",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.29.1000",
      "rawHtsCode": "5210.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "3-thread or 4-thread twill, including cross twill (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "10.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "26.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.29.20",
      "rawHtsCode": "5210.29.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave, other than 3-thread or 4-thread twill or cross twill",
      "units": [],
      "generalRate": "10.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "26.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.29.2020",
      "rawHtsCode": "5210.29.20.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.29.2090",
      "rawHtsCode": "5210.29.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.29.40",
      "rawHtsCode": "5210.29.40",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "24.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.29.4020",
      "rawHtsCode": "5210.29.40.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.29.4090",
      "rawHtsCode": "5210.29.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.29.60",
      "rawHtsCode": "5210.29.60",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "29.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.29.6020",
      "rawHtsCode": "5210.29.60.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.29.6090",
      "rawHtsCode": "5210.29.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.29.80",
      "rawHtsCode": "5210.29.80",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "14.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.29.8020",
      "rawHtsCode": "5210.29.80.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.29.8090",
      "rawHtsCode": "5210.29.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.31",
      "rawHtsCode": "5210.31",
      "superior": null,
      "indent": "2",
      "description": "Plain weave:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.31.40",
      "rawHtsCode": "5210.31.40",
      "superior": null,
      "indent": "3",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.31.4020",
      "rawHtsCode": "5210.31.40.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.31.4040",
      "rawHtsCode": "5210.31.40.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.31.4090",
      "rawHtsCode": "5210.31.40.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.31.60",
      "rawHtsCode": "5210.31.60",
      "superior": null,
      "indent": "3",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "12.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "32.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.31.6020",
      "rawHtsCode": "5210.31.60.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.31.6040",
      "rawHtsCode": "5210.31.60.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.31.6060",
      "rawHtsCode": "5210.31.60.60",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.31.6090",
      "rawHtsCode": "5210.31.60.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.31.80",
      "rawHtsCode": "5210.31.80",
      "superior": null,
      "indent": "3",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "15.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.31.8020",
      "rawHtsCode": "5210.31.80.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.31.8090",
      "rawHtsCode": "5210.31.80.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.32.0000",
      "rawHtsCode": "5210.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "29.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.39",
      "rawHtsCode": "5210.39",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.39.20",
      "rawHtsCode": "5210.39.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "29.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.39.2020",
      "rawHtsCode": "5210.39.20.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.39.2090",
      "rawHtsCode": "5210.39.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.39.40",
      "rawHtsCode": "5210.39.40",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "27.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.39.4020",
      "rawHtsCode": "5210.39.40.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.39.4090",
      "rawHtsCode": "5210.39.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.39.60",
      "rawHtsCode": "5210.39.60",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "12.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "32.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.39.6020",
      "rawHtsCode": "5210.39.60.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.39.6090",
      "rawHtsCode": "5210.39.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.39.80",
      "rawHtsCode": "5210.39.80",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "12.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.39.8020",
      "rawHtsCode": "5210.39.80.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.39.8090",
      "rawHtsCode": "5210.39.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.41",
      "rawHtsCode": "5210.41",
      "superior": null,
      "indent": "2",
      "description": "Plain weave:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.41.4000",
      "rawHtsCode": "5210.41.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of number 42 or lower number (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "27.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.41.6000",
      "rawHtsCode": "5210.41.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of numbers 43 to 68 (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "32.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.41.8000",
      "rawHtsCode": "5210.41.80.00",
      "superior": null,
      "indent": "3",
      "description": "Of number 69 or higher number (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "15.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.49",
      "rawHtsCode": "5210.49",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.49.1000",
      "rawHtsCode": "5210.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "3-thread or 4-thread twill, including cross twill (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "29.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.49.2000",
      "rawHtsCode": "5210.49.20.00",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave, other than 3-thread or 4-thread twill or cross twill (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "29.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.49.40",
      "rawHtsCode": "5210.49.40",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "27.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.49.4010",
      "rawHtsCode": "5210.49.40.10",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.49.4020",
      "rawHtsCode": "5210.49.40.20",
      "superior": null,
      "indent": "5",
      "description": "Jacquard woven (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.49.4090",
      "rawHtsCode": "5210.49.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.49.60",
      "rawHtsCode": "5210.49.60",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "10.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "32.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.49.6010",
      "rawHtsCode": "5210.49.60.10",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.49.6020",
      "rawHtsCode": "5210.49.60.20",
      "superior": null,
      "indent": "5",
      "description": "Jacquard woven (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.49.6090",
      "rawHtsCode": "5210.49.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.49.80",
      "rawHtsCode": "5210.49.80",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "15.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.49.8020",
      "rawHtsCode": "5210.49.80.20",
      "superior": null,
      "indent": "5",
      "description": "Jacquard woven (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.49.8090",
      "rawHtsCode": "5210.49.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.51",
      "rawHtsCode": "5210.51",
      "superior": null,
      "indent": "2",
      "description": "Plain weave:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.51.40",
      "rawHtsCode": "5210.51.40",
      "superior": null,
      "indent": "3",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.51.4020",
      "rawHtsCode": "5210.51.40.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.51.4040",
      "rawHtsCode": "5210.51.40.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.51.4090",
      "rawHtsCode": "5210.51.40.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.51.60",
      "rawHtsCode": "5210.51.60",
      "superior": null,
      "indent": "3",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "12.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "32.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.51.6020",
      "rawHtsCode": "5210.51.60.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.51.6040",
      "rawHtsCode": "5210.51.60.40",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.51.6060",
      "rawHtsCode": "5210.51.60.60",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.51.6090",
      "rawHtsCode": "5210.51.60.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.51.80",
      "rawHtsCode": "5210.51.80",
      "superior": null,
      "indent": "3",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "15.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.51.8020",
      "rawHtsCode": "5210.51.80.20",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.51.8090",
      "rawHtsCode": "5210.51.80.90",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.59",
      "rawHtsCode": "5210.59",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.59.1000",
      "rawHtsCode": "5210.59.10.00",
      "superior": null,
      "indent": "3",
      "description": "3-thread or 4-thread twill, including cross twill (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "29.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.59.20",
      "rawHtsCode": "5210.59.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave, other than 3-thread or 4-thread twill or cross twill",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "29.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.59.2020",
      "rawHtsCode": "5210.59.20.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.59.2090",
      "rawHtsCode": "5210.59.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.59.40",
      "rawHtsCode": "5210.59.40",
      "superior": null,
      "indent": "4",
      "description": "Of number 42 or lower number",
      "units": [],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "27.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.59.4020",
      "rawHtsCode": "5210.59.40.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.59.4090",
      "rawHtsCode": "5210.59.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.59.60",
      "rawHtsCode": "5210.59.60",
      "superior": null,
      "indent": "4",
      "description": "Of numbers 43 to 68",
      "units": [],
      "generalRate": "10.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "32.7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.59.6020",
      "rawHtsCode": "5210.59.60.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.59.6090",
      "rawHtsCode": "5210.59.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.59.80",
      "rawHtsCode": "5210.59.80",
      "superior": null,
      "indent": "4",
      "description": "Of number 69 or higher number",
      "units": [],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "43.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5210.59.8020",
      "rawHtsCode": "5210.59.80.20",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5210.59.8090",
      "rawHtsCode": "5210.59.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211",
      "rawHtsCode": "5211",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of cotton, containing less than 85 percent by weight of cotton, mixed mainly or solely with man-made fibers, weighing more than 200 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.11.00",
      "rawHtsCode": "5211.11.00",
      "superior": null,
      "indent": "2",
      "description": "Plain weave",
      "units": [],
      "generalRate": "7.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "19.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.11.0020",
      "rawHtsCode": "5211.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.11.0025",
      "rawHtsCode": "5211.11.00.25",
      "superior": null,
      "indent": "5",
      "description": "Osnaburg (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.11.0035",
      "rawHtsCode": "5211.11.00.35",
      "superior": null,
      "indent": "5",
      "description": "Other (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.11.0050",
      "rawHtsCode": "5211.11.00.50",
      "superior": null,
      "indent": "4",
      "description": "Napped (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.11.0090",
      "rawHtsCode": "5211.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Plain weave duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.12.00",
      "rawHtsCode": "5211.12.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill",
      "units": [],
      "generalRate": "7.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "19.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.12.0020",
      "rawHtsCode": "5211.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.12.0040",
      "rawHtsCode": "5211.12.00.40",
      "superior": null,
      "indent": "3",
      "description": "Napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.19.00",
      "rawHtsCode": "5211.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics",
      "units": [],
      "generalRate": "7.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "19.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.19.0020",
      "rawHtsCode": "5211.19.00.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.19.0040",
      "rawHtsCode": "5211.19.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.19.0060",
      "rawHtsCode": "5211.19.00.60",
      "superior": null,
      "indent": "3",
      "description": "Duck, except plain weave (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.19.0090",
      "rawHtsCode": "5211.19.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.20",
      "rawHtsCode": "5211.20",
      "superior": null,
      "indent": "1",
      "description": "Bleached:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.20.21",
      "rawHtsCode": "5211.20.21",
      "superior": null,
      "indent": "2",
      "description": "Plain weave",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.20.2120",
      "rawHtsCode": "5211.20.21.20",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.20.2125",
      "rawHtsCode": "5211.20.21.25",
      "superior": null,
      "indent": "5",
      "description": "Osnaburg (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.20.2135",
      "rawHtsCode": "5211.20.21.35",
      "superior": null,
      "indent": "5",
      "description": "Other (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.20.2150",
      "rawHtsCode": "5211.20.21.50",
      "superior": null,
      "indent": "4",
      "description": "Napped (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.20.2190",
      "rawHtsCode": "5211.20.21.90",
      "superior": null,
      "indent": "3",
      "description": "Plain weave duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.20.22",
      "rawHtsCode": "5211.20.22",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.20.2220",
      "rawHtsCode": "5211.20.22.20",
      "superior": null,
      "indent": "3",
      "description": "Not napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.20.2240",
      "rawHtsCode": "5211.20.22.40",
      "superior": null,
      "indent": "3",
      "description": "Napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.20.29",
      "rawHtsCode": "5211.20.29",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.20.2920",
      "rawHtsCode": "5211.20.29.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.20.2940",
      "rawHtsCode": "5211.20.29.40",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.20.2960",
      "rawHtsCode": "5211.20.29.60",
      "superior": null,
      "indent": "3",
      "description": "Duck, except plain weave (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.20.2990",
      "rawHtsCode": "5211.20.29.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.31.00",
      "rawHtsCode": "5211.31.00",
      "superior": null,
      "indent": "2",
      "description": "Plain weave",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.31.0020",
      "rawHtsCode": "5211.31.00.20",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.31.0025",
      "rawHtsCode": "5211.31.00.25",
      "superior": null,
      "indent": "5",
      "description": "Osnaburg (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.31.0035",
      "rawHtsCode": "5211.31.00.35",
      "superior": null,
      "indent": "5",
      "description": "Other (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.31.0050",
      "rawHtsCode": "5211.31.00.50",
      "superior": null,
      "indent": "4",
      "description": "Napped (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.31.0090",
      "rawHtsCode": "5211.31.00.90",
      "superior": null,
      "indent": "3",
      "description": "Plain weave duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.32.00",
      "rawHtsCode": "5211.32.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.32.0020",
      "rawHtsCode": "5211.32.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.32.0040",
      "rawHtsCode": "5211.32.00.40",
      "superior": null,
      "indent": "3",
      "description": "Napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.39.00",
      "rawHtsCode": "5211.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.39.0020",
      "rawHtsCode": "5211.39.00.20",
      "superior": null,
      "indent": "4",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.39.0040",
      "rawHtsCode": "5211.39.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.39.0060",
      "rawHtsCode": "5211.39.00.60",
      "superior": null,
      "indent": "3",
      "description": "Duck, except plain weave (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.39.0090",
      "rawHtsCode": "5211.39.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.41.00",
      "rawHtsCode": "5211.41.00",
      "superior": null,
      "indent": "2",
      "description": "Plain weave",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.41.0020",
      "rawHtsCode": "5211.41.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not napped (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.41.0040",
      "rawHtsCode": "5211.41.00.40",
      "superior": null,
      "indent": "3",
      "description": "Napped (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.42.00",
      "rawHtsCode": "5211.42.00",
      "superior": null,
      "indent": "2",
      "description": "Denim",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.42.0020",
      "rawHtsCode": "5211.42.00.20",
      "superior": null,
      "indent": "4",
      "description": "Weighing not more than 360 g/m² (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.42.0040",
      "rawHtsCode": "5211.42.00.40",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 360 g/m² (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.42.0060",
      "rawHtsCode": "5211.42.00.60",
      "superior": null,
      "indent": "4",
      "description": "Weighing not more than 360 g/m² (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.42.0080",
      "rawHtsCode": "5211.42.00.80",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 360 g/m² (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.43.00",
      "rawHtsCode": "5211.43.00",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics of 3-thread or 4-thread twill, including cross twill",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.43.0030",
      "rawHtsCode": "5211.43.00.30",
      "superior": null,
      "indent": "3",
      "description": "Not napped (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.43.0050",
      "rawHtsCode": "5211.43.00.50",
      "superior": null,
      "indent": "3",
      "description": "Napped (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.49.00",
      "rawHtsCode": "5211.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.49.0020",
      "rawHtsCode": "5211.49.00.20",
      "superior": null,
      "indent": "3",
      "description": "Jacquard woven (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.49.0090",
      "rawHtsCode": "5211.49.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.51.00",
      "rawHtsCode": "5211.51.00",
      "superior": null,
      "indent": "2",
      "description": "Plain weave",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5211.51.0020",
      "rawHtsCode": "5211.51.00.20",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.51.0030",
      "rawHtsCode": "5211.51.00.30",
      "superior": null,
      "indent": "4",
      "description": "Not napped (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.51.0050",
      "rawHtsCode": "5211.51.00.50",
      "superior": null,
      "indent": "4",
      "description": "Napped (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.51.0090",
      "rawHtsCode": "5211.51.00.90",
      "superior": null,
      "indent": "3",
      "description": "Plain weave duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.52.00",
      "rawHtsCode": "5211.52.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.52.0020",
      "rawHtsCode": "5211.52.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.52.0040",
      "rawHtsCode": "5211.52.00.40",
      "superior": null,
      "indent": "3",
      "description": "Napped (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.59.00",
      "rawHtsCode": "5211.59.00",
      "superior": null,
      "indent": "2",
      "description": "Other fabrics",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5211.59.0015",
      "rawHtsCode": "5211.59.00.15",
      "superior": null,
      "indent": "5",
      "description": "Discharge printed (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.59.0025",
      "rawHtsCode": "5211.59.00.25",
      "superior": null,
      "indent": "5",
      "description": "Other (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.59.0040",
      "rawHtsCode": "5211.59.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.59.0060",
      "rawHtsCode": "5211.59.00.60",
      "superior": null,
      "indent": "3",
      "description": "Duck, except plain weave (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5211.59.0090",
      "rawHtsCode": "5211.59.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212",
      "rawHtsCode": "5212",
      "superior": null,
      "indent": "0",
      "description": "Other woven fabrics of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.11",
      "rawHtsCode": "5212.11",
      "superior": null,
      "indent": "2",
      "description": "Unbleached:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.11.10",
      "rawHtsCode": "5212.11.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "16.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.11.1010",
      "rawHtsCode": "5212.11.10.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.11.1020",
      "rawHtsCode": "5212.11.10.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.11.60",
      "rawHtsCode": "5212.11.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.11.6010",
      "rawHtsCode": "5212.11.60.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with wool or fine animal hair (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.11.6020",
      "rawHtsCode": "5212.11.60.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.11.6030",
      "rawHtsCode": "5212.11.60.30",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.11.6040",
      "rawHtsCode": "5212.11.60.40",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.11.6050",
      "rawHtsCode": "5212.11.60.50",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth; lawns,voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.11.6060",
      "rawHtsCode": "5212.11.60.60",
      "superior": null,
      "indent": "6",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.11.6070",
      "rawHtsCode": "5212.11.60.70",
      "superior": null,
      "indent": "6",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.11.6080",
      "rawHtsCode": "5212.11.60.80",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.11.6090",
      "rawHtsCode": "5212.11.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.12",
      "rawHtsCode": "5212.12",
      "superior": null,
      "indent": "2",
      "description": "Bleached:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.12.10",
      "rawHtsCode": "5212.12.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "16.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.12.1010",
      "rawHtsCode": "5212.12.10.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.12.1020",
      "rawHtsCode": "5212.12.10.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.12.60",
      "rawHtsCode": "5212.12.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.12.6010",
      "rawHtsCode": "5212.12.60.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with wool or fine animal hair (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.12.6020",
      "rawHtsCode": "5212.12.60.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.12.6030",
      "rawHtsCode": "5212.12.60.30",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.12.6040",
      "rawHtsCode": "5212.12.60.40",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.12.6050",
      "rawHtsCode": "5212.12.60.50",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.12.6060",
      "rawHtsCode": "5212.12.60.60",
      "superior": null,
      "indent": "6",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.12.6070",
      "rawHtsCode": "5212.12.60.70",
      "superior": null,
      "indent": "6",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.12.6080",
      "rawHtsCode": "5212.12.60.80",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.12.6090",
      "rawHtsCode": "5212.12.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.13",
      "rawHtsCode": "5212.13",
      "superior": null,
      "indent": "2",
      "description": "Dyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.13.10",
      "rawHtsCode": "5212.13.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "16.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.13.1010",
      "rawHtsCode": "5212.13.10.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.13.1020",
      "rawHtsCode": "5212.13.10.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.13.60",
      "rawHtsCode": "5212.13.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.13.6010",
      "rawHtsCode": "5212.13.60.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with wool or fine animal hair (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.13.6020",
      "rawHtsCode": "5212.13.60.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.13.6030",
      "rawHtsCode": "5212.13.60.30",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.13.6040",
      "rawHtsCode": "5212.13.60.40",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.13.6050",
      "rawHtsCode": "5212.13.60.50",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.13.6060",
      "rawHtsCode": "5212.13.60.60",
      "superior": null,
      "indent": "6",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.13.6070",
      "rawHtsCode": "5212.13.60.70",
      "superior": null,
      "indent": "6",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.13.6080",
      "rawHtsCode": "5212.13.60.80",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.13.6090",
      "rawHtsCode": "5212.13.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.14",
      "rawHtsCode": "5212.14",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.14.10",
      "rawHtsCode": "5212.14.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "16.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.14.1010",
      "rawHtsCode": "5212.14.10.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.14.1020",
      "rawHtsCode": "5212.14.10.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.14.60",
      "rawHtsCode": "5212.14.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.14.6010",
      "rawHtsCode": "5212.14.60.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with wool or fine animal hair (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.14.6020",
      "rawHtsCode": "5212.14.60.20",
      "superior": null,
      "indent": "6",
      "description": "Of a width exceeding 127 cm (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.14.6030",
      "rawHtsCode": "5212.14.60.30",
      "superior": null,
      "indent": "6",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.14.6090",
      "rawHtsCode": "5212.14.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.15",
      "rawHtsCode": "5212.15",
      "superior": null,
      "indent": "2",
      "description": "Printed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.15.10",
      "rawHtsCode": "5212.15.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5212.15.1010",
      "rawHtsCode": "5212.15.10.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.15.1020",
      "rawHtsCode": "5212.15.10.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.15.60",
      "rawHtsCode": "5212.15.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.15.6010",
      "rawHtsCode": "5212.15.60.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with wool or fine animal hair (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.15.6020",
      "rawHtsCode": "5212.15.60.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.15.6030",
      "rawHtsCode": "5212.15.60.30",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.15.6040",
      "rawHtsCode": "5212.15.60.40",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.15.6050",
      "rawHtsCode": "5212.15.60.50",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth; lawns,voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.15.6060",
      "rawHtsCode": "5212.15.60.60",
      "superior": null,
      "indent": "6",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.15.6070",
      "rawHtsCode": "5212.15.60.70",
      "superior": null,
      "indent": "6",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.15.6080",
      "rawHtsCode": "5212.15.60.80",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.15.6090",
      "rawHtsCode": "5212.15.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.21",
      "rawHtsCode": "5212.21",
      "superior": null,
      "indent": "2",
      "description": "Unbleached:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.21.10",
      "rawHtsCode": "5212.21.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "16.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.21.1010",
      "rawHtsCode": "5212.21.10.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.21.1020",
      "rawHtsCode": "5212.21.10.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.21.60",
      "rawHtsCode": "5212.21.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.21.6010",
      "rawHtsCode": "5212.21.60.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with wool or fine animal hair (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.21.6020",
      "rawHtsCode": "5212.21.60.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.21.6030",
      "rawHtsCode": "5212.21.60.30",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.21.6040",
      "rawHtsCode": "5212.21.60.40",
      "superior": null,
      "indent": "5",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.21.6050",
      "rawHtsCode": "5212.21.60.50",
      "superior": null,
      "indent": "6",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.21.6060",
      "rawHtsCode": "5212.21.60.60",
      "superior": null,
      "indent": "6",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.21.6090",
      "rawHtsCode": "5212.21.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.22",
      "rawHtsCode": "5212.22",
      "superior": null,
      "indent": "2",
      "description": "Bleached:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.22.10",
      "rawHtsCode": "5212.22.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "16.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.22.1010",
      "rawHtsCode": "5212.22.10.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.22.1020",
      "rawHtsCode": "5212.22.10.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.22.60",
      "rawHtsCode": "5212.22.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.22.6010",
      "rawHtsCode": "5212.22.60.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with wool or fine animal hair (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.22.6020",
      "rawHtsCode": "5212.22.60.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.22.6030",
      "rawHtsCode": "5212.22.60.30",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.22.6040",
      "rawHtsCode": "5212.22.60.40",
      "superior": null,
      "indent": "5",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.22.6050",
      "rawHtsCode": "5212.22.60.50",
      "superior": null,
      "indent": "6",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.22.6060",
      "rawHtsCode": "5212.22.60.60",
      "superior": null,
      "indent": "6",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.22.6090",
      "rawHtsCode": "5212.22.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.23",
      "rawHtsCode": "5212.23",
      "superior": null,
      "indent": "2",
      "description": "Dyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.23.10",
      "rawHtsCode": "5212.23.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "16.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.23.1010",
      "rawHtsCode": "5212.23.10.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.23.1020",
      "rawHtsCode": "5212.23.10.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.23.60",
      "rawHtsCode": "5212.23.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.23.6010",
      "rawHtsCode": "5212.23.60.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with wool or fine animal hair (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.23.6020",
      "rawHtsCode": "5212.23.60.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.23.6030",
      "rawHtsCode": "5212.23.60.30",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.23.6040",
      "rawHtsCode": "5212.23.60.40",
      "superior": null,
      "indent": "5",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.23.6050",
      "rawHtsCode": "5212.23.60.50",
      "superior": null,
      "indent": "6",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.23.6060",
      "rawHtsCode": "5212.23.60.60",
      "superior": null,
      "indent": "6",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.23.6090",
      "rawHtsCode": "5212.23.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.24",
      "rawHtsCode": "5212.24",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.24.10",
      "rawHtsCode": "5212.24.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "16.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.24.1010",
      "rawHtsCode": "5212.24.10.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.24.1020",
      "rawHtsCode": "5212.24.10.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.24.60",
      "rawHtsCode": "5212.24.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5212.24.6010",
      "rawHtsCode": "5212.24.60.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with wool or fine animal hair (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.24.6020",
      "rawHtsCode": "5212.24.60.20",
      "superior": null,
      "indent": "5",
      "description": "Blue denim (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.24.6030",
      "rawHtsCode": "5212.24.60.30",
      "superior": null,
      "indent": "6",
      "description": "Of a width exceeding 127 cm (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.24.6040",
      "rawHtsCode": "5212.24.60.40",
      "superior": null,
      "indent": "6",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.24.6090",
      "rawHtsCode": "5212.24.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.25",
      "rawHtsCode": "5212.25",
      "superior": null,
      "indent": "2",
      "description": "Printed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.25.10",
      "rawHtsCode": "5212.25.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5212.25.1010",
      "rawHtsCode": "5212.25.10.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.25.1020",
      "rawHtsCode": "5212.25.10.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.25.60",
      "rawHtsCode": "5212.25.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5212.25.6010",
      "rawHtsCode": "5212.25.60.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with wool or fine animal hair (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.25.6020",
      "rawHtsCode": "5212.25.60.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.25.6030",
      "rawHtsCode": "5212.25.60.30",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.25.6040",
      "rawHtsCode": "5212.25.60.40",
      "superior": null,
      "indent": "5",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.25.6050",
      "rawHtsCode": "5212.25.60.50",
      "superior": null,
      "indent": "6",
      "description": "Sateens (326)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.25.6060",
      "rawHtsCode": "5212.25.60.60",
      "superior": null,
      "indent": "6",
      "description": "Other (317)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5212.25.6090",
      "rawHtsCode": "5212.25.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5301",
      "rawHtsCode": "5301",
      "superior": null,
      "indent": "0",
      "description": "Flax, raw or processed but not spun; flax tow and waste (including yarn waste and garnetted stock):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5301.10.0000",
      "rawHtsCode": "5301.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Flax, raw or retted",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5301.21.0000",
      "rawHtsCode": "5301.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Broken or scutched",
      "units": [
        "kg"
      ],
      "generalRate": "0.2¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5301.29.0000",
      "rawHtsCode": "5301.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5301.30.0000",
      "rawHtsCode": "5301.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Flax tow and waste",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5302",
      "rawHtsCode": "5302",
      "superior": null,
      "indent": "0",
      "description": "True hemp (<u>Cannabis</u> <u>sativa</u> <u>L.</u>), raw or processed but not spun; tow and waste of true hemp (including yarn waste and garnetted stock):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5302.10.0000",
      "rawHtsCode": "5302.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "True hemp, raw or retted",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5302.90.0000",
      "rawHtsCode": "5302.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5303",
      "rawHtsCode": "5303",
      "superior": null,
      "indent": "0",
      "description": "Jute and other textile bast fibers (excluding flax, true hemp and ramie), raw or processed but not spun; tow and waste of these fibers (including yarn waste and garnetted stock):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5303.10.0000",
      "rawHtsCode": "5303.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Jute and other textile bast fibers, raw or retted",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5303.90.0000",
      "rawHtsCode": "5303.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5305.00.0000",
      "rawHtsCode": "5305.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Coconut, abaca (Manila hemp or <u>Musa</u> <u>textilis</u> <u>Nee</u>), ramie and other vegetable textile fibers, not elsewhere specified or included, raw or processed but not spun; tow, noils and waste of these fibers (including yarn waste and garnetted stock)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5306",
      "rawHtsCode": "5306",
      "superior": null,
      "indent": "0",
      "description": "Flax yarn:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5306.10.0000",
      "rawHtsCode": "5306.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Single (800)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5306.20.0000",
      "rawHtsCode": "5306.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Multiple (folded) or cabled (800)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5307",
      "rawHtsCode": "5307",
      "superior": null,
      "indent": "0",
      "description": "Yarn of jute or of other textile bast fibers of heading 5303:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5307.10.0000",
      "rawHtsCode": "5307.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Single",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5307.20.0000",
      "rawHtsCode": "5307.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Multiple (folded) or cabled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5308",
      "rawHtsCode": "5308",
      "superior": null,
      "indent": "0",
      "description": "Yarn of other vegetable textile fibers; paper yarn:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5308.10.0000",
      "rawHtsCode": "5308.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Coir yarn",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5308.20.0000",
      "rawHtsCode": "5308.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "True hemp yarn (800)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5308.90",
      "rawHtsCode": "5308.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5308.90.1000",
      "rawHtsCode": "5308.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Paper yarn",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5308.90.9000",
      "rawHtsCode": "5308.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (800)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "5309",
      "rawHtsCode": "5309",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of flax:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.11.00",
      "rawHtsCode": "5309.11.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5309.11.0010",
      "rawHtsCode": "5309.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of a width exceeding 127 cm (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.11.0090",
      "rawHtsCode": "5309.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.19.00",
      "rawHtsCode": "5309.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5309.19.0010",
      "rawHtsCode": "5309.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of a width exceeding 127 cm (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.19.0090",
      "rawHtsCode": "5309.19.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.21",
      "rawHtsCode": "5309.21",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.21.2000",
      "rawHtsCode": "5309.21.20.00",
      "superior": null,
      "indent": "3",
      "description": "Containing more than 17 percent by weight of wool or fine animal hair (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5309.21.30",
      "rawHtsCode": "5309.21.30",
      "superior": null,
      "indent": "4",
      "description": "Containing cotton and man-made fibers",
      "units": [],
      "generalRate": "6.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "78%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5309.21.3005",
      "rawHtsCode": "5309.21.30.05",
      "superior": null,
      "indent": "6",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.21.3010",
      "rawHtsCode": "5309.21.30.10",
      "superior": null,
      "indent": "6",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.21.3015",
      "rawHtsCode": "5309.21.30.15",
      "superior": null,
      "indent": "6",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.21.3020",
      "rawHtsCode": "5309.21.30.20",
      "superior": null,
      "indent": "6",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.21.3055",
      "rawHtsCode": "5309.21.30.55",
      "superior": null,
      "indent": "6",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.21.3060",
      "rawHtsCode": "5309.21.30.60",
      "superior": null,
      "indent": "6",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.21.3065",
      "rawHtsCode": "5309.21.30.65",
      "superior": null,
      "indent": "6",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.21.3070",
      "rawHtsCode": "5309.21.30.70",
      "superior": null,
      "indent": "6",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.21.3090",
      "rawHtsCode": "5309.21.30.90",
      "superior": null,
      "indent": "5",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.21.40",
      "rawHtsCode": "5309.21.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5309.21.4010",
      "rawHtsCode": "5309.21.40.10",
      "superior": null,
      "indent": "5",
      "description": "Of a width exceeding 127 cm (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.21.4090",
      "rawHtsCode": "5309.21.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.29",
      "rawHtsCode": "5309.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.29.2000",
      "rawHtsCode": "5309.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Containing more than 17 percent by weight of wool or fine animal hair (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5309.29.30",
      "rawHtsCode": "5309.29.30",
      "superior": null,
      "indent": "4",
      "description": "Containing cotton and man-made fibers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "78%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5309.29.3005",
      "rawHtsCode": "5309.29.30.05",
      "superior": null,
      "indent": "6",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.29.3010",
      "rawHtsCode": "5309.29.30.10",
      "superior": null,
      "indent": "6",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.29.3015",
      "rawHtsCode": "5309.29.30.15",
      "superior": null,
      "indent": "6",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.29.3020",
      "rawHtsCode": "5309.29.30.20",
      "superior": null,
      "indent": "6",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.29.3055",
      "rawHtsCode": "5309.29.30.55",
      "superior": null,
      "indent": "6",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.29.3060",
      "rawHtsCode": "5309.29.30.60",
      "superior": null,
      "indent": "6",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.29.3065",
      "rawHtsCode": "5309.29.30.65",
      "superior": null,
      "indent": "6",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.29.3070",
      "rawHtsCode": "5309.29.30.70",
      "superior": null,
      "indent": "6",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.29.3090",
      "rawHtsCode": "5309.29.30.90",
      "superior": null,
      "indent": "5",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.29.40",
      "rawHtsCode": "5309.29.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5309.29.4010",
      "rawHtsCode": "5309.29.40.10",
      "superior": null,
      "indent": "5",
      "description": "Of a width exceeding 127 cm (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5309.29.4090",
      "rawHtsCode": "5309.29.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5310",
      "rawHtsCode": "5310",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of jute or of other textile bast fibers of heading 5303:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5310.10.00",
      "rawHtsCode": "5310.10.00",
      "superior": null,
      "indent": "1",
      "description": "Unbleached",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5310.10.0020",
      "rawHtsCode": "5310.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Not over 130 cm in width",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5310.10.0040",
      "rawHtsCode": "5310.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Over 130 cm but not over 250 cm in width",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5310.10.0060",
      "rawHtsCode": "5310.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Over 250 cm in width",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5310.90.0000",
      "rawHtsCode": "5310.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5311.00",
      "rawHtsCode": "5311.00",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of other vegetable textile fibers; woven fabrics of paper yarn:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5311.00.2000",
      "rawHtsCode": "5311.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "Containing more than 17 percent by weight of wool or fine animal hair (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5311.00.30",
      "rawHtsCode": "5311.00.30",
      "superior": null,
      "indent": "3",
      "description": "Containing cotton and man-made fibers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "78%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5311.00.3005",
      "rawHtsCode": "5311.00.30.05",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (314)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5311.00.3010",
      "rawHtsCode": "5311.00.30.10",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (313)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5311.00.3015",
      "rawHtsCode": "5311.00.30.15",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (315)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5311.00.3020",
      "rawHtsCode": "5311.00.30.20",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5311.00.3055",
      "rawHtsCode": "5311.00.30.55",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5311.00.3060",
      "rawHtsCode": "5311.00.30.60",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5311.00.3065",
      "rawHtsCode": "5311.00.30.65",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5311.00.3070",
      "rawHtsCode": "5311.00.30.70",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5311.00.3090",
      "rawHtsCode": "5311.00.30.90",
      "superior": null,
      "indent": "4",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5311.00.40",
      "rawHtsCode": "5311.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5311.00.4010",
      "rawHtsCode": "5311.00.40.10",
      "superior": null,
      "indent": "4",
      "description": "Of true hemp fibers (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5311.00.4020",
      "rawHtsCode": "5311.00.40.20",
      "superior": null,
      "indent": "4",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5311.00.6000",
      "rawHtsCode": "5311.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Of paper yarn",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5401",
      "rawHtsCode": "5401",
      "superior": null,
      "indent": "0",
      "description": "Sewing thread of man-made filaments, whether or not put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5401.10.0000",
      "rawHtsCode": "5401.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of synthetic filaments (200)",
      "units": [
        "kg"
      ],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5401.20.0000",
      "rawHtsCode": "5401.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of artificial filaments (200)",
      "units": [
        "kg"
      ],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402",
      "rawHtsCode": "5402",
      "superior": null,
      "indent": "0",
      "description": "Synthetic filament yarn (other than sewing thread), not put up for retail sale, including synthetic monofilament of less than <il>67 decitex</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.11",
      "rawHtsCode": "5402.11",
      "superior": null,
      "indent": "2",
      "description": "Of aramids:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.11.30",
      "rawHtsCode": "5402.11.30",
      "superior": null,
      "indent": "3",
      "description": "Single yarn",
      "units": [],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.11.3010",
      "rawHtsCode": "5402.11.30.10",
      "superior": null,
      "indent": "5",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.11.3030",
      "rawHtsCode": "5402.11.30.30",
      "superior": null,
      "indent": "5",
      "description": "Multifilament, with twist of 5 turns or more per meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.11.3050",
      "rawHtsCode": "5402.11.30.50",
      "superior": null,
      "indent": "5",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.11.3070",
      "rawHtsCode": "5402.11.30.70",
      "superior": null,
      "indent": "5",
      "description": "Multifilament, with twist of 5 turns or more per meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.11.6000",
      "rawHtsCode": "5402.11.60.00",
      "superior": null,
      "indent": "3",
      "description": "Multiple (folded) or cabled (606)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.19",
      "rawHtsCode": "5402.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.19.30",
      "rawHtsCode": "5402.19.30",
      "superior": null,
      "indent": "3",
      "description": "Single yarn",
      "units": [],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.19.3010",
      "rawHtsCode": "5402.19.30.10",
      "superior": null,
      "indent": "5",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.19.3030",
      "rawHtsCode": "5402.19.30.30",
      "superior": null,
      "indent": "5",
      "description": "Multifilament, with twist of 5 turns or more per meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.19.3050",
      "rawHtsCode": "5402.19.30.50",
      "superior": null,
      "indent": "5",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.19.3070",
      "rawHtsCode": "5402.19.30.70",
      "superior": null,
      "indent": "5",
      "description": "Multifilament, with twist of 5 turns or more per meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.19.6000",
      "rawHtsCode": "5402.19.60.00",
      "superior": null,
      "indent": "3",
      "description": "Multiple (folded) or cabled (606)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.20",
      "rawHtsCode": "5402.20",
      "superior": null,
      "indent": "1",
      "description": "High tenacity yarn of polyesters, whether or not textured:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.20.30",
      "rawHtsCode": "5402.20.30",
      "superior": null,
      "indent": "2",
      "description": "Single yarn",
      "units": [],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.20.3010",
      "rawHtsCode": "5402.20.30.10",
      "superior": null,
      "indent": "4",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.20.3030",
      "rawHtsCode": "5402.20.30.30",
      "superior": null,
      "indent": "4",
      "description": "Multifilament, with twist of 5 turns or more per meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.20.3050",
      "rawHtsCode": "5402.20.30.50",
      "superior": null,
      "indent": "4",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.20.3070",
      "rawHtsCode": "5402.20.30.70",
      "superior": null,
      "indent": "4",
      "description": "Multifilament, with twist of 5 turns or more per meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.20.6000",
      "rawHtsCode": "5402.20.60.00",
      "superior": null,
      "indent": "2",
      "description": "Multiple (folded) or cabled (606)",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.31",
      "rawHtsCode": "5402.31",
      "superior": null,
      "indent": "2",
      "description": "Of nylon or other polyamides, measuring per single yarn not more than 500 decitex:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.31.3000",
      "rawHtsCode": "5402.31.30.00",
      "superior": null,
      "indent": "3",
      "description": "Single yarn (600)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.31.6000",
      "rawHtsCode": "5402.31.60.00",
      "superior": null,
      "indent": "3",
      "description": "Multiple (folded) or cabled yarn (600)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.32",
      "rawHtsCode": "5402.32",
      "superior": null,
      "indent": "2",
      "description": "Of nylon or other polyamides, measuring per single yarn more than 500 decitex:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.32.3000",
      "rawHtsCode": "5402.32.30.00",
      "superior": null,
      "indent": "3",
      "description": "Single yarn (600)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.32.6000",
      "rawHtsCode": "5402.32.60.00",
      "superior": null,
      "indent": "3",
      "description": "Multiple (folded) or cabled yarn (600)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.33",
      "rawHtsCode": "5402.33",
      "superior": null,
      "indent": "2",
      "description": "Of polyesters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.33.3000",
      "rawHtsCode": "5402.33.30.00",
      "superior": null,
      "indent": "3",
      "description": "Single yarn (600)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.33.6000",
      "rawHtsCode": "5402.33.60.00",
      "superior": null,
      "indent": "3",
      "description": "Multiple (folded) or cabled yarn (600)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.34",
      "rawHtsCode": "5402.34",
      "superior": null,
      "indent": "2",
      "description": "Of polypropylene:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.34.3000",
      "rawHtsCode": "5402.34.30.00",
      "superior": null,
      "indent": "3",
      "description": "Single yarn (600)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.34.6000",
      "rawHtsCode": "5402.34.60.00",
      "superior": null,
      "indent": "3",
      "description": "Multiple (folded) or cabled yarn (600)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.39",
      "rawHtsCode": "5402.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.39.31",
      "rawHtsCode": "5402.39.31",
      "superior": null,
      "indent": "3",
      "description": "Single yarn",
      "units": [],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.39.3110",
      "rawHtsCode": "5402.39.31.10",
      "superior": null,
      "indent": "4",
      "description": "Of polyethylene (600)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.39.3190",
      "rawHtsCode": "5402.39.31.90",
      "superior": null,
      "indent": "4",
      "description": "Other (600)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.39.61",
      "rawHtsCode": "5402.39.61",
      "superior": null,
      "indent": "3",
      "description": "Multiple (folded) or cabled yarn",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.39.6110",
      "rawHtsCode": "5402.39.61.10",
      "superior": null,
      "indent": "4",
      "description": "Of polyethylene (600)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.39.6190",
      "rawHtsCode": "5402.39.61.90",
      "superior": null,
      "indent": "4",
      "description": "Other (600)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.44.00",
      "rawHtsCode": "5402.44.00",
      "superior": null,
      "indent": "2",
      "description": "Elastomeric",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.44.0005",
      "rawHtsCode": "5402.44.00.05",
      "superior": null,
      "indent": "3",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.44.0040",
      "rawHtsCode": "5402.44.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.45",
      "rawHtsCode": "5402.45",
      "superior": null,
      "indent": "2",
      "description": "Other, of nylon or other polyamides:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.45.1000",
      "rawHtsCode": "5402.45.10.00",
      "superior": null,
      "indent": "3",
      "description": "Colored multifilament, untwisted or with a twist of less than 5 turns per meter, measuring not less than 22 decitex per filament, certified by the importer to be used in the manufacture of wigs for dolls",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5402.45.90",
      "rawHtsCode": "5402.45.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.45.9010",
      "rawHtsCode": "5402.45.90.10",
      "superior": null,
      "indent": "5",
      "description": "Multifilament, partially oriented",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.45.9030",
      "rawHtsCode": "5402.45.90.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.45.9040",
      "rawHtsCode": "5402.45.90.40",
      "superior": null,
      "indent": "4",
      "description": "Multifilament, with twist of 5 turns or more per meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.46.0000",
      "rawHtsCode": "5402.46.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, of polyesters, partially oriented",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.47",
      "rawHtsCode": "5402.47",
      "superior": null,
      "indent": "2",
      "description": "Other, of polyesters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.47.10",
      "rawHtsCode": "5402.47.10",
      "superior": null,
      "indent": "3",
      "description": "Wholly of polyester, measuring not less than <il>75 decitex</il> but not more than <il>80 decitex</il>, and having 24 filaments per yarn",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.47.1020",
      "rawHtsCode": "5402.47.10.20",
      "superior": null,
      "indent": "4",
      "description": "Untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.47.1040",
      "rawHtsCode": "5402.47.10.40",
      "superior": null,
      "indent": "4",
      "description": "With twist of 5 turns or more per meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.47.90",
      "rawHtsCode": "5402.47.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.47.9020",
      "rawHtsCode": "5402.47.90.20",
      "superior": null,
      "indent": "4",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.47.9040",
      "rawHtsCode": "5402.47.90.40",
      "superior": null,
      "indent": "4",
      "description": "Multifilament, with twist of 5 turns or more per meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.48.00",
      "rawHtsCode": "5402.48.00",
      "superior": null,
      "indent": "2",
      "description": "Other, of polypropylene",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.48.0010",
      "rawHtsCode": "5402.48.00.10",
      "superior": null,
      "indent": "3",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.48.0070",
      "rawHtsCode": "5402.48.00.70",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.49",
      "rawHtsCode": "5402.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.49.1100",
      "rawHtsCode": "5402.49.11.00",
      "superior": null,
      "indent": "3",
      "description": "Colored multifilament, of modacrylic, untwisted or with a twist of less than 5 turns per meter, measuring not less than 22 decitex per filament, certified by the importer to be used in the manufacture of wigs for dolls",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5402.49.91",
      "rawHtsCode": "5402.49.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.49.9115",
      "rawHtsCode": "5402.49.91.15",
      "superior": null,
      "indent": "5",
      "description": "Of polyethylene",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.49.9140",
      "rawHtsCode": "5402.49.91.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.49.9175",
      "rawHtsCode": "5402.49.91.75",
      "superior": null,
      "indent": "5",
      "description": "Of polyethylene (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.49.9180",
      "rawHtsCode": "5402.49.91.80",
      "superior": null,
      "indent": "5",
      "description": "Other (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.51.0000",
      "rawHtsCode": "5402.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of nylon or other polyamides (606)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.52",
      "rawHtsCode": "5402.52",
      "superior": null,
      "indent": "2",
      "description": "Of polyesters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5402.52.1000",
      "rawHtsCode": "5402.52.10.00",
      "superior": null,
      "indent": "3",
      "description": "Wholly of polyester, measuring not less than <il>75 decitex</il> but not more than <il>80 decitex</il>, and having 24 filaments per yarn (606)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.52.9000",
      "rawHtsCode": "5402.52.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (606)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.53.0000",
      "rawHtsCode": "5402.53.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of polypropylene (606)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.59.0100",
      "rawHtsCode": "5402.59.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other (606)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.61.0000",
      "rawHtsCode": "5402.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of nylon or other polyamides (606)",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.62.0000",
      "rawHtsCode": "5402.62.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of polyesters (606)",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.63.0000",
      "rawHtsCode": "5402.63.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of polypropylene (606)",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5402.69.0100",
      "rawHtsCode": "5402.69.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other (606)",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5403",
      "rawHtsCode": "5403",
      "superior": null,
      "indent": "0",
      "description": "Artificial filament yarn (other than sewing thread), not put up for retail sale, including artificial monofilament of less than <il>67 decitex</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5403.10",
      "rawHtsCode": "5403.10",
      "superior": null,
      "indent": "1",
      "description": "High tenacity yarn of viscose rayon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5403.10.30",
      "rawHtsCode": "5403.10.30",
      "superior": null,
      "indent": "2",
      "description": "Single yarn",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5403.10.3020",
      "rawHtsCode": "5403.10.30.20",
      "superior": null,
      "indent": "3",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5403.10.3040",
      "rawHtsCode": "5403.10.30.40",
      "superior": null,
      "indent": "3",
      "description": "Multifilament, with twist of 5 turns or more per meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5403.10.6000",
      "rawHtsCode": "5403.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Multiple (folded) or cabled (606)",
      "units": [
        "kg"
      ],
      "generalRate": "9.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5403.31.00",
      "rawHtsCode": "5403.31.00",
      "superior": null,
      "indent": "2",
      "description": "Of viscose rayon, untwisted or with a twist not ex- ceeding 120 turns/m",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5403.31.0020",
      "rawHtsCode": "5403.31.00.20",
      "superior": null,
      "indent": "3",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5403.31.0040",
      "rawHtsCode": "5403.31.00.40",
      "superior": null,
      "indent": "3",
      "description": "Multifilament, with twist of 5 turns or more per meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5403.32.0000",
      "rawHtsCode": "5403.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of viscose rayon, with a twist exceeding 120 turns/m (606)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5403.33.00",
      "rawHtsCode": "5403.33.00",
      "superior": null,
      "indent": "2",
      "description": "Of cellulose acetate",
      "units": [],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5403.33.0020",
      "rawHtsCode": "5403.33.00.20",
      "superior": null,
      "indent": "3",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5403.33.0040",
      "rawHtsCode": "5403.33.00.40",
      "superior": null,
      "indent": "3",
      "description": "Multifilament, with twist of 5 turns or more per ` meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5403.39",
      "rawHtsCode": "5403.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5403.39.1000",
      "rawHtsCode": "5403.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Textured yarn (600)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5403.39.90",
      "rawHtsCode": "5403.39.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5403.39.9020",
      "rawHtsCode": "5403.39.90.20",
      "superior": null,
      "indent": "4",
      "description": "Monofilament; multifilament, untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5403.39.9040",
      "rawHtsCode": "5403.39.90.40",
      "superior": null,
      "indent": "4",
      "description": "Multifilament, with twist of 5 turns or more per meter (606)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5403.41.0000",
      "rawHtsCode": "5403.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of viscose rayon (606)",
      "units": [
        "kg"
      ],
      "generalRate": "9.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5403.42.0000",
      "rawHtsCode": "5403.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of cellulose acetate (606)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5403.49",
      "rawHtsCode": "5403.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5403.49.1000",
      "rawHtsCode": "5403.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Textured yarn (600)",
      "units": [
        "kg"
      ],
      "generalRate": "9.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5403.49.9000",
      "rawHtsCode": "5403.49.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (606)",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5404",
      "rawHtsCode": "5404",
      "superior": null,
      "indent": "0",
      "description": "Synthetic monofilament of <il>67 decitex</il> or more and of which no cross-sectional dimension exceeds 1 mm; strip and the like (for example, artificial straw) of synthetic textile materials of an apparent width not exceeding 5 mm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5404.11.0000",
      "rawHtsCode": "5404.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Elastomeric",
      "units": [
        "kg"
      ],
      "generalRate": "6.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5404.12",
      "rawHtsCode": "5404.12",
      "superior": null,
      "indent": "2",
      "description": "Other, of polypropylene:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5404.12.1000",
      "rawHtsCode": "5404.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "Not over 254 mm in length",
      "units": [
        "kg"
      ],
      "generalRate": "6.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5404.12.9000",
      "rawHtsCode": "5404.12.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5404.19",
      "rawHtsCode": "5404.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5404.19.1000",
      "rawHtsCode": "5404.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Racket strings",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5404.19.80",
      "rawHtsCode": "5404.19.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5404.19.8020",
      "rawHtsCode": "5404.19.80.20",
      "superior": null,
      "indent": "4",
      "description": "Of nylon or other polyamides",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5404.19.8040",
      "rawHtsCode": "5404.19.80.40",
      "superior": null,
      "indent": "4",
      "description": "Of polyesters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5404.19.8080",
      "rawHtsCode": "5404.19.80.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5404.90.0000",
      "rawHtsCode": "5404.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5405.00",
      "rawHtsCode": "5405.00",
      "superior": null,
      "indent": "0",
      "description": "Artificial monofilament of <il>67 decitex</il> or more and of which no cross-sectional dimension exceeds 1 mm; strip and the like (for example, artificial straw) of artificial textile materials of an apparent width not exceeding 5 mm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5405.00.3000",
      "rawHtsCode": "5405.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Monofilament",
      "units": [
        "kg"
      ],
      "generalRate": "6.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5405.00.6000",
      "rawHtsCode": "5405.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5406.00",
      "rawHtsCode": "5406.00",
      "superior": null,
      "indent": "0",
      "description": "Man-made filament yarn (other than sewing thread), put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5406.00.10",
      "rawHtsCode": "5406.00.10",
      "superior": null,
      "indent": "1",
      "description": "Synthetic filament yarn",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5406.00.1020",
      "rawHtsCode": "5406.00.10.20",
      "superior": null,
      "indent": "2",
      "description": "Of acrylic (200)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5406.00.1040",
      "rawHtsCode": "5406.00.10.40",
      "superior": null,
      "indent": "2",
      "description": "Of polyesters (200)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5406.00.1090",
      "rawHtsCode": "5406.00.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other (200)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5406.00.2000",
      "rawHtsCode": "5406.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Artificial filament yarn (200)",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407",
      "rawHtsCode": "5407",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of synthetic filament yarn, including woven fabrics obtained from materials of heading 5404:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.10.00",
      "rawHtsCode": "5407.10.00",
      "superior": null,
      "indent": "1",
      "description": "Woven fabrics obtained from high tenacity yarn of nylon or other polyamides or of polyesters",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.10.0010",
      "rawHtsCode": "5407.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of polyester, weighing not more than 170 g/m² (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.10.0090",
      "rawHtsCode": "5407.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.20.0000",
      "rawHtsCode": "5407.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Woven fabrics obtained from strip or the like (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5407.30",
      "rawHtsCode": "5407.30",
      "superior": null,
      "indent": "1",
      "description": "Fabrics specified in note 9 to section XI:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.30.1000",
      "rawHtsCode": "5407.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Over 60 percent by weight of plastics",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5407.30.9000",
      "rawHtsCode": "5407.30.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.41.00",
      "rawHtsCode": "5407.41.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.41.0010",
      "rawHtsCode": "5407.41.00.10",
      "superior": null,
      "indent": "4",
      "description": "With both selvages woven (621)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.41.0020",
      "rawHtsCode": "5407.41.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other (621)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.41.0030",
      "rawHtsCode": "5407.41.00.30",
      "superior": null,
      "indent": "4",
      "description": "Weighing not more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.41.0060",
      "rawHtsCode": "5407.41.00.60",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.42.00",
      "rawHtsCode": "5407.42.00",
      "superior": null,
      "indent": "2",
      "description": "Dyed",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.42.0030",
      "rawHtsCode": "5407.42.00.30",
      "superior": null,
      "indent": "3",
      "description": "Weighing not more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.42.0060",
      "rawHtsCode": "5407.42.00.60",
      "superior": null,
      "indent": "3",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.43",
      "rawHtsCode": "5407.43",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.43.1000",
      "rawHtsCode": "5407.43.10.00",
      "superior": null,
      "indent": "3",
      "description": "The thread count of which per cm (treating multiple (folded) or cabled yarns as single threads) is over 69 but not over 142 in the warp and over 31 but not over 71 in the filling (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12.2¢/kg + 11.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.43.20",
      "rawHtsCode": "5407.43.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.43.2030",
      "rawHtsCode": "5407.43.20.30",
      "superior": null,
      "indent": "4",
      "description": "Weighing not more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.43.2060",
      "rawHtsCode": "5407.43.20.60",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.44.00",
      "rawHtsCode": "5407.44.00",
      "superior": null,
      "indent": "2",
      "description": "Printed",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.44.0030",
      "rawHtsCode": "5407.44.00.30",
      "superior": null,
      "indent": "3",
      "description": "Weighing not more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.44.0060",
      "rawHtsCode": "5407.44.00.60",
      "superior": null,
      "indent": "3",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.51.00",
      "rawHtsCode": "5407.51.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.51.0020",
      "rawHtsCode": "5407.51.00.20",
      "superior": null,
      "indent": "4",
      "description": "Flat fabrics (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.51.0040",
      "rawHtsCode": "5407.51.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.51.0060",
      "rawHtsCode": "5407.51.00.60",
      "superior": null,
      "indent": "3",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.52",
      "rawHtsCode": "5407.52",
      "superior": null,
      "indent": "2",
      "description": "Dyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.52.0500",
      "rawHtsCode": "5407.52.05.00",
      "superior": null,
      "indent": "3",
      "description": "Measuring less than 77 cm in width or less than 77 cm between selvages, the thread count of which per cm (treating multiple (folded) or cabled yarns as single threads) is over 69 but not over 142 in the warp and over 31 but not over 71 in the filling (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "18.9¢/kg + 17.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.52.20",
      "rawHtsCode": "5407.52.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.52.2020",
      "rawHtsCode": "5407.52.20.20",
      "superior": null,
      "indent": "5",
      "description": "Flat fabrics (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.52.2040",
      "rawHtsCode": "5407.52.20.40",
      "superior": null,
      "indent": "5",
      "description": "Other (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.52.2060",
      "rawHtsCode": "5407.52.20.60",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.53",
      "rawHtsCode": "5407.53",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.53.1000",
      "rawHtsCode": "5407.53.10.00",
      "superior": null,
      "indent": "3",
      "description": "The thread count of which per cm (treating multiple (folded) or cabled yarns as single threads) is over 69 but not over 142 in the warp and over 31 but not over 71 in the filling (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "18.8¢/kg + 17.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.53.20",
      "rawHtsCode": "5407.53.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.53.2020",
      "rawHtsCode": "5407.53.20.20",
      "superior": null,
      "indent": "5",
      "description": "Flat fabrics (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.53.2040",
      "rawHtsCode": "5407.53.20.40",
      "superior": null,
      "indent": "5",
      "description": "Other (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.53.2060",
      "rawHtsCode": "5407.53.20.60",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.54.00",
      "rawHtsCode": "5407.54.00",
      "superior": null,
      "indent": "2",
      "description": "Printed",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.54.0020",
      "rawHtsCode": "5407.54.00.20",
      "superior": null,
      "indent": "4",
      "description": "Flat fabrics (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.54.0040",
      "rawHtsCode": "5407.54.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.54.0060",
      "rawHtsCode": "5407.54.00.60",
      "superior": null,
      "indent": "3",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61",
      "rawHtsCode": "5407.61",
      "superior": null,
      "indent": "2",
      "description": "Containing 85 percent or more by weight of non textured polyester filaments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61.1100",
      "rawHtsCode": "5407.61.11.00",
      "superior": null,
      "indent": "4",
      "description": "Wholly of polyester, of single yarns measuring not less than <il>75 decitex</il> but not more than <il>80 decitex</il>, having 24 filaments per yarn and with a twist of 900 or more turns per meter (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "19.4¢/kg + 18%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.61.1900",
      "rawHtsCode": "5407.61.19.00",
      "superior": null,
      "indent": "4",
      "description": "Other (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "19.4¢/kg + 18%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.61.2100",
      "rawHtsCode": "5407.61.21.00",
      "superior": null,
      "indent": "4",
      "description": "Wholly of polyester, of single yarns meas- uring not less than <il>75 decitex</il> but not more than <il>80 decitex</il>, having 24 filaments per yarn and with a twist of 900 or more turns per meter (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12.2¢/kg + 11.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.61.2900",
      "rawHtsCode": "5407.61.29.00",
      "superior": null,
      "indent": "4",
      "description": "Other (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12.2¢/kg + 11.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.61.9100",
      "rawHtsCode": "5407.61.91.00",
      "superior": null,
      "indent": "4",
      "description": "Wholly of polyester, of single yarns meas- uring not less than <il>75 decitex</il> but not more than <il>80 decitex</il>, having 24 filaments per yarn and with a twist of 900 or more turns per meter (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.61.99",
      "rawHtsCode": "5407.61.99",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.61.9905",
      "rawHtsCode": "5407.61.99.05",
      "superior": null,
      "indent": "7",
      "description": "Flat fabrics (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61.9910",
      "rawHtsCode": "5407.61.99.10",
      "superior": null,
      "indent": "7",
      "description": "Other (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61.9915",
      "rawHtsCode": "5407.61.99.15",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61.9925",
      "rawHtsCode": "5407.61.99.25",
      "superior": null,
      "indent": "7",
      "description": "Flat fabrics (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61.9930",
      "rawHtsCode": "5407.61.99.30",
      "superior": null,
      "indent": "7",
      "description": "Other (619)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61.9935",
      "rawHtsCode": "5407.61.99.35",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61.9945",
      "rawHtsCode": "5407.61.99.45",
      "superior": null,
      "indent": "7",
      "description": "Flat fabrics (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61.9950",
      "rawHtsCode": "5407.61.99.50",
      "superior": null,
      "indent": "7",
      "description": "Other (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61.9955",
      "rawHtsCode": "5407.61.99.55",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61.9965",
      "rawHtsCode": "5407.61.99.65",
      "superior": null,
      "indent": "7",
      "description": "Flat fabrics (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61.9970",
      "rawHtsCode": "5407.61.99.70",
      "superior": null,
      "indent": "7",
      "description": "Other (619)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.61.9975",
      "rawHtsCode": "5407.61.99.75",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.69",
      "rawHtsCode": "5407.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.69.10",
      "rawHtsCode": "5407.69.10",
      "superior": null,
      "indent": "3",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.69.1010",
      "rawHtsCode": "5407.69.10.10",
      "superior": null,
      "indent": "4",
      "description": "Weighing not more than 170 g/m² (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.69.1060",
      "rawHtsCode": "5407.69.10.60",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.69.20",
      "rawHtsCode": "5407.69.20",
      "superior": null,
      "indent": "3",
      "description": "Dyed",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.69.2010",
      "rawHtsCode": "5407.69.20.10",
      "superior": null,
      "indent": "4",
      "description": "Weighing not more than 170 g/m² (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.69.2060",
      "rawHtsCode": "5407.69.20.60",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.69.3000",
      "rawHtsCode": "5407.69.30.00",
      "superior": null,
      "indent": "4",
      "description": "The thread count of which per cm (treating multiple (folded) or cabled yarns as single threads) is over 69 but not over 142 in the warp and over 31 but not over 71 in the filling (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5407.69.40",
      "rawHtsCode": "5407.69.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.69.4010",
      "rawHtsCode": "5407.69.40.10",
      "superior": null,
      "indent": "5",
      "description": "Weighing not more than 170 g/m² (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.69.4060",
      "rawHtsCode": "5407.69.40.60",
      "superior": null,
      "indent": "5",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.69.90",
      "rawHtsCode": "5407.69.90",
      "superior": null,
      "indent": "3",
      "description": "Printed",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.69.9010",
      "rawHtsCode": "5407.69.90.10",
      "superior": null,
      "indent": "4",
      "description": "Weighing not more than 170 g/m² (619)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.69.9060",
      "rawHtsCode": "5407.69.90.60",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.71.00",
      "rawHtsCode": "5407.71.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.71.0015",
      "rawHtsCode": "5407.71.00.15",
      "superior": null,
      "indent": "3",
      "description": "Weighing not more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.71.0060",
      "rawHtsCode": "5407.71.00.60",
      "superior": null,
      "indent": "3",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.72.00",
      "rawHtsCode": "5407.72.00",
      "superior": null,
      "indent": "2",
      "description": "Dyed",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.72.0015",
      "rawHtsCode": "5407.72.00.15",
      "superior": null,
      "indent": "3",
      "description": "Weighing not more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.72.0060",
      "rawHtsCode": "5407.72.00.60",
      "superior": null,
      "indent": "3",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.73",
      "rawHtsCode": "5407.73",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.73.1000",
      "rawHtsCode": "5407.73.10.00",
      "superior": null,
      "indent": "3",
      "description": "The thread count of which per cm (treating multiple (folded) or cabled yarns as single threads) is over 69 but not over 142 in the warp and over 31 but not over 71 in the filling (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5407.73.20",
      "rawHtsCode": "5407.73.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.73.2015",
      "rawHtsCode": "5407.73.20.15",
      "superior": null,
      "indent": "4",
      "description": "Weighing not more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.73.2060",
      "rawHtsCode": "5407.73.20.60",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.74.00",
      "rawHtsCode": "5407.74.00",
      "superior": null,
      "indent": "2",
      "description": "Printed",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.74.0015",
      "rawHtsCode": "5407.74.00.15",
      "superior": null,
      "indent": "3",
      "description": "Weighing not more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.74.0060",
      "rawHtsCode": "5407.74.00.60",
      "superior": null,
      "indent": "3",
      "description": "Weighing more than 170 g/m² (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.81.00",
      "rawHtsCode": "5407.81.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.81.0010",
      "rawHtsCode": "5407.81.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.81.0020",
      "rawHtsCode": "5407.81.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.81.0030",
      "rawHtsCode": "5407.81.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.81.0040",
      "rawHtsCode": "5407.81.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.81.0090",
      "rawHtsCode": "5407.81.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.82.00",
      "rawHtsCode": "5407.82.00",
      "superior": null,
      "indent": "2",
      "description": "Dyed",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.82.0010",
      "rawHtsCode": "5407.82.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.82.0020",
      "rawHtsCode": "5407.82.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.82.0030",
      "rawHtsCode": "5407.82.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.82.0040",
      "rawHtsCode": "5407.82.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.82.0090",
      "rawHtsCode": "5407.82.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.83.00",
      "rawHtsCode": "5407.83.00",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.83.0010",
      "rawHtsCode": "5407.83.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.83.0020",
      "rawHtsCode": "5407.83.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.83.0030",
      "rawHtsCode": "5407.83.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.83.0040",
      "rawHtsCode": "5407.83.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.83.0090",
      "rawHtsCode": "5407.83.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.84.00",
      "rawHtsCode": "5407.84.00",
      "superior": null,
      "indent": "2",
      "description": "Printed",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.84.0010",
      "rawHtsCode": "5407.84.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.84.0020",
      "rawHtsCode": "5407.84.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.84.0030",
      "rawHtsCode": "5407.84.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.84.0040",
      "rawHtsCode": "5407.84.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.84.0090",
      "rawHtsCode": "5407.84.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.91",
      "rawHtsCode": "5407.91",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.91.05",
      "rawHtsCode": "5407.91.05",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.91.0510",
      "rawHtsCode": "5407.91.05.10",
      "superior": null,
      "indent": "5",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.91.0520",
      "rawHtsCode": "5407.91.05.20",
      "superior": null,
      "indent": "5",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.91.1000",
      "rawHtsCode": "5407.91.10.00",
      "superior": null,
      "indent": "4",
      "description": "Other (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.91.20",
      "rawHtsCode": "5407.91.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.91.2010",
      "rawHtsCode": "5407.91.20.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with artificial filaments (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.91.2020",
      "rawHtsCode": "5407.91.20.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.91.2030",
      "rawHtsCode": "5407.91.20.30",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.91.2040",
      "rawHtsCode": "5407.91.20.40",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.91.2050",
      "rawHtsCode": "5407.91.20.50",
      "superior": null,
      "indent": "5",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.91.2090",
      "rawHtsCode": "5407.91.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.92",
      "rawHtsCode": "5407.92",
      "superior": null,
      "indent": "2",
      "description": "Dyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.92.05",
      "rawHtsCode": "5407.92.05",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.92.0510",
      "rawHtsCode": "5407.92.05.10",
      "superior": null,
      "indent": "5",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.92.0520",
      "rawHtsCode": "5407.92.05.20",
      "superior": null,
      "indent": "5",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.92.10",
      "rawHtsCode": "5407.92.10",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.92.1010",
      "rawHtsCode": "5407.92.10.10",
      "superior": null,
      "indent": "5",
      "description": "Not combed (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.92.1020",
      "rawHtsCode": "5407.92.10.20",
      "superior": null,
      "indent": "5",
      "description": "Combed (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.92.20",
      "rawHtsCode": "5407.92.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.92.2010",
      "rawHtsCode": "5407.92.20.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with artificial filaments or metalized yarn (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.92.2020",
      "rawHtsCode": "5407.92.20.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.92.2030",
      "rawHtsCode": "5407.92.20.30",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.92.2040",
      "rawHtsCode": "5407.92.20.40",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.92.2050",
      "rawHtsCode": "5407.92.20.50",
      "superior": null,
      "indent": "5",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.92.2090",
      "rawHtsCode": "5407.92.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.93",
      "rawHtsCode": "5407.93",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.93.05",
      "rawHtsCode": "5407.93.05",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.93.0510",
      "rawHtsCode": "5407.93.05.10",
      "superior": null,
      "indent": "5",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.93.0520",
      "rawHtsCode": "5407.93.05.20",
      "superior": null,
      "indent": "5",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.93.1000",
      "rawHtsCode": "5407.93.10.00",
      "superior": null,
      "indent": "4",
      "description": "Other (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.93.1500",
      "rawHtsCode": "5407.93.15.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 85 percent or more by weight of man-made filaments, the thread count of which per cm (treating multiple (folded) or cabled yarns as single threads) is over 69 but not over 142 in the warp and over 31 but not over 71 in the filling (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5407.93.20",
      "rawHtsCode": "5407.93.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.93.2010",
      "rawHtsCode": "5407.93.20.10",
      "superior": null,
      "indent": "5",
      "description": "Mixed mainly or solely with artificial filaments or metalized yarn (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.93.2020",
      "rawHtsCode": "5407.93.20.20",
      "superior": null,
      "indent": "6",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.93.2030",
      "rawHtsCode": "5407.93.20.30",
      "superior": null,
      "indent": "6",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.93.2040",
      "rawHtsCode": "5407.93.20.40",
      "superior": null,
      "indent": "6",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.93.2050",
      "rawHtsCode": "5407.93.20.50",
      "superior": null,
      "indent": "6",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.93.2090",
      "rawHtsCode": "5407.93.20.90",
      "superior": null,
      "indent": "6",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.94",
      "rawHtsCode": "5407.94",
      "superior": null,
      "indent": "2",
      "description": "Printed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.94.05",
      "rawHtsCode": "5407.94.05",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5407.94.0510",
      "rawHtsCode": "5407.94.05.10",
      "superior": null,
      "indent": "5",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.94.0520",
      "rawHtsCode": "5407.94.05.20",
      "superior": null,
      "indent": "5",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.94.1000",
      "rawHtsCode": "5407.94.10.00",
      "superior": null,
      "indent": "4",
      "description": "Other (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.94.20",
      "rawHtsCode": "5407.94.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5407.94.2010",
      "rawHtsCode": "5407.94.20.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with artificial filaments or metalized yarns (620)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.94.2020",
      "rawHtsCode": "5407.94.20.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.94.2030",
      "rawHtsCode": "5407.94.20.30",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.94.2040",
      "rawHtsCode": "5407.94.20.40",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.94.2050",
      "rawHtsCode": "5407.94.20.50",
      "superior": null,
      "indent": "5",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5407.94.2090",
      "rawHtsCode": "5407.94.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408",
      "rawHtsCode": "5408",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of artificial filament yarn, including woven fabrics obtained from materials of heading 5405:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.10.0000",
      "rawHtsCode": "5408.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Woven fabrics obtained from high tenacity yarn of viscose rayon (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.21.00",
      "rawHtsCode": "5408.21.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.21.0030",
      "rawHtsCode": "5408.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Weighing not more than 170 g/m² (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.21.0060",
      "rawHtsCode": "5408.21.00.60",
      "superior": null,
      "indent": "3",
      "description": "Weighing more than 170 g/m² (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.22",
      "rawHtsCode": "5408.22",
      "superior": null,
      "indent": "2",
      "description": "Dyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.22.1000",
      "rawHtsCode": "5408.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of cuprammonium rayon (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.22.90",
      "rawHtsCode": "5408.22.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.22.9030",
      "rawHtsCode": "5408.22.90.30",
      "superior": null,
      "indent": "4",
      "description": "Weighing not more than 170 g/m² (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.22.9060",
      "rawHtsCode": "5408.22.90.60",
      "superior": null,
      "indent": "4",
      "description": "Weighing more than 170 g/m² (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.23",
      "rawHtsCode": "5408.23",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.23.1100",
      "rawHtsCode": "5408.23.11.00",
      "superior": null,
      "indent": "4",
      "description": "Of cuprammonium rayon (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5408.23.1900",
      "rawHtsCode": "5408.23.19.00",
      "superior": null,
      "indent": "4",
      "description": "Other (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5408.23.2100",
      "rawHtsCode": "5408.23.21.00",
      "superior": null,
      "indent": "4",
      "description": "Of cuprammonium rayon (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.23.29",
      "rawHtsCode": "5408.23.29",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.23.2930",
      "rawHtsCode": "5408.23.29.30",
      "superior": null,
      "indent": "5",
      "description": "Weighing not more than 170 g/m² (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.23.2960",
      "rawHtsCode": "5408.23.29.60",
      "superior": null,
      "indent": "5",
      "description": "Weighing more than 170 g/m² (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.24",
      "rawHtsCode": "5408.24",
      "superior": null,
      "indent": "2",
      "description": "Printed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.24.1000",
      "rawHtsCode": "5408.24.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of cuprammonium rayon (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.24.90",
      "rawHtsCode": "5408.24.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.24.9010",
      "rawHtsCode": "5408.24.90.10",
      "superior": null,
      "indent": "5",
      "description": "Discharge printed (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.24.9020",
      "rawHtsCode": "5408.24.90.20",
      "superior": null,
      "indent": "5",
      "description": "Other (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.24.9040",
      "rawHtsCode": "5408.24.90.40",
      "superior": null,
      "indent": "5",
      "description": "Discharge printed (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.24.9050",
      "rawHtsCode": "5408.24.90.50",
      "superior": null,
      "indent": "5",
      "description": "Other (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.31",
      "rawHtsCode": "5408.31",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.31.05",
      "rawHtsCode": "5408.31.05",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.31.0510",
      "rawHtsCode": "5408.31.05.10",
      "superior": null,
      "indent": "5",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.31.0520",
      "rawHtsCode": "5408.31.05.20",
      "superior": null,
      "indent": "5",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.31.1000",
      "rawHtsCode": "5408.31.10.00",
      "superior": null,
      "indent": "4",
      "description": "Other (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.31.20",
      "rawHtsCode": "5408.31.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.31.2010",
      "rawHtsCode": "5408.31.20.10",
      "superior": null,
      "indent": "4",
      "description": "Mixed mainly or solely with synthetic filaments (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.31.2020",
      "rawHtsCode": "5408.31.20.20",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.31.2030",
      "rawHtsCode": "5408.31.20.30",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.31.2040",
      "rawHtsCode": "5408.31.20.40",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.31.2050",
      "rawHtsCode": "5408.31.20.50",
      "superior": null,
      "indent": "5",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.31.2090",
      "rawHtsCode": "5408.31.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.32",
      "rawHtsCode": "5408.32",
      "superior": null,
      "indent": "2",
      "description": "Dyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.32.05",
      "rawHtsCode": "5408.32.05",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "19.7%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.32.0510",
      "rawHtsCode": "5408.32.05.10",
      "superior": null,
      "indent": "5",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.32.0520",
      "rawHtsCode": "5408.32.05.20",
      "superior": null,
      "indent": "5",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.32.1000",
      "rawHtsCode": "5408.32.10.00",
      "superior": null,
      "indent": "4",
      "description": "Other (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.32.3000",
      "rawHtsCode": "5408.32.30.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 30 percent or more by weight of silk or silk waste, valued over <il>$33 per kg</il> (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "6.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.32.90",
      "rawHtsCode": "5408.32.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "15%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.32.9010",
      "rawHtsCode": "5408.32.90.10",
      "superior": null,
      "indent": "5",
      "description": "Mixed mainly or solely with synthetic filaments (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.32.9020",
      "rawHtsCode": "5408.32.90.20",
      "superior": null,
      "indent": "6",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.32.9030",
      "rawHtsCode": "5408.32.90.30",
      "superior": null,
      "indent": "6",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.32.9040",
      "rawHtsCode": "5408.32.90.40",
      "superior": null,
      "indent": "6",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.32.9050",
      "rawHtsCode": "5408.32.90.50",
      "superior": null,
      "indent": "6",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.32.9090",
      "rawHtsCode": "5408.32.90.90",
      "superior": null,
      "indent": "6",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.33",
      "rawHtsCode": "5408.33",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.33.05",
      "rawHtsCode": "5408.33.05",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "19.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.33.0510",
      "rawHtsCode": "5408.33.05.10",
      "superior": null,
      "indent": "5",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.33.0520",
      "rawHtsCode": "5408.33.05.20",
      "superior": null,
      "indent": "5",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.33.1000",
      "rawHtsCode": "5408.33.10.00",
      "superior": null,
      "indent": "4",
      "description": "Other (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.33.1500",
      "rawHtsCode": "5408.33.15.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 85 percent or more by weight of man-made filaments, the thread count of which per cm (treating multiple (folded) or cabled yarns as single threads) is over 69 but not over 142 in the warp and over 31 but not over 71 in the filling (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12.3¢/kg + 11.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "24.3¢/kg + 81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.33.3000",
      "rawHtsCode": "5408.33.30.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 30 percent or more by weight of silk or silk waste, valued over <il>$33 per kg</il> (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "6.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.33.90",
      "rawHtsCode": "5408.33.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.33.9010",
      "rawHtsCode": "5408.33.90.10",
      "superior": null,
      "indent": "5",
      "description": "Mixed mainly or solely with synthetic filaments or metalized yarn (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.33.9020",
      "rawHtsCode": "5408.33.90.20",
      "superior": null,
      "indent": "6",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.33.9030",
      "rawHtsCode": "5408.33.90.30",
      "superior": null,
      "indent": "6",
      "description": "Sheeting(627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.33.9040",
      "rawHtsCode": "5408.33.90.40",
      "superior": null,
      "indent": "6",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.33.9050",
      "rawHtsCode": "5408.33.90.50",
      "superior": null,
      "indent": "6",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.33.9090",
      "rawHtsCode": "5408.33.90.90",
      "superior": null,
      "indent": "6",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.34",
      "rawHtsCode": "5408.34",
      "superior": null,
      "indent": "2",
      "description": "Printed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.34.05",
      "rawHtsCode": "5408.34.05",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "5408.34.0510",
      "rawHtsCode": "5408.34.05.10",
      "superior": null,
      "indent": "5",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.34.0520",
      "rawHtsCode": "5408.34.05.20",
      "superior": null,
      "indent": "5",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.34.1000",
      "rawHtsCode": "5408.34.10.00",
      "superior": null,
      "indent": "4",
      "description": "Other (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.34.3000",
      "rawHtsCode": "5408.34.30.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 30 percent or more by weight of silk or silk waste, valued over $33 per kg (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5408.34.90",
      "rawHtsCode": "5408.34.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5408.34.9010",
      "rawHtsCode": "5408.34.90.10",
      "superior": null,
      "indent": "5",
      "description": "Mixed mainly or solely with synthetic filaments (618)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.34.9020",
      "rawHtsCode": "5408.34.90.20",
      "superior": null,
      "indent": "6",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.34.9030",
      "rawHtsCode": "5408.34.90.30",
      "superior": null,
      "indent": "6",
      "description": "Sheeting(627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.34.9040",
      "rawHtsCode": "5408.34.90.40",
      "superior": null,
      "indent": "6",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.34.9050",
      "rawHtsCode": "5408.34.90.50",
      "superior": null,
      "indent": "6",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.34.9085",
      "rawHtsCode": "5408.34.90.85",
      "superior": null,
      "indent": "7",
      "description": "Discharge printed (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5408.34.9095",
      "rawHtsCode": "5408.34.90.95",
      "superior": null,
      "indent": "7",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5501",
      "rawHtsCode": "5501",
      "superior": null,
      "indent": "0",
      "description": "Synthetic filament tow:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5501.11.0000",
      "rawHtsCode": "5501.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of aramids",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5501.19.0000",
      "rawHtsCode": "5501.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5501.20.0000",
      "rawHtsCode": "5501.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of polyesters",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5501.30.00",
      "rawHtsCode": "5501.30.00",
      "superior": null,
      "indent": "1",
      "description": "Acrylic or modacrylic",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5501.30.0010",
      "rawHtsCode": "5501.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Containing 92 percent or more by weight of acrylonitrile units with filaments numbering fewer than 70,000 (+/-2000) with filament diameter <il>1.59 decitex</il> (plus or minus 0.027) or less, or in a separable tow construction capable of being separated into tows of 70,000 (+/-2000) or fewer with filament diameter <il>1.59 decitex</il> (plus or minus 0.027) or less.",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5501.30.0090",
      "rawHtsCode": "5501.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5501.40.0000",
      "rawHtsCode": "5501.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of polypropylene",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5501.90.0100",
      "rawHtsCode": "5501.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5502",
      "rawHtsCode": "5502",
      "superior": null,
      "indent": "0",
      "description": "Artificial filament tow:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5502.10.0000",
      "rawHtsCode": "5502.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of cellulose acetate",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5502.90.0000",
      "rawHtsCode": "5502.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5503",
      "rawHtsCode": "5503",
      "superior": null,
      "indent": "0",
      "description": "Synthetic staple fibers, not carded, combed or otherwise processed for spinning:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5503.11.0000",
      "rawHtsCode": "5503.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of aramids",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5503.19",
      "rawHtsCode": "5503.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5503.19.1000",
      "rawHtsCode": "5503.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 10 percent or more by weight of nylon 12",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5503.19.9000",
      "rawHtsCode": "5503.19.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5503.20.00",
      "rawHtsCode": "5503.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of polyesters",
      "units": [],
      "generalRate": "4.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.55.01 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5503.20.0015",
      "rawHtsCode": "5503.20.00.15",
      "superior": null,
      "indent": "2",
      "description": "Bi-component fibers having an outer copolymer sheath that melts at a lower temperature than the core, of a kind used for bonding fibers together",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5503.20.0025",
      "rawHtsCode": "5503.20.00.25",
      "superior": null,
      "indent": "3",
      "description": "Measuring less than 3.3 decitex",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5503.20.0045",
      "rawHtsCode": "5503.20.00.45",
      "superior": null,
      "indent": "3",
      "description": "Measuring 3.3 decitex or more but less than <il>13.2 decitex</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5503.20.0065",
      "rawHtsCode": "5503.20.00.65",
      "superior": null,
      "indent": "3",
      "description": "Measuring <il>13.2 decitex</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5503.30.0000",
      "rawHtsCode": "5503.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Acrylic or modacrylic",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5503.40.0000",
      "rawHtsCode": "5503.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of polypropylene",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5503.90",
      "rawHtsCode": "5503.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5503.90.1000",
      "rawHtsCode": "5503.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of vinyon",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5503.90.9000",
      "rawHtsCode": "5503.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5504",
      "rawHtsCode": "5504",
      "superior": null,
      "indent": "0",
      "description": "Artificial staple fibers, not carded, combed or otherwise processed for spinning:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5504.10.0000",
      "rawHtsCode": "5504.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of viscose rayon",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5504.90.0000",
      "rawHtsCode": "5504.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5505",
      "rawHtsCode": "5505",
      "superior": null,
      "indent": "0",
      "description": "Waste (including noils, yarn waste and garnetted stock) of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5505.10.00",
      "rawHtsCode": "5505.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of synthetic fibers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5505.10.0020",
      "rawHtsCode": "5505.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Of nylon or other polyamides",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5505.10.0040",
      "rawHtsCode": "5505.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Of polyesters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5505.10.0060",
      "rawHtsCode": "5505.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5505.20.0000",
      "rawHtsCode": "5505.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of artificial fibers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5506",
      "rawHtsCode": "5506",
      "superior": null,
      "indent": "0",
      "description": "Synthetic staple fibers, carded, combed or otherwise processed for spinning:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5506.10.0000",
      "rawHtsCode": "5506.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of nylon or other polyamides",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5506.20.0000",
      "rawHtsCode": "5506.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of polyesters",
      "units": [
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5506.30.0000",
      "rawHtsCode": "5506.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Acrylic or modacrylic",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5506.40.0000",
      "rawHtsCode": "5506.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of polypropylene",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5506.90.0100",
      "rawHtsCode": "5506.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5507.00.0000",
      "rawHtsCode": "5507.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Artificial staple fibers, carded, combed or otherwise processed for spinning",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5508",
      "rawHtsCode": "5508",
      "superior": null,
      "indent": "0",
      "description": "Sewing thread of man-made staple fibers, whether or not put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5508.10.0000",
      "rawHtsCode": "5508.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of synthetic staple fibers (200)",
      "units": [
        "kg"
      ],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5508.20.0000",
      "rawHtsCode": "5508.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of artificial staple fibers (200)",
      "units": [
        "kg"
      ],
      "generalRate": "11%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509",
      "rawHtsCode": "5509",
      "superior": null,
      "indent": "0",
      "description": "Yarn (other than sewing thread) of synthetic staple fibers, not put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5509.11.0000",
      "rawHtsCode": "5509.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Single yarn (604)",
      "units": [
        "kg"
      ],
      "generalRate": "9.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.12.0000",
      "rawHtsCode": "5509.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Multiple (folded) or cabled yarn (604)",
      "units": [
        "kg"
      ],
      "generalRate": "10.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.21.0000",
      "rawHtsCode": "5509.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Single yarn (604)",
      "units": [
        "kg"
      ],
      "generalRate": "9.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.22.00",
      "rawHtsCode": "5509.22.00",
      "superior": null,
      "indent": "2",
      "description": "Multiple (folded) or cabled yarn",
      "units": [],
      "generalRate": "10.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.22.0010",
      "rawHtsCode": "5509.22.00.10",
      "superior": null,
      "indent": "3",
      "description": "Multiple (folded), with a final \"Z\" twist (200)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5509.22.0090",
      "rawHtsCode": "5509.22.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (604)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5509.31.0000",
      "rawHtsCode": "5509.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Single yarn (604)",
      "units": [
        "kg"
      ],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.32.0000",
      "rawHtsCode": "5509.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Multiple (folded) or cabled yarn (604)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.41.00",
      "rawHtsCode": "5509.41.00",
      "superior": null,
      "indent": "2",
      "description": "Single yarn",
      "units": [],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.41.0010",
      "rawHtsCode": "5509.41.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of polyvinyl alcohol (PVA) fibers (604)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5509.41.0090",
      "rawHtsCode": "5509.41.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (604)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5509.42.00",
      "rawHtsCode": "5509.42.00",
      "superior": null,
      "indent": "2",
      "description": "Multiple (folded) or cabled yarn",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.42.0010",
      "rawHtsCode": "5509.42.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of polyvinyl alcohol (PVA) fibers (604)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5509.42.0090",
      "rawHtsCode": "5509.42.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (604)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5509.51",
      "rawHtsCode": "5509.51",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with artificial staple fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5509.51.3000",
      "rawHtsCode": "5509.51.30.00",
      "superior": null,
      "indent": "3",
      "description": "Single yarn (607)",
      "units": [
        "kg"
      ],
      "generalRate": "9.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.51.6000",
      "rawHtsCode": "5509.51.60.00",
      "superior": null,
      "indent": "3",
      "description": "Multiple (folded) or cabled yarn (607)",
      "units": [
        "kg"
      ],
      "generalRate": "10.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.52.0000",
      "rawHtsCode": "5509.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with wool or fine animal hair (607)",
      "units": [
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.53.00",
      "rawHtsCode": "5509.53.00",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with cotton",
      "units": [],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.53.0030",
      "rawHtsCode": "5509.53.00.30",
      "superior": null,
      "indent": "3",
      "description": "Not exceeding 52 nm (607)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5509.53.0060",
      "rawHtsCode": "5509.53.00.60",
      "superior": null,
      "indent": "3",
      "description": "Exceeding 52 nm (607)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5509.59.0000",
      "rawHtsCode": "5509.59.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other (607)",
      "units": [
        "kg"
      ],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.61.0000",
      "rawHtsCode": "5509.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with wool or fine animal hair (607)",
      "units": [
        "kg"
      ],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.62.0000",
      "rawHtsCode": "5509.62.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with cotton (607)",
      "units": [
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.69",
      "rawHtsCode": "5509.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5509.69.2000",
      "rawHtsCode": "5509.69.20.00",
      "superior": null,
      "indent": "4",
      "description": "Single yarn (607)",
      "units": [
        "kg"
      ],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.69.4000",
      "rawHtsCode": "5509.69.40.00",
      "superior": null,
      "indent": "4",
      "description": "Multiple (folded) or cabled yarn (607)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.69.6000",
      "rawHtsCode": "5509.69.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other (607)",
      "units": [
        "kg"
      ],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.91.0000",
      "rawHtsCode": "5509.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with wool or fine animal hair (607)",
      "units": [
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.92.0000",
      "rawHtsCode": "5509.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with cotton (607)",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.99",
      "rawHtsCode": "5509.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5509.99.2000",
      "rawHtsCode": "5509.99.20.00",
      "superior": null,
      "indent": "4",
      "description": "Single yarn (607)",
      "units": [
        "kg"
      ],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.99.4000",
      "rawHtsCode": "5509.99.40.00",
      "superior": null,
      "indent": "4",
      "description": "Multiple (folded) or cabled yarn (607)",
      "units": [
        "kg"
      ],
      "generalRate": "10.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5509.99.6000",
      "rawHtsCode": "5509.99.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other (607)",
      "units": [
        "kg"
      ],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5510",
      "rawHtsCode": "5510",
      "superior": null,
      "indent": "0",
      "description": "Yarn (other than sewing thread) of artificial staple fibers, not put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5510.11.0000",
      "rawHtsCode": "5510.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Single yarn (603)",
      "units": [
        "kg"
      ],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5510.12.0000",
      "rawHtsCode": "5510.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Multiple (folded) or cabled yarn (603)",
      "units": [
        "kg"
      ],
      "generalRate": "10.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5510.20.0000",
      "rawHtsCode": "5510.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other yarn, mixed mainly or solely with wool or fine animal hair (607)",
      "units": [
        "kg"
      ],
      "generalRate": "10.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5510.30.0000",
      "rawHtsCode": "5510.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other yarn, mixed mainly or solely with cotton (607)",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5510.90",
      "rawHtsCode": "5510.90",
      "superior": null,
      "indent": "1",
      "description": "Other yarn:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5510.90.2000",
      "rawHtsCode": "5510.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Single yarn (607)",
      "units": [
        "kg"
      ],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5510.90.4000",
      "rawHtsCode": "5510.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Multiple (folded) or cabled yarn (607)",
      "units": [
        "kg"
      ],
      "generalRate": "10.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5510.90.6000",
      "rawHtsCode": "5510.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other (607)",
      "units": [
        "kg"
      ],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5511",
      "rawHtsCode": "5511",
      "superior": null,
      "indent": "0",
      "description": "Yarn (other than sewing thread) of man-made staple fibers, put up for retail sale:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5511.10.00",
      "rawHtsCode": "5511.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of synthetic staple fibers, containing 85 percent or more by weight of such fibers",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5511.10.0030",
      "rawHtsCode": "5511.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Acrylic or modacrylic (200)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5511.10.0060",
      "rawHtsCode": "5511.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other (200)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5511.20.0000",
      "rawHtsCode": "5511.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of synthetic staple fibers, containing less than 85 percent by weight of such fibers (200)",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5511.30.0000",
      "rawHtsCode": "5511.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of artificial staple fibers (200)",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5512",
      "rawHtsCode": "5512",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of synthetic staple fibers, containing 85 percent or more by weight of synthetic staple fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.11.00",
      "rawHtsCode": "5512.11.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5512.11.0010",
      "rawHtsCode": "5512.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.11.0022",
      "rawHtsCode": "5512.11.00.22",
      "superior": null,
      "indent": "4",
      "description": "Of a width exceeding 254 cm (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.11.0027",
      "rawHtsCode": "5512.11.00.27",
      "superior": null,
      "indent": "4",
      "description": "Other (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.11.0030",
      "rawHtsCode": "5512.11.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.11.0040",
      "rawHtsCode": "5512.11.00.40",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.11.0050",
      "rawHtsCode": "5512.11.00.50",
      "superior": null,
      "indent": "3",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.11.0060",
      "rawHtsCode": "5512.11.00.60",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.11.0070",
      "rawHtsCode": "5512.11.00.70",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.11.0090",
      "rawHtsCode": "5512.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.19.00",
      "rawHtsCode": "5512.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5512.19.0005",
      "rawHtsCode": "5512.19.00.05",
      "superior": null,
      "indent": "3",
      "description": "Of yarns of different colors, except blue denim or jacquard weave (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.19.0010",
      "rawHtsCode": "5512.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Blue denim (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.19.0015",
      "rawHtsCode": "5512.19.00.15",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.19.0022",
      "rawHtsCode": "5512.19.00.22",
      "superior": null,
      "indent": "5",
      "description": "Of a width exceeding 254 cm (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.19.0027",
      "rawHtsCode": "5512.19.00.27",
      "superior": null,
      "indent": "5",
      "description": "Other (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.19.0030",
      "rawHtsCode": "5512.19.00.30",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.19.0035",
      "rawHtsCode": "5512.19.00.35",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.19.0040",
      "rawHtsCode": "5512.19.00.40",
      "superior": null,
      "indent": "4",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.19.0045",
      "rawHtsCode": "5512.19.00.45",
      "superior": null,
      "indent": "4",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.19.0050",
      "rawHtsCode": "5512.19.00.50",
      "superior": null,
      "indent": "4",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.19.0090",
      "rawHtsCode": "5512.19.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.21.00",
      "rawHtsCode": "5512.21.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5512.21.0010",
      "rawHtsCode": "5512.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.21.0020",
      "rawHtsCode": "5512.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.21.0030",
      "rawHtsCode": "5512.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.21.0040",
      "rawHtsCode": "5512.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.21.0050",
      "rawHtsCode": "5512.21.00.50",
      "superior": null,
      "indent": "3",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.21.0060",
      "rawHtsCode": "5512.21.00.60",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.21.0070",
      "rawHtsCode": "5512.21.00.70",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.21.0090",
      "rawHtsCode": "5512.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.29.00",
      "rawHtsCode": "5512.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5512.29.0005",
      "rawHtsCode": "5512.29.00.05",
      "superior": null,
      "indent": "3",
      "description": "Of yarns of different colors, except blue denim or jacquard weave (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.29.0010",
      "rawHtsCode": "5512.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Blue denim (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.29.0015",
      "rawHtsCode": "5512.29.00.15",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.29.0020",
      "rawHtsCode": "5512.29.00.20",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.29.0025",
      "rawHtsCode": "5512.29.00.25",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.29.0030",
      "rawHtsCode": "5512.29.00.30",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.29.0035",
      "rawHtsCode": "5512.29.00.35",
      "superior": null,
      "indent": "4",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.29.0040",
      "rawHtsCode": "5512.29.00.40",
      "superior": null,
      "indent": "4",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.29.0045",
      "rawHtsCode": "5512.29.00.45",
      "superior": null,
      "indent": "4",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.29.0090",
      "rawHtsCode": "5512.29.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.91.00",
      "rawHtsCode": "5512.91.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5512.91.0010",
      "rawHtsCode": "5512.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.91.0020",
      "rawHtsCode": "5512.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.91.0030",
      "rawHtsCode": "5512.91.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.91.0040",
      "rawHtsCode": "5512.91.00.40",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.91.0050",
      "rawHtsCode": "5512.91.00.50",
      "superior": null,
      "indent": "3",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.91.0060",
      "rawHtsCode": "5512.91.00.60",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.91.0070",
      "rawHtsCode": "5512.91.00.70",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.91.0090",
      "rawHtsCode": "5512.91.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.99.00",
      "rawHtsCode": "5512.99.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5512.99.0005",
      "rawHtsCode": "5512.99.00.05",
      "superior": null,
      "indent": "3",
      "description": "Of yarns of different colors, except blue denim or jacquard weave (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.99.0010",
      "rawHtsCode": "5512.99.00.10",
      "superior": null,
      "indent": "3",
      "description": "Blue denim (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.99.0015",
      "rawHtsCode": "5512.99.00.15",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.99.0020",
      "rawHtsCode": "5512.99.00.20",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.99.0025",
      "rawHtsCode": "5512.99.00.25",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.99.0030",
      "rawHtsCode": "5512.99.00.30",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.99.0035",
      "rawHtsCode": "5512.99.00.35",
      "superior": null,
      "indent": "4",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.99.0040",
      "rawHtsCode": "5512.99.00.40",
      "superior": null,
      "indent": "4",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.99.0045",
      "rawHtsCode": "5512.99.00.45",
      "superior": null,
      "indent": "4",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5512.99.0090",
      "rawHtsCode": "5512.99.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513",
      "rawHtsCode": "5513",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of synthetic staple fibers, containing less than 85 percent by weight of such fibers, mixed mainly or solely with cotton, of a weight not exceeding 170 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.11.00",
      "rawHtsCode": "5513.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of polyester staple fibers, plain weave",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.11.0020",
      "rawHtsCode": "5513.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.11.0040",
      "rawHtsCode": "5513.11.00.40",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.11.0060",
      "rawHtsCode": "5513.11.00.60",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.11.0090",
      "rawHtsCode": "5513.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.12.0000",
      "rawHtsCode": "5513.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill, of polyester staple fibers (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.13.00",
      "rawHtsCode": "5513.13.00",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics of polyester staple fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.13.0020",
      "rawHtsCode": "5513.13.00.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.13.0040",
      "rawHtsCode": "5513.13.00.40",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.13.0090",
      "rawHtsCode": "5513.13.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.19.00",
      "rawHtsCode": "5513.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.19.0010",
      "rawHtsCode": "5513.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.19.0020",
      "rawHtsCode": "5513.19.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.19.0030",
      "rawHtsCode": "5513.19.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.19.0040",
      "rawHtsCode": "5513.19.00.40",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.19.0050",
      "rawHtsCode": "5513.19.00.50",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.19.0060",
      "rawHtsCode": "5513.19.00.60",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.19.0090",
      "rawHtsCode": "5513.19.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.21.00",
      "rawHtsCode": "5513.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of polyester staple fibers, plain weave",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.21.0020",
      "rawHtsCode": "5513.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.21.0040",
      "rawHtsCode": "5513.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.21.0060",
      "rawHtsCode": "5513.21.00.60",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.21.0090",
      "rawHtsCode": "5513.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.23.01",
      "rawHtsCode": "5513.23.01",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics of polyester staple fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.23.0121",
      "rawHtsCode": "5513.23.01.21",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.23.0141",
      "rawHtsCode": "5513.23.01.41",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.23.0191",
      "rawHtsCode": "5513.23.01.91",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.29.00",
      "rawHtsCode": "5513.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.29.0010",
      "rawHtsCode": "5513.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.29.0020",
      "rawHtsCode": "5513.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.29.0030",
      "rawHtsCode": "5513.29.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.29.0040",
      "rawHtsCode": "5513.29.00.40",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.29.0050",
      "rawHtsCode": "5513.29.00.50",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.29.0060",
      "rawHtsCode": "5513.29.00.60",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.29.0090",
      "rawHtsCode": "5513.29.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.31.0000",
      "rawHtsCode": "5513.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of polyester staple fibers, plain weave (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.39.01",
      "rawHtsCode": "5513.39.01",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.39.0111",
      "rawHtsCode": "5513.39.01.11",
      "superior": null,
      "indent": "3",
      "description": "Jacquard weave (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.39.0115",
      "rawHtsCode": "5513.39.01.15",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.39.0191",
      "rawHtsCode": "5513.39.01.91",
      "superior": null,
      "indent": "3",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.41.00",
      "rawHtsCode": "5513.41.00",
      "superior": null,
      "indent": "2",
      "description": "Of polyester staple fibers, plain weave",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.41.0020",
      "rawHtsCode": "5513.41.00.20",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.41.0040",
      "rawHtsCode": "5513.41.00.40",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.41.0060",
      "rawHtsCode": "5513.41.00.60",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.41.0090",
      "rawHtsCode": "5513.41.00.90",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.49",
      "rawHtsCode": "5513.49",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.49.1000",
      "rawHtsCode": "5513.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "3-thread or 4-thread twill, including cross twill, of polyester staple fibers (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.49.20",
      "rawHtsCode": "5513.49.20",
      "superior": null,
      "indent": "3",
      "description": "Other woven fabrics of polyester staple fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.49.2020",
      "rawHtsCode": "5513.49.20.20",
      "superior": null,
      "indent": "4",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.49.2040",
      "rawHtsCode": "5513.49.20.40",
      "superior": null,
      "indent": "4",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.49.2090",
      "rawHtsCode": "5513.49.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.49.90",
      "rawHtsCode": "5513.49.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5513.49.9010",
      "rawHtsCode": "5513.49.90.10",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.49.9020",
      "rawHtsCode": "5513.49.90.20",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.49.9030",
      "rawHtsCode": "5513.49.90.30",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.49.9040",
      "rawHtsCode": "5513.49.90.40",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.49.9050",
      "rawHtsCode": "5513.49.90.50",
      "superior": null,
      "indent": "4",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.49.9060",
      "rawHtsCode": "5513.49.90.60",
      "superior": null,
      "indent": "4",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5513.49.9090",
      "rawHtsCode": "5513.49.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514",
      "rawHtsCode": "5514",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of synthetic staple fibers, containing less than 85 percent by weight of such fibers, mixed mainly or solely with cotton, of a weight exceeding 170 g/m²:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.11.00",
      "rawHtsCode": "5514.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of polyester staple fibers, plain weave",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.11.0020",
      "rawHtsCode": "5514.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.11.0030",
      "rawHtsCode": "5514.11.00.30",
      "superior": null,
      "indent": "4",
      "description": "Not napped (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.11.0050",
      "rawHtsCode": "5514.11.00.50",
      "superior": null,
      "indent": "4",
      "description": "Napped (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.11.0090",
      "rawHtsCode": "5514.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Plain weave duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.12.00",
      "rawHtsCode": "5514.12.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill, of polyester staple fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.12.0020",
      "rawHtsCode": "5514.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not napped (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.12.0040",
      "rawHtsCode": "5514.12.00.40",
      "superior": null,
      "indent": "3",
      "description": "Napped (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.19",
      "rawHtsCode": "5514.19",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.19.10",
      "rawHtsCode": "5514.19.10",
      "superior": null,
      "indent": "3",
      "description": "Woven fabrics of polyester staple fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.19.1020",
      "rawHtsCode": "5514.19.10.20",
      "superior": null,
      "indent": "4",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.19.1040",
      "rawHtsCode": "5514.19.10.40",
      "superior": null,
      "indent": "4",
      "description": "Duck, except plain weave (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.19.1090",
      "rawHtsCode": "5514.19.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.19.90",
      "rawHtsCode": "5514.19.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.19.9010",
      "rawHtsCode": "5514.19.90.10",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.19.9020",
      "rawHtsCode": "5514.19.90.20",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.19.9030",
      "rawHtsCode": "5514.19.90.30",
      "superior": null,
      "indent": "4",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.19.9040",
      "rawHtsCode": "5514.19.90.40",
      "superior": null,
      "indent": "4",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.19.9090",
      "rawHtsCode": "5514.19.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.21.00",
      "rawHtsCode": "5514.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of polyester staple fibers, plain weave",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.21.0020",
      "rawHtsCode": "5514.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.21.0030",
      "rawHtsCode": "5514.21.00.30",
      "superior": null,
      "indent": "4",
      "description": "Not napped (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.21.0050",
      "rawHtsCode": "5514.21.00.50",
      "superior": null,
      "indent": "4",
      "description": "Napped (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.21.0090",
      "rawHtsCode": "5514.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Plain weave duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.22.00",
      "rawHtsCode": "5514.22.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill, of polyester staple fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.22.0020",
      "rawHtsCode": "5514.22.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not napped (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.22.0040",
      "rawHtsCode": "5514.22.00.40",
      "superior": null,
      "indent": "3",
      "description": "Napped (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.23.00",
      "rawHtsCode": "5514.23.00",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics of polyester staple fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.23.0020",
      "rawHtsCode": "5514.23.00.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.23.0040",
      "rawHtsCode": "5514.23.00.40",
      "superior": null,
      "indent": "3",
      "description": "Duck, except plain weave (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.23.0090",
      "rawHtsCode": "5514.23.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.29.00",
      "rawHtsCode": "5514.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.29.0010",
      "rawHtsCode": "5514.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.29.0020",
      "rawHtsCode": "5514.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.29.0030",
      "rawHtsCode": "5514.29.00.30",
      "superior": null,
      "indent": "3",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.29.0040",
      "rawHtsCode": "5514.29.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.29.0090",
      "rawHtsCode": "5514.29.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.30",
      "rawHtsCode": "5514.30",
      "superior": null,
      "indent": "1",
      "description": "Of yarns of different colors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.30.3100",
      "rawHtsCode": "5514.30.31.00",
      "superior": null,
      "indent": "2",
      "description": "Of polyester staple fibers, plain weave (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.30.32",
      "rawHtsCode": "5514.30.32",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill, of polyester staple fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.30.3210",
      "rawHtsCode": "5514.30.32.10",
      "superior": null,
      "indent": "4",
      "description": "Blue denim (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.30.3215",
      "rawHtsCode": "5514.30.32.15",
      "superior": null,
      "indent": "4",
      "description": "Other denim (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.30.3280",
      "rawHtsCode": "5514.30.32.80",
      "superior": null,
      "indent": "3",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.30.33",
      "rawHtsCode": "5514.30.33",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics of polyester staple fibers",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.30.3310",
      "rawHtsCode": "5514.30.33.10",
      "superior": null,
      "indent": "3",
      "description": "Jacquard weave (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.30.3390",
      "rawHtsCode": "5514.30.33.90",
      "superior": null,
      "indent": "3",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.30.39",
      "rawHtsCode": "5514.30.39",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5514.30.3910",
      "rawHtsCode": "5514.30.39.10",
      "superior": null,
      "indent": "3",
      "description": "Blue denim (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.30.3920",
      "rawHtsCode": "5514.30.39.20",
      "superior": null,
      "indent": "3",
      "description": "Jacquard weave (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.30.3990",
      "rawHtsCode": "5514.30.39.90",
      "superior": null,
      "indent": "3",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.41.00",
      "rawHtsCode": "5514.41.00",
      "superior": null,
      "indent": "2",
      "description": "Of polyester staple fibers, plain weave",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.41.0020",
      "rawHtsCode": "5514.41.00.20",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.41.0030",
      "rawHtsCode": "5514.41.00.30",
      "superior": null,
      "indent": "4",
      "description": "Not napped (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.41.0050",
      "rawHtsCode": "5514.41.00.50",
      "superior": null,
      "indent": "4",
      "description": "Napped (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.41.0090",
      "rawHtsCode": "5514.41.00.90",
      "superior": null,
      "indent": "3",
      "description": "Plain weave duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.42.00",
      "rawHtsCode": "5514.42.00",
      "superior": null,
      "indent": "2",
      "description": "3-thread or 4-thread twill, including cross twill, of polyester staple fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.42.0020",
      "rawHtsCode": "5514.42.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not napped (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.42.0040",
      "rawHtsCode": "5514.42.00.40",
      "superior": null,
      "indent": "3",
      "description": "Napped (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.43.00",
      "rawHtsCode": "5514.43.00",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics of polyester staple fibers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5514.43.0020",
      "rawHtsCode": "5514.43.00.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.43.0040",
      "rawHtsCode": "5514.43.00.40",
      "superior": null,
      "indent": "3",
      "description": "Duck, except plain weave (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.43.0090",
      "rawHtsCode": "5514.43.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.49.00",
      "rawHtsCode": "5514.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other woven fabrics",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5514.49.0010",
      "rawHtsCode": "5514.49.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.49.0020",
      "rawHtsCode": "5514.49.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.49.0030",
      "rawHtsCode": "5514.49.00.30",
      "superior": null,
      "indent": "3",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.49.0040",
      "rawHtsCode": "5514.49.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5514.49.0090",
      "rawHtsCode": "5514.49.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515",
      "rawHtsCode": "5515",
      "superior": null,
      "indent": "0",
      "description": "Other woven fabrics of synthetic staple fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.11.00",
      "rawHtsCode": "5515.11.00",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with viscose rayon staple fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5515.11.0005",
      "rawHtsCode": "5515.11.00.05",
      "superior": null,
      "indent": "3",
      "description": "Of yarns of different colors, except blue denim or jacquard weave (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.11.0010",
      "rawHtsCode": "5515.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Blue denim (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.11.0015",
      "rawHtsCode": "5515.11.00.15",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.11.0020",
      "rawHtsCode": "5515.11.00.20",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.11.0025",
      "rawHtsCode": "5515.11.00.25",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.11.0030",
      "rawHtsCode": "5515.11.00.30",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.11.0035",
      "rawHtsCode": "5515.11.00.35",
      "superior": null,
      "indent": "4",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.11.0040",
      "rawHtsCode": "5515.11.00.40",
      "superior": null,
      "indent": "4",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.11.0045",
      "rawHtsCode": "5515.11.00.45",
      "superior": null,
      "indent": "4",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.11.0090",
      "rawHtsCode": "5515.11.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.12.00",
      "rawHtsCode": "5515.12.00",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with man-made filaments",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5515.12.0010",
      "rawHtsCode": "5515.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.12.0022",
      "rawHtsCode": "5515.12.00.22",
      "superior": null,
      "indent": "4",
      "description": "Of a width exceeding 254 cm (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.12.0027",
      "rawHtsCode": "5515.12.00.27",
      "superior": null,
      "indent": "4",
      "description": "Other (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.12.0030",
      "rawHtsCode": "5515.12.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.12.0040",
      "rawHtsCode": "5515.12.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.12.0090",
      "rawHtsCode": "5515.12.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.13",
      "rawHtsCode": "5515.13",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.13.05",
      "rawHtsCode": "5515.13.05",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5515.13.0510",
      "rawHtsCode": "5515.13.05.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.13.0520",
      "rawHtsCode": "5515.13.05.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.13.10",
      "rawHtsCode": "5515.13.10",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5515.13.1010",
      "rawHtsCode": "5515.13.10.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.13.1020",
      "rawHtsCode": "5515.13.10.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.19.00",
      "rawHtsCode": "5515.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5515.19.0005",
      "rawHtsCode": "5515.19.00.05",
      "superior": null,
      "indent": "3",
      "description": "Of yarns of different colors, except blue denim or jacquard weave (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.19.0010",
      "rawHtsCode": "5515.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Blue denim (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.19.0015",
      "rawHtsCode": "5515.19.00.15",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.19.0020",
      "rawHtsCode": "5515.19.00.20",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.19.0025",
      "rawHtsCode": "5515.19.00.25",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.19.0030",
      "rawHtsCode": "5515.19.00.30",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.19.0035",
      "rawHtsCode": "5515.19.00.35",
      "superior": null,
      "indent": "4",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.19.0040",
      "rawHtsCode": "5515.19.00.40",
      "superior": null,
      "indent": "4",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.19.0045",
      "rawHtsCode": "5515.19.00.45",
      "superior": null,
      "indent": "4",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.19.0090",
      "rawHtsCode": "5515.19.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.21.00",
      "rawHtsCode": "5515.21.00",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with man-made filaments",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5515.21.0010",
      "rawHtsCode": "5515.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.21.0020",
      "rawHtsCode": "5515.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.21.0030",
      "rawHtsCode": "5515.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.21.0040",
      "rawHtsCode": "5515.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.21.0090",
      "rawHtsCode": "5515.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.22",
      "rawHtsCode": "5515.22",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.22.05",
      "rawHtsCode": "5515.22.05",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "20.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5515.22.0510",
      "rawHtsCode": "5515.22.05.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.22.0520",
      "rawHtsCode": "5515.22.05.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.22.1000",
      "rawHtsCode": "5515.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Other (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5515.29.00",
      "rawHtsCode": "5515.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5515.29.0005",
      "rawHtsCode": "5515.29.00.05",
      "superior": null,
      "indent": "3",
      "description": "Of yarns of different colors, except blue denim or jacquard weave (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.29.0010",
      "rawHtsCode": "5515.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Blue denim (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.29.0015",
      "rawHtsCode": "5515.29.00.15",
      "superior": null,
      "indent": "4",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.29.0020",
      "rawHtsCode": "5515.29.00.20",
      "superior": null,
      "indent": "4",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.29.0025",
      "rawHtsCode": "5515.29.00.25",
      "superior": null,
      "indent": "4",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.29.0030",
      "rawHtsCode": "5515.29.00.30",
      "superior": null,
      "indent": "4",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.29.0035",
      "rawHtsCode": "5515.29.00.35",
      "superior": null,
      "indent": "4",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.29.0040",
      "rawHtsCode": "5515.29.00.40",
      "superior": null,
      "indent": "4",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.29.0045",
      "rawHtsCode": "5515.29.00.45",
      "superior": null,
      "indent": "4",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.29.0090",
      "rawHtsCode": "5515.29.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.91.00",
      "rawHtsCode": "5515.91.00",
      "superior": null,
      "indent": "2",
      "description": "Mixed mainly or solely with man-made filaments",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5515.91.0010",
      "rawHtsCode": "5515.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.91.0020",
      "rawHtsCode": "5515.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.91.0030",
      "rawHtsCode": "5515.91.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.91.0040",
      "rawHtsCode": "5515.91.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.91.0090",
      "rawHtsCode": "5515.91.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99",
      "rawHtsCode": "5515.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.05",
      "rawHtsCode": "5515.99.05",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5515.99.0510",
      "rawHtsCode": "5515.99.05.10",
      "superior": null,
      "indent": "5",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.0520",
      "rawHtsCode": "5515.99.05.20",
      "superior": null,
      "indent": "5",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.10",
      "rawHtsCode": "5515.99.10",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5515.99.1010",
      "rawHtsCode": "5515.99.10.10",
      "superior": null,
      "indent": "5",
      "description": "Not combed (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.1020",
      "rawHtsCode": "5515.99.10.20",
      "superior": null,
      "indent": "5",
      "description": "Combed (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.90",
      "rawHtsCode": "5515.99.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5515.99.9005",
      "rawHtsCode": "5515.99.90.05",
      "superior": null,
      "indent": "4",
      "description": "Of yarns of different colors, except blue denim or jacquard weave (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.9010",
      "rawHtsCode": "5515.99.90.10",
      "superior": null,
      "indent": "4",
      "description": "Blue denim (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.9015",
      "rawHtsCode": "5515.99.90.15",
      "superior": null,
      "indent": "5",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.9020",
      "rawHtsCode": "5515.99.90.20",
      "superior": null,
      "indent": "5",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.9025",
      "rawHtsCode": "5515.99.90.25",
      "superior": null,
      "indent": "5",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.9030",
      "rawHtsCode": "5515.99.90.30",
      "superior": null,
      "indent": "5",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.9035",
      "rawHtsCode": "5515.99.90.35",
      "superior": null,
      "indent": "5",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.9040",
      "rawHtsCode": "5515.99.90.40",
      "superior": null,
      "indent": "5",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.9045",
      "rawHtsCode": "5515.99.90.45",
      "superior": null,
      "indent": "5",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5515.99.9090",
      "rawHtsCode": "5515.99.90.90",
      "superior": null,
      "indent": "5",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516",
      "rawHtsCode": "5516",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of artificial staple fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.11.00",
      "rawHtsCode": "5516.11.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.11.0010",
      "rawHtsCode": "5516.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Plain weave (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.11.0020",
      "rawHtsCode": "5516.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.11.0090",
      "rawHtsCode": "5516.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.12.00",
      "rawHtsCode": "5516.12.00",
      "superior": null,
      "indent": "2",
      "description": "Dyed",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.12.0010",
      "rawHtsCode": "5516.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Plain weave (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.12.0020",
      "rawHtsCode": "5516.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.12.0090",
      "rawHtsCode": "5516.12.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.13.0000",
      "rawHtsCode": "5516.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.14.00",
      "rawHtsCode": "5516.14.00",
      "superior": null,
      "indent": "2",
      "description": "Printed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.14.0005",
      "rawHtsCode": "5516.14.00.05",
      "superior": null,
      "indent": "4",
      "description": "Discharge printed (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.14.0015",
      "rawHtsCode": "5516.14.00.15",
      "superior": null,
      "indent": "4",
      "description": "Other (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.14.0025",
      "rawHtsCode": "5516.14.00.25",
      "superior": null,
      "indent": "4",
      "description": "Discharge printed (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.14.0030",
      "rawHtsCode": "5516.14.00.30",
      "superior": null,
      "indent": "4",
      "description": "Other (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.14.0085",
      "rawHtsCode": "5516.14.00.85",
      "superior": null,
      "indent": "4",
      "description": "Discharge printed (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.14.0095",
      "rawHtsCode": "5516.14.00.95",
      "superior": null,
      "indent": "4",
      "description": "Other (611)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.21.00",
      "rawHtsCode": "5516.21.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.21.0010",
      "rawHtsCode": "5516.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.21.0020",
      "rawHtsCode": "5516.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.21.0030",
      "rawHtsCode": "5516.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.21.0040",
      "rawHtsCode": "5516.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.21.0090",
      "rawHtsCode": "5516.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.22.00",
      "rawHtsCode": "5516.22.00",
      "superior": null,
      "indent": "2",
      "description": "Dyed",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.22.0010",
      "rawHtsCode": "5516.22.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.22.0020",
      "rawHtsCode": "5516.22.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.22.0030",
      "rawHtsCode": "5516.22.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.22.0040",
      "rawHtsCode": "5516.22.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.22.0090",
      "rawHtsCode": "5516.22.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.23.00",
      "rawHtsCode": "5516.23.00",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.23.0010",
      "rawHtsCode": "5516.23.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.23.0020",
      "rawHtsCode": "5516.23.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.23.0030",
      "rawHtsCode": "5516.23.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.23.0040",
      "rawHtsCode": "5516.23.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.23.0090",
      "rawHtsCode": "5516.23.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.24.00",
      "rawHtsCode": "5516.24.00",
      "superior": null,
      "indent": "2",
      "description": "Printed",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.24.0010",
      "rawHtsCode": "5516.24.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (625)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.24.0020",
      "rawHtsCode": "5516.24.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (627)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.24.0030",
      "rawHtsCode": "5516.24.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (626)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.24.0040",
      "rawHtsCode": "5516.24.00.40",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (628)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.24.0085",
      "rawHtsCode": "5516.24.00.85",
      "superior": null,
      "indent": "4",
      "description": "Discharge printed (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.24.0095",
      "rawHtsCode": "5516.24.00.95",
      "superior": null,
      "indent": "4",
      "description": "Other (629)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.31",
      "rawHtsCode": "5516.31",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.31.05",
      "rawHtsCode": "5516.31.05",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "19.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.31.0510",
      "rawHtsCode": "5516.31.05.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.31.0520",
      "rawHtsCode": "5516.31.05.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.31.1000",
      "rawHtsCode": "5516.31.10.00",
      "superior": null,
      "indent": "3",
      "description": "Other (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.32",
      "rawHtsCode": "5516.32",
      "superior": null,
      "indent": "2",
      "description": "Dyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.32.05",
      "rawHtsCode": "5516.32.05",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.32.0510",
      "rawHtsCode": "5516.32.05.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.32.0520",
      "rawHtsCode": "5516.32.05.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.32.1000",
      "rawHtsCode": "5516.32.10.00",
      "superior": null,
      "indent": "3",
      "description": "Other (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.33",
      "rawHtsCode": "5516.33",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.33.05",
      "rawHtsCode": "5516.33.05",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.33.0510",
      "rawHtsCode": "5516.33.05.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.33.0520",
      "rawHtsCode": "5516.33.05.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.33.1000",
      "rawHtsCode": "5516.33.10.00",
      "superior": null,
      "indent": "3",
      "description": "Other (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.34",
      "rawHtsCode": "5516.34",
      "superior": null,
      "indent": "2",
      "description": "Printed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.34.05",
      "rawHtsCode": "5516.34.05",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "19.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "48.5¢/kg + 68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.34.0510",
      "rawHtsCode": "5516.34.05.10",
      "superior": null,
      "indent": "4",
      "description": "Not combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.34.0520",
      "rawHtsCode": "5516.34.05.20",
      "superior": null,
      "indent": "4",
      "description": "Combed (410)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.34.1000",
      "rawHtsCode": "5516.34.10.00",
      "superior": null,
      "indent": "3",
      "description": "Other (624)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.41.00",
      "rawHtsCode": "5516.41.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.41.0010",
      "rawHtsCode": "5516.41.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.41.0022",
      "rawHtsCode": "5516.41.00.22",
      "superior": null,
      "indent": "4",
      "description": "Of a width exceeding 127 cm (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.41.0027",
      "rawHtsCode": "5516.41.00.27",
      "superior": null,
      "indent": "4",
      "description": "Other (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.41.0030",
      "rawHtsCode": "5516.41.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.41.0040",
      "rawHtsCode": "5516.41.00.40",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.41.0050",
      "rawHtsCode": "5516.41.00.50",
      "superior": null,
      "indent": "3",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.41.0060",
      "rawHtsCode": "5516.41.00.60",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.41.0070",
      "rawHtsCode": "5516.41.00.70",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.41.0090",
      "rawHtsCode": "5516.41.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.42.00",
      "rawHtsCode": "5516.42.00",
      "superior": null,
      "indent": "2",
      "description": "Dyed",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.42.0010",
      "rawHtsCode": "5516.42.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.42.0022",
      "rawHtsCode": "5516.42.00.22",
      "superior": null,
      "indent": "4",
      "description": "Of a width exceeding 127 cm (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.42.0027",
      "rawHtsCode": "5516.42.00.27",
      "superior": null,
      "indent": "4",
      "description": "Other (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.42.0030",
      "rawHtsCode": "5516.42.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.42.0040",
      "rawHtsCode": "5516.42.00.40",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.42.0050",
      "rawHtsCode": "5516.42.00.50",
      "superior": null,
      "indent": "3",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.42.0060",
      "rawHtsCode": "5516.42.00.60",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.42.0070",
      "rawHtsCode": "5516.42.00.70",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.42.0090",
      "rawHtsCode": "5516.42.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.43.00",
      "rawHtsCode": "5516.43.00",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5516.43.0010",
      "rawHtsCode": "5516.43.00.10",
      "superior": null,
      "indent": "4",
      "description": "Blue denim (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.43.0015",
      "rawHtsCode": "5516.43.00.15",
      "superior": null,
      "indent": "4",
      "description": "Other denim (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.43.0020",
      "rawHtsCode": "5516.43.00.20",
      "superior": null,
      "indent": "3",
      "description": "Jacquard weave (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.43.0035",
      "rawHtsCode": "5516.43.00.35",
      "superior": null,
      "indent": "4",
      "description": "Of a width exceeding 127 cm (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.43.0080",
      "rawHtsCode": "5516.43.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.44.00",
      "rawHtsCode": "5516.44.00",
      "superior": null,
      "indent": "2",
      "description": "Printed",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.44.0010",
      "rawHtsCode": "5516.44.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.44.0022",
      "rawHtsCode": "5516.44.00.22",
      "superior": null,
      "indent": "4",
      "description": "Of a width exceeding 127 cm (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.44.0027",
      "rawHtsCode": "5516.44.00.27",
      "superior": null,
      "indent": "4",
      "description": "Other (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.44.0030",
      "rawHtsCode": "5516.44.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.44.0040",
      "rawHtsCode": "5516.44.00.40",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.44.0050",
      "rawHtsCode": "5516.44.00.50",
      "superior": null,
      "indent": "3",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.44.0060",
      "rawHtsCode": "5516.44.00.60",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.44.0070",
      "rawHtsCode": "5516.44.00.70",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.44.0090",
      "rawHtsCode": "5516.44.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.91.00",
      "rawHtsCode": "5516.91.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.91.0010",
      "rawHtsCode": "5516.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.91.0020",
      "rawHtsCode": "5516.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.91.0030",
      "rawHtsCode": "5516.91.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.91.0040",
      "rawHtsCode": "5516.91.00.40",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.91.0050",
      "rawHtsCode": "5516.91.00.50",
      "superior": null,
      "indent": "3",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.91.0060",
      "rawHtsCode": "5516.91.00.60",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.91.0070",
      "rawHtsCode": "5516.91.00.70",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.91.0090",
      "rawHtsCode": "5516.91.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.92.00",
      "rawHtsCode": "5516.92.00",
      "superior": null,
      "indent": "2",
      "description": "Dyed",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.92.0010",
      "rawHtsCode": "5516.92.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.92.0020",
      "rawHtsCode": "5516.92.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.92.0030",
      "rawHtsCode": "5516.92.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.92.0040",
      "rawHtsCode": "5516.92.00.40",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.92.0050",
      "rawHtsCode": "5516.92.00.50",
      "superior": null,
      "indent": "3",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.92.0060",
      "rawHtsCode": "5516.92.00.60",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.92.0070",
      "rawHtsCode": "5516.92.00.70",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.92.0090",
      "rawHtsCode": "5516.92.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.93.00",
      "rawHtsCode": "5516.93.00",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.93.0010",
      "rawHtsCode": "5516.93.00.10",
      "superior": null,
      "indent": "3",
      "description": "Blue denim (225)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.93.0020",
      "rawHtsCode": "5516.93.00.20",
      "superior": null,
      "indent": "3",
      "description": "Jacquard weave (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.93.0090",
      "rawHtsCode": "5516.93.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (218)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.94.00",
      "rawHtsCode": "5516.94.00",
      "superior": null,
      "indent": "2",
      "description": "Printed",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5516.94.0010",
      "rawHtsCode": "5516.94.00.10",
      "superior": null,
      "indent": "3",
      "description": "Poplin or broadcloth (614)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.94.0020",
      "rawHtsCode": "5516.94.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sheeting (613)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.94.0030",
      "rawHtsCode": "5516.94.00.30",
      "superior": null,
      "indent": "3",
      "description": "Printcloth (615)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.94.0040",
      "rawHtsCode": "5516.94.00.40",
      "superior": null,
      "indent": "3",
      "description": "Cheesecloth; lawns, voiles or batistes (226)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.94.0050",
      "rawHtsCode": "5516.94.00.50",
      "superior": null,
      "indent": "3",
      "description": "Duck (219)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.94.0060",
      "rawHtsCode": "5516.94.00.60",
      "superior": null,
      "indent": "3",
      "description": "Satin weave or twill weave (617)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.94.0070",
      "rawHtsCode": "5516.94.00.70",
      "superior": null,
      "indent": "3",
      "description": "Oxford cloth (227)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5516.94.0090",
      "rawHtsCode": "5516.94.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5601",
      "rawHtsCode": "5601",
      "superior": null,
      "indent": "0",
      "description": "Wadding of textile materials and articles thereof; textile fibers, not exceeding 5 mm in length (flock), textile dust and mill neps:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5601.21.00",
      "rawHtsCode": "5601.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "3.6%",
      "specialRate": "Free (AU,B,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5601.21.0010",
      "rawHtsCode": "5601.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Wadding, in the piece (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5601.21.0090",
      "rawHtsCode": "5601.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (369)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5601.22.00",
      "rawHtsCode": "5601.22.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,B,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5601.22.0010",
      "rawHtsCode": "5601.22.00.10",
      "superior": null,
      "indent": "3",
      "description": "Wadding, in the piece (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5601.22.0050",
      "rawHtsCode": "5601.22.00.50",
      "superior": null,
      "indent": "3",
      "description": "Flocked swabs, other than articles of heading 3926 (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5601.22.0091",
      "rawHtsCode": "5601.22.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5601.29.00",
      "rawHtsCode": "5601.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (AU,B,BH, CL,CO,E*,IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5601.29.0010",
      "rawHtsCode": "5601.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5601.29.0020",
      "rawHtsCode": "5601.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (469)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5601.29.0090",
      "rawHtsCode": "5601.29.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5601.30.0000",
      "rawHtsCode": "5601.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Textile flock and dust and mill neps",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5602",
      "rawHtsCode": "5602",
      "superior": null,
      "indent": "0",
      "description": "Felt, whether or not impregnated, coated, covered or laminated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5602.10",
      "rawHtsCode": "5602.10",
      "superior": null,
      "indent": "1",
      "description": "Needleloom felt and stitchbonded fiber fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5602.10.1000",
      "rawHtsCode": "5602.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Laminated fabrics (223)",
      "units": [
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5602.10.90",
      "rawHtsCode": "5602.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "10.6%",
      "specialRate": "Free (AU,B,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5602.10.9010",
      "rawHtsCode": "5602.10.90.10",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (414)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5602.10.9090",
      "rawHtsCode": "5602.10.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5602.21.0000",
      "rawHtsCode": "5602.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (414)",
      "units": [
        "kg"
      ],
      "generalRate": "49.5¢/kg + 7.5%",
      "specialRate": "Free (AU,B,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "88¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5602.29.0000",
      "rawHtsCode": "5602.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials (223)",
      "units": [
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,B,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5602.90",
      "rawHtsCode": "5602.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5602.90.3000",
      "rawHtsCode": "5602.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Laminated fabrics (223)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5602.90.6000",
      "rawHtsCode": "5602.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers (223)",
      "units": [
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,B,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5602.90.9000",
      "rawHtsCode": "5602.90.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (414)",
      "units": [
        "kg"
      ],
      "generalRate": "52.9¢/kg + 8%",
      "specialRate": "Free (AU,B,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "88¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5603",
      "rawHtsCode": "5603",
      "superior": null,
      "indent": "0",
      "description": "Nonwovens, whether or not impregnated, coated, covered or laminated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.11.00",
      "rawHtsCode": "5603.11.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing not more than 25 g/m<sup>2</sup>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5603.11.0010",
      "rawHtsCode": "5603.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Impregnated, coated or covered with material other than or in addition to rubber, plastics, wood pulp or glass fibers; \"imitation suede\" (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.11.0070",
      "rawHtsCode": "5603.11.00.70",
      "superior": null,
      "indent": "3",
      "description": "Nonwoven articles, ready for use and packaged for industrial, institutional or retail sale, whether or not separated, perforated or impregnated, not elsewhere specified or included (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.11.0095",
      "rawHtsCode": "5603.11.00.95",
      "superior": null,
      "indent": "3",
      "description": "Other (223)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.12.00",
      "rawHtsCode": "5603.12.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing more than 25 g/m<sup>2</sup> but not more than 70 g/m<sup>2</sup>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5603.12.0010",
      "rawHtsCode": "5603.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Impregnated, coated or covered with material other than or in addition to rubber, plastics, wood pulp or glass fibers; \"imitation suede\" (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.12.0070",
      "rawHtsCode": "5603.12.00.70",
      "superior": null,
      "indent": "3",
      "description": "Nonwoven articles, ready for use and packaged for industrial, institutional or retail sale, whether or not separated, perforated or impregnated, not elsewhere specified or included (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.12.0095",
      "rawHtsCode": "5603.12.00.95",
      "superior": null,
      "indent": "3",
      "description": "Other (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.13.00",
      "rawHtsCode": "5603.13.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing more than 70 g/m<sup>2</sup> but not more than 150 g/m<sup>2</sup>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5603.13.0010",
      "rawHtsCode": "5603.13.00.10",
      "superior": null,
      "indent": "3",
      "description": "Impregnated, coated or covered with material other than or in addition to rubber, plastics, wood pulp or glass fibers; \"imitation suede\" (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.13.0070",
      "rawHtsCode": "5603.13.00.70",
      "superior": null,
      "indent": "3",
      "description": "Nonwoven articles, ready for use and packaged for industrial, institutional or retail sale, whether or not separated, perforated or impregnated, not elsewhere specified or included (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.13.0095",
      "rawHtsCode": "5603.13.00.95",
      "superior": null,
      "indent": "3",
      "description": "Other (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.14",
      "rawHtsCode": "5603.14",
      "superior": null,
      "indent": "2",
      "description": "Weighing more than 150 g/m<sup>2</sup>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.14.3000",
      "rawHtsCode": "5603.14.30.00",
      "superior": null,
      "indent": "3",
      "description": "Laminated fabrics (223)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5603.14.90",
      "rawHtsCode": "5603.14.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5603.14.9010",
      "rawHtsCode": "5603.14.90.10",
      "superior": null,
      "indent": "4",
      "description": "Impregnated, coated or covered with material other than or in addition to rubber, plastics, wood pulp or glass fibers; \"imitation suede\" (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.14.9090",
      "rawHtsCode": "5603.14.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.91.00",
      "rawHtsCode": "5603.91.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing not more than 25 g/m<sup>2</sup>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5603.91.0010",
      "rawHtsCode": "5603.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Impregnated, coated or covered with material other than or in addition to rubber, plastics, wood pulp or glass fibers; \"imitation suede\" (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.91.0090",
      "rawHtsCode": "5603.91.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.92.00",
      "rawHtsCode": "5603.92.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing more than 25 g/m<sup>2</sup> but not more than 70 g/m<sup>2</sup>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "5603.92.0010",
      "rawHtsCode": "5603.92.00.10",
      "superior": null,
      "indent": "3",
      "description": "Impregnated, coated or covered with material other than or in addition to rubber, plastics, wood pulp or glass fibers; \"imitation suede\" (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.92.0070",
      "rawHtsCode": "5603.92.00.70",
      "superior": null,
      "indent": "3",
      "description": "Nonwoven articles, ready for use and packaged for industrial, institutional or retail sale, whether or not separated, perforated or impregnated, not elsewhere specified or included (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "5603.92.0095",
      "rawHtsCode": "5603.92.00.95",
      "superior": null,
      "indent": "3",
      "description": "Other (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "5603.93.00",
      "rawHtsCode": "5603.93.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing more than 70 g/m<sup>2</sup> but not more than 150 g/m<sup>2</sup>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5603.93.0010",
      "rawHtsCode": "5603.93.00.10",
      "superior": null,
      "indent": "3",
      "description": "Impregnated, coated or covered with material other than or in addition to rubber, plastics, wood pulp or glass fibers; \"imitation suede\" (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.93.0090",
      "rawHtsCode": "5603.93.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "5603.94",
      "rawHtsCode": "5603.94",
      "superior": null,
      "indent": "2",
      "description": "Weighing more than 150 g/m<sup>2</sup>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.94.10",
      "rawHtsCode": "5603.94.10",
      "superior": null,
      "indent": "3",
      "description": "Floor covering underlays",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5603.94.1010",
      "rawHtsCode": "5603.94.10.10",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (469)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.94.1090",
      "rawHtsCode": "5603.94.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.94.3000",
      "rawHtsCode": "5603.94.30.00",
      "superior": null,
      "indent": "4",
      "description": "Laminated fabrics (223)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5603.94.90",
      "rawHtsCode": "5603.94.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5603.94.9010",
      "rawHtsCode": "5603.94.90.10",
      "superior": null,
      "indent": "5",
      "description": "Impregnated, coated or covered with material other than or in addition to rubber, plastics, wood pulp or glass fibers; \"imitation suede\" (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.94.9030",
      "rawHtsCode": "5603.94.90.30",
      "superior": null,
      "indent": "6",
      "description": "Thermal bonded, of staple fibers (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.94.9050",
      "rawHtsCode": "5603.94.90.50",
      "superior": null,
      "indent": "6",
      "description": "Obtained by mechanical entanglement, of staple fibers (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.94.9070",
      "rawHtsCode": "5603.94.90.70",
      "superior": null,
      "indent": "7",
      "description": "Of filaments (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5603.94.9090",
      "rawHtsCode": "5603.94.90.90",
      "superior": null,
      "indent": "7",
      "description": "Of staple fibers (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5604",
      "rawHtsCode": "5604",
      "superior": null,
      "indent": "0",
      "description": "Rubber thread and cord, textile covered; textile yarn, and strip and the like of heading 5404 or 5405, impregnated, coated, covered or sheathed with rubber or plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5604.10.0000",
      "rawHtsCode": "5604.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Rubber thread and cord, textile covered (201)",
      "units": [
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5604.90.2000",
      "rawHtsCode": "5604.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "High tenacity yarn of polyesters, of nylon or other polyamides or of viscose rayon, impregnated or coated (201)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5604.90.9000",
      "rawHtsCode": "5604.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5605.00",
      "rawHtsCode": "5605.00",
      "superior": null,
      "indent": "0",
      "description": "Metalized yarn, whether or not gimped, being textile yarn, or strip or the like of heading 5404 or 5405, combined with metal in the form of thread, strip or powder or covered with metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5605.00.1000",
      "rawHtsCode": "5605.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Metal coated or metal laminated man-made filament or strip or the like, ungimped, and untwisted or with twist of less than 5 turns per meter",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5605.00.9000",
      "rawHtsCode": "5605.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other (201)",
      "units": [
        "kg"
      ],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR, MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5606.00.00",
      "rawHtsCode": "5606.00.00",
      "superior": null,
      "indent": "0",
      "description": "Gimped yarn, and strip and the like of heading 5404 or 5405, gimped (other than those of heading 5605 and gimped horsehair yarn); chenille yarn (including flock chenille yarn); loop wale-yarn",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5606.00.0010",
      "rawHtsCode": "5606.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Containing elastomeric filaments (201)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5606.00.0090",
      "rawHtsCode": "5606.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other (201)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5607",
      "rawHtsCode": "5607",
      "superior": null,
      "indent": "0",
      "description": "Twine, cordage, ropes and cables, whether or not plaited or braided and whether or not impregnated, coated, covered or sheathed with rubber or plastics: ",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5607.21.0000",
      "rawHtsCode": "5607.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Binder or baler twine",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5607.29.0000",
      "rawHtsCode": "5607.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5607.41",
      "rawHtsCode": "5607.41",
      "superior": null,
      "indent": "2",
      "description": "Binder or baler twine:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5607.41.1000",
      "rawHtsCode": "5607.41.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of wide nonfibrillated strip",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5607.41.3000",
      "rawHtsCode": "5607.41.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other (201)",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5607.49",
      "rawHtsCode": "5607.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5607.49.1000",
      "rawHtsCode": "5607.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of wide nonfibrillated strip",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5607.49.1500",
      "rawHtsCode": "5607.49.15.00",
      "superior": null,
      "indent": "4",
      "description": "Measuring less than <il>4.8 mm</il> in diameter (201)",
      "units": [
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5607.49.2500",
      "rawHtsCode": "5607.49.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other (201)",
      "units": [
        "kg"
      ],
      "generalRate": "9.8¢/kg + 5.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "27.6¢/kg + 76.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5607.49.3000",
      "rawHtsCode": "5607.49.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5607.50",
      "rawHtsCode": "5607.50",
      "superior": null,
      "indent": "1",
      "description": "Of other synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5607.50.2500",
      "rawHtsCode": "5607.50.25.00",
      "superior": null,
      "indent": "3",
      "description": "3-ply or 4-ply multicolored twine having a final \"S\" twist, containing at least 10 percent by weight of cotton, measuring less than 3.5 mm in diameter (201)",
      "units": [
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5607.50.3500",
      "rawHtsCode": "5607.50.35.00",
      "superior": null,
      "indent": "3",
      "description": "Other (201)",
      "units": [
        "kg"
      ],
      "generalRate": "19.9¢/kg + 10.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "27.6¢/kg + 76.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5607.50.4000",
      "rawHtsCode": "5607.50.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5607.90",
      "rawHtsCode": "5607.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5607.90.1000",
      "rawHtsCode": "5607.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of coir",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5607.90.1500",
      "rawHtsCode": "5607.90.15.00",
      "superior": null,
      "indent": "2",
      "description": "Of jute or other textile bast fibers of heading 5303",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5607.90.2500",
      "rawHtsCode": "5607.90.25.00",
      "superior": null,
      "indent": "3",
      "description": "Of stranded construction measuring 1.88 cm or over in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5607.90.3500",
      "rawHtsCode": "5607.90.35.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5607.90.9000",
      "rawHtsCode": "5607.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (201)",
      "units": [
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5608",
      "rawHtsCode": "5608",
      "superior": null,
      "indent": "0",
      "description": "Knotted netting of twine, cordage or rope; made up fishing nets and other made up nets, of textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5608.11.00",
      "rawHtsCode": "5608.11.00",
      "superior": null,
      "indent": "2",
      "description": "Made up fishing nets",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "82%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5608.11.0010",
      "rawHtsCode": "5608.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Hand-cast string-drawn",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5608.11.0090",
      "rawHtsCode": "5608.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5608.19",
      "rawHtsCode": "5608.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5608.19.10",
      "rawHtsCode": "5608.19.10",
      "superior": null,
      "indent": "3",
      "description": "Fish netting",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "82%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5608.19.1010",
      "rawHtsCode": "5608.19.10.10",
      "superior": null,
      "indent": "4",
      "description": "Salmon gill netting, of nylon or other polyamides (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5608.19.1020",
      "rawHtsCode": "5608.19.10.20",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5608.19.20",
      "rawHtsCode": "5608.19.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (AU,B,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5608.19.2010",
      "rawHtsCode": "5608.19.20.10",
      "superior": null,
      "indent": "4",
      "description": "Bait bags with draw string closures",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5608.19.2090",
      "rawHtsCode": "5608.19.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5608.90",
      "rawHtsCode": "5608.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5608.90.1000",
      "rawHtsCode": "5608.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fish netting and fishing nets",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "82%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5608.90.2300",
      "rawHtsCode": "5608.90.23.00",
      "superior": null,
      "indent": "4",
      "description": "Hammocks",
      "units": [
        "kg"
      ],
      "generalRate": "14.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5608.90.2700",
      "rawHtsCode": "5608.90.27.00",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "14.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5608.90.3000",
      "rawHtsCode": "5608.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5609.00",
      "rawHtsCode": "5609.00",
      "superior": null,
      "indent": "0",
      "description": "Articles of yarn, strip or the like of heading 5404 or 5405, twine, cordage, rope or cables, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5609.00.1000",
      "rawHtsCode": "5609.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of cotton",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5609.00.2000",
      "rawHtsCode": "5609.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of vegetable fibers, except cotton",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5609.00.3000",
      "rawHtsCode": "5609.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5609.00.4000",
      "rawHtsCode": "5609.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5701",
      "rawHtsCode": "5701",
      "superior": null,
      "indent": "0",
      "description": "Carpets and other textile floor coverings, knotted, whether or not made up:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5701.10",
      "rawHtsCode": "5701.10",
      "superior": null,
      "indent": "1",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5701.10.1300",
      "rawHtsCode": "5701.10.13.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed and folklore products",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5701.10.1600",
      "rawHtsCode": "5701.10.16.00",
      "superior": null,
      "indent": "3",
      "description": "Other (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5701.10.4000",
      "rawHtsCode": "5701.10.40.00",
      "superior": null,
      "indent": "3",
      "description": "Hand-hooked, that is, in which the tufts were inserted and knotted by hand or by means of a hand tool (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5701.10.9000",
      "rawHtsCode": "5701.10.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5701.90",
      "rawHtsCode": "5701.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5701.90.10",
      "rawHtsCode": "5701.90.10",
      "superior": null,
      "indent": "2",
      "description": "With pile inserted and knotted during weaving or knitting",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5701.90.1010",
      "rawHtsCode": "5701.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Hand-knotted",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5701.90.1020",
      "rawHtsCode": "5701.90.10.20",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (369)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5701.90.1030",
      "rawHtsCode": "5701.90.10.30",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5701.90.1090",
      "rawHtsCode": "5701.90.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5701.90.20",
      "rawHtsCode": "5701.90.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5701.90.2010",
      "rawHtsCode": "5701.90.20.10",
      "superior": null,
      "indent": "3",
      "description": "Hand-hooked, that is, in which the tufts were inserted and knotted by hand or by means of a hand tool",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5701.90.2020",
      "rawHtsCode": "5701.90.20.20",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (369)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5701.90.2030",
      "rawHtsCode": "5701.90.20.30",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5701.90.2090",
      "rawHtsCode": "5701.90.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702",
      "rawHtsCode": "5702",
      "superior": null,
      "indent": "0",
      "description": "Carpets and other textile floor coverings, woven, not tufted or flocked, whether or not made up, including \"Kelem\", \"Schumacks\", \"Karamanie\" and similar handwoven rugs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.10",
      "rawHtsCode": "5702.10",
      "superior": null,
      "indent": "1",
      "description": "\"Kelem\", \"Schumacks\", \"Karamanie\" and similar hand woven rugs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.10.1000",
      "rawHtsCode": "5702.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Certified hand-loomed and folklore products",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5702.10.90",
      "rawHtsCode": "5702.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5702.10.9010",
      "rawHtsCode": "5702.10.90.10",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.10.9020",
      "rawHtsCode": "5702.10.90.20",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (369)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.10.9030",
      "rawHtsCode": "5702.10.90.30",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.10.9090",
      "rawHtsCode": "5702.10.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.20",
      "rawHtsCode": "5702.20",
      "superior": null,
      "indent": "1",
      "description": "Floor coverings of coconut fibers (coir):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.20.1000",
      "rawHtsCode": "5702.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "With pile",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.29/m<sup>2</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5702.20.2000",
      "rawHtsCode": "5702.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "16%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5702.31",
      "rawHtsCode": "5702.31",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.31.1000",
      "rawHtsCode": "5702.31.10.00",
      "superior": null,
      "indent": "3",
      "description": "Wilton (including brussels) and velvet (including tapestry) floor coverings and floor coverings of like character or description (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.31.2000",
      "rawHtsCode": "5702.31.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.32",
      "rawHtsCode": "5702.32",
      "superior": null,
      "indent": "2",
      "description": "Of man-made textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.32.1000",
      "rawHtsCode": "5702.32.10.00",
      "superior": null,
      "indent": "3",
      "description": "Wilton (including brussels) and velvet (including tapestry) floor coverings and floor coverings of like character or description (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.32.2000",
      "rawHtsCode": "5702.32.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.39",
      "rawHtsCode": "5702.39",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.39.1000",
      "rawHtsCode": "5702.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of jute",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5702.39.20",
      "rawHtsCode": "5702.39.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.39.2010",
      "rawHtsCode": "5702.39.20.10",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (369)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.39.2090",
      "rawHtsCode": "5702.39.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.41",
      "rawHtsCode": "5702.41",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.41.1000",
      "rawHtsCode": "5702.41.10.00",
      "superior": null,
      "indent": "3",
      "description": "Wilton (including brussels) and velvet (including tapestry) floor coverings and floor coverings of like character or description (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5702.41.2000",
      "rawHtsCode": "5702.41.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5702.42",
      "rawHtsCode": "5702.42",
      "superior": null,
      "indent": "2",
      "description": "Of man-made textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.42.1000",
      "rawHtsCode": "5702.42.10.00",
      "superior": null,
      "indent": "3",
      "description": "Wilton (including brussels) and velvet (including tapestry) floor coverings and floor coverings of like character or description (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5702.42.20",
      "rawHtsCode": "5702.42.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5702.42.2020",
      "rawHtsCode": "5702.42.20.20",
      "superior": null,
      "indent": "4",
      "description": "Not made on a power-driven loom (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.42.2080",
      "rawHtsCode": "5702.42.20.80",
      "superior": null,
      "indent": "4",
      "description": "Other (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.49",
      "rawHtsCode": "5702.49",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.49.10",
      "rawHtsCode": "5702.49.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5702.49.1020",
      "rawHtsCode": "5702.49.10.20",
      "superior": null,
      "indent": "4",
      "description": "Not made on a power-driven loom (369)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.49.1080",
      "rawHtsCode": "5702.49.10.80",
      "superior": null,
      "indent": "4",
      "description": "Other (369)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.49.1500",
      "rawHtsCode": "5702.49.15.00",
      "superior": null,
      "indent": "3",
      "description": "Of jute",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5702.49.2000",
      "rawHtsCode": "5702.49.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,B,BH, CL,CO,E*,IL,JO,KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.50",
      "rawHtsCode": "5702.50",
      "superior": null,
      "indent": "1",
      "description": "Other, not of pile construction, not made up:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.50.2000",
      "rawHtsCode": "5702.50.20.00",
      "superior": null,
      "indent": "3",
      "description": "Woven, but not made on a power-driven loom (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.50.4000",
      "rawHtsCode": "5702.50.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,NP,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.50.5200",
      "rawHtsCode": "5702.50.52.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made textile materials (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.50.5600",
      "rawHtsCode": "5702.50.56.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (369)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "6.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.50.5900",
      "rawHtsCode": "5702.50.59.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR,MA,NP,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.91",
      "rawHtsCode": "5702.91",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.91.2000",
      "rawHtsCode": "5702.91.20.00",
      "superior": null,
      "indent": "4",
      "description": "Certified hand-loomed and folklore products",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5702.91.3000",
      "rawHtsCode": "5702.91.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,IL,JO,KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.91.4000",
      "rawHtsCode": "5702.91.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.92",
      "rawHtsCode": "5702.92",
      "superior": null,
      "indent": "2",
      "description": "Of man-made textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.92.1000",
      "rawHtsCode": "5702.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "Woven, but not made on a power-driven loom (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.92.9000",
      "rawHtsCode": "5702.92.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.99",
      "rawHtsCode": "5702.99",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5702.99.0500",
      "rawHtsCode": "5702.99.05.00",
      "superior": null,
      "indent": "4",
      "description": "Woven, but not made on a power-driven loom (369)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "6.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.99.1500",
      "rawHtsCode": "5702.99.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other (369)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "6.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5702.99.2000",
      "rawHtsCode": "5702.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5703",
      "rawHtsCode": "5703",
      "superior": null,
      "indent": "0",
      "description": "Carpets and other textile floor coverings (including turf), tufted, whether or not made up:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.10",
      "rawHtsCode": "5703.10",
      "superior": null,
      "indent": "1",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.10.2000",
      "rawHtsCode": "5703.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Hand-hooked, that is, in which the tufts were inserted by hand or by means of a hand tool (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,IL,JO,KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5703.10.8000",
      "rawHtsCode": "5703.10.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,B,BH,CL,CO,IL,JO, KR,MA,NP,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5703.21.00",
      "rawHtsCode": "5703.21.00",
      "superior": null,
      "indent": "2",
      "description": "Turf",
      "units": [],
      "generalRate": "6.7%",
      "specialRate": "Free (AU,B,BH,CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5703.21.0010",
      "rawHtsCode": "5703.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Measuring not more than 5.25 m<sup>2</sup> in area (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.21.0090",
      "rawHtsCode": "5703.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.29",
      "rawHtsCode": "5703.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.29.1000",
      "rawHtsCode": "5703.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Hand-hooked, that is, in which the tufts were inserted by hand or by means of a hand tool (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5703.29.20",
      "rawHtsCode": "5703.29.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.7%",
      "specialRate": "Free (AU,B,BH,CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5703.29.2010",
      "rawHtsCode": "5703.29.20.10",
      "superior": null,
      "indent": "4",
      "description": "Measuring not more than 5.25 m<sup>2</sup> in area (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.29.2090",
      "rawHtsCode": "5703.29.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.31.00",
      "rawHtsCode": "5703.31.00",
      "superior": null,
      "indent": "2",
      "description": "Turf",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,B,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5703.31.0030",
      "rawHtsCode": "5703.31.00.30",
      "superior": null,
      "indent": "3",
      "description": "Measuring not more than <il>5.25 m<sup>2</sup></il> in area (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.31.0060",
      "rawHtsCode": "5703.31.00.60",
      "superior": null,
      "indent": "4",
      "description": "In rolls of a width equal to or exceeding 1.0 meter, or in sheets measuring 1.0 meter or greater on any side (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.31.0085",
      "rawHtsCode": "5703.31.00.85",
      "superior": null,
      "indent": "4",
      "description": "Other (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.39",
      "rawHtsCode": "5703.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.39.1000",
      "rawHtsCode": "5703.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Hand-hooked, that is, in which the tufts were inserted by hand or by means of a hand tool (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5703.39.20",
      "rawHtsCode": "5703.39.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,B,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5703.39.2030",
      "rawHtsCode": "5703.39.20.30",
      "superior": null,
      "indent": "4",
      "description": "Measuring not more than <il>5.25 m<sup>2</sup></il> in area (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.39.2090",
      "rawHtsCode": "5703.39.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5703.90.0000",
      "rawHtsCode": "5703.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5704",
      "rawHtsCode": "5704",
      "superior": null,
      "indent": "0",
      "description": "Carpets and other textile floor coverings, of felt, not tufted or flocked, whether or not made up:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5704.10.00",
      "rawHtsCode": "5704.10.00",
      "superior": null,
      "indent": "1",
      "description": "Tiles, having a maximum surface area of <il>0.3 m<sup>2</sup></il>",
      "units": [],
      "generalRate": "4.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5704.10.0010",
      "rawHtsCode": "5704.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5704.10.0090",
      "rawHtsCode": "5704.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5704.20.00",
      "rawHtsCode": "5704.20.00",
      "superior": null,
      "indent": "1",
      "description": "Tiles, having a maximum surface area exceeding 0.3m<sup>2</sup> but not exceeding 1m<sup>2</sup>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5704.20.0010",
      "rawHtsCode": "5704.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5704.20.0090",
      "rawHtsCode": "5704.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5704.90.01",
      "rawHtsCode": "5704.90.01",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5704.90.0110",
      "rawHtsCode": "5704.90.01.10",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5704.90.0190",
      "rawHtsCode": "5704.90.01.90",
      "superior": null,
      "indent": "2",
      "description": "Other (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5705.00",
      "rawHtsCode": "5705.00",
      "superior": null,
      "indent": "0",
      "description": "Other carpets and other textile floor coverings, whether or not made up:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5705.00.1000",
      "rawHtsCode": "5705.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of coir",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "16%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5705.00.20",
      "rawHtsCode": "5705.00.20",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (AU,B,BH, CL,CO,E*,IL,JO,KR,MA,NP,OM,P,PA, PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5705.00.2005",
      "rawHtsCode": "5705.00.20.05",
      "superior": null,
      "indent": "3",
      "description": "Needlepoint (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5705.00.2015",
      "rawHtsCode": "5705.00.20.15",
      "superior": null,
      "indent": "3",
      "description": "Other (465)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5705.00.2020",
      "rawHtsCode": "5705.00.20.20",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (369)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5705.00.2030",
      "rawHtsCode": "5705.00.20.30",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (665)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5705.00.2090",
      "rawHtsCode": "5705.00.20.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801",
      "rawHtsCode": "5801",
      "superior": null,
      "indent": "0",
      "description": "Woven pile fabrics and chenille fabrics, other than fabrics of heading 5802 or 5806:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.10.0000",
      "rawHtsCode": "5801.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of wool or fine animal hair (414)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "5801.21.0000",
      "rawHtsCode": "5801.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Uncut weft pile fabrics (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "20.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.22",
      "rawHtsCode": "5801.22",
      "superior": null,
      "indent": "2",
      "description": "Cut corduroy:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.22.1000",
      "rawHtsCode": "5801.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Greater than 7.5 wales per cm (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.22.9000",
      "rawHtsCode": "5801.22.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "20.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.23.0000",
      "rawHtsCode": "5801.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other weft pile fabrics (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "44%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.26.00",
      "rawHtsCode": "5801.26.00",
      "superior": null,
      "indent": "2",
      "description": "Chenille fabrics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5801.26.0010",
      "rawHtsCode": "5801.26.00.10",
      "superior": null,
      "indent": "3",
      "description": "With chenille yarns on one side only (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.26.0020",
      "rawHtsCode": "5801.26.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.27",
      "rawHtsCode": "5801.27",
      "superior": null,
      "indent": "2",
      "description": "Warp pile fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.27.1000",
      "rawHtsCode": "5801.27.10.00",
      "superior": null,
      "indent": "3",
      "description": "Epinglé (uncut) (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "10.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.27.50",
      "rawHtsCode": "5801.27.50",
      "superior": null,
      "indent": "3",
      "description": "Cut (224)",
      "units": [],
      "generalRate": "18.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.27.5010",
      "rawHtsCode": "5801.27.50.10",
      "superior": null,
      "indent": "4",
      "description": "Over 271 grams per square meter (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.27.5020",
      "rawHtsCode": "5801.27.50.20",
      "superior": null,
      "indent": "4",
      "description": "Other (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.31.0000",
      "rawHtsCode": "5801.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Uncut weft pile fabrics (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "17.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "79.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.32.0000",
      "rawHtsCode": "5801.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cut corduroy (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "79.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.33.0000",
      "rawHtsCode": "5801.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other weft pile fabrics (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "9.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "79.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.36.00",
      "rawHtsCode": "5801.36.00",
      "superior": null,
      "indent": "2",
      "description": "Chenille fabrics",
      "units": [],
      "generalRate": "9.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "79.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.36.0010",
      "rawHtsCode": "5801.36.00.10",
      "superior": null,
      "indent": "3",
      "description": "With chenille yarns on one side only (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.36.0020",
      "rawHtsCode": "5801.36.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.37",
      "rawHtsCode": "5801.37",
      "superior": null,
      "indent": "2",
      "description": "Warp pile fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.37.1000",
      "rawHtsCode": "5801.37.10.00",
      "superior": null,
      "indent": "3",
      "description": "Epinglé (uncut) (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "79.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.37.50",
      "rawHtsCode": "5801.37.50",
      "superior": null,
      "indent": "3",
      "description": "Cut",
      "units": [],
      "generalRate": "17.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "79.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.37.5010",
      "rawHtsCode": "5801.37.50.10",
      "superior": null,
      "indent": "4",
      "description": "Over 271 grams per square meter (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.37.5020",
      "rawHtsCode": "5801.37.50.20",
      "superior": null,
      "indent": "4",
      "description": "Other (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.90",
      "rawHtsCode": "5801.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.90.1000",
      "rawHtsCode": "5801.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of vegetable fibers, except cotton (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.90.20",
      "rawHtsCode": "5801.90.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5801.90.2010",
      "rawHtsCode": "5801.90.20.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5801.90.2090",
      "rawHtsCode": "5801.90.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5802",
      "rawHtsCode": "5802",
      "superior": null,
      "indent": "0",
      "description": "Terry toweling and similar woven terry fabrics, other than narrow fabrics of heading 5806; tufted textile fabrics, other than products of heading 5703:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5802.10",
      "rawHtsCode": "5802.10",
      "superior": null,
      "indent": "1",
      "description": "Terry toweling and similar woven terry fabrics, of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5802.10.1000",
      "rawHtsCode": "5802.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "9.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5802.10.9000",
      "rawHtsCode": "5802.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "9.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5802.20.00",
      "rawHtsCode": "5802.20.00",
      "superior": null,
      "indent": "1",
      "description": "Terry toweling and similar woven terry fabrics, of other textile materials",
      "units": [],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH,CL, CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "79.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5802.20.0010",
      "rawHtsCode": "5802.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5802.20.0020",
      "rawHtsCode": "5802.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5802.20.0090",
      "rawHtsCode": "5802.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5802.30.00",
      "rawHtsCode": "5802.30.00",
      "superior": null,
      "indent": "1",
      "description": "Tufted textile fabrics",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "79.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5802.30.0010",
      "rawHtsCode": "5802.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5802.30.0020",
      "rawHtsCode": "5802.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (414)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5802.30.0030",
      "rawHtsCode": "5802.30.00.30",
      "superior": null,
      "indent": "2",
      "description": "Of cotton; of man-made fibers (224)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5802.30.0090",
      "rawHtsCode": "5802.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5803.00",
      "rawHtsCode": "5803.00",
      "superior": null,
      "indent": "0",
      "description": "Gauze, other than narrow fabrics of heading 5806:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5803.00.1000",
      "rawHtsCode": "5803.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of cotton (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "41.75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5803.00.2000",
      "rawHtsCode": "5803.00.20.00",
      "superior": null,
      "indent": "3",
      "description": "Tapestry fabrics and upholstery fabrics of a weight not exceeding <il>140 g/m²</il> (414)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5803.00.3000",
      "rawHtsCode": "5803.00.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other (414)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "16.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5803.00.4000",
      "rawHtsCode": "5803.00.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of vegetable fibers, except cotton (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5803.00.5000",
      "rawHtsCode": "5803.00.50.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (220)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5803.00.90",
      "rawHtsCode": "5803.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5803.00.9010",
      "rawHtsCode": "5803.00.90.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5803.00.9090",
      "rawHtsCode": "5803.00.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other (810)",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5804",
      "rawHtsCode": "5804",
      "superior": null,
      "indent": "0",
      "description": "Tulles and other net fabrics, not including woven, knitted or crocheted fabrics; lace in the piece, in strips or in motifs, other than fabrics of headings 6002 to 6006:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5804.10",
      "rawHtsCode": "5804.10",
      "superior": null,
      "indent": "1",
      "description": "Tulles and other net fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5804.10.1000",
      "rawHtsCode": "5804.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton or man-made fibers (229)",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5804.10.90",
      "rawHtsCode": "5804.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5804.10.9010",
      "rawHtsCode": "5804.10.90.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5804.10.9090",
      "rawHtsCode": "5804.10.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5804.21.0000",
      "rawHtsCode": "5804.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (229)",
      "units": [
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5804.29",
      "rawHtsCode": "5804.29",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5804.29.1000",
      "rawHtsCode": "5804.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (229)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5804.29.90",
      "rawHtsCode": "5804.29.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5804.29.9010",
      "rawHtsCode": "5804.29.90.10",
      "superior": null,
      "indent": "4",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5804.29.9090",
      "rawHtsCode": "5804.29.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5804.30.00",
      "rawHtsCode": "5804.30.00",
      "superior": null,
      "indent": "1",
      "description": "Hand-made lace",
      "units": [],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5804.30.0010",
      "rawHtsCode": "5804.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5804.30.0020",
      "rawHtsCode": "5804.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "Of cotton; of man-made fibers (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5804.30.0090",
      "rawHtsCode": "5804.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5805.00",
      "rawHtsCode": "5805.00",
      "superior": null,
      "indent": "0",
      "description": "Hand-woven tapestries of the type Gobelins, Flanders, Aubusson, Beauvais and the like, and needle-worked tapestries (for example, petit point, cross stitch), whether or not made up:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5805.00.1000",
      "rawHtsCode": "5805.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Hand-woven tapestries fit only for use as wall hangings and valued over $215 per square meter",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5805.00.2000",
      "rawHtsCode": "5805.00.20.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed and folklore products",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5805.00.2500",
      "rawHtsCode": "5805.00.25.00",
      "superior": null,
      "indent": "3",
      "description": "Other (414)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "64.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "5805.00.3000",
      "rawHtsCode": "5805.00.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (369)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5805.00.40",
      "rawHtsCode": "5805.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "5805.00.4010",
      "rawHtsCode": "5805.00.40.10",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers (666)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5805.00.4090",
      "rawHtsCode": "5805.00.40.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806",
      "rawHtsCode": "5806",
      "superior": null,
      "indent": "0",
      "description": "Narrow woven fabrics, other than goods of heading 5807; narrow fabrics consisting of warp without weft assembled by means of an adhesive (bolducs):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.10",
      "rawHtsCode": "5806.10",
      "superior": null,
      "indent": "1",
      "description": "Woven pile fabrics (including terry toweling and similar terry fabrics) and chenille fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.10.1000",
      "rawHtsCode": "5806.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (229)",
      "units": [
        "kg"
      ],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "62.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5806.10.2400",
      "rawHtsCode": "5806.10.24.00",
      "superior": null,
      "indent": "3",
      "description": "Fastener fabric tapes (229)",
      "units": [
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5806.10.2800",
      "rawHtsCode": "5806.10.28.00",
      "superior": null,
      "indent": "3",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5806.10.30",
      "rawHtsCode": "5806.10.30",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "59%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5806.10.3010",
      "rawHtsCode": "5806.10.30.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.10.3020",
      "rawHtsCode": "5806.10.30.20",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (414)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.10.3090",
      "rawHtsCode": "5806.10.30.90",
      "superior": null,
      "indent": "3",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.20.00",
      "rawHtsCode": "5806.20.00",
      "superior": null,
      "indent": "1",
      "description": "Other woven fabrics, containing by weight 5 percent or more of elastomeric yarn or rubber thread",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5806.20.0010",
      "rawHtsCode": "5806.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Containing elastomeric yarn (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.20.0090",
      "rawHtsCode": "5806.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.31.0000",
      "rawHtsCode": "5806.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (229)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5806.32",
      "rawHtsCode": "5806.32",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.32.10",
      "rawHtsCode": "5806.32.10",
      "superior": null,
      "indent": "3",
      "description": "Ribbons",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "76.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5806.32.1010",
      "rawHtsCode": "5806.32.10.10",
      "superior": null,
      "indent": "4",
      "description": "Suitable for the manufacture of typewriter or similar ribbons of heading 9612 (621)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.32.1020",
      "rawHtsCode": "5806.32.10.20",
      "superior": null,
      "indent": "8",
      "description": "Containing wire in selvedge (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.32.1030",
      "rawHtsCode": "5806.32.10.30",
      "superior": null,
      "indent": "8",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.32.1040",
      "rawHtsCode": "5806.32.10.40",
      "superior": null,
      "indent": "7",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.32.1050",
      "rawHtsCode": "5806.32.10.50",
      "superior": null,
      "indent": "8",
      "description": "Containing wire in selvedge (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.32.1060",
      "rawHtsCode": "5806.32.10.60",
      "superior": null,
      "indent": "8",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.32.1070",
      "rawHtsCode": "5806.32.10.70",
      "superior": null,
      "indent": "7",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.32.1080",
      "rawHtsCode": "5806.32.10.80",
      "superior": null,
      "indent": "6",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.32.1095",
      "rawHtsCode": "5806.32.10.95",
      "superior": null,
      "indent": "5",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.32.2000",
      "rawHtsCode": "5806.32.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "84%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5806.39",
      "rawHtsCode": "5806.39",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.39.1000",
      "rawHtsCode": "5806.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (414)",
      "units": [
        "kg"
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "59%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5806.39.2000",
      "rawHtsCode": "5806.39.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of vegetable fibers, except cotton (899)",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5806.39.30",
      "rawHtsCode": "5806.39.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5806.39.3010",
      "rawHtsCode": "5806.39.30.10",
      "superior": null,
      "indent": "4",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.39.3020",
      "rawHtsCode": "5806.39.30.20",
      "superior": null,
      "indent": "5",
      "description": "Of metalized yarn (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.39.3080",
      "rawHtsCode": "5806.39.30.80",
      "superior": null,
      "indent": "5",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5806.40.0000",
      "rawHtsCode": "5806.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Fabrics consisting of warp without weft assembled by means of an adhesive (bolducs)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5807",
      "rawHtsCode": "5807",
      "superior": null,
      "indent": "0",
      "description": "Labels, badges and similar articles of textile materials, in the piece, in strips or cut to shape or size, not embroidered:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5807.10",
      "rawHtsCode": "5807.10",
      "superior": null,
      "indent": "1",
      "description": "Woven:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5807.10.05",
      "rawHtsCode": "5807.10.05",
      "superior": null,
      "indent": "3",
      "description": "Of cotton or man-made fibers",
      "units": [],
      "generalRate": "7.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "71.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5807.10.0510",
      "rawHtsCode": "5807.10.05.10",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (369)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5807.10.0520",
      "rawHtsCode": "5807.10.05.20",
      "superior": null,
      "indent": "4",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5807.10.1500",
      "rawHtsCode": "5807.10.15.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "71.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5807.10.20",
      "rawHtsCode": "5807.10.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5807.10.2010",
      "rawHtsCode": "5807.10.20.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5807.10.2020",
      "rawHtsCode": "5807.10.20.20",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5807.10.2090",
      "rawHtsCode": "5807.10.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5807.90",
      "rawHtsCode": "5807.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5807.90.05",
      "rawHtsCode": "5807.90.05",
      "superior": null,
      "indent": "3",
      "description": "Of cotton or man-made fibers",
      "units": [],
      "generalRate": "7.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "71.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5807.90.0510",
      "rawHtsCode": "5807.90.05.10",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (369)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5807.90.0520",
      "rawHtsCode": "5807.90.05.20",
      "superior": null,
      "indent": "4",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5807.90.1500",
      "rawHtsCode": "5807.90.15.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "71.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5807.90.20",
      "rawHtsCode": "5807.90.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5807.90.2010",
      "rawHtsCode": "5807.90.20.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5807.90.2020",
      "rawHtsCode": "5807.90.20.20",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5807.90.2090",
      "rawHtsCode": "5807.90.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5808",
      "rawHtsCode": "5808",
      "superior": null,
      "indent": "0",
      "description": "Braids in the piece; ornamental trimmings in the piece, without embroidery, other than knitted or crocheted; tassels, pompons and similar articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5808.10",
      "rawHtsCode": "5808.10",
      "superior": null,
      "indent": "1",
      "description": "Braids in the piece:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5808.10.1000",
      "rawHtsCode": "5808.10.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of abaca or ramie (899)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5808.10.4000",
      "rawHtsCode": "5808.10.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton or man-made fibers (229)",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5808.10.5000",
      "rawHtsCode": "5808.10.50.00",
      "superior": null,
      "indent": "3",
      "description": "Of other textile materials",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5808.10.7000",
      "rawHtsCode": "5808.10.70.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton or man-made fibers (229)",
      "units": [
        "kg"
      ],
      "generalRate": "7.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5808.10.9000",
      "rawHtsCode": "5808.10.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5808.90.00",
      "rawHtsCode": "5808.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5808.90.0010",
      "rawHtsCode": "5808.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of cotton; of man-made fibers (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5808.90.0090",
      "rawHtsCode": "5808.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5809.00.0000",
      "rawHtsCode": "5809.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of metal thread and woven fabrics of metalized yarn of heading 5605, of a kind used in apparel, as furnishing fabrics or for similar purposes, not elsewhere specified or included (229)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5810",
      "rawHtsCode": "5810",
      "superior": null,
      "indent": "0",
      "description": "Embroidery in the piece, in strips or in motifs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5810.10.0000",
      "rawHtsCode": "5810.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Embroidery without visible ground (229)",
      "units": [
        "kg"
      ],
      "generalRate": "14.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5810.91.00",
      "rawHtsCode": "5810.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "See additional U.S. note 1",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "See additional U.S. note 1",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5810.91.0010",
      "rawHtsCode": "5810.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Weighing over 200 g/m²",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5810.91.0020",
      "rawHtsCode": "5810.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5810.92",
      "rawHtsCode": "5810.92",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5810.92.1000",
      "rawHtsCode": "5810.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "Badges, emblems and motifs",
      "units": [
        "kg"
      ],
      "generalRate": "See additional U.S. note 2",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "See additional U.S. note 2",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5810.92.90",
      "rawHtsCode": "5810.92.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "See additional U.S. note 3",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "See additional U.S. note 3",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5810.92.9030",
      "rawHtsCode": "5810.92.90.30",
      "superior": null,
      "indent": "4",
      "description": "Labels (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5810.92.9050",
      "rawHtsCode": "5810.92.90.50",
      "superior": null,
      "indent": "5",
      "description": "On a ground fabric weighing less than <il>100 g/m²</il> and of a width of more than <il>225 cm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5810.92.9080",
      "rawHtsCode": "5810.92.90.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5810.99",
      "rawHtsCode": "5810.99",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5810.99.1000",
      "rawHtsCode": "5810.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (414)",
      "units": [
        "kg"
      ],
      "generalRate": "See additional U.S. note 4",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "See additional U.S. note 4",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5810.99.9000",
      "rawHtsCode": "5810.99.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "See additional U.S. note 5",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "See additional U.S. note 5",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5811.00",
      "rawHtsCode": "5811.00",
      "superior": null,
      "indent": "0",
      "description": "Quilted textile products in the piece, composed of one or more layers of textile materials assembled with padding by stitching or otherwise, other than embroidery of heading 5810:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5811.00.1000",
      "rawHtsCode": "5811.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of wool or fine animal hair (414)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "57%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5811.00.2000",
      "rawHtsCode": "5811.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of cotton (229)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5811.00.3000",
      "rawHtsCode": "5811.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers (229)",
      "units": [
        "m²",
        "<u>kg</u>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5811.00.4000",
      "rawHtsCode": "5811.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials",
      "units": [
        "m²",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5901",
      "rawHtsCode": "5901",
      "superior": null,
      "indent": "0",
      "description": "Textile fabrics coated with gum or amylaceous substances, of a kind used for the outer covers of books or the like; tracing cloth; prepared painting canvas; buckram and similar stiffened textile fabrics of a kind used for hat foundations:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5901.10",
      "rawHtsCode": "5901.10",
      "superior": null,
      "indent": "1",
      "description": "Textile fabrics coated with gum or amylaceous sub- stances, of a kind used for the outer covers of books or the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5901.10.1000",
      "rawHtsCode": "5901.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "74.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5901.10.2000",
      "rawHtsCode": "5901.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5901.90",
      "rawHtsCode": "5901.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5901.90.2000",
      "rawHtsCode": "5901.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "74.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5901.90.4000",
      "rawHtsCode": "5901.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5902",
      "rawHtsCode": "5902",
      "superior": null,
      "indent": "0",
      "description": "Tire cord fabric of high tenacity yarn of nylon or other poly- amides, polyesters or viscose rayon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5902.10.0000",
      "rawHtsCode": "5902.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of nylon or other polyamides (229)",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5902.20.0000",
      "rawHtsCode": "5902.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of polyesters (229)",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5902.90.0000",
      "rawHtsCode": "5902.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other (229)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5903",
      "rawHtsCode": "5903",
      "superior": null,
      "indent": "0",
      "description": "Textile fabrics impregnated, coated, covered or laminated with plastics, other than those of heading 5902:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5903.10",
      "rawHtsCode": "5903.10",
      "superior": null,
      "indent": "1",
      "description": "With poly(vinyl chloride):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5903.10.1000",
      "rawHtsCode": "5903.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5903.10.1500",
      "rawHtsCode": "5903.10.15.00",
      "superior": null,
      "indent": "4",
      "description": "Over 60 percent by weight of plastics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "5903.10.1800",
      "rawHtsCode": "5903.10.18.00",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "14.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5903.10.20",
      "rawHtsCode": "5903.10.20",
      "superior": null,
      "indent": "4",
      "description": "Over 70 percent by weight of rubber or plastics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "5903.10.2010",
      "rawHtsCode": "5903.10.20.10",
      "superior": null,
      "indent": "5",
      "description": "Fabrics, of yarns sheathed with poly(vinyl chloride), not otherwise impregnated, coated, covered or laminated",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5903.10.2090",
      "rawHtsCode": "5903.10.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5903.10.2500",
      "rawHtsCode": "5903.10.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "84.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5903.10.3000",
      "rawHtsCode": "5903.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5903.20",
      "rawHtsCode": "5903.20",
      "superior": null,
      "indent": "1",
      "description": "With polyurethane:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5903.20.1000",
      "rawHtsCode": "5903.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR, MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5903.20.1500",
      "rawHtsCode": "5903.20.15.00",
      "superior": null,
      "indent": "4",
      "description": "Over 60 percent by weight of plastics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5903.20.1800",
      "rawHtsCode": "5903.20.18.00",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5903.20.2000",
      "rawHtsCode": "5903.20.20.00",
      "superior": null,
      "indent": "4",
      "description": "Over 70 percent by weight of rubber or plastics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "5903.20.2500",
      "rawHtsCode": "5903.20.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "84.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5903.20.30",
      "rawHtsCode": "5903.20.30",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5903.20.3010",
      "rawHtsCode": "5903.20.30.10",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5903.20.3090",
      "rawHtsCode": "5903.20.30.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5903.90",
      "rawHtsCode": "5903.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5903.90.1000",
      "rawHtsCode": "5903.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5903.90.1500",
      "rawHtsCode": "5903.90.15.00",
      "superior": null,
      "indent": "4",
      "description": "Over 60 percent by weight of plastics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5903.90.1800",
      "rawHtsCode": "5903.90.18.00",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5903.90.2000",
      "rawHtsCode": "5903.90.20.00",
      "superior": null,
      "indent": "4",
      "description": "Over 70 percent by weight of rubber or plastics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "5903.90.2500",
      "rawHtsCode": "5903.90.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PE,S,SG)",
      "otherRate": "84.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5903.90.30",
      "rawHtsCode": "5903.90.30",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5903.90.3010",
      "rawHtsCode": "5903.90.30.10",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (414)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5903.90.3090",
      "rawHtsCode": "5903.90.30.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5904",
      "rawHtsCode": "5904",
      "superior": null,
      "indent": "0",
      "description": "Linoleum, whether or not cut to shape; floor coverings con- sisting of a coating or covering applied on a textile backing, whether or not cut to shape:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5904.10.0000",
      "rawHtsCode": "5904.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Linoleum",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5904.90",
      "rawHtsCode": "5904.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5904.90.1000",
      "rawHtsCode": "5904.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "With a base consisting of needleloom felt or non- wovens",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5904.90.9000",
      "rawHtsCode": "5904.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5905.00",
      "rawHtsCode": "5905.00",
      "superior": null,
      "indent": "0",
      "description": "Textile wall coverings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5905.00.1000",
      "rawHtsCode": "5905.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Backed with permanently affixed paper",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.3¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5905.00.9000",
      "rawHtsCode": "5905.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5906",
      "rawHtsCode": "5906",
      "superior": null,
      "indent": "0",
      "description": "Rubberized textile fabrics, other than those of heading 5902:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5906.10.0000",
      "rawHtsCode": "5906.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Adhesive tape of a width not exceeding 20 cm",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5906.91",
      "rawHtsCode": "5906.91",
      "superior": null,
      "indent": "2",
      "description": "Knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5906.91.1000",
      "rawHtsCode": "5906.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5906.91.2000",
      "rawHtsCode": "5906.91.20.00",
      "superior": null,
      "indent": "4",
      "description": "Over 70 percent by weight of rubber or plastics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5906.91.2500",
      "rawHtsCode": "5906.91.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "84.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5906.91.3000",
      "rawHtsCode": "5906.91.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5906.99",
      "rawHtsCode": "5906.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5906.99.1000",
      "rawHtsCode": "5906.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5906.99.2000",
      "rawHtsCode": "5906.99.20.00",
      "superior": null,
      "indent": "4",
      "description": "Over 70 percent by weight of rubber or plastics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5906.99.2500",
      "rawHtsCode": "5906.99.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "84.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5906.99.3000",
      "rawHtsCode": "5906.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5907.00",
      "rawHtsCode": "5907.00",
      "superior": null,
      "indent": "0",
      "description": "Textile fabrics otherwise impregnated, coated or covered; painted canvas being theatrical scenery, studio back-cloths or the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5907.00.0500",
      "rawHtsCode": "5907.00.05.00",
      "superior": null,
      "indent": "3",
      "description": "Theatrical, ballet, and operatic scenery and properties, including sets (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5907.00.1500",
      "rawHtsCode": "5907.00.15.00",
      "superior": null,
      "indent": "3",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5907.00.2500",
      "rawHtsCode": "5907.00.25.00",
      "superior": null,
      "indent": "3",
      "description": "Theatrical, ballet, and operatic scenery and properties, including sets (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5907.00.3500",
      "rawHtsCode": "5907.00.35.00",
      "superior": null,
      "indent": "3",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5907.00.6000",
      "rawHtsCode": "5907.00.60.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.",
        "See subheading 9907.59.01."
      ],
      "flags": []
    },
    {
      "htsCode": "5907.00.80",
      "rawHtsCode": "5907.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.",
        "See subheading 9907.59.01."
      ],
      "flags": []
    },
    {
      "htsCode": "5907.00.8010",
      "rawHtsCode": "5907.00.80.10",
      "superior": null,
      "indent": "3",
      "description": "Of vegetable fibers, except cotton (810)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5907.00.8090",
      "rawHtsCode": "5907.00.80.90",
      "superior": null,
      "indent": "3",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5908.00.0000",
      "rawHtsCode": "5908.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Textile wicks, woven, plaited or knitted, for lamps, stoves, lighters, candles or the like; incandescent gas mantles and tubular knitted gas mantle fabric therefor, whether or not impregnated",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5909.00",
      "rawHtsCode": "5909.00",
      "superior": null,
      "indent": "0",
      "description": "Textile hosepiping and similar textile tubing, with or without lining, armor or accessories of other materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5909.00.1000",
      "rawHtsCode": "5909.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of vegetable fibers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "21.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5909.00.2000",
      "rawHtsCode": "5909.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (AU,B,BH, CL,CO,E*,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "88.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5910.00",
      "rawHtsCode": "5910.00",
      "superior": null,
      "indent": "0",
      "description": "Transmission or conveyor belts or belting, of textile material, whether or not impregnated, coated, covered or laminated with plastics, or reinforced with metal or other material:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5910.00.10",
      "rawHtsCode": "5910.00.10",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5910.00.1010",
      "rawHtsCode": "5910.00.10.10",
      "superior": null,
      "indent": "4",
      "description": "V-belts",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5910.00.1020",
      "rawHtsCode": "5910.00.10.20",
      "superior": null,
      "indent": "4",
      "description": "Synchronous belts",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5910.00.1030",
      "rawHtsCode": "5910.00.10.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5910.00.1060",
      "rawHtsCode": "5910.00.10.60",
      "superior": null,
      "indent": "4",
      "description": "Link",
      "units": [
        "m",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5910.00.1070",
      "rawHtsCode": "5910.00.10.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5910.00.1090",
      "rawHtsCode": "5910.00.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5910.00.9000",
      "rawHtsCode": "5910.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5911",
      "rawHtsCode": "5911",
      "superior": null,
      "indent": "0",
      "description": "Textile products and articles, for technical uses, specified in note 8 to this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5911.10",
      "rawHtsCode": "5911.10",
      "superior": null,
      "indent": "1",
      "description": "Textile fabrics, felt and felt-lined woven fabrics, coated, covered or laminated with rubber, leather or other material, of a kind used for card clothing, and similar fabrics of a kind used for other technical purposes, including narrow fabrics made of velvet impregnated with rubber, for covering weaving spindles (weaving beams):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5911.10.1000",
      "rawHtsCode": "5911.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Printers' rubberized blankets",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5911.10.2000",
      "rawHtsCode": "5911.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5911.20",
      "rawHtsCode": "5911.20",
      "superior": null,
      "indent": "1",
      "description": "Bolting cloth, whether or not made up:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5911.20.1000",
      "rawHtsCode": "5911.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fabrics principally used for stenciling purposes in screen-process printing",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "62%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5911.20.2000",
      "rawHtsCode": "5911.20.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of silk",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5911.20.3000",
      "rawHtsCode": "5911.20.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other (229)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "63%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "5911.31.00",
      "rawHtsCode": "5911.31.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing less than 650 g/m<sup>2</sup>",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5911.31.0010",
      "rawHtsCode": "5911.31.00.10",
      "superior": null,
      "indent": "3",
      "description": "Press felts",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5911.31.0020",
      "rawHtsCode": "5911.31.00.20",
      "superior": null,
      "indent": "3",
      "description": "Dryer felts and dryer fabrics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5911.31.0030",
      "rawHtsCode": "5911.31.00.30",
      "superior": null,
      "indent": "3",
      "description": "Paper-forming fabrics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5911.31.0080",
      "rawHtsCode": "5911.31.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5911.32.00",
      "rawHtsCode": "5911.32.00",
      "superior": null,
      "indent": "2",
      "description": "Weighing 650 g/m<sup>2</sup> or more",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5911.32.0010",
      "rawHtsCode": "5911.32.00.10",
      "superior": null,
      "indent": "3",
      "description": "Press felts",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5911.32.0020",
      "rawHtsCode": "5911.32.00.20",
      "superior": null,
      "indent": "3",
      "description": "Dryer felts and dryer fabrics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5911.32.0030",
      "rawHtsCode": "5911.32.00.30",
      "superior": null,
      "indent": "3",
      "description": "Paper-forming fabrics",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5911.32.0080",
      "rawHtsCode": "5911.32.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5911.40.0100",
      "rawHtsCode": "5911.40.01.00",
      "superior": null,
      "indent": "1",
      "description": "Filtering or straining cloth of a kind used in oil presses or the like, including that of human hair",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "81%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5911.90.00",
      "rawHtsCode": "5911.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,B,BH, CL,CO,E*,IL, JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.",
        "See headings 9902.22.84 and 9902.25.64."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "5911.90.0040",
      "rawHtsCode": "5911.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Cords, braids and the like of a kind used in industry as packing or lubricating material",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "5911.90.0080",
      "rawHtsCode": "5911.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6001",
      "rawHtsCode": "6001",
      "superior": null,
      "indent": "0",
      "description": "Pile fabrics, including \"long pile\" fabrics and terry fabrics, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6001.10",
      "rawHtsCode": "6001.10",
      "superior": null,
      "indent": "1",
      "description": "\"Long pile\" fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6001.10.2000",
      "rawHtsCode": "6001.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (224)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "17.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "79.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6001.10.6000",
      "rawHtsCode": "6001.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other (224)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6001.21.0000",
      "rawHtsCode": "6001.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (224)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "9.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6001.22.0000",
      "rawHtsCode": "6001.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (224)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "17.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "79.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6001.29.0000",
      "rawHtsCode": "6001.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials (414)",
      "units": [
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6001.91.00",
      "rawHtsCode": "6001.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "18.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6001.91.0010",
      "rawHtsCode": "6001.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Over 271 grams per square meter (224)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6001.91.0020",
      "rawHtsCode": "6001.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other (224)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6001.92.00",
      "rawHtsCode": "6001.92.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "17.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "79.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6001.92.0010",
      "rawHtsCode": "6001.92.00.10",
      "superior": null,
      "indent": "4",
      "description": "Velour (224)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6001.92.0020",
      "rawHtsCode": "6001.92.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other (224)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6001.92.0030",
      "rawHtsCode": "6001.92.00.30",
      "superior": null,
      "indent": "4",
      "description": "Velour (224)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6001.92.0040",
      "rawHtsCode": "6001.92.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other (224)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6001.99",
      "rawHtsCode": "6001.99",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6001.99.1000",
      "rawHtsCode": "6001.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6001.99.9000",
      "rawHtsCode": "6001.99.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (414)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "61.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6002",
      "rawHtsCode": "6002",
      "superior": null,
      "indent": "0",
      "description": "Knitted or crocheted fabrics of a width not exceeding <il>30 cm</il>, containing by weight <il>5 percent</il> or more of elastomeric yarn or rubber thread, other than those of heading 6001:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6002.40",
      "rawHtsCode": "6002.40",
      "superior": null,
      "indent": "1",
      "description": "Containing by weight 5 percent or more of elastomeric yarn but not containing rubber thread:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6002.40.4000",
      "rawHtsCode": "6002.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (222)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6002.40.80",
      "rawHtsCode": "6002.40.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6002.40.8020",
      "rawHtsCode": "6002.40.80.20",
      "superior": null,
      "indent": "3",
      "description": "Open-work fabrics, warp knit (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6002.40.8080",
      "rawHtsCode": "6002.40.80.80",
      "superior": null,
      "indent": "3",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6002.90",
      "rawHtsCode": "6002.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6002.90.4000",
      "rawHtsCode": "6002.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (222)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6002.90.80",
      "rawHtsCode": "6002.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6002.90.8020",
      "rawHtsCode": "6002.90.80.20",
      "superior": null,
      "indent": "3",
      "description": "Open-work fabrics, warp knit (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6002.90.8080",
      "rawHtsCode": "6002.90.80.80",
      "superior": null,
      "indent": "3",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6003",
      "rawHtsCode": "6003",
      "superior": null,
      "indent": "0",
      "description": "Knitted or crocheted fabrics of a width not exceeding <il>30 cm</il>, other than those of heading 6001 or 6002:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6003.10",
      "rawHtsCode": "6003.10",
      "superior": null,
      "indent": "1",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6003.10.1000",
      "rawHtsCode": "6003.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Open-work fabrics, warp knit (229)",
      "units": [
        "kg"
      ],
      "generalRate": "14.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6003.10.9000",
      "rawHtsCode": "6003.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "59%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6003.20",
      "rawHtsCode": "6003.20",
      "superior": null,
      "indent": "1",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6003.20.1000",
      "rawHtsCode": "6003.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Open-work fabrics, warp knit (229)",
      "units": [
        "kg"
      ],
      "generalRate": "14.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6003.20.3000",
      "rawHtsCode": "6003.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6003.30",
      "rawHtsCode": "6003.30",
      "superior": null,
      "indent": "1",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6003.30.1000",
      "rawHtsCode": "6003.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Open-work fabrics, warp knit (229)",
      "units": [
        "kg"
      ],
      "generalRate": "14.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6003.30.6000",
      "rawHtsCode": "6003.30.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "7.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6003.40",
      "rawHtsCode": "6003.40",
      "superior": null,
      "indent": "1",
      "description": "Of artificial fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6003.40.1000",
      "rawHtsCode": "6003.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Open-work fabrics, warp knit (229)",
      "units": [
        "kg"
      ],
      "generalRate": "14.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6003.40.6000",
      "rawHtsCode": "6003.40.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "7.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6003.90",
      "rawHtsCode": "6003.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6003.90.1000",
      "rawHtsCode": "6003.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Open-work fabrics, warp knit (229)",
      "units": [
        "kg"
      ],
      "generalRate": "14.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6003.90.9000",
      "rawHtsCode": "6003.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "59%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6004",
      "rawHtsCode": "6004",
      "superior": null,
      "indent": "0",
      "description": "Knitted or crocheted fabrics of a width exceeding <il>30 cm</il>, containing by weight <il>5 percent</il> or more of elastomeric yarn or rubber thread, other than those of heading 6001:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6004.10.00",
      "rawHtsCode": "6004.10.00",
      "superior": null,
      "indent": "1",
      "description": "Containing by weight <il>5 percent</il> or more of elastomeric yarn but not containing rubber thread",
      "units": [],
      "generalRate": "12.3%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6004.10.0010",
      "rawHtsCode": "6004.10.00.10",
      "superior": null,
      "indent": "3",
      "description": "Open-work figured fabrics (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6004.10.0025",
      "rawHtsCode": "6004.10.00.25",
      "superior": null,
      "indent": "3",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6004.10.0085",
      "rawHtsCode": "6004.10.00.85",
      "superior": null,
      "indent": "2",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6004.90",
      "rawHtsCode": "6004.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6004.90.20",
      "rawHtsCode": "6004.90.20",
      "superior": null,
      "indent": "2",
      "description": "Containing elastomeric yarn and rubber thread",
      "units": [],
      "generalRate": "12.3%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6004.90.2010",
      "rawHtsCode": "6004.90.20.10",
      "superior": null,
      "indent": "4",
      "description": "Open-work figured fabrics (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6004.90.2025",
      "rawHtsCode": "6004.90.20.25",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6004.90.2085",
      "rawHtsCode": "6004.90.20.85",
      "superior": null,
      "indent": "3",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6004.90.9000",
      "rawHtsCode": "6004.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005",
      "rawHtsCode": "6005",
      "superior": null,
      "indent": "0",
      "description": "Warp knit fabrics (including those made on galloon knitting machines), other than those of headings 6001 to 6004:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.21.0000",
      "rawHtsCode": "6005.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached (222)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.22.0000",
      "rawHtsCode": "6005.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dyed (222)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.23.0000",
      "rawHtsCode": "6005.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors (222)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.24.0000",
      "rawHtsCode": "6005.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Printed (222)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.35.0000",
      "rawHtsCode": "6005.35.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fabrics specified in subheading note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.36.00",
      "rawHtsCode": "6005.36.00",
      "superior": null,
      "indent": "2",
      "description": "Other, unbleached or bleached",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.36.0010",
      "rawHtsCode": "6005.36.00.10",
      "superior": null,
      "indent": "3",
      "description": "Open-work fabrics (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.36.0020",
      "rawHtsCode": "6005.36.00.20",
      "superior": null,
      "indent": "4",
      "description": "Stitch-bonded goods (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.36.0080",
      "rawHtsCode": "6005.36.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.37.00",
      "rawHtsCode": "6005.37.00",
      "superior": null,
      "indent": "2",
      "description": "Other, dyed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.37.0010",
      "rawHtsCode": "6005.37.00.10",
      "superior": null,
      "indent": "3",
      "description": "Open-work fabrics (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.37.0020",
      "rawHtsCode": "6005.37.00.20",
      "superior": null,
      "indent": "4",
      "description": "Stitch-bonded goods (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.37.0080",
      "rawHtsCode": "6005.37.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.38.00",
      "rawHtsCode": "6005.38.00",
      "superior": null,
      "indent": "2",
      "description": "Other, of yarns of different colors",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.38.0010",
      "rawHtsCode": "6005.38.00.10",
      "superior": null,
      "indent": "3",
      "description": "Open-work fabrics (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.38.0020",
      "rawHtsCode": "6005.38.00.20",
      "superior": null,
      "indent": "4",
      "description": "Stitch-bonded goods (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.38.0080",
      "rawHtsCode": "6005.38.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.39.00",
      "rawHtsCode": "6005.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other, printed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.39.0010",
      "rawHtsCode": "6005.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Open-work fabrics (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.39.0020",
      "rawHtsCode": "6005.39.00.20",
      "superior": null,
      "indent": "4",
      "description": "Stitch-bonded goods (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.39.0080",
      "rawHtsCode": "6005.39.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.41.00",
      "rawHtsCode": "6005.41.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.41.0010",
      "rawHtsCode": "6005.41.00.10",
      "superior": null,
      "indent": "3",
      "description": "Open-work fabrics (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.41.0020",
      "rawHtsCode": "6005.41.00.20",
      "superior": null,
      "indent": "4",
      "description": "Stitch-bonded goods (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.41.0080",
      "rawHtsCode": "6005.41.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.42.00",
      "rawHtsCode": "6005.42.00",
      "superior": null,
      "indent": "2",
      "description": "Dyed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.42.0010",
      "rawHtsCode": "6005.42.00.10",
      "superior": null,
      "indent": "3",
      "description": "Open-work fabrics (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.42.0020",
      "rawHtsCode": "6005.42.00.20",
      "superior": null,
      "indent": "4",
      "description": "Stitch-bonded goods (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.42.0080",
      "rawHtsCode": "6005.42.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.43.00",
      "rawHtsCode": "6005.43.00",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.43.0010",
      "rawHtsCode": "6005.43.00.10",
      "superior": null,
      "indent": "3",
      "description": "Open-work fabrics (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.43.0020",
      "rawHtsCode": "6005.43.00.20",
      "superior": null,
      "indent": "4",
      "description": "Stitch-bonded goods (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.43.0080",
      "rawHtsCode": "6005.43.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.44.00",
      "rawHtsCode": "6005.44.00",
      "superior": null,
      "indent": "2",
      "description": "Printed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.44.0010",
      "rawHtsCode": "6005.44.00.10",
      "superior": null,
      "indent": "3",
      "description": "Open-work fabrics (229)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.44.0020",
      "rawHtsCode": "6005.44.00.20",
      "superior": null,
      "indent": "4",
      "description": "Stitch-bonded goods (223)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.44.0080",
      "rawHtsCode": "6005.44.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.90",
      "rawHtsCode": "6005.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6005.90.1000",
      "rawHtsCode": "6005.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (414)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6005.90.9000",
      "rawHtsCode": "6005.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006",
      "rawHtsCode": "6006",
      "superior": null,
      "indent": "0",
      "description": "Other knitted or crocheted fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.10.0000",
      "rawHtsCode": "6006.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of wool or fine animal hair (414)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.21",
      "rawHtsCode": "6006.21",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.21.1000",
      "rawHtsCode": "6006.21.10.00",
      "superior": null,
      "indent": "3",
      "description": "Circular knit, wholly of cotton yarns exceeding <il>100 metric</il> number per single yarn (222)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.21.90",
      "rawHtsCode": "6006.21.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.21.9020",
      "rawHtsCode": "6006.21.90.20",
      "superior": null,
      "indent": "4",
      "description": "Of single knit construction (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.21.9080",
      "rawHtsCode": "6006.21.90.80",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.22",
      "rawHtsCode": "6006.22",
      "superior": null,
      "indent": "2",
      "description": "Dyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.22.1000",
      "rawHtsCode": "6006.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Circular knit, wholly of cotton yarns exceeding <il>100 metric</il> number per single yarn (222)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.22.90",
      "rawHtsCode": "6006.22.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.22.9020",
      "rawHtsCode": "6006.22.90.20",
      "superior": null,
      "indent": "4",
      "description": "Of single knit construction (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.22.9080",
      "rawHtsCode": "6006.22.90.80",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.23",
      "rawHtsCode": "6006.23",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.23.1000",
      "rawHtsCode": "6006.23.10.00",
      "superior": null,
      "indent": "3",
      "description": "Circular knit, wholly of cotton yarns exceeding <il>100 metric</il> number per single yarn (222)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.23.90",
      "rawHtsCode": "6006.23.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.23.9020",
      "rawHtsCode": "6006.23.90.20",
      "superior": null,
      "indent": "4",
      "description": "Of single knit construction (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.23.9080",
      "rawHtsCode": "6006.23.90.80",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.24",
      "rawHtsCode": "6006.24",
      "superior": null,
      "indent": "2",
      "description": "Printed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.24.1000",
      "rawHtsCode": "6006.24.10.00",
      "superior": null,
      "indent": "3",
      "description": "Circular knit, wholly of cotton yarns exceeding <il>100 metric</il> number per single yarn (222)",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.24.90",
      "rawHtsCode": "6006.24.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.24.9020",
      "rawHtsCode": "6006.24.90.20",
      "superior": null,
      "indent": "4",
      "description": "Of single knit construction (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.24.9080",
      "rawHtsCode": "6006.24.90.80",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.31.00",
      "rawHtsCode": "6006.31.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.31.0020",
      "rawHtsCode": "6006.31.00.20",
      "superior": null,
      "indent": "4",
      "description": "Of nylon (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.31.0040",
      "rawHtsCode": "6006.31.00.40",
      "superior": null,
      "indent": "4",
      "description": "Of polyester (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.31.0060",
      "rawHtsCode": "6006.31.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.31.0080",
      "rawHtsCode": "6006.31.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.32.00",
      "rawHtsCode": "6006.32.00",
      "superior": null,
      "indent": "2",
      "description": "Dyed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.32.0020",
      "rawHtsCode": "6006.32.00.20",
      "superior": null,
      "indent": "4",
      "description": "Of nylon (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.32.0040",
      "rawHtsCode": "6006.32.00.40",
      "superior": null,
      "indent": "4",
      "description": "Of polyester (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.32.0060",
      "rawHtsCode": "6006.32.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.32.0080",
      "rawHtsCode": "6006.32.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.33.00",
      "rawHtsCode": "6006.33.00",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.33.0020",
      "rawHtsCode": "6006.33.00.20",
      "superior": null,
      "indent": "4",
      "description": "Of nylon (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.33.0040",
      "rawHtsCode": "6006.33.00.40",
      "superior": null,
      "indent": "4",
      "description": "Of polyester (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.33.0060",
      "rawHtsCode": "6006.33.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.33.0080",
      "rawHtsCode": "6006.33.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.34.00",
      "rawHtsCode": "6006.34.00",
      "superior": null,
      "indent": "2",
      "description": "Printed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.34.0020",
      "rawHtsCode": "6006.34.00.20",
      "superior": null,
      "indent": "4",
      "description": "Of nylon (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.34.0040",
      "rawHtsCode": "6006.34.00.40",
      "superior": null,
      "indent": "4",
      "description": "Of polyester (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.34.0060",
      "rawHtsCode": "6006.34.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.34.0080",
      "rawHtsCode": "6006.34.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.41.00",
      "rawHtsCode": "6006.41.00",
      "superior": null,
      "indent": "2",
      "description": "Unbleached or bleached",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.41.0025",
      "rawHtsCode": "6006.41.00.25",
      "superior": null,
      "indent": "3",
      "description": "Of double knit or interlock construction (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.41.0085",
      "rawHtsCode": "6006.41.00.85",
      "superior": null,
      "indent": "3",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.42.00",
      "rawHtsCode": "6006.42.00",
      "superior": null,
      "indent": "2",
      "description": "Dyed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.42.0025",
      "rawHtsCode": "6006.42.00.25",
      "superior": null,
      "indent": "3",
      "description": "Of double knit or interlock construction (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.42.0085",
      "rawHtsCode": "6006.42.00.85",
      "superior": null,
      "indent": "3",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.43.00",
      "rawHtsCode": "6006.43.00",
      "superior": null,
      "indent": "2",
      "description": "Of yarns of different colors",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.43.0025",
      "rawHtsCode": "6006.43.00.25",
      "superior": null,
      "indent": "3",
      "description": "Of double knit or interlock construction (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.43.0085",
      "rawHtsCode": "6006.43.00.85",
      "superior": null,
      "indent": "3",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.44.00",
      "rawHtsCode": "6006.44.00",
      "superior": null,
      "indent": "2",
      "description": "Printed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "113.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.44.0025",
      "rawHtsCode": "6006.44.00.25",
      "superior": null,
      "indent": "3",
      "description": "Of double knit or interlock construction (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.44.0085",
      "rawHtsCode": "6006.44.00.85",
      "superior": null,
      "indent": "3",
      "description": "Other (222)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.90",
      "rawHtsCode": "6006.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6006.90.1000",
      "rawHtsCode": "6006.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6006.90.9000",
      "rawHtsCode": "6006.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6101",
      "rawHtsCode": "6101",
      "superior": null,
      "indent": "0",
      "description": "Men's or boys' overcoats, carcoats, capes, cloaks, anoraks (including ski-jackets), windbreakers and similar articles, knitted or crocheted, other than those of heading 6103:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6101.20.00",
      "rawHtsCode": "6101.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of cotton",
      "units": [],
      "generalRate": "15.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6101.20.0010",
      "rawHtsCode": "6101.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Men's (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6101.20.0020",
      "rawHtsCode": "6101.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Boys' (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6101.30",
      "rawHtsCode": "6101.30",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6101.30.1000",
      "rawHtsCode": "6101.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 25 percent or more by weight of leather (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6101.30.1500",
      "rawHtsCode": "6101.30.15.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "38.6¢/kg + 10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "77.2¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6101.30.20",
      "rawHtsCode": "6101.30.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6101.30.2010",
      "rawHtsCode": "6101.30.20.10",
      "superior": null,
      "indent": "4",
      "description": "Men's (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6101.30.2020",
      "rawHtsCode": "6101.30.20.20",
      "superior": null,
      "indent": "4",
      "description": "Boys' (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6101.90",
      "rawHtsCode": "6101.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6101.90.0500",
      "rawHtsCode": "6101.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "61.7¢/kg + 16%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "77.2¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6101.90.1000",
      "rawHtsCode": "6101.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste (734)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6101.90.90",
      "rawHtsCode": "6101.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6101.90.9010",
      "rawHtsCode": "6101.90.90.10",
      "superior": null,
      "indent": "3",
      "description": "Subject to cotton restraints (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6101.90.9020",
      "rawHtsCode": "6101.90.90.20",
      "superior": null,
      "indent": "3",
      "description": "Subject to wool restraints (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6101.90.9030",
      "rawHtsCode": "6101.90.90.30",
      "superior": null,
      "indent": "3",
      "description": "Subject to man-made fiber restraints (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6101.90.9060",
      "rawHtsCode": "6101.90.90.60",
      "superior": null,
      "indent": "3",
      "description": "Other (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6102",
      "rawHtsCode": "6102",
      "superior": null,
      "indent": "0",
      "description": "Women's or girls' overcoats, carcoats, capes, cloaks, anoraks (including ski-jackets), windbreakers and similar articles, knitted or crocheted, other than those of heading 6104:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6102.10.0000",
      "rawHtsCode": "6102.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of wool or fine animal hair (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "55.9¢/kg + 16.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "68.3¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6102.20.00",
      "rawHtsCode": "6102.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of cotton",
      "units": [],
      "generalRate": "15.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6102.20.0010",
      "rawHtsCode": "6102.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Women's (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6102.20.0020",
      "rawHtsCode": "6102.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Girls' (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6102.30",
      "rawHtsCode": "6102.30",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6102.30.0500",
      "rawHtsCode": "6102.30.05.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 25 percent or more by weight of leather (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6102.30.1000",
      "rawHtsCode": "6102.30.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "64.4¢/kg + 18.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "68.3¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6102.30.20",
      "rawHtsCode": "6102.30.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6102.30.2010",
      "rawHtsCode": "6102.30.20.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6102.30.2020",
      "rawHtsCode": "6102.30.20.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6102.90",
      "rawHtsCode": "6102.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6102.90.1000",
      "rawHtsCode": "6102.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6102.90.90",
      "rawHtsCode": "6102.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6102.90.9005",
      "rawHtsCode": "6102.90.90.05",
      "superior": null,
      "indent": "3",
      "description": "Subject to cotton restraints (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6102.90.9010",
      "rawHtsCode": "6102.90.90.10",
      "superior": null,
      "indent": "3",
      "description": "Subject to wool restraints (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6102.90.9015",
      "rawHtsCode": "6102.90.90.15",
      "superior": null,
      "indent": "3",
      "description": "Subject to man-made fiber restraints (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6102.90.9030",
      "rawHtsCode": "6102.90.90.30",
      "superior": null,
      "indent": "3",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103",
      "rawHtsCode": "6103",
      "superior": null,
      "indent": "0",
      "description": "Men's or boys' suits, ensembles, suit-type jackets, blazers, trousers, bib and brace overalls, breeches and shorts (other than swimwear), knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.10",
      "rawHtsCode": "6103.10",
      "superior": null,
      "indent": "1",
      "description": "Suits:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.10.1000",
      "rawHtsCode": "6103.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "38.8¢/kg + 10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "77.2¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.10.2000",
      "rawHtsCode": "6103.10.20.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "60.3¢/kg + 15.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "77.2¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.10.3000",
      "rawHtsCode": "6103.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other (643)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.10.4000",
      "rawHtsCode": "6103.10.40.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "77.2¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.10.5000",
      "rawHtsCode": "6103.10.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other (643)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6103.10.60",
      "rawHtsCode": "6103.10.60",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [],
      "generalRate": "9.4%",
      "specialRate": "Free (AU,BH, CL,CO, IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.10.6010",
      "rawHtsCode": "6103.10.60.10",
      "superior": null,
      "indent": "4",
      "description": "Jackets imported as parts of suits (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.10.6015",
      "rawHtsCode": "6103.10.60.15",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts imported as parts of suits (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.10.6030",
      "rawHtsCode": "6103.10.60.30",
      "superior": null,
      "indent": "4",
      "description": "Waistcoats imported as parts of suits (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.10.7000",
      "rawHtsCode": "6103.10.70.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (743)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.10.90",
      "rawHtsCode": "6103.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.10.9010",
      "rawHtsCode": "6103.10.90.10",
      "superior": null,
      "indent": "5",
      "description": "Jackets imported as parts of suits (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.10.9020",
      "rawHtsCode": "6103.10.90.20",
      "superior": null,
      "indent": "5",
      "description": "Trousers, breeches, and shorts imported as parts of suits (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.10.9030",
      "rawHtsCode": "6103.10.90.30",
      "superior": null,
      "indent": "5",
      "description": "Waistcoats imported as parts of suits (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.10.9040",
      "rawHtsCode": "6103.10.90.40",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.10.9050",
      "rawHtsCode": "6103.10.90.50",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (643)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.10.9080",
      "rawHtsCode": "6103.10.90.80",
      "superior": null,
      "indent": "4",
      "description": "Other (843)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.22.00",
      "rawHtsCode": "6103.22.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.22.0010",
      "rawHtsCode": "6103.22.00.10",
      "superior": null,
      "indent": "3",
      "description": "Garments described in heading 6101 (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.22.0020",
      "rawHtsCode": "6103.22.00.20",
      "superior": null,
      "indent": "3",
      "description": "Jackets and blazers described in heading 6103 (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.22.0030",
      "rawHtsCode": "6103.22.00.30",
      "superior": null,
      "indent": "3",
      "description": "Trousers and breeches (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.22.0040",
      "rawHtsCode": "6103.22.00.40",
      "superior": null,
      "indent": "3",
      "description": "Shorts (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.22.0050",
      "rawHtsCode": "6103.22.00.50",
      "superior": null,
      "indent": "3",
      "description": "Shirts (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.22.0070",
      "rawHtsCode": "6103.22.00.70",
      "superior": null,
      "indent": "3",
      "description": "Sweaters (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.22.0080",
      "rawHtsCode": "6103.22.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other (359)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.00",
      "rawHtsCode": "6103.23.00",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.23.0005",
      "rawHtsCode": "6103.23.00.05",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6101 (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0007",
      "rawHtsCode": "6103.23.00.07",
      "superior": null,
      "indent": "4",
      "description": "Jackets and blazers described in heading 6103 (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0010",
      "rawHtsCode": "6103.23.00.10",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0025",
      "rawHtsCode": "6103.23.00.25",
      "superior": null,
      "indent": "4",
      "description": "Shirts (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0030",
      "rawHtsCode": "6103.23.00.30",
      "superior": null,
      "indent": "4",
      "description": "Sweaters (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0035",
      "rawHtsCode": "6103.23.00.35",
      "superior": null,
      "indent": "4",
      "description": "Other (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0036",
      "rawHtsCode": "6103.23.00.36",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6101 (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0037",
      "rawHtsCode": "6103.23.00.37",
      "superior": null,
      "indent": "4",
      "description": "Jackets and blazers described in heading 6103 (633)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0040",
      "rawHtsCode": "6103.23.00.40",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0045",
      "rawHtsCode": "6103.23.00.45",
      "superior": null,
      "indent": "4",
      "description": "Shorts (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0055",
      "rawHtsCode": "6103.23.00.55",
      "superior": null,
      "indent": "4",
      "description": "Bib and brace overalls (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0070",
      "rawHtsCode": "6103.23.00.70",
      "superior": null,
      "indent": "4",
      "description": "Sweaters (645)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0075",
      "rawHtsCode": "6103.23.00.75",
      "superior": null,
      "indent": "4",
      "description": "Shirts (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.23.0080",
      "rawHtsCode": "6103.23.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29",
      "rawHtsCode": "6103.29",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.05",
      "rawHtsCode": "6103.29.05",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.29.0510",
      "rawHtsCode": "6103.29.05.10",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6101 (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.0520",
      "rawHtsCode": "6103.29.05.20",
      "superior": null,
      "indent": "4",
      "description": "Jackets and blazers described in heading heading 6103 (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.0530",
      "rawHtsCode": "6103.29.05.30",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.0550",
      "rawHtsCode": "6103.29.05.50",
      "superior": null,
      "indent": "4",
      "description": "Shirts (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.0560",
      "rawHtsCode": "6103.29.05.60",
      "superior": null,
      "indent": "4",
      "description": "Sweaters (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.0570",
      "rawHtsCode": "6103.29.05.70",
      "superior": null,
      "indent": "4",
      "description": "Other (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.10",
      "rawHtsCode": "6103.29.10",
      "superior": null,
      "indent": "3",
      "description": "Of artificial fibers",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.29.1010",
      "rawHtsCode": "6103.29.10.10",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6101 (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.1015",
      "rawHtsCode": "6103.29.10.15",
      "superior": null,
      "indent": "4",
      "description": "Jackets and blazers described in heading 6103 (633)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.1020",
      "rawHtsCode": "6103.29.10.20",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.1030",
      "rawHtsCode": "6103.29.10.30",
      "superior": null,
      "indent": "4",
      "description": "Shorts (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.1040",
      "rawHtsCode": "6103.29.10.40",
      "superior": null,
      "indent": "4",
      "description": "Sweaters (645)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.1050",
      "rawHtsCode": "6103.29.10.50",
      "superior": null,
      "indent": "4",
      "description": "Shirts (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.1060",
      "rawHtsCode": "6103.29.10.60",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.20",
      "rawHtsCode": "6103.29.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.29.2028",
      "rawHtsCode": "6103.29.20.28",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste (734)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2030",
      "rawHtsCode": "6103.29.20.30",
      "superior": null,
      "indent": "5",
      "description": "Other (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2034",
      "rawHtsCode": "6103.29.20.34",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste (733)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2036",
      "rawHtsCode": "6103.29.20.36",
      "superior": null,
      "indent": "5",
      "description": "Other (833)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2040",
      "rawHtsCode": "6103.29.20.40",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste (747)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2044",
      "rawHtsCode": "6103.29.20.44",
      "superior": null,
      "indent": "6",
      "description": "Trousers and breeches (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2048",
      "rawHtsCode": "6103.29.20.48",
      "superior": null,
      "indent": "6",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2052",
      "rawHtsCode": "6103.29.20.52",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste (738)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2054",
      "rawHtsCode": "6103.29.20.54",
      "superior": null,
      "indent": "5",
      "description": "Other (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2058",
      "rawHtsCode": "6103.29.20.58",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2060",
      "rawHtsCode": "6103.29.20.60",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2062",
      "rawHtsCode": "6103.29.20.62",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (645)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2064",
      "rawHtsCode": "6103.29.20.64",
      "superior": null,
      "indent": "7",
      "description": "Containing 70 percent or more by weight of silk or silk waste (745)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2066",
      "rawHtsCode": "6103.29.20.66",
      "superior": null,
      "indent": "8",
      "description": "Assembled in Hong Kong from knit-to-shape component parts knitted elsewhere (846)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2068",
      "rawHtsCode": "6103.29.20.68",
      "superior": null,
      "indent": "8",
      "description": "Other (846)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2070",
      "rawHtsCode": "6103.29.20.70",
      "superior": null,
      "indent": "7",
      "description": "Assembled in Hong Kong from knit-to-shape component parts knitted elsewhere (845)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2074",
      "rawHtsCode": "6103.29.20.74",
      "superior": null,
      "indent": "7",
      "description": "Other (845)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2080",
      "rawHtsCode": "6103.29.20.80",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.29.2082",
      "rawHtsCode": "6103.29.20.82",
      "superior": null,
      "indent": "5",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.31.0000",
      "rawHtsCode": "6103.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "38.6¢/kg + 10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "77.2¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.32.0000",
      "rawHtsCode": "6103.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "13.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.33",
      "rawHtsCode": "6103.33",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.33.1000",
      "rawHtsCode": "6103.33.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "38.6¢/kg + 10%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.2¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.33.2000",
      "rawHtsCode": "6103.33.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (633)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.39",
      "rawHtsCode": "6103.39",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.39.1000",
      "rawHtsCode": "6103.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of artificial fibers (633)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.39.4000",
      "rawHtsCode": "6103.39.40.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (733)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.39.80",
      "rawHtsCode": "6103.39.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.39.8010",
      "rawHtsCode": "6103.39.80.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.39.8020",
      "rawHtsCode": "6103.39.80.20",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.39.8030",
      "rawHtsCode": "6103.39.80.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (633)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.39.8060",
      "rawHtsCode": "6103.39.80.60",
      "superior": null,
      "indent": "4",
      "description": "Other (833)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.41",
      "rawHtsCode": "6103.41",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.41.10",
      "rawHtsCode": "6103.41.10",
      "superior": null,
      "indent": "3",
      "description": "Trousers, breeches and shorts",
      "units": [],
      "generalRate": "61.1¢/kg + 15.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "77.2¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.41.1010",
      "rawHtsCode": "6103.41.10.10",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.41.1020",
      "rawHtsCode": "6103.41.10.20",
      "superior": null,
      "indent": "4",
      "description": "Shorts (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.41.2000",
      "rawHtsCode": "6103.41.20.00",
      "superior": null,
      "indent": "3",
      "description": "Bib and brace overalls (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.42",
      "rawHtsCode": "6103.42",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.42.10",
      "rawHtsCode": "6103.42.10",
      "superior": null,
      "indent": "3",
      "description": "Trousers, breeches and shorts",
      "units": [],
      "generalRate": "16.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.42.1020",
      "rawHtsCode": "6103.42.10.20",
      "superior": null,
      "indent": "5",
      "description": "Men's (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.42.1035",
      "rawHtsCode": "6103.42.10.35",
      "superior": null,
      "indent": "6",
      "description": "Imported as parts of play suits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.42.1040",
      "rawHtsCode": "6103.42.10.40",
      "superior": null,
      "indent": "6",
      "description": "Other (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.42.1050",
      "rawHtsCode": "6103.42.10.50",
      "superior": null,
      "indent": "5",
      "description": "Men's (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.42.1065",
      "rawHtsCode": "6103.42.10.65",
      "superior": null,
      "indent": "6",
      "description": "Imported as parts of play suits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.42.1070",
      "rawHtsCode": "6103.42.10.70",
      "superior": null,
      "indent": "6",
      "description": "Other (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.42.20",
      "rawHtsCode": "6103.42.20",
      "superior": null,
      "indent": "3",
      "description": "Bib and brace overalls",
      "units": [],
      "generalRate": "10.3%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.42.2010",
      "rawHtsCode": "6103.42.20.10",
      "superior": null,
      "indent": "4",
      "description": "Insulated, for cold weather protection(359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.42.2015",
      "rawHtsCode": "6103.42.20.15",
      "superior": null,
      "indent": "5",
      "description": "Boys' sizes 2-7 (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.42.2025",
      "rawHtsCode": "6103.42.20.25",
      "superior": null,
      "indent": "5",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43",
      "rawHtsCode": "6103.43",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43.10",
      "rawHtsCode": "6103.43.10",
      "superior": null,
      "indent": "4",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "58.5¢/kg + 15.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.2¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.43.1010",
      "rawHtsCode": "6103.43.10.10",
      "superior": null,
      "indent": "5",
      "description": "Trousers and breeches (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43.1020",
      "rawHtsCode": "6103.43.10.20",
      "superior": null,
      "indent": "5",
      "description": "Shorts (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43.15",
      "rawHtsCode": "6103.43.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.43.1520",
      "rawHtsCode": "6103.43.15.20",
      "superior": null,
      "indent": "6",
      "description": "Men's (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43.1535",
      "rawHtsCode": "6103.43.15.35",
      "superior": null,
      "indent": "7",
      "description": "Imported as parts of play suits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43.1540",
      "rawHtsCode": "6103.43.15.40",
      "superior": null,
      "indent": "7",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43.1550",
      "rawHtsCode": "6103.43.15.50",
      "superior": null,
      "indent": "6",
      "description": "Men's (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43.1565",
      "rawHtsCode": "6103.43.15.65",
      "superior": null,
      "indent": "7",
      "description": "Imported as parts of play suits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43.1570",
      "rawHtsCode": "6103.43.15.70",
      "superior": null,
      "indent": "7",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43.20",
      "rawHtsCode": "6103.43.20",
      "superior": null,
      "indent": "3",
      "description": "Bib and brace overalls",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.43.2010",
      "rawHtsCode": "6103.43.20.10",
      "superior": null,
      "indent": "4",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43.2015",
      "rawHtsCode": "6103.43.20.15",
      "superior": null,
      "indent": "5",
      "description": "Insulated, for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43.2020",
      "rawHtsCode": "6103.43.20.20",
      "superior": null,
      "indent": "6",
      "description": "Men's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.43.2025",
      "rawHtsCode": "6103.43.20.25",
      "superior": null,
      "indent": "6",
      "description": "Boys' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49",
      "rawHtsCode": "6103.49",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.10",
      "rawHtsCode": "6103.49.10",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts",
      "units": [],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.49.1010",
      "rawHtsCode": "6103.49.10.10",
      "superior": null,
      "indent": "5",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.1020",
      "rawHtsCode": "6103.49.10.20",
      "superior": null,
      "indent": "6",
      "description": "Trousers and breeches (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.1060",
      "rawHtsCode": "6103.49.10.60",
      "superior": null,
      "indent": "6",
      "description": "Shorts (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.2000",
      "rawHtsCode": "6103.49.20.00",
      "superior": null,
      "indent": "4",
      "description": "Bib and brace overalls (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.49.40",
      "rawHtsCode": "6103.49.40",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.49.4010",
      "rawHtsCode": "6103.49.40.10",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts (747)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.4020",
      "rawHtsCode": "6103.49.40.20",
      "superior": null,
      "indent": "4",
      "description": "Bib and brace overalls (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.80",
      "rawHtsCode": "6103.49.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6103.49.8010",
      "rawHtsCode": "6103.49.80.10",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.8012",
      "rawHtsCode": "6103.49.80.12",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.8014",
      "rawHtsCode": "6103.49.80.14",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.8024",
      "rawHtsCode": "6103.49.80.24",
      "superior": null,
      "indent": "6",
      "description": "Trousers and breeches (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.8026",
      "rawHtsCode": "6103.49.80.26",
      "superior": null,
      "indent": "6",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.8034",
      "rawHtsCode": "6103.49.80.34",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.8036",
      "rawHtsCode": "6103.49.80.36",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.8038",
      "rawHtsCode": "6103.49.80.38",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6103.49.8060",
      "rawHtsCode": "6103.49.80.60",
      "superior": null,
      "indent": "5",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104",
      "rawHtsCode": "6104",
      "superior": null,
      "indent": "0",
      "description": "Women's or girls' suits, ensembles, suit-type jackets, blazers, dresses, skirts, divided skirts, trousers, bib and brace overalls, breeches and shorts (other than swimwear), knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.13",
      "rawHtsCode": "6104.13",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.13.1000",
      "rawHtsCode": "6104.13.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (444)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6104.13.2000",
      "rawHtsCode": "6104.13.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (644)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.19",
      "rawHtsCode": "6104.19",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.19.1000",
      "rawHtsCode": "6104.19.10.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (444)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.19.1500",
      "rawHtsCode": "6104.19.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other (644)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6104.19.4000",
      "rawHtsCode": "6104.19.40.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (744)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.19.5000",
      "rawHtsCode": "6104.19.50.00",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (444)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.19.60",
      "rawHtsCode": "6104.19.60",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [],
      "generalRate": "9.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.19.6010",
      "rawHtsCode": "6104.19.60.10",
      "superior": null,
      "indent": "4",
      "description": "Jackets imported as parts of suits (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.19.6020",
      "rawHtsCode": "6104.19.60.20",
      "superior": null,
      "indent": "4",
      "description": "Skirts and divided skirts imported as parts of suits (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.19.6030",
      "rawHtsCode": "6104.19.60.30",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts imported as parts of suits (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.19.6040",
      "rawHtsCode": "6104.19.60.40",
      "superior": null,
      "indent": "4",
      "description": "Waistcoats imported as parts of suits (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.19.80",
      "rawHtsCode": "6104.19.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.19.8010",
      "rawHtsCode": "6104.19.80.10",
      "superior": null,
      "indent": "5",
      "description": "Jackets imported as parts of suits (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.19.8020",
      "rawHtsCode": "6104.19.80.20",
      "superior": null,
      "indent": "5",
      "description": "Skirts and divided skirts imported as parts of suits (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.19.8030",
      "rawHtsCode": "6104.19.80.30",
      "superior": null,
      "indent": "5",
      "description": "Trousers, breeches and shorts imported as parts of suits (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.19.8040",
      "rawHtsCode": "6104.19.80.40",
      "superior": null,
      "indent": "5",
      "description": "Waistcoats imported as parts of suits (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.19.8050",
      "rawHtsCode": "6104.19.80.50",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (444)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.19.8060",
      "rawHtsCode": "6104.19.80.60",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (644)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.19.8090",
      "rawHtsCode": "6104.19.80.90",
      "superior": null,
      "indent": "4",
      "description": "Other (844)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.22.00",
      "rawHtsCode": "6104.22.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.22.0010",
      "rawHtsCode": "6104.22.00.10",
      "superior": null,
      "indent": "3",
      "description": "Garments described in heading 6102; jackets and blazers described in heading 6104 (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.22.0030",
      "rawHtsCode": "6104.22.00.30",
      "superior": null,
      "indent": "3",
      "description": "Skirts and divided skirts (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.22.0040",
      "rawHtsCode": "6104.22.00.40",
      "superior": null,
      "indent": "3",
      "description": "Trousers and breeches (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.22.0050",
      "rawHtsCode": "6104.22.00.50",
      "superior": null,
      "indent": "3",
      "description": "Shorts (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.22.0060",
      "rawHtsCode": "6104.22.00.60",
      "superior": null,
      "indent": "3",
      "description": "Blouses, shirts and tops (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.22.0080",
      "rawHtsCode": "6104.22.00.80",
      "superior": null,
      "indent": "3",
      "description": "Sweaters (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.22.0090",
      "rawHtsCode": "6104.22.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.00",
      "rawHtsCode": "6104.23.00",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.23.0010",
      "rawHtsCode": "6104.23.00.10",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6102; jackets and blazers described in heading 6104 (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.0014",
      "rawHtsCode": "6104.23.00.14",
      "superior": null,
      "indent": "4",
      "description": "Skirts and divided skirts (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.0016",
      "rawHtsCode": "6104.23.00.16",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.0020",
      "rawHtsCode": "6104.23.00.20",
      "superior": null,
      "indent": "4",
      "description": "Blouses, shirts and tops (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.0022",
      "rawHtsCode": "6104.23.00.22",
      "superior": null,
      "indent": "4",
      "description": "Sweaters (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.0024",
      "rawHtsCode": "6104.23.00.24",
      "superior": null,
      "indent": "4",
      "description": "Other (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.0026",
      "rawHtsCode": "6104.23.00.26",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6102; jackets and blazers described in heading 6104 (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.0030",
      "rawHtsCode": "6104.23.00.30",
      "superior": null,
      "indent": "4",
      "description": "Skirts and divided skirts (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.0032",
      "rawHtsCode": "6104.23.00.32",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.0034",
      "rawHtsCode": "6104.23.00.34",
      "superior": null,
      "indent": "4",
      "description": "Shorts (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.0036",
      "rawHtsCode": "6104.23.00.36",
      "superior": null,
      "indent": "4",
      "description": "Blouses, shirts and tops (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.0040",
      "rawHtsCode": "6104.23.00.40",
      "superior": null,
      "indent": "4",
      "description": "Sweaters (646)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.23.0042",
      "rawHtsCode": "6104.23.00.42",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29",
      "rawHtsCode": "6104.29",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.05",
      "rawHtsCode": "6104.29.05",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.29.0510",
      "rawHtsCode": "6104.29.05.10",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6102; jackets and blazers described in heading 6104 (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.0530",
      "rawHtsCode": "6104.29.05.30",
      "superior": null,
      "indent": "4",
      "description": "Skirts and divided skirts (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.0540",
      "rawHtsCode": "6104.29.05.40",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.0560",
      "rawHtsCode": "6104.29.05.60",
      "superior": null,
      "indent": "4",
      "description": "Blouses and shirts (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.0570",
      "rawHtsCode": "6104.29.05.70",
      "superior": null,
      "indent": "4",
      "description": "Sweaters (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.0580",
      "rawHtsCode": "6104.29.05.80",
      "superior": null,
      "indent": "4",
      "description": "Other (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.10",
      "rawHtsCode": "6104.29.10",
      "superior": null,
      "indent": "3",
      "description": "Of artificial fibers",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if entered separately",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if entered separately",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.29.1010",
      "rawHtsCode": "6104.29.10.10",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6102; jackets and blazers described in heading 6104 (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.1020",
      "rawHtsCode": "6104.29.10.20",
      "superior": null,
      "indent": "4",
      "description": "Skirts and divided skirts (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.1030",
      "rawHtsCode": "6104.29.10.30",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.1040",
      "rawHtsCode": "6104.29.10.40",
      "superior": null,
      "indent": "4",
      "description": "Shorts (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.1050",
      "rawHtsCode": "6104.29.10.50",
      "superior": null,
      "indent": "4",
      "description": "Blouses, shirts and tops (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.1060",
      "rawHtsCode": "6104.29.10.60",
      "superior": null,
      "indent": "4",
      "description": "Sweaters (646)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.1070",
      "rawHtsCode": "6104.29.10.70",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.20",
      "rawHtsCode": "6104.29.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA, OM,P,PA,PE,S, SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.29.2010",
      "rawHtsCode": "6104.29.20.10",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2012",
      "rawHtsCode": "6104.29.20.12",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2014",
      "rawHtsCode": "6104.29.20.14",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2016",
      "rawHtsCode": "6104.29.20.16",
      "superior": null,
      "indent": "7",
      "description": "Containing 70 percent or more by weight of silk or silk waste (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2018",
      "rawHtsCode": "6104.29.20.18",
      "superior": null,
      "indent": "7",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2020",
      "rawHtsCode": "6104.29.20.20",
      "superior": null,
      "indent": "6",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2022",
      "rawHtsCode": "6104.29.20.22",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2024",
      "rawHtsCode": "6104.29.20.24",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2026",
      "rawHtsCode": "6104.29.20.26",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2028",
      "rawHtsCode": "6104.29.20.28",
      "superior": null,
      "indent": "7",
      "description": "Containing 70 percent or more by weight of silk or silk waste (742)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2030",
      "rawHtsCode": "6104.29.20.30",
      "superior": null,
      "indent": "7",
      "description": "Other (842)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2032",
      "rawHtsCode": "6104.29.20.32",
      "superior": null,
      "indent": "6",
      "description": "Other (842)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2034",
      "rawHtsCode": "6104.29.20.34",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2036",
      "rawHtsCode": "6104.29.20.36",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2038",
      "rawHtsCode": "6104.29.20.38",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2040",
      "rawHtsCode": "6104.29.20.40",
      "superior": null,
      "indent": "7",
      "description": "Containing 70 percent or more by weight of silk or silk waste (748)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2041",
      "rawHtsCode": "6104.29.20.41",
      "superior": null,
      "indent": "8",
      "description": "Trousers and breeches (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2043",
      "rawHtsCode": "6104.29.20.43",
      "superior": null,
      "indent": "8",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2045",
      "rawHtsCode": "6104.29.20.45",
      "superior": null,
      "indent": "7",
      "description": "Trousers and breeches (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2047",
      "rawHtsCode": "6104.29.20.47",
      "superior": null,
      "indent": "7",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2049",
      "rawHtsCode": "6104.29.20.49",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2051",
      "rawHtsCode": "6104.29.20.51",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2055",
      "rawHtsCode": "6104.29.20.55",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2057",
      "rawHtsCode": "6104.29.20.57",
      "superior": null,
      "indent": "7",
      "description": "Containing 70 percent or more by weight of silk or silk waste (739)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2061",
      "rawHtsCode": "6104.29.20.61",
      "superior": null,
      "indent": "7",
      "description": "Other (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2063",
      "rawHtsCode": "6104.29.20.63",
      "superior": null,
      "indent": "6",
      "description": "Other (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2065",
      "rawHtsCode": "6104.29.20.65",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2067",
      "rawHtsCode": "6104.29.20.67",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2069",
      "rawHtsCode": "6104.29.20.69",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (646)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2071",
      "rawHtsCode": "6104.29.20.71",
      "superior": null,
      "indent": "7",
      "description": "Containing 70 percent or more by weight of silk or silk waste waste (746)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2073",
      "rawHtsCode": "6104.29.20.73",
      "superior": null,
      "indent": "8",
      "description": "Assembled in Hong Kong from knit-to-shape component parts knitted elsewhere (846)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2075",
      "rawHtsCode": "6104.29.20.75",
      "superior": null,
      "indent": "8",
      "description": "Other (846)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2077",
      "rawHtsCode": "6104.29.20.77",
      "superior": null,
      "indent": "7",
      "description": "Assembled in Hong Kong from knit-to-shape component parts knitted elsewhere (845)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2079",
      "rawHtsCode": "6104.29.20.79",
      "superior": null,
      "indent": "7",
      "description": "Other (845)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2081",
      "rawHtsCode": "6104.29.20.81",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2083",
      "rawHtsCode": "6104.29.20.83",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2085",
      "rawHtsCode": "6104.29.20.85",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2086",
      "rawHtsCode": "6104.29.20.86",
      "superior": null,
      "indent": "7",
      "description": "Containing 70 percent or more by weight of silk or silk waste (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2087",
      "rawHtsCode": "6104.29.20.87",
      "superior": null,
      "indent": "7",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.29.2090",
      "rawHtsCode": "6104.29.20.90",
      "superior": null,
      "indent": "6",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.31.0000",
      "rawHtsCode": "6104.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "54.8¢/kg + 16%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "68.3¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.32.0000",
      "rawHtsCode": "6104.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.33",
      "rawHtsCode": "6104.33",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.33.1000",
      "rawHtsCode": "6104.33.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "56.4¢/kg + 16.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "68.3¢/kg + 54.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.33.2000",
      "rawHtsCode": "6104.33.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.39",
      "rawHtsCode": "6104.39",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.39.1000",
      "rawHtsCode": "6104.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of artificial fibers (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "24%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.39.20",
      "rawHtsCode": "6104.39.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6104.39.2010",
      "rawHtsCode": "6104.39.20.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.39.2020",
      "rawHtsCode": "6104.39.20.20",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.39.2030",
      "rawHtsCode": "6104.39.20.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.39.2040",
      "rawHtsCode": "6104.39.20.40",
      "superior": null,
      "indent": "6",
      "description": "Containing 70 percent or more by weight of silk or silk waste (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.39.2050",
      "rawHtsCode": "6104.39.20.50",
      "superior": null,
      "indent": "6",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.39.2090",
      "rawHtsCode": "6104.39.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.41.00",
      "rawHtsCode": "6104.41.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.41.0010",
      "rawHtsCode": "6104.41.00.10",
      "superior": null,
      "indent": "3",
      "description": "Women's (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.41.0020",
      "rawHtsCode": "6104.41.00.20",
      "superior": null,
      "indent": "3",
      "description": "Girls' (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.42.00",
      "rawHtsCode": "6104.42.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "11.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.42.0010",
      "rawHtsCode": "6104.42.00.10",
      "superior": null,
      "indent": "3",
      "description": "Women's (336)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.42.0020",
      "rawHtsCode": "6104.42.00.20",
      "superior": null,
      "indent": "3",
      "description": "Girls' (336)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.43",
      "rawHtsCode": "6104.43",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.43.10",
      "rawHtsCode": "6104.43.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.43.1010",
      "rawHtsCode": "6104.43.10.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.43.1020",
      "rawHtsCode": "6104.43.10.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.43.20",
      "rawHtsCode": "6104.43.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.43.2010",
      "rawHtsCode": "6104.43.20.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.43.2020",
      "rawHtsCode": "6104.43.20.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.44",
      "rawHtsCode": "6104.44",
      "superior": null,
      "indent": "2",
      "description": "Of artificial fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.44.1000",
      "rawHtsCode": "6104.44.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.44.20",
      "rawHtsCode": "6104.44.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.44.2010",
      "rawHtsCode": "6104.44.20.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.44.2020",
      "rawHtsCode": "6104.44.20.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.49",
      "rawHtsCode": "6104.49",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.49.1000",
      "rawHtsCode": "6104.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (736)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.49.90",
      "rawHtsCode": "6104.49.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.49.9010",
      "rawHtsCode": "6104.49.90.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (336)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.49.9020",
      "rawHtsCode": "6104.49.90.20",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.49.9030",
      "rawHtsCode": "6104.49.90.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.49.9060",
      "rawHtsCode": "6104.49.90.60",
      "superior": null,
      "indent": "4",
      "description": "Other (836)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.51.0000",
      "rawHtsCode": "6104.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.52.00",
      "rawHtsCode": "6104.52.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "8.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.52.0010",
      "rawHtsCode": "6104.52.00.10",
      "superior": null,
      "indent": "3",
      "description": "Women's (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.52.0020",
      "rawHtsCode": "6104.52.00.20",
      "superior": null,
      "indent": "3",
      "description": "Girls' (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.53",
      "rawHtsCode": "6104.53",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.53.1000",
      "rawHtsCode": "6104.53.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.53.20",
      "rawHtsCode": "6104.53.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.53.2010",
      "rawHtsCode": "6104.53.20.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.53.2020",
      "rawHtsCode": "6104.53.20.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.59",
      "rawHtsCode": "6104.59",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.59.10",
      "rawHtsCode": "6104.59.10",
      "superior": null,
      "indent": "3",
      "description": "Of artificial fibers",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.59.1005",
      "rawHtsCode": "6104.59.10.05",
      "superior": null,
      "indent": "4",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.59.1030",
      "rawHtsCode": "6104.59.10.30",
      "superior": null,
      "indent": "5",
      "description": "Women's (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.59.1060",
      "rawHtsCode": "6104.59.10.60",
      "superior": null,
      "indent": "5",
      "description": "Girls' (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.59.4000",
      "rawHtsCode": "6104.59.40.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (742)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.59.80",
      "rawHtsCode": "6104.59.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.59.8010",
      "rawHtsCode": "6104.59.80.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.59.8020",
      "rawHtsCode": "6104.59.80.20",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.59.8030",
      "rawHtsCode": "6104.59.80.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.59.8090",
      "rawHtsCode": "6104.59.80.90",
      "superior": null,
      "indent": "4",
      "description": "Other (842)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.61.00",
      "rawHtsCode": "6104.61.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.61.0010",
      "rawHtsCode": "6104.61.00.10",
      "superior": null,
      "indent": "3",
      "description": "Trousers and breeches (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.61.0020",
      "rawHtsCode": "6104.61.00.20",
      "superior": null,
      "indent": "3",
      "description": "Shorts (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.61.0030",
      "rawHtsCode": "6104.61.00.30",
      "superior": null,
      "indent": "3",
      "description": "Bib and brace overalls (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62",
      "rawHtsCode": "6104.62",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62.10",
      "rawHtsCode": "6104.62.10",
      "superior": null,
      "indent": "3",
      "description": "Bib and brace overalls",
      "units": [],
      "generalRate": "10.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.62.1010",
      "rawHtsCode": "6104.62.10.10",
      "superior": null,
      "indent": "4",
      "description": "Insulated, for cold weather protection (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62.1020",
      "rawHtsCode": "6104.62.10.20",
      "superior": null,
      "indent": "5",
      "description": "Women's (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62.1030",
      "rawHtsCode": "6104.62.10.30",
      "superior": null,
      "indent": "5",
      "description": "Girls' (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62.20",
      "rawHtsCode": "6104.62.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.62.2006",
      "rawHtsCode": "6104.62.20.06",
      "superior": null,
      "indent": "6",
      "description": "Containing 5 percent or more by weight of elastomeric yarn or rubber thread (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62.2011",
      "rawHtsCode": "6104.62.20.11",
      "superior": null,
      "indent": "6",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62.2016",
      "rawHtsCode": "6104.62.20.16",
      "superior": null,
      "indent": "7",
      "description": "Containing 5 percent or more by weight of elastomeric yarn or rubber thread (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62.2021",
      "rawHtsCode": "6104.62.20.21",
      "superior": null,
      "indent": "7",
      "description": "Other (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62.2026",
      "rawHtsCode": "6104.62.20.26",
      "superior": null,
      "indent": "7",
      "description": "Containing 5 percent or more by weight of elastomeric yarn or rubber thread (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62.2028",
      "rawHtsCode": "6104.62.20.28",
      "superior": null,
      "indent": "7",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62.2030",
      "rawHtsCode": "6104.62.20.30",
      "superior": null,
      "indent": "5",
      "description": "Women's (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62.2050",
      "rawHtsCode": "6104.62.20.50",
      "superior": null,
      "indent": "6",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.62.2060",
      "rawHtsCode": "6104.62.20.60",
      "superior": null,
      "indent": "6",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63",
      "rawHtsCode": "6104.63",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.10",
      "rawHtsCode": "6104.63.10",
      "superior": null,
      "indent": "3",
      "description": "Bib and brace overalls",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.63.1010",
      "rawHtsCode": "6104.63.10.10",
      "superior": null,
      "indent": "4",
      "description": "Insulated, for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.1020",
      "rawHtsCode": "6104.63.10.20",
      "superior": null,
      "indent": "5",
      "description": "Women's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.1030",
      "rawHtsCode": "6104.63.10.30",
      "superior": null,
      "indent": "5",
      "description": "Girls' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.15",
      "rawHtsCode": "6104.63.15",
      "superior": null,
      "indent": "4",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.63.1510",
      "rawHtsCode": "6104.63.15.10",
      "superior": null,
      "indent": "5",
      "description": "Trousers and breeches (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.1520",
      "rawHtsCode": "6104.63.15.20",
      "superior": null,
      "indent": "5",
      "description": "Shorts (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.20",
      "rawHtsCode": "6104.63.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.63.2006",
      "rawHtsCode": "6104.63.20.06",
      "superior": null,
      "indent": "7",
      "description": "Containing 5 percent or more by weight of elastomeric yarn or rubber thread (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.2011",
      "rawHtsCode": "6104.63.20.11",
      "superior": null,
      "indent": "7",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.2016",
      "rawHtsCode": "6104.63.20.16",
      "superior": null,
      "indent": "8",
      "description": "Containing 5 percent or more by weight of elastomeric yarn or rubber thread (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.2021",
      "rawHtsCode": "6104.63.20.21",
      "superior": null,
      "indent": "8",
      "description": "Other (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.2026",
      "rawHtsCode": "6104.63.20.26",
      "superior": null,
      "indent": "8",
      "description": "Containing 5 percent or more by weight of elastomeric yarn or rubber thread (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.2028",
      "rawHtsCode": "6104.63.20.28",
      "superior": null,
      "indent": "8",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.2030",
      "rawHtsCode": "6104.63.20.30",
      "superior": null,
      "indent": "6",
      "description": "Women's (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.2050",
      "rawHtsCode": "6104.63.20.50",
      "superior": null,
      "indent": "7",
      "description": "Imported as parts of play suits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.63.2060",
      "rawHtsCode": "6104.63.20.60",
      "superior": null,
      "indent": "7",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69",
      "rawHtsCode": "6104.69",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.1000",
      "rawHtsCode": "6104.69.10.00",
      "superior": null,
      "indent": "4",
      "description": "Bib and brace overalls (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.69.20",
      "rawHtsCode": "6104.69.20",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts",
      "units": [],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.69.2005",
      "rawHtsCode": "6104.69.20.05",
      "superior": null,
      "indent": "5",
      "description": "Containing 23 percent or more by by weight of wool or fine animal hair (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.2030",
      "rawHtsCode": "6104.69.20.30",
      "superior": null,
      "indent": "6",
      "description": "Trousers and breeches (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.2060",
      "rawHtsCode": "6104.69.20.60",
      "superior": null,
      "indent": "6",
      "description": "Shorts (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.40",
      "rawHtsCode": "6104.69.40",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.69.4010",
      "rawHtsCode": "6104.69.40.10",
      "superior": null,
      "indent": "4",
      "description": "Bib and brace overalls (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.4020",
      "rawHtsCode": "6104.69.40.20",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts (748)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.80",
      "rawHtsCode": "6104.69.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6104.69.8010",
      "rawHtsCode": "6104.69.80.10",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.8012",
      "rawHtsCode": "6104.69.80.12",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.8014",
      "rawHtsCode": "6104.69.80.14",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.8020",
      "rawHtsCode": "6104.69.80.20",
      "superior": null,
      "indent": "5",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.8022",
      "rawHtsCode": "6104.69.80.22",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.8024",
      "rawHtsCode": "6104.69.80.24",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.8026",
      "rawHtsCode": "6104.69.80.26",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.8038",
      "rawHtsCode": "6104.69.80.38",
      "superior": null,
      "indent": "6",
      "description": "Trousers and breeches (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6104.69.8040",
      "rawHtsCode": "6104.69.80.40",
      "superior": null,
      "indent": "6",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105",
      "rawHtsCode": "6105",
      "superior": null,
      "indent": "0",
      "description": "Men's or boys' shirts, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105.10.00",
      "rawHtsCode": "6105.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of cotton",
      "units": [],
      "generalRate": "19.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6105.10.0010",
      "rawHtsCode": "6105.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Men's (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105.10.0020",
      "rawHtsCode": "6105.10.00.20",
      "superior": null,
      "indent": "3",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105.10.0030",
      "rawHtsCode": "6105.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105.20",
      "rawHtsCode": "6105.20",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105.20.1000",
      "rawHtsCode": "6105.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6105.20.20",
      "rawHtsCode": "6105.20.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "32%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6105.20.2010",
      "rawHtsCode": "6105.20.20.10",
      "superior": null,
      "indent": "3",
      "description": "Men's (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105.20.2020",
      "rawHtsCode": "6105.20.20.20",
      "superior": null,
      "indent": "4",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105.20.2030",
      "rawHtsCode": "6105.20.20.30",
      "superior": null,
      "indent": "4",
      "description": "Other (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105.90",
      "rawHtsCode": "6105.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105.90.1000",
      "rawHtsCode": "6105.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6105.90.4000",
      "rawHtsCode": "6105.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste (738)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6105.90.80",
      "rawHtsCode": "6105.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6105.90.8010",
      "rawHtsCode": "6105.90.80.10",
      "superior": null,
      "indent": "3",
      "description": "Subject to cotton restraints (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105.90.8020",
      "rawHtsCode": "6105.90.80.20",
      "superior": null,
      "indent": "3",
      "description": "Subject to wool restraints (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105.90.8030",
      "rawHtsCode": "6105.90.80.30",
      "superior": null,
      "indent": "3",
      "description": "Subject to man-made fiber restraints (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6105.90.8060",
      "rawHtsCode": "6105.90.80.60",
      "superior": null,
      "indent": "3",
      "description": "Other (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106",
      "rawHtsCode": "6106",
      "superior": null,
      "indent": "0",
      "description": "Women's or girls' blouses and shirts, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.10.00",
      "rawHtsCode": "6106.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of cotton",
      "units": [],
      "generalRate": "19.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6106.10.0010",
      "rawHtsCode": "6106.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Women's (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.10.0020",
      "rawHtsCode": "6106.10.00.20",
      "superior": null,
      "indent": "3",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.10.0030",
      "rawHtsCode": "6106.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.20",
      "rawHtsCode": "6106.20",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.20.10",
      "rawHtsCode": "6106.20.10",
      "superior": null,
      "indent": "2",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6106.20.1010",
      "rawHtsCode": "6106.20.10.10",
      "superior": null,
      "indent": "3",
      "description": "Women's (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.20.1020",
      "rawHtsCode": "6106.20.10.20",
      "superior": null,
      "indent": "3",
      "description": "Girls' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.20.20",
      "rawHtsCode": "6106.20.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "32%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6106.20.2010",
      "rawHtsCode": "6106.20.20.10",
      "superior": null,
      "indent": "3",
      "description": "Women's (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.20.2020",
      "rawHtsCode": "6106.20.20.20",
      "superior": null,
      "indent": "4",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.20.2030",
      "rawHtsCode": "6106.20.20.30",
      "superior": null,
      "indent": "4",
      "description": "Other (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.90",
      "rawHtsCode": "6106.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.90.10",
      "rawHtsCode": "6106.90.10",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6106.90.1010",
      "rawHtsCode": "6106.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Women's (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.90.1020",
      "rawHtsCode": "6106.90.10.20",
      "superior": null,
      "indent": "3",
      "description": "Girls' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.90.1500",
      "rawHtsCode": "6106.90.15.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (739)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6106.90.25",
      "rawHtsCode": "6106.90.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6106.90.2510",
      "rawHtsCode": "6106.90.25.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.90.2520",
      "rawHtsCode": "6106.90.25.20",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.90.2530",
      "rawHtsCode": "6106.90.25.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.90.2550",
      "rawHtsCode": "6106.90.25.50",
      "superior": null,
      "indent": "4",
      "description": "Other (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.90.30",
      "rawHtsCode": "6106.90.30",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6106.90.3010",
      "rawHtsCode": "6106.90.30.10",
      "superior": null,
      "indent": "3",
      "description": "Subject to cotton restraints (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.90.3020",
      "rawHtsCode": "6106.90.30.20",
      "superior": null,
      "indent": "3",
      "description": "Subject to wool restraints (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.90.3030",
      "rawHtsCode": "6106.90.30.30",
      "superior": null,
      "indent": "3",
      "description": "Subject to man-made fiber restraints (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6106.90.3040",
      "rawHtsCode": "6106.90.30.40",
      "superior": null,
      "indent": "3",
      "description": "Other (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107",
      "rawHtsCode": "6107",
      "superior": null,
      "indent": "0",
      "description": "Men's or boys' underpants, briefs, nightshirts, pajamas, bathrobes, dressing gowns and similar articles, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.11.00",
      "rawHtsCode": "6107.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "7.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.11.0010",
      "rawHtsCode": "6107.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Men's (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.11.0020",
      "rawHtsCode": "6107.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Boys' (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.12.00",
      "rawHtsCode": "6107.12.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.12.0010",
      "rawHtsCode": "6107.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Men's (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.12.0020",
      "rawHtsCode": "6107.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Boys' (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.19",
      "rawHtsCode": "6107.19",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.19.1000",
      "rawHtsCode": "6107.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (752)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.19.9000",
      "rawHtsCode": "6107.19.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (852)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.21.00",
      "rawHtsCode": "6107.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "8.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.21.0010",
      "rawHtsCode": "6107.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Men's (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.21.0020",
      "rawHtsCode": "6107.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Boys' (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.22.00",
      "rawHtsCode": "6107.22.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.22.0010",
      "rawHtsCode": "6107.22.00.10",
      "superior": null,
      "indent": "3",
      "description": "Men's (651)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.22.0015",
      "rawHtsCode": "6107.22.00.15",
      "superior": null,
      "indent": "4",
      "description": "Blanket sleepers (651)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.22.0025",
      "rawHtsCode": "6107.22.00.25",
      "superior": null,
      "indent": "4",
      "description": "Other (651)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.29",
      "rawHtsCode": "6107.29",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.29.2000",
      "rawHtsCode": "6107.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.29.5000",
      "rawHtsCode": "6107.29.50.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (751)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.29.9000",
      "rawHtsCode": "6107.29.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (851)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.91.00",
      "rawHtsCode": "6107.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "8.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.91.0030",
      "rawHtsCode": "6107.91.00.30",
      "superior": null,
      "indent": "3",
      "description": "Sleepwear (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.91.0040",
      "rawHtsCode": "6107.91.00.40",
      "superior": null,
      "indent": "4",
      "description": "Men's (350)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.91.0090",
      "rawHtsCode": "6107.91.00.90",
      "superior": null,
      "indent": "4",
      "description": "Boys' (350)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.99",
      "rawHtsCode": "6107.99",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.99.10",
      "rawHtsCode": "6107.99.10",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.99.1030",
      "rawHtsCode": "6107.99.10.30",
      "superior": null,
      "indent": "4",
      "description": "Sleepwear (651)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.99.1040",
      "rawHtsCode": "6107.99.10.40",
      "superior": null,
      "indent": "5",
      "description": "Men's (650)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.99.1090",
      "rawHtsCode": "6107.99.10.90",
      "superior": null,
      "indent": "5",
      "description": "Boys' (650)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.99.2000",
      "rawHtsCode": "6107.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.99.50",
      "rawHtsCode": "6107.99.50",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "0.8%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6107.99.5013",
      "rawHtsCode": "6107.99.50.13",
      "superior": null,
      "indent": "4",
      "description": "Sleepwear (751)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.99.5015",
      "rawHtsCode": "6107.99.50.15",
      "superior": null,
      "indent": "4",
      "description": "Other (750)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6107.99.9000",
      "rawHtsCode": "6107.99.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (850)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108",
      "rawHtsCode": "6108",
      "superior": null,
      "indent": "0",
      "description": "Women's or girls' slips, petticoats, briefs, panties, night dresses, pajamas, negligees, bathrobes, dressing gowns and similar articles, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.11.00",
      "rawHtsCode": "6108.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.11.0010",
      "rawHtsCode": "6108.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Women's (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.11.0020",
      "rawHtsCode": "6108.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Girls' (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.19.1000",
      "rawHtsCode": "6108.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (752)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.19.90",
      "rawHtsCode": "6108.19.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.19.9010",
      "rawHtsCode": "6108.19.90.10",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.19.9030",
      "rawHtsCode": "6108.19.90.30",
      "superior": null,
      "indent": "4",
      "description": "Other (852)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.21.00",
      "rawHtsCode": "6108.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "7.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.21.0010",
      "rawHtsCode": "6108.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Women's (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.21.0020",
      "rawHtsCode": "6108.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Girls' (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.22",
      "rawHtsCode": "6108.22",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.22.1000",
      "rawHtsCode": "6108.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Disposable briefs and panties designed for one-time use",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "8.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.22.90",
      "rawHtsCode": "6108.22.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "15.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.22.9020",
      "rawHtsCode": "6108.22.90.20",
      "superior": null,
      "indent": "4",
      "description": "Women's (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.22.9030",
      "rawHtsCode": "6108.22.90.30",
      "superior": null,
      "indent": "4",
      "description": "Girls' (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.29",
      "rawHtsCode": "6108.29",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.29.1000",
      "rawHtsCode": "6108.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (752)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "2.1%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.29.9000",
      "rawHtsCode": "6108.29.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (852)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "13.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.31.00",
      "rawHtsCode": "6108.31.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.31.0010",
      "rawHtsCode": "6108.31.00.10",
      "superior": null,
      "indent": "3",
      "description": "Women's (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.31.0020",
      "rawHtsCode": "6108.31.00.20",
      "superior": null,
      "indent": "3",
      "description": "Girls' (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.32.00",
      "rawHtsCode": "6108.32.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.32.0010",
      "rawHtsCode": "6108.32.00.10",
      "superior": null,
      "indent": "3",
      "description": "Women's (651)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.32.0015",
      "rawHtsCode": "6108.32.00.15",
      "superior": null,
      "indent": "4",
      "description": "Blanket sleepers (651)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.32.0025",
      "rawHtsCode": "6108.32.00.25",
      "superior": null,
      "indent": "4",
      "description": "Other (651)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.39",
      "rawHtsCode": "6108.39",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.39.1000",
      "rawHtsCode": "6108.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.39.4000",
      "rawHtsCode": "6108.39.40.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (751)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "0.6%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.39.8000",
      "rawHtsCode": "6108.39.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other (851)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.91.00",
      "rawHtsCode": "6108.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.91.0005",
      "rawHtsCode": "6108.91.00.05",
      "superior": null,
      "indent": "4",
      "description": "Underpants (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.91.0015",
      "rawHtsCode": "6108.91.00.15",
      "superior": null,
      "indent": "5",
      "description": "Women's (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.91.0025",
      "rawHtsCode": "6108.91.00.25",
      "superior": null,
      "indent": "5",
      "description": "Girls' (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.91.0030",
      "rawHtsCode": "6108.91.00.30",
      "superior": null,
      "indent": "4",
      "description": "Women's (350)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.91.0040",
      "rawHtsCode": "6108.91.00.40",
      "superior": null,
      "indent": "4",
      "description": "Girls' (350)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.92.00",
      "rawHtsCode": "6108.92.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.92.0005",
      "rawHtsCode": "6108.92.00.05",
      "superior": null,
      "indent": "4",
      "description": "Underpants (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.92.0015",
      "rawHtsCode": "6108.92.00.15",
      "superior": null,
      "indent": "5",
      "description": "Women's (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.92.0025",
      "rawHtsCode": "6108.92.00.25",
      "superior": null,
      "indent": "5",
      "description": "Girls' (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.92.0030",
      "rawHtsCode": "6108.92.00.30",
      "superior": null,
      "indent": "4",
      "description": "Women's (650)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.92.0040",
      "rawHtsCode": "6108.92.00.40",
      "superior": null,
      "indent": "4",
      "description": "Girls' (650)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.99",
      "rawHtsCode": "6108.99",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.99.2000",
      "rawHtsCode": "6108.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.99.50",
      "rawHtsCode": "6108.99.50",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "0.6%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6108.99.5013",
      "rawHtsCode": "6108.99.50.13",
      "superior": null,
      "indent": "4",
      "description": "Underwear (752)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.99.5015",
      "rawHtsCode": "6108.99.50.15",
      "superior": null,
      "indent": "4",
      "description": "Other (750)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6108.99.9000",
      "rawHtsCode": "6108.99.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (850)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6109",
      "rawHtsCode": "6109",
      "superior": null,
      "indent": "0",
      "description": "T-shirts, singlets, tank tops and similar garments, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.00",
      "rawHtsCode": "6109.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of cotton",
      "units": [],
      "generalRate": "16.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6109.10.0004",
      "rawHtsCode": "6109.10.00.04",
      "superior": null,
      "indent": "3",
      "description": "T-shirts, all white, short hemmed sleeves, hemmed bottom, crew or round neckline, or V-neck with a mitered seam at the center of the V, without pockets, trim or embroidery (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0007",
      "rawHtsCode": "6109.10.00.07",
      "superior": null,
      "indent": "3",
      "description": "Singlets, all white, without pockets, trim or embroidery (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0011",
      "rawHtsCode": "6109.10.00.11",
      "superior": null,
      "indent": "3",
      "description": "Thermal undershirts (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0012",
      "rawHtsCode": "6109.10.00.12",
      "superior": null,
      "indent": "4",
      "description": "Men's (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0014",
      "rawHtsCode": "6109.10.00.14",
      "superior": null,
      "indent": "4",
      "description": "Boys' (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0018",
      "rawHtsCode": "6109.10.00.18",
      "superior": null,
      "indent": "4",
      "description": "Men's (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0023",
      "rawHtsCode": "6109.10.00.23",
      "superior": null,
      "indent": "4",
      "description": "Boys' (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0027",
      "rawHtsCode": "6109.10.00.27",
      "superior": null,
      "indent": "3",
      "description": "Other (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0037",
      "rawHtsCode": "6109.10.00.37",
      "superior": null,
      "indent": "3",
      "description": "Underwear (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0040",
      "rawHtsCode": "6109.10.00.40",
      "superior": null,
      "indent": "5",
      "description": "Women's (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0045",
      "rawHtsCode": "6109.10.00.45",
      "superior": null,
      "indent": "5",
      "description": "Girls' (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0060",
      "rawHtsCode": "6109.10.00.60",
      "superior": null,
      "indent": "5",
      "description": "Women's (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0065",
      "rawHtsCode": "6109.10.00.65",
      "superior": null,
      "indent": "5",
      "description": "Girls' (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.10.0070",
      "rawHtsCode": "6109.10.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90",
      "rawHtsCode": "6109.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.10",
      "rawHtsCode": "6109.90.10",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "32%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6109.90.1007",
      "rawHtsCode": "6109.90.10.07",
      "superior": null,
      "indent": "5",
      "description": "Men's (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1009",
      "rawHtsCode": "6109.90.10.09",
      "superior": null,
      "indent": "5",
      "description": "Boys' (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1013",
      "rawHtsCode": "6109.90.10.13",
      "superior": null,
      "indent": "5",
      "description": "Men's (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1025",
      "rawHtsCode": "6109.90.10.25",
      "superior": null,
      "indent": "5",
      "description": "Boys' (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1047",
      "rawHtsCode": "6109.90.10.47",
      "superior": null,
      "indent": "4",
      "description": "Thermal undershirts (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1049",
      "rawHtsCode": "6109.90.10.49",
      "superior": null,
      "indent": "4",
      "description": "Other (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1050",
      "rawHtsCode": "6109.90.10.50",
      "superior": null,
      "indent": "5",
      "description": "Women's (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1060",
      "rawHtsCode": "6109.90.10.60",
      "superior": null,
      "indent": "5",
      "description": "Girls' (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1065",
      "rawHtsCode": "6109.90.10.65",
      "superior": null,
      "indent": "5",
      "description": "Women's (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1070",
      "rawHtsCode": "6109.90.10.70",
      "superior": null,
      "indent": "5",
      "description": "Girls' (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1075",
      "rawHtsCode": "6109.90.10.75",
      "superior": null,
      "indent": "4",
      "description": "Thermal undershirts (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1090",
      "rawHtsCode": "6109.90.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.15",
      "rawHtsCode": "6109.90.15",
      "superior": null,
      "indent": "2",
      "description": "Of wool, with long sleeves",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6109.90.1510",
      "rawHtsCode": "6109.90.15.10",
      "superior": null,
      "indent": "4",
      "description": "Underwear (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1520",
      "rawHtsCode": "6109.90.15.20",
      "superior": null,
      "indent": "4",
      "description": "Other (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1530",
      "rawHtsCode": "6109.90.15.30",
      "superior": null,
      "indent": "4",
      "description": "Underwear (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.1540",
      "rawHtsCode": "6109.90.15.40",
      "superior": null,
      "indent": "4",
      "description": "Other (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.40",
      "rawHtsCode": "6109.90.40",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "2.6%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6109.90.4010",
      "rawHtsCode": "6109.90.40.10",
      "superior": null,
      "indent": "3",
      "description": "Men's or boys' (738)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.4020",
      "rawHtsCode": "6109.90.40.20",
      "superior": null,
      "indent": "3",
      "description": "Women's or girls' (739)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.80",
      "rawHtsCode": "6109.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6109.90.8010",
      "rawHtsCode": "6109.90.80.10",
      "superior": null,
      "indent": "3",
      "description": "Men's or boys' (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.8020",
      "rawHtsCode": "6109.90.80.20",
      "superior": null,
      "indent": "4",
      "description": "Of wool (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6109.90.8030",
      "rawHtsCode": "6109.90.80.30",
      "superior": null,
      "indent": "4",
      "description": "Other (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110",
      "rawHtsCode": "6110",
      "superior": null,
      "indent": "0",
      "description": "Sweaters, pullovers, sweatshirts, waistcoats (vests) and similar articles, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.11.00",
      "rawHtsCode": "6110.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6110.11.0015",
      "rawHtsCode": "6110.11.00.15",
      "superior": null,
      "indent": "4",
      "description": "Men's (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.11.0025",
      "rawHtsCode": "6110.11.00.25",
      "superior": null,
      "indent": "4",
      "description": "Boys' (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.11.0030",
      "rawHtsCode": "6110.11.00.30",
      "superior": null,
      "indent": "4",
      "description": "Women's (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.11.0040",
      "rawHtsCode": "6110.11.00.40",
      "superior": null,
      "indent": "4",
      "description": "Girls' (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.11.0050",
      "rawHtsCode": "6110.11.00.50",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.11.0060",
      "rawHtsCode": "6110.11.00.60",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.11.0070",
      "rawHtsCode": "6110.11.00.70",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.11.0080",
      "rawHtsCode": "6110.11.00.80",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12",
      "rawHtsCode": "6110.12",
      "superior": null,
      "indent": "2",
      "description": "Of Kashmir (cashmere) goats:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.10",
      "rawHtsCode": "6110.12.10",
      "superior": null,
      "indent": "3",
      "description": "Wholly of cashmere",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6110.12.1010",
      "rawHtsCode": "6110.12.10.10",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.1020",
      "rawHtsCode": "6110.12.10.20",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.1030",
      "rawHtsCode": "6110.12.10.30",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.1040",
      "rawHtsCode": "6110.12.10.40",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.1050",
      "rawHtsCode": "6110.12.10.50",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.1060",
      "rawHtsCode": "6110.12.10.60",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.20",
      "rawHtsCode": "6110.12.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6110.12.2010",
      "rawHtsCode": "6110.12.20.10",
      "superior": null,
      "indent": "5",
      "description": "Men's (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.2020",
      "rawHtsCode": "6110.12.20.20",
      "superior": null,
      "indent": "5",
      "description": "Boys' (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.2030",
      "rawHtsCode": "6110.12.20.30",
      "superior": null,
      "indent": "5",
      "description": "Women's (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.2040",
      "rawHtsCode": "6110.12.20.40",
      "superior": null,
      "indent": "5",
      "description": "Girls' (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.2050",
      "rawHtsCode": "6110.12.20.50",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.2060",
      "rawHtsCode": "6110.12.20.60",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.2070",
      "rawHtsCode": "6110.12.20.70",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.12.2080",
      "rawHtsCode": "6110.12.20.80",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.19.00",
      "rawHtsCode": "6110.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6110.19.0015",
      "rawHtsCode": "6110.19.00.15",
      "superior": null,
      "indent": "4",
      "description": "Men's (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.19.0025",
      "rawHtsCode": "6110.19.00.25",
      "superior": null,
      "indent": "4",
      "description": "Boys' (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.19.0030",
      "rawHtsCode": "6110.19.00.30",
      "superior": null,
      "indent": "4",
      "description": "Women's (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.19.0040",
      "rawHtsCode": "6110.19.00.40",
      "superior": null,
      "indent": "4",
      "description": "Girls' (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.19.0050",
      "rawHtsCode": "6110.19.00.50",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.19.0060",
      "rawHtsCode": "6110.19.00.60",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.19.0070",
      "rawHtsCode": "6110.19.00.70",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.19.0080",
      "rawHtsCode": "6110.19.00.80",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20",
      "rawHtsCode": "6110.20",
      "superior": null,
      "indent": "1",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.10",
      "rawHtsCode": "6110.20.10",
      "superior": null,
      "indent": "2",
      "description": "Containing 36 percent or more by weight of flax fibers",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6110.20.1010",
      "rawHtsCode": "6110.20.10.10",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.1020",
      "rawHtsCode": "6110.20.10.20",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.1022",
      "rawHtsCode": "6110.20.10.22",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.1024",
      "rawHtsCode": "6110.20.10.24",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.1026",
      "rawHtsCode": "6110.20.10.26",
      "superior": null,
      "indent": "5",
      "description": "Knit to shape articles described in statistical note 6 to this chapter (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.1029",
      "rawHtsCode": "6110.20.10.29",
      "superior": null,
      "indent": "5",
      "description": "Other (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.1031",
      "rawHtsCode": "6110.20.10.31",
      "superior": null,
      "indent": "5",
      "description": "Knit to shape articles described in statistical note 6 to this chapter (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.1033",
      "rawHtsCode": "6110.20.10.33",
      "superior": null,
      "indent": "5",
      "description": "Other (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.20",
      "rawHtsCode": "6110.20.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "16.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6110.20.2005",
      "rawHtsCode": "6110.20.20.05",
      "superior": null,
      "indent": "3",
      "description": "Boys' or girls' garments imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2010",
      "rawHtsCode": "6110.20.20.10",
      "superior": null,
      "indent": "5",
      "description": "Men's (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2015",
      "rawHtsCode": "6110.20.20.15",
      "superior": null,
      "indent": "5",
      "description": "Boys' (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2020",
      "rawHtsCode": "6110.20.20.20",
      "superior": null,
      "indent": "5",
      "description": "Women's (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2025",
      "rawHtsCode": "6110.20.20.25",
      "superior": null,
      "indent": "5",
      "description": "Girls' (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2030",
      "rawHtsCode": "6110.20.20.30",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2035",
      "rawHtsCode": "6110.20.20.35",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2041",
      "rawHtsCode": "6110.20.20.41",
      "superior": null,
      "indent": "5",
      "description": "Men's (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2044",
      "rawHtsCode": "6110.20.20.44",
      "superior": null,
      "indent": "5",
      "description": "Boys' (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2046",
      "rawHtsCode": "6110.20.20.46",
      "superior": null,
      "indent": "5",
      "description": "Women's (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2049",
      "rawHtsCode": "6110.20.20.49",
      "superior": null,
      "indent": "5",
      "description": "Girls' (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2067",
      "rawHtsCode": "6110.20.20.67",
      "superior": null,
      "indent": "6",
      "description": "Knit to shape articles described in statistical note 6 to this chapter (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2069",
      "rawHtsCode": "6110.20.20.69",
      "superior": null,
      "indent": "6",
      "description": "Other (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2077",
      "rawHtsCode": "6110.20.20.77",
      "superior": null,
      "indent": "6",
      "description": "Knit to shape articles described in statistical note 6 to this chapter (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.20.2079",
      "rawHtsCode": "6110.20.20.79",
      "superior": null,
      "indent": "6",
      "description": "Other (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30",
      "rawHtsCode": "6110.30",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.10",
      "rawHtsCode": "6110.30.10",
      "superior": null,
      "indent": "2",
      "description": "Containing 25 percent or more by weight of leather",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6110.30.1010",
      "rawHtsCode": "6110.30.10.10",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (645)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.1020",
      "rawHtsCode": "6110.30.10.20",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (646)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.1030",
      "rawHtsCode": "6110.30.10.30",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.1040",
      "rawHtsCode": "6110.30.10.40",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.1050",
      "rawHtsCode": "6110.30.10.50",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.1060",
      "rawHtsCode": "6110.30.10.60",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.15",
      "rawHtsCode": "6110.30.15",
      "superior": null,
      "indent": "3",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "17%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "54.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6110.30.1510",
      "rawHtsCode": "6110.30.15.10",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.1520",
      "rawHtsCode": "6110.30.15.20",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.1530",
      "rawHtsCode": "6110.30.15.30",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.1540",
      "rawHtsCode": "6110.30.15.40",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.1550",
      "rawHtsCode": "6110.30.15.50",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.1560",
      "rawHtsCode": "6110.30.15.60",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.20",
      "rawHtsCode": "6110.30.20",
      "superior": null,
      "indent": "4",
      "description": "Containing 30 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6110.30.2010",
      "rawHtsCode": "6110.30.20.10",
      "superior": null,
      "indent": "6",
      "description": "Men's or boys' (645)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.2020",
      "rawHtsCode": "6110.30.20.20",
      "superior": null,
      "indent": "6",
      "description": "Women's or girls' (646)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.2030",
      "rawHtsCode": "6110.30.20.30",
      "superior": null,
      "indent": "6",
      "description": "Men's or boys' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.2040",
      "rawHtsCode": "6110.30.20.40",
      "superior": null,
      "indent": "6",
      "description": "Women's or girls' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.2051",
      "rawHtsCode": "6110.30.20.51",
      "superior": null,
      "indent": "7",
      "description": "Knit to shape articles described in statistical note 6 to this chapter (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.2053",
      "rawHtsCode": "6110.30.20.53",
      "superior": null,
      "indent": "7",
      "description": "Other (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.2061",
      "rawHtsCode": "6110.30.20.61",
      "superior": null,
      "indent": "7",
      "description": "Knit to shape articles described in statistical note 6 to this chapter (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.2063",
      "rawHtsCode": "6110.30.20.63",
      "superior": null,
      "indent": "7",
      "description": "Other (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.30",
      "rawHtsCode": "6110.30.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "32%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6110.30.3005",
      "rawHtsCode": "6110.30.30.05",
      "superior": null,
      "indent": "5",
      "description": "Boys' and girls' garments imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3010",
      "rawHtsCode": "6110.30.30.10",
      "superior": null,
      "indent": "7",
      "description": "Men's (645)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3015",
      "rawHtsCode": "6110.30.30.15",
      "superior": null,
      "indent": "7",
      "description": "Boys' (645)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3020",
      "rawHtsCode": "6110.30.30.20",
      "superior": null,
      "indent": "7",
      "description": "Women's (646)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3025",
      "rawHtsCode": "6110.30.30.25",
      "superior": null,
      "indent": "7",
      "description": "Girls' (646)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3030",
      "rawHtsCode": "6110.30.30.30",
      "superior": null,
      "indent": "7",
      "description": "Men's or boys' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3035",
      "rawHtsCode": "6110.30.30.35",
      "superior": null,
      "indent": "7",
      "description": "Women's or girls' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3041",
      "rawHtsCode": "6110.30.30.41",
      "superior": null,
      "indent": "7",
      "description": "Men's (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3044",
      "rawHtsCode": "6110.30.30.44",
      "superior": null,
      "indent": "7",
      "description": "Boys' (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3045",
      "rawHtsCode": "6110.30.30.45",
      "superior": null,
      "indent": "7",
      "description": "Women's or girls' (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3051",
      "rawHtsCode": "6110.30.30.51",
      "superior": null,
      "indent": "8",
      "description": "Knit to shape articles described in statistical note 6 to this chapter (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3053",
      "rawHtsCode": "6110.30.30.53",
      "superior": null,
      "indent": "8",
      "description": "Other (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3057",
      "rawHtsCode": "6110.30.30.57",
      "superior": null,
      "indent": "8",
      "description": "Knit to shape articles described in statistical note 6 to this chapter (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.30.3059",
      "rawHtsCode": "6110.30.30.59",
      "superior": null,
      "indent": "8",
      "description": "Other (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90",
      "rawHtsCode": "6110.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.10",
      "rawHtsCode": "6110.90.10",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6110.90.1010",
      "rawHtsCode": "6110.90.10.10",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (745)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.1020",
      "rawHtsCode": "6110.90.10.20",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (746)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.1030",
      "rawHtsCode": "6110.90.10.30",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.1040",
      "rawHtsCode": "6110.90.10.40",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.1050",
      "rawHtsCode": "6110.90.10.50",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (738)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.1060",
      "rawHtsCode": "6110.90.10.60",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (739)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.90",
      "rawHtsCode": "6110.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6110.90.9010",
      "rawHtsCode": "6110.90.90.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9012",
      "rawHtsCode": "6110.90.90.12",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (445)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9014",
      "rawHtsCode": "6110.90.90.14",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (645)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9015",
      "rawHtsCode": "6110.90.90.15",
      "superior": null,
      "indent": "5",
      "description": "Of silk (846)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9023",
      "rawHtsCode": "6110.90.90.23",
      "superior": null,
      "indent": "5",
      "description": "Other (845)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9026",
      "rawHtsCode": "6110.90.90.26",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9028",
      "rawHtsCode": "6110.90.90.28",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9030",
      "rawHtsCode": "6110.90.90.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (646)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9034",
      "rawHtsCode": "6110.90.90.34",
      "superior": null,
      "indent": "5",
      "description": "Of silk (846)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9041",
      "rawHtsCode": "6110.90.90.41",
      "superior": null,
      "indent": "5",
      "description": "Other (845)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9044",
      "rawHtsCode": "6110.90.90.44",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9046",
      "rawHtsCode": "6110.90.90.46",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9048",
      "rawHtsCode": "6110.90.90.48",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9050",
      "rawHtsCode": "6110.90.90.50",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9052",
      "rawHtsCode": "6110.90.90.52",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9054",
      "rawHtsCode": "6110.90.90.54",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9064",
      "rawHtsCode": "6110.90.90.64",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9066",
      "rawHtsCode": "6110.90.90.66",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9067",
      "rawHtsCode": "6110.90.90.67",
      "superior": null,
      "indent": "6",
      "description": "Knit to shape articles described in statistical note 6 to this chapter (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9069",
      "rawHtsCode": "6110.90.90.69",
      "superior": null,
      "indent": "6",
      "description": "Other (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9071",
      "rawHtsCode": "6110.90.90.71",
      "superior": null,
      "indent": "6",
      "description": "Knit to shape articles described in statistical note 6 to this chapter (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9073",
      "rawHtsCode": "6110.90.90.73",
      "superior": null,
      "indent": "6",
      "description": "Other (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9075",
      "rawHtsCode": "6110.90.90.75",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9077",
      "rawHtsCode": "6110.90.90.77",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9079",
      "rawHtsCode": "6110.90.90.79",
      "superior": null,
      "indent": "6",
      "description": "Knit to shape articles described in statistical note 6 to this chapter (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9080",
      "rawHtsCode": "6110.90.90.80",
      "superior": null,
      "indent": "6",
      "description": "Other (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9081",
      "rawHtsCode": "6110.90.90.81",
      "superior": null,
      "indent": "6",
      "description": "Knit to shape articles described in statistical note 6 to this chapter (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9082",
      "rawHtsCode": "6110.90.90.82",
      "superior": null,
      "indent": "6",
      "description": "Other (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9088",
      "rawHtsCode": "6110.90.90.88",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6110.90.9090",
      "rawHtsCode": "6110.90.90.90",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111",
      "rawHtsCode": "6111",
      "superior": null,
      "indent": "0",
      "description": "Babies' garments and clothing accessories, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.20",
      "rawHtsCode": "6111.20",
      "superior": null,
      "indent": "1",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.20.1000",
      "rawHtsCode": "6111.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Blouses and shirts, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "19.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.20.2000",
      "rawHtsCode": "6111.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "T-shirts, singlets and similar garments, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.20.3000",
      "rawHtsCode": "6111.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "Sweaters, pullovers, sweatshirts, waistcoats (vests) and similar articles, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.20.4000",
      "rawHtsCode": "6111.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Dresses (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "11.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.20.5000",
      "rawHtsCode": "6111.20.50.00",
      "superior": null,
      "indent": "3",
      "description": "Trousers, breeches and shorts, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.20.60",
      "rawHtsCode": "6111.20.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.20.6010",
      "rawHtsCode": "6111.20.60.10",
      "superior": null,
      "indent": "4",
      "description": "Sunsuits, washsuits and similar apparel (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.20.6020",
      "rawHtsCode": "6111.20.60.20",
      "superior": null,
      "indent": "4",
      "description": "Sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.20.6030",
      "rawHtsCode": "6111.20.60.30",
      "superior": null,
      "indent": "5",
      "description": "Imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.20.6050",
      "rawHtsCode": "6111.20.60.50",
      "superior": null,
      "indent": "5",
      "description": "Babiesʼ socks and booties (239)",
      "units": [
        "doz. prs.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.20.6070",
      "rawHtsCode": "6111.20.60.70",
      "superior": null,
      "indent": "5",
      "description": "Other (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "6111.30",
      "rawHtsCode": "6111.30",
      "superior": null,
      "indent": "1",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.30.1000",
      "rawHtsCode": "6111.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Trousers, breeches and shorts, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.30.2000",
      "rawHtsCode": "6111.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Blouses and shirts, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "32%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.30.3000",
      "rawHtsCode": "6111.30.30.00",
      "superior": null,
      "indent": "2",
      "description": "T-shirts, singlets and similar garments, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "32%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.30.4000",
      "rawHtsCode": "6111.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Sweaters, pullovers, sweatshirts, waistcoats (vests) and similar articles, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "30%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.30.50",
      "rawHtsCode": "6111.30.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.30.5010",
      "rawHtsCode": "6111.30.50.10",
      "superior": null,
      "indent": "3",
      "description": "Sunsuits, washsuits and similar apparel (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.30.5015",
      "rawHtsCode": "6111.30.50.15",
      "superior": null,
      "indent": "3",
      "description": "Blanket sleepers (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.30.5020",
      "rawHtsCode": "6111.30.50.20",
      "superior": null,
      "indent": "3",
      "description": "Sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.30.5030",
      "rawHtsCode": "6111.30.50.30",
      "superior": null,
      "indent": "4",
      "description": "Imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.30.5050",
      "rawHtsCode": "6111.30.50.50",
      "superior": null,
      "indent": "4",
      "description": "Babiesʼ socks and booties (239)",
      "units": [
        "doz. prs.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.30.5070",
      "rawHtsCode": "6111.30.50.70",
      "superior": null,
      "indent": "4",
      "description": "Other (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.90",
      "rawHtsCode": "6111.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.90.05",
      "rawHtsCode": "6111.90.05",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.90.0510",
      "rawHtsCode": "6111.90.05.10",
      "superior": null,
      "indent": "3",
      "description": "Sweaters, pullovers, sweatshirts, waistcoats (vests) and similar articles (439)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.90.0530",
      "rawHtsCode": "6111.90.05.30",
      "superior": null,
      "indent": "3",
      "description": "Other (439)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.90.1000",
      "rawHtsCode": "6111.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Trousers, breeches and shorts, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.90.2000",
      "rawHtsCode": "6111.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Blouses and shirts, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "17.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.90.3000",
      "rawHtsCode": "6111.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "T-shirts, singlets and similar garments, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.90.4000",
      "rawHtsCode": "6111.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Sweaters, pullovers, sweatshirts, waistcoats (vests) and similar except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "26%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.90.50",
      "rawHtsCode": "6111.90.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.90.5010",
      "rawHtsCode": "6111.90.50.10",
      "superior": null,
      "indent": "4",
      "description": "Sunsuits, playsuits and washsuits (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.90.5020",
      "rawHtsCode": "6111.90.50.20",
      "superior": null,
      "indent": "4",
      "description": "Sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.90.5030",
      "rawHtsCode": "6111.90.50.30",
      "superior": null,
      "indent": "5",
      "description": "Imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.90.5050",
      "rawHtsCode": "6111.90.50.50",
      "superior": null,
      "indent": "5",
      "description": "Babiesʼ socks and booties (239)",
      "units": [
        "doz. prs.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.90.5070",
      "rawHtsCode": "6111.90.50.70",
      "superior": null,
      "indent": "5",
      "description": "Other (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6111.90.7000",
      "rawHtsCode": "6111.90.70.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6111.90.9000",
      "rawHtsCode": "6111.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (839)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6112",
      "rawHtsCode": "6112",
      "superior": null,
      "indent": "0",
      "description": "Track suits, ski-suits and swimwear, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.11.00",
      "rawHtsCode": "6112.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6112.11.0010",
      "rawHtsCode": "6112.11.00.10",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.11.0020",
      "rawHtsCode": "6112.11.00.20",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.11.0030",
      "rawHtsCode": "6112.11.00.30",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.11.0040",
      "rawHtsCode": "6112.11.00.40",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.11.0050",
      "rawHtsCode": "6112.11.00.50",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.11.0060",
      "rawHtsCode": "6112.11.00.60",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.12.00",
      "rawHtsCode": "6112.12.00",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers",
      "units": [],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6112.12.0010",
      "rawHtsCode": "6112.12.00.10",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.12.0020",
      "rawHtsCode": "6112.12.00.20",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.12.0030",
      "rawHtsCode": "6112.12.00.30",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.12.0040",
      "rawHtsCode": "6112.12.00.40",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.12.0050",
      "rawHtsCode": "6112.12.00.50",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.12.0060",
      "rawHtsCode": "6112.12.00.60",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19",
      "rawHtsCode": "6112.19",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.10",
      "rawHtsCode": "6112.19.10",
      "superior": null,
      "indent": "3",
      "description": "Of artificial fibers",
      "units": [],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6112.19.1010",
      "rawHtsCode": "6112.19.10.10",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.1020",
      "rawHtsCode": "6112.19.10.20",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.1030",
      "rawHtsCode": "6112.19.10.30",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.1040",
      "rawHtsCode": "6112.19.10.40",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.1050",
      "rawHtsCode": "6112.19.10.50",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.1060",
      "rawHtsCode": "6112.19.10.60",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.40",
      "rawHtsCode": "6112.19.40",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6112.19.4010",
      "rawHtsCode": "6112.19.40.10",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (734)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.4020",
      "rawHtsCode": "6112.19.40.20",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.4030",
      "rawHtsCode": "6112.19.40.30",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (738)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.4040",
      "rawHtsCode": "6112.19.40.40",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (739)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.4050",
      "rawHtsCode": "6112.19.40.50",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (747)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.4060",
      "rawHtsCode": "6112.19.40.60",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (748)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.80",
      "rawHtsCode": "6112.19.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "21.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6112.19.8010",
      "rawHtsCode": "6112.19.80.10",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.8020",
      "rawHtsCode": "6112.19.80.20",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.8030",
      "rawHtsCode": "6112.19.80.30",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.8040",
      "rawHtsCode": "6112.19.80.40",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.8050",
      "rawHtsCode": "6112.19.80.50",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.19.8060",
      "rawHtsCode": "6112.19.80.60",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20",
      "rawHtsCode": "6112.20",
      "superior": null,
      "indent": "1",
      "description": "Ski-suits:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20.10",
      "rawHtsCode": "6112.20.10",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6112.20.1010",
      "rawHtsCode": "6112.20.10.10",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20.1020",
      "rawHtsCode": "6112.20.10.20",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20.1030",
      "rawHtsCode": "6112.20.10.30",
      "superior": null,
      "indent": "5",
      "description": "Men's or boys' (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20.1040",
      "rawHtsCode": "6112.20.10.40",
      "superior": null,
      "indent": "5",
      "description": "Women's or girls' (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20.1050",
      "rawHtsCode": "6112.20.10.50",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20.1060",
      "rawHtsCode": "6112.20.10.60",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20.1070",
      "rawHtsCode": "6112.20.10.70",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20.1080",
      "rawHtsCode": "6112.20.10.80",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20.1090",
      "rawHtsCode": "6112.20.10.90",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20.20",
      "rawHtsCode": "6112.20.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "8.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6112.20.2010",
      "rawHtsCode": "6112.20.20.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20.2020",
      "rawHtsCode": "6112.20.20.20",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.20.2030",
      "rawHtsCode": "6112.20.20.30",
      "superior": null,
      "indent": "3",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.31.00",
      "rawHtsCode": "6112.31.00",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers",
      "units": [],
      "generalRate": "25.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6112.31.0010",
      "rawHtsCode": "6112.31.00.10",
      "superior": null,
      "indent": "3",
      "description": "Men's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.31.0020",
      "rawHtsCode": "6112.31.00.20",
      "superior": null,
      "indent": "3",
      "description": "Boys' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.39.00",
      "rawHtsCode": "6112.39.00",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials",
      "units": [],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6112.39.0010",
      "rawHtsCode": "6112.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.39.0015",
      "rawHtsCode": "6112.39.00.15",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.39.0090",
      "rawHtsCode": "6112.39.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.41.00",
      "rawHtsCode": "6112.41.00",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers",
      "units": [],
      "generalRate": "24.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6112.41.0010",
      "rawHtsCode": "6112.41.00.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.41.0020",
      "rawHtsCode": "6112.41.00.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.41.0030",
      "rawHtsCode": "6112.41.00.30",
      "superior": null,
      "indent": "4",
      "description": "Women's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.41.0040",
      "rawHtsCode": "6112.41.00.40",
      "superior": null,
      "indent": "4",
      "description": "Girls' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.49.00",
      "rawHtsCode": "6112.49.00",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials",
      "units": [],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6112.49.0010",
      "rawHtsCode": "6112.49.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.49.0015",
      "rawHtsCode": "6112.49.00.15",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6112.49.0090",
      "rawHtsCode": "6112.49.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00",
      "rawHtsCode": "6113.00",
      "superior": null,
      "indent": "0",
      "description": "Garments, made up of knitted or crocheted fabrics of heading 5903, 5906 or 5907:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.10",
      "rawHtsCode": "6113.00.10",
      "superior": null,
      "indent": "1",
      "description": "Having an outer surface impregnated, coated, covered, or laminated with rubber or plastics material which completely obscures the underlying fabric",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6113.00.1005",
      "rawHtsCode": "6113.00.10.05",
      "superior": null,
      "indent": "3",
      "description": "Men's or boys'",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.1010",
      "rawHtsCode": "6113.00.10.10",
      "superior": null,
      "indent": "3",
      "description": "Women's or girls'",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.1012",
      "rawHtsCode": "6113.00.10.12",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.90",
      "rawHtsCode": "6113.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6113.00.9015",
      "rawHtsCode": "6113.00.90.15",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9020",
      "rawHtsCode": "6113.00.90.20",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9025",
      "rawHtsCode": "6113.00.90.25",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9030",
      "rawHtsCode": "6113.00.90.30",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9038",
      "rawHtsCode": "6113.00.90.38",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9042",
      "rawHtsCode": "6113.00.90.42",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9044",
      "rawHtsCode": "6113.00.90.44",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9052",
      "rawHtsCode": "6113.00.90.52",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9055",
      "rawHtsCode": "6113.00.90.55",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9060",
      "rawHtsCode": "6113.00.90.60",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9065",
      "rawHtsCode": "6113.00.90.65",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9070",
      "rawHtsCode": "6113.00.90.70",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9074",
      "rawHtsCode": "6113.00.90.74",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9082",
      "rawHtsCode": "6113.00.90.82",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9084",
      "rawHtsCode": "6113.00.90.84",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6113.00.9086",
      "rawHtsCode": "6113.00.90.86",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114",
      "rawHtsCode": "6114",
      "superior": null,
      "indent": "0",
      "description": "Other garments, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.00",
      "rawHtsCode": "6114.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of cotton",
      "units": [],
      "generalRate": "10.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6114.20.0005",
      "rawHtsCode": "6114.20.00.05",
      "superior": null,
      "indent": "3",
      "description": "Men's or boys' (338)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.0010",
      "rawHtsCode": "6114.20.00.10",
      "superior": null,
      "indent": "3",
      "description": "Women's or girls' (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.0015",
      "rawHtsCode": "6114.20.00.15",
      "superior": null,
      "indent": "2",
      "description": "Jumpers (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.0020",
      "rawHtsCode": "6114.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Bodysuits and bodyshirts (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.0035",
      "rawHtsCode": "6114.20.00.35",
      "superior": null,
      "indent": "3",
      "description": "Boys' (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.0040",
      "rawHtsCode": "6114.20.00.40",
      "superior": null,
      "indent": "3",
      "description": "Women's or girls' (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.0042",
      "rawHtsCode": "6114.20.00.42",
      "superior": null,
      "indent": "3",
      "description": "Insulated, for cold weather protection (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.0044",
      "rawHtsCode": "6114.20.00.44",
      "superior": null,
      "indent": "4",
      "description": "Boys', sizes 2-7 (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.0046",
      "rawHtsCode": "6114.20.00.46",
      "superior": null,
      "indent": "4",
      "description": "Girls' (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.0048",
      "rawHtsCode": "6114.20.00.48",
      "superior": null,
      "indent": "4",
      "description": "Men's and other boys' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.0052",
      "rawHtsCode": "6114.20.00.52",
      "superior": null,
      "indent": "4",
      "description": "Women's (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.0055",
      "rawHtsCode": "6114.20.00.55",
      "superior": null,
      "indent": "3",
      "description": "Men's or boys' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.20.0060",
      "rawHtsCode": "6114.20.00.60",
      "superior": null,
      "indent": "3",
      "description": "Women's or girls' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30",
      "rawHtsCode": "6114.30",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.10",
      "rawHtsCode": "6114.30.10",
      "superior": null,
      "indent": "2",
      "description": "Tops",
      "units": [],
      "generalRate": "28.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6114.30.1010",
      "rawHtsCode": "6114.30.10.10",
      "superior": null,
      "indent": "3",
      "description": "Men's or boys' (638)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.1020",
      "rawHtsCode": "6114.30.10.20",
      "superior": null,
      "indent": "3",
      "description": "Women's or girls' (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.20",
      "rawHtsCode": "6114.30.20",
      "superior": null,
      "indent": "2",
      "description": "Bodysuits and bodyshirts",
      "units": [],
      "generalRate": "32%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6114.30.2010",
      "rawHtsCode": "6114.30.20.10",
      "superior": null,
      "indent": "3",
      "description": "Of fabric containing by weight 5 percent or more elastomeric yarn or rubber thread (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.2030",
      "rawHtsCode": "6114.30.20.30",
      "superior": null,
      "indent": "4",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.2060",
      "rawHtsCode": "6114.30.20.60",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.30",
      "rawHtsCode": "6114.30.30",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6114.30.3012",
      "rawHtsCode": "6114.30.30.12",
      "superior": null,
      "indent": "4",
      "description": "Containing 23 percent or more by weight of wool orfine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.3014",
      "rawHtsCode": "6114.30.30.14",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.3020",
      "rawHtsCode": "6114.30.30.20",
      "superior": null,
      "indent": "4",
      "description": "Boys' (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.3030",
      "rawHtsCode": "6114.30.30.30",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.3042",
      "rawHtsCode": "6114.30.30.42",
      "superior": null,
      "indent": "5",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.3044",
      "rawHtsCode": "6114.30.30.44",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.3052",
      "rawHtsCode": "6114.30.30.52",
      "superior": null,
      "indent": "5",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.3054",
      "rawHtsCode": "6114.30.30.54",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.3060",
      "rawHtsCode": "6114.30.30.60",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.30.3070",
      "rawHtsCode": "6114.30.30.70",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90",
      "rawHtsCode": "6114.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.05",
      "rawHtsCode": "6114.90.05",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6114.90.0520",
      "rawHtsCode": "6114.90.05.20",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.0540",
      "rawHtsCode": "6114.90.05.40",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.0550",
      "rawHtsCode": "6114.90.05.50",
      "superior": null,
      "indent": "3",
      "description": "Jumpers (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.0560",
      "rawHtsCode": "6114.90.05.60",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.0570",
      "rawHtsCode": "6114.90.05.70",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.10",
      "rawHtsCode": "6114.90.10",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "0.9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6114.90.1010",
      "rawHtsCode": "6114.90.10.10",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys' (738)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.1020",
      "rawHtsCode": "6114.90.10.20",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls' (739)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.1030",
      "rawHtsCode": "6114.90.10.30",
      "superior": null,
      "indent": "3",
      "description": "Jumpers (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.1040",
      "rawHtsCode": "6114.90.10.40",
      "superior": null,
      "indent": "3",
      "description": "Sunsuits, washsuits and similar apparel (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.1050",
      "rawHtsCode": "6114.90.10.50",
      "superior": null,
      "indent": "3",
      "description": "Coveralls, jumpsuits and similar apparel (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.1060",
      "rawHtsCode": "6114.90.10.60",
      "superior": null,
      "indent": "3",
      "description": "Other (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.90",
      "rawHtsCode": "6114.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6114.90.9010",
      "rawHtsCode": "6114.90.90.10",
      "superior": null,
      "indent": "3",
      "description": "Tops (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.9020",
      "rawHtsCode": "6114.90.90.20",
      "superior": null,
      "indent": "3",
      "description": "Jumpers (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.9030",
      "rawHtsCode": "6114.90.90.30",
      "superior": null,
      "indent": "3",
      "description": "Sunsuits, washsuits and similar apparel (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.9040",
      "rawHtsCode": "6114.90.90.40",
      "superior": null,
      "indent": "3",
      "description": "Coveralls, jumpsuits and similar apparel (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.9045",
      "rawHtsCode": "6114.90.90.45",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.9050",
      "rawHtsCode": "6114.90.90.50",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.9055",
      "rawHtsCode": "6114.90.90.55",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6114.90.9070",
      "rawHtsCode": "6114.90.90.70",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115",
      "rawHtsCode": "6115",
      "superior": null,
      "indent": "0",
      "description": "Panty hose, tights, stockings, socks and other hosiery, including graduated compression hosiery (for example, stockings for varicose veins) and footwear without applied soles, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.10",
      "rawHtsCode": "6115.10",
      "superior": null,
      "indent": "1",
      "description": "Graduated compression hosiery (for example, stockings for varicose veins):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.10.0500",
      "rawHtsCode": "6115.10.05.00",
      "superior": null,
      "indent": "2",
      "description": "Surgical panty hose and surgical stockings with graduated compression for orthopedic treatment",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.10.1000",
      "rawHtsCode": "6115.10.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of synthetic fibers (659)",
      "units": [
        "<il>doz. prs.</il>",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.10.15",
      "rawHtsCode": "6115.10.15",
      "superior": null,
      "indent": "3",
      "description": "Of other textile materials",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.10.1510",
      "rawHtsCode": "6115.10.15.10",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (359)",
      "units": [
        "<il>doz. prs.</il>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.10.1520",
      "rawHtsCode": "6115.10.15.20",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "<il>doz. prs.</il>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.10.1540",
      "rawHtsCode": "6115.10.15.40",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "<il>doz. prs.</il>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.10.3000",
      "rawHtsCode": "6115.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (332)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "13.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.10.4000",
      "rawHtsCode": "6115.10.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of synthetic fibers (632)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "14.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.10.5500",
      "rawHtsCode": "6115.10.55.00",
      "superior": null,
      "indent": "3",
      "description": "Of artificial fibers (632)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "14.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.10.6000",
      "rawHtsCode": "6115.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of other textile materials (832)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "9.9%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.21.00",
      "rawHtsCode": "6115.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers, measuring per single yarn less than 67 decitex",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.21.0010",
      "rawHtsCode": "6115.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Tights (659)",
      "units": [
        "<il>doz. prs.</il>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.21.0020",
      "rawHtsCode": "6115.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other (632)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.22.0000",
      "rawHtsCode": "6115.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers, measuring per single yarn 67 decitex or more (659)",
      "units": [
        "<il>doz. prs.</il>",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.29",
      "rawHtsCode": "6115.29",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.29.4000",
      "rawHtsCode": "6115.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.29.80",
      "rawHtsCode": "6115.29.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.29.8010",
      "rawHtsCode": "6115.29.80.10",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (359)",
      "units": [
        "<il>doz. prs.</il>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.29.8020",
      "rawHtsCode": "6115.29.80.20",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "<il>doz. prs.</il>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.29.8040",
      "rawHtsCode": "6115.29.80.40",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "<il>doz. prs.</il>",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.30",
      "rawHtsCode": "6115.30",
      "superior": null,
      "indent": "1",
      "description": "Other women's full-length or knee-length hosiery, measuring per single yarn less than 67 decitex:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.30.1000",
      "rawHtsCode": "6115.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.30.90",
      "rawHtsCode": "6115.30.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "14.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.30.9010",
      "rawHtsCode": "6115.30.90.10",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers (632)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.30.9030",
      "rawHtsCode": "6115.30.90.30",
      "superior": null,
      "indent": "3",
      "description": "Other (832)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.94.0000",
      "rawHtsCode": "6115.94.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (432)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.95",
      "rawHtsCode": "6115.95",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.95.6000",
      "rawHtsCode": "6115.95.60.00",
      "superior": null,
      "indent": "3",
      "description": "Containing lace or net (332)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.95.9000",
      "rawHtsCode": "6115.95.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (332)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "13.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.96",
      "rawHtsCode": "6115.96",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.96.60",
      "rawHtsCode": "6115.96.60",
      "superior": null,
      "indent": "3",
      "description": "Containing lace or net",
      "units": [],
      "generalRate": "18.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.96.6010",
      "rawHtsCode": "6115.96.60.10",
      "superior": null,
      "indent": "4",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (432)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.96.6020",
      "rawHtsCode": "6115.96.60.20",
      "superior": null,
      "indent": "4",
      "description": "Other (632)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.96.90",
      "rawHtsCode": "6115.96.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.96.9010",
      "rawHtsCode": "6115.96.90.10",
      "superior": null,
      "indent": "4",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (432)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.96.9020",
      "rawHtsCode": "6115.96.90.20",
      "superior": null,
      "indent": "4",
      "description": "Other (632)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.99",
      "rawHtsCode": "6115.99",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.99.14",
      "rawHtsCode": "6115.99.14",
      "superior": null,
      "indent": "4",
      "description": "Containing lace or net",
      "units": [],
      "generalRate": "18.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.99.1410",
      "rawHtsCode": "6115.99.14.10",
      "superior": null,
      "indent": "5",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (432)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.99.1420",
      "rawHtsCode": "6115.99.14.20",
      "superior": null,
      "indent": "5",
      "description": "Other (632)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.99.19",
      "rawHtsCode": "6115.99.19",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "14.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.99.1910",
      "rawHtsCode": "6115.99.19.10",
      "superior": null,
      "indent": "5",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (432)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.99.1920",
      "rawHtsCode": "6115.99.19.20",
      "superior": null,
      "indent": "5",
      "description": "Other (632)",
      "units": [
        "<il>doz. prs</il>.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6115.99.4000",
      "rawHtsCode": "6115.99.40.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6115.99.9000",
      "rawHtsCode": "6115.99.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (832)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "9.9%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116",
      "rawHtsCode": "6116",
      "superior": null,
      "indent": "0",
      "description": "Gloves, mittens and mitts, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10",
      "rawHtsCode": "6116.10",
      "superior": null,
      "indent": "1",
      "description": "Impregnated, coated, covered or laminated with plastics or rubber:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.0500",
      "rawHtsCode": "6116.10.05.00",
      "superior": null,
      "indent": "2",
      "description": "Ice hockey gloves and field hockey gloves",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.0800",
      "rawHtsCode": "6116.10.08.00",
      "superior": null,
      "indent": "2",
      "description": "Other gloves, mittens and mitts, all the foregoing specially designed for use in sports, including ski and snowmobile gloves, mittens and mitts",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.10.1300",
      "rawHtsCode": "6116.10.13.00",
      "superior": null,
      "indent": "6",
      "description": "Containing over 50 percent by weight of plastics or rubber",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "61%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.10.17",
      "rawHtsCode": "6116.10.17",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "23.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG) 22.5% (E)",
      "otherRate": "61%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.10.1720",
      "rawHtsCode": "6116.10.17.20",
      "superior": null,
      "indent": "7",
      "description": "Subject to cotton restraints (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.1730",
      "rawHtsCode": "6116.10.17.30",
      "superior": null,
      "indent": "7",
      "description": "Subject to man-made fiber restraints (631)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.1740",
      "rawHtsCode": "6116.10.17.40",
      "superior": null,
      "indent": "7",
      "description": "Other (831)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.4400",
      "rawHtsCode": "6116.10.44.00",
      "superior": null,
      "indent": "6",
      "description": "Containing over 50 percent by weight of plastics or rubber",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "9.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA, OM,P,PA,PE,S,SG) 8.9% (E)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.10.48",
      "rawHtsCode": "6116.10.48",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "18.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG) 16.3% (E)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.10.4810",
      "rawHtsCode": "6116.10.48.10",
      "superior": null,
      "indent": "7",
      "description": "Subject to cotton restraints (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.4820",
      "rawHtsCode": "6116.10.48.20",
      "superior": null,
      "indent": "7",
      "description": "Subject to man-made fiber re- straints (631)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.4830",
      "rawHtsCode": "6116.10.48.30",
      "superior": null,
      "indent": "7",
      "description": "Other (831)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.55",
      "rawHtsCode": "6116.10.55",
      "superior": null,
      "indent": "5",
      "description": "Containing 50 percent or more by weight of cotton, man-made fibers or other textile fibers, or any combination thereof",
      "units": [],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG) 10.7% (E)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.10.5510",
      "rawHtsCode": "6116.10.55.10",
      "superior": null,
      "indent": "6",
      "description": "Subject to cotton restraints (331)",
      "units": [
        "<il>doz. prs</il>.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.5520",
      "rawHtsCode": "6116.10.55.20",
      "superior": null,
      "indent": "6",
      "description": "Subject to man-made fiber restraints (631)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.5530",
      "rawHtsCode": "6116.10.55.30",
      "superior": null,
      "indent": "6",
      "description": "Other (831)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.6500",
      "rawHtsCode": "6116.10.65.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "<il>doz. prs</il>.",
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL, JO,KR,MA, OM,P,PA,PE,S,SG) 6% (E)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.10.75",
      "rawHtsCode": "6116.10.75",
      "superior": null,
      "indent": "4",
      "description": "Containing 50 percent or more by weight of cotton, man-made fibers or other textile fibers, or any combination thereof",
      "units": [],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.10.7510",
      "rawHtsCode": "6116.10.75.10",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.7520",
      "rawHtsCode": "6116.10.75.20",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (631)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.7530",
      "rawHtsCode": "6116.10.75.30",
      "superior": null,
      "indent": "5",
      "description": "Other (831)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.10.9500",
      "rawHtsCode": "6116.10.95.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "<il>doz. prs</il>.",
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.91.0000",
      "rawHtsCode": "6116.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (431)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "31.2¢/kg + 7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg +50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.92",
      "rawHtsCode": "6116.92",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.92.0500",
      "rawHtsCode": "6116.92.05.00",
      "superior": null,
      "indent": "3",
      "description": "Ice hockey gloves and field hockey gloves",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.92.0800",
      "rawHtsCode": "6116.92.08.00",
      "superior": null,
      "indent": "3",
      "description": "Other gloves, mittens and mitts, all the fore going specially designed for use in sports, including ski and snowmobile gloves, mittens and mitts",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.92.64",
      "rawHtsCode": "6116.92.64",
      "superior": null,
      "indent": "5",
      "description": "Without fourchettes",
      "units": [],
      "generalRate": "23.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG) 22.5% (E)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.92.6410",
      "rawHtsCode": "6116.92.64.10",
      "superior": null,
      "indent": "6",
      "description": "Terry cloth type, looped pile fabric (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.92.6420",
      "rawHtsCode": "6116.92.64.20",
      "superior": null,
      "indent": "6",
      "description": "Jersey type, brushed or napped fabric (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.92.6430",
      "rawHtsCode": "6116.92.64.30",
      "superior": null,
      "indent": "6",
      "description": "Lisle type, no pile, not brushed or napped (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.92.6440",
      "rawHtsCode": "6116.92.64.40",
      "superior": null,
      "indent": "6",
      "description": "Other (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.92.74",
      "rawHtsCode": "6116.92.74",
      "superior": null,
      "indent": "5",
      "description": "With fourchettes",
      "units": [],
      "generalRate": "23.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.92.7450",
      "rawHtsCode": "6116.92.74.50",
      "superior": null,
      "indent": "6",
      "description": "Jersey type, brushed or napped fabric (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.92.7460",
      "rawHtsCode": "6116.92.74.60",
      "superior": null,
      "indent": "6",
      "description": "Lisle type, no pile, not brushed or napped (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.92.7470",
      "rawHtsCode": "6116.92.74.70",
      "superior": null,
      "indent": "6",
      "description": "Other (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.92.8800",
      "rawHtsCode": "6116.92.88.00",
      "superior": null,
      "indent": "5",
      "description": "Without fourchettes (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "9.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG) 7.4% (E)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.92.9400",
      "rawHtsCode": "6116.92.94.00",
      "superior": null,
      "indent": "5",
      "description": "With fourchettes (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "9.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.93",
      "rawHtsCode": "6116.93",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.93.0500",
      "rawHtsCode": "6116.93.05.00",
      "superior": null,
      "indent": "3",
      "description": "Ice hockey gloves and field hockey gloves",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6116.93.0800",
      "rawHtsCode": "6116.93.08.00",
      "superior": null,
      "indent": "3",
      "description": "Other gloves, mittens and mitts, all the fore going specially designed for use in sports, including ski and snowmobile gloves, mittens and mitts",
      "units": [
        "<il>doz. prs</il>.",
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.93.6400",
      "rawHtsCode": "6116.93.64.00",
      "superior": null,
      "indent": "5",
      "description": "Without fourchettes (431)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "31¢/kg + 6.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG) 31¢/kg + 5.4% (E)",
      "otherRate": "$1.10/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.93.7400",
      "rawHtsCode": "6116.93.74.00",
      "superior": null,
      "indent": "5",
      "description": "With fourchettes (431)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "31¢/kg + 6.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.93.8800",
      "rawHtsCode": "6116.93.88.00",
      "superior": null,
      "indent": "5",
      "description": "Without fourchettes (631)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "18.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG) 16.3% (E)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.93.9400",
      "rawHtsCode": "6116.93.94.00",
      "superior": null,
      "indent": "5",
      "description": "With fourchettes (631)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "18.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.99",
      "rawHtsCode": "6116.99",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.99.2000",
      "rawHtsCode": "6116.99.20.00",
      "superior": null,
      "indent": "4",
      "description": "Ice hockey gloves and field hockey gloves",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.99.3500",
      "rawHtsCode": "6116.99.35.00",
      "superior": null,
      "indent": "4",
      "description": "Other gloves, mittens and mitts, all the fore going specially designed for use in sports, including ski and snowmobile gloves, mittens and mitts",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.99.4800",
      "rawHtsCode": "6116.99.48.00",
      "superior": null,
      "indent": "5",
      "description": "Without fourchettes (631)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "18.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG) 16.5% (E)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.99.5400",
      "rawHtsCode": "6116.99.54.00",
      "superior": null,
      "indent": "5",
      "description": "With fourchettes (631)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "18.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.99.7500",
      "rawHtsCode": "6116.99.75.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.99.95",
      "rawHtsCode": "6116.99.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6116.99.9510",
      "rawHtsCode": "6116.99.95.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (331)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.99.9520",
      "rawHtsCode": "6116.99.95.20",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (431)",
      "units": [
        "<il>doz. prs.</il>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.99.9530",
      "rawHtsCode": "6116.99.95.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (631)",
      "units": [
        "<il>doz. prs</il>.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6116.99.9560",
      "rawHtsCode": "6116.99.95.60",
      "superior": null,
      "indent": "4",
      "description": "Other (831)",
      "units": [
        "<il>doz. prs</il>.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117",
      "rawHtsCode": "6117",
      "superior": null,
      "indent": "0",
      "description": "Other made up clothing accessories, knitted or crocheted; knitted or crocheted parts of garments or of clothing accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.10",
      "rawHtsCode": "6117.10",
      "superior": null,
      "indent": "1",
      "description": "Shawls, scarves, mufflers, mantillas, veils and the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.10.1000",
      "rawHtsCode": "6117.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "9.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6117.10.20",
      "rawHtsCode": "6117.10.20",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6117.10.2010",
      "rawHtsCode": "6117.10.20.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.10.2030",
      "rawHtsCode": "6117.10.20.30",
      "superior": null,
      "indent": "3",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.10.4000",
      "rawHtsCode": "6117.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6117.10.60",
      "rawHtsCode": "6117.10.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "9.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,NP,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6117.10.6010",
      "rawHtsCode": "6117.10.60.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.10.6020",
      "rawHtsCode": "6117.10.60.20",
      "superior": null,
      "indent": "3",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.80",
      "rawHtsCode": "6117.80",
      "superior": null,
      "indent": "1",
      "description": "Other accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.80.2000",
      "rawHtsCode": "6117.80.20.00",
      "superior": null,
      "indent": "3",
      "description": "Ties, bow ties and cravats (758)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "1.2%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "71.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6117.80.30",
      "rawHtsCode": "6117.80.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6117.80.3010",
      "rawHtsCode": "6117.80.30.10",
      "superior": null,
      "indent": "4",
      "description": "Headbands, ponytail holders and similar articles",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.80.3090",
      "rawHtsCode": "6117.80.30.90",
      "superior": null,
      "indent": "4",
      "description": "Other (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.80.8500",
      "rawHtsCode": "6117.80.85.00",
      "superior": null,
      "indent": "3",
      "description": "Headbands, ponytail holders and similar articles",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6117.80.87",
      "rawHtsCode": "6117.80.87",
      "superior": null,
      "indent": "3",
      "description": "Ties, bow ties and cravats",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "71.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6117.80.8710",
      "rawHtsCode": "6117.80.87.10",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.80.8720",
      "rawHtsCode": "6117.80.87.20",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.80.8730",
      "rawHtsCode": "6117.80.87.30",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.80.8770",
      "rawHtsCode": "6117.80.87.70",
      "superior": null,
      "indent": "4",
      "description": "Other (858)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.80.95",
      "rawHtsCode": "6117.80.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6117.80.9510",
      "rawHtsCode": "6117.80.95.10",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.80.9520",
      "rawHtsCode": "6117.80.95.20",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.80.9530",
      "rawHtsCode": "6117.80.95.30",
      "superior": null,
      "indent": "5",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.80.9540",
      "rawHtsCode": "6117.80.95.40",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.80.9570",
      "rawHtsCode": "6117.80.95.70",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90",
      "rawHtsCode": "6117.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.10",
      "rawHtsCode": "6117.90.10",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "2.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6117.90.1010",
      "rawHtsCode": "6117.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Of sweaters (746)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.1020",
      "rawHtsCode": "6117.90.10.20",
      "superior": null,
      "indent": "3",
      "description": "Of blouses and shirts (739)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.1030",
      "rawHtsCode": "6117.90.10.30",
      "superior": null,
      "indent": "3",
      "description": "Of coats and jackets (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.1040",
      "rawHtsCode": "6117.90.10.40",
      "superior": null,
      "indent": "3",
      "description": "Of trousers, breeches and shorts (748)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.1060",
      "rawHtsCode": "6117.90.10.60",
      "superior": null,
      "indent": "3",
      "description": "Other (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.90",
      "rawHtsCode": "6117.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "14.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6117.90.9003",
      "rawHtsCode": "6117.90.90.03",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (345)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9005",
      "rawHtsCode": "6117.90.90.05",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (446)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9010",
      "rawHtsCode": "6117.90.90.10",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (646)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9015",
      "rawHtsCode": "6117.90.90.15",
      "superior": null,
      "indent": "4",
      "description": "Other (845)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9020",
      "rawHtsCode": "6117.90.90.20",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (339)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9025",
      "rawHtsCode": "6117.90.90.25",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9030",
      "rawHtsCode": "6117.90.90.30",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (639)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9035",
      "rawHtsCode": "6117.90.90.35",
      "superior": null,
      "indent": "4",
      "description": "Other (838)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9040",
      "rawHtsCode": "6117.90.90.40",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9045",
      "rawHtsCode": "6117.90.90.45",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9050",
      "rawHtsCode": "6117.90.90.50",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9055",
      "rawHtsCode": "6117.90.90.55",
      "superior": null,
      "indent": "4",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9060",
      "rawHtsCode": "6117.90.90.60",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9065",
      "rawHtsCode": "6117.90.90.65",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9070",
      "rawHtsCode": "6117.90.90.70",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9075",
      "rawHtsCode": "6117.90.90.75",
      "superior": null,
      "indent": "4",
      "description": "Other (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9080",
      "rawHtsCode": "6117.90.90.80",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9085",
      "rawHtsCode": "6117.90.90.85",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9090",
      "rawHtsCode": "6117.90.90.90",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6117.90.9095",
      "rawHtsCode": "6117.90.90.95",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201",
      "rawHtsCode": "6201",
      "superior": null,
      "indent": "0",
      "description": "Men's or boys' overcoats, carcoats, capes, cloaks, anoraks (including ski jackets), windbreakers and   similar articles (including padded, sleeveless jackets), other than those of heading 6203:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.20",
      "rawHtsCode": "6201.20",
      "superior": null,
      "indent": "1",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.20.11",
      "rawHtsCode": "6201.20.11",
      "superior": null,
      "indent": "2",
      "description": "Overcoats, carcoats, capes, cloaks and similar coats:",
      "units": [],
      "generalRate": "41¢/kg + 16.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.20.1110",
      "rawHtsCode": "6201.20.11.10",
      "superior": null,
      "indent": "3",
      "description": "Men's (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.20.1120",
      "rawHtsCode": "6201.20.11.20",
      "superior": null,
      "indent": "3",
      "description": "Boys' (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.20.1900",
      "rawHtsCode": "6201.20.19.00",
      "superior": null,
      "indent": "4",
      "description": "Padded, sleeveless jackets (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.20.29",
      "rawHtsCode": "6201.20.29",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "49.7¢/kg + 19.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.20.2911",
      "rawHtsCode": "6201.20.29.11",
      "superior": null,
      "indent": "5",
      "description": "Men's (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.20.2921",
      "rawHtsCode": "6201.20.29.21",
      "superior": null,
      "indent": "5",
      "description": "Boys' (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.20.3500",
      "rawHtsCode": "6201.20.35.00",
      "superior": null,
      "indent": "4",
      "description": "Padded, sleeveless jackets (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.20.40",
      "rawHtsCode": "6201.20.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "49.7¢/kg + 19.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.20.4011",
      "rawHtsCode": "6201.20.40.11",
      "superior": null,
      "indent": "5",
      "description": "Men's (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.20.4021",
      "rawHtsCode": "6201.20.40.21",
      "superior": null,
      "indent": "5",
      "description": "Boys' (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30",
      "rawHtsCode": "6201.30",
      "superior": null,
      "indent": "1",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.1200",
      "rawHtsCode": "6201.30.12.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35   percent or more by weight; containing 10 percent or more by weight of down (353)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.30.20",
      "rawHtsCode": "6201.30.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "9.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.30.2010",
      "rawHtsCode": "6201.30.20.10",
      "superior": null,
      "indent": "5",
      "description": "Men's (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.2020",
      "rawHtsCode": "6201.30.20.20",
      "superior": null,
      "indent": "5",
      "description": "Boys' (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.2025",
      "rawHtsCode": "6201.30.20.25",
      "superior": null,
      "indent": "6",
      "description": "Men's (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.2035",
      "rawHtsCode": "6201.30.20.35",
      "superior": null,
      "indent": "6",
      "description": "Boys' (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.2050",
      "rawHtsCode": "6201.30.20.50",
      "superior": null,
      "indent": "6",
      "description": "Men's (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.2060",
      "rawHtsCode": "6201.30.20.60",
      "superior": null,
      "indent": "6",
      "description": "Boys' (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.3000",
      "rawHtsCode": "6201.30.30.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down (353)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.30.4000",
      "rawHtsCode": "6201.30.40.00",
      "superior": null,
      "indent": "5",
      "description": "Water resistant (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.30.50",
      "rawHtsCode": "6201.30.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "9.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.30.5005",
      "rawHtsCode": "6201.30.50.05",
      "superior": null,
      "indent": "7",
      "description": "With attachments for sleeves (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.5010",
      "rawHtsCode": "6201.30.50.10",
      "superior": null,
      "indent": "7",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.5021",
      "rawHtsCode": "6201.30.50.21",
      "superior": null,
      "indent": "7",
      "description": "Corduroy (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.5031",
      "rawHtsCode": "6201.30.50.31",
      "superior": null,
      "indent": "8",
      "description": "Men's (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.5041",
      "rawHtsCode": "6201.30.50.41",
      "superior": null,
      "indent": "8",
      "description": "Boys' (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.5051",
      "rawHtsCode": "6201.30.50.51",
      "superior": null,
      "indent": "8",
      "description": "Men's (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.5061",
      "rawHtsCode": "6201.30.50.61",
      "superior": null,
      "indent": "8",
      "description": "Boys' (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.6000",
      "rawHtsCode": "6201.30.60.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down (353)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.30.7000",
      "rawHtsCode": "6201.30.70.00",
      "superior": null,
      "indent": "5",
      "description": "Water resistant (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.30.80",
      "rawHtsCode": "6201.30.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "9.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.30.8005",
      "rawHtsCode": "6201.30.80.05",
      "superior": null,
      "indent": "7",
      "description": "With attachments for sleeves (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.8010",
      "rawHtsCode": "6201.30.80.10",
      "superior": null,
      "indent": "7",
      "description": "Other (359)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.8021",
      "rawHtsCode": "6201.30.80.21",
      "superior": null,
      "indent": "7",
      "description": "Corduroy (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.8031",
      "rawHtsCode": "6201.30.80.31",
      "superior": null,
      "indent": "8",
      "description": "Men's (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.8041",
      "rawHtsCode": "6201.30.80.41",
      "superior": null,
      "indent": "8",
      "description": "Boys' (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.8051",
      "rawHtsCode": "6201.30.80.51",
      "superior": null,
      "indent": "8",
      "description": "Men's (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.30.8061",
      "rawHtsCode": "6201.30.80.61",
      "superior": null,
      "indent": "8",
      "description": "Boys' (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40",
      "rawHtsCode": "6201.40",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.1000",
      "rawHtsCode": "6201.40.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35   percent or more by weight; containing 10 percent or more by weight of down (653)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.15",
      "rawHtsCode": "6201.40.15",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "49.7¢/kg + 19.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.1510",
      "rawHtsCode": "6201.40.15.10",
      "superior": null,
      "indent": "5",
      "description": "Men's (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.1520",
      "rawHtsCode": "6201.40.15.20",
      "superior": null,
      "indent": "5",
      "description": "Boys' (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.20",
      "rawHtsCode": "6201.40.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "27.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.2015",
      "rawHtsCode": "6201.40.20.15",
      "superior": null,
      "indent": "6",
      "description": "Men's (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.2020",
      "rawHtsCode": "6201.40.20.20",
      "superior": null,
      "indent": "6",
      "description": "Boys' (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.2030",
      "rawHtsCode": "6201.40.20.30",
      "superior": null,
      "indent": "6",
      "description": "Men's (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.2040",
      "rawHtsCode": "6201.40.20.40",
      "superior": null,
      "indent": "6",
      "description": "Boys' (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.2500",
      "rawHtsCode": "6201.40.25.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down (653)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.35",
      "rawHtsCode": "6201.40.35",
      "superior": null,
      "indent": "5",
      "description": "Padded sleeveless jackets:",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.3510",
      "rawHtsCode": "6201.40.35.10",
      "superior": null,
      "indent": "6",
      "description": "With attachments for sleeves (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.3520",
      "rawHtsCode": "6201.40.35.20",
      "superior": null,
      "indent": "6",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.40",
      "rawHtsCode": "6201.40.40",
      "superior": null,
      "indent": "6",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "49.5¢/kg + 19.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.4011",
      "rawHtsCode": "6201.40.40.11",
      "superior": null,
      "indent": "7",
      "description": "Men's (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.4021",
      "rawHtsCode": "6201.40.40.21",
      "superior": null,
      "indent": "7",
      "description": "Boys' (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.4500",
      "rawHtsCode": "6201.40.45.00",
      "superior": null,
      "indent": "7",
      "description": "Water resistant (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.50",
      "rawHtsCode": "6201.40.50",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [],
      "generalRate": "27.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.5011",
      "rawHtsCode": "6201.40.50.11",
      "superior": null,
      "indent": "8",
      "description": "Men's (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.5021",
      "rawHtsCode": "6201.40.50.21",
      "superior": null,
      "indent": "8",
      "description": "Boys' (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.5500",
      "rawHtsCode": "6201.40.55.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down (653)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.60",
      "rawHtsCode": "6201.40.60",
      "superior": null,
      "indent": "5",
      "description": "Padded, sleeveless jackets",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.6010",
      "rawHtsCode": "6201.40.60.10",
      "superior": null,
      "indent": "6",
      "description": "With attachments for sleeves (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.6020",
      "rawHtsCode": "6201.40.60.20",
      "superior": null,
      "indent": "6",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.65",
      "rawHtsCode": "6201.40.65",
      "superior": null,
      "indent": "6",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "49.5¢/kg + 19.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.6511",
      "rawHtsCode": "6201.40.65.11",
      "superior": null,
      "indent": "7",
      "description": "Men's (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.6521",
      "rawHtsCode": "6201.40.65.21",
      "superior": null,
      "indent": "7",
      "description": "Boys' (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.7000",
      "rawHtsCode": "6201.40.70.00",
      "superior": null,
      "indent": "7",
      "description": "Water resistant (634) ",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.75",
      "rawHtsCode": "6201.40.75",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [],
      "generalRate": "27.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.40.7511",
      "rawHtsCode": "6201.40.75.11",
      "superior": null,
      "indent": "8",
      "description": "Men's (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.40.7521",
      "rawHtsCode": "6201.40.75.21",
      "superior": null,
      "indent": "8",
      "description": "Boys' (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90",
      "rawHtsCode": "6201.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90.1900",
      "rawHtsCode": "6201.90.19.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (734)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6201.90.29",
      "rawHtsCode": "6201.90.29",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.90.2910",
      "rawHtsCode": "6201.90.29.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90.2920",
      "rawHtsCode": "6201.90.29.20",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90.2930",
      "rawHtsCode": "6201.90.29.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90.2960",
      "rawHtsCode": "6201.90.29.60",
      "superior": null,
      "indent": "4",
      "description": "Other (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90.3900",
      "rawHtsCode": "6201.90.39.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6201.90.49",
      "rawHtsCode": "6201.90.49",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.90.4910",
      "rawHtsCode": "6201.90.49.10",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90.4920",
      "rawHtsCode": "6201.90.49.20",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90.4930",
      "rawHtsCode": "6201.90.49.30",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90.4960",
      "rawHtsCode": "6201.90.49.60",
      "superior": null,
      "indent": "5",
      "description": "Other (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90.5900",
      "rawHtsCode": "6201.90.59.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6201.90.69",
      "rawHtsCode": "6201.90.69",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6201.90.6910",
      "rawHtsCode": "6201.90.69.10",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90.6920",
      "rawHtsCode": "6201.90.69.20",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90.6930",
      "rawHtsCode": "6201.90.69.30",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6201.90.6960",
      "rawHtsCode": "6201.90.69.60",
      "superior": null,
      "indent": "5",
      "description": "Other (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202",
      "rawHtsCode": "6202",
      "superior": null,
      "indent": "0",
      "description": "Women's or girls' overcoats, carcoats, capes, cloaks, anoraks (including ski jackets), windbreakers   and similar articles (including padded, sleeveless jackets), other than those of heading 6204:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.20",
      "rawHtsCode": "6202.20",
      "superior": null,
      "indent": "1",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.20.11",
      "rawHtsCode": "6202.20.11",
      "superior": null,
      "indent": "2",
      "description": "Overcoats, carcoats, capes, cloaks and similar coats:",
      "units": [],
      "generalRate": "41¢/kg + 16.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "46.3¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.20.1110",
      "rawHtsCode": "6202.20.11.10",
      "superior": null,
      "indent": "3",
      "description": "Women's (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.20.1120",
      "rawHtsCode": "6202.20.11.20",
      "superior": null,
      "indent": "3",
      "description": "Girls' (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.20.1900",
      "rawHtsCode": "6202.20.19.00",
      "superior": null,
      "indent": "4",
      "description": "Padded, sleeveless jackets (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.20.29",
      "rawHtsCode": "6202.20.29",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "36¢/kg + 16.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "46.3¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.20.2911",
      "rawHtsCode": "6202.20.29.11",
      "superior": null,
      "indent": "5",
      "description": "Women's (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.20.2921",
      "rawHtsCode": "6202.20.29.21",
      "superior": null,
      "indent": "5",
      "description": "Girls' (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.20.3500",
      "rawHtsCode": "6202.20.35.00",
      "superior": null,
      "indent": "4",
      "description": "Padded, sleeveless jackets (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.20.40",
      "rawHtsCode": "6202.20.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "36¢/kg + 16.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "46.3¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.20.4011",
      "rawHtsCode": "6202.20.40.11",
      "superior": null,
      "indent": "5",
      "description": "Women's (438)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.20.4021",
      "rawHtsCode": "6202.20.40.21",
      "superior": null,
      "indent": "5",
      "description": "Girls' (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30",
      "rawHtsCode": "6202.30",
      "superior": null,
      "indent": "1",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.1200",
      "rawHtsCode": "6202.30.12.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35   percent or more by weight; containing 10 percent or more by weight of down (354)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.30.20",
      "rawHtsCode": "6202.30.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.30.2010",
      "rawHtsCode": "6202.30.20.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.2020",
      "rawHtsCode": "6202.30.20.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.2025",
      "rawHtsCode": "6202.30.20.25",
      "superior": null,
      "indent": "6",
      "description": "Women's (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.2035",
      "rawHtsCode": "6202.30.20.35",
      "superior": null,
      "indent": "6",
      "description": "Girls' (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.2050",
      "rawHtsCode": "6202.30.20.50",
      "superior": null,
      "indent": "6",
      "description": "Women's (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.2060",
      "rawHtsCode": "6202.30.20.60",
      "superior": null,
      "indent": "6",
      "description": "Girls' (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.3000",
      "rawHtsCode": "6202.30.30.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down (354)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.30.4000",
      "rawHtsCode": "6202.30.40.00",
      "superior": null,
      "indent": "5",
      "description": "Water resistant (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.30.50",
      "rawHtsCode": "6202.30.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "8.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.30.5010",
      "rawHtsCode": "6202.30.50.10",
      "superior": null,
      "indent": "7",
      "description": "With attachments for sleeves (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.5020",
      "rawHtsCode": "6202.30.50.20",
      "superior": null,
      "indent": "7",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.5026",
      "rawHtsCode": "6202.30.50.26",
      "superior": null,
      "indent": "8",
      "description": "Women's (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.5031",
      "rawHtsCode": "6202.30.50.31",
      "superior": null,
      "indent": "8",
      "description": "Girls' (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.5061",
      "rawHtsCode": "6202.30.50.61",
      "superior": null,
      "indent": "8",
      "description": "Women's (335) ",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.5071",
      "rawHtsCode": "6202.30.50.71",
      "superior": null,
      "indent": "8",
      "description": "Girls' (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.6000",
      "rawHtsCode": "6202.30.60.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down (354)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.30.7000",
      "rawHtsCode": "6202.30.70.00",
      "superior": null,
      "indent": "5",
      "description": "Water resistant (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.30.80",
      "rawHtsCode": "6202.30.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "8.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.30.8010",
      "rawHtsCode": "6202.30.80.10",
      "superior": null,
      "indent": "7",
      "description": "With attachments for sleeves (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.8020",
      "rawHtsCode": "6202.30.80.20",
      "superior": null,
      "indent": "7",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.8026",
      "rawHtsCode": "6202.30.80.26",
      "superior": null,
      "indent": "8",
      "description": "Women's (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.8031",
      "rawHtsCode": "6202.30.80.31",
      "superior": null,
      "indent": "8",
      "description": "Girls' (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.8061",
      "rawHtsCode": "6202.30.80.61",
      "superior": null,
      "indent": "8",
      "description": "Women's (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.30.8071",
      "rawHtsCode": "6202.30.80.71",
      "superior": null,
      "indent": "8",
      "description": "Girls' (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40",
      "rawHtsCode": "6202.40",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.1000",
      "rawHtsCode": "6202.40.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35   percent or more by weight; containing 10 percent or more by weight of down (654)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.15",
      "rawHtsCode": "6202.40.15",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "43.5¢/kg + 19.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "46.3¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.1510",
      "rawHtsCode": "6202.40.15.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.1520",
      "rawHtsCode": "6202.40.15.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.20",
      "rawHtsCode": "6202.40.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "27.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.2005",
      "rawHtsCode": "6202.40.20.05",
      "superior": null,
      "indent": "6",
      "description": "Women's (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.2010",
      "rawHtsCode": "6202.40.20.10",
      "superior": null,
      "indent": "6",
      "description": "Girls' (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.2020",
      "rawHtsCode": "6202.40.20.20",
      "superior": null,
      "indent": "6",
      "description": "Women's (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.2030",
      "rawHtsCode": "6202.40.20.30",
      "superior": null,
      "indent": "6",
      "description": "Girls' (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.2500",
      "rawHtsCode": "6202.40.25.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down (654)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.35",
      "rawHtsCode": "6202.40.35",
      "superior": null,
      "indent": "5",
      "description": "Padded, sleeveless jackets",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.3510",
      "rawHtsCode": "6202.40.35.10",
      "superior": null,
      "indent": "6",
      "description": "With attachments for sleeves (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.3520",
      "rawHtsCode": "6202.40.35.20",
      "superior": null,
      "indent": "6",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.40",
      "rawHtsCode": "6202.40.40",
      "superior": null,
      "indent": "6",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "43.4¢/kg + 19.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "46.3¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.4011",
      "rawHtsCode": "6202.40.40.11",
      "superior": null,
      "indent": "7",
      "description": "Women's (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.4021",
      "rawHtsCode": "6202.40.40.21",
      "superior": null,
      "indent": "7",
      "description": "Girls' (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.4500",
      "rawHtsCode": "6202.40.45.00",
      "superior": null,
      "indent": "7",
      "description": "Water resistant (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.50",
      "rawHtsCode": "6202.40.50",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [],
      "generalRate": "27.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.5011",
      "rawHtsCode": "6202.40.50.11",
      "superior": null,
      "indent": "8",
      "description": "Women's (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.5021",
      "rawHtsCode": "6202.40.50.21",
      "superior": null,
      "indent": "8",
      "description": "Girls' (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.5500",
      "rawHtsCode": "6202.40.55.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down (654)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.60",
      "rawHtsCode": "6202.40.60",
      "superior": null,
      "indent": "5",
      "description": "Padded, sleeveless jackets",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.6010",
      "rawHtsCode": "6202.40.60.10",
      "superior": null,
      "indent": "6",
      "description": "With attachments for sleeves (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.6020",
      "rawHtsCode": "6202.40.60.20",
      "superior": null,
      "indent": "6",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.65",
      "rawHtsCode": "6202.40.65",
      "superior": null,
      "indent": "6",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "43.4¢/kg + 19.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "46.3¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.6511",
      "rawHtsCode": "6202.40.65.11",
      "superior": null,
      "indent": "7",
      "description": "Women's (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.6521",
      "rawHtsCode": "6202.40.65.21",
      "superior": null,
      "indent": "7",
      "description": "Girls' (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.7000",
      "rawHtsCode": "6202.40.70.00",
      "superior": null,
      "indent": "7",
      "description": "Water resistant (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.75",
      "rawHtsCode": "6202.40.75",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [],
      "generalRate": "27.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.40.7511",
      "rawHtsCode": "6202.40.75.11",
      "superior": null,
      "indent": "8",
      "description": "Women's (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.40.7521",
      "rawHtsCode": "6202.40.75.21",
      "superior": null,
      "indent": "8",
      "description": "Girls'  (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90",
      "rawHtsCode": "6202.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90.1900",
      "rawHtsCode": "6202.90.19.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6202.90.29",
      "rawHtsCode": "6202.90.29",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.90.2910",
      "rawHtsCode": "6202.90.29.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90.2920",
      "rawHtsCode": "6202.90.29.20",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90.2930",
      "rawHtsCode": "6202.90.29.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90.2960",
      "rawHtsCode": "6202.90.29.60",
      "superior": null,
      "indent": "4",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90.3900",
      "rawHtsCode": "6202.90.39.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6202.90.49",
      "rawHtsCode": "6202.90.49",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.90.4911",
      "rawHtsCode": "6202.90.49.11",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (335) ",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90.4921",
      "rawHtsCode": "6202.90.49.21",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90.4931",
      "rawHtsCode": "6202.90.49.31",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90.4961",
      "rawHtsCode": "6202.90.49.61",
      "superior": null,
      "indent": "5",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90.5900",
      "rawHtsCode": "6202.90.59.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6202.90.69",
      "rawHtsCode": "6202.90.69",
      "superior": null,
      "indent": "4",
      "description": "Other ",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6202.90.6911",
      "rawHtsCode": "6202.90.69.11",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90.6921",
      "rawHtsCode": "6202.90.69.21",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90.6931",
      "rawHtsCode": "6202.90.69.31",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6202.90.6961",
      "rawHtsCode": "6202.90.69.61",
      "superior": null,
      "indent": "5",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203",
      "rawHtsCode": "6203",
      "superior": null,
      "indent": "0",
      "description": "Men's or boys' suits, ensembles, suit-type jackets, blazers, trousers, bib and brace overalls,   breeches and shorts (other than swimwear):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.11",
      "rawHtsCode": "6203.11",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.11.1500",
      "rawHtsCode": "6203.11.15.00",
      "superior": null,
      "indent": "4",
      "description": "Of worsted wool fabric, made of wool yarn having an average fiber diameter of 18.5 microns or less   (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.11.3000",
      "rawHtsCode": "6203.11.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.11.6000",
      "rawHtsCode": "6203.11.60.00",
      "superior": null,
      "indent": "4",
      "description": "Of worsted wool fabric, made of wool yarn having an average fiber diameter of 18.5 microns or less   (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.11.9000",
      "rawHtsCode": "6203.11.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.12",
      "rawHtsCode": "6203.12",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.12.1000",
      "rawHtsCode": "6203.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.12.20",
      "rawHtsCode": "6203.12.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "27.3%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.12.2010",
      "rawHtsCode": "6203.12.20.10",
      "superior": null,
      "indent": "4",
      "description": "Men's (643)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.12.2020",
      "rawHtsCode": "6203.12.20.20",
      "superior": null,
      "indent": "4",
      "description": "Boys' (643)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.19",
      "rawHtsCode": "6203.19",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.19.10",
      "rawHtsCode": "6203.19.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.19.1010",
      "rawHtsCode": "6203.19.10.10",
      "superior": null,
      "indent": "4",
      "description": "Jackets imported as parts of suits (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.19.1020",
      "rawHtsCode": "6203.19.10.20",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts imported as parts of suits (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.19.1030",
      "rawHtsCode": "6203.19.10.30",
      "superior": null,
      "indent": "4",
      "description": "Waistcoats imported as parts of suits (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.19.2000",
      "rawHtsCode": "6203.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "52.9¢/kg + 21%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.19.3000",
      "rawHtsCode": "6203.19.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other (643)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "77.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.19.5000",
      "rawHtsCode": "6203.19.50.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (743)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.19.90",
      "rawHtsCode": "6203.19.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.19.9010",
      "rawHtsCode": "6203.19.90.10",
      "superior": null,
      "indent": "5",
      "description": "Jackets imported as parts of suits (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.19.9020",
      "rawHtsCode": "6203.19.90.20",
      "superior": null,
      "indent": "5",
      "description": "Trousers, breeches and shorts imported as parts of suits (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.19.9030",
      "rawHtsCode": "6203.19.90.30",
      "superior": null,
      "indent": "5",
      "description": "Waistcoats imported as parts of suits (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.19.9040",
      "rawHtsCode": "6203.19.90.40",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.19.9050",
      "rawHtsCode": "6203.19.90.50",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (643)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.19.9080",
      "rawHtsCode": "6203.19.90.80",
      "superior": null,
      "indent": "4",
      "description": "Other (843)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.22",
      "rawHtsCode": "6203.22",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.22.1000",
      "rawHtsCode": "6203.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Judo, karate and other oriental martial arts uniforms (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.22.30",
      "rawHtsCode": "6203.22.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.22.3010",
      "rawHtsCode": "6203.22.30.10",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6201 (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.22.3015",
      "rawHtsCode": "6203.22.30.15",
      "superior": null,
      "indent": "4",
      "description": "Jackets and blazers described in heading 6203 (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.22.3020",
      "rawHtsCode": "6203.22.30.20",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.22.3030",
      "rawHtsCode": "6203.22.30.30",
      "superior": null,
      "indent": "4",
      "description": "Shorts (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.22.3050",
      "rawHtsCode": "6203.22.30.50",
      "superior": null,
      "indent": "4",
      "description": "Shirts (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.22.3060",
      "rawHtsCode": "6203.22.30.60",
      "superior": null,
      "indent": "4",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.23.00",
      "rawHtsCode": "6203.23.00",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.23.0010",
      "rawHtsCode": "6203.23.00.10",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6201 (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.23.0015",
      "rawHtsCode": "6203.23.00.15",
      "superior": null,
      "indent": "4",
      "description": "Jackets and blazers described in heading 6203 (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.23.0020",
      "rawHtsCode": "6203.23.00.20",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.23.0030",
      "rawHtsCode": "6203.23.00.30",
      "superior": null,
      "indent": "4",
      "description": "Shirts (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.23.0040",
      "rawHtsCode": "6203.23.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.23.0050",
      "rawHtsCode": "6203.23.00.50",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6201(634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.23.0055",
      "rawHtsCode": "6203.23.00.55",
      "superior": null,
      "indent": "4",
      "description": "Jackets and blazers described in heading 6203 (633)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.23.0060",
      "rawHtsCode": "6203.23.00.60",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.23.0070",
      "rawHtsCode": "6203.23.00.70",
      "superior": null,
      "indent": "4",
      "description": "Shorts (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.23.0080",
      "rawHtsCode": "6203.23.00.80",
      "superior": null,
      "indent": "4",
      "description": "Shirts (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.23.0090",
      "rawHtsCode": "6203.23.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29",
      "rawHtsCode": "6203.29",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.10",
      "rawHtsCode": "6203.29.10",
      "superior": null,
      "indent": "4",
      "description": "Suits, suit-type jackets and trousers, the foregoing of worsted wool fabric, made of wool yarn having   an average fiber diameter of 18.5 microns or less",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.29.1010",
      "rawHtsCode": "6203.29.10.10",
      "superior": null,
      "indent": "5",
      "description": "Suits (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.1015",
      "rawHtsCode": "6203.29.10.15",
      "superior": null,
      "indent": "5",
      "description": "Suit-type jackets (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.1020",
      "rawHtsCode": "6203.29.10.20",
      "superior": null,
      "indent": "5",
      "description": "Trousers (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.15",
      "rawHtsCode": "6203.29.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.29.1510",
      "rawHtsCode": "6203.29.15.10",
      "superior": null,
      "indent": "5",
      "description": "Garments described in heading 6201 (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.1515",
      "rawHtsCode": "6203.29.15.15",
      "superior": null,
      "indent": "5",
      "description": "Jackets and blazers described in heading 6203 (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.1520",
      "rawHtsCode": "6203.29.15.20",
      "superior": null,
      "indent": "5",
      "description": "Trousers, breeches and shorts (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.1530",
      "rawHtsCode": "6203.29.15.30",
      "superior": null,
      "indent": "5",
      "description": "Shirts (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.1560",
      "rawHtsCode": "6203.29.15.60",
      "superior": null,
      "indent": "5",
      "description": "Other (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.20",
      "rawHtsCode": "6203.29.20",
      "superior": null,
      "indent": "3",
      "description": "Of artificial fibers",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.29.2010",
      "rawHtsCode": "6203.29.20.10",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6201 (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.2020",
      "rawHtsCode": "6203.29.20.20",
      "superior": null,
      "indent": "4",
      "description": "Jackets and blazers described in heading 6203 (633)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.2030",
      "rawHtsCode": "6203.29.20.30",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.2035",
      "rawHtsCode": "6203.29.20.35",
      "superior": null,
      "indent": "4",
      "description": "Shorts (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.2050",
      "rawHtsCode": "6203.29.20.50",
      "superior": null,
      "indent": "4",
      "description": "Shirts (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.2060",
      "rawHtsCode": "6203.29.20.60",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.30",
      "rawHtsCode": "6203.29.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "The rate applicable to each garment in the in the ensemble if separately entered",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.29.3010",
      "rawHtsCode": "6203.29.30.10",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste (734)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.3020",
      "rawHtsCode": "6203.29.30.20",
      "superior": null,
      "indent": "5",
      "description": "Other (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.3026",
      "rawHtsCode": "6203.29.30.26",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste (733)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.3028",
      "rawHtsCode": "6203.29.30.28",
      "superior": null,
      "indent": "5",
      "description": "Other (833)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.3030",
      "rawHtsCode": "6203.29.30.30",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste (747)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.3046",
      "rawHtsCode": "6203.29.30.46",
      "superior": null,
      "indent": "6",
      "description": "Trousers and breeches (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.3048",
      "rawHtsCode": "6203.29.30.48",
      "superior": null,
      "indent": "6",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.3050",
      "rawHtsCode": "6203.29.30.50",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste (740)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.3060",
      "rawHtsCode": "6203.29.30.60",
      "superior": null,
      "indent": "5",
      "description": "Other (840)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.3070",
      "rawHtsCode": "6203.29.30.70",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.29.3080",
      "rawHtsCode": "6203.29.30.80",
      "superior": null,
      "indent": "5",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.31",
      "rawHtsCode": "6203.31",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.31.50",
      "rawHtsCode": "6203.31.50",
      "superior": null,
      "indent": "3",
      "description": "Of worsted wool fabric, made of wool yarn having an average fiber diameter of <il>18.5 microns</il> or less",
      "units": [],
      "generalRate": "17.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "59.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.31.5010",
      "rawHtsCode": "6203.31.50.10",
      "superior": null,
      "indent": "4",
      "description": "For suits described in Note 3(a) (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.31.5020",
      "rawHtsCode": "6203.31.50.20",
      "superior": null,
      "indent": "4",
      "description": "Other (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.31.90",
      "rawHtsCode": "6203.31.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "17.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "59.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.31.9010",
      "rawHtsCode": "6203.31.90.10",
      "superior": null,
      "indent": "4",
      "description": "For suits described in Note 3(a) (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.31.9020",
      "rawHtsCode": "6203.31.90.20",
      "superior": null,
      "indent": "4",
      "description": "Other (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.32",
      "rawHtsCode": "6203.32",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.32.1000",
      "rawHtsCode": "6203.32.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of flax fibers (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.32.20",
      "rawHtsCode": "6203.32.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "9.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.32.2010",
      "rawHtsCode": "6203.32.20.10",
      "superior": null,
      "indent": "5",
      "description": "Men's (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.32.2020",
      "rawHtsCode": "6203.32.20.20",
      "superior": null,
      "indent": "5",
      "description": "Boys' (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.32.2030",
      "rawHtsCode": "6203.32.20.30",
      "superior": null,
      "indent": "4",
      "description": "Blue denim (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.32.2040",
      "rawHtsCode": "6203.32.20.40",
      "superior": null,
      "indent": "5",
      "description": "Men's (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.32.2050",
      "rawHtsCode": "6203.32.20.50",
      "superior": null,
      "indent": "5",
      "description": "Boys' (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.33",
      "rawHtsCode": "6203.33",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.33.10",
      "rawHtsCode": "6203.33.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "22%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "59.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.33.1030",
      "rawHtsCode": "6203.33.10.30",
      "superior": null,
      "indent": "5",
      "description": "For suits described in Note 3(a) (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.33.1040",
      "rawHtsCode": "6203.33.10.40",
      "superior": null,
      "indent": "5",
      "description": "Other (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.33.1050",
      "rawHtsCode": "6203.33.10.50",
      "superior": null,
      "indent": "5",
      "description": "For suits described in Note 3(a) (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.33.1060",
      "rawHtsCode": "6203.33.10.60",
      "superior": null,
      "indent": "5",
      "description": "Other (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.33.20",
      "rawHtsCode": "6203.33.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "27.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.33.2010",
      "rawHtsCode": "6203.33.20.10",
      "superior": null,
      "indent": "4",
      "description": "Men's (633)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.33.2020",
      "rawHtsCode": "6203.33.20.20",
      "superior": null,
      "indent": "4",
      "description": "Boys' (633)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.39",
      "rawHtsCode": "6203.39",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.39.10",
      "rawHtsCode": "6203.39.10",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "22%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "59.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.39.1010",
      "rawHtsCode": "6203.39.10.10",
      "superior": null,
      "indent": "5",
      "description": "For suits described in Note 3(a) (443)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.39.1020",
      "rawHtsCode": "6203.39.10.20",
      "superior": null,
      "indent": "5",
      "description": "Other (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.39.20",
      "rawHtsCode": "6203.39.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "27.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.39.2010",
      "rawHtsCode": "6203.39.20.10",
      "superior": null,
      "indent": "5",
      "description": "Men's (633)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.39.2020",
      "rawHtsCode": "6203.39.20.20",
      "superior": null,
      "indent": "5",
      "description": "Boys' (633)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.39.5000",
      "rawHtsCode": "6203.39.50.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (733)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.39.90",
      "rawHtsCode": "6203.39.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.39.9010",
      "rawHtsCode": "6203.39.90.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (333)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.39.9020",
      "rawHtsCode": "6203.39.90.20",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (433)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.39.9030",
      "rawHtsCode": "6203.39.90.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (633)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.39.9060",
      "rawHtsCode": "6203.39.90.60",
      "superior": null,
      "indent": "4",
      "description": "Other (833)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41",
      "rawHtsCode": "6203.41",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.01",
      "rawHtsCode": "6203.41.01",
      "superior": null,
      "indent": "5",
      "description": "Trousers and breeches, containing elastomeric fiber, water resistant, without belt loops, weighing more than 9 kg per dozen",
      "units": [],
      "generalRate": "7.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.41.0110",
      "rawHtsCode": "6203.41.01.10",
      "superior": null,
      "indent": "6",
      "description": "Men's (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.0120",
      "rawHtsCode": "6203.41.01.20",
      "superior": null,
      "indent": "6",
      "description": "Boys' (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.03",
      "rawHtsCode": "6203.41.03",
      "superior": null,
      "indent": "6",
      "description": "Trousers of worsted wool fabric, made of wool yarn having an average fiber diameter of 18.5 microns or less",
      "units": [],
      "generalRate": "41.9¢/kg + 16.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.41.0310",
      "rawHtsCode": "6203.41.03.10",
      "superior": null,
      "indent": "7",
      "description": "Men's (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.0320",
      "rawHtsCode": "6203.41.03.20",
      "superior": null,
      "indent": "7",
      "description": "Boys' (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.06",
      "rawHtsCode": "6203.41.06",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "41.9¢/kg + 16.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.41.0610",
      "rawHtsCode": "6203.41.06.10",
      "superior": null,
      "indent": "8",
      "description": "Men's (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.0620",
      "rawHtsCode": "6203.41.06.20",
      "superior": null,
      "indent": "8",
      "description": "Boys' (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.0630",
      "rawHtsCode": "6203.41.06.30",
      "superior": null,
      "indent": "7",
      "description": "Shorts (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.0800",
      "rawHtsCode": "6203.41.08.00",
      "superior": null,
      "indent": "4",
      "description": "Bib and brace overalls (459) ",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "63%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.41.25",
      "rawHtsCode": "6203.41.25",
      "superior": null,
      "indent": "5",
      "description": "Trousers and breeches, containing elastomeric fiber, water resistant, without belt loops, weighing more than 9 kg per dozen",
      "units": [],
      "generalRate": "7.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.41.2510",
      "rawHtsCode": "6203.41.25.10",
      "superior": null,
      "indent": "6",
      "description": "Men's (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.2520",
      "rawHtsCode": "6203.41.25.20",
      "superior": null,
      "indent": "6",
      "description": "Boys' (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.30",
      "rawHtsCode": "6203.41.30",
      "superior": null,
      "indent": "6",
      "description": "Trousers of worsted wool fabric, made of wool yarn having an average fiber diameter of 18.5 microns or less",
      "units": [],
      "generalRate": "41.9¢/kg + 16.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.41.3010",
      "rawHtsCode": "6203.41.30.10",
      "superior": null,
      "indent": "7",
      "description": "Men's (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.3020",
      "rawHtsCode": "6203.41.30.20",
      "superior": null,
      "indent": "7",
      "description": "Boys' (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.60",
      "rawHtsCode": "6203.41.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "41.9¢/kg + 16.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.41.6010",
      "rawHtsCode": "6203.41.60.10",
      "superior": null,
      "indent": "8",
      "description": "Men's (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.6020",
      "rawHtsCode": "6203.41.60.20",
      "superior": null,
      "indent": "8",
      "description": "Boys'  (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.6030",
      "rawHtsCode": "6203.41.60.30",
      "superior": null,
      "indent": "7",
      "description": "Shorts (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.41.8000",
      "rawHtsCode": "6203.41.80.00",
      "superior": null,
      "indent": "4",
      "description": "Bib and brace overalls (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "63%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.42",
      "rawHtsCode": "6203.42",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0300",
      "rawHtsCode": "6203.42.03.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6203.42.05",
      "rawHtsCode": "6203.42.05",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls",
      "units": [],
      "generalRate": "10.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.42.0505",
      "rawHtsCode": "6203.42.05.05",
      "superior": null,
      "indent": "6",
      "description": "Insulated for cold weather protection (359)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0510",
      "rawHtsCode": "6203.42.05.10",
      "superior": null,
      "indent": "7",
      "description": "Men's (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0525",
      "rawHtsCode": "6203.42.05.25",
      "superior": null,
      "indent": "8",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0550",
      "rawHtsCode": "6203.42.05.50",
      "superior": null,
      "indent": "8",
      "description": "Other (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0590",
      "rawHtsCode": "6203.42.05.90",
      "superior": null,
      "indent": "7",
      "description": "Other (359)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.07",
      "rawHtsCode": "6203.42.07",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "16.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.42.0703",
      "rawHtsCode": "6203.42.07.03",
      "superior": null,
      "indent": "6",
      "description": "Containing compact yarns described in statistical reporting numbers 5205.42.0021, 5205.43.0021 5205.44.0021, 5205.46.0021 or 5205.47.0021 (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0706",
      "rawHtsCode": "6203.42.07.06",
      "superior": null,
      "indent": "8",
      "description": "Corduroy (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0711",
      "rawHtsCode": "6203.42.07.11",
      "superior": null,
      "indent": "8",
      "description": "Blue denim (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0716",
      "rawHtsCode": "6203.42.07.16",
      "superior": null,
      "indent": "8",
      "description": "Other (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0721",
      "rawHtsCode": "6203.42.07.21",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0726",
      "rawHtsCode": "6203.42.07.26",
      "superior": null,
      "indent": "9",
      "description": "Other (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0731",
      "rawHtsCode": "6203.42.07.31",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0736",
      "rawHtsCode": "6203.42.07.36",
      "superior": null,
      "indent": "9",
      "description": "Other (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0741",
      "rawHtsCode": "6203.42.07.41",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0746",
      "rawHtsCode": "6203.42.07.46",
      "superior": null,
      "indent": "9",
      "description": "Other (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0751",
      "rawHtsCode": "6203.42.07.51",
      "superior": null,
      "indent": "7",
      "description": "Men's shorts (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0756",
      "rawHtsCode": "6203.42.07.56",
      "superior": null,
      "indent": "8",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.0761",
      "rawHtsCode": "6203.42.07.61",
      "superior": null,
      "indent": "8",
      "description": "Other (347) ",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.1700",
      "rawHtsCode": "6203.42.17.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6203.42.25",
      "rawHtsCode": "6203.42.25",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls",
      "units": [],
      "generalRate": "10.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.42.2505",
      "rawHtsCode": "6203.42.25.05",
      "superior": null,
      "indent": "6",
      "description": "Insulated, for cold weather protection (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.2510",
      "rawHtsCode": "6203.42.25.10",
      "superior": null,
      "indent": "7",
      "description": "Men's (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.2525",
      "rawHtsCode": "6203.42.25.25",
      "superior": null,
      "indent": "8",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.2550",
      "rawHtsCode": "6203.42.25.50",
      "superior": null,
      "indent": "8",
      "description": "Other (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.2590",
      "rawHtsCode": "6203.42.25.90",
      "superior": null,
      "indent": "7",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.45",
      "rawHtsCode": "6203.42.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "16.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.42.4503",
      "rawHtsCode": "6203.42.45.03",
      "superior": null,
      "indent": "6",
      "description": "Containing compact yarns described in statistical reporting numbers 5205.42.0021, 5205.43.0021 5205.44.0021, 5205.46.0021 or 5205.47.0021 (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4506",
      "rawHtsCode": "6203.42.45.06",
      "superior": null,
      "indent": "8",
      "description": "Corduroy (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4511",
      "rawHtsCode": "6203.42.45.11",
      "superior": null,
      "indent": "8",
      "description": "Blue denim (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4514",
      "rawHtsCode": "6203.42.45.14",
      "superior": null,
      "indent": "8",
      "description": "Designed for use in hospitals, clinics, laboratories or contaminated areas (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4518",
      "rawHtsCode": "6203.42.45.18",
      "superior": null,
      "indent": "8",
      "description": "Other (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4521",
      "rawHtsCode": "6203.42.45.21",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4526",
      "rawHtsCode": "6203.42.45.26",
      "superior": null,
      "indent": "9",
      "description": "Other (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4531",
      "rawHtsCode": "6203.42.45.31",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4536",
      "rawHtsCode": "6203.42.45.36",
      "superior": null,
      "indent": "9",
      "description": "Other (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4541",
      "rawHtsCode": "6203.42.45.41",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4546",
      "rawHtsCode": "6203.42.45.46",
      "superior": null,
      "indent": "9",
      "description": "Other (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4551",
      "rawHtsCode": "6203.42.45.51",
      "superior": null,
      "indent": "7",
      "description": "Men's shorts (347)",
      "units": [
        "doz. ",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4556",
      "rawHtsCode": "6203.42.45.56",
      "superior": null,
      "indent": "8",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.42.4561",
      "rawHtsCode": "6203.42.45.61",
      "superior": null,
      "indent": "8",
      "description": "Other (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43",
      "rawHtsCode": "6203.43",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.0100",
      "rawHtsCode": "6203.43.01.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.0300",
      "rawHtsCode": "6203.43.03.00",
      "superior": null,
      "indent": "6",
      "description": "Water resistant (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.43.05",
      "rawHtsCode": "6203.43.05",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.43.0505",
      "rawHtsCode": "6203.43.05.05",
      "superior": null,
      "indent": "7",
      "description": "Insulated, for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.0510",
      "rawHtsCode": "6203.43.05.10",
      "superior": null,
      "indent": "8",
      "description": "Men's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.0525",
      "rawHtsCode": "6203.43.05.25",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.0550",
      "rawHtsCode": "6203.43.05.50",
      "superior": null,
      "indent": "9",
      "description": "Other (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.0590",
      "rawHtsCode": "6203.43.05.90",
      "superior": null,
      "indent": "8",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.09",
      "rawHtsCode": "6203.43.09",
      "superior": null,
      "indent": "6",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "49.6¢/kg + 19.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.43.0910",
      "rawHtsCode": "6203.43.09.10",
      "superior": null,
      "indent": "8",
      "description": "Men's (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.0920",
      "rawHtsCode": "6203.43.09.20",
      "superior": null,
      "indent": "8",
      "description": "Boys' (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.0930",
      "rawHtsCode": "6203.43.09.30",
      "superior": null,
      "indent": "7",
      "description": "Shorts (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.11",
      "rawHtsCode": "6203.43.11",
      "superior": null,
      "indent": "7",
      "description": "Water resistant trousers or breeches (647) ",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.43.1110",
      "rawHtsCode": "6203.43.11.10",
      "superior": null,
      "indent": "8",
      "description": "Ski/snowboard pants (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.1190",
      "rawHtsCode": "6203.43.11.90",
      "superior": null,
      "indent": "8",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.13",
      "rawHtsCode": "6203.43.13",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [],
      "generalRate": "27.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.43.1310",
      "rawHtsCode": "6203.43.13.10",
      "superior": null,
      "indent": "9",
      "description": "Men's (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.1315",
      "rawHtsCode": "6203.43.13.15",
      "superior": null,
      "indent": "10",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.1320",
      "rawHtsCode": "6203.43.13.20",
      "superior": null,
      "indent": "10",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.1330",
      "rawHtsCode": "6203.43.13.30",
      "superior": null,
      "indent": "9",
      "description": "Men's (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.1335",
      "rawHtsCode": "6203.43.13.35",
      "superior": null,
      "indent": "10",
      "description": "Imported as parts of playsuits (257)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.1340",
      "rawHtsCode": "6203.43.13.40",
      "superior": null,
      "indent": "10",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.4500",
      "rawHtsCode": "6203.43.45.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6203.43.5500",
      "rawHtsCode": "6203.43.55.00",
      "superior": null,
      "indent": "6",
      "description": "Water resistant (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.43.60",
      "rawHtsCode": "6203.43.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.43.6005",
      "rawHtsCode": "6203.43.60.05",
      "superior": null,
      "indent": "7",
      "description": "Insulated, for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.6010",
      "rawHtsCode": "6203.43.60.10",
      "superior": null,
      "indent": "8",
      "description": "Men's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.6025",
      "rawHtsCode": "6203.43.60.25",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.6050",
      "rawHtsCode": "6203.43.60.50",
      "superior": null,
      "indent": "9",
      "description": "Other (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.6090",
      "rawHtsCode": "6203.43.60.90",
      "superior": null,
      "indent": "8",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.6500",
      "rawHtsCode": "6203.43.65.00",
      "superior": null,
      "indent": "6",
      "description": "Certified hand-loomed and folklore products (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "12.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.43.70",
      "rawHtsCode": "6203.43.70",
      "superior": null,
      "indent": "7",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "49.6¢/kg + 19.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.43.7010",
      "rawHtsCode": "6203.43.70.10",
      "superior": null,
      "indent": "9",
      "description": "Men's (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.7020",
      "rawHtsCode": "6203.43.70.20",
      "superior": null,
      "indent": "9",
      "description": "Boys' (447) ",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.7030",
      "rawHtsCode": "6203.43.70.30",
      "superior": null,
      "indent": "8",
      "description": "Shorts (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.75",
      "rawHtsCode": "6203.43.75",
      "superior": null,
      "indent": "8",
      "description": "Water resistant trousers or breeches (647)",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.43.7510",
      "rawHtsCode": "6203.43.75.10",
      "superior": null,
      "indent": "9",
      "description": "Ski/snowboard pants (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.7590",
      "rawHtsCode": "6203.43.75.90",
      "superior": null,
      "indent": "9",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.90",
      "rawHtsCode": "6203.43.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [],
      "generalRate": "27.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.43.9009",
      "rawHtsCode": "6203.43.90.09",
      "superior": null,
      "indent": "11",
      "description": "Designed for use in hospitals, clinics, laboratories or contaminated areas (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.9011",
      "rawHtsCode": "6203.43.90.11",
      "superior": null,
      "indent": "11",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.9015",
      "rawHtsCode": "6203.43.90.15",
      "superior": null,
      "indent": "11",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.9020",
      "rawHtsCode": "6203.43.90.20",
      "superior": null,
      "indent": "11",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.9030",
      "rawHtsCode": "6203.43.90.30",
      "superior": null,
      "indent": "10",
      "description": "Men's (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.9035",
      "rawHtsCode": "6203.43.90.35",
      "superior": null,
      "indent": "11",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.43.9040",
      "rawHtsCode": "6203.43.90.40",
      "superior": null,
      "indent": "11",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49",
      "rawHtsCode": "6203.49",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.01",
      "rawHtsCode": "6203.49.01",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.49.0105",
      "rawHtsCode": "6203.49.01.05",
      "superior": null,
      "indent": "6",
      "description": "Insulated, for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0110",
      "rawHtsCode": "6203.49.01.10",
      "superior": null,
      "indent": "7",
      "description": "Men's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0125",
      "rawHtsCode": "6203.49.01.25",
      "superior": null,
      "indent": "8",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0150",
      "rawHtsCode": "6203.49.01.50",
      "superior": null,
      "indent": "8",
      "description": "Other (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0190",
      "rawHtsCode": "6203.49.01.90",
      "superior": null,
      "indent": "7",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.05",
      "rawHtsCode": "6203.49.05",
      "superior": null,
      "indent": "5",
      "description": "Trousers, breeches and shorts",
      "units": [],
      "generalRate": "27.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.49.0505",
      "rawHtsCode": "6203.49.05.05",
      "superior": null,
      "indent": "6",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0515",
      "rawHtsCode": "6203.49.05.15",
      "superior": null,
      "indent": "8",
      "description": "Men's (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0520",
      "rawHtsCode": "6203.49.05.20",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0530",
      "rawHtsCode": "6203.49.05.30",
      "superior": null,
      "indent": "9",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0545",
      "rawHtsCode": "6203.49.05.45",
      "superior": null,
      "indent": "8",
      "description": "Men's (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0550",
      "rawHtsCode": "6203.49.05.50",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0560",
      "rawHtsCode": "6203.49.05.60",
      "superior": null,
      "indent": "9",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.07",
      "rawHtsCode": "6203.49.07",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6203.49.0710",
      "rawHtsCode": "6203.49.07.10",
      "superior": null,
      "indent": "6",
      "description": "Bib and brace overalls (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0720",
      "rawHtsCode": "6203.49.07.20",
      "superior": null,
      "indent": "6",
      "description": "Trousers and breeches (747)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0730",
      "rawHtsCode": "6203.49.07.30",
      "superior": null,
      "indent": "6",
      "description": "Shorts (747)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.09",
      "rawHtsCode": "6203.49.09",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.49.0910",
      "rawHtsCode": "6203.49.09.10",
      "superior": null,
      "indent": "6",
      "description": "Bib and brace overalls (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0920",
      "rawHtsCode": "6203.49.09.20",
      "superior": null,
      "indent": "7",
      "description": "Subject to cotton restraints (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0925",
      "rawHtsCode": "6203.49.09.25",
      "superior": null,
      "indent": "7",
      "description": "Subject to wool restraints (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0930",
      "rawHtsCode": "6203.49.09.30",
      "superior": null,
      "indent": "7",
      "description": "Subject to man-made fiber restraints (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0945",
      "rawHtsCode": "6203.49.09.45",
      "superior": null,
      "indent": "7",
      "description": "Other (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.0960",
      "rawHtsCode": "6203.49.09.60",
      "superior": null,
      "indent": "6",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.25",
      "rawHtsCode": "6203.49.25",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.49.2505",
      "rawHtsCode": "6203.49.25.05",
      "superior": null,
      "indent": "6",
      "description": "Insulated, for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.2510",
      "rawHtsCode": "6203.49.25.10",
      "superior": null,
      "indent": "7",
      "description": "Men's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.2525",
      "rawHtsCode": "6203.49.25.25",
      "superior": null,
      "indent": "8",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.2550",
      "rawHtsCode": "6203.49.25.50",
      "superior": null,
      "indent": "8",
      "description": "Other (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.2590",
      "rawHtsCode": "6203.49.25.90",
      "superior": null,
      "indent": "7",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.3500",
      "rawHtsCode": "6203.49.35.00",
      "superior": null,
      "indent": "6",
      "description": "Certified hand-loomed and folklore products",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "12.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.49.50",
      "rawHtsCode": "6203.49.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "27.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.49.5005",
      "rawHtsCode": "6203.49.50.05",
      "superior": null,
      "indent": "7",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.5015",
      "rawHtsCode": "6203.49.50.15",
      "superior": null,
      "indent": "9",
      "description": "Men's (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.5020",
      "rawHtsCode": "6203.49.50.20",
      "superior": null,
      "indent": "10",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.5030",
      "rawHtsCode": "6203.49.50.30",
      "superior": null,
      "indent": "10",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.5045",
      "rawHtsCode": "6203.49.50.45",
      "superior": null,
      "indent": "9",
      "description": "Men's (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.5050",
      "rawHtsCode": "6203.49.50.50",
      "superior": null,
      "indent": "10",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.5060",
      "rawHtsCode": "6203.49.50.60",
      "superior": null,
      "indent": "10",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.60",
      "rawHtsCode": "6203.49.60",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.6010",
      "rawHtsCode": "6203.49.60.10",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.6020",
      "rawHtsCode": "6203.49.60.20",
      "superior": null,
      "indent": "5",
      "description": "Trousers and breeches (747)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.6030",
      "rawHtsCode": "6203.49.60.30",
      "superior": null,
      "indent": "5",
      "description": "Shorts (747)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.90",
      "rawHtsCode": "6203.49.90",
      "superior": null,
      "indent": "4",
      "description": "Other ",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG) ",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6203.49.9010",
      "rawHtsCode": "6203.49.90.10",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.9020",
      "rawHtsCode": "6203.49.90.20",
      "superior": null,
      "indent": "6",
      "description": "Subject to cotton restraints (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.9025",
      "rawHtsCode": "6203.49.90.25",
      "superior": null,
      "indent": "6",
      "description": "Subject to wool restraints (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.9030",
      "rawHtsCode": "6203.49.90.30",
      "superior": null,
      "indent": "6",
      "description": "Subject to man-made fiber restraints (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.9045",
      "rawHtsCode": "6203.49.90.45",
      "superior": null,
      "indent": "6",
      "description": "Other (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6203.49.9060",
      "rawHtsCode": "6203.49.90.60",
      "superior": null,
      "indent": "5",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204",
      "rawHtsCode": "6204",
      "superior": null,
      "indent": "0",
      "description": "Women's or girls' suits, ensembles, suit-type jackets, blazers, dresses, skirts, divided skirts,   trousers, bib and brace overalls, breeches and shorts (other than swimwear):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.11.0000",
      "rawHtsCode": "6204.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (444)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.12.00",
      "rawHtsCode": "6204.12.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.12.0010",
      "rawHtsCode": "6204.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Jackets imported as parts of suits (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.12.0020",
      "rawHtsCode": "6204.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Skirts and divided skirts imported as parts of suits (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.12.0030",
      "rawHtsCode": "6204.12.00.30",
      "superior": null,
      "indent": "3",
      "description": "Trousers, breeches and shorts imported as parts of suits (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.12.0040",
      "rawHtsCode": "6204.12.00.40",
      "superior": null,
      "indent": "3",
      "description": "Waistcoats imported as parts of suits (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.13",
      "rawHtsCode": "6204.13",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.13.1000",
      "rawHtsCode": "6204.13.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (444)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "17%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.13.20",
      "rawHtsCode": "6204.13.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "35.3¢/kg + 25.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "37.5¢/kg + 76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.13.2010",
      "rawHtsCode": "6204.13.20.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (644)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.13.2020",
      "rawHtsCode": "6204.13.20.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (644)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.19",
      "rawHtsCode": "6204.19",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.19.1000",
      "rawHtsCode": "6204.19.10.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (444)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "17%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.19.2000",
      "rawHtsCode": "6204.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other (644)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "35.3¢/kg + 25.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "37.5¢/kg + 76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.19.4000",
      "rawHtsCode": "6204.19.40.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (744)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.19.80",
      "rawHtsCode": "6204.19.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.19.8010",
      "rawHtsCode": "6204.19.80.10",
      "superior": null,
      "indent": "5",
      "description": "Jackets imported as parts of suits (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.19.8020",
      "rawHtsCode": "6204.19.80.20",
      "superior": null,
      "indent": "5",
      "description": "Skirts and divided skirts imported as parts of suits (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.19.8030",
      "rawHtsCode": "6204.19.80.30",
      "superior": null,
      "indent": "5",
      "description": "Trousers, breeches and shorts imported as parts of suits (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.19.8040",
      "rawHtsCode": "6204.19.80.40",
      "superior": null,
      "indent": "5",
      "description": "Waistcoats imported as parts of suits (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.19.8050",
      "rawHtsCode": "6204.19.80.50",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (444)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.19.8060",
      "rawHtsCode": "6204.19.80.60",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (644)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.19.8090",
      "rawHtsCode": "6204.19.80.90",
      "superior": null,
      "indent": "4",
      "description": "Other (844)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.21.00",
      "rawHtsCode": "6204.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.21.0010",
      "rawHtsCode": "6204.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Garments described in heading 6202; jackets and blazers described in heading 6204 (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.21.0030",
      "rawHtsCode": "6204.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Skirts and divided skirts (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.21.0040",
      "rawHtsCode": "6204.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Trousers, breeches and shorts (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.21.0060",
      "rawHtsCode": "6204.21.00.60",
      "superior": null,
      "indent": "3",
      "description": "Blouses and shirts (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.21.0070",
      "rawHtsCode": "6204.21.00.70",
      "superior": null,
      "indent": "3",
      "description": "Other (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.22",
      "rawHtsCode": "6204.22",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.22.1000",
      "rawHtsCode": "6204.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Judo, karate and other oriental martial arts uniforms (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.22.30",
      "rawHtsCode": "6204.22.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.22.3010",
      "rawHtsCode": "6204.22.30.10",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6202; jackets and blazers described in heading 6204 (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.22.3030",
      "rawHtsCode": "6204.22.30.30",
      "superior": null,
      "indent": "4",
      "description": "Skirts and divided skirts (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.22.3040",
      "rawHtsCode": "6204.22.30.40",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.22.3050",
      "rawHtsCode": "6204.22.30.50",
      "superior": null,
      "indent": "4",
      "description": "Shorts (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.22.3060",
      "rawHtsCode": "6204.22.30.60",
      "superior": null,
      "indent": "5",
      "description": "With two or more colors in the warp and/or filling (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.22.3065",
      "rawHtsCode": "6204.22.30.65",
      "superior": null,
      "indent": "5",
      "description": "Other (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.22.3070",
      "rawHtsCode": "6204.22.30.70",
      "superior": null,
      "indent": "4",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.23.00",
      "rawHtsCode": "6204.23.00",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.23.0005",
      "rawHtsCode": "6204.23.00.05",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6202; jackets and blazers described in heading 6204 (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.23.0010",
      "rawHtsCode": "6204.23.00.10",
      "superior": null,
      "indent": "4",
      "description": "Skirts and divided skirts (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.23.0015",
      "rawHtsCode": "6204.23.00.15",
      "superior": null,
      "indent": "4",
      "description": "Trousers, breeches and shorts (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.23.0020",
      "rawHtsCode": "6204.23.00.20",
      "superior": null,
      "indent": "4",
      "description": "Blouses and shirts (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.23.0025",
      "rawHtsCode": "6204.23.00.25",
      "superior": null,
      "indent": "4",
      "description": "Other (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.23.0030",
      "rawHtsCode": "6204.23.00.30",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6202; jackets and blazers described in heading 6204 (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.23.0035",
      "rawHtsCode": "6204.23.00.35",
      "superior": null,
      "indent": "4",
      "description": "Skirts and divided skirts (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.23.0040",
      "rawHtsCode": "6204.23.00.40",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.23.0045",
      "rawHtsCode": "6204.23.00.45",
      "superior": null,
      "indent": "4",
      "description": "Shorts (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.23.0050",
      "rawHtsCode": "6204.23.00.50",
      "superior": null,
      "indent": "5",
      "description": "With two or more colors in the warp and/or filling (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.23.0055",
      "rawHtsCode": "6204.23.00.55",
      "superior": null,
      "indent": "5",
      "description": "Other (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.23.0060",
      "rawHtsCode": "6204.23.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29",
      "rawHtsCode": "6204.29",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.20",
      "rawHtsCode": "6204.29.20",
      "superior": null,
      "indent": "3",
      "description": "Of artificial fibers",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.29.2010",
      "rawHtsCode": "6204.29.20.10",
      "superior": null,
      "indent": "4",
      "description": "Garments described in heading 6202; jackets and blazers described in heading 6204 (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.2015",
      "rawHtsCode": "6204.29.20.15",
      "superior": null,
      "indent": "4",
      "description": "Skirts and divided skirts.(642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.2020",
      "rawHtsCode": "6204.29.20.20",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.2025",
      "rawHtsCode": "6204.29.20.25",
      "superior": null,
      "indent": "4",
      "description": "Shorts (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.2030",
      "rawHtsCode": "6204.29.20.30",
      "superior": null,
      "indent": "5",
      "description": "With two or more colors in the warp and/or filling (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.2040",
      "rawHtsCode": "6204.29.20.40",
      "superior": null,
      "indent": "5",
      "description": "Other (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.2050",
      "rawHtsCode": "6204.29.20.50",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.40",
      "rawHtsCode": "6204.29.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "The rate applicable to each garment in the ensemble if separately entered",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to each garment in the ensemble if separately entered",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.29.4010",
      "rawHtsCode": "6204.29.40.10",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4012",
      "rawHtsCode": "6204.29.40.12",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4014",
      "rawHtsCode": "6204.29.40.14",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4016",
      "rawHtsCode": "6204.29.40.16",
      "superior": null,
      "indent": "7",
      "description": "Containing 70 percent or more by weight of silk or silk waste (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4018",
      "rawHtsCode": "6204.29.40.18",
      "superior": null,
      "indent": "7",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4020",
      "rawHtsCode": "6204.29.40.20",
      "superior": null,
      "indent": "6",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4022",
      "rawHtsCode": "6204.29.40.22",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4024",
      "rawHtsCode": "6204.29.40.24",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4026",
      "rawHtsCode": "6204.29.40.26",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4028",
      "rawHtsCode": "6204.29.40.28",
      "superior": null,
      "indent": "7",
      "description": "Containing 70 percent or more by weight of silk or silk waste (742)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4030",
      "rawHtsCode": "6204.29.40.30",
      "superior": null,
      "indent": "7",
      "description": "Other (842)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4032",
      "rawHtsCode": "6204.29.40.32",
      "superior": null,
      "indent": "6",
      "description": "Other (842)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4034",
      "rawHtsCode": "6204.29.40.34",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4036",
      "rawHtsCode": "6204.29.40.36",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4038",
      "rawHtsCode": "6204.29.40.38",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4040",
      "rawHtsCode": "6204.29.40.40",
      "superior": null,
      "indent": "7",
      "description": "Containing 70 percent or more by weight of silk or silk waste (748)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4041",
      "rawHtsCode": "6204.29.40.41",
      "superior": null,
      "indent": "8",
      "description": "Trousers and breeches (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4043",
      "rawHtsCode": "6204.29.40.43",
      "superior": null,
      "indent": "8",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4047",
      "rawHtsCode": "6204.29.40.47",
      "superior": null,
      "indent": "7",
      "description": "Trousers and breeches (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4049",
      "rawHtsCode": "6204.29.40.49",
      "superior": null,
      "indent": "7",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4070",
      "rawHtsCode": "6204.29.40.70",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4072",
      "rawHtsCode": "6204.29.40.72",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4074",
      "rawHtsCode": "6204.29.40.74",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4076",
      "rawHtsCode": "6204.29.40.76",
      "superior": null,
      "indent": "7",
      "description": "Containing 70 percent or more by weight of silk or silk waste (741)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4078",
      "rawHtsCode": "6204.29.40.78",
      "superior": null,
      "indent": "7",
      "description": "Other (840)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4080",
      "rawHtsCode": "6204.29.40.80",
      "superior": null,
      "indent": "6",
      "description": "Other (840)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4082",
      "rawHtsCode": "6204.29.40.82",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4084",
      "rawHtsCode": "6204.29.40.84",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4086",
      "rawHtsCode": "6204.29.40.86",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4088",
      "rawHtsCode": "6204.29.40.88",
      "superior": null,
      "indent": "7",
      "description": "Containing 70 percent or more by weight of silk or silk waste (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4090",
      "rawHtsCode": "6204.29.40.90",
      "superior": null,
      "indent": "7",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.29.4092",
      "rawHtsCode": "6204.29.40.92",
      "superior": null,
      "indent": "6",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.31",
      "rawHtsCode": "6204.31",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.31.10",
      "rawHtsCode": "6204.31.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 30 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.31.1010",
      "rawHtsCode": "6204.31.10.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.31.1020",
      "rawHtsCode": "6204.31.10.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.31.20",
      "rawHtsCode": "6204.31.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "17.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "46.3¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.31.2010",
      "rawHtsCode": "6204.31.20.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.31.2020",
      "rawHtsCode": "6204.31.20.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.32",
      "rawHtsCode": "6204.32",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.32.1000",
      "rawHtsCode": "6204.32.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of flax fibers (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.32.20",
      "rawHtsCode": "6204.32.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "9.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.32.2010",
      "rawHtsCode": "6204.32.20.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.32.2020",
      "rawHtsCode": "6204.32.20.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.32.2030",
      "rawHtsCode": "6204.32.20.30",
      "superior": null,
      "indent": "5",
      "description": "Women's (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.32.2040",
      "rawHtsCode": "6204.32.20.40",
      "superior": null,
      "indent": "5",
      "description": "Girls' (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.33",
      "rawHtsCode": "6204.33",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.33.1000",
      "rawHtsCode": "6204.33.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 30 percent or more by weight of silk or silk waste (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.33.2000",
      "rawHtsCode": "6204.33.20.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of flax fibers (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.33.40",
      "rawHtsCode": "6204.33.40",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "46.3¢/kg + 21%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "46.3¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.33.4010",
      "rawHtsCode": "6204.33.40.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.33.4020",
      "rawHtsCode": "6204.33.40.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.33.50",
      "rawHtsCode": "6204.33.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "27.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.33.5010",
      "rawHtsCode": "6204.33.50.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.33.5020",
      "rawHtsCode": "6204.33.50.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.39",
      "rawHtsCode": "6204.39",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.39.20",
      "rawHtsCode": "6204.39.20",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "37.1¢/kg + 16.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "46.3¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.39.2010",
      "rawHtsCode": "6204.39.20.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.39.2020",
      "rawHtsCode": "6204.39.20.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.39.30",
      "rawHtsCode": "6204.39.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "27.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.39.3010",
      "rawHtsCode": "6204.39.30.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.39.3020",
      "rawHtsCode": "6204.39.30.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.39.6000",
      "rawHtsCode": "6204.39.60.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.39.80",
      "rawHtsCode": "6204.39.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,BH,CL, CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.39.8010",
      "rawHtsCode": "6204.39.80.10",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.39.8020",
      "rawHtsCode": "6204.39.80.20",
      "superior": null,
      "indent": "5",
      "description": "Subject to wool restraints (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.39.8030",
      "rawHtsCode": "6204.39.80.30",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.39.8050",
      "rawHtsCode": "6204.39.80.50",
      "superior": null,
      "indent": "6",
      "description": "Of silk (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.39.8060",
      "rawHtsCode": "6204.39.80.60",
      "superior": null,
      "indent": "6",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.41",
      "rawHtsCode": "6204.41",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.41.1000",
      "rawHtsCode": "6204.41.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 30 percent or more by weight of silk or silk waste (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.41.20",
      "rawHtsCode": "6204.41.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.41.2010",
      "rawHtsCode": "6204.41.20.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.41.2020",
      "rawHtsCode": "6204.41.20.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.42",
      "rawHtsCode": "6204.42",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.42.1000",
      "rawHtsCode": "6204.42.10.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed and folklore products (336)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "11.8%",
      "specialRate": "Free (AU,BH,CL, CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.42.2000",
      "rawHtsCode": "6204.42.20.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of flax fibers (336)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.42.30",
      "rawHtsCode": "6204.42.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.42.3010",
      "rawHtsCode": "6204.42.30.10",
      "superior": null,
      "indent": "6",
      "description": "Women's (336)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.42.3020",
      "rawHtsCode": "6204.42.30.20",
      "superior": null,
      "indent": "6",
      "description": "Girls' (336)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.42.3030",
      "rawHtsCode": "6204.42.30.30",
      "superior": null,
      "indent": "7",
      "description": "Women's (336)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.42.3040",
      "rawHtsCode": "6204.42.30.40",
      "superior": null,
      "indent": "7",
      "description": "Girls' (336)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.42.3050",
      "rawHtsCode": "6204.42.30.50",
      "superior": null,
      "indent": "7",
      "description": "Women's (336)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.42.3060",
      "rawHtsCode": "6204.42.30.60",
      "superior": null,
      "indent": "7",
      "description": "Girls' (336)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.43",
      "rawHtsCode": "6204.43",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.43.1000",
      "rawHtsCode": "6204.43.10.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed and folklore products (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.43.2000",
      "rawHtsCode": "6204.43.20.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 30 percent or more by weight of silk or silk waste (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.43.30",
      "rawHtsCode": "6204.43.30",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.43.3010",
      "rawHtsCode": "6204.43.30.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.43.3020",
      "rawHtsCode": "6204.43.30.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.43.40",
      "rawHtsCode": "6204.43.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.43.4010",
      "rawHtsCode": "6204.43.40.10",
      "superior": null,
      "indent": "6",
      "description": "Women's (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.43.4020",
      "rawHtsCode": "6204.43.40.20",
      "superior": null,
      "indent": "6",
      "description": "Girls' (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.43.4030",
      "rawHtsCode": "6204.43.40.30",
      "superior": null,
      "indent": "6",
      "description": "Women's (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.43.4040",
      "rawHtsCode": "6204.43.40.40",
      "superior": null,
      "indent": "6",
      "description": "Girls' (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.44",
      "rawHtsCode": "6204.44",
      "superior": null,
      "indent": "2",
      "description": "Of artificial fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.44.2000",
      "rawHtsCode": "6204.44.20.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed and folklore products (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.44.30",
      "rawHtsCode": "6204.44.30",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.44.3010",
      "rawHtsCode": "6204.44.30.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.44.3020",
      "rawHtsCode": "6204.44.30.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.44.40",
      "rawHtsCode": "6204.44.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.44.4010",
      "rawHtsCode": "6204.44.40.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.44.4020",
      "rawHtsCode": "6204.44.40.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.49",
      "rawHtsCode": "6204.49",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.49.1000",
      "rawHtsCode": "6204.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (736)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "6.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.49.50",
      "rawHtsCode": "6204.49.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.9%",
      "specialRate": "Free (AU,BH,CL, CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.49.5010",
      "rawHtsCode": "6204.49.50.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (336)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.49.5020",
      "rawHtsCode": "6204.49.50.20",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (436)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.49.5030",
      "rawHtsCode": "6204.49.50.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (636)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.49.5050",
      "rawHtsCode": "6204.49.50.50",
      "superior": null,
      "indent": "5",
      "description": "Of silk (836)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.49.5060",
      "rawHtsCode": "6204.49.50.60",
      "superior": null,
      "indent": "5",
      "description": "Other (836)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.51.00",
      "rawHtsCode": "6204.51.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.51.0010",
      "rawHtsCode": "6204.51.00.10",
      "superior": null,
      "indent": "3",
      "description": "Women's (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.51.0020",
      "rawHtsCode": "6204.51.00.20",
      "superior": null,
      "indent": "3",
      "description": "Girls' (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.52",
      "rawHtsCode": "6204.52",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.52.1000",
      "rawHtsCode": "6204.52.10.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed and folklore products (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH,CL, CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.52.20",
      "rawHtsCode": "6204.52.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.52.2010",
      "rawHtsCode": "6204.52.20.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.52.2020",
      "rawHtsCode": "6204.52.20.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.52.2030",
      "rawHtsCode": "6204.52.20.30",
      "superior": null,
      "indent": "5",
      "description": "Women's (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.52.2040",
      "rawHtsCode": "6204.52.20.40",
      "superior": null,
      "indent": "5",
      "description": "Girls' (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.52.2070",
      "rawHtsCode": "6204.52.20.70",
      "superior": null,
      "indent": "5",
      "description": "Women's (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.52.2080",
      "rawHtsCode": "6204.52.20.80",
      "superior": null,
      "indent": "5",
      "description": "Girls' (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.53",
      "rawHtsCode": "6204.53",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.53.1000",
      "rawHtsCode": "6204.53.10.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed products and folklore products (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.53.20",
      "rawHtsCode": "6204.53.20",
      "superior": null,
      "indent": "4",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.53.2010",
      "rawHtsCode": "6204.53.20.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.53.2020",
      "rawHtsCode": "6204.53.20.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.53.30",
      "rawHtsCode": "6204.53.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.53.3010",
      "rawHtsCode": "6204.53.30.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.53.3020",
      "rawHtsCode": "6204.53.30.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.59",
      "rawHtsCode": "6204.59",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.59.1000",
      "rawHtsCode": "6204.59.10.00",
      "superior": null,
      "indent": "4",
      "description": "Certified hand-loomed and folklore products (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.59.20",
      "rawHtsCode": "6204.59.20",
      "superior": null,
      "indent": "5",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.59.2010",
      "rawHtsCode": "6204.59.20.10",
      "superior": null,
      "indent": "6",
      "description": "Women's (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.59.2020",
      "rawHtsCode": "6204.59.20.20",
      "superior": null,
      "indent": "6",
      "description": "Girls' (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.59.30",
      "rawHtsCode": "6204.59.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.59.3010",
      "rawHtsCode": "6204.59.30.10",
      "superior": null,
      "indent": "6",
      "description": "Women's (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.59.3020",
      "rawHtsCode": "6204.59.30.20",
      "superior": null,
      "indent": "6",
      "description": "Girls' (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.59.40",
      "rawHtsCode": "6204.59.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA, OM,P,PA, PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.59.4010",
      "rawHtsCode": "6204.59.40.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (342)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.59.4020",
      "rawHtsCode": "6204.59.40.20",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (442)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.59.4030",
      "rawHtsCode": "6204.59.40.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (642)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.59.4040",
      "rawHtsCode": "6204.59.40.40",
      "superior": null,
      "indent": "6",
      "description": "Containing 70 percent or more by weight of silk or silk waste (742)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.59.4050",
      "rawHtsCode": "6204.59.40.50",
      "superior": null,
      "indent": "6",
      "description": "Other (842)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.59.4060",
      "rawHtsCode": "6204.59.40.60",
      "superior": null,
      "indent": "5",
      "description": "Other (842)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61",
      "rawHtsCode": "6204.61",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61.05",
      "rawHtsCode": "6204.61.05",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches, containing elastomeric fiber, water resistant, without belt loops, weighing more than 6 kg per dozen",
      "units": [],
      "generalRate": "7.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.61.0510",
      "rawHtsCode": "6204.61.05.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61.0520",
      "rawHtsCode": "6204.61.05.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61.15",
      "rawHtsCode": "6204.61.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.61.1510",
      "rawHtsCode": "6204.61.15.10",
      "superior": null,
      "indent": "6",
      "description": "Women's (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61.1520",
      "rawHtsCode": "6204.61.15.20",
      "superior": null,
      "indent": "6",
      "description": "Girls' (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61.1530",
      "rawHtsCode": "6204.61.15.30",
      "superior": null,
      "indent": "5",
      "description": "Shorts (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61.1540",
      "rawHtsCode": "6204.61.15.40",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overall (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61.60",
      "rawHtsCode": "6204.61.60",
      "superior": null,
      "indent": "4",
      "description": "Trousers and breeches, containing elastomeric fiber, water resistant, without belt loops, weighing more than 6 kg per dozen",
      "units": [],
      "generalRate": "7.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.61.6010",
      "rawHtsCode": "6204.61.60.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61.6020",
      "rawHtsCode": "6204.61.60.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61.80",
      "rawHtsCode": "6204.61.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.61.8010",
      "rawHtsCode": "6204.61.80.10",
      "superior": null,
      "indent": "6",
      "description": "Women's (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61.8020",
      "rawHtsCode": "6204.61.80.20",
      "superior": null,
      "indent": "6",
      "description": "Girls' (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61.8030",
      "rawHtsCode": "6204.61.80.30",
      "superior": null,
      "indent": "5",
      "description": "Shorts (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.61.8040",
      "rawHtsCode": "6204.61.80.40",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62",
      "rawHtsCode": "6204.62",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.0300",
      "rawHtsCode": "6204.62.03.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6204.62.05",
      "rawHtsCode": "6204.62.05",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls",
      "units": [],
      "generalRate": "8.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.62.0505",
      "rawHtsCode": "6204.62.05.05",
      "superior": null,
      "indent": "6",
      "description": "Insulated, for cold weather protection (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.0510",
      "rawHtsCode": "6204.62.05.10",
      "superior": null,
      "indent": "7",
      "description": "Women's (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.0525",
      "rawHtsCode": "6204.62.05.25",
      "superior": null,
      "indent": "8",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.0550",
      "rawHtsCode": "6204.62.05.50",
      "superior": null,
      "indent": "8",
      "description": "Other (237) ",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.15",
      "rawHtsCode": "6204.62.15",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "16.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.62.1503",
      "rawHtsCode": "6204.62.15.03",
      "superior": null,
      "indent": "6",
      "description": "Containing compact yarns described in statistical reporting numbers 5205.42.0021, 5205.43.0021, 5205.44.0021, 5205.46.0021 or 5205.47.0021 (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.1506",
      "rawHtsCode": "6204.62.15.06",
      "superior": null,
      "indent": "8",
      "description": "Corduroy (348) ",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.1511",
      "rawHtsCode": "6204.62.15.11",
      "superior": null,
      "indent": "8",
      "description": "Blue denim (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.1521",
      "rawHtsCode": "6204.62.15.21",
      "superior": null,
      "indent": "8",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.1526",
      "rawHtsCode": "6204.62.15.26",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.1531",
      "rawHtsCode": "6204.62.15.31",
      "superior": null,
      "indent": "9",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.1536",
      "rawHtsCode": "6204.62.15.36",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.1541",
      "rawHtsCode": "6204.62.15.41",
      "superior": null,
      "indent": "9",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.1546",
      "rawHtsCode": "6204.62.15.46",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.1551",
      "rawHtsCode": "6204.62.15.51",
      "superior": null,
      "indent": "9",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.1556",
      "rawHtsCode": "6204.62.15.56",
      "superior": null,
      "indent": "7",
      "description": "Women's shorts (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.1561",
      "rawHtsCode": "6204.62.15.61",
      "superior": null,
      "indent": "8",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.1566",
      "rawHtsCode": "6204.62.15.66",
      "superior": null,
      "indent": "8",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.5000",
      "rawHtsCode": "6204.62.50.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6204.62.60",
      "rawHtsCode": "6204.62.60",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls",
      "units": [],
      "generalRate": "8.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.62.6005",
      "rawHtsCode": "6204.62.60.05",
      "superior": null,
      "indent": "6",
      "description": "Insulated, for cold weather protection (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.6010",
      "rawHtsCode": "6204.62.60.10",
      "superior": null,
      "indent": "7",
      "description": "Women's (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.6025",
      "rawHtsCode": "6204.62.60.25",
      "superior": null,
      "indent": "8",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.6050",
      "rawHtsCode": "6204.62.60.50",
      "superior": null,
      "indent": "8",
      "description": "Other (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.7000",
      "rawHtsCode": "6204.62.70.00",
      "superior": null,
      "indent": "6",
      "description": "Certified hand-loomed and folklore products (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.62.80",
      "rawHtsCode": "6204.62.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "16.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.62.8003",
      "rawHtsCode": "6204.62.80.03",
      "superior": null,
      "indent": "7",
      "description": "Containing compact yarns described in statistical reporting numbers 5205.42.0021, 5205.43.0021, 5205.44.0021, 5205.46.0021 or 5205.47.0021 (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8006",
      "rawHtsCode": "6204.62.80.06",
      "superior": null,
      "indent": "9",
      "description": "Corduroy (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8011",
      "rawHtsCode": "6204.62.80.11",
      "superior": null,
      "indent": "9",
      "description": "Blue denim (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8014",
      "rawHtsCode": "6204.62.80.14",
      "superior": null,
      "indent": "9",
      "description": "Designed for use in hospitals, clinics, laboratories or contaminated areas (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8018",
      "rawHtsCode": "6204.62.80.18",
      "superior": null,
      "indent": "9",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8026",
      "rawHtsCode": "6204.62.80.26",
      "superior": null,
      "indent": "10",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8031",
      "rawHtsCode": "6204.62.80.31",
      "superior": null,
      "indent": "10",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8036",
      "rawHtsCode": "6204.62.80.36",
      "superior": null,
      "indent": "10",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8041",
      "rawHtsCode": "6204.62.80.41",
      "superior": null,
      "indent": "10",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8046",
      "rawHtsCode": "6204.62.80.46",
      "superior": null,
      "indent": "10",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8051",
      "rawHtsCode": "6204.62.80.51",
      "superior": null,
      "indent": "10",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8056",
      "rawHtsCode": "6204.62.80.56",
      "superior": null,
      "indent": "8",
      "description": "Women's shorts (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8061",
      "rawHtsCode": "6204.62.80.61",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.62.8066",
      "rawHtsCode": "6204.62.80.66",
      "superior": null,
      "indent": "9",
      "description": "Other (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63",
      "rawHtsCode": "6204.63",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.0100",
      "rawHtsCode": "6204.63.01.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6204.63.0200",
      "rawHtsCode": "6204.63.02.00",
      "superior": null,
      "indent": "6",
      "description": "Water resistant",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.63.03",
      "rawHtsCode": "6204.63.03",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.63.0305",
      "rawHtsCode": "6204.63.03.05",
      "superior": null,
      "indent": "7",
      "description": "Insulated, for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.0310",
      "rawHtsCode": "6204.63.03.10",
      "superior": null,
      "indent": "8",
      "description": "Women's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.0325",
      "rawHtsCode": "6204.63.03.25",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.0350",
      "rawHtsCode": "6204.63.03.50",
      "superior": null,
      "indent": "9",
      "description": "Other (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.08",
      "rawHtsCode": "6204.63.08",
      "superior": null,
      "indent": "6",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.63.0810",
      "rawHtsCode": "6204.63.08.10",
      "superior": null,
      "indent": "7",
      "description": "Women's (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.0820",
      "rawHtsCode": "6204.63.08.20",
      "superior": null,
      "indent": "7",
      "description": "Girls' (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.09",
      "rawHtsCode": "6204.63.09",
      "superior": null,
      "indent": "7",
      "description": "Water resistant trousers or breeches",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.63.0910",
      "rawHtsCode": "6204.63.09.10",
      "superior": null,
      "indent": "8",
      "description": "Ski/snowboard pants (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.0990",
      "rawHtsCode": "6204.63.09.90",
      "superior": null,
      "indent": "8",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.11",
      "rawHtsCode": "6204.63.11",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [],
      "generalRate": "28.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG) ",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.63.1110",
      "rawHtsCode": "6204.63.11.10",
      "superior": null,
      "indent": "9",
      "description": "Women's (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.1125",
      "rawHtsCode": "6204.63.11.25",
      "superior": null,
      "indent": "10",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.1130",
      "rawHtsCode": "6204.63.11.30",
      "superior": null,
      "indent": "10",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.1132",
      "rawHtsCode": "6204.63.11.32",
      "superior": null,
      "indent": "9",
      "description": "Women's (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.1135",
      "rawHtsCode": "6204.63.11.35",
      "superior": null,
      "indent": "10",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.1140",
      "rawHtsCode": "6204.63.11.40",
      "superior": null,
      "indent": "10",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.5000",
      "rawHtsCode": "6204.63.50.00",
      "superior": null,
      "indent": "4",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6204.63.5500",
      "rawHtsCode": "6204.63.55.00",
      "superior": null,
      "indent": "6",
      "description": "Water resistant (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.63.60",
      "rawHtsCode": "6204.63.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.63.6005",
      "rawHtsCode": "6204.63.60.05",
      "superior": null,
      "indent": "7",
      "description": "Insulated, for cold weather protection (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.6010",
      "rawHtsCode": "6204.63.60.10",
      "superior": null,
      "indent": "8",
      "description": "Women's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.6025",
      "rawHtsCode": "6204.63.60.25",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.6050",
      "rawHtsCode": "6204.63.60.50",
      "superior": null,
      "indent": "9",
      "description": "Other (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.6500",
      "rawHtsCode": "6204.63.65.00",
      "superior": null,
      "indent": "5",
      "description": "Certified hand-loomed and folklore products (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.63.70",
      "rawHtsCode": "6204.63.70",
      "superior": null,
      "indent": "6",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU, BH, CL, CO, IL, JO, KR, MA, OM, P, PA, PE, S, SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.63.7010",
      "rawHtsCode": "6204.63.70.10",
      "superior": null,
      "indent": "7",
      "description": "Women's (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.7020",
      "rawHtsCode": "6204.63.70.20",
      "superior": null,
      "indent": "7",
      "description": "Girls' (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.75",
      "rawHtsCode": "6204.63.75",
      "superior": null,
      "indent": "7",
      "description": "Water resistant trousers or breeches (648)",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.63.7510",
      "rawHtsCode": "6204.63.75.10",
      "superior": null,
      "indent": "8",
      "description": "Ski/snowboard pants (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.7590",
      "rawHtsCode": "6204.63.75.90",
      "superior": null,
      "indent": "8",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.90",
      "rawHtsCode": "6204.63.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [],
      "generalRate": "28.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG) ",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.63.9009",
      "rawHtsCode": "6204.63.90.09",
      "superior": null,
      "indent": "10",
      "description": "Designed for use in hospitals, clinics, laboratories or contaminated areas (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.9011",
      "rawHtsCode": "6204.63.90.11",
      "superior": null,
      "indent": "10",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.9025",
      "rawHtsCode": "6204.63.90.25",
      "superior": null,
      "indent": "10",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.9030",
      "rawHtsCode": "6204.63.90.30",
      "superior": null,
      "indent": "10",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.9032",
      "rawHtsCode": "6204.63.90.32",
      "superior": null,
      "indent": "9",
      "description": "Women's (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.9035",
      "rawHtsCode": "6204.63.90.35",
      "superior": null,
      "indent": "10",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.63.9040",
      "rawHtsCode": "6204.63.90.40",
      "superior": null,
      "indent": "10",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69",
      "rawHtsCode": "6204.69",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.01",
      "rawHtsCode": "6204.69.01",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.69.0105",
      "rawHtsCode": "6204.69.01.05",
      "superior": null,
      "indent": "6",
      "description": "Insulated, for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0110",
      "rawHtsCode": "6204.69.01.10",
      "superior": null,
      "indent": "7",
      "description": "Women's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0125",
      "rawHtsCode": "6204.69.01.25",
      "superior": null,
      "indent": "8",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0150",
      "rawHtsCode": "6204.69.01.50",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.02",
      "rawHtsCode": "6204.69.02",
      "superior": null,
      "indent": "6",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.69.0210",
      "rawHtsCode": "6204.69.02.10",
      "superior": null,
      "indent": "8",
      "description": "Women's (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0220",
      "rawHtsCode": "6204.69.02.20",
      "superior": null,
      "indent": "8",
      "description": "Girls' (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0230",
      "rawHtsCode": "6204.69.02.30",
      "superior": null,
      "indent": "7",
      "description": "Shorts (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.03",
      "rawHtsCode": "6204.69.03",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "28.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.69.0310",
      "rawHtsCode": "6204.69.03.10",
      "superior": null,
      "indent": "8",
      "description": "Women's (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0320",
      "rawHtsCode": "6204.69.03.20",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0330",
      "rawHtsCode": "6204.69.03.30",
      "superior": null,
      "indent": "9",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0340",
      "rawHtsCode": "6204.69.03.40",
      "superior": null,
      "indent": "8",
      "description": "Women's (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0350",
      "rawHtsCode": "6204.69.03.50",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0360",
      "rawHtsCode": "6204.69.03.60",
      "superior": null,
      "indent": "9",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.04",
      "rawHtsCode": "6204.69.04",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "1.1%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.69.0410",
      "rawHtsCode": "6204.69.04.10",
      "superior": null,
      "indent": "6",
      "description": "Trousers, breeches and shorts (748)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0420",
      "rawHtsCode": "6204.69.04.20",
      "superior": null,
      "indent": "6",
      "description": "Bib and brace overalls (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.05",
      "rawHtsCode": "6204.69.05",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.69.0510",
      "rawHtsCode": "6204.69.05.10",
      "superior": null,
      "indent": "7",
      "description": "Subject to cotton restraints (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0520",
      "rawHtsCode": "6204.69.05.20",
      "superior": null,
      "indent": "7",
      "description": "Subject to wool restraints (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0530",
      "rawHtsCode": "6204.69.05.30",
      "superior": null,
      "indent": "7",
      "description": "Subject to man-made fiber restraints (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0540",
      "rawHtsCode": "6204.69.05.40",
      "superior": null,
      "indent": "8",
      "description": "Trousers and breeches (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0550",
      "rawHtsCode": "6204.69.05.50",
      "superior": null,
      "indent": "8",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0570",
      "rawHtsCode": "6204.69.05.70",
      "superior": null,
      "indent": "6",
      "description": "Bib and brace overalls (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.06",
      "rawHtsCode": "6204.69.06",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.69.0610",
      "rawHtsCode": "6204.69.06.10",
      "superior": null,
      "indent": "6",
      "description": "Subject to cotton restraints (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0620",
      "rawHtsCode": "6204.69.06.20",
      "superior": null,
      "indent": "6",
      "description": "Subject to wool restraints (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0630",
      "rawHtsCode": "6204.69.06.30",
      "superior": null,
      "indent": "6",
      "description": "Subject to man-made fiber restraints (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0644",
      "rawHtsCode": "6204.69.06.44",
      "superior": null,
      "indent": "7",
      "description": "Trousers and breeches (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0646",
      "rawHtsCode": "6204.69.06.46",
      "superior": null,
      "indent": "7",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.0650",
      "rawHtsCode": "6204.69.06.50",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.15",
      "rawHtsCode": "6204.69.15",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.69.1505",
      "rawHtsCode": "6204.69.15.05",
      "superior": null,
      "indent": "6",
      "description": "Insulated, for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.1510",
      "rawHtsCode": "6204.69.15.10",
      "superior": null,
      "indent": "7",
      "description": "Women's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.1525",
      "rawHtsCode": "6204.69.15.25",
      "superior": null,
      "indent": "8",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.1550",
      "rawHtsCode": "6204.69.15.50",
      "superior": null,
      "indent": "8",
      "description": "Other (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.22",
      "rawHtsCode": "6204.69.22",
      "superior": null,
      "indent": "6",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "13.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.69.2210",
      "rawHtsCode": "6204.69.22.10",
      "superior": null,
      "indent": "8",
      "description": "Women's (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.2220",
      "rawHtsCode": "6204.69.22.20",
      "superior": null,
      "indent": "8",
      "description": "Girls' (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.2230",
      "rawHtsCode": "6204.69.22.30",
      "superior": null,
      "indent": "7",
      "description": "Shorts (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.28",
      "rawHtsCode": "6204.69.28",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "28.6%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.69.2810",
      "rawHtsCode": "6204.69.28.10",
      "superior": null,
      "indent": "8",
      "description": "Women's (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.2820",
      "rawHtsCode": "6204.69.28.20",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.2830",
      "rawHtsCode": "6204.69.28.30",
      "superior": null,
      "indent": "9",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.2840",
      "rawHtsCode": "6204.69.28.40",
      "superior": null,
      "indent": "8",
      "description": "Women's (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.2850",
      "rawHtsCode": "6204.69.28.50",
      "superior": null,
      "indent": "9",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.2860",
      "rawHtsCode": "6204.69.28.60",
      "superior": null,
      "indent": "9",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.45",
      "rawHtsCode": "6204.69.45",
      "superior": null,
      "indent": "5",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "1.1%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.69.4510",
      "rawHtsCode": "6204.69.45.10",
      "superior": null,
      "indent": "6",
      "description": "Trousers, breeches and shorts (748)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.4520",
      "rawHtsCode": "6204.69.45.20",
      "superior": null,
      "indent": "6",
      "description": "Bib and brace overalls (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.65",
      "rawHtsCode": "6204.69.65",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.69.6510",
      "rawHtsCode": "6204.69.65.10",
      "superior": null,
      "indent": "7",
      "description": "Subject to cotton restraints (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.6520",
      "rawHtsCode": "6204.69.65.20",
      "superior": null,
      "indent": "7",
      "description": "Subject to wool restraints (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.6530",
      "rawHtsCode": "6204.69.65.30",
      "superior": null,
      "indent": "7",
      "description": "Subject to man-made fiber restraints (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.6540",
      "rawHtsCode": "6204.69.65.40",
      "superior": null,
      "indent": "8",
      "description": "Trousers and breeches (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.6550",
      "rawHtsCode": "6204.69.65.50",
      "superior": null,
      "indent": "8",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.6570",
      "rawHtsCode": "6204.69.65.70",
      "superior": null,
      "indent": "6",
      "description": "Bib and brace overalls (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.80",
      "rawHtsCode": "6204.69.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6204.69.8010",
      "rawHtsCode": "6204.69.80.10",
      "superior": null,
      "indent": "6",
      "description": "Subject to cotton restraints (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.8020",
      "rawHtsCode": "6204.69.80.20",
      "superior": null,
      "indent": "6",
      "description": "Subject to wool restraints (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.8030",
      "rawHtsCode": "6204.69.80.30",
      "superior": null,
      "indent": "6",
      "description": "Subject to man-made fiber restraints (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.8044",
      "rawHtsCode": "6204.69.80.44",
      "superior": null,
      "indent": "7",
      "description": "Trousers and breeches (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.8046",
      "rawHtsCode": "6204.69.80.46",
      "superior": null,
      "indent": "7",
      "description": "Shorts (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6204.69.8050",
      "rawHtsCode": "6204.69.80.50",
      "superior": null,
      "indent": "5",
      "description": "Bib and brace overalls (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205",
      "rawHtsCode": "6205",
      "superior": null,
      "indent": "0",
      "description": "Men's or boys' shirts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20",
      "rawHtsCode": "6205.20",
      "superior": null,
      "indent": "1",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.1000",
      "rawHtsCode": "6205.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Certified hand-loomed and folklore products (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "8.7%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6205.20.20",
      "rawHtsCode": "6205.20.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "19.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6205.20.2003",
      "rawHtsCode": "6205.20.20.03",
      "superior": null,
      "indent": "3",
      "description": "Containing compact yarns described in statistical reporting number 5205.42.0021, 5205.43.0021,   5205.44.0021, 5205.46.0021 or 5205.47.0021 (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2016",
      "rawHtsCode": "6205.20.20.16",
      "superior": null,
      "indent": "5",
      "description": "Men's (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2021",
      "rawHtsCode": "6205.20.20.21",
      "superior": null,
      "indent": "5",
      "description": "Boys' (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2026",
      "rawHtsCode": "6205.20.20.26",
      "superior": null,
      "indent": "5",
      "description": "Men's (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2031",
      "rawHtsCode": "6205.20.20.31",
      "superior": null,
      "indent": "5",
      "description": "Boys' (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2036",
      "rawHtsCode": "6205.20.20.36",
      "superior": null,
      "indent": "5",
      "description": "Men's (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2041",
      "rawHtsCode": "6205.20.20.41",
      "superior": null,
      "indent": "6",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2044",
      "rawHtsCode": "6205.20.20.44",
      "superior": null,
      "indent": "6",
      "description": "Other (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2047",
      "rawHtsCode": "6205.20.20.47",
      "superior": null,
      "indent": "6",
      "description": "Napped (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2051",
      "rawHtsCode": "6205.20.20.51",
      "superior": null,
      "indent": "7",
      "description": "Men's (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2056",
      "rawHtsCode": "6205.20.20.56",
      "superior": null,
      "indent": "8",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2061",
      "rawHtsCode": "6205.20.20.61",
      "superior": null,
      "indent": "8",
      "description": "Other (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2063",
      "rawHtsCode": "6205.20.20.63",
      "superior": null,
      "indent": "7",
      "description": "Designed for use in hospitals, clinics, laboratories or contaminated areas (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2067",
      "rawHtsCode": "6205.20.20.67",
      "superior": null,
      "indent": "7",
      "description": "Other (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2071",
      "rawHtsCode": "6205.20.20.71",
      "superior": null,
      "indent": "7",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.20.2076",
      "rawHtsCode": "6205.20.20.76",
      "superior": null,
      "indent": "7",
      "description": "Other (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30",
      "rawHtsCode": "6205.30",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.1000",
      "rawHtsCode": "6205.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Certified hand-loomed and folklore products (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "12.2%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6205.30.15",
      "rawHtsCode": "6205.30.15",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "49.6¢/kg + 19.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6205.30.1510",
      "rawHtsCode": "6205.30.15.10",
      "superior": null,
      "indent": "4",
      "description": "Men's (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.1520",
      "rawHtsCode": "6205.30.15.20",
      "superior": null,
      "indent": "4",
      "description": "Boys' (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.20",
      "rawHtsCode": "6205.30.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "29.1¢/kg + 25.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "30.9¢/kg + 76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6205.30.2010",
      "rawHtsCode": "6205.30.20.10",
      "superior": null,
      "indent": "6",
      "description": "Men's (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.2020",
      "rawHtsCode": "6205.30.20.20",
      "superior": null,
      "indent": "6",
      "description": "Boys' (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.2030",
      "rawHtsCode": "6205.30.20.30",
      "superior": null,
      "indent": "6",
      "description": "Men's (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.2040",
      "rawHtsCode": "6205.30.20.40",
      "superior": null,
      "indent": "6",
      "description": "Boys' (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.2050",
      "rawHtsCode": "6205.30.20.50",
      "superior": null,
      "indent": "6",
      "description": "Men's (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.2055",
      "rawHtsCode": "6205.30.20.55",
      "superior": null,
      "indent": "7",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.2060",
      "rawHtsCode": "6205.30.20.60",
      "superior": null,
      "indent": "7",
      "description": "Other (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.2071",
      "rawHtsCode": "6205.30.20.71",
      "superior": null,
      "indent": "7",
      "description": "Designed for use in hospitals, clinics, laboratories or contaminated areas (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.2073",
      "rawHtsCode": "6205.30.20.73",
      "superior": null,
      "indent": "7",
      "description": "Other (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.2075",
      "rawHtsCode": "6205.30.20.75",
      "superior": null,
      "indent": "7",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.30.2080",
      "rawHtsCode": "6205.30.20.80",
      "superior": null,
      "indent": "7",
      "description": "Other (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.90",
      "rawHtsCode": "6205.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.90.0500",
      "rawHtsCode": "6205.90.05.00",
      "superior": null,
      "indent": "3",
      "description": "Certified hand-loomed and folklore products (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6205.90.07",
      "rawHtsCode": "6205.90.07",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "17.5%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52.9¢/kg + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6205.90.0710",
      "rawHtsCode": "6205.90.07.10",
      "superior": null,
      "indent": "4",
      "description": "Men's (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.90.0720",
      "rawHtsCode": "6205.90.07.20",
      "superior": null,
      "indent": "4",
      "description": "Boys' (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.90.1000",
      "rawHtsCode": "6205.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (740)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6205.90.30",
      "rawHtsCode": "6205.90.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6205.90.3010",
      "rawHtsCode": "6205.90.30.10",
      "superior": null,
      "indent": "4",
      "description": "Subject to cotton restraints (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.90.3020",
      "rawHtsCode": "6205.90.30.20",
      "superior": null,
      "indent": "4",
      "description": "Subject to wool restraints (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.90.3030",
      "rawHtsCode": "6205.90.30.30",
      "superior": null,
      "indent": "4",
      "description": "Subject to man-made fiber restraints (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.90.3050",
      "rawHtsCode": "6205.90.30.50",
      "superior": null,
      "indent": "4",
      "description": "Other (840)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.90.40",
      "rawHtsCode": "6205.90.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6205.90.4010",
      "rawHtsCode": "6205.90.40.10",
      "superior": null,
      "indent": "3",
      "description": "Subject to cotton restraints (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.90.4020",
      "rawHtsCode": "6205.90.40.20",
      "superior": null,
      "indent": "3",
      "description": "Subject to wool restraints (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.90.4030",
      "rawHtsCode": "6205.90.40.30",
      "superior": null,
      "indent": "3",
      "description": "Subject to man-made fiber restraints (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6205.90.4040",
      "rawHtsCode": "6205.90.40.40",
      "superior": null,
      "indent": "3",
      "description": "Other (840)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206",
      "rawHtsCode": "6206",
      "superior": null,
      "indent": "0",
      "description": "Women's or girls' blouses, shirts and shirt-blouses:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.10.00",
      "rawHtsCode": "6206.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of silk or silk waste",
      "units": [],
      "generalRate": "6.9%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6206.10.0010",
      "rawHtsCode": "6206.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Subject to cotton restraints (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.10.0020",
      "rawHtsCode": "6206.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Subject to wool restraints (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.10.0030",
      "rawHtsCode": "6206.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Subject to man-made fiber restraints (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.10.0040",
      "rawHtsCode": "6206.10.00.40",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (741)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.10.0050",
      "rawHtsCode": "6206.10.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other (840)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.20",
      "rawHtsCode": "6206.20",
      "superior": null,
      "indent": "1",
      "description": "Of wool or fine animal hair:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.20.1000",
      "rawHtsCode": "6206.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Certified hand-loomed and folklore products (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6206.20.20",
      "rawHtsCode": "6206.20.20",
      "superior": null,
      "indent": "3",
      "description": "Containing 30 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6206.20.2010",
      "rawHtsCode": "6206.20.20.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.20.2020",
      "rawHtsCode": "6206.20.20.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.20.30",
      "rawHtsCode": "6206.20.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "17%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "82.7¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6206.20.3010",
      "rawHtsCode": "6206.20.30.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.20.3020",
      "rawHtsCode": "6206.20.30.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.30",
      "rawHtsCode": "6206.30",
      "superior": null,
      "indent": "1",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.30.1000",
      "rawHtsCode": "6206.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Certified hand-loomed and folklore products (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6206.30.2000",
      "rawHtsCode": "6206.30.20.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of flax fibers (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6206.30.30",
      "rawHtsCode": "6206.30.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "15.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6206.30.3003",
      "rawHtsCode": "6206.30.30.03",
      "superior": null,
      "indent": "4",
      "description": "Containing compact yarns described in statistical reporting numbers 5205.42.0021, 5205.43.0021,   5205.44.0021,5205.46.0021or 5205.47.0021 (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.30.3011",
      "rawHtsCode": "6206.30.30.11",
      "superior": null,
      "indent": "6",
      "description": "Women's (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.30.3021",
      "rawHtsCode": "6206.30.30.21",
      "superior": null,
      "indent": "7",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.30.3031",
      "rawHtsCode": "6206.30.30.31",
      "superior": null,
      "indent": "7",
      "description": "Other (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.30.3043",
      "rawHtsCode": "6206.30.30.43",
      "superior": null,
      "indent": "7",
      "description": "Designed for use in hospitals, clinics, laboratories or contaminated areas (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.30.3045",
      "rawHtsCode": "6206.30.30.45",
      "superior": null,
      "indent": "7",
      "description": "Other (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.30.3051",
      "rawHtsCode": "6206.30.30.51",
      "superior": null,
      "indent": "7",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.30.3061",
      "rawHtsCode": "6206.30.30.61",
      "superior": null,
      "indent": "7",
      "description": "Other (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.40",
      "rawHtsCode": "6206.40",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.40.1000",
      "rawHtsCode": "6206.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Certified hand-loomed and folklore products (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6206.40.2000",
      "rawHtsCode": "6206.40.20.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 30 percent or more by weight of silk or silk waste (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6206.40.25",
      "rawHtsCode": "6206.40.25",
      "superior": null,
      "indent": "3",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair",
      "units": [],
      "generalRate": "56.3¢/kg + 14.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "82.7¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6206.40.2510",
      "rawHtsCode": "6206.40.25.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.40.2520",
      "rawHtsCode": "6206.40.25.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.40.30",
      "rawHtsCode": "6206.40.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "26.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6206.40.3010",
      "rawHtsCode": "6206.40.30.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.40.3020",
      "rawHtsCode": "6206.40.30.20",
      "superior": null,
      "indent": "6",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.40.3025",
      "rawHtsCode": "6206.40.30.25",
      "superior": null,
      "indent": "6",
      "description": "Other (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.40.3033",
      "rawHtsCode": "6206.40.30.33",
      "superior": null,
      "indent": "6",
      "description": "Designed for use in hospitals, clinics, laboratories or contaminated areas (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.40.3035",
      "rawHtsCode": "6206.40.30.35",
      "superior": null,
      "indent": "6",
      "description": "Other (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.40.3040",
      "rawHtsCode": "6206.40.30.40",
      "superior": null,
      "indent": "6",
      "description": "Imported as parts of playsuits (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.40.3050",
      "rawHtsCode": "6206.40.30.50",
      "superior": null,
      "indent": "6",
      "description": "Other (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.90.00",
      "rawHtsCode": "6206.90.00",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials",
      "units": [],
      "generalRate": "6.7%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6206.90.0010",
      "rawHtsCode": "6206.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Subject to cotton restraints (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.90.0020",
      "rawHtsCode": "6206.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Subject to wool restraints (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.90.0030",
      "rawHtsCode": "6206.90.00.30",
      "superior": null,
      "indent": "2",
      "description": "Subject to man-made fiber restraints (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6206.90.0040",
      "rawHtsCode": "6206.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other (840)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207",
      "rawHtsCode": "6207",
      "superior": null,
      "indent": "0",
      "description": "Men's or boys' singlets and other undershirts, underpants, briefs, nightshirts, pajamas, bathrobes,   dressing gowns and similar articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.11.0000",
      "rawHtsCode": "6207.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "6.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.19",
      "rawHtsCode": "6207.19",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.19.1000",
      "rawHtsCode": "6207.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (752)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.19.90",
      "rawHtsCode": "6207.19.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "10.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.19.9010",
      "rawHtsCode": "6207.19.90.10",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.19.9030",
      "rawHtsCode": "6207.19.90.30",
      "superior": null,
      "indent": "4",
      "description": "Other (852)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.21.00",
      "rawHtsCode": "6207.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "8.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.21.0010",
      "rawHtsCode": "6207.21.00.10",
      "superior": null,
      "indent": "4",
      "description": "Men's (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.21.0020",
      "rawHtsCode": "6207.21.00.20",
      "superior": null,
      "indent": "4",
      "description": "Boys' (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.21.0030",
      "rawHtsCode": "6207.21.00.30",
      "superior": null,
      "indent": "4",
      "description": "Men's (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.21.0040",
      "rawHtsCode": "6207.21.00.40",
      "superior": null,
      "indent": "4",
      "description": "Boys' (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.22.0000",
      "rawHtsCode": "6207.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (651)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.29",
      "rawHtsCode": "6207.29",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.29.1000",
      "rawHtsCode": "6207.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (751)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.29.90",
      "rawHtsCode": "6207.29.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.29.9010",
      "rawHtsCode": "6207.29.90.10",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.29.9030",
      "rawHtsCode": "6207.29.90.30",
      "superior": null,
      "indent": "4",
      "description": "Other (851)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.91",
      "rawHtsCode": "6207.91",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.91.1000",
      "rawHtsCode": "6207.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Bathrobes, dressing gowns and similar articles (350)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.91.30",
      "rawHtsCode": "6207.91.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.91.3010",
      "rawHtsCode": "6207.91.30.10",
      "superior": null,
      "indent": "4",
      "description": "Sleepwear (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.91.3020",
      "rawHtsCode": "6207.91.30.20",
      "superior": null,
      "indent": "4",
      "description": "Other (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.99",
      "rawHtsCode": "6207.99",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.99.2000",
      "rawHtsCode": "6207.99.20.00",
      "superior": null,
      "indent": "4",
      "description": "Bathrobes, dressing gowns and similar articles (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.99.4000",
      "rawHtsCode": "6207.99.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "6.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "52%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.99.70",
      "rawHtsCode": "6207.99.70",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "1.1%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.99.7010",
      "rawHtsCode": "6207.99.70.10",
      "superior": null,
      "indent": "4",
      "description": "Bathrobes, dressing gowns and similar articles (750)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.99.7020",
      "rawHtsCode": "6207.99.70.20",
      "superior": null,
      "indent": "4",
      "description": "Sleepwear (751)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.99.7030",
      "rawHtsCode": "6207.99.70.30",
      "superior": null,
      "indent": "4",
      "description": "Other (752)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.99.75",
      "rawHtsCode": "6207.99.75",
      "superior": null,
      "indent": "4",
      "description": "Bathrobes, dressing gowns and similar articles",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.99.7510",
      "rawHtsCode": "6207.99.75.10",
      "superior": null,
      "indent": "5",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.99.7520",
      "rawHtsCode": "6207.99.75.20",
      "superior": null,
      "indent": "5",
      "description": "Other (650)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.99.85",
      "rawHtsCode": "6207.99.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "10.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.99.8510",
      "rawHtsCode": "6207.99.85.10",
      "superior": null,
      "indent": "5",
      "description": "Sleepwear (651)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.99.8520",
      "rawHtsCode": "6207.99.85.20",
      "superior": null,
      "indent": "5",
      "description": "Other (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.99.90",
      "rawHtsCode": "6207.99.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6207.99.9010",
      "rawHtsCode": "6207.99.90.10",
      "superior": null,
      "indent": "4",
      "description": "Bathrobes, dressing gowns and similar articles (850)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6207.99.9040",
      "rawHtsCode": "6207.99.90.40",
      "superior": null,
      "indent": "4",
      "description": "Other (852)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208",
      "rawHtsCode": "6208",
      "superior": null,
      "indent": "0",
      "description": "Women's or girls' singlets and other undershirts, slips, petticoats, briefs, panties, nightdresses,   pajamas, negligees, bathrobes, dressing gowns and similar articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.11.0000",
      "rawHtsCode": "6208.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.19",
      "rawHtsCode": "6208.19",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.19.2000",
      "rawHtsCode": "6208.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.19.5000",
      "rawHtsCode": "6208.19.50.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent of more by weight of silk or silk waste (752)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.19.9000",
      "rawHtsCode": "6208.19.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (852)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "8.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.21.00",
      "rawHtsCode": "6208.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "8.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See  9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.21.0010",
      "rawHtsCode": "6208.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "With two or more colors in the warp and/or the filling (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.21.0020",
      "rawHtsCode": "6208.21.00.20",
      "superior": null,
      "indent": "4",
      "description": "Women's (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.21.0030",
      "rawHtsCode": "6208.21.00.30",
      "superior": null,
      "indent": "4",
      "description": "Girls' (351)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.22.0000",
      "rawHtsCode": "6208.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (651)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.29",
      "rawHtsCode": "6208.29",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.29.1000",
      "rawHtsCode": "6208.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (751)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.29.90",
      "rawHtsCode": "6208.29.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.29.9010",
      "rawHtsCode": "6208.29.90.10",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.29.9030",
      "rawHtsCode": "6208.29.90.30",
      "superior": null,
      "indent": "4",
      "description": "Other (851)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.91",
      "rawHtsCode": "6208.91",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.91.10",
      "rawHtsCode": "6208.91.10",
      "superior": null,
      "indent": "3",
      "description": "Bathrobes, dressing gowns and similar articles",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.91.1010",
      "rawHtsCode": "6208.91.10.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (350)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.91.1020",
      "rawHtsCode": "6208.91.10.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (350)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.91.30",
      "rawHtsCode": "6208.91.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "11.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.91.3010",
      "rawHtsCode": "6208.91.30.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.91.3020",
      "rawHtsCode": "6208.91.30.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (352)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.92.00",
      "rawHtsCode": "6208.92.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.92.0010",
      "rawHtsCode": "6208.92.00.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (650)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.92.0020",
      "rawHtsCode": "6208.92.00.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (650)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.92.0030",
      "rawHtsCode": "6208.92.00.30",
      "superior": null,
      "indent": "4",
      "description": "Women's (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.92.0040",
      "rawHtsCode": "6208.92.00.40",
      "superior": null,
      "indent": "4",
      "description": "Girls' (652)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.99",
      "rawHtsCode": "6208.99",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.99.20",
      "rawHtsCode": "6208.99.20",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.99.2010",
      "rawHtsCode": "6208.99.20.10",
      "superior": null,
      "indent": "4",
      "description": "Bathrobes, dressing gowns and similar articles (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.99.2020",
      "rawHtsCode": "6208.99.20.20",
      "superior": null,
      "indent": "4",
      "description": "Other (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.99.30",
      "rawHtsCode": "6208.99.30",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "1.1%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.99.3010",
      "rawHtsCode": "6208.99.30.10",
      "superior": null,
      "indent": "5",
      "description": "Bathrobes, dressing gowns and similar articles (750)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.99.3020",
      "rawHtsCode": "6208.99.30.20",
      "superior": null,
      "indent": "5",
      "description": "Other (752)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.99.50",
      "rawHtsCode": "6208.99.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.99.5010",
      "rawHtsCode": "6208.99.50.10",
      "superior": null,
      "indent": "5",
      "description": "Bathrobes, dressing gowns and similar articles (850)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.99.5020",
      "rawHtsCode": "6208.99.50.20",
      "superior": null,
      "indent": "5",
      "description": "Other (852)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.99.80",
      "rawHtsCode": "6208.99.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6208.99.8010",
      "rawHtsCode": "6208.99.80.10",
      "superior": null,
      "indent": "4",
      "description": "Bathrobes, dressing gowns and similar articles (850)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6208.99.8020",
      "rawHtsCode": "6208.99.80.20",
      "superior": null,
      "indent": "4",
      "description": "Other (852)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209",
      "rawHtsCode": "6209",
      "superior": null,
      "indent": "0",
      "description": "Babies' garments and clothing accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.20",
      "rawHtsCode": "6209.20",
      "superior": null,
      "indent": "1",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.20.1000",
      "rawHtsCode": "6209.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Dresses (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "11.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6209.20.2000",
      "rawHtsCode": "6209.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Blouses and shirts, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6209.20.3000",
      "rawHtsCode": "6209.20.30.00",
      "superior": null,
      "indent": "3",
      "description": "Trousers, breeches and shorts, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6209.20.50",
      "rawHtsCode": "6209.20.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "9.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6209.20.5030",
      "rawHtsCode": "6209.20.50.30",
      "superior": null,
      "indent": "4",
      "description": "Sunsuits, washsuits and similar apparel (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.20.5035",
      "rawHtsCode": "6209.20.50.35",
      "superior": null,
      "indent": "4",
      "description": "Sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.20.5045",
      "rawHtsCode": "6209.20.50.45",
      "superior": null,
      "indent": "5",
      "description": "Imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.20.5050",
      "rawHtsCode": "6209.20.50.50",
      "superior": null,
      "indent": "5",
      "description": "Other (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.30",
      "rawHtsCode": "6209.30",
      "superior": null,
      "indent": "1",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.30.1000",
      "rawHtsCode": "6209.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Blouses and shirts, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "22%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6209.30.2000",
      "rawHtsCode": "6209.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Trousers, breeches and shorts, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "28.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6209.30.30",
      "rawHtsCode": "6209.30.30",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6209.30.3010",
      "rawHtsCode": "6209.30.30.10",
      "superior": null,
      "indent": "3",
      "description": "Sunsuits, washsuits and similar apparel (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.30.3020",
      "rawHtsCode": "6209.30.30.20",
      "superior": null,
      "indent": "3",
      "description": "Sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.30.3030",
      "rawHtsCode": "6209.30.30.30",
      "superior": null,
      "indent": "4",
      "description": "Imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.30.3040",
      "rawHtsCode": "6209.30.30.40",
      "superior": null,
      "indent": "4",
      "description": "Other (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.90",
      "rawHtsCode": "6209.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.90.0500",
      "rawHtsCode": "6209.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (439)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "31.8¢/kg + 14.4%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "46.3¢/kg + 58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6209.90.1000",
      "rawHtsCode": "6209.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Blouses and shirts, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "22%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6209.90.2000",
      "rawHtsCode": "6209.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Trousers, breeches and shorts, except those imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6209.90.30",
      "rawHtsCode": "6209.90.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6209.90.3010",
      "rawHtsCode": "6209.90.30.10",
      "superior": null,
      "indent": "4",
      "description": "Sunsuits, washsuits and similar apparel (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.90.3015",
      "rawHtsCode": "6209.90.30.15",
      "superior": null,
      "indent": "4",
      "description": "Blanket sleepers (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.90.3020",
      "rawHtsCode": "6209.90.30.20",
      "superior": null,
      "indent": "4",
      "description": "Sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.90.3030",
      "rawHtsCode": "6209.90.30.30",
      "superior": null,
      "indent": "5",
      "description": "Imported as parts of sets (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.90.3040",
      "rawHtsCode": "6209.90.30.40",
      "superior": null,
      "indent": "5",
      "description": "Other (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6209.90.5000",
      "rawHtsCode": "6209.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6209.90.9000",
      "rawHtsCode": "6209.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (839)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210",
      "rawHtsCode": "6210",
      "superior": null,
      "indent": "0",
      "description": "Garments, made up of fabrics of heading 5602, 5603, 5903, 5906 or 5907:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.10",
      "rawHtsCode": "6210.10",
      "superior": null,
      "indent": "1",
      "description": "Of fabrics of heading 5602 or 5603:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.10.2000",
      "rawHtsCode": "6210.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of fabrics formed on a base of paper or covered or lined with paper",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "26.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.10.50",
      "rawHtsCode": "6210.10.50",
      "superior": null,
      "indent": "3",
      "description": "Nonwoven disposable apparel designed for use in hospitals, clinics, laboratories or contaminated areas",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6210.10.5010",
      "rawHtsCode": "6210.10.50.10",
      "superior": null,
      "indent": "4",
      "description": "Surgical or isolation gowns",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "6210.10.5090",
      "rawHtsCode": "6210.10.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "6210.10.7000",
      "rawHtsCode": "6210.10.70.00",
      "superior": null,
      "indent": "4",
      "description": "Disposable briefs and panties designed for one-time use",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.10.90",
      "rawHtsCode": "6210.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.10.9010",
      "rawHtsCode": "6210.10.90.10",
      "superior": null,
      "indent": "5",
      "description": "Overalls and coveralls (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.10.9040",
      "rawHtsCode": "6210.10.90.40",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.20",
      "rawHtsCode": "6210.20",
      "superior": null,
      "indent": "1",
      "description": "Other garments, of the type described in heading 6201:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.20.3000",
      "rawHtsCode": "6210.20.30.00",
      "superior": null,
      "indent": "3",
      "description": "Having an outer surface impregnated, coated, covered, or laminated with rubber or plastics material   which completely obscures the underlying fabric",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.20.50",
      "rawHtsCode": "6210.20.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.20.5010",
      "rawHtsCode": "6210.20.50.10",
      "superior": null,
      "indent": "4",
      "description": "Overcoats, carcoats, capes, cloaks and similar garments (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.20.5020",
      "rawHtsCode": "6210.20.50.20",
      "superior": null,
      "indent": "5",
      "description": "Recreational performance outerwear (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.20.5029",
      "rawHtsCode": "6210.20.50.29",
      "superior": null,
      "indent": "5",
      "description": "Other (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.20.7000",
      "rawHtsCode": "6210.20.70.00",
      "superior": null,
      "indent": "3",
      "description": "Having an outer surface impregnated, coated, covered, or laminated with rubber or plastics material which completely obscures the underlying fabric",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.20.90",
      "rawHtsCode": "6210.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.20.9010",
      "rawHtsCode": "6210.20.90.10",
      "superior": null,
      "indent": "5",
      "description": "Of linen (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.20.9020",
      "rawHtsCode": "6210.20.90.20",
      "superior": null,
      "indent": "5",
      "description": "Other (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.20.9030",
      "rawHtsCode": "6210.20.90.30",
      "superior": null,
      "indent": "6",
      "description": "Having a fiber content of 70 percent or more by weight of silk or silk waste (734)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.20.9039",
      "rawHtsCode": "6210.20.90.39",
      "superior": null,
      "indent": "6",
      "description": "Other (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.20.9040",
      "rawHtsCode": "6210.20.90.40",
      "superior": null,
      "indent": "6",
      "description": "Having a fiber content of 70 percent or more by weight of silk or silk waste (734)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.20.9049",
      "rawHtsCode": "6210.20.90.49",
      "superior": null,
      "indent": "6",
      "description": "Other (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.30",
      "rawHtsCode": "6210.30",
      "superior": null,
      "indent": "1",
      "description": "Other garments, of the type described in heading 6202:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.30.3000",
      "rawHtsCode": "6210.30.30.00",
      "superior": null,
      "indent": "3",
      "description": "Having an outer surface impregnated, coated, covered, or laminated with rubber or plastics material which completely obscure the underlying fabric",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.30.50",
      "rawHtsCode": "6210.30.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.30.5010",
      "rawHtsCode": "6210.30.50.10",
      "superior": null,
      "indent": "4",
      "description": "Overcoats, carcoats, capes, cloaks and similar garments (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.30.5020",
      "rawHtsCode": "6210.30.50.20",
      "superior": null,
      "indent": "5",
      "description": "Recreational performance outerwear (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.30.5029",
      "rawHtsCode": "6210.30.50.29",
      "superior": null,
      "indent": "5",
      "description": "Other (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.30.7000",
      "rawHtsCode": "6210.30.70.00",
      "superior": null,
      "indent": "3",
      "description": "Having an outer surface impregnated, coated, covered, or laminated with rubber or plastics material which completely obscures the underlying fabric",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.30.90",
      "rawHtsCode": "6210.30.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.30.9010",
      "rawHtsCode": "6210.30.90.10",
      "superior": null,
      "indent": "5",
      "description": "Of linen (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.30.9020",
      "rawHtsCode": "6210.30.90.20",
      "superior": null,
      "indent": "5",
      "description": "Other (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.30.9030",
      "rawHtsCode": "6210.30.90.30",
      "superior": null,
      "indent": "6",
      "description": "Having a fiber content of 70 percent or more by weight of silk or silk waste (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.30.9039",
      "rawHtsCode": "6210.30.90.39",
      "superior": null,
      "indent": "6",
      "description": "Other (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.30.9040",
      "rawHtsCode": "6210.30.90.40",
      "superior": null,
      "indent": "6",
      "description": "Having a fiber content of 70 percent or more by weight of silk or silk waste (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.30.9049",
      "rawHtsCode": "6210.30.90.49",
      "superior": null,
      "indent": "6",
      "description": "Other (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40",
      "rawHtsCode": "6210.40",
      "superior": null,
      "indent": "1",
      "description": "Other men's or boys' garments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.1500",
      "rawHtsCode": "6210.40.15.00",
      "superior": null,
      "indent": "4",
      "description": "Having an outer surface impregnated, coated, cover or laminated with rubber or plastics material which completely obscures the underlying fabric",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.40.25",
      "rawHtsCode": "6210.40.25",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.40.2531",
      "rawHtsCode": "6210.40.25.31",
      "superior": null,
      "indent": "6",
      "description": "Ski/snowboard pants (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.2539",
      "rawHtsCode": "6210.40.25.39",
      "superior": null,
      "indent": "6",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.2540",
      "rawHtsCode": "6210.40.25.40",
      "superior": null,
      "indent": "5",
      "description": "Overalls and coveralls (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.2550",
      "rawHtsCode": "6210.40.25.50",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.2800",
      "rawHtsCode": "6210.40.28.00",
      "superior": null,
      "indent": "4",
      "description": "Having an outer surface impregnated, coated, covered or laminated with rubber or plastics material which completely obscures the underlying fabric",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.40.29",
      "rawHtsCode": "6210.40.29",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.40.2917",
      "rawHtsCode": "6210.40.29.17",
      "superior": null,
      "indent": "6",
      "description": "Trousers, breeches and shorts (747)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.2918",
      "rawHtsCode": "6210.40.29.18",
      "superior": null,
      "indent": "6",
      "description": "Overalls and coveralls (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.2919",
      "rawHtsCode": "6210.40.29.19",
      "superior": null,
      "indent": "6",
      "description": "Other (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.2933",
      "rawHtsCode": "6210.40.29.33",
      "superior": null,
      "indent": "6",
      "description": "Trousers, breeches and shorts (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.2945",
      "rawHtsCode": "6210.40.29.45",
      "superior": null,
      "indent": "6",
      "description": "Overalls and coveralls (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.2960",
      "rawHtsCode": "6210.40.29.60",
      "superior": null,
      "indent": "6",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.3500",
      "rawHtsCode": "6210.40.35.00",
      "superior": null,
      "indent": "4",
      "description": "Having an outer surface impregnated, coated, covered or laminated with rubber or plastics material which completely obscures the underlying fabric",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.40.55",
      "rawHtsCode": "6210.40.55",
      "superior": null,
      "indent": "4",
      "description": "Other ",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.40.5531",
      "rawHtsCode": "6210.40.55.31",
      "superior": null,
      "indent": "6",
      "description": "Ski/snowboard pants (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.5539",
      "rawHtsCode": "6210.40.55.39",
      "superior": null,
      "indent": "6",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.5540",
      "rawHtsCode": "6210.40.55.40",
      "superior": null,
      "indent": "5",
      "description": "Overalls and coveralls (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.5550",
      "rawHtsCode": "6210.40.55.50",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.7500",
      "rawHtsCode": "6210.40.75.00",
      "superior": null,
      "indent": "4",
      "description": "Having an outer surface impregnated, coated, covered or laminated with rubber or plastics material which completely obscures the underlying fabric",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.40.80",
      "rawHtsCode": "6210.40.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.40.8017",
      "rawHtsCode": "6210.40.80.17",
      "superior": null,
      "indent": "6",
      "description": "Trousers, breeches and shorts (747)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.8018",
      "rawHtsCode": "6210.40.80.18",
      "superior": null,
      "indent": "6",
      "description": "Overalls and coveralls (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.8019",
      "rawHtsCode": "6210.40.80.19",
      "superior": null,
      "indent": "6",
      "description": "Other (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.8033",
      "rawHtsCode": "6210.40.80.33",
      "superior": null,
      "indent": "6",
      "description": "Trousers, breeches and shorts (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.8045",
      "rawHtsCode": "6210.40.80.45",
      "superior": null,
      "indent": "6",
      "description": "Overalls and coveralls (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.40.8060",
      "rawHtsCode": "6210.40.80.60",
      "superior": null,
      "indent": "6",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50",
      "rawHtsCode": "6210.50",
      "superior": null,
      "indent": "1",
      "description": "Other women's or girls' garments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.0300",
      "rawHtsCode": "6210.50.03.00",
      "superior": null,
      "indent": "4",
      "description": "Having an outer surface impregnated, coated, covered or laminated with rubber or plastics material which completely obscures the underlying fabric",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.50.05",
      "rawHtsCode": "6210.50.05",
      "superior": null,
      "indent": "4",
      "description": "Other ",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.50.0531",
      "rawHtsCode": "6210.50.05.31",
      "superior": null,
      "indent": "6",
      "description": "Ski/snowboard pants (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.0539",
      "rawHtsCode": "6210.50.05.39",
      "superior": null,
      "indent": "6",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.0540",
      "rawHtsCode": "6210.50.05.40",
      "superior": null,
      "indent": "5",
      "description": "Overalls and coveralls (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.0555",
      "rawHtsCode": "6210.50.05.55",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.1200",
      "rawHtsCode": "6210.50.12.00",
      "superior": null,
      "indent": "4",
      "description": "Having an outer surface impregnated, coated, covered or laminated with rubber or plastics material which completely obscures the underlying fabric",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.50.22",
      "rawHtsCode": "6210.50.22",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.50.2220",
      "rawHtsCode": "6210.50.22.20",
      "superior": null,
      "indent": "6",
      "description": "Trousers, breeches and shorts (748)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.2230",
      "rawHtsCode": "6210.50.22.30",
      "superior": null,
      "indent": "6",
      "description": "Overalls and coveralls (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.2240",
      "rawHtsCode": "6210.50.22.40",
      "superior": null,
      "indent": "6",
      "description": "Other (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.2260",
      "rawHtsCode": "6210.50.22.60",
      "superior": null,
      "indent": "6",
      "description": "Trousers, breeches and shorts (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.2270",
      "rawHtsCode": "6210.50.22.70",
      "superior": null,
      "indent": "6",
      "description": "Overalls and coveralls (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.2290",
      "rawHtsCode": "6210.50.22.90",
      "superior": null,
      "indent": "6",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.3500",
      "rawHtsCode": "6210.50.35.00",
      "superior": null,
      "indent": "4",
      "description": "Having an outer surface impregnated, coated, covered or laminated with rubber or plastics material which completely obscures the underlying fabric",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.50.55",
      "rawHtsCode": "6210.50.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.50.5531",
      "rawHtsCode": "6210.50.55.31",
      "superior": null,
      "indent": "6",
      "description": "Ski/snowboard pants (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.5539",
      "rawHtsCode": "6210.50.55.39",
      "superior": null,
      "indent": "6",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.5540",
      "rawHtsCode": "6210.50.55.40",
      "superior": null,
      "indent": "5",
      "description": "Overalls and coveralls (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.5555",
      "rawHtsCode": "6210.50.55.55",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.7500",
      "rawHtsCode": "6210.50.75.00",
      "superior": null,
      "indent": "4",
      "description": "Having an outer surface impregnated, coated, covered or laminated with rubber or plastics material which completely obscures the underlying fabric",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.50.80",
      "rawHtsCode": "6210.50.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6210.50.8020",
      "rawHtsCode": "6210.50.80.20",
      "superior": null,
      "indent": "6",
      "description": "Trousers, breeches and shorts (748)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.8030",
      "rawHtsCode": "6210.50.80.30",
      "superior": null,
      "indent": "6",
      "description": "Overalls and coveralls (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.8040",
      "rawHtsCode": "6210.50.80.40",
      "superior": null,
      "indent": "6",
      "description": "Other (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.8060",
      "rawHtsCode": "6210.50.80.60",
      "superior": null,
      "indent": "6",
      "description": "Trousers, breeches and shorts (348)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.8070",
      "rawHtsCode": "6210.50.80.70",
      "superior": null,
      "indent": "6",
      "description": "Overalls and coveralls (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6210.50.8090",
      "rawHtsCode": "6210.50.80.90",
      "superior": null,
      "indent": "6",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211",
      "rawHtsCode": "6211",
      "superior": null,
      "indent": "0",
      "description": "Track suits, ski-suits and swimwear; other garments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.11",
      "rawHtsCode": "6211.11",
      "superior": null,
      "indent": "2",
      "description": "Men's or boys':",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.11.10",
      "rawHtsCode": "6211.11.10",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "27.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.11.1010",
      "rawHtsCode": "6211.11.10.10",
      "superior": null,
      "indent": "4",
      "description": "Men's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.11.1020",
      "rawHtsCode": "6211.11.10.20",
      "superior": null,
      "indent": "4",
      "description": "Boys' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.11.4000",
      "rawHtsCode": "6211.11.40.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "4%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.11.80",
      "rawHtsCode": "6211.11.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.11.8010",
      "rawHtsCode": "6211.11.80.10",
      "superior": null,
      "indent": "5",
      "description": "Men's (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.11.8020",
      "rawHtsCode": "6211.11.80.20",
      "superior": null,
      "indent": "5",
      "description": "Boys' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.11.8040",
      "rawHtsCode": "6211.11.80.40",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.12",
      "rawHtsCode": "6211.12",
      "superior": null,
      "indent": "2",
      "description": "Women's or girls':",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.12.10",
      "rawHtsCode": "6211.12.10",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "11.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.12.1010",
      "rawHtsCode": "6211.12.10.10",
      "superior": null,
      "indent": "4",
      "description": "Women's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.12.1020",
      "rawHtsCode": "6211.12.10.20",
      "superior": null,
      "indent": "4",
      "description": "Girls' (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.12.4000",
      "rawHtsCode": "6211.12.40.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "1.2%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.12.80",
      "rawHtsCode": "6211.12.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.12.8010",
      "rawHtsCode": "6211.12.80.10",
      "superior": null,
      "indent": "5",
      "description": "Women's (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.12.8020",
      "rawHtsCode": "6211.12.80.20",
      "superior": null,
      "indent": "5",
      "description": "Girls' (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.12.8030",
      "rawHtsCode": "6211.12.80.30",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20",
      "rawHtsCode": "6211.20",
      "superior": null,
      "indent": "1",
      "description": "Ski-suits:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.04",
      "rawHtsCode": "6211.20.04",
      "superior": null,
      "indent": "3",
      "description": "Anoraks (including ski-jackets), windbreakers and similar articles (including padded, sleeveless   jackets) imported as parts of suits",
      "units": [],
      "generalRate": "0.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.0410",
      "rawHtsCode": "6211.20.04.10",
      "superior": null,
      "indent": "5",
      "description": "Of cotton (353)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.0420",
      "rawHtsCode": "6211.20.04.20",
      "superior": null,
      "indent": "5",
      "description": "Other (653)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.0430",
      "rawHtsCode": "6211.20.04.30",
      "superior": null,
      "indent": "5",
      "description": "Of cotton (354)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.0440",
      "rawHtsCode": "6211.20.04.40",
      "superior": null,
      "indent": "5",
      "description": "Other (654)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.08",
      "rawHtsCode": "6211.20.08",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.0810",
      "rawHtsCode": "6211.20.08.10",
      "superior": null,
      "indent": "4",
      "description": "Men's or boys'",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.0820",
      "rawHtsCode": "6211.20.08.20",
      "superior": null,
      "indent": "4",
      "description": "Women's or girls'",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.15",
      "rawHtsCode": "6211.20.15",
      "superior": null,
      "indent": "3",
      "description": "Water resistant",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.1510",
      "rawHtsCode": "6211.20.15.10",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.1515",
      "rawHtsCode": "6211.20.15.15",
      "superior": null,
      "indent": "6",
      "description": "Other (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.1520",
      "rawHtsCode": "6211.20.15.20",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.1525",
      "rawHtsCode": "6211.20.15.25",
      "superior": null,
      "indent": "6",
      "description": "Other (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.1530",
      "rawHtsCode": "6211.20.15.30",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.1535",
      "rawHtsCode": "6211.20.15.35",
      "superior": null,
      "indent": "6",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.1540",
      "rawHtsCode": "6211.20.15.40",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.1545",
      "rawHtsCode": "6211.20.15.45",
      "superior": null,
      "indent": "6",
      "description": "Other (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.1550",
      "rawHtsCode": "6211.20.15.50",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.1555",
      "rawHtsCode": "6211.20.15.55",
      "superior": null,
      "indent": "6",
      "description": "Other (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.1560",
      "rawHtsCode": "6211.20.15.60",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.1565",
      "rawHtsCode": "6211.20.15.65",
      "superior": null,
      "indent": "6",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.2400",
      "rawHtsCode": "6211.20.24.00",
      "superior": null,
      "indent": "6",
      "description": "Of wool or fine animal hair (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.28",
      "rawHtsCode": "6211.20.28",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "27.7%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.2810",
      "rawHtsCode": "6211.20.28.10",
      "superior": null,
      "indent": "7",
      "description": "Of cotton (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.2820",
      "rawHtsCode": "6211.20.28.20",
      "superior": null,
      "indent": "7",
      "description": "Of man-made fibers (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.2830",
      "rawHtsCode": "6211.20.28.30",
      "superior": null,
      "indent": "7",
      "description": "Other (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.3400",
      "rawHtsCode": "6211.20.34.00",
      "superior": null,
      "indent": "6",
      "description": "Of wool or fine animal hair (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.38",
      "rawHtsCode": "6211.20.38",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "28.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.3810",
      "rawHtsCode": "6211.20.38.10",
      "superior": null,
      "indent": "7",
      "description": "Of cotton (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.3820",
      "rawHtsCode": "6211.20.38.20",
      "superior": null,
      "indent": "7",
      "description": "Of man-made fibers (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.3830",
      "rawHtsCode": "6211.20.38.30",
      "superior": null,
      "indent": "7",
      "description": "Other (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.4400",
      "rawHtsCode": "6211.20.44.00",
      "superior": null,
      "indent": "6",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.48",
      "rawHtsCode": "6211.20.48",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.4815",
      "rawHtsCode": "6211.20.48.15",
      "superior": null,
      "indent": "7",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.4835",
      "rawHtsCode": "6211.20.48.35",
      "superior": null,
      "indent": "7",
      "description": "Of man-made fibers (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.4860",
      "rawHtsCode": "6211.20.48.60",
      "superior": null,
      "indent": "7",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.5400",
      "rawHtsCode": "6211.20.54.00",
      "superior": null,
      "indent": "6",
      "description": "Of wool or fine animal hair (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.58",
      "rawHtsCode": "6211.20.58",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "28%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.5810",
      "rawHtsCode": "6211.20.58.10",
      "superior": null,
      "indent": "7",
      "description": "Of cotton (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.5820",
      "rawHtsCode": "6211.20.58.20",
      "superior": null,
      "indent": "7",
      "description": "Of man-made fibers (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.5830",
      "rawHtsCode": "6211.20.58.30",
      "superior": null,
      "indent": "7",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.6400",
      "rawHtsCode": "6211.20.64.00",
      "superior": null,
      "indent": "6",
      "description": "Of wool or fine animal hair (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "17.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.68",
      "rawHtsCode": "6211.20.68",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "28.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.6810",
      "rawHtsCode": "6211.20.68.10",
      "superior": null,
      "indent": "7",
      "description": "Of cotton (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.6820",
      "rawHtsCode": "6211.20.68.20",
      "superior": null,
      "indent": "7",
      "description": "Of man-made fibers (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.6830",
      "rawHtsCode": "6211.20.68.30",
      "superior": null,
      "indent": "7",
      "description": "Other (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.7400",
      "rawHtsCode": "6211.20.74.00",
      "superior": null,
      "indent": "6",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.78",
      "rawHtsCode": "6211.20.78",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.20.7810",
      "rawHtsCode": "6211.20.78.10",
      "superior": null,
      "indent": "7",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.7820",
      "rawHtsCode": "6211.20.78.20",
      "superior": null,
      "indent": "7",
      "description": "Of man-made fibers (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.20.7830",
      "rawHtsCode": "6211.20.78.30",
      "superior": null,
      "indent": "7",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32",
      "rawHtsCode": "6211.32",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.50",
      "rawHtsCode": "6211.32.50",
      "superior": null,
      "indent": "3",
      "description": "Recreational performance outerwear",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.32.5003",
      "rawHtsCode": "6211.32.50.03",
      "superior": null,
      "indent": "5",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.5007",
      "rawHtsCode": "6211.32.50.07",
      "superior": null,
      "indent": "5",
      "description": "Other, insulated for cold weather protection (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.5010",
      "rawHtsCode": "6211.32.50.10",
      "superior": null,
      "indent": "6",
      "description": "Men's (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.5015",
      "rawHtsCode": "6211.32.50.15",
      "superior": null,
      "indent": "7",
      "description": "Sizes 2-7 (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.5025",
      "rawHtsCode": "6211.32.50.25",
      "superior": null,
      "indent": "7",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.5030",
      "rawHtsCode": "6211.32.50.30",
      "superior": null,
      "indent": "4",
      "description": "Washsuits, sunsuits, one-piece piece playsuits and similar apparel for boys (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.5040",
      "rawHtsCode": "6211.32.50.40",
      "superior": null,
      "indent": "5",
      "description": "Trousers (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.5050",
      "rawHtsCode": "6211.32.50.50",
      "superior": null,
      "indent": "5",
      "description": "Other (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.5060",
      "rawHtsCode": "6211.32.50.60",
      "superior": null,
      "indent": "4",
      "description": "Shirts excluded from heading 6205 (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.5070",
      "rawHtsCode": "6211.32.50.70",
      "superior": null,
      "indent": "4",
      "description": "Vests (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.5075",
      "rawHtsCode": "6211.32.50.75",
      "superior": null,
      "indent": "4",
      "description": "Jackets and jacket-type garments excluded from heading 6201 (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.5081",
      "rawHtsCode": "6211.32.50.81",
      "superior": null,
      "indent": "4",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.90",
      "rawHtsCode": "6211.32.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.32.9003",
      "rawHtsCode": "6211.32.90.03",
      "superior": null,
      "indent": "5",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.9007",
      "rawHtsCode": "6211.32.90.07",
      "superior": null,
      "indent": "5",
      "description": "Other, insulated for cold weather protection (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.9010",
      "rawHtsCode": "6211.32.90.10",
      "superior": null,
      "indent": "6",
      "description": "Men's (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.9015",
      "rawHtsCode": "6211.32.90.15",
      "superior": null,
      "indent": "7",
      "description": "Sizes 2-7 (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.9025",
      "rawHtsCode": "6211.32.90.25",
      "superior": null,
      "indent": "7",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.9030",
      "rawHtsCode": "6211.32.90.30",
      "superior": null,
      "indent": "4",
      "description": "Washsuits, sunsuits, one-piece piece playsuits and similar apparel for boys (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.9040",
      "rawHtsCode": "6211.32.90.40",
      "superior": null,
      "indent": "5",
      "description": "Trousers (347)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.9050",
      "rawHtsCode": "6211.32.90.50",
      "superior": null,
      "indent": "5",
      "description": "Other (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.9060",
      "rawHtsCode": "6211.32.90.60",
      "superior": null,
      "indent": "4",
      "description": "Shirts excluded from heading 6205 (340)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.9070",
      "rawHtsCode": "6211.32.90.70",
      "superior": null,
      "indent": "4",
      "description": "Vests (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.9075",
      "rawHtsCode": "6211.32.90.75",
      "superior": null,
      "indent": "4",
      "description": "Jackets and jacket-type garments excluded from heading 6201 (334)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.32.9081",
      "rawHtsCode": "6211.32.90.81",
      "superior": null,
      "indent": "4",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33",
      "rawHtsCode": "6211.33",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.50",
      "rawHtsCode": "6211.33.50",
      "superior": null,
      "indent": "3",
      "description": "Recreational performance outerwear",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.33.5003",
      "rawHtsCode": "6211.33.50.03",
      "superior": null,
      "indent": "5",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.5007",
      "rawHtsCode": "6211.33.50.07",
      "superior": null,
      "indent": "5",
      "description": "Other, insulated for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.5010",
      "rawHtsCode": "6211.33.50.10",
      "superior": null,
      "indent": "6",
      "description": "Men's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.5015",
      "rawHtsCode": "6211.33.50.15",
      "superior": null,
      "indent": "7",
      "description": "Sizes 2-7 (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.5017",
      "rawHtsCode": "6211.33.50.17",
      "superior": null,
      "indent": "7",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.5025",
      "rawHtsCode": "6211.33.50.25",
      "superior": null,
      "indent": "4",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel for boys (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.5030",
      "rawHtsCode": "6211.33.50.30",
      "superior": null,
      "indent": "5",
      "description": "Trousers (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.5035",
      "rawHtsCode": "6211.33.50.35",
      "superior": null,
      "indent": "5",
      "description": "Other (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.5040",
      "rawHtsCode": "6211.33.50.40",
      "superior": null,
      "indent": "4",
      "description": "Shirts excluded from heading 6205 (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.5052",
      "rawHtsCode": "6211.33.50.52",
      "superior": null,
      "indent": "5",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.5054",
      "rawHtsCode": "6211.33.50.54",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.5058",
      "rawHtsCode": "6211.33.50.58",
      "superior": null,
      "indent": "4",
      "description": "Jackets and jacket-type garments excluded from heading 6201 (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.5061",
      "rawHtsCode": "6211.33.50.61",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.90",
      "rawHtsCode": "6211.33.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.33.9003",
      "rawHtsCode": "6211.33.90.03",
      "superior": null,
      "indent": "5",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more by weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9007",
      "rawHtsCode": "6211.33.90.07",
      "superior": null,
      "indent": "5",
      "description": "Other, insulated for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9010",
      "rawHtsCode": "6211.33.90.10",
      "superior": null,
      "indent": "6",
      "description": "Men's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9015",
      "rawHtsCode": "6211.33.90.15",
      "superior": null,
      "indent": "7",
      "description": "Sizes 2-7 (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9017",
      "rawHtsCode": "6211.33.90.17",
      "superior": null,
      "indent": "7",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9025",
      "rawHtsCode": "6211.33.90.25",
      "superior": null,
      "indent": "4",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel for boys (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9030",
      "rawHtsCode": "6211.33.90.30",
      "superior": null,
      "indent": "5",
      "description": "Trousers (647)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9035",
      "rawHtsCode": "6211.33.90.35",
      "superior": null,
      "indent": "5",
      "description": "Other (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9042",
      "rawHtsCode": "6211.33.90.42",
      "superior": null,
      "indent": "5",
      "description": "Designed for use in hospitals, clinics, laboratories or contaminated areas (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9044",
      "rawHtsCode": "6211.33.90.44",
      "superior": null,
      "indent": "5",
      "description": "Other (640)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9052",
      "rawHtsCode": "6211.33.90.52",
      "superior": null,
      "indent": "5",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9054",
      "rawHtsCode": "6211.33.90.54",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9058",
      "rawHtsCode": "6211.33.90.58",
      "superior": null,
      "indent": "4",
      "description": "Jackets and jacket-type garments excluded from heading 6201 (634)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.33.9061",
      "rawHtsCode": "6211.33.90.61",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39",
      "rawHtsCode": "6211.39",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.03",
      "rawHtsCode": "6211.39.03",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.39.0310",
      "rawHtsCode": "6211.39.03.10",
      "superior": null,
      "indent": "6",
      "description": "Trousers (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.0320",
      "rawHtsCode": "6211.39.03.20",
      "superior": null,
      "indent": "6",
      "description": "Other (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.0330",
      "rawHtsCode": "6211.39.03.30",
      "superior": null,
      "indent": "5",
      "description": "Shirts excluded from heading 6205 (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.0340",
      "rawHtsCode": "6211.39.03.40",
      "superior": null,
      "indent": "5",
      "description": "Vests (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.0345",
      "rawHtsCode": "6211.39.03.45",
      "superior": null,
      "indent": "5",
      "description": "Jackets and jacket-type garments excluded from heading 6201 (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.0351",
      "rawHtsCode": "6211.39.03.51",
      "superior": null,
      "indent": "5",
      "description": "Other (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.07",
      "rawHtsCode": "6211.39.07",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "0.5%",
      "specialRate": "Free (AU, BH, CL, CO, E, IL, JO, KR, MA, OM, P, PA, PE, S, SG) ",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.39.0710",
      "rawHtsCode": "6211.39.07.10",
      "superior": null,
      "indent": "5",
      "description": "Coveralls, jumpsuits and similar apparel (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.0720",
      "rawHtsCode": "6211.39.07.20",
      "superior": null,
      "indent": "5",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.0730",
      "rawHtsCode": "6211.39.07.30",
      "superior": null,
      "indent": "6",
      "description": "Trousers (747)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.0740",
      "rawHtsCode": "6211.39.07.40",
      "superior": null,
      "indent": "6",
      "description": "Other (734)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.0750",
      "rawHtsCode": "6211.39.07.50",
      "superior": null,
      "indent": "5",
      "description": "Shirts excluded from heading 6205 (740)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.0760",
      "rawHtsCode": "6211.39.07.60",
      "superior": null,
      "indent": "5",
      "description": "Vests (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.0770",
      "rawHtsCode": "6211.39.07.70",
      "superior": null,
      "indent": "5",
      "description": "Jackets and jacket-type garments excluded from heading 6201 (734)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.0790",
      "rawHtsCode": "6211.39.07.90",
      "superior": null,
      "indent": "5",
      "description": "Other (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.15",
      "rawHtsCode": "6211.39.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (AU, BH, CL, CO, E*, IL, JO, KR, MA, OM, P, PE, S, SG) ",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.39.1510",
      "rawHtsCode": "6211.39.15.10",
      "superior": null,
      "indent": "5",
      "description": "Coveralls, jumpsuits and similar apparel (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.1520",
      "rawHtsCode": "6211.39.15.20",
      "superior": null,
      "indent": "5",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.1530",
      "rawHtsCode": "6211.39.15.30",
      "superior": null,
      "indent": "6",
      "description": "Trousers (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.1540",
      "rawHtsCode": "6211.39.15.40",
      "superior": null,
      "indent": "6",
      "description": "Other (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.1550",
      "rawHtsCode": "6211.39.15.50",
      "superior": null,
      "indent": "5",
      "description": "Shirts excluded from heading 6205 (840)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.1560",
      "rawHtsCode": "6211.39.15.60",
      "superior": null,
      "indent": "5",
      "description": "Vests (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.1570",
      "rawHtsCode": "6211.39.15.70",
      "superior": null,
      "indent": "5",
      "description": "Jackets and jacket-type garments excluded from heading 6201 (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.1590",
      "rawHtsCode": "6211.39.15.90",
      "superior": null,
      "indent": "5",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.30",
      "rawHtsCode": "6211.39.30",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.39.3010",
      "rawHtsCode": "6211.39.30.10",
      "superior": null,
      "indent": "6",
      "description": "Trousers (447)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.3020",
      "rawHtsCode": "6211.39.30.20",
      "superior": null,
      "indent": "6",
      "description": "Other (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.3030",
      "rawHtsCode": "6211.39.30.30",
      "superior": null,
      "indent": "5",
      "description": "Shirts excluded from heading 6205 (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.3040",
      "rawHtsCode": "6211.39.30.40",
      "superior": null,
      "indent": "5",
      "description": "Vests (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.3045",
      "rawHtsCode": "6211.39.30.45",
      "superior": null,
      "indent": "5",
      "description": "Jackets and jacket-type garments excluded from heading 6201 (434)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.3051",
      "rawHtsCode": "6211.39.30.51",
      "superior": null,
      "indent": "5",
      "description": "Other (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.60",
      "rawHtsCode": "6211.39.60",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "0.5%",
      "specialRate": "Free (AU, BH, CL, CO, E, IL, JO, KR, MA, OM, P, PA, PE, S, SG) ",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.39.6010",
      "rawHtsCode": "6211.39.60.10",
      "superior": null,
      "indent": "5",
      "description": "Coveralls, jumpsuits and similar apparel (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.6020",
      "rawHtsCode": "6211.39.60.20",
      "superior": null,
      "indent": "5",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.6030",
      "rawHtsCode": "6211.39.60.30",
      "superior": null,
      "indent": "6",
      "description": "Trousers (747)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.6040",
      "rawHtsCode": "6211.39.60.40",
      "superior": null,
      "indent": "6",
      "description": "Other (734)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.6050",
      "rawHtsCode": "6211.39.60.50",
      "superior": null,
      "indent": "5",
      "description": "Shirts excluded from heading 6205 (740)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.6060",
      "rawHtsCode": "6211.39.60.60",
      "superior": null,
      "indent": "5",
      "description": "Vests (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.6070",
      "rawHtsCode": "6211.39.60.70",
      "superior": null,
      "indent": "5",
      "description": "Jackets and jacket-type garments excluded from heading 6201 (734)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.6090",
      "rawHtsCode": "6211.39.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.80",
      "rawHtsCode": "6211.39.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (AU, BH, CL, CO, E*, IL, JO, KR, MA, OM, P, PE, S, SG) ",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.39.8010",
      "rawHtsCode": "6211.39.80.10",
      "superior": null,
      "indent": "5",
      "description": "Coveralls, jumpsuits and similar apparel (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.8020",
      "rawHtsCode": "6211.39.80.20",
      "superior": null,
      "indent": "5",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.8030",
      "rawHtsCode": "6211.39.80.30",
      "superior": null,
      "indent": "6",
      "description": "Trousers (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.8040",
      "rawHtsCode": "6211.39.80.40",
      "superior": null,
      "indent": "6",
      "description": "Other (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.8050",
      "rawHtsCode": "6211.39.80.50",
      "superior": null,
      "indent": "5",
      "description": "Shirts excluded from heading 6205 (840)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.8060",
      "rawHtsCode": "6211.39.80.60",
      "superior": null,
      "indent": "5",
      "description": "Vests (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.8070",
      "rawHtsCode": "6211.39.80.70",
      "superior": null,
      "indent": "5",
      "description": "Jackets and jacket-type garments excluded from heading 6201 (834)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.39.8090",
      "rawHtsCode": "6211.39.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42",
      "rawHtsCode": "6211.42",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.05",
      "rawHtsCode": "6211.42.05",
      "superior": null,
      "indent": "3",
      "description": "Recreational performance outerwear",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG) ",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.42.0503",
      "rawHtsCode": "6211.42.05.03",
      "superior": null,
      "indent": "5",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.0507",
      "rawHtsCode": "6211.42.05.07",
      "superior": null,
      "indent": "5",
      "description": "Other, insulated for cold weather protection (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.0510",
      "rawHtsCode": "6211.42.05.10",
      "superior": null,
      "indent": "6",
      "description": "Women's (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.0520",
      "rawHtsCode": "6211.42.05.20",
      "superior": null,
      "indent": "6",
      "description": "Girls' (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.0525",
      "rawHtsCode": "6211.42.05.25",
      "superior": null,
      "indent": "4",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.0530",
      "rawHtsCode": "6211.42.05.30",
      "superior": null,
      "indent": "5",
      "description": "Trousers (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.0540",
      "rawHtsCode": "6211.42.05.40",
      "superior": null,
      "indent": "5",
      "description": "Other (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.0554",
      "rawHtsCode": "6211.42.05.54",
      "superior": null,
      "indent": "5",
      "description": "With two or more colors in the warp and/or filling (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.0556",
      "rawHtsCode": "6211.42.05.56",
      "superior": null,
      "indent": "5",
      "description": "Other (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.0560",
      "rawHtsCode": "6211.42.05.60",
      "superior": null,
      "indent": "4",
      "description": "Jumpers (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.0570",
      "rawHtsCode": "6211.42.05.70",
      "superior": null,
      "indent": "4",
      "description": "Vests (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.0575",
      "rawHtsCode": "6211.42.05.75",
      "superior": null,
      "indent": "4",
      "description": "Jackets and jacket-type garments excluded from heading 6202 (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.0581",
      "rawHtsCode": "6211.42.05.81",
      "superior": null,
      "indent": "4",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.10",
      "rawHtsCode": "6211.42.10",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG) ",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.42.1003",
      "rawHtsCode": "6211.42.10.03",
      "superior": null,
      "indent": "5",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1007",
      "rawHtsCode": "6211.42.10.07",
      "superior": null,
      "indent": "5",
      "description": "Other, insulated for cold weather protection (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1010",
      "rawHtsCode": "6211.42.10.10",
      "superior": null,
      "indent": "6",
      "description": "Women's (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1020",
      "rawHtsCode": "6211.42.10.20",
      "superior": null,
      "indent": "6",
      "description": "Girls' (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1025",
      "rawHtsCode": "6211.42.10.25",
      "superior": null,
      "indent": "4",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1030",
      "rawHtsCode": "6211.42.10.30",
      "superior": null,
      "indent": "5",
      "description": "Trousers (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1040",
      "rawHtsCode": "6211.42.10.40",
      "superior": null,
      "indent": "5",
      "description": "Other (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1054",
      "rawHtsCode": "6211.42.10.54",
      "superior": null,
      "indent": "5",
      "description": "With two or more colors in the warp and/or filling (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1056",
      "rawHtsCode": "6211.42.10.56",
      "superior": null,
      "indent": "5",
      "description": "Other (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1060",
      "rawHtsCode": "6211.42.10.60",
      "superior": null,
      "indent": "4",
      "description": "Jumpers (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1070",
      "rawHtsCode": "6211.42.10.70",
      "superior": null,
      "indent": "4",
      "description": "Vests (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1075",
      "rawHtsCode": "6211.42.10.75",
      "superior": null,
      "indent": "4",
      "description": "Jackets and jacket-type garments excluded from heading 6202 (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1082",
      "rawHtsCode": "6211.42.10.82",
      "superior": null,
      "indent": "5",
      "description": "Surgical or isolation gowns (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1088",
      "rawHtsCode": "6211.42.10.88",
      "superior": null,
      "indent": "5",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.42.1092",
      "rawHtsCode": "6211.42.10.92",
      "superior": null,
      "indent": "4",
      "description": "Other (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43",
      "rawHtsCode": "6211.43",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.05",
      "rawHtsCode": "6211.43.05",
      "superior": null,
      "indent": "3",
      "description": "Recreational performance outerwear",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.43.0503",
      "rawHtsCode": "6211.43.05.03",
      "superior": null,
      "indent": "5",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0507",
      "rawHtsCode": "6211.43.05.07",
      "superior": null,
      "indent": "5",
      "description": "Other, insulated for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0510",
      "rawHtsCode": "6211.43.05.10",
      "superior": null,
      "indent": "6",
      "description": "Women's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0520",
      "rawHtsCode": "6211.43.05.20",
      "superior": null,
      "indent": "6",
      "description": "Girls' (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0530",
      "rawHtsCode": "6211.43.05.30",
      "superior": null,
      "indent": "4",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0540",
      "rawHtsCode": "6211.43.05.40",
      "superior": null,
      "indent": "5",
      "description": "Trousers (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0550",
      "rawHtsCode": "6211.43.05.50",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0560",
      "rawHtsCode": "6211.43.05.60",
      "superior": null,
      "indent": "4",
      "description": "Blouses, shirts and shirt-blouses, sleeveless tank styles and similar upper body garments, excluded from heading 6206 (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0564",
      "rawHtsCode": "6211.43.05.64",
      "superior": null,
      "indent": "5",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0566",
      "rawHtsCode": "6211.43.05.66",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0574",
      "rawHtsCode": "6211.43.05.74",
      "superior": null,
      "indent": "5",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0576",
      "rawHtsCode": "6211.43.05.76",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0578",
      "rawHtsCode": "6211.43.05.78",
      "superior": null,
      "indent": "4",
      "description": "Jackets and jacket-type garments excluded from heading 6202 (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.0591",
      "rawHtsCode": "6211.43.05.91",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.10",
      "rawHtsCode": "6211.43.10",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.43.1003",
      "rawHtsCode": "6211.43.10.03",
      "superior": null,
      "indent": "5",
      "description": "Containing 15 percent or more by weight of down and waterfowl plumage and of which down comprises 35 percent or more weight; containing 10 percent or more by weight of down",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1007",
      "rawHtsCode": "6211.43.10.07",
      "superior": null,
      "indent": "5",
      "description": "Other, insulated for cold weather protection (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1010",
      "rawHtsCode": "6211.43.10.10",
      "superior": null,
      "indent": "6",
      "description": "Women's (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1020",
      "rawHtsCode": "6211.43.10.20",
      "superior": null,
      "indent": "6",
      "description": "Girls' (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1030",
      "rawHtsCode": "6211.43.10.30",
      "superior": null,
      "indent": "4",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel (237)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1040",
      "rawHtsCode": "6211.43.10.40",
      "superior": null,
      "indent": "5",
      "description": "Trousers (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1050",
      "rawHtsCode": "6211.43.10.50",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1059",
      "rawHtsCode": "6211.43.10.59",
      "superior": null,
      "indent": "5",
      "description": "Designed for use in hospitals, clinics, laboratories or contaminated areas (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1062",
      "rawHtsCode": "6211.43.10.62",
      "superior": null,
      "indent": "5",
      "description": "Other (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1064",
      "rawHtsCode": "6211.43.10.64",
      "superior": null,
      "indent": "5",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1066",
      "rawHtsCode": "6211.43.10.66",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1074",
      "rawHtsCode": "6211.43.10.74",
      "superior": null,
      "indent": "5",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1076",
      "rawHtsCode": "6211.43.10.76",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1078",
      "rawHtsCode": "6211.43.10.78",
      "superior": null,
      "indent": "4",
      "description": "Jackets and jacket-type garments excluded from heading 6202 (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1082",
      "rawHtsCode": "6211.43.10.82",
      "superior": null,
      "indent": "5",
      "description": "Surgical or isolation gowns (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1088",
      "rawHtsCode": "6211.43.10.88",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.43.1092",
      "rawHtsCode": "6211.43.10.92",
      "superior": null,
      "indent": "4",
      "description": "Other (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49",
      "rawHtsCode": "6211.49",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.03",
      "rawHtsCode": "6211.49.03",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "1.2%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) ",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.49.0310",
      "rawHtsCode": "6211.49.03.10",
      "superior": null,
      "indent": "5",
      "description": "Coveralls, jumpsuits and similar apparel:",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.0320",
      "rawHtsCode": "6211.49.03.20",
      "superior": null,
      "indent": "5",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.0330",
      "rawHtsCode": "6211.49.03.30",
      "superior": null,
      "indent": "6",
      "description": "Trousers (748)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.0340",
      "rawHtsCode": "6211.49.03.40",
      "superior": null,
      "indent": "6",
      "description": "Other (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.0350",
      "rawHtsCode": "6211.49.03.50",
      "superior": null,
      "indent": "5",
      "description": "Blouses, shirts and shirt-blouses, sleeveless tank styles and similar upper body garments, excluded from heading 6206",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.0360",
      "rawHtsCode": "6211.49.03.60",
      "superior": null,
      "indent": "5",
      "description": "Jumpers (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.0370",
      "rawHtsCode": "6211.49.03.70",
      "superior": null,
      "indent": "5",
      "description": "Vests (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.0380",
      "rawHtsCode": "6211.49.03.80",
      "superior": null,
      "indent": "5",
      "description": "Jackets and jacket-type garments excluded from heading 6202 (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.0390",
      "rawHtsCode": "6211.49.03.90",
      "superior": null,
      "indent": "5",
      "description": "Other (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.15",
      "rawHtsCode": "6211.49.15",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.49.1510",
      "rawHtsCode": "6211.49.15.10",
      "superior": null,
      "indent": "6",
      "description": "Trousers (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.1520",
      "rawHtsCode": "6211.49.15.20",
      "superior": null,
      "indent": "6",
      "description": "Other (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.1530",
      "rawHtsCode": "6211.49.15.30",
      "superior": null,
      "indent": "5",
      "description": "Blouses, shirts and shirt-blouses, sleeveless tank styles and similar upper body garments, excluded from heading 6206 (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.1540",
      "rawHtsCode": "6211.49.15.40",
      "superior": null,
      "indent": "5",
      "description": "Jumpers (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.1550",
      "rawHtsCode": "6211.49.15.50",
      "superior": null,
      "indent": "5",
      "description": "Vests (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.1555",
      "rawHtsCode": "6211.49.15.55",
      "superior": null,
      "indent": "5",
      "description": "Jackets and jacket-type garments excluded from heading 6202 (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.1561",
      "rawHtsCode": "6211.49.15.61",
      "superior": null,
      "indent": "5",
      "description": "Other (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.25",
      "rawHtsCode": "6211.49.25",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) ",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.49.2510",
      "rawHtsCode": "6211.49.25.10",
      "superior": null,
      "indent": "5",
      "description": "Coveralls, jumpsuits and similar apparel (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.2520",
      "rawHtsCode": "6211.49.25.20",
      "superior": null,
      "indent": "5",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.2530",
      "rawHtsCode": "6211.49.25.30",
      "superior": null,
      "indent": "6",
      "description": "Trousers (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.2540",
      "rawHtsCode": "6211.49.25.40",
      "superior": null,
      "indent": "6",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.2550",
      "rawHtsCode": "6211.49.25.50",
      "superior": null,
      "indent": "5",
      "description": "Blouses, shirts and shirt-blouses, sleeveless tank styles and similar upper body garments, excluded from heading 6206 (840)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.2560",
      "rawHtsCode": "6211.49.25.60",
      "superior": null,
      "indent": "5",
      "description": "Jumpers (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.2570",
      "rawHtsCode": "6211.49.25.70",
      "superior": null,
      "indent": "5",
      "description": "Vests (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.2580",
      "rawHtsCode": "6211.49.25.80",
      "superior": null,
      "indent": "5",
      "description": "Jackets and jacket-type garments excluded from heading 6202 (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.2590",
      "rawHtsCode": "6211.49.25.90",
      "superior": null,
      "indent": "5",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.50",
      "rawHtsCode": "6211.49.50",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "1.2%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.49.5010",
      "rawHtsCode": "6211.49.50.10",
      "superior": null,
      "indent": "5",
      "description": "Coveralls, jumpsuits and similar apparel:",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.5020",
      "rawHtsCode": "6211.49.50.20",
      "superior": null,
      "indent": "5",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.5030",
      "rawHtsCode": "6211.49.50.30",
      "superior": null,
      "indent": "6",
      "description": "Trousers (748)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.5040",
      "rawHtsCode": "6211.49.50.40",
      "superior": null,
      "indent": "6",
      "description": "Other (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.5050",
      "rawHtsCode": "6211.49.50.50",
      "superior": null,
      "indent": "5",
      "description": "Blouses, shirts and shirt-blouses, sleeveless tank styles and similar upper body garments, excluded from heading 6206",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.5060",
      "rawHtsCode": "6211.49.50.60",
      "superior": null,
      "indent": "5",
      "description": "Jumpers (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.5070",
      "rawHtsCode": "6211.49.50.70",
      "superior": null,
      "indent": "5",
      "description": "Vests (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.5080",
      "rawHtsCode": "6211.49.50.80",
      "superior": null,
      "indent": "5",
      "description": "Jackets and jacket-type garments excluded from heading 6202 (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.5090",
      "rawHtsCode": "6211.49.50.90",
      "superior": null,
      "indent": "5",
      "description": "Other (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.60",
      "rawHtsCode": "6211.49.60",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair",
      "units": [],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "58.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.49.6010",
      "rawHtsCode": "6211.49.60.10",
      "superior": null,
      "indent": "6",
      "description": "Trousers (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.6020",
      "rawHtsCode": "6211.49.60.20",
      "superior": null,
      "indent": "6",
      "description": "Other (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.6030",
      "rawHtsCode": "6211.49.60.30",
      "superior": null,
      "indent": "5",
      "description": "Blouses, shirts and shirt-blouses, sleeveless tank styles and similar upper body garments, excluded from heading 6206 (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.6040",
      "rawHtsCode": "6211.49.60.40",
      "superior": null,
      "indent": "5",
      "description": "Jumpers (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.6050",
      "rawHtsCode": "6211.49.60.50",
      "superior": null,
      "indent": "5",
      "description": "Vests (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.6055",
      "rawHtsCode": "6211.49.60.55",
      "superior": null,
      "indent": "5",
      "description": "Jackets and jacket-type garments excluded from heading 6202 (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.6061",
      "rawHtsCode": "6211.49.60.61",
      "superior": null,
      "indent": "5",
      "description": "Other (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.80",
      "rawHtsCode": "6211.49.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6211.49.8010",
      "rawHtsCode": "6211.49.80.10",
      "superior": null,
      "indent": "5",
      "description": "Coveralls, jumpsuits and similar apparel (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.8020",
      "rawHtsCode": "6211.49.80.20",
      "superior": null,
      "indent": "5",
      "description": "Washsuits, sunsuits, one-piece playsuits and similar apparel (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.8030",
      "rawHtsCode": "6211.49.80.30",
      "superior": null,
      "indent": "6",
      "description": "Trousers (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.8040",
      "rawHtsCode": "6211.49.80.40",
      "superior": null,
      "indent": "6",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.8050",
      "rawHtsCode": "6211.49.80.50",
      "superior": null,
      "indent": "5",
      "description": "Blouses, shirts and shirt-blouses, sleeveless tank styles and similar upper body garments, excluded from heading 6206 (840)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.8060",
      "rawHtsCode": "6211.49.80.60",
      "superior": null,
      "indent": "5",
      "description": "Jumpers (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.8070",
      "rawHtsCode": "6211.49.80.70",
      "superior": null,
      "indent": "5",
      "description": "Vests (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.8080",
      "rawHtsCode": "6211.49.80.80",
      "superior": null,
      "indent": "5",
      "description": "Jackets and jacket-type garments excluded from heading 6202 (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6211.49.8090",
      "rawHtsCode": "6211.49.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212",
      "rawHtsCode": "6212",
      "superior": null,
      "indent": "0",
      "description": "Brassieres, girdles, corsets, braces, suspenders, garters and similar articles and parts thereof,   whether or not knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.10",
      "rawHtsCode": "6212.10",
      "superior": null,
      "indent": "1",
      "description": "Brassieres:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.10.3000",
      "rawHtsCode": "6212.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6212.10.50",
      "rawHtsCode": "6212.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "16.9%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6212.10.5010",
      "rawHtsCode": "6212.10.50.10",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (349)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.10.5020",
      "rawHtsCode": "6212.10.50.20",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (649)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.10.5030",
      "rawHtsCode": "6212.10.50.30",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.10.7000",
      "rawHtsCode": "6212.10.70.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6212.10.90",
      "rawHtsCode": "6212.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "16.9%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6212.10.9010",
      "rawHtsCode": "6212.10.90.10",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (349)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.10.9020",
      "rawHtsCode": "6212.10.90.20",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (649)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.10.9040",
      "rawHtsCode": "6212.10.90.40",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.20.00",
      "rawHtsCode": "6212.20.00",
      "superior": null,
      "indent": "1",
      "description": "Girdles and panty-girdles",
      "units": [],
      "generalRate": "20%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6212.20.0010",
      "rawHtsCode": "6212.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (349)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.20.0020",
      "rawHtsCode": "6212.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (649)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.20.0030",
      "rawHtsCode": "6212.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.30.00",
      "rawHtsCode": "6212.30.00",
      "superior": null,
      "indent": "1",
      "description": "Corsets",
      "units": [],
      "generalRate": "23.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6212.30.0010",
      "rawHtsCode": "6212.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (349)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.30.0020",
      "rawHtsCode": "6212.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (649)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.30.0030",
      "rawHtsCode": "6212.30.00.30",
      "superior": null,
      "indent": "2",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.90.00",
      "rawHtsCode": "6212.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "6.6%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "83.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6212.90.0010",
      "rawHtsCode": "6212.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of cotton or cotton and rubber or plastics (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.90.0020",
      "rawHtsCode": "6212.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Of wool or wool and rubber or plastics (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.90.0030",
      "rawHtsCode": "6212.90.00.30",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers or man-made fibers and rubber or plastics (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.90.0050",
      "rawHtsCode": "6212.90.00.50",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6212.90.0090",
      "rawHtsCode": "6212.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6213",
      "rawHtsCode": "6213",
      "superior": null,
      "indent": "0",
      "description": "Handkerchiefs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6213.20",
      "rawHtsCode": "6213.20",
      "superior": null,
      "indent": "1",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6213.20.1000",
      "rawHtsCode": "6213.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Hemmed, not containing lace or embroidery (330)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "58%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6213.20.2000",
      "rawHtsCode": "6213.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other (330)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "7.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6213.90",
      "rawHtsCode": "6213.90",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6213.90.0500",
      "rawHtsCode": "6213.90.05.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6213.90.0700",
      "rawHtsCode": "6213.90.07.00",
      "superior": null,
      "indent": "3",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6213.90.1000",
      "rawHtsCode": "6213.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (630)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "10.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "68.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6213.90.2000",
      "rawHtsCode": "6213.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6214",
      "rawHtsCode": "6214",
      "superior": null,
      "indent": "0",
      "description": "Shawls, scarves, mufflers, mantillas, veils and the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6214.10",
      "rawHtsCode": "6214.10",
      "superior": null,
      "indent": "1",
      "description": "Of silk or silk waste:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6214.10.1000",
      "rawHtsCode": "6214.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "1.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6214.10.2000",
      "rawHtsCode": "6214.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,NP,OM, P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6214.20.0000",
      "rawHtsCode": "6214.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "6.7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6214.30.0000",
      "rawHtsCode": "6214.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of synthetic fibers (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6214.40.0000",
      "rawHtsCode": "6214.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of artificial fibers (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6214.90.00",
      "rawHtsCode": "6214.90.00",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials",
      "units": [],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,NP,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6214.90.0010",
      "rawHtsCode": "6214.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6214.90.0090",
      "rawHtsCode": "6214.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6215",
      "rawHtsCode": "6215",
      "superior": null,
      "indent": "0",
      "description": "Ties, bow ties and cravats:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6215.10.00",
      "rawHtsCode": "6215.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of silk or silk waste",
      "units": [],
      "generalRate": "7.2%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6215.10.0025",
      "rawHtsCode": "6215.10.00.25",
      "superior": null,
      "indent": "2",
      "description": "Containing 50 percent or more by weight (including any linings and interlinings) of textile materials   other than silk or silk waste (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6215.10.0040",
      "rawHtsCode": "6215.10.00.40",
      "superior": null,
      "indent": "3",
      "description": "With outer shell containing 70 percent or more by weight of silk or silk waste (758)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6215.10.0090",
      "rawHtsCode": "6215.10.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (858)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6215.20.0000",
      "rawHtsCode": "6215.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of man-made fibers (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "24.8¢/kg + 12.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "26.5¢/kg +65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6215.90.00",
      "rawHtsCode": "6215.90.00",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6215.90.0010",
      "rawHtsCode": "6215.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6215.90.0015",
      "rawHtsCode": "6215.90.00.15",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6215.90.0020",
      "rawHtsCode": "6215.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Other (858)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00",
      "rawHtsCode": "6216.00",
      "superior": null,
      "indent": "0",
      "description": "Gloves, mittens and mitts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.0500",
      "rawHtsCode": "6216.00.05.00",
      "superior": null,
      "indent": "2",
      "description": "Ice hockey gloves and field hockey gloves",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6216.00.0800",
      "rawHtsCode": "6216.00.08.00",
      "superior": null,
      "indent": "2",
      "description": "Other gloves, mittens and mitts, all the foregoing specially designed for use in sports, including   ski and snowmobile gloves, mittens and mitts",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "0.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.1300",
      "rawHtsCode": "6216.00.13.00",
      "superior": null,
      "indent": "6",
      "description": "Containing over 50 percent by weight of plastics or rubber",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.17",
      "rawHtsCode": "6216.00.17",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "23.5%",
      "specialRate": "Free (AU,BH, CL,CO, IL,JO,KR, MA,OM,P, PA,PE,S,SG) 22.5% (E)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.1720",
      "rawHtsCode": "6216.00.17.20",
      "superior": null,
      "indent": "7",
      "description": "Subject to cotton restraints (331)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.1730",
      "rawHtsCode": "6216.00.17.30",
      "superior": null,
      "indent": "7",
      "description": "Subject to man-made fiber restraints (631)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.1740",
      "rawHtsCode": "6216.00.17.40",
      "superior": null,
      "indent": "7",
      "description": "Other (831)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.1900",
      "rawHtsCode": "6216.00.19.00",
      "superior": null,
      "indent": "6",
      "description": "Containing over 50 percent by weight of plastics or rubber",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "11.1¢/kg + 5.5%",
      "specialRate": "Free (AU,BH, CL,CO, IL,JO,KR, MA,OM,P, PA,PE,S,SG) 11.1¢/kg + 4.5% (E)",
      "otherRate": "99.2¢/kg + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.21",
      "rawHtsCode": "6216.00.21",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "20.6¢/kg + 10.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG) 20.6¢/kg + 8.1% (E)",
      "otherRate": "99.2¢/kg + 65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.2110",
      "rawHtsCode": "6216.00.21.10",
      "superior": null,
      "indent": "7",
      "description": "Subject to cotton restraints (331)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.2120",
      "rawHtsCode": "6216.00.21.20",
      "superior": null,
      "indent": "7",
      "description": "Subject to man-made fiber restraints (631)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.2130",
      "rawHtsCode": "6216.00.21.30",
      "superior": null,
      "indent": "7",
      "description": "Other (831)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.24",
      "rawHtsCode": "6216.00.24",
      "superior": null,
      "indent": "5",
      "description": "Containing 50 per cent or more by weight of cotton, man-made fibers or any combination thereof",
      "units": [],
      "generalRate": "13.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG) 10.7% (E)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.2410",
      "rawHtsCode": "6216.00.24.10",
      "superior": null,
      "indent": "6",
      "description": "Subject to cotton restraints (331)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.2425",
      "rawHtsCode": "6216.00.24.25",
      "superior": null,
      "indent": "6",
      "description": "Subject to man-made fiber restraints (631)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.2430",
      "rawHtsCode": "6216.00.24.30",
      "superior": null,
      "indent": "6",
      "description": "Other (831)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.2600",
      "rawHtsCode": "6216.00.26.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM,P, PA,PE,S,SG) 6% (E)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.29",
      "rawHtsCode": "6216.00.29",
      "superior": null,
      "indent": "4",
      "description": "Containing 50 percent or more by weight of cotton, man-made fibers or any combi- nation thereof",
      "units": [],
      "generalRate": "13%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.2910",
      "rawHtsCode": "6216.00.29.10",
      "superior": null,
      "indent": "5",
      "description": "Subject to cotton restraints (331)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.2925",
      "rawHtsCode": "6216.00.29.25",
      "superior": null,
      "indent": "5",
      "description": "Subject to man-made fiber restraints (631)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.2930",
      "rawHtsCode": "6216.00.29.30",
      "superior": null,
      "indent": "5",
      "description": "Other (831)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.3100",
      "rawHtsCode": "6216.00.31.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.3300",
      "rawHtsCode": "6216.00.33.00",
      "superior": null,
      "indent": "3",
      "description": "Ice hockey and field hockey gloves",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6216.00.3500",
      "rawHtsCode": "6216.00.35.00",
      "superior": null,
      "indent": "3",
      "description": "Other gloves, mittens and mitts, all the fore- going specially designed for use in sports, including   ski and snowmobile gloves, mittens and mitts",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.3800",
      "rawHtsCode": "6216.00.38.00",
      "superior": null,
      "indent": "4",
      "description": "Without fourchettes (331)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "23.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG) 22.5% (E)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.4100",
      "rawHtsCode": "6216.00.41.00",
      "superior": null,
      "indent": "4",
      "description": "With fourchettes (331)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "23.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.4300",
      "rawHtsCode": "6216.00.43.00",
      "superior": null,
      "indent": "3",
      "description": "Ice hockey and field hockey gloves",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6216.00.4600",
      "rawHtsCode": "6216.00.46.00",
      "superior": null,
      "indent": "3",
      "description": "Other gloves, mittens and mitts, all the fore- going specially designed for use in sports, including   ski and snowmobile gloves, mittens and mitts",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.54",
      "rawHtsCode": "6216.00.54",
      "superior": null,
      "indent": "4",
      "description": "Without fourchettes",
      "units": [],
      "generalRate": "20.7¢/kg + 10.4%",
      "specialRate": "Free (AU,BH, CL,CO, IL,JO,KR, MA,OM,P, PA,PE,S,SG) 20.7¢/kg + 8.2% (E)",
      "otherRate": "99.2¢/kg + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.5410",
      "rawHtsCode": "6216.00.54.10",
      "superior": null,
      "indent": "5",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (431)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.5420",
      "rawHtsCode": "6216.00.54.20",
      "superior": null,
      "indent": "5",
      "description": "Other (631)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.58",
      "rawHtsCode": "6216.00.58",
      "superior": null,
      "indent": "4",
      "description": "With fourchettes",
      "units": [],
      "generalRate": "20.7¢/kg + 10.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "99.2¢/kg + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.5810",
      "rawHtsCode": "6216.00.58.10",
      "superior": null,
      "indent": "5",
      "description": "Containing 36 percent or more by weight of wool or fine animal hair (431)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.5820",
      "rawHtsCode": "6216.00.58.20",
      "superior": null,
      "indent": "5",
      "description": "Other (631)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6216.00.8000",
      "rawHtsCode": "6216.00.80.00",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (431)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6216.00.9000",
      "rawHtsCode": "6216.00.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (831)",
      "units": [
        "doz. prs.",
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6217",
      "rawHtsCode": "6217",
      "superior": null,
      "indent": "0",
      "description": "Other made up clothing accessories; parts of garments or of clothing accessories, other than those of   heading 6212:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.10",
      "rawHtsCode": "6217.10",
      "superior": null,
      "indent": "1",
      "description": "Accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.10.10",
      "rawHtsCode": "6217.10.10",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "2.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6217.10.1010",
      "rawHtsCode": "6217.10.10.10",
      "superior": null,
      "indent": "3",
      "description": "Headbands, ponytail holders and similar articles",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.10.1090",
      "rawHtsCode": "6217.10.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other (759)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.10.8500",
      "rawHtsCode": "6217.10.85.00",
      "superior": null,
      "indent": "3",
      "description": "Headbands, ponytail holders and similar articles",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E*,IL,JO,KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6217.10.95",
      "rawHtsCode": "6217.10.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6217.10.9510",
      "rawHtsCode": "6217.10.95.10",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.10.9520",
      "rawHtsCode": "6217.10.95.20",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.10.9530",
      "rawHtsCode": "6217.10.95.30",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.10.9550",
      "rawHtsCode": "6217.10.95.50",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90",
      "rawHtsCode": "6217.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.10",
      "rawHtsCode": "6217.90.10",
      "superior": null,
      "indent": "2",
      "description": "Containing 70 percent or more by weight of silk or silk waste",
      "units": [],
      "generalRate": "2.3%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6217.90.1010",
      "rawHtsCode": "6217.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Of blouses and shirts (741)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.1020",
      "rawHtsCode": "6217.90.10.20",
      "superior": null,
      "indent": "3",
      "description": "Of coats and jackets (735)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.1030",
      "rawHtsCode": "6217.90.10.30",
      "superior": null,
      "indent": "3",
      "description": "Of trousers and breeches (748)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.1060",
      "rawHtsCode": "6217.90.10.60",
      "superior": null,
      "indent": "3",
      "description": "Other (759)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.90",
      "rawHtsCode": "6217.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "14.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6217.90.9003",
      "rawHtsCode": "6217.90.90.03",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (341)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9005",
      "rawHtsCode": "6217.90.90.05",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (440)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9010",
      "rawHtsCode": "6217.90.90.10",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (641)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9020",
      "rawHtsCode": "6217.90.90.20",
      "superior": null,
      "indent": "4",
      "description": "Other (840)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9025",
      "rawHtsCode": "6217.90.90.25",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (335)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9030",
      "rawHtsCode": "6217.90.90.30",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (435)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9035",
      "rawHtsCode": "6217.90.90.35",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (635)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9045",
      "rawHtsCode": "6217.90.90.45",
      "superior": null,
      "indent": "4",
      "description": "Other (835)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9050",
      "rawHtsCode": "6217.90.90.50",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (348)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9055",
      "rawHtsCode": "6217.90.90.55",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (448)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9060",
      "rawHtsCode": "6217.90.90.60",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (648)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9070",
      "rawHtsCode": "6217.90.90.70",
      "superior": null,
      "indent": "4",
      "description": "Other (847)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9075",
      "rawHtsCode": "6217.90.90.75",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9080",
      "rawHtsCode": "6217.90.90.80",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9085",
      "rawHtsCode": "6217.90.90.85",
      "superior": null,
      "indent": "4",
      "description": "Of man-made fibers (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6217.90.9095",
      "rawHtsCode": "6217.90.90.95",
      "superior": null,
      "indent": "4",
      "description": "Other (859)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6301",
      "rawHtsCode": "6301",
      "superior": null,
      "indent": "0",
      "description": "Blankets and traveling rugs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6301.10.0000",
      "rawHtsCode": "6301.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Electric blankets (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6301.20.00",
      "rawHtsCode": "6301.20.00",
      "superior": null,
      "indent": "1",
      "description": "Blankets (other than electric blankets) and traveling rugs, of wool or fine animal hair",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.10/kg + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6301.20.0010",
      "rawHtsCode": "6301.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Not over 3 meters in length (464)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6301.20.0020",
      "rawHtsCode": "6301.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Over 3 meters in length (410)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6301.30.00",
      "rawHtsCode": "6301.30.00",
      "superior": null,
      "indent": "1",
      "description": "Blankets (other than electric blankets) and traveling rugs, of cotton",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6301.30.0010",
      "rawHtsCode": "6301.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Woven (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6301.30.0020",
      "rawHtsCode": "6301.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "Other (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6301.40.00",
      "rawHtsCode": "6301.40.00",
      "superior": null,
      "indent": "1",
      "description": "Blankets (other than electric blankets) and traveling rugs, of synthetic fibers",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6301.40.0010",
      "rawHtsCode": "6301.40.00.10",
      "superior": null,
      "indent": "2",
      "description": "Woven (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6301.40.0020",
      "rawHtsCode": "6301.40.00.20",
      "superior": null,
      "indent": "2",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6301.90.00",
      "rawHtsCode": "6301.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other blankets and traveling rugs",
      "units": [],
      "generalRate": "7.2%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6301.90.0010",
      "rawHtsCode": "6301.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of artificial fibers (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6301.90.0020",
      "rawHtsCode": "6301.90.00.20",
      "superior": null,
      "indent": "3",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6301.90.0030",
      "rawHtsCode": "6301.90.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302",
      "rawHtsCode": "6302",
      "superior": null,
      "indent": "0",
      "description": "Bed linen, table linen, toilet linen and kitchen linen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.10.00",
      "rawHtsCode": "6302.10.00",
      "superior": null,
      "indent": "1",
      "description": "Bed linen, knitted or crocheted",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.10.0005",
      "rawHtsCode": "6302.10.00.05",
      "superior": null,
      "indent": "3",
      "description": "Pillowcases and bolster cases (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.10.0008",
      "rawHtsCode": "6302.10.00.08",
      "superior": null,
      "indent": "3",
      "description": "Sheets (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.10.0015",
      "rawHtsCode": "6302.10.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.10.0020",
      "rawHtsCode": "6302.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "6302.21",
      "rawHtsCode": "6302.21",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.30",
      "rawHtsCode": "6302.21.30",
      "superior": null,
      "indent": "4",
      "description": "Napped",
      "units": [],
      "generalRate": "11.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.21.3010",
      "rawHtsCode": "6302.21.30.10",
      "superior": null,
      "indent": "5",
      "description": "Pillowcases, other than bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.3020",
      "rawHtsCode": "6302.21.30.20",
      "superior": null,
      "indent": "5",
      "description": "Sheets (361)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.3030",
      "rawHtsCode": "6302.21.30.30",
      "superior": null,
      "indent": "5",
      "description": "Bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.3040",
      "rawHtsCode": "6302.21.30.40",
      "superior": null,
      "indent": "5",
      "description": "Pillowcovers (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.3050",
      "rawHtsCode": "6302.21.30.50",
      "superior": null,
      "indent": "5",
      "description": "Other (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.50",
      "rawHtsCode": "6302.21.50",
      "superior": null,
      "indent": "4",
      "description": "Not napped",
      "units": [],
      "generalRate": "20.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.21.5010",
      "rawHtsCode": "6302.21.50.10",
      "superior": null,
      "indent": "5",
      "description": "Pillowcases, other than bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.5020",
      "rawHtsCode": "6302.21.50.20",
      "superior": null,
      "indent": "5",
      "description": "Sheets (361)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.5030",
      "rawHtsCode": "6302.21.50.30",
      "superior": null,
      "indent": "5",
      "description": "Bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.5040",
      "rawHtsCode": "6302.21.50.40",
      "superior": null,
      "indent": "5",
      "description": "Pillowcovers (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.5050",
      "rawHtsCode": "6302.21.50.50",
      "superior": null,
      "indent": "5",
      "description": "Other (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.70",
      "rawHtsCode": "6302.21.70",
      "superior": null,
      "indent": "4",
      "description": "Napped",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.21.7010",
      "rawHtsCode": "6302.21.70.10",
      "superior": null,
      "indent": "5",
      "description": "Pillowcases, other than bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.7020",
      "rawHtsCode": "6302.21.70.20",
      "superior": null,
      "indent": "5",
      "description": "Sheets (361)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.7030",
      "rawHtsCode": "6302.21.70.30",
      "superior": null,
      "indent": "5",
      "description": "Bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.7040",
      "rawHtsCode": "6302.21.70.40",
      "superior": null,
      "indent": "5",
      "description": "Pillow covers (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.7050",
      "rawHtsCode": "6302.21.70.50",
      "superior": null,
      "indent": "5",
      "description": "Other (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.90",
      "rawHtsCode": "6302.21.90",
      "superior": null,
      "indent": "4",
      "description": "Not napped",
      "units": [],
      "generalRate": "6.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See  9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.21.9010",
      "rawHtsCode": "6302.21.90.10",
      "superior": null,
      "indent": "5",
      "description": "Pillowcases, other than bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.9020",
      "rawHtsCode": "6302.21.90.20",
      "superior": null,
      "indent": "5",
      "description": "Sheets (361)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.9030",
      "rawHtsCode": "6302.21.90.30",
      "superior": null,
      "indent": "5",
      "description": "Bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.9040",
      "rawHtsCode": "6302.21.90.40",
      "superior": null,
      "indent": "5",
      "description": "Pillow covers (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.21.9050",
      "rawHtsCode": "6302.21.90.50",
      "superior": null,
      "indent": "5",
      "description": "Other (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.22",
      "rawHtsCode": "6302.22",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.22.10",
      "rawHtsCode": "6302.22.10",
      "superior": null,
      "indent": "3",
      "description": "Containing any embroidery, lace, braid, edging, trimming, piping or applique work",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.22.1010",
      "rawHtsCode": "6302.22.10.10",
      "superior": null,
      "indent": "5",
      "description": "Napped (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.22.1020",
      "rawHtsCode": "6302.22.10.20",
      "superior": null,
      "indent": "5",
      "description": "Not napped (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.22.1030",
      "rawHtsCode": "6302.22.10.30",
      "superior": null,
      "indent": "5",
      "description": "Napped (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.22.1040",
      "rawHtsCode": "6302.22.10.40",
      "superior": null,
      "indent": "5",
      "description": "Not napped (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.22.1050",
      "rawHtsCode": "6302.22.10.50",
      "superior": null,
      "indent": "5",
      "description": "Bolster cases (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.22.1060",
      "rawHtsCode": "6302.22.10.60",
      "superior": null,
      "indent": "5",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.22.20",
      "rawHtsCode": "6302.22.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.22.2010",
      "rawHtsCode": "6302.22.20.10",
      "superior": null,
      "indent": "4",
      "description": "Pillow cases (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.22.2020",
      "rawHtsCode": "6302.22.20.20",
      "superior": null,
      "indent": "4",
      "description": "Sheets (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.22.2030",
      "rawHtsCode": "6302.22.20.30",
      "superior": null,
      "indent": "4",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.29.00",
      "rawHtsCode": "6302.29.00",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*, IL, JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.29.0010",
      "rawHtsCode": "6302.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.29.0020",
      "rawHtsCode": "6302.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31",
      "rawHtsCode": "6302.31",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.30",
      "rawHtsCode": "6302.31.30",
      "superior": null,
      "indent": "4",
      "description": "Napped",
      "units": [],
      "generalRate": "11.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.31.3010",
      "rawHtsCode": "6302.31.30.10",
      "superior": null,
      "indent": "5",
      "description": "Pillowcases, other than bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.3020",
      "rawHtsCode": "6302.31.30.20",
      "superior": null,
      "indent": "5",
      "description": "Sheets (361)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.3030",
      "rawHtsCode": "6302.31.30.30",
      "superior": null,
      "indent": "5",
      "description": "Bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.3040",
      "rawHtsCode": "6302.31.30.40",
      "superior": null,
      "indent": "5",
      "description": "Pillowcovers (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.3050",
      "rawHtsCode": "6302.31.30.50",
      "superior": null,
      "indent": "5",
      "description": "Other (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.50",
      "rawHtsCode": "6302.31.50",
      "superior": null,
      "indent": "4",
      "description": "Not napped",
      "units": [],
      "generalRate": "20.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.31.5010",
      "rawHtsCode": "6302.31.50.10",
      "superior": null,
      "indent": "5",
      "description": "Pillowcases, other than bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.5020",
      "rawHtsCode": "6302.31.50.20",
      "superior": null,
      "indent": "5",
      "description": "Sheets (361)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.5030",
      "rawHtsCode": "6302.31.50.30",
      "superior": null,
      "indent": "5",
      "description": "Bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.5040",
      "rawHtsCode": "6302.31.50.40",
      "superior": null,
      "indent": "5",
      "description": "Pillowcovers (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.5050",
      "rawHtsCode": "6302.31.50.50",
      "superior": null,
      "indent": "5",
      "description": "Other (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.70",
      "rawHtsCode": "6302.31.70",
      "superior": null,
      "indent": "4",
      "description": "Napped",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.31.7010",
      "rawHtsCode": "6302.31.70.10",
      "superior": null,
      "indent": "5",
      "description": "Pillowcases, other than bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.7020",
      "rawHtsCode": "6302.31.70.20",
      "superior": null,
      "indent": "5",
      "description": "Sheets (361)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.7030",
      "rawHtsCode": "6302.31.70.30",
      "superior": null,
      "indent": "5",
      "description": "Bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.7040",
      "rawHtsCode": "6302.31.70.40",
      "superior": null,
      "indent": "5",
      "description": "Pillowcovers (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.7050",
      "rawHtsCode": "6302.31.70.50",
      "superior": null,
      "indent": "5",
      "description": "Other (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.90",
      "rawHtsCode": "6302.31.90",
      "superior": null,
      "indent": "4",
      "description": "Not napped",
      "units": [],
      "generalRate": "6.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.31.9010",
      "rawHtsCode": "6302.31.90.10",
      "superior": null,
      "indent": "5",
      "description": "Pillowcases, other than bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.9020",
      "rawHtsCode": "6302.31.90.20",
      "superior": null,
      "indent": "5",
      "description": "Sheets (361)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.9030",
      "rawHtsCode": "6302.31.90.30",
      "superior": null,
      "indent": "5",
      "description": "Bolster cases (360)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.31.9040",
      "rawHtsCode": "6302.31.90.40",
      "superior": null,
      "indent": "5",
      "description": "Pillowcovers (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "6302.31.9050",
      "rawHtsCode": "6302.31.90.50",
      "superior": null,
      "indent": "5",
      "description": "Other (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32",
      "rawHtsCode": "6302.32",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32.10",
      "rawHtsCode": "6302.32.10",
      "superior": null,
      "indent": "3",
      "description": "Containing any embroidery, lace, braid, edging, trimming, piping or applique work",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.32.1010",
      "rawHtsCode": "6302.32.10.10",
      "superior": null,
      "indent": "5",
      "description": "Napped (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32.1020",
      "rawHtsCode": "6302.32.10.20",
      "superior": null,
      "indent": "5",
      "description": "Not napped (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32.1030",
      "rawHtsCode": "6302.32.10.30",
      "superior": null,
      "indent": "5",
      "description": "Napped (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32.1040",
      "rawHtsCode": "6302.32.10.40",
      "superior": null,
      "indent": "5",
      "description": "Not napped (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32.1050",
      "rawHtsCode": "6302.32.10.50",
      "superior": null,
      "indent": "5",
      "description": "Bolster cases (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32.1060",
      "rawHtsCode": "6302.32.10.60",
      "superior": null,
      "indent": "5",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32.20",
      "rawHtsCode": "6302.32.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.32.2010",
      "rawHtsCode": "6302.32.20.10",
      "superior": null,
      "indent": "5",
      "description": "Napped (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32.2020",
      "rawHtsCode": "6302.32.20.20",
      "superior": null,
      "indent": "5",
      "description": "Not napped (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32.2030",
      "rawHtsCode": "6302.32.20.30",
      "superior": null,
      "indent": "5",
      "description": "Napped (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32.2040",
      "rawHtsCode": "6302.32.20.40",
      "superior": null,
      "indent": "5",
      "description": "Not napped (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32.2050",
      "rawHtsCode": "6302.32.20.50",
      "superior": null,
      "indent": "5",
      "description": "Bolster cases (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.32.2060",
      "rawHtsCode": "6302.32.20.60",
      "superior": null,
      "indent": "5",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.39.00",
      "rawHtsCode": "6302.39.00",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials",
      "units": [],
      "generalRate": "4.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.39.0010",
      "rawHtsCode": "6302.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (469)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.39.0020",
      "rawHtsCode": "6302.39.00.20",
      "superior": null,
      "indent": "4",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.39.0030",
      "rawHtsCode": "6302.39.00.30",
      "superior": null,
      "indent": "4",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.40",
      "rawHtsCode": "6302.40",
      "superior": null,
      "indent": "1",
      "description": "Table linen, knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.40.1000",
      "rawHtsCode": "6302.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of vegetable fibers (except cotton) (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.40.20",
      "rawHtsCode": "6302.40.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.40.2010",
      "rawHtsCode": "6302.40.20.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.40.2020",
      "rawHtsCode": "6302.40.20.20",
      "superior": null,
      "indent": "3",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.51",
      "rawHtsCode": "6302.51",
      "superior": null,
      "indent": "2",
      "description": "Of cotton:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.51.1000",
      "rawHtsCode": "6302.51.10.00",
      "superior": null,
      "indent": "4",
      "description": "Damask (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "6.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.51.2000",
      "rawHtsCode": "6302.51.20.00",
      "superior": null,
      "indent": "5",
      "description": "Plain woven (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.51.3000",
      "rawHtsCode": "6302.51.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.51.4000",
      "rawHtsCode": "6302.51.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.53.00",
      "rawHtsCode": "6302.53.00",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers",
      "units": [],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.53.0010",
      "rawHtsCode": "6302.53.00.10",
      "superior": null,
      "indent": "4",
      "description": "Damask (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.53.0020",
      "rawHtsCode": "6302.53.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.53.0030",
      "rawHtsCode": "6302.53.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.59",
      "rawHtsCode": "6302.59",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.59.10",
      "rawHtsCode": "6302.59.10",
      "superior": null,
      "indent": "4",
      "description": "Tablecloths and napkins",
      "units": [],
      "generalRate": "5.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.59.1010",
      "rawHtsCode": "6302.59.10.10",
      "superior": null,
      "indent": "5",
      "description": "Damask (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.59.1020",
      "rawHtsCode": "6302.59.10.20",
      "superior": null,
      "indent": "5",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.59.2000",
      "rawHtsCode": "6302.59.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6302.59.30",
      "rawHtsCode": "6302.59.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.59.3010",
      "rawHtsCode": "6302.59.30.10",
      "superior": null,
      "indent": "4",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.59.3020",
      "rawHtsCode": "6302.59.30.20",
      "superior": null,
      "indent": "4",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.60.00",
      "rawHtsCode": "6302.60.00",
      "superior": null,
      "indent": "1",
      "description": "Toilet linen and kitchen linen, of terry toweling or similar terry fabrics, of cotton",
      "units": [],
      "generalRate": "9.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.60.0010",
      "rawHtsCode": "6302.60.00.10",
      "superior": null,
      "indent": "3",
      "description": "Dish (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.60.0020",
      "rawHtsCode": "6302.60.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other (363)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.60.0030",
      "rawHtsCode": "6302.60.00.30",
      "superior": null,
      "indent": "2",
      "description": "Other (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.91.00",
      "rawHtsCode": "6302.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "9.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.91.0005",
      "rawHtsCode": "6302.91.00.05",
      "superior": null,
      "indent": "5",
      "description": "Dish (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.91.0015",
      "rawHtsCode": "6302.91.00.15",
      "superior": null,
      "indent": "5",
      "description": "Other (363)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.91.0025",
      "rawHtsCode": "6302.91.00.25",
      "superior": null,
      "indent": "4",
      "description": "Other (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.91.0035",
      "rawHtsCode": "6302.91.00.35",
      "superior": null,
      "indent": "5",
      "description": "Jacquard figured (363)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.91.0045",
      "rawHtsCode": "6302.91.00.45",
      "superior": null,
      "indent": "6",
      "description": "Dish (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.91.0050",
      "rawHtsCode": "6302.91.00.50",
      "superior": null,
      "indent": "6",
      "description": "Other (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.91.0060",
      "rawHtsCode": "6302.91.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.93",
      "rawHtsCode": "6302.93",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.93.1000",
      "rawHtsCode": "6302.93.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pile or tufted construction (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "78%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.93.2000",
      "rawHtsCode": "6302.93.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "9.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.99",
      "rawHtsCode": "6302.99",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.99.1000",
      "rawHtsCode": "6302.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6302.99.15",
      "rawHtsCode": "6302.99.15",
      "superior": null,
      "indent": "3",
      "description": "Of flax",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6302.99.1510",
      "rawHtsCode": "6302.99.15.10",
      "superior": null,
      "indent": "4",
      "description": "Towels (863)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.99.1520",
      "rawHtsCode": "6302.99.15.20",
      "superior": null,
      "indent": "4",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6302.99.2000",
      "rawHtsCode": "6302.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6303",
      "rawHtsCode": "6303",
      "superior": null,
      "indent": "0",
      "description": "Curtains (including drapes) and interior blinds; curtain or bed valances:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.12.00",
      "rawHtsCode": "6303.12.00",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers",
      "units": [],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6303.12.0010",
      "rawHtsCode": "6303.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Window shades and window blinds (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.12.0090",
      "rawHtsCode": "6303.12.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.19",
      "rawHtsCode": "6303.19",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.19.1100",
      "rawHtsCode": "6303.19.11.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "10.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6303.19.21",
      "rawHtsCode": "6303.19.21",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.4%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM,P, PA, PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6303.19.2110",
      "rawHtsCode": "6303.19.21.10",
      "superior": null,
      "indent": "4",
      "description": "Of artificial fibers (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.19.2120",
      "rawHtsCode": "6303.19.21.20",
      "superior": null,
      "indent": "4",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.91.00",
      "rawHtsCode": "6303.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [],
      "generalRate": "10.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6303.91.0010",
      "rawHtsCode": "6303.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Window curtains (including drapes) and window valances (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.91.0020",
      "rawHtsCode": "6303.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.92",
      "rawHtsCode": "6303.92",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.92.1000",
      "rawHtsCode": "6303.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "Made up from fabrics described in subheading 5407.61.11, 5407.61.21 or 5407.61.91 (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6303.92.20",
      "rawHtsCode": "6303.92.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6303.92.2010",
      "rawHtsCode": "6303.92.20.10",
      "superior": null,
      "indent": "4",
      "description": "Window curtains (including drapes) and window valances (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.92.2030",
      "rawHtsCode": "6303.92.20.30",
      "superior": null,
      "indent": "5",
      "description": "Window shades and window blinds (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.92.2050",
      "rawHtsCode": "6303.92.20.50",
      "superior": null,
      "indent": "5",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.99.00",
      "rawHtsCode": "6303.99.00",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials",
      "units": [],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6303.99.0010",
      "rawHtsCode": "6303.99.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of artificial fibers (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.99.0030",
      "rawHtsCode": "6303.99.00.30",
      "superior": null,
      "indent": "4",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6303.99.0060",
      "rawHtsCode": "6303.99.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304",
      "rawHtsCode": "6304",
      "superior": null,
      "indent": "0",
      "description": "Other furnishing articles, excluding those of heading 9404:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.11",
      "rawHtsCode": "6304.11",
      "superior": null,
      "indent": "2",
      "description": "Knitted or crocheted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.11.1000",
      "rawHtsCode": "6304.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.11.2000",
      "rawHtsCode": "6304.11.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.11.3000",
      "rawHtsCode": "6304.11.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "5.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.19",
      "rawHtsCode": "6304.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.19.0500",
      "rawHtsCode": "6304.19.05.00",
      "superior": null,
      "indent": "4",
      "description": "Containing any embroidery, lace, braid, edging, trimming, piping or applique work (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "12%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.19.1000",
      "rawHtsCode": "6304.19.10.00",
      "superior": null,
      "indent": "4",
      "description": "Other (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.19.1500",
      "rawHtsCode": "6304.19.15.00",
      "superior": null,
      "indent": "4",
      "description": "Containing any embroidery, lace, braid, edging, trimming, piping or applique work (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.19.2000",
      "rawHtsCode": "6304.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "77.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.19.30",
      "rawHtsCode": "6304.19.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.19.3030",
      "rawHtsCode": "6304.19.30.30",
      "superior": null,
      "indent": "4",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.19.3040",
      "rawHtsCode": "6304.19.30.40",
      "superior": null,
      "indent": "5",
      "description": "Of wool or fine animal hair (469)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.19.3060",
      "rawHtsCode": "6304.19.30.60",
      "superior": null,
      "indent": "5",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.20.00",
      "rawHtsCode": "6304.20.00",
      "superior": null,
      "indent": "1",
      "description": "Bed nets specified in subheading note 1 to this chapter",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.20.0020",
      "rawHtsCode": "6304.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.20.0040",
      "rawHtsCode": "6304.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.20.0050",
      "rawHtsCode": "6304.20.00.50",
      "superior": null,
      "indent": "3",
      "description": "Of wool or fine animal hair (469)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.20.0060",
      "rawHtsCode": "6304.20.00.60",
      "superior": null,
      "indent": "4",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.20.0070",
      "rawHtsCode": "6304.20.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other (899)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.91.01",
      "rawHtsCode": "6304.91.01",
      "superior": null,
      "indent": "2",
      "description": "Knitted or crocheted",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.91.0120",
      "rawHtsCode": "6304.91.01.20",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.91.0140",
      "rawHtsCode": "6304.91.01.40",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.91.0150",
      "rawHtsCode": "6304.91.01.50",
      "superior": null,
      "indent": "4",
      "description": "Of wool or fine animal hair (469)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.91.0160",
      "rawHtsCode": "6304.91.01.60",
      "superior": null,
      "indent": "5",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.91.0170",
      "rawHtsCode": "6304.91.01.70",
      "superior": null,
      "indent": "5",
      "description": "Other (899)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "?"
      ],
      "flags": []
    },
    {
      "htsCode": "6304.92.0000",
      "rawHtsCode": "6304.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not knitted or crocheted, of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.93.0000",
      "rawHtsCode": "6304.93.00.00",
      "superior": null,
      "indent": "2",
      "description": "Not knitted or crocheted, of synthetic fibers (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "9.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.99",
      "rawHtsCode": "6304.99",
      "superior": null,
      "indent": "2",
      "description": "Not knitted or crocheted, of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.99.1000",
      "rawHtsCode": "6304.99.10.00",
      "superior": null,
      "indent": "4",
      "description": "Certified hand-loomed and folklore products",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.99.1500",
      "rawHtsCode": "6304.99.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other (469)",
      "units": [
        "m<sup>2</sup>",
        "<u>kg</u>"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.99.2500",
      "rawHtsCode": "6304.99.25.00",
      "superior": null,
      "indent": "5",
      "description": "Wall hangings of jute",
      "units": [
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.99.3500",
      "rawHtsCode": "6304.99.35.00",
      "superior": null,
      "indent": "5",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.99.4000",
      "rawHtsCode": "6304.99.40.00",
      "superior": null,
      "indent": "4",
      "description": "Certified hand-loomed and folklore pillow covers of wool or fine animal hair",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.99.60",
      "rawHtsCode": "6304.99.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6304.99.6010",
      "rawHtsCode": "6304.99.60.10",
      "superior": null,
      "indent": "5",
      "description": "Of wool or fine animal hair (469)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.99.6020",
      "rawHtsCode": "6304.99.60.20",
      "superior": null,
      "indent": "5",
      "description": "Of artificial fibers (666)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.99.6030",
      "rawHtsCode": "6304.99.60.30",
      "superior": null,
      "indent": "6",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6304.99.6040",
      "rawHtsCode": "6304.99.60.40",
      "superior": null,
      "indent": "6",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6305",
      "rawHtsCode": "6305",
      "superior": null,
      "indent": "0",
      "description": "Sacks and bags, of a kind used for the packing of goods:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6305.10.0000",
      "rawHtsCode": "6305.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of jute or of other textile bast fibers of heading 5303",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6305.20.0000",
      "rawHtsCode": "6305.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of cotton (369)",
      "units": [
        "kg"
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6305.32.00",
      "rawHtsCode": "6305.32.00",
      "superior": null,
      "indent": "2",
      "description": "Flexible intermediate bulk containers",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "103%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6305.32.0010",
      "rawHtsCode": "6305.32.00.10",
      "superior": null,
      "indent": "3",
      "description": "Weighing one kg or more (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6305.32.0020",
      "rawHtsCode": "6305.32.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6305.33.00",
      "rawHtsCode": "6305.33.00",
      "superior": null,
      "indent": "2",
      "description": "Other, of polyethylene or polypropylene strip or the like",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "103%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6305.33.0010",
      "rawHtsCode": "6305.33.00.10",
      "superior": null,
      "indent": "3",
      "description": "Weighing one kg or more (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6305.33.0040",
      "rawHtsCode": "6305.33.00.40",
      "superior": null,
      "indent": "5",
      "description": "Printed with three or more colors (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6305.33.0060",
      "rawHtsCode": "6305.33.00.60",
      "superior": null,
      "indent": "5",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6305.33.0080",
      "rawHtsCode": "6305.33.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6305.39.0000",
      "rawHtsCode": "6305.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "8.4%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "103%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6305.90.0000",
      "rawHtsCode": "6305.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of other textile materials (899)",
      "units": [
        "kg"
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6306",
      "rawHtsCode": "6306",
      "superior": null,
      "indent": "0",
      "description": "Tarpaulins, awnings and sunblinds; tents (including temporary canopies and similar articles); sails for boats, sailboards or landcraft; camping goods:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6306.12.0000",
      "rawHtsCode": "6306.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers (669)",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6306.19",
      "rawHtsCode": "6306.19",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6306.19.1100",
      "rawHtsCode": "6306.19.11.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (369)",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6306.19.21",
      "rawHtsCode": "6306.19.21",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.1%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6306.19.2110",
      "rawHtsCode": "6306.19.21.10",
      "superior": null,
      "indent": "4",
      "description": "Of artificial fibers (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6306.19.2120",
      "rawHtsCode": "6306.19.21.20",
      "superior": null,
      "indent": "4",
      "description": "Other (899)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6306.22",
      "rawHtsCode": "6306.22",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6306.22.1000",
      "rawHtsCode": "6306.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Backpacking tents",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6306.22.90",
      "rawHtsCode": "6306.22.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6306.22.9010",
      "rawHtsCode": "6306.22.90.10",
      "superior": null,
      "indent": "4",
      "description": "Screen houses",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6306.22.9030",
      "rawHtsCode": "6306.22.90.30",
      "superior": null,
      "indent": "4",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6306.29",
      "rawHtsCode": "6306.29",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6306.29.1100",
      "rawHtsCode": "6306.29.11.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6306.29.2100",
      "rawHtsCode": "6306.29.21.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6306.30.00",
      "rawHtsCode": "6306.30.00",
      "superior": null,
      "indent": "1",
      "description": "Sails",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6306.30.0010",
      "rawHtsCode": "6306.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6306.30.0020",
      "rawHtsCode": "6306.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6306.40",
      "rawHtsCode": "6306.40",
      "superior": null,
      "indent": "1",
      "description": "Pneumatic mattresses:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6306.40.4100",
      "rawHtsCode": "6306.40.41.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6306.40.4900",
      "rawHtsCode": "6306.40.49.00",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6306.90",
      "rawHtsCode": "6306.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6306.90.1000",
      "rawHtsCode": "6306.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6306.90.5000",
      "rawHtsCode": "6306.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Of other textile materials",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6307",
      "rawHtsCode": "6307",
      "superior": null,
      "indent": "0",
      "description": "Other made up articles, including dress patterns:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.10",
      "rawHtsCode": "6307.10",
      "superior": null,
      "indent": "1",
      "description": "Floorcloths, dishcloths, dusters and similar cleaning cloths:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.10.10",
      "rawHtsCode": "6307.10.10",
      "superior": null,
      "indent": "2",
      "description": "Dustcloths, mop cloths and polishing cloths, of cotton",
      "units": [],
      "generalRate": "4.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "26.2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6307.10.1020",
      "rawHtsCode": "6307.10.10.20",
      "superior": null,
      "indent": "3",
      "description": "Bar mops (measuring 46 to 57 centimeters in length and 38 to43 centimeters in width) of terry fabric (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.10.1090",
      "rawHtsCode": "6307.10.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other (369)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.10.20",
      "rawHtsCode": "6307.10.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6307.10.2005",
      "rawHtsCode": "6307.10.20.05",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.10.2015",
      "rawHtsCode": "6307.10.20.15",
      "superior": null,
      "indent": "4",
      "description": "Other (863)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.10.2027",
      "rawHtsCode": "6307.10.20.27",
      "superior": null,
      "indent": "4",
      "description": "Of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.10.2028",
      "rawHtsCode": "6307.10.20.28",
      "superior": null,
      "indent": "4",
      "description": "Other (863)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.10.2030",
      "rawHtsCode": "6307.10.20.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.20.0000",
      "rawHtsCode": "6307.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Lifejackets and lifebelts",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6307.90",
      "rawHtsCode": "6307.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.30",
      "rawHtsCode": "6307.90.30",
      "superior": null,
      "indent": "2",
      "description": "Labels",
      "units": [],
      "generalRate": "7.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "71.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6307.90.3010",
      "rawHtsCode": "6307.90.30.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (369)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.3020",
      "rawHtsCode": "6307.90.30.20",
      "superior": null,
      "indent": "3",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.40",
      "rawHtsCode": "6307.90.40",
      "superior": null,
      "indent": "2",
      "description": "Cords and tassels",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6307.90.4010",
      "rawHtsCode": "6307.90.40.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (369)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.4020",
      "rawHtsCode": "6307.90.40.20",
      "superior": null,
      "indent": "3",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.50",
      "rawHtsCode": "6307.90.50",
      "superior": null,
      "indent": "2",
      "description": "Corset lacings, footwear lacings or similar lacings",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6307.90.5010",
      "rawHtsCode": "6307.90.50.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (369)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.5020",
      "rawHtsCode": "6307.90.50.20",
      "superior": null,
      "indent": "3",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.60",
      "rawHtsCode": "6307.90.60",
      "superior": null,
      "indent": "3",
      "description": "Of fabric formed on a base of paper or covered or lined with paper",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6307.90.6010",
      "rawHtsCode": "6307.90.60.10",
      "superior": null,
      "indent": "4",
      "description": "Perineal towels",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.6090",
      "rawHtsCode": "6307.90.60.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.6800",
      "rawHtsCode": "6307.90.68.00",
      "superior": null,
      "indent": "4",
      "description": "Spunlaced or bonded fiber fabric disposable surgical drapes of man-made fibers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6307.90.7200",
      "rawHtsCode": "6307.90.72.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6307.90.7500",
      "rawHtsCode": "6307.90.75.00",
      "superior": null,
      "indent": "2",
      "description": "Toys for pets, of textile materials",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6307.90.8500",
      "rawHtsCode": "6307.90.85.00",
      "superior": null,
      "indent": "2",
      "description": "Wall banners, of man-made fibers",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6307.90.89",
      "rawHtsCode": "6307.90.89",
      "superior": null,
      "indent": "3",
      "description": "Surgical towels; cotton towels of pile or tufted construction; pillow shells, of cotton; shells for quilts, eiderdowns, comforters and similar articles of cotton",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,B,BH, CL,CO,E*,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6307.90.8910",
      "rawHtsCode": "6307.90.89.10",
      "superior": null,
      "indent": "4",
      "description": "Surgical towels (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.8940",
      "rawHtsCode": "6307.90.89.40",
      "superior": null,
      "indent": "4",
      "description": "Cotton towels of pile or tufted construction (363)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.8945",
      "rawHtsCode": "6307.90.89.45",
      "superior": null,
      "indent": "4",
      "description": "Pillow shells, of cotton (369)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.8950",
      "rawHtsCode": "6307.90.89.50",
      "superior": null,
      "indent": "5",
      "description": "Sleeping bag shells",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.8985",
      "rawHtsCode": "6307.90.89.85",
      "superior": null,
      "indent": "6",
      "description": "Containing 85 percent or more by weight of cotton",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.8995",
      "rawHtsCode": "6307.90.89.95",
      "superior": null,
      "indent": "6",
      "description": "Other (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.98",
      "rawHtsCode": "6307.90.98",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.57.01, 9903.88.15 and 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6307.90.9825",
      "rawHtsCode": "6307.90.98.25",
      "superior": null,
      "indent": "5",
      "description": "Of the United States",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.9835",
      "rawHtsCode": "6307.90.98.35",
      "superior": null,
      "indent": "5",
      "description": "Of other nations",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.9842",
      "rawHtsCode": "6307.90.98.42",
      "superior": null,
      "indent": "6",
      "description": "Surgical",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.07. "
      ],
      "flags": []
    },
    {
      "htsCode": "6307.90.9844",
      "rawHtsCode": "6307.90.98.44",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.07. "
      ],
      "flags": []
    },
    {
      "htsCode": "6307.90.9850",
      "rawHtsCode": "6307.90.98.50",
      "superior": null,
      "indent": "5",
      "description": "Other respirators",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.07. "
      ],
      "flags": []
    },
    {
      "htsCode": "6307.90.9870",
      "rawHtsCode": "6307.90.98.70",
      "superior": null,
      "indent": "6",
      "description": "Disposable",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.07. "
      ],
      "flags": []
    },
    {
      "htsCode": "6307.90.9875",
      "rawHtsCode": "6307.90.98.75",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.07. "
      ],
      "flags": []
    },
    {
      "htsCode": "6307.90.9882",
      "rawHtsCode": "6307.90.98.82",
      "superior": null,
      "indent": "5",
      "description": "Other towels of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.9884",
      "rawHtsCode": "6307.90.98.84",
      "superior": null,
      "indent": "5",
      "description": "Other towels of man-made fibers (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.9885",
      "rawHtsCode": "6307.90.98.85",
      "superior": null,
      "indent": "5",
      "description": "Furniture movers' pads of cotton",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.9887",
      "rawHtsCode": "6307.90.98.87",
      "superior": null,
      "indent": "5",
      "description": "Furniture movers' pads of man-made fibers",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6307.90.9891",
      "rawHtsCode": "6307.90.98.91",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "6308.00.00",
      "rawHtsCode": "6308.00.00",
      "superior": null,
      "indent": "0",
      "description": "Needlecraft sets consisting of woven fabric and yarn, whether or not with accessories, for making up into rugs, tapestries, embroidered tablecloths or napkins, or similar textile articles, put up in packings for retail sale",
      "units": [],
      "generalRate": "11.4%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,NP,OM, P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6308.00.0010",
      "rawHtsCode": "6308.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Containing wool yarn (469)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6308.00.0020",
      "rawHtsCode": "6308.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6309.00.00",
      "rawHtsCode": "6309.00.00",
      "superior": null,
      "indent": "0",
      "description": "Worn clothing and other worn articles",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "93%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6309.00.0010",
      "rawHtsCode": "6309.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Worn clothing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6309.00.0020",
      "rawHtsCode": "6309.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6310",
      "rawHtsCode": "6310",
      "superior": null,
      "indent": "0",
      "description": "Used or new rags, scrap twine, cordage, rope and cables, and worn out articles of twine, cordage, rope or cables, of textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6310.10",
      "rawHtsCode": "6310.10",
      "superior": null,
      "indent": "1",
      "description": "Sorted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6310.10.1000",
      "rawHtsCode": "6310.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "39.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6310.10.20",
      "rawHtsCode": "6310.10.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6310.10.2010",
      "rawHtsCode": "6310.10.20.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6310.10.2020",
      "rawHtsCode": "6310.10.20.20",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6310.10.2030",
      "rawHtsCode": "6310.10.20.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6310.90",
      "rawHtsCode": "6310.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6310.90.1000",
      "rawHtsCode": "6310.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of wool or fine animal hair",
      "units": [
        "kg"
      ],
      "generalRate": "5.5¢/kg",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "39.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6310.90.2000",
      "rawHtsCode": "6310.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6401",
      "rawHtsCode": "6401",
      "superior": null,
      "indent": "0",
      "description": "Waterproof footwear with outer soles and uppers of rubber or plastics, the uppers of which are neither fixed to the sole nor assembled by stitching, riveting, nailing, screwing, plugging or similar processes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6401.10.0000",
      "rawHtsCode": "6401.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Footwear incorporating a protective metal toe-cap",
      "units": [
        "prs."
      ],
      "generalRate": "37.5% ",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6401.92",
      "rawHtsCode": "6401.92",
      "superior": null,
      "indent": "2",
      "description": "Covering the ankle but not covering the knee:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6401.92.3000",
      "rawHtsCode": "6401.92.30.00",
      "superior": null,
      "indent": "3",
      "description": "Ski-boots and snowboard boots",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6401.92.6000",
      "rawHtsCode": "6401.92.60.00",
      "superior": null,
      "indent": "4",
      "description": "Having soles and uppers of which over 90 percent of the external surface area (including any accessories or reinforcements such as those mentioned in note 4(a) to this chapter) is poly(vinyl chloride), whether or not supported or lined with poly(vinyl chloride) but not otherwise supported or lined",
      "units": [
        "prs."
      ],
      "generalRate": "4.6%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6401.92.90",
      "rawHtsCode": "6401.92.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "37.5% ",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6401.92.9030",
      "rawHtsCode": "6401.92.90.30",
      "superior": null,
      "indent": "5",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6401.92.9060",
      "rawHtsCode": "6401.92.90.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6401.99",
      "rawHtsCode": "6401.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6401.99.1000",
      "rawHtsCode": "6401.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Covering the knee",
      "units": [
        "prs."
      ],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6401.99.3000",
      "rawHtsCode": "6401.99.30.00",
      "superior": null,
      "indent": "5",
      "description": "Designed for use without closures",
      "units": [
        "prs."
      ],
      "generalRate": "25% ",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6401.99.6000",
      "rawHtsCode": "6401.99.60.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "37.5% ",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6401.99.8000",
      "rawHtsCode": "6401.99.80.00",
      "superior": null,
      "indent": "5",
      "description": "Having uppers of which over 90 percent of the external surface area (including any accessories or reinforcements such as those mentioned in note 4(a) to this chapter) is rubber or plastics (except footwear having foxing or a foxing-like band applied or molded at the sole and overlapping the upper)",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6401.99.9000",
      "rawHtsCode": "6401.99.90.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402",
      "rawHtsCode": "6402",
      "superior": null,
      "indent": "0",
      "description": "Other footwear with outer soles and uppers of rubber or plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.12.0000",
      "rawHtsCode": "6402.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ski-boots, cross-country ski footwear and snowboard boots",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6402.19",
      "rawHtsCode": "6402.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.05",
      "rawHtsCode": "6402.19.05",
      "superior": null,
      "indent": "4",
      "description": "Golf shoes",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.19.0530",
      "rawHtsCode": "6402.19.05.30",
      "superior": null,
      "indent": "5",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.0560",
      "rawHtsCode": "6402.19.05.60",
      "superior": null,
      "indent": "5",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.0590",
      "rawHtsCode": "6402.19.05.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.15",
      "rawHtsCode": "6402.19.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5.1%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.19.1520",
      "rawHtsCode": "6402.19.15.20",
      "superior": null,
      "indent": "5",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.1541",
      "rawHtsCode": "6402.19.15.41",
      "superior": null,
      "indent": "5",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.1561",
      "rawHtsCode": "6402.19.15.61",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.30",
      "rawHtsCode": "6402.19.30",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $3/pair",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "84%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.3031",
      "rawHtsCode": "6402.19.30.31",
      "superior": null,
      "indent": "5",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.3061",
      "rawHtsCode": "6402.19.30.61",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.50",
      "rawHtsCode": "6402.19.50",
      "superior": null,
      "indent": "4",
      "description": "Valued over $3 but not over $6.50/pair",
      "units": [],
      "generalRate": "76¢/pr. + 32%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$1.58/pr. + 66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.19.5031",
      "rawHtsCode": "6402.19.50.31",
      "superior": null,
      "indent": "5",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.5061",
      "rawHtsCode": "6402.19.50.61",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.70",
      "rawHtsCode": "6402.19.70",
      "superior": null,
      "indent": "4",
      "description": "Valued over $6.50 but not over $12/pair",
      "units": [],
      "generalRate": "76¢/pr. + 17%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$1.58/pr. + 35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.19.7031",
      "rawHtsCode": "6402.19.70.31",
      "superior": null,
      "indent": "5",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.7061",
      "rawHtsCode": "6402.19.70.61",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.90",
      "rawHtsCode": "6402.19.90",
      "superior": null,
      "indent": "4",
      "description": "Valued over $12/pair",
      "units": [],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.19.9031",
      "rawHtsCode": "6402.19.90.31",
      "superior": null,
      "indent": "5",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.19.9061",
      "rawHtsCode": "6402.19.90.61",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.20.0000",
      "rawHtsCode": "6402.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Footwear with upper straps or thongs assembled to the sole by means of plugs (zoris)",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91",
      "rawHtsCode": "6402.91",
      "superior": null,
      "indent": "2",
      "description": "Covering the ankle:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.0500",
      "rawHtsCode": "6402.91.05.00",
      "superior": null,
      "indent": "4",
      "description": "Having uppers of which over 90 percent of the external surface area (including any accessories or reinforcements such as those mentioned in note 4(a) to this chapter) is rubber or plastics (except footwear having foxing or a foxing-like band applied or molded at the sole and overlapping the upper and except footwear designed to be worn over, or in lieu of, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather)",
      "units": [
        "prs."
      ],
      "generalRate": "6% ",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.1000",
      "rawHtsCode": "6402.91.10.00",
      "superior": null,
      "indent": "5",
      "description": "Footwear designed to be worn over, or in lieu of, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather",
      "units": [
        "prs."
      ],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.1600",
      "rawHtsCode": "6402.91.16.00",
      "superior": null,
      "indent": "6",
      "description": "Valued not over $3/pair",
      "units": [
        "prs."
      ],
      "generalRate": "24%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,R,S,SG)",
      "otherRate": "84%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.2000",
      "rawHtsCode": "6402.91.20.00",
      "superior": null,
      "indent": "6",
      "description": "Valued over $3 but not over $6.50/pair",
      "units": [
        "prs."
      ],
      "generalRate": "90¢/pr. + 37.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$1.58/pr. + 66%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.2600",
      "rawHtsCode": "6402.91.26.00",
      "superior": null,
      "indent": "6",
      "description": "Valued over $6.50 but not over $12/pair",
      "units": [
        "prs."
      ],
      "generalRate": "90¢/pr. + 20%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$1.58/pr. + 35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.3000",
      "rawHtsCode": "6402.91.30.00",
      "superior": null,
      "indent": "6",
      "description": "Valued over $12/pair",
      "units": [
        "prs."
      ],
      "generalRate": "20%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.40",
      "rawHtsCode": "6402.91.40",
      "superior": null,
      "indent": "4",
      "description": "Having uppers of which over 90 percent of the external surface area (including any accessories or reinforcements such as those mentioned in note 4(a) to this chapter) is rubber or plastics except (1) footwear having a foxing or a foxing-like band applied or molded at the sole and overlapping the upper and (2) except footwear (other than footwear having uppers which from a point 3 cm above the top of the outer sole are entirely of non- molded construction formed by sewing the parts together and having exposed on the outer surface a substantial portion of functional stitching) designed to be worn over, or in lieu of, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.4005",
      "rawHtsCode": "6402.91.40.05",
      "superior": null,
      "indent": "6",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.4010",
      "rawHtsCode": "6402.91.40.10",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.4040",
      "rawHtsCode": "6402.91.40.40",
      "superior": null,
      "indent": "6",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.4050",
      "rawHtsCode": "6402.91.40.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.4063",
      "rawHtsCode": "6402.91.40.63",
      "superior": null,
      "indent": "5",
      "description": "For infants, as described in statistical note 2 to this chapter",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.4067",
      "rawHtsCode": "6402.91.40.67",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.42",
      "rawHtsCode": "6402.91.42",
      "superior": null,
      "indent": "4",
      "description": "Protective active footwear (except footwear with waterproof molded bottoms, including bottoms comprising an outer sole and all or part of the upper and except footwear with insulation that provides protection against cold weather) whose height from the bottom of the outer sole to the top of the upper does not exceed 15.34 cm ",
      "units": [],
      "generalRate": "20%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.4230",
      "rawHtsCode": "6402.91.42.30",
      "superior": null,
      "indent": "5",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.4260",
      "rawHtsCode": "6402.91.42.60",
      "superior": null,
      "indent": "5",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.4290",
      "rawHtsCode": "6402.91.42.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.50",
      "rawHtsCode": "6402.91.50",
      "superior": null,
      "indent": "5",
      "description": "Footwear designed to be worn over, or in lieu of, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather",
      "units": [],
      "generalRate": "37.5% ",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.5010",
      "rawHtsCode": "6402.91.50.10",
      "superior": null,
      "indent": "7",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.5020",
      "rawHtsCode": "6402.91.50.20",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.5045",
      "rawHtsCode": "6402.91.50.45",
      "superior": null,
      "indent": "7",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.5050",
      "rawHtsCode": "6402.91.50.50",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.5090",
      "rawHtsCode": "6402.91.50.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.60",
      "rawHtsCode": "6402.91.60",
      "superior": null,
      "indent": "6",
      "description": "Valued not over $3/pair",
      "units": [],
      "generalRate": "48%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "84%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.6030",
      "rawHtsCode": "6402.91.60.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.6060",
      "rawHtsCode": "6402.91.60.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.6090",
      "rawHtsCode": "6402.91.60.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.70",
      "rawHtsCode": "6402.91.70",
      "superior": null,
      "indent": "6",
      "description": "Valued over $3 but not over $6.50/pair",
      "units": [],
      "generalRate": "90¢/pr. + 37.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,R,S, SG)",
      "otherRate": "$1.58/pr. + 66%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.7030",
      "rawHtsCode": "6402.91.70.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.7060",
      "rawHtsCode": "6402.91.70.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.7090",
      "rawHtsCode": "6402.91.70.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.80",
      "rawHtsCode": "6402.91.80",
      "superior": null,
      "indent": "6",
      "description": "Valued over $6.50 but not over $12/pair",
      "units": [],
      "generalRate": "90¢/pr. + 20%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$1.58/pr. + 35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.8005",
      "rawHtsCode": "6402.91.80.05",
      "superior": null,
      "indent": "7",
      "description": "Tennis shoes, basketball shoes, gym shoes, training shoes and the like",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.8010",
      "rawHtsCode": "6402.91.80.10",
      "superior": null,
      "indent": "9",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.8021",
      "rawHtsCode": "6402.91.80.21",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.8045",
      "rawHtsCode": "6402.91.80.45",
      "superior": null,
      "indent": "9",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.8051",
      "rawHtsCode": "6402.91.80.51",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.8091",
      "rawHtsCode": "6402.91.80.91",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.90",
      "rawHtsCode": "6402.91.90",
      "superior": null,
      "indent": "6",
      "description": "Valued over $12/pair",
      "units": [],
      "generalRate": "20%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.91.9005",
      "rawHtsCode": "6402.91.90.05",
      "superior": null,
      "indent": "7",
      "description": "Tennis shoes, basketball shoes, gym shoes, training shoes and the like",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.9010",
      "rawHtsCode": "6402.91.90.10",
      "superior": null,
      "indent": "9",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.9035",
      "rawHtsCode": "6402.91.90.35",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.9045",
      "rawHtsCode": "6402.91.90.45",
      "superior": null,
      "indent": "9",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.9065",
      "rawHtsCode": "6402.91.90.65",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.91.9095",
      "rawHtsCode": "6402.91.90.95",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99",
      "rawHtsCode": "6402.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.0400",
      "rawHtsCode": "6402.99.04.00",
      "superior": null,
      "indent": "4",
      "description": "Having uppers of which over 90 percent of the external surface area (including any accessories or reinforcements such as those mentioned in note 4(a) to this chapter) is rubber or plastics (except footwear having foxing or a foxing-like band applied or molded at the sole and overlapping the upper and except footwear designed to be worn over, or in lieu of, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather)",
      "units": [
        "prs."
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.0800",
      "rawHtsCode": "6402.99.08.00",
      "superior": null,
      "indent": "5",
      "description": "Footwear designed to be worn over, or in lieu of, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather",
      "units": [
        "prs."
      ],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.1200",
      "rawHtsCode": "6402.99.12.00",
      "superior": null,
      "indent": "6",
      "description": "Valued not over $3/pair",
      "units": [
        "prs."
      ],
      "generalRate": "24%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "84%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.1600",
      "rawHtsCode": "6402.99.16.00",
      "superior": null,
      "indent": "6",
      "description": "Valued over $3 but not over $6.50/pair",
      "units": [
        "prs."
      ],
      "generalRate": "90¢/pr. + 37.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$1.58/pr. + 66%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.1900",
      "rawHtsCode": "6402.99.19.00",
      "superior": null,
      "indent": "6",
      "description": "Valued over $6.50 but not over $12/pair",
      "units": [
        "prs."
      ],
      "generalRate": "90¢/pr. + 20%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$1.58/pr. + 35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.2100",
      "rawHtsCode": "6402.99.21.00",
      "superior": null,
      "indent": "6",
      "description": "Valued over $12/pair",
      "units": [
        "prs."
      ],
      "generalRate": "20%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL, JO,KR,MA, OM,P,PA,PE,R,S, SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.23",
      "rawHtsCode": "6402.99.23",
      "superior": null,
      "indent": "5",
      "description": "Made on a base or platform of wood",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.2330",
      "rawHtsCode": "6402.99.23.30",
      "superior": null,
      "indent": "6",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.2360",
      "rawHtsCode": "6402.99.23.60",
      "superior": null,
      "indent": "6",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.2390",
      "rawHtsCode": "6402.99.23.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.25",
      "rawHtsCode": "6402.99.25",
      "superior": null,
      "indent": "5",
      "description": "Made on a base or platform of cork",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.2530",
      "rawHtsCode": "6402.99.25.30",
      "superior": null,
      "indent": "6",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.2560",
      "rawHtsCode": "6402.99.25.60",
      "superior": null,
      "indent": "6",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.2590",
      "rawHtsCode": "6402.99.25.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.27",
      "rawHtsCode": "6402.99.27",
      "superior": null,
      "indent": "6",
      "description": "Sandals and similar footwear of plastics, produced in one piece by molding",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.2730",
      "rawHtsCode": "6402.99.27.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.2760",
      "rawHtsCode": "6402.99.27.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.2790",
      "rawHtsCode": "6402.99.27.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.31",
      "rawHtsCode": "6402.99.31",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.3110",
      "rawHtsCode": "6402.99.31.10",
      "superior": null,
      "indent": "7",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3115",
      "rawHtsCode": "6402.99.31.15",
      "superior": null,
      "indent": "7",
      "description": "Tennis shoes, basketball shoes, gym shoes, training shoes and the like",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3135",
      "rawHtsCode": "6402.99.31.35",
      "superior": null,
      "indent": "9",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3145",
      "rawHtsCode": "6402.99.31.45",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3155",
      "rawHtsCode": "6402.99.31.55",
      "superior": null,
      "indent": "9",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3165",
      "rawHtsCode": "6402.99.31.65",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3173",
      "rawHtsCode": "6402.99.31.73",
      "superior": null,
      "indent": "8",
      "description": "For infants, as described in statistical note 2 to this chapter",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3177",
      "rawHtsCode": "6402.99.31.77",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.32",
      "rawHtsCode": "6402.99.32",
      "superior": null,
      "indent": "5",
      "description": "Protective active footwear",
      "units": [],
      "generalRate": "20% ",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.3230",
      "rawHtsCode": "6402.99.32.30",
      "superior": null,
      "indent": "6",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3260",
      "rawHtsCode": "6402.99.32.60",
      "superior": null,
      "indent": "6",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3290",
      "rawHtsCode": "6402.99.32.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.33",
      "rawHtsCode": "6402.99.33",
      "superior": null,
      "indent": "5",
      "description": "Footwear designed to be worn over, or in lieu of, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather",
      "units": [],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.3310",
      "rawHtsCode": "6402.99.33.10",
      "superior": null,
      "indent": "7",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3320",
      "rawHtsCode": "6402.99.33.20",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3345",
      "rawHtsCode": "6402.99.33.45",
      "superior": null,
      "indent": "7",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3350",
      "rawHtsCode": "6402.99.33.50",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.3390",
      "rawHtsCode": "6402.99.33.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.4100",
      "rawHtsCode": "6402.99.41.00",
      "superior": null,
      "indent": "6",
      "description": "Having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [
        "prs."
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.49",
      "rawHtsCode": "6402.99.49",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA,P, PA,PE,OM,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.4920",
      "rawHtsCode": "6402.99.49.20",
      "superior": null,
      "indent": "7",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.4940",
      "rawHtsCode": "6402.99.49.40",
      "superior": null,
      "indent": "8",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.4960",
      "rawHtsCode": "6402.99.49.60",
      "superior": null,
      "indent": "8",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.4980",
      "rawHtsCode": "6402.99.49.80",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.6100",
      "rawHtsCode": "6402.99.61.00",
      "superior": null,
      "indent": "7",
      "description": "Having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [
        "prs."
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.69",
      "rawHtsCode": "6402.99.69",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [],
      "generalRate": "48%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "84%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.6915",
      "rawHtsCode": "6402.99.69.15",
      "superior": null,
      "indent": "8",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.6930",
      "rawHtsCode": "6402.99.69.30",
      "superior": null,
      "indent": "9",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.6960",
      "rawHtsCode": "6402.99.69.60",
      "superior": null,
      "indent": "9",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.6990",
      "rawHtsCode": "6402.99.69.90",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.7100",
      "rawHtsCode": "6402.99.71.00",
      "superior": null,
      "indent": "7",
      "description": "Having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [
        "prs."
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.79",
      "rawHtsCode": "6402.99.79",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [],
      "generalRate": "90¢/pr. + 37.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "$1.58/pr. + 66%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.7915",
      "rawHtsCode": "6402.99.79.15",
      "superior": null,
      "indent": "8",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.7930",
      "rawHtsCode": "6402.99.79.30",
      "superior": null,
      "indent": "9",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.7960",
      "rawHtsCode": "6402.99.79.60",
      "superior": null,
      "indent": "9",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.7990",
      "rawHtsCode": "6402.99.79.90",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.80",
      "rawHtsCode": "6402.99.80",
      "superior": null,
      "indent": "6",
      "description": "Valued over $6.50 but not over $12/pair",
      "units": [],
      "generalRate": "90¢/pr. + 20%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$1.58/pr. + 35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.8005",
      "rawHtsCode": "6402.99.80.05",
      "superior": null,
      "indent": "7",
      "description": "Tennis shoes, basketball shoes, gym shoes, training shoes and the like",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.8031",
      "rawHtsCode": "6402.99.80.31",
      "superior": null,
      "indent": "8",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.8061",
      "rawHtsCode": "6402.99.80.61",
      "superior": null,
      "indent": "8",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.8091",
      "rawHtsCode": "6402.99.80.91",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.90",
      "rawHtsCode": "6402.99.90",
      "superior": null,
      "indent": "6",
      "description": "Valued over $12/pair",
      "units": [],
      "generalRate": "20%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6402.99.9005",
      "rawHtsCode": "6402.99.90.05",
      "superior": null,
      "indent": "7",
      "description": "Tennis shoes, basketball shoes, gym shoes, training shoes and the like",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.9035",
      "rawHtsCode": "6402.99.90.35",
      "superior": null,
      "indent": "8",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.9065",
      "rawHtsCode": "6402.99.90.65",
      "superior": null,
      "indent": "8",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6402.99.9095",
      "rawHtsCode": "6402.99.90.95",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403",
      "rawHtsCode": "6403",
      "superior": null,
      "indent": "0",
      "description": "Footwear with outer soles of rubber, plastics, leather or composition leather and uppers of leather:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.12",
      "rawHtsCode": "6403.12",
      "superior": null,
      "indent": "2",
      "description": "Ski-boots, cross-country ski footwear and snowboard boots:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.12.3000",
      "rawHtsCode": "6403.12.30.00",
      "superior": null,
      "indent": "3",
      "description": "Welt footwear",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6403.12.6000",
      "rawHtsCode": "6403.12.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6403.19",
      "rawHtsCode": "6403.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.19.1000",
      "rawHtsCode": "6403.19.10.00",
      "superior": null,
      "indent": "5",
      "description": "Golf shoes",
      "units": [
        "prs."
      ],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.19.2000",
      "rawHtsCode": "6403.19.20.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6403.19.30",
      "rawHtsCode": "6403.19.30",
      "superior": null,
      "indent": "5",
      "description": "Golf shoes",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.19.3030",
      "rawHtsCode": "6403.19.30.30",
      "superior": null,
      "indent": "6",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.19.3090",
      "rawHtsCode": "6403.19.30.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.19.40",
      "rawHtsCode": "6403.19.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "4.3%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.19.4030",
      "rawHtsCode": "6403.19.40.30",
      "superior": null,
      "indent": "6",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.19.4090",
      "rawHtsCode": "6403.19.40.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.19.50",
      "rawHtsCode": "6403.19.50",
      "superior": null,
      "indent": "4",
      "description": "Golf shoes",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.19.5031",
      "rawHtsCode": "6403.19.50.31",
      "superior": null,
      "indent": "6",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.19.5061",
      "rawHtsCode": "6403.19.50.61",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.19.5091",
      "rawHtsCode": "6403.19.50.91",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.19.70",
      "rawHtsCode": "6403.19.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6403.19.7031",
      "rawHtsCode": "6403.19.70.31",
      "superior": null,
      "indent": "6",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.19.7061",
      "rawHtsCode": "6403.19.70.61",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.19.7091",
      "rawHtsCode": "6403.19.70.91",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.20.0000",
      "rawHtsCode": "6403.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Footwear with outer soles of leather, and uppers which consist of leather straps across the instep and around the big toe",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6403.40",
      "rawHtsCode": "6403.40",
      "superior": null,
      "indent": "1",
      "description": "Other footwear, incorporating a protective metal toe-cap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.40.30",
      "rawHtsCode": "6403.40.30",
      "superior": null,
      "indent": "2",
      "description": "Welt footwear",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.40.3030",
      "rawHtsCode": "6403.40.30.30",
      "superior": null,
      "indent": "3",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.40.3090",
      "rawHtsCode": "6403.40.30.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.40.6000",
      "rawHtsCode": "6403.40.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.51",
      "rawHtsCode": "6403.51",
      "superior": null,
      "indent": "2",
      "description": "Covering the ankle:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.51.1100",
      "rawHtsCode": "6403.51.11.00",
      "superior": null,
      "indent": "3",
      "description": "Footwear made on a base or platform of wood, not having an inner sole or a protective metal toe-cap",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6403.51.30",
      "rawHtsCode": "6403.51.30",
      "superior": null,
      "indent": "4",
      "description": "Welt footwear",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.51.3015",
      "rawHtsCode": "6403.51.30.15",
      "superior": null,
      "indent": "6",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.51.3030",
      "rawHtsCode": "6403.51.30.30",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.51.3060",
      "rawHtsCode": "6403.51.30.60",
      "superior": null,
      "indent": "5",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.51.3071",
      "rawHtsCode": "6403.51.30.71",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.51.60",
      "rawHtsCode": "6403.51.60",
      "superior": null,
      "indent": "5",
      "description": "For men, youths and boys",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.51.6015",
      "rawHtsCode": "6403.51.60.15",
      "superior": null,
      "indent": "7",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.51.6030",
      "rawHtsCode": "6403.51.60.30",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.51.6060",
      "rawHtsCode": "6403.51.60.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.51.90",
      "rawHtsCode": "6403.51.90",
      "superior": null,
      "indent": "5",
      "description": "For other persons",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.51.9015",
      "rawHtsCode": "6403.51.90.15",
      "superior": null,
      "indent": "7",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.51.9030",
      "rawHtsCode": "6403.51.90.30",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.51.9041",
      "rawHtsCode": "6403.51.90.41",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59",
      "rawHtsCode": "6403.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.1000",
      "rawHtsCode": "6403.59.10.00",
      "superior": null,
      "indent": "3",
      "description": "Footwear made on a base or platform of wood, not having an inner sole or a protective metal toe-cap",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6403.59.15",
      "rawHtsCode": "6403.59.15",
      "superior": null,
      "indent": "4",
      "description": "Turn or turned footwear",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,R,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.59.1520",
      "rawHtsCode": "6403.59.15.20",
      "superior": null,
      "indent": "5",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.1545",
      "rawHtsCode": "6403.59.15.45",
      "superior": null,
      "indent": "5",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.1561",
      "rawHtsCode": "6403.59.15.61",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.30",
      "rawHtsCode": "6403.59.30",
      "superior": null,
      "indent": "4",
      "description": "Welt footwear",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.59.3020",
      "rawHtsCode": "6403.59.30.20",
      "superior": null,
      "indent": "6",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.3040",
      "rawHtsCode": "6403.59.30.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.3060",
      "rawHtsCode": "6403.59.30.60",
      "superior": null,
      "indent": "5",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.3081",
      "rawHtsCode": "6403.59.30.81",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.60",
      "rawHtsCode": "6403.59.60",
      "superior": null,
      "indent": "5",
      "description": "For men, youths and boys",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.59.6040",
      "rawHtsCode": "6403.59.60.40",
      "superior": null,
      "indent": "7",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.6060",
      "rawHtsCode": "6403.59.60.60",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.6080",
      "rawHtsCode": "6403.59.60.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.90",
      "rawHtsCode": "6403.59.90",
      "superior": null,
      "indent": "5",
      "description": "For other persons",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.59.9030",
      "rawHtsCode": "6403.59.90.30",
      "superior": null,
      "indent": "7",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.9045",
      "rawHtsCode": "6403.59.90.45",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.59.9061",
      "rawHtsCode": "6403.59.90.61",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91",
      "rawHtsCode": "6403.91",
      "superior": null,
      "indent": "2",
      "description": "Covering the ankle:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.1100",
      "rawHtsCode": "6403.91.11.00",
      "superior": null,
      "indent": "3",
      "description": "Footwear made on a base or platform of wood, not having an inner sole or a protective metal toe-cap",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6403.91.30",
      "rawHtsCode": "6403.91.30",
      "superior": null,
      "indent": "4",
      "description": "Welt footwear",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.91.3010",
      "rawHtsCode": "6403.91.30.10",
      "superior": null,
      "indent": "6",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.3025",
      "rawHtsCode": "6403.91.30.25",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.3035",
      "rawHtsCode": "6403.91.30.35",
      "superior": null,
      "indent": "7",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.3040",
      "rawHtsCode": "6403.91.30.40",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.3080",
      "rawHtsCode": "6403.91.30.80",
      "superior": null,
      "indent": "6",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.3091",
      "rawHtsCode": "6403.91.30.91",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.60",
      "rawHtsCode": "6403.91.60",
      "superior": null,
      "indent": "5",
      "description": "For men, youths and boys",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.91.6010",
      "rawHtsCode": "6403.91.60.10",
      "superior": null,
      "indent": "6",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.6030",
      "rawHtsCode": "6403.91.60.30",
      "superior": null,
      "indent": "8",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.6040",
      "rawHtsCode": "6403.91.60.40",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.6050",
      "rawHtsCode": "6403.91.60.50",
      "superior": null,
      "indent": "8",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.6060",
      "rawHtsCode": "6403.91.60.60",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.6065",
      "rawHtsCode": "6403.91.60.65",
      "superior": null,
      "indent": "9",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.6075",
      "rawHtsCode": "6403.91.60.75",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.6090",
      "rawHtsCode": "6403.91.60.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.90",
      "rawHtsCode": "6403.91.90",
      "superior": null,
      "indent": "5",
      "description": "For other persons",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.91.9015",
      "rawHtsCode": "6403.91.90.15",
      "superior": null,
      "indent": "6",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.9025",
      "rawHtsCode": "6403.91.90.25",
      "superior": null,
      "indent": "8",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.9045",
      "rawHtsCode": "6403.91.90.45",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.91.9051",
      "rawHtsCode": "6403.91.90.51",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99",
      "rawHtsCode": "6403.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.1000",
      "rawHtsCode": "6403.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Footwear made on a base or platform of wood, not having an inner sole or a protective metal toe-cap",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6403.99.20",
      "rawHtsCode": "6403.99.20",
      "superior": null,
      "indent": "4",
      "description": "Footwear made on a base or platform of wood",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.99.2030",
      "rawHtsCode": "6403.99.20.30",
      "superior": null,
      "indent": "5",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.2060",
      "rawHtsCode": "6403.99.20.60",
      "superior": null,
      "indent": "5",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.2090",
      "rawHtsCode": "6403.99.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.40",
      "rawHtsCode": "6403.99.40",
      "superior": null,
      "indent": "5",
      "description": "Welt footwear",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.99.4010",
      "rawHtsCode": "6403.99.40.10",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.4020",
      "rawHtsCode": "6403.99.40.20",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.4035",
      "rawHtsCode": "6403.99.40.35",
      "superior": null,
      "indent": "8",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.4055",
      "rawHtsCode": "6403.99.40.55",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.4080",
      "rawHtsCode": "6403.99.40.80",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.4091",
      "rawHtsCode": "6403.99.40.91",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.60",
      "rawHtsCode": "6403.99.60",
      "superior": null,
      "indent": "6",
      "description": "For men, youths and boys",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.99.6015",
      "rawHtsCode": "6403.99.60.15",
      "superior": null,
      "indent": "7",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.6025",
      "rawHtsCode": "6403.99.60.25",
      "superior": null,
      "indent": "7",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.6030",
      "rawHtsCode": "6403.99.60.30",
      "superior": null,
      "indent": "9",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.6040",
      "rawHtsCode": "6403.99.60.40",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.6050",
      "rawHtsCode": "6403.99.60.50",
      "superior": null,
      "indent": "9",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.6060",
      "rawHtsCode": "6403.99.60.60",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.6065",
      "rawHtsCode": "6403.99.60.65",
      "superior": null,
      "indent": "10",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.6075",
      "rawHtsCode": "6403.99.60.75",
      "superior": null,
      "indent": "10",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.6090",
      "rawHtsCode": "6403.99.60.90",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.75",
      "rawHtsCode": "6403.99.75",
      "superior": null,
      "indent": "7",
      "description": "Valued not over $2.50/pair",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.99.7515",
      "rawHtsCode": "6403.99.75.15",
      "superior": null,
      "indent": "8",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.7530",
      "rawHtsCode": "6403.99.75.30",
      "superior": null,
      "indent": "10",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.7560",
      "rawHtsCode": "6403.99.75.60",
      "superior": null,
      "indent": "10",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.7590",
      "rawHtsCode": "6403.99.75.90",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.90",
      "rawHtsCode": "6403.99.90",
      "superior": null,
      "indent": "7",
      "description": "Valued over $2.50/pair",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6403.99.9005",
      "rawHtsCode": "6403.99.90.05",
      "superior": null,
      "indent": "8",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.9015",
      "rawHtsCode": "6403.99.90.15",
      "superior": null,
      "indent": "8",
      "description": "Work footwear",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.9021",
      "rawHtsCode": "6403.99.90.21",
      "superior": null,
      "indent": "10",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.9031",
      "rawHtsCode": "6403.99.90.31",
      "superior": null,
      "indent": "10",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.9041",
      "rawHtsCode": "6403.99.90.41",
      "superior": null,
      "indent": "9",
      "description": "Other tennis shoes, basketball shoes, and the like",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.9055",
      "rawHtsCode": "6403.99.90.55",
      "superior": null,
      "indent": "11",
      "description": "With pigskin uppers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.9065",
      "rawHtsCode": "6403.99.90.65",
      "superior": null,
      "indent": "11",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6403.99.9071",
      "rawHtsCode": "6403.99.90.71",
      "superior": null,
      "indent": "10",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404",
      "rawHtsCode": "6404",
      "superior": null,
      "indent": "0",
      "description": "Footwear with outer soles of rubber, plastics, leather or composition leather and uppers of textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11",
      "rawHtsCode": "6404.11",
      "superior": null,
      "indent": "2",
      "description": "Sports footwear; tennis shoes, basketball shoes, gym shoes, training shoes and the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.20",
      "rawHtsCode": "6404.11.20",
      "superior": null,
      "indent": "3",
      "description": "Having uppers of which over 50 percent of the external surface area (including any leather accessories or reinforcements such as those mentioned in note 4(a) to this chapter) is leather",
      "units": [],
      "generalRate": "10.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.2030",
      "rawHtsCode": "6404.11.20.30",
      "superior": null,
      "indent": "4",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.2060",
      "rawHtsCode": "6404.11.20.60",
      "superior": null,
      "indent": "4",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.2071",
      "rawHtsCode": "6404.11.20.71",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.41",
      "rawHtsCode": "6404.11.41",
      "superior": null,
      "indent": "6",
      "description": "With uppers of vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.4130",
      "rawHtsCode": "6404.11.41.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.4160",
      "rawHtsCode": "6404.11.41.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.4190",
      "rawHtsCode": "6404.11.41.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.4900",
      "rawHtsCode": "6404.11.49.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.51",
      "rawHtsCode": "6404.11.51",
      "superior": null,
      "indent": "6",
      "description": "With uppers of vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.5130",
      "rawHtsCode": "6404.11.51.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.5160",
      "rawHtsCode": "6404.11.51.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.5190",
      "rawHtsCode": "6404.11.51.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.5900",
      "rawHtsCode": "6404.11.59.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "48%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "84%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.61",
      "rawHtsCode": "6404.11.61",
      "superior": null,
      "indent": "6",
      "description": "With uppers of vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.6130",
      "rawHtsCode": "6404.11.61.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.6160",
      "rawHtsCode": "6404.11.61.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.6190",
      "rawHtsCode": "6404.11.61.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.69",
      "rawHtsCode": "6404.11.69",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.6930",
      "rawHtsCode": "6404.11.69.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.6960",
      "rawHtsCode": "6404.11.69.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.6990",
      "rawHtsCode": "6404.11.69.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.71",
      "rawHtsCode": "6404.11.71",
      "superior": null,
      "indent": "6",
      "description": "With uppers of vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.7130",
      "rawHtsCode": "6404.11.71.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.7160",
      "rawHtsCode": "6404.11.71.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.7190",
      "rawHtsCode": "6404.11.71.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.75",
      "rawHtsCode": "6404.11.75",
      "superior": null,
      "indent": "6",
      "description": "With uppers of textile materials other than vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.7530",
      "rawHtsCode": "6404.11.75.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.7560",
      "rawHtsCode": "6404.11.75.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.7590",
      "rawHtsCode": "6404.11.75.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.79",
      "rawHtsCode": "6404.11.79",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "90¢/pr. + 37.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "$1.58/pr. + 66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.7930",
      "rawHtsCode": "6404.11.79.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.7960",
      "rawHtsCode": "6404.11.79.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.7990",
      "rawHtsCode": "6404.11.79.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.81",
      "rawHtsCode": "6404.11.81",
      "superior": null,
      "indent": "5",
      "description": "With uppers of vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.8130",
      "rawHtsCode": "6404.11.81.30",
      "superior": null,
      "indent": "6",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.8160",
      "rawHtsCode": "6404.11.81.60",
      "superior": null,
      "indent": "6",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.8190",
      "rawHtsCode": "6404.11.81.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.85",
      "rawHtsCode": "6404.11.85",
      "superior": null,
      "indent": "5",
      "description": "With uppers of textile material other than vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.8530",
      "rawHtsCode": "6404.11.85.30",
      "superior": null,
      "indent": "6",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.8560",
      "rawHtsCode": "6404.11.85.60",
      "superior": null,
      "indent": "6",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.8590",
      "rawHtsCode": "6404.11.85.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.89",
      "rawHtsCode": "6404.11.89",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "90¢/pr. + 20%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "$1.58/pr. + 35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.8930",
      "rawHtsCode": "6404.11.89.30",
      "superior": null,
      "indent": "6",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.8960",
      "rawHtsCode": "6404.11.89.60",
      "superior": null,
      "indent": "6",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.8990",
      "rawHtsCode": "6404.11.89.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.90",
      "rawHtsCode": "6404.11.90",
      "superior": null,
      "indent": "4",
      "description": "Valued over $12/pair",
      "units": [],
      "generalRate": "20%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.11.9010",
      "rawHtsCode": "6404.11.90.10",
      "superior": null,
      "indent": "6",
      "description": "Ski boots, cross country ski footwear and snowboard boots",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.9020",
      "rawHtsCode": "6404.11.90.20",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.9040",
      "rawHtsCode": "6404.11.90.40",
      "superior": null,
      "indent": "6",
      "description": "Ski boots, cross country ski footwear and snowboard boots",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.9050",
      "rawHtsCode": "6404.11.90.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.9070",
      "rawHtsCode": "6404.11.90.70",
      "superior": null,
      "indent": "6",
      "description": "Ski boots, cross country ski footwear and snowboard boots",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.11.9080",
      "rawHtsCode": "6404.11.90.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19",
      "rawHtsCode": "6404.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.15",
      "rawHtsCode": "6404.19.15",
      "superior": null,
      "indent": "3",
      "description": "Footwear having uppers of which over 50 percent of the external surface area (including any leather accessories or reinforcements such as those mentioned in note 4(a) to this chapter) is leather",
      "units": [],
      "generalRate": "10.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.41.10 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.1520",
      "rawHtsCode": "6404.19.15.20",
      "superior": null,
      "indent": "4",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.1560",
      "rawHtsCode": "6404.19.15.60",
      "superior": null,
      "indent": "4",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.1581",
      "rawHtsCode": "6404.19.15.81",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.20",
      "rawHtsCode": "6404.19.20",
      "superior": null,
      "indent": "3",
      "description": "Footwear designed to be worn over, or in lieu of, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather",
      "units": [],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.2030",
      "rawHtsCode": "6404.19.20.30",
      "superior": null,
      "indent": "4",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.2060",
      "rawHtsCode": "6404.19.20.60",
      "superior": null,
      "indent": "4",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.2090",
      "rawHtsCode": "6404.19.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.25",
      "rawHtsCode": "6404.19.25",
      "superior": null,
      "indent": "5",
      "description": "With uppers of vegetable fibers",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.2515",
      "rawHtsCode": "6404.19.25.15",
      "superior": null,
      "indent": "7",
      "description": "Covering the ankle",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.2520",
      "rawHtsCode": "6404.19.25.20",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.2530",
      "rawHtsCode": "6404.19.25.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.2560",
      "rawHtsCode": "6404.19.25.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.2590",
      "rawHtsCode": "6404.19.25.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.30",
      "rawHtsCode": "6404.19.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.3015",
      "rawHtsCode": "6404.19.30.15",
      "superior": null,
      "indent": "7",
      "description": "Covering the ankle",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.3020",
      "rawHtsCode": "6404.19.30.20",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.3040",
      "rawHtsCode": "6404.19.30.40",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.3060",
      "rawHtsCode": "6404.19.30.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.3080",
      "rawHtsCode": "6404.19.30.80",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.36",
      "rawHtsCode": "6404.19.36",
      "superior": null,
      "indent": "5",
      "description": "With uppers of vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.3630",
      "rawHtsCode": "6404.19.36.30",
      "superior": null,
      "indent": "6",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.3660",
      "rawHtsCode": "6404.19.36.60",
      "superior": null,
      "indent": "6",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.3690",
      "rawHtsCode": "6404.19.36.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.37",
      "rawHtsCode": "6404.19.37",
      "superior": null,
      "indent": "5",
      "description": "With uppers of textile material other than vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.3715",
      "rawHtsCode": "6404.19.37.15",
      "superior": null,
      "indent": "6",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.3730",
      "rawHtsCode": "6404.19.37.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.3760",
      "rawHtsCode": "6404.19.37.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.3790",
      "rawHtsCode": "6404.19.37.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.39",
      "rawHtsCode": "6404.19.39",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.27.09 and 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.3915",
      "rawHtsCode": "6404.19.39.15",
      "superior": null,
      "indent": "6",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.3940",
      "rawHtsCode": "6404.19.39.40",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.3960",
      "rawHtsCode": "6404.19.39.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.3980",
      "rawHtsCode": "6404.19.39.80",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.42",
      "rawHtsCode": "6404.19.42",
      "superior": null,
      "indent": "6",
      "description": "With uppers of vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S.note 5 to this chapter",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.4230",
      "rawHtsCode": "6404.19.42.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.4260",
      "rawHtsCode": "6404.19.42.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.4290",
      "rawHtsCode": "6404.19.42.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.47",
      "rawHtsCode": "6404.19.47",
      "superior": null,
      "indent": "6",
      "description": "With uppers of textile material other than vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.4715",
      "rawHtsCode": "6404.19.47.15",
      "superior": null,
      "indent": "7",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.4730",
      "rawHtsCode": "6404.19.47.30",
      "superior": null,
      "indent": "8",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.4760",
      "rawHtsCode": "6404.19.47.60",
      "superior": null,
      "indent": "8",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.4790",
      "rawHtsCode": "6404.19.47.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.49",
      "rawHtsCode": "6404.19.49",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,R,S, SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.4930",
      "rawHtsCode": "6404.19.49.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.4960",
      "rawHtsCode": "6404.19.49.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.4990",
      "rawHtsCode": "6404.19.49.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.52",
      "rawHtsCode": "6404.19.52",
      "superior": null,
      "indent": "6",
      "description": "With uppers of vegetable fibers and having outer soles with textile textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.5230",
      "rawHtsCode": "6404.19.52.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.5260",
      "rawHtsCode": "6404.19.52.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.5290",
      "rawHtsCode": "6404.19.52.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.57",
      "rawHtsCode": "6404.19.57",
      "superior": null,
      "indent": "6",
      "description": "With uppers of textile material other than vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.5715",
      "rawHtsCode": "6404.19.57.15",
      "superior": null,
      "indent": "7",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.5730",
      "rawHtsCode": "6404.19.57.30",
      "superior": null,
      "indent": "8",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.5760",
      "rawHtsCode": "6404.19.57.60",
      "superior": null,
      "indent": "8",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.5790",
      "rawHtsCode": "6404.19.57.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.59",
      "rawHtsCode": "6404.19.59",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "48%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "84%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.5915",
      "rawHtsCode": "6404.19.59.15",
      "superior": null,
      "indent": "7",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.5930",
      "rawHtsCode": "6404.19.59.30",
      "superior": null,
      "indent": "8",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.5960",
      "rawHtsCode": "6404.19.59.60",
      "superior": null,
      "indent": "8",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.5990",
      "rawHtsCode": "6404.19.59.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.61",
      "rawHtsCode": "6404.19.61",
      "superior": null,
      "indent": "6",
      "description": "With uppers of textile material other than vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.6115",
      "rawHtsCode": "6404.19.61.15",
      "superior": null,
      "indent": "7",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.6130",
      "rawHtsCode": "6404.19.61.30",
      "superior": null,
      "indent": "8",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.6160",
      "rawHtsCode": "6404.19.61.60",
      "superior": null,
      "indent": "8",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.6190",
      "rawHtsCode": "6404.19.61.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.69",
      "rawHtsCode": "6404.19.69",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.6930",
      "rawHtsCode": "6404.19.69.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.6960",
      "rawHtsCode": "6404.19.69.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.6990",
      "rawHtsCode": "6404.19.69.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.72",
      "rawHtsCode": "6404.19.72",
      "superior": null,
      "indent": "6",
      "description": "With uppers of vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.7230",
      "rawHtsCode": "6404.19.72.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.7260",
      "rawHtsCode": "6404.19.72.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.7290",
      "rawHtsCode": "6404.19.72.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.77",
      "rawHtsCode": "6404.19.77",
      "superior": null,
      "indent": "6",
      "description": "With uppers of textile material other than vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.7715",
      "rawHtsCode": "6404.19.77.15",
      "superior": null,
      "indent": "7",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.7730",
      "rawHtsCode": "6404.19.77.30",
      "superior": null,
      "indent": "8",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.7760",
      "rawHtsCode": "6404.19.77.60",
      "superior": null,
      "indent": "8",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.7790",
      "rawHtsCode": "6404.19.77.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.79",
      "rawHtsCode": "6404.19.79",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "90¢/pr. + 37.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "$1.58/pr. + 66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.7915",
      "rawHtsCode": "6404.19.79.15",
      "superior": null,
      "indent": "7",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.7930",
      "rawHtsCode": "6404.19.79.30",
      "superior": null,
      "indent": "8",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.7960",
      "rawHtsCode": "6404.19.79.60",
      "superior": null,
      "indent": "8",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.7990",
      "rawHtsCode": "6404.19.79.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.82",
      "rawHtsCode": "6404.19.82",
      "superior": null,
      "indent": "5",
      "description": "Wither uppers of vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.8230",
      "rawHtsCode": "6404.19.82.30",
      "superior": null,
      "indent": "6",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.8260",
      "rawHtsCode": "6404.19.82.60",
      "superior": null,
      "indent": "6",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.8290",
      "rawHtsCode": "6404.19.82.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.87",
      "rawHtsCode": "6404.19.87",
      "superior": null,
      "indent": "5",
      "description": "With uppers of textile material other than vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to this chapter",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.8715",
      "rawHtsCode": "6404.19.87.15",
      "superior": null,
      "indent": "6",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.8730",
      "rawHtsCode": "6404.19.87.30",
      "superior": null,
      "indent": "7",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.8760",
      "rawHtsCode": "6404.19.87.60",
      "superior": null,
      "indent": "7",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.8790",
      "rawHtsCode": "6404.19.87.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.89",
      "rawHtsCode": "6404.19.89",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "90¢/pr. + 20%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "$1.58/pr. + 35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.8930",
      "rawHtsCode": "6404.19.89.30",
      "superior": null,
      "indent": "6",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.8960",
      "rawHtsCode": "6404.19.89.60",
      "superior": null,
      "indent": "6",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.8990",
      "rawHtsCode": "6404.19.89.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.90",
      "rawHtsCode": "6404.19.90",
      "superior": null,
      "indent": "4",
      "description": "Valued over $12/pair",
      "units": [],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.19.9030",
      "rawHtsCode": "6404.19.90.30",
      "superior": null,
      "indent": "5",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.9060",
      "rawHtsCode": "6404.19.90.60",
      "superior": null,
      "indent": "5",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.19.9090",
      "rawHtsCode": "6404.19.90.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.20",
      "rawHtsCode": "6404.20",
      "superior": null,
      "indent": "1",
      "description": "Footwear with outer soles of leather or composition leather:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.20.20",
      "rawHtsCode": "6404.20.20",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $2.50/pair",
      "units": [],
      "generalRate": "15%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.20.2030",
      "rawHtsCode": "6404.20.20.30",
      "superior": null,
      "indent": "4",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.20.2060",
      "rawHtsCode": "6404.20.20.60",
      "superior": null,
      "indent": "4",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.20.2090",
      "rawHtsCode": "6404.20.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.20.40",
      "rawHtsCode": "6404.20.40",
      "superior": null,
      "indent": "3",
      "description": "Valued over $2.50/pair",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.20.4030",
      "rawHtsCode": "6404.20.40.30",
      "superior": null,
      "indent": "4",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.20.4060",
      "rawHtsCode": "6404.20.40.60",
      "superior": null,
      "indent": "4",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.20.4090",
      "rawHtsCode": "6404.20.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.20.60",
      "rawHtsCode": "6404.20.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "37.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA, PE,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6404.20.6040",
      "rawHtsCode": "6404.20.60.40",
      "superior": null,
      "indent": "3",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.20.6060",
      "rawHtsCode": "6404.20.60.60",
      "superior": null,
      "indent": "3",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6404.20.6080",
      "rawHtsCode": "6404.20.60.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405",
      "rawHtsCode": "6405",
      "superior": null,
      "indent": "0",
      "description": "Other footwear:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.10.00",
      "rawHtsCode": "6405.10.00",
      "superior": null,
      "indent": "1",
      "description": "With uppers of leather or composition leather",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6405.10.0030",
      "rawHtsCode": "6405.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.10.0060",
      "rawHtsCode": "6405.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.10.0090",
      "rawHtsCode": "6405.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20",
      "rawHtsCode": "6405.20",
      "superior": null,
      "indent": "1",
      "description": "With uppers of textile materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20.30",
      "rawHtsCode": "6405.20.30",
      "superior": null,
      "indent": "2",
      "description": "With uppers of vegetable fibers",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6405.20.3030",
      "rawHtsCode": "6405.20.30.30",
      "superior": null,
      "indent": "3",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20.3060",
      "rawHtsCode": "6405.20.30.60",
      "superior": null,
      "indent": "3",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20.3070",
      "rawHtsCode": "6405.20.30.70",
      "superior": null,
      "indent": "3",
      "description": "For infants, as described in statistical note 2 to this chapter",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20.3080",
      "rawHtsCode": "6405.20.30.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20.60",
      "rawHtsCode": "6405.20.60",
      "superior": null,
      "indent": "2",
      "description": "With soles and uppers of wool felt",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6405.20.6030",
      "rawHtsCode": "6405.20.60.30",
      "superior": null,
      "indent": "3",
      "description": "For men (459)",
      "units": [
        "prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20.6060",
      "rawHtsCode": "6405.20.60.60",
      "superior": null,
      "indent": "3",
      "description": "For women (459)",
      "units": [
        "prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20.6090",
      "rawHtsCode": "6405.20.60.90",
      "superior": null,
      "indent": "3",
      "description": "Other (459)",
      "units": [
        "prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20.90",
      "rawHtsCode": "6405.20.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6405.20.9015",
      "rawHtsCode": "6405.20.90.15",
      "superior": null,
      "indent": "3",
      "description": "House slippers",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20.9030",
      "rawHtsCode": "6405.20.90.30",
      "superior": null,
      "indent": "4",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20.9060",
      "rawHtsCode": "6405.20.90.60",
      "superior": null,
      "indent": "4",
      "description": "For women",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20.9070",
      "rawHtsCode": "6405.20.90.70",
      "superior": null,
      "indent": "4",
      "description": "For infants, as described in statistical note 2 to this chapter",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.20.9080",
      "rawHtsCode": "6405.20.90.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.90",
      "rawHtsCode": "6405.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.90.2000",
      "rawHtsCode": "6405.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Disposable footwear, designed for one-time use",
      "units": [
        "prs."
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6405.90.90",
      "rawHtsCode": "6405.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "12.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6405.90.9030",
      "rawHtsCode": "6405.90.90.30",
      "superior": null,
      "indent": "3",
      "description": "For infants, as described in statistical note 2 to this chapter",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6405.90.9060",
      "rawHtsCode": "6405.90.90.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406",
      "rawHtsCode": "6406",
      "superior": null,
      "indent": "0",
      "description": "Parts of footwear (including uppers whether or not attached to soles other than outer soles); removable insoles, heel cushions and similar articles; gaiters, leggings and similar articles, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.10",
      "rawHtsCode": "6406.10",
      "superior": null,
      "indent": "1",
      "description": "Uppers and parts thereof, other than stiffeners:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.10.0500",
      "rawHtsCode": "6406.10.05.00",
      "superior": null,
      "indent": "4",
      "description": "For men, youths and boys",
      "units": [
        "prs."
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.1000",
      "rawHtsCode": "6406.10.10.00",
      "superior": null,
      "indent": "4",
      "description": "For other persons",
      "units": [
        "prs."
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,R,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.20",
      "rawHtsCode": "6406.10.20",
      "superior": null,
      "indent": "4",
      "description": "Of which over 50 percent of the external surface area (including any leather accessories or reinforcements such as those mentioned in note 4(a) to this chapter) is leather",
      "units": [],
      "generalRate": "10.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,R,S, SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.2031",
      "rawHtsCode": "6406.10.20.31",
      "superior": null,
      "indent": "5",
      "description": "For men",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.10.2061",
      "rawHtsCode": "6406.10.20.61",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.10.2500",
      "rawHtsCode": "6406.10.25.00",
      "superior": null,
      "indent": "5",
      "description": "Valued not over $3/pair",
      "units": [
        "prs."
      ],
      "generalRate": "33.6%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "84%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.3000",
      "rawHtsCode": "6406.10.30.00",
      "superior": null,
      "indent": "5",
      "description": "Valued over $3 but not over $6.50/pair",
      "units": [
        "prs."
      ],
      "generalRate": "63¢/pr. + 26.2%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "$1.58/pr. + 66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.3500",
      "rawHtsCode": "6406.10.35.00",
      "superior": null,
      "indent": "5",
      "description": "Valued over $6.50 but not over $12/pair",
      "units": [
        "prs."
      ],
      "generalRate": "62¢/pr. + 13.7%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "$1.58/pr. + 35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.4000",
      "rawHtsCode": "6406.10.40.00",
      "superior": null,
      "indent": "5",
      "description": "Valued over $12/pair",
      "units": [
        "prs."
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.4500",
      "rawHtsCode": "6406.10.45.00",
      "superior": null,
      "indent": "4",
      "description": "Of which over 90 percent of the external surface area (including any accessories or reinforcements such as those mentioned in note 4(a) to this chapter) is rubber or plastics and not suitable to be finished into footwear (1) having foxing or a foxing-like band applied or molded at the sole and overlapping the upper, or (2) designed to be worn over, or in lieu of, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather",
      "units": [
        "prs."
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.5000",
      "rawHtsCode": "6406.10.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "26.2%",
      "specialRate": "Free (AU,BH, CL,CO,D,IL,JO, KR,MA,OM, P,PA,PE,R,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.6000",
      "rawHtsCode": "6406.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of rubber or plastics",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6406.10.6500",
      "rawHtsCode": "6406.10.65.00",
      "superior": null,
      "indent": "3",
      "description": "Of leather",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6406.10.7000",
      "rawHtsCode": "6406.10.70.00",
      "superior": null,
      "indent": "3",
      "description": "Of textile materials of which over 50 percent of the external surface area (including any leather accessories or reinforcements such as those mentioned in note 4(a) to this chapter) is leather",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6406.10.7200",
      "rawHtsCode": "6406.10.72.00",
      "superior": null,
      "indent": "5",
      "description": "Uppers of which less than 50 percent of the external surface area (including any leather, rubber or plastics accessories or reinforcements such as those mentioned in note 4(a) to this chapter) is textile materials",
      "units": [
        "prs."
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "62.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.7700",
      "rawHtsCode": "6406.10.77.00",
      "superior": null,
      "indent": "5",
      "description": "Other (369)",
      "units": [
        "prs.",
        "kg"
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "62.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.8500",
      "rawHtsCode": "6406.10.85.00",
      "superior": null,
      "indent": "5",
      "description": "Uppers of which less than 50 percent of the external surface area (including any leather, rubber or plastics accessories or reinforcements such as those mentioned in note 4(a) to this chapter) is textile materials",
      "units": [
        "prs."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.90",
      "rawHtsCode": "6406.10.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.10.9020",
      "rawHtsCode": "6406.10.90.20",
      "superior": null,
      "indent": "7",
      "description": "Of wool or fine animal hair (469)",
      "units": [
        "prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.10.9040",
      "rawHtsCode": "6406.10.90.40",
      "superior": null,
      "indent": "7",
      "description": "Of man-made fibers (669)",
      "units": [
        "prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.10.9060",
      "rawHtsCode": "6406.10.90.60",
      "superior": null,
      "indent": "7",
      "description": "Other (899)",
      "units": [
        "prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.10.9090",
      "rawHtsCode": "6406.10.90.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "prs.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.20.0000",
      "rawHtsCode": "6406.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Outer soles and heels, of rubber or plastics",
      "units": [
        "prs.",
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.90",
      "rawHtsCode": "6406.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.90.1000",
      "rawHtsCode": "6406.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of wood",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.90.15",
      "rawHtsCode": "6406.90.15",
      "superior": null,
      "indent": "3",
      "description": "Of textile materials",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "72%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.90.1505",
      "rawHtsCode": "6406.90.15.05",
      "superior": null,
      "indent": "6",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.90.1510",
      "rawHtsCode": "6406.90.15.10",
      "superior": null,
      "indent": "6",
      "description": "Other (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.90.1540",
      "rawHtsCode": "6406.90.15.40",
      "superior": null,
      "indent": "5",
      "description": "Other (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.90.1550",
      "rawHtsCode": "6406.90.15.50",
      "superior": null,
      "indent": "6",
      "description": "Of cotton (359)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.90.1560",
      "rawHtsCode": "6406.90.15.60",
      "superior": null,
      "indent": "6",
      "description": "Of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.90.1570",
      "rawHtsCode": "6406.90.15.70",
      "superior": null,
      "indent": "6",
      "description": "Other (859)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.90.1580",
      "rawHtsCode": "6406.90.15.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.90.30",
      "rawHtsCode": "6406.90.30",
      "superior": null,
      "indent": "3",
      "description": "Of rubber or plastics",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6406.90.3030",
      "rawHtsCode": "6406.90.30.30",
      "superior": null,
      "indent": "4",
      "description": "Bottoms",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.90.3060",
      "rawHtsCode": "6406.90.30.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6406.90.6000",
      "rawHtsCode": "6406.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of leather",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6406.90.9000",
      "rawHtsCode": "6406.90.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6501.00",
      "rawHtsCode": "6501.00",
      "superior": null,
      "indent": "0",
      "description": "Hat forms, hat bodies and hoods of felt, neither blocked to shape nor with made brims; plateaux and manchons (including slit manchons), of felt:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6501.00.3000",
      "rawHtsCode": "6501.00.30.00",
      "superior": null,
      "indent": "2",
      "description": "For men or boys",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$16/doz. + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6501.00.6000",
      "rawHtsCode": "6501.00.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "96¢/doz. + 1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$16/doz. + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6501.00.9000",
      "rawHtsCode": "6501.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other (459)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "10.3¢/kg + 10.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "88.2¢/kg + 55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6502.00",
      "rawHtsCode": "6502.00",
      "superior": null,
      "indent": "0",
      "description": "Hat shapes, plaited or made by assembling strips of any material, neither blocked to shape, nor with made brims, not lined, nor trimmed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6502.00.2000",
      "rawHtsCode": "6502.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "Sewed",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "34¢/doz. + 3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$3/doz. + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6502.00.4000",
      "rawHtsCode": "6502.00.40.00",
      "superior": null,
      "indent": "3",
      "description": "Not bleached and not colored",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6502.00.60",
      "rawHtsCode": "6502.00.60",
      "superior": null,
      "indent": "3",
      "description": "Bleached or colored",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25¢/doz. + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6502.00.6030",
      "rawHtsCode": "6502.00.60.30",
      "superior": null,
      "indent": "4",
      "description": "Of paper",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6502.00.6060",
      "rawHtsCode": "6502.00.60.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6502.00.90",
      "rawHtsCode": "6502.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "6.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6502.00.9030",
      "rawHtsCode": "6502.00.90.30",
      "superior": null,
      "indent": "2",
      "description": "Of man-made fibers (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6502.00.9060",
      "rawHtsCode": "6502.00.90.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6504.00",
      "rawHtsCode": "6504.00",
      "superior": null,
      "indent": "0",
      "description": "Hats and other headgear, plaited or made by assembling strips of any material, whether or not lined or trimmed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6504.00.3000",
      "rawHtsCode": "6504.00.30.00",
      "superior": null,
      "indent": "2",
      "description": "Sewed",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$3/doz. + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6504.00.6000",
      "rawHtsCode": "6504.00.60.00",
      "superior": null,
      "indent": "2",
      "description": "Not sewed",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "94¢/doz. + 4.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$3.50/doz. + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6504.00.90",
      "rawHtsCode": "6504.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "6.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA,NP,OM,P,PA, PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6504.00.9015",
      "rawHtsCode": "6504.00.90.15",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6504.00.9045",
      "rawHtsCode": "6504.00.90.45",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6504.00.9060",
      "rawHtsCode": "6504.00.90.60",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers (659)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6504.00.9075",
      "rawHtsCode": "6504.00.90.75",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00",
      "rawHtsCode": "6505.00",
      "superior": null,
      "indent": "0",
      "description": "Hats and other headgear, knitted or crocheted, or made up from lace, felt or other textile fabric, in the piece (but not in strips), whether or not lined or trimmed; hair-nets of any material, whether or not lined or trimmed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.0100",
      "rawHtsCode": "6505.00.01.00",
      "superior": null,
      "indent": "1",
      "description": "Hair-nets",
      "units": [
        "kg"
      ],
      "generalRate": "9.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "As shown in Pres. Proc. 8771; general rate should be 9.4% and column 2 rate should be 90% based on prior provisions. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6505.00.04",
      "rawHtsCode": "6505.00.04",
      "superior": null,
      "indent": "3",
      "description": "Of fur felt",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$16/doz. + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6505.00.0410",
      "rawHtsCode": "6505.00.04.10",
      "superior": null,
      "indent": "4",
      "description": "For men or boys",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.0450",
      "rawHtsCode": "6505.00.04.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.0800",
      "rawHtsCode": "6505.00.08.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "13.5¢/kg + 6.3% + 1.9¢/article",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "88.2¢/kg + 55% + 12.5¢/ article",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6505.00.15",
      "rawHtsCode": "6505.00.15",
      "superior": null,
      "indent": "4",
      "description": "Knitted",
      "units": [],
      "generalRate": "7.9%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6505.00.1515",
      "rawHtsCode": "6505.00.15.15",
      "superior": null,
      "indent": "6",
      "description": "For babies (239)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.1525",
      "rawHtsCode": "6505.00.15.25",
      "superior": null,
      "indent": "7",
      "description": "Visors, and other headgear which provides no covering for the crown of the head (359)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.1540",
      "rawHtsCode": "6505.00.15.40",
      "superior": null,
      "indent": "7",
      "description": "Other (359)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.1560",
      "rawHtsCode": "6505.00.15.60",
      "superior": null,
      "indent": "5",
      "description": "Other (859)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.20",
      "rawHtsCode": "6505.00.20",
      "superior": null,
      "indent": "5",
      "description": "Certified hand-loomed and folklore products; and headwear of cotton",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL, JO,KR,MA, NP,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6505.00.2030",
      "rawHtsCode": "6505.00.20.30",
      "superior": null,
      "indent": "6",
      "description": "For babies (239)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.2060",
      "rawHtsCode": "6505.00.20.60",
      "superior": null,
      "indent": "6",
      "description": "Other (359)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.25",
      "rawHtsCode": "6505.00.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6505.00.2545",
      "rawHtsCode": "6505.00.25.45",
      "superior": null,
      "indent": "6",
      "description": "Visors, and other headgear of cotton which provides no covering for the crown of the head (359)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.2590",
      "rawHtsCode": "6505.00.25.90",
      "superior": null,
      "indent": "6",
      "description": "Other (859)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.30",
      "rawHtsCode": "6505.00.30",
      "superior": null,
      "indent": "4",
      "description": "Knitted or crocheted or made up from knitted or crocheted fabric",
      "units": [],
      "generalRate": "25.4¢/kg + 7.7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "$1.10/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6505.00.3030",
      "rawHtsCode": "6505.00.30.30",
      "superior": null,
      "indent": "5",
      "description": "For babies (439)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.3045",
      "rawHtsCode": "6505.00.30.45",
      "superior": null,
      "indent": "6",
      "description": "Visors, and other headgear which provides no covering for the crown of the head (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.3090",
      "rawHtsCode": "6505.00.30.90",
      "superior": null,
      "indent": "6",
      "description": "Other (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.40",
      "rawHtsCode": "6505.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "31¢/kg + 7.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "$1.10/kg + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6505.00.4030",
      "rawHtsCode": "6505.00.40.30",
      "superior": null,
      "indent": "5",
      "description": "For babies (439)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.4045",
      "rawHtsCode": "6505.00.40.45",
      "superior": null,
      "indent": "6",
      "description": "Visors, and other headgear which provides no covering for the crown of the head (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.4090",
      "rawHtsCode": "6505.00.40.90",
      "superior": null,
      "indent": "6",
      "description": "Other (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.50",
      "rawHtsCode": "6505.00.50",
      "superior": null,
      "indent": "5",
      "description": "Wholly or in part of braid",
      "units": [],
      "generalRate": "6.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6505.00.5030",
      "rawHtsCode": "6505.00.50.30",
      "superior": null,
      "indent": "6",
      "description": "For babies (239)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.5045",
      "rawHtsCode": "6505.00.50.45",
      "superior": null,
      "indent": "7",
      "description": "Visors, and other headgear which provides no covering for the crown of the head (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.5090",
      "rawHtsCode": "6505.00.50.90",
      "superior": null,
      "indent": "7",
      "description": "Other (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.60",
      "rawHtsCode": "6505.00.60",
      "superior": null,
      "indent": "5",
      "description": "Not in part of braid",
      "units": [],
      "generalRate": "20¢/kg + 7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "99.2¢/kg + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6505.00.6030",
      "rawHtsCode": "6505.00.60.30",
      "superior": null,
      "indent": "6",
      "description": "For babies (239)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.6040",
      "rawHtsCode": "6505.00.60.40",
      "superior": null,
      "indent": "7",
      "description": "Containing 23 percent or more by weight of wool or fine animal hair (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.6045",
      "rawHtsCode": "6505.00.60.45",
      "superior": null,
      "indent": "8",
      "description": "Visors, and other headgear which provides no covering for the crown of the head (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.6090",
      "rawHtsCode": "6505.00.60.90",
      "superior": null,
      "indent": "8",
      "description": "Other (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.70",
      "rawHtsCode": "6505.00.70",
      "superior": null,
      "indent": "5",
      "description": "Wholly or in part of braid",
      "units": [],
      "generalRate": "6.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6505.00.7030",
      "rawHtsCode": "6505.00.70.30",
      "superior": null,
      "indent": "6",
      "description": "For babies (239)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.7045",
      "rawHtsCode": "6505.00.70.45",
      "superior": null,
      "indent": "7",
      "description": "Visors, and other headgear which provides no covering for the crown of the head (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.7090",
      "rawHtsCode": "6505.00.70.90",
      "superior": null,
      "indent": "7",
      "description": "Other (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.80",
      "rawHtsCode": "6505.00.80",
      "superior": null,
      "indent": "5",
      "description": "Not in part of braid",
      "units": [],
      "generalRate": "18.7¢/kg + 6.8%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "99.2¢/kg + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6505.00.8015",
      "rawHtsCode": "6505.00.80.15",
      "superior": null,
      "indent": "6",
      "description": "Nonwoven disposable headgear without peaks or visors",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "6505.00.8045",
      "rawHtsCode": "6505.00.80.45",
      "superior": null,
      "indent": "7",
      "description": "For babies (239)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.8050",
      "rawHtsCode": "6505.00.80.50",
      "superior": null,
      "indent": "8",
      "description": "Visors, and other headgear which provides no covering for the crown of the head (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.8090",
      "rawHtsCode": "6505.00.80.90",
      "superior": null,
      "indent": "8",
      "description": "Other (659)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.90",
      "rawHtsCode": "6505.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "20.7¢/kg + 7.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL, JO,KR,MA,NP,OM,P, PA,PE,S,SG)",
      "otherRate": "99.2¢/kg + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "As shown in Pres. Proc. 8771; E* omitted based on previous provision.",
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6505.00.9030",
      "rawHtsCode": "6505.00.90.30",
      "superior": null,
      "indent": "4",
      "description": "Containing 70 percent or more by weight of silk or silk waste (759)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.9045",
      "rawHtsCode": "6505.00.90.45",
      "superior": null,
      "indent": "5",
      "description": "Of fine animal hair (459)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.9050",
      "rawHtsCode": "6505.00.90.50",
      "superior": null,
      "indent": "5",
      "description": "Of paper yarn",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.9076",
      "rawHtsCode": "6505.00.90.76",
      "superior": null,
      "indent": "6",
      "description": "Of unspun vegetable fibers",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6505.00.9089",
      "rawHtsCode": "6505.00.90.89",
      "superior": null,
      "indent": "6",
      "description": "Other (859)",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6506",
      "rawHtsCode": "6506",
      "superior": null,
      "indent": "0",
      "description": "Other headgear, whether or not lined or trimmed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6506.10",
      "rawHtsCode": "6506.10",
      "superior": null,
      "indent": "1",
      "description": "Safety headgear:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6506.10.30",
      "rawHtsCode": "6506.10.30",
      "superior": null,
      "indent": "2",
      "description": "Of reinforced or laminated plastics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.10/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6506.10.3030",
      "rawHtsCode": "6506.10.30.30",
      "superior": null,
      "indent": "3",
      "description": "Motorcycle helmets",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6506.10.3045",
      "rawHtsCode": "6506.10.30.45",
      "superior": null,
      "indent": "4",
      "description": "Athletic, recreational and sporting headgear",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6506.10.3075",
      "rawHtsCode": "6506.10.30.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6506.10.60",
      "rawHtsCode": "6506.10.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6506.10.6030",
      "rawHtsCode": "6506.10.60.30",
      "superior": null,
      "indent": "3",
      "description": "Motorcycle helmets",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "6506.10.6045",
      "rawHtsCode": "6506.10.60.45",
      "superior": null,
      "indent": "4",
      "description": "Athletic, recreational and sporting headgear",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "6506.10.6075",
      "rawHtsCode": "6506.10.60.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6506.91.00",
      "rawHtsCode": "6506.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of rubber or plastics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6506.91.0030",
      "rawHtsCode": "6506.91.00.30",
      "superior": null,
      "indent": "3",
      "description": "Bathing caps",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6506.91.0045",
      "rawHtsCode": "6506.91.00.45",
      "superior": null,
      "indent": "3",
      "description": "Visors, or other headgear which provides no covering for the crown of the head",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6506.91.0060",
      "rawHtsCode": "6506.91.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6506.99",
      "rawHtsCode": "6506.99",
      "superior": null,
      "indent": "2",
      "description": "Of other materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6506.99.3000",
      "rawHtsCode": "6506.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of furskin",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6506.99.6000",
      "rawHtsCode": "6506.99.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,NP,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6507.00.0000",
      "rawHtsCode": "6507.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Headbands, linings, covers, hat foundations, hat frames, peaks (visors) and chin straps, for headgear",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6601",
      "rawHtsCode": "6601",
      "superior": null,
      "indent": "0",
      "description": "Umbrellas and sun umbrellas (including walking-stick umbrellas, garden umbrellas and similar umbrellas):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6601.10.0000",
      "rawHtsCode": "6601.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Garden or similar umbrellas",
      "units": [
        "doz."
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6601.91.0000",
      "rawHtsCode": "6601.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Having a telescopic shaft",
      "units": [
        "doz."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6601.99.0000",
      "rawHtsCode": "6601.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "doz."
      ],
      "generalRate": "8.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6602.00.0000",
      "rawHtsCode": "6602.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Walking-sticks, seat-sticks, whips, riding-crops and the like",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6603",
      "rawHtsCode": "6603",
      "superior": null,
      "indent": "0",
      "description": "Parts, trimmings and accessories of articles of heading 6601 or 6602:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6603.20",
      "rawHtsCode": "6603.20",
      "superior": null,
      "indent": "1",
      "description": "Umbrella frames, including frames mounted on shafts (sticks):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6603.20.3000",
      "rawHtsCode": "6603.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "For hand-held umbrellas chiefly used for protection against rain",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6603.20.9000",
      "rawHtsCode": "6603.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "12%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6603.90",
      "rawHtsCode": "6603.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6603.90.4100",
      "rawHtsCode": "6603.90.41.00",
      "superior": null,
      "indent": "2",
      "description": "Umbrella handles, knobs, tips and caps",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6603.90.8100",
      "rawHtsCode": "6603.90.81.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6701.00",
      "rawHtsCode": "6701.00",
      "superior": null,
      "indent": "0",
      "description": "Skins and other parts of birds with their feathers or down, feathers, parts of feathers, down and articles thereof (other than goods of heading 0505 and worked quills and scapes):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6701.00.3000",
      "rawHtsCode": "6701.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Articles of feathers or down",
      "units": [
        "No."
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6701.00.6000",
      "rawHtsCode": "6701.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6702",
      "rawHtsCode": "6702",
      "superior": null,
      "indent": "0",
      "description": "Artificial flowers, foliage and fruit and parts thereof; articles made of artificial flowers, foliage or fruit:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6702.10",
      "rawHtsCode": "6702.10",
      "superior": null,
      "indent": "1",
      "description": "Of plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6702.10.2000",
      "rawHtsCode": "6702.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Assembled by binding with flexible materials such as wire, paper, textile materials, or foil, or by gluing or by similar methods",
      "units": [
        "No."
      ],
      "generalRate": "8.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6702.10.4000",
      "rawHtsCode": "6702.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other, including parts",
      "units": [
        "No."
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6702.90",
      "rawHtsCode": "6702.90",
      "superior": null,
      "indent": "1",
      "description": "Of other materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6702.90.1000",
      "rawHtsCode": "6702.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of feathers",
      "units": [
        "No."
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6702.90.3500",
      "rawHtsCode": "6702.90.35.00",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers",
      "units": [
        "No."
      ],
      "generalRate": "9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "71.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6702.90.6500",
      "rawHtsCode": "6702.90.65.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "17%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6703.00",
      "rawHtsCode": "6703.00",
      "superior": null,
      "indent": "0",
      "description": "Human hair, dressed, thinned, bleached or otherwise worked; wool or other animal hair or other textile materials, prepared for use in making wigs or the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6703.00.3000",
      "rawHtsCode": "6703.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Human hair",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6703.00.6000",
      "rawHtsCode": "6703.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6704",
      "rawHtsCode": "6704",
      "superior": null,
      "indent": "0",
      "description": "Wigs, false beards, eyebrows and eyelashes, switches and the like, of human or animal hair or of textile materials; articles of human hair not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6704.11.0000",
      "rawHtsCode": "6704.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Complete wigs",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6704.19.0000",
      "rawHtsCode": "6704.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6704.20.0000",
      "rawHtsCode": "6704.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of human hair",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6704.90.0000",
      "rawHtsCode": "6704.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of other materials",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6801.00.0000",
      "rawHtsCode": "6801.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Setts, curbstones and flagstones, of natural stone (except slate)",
      "units": [
        "t"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802",
      "rawHtsCode": "6802",
      "superior": null,
      "indent": "0",
      "description": "Worked monumental or building stone (except slate) and articles thereof, other than goods of heading 6801; mosaic cubes and the like, of natural stone (including slate), whether or not on a backing; artificially colored granules, chippings and powder, of natural stone (including slate):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.10.0000",
      "rawHtsCode": "6802.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tiles, cubes and similar articles, whether or not rectangular (including square), the largest face of which is capable of being enclosed in a square the side of which is less than <il>7 cm</il>; artificially colored granules, chippings and powder",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.21",
      "rawHtsCode": "6802.21",
      "superior": null,
      "indent": "2",
      "description": "Marble, travertine and alabaster:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.21.1000",
      "rawHtsCode": "6802.21.10.00",
      "superior": null,
      "indent": "3",
      "description": "Travertine",
      "units": [
        "t"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.21.5000",
      "rawHtsCode": "6802.21.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.23.0000",
      "rawHtsCode": "6802.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Granite",
      "units": [
        "t"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.29",
      "rawHtsCode": "6802.29",
      "superior": null,
      "indent": "2",
      "description": "Other stone:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.29.1000",
      "rawHtsCode": "6802.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Calcareous stone, other than marble, travertine or alabaster",
      "units": [
        "t"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.29.9000",
      "rawHtsCode": "6802.29.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.91",
      "rawHtsCode": "6802.91",
      "superior": null,
      "indent": "2",
      "description": "Marble, travertine and alabaster:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.91.0500",
      "rawHtsCode": "6802.91.05.00",
      "superior": null,
      "indent": "4",
      "description": "Slabs",
      "units": [
        "t"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.91.1500",
      "rawHtsCode": "6802.91.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.91.2000",
      "rawHtsCode": "6802.91.20.00",
      "superior": null,
      "indent": "4",
      "description": "Articles of subheading 6802.21.10 that have been dressed or polished, but not further worked",
      "units": [
        "t"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.91.2500",
      "rawHtsCode": "6802.91.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.91.3000",
      "rawHtsCode": "6802.91.30.00",
      "superior": null,
      "indent": "3",
      "description": "Alabaster",
      "units": [
        "t"
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.92.0000",
      "rawHtsCode": "6802.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other calcareous stone",
      "units": [
        "t"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.93.00",
      "rawHtsCode": "6802.93.00",
      "superior": null,
      "indent": "2",
      "description": "Granite",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.93.0010",
      "rawHtsCode": "6802.93.00.10",
      "superior": null,
      "indent": "3",
      "description": "Articles for monumental or building purposes of subheading 6802.23.00, not cut to size, with only one face surface-worked more than simply cut or sawn",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.93.0020",
      "rawHtsCode": "6802.93.00.20",
      "superior": null,
      "indent": "4",
      "description": "With a maximum thickness of <il>1.5 cm</il>",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.93.0025",
      "rawHtsCode": "6802.93.00.25",
      "superior": null,
      "indent": "4",
      "description": "With a maximum thickness greater than <il>1.5 cm</il> but not greater than <il>7.5 cm</il>",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.93.0035",
      "rawHtsCode": "6802.93.00.35",
      "superior": null,
      "indent": "5",
      "description": "Monuments, bases and markers",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.93.0060",
      "rawHtsCode": "6802.93.00.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.93.0090",
      "rawHtsCode": "6802.93.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.99.00",
      "rawHtsCode": "6802.99.00",
      "superior": null,
      "indent": "2",
      "description": "Other stone",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6802.99.0030",
      "rawHtsCode": "6802.99.00.30",
      "superior": null,
      "indent": "3",
      "description": "Monuments, bases and markers",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.99.0050",
      "rawHtsCode": "6802.99.00.50",
      "superior": null,
      "indent": "5",
      "description": "Slabs",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.99.0070",
      "rawHtsCode": "6802.99.00.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6802.99.0090",
      "rawHtsCode": "6802.99.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "6803.00",
      "rawHtsCode": "6803.00",
      "superior": null,
      "indent": "0",
      "description": "Worked slate and articles of slate or of agglomerated slate:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6803.00.1000",
      "rawHtsCode": "6803.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Roofing slate",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6803.00.5000",
      "rawHtsCode": "6803.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6804",
      "rawHtsCode": "6804",
      "superior": null,
      "indent": "0",
      "description": "Millstones, grindstones, grinding wheels and the like, without frameworks, for grinding, sharpening, polishing, trueing or cutting, hand sharpening or polishing stones, and parts thereof, of natural stone, of agglomerated natural or artificial abrasives, or of ceramics, with or without parts of other materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6804.10.0000",
      "rawHtsCode": "6804.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Millstones and grindstones for milling, grinding or pulping",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6804.21.00",
      "rawHtsCode": "6804.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of agglomerated synthetic or natural diamond",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6804.21.0010",
      "rawHtsCode": "6804.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Segments for circular sawblades, consisting of diamond agglomerated with metal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6804.21.0020",
      "rawHtsCode": "6804.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Articles consisting of a continuous rim segment of diamond agglomerated with metal, attached to circular plates of steel (whether or not attached to non-steel plates)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6804.21.0030",
      "rawHtsCode": "6804.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Articles consisting of multiple segments of diamond agglomerated with metal, attached to circular plates of steel, without cutting parts (whether or not attached to non-steel plates)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6804.21.0090",
      "rawHtsCode": "6804.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6804.22",
      "rawHtsCode": "6804.22",
      "superior": null,
      "indent": "2",
      "description": "Of other agglomerated abrasives or of ceramics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6804.22.1000",
      "rawHtsCode": "6804.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Bonded with synthetic resins",
      "units": [
        "kg"
      ],
      "generalRate": "5¢/kg + 2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6804.22.4000",
      "rawHtsCode": "6804.22.40.00",
      "superior": null,
      "indent": "4",
      "description": "Abrasive wheels",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6804.22.6000",
      "rawHtsCode": "6804.22.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6804.23.0000",
      "rawHtsCode": "6804.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of natural stone",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6804.30.0000",
      "rawHtsCode": "6804.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hand sharpening or polishing stones",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6805",
      "rawHtsCode": "6805",
      "superior": null,
      "indent": "0",
      "description": "Natural or artificial abrasive powder or grain, on a base of textile material, of paper, of paperboard or of other materials, whether or not cut to shape or sewn or otherwise made up:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6805.10.0000",
      "rawHtsCode": "6805.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "On a base of woven textile fabric only",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6805.20.0000",
      "rawHtsCode": "6805.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "On a base of paper or paperboard only",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6805.30",
      "rawHtsCode": "6805.30",
      "superior": null,
      "indent": "1",
      "description": "On a base of other materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6805.30.1000",
      "rawHtsCode": "6805.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Articles wholly or partly coated with abrasives, in the form of sheets, strips, disks, belts, sleeves or similar forms",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6805.30.5000",
      "rawHtsCode": "6805.30.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6806",
      "rawHtsCode": "6806",
      "superior": null,
      "indent": "0",
      "description": "Slag wool, rock wool and similar mineral wools; exfoliated vermiculite, expanded clays, foamed slag and similar expanded mineral materials; mixtures and articles of heat-insulating, sound-insulating or sound-absorbing mineral materials, other than those of heading 6811 or 6812, or of chapter 69:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6806.10.00",
      "rawHtsCode": "6806.10.00",
      "superior": null,
      "indent": "1",
      "description": "Slag wool, rock wool and similar mineral wools (including intermixtures thereof), in bulk, sheets or rolls",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6806.10.0010",
      "rawHtsCode": "6806.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Accoustical pads and boards",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6806.10.0020",
      "rawHtsCode": "6806.10.00.20",
      "superior": null,
      "indent": "3",
      "description": "Batts, not exceeding <il>61 cm</il> in width",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6806.10.0040",
      "rawHtsCode": "6806.10.00.40",
      "superior": null,
      "indent": "3",
      "description": "Batts, exceeding <il>61 cm</il> in width",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6806.10.0060",
      "rawHtsCode": "6806.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Pipe coverings",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6806.10.0090",
      "rawHtsCode": "6806.10.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6806.20.0000",
      "rawHtsCode": "6806.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Exfoliated vermiculite, expanded clays, foamed slag and similar expanded mineral materials (including intermixtures thereof)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6806.90.00",
      "rawHtsCode": "6806.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6806.90.0010",
      "rawHtsCode": "6806.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Accoustical pads and boards",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6806.90.0020",
      "rawHtsCode": "6806.90.00.20",
      "superior": null,
      "indent": "3",
      "description": "Of molded calcium silicate",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6806.90.0090",
      "rawHtsCode": "6806.90.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6807",
      "rawHtsCode": "6807",
      "superior": null,
      "indent": "0",
      "description": "Articles of asphalt or of similar material (for example, petroleum bitumen or coal tar pitch):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6807.10.0000",
      "rawHtsCode": "6807.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "In rolls",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6807.90.00",
      "rawHtsCode": "6807.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6807.90.0010",
      "rawHtsCode": "6807.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Articles of a kind used for roofing or siding",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6807.90.0050",
      "rawHtsCode": "6807.90.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6808.00.0000",
      "rawHtsCode": "6808.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Panels, boards, tiles, blocks and similar articles of vegetable fiber, of straw or of shavings, chips, particles, sawdust or other waste, of wood, agglomerated with cement, plaster or other mineral binders",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6809",
      "rawHtsCode": "6809",
      "superior": null,
      "indent": "0",
      "description": "Articles of plaster or of compositions based on plaster:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6809.11.00",
      "rawHtsCode": "6809.11.00",
      "superior": null,
      "indent": "2",
      "description": "Faced or reinforced with paper or paperboard only",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6809.11.0010",
      "rawHtsCode": "6809.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of gypsum plaster",
      "units": [
        "kg",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6809.11.0080",
      "rawHtsCode": "6809.11.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6809.19.0000",
      "rawHtsCode": "6809.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6809.90.0000",
      "rawHtsCode": "6809.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other articles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6810",
      "rawHtsCode": "6810",
      "superior": null,
      "indent": "0",
      "description": "Articles of cement, of concrete or of artificial stone, whether or not reinforced:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6810.11.00",
      "rawHtsCode": "6810.11.00",
      "superior": null,
      "indent": "2",
      "description": "Building blocks and bricks",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6810.11.0010",
      "rawHtsCode": "6810.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight more than <il>70 percent</il> magnesia, expressed as MgO, with carbon content ranging from trace amounts to less than <il>30 percent</il>, and chemically bonded by resin or pitch",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6810.11.0070",
      "rawHtsCode": "6810.11.00.70",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6810.19",
      "rawHtsCode": "6810.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6810.19.1200",
      "rawHtsCode": "6810.19.12.00",
      "superior": null,
      "indent": "4",
      "description": "Of stone agglomerated with binders other than cement",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6810.19.1400",
      "rawHtsCode": "6810.19.14.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6810.19.5000",
      "rawHtsCode": "6810.19.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6810.91.0000",
      "rawHtsCode": "6810.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Prefabricated structural components for building or civil engineering",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6810.99.00",
      "rawHtsCode": "6810.99.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6810.99.0020",
      "rawHtsCode": "6810.99.00.20",
      "superior": null,
      "indent": "4",
      "description": "In slabs of rectangular shape, with a length of 3 m or more and a width of 1.25 m or more",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6810.99.0040",
      "rawHtsCode": "6810.99.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6810.99.0080",
      "rawHtsCode": "6810.99.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6811",
      "rawHtsCode": "6811",
      "superior": null,
      "indent": "0",
      "description": "Articles of asbestos-cement, of cellulose fiber-cement or the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6811.40.0000",
      "rawHtsCode": "6811.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Containing asbestos",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6811.81.0000",
      "rawHtsCode": "6811.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "Corrugated sheets",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6811.82.0000",
      "rawHtsCode": "6811.82.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other sheets, panels, tiles and similar articles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6811.89",
      "rawHtsCode": "6811.89",
      "superior": null,
      "indent": "2",
      "description": "Other articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6811.89.1000",
      "rawHtsCode": "6811.89.10.00",
      "superior": null,
      "indent": "3",
      "description": "Tubes, pipes and tube or pipe fittings",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6811.89.9000",
      "rawHtsCode": "6811.89.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other articles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6812",
      "rawHtsCode": "6812",
      "superior": null,
      "indent": "0",
      "description": "Fabricated asbestos fibers; mixtures with a basis of asbestos or with a basis of asbestos and magnesium carbonate; articles of such mixtures or of asbestos (for example, thread, woven fabric, clothing, headgear, footwear, gaskets), whether or not reinforced, other than goods of heading 6811 or 6813:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6812.80",
      "rawHtsCode": "6812.80",
      "superior": null,
      "indent": "1",
      "description": "Of crocidolite:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6812.80.1000",
      "rawHtsCode": "6812.80.10.00",
      "superior": null,
      "indent": "2",
      "description": "Footwear",
      "units": [
        "kg"
      ],
      "generalRate": "8.3%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6812.80.9000",
      "rawHtsCode": "6812.80.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6812.91",
      "rawHtsCode": "6812.91",
      "superior": null,
      "indent": "2",
      "description": "Clothing, clothing accessories, footwear and headgear",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6812.91.1000",
      "rawHtsCode": "6812.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Footwear",
      "units": [
        "kg"
      ],
      "generalRate": "8.3%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6812.91.9000",
      "rawHtsCode": "6812.91.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6812.99",
      "rawHtsCode": "6812.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6812.99.1000",
      "rawHtsCode": "6812.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Paper, millboard and felt",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6812.99.2000",
      "rawHtsCode": "6812.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Compressed asbestos fiber jointing, in sheets or rolls",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6812.99.9000",
      "rawHtsCode": "6812.99.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6813",
      "rawHtsCode": "6813",
      "superior": null,
      "indent": "0",
      "description": "Friction material and articles thereof (for example, sheets, rolls, strips, segments, discs, washers, pads), not mounted, for brakes, for clutches or the like, with a basis of asbestos, of other mineral substances or of cellulose, whether or not combined with textile or other materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6813.20.00",
      "rawHtsCode": "6813.20.00",
      "superior": null,
      "indent": "1",
      "description": "Containing asbestos",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6813.20.0010",
      "rawHtsCode": "6813.20.00.10",
      "superior": null,
      "indent": "3",
      "description": "Articles for use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6813.20.0015",
      "rawHtsCode": "6813.20.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6813.20.0020",
      "rawHtsCode": "6813.20.00.20",
      "superior": null,
      "indent": "3",
      "description": "Articles for use in civil aircraft:",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6813.20.0025",
      "rawHtsCode": "6813.20.00.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6813.81.00",
      "rawHtsCode": "6813.81.00",
      "superior": null,
      "indent": "2",
      "description": "Brake linings and pads",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6813.81.0010",
      "rawHtsCode": "6813.81.00.10",
      "superior": null,
      "indent": "3",
      "description": "Articles for use in civil aircraft, with a basis of mineral substances",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6813.81.0050",
      "rawHtsCode": "6813.81.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6813.89.00",
      "rawHtsCode": "6813.89.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6813.89.0010",
      "rawHtsCode": "6813.89.00.10",
      "superior": null,
      "indent": "3",
      "description": "Articles for use in civil aircraft, with a basis of mineral substances",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6813.89.0050",
      "rawHtsCode": "6813.89.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6814",
      "rawHtsCode": "6814",
      "superior": null,
      "indent": "0",
      "description": "Worked mica and articles of mica, including agglomerated or reconstituted mica, whether or not on a support of paper, paperboard or other materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6814.10.0000",
      "rawHtsCode": "6814.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Plates, sheets and strips of agglomerated or reconstituted mica, whether or not on a support",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6814.90.0000",
      "rawHtsCode": "6814.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6815",
      "rawHtsCode": "6815",
      "superior": null,
      "indent": "0",
      "description": "Articles of stone or of other mineral substances (including carbon fibers, articles of carbon fibers and articles of peat), not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6815.11.0000",
      "rawHtsCode": "6815.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Carbon fibers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6815.12.0000",
      "rawHtsCode": "6815.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fabrics of carbon fibers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6815.13.0000",
      "rawHtsCode": "6815.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other articles of carbon fibers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6815.19.0000",
      "rawHtsCode": "6815.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6815.20.0000",
      "rawHtsCode": "6815.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Articles of peat",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6815.91.00",
      "rawHtsCode": "6815.91.00",
      "superior": null,
      "indent": "2",
      "description": "Containing magnesite, magnesia in the form of periclase, dolomite including in the form of dolime, or chromite",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6815.91.0011",
      "rawHtsCode": "6815.91.00.11",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight more than <il>70 percent</il> magnesia, expressed as MgO, with carbon content ranging from trace amounts to less than <il>30 percent</il>, and chemically bonded by resin or pitch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6815.91.0071",
      "rawHtsCode": "6815.91.00.71",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6815.99",
      "rawHtsCode": "6815.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6815.99.2000",
      "rawHtsCode": "6815.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Talc, steatite and soapstone, cut or sawed, or in blanks, crayons, cubes, disks or other forms",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6815.99.41",
      "rawHtsCode": "6815.99.41",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6815.99.4110",
      "rawHtsCode": "6815.99.41.10",
      "superior": null,
      "indent": "4",
      "description": "Containing by weight more than <il>70 percent</il> magnesia, expressed as MgO, with carbon content ranging from trace amounts to less than <il>30 percent</il>, and chemically bonded by resin or pitch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6815.99.4170",
      "rawHtsCode": "6815.99.41.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6901.00.0000",
      "rawHtsCode": "6901.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Bricks, blocks, tiles and other ceramic goods of siliceous fossil meals (for example, kieselguhr, tripolite or diatomite) or of similar siliceous earths",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6902",
      "rawHtsCode": "6902",
      "superior": null,
      "indent": "0",
      "description": "Refractory bricks, blocks, tiles and similar refractory ceramic constructional goods, other than those of siliceous fossil meals or similar siliceous earths:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6902.10",
      "rawHtsCode": "6902.10",
      "superior": null,
      "indent": "1",
      "description": "Containing by weight, singly or together, more than 50 percent of the elements magnesium, calcium or chromium, expressed as MgO, CaO or Cr<sub>2</sub>O<sub>3</sub>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6902.10.1000",
      "rawHtsCode": "6902.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Magnesite bricks",
      "units": [
        "thousands",
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "13%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6902.10.5000",
      "rawHtsCode": "6902.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6902.20",
      "rawHtsCode": "6902.20",
      "superior": null,
      "indent": "1",
      "description": "Containing by weight more than 50 percent of alumina (Al<sub>2</sub>O<sub>3</sub>), of silica (SiO<sub>2</sub>) or of a mixture or compound of these products:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6902.20.10",
      "rawHtsCode": "6902.20.10",
      "superior": null,
      "indent": "2",
      "description": "Bricks",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6902.20.1010",
      "rawHtsCode": "6902.20.10.10",
      "superior": null,
      "indent": "3",
      "description": "Alumina",
      "units": [
        "thousands",
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6902.20.1020",
      "rawHtsCode": "6902.20.10.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "thousands",
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6902.20.50",
      "rawHtsCode": "6902.20.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6902.20.5010",
      "rawHtsCode": "6902.20.50.10",
      "superior": null,
      "indent": "3",
      "description": "Alumina",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6902.20.5020",
      "rawHtsCode": "6902.20.50.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6902.90",
      "rawHtsCode": "6902.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6902.90.10",
      "rawHtsCode": "6902.90.10",
      "superior": null,
      "indent": "2",
      "description": "Bricks",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6902.90.1010",
      "rawHtsCode": "6902.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Clay",
      "units": [
        "thousands",
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6902.90.1020",
      "rawHtsCode": "6902.90.10.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "thousands",
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6902.90.50",
      "rawHtsCode": "6902.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6902.90.5010",
      "rawHtsCode": "6902.90.50.10",
      "superior": null,
      "indent": "3",
      "description": "Clay",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6902.90.5020",
      "rawHtsCode": "6902.90.50.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6903",
      "rawHtsCode": "6903",
      "superior": null,
      "indent": "0",
      "description": "Other refractory ceramic goods (for example, retorts, crucibles, muffles, nozzles, plugs, supports, cupels, tubes, pipes, sheaths, rods and slide gates), other than those of siliceous fossil meals or of similar siliceous earths:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6903.10.0000",
      "rawHtsCode": "6903.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Containing by weight more than 50 percent of free carbon",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6903.20.0000",
      "rawHtsCode": "6903.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Containing by weight more than 50 percent of alumina (Al<sub>2</sub>O<sub>3</sub>) or of a mixture or compound of alumina and of silica (SiO<sub>2</sub>)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6903.90.00",
      "rawHtsCode": "6903.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6903.90.0010",
      "rawHtsCode": "6903.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of clay",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6903.90.0050",
      "rawHtsCode": "6903.90.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6904",
      "rawHtsCode": "6904",
      "superior": null,
      "indent": "0",
      "description": "Ceramic building bricks, flooring blocks, support or filler tiles and the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6904.10.00",
      "rawHtsCode": "6904.10.00",
      "superior": null,
      "indent": "1",
      "description": "Building bricks",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6904.10.0010",
      "rawHtsCode": "6904.10.00.10",
      "superior": null,
      "indent": "3",
      "description": "Heat insulating",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6904.10.0020",
      "rawHtsCode": "6904.10.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6904.10.0030",
      "rawHtsCode": "6904.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "Heat insulating",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6904.10.0040",
      "rawHtsCode": "6904.10.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6904.90.0000",
      "rawHtsCode": "6904.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "thousands"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6905",
      "rawHtsCode": "6905",
      "superior": null,
      "indent": "0",
      "description": "Roofing tiles, chimney pots, cowls, chimney liners, architectural ornaments and other ceramic constructional goods:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6905.10.0000",
      "rawHtsCode": "6905.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Roofing tiles",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "13.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6905.90.00",
      "rawHtsCode": "6905.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6905.90.0010",
      "rawHtsCode": "6905.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Heat insulating",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6905.90.0050",
      "rawHtsCode": "6905.90.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6906.00.0000",
      "rawHtsCode": "6906.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Ceramic pipes, conduits, guttering and pipe fittings",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "6907",
      "rawHtsCode": "6907",
      "superior": null,
      "indent": "0",
      "description": "Ceramic flags and paving, hearth or wall tiles; ceramic mosaic cubes and the like, whether or not on a backing; finishing ceramics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.21",
      "rawHtsCode": "6907.21",
      "superior": null,
      "indent": "2",
      "description": "Of a water absorption coefficient by weight not exceeding 0.5%:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.21.10",
      "rawHtsCode": "6907.21.10",
      "superior": null,
      "indent": "3",
      "description": "Unglazed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.21.1005",
      "rawHtsCode": "6907.21.10.05",
      "superior": null,
      "indent": "4",
      "description": "Tiles, whether or not rectangular, the largest surface area of which is capable of being enclosed in a square the side of which is less than 7 cm",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.21.1011",
      "rawHtsCode": "6907.21.10.11",
      "superior": null,
      "indent": "5",
      "description": "Tiles, the largest surface area of which is capable of being enclosed in a square the side of which is 30 cm or less",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.21.1051",
      "rawHtsCode": "6907.21.10.51",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.21.2000",
      "rawHtsCode": "6907.21.20.00",
      "superior": null,
      "indent": "5",
      "description": "Having not over 3229 tiles per square meter, most of which have faces bounded entirely by straight lines",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.21.3000",
      "rawHtsCode": "6907.21.30.00",
      "superior": null,
      "indent": "6",
      "description": "The largest surface area of which is less than 38.7 cm<sup>2</sup>",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.21.4000",
      "rawHtsCode": "6907.21.40.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.21.90",
      "rawHtsCode": "6907.21.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.21.9011",
      "rawHtsCode": "6907.21.90.11",
      "superior": null,
      "indent": "5",
      "description": "Tiles, the largest surface area of which is capable of being enclosed in a square the side of which is 30 cm or less",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.21.9051",
      "rawHtsCode": "6907.21.90.51",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.22",
      "rawHtsCode": "6907.22",
      "superior": null,
      "indent": "2",
      "description": "Of water absorption coefficient by weight exceeding 0.5 percent but not exceeding 10 percent:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.22.10",
      "rawHtsCode": "6907.22.10",
      "superior": null,
      "indent": "3",
      "description": "Unglazed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.22.1005",
      "rawHtsCode": "6907.22.10.05",
      "superior": null,
      "indent": "4",
      "description": "Tiles, whether or not rectangular, the largest surface area of which is capable of being enclosed in a square the side of which is less than 7 cm",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.22.1011",
      "rawHtsCode": "6907.22.10.11",
      "superior": null,
      "indent": "5",
      "description": "Tiles, the largest surface area of which is capable of being enclosed in a square the side of which is 30 cm or less",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.22.1051",
      "rawHtsCode": "6907.22.10.51",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.22.2000",
      "rawHtsCode": "6907.22.20.00",
      "superior": null,
      "indent": "5",
      "description": "Having not over 3229 tiles per square meter, most of which have faces bounded entirely by straight lines",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.22.3000",
      "rawHtsCode": "6907.22.30.00",
      "superior": null,
      "indent": "6",
      "description": "The largest surface area of which is less than 38.7 cm<sup>2</sup>",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.22.4000",
      "rawHtsCode": "6907.22.40.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.22.90",
      "rawHtsCode": "6907.22.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.22.9011",
      "rawHtsCode": "6907.22.90.11",
      "superior": null,
      "indent": "5",
      "description": "Tiles, the largest surface area of which is capable of being enclosed in a square the side of which is 30 cm or less",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.22.9051",
      "rawHtsCode": "6907.22.90.51",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.23",
      "rawHtsCode": "6907.23",
      "superior": null,
      "indent": "2",
      "description": "Of a water absorption coefficient by weight exceeding 10 percent:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.23.10",
      "rawHtsCode": "6907.23.10",
      "superior": null,
      "indent": "3",
      "description": "Unglazed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.23.1005",
      "rawHtsCode": "6907.23.10.05",
      "superior": null,
      "indent": "4",
      "description": "Tiles, whether or not rectangular, the largest surface area of which is capable of being enclosed in a square the side of which is less than 7 cm",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.23.1011",
      "rawHtsCode": "6907.23.10.11",
      "superior": null,
      "indent": "5",
      "description": "Tiles, the largest surface area of which is capable of being enclosed in a square the side of which is 30 cm or less",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.23.1051",
      "rawHtsCode": "6907.23.10.51",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.23.2000",
      "rawHtsCode": "6907.23.20.00",
      "superior": null,
      "indent": "5",
      "description": "Having not over 3229 tiles per square meter, most of which have faces bounded entirely by straight lines",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.23.3000",
      "rawHtsCode": "6907.23.30.00",
      "superior": null,
      "indent": "6",
      "description": "The largest surface area of which is less than 38.7 cm<sup>2</sup>",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.23.4000",
      "rawHtsCode": "6907.23.40.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.23.90",
      "rawHtsCode": "6907.23.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.23.9011",
      "rawHtsCode": "6907.23.90.11",
      "superior": null,
      "indent": "5",
      "description": "Tiles, the largest surface area of which is capable of being enclosed in a square the side of which is 30 cm or less",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.23.9051",
      "rawHtsCode": "6907.23.90.51",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.30",
      "rawHtsCode": "6907.30",
      "superior": null,
      "indent": "1",
      "description": "Mosaic cubes and the like, other than those of subheading 6907.40:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.30.10",
      "rawHtsCode": "6907.30.10",
      "superior": null,
      "indent": "2",
      "description": "Unglazed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.30.1005",
      "rawHtsCode": "6907.30.10.05",
      "superior": null,
      "indent": "3",
      "description": "Cubes and the like, whether or not rectangular, the largest surface area of which is capable of being enclosed in a square the side of which is less than 7 cm",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.30.1011",
      "rawHtsCode": "6907.30.10.11",
      "superior": null,
      "indent": "4",
      "description": "Cubes and the like, the largest surface area of which is capable of being enclosed in a square the side of which is 30cm or less",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.30.1051",
      "rawHtsCode": "6907.30.10.51",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.30.2000",
      "rawHtsCode": "6907.30.20.00",
      "superior": null,
      "indent": "4",
      "description": "Having not over 3229 cubes per square meter, most of which have straight lines",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.30.3000",
      "rawHtsCode": "6907.30.30.00",
      "superior": null,
      "indent": "5",
      "description": "The largest surface area of which is less than 38.7 cm<sup>2</sup>",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.30.4000",
      "rawHtsCode": "6907.30.40.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.30.90",
      "rawHtsCode": "6907.30.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.30.9011",
      "rawHtsCode": "6907.30.90.11",
      "superior": null,
      "indent": "4",
      "description": "Cubes and the like, the largest surface area of which is capable of being enclosed in a square the side of which is 30 cm or less",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.30.9051",
      "rawHtsCode": "6907.30.90.51",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.40",
      "rawHtsCode": "6907.40",
      "superior": null,
      "indent": "1",
      "description": "Finishing ceramics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.40.10",
      "rawHtsCode": "6907.40.10",
      "superior": null,
      "indent": "2",
      "description": "Unglazed",
      "units": [],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.40.1005",
      "rawHtsCode": "6907.40.10.05",
      "superior": null,
      "indent": "3",
      "description": "Finishing ceramics, whether or not rectangular, the largest surface area of which is capable of being enclosed in a square the side of which is less than 7 cm:",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.40.1011",
      "rawHtsCode": "6907.40.10.11",
      "superior": null,
      "indent": "4",
      "description": "Finishing ceramics, the largest surface area of which is capable of being enclosed in a square the side of which is 30 cm or less",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.40.1051",
      "rawHtsCode": "6907.40.10.51",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.40.2000",
      "rawHtsCode": "6907.40.20.00",
      "superior": null,
      "indent": "4",
      "description": "Having not over 3229 finishing ceramics per square meter, most of which have faces bounded entirely by straight lines",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "10%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.40.3000",
      "rawHtsCode": "6907.40.30.00",
      "superior": null,
      "indent": "5",
      "description": "The largest surface area of which is less than 38.7 cm<sup>2</sup>",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.40.4000",
      "rawHtsCode": "6907.40.40.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.40.90",
      "rawHtsCode": "6907.40.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6907.40.9011",
      "rawHtsCode": "6907.40.90.11",
      "superior": null,
      "indent": "4",
      "description": "Finishing ceramics, the largest surface area of which is capable of being enclosed in a square the side of which is 30 cm or less",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6907.40.9051",
      "rawHtsCode": "6907.40.90.51",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6909",
      "rawHtsCode": "6909",
      "superior": null,
      "indent": "0",
      "description": "Ceramic wares for laboratory, chemical or other technical uses; ceramic troughs, tubs and similar receptacles of a kind used in agriculture; ceramic pots, jars and similar articles of a kind used for the conveyance or packing of goods:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6909.11",
      "rawHtsCode": "6909.11",
      "superior": null,
      "indent": "2",
      "description": "Of porcelain or china:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6909.11.2000",
      "rawHtsCode": "6909.11.20.00",
      "superior": null,
      "indent": "3",
      "description": "Machinery parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "6909.11.4000",
      "rawHtsCode": "6909.11.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6909.12.0000",
      "rawHtsCode": "6909.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Articles having a hardness equivalent to 9 or more on the Mohs scale",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6909.19",
      "rawHtsCode": "6909.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6909.19.1000",
      "rawHtsCode": "6909.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Ferrite core memories",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6909.19.50",
      "rawHtsCode": "6909.19.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6909.19.5010",
      "rawHtsCode": "6909.19.50.10",
      "superior": null,
      "indent": "4",
      "description": "Ceramic bearings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6909.19.5095",
      "rawHtsCode": "6909.19.50.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6909.90.0000",
      "rawHtsCode": "6909.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6910",
      "rawHtsCode": "6910",
      "superior": null,
      "indent": "0",
      "description": "Ceramic sinks, washbasins, washbasin pedestals, baths, bidets, water closet bowls, flush tanks, urinals and similar sanitary fixtures:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6910.10.00",
      "rawHtsCode": "6910.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of porcelain or china",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6910.10.0005",
      "rawHtsCode": "6910.10.00.05",
      "superior": null,
      "indent": "2",
      "description": "Water closet bowls, flushometer type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6910.10.0010",
      "rawHtsCode": "6910.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Water closet bowls with tanks, in one piece",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6910.10.0015",
      "rawHtsCode": "6910.10.00.15",
      "superior": null,
      "indent": "2",
      "description": "Flush tanks",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6910.10.0020",
      "rawHtsCode": "6910.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Other water closet bowls",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6910.10.0030",
      "rawHtsCode": "6910.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Sinks and lavatories",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6910.10.0050",
      "rawHtsCode": "6910.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6910.90.0000",
      "rawHtsCode": "6910.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911",
      "rawHtsCode": "6911",
      "superior": null,
      "indent": "0",
      "description": "Tableware, kitchenware, other household articles and toilet articles, of porcelain or china:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6911.10",
      "rawHtsCode": "6911.10",
      "superior": null,
      "indent": "1",
      "description": "Tableware and kitchenware:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6911.10.1000",
      "rawHtsCode": "6911.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Hotel or restaurant ware and other ware not household ware",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.10.1500",
      "rawHtsCode": "6911.10.15.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $31.50 per dozen pieces",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.10.2500",
      "rawHtsCode": "6911.10.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.10.35",
      "rawHtsCode": "6911.10.35",
      "superior": null,
      "indent": "5",
      "description": "In any pattern for which the aggregate value of the articles listed in additional U.S. note 6(b) of this chapter is not over $56",
      "units": [],
      "generalRate": "26%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.10.3510",
      "rawHtsCode": "6911.10.35.10",
      "superior": null,
      "indent": "6",
      "description": "Plates not over 27.9 cm in maximum dimension; teacups and saucers; mugs; soups, fruits and cereals, the foregoing not over 22.9 cm in maximum dimension",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6911.10.3550",
      "rawHtsCode": "6911.10.35.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6911.10.37",
      "rawHtsCode": "6911.10.37",
      "superior": null,
      "indent": "6",
      "description": "Aggregate value not over $200",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.10.3710",
      "rawHtsCode": "6911.10.37.10",
      "superior": null,
      "indent": "7",
      "description": "Plates not over 27.9 cm in maximum dimension, teacups and saucers; mugs; soups, fruits and cereals, the foregoing not over 22.9 cm in maximum dimension",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6911.10.3750",
      "rawHtsCode": "6911.10.37.50",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6911.10.38",
      "rawHtsCode": "6911.10.38",
      "superior": null,
      "indent": "6",
      "description": "Aggregate value over $200",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.10.3810",
      "rawHtsCode": "6911.10.38.10",
      "superior": null,
      "indent": "7",
      "description": "Plates not over 27.9 cm in maximum dimension; teacups and saucers; mugs; soups, fruits and cereals, the foregoing not over 22.9 cm in maximum dimension",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6911.10.3850",
      "rawHtsCode": "6911.10.38.50",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6911.10.4100",
      "rawHtsCode": "6911.10.41.00",
      "superior": null,
      "indent": "5",
      "description": "Steins with permanently attached pewter lids, candy boxes, decanters, punch bowls, pretzel dishes, tidbit dishes, tiered servers, bonbon dishes, egg cups, spoons and spoon rests, oil and vinegar sets, tumblers and salt and pepper shaker sets",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.10.4500",
      "rawHtsCode": "6911.10.45.00",
      "superior": null,
      "indent": "5",
      "description": "Mugs and other steins",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.10.5200",
      "rawHtsCode": "6911.10.52.00",
      "superior": null,
      "indent": "5",
      "description": "Cups valued over $8 but not over $29 per dozen; saucers valued over $5.25 but not over $18.75 per dozen; soups, oatmeals and cereals valued over $9.30 but not over $33 per dozen; plates not over 22.9 cm in maximum diameter and valued over $8.50 but not over $31 per dozen; plates over 22.9 but not over 27.9 cm in maximum diameter and valued over $11.50 but not over $41 per dozen; platters or chop dishes valued over $40 but not over $143 per dozen; sugars valued over $23 but not over $85 per dozen; creamers valued over $20 but not over $75 per dozen; and beverage servers valued over $50 but not over $180 per dozen",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.10.5800",
      "rawHtsCode": "6911.10.58.00",
      "superior": null,
      "indent": "5",
      "description": "Cups valued over $29 per dozen; saucers valued over $18.75 per dozen; soups, oatmeals and cereals valued over $33 per dozen; plates not over 22.9 cm in maximum diameter and valued over $31 per dozen; plates over 22.9 but not over 27.9 cm in maximum diameter and valued over $41 per dozen; platters or chop dishes valued over $143 per dozen; sugars valued over $85 per dozen; creamers valued over $75 per dozen; and beverage servers valued over $180 per dozen",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.10.6000",
      "rawHtsCode": "6911.10.60.00",
      "superior": null,
      "indent": "5",
      "description": "Serviette rings",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "20.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.10.80",
      "rawHtsCode": "6911.10.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "20.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.10.8010",
      "rawHtsCode": "6911.10.80.10",
      "superior": null,
      "indent": "6",
      "description": "Suitable for food or drink contact",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6911.10.8090",
      "rawHtsCode": "6911.10.80.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6911.90.00",
      "rawHtsCode": "6911.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "5.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6911.90.0010",
      "rawHtsCode": "6911.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Toilet articles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6911.90.0050",
      "rawHtsCode": "6911.90.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6912.00",
      "rawHtsCode": "6912.00",
      "superior": null,
      "indent": "0",
      "description": "Ceramic tableware, kitchenware, other household articles and toilet articles, other than of porcelain or china:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6912.00.1000",
      "rawHtsCode": "6912.00.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of coarse-grained earthenware, or of coarse- grained stoneware; of fine-grained earthenware, whether or not decorated, having a reddish-colored body and a lustrous glaze which, on teapots, may be any color, but which, on other articles, must be mottled, streaked or solidly colored brown to black with metallic oxide or salt",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "0.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6912.00.2000",
      "rawHtsCode": "6912.00.20.00",
      "superior": null,
      "indent": "3",
      "description": "Hotel or restaurant ware and other ware not household ware",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "28%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6912.00.35",
      "rawHtsCode": "6912.00.35",
      "superior": null,
      "indent": "5",
      "description": "In any pattern for which the aggregate value of the articles listed in additional U.S. note 6(b) of this chapter is not over $38",
      "units": [],
      "generalRate": "9.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6912.00.3510",
      "rawHtsCode": "6912.00.35.10",
      "superior": null,
      "indent": "6",
      "description": "Plates not over 27.9 cm in maximum dimension; teacups and saucers; mugs; soups, fruits and cereals, the foregoing not over 22.9 cm in maximum dimension",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6912.00.3550",
      "rawHtsCode": "6912.00.35.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6912.00.39",
      "rawHtsCode": "6912.00.39",
      "superior": null,
      "indent": "5",
      "description": "In any pattern for which the aggregate value of the articles listed in additional U.S. note 6(b) of this chapter is over $38",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6912.00.3910",
      "rawHtsCode": "6912.00.39.10",
      "superior": null,
      "indent": "6",
      "description": "Plates not over <il>27.9 cm</il> in maximum dimension; teacups and saucers; mugs; soups, fruits and cereals, the foregoing not over <il>22.9 cm</il> in maximum dimension",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6912.00.3950",
      "rawHtsCode": "6912.00.39.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6912.00.4100",
      "rawHtsCode": "6912.00.41.00",
      "superior": null,
      "indent": "5",
      "description": "Steins with permanently attached pewter lids; candy boxes, decanters, punch bowls, pretzel dishes, tidbit dishes, tiered servers, bonbon dishes, egg cups, spoons and spoon rests, oil and vinegar sets, tumblers and salt and pepper shaker sets",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6912.00.4400",
      "rawHtsCode": "6912.00.44.00",
      "superior": null,
      "indent": "5",
      "description": "Mugs and other steins",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6912.00.4500",
      "rawHtsCode": "6912.00.45.00",
      "superior": null,
      "indent": "5",
      "description": "Cups valued over $5.25 per dozen; saucers valued over $3 per dozen; soups, oatmeals and cereals valued over $6 per dozen; plates not over 22.9 cm in maximum diameter and valued over $6 per dozen; plates over 22.9 but not over 27.9 cm in maximum diameter and valued over $8.50 per dozen; platters or chop dishes valued over $35 per dozen; sugars valued over $21 per dozen; creamers valued over $15 per dozen; and beverage servers valued over $42 per dozen",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6912.00.4600",
      "rawHtsCode": "6912.00.46.00",
      "superior": null,
      "indent": "5",
      "description": "Serviette rings",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "9.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6912.00.48",
      "rawHtsCode": "6912.00.48",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "9.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6912.00.4810",
      "rawHtsCode": "6912.00.48.10",
      "superior": null,
      "indent": "6",
      "description": "Suitable for food or drink contact",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6912.00.4890",
      "rawHtsCode": "6912.00.48.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6912.00.5000",
      "rawHtsCode": "6912.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6913",
      "rawHtsCode": "6913",
      "superior": null,
      "indent": "0",
      "description": "Statuettes and other ornamental ceramic articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6913.10",
      "rawHtsCode": "6913.10",
      "superior": null,
      "indent": "1",
      "description": "Of porcelain or china:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6913.10.1000",
      "rawHtsCode": "6913.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Statues, statuettes and handmade flowers, valued over $2.50 each and produced by professional sculptors or directly from molds made from original models produced by professional sculptors",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "6913.10.2000",
      "rawHtsCode": "6913.10.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of bone chinaware",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6913.10.5000",
      "rawHtsCode": "6913.10.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6913.90",
      "rawHtsCode": "6913.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6913.90.1000",
      "rawHtsCode": "6913.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Statues, statuettes and handmade flowers, valued over $2.50 each and produced by professional sculptors or directly from molds made from original models produced by professional sculptors",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6913.90.2000",
      "rawHtsCode": "6913.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of ceramic tile",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6913.90.3000",
      "rawHtsCode": "6913.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of earthenware, whether or not decorated, having a reddish-colored body and a lustrous glaze, and mottled, streaked or solidly colored brown to black with metallic oxide or salt",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "6913.90.5000",
      "rawHtsCode": "6913.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "51.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6914",
      "rawHtsCode": "6914",
      "superior": null,
      "indent": "0",
      "description": "Other ceramic articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6914.10",
      "rawHtsCode": "6914.10",
      "superior": null,
      "indent": "1",
      "description": "Of porcelain or china:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6914.10.4000",
      "rawHtsCode": "6914.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Ceramic ferrules of porcelain or china, not exceeding 3 mm in diameter or 25 mm in length, having a fiber channel opening and/or ceramic mating sleeves of alumina or zirconia",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6914.10.8000",
      "rawHtsCode": "6914.10.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "6914.90",
      "rawHtsCode": "6914.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "6914.90.4100",
      "rawHtsCode": "6914.90.41.00",
      "superior": null,
      "indent": "2",
      "description": "Ceramic ferrules of alumina or zirconia, not exceeding 3 mm in diameter or 25 mm in length, having a fiber channel opening and/or ceramic mating sleeves of alumina or zirconia",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "6914.90.8000",
      "rawHtsCode": "6914.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "Dz Pcs"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7001.00",
      "rawHtsCode": "7001.00",
      "superior": null,
      "indent": "0",
      "description": "Cullet and other waste and scrap of glass, excluding glass from cathode-ray tubes or other activated glass of heading 8549; glass in the mass:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7001.00.1000",
      "rawHtsCode": "7001.00.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of fused quartz or other fused silica",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7001.00.2000",
      "rawHtsCode": "7001.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7001.00.5100",
      "rawHtsCode": "7001.00.51.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7002",
      "rawHtsCode": "7002",
      "superior": null,
      "indent": "0",
      "description": "Glass in balls (other than microspheres of heading 7018), rods or tubes, unworked:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7002.10",
      "rawHtsCode": "7002.10",
      "superior": null,
      "indent": "1",
      "description": "Balls:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7002.10.1000",
      "rawHtsCode": "7002.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Not over 6 mm in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7002.10.2000",
      "rawHtsCode": "7002.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7002.20",
      "rawHtsCode": "7002.20",
      "superior": null,
      "indent": "1",
      "description": "Rods:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7002.20.1000",
      "rawHtsCode": "7002.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of fused quartz or other fused silica",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "7002.20.5000",
      "rawHtsCode": "7002.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7002.31.0000",
      "rawHtsCode": "7002.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of fused quartz or other fused silica",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7002.32.0000",
      "rawHtsCode": "7002.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of other glass having a linear coefficient of expansion not exceeding 5 x 10<sup>-6</sup> per Kelvin within a temperature range of 0˚C to 300˚C",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7002.39.00",
      "rawHtsCode": "7002.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7002.39.0010",
      "rawHtsCode": "7002.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of a length not exceeding 200 mm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7002.39.0090",
      "rawHtsCode": "7002.39.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7003",
      "rawHtsCode": "7003",
      "superior": null,
      "indent": "0",
      "description": "Cast glass and rolled glass, in sheets or profiles, whether or not having an absorbent, reflecting or non-reflecting layer, but not otherwise worked:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7003.12.0000",
      "rawHtsCode": "7003.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Colored throughout the mass (body tinted), opacified, flashed or having an absorbent, reflecting or non-reflecting layer",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "12%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7003.19.0000",
      "rawHtsCode": "7003.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "21%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7003.20.0000",
      "rawHtsCode": "7003.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Wired sheets",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "21%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7003.30.0000",
      "rawHtsCode": "7003.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Profiles",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7004",
      "rawHtsCode": "7004",
      "superior": null,
      "indent": "0",
      "description": "Drawn glass and blown glass, in sheets, whether or not having an absorbent, reflecting or non-reflecting layer, but not otherwise worked:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7004.20",
      "rawHtsCode": "7004.20",
      "superior": null,
      "indent": "1",
      "description": "Glass, colored throughout the mass (body tinted), opacified, flashed or having an absorbent, reflecting or non-reflecting layer:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7004.20.1000",
      "rawHtsCode": "7004.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Having an absorbent, reflecting or non-reflecting layer",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7004.20.20",
      "rawHtsCode": "7004.20.20",
      "superior": null,
      "indent": "3",
      "description": "In rectangular shape",
      "units": [],
      "generalRate": "1¢/kg + 1.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.2¢/kg + 5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7004.20.2010",
      "rawHtsCode": "7004.20.20.10",
      "superior": null,
      "indent": "4",
      "description": "Measuring less than 5 mm in thickness",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7004.20.2020",
      "rawHtsCode": "7004.20.20.20",
      "superior": null,
      "indent": "4",
      "description": "Measuring 5 mm and over in thickness",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7004.20.5000",
      "rawHtsCode": "7004.20.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7004.90",
      "rawHtsCode": "7004.90",
      "superior": null,
      "indent": "1",
      "description": "Other glass:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7004.90.0500",
      "rawHtsCode": "7004.90.05.00",
      "superior": null,
      "indent": "4",
      "description": "Measuring not over 0.26 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7004.90.1000",
      "rawHtsCode": "7004.90.10.00",
      "superior": null,
      "indent": "4",
      "description": "Measuring over 0.26 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7004.90.1500",
      "rawHtsCode": "7004.90.15.00",
      "superior": null,
      "indent": "4",
      "description": "Measuring not over 0.26 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7004.90.2000",
      "rawHtsCode": "7004.90.20.00",
      "superior": null,
      "indent": "4",
      "description": "Measuring over 0.26 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7004.90.25",
      "rawHtsCode": "7004.90.25",
      "superior": null,
      "indent": "3",
      "description": "Measuring over 2 but not over 3.5 mm in thickness",
      "units": [],
      "generalRate": "0.7¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7004.90.2510",
      "rawHtsCode": "7004.90.25.10",
      "superior": null,
      "indent": "4",
      "description": "Measuring not over 0.26 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7004.90.2520",
      "rawHtsCode": "7004.90.25.20",
      "superior": null,
      "indent": "4",
      "description": "Measuring over 0.26 but not over 0.58 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7004.90.2550",
      "rawHtsCode": "7004.90.25.50",
      "superior": null,
      "indent": "4",
      "description": "Measuring over 0.58 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7004.90.30",
      "rawHtsCode": "7004.90.30",
      "superior": null,
      "indent": "4",
      "description": "Measuring not over 0.65 m<sup>2</sup> in area",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7004.90.3010",
      "rawHtsCode": "7004.90.30.10",
      "superior": null,
      "indent": "6",
      "description": "Measuring over 3.5 but not over 5 mm in thickness",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7004.90.3020",
      "rawHtsCode": "7004.90.30.20",
      "superior": null,
      "indent": "6",
      "description": "Measuring over 5 mm in thickness",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7004.90.3050",
      "rawHtsCode": "7004.90.30.50",
      "superior": null,
      "indent": "5",
      "description": "Measuring over 0.26 but not over 0.65 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7004.90.4000",
      "rawHtsCode": "7004.90.40.00",
      "superior": null,
      "indent": "4",
      "description": "Measuring over 0.65 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7004.90.5000",
      "rawHtsCode": "7004.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7005",
      "rawHtsCode": "7005",
      "superior": null,
      "indent": "0",
      "description": "Float glass and surface ground or polished glass, in sheets, whether or not having an absorbent, reflecting or non-reflecting layer, but not otherwise worked:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.10",
      "rawHtsCode": "7005.10",
      "superior": null,
      "indent": "1",
      "description": "Nonwired glass, having an absorbent, reflecting or non-reflecting layer:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.10.4000",
      "rawHtsCode": "7005.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Suitable for use in liquid crystal displays, measuring not over 1.2 mm in thickness and not over 0.8 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7005.10.8000",
      "rawHtsCode": "7005.10.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7005.21",
      "rawHtsCode": "7005.21",
      "superior": null,
      "indent": "2",
      "description": "Colored throughout the mass (body tinted), opacified, flashed or merely surface ground:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.21.10",
      "rawHtsCode": "7005.21.10",
      "superior": null,
      "indent": "3",
      "description": "Measuring less than 10 mm in thickness",
      "units": [],
      "generalRate": "14.5¢/m<sup>2 </sup>+ 0.4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$2.13/m<sup>2</sup> + 5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7005.21.1010",
      "rawHtsCode": "7005.21.10.10",
      "superior": null,
      "indent": "4",
      "description": "Measuring less than 5 mm in thickness",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.21.1030",
      "rawHtsCode": "7005.21.10.30",
      "superior": null,
      "indent": "4",
      "description": "Measuring 5 mm or more but less than 10 mm in thickness",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.21.2000",
      "rawHtsCode": "7005.21.20.00",
      "superior": null,
      "indent": "3",
      "description": "Measuring 10 mm or more in thickness",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7005.29",
      "rawHtsCode": "7005.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.29.04",
      "rawHtsCode": "7005.29.04",
      "superior": null,
      "indent": "5",
      "description": "Suitable for use in liquid crystal displays",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.35/m<sup>2</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7005.29.0410",
      "rawHtsCode": "7005.29.04.10",
      "superior": null,
      "indent": "6",
      "description": "Measuring not over 0.26 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.29.0450",
      "rawHtsCode": "7005.29.04.50",
      "superior": null,
      "indent": "6",
      "description": "Measuring over 0.26 m<sup>2</sup> but not over 0.65 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.29.08",
      "rawHtsCode": "7005.29.08",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "18.7¢/m<sup>2</sup>",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "$1.35/m<sup>2</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7005.29.0810",
      "rawHtsCode": "7005.29.08.10",
      "superior": null,
      "indent": "6",
      "description": "Measuring not over 0.26 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.29.0850",
      "rawHtsCode": "7005.29.08.50",
      "superior": null,
      "indent": "6",
      "description": "Measuring over 0.26 m<sup>2</sup> but not over 0.65 m<sup>2</sup> in area",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.29.14",
      "rawHtsCode": "7005.29.14",
      "superior": null,
      "indent": "5",
      "description": "Suitable for use in liquid crystal displays, measuring not over 0.8 m<sup>2</sup> in area",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.13/m<sup>2</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7005.29.1410",
      "rawHtsCode": "7005.29.14.10",
      "superior": null,
      "indent": "6",
      "description": "Measuring less than 5 mm in thickness",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.29.1450",
      "rawHtsCode": "7005.29.14.50",
      "superior": null,
      "indent": "6",
      "description": "Measuring 5 mm or more but less than 10 mm in thickness",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.29.18",
      "rawHtsCode": "7005.29.18",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "14.5¢/m<sup>2</sup>",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$2.13/m<sup>2</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7005.29.1810",
      "rawHtsCode": "7005.29.18.10",
      "superior": null,
      "indent": "6",
      "description": "Measuring less than 5 mm in thickness",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.29.1850",
      "rawHtsCode": "7005.29.18.50",
      "superior": null,
      "indent": "6",
      "description": "Measuring 5 mm or more but less than 10 mm in thickness",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7005.29.2500",
      "rawHtsCode": "7005.29.25.00",
      "superior": null,
      "indent": "3",
      "description": "Measuring 10 mm or more in thickness",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7005.30.0000",
      "rawHtsCode": "7005.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Wired glass",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "29.1¢/m<sup>2</sup>",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$2.48/m<sup>2</sup>",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7006.00",
      "rawHtsCode": "7006.00",
      "superior": null,
      "indent": "0",
      "description": "Glass of heading 7003, 7004 or 7005, bent, edge-worked, engraved, drilled, enameled or otherwise worked, but not framed or fitted with other materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7006.00.1000",
      "rawHtsCode": "7006.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Strips not over 15.2 cm in width, measuring over 2 mm in thickness, and having all longitudinal edges ground or otherwise smoothed or processed",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "53%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7006.00.2000",
      "rawHtsCode": "7006.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "Glass, drawn or blown and not containing wire netting and not surface ground or polished",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7006.00.40",
      "rawHtsCode": "7006.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.9%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7006.00.4010",
      "rawHtsCode": "7006.00.40.10",
      "superior": null,
      "indent": "3",
      "description": "Having an absorbent or reflecting layer",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7006.00.4050",
      "rawHtsCode": "7006.00.40.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7007",
      "rawHtsCode": "7007",
      "superior": null,
      "indent": "0",
      "description": "Safety glass, consisting of toughened (tempered) or laminated glass:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7007.11.00",
      "rawHtsCode": "7007.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of size and shape suitable for incorporation in vehicles, aircraft, spacecraft or vessels",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7007.11.0010",
      "rawHtsCode": "7007.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "For motor vehicles of chapter 87",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7007.11.0090",
      "rawHtsCode": "7007.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7007.19.0000",
      "rawHtsCode": "7007.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7007.21",
      "rawHtsCode": "7007.21",
      "superior": null,
      "indent": "2",
      "description": "Of size and shape suitable for incorporation in vehicles, aircraft, spacecraft or vessels:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7007.21.11",
      "rawHtsCode": "7007.21.11",
      "superior": null,
      "indent": "3",
      "description": "Windshields",
      "units": [],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7007.21.1110",
      "rawHtsCode": "7007.21.11.10",
      "superior": null,
      "indent": "4",
      "description": "For motor vehicles of chapter 87",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7007.21.1190",
      "rawHtsCode": "7007.21.11.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7007.21.5100",
      "rawHtsCode": "7007.21.51.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7007.29.0000",
      "rawHtsCode": "7007.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7008.00.0000",
      "rawHtsCode": "7008.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Multiple-walled insulating units of glass",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7009",
      "rawHtsCode": "7009",
      "superior": null,
      "indent": "0",
      "description": "Glass mirrors, whether or not framed, including rear-view mirrors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7009.10.0000",
      "rawHtsCode": "7009.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Rear-view mirrors for vehicles",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7009.91",
      "rawHtsCode": "7009.91",
      "superior": null,
      "indent": "2",
      "description": "Unframed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7009.91.10",
      "rawHtsCode": "7009.91.10",
      "superior": null,
      "indent": "3",
      "description": "Not over 929 cm<sup>2</sup> in reflecting area",
      "units": [],
      "generalRate": "7.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7009.91.1010",
      "rawHtsCode": "7009.91.10.10",
      "superior": null,
      "indent": "4",
      "description": "Containing LED or fluorescent lighting",
      "units": [
        "cm<sup>2</sup>",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7009.91.1090",
      "rawHtsCode": "7009.91.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "cm<sup>2</sup>",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7009.91.50",
      "rawHtsCode": "7009.91.50",
      "superior": null,
      "indent": "3",
      "description": "Over 929 cm<sup>2</sup> in reflecting area",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.25% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7009.91.5010",
      "rawHtsCode": "7009.91.50.10",
      "superior": null,
      "indent": "4",
      "description": "Containing LED or fluorescent lighting",
      "units": [
        "cm<sup>2</sup>",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7009.91.5091",
      "rawHtsCode": "7009.91.50.91",
      "superior": null,
      "indent": "5",
      "description": "Over-the-door mirrors of a kind described in statistical note 2 to this chapter",
      "units": [
        "cm<sup>2</sup>",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7009.91.5095",
      "rawHtsCode": "7009.91.50.95",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "cm<sup>2</sup>",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7009.92",
      "rawHtsCode": "7009.92",
      "superior": null,
      "indent": "2",
      "description": "Framed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7009.92.10",
      "rawHtsCode": "7009.92.10",
      "superior": null,
      "indent": "3",
      "description": "Not over 929 cm<sup>2</sup> in reflecting area",
      "units": [],
      "generalRate": "7.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7009.92.1010",
      "rawHtsCode": "7009.92.10.10",
      "superior": null,
      "indent": "4",
      "description": "Containing LED or fluorescent lighting",
      "units": [
        "cm<sup>2</sup>",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7009.92.1090",
      "rawHtsCode": "7009.92.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "cm<sup>2</sup>",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7009.92.50",
      "rawHtsCode": "7009.92.50",
      "superior": null,
      "indent": "3",
      "description": "Over 929 cm<sup>2</sup> in reflecting area",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.25% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7009.92.5010",
      "rawHtsCode": "7009.92.50.10",
      "superior": null,
      "indent": "4",
      "description": "Containing LED or fluorescent lighting",
      "units": [
        "cm<sup>2</sup>",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7009.92.5091",
      "rawHtsCode": "7009.92.50.91",
      "superior": null,
      "indent": "5",
      "description": "Over-the-door mirrors of a kind described in statistical note 2 to this chapter",
      "units": [
        "cm<sup>2</sup>",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7009.92.5095",
      "rawHtsCode": "7009.92.50.95",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "cm<sup>2</sup>",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010",
      "rawHtsCode": "7010",
      "superior": null,
      "indent": "0",
      "description": "Carboys, bottles, flasks, jars, pots, vials, ampoules and other containers, of glass, of a kind used for the conveyance or packing of goods; preserving jars of glass; stoppers, lids and other closures, of glass:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.10.0000",
      "rawHtsCode": "7010.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ampoules",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50¢/gross",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7010.20",
      "rawHtsCode": "7010.20",
      "superior": null,
      "indent": "1",
      "description": "Stoppers, lids and other closures:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.20.2000",
      "rawHtsCode": "7010.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Produced by automatic machine",
      "units": [
        "gross"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7010.20.3000",
      "rawHtsCode": "7010.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "5.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7010.90",
      "rawHtsCode": "7010.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.05",
      "rawHtsCode": "7010.90.05",
      "superior": null,
      "indent": "2",
      "description": "Serum bottles, vials and other pharmaceutical containers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50¢/gross",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7010.90.0510",
      "rawHtsCode": "7010.90.05.10",
      "superior": null,
      "indent": "3",
      "description": "Of a capacity exceeding 1 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.0520",
      "rawHtsCode": "7010.90.05.20",
      "superior": null,
      "indent": "3",
      "description": "Of a capacity exceeding 0.33 liter but not exceeding 1 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.0530",
      "rawHtsCode": "7010.90.05.30",
      "superior": null,
      "indent": "3",
      "description": "Of a capacity exceeding 0.15 liter but not exceeding 0.33 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.0540",
      "rawHtsCode": "7010.90.05.40",
      "superior": null,
      "indent": "3",
      "description": "Of a capacity not exceeding 0.15 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.20",
      "rawHtsCode": "7010.90.20",
      "superior": null,
      "indent": "3",
      "description": "Produced by automatic machine",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7010.90.2010",
      "rawHtsCode": "7010.90.20.10",
      "superior": null,
      "indent": "4",
      "description": "Of a capacity exceeding 1 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.2020",
      "rawHtsCode": "7010.90.20.20",
      "superior": null,
      "indent": "4",
      "description": "Of a capacity exceeding 0.33 liter but not exceeding 1 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.2030",
      "rawHtsCode": "7010.90.20.30",
      "superior": null,
      "indent": "4",
      "description": "Of a capacity exceeding 0.15 liter but not exceeding 0.33 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.2040",
      "rawHtsCode": "7010.90.20.40",
      "superior": null,
      "indent": "4",
      "description": "Of a capacity not exceeding 0.15 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.30",
      "rawHtsCode": "7010.90.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7010.90.3010",
      "rawHtsCode": "7010.90.30.10",
      "superior": null,
      "indent": "4",
      "description": "Of a capacity exceeding 1 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.3020",
      "rawHtsCode": "7010.90.30.20",
      "superior": null,
      "indent": "4",
      "description": "Of a capacity exceeding 0.33 liter but not exceeding 1 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.3030",
      "rawHtsCode": "7010.90.30.30",
      "superior": null,
      "indent": "4",
      "description": "Of a capacity exceeding 0.15 liter but not exceeding 0.33 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.3040",
      "rawHtsCode": "7010.90.30.40",
      "superior": null,
      "indent": "4",
      "description": "Of a capacity not exceeding 0.15 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.50",
      "rawHtsCode": "7010.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other containers (with or without their closures)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7010.90.5005",
      "rawHtsCode": "7010.90.50.05",
      "superior": null,
      "indent": "4",
      "description": "Having a mouth with an outer diameter of <il>38 mm</il> or more",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.5009",
      "rawHtsCode": "7010.90.50.09",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.5015",
      "rawHtsCode": "7010.90.50.15",
      "superior": null,
      "indent": "4",
      "description": "Having a mouth with an outer diameter of <il>38 mm</il> or more",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.5019",
      "rawHtsCode": "7010.90.50.19",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.5025",
      "rawHtsCode": "7010.90.50.25",
      "superior": null,
      "indent": "4",
      "description": "Having a mouth with an outer diameter of <il>38 mm</il> or more",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.5029",
      "rawHtsCode": "7010.90.50.29",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.5035",
      "rawHtsCode": "7010.90.50.35",
      "superior": null,
      "indent": "4",
      "description": "Having a mouth with an outer diameter of <il>38 mm</il> or more",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.5039",
      "rawHtsCode": "7010.90.50.39",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.5045",
      "rawHtsCode": "7010.90.50.45",
      "superior": null,
      "indent": "4",
      "description": "Having a mouth with an outer diameter of <il>38 mm</il> or more",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.5049",
      "rawHtsCode": "7010.90.50.49",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7010.90.5055",
      "rawHtsCode": "7010.90.50.55",
      "superior": null,
      "indent": "3",
      "description": "Of a capacity not exceeding 0.118 liter",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7011",
      "rawHtsCode": "7011",
      "superior": null,
      "indent": "0",
      "description": "Glass envelopes (including bulbs and tubes), open, and glass parts thereof, without fittings, for electric lamps and light sources, cathode-ray tubes or the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7011.10",
      "rawHtsCode": "7011.10",
      "superior": null,
      "indent": "1",
      "description": "For electric lighting:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7011.10.1000",
      "rawHtsCode": "7011.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Bulbs for incandescent lamps",
      "units": [
        "hundreds"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7011.10.5000",
      "rawHtsCode": "7011.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "hundreds"
      ],
      "generalRate": "4.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7011.20",
      "rawHtsCode": "7011.20",
      "superior": null,
      "indent": "1",
      "description": "For cathode-ray tubes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7011.20.1000",
      "rawHtsCode": "7011.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Cones",
      "units": [
        "hundreds"
      ],
      "generalRate": "5.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7011.20.4500",
      "rawHtsCode": "7011.20.45.00",
      "superior": null,
      "indent": "3",
      "description": "Monochrome glass envelopes, the foregoing certified by the importer as being for actual use in automatic data processing machine data or graphic display cathode ray tubes",
      "units": [
        "hundreds"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7011.20.85",
      "rawHtsCode": "7011.20.85",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7011.20.8510",
      "rawHtsCode": "7011.20.85.10",
      "superior": null,
      "indent": "5",
      "description": "With greatest diagonal measurement not exceeding <il>50 cm</il>",
      "units": [
        "hundreds"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7011.20.8525",
      "rawHtsCode": "7011.20.85.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "hundreds"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7011.20.8540",
      "rawHtsCode": "7011.20.85.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "hundreds"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7011.90.0000",
      "rawHtsCode": "7011.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "hundreds"
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013",
      "rawHtsCode": "7013",
      "superior": null,
      "indent": "0",
      "description": "Glassware of a kind used for table, kitchen, toilet, office, indoor decoration or similar purposes (other than that of heading 7010 or 7018):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.10",
      "rawHtsCode": "7013.10",
      "superior": null,
      "indent": "1",
      "description": "Of glass-ceramics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.10.1000",
      "rawHtsCode": "7013.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Kitchenware, non-glazed, greater than 75 percent by volume crystalline, of lithium aluminosilicate, having a linear coefficient of expansion not exceeding 10 x 10<sup>-7</sup> per Kelvin within a temperature range of 0˚C to 300˚C, transparent, haze-free, exhibiting transmittances of infrared radiations in excess of 75 percent at a wavelength of 2.5 microns when measured on a sample 3 mm in thickness, and containing β-quartz solid solution as the predominant crystal phase",
      "units": [
        "No."
      ],
      "generalRate": "6.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.10.5000",
      "rawHtsCode": "7013.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "26%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.22",
      "rawHtsCode": "7013.22",
      "superior": null,
      "indent": "2",
      "description": "Of lead crystal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.22.1000",
      "rawHtsCode": "7013.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $1 each",
      "units": [
        "No."
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.22.2000",
      "rawHtsCode": "7013.22.20.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $1 but not over $3 each",
      "units": [
        "No."
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.22.3000",
      "rawHtsCode": "7013.22.30.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $3 but not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "7.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.22.5000",
      "rawHtsCode": "7013.22.50.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.28",
      "rawHtsCode": "7013.28",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.28.0500",
      "rawHtsCode": "7013.28.05.00",
      "superior": null,
      "indent": "3",
      "description": "Pressed and toughened (specially tempered)",
      "units": [
        "No."
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.28.1000",
      "rawHtsCode": "7013.28.10.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $0.30 each",
      "units": [
        "No."
      ],
      "generalRate": "28.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.28.20",
      "rawHtsCode": "7013.28.20",
      "superior": null,
      "indent": "4",
      "description": "Valued over $0.30 but not over $3 each",
      "units": [],
      "generalRate": "22.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.28.2010",
      "rawHtsCode": "7013.28.20.10",
      "superior": null,
      "indent": "5",
      "description": "Crystalline or non-lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.28.2090",
      "rawHtsCode": "7013.28.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.28.3000",
      "rawHtsCode": "7013.28.30.00",
      "superior": null,
      "indent": "6",
      "description": "Valued over $3 but not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.28.4000",
      "rawHtsCode": "7013.28.40.00",
      "superior": null,
      "indent": "6",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.28.50",
      "rawHtsCode": "7013.28.50",
      "superior": null,
      "indent": "6",
      "description": "Valued over $3 but not over $5 each",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.28.5010",
      "rawHtsCode": "7013.28.50.10",
      "superior": null,
      "indent": "7",
      "description": "Crystalline or non-lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.28.5090",
      "rawHtsCode": "7013.28.50.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.28.60",
      "rawHtsCode": "7013.28.60",
      "superior": null,
      "indent": "6",
      "description": "Valued over $5 each",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.28.6010",
      "rawHtsCode": "7013.28.60.10",
      "superior": null,
      "indent": "7",
      "description": "Crystalline or non-lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.28.6090",
      "rawHtsCode": "7013.28.60.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.33",
      "rawHtsCode": "7013.33",
      "superior": null,
      "indent": "2",
      "description": "Of lead crystal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.33.1000",
      "rawHtsCode": "7013.33.10.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $1 each",
      "units": [
        "No."
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.33.2000",
      "rawHtsCode": "7013.33.20.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $1 but not over $3 each",
      "units": [
        "No."
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.33.3000",
      "rawHtsCode": "7013.33.30.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $3 but not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "7.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.33.5000",
      "rawHtsCode": "7013.33.50.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.37",
      "rawHtsCode": "7013.37",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.37.0500",
      "rawHtsCode": "7013.37.05.00",
      "superior": null,
      "indent": "3",
      "description": "Pressed and toughened (specially tempered)",
      "units": [
        "No."
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.37.1001",
      "rawHtsCode": "7013.37.10.01",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $0.30 each",
      "units": [
        "No."
      ],
      "generalRate": "28.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.37.20",
      "rawHtsCode": "7013.37.20",
      "superior": null,
      "indent": "4",
      "description": "Valued over $0.30 but not over $3 each",
      "units": [],
      "generalRate": "22.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.37.2010",
      "rawHtsCode": "7013.37.20.10",
      "superior": null,
      "indent": "5",
      "description": "Crystalline or non-lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.37.2090",
      "rawHtsCode": "7013.37.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.37.3000",
      "rawHtsCode": "7013.37.30.00",
      "superior": null,
      "indent": "6",
      "description": "Valued over $3 but not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.37.4000",
      "rawHtsCode": "7013.37.40.00",
      "superior": null,
      "indent": "6",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.37.50",
      "rawHtsCode": "7013.37.50",
      "superior": null,
      "indent": "6",
      "description": "Valued over $3 but not over $5 each",
      "units": [],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.37.5010",
      "rawHtsCode": "7013.37.50.10",
      "superior": null,
      "indent": "7",
      "description": "Crystalline or non-lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.37.5090",
      "rawHtsCode": "7013.37.50.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.37.60",
      "rawHtsCode": "7013.37.60",
      "superior": null,
      "indent": "6",
      "description": "Valued over $5 each",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.37.6010",
      "rawHtsCode": "7013.37.60.10",
      "superior": null,
      "indent": "7",
      "description": "Crystalline or non-lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.37.6090",
      "rawHtsCode": "7013.37.60.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.41",
      "rawHtsCode": "7013.41",
      "superior": null,
      "indent": "2",
      "description": "Of lead crystal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.41.1000",
      "rawHtsCode": "7013.41.10.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $1 each",
      "units": [
        "No."
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.41.2000",
      "rawHtsCode": "7013.41.20.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $1 but not over $3 each",
      "units": [
        "No."
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.41.3000",
      "rawHtsCode": "7013.41.30.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $3 but not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "10.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.41.5000",
      "rawHtsCode": "7013.41.50.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.42",
      "rawHtsCode": "7013.42",
      "superior": null,
      "indent": "2",
      "description": "Of glass having a linear coefficient of expansion not exceeding 5 x 10<sup>-6</sup> per Kelvin within a temperature range of <il>0˚C to 300˚C:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.42.1000",
      "rawHtsCode": "7013.42.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pressed and toughened (specially tempered)",
      "units": [
        "No."
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.42.2000",
      "rawHtsCode": "7013.42.20.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $3 each",
      "units": [
        "No."
      ],
      "generalRate": "22.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.42.3000",
      "rawHtsCode": "7013.42.30.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $3 but not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.42.4000",
      "rawHtsCode": "7013.42.40.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.49",
      "rawHtsCode": "7013.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.49.1000",
      "rawHtsCode": "7013.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pressed and toughened (specially tempered)",
      "units": [
        "No."
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.49.20",
      "rawHtsCode": "7013.49.20",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $3 each",
      "units": [],
      "generalRate": "22.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.49.2010",
      "rawHtsCode": "7013.49.20.10",
      "superior": null,
      "indent": "5",
      "description": "Crystalline or non-lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.49.2090",
      "rawHtsCode": "7013.49.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.49.3000",
      "rawHtsCode": "7013.49.30.00",
      "superior": null,
      "indent": "6",
      "description": "Valued over $3 but not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "11.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.49.4000",
      "rawHtsCode": "7013.49.40.00",
      "superior": null,
      "indent": "6",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.49.50",
      "rawHtsCode": "7013.49.50",
      "superior": null,
      "indent": "6",
      "description": "Valued over $3 but not over $5 each",
      "units": [],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.49.5010",
      "rawHtsCode": "7013.49.50.10",
      "superior": null,
      "indent": "7",
      "description": "Crystalline or non-lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.49.5090",
      "rawHtsCode": "7013.49.50.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.49.60",
      "rawHtsCode": "7013.49.60",
      "superior": null,
      "indent": "6",
      "description": "Valued over $5 each",
      "units": [],
      "generalRate": "7.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.49.6010",
      "rawHtsCode": "7013.49.60.10",
      "superior": null,
      "indent": "7",
      "description": "Crystalline or non-lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.49.6090",
      "rawHtsCode": "7013.49.60.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.91",
      "rawHtsCode": "7013.91",
      "superior": null,
      "indent": "2",
      "description": "Of lead crystal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.91.1000",
      "rawHtsCode": "7013.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $1 each",
      "units": [
        "No."
      ],
      "generalRate": "20%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.91.2000",
      "rawHtsCode": "7013.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $1 but not over $3 each",
      "units": [
        "No."
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.91.3000",
      "rawHtsCode": "7013.91.30.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $3 but not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "10.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.91.5000",
      "rawHtsCode": "7013.91.50.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.99",
      "rawHtsCode": "7013.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.99.1000",
      "rawHtsCode": "7013.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Glassware decorated with metal flecking, glass pictorial scenes or glass thread- or ribbon-like effects, any of the foregoing embedded or introduced into the body of the glassware prior to its solidification; millefiori glassware; glassware colored prior to solidification, and characterized by random distribution of numerous bubbles, seeds or stones, throughout the mass of the glass",
      "units": [
        "No."
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.99.2000",
      "rawHtsCode": "7013.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Pressed and toughened (specially tempered)",
      "units": [
        "No."
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.99.3000",
      "rawHtsCode": "7013.99.30.00",
      "superior": null,
      "indent": "4",
      "description": "Smokers' articles; perfume bottles fitted with ground glass stoppers",
      "units": [
        "No."
      ],
      "generalRate": "9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.99.3500",
      "rawHtsCode": "7013.99.35.00",
      "superior": null,
      "indent": "4",
      "description": "Votive-candle holders",
      "units": [
        "No."
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.99.4001",
      "rawHtsCode": "7013.99.40.01",
      "superior": null,
      "indent": "5",
      "description": "Valued not over $0.30 each",
      "units": [
        "No."
      ],
      "generalRate": "38%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.99.50",
      "rawHtsCode": "7013.99.50",
      "superior": null,
      "indent": "5",
      "description": "Valued over $0.30 but not over $3 each",
      "units": [],
      "generalRate": "30%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.99.5010",
      "rawHtsCode": "7013.99.50.10",
      "superior": null,
      "indent": "6",
      "description": "Crystalline or non-lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.99.5090",
      "rawHtsCode": "7013.99.50.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.99.6000",
      "rawHtsCode": "7013.99.60.00",
      "superior": null,
      "indent": "7",
      "description": "Valued over $3 but not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.99.7000",
      "rawHtsCode": "7013.99.70.00",
      "superior": null,
      "indent": "7",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.99.80",
      "rawHtsCode": "7013.99.80",
      "superior": null,
      "indent": "7",
      "description": "Valued over $3 but not over $5 each",
      "units": [],
      "generalRate": "11.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.99.8010",
      "rawHtsCode": "7013.99.80.10",
      "superior": null,
      "indent": "8",
      "description": "Crystalline or non-lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.99.8090",
      "rawHtsCode": "7013.99.80.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.99.90",
      "rawHtsCode": "7013.99.90",
      "superior": null,
      "indent": "7",
      "description": "Valued over $5 each",
      "units": [],
      "generalRate": "7.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7013.99.9010",
      "rawHtsCode": "7013.99.90.10",
      "superior": null,
      "indent": "8",
      "description": "Crystalline or non-lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7013.99.9090",
      "rawHtsCode": "7013.99.90.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7014.00",
      "rawHtsCode": "7014.00",
      "superior": null,
      "indent": "0",
      "description": "Signaling glassware and optical elements of glass (other than those of heading 7015), not optically worked:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7014.00.1000",
      "rawHtsCode": "7014.00.10.00",
      "superior": null,
      "indent": "2",
      "description": "Lens blanks (other than for spectacles)",
      "units": [
        "No."
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7014.00.2000",
      "rawHtsCode": "7014.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7014.00.3000",
      "rawHtsCode": "7014.00.30.00",
      "superior": null,
      "indent": "2",
      "description": "Lenses and filters, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7014.00.5000",
      "rawHtsCode": "7014.00.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7015",
      "rawHtsCode": "7015",
      "superior": null,
      "indent": "0",
      "description": "Clock or watch glasses and similar glasses, glasses for noncorrective or corrective spectacles, curved, bent, hollowed or the like, not optically worked; hollow glass spheres and their segments, for the manufacture of such glasses:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7015.10.0000",
      "rawHtsCode": "7015.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Glasses for corrective spectacles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7015.90",
      "rawHtsCode": "7015.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7015.90.1000",
      "rawHtsCode": "7015.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Round",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7015.90.2000",
      "rawHtsCode": "7015.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7015.90.5000",
      "rawHtsCode": "7015.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7016",
      "rawHtsCode": "7016",
      "superior": null,
      "indent": "0",
      "description": "Paving blocks, slabs, bricks, squares, tiles and other articles of pressed or molded glass, whether or not wired, of a kind used for building or construction purposes; glass cubes and other glass smallwares, whether or not on a backing, for mosaics or similar decorative purposes; leaded glass windows and the like; multicellular or foam glass in blocks, panels, plates, shells or similar forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7016.10.0000",
      "rawHtsCode": "7016.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Glass cubes and other glass smallwares, whether or not on a backing, for mosaics or similar decorative purposes",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7016.90",
      "rawHtsCode": "7016.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7016.90.10",
      "rawHtsCode": "7016.90.10",
      "superior": null,
      "indent": "2",
      "description": "Paving blocks, slabs, bricks, squares, tiles and other articles of pressed or molded glass",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7016.90.1010",
      "rawHtsCode": "7016.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Bricks and blocks",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7016.90.1050",
      "rawHtsCode": "7016.90.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7016.90.5000",
      "rawHtsCode": "7016.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7017",
      "rawHtsCode": "7017",
      "superior": null,
      "indent": "0",
      "description": "Laboratory, hygienic or pharmaceutical glassware, whether or not graduated or calibrated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7017.10",
      "rawHtsCode": "7017.10",
      "superior": null,
      "indent": "1",
      "description": "Of fused quartz or other fused silica:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7017.10.3000",
      "rawHtsCode": "7017.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Quartz reactor tubes and holders designed for insertion into diffusion and oxidation furnaces for production of semiconductor wafers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7017.10.6000",
      "rawHtsCode": "7017.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7017.20.0000",
      "rawHtsCode": "7017.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of other glass having a linear coefficient of expansion not exceeding 5 x 10<sup>-6</sup> per Kelvin within a temperature range of 0°C to 300°C",
      "units": [
        "kg"
      ],
      "generalRate": "6.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "85%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7017.90",
      "rawHtsCode": "7017.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7017.90.1000",
      "rawHtsCode": "7017.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Microscope slides and micro cover glasses",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "85%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7017.90.5000",
      "rawHtsCode": "7017.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "85%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7018",
      "rawHtsCode": "7018",
      "superior": null,
      "indent": "0",
      "description": "Glass beads, imitation pearls, imitation precious or semiprecious stones and similar glass smallwares and articles thereof other than imitation jewelry; glass eyes other than prosthetic articles; statuettes and other ornaments of lamp-worked glass, other than imitation jewelry; glass microspheres not exceeding 1 mm in diameter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7018.10",
      "rawHtsCode": "7018.10",
      "superior": null,
      "indent": "1",
      "description": "Glass beads, imitation pearls, imitation precious or semiprecious stones and similar glass smallwares:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7018.10.1000",
      "rawHtsCode": "7018.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Imitation pearls and imitation pearl beads of all shapes and colors, drilled or not drilled, but not strung (except temporarily) and not set",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7018.10.2000",
      "rawHtsCode": "7018.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Imitation precious or semiprecious stones (except imitation beads thereof)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7018.10.5000",
      "rawHtsCode": "7018.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7018.20.0000",
      "rawHtsCode": "7018.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Glass microspheres not exceeding 1 mm in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7018.90",
      "rawHtsCode": "7018.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7018.90.1000",
      "rawHtsCode": "7018.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Glass eyes, except prosthetic articles",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7018.90.5000",
      "rawHtsCode": "7018.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019",
      "rawHtsCode": "7019",
      "superior": null,
      "indent": "0",
      "description": "Glass fibers (including glass wool) and articles thereof (for example, yarn, rovings, woven fabrics):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.11.0000",
      "rawHtsCode": "7019.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Chopped strands, of a length of not more than <il>50 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.12.00",
      "rawHtsCode": "7019.12.00",
      "superior": null,
      "indent": "2",
      "description": "Rovings",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.12.0040",
      "rawHtsCode": "7019.12.00.40",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used in industry as packing or lubricating materials",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.12.0080",
      "rawHtsCode": "7019.12.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.13",
      "rawHtsCode": "7019.13",
      "superior": null,
      "indent": "2",
      "description": "Other yarn, slivers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.13.0500",
      "rawHtsCode": "7019.13.05.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass rubber reinforcing yarn, made from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.13.15",
      "rawHtsCode": "7019.13.15",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.13.1540",
      "rawHtsCode": "7019.13.15.40",
      "superior": null,
      "indent": "6",
      "description": "Of a kind used in industry as packing or lubricating materials (201)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.13.1580",
      "rawHtsCode": "7019.13.15.80",
      "superior": null,
      "indent": "6",
      "description": "Other (201)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.13.2400",
      "rawHtsCode": "7019.13.24.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass rubber reinforcing yarn, made from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.13.2800",
      "rawHtsCode": "7019.13.28.00",
      "superior": null,
      "indent": "5",
      "description": "Other (201)",
      "units": [
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.13.3500",
      "rawHtsCode": "7019.13.35.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.14.0000",
      "rawHtsCode": "7019.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mechanically bonded mats",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.15.0000",
      "rawHtsCode": "7019.15.00.00",
      "superior": null,
      "indent": "2",
      "description": "Chemically bonded mats",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.19",
      "rawHtsCode": "7019.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.19.3000",
      "rawHtsCode": "7019.19.30.00",
      "superior": null,
      "indent": "3",
      "description": "Chopped strands, of a length more than <il>50 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.19.7000",
      "rawHtsCode": "7019.19.70.00",
      "superior": null,
      "indent": "3",
      "description": "Fiberglass rubber reinforcing cord, made from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.19.9100",
      "rawHtsCode": "7019.19.91.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E*, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.61",
      "rawHtsCode": "7019.61",
      "superior": null,
      "indent": "2",
      "description": "Closed woven fabrics of rovings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.61.0500",
      "rawHtsCode": "7019.61.05.00",
      "superior": null,
      "indent": "4",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.61.1000",
      "rawHtsCode": "7019.61.10.00",
      "superior": null,
      "indent": "4",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.61.3000",
      "rawHtsCode": "7019.61.30.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.61.40",
      "rawHtsCode": "7019.61.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.61.4030",
      "rawHtsCode": "7019.61.40.30",
      "superior": null,
      "indent": "6",
      "description": "Silica filament fabric of filaments with silica content greater than 93 percent (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.61.4060",
      "rawHtsCode": "7019.61.40.60",
      "superior": null,
      "indent": "6",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.61.7000",
      "rawHtsCode": "7019.61.70.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.61.90",
      "rawHtsCode": "7019.61.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.61.9030",
      "rawHtsCode": "7019.61.90.30",
      "superior": null,
      "indent": "6",
      "description": "Silica filament fabric of filaments with silica content greater than 93 percent (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.61.9060",
      "rawHtsCode": "7019.61.90.60",
      "superior": null,
      "indent": "6",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.62",
      "rawHtsCode": "7019.62",
      "superior": null,
      "indent": "2",
      "description": "Other closed fabrics of rovings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.62.0500",
      "rawHtsCode": "7019.62.05.00",
      "superior": null,
      "indent": "4",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.62.1500",
      "rawHtsCode": "7019.62.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.62.3000",
      "rawHtsCode": "7019.62.30.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.62.40",
      "rawHtsCode": "7019.62.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.62.4030",
      "rawHtsCode": "7019.62.40.30",
      "superior": null,
      "indent": "6",
      "description": "Silica filament fabric of filaments with silica content greater than 93 percent (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.62.4060",
      "rawHtsCode": "7019.62.40.60",
      "superior": null,
      "indent": "6",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.62.7000",
      "rawHtsCode": "7019.62.70.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.62.90",
      "rawHtsCode": "7019.62.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.62.9030",
      "rawHtsCode": "7019.62.90.30",
      "superior": null,
      "indent": "6",
      "description": "Silica filament fabric of filaments with silica content greater than 93 percent (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.62.9060",
      "rawHtsCode": "7019.62.90.60",
      "superior": null,
      "indent": "6",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.63",
      "rawHtsCode": "7019.63",
      "superior": null,
      "indent": "2",
      "description": "Closed woven fabrics, plain weave, of yarns, not coated or laminated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.63.0500",
      "rawHtsCode": "7019.63.05.00",
      "superior": null,
      "indent": "4",
      "description": "Fiberglass tire cord woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.63.15",
      "rawHtsCode": "7019.63.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.63.1510",
      "rawHtsCode": "7019.63.15.10",
      "superior": null,
      "indent": "5",
      "description": "Weighing 185 grams or less per square meter (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.63.1590",
      "rawHtsCode": "7019.63.15.90",
      "superior": null,
      "indent": "5",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.63.3000",
      "rawHtsCode": "7019.63.30.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.63.40",
      "rawHtsCode": "7019.63.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.63.4030",
      "rawHtsCode": "7019.63.40.30",
      "superior": null,
      "indent": "6",
      "description": "Silica filament fabric of filaments with silica content greater than 93 percent (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.63.4060",
      "rawHtsCode": "7019.63.40.60",
      "superior": null,
      "indent": "6",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.63.7000",
      "rawHtsCode": "7019.63.70.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.63.90",
      "rawHtsCode": "7019.63.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.63.9030",
      "rawHtsCode": "7019.63.90.30",
      "superior": null,
      "indent": "6",
      "description": "Silica filament fabric of filaments with silica content greater than 93 percent (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.63.9060",
      "rawHtsCode": "7019.63.90.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.64",
      "rawHtsCode": "7019.64",
      "superior": null,
      "indent": "2",
      "description": "Closed woven fabrics, plain weave, of yarns, coated or laminated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.64.0500",
      "rawHtsCode": "7019.64.05.00",
      "superior": null,
      "indent": "4",
      "description": "Fiberglass tire cord woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.64.15",
      "rawHtsCode": "7019.64.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.64.1510",
      "rawHtsCode": "7019.64.15.10",
      "superior": null,
      "indent": "5",
      "description": "Weighing 185 grams or less per square meter (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.64.1590",
      "rawHtsCode": "7019.64.15.90",
      "superior": null,
      "indent": "5",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.64.3000",
      "rawHtsCode": "7019.64.30.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.64.40",
      "rawHtsCode": "7019.64.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.64.4030",
      "rawHtsCode": "7019.64.40.30",
      "superior": null,
      "indent": "6",
      "description": "Silica filament fabric of filaments with silica content greater than 93 percent (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.64.4060",
      "rawHtsCode": "7019.64.40.60",
      "superior": null,
      "indent": "6",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.64.7000",
      "rawHtsCode": "7019.64.70.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.64.90",
      "rawHtsCode": "7019.64.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.64.9030",
      "rawHtsCode": "7019.64.90.30",
      "superior": null,
      "indent": "6",
      "description": "Silica filament fabric of filaments with silica content greater than 93 percent (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.64.9060",
      "rawHtsCode": "7019.64.90.60",
      "superior": null,
      "indent": "6",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.65",
      "rawHtsCode": "7019.65",
      "superior": null,
      "indent": "2",
      "description": "Open woven fabrics of a width not exceeding 30 cm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.65.5100",
      "rawHtsCode": "7019.65.51.00",
      "superior": null,
      "indent": "3",
      "description": "Fiberglass tire cord woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.65.90",
      "rawHtsCode": "7019.65.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.65.9010",
      "rawHtsCode": "7019.65.90.10",
      "superior": null,
      "indent": "4",
      "description": "Weighing 185 grams or less per square meter (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.65.9090",
      "rawHtsCode": "7019.65.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.66",
      "rawHtsCode": "7019.66",
      "superior": null,
      "indent": "3",
      "description": "Plain weave, weighing less than 250 g/m<sup>2</sup>, of filaments measuring per single yarn not more than 136 tex:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.66.3000",
      "rawHtsCode": "7019.66.30.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.66.40",
      "rawHtsCode": "7019.66.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.66.4010",
      "rawHtsCode": "7019.66.40.10",
      "superior": null,
      "indent": "6",
      "description": "Weighing 185 grams or less per square meter (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.66.4021",
      "rawHtsCode": "7019.66.40.21",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than 215 grams per square meter, with a filament diameter of 7 to <il>13 microns</il> (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.66.4096",
      "rawHtsCode": "7019.66.40.96",
      "superior": null,
      "indent": "6",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.66.7000",
      "rawHtsCode": "7019.66.70.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.66.90",
      "rawHtsCode": "7019.66.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.66.9010",
      "rawHtsCode": "7019.66.90.10",
      "superior": null,
      "indent": "6",
      "description": "Weighing 185 grams or less per square meter (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.66.9021",
      "rawHtsCode": "7019.66.90.21",
      "superior": null,
      "indent": "6",
      "description": "Weighing more than 215 grams per square meter, with a filament diameter of 7 to <il>13 microns</il> (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.66.9060",
      "rawHtsCode": "7019.66.90.60",
      "superior": null,
      "indent": "6",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.69",
      "rawHtsCode": "7019.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.69.3000",
      "rawHtsCode": "7019.69.30.00",
      "superior": null,
      "indent": "4",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.69.40",
      "rawHtsCode": "7019.69.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.69.4010",
      "rawHtsCode": "7019.69.40.10",
      "superior": null,
      "indent": "5",
      "description": "Weighing 185 grams or less per square meter (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.69.4021",
      "rawHtsCode": "7019.69.40.21",
      "superior": null,
      "indent": "5",
      "description": "Weighing more than 215 grams per square meter, with a filament diameter of 7 to <il>13 microns</il> (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.69.4096",
      "rawHtsCode": "7019.69.40.96",
      "superior": null,
      "indent": "5",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.69.7000",
      "rawHtsCode": "7019.69.70.00",
      "superior": null,
      "indent": "4",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.69.90",
      "rawHtsCode": "7019.69.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.69.9010",
      "rawHtsCode": "7019.69.90.10",
      "superior": null,
      "indent": "5",
      "description": "Weighing 185 grams or less per square meter (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.69.9021",
      "rawHtsCode": "7019.69.90.21",
      "superior": null,
      "indent": "5",
      "description": "Weighing more than 215 grams per square meter, with a filament diameter of 7 to <il>13 microns</il> (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.69.9060",
      "rawHtsCode": "7019.69.90.60",
      "superior": null,
      "indent": "5",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.71.0000",
      "rawHtsCode": "7019.71.00.00",
      "superior": null,
      "indent": "2",
      "description": "Veils (thin sheets)",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.72",
      "rawHtsCode": "7019.72",
      "superior": null,
      "indent": "2",
      "description": "Other closed fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.72.0500",
      "rawHtsCode": "7019.72.05.00",
      "superior": null,
      "indent": "4",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.72.1500",
      "rawHtsCode": "7019.72.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.72.3000",
      "rawHtsCode": "7019.72.30.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.72.40",
      "rawHtsCode": "7019.72.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.72.4030",
      "rawHtsCode": "7019.72.40.30",
      "superior": null,
      "indent": "6",
      "description": "Silica filament fabric of filaments with silica content greater than 93 percent (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.72.4060",
      "rawHtsCode": "7019.72.40.60",
      "superior": null,
      "indent": "6",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.72.7000",
      "rawHtsCode": "7019.72.70.00",
      "superior": null,
      "indent": "5",
      "description": "Fiberglass tire cord fabric woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.72.90",
      "rawHtsCode": "7019.72.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "7%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.72.9030",
      "rawHtsCode": "7019.72.90.30",
      "superior": null,
      "indent": "6",
      "description": "Silica filament fabric of filaments with silica content greater than 93 percent (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.72.9060",
      "rawHtsCode": "7019.72.90.60",
      "superior": null,
      "indent": "6",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.73",
      "rawHtsCode": "7019.73",
      "superior": null,
      "indent": "2",
      "description": "Other open fabrics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.73.5100",
      "rawHtsCode": "7019.73.51.00",
      "superior": null,
      "indent": "3",
      "description": "Fiberglass tire cord woven from electrically nonconductive continuous fiberglass filaments <il>9 microns</il> in diameter to 11 microns in diameter and impregnated with resorcinol formaldehyde latex treatment for adhesion to polymeric compounds (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7019.73.90",
      "rawHtsCode": "7019.73.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.73.9010",
      "rawHtsCode": "7019.73.90.10",
      "superior": null,
      "indent": "4",
      "description": "Weighing 185 grams or less per square meter (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.73.9090",
      "rawHtsCode": "7019.73.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other (622)",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.80",
      "rawHtsCode": "7019.80",
      "superior": null,
      "indent": "1",
      "description": "Glass wool and articles of glass wool:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.80.10",
      "rawHtsCode": "7019.80.10",
      "superior": null,
      "indent": "2",
      "description": "Insulation products",
      "units": [],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.80.1010",
      "rawHtsCode": "7019.80.10.10",
      "superior": null,
      "indent": "3",
      "description": "Batts",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.80.1020",
      "rawHtsCode": "7019.80.10.20",
      "superior": null,
      "indent": "3",
      "description": "Pipe coverings",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.80.1090",
      "rawHtsCode": "7019.80.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.80.9000",
      "rawHtsCode": "7019.80.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg",
        "m<sup>2</sup>"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.90",
      "rawHtsCode": "7019.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.90.1100",
      "rawHtsCode": "7019.90.11.00",
      "superior": null,
      "indent": "2",
      "description": "Woven",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.90.51",
      "rawHtsCode": "7019.90.51",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7019.90.5120",
      "rawHtsCode": "7019.90.51.20",
      "superior": null,
      "indent": "3",
      "description": "Glass fibers in bulk",
      "units": [
        "kg",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.90.5140",
      "rawHtsCode": "7019.90.51.40",
      "superior": null,
      "indent": "3",
      "description": "Glass fiber filters",
      "units": [
        "kg",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7019.90.5150",
      "rawHtsCode": "7019.90.51.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7020.00",
      "rawHtsCode": "7020.00",
      "superior": null,
      "indent": "0",
      "description": "Other articles of glass:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7020.00.3000",
      "rawHtsCode": "7020.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Quartz reactor tubes and holders designed for insertion into diffusion and oxidation furnaces for production of semiconductor wafers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7020.00.4000",
      "rawHtsCode": "7020.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Glass inners for vacuum flasks or for other vacuum vessels",
      "units": [
        "No."
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7020.00.6000",
      "rawHtsCode": "7020.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7101",
      "rawHtsCode": "7101",
      "superior": null,
      "indent": "0",
      "description": "Pearls, natural or cultured, whether or not worked or graded but not strung, mounted or set; pearls, natural or cultured, temporarily strung for convenience of transport:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7101.10",
      "rawHtsCode": "7101.10",
      "superior": null,
      "indent": "1",
      "description": "Natural pearls:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7101.10.3000",
      "rawHtsCode": "7101.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Graded and temporarily strung for convenience of transport",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7101.10.6000",
      "rawHtsCode": "7101.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7101.21.0000",
      "rawHtsCode": "7101.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unworked",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7101.22",
      "rawHtsCode": "7101.22",
      "superior": null,
      "indent": "2",
      "description": "Worked:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7101.22.3000",
      "rawHtsCode": "7101.22.30.00",
      "superior": null,
      "indent": "3",
      "description": "Graded and temporarily strung for convenience of transport",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7101.22.6000",
      "rawHtsCode": "7101.22.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7102",
      "rawHtsCode": "7102",
      "superior": null,
      "indent": "0",
      "description": "Diamonds, whether or not worked, but not mounted or set:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7102.10.0000",
      "rawHtsCode": "7102.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Unsorted",
      "units": [
        "carat"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7102.21",
      "rawHtsCode": "7102.21",
      "superior": null,
      "indent": "2",
      "description": "Unworked or simply sawn, cleaved or bruted:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7102.21.10",
      "rawHtsCode": "7102.21.10",
      "superior": null,
      "indent": "3",
      "description": "Miners' diamonds",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7102.21.1010",
      "rawHtsCode": "7102.21.10.10",
      "superior": null,
      "indent": "4",
      "description": "Carbonados",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7102.21.1020",
      "rawHtsCode": "7102.21.10.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7102.21.3000",
      "rawHtsCode": "7102.21.30.00",
      "superior": null,
      "indent": "4",
      "description": "Simply sawn, cleaved or bruted",
      "units": [
        "carat"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7102.21.4000",
      "rawHtsCode": "7102.21.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "carat"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7102.29.00",
      "rawHtsCode": "7102.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7102.29.0010",
      "rawHtsCode": "7102.29.00.10",
      "superior": null,
      "indent": "4",
      "description": "Carbonados",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7102.29.0020",
      "rawHtsCode": "7102.29.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7102.29.0050",
      "rawHtsCode": "7102.29.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7102.31.0000",
      "rawHtsCode": "7102.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unworked or simply sawn, cleaved or bruted",
      "units": [
        "carat"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7102.39.00",
      "rawHtsCode": "7102.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7102.39.0010",
      "rawHtsCode": "7102.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Weighing not over 0.5 carat each",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7102.39.0050",
      "rawHtsCode": "7102.39.00.50",
      "superior": null,
      "indent": "3",
      "description": "Weighing over 0.5 carat each",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7103",
      "rawHtsCode": "7103",
      "superior": null,
      "indent": "0",
      "description": "Precious stones (other than diamonds) and semiprecious stones, whether or not worked or graded but not strung, mounted or set; ungraded precious stones (other than diamonds) and semiprecious stones, temporarily strung for convenience of transport:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7103.10",
      "rawHtsCode": "7103.10",
      "superior": null,
      "indent": "1",
      "description": "Unworked or simply sawn or roughly shaped:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7103.10.2000",
      "rawHtsCode": "7103.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Unworked",
      "units": [
        "carat"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7103.10.4000",
      "rawHtsCode": "7103.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "carat"
      ],
      "generalRate": "10.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7103.91.00",
      "rawHtsCode": "7103.91.00",
      "superior": null,
      "indent": "2",
      "description": "Rubies, sapphires and emeralds",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7103.91.0010",
      "rawHtsCode": "7103.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Rubies",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7103.91.0020",
      "rawHtsCode": "7103.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sapphires",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7103.91.0030",
      "rawHtsCode": "7103.91.00.30",
      "superior": null,
      "indent": "3",
      "description": "Emeralds",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7103.99",
      "rawHtsCode": "7103.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7103.99.1000",
      "rawHtsCode": "7103.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cut but not set, and suitable for use in the manufacture of jewelry",
      "units": [
        "carat"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7103.99.5000",
      "rawHtsCode": "7103.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "carat"
      ],
      "generalRate": "10.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7104",
      "rawHtsCode": "7104",
      "superior": null,
      "indent": "0",
      "description": "Synthetic or reconstructed precious or semiprecious stones, whether or not worked or graded but not strung, mounted or set; ungraded synthetic or reconstructed precious or semiprecious stones, temporarily strung for convenience of transport:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7104.10.0000",
      "rawHtsCode": "7104.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Piezo-electric quartz",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7104.21.0000",
      "rawHtsCode": "7104.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Diamonds",
      "units": [
        "g"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7104.29.0000",
      "rawHtsCode": "7104.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7104.91",
      "rawHtsCode": "7104.91",
      "superior": null,
      "indent": "2",
      "description": "Diamonds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7104.91.1000",
      "rawHtsCode": "7104.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cut but not set, and suitable for use in the manufacture of jewelry",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7104.91.5000",
      "rawHtsCode": "7104.91.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7104.99",
      "rawHtsCode": "7104.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7104.99.1000",
      "rawHtsCode": "7104.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cut but not set, and suitable for use in the manufacture of jewelry",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7104.99.5000",
      "rawHtsCode": "7104.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7105",
      "rawHtsCode": "7105",
      "superior": null,
      "indent": "0",
      "description": "Dust and powder of natural or synthetic precious or semi- precious stones:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7105.10.00",
      "rawHtsCode": "7105.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of diamonds",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7105.10.0011",
      "rawHtsCode": "7105.10.00.11",
      "superior": null,
      "indent": "3",
      "description": "80 mesh or finer",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7105.10.0015",
      "rawHtsCode": "7105.10.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7105.10.0020",
      "rawHtsCode": "7105.10.00.20",
      "superior": null,
      "indent": "3",
      "description": "Coated with metal",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7105.10.0030",
      "rawHtsCode": "7105.10.00.30",
      "superior": null,
      "indent": "4",
      "description": "80 mesh or finer",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7105.10.0050",
      "rawHtsCode": "7105.10.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "carat"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7105.90.0000",
      "rawHtsCode": "7105.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7106",
      "rawHtsCode": "7106",
      "superior": null,
      "indent": "0",
      "description": "Silver (including silver plated with gold or platinum), unwrought or in semimanufactured forms, or in powder form:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7106.10.0000",
      "rawHtsCode": "7106.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Powder",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7106.91",
      "rawHtsCode": "7106.91",
      "superior": null,
      "indent": "2",
      "description": "Unwrought:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7106.91.10",
      "rawHtsCode": "7106.91.10",
      "superior": null,
      "indent": "3",
      "description": "Bullion and dore",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7106.91.1010",
      "rawHtsCode": "7106.91.10.10",
      "superior": null,
      "indent": "4",
      "description": "Bullion",
      "units": [
        "Ag g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7106.91.1020",
      "rawHtsCode": "7106.91.10.20",
      "superior": null,
      "indent": "4",
      "description": "Dore",
      "units": [
        "Ag g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7106.91.5000",
      "rawHtsCode": "7106.91.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7106.92",
      "rawHtsCode": "7106.92",
      "superior": null,
      "indent": "2",
      "description": "Semimanufactured:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7106.92.1000",
      "rawHtsCode": "7106.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "Rectangular or near rectangular shapes, containing 99.5 percent or more by weight of silver and not otherwise marked or decorated than with weight, purity, or other identifying information",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7106.92.5000",
      "rawHtsCode": "7106.92.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7107.00.0000",
      "rawHtsCode": "7107.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Base metals clad with silver, not further worked than semi- manufactured",
      "units": [
        "g"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7108",
      "rawHtsCode": "7108",
      "superior": null,
      "indent": "0",
      "description": "Gold (including gold plated with platinum) unwrought or in semi-manufactured forms, or in powder form:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7108.11.0000",
      "rawHtsCode": "7108.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Powder",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7108.12",
      "rawHtsCode": "7108.12",
      "superior": null,
      "indent": "2",
      "description": "Other unwrought forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7108.12.10",
      "rawHtsCode": "7108.12.10",
      "superior": null,
      "indent": "3",
      "description": "Bullion and dore",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7108.12.1013",
      "rawHtsCode": "7108.12.10.13",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight not less than 99.95 percent of gold",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7108.12.1017",
      "rawHtsCode": "7108.12.10.17",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7108.12.1020",
      "rawHtsCode": "7108.12.10.20",
      "superior": null,
      "indent": "4",
      "description": "Dore",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7108.12.50",
      "rawHtsCode": "7108.12.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7108.12.5010",
      "rawHtsCode": "7108.12.50.10",
      "superior": null,
      "indent": "4",
      "description": "Containing by weight not less than 99.95 percent of gold",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7108.12.5050",
      "rawHtsCode": "7108.12.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7108.13",
      "rawHtsCode": "7108.13",
      "superior": null,
      "indent": "2",
      "description": "Other semimanufactured forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7108.13.1000",
      "rawHtsCode": "7108.13.10.00",
      "superior": null,
      "indent": "3",
      "description": "Gold leaf",
      "units": [
        "cm<sup>2</sup>",
        "Au g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7108.13.5500",
      "rawHtsCode": "7108.13.55.00",
      "superior": null,
      "indent": "4",
      "description": "Rectangular or near rectangular shapes, containing 99.5 percent or more by weight of gold and not otherwise marked or decorated than with weight, purity, or other identifying information",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7108.13.7000",
      "rawHtsCode": "7108.13.70.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7108.20.0000",
      "rawHtsCode": "7108.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Monetary",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7109.00.0000",
      "rawHtsCode": "7109.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Base metals or silver, clad with gold, not further worked than semimanufactured",
      "units": [
        "g"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7110",
      "rawHtsCode": "7110",
      "superior": null,
      "indent": "0",
      "description": "Platinum, unwrought or in semimanufactured forms, or in powder form:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7110.11.00",
      "rawHtsCode": "7110.11.00",
      "superior": null,
      "indent": "2",
      "description": "Unwrought or in powder form",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7110.11.0010",
      "rawHtsCode": "7110.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Grain and nuggets of the metal platinum",
      "units": [
        "Pt g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7110.11.0020",
      "rawHtsCode": "7110.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sponge of the metal platinum",
      "units": [
        "Pt g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7110.11.0050",
      "rawHtsCode": "7110.11.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "Pt g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7110.19.0000",
      "rawHtsCode": "7110.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "Pt g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7110.21.0000",
      "rawHtsCode": "7110.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unwrought or in powder",
      "units": [
        "Pd g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7110.29.0000",
      "rawHtsCode": "7110.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "Pd g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7110.31.0000",
      "rawHtsCode": "7110.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unwrought or in powder form",
      "units": [
        "Rh g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7110.39.0000",
      "rawHtsCode": "7110.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "Rh g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7110.41.00",
      "rawHtsCode": "7110.41.00",
      "superior": null,
      "indent": "2",
      "description": "Unwrought or in powder form",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7110.41.0010",
      "rawHtsCode": "7110.41.00.10",
      "superior": null,
      "indent": "4",
      "description": "Iridium",
      "units": [
        "Ir g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7110.41.0020",
      "rawHtsCode": "7110.41.00.20",
      "superior": null,
      "indent": "4",
      "description": "Osmium",
      "units": [
        "Os g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7110.41.0030",
      "rawHtsCode": "7110.41.00.30",
      "superior": null,
      "indent": "4",
      "description": "Ruthenium",
      "units": [
        "Ru g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7110.41.0050",
      "rawHtsCode": "7110.41.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7110.49.00",
      "rawHtsCode": "7110.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7110.49.0010",
      "rawHtsCode": "7110.49.00.10",
      "superior": null,
      "indent": "3",
      "description": "Iridium separately",
      "units": [
        "Ir g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7110.49.0050",
      "rawHtsCode": "7110.49.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7111.00.0000",
      "rawHtsCode": "7111.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Base metals, silver or gold, clad with platinum, not further worked than semimanufactured",
      "units": [
        "g"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7112",
      "rawHtsCode": "7112",
      "superior": null,
      "indent": "0",
      "description": "Waste and scrap of precious metal or of metal clad with precious metal; other waste and scrap containing precious metal or precious metal compounds, of a kind used principally for the recovery of precious metal other than goods of heading 8549:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7112.30.0100",
      "rawHtsCode": "7112.30.01.00",
      "superior": null,
      "indent": "1",
      "description": "Ash containing precious metal or precious metal compounds",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7112.91.0100",
      "rawHtsCode": "7112.91.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of gold, including metal clad with gold but excluding sweepings containing other precious metals",
      "units": [
        "g",
        "Au g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7112.92.0100",
      "rawHtsCode": "7112.92.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of platinum, including metal clad with platinum but excluding sweepings containing other precious metals",
      "units": [
        "g",
        "Pt g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7112.99.0100",
      "rawHtsCode": "7112.99.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7113",
      "rawHtsCode": "7113",
      "superior": null,
      "indent": "0",
      "description": "Articles of jewelry and parts thereof, of precious metal or of metal clad with precious metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7113.11",
      "rawHtsCode": "7113.11",
      "superior": null,
      "indent": "2",
      "description": "Of silver, whether or not plated or clad with other precious metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7113.11.1000",
      "rawHtsCode": "7113.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Rope, curb, cable, chain and similar articles produced in continuous lengths, all the foregoing, whether or not cut to specific lengths and whether or not set with imitation pearls or imitation gemstones, suitable for use in the manufacture of articles provided for in this heading",
      "units": [
        "g"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.11.2000",
      "rawHtsCode": "7113.11.20.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $18 per dozen pieces or parts",
      "units": [
        "g"
      ],
      "generalRate": "13.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.11.5000",
      "rawHtsCode": "7113.11.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.19",
      "rawHtsCode": "7113.19",
      "superior": null,
      "indent": "2",
      "description": "Of other precious metal, whether or not plated or clad with precious metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7113.19.1000",
      "rawHtsCode": "7113.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Rope, curb, cable, chain and similar articles produced in continuous lengths, all the foregoing, whether or not cut to specific lengths and whether or not set with imitation pearls or imitation gemstones, suitable for use in the manufacture of articles provided for in this heading",
      "units": [
        "g"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.19.2100",
      "rawHtsCode": "7113.19.21.00",
      "superior": null,
      "indent": "5",
      "description": "Rope",
      "units": [
        "g"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.19.2500",
      "rawHtsCode": "7113.19.25.00",
      "superior": null,
      "indent": "5",
      "description": "Mixed link",
      "units": [
        "g"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.19.2900",
      "rawHtsCode": "7113.19.29.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.19.3000",
      "rawHtsCode": "7113.19.30.00",
      "superior": null,
      "indent": "4",
      "description": "Clasps and parts thereof",
      "units": [
        "g"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.19.50",
      "rawHtsCode": "7113.19.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.19.5021",
      "rawHtsCode": "7113.19.50.21",
      "superior": null,
      "indent": "6",
      "description": "Necklaces and neck chains",
      "units": [
        "pcs "
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 2 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "7113.19.5025",
      "rawHtsCode": "7113.19.50.25",
      "superior": null,
      "indent": "6",
      "description": "Rings",
      "units": [
        "pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 2 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "7113.19.5030",
      "rawHtsCode": "7113.19.50.30",
      "superior": null,
      "indent": "6",
      "description": "Earrings",
      "units": [
        "pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 2 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "7113.19.5045",
      "rawHtsCode": "7113.19.50.45",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "pcs "
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 2 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "7113.19.5091",
      "rawHtsCode": "7113.19.50.91",
      "superior": null,
      "indent": "6",
      "description": "Articles of jewelry, of gold, other than rope, curb, cable, chain, necklaces, neck chains or clasps",
      "units": [
        "pcs"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7113.19.5095",
      "rawHtsCode": "7113.19.50.95",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7113.20",
      "rawHtsCode": "7113.20",
      "superior": null,
      "indent": "1",
      "description": "Of base metal clad with precious metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7113.20.1000",
      "rawHtsCode": "7113.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Rope, curb, cable, chain and similar articles produced in continuous lengths, all the foregoing, whether or not cut to specific lengths and whether or not set with imitation pearls or imitation gemstones, suitable for use in the manufacture of articles provided for in this heading",
      "units": [
        "g"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.20.2100",
      "rawHtsCode": "7113.20.21.00",
      "superior": null,
      "indent": "4",
      "description": "Rope",
      "units": [
        "g"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.20.2500",
      "rawHtsCode": "7113.20.25.00",
      "superior": null,
      "indent": "4",
      "description": "Mixed link",
      "units": [
        "g"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.20.2900",
      "rawHtsCode": "7113.20.29.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "5.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.20.3000",
      "rawHtsCode": "7113.20.30.00",
      "superior": null,
      "indent": "3",
      "description": "Clasps and parts thereof",
      "units": [
        "g"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7113.20.5000",
      "rawHtsCode": "7113.20.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "5.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7114",
      "rawHtsCode": "7114",
      "superior": null,
      "indent": "0",
      "description": "Articles of goldsmiths' or silversmiths' wares and parts thereof, of precious metal or of metal clad with precious metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7114.11",
      "rawHtsCode": "7114.11",
      "superior": null,
      "indent": "2",
      "description": "Of silver, whether or not plated or clad with other precious metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7114.11.1000",
      "rawHtsCode": "7114.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Knives with silver handles",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "16¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7114.11.2000",
      "rawHtsCode": "7114.11.20.00",
      "superior": null,
      "indent": "3",
      "description": "Forks with silver handles",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "16¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7114.11.3000",
      "rawHtsCode": "7114.11.30.00",
      "superior": null,
      "indent": "4",
      "description": "With sterling silver handles",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7114.11.4000",
      "rawHtsCode": "7114.11.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7114.11.4500",
      "rawHtsCode": "7114.11.45.00",
      "superior": null,
      "indent": "3",
      "description": "Sets of the foregoing which include two or more knives, forks, spoons or ladles",
      "units": [
        "pcs"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7114.11.5000",
      "rawHtsCode": "7114.11.50.00",
      "superior": null,
      "indent": "4",
      "description": "Sterling silver tableware",
      "units": [
        "g"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7114.11.6000",
      "rawHtsCode": "7114.11.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7114.11.7000",
      "rawHtsCode": "7114.11.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7114.19.0000",
      "rawHtsCode": "7114.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of other precious metal whether or not plated or clad with precious metal",
      "units": [
        "g"
      ],
      "generalRate": "7.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7114.20.00",
      "rawHtsCode": "7114.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of base metal clad with precious metal",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7114.20.0040",
      "rawHtsCode": "7114.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Articles not elsewhere specified or included, of a type used for household, table or kitchen use; toilet or sanitary ware",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7114.20.0060",
      "rawHtsCode": "7114.20.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7115",
      "rawHtsCode": "7115",
      "superior": null,
      "indent": "0",
      "description": "Other articles of precious metal or of metal clad with precious metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7115.10.0000",
      "rawHtsCode": "7115.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Catalysts in the form of wire cloth or grill, of platinum",
      "units": [
        "g"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7115.90",
      "rawHtsCode": "7115.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7115.90.05",
      "rawHtsCode": "7115.90.05",
      "superior": null,
      "indent": "2",
      "description": "Articles of precious metal, in rectangular or near rectangular shapes, containing 99.5 percent or more by weight of a precious metal and not otherwise marked or decorated than with weight, purity, or other identifying information",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7115.90.0530",
      "rawHtsCode": "7115.90.05.30",
      "superior": null,
      "indent": "3",
      "description": "Of gold",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7115.90.0560",
      "rawHtsCode": "7115.90.05.60",
      "superior": null,
      "indent": "3",
      "description": "Of silver",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7115.90.0590",
      "rawHtsCode": "7115.90.05.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7115.90.3000",
      "rawHtsCode": "7115.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of gold, including metal clad with gold",
      "units": [
        "g"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7115.90.4000",
      "rawHtsCode": "7115.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of silver, including metal clad with silver",
      "units": [
        "g"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7115.90.6000",
      "rawHtsCode": "7115.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7116",
      "rawHtsCode": "7116",
      "superior": null,
      "indent": "0",
      "description": "Articles of natural or cultured pearls, precious or semiprecious stones (natural, synthetic or reconstructed):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7116.10",
      "rawHtsCode": "7116.10",
      "superior": null,
      "indent": "1",
      "description": "Of natural or cultured pearls:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7116.10.1000",
      "rawHtsCode": "7116.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Natural",
      "units": [
        "g"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7116.10.2500",
      "rawHtsCode": "7116.10.25.00",
      "superior": null,
      "indent": "2",
      "description": "Cultured",
      "units": [
        "g"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7116.20",
      "rawHtsCode": "7116.20",
      "superior": null,
      "indent": "1",
      "description": "Of precious or semiprecious stones (natural, synthetic or reconstructed):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7116.20.0500",
      "rawHtsCode": "7116.20.05.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $40 per piece",
      "units": [
        "g"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7116.20.1500",
      "rawHtsCode": "7116.20.15.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7116.20.3000",
      "rawHtsCode": "7116.20.30.00",
      "superior": null,
      "indent": "4",
      "description": "Graded semiprecious stones strung temporarily for convenience of transport",
      "units": [
        "g"
      ],
      "generalRate": "2.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7116.20.3500",
      "rawHtsCode": "7116.20.35.00",
      "superior": null,
      "indent": "4",
      "description": "Figurines of semiprecious stone",
      "units": [
        "No."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7116.20.4000",
      "rawHtsCode": "7116.20.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "10.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7116.20.5000",
      "rawHtsCode": "7116.20.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7117",
      "rawHtsCode": "7117",
      "superior": null,
      "indent": "0",
      "description": "Imitation jewelry:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7117.11.0000",
      "rawHtsCode": "7117.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cuff links and studs",
      "units": [
        "No."
      ],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7117.19",
      "rawHtsCode": "7117.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7117.19.0500",
      "rawHtsCode": "7117.19.05.00",
      "superior": null,
      "indent": "5",
      "description": "Toy jewelry valued not over 8 cents per piece",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7117.19.1500",
      "rawHtsCode": "7117.19.15.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7117.19.2000",
      "rawHtsCode": "7117.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over 33 cents per meter",
      "units": [
        "kg"
      ],
      "generalRate": "11%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7117.19.3000",
      "rawHtsCode": "7117.19.30.00",
      "superior": null,
      "indent": "3",
      "description": "Religious articles of a purely devotional charac- ter designed to be worn on apparel or carried on or about or attached to the person",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7117.19.6000",
      "rawHtsCode": "7117.19.60.00",
      "superior": null,
      "indent": "4",
      "description": "Toy jewelry valued not over 8 cents per piece",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7117.19.9000",
      "rawHtsCode": "7117.19.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "11%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7117.90",
      "rawHtsCode": "7117.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7117.90.1000",
      "rawHtsCode": "7117.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Necklaces, valued not over 30 cents per dozen, composed wholly of plastic shapes mounted on fiber string",
      "units": [
        "doz."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7117.90.2000",
      "rawHtsCode": "7117.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Rosaries and chaplets",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7117.90.3000",
      "rawHtsCode": "7117.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7117.90.4500",
      "rawHtsCode": "7117.90.45.00",
      "superior": null,
      "indent": "4",
      "description": "Toy jewelry (except parts)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7117.90.5500",
      "rawHtsCode": "7117.90.55.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7117.90.6000",
      "rawHtsCode": "7117.90.60.00",
      "superior": null,
      "indent": "4",
      "description": "Toy jewelry (except parts) valued not over 8 cents per piece",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7117.90.7500",
      "rawHtsCode": "7117.90.75.00",
      "superior": null,
      "indent": "5",
      "description": "Of plastics",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7117.90.9000",
      "rawHtsCode": "7117.90.90.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "11%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7118",
      "rawHtsCode": "7118",
      "superior": null,
      "indent": "0",
      "description": "Coin:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7118.10.0000",
      "rawHtsCode": "7118.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Coin (other than gold coin), not being legal tender",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7118.90.00",
      "rawHtsCode": "7118.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7118.90.0011",
      "rawHtsCode": "7118.90.00.11",
      "superior": null,
      "indent": "3",
      "description": "Canadian maple leaf",
      "units": [
        "g",
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7118.90.0019",
      "rawHtsCode": "7118.90.00.19",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "g",
        "Au g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7118.90.0020",
      "rawHtsCode": "7118.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Platinum",
      "units": [
        "g",
        "Pt g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7118.90.0055",
      "rawHtsCode": "7118.90.00.55",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7201",
      "rawHtsCode": "7201",
      "superior": null,
      "indent": "0",
      "description": "Pig iron and spiegeleisen in pigs, blocks or other primary forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7201.10.0000",
      "rawHtsCode": "7201.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Nonalloy pig iron containing by weight 0.5 percent or less of phosphorus",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.11/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7201.20.0000",
      "rawHtsCode": "7201.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Nonalloy pig iron containing by weight more than 0.5 percent of phosphorus",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.11/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7201.50",
      "rawHtsCode": "7201.50",
      "superior": null,
      "indent": "1",
      "description": "Alloy pig iron; spiegeleisen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7201.50.3000",
      "rawHtsCode": "7201.50.30.00",
      "superior": null,
      "indent": "2",
      "description": "Alloy pig iron",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.11/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7201.50.6000",
      "rawHtsCode": "7201.50.60.00",
      "superior": null,
      "indent": "2",
      "description": "Spiegeleisen",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7202",
      "rawHtsCode": "7202",
      "superior": null,
      "indent": "0",
      "description": "Ferroalloys:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7202.11",
      "rawHtsCode": "7202.11",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight more than 2 percent of carbon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7202.11.1000",
      "rawHtsCode": "7202.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight more than 2 percent but not more than 4 percent of carbon",
      "units": [
        "kg",
        "Mn kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.11.5000",
      "rawHtsCode": "7202.11.50.00",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight more than 4 percent of carbon",
      "units": [
        "kg",
        "Mn kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.19",
      "rawHtsCode": "7202.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7202.19.1000",
      "rawHtsCode": "7202.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight not more than 1 percent of carbon",
      "units": [
        "kg",
        "Mn kg"
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.19.5000",
      "rawHtsCode": "7202.19.50.00",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight more than 1 percent but not more than 2 percent of carbon",
      "units": [
        "kg",
        "Mn kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.21",
      "rawHtsCode": "7202.21",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight more than 55 percent of silicon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7202.21.1000",
      "rawHtsCode": "7202.21.10.00",
      "superior": null,
      "indent": "4",
      "description": "Containing by weight more than 3 percent of calcium",
      "units": [
        "kg",
        "Si kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.21.5000",
      "rawHtsCode": "7202.21.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "Si kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.21.7500",
      "rawHtsCode": "7202.21.75.00",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight more than 80 percent but not more than 90 percent of silicon",
      "units": [
        "kg",
        "Si kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.21.9000",
      "rawHtsCode": "7202.21.90.00",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight more than 90 percent of silicon",
      "units": [
        "kg",
        "Si kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.29.00",
      "rawHtsCode": "7202.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg on silicon content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7202.29.0010",
      "rawHtsCode": "7202.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight over 2 percent of magnesium",
      "units": [
        "kg",
        "Si kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7202.29.0050",
      "rawHtsCode": "7202.29.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "Si kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7202.30.0000",
      "rawHtsCode": "7202.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ferrosilicon manganese",
      "units": [
        "kg",
        "Mn kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "23%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.41.0000",
      "rawHtsCode": "7202.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight more than 4 percent of carbon",
      "units": [
        "kg",
        "Cr kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.49",
      "rawHtsCode": "7202.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7202.49.1000",
      "rawHtsCode": "7202.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight more than 3 percent of carbon",
      "units": [
        "kg",
        "Cr kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "7.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.49.50",
      "rawHtsCode": "7202.49.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.49.5010",
      "rawHtsCode": "7202.49.50.10",
      "superior": null,
      "indent": "4",
      "description": "Containing by weight more than 0.5 percent of carbon",
      "units": [
        "kg",
        "Cr kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7202.49.5090",
      "rawHtsCode": "7202.49.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "Cr kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7202.50.0000",
      "rawHtsCode": "7202.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ferrosilicon chromium",
      "units": [
        "kg",
        "Cr kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.60.0000",
      "rawHtsCode": "7202.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ferronickel",
      "units": [
        "kg",
        "Ni kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7202.70.0000",
      "rawHtsCode": "7202.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ferromolybdenum",
      "units": [
        "kg",
        "Mo kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "31.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.80.0000",
      "rawHtsCode": "7202.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ferrotungsten and ferrosilicon tungsten",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.91.0000",
      "rawHtsCode": "7202.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ferrotitanium and ferrosilicon titanium",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.92.0000",
      "rawHtsCode": "7202.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ferrovanadium",
      "units": [
        "kg",
        "V kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.93",
      "rawHtsCode": "7202.93",
      "superior": null,
      "indent": "2",
      "description": "Ferroniobium:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7202.93.4000",
      "rawHtsCode": "7202.93.40.00",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight less than 0.02 percent of phosphorus or sulfur or less than 0.4 percent of silicon",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.93.8000",
      "rawHtsCode": "7202.93.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.99",
      "rawHtsCode": "7202.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7202.99.1000",
      "rawHtsCode": "7202.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Ferrozirconium",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.99.2000",
      "rawHtsCode": "7202.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Calcium silicon",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.99.80",
      "rawHtsCode": "7202.99.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7202.99.8020",
      "rawHtsCode": "7202.99.80.20",
      "superior": null,
      "indent": "4",
      "description": "Ferrophosphorus",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7202.99.8040",
      "rawHtsCode": "7202.99.80.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7203",
      "rawHtsCode": "7203",
      "superior": null,
      "indent": "0",
      "description": "Ferrous products obtained by direct reduction of iron ore and other spongy ferrous products, in lumps, pellets or similar forms; iron having a minimum purity by weight of 99.94 percent, in lumps, pellets or similar forms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7203.10.0000",
      "rawHtsCode": "7203.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ferrous products obtained by direct reduction of iron ore",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.21/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7203.90.0000",
      "rawHtsCode": "7203.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.21/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7204",
      "rawHtsCode": "7204",
      "superior": null,
      "indent": "0",
      "description": "Ferrous waste and scrap; remelting scrap ingots of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7204.10.0000",
      "rawHtsCode": "7204.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Waste and scrap of cast iron",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74¢/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7204.21.0000",
      "rawHtsCode": "7204.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of stainless steel",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74¢/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7204.29.0000",
      "rawHtsCode": "7204.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74¢/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7204.30.0000",
      "rawHtsCode": "7204.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Waste and scrap of tinned iron or steel",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7204.41.00",
      "rawHtsCode": "7204.41.00",
      "superior": null,
      "indent": "2",
      "description": "Turnings, shavings, chips, milling waste, sawdust, filings, trimmings and stampings, whether or not in bundles",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74¢/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7204.41.0020",
      "rawHtsCode": "7204.41.00.20",
      "superior": null,
      "indent": "3",
      "description": "No. 1 bundles",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7204.41.0040",
      "rawHtsCode": "7204.41.00.40",
      "superior": null,
      "indent": "3",
      "description": "No. 2 bundles",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7204.41.0060",
      "rawHtsCode": "7204.41.00.60",
      "superior": null,
      "indent": "3",
      "description": "Borings, shovelings and turnings",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7204.41.0080",
      "rawHtsCode": "7204.41.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7204.49.00",
      "rawHtsCode": "7204.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74¢/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7204.49.0020",
      "rawHtsCode": "7204.49.00.20",
      "superior": null,
      "indent": "3",
      "description": "No. 1 heavy melting",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7204.49.0040",
      "rawHtsCode": "7204.49.00.40",
      "superior": null,
      "indent": "3",
      "description": "No. 2 heavy melting",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7204.49.0060",
      "rawHtsCode": "7204.49.00.60",
      "superior": null,
      "indent": "4",
      "description": "Cut plate and structural",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7204.49.0070",
      "rawHtsCode": "7204.49.00.70",
      "superior": null,
      "indent": "4",
      "description": "Shredded",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7204.49.0080",
      "rawHtsCode": "7204.49.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7204.50.0000",
      "rawHtsCode": "7204.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Remelting scrap ingots",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "74¢/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7205",
      "rawHtsCode": "7205",
      "superior": null,
      "indent": "0",
      "description": "Granules and powders, of pig iron, spiegeleisen, iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7205.10.0000",
      "rawHtsCode": "7205.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Granules",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7205.21.0000",
      "rawHtsCode": "7205.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7205.29.0000",
      "rawHtsCode": "7205.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.21/t",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7206",
      "rawHtsCode": "7206",
      "superior": null,
      "indent": "0",
      "description": "Iron and nonalloy steel in ingots or other primary forms (excluding iron of heading 7203):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7206.10.0000",
      "rawHtsCode": "7206.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ingots",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7206.90.0000",
      "rawHtsCode": "7206.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7207",
      "rawHtsCode": "7207",
      "superior": null,
      "indent": "0",
      "description": "Semifinished products of iron or nonalloy steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7207.11.0000",
      "rawHtsCode": "7207.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of rectangular (including square) cross section, the width measuring less than twice the thickness",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7207.12.00",
      "rawHtsCode": "7207.12.00",
      "superior": null,
      "indent": "2",
      "description": "Other, of rectangular (other than square) cross section",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7207.12.0010",
      "rawHtsCode": "7207.12.00.10",
      "superior": null,
      "indent": "3",
      "description": "Having a width measuring less than four times the thickness",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7207.12.0050",
      "rawHtsCode": "7207.12.00.50",
      "superior": null,
      "indent": "3",
      "description": "Having a width measuring at least four times the thickness",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7207.19.00",
      "rawHtsCode": "7207.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7207.19.0030",
      "rawHtsCode": "7207.19.00.30",
      "superior": null,
      "indent": "3",
      "description": "Of circular cross section",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7207.19.0090",
      "rawHtsCode": "7207.19.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7207.20.00",
      "rawHtsCode": "7207.20.00",
      "superior": null,
      "indent": "1",
      "description": "Containing by weight 0.25 percent or more of carbon",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7207.20.0025",
      "rawHtsCode": "7207.20.00.25",
      "superior": null,
      "indent": "3",
      "description": "Having a width measuring less than four times the thickness",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7207.20.0045",
      "rawHtsCode": "7207.20.00.45",
      "superior": null,
      "indent": "3",
      "description": "Having a width measuring at least four times the thickness",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7207.20.0075",
      "rawHtsCode": "7207.20.00.75",
      "superior": null,
      "indent": "2",
      "description": "Of circular cross section",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7207.20.0090",
      "rawHtsCode": "7207.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208",
      "rawHtsCode": "7208",
      "superior": null,
      "indent": "0",
      "description": "Flat-rolled products of iron or nonalloy steel, of a width of <il>600 mm</il> or more, hot-rolled, not clad, plated or coated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.10",
      "rawHtsCode": "7208.10",
      "superior": null,
      "indent": "1",
      "description": "In coils, not further worked than hot-rolled, with patterns in relief:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.10.1500",
      "rawHtsCode": "7208.10.15.00",
      "superior": null,
      "indent": "2",
      "description": "Pickled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.10.3000",
      "rawHtsCode": "7208.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness of <il>4.75 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.10.6000",
      "rawHtsCode": "7208.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness of less than <il>4.75 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.25",
      "rawHtsCode": "7208.25",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of <il>4.75 mm</il> or more:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.25.3000",
      "rawHtsCode": "7208.25.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of high-strength steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.25.6000",
      "rawHtsCode": "7208.25.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.26.00",
      "rawHtsCode": "7208.26.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 3 mm or more but less than <il>4.75 mm</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.26.0030",
      "rawHtsCode": "7208.26.00.30",
      "superior": null,
      "indent": "3",
      "description": "High-strength steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.26.0060",
      "rawHtsCode": "7208.26.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.27.00",
      "rawHtsCode": "7208.27.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of less than 3 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.27.0040",
      "rawHtsCode": "7208.27.00.40",
      "superior": null,
      "indent": "4",
      "description": "“Advanced” or “ultra” of a kind described in statistical note 4 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.27.0045",
      "rawHtsCode": "7208.27.00.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.27.0060",
      "rawHtsCode": "7208.27.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.36.00",
      "rawHtsCode": "7208.36.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness exceeding 10 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.36.0030",
      "rawHtsCode": "7208.36.00.30",
      "superior": null,
      "indent": "3",
      "description": "High-strength steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.36.0060",
      "rawHtsCode": "7208.36.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.37.00",
      "rawHtsCode": "7208.37.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of <il>4.75 mm</il> or more but not exceeding 10 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.37.0030",
      "rawHtsCode": "7208.37.00.30",
      "superior": null,
      "indent": "3",
      "description": "High-strength steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.37.0060",
      "rawHtsCode": "7208.37.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.38.00",
      "rawHtsCode": "7208.38.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 3 mm or more but less than <il>4.75 mm</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.38.0015",
      "rawHtsCode": "7208.38.00.15",
      "superior": null,
      "indent": "3",
      "description": "High-strength steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.38.0030",
      "rawHtsCode": "7208.38.00.30",
      "superior": null,
      "indent": "4",
      "description": "With untrimmed edges",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.38.0090",
      "rawHtsCode": "7208.38.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.39.00",
      "rawHtsCode": "7208.39.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of less than 3 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.39.0020",
      "rawHtsCode": "7208.39.00.20",
      "superior": null,
      "indent": "4",
      "description": "“Advanced” or “ultra” of a kind described in statistical note 4 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.39.0025",
      "rawHtsCode": "7208.39.00.25",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.39.0030",
      "rawHtsCode": "7208.39.00.30",
      "superior": null,
      "indent": "4",
      "description": "With untrimmed edges",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.39.0090",
      "rawHtsCode": "7208.39.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.40",
      "rawHtsCode": "7208.40",
      "superior": null,
      "indent": "1",
      "description": "Not in coils, not further worked than hot-rolled, with patterns in relief:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.40.30",
      "rawHtsCode": "7208.40.30",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of <il>4.75 mm</il> or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.40.3030",
      "rawHtsCode": "7208.40.30.30",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness exceeding 10 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.40.3060",
      "rawHtsCode": "7208.40.30.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.40.60",
      "rawHtsCode": "7208.40.60",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of less than <il>4.75 mm</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.40.6030",
      "rawHtsCode": "7208.40.60.30",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness less than 3 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.40.6060",
      "rawHtsCode": "7208.40.60.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.51.00",
      "rawHtsCode": "7208.51.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness exceeding 10 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.51.0030",
      "rawHtsCode": "7208.51.00.30",
      "superior": null,
      "indent": "3",
      "description": "Universal mill plate",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.51.0045",
      "rawHtsCode": "7208.51.00.45",
      "superior": null,
      "indent": "4",
      "description": "Of high-strength steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.51.0060",
      "rawHtsCode": "7208.51.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7208.52.0000",
      "rawHtsCode": "7208.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of <il>4.75 mm</il> or more but not exceeding 10 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.53.0000",
      "rawHtsCode": "7208.53.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 3 mm or more but less than <il>4.75 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.54.0000",
      "rawHtsCode": "7208.54.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of less than 3 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7208.90.0000",
      "rawHtsCode": "7208.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7209",
      "rawHtsCode": "7209",
      "superior": null,
      "indent": "0",
      "description": "Flat-rolled products of iron or nonalloy steel, of a width of <il>600 mm</il> or more, cold-rolled (cold-reduced), not clad, plated or coated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.15.0000",
      "rawHtsCode": "7209.15.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 3 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7209.16.00",
      "rawHtsCode": "7209.16.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness exceeding <il>1 mm</il> but less than 3 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7209.16.0040",
      "rawHtsCode": "7209.16.00.40",
      "superior": null,
      "indent": "5",
      "description": "“Advanced” or “ultra” of a kind described in statistical note 4 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.16.0045",
      "rawHtsCode": "7209.16.00.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.16.0060",
      "rawHtsCode": "7209.16.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.16.0070",
      "rawHtsCode": "7209.16.00.70",
      "superior": null,
      "indent": "4",
      "description": "Annealed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.16.0091",
      "rawHtsCode": "7209.16.00.91",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.17.00",
      "rawHtsCode": "7209.17.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 0.5 mm or more but not exceeding <il>1 mm</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7209.17.0040",
      "rawHtsCode": "7209.17.00.40",
      "superior": null,
      "indent": "5",
      "description": "“Advanced” or “ultra” of a kind described in statistical note 4 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.17.0045",
      "rawHtsCode": "7209.17.00.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.17.0060",
      "rawHtsCode": "7209.17.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.17.0070",
      "rawHtsCode": "7209.17.00.70",
      "superior": null,
      "indent": "4",
      "description": "Annealed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.17.0091",
      "rawHtsCode": "7209.17.00.91",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.18",
      "rawHtsCode": "7209.18",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of less than 0.5 mm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.18.15",
      "rawHtsCode": "7209.18.15",
      "superior": null,
      "indent": "3",
      "description": "Of high-strength steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7209.18.1530",
      "rawHtsCode": "7209.18.15.30",
      "superior": null,
      "indent": "4",
      "description": "Annealed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.18.1560",
      "rawHtsCode": "7209.18.15.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.18.25",
      "rawHtsCode": "7209.18.25",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness of less than 0.361 mm (blackplate)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7209.18.2520",
      "rawHtsCode": "7209.18.25.20",
      "superior": null,
      "indent": "5",
      "description": "Annealed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.18.2585",
      "rawHtsCode": "7209.18.25.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.18.60",
      "rawHtsCode": "7209.18.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7209.18.6020",
      "rawHtsCode": "7209.18.60.20",
      "superior": null,
      "indent": "5",
      "description": "Annealed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.18.6090",
      "rawHtsCode": "7209.18.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7209.25.0000",
      "rawHtsCode": "7209.25.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 3 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7209.26.0000",
      "rawHtsCode": "7209.26.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness exceeding <il>1 mm</il> but less than 3 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7209.27.0000",
      "rawHtsCode": "7209.27.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 0.5 mm or more but not exceeding <il>1 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7209.28.0000",
      "rawHtsCode": "7209.28.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of less than 0.5 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7209.90.0000",
      "rawHtsCode": "7209.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210",
      "rawHtsCode": "7210",
      "superior": null,
      "indent": "0",
      "description": "Flat-rolled products of iron or nonalloy steel, of a width of <il>600 mm</il> or more, clad, plated or coated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.11.0000",
      "rawHtsCode": "7210.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 0.5 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.12.0000",
      "rawHtsCode": "7210.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of less than 0.5 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.20.0000",
      "rawHtsCode": "7210.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Plated or coated with lead, including terne-plate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.30.00",
      "rawHtsCode": "7210.30.00",
      "superior": null,
      "indent": "1",
      "description": "Electrolytically plated or coated with zinc",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "21.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.30.0030",
      "rawHtsCode": "7210.30.00.30",
      "superior": null,
      "indent": "2",
      "description": "Of high-strength steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.30.0060",
      "rawHtsCode": "7210.30.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.41.0000",
      "rawHtsCode": "7210.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Corrugated",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "21.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.49.00",
      "rawHtsCode": "7210.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "21.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.49.0040",
      "rawHtsCode": "7210.49.00.40",
      "superior": null,
      "indent": "4",
      "description": "“Advanced” or “ultra” of a kind described in statistical note 4 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.49.0045",
      "rawHtsCode": "7210.49.00.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.49.0091",
      "rawHtsCode": "7210.49.00.91",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness of 0.4 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.49.0095",
      "rawHtsCode": "7210.49.00.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.50.00",
      "rawHtsCode": "7210.50.00",
      "superior": null,
      "indent": "1",
      "description": "Plated or coated with chromium oxides or with chromium and chromium oxides",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.50.0020",
      "rawHtsCode": "7210.50.00.20",
      "superior": null,
      "indent": "3",
      "description": "Of a width less than 1050 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.50.0090",
      "rawHtsCode": "7210.50.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.61.0000",
      "rawHtsCode": "7210.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Plated or coated with aluminum-zinc alloys",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "21.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.69.0000",
      "rawHtsCode": "7210.69.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "21.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.70",
      "rawHtsCode": "7210.70",
      "superior": null,
      "indent": "1",
      "description": "Painted, varnished or coated with plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.70.3000",
      "rawHtsCode": "7210.70.30.00",
      "superior": null,
      "indent": "2",
      "description": "Not coated or plated with metal and not clad",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.70.60",
      "rawHtsCode": "7210.70.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "21.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.70.6030",
      "rawHtsCode": "7210.70.60.30",
      "superior": null,
      "indent": "4",
      "description": "Electrolytically coated or plated",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.70.6060",
      "rawHtsCode": "7210.70.60.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.70.6090",
      "rawHtsCode": "7210.70.60.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.90",
      "rawHtsCode": "7210.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7210.90.1000",
      "rawHtsCode": "7210.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Clad",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.90.6000",
      "rawHtsCode": "7210.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Electrolytically coated or plated with base metal",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7210.90.9000",
      "rawHtsCode": "7210.90.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "21.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211",
      "rawHtsCode": "7211",
      "superior": null,
      "indent": "0",
      "description": "Flat-rolled products of iron or nonalloy steel, of a width of less than <il>600 mm</il>, not clad, plated or coated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.13.0000",
      "rawHtsCode": "7211.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Universal mill plate",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.14.00",
      "rawHtsCode": "7211.14.00",
      "superior": null,
      "indent": "2",
      "description": "Other, of a thickness of <il>4.75 mm</il> or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.14.0030",
      "rawHtsCode": "7211.14.00.30",
      "superior": null,
      "indent": "3",
      "description": "Of high-strength steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.14.0045",
      "rawHtsCode": "7211.14.00.45",
      "superior": null,
      "indent": "4",
      "description": "Not in coils",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.14.0090",
      "rawHtsCode": "7211.14.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.19",
      "rawHtsCode": "7211.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.19.1500",
      "rawHtsCode": "7211.19.15.00",
      "superior": null,
      "indent": "4",
      "description": "Of high-strength steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.19.2000",
      "rawHtsCode": "7211.19.20.00",
      "superior": null,
      "indent": "5",
      "description": "Of a thickness exceeding 1.25 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.19.3000",
      "rawHtsCode": "7211.19.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.19.4500",
      "rawHtsCode": "7211.19.45.00",
      "superior": null,
      "indent": "4",
      "description": "Of high-strength steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.19.6000",
      "rawHtsCode": "7211.19.60.00",
      "superior": null,
      "indent": "5",
      "description": "Pickled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.19.75",
      "rawHtsCode": "7211.19.75",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.19.7530",
      "rawHtsCode": "7211.19.75.30",
      "superior": null,
      "indent": "7",
      "description": "With untrimmed edges",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.19.7560",
      "rawHtsCode": "7211.19.75.60",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.19.7590",
      "rawHtsCode": "7211.19.75.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.23",
      "rawHtsCode": "7211.23",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight less than 0.25 percent of carbon:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.23.1500",
      "rawHtsCode": "7211.23.15.00",
      "superior": null,
      "indent": "5",
      "description": "Of high-strength steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.23.2000",
      "rawHtsCode": "7211.23.20.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.23.3000",
      "rawHtsCode": "7211.23.30.00",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness exceeding 0.25 mm but not exceeding 1.25 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.23.4500",
      "rawHtsCode": "7211.23.45.00",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness not exceeding 0.25 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.23.60",
      "rawHtsCode": "7211.23.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.23.6030",
      "rawHtsCode": "7211.23.60.30",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness exceeding 1.25 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.23.6060",
      "rawHtsCode": "7211.23.60.60",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness exceeding 0.25 mm but not exceeding 1.25 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.23.6090",
      "rawHtsCode": "7211.23.60.90",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness not exceeding 0.25 mm:",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.29",
      "rawHtsCode": "7211.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.29.20",
      "rawHtsCode": "7211.29.20",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness exceeding 0.25 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.29.2030",
      "rawHtsCode": "7211.29.20.30",
      "superior": null,
      "indent": "5",
      "description": "Of a width less than 51 mm, in coils",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.29.2090",
      "rawHtsCode": "7211.29.20.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.29.4500",
      "rawHtsCode": "7211.29.45.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.29.60",
      "rawHtsCode": "7211.29.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7211.29.6030",
      "rawHtsCode": "7211.29.60.30",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness exceeding 1.25 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.29.6080",
      "rawHtsCode": "7211.29.60.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7211.90.0000",
      "rawHtsCode": "7211.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7212",
      "rawHtsCode": "7212",
      "superior": null,
      "indent": "0",
      "description": "Flat-rolled products of iron or nonalloy steel, of a width of less than <il>600 mm</il>, clad, plated or coated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7212.10.0000",
      "rawHtsCode": "7212.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Plated or coated with tin",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7212.20.0000",
      "rawHtsCode": "7212.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Electrolytically plated or coated with zinc",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "21.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7212.30",
      "rawHtsCode": "7212.30",
      "superior": null,
      "indent": "1",
      "description": "Otherwise plated or coated with zinc:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7212.30.10",
      "rawHtsCode": "7212.30.10",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness exceeding 0.25 mm or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7212.30.1030",
      "rawHtsCode": "7212.30.10.30",
      "superior": null,
      "indent": "4",
      "description": "Of a width less than 51 mm, in coils",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7212.30.1090",
      "rawHtsCode": "7212.30.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7212.30.3000",
      "rawHtsCode": "7212.30.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7212.30.5000",
      "rawHtsCode": "7212.30.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "21.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7212.40",
      "rawHtsCode": "7212.40",
      "superior": null,
      "indent": "1",
      "description": "Painted, varnished or coated with plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7212.40.1000",
      "rawHtsCode": "7212.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of a width of less than 300 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7212.40.5000",
      "rawHtsCode": "7212.40.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7212.50.0000",
      "rawHtsCode": "7212.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Otherwise plated or coated",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "21.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7212.60.0000",
      "rawHtsCode": "7212.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Clad",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7213",
      "rawHtsCode": "7213",
      "superior": null,
      "indent": "0",
      "description": "Bars and rods, hot-rolled, in irregularly wound coils, of iron or nonalloy steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7213.10.0000",
      "rawHtsCode": "7213.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Concrete reinforcing bars and rods",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7213.20.00",
      "rawHtsCode": "7213.20.00",
      "superior": null,
      "indent": "1",
      "description": "Other, of free-cutting steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7213.20.0010",
      "rawHtsCode": "7213.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight 0.1 percent or more of lead",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7213.20.0080",
      "rawHtsCode": "7213.20.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7213.91",
      "rawHtsCode": "7213.91",
      "superior": null,
      "indent": "2",
      "description": "Of circular cross section measuring less than 14 mm in diameter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7213.91.30",
      "rawHtsCode": "7213.91.30",
      "superior": null,
      "indent": "3",
      "description": "Not tempered, not treated and not partly manufactured",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7213.91.3011",
      "rawHtsCode": "7213.91.30.11",
      "superior": null,
      "indent": "4",
      "description": "Tire cord-quality steel wire rod of a kind described in statistical note 5 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7213.91.3015",
      "rawHtsCode": "7213.91.30.15",
      "superior": null,
      "indent": "4",
      "description": "Of Cold Heading Quality (CHQ) steel of a kind described in statistical note 6 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7213.91.3020",
      "rawHtsCode": "7213.91.30.20",
      "superior": null,
      "indent": "4",
      "description": "Of welding quality wire rods of a kind described in statistical note 7 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7213.91.3093",
      "rawHtsCode": "7213.91.30.93",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7213.91.4500",
      "rawHtsCode": "7213.91.45.00",
      "superior": null,
      "indent": "4",
      "description": "Containing by weight 0.6 percent or more of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7213.91.6000",
      "rawHtsCode": "7213.91.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7213.99.00",
      "rawHtsCode": "7213.99.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7213.99.0030",
      "rawHtsCode": "7213.99.00.30",
      "superior": null,
      "indent": "4",
      "description": "With a diameter of 14 mm or more but less than 19 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7213.99.0060",
      "rawHtsCode": "7213.99.00.60",
      "superior": null,
      "indent": "4",
      "description": "With a diameter of 19 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7213.99.0090",
      "rawHtsCode": "7213.99.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214",
      "rawHtsCode": "7214",
      "superior": null,
      "indent": "0",
      "description": "Other bars and rods of iron or nonalloy steel, not further worked than forged, hot-rolled, hot-drawn or hot-extruded, but including those twisted after rolling:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.10.0000",
      "rawHtsCode": "7214.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Forged",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.20.0000",
      "rawHtsCode": "7214.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Concrete reinforcing bars and rods",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7214.30.00",
      "rawHtsCode": "7214.30.00",
      "superior": null,
      "indent": "1",
      "description": "Other, of free-cutting steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7214.30.0010",
      "rawHtsCode": "7214.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight 0.1 percent or more of lead",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.30.0080",
      "rawHtsCode": "7214.30.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.91.00",
      "rawHtsCode": "7214.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of rectangular (other than square) cross-section",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7214.91.0016",
      "rawHtsCode": "7214.91.00.16",
      "superior": null,
      "indent": "4",
      "description": "With a maximum cross section less than 152 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.91.0020",
      "rawHtsCode": "7214.91.00.20",
      "superior": null,
      "indent": "4",
      "description": "With a maximum cross section of 152 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.91.0060",
      "rawHtsCode": "7214.91.00.60",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight 0.25 percent or more but less than 0.6 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.91.0090",
      "rawHtsCode": "7214.91.00.90",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight 0.6 percent or more of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.99.00",
      "rawHtsCode": "7214.99.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7214.99.0016",
      "rawHtsCode": "7214.99.00.16",
      "superior": null,
      "indent": "5",
      "description": "With a diameter less than 76 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.99.0021",
      "rawHtsCode": "7214.99.00.21",
      "superior": null,
      "indent": "5",
      "description": "With a diameter of 76 mm or more but not exceeding 152 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.99.0026",
      "rawHtsCode": "7214.99.00.26",
      "superior": null,
      "indent": "5",
      "description": "With a diameter exceeding 152 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.99.0031",
      "rawHtsCode": "7214.99.00.31",
      "superior": null,
      "indent": "5",
      "description": "With a diameter less than 76 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.99.0036",
      "rawHtsCode": "7214.99.00.36",
      "superior": null,
      "indent": "5",
      "description": "With a diameter of 76 mm or more but not exceeding 152 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.99.0040",
      "rawHtsCode": "7214.99.00.40",
      "superior": null,
      "indent": "5",
      "description": "With a diameter exceeding 152 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.99.0045",
      "rawHtsCode": "7214.99.00.45",
      "superior": null,
      "indent": "4",
      "description": "Containing by weight 0.6 percent or more of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.99.0060",
      "rawHtsCode": "7214.99.00.60",
      "superior": null,
      "indent": "4",
      "description": "Containing by weight less than 0.25 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.99.0075",
      "rawHtsCode": "7214.99.00.75",
      "superior": null,
      "indent": "4",
      "description": "Containing by weight 0.25 percent or more but less than 0.6 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7214.99.0090",
      "rawHtsCode": "7214.99.00.90",
      "superior": null,
      "indent": "4",
      "description": "Containing by weight 0.6 percent or more of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7215",
      "rawHtsCode": "7215",
      "superior": null,
      "indent": "0",
      "description": "Other bars and rods of iron or nonalloy steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7215.10.00",
      "rawHtsCode": "7215.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of free-cutting steel, not further worked than cold-formed or cold-finished",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.3¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7215.10.0010",
      "rawHtsCode": "7215.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight 0.1 percent or more of lead",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7215.10.0080",
      "rawHtsCode": "7215.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7215.50.00",
      "rawHtsCode": "7215.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other, not further worked than cold-formed or cold-finished",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.3¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7215.50.0016",
      "rawHtsCode": "7215.50.00.16",
      "superior": null,
      "indent": "3",
      "description": "With a diameter or cross section measuring less than 76 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7215.50.0018",
      "rawHtsCode": "7215.50.00.18",
      "superior": null,
      "indent": "3",
      "description": "With a diameter or cross section measuring 76 mm or more but not exceeding 228 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7215.50.0020",
      "rawHtsCode": "7215.50.00.20",
      "superior": null,
      "indent": "3",
      "description": "With a diameter or cross section exceeding 228 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7215.50.0061",
      "rawHtsCode": "7215.50.00.61",
      "superior": null,
      "indent": "3",
      "description": "With a diameter or cross section measuring less than 76 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7215.50.0063",
      "rawHtsCode": "7215.50.00.63",
      "superior": null,
      "indent": "3",
      "description": "With a diameter or cross section measuring 76 mm or more but not exceeding 228 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7215.50.0065",
      "rawHtsCode": "7215.50.00.65",
      "superior": null,
      "indent": "3",
      "description": "With a diameter or cross section exceeding 228 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7215.50.0090",
      "rawHtsCode": "7215.50.00.90",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight 0.6 percent or more of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7215.90",
      "rawHtsCode": "7215.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7215.90.1000",
      "rawHtsCode": "7215.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Not cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7215.90.3000",
      "rawHtsCode": "7215.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.3¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7215.90.5000",
      "rawHtsCode": "7215.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.3¢/kg + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7216",
      "rawHtsCode": "7216",
      "superior": null,
      "indent": "0",
      "description": "Angles, shapes and sections of iron or nonalloy steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7216.10.00",
      "rawHtsCode": "7216.10.00",
      "superior": null,
      "indent": "1",
      "description": "U, I or H sections, not further worked than hot-rolled, hot-drawn or extruded, of a height of less than <il>80 mm</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7216.10.0010",
      "rawHtsCode": "7216.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "U sections",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7216.10.0050",
      "rawHtsCode": "7216.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7216.21.0000",
      "rawHtsCode": "7216.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "L sections",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7216.22.0000",
      "rawHtsCode": "7216.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "T sections",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7216.31.0000",
      "rawHtsCode": "7216.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "U sections",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7216.32.0000",
      "rawHtsCode": "7216.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "I sections (standard beams)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7216.33.00",
      "rawHtsCode": "7216.33.00",
      "superior": null,
      "indent": "2",
      "description": "H sections",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7216.33.0030",
      "rawHtsCode": "7216.33.00.30",
      "superior": null,
      "indent": "3",
      "description": "Weighing not more than 11.3 kg per 30.5 cm, with a web depth measuring 102 mm to 356 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7216.33.0060",
      "rawHtsCode": "7216.33.00.60",
      "superior": null,
      "indent": "3",
      "description": "Weighing more than 11.3 kg but not more than 27.2 kg per 30.5 cm, with a web depth measuring 203 mm to 457 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7216.33.0090",
      "rawHtsCode": "7216.33.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7216.40.00",
      "rawHtsCode": "7216.40.00",
      "superior": null,
      "indent": "1",
      "description": "L or T sections, not further worked than hot-rolled, hot-drawn or extruded, of a height of <il>80 mm</il> or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7216.40.0010",
      "rawHtsCode": "7216.40.00.10",
      "superior": null,
      "indent": "2",
      "description": "L sections",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7216.40.0050",
      "rawHtsCode": "7216.40.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7216.50.0000",
      "rawHtsCode": "7216.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other angles, shapes and sections, not further worked than hot-rolled, hot-drawn or extruded",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7216.61.0000",
      "rawHtsCode": "7216.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Obtained from flat-rolled products",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7216.69.0000",
      "rawHtsCode": "7216.69.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7216.91.00",
      "rawHtsCode": "7216.91.00",
      "superior": null,
      "indent": "2",
      "description": "Cold-formed or cold-finished from flat-rolled products",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7216.91.0010",
      "rawHtsCode": "7216.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Drilled, notched, punched or cambered",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7216.91.0090",
      "rawHtsCode": "7216.91.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7216.99.00",
      "rawHtsCode": "7216.99.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7216.99.0010",
      "rawHtsCode": "7216.99.00.10",
      "superior": null,
      "indent": "3",
      "description": "Drilled, notched, punched or cambered",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7216.99.0090",
      "rawHtsCode": "7216.99.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217",
      "rawHtsCode": "7217",
      "superior": null,
      "indent": "0",
      "description": "Wire of iron or nonalloy steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10",
      "rawHtsCode": "7217.10",
      "superior": null,
      "indent": "1",
      "description": "Not plated or coated, whether or not polished:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.1000",
      "rawHtsCode": "7217.10.10.00",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness not exceeding 0.25 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.10.2000",
      "rawHtsCode": "7217.10.20.00",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness exceeding 0.25 mm but not exceeding 1.25 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.10.3000",
      "rawHtsCode": "7217.10.30.00",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness exceeding 1.25 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.10.40",
      "rawHtsCode": "7217.10.40",
      "superior": null,
      "indent": "4",
      "description": "With a diameter of less than 1.5 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.10.4040",
      "rawHtsCode": "7217.10.40.40",
      "superior": null,
      "indent": "6",
      "description": "In coils weighing not more than 2 kilograms",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.4045",
      "rawHtsCode": "7217.10.40.45",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.4090",
      "rawHtsCode": "7217.10.40.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.50",
      "rawHtsCode": "7217.10.50",
      "superior": null,
      "indent": "4",
      "description": "With a diameter of 1.5 mm or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.10.5030",
      "rawHtsCode": "7217.10.50.30",
      "superior": null,
      "indent": "5",
      "description": "Heat treated",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.5090",
      "rawHtsCode": "7217.10.50.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.6000",
      "rawHtsCode": "7217.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other wire",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.10.7000",
      "rawHtsCode": "7217.10.70.00",
      "superior": null,
      "indent": "3",
      "description": "Flat wire",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.10.80",
      "rawHtsCode": "7217.10.80",
      "superior": null,
      "indent": "3",
      "description": "Round wire",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.10.8010",
      "rawHtsCode": "7217.10.80.10",
      "superior": null,
      "indent": "5",
      "description": "Heat treated",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.8020",
      "rawHtsCode": "7217.10.80.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.8025",
      "rawHtsCode": "7217.10.80.25",
      "superior": null,
      "indent": "6",
      "description": "With a diameter of less than 1.0 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.8030",
      "rawHtsCode": "7217.10.80.30",
      "superior": null,
      "indent": "6",
      "description": "With a diameter of 1.0 mm or more but less than 1.5 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.8045",
      "rawHtsCode": "7217.10.80.45",
      "superior": null,
      "indent": "6",
      "description": "With a diameter of 1.5 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.8060",
      "rawHtsCode": "7217.10.80.60",
      "superior": null,
      "indent": "6",
      "description": "With a diameter of less than 1.0 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.8075",
      "rawHtsCode": "7217.10.80.75",
      "superior": null,
      "indent": "6",
      "description": "With a diameter of 1.0 mm or more but less than 1.5 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.8090",
      "rawHtsCode": "7217.10.80.90",
      "superior": null,
      "indent": "6",
      "description": "With a diameter of 1.5 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.10.9000",
      "rawHtsCode": "7217.10.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other wire",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.20",
      "rawHtsCode": "7217.20",
      "superior": null,
      "indent": "1",
      "description": "Plated or coated with zinc:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.20.1500",
      "rawHtsCode": "7217.20.15.00",
      "superior": null,
      "indent": "2",
      "description": "Flat wire",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.20.3000",
      "rawHtsCode": "7217.20.30.00",
      "superior": null,
      "indent": "3",
      "description": "With a diameter of 1.5 mm or more and containing by weight less than 0.25 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.20.45",
      "rawHtsCode": "7217.20.45",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.20.4510",
      "rawHtsCode": "7217.20.45.10",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight less than 0.25 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.20.4520",
      "rawHtsCode": "7217.20.45.20",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight 0.25 percent or more but less than 0.6 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.20.4530",
      "rawHtsCode": "7217.20.45.30",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight 0.6 percent or more of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.20.4540",
      "rawHtsCode": "7217.20.45.40",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight less than 0.25 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.20.4550",
      "rawHtsCode": "7217.20.45.50",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight 0.25 percent or more but less than 0.6 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.20.4560",
      "rawHtsCode": "7217.20.45.60",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight 0.6 percent or more of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.20.4570",
      "rawHtsCode": "7217.20.45.70",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight 0.25 percent or more but less than 0.6 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.20.4580",
      "rawHtsCode": "7217.20.45.80",
      "superior": null,
      "indent": "5",
      "description": "Containing by weight 0.6 percent or more of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.20.6000",
      "rawHtsCode": "7217.20.60.00",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight less than 0.25 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.20.7500",
      "rawHtsCode": "7217.20.75.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.30",
      "rawHtsCode": "7217.30",
      "superior": null,
      "indent": "1",
      "description": "Plated or coated with other base metals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.30.15",
      "rawHtsCode": "7217.30.15",
      "superior": null,
      "indent": "2",
      "description": "Flat wire",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.30.1530",
      "rawHtsCode": "7217.30.15.30",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight 0.6 percent or more of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.30.1560",
      "rawHtsCode": "7217.30.15.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.30.3000",
      "rawHtsCode": "7217.30.30.00",
      "superior": null,
      "indent": "3",
      "description": "With a diameter of 1.5 mm or more and containing by weight less than 0.25 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.30.45",
      "rawHtsCode": "7217.30.45",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.30.4504",
      "rawHtsCode": "7217.30.45.04",
      "superior": null,
      "indent": "4",
      "description": "Containing by weight less than 0.20 percent of carbon, and suitable for electric arc welding",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.30.4511",
      "rawHtsCode": "7217.30.45.11",
      "superior": null,
      "indent": "6",
      "description": "Containing by weight less than 0.25 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.30.4520",
      "rawHtsCode": "7217.30.45.20",
      "superior": null,
      "indent": "6",
      "description": "Containing by weight 0.25 percent or more but less than 0.6 percent or carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.30.4530",
      "rawHtsCode": "7217.30.45.30",
      "superior": null,
      "indent": "6",
      "description": "Containing by weight 0.6 percent or more of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.30.4541",
      "rawHtsCode": "7217.30.45.41",
      "superior": null,
      "indent": "6",
      "description": "Containing by weight less than 0.25 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.30.4550",
      "rawHtsCode": "7217.30.45.50",
      "superior": null,
      "indent": "6",
      "description": "Containing by weight 0.25 percent or more but less than 0.6 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.30.4560",
      "rawHtsCode": "7217.30.45.60",
      "superior": null,
      "indent": "6",
      "description": "Containing by weight 0.6 percent or more of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.30.4590",
      "rawHtsCode": "7217.30.45.90",
      "superior": null,
      "indent": "5",
      "description": "With a diameter of 1.5 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.30.6000",
      "rawHtsCode": "7217.30.60.00",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight less than 0.25 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.30.7500",
      "rawHtsCode": "7217.30.75.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "26%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.90",
      "rawHtsCode": "7217.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.90.1000",
      "rawHtsCode": "7217.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Coated with plastics",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.90.50",
      "rawHtsCode": "7217.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7217.90.5030",
      "rawHtsCode": "7217.90.50.30",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight less than 0.25 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.90.5060",
      "rawHtsCode": "7217.90.50.60",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight 0.25 percent or more but less than 0.6 percent of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7217.90.5090",
      "rawHtsCode": "7217.90.50.90",
      "superior": null,
      "indent": "3",
      "description": "Containing by weight 0.6 percent or more of carbon",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7218",
      "rawHtsCode": "7218",
      "superior": null,
      "indent": "0",
      "description": "Stainless steel in ingots or other primary forms; semi-finished products of stainless steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7218.10.0000",
      "rawHtsCode": "7218.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ingots and other primary forms",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7218.91.00",
      "rawHtsCode": "7218.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of rectangular (other than square) cross-section",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7218.91.0015",
      "rawHtsCode": "7218.91.00.15",
      "superior": null,
      "indent": "4",
      "description": "Having a cross-sectional area of less than <il>232 cm<sup>2</sup></il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7218.91.0030",
      "rawHtsCode": "7218.91.00.30",
      "superior": null,
      "indent": "4",
      "description": "Having a cross-sectional area of <il>232 cm<sup>2</sup></il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7218.91.0060",
      "rawHtsCode": "7218.91.00.60",
      "superior": null,
      "indent": "3",
      "description": "Having a width at least four times the thickness",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7218.99.00",
      "rawHtsCode": "7218.99.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7218.99.0015",
      "rawHtsCode": "7218.99.00.15",
      "superior": null,
      "indent": "4",
      "description": "Having a cross-sectional area of less than <il>232 cm<sup>2</sup></il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7218.99.0030",
      "rawHtsCode": "7218.99.00.30",
      "superior": null,
      "indent": "4",
      "description": "Having a cross-sectional area of <il>232 cm<sup>2</sup></il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7218.99.0045",
      "rawHtsCode": "7218.99.00.45",
      "superior": null,
      "indent": "4",
      "description": "Having a cross-sectional area of less than <il>232 cm<sup>2</sup></il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7218.99.0060",
      "rawHtsCode": "7218.99.00.60",
      "superior": null,
      "indent": "4",
      "description": "Having a cross-sectional area of <il>232 cm<sup>2</sup></il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7218.99.0090",
      "rawHtsCode": "7218.99.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219",
      "rawHtsCode": "7219",
      "superior": null,
      "indent": "0",
      "description": "Flat-rolled products of stainless steel, of a width of <il>600 mm</il> or more:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.11.00",
      "rawHtsCode": "7219.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness exceeding 10 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.11.0030",
      "rawHtsCode": "7219.11.00.30",
      "superior": null,
      "indent": "3",
      "description": "Of a width not exceeding <il>1575 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.11.0060",
      "rawHtsCode": "7219.11.00.60",
      "superior": null,
      "indent": "3",
      "description": "Of a width exceeding <il>1575 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.12.00",
      "rawHtsCode": "7219.12.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of <il>4.75 mm</il> or more but not exceeding 10 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.12.0002",
      "rawHtsCode": "7219.12.00.02",
      "superior": null,
      "indent": "3",
      "description": "Not annealed or not pickled",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.12.0006",
      "rawHtsCode": "7219.12.00.06",
      "superior": null,
      "indent": "4",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.12.0021",
      "rawHtsCode": "7219.12.00.21",
      "superior": null,
      "indent": "7",
      "description": "Of a width not exceeding <il>1575 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.12.0026",
      "rawHtsCode": "7219.12.00.26",
      "superior": null,
      "indent": "7",
      "description": "Of a width exceeding <il>1575 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.12.0051",
      "rawHtsCode": "7219.12.00.51",
      "superior": null,
      "indent": "7",
      "description": "Of a width not exceeding <il>1575 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.12.0056",
      "rawHtsCode": "7219.12.00.56",
      "superior": null,
      "indent": "7",
      "description": "Of a width exceeding <il>1575 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.12.0066",
      "rawHtsCode": "7219.12.00.66",
      "superior": null,
      "indent": "7",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.12.0071",
      "rawHtsCode": "7219.12.00.71",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.12.0081",
      "rawHtsCode": "7219.12.00.81",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.13.00",
      "rawHtsCode": "7219.13.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 3 mm or more but less than <il>4.75 mm</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.13.0002",
      "rawHtsCode": "7219.13.00.02",
      "superior": null,
      "indent": "3",
      "description": "Not annealed or not pickled",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.13.0031",
      "rawHtsCode": "7219.13.00.31",
      "superior": null,
      "indent": "4",
      "description": "Of a width of 1370 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.13.0051",
      "rawHtsCode": "7219.13.00.51",
      "superior": null,
      "indent": "6",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.13.0071",
      "rawHtsCode": "7219.13.00.71",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.13.0081",
      "rawHtsCode": "7219.13.00.81",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.14.00",
      "rawHtsCode": "7219.14.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of less than 3 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.14.0030",
      "rawHtsCode": "7219.14.00.30",
      "superior": null,
      "indent": "3",
      "description": "Of a width of 1370 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.14.0065",
      "rawHtsCode": "7219.14.00.65",
      "superior": null,
      "indent": "4",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.14.0090",
      "rawHtsCode": "7219.14.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.21.00",
      "rawHtsCode": "7219.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness exceeding 10 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.21.0005",
      "rawHtsCode": "7219.21.00.05",
      "superior": null,
      "indent": "3",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.21.0020",
      "rawHtsCode": "7219.21.00.20",
      "superior": null,
      "indent": "4",
      "description": "Of a width not exceeding <il>1575 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.21.0040",
      "rawHtsCode": "7219.21.00.40",
      "superior": null,
      "indent": "4",
      "description": "Of a width exceeding <il>1575 mm</il> but not exceeding 1880 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.21.0060",
      "rawHtsCode": "7219.21.00.60",
      "superior": null,
      "indent": "4",
      "description": "Of a width exceeding 1880 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.22.00",
      "rawHtsCode": "7219.22.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of <il>4.75 mm</il> or more but not exceeding 10 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.22.0005",
      "rawHtsCode": "7219.22.00.05",
      "superior": null,
      "indent": "3",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.22.0015",
      "rawHtsCode": "7219.22.00.15",
      "superior": null,
      "indent": "6",
      "description": "Of a width not exceeding <il>1575 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.22.0020",
      "rawHtsCode": "7219.22.00.20",
      "superior": null,
      "indent": "6",
      "description": "Of a width exceeding <il>1575 mm</il> but not exceeding 1880 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.22.0025",
      "rawHtsCode": "7219.22.00.25",
      "superior": null,
      "indent": "6",
      "description": "Of a width exceeding 1880 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.22.0035",
      "rawHtsCode": "7219.22.00.35",
      "superior": null,
      "indent": "6",
      "description": "Of a width not exceeding <il>1575 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.22.0040",
      "rawHtsCode": "7219.22.00.40",
      "superior": null,
      "indent": "6",
      "description": "Of a width exceeding <il>1575 mm</il> but not exceeding 1880 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.22.0045",
      "rawHtsCode": "7219.22.00.45",
      "superior": null,
      "indent": "6",
      "description": "Of a width exceeding 1880 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.22.0070",
      "rawHtsCode": "7219.22.00.70",
      "superior": null,
      "indent": "5",
      "description": "Of a width not exceeding <il>1575 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.22.0075",
      "rawHtsCode": "7219.22.00.75",
      "superior": null,
      "indent": "5",
      "description": "Of a width exceeding <il>1575 mm</il> but not exceeding 1880 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.22.0080",
      "rawHtsCode": "7219.22.00.80",
      "superior": null,
      "indent": "5",
      "description": "Of a width exceeding 1880 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.23.00",
      "rawHtsCode": "7219.23.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 3 mm or more but less than <il>4.75 mm</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.23.0030",
      "rawHtsCode": "7219.23.00.30",
      "superior": null,
      "indent": "3",
      "description": "Of a width of 1370 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.23.0060",
      "rawHtsCode": "7219.23.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.24.00",
      "rawHtsCode": "7219.24.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of less than 3 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.24.0030",
      "rawHtsCode": "7219.24.00.30",
      "superior": null,
      "indent": "3",
      "description": "Of a width of 1370 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.24.0060",
      "rawHtsCode": "7219.24.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.31.00",
      "rawHtsCode": "7219.31.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of <il>4.75 mm</il> or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.31.0010",
      "rawHtsCode": "7219.31.00.10",
      "superior": null,
      "indent": "3",
      "description": "In coils",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.31.0050",
      "rawHtsCode": "7219.31.00.50",
      "superior": null,
      "indent": "3",
      "description": "Not in coils",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.32.00",
      "rawHtsCode": "7219.32.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 3 mm or more but less than <il>4.75 mm</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.32.0005",
      "rawHtsCode": "7219.32.00.05",
      "superior": null,
      "indent": "5",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.32.0020",
      "rawHtsCode": "7219.32.00.20",
      "superior": null,
      "indent": "6",
      "description": "Containing more than 0.5 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.32.0025",
      "rawHtsCode": "7219.32.00.25",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.32.0035",
      "rawHtsCode": "7219.32.00.35",
      "superior": null,
      "indent": "5",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.32.0036",
      "rawHtsCode": "7219.32.00.36",
      "superior": null,
      "indent": "7",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.32.0038",
      "rawHtsCode": "7219.32.00.38",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.32.0042",
      "rawHtsCode": "7219.32.00.42",
      "superior": null,
      "indent": "7",
      "description": "Containing less than 15 percent by weight of chromium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.32.0044",
      "rawHtsCode": "7219.32.00.44",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.32.0045",
      "rawHtsCode": "7219.32.00.45",
      "superior": null,
      "indent": "4",
      "description": "Of a width of 1370 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.32.0060",
      "rawHtsCode": "7219.32.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.33.00",
      "rawHtsCode": "7219.33.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness exceeding <il>1 mm</il> but less than 3 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.33.0005",
      "rawHtsCode": "7219.33.00.05",
      "superior": null,
      "indent": "5",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.33.0020",
      "rawHtsCode": "7219.33.00.20",
      "superior": null,
      "indent": "6",
      "description": "Containing more than 0.5 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.33.0025",
      "rawHtsCode": "7219.33.00.25",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.33.0035",
      "rawHtsCode": "7219.33.00.35",
      "superior": null,
      "indent": "5",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.33.0036",
      "rawHtsCode": "7219.33.00.36",
      "superior": null,
      "indent": "7",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.33.0038",
      "rawHtsCode": "7219.33.00.38",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.33.0042",
      "rawHtsCode": "7219.33.00.42",
      "superior": null,
      "indent": "7",
      "description": "Containing less than 15 percent by weight of chromium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.33.0044",
      "rawHtsCode": "7219.33.00.44",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.33.0045",
      "rawHtsCode": "7219.33.00.45",
      "superior": null,
      "indent": "4",
      "description": "Of a width of 1370 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.33.0070",
      "rawHtsCode": "7219.33.00.70",
      "superior": null,
      "indent": "5",
      "description": "Containing more than 0.5 percent but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.33.0080",
      "rawHtsCode": "7219.33.00.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.34.00",
      "rawHtsCode": "7219.34.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 0.5 mm or more but not exceeding <il>1 mm</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.34.0005",
      "rawHtsCode": "7219.34.00.05",
      "superior": null,
      "indent": "4",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.34.0020",
      "rawHtsCode": "7219.34.00.20",
      "superior": null,
      "indent": "6",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.34.0025",
      "rawHtsCode": "7219.34.00.25",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.34.0030",
      "rawHtsCode": "7219.34.00.30",
      "superior": null,
      "indent": "6",
      "description": "Containing less than 15 percent by weight of chromium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.34.0035",
      "rawHtsCode": "7219.34.00.35",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.34.0050",
      "rawHtsCode": "7219.34.00.50",
      "superior": null,
      "indent": "3",
      "description": "Not in coils",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.35.00",
      "rawHtsCode": "7219.35.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of less than 0.5 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.35.0005",
      "rawHtsCode": "7219.35.00.05",
      "superior": null,
      "indent": "5",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.35.0015",
      "rawHtsCode": "7219.35.00.15",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.35.0030",
      "rawHtsCode": "7219.35.00.30",
      "superior": null,
      "indent": "5",
      "description": "Containing less than 15 percent by weight of chromium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.35.0035",
      "rawHtsCode": "7219.35.00.35",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.35.0050",
      "rawHtsCode": "7219.35.00.50",
      "superior": null,
      "indent": "3",
      "description": "Not in coils",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.90.00",
      "rawHtsCode": "7219.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7219.90.0010",
      "rawHtsCode": "7219.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.90.0020",
      "rawHtsCode": "7219.90.00.20",
      "superior": null,
      "indent": "4",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.90.0025",
      "rawHtsCode": "7219.90.00.25",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.90.0060",
      "rawHtsCode": "7219.90.00.60",
      "superior": null,
      "indent": "4",
      "description": "Containing less than 15 percent by weight of chromium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7219.90.0080",
      "rawHtsCode": "7219.90.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220",
      "rawHtsCode": "7220",
      "superior": null,
      "indent": "0",
      "description": "Flat-rolled products of stainless steel, of a width of less than <il>600 mm</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.11.0000",
      "rawHtsCode": "7220.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of <il>4.75 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7220.12",
      "rawHtsCode": "7220.12",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of less than <il>4.75 mm</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.12.1000",
      "rawHtsCode": "7220.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of a width of 300 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7220.12.5000",
      "rawHtsCode": "7220.12.50.00",
      "superior": null,
      "indent": "3",
      "description": "Of a width of less than 300 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7220.20",
      "rawHtsCode": "7220.20",
      "superior": null,
      "indent": "1",
      "description": "Not further worked than cold-rolled (cold-reduced):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.10",
      "rawHtsCode": "7220.20.10",
      "superior": null,
      "indent": "2",
      "description": "Of a width of 300 mm or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7220.20.1010",
      "rawHtsCode": "7220.20.10.10",
      "superior": null,
      "indent": "4",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.1015",
      "rawHtsCode": "7220.20.10.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.1060",
      "rawHtsCode": "7220.20.10.60",
      "superior": null,
      "indent": "4",
      "description": "Containing less than 15 percent by weight of chromium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.1080",
      "rawHtsCode": "7220.20.10.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.60",
      "rawHtsCode": "7220.20.60",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness exceeding 1.25 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7220.20.6005",
      "rawHtsCode": "7220.20.60.05",
      "superior": null,
      "indent": "4",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.6010",
      "rawHtsCode": "7220.20.60.10",
      "superior": null,
      "indent": "6",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.6015",
      "rawHtsCode": "7220.20.60.15",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.6060",
      "rawHtsCode": "7220.20.60.60",
      "superior": null,
      "indent": "6",
      "description": "Containing less than 15 percent by weight of chromium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.6080",
      "rawHtsCode": "7220.20.60.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.70",
      "rawHtsCode": "7220.20.70",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness exceeding 0.25 mm but not exceeding 1.25 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7220.20.7005",
      "rawHtsCode": "7220.20.70.05",
      "superior": null,
      "indent": "4",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.7010",
      "rawHtsCode": "7220.20.70.10",
      "superior": null,
      "indent": "6",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.7015",
      "rawHtsCode": "7220.20.70.15",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.7060",
      "rawHtsCode": "7220.20.70.60",
      "superior": null,
      "indent": "6",
      "description": "Containing less than 15 percent by weight of chromium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.7080",
      "rawHtsCode": "7220.20.70.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.8000",
      "rawHtsCode": "7220.20.80.00",
      "superior": null,
      "indent": "4",
      "description": "Razor blade steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7220.20.90",
      "rawHtsCode": "7220.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7220.20.9030",
      "rawHtsCode": "7220.20.90.30",
      "superior": null,
      "indent": "5",
      "description": "Containing more than 0.5 percent but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.20.9060",
      "rawHtsCode": "7220.20.90.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.90.00",
      "rawHtsCode": "7220.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7220.90.0010",
      "rawHtsCode": "7220.90.00.10",
      "superior": null,
      "indent": "3",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.90.0015",
      "rawHtsCode": "7220.90.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.90.0060",
      "rawHtsCode": "7220.90.00.60",
      "superior": null,
      "indent": "3",
      "description": "Containing less than 15 percent by weight of chromium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7220.90.0080",
      "rawHtsCode": "7220.90.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7221.00.00",
      "rawHtsCode": "7221.00.00",
      "superior": null,
      "indent": "0",
      "description": "Bars and rods, hot-rolled, in irregularly wound coils, of stainless steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7221.00.0005",
      "rawHtsCode": "7221.00.00.05",
      "superior": null,
      "indent": "1",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7221.00.0017",
      "rawHtsCode": "7221.00.00.17",
      "superior": null,
      "indent": "4",
      "description": "Containing less than 8 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7221.00.0018",
      "rawHtsCode": "7221.00.00.18",
      "superior": null,
      "indent": "4",
      "description": "Containing 8 percent or more but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7221.00.0030",
      "rawHtsCode": "7221.00.00.30",
      "superior": null,
      "indent": "3",
      "description": "With a diameter of 14 mm or more but less than 19 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7221.00.0045",
      "rawHtsCode": "7221.00.00.45",
      "superior": null,
      "indent": "3",
      "description": "With a diameter of 19 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7221.00.0075",
      "rawHtsCode": "7221.00.00.75",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222",
      "rawHtsCode": "7222",
      "superior": null,
      "indent": "0",
      "description": "Other bars and rods of stainless steel; angles, shapes and sections of stainless steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.11.00",
      "rawHtsCode": "7222.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of circular cross-section",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7222.11.0001",
      "rawHtsCode": "7222.11.00.01",
      "superior": null,
      "indent": "3",
      "description": "Electroslag or vacuum arc remelted",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.11.0006",
      "rawHtsCode": "7222.11.00.06",
      "superior": null,
      "indent": "3",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.11.0057",
      "rawHtsCode": "7222.11.00.57",
      "superior": null,
      "indent": "5",
      "description": "Containing less than 8 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.11.0059",
      "rawHtsCode": "7222.11.00.59",
      "superior": null,
      "indent": "5",
      "description": "Containing 8 percent or more but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.11.0082",
      "rawHtsCode": "7222.11.00.82",
      "superior": null,
      "indent": "5",
      "description": "Containing less than 8 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.11.0084",
      "rawHtsCode": "7222.11.00.84",
      "superior": null,
      "indent": "5",
      "description": "Containing 8 percent or more but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.19.00",
      "rawHtsCode": "7222.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7222.19.0001",
      "rawHtsCode": "7222.19.00.01",
      "superior": null,
      "indent": "3",
      "description": "Electroslag or vacuum arc remelted",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.19.0006",
      "rawHtsCode": "7222.19.00.06",
      "superior": null,
      "indent": "4",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.19.0052",
      "rawHtsCode": "7222.19.00.52",
      "superior": null,
      "indent": "5",
      "description": "Containing less than 8 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.19.0054",
      "rawHtsCode": "7222.19.00.54",
      "superior": null,
      "indent": "5",
      "description": "Containing 8 percent or more but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.20.00",
      "rawHtsCode": "7222.20.00",
      "superior": null,
      "indent": "1",
      "description": "Bars and rods, not further worked than cold-formed or cold-finished",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7222.20.0001",
      "rawHtsCode": "7222.20.00.01",
      "superior": null,
      "indent": "2",
      "description": "Electroslag or vacuum arc remelted",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.20.0006",
      "rawHtsCode": "7222.20.00.06",
      "superior": null,
      "indent": "2",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.20.0041",
      "rawHtsCode": "7222.20.00.41",
      "superior": null,
      "indent": "5",
      "description": "Containing less than 8 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.20.0043",
      "rawHtsCode": "7222.20.00.43",
      "superior": null,
      "indent": "5",
      "description": "Containing 8 percent or more but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.20.0062",
      "rawHtsCode": "7222.20.00.62",
      "superior": null,
      "indent": "5",
      "description": "Containing less than 8 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.20.0064",
      "rawHtsCode": "7222.20.00.64",
      "superior": null,
      "indent": "5",
      "description": "Containing 8 percent or more but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.20.0067",
      "rawHtsCode": "7222.20.00.67",
      "superior": null,
      "indent": "5",
      "description": "Containing less than 8 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.20.0069",
      "rawHtsCode": "7222.20.00.69",
      "superior": null,
      "indent": "5",
      "description": "Containing 8 percent or more but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.20.0071",
      "rawHtsCode": "7222.20.00.71",
      "superior": null,
      "indent": "4",
      "description": "Containing less than 8 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.20.0073",
      "rawHtsCode": "7222.20.00.73",
      "superior": null,
      "indent": "4",
      "description": "Containing 8 percent or more but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.30.00",
      "rawHtsCode": "7222.30.00",
      "superior": null,
      "indent": "1",
      "description": "Other bars and rods",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7222.30.0001",
      "rawHtsCode": "7222.30.00.01",
      "superior": null,
      "indent": "2",
      "description": "Electroslag or vacuum arc remelted",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.30.0012",
      "rawHtsCode": "7222.30.00.12",
      "superior": null,
      "indent": "2",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.30.0022",
      "rawHtsCode": "7222.30.00.22",
      "superior": null,
      "indent": "4",
      "description": "Containing less than 8 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.30.0024",
      "rawHtsCode": "7222.30.00.24",
      "superior": null,
      "indent": "4",
      "description": "Containing 8 percent or more but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.30.0082",
      "rawHtsCode": "7222.30.00.82",
      "superior": null,
      "indent": "4",
      "description": "Containing less than 8 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.30.0084",
      "rawHtsCode": "7222.30.00.84",
      "superior": null,
      "indent": "4",
      "description": "Containing 8 percent or more but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.40",
      "rawHtsCode": "7222.40",
      "superior": null,
      "indent": "1",
      "description": "Angles, shapes and sections:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.40.30",
      "rawHtsCode": "7222.40.30",
      "superior": null,
      "indent": "2",
      "description": "Hot-rolled, not drilled, not punched and not otherwise advanced",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7222.40.3025",
      "rawHtsCode": "7222.40.30.25",
      "superior": null,
      "indent": "4",
      "description": "Angles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.40.3045",
      "rawHtsCode": "7222.40.30.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.40.3065",
      "rawHtsCode": "7222.40.30.65",
      "superior": null,
      "indent": "4",
      "description": "Angles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.40.3085",
      "rawHtsCode": "7222.40.30.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7222.40.6000",
      "rawHtsCode": "7222.40.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7223.00",
      "rawHtsCode": "7223.00",
      "superior": null,
      "indent": "0",
      "description": "Wire of stainless steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7223.00.10",
      "rawHtsCode": "7223.00.10",
      "superior": null,
      "indent": "1",
      "description": "Round wire",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7223.00.1005",
      "rawHtsCode": "7223.00.10.05",
      "superior": null,
      "indent": "2",
      "description": "Spring round wire of a kind described in statistical note 8 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7223.00.1016",
      "rawHtsCode": "7223.00.10.16",
      "superior": null,
      "indent": "3",
      "description": "With a diameter of less than 0.25 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7223.00.1031",
      "rawHtsCode": "7223.00.10.31",
      "superior": null,
      "indent": "3",
      "description": "With a diameter of 0.25 mm or more but less than 0.76 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7223.00.1046",
      "rawHtsCode": "7223.00.10.46",
      "superior": null,
      "indent": "3",
      "description": "With a diameter of 0.76 mm or more but less than 1.52 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7223.00.1061",
      "rawHtsCode": "7223.00.10.61",
      "superior": null,
      "indent": "3",
      "description": "With a diameter of 1.52 mm or more but less than 5.1 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7223.00.1076",
      "rawHtsCode": "7223.00.10.76",
      "superior": null,
      "indent": "3",
      "description": "With a diameter of 5.1 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7223.00.5000",
      "rawHtsCode": "7223.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Flat wire",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7223.00.9000",
      "rawHtsCode": "7223.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7224",
      "rawHtsCode": "7224",
      "superior": null,
      "indent": "0",
      "description": "Other alloy steel in ingots or other primary forms; semi-finished products of other alloy steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7224.10.00",
      "rawHtsCode": "7224.10.00",
      "superior": null,
      "indent": "1",
      "description": "Ingots and other primary forms",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7224.10.0005",
      "rawHtsCode": "7224.10.00.05",
      "superior": null,
      "indent": "2",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7224.10.0045",
      "rawHtsCode": "7224.10.00.45",
      "superior": null,
      "indent": "3",
      "description": "Of tool steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7224.10.0075",
      "rawHtsCode": "7224.10.00.75",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7224.90.00",
      "rawHtsCode": "7224.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7224.90.0005",
      "rawHtsCode": "7224.90.00.05",
      "superior": null,
      "indent": "2",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7224.90.0015",
      "rawHtsCode": "7224.90.00.15",
      "superior": null,
      "indent": "5",
      "description": "Having a width less than four times the thickness",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7224.90.0025",
      "rawHtsCode": "7224.90.00.25",
      "superior": null,
      "indent": "5",
      "description": "Having a width at least four times the thickness",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7224.90.0035",
      "rawHtsCode": "7224.90.00.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7224.90.0045",
      "rawHtsCode": "7224.90.00.45",
      "superior": null,
      "indent": "5",
      "description": "Having a width less than four times the thickness",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7224.90.0055",
      "rawHtsCode": "7224.90.00.55",
      "superior": null,
      "indent": "5",
      "description": "Having a width at least four times the thickness",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7224.90.0065",
      "rawHtsCode": "7224.90.00.65",
      "superior": null,
      "indent": "4",
      "description": "Of circular cross section",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7224.90.0075",
      "rawHtsCode": "7224.90.00.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225",
      "rawHtsCode": "7225",
      "superior": null,
      "indent": "0",
      "description": "Flat-rolled products of other alloy steel, of a width of <il>600 mm</il> or more:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.11.0000",
      "rawHtsCode": "7225.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Grain-oriented",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.19.0000",
      "rawHtsCode": "7225.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.30",
      "rawHtsCode": "7225.30",
      "superior": null,
      "indent": "1",
      "description": "Other, not further worked than hot-rolled, in coils:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.30.11",
      "rawHtsCode": "7225.30.11",
      "superior": null,
      "indent": "3",
      "description": "Of tool steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.30.1110",
      "rawHtsCode": "7225.30.11.10",
      "superior": null,
      "indent": "4",
      "description": "Of high-speed steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.30.1180",
      "rawHtsCode": "7225.30.11.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.30.30",
      "rawHtsCode": "7225.30.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.30.3005",
      "rawHtsCode": "7225.30.30.05",
      "superior": null,
      "indent": "4",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.30.3050",
      "rawHtsCode": "7225.30.30.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.30.51",
      "rawHtsCode": "7225.30.51",
      "superior": null,
      "indent": "3",
      "description": "Of tool steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.30.5110",
      "rawHtsCode": "7225.30.51.10",
      "superior": null,
      "indent": "4",
      "description": "Of high-speed steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.30.5180",
      "rawHtsCode": "7225.30.51.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.30.7000",
      "rawHtsCode": "7225.30.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.40",
      "rawHtsCode": "7225.40",
      "superior": null,
      "indent": "1",
      "description": "Other, not further worked than hot-rolled, not in coils:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.40.11",
      "rawHtsCode": "7225.40.11",
      "superior": null,
      "indent": "3",
      "description": "Of tool steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.40.1110",
      "rawHtsCode": "7225.40.11.10",
      "superior": null,
      "indent": "4",
      "description": "Of high-speed steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.40.1180",
      "rawHtsCode": "7225.40.11.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.40.30",
      "rawHtsCode": "7225.40.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.40.3005",
      "rawHtsCode": "7225.40.30.05",
      "superior": null,
      "indent": "4",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.40.3050",
      "rawHtsCode": "7225.40.30.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.40.51",
      "rawHtsCode": "7225.40.51",
      "superior": null,
      "indent": "3",
      "description": "Of tool steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.40.5110",
      "rawHtsCode": "7225.40.51.10",
      "superior": null,
      "indent": "4",
      "description": "Of high-speed steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.40.5130",
      "rawHtsCode": "7225.40.51.30",
      "superior": null,
      "indent": "4",
      "description": "Of ball-bearing steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.40.5160",
      "rawHtsCode": "7225.40.51.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.40.7000",
      "rawHtsCode": "7225.40.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.50",
      "rawHtsCode": "7225.50",
      "superior": null,
      "indent": "1",
      "description": "Other, not further worked than cold-rolled (cold-reduced):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.50.11",
      "rawHtsCode": "7225.50.11",
      "superior": null,
      "indent": "2",
      "description": "Of tool steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.50.1110",
      "rawHtsCode": "7225.50.11.10",
      "superior": null,
      "indent": "3",
      "description": "Of high-speed steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.50.1130",
      "rawHtsCode": "7225.50.11.30",
      "superior": null,
      "indent": "3",
      "description": "Of ball-bearing steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.50.1160",
      "rawHtsCode": "7225.50.11.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.50.6000",
      "rawHtsCode": "7225.50.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness of <il>4.75 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.50.7000",
      "rawHtsCode": "7225.50.70.00",
      "superior": null,
      "indent": "4",
      "description": "Heat-resisting steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.50.80",
      "rawHtsCode": "7225.50.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.50.8010",
      "rawHtsCode": "7225.50.80.10",
      "superior": null,
      "indent": "5",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.50.8080",
      "rawHtsCode": "7225.50.80.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.91.0000",
      "rawHtsCode": "7225.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Electrolytically plated or coated with zinc",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.92.0000",
      "rawHtsCode": "7225.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Otherwise plated or coated with zinc",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.99.00",
      "rawHtsCode": "7225.99.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7225.99.0010",
      "rawHtsCode": "7225.99.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7225.99.0090",
      "rawHtsCode": "7225.99.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226",
      "rawHtsCode": "7226",
      "superior": null,
      "indent": "0",
      "description": "Flat-rolled products of other alloy steel, of a width of less than <il>600 mm</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.11",
      "rawHtsCode": "7226.11",
      "superior": null,
      "indent": "2",
      "description": "Grain-oriented:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.11.1000",
      "rawHtsCode": "7226.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of a width of 300 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.11.90",
      "rawHtsCode": "7226.11.90",
      "superior": null,
      "indent": "3",
      "description": "Of a width of less than 300 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.11.9030",
      "rawHtsCode": "7226.11.90.30",
      "superior": null,
      "indent": "4",
      "description": "Of thickness not exceeding 0.25 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.11.9060",
      "rawHtsCode": "7226.11.90.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.19",
      "rawHtsCode": "7226.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.19.1000",
      "rawHtsCode": "7226.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of a width of 300 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.19.9000",
      "rawHtsCode": "7226.19.90.00",
      "superior": null,
      "indent": "3",
      "description": "Of a width of less than 300 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.20.0000",
      "rawHtsCode": "7226.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of high-speed steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.91",
      "rawHtsCode": "7226.91",
      "superior": null,
      "indent": "2",
      "description": "Not further worked than hot-rolled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.91.0500",
      "rawHtsCode": "7226.91.05.00",
      "superior": null,
      "indent": "4",
      "description": "Of chipper knife steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.91.15",
      "rawHtsCode": "7226.91.15",
      "superior": null,
      "indent": "5",
      "description": "Of a width of 300 mm or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.91.1530",
      "rawHtsCode": "7226.91.15.30",
      "superior": null,
      "indent": "6",
      "description": "Of ball-bearing steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.91.1560",
      "rawHtsCode": "7226.91.15.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.91.25",
      "rawHtsCode": "7226.91.25",
      "superior": null,
      "indent": "5",
      "description": "Of a width of less than 300 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.91.2530",
      "rawHtsCode": "7226.91.25.30",
      "superior": null,
      "indent": "6",
      "description": "Of ball-bearing steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.91.2560",
      "rawHtsCode": "7226.91.25.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.91.5000",
      "rawHtsCode": "7226.91.50.00",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness of <il>4.75 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.91.7000",
      "rawHtsCode": "7226.91.70.00",
      "superior": null,
      "indent": "5",
      "description": "Of a width of 300 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.91.8000",
      "rawHtsCode": "7226.91.80.00",
      "superior": null,
      "indent": "5",
      "description": "Of a width of less than 300 mm",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.92",
      "rawHtsCode": "7226.92",
      "superior": null,
      "indent": "2",
      "description": "Not further worked than cold-rolled (cold-reduced):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.92.10",
      "rawHtsCode": "7226.92.10",
      "superior": null,
      "indent": "4",
      "description": "Of a width of 300 mm or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.92.1030",
      "rawHtsCode": "7226.92.10.30",
      "superior": null,
      "indent": "5",
      "description": "Of ball-bearing steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.92.1060",
      "rawHtsCode": "7226.92.10.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.92.30",
      "rawHtsCode": "7226.92.30",
      "superior": null,
      "indent": "4",
      "description": "Of a width of less than 300 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.92.3030",
      "rawHtsCode": "7226.92.30.30",
      "superior": null,
      "indent": "5",
      "description": "Of ball-bearing steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.92.3060",
      "rawHtsCode": "7226.92.30.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.92.5000",
      "rawHtsCode": "7226.92.50.00",
      "superior": null,
      "indent": "4",
      "description": "Of a width of 300 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.4¢/kg + 28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.92.70",
      "rawHtsCode": "7226.92.70",
      "superior": null,
      "indent": "5",
      "description": "Of a thickness not exceeding 0.25 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.92.7005",
      "rawHtsCode": "7226.92.70.05",
      "superior": null,
      "indent": "6",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.92.7050",
      "rawHtsCode": "7226.92.70.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.92.80",
      "rawHtsCode": "7226.92.80",
      "superior": null,
      "indent": "5",
      "description": "Of a thickness exceeding 0.25 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.92.8005",
      "rawHtsCode": "7226.92.80.05",
      "superior": null,
      "indent": "6",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.92.8050",
      "rawHtsCode": "7226.92.80.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.99.01",
      "rawHtsCode": "7226.99.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7226.99.0110",
      "rawHtsCode": "7226.99.01.10",
      "superior": null,
      "indent": "3",
      "description": "Electrolytically plated or coated with zinc",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.99.0130",
      "rawHtsCode": "7226.99.01.30",
      "superior": null,
      "indent": "3",
      "description": "Otherwise plated or coated with zinc",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7226.99.0180",
      "rawHtsCode": "7226.99.01.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227",
      "rawHtsCode": "7227",
      "superior": null,
      "indent": "0",
      "description": "Bars and rods, hot-rolled, in irregularly wound coils, of other alloy steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.10.0000",
      "rawHtsCode": "7227.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of high-speed steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "14%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7227.20.00",
      "rawHtsCode": "7227.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of silico-manganese steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7227.20.0030",
      "rawHtsCode": "7227.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Of welding quality wire rods of a kind described in statistical note 7 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.20.0080",
      "rawHtsCode": "7227.20.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.90",
      "rawHtsCode": "7227.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.90.10",
      "rawHtsCode": "7227.90.10",
      "superior": null,
      "indent": "3",
      "description": "Not tempered, not treated, and not partly manufactured",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "12%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7227.90.1030",
      "rawHtsCode": "7227.90.10.30",
      "superior": null,
      "indent": "4",
      "description": "Of ball-bearing steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.90.1060",
      "rawHtsCode": "7227.90.10.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.90.20",
      "rawHtsCode": "7227.90.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7227.90.2030",
      "rawHtsCode": "7227.90.20.30",
      "superior": null,
      "indent": "4",
      "description": "Of ball-bearing steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.90.2060",
      "rawHtsCode": "7227.90.20.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.90.60",
      "rawHtsCode": "7227.90.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7227.90.6005",
      "rawHtsCode": "7227.90.60.05",
      "superior": null,
      "indent": "3",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.90.6010",
      "rawHtsCode": "7227.90.60.10",
      "superior": null,
      "indent": "3",
      "description": "Of Cold Heading Quality (CHQ) steel of a kind described in statistical note 6 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.90.6020",
      "rawHtsCode": "7227.90.60.20",
      "superior": null,
      "indent": "3",
      "description": "Of welding quality wire rods of a kind described in statistical note 7 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.90.6030",
      "rawHtsCode": "7227.90.60.30",
      "superior": null,
      "indent": "4",
      "description": "With a diameter of less than 14 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.90.6035",
      "rawHtsCode": "7227.90.60.35",
      "superior": null,
      "indent": "4",
      "description": "With a diameter of 14 mm or more but less than 19 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.90.6040",
      "rawHtsCode": "7227.90.60.40",
      "superior": null,
      "indent": "4",
      "description": "With a diameter of 19 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7227.90.6090",
      "rawHtsCode": "7227.90.60.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228",
      "rawHtsCode": "7228",
      "superior": null,
      "indent": "0",
      "description": "Other bars and rods of other alloy steel; angles, shapes and sections, of other alloy steel; hollow drill bars and rods, of alloy or nonalloy steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.10.00",
      "rawHtsCode": "7228.10.00",
      "superior": null,
      "indent": "1",
      "description": "Bars and rods, of high-speed steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "32%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.10.0010",
      "rawHtsCode": "7228.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Not cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.10.0030",
      "rawHtsCode": "7228.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "With a maximum cross-sectional dimension of less than <il>18 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.10.0060",
      "rawHtsCode": "7228.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "With a maximum cross-sectional dimension of <il>18 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.20",
      "rawHtsCode": "7228.20",
      "superior": null,
      "indent": "1",
      "description": "Bars and rods, of silico-manganese steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.20.1000",
      "rawHtsCode": "7228.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Not cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.20.5000",
      "rawHtsCode": "7228.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.30",
      "rawHtsCode": "7228.30",
      "superior": null,
      "indent": "2",
      "description": "Of tool steel (other than high-speed steel):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.30.2000",
      "rawHtsCode": "7228.30.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of ball-bearing steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.30.4000",
      "rawHtsCode": "7228.30.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of chipper knife steel, not cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.30.6000",
      "rawHtsCode": "7228.30.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.30.80",
      "rawHtsCode": "7228.30.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.30.8005",
      "rawHtsCode": "7228.30.80.05",
      "superior": null,
      "indent": "3",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.30.8010",
      "rawHtsCode": "7228.30.80.10",
      "superior": null,
      "indent": "3",
      "description": "Concrete reinforcing bars and rods",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.30.8015",
      "rawHtsCode": "7228.30.80.15",
      "superior": null,
      "indent": "4",
      "description": "With a diameter or cross section measuring less than 76 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.30.8041",
      "rawHtsCode": "7228.30.80.41",
      "superior": null,
      "indent": "4",
      "description": "With a diameter or cross section measuring 76 mm or more but not exceeding 152 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.30.8045",
      "rawHtsCode": "7228.30.80.45",
      "superior": null,
      "indent": "4",
      "description": "With a diameter or cross section measuring 152 mm or more but not exceeding 228 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.30.8070",
      "rawHtsCode": "7228.30.80.70",
      "superior": null,
      "indent": "4",
      "description": "With a diameter or cross section exceeding 228 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.40.0000",
      "rawHtsCode": "7228.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other bars and rods, not further worked than forged",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.50",
      "rawHtsCode": "7228.50",
      "superior": null,
      "indent": "1",
      "description": "Other bars and rods, not further worked than cold-formed or cold-finished:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.50.10",
      "rawHtsCode": "7228.50.10",
      "superior": null,
      "indent": "2",
      "description": "Of tool steel (other than high-speed steel)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.50.1010",
      "rawHtsCode": "7228.50.10.10",
      "superior": null,
      "indent": "3",
      "description": "Of ball-bearing steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.50.1020",
      "rawHtsCode": "7228.50.10.20",
      "superior": null,
      "indent": "5",
      "description": "Of round or rectangular cross section with surfaces ground, milled or polished",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.50.1040",
      "rawHtsCode": "7228.50.10.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.50.1060",
      "rawHtsCode": "7228.50.10.60",
      "superior": null,
      "indent": "5",
      "description": "Of round or rectangular cross section with surfaces ground, milled or polished",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.50.1080",
      "rawHtsCode": "7228.50.10.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.50.50",
      "rawHtsCode": "7228.50.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.50.5005",
      "rawHtsCode": "7228.50.50.05",
      "superior": null,
      "indent": "3",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.50.5015",
      "rawHtsCode": "7228.50.50.15",
      "superior": null,
      "indent": "4",
      "description": "With a diameter or cross section measuring less than 76 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.50.5040",
      "rawHtsCode": "7228.50.50.40",
      "superior": null,
      "indent": "4",
      "description": "With a diameter or cross section measuring 76 mm or more but not exceeding 228 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.50.5070",
      "rawHtsCode": "7228.50.50.70",
      "superior": null,
      "indent": "4",
      "description": "With a diameter or cross section exceeding 228 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.60",
      "rawHtsCode": "7228.60",
      "superior": null,
      "indent": "1",
      "description": "Other bars and rods:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.60.10",
      "rawHtsCode": "7228.60.10",
      "superior": null,
      "indent": "2",
      "description": "Of tool steel (other than high-speed steel)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "29%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.60.1030",
      "rawHtsCode": "7228.60.10.30",
      "superior": null,
      "indent": "3",
      "description": "Of ball-bearing steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.60.1060",
      "rawHtsCode": "7228.60.10.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.60.6000",
      "rawHtsCode": "7228.60.60.00",
      "superior": null,
      "indent": "3",
      "description": "Not cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.60.8000",
      "rawHtsCode": "7228.60.80.00",
      "superior": null,
      "indent": "3",
      "description": "Cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.70",
      "rawHtsCode": "7228.70",
      "superior": null,
      "indent": "1",
      "description": "Angles, shapes and sections:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.70.30",
      "rawHtsCode": "7228.70.30",
      "superior": null,
      "indent": "2",
      "description": "Hot-rolled, not drilled, not punched and not otherwise advanced",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.70.3010",
      "rawHtsCode": "7228.70.30.10",
      "superior": null,
      "indent": "3",
      "description": "U, I, H and T sections",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.70.3020",
      "rawHtsCode": "7228.70.30.20",
      "superior": null,
      "indent": "5",
      "description": "Angles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.70.3041",
      "rawHtsCode": "7228.70.30.41",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.70.3060",
      "rawHtsCode": "7228.70.30.60",
      "superior": null,
      "indent": "5",
      "description": "Angles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.70.3081",
      "rawHtsCode": "7228.70.30.81",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7228.70.6000",
      "rawHtsCode": "7228.70.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7228.80.0000",
      "rawHtsCode": "7228.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hollow drill bars and rods",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7229",
      "rawHtsCode": "7229",
      "superior": null,
      "indent": "0",
      "description": "Wire of other alloy steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7229.20.00",
      "rawHtsCode": "7229.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of silico-manganese steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7229.20.0010",
      "rawHtsCode": "7229.20.00.10",
      "superior": null,
      "indent": "3",
      "description": "Plated or coated with copper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7229.20.0015",
      "rawHtsCode": "7229.20.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7229.20.0090",
      "rawHtsCode": "7229.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7229.90",
      "rawHtsCode": "7229.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7229.90.0500",
      "rawHtsCode": "7229.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "Of high-speed steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "37%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7229.90.1000",
      "rawHtsCode": "7229.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Flat wire",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7229.90.50",
      "rawHtsCode": "7229.90.50",
      "superior": null,
      "indent": "3",
      "description": "Round wire",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7229.90.5006",
      "rawHtsCode": "7229.90.50.06",
      "superior": null,
      "indent": "5",
      "description": "Plated or coated with copper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7229.90.5008",
      "rawHtsCode": "7229.90.50.08",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7229.90.5016",
      "rawHtsCode": "7229.90.50.16",
      "superior": null,
      "indent": "5",
      "description": "With a diameter of less than 1.0 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7229.90.5031",
      "rawHtsCode": "7229.90.50.31",
      "superior": null,
      "indent": "5",
      "description": "With a diameter of 1.0 mm or more but less than 1.5 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7229.90.5051",
      "rawHtsCode": "7229.90.50.51",
      "superior": null,
      "indent": "5",
      "description": "With a diameter of 1.5 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7229.90.9000",
      "rawHtsCode": "7229.90.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other wire",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7301",
      "rawHtsCode": "7301",
      "superior": null,
      "indent": "0",
      "description": "Sheet piling of iron or steel, whether or not drilled, punched or made from assembled elements; welded angles, shapes and sections, of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7301.10.0000",
      "rawHtsCode": "7301.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sheet piling",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7301.20",
      "rawHtsCode": "7301.20",
      "superior": null,
      "indent": "1",
      "description": "Angles, shapes and sections:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7301.20.1000",
      "rawHtsCode": "7301.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7301.20.5000",
      "rawHtsCode": "7301.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7302",
      "rawHtsCode": "7302",
      "superior": null,
      "indent": "0",
      "description": "Railway or tramway track construction material of iron or steel, the following: rails, check-rails and rack rails, switch blades, crossing frogs, point rods and other crossing pieces, sleepers (cross-ties), fish-plates, chairs, chair wedges, sole plates (base plates), rail clips, bedplates, ties and other material specialized for jointing or fixing rails:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.10",
      "rawHtsCode": "7302.10",
      "superior": null,
      "indent": "1",
      "description": "Rails:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.10.10",
      "rawHtsCode": "7302.10.10",
      "superior": null,
      "indent": "2",
      "description": "Of iron or nonalloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7302.10.1010",
      "rawHtsCode": "7302.10.10.10",
      "superior": null,
      "indent": "5",
      "description": "Standard tee rails over 30 kg per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.10.1015",
      "rawHtsCode": "7302.10.10.15",
      "superior": null,
      "indent": "6",
      "description": "Over 30 kg per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.10.1025",
      "rawHtsCode": "7302.10.10.25",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.10.1035",
      "rawHtsCode": "7302.10.10.35",
      "superior": null,
      "indent": "5",
      "description": "Standard tee rails over 30 kg per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.10.1045",
      "rawHtsCode": "7302.10.10.45",
      "superior": null,
      "indent": "6",
      "description": "Over 30 kg per meter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.10.1055",
      "rawHtsCode": "7302.10.10.55",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.10.1065",
      "rawHtsCode": "7302.10.10.65",
      "superior": null,
      "indent": "4",
      "description": "Railway rails for rerolling",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.10.1075",
      "rawHtsCode": "7302.10.10.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.10.50",
      "rawHtsCode": "7302.10.50",
      "superior": null,
      "indent": "2",
      "description": "Of alloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7302.10.5020",
      "rawHtsCode": "7302.10.50.20",
      "superior": null,
      "indent": "3",
      "description": "New",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.10.5040",
      "rawHtsCode": "7302.10.50.40",
      "superior": null,
      "indent": "4",
      "description": "Railway rails for rerolling",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.10.5060",
      "rawHtsCode": "7302.10.50.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.30.0000",
      "rawHtsCode": "7302.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Switch blades, crossing frogs, point rods and other crossing pieces",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7302.40.0000",
      "rawHtsCode": "7302.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Fish-plates and sole plates",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7302.90",
      "rawHtsCode": "7302.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7302.90.1000",
      "rawHtsCode": "7302.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Sleepers (cross-ties)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7302.90.9000",
      "rawHtsCode": "7302.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7303.00.00",
      "rawHtsCode": "7303.00.00",
      "superior": null,
      "indent": "0",
      "description": "Tubes, pipes and hollow profiles, of cast iron",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7303.00.0030",
      "rawHtsCode": "7303.00.00.30",
      "superior": null,
      "indent": "1",
      "description": "Soil pipe",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7303.00.0060",
      "rawHtsCode": "7303.00.00.60",
      "superior": null,
      "indent": "1",
      "description": "Pressure pipe with an inside diameter of less than <il>356 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7303.00.0090",
      "rawHtsCode": "7303.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304",
      "rawHtsCode": "7304",
      "superior": null,
      "indent": "0",
      "description": "Tubes, pipes and hollow profiles, seamless, of iron (other than cast iron) or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.11.00",
      "rawHtsCode": "7304.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of stainless steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.11.0020",
      "rawHtsCode": "7304.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "Having an outside diameter not exceeding <il>114.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.11.0050",
      "rawHtsCode": "7304.11.00.50",
      "superior": null,
      "indent": "3",
      "description": "Having an outside diameter exceeding <il>114.3 mm</il> but not exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.11.0080",
      "rawHtsCode": "7304.11.00.80",
      "superior": null,
      "indent": "3",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.19",
      "rawHtsCode": "7304.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.19.10",
      "rawHtsCode": "7304.19.10",
      "superior": null,
      "indent": "3",
      "description": "Of iron or nonalloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.19.1020",
      "rawHtsCode": "7304.19.10.20",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter not exceeding <il>114.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.19.1030",
      "rawHtsCode": "7304.19.10.30",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter exceeding <il>114.3 mm</il> but less than <il>215.9 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.19.1045",
      "rawHtsCode": "7304.19.10.45",
      "superior": null,
      "indent": "5",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.19.1060",
      "rawHtsCode": "7304.19.10.60",
      "superior": null,
      "indent": "5",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.19.1080",
      "rawHtsCode": "7304.19.10.80",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.19.50",
      "rawHtsCode": "7304.19.50",
      "superior": null,
      "indent": "3",
      "description": "Of other alloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.19.5020",
      "rawHtsCode": "7304.19.50.20",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter not exceeding <il>114.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.19.5050",
      "rawHtsCode": "7304.19.50.50",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter exceeding <il>114.3 mm</il> but not exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.19.5080",
      "rawHtsCode": "7304.19.50.80",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.22.00",
      "rawHtsCode": "7304.22.00",
      "superior": null,
      "indent": "2",
      "description": "Drill pipe of stainless steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.22.0030",
      "rawHtsCode": "7304.22.00.30",
      "superior": null,
      "indent": "4",
      "description": "Having a wall thickness not exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.22.0045",
      "rawHtsCode": "7304.22.00.45",
      "superior": null,
      "indent": "4",
      "description": "Having a wall thickness exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.22.0060",
      "rawHtsCode": "7304.22.00.60",
      "superior": null,
      "indent": "3",
      "description": "Having an outside diameter exceeding <il>168.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.23",
      "rawHtsCode": "7304.23",
      "superior": null,
      "indent": "2",
      "description": "Other drill pipe:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.23.3000",
      "rawHtsCode": "7304.23.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.23.60",
      "rawHtsCode": "7304.23.60",
      "superior": null,
      "indent": "3",
      "description": "Of alloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.23.6030",
      "rawHtsCode": "7304.23.60.30",
      "superior": null,
      "indent": "5",
      "description": "Having a wall thickness not exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.23.6045",
      "rawHtsCode": "7304.23.60.45",
      "superior": null,
      "indent": "5",
      "description": "Having a wall thickness exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.23.6060",
      "rawHtsCode": "7304.23.60.60",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter exceeding <il>168.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24",
      "rawHtsCode": "7304.24",
      "superior": null,
      "indent": "2",
      "description": "Other, of stainless steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.30",
      "rawHtsCode": "7304.24.30",
      "superior": null,
      "indent": "4",
      "description": "Threaded or coupled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.24.3010",
      "rawHtsCode": "7304.24.30.10",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.3020",
      "rawHtsCode": "7304.24.30.20",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.3030",
      "rawHtsCode": "7304.24.30.30",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.3040",
      "rawHtsCode": "7304.24.30.40",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.3045",
      "rawHtsCode": "7304.24.30.45",
      "superior": null,
      "indent": "5",
      "description": "Having an outside diameter exceeding 285.8 mm but not exceeding 406.4 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.3080",
      "rawHtsCode": "7304.24.30.80",
      "superior": null,
      "indent": "5",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.40",
      "rawHtsCode": "7304.24.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.24.4010",
      "rawHtsCode": "7304.24.40.10",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.4020",
      "rawHtsCode": "7304.24.40.20",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.4030",
      "rawHtsCode": "7304.24.40.30",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.4040",
      "rawHtsCode": "7304.24.40.40",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.4050",
      "rawHtsCode": "7304.24.40.50",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.4060",
      "rawHtsCode": "7304.24.40.60",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.4080",
      "rawHtsCode": "7304.24.40.80",
      "superior": null,
      "indent": "5",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.60",
      "rawHtsCode": "7304.24.60",
      "superior": null,
      "indent": "3",
      "description": "Tubing",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.24.6015",
      "rawHtsCode": "7304.24.60.15",
      "superior": null,
      "indent": "5",
      "description": "Having a wall thickness not exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.6030",
      "rawHtsCode": "7304.24.60.30",
      "superior": null,
      "indent": "5",
      "description": "Having a wall thickness exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.6045",
      "rawHtsCode": "7304.24.60.45",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter exceeding <il>114.3 mm</il> but less than <il>215.9 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.6060",
      "rawHtsCode": "7304.24.60.60",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter of <il>215.9 mm</il> or more but not exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.24.6075",
      "rawHtsCode": "7304.24.60.75",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29",
      "rawHtsCode": "7304.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.10",
      "rawHtsCode": "7304.29.10",
      "superior": null,
      "indent": "5",
      "description": "Threaded or coupled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.29.1010",
      "rawHtsCode": "7304.29.10.10",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.1020",
      "rawHtsCode": "7304.29.10.20",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.1030",
      "rawHtsCode": "7304.29.10.30",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.1040",
      "rawHtsCode": "7304.29.10.40",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.1050",
      "rawHtsCode": "7304.29.10.50",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.1060",
      "rawHtsCode": "7304.29.10.60",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.1080",
      "rawHtsCode": "7304.29.10.80",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.20",
      "rawHtsCode": "7304.29.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.29.2010",
      "rawHtsCode": "7304.29.20.10",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.2020",
      "rawHtsCode": "7304.29.20.20",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.2030",
      "rawHtsCode": "7304.29.20.30",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.2040",
      "rawHtsCode": "7304.29.20.40",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.2050",
      "rawHtsCode": "7304.29.20.50",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.2060",
      "rawHtsCode": "7304.29.20.60",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.2080",
      "rawHtsCode": "7304.29.20.80",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.31",
      "rawHtsCode": "7304.29.31",
      "superior": null,
      "indent": "5",
      "description": "Threaded or coupled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.29.3110",
      "rawHtsCode": "7304.29.31.10",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.3120",
      "rawHtsCode": "7304.29.31.20",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.3130",
      "rawHtsCode": "7304.29.31.30",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.3140",
      "rawHtsCode": "7304.29.31.40",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.3150",
      "rawHtsCode": "7304.29.31.50",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.3160",
      "rawHtsCode": "7304.29.31.60",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.3180",
      "rawHtsCode": "7304.29.31.80",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.41",
      "rawHtsCode": "7304.29.41",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.29.4110",
      "rawHtsCode": "7304.29.41.10",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.4120",
      "rawHtsCode": "7304.29.41.20",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.4130",
      "rawHtsCode": "7304.29.41.30",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.4140",
      "rawHtsCode": "7304.29.41.40",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.4150",
      "rawHtsCode": "7304.29.41.50",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.4160",
      "rawHtsCode": "7304.29.41.60",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.4180",
      "rawHtsCode": "7304.29.41.80",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.50",
      "rawHtsCode": "7304.29.50",
      "superior": null,
      "indent": "4",
      "description": "Of iron or nonalloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.29.5015",
      "rawHtsCode": "7304.29.50.15",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness not exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.5030",
      "rawHtsCode": "7304.29.50.30",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.5045",
      "rawHtsCode": "7304.29.50.45",
      "superior": null,
      "indent": "5",
      "description": "Having an outside diameter exceeding <il>114.3 mm</il> but less than <il>215.9 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.5060",
      "rawHtsCode": "7304.29.50.60",
      "superior": null,
      "indent": "5",
      "description": "Having an outside diameter of <il>215.9 mm</il> or more but not exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.5075",
      "rawHtsCode": "7304.29.50.75",
      "superior": null,
      "indent": "5",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.61",
      "rawHtsCode": "7304.29.61",
      "superior": null,
      "indent": "4",
      "description": "Of other alloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.29.6115",
      "rawHtsCode": "7304.29.61.15",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness not exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.6130",
      "rawHtsCode": "7304.29.61.30",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.6145",
      "rawHtsCode": "7304.29.61.45",
      "superior": null,
      "indent": "5",
      "description": "Having an outside diameter exceeding <il>114.3 mm</il> but less than <il>215.9 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.6160",
      "rawHtsCode": "7304.29.61.60",
      "superior": null,
      "indent": "5",
      "description": "Having an outside diameter of <il>215.9 mm</il> or more but not exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.29.6175",
      "rawHtsCode": "7304.29.61.75",
      "superior": null,
      "indent": "5",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.31",
      "rawHtsCode": "7304.31",
      "superior": null,
      "indent": "2",
      "description": "Cold-drawn or cold-rolled (cold-reduced):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.31.3000",
      "rawHtsCode": "7304.31.30.00",
      "superior": null,
      "indent": "3",
      "description": "Hollow bars",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "22%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.31.60",
      "rawHtsCode": "7304.31.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.31.6010",
      "rawHtsCode": "7304.31.60.10",
      "superior": null,
      "indent": "4",
      "description": "Suitable for use in boilers, superheaters, heat exchangers, condensers, refining furnaces and feedwater heaters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.31.6050",
      "rawHtsCode": "7304.31.60.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.00",
      "rawHtsCode": "7304.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.39.0002",
      "rawHtsCode": "7304.39.00.02",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter less than <il>38.1 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0004",
      "rawHtsCode": "7304.39.00.04",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter of <il>38.1 mm</il> or more but less than 190.5 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0006",
      "rawHtsCode": "7304.39.00.06",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter of <il>190.5 mm</il> or more but not exceeding <il>285.8 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0008",
      "rawHtsCode": "7304.39.00.08",
      "superior": null,
      "indent": "4",
      "description": "Having an outside diameter exceeding <il>285.8 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0016",
      "rawHtsCode": "7304.39.00.16",
      "superior": null,
      "indent": "4",
      "description": "Galvanized, having an outside diameter not exceeding <il>114.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0020",
      "rawHtsCode": "7304.39.00.20",
      "superior": null,
      "indent": "5",
      "description": "Having an outside diameter less than <il>38.1 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0024",
      "rawHtsCode": "7304.39.00.24",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness less than <il>6.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0028",
      "rawHtsCode": "7304.39.00.28",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>6.4 mm</il> or more but not exceeding <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0032",
      "rawHtsCode": "7304.39.00.32",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness exceeding <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0036",
      "rawHtsCode": "7304.39.00.36",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0040",
      "rawHtsCode": "7304.39.00.40",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more but less than <il>19 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0044",
      "rawHtsCode": "7304.39.00.44",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>19 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0048",
      "rawHtsCode": "7304.39.00.48",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0052",
      "rawHtsCode": "7304.39.00.52",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more but less than <il>19 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0056",
      "rawHtsCode": "7304.39.00.56",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>19 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0062",
      "rawHtsCode": "7304.39.00.62",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0068",
      "rawHtsCode": "7304.39.00.68",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more but less than <il>19 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0072",
      "rawHtsCode": "7304.39.00.72",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>19 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0076",
      "rawHtsCode": "7304.39.00.76",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness less than <il>19 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.39.0080",
      "rawHtsCode": "7304.39.00.80",
      "superior": null,
      "indent": "6",
      "description": "Having a wall thickness of <il>19 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.41",
      "rawHtsCode": "7304.41",
      "superior": null,
      "indent": "2",
      "description": "Cold-drawn or cold-rolled (cold-reduced):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.41.30",
      "rawHtsCode": "7304.41.30",
      "superior": null,
      "indent": "3",
      "description": "Of an external diameter of less than <il>19 mm</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.41.3005",
      "rawHtsCode": "7304.41.30.05",
      "superior": null,
      "indent": "4",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.41.3015",
      "rawHtsCode": "7304.41.30.15",
      "superior": null,
      "indent": "5",
      "description": "Suitable for use in boilers, superheaters, heat exchangers, condensers, refining furnaces and feedwater heaters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.41.3045",
      "rawHtsCode": "7304.41.30.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.41.60",
      "rawHtsCode": "7304.41.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.41.6005",
      "rawHtsCode": "7304.41.60.05",
      "superior": null,
      "indent": "4",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.41.6015",
      "rawHtsCode": "7304.41.60.15",
      "superior": null,
      "indent": "5",
      "description": "Suitable for use in boilers, superheaters, heat exchangers, condensers, refining furnaces and feedwater heaters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.41.6045",
      "rawHtsCode": "7304.41.60.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.49.00",
      "rawHtsCode": "7304.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.49.0005",
      "rawHtsCode": "7304.49.00.05",
      "superior": null,
      "indent": "3",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.49.0015",
      "rawHtsCode": "7304.49.00.15",
      "superior": null,
      "indent": "4",
      "description": "Hollow bars",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.49.0045",
      "rawHtsCode": "7304.49.00.45",
      "superior": null,
      "indent": "5",
      "description": "Suitable for use in boilers, superheaters, heat exchangers, condensers, refining furnaces and feedwater heaters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.49.0060",
      "rawHtsCode": "7304.49.00.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.51",
      "rawHtsCode": "7304.51",
      "superior": null,
      "indent": "2",
      "description": "Cold-drawn or cold-rolled (cold-reduced):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.51.1000",
      "rawHtsCode": "7304.51.10.00",
      "superior": null,
      "indent": "3",
      "description": "Suitable for use in the manufacture of ball or roller bearings",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.51.50",
      "rawHtsCode": "7304.51.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.51.5005",
      "rawHtsCode": "7304.51.50.05",
      "superior": null,
      "indent": "4",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.51.5015",
      "rawHtsCode": "7304.51.50.15",
      "superior": null,
      "indent": "6",
      "description": "Of heat-resisting steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.51.5045",
      "rawHtsCode": "7304.51.50.45",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.51.5060",
      "rawHtsCode": "7304.51.50.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59",
      "rawHtsCode": "7304.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.1000",
      "rawHtsCode": "7304.59.10.00",
      "superior": null,
      "indent": "3",
      "description": "Suitable for use in the manufacture of ball or roller bearings",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.59.20",
      "rawHtsCode": "7304.59.20",
      "superior": null,
      "indent": "4",
      "description": "Suitable for use in boilers, superheaters, heat exchangers, condensers, refining furnaces and feedwater heaters",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.59.2030",
      "rawHtsCode": "7304.59.20.30",
      "superior": null,
      "indent": "5",
      "description": "Of heat-resisting steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.2040",
      "rawHtsCode": "7304.59.20.40",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter less than <il>38.1 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.2045",
      "rawHtsCode": "7304.59.20.45",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter of <il>38.1 mm</il> or more but not exceeding <il>114.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.2055",
      "rawHtsCode": "7304.59.20.55",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter exceeding <il>114.3 mm</il> but less than <il>190.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.2060",
      "rawHtsCode": "7304.59.20.60",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter of <il>190.5 mm</il> or more but not exceeding <il>285.8 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.2070",
      "rawHtsCode": "7304.59.20.70",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter exceeding <il>285.8 mm</il> but not exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.2080",
      "rawHtsCode": "7304.59.20.80",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.6000",
      "rawHtsCode": "7304.59.60.00",
      "superior": null,
      "indent": "5",
      "description": "Of heat-resisting steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.59.80",
      "rawHtsCode": "7304.59.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.59.8010",
      "rawHtsCode": "7304.59.80.10",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter less than <il>38.1 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8015",
      "rawHtsCode": "7304.59.80.15",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>6.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8020",
      "rawHtsCode": "7304.59.80.20",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>6.4 mm</il> or more but not exceeding <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8025",
      "rawHtsCode": "7304.59.80.25",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness exceeding <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8030",
      "rawHtsCode": "7304.59.80.30",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8035",
      "rawHtsCode": "7304.59.80.35",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more but less than <il>19 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8040",
      "rawHtsCode": "7304.59.80.40",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>19 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8045",
      "rawHtsCode": "7304.59.80.45",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8050",
      "rawHtsCode": "7304.59.80.50",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more but less than <il>19 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8055",
      "rawHtsCode": "7304.59.80.55",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>19 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8060",
      "rawHtsCode": "7304.59.80.60",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8065",
      "rawHtsCode": "7304.59.80.65",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>12.7 mm</il> or more but less than <il>19 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8070",
      "rawHtsCode": "7304.59.80.70",
      "superior": null,
      "indent": "7",
      "description": "Having a wall thickness of <il>19 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.59.8080",
      "rawHtsCode": "7304.59.80.80",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.90",
      "rawHtsCode": "7304.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7304.90.1000",
      "rawHtsCode": "7304.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.90.3000",
      "rawHtsCode": "7304.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.90.5000",
      "rawHtsCode": "7304.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7304.90.7000",
      "rawHtsCode": "7304.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305",
      "rawHtsCode": "7305",
      "superior": null,
      "indent": "0",
      "description": "Other tubes and pipes (for example, welded, riveted or similarly closed), having circular cross sections, the external diameter of which exceeds <il>406.4 mm</il>, of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.11",
      "rawHtsCode": "7305.11",
      "superior": null,
      "indent": "2",
      "description": "Longitudinally submerged arc welded:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.11.10",
      "rawHtsCode": "7305.11.10",
      "superior": null,
      "indent": "3",
      "description": "Of iron or nonalloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.11.1030",
      "rawHtsCode": "7305.11.10.30",
      "superior": null,
      "indent": "4",
      "description": "With an external diameter exceeding <il>406.4 mm</il> but not exceeding <il>609.6 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.11.1060",
      "rawHtsCode": "7305.11.10.60",
      "superior": null,
      "indent": "4",
      "description": "With an external diameter exceeding <il>609.6 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.11.5000",
      "rawHtsCode": "7305.11.50.00",
      "superior": null,
      "indent": "3",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.12",
      "rawHtsCode": "7305.12",
      "superior": null,
      "indent": "2",
      "description": "Other, longitudinally welded:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.12.10",
      "rawHtsCode": "7305.12.10",
      "superior": null,
      "indent": "3",
      "description": "Of iron or nonalloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.12.1030",
      "rawHtsCode": "7305.12.10.30",
      "superior": null,
      "indent": "4",
      "description": "With an external diameter exceeding <il>406.4 mm</il> but not exceeding <il>609.6 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.12.1060",
      "rawHtsCode": "7305.12.10.60",
      "superior": null,
      "indent": "4",
      "description": "With an external diameter exceeding <il>609.6 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.12.5000",
      "rawHtsCode": "7305.12.50.00",
      "superior": null,
      "indent": "3",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.19",
      "rawHtsCode": "7305.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.19.10",
      "rawHtsCode": "7305.19.10",
      "superior": null,
      "indent": "3",
      "description": "Of iron or nonalloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.19.1030",
      "rawHtsCode": "7305.19.10.30",
      "superior": null,
      "indent": "4",
      "description": "With an external diameter exceeding <il>406.4 mm</il> but not exceeding <il>609.6 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.19.1060",
      "rawHtsCode": "7305.19.10.60",
      "superior": null,
      "indent": "4",
      "description": "With an external diameter exceeding <il>609.6 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.19.5000",
      "rawHtsCode": "7305.19.50.00",
      "superior": null,
      "indent": "3",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.20",
      "rawHtsCode": "7305.20",
      "superior": null,
      "indent": "1",
      "description": "Casing of a kind used in drilling for oil or gas:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.20.2000",
      "rawHtsCode": "7305.20.20.00",
      "superior": null,
      "indent": "3",
      "description": "Threaded or coupled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.20.4000",
      "rawHtsCode": "7305.20.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.20.6000",
      "rawHtsCode": "7305.20.60.00",
      "superior": null,
      "indent": "3",
      "description": "Threaded or coupled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.20.8000",
      "rawHtsCode": "7305.20.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.31",
      "rawHtsCode": "7305.31",
      "superior": null,
      "indent": "2",
      "description": "Longitudinally welded:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.31.2000",
      "rawHtsCode": "7305.31.20.00",
      "superior": null,
      "indent": "3",
      "description": "Tapered pipes and tubes of steel principally used as parts of illuminating articles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.31.4000",
      "rawHtsCode": "7305.31.40.00",
      "superior": null,
      "indent": "4",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.31.60",
      "rawHtsCode": "7305.31.60",
      "superior": null,
      "indent": "4",
      "description": "Of alloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.31.6010",
      "rawHtsCode": "7305.31.60.10",
      "superior": null,
      "indent": "5",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.31.6090",
      "rawHtsCode": "7305.31.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.39",
      "rawHtsCode": "7305.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.39.1000",
      "rawHtsCode": "7305.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.39.5000",
      "rawHtsCode": "7305.39.50.00",
      "superior": null,
      "indent": "3",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.90",
      "rawHtsCode": "7305.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7305.90.1000",
      "rawHtsCode": "7305.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7305.90.5000",
      "rawHtsCode": "7305.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306",
      "rawHtsCode": "7306",
      "superior": null,
      "indent": "0",
      "description": "Other tubes, pipes and hollow profiles (for example, open seamed or welded, riveted or similarly closed), of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.11.00",
      "rawHtsCode": "7306.11.00",
      "superior": null,
      "indent": "2",
      "description": "Welded, of stainless steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.11.0010",
      "rawHtsCode": "7306.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "With an outside diameter not exceeding <il>114.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.11.0050",
      "rawHtsCode": "7306.11.00.50",
      "superior": null,
      "indent": "3",
      "description": "With an outside diameter exceeding <il>114.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.19",
      "rawHtsCode": "7306.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.19.10",
      "rawHtsCode": "7306.19.10",
      "superior": null,
      "indent": "3",
      "description": "Of iron or nonalloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.19.1010",
      "rawHtsCode": "7306.19.10.10",
      "superior": null,
      "indent": "4",
      "description": "With an outside diameter not exceeding <il>114.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.19.1050",
      "rawHtsCode": "7306.19.10.50",
      "superior": null,
      "indent": "4",
      "description": "With an outside diameter exceeding <il>114.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.19.51",
      "rawHtsCode": "7306.19.51",
      "superior": null,
      "indent": "3",
      "description": "Of alloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.19.5110",
      "rawHtsCode": "7306.19.51.10",
      "superior": null,
      "indent": "4",
      "description": "With an outside diameter not exceeding <il>114.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.19.5150",
      "rawHtsCode": "7306.19.51.50",
      "superior": null,
      "indent": "4",
      "description": "With an outside diameter exceeding <il>114.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.21",
      "rawHtsCode": "7306.21",
      "superior": null,
      "indent": "2",
      "description": "Welded of stainless steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.21.3000",
      "rawHtsCode": "7306.21.30.00",
      "superior": null,
      "indent": "4",
      "description": "Threaded or coupled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.21.4000",
      "rawHtsCode": "7306.21.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.21.80",
      "rawHtsCode": "7306.21.80",
      "superior": null,
      "indent": "3",
      "description": "Tubing",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.21.8010",
      "rawHtsCode": "7306.21.80.10",
      "superior": null,
      "indent": "4",
      "description": "Imported with coupling",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.21.8050",
      "rawHtsCode": "7306.21.80.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.29",
      "rawHtsCode": "7306.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.29.10",
      "rawHtsCode": "7306.29.10",
      "superior": null,
      "indent": "5",
      "description": "Threaded or coupled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.29.1030",
      "rawHtsCode": "7306.29.10.30",
      "superior": null,
      "indent": "6",
      "description": "Imported with coupling",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.29.1090",
      "rawHtsCode": "7306.29.10.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.29.2000",
      "rawHtsCode": "7306.29.20.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.29.3100",
      "rawHtsCode": "7306.29.31.00",
      "superior": null,
      "indent": "5",
      "description": "Threaded or coupled",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.29.4100",
      "rawHtsCode": "7306.29.41.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.29.60",
      "rawHtsCode": "7306.29.60",
      "superior": null,
      "indent": "4",
      "description": "Of iron or nonalloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.29.6010",
      "rawHtsCode": "7306.29.60.10",
      "superior": null,
      "indent": "5",
      "description": "Imported with coupling",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.29.6050",
      "rawHtsCode": "7306.29.60.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.29.81",
      "rawHtsCode": "7306.29.81",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.29.8110",
      "rawHtsCode": "7306.29.81.10",
      "superior": null,
      "indent": "5",
      "description": "Imported with coupling",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.29.8150",
      "rawHtsCode": "7306.29.81.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30",
      "rawHtsCode": "7306.30",
      "superior": null,
      "indent": "1",
      "description": "Other, welded, of circular cross section, of iron or nonalloy steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.10",
      "rawHtsCode": "7306.30.10",
      "superior": null,
      "indent": "2",
      "description": "Having a wall thickness of less than <il>1.65 mm</il>",
      "units": [
        " "
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.30.1010",
      "rawHtsCode": "7306.30.10.10",
      "superior": null,
      "indent": "3",
      "description": "Internally coated or lined with a non-electrically insulating material, suitable for use as electrical conduit",
      "units": [
        "kg"
      ],
      "generalRate": "\n",
      "specialRate": "",
      "otherRate": "\n",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.1090",
      "rawHtsCode": "7306.30.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "\n",
      "specialRate": "",
      "otherRate": "\n",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.3000",
      "rawHtsCode": "7306.30.30.00",
      "superior": null,
      "indent": "3",
      "description": "Tapered steel pipes and tubes principally used as parts of illuminating articles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.30.50",
      "rawHtsCode": "7306.30.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.30.5010",
      "rawHtsCode": "7306.30.50.10",
      "superior": null,
      "indent": "4",
      "description": "Suitable for use in boilers, superheaters, heat exchangers, condensers, refining furnaces and feedwater heaters, whether or not cold drawn",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5015",
      "rawHtsCode": "7306.30.50.15",
      "superior": null,
      "indent": "4",
      "description": "Other, cold-drawn",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5020",
      "rawHtsCode": "7306.30.50.20",
      "superior": null,
      "indent": "4",
      "description": "Other, cold-rolled (cold-reduced) with a wall thickness not exceeding <il>2.54 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5026",
      "rawHtsCode": "7306.30.50.26",
      "superior": null,
      "indent": "8",
      "description": "With an outside diameter not exceeding 50.8 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5027",
      "rawHtsCode": "7306.30.50.27",
      "superior": null,
      "indent": "8",
      "description": "With an outside diameter exceeding 50.8 mm but not exceeding 114.3 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5028",
      "rawHtsCode": "7306.30.50.28",
      "superior": null,
      "indent": "7",
      "description": "Internally coated or lined with a non-electrically insulating material, suitable for use as electrical conduit",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5031",
      "rawHtsCode": "7306.30.50.31",
      "superior": null,
      "indent": "8",
      "description": "With an outside diameter not exceeding 50.8 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5033",
      "rawHtsCode": "7306.30.50.33",
      "superior": null,
      "indent": "8",
      "description": "With an outside diameter exceeding 50.8 mm but not exceeding 114.3 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5035",
      "rawHtsCode": "7306.30.50.35",
      "superior": null,
      "indent": "7",
      "description": "Tube and pipe hollows for redrawing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5041",
      "rawHtsCode": "7306.30.50.41",
      "superior": null,
      "indent": "8",
      "description": "With an outside diameter not exceeding 50.8 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5043",
      "rawHtsCode": "7306.30.50.43",
      "superior": null,
      "indent": "8",
      "description": "With an outside diameter exceeding 50.8 mm but not exceeding 114.3 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5056",
      "rawHtsCode": "7306.30.50.56",
      "superior": null,
      "indent": "8",
      "description": "With an outside diameter not exceeding 50.8 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5057",
      "rawHtsCode": "7306.30.50.57",
      "superior": null,
      "indent": "8",
      "description": "With an outside diameter exceeding 50.8 mm but not exceeding 114.3 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5085",
      "rawHtsCode": "7306.30.50.85",
      "superior": null,
      "indent": "6",
      "description": "Galvanized",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.30.5090",
      "rawHtsCode": "7306.30.50.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40",
      "rawHtsCode": "7306.40",
      "superior": null,
      "indent": "1",
      "description": "Other, welded, of circular cross section, of stainless steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.10",
      "rawHtsCode": "7306.40.10",
      "superior": null,
      "indent": "2",
      "description": "Having a wall thickness of less than <il>1.65 mm</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.40.1010",
      "rawHtsCode": "7306.40.10.10",
      "superior": null,
      "indent": "4",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.1015",
      "rawHtsCode": "7306.40.10.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.1090",
      "rawHtsCode": "7306.40.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.50",
      "rawHtsCode": "7306.40.50",
      "superior": null,
      "indent": "2",
      "description": "Having a wall thickness of <il>1.65 mm</il> or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.40.5005",
      "rawHtsCode": "7306.40.50.05",
      "superior": null,
      "indent": "3",
      "description": "Of high-nickel alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.5015",
      "rawHtsCode": "7306.40.50.15",
      "superior": null,
      "indent": "4",
      "description": "Suitable for use in boilers, superheaters, heat exchangers, condensers, refining furnaces and feedwater heaters, whether or not cold-drawn",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.5040",
      "rawHtsCode": "7306.40.50.40",
      "superior": null,
      "indent": "5",
      "description": "Containing more than 0.5 percent but less than 24 percent by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.5042",
      "rawHtsCode": "7306.40.50.42",
      "superior": null,
      "indent": "6",
      "description": "Containing less than 15 percent by weight of chromium",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.5044",
      "rawHtsCode": "7306.40.50.44",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.5062",
      "rawHtsCode": "7306.40.50.62",
      "superior": null,
      "indent": "7",
      "description": "Containing more than 1.5 percent but less than 5 percent by weight of molybdenum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.5064",
      "rawHtsCode": "7306.40.50.64",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.5080",
      "rawHtsCode": "7306.40.50.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.5085",
      "rawHtsCode": "7306.40.50.85",
      "superior": null,
      "indent": "6",
      "description": "Containing more than 0.5 percent but less than <il>24 percent</il> by weight of nickel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.40.5090",
      "rawHtsCode": "7306.40.50.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.50",
      "rawHtsCode": "7306.50",
      "superior": null,
      "indent": "1",
      "description": "Other, welded, of circular cross section, of other alloy steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.50.1000",
      "rawHtsCode": "7306.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Having a wall thickness of less than <il>1.65 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.50.3000",
      "rawHtsCode": "7306.50.30.00",
      "superior": null,
      "indent": "3",
      "description": "Tapered pipes and tubes of steel principally used as parts of illuminating articles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.50.50",
      "rawHtsCode": "7306.50.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.50.5010",
      "rawHtsCode": "7306.50.50.10",
      "superior": null,
      "indent": "4",
      "description": "Suitable for use in boilers, superheaters, heat exchangers, condensers, refining furnaces and feedwater heaters, whether or not cold-drawn",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.50.5030",
      "rawHtsCode": "7306.50.50.30",
      "superior": null,
      "indent": "4",
      "description": "Other, cold-drawn or cold-rolled (cold- reduced)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.50.5050",
      "rawHtsCode": "7306.50.50.50",
      "superior": null,
      "indent": "5",
      "description": "With an outside diameter not exceeding <il>114.3 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.50.5070",
      "rawHtsCode": "7306.50.50.70",
      "superior": null,
      "indent": "5",
      "description": "With an outside diameter exceeding <il>114.3 mm</il> but not exceeding <il>406.4 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.61",
      "rawHtsCode": "7306.61",
      "superior": null,
      "indent": "2",
      "description": "Of square or rectangular cross section:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.61.1000",
      "rawHtsCode": "7306.61.10.00",
      "superior": null,
      "indent": "4",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.61.3000",
      "rawHtsCode": "7306.61.30.00",
      "superior": null,
      "indent": "4",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.61.5000",
      "rawHtsCode": "7306.61.50.00",
      "superior": null,
      "indent": "4",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.61.70",
      "rawHtsCode": "7306.61.70",
      "superior": null,
      "indent": "4",
      "description": "Of alloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.61.7030",
      "rawHtsCode": "7306.61.70.30",
      "superior": null,
      "indent": "5",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.61.7060",
      "rawHtsCode": "7306.61.70.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.69",
      "rawHtsCode": "7306.69",
      "superior": null,
      "indent": "2",
      "description": "Of other noncircular cross section:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.69.1000",
      "rawHtsCode": "7306.69.10.00",
      "superior": null,
      "indent": "4",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.69.3000",
      "rawHtsCode": "7306.69.30.00",
      "superior": null,
      "indent": "4",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.69.5000",
      "rawHtsCode": "7306.69.50.00",
      "superior": null,
      "indent": "4",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.69.70",
      "rawHtsCode": "7306.69.70",
      "superior": null,
      "indent": "4",
      "description": "Of alloy steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.69.7030",
      "rawHtsCode": "7306.69.70.30",
      "superior": null,
      "indent": "5",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.69.7060",
      "rawHtsCode": "7306.69.70.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.90",
      "rawHtsCode": "7306.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7306.90.1000",
      "rawHtsCode": "7306.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7306.90.5000",
      "rawHtsCode": "7306.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7307",
      "rawHtsCode": "7307",
      "superior": null,
      "indent": "0",
      "description": "Tube or pipe fittings (for example, couplings, elbows, sleeves), of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.11.00",
      "rawHtsCode": "7307.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of nonmalleable cast iron",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.11.0030",
      "rawHtsCode": "7307.11.00.30",
      "superior": null,
      "indent": "3",
      "description": "For threaded pipe",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.11.0045",
      "rawHtsCode": "7307.11.00.45",
      "superior": null,
      "indent": "4",
      "description": "For cast-iron soil pipe",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.11.0060",
      "rawHtsCode": "7307.11.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.19",
      "rawHtsCode": "7307.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.19.30",
      "rawHtsCode": "7307.19.30",
      "superior": null,
      "indent": "3",
      "description": "Ductile fittings",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.19.3040",
      "rawHtsCode": "7307.19.30.40",
      "superior": null,
      "indent": "4",
      "description": "Grooved-end fittings (including grooved couplings)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.19.3060",
      "rawHtsCode": "7307.19.30.60",
      "superior": null,
      "indent": "5",
      "description": "Threaded",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.19.3070",
      "rawHtsCode": "7307.19.30.70",
      "superior": null,
      "indent": "5",
      "description": "With mechanical, push-on (rubber compression) or flanged joints attached",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.19.3085",
      "rawHtsCode": "7307.19.30.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.19.90",
      "rawHtsCode": "7307.19.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.19.9030",
      "rawHtsCode": "7307.19.90.30",
      "superior": null,
      "indent": "4",
      "description": "Unions",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.19.9040",
      "rawHtsCode": "7307.19.90.40",
      "superior": null,
      "indent": "5",
      "description": "Grooved-end fittings (including grooved couplings)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.19.9060",
      "rawHtsCode": "7307.19.90.60",
      "superior": null,
      "indent": "6",
      "description": "Threaded",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.19.9080",
      "rawHtsCode": "7307.19.90.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.21",
      "rawHtsCode": "7307.21",
      "superior": null,
      "indent": "2",
      "description": "Flanges:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.21.1000",
      "rawHtsCode": "7307.21.10.00",
      "superior": null,
      "indent": "3",
      "description": "Not machined, not tooled and not otherwise processed after forging",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "34%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.21.5000",
      "rawHtsCode": "7307.21.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.22",
      "rawHtsCode": "7307.22",
      "superior": null,
      "indent": "2",
      "description": "Threaded elbows, bends and sleeves:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.22.1000",
      "rawHtsCode": "7307.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Sleeves (couplings)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7307.22.5000",
      "rawHtsCode": "7307.22.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.23.00",
      "rawHtsCode": "7307.23.00",
      "superior": null,
      "indent": "2",
      "description": "Butt welding fittings",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.23.0030",
      "rawHtsCode": "7307.23.00.30",
      "superior": null,
      "indent": "3",
      "description": "Not machined, not tooled and not otherwise processed after forming",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.23.0090",
      "rawHtsCode": "7307.23.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.29.00",
      "rawHtsCode": "7307.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.29.0030",
      "rawHtsCode": "7307.29.00.30",
      "superior": null,
      "indent": "3",
      "description": "Nipples",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.29.0090",
      "rawHtsCode": "7307.29.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.91",
      "rawHtsCode": "7307.91",
      "superior": null,
      "indent": "2",
      "description": "Flanges:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.91.1000",
      "rawHtsCode": "7307.91.10.00",
      "superior": null,
      "indent": "4",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.91.3000",
      "rawHtsCode": "7307.91.30.00",
      "superior": null,
      "indent": "4",
      "description": "Of alloy steel (except stainless steel)",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.91.50",
      "rawHtsCode": "7307.91.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.75% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.91.5010",
      "rawHtsCode": "7307.91.50.10",
      "superior": null,
      "indent": "5",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.91.5030",
      "rawHtsCode": "7307.91.50.30",
      "superior": null,
      "indent": "5",
      "description": "Of alloy steel (except stainless steel)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.91.5050",
      "rawHtsCode": "7307.91.50.50",
      "superior": null,
      "indent": "5",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.91.5070",
      "rawHtsCode": "7307.91.50.70",
      "superior": null,
      "indent": "5",
      "description": "Of alloy steel (except stainless steel)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.92",
      "rawHtsCode": "7307.92",
      "superior": null,
      "indent": "2",
      "description": "Threaded elbows, bends and sleeves:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.92.30",
      "rawHtsCode": "7307.92.30",
      "superior": null,
      "indent": "3",
      "description": "Sleeves (couplings)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7307.92.3010",
      "rawHtsCode": "7307.92.30.10",
      "superior": null,
      "indent": "4",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.92.3030",
      "rawHtsCode": "7307.92.30.30",
      "superior": null,
      "indent": "4",
      "description": "Of alloy steel (except stainless steel)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.92.9000",
      "rawHtsCode": "7307.92.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.1% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.93",
      "rawHtsCode": "7307.93",
      "superior": null,
      "indent": "2",
      "description": "Butt welding fittings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.93.30",
      "rawHtsCode": "7307.93.30",
      "superior": null,
      "indent": "4",
      "description": "Of iron or nonalloy steel",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.93.3010",
      "rawHtsCode": "7307.93.30.10",
      "superior": null,
      "indent": "5",
      "description": "Not machined, not tooled and not otherwise processed after forging",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.93.3040",
      "rawHtsCode": "7307.93.30.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.93.6000",
      "rawHtsCode": "7307.93.60.00",
      "superior": null,
      "indent": "4",
      "description": "Of alloy steel (except stainless steel)",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.93.90",
      "rawHtsCode": "7307.93.90",
      "superior": null,
      "indent": "3",
      "description": "With an inside diameter of <il>360 mm</il> or more",
      "units": [],
      "generalRate": "4.3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.93.9010",
      "rawHtsCode": "7307.93.90.10",
      "superior": null,
      "indent": "5",
      "description": "Not machined, not tooled and not otherwise processed after forging",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.93.9040",
      "rawHtsCode": "7307.93.90.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.93.9060",
      "rawHtsCode": "7307.93.90.60",
      "superior": null,
      "indent": "4",
      "description": "Of alloy steel (except stainless steel)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.99",
      "rawHtsCode": "7307.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.99.1000",
      "rawHtsCode": "7307.99.10.00",
      "superior": null,
      "indent": "4",
      "description": "Of iron or nonalloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.99.3000",
      "rawHtsCode": "7307.99.30.00",
      "superior": null,
      "indent": "4",
      "description": "Of alloy steel (except stainless steel)",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.99.50",
      "rawHtsCode": "7307.99.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7307.99.5015",
      "rawHtsCode": "7307.99.50.15",
      "superior": null,
      "indent": "5",
      "description": "Nipples",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.99.5045",
      "rawHtsCode": "7307.99.50.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7307.99.5060",
      "rawHtsCode": "7307.99.50.60",
      "superior": null,
      "indent": "4",
      "description": "Of alloy steel (except stainless steel)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7308",
      "rawHtsCode": "7308",
      "superior": null,
      "indent": "0",
      "description": "Structures (excluding prefabricated buildings of heading 9406) and parts of structures (for example, bridges and bridge sections, lock gates, towers, lattice masts, roofs, roofing frameworks, doors and windows and their frames and thresholds for doors, shutters, balustrades, pillars and columns) of iron or steel; plates, rods, angles, shapes, sections, tubes and the like, prepared for use in structures, of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7308.10.0000",
      "rawHtsCode": "7308.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Bridges and bridge sections",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "7308.20.00",
      "rawHtsCode": "7308.20.00",
      "superior": null,
      "indent": "1",
      "description": "Towers and lattice masts",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "7308.20.0030",
      "rawHtsCode": "7308.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Tubular, whether or not tapered, and sectional components thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7308.20.0035",
      "rawHtsCode": "7308.20.00.35",
      "superior": null,
      "indent": "2",
      "description": "Tubular wind turbine towers, whether or not tapered, and sectional components thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7308.20.0090",
      "rawHtsCode": "7308.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7308.30",
      "rawHtsCode": "7308.30",
      "superior": null,
      "indent": "1",
      "description": "Doors, windows and their frames and thresholds for doors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7308.30.1000",
      "rawHtsCode": "7308.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7308.30.50",
      "rawHtsCode": "7308.30.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7308.30.5015",
      "rawHtsCode": "7308.30.50.15",
      "superior": null,
      "indent": "3",
      "description": "Windows and their frames",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7308.30.5025",
      "rawHtsCode": "7308.30.50.25",
      "superior": null,
      "indent": "3",
      "description": "Thresholds for doors",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7308.30.5050",
      "rawHtsCode": "7308.30.50.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7308.40.0000",
      "rawHtsCode": "7308.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Equipment for scaffolding, shuttering, propping or pit- propping",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7308.90",
      "rawHtsCode": "7308.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7308.90.3000",
      "rawHtsCode": "7308.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Not in part of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7308.90.6000",
      "rawHtsCode": "7308.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7308.90.7000",
      "rawHtsCode": "7308.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "Steel grating",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "7308.90.95",
      "rawHtsCode": "7308.90.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "7308.90.9530",
      "rawHtsCode": "7308.90.95.30",
      "superior": null,
      "indent": "4",
      "description": "Sheet-metal roofing, siding, flooring and roof drainage equipment",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7308.90.9560",
      "rawHtsCode": "7308.90.95.60",
      "superior": null,
      "indent": "5",
      "description": "Architectural and ornamental work",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7308.90.9590",
      "rawHtsCode": "7308.90.95.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7309.00.00",
      "rawHtsCode": "7309.00.00",
      "superior": null,
      "indent": "0",
      "description": "Reservoirs, tanks, vats and similar containers for any material (other than compressed or liquefied gas), of iron or steel, of a capacity exceeding <il>300 liters</il>, whether or not lined or heat insulated, but not fitted with mechanical or thermal equipment",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7309.00.0030",
      "rawHtsCode": "7309.00.00.30",
      "superior": null,
      "indent": "1",
      "description": "Tanks",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7309.00.0090",
      "rawHtsCode": "7309.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7310",
      "rawHtsCode": "7310",
      "superior": null,
      "indent": "0",
      "description": "Tanks, casks, drums, cans, boxes and similar containers, for any material (other than compressed or liquefied gas), of iron or steel, of a capacity not exceeding <il>300 liters</il>, whether or not lined or heat insulated, but not fitted with mechanical or thermal equipment:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7310.10.00",
      "rawHtsCode": "7310.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of a capacity of <il>50 liters</il> or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7310.10.0005",
      "rawHtsCode": "7310.10.00.05",
      "superior": null,
      "indent": "2",
      "description": "Refillable stainless steel kegs, whether or not pressurized, of a kind described in statistical note 1 to this chapter.",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7310.10.0015",
      "rawHtsCode": "7310.10.00.15",
      "superior": null,
      "indent": "2",
      "description": "Empty steel drums and barrels",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7310.10.0090",
      "rawHtsCode": "7310.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7310.21.00",
      "rawHtsCode": "7310.21.00",
      "superior": null,
      "indent": "2",
      "description": "Cans which are to be closed by soldering or crimping",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7310.21.0025",
      "rawHtsCode": "7310.21.00.25",
      "superior": null,
      "indent": "3",
      "description": "Containers, of circular cross section, of a volume capacity between <il>11.4 liters</il> and <il>26.6 liters</il>, of a kind used for the conveyance of goods",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7310.21.0070",
      "rawHtsCode": "7310.21.00.70",
      "superior": null,
      "indent": "3",
      "description": "Containers of a circular cross section, of a capacity not exceeding 11.4 liters, of a kind used for aerosols",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7310.21.0075",
      "rawHtsCode": "7310.21.00.75",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7310.29.00",
      "rawHtsCode": "7310.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7310.29.0020",
      "rawHtsCode": "7310.29.00.20",
      "superior": null,
      "indent": "4",
      "description": "Refillable stainless steel kegs, whether or not pressurized, of a kind described in statistical note 1 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7310.29.0030",
      "rawHtsCode": "7310.29.00.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7310.29.0055",
      "rawHtsCode": "7310.29.00.55",
      "superior": null,
      "indent": "4",
      "description": "Refillable stainless steel kegs, whether or not pressurized, of a kind described in statistical note 1 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7310.29.0065",
      "rawHtsCode": "7310.29.00.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7311.00.00",
      "rawHtsCode": "7311.00.00",
      "superior": null,
      "indent": "0",
      "description": "Containers for compressed or liquefied gas, of iron or steel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7311.00.0030",
      "rawHtsCode": "7311.00.00.30",
      "superior": null,
      "indent": "2",
      "description": "Seamless steel containers not overwrapped, marked DOT 3A, 3AX, 3AA, 3AAX, 3B, 3E, 3HT, 3T or DOT-E followed by a specific exemption number",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7311.00.0060",
      "rawHtsCode": "7311.00.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7311.00.0090",
      "rawHtsCode": "7311.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312",
      "rawHtsCode": "7312",
      "superior": null,
      "indent": "0",
      "description": "Stranded wire, ropes, cables, plaited bands, slings and the like, of iron or steel, not electrically insulated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10",
      "rawHtsCode": "7312.10",
      "superior": null,
      "indent": "1",
      "description": "Stranded wire, ropes and cables:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.0500",
      "rawHtsCode": "7312.10.05.00",
      "superior": null,
      "indent": "4",
      "description": "Fitted with fittings or made up into articles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7312.10.10",
      "rawHtsCode": "7312.10.10",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7312.10.1030",
      "rawHtsCode": "7312.10.10.30",
      "superior": null,
      "indent": "5",
      "description": "Tire cord",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.1050",
      "rawHtsCode": "7312.10.10.50",
      "superior": null,
      "indent": "5",
      "description": "Other, stranded wire having a lay or twist of not more than 1 revolution for a length equal to the strand diameter multiplied by <il>8.5</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.1070",
      "rawHtsCode": "7312.10.10.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.2000",
      "rawHtsCode": "7312.10.20.00",
      "superior": null,
      "indent": "4",
      "description": "Fitted with fittings or made up into articles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7312.10.30",
      "rawHtsCode": "7312.10.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7312.10.3005",
      "rawHtsCode": "7312.10.30.05",
      "superior": null,
      "indent": "5",
      "description": "Tire cord",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.3010",
      "rawHtsCode": "7312.10.30.10",
      "superior": null,
      "indent": "6",
      "description": "Covered with textile or other non- metallic material",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.3012",
      "rawHtsCode": "7312.10.30.12",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.3020",
      "rawHtsCode": "7312.10.30.20",
      "superior": null,
      "indent": "5",
      "description": "Other, stranded wire having a lay or twist of not more than 1 revolution for a length equal to the strand diameter multiplied by 8.5",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.3045",
      "rawHtsCode": "7312.10.30.45",
      "superior": null,
      "indent": "6",
      "description": "Of brass plated wire",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.3065",
      "rawHtsCode": "7312.10.30.65",
      "superior": null,
      "indent": "8",
      "description": "ACSR core strand",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.3070",
      "rawHtsCode": "7312.10.30.70",
      "superior": null,
      "indent": "9",
      "description": "Covered with textile or other nonmetallic material",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.3074",
      "rawHtsCode": "7312.10.30.74",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.3080",
      "rawHtsCode": "7312.10.30.80",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.5000",
      "rawHtsCode": "7312.10.50.00",
      "superior": null,
      "indent": "4",
      "description": "Fitted with fittings or made up into articles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7312.10.60",
      "rawHtsCode": "7312.10.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7312.10.6030",
      "rawHtsCode": "7312.10.60.30",
      "superior": null,
      "indent": "5",
      "description": "With a diameter not exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.6060",
      "rawHtsCode": "7312.10.60.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.7000",
      "rawHtsCode": "7312.10.70.00",
      "superior": null,
      "indent": "4",
      "description": "Fitted with fittings or made up into articles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7312.10.8000",
      "rawHtsCode": "7312.10.80.00",
      "superior": null,
      "indent": "5",
      "description": "Of brass plated wire",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7312.10.90",
      "rawHtsCode": "7312.10.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7312.10.9030",
      "rawHtsCode": "7312.10.90.30",
      "superior": null,
      "indent": "7",
      "description": "With a diameter not exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.9060",
      "rawHtsCode": "7312.10.90.60",
      "superior": null,
      "indent": "7",
      "description": "With a diameter exceeding <il>9.5 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.10.9090",
      "rawHtsCode": "7312.10.90.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7312.90.0000",
      "rawHtsCode": "7312.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7313.00.0000",
      "rawHtsCode": "7313.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Barbed wire of iron or steel; twisted hoop or single flat wire, barbed or not, and loosely twisted double wire, of a kind used for fencing, of iron or steel",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314",
      "rawHtsCode": "7314",
      "superior": null,
      "indent": "0",
      "description": "Cloth (including endless bands), grill, netting and fencing, of iron or steel wire; expanded metal of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.12",
      "rawHtsCode": "7314.12",
      "superior": null,
      "indent": "2",
      "description": "Endless bands for machinery, of stainless steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.12.1000",
      "rawHtsCode": "7314.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "With meshes not finer than <il>12 wires</il> to the lineal centimeter in warp or filling",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.12.2000",
      "rawHtsCode": "7314.12.20.00",
      "superior": null,
      "indent": "3",
      "description": "With meshes finer than 12 but not finer than <il>36 wires</il> to the lineal centimeter in warp or filling",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.12.3000",
      "rawHtsCode": "7314.12.30.00",
      "superior": null,
      "indent": "5",
      "description": "With 94 or more wires to the lineal centimeter",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.12.6000",
      "rawHtsCode": "7314.12.60.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.12.9000",
      "rawHtsCode": "7314.12.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.14",
      "rawHtsCode": "7314.14",
      "superior": null,
      "indent": "2",
      "description": "Other woven cloth, of stainless steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.14.1000",
      "rawHtsCode": "7314.14.10.00",
      "superior": null,
      "indent": "3",
      "description": "With meshes not finer than <il>12 wires</il> to the lineal centimeter in warp or filling",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.14.2000",
      "rawHtsCode": "7314.14.20.00",
      "superior": null,
      "indent": "3",
      "description": "With meshes finer than 12 but not finer than <il>36 wires</il> to the lineal centimeter in warp or filling",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.14.3000",
      "rawHtsCode": "7314.14.30.00",
      "superior": null,
      "indent": "5",
      "description": "With 94 or more wires to the lineal centimeter",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.14.6000",
      "rawHtsCode": "7314.14.60.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.14.9000",
      "rawHtsCode": "7314.14.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.19.0100",
      "rawHtsCode": "7314.19.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.20.0000",
      "rawHtsCode": "7314.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Grill, netting and fencing, welded at the intersection, of wire with a maximum cross-sectional dimension of <il>3 mm</il> or more and having a mesh size of <il>100 cm<sup>2</sup></il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.31",
      "rawHtsCode": "7314.31",
      "superior": null,
      "indent": "2",
      "description": "Plated or coated with zinc:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.31.1000",
      "rawHtsCode": "7314.31.10.00",
      "superior": null,
      "indent": "3",
      "description": "Wire fencing plated or coated with zinc, whether or not covered with plastic material",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.31.50",
      "rawHtsCode": "7314.31.50",
      "superior": null,
      "indent": "3",
      "description": "Other:",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.31.5010",
      "rawHtsCode": "7314.31.50.10",
      "superior": null,
      "indent": "4",
      "description": "Welded wire stucco netting, furred, not reinforced with supplemental horizontal wire",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.31.5080",
      "rawHtsCode": "7314.31.50.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.39.0000",
      "rawHtsCode": "7314.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.41.00",
      "rawHtsCode": "7314.41.00",
      "superior": null,
      "indent": "2",
      "description": "Plated or coated with zinc",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.41.0030",
      "rawHtsCode": "7314.41.00.30",
      "superior": null,
      "indent": "3",
      "description": "Chain link fencing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.41.0040",
      "rawHtsCode": "7314.41.00.40",
      "superior": null,
      "indent": "4",
      "description": "Of wire with maximum cross- sectional dimension of <il>1 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.41.0045",
      "rawHtsCode": "7314.41.00.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.41.0080",
      "rawHtsCode": "7314.41.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.42.00",
      "rawHtsCode": "7314.42.00",
      "superior": null,
      "indent": "2",
      "description": "Coated with plastics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.1¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.42.0030",
      "rawHtsCode": "7314.42.00.30",
      "superior": null,
      "indent": "3",
      "description": "Chain link fencing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.42.0060",
      "rawHtsCode": "7314.42.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.49",
      "rawHtsCode": "7314.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7314.49.3000",
      "rawHtsCode": "7314.49.30.00",
      "superior": null,
      "indent": "3",
      "description": "Not cut to shape",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.49.6000",
      "rawHtsCode": "7314.49.60.00",
      "superior": null,
      "indent": "3",
      "description": "Cut to shape",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7314.50.0000",
      "rawHtsCode": "7314.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Expanded metal",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7315",
      "rawHtsCode": "7315",
      "superior": null,
      "indent": "0",
      "description": "Chain and parts thereof, of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7315.11.00",
      "rawHtsCode": "7315.11.00",
      "superior": null,
      "indent": "2",
      "description": "Roller chain",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7315.11.0005",
      "rawHtsCode": "7315.11.00.05",
      "superior": null,
      "indent": "3",
      "description": "For motor vehicles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7315.11.0010",
      "rawHtsCode": "7315.11.00.10",
      "superior": null,
      "indent": "5",
      "description": "Bicycle chains",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7315.11.0045",
      "rawHtsCode": "7315.11.00.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7315.11.0060",
      "rawHtsCode": "7315.11.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7315.12.00",
      "rawHtsCode": "7315.12.00",
      "superior": null,
      "indent": "2",
      "description": "Other chain",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7315.12.0020",
      "rawHtsCode": "7315.12.00.20",
      "superior": null,
      "indent": "3",
      "description": "Of not over <il>50 mm</il> pitch and containing more than 3 parts per pitch",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7315.12.0040",
      "rawHtsCode": "7315.12.00.40",
      "superior": null,
      "indent": "4",
      "description": "Welded steel chain",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7315.12.0060",
      "rawHtsCode": "7315.12.00.60",
      "superior": null,
      "indent": "4",
      "description": "Cast and combination chain",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7315.12.0080",
      "rawHtsCode": "7315.12.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7315.19.0000",
      "rawHtsCode": "7315.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7315.20",
      "rawHtsCode": "7315.20",
      "superior": null,
      "indent": "1",
      "description": "Skid chain:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7315.20.1000",
      "rawHtsCode": "7315.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Not over <il>8 mm</il> in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7315.20.5000",
      "rawHtsCode": "7315.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Over <il>8 mm</il> in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7315.81.0000",
      "rawHtsCode": "7315.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "Stud link",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7315.82",
      "rawHtsCode": "7315.82",
      "superior": null,
      "indent": "2",
      "description": "Other, welded link:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7315.82.1000",
      "rawHtsCode": "7315.82.10.00",
      "superior": null,
      "indent": "4",
      "description": "Not over <il>10 mm</il> in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7315.82.3000",
      "rawHtsCode": "7315.82.30.00",
      "superior": null,
      "indent": "4",
      "description": "Over <il>10 mm</il> in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7315.82.5000",
      "rawHtsCode": "7315.82.50.00",
      "superior": null,
      "indent": "4",
      "description": "Not over <il>10 mm</il> in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7315.82.7000",
      "rawHtsCode": "7315.82.70.00",
      "superior": null,
      "indent": "4",
      "description": "Over <il>10 mm</il> in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7315.89",
      "rawHtsCode": "7315.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7315.89.1000",
      "rawHtsCode": "7315.89.10.00",
      "superior": null,
      "indent": "4",
      "description": "Not over <il>8 mm</il> in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7315.89.3000",
      "rawHtsCode": "7315.89.30.00",
      "superior": null,
      "indent": "4",
      "description": "Over <il>8 mm</il> in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.7¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7315.89.5000",
      "rawHtsCode": "7315.89.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7315.90.0000",
      "rawHtsCode": "7315.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other parts",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7316.00.0000",
      "rawHtsCode": "7316.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Anchors, grapnels and parts thereof, of iron or steel",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7317.00",
      "rawHtsCode": "7317.00",
      "superior": null,
      "indent": "0",
      "description": "Nails, tacks, drawing pins, corrugated nails, staples (other than those of heading 8305) and similar articles, of iron or steel, whether or not with heads of other material, but excluding such articles with heads of copper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.1000",
      "rawHtsCode": "7317.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Thumb tacks",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7317.00.2000",
      "rawHtsCode": "7317.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "Not threaded",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.5¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7317.00.3000",
      "rawHtsCode": "7317.00.30.00",
      "superior": null,
      "indent": "2",
      "description": "Threaded",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7317.00.55",
      "rawHtsCode": "7317.00.55",
      "superior": null,
      "indent": "3",
      "description": "Made of round wire",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7317.00.5501",
      "rawHtsCode": "7317.00.55.01",
      "superior": null,
      "indent": "5",
      "description": "Collated roofing nails with a length of <il>20.6 mm</il> to <il>46.1 mm</il>, a head diameter of <il>8.3 mm</il> to <il>10.6 mm</il>, a shank diameter of <il>2.5 mm</il> to <il>3.2 mm</il>, whether or not galvanized",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5502",
      "rawHtsCode": "7317.00.55.02",
      "superior": null,
      "indent": "7",
      "description": "Galvanized",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5503",
      "rawHtsCode": "7317.00.55.03",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5505",
      "rawHtsCode": "7317.00.55.05",
      "superior": null,
      "indent": "7",
      "description": "Galvanized",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5507",
      "rawHtsCode": "7317.00.55.07",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5508",
      "rawHtsCode": "7317.00.55.08",
      "superior": null,
      "indent": "6",
      "description": "Assembled in a paper strip",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5511",
      "rawHtsCode": "7317.00.55.11",
      "superior": null,
      "indent": "6",
      "description": "Assembled in a wire strip",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5518",
      "rawHtsCode": "7317.00.55.18",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5519",
      "rawHtsCode": "7317.00.55.19",
      "superior": null,
      "indent": "5",
      "description": "With a length of less than <il>25.4 mm</il> and with a diameter of less than <il>1.65 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5520",
      "rawHtsCode": "7317.00.55.20",
      "superior": null,
      "indent": "7",
      "description": "Not coated, plated or painted",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5530",
      "rawHtsCode": "7317.00.55.30",
      "superior": null,
      "indent": "8",
      "description": "Galvanized",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5540",
      "rawHtsCode": "7317.00.55.40",
      "superior": null,
      "indent": "8",
      "description": "Vinyl, resin or cement coated",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5550",
      "rawHtsCode": "7317.00.55.50",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5560",
      "rawHtsCode": "7317.00.55.60",
      "superior": null,
      "indent": "7",
      "description": "Not coated, plated or painted",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5570",
      "rawHtsCode": "7317.00.55.70",
      "superior": null,
      "indent": "8",
      "description": "Galvanized",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5580",
      "rawHtsCode": "7317.00.55.80",
      "superior": null,
      "indent": "8",
      "description": "Vinyl, resin or cement coated",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.5590",
      "rawHtsCode": "7317.00.55.90",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.65",
      "rawHtsCode": "7317.00.65",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "5.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7317.00.6530",
      "rawHtsCode": "7317.00.65.30",
      "superior": null,
      "indent": "4",
      "description": "Cut",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.6560",
      "rawHtsCode": "7317.00.65.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7317.00.7500",
      "rawHtsCode": "7317.00.75.00",
      "superior": null,
      "indent": "2",
      "description": "Of two or more pieces",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7318",
      "rawHtsCode": "7318",
      "superior": null,
      "indent": "0",
      "description": "Screws, bolts, nuts, coach screws, screw hooks, rivets, cotters, cotter pins, washers (including spring washers) and similar articles, of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.11.0000",
      "rawHtsCode": "7318.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Coach screws",
      "units": [
        "kg"
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7318.12.0000",
      "rawHtsCode": "7318.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other wood screws",
      "units": [
        "kg"
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7318.13.00",
      "rawHtsCode": "7318.13.00",
      "superior": null,
      "indent": "2",
      "description": "Screw hooks and screw rings",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7318.13.0030",
      "rawHtsCode": "7318.13.00.30",
      "superior": null,
      "indent": "3",
      "description": "Having shanks or threads with a diameter of less than <il>6 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.13.0060",
      "rawHtsCode": "7318.13.00.60",
      "superior": null,
      "indent": "3",
      "description": "Having shanks or threads with a diameter of <il>6 mm</il> or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.14",
      "rawHtsCode": "7318.14",
      "superior": null,
      "indent": "2",
      "description": "Self-tapping screws:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.14.10",
      "rawHtsCode": "7318.14.10",
      "superior": null,
      "indent": "3",
      "description": "Having shanks or threads with a diameter of less than <il>6 mm</il>",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.1% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7318.14.1030",
      "rawHtsCode": "7318.14.10.30",
      "superior": null,
      "indent": "4",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.14.1060",
      "rawHtsCode": "7318.14.10.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.14.50",
      "rawHtsCode": "7318.14.50",
      "superior": null,
      "indent": "3",
      "description": "Having shanks or threads with a diameter of <il>6 mm</il> or more",
      "units": [],
      "generalRate": "8.6%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 4.3% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7318.14.5020",
      "rawHtsCode": "7318.14.50.20",
      "superior": null,
      "indent": "4",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.14.5080",
      "rawHtsCode": "7318.14.50.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15",
      "rawHtsCode": "7318.15",
      "superior": null,
      "indent": "2",
      "description": "Other screws and bolts, whether or not with their nuts or washers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.20",
      "rawHtsCode": "7318.15.20",
      "superior": null,
      "indent": "3",
      "description": "Bolts and bolts and their nuts or washers entered or exported in the same shipment",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7318.15.2010",
      "rawHtsCode": "7318.15.20.10",
      "superior": null,
      "indent": "4",
      "description": "Having shanks or threads with a diameter of less than <il>6 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.2020",
      "rawHtsCode": "7318.15.20.20",
      "superior": null,
      "indent": "5",
      "description": "Track bolts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.2030",
      "rawHtsCode": "7318.15.20.30",
      "superior": null,
      "indent": "5",
      "description": "Structural bolts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.2041",
      "rawHtsCode": "7318.15.20.41",
      "superior": null,
      "indent": "6",
      "description": "Right-angle anchor bolts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.2046",
      "rawHtsCode": "7318.15.20.46",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.2051",
      "rawHtsCode": "7318.15.20.51",
      "superior": null,
      "indent": "7",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.2055",
      "rawHtsCode": "7318.15.20.55",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.2061",
      "rawHtsCode": "7318.15.20.61",
      "superior": null,
      "indent": "7",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.2065",
      "rawHtsCode": "7318.15.20.65",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.2091",
      "rawHtsCode": "7318.15.20.91",
      "superior": null,
      "indent": "7",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.2095",
      "rawHtsCode": "7318.15.20.95",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.4000",
      "rawHtsCode": "7318.15.40.00",
      "superior": null,
      "indent": "3",
      "description": "Machine screws <il>9.5 mm</il> or more in length and <il>3.2 mm</il> or more in diameter (not including cap screws)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7318.15.50",
      "rawHtsCode": "7318.15.50",
      "superior": null,
      "indent": "3",
      "description": "Studs",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7318.15.5030",
      "rawHtsCode": "7318.15.50.30",
      "superior": null,
      "indent": "4",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.5051",
      "rawHtsCode": "7318.15.50.51",
      "superior": null,
      "indent": "6",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.5056",
      "rawHtsCode": "7318.15.50.56",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.5090",
      "rawHtsCode": "7318.15.50.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.60",
      "rawHtsCode": "7318.15.60",
      "superior": null,
      "indent": "4",
      "description": "Having shanks or threads with a diameter of less than <il>6 mm</il>",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7318.15.6010",
      "rawHtsCode": "7318.15.60.10",
      "superior": null,
      "indent": "6",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.6040",
      "rawHtsCode": "7318.15.60.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.6070",
      "rawHtsCode": "7318.15.60.70",
      "superior": null,
      "indent": "6",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.6080",
      "rawHtsCode": "7318.15.60.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.80",
      "rawHtsCode": "7318.15.80",
      "superior": null,
      "indent": "4",
      "description": "Having shanks or threads with a diameter of <il>6 mm</il> or more",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7318.15.8020",
      "rawHtsCode": "7318.15.80.20",
      "superior": null,
      "indent": "5",
      "description": "Set screws",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.8030",
      "rawHtsCode": "7318.15.80.30",
      "superior": null,
      "indent": "7",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.8045",
      "rawHtsCode": "7318.15.80.45",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.8055",
      "rawHtsCode": "7318.15.80.55",
      "superior": null,
      "indent": "8",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.8066",
      "rawHtsCode": "7318.15.80.66",
      "superior": null,
      "indent": "9",
      "description": "Cap screws",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.8069",
      "rawHtsCode": "7318.15.80.69",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.8082",
      "rawHtsCode": "7318.15.80.82",
      "superior": null,
      "indent": "8",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.15.8085",
      "rawHtsCode": "7318.15.80.85",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.16.00",
      "rawHtsCode": "7318.16.00",
      "superior": null,
      "indent": "2",
      "description": "Nuts",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "0.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7318.16.0015",
      "rawHtsCode": "7318.16.00.15",
      "superior": null,
      "indent": "4",
      "description": "Non-locking chrome-plated",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.16.0030",
      "rawHtsCode": "7318.16.00.30",
      "superior": null,
      "indent": "4",
      "description": "Locking",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.16.0045",
      "rawHtsCode": "7318.16.00.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.16.0060",
      "rawHtsCode": "7318.16.00.60",
      "superior": null,
      "indent": "4",
      "description": "Of stainless steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.16.0085",
      "rawHtsCode": "7318.16.00.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.19.0000",
      "rawHtsCode": "7318.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.85% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7318.21.00",
      "rawHtsCode": "7318.21.00",
      "superior": null,
      "indent": "2",
      "description": "Spring washers and other lock washers",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.9% (JP)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7318.21.0030",
      "rawHtsCode": "7318.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Helical spring lock washers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.21.0090",
      "rawHtsCode": "7318.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7318.22.0000",
      "rawHtsCode": "7318.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other washers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1.3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7318.23.0000",
      "rawHtsCode": "7318.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Rivets",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7318.24.0000",
      "rawHtsCode": "7318.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cotters and cotter pins",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7318.29.0000",
      "rawHtsCode": "7318.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7319",
      "rawHtsCode": "7319",
      "superior": null,
      "indent": "0",
      "description": "Sewing needles, knitting needles, bodkins, crochet hooks, embroidery stilettos and similar articles for use in the hand, of iron or steel; safety pins and other pins of iron or steel, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7319.40",
      "rawHtsCode": "7319.40",
      "superior": null,
      "indent": "1",
      "description": "Safety pins and other pins:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7319.40.20",
      "rawHtsCode": "7319.40.20",
      "superior": null,
      "indent": "2",
      "description": "Safety pins",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7319.40.2010",
      "rawHtsCode": "7319.40.20.10",
      "superior": null,
      "indent": "3",
      "description": "On cards",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7319.40.2050",
      "rawHtsCode": "7319.40.20.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7319.40.3000",
      "rawHtsCode": "7319.40.30.00",
      "superior": null,
      "indent": "2",
      "description": "Dressmakers' or common pins",
      "units": [
        "kg"
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7319.40.50",
      "rawHtsCode": "7319.40.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7319.40.5010",
      "rawHtsCode": "7319.40.50.10",
      "superior": null,
      "indent": "3",
      "description": "Push pins",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7319.40.5050",
      "rawHtsCode": "7319.40.50.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7319.90",
      "rawHtsCode": "7319.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7319.90.1000",
      "rawHtsCode": "7319.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Sewing, darning or embroidery needles",
      "units": [
        "thousands"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7319.90.9000",
      "rawHtsCode": "7319.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7320",
      "rawHtsCode": "7320",
      "superior": null,
      "indent": "0",
      "description": "Springs and leaves for springs, of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.10",
      "rawHtsCode": "7320.10",
      "superior": null,
      "indent": "1",
      "description": "Leaf springs and leaves therefor:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.10.3000",
      "rawHtsCode": "7320.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "To be used in motor vehicles having a G.V.W. not exceeding <il>4 metric tons</il>",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7320.10.60",
      "rawHtsCode": "7320.10.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7320.10.6015",
      "rawHtsCode": "7320.10.60.15",
      "superior": null,
      "indent": "4",
      "description": "Leaf springs having individual leaves with a thickness of <il>1.6 mm</il> or more and leaves therefor",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.10.6060",
      "rawHtsCode": "7320.10.60.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.10.90",
      "rawHtsCode": "7320.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7320.10.9015",
      "rawHtsCode": "7320.10.90.15",
      "superior": null,
      "indent": "3",
      "description": "Leaf springs having individual leaves with a thickness of <il>1.6 mm</il> or more and leaves therefor",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.10.9060",
      "rawHtsCode": "7320.10.90.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.20",
      "rawHtsCode": "7320.20",
      "superior": null,
      "indent": "1",
      "description": "Helical springs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.20.1000",
      "rawHtsCode": "7320.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Suitable for motor-vehicle suspension",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7320.20.50",
      "rawHtsCode": "7320.20.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7320.20.5010",
      "rawHtsCode": "7320.20.50.10",
      "superior": null,
      "indent": "4",
      "description": "Suitable for use in mattress supports and mattresses of heading 9404",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.20.5020",
      "rawHtsCode": "7320.20.50.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.20.5045",
      "rawHtsCode": "7320.20.50.45",
      "superior": null,
      "indent": "3",
      "description": "Helical springs, of wire having a cross-sectional dimension of <il>5.1 mm</il> or more but less than <il>12.7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.20.5060",
      "rawHtsCode": "7320.20.50.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.90",
      "rawHtsCode": "7320.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.90.1000",
      "rawHtsCode": "7320.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Hairsprings",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7320.90.50",
      "rawHtsCode": "7320.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7320.90.5010",
      "rawHtsCode": "7320.90.50.10",
      "superior": null,
      "indent": "4",
      "description": "Suitable for use in mattress supports and mattresses of heading 9404",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.90.5020",
      "rawHtsCode": "7320.90.50.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7320.90.5060",
      "rawHtsCode": "7320.90.50.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321",
      "rawHtsCode": "7321",
      "superior": null,
      "indent": "0",
      "description": "Stoves, ranges, grates, cookers (including those with subsidiary boilers for central heating), barbecues, braziers, gas rings, plate warmers and similar nonelectric domestic appliances, and parts thereof, of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.11",
      "rawHtsCode": "7321.11",
      "superior": null,
      "indent": "2",
      "description": "For gas fuel or for both gas and other fuels:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.11.10",
      "rawHtsCode": "7321.11.10",
      "superior": null,
      "indent": "3",
      "description": "Portable",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7321.11.1030",
      "rawHtsCode": "7321.11.10.30",
      "superior": null,
      "indent": "4",
      "description": "Stoves or ranges",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.11.1060",
      "rawHtsCode": "7321.11.10.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.11.30",
      "rawHtsCode": "7321.11.30",
      "superior": null,
      "indent": "4",
      "description": "Stoves or ranges:",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7321.11.3010",
      "rawHtsCode": "7321.11.30.10",
      "superior": null,
      "indent": "5",
      "description": "Of a maximum width not exceeding <il>70 centimeters</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.11.3020",
      "rawHtsCode": "7321.11.30.20",
      "superior": null,
      "indent": "5",
      "description": "Of a maximum width exceeding 70 but not exceeding <il>80 centimeters</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.11.3050",
      "rawHtsCode": "7321.11.30.50",
      "superior": null,
      "indent": "5",
      "description": "Of a maximum width exceeding <il>80 centimeters</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.11.6000",
      "rawHtsCode": "7321.11.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7321.12.0000",
      "rawHtsCode": "7321.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "For liquid fuel",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.19.00",
      "rawHtsCode": "7321.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other, including appliances for solid fuel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.19.0020",
      "rawHtsCode": "7321.19.00.20",
      "superior": null,
      "indent": "4",
      "description": "Hibachis",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.19.0040",
      "rawHtsCode": "7321.19.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.19.0060",
      "rawHtsCode": "7321.19.00.60",
      "superior": null,
      "indent": "4",
      "description": "Of cast iron",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.19.0080",
      "rawHtsCode": "7321.19.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.81",
      "rawHtsCode": "7321.81",
      "superior": null,
      "indent": "2",
      "description": "For gas fuel or for both gas and other fuels:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.81.1000",
      "rawHtsCode": "7321.81.10.00",
      "superior": null,
      "indent": "3",
      "description": "Portable",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7321.81.5000",
      "rawHtsCode": "7321.81.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7321.82",
      "rawHtsCode": "7321.82",
      "superior": null,
      "indent": "2",
      "description": "For liquid fuel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.82.1000",
      "rawHtsCode": "7321.82.10.00",
      "superior": null,
      "indent": "3",
      "description": "Portable",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7321.82.5000",
      "rawHtsCode": "7321.82.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7321.89.00",
      "rawHtsCode": "7321.89.00",
      "superior": null,
      "indent": "2",
      "description": "Other, including appliances for solid fuel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7321.89.0010",
      "rawHtsCode": "7321.89.00.10",
      "superior": null,
      "indent": "3",
      "description": "Fireplace grates of cast iron",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.89.0050",
      "rawHtsCode": "7321.89.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.90",
      "rawHtsCode": "7321.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.90.1000",
      "rawHtsCode": "7321.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cooking chambers, whether or not assembled",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7321.90.2000",
      "rawHtsCode": "7321.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Top surface panels with or without burners or controls",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7321.90.4000",
      "rawHtsCode": "7321.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Door assemblies, incorporating more than one of the following: inner panel, outer panel, window, insulation",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7321.90.5000",
      "rawHtsCode": "7321.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7321.90.60",
      "rawHtsCode": "7321.90.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7321.90.6040",
      "rawHtsCode": "7321.90.60.40",
      "superior": null,
      "indent": "4",
      "description": "Shelving and racks for cooking ovens",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.90.6060",
      "rawHtsCode": "7321.90.60.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7321.90.6090",
      "rawHtsCode": "7321.90.60.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7322",
      "rawHtsCode": "7322",
      "superior": null,
      "indent": "0",
      "description": "Radiators for central heating, not electrically heated, and parts thereof, of iron or steel; air heaters and hot air distributors (including distributors which can also distribute fresh or conditioned air), not electrically heated, incorporating a motor-driven fan or blower, and parts thereof, of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7322.11.0000",
      "rawHtsCode": "7322.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of cast iron",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7322.19.0000",
      "rawHtsCode": "7322.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7322.90.00",
      "rawHtsCode": "7322.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other, including parts",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7322.90.0015",
      "rawHtsCode": "7322.90.00.15",
      "superior": null,
      "indent": "2",
      "description": "Air heaters, not electrically heated, incorporating a motor-driven fan or blower",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7322.90.0030",
      "rawHtsCode": "7322.90.00.30",
      "superior": null,
      "indent": "2",
      "description": "Hot air distributors, not electrically heated, incorporating a motor-driven fan or blower",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7322.90.0045",
      "rawHtsCode": "7322.90.00.45",
      "superior": null,
      "indent": "2",
      "description": "Parts of air heaters and hot air distributors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323",
      "rawHtsCode": "7323",
      "superior": null,
      "indent": "0",
      "description": "Table, kitchen or other household articles and parts thereof, of iron or steel; iron or steel wool; pot scourers and scouring or polishing pads, gloves and the like, of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.10.0000",
      "rawHtsCode": "7323.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Iron or steel wool; pot scourers and scouring or polishing pads, gloves and the like",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "22¢/kg + 30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7323.91",
      "rawHtsCode": "7323.91",
      "superior": null,
      "indent": "2",
      "description": "Of cast iron, not enameled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.91.1000",
      "rawHtsCode": "7323.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Coated or plated with precious metal",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7323.91.50",
      "rawHtsCode": "7323.91.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7323.91.5020",
      "rawHtsCode": "7323.91.50.20",
      "superior": null,
      "indent": "4",
      "description": "Bakeware (cookware not suitable for stove top use)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.91.5040",
      "rawHtsCode": "7323.91.50.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.92.00",
      "rawHtsCode": "7323.92.00",
      "superior": null,
      "indent": "2",
      "description": "Of cast iron, enameled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7323.92.0020",
      "rawHtsCode": "7323.92.00.20",
      "superior": null,
      "indent": "3",
      "description": "Bakeware (cookware not suitable for stove top use)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.92.0040",
      "rawHtsCode": "7323.92.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.93.00",
      "rawHtsCode": "7323.93.00",
      "superior": null,
      "indent": "2",
      "description": "Of stainless steel",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7323.93.0015",
      "rawHtsCode": "7323.93.00.15",
      "superior": null,
      "indent": "4",
      "description": "Teakettles",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.93.0035",
      "rawHtsCode": "7323.93.00.35",
      "superior": null,
      "indent": "6",
      "description": "Bakeware (cookware not suitable for stove top use)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.93.0045",
      "rawHtsCode": "7323.93.00.45",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.93.0060",
      "rawHtsCode": "7323.93.00.60",
      "superior": null,
      "indent": "5",
      "description": "Kitchen ware",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.93.0080",
      "rawHtsCode": "7323.93.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.94.00",
      "rawHtsCode": "7323.94.00",
      "superior": null,
      "indent": "2",
      "description": "Of iron (other than cast iron) or steel, enameled",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7323.94.0010",
      "rawHtsCode": "7323.94.00.10",
      "superior": null,
      "indent": "5",
      "description": "Teakettles",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.94.0021",
      "rawHtsCode": "7323.94.00.21",
      "superior": null,
      "indent": "7",
      "description": "Bakeware (cookware not suitable for stove top use)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.94.0026",
      "rawHtsCode": "7323.94.00.26",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.94.0030",
      "rawHtsCode": "7323.94.00.30",
      "superior": null,
      "indent": "6",
      "description": "Kitchen ware",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.94.0040",
      "rawHtsCode": "7323.94.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.94.0080",
      "rawHtsCode": "7323.94.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.99",
      "rawHtsCode": "7323.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.99.1000",
      "rawHtsCode": "7323.99.10.00",
      "superior": null,
      "indent": "4",
      "description": "Coated or plated with silver",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7323.99.3000",
      "rawHtsCode": "7323.99.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "8.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7323.99.50",
      "rawHtsCode": "7323.99.50",
      "superior": null,
      "indent": "4",
      "description": "Of tinplate",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.99.5030",
      "rawHtsCode": "7323.99.50.30",
      "superior": null,
      "indent": "5",
      "description": "Kitchen or tableware suitable for food or drink contact",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.99.5060",
      "rawHtsCode": "7323.99.50.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.99.7000",
      "rawHtsCode": "7323.99.70.00",
      "superior": null,
      "indent": "5",
      "description": "Cookingware",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7323.99.90",
      "rawHtsCode": "7323.99.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7323.99.9030",
      "rawHtsCode": "7323.99.90.30",
      "superior": null,
      "indent": "6",
      "description": "Kitchen or tableware suitable for food or drink contact",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.99.9040",
      "rawHtsCode": "7323.99.90.40",
      "superior": null,
      "indent": "6",
      "description": "Gates for confining children or pets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7323.99.9080",
      "rawHtsCode": "7323.99.90.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7324",
      "rawHtsCode": "7324",
      "superior": null,
      "indent": "0",
      "description": "Sanitary ware and parts thereof, of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7324.10.00",
      "rawHtsCode": "7324.10.00",
      "superior": null,
      "indent": "1",
      "description": "Sinks and wash basins, of stainless steel",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7324.10.0010",
      "rawHtsCode": "7324.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Stainless steel sinks with one or more drawn bowls (basins)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7324.10.0050",
      "rawHtsCode": "7324.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7324.21",
      "rawHtsCode": "7324.21",
      "superior": null,
      "indent": "2",
      "description": "Of cast iron, whether or not enamelled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7324.21.1000",
      "rawHtsCode": "7324.21.10.00",
      "superior": null,
      "indent": "3",
      "description": "Coated or plated with precious metal",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7324.21.5000",
      "rawHtsCode": "7324.21.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7324.29.0000",
      "rawHtsCode": "7324.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "7324.90.0000",
      "rawHtsCode": "7324.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other, including parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7325",
      "rawHtsCode": "7325",
      "superior": null,
      "indent": "0",
      "description": "Other cast articles of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7325.10.00",
      "rawHtsCode": "7325.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of nonmalleable cast iron",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7325.10.0010",
      "rawHtsCode": "7325.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Manhole covers, rings and frames",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7325.10.0020",
      "rawHtsCode": "7325.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Catch basins, grates and frames",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7325.10.0025",
      "rawHtsCode": "7325.10.00.25",
      "superior": null,
      "indent": "2",
      "description": "Cleanout covers and frames",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7325.10.0030",
      "rawHtsCode": "7325.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Valve and service boxes",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7325.10.0035",
      "rawHtsCode": "7325.10.00.35",
      "superior": null,
      "indent": "2",
      "description": "Meter boxes",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7325.10.0080",
      "rawHtsCode": "7325.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7325.91.0000",
      "rawHtsCode": "7325.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Grinding balls and similar articles for mills",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7325.99",
      "rawHtsCode": "7325.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7325.99.1000",
      "rawHtsCode": "7325.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of cast iron",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7325.99.5000",
      "rawHtsCode": "7325.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7326",
      "rawHtsCode": "7326",
      "superior": null,
      "indent": "0",
      "description": "Other articles of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.11.0000",
      "rawHtsCode": "7326.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Grinding balls and similar articles for mills",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7326.19.00",
      "rawHtsCode": "7326.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7326.19.0010",
      "rawHtsCode": "7326.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Forged",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.19.0080",
      "rawHtsCode": "7326.19.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.20.00",
      "rawHtsCode": "7326.20.00",
      "superior": null,
      "indent": "1",
      "description": "Articles of iron or steel wire",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7326.20.0010",
      "rawHtsCode": "7326.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Belts and belting",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.20.0020",
      "rawHtsCode": "7326.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Garment hangers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.20.0030",
      "rawHtsCode": "7326.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Sod staples, U staples, irrigation staples, ground staples, and ground pins",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.20.0040",
      "rawHtsCode": "7326.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Double loop bar ties and double loop wire ties",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.20.0055",
      "rawHtsCode": "7326.20.00.55",
      "superior": null,
      "indent": "2",
      "description": "Paint roller frames",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.20.0090",
      "rawHtsCode": "7326.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.90",
      "rawHtsCode": "7326.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.90.1000",
      "rawHtsCode": "7326.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of tinplate",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7326.90.2500",
      "rawHtsCode": "7326.90.25.00",
      "superior": null,
      "indent": "3",
      "description": "Cable or inner wire for caliper and cantilever brakes and casing therefor, whether or not cut to length",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7326.90.3500",
      "rawHtsCode": "7326.90.35.00",
      "superior": null,
      "indent": "3",
      "description": "Containers of a kind normally carried on the person, in the pocket or in the handbag",
      "units": [
        "doz."
      ],
      "generalRate": "7.8%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7326.90.4500",
      "rawHtsCode": "7326.90.45.00",
      "superior": null,
      "indent": "3",
      "description": "Horse and mule shoes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7326.90.6000",
      "rawHtsCode": "7326.90.60.00",
      "superior": null,
      "indent": "4",
      "description": "Coated or plated with precious metal",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "8.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7326.90.86",
      "rawHtsCode": "7326.90.86",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7326.90.8605",
      "rawHtsCode": "7326.90.86.05",
      "superior": null,
      "indent": "5",
      "description": "Rods for electrical grounding",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.90.8610",
      "rawHtsCode": "7326.90.86.10",
      "superior": null,
      "indent": "5",
      "description": "Laminated goods consisting of two or more flat-rolled sheets of iron or steel held together with an adhesive or having a core of non-metallic material",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.90.8630",
      "rawHtsCode": "7326.90.86.30",
      "superior": null,
      "indent": "5",
      "description": "Hangers and similar supports for tubes and pipes",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.90.8635",
      "rawHtsCode": "7326.90.86.35",
      "superior": null,
      "indent": "5",
      "description": "Fence posts, studded with corrugations, knobs, studs, notches or similar protrusions, with or without anchor plates",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.90.8645",
      "rawHtsCode": "7326.90.86.45",
      "superior": null,
      "indent": "5",
      "description": "Barbed tape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.90.8660",
      "rawHtsCode": "7326.90.86.60",
      "superior": null,
      "indent": "5",
      "description": "Ladders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.90.8675",
      "rawHtsCode": "7326.90.86.75",
      "superior": null,
      "indent": "5",
      "description": "Paint roller frames (other than of iron or steel wire)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.90.8676",
      "rawHtsCode": "7326.90.86.76",
      "superior": null,
      "indent": "5",
      "description": "Metal handles for brooms, mops, paint applicators and similar products",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.90.8677",
      "rawHtsCode": "7326.90.86.77",
      "superior": null,
      "indent": "5",
      "description": "Burial caskets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7326.90.8688",
      "rawHtsCode": "7326.90.86.88",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "7401.00.0000",
      "rawHtsCode": "7401.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Copper mattes; cement copper (precipitated copper)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7402.00.0000",
      "rawHtsCode": "7402.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Unrefined copper; copper anodes for electrolytic refining",
      "units": [
        "kg",
        "Cu kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7403",
      "rawHtsCode": "7403",
      "superior": null,
      "indent": "0",
      "description": "Refined copper and copper alloys, unwrought (other than master alloys of heading 7405):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7403.11.0000",
      "rawHtsCode": "7403.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cathodes and sections of cathodes",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7403.12.0000",
      "rawHtsCode": "7403.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Wire bars",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7403.13.0000",
      "rawHtsCode": "7403.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Billets",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7403.19.0000",
      "rawHtsCode": "7403.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7403.21.0000",
      "rawHtsCode": "7403.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Copper-zinc base alloys (brass)",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7403.22.0000",
      "rawHtsCode": "7403.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Copper-tin base alloys (bronze)",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7403.29.01",
      "rawHtsCode": "7403.29.01",
      "superior": null,
      "indent": "2",
      "description": "Other copper alloys",
      "units": [],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7403.29.0110",
      "rawHtsCode": "7403.29.01.10",
      "superior": null,
      "indent": "3",
      "description": "Copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7403.29.0180",
      "rawHtsCode": "7403.29.01.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7404.00",
      "rawHtsCode": "7404.00",
      "superior": null,
      "indent": "0",
      "description": "Copper waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7404.00.30",
      "rawHtsCode": "7404.00.30",
      "superior": null,
      "indent": "1",
      "description": "Spent anodes; waste and scrap with a copper content of less than 94 percent by weight",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7404.00.3020",
      "rawHtsCode": "7404.00.30.20",
      "superior": null,
      "indent": "2",
      "description": "Of refined copper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7404.00.3045",
      "rawHtsCode": "7404.00.30.45",
      "superior": null,
      "indent": "4",
      "description": "Containing more than 0.3 percent of lead",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7404.00.3055",
      "rawHtsCode": "7404.00.30.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7404.00.3065",
      "rawHtsCode": "7404.00.30.65",
      "superior": null,
      "indent": "3",
      "description": "Of copper-tin base alloys (bronze)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7404.00.3090",
      "rawHtsCode": "7404.00.30.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7404.00.60",
      "rawHtsCode": "7404.00.60",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7404.00.6020",
      "rawHtsCode": "7404.00.60.20",
      "superior": null,
      "indent": "2",
      "description": "Of refined copper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7404.00.6045",
      "rawHtsCode": "7404.00.60.45",
      "superior": null,
      "indent": "4",
      "description": "Containing more than 0.3 percent of lead",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7404.00.6055",
      "rawHtsCode": "7404.00.60.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7404.00.6065",
      "rawHtsCode": "7404.00.60.65",
      "superior": null,
      "indent": "3",
      "description": "Of copper-tin base alloys (bronze)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7404.00.6090",
      "rawHtsCode": "7404.00.60.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7405.00",
      "rawHtsCode": "7405.00",
      "superior": null,
      "indent": "0",
      "description": "Master alloys of copper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7405.00.1000",
      "rawHtsCode": "7405.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Containing by weight 5 percent or more but not more than 15 percent of phosphorus",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "12%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7405.00.60",
      "rawHtsCode": "7405.00.60",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7405.00.6030",
      "rawHtsCode": "7405.00.60.30",
      "superior": null,
      "indent": "2",
      "description": "Beryllium copper master alloy",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7405.00.6050",
      "rawHtsCode": "7405.00.60.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7406",
      "rawHtsCode": "7406",
      "superior": null,
      "indent": "0",
      "description": "Copper powders and flakes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7406.10.0000",
      "rawHtsCode": "7406.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Powders of non-lamellar structure",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7406.20.0000",
      "rawHtsCode": "7406.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Powders of lamellar structure; flakes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "12%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7407",
      "rawHtsCode": "7407",
      "superior": null,
      "indent": "0",
      "description": "Copper bars, rods and profiles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7407.10",
      "rawHtsCode": "7407.10",
      "superior": null,
      "indent": "1",
      "description": "Of refined copper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7407.10.1500",
      "rawHtsCode": "7407.10.15.00",
      "superior": null,
      "indent": "3",
      "description": "Hollow profiles",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7407.10.3000",
      "rawHtsCode": "7407.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7407.10.50",
      "rawHtsCode": "7407.10.50",
      "superior": null,
      "indent": "2",
      "description": "Bars and rods",
      "units": [],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7407.10.5010",
      "rawHtsCode": "7407.10.50.10",
      "superior": null,
      "indent": "3",
      "description": "Having a rectangular cross section",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7407.10.5050",
      "rawHtsCode": "7407.10.50.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7407.21",
      "rawHtsCode": "7407.21",
      "superior": null,
      "indent": "2",
      "description": "Of copper-zinc base alloys (brass):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7407.21.1500",
      "rawHtsCode": "7407.21.15.00",
      "superior": null,
      "indent": "4",
      "description": "Hollow profiles",
      "units": [
        "kg"
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7407.21.3000",
      "rawHtsCode": "7407.21.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "17%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7407.21.5000",
      "rawHtsCode": "7407.21.50.00",
      "superior": null,
      "indent": "4",
      "description": "Low fuming brazing rods",
      "units": [
        "kg"
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7407.21.7000",
      "rawHtsCode": "7407.21.70.00",
      "superior": null,
      "indent": "5",
      "description": "Having a rectangular cross section",
      "units": [
        "kg"
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7407.21.9000",
      "rawHtsCode": "7407.21.90.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7407.29",
      "rawHtsCode": "7407.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7407.29.16",
      "rawHtsCode": "7407.29.16",
      "superior": null,
      "indent": "4",
      "description": "Hollow",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7407.29.1610",
      "rawHtsCode": "7407.29.16.10",
      "superior": null,
      "indent": "5",
      "description": "Of copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7407.29.1680",
      "rawHtsCode": "7407.29.16.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7407.29.3400",
      "rawHtsCode": "7407.29.34.00",
      "superior": null,
      "indent": "5",
      "description": "Of copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver)",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7407.29.3800",
      "rawHtsCode": "7407.29.38.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7407.29.4000",
      "rawHtsCode": "7407.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "Bars and rods of copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver)",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7407.29.5000",
      "rawHtsCode": "7407.29.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other bars and rods",
      "units": [
        "kg"
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7408",
      "rawHtsCode": "7408",
      "superior": null,
      "indent": "0",
      "description": "Copper wire:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7408.11",
      "rawHtsCode": "7408.11",
      "superior": null,
      "indent": "2",
      "description": "Of which the maximum cross-sectional dimension exceeds 6 mm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7408.11.3000",
      "rawHtsCode": "7408.11.30.00",
      "superior": null,
      "indent": "3",
      "description": "With a maximum cross-sectional dimension over 9.5 mm",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7408.11.6000",
      "rawHtsCode": "7408.11.60.00",
      "superior": null,
      "indent": "3",
      "description": "With a maximum cross-sectional dimension over 6 mm but not over 9.5 mm",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7408.19.00",
      "rawHtsCode": "7408.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7408.19.0030",
      "rawHtsCode": "7408.19.00.30",
      "superior": null,
      "indent": "3",
      "description": "With a maximum cross-sectional dimension of <il>3 mm</il> or less",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7408.19.0060",
      "rawHtsCode": "7408.19.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7408.21.0000",
      "rawHtsCode": "7408.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of copper-zinc base alloys (brass)",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7408.22",
      "rawHtsCode": "7408.22",
      "superior": null,
      "indent": "2",
      "description": "Of copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7408.22.1000",
      "rawHtsCode": "7408.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Coated or plated with metal",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7408.22.5000",
      "rawHtsCode": "7408.22.50.00",
      "superior": null,
      "indent": "3",
      "description": "Not coated or plated with metal",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7408.29",
      "rawHtsCode": "7408.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7408.29.1000",
      "rawHtsCode": "7408.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Coated or plated with metal",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7408.29.5000",
      "rawHtsCode": "7408.29.50.00",
      "superior": null,
      "indent": "3",
      "description": "Not coated or plated with metal",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "28%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409",
      "rawHtsCode": "7409",
      "superior": null,
      "indent": "0",
      "description": "Copper plates, sheets and strip, of a thickness exceeding <il>0.15 mm</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.11",
      "rawHtsCode": "7409.11",
      "superior": null,
      "indent": "2",
      "description": "In coils:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.11.1000",
      "rawHtsCode": "7409.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness of 5 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "38%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.11.50",
      "rawHtsCode": "7409.11.50",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness of less than 5 mm",
      "units": [],
      "generalRate": "1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.11.5010",
      "rawHtsCode": "7409.11.50.10",
      "superior": null,
      "indent": "4",
      "description": "Of a width of 500 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.11.5050",
      "rawHtsCode": "7409.11.50.50",
      "superior": null,
      "indent": "4",
      "description": "Of a width of less than 500 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.19",
      "rawHtsCode": "7409.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.19.1000",
      "rawHtsCode": "7409.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness of 5 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.19.5000",
      "rawHtsCode": "7409.19.50.00",
      "superior": null,
      "indent": "4",
      "description": "Of a width of 500 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.19.9000",
      "rawHtsCode": "7409.19.90.00",
      "superior": null,
      "indent": "4",
      "description": "Of a width of less than 500 mm",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.21.00",
      "rawHtsCode": "7409.21.00",
      "superior": null,
      "indent": "2",
      "description": "In coils",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.21.0010",
      "rawHtsCode": "7409.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness of 5 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.21.0050",
      "rawHtsCode": "7409.21.00.50",
      "superior": null,
      "indent": "4",
      "description": "Of a width of 500 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.21.0075",
      "rawHtsCode": "7409.21.00.75",
      "superior": null,
      "indent": "5",
      "description": "Of a thickness less than 1.6 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.21.0090",
      "rawHtsCode": "7409.21.00.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.29.00",
      "rawHtsCode": "7409.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.29.0010",
      "rawHtsCode": "7409.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness of 5 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.29.0050",
      "rawHtsCode": "7409.29.00.50",
      "superior": null,
      "indent": "4",
      "description": "Of a width of 500 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.29.0075",
      "rawHtsCode": "7409.29.00.75",
      "superior": null,
      "indent": "5",
      "description": "Of a thickness less than 1.6 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.29.0090",
      "rawHtsCode": "7409.29.00.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.31",
      "rawHtsCode": "7409.31",
      "superior": null,
      "indent": "2",
      "description": "In coils:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.31.1000",
      "rawHtsCode": "7409.31.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness of 5 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.31.5000",
      "rawHtsCode": "7409.31.50.00",
      "superior": null,
      "indent": "4",
      "description": "Of a width of 500 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.31.9000",
      "rawHtsCode": "7409.31.90.00",
      "superior": null,
      "indent": "4",
      "description": "Of a width of less than 500 mm",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.39",
      "rawHtsCode": "7409.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.39.10",
      "rawHtsCode": "7409.39.10",
      "superior": null,
      "indent": "3",
      "description": "Of a thickness of 5 mm or more",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.39.1030",
      "rawHtsCode": "7409.39.10.30",
      "superior": null,
      "indent": "4",
      "description": "Of phosphor bronze",
      "units": [
        "kg",
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.39.1060",
      "rawHtsCode": "7409.39.10.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.39.5000",
      "rawHtsCode": "7409.39.50.00",
      "superior": null,
      "indent": "4",
      "description": "Of a width of 500 mm or more",
      "units": [
        "kg"
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.39.90",
      "rawHtsCode": "7409.39.90",
      "superior": null,
      "indent": "4",
      "description": "Of a width of less than 500 mm",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.39.9030",
      "rawHtsCode": "7409.39.90.30",
      "superior": null,
      "indent": "5",
      "description": "Of phosphor bronze",
      "units": [
        "kg",
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.39.9060",
      "rawHtsCode": "7409.39.90.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.40.0000",
      "rawHtsCode": "7409.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of copper-nickel base alloys (cupro-nickel) or copper- nickel-zinc base alloys (nickel silver)",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "48%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.90",
      "rawHtsCode": "7409.90",
      "superior": null,
      "indent": "1",
      "description": "Of other copper alloys:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.90.10",
      "rawHtsCode": "7409.90.10",
      "superior": null,
      "indent": "2",
      "description": "Of a thickness of 5 mm or more",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.90.1030",
      "rawHtsCode": "7409.90.10.30",
      "superior": null,
      "indent": "3",
      "description": "Of beryllium copper",
      "units": [
        "kg",
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.90.1060",
      "rawHtsCode": "7409.90.10.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.90.50",
      "rawHtsCode": "7409.90.50",
      "superior": null,
      "indent": "3",
      "description": "Of a width of 500 mm or more",
      "units": [],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.90.5030",
      "rawHtsCode": "7409.90.50.30",
      "superior": null,
      "indent": "4",
      "description": "Of beryllium copper",
      "units": [
        "kg",
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.90.5060",
      "rawHtsCode": "7409.90.50.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.90.90",
      "rawHtsCode": "7409.90.90",
      "superior": null,
      "indent": "3",
      "description": "Of a width of less than 500 mm",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7409.90.9030",
      "rawHtsCode": "7409.90.90.30",
      "superior": null,
      "indent": "4",
      "description": "Of beryllium copper",
      "units": [
        "kg",
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7409.90.9060",
      "rawHtsCode": "7409.90.90.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "Cu kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7410",
      "rawHtsCode": "7410",
      "superior": null,
      "indent": "0",
      "description": "Copper foil (whether or not printed or backed with paper, paperboard, plastics or similar backing materials) of a thickness (excluding any backing) not exceeding 0.15 mm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7410.11.0000",
      "rawHtsCode": "7410.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of refined copper",
      "units": [
        "kg"
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7410.12.00",
      "rawHtsCode": "7410.12.00",
      "superior": null,
      "indent": "2",
      "description": "Of copper alloys",
      "units": [],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7410.12.0030",
      "rawHtsCode": "7410.12.00.30",
      "superior": null,
      "indent": "3",
      "description": "Of copper-zinc base alloys (brass)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7410.12.0060",
      "rawHtsCode": "7410.12.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7410.21",
      "rawHtsCode": "7410.21",
      "superior": null,
      "indent": "2",
      "description": "Of refined copper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7410.21.30",
      "rawHtsCode": "7410.21.30",
      "superior": null,
      "indent": "3",
      "description": "Copper clad laminates",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7410.21.3020",
      "rawHtsCode": "7410.21.30.20",
      "superior": null,
      "indent": "5",
      "description": "Having copper on one side only",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7410.21.3040",
      "rawHtsCode": "7410.21.30.40",
      "superior": null,
      "indent": "5",
      "description": "Having copper on both sides",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7410.21.3060",
      "rawHtsCode": "7410.21.30.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7410.21.6000",
      "rawHtsCode": "7410.21.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7410.22.0000",
      "rawHtsCode": "7410.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of copper alloys",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7411",
      "rawHtsCode": "7411",
      "superior": null,
      "indent": "0",
      "description": "Copper tubes and pipes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7411.10",
      "rawHtsCode": "7411.10",
      "superior": null,
      "indent": "1",
      "description": "Of refined copper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7411.10.10",
      "rawHtsCode": "7411.10.10",
      "superior": null,
      "indent": "2",
      "description": "Seamless",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7411.10.1030",
      "rawHtsCode": "7411.10.10.30",
      "superior": null,
      "indent": "3",
      "description": "Having an outside diameter of 6 mm or more but not exceeding 16 mm, in coils on spools",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7411.10.1090",
      "rawHtsCode": "7411.10.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7411.10.5000",
      "rawHtsCode": "7411.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "47%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7411.21",
      "rawHtsCode": "7411.21",
      "superior": null,
      "indent": "2",
      "description": "Of copper-zinc base alloys (brass):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7411.21.1000",
      "rawHtsCode": "7411.21.10.00",
      "superior": null,
      "indent": "3",
      "description": "Seamless",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7411.21.5000",
      "rawHtsCode": "7411.21.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7411.22.0000",
      "rawHtsCode": "7411.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel-silver)",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "47%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7411.29",
      "rawHtsCode": "7411.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7411.29.1000",
      "rawHtsCode": "7411.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Seamless",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7411.29.5000",
      "rawHtsCode": "7411.29.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7412",
      "rawHtsCode": "7412",
      "superior": null,
      "indent": "0",
      "description": "Copper tube or pipe fittings (for example couplings, elbows, sleeves):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7412.10.0000",
      "rawHtsCode": "7412.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of refined copper",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7412.20.00",
      "rawHtsCode": "7412.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of copper alloys",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "49%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7412.20.0015",
      "rawHtsCode": "7412.20.00.15",
      "superior": null,
      "indent": "2",
      "description": "For brake hoses for vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or headings 8702, 8703, 8704, or 8705",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7412.20.0025",
      "rawHtsCode": "7412.20.00.25",
      "superior": null,
      "indent": "5",
      "description": "Nipples",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7412.20.0035",
      "rawHtsCode": "7412.20.00.35",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7412.20.0045",
      "rawHtsCode": "7412.20.00.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7412.20.0065",
      "rawHtsCode": "7412.20.00.65",
      "superior": null,
      "indent": "5",
      "description": "Nipples",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7412.20.0085",
      "rawHtsCode": "7412.20.00.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7412.20.0090",
      "rawHtsCode": "7412.20.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7413.00",
      "rawHtsCode": "7413.00",
      "superior": null,
      "indent": "0",
      "description": "Stranded wire, cables, plaited bands and the like, including slings and similar articles, of copper, not electrically insulated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7413.00.1000",
      "rawHtsCode": "7413.00.10.00",
      "superior": null,
      "indent": "2",
      "description": "Stranded wire",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7413.00.5000",
      "rawHtsCode": "7413.00.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7413.00.9000",
      "rawHtsCode": "7413.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Fitted with fittings or made up into articles",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7415",
      "rawHtsCode": "7415",
      "superior": null,
      "indent": "0",
      "description": "Nails, tacks, drawing pins, staples (other than those of heading 8305) and similar articles, of copper or of iron or steel with heads of copper; screws, bolts, nuts, screw hooks, rivets, cotters, cotter pins, washers (including spring washers) and similar articles, of copper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7415.10.0000",
      "rawHtsCode": "7415.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Nails and tacks, drawing pins, staples and similar articles",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7415.21.0000",
      "rawHtsCode": "7415.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Washers (including spring washers)",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7415.29.0000",
      "rawHtsCode": "7415.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7415.33",
      "rawHtsCode": "7415.33",
      "superior": null,
      "indent": "2",
      "description": "Screws, bolts and nuts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7415.33.0500",
      "rawHtsCode": "7415.33.05.00",
      "superior": null,
      "indent": "3",
      "description": "Screws for wood",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7415.33.1000",
      "rawHtsCode": "7415.33.10.00",
      "superior": null,
      "indent": "3",
      "description": "Muntz or yellow metal bolts",
      "units": [
        "kg"
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "7%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7415.33.80",
      "rawHtsCode": "7415.33.80",
      "superior": null,
      "indent": "3",
      "description": "Other screws and bolts; nuts",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7415.33.8010",
      "rawHtsCode": "7415.33.80.10",
      "superior": null,
      "indent": "4",
      "description": "Having shanks, threads or holes 6 mm or more in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7415.33.8050",
      "rawHtsCode": "7415.33.80.50",
      "superior": null,
      "indent": "4",
      "description": "Having shanks, threads or holes less than <il>6 mm</il> in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7415.39.0000",
      "rawHtsCode": "7415.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7418",
      "rawHtsCode": "7418",
      "superior": null,
      "indent": "0",
      "description": "Table, kitchen or other household articles and parts thereof, of copper; pot scourers and scouring or polishing pads, gloves and the like, of copper; sanitary ware and parts thereof, of copper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7418.10.00",
      "rawHtsCode": "7418.10.00",
      "superior": null,
      "indent": "1",
      "description": "Table, kitchen or other household articles and parts thereof; pot scourers and scouring or polishing pads, gloves and the like",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7418.10.0002",
      "rawHtsCode": "7418.10.00.02",
      "superior": null,
      "indent": "3",
      "description": "Of copper-zinc base alloys (brass)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7418.10.0004",
      "rawHtsCode": "7418.10.00.04",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7418.10.0019",
      "rawHtsCode": "7418.10.00.19",
      "superior": null,
      "indent": "3",
      "description": "Coated or plated with precious metals",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7418.10.0021",
      "rawHtsCode": "7418.10.00.21",
      "superior": null,
      "indent": "5",
      "description": "Cooking or heating apparatus of a kind used for domestic purposes, non- electric and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7418.10.0023",
      "rawHtsCode": "7418.10.00.23",
      "superior": null,
      "indent": "5",
      "description": "Cooking and kitchen ware",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7418.10.0025",
      "rawHtsCode": "7418.10.00.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7418.10.0051",
      "rawHtsCode": "7418.10.00.51",
      "superior": null,
      "indent": "5",
      "description": "Cooking or heating apparatus of a kind used for domestic purposes, non- electric and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7418.10.0053",
      "rawHtsCode": "7418.10.00.53",
      "superior": null,
      "indent": "5",
      "description": "Cooking and kitchen ware",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7418.10.0055",
      "rawHtsCode": "7418.10.00.55",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7418.20",
      "rawHtsCode": "7418.20",
      "superior": null,
      "indent": "1",
      "description": "Sanitary ware and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7418.20.1000",
      "rawHtsCode": "7418.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of copper-zinc base alloys (brass)",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7418.20.5000",
      "rawHtsCode": "7418.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7419",
      "rawHtsCode": "7419",
      "superior": null,
      "indent": "0",
      "description": "Other articles of copper:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7419.20.00",
      "rawHtsCode": "7419.20.00",
      "superior": null,
      "indent": "1",
      "description": "Cast, molded, stamped or forged, but not further worked",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7419.20.0010",
      "rawHtsCode": "7419.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Brass plumbing goods, not elsewhere specified or included",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7419.20.0050",
      "rawHtsCode": "7419.20.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7419.80",
      "rawHtsCode": "7419.80",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7419.80.0300",
      "rawHtsCode": "7419.80.03.00",
      "superior": null,
      "indent": "4",
      "description": "Fourdrinier wires, seamed or not seamed, suitable for use in papermaking machines, with 94 or more wires to the lineal centimeter",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7419.80.06",
      "rawHtsCode": "7419.80.06",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7419.80.0660",
      "rawHtsCode": "7419.80.06.60",
      "superior": null,
      "indent": "5",
      "description": "Fourdrinier wires, seamed or not seamed, suitable for use in papermaking machines, with fewer than 94 or more wires to the lineal centimeter",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7419.80.0680",
      "rawHtsCode": "7419.80.06.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "m<sup>2</sup>",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7419.80.0900",
      "rawHtsCode": "7419.80.09.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "43%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7419.80.1500",
      "rawHtsCode": "7419.80.15.00",
      "superior": null,
      "indent": "2",
      "description": "Containers of a kind normally carried on the person, in the pocket or in the handbag",
      "units": [
        "doz."
      ],
      "generalRate": "3%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7419.80.1600",
      "rawHtsCode": "7419.80.16.00",
      "superior": null,
      "indent": "2",
      "description": "Copper springs",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7419.80.1700",
      "rawHtsCode": "7419.80.17.00",
      "superior": null,
      "indent": "2",
      "description": "Chain and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7419.80.3000",
      "rawHtsCode": "7419.80.30.00",
      "superior": null,
      "indent": "3",
      "description": "Coated or plated with precious metal",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7419.80.50",
      "rawHtsCode": "7419.80.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7419.80.5010",
      "rawHtsCode": "7419.80.50.10",
      "superior": null,
      "indent": "4",
      "description": "Brass plumbing goods not elsewhere specified or included",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7419.80.5050",
      "rawHtsCode": "7419.80.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7501",
      "rawHtsCode": "7501",
      "superior": null,
      "indent": "0",
      "description": "Nickel mattes, nickel oxide sinters and other intermediate products of nickel metallurgy:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7501.10.0000",
      "rawHtsCode": "7501.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Nickel mattes",
      "units": [
        "kg",
        "Ni kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7501.20.0000",
      "rawHtsCode": "7501.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Nickel oxide sinters and other intermediate products of nickel metallurgy",
      "units": [
        "kg",
        "Ni kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7502",
      "rawHtsCode": "7502",
      "superior": null,
      "indent": "0",
      "description": "Unwrought nickel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7502.10.0000",
      "rawHtsCode": "7502.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Nickel, not alloyed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7502.20.0000",
      "rawHtsCode": "7502.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Nickel alloys",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7503.00.0000",
      "rawHtsCode": "7503.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Nickel waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7504.00.00",
      "rawHtsCode": "7504.00.00",
      "superior": null,
      "indent": "0",
      "description": "Nickel powders and flakes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6.6¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "7504.00.0010",
      "rawHtsCode": "7504.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Powders",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7504.00.0050",
      "rawHtsCode": "7504.00.00.50",
      "superior": null,
      "indent": "1",
      "description": "Flakes",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7505",
      "rawHtsCode": "7505",
      "superior": null,
      "indent": "0",
      "description": "Nickel bars, rods, profiles and wire:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7505.11",
      "rawHtsCode": "7505.11",
      "superior": null,
      "indent": "2",
      "description": "Of nickel, not alloyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7505.11.1000",
      "rawHtsCode": "7505.11.10.00",
      "superior": null,
      "indent": "4",
      "description": "Cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7505.11.3000",
      "rawHtsCode": "7505.11.30.00",
      "superior": null,
      "indent": "4",
      "description": "Not cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7505.11.5000",
      "rawHtsCode": "7505.11.50.00",
      "superior": null,
      "indent": "3",
      "description": "Profiles",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7505.12",
      "rawHtsCode": "7505.12",
      "superior": null,
      "indent": "2",
      "description": "Of nickel alloys:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7505.12.1000",
      "rawHtsCode": "7505.12.10.00",
      "superior": null,
      "indent": "4",
      "description": "Cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7505.12.3000",
      "rawHtsCode": "7505.12.30.00",
      "superior": null,
      "indent": "4",
      "description": "Not cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7505.12.5000",
      "rawHtsCode": "7505.12.50.00",
      "superior": null,
      "indent": "3",
      "description": "Profiles",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7505.21",
      "rawHtsCode": "7505.21",
      "superior": null,
      "indent": "2",
      "description": "Of nickel, not alloyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7505.21.1000",
      "rawHtsCode": "7505.21.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7505.21.5000",
      "rawHtsCode": "7505.21.50.00",
      "superior": null,
      "indent": "3",
      "description": "Not cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7505.22",
      "rawHtsCode": "7505.22",
      "superior": null,
      "indent": "2",
      "description": "Of nickel alloys:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7505.22.1000",
      "rawHtsCode": "7505.22.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7505.22.5000",
      "rawHtsCode": "7505.22.50.00",
      "superior": null,
      "indent": "3",
      "description": "Not cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7506",
      "rawHtsCode": "7506",
      "superior": null,
      "indent": "0",
      "description": "Nickel plates, sheets, strip and foil:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7506.10",
      "rawHtsCode": "7506.10",
      "superior": null,
      "indent": "1",
      "description": "Of nickel, not alloyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7506.10.0500",
      "rawHtsCode": "7506.10.05.00",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 0.15 mm in thickness",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7506.10.1000",
      "rawHtsCode": "7506.10.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7506.10.3000",
      "rawHtsCode": "7506.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Not cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7506.20",
      "rawHtsCode": "7506.20",
      "superior": null,
      "indent": "1",
      "description": "Of nickel alloys:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7506.20.0500",
      "rawHtsCode": "7506.20.05.00",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 0.15 mm in thickness",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7506.20.1000",
      "rawHtsCode": "7506.20.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7506.20.3000",
      "rawHtsCode": "7506.20.30.00",
      "superior": null,
      "indent": "3",
      "description": "Not cold-formed",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7507",
      "rawHtsCode": "7507",
      "superior": null,
      "indent": "0",
      "description": "Nickel tubes, pipes and tube or pipe fittings (for example, couplings, elbows, sleeves):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7507.11.0000",
      "rawHtsCode": "7507.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of nickel, not alloyed",
      "units": [
        "kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7507.12.0000",
      "rawHtsCode": "7507.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of nickel alloys",
      "units": [
        "kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7507.20.0000",
      "rawHtsCode": "7507.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tube or pipe fittings",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7508",
      "rawHtsCode": "7508",
      "superior": null,
      "indent": "0",
      "description": "Other articles of nickel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7508.10.0000",
      "rawHtsCode": "7508.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cloth, grill and netting, of nickel wire",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7508.90",
      "rawHtsCode": "7508.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7508.90.1000",
      "rawHtsCode": "7508.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Stranded wire",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7508.90.5000",
      "rawHtsCode": "7508.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7601",
      "rawHtsCode": "7601",
      "superior": null,
      "indent": "0",
      "description": "Unwrought aluminum:<nl/>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7601.10",
      "rawHtsCode": "7601.10",
      "superior": null,
      "indent": "1",
      "description": "Aluminum, not alloyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7601.10.3000",
      "rawHtsCode": "7601.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of uniform cross section throughout its length, the least cross-sectional dimension of which is not greater than <il>9.5 mm</il>, in coils",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "18.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7601.10.60",
      "rawHtsCode": "7601.10.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7601.10.6040",
      "rawHtsCode": "7601.10.60.40",
      "superior": null,
      "indent": "3",
      "description": "Of 99.9 percent aluminum or greater",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7601.10.6045",
      "rawHtsCode": "7601.10.60.45",
      "superior": null,
      "indent": "3",
      "description": "Of greater than 99.8 percent but less than 99.9 percent",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7601.10.6090",
      "rawHtsCode": "7601.10.60.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7601.20",
      "rawHtsCode": "7601.20",
      "superior": null,
      "indent": "1",
      "description": "Aluminum alloys:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7601.20.3000",
      "rawHtsCode": "7601.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of uniform cross section throughout its length, the least cross-sectional dimension of which is not greater than 9.5 mm, in coils",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "18.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7601.20.6000",
      "rawHtsCode": "7601.20.60.00",
      "superior": null,
      "indent": "3",
      "description": "Containing 25 percent or more by weight of silicon",
      "units": [
        "kg"
      ],
      "generalRate": "2.1%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7601.20.90",
      "rawHtsCode": "7601.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "7601.20.9030",
      "rawHtsCode": "7601.20.90.30",
      "superior": null,
      "indent": "4",
      "description": "Aluminum vanadium master alloy",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7601.20.9045",
      "rawHtsCode": "7601.20.90.45",
      "superior": null,
      "indent": "5",
      "description": "Of uniform circular cross section throughout its length, the foregoing comprised of billets, not in coils",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7601.20.9060",
      "rawHtsCode": "7601.20.90.60",
      "superior": null,
      "indent": "5",
      "description": "Other, containing 0.03 percent or more by weight of lead (secondary aluminum)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7601.20.9075",
      "rawHtsCode": "7601.20.90.75",
      "superior": null,
      "indent": "6",
      "description": "Remelt scrap ingot",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7601.20.9080",
      "rawHtsCode": "7601.20.90.80",
      "superior": null,
      "indent": "6",
      "description": "Sheet ingot (slab) of a kind described in statistical note 3 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7601.20.9085",
      "rawHtsCode": "7601.20.90.85",
      "superior": null,
      "indent": "6",
      "description": "Foundry ingot of a kind described in statistical note 4 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7601.20.9095",
      "rawHtsCode": "7601.20.90.95",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7602.00.00",
      "rawHtsCode": "7602.00.00",
      "superior": null,
      "indent": "0",
      "description": "Aluminum waste and scrap",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7602.00.0035",
      "rawHtsCode": "7602.00.00.35",
      "superior": null,
      "indent": "1",
      "description": "Recyclable used beverage containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7602.00.0045",
      "rawHtsCode": "7602.00.00.45",
      "superior": null,
      "indent": "1",
      "description": "Recyclable aluminum auto and truck wheels",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7602.00.0055",
      "rawHtsCode": "7602.00.00.55",
      "superior": null,
      "indent": "1",
      "description": "Recyclable aluminum from industrial processes, including turnings, borings, shavings, filings, clippings and chips",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7602.00.0065",
      "rawHtsCode": "7602.00.00.65",
      "superior": null,
      "indent": "1",
      "description": "Other recyclable aluminum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7602.00.0075",
      "rawHtsCode": "7602.00.00.75",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7603",
      "rawHtsCode": "7603",
      "superior": null,
      "indent": "0",
      "description": "Aluminum powders and flakes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7603.10.0000",
      "rawHtsCode": "7603.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Powders of non-lamellar structure",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7603.20.0000",
      "rawHtsCode": "7603.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Powders of lamellar structure; flakes",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7604",
      "rawHtsCode": "7604",
      "superior": null,
      "indent": "0",
      "description": "Aluminum bars, rods and profiles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7604.10",
      "rawHtsCode": "7604.10",
      "superior": null,
      "indent": "1",
      "description": "Of aluminum, not alloyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7604.10.1000",
      "rawHtsCode": "7604.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Profiles",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7604.10.3000",
      "rawHtsCode": "7604.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Having a round cross section",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7604.10.5000",
      "rawHtsCode": "7604.10.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7604.21.00",
      "rawHtsCode": "7604.21.00",
      "superior": null,
      "indent": "2",
      "description": "Hollow profiles",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "15.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7604.21.0010",
      "rawHtsCode": "7604.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Heat-treatable industrial alloys of a kind described in statistical note 7 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7604.21.0090",
      "rawHtsCode": "7604.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7604.29",
      "rawHtsCode": "7604.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7604.29.10",
      "rawHtsCode": "7604.29.10",
      "superior": null,
      "indent": "3",
      "description": "Other profiles",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7604.29.1010",
      "rawHtsCode": "7604.29.10.10",
      "superior": null,
      "indent": "4",
      "description": "Heat-treatable industrial alloys of a kind described in statistical note 7 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7604.29.1090",
      "rawHtsCode": "7604.29.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7604.29.30",
      "rawHtsCode": "7604.29.30",
      "superior": null,
      "indent": "4",
      "description": "Having a round cross section",
      "units": [],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7604.29.3030",
      "rawHtsCode": "7604.29.30.30",
      "superior": null,
      "indent": "5",
      "description": "High-strength heat-treatable alloys of a kind described in statistical note 6 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7604.29.3060",
      "rawHtsCode": "7604.29.30.60",
      "superior": null,
      "indent": "5",
      "description": "Heat-treatable industrial alloys of a kind described in statistical note 7 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7604.29.3090",
      "rawHtsCode": "7604.29.30.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7604.29.50",
      "rawHtsCode": "7604.29.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7604.29.5020",
      "rawHtsCode": "7604.29.50.20",
      "superior": null,
      "indent": "5",
      "description": "High-strength heat-treatable alloys of a kind described in statistical note 6 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7604.29.5050",
      "rawHtsCode": "7604.29.50.50",
      "superior": null,
      "indent": "5",
      "description": "Heat-treatable industrial alloys of a kind described in statistical note 7 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7604.29.5090",
      "rawHtsCode": "7604.29.50.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7605",
      "rawHtsCode": "7605",
      "superior": null,
      "indent": "0",
      "description": "Aluminum wire:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7605.11.0000",
      "rawHtsCode": "7605.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of which the maximum cross-sectional dimension exceeds <il>7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7605.19.0000",
      "rawHtsCode": "7605.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7605.21.0000",
      "rawHtsCode": "7605.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of which the maximum cross-sectional dimension exceeds <il>7 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7605.29.0000",
      "rawHtsCode": "7605.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7606",
      "rawHtsCode": "7606",
      "superior": null,
      "indent": "0",
      "description": "Aluminum plates, sheets and strip, of a thickness exceeding <il>0.2 mm</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.11",
      "rawHtsCode": "7606.11",
      "superior": null,
      "indent": "2",
      "description": "Of aluminum, not alloyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.11.30",
      "rawHtsCode": "7606.11.30",
      "superior": null,
      "indent": "3",
      "description": "Not clad",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7606.11.3030",
      "rawHtsCode": "7606.11.30.30",
      "superior": null,
      "indent": "4",
      "description": "With a thickness of more than 6.3 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.11.3060",
      "rawHtsCode": "7606.11.30.60",
      "superior": null,
      "indent": "4",
      "description": "With a thickness of 6.3 mm or less",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.11.6000",
      "rawHtsCode": "7606.11.60.00",
      "superior": null,
      "indent": "3",
      "description": "Clad",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7606.12",
      "rawHtsCode": "7606.12",
      "superior": null,
      "indent": "2",
      "description": "Of aluminum alloys:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.12.30",
      "rawHtsCode": "7606.12.30",
      "superior": null,
      "indent": "3",
      "description": "Not clad",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7606.12.3015",
      "rawHtsCode": "7606.12.30.15",
      "superior": null,
      "indent": "5",
      "description": "High-strength heat-treatable alloys of a kind described in statistical note 6 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.12.3025",
      "rawHtsCode": "7606.12.30.25",
      "superior": null,
      "indent": "5",
      "description": "Heat-treatable industrial alloys of a kind described in statistical note 7 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.12.3035",
      "rawHtsCode": "7606.12.30.35",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.12.3045",
      "rawHtsCode": "7606.12.30.45",
      "superior": null,
      "indent": "6",
      "description": "Body stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.12.3055",
      "rawHtsCode": "7606.12.30.55",
      "superior": null,
      "indent": "6",
      "description": "Lid stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.12.3091",
      "rawHtsCode": "7606.12.30.91",
      "superior": null,
      "indent": "6",
      "description": "Heat-treatable industrial alloys of a kind described in statistical note 7 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.12.3096",
      "rawHtsCode": "7606.12.30.96",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.12.6000",
      "rawHtsCode": "7606.12.60.00",
      "superior": null,
      "indent": "3",
      "description": "Clad",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7606.91",
      "rawHtsCode": "7606.91",
      "superior": null,
      "indent": "2",
      "description": "Of aluminum, not alloyed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.91.30",
      "rawHtsCode": "7606.91.30",
      "superior": null,
      "indent": "3",
      "description": "Not clad",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7606.91.3055",
      "rawHtsCode": "7606.91.30.55",
      "superior": null,
      "indent": "4",
      "description": "With a thickness of more than 6.3 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.91.3095",
      "rawHtsCode": "7606.91.30.95",
      "superior": null,
      "indent": "4",
      "description": "With a thickness of 6.3 mm or less",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.91.60",
      "rawHtsCode": "7606.91.60",
      "superior": null,
      "indent": "3",
      "description": "Clad",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "9.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7606.91.6055",
      "rawHtsCode": "7606.91.60.55",
      "superior": null,
      "indent": "4",
      "description": "With a thickness of more than 6.3 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.91.6095",
      "rawHtsCode": "7606.91.60.95",
      "superior": null,
      "indent": "4",
      "description": "With a thickness of 6.3 mm or less",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.92",
      "rawHtsCode": "7606.92",
      "superior": null,
      "indent": "2",
      "description": "Of aluminum alloys:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.92.30",
      "rawHtsCode": "7606.92.30",
      "superior": null,
      "indent": "3",
      "description": "Not clad",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7606.92.3025",
      "rawHtsCode": "7606.92.30.25",
      "superior": null,
      "indent": "4",
      "description": "With a thickness of more than 6.3 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.92.3035",
      "rawHtsCode": "7606.92.30.35",
      "superior": null,
      "indent": "4",
      "description": "With a thickness of 6.3 mm or less",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.92.60",
      "rawHtsCode": "7606.92.60",
      "superior": null,
      "indent": "3",
      "description": "Clad",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7606.92.6055",
      "rawHtsCode": "7606.92.60.55",
      "superior": null,
      "indent": "5",
      "description": "With a thickness of more than 6.3 mm",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7606.92.6095",
      "rawHtsCode": "7606.92.60.95",
      "superior": null,
      "indent": "5",
      "description": "With a thickness of 6.3 mm or less",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7607",
      "rawHtsCode": "7607",
      "superior": null,
      "indent": "0",
      "description": "Aluminum foil (whether or not printed, or backed with paper, paperboard, plastics or similar backing materials) of a thickness (excluding any backing) not exceeding 0.2 mm:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7607.11",
      "rawHtsCode": "7607.11",
      "superior": null,
      "indent": "2",
      "description": "Rolled but not further worked:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7607.11.3000",
      "rawHtsCode": "7607.11.30.00",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness not exceeding <il>0.01 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7607.11.60",
      "rawHtsCode": "7607.11.60",
      "superior": null,
      "indent": "4",
      "description": "Of a thickness exceeding <il>0.01 mm</il>",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7607.11.6010",
      "rawHtsCode": "7607.11.60.10",
      "superior": null,
      "indent": "5",
      "description": "Boxed aluminum foil weighing not more than 11.3 kg",
      "units": [
        "kg",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7607.11.6090",
      "rawHtsCode": "7607.11.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7607.11.90",
      "rawHtsCode": "7607.11.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7607.11.9030",
      "rawHtsCode": "7607.11.90.30",
      "superior": null,
      "indent": "5",
      "description": "Body stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7607.11.9060",
      "rawHtsCode": "7607.11.90.60",
      "superior": null,
      "indent": "5",
      "description": "Lid stock",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7607.11.9090",
      "rawHtsCode": "7607.11.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7607.19",
      "rawHtsCode": "7607.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7607.19.1000",
      "rawHtsCode": "7607.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Etched capacitor foil",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.           "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7607.19.3000",
      "rawHtsCode": "7607.19.30.00",
      "superior": null,
      "indent": "4",
      "description": "Cut to shape, of a thickness not exceeding <il>0.15 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7607.19.6000",
      "rawHtsCode": "7607.19.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "13.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7607.20",
      "rawHtsCode": "7607.20",
      "superior": null,
      "indent": "1",
      "description": "Backed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7607.20.1000",
      "rawHtsCode": "7607.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Covered or decorated with a character, design, fancy effect or pattern",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "22.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7607.20.5000",
      "rawHtsCode": "7607.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "23%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7608",
      "rawHtsCode": "7608",
      "superior": null,
      "indent": "0",
      "description": "Aluminum tubes and pipes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7608.10.00",
      "rawHtsCode": "7608.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of aluminum, not alloyed",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See additional U.S. note 1 to this chapter. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7608.10.0030",
      "rawHtsCode": "7608.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Seamless",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7608.10.0090",
      "rawHtsCode": "7608.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7608.20.00",
      "rawHtsCode": "7608.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of aluminum alloys",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See additional U.S. note 1 to this chapter. ",
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7608.20.0030",
      "rawHtsCode": "7608.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Seamless",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7608.20.0090",
      "rawHtsCode": "7608.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7609.00.0000",
      "rawHtsCode": "7609.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Aluminum tube or pipe fittings (for example, couplings, elbows, sleeves)",
      "units": [
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7610",
      "rawHtsCode": "7610",
      "superior": null,
      "indent": "0",
      "description": "Aluminum structures (excluding prefabricated buildings of heading 9406) and parts of structures (for example, bridges and bridge-sections, towers, lattice masts, roofs, roofing frameworks, doors and windows and their frames and thresholds for doors, balustrades, pillars and columns); aluminum plates, rods, profiles, tubes and the like, prepared for use in structures:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7610.10.00",
      "rawHtsCode": "7610.10.00",
      "superior": null,
      "indent": "1",
      "description": "Doors, windows and their frames and thresholds for doors",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7610.10.0010",
      "rawHtsCode": "7610.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Windows and their frames",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7610.10.0020",
      "rawHtsCode": "7610.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Thresholds for doors",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7610.10.0030",
      "rawHtsCode": "7610.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7610.90.00",
      "rawHtsCode": "7610.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7610.90.0020",
      "rawHtsCode": "7610.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Sheet-metal roofing, siding, flooring, and roof guttering and drainage equipment",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7610.90.0040",
      "rawHtsCode": "7610.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Architectural and ornamental work",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7610.90.0060",
      "rawHtsCode": "7610.90.00.60",
      "superior": null,
      "indent": "3",
      "description": "Mobile homes",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7610.90.0080",
      "rawHtsCode": "7610.90.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7611.00.00",
      "rawHtsCode": "7611.00.00",
      "superior": null,
      "indent": "0",
      "description": "Aluminum reservoirs, tanks, vats and similar containers, for any material (other than compressed or liquefied gas), of a capacity exceeding 300 liters, whether or not lined or heat insulated, but not fitted with mechanical or thermal equipment",
      "units": [],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7611.00.0030",
      "rawHtsCode": "7611.00.00.30",
      "superior": null,
      "indent": "1",
      "description": "Tanks",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7611.00.0090",
      "rawHtsCode": "7611.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7612",
      "rawHtsCode": "7612",
      "superior": null,
      "indent": "0",
      "description": "Aluminum casks, drums, cans, boxes and similar containers (including rigid or collapsible tubular containers), for any material (other than compressed or liquefied gas), of a capacity not exceeding 300 liters, whether or not lined or heat insulated, but not fitted with mechanical or thermal equipment:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7612.10.0000",
      "rawHtsCode": "7612.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Collapsible tubular containers",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7612.90",
      "rawHtsCode": "7612.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7612.90.10",
      "rawHtsCode": "7612.90.10",
      "superior": null,
      "indent": "2",
      "description": "Of a capacity not exceeding 20 liters",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7612.90.1040",
      "rawHtsCode": "7612.90.10.40",
      "superior": null,
      "indent": "4",
      "description": "With a circular cross section, of a kind used for aerosols",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7612.90.1045",
      "rawHtsCode": "7612.90.10.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7612.90.1060",
      "rawHtsCode": "7612.90.10.60",
      "superior": null,
      "indent": "3",
      "description": "Cans of a capacity exceeding 355 ml but less than 3.8 liters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7612.90.1090",
      "rawHtsCode": "7612.90.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7612.90.5000",
      "rawHtsCode": "7612.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "7613.00.0000",
      "rawHtsCode": "7613.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Aluminum containers for compressed or liquefied gas",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7614",
      "rawHtsCode": "7614",
      "superior": null,
      "indent": "0",
      "description": "Stranded wire, cables, plaited bands and the like, including slings and similar articles, of aluminum, not electrically insulated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7614.10",
      "rawHtsCode": "7614.10",
      "superior": null,
      "indent": "1",
      "description": "With steel core:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7614.10.1000",
      "rawHtsCode": "7614.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Not fitted with fittings and not made up into articles",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7614.10.5000",
      "rawHtsCode": "7614.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Fitted with fittings or made up into articles",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7614.90",
      "rawHtsCode": "7614.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7614.90.20",
      "rawHtsCode": "7614.90.20",
      "superior": null,
      "indent": "3",
      "description": "Electrical conductors",
      "units": [],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7614.90.2030",
      "rawHtsCode": "7614.90.20.30",
      "superior": null,
      "indent": "4",
      "description": "With a cross-sectional area less than 240 mm²",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7614.90.2060",
      "rawHtsCode": "7614.90.20.60",
      "superior": null,
      "indent": "4",
      "description": "With a cross-sectional area greater than or equal to 240 mm²",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7614.90.4000",
      "rawHtsCode": "7614.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7614.90.5000",
      "rawHtsCode": "7614.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Fitted with fittings or made up into articles",
      "units": [
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7615",
      "rawHtsCode": "7615",
      "superior": null,
      "indent": "0",
      "description": "Table, kitchen or other household articles and parts thereof, of aluminum; pot scourers and scouring or polishing pads, gloves and the like, of aluminum; sanitary ware and parts thereof, of aluminum:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7615.10",
      "rawHtsCode": "7615.10",
      "superior": null,
      "indent": "1",
      "description": "Table, kitchen or other household articles and parts thereof; pot scourers and scouring or polishing pads, gloves and the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7615.10.1100",
      "rawHtsCode": "7615.10.11.00",
      "superior": null,
      "indent": "2",
      "description": "Pot scourers and scouring or polishing pads, gloves and the like",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7615.10.20",
      "rawHtsCode": "7615.10.20",
      "superior": null,
      "indent": "5",
      "description": "Cast",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7615.10.2015",
      "rawHtsCode": "7615.10.20.15",
      "superior": null,
      "indent": "6",
      "description": "Bakeware (cookware not suitable for stove top use)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7615.10.2025",
      "rawHtsCode": "7615.10.20.25",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7615.10.30",
      "rawHtsCode": "7615.10.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7615.10.3015",
      "rawHtsCode": "7615.10.30.15",
      "superior": null,
      "indent": "6",
      "description": "Bakeware (cookware not suitable for stove top use)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7615.10.3025",
      "rawHtsCode": "7615.10.30.25",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7615.10.50",
      "rawHtsCode": "7615.10.50",
      "superior": null,
      "indent": "5",
      "description": "Cast",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7615.10.5020",
      "rawHtsCode": "7615.10.50.20",
      "superior": null,
      "indent": "6",
      "description": "Bakeware (cookware not suitable for stove top use)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7615.10.5040",
      "rawHtsCode": "7615.10.50.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7615.10.71",
      "rawHtsCode": "7615.10.71",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7615.10.7125",
      "rawHtsCode": "7615.10.71.25",
      "superior": null,
      "indent": "6",
      "description": "Containers suitable for food preparation, baking, reheating or storage, 0.04 mm or more but not over 0.22 mm in thickness",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7615.10.7130",
      "rawHtsCode": "7615.10.71.30",
      "superior": null,
      "indent": "7",
      "description": "Bakeware (cookware not suitable for stove top use)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7615.10.7155",
      "rawHtsCode": "7615.10.71.55",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7615.10.7180",
      "rawHtsCode": "7615.10.71.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7615.10.9100",
      "rawHtsCode": "7615.10.91.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7615.20.0000",
      "rawHtsCode": "7615.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sanitary ware and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7616",
      "rawHtsCode": "7616",
      "superior": null,
      "indent": "0",
      "description": "Other articles of aluminum:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.10",
      "rawHtsCode": "7616.10",
      "superior": null,
      "indent": "1",
      "description": "Nails, tacks, staples (other than those of heading 8305), screws, bolts, nuts, screw hooks, rivets, cotters, cotter pins, washers and similar articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.10.1000",
      "rawHtsCode": "7616.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Nails, tacks and staples",
      "units": [
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7616.10.3000",
      "rawHtsCode": "7616.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Rivets",
      "units": [
        "kg"
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7616.10.5000",
      "rawHtsCode": "7616.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Cotters and cotter pins",
      "units": [
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7616.10.70",
      "rawHtsCode": "7616.10.70",
      "superior": null,
      "indent": "3",
      "description": "Having shanks, threads or holes over 6 mm in diameter",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.75% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7616.10.7030",
      "rawHtsCode": "7616.10.70.30",
      "superior": null,
      "indent": "4",
      "description": "Threaded fasteners",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.10.7090",
      "rawHtsCode": "7616.10.70.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.10.90",
      "rawHtsCode": "7616.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7616.10.9030",
      "rawHtsCode": "7616.10.90.30",
      "superior": null,
      "indent": "4",
      "description": "Threaded fasteners",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.10.9090",
      "rawHtsCode": "7616.10.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.91.0000",
      "rawHtsCode": "7616.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cloth, grill, netting and fencing, of aluminum wire",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7616.99",
      "rawHtsCode": "7616.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.99.1000",
      "rawHtsCode": "7616.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Luggage frames",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "7616.99.51",
      "rawHtsCode": "7616.99.51",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7616.99.5120",
      "rawHtsCode": "7616.99.51.20",
      "superior": null,
      "indent": "4",
      "description": "Laminated goods consisting of 2 or more flat-rolled sheets of aluminum held together with an adhesive or having a core of non-metallic material",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.99.5130",
      "rawHtsCode": "7616.99.51.30",
      "superior": null,
      "indent": "4",
      "description": "Ladders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.99.5140",
      "rawHtsCode": "7616.99.51.40",
      "superior": null,
      "indent": "4",
      "description": "Venetian blinds and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.99.5150",
      "rawHtsCode": "7616.99.51.50",
      "superior": null,
      "indent": "4",
      "description": "Hangers and supports for pipes and tubes",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.99.5160",
      "rawHtsCode": "7616.99.51.60",
      "superior": null,
      "indent": "5",
      "description": "Castings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.99.5170",
      "rawHtsCode": "7616.99.51.70",
      "superior": null,
      "indent": "5",
      "description": "Forgings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.99.5175",
      "rawHtsCode": "7616.99.51.75",
      "superior": null,
      "indent": "6",
      "description": "Articles of wire",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7616.99.5190",
      "rawHtsCode": "7616.99.51.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7801",
      "rawHtsCode": "7801",
      "superior": null,
      "indent": "0",
      "description": "Unwrought lead:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7801.10.0000",
      "rawHtsCode": "7801.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Refined lead",
      "units": [
        "kg"
      ],
      "generalRate": "2.5% on the value of the lead content",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7801.91.0000",
      "rawHtsCode": "7801.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight antimony as the principal other element",
      "units": [
        "kg",
        "Pb kg"
      ],
      "generalRate": "2.5% on the value of the lead content",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7801.99",
      "rawHtsCode": "7801.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7801.99.3000",
      "rawHtsCode": "7801.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "Lead bullion",
      "units": [
        "kg",
        "Pb kg"
      ],
      "generalRate": "2.5% on the value of the lead content",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7801.99.90",
      "rawHtsCode": "7801.99.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.5% on the value of the lead content",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7801.99.9030",
      "rawHtsCode": "7801.99.90.30",
      "superior": null,
      "indent": "4",
      "description": "Alloys of lead",
      "units": [
        "kg",
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7801.99.9050",
      "rawHtsCode": "7801.99.90.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7802.00.00",
      "rawHtsCode": "7802.00.00",
      "superior": null,
      "indent": "0",
      "description": "Lead waste and scrap",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7802.00.0030",
      "rawHtsCode": "7802.00.00.30",
      "superior": null,
      "indent": "1",
      "description": "Obtained from lead-acid storage batteries",
      "units": [
        "kg",
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7802.00.0060",
      "rawHtsCode": "7802.00.00.60",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg",
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7804",
      "rawHtsCode": "7804",
      "superior": null,
      "indent": "0",
      "description": "Lead plates, sheets, strip and foil; lead powders and flakes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7804.11.0000",
      "rawHtsCode": "7804.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sheets, strip and foil of a thickness (excluding any backing) not exceeding 0.2 mm",
      "units": [
        "kg"
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7804.19.0000",
      "rawHtsCode": "7804.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7804.20.0000",
      "rawHtsCode": "7804.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Powders and flakes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "7806",
      "rawHtsCode": "7806",
      "superior": null,
      "indent": "0",
      "description": "Other articles of lead:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7806.00.0300",
      "rawHtsCode": "7806.00.03.00",
      "superior": null,
      "indent": "1",
      "description": "Lead bars, rods, profiles and wire",
      "units": [
        "kg"
      ],
      "generalRate": "1.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7806.00.0500",
      "rawHtsCode": "7806.00.05.00",
      "superior": null,
      "indent": "1",
      "description": "Lead tubes, pipes and tube or pipe fittings (for example, couplings, elbows, sleeves)",
      "units": [
        "kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7806.00.8000",
      "rawHtsCode": "7806.00.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7901",
      "rawHtsCode": "7901",
      "superior": null,
      "indent": "0",
      "description": "Unwrought zinc:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7901.11.0000",
      "rawHtsCode": "7901.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight 99.99 percent or more of zinc",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7901.12",
      "rawHtsCode": "7901.12",
      "superior": null,
      "indent": "2",
      "description": "Containing by weight less than 99.99 percent of zinc:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7901.12.1000",
      "rawHtsCode": "7901.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "Casting-grade zinc",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7901.12.5000",
      "rawHtsCode": "7901.12.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7901.20.0000",
      "rawHtsCode": "7901.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Zinc alloys",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7902.00.0000",
      "rawHtsCode": "7902.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Zinc waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7903",
      "rawHtsCode": "7903",
      "superior": null,
      "indent": "0",
      "description": "Zinc dust, powders and flakes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7903.10.0000",
      "rawHtsCode": "7903.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Zinc dust",
      "units": [
        "kg"
      ],
      "generalRate": "0.7¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7903.90",
      "rawHtsCode": "7903.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7903.90.3000",
      "rawHtsCode": "7903.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Powders",
      "units": [
        "kg"
      ],
      "generalRate": "0.5¢/kg",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3.9¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7903.90.6000",
      "rawHtsCode": "7903.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7904.00.0000",
      "rawHtsCode": "7904.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Zinc bars, rods, profiles and wire",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7905.00.0000",
      "rawHtsCode": "7905.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Zinc plates, sheets, strip and foil",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7907.00",
      "rawHtsCode": "7907.00",
      "superior": null,
      "indent": "0",
      "description": "Other articles of zinc:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "7907.00.1000",
      "rawHtsCode": "7907.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Articles of a type used for household, table or kitchen use; toilet and sanitary wares; all the foregoing and parts thereof of zinc",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7907.00.2000",
      "rawHtsCode": "7907.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Zinc tubes, pipes and tube or pipe fittings (for example, couplings, elbows, sleeves)",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "7907.00.6000",
      "rawHtsCode": "7907.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8001",
      "rawHtsCode": "8001",
      "superior": null,
      "indent": "0",
      "description": "Unwrought tin:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8001.10.0000",
      "rawHtsCode": "8001.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tin, not alloyed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8001.20.00",
      "rawHtsCode": "8001.20.00",
      "superior": null,
      "indent": "1",
      "description": "Tin alloys",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8001.20.0010",
      "rawHtsCode": "8001.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Containing, by weight, 5 percent or less of lead",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8001.20.0050",
      "rawHtsCode": "8001.20.00.50",
      "superior": null,
      "indent": "2",
      "description": "Containing, by weight, more than 5 percent but not more than 25 percent of lead",
      "units": [
        "kg",
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8001.20.0090",
      "rawHtsCode": "8001.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Containing, by weight, more than 25 percent of lead",
      "units": [
        "kg",
        "Pb kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8002.00.0000",
      "rawHtsCode": "8002.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Tin waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8003.00.0000",
      "rawHtsCode": "8003.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Tin bars, rods, profiles and wire",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8007.00",
      "rawHtsCode": "8007.00",
      "superior": null,
      "indent": "0",
      "description": "Other articles of tin:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8007.00.10",
      "rawHtsCode": "8007.00.10",
      "superior": null,
      "indent": "1",
      "description": "Articles not elsewhere specified or included of a type used for household, table or kitchen use; toilet and sanitary wares; all the foregoing not coated or plated with precious metal",
      "units": [],
      "generalRate": "2.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8007.00.1010",
      "rawHtsCode": "8007.00.10.10",
      "superior": null,
      "indent": "2",
      "description": "Suitable for food or beverage service",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8007.00.1050",
      "rawHtsCode": "8007.00.10.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8007.00.2000",
      "rawHtsCode": "8007.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Tin plates, sheets and strip, of a thickness exceeding <il>0.2 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8007.00.3100",
      "rawHtsCode": "8007.00.31.00",
      "superior": null,
      "indent": "1",
      "description": "Tin foil (whether or not printed or backed with paper, paperboard, plastics or similar backing materials), of a thickness (excluding any backing) not exceeding <il>0.2 mm</il>",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8007.00.3200",
      "rawHtsCode": "8007.00.32.00",
      "superior": null,
      "indent": "1",
      "description": "Powders and flakes",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8007.00.4000",
      "rawHtsCode": "8007.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Tin tubes, pipes and tube or pipe fittings (for example, couplings, elbows, sleeves)",
      "units": [
        "kg"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8007.00.5000",
      "rawHtsCode": "8007.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8101",
      "rawHtsCode": "8101",
      "superior": null,
      "indent": "0",
      "description": "Tungsten (wolfram) and articles thereof, including waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8101.10.0000",
      "rawHtsCode": "8101.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Powders",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "58%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8101.94.0000",
      "rawHtsCode": "8101.94.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unwrought tungsten, including bars and rods obtained simply by sintering",
      "units": [
        "kg"
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.11. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8101.96.0000",
      "rawHtsCode": "8101.96.00.00",
      "superior": null,
      "indent": "2",
      "description": "Wire",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8101.97.0000",
      "rawHtsCode": "8101.97.00.00",
      "superior": null,
      "indent": "2",
      "description": "Waste and scrap",
      "units": [
        "kg",
        "W kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8101.99",
      "rawHtsCode": "8101.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8101.99.1000",
      "rawHtsCode": "8101.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Bars and rods, other than those obtained simply by sintering, profiles, plates, sheets, strip and foil",
      "units": [
        "kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.11. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8101.99.8000",
      "rawHtsCode": "8101.99.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.11. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8102",
      "rawHtsCode": "8102",
      "superior": null,
      "indent": "0",
      "description": "Molybdenum and articles thereof, including waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8102.10.0000",
      "rawHtsCode": "8102.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Powders",
      "units": [
        "kg",
        "Mo kg"
      ],
      "generalRate": "9.1¢/kg on molybdenum content + 1.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg on molybdenum content + 15%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8102.94.0000",
      "rawHtsCode": "8102.94.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unwrought molybdenum, including bars and rods obtained simply by sintering",
      "units": [
        "kg",
        "Mo kg"
      ],
      "generalRate": "13.9¢/kg on molybdenum content + 1.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.10/kg on molybdenum content + 15%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8102.95",
      "rawHtsCode": "8102.95",
      "superior": null,
      "indent": "2",
      "description": "Bars and rods, other than those obtained simply by sintering, profiles, plates, sheets, strip and foil:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8102.95.3000",
      "rawHtsCode": "8102.95.30.00",
      "superior": null,
      "indent": "3",
      "description": "Bars and rods",
      "units": [
        "kg"
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8102.95.6000",
      "rawHtsCode": "8102.95.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8102.96.0000",
      "rawHtsCode": "8102.96.00.00",
      "superior": null,
      "indent": "2",
      "description": "Wire",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8102.97.0000",
      "rawHtsCode": "8102.97.00.00",
      "superior": null,
      "indent": "2",
      "description": "Waste and scrap",
      "units": [
        "kg",
        "Mo kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8102.99.0000",
      "rawHtsCode": "8102.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8103",
      "rawHtsCode": "8103",
      "superior": null,
      "indent": "0",
      "description": "Tantalum and articles thereof, including waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8103.20.00",
      "rawHtsCode": "8103.20.00",
      "superior": null,
      "indent": "1",
      "description": "Unwrought tantalum, including bars and rods obtained simply by sintering; powders",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8103.20.0030",
      "rawHtsCode": "8103.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Powders",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8103.20.0090",
      "rawHtsCode": "8103.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8103.30.0000",
      "rawHtsCode": "8103.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8103.91.0000",
      "rawHtsCode": "8103.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Crucibles",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8103.99.0000",
      "rawHtsCode": "8103.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8104",
      "rawHtsCode": "8104",
      "superior": null,
      "indent": "0",
      "description": "Magnesium and articles thereof, including waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8104.11.0000",
      "rawHtsCode": "8104.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing at least 99.8 percent by weight of magnesium",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "100%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8104.19.0000",
      "rawHtsCode": "8104.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg",
        "Mg kg"
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8104.20.0000",
      "rawHtsCode": "8104.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8104.30.0000",
      "rawHtsCode": "8104.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Raspings, turnings and granules, graded according to size; powders",
      "units": [
        "kg",
        "Mg kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8104.90.0000",
      "rawHtsCode": "8104.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg",
        "Mg kg"
      ],
      "generalRate": "14.8¢/kg on magnesium content + 3.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "88¢/kg on magnesium content + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8105",
      "rawHtsCode": "8105",
      "superior": null,
      "indent": "0",
      "description": "Cobalt mattes and other intermediate products of cobalt metallurgy; cobalt and articles thereof, including waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8105.20",
      "rawHtsCode": "8105.20",
      "superior": null,
      "indent": "1",
      "description": "Cobalt mattes and other intermediate products of cobalt metallurgy; unwrought cobalt; powders:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8105.20.3000",
      "rawHtsCode": "8105.20.30.00",
      "superior": null,
      "indent": "3",
      "description": "Alloys",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8105.20.6000",
      "rawHtsCode": "8105.20.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8105.20.9000",
      "rawHtsCode": "8105.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8105.30.0000",
      "rawHtsCode": "8105.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8105.90.0000",
      "rawHtsCode": "8105.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8106",
      "rawHtsCode": "8106",
      "superior": null,
      "indent": "0",
      "description": "Bismuth and articles thereof, including waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8106.10.0000",
      "rawHtsCode": "8106.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Containing more than 99.99 percent of bismuth, by weight",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "7.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8106.90.0000",
      "rawHtsCode": "8106.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "7.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8108",
      "rawHtsCode": "8108",
      "superior": null,
      "indent": "0",
      "description": "Titanium and articles thereof, including waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8108.20.00",
      "rawHtsCode": "8108.20.00",
      "superior": null,
      "indent": "1",
      "description": "Unwrought titanium; powders",
      "units": [],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8108.20.0010",
      "rawHtsCode": "8108.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Sponge",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8108.20.0015",
      "rawHtsCode": "8108.20.00.15",
      "superior": null,
      "indent": "3",
      "description": "Powders",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8108.20.0030",
      "rawHtsCode": "8108.20.00.30",
      "superior": null,
      "indent": "3",
      "description": "Ingots",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8108.20.0095",
      "rawHtsCode": "8108.20.00.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8108.30.0000",
      "rawHtsCode": "8108.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "8108.90",
      "rawHtsCode": "8108.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8108.90.30",
      "rawHtsCode": "8108.90.30",
      "superior": null,
      "indent": "2",
      "description": "Articles of titanium",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8108.90.3030",
      "rawHtsCode": "8108.90.30.30",
      "superior": null,
      "indent": "3",
      "description": "Castings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8108.90.3060",
      "rawHtsCode": "8108.90.30.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8108.90.60",
      "rawHtsCode": "8108.90.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "15%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See additional U.S. note 2 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8108.90.6020",
      "rawHtsCode": "8108.90.60.20",
      "superior": null,
      "indent": "3",
      "description": "Blooms, sheet bars, and slabs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8108.90.6031",
      "rawHtsCode": "8108.90.60.31",
      "superior": null,
      "indent": "3",
      "description": "Other bars, rods, profiles and wire",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8108.90.6045",
      "rawHtsCode": "8108.90.60.45",
      "superior": null,
      "indent": "3",
      "description": "Plates, sheets, strips and foil",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8108.90.6060",
      "rawHtsCode": "8108.90.60.60",
      "superior": null,
      "indent": "3",
      "description": "Tubes and pipes",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8108.90.6075",
      "rawHtsCode": "8108.90.60.75",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8109",
      "rawHtsCode": "8109",
      "superior": null,
      "indent": "0",
      "description": "Zirconium and articles thereof, including waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8109.21.0000",
      "rawHtsCode": "8109.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing less than 1 part hafnium to 500 parts zirconium by weight",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8109.29.0000",
      "rawHtsCode": "8109.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8109.31.0000",
      "rawHtsCode": "8109.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing less than 1 part hafnium to 500 parts zirconium by weight",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8109.39.0000",
      "rawHtsCode": "8109.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8109.91.0000",
      "rawHtsCode": "8109.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing less than 1 part hafnium to 500 parts zirconium by weight",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8109.99.0000",
      "rawHtsCode": "8109.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8110",
      "rawHtsCode": "8110",
      "superior": null,
      "indent": "0",
      "description": "Antimony and articles thereof, including waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8110.10.0000",
      "rawHtsCode": "8110.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Unwrought antimony; powders",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8110.20.0000",
      "rawHtsCode": "8110.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8110.90.0000",
      "rawHtsCode": "8110.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4.4¢/kg",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8111.00",
      "rawHtsCode": "8111.00",
      "superior": null,
      "indent": "0",
      "description": "Manganese and articles thereof, including waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8111.00.3000",
      "rawHtsCode": "8111.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8111.00.4700",
      "rawHtsCode": "8111.00.47.00",
      "superior": null,
      "indent": "3",
      "description": "Flake containing at least 99.5 percent by weight manganese",
      "units": [
        "kg"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8111.00.49",
      "rawHtsCode": "8111.00.49",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8111.00.4910",
      "rawHtsCode": "8111.00.49.10",
      "superior": null,
      "indent": "4",
      "description": "Powder containing at least 99.5 percent by weight manganese",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8111.00.4990",
      "rawHtsCode": "8111.00.49.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8111.00.6000",
      "rawHtsCode": "8111.00.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112",
      "rawHtsCode": "8112",
      "superior": null,
      "indent": "0",
      "description": "Beryllium, chromium, hafnium, rhenium, thallium, cadmium, germanium, vanadium, gallium, indium and niobium (columbium), and articles of these metals, including waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8112.12.0000",
      "rawHtsCode": "8112.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unwrought; powders",
      "units": [
        "kg"
      ],
      "generalRate": "8.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.13.0000",
      "rawHtsCode": "8112.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8112.19.0000",
      "rawHtsCode": "8112.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.21.0000",
      "rawHtsCode": "8112.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unwrought; powders",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.22.0000",
      "rawHtsCode": "8112.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8112.29.0000",
      "rawHtsCode": "8112.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.31.0000",
      "rawHtsCode": "8112.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unwrought; waste and scrap; powders",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "8112.39.0000",
      "rawHtsCode": "8112.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free(A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.41",
      "rawHtsCode": "8112.41",
      "superior": null,
      "indent": "2",
      "description": "Unwrought; waste and scrap; powders:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8112.41.1000",
      "rawHtsCode": "8112.41.10.00",
      "superior": null,
      "indent": "3",
      "description": "Waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "8112.41.5000",
      "rawHtsCode": "8112.41.50.00",
      "superior": null,
      "indent": "3",
      "description": "Unwrought; powders",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.49.0000",
      "rawHtsCode": "8112.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.51.0000",
      "rawHtsCode": "8112.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unwrought; powders",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.52.0000",
      "rawHtsCode": "8112.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "Waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8112.59.0000",
      "rawHtsCode": "8112.59.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.61.0000",
      "rawHtsCode": "8112.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8112.69",
      "rawHtsCode": "8112.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8112.69.1000",
      "rawHtsCode": "8112.69.10.00",
      "superior": null,
      "indent": "3",
      "description": "Unwrought cadmium; powders",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8112.69.9000",
      "rawHtsCode": "8112.69.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.92",
      "rawHtsCode": "8112.92",
      "superior": null,
      "indent": "2",
      "description": "Unwrought; waste and scrap; powders:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8112.92.0700",
      "rawHtsCode": "8112.92.07.00",
      "superior": null,
      "indent": "3",
      "description": "Waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "8112.92.1000",
      "rawHtsCode": "8112.92.10.00",
      "superior": null,
      "indent": "4",
      "description": "Gallium",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.92.3000",
      "rawHtsCode": "8112.92.30.00",
      "superior": null,
      "indent": "4",
      "description": "Indium",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.09. ",
        "See 9903.91.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8112.92.4000",
      "rawHtsCode": "8112.92.40.00",
      "superior": null,
      "indent": "4",
      "description": "Niobium (columbium)",
      "units": [
        "kg"
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.09. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.92.6000",
      "rawHtsCode": "8112.92.60.00",
      "superior": null,
      "indent": "5",
      "description": "Unwrought",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.92.6500",
      "rawHtsCode": "8112.92.65.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.92.7000",
      "rawHtsCode": "8112.92.70.00",
      "superior": null,
      "indent": "4",
      "description": "Vanadium",
      "units": [
        "kg",
        "V kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.99",
      "rawHtsCode": "8112.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8112.99.1000",
      "rawHtsCode": "8112.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Germanium",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.99.2000",
      "rawHtsCode": "8112.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Vanadium",
      "units": [
        "kg",
        "V kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D, E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8112.99.9100",
      "rawHtsCode": "8112.99.91.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8113.00.0000",
      "rawHtsCode": "8113.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Cermets and articles thereof, including waste and scrap",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8201",
      "rawHtsCode": "8201",
      "superior": null,
      "indent": "0",
      "description": "Handtools of the following kinds and base metal parts thereof: spades, shovels, mattocks, picks, hoes, forks and rakes; axes, bill hooks and similar hewing tools; secateurs and pruners of any kind; scythes, sickles, hay knives, hedge shears, timber wedges and other tools of a kind used in agriculture, horticulture or forestry:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8201.10.0000",
      "rawHtsCode": "8201.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Spades and shovels, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8201.30.00",
      "rawHtsCode": "8201.30.00",
      "superior": null,
      "indent": "1",
      "description": "Mattocks, picks, hoes and rakes, and parts thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8201.30.0010",
      "rawHtsCode": "8201.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Mattocks and picks, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8201.30.0080",
      "rawHtsCode": "8201.30.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8201.40",
      "rawHtsCode": "8201.40",
      "superior": null,
      "indent": "1",
      "description": "Axes, bill hooks and similar hewing tools, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8201.40.3000",
      "rawHtsCode": "8201.40.30.00",
      "superior": null,
      "indent": "2",
      "description": "Machetes, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8201.40.60",
      "rawHtsCode": "8201.40.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8201.40.6010",
      "rawHtsCode": "8201.40.60.10",
      "superior": null,
      "indent": "3",
      "description": "Axes and adzes, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8201.40.6080",
      "rawHtsCode": "8201.40.60.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8201.50.0000",
      "rawHtsCode": "8201.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Secateurs and similar one-handed pruners and shears (including poultry shears), and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "1¢ each + 2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8201.60.0000",
      "rawHtsCode": "8201.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hedge shears, two-handed pruning shears and similar two-handed shears, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "1¢ each + 2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8201.90",
      "rawHtsCode": "8201.90",
      "superior": null,
      "indent": "1",
      "description": "Other handtools of a kind used in agriculture, horticulture or forestry, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8201.90.3000",
      "rawHtsCode": "8201.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Grass shears, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "2¢ each + 5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8201.90.4000",
      "rawHtsCode": "8201.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Forks, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8201.90.6000",
      "rawHtsCode": "8201.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8202",
      "rawHtsCode": "8202",
      "superior": null,
      "indent": "0",
      "description": "Handsaws, and metal parts thereof; blades for saws of all kinds (including slitting, slotting or toothless saw blades), and base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8202.10.0000",
      "rawHtsCode": "8202.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Handsaws, and parts (except blades) thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8202.20.00",
      "rawHtsCode": "8202.20.00",
      "superior": null,
      "indent": "1",
      "description": "Bandsaw blades, and parts thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8202.20.0030",
      "rawHtsCode": "8202.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Metal cutting blades",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8202.20.0060",
      "rawHtsCode": "8202.20.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8202.31.0000",
      "rawHtsCode": "8202.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "With working part of steel",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8202.39.00",
      "rawHtsCode": "8202.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other, including parts",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8202.39.0010",
      "rawHtsCode": "8202.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "With diamond working parts",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8202.39.0040",
      "rawHtsCode": "8202.39.00.40",
      "superior": null,
      "indent": "3",
      "description": "Diamond sawblade cores",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8202.39.0070",
      "rawHtsCode": "8202.39.00.70",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8202.40",
      "rawHtsCode": "8202.40",
      "superior": null,
      "indent": "1",
      "description": "Chain saw blades, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8202.40.3000",
      "rawHtsCode": "8202.40.30.00",
      "superior": null,
      "indent": "2",
      "description": "With cutting parts containing by weight over 0.2 percent of chromium, molybdenum, or tungsten or over <il>0.1 percent</il> of vanadium",
      "units": [
        "No."
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8202.40.60",
      "rawHtsCode": "8202.40.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8202.40.6030",
      "rawHtsCode": "8202.40.60.30",
      "superior": null,
      "indent": "3",
      "description": "In continuous lengths",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8202.40.6060",
      "rawHtsCode": "8202.40.60.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8202.91",
      "rawHtsCode": "8202.91",
      "superior": null,
      "indent": "2",
      "description": "Straight saw blades, for working metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8202.91.3000",
      "rawHtsCode": "8202.91.30.00",
      "superior": null,
      "indent": "3",
      "description": "Hacksaw blades",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8202.91.6000",
      "rawHtsCode": "8202.91.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40¢/gross",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8202.99.0000",
      "rawHtsCode": "8202.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8203",
      "rawHtsCode": "8203",
      "superior": null,
      "indent": "0",
      "description": "Files, rasps, pliers (including cutting pliers), pincers, tweezers, metal cutting shears, pipe cutters, bolt cutters, perforating punches and similar handtools, and base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8203.10",
      "rawHtsCode": "8203.10",
      "superior": null,
      "indent": "1",
      "description": "Files, rasps and similar tools:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8203.10.3000",
      "rawHtsCode": "8203.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Not over 11 cm in length",
      "units": [
        "doz."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "47.5¢/doz.",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8203.10.6000",
      "rawHtsCode": "8203.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Over 11 cm but not over 17 cm in length",
      "units": [
        "doz."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "62.5¢/doz.",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8203.10.9000",
      "rawHtsCode": "8203.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Over 17 cm in length",
      "units": [
        "doz."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "77.5¢/doz.",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8203.20",
      "rawHtsCode": "8203.20",
      "superior": null,
      "indent": "1",
      "description": "Pliers (including cutting pliers), pincers, tweezers and similar tools, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8203.20.2000",
      "rawHtsCode": "8203.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Tweezers",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8203.20.4000",
      "rawHtsCode": "8203.20.40.00",
      "superior": null,
      "indent": "3",
      "description": "Slip joint pliers",
      "units": [
        "doz."
      ],
      "generalRate": "12%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8203.20.60",
      "rawHtsCode": "8203.20.60",
      "superior": null,
      "indent": "3",
      "description": "Other (except parts)",
      "units": [],
      "generalRate": "12¢/doz. + 5.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.20/doz. + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8203.20.6030",
      "rawHtsCode": "8203.20.60.30",
      "superior": null,
      "indent": "4",
      "description": "Pliers",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8203.20.6060",
      "rawHtsCode": "8203.20.60.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8203.20.8000",
      "rawHtsCode": "8203.20.80.00",
      "superior": null,
      "indent": "3",
      "description": "Parts",
      "units": [
        "No."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8203.30.0000",
      "rawHtsCode": "8203.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Metal cutting shears and similar tools, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8203.40",
      "rawHtsCode": "8203.40",
      "superior": null,
      "indent": "1",
      "description": "Pipe cutters, bolt cutters, perforating punches and similar tools, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8203.40.3000",
      "rawHtsCode": "8203.40.30.00",
      "superior": null,
      "indent": "2",
      "description": "With cutting part containing by weight over 0.2 percent of chromium, molybdenum, or tungsten or over 0.1 percent of vanadium",
      "units": [
        "No."
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8203.40.6000",
      "rawHtsCode": "8203.40.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8204",
      "rawHtsCode": "8204",
      "superior": null,
      "indent": "0",
      "description": "Hand-operated spanners and wrenches (including torque meter wrenches but not including tap wrenches); socket wrenches, with or without handles, drives or extensions; base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8204.11.00",
      "rawHtsCode": "8204.11.00",
      "superior": null,
      "indent": "2",
      "description": "Nonadjustable, and parts thereof",
      "units": [],
      "generalRate": "9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8204.11.0030",
      "rawHtsCode": "8204.11.00.30",
      "superior": null,
      "indent": "3",
      "description": "Open-end, box and combination open-end and box wrenches",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8204.11.0060",
      "rawHtsCode": "8204.11.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8204.12.0000",
      "rawHtsCode": "8204.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Adjustable, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8204.20.0000",
      "rawHtsCode": "8204.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Socket wrenches, with or without handles, drives and extensions, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205",
      "rawHtsCode": "8205",
      "superior": null,
      "indent": "0",
      "description": "Handtools (including glass cutters) not elsewhere specified or included; blow torches and similar self-contained torches; vises, clamps and the like, other than accessories for and parts of machine tools or water-jet cutting machines; anvils; portable forges; hand- or pedal-operated grinding wheels with frameworks; base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.10.0000",
      "rawHtsCode": "8205.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Drilling, threading or tapping tools, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.20",
      "rawHtsCode": "8205.20",
      "superior": null,
      "indent": "1",
      "description": "Hammers and sledge hammers, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.20.3000",
      "rawHtsCode": "8205.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "With heads not over 1.5 kg each",
      "units": [
        "No."
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.20.6000",
      "rawHtsCode": "8205.20.60.00",
      "superior": null,
      "indent": "2",
      "description": "With heads over 1.5 kg each",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8205.30",
      "rawHtsCode": "8205.30",
      "superior": null,
      "indent": "1",
      "description": "Planes, chisels, gouges and similar cutting tools for working wood, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.30.3000",
      "rawHtsCode": "8205.30.30.00",
      "superior": null,
      "indent": "2",
      "description": "With cutting part containing by weight over 0.2 percent of chromium, molybdenum, or tungsten or over 0.1 percent of vanadium",
      "units": [
        "No."
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.30.6000",
      "rawHtsCode": "8205.30.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.40.0000",
      "rawHtsCode": "8205.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Screwdrivers, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "6.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.1% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.51",
      "rawHtsCode": "8205.51",
      "superior": null,
      "indent": "2",
      "description": "Household tools, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.51.1500",
      "rawHtsCode": "8205.51.15.00",
      "superior": null,
      "indent": "4",
      "description": "Carving and butcher steels, with or without handles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8205.51.30",
      "rawHtsCode": "8205.51.30",
      "superior": null,
      "indent": "4",
      "description": "Other (including parts)",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.51.3030",
      "rawHtsCode": "8205.51.30.30",
      "superior": null,
      "indent": "5",
      "description": "Kitchen and table implements",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8205.51.3060",
      "rawHtsCode": "8205.51.30.60",
      "superior": null,
      "indent": "5",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.51.4500",
      "rawHtsCode": "8205.51.45.00",
      "superior": null,
      "indent": "3",
      "description": "Of copper",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8205.51.6000",
      "rawHtsCode": "8205.51.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of aluminum",
      "units": [
        "kg"
      ],
      "generalRate": "2.2¢/kg + 5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "19¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.51.7500",
      "rawHtsCode": "8205.51.75.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.59",
      "rawHtsCode": "8205.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.59.1000",
      "rawHtsCode": "8205.59.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pipe tools, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.6% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.59.2000",
      "rawHtsCode": "8205.59.20.00",
      "superior": null,
      "indent": "3",
      "description": "Powder-actuated handtools, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8205.59.30",
      "rawHtsCode": "8205.59.30",
      "superior": null,
      "indent": "3",
      "description": "Crowbars, track tools and wedges, and parts thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "8205.59.3010",
      "rawHtsCode": "8205.59.30.10",
      "superior": null,
      "indent": "4",
      "description": "Crowbars",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.59.3080",
      "rawHtsCode": "8205.59.30.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.59.4500",
      "rawHtsCode": "8205.59.45.00",
      "superior": null,
      "indent": "5",
      "description": "Caulking guns",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.59.55",
      "rawHtsCode": "8205.59.55",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.59.5505",
      "rawHtsCode": "8205.59.55.05",
      "superior": null,
      "indent": "7",
      "description": "Single edge razor blades other than for shaving",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.59.5510",
      "rawHtsCode": "8205.59.55.10",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.59.5560",
      "rawHtsCode": "8205.59.55.60",
      "superior": null,
      "indent": "6",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.59.6000",
      "rawHtsCode": "8205.59.60.00",
      "superior": null,
      "indent": "4",
      "description": "Of copper",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8205.59.7000",
      "rawHtsCode": "8205.59.70.00",
      "superior": null,
      "indent": "4",
      "description": "Of aluminum",
      "units": [
        "kg"
      ],
      "generalRate": "1.5¢/kg + 3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "19¢/kg + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.59.8000",
      "rawHtsCode": "8205.59.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.60.0000",
      "rawHtsCode": "8205.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Blow torches and similar self-contained torches, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.70.00",
      "rawHtsCode": "8205.70.00",
      "superior": null,
      "indent": "1",
      "description": "Vises, clamps and the like, and parts thereof",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8205.70.0030",
      "rawHtsCode": "8205.70.00.30",
      "superior": null,
      "indent": "3",
      "description": "Pipe",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.70.0060",
      "rawHtsCode": "8205.70.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.70.0090",
      "rawHtsCode": "8205.70.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.90",
      "rawHtsCode": "8205.90",
      "superior": null,
      "indent": "1",
      "description": "Other, including sets of articles of two or more subheadings of this heading:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8205.90.1000",
      "rawHtsCode": "8205.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Anvils; portable forges; hand- or pedal-operated grinding wheels with frameworks; base metal parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8205.90.6000",
      "rawHtsCode": "8205.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Sets of articles of two or more of the foregoing subheadings",
      "units": [
        "pcs"
      ],
      "generalRate": "The rate of duty applicable to that article in the set subject to the highest rate of duty",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "The rate of duty applicable to that article in the set subject to the highest rate of duty",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8206.00.0000",
      "rawHtsCode": "8206.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Tools of two or more of headings 8202 to 8205, put up in sets for retail sale",
      "units": [
        "pcs"
      ],
      "generalRate": "The rate of duty applicable to that article in the set subject to the highest rate of duty",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "The rate of duty applicable to that article in the set subject to the highest rate of duty",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24. ",
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207",
      "rawHtsCode": "8207",
      "superior": null,
      "indent": "0",
      "description": "Interchangeable tools for handtools, whether or not power operated, or for machine-tools (for example, for pressing, stamping, punching, tapping, threading, drilling, boring, broaching, milling, turning or screwdriving), including dies for drawing or extruding metal, and rock drilling or earth boring tools; base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.13.0000",
      "rawHtsCode": "8207.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "With working part of cermets",
      "units": [
        "No."
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.19",
      "rawHtsCode": "8207.19",
      "superior": null,
      "indent": "2",
      "description": "Other, including parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.19.30",
      "rawHtsCode": "8207.19.30",
      "superior": null,
      "indent": "3",
      "description": "With cutting part containing by weight over 0.2 percent of chromium, molybdenum, or tungsten or over 0.1 percent of vanadium",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.19.3030",
      "rawHtsCode": "8207.19.30.30",
      "superior": null,
      "indent": "4",
      "description": "Percussion rock drill bits",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.19.3060",
      "rawHtsCode": "8207.19.30.60",
      "superior": null,
      "indent": "5",
      "description": "Rotary rock drill bits, core bits and reamers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.19.3090",
      "rawHtsCode": "8207.19.30.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.19.60",
      "rawHtsCode": "8207.19.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.82.01 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.19.6030",
      "rawHtsCode": "8207.19.60.30",
      "superior": null,
      "indent": "4",
      "description": "Percussion rock drill bits",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.19.6065",
      "rawHtsCode": "8207.19.60.65",
      "superior": null,
      "indent": "6",
      "description": "With working part of diamonds",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.19.6070",
      "rawHtsCode": "8207.19.60.70",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.19.6090",
      "rawHtsCode": "8207.19.60.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.20.00",
      "rawHtsCode": "8207.20.00",
      "superior": null,
      "indent": "1",
      "description": "Dies for drawing or extruding metal, and parts thereof",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.20.0030",
      "rawHtsCode": "8207.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Diamond wire drawing dies",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.20.0040",
      "rawHtsCode": "8207.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other dies",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.20.0070",
      "rawHtsCode": "8207.20.00.70",
      "superior": null,
      "indent": "2",
      "description": "Parts",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.30",
      "rawHtsCode": "8207.30",
      "superior": null,
      "indent": "1",
      "description": "Tools for pressing, stamping or punching, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.30.30",
      "rawHtsCode": "8207.30.30",
      "superior": null,
      "indent": "2",
      "description": "Suitable for cutting metal, and parts thereof",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.85% (JP)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.30.3020",
      "rawHtsCode": "8207.30.30.20",
      "superior": null,
      "indent": "3",
      "description": "Tools",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.30.3050",
      "rawHtsCode": "8207.30.30.50",
      "superior": null,
      "indent": "3",
      "description": "Parts",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.30.60",
      "rawHtsCode": "8207.30.60",
      "superior": null,
      "indent": "2",
      "description": "Not suitable for cutting metal, and parts thereof",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.30.6032",
      "rawHtsCode": "8207.30.60.32",
      "superior": null,
      "indent": "3",
      "description": "Stamping dies not suitable for cutting metal",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.30.6062",
      "rawHtsCode": "8207.30.60.62",
      "superior": null,
      "indent": "3",
      "description": "Metal forming dies, including thread-rolling dies",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.30.6092",
      "rawHtsCode": "8207.30.60.92",
      "superior": null,
      "indent": "3",
      "description": "Other tools",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.30.6095",
      "rawHtsCode": "8207.30.60.95",
      "superior": null,
      "indent": "3",
      "description": "Parts",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.40",
      "rawHtsCode": "8207.40",
      "superior": null,
      "indent": "1",
      "description": "Tools for tapping or threading, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.40.3000",
      "rawHtsCode": "8207.40.30.00",
      "superior": null,
      "indent": "2",
      "description": "With cutting part containing by weight over 0.2 percent of chromium, molybdenum, or tungsten or over 0.1 percent of vanadium",
      "units": [
        "No."
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.85% (JP)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.40.6000",
      "rawHtsCode": "8207.40.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.50",
      "rawHtsCode": "8207.50",
      "superior": null,
      "indent": "1",
      "description": "Tools for drilling, other than for rock drilling, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.50.20",
      "rawHtsCode": "8207.50.20",
      "superior": null,
      "indent": "2",
      "description": "With cutting part containing by weight over 0.2 percent of chromium, molybdenum, or tungsten or over 0.1 percent of vanadium",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.50.2030",
      "rawHtsCode": "8207.50.20.30",
      "superior": null,
      "indent": "3",
      "description": "Masonry drills",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.50.2045",
      "rawHtsCode": "8207.50.20.45",
      "superior": null,
      "indent": "4",
      "description": "Brad point",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.50.2055",
      "rawHtsCode": "8207.50.20.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.50.2070",
      "rawHtsCode": "8207.50.20.70",
      "superior": null,
      "indent": "4",
      "description": "For woodworking",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.50.2080",
      "rawHtsCode": "8207.50.20.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.50.40",
      "rawHtsCode": "8207.50.40",
      "superior": null,
      "indent": "3",
      "description": "Suitable for cutting metal, and parts thereof",
      "units": [],
      "generalRate": "8.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.82.01 and 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.50.4030",
      "rawHtsCode": "8207.50.40.30",
      "superior": null,
      "indent": "4",
      "description": "Twist drills",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.50.4060",
      "rawHtsCode": "8207.50.40.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.50.6000",
      "rawHtsCode": "8207.50.60.00",
      "superior": null,
      "indent": "4",
      "description": "For handtools, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "5.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.50.8000",
      "rawHtsCode": "8207.50.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.82.01 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.60.00",
      "rawHtsCode": "8207.60.00",
      "superior": null,
      "indent": "1",
      "description": "Tools for boring or broaching, and parts thereof",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.60.0030",
      "rawHtsCode": "8207.60.00.30",
      "superior": null,
      "indent": "2",
      "description": "Broaches",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.60.0035",
      "rawHtsCode": "8207.60.00.35",
      "superior": null,
      "indent": "2",
      "description": "Reamers, except gun reamers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.60.0061",
      "rawHtsCode": "8207.60.00.61",
      "superior": null,
      "indent": "2",
      "description": "Other (including parts thereof)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.70",
      "rawHtsCode": "8207.70",
      "superior": null,
      "indent": "1",
      "description": "Tools for milling, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.70.30",
      "rawHtsCode": "8207.70.30",
      "superior": null,
      "indent": "2",
      "description": "With cutting part containing by weight over 0.2 percent of chromium, molybdenum, or tungsten or over 0.1 percent of vanadium",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.70.3030",
      "rawHtsCode": "8207.70.30.30",
      "superior": null,
      "indent": "3",
      "description": "End milling cutters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.70.3040",
      "rawHtsCode": "8207.70.30.40",
      "superior": null,
      "indent": "3",
      "description": "Router bits for woodworking",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.70.3060",
      "rawHtsCode": "8207.70.30.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.70.60",
      "rawHtsCode": "8207.70.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.82.01 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.70.6030",
      "rawHtsCode": "8207.70.60.30",
      "superior": null,
      "indent": "3",
      "description": "End milling cutters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.70.6040",
      "rawHtsCode": "8207.70.60.40",
      "superior": null,
      "indent": "3",
      "description": "Router bits not suitable for cutting metal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.70.6060",
      "rawHtsCode": "8207.70.60.60",
      "superior": null,
      "indent": "3",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.80",
      "rawHtsCode": "8207.80",
      "superior": null,
      "indent": "1",
      "description": "Tools for turning:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.80.3000",
      "rawHtsCode": "8207.80.30.00",
      "superior": null,
      "indent": "2",
      "description": "With cutting part containing by weight over 0.2 percent of chromium, molybdenum, or tungsten or over 0.1 percent of vanadium",
      "units": [
        "No."
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.80.6000",
      "rawHtsCode": "8207.80.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.82.01 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.90",
      "rawHtsCode": "8207.90",
      "superior": null,
      "indent": "1",
      "description": "Other interchangeable tools, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.90.1500",
      "rawHtsCode": "8207.90.15.00",
      "superior": null,
      "indent": "2",
      "description": "Files and rasps, including rotary files and rasps, and parts thereof",
      "units": [
        "doz."
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.90.30",
      "rawHtsCode": "8207.90.30",
      "superior": null,
      "indent": "3",
      "description": "Cutting tools with cutting part containing by weight over 0.2 percent of chromium, molybdenum, or tungsten or over 0.1 percent of vanadium",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.90.3030",
      "rawHtsCode": "8207.90.30.30",
      "superior": null,
      "indent": "4",
      "description": "Hobs and other gear cutting tools",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.90.3075",
      "rawHtsCode": "8207.90.30.75",
      "superior": null,
      "indent": "5",
      "description": "Cutterheads with interchangeable tools",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.90.3080",
      "rawHtsCode": "8207.90.30.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.90.3085",
      "rawHtsCode": "8207.90.30.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.90.4500",
      "rawHtsCode": "8207.90.45.00",
      "superior": null,
      "indent": "4",
      "description": "Suitable for cutting metal, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.82.01 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.90.6000",
      "rawHtsCode": "8207.90.60.00",
      "superior": null,
      "indent": "5",
      "description": "For handtools, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.90.75",
      "rawHtsCode": "8207.90.75",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.82.01 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8207.90.7545",
      "rawHtsCode": "8207.90.75.45",
      "superior": null,
      "indent": "6",
      "description": "Cutterheads with interchangeable tools",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8207.90.7585",
      "rawHtsCode": "8207.90.75.85",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8208",
      "rawHtsCode": "8208",
      "superior": null,
      "indent": "0",
      "description": "Knives and cutting blades, for machines or for mechanical appliances, and base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8208.10.00",
      "rawHtsCode": "8208.10.00",
      "superior": null,
      "indent": "1",
      "description": "For metal working, and parts thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8208.10.0030",
      "rawHtsCode": "8208.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Over 30.5 cm in length, for metal shearing machines or over 15.2 cm in diameter for metal shearing/slitting machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8208.10.0060",
      "rawHtsCode": "8208.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8208.20.00",
      "rawHtsCode": "8208.20.00",
      "superior": null,
      "indent": "1",
      "description": "For wood working, and parts thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8208.20.0030",
      "rawHtsCode": "8208.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Over 73.7 cm in length, for veneer-cutting machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8208.20.0060",
      "rawHtsCode": "8208.20.00.60",
      "superior": null,
      "indent": "2",
      "description": "Over 15.2 cm in length, for wood-chipper machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8208.20.0090",
      "rawHtsCode": "8208.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8208.30.00",
      "rawHtsCode": "8208.30.00",
      "superior": null,
      "indent": "1",
      "description": "For kitchen appliances or for machines used by the food industry, and parts thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8208.30.0030",
      "rawHtsCode": "8208.30.00.30",
      "superior": null,
      "indent": "2",
      "description": "For meat-slicing, meat-cutting or meat-chopping machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8208.30.0060",
      "rawHtsCode": "8208.30.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8208.40",
      "rawHtsCode": "8208.40",
      "superior": null,
      "indent": "1",
      "description": "For agricultural, horticultural or forestry machines, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8208.40.3000",
      "rawHtsCode": "8208.40.30.00",
      "superior": null,
      "indent": "2",
      "description": "Lawnmower blades",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8208.40.6000",
      "rawHtsCode": "8208.40.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8208.90",
      "rawHtsCode": "8208.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8208.90.3000",
      "rawHtsCode": "8208.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "For shoe machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8208.90.6000",
      "rawHtsCode": "8208.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "8209.00.00",
      "rawHtsCode": "8209.00.00",
      "superior": null,
      "indent": "0",
      "description": "Plates, sticks, tips and the like for tools, unmounted, of cermets",
      "units": [],
      "generalRate": "4.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8209.00.0030",
      "rawHtsCode": "8209.00.00.30",
      "superior": null,
      "indent": "1",
      "description": "Of sintered metal carbides",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8209.00.0060",
      "rawHtsCode": "8209.00.00.60",
      "superior": null,
      "indent": "1",
      "description": "Of other cermets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8210.00.0000",
      "rawHtsCode": "8210.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Hand-operated mechanical appliances, weighing 10 kg or less, used in the preparation, conditioning or serving of food or drink, and base metal parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211",
      "rawHtsCode": "8211",
      "superior": null,
      "indent": "0",
      "description": "Knives with cutting blades, serrated or not (including pruning knives), other than knives of heading 8208, and blades and other base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.10.0000",
      "rawHtsCode": "8211.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sets of assorted articles",
      "units": [
        "pcs"
      ],
      "generalRate": "The rate of duty applicable to that article in the set subject to the highest rate of duty",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "The rate of duty appli- cable to that article in the set subject to the high- est rate of duty",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.91",
      "rawHtsCode": "8211.91",
      "superior": null,
      "indent": "2",
      "description": "Table knives having fixed blades:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.91.1000",
      "rawHtsCode": "8211.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Knives with silver-plated handles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8211.91.2000",
      "rawHtsCode": "8211.91.20.00",
      "superior": null,
      "indent": "5",
      "description": "Valued under 25¢ each, not over 25.9 cm in overall length",
      "units": [
        "pcs"
      ],
      "generalRate": "0.4¢ each + 6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "2¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.91.2500",
      "rawHtsCode": "8211.91.25.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "0.4¢ each + 6.8%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "2¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.91.3000",
      "rawHtsCode": "8211.91.30.00",
      "superior": null,
      "indent": "5",
      "description": "Valued under 25¢ each, not over 25.9 cm in overall length",
      "units": [
        "pcs"
      ],
      "generalRate": "0.9¢ each + 10.6%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.91.4000",
      "rawHtsCode": "8211.91.40.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "0.3¢ each + 3.7%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "2¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.91.50",
      "rawHtsCode": "8211.91.50",
      "superior": null,
      "indent": "3",
      "description": "Knives with rubber or plastic handles",
      "units": [],
      "generalRate": "0.7¢ each + 3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.91.5030",
      "rawHtsCode": "8211.91.50.30",
      "superior": null,
      "indent": "4",
      "description": "Steak knives",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.91.5060",
      "rawHtsCode": "8211.91.50.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.91.80",
      "rawHtsCode": "8211.91.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "0.3¢ each + 4.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.91.8030",
      "rawHtsCode": "8211.91.80.30",
      "superior": null,
      "indent": "4",
      "description": "Steak knives",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.91.8060",
      "rawHtsCode": "8211.91.80.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.92",
      "rawHtsCode": "8211.92",
      "superior": null,
      "indent": "2",
      "description": "Other knives having fixed blades:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.92.2000",
      "rawHtsCode": "8211.92.20.00",
      "superior": null,
      "indent": "4",
      "description": "Kitchen and butcher knives",
      "units": [
        "No."
      ],
      "generalRate": "0.8¢ each + 4.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.92.40",
      "rawHtsCode": "8211.92.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "1¢ each + 4.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.92.4050",
      "rawHtsCode": "8211.92.40.50",
      "superior": null,
      "indent": "5",
      "description": "Sheath-type knives",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.92.4060",
      "rawHtsCode": "8211.92.40.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.92.6000",
      "rawHtsCode": "8211.92.60.00",
      "superior": null,
      "indent": "4",
      "description": "Hunting knives with wood handles",
      "units": [
        "No."
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.92.90",
      "rawHtsCode": "8211.92.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "0.4¢ each + 6.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.92.9030",
      "rawHtsCode": "8211.92.90.30",
      "superior": null,
      "indent": "5",
      "description": "Kitchen and butcher knives",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.92.9045",
      "rawHtsCode": "8211.92.90.45",
      "superior": null,
      "indent": "5",
      "description": "Sheath-type knives",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.92.9060",
      "rawHtsCode": "8211.92.90.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.93.00",
      "rawHtsCode": "8211.93.00",
      "superior": null,
      "indent": "2",
      "description": "Knives having other than fixed blades",
      "units": [],
      "generalRate": "3¢ each + 5.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35¢ each + 55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.93.0031",
      "rawHtsCode": "8211.93.00.31",
      "superior": null,
      "indent": "3",
      "description": "Folding two-handled multi-use tools in which one or more tools are housed in each handle and one or more of the tools is a folding knife blade",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.93.0035",
      "rawHtsCode": "8211.93.00.35",
      "superior": null,
      "indent": "3",
      "description": "Pen knives, pocket knives and other knives which have folding blades",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.93.0060",
      "rawHtsCode": "8211.93.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.94",
      "rawHtsCode": "8211.94",
      "superior": null,
      "indent": "2",
      "description": "Blades:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.94.1000",
      "rawHtsCode": "8211.94.10.00",
      "superior": null,
      "indent": "3",
      "description": "For knives having fixed blades",
      "units": [
        "No."
      ],
      "generalRate": "0.16¢ each + 2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.94.5000",
      "rawHtsCode": "8211.94.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1¢ each + 5.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "11¢ each + 55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.95",
      "rawHtsCode": "8211.95",
      "superior": null,
      "indent": "2",
      "description": "Handles of base metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8211.95.1000",
      "rawHtsCode": "8211.95.10.00",
      "superior": null,
      "indent": "3",
      "description": "For table knives having fixed blades",
      "units": [
        "No."
      ],
      "generalRate": "0.3¢ each + 4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.95.5000",
      "rawHtsCode": "8211.95.50.00",
      "superior": null,
      "indent": "3",
      "description": "For other knives having fixed blades",
      "units": [
        "No."
      ],
      "generalRate": "0.4¢ each + 6.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8211.95.9000",
      "rawHtsCode": "8211.95.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3¢ each + 5.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35¢ each + 55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8212",
      "rawHtsCode": "8212",
      "superior": null,
      "indent": "0",
      "description": "Razors and razor blades (including razor blade blanks in strips), and base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8212.10.0000",
      "rawHtsCode": "8212.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Razors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10¢ each + 30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8212.20.00",
      "rawHtsCode": "8212.20.00",
      "superior": null,
      "indent": "1",
      "description": "Safety razor blades, including razor blade blanks in strips",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "1¢ each + 30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8212.20.0005",
      "rawHtsCode": "8212.20.00.05",
      "superior": null,
      "indent": "2",
      "description": "Single edge razor blades for shaving",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8212.20.0010",
      "rawHtsCode": "8212.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8212.90.0000",
      "rawHtsCode": "8212.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8213.00",
      "rawHtsCode": "8213.00",
      "superior": null,
      "indent": "0",
      "description": "Scissors, tailors' shears and similar shears, and blades and other base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8213.00.3000",
      "rawHtsCode": "8213.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Valued not over $1.75/dozen",
      "units": [
        "No."
      ],
      "generalRate": "1.7¢ each + 4.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "15¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8213.00.6000",
      "rawHtsCode": "8213.00.60.00",
      "superior": null,
      "indent": "2",
      "description": "Pinking shears, valued over $30/dozen",
      "units": [
        "No."
      ],
      "generalRate": "8¢ each + 8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8213.00.9000",
      "rawHtsCode": "8213.00.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "3¢ each + 3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8214",
      "rawHtsCode": "8214",
      "superior": null,
      "indent": "0",
      "description": "Other articles of cutlery (for example, hair clippers, butchers' or kitchen cleavers, chopping or mincing knives, paper knives); manicure or pedicure sets and instruments (including nail files); base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8214.10.0000",
      "rawHtsCode": "8214.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Paper knives, letter openers, erasing knives, pencil sharpeners (nonmechanical) and blades and other parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "0.3¢ each + 4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8214.20",
      "rawHtsCode": "8214.20",
      "superior": null,
      "indent": "1",
      "description": "Manicure or pedicure sets and instruments (including nail files), and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8214.20.3000",
      "rawHtsCode": "8214.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "Cuticle or cornknives, cuticle pushers, nail files, nailcleaners, nail nippers and clippers, all the foregoing used for manicure or pedicure purposes, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8214.20.6000",
      "rawHtsCode": "8214.20.60.00",
      "superior": null,
      "indent": "3",
      "description": "In leather containers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8214.20.9000",
      "rawHtsCode": "8214.20.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8214.90",
      "rawHtsCode": "8214.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8214.90.3000",
      "rawHtsCode": "8214.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Cleavers with their handles",
      "units": [
        "No."
      ],
      "generalRate": "1¢ each + 4.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8214.90.6000",
      "rawHtsCode": "8214.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "0.2¢ each + 3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8214.90.9000",
      "rawHtsCode": "8214.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "1.4¢ each + 3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215",
      "rawHtsCode": "8215",
      "superior": null,
      "indent": "0",
      "description": "Spoons, forks, ladles, skimmers, cake-servers, fish-knives, butter-knives, sugar tongs and similar kitchen or tableware; and base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8215.10.0000",
      "rawHtsCode": "8215.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sets of assorted articles containing at least one article plated with precious metal",
      "units": [
        "pcs"
      ],
      "generalRate": "The rate of duty applicable to that article in the set subject to the highest rate of duty",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "The rate of duty applicable to that article in the set subject to the highest rate of duty",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.20.0000",
      "rawHtsCode": "8215.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other sets of assorted articles",
      "units": [
        "pcs"
      ],
      "generalRate": "The rate of duty applicable to that article in the set subject to the highest rate of duty",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "The rate of duty applicable to that article in the set subject to the highest rate of duty",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.91",
      "rawHtsCode": "8215.91",
      "superior": null,
      "indent": "2",
      "description": "Plated with precious metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8215.91.3000",
      "rawHtsCode": "8215.91.30.00",
      "superior": null,
      "indent": "3",
      "description": "Forks",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8215.91.6000",
      "rawHtsCode": "8215.91.60.00",
      "superior": null,
      "indent": "3",
      "description": "Spoons and ladles",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.91.9000",
      "rawHtsCode": "8215.91.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.99",
      "rawHtsCode": "8215.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8215.99.0100",
      "rawHtsCode": "8215.99.01.00",
      "superior": null,
      "indent": "6",
      "description": "Valued under 25¢ each, not over <il>25.9 cm</il> in overall length",
      "units": [
        "pcs"
      ],
      "generalRate": "0.9¢ each + 15.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.99.0500",
      "rawHtsCode": "8215.99.05.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "0.5¢ each + 8.5%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "2¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.99.1000",
      "rawHtsCode": "8215.99.10.00",
      "superior": null,
      "indent": "6",
      "description": "Valued under 25¢ each",
      "units": [
        "pcs"
      ],
      "generalRate": "0.5¢ each + 6.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "2¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.99.1500",
      "rawHtsCode": "8215.99.15.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "0.4¢ each + 4.8%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "2¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.99.2000",
      "rawHtsCode": "8215.99.20.00",
      "superior": null,
      "indent": "4",
      "description": "With rubber or plastic handles",
      "units": [
        "No."
      ],
      "generalRate": "0.5¢ each + 3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.99.2200",
      "rawHtsCode": "8215.99.22.00",
      "superior": null,
      "indent": "5",
      "description": "Without their handles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8215.99.2400",
      "rawHtsCode": "8215.99.24.00",
      "superior": null,
      "indent": "6",
      "description": "Table forks (including table serving forks) and barbecue forks with wooden handles",
      "units": [
        "No."
      ],
      "generalRate": "0.3¢ each + 4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.99.2600",
      "rawHtsCode": "8215.99.26.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "0.2¢ each + 3.1%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "8¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.99.3000",
      "rawHtsCode": "8215.99.30.00",
      "superior": null,
      "indent": "5",
      "description": "Spoons valued under 25¢ each",
      "units": [
        "pcs"
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.99.3500",
      "rawHtsCode": "8215.99.35.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "pcs"
      ],
      "generalRate": "6.8%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.99.40",
      "rawHtsCode": "8215.99.40",
      "superior": null,
      "indent": "4",
      "description": "With base metal (except stainless steel) or nonmetal handles",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8215.99.4030",
      "rawHtsCode": "8215.99.40.30",
      "superior": null,
      "indent": "5",
      "description": "Tablespoons and table ladles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8215.99.4060",
      "rawHtsCode": "8215.99.40.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8215.99.4500",
      "rawHtsCode": "8215.99.45.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8215.99.5000",
      "rawHtsCode": "8215.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other (including parts)",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301",
      "rawHtsCode": "8301",
      "superior": null,
      "indent": "0",
      "description": "Padlocks and locks (key, combination or electrically operated), of base metal; clasps and frames with clasps, incorporating locks, of base metal; keys and parts of any of the foregoing articles, of base metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.10",
      "rawHtsCode": "8301.10",
      "superior": null,
      "indent": "1",
      "description": "Padlocks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.10.2000",
      "rawHtsCode": "8301.10.20.00",
      "superior": null,
      "indent": "3",
      "description": "Not over 3.8 cm in width",
      "units": [
        "doz."
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "39.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.10.4000",
      "rawHtsCode": "8301.10.40.00",
      "superior": null,
      "indent": "3",
      "description": "Over 3.8 cm but not over 6.4 cm in width",
      "units": [
        "doz."
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "29.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.10.5000",
      "rawHtsCode": "8301.10.50.00",
      "superior": null,
      "indent": "3",
      "description": "Over 6.4 cm in width",
      "units": [
        "doz."
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "28.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.10.60",
      "rawHtsCode": "8301.10.60",
      "superior": null,
      "indent": "3",
      "description": "Not over 3.8 cm in width",
      "units": [],
      "generalRate": "6.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.10.6020",
      "rawHtsCode": "8301.10.60.20",
      "superior": null,
      "indent": "4",
      "description": "Lock bodies containing hardened steel components with attached (or insertable) flexible cable composed of wire strands and hardened steel beads",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.10.6080",
      "rawHtsCode": "8301.10.60.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.10.8000",
      "rawHtsCode": "8301.10.80.00",
      "superior": null,
      "indent": "3",
      "description": "Over 3.8 cm but not over 6.4 cm in width",
      "units": [
        "doz."
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "36%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.10.9000",
      "rawHtsCode": "8301.10.90.00",
      "superior": null,
      "indent": "3",
      "description": "Over 6.4 cm in width",
      "units": [
        "doz."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "29.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.20.00",
      "rawHtsCode": "8301.20.00",
      "superior": null,
      "indent": "1",
      "description": "Locks of a kind used on motor vehicles",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.20.0030",
      "rawHtsCode": "8301.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Non-integral steering wheel immobilizer devices",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.20.0060",
      "rawHtsCode": "8301.20.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.30.00",
      "rawHtsCode": "8301.30.00",
      "superior": null,
      "indent": "1",
      "description": "Locks of a kind used for furniture",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.30.0060",
      "rawHtsCode": "8301.30.00.60",
      "superior": null,
      "indent": "2",
      "description": "Cam locks and other locks suitable for use with chests, drawers and similar items",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.30.0090",
      "rawHtsCode": "8301.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.40",
      "rawHtsCode": "8301.40",
      "superior": null,
      "indent": "1",
      "description": "Other locks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.40.3000",
      "rawHtsCode": "8301.40.30.00",
      "superior": null,
      "indent": "2",
      "description": "Luggage locks",
      "units": [
        "doz."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.40.60",
      "rawHtsCode": "8301.40.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.85% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.40.6030",
      "rawHtsCode": "8301.40.60.30",
      "superior": null,
      "indent": "3",
      "description": "Door locks, locksets and other locks suitable for use with interior or exterior doors (except garage, overhead or sliding doors)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.40.6060",
      "rawHtsCode": "8301.40.60.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.50.0000",
      "rawHtsCode": "8301.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Clasps and frames with clasps, incorporating locks",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.60.00",
      "rawHtsCode": "8301.60.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.60.0010",
      "rawHtsCode": "8301.60.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of copper or copper alloys",
      "units": [
        "kg"
      ],
      "generalRate": "\n",
      "specialRate": "\n",
      "otherRate": "\n",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.60.0060",
      "rawHtsCode": "8301.60.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "\n",
      "specialRate": "\n",
      "otherRate": "\n",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.70.00",
      "rawHtsCode": "8301.70.00",
      "superior": null,
      "indent": "1",
      "description": "Keys presented separately",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8301.70.0010",
      "rawHtsCode": "8301.70.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of copper or copper alloys",
      "units": [
        "kg"
      ],
      "generalRate": "\n",
      "specialRate": "\n",
      "otherRate": "\n",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8301.70.0060",
      "rawHtsCode": "8301.70.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "\n",
      "specialRate": "\n",
      "otherRate": "\n",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302",
      "rawHtsCode": "8302",
      "superior": null,
      "indent": "0",
      "description": "Base metal mountings, fittings and similar articles suitable for furniture, doors, staircases, windows, blinds, coachwork, saddlery, trunks, chests, caskets or the like; base metal hat racks, hat-pegs, brackets and similar fixtures; castors with mountings of base metal; automatic door closers of base metal; and base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.10",
      "rawHtsCode": "8302.10",
      "superior": null,
      "indent": "1",
      "description": "Hinges, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.10.3000",
      "rawHtsCode": "8302.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Designed for motor vehicles",
      "units": [
        "kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.10.60",
      "rawHtsCode": "8302.10.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.10.6030",
      "rawHtsCode": "8302.10.60.30",
      "superior": null,
      "indent": "4",
      "description": "Suitable for interior and exterior doors (except garage, overhead or sliding doors)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.10.6060",
      "rawHtsCode": "8302.10.60.60",
      "superior": null,
      "indent": "4",
      "description": "Suitable for furniture and cabinets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.10.6090",
      "rawHtsCode": "8302.10.60.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.10.90",
      "rawHtsCode": "8302.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.10.9030",
      "rawHtsCode": "8302.10.90.30",
      "superior": null,
      "indent": "3",
      "description": "Suitable for interior and exterior doors (except garage, overhead or sliding doors)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.10.9060",
      "rawHtsCode": "8302.10.90.60",
      "superior": null,
      "indent": "3",
      "description": "Suitable for furniture and cabinets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.10.9090",
      "rawHtsCode": "8302.10.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.20.0000",
      "rawHtsCode": "8302.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Castors, and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.30",
      "rawHtsCode": "8302.30",
      "superior": null,
      "indent": "1",
      "description": "Other mountings, fittings and similar articles suitable for motor vehicles; and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.30.30",
      "rawHtsCode": "8302.30.30",
      "superior": null,
      "indent": "2",
      "description": "Of iron or steel, of aluminum or of zinc",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.30.3010",
      "rawHtsCode": "8302.30.30.10",
      "superior": null,
      "indent": "3",
      "description": "Pneumatic cylinders for lifting, lowering, dampening or counter-balancing",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.30.3060",
      "rawHtsCode": "8302.30.30.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.30.6000",
      "rawHtsCode": "8302.30.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.41",
      "rawHtsCode": "8302.41",
      "superior": null,
      "indent": "2",
      "description": "Suitable for buildings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.41.3000",
      "rawHtsCode": "8302.41.30.00",
      "superior": null,
      "indent": "3",
      "description": "Door closers (except automatic door closers), and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.41.60",
      "rawHtsCode": "8302.41.60",
      "superior": null,
      "indent": "4",
      "description": "Of iron or steel, of aluminum or of zinc",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.41.6015",
      "rawHtsCode": "8302.41.60.15",
      "superior": null,
      "indent": "6",
      "description": "Doorstops, chain door fasteners, door pulls, kick plates, door knockers and escutcheons",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.41.6045",
      "rawHtsCode": "8302.41.60.45",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.41.6050",
      "rawHtsCode": "8302.41.60.50",
      "superior": null,
      "indent": "5",
      "description": "For curtains, draperies and window shades",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.41.6080",
      "rawHtsCode": "8302.41.60.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.41.90",
      "rawHtsCode": "8302.41.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.41.9015",
      "rawHtsCode": "8302.41.90.15",
      "superior": null,
      "indent": "6",
      "description": "Doorstops, chain door fasteners, door pulls, kick plates, door knockers and escutcheons",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.41.9045",
      "rawHtsCode": "8302.41.90.45",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.41.9050",
      "rawHtsCode": "8302.41.90.50",
      "superior": null,
      "indent": "5",
      "description": "For curtains, draperies and window shades",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.41.9080",
      "rawHtsCode": "8302.41.90.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.42",
      "rawHtsCode": "8302.42",
      "superior": null,
      "indent": "2",
      "description": "Other, suitable for furniture:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.42.30",
      "rawHtsCode": "8302.42.30",
      "superior": null,
      "indent": "3",
      "description": "Of iron or steel, of aluminum or of zinc",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.42.3010",
      "rawHtsCode": "8302.42.30.10",
      "superior": null,
      "indent": "4",
      "description": "Pneumatic cylinders for lifting, lowering, dampening or counterbalancing",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.42.3015",
      "rawHtsCode": "8302.42.30.15",
      "superior": null,
      "indent": "4",
      "description": "Drawer slides",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.42.3065",
      "rawHtsCode": "8302.42.30.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.42.6000",
      "rawHtsCode": "8302.42.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.49",
      "rawHtsCode": "8302.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.49.2000",
      "rawHtsCode": "8302.49.20.00",
      "superior": null,
      "indent": "4",
      "description": "Coated or plated with precious metal",
      "units": [
        "kg"
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.49.4000",
      "rawHtsCode": "8302.49.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8302.49.60",
      "rawHtsCode": "8302.49.60",
      "superior": null,
      "indent": "4",
      "description": "Of iron or steel, of aluminum or of zinc",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.49.6035",
      "rawHtsCode": "8302.49.60.35",
      "superior": null,
      "indent": "5",
      "description": "Pneumatic cylinders for lifting, lowering, dampening or counterbalancing",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.49.6045",
      "rawHtsCode": "8302.49.60.45",
      "superior": null,
      "indent": "6",
      "description": "For railway vehicles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.49.6055",
      "rawHtsCode": "8302.49.60.55",
      "superior": null,
      "indent": "6",
      "description": "For aircraft, vessels and other vehicles (except motor vehicles) of section XVII",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.49.6085",
      "rawHtsCode": "8302.49.60.85",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.49.80",
      "rawHtsCode": "8302.49.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.49.8040",
      "rawHtsCode": "8302.49.80.40",
      "superior": null,
      "indent": "6",
      "description": "Of copper",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.49.8050",
      "rawHtsCode": "8302.49.80.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.49.8090",
      "rawHtsCode": "8302.49.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.50.0000",
      "rawHtsCode": "8302.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hat-racks, hat pegs, brackets and similar fixtures, and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8302.60",
      "rawHtsCode": "8302.60",
      "superior": null,
      "indent": "1",
      "description": "Automatic door closers, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8302.60.3000",
      "rawHtsCode": "8302.60.30.00",
      "superior": null,
      "indent": "2",
      "description": "Automatic door closers",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8302.60.9000",
      "rawHtsCode": "8302.60.90.00",
      "superior": null,
      "indent": "2",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8303.00.0000",
      "rawHtsCode": "8303.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Armored or reinforced safes, strong-boxes and doors and safe deposit lockers for strong-rooms, cash or deed boxes and the like, and parts thereof, of base metal",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8304.00.0000",
      "rawHtsCode": "8304.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Desk-top filing or card-index cabinets, paper trays, paper rests, pen trays, office-stamp stands and similar office or desk equipment and parts thereof, of base metal, other than office furniture of heading 9403",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8305",
      "rawHtsCode": "8305",
      "superior": null,
      "indent": "0",
      "description": "Fittings for looseleaf binders or files, letter clips, letter corners, paper clips, indexing tags and similar office articles, and parts thereof, of base metal; staples in strips (for example, for offices, upholstery, packaging), of base metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8305.10.00",
      "rawHtsCode": "8305.10.00",
      "superior": null,
      "indent": "1",
      "description": "Fittings for looseleaf binders or files",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8305.10.0010",
      "rawHtsCode": "8305.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Ring binder mechanisms",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8305.10.0050",
      "rawHtsCode": "8305.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8305.20.0000",
      "rawHtsCode": "8305.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Staples in strips",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "4%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "8305.90",
      "rawHtsCode": "8305.90",
      "superior": null,
      "indent": "1",
      "description": "Other, including parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8305.90.30",
      "rawHtsCode": "8305.90.30",
      "superior": null,
      "indent": "2",
      "description": "Paper clips, and parts thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8305.90.3010",
      "rawHtsCode": "8305.90.30.10",
      "superior": null,
      "indent": "3",
      "description": "Wholly of wire",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8305.90.3050",
      "rawHtsCode": "8305.90.30.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8305.90.6000",
      "rawHtsCode": "8305.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8306",
      "rawHtsCode": "8306",
      "superior": null,
      "indent": "0",
      "description": "Bells, gongs and the like, nonelectric, of base metal; statuettes and other ornaments, of base metal; photograph, picture or similar frames, of base metal; mirrors of base metal; and base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8306.10.0000",
      "rawHtsCode": "8306.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Bells, gongs and the like, and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8306.21.0000",
      "rawHtsCode": "8306.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Plated with precious metal, and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8306.29.0000",
      "rawHtsCode": "8306.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "46%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8306.30.0000",
      "rawHtsCode": "8306.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Photograph, picture or similar frames; mirrors; and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8307",
      "rawHtsCode": "8307",
      "superior": null,
      "indent": "0",
      "description": "Flexible tubing of base metal, with or without fittings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8307.10",
      "rawHtsCode": "8307.10",
      "superior": null,
      "indent": "1",
      "description": "Of iron or steel:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8307.10.3000",
      "rawHtsCode": "8307.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "With fittings",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8307.10.6000",
      "rawHtsCode": "8307.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8307.90",
      "rawHtsCode": "8307.90",
      "superior": null,
      "indent": "1",
      "description": "Of other base metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8307.90.3000",
      "rawHtsCode": "8307.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "With fittings",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8307.90.6000",
      "rawHtsCode": "8307.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8308",
      "rawHtsCode": "8308",
      "superior": null,
      "indent": "0",
      "description": "Clasps, frames with clasps, buckles, buckle-clasps, hooks, eyes, eyelets and the like, of base metal, of a kind used for clothing or clothing accessories, footwear, jewelry, wrist watches, books, awnings, leather goods, travel goods or saddlery or for other made up articles; tubular or bifurcated rivets, of base metal; beads and spangles, of base metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8308.10.0000",
      "rawHtsCode": "8308.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hooks, eyes and eyelets",
      "units": [
        "kg"
      ],
      "generalRate": "1.1¢/kg + 2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10¢/kg + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8308.20",
      "rawHtsCode": "8308.20",
      "superior": null,
      "indent": "1",
      "description": "Tubular or bifurcated rivets:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8308.20.3000",
      "rawHtsCode": "8308.20.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of iron or steel and not brightened, not lathed and not machined",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8308.20.6000",
      "rawHtsCode": "8308.20.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8308.90",
      "rawHtsCode": "8308.90",
      "superior": null,
      "indent": "1",
      "description": "Other, including parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8308.90.3000",
      "rawHtsCode": "8308.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Beads and spangles of base metal",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8308.90.6000",
      "rawHtsCode": "8308.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Buckles and buckle clasps, and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8308.90.9000",
      "rawHtsCode": "8308.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8309",
      "rawHtsCode": "8309",
      "superior": null,
      "indent": "0",
      "description": "Stoppers, caps and lids (including crown corks, screw caps and pouring stoppers), capsules for bottles, threaded bungs, bung covers, seals and other packing accessories, and parts thereof, of base metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8309.10.0000",
      "rawHtsCode": "8309.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Crown corks (including crown seals and caps), and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8309.90.00",
      "rawHtsCode": "8309.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8309.90.0020",
      "rawHtsCode": "8309.90.00.20",
      "superior": null,
      "indent": "3",
      "description": "For cans of a kind used for the conveyance of beverages as described in statistical note 1 to this chapter",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8309.90.0025",
      "rawHtsCode": "8309.90.00.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8309.90.0080",
      "rawHtsCode": "8309.90.00.80",
      "superior": null,
      "indent": "3",
      "description": "Of steel",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8309.90.0085",
      "rawHtsCode": "8309.90.00.85",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8310.00.0000",
      "rawHtsCode": "8310.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Sign plates, name plates, address plates and similar plates, numbers, letters and other symbols, and parts thereof, of base metal, excluding those of heading 9405",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8311",
      "rawHtsCode": "8311",
      "superior": null,
      "indent": "0",
      "description": "Wire, rods, tubes, plates, electrodes and similar products of base metal or of metal carbides, coated or cored with flux material, of a kind used for soldering, brazing, welding or deposition of metal or of metal carbides; wire and rods, of agglomerated base metal powder, used for metal spraying; base metal parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8311.10.0000",
      "rawHtsCode": "8311.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Coated electrodes of base metal, for electric arc-welding",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8311.20.0000",
      "rawHtsCode": "8311.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cored wire of base metal, for electric arc-welding",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8311.30",
      "rawHtsCode": "8311.30",
      "superior": null,
      "indent": "1",
      "description": "Coated rods and cored wire, of base metal, for soldering, brazing or welding by flame:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8311.30.3000",
      "rawHtsCode": "8311.30.30.00",
      "superior": null,
      "indent": "2",
      "description": "Lead-tin solders",
      "units": [
        "kg",
        "Pb kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.5¢/kg on lead content",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8311.30.6000",
      "rawHtsCode": "8311.30.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8311.90.0000",
      "rawHtsCode": "8311.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8401",
      "rawHtsCode": "8401",
      "superior": null,
      "indent": "0",
      "description": "Nuclear reactors; fuel elements (cartridges), non-irradiated, for nuclear reactors; machinery and apparatus for isotopic separation; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8401.10.0000",
      "rawHtsCode": "8401.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Nuclear reactors",
      "units": [
        "t"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8401.20.0000",
      "rawHtsCode": "8401.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery and apparatus for isotopic separation, and parts thereof",
      "units": [
        "t"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8401.30.0000",
      "rawHtsCode": "8401.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Fuel elements (cartridges), non-irradiated, and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8401.40.0000",
      "rawHtsCode": "8401.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts of nuclear reactors",
      "units": [
        "t"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8402",
      "rawHtsCode": "8402",
      "superior": null,
      "indent": "0",
      "description": "Steam or other vapor generating boilers (other than central heating hot water boilers capable also of producing low pressure steam); super-heated water boilers; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8402.11.0000",
      "rawHtsCode": "8402.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Watertube boilers with a steam production exceeding 45 t per hour",
      "units": [
        "t"
      ],
      "generalRate": "5.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8402.12.0000",
      "rawHtsCode": "8402.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Watertube boilers with a steam production not exceeding 45 t per hour",
      "units": [
        "t"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8402.19.0000",
      "rawHtsCode": "8402.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other vapor generating boilers, including hybrid boilers",
      "units": [
        "t"
      ],
      "generalRate": "5.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8402.20.0000",
      "rawHtsCode": "8402.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Super-heated water boilers",
      "units": [
        "t"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8402.90.00",
      "rawHtsCode": "8402.90.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [],
      "generalRate": "4.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8402.90.0010",
      "rawHtsCode": "8402.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Heat exchangers",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8402.90.0090",
      "rawHtsCode": "8402.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8403",
      "rawHtsCode": "8403",
      "superior": null,
      "indent": "0",
      "description": "Central heating boilers (other than those of heading 8402) and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8403.10.0000",
      "rawHtsCode": "8403.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Boilers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8403.90.0000",
      "rawHtsCode": "8403.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8404",
      "rawHtsCode": "8404",
      "superior": null,
      "indent": "0",
      "description": "Auxiliary plant for use with boilers of heading 8402 or 8403 (for example, economizers, super-heaters, soot removers, gas recoverers); condensers for steam or other vapor power units; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8404.10.00",
      "rawHtsCode": "8404.10.00",
      "superior": null,
      "indent": "1",
      "description": "Auxiliary plant for use with boilers of heading 8402 or 8403",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8404.10.0010",
      "rawHtsCode": "8404.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Economizers",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8404.10.0050",
      "rawHtsCode": "8404.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "t"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8404.20.0000",
      "rawHtsCode": "8404.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Condensers for steam or other vapor power units",
      "units": [
        "t"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8404.90.0000",
      "rawHtsCode": "8404.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8405",
      "rawHtsCode": "8405",
      "superior": null,
      "indent": "0",
      "description": "Producer gas or water gas generators, with or without their purifiers; acetylene gas generators and similar water process gas generators, with or without their purifiers; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8405.10.0000",
      "rawHtsCode": "8405.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Producer gas or water gas generators, with or without their purifiers; acetylene gas generators and similar water process gas generators, with or without their purifiers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8405.90.0000",
      "rawHtsCode": "8405.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8406",
      "rawHtsCode": "8406",
      "superior": null,
      "indent": "0",
      "description": "Steam turbines and other vapor turbines, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.10",
      "rawHtsCode": "8406.10",
      "superior": null,
      "indent": "1",
      "description": "Turbines for marine propulsion:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.10.1000",
      "rawHtsCode": "8406.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Steam turbines",
      "units": [
        "No."
      ],
      "generalRate": "6.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8406.10.9000",
      "rawHtsCode": "8406.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8406.81",
      "rawHtsCode": "8406.81",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding 40 MW:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.81.10",
      "rawHtsCode": "8406.81.10",
      "superior": null,
      "indent": "3",
      "description": "Steam turbines",
      "units": [],
      "generalRate": "6.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.35% (JP)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8406.81.1020",
      "rawHtsCode": "8406.81.10.20",
      "superior": null,
      "indent": "4",
      "description": "Stationary steam turbines, condensing type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.81.1070",
      "rawHtsCode": "8406.81.10.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.81.9000",
      "rawHtsCode": "8406.81.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8406.82",
      "rawHtsCode": "8406.82",
      "superior": null,
      "indent": "2",
      "description": "Of an output not exceeding 40 MW:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.82.10",
      "rawHtsCode": "8406.82.10",
      "superior": null,
      "indent": "3",
      "description": "Steam turbines",
      "units": [],
      "generalRate": "6.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8406.82.1010",
      "rawHtsCode": "8406.82.10.10",
      "superior": null,
      "indent": "5",
      "description": "Not exceeding <il>7,460 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.82.1020",
      "rawHtsCode": "8406.82.10.20",
      "superior": null,
      "indent": "5",
      "description": "Exceeding <il>7,460 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.82.1050",
      "rawHtsCode": "8406.82.10.50",
      "superior": null,
      "indent": "5",
      "description": "Not exceeding <il>7,460 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.82.1070",
      "rawHtsCode": "8406.82.10.70",
      "superior": null,
      "indent": "5",
      "description": "Exceeding <il>7,460 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.82.9000",
      "rawHtsCode": "8406.82.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8406.90",
      "rawHtsCode": "8406.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.90.2000",
      "rawHtsCode": "8406.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Rotors, finished for final assembly",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8406.90.3000",
      "rawHtsCode": "8406.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Rotors, not further advanced than cleaned or machined for removal of fins, gates, sprues, and risers, or to permit location in finishing machinery",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8406.90.4000",
      "rawHtsCode": "8406.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Blades, rotating or stationary",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8406.90.45",
      "rawHtsCode": "8406.90.45",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8406.90.4540",
      "rawHtsCode": "8406.90.45.40",
      "superior": null,
      "indent": "4",
      "description": "Rotors or spindles and rotor or spindle assemblies",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.90.4580",
      "rawHtsCode": "8406.90.45.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8406.90.5000",
      "rawHtsCode": "8406.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Rotors, finished for final assembly",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8406.90.6000",
      "rawHtsCode": "8406.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Rotors, not further advanced than cleaned or machined for removal of fins, gates, sprues, and risers, or to permit location in finishing machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8406.90.7000",
      "rawHtsCode": "8406.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "Blades, rotating or stationary",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8406.90.7500",
      "rawHtsCode": "8406.90.75.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8407",
      "rawHtsCode": "8407",
      "superior": null,
      "indent": "0",
      "description": "Spark-ignition reciprocating or rotary internal combustion piston engines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.10.00",
      "rawHtsCode": "8407.10.00",
      "superior": null,
      "indent": "1",
      "description": "Aircraft engines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.10.0020",
      "rawHtsCode": "8407.10.00.20",
      "superior": null,
      "indent": "4",
      "description": "Less than <il>373 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.10.0040",
      "rawHtsCode": "8407.10.00.40",
      "superior": null,
      "indent": "4",
      "description": "<il>373 kW</il> or over",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.10.0060",
      "rawHtsCode": "8407.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.10.0090",
      "rawHtsCode": "8407.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.21.00",
      "rawHtsCode": "8407.21.00",
      "superior": null,
      "indent": "2",
      "description": "Outboard motors",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8407.21.0040",
      "rawHtsCode": "8407.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Less than <il>22.38 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.21.0080",
      "rawHtsCode": "8407.21.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.29.00",
      "rawHtsCode": "8407.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.29.0010",
      "rawHtsCode": "8407.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Inboard engines with outboard drive",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.29.0020",
      "rawHtsCode": "8407.29.00.20",
      "superior": null,
      "indent": "4",
      "description": "Less than <il>746 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.29.0030",
      "rawHtsCode": "8407.29.00.30",
      "superior": null,
      "indent": "4",
      "description": "<il>746 W</il> or greater, but not exceeding <il>18.65 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.29.0040",
      "rawHtsCode": "8407.29.00.40",
      "superior": null,
      "indent": "4",
      "description": "Exceeding <il>18.65 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.31.00",
      "rawHtsCode": "8407.31.00",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity not exceeding <il>50 cc</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.31.0040",
      "rawHtsCode": "8407.31.00.40",
      "superior": null,
      "indent": "3",
      "description": "Less than <il>746 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.31.0080",
      "rawHtsCode": "8407.31.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.32",
      "rawHtsCode": "8407.32",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity exceeding <il>50 cc</il> but not exceeding <il>250 cc</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.32.1000",
      "rawHtsCode": "8407.32.10.00",
      "superior": null,
      "indent": "3",
      "description": "To be installed in tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.32.20",
      "rawHtsCode": "8407.32.20",
      "superior": null,
      "indent": "3",
      "description": "To be installed in vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29, or heading 8702, 8703 or 8704",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8407.32.2040",
      "rawHtsCode": "8407.32.20.40",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.32.2080",
      "rawHtsCode": "8407.32.20.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.32.90",
      "rawHtsCode": "8407.32.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.32.9040",
      "rawHtsCode": "8407.32.90.40",
      "superior": null,
      "indent": "4",
      "description": "Not exceeding <il>18.65 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.32.9080",
      "rawHtsCode": "8407.32.90.80",
      "superior": null,
      "indent": "4",
      "description": "Exceeding <il>18.65 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.33",
      "rawHtsCode": "8407.33",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity exceeding <il>250 cc</il> but not exceeding <il>1,000 cc</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.33.10",
      "rawHtsCode": "8407.33.10",
      "superior": null,
      "indent": "3",
      "description": "To be installed in tractors suitable for agricultural use",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.33.1030",
      "rawHtsCode": "8407.33.10.30",
      "superior": null,
      "indent": "4",
      "description": "Not exceeding <il>37.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.33.1060",
      "rawHtsCode": "8407.33.10.60",
      "superior": null,
      "indent": "5",
      "description": "Air-cooled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.33.1090",
      "rawHtsCode": "8407.33.10.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.33.30",
      "rawHtsCode": "8407.33.30",
      "superior": null,
      "indent": "4",
      "description": "To be installed in vehicles specially designed for traveling on snow, golf carts, non-amphibious all-terrain vehicles and burden carriers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8407.33.3040",
      "rawHtsCode": "8407.33.30.40",
      "superior": null,
      "indent": "5",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.33.3080",
      "rawHtsCode": "8407.33.30.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.33.60",
      "rawHtsCode": "8407.33.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8407.33.6040",
      "rawHtsCode": "8407.33.60.40",
      "superior": null,
      "indent": "5",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.33.6080",
      "rawHtsCode": "8407.33.60.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.33.90",
      "rawHtsCode": "8407.33.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.33.9040",
      "rawHtsCode": "8407.33.90.40",
      "superior": null,
      "indent": "4",
      "description": "Not exceeding <il>18.65 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.33.9080",
      "rawHtsCode": "8407.33.90.80",
      "superior": null,
      "indent": "4",
      "description": "Exceeding <il>18.65 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.34",
      "rawHtsCode": "8407.34",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity exceeding <il>1,000 cc</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.34.05",
      "rawHtsCode": "8407.34.05",
      "superior": null,
      "indent": "4",
      "description": "To be installed in tractors suitable for agricultural use",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.34.0530",
      "rawHtsCode": "8407.34.05.30",
      "superior": null,
      "indent": "5",
      "description": "Not exceeding <il>37.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.34.0560",
      "rawHtsCode": "8407.34.05.60",
      "superior": null,
      "indent": "6",
      "description": "Air-cooled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.34.0590",
      "rawHtsCode": "8407.34.05.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.34.1400",
      "rawHtsCode": "8407.34.14.00",
      "superior": null,
      "indent": "5",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8407.34.1800",
      "rawHtsCode": "8407.34.18.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8407.34.2500",
      "rawHtsCode": "8407.34.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.34.35",
      "rawHtsCode": "8407.34.35",
      "superior": null,
      "indent": "4",
      "description": "To be installed in tractors suitable for agricultural use",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.34.3530",
      "rawHtsCode": "8407.34.35.30",
      "superior": null,
      "indent": "5",
      "description": "Not exceeding <il>37.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.34.3560",
      "rawHtsCode": "8407.34.35.60",
      "superior": null,
      "indent": "6",
      "description": "Air-cooled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.34.3590",
      "rawHtsCode": "8407.34.35.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.34.4400",
      "rawHtsCode": "8407.34.44.00",
      "superior": null,
      "indent": "5",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8407.34.4800",
      "rawHtsCode": "8407.34.48.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8407.34.5500",
      "rawHtsCode": "8407.34.55.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.90",
      "rawHtsCode": "8407.90",
      "superior": null,
      "indent": "1",
      "description": "Other engines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.90.10",
      "rawHtsCode": "8407.90.10",
      "superior": null,
      "indent": "2",
      "description": "To be installed in agricultural or horticultural machinery or equipment",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.90.1010",
      "rawHtsCode": "8407.90.10.10",
      "superior": null,
      "indent": "4",
      "description": "Less than 4,476 W",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.90.1020",
      "rawHtsCode": "8407.90.10.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.90.1060",
      "rawHtsCode": "8407.90.10.60",
      "superior": null,
      "indent": "4",
      "description": "Air-cooled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.90.1080",
      "rawHtsCode": "8407.90.10.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.90.90",
      "rawHtsCode": "8407.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8407.90.9010",
      "rawHtsCode": "8407.90.90.10",
      "superior": null,
      "indent": "3",
      "description": "Gas (natural or liquid propane (LP)) engines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8407.90.9020",
      "rawHtsCode": "8407.90.90.20",
      "superior": null,
      "indent": "4",
      "description": "Less than <il>746 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.90.9040",
      "rawHtsCode": "8407.90.90.40",
      "superior": null,
      "indent": "4",
      "description": "<il>746 W</il> or greater but less than <il>4,476 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.90.9060",
      "rawHtsCode": "8407.90.90.60",
      "superior": null,
      "indent": "4",
      "description": "<il>4,476 W</il> or greater but not exceeding <il>18.65 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8407.90.9080",
      "rawHtsCode": "8407.90.90.80",
      "superior": null,
      "indent": "4",
      "description": "Exceeding <il>18.65 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408",
      "rawHtsCode": "8408",
      "superior": null,
      "indent": "0",
      "description": "Compression-ignition internal combustion piston engines (diesel or semi-diesel engines):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.10.00",
      "rawHtsCode": "8408.10.00",
      "superior": null,
      "indent": "1",
      "description": "Marine propulsion engines",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8408.10.0005",
      "rawHtsCode": "8408.10.00.05",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding <il>111.9 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.10.0015",
      "rawHtsCode": "8408.10.00.15",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>111.9 kW</il> but not exceeding <il>149.2 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.10.0020",
      "rawHtsCode": "8408.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>149.2 kW</il> but not exceeding <il>223.8 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.10.0030",
      "rawHtsCode": "8408.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>223.8 kW</il> but not exceeding <il>373 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.10.0040",
      "rawHtsCode": "8408.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>373 kW</il> but not exceeding <il>746 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.10.0050",
      "rawHtsCode": "8408.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>746 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.20",
      "rawHtsCode": "8408.20",
      "superior": null,
      "indent": "1",
      "description": "Engines of a kind used for the propulsion of vehicles of chapter 87:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.20.10",
      "rawHtsCode": "8408.20.10",
      "superior": null,
      "indent": "2",
      "description": "To be installed in tractors suitable for agricultural use",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8408.20.1040",
      "rawHtsCode": "8408.20.10.40",
      "superior": null,
      "indent": "3",
      "description": "Not exceeding <il>37.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.20.1080",
      "rawHtsCode": "8408.20.10.80",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>37.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.20.2000",
      "rawHtsCode": "8408.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "To be installed in vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29, or heading 8702, 8703 or 8704",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8408.20.9000",
      "rawHtsCode": "8408.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8408.90",
      "rawHtsCode": "8408.90",
      "superior": null,
      "indent": "1",
      "description": "Other engines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.90.10",
      "rawHtsCode": "8408.90.10",
      "superior": null,
      "indent": "2",
      "description": "To be installed in agricultural or horticultural machinery or equipment",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.      "
      ],
      "flags": []
    },
    {
      "htsCode": "8408.90.1040",
      "rawHtsCode": "8408.90.10.40",
      "superior": null,
      "indent": "3",
      "description": "Not exceeding <il>37.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.90.1080",
      "rawHtsCode": "8408.90.10.80",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>37.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.90.90",
      "rawHtsCode": "8408.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8408.90.9010",
      "rawHtsCode": "8408.90.90.10",
      "superior": null,
      "indent": "3",
      "description": "Not exceeding <il>149.2 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.90.9020",
      "rawHtsCode": "8408.90.90.20",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>149.2 kW</il> but not exceeding <il>373 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.90.9030",
      "rawHtsCode": "8408.90.90.30",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>373 kW </il>but not exceeding <il>746 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.90.9040",
      "rawHtsCode": "8408.90.90.40",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>746 kW</il> but not exceeding <il>1,119 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8408.90.9050",
      "rawHtsCode": "8408.90.90.50",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>1,119 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409",
      "rawHtsCode": "8409",
      "superior": null,
      "indent": "0",
      "description": "Parts suitable for use solely or principally with the engines of heading 8407 or 8408:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.10.00",
      "rawHtsCode": "8409.10.00",
      "superior": null,
      "indent": "1",
      "description": "For aircraft engines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8409.10.0040",
      "rawHtsCode": "8409.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "For use in civil aircraft",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See General Note 6."
      ],
      "flags": []
    },
    {
      "htsCode": "8409.10.0080",
      "rawHtsCode": "8409.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.91",
      "rawHtsCode": "8409.91",
      "superior": null,
      "indent": "2",
      "description": "Suitable for use solely or principally with spark-ignition internal combustion piston engines (including rotary engines):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.91.10",
      "rawHtsCode": "8409.91.10",
      "superior": null,
      "indent": "3",
      "description": "Cast-iron parts, not advanced beyond cleaning, and machined only for the removal of fins, gates, sprues and risers or to permit location in finishing machinery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8409.91.1040",
      "rawHtsCode": "8409.91.10.40",
      "superior": null,
      "indent": "4",
      "description": "For vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29, or heading 8702, 8703 or 8704",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.91.1060",
      "rawHtsCode": "8409.91.10.60",
      "superior": null,
      "indent": "4",
      "description": "For marine propulsion engines",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.91.1080",
      "rawHtsCode": "8409.91.10.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.91.3000",
      "rawHtsCode": "8409.91.30.00",
      "superior": null,
      "indent": "5",
      "description": "Aluminum cylinder heads",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8409.91.50",
      "rawHtsCode": "8409.91.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8409.91.5010",
      "rawHtsCode": "8409.91.50.10",
      "superior": null,
      "indent": "6",
      "description": "Connecting rods",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.91.5081",
      "rawHtsCode": "8409.91.50.81",
      "superior": null,
      "indent": "6",
      "description": "Steel forgings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.91.5085",
      "rawHtsCode": "8409.91.50.85",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.91.92",
      "rawHtsCode": "8409.91.92",
      "superior": null,
      "indent": "4",
      "description": "For marine propulsion engines",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8409.91.9210",
      "rawHtsCode": "8409.91.92.10",
      "superior": null,
      "indent": "5",
      "description": "Connecting rods",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.91.9290",
      "rawHtsCode": "8409.91.92.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.91.99",
      "rawHtsCode": "8409.91.99",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8409.91.9910",
      "rawHtsCode": "8409.91.99.10",
      "superior": null,
      "indent": "5",
      "description": "Connecting rods",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.91.9990",
      "rawHtsCode": "8409.91.99.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.99",
      "rawHtsCode": "8409.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.99.10",
      "rawHtsCode": "8409.99.10",
      "superior": null,
      "indent": "3",
      "description": "Cast-iron parts, not advanced beyond cleaning, and machined only for the removal of fins, gates, sprues and risers or to permit location in finishing machinery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8409.99.1040",
      "rawHtsCode": "8409.99.10.40",
      "superior": null,
      "indent": "4",
      "description": "For vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29, or heading 8702, 8703 or 8704",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.99.1060",
      "rawHtsCode": "8409.99.10.60",
      "superior": null,
      "indent": "4",
      "description": "For marine propulsion engines",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.99.1080",
      "rawHtsCode": "8409.99.10.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.99.91",
      "rawHtsCode": "8409.99.91",
      "superior": null,
      "indent": "4",
      "description": "To be installed in vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29, or heading 8702, 8703 or 8704",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8409.99.9110",
      "rawHtsCode": "8409.99.91.10",
      "superior": null,
      "indent": "5",
      "description": "Connecting rods",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.99.9190",
      "rawHtsCode": "8409.99.91.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.99.92",
      "rawHtsCode": "8409.99.92",
      "superior": null,
      "indent": "4",
      "description": "For marine propulsion engines",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8409.99.9210",
      "rawHtsCode": "8409.99.92.10",
      "superior": null,
      "indent": "5",
      "description": "Connecting rods",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.99.9290",
      "rawHtsCode": "8409.99.92.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.99.99",
      "rawHtsCode": "8409.99.99",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8409.99.9910",
      "rawHtsCode": "8409.99.99.10",
      "superior": null,
      "indent": "5",
      "description": "Connecting rods",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8409.99.9990",
      "rawHtsCode": "8409.99.99.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8410",
      "rawHtsCode": "8410",
      "superior": null,
      "indent": "0",
      "description": "Hydraulic turbines, water wheels and regulators therefor; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8410.11.0000",
      "rawHtsCode": "8410.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a power not exceeding <il>1,000 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8410.12.0000",
      "rawHtsCode": "8410.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a power exceeding <il>1,000 kW</il> but not exceeding <il>10,000 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8410.13.0000",
      "rawHtsCode": "8410.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a power exceeding <il>10,000 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8410.90.0000",
      "rawHtsCode": "8410.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts, including regulators",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8411",
      "rawHtsCode": "8411",
      "superior": null,
      "indent": "0",
      "description": "Turbojets, turbopropellers and other gas turbines, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.11",
      "rawHtsCode": "8411.11",
      "superior": null,
      "indent": "2",
      "description": "Of a thrust not exceeding 25 kN:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.11.4000",
      "rawHtsCode": "8411.11.40.00",
      "superior": null,
      "indent": "3",
      "description": "Aircraft turbines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.11.8000",
      "rawHtsCode": "8411.11.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.12",
      "rawHtsCode": "8411.12",
      "superior": null,
      "indent": "2",
      "description": "Of a thrust exceeding 25 kN:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.12.4000",
      "rawHtsCode": "8411.12.40.00",
      "superior": null,
      "indent": "3",
      "description": "Aircraft turbines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.12.8000",
      "rawHtsCode": "8411.12.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.21",
      "rawHtsCode": "8411.21",
      "superior": null,
      "indent": "2",
      "description": "Of a power not exceeding <il>1,100 kW</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.21.4000",
      "rawHtsCode": "8411.21.40.00",
      "superior": null,
      "indent": "3",
      "description": "Aircraft turbines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.21.8000",
      "rawHtsCode": "8411.21.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.22",
      "rawHtsCode": "8411.22",
      "superior": null,
      "indent": "2",
      "description": "Of a power exceeding <il>1,100 kW</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.22.4000",
      "rawHtsCode": "8411.22.40.00",
      "superior": null,
      "indent": "3",
      "description": "Aircraft turbines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.22.8000",
      "rawHtsCode": "8411.22.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.81",
      "rawHtsCode": "8411.81",
      "superior": null,
      "indent": "2",
      "description": "Of a power not exceeding <il>5,000 kW</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.81.4000",
      "rawHtsCode": "8411.81.40.00",
      "superior": null,
      "indent": "3",
      "description": "Aircraft turbines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.81.80",
      "rawHtsCode": "8411.81.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8411.81.8010",
      "rawHtsCode": "8411.81.80.10",
      "superior": null,
      "indent": "4",
      "description": "Industrial turbines of a kind described in statistical note 1 of this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.81.8090",
      "rawHtsCode": "8411.81.80.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.82",
      "rawHtsCode": "8411.82",
      "superior": null,
      "indent": "2",
      "description": "Of a power exceeding <il>5,000 kW</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.82.4000",
      "rawHtsCode": "8411.82.40.00",
      "superior": null,
      "indent": "3",
      "description": "Aircraft turbines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.82.80",
      "rawHtsCode": "8411.82.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8411.82.8010",
      "rawHtsCode": "8411.82.80.10",
      "superior": null,
      "indent": "4",
      "description": "Industrial turbines of a kind described in statistical note 1 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.82.8090",
      "rawHtsCode": "8411.82.80.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.91",
      "rawHtsCode": "8411.91",
      "superior": null,
      "indent": "2",
      "description": "Of turbojets or turbopropellers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.91.10",
      "rawHtsCode": "8411.91.10",
      "superior": null,
      "indent": "3",
      "description": "Cast-iron parts, not advanced beyond cleaning, and machined only for the removal of fins, gates, sprues and risers or to permit location in finishing machinery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.91.1040",
      "rawHtsCode": "8411.91.10.40",
      "superior": null,
      "indent": "4",
      "description": "Parts of nonaircraft turbines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.91.1060",
      "rawHtsCode": "8411.91.10.60",
      "superior": null,
      "indent": "5",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See General Note 6. "
      ],
      "flags": []
    },
    {
      "htsCode": "8411.91.1090",
      "rawHtsCode": "8411.91.10.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.91.90",
      "rawHtsCode": "8411.91.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.91.9040",
      "rawHtsCode": "8411.91.90.40",
      "superior": null,
      "indent": "4",
      "description": "Parts of nonaircraft turbines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.91.9081",
      "rawHtsCode": "8411.91.90.81",
      "superior": null,
      "indent": "5",
      "description": "Steel forgings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.91.9085",
      "rawHtsCode": "8411.91.90.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.99",
      "rawHtsCode": "8411.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.99.10",
      "rawHtsCode": "8411.99.10",
      "superior": null,
      "indent": "3",
      "description": "Cast-iron parts, not advanced beyond cleaning, and machined only for the removal of fins, gates, sprues and risers or to permit location in finishing machinery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8411.99.1010",
      "rawHtsCode": "8411.99.10.10",
      "superior": null,
      "indent": "4",
      "description": "Parts of nonaircraft gas turbines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.99.1040",
      "rawHtsCode": "8411.99.10.40",
      "superior": null,
      "indent": "5",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See General Note 6. "
      ],
      "flags": []
    },
    {
      "htsCode": "8411.99.1080",
      "rawHtsCode": "8411.99.10.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.99.90",
      "rawHtsCode": "8411.99.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8411.99.9030",
      "rawHtsCode": "8411.99.90.30",
      "superior": null,
      "indent": "5",
      "description": "Rotors or spindles and rotor or spindle assemblies",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.99.9081",
      "rawHtsCode": "8411.99.90.81",
      "superior": null,
      "indent": "6",
      "description": "Steel forgings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.99.9085",
      "rawHtsCode": "8411.99.90.85",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8411.99.9090",
      "rawHtsCode": "8411.99.90.90",
      "superior": null,
      "indent": "4",
      "description": "Parts of aircraft gas turbines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412",
      "rawHtsCode": "8412",
      "superior": null,
      "indent": "0",
      "description": "Other engines and motors, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.10.00",
      "rawHtsCode": "8412.10.00",
      "superior": null,
      "indent": "1",
      "description": "Reaction engines other than turbojets",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8412.10.0010",
      "rawHtsCode": "8412.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Missile and rocket engines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.10.0090",
      "rawHtsCode": "8412.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.21.00",
      "rawHtsCode": "8412.21.00",
      "superior": null,
      "indent": "2",
      "description": "Linear acting (cylinders)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8412.21.0015",
      "rawHtsCode": "8412.21.00.15",
      "superior": null,
      "indent": "3",
      "description": "Tie-rod type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.21.0030",
      "rawHtsCode": "8412.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Weld fused type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.21.0045",
      "rawHtsCode": "8412.21.00.45",
      "superior": null,
      "indent": "4",
      "description": "Telescoping",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.21.0060",
      "rawHtsCode": "8412.21.00.60",
      "superior": null,
      "indent": "4",
      "description": "Rodless",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.21.0075",
      "rawHtsCode": "8412.21.00.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.29",
      "rawHtsCode": "8412.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.29.4000",
      "rawHtsCode": "8412.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "Hydrojet engines for marine propulsion",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8412.29.80",
      "rawHtsCode": "8412.29.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8412.29.8015",
      "rawHtsCode": "8412.29.80.15",
      "superior": null,
      "indent": "5",
      "description": "Gear type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.29.8030",
      "rawHtsCode": "8412.29.80.30",
      "superior": null,
      "indent": "5",
      "description": "Radial piston type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.29.8045",
      "rawHtsCode": "8412.29.80.45",
      "superior": null,
      "indent": "5",
      "description": "Axial piston type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.29.8060",
      "rawHtsCode": "8412.29.80.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.29.8075",
      "rawHtsCode": "8412.29.80.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.31.00",
      "rawHtsCode": "8412.31.00",
      "superior": null,
      "indent": "2",
      "description": "Linear acting (cylinders)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8412.31.0040",
      "rawHtsCode": "8412.31.00.40",
      "superior": null,
      "indent": "3",
      "description": "Tie-rod type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.31.0080",
      "rawHtsCode": "8412.31.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.39.00",
      "rawHtsCode": "8412.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8412.39.0040",
      "rawHtsCode": "8412.39.00.40",
      "superior": null,
      "indent": "3",
      "description": "Unlimited rotary acting",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.39.0080",
      "rawHtsCode": "8412.39.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.80",
      "rawHtsCode": "8412.80",
      "superior": null,
      "indent": "1",
      "description": "Other engines and motors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.80.1000",
      "rawHtsCode": "8412.80.10.00",
      "superior": null,
      "indent": "2",
      "description": "Spring-operated and weight-operated motors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8412.80.9000",
      "rawHtsCode": "8412.80.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8412.90",
      "rawHtsCode": "8412.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.90.1000",
      "rawHtsCode": "8412.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of hydrojet engines for marine propulsion",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8412.90.90",
      "rawHtsCode": "8412.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8412.90.9005",
      "rawHtsCode": "8412.90.90.05",
      "superior": null,
      "indent": "4",
      "description": "Of linear acting engines and motors",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.90.9015",
      "rawHtsCode": "8412.90.90.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.90.9025",
      "rawHtsCode": "8412.90.90.25",
      "superior": null,
      "indent": "4",
      "description": "Of linear acting engines and motors",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.90.9035",
      "rawHtsCode": "8412.90.90.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.90.9050",
      "rawHtsCode": "8412.90.90.50",
      "superior": null,
      "indent": "3",
      "description": "Of reaction engines other than turbojets",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.90.9070",
      "rawHtsCode": "8412.90.90.70",
      "superior": null,
      "indent": "4",
      "description": "Wind turbine blades, imported in accordance with statistical note 2 of this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.90.9075",
      "rawHtsCode": "8412.90.90.75",
      "superior": null,
      "indent": "4",
      "description": "Wind turbine hubs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8412.90.9085",
      "rawHtsCode": "8412.90.90.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413",
      "rawHtsCode": "8413",
      "superior": null,
      "indent": "0",
      "description": "Pumps for liquids, whether or not fitted with a measuring device; liquid elevators; part thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.11.0000",
      "rawHtsCode": "8413.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Pumps for dispensing fuel or lubricants, of the type used in filling-stations or in garages",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8413.19.0000",
      "rawHtsCode": "8413.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01.  "
      ],
      "flags": []
    },
    {
      "htsCode": "8413.20.0000",
      "rawHtsCode": "8413.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hand pumps, other than those of subheading 8413.11 or 8413.19",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8413.30",
      "rawHtsCode": "8413.30",
      "superior": null,
      "indent": "1",
      "description": "Fuel, lubricating or cooling medium pumps for internal combustion piston engines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.30.1000",
      "rawHtsCode": "8413.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Fuel-injection pumps for compression-ignition engines",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8413.30.90",
      "rawHtsCode": "8413.30.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8413.30.9030",
      "rawHtsCode": "8413.30.90.30",
      "superior": null,
      "indent": "3",
      "description": "Fuel pumps",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.30.9060",
      "rawHtsCode": "8413.30.90.60",
      "superior": null,
      "indent": "3",
      "description": "Lubricating pumps",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.30.9090",
      "rawHtsCode": "8413.30.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8413.40.0000",
      "rawHtsCode": "8413.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Concrete pumps",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8413.50.00",
      "rawHtsCode": "8413.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other reciprocating positive displacement pumps",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8413.50.0010",
      "rawHtsCode": "8413.50.00.10",
      "superior": null,
      "indent": "2",
      "description": "Oil well and oil field pumps",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.50.0050",
      "rawHtsCode": "8413.50.00.50",
      "superior": null,
      "indent": "2",
      "description": "Diaphragm pumps",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.50.0070",
      "rawHtsCode": "8413.50.00.70",
      "superior": null,
      "indent": "4",
      "description": "Radial piston type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.50.0080",
      "rawHtsCode": "8413.50.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.50.0090",
      "rawHtsCode": "8413.50.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.60.00",
      "rawHtsCode": "8413.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other rotary positive displacement pumps",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8413.60.0020",
      "rawHtsCode": "8413.60.00.20",
      "superior": null,
      "indent": "3",
      "description": "Vane type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.60.0030",
      "rawHtsCode": "8413.60.00.30",
      "superior": null,
      "indent": "3",
      "description": "Gear type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.60.0040",
      "rawHtsCode": "8413.60.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.60.0050",
      "rawHtsCode": "8413.60.00.50",
      "superior": null,
      "indent": "3",
      "description": "Oil well and oil field pumps",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.60.0070",
      "rawHtsCode": "8413.60.00.70",
      "superior": null,
      "indent": "3",
      "description": "Roller pumps",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.60.0090",
      "rawHtsCode": "8413.60.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.70",
      "rawHtsCode": "8413.70",
      "superior": null,
      "indent": "1",
      "description": "Other centrifugal pumps:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.70.1000",
      "rawHtsCode": "8413.70.10.00",
      "superior": null,
      "indent": "2",
      "description": "Stock pumps imported for use with machines for making cellulosic pulp, paper or paperboard",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8413.70.20",
      "rawHtsCode": "8413.70.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8413.70.2004",
      "rawHtsCode": "8413.70.20.04",
      "superior": null,
      "indent": "3",
      "description": "Submersible pumps",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.70.2005",
      "rawHtsCode": "8413.70.20.05",
      "superior": null,
      "indent": "5",
      "description": "With discharge outlet under <il>5.08 cm</il> in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.70.2015",
      "rawHtsCode": "8413.70.20.15",
      "superior": null,
      "indent": "5",
      "description": "With discharge outlet <il>5.08 cm</il> or over in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.70.2022",
      "rawHtsCode": "8413.70.20.22",
      "superior": null,
      "indent": "5",
      "description": "With discharge outlet under <il>7.6 cm</il> in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.70.2025",
      "rawHtsCode": "8413.70.20.25",
      "superior": null,
      "indent": "5",
      "description": "With discharge outlet <il>7.6 cm</il> or over in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.70.2030",
      "rawHtsCode": "8413.70.20.30",
      "superior": null,
      "indent": "4",
      "description": "Single-stage, double-suction",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.70.2040",
      "rawHtsCode": "8413.70.20.40",
      "superior": null,
      "indent": "4",
      "description": "Multi-stage, single- or double-suction",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.70.2090",
      "rawHtsCode": "8413.70.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.81.00",
      "rawHtsCode": "8413.81.00",
      "superior": null,
      "indent": "2",
      "description": "Pumps",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8413.81.0020",
      "rawHtsCode": "8413.81.00.20",
      "superior": null,
      "indent": "3",
      "description": "Turbine pumps",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.81.0030",
      "rawHtsCode": "8413.81.00.30",
      "superior": null,
      "indent": "3",
      "description": "Household water systems, self-contained; and windmill pumps",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.81.0040",
      "rawHtsCode": "8413.81.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.82.0000",
      "rawHtsCode": "8413.82.00.00",
      "superior": null,
      "indent": "2",
      "description": "Liquid elevators",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8413.91",
      "rawHtsCode": "8413.91",
      "superior": null,
      "indent": "2",
      "description": "Of pumps:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.91.1000",
      "rawHtsCode": "8413.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of fuel-injection pumps for compression-ignition engines",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8413.91.2000",
      "rawHtsCode": "8413.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of stock pumps imported for use with machines for making cellulosic pulp, paper or paperboard",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8413.91.90",
      "rawHtsCode": "8413.91.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8413.91.9010",
      "rawHtsCode": "8413.91.90.10",
      "superior": null,
      "indent": "4",
      "description": "Of subheading 8413.30.90",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.91.9055",
      "rawHtsCode": "8413.91.90.55",
      "superior": null,
      "indent": "5",
      "description": "Fluid end blocks",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.91.9060",
      "rawHtsCode": "8413.91.90.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.91.9065",
      "rawHtsCode": "8413.91.90.65",
      "superior": null,
      "indent": "5",
      "description": "Sucker rods of a kind described in statistical note 3 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8413.91.9085",
      "rawHtsCode": "8413.91.90.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8413.91.9096",
      "rawHtsCode": "8413.91.90.96",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8413.92.0000",
      "rawHtsCode": "8413.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of liquid elevators",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8414",
      "rawHtsCode": "8414",
      "superior": null,
      "indent": "0",
      "description": "Air or vacuum pumps, air or other gas compressors and fans; ventilating or recycling hoods incorporating a fan, whether or not fitted with filters; gas-tight biological safety cabinets, whether or not fitted with filters; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.10.0000",
      "rawHtsCode": "8414.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Vacuum pumps",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8414.20.0000",
      "rawHtsCode": "8414.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hand- or foot-operated air pumps",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8414.30",
      "rawHtsCode": "8414.30",
      "superior": null,
      "indent": "1",
      "description": "Compressors of a kind used in refrigerating equipment (including air conditioning):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.30.4000",
      "rawHtsCode": "8414.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 1/4 horsepower",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8414.30.80",
      "rawHtsCode": "8414.30.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8414.30.8010",
      "rawHtsCode": "8414.30.80.10",
      "superior": null,
      "indent": "4",
      "description": "Not exceeding 200 horsepower",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.30.8020",
      "rawHtsCode": "8414.30.80.20",
      "superior": null,
      "indent": "4",
      "description": "Exceeding 200 horsepower",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.30.8030",
      "rawHtsCode": "8414.30.80.30",
      "superior": null,
      "indent": "5",
      "description": "For motor vehicles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8414.30.8050",
      "rawHtsCode": "8414.30.80.50",
      "superior": null,
      "indent": "6",
      "description": "Exceeding 1/4 horsepower but not exceeding 1 horsepower",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.30.8060",
      "rawHtsCode": "8414.30.80.60",
      "superior": null,
      "indent": "6",
      "description": "Exceeding 1 horsepower but not exceeding 3 horsepower",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8414.30.8070",
      "rawHtsCode": "8414.30.80.70",
      "superior": null,
      "indent": "6",
      "description": "Exceeding 3 horsepower but not exceeding 10 horsepower",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.30.8080",
      "rawHtsCode": "8414.30.80.80",
      "superior": null,
      "indent": "6",
      "description": "Exceeding 10 horsepower",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.30.8090",
      "rawHtsCode": "8414.30.80.90",
      "superior": null,
      "indent": "4",
      "description": "For ammonia",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.40.0000",
      "rawHtsCode": "8414.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Air compressors mounted on a wheeled chassis for towing",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8414.51",
      "rawHtsCode": "8414.51",
      "superior": null,
      "indent": "2",
      "description": "Table, floor, wall, window, ceiling or roof fans, with a self-contained electric motor of an output not exceeding 125 W:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.51.3000",
      "rawHtsCode": "8414.51.30.00",
      "superior": null,
      "indent": "3",
      "description": "Ceiling fans for permanent installation",
      "units": [
        "No."
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8414.51.90",
      "rawHtsCode": "8414.51.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.7%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8414.51.9060",
      "rawHtsCode": "8414.51.90.60",
      "superior": null,
      "indent": "4",
      "description": "For permanent installation",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.51.9090",
      "rawHtsCode": "8414.51.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.59",
      "rawHtsCode": "8414.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.59.1000",
      "rawHtsCode": "8414.59.10.00",
      "superior": null,
      "indent": "3",
      "description": "Blowers for pipe organs",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8414.59.1500",
      "rawHtsCode": "8414.59.15.00",
      "superior": null,
      "indent": "3",
      "description": "Fans of a kind used solely or principally for cooling microprocessors, telecommunications apparatus, automatic data processing machines or units of automatic data processing machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8414.59.3000",
      "rawHtsCode": "8414.59.30.00",
      "superior": null,
      "indent": "4",
      "description": "Turbochargers and superchargers",
      "units": [
        "No."
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8414.59.65",
      "rawHtsCode": "8414.59.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.3%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8414.59.6540",
      "rawHtsCode": "8414.59.65.40",
      "superior": null,
      "indent": "5",
      "description": "Suitable for use with motor vehicles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8414.59.6560",
      "rawHtsCode": "8414.59.65.60",
      "superior": null,
      "indent": "6",
      "description": "Centrifugal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8414.59.6590",
      "rawHtsCode": "8414.59.65.90",
      "superior": null,
      "indent": "6",
      "description": "Axial",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.59.6595",
      "rawHtsCode": "8414.59.65.95",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.60.0000",
      "rawHtsCode": "8414.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hoods having a maximum horizontal side not exceeding <il>120 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8414.70.0000",
      "rawHtsCode": "8414.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Gas-tight biological safety cabinets",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8414.80",
      "rawHtsCode": "8414.80",
      "superior": null,
      "indent": "1",
      "description": "Other, except parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.0500",
      "rawHtsCode": "8414.80.05.00",
      "superior": null,
      "indent": "3",
      "description": "Turbochargers and superchargers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8414.80.16",
      "rawHtsCode": "8414.80.16",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8414.80.1605",
      "rawHtsCode": "8414.80.16.05",
      "superior": null,
      "indent": "6",
      "description": "Not exceeding <il>746 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1615",
      "rawHtsCode": "8414.80.16.15",
      "superior": null,
      "indent": "6",
      "description": "Exceeding <il>746 W</il> but not exceeding <il>4.48 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1625",
      "rawHtsCode": "8414.80.16.25",
      "superior": null,
      "indent": "6",
      "description": "Exceeding <il>4.48 kW</il> but not exceeding <il>8.21 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1635",
      "rawHtsCode": "8414.80.16.35",
      "superior": null,
      "indent": "6",
      "description": "Exceeding <il>8.21 kW</il> but not exceeding <il>11.19 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1640",
      "rawHtsCode": "8414.80.16.40",
      "superior": null,
      "indent": "6",
      "description": "Exceeding <il>11.19 kW</il> but not exceeding <il>19.4 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1645",
      "rawHtsCode": "8414.80.16.45",
      "superior": null,
      "indent": "6",
      "description": "Exceeding <il>19.4 kW</il> but not exceeding <il>74.6 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1655",
      "rawHtsCode": "8414.80.16.55",
      "superior": null,
      "indent": "6",
      "description": "Exceeding <il>74.6 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1660",
      "rawHtsCode": "8414.80.16.60",
      "superior": null,
      "indent": "6",
      "description": "Not exceeding <il>11.19 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1665",
      "rawHtsCode": "8414.80.16.65",
      "superior": null,
      "indent": "6",
      "description": "Exceeding <il>11.19 kW</il> but under <il>22.38 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1670",
      "rawHtsCode": "8414.80.16.70",
      "superior": null,
      "indent": "6",
      "description": "<il>22.38 kW</il> and over but not exceeding <il>74.6 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1675",
      "rawHtsCode": "8414.80.16.75",
      "superior": null,
      "indent": "6",
      "description": "Exceeding <il>74.6 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1680",
      "rawHtsCode": "8414.80.16.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1685",
      "rawHtsCode": "8414.80.16.85",
      "superior": null,
      "indent": "5",
      "description": "Under <il>0.57 cubic</il> meters per minute",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.1690",
      "rawHtsCode": "8414.80.16.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.20",
      "rawHtsCode": "8414.80.20",
      "superior": null,
      "indent": "2",
      "description": "Other compressors",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8414.80.2005",
      "rawHtsCode": "8414.80.20.05",
      "superior": null,
      "indent": "3",
      "description": "Refrigerant recovery units",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.2015",
      "rawHtsCode": "8414.80.20.15",
      "superior": null,
      "indent": "4",
      "description": "Centrifugal and axial",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.2055",
      "rawHtsCode": "8414.80.20.55",
      "superior": null,
      "indent": "5",
      "description": "Not exceeding <il>186.5 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.2065",
      "rawHtsCode": "8414.80.20.65",
      "superior": null,
      "indent": "5",
      "description": "Exceeding <il>186.5 kW</il> but not exceeding <il>746 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.2075",
      "rawHtsCode": "8414.80.20.75",
      "superior": null,
      "indent": "5",
      "description": "Exceeding <il>746 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.80.9000",
      "rawHtsCode": "8414.80.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8414.90",
      "rawHtsCode": "8414.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.90.10",
      "rawHtsCode": "8414.90.10",
      "superior": null,
      "indent": "2",
      "description": "Of fans (including blowers) and ventilating or recycling hoods",
      "units": [],
      "generalRate": "4.7%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8414.90.1040",
      "rawHtsCode": "8414.90.10.40",
      "superior": null,
      "indent": "3",
      "description": "Of fans of subheading 8414.51",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.90.1080",
      "rawHtsCode": "8414.90.10.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.90.3000",
      "rawHtsCode": "8414.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Stators and rotors of goods of subheading 8414.30",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8414.90.41",
      "rawHtsCode": "8414.90.41",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8414.90.4120",
      "rawHtsCode": "8414.90.41.20",
      "superior": null,
      "indent": "5",
      "description": "Compressor housings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.90.4140",
      "rawHtsCode": "8414.90.41.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.90.4145",
      "rawHtsCode": "8414.90.41.45",
      "superior": null,
      "indent": "6",
      "description": "Compressor housings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.90.4155",
      "rawHtsCode": "8414.90.41.55",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.90.4165",
      "rawHtsCode": "8414.90.41.65",
      "superior": null,
      "indent": "6",
      "description": "Compressor housings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.90.4180",
      "rawHtsCode": "8414.90.41.80",
      "superior": null,
      "indent": "6",
      "description": "Impeller covers and hubs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.90.4190",
      "rawHtsCode": "8414.90.41.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.90.91",
      "rawHtsCode": "8414.90.91",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8414.90.9140",
      "rawHtsCode": "8414.90.91.40",
      "superior": null,
      "indent": "3",
      "description": "Of vacuum pumps",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8414.90.9180",
      "rawHtsCode": "8414.90.91.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415",
      "rawHtsCode": "8415",
      "superior": null,
      "indent": "0",
      "description": "Air conditioning machines, comprising a motor-driven fan and elements for changing the temperature and humidity, including those machines in which the humidity cannot be separately regulated; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.10",
      "rawHtsCode": "8415.10",
      "superior": null,
      "indent": "1",
      "description": "Of a kind designed to be fixed to a window, wall, ceiling or floor, self-contained or “split system”:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.10.30",
      "rawHtsCode": "8415.10.30",
      "superior": null,
      "indent": "2",
      "description": "Self-contained",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8415.10.3040",
      "rawHtsCode": "8415.10.30.40",
      "superior": null,
      "indent": "3",
      "description": "Less than <il>2.93 kW</il> per hour",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.10.3060",
      "rawHtsCode": "8415.10.30.60",
      "superior": null,
      "indent": "3",
      "description": "<il>2.93 kW</il> per hour or greater but less than <il>4.98 kW</il> per hour",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.10.3080",
      "rawHtsCode": "8415.10.30.80",
      "superior": null,
      "indent": "3",
      "description": "<il>4.98 kW</il> per hour or greater",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.10.6000",
      "rawHtsCode": "8415.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Incorporating a refrigerating unit and a valve for reversal of the cooling/heat cycle (reversible heat pumps)",
      "units": [
        "No."
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8415.10.9000",
      "rawHtsCode": "8415.10.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8415.20.0000",
      "rawHtsCode": "8415.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of a kind used for persons, in motor vehicles",
      "units": [
        "No."
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8415.81.01",
      "rawHtsCode": "8415.81.01",
      "superior": null,
      "indent": "2",
      "description": "Incorporating a refrigerating unit and a valve for reversal of the cooling/heat cycle (reversible heat pumps)",
      "units": [],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8415.81.0110",
      "rawHtsCode": "8415.81.01.10",
      "superior": null,
      "indent": "4",
      "description": "Not exceeding <il>17.58 kW</il> per hour",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.81.0120",
      "rawHtsCode": "8415.81.01.20",
      "superior": null,
      "indent": "4",
      "description": "Exceeding <il>17.58 kW</il> per hour",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.81.0130",
      "rawHtsCode": "8415.81.01.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.82.01",
      "rawHtsCode": "8415.82.01",
      "superior": null,
      "indent": "2",
      "description": "Other, incorporating a refrigerating unit",
      "units": [],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8415.82.0105",
      "rawHtsCode": "8415.82.01.05",
      "superior": null,
      "indent": "4",
      "description": "Not exceeding <il>17.58 kW</il> per hour",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.82.0110",
      "rawHtsCode": "8415.82.01.10",
      "superior": null,
      "indent": "4",
      "description": "Exceeding <il>17.58 kW</il> per hour",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.82.0115",
      "rawHtsCode": "8415.82.01.15",
      "superior": null,
      "indent": "4",
      "description": "Not exceeding <il>17.58 kW</il> per hour",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.82.0120",
      "rawHtsCode": "8415.82.01.20",
      "superior": null,
      "indent": "4",
      "description": "Exceeding <il>17.58 kW</il> per hour",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.82.0130",
      "rawHtsCode": "8415.82.01.30",
      "superior": null,
      "indent": "4",
      "description": "Room fan coil units",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.82.0135",
      "rawHtsCode": "8415.82.01.35",
      "superior": null,
      "indent": "4",
      "description": "Central station air handlers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.82.0140",
      "rawHtsCode": "8415.82.01.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.82.0155",
      "rawHtsCode": "8415.82.01.55",
      "superior": null,
      "indent": "4",
      "description": "With a rated water removal capacity of less than <il>35 liters</il> over a 24 hour period",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.82.0160",
      "rawHtsCode": "8415.82.01.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.82.0170",
      "rawHtsCode": "8415.82.01.70",
      "superior": null,
      "indent": "3",
      "description": "Other air conditioning machines incorporating a refrigerating unit",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.83.00",
      "rawHtsCode": "8415.83.00",
      "superior": null,
      "indent": "2",
      "description": "Not incorporating a refrigerating unit",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8415.83.0050",
      "rawHtsCode": "8415.83.00.50",
      "superior": null,
      "indent": "5",
      "description": "Not exceeding <il>17.58 kW</il> per hour",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.83.0060",
      "rawHtsCode": "8415.83.00.60",
      "superior": null,
      "indent": "5",
      "description": "Exceeding <il>17.58 kW</il> per hour",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.83.0070",
      "rawHtsCode": "8415.83.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.83.0090",
      "rawHtsCode": "8415.83.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other air conditioning machines not incorporating a refrigerating unit",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.90",
      "rawHtsCode": "8415.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.90.4000",
      "rawHtsCode": "8415.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Chassis, chassis bases and outer cabinets",
      "units": [
        "No."
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8415.90.80",
      "rawHtsCode": "8415.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) See 9921.01.01, 9921.01.02 (JP)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8415.90.8010",
      "rawHtsCode": "8415.90.80.10",
      "superior": null,
      "indent": "4",
      "description": "Of copper or copper alloys",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.90.8020",
      "rawHtsCode": "8415.90.80.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.90.8045",
      "rawHtsCode": "8415.90.80.45",
      "superior": null,
      "indent": "4",
      "description": "Of automotive air conditioners",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.90.8050",
      "rawHtsCode": "8415.90.80.50",
      "superior": null,
      "indent": "5",
      "description": "Of copper or copper alloys",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.90.8070",
      "rawHtsCode": "8415.90.80.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8415.90.8085",
      "rawHtsCode": "8415.90.80.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8416",
      "rawHtsCode": "8416",
      "superior": null,
      "indent": "0",
      "description": "Furnace burners for liquid fuel, for pulverized solid fuel or for gas; mechanical stokers, including their mechanical grates, mechanical ash dischargers and similar appliances; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8416.10.0000",
      "rawHtsCode": "8416.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Furnace burners for liquid fuel",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8416.20.00",
      "rawHtsCode": "8416.20.00",
      "superior": null,
      "indent": "1",
      "description": "Other furnace burners, including combination burners",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8416.20.0040",
      "rawHtsCode": "8416.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Gas burners",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8416.20.0080",
      "rawHtsCode": "8416.20.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8416.30.0000",
      "rawHtsCode": "8416.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mechanical stokers, including their mechanical grates, mechanical ash dischargers and similar appliances",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8416.90.0000",
      "rawHtsCode": "8416.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8417",
      "rawHtsCode": "8417",
      "superior": null,
      "indent": "0",
      "description": "Industrial or laboratory furnaces and ovens, including incinerators, nonelectric, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8417.10.0000",
      "rawHtsCode": "8417.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Furnaces and ovens for the roasting, melting or other heat treatment of ores, pyrites or of metals",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8417.20.0000",
      "rawHtsCode": "8417.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Bakery ovens, including biscuit ovens",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8417.80.0000",
      "rawHtsCode": "8417.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other, except parts",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8417.90.0000",
      "rawHtsCode": "8417.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8418",
      "rawHtsCode": "8418",
      "superior": null,
      "indent": "0",
      "description": "Refrigerators, freezers and other refrigerating or freezing equipment, electric or other; heat pumps, other than the air conditioning machines of heading 8415; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.10.00",
      "rawHtsCode": "8418.10.00",
      "superior": null,
      "indent": "1",
      "description": "Combined refrigerator-freezers, fitted with separate external doors or drawers, or combinations thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8418.10.0010",
      "rawHtsCode": "8418.10.00.10",
      "superior": null,
      "indent": "3",
      "description": "Having a refrigerated volume of under <il>184 liters</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.10.0020",
      "rawHtsCode": "8418.10.00.20",
      "superior": null,
      "indent": "3",
      "description": "Having a refrigerated volume of <il>184 liters</il> and over but under <il>269 liters</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.10.0030",
      "rawHtsCode": "8418.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "Having a refrigerated volume of <il>269 liters</il> and over but under <il>382 liters</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.10.0045",
      "rawHtsCode": "8418.10.00.45",
      "superior": null,
      "indent": "6",
      "description": "Having an external depth (excluding door handles) not exceeding <il>73 centimeters</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.10.0055",
      "rawHtsCode": "8418.10.00.55",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.10.0065",
      "rawHtsCode": "8418.10.00.65",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.10.0080",
      "rawHtsCode": "8418.10.00.80",
      "superior": null,
      "indent": "4",
      "description": "Refrigerators with a top freezer compartment",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.10.0085",
      "rawHtsCode": "8418.10.00.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.10.0090",
      "rawHtsCode": "8418.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.21.00",
      "rawHtsCode": "8418.21.00",
      "superior": null,
      "indent": "2",
      "description": "Compression type",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8418.21.0010",
      "rawHtsCode": "8418.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Having a refrigerated volume of under <il>184 liters</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.21.0020",
      "rawHtsCode": "8418.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Having a refrigerated volume of <il>184 liters</il> and over but under <il>269 liters</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.21.0030",
      "rawHtsCode": "8418.21.00.30",
      "superior": null,
      "indent": "3",
      "description": "Having a refrigerated volume of <il>269 liters</il> and over but under <il>382 liters</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.21.0090",
      "rawHtsCode": "8418.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Having a refrigerated volume of <il>382 liters</il> and over",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.29",
      "rawHtsCode": "8418.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.29.1000",
      "rawHtsCode": "8418.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Absorption type, electrical",
      "units": [
        "No."
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8418.29.2000",
      "rawHtsCode": "8418.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8418.30.0000",
      "rawHtsCode": "8418.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Freezers of the chest type, not exceeding <il>800 liters</il> capacity",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8418.40.0000",
      "rawHtsCode": "8418.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Freezers of the upright type, not exceeding <il>900 liters</il> capacity",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8418.50.00",
      "rawHtsCode": "8418.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other furniture (chests, cabinets, display counters, show-cases and the like) for storage and display, incorporating refrigerating or freezing equipment",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8418.50.0040",
      "rawHtsCode": "8418.50.00.40",
      "superior": null,
      "indent": "2",
      "description": "Freezing",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.50.0080",
      "rawHtsCode": "8418.50.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8418.61.0100",
      "rawHtsCode": "8418.61.01.00",
      "superior": null,
      "indent": "2",
      "description": "Heat pumps other than air conditioning machines of heading 8415",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8418.69.01",
      "rawHtsCode": "8418.69.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8418.69.0110",
      "rawHtsCode": "8418.69.01.10",
      "superior": null,
      "indent": "3",
      "description": "Icemaking machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.69.0120",
      "rawHtsCode": "8418.69.01.20",
      "superior": null,
      "indent": "3",
      "description": "Drinking water coolers, self-contained",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.69.0130",
      "rawHtsCode": "8418.69.01.30",
      "superior": null,
      "indent": "3",
      "description": "Soda fountain and beer dispensing equipment",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.69.0140",
      "rawHtsCode": "8418.69.01.40",
      "superior": null,
      "indent": "3",
      "description": "Centrifugal liquid chilling refrigerating units",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.69.0150",
      "rawHtsCode": "8418.69.01.50",
      "superior": null,
      "indent": "3",
      "description": "Reciprocating liquid chilling refrigerating units",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.69.0160",
      "rawHtsCode": "8418.69.01.60",
      "superior": null,
      "indent": "3",
      "description": "Absorption liquid chilling units",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.69.0180",
      "rawHtsCode": "8418.69.01.80",
      "superior": null,
      "indent": "3",
      "description": "Other refrigerating or freezing equipment",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.91.0000",
      "rawHtsCode": "8418.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Furniture designed to receive refrigerating or freezing equipment",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8418.99",
      "rawHtsCode": "8418.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.99.4000",
      "rawHtsCode": "8418.99.40.00",
      "superior": null,
      "indent": "3",
      "description": "Door assemblies incorporating more than one of the following: inner panel; outer panel; insulation; hinges; handles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8418.99.80",
      "rawHtsCode": "8418.99.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.           "
      ],
      "flags": []
    },
    {
      "htsCode": "8418.99.8005",
      "rawHtsCode": "8418.99.80.05",
      "superior": null,
      "indent": "5",
      "description": "Not exceeding <il>746 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.99.8010",
      "rawHtsCode": "8418.99.80.10",
      "superior": null,
      "indent": "5",
      "description": "Exceeding <il>746 W</il> but not exceeding <il>2.2 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.99.8015",
      "rawHtsCode": "8418.99.80.15",
      "superior": null,
      "indent": "5",
      "description": "Exceeding <il>2.2 kW</il> but not exceeding <il>7.5 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.99.8020",
      "rawHtsCode": "8418.99.80.20",
      "superior": null,
      "indent": "5",
      "description": "Exceeding <il>7.5 kW</il> but not exceeding <il>22.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.99.8025",
      "rawHtsCode": "8418.99.80.25",
      "superior": null,
      "indent": "5",
      "description": "Exceeding <il>22.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.99.8050",
      "rawHtsCode": "8418.99.80.50",
      "superior": null,
      "indent": "5",
      "description": "Parts of combined refrigerator-freezers fitted with separate external doors and parts of household type refrigerators",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8418.99.8060",
      "rawHtsCode": "8418.99.80.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419",
      "rawHtsCode": "8419",
      "superior": null,
      "indent": "0",
      "description": "Machinery, plant or laboratory equipment, whether or not electrically heated (excluding furnaces, ovens and other equipment of heading 8514), for the treatment of materials by a process involving a change of temperature such as heating, cooking, roasting, distilling, rectifying, sterilizing, pasteurizing, steaming, drying, evaporating, vaporizing, condensing or cooling, other than machinery or plant of a kind used for domestic purposes; instantaneous or storage water heaters, nonelectric; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.11.0000",
      "rawHtsCode": "8419.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Instantaneous gas water heaters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8419.12.0000",
      "rawHtsCode": "8419.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Solar water heaters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.19.01",
      "rawHtsCode": "8419.19.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.19.0120",
      "rawHtsCode": "8419.19.01.20",
      "superior": null,
      "indent": "3",
      "description": "Instantaneous water heaters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.19.0160",
      "rawHtsCode": "8419.19.01.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.20.00",
      "rawHtsCode": "8419.20.00",
      "superior": null,
      "indent": "1",
      "description": "Medical, surgical or laboratory sterilizers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.20.0010",
      "rawHtsCode": "8419.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Medical or surgical sterilizers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.20.0020",
      "rawHtsCode": "8419.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Laboratory sterilizers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.33",
      "rawHtsCode": "8419.33",
      "superior": null,
      "indent": "2",
      "description": "Lyophilisation apparatus, freeze drying units and spray dryers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.33.1000",
      "rawHtsCode": "8419.33.10.00",
      "superior": null,
      "indent": "3",
      "description": "For agricultural products",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.33.5000",
      "rawHtsCode": "8419.33.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.34.0000",
      "rawHtsCode": "8419.34.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, for agricultural products",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.35",
      "rawHtsCode": "8419.35",
      "superior": null,
      "indent": "2",
      "description": "Other, for wood, paper pulp, paper or paperboard",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.35.1000",
      "rawHtsCode": "8419.35.10.00",
      "superior": null,
      "indent": "3",
      "description": "For wood",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.35.5000",
      "rawHtsCode": "8419.35.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.39.02",
      "rawHtsCode": "8419.39.02",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.39.0270",
      "rawHtsCode": "8419.39.02.70",
      "superior": null,
      "indent": "3",
      "description": "For foods and beverages",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.39.0280",
      "rawHtsCode": "8419.39.02.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.40.00",
      "rawHtsCode": "8419.40.00",
      "superior": null,
      "indent": "1",
      "description": "Distilling or rectifying plant",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8419.40.0040",
      "rawHtsCode": "8419.40.00.40",
      "superior": null,
      "indent": "2",
      "description": "For food and beverages",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.40.0080",
      "rawHtsCode": "8419.40.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.50",
      "rawHtsCode": "8419.50",
      "superior": null,
      "indent": "1",
      "description": "Heat exchange units:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.50.1000",
      "rawHtsCode": "8419.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Brazed aluminum plate-fin heat exchangers",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8419.50.5000",
      "rawHtsCode": "8419.50.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01.  "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.60",
      "rawHtsCode": "8419.60",
      "superior": null,
      "indent": "1",
      "description": "Machinery for liquefying air or other gases:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.60.1000",
      "rawHtsCode": "8419.60.10.00",
      "superior": null,
      "indent": "2",
      "description": "Machinery containing brazed aluminum plate-fin heat exchangers",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8419.60.5000",
      "rawHtsCode": "8419.60.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8419.81",
      "rawHtsCode": "8419.81",
      "superior": null,
      "indent": "2",
      "description": "For making hot drinks or for cooking or heating food:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.81.50",
      "rawHtsCode": "8419.81.50",
      "superior": null,
      "indent": "3",
      "description": "Cooking stoves, ranges and ovens",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.81.5040",
      "rawHtsCode": "8419.81.50.40",
      "superior": null,
      "indent": "4",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See General Note 6."
      ],
      "flags": []
    },
    {
      "htsCode": "8419.81.5080",
      "rawHtsCode": "8419.81.50.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.81.90",
      "rawHtsCode": "8419.81.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.81.9040",
      "rawHtsCode": "8419.81.90.40",
      "superior": null,
      "indent": "4",
      "description": "Of a type used in restaurants, hotels or similar locations",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.81.9080",
      "rawHtsCode": "8419.81.90.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.89",
      "rawHtsCode": "8419.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.89.1000",
      "rawHtsCode": "8419.89.10.00",
      "superior": null,
      "indent": "3",
      "description": "For making paper pulp, paper or paperboard",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8419.89.6000",
      "rawHtsCode": "8419.89.60.00",
      "superior": null,
      "indent": "4",
      "description": "Molten-salt-cooled acrylic acid reactors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8419.89.95",
      "rawHtsCode": "8419.89.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8419.89.9520",
      "rawHtsCode": "8419.89.95.20",
      "superior": null,
      "indent": "6",
      "description": "For food and beverages",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.89.9540",
      "rawHtsCode": "8419.89.95.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.89.9560",
      "rawHtsCode": "8419.89.95.60",
      "superior": null,
      "indent": "6",
      "description": "For food and beverages",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.89.9580",
      "rawHtsCode": "8419.89.95.80",
      "superior": null,
      "indent": "6",
      "description": "For rubber and plastics",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.89.9585",
      "rawHtsCode": "8419.89.95.85",
      "superior": null,
      "indent": "6",
      "description": "For other materials",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.90",
      "rawHtsCode": "8419.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.90.1000",
      "rawHtsCode": "8419.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of instantaneous or storage water heaters",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01.  "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.90.2000",
      "rawHtsCode": "8419.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of machinery and plant for making paper pulp, paper or paperboard",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.90.3000",
      "rawHtsCode": "8419.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of heat exchange units",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.90.50",
      "rawHtsCode": "8419.90.50",
      "superior": null,
      "indent": "3",
      "description": "Of molten-salt-cooled acrylic acid reactors; of medical, surgical or laboratory sterilizers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8419.90.5040",
      "rawHtsCode": "8419.90.50.40",
      "superior": null,
      "indent": "4",
      "description": "Of medical, surgical or laboratory sterilizers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.90.5080",
      "rawHtsCode": "8419.90.50.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.90.8500",
      "rawHtsCode": "8419.90.85.00",
      "superior": null,
      "indent": "3",
      "description": "Of electromechanical tools for working in the hand with self-contained electric motor",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8419.90.95",
      "rawHtsCode": "8419.90.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8419.90.9520",
      "rawHtsCode": "8419.90.95.20",
      "superior": null,
      "indent": "4",
      "description": "Of an apparatus of a type used in restaurants, hotels or similar locations",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8419.90.9580",
      "rawHtsCode": "8419.90.95.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8420",
      "rawHtsCode": "8420",
      "superior": null,
      "indent": "0",
      "description": "Calendering or other rolling machines, other than for metals or glass, and cylinders therefor; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8420.10",
      "rawHtsCode": "8420.10",
      "superior": null,
      "indent": "1",
      "description": "Calendering or other rolling machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8420.10.1000",
      "rawHtsCode": "8420.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Textile calendering or rolling machines",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8420.10.2000",
      "rawHtsCode": "8420.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Calendering or similar rolling machines for making paper pulp, paper or paperboard",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8420.10.90",
      "rawHtsCode": "8420.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8420.10.9040",
      "rawHtsCode": "8420.10.90.40",
      "superior": null,
      "indent": "3",
      "description": "Calendering or other rolling machines for rubber and plastics",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8420.10.9080",
      "rawHtsCode": "8420.10.90.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8420.91",
      "rawHtsCode": "8420.91",
      "superior": null,
      "indent": "2",
      "description": "Cylinders:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8420.91.1000",
      "rawHtsCode": "8420.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "For textile calendering or rolling machines",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8420.91.2000",
      "rawHtsCode": "8420.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "For calendering or other rolling machines for machines for making paper pulp, paper or paperboard",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8420.91.9000",
      "rawHtsCode": "8420.91.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8420.99",
      "rawHtsCode": "8420.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8420.99.1000",
      "rawHtsCode": "8420.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of machines for processing textiles",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8420.99.2000",
      "rawHtsCode": "8420.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of machines for making paper pulp, paper or paperboard",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8420.99.9000",
      "rawHtsCode": "8420.99.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421",
      "rawHtsCode": "8421",
      "superior": null,
      "indent": "0",
      "description": "Centrifuges, including centrifugal dryers; filtering or purifying machinery and apparatus, for liquids or gases; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8421.11.0000",
      "rawHtsCode": "8421.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cream separators",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.12.0000",
      "rawHtsCode": "8421.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Clothes-dryers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.19.0000",
      "rawHtsCode": "8421.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8421.21.0000",
      "rawHtsCode": "8421.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "For filtering or purifying water",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.22.0000",
      "rawHtsCode": "8421.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "For filtering or purifying beverages other than water",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.23.0000",
      "rawHtsCode": "8421.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Oil or fuel filters for internal combustion engines",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8421.29.00",
      "rawHtsCode": "8421.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8421.29.0005",
      "rawHtsCode": "8421.29.00.05",
      "superior": null,
      "indent": "3",
      "description": "Refrigerant recovery and recycling units",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8421.29.0015",
      "rawHtsCode": "8421.29.00.15",
      "superior": null,
      "indent": "4",
      "description": "Oil-separation equipment",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8421.29.0040",
      "rawHtsCode": "8421.29.00.40",
      "superior": null,
      "indent": "5",
      "description": "Hydraulic fluid power filters, rated at <il>1,000 kPa</il> or greater",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8421.29.0065",
      "rawHtsCode": "8421.29.00.65",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8421.31.0000",
      "rawHtsCode": "8421.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Intake air filters for internal combustion engines",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8421.32.0000",
      "rawHtsCode": "8421.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Catalytic converters or particulate filters, whether or not combined, for purifying or filtering exhaust gases from internal combustion engines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.39.01",
      "rawHtsCode": "8421.39.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.39.0105",
      "rawHtsCode": "8421.39.01.05",
      "superior": null,
      "indent": "4",
      "description": "For machine tools of headings 8456 through 8465, inclusive",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8421.39.0115",
      "rawHtsCode": "8421.39.01.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.39.0120",
      "rawHtsCode": "8421.39.01.20",
      "superior": null,
      "indent": "5",
      "description": "Electrostatic precipitators",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8421.39.0130",
      "rawHtsCode": "8421.39.01.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8421.39.0140",
      "rawHtsCode": "8421.39.01.40",
      "superior": null,
      "indent": "4",
      "description": "Gas separation equipment",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8421.39.0160",
      "rawHtsCode": "8421.39.01.60",
      "superior": null,
      "indent": "5",
      "description": "Pneumatic fluid power filters, rated at <il>550 kPa</il> or greater",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8421.39.0190",
      "rawHtsCode": "8421.39.01.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.91",
      "rawHtsCode": "8421.91",
      "superior": null,
      "indent": "2",
      "description": "Of centrifuges, including centrifugal dryers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8421.91.2000",
      "rawHtsCode": "8421.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "Drying chambers for the clothes-dryers of subheading 8421.12 and other parts of clothes-dryers incorporating drying chambers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.91.4000",
      "rawHtsCode": "8421.91.40.00",
      "superior": null,
      "indent": "3",
      "description": "Furniture designed to receive the clothes-dryers of subheading 8421.12",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.91.6000",
      "rawHtsCode": "8421.91.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.99.01",
      "rawHtsCode": "8421.99.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.99.0140",
      "rawHtsCode": "8421.99.01.40",
      "superior": null,
      "indent": "3",
      "description": "Parts of machinery and apparatus for filtering or purifying water",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8421.99.0180",
      "rawHtsCode": "8421.99.01.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422",
      "rawHtsCode": "8422",
      "superior": null,
      "indent": "0",
      "description": "Dishwashing machines; machinery for cleaning or drying bottles or other containers; machinery for filling, closing, sealing or labeling bottles, cans, boxes, bags or other containers; machinery for capsuling bottles, jars, tubes and similar containers; other packing or wrapping machinery (including heat-shrink wrapping machinery); machinery for aerating beverages; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.11.0000",
      "rawHtsCode": "8422.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of the household type",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8422.19.0000",
      "rawHtsCode": "8422.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8422.20.0000",
      "rawHtsCode": "8422.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for cleaning or drying bottles or other containers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8422.30",
      "rawHtsCode": "8422.30",
      "superior": null,
      "indent": "1",
      "description": "Machinery for filling, closing, sealing or labeling bottles, cans, boxes, bags or other containers; machinery for capsuling bottles, jars, tubes and similar containers; machinery for aerating beverages:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.30.1100",
      "rawHtsCode": "8422.30.11.00",
      "superior": null,
      "indent": "2",
      "description": "Can-sealing machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8422.30.91",
      "rawHtsCode": "8422.30.91",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8422.30.9110",
      "rawHtsCode": "8422.30.91.10",
      "superior": null,
      "indent": "3",
      "description": "Machines for aerating beverages",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.30.9120",
      "rawHtsCode": "8422.30.91.20",
      "superior": null,
      "indent": "3",
      "description": "Labeling machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.30.9130",
      "rawHtsCode": "8422.30.91.30",
      "superior": null,
      "indent": "6",
      "description": "Vacuum or gas packaging",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.30.9140",
      "rawHtsCode": "8422.30.91.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.30.9150",
      "rawHtsCode": "8422.30.91.50",
      "superior": null,
      "indent": "6",
      "description": "Vacuum or gas packaging",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.30.9160",
      "rawHtsCode": "8422.30.91.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.30.9170",
      "rawHtsCode": "8422.30.91.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.30.9180",
      "rawHtsCode": "8422.30.91.80",
      "superior": null,
      "indent": "5",
      "description": "Machines for opening, filling and closing bags",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.30.9185",
      "rawHtsCode": "8422.30.91.85",
      "superior": null,
      "indent": "5",
      "description": "Machines for forming, filling and sealing bags/pouches",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.30.9186",
      "rawHtsCode": "8422.30.91.86",
      "superior": null,
      "indent": "5",
      "description": "Machines for opening, filling and closing boxes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.30.9187",
      "rawHtsCode": "8422.30.91.87",
      "superior": null,
      "indent": "5",
      "description": "Machines for skin and blister packaging",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.30.9191",
      "rawHtsCode": "8422.30.91.91",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.40",
      "rawHtsCode": "8422.40",
      "superior": null,
      "indent": "1",
      "description": "Other packing or wrapping machinery (including heat-shrink wrapping machinery):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.40.11",
      "rawHtsCode": "8422.40.11",
      "superior": null,
      "indent": "2",
      "description": "Machines for packaging pipe tobacco; machines for wrapping candy; machines for wrapping cigarette packages; and combination candy cutting and wrapping machines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8422.40.1110",
      "rawHtsCode": "8422.40.11.10",
      "superior": null,
      "indent": "3",
      "description": "Machines for wrapping candy",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.40.1190",
      "rawHtsCode": "8422.40.11.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.40.91",
      "rawHtsCode": "8422.40.91",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8422.40.9140",
      "rawHtsCode": "8422.40.91.40",
      "superior": null,
      "indent": "3",
      "description": "Strapping machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.40.9150",
      "rawHtsCode": "8422.40.91.50",
      "superior": null,
      "indent": "3",
      "description": "Machines for case and tray forming, packing, unpacking, closing and sealing",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.40.9160",
      "rawHtsCode": "8422.40.91.60",
      "superior": null,
      "indent": "3",
      "description": "Machines for shrink film and heat sealing",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.40.9170",
      "rawHtsCode": "8422.40.91.70",
      "superior": null,
      "indent": "3",
      "description": "Machines for wrapping",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.40.9181",
      "rawHtsCode": "8422.40.91.81",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.90",
      "rawHtsCode": "8422.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.90.0200",
      "rawHtsCode": "8422.90.02.00",
      "superior": null,
      "indent": "3",
      "description": "Water containment chambers for the dishwashing machines of subheading 8422.11 and other parts of dishwashing machines of the household type incorporating water containment chambers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8422.90.0400",
      "rawHtsCode": "8422.90.04.00",
      "superior": null,
      "indent": "3",
      "description": "Door assemblies for the dishwashing machines of subheading 8422.11",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8422.90.06",
      "rawHtsCode": "8422.90.06",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01.  "
      ],
      "flags": []
    },
    {
      "htsCode": "8422.90.0640",
      "rawHtsCode": "8422.90.06.40",
      "superior": null,
      "indent": "4",
      "description": "Of the household type",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.90.0680",
      "rawHtsCode": "8422.90.06.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.90.1100",
      "rawHtsCode": "8422.90.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of can-sealing machines",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8422.90.2100",
      "rawHtsCode": "8422.90.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of machines for packaging pipe tobacco, wrapping candy or wrapping cigarette packages, and of combination candy cutting and wrapping machines",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8422.90.91",
      "rawHtsCode": "8422.90.91",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8422.90.9120",
      "rawHtsCode": "8422.90.91.20",
      "superior": null,
      "indent": "3",
      "description": "Of machinery for cleaning or drying bottles or other containers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.90.9130",
      "rawHtsCode": "8422.90.91.30",
      "superior": null,
      "indent": "4",
      "description": "Of strapping machines",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.90.9160",
      "rawHtsCode": "8422.90.91.60",
      "superior": null,
      "indent": "4",
      "description": "Of other wrapping and packaging machines",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8422.90.9195",
      "rawHtsCode": "8422.90.91.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423",
      "rawHtsCode": "8423",
      "superior": null,
      "indent": "0",
      "description": "Weighing machinery (excluding balances of a sensitivity of 5 cg or better), including weight-operated counting or checking machines; weighing machine weights of all kinds; parts of weighing machinery:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.10.00",
      "rawHtsCode": "8423.10.00",
      "superior": null,
      "indent": "1",
      "description": "Personal weighing machines, including baby scales; household scales",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.10.0010",
      "rawHtsCode": "8423.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Digital electronic type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.10.0030",
      "rawHtsCode": "8423.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "Of a kind suitable for carrying on the person",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.10.0060",
      "rawHtsCode": "8423.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.20",
      "rawHtsCode": "8423.20",
      "superior": null,
      "indent": "1",
      "description": "Scales for continuous weighing of goods on conveyors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.20.1000",
      "rawHtsCode": "8423.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Using electronic means for gauging weights",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8423.20.9000",
      "rawHtsCode": "8423.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8423.30.0000",
      "rawHtsCode": "8423.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Constant-weight scales and scales for discharging a predetermined weight of material into a bag or container, including hopper scales",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8423.81.00",
      "rawHtsCode": "8423.81.00",
      "superior": null,
      "indent": "2",
      "description": "Having a maximum weighing capacity not exceeding <il>30 kg</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8423.81.0010",
      "rawHtsCode": "8423.81.00.10",
      "superior": null,
      "indent": "4",
      "description": "Counting scales",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.81.0020",
      "rawHtsCode": "8423.81.00.20",
      "superior": null,
      "indent": "4",
      "description": "Retail scales, non-computing",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.81.0030",
      "rawHtsCode": "8423.81.00.30",
      "superior": null,
      "indent": "4",
      "description": "Retail scales, computing",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.81.0040",
      "rawHtsCode": "8423.81.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.81.0050",
      "rawHtsCode": "8423.81.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.82.00",
      "rawHtsCode": "8423.82.00",
      "superior": null,
      "indent": "2",
      "description": "Having a maximum weighing capacity exceeding <il>30 kg</il> but not exceeding <il>5,000 kg</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8423.82.0010",
      "rawHtsCode": "8423.82.00.10",
      "superior": null,
      "indent": "3",
      "description": "Digital electronic type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.82.0050",
      "rawHtsCode": "8423.82.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.89",
      "rawHtsCode": "8423.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.89.1000",
      "rawHtsCode": "8423.89.10.00",
      "superior": null,
      "indent": "3",
      "description": "Using electronic means for gauging",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8423.89.9000",
      "rawHtsCode": "8423.89.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8423.90",
      "rawHtsCode": "8423.90",
      "superior": null,
      "indent": "1",
      "description": "Weighing machine weights of all kinds; parts of weighing machinery:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8423.90.1000",
      "rawHtsCode": "8423.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Parts of weighing machinery using electronic means for gauging weight, excluding parts of machines for weighing motor vehicles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8423.90.9000",
      "rawHtsCode": "8423.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8424",
      "rawHtsCode": "8424",
      "superior": null,
      "indent": "0",
      "description": "Mechanical appliances (whether or not hand operated) for projecting, dispersing or spraying liquids or powders; fire extinguishers, whether or not charged; spray guns and similar appliances; steam or sand blasting machines and similar jet projecting machines; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8424.10.0000",
      "rawHtsCode": "8424.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Fire extinguishers, whether or not charged",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8424.20",
      "rawHtsCode": "8424.20",
      "superior": null,
      "indent": "1",
      "description": "Spray guns and similar appliances:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8424.20.1000",
      "rawHtsCode": "8424.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Simple piston pump sprays and powder bellows",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8424.20.9000",
      "rawHtsCode": "8424.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8424.30",
      "rawHtsCode": "8424.30",
      "superior": null,
      "indent": "1",
      "description": "Steam or sand blasting machines and similar jet projecting machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8424.30.1000",
      "rawHtsCode": "8424.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Sand blasting machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8424.30.9000",
      "rawHtsCode": "8424.30.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8424.41",
      "rawHtsCode": "8424.41",
      "superior": null,
      "indent": "2",
      "description": "Portable sprayers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8424.41.1000",
      "rawHtsCode": "8424.41.10.00",
      "superior": null,
      "indent": "3",
      "description": "Sprayers (except sprayers, self-contained, having a capacity not over 20 liters)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8424.41.9000",
      "rawHtsCode": "8424.41.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8424.49.0000",
      "rawHtsCode": "8424.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8424.82.00",
      "rawHtsCode": "8424.82.00",
      "superior": null,
      "indent": "2",
      "description": "Agricultural or horticultural",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8424.82.0010",
      "rawHtsCode": "8424.82.00.10",
      "superior": null,
      "indent": "4",
      "description": "Self-propelled, center pivot",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8424.82.0020",
      "rawHtsCode": "8424.82.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8424.82.0090",
      "rawHtsCode": "8424.82.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8424.89.1000",
      "rawHtsCode": "8424.89.10.00",
      "superior": null,
      "indent": "2",
      "description": "Mechanical appliances for projecting, dispersing or spraying, of a kind used solely or principally for the manufacture of printed circuits or printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8424.89.9000",
      "rawHtsCode": "8424.89.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8424.90",
      "rawHtsCode": "8424.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8424.90.0500",
      "rawHtsCode": "8424.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "Of fire extinguishers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8424.90.1000",
      "rawHtsCode": "8424.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of simple piston pump sprays and powder bellows",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8424.90.2000",
      "rawHtsCode": "8424.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of sand blasting machines",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8424.90.90",
      "rawHtsCode": "8424.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.  "
      ],
      "flags": []
    },
    {
      "htsCode": "8424.90.9040",
      "rawHtsCode": "8424.90.90.40",
      "superior": null,
      "indent": "3",
      "description": "Of steam and similar jet projecting machines",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8424.90.9080",
      "rawHtsCode": "8424.90.90.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8425",
      "rawHtsCode": "8425",
      "superior": null,
      "indent": "0",
      "description": "Pulley tackle and hoists other than skip hoists; winches and capstans; jacks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8425.11.0000",
      "rawHtsCode": "8425.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Powered by electric motor",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8425.19.0000",
      "rawHtsCode": "8425.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8425.31.0100",
      "rawHtsCode": "8425.31.01.00",
      "superior": null,
      "indent": "2",
      "description": "Powered by electric motor",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8425.39.0100",
      "rawHtsCode": "8425.39.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8425.41.0000",
      "rawHtsCode": "8425.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Built-in jacking systems of a type used in garages",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8425.42.0000",
      "rawHtsCode": "8425.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other jacks and hoists, hydraulic",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8425.49.0000",
      "rawHtsCode": "8425.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8426",
      "rawHtsCode": "8426",
      "superior": null,
      "indent": "0",
      "description": "Ships' derricks; cranes, including cable cranes; mobile lifting frames, straddle carriers and works trucks fitted with a crane:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8426.11.0000",
      "rawHtsCode": "8426.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Overhead traveling cranes on fixed support",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8426.12.0000",
      "rawHtsCode": "8426.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mobile lifting frames on tires and straddle carriers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8426.19.0000",
      "rawHtsCode": "8426.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.92. ",
        "See 9903.91.09. "
      ],
      "flags": []
    },
    {
      "htsCode": "8426.20.0000",
      "rawHtsCode": "8426.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tower cranes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8426.30.0000",
      "rawHtsCode": "8426.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Portal or pedestal jib cranes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8426.41.00",
      "rawHtsCode": "8426.41.00",
      "superior": null,
      "indent": "2",
      "description": "On tires",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8426.41.0005",
      "rawHtsCode": "8426.41.00.05",
      "superior": null,
      "indent": "3",
      "description": "Works trucks fitted with a crane",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8426.41.0010",
      "rawHtsCode": "8426.41.00.10",
      "superior": null,
      "indent": "4",
      "description": "Cable operated",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8426.41.0090",
      "rawHtsCode": "8426.41.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8426.49.00",
      "rawHtsCode": "8426.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8426.49.0010",
      "rawHtsCode": "8426.49.00.10",
      "superior": null,
      "indent": "3",
      "description": "Cable operated",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8426.49.0090",
      "rawHtsCode": "8426.49.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8426.91.0000",
      "rawHtsCode": "8426.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Designed for mounting on road vehicles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8426.99.0000",
      "rawHtsCode": "8426.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8427",
      "rawHtsCode": "8427",
      "superior": null,
      "indent": "0",
      "description": "Fork-lift trucks; other works trucks fitted with lifting or handling equipment:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8427.10",
      "rawHtsCode": "8427.10",
      "superior": null,
      "indent": "1",
      "description": "Self-propelled trucks powered by an electric motor:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8427.10.4000",
      "rawHtsCode": "8427.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Rider-type, counterbalanced fork-lift trucks",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8427.10.80",
      "rawHtsCode": "8427.10.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8427.10.8020",
      "rawHtsCode": "8427.10.80.20",
      "superior": null,
      "indent": "4",
      "description": "Aerial work platforms of a kind described in statistical note 4 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8427.10.8030",
      "rawHtsCode": "8427.10.80.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8427.10.8040",
      "rawHtsCode": "8427.10.80.40",
      "superior": null,
      "indent": "4",
      "description": "Aerial work platforms of a kind described in statistical note 4 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8427.10.8050",
      "rawHtsCode": "8427.10.80.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8427.10.8070",
      "rawHtsCode": "8427.10.80.70",
      "superior": null,
      "indent": "4",
      "description": "Aerial work platforms of a kind described in statistical note 4 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8427.10.8095",
      "rawHtsCode": "8427.10.80.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8427.20",
      "rawHtsCode": "8427.20",
      "superior": null,
      "indent": "1",
      "description": "Other self-propelled trucks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8427.20.4000",
      "rawHtsCode": "8427.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Rider-type, counterbalanced fork-lift trucks",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8427.20.80",
      "rawHtsCode": "8427.20.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8427.20.8020",
      "rawHtsCode": "8427.20.80.20",
      "superior": null,
      "indent": "3",
      "description": "Aerial work platforms of a kind described in statistical note 4 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8427.20.8090",
      "rawHtsCode": "8427.20.80.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8427.90.00",
      "rawHtsCode": "8427.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other trucks",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8427.90.0020",
      "rawHtsCode": "8427.90.00.20",
      "superior": null,
      "indent": "3",
      "description": "Aerial work platforms of a kind described in statistical note 4 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8427.90.0090",
      "rawHtsCode": "8427.90.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8428",
      "rawHtsCode": "8428",
      "superior": null,
      "indent": "0",
      "description": "Other lifting, handling, loading or unloading machinery (for example, elevators, escalators, conveyors, teleferics):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8428.10.0000",
      "rawHtsCode": "8428.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Passenger or freight elevators other than continuous action; skip hoists",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8428.20.00",
      "rawHtsCode": "8428.20.00",
      "superior": null,
      "indent": "1",
      "description": "Pneumatic elevators and conveyors",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8428.20.0010",
      "rawHtsCode": "8428.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Conveyors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8428.20.0050",
      "rawHtsCode": "8428.20.00.50",
      "superior": null,
      "indent": "2",
      "description": "Elevators",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8428.31.0000",
      "rawHtsCode": "8428.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Specially designed for underground use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8428.32.0000",
      "rawHtsCode": "8428.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, bucket type",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8428.33.0000",
      "rawHtsCode": "8428.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, belt type",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8428.39.0000",
      "rawHtsCode": "8428.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8428.40.0000",
      "rawHtsCode": "8428.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Escalators and moving walkways",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8428.60.0000",
      "rawHtsCode": "8428.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Teleferics, chair lifts, ski draglines; traction mechanisms for funiculars",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8428.70.0000",
      "rawHtsCode": "8428.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Industrial robots",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8428.90.03",
      "rawHtsCode": "8428.90.03",
      "superior": null,
      "indent": "1",
      "description": "Other machinery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8428.90.0310",
      "rawHtsCode": "8428.90.03.10",
      "superior": null,
      "indent": "2",
      "description": "Woodland log handling equipment (other than skidders)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8428.90.0390",
      "rawHtsCode": "8428.90.03.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429",
      "rawHtsCode": "8429",
      "superior": null,
      "indent": "0",
      "description": "Self-propelled bulldozers, angledozers, graders, levelers, scrapers, mechanical shovels, excavators, shovel loaders, tamping machines and road rollers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.11.00",
      "rawHtsCode": "8429.11.00",
      "superior": null,
      "indent": "2",
      "description": "Track laying",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8429.11.0010",
      "rawHtsCode": "8429.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.11.0090",
      "rawHtsCode": "8429.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.19.00",
      "rawHtsCode": "8429.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8429.19.0010",
      "rawHtsCode": "8429.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.19.0090",
      "rawHtsCode": "8429.19.00.90",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.20.0000",
      "rawHtsCode": "8429.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Graders and levelers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8429.30.00",
      "rawHtsCode": "8429.30.00",
      "superior": null,
      "indent": "1",
      "description": "Scrapers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8429.30.0020",
      "rawHtsCode": "8429.30.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not exceeding <il>13.7 m<sup>3</sup></il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.30.0040",
      "rawHtsCode": "8429.30.00.40",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>13.7 m<sup>3</sup></il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.30.0060",
      "rawHtsCode": "8429.30.00.60",
      "superior": null,
      "indent": "2",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.40.00",
      "rawHtsCode": "8429.40.00",
      "superior": null,
      "indent": "1",
      "description": "Tamping machines and road rollers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8429.40.0020",
      "rawHtsCode": "8429.40.00.20",
      "superior": null,
      "indent": "3",
      "description": "Vibratory",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.40.0040",
      "rawHtsCode": "8429.40.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.40.0060",
      "rawHtsCode": "8429.40.00.60",
      "superior": null,
      "indent": "2",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51",
      "rawHtsCode": "8429.51",
      "superior": null,
      "indent": "2",
      "description": "Front-end shovel loaders:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.10",
      "rawHtsCode": "8429.51.10",
      "superior": null,
      "indent": "3",
      "description": "Wheel-type",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8429.51.1005",
      "rawHtsCode": "8429.51.10.05",
      "superior": null,
      "indent": "6",
      "description": "2 wheel drive",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.1015",
      "rawHtsCode": "8429.51.10.15",
      "superior": null,
      "indent": "7",
      "description": "Under <il>1.5 m<sup>3</sup></il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.1025",
      "rawHtsCode": "8429.51.10.25",
      "superior": null,
      "indent": "7",
      "description": "At least <il>1.5 m<sup>3</sup></il> but under <il>2.2 m<sup>3</sup></il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.1030",
      "rawHtsCode": "8429.51.10.30",
      "superior": null,
      "indent": "7",
      "description": "At least <il>2.2 m<sup>3</sup></il> but under <il>2.9 m<sup>3</sup></il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.1035",
      "rawHtsCode": "8429.51.10.35",
      "superior": null,
      "indent": "7",
      "description": "At least <il>2.9 m<sup>3</sup></il> but under <il>3.8 m<sup>3</sup></il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.1040",
      "rawHtsCode": "8429.51.10.40",
      "superior": null,
      "indent": "7",
      "description": "At least <il>3.8 m<sup>3</sup></il> but under <il>5.2 m<sup>3</sup></il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.1045",
      "rawHtsCode": "8429.51.10.45",
      "superior": null,
      "indent": "7",
      "description": "At least <il>5.2 m<sup>3</sup></il> but under <il>7.6 m<sup>3</sup></il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.1050",
      "rawHtsCode": "8429.51.10.50",
      "superior": null,
      "indent": "7",
      "description": "At least <il>7.6 m<sup>3</sup></il> but under <il>11.4 m<sup>3</sup></il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.1055",
      "rawHtsCode": "8429.51.10.55",
      "superior": null,
      "indent": "7",
      "description": "<il>11.4 m<sup>3</sup></il> and over",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.1060",
      "rawHtsCode": "8429.51.10.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.1065",
      "rawHtsCode": "8429.51.10.65",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.50",
      "rawHtsCode": "8429.51.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8429.51.5010",
      "rawHtsCode": "8429.51.50.10",
      "superior": null,
      "indent": "5",
      "description": "Less than <il>44.7 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.5020",
      "rawHtsCode": "8429.51.50.20",
      "superior": null,
      "indent": "5",
      "description": "At least <il>44.7 kW</il> but under <il>67.1 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.5030",
      "rawHtsCode": "8429.51.50.30",
      "superior": null,
      "indent": "5",
      "description": "At least <il>67.1 kW</il> but under <il>93.2 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.5040",
      "rawHtsCode": "8429.51.50.40",
      "superior": null,
      "indent": "5",
      "description": "At least <il>93.2 kW</il> but under <il>119.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.5050",
      "rawHtsCode": "8429.51.50.50",
      "superior": null,
      "indent": "5",
      "description": "<il>119.3 kW</il> and over",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.51.5060",
      "rawHtsCode": "8429.51.50.60",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.52",
      "rawHtsCode": "8429.52",
      "superior": null,
      "indent": "2",
      "description": "Machinery with a 360˚ revolving superstructure:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.52.10",
      "rawHtsCode": "8429.52.10",
      "superior": null,
      "indent": "3",
      "description": "Backhoes, shovels, clamshells and draglines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8429.52.1010",
      "rawHtsCode": "8429.52.10.10",
      "superior": null,
      "indent": "6",
      "description": "Hydraulic",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.52.1020",
      "rawHtsCode": "8429.52.10.20",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.52.1030",
      "rawHtsCode": "8429.52.10.30",
      "superior": null,
      "indent": "6",
      "description": "Hydraulic",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.52.1040",
      "rawHtsCode": "8429.52.10.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.52.1050",
      "rawHtsCode": "8429.52.10.50",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.52.50",
      "rawHtsCode": "8429.52.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8429.52.5010",
      "rawHtsCode": "8429.52.50.10",
      "superior": null,
      "indent": "4",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.52.5090",
      "rawHtsCode": "8429.52.50.90",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.59",
      "rawHtsCode": "8429.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.59.10",
      "rawHtsCode": "8429.59.10",
      "superior": null,
      "indent": "3",
      "description": "Backhoes, shovels, clamshells and draglines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8429.59.1030",
      "rawHtsCode": "8429.59.10.30",
      "superior": null,
      "indent": "5",
      "description": "Backhoes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.59.1060",
      "rawHtsCode": "8429.59.10.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.59.1090",
      "rawHtsCode": "8429.59.10.90",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.59.50",
      "rawHtsCode": "8429.59.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8429.59.5020",
      "rawHtsCode": "8429.59.50.20",
      "superior": null,
      "indent": "6",
      "description": "Ladder type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.59.5040",
      "rawHtsCode": "8429.59.50.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.59.5060",
      "rawHtsCode": "8429.59.50.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8429.59.5080",
      "rawHtsCode": "8429.59.50.80",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430",
      "rawHtsCode": "8430",
      "superior": null,
      "indent": "0",
      "description": "Other moving, grading, leveling, scraping, excavating, tamping, compacting, extracting or boring machinery, for earth, minerals or ores; pile-drivers and pile-extractors; snowplows and snowblowers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.10.0000",
      "rawHtsCode": "8430.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Pile-drivers and pile-extractors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8430.20.00",
      "rawHtsCode": "8430.20.00",
      "superior": null,
      "indent": "1",
      "description": "Snowplows and snowblowers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8430.20.0030",
      "rawHtsCode": "8430.20.00.30",
      "superior": null,
      "indent": "3",
      "description": "Attachment type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.20.0060",
      "rawHtsCode": "8430.20.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.20.0090",
      "rawHtsCode": "8430.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.31.00",
      "rawHtsCode": "8430.31.00",
      "superior": null,
      "indent": "2",
      "description": "Self-propelled",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8430.31.0040",
      "rawHtsCode": "8430.31.00.40",
      "superior": null,
      "indent": "3",
      "description": "Rock breaking machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.31.0080",
      "rawHtsCode": "8430.31.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.39.00",
      "rawHtsCode": "8430.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8430.39.0040",
      "rawHtsCode": "8430.39.00.40",
      "superior": null,
      "indent": "3",
      "description": "Rock breaking machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.39.0080",
      "rawHtsCode": "8430.39.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.41.0000",
      "rawHtsCode": "8430.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Self-propelled",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8430.49",
      "rawHtsCode": "8430.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.49.4000",
      "rawHtsCode": "8430.49.40.00",
      "superior": null,
      "indent": "3",
      "description": "Offshore oil and natural gas drilling and production platforms",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8430.49.80",
      "rawHtsCode": "8430.49.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8430.49.8010",
      "rawHtsCode": "8430.49.80.10",
      "superior": null,
      "indent": "5",
      "description": "Rotary",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.49.8020",
      "rawHtsCode": "8430.49.80.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.49.8030",
      "rawHtsCode": "8430.49.80.30",
      "superior": null,
      "indent": "5",
      "description": "Rotary",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.49.8040",
      "rawHtsCode": "8430.49.80.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.49.8050",
      "rawHtsCode": "8430.49.80.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.50",
      "rawHtsCode": "8430.50",
      "superior": null,
      "indent": "1",
      "description": "Other machinery, self-propelled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8430.50.1000",
      "rawHtsCode": "8430.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Peat excavators",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8430.50.5000",
      "rawHtsCode": "8430.50.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8430.61.0000",
      "rawHtsCode": "8430.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tamping or compacting machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8430.69.0100",
      "rawHtsCode": "8430.69.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8431",
      "rawHtsCode": "8431",
      "superior": null,
      "indent": "0",
      "description": "Parts suitable for use solely or principally with the machinery of headings 8425 to 8430:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.10.00",
      "rawHtsCode": "8431.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of machinery of heading 8425",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8431.10.0010",
      "rawHtsCode": "8431.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of machinery of subheading 8425.11 or 8425.19",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.10.0090",
      "rawHtsCode": "8431.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.20.0000",
      "rawHtsCode": "8431.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of machinery of heading 8427",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8431.31.00",
      "rawHtsCode": "8431.31.00",
      "superior": null,
      "indent": "2",
      "description": "Of passenger or freight elevators other than continuous action, skip hoists or escalators",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8431.31.0020",
      "rawHtsCode": "8431.31.00.20",
      "superior": null,
      "indent": "3",
      "description": "Of skip hoists",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.31.0040",
      "rawHtsCode": "8431.31.00.40",
      "superior": null,
      "indent": "3",
      "description": "Of escalators",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.31.0060",
      "rawHtsCode": "8431.31.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.39.00",
      "rawHtsCode": "8431.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8431.39.0010",
      "rawHtsCode": "8431.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of elevators and conveyors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.39.0050",
      "rawHtsCode": "8431.39.00.50",
      "superior": null,
      "indent": "4",
      "description": "Of oil and gas field machinery",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.39.0070",
      "rawHtsCode": "8431.39.00.70",
      "superior": null,
      "indent": "4",
      "description": "Of the woodland log handling equipment of statistical reporting number 8428.90.0310",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.39.0080",
      "rawHtsCode": "8431.39.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.41.00",
      "rawHtsCode": "8431.41.00",
      "superior": null,
      "indent": "2",
      "description": "Buckets, shovels, grabs and grips",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8431.41.0020",
      "rawHtsCode": "8431.41.00.20",
      "superior": null,
      "indent": "3",
      "description": "Shovel attachments",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.41.0040",
      "rawHtsCode": "8431.41.00.40",
      "superior": null,
      "indent": "3",
      "description": "Clamshell (grappler) attachments",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.41.0060",
      "rawHtsCode": "8431.41.00.60",
      "superior": null,
      "indent": "3",
      "description": "Dragline buckets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.41.0080",
      "rawHtsCode": "8431.41.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.42.0000",
      "rawHtsCode": "8431.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Bulldozer or angledozer blades",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8431.43",
      "rawHtsCode": "8431.43",
      "superior": null,
      "indent": "2",
      "description": "Parts for boring or sinking machinery of subheading 8430.41 or 8430.49:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.43.4000",
      "rawHtsCode": "8431.43.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of offshore oil and natural gas drilling and production platforms",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8431.43.80",
      "rawHtsCode": "8431.43.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8431.43.8020",
      "rawHtsCode": "8431.43.80.20",
      "superior": null,
      "indent": "5",
      "description": "Tool joints, whether or not forged",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.43.8040",
      "rawHtsCode": "8431.43.80.40",
      "superior": null,
      "indent": "5",
      "description": "Drill pipe fitted with tool joints",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.43.8060",
      "rawHtsCode": "8431.43.80.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.43.8090",
      "rawHtsCode": "8431.43.80.90",
      "superior": null,
      "indent": "4",
      "description": "Of other boring or sinking machinery",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49",
      "rawHtsCode": "8431.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.10",
      "rawHtsCode": "8431.49.10",
      "superior": null,
      "indent": "3",
      "description": "Of machinery of heading 8426",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8431.49.1010",
      "rawHtsCode": "8431.49.10.10",
      "superior": null,
      "indent": "4",
      "description": "Of machinery of subheadings 8426.11, 8426.19 and 8426.30",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.1060",
      "rawHtsCode": "8431.49.10.60",
      "superior": null,
      "indent": "4",
      "description": "Of mobile lifting frames, straddle carriers and works trucks fitted with a crane",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.1070",
      "rawHtsCode": "8431.49.10.70",
      "superior": null,
      "indent": "5",
      "description": "Of copper or copper alloys",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.1080",
      "rawHtsCode": "8431.49.10.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.90",
      "rawHtsCode": "8431.49.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8431.49.9005",
      "rawHtsCode": "8431.49.90.05",
      "superior": null,
      "indent": "5",
      "description": "Backhoe attachments",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9010",
      "rawHtsCode": "8431.49.90.10",
      "superior": null,
      "indent": "5",
      "description": "Front-end loader attachments",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9015",
      "rawHtsCode": "8431.49.90.15",
      "superior": null,
      "indent": "5",
      "description": "Rippers and rooters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9020",
      "rawHtsCode": "8431.49.90.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9025",
      "rawHtsCode": "8431.49.90.25",
      "superior": null,
      "indent": "6",
      "description": "Cast axle housings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9032",
      "rawHtsCode": "8431.49.90.32",
      "superior": null,
      "indent": "7",
      "description": "Of copper or copper alloys",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9034",
      "rawHtsCode": "8431.49.90.34",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9035",
      "rawHtsCode": "8431.49.90.35",
      "superior": null,
      "indent": "6",
      "description": "Cast axle housings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9036",
      "rawHtsCode": "8431.49.90.36",
      "superior": null,
      "indent": "7",
      "description": "Road wheels",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9038",
      "rawHtsCode": "8431.49.90.38",
      "superior": null,
      "indent": "7",
      "description": "Wheel and tire assemblies",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9039",
      "rawHtsCode": "8431.49.90.39",
      "superior": null,
      "indent": "8",
      "description": "Of copper or copper alloys",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9041",
      "rawHtsCode": "8431.49.90.41",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9045",
      "rawHtsCode": "8431.49.90.45",
      "superior": null,
      "indent": "6",
      "description": "Scraper bowls for scrapers of subheadings 8429.30 and 8430.69.01",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9050",
      "rawHtsCode": "8431.49.90.50",
      "superior": null,
      "indent": "6",
      "description": "Track links",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9055",
      "rawHtsCode": "8431.49.90.55",
      "superior": null,
      "indent": "6",
      "description": "Cast axle housings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9081",
      "rawHtsCode": "8431.49.90.81",
      "superior": null,
      "indent": "7",
      "description": "Steel forgings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9084",
      "rawHtsCode": "8431.49.90.84",
      "superior": null,
      "indent": "8",
      "description": "Road wheels",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9090",
      "rawHtsCode": "8431.49.90.90",
      "superior": null,
      "indent": "8",
      "description": "Wheel and tire assemblies",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9092",
      "rawHtsCode": "8431.49.90.92",
      "superior": null,
      "indent": "9",
      "description": "Of copper or copper alloys",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8431.49.9094",
      "rawHtsCode": "8431.49.90.94",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432",
      "rawHtsCode": "8432",
      "superior": null,
      "indent": "0",
      "description": "Agricultural, horticultural or forestry machinery for soil preparation or cultivation; lawn or sports ground rollers; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.10.00",
      "rawHtsCode": "8432.10.00",
      "superior": null,
      "indent": "1",
      "description": "Plows",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8432.10.0020",
      "rawHtsCode": "8432.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Moldboard plows except listers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.10.0040",
      "rawHtsCode": "8432.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Disc plows",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.10.0060",
      "rawHtsCode": "8432.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.21.0000",
      "rawHtsCode": "8432.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Disc harrows",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8432.29.00",
      "rawHtsCode": "8432.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8432.29.0040",
      "rawHtsCode": "8432.29.00.40",
      "superior": null,
      "indent": "4",
      "description": "Cultivators, tractor drawn or for tractor mounting",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.29.0060",
      "rawHtsCode": "8432.29.00.60",
      "superior": null,
      "indent": "4",
      "description": "Walk behind rotary tillers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.29.0080",
      "rawHtsCode": "8432.29.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.29.0090",
      "rawHtsCode": "8432.29.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.31.00",
      "rawHtsCode": "8432.31.00",
      "superior": null,
      "indent": "2",
      "description": "No-till direct seeders, planters and transplanters",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8432.31.0010",
      "rawHtsCode": "8432.31.00.10",
      "superior": null,
      "indent": "3",
      "description": "Planters and transplanters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.31.0090",
      "rawHtsCode": "8432.31.00.90",
      "superior": null,
      "indent": "3",
      "description": "Seeders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.39.00",
      "rawHtsCode": "8432.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8432.39.0010",
      "rawHtsCode": "8432.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Planters and transplanters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.39.0090",
      "rawHtsCode": "8432.39.00.90",
      "superior": null,
      "indent": "3",
      "description": "Seeders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.41.0000",
      "rawHtsCode": "8432.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Manure spreaders",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8432.42.0000",
      "rawHtsCode": "8432.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fertilizer distributors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8432.80.00",
      "rawHtsCode": "8432.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other machinery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8432.80.0010",
      "rawHtsCode": "8432.80.00.10",
      "superior": null,
      "indent": "2",
      "description": "Tow behind spreaders, aerators, and de- thatchers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.80.0080",
      "rawHtsCode": "8432.80.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.90.00",
      "rawHtsCode": "8432.90.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8432.90.0010",
      "rawHtsCode": "8432.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Road wheels without tires",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.90.0020",
      "rawHtsCode": "8432.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Wheel and tire assemblies",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.90.0040",
      "rawHtsCode": "8432.90.00.40",
      "superior": null,
      "indent": "3",
      "description": "Of plows",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.90.0050",
      "rawHtsCode": "8432.90.00.50",
      "superior": null,
      "indent": "3",
      "description": "Of harrows, scarifiers, cultivators, weeders and hoes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.90.0060",
      "rawHtsCode": "8432.90.00.60",
      "superior": null,
      "indent": "3",
      "description": "Of seeders, planters, transplanters, manure spreaders and fertilizer distributors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8432.90.0081",
      "rawHtsCode": "8432.90.00.81",
      "superior": null,
      "indent": "3",
      "description": "Of other machinery",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433",
      "rawHtsCode": "8433",
      "superior": null,
      "indent": "0",
      "description": "Harvesting or threshing machinery, including straw or fodder balers; grass or hay mowers; machines for cleaning, sorting or grading eggs, fruit or other agricultural produce, other than machinery of heading 8437; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.11.00",
      "rawHtsCode": "8433.11.00",
      "superior": null,
      "indent": "2",
      "description": "Powered, with the cutting device rotating in a horizontal plane",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8433.11.0010",
      "rawHtsCode": "8433.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Electric mowers, including battery operated",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.11.0020",
      "rawHtsCode": "8433.11.00.20",
      "superior": null,
      "indent": "4",
      "description": "Under <il>5.2 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.11.0030",
      "rawHtsCode": "8433.11.00.30",
      "superior": null,
      "indent": "4",
      "description": "<il>5.2 kW</il> and over but under <il>7.46 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.11.0040",
      "rawHtsCode": "8433.11.00.40",
      "superior": null,
      "indent": "4",
      "description": "<il>7.46 kW</il> and over",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.11.0050",
      "rawHtsCode": "8433.11.00.50",
      "superior": null,
      "indent": "4",
      "description": "Under <il>3.7 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.11.0060",
      "rawHtsCode": "8433.11.00.60",
      "superior": null,
      "indent": "4",
      "description": "<il>3.7 kW</il> and over",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.19.00",
      "rawHtsCode": "8433.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8433.19.0010",
      "rawHtsCode": "8433.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Greens mowers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.19.0020",
      "rawHtsCode": "8433.19.00.20",
      "superior": null,
      "indent": "3",
      "description": "Gang cutting units",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.19.0030",
      "rawHtsCode": "8433.19.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other riding mowers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.19.0040",
      "rawHtsCode": "8433.19.00.40",
      "superior": null,
      "indent": "4",
      "description": "Gasoline powered",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.19.0050",
      "rawHtsCode": "8433.19.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.20.00",
      "rawHtsCode": "8433.20.00",
      "superior": null,
      "indent": "1",
      "description": "Other mowers, including cutter bars for tractor mounting",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8433.20.0020",
      "rawHtsCode": "8433.20.00.20",
      "superior": null,
      "indent": "3",
      "description": "Rotary cutter type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.20.0040",
      "rawHtsCode": "8433.20.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.20.0060",
      "rawHtsCode": "8433.20.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.30.0000",
      "rawHtsCode": "8433.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other haymaking machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8433.40.0000",
      "rawHtsCode": "8433.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Straw or fodder balers, including pick-up balers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8433.51.00",
      "rawHtsCode": "8433.51.00",
      "superior": null,
      "indent": "2",
      "description": "Combine harvester-threshers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8433.51.0010",
      "rawHtsCode": "8433.51.00.10",
      "superior": null,
      "indent": "3",
      "description": "Self-propelled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.51.0090",
      "rawHtsCode": "8433.51.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.52.0000",
      "rawHtsCode": "8433.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other threshing machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8433.53.0000",
      "rawHtsCode": "8433.53.00.00",
      "superior": null,
      "indent": "2",
      "description": "Root or tuber harvesting machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8433.59.00",
      "rawHtsCode": "8433.59.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8433.59.0010",
      "rawHtsCode": "8433.59.00.10",
      "superior": null,
      "indent": "3",
      "description": "Field forage harvesters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.59.0090",
      "rawHtsCode": "8433.59.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.60.00",
      "rawHtsCode": "8433.60.00",
      "superior": null,
      "indent": "1",
      "description": "Machines for cleaning, sorting or grading eggs, fruit or other agricultural produce",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8433.60.0010",
      "rawHtsCode": "8433.60.00.10",
      "superior": null,
      "indent": "2",
      "description": "Machines for cleaning, sorting or grading eggs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.60.0090",
      "rawHtsCode": "8433.60.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.90",
      "rawHtsCode": "8433.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.90.10",
      "rawHtsCode": "8433.90.10",
      "superior": null,
      "indent": "2",
      "description": "Of mowers for lawns, parks or sports grounds",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8433.90.1010",
      "rawHtsCode": "8433.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Wheel and tire assemblies",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.90.1090",
      "rawHtsCode": "8433.90.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.90.50",
      "rawHtsCode": "8433.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8433.90.5010",
      "rawHtsCode": "8433.90.50.10",
      "superior": null,
      "indent": "4",
      "description": "Road wheels",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.90.5025",
      "rawHtsCode": "8433.90.50.25",
      "superior": null,
      "indent": "4",
      "description": "Of haying machines and balers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.90.5045",
      "rawHtsCode": "8433.90.50.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.90.5060",
      "rawHtsCode": "8433.90.50.60",
      "superior": null,
      "indent": "3",
      "description": "Of machines for cleaning, sorting or grading eggs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8433.90.5080",
      "rawHtsCode": "8433.90.50.80",
      "superior": null,
      "indent": "3",
      "description": "Of machines for cleaning, sorting or grading fruit or other agricultural produce",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8434",
      "rawHtsCode": "8434",
      "superior": null,
      "indent": "0",
      "description": "Milking machines and dairy machinery, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8434.10.0000",
      "rawHtsCode": "8434.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Milking machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8434.20.0000",
      "rawHtsCode": "8434.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Dairy machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8434.90.0000",
      "rawHtsCode": "8434.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8435",
      "rawHtsCode": "8435",
      "superior": null,
      "indent": "0",
      "description": "Presses, crushers and similar machinery, used in the manufacture of wine, cider, fruit juices or similar beverages; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8435.10.0000",
      "rawHtsCode": "8435.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8435.90.0000",
      "rawHtsCode": "8435.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8436",
      "rawHtsCode": "8436",
      "superior": null,
      "indent": "0",
      "description": "Other agricultural, horticultural, forestry, poultry-keeping or bee-keeping machinery, including germination plant fitted with mechanical or thermal equipment; poultry incubators and brooders; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8436.10.0000",
      "rawHtsCode": "8436.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for preparing animal feeds",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8436.21.0000",
      "rawHtsCode": "8436.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Poultry incubators and brooders",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8436.29.0000",
      "rawHtsCode": "8436.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8436.80.00",
      "rawHtsCode": "8436.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other machinery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8436.80.0020",
      "rawHtsCode": "8436.80.00.20",
      "superior": null,
      "indent": "2",
      "description": "Forestry machinery",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8436.80.0040",
      "rawHtsCode": "8436.80.00.40",
      "superior": null,
      "indent": "3",
      "description": "Barn and barnyard machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8436.80.0060",
      "rawHtsCode": "8436.80.00.60",
      "superior": null,
      "indent": "3",
      "description": "Machines for preparing crops for market or for use",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8436.80.0070",
      "rawHtsCode": "8436.80.00.70",
      "superior": null,
      "indent": "4",
      "description": "Bee-keeping machinery",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8436.80.0090",
      "rawHtsCode": "8436.80.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8436.91.00",
      "rawHtsCode": "8436.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of poultry-keeping machinery or poultry incubators and brooders",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8436.91.0040",
      "rawHtsCode": "8436.91.00.40",
      "superior": null,
      "indent": "3",
      "description": "Of poultry incubators and brooders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8436.91.0080",
      "rawHtsCode": "8436.91.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8436.99.00",
      "rawHtsCode": "8436.99.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8436.99.0020",
      "rawHtsCode": "8436.99.00.20",
      "superior": null,
      "indent": "3",
      "description": "Of forestry machinery",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8436.99.0030",
      "rawHtsCode": "8436.99.00.30",
      "superior": null,
      "indent": "3",
      "description": "Of bee-keeping machinery",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8436.99.0035",
      "rawHtsCode": "8436.99.00.35",
      "superior": null,
      "indent": "3",
      "description": "Of machinery for preparing animal feeds",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8436.99.0040",
      "rawHtsCode": "8436.99.00.40",
      "superior": null,
      "indent": "4",
      "description": "Of barn or barnyard machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8436.99.0070",
      "rawHtsCode": "8436.99.00.70",
      "superior": null,
      "indent": "4",
      "description": "Of machines for preparing crops for market or for use",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8436.99.0090",
      "rawHtsCode": "8436.99.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8437",
      "rawHtsCode": "8437",
      "superior": null,
      "indent": "0",
      "description": "Machines for cleaning, sorting or grading seed, grain or dried leguminous vegetables, and parts thereof; machinery used in the milling industry or for the working of cereals or dried leguminous vegetables, other than farm type machinery; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8437.10.0000",
      "rawHtsCode": "8437.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machines for cleaning, sorting or grading seed, grain or dried leguminous vegetables",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8437.80.00",
      "rawHtsCode": "8437.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other machinery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8437.80.0010",
      "rawHtsCode": "8437.80.00.10",
      "superior": null,
      "indent": "2",
      "description": "Flour mill and grain mill machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8437.80.0090",
      "rawHtsCode": "8437.80.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8437.90.00",
      "rawHtsCode": "8437.90.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8437.90.0010",
      "rawHtsCode": "8437.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of flour mill or grain mill machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8437.90.0090",
      "rawHtsCode": "8437.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8438",
      "rawHtsCode": "8438",
      "superior": null,
      "indent": "0",
      "description": "Machinery, not specified or included elsewhere in this chapter, for the industrial preparation or manufacture of food or drink, other than machinery for the extraction or preparation of animal or fixed vegetable or microbial fats or oils; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8438.10.00",
      "rawHtsCode": "8438.10.00",
      "superior": null,
      "indent": "1",
      "description": "Bakery machinery and machinery for the manufacture of macaroni, spaghetti or similar products",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8438.10.0010",
      "rawHtsCode": "8438.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Bakery machinery",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8438.10.0090",
      "rawHtsCode": "8438.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8438.20.0000",
      "rawHtsCode": "8438.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for the manufacture of confectionery, cocoa or chocolate",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8438.30.0000",
      "rawHtsCode": "8438.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for sugar manufacture",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8438.40.0000",
      "rawHtsCode": "8438.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Brewery machinery",
      "units": [
        "No."
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8438.50.00",
      "rawHtsCode": "8438.50.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for the preparation of meat or poultry",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8438.50.0010",
      "rawHtsCode": "8438.50.00.10",
      "superior": null,
      "indent": "2",
      "description": "Meat- and poultry-packing plant machinery",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8438.50.0090",
      "rawHtsCode": "8438.50.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8438.60.0000",
      "rawHtsCode": "8438.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for the preparation of fruits, nuts or vegetables",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8438.80.0000",
      "rawHtsCode": "8438.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8438.90",
      "rawHtsCode": "8438.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8438.90.1000",
      "rawHtsCode": "8438.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of machinery for sugar manufacture",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8438.90.90",
      "rawHtsCode": "8438.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8438.90.9015",
      "rawHtsCode": "8438.90.90.15",
      "superior": null,
      "indent": "3",
      "description": "Of bakery machinery and machinery for the manufacture of macaroni, spaghetti or similar products",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8438.90.9030",
      "rawHtsCode": "8438.90.90.30",
      "superior": null,
      "indent": "3",
      "description": "Of machinery for the manufacture of confectionery, cocoa or chocolate",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8438.90.9060",
      "rawHtsCode": "8438.90.90.60",
      "superior": null,
      "indent": "3",
      "description": "Of machinery for the preparation of meat or poultry",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8438.90.9090",
      "rawHtsCode": "8438.90.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8439",
      "rawHtsCode": "8439",
      "superior": null,
      "indent": "0",
      "description": "Machinery for making pulp of fibrous cellulosic material or for making or finishing paper or paperboard (other than the machinery of heading 8419); parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8439.10.00",
      "rawHtsCode": "8439.10.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for making pulp of fibrous cellulosic material",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8439.10.0010",
      "rawHtsCode": "8439.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8439.10.0090",
      "rawHtsCode": "8439.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8439.20.00",
      "rawHtsCode": "8439.20.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for making paper or paperboard",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8439.20.0010",
      "rawHtsCode": "8439.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8439.20.0090",
      "rawHtsCode": "8439.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8439.30.0000",
      "rawHtsCode": "8439.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for finishing paper or paperboard",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8439.91",
      "rawHtsCode": "8439.91",
      "superior": null,
      "indent": "2",
      "description": "Of machinery for making pulp of fibrous cellulosic materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8439.91.1000",
      "rawHtsCode": "8439.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Bed plates, roll bars and other stock-treating parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8439.91.9000",
      "rawHtsCode": "8439.91.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8439.99",
      "rawHtsCode": "8439.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8439.99.1000",
      "rawHtsCode": "8439.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of machinery for making paper or paperboard",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8439.99.5000",
      "rawHtsCode": "8439.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Of machinery for finishing paper or paperboard",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8440",
      "rawHtsCode": "8440",
      "superior": null,
      "indent": "0",
      "description": "Bookbinding machinery, including book-sewing machines, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8440.10.0000",
      "rawHtsCode": "8440.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8440.90.0000",
      "rawHtsCode": "8440.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8441",
      "rawHtsCode": "8441",
      "superior": null,
      "indent": "0",
      "description": "Other machinery for making up paper pulp, paper or paperboard, including cutting machines of all kinds, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8441.10.0000",
      "rawHtsCode": "8441.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cutting machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8441.20.0000",
      "rawHtsCode": "8441.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machines for making bags, sacks or envelopes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8441.30.0000",
      "rawHtsCode": "8441.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machines for making cartons, boxes, cases, tubes, drums or similar containers, other than by molding",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8441.40.0000",
      "rawHtsCode": "8441.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machines for molding articles in paper pulp, paper or paperboard",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8441.80.0000",
      "rawHtsCode": "8441.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8441.90.0000",
      "rawHtsCode": "8441.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8442",
      "rawHtsCode": "8442",
      "superior": null,
      "indent": "0",
      "description": "Machinery, apparatus and equipment (other than the machines of headings 8456 to 8465), for preparing or making plates, cylinders or other printing components; plates, cylinders and other printing components; plates, cylinders and lithographic stones, prepared for printing purposes (for example, planed, grained or polished); parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8442.30.01",
      "rawHtsCode": "8442.30.01",
      "superior": null,
      "indent": "1",
      "description": "Machinery, apparatus and equipment",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8442.30.0110",
      "rawHtsCode": "8442.30.01.10",
      "superior": null,
      "indent": "2",
      "description": "Phototypesetting and composing machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8442.30.0150",
      "rawHtsCode": "8442.30.01.50",
      "superior": null,
      "indent": "2",
      "description": "Other machinery, apparatus and equipment",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8442.40.0000",
      "rawHtsCode": "8442.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts of the foregoing machinery, apparatus or equipment",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8442.50",
      "rawHtsCode": "8442.50",
      "superior": null,
      "indent": "1",
      "description": "Plates, cylinders and other printing components; plates, cylinders and lithographic stones, prepared for printing purposes (for example, planed, grained or polished):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8442.50.1000",
      "rawHtsCode": "8442.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Plates",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8442.50.9000",
      "rawHtsCode": "8442.50.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443",
      "rawHtsCode": "8443",
      "superior": null,
      "indent": "0",
      "description": "Printing machinery used for printing by means of plates, cylinders and other printing components of heading 8442; other printers, copying machines and facsimile machines, whether or not combined; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.11",
      "rawHtsCode": "8443.11",
      "superior": null,
      "indent": "2",
      "description": "Offset printing machinery, reel-fed:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.11.1000",
      "rawHtsCode": "8443.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Double-width newspaper printing presses",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8443.11.5000",
      "rawHtsCode": "8443.11.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8443.12.0000",
      "rawHtsCode": "8443.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Offset printing machinery, sheet-fed, office type (using sheets with one side not exceeding <il>22 cm</il> and the other side not exceeding <il>36 cm</il> in the unfolded state)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8443.13.0000",
      "rawHtsCode": "8443.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other offset printing machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.14.0000",
      "rawHtsCode": "8443.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Letterpress printing machinery, reel fed, excluding flexographic printing",
      "units": [
        "No."
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8443.15.0000",
      "rawHtsCode": "8443.15.00.00",
      "superior": null,
      "indent": "2",
      "description": "Letterpress printing machinery, other than reel fed, excluding flexographic printing",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8443.16.0000",
      "rawHtsCode": "8443.16.00.00",
      "superior": null,
      "indent": "2",
      "description": "Flexographic printing machinery",
      "units": [
        "No."
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8443.17.0000",
      "rawHtsCode": "8443.17.00.00",
      "superior": null,
      "indent": "2",
      "description": "Gravure printing machinery",
      "units": [
        "No."
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8443.19",
      "rawHtsCode": "8443.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.19.2000",
      "rawHtsCode": "8443.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Textile printing machinery",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8443.19.3000",
      "rawHtsCode": "8443.19.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.31.0000",
      "rawHtsCode": "8443.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Machines which perform two or more of the functions of printing, copying or facsimile transmission, capable of connecting to an automatic data processing machine or to a network",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.32",
      "rawHtsCode": "8443.32",
      "superior": null,
      "indent": "2",
      "description": "Other, capable of connecting to an automatic data processing machine or to a network:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.32.10",
      "rawHtsCode": "8443.32.10",
      "superior": null,
      "indent": "3",
      "description": "Printer units",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.32.1010",
      "rawHtsCode": "8443.32.10.10",
      "superior": null,
      "indent": "5",
      "description": "Capable of producing more than 20 pages per minute",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.32.1020",
      "rawHtsCode": "8443.32.10.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.32.1030",
      "rawHtsCode": "8443.32.10.30",
      "superior": null,
      "indent": "4",
      "description": "Light bar electronic type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.32.1040",
      "rawHtsCode": "8443.32.10.40",
      "superior": null,
      "indent": "4",
      "description": "Ink jet",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.32.1050",
      "rawHtsCode": "8443.32.10.50",
      "superior": null,
      "indent": "4",
      "description": "Thermal transfer",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.32.1060",
      "rawHtsCode": "8443.32.10.60",
      "superior": null,
      "indent": "4",
      "description": "Ionographic",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.32.1070",
      "rawHtsCode": "8443.32.10.70",
      "superior": null,
      "indent": "4",
      "description": "Daisy wheel",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.32.1080",
      "rawHtsCode": "8443.32.10.80",
      "superior": null,
      "indent": "4",
      "description": "Dot matrix",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.32.1090",
      "rawHtsCode": "8443.32.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.32.5000",
      "rawHtsCode": "8443.32.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.39",
      "rawHtsCode": "8443.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.39.1000",
      "rawHtsCode": "8443.39.10.00",
      "superior": null,
      "indent": "5",
      "description": "Operating by reproducing the original image directly onto the copy (direct process)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.39.2000",
      "rawHtsCode": "8443.39.20.00",
      "superior": null,
      "indent": "5",
      "description": "Operating by reproducing the original image via an intermediate onto the copy (indirect process)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8443.39.3000",
      "rawHtsCode": "8443.39.30.00",
      "superior": null,
      "indent": "5",
      "description": "Incorporating an optical system",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8443.39.4000",
      "rawHtsCode": "8443.39.40.00",
      "superior": null,
      "indent": "5",
      "description": "Of the contact type",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8443.39.5000",
      "rawHtsCode": "8443.39.50.00",
      "superior": null,
      "indent": "4",
      "description": "Thermocopying apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8443.39.6000",
      "rawHtsCode": "8443.39.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.39.9000",
      "rawHtsCode": "8443.39.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.91",
      "rawHtsCode": "8443.91",
      "superior": null,
      "indent": "2",
      "description": "Parts and accessories of printing machinery used for printing by means of plates, cylinders and other printing components of heading 8442:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.91.1000",
      "rawHtsCode": "8443.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Machines for uses ancillary to printing",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.91.2000",
      "rawHtsCode": "8443.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "Parts for textile printing machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.91.3000",
      "rawHtsCode": "8443.91.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.99",
      "rawHtsCode": "8443.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.99.1000",
      "rawHtsCode": "8443.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Accessory and auxiliary machines which are intended for attachment to an electrostatic photocopier and which do not operate independently of such photocopier",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8443.99.20",
      "rawHtsCode": "8443.99.20",
      "superior": null,
      "indent": "4",
      "description": "Parts of printer units of subheading 8443.32.10 specified in additional U.S. note 2 to this chapter",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.99.2010",
      "rawHtsCode": "8443.99.20.10",
      "superior": null,
      "indent": "5",
      "description": "Ink cartridges",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.99.2050",
      "rawHtsCode": "8443.99.20.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.99.25",
      "rawHtsCode": "8443.99.25",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.99.2510",
      "rawHtsCode": "8443.99.25.10",
      "superior": null,
      "indent": "5",
      "description": "Ink cartridges",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.99.2550",
      "rawHtsCode": "8443.99.25.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.99.3000",
      "rawHtsCode": "8443.99.30.00",
      "superior": null,
      "indent": "4",
      "description": "Parts of facsimile machines specified in additional U.S. note 3 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.99.3500",
      "rawHtsCode": "8443.99.35.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.99.4000",
      "rawHtsCode": "8443.99.40.00",
      "superior": null,
      "indent": "4",
      "description": "Parts of photocopying apparatus of subheading 8443.39.20 specified in additional U.S. note 4 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.99.4500",
      "rawHtsCode": "8443.99.45.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.99.50",
      "rawHtsCode": "8443.99.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8443.99.5011",
      "rawHtsCode": "8443.99.50.11",
      "superior": null,
      "indent": "5",
      "description": "Ink cartridges",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.99.5015",
      "rawHtsCode": "8443.99.50.15",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8443.99.5050",
      "rawHtsCode": "8443.99.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8444.00.00",
      "rawHtsCode": "8444.00.00",
      "superior": null,
      "indent": "0",
      "description": "Machines for extruding, drawing, texturing or cutting man-made textile materials",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8444.00.0010",
      "rawHtsCode": "8444.00.00.10",
      "superior": null,
      "indent": "1",
      "description": "Texturing machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8444.00.0090",
      "rawHtsCode": "8444.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8445",
      "rawHtsCode": "8445",
      "superior": null,
      "indent": "0",
      "description": "Machines for preparing textile fibers; spinning, doubling or twisting machines and other machinery for producing textile yarns; textile reeling or winding (including weft winding) machines and machines for preparing textile yarns for use on the machines of heading 8446 or 8447:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8445.11.0000",
      "rawHtsCode": "8445.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Carding machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8445.12.0000",
      "rawHtsCode": "8445.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Combing machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8445.13.0000",
      "rawHtsCode": "8445.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Drawing or roving machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8445.19.00",
      "rawHtsCode": "8445.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8445.19.0040",
      "rawHtsCode": "8445.19.00.40",
      "superior": null,
      "indent": "3",
      "description": "Cotton gins",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8445.19.0080",
      "rawHtsCode": "8445.19.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8445.20.0000",
      "rawHtsCode": "8445.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Textile spinning machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8445.30.00",
      "rawHtsCode": "8445.30.00",
      "superior": null,
      "indent": "1",
      "description": "Textile doubling or twisting machines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8445.30.0010",
      "rawHtsCode": "8445.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Textile twisting machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8445.30.0090",
      "rawHtsCode": "8445.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8445.40.0000",
      "rawHtsCode": "8445.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Textile winding (including weft winding) or reeling machines",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8445.90.0000",
      "rawHtsCode": "8445.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8446",
      "rawHtsCode": "8446",
      "superior": null,
      "indent": "0",
      "description": "Weaving machines (looms):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8446.10.00",
      "rawHtsCode": "8446.10.00",
      "superior": null,
      "indent": "1",
      "description": "For weaving fabrics of a width not exceeding <il>30 cm</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8446.10.0010",
      "rawHtsCode": "8446.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Power looms",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8446.10.0090",
      "rawHtsCode": "8446.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8446.21",
      "rawHtsCode": "8446.21",
      "superior": null,
      "indent": "2",
      "description": "Power looms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8446.21.1000",
      "rawHtsCode": "8446.21.10.00",
      "superior": null,
      "indent": "3",
      "description": "For weaving fabrics of a width exceeding 4.9 m",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8446.21.5000",
      "rawHtsCode": "8446.21.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8446.29.0000",
      "rawHtsCode": "8446.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8446.30",
      "rawHtsCode": "8446.30",
      "superior": null,
      "indent": "1",
      "description": "For weaving fabrics of a width exceeding <il>30 cm</il>, shuttleless type:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8446.30.10",
      "rawHtsCode": "8446.30.10",
      "superior": null,
      "indent": "2",
      "description": "Power looms for weaving fabrics of a width exceeding <il>4.9 m</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8446.30.1010",
      "rawHtsCode": "8446.30.10.10",
      "superior": null,
      "indent": "3",
      "description": "Rapier type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8446.30.1020",
      "rawHtsCode": "8446.30.10.20",
      "superior": null,
      "indent": "3",
      "description": "Jet type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8446.30.1030",
      "rawHtsCode": "8446.30.10.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8446.30.50",
      "rawHtsCode": "8446.30.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8446.30.5010",
      "rawHtsCode": "8446.30.50.10",
      "superior": null,
      "indent": "3",
      "description": "Rapier type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8446.30.5020",
      "rawHtsCode": "8446.30.50.20",
      "superior": null,
      "indent": "3",
      "description": "Jet type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8446.30.5030",
      "rawHtsCode": "8446.30.50.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8447",
      "rawHtsCode": "8447",
      "superior": null,
      "indent": "0",
      "description": "Knitting machines, stitch-bonding machines and machines for making gimped yarn, tulle, lace, embroidery, trimmings, braid or net and machines for tufting:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8447.11",
      "rawHtsCode": "8447.11",
      "superior": null,
      "indent": "2",
      "description": "With cylinder diameter not exceeding <il>165 mm:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8447.11.1000",
      "rawHtsCode": "8447.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "For knitting hosiery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8447.11.90",
      "rawHtsCode": "8447.11.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8447.11.9010",
      "rawHtsCode": "8447.11.90.10",
      "superior": null,
      "indent": "4",
      "description": "Open-top cylinder machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8447.11.9020",
      "rawHtsCode": "8447.11.90.20",
      "superior": null,
      "indent": "4",
      "description": "Cylinder and dial machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8447.11.9090",
      "rawHtsCode": "8447.11.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8447.12",
      "rawHtsCode": "8447.12",
      "superior": null,
      "indent": "2",
      "description": "With cylinder diameter exceeding <il>165 mm:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8447.12.1000",
      "rawHtsCode": "8447.12.10.00",
      "superior": null,
      "indent": "3",
      "description": "For knitting hosiery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8447.12.90",
      "rawHtsCode": "8447.12.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8447.12.9010",
      "rawHtsCode": "8447.12.90.10",
      "superior": null,
      "indent": "4",
      "description": "Open-top cylinder machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8447.12.9020",
      "rawHtsCode": "8447.12.90.20",
      "superior": null,
      "indent": "4",
      "description": "Cylinder and dial machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8447.12.9090",
      "rawHtsCode": "8447.12.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8447.20",
      "rawHtsCode": "8447.20",
      "superior": null,
      "indent": "1",
      "description": "Flat knitting machines; stitch-bonding machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8447.20.2000",
      "rawHtsCode": "8447.20.20.00",
      "superior": null,
      "indent": "3",
      "description": "Power driven flat knitting machines over <il>50.8 cm</il> in width",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8447.20.3000",
      "rawHtsCode": "8447.20.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8447.20.4000",
      "rawHtsCode": "8447.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Warp knitting machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8447.20.6000",
      "rawHtsCode": "8447.20.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8447.90",
      "rawHtsCode": "8447.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8447.90.1000",
      "rawHtsCode": "8447.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Braiding and lace-braiding machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8447.90.5000",
      "rawHtsCode": "8447.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Embroidery machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8447.90.9000",
      "rawHtsCode": "8447.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8448",
      "rawHtsCode": "8448",
      "superior": null,
      "indent": "0",
      "description": "Auxiliary machinery for use with machines of heading 8444, 8445, 8446 or 8447 (for example, dobbies, Jacquards, automatic stop motions and shuttle changing mechanisms); parts and accessories suitable for use solely or principally with the machines of this heading or of heading 8444, 8445, 8446 or 8447 (for example, spindles and spindle flyers, card clothing, combs, extruding nipples, shuttles, healds and heald-frames, hosiery needles):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8448.11.0000",
      "rawHtsCode": "8448.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dobbies and Jacquards; card reducing, copying, punching or assembling machines for use therewith",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8448.19.0000",
      "rawHtsCode": "8448.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8448.20",
      "rawHtsCode": "8448.20",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories of machines of heading 8444 or of their auxiliary machinery:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8448.20.1000",
      "rawHtsCode": "8448.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of machines for extruding or drawing man-made textile filaments",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8448.20.50",
      "rawHtsCode": "8448.20.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8448.20.5010",
      "rawHtsCode": "8448.20.50.10",
      "superior": null,
      "indent": "3",
      "description": "Of texturing machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8448.20.5090",
      "rawHtsCode": "8448.20.50.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8448.31.0000",
      "rawHtsCode": "8448.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Card clothing",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8448.32.00",
      "rawHtsCode": "8448.32.00",
      "superior": null,
      "indent": "2",
      "description": "Of machines for preparing textile fibers, other than card clothing",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8448.32.0010",
      "rawHtsCode": "8448.32.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton gins",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8448.32.0090",
      "rawHtsCode": "8448.32.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8448.33.0000",
      "rawHtsCode": "8448.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Spindles, spindle flyers, spinning rings and ring travellers",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8448.39",
      "rawHtsCode": "8448.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8448.39.1000",
      "rawHtsCode": "8448.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Parts of spinning, doubling or twisting machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8448.39.5000",
      "rawHtsCode": "8448.39.50.00",
      "superior": null,
      "indent": "3",
      "description": "Parts of winding or reeling machines",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8448.39.9000",
      "rawHtsCode": "8448.39.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8448.42.0000",
      "rawHtsCode": "8448.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Reeds for looms, healds and heald-frames",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8448.49",
      "rawHtsCode": "8448.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8448.49.1000",
      "rawHtsCode": "8448.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Shuttles",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8448.49.2000",
      "rawHtsCode": "8448.49.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8448.51",
      "rawHtsCode": "8448.51",
      "superior": null,
      "indent": "2",
      "description": "Sinkers, needles and other articles used in forming stitches:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8448.51.1000",
      "rawHtsCode": "8448.51.10.00",
      "superior": null,
      "indent": "4",
      "description": "Latch needles",
      "units": [
        "thousands"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2/1,000 + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8448.51.2000",
      "rawHtsCode": "8448.51.20.00",
      "superior": null,
      "indent": "4",
      "description": "Spring-beard needles",
      "units": [
        "thousands"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.50/1,000 + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8448.51.3000",
      "rawHtsCode": "8448.51.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "thousands"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.15/1,000 + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8448.51.5000",
      "rawHtsCode": "8448.51.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8448.59",
      "rawHtsCode": "8448.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8448.59.1000",
      "rawHtsCode": "8448.59.10.00",
      "superior": null,
      "indent": "3",
      "description": "Parts of knitting machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8448.59.5000",
      "rawHtsCode": "8448.59.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8449.00",
      "rawHtsCode": "8449.00",
      "superior": null,
      "indent": "0",
      "description": "Machinery for the manufacture or finishing of felt or nonwovens in the piece or in shapes, including machinery for making felt hats; blocks for making hats; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8449.00.1000",
      "rawHtsCode": "8449.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Finishing machinery and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8449.00.5000",
      "rawHtsCode": "8449.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8450",
      "rawHtsCode": "8450",
      "superior": null,
      "indent": "0",
      "description": "Household- or laundry-type washing machines, including machines which both wash and dry; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8450.11.00",
      "rawHtsCode": "8450.11.00",
      "superior": null,
      "indent": "2",
      "description": "Fully automatic machines",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8450.11.0010",
      "rawHtsCode": "8450.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Coin operated",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8450.11.0040",
      "rawHtsCode": "8450.11.00.40",
      "superior": null,
      "indent": "4",
      "description": "Top Loading",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8450.11.0080",
      "rawHtsCode": "8450.11.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8450.12.0000",
      "rawHtsCode": "8450.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other machines with built-in centrifugal dryer",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8450.19.0000",
      "rawHtsCode": "8450.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8450.20.00",
      "rawHtsCode": "8450.20.00",
      "superior": null,
      "indent": "1",
      "description": "Machines, each of a dry linen capacity exceeding <il>10 kg</il>",
      "units": [],
      "generalRate": "1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8450.20.0010",
      "rawHtsCode": "8450.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Coin operated",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8450.20.0040",
      "rawHtsCode": "8450.20.00.40",
      "superior": null,
      "indent": "3",
      "description": "Top Loading",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8450.20.0080",
      "rawHtsCode": "8450.20.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8450.90",
      "rawHtsCode": "8450.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8450.90.2000",
      "rawHtsCode": "8450.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Tubs and tub assemblies",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8450.90.4000",
      "rawHtsCode": "8450.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Furniture designed to receive the machines of subheadings 8450.11 through 8450.20, inclusive",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8450.90.6000",
      "rawHtsCode": "8450.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8451",
      "rawHtsCode": "8451",
      "superior": null,
      "indent": "0",
      "description": "Machinery (other than machines of heading 8450) for washing, cleaning, wringing, drying, ironing, pressing (including fusing presses), bleaching, dyeing, dressing, finishing, coating or impregnating textile yarns, fabrics or made up textile articles and machines for applying the paste to the base fabric or other support used in the manufacture of floor coverings such as linoleum; machines for reeling, unreeling, folding, cutting or pinking textile fabrics; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8451.10.0000",
      "rawHtsCode": "8451.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Dry-cleaning machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8451.21.00",
      "rawHtsCode": "8451.21.00",
      "superior": null,
      "indent": "2",
      "description": "Each of a dry linen capacity not exceeding <il>10 kg</il>",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8451.21.0010",
      "rawHtsCode": "8451.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "Coin operated",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8451.21.0090",
      "rawHtsCode": "8451.21.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8451.29.00",
      "rawHtsCode": "8451.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8451.29.0010",
      "rawHtsCode": "8451.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "For drying made up articles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8451.29.0090",
      "rawHtsCode": "8451.29.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8451.30.0000",
      "rawHtsCode": "8451.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ironing machines and presses (including fusing presses)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8451.40.0000",
      "rawHtsCode": "8451.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Washing, bleaching or dyeing machines",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8451.50.0000",
      "rawHtsCode": "8451.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machines for reeling, unreeling, folding, cutting or pinking textile fabrics",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8451.80.0000",
      "rawHtsCode": "8451.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other machinery",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8451.90",
      "rawHtsCode": "8451.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8451.90.3000",
      "rawHtsCode": "8451.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Drying chambers for the drying machines of subheading 8451.21 or 8451.29, and other parts of drying machines incorporating drying chambers",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8451.90.6000",
      "rawHtsCode": "8451.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Furniture designed to receive the drying machines of subheading 8451.21 or 8451.29",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8451.90.90",
      "rawHtsCode": "8451.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8451.90.9010",
      "rawHtsCode": "8451.90.90.10",
      "superior": null,
      "indent": "3",
      "description": "Of machines for washing, dry-cleaning, ironing, pressing or drying made up textile articles or of other household or laundry type machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8451.90.9020",
      "rawHtsCode": "8451.90.90.20",
      "superior": null,
      "indent": "4",
      "description": "Of machines for bleaching, dyeing, washing or cleaning",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8451.90.9090",
      "rawHtsCode": "8451.90.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8452",
      "rawHtsCode": "8452",
      "superior": null,
      "indent": "0",
      "description": "Sewing machines, other than book-sewing machines of heading 8440; furniture, bases and covers specially designed for sewing machines; sewing machine needles; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8452.10.00",
      "rawHtsCode": "8452.10.00",
      "superior": null,
      "indent": "1",
      "description": "Sewing machines of the household type",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8452.10.0010",
      "rawHtsCode": "8452.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Valued not over $20 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8452.10.0090",
      "rawHtsCode": "8452.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8452.21",
      "rawHtsCode": "8452.21",
      "superior": null,
      "indent": "2",
      "description": "Automatic units:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8452.21.1000",
      "rawHtsCode": "8452.21.10.00",
      "superior": null,
      "indent": "3",
      "description": "Specially designed to join footwear soles to uppers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8452.21.9000",
      "rawHtsCode": "8452.21.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8452.29",
      "rawHtsCode": "8452.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8452.29.1000",
      "rawHtsCode": "8452.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Specially designed to join footwear soles to uppers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8452.29.9000",
      "rawHtsCode": "8452.29.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8452.30.0000",
      "rawHtsCode": "8452.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sewing machine needles",
      "units": [
        "thousands"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "42%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8452.90",
      "rawHtsCode": "8452.90",
      "superior": null,
      "indent": "1",
      "description": "Furniture, bases and covers for sewing machines, and parts thereof; other parts of sewing machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8452.90.1000",
      "rawHtsCode": "8452.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Furniture, bases and covers for sewing machines, and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8452.90.20",
      "rawHtsCode": "8452.90.20",
      "superior": null,
      "indent": "2",
      "description": "Other parts of sewing machines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8452.90.2010",
      "rawHtsCode": "8452.90.20.10",
      "superior": null,
      "indent": "3",
      "description": "Of household machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8452.90.2090",
      "rawHtsCode": "8452.90.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8453",
      "rawHtsCode": "8453",
      "superior": null,
      "indent": "0",
      "description": "Machinery for preparing, tanning or working hides, skins or leather or for making or repairing footwear or other articles of hides, skins or leather, other than sewing machines; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8453.10.0000",
      "rawHtsCode": "8453.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for preparing, tanning or working hides, skins or leather",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8453.20.0000",
      "rawHtsCode": "8453.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for making or repairing footwear",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8453.80.0000",
      "rawHtsCode": "8453.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8453.90",
      "rawHtsCode": "8453.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8453.90.1000",
      "rawHtsCode": "8453.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of machinery for making or repairing footwear",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8453.90.5000",
      "rawHtsCode": "8453.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8454",
      "rawHtsCode": "8454",
      "superior": null,
      "indent": "0",
      "description": "Converters, ladles, ingot molds and casting machines, of a kind used in metallurgy or in metal foundries, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8454.10.0000",
      "rawHtsCode": "8454.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Converters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8454.20.00",
      "rawHtsCode": "8454.20.00",
      "superior": null,
      "indent": "1",
      "description": "Ingot molds and ladles",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8454.20.0010",
      "rawHtsCode": "8454.20.00.10",
      "superior": null,
      "indent": "3",
      "description": "For steel ingots",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8454.20.0060",
      "rawHtsCode": "8454.20.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8454.20.0080",
      "rawHtsCode": "8454.20.00.80",
      "superior": null,
      "indent": "2",
      "description": "Ladles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8454.30.00",
      "rawHtsCode": "8454.30.00",
      "superior": null,
      "indent": "1",
      "description": "Casting machines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8454.30.0010",
      "rawHtsCode": "8454.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Die casting machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8454.30.0090",
      "rawHtsCode": "8454.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8454.90.00",
      "rawHtsCode": "8454.90.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8454.90.0030",
      "rawHtsCode": "8454.90.00.30",
      "superior": null,
      "indent": "3",
      "description": "Of die casting machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8454.90.0060",
      "rawHtsCode": "8454.90.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8454.90.0070",
      "rawHtsCode": "8454.90.00.70",
      "superior": null,
      "indent": "2",
      "description": "Of ingot molds",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8454.90.0080",
      "rawHtsCode": "8454.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8455",
      "rawHtsCode": "8455",
      "superior": null,
      "indent": "0",
      "description": "Metal-rolling mills and rolls therefor; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8455.10.0000",
      "rawHtsCode": "8455.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tube mills",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8455.21.0000",
      "rawHtsCode": "8455.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Hot or combination hot and cold",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8455.22.0000",
      "rawHtsCode": "8455.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cold",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8455.30.00",
      "rawHtsCode": "8455.30.00",
      "superior": null,
      "indent": "1",
      "description": "Rolls for rolling mills",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8455.30.0005",
      "rawHtsCode": "8455.30.00.05",
      "superior": null,
      "indent": "3",
      "description": "Not exceeding <il>2,268 kg</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8455.30.0015",
      "rawHtsCode": "8455.30.00.15",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>2,268 kg</il> but not exceeding <il>6,803.9 kg</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8455.30.0025",
      "rawHtsCode": "8455.30.00.25",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>6,803.9 kg</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8455.30.0035",
      "rawHtsCode": "8455.30.00.35",
      "superior": null,
      "indent": "3",
      "description": "Not exceeding <il>2,268 kg</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8455.30.0045",
      "rawHtsCode": "8455.30.00.45",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>2,268 kg</il> but not exceeding <il>6,803.9 kg</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8455.30.0055",
      "rawHtsCode": "8455.30.00.55",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>6,803.9 kg</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8455.30.0065",
      "rawHtsCode": "8455.30.00.65",
      "superior": null,
      "indent": "3",
      "description": "Not exceeding <il>2,268 kg</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8455.30.0075",
      "rawHtsCode": "8455.30.00.75",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>2,268 kg</il> but not exceeding <il>6,803.9 kg</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8455.30.0085",
      "rawHtsCode": "8455.30.00.85",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>6,803.9 kg</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8455.90",
      "rawHtsCode": "8455.90",
      "superior": null,
      "indent": "1",
      "description": "Other parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8455.90.4000",
      "rawHtsCode": "8455.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Castings or weldments, individually weighing less than <il>90 tons</il>, for the machines of heading 8455",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8455.90.8000",
      "rawHtsCode": "8455.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8456",
      "rawHtsCode": "8456",
      "superior": null,
      "indent": "0",
      "description": "Machine tools for working any material by removal of material, by laser or other light or photon beam, ultrasonic, electro-discharge, electro-chemical, electron-beam, ionic-beam or plasma arc processes; water-jet cutting machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.11",
      "rawHtsCode": "8456.11",
      "superior": null,
      "indent": "2",
      "description": "Operated by laser:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.11.10",
      "rawHtsCode": "8456.11.10",
      "superior": null,
      "indent": "3",
      "description": "For working metal",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8456.11.1010",
      "rawHtsCode": "8456.11.10.10",
      "superior": null,
      "indent": "4",
      "description": "Numerically controlled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.11.1050",
      "rawHtsCode": "8456.11.10.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.11.7000",
      "rawHtsCode": "8456.11.70.00",
      "superior": null,
      "indent": "4",
      "description": "Of a kind used solely or principally for the manufacture of printed circuits, printed circuit assemblies, parts of heading 8517 or parts of automatic data processing units",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8456.11.9000",
      "rawHtsCode": "8456.11.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8456.12",
      "rawHtsCode": "8456.12",
      "superior": null,
      "indent": "2",
      "description": "Operated by other light or photon beam processes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.12.10",
      "rawHtsCode": "8456.12.10",
      "superior": null,
      "indent": "3",
      "description": "For working metal",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8456.12.1010",
      "rawHtsCode": "8456.12.10.10",
      "superior": null,
      "indent": "4",
      "description": "Numerically controlled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.12.1050",
      "rawHtsCode": "8456.12.10.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.12.7000",
      "rawHtsCode": "8456.12.70.00",
      "superior": null,
      "indent": "4",
      "description": "Of a kind used solely or principally for the manufacture of printed circuits, printed circuit assemblies, parts of heading 8517 or parts of automatic data processing",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8456.12.9000",
      "rawHtsCode": "8456.12.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8456.20",
      "rawHtsCode": "8456.20",
      "superior": null,
      "indent": "1",
      "description": "Operated by ultrasonic processes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.20.10",
      "rawHtsCode": "8456.20.10",
      "superior": null,
      "indent": "2",
      "description": "For working metal",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8456.20.1010",
      "rawHtsCode": "8456.20.10.10",
      "superior": null,
      "indent": "3",
      "description": "Numerically controlled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.20.1050",
      "rawHtsCode": "8456.20.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.20.5000",
      "rawHtsCode": "8456.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8456.30",
      "rawHtsCode": "8456.30",
      "superior": null,
      "indent": "1",
      "description": "Operated by electro-discharge processes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.30.10",
      "rawHtsCode": "8456.30.10",
      "superior": null,
      "indent": "2",
      "description": "For working metal",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8456.30.1020",
      "rawHtsCode": "8456.30.10.20",
      "superior": null,
      "indent": "3",
      "description": "Traveling wire (wire-cut) type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.30.1050",
      "rawHtsCode": "8456.30.10.50",
      "superior": null,
      "indent": "4",
      "description": "Numerically controlled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.30.1070",
      "rawHtsCode": "8456.30.10.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.30.5000",
      "rawHtsCode": "8456.30.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8456.40",
      "rawHtsCode": "8456.40",
      "superior": null,
      "indent": "1",
      "description": "Operated by plasma arc process:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.40.10",
      "rawHtsCode": "8456.40.10",
      "superior": null,
      "indent": "2",
      "description": "For working metal",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8456.40.1010",
      "rawHtsCode": "8456.40.10.10",
      "superior": null,
      "indent": "3",
      "description": "Numerically controlled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.40.1090",
      "rawHtsCode": "8456.40.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.40.9000",
      "rawHtsCode": "8456.40.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8456.50.0000",
      "rawHtsCode": "8456.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Water-jet cutting machines",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8456.90",
      "rawHtsCode": "8456.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8456.90.3100",
      "rawHtsCode": "8456.90.31.00",
      "superior": null,
      "indent": "2",
      "description": "For working metal",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8456.90.7100",
      "rawHtsCode": "8456.90.71.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8457",
      "rawHtsCode": "8457",
      "superior": null,
      "indent": "0",
      "description": "Machining centers, unit construction machines (single station) and multistation transfer machines, for working metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8457.10.00",
      "rawHtsCode": "8457.10.00",
      "superior": null,
      "indent": "1",
      "description": "Machining centers",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8457.10.0005",
      "rawHtsCode": "8457.10.00.05",
      "superior": null,
      "indent": "2",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8457.10.0015",
      "rawHtsCode": "8457.10.00.15",
      "superior": null,
      "indent": "5",
      "description": "Not over <il>660 mm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8457.10.0025",
      "rawHtsCode": "8457.10.00.25",
      "superior": null,
      "indent": "5",
      "description": "Over <il>660 mm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8457.10.0055",
      "rawHtsCode": "8457.10.00.55",
      "superior": null,
      "indent": "5",
      "description": "Not over <il>685 mm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8457.10.0060",
      "rawHtsCode": "8457.10.00.60",
      "superior": null,
      "indent": "5",
      "description": "Over <il>685 mm</il> but not over <il>1,016 mm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8457.10.0065",
      "rawHtsCode": "8457.10.00.65",
      "superior": null,
      "indent": "5",
      "description": "Over <il>1,016 mm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8457.10.0070",
      "rawHtsCode": "8457.10.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8457.10.0075",
      "rawHtsCode": "8457.10.00.75",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8457.20.00",
      "rawHtsCode": "8457.20.00",
      "superior": null,
      "indent": "1",
      "description": "Unit construction machines (single station)",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8457.20.0010",
      "rawHtsCode": "8457.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8457.20.0090",
      "rawHtsCode": "8457.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8457.30.00",
      "rawHtsCode": "8457.30.00",
      "superior": null,
      "indent": "1",
      "description": "Multistation transfer machines",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8457.30.0010",
      "rawHtsCode": "8457.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8457.30.0090",
      "rawHtsCode": "8457.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458",
      "rawHtsCode": "8458",
      "superior": null,
      "indent": "0",
      "description": "Lathes (including turning centers) for removing metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.11.00",
      "rawHtsCode": "8458.11.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8458.11.0005",
      "rawHtsCode": "8458.11.00.05",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.11.0010",
      "rawHtsCode": "8458.11.00.10",
      "superior": null,
      "indent": "4",
      "description": "Multiple spindle",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.11.0030",
      "rawHtsCode": "8458.11.00.30",
      "superior": null,
      "indent": "5",
      "description": "With a power rating of less than <il>18.65 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.11.0050",
      "rawHtsCode": "8458.11.00.50",
      "superior": null,
      "indent": "5",
      "description": "With a power rating of <il>18.65 kW</il> or greater but not exceeding <il>37.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.11.0090",
      "rawHtsCode": "8458.11.00.90",
      "superior": null,
      "indent": "5",
      "description": "With a power rating exceeding <il>37.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.19.00",
      "rawHtsCode": "8458.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8458.19.0010",
      "rawHtsCode": "8458.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.19.0020",
      "rawHtsCode": "8458.19.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.19.0030",
      "rawHtsCode": "8458.19.00.30",
      "superior": null,
      "indent": "4",
      "description": "Engine or toolroom lathes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.19.0050",
      "rawHtsCode": "8458.19.00.50",
      "superior": null,
      "indent": "5",
      "description": "Single spindle",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.19.0070",
      "rawHtsCode": "8458.19.00.70",
      "superior": null,
      "indent": "5",
      "description": "Multiple spindle",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.19.0090",
      "rawHtsCode": "8458.19.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.91",
      "rawHtsCode": "8458.91",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.91.10",
      "rawHtsCode": "8458.91.10",
      "superior": null,
      "indent": "3",
      "description": "Vertical turret lathes",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8458.91.1040",
      "rawHtsCode": "8458.91.10.40",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.91.1060",
      "rawHtsCode": "8458.91.10.60",
      "superior": null,
      "indent": "5",
      "description": "Multiple spindle",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.91.1080",
      "rawHtsCode": "8458.91.10.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.91.50",
      "rawHtsCode": "8458.91.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8458.91.5040",
      "rawHtsCode": "8458.91.50.40",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.91.5050",
      "rawHtsCode": "8458.91.50.50",
      "superior": null,
      "indent": "5",
      "description": "Multiple spindle",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.91.5070",
      "rawHtsCode": "8458.91.50.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.99",
      "rawHtsCode": "8458.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.99.10",
      "rawHtsCode": "8458.99.10",
      "superior": null,
      "indent": "3",
      "description": "Vertical turret lathes",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8458.99.1010",
      "rawHtsCode": "8458.99.10.10",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.99.1050",
      "rawHtsCode": "8458.99.10.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.99.50",
      "rawHtsCode": "8458.99.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8458.99.5030",
      "rawHtsCode": "8458.99.50.30",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.99.5060",
      "rawHtsCode": "8458.99.50.60",
      "superior": null,
      "indent": "4",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8458.99.5090",
      "rawHtsCode": "8458.99.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459",
      "rawHtsCode": "8459",
      "superior": null,
      "indent": "0",
      "description": "Machine tools (including way-type unit head machines) for drilling, boring, milling, threading or tapping by removing metal, other than lathes (including turning centers) of heading 8458:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.10.0000",
      "rawHtsCode": "8459.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Way-type unit head machines",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.21.00",
      "rawHtsCode": "8459.21.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.21.0040",
      "rawHtsCode": "8459.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.21.0080",
      "rawHtsCode": "8459.21.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.29.00",
      "rawHtsCode": "8459.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.29.0010",
      "rawHtsCode": "8459.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.29.0020",
      "rawHtsCode": "8459.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.29.0040",
      "rawHtsCode": "8459.29.00.40",
      "superior": null,
      "indent": "4",
      "description": "Multiple spindle",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.29.0050",
      "rawHtsCode": "8459.29.00.50",
      "superior": null,
      "indent": "5",
      "description": "Radial",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.29.0070",
      "rawHtsCode": "8459.29.00.70",
      "superior": null,
      "indent": "5",
      "description": "Upright, excluding sensitive (hand- directed), turret and deep-hole machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.29.0090",
      "rawHtsCode": "8459.29.00.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.31.00",
      "rawHtsCode": "8459.31.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.31.0005",
      "rawHtsCode": "8459.31.00.05",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.31.0010",
      "rawHtsCode": "8459.31.00.10",
      "superior": null,
      "indent": "5",
      "description": "Table type, excluding planer type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.31.0040",
      "rawHtsCode": "8459.31.00.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.31.0070",
      "rawHtsCode": "8459.31.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.39.00",
      "rawHtsCode": "8459.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.39.0010",
      "rawHtsCode": "8459.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.39.0020",
      "rawHtsCode": "8459.39.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.39.0040",
      "rawHtsCode": "8459.39.00.40",
      "superior": null,
      "indent": "4",
      "description": "Horizontal spindle",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.39.0050",
      "rawHtsCode": "8459.39.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.41.00",
      "rawHtsCode": "8459.41.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.41.0010",
      "rawHtsCode": "8459.41.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.41.0020",
      "rawHtsCode": "8459.41.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.41.0030",
      "rawHtsCode": "8459.41.00.30",
      "superior": null,
      "indent": "4",
      "description": "Vertical",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.41.0090",
      "rawHtsCode": "8459.41.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.49.00",
      "rawHtsCode": "8459.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.49.0010",
      "rawHtsCode": "8459.49.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.49.0020",
      "rawHtsCode": "8459.49.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.49.0030",
      "rawHtsCode": "8459.49.00.30",
      "superior": null,
      "indent": "4",
      "description": "Vertical",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.49.0090",
      "rawHtsCode": "8459.49.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.51.00",
      "rawHtsCode": "8459.51.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.51.0040",
      "rawHtsCode": "8459.51.00.40",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.51.0080",
      "rawHtsCode": "8459.51.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.59.00",
      "rawHtsCode": "8459.59.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.59.0010",
      "rawHtsCode": "8459.59.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.59.0020",
      "rawHtsCode": "8459.59.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.59.0030",
      "rawHtsCode": "8459.59.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.61.00",
      "rawHtsCode": "8459.61.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.61.0040",
      "rawHtsCode": "8459.61.00.40",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.61.0080",
      "rawHtsCode": "8459.61.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.69.00",
      "rawHtsCode": "8459.69.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.69.0010",
      "rawHtsCode": "8459.69.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.69.0020",
      "rawHtsCode": "8459.69.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.69.0050",
      "rawHtsCode": "8459.69.00.50",
      "superior": null,
      "indent": "4",
      "description": "Profile, duplicating or die sinking",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.69.0070",
      "rawHtsCode": "8459.69.00.70",
      "superior": null,
      "indent": "4",
      "description": "Bed type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.69.0090",
      "rawHtsCode": "8459.69.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.70",
      "rawHtsCode": "8459.70",
      "superior": null,
      "indent": "1",
      "description": "Other threading or tapping machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.70.4000",
      "rawHtsCode": "8459.70.40.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.70.80",
      "rawHtsCode": "8459.70.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8459.70.8040",
      "rawHtsCode": "8459.70.80.40",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.70.8060",
      "rawHtsCode": "8459.70.80.60",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8459.70.8080",
      "rawHtsCode": "8459.70.80.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460",
      "rawHtsCode": "8460",
      "superior": null,
      "indent": "0",
      "description": "Machine tools for deburring, sharpening, grinding, honing, lapping, polishing or otherwise finishing metal or cermets by means of grinding stones, abrasives or polishing products, other than gear cutting, gear grinding or gear finishing machines of heading 8461:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.12.00",
      "rawHtsCode": "8460.12.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8460.12.0040",
      "rawHtsCode": "8460.12.00.40",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.12.0080",
      "rawHtsCode": "8460.12.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.19.01",
      "rawHtsCode": "8460.19.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8460.19.0105",
      "rawHtsCode": "8460.19.01.05",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.19.0110",
      "rawHtsCode": "8460.19.01.10",
      "superior": null,
      "indent": "4",
      "description": "Reciprocating-table type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.19.0150",
      "rawHtsCode": "8460.19.01.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.22.00",
      "rawHtsCode": "8460.22.00",
      "superior": null,
      "indent": "2",
      "description": "Centerless grinding machines, numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8460.22.0040",
      "rawHtsCode": "8460.22.00.40",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.22.0080",
      "rawHtsCode": "8460.22.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.23.00",
      "rawHtsCode": "8460.23.00",
      "superior": null,
      "indent": "2",
      "description": "Other cylindrical grinding machines, numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8460.23.0040",
      "rawHtsCode": "8460.23.00.40",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.23.0055",
      "rawHtsCode": "8460.23.00.55",
      "superior": null,
      "indent": "4",
      "description": "External cylindrical, including universal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.23.0065",
      "rawHtsCode": "8460.23.00.65",
      "superior": null,
      "indent": "4",
      "description": "Internal cylindrical",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.23.0075",
      "rawHtsCode": "8460.23.00.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.24.00",
      "rawHtsCode": "8460.24.00",
      "superior": null,
      "indent": "2",
      "description": "Other, numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8460.24.0005",
      "rawHtsCode": "8460.24.00.05",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.24.0080",
      "rawHtsCode": "8460.24.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.29.01",
      "rawHtsCode": "8460.29.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8460.29.0105",
      "rawHtsCode": "8460.29.01.05",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.29.0110",
      "rawHtsCode": "8460.29.01.10",
      "superior": null,
      "indent": "4",
      "description": "External cylindrical, including universal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.29.0130",
      "rawHtsCode": "8460.29.01.30",
      "superior": null,
      "indent": "4",
      "description": "Internal cylindrical",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.29.0150",
      "rawHtsCode": "8460.29.01.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.31.00",
      "rawHtsCode": "8460.31.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8460.31.0040",
      "rawHtsCode": "8460.31.00.40",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.31.0080",
      "rawHtsCode": "8460.31.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.39.00",
      "rawHtsCode": "8460.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8460.39.0010",
      "rawHtsCode": "8460.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.39.0020",
      "rawHtsCode": "8460.39.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.39.0050",
      "rawHtsCode": "8460.39.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.40",
      "rawHtsCode": "8460.40",
      "superior": null,
      "indent": "1",
      "description": "Honing or lapping machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.40.40",
      "rawHtsCode": "8460.40.40",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8460.40.4010",
      "rawHtsCode": "8460.40.40.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.40.4060",
      "rawHtsCode": "8460.40.40.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.40.80",
      "rawHtsCode": "8460.40.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8460.40.8010",
      "rawHtsCode": "8460.40.80.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.40.8020",
      "rawHtsCode": "8460.40.80.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.40.8080",
      "rawHtsCode": "8460.40.80.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.90",
      "rawHtsCode": "8460.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.90.40",
      "rawHtsCode": "8460.90.40",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8460.90.4010",
      "rawHtsCode": "8460.90.40.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.90.4060",
      "rawHtsCode": "8460.90.40.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.90.80",
      "rawHtsCode": "8460.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8460.90.8010",
      "rawHtsCode": "8460.90.80.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.90.8020",
      "rawHtsCode": "8460.90.80.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8460.90.8080",
      "rawHtsCode": "8460.90.80.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461",
      "rawHtsCode": "8461",
      "superior": null,
      "indent": "0",
      "description": "Machine tools for planing, shaping, slotting, broaching, gear cutting, gear grinding or gear finishing, sawing, cutting-off and other machine tools working by removing metal or cermets, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.20",
      "rawHtsCode": "8461.20",
      "superior": null,
      "indent": "1",
      "description": "Shaping or slotting machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.20.4000",
      "rawHtsCode": "8461.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [
        "No."
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8461.20.80",
      "rawHtsCode": "8461.20.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8461.20.8030",
      "rawHtsCode": "8461.20.80.30",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.20.8070",
      "rawHtsCode": "8461.20.80.70",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.20.8090",
      "rawHtsCode": "8461.20.80.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.30",
      "rawHtsCode": "8461.30",
      "superior": null,
      "indent": "1",
      "description": "Broaching machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.30.40",
      "rawHtsCode": "8461.30.40",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8461.30.4020",
      "rawHtsCode": "8461.30.40.20",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.30.4060",
      "rawHtsCode": "8461.30.40.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.30.80",
      "rawHtsCode": "8461.30.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8461.30.8020",
      "rawHtsCode": "8461.30.80.20",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.30.8040",
      "rawHtsCode": "8461.30.80.40",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.30.8080",
      "rawHtsCode": "8461.30.80.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.40",
      "rawHtsCode": "8461.40",
      "superior": null,
      "indent": "1",
      "description": "Gear cutting, gear grinding or gear finishing machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.40.10",
      "rawHtsCode": "8461.40.10",
      "superior": null,
      "indent": "2",
      "description": "Gear cutting machines",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)2.9% (JP)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8461.40.1010",
      "rawHtsCode": "8461.40.10.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.40.1020",
      "rawHtsCode": "8461.40.10.20",
      "superior": null,
      "indent": "4",
      "description": "For bevel gears",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.40.1030",
      "rawHtsCode": "8461.40.10.30",
      "superior": null,
      "indent": "5",
      "description": "Gear hobbers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.40.1040",
      "rawHtsCode": "8461.40.10.40",
      "superior": null,
      "indent": "5",
      "description": "Gear shapers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.40.1060",
      "rawHtsCode": "8461.40.10.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.40.50",
      "rawHtsCode": "8461.40.50",
      "superior": null,
      "indent": "2",
      "description": "Gear grinding or finishing machines",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8461.40.5020",
      "rawHtsCode": "8461.40.50.20",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.40.5040",
      "rawHtsCode": "8461.40.50.40",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.40.5050",
      "rawHtsCode": "8461.40.50.50",
      "superior": null,
      "indent": "4",
      "description": "For bevel gears",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.40.5070",
      "rawHtsCode": "8461.40.50.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.50",
      "rawHtsCode": "8461.50",
      "superior": null,
      "indent": "1",
      "description": "Sawing or cutting-off machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.50.40",
      "rawHtsCode": "8461.50.40",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8461.50.4010",
      "rawHtsCode": "8461.50.40.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.50.4050",
      "rawHtsCode": "8461.50.40.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.50.80",
      "rawHtsCode": "8461.50.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8461.50.8010",
      "rawHtsCode": "8461.50.80.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.50.8020",
      "rawHtsCode": "8461.50.80.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.50.8090",
      "rawHtsCode": "8461.50.80.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.90",
      "rawHtsCode": "8461.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.90.30",
      "rawHtsCode": "8461.90.30",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8461.90.3020",
      "rawHtsCode": "8461.90.30.20",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.90.3040",
      "rawHtsCode": "8461.90.30.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.90.3060",
      "rawHtsCode": "8461.90.30.60",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.90.3080",
      "rawHtsCode": "8461.90.30.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.90.60",
      "rawHtsCode": "8461.90.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8461.90.6010",
      "rawHtsCode": "8461.90.60.10",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.90.6020",
      "rawHtsCode": "8461.90.60.20",
      "superior": null,
      "indent": "4",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.90.6030",
      "rawHtsCode": "8461.90.60.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.90.6040",
      "rawHtsCode": "8461.90.60.40",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.90.6050",
      "rawHtsCode": "8461.90.60.50",
      "superior": null,
      "indent": "4",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8461.90.6090",
      "rawHtsCode": "8461.90.60.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462",
      "rawHtsCode": "8462",
      "superior": null,
      "indent": "0",
      "description": "Machine tools (including presses) for working metal by forging, hammering or die forging (excluding rolling mills); machine tools (including presses, slitting lines and cut-to-length lines) for working metal by bending, folding, straightening, flattening, shearing, punching, notching or nibbling (excluding drawbenches); presses for working metal or metal carbides, not specified above:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.11.00",
      "rawHtsCode": "8462.11.00",
      "superior": null,
      "indent": "2",
      "description": "Closed die forging machines",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.11.0010",
      "rawHtsCode": "8462.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.11.0030",
      "rawHtsCode": "8462.11.00.30",
      "superior": null,
      "indent": "4",
      "description": "Headers and upsetters, including cold headers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.11.0035",
      "rawHtsCode": "8462.11.00.35",
      "superior": null,
      "indent": "4",
      "description": "Mechanical transfer presses",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.11.0055",
      "rawHtsCode": "8462.11.00.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.19.00",
      "rawHtsCode": "8462.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.19.0010",
      "rawHtsCode": "8462.19.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.19.0030",
      "rawHtsCode": "8462.19.00.30",
      "superior": null,
      "indent": "4",
      "description": "Headers and upsetters, including cold headers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.19.0035",
      "rawHtsCode": "8462.19.00.35",
      "superior": null,
      "indent": "4",
      "description": "Mechanical transfer presses",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.19.0055",
      "rawHtsCode": "8462.19.00.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.22.00",
      "rawHtsCode": "8462.22.00",
      "superior": null,
      "indent": "2",
      "description": "Profile forming machines",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.22.0010",
      "rawHtsCode": "8462.22.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.22.0020",
      "rawHtsCode": "8462.22.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.22.0050",
      "rawHtsCode": "8462.22.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.23.00",
      "rawHtsCode": "8462.23.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled press brakes",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.23.0010",
      "rawHtsCode": "8462.23.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.23.0020",
      "rawHtsCode": "8462.23.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.23.0050",
      "rawHtsCode": "8462.23.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.24.00",
      "rawHtsCode": "8462.24.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled panel benders",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.24.0010",
      "rawHtsCode": "8462.24.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.24.0020",
      "rawHtsCode": "8462.24.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.24.0050",
      "rawHtsCode": "8462.24.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.25.00",
      "rawHtsCode": "8462.25.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled roll forming machines",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.25.0010",
      "rawHtsCode": "8462.25.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.25.0020",
      "rawHtsCode": "8462.25.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.25.0050",
      "rawHtsCode": "8462.25.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.26.00",
      "rawHtsCode": "8462.26.00",
      "superior": null,
      "indent": "2",
      "description": "Other numerically controlled bending, folding, straightening or flattening machines",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.26.0010",
      "rawHtsCode": "8462.26.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.26.0020",
      "rawHtsCode": "8462.26.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.26.0050",
      "rawHtsCode": "8462.26.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.29.00",
      "rawHtsCode": "8462.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.29.0010",
      "rawHtsCode": "8462.29.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.29.0020",
      "rawHtsCode": "8462.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.29.0030",
      "rawHtsCode": "8462.29.00.30",
      "superior": null,
      "indent": "4",
      "description": "Press brakes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.29.0040",
      "rawHtsCode": "8462.29.00.40",
      "superior": null,
      "indent": "4",
      "description": "Bending rolls",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.29.0050",
      "rawHtsCode": "8462.29.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.32",
      "rawHtsCode": "8462.32",
      "superior": null,
      "indent": "2",
      "description": "Slitting lines and cut-to-length lines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.32.10",
      "rawHtsCode": "8462.32.10",
      "superior": null,
      "indent": "3",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.32.1040",
      "rawHtsCode": "8462.32.10.40",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.32.1080",
      "rawHtsCode": "8462.32.10.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.32.50",
      "rawHtsCode": "8462.32.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.32.5010",
      "rawHtsCode": "8462.32.50.10",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.32.5020",
      "rawHtsCode": "8462.32.50.20",
      "superior": null,
      "indent": "4",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.32.5050",
      "rawHtsCode": "8462.32.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.33.00",
      "rawHtsCode": "8462.33.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled shearing machines",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.33.0040",
      "rawHtsCode": "8462.33.00.40",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.33.0080",
      "rawHtsCode": "8462.33.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.39.00",
      "rawHtsCode": "8462.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.39.0010",
      "rawHtsCode": "8462.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.39.0020",
      "rawHtsCode": "8462.39.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.39.0050",
      "rawHtsCode": "8462.39.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.42.00",
      "rawHtsCode": "8462.42.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.42.0040",
      "rawHtsCode": "8462.42.00.40",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.42.0080",
      "rawHtsCode": "8462.42.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.49.00",
      "rawHtsCode": "8462.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.49.0010",
      "rawHtsCode": "8462.49.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.49.0020",
      "rawHtsCode": "8462.49.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.49.0050",
      "rawHtsCode": "8462.49.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.51.00",
      "rawHtsCode": "8462.51.00",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.51.0040",
      "rawHtsCode": "8462.51.00.40",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.51.0080",
      "rawHtsCode": "8462.51.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.59.00",
      "rawHtsCode": "8462.59.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.59.0010",
      "rawHtsCode": "8462.59.00.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.59.0020",
      "rawHtsCode": "8462.59.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.59.0050",
      "rawHtsCode": "8462.59.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.61",
      "rawHtsCode": "8462.61",
      "superior": null,
      "indent": "2",
      "description": "Hydraulic presses:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.61.40",
      "rawHtsCode": "8462.61.40",
      "superior": null,
      "indent": "3",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.61.4030",
      "rawHtsCode": "8462.61.40.30",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.61.4060",
      "rawHtsCode": "8462.61.40.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.61.80",
      "rawHtsCode": "8462.61.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.61.8030",
      "rawHtsCode": "8462.61.80.30",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.61.8090",
      "rawHtsCode": "8462.61.80.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.62",
      "rawHtsCode": "8462.62",
      "superior": null,
      "indent": "2",
      "description": "Mechanical presses:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.62.40",
      "rawHtsCode": "8462.62.40",
      "superior": null,
      "indent": "3",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.62.4010",
      "rawHtsCode": "8462.62.40.10",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.62.4030",
      "rawHtsCode": "8462.62.40.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.62.50",
      "rawHtsCode": "8462.62.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.62.5030",
      "rawHtsCode": "8462.62.50.30",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.62.5090",
      "rawHtsCode": "8462.62.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.63",
      "rawHtsCode": "8462.63",
      "superior": null,
      "indent": "2",
      "description": "Servo-presses:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.63.40",
      "rawHtsCode": "8462.63.40",
      "superior": null,
      "indent": "3",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.63.4010",
      "rawHtsCode": "8462.63.40.10",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.63.4030",
      "rawHtsCode": "8462.63.40.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.63.80",
      "rawHtsCode": "8462.63.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.63.8010",
      "rawHtsCode": "8462.63.80.10",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.63.8020",
      "rawHtsCode": "8462.63.80.20",
      "superior": null,
      "indent": "4",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.63.8060",
      "rawHtsCode": "8462.63.80.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.69",
      "rawHtsCode": "8462.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.69.40",
      "rawHtsCode": "8462.69.40",
      "superior": null,
      "indent": "3",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.69.4010",
      "rawHtsCode": "8462.69.40.10",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.69.4030",
      "rawHtsCode": "8462.69.40.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.69.80",
      "rawHtsCode": "8462.69.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.69.8010",
      "rawHtsCode": "8462.69.80.10",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.69.8020",
      "rawHtsCode": "8462.69.80.20",
      "superior": null,
      "indent": "4",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.69.8060",
      "rawHtsCode": "8462.69.80.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.90",
      "rawHtsCode": "8462.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.90.40",
      "rawHtsCode": "8462.90.40",
      "superior": null,
      "indent": "2",
      "description": "Numerically controlled",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.90.4010",
      "rawHtsCode": "8462.90.40.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.90.4030",
      "rawHtsCode": "8462.90.40.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.90.80",
      "rawHtsCode": "8462.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8462.90.8010",
      "rawHtsCode": "8462.90.80.10",
      "superior": null,
      "indent": "3",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.90.8020",
      "rawHtsCode": "8462.90.80.20",
      "superior": null,
      "indent": "3",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8462.90.8060",
      "rawHtsCode": "8462.90.80.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463",
      "rawHtsCode": "8463",
      "superior": null,
      "indent": "0",
      "description": "Other machine tools for working metal or cermets, without removing material:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463.10.00",
      "rawHtsCode": "8463.10.00",
      "superior": null,
      "indent": "1",
      "description": "Drawbenches for bars, tubes, profiles, wire or the like",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8463.10.0040",
      "rawHtsCode": "8463.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463.10.0060",
      "rawHtsCode": "8463.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463.10.0080",
      "rawHtsCode": "8463.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463.20.00",
      "rawHtsCode": "8463.20.00",
      "superior": null,
      "indent": "1",
      "description": "Thread rolling machines",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8463.20.0040",
      "rawHtsCode": "8463.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463.20.0060",
      "rawHtsCode": "8463.20.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463.20.0080",
      "rawHtsCode": "8463.20.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463.30.00",
      "rawHtsCode": "8463.30.00",
      "superior": null,
      "indent": "1",
      "description": "Machines for working wire",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8463.30.0040",
      "rawHtsCode": "8463.30.00.40",
      "superior": null,
      "indent": "2",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463.30.0060",
      "rawHtsCode": "8463.30.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463.30.0080",
      "rawHtsCode": "8463.30.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463.90.00",
      "rawHtsCode": "8463.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8463.90.0040",
      "rawHtsCode": "8463.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463.90.0060",
      "rawHtsCode": "8463.90.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other, valued under $3,025 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8463.90.0080",
      "rawHtsCode": "8463.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8464",
      "rawHtsCode": "8464",
      "superior": null,
      "indent": "0",
      "description": "Machine tools for working stone, ceramics, concrete, asbestos-cement or like mineral materials or for cold working glass:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8464.10.0100",
      "rawHtsCode": "8464.10.01.00",
      "superior": null,
      "indent": "1",
      "description": "Sawing machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8464.20.01",
      "rawHtsCode": "8464.20.01",
      "superior": null,
      "indent": "1",
      "description": "Grinding or polishing machines",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8464.20.0110",
      "rawHtsCode": "8464.20.01.10",
      "superior": null,
      "indent": "2",
      "description": "Glass-working machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8464.20.0120",
      "rawHtsCode": "8464.20.01.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8464.90.01",
      "rawHtsCode": "8464.90.01",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8464.90.0110",
      "rawHtsCode": "8464.90.01.10",
      "superior": null,
      "indent": "2",
      "description": "Glass-working machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8464.90.0120",
      "rawHtsCode": "8464.90.01.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465",
      "rawHtsCode": "8465",
      "superior": null,
      "indent": "0",
      "description": "Machine tools (including machines for nailing, stapling, glueing or otherwise assembling) for working wood, cork, bone, hard rubber, hard plastics or similar hard materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.10.00",
      "rawHtsCode": "8465.10.00",
      "superior": null,
      "indent": "1",
      "description": "Machines which can carry out different types of machining operations without tool change between such operations",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8465.10.0005",
      "rawHtsCode": "8465.10.00.05",
      "superior": null,
      "indent": "4",
      "description": "Tenoners",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.10.0015",
      "rawHtsCode": "8465.10.00.15",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.10.0025",
      "rawHtsCode": "8465.10.00.25",
      "superior": null,
      "indent": "5",
      "description": "Numerically controlled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.10.0035",
      "rawHtsCode": "8465.10.00.35",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.10.0045",
      "rawHtsCode": "8465.10.00.45",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.10.0050",
      "rawHtsCode": "8465.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.20",
      "rawHtsCode": "8465.20",
      "superior": null,
      "indent": "1",
      "description": "Machining centers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.20.1000",
      "rawHtsCode": "8465.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "For sawing, planing, milling, molding, grinding, sanding, polishing, drilling or mortising",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8465.20.5000",
      "rawHtsCode": "8465.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "For bending or assembling",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8465.20.8000",
      "rawHtsCode": "8465.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8465.91.00",
      "rawHtsCode": "8465.91.00",
      "superior": null,
      "indent": "2",
      "description": "Sawing machines",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8465.91.0002",
      "rawHtsCode": "8465.91.00.02",
      "superior": null,
      "indent": "5",
      "description": "Rip saws",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0006",
      "rawHtsCode": "8465.91.00.06",
      "superior": null,
      "indent": "5",
      "description": "Panel saws",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0012",
      "rawHtsCode": "8465.91.00.12",
      "superior": null,
      "indent": "5",
      "description": "Band saws",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0016",
      "rawHtsCode": "8465.91.00.16",
      "superior": null,
      "indent": "5",
      "description": "Cross-cut and optimizing saws",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0022",
      "rawHtsCode": "8465.91.00.22",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0027",
      "rawHtsCode": "8465.91.00.27",
      "superior": null,
      "indent": "5",
      "description": "Sawmill machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0032",
      "rawHtsCode": "8465.91.00.32",
      "superior": null,
      "indent": "6",
      "description": "Radial arm saws",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0036",
      "rawHtsCode": "8465.91.00.36",
      "superior": null,
      "indent": "6",
      "description": "Tilting arbor table saws",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0041",
      "rawHtsCode": "8465.91.00.41",
      "superior": null,
      "indent": "6",
      "description": "Rip saws",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0047",
      "rawHtsCode": "8465.91.00.47",
      "superior": null,
      "indent": "6",
      "description": "Miter saws",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0049",
      "rawHtsCode": "8465.91.00.49",
      "superior": null,
      "indent": "6",
      "description": "Scroll saws",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0053",
      "rawHtsCode": "8465.91.00.53",
      "superior": null,
      "indent": "7",
      "description": "Valued under $3,000 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0058",
      "rawHtsCode": "8465.91.00.58",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0064",
      "rawHtsCode": "8465.91.00.64",
      "superior": null,
      "indent": "7",
      "description": "Valued under $1,000 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0068",
      "rawHtsCode": "8465.91.00.68",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0074",
      "rawHtsCode": "8465.91.00.74",
      "superior": null,
      "indent": "6",
      "description": "Cross-cut and optimizing saws",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0078",
      "rawHtsCode": "8465.91.00.78",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.91.0091",
      "rawHtsCode": "8465.91.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.00",
      "rawHtsCode": "8465.92.00",
      "superior": null,
      "indent": "2",
      "description": "Planing, milling or molding (by cutting) machines",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8465.92.0003",
      "rawHtsCode": "8465.92.00.03",
      "superior": null,
      "indent": "5",
      "description": "Moulders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0006",
      "rawHtsCode": "8465.92.00.06",
      "superior": null,
      "indent": "5",
      "description": "Routers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0016",
      "rawHtsCode": "8465.92.00.16",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0026",
      "rawHtsCode": "8465.92.00.26",
      "superior": null,
      "indent": "6",
      "description": "Valued under $3,000 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0029",
      "rawHtsCode": "8465.92.00.29",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0031",
      "rawHtsCode": "8465.92.00.31",
      "superior": null,
      "indent": "5",
      "description": "Moulders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0034",
      "rawHtsCode": "8465.92.00.34",
      "superior": null,
      "indent": "6",
      "description": "Valued under $1,000 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0037",
      "rawHtsCode": "8465.92.00.37",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0042",
      "rawHtsCode": "8465.92.00.42",
      "superior": null,
      "indent": "6",
      "description": "Valued under $1,000 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0046",
      "rawHtsCode": "8465.92.00.46",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0051",
      "rawHtsCode": "8465.92.00.51",
      "superior": null,
      "indent": "6",
      "description": "Valued under $3,000 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0055",
      "rawHtsCode": "8465.92.00.55",
      "superior": null,
      "indent": "7",
      "description": "Numerically controlled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0058",
      "rawHtsCode": "8465.92.00.58",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0062",
      "rawHtsCode": "8465.92.00.62",
      "superior": null,
      "indent": "6",
      "description": "Valued under $1,000 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0066",
      "rawHtsCode": "8465.92.00.66",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0072",
      "rawHtsCode": "8465.92.00.72",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.92.0091",
      "rawHtsCode": "8465.92.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.93.00",
      "rawHtsCode": "8465.93.00",
      "superior": null,
      "indent": "2",
      "description": "Grinding, sanding or polishing machines",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8465.93.0004",
      "rawHtsCode": "8465.93.00.04",
      "superior": null,
      "indent": "5",
      "description": "Belt sanders, for a belt width <il>60 cm</il> or wider",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.93.0012",
      "rawHtsCode": "8465.93.00.12",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.93.0030",
      "rawHtsCode": "8465.93.00.30",
      "superior": null,
      "indent": "6",
      "description": "Valued under $1,000 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.93.0045",
      "rawHtsCode": "8465.93.00.45",
      "superior": null,
      "indent": "6",
      "description": "Valued $1,000 or over but under $3,000 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.93.0055",
      "rawHtsCode": "8465.93.00.55",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.93.0065",
      "rawHtsCode": "8465.93.00.65",
      "superior": null,
      "indent": "5",
      "description": "Belt sanders, for a belt width <il>60 cm</il> or wider",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.93.0075",
      "rawHtsCode": "8465.93.00.75",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.93.0091",
      "rawHtsCode": "8465.93.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.94.00",
      "rawHtsCode": "8465.94.00",
      "superior": null,
      "indent": "2",
      "description": "Bending or assembling machines",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8465.94.0005",
      "rawHtsCode": "8465.94.00.05",
      "superior": null,
      "indent": "4",
      "description": "Used or rebuilt",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.94.0015",
      "rawHtsCode": "8465.94.00.15",
      "superior": null,
      "indent": "5",
      "description": "Doweling machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.94.0025",
      "rawHtsCode": "8465.94.00.25",
      "superior": null,
      "indent": "5",
      "description": "Edgebanding machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.94.0035",
      "rawHtsCode": "8465.94.00.35",
      "superior": null,
      "indent": "5",
      "description": "Laminating machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.94.0045",
      "rawHtsCode": "8465.94.00.45",
      "superior": null,
      "indent": "6",
      "description": "Cold",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.94.0055",
      "rawHtsCode": "8465.94.00.55",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.94.0065",
      "rawHtsCode": "8465.94.00.65",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.94.0091",
      "rawHtsCode": "8465.94.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.95.00",
      "rawHtsCode": "8465.95.00",
      "superior": null,
      "indent": "2",
      "description": "Drilling or mortising machines",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8465.95.0005",
      "rawHtsCode": "8465.95.00.05",
      "superior": null,
      "indent": "5",
      "description": "Numerically controlled boring machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.95.0010",
      "rawHtsCode": "8465.95.00.10",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.95.0020",
      "rawHtsCode": "8465.95.00.20",
      "superior": null,
      "indent": "6",
      "description": "Numerically controlled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.95.0035",
      "rawHtsCode": "8465.95.00.35",
      "superior": null,
      "indent": "7",
      "description": "Valued under $3,000 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.95.0045",
      "rawHtsCode": "8465.95.00.45",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.95.0055",
      "rawHtsCode": "8465.95.00.55",
      "superior": null,
      "indent": "6",
      "description": "Valued under $1,000 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.95.0060",
      "rawHtsCode": "8465.95.00.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.95.0065",
      "rawHtsCode": "8465.95.00.65",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.95.0091",
      "rawHtsCode": "8465.95.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.96.00",
      "rawHtsCode": "8465.96.00",
      "superior": null,
      "indent": "2",
      "description": "Splitting, slicing or paring machines",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8465.96.0015",
      "rawHtsCode": "8465.96.00.15",
      "superior": null,
      "indent": "4",
      "description": "Log splitters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.96.0025",
      "rawHtsCode": "8465.96.00.25",
      "superior": null,
      "indent": "4",
      "description": "Chippers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.96.0030",
      "rawHtsCode": "8465.96.00.30",
      "superior": null,
      "indent": "4",
      "description": "Hogs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.96.0040",
      "rawHtsCode": "8465.96.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.96.0051",
      "rawHtsCode": "8465.96.00.51",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.99.02",
      "rawHtsCode": "8465.99.02",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8465.99.0210",
      "rawHtsCode": "8465.99.02.10",
      "superior": null,
      "indent": "4",
      "description": "Debarkers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.99.0220",
      "rawHtsCode": "8465.99.02.20",
      "superior": null,
      "indent": "4",
      "description": "Lathes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.99.0230",
      "rawHtsCode": "8465.99.02.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8465.99.0250",
      "rawHtsCode": "8465.99.02.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466",
      "rawHtsCode": "8466",
      "superior": null,
      "indent": "0",
      "description": "Parts and accessories suitable for use solely or principally with the machines of headings 8456 to 8465, including work or tool holders, self-opening dieheads, dividing heads and other special attachments for the machines; tool holders for any type of tool for working in the hand:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.10.01",
      "rawHtsCode": "8466.10.01",
      "superior": null,
      "indent": "1",
      "description": "Tool holders and self-opening dieheads",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.10.0110",
      "rawHtsCode": "8466.10.01.10",
      "superior": null,
      "indent": "2",
      "description": "Tool holders for forming-type or cutting-type dies",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.10.0130",
      "rawHtsCode": "8466.10.01.30",
      "superior": null,
      "indent": "2",
      "description": "Holders for replaceable cutting or drill inserts",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.10.0175",
      "rawHtsCode": "8466.10.01.75",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.20",
      "rawHtsCode": "8466.20",
      "superior": null,
      "indent": "1",
      "description": "Work holders:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.20.10",
      "rawHtsCode": "8466.20.10",
      "superior": null,
      "indent": "2",
      "description": "For machine tools used in cutting gears",
      "units": [],
      "generalRate": "4.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.20.1010",
      "rawHtsCode": "8466.20.10.10",
      "superior": null,
      "indent": "3",
      "description": "Jigs and fixtures",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.20.1090",
      "rawHtsCode": "8466.20.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.20.80",
      "rawHtsCode": "8466.20.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.20.8020",
      "rawHtsCode": "8466.20.80.20",
      "superior": null,
      "indent": "4",
      "description": "Jigs and fixtures",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.20.8035",
      "rawHtsCode": "8466.20.80.35",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.20.8040",
      "rawHtsCode": "8466.20.80.40",
      "superior": null,
      "indent": "4",
      "description": "Jigs and fixtures",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.20.8065",
      "rawHtsCode": "8466.20.80.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.30",
      "rawHtsCode": "8466.30",
      "superior": null,
      "indent": "1",
      "description": "Dividing heads and other special attachments for machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.30.1000",
      "rawHtsCode": "8466.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Dividing heads",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.30.60",
      "rawHtsCode": "8466.30.60",
      "superior": null,
      "indent": "3",
      "description": "Machines",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.30.6040",
      "rawHtsCode": "8466.30.60.40",
      "superior": null,
      "indent": "4",
      "description": "For woodworking machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.30.6085",
      "rawHtsCode": "8466.30.60.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.30.8000",
      "rawHtsCode": "8466.30.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.91",
      "rawHtsCode": "8466.91",
      "superior": null,
      "indent": "2",
      "description": "For machines of heading 8464:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.91.1000",
      "rawHtsCode": "8466.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cast-iron parts not advanced beyond cleaning, and machined only for the removal of fins, gates, sprues and risers or to permit location in finishing machinery",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8466.91.5000",
      "rawHtsCode": "8466.91.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8466.92",
      "rawHtsCode": "8466.92",
      "superior": null,
      "indent": "2",
      "description": "For machines of heading 8465:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.92.1000",
      "rawHtsCode": "8466.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cast-iron parts not advanced beyond cleaning, and machined only for the removal of fins, gates, sprues and risers or to permit location in finishing machinery",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8466.92.50",
      "rawHtsCode": "8466.92.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.92.5010",
      "rawHtsCode": "8466.92.50.10",
      "superior": null,
      "indent": "4",
      "description": "Of woodworking machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.92.5090",
      "rawHtsCode": "8466.92.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.93",
      "rawHtsCode": "8466.93",
      "superior": null,
      "indent": "2",
      "description": "For machines of headings 8456 to 8461:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.93.1100",
      "rawHtsCode": "8466.93.11.00",
      "superior": null,
      "indent": "3",
      "description": "For water-jet cutting machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8466.93.15",
      "rawHtsCode": "8466.93.15",
      "superior": null,
      "indent": "5",
      "description": "Cast-iron parts not advanced beyond cleaning, and machined only for the removal of fins, gates, sprues and risers or to permit location in finishing machinery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8466.93.1530",
      "rawHtsCode": "8466.93.15.30",
      "superior": null,
      "indent": "6",
      "description": "For metalworking machine tools for cutting, grinding or finishing gears",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.93.1560",
      "rawHtsCode": "8466.93.15.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.93.3000",
      "rawHtsCode": "8466.93.30.00",
      "superior": null,
      "indent": "6",
      "description": "Of metalworking machine tools for cutting gears",
      "units": [
        "No."
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.93.53",
      "rawHtsCode": "8466.93.53",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "4.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.93.5340",
      "rawHtsCode": "8466.93.53.40",
      "superior": null,
      "indent": "7",
      "description": "Of metalworking machine tools for grinding or finishing gears",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.93.5385",
      "rawHtsCode": "8466.93.53.85",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.93.60",
      "rawHtsCode": "8466.93.60",
      "superior": null,
      "indent": "5",
      "description": "Cast-iron parts not advanced beyond cleaning, and machined only for the removal of fins, gates, sprues and risers or to permit location in finishing machinery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8466.93.6030",
      "rawHtsCode": "8466.93.60.30",
      "superior": null,
      "indent": "6",
      "description": "For metalworking machine tools for cutting, grinding or finishing gears",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.93.6060",
      "rawHtsCode": "8466.93.60.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.93.7500",
      "rawHtsCode": "8466.93.75.00",
      "superior": null,
      "indent": "6",
      "description": "Of metalworking machine tools for cutting gears",
      "units": [
        "No."
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.93.9600",
      "rawHtsCode": "8466.93.96.00",
      "superior": null,
      "indent": "7",
      "description": "Parts and accessories of machine tools of subheadings 8456.11, 8456.12, 8456.30, 8457.10, 8458.91, 8459.21, 8459.61 and 8461.50, of a kind used solely or principally for the manufacture of printed circuits, printed circuit assemblies, parts of heading 8517 or parts of automatic data processing machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8466.93.98",
      "rawHtsCode": "8466.93.98",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [],
      "generalRate": "4.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.93.9840",
      "rawHtsCode": "8466.93.98.40",
      "superior": null,
      "indent": "8",
      "description": "Of metalworking machine tools for grinding or finishing gears",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.93.9885",
      "rawHtsCode": "8466.93.98.85",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.94",
      "rawHtsCode": "8466.94",
      "superior": null,
      "indent": "2",
      "description": "For machines of heading 8462 or 8463:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.94.2000",
      "rawHtsCode": "8466.94.20.00",
      "superior": null,
      "indent": "4",
      "description": "Bed, base, table, column, cradle, frame, bolster, crown, slide, rod, tailstock and headstock castings, weldments or fabrications",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8466.94.4000",
      "rawHtsCode": "8466.94.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8466.94.65",
      "rawHtsCode": "8466.94.65",
      "superior": null,
      "indent": "4",
      "description": "Bed, base, table, column, cradle, frame, bolster, crown, slide, rod, tailstock and headstock castings, weldments or fabrications",
      "units": [],
      "generalRate": "4.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.94.6540",
      "rawHtsCode": "8466.94.65.40",
      "superior": null,
      "indent": "5",
      "description": "Parts of mechanical transfer presses",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.94.6585",
      "rawHtsCode": "8466.94.65.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.94.85",
      "rawHtsCode": "8466.94.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "4.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8466.94.8540",
      "rawHtsCode": "8466.94.85.40",
      "superior": null,
      "indent": "5",
      "description": "Parts of mechanical transfer presses",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8466.94.8585",
      "rawHtsCode": "8466.94.85.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467",
      "rawHtsCode": "8467",
      "superior": null,
      "indent": "0",
      "description": "Tools for working in the hand, pneumatic, hydraulic or with self-contained electric or nonelectric motor, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.11",
      "rawHtsCode": "8467.11",
      "superior": null,
      "indent": "2",
      "description": "Rotary type (including combined rotary-percussion):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.11.10",
      "rawHtsCode": "8467.11.10",
      "superior": null,
      "indent": "3",
      "description": "Suitable for metal working",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8467.11.1040",
      "rawHtsCode": "8467.11.10.40",
      "superior": null,
      "indent": "4",
      "description": "Grinders, polishers and sanders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.11.1080",
      "rawHtsCode": "8467.11.10.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.11.50",
      "rawHtsCode": "8467.11.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8467.11.5010",
      "rawHtsCode": "8467.11.50.10",
      "superior": null,
      "indent": "4",
      "description": "Rock drills",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.11.5020",
      "rawHtsCode": "8467.11.50.20",
      "superior": null,
      "indent": "4",
      "description": "Drills, other than rock drills; screwdrivers and nut runners",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.11.5040",
      "rawHtsCode": "8467.11.50.40",
      "superior": null,
      "indent": "4",
      "description": "Wrenches, other than nut runners",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.11.5090",
      "rawHtsCode": "8467.11.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.19",
      "rawHtsCode": "8467.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.19.1000",
      "rawHtsCode": "8467.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Suitable for metal working",
      "units": [
        "No."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8467.19.50",
      "rawHtsCode": "8467.19.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8467.19.5030",
      "rawHtsCode": "8467.19.50.30",
      "superior": null,
      "indent": "4",
      "description": "Pneumatic, hand-held force feed lubricating equipment",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.19.5060",
      "rawHtsCode": "8467.19.50.60",
      "superior": null,
      "indent": "4",
      "description": "Designed for use in construction or mining",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.19.5090",
      "rawHtsCode": "8467.19.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.21.00",
      "rawHtsCode": "8467.21.00",
      "superior": null,
      "indent": "2",
      "description": "Drills of all kinds",
      "units": [],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8467.21.0010",
      "rawHtsCode": "8467.21.00.10",
      "superior": null,
      "indent": "4",
      "description": "Battery powered",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.21.0030",
      "rawHtsCode": "8467.21.00.30",
      "superior": null,
      "indent": "5",
      "description": "With a chuck capacity of less than <il>12.7 mm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.21.0050",
      "rawHtsCode": "8467.21.00.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.21.0070",
      "rawHtsCode": "8467.21.00.70",
      "superior": null,
      "indent": "3",
      "description": "Other, including hammer drills",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.22.00",
      "rawHtsCode": "8467.22.00",
      "superior": null,
      "indent": "2",
      "description": "Saws",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.22.0020",
      "rawHtsCode": "8467.22.00.20",
      "superior": null,
      "indent": "3",
      "description": "Circular",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.22.0040",
      "rawHtsCode": "8467.22.00.40",
      "superior": null,
      "indent": "3",
      "description": "Chain",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.22.0070",
      "rawHtsCode": "8467.22.00.70",
      "superior": null,
      "indent": "3",
      "description": "Reciprocating and jig",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.22.0090",
      "rawHtsCode": "8467.22.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.29.00",
      "rawHtsCode": "8467.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8467.29.0010",
      "rawHtsCode": "8467.29.00.10",
      "superior": null,
      "indent": "4",
      "description": "Angle grinders, sanders and polishers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.29.0015",
      "rawHtsCode": "8467.29.00.15",
      "superior": null,
      "indent": "4",
      "description": "Orbital and straight-line sanders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.29.0025",
      "rawHtsCode": "8467.29.00.25",
      "superior": null,
      "indent": "5",
      "description": "Belt sanders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.29.0035",
      "rawHtsCode": "8467.29.00.35",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.29.0040",
      "rawHtsCode": "8467.29.00.40",
      "superior": null,
      "indent": "3",
      "description": "Screwdrivers, nut-runners and impact wrenches",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.29.0055",
      "rawHtsCode": "8467.29.00.55",
      "superior": null,
      "indent": "3",
      "description": "Routers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.29.0065",
      "rawHtsCode": "8467.29.00.65",
      "superior": null,
      "indent": "3",
      "description": "Planers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.29.0070",
      "rawHtsCode": "8467.29.00.70",
      "superior": null,
      "indent": "3",
      "description": "Grass and weed trimmers/edgers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.29.0080",
      "rawHtsCode": "8467.29.00.80",
      "superior": null,
      "indent": "3",
      "description": "Electropneumatic rotary and percussion hammers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.29.0085",
      "rawHtsCode": "8467.29.00.85",
      "superior": null,
      "indent": "3",
      "description": "Electric scissors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.29.0090",
      "rawHtsCode": "8467.29.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.81.0000",
      "rawHtsCode": "8467.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "Chain saws",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8467.89",
      "rawHtsCode": "8467.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.89.1000",
      "rawHtsCode": "8467.89.10.00",
      "superior": null,
      "indent": "3",
      "description": "Suitable for metal working",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8467.89.50",
      "rawHtsCode": "8467.89.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8467.89.5030",
      "rawHtsCode": "8467.89.50.30",
      "superior": null,
      "indent": "4",
      "description": "Gasoline powered grass and weed trimmers and brushcutters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.89.5060",
      "rawHtsCode": "8467.89.50.60",
      "superior": null,
      "indent": "4",
      "description": "Other, designed for use in agriculture or horticulture",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.89.5090",
      "rawHtsCode": "8467.89.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.91.0100",
      "rawHtsCode": "8467.91.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of chain saws",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8467.92.00",
      "rawHtsCode": "8467.92.00",
      "superior": null,
      "indent": "2",
      "description": "Of pneumatic tools",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8467.92.0050",
      "rawHtsCode": "8467.92.00.50",
      "superior": null,
      "indent": "3",
      "description": "Of pneumatic, hand-held force feed lubricating equipment",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.92.0090",
      "rawHtsCode": "8467.92.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.99.01",
      "rawHtsCode": "8467.99.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8467.99.0130",
      "rawHtsCode": "8467.99.01.30",
      "superior": null,
      "indent": "3",
      "description": "Of gasoline powered grass and weed trimmers and brushcutters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8467.99.0190",
      "rawHtsCode": "8467.99.01.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8468",
      "rawHtsCode": "8468",
      "superior": null,
      "indent": "0",
      "description": "Machinery and apparatus for soldering, brazing or welding, whether or not capable of cutting, other than those of heading 8515; gas-operated surface tempering machines and appliances; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8468.10.0000",
      "rawHtsCode": "8468.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hand-held blow torches",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8468.20",
      "rawHtsCode": "8468.20",
      "superior": null,
      "indent": "1",
      "description": "Other gas-operated machinery and apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8468.20.1000",
      "rawHtsCode": "8468.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Hand-directed or -controlled",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8468.20.5000",
      "rawHtsCode": "8468.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8468.80",
      "rawHtsCode": "8468.80",
      "superior": null,
      "indent": "1",
      "description": "Other machinery and apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8468.80.1000",
      "rawHtsCode": "8468.80.10.00",
      "superior": null,
      "indent": "2",
      "description": "Hand-directed or -controlled",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8468.80.5000",
      "rawHtsCode": "8468.80.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8468.90",
      "rawHtsCode": "8468.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8468.90.1000",
      "rawHtsCode": "8468.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of hand-directed or -controlled machinery and apparatus",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8468.90.5000",
      "rawHtsCode": "8468.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8470",
      "rawHtsCode": "8470",
      "superior": null,
      "indent": "0",
      "description": "Calculating machines and pocket-size data recording, reproducing and displaying machines with calculating functions; accounting machines, postage-franking machines, ticket-issuing machines and similar machines, incorporating a calculating device; cash registers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8470.10.00",
      "rawHtsCode": "8470.10.00",
      "superior": null,
      "indent": "1",
      "description": "Electronic calculators capable of operation without an external source of electric power and pocket-size data recording, reproducing and displaying machines with calculating functions",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8470.10.0040",
      "rawHtsCode": "8470.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Display only",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8470.10.0060",
      "rawHtsCode": "8470.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8470.21.0000",
      "rawHtsCode": "8470.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Incorporating a printing device",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8470.29.0000",
      "rawHtsCode": "8470.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8470.30.0000",
      "rawHtsCode": "8470.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other calculating machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8470.50.00",
      "rawHtsCode": "8470.50.00",
      "superior": null,
      "indent": "1",
      "description": "Cash registers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8470.50.0020",
      "rawHtsCode": "8470.50.00.20",
      "superior": null,
      "indent": "2",
      "description": "Point-of-sale terminals",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8470.50.0060",
      "rawHtsCode": "8470.50.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8470.90.01",
      "rawHtsCode": "8470.90.01",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8470.90.0110",
      "rawHtsCode": "8470.90.01.10",
      "superior": null,
      "indent": "2",
      "description": "Postage-franking machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8470.90.0190",
      "rawHtsCode": "8470.90.01.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471",
      "rawHtsCode": "8471",
      "superior": null,
      "indent": "0",
      "description": "Automatic data processing machines and units thereof; magnetic or optical readers, machines for transcribing data onto data media in coded form and machines for processing such data, not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.30.0100",
      "rawHtsCode": "8471.30.01.00",
      "superior": null,
      "indent": "1",
      "description": "Portable automatic data processing machines, weighing not more than <il>10 kg</il>, consisting of at least a central processing unit, a keyboard and a display",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.41.01",
      "rawHtsCode": "8471.41.01",
      "superior": null,
      "indent": "2",
      "description": "Comprising in the same housing at least a central processing unit and an input and output unit, whether or not combined",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8471.41.0110",
      "rawHtsCode": "8471.41.01.10",
      "superior": null,
      "indent": "3",
      "description": "With cathode-ray tube (CRT)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.41.0150",
      "rawHtsCode": "8471.41.01.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.49.0000",
      "rawHtsCode": "8471.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, entered in the form of systems",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8471.50.01",
      "rawHtsCode": "8471.50.01",
      "superior": null,
      "indent": "1",
      "description": "Processing units other than those of subheading 8471.41 or 8471.49, whether or not containing in the same housing one or two of the following types of unit: storage units, input units, output units",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8471.50.0110",
      "rawHtsCode": "8471.50.01.10",
      "superior": null,
      "indent": "2",
      "description": "With cathode-ray tube (CRT)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.50.0150",
      "rawHtsCode": "8471.50.01.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.60",
      "rawHtsCode": "8471.60",
      "superior": null,
      "indent": "1",
      "description": "Input or output units, whether or not containing storage units in the same housing:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.60.10",
      "rawHtsCode": "8471.60.10",
      "superior": null,
      "indent": "2",
      "description": "Combined input/output units",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8471.60.1010",
      "rawHtsCode": "8471.60.10.10",
      "superior": null,
      "indent": "3",
      "description": "With cathode-ray tube (CRT)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.60.1050",
      "rawHtsCode": "8471.60.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.60.2000",
      "rawHtsCode": "8471.60.20.00",
      "superior": null,
      "indent": "3",
      "description": "Keyboards",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.60.7000",
      "rawHtsCode": "8471.60.70.00",
      "superior": null,
      "indent": "3",
      "description": "Units suitable for physical incorporation into automatic data processing machines or units thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8471.60.8000",
      "rawHtsCode": "8471.60.80.00",
      "superior": null,
      "indent": "3",
      "description": "Optical scanners and magnetic ink recognition devices",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8471.60.90",
      "rawHtsCode": "8471.60.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8471.60.9030",
      "rawHtsCode": "8471.60.90.30",
      "superior": null,
      "indent": "4",
      "description": "Card key and magnetic media entry devices",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.60.9050",
      "rawHtsCode": "8471.60.90.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.70",
      "rawHtsCode": "8471.70",
      "superior": null,
      "indent": "1",
      "description": "Storage units:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.70.1000",
      "rawHtsCode": "8471.70.10.00",
      "superior": null,
      "indent": "4",
      "description": "Without read-write unit assembled therein; read-write units entered separately",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8471.70.2000",
      "rawHtsCode": "8471.70.20.00",
      "superior": null,
      "indent": "4",
      "description": "Units for physical incorporation into automatic data processing machines or units thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8471.70.3000",
      "rawHtsCode": "8471.70.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8471.70.40",
      "rawHtsCode": "8471.70.40",
      "superior": null,
      "indent": "4",
      "description": "Not assembled in cabinets, and without attached external power supply",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8471.70.4035",
      "rawHtsCode": "8471.70.40.35",
      "superior": null,
      "indent": "5",
      "description": "Flexible (floppy) magnetic disk drive units",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.70.4065",
      "rawHtsCode": "8471.70.40.65",
      "superior": null,
      "indent": "5",
      "description": "Hard magnetic disk drive units",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.70.4095",
      "rawHtsCode": "8471.70.40.95",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.70.50",
      "rawHtsCode": "8471.70.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8471.70.5035",
      "rawHtsCode": "8471.70.50.35",
      "superior": null,
      "indent": "5",
      "description": "Flexible (floppy) magnetic disk drive units",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.70.5065",
      "rawHtsCode": "8471.70.50.65",
      "superior": null,
      "indent": "5",
      "description": "Hard magnetic disk drive units",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.70.5095",
      "rawHtsCode": "8471.70.50.95",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.70.6000",
      "rawHtsCode": "8471.70.60.00",
      "superior": null,
      "indent": "3",
      "description": "Not assembled in cabinets for placing on a table, desk, wall, floor or similar place",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8471.70.9000",
      "rawHtsCode": "8471.70.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8471.80",
      "rawHtsCode": "8471.80",
      "superior": null,
      "indent": "1",
      "description": "Other units of automatic data processing machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8471.80.1000",
      "rawHtsCode": "8471.80.10.00",
      "superior": null,
      "indent": "2",
      "description": "Control or adapter units",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8471.80.4000",
      "rawHtsCode": "8471.80.40.00",
      "superior": null,
      "indent": "3",
      "description": "Units suitable for physical incorporation into automatic data processing machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8471.80.9000",
      "rawHtsCode": "8471.80.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8471.90.0000",
      "rawHtsCode": "8471.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8472",
      "rawHtsCode": "8472",
      "superior": null,
      "indent": "0",
      "description": "Other office machines (for example, hectograph or stencil duplicating machines, addressing machines, automatic banknote dispensers, coin-sorting machines, coin-counting or wrapping machines, pencil-sharpening machines, perforating or stapling machines):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8472.10.0000",
      "rawHtsCode": "8472.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Duplicating machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8472.30.0000",
      "rawHtsCode": "8472.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machines for sorting or folding mail or for inserting mail in envelopes or bands, machines for opening, closing or sealing mail and machines for affixing or canceling postage stamps",
      "units": [
        "No."
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8472.90",
      "rawHtsCode": "8472.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8472.90.0500",
      "rawHtsCode": "8472.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "Addressing machines and address plate embossing machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8472.90.1000",
      "rawHtsCode": "8472.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Automatic teller machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8472.90.4000",
      "rawHtsCode": "8472.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Pencil sharpeners",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8472.90.5000",
      "rawHtsCode": "8472.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Typewriters other than printers of heading 8443; word processing machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8472.90.6000",
      "rawHtsCode": "8472.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Numbering, dating and check-writing machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8472.90.90",
      "rawHtsCode": "8472.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8472.90.9040",
      "rawHtsCode": "8472.90.90.40",
      "superior": null,
      "indent": "3",
      "description": "Desktop note counters and note scanners",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8472.90.9060",
      "rawHtsCode": "8472.90.90.60",
      "superior": null,
      "indent": "3",
      "description": "Other currency and coin handling machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8472.90.9080",
      "rawHtsCode": "8472.90.90.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8473",
      "rawHtsCode": "8473",
      "superior": null,
      "indent": "0",
      "description": "Parts and accessories (other than covers, carrying cases and the like) suitable for use solely or principally with machines of headings 8470 to 8472:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8473.21.0000",
      "rawHtsCode": "8473.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of the electronic calculating machines of subheading 8470.10, 8470.21 or 8470.29",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8473.29.0000",
      "rawHtsCode": "8473.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8473.30",
      "rawHtsCode": "8473.30",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories of the machines of heading 8471:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8473.30.11",
      "rawHtsCode": "8473.30.11",
      "superior": null,
      "indent": "3",
      "description": "Printed circuit assemblies",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8473.30.1140",
      "rawHtsCode": "8473.30.11.40",
      "superior": null,
      "indent": "4",
      "description": "Memory modules suitable for use solely or principally with machines of heading 8471",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8473.30.1180",
      "rawHtsCode": "8473.30.11.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8473.30.2000",
      "rawHtsCode": "8473.30.20.00",
      "superior": null,
      "indent": "3",
      "description": "Parts and accessories, including face plates and lock latches, of printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8473.30.5100",
      "rawHtsCode": "8473.30.51.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.  ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8473.30.9100",
      "rawHtsCode": "8473.30.91.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8473.40",
      "rawHtsCode": "8473.40",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories of the machines of heading 8472:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8473.40.1000",
      "rawHtsCode": "8473.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Printed circuit assemblies for automatic teller machines of subheading 8472.90.10",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8473.40.2100",
      "rawHtsCode": "8473.40.21.00",
      "superior": null,
      "indent": "2",
      "description": "Printed circuit assemblies of word processing machines of 8472.90.50",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8473.40.4100",
      "rawHtsCode": "8473.40.41.00",
      "superior": null,
      "indent": "2",
      "description": "Other parts and accessories of the machines of 8472.90.50",
      "units": [
        "kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8473.40.8600",
      "rawHtsCode": "8473.40.86.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8473.50",
      "rawHtsCode": "8473.50",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories equally suitable for use with machines of two or more of the headings 8470 to 8472:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8473.50.3000",
      "rawHtsCode": "8473.50.30.00",
      "superior": null,
      "indent": "2",
      "description": "Printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8473.50.6000",
      "rawHtsCode": "8473.50.60.00",
      "superior": null,
      "indent": "2",
      "description": "Parts and accessories, including face plates and lock latches, of printed circuit assemblies",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8473.50.9000",
      "rawHtsCode": "8473.50.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8474",
      "rawHtsCode": "8474",
      "superior": null,
      "indent": "0",
      "description": "Machinery for sorting, screening, separating, washing, crushing, grinding, mixing or kneading earth, stone, ores or other mineral substances, in solid (including powder or paste) form; machinery for agglomerating, shaping or molding solid mineral fuels, ceramic paste, unhardened cements, plastering materials or other mineral products in powder or paste form; machines for forming foundry molds of sand; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.10.00",
      "rawHtsCode": "8474.10.00",
      "superior": null,
      "indent": "1",
      "description": "Sorting, screening, separating or washing machines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8474.10.0010",
      "rawHtsCode": "8474.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Portable",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.10.0090",
      "rawHtsCode": "8474.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Stationary",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.20.00",
      "rawHtsCode": "8474.20.00",
      "superior": null,
      "indent": "1",
      "description": "Crushing or grinding machines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8474.20.0010",
      "rawHtsCode": "8474.20.00.10",
      "superior": null,
      "indent": "2",
      "description": "Portable",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.20.0050",
      "rawHtsCode": "8474.20.00.50",
      "superior": null,
      "indent": "3",
      "description": "Crushing",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.20.0070",
      "rawHtsCode": "8474.20.00.70",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.31.0000",
      "rawHtsCode": "8474.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Concrete or mortar mixers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8474.32.0000",
      "rawHtsCode": "8474.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Machines for mixing mineral substances with bitumen",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8474.39.0000",
      "rawHtsCode": "8474.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8474.80.00",
      "rawHtsCode": "8474.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other machinery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8474.80.0010",
      "rawHtsCode": "8474.80.00.10",
      "superior": null,
      "indent": "3",
      "description": "Designed for use with ceramic paste, unhardened cements and plastering materials",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.80.0015",
      "rawHtsCode": "8474.80.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.80.0020",
      "rawHtsCode": "8474.80.00.20",
      "superior": null,
      "indent": "2",
      "description": "Machines for forming foundry molds of sand",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.80.0080",
      "rawHtsCode": "8474.80.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.90.00",
      "rawHtsCode": "8474.90.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8474.90.0010",
      "rawHtsCode": "8474.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of sorting, screening, separating or washing machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.90.0020",
      "rawHtsCode": "8474.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Of crushing or grinding machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.90.0050",
      "rawHtsCode": "8474.90.00.50",
      "superior": null,
      "indent": "2",
      "description": "Of mixing or kneading machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8474.90.0090",
      "rawHtsCode": "8474.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8475",
      "rawHtsCode": "8475",
      "superior": null,
      "indent": "0",
      "description": "Machines for assembling electric or electronic lamps, tubes or flashbulbs, in glass envelopes; machines for manufacturing or hot working glass or glassware; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8475.10.0000",
      "rawHtsCode": "8475.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machines for assembling electric or electronic lamps, tubes or flashbulbs, in glass envelopes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8475.21.0000",
      "rawHtsCode": "8475.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Machines for making optical fibers and preforms thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8475.29.0000",
      "rawHtsCode": "8475.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8475.90",
      "rawHtsCode": "8475.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8475.90.1000",
      "rawHtsCode": "8475.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of machines for assembling electric or electronic lamps, tubes or flashbulbs, in glass envelopes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8475.90.9000",
      "rawHtsCode": "8475.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8476",
      "rawHtsCode": "8476",
      "superior": null,
      "indent": "0",
      "description": "Automatic goods-vending machines (for example, postage stamp, cigarette, food or beverage machines), including money-changing machines; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8476.21.0000",
      "rawHtsCode": "8476.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Incorporating heating or refrigerating devices",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8476.29.0000",
      "rawHtsCode": "8476.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8476.81.0000",
      "rawHtsCode": "8476.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "Incorporating heating or refrigerating devices",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8476.89.0000",
      "rawHtsCode": "8476.89.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8476.90.0000",
      "rawHtsCode": "8476.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8477",
      "rawHtsCode": "8477",
      "superior": null,
      "indent": "0",
      "description": "Machinery for working rubber or plastics or for the manufacture of products from these materials, not specified or included elsewhere in this chapter; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.10",
      "rawHtsCode": "8477.10",
      "superior": null,
      "indent": "1",
      "description": "Injection-molding machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.10.3000",
      "rawHtsCode": "8477.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "For manufacturing shoes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8477.10.4000",
      "rawHtsCode": "8477.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "For use in the manufacture of optical media",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8477.10.90",
      "rawHtsCode": "8477.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8477.10.9015",
      "rawHtsCode": "8477.10.90.15",
      "superior": null,
      "indent": "3",
      "description": "Of a type used for processing rubber or other thermosetting materials",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.10.9030",
      "rawHtsCode": "8477.10.90.30",
      "superior": null,
      "indent": "4",
      "description": "With a clamp force less than <il>50 tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.10.9040",
      "rawHtsCode": "8477.10.90.40",
      "superior": null,
      "indent": "4",
      "description": "With a clamp force equal to or greater than <il>50 tons</il> and less than <il>300 tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.10.9050",
      "rawHtsCode": "8477.10.90.50",
      "superior": null,
      "indent": "4",
      "description": "With a clamp force equal to or greater than <il>300 tons</il> and less than <il>750 tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.10.9060",
      "rawHtsCode": "8477.10.90.60",
      "superior": null,
      "indent": "4",
      "description": "With a clamp force equal to or greater than <il>750 tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.20.00",
      "rawHtsCode": "8477.20.00",
      "superior": null,
      "indent": "1",
      "description": "Extruders",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8477.20.0005",
      "rawHtsCode": "8477.20.00.05",
      "superior": null,
      "indent": "3",
      "description": "Single screw",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.20.0015",
      "rawHtsCode": "8477.20.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other, including multiple screw",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.20.0035",
      "rawHtsCode": "8477.20.00.35",
      "superior": null,
      "indent": "4",
      "description": "Less than <il>6.4 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.20.0045",
      "rawHtsCode": "8477.20.00.45",
      "superior": null,
      "indent": "4",
      "description": "<il>6.4 cm</il> or greater",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.20.0055",
      "rawHtsCode": "8477.20.00.55",
      "superior": null,
      "indent": "4",
      "description": "With a screw size less than <il>6.4 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.20.0065",
      "rawHtsCode": "8477.20.00.65",
      "superior": null,
      "indent": "4",
      "description": "With a screw size <il>6.4 cm</il> or greater",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.30.0000",
      "rawHtsCode": "8477.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Blow-molding machines",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8477.40.0100",
      "rawHtsCode": "8477.40.01.00",
      "superior": null,
      "indent": "1",
      "description": "Vacuum-molding machines and other thermoforming machines",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8477.51.00",
      "rawHtsCode": "8477.51.00",
      "superior": null,
      "indent": "2",
      "description": "For molding or retreading pneumatic tires or for molding or otherwise forming inner tubes",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8477.51.0010",
      "rawHtsCode": "8477.51.00.10",
      "superior": null,
      "indent": "3",
      "description": "For molding or retreading pneumatic tires",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.51.0090",
      "rawHtsCode": "8477.51.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.59.0100",
      "rawHtsCode": "8477.59.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8477.80.0100",
      "rawHtsCode": "8477.80.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other machinery",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8477.90",
      "rawHtsCode": "8477.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.90.25",
      "rawHtsCode": "8477.90.25",
      "superior": null,
      "indent": "2",
      "description": "Base, bed, platen, clamp cylinder, ram, and injection castings, weldments and fabrications",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8477.90.2540",
      "rawHtsCode": "8477.90.25.40",
      "superior": null,
      "indent": "3",
      "description": "Of machines of subheading 8477.10.30, 8477.10.40 or 8477.10.90",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.90.2580",
      "rawHtsCode": "8477.90.25.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.90.4501",
      "rawHtsCode": "8477.90.45.01",
      "superior": null,
      "indent": "2",
      "description": "Barrel screws",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8477.90.6500",
      "rawHtsCode": "8477.90.65.00",
      "superior": null,
      "indent": "2",
      "description": "Hydraulic assemblies incorporating more than one of the following: manifold; valves; pump; oil cooler",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8477.90.86",
      "rawHtsCode": "8477.90.86",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8477.90.8601",
      "rawHtsCode": "8477.90.86.01",
      "superior": null,
      "indent": "3",
      "description": "Of injection-molding machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.90.8620",
      "rawHtsCode": "8477.90.86.20",
      "superior": null,
      "indent": "3",
      "description": "Of extruders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.90.8630",
      "rawHtsCode": "8477.90.86.30",
      "superior": null,
      "indent": "3",
      "description": "Of blow-molding machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.90.8640",
      "rawHtsCode": "8477.90.86.40",
      "superior": null,
      "indent": "3",
      "description": "Of machines for forming pneumatic tires",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8477.90.8695",
      "rawHtsCode": "8477.90.86.95",
      "superior": null,
      "indent": "3",
      "description": "Other parts",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8478",
      "rawHtsCode": "8478",
      "superior": null,
      "indent": "0",
      "description": "Machinery for preparing or making up tobacco, not specified or included elsewhere in this chapter; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8478.10.00",
      "rawHtsCode": "8478.10.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8478.10.0010",
      "rawHtsCode": "8478.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Industrial cigarette-making machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8478.10.0090",
      "rawHtsCode": "8478.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8478.90.00",
      "rawHtsCode": "8478.90.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8478.90.0010",
      "rawHtsCode": "8478.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Parts of industrial cigarette-making machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8478.90.0090",
      "rawHtsCode": "8478.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479",
      "rawHtsCode": "8479",
      "superior": null,
      "indent": "0",
      "description": "Machines and mechanical appliances having individual functions, not specified or included elsewhere in this chapter; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.10.00",
      "rawHtsCode": "8479.10.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for public works, building or the like",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8479.10.0040",
      "rawHtsCode": "8479.10.00.40",
      "superior": null,
      "indent": "3",
      "description": "For concrete",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.10.0060",
      "rawHtsCode": "8479.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "For bituminous material",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.10.0080",
      "rawHtsCode": "8479.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.20.0000",
      "rawHtsCode": "8479.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machinery for the extraction or preparation of animal or fixed vegetable or microbial fats or oils",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8479.30.0000",
      "rawHtsCode": "8479.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Presses for the manufacture of particle board or fiber building board of wood or other ligneous materials and other machinery for treating wood or cork",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8479.40.0000",
      "rawHtsCode": "8479.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Rope or cable-making machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8479.50.0000",
      "rawHtsCode": "8479.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Industrial robots, not elsewhere specified or included",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8479.60.0000",
      "rawHtsCode": "8479.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Evaporative air coolers",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8479.71.0000",
      "rawHtsCode": "8479.71.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used in airports",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8479.79.0000",
      "rawHtsCode": "8479.79.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8479.81.0000",
      "rawHtsCode": "8479.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "For treating metal, including electric wire coil-winders",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8479.82.00",
      "rawHtsCode": "8479.82.00",
      "superior": null,
      "indent": "2",
      "description": "Mixing, kneading, crushing, grinding, screening, sifting, homogenizing, emulsifying or stirring machines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8479.82.0040",
      "rawHtsCode": "8479.82.00.40",
      "superior": null,
      "indent": "3",
      "description": "Mixing, kneading or stirring machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.82.0080",
      "rawHtsCode": "8479.82.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.83.0000",
      "rawHtsCode": "8479.83.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cold isostatic presses",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8479.89",
      "rawHtsCode": "8479.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.89.1000",
      "rawHtsCode": "8479.89.10.00",
      "superior": null,
      "indent": "4",
      "description": "Air humidifiers or dehumidifiers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8479.89.2000",
      "rawHtsCode": "8479.89.20.00",
      "superior": null,
      "indent": "4",
      "description": "Floor polishers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8479.89.5500",
      "rawHtsCode": "8479.89.55.00",
      "superior": null,
      "indent": "4",
      "description": "Trash compactors",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8479.89.6500",
      "rawHtsCode": "8479.89.65.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See additional U.S. note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8479.89.7000",
      "rawHtsCode": "8479.89.70.00",
      "superior": null,
      "indent": "3",
      "description": "Carpet sweepers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8479.89.8300",
      "rawHtsCode": "8479.89.83.00",
      "superior": null,
      "indent": "3",
      "description": "Machines for the manufacturing of optical media",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8479.89.9200",
      "rawHtsCode": "8479.89.92.00",
      "superior": null,
      "indent": "3",
      "description": "Automated electronic component placement machines of a kind used solely or principally for the manufacture of printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8479.89.95",
      "rawHtsCode": "8479.89.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.03.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8479.89.9550",
      "rawHtsCode": "8479.89.95.50",
      "superior": null,
      "indent": "4",
      "description": "Oil and gas field wireline and downhole equipment",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.89.9560",
      "rawHtsCode": "8479.89.95.60",
      "superior": null,
      "indent": "4",
      "description": "Automotive maintenance machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.89.9565",
      "rawHtsCode": "8479.89.95.65",
      "superior": null,
      "indent": "4",
      "description": "Hydraulic accumulators",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.89.9585",
      "rawHtsCode": "8479.89.95.85",
      "superior": null,
      "indent": "4",
      "description": "Ultrasonic cleaning devices",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.89.9595",
      "rawHtsCode": "8479.89.95.95",
      "superior": null,
      "indent": "4",
      "description": "Industrial vibrators",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.89.9596",
      "rawHtsCode": "8479.89.95.96",
      "superior": null,
      "indent": "4",
      "description": "Tow behind sweepers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.89.9599",
      "rawHtsCode": "8479.89.95.99",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.90",
      "rawHtsCode": "8479.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.90.4100",
      "rawHtsCode": "8479.90.41.00",
      "superior": null,
      "indent": "2",
      "description": "Of articles of subheading 8479.89.10 or 8479.89.70",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8479.90.4500",
      "rawHtsCode": "8479.90.45.00",
      "superior": null,
      "indent": "3",
      "description": "Frame assemblies incorporating more than one of the following: baseplate; side frames; power screws; front plates",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8479.90.5500",
      "rawHtsCode": "8479.90.55.00",
      "superior": null,
      "indent": "3",
      "description": "Ram assemblies incorporating a ram wrapper and/or ram cover",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8479.90.6500",
      "rawHtsCode": "8479.90.65.00",
      "superior": null,
      "indent": "3",
      "description": "Container assemblies incorporating more than one of the following: container bottom; container wrapper; slide track; container front",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8479.90.7500",
      "rawHtsCode": "8479.90.75.00",
      "superior": null,
      "indent": "3",
      "description": "Cabinets or cases",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8479.90.8500",
      "rawHtsCode": "8479.90.85.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.  "
      ],
      "flags": []
    },
    {
      "htsCode": "8479.90.95",
      "rawHtsCode": "8479.90.95",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8479.90.9530",
      "rawHtsCode": "8479.90.95.30",
      "superior": null,
      "indent": "3",
      "description": "Of industrial robots",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.90.9550",
      "rawHtsCode": "8479.90.95.50",
      "superior": null,
      "indent": "4",
      "description": "Of machinery for public works, building or the like",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.90.9560",
      "rawHtsCode": "8479.90.95.60",
      "superior": null,
      "indent": "4",
      "description": "Of presses for the manufacture of particle board or fiber building board of wood or other ligneous materials and other machinery for treating wood or cork",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.90.9565",
      "rawHtsCode": "8479.90.95.65",
      "superior": null,
      "indent": "4",
      "description": "Of machines or mechanical appliances for treating metal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8479.90.9596",
      "rawHtsCode": "8479.90.95.96",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8480",
      "rawHtsCode": "8480",
      "superior": null,
      "indent": "0",
      "description": "Molding boxes for metal foundry; mold bases; molding patterns; molds for metal (other than ingot molds), metal carbides, glass, mineral materials, rubber or plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.10.0000",
      "rawHtsCode": "8480.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Molding boxes for metal foundry",
      "units": [
        "No."
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8480.20.0000",
      "rawHtsCode": "8480.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mold bases",
      "units": [
        "No."
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8480.30.0000",
      "rawHtsCode": "8480.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Molding patterns",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8480.41.0000",
      "rawHtsCode": "8480.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Injection or compression types",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8480.49.00",
      "rawHtsCode": "8480.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other types",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8480.49.0010",
      "rawHtsCode": "8480.49.00.10",
      "superior": null,
      "indent": "3",
      "description": "Molds for centrifugal casting of ductile iron pipe",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.49.0090",
      "rawHtsCode": "8480.49.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.50.00",
      "rawHtsCode": "8480.50.00",
      "superior": null,
      "indent": "1",
      "description": "Molds for glass",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8480.50.0010",
      "rawHtsCode": "8480.50.00.10",
      "superior": null,
      "indent": "2",
      "description": "Injection or compression types",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.50.0090",
      "rawHtsCode": "8480.50.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other types",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.60.00",
      "rawHtsCode": "8480.60.00",
      "superior": null,
      "indent": "1",
      "description": "Molds for mineral materials",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8480.60.0010",
      "rawHtsCode": "8480.60.00.10",
      "superior": null,
      "indent": "2",
      "description": "Injection or compression types",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.60.0090",
      "rawHtsCode": "8480.60.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other types",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.71",
      "rawHtsCode": "8480.71",
      "superior": null,
      "indent": "2",
      "description": "Injection or compression types:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.71.1000",
      "rawHtsCode": "8480.71.10.00",
      "superior": null,
      "indent": "3",
      "description": "For shoe machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8480.71.4000",
      "rawHtsCode": "8480.71.40.00",
      "superior": null,
      "indent": "3",
      "description": "For the manufacture of semiconductor devices",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8480.71.80",
      "rawHtsCode": "8480.71.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8480.71.8020",
      "rawHtsCode": "8480.71.80.20",
      "superior": null,
      "indent": "4",
      "description": "Temporarily imported for testing, calibration, examination, repair or alteration; returned after being exported for testing, calibration, examination, repair or alteration",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.71.8045",
      "rawHtsCode": "8480.71.80.45",
      "superior": null,
      "indent": "5",
      "description": "Injection type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.71.8060",
      "rawHtsCode": "8480.71.80.60",
      "superior": null,
      "indent": "5",
      "description": "Compression type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.79",
      "rawHtsCode": "8480.79",
      "superior": null,
      "indent": "2",
      "description": "Other types:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.79.1000",
      "rawHtsCode": "8480.79.10.00",
      "superior": null,
      "indent": "3",
      "description": "Molds for shoe machinery",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8480.79.90",
      "rawHtsCode": "8480.79.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8480.79.9010",
      "rawHtsCode": "8480.79.90.10",
      "superior": null,
      "indent": "4",
      "description": "Blow molds",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.79.9020",
      "rawHtsCode": "8480.79.90.20",
      "superior": null,
      "indent": "4",
      "description": "Bladder operated molds",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8480.79.9090",
      "rawHtsCode": "8480.79.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other molds",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481",
      "rawHtsCode": "8481",
      "superior": null,
      "indent": "0",
      "description": "Taps, cocks, valves and similar appliances, for pipes, boiler shells, tanks, vats or the like, including pressure-reducing valves and thermostatically controlled valves; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.10.00",
      "rawHtsCode": "8481.10.00",
      "superior": null,
      "indent": "1",
      "description": "Pressure-reducing valves",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.10.0020",
      "rawHtsCode": "8481.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Hydraulic fluid power type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.10.0040",
      "rawHtsCode": "8481.10.00.40",
      "superior": null,
      "indent": "3",
      "description": "Filter-regulators and filter-regulator-lubricators",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.10.0060",
      "rawHtsCode": "8481.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.10.0090",
      "rawHtsCode": "8481.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.20.00",
      "rawHtsCode": "8481.20.00",
      "superior": null,
      "indent": "1",
      "description": "Valves for oleohydraulic or pneumatic transmissions",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.20.0010",
      "rawHtsCode": "8481.20.00.10",
      "superior": null,
      "indent": "4",
      "description": "Manual type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.20.0020",
      "rawHtsCode": "8481.20.00.20",
      "superior": null,
      "indent": "4",
      "description": "Solenoid type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.20.0030",
      "rawHtsCode": "8481.20.00.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.20.0040",
      "rawHtsCode": "8481.20.00.40",
      "superior": null,
      "indent": "3",
      "description": "Flow control type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.20.0050",
      "rawHtsCode": "8481.20.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.20.0060",
      "rawHtsCode": "8481.20.00.60",
      "superior": null,
      "indent": "4",
      "description": "Solenoid type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.20.0070",
      "rawHtsCode": "8481.20.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.20.0080",
      "rawHtsCode": "8481.20.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.30",
      "rawHtsCode": "8481.30",
      "superior": null,
      "indent": "1",
      "description": "Check (nonreturn) valves:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.30.10",
      "rawHtsCode": "8481.30.10",
      "superior": null,
      "indent": "2",
      "description": "Of copper",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.30.1010",
      "rawHtsCode": "8481.30.10.10",
      "superior": null,
      "indent": "3",
      "description": "Having a pressure rating under <il>850 kPa</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.30.1090",
      "rawHtsCode": "8481.30.10.90",
      "superior": null,
      "indent": "3",
      "description": "Having a pressure rating of <il>850 kPa</il> or over",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.30.20",
      "rawHtsCode": "8481.30.20",
      "superior": null,
      "indent": "2",
      "description": "Of iron or steel",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.30.2010",
      "rawHtsCode": "8481.30.20.10",
      "superior": null,
      "indent": "3",
      "description": "Of iron",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.30.2090",
      "rawHtsCode": "8481.30.20.90",
      "superior": null,
      "indent": "3",
      "description": "Of steel",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.30.9000",
      "rawHtsCode": "8481.30.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.40.0000",
      "rawHtsCode": "8481.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Safety or relief valves",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.80",
      "rawHtsCode": "8481.80",
      "superior": null,
      "indent": "1",
      "description": "Other appliances:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.10",
      "rawHtsCode": "8481.80.10",
      "superior": null,
      "indent": "3",
      "description": "Of copper",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "47%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.80.1020",
      "rawHtsCode": "8481.80.10.20",
      "superior": null,
      "indent": "5",
      "description": "Bath and shower faucets",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.1030",
      "rawHtsCode": "8481.80.10.30",
      "superior": null,
      "indent": "5",
      "description": "Sink and lavatory faucets",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.1040",
      "rawHtsCode": "8481.80.10.40",
      "superior": null,
      "indent": "5",
      "description": "Supply stops",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.1050",
      "rawHtsCode": "8481.80.10.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.1060",
      "rawHtsCode": "8481.80.10.60",
      "superior": null,
      "indent": "5",
      "description": "Gate type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.1070",
      "rawHtsCode": "8481.80.10.70",
      "superior": null,
      "indent": "5",
      "description": "Globe type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.1075",
      "rawHtsCode": "8481.80.10.75",
      "superior": null,
      "indent": "5",
      "description": "Plug type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.1085",
      "rawHtsCode": "8481.80.10.85",
      "superior": null,
      "indent": "5",
      "description": "Ball type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.1090",
      "rawHtsCode": "8481.80.10.90",
      "superior": null,
      "indent": "5",
      "description": "Butterfly type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.1095",
      "rawHtsCode": "8481.80.10.95",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.30",
      "rawHtsCode": "8481.80.30",
      "superior": null,
      "indent": "3",
      "description": "Of iron or steel",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)2.8% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.80.3010",
      "rawHtsCode": "8481.80.30.10",
      "superior": null,
      "indent": "5",
      "description": "Gate type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.3015",
      "rawHtsCode": "8481.80.30.15",
      "superior": null,
      "indent": "5",
      "description": "Globe type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.3020",
      "rawHtsCode": "8481.80.30.20",
      "superior": null,
      "indent": "5",
      "description": "Plug type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.3025",
      "rawHtsCode": "8481.80.30.25",
      "superior": null,
      "indent": "5",
      "description": "Ball type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.3030",
      "rawHtsCode": "8481.80.30.30",
      "superior": null,
      "indent": "5",
      "description": "Butterfly type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.3040",
      "rawHtsCode": "8481.80.30.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.3055",
      "rawHtsCode": "8481.80.30.55",
      "superior": null,
      "indent": "5",
      "description": "Gate type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.3060",
      "rawHtsCode": "8481.80.30.60",
      "superior": null,
      "indent": "5",
      "description": "Globe type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.3065",
      "rawHtsCode": "8481.80.30.65",
      "superior": null,
      "indent": "5",
      "description": "Plug type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.3070",
      "rawHtsCode": "8481.80.30.70",
      "superior": null,
      "indent": "5",
      "description": "Ball type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.3075",
      "rawHtsCode": "8481.80.30.75",
      "superior": null,
      "indent": "5",
      "description": "Butterfly type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.3090",
      "rawHtsCode": "8481.80.30.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.50",
      "rawHtsCode": "8481.80.50",
      "superior": null,
      "indent": "3",
      "description": "Of other materials",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.80.5040",
      "rawHtsCode": "8481.80.50.40",
      "superior": null,
      "indent": "4",
      "description": "Pressure spray can valves",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.5060",
      "rawHtsCode": "8481.80.50.60",
      "superior": null,
      "indent": "4",
      "description": "Bath, shower, sink and lavatory faucets",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.5090",
      "rawHtsCode": "8481.80.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.90",
      "rawHtsCode": "8481.80.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.80.9005",
      "rawHtsCode": "8481.80.90.05",
      "superior": null,
      "indent": "3",
      "description": "Solenoid valves",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.9010",
      "rawHtsCode": "8481.80.90.10",
      "superior": null,
      "indent": "3",
      "description": "Ballcock mechanisms",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.9015",
      "rawHtsCode": "8481.80.90.15",
      "superior": null,
      "indent": "3",
      "description": "Regulator valves, self-operating, for controlling variables such as temperature, pressure, flow and liquid level",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.9020",
      "rawHtsCode": "8481.80.90.20",
      "superior": null,
      "indent": "5",
      "description": "Control valves designed for proportional operation by a signal from a control device",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.9025",
      "rawHtsCode": "8481.80.90.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.9030",
      "rawHtsCode": "8481.80.90.30",
      "superior": null,
      "indent": "4",
      "description": "With hydraulic actuators",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.9035",
      "rawHtsCode": "8481.80.90.35",
      "superior": null,
      "indent": "5",
      "description": "Control valves designed for proportional operation by a signal from a control device",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.9040",
      "rawHtsCode": "8481.80.90.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.9045",
      "rawHtsCode": "8481.80.90.45",
      "superior": null,
      "indent": "4",
      "description": "With thermostatic actuators",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.80.9050",
      "rawHtsCode": "8481.80.90.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.90",
      "rawHtsCode": "8481.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.90.1000",
      "rawHtsCode": "8481.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of copper",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "47%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.90.3000",
      "rawHtsCode": "8481.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of iron or steel",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.90.5000",
      "rawHtsCode": "8481.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Of other materials",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8481.90.90",
      "rawHtsCode": "8481.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8481.90.9020",
      "rawHtsCode": "8481.90.90.20",
      "superior": null,
      "indent": "4",
      "description": "Valve bodies",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8481.90.9040",
      "rawHtsCode": "8481.90.90.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8481.90.9060",
      "rawHtsCode": "8481.90.90.60",
      "superior": null,
      "indent": "4",
      "description": "Valve bodies",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.90.9081",
      "rawHtsCode": "8481.90.90.81",
      "superior": null,
      "indent": "5",
      "description": "Steel forgings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8481.90.9085",
      "rawHtsCode": "8481.90.90.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482",
      "rawHtsCode": "8482",
      "superior": null,
      "indent": "0",
      "description": "Ball or roller bearings, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10",
      "rawHtsCode": "8482.10",
      "superior": null,
      "indent": "1",
      "description": "Ball bearings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.10",
      "rawHtsCode": "8482.10.10",
      "superior": null,
      "indent": "2",
      "description": "Ball bearings with integral shafts",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.10.1040",
      "rawHtsCode": "8482.10.10.40",
      "superior": null,
      "indent": "3",
      "description": "Bearings having an outside diameter not over <il>30 mm</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.1080",
      "rawHtsCode": "8482.10.10.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.50",
      "rawHtsCode": "8482.10.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "9%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "67%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.10.5004",
      "rawHtsCode": "8482.10.50.04",
      "superior": null,
      "indent": "3",
      "description": "Unground bearings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5008",
      "rawHtsCode": "8482.10.50.08",
      "superior": null,
      "indent": "4",
      "description": "Thrust bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5012",
      "rawHtsCode": "8482.10.50.12",
      "superior": null,
      "indent": "4",
      "description": "Linear bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5016",
      "rawHtsCode": "8482.10.50.16",
      "superior": null,
      "indent": "6",
      "description": "Flanged",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5024",
      "rawHtsCode": "8482.10.50.24",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5028",
      "rawHtsCode": "8482.10.50.28",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5032",
      "rawHtsCode": "8482.10.50.32",
      "superior": null,
      "indent": "6",
      "description": "Maximum or full capacity type",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5036",
      "rawHtsCode": "8482.10.50.36",
      "superior": null,
      "indent": "7",
      "description": "Under <il>9 mm</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5044",
      "rawHtsCode": "8482.10.50.44",
      "superior": null,
      "indent": "7",
      "description": "<il>9 mm</il> and over but not over <il>30 mm</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5048",
      "rawHtsCode": "8482.10.50.48",
      "superior": null,
      "indent": "7",
      "description": "Over <il>30 mm</il> but not over <il>52 mm</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5052",
      "rawHtsCode": "8482.10.50.52",
      "superior": null,
      "indent": "7",
      "description": "Over <il>52 mm</il> but not over <il>100 mm.</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5056",
      "rawHtsCode": "8482.10.50.56",
      "superior": null,
      "indent": "7",
      "description": "Over <il>100 mm</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5060",
      "rawHtsCode": "8482.10.50.60",
      "superior": null,
      "indent": "5",
      "description": "Double row ball bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5064",
      "rawHtsCode": "8482.10.50.64",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.10.5068",
      "rawHtsCode": "8482.10.50.68",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.20.00",
      "rawHtsCode": "8482.20.00",
      "superior": null,
      "indent": "1",
      "description": "Tapered roller bearings, including cone and tapered roller assemblies",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "67%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.20.0020",
      "rawHtsCode": "8482.20.00.20",
      "superior": null,
      "indent": "4",
      "description": "Flanged",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.20.0030",
      "rawHtsCode": "8482.20.00.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.20.0040",
      "rawHtsCode": "8482.20.00.40",
      "superior": null,
      "indent": "4",
      "description": "With cups having an outside diameter not exceeding <il>102 mm</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.20.0061",
      "rawHtsCode": "8482.20.00.61",
      "superior": null,
      "indent": "4",
      "description": "With cups having an outside diameter exceeding 102 mm but not exceeding 203 mm",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.20.0064",
      "rawHtsCode": "8482.20.00.64",
      "superior": null,
      "indent": "4",
      "description": "With cups having an outside diameter exceeding 203 mm but not exceeding 305 mm",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.20.0067",
      "rawHtsCode": "8482.20.00.67",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.20.0070",
      "rawHtsCode": "8482.20.00.70",
      "superior": null,
      "indent": "3",
      "description": "For cups having an outside diameter not exceeding <il>102 mm</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.20.0081",
      "rawHtsCode": "8482.20.00.81",
      "superior": null,
      "indent": "3",
      "description": "For cups having an outside diameter exceeding 102 mm but not exceeding 203 mm",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.20.0090",
      "rawHtsCode": "8482.20.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.30.00",
      "rawHtsCode": "8482.30.00",
      "superior": null,
      "indent": "1",
      "description": "Spherical roller bearings",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "67%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.30.0040",
      "rawHtsCode": "8482.30.00.40",
      "superior": null,
      "indent": "2",
      "description": "Single row",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.30.0080",
      "rawHtsCode": "8482.30.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.40.0000",
      "rawHtsCode": "8482.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Needle roller bearings, including cage and needle roller assemblies",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "67%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.50.0000",
      "rawHtsCode": "8482.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other cylindrical roller bearings, including cage and roller assemblies",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "67%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.80.00",
      "rawHtsCode": "8482.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other, including combined ball/roller bearings",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "67%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.80.0020",
      "rawHtsCode": "8482.80.00.20",
      "superior": null,
      "indent": "2",
      "description": "Combined ball and spherical roller bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.80.0040",
      "rawHtsCode": "8482.80.00.40",
      "superior": null,
      "indent": "2",
      "description": "Combined ball and needle roller bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.80.0060",
      "rawHtsCode": "8482.80.00.60",
      "superior": null,
      "indent": "2",
      "description": "Combined ball and other cylindrical roller bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.80.0080",
      "rawHtsCode": "8482.80.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.91.00",
      "rawHtsCode": "8482.91.00",
      "superior": null,
      "indent": "2",
      "description": "Balls, needles and rollers",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.91.0010",
      "rawHtsCode": "8482.91.00.10",
      "superior": null,
      "indent": "4",
      "description": "Of alloy steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.91.0015",
      "rawHtsCode": "8482.91.00.15",
      "superior": null,
      "indent": "4",
      "description": "Of copper or copper alloys as described in statistical note 6 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.91.0030",
      "rawHtsCode": "8482.91.00.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.91.0040",
      "rawHtsCode": "8482.91.00.40",
      "superior": null,
      "indent": "3",
      "description": "Needles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.91.0050",
      "rawHtsCode": "8482.91.00.50",
      "superior": null,
      "indent": "3",
      "description": "Tapered rollers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.91.0070",
      "rawHtsCode": "8482.91.00.70",
      "superior": null,
      "indent": "3",
      "description": "Spherical rollers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.91.0080",
      "rawHtsCode": "8482.91.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other cylindrical rollers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.91.0090",
      "rawHtsCode": "8482.91.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.99",
      "rawHtsCode": "8482.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.99.0500",
      "rawHtsCode": "8482.99.05.00",
      "superior": null,
      "indent": "4",
      "description": "For ball bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "9.9%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "67%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.99.15",
      "rawHtsCode": "8482.99.15",
      "superior": null,
      "indent": "4",
      "description": "For tapered roller bearings",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "67%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.99.1550",
      "rawHtsCode": "8482.99.15.50",
      "superior": null,
      "indent": "6",
      "description": "Having an outside diameter not exceeding 203 mm",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.99.1570",
      "rawHtsCode": "8482.99.15.70",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.99.1580",
      "rawHtsCode": "8482.99.15.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.99.25",
      "rawHtsCode": "8482.99.25",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "67%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.99.2520",
      "rawHtsCode": "8482.99.25.20",
      "superior": null,
      "indent": "5",
      "description": "For spherical roller bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.99.2540",
      "rawHtsCode": "8482.99.25.40",
      "superior": null,
      "indent": "5",
      "description": "For needle bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.99.2560",
      "rawHtsCode": "8482.99.25.60",
      "superior": null,
      "indent": "5",
      "description": "For other cylindrical roller bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.99.2580",
      "rawHtsCode": "8482.99.25.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.99.3500",
      "rawHtsCode": "8482.99.35.00",
      "superior": null,
      "indent": "4",
      "description": "Parts of ball bearings (including parts of ball bearings with integral shafts)",
      "units": [
        "kg"
      ],
      "generalRate": "9.9%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "67%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.99.4500",
      "rawHtsCode": "8482.99.45.00",
      "superior": null,
      "indent": "4",
      "description": "Parts of tapered roller bearings",
      "units": [
        "kg"
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "67%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.99.65",
      "rawHtsCode": "8482.99.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "67%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8482.99.6510",
      "rawHtsCode": "8482.99.65.10",
      "superior": null,
      "indent": "5",
      "description": "For spherical roller bearings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.99.6530",
      "rawHtsCode": "8482.99.65.30",
      "superior": null,
      "indent": "5",
      "description": "For needle bearings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.99.6560",
      "rawHtsCode": "8482.99.65.60",
      "superior": null,
      "indent": "5",
      "description": "For other cylindrical roller bearings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8482.99.6595",
      "rawHtsCode": "8482.99.65.95",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483",
      "rawHtsCode": "8483",
      "superior": null,
      "indent": "0",
      "description": "Transmission shafts (including camshafts and crankshafts) and cranks; bearing housings, housed bearings and plain shaft bearings; gears and gearing; ball or roller screws; gear boxes and other speed changers, including torque converters; flywheels and pulleys, including pulley blocks; clutches and shaft couplings (including universal joints); parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.10",
      "rawHtsCode": "8483.10",
      "superior": null,
      "indent": "1",
      "description": "Transmission shafts (including camshafts and crankshafts) and cranks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.10.10",
      "rawHtsCode": "8483.10.10",
      "superior": null,
      "indent": "3",
      "description": "Designed for use solely or principally with spark-ignition internal combustion piston engines or rotary engines",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.10.1010",
      "rawHtsCode": "8483.10.10.10",
      "superior": null,
      "indent": "5",
      "description": "For motorcycles",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.10.1030",
      "rawHtsCode": "8483.10.10.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.10.1050",
      "rawHtsCode": "8483.10.10.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.10.30",
      "rawHtsCode": "8483.10.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.10.3010",
      "rawHtsCode": "8483.10.30.10",
      "superior": null,
      "indent": "4",
      "description": "For vehicles of chapter 87",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.10.3050",
      "rawHtsCode": "8483.10.30.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.10.5000",
      "rawHtsCode": "8483.10.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other transmission shafts and cranks",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8483.20",
      "rawHtsCode": "8483.20",
      "superior": null,
      "indent": "1",
      "description": "Housed bearings, incorporating ball or roller bearings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.20.40",
      "rawHtsCode": "8483.20.40",
      "superior": null,
      "indent": "2",
      "description": "Flange, take-up, cartridge and hanger units",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.20.4040",
      "rawHtsCode": "8483.20.40.40",
      "superior": null,
      "indent": "3",
      "description": "Incorporating ball bearings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.20.4080",
      "rawHtsCode": "8483.20.40.80",
      "superior": null,
      "indent": "3",
      "description": "Incorporating roller bearings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.20.80",
      "rawHtsCode": "8483.20.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.20.8040",
      "rawHtsCode": "8483.20.80.40",
      "superior": null,
      "indent": "3",
      "description": "Incorporating ball bearings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.20.8080",
      "rawHtsCode": "8483.20.80.80",
      "superior": null,
      "indent": "3",
      "description": "Incorporating roller bearings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.30",
      "rawHtsCode": "8483.30",
      "superior": null,
      "indent": "1",
      "description": "Bearing housings; plain shaft bearings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.30.40",
      "rawHtsCode": "8483.30.40",
      "superior": null,
      "indent": "2",
      "description": "Flange, take-up, cartridge and hanger units",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.30.4040",
      "rawHtsCode": "8483.30.40.40",
      "superior": null,
      "indent": "3",
      "description": "Ball or roller bearing type",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.30.4080",
      "rawHtsCode": "8483.30.40.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.30.80",
      "rawHtsCode": "8483.30.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A+,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.30.8020",
      "rawHtsCode": "8483.30.80.20",
      "superior": null,
      "indent": "4",
      "description": "Ball or roller bearing type",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.30.8040",
      "rawHtsCode": "8483.30.80.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.30.8055",
      "rawHtsCode": "8483.30.80.55",
      "superior": null,
      "indent": "5",
      "description": "Rod end bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.30.8065",
      "rawHtsCode": "8483.30.80.65",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.30.8070",
      "rawHtsCode": "8483.30.80.70",
      "superior": null,
      "indent": "5",
      "description": "Spherical",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.30.8090",
      "rawHtsCode": "8483.30.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.40",
      "rawHtsCode": "8483.40",
      "superior": null,
      "indent": "1",
      "description": "Gears and gearing, other than toothed wheels, chain sprockets and other transmission elements entered separately; ball or roller screws; gear boxes and other speed changers, including torque converters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.40.1000",
      "rawHtsCode": "8483.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Torque converters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8483.40.30",
      "rawHtsCode": "8483.40.30",
      "superior": null,
      "indent": "4",
      "description": "Imported for use with machines for making cellulosic pulp, paper or paperboard",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8483.40.3040",
      "rawHtsCode": "8483.40.30.40",
      "superior": null,
      "indent": "5",
      "description": "Fixed ratio speed changers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.40.3080",
      "rawHtsCode": "8483.40.30.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.40.50",
      "rawHtsCode": "8483.40.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.40.5010",
      "rawHtsCode": "8483.40.50.10",
      "superior": null,
      "indent": "5",
      "description": "Fixed ratio speed changers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.40.5020",
      "rawHtsCode": "8483.40.50.20",
      "superior": null,
      "indent": "5",
      "description": "Gear boxes and speed changers for wind turbines, as described in statistical note 6 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.40.5080",
      "rawHtsCode": "8483.40.50.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.40.7000",
      "rawHtsCode": "8483.40.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other speed changers",
      "units": [
        "No."
      ],
      "generalRate": "25¢ each + 3.9%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.40.8000",
      "rawHtsCode": "8483.40.80.00",
      "superior": null,
      "indent": "2",
      "description": "Ball or roller screws",
      "units": [
        "No."
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.40.9000",
      "rawHtsCode": "8483.40.90.00",
      "superior": null,
      "indent": "2",
      "description": "Gears and gearing, other than toothed wheels, chain sprockets and other transmission elements entered separately",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.50",
      "rawHtsCode": "8483.50",
      "superior": null,
      "indent": "1",
      "description": "Flywheels and pulleys, including pulley blocks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.50.4000",
      "rawHtsCode": "8483.50.40.00",
      "superior": null,
      "indent": "2",
      "description": "Gray-iron awning or tackle pulleys, not over <il>6.4 cm</il> in wheel diameter",
      "units": [
        "No."
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.50.6000",
      "rawHtsCode": "8483.50.60.00",
      "superior": null,
      "indent": "3",
      "description": "Flywheels",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.50.90",
      "rawHtsCode": "8483.50.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.50.9040",
      "rawHtsCode": "8483.50.90.40",
      "superior": null,
      "indent": "4",
      "description": "Grooved pulleys",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8483.50.9080",
      "rawHtsCode": "8483.50.90.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.60",
      "rawHtsCode": "8483.60",
      "superior": null,
      "indent": "1",
      "description": "Clutches and shaft couplings (including universal joints):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.60.40",
      "rawHtsCode": "8483.60.40",
      "superior": null,
      "indent": "2",
      "description": "Clutches and universal joints",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.60.4040",
      "rawHtsCode": "8483.60.40.40",
      "superior": null,
      "indent": "3",
      "description": "Clutches",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.60.4080",
      "rawHtsCode": "8483.60.40.80",
      "superior": null,
      "indent": "3",
      "description": "Universal joints",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.60.8000",
      "rawHtsCode": "8483.60.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A+,AU,B,BH, C,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.90",
      "rawHtsCode": "8483.90",
      "superior": null,
      "indent": "1",
      "description": "Toothed wheels, chain sprockets and other transmission elements presented separately; parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.90.10",
      "rawHtsCode": "8483.90.10",
      "superior": null,
      "indent": "2",
      "description": "Chain sprockets and parts thereof",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.90.1010",
      "rawHtsCode": "8483.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Forged",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.90.1050",
      "rawHtsCode": "8483.90.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.90.2000",
      "rawHtsCode": "8483.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Parts of flange, take-up, cartridge and hanger units",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.90.3000",
      "rawHtsCode": "8483.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A+,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.90.50",
      "rawHtsCode": "8483.90.50",
      "superior": null,
      "indent": "2",
      "description": "Parts of gearing, gear boxes and other speed changers",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.90.5010",
      "rawHtsCode": "8483.90.50.10",
      "superior": null,
      "indent": "3",
      "description": "Forged gear blanks",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.90.5020",
      "rawHtsCode": "8483.90.50.20",
      "superior": null,
      "indent": "3",
      "description": "Parts of gear boxes and speed changers for wind turbines",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.90.5080",
      "rawHtsCode": "8483.90.50.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.90.7000",
      "rawHtsCode": "8483.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "Parts of articles of subheading 8483.20",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.90.80",
      "rawHtsCode": "8483.90.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A+,AU,B,BH, C,CL,CO,D,E, IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8483.90.8010",
      "rawHtsCode": "8483.90.80.10",
      "superior": null,
      "indent": "4",
      "description": "Parts of articles of subheading 8483.60.80",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.90.8040",
      "rawHtsCode": "8483.90.80.40",
      "superior": null,
      "indent": "4",
      "description": "Parts of universal joints",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8483.90.8080",
      "rawHtsCode": "8483.90.80.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8484",
      "rawHtsCode": "8484",
      "superior": null,
      "indent": "0",
      "description": "Gaskets and similar joints of metal sheeting combined with other material or of two or more layers of metal; sets or assortments of gaskets and similar joints, dissimilar in composition, put up in pouches, envelopes or similar packings; mechanical seals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8484.10.0000",
      "rawHtsCode": "8484.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Gaskets and similar joints of metal sheeting combined with other material or of two or more layers of metal",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8484.20.0000",
      "rawHtsCode": "8484.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mechanical seals",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8484.90.0000",
      "rawHtsCode": "8484.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8485",
      "rawHtsCode": "8485",
      "superior": null,
      "indent": "0",
      "description": "Machines for additive manufacturing:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8485.10.0100",
      "rawHtsCode": "8485.10.01.00",
      "superior": null,
      "indent": "1",
      "description": "By metal deposit",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8485.20.0000",
      "rawHtsCode": "8485.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "By plastics or rubber deposit",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8485.30.0000",
      "rawHtsCode": "8485.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "By plaster, cement, ceramics or glass deposit",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8485.80.0000",
      "rawHtsCode": "8485.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8485.90",
      "rawHtsCode": "8485.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8485.90.1000",
      "rawHtsCode": "8485.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "By plastics or rubber deposit",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8485.90.9000",
      "rawHtsCode": "8485.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8486",
      "rawHtsCode": "8486",
      "superior": null,
      "indent": "0",
      "description": "Machines and apparatus of a kind used solely or principally for the manufacture of semiconductor boules or wafers, semiconductor devices, electronic integrated circuits or flat panel displays; machines and apparatus specified in note 11(C) to this chapter; parts and accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8486.10.0000",
      "rawHtsCode": "8486.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machines and apparatus for the manufacture of boules or wafers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.88.70. "
      ],
      "flags": []
    },
    {
      "htsCode": "8486.20.0000",
      "rawHtsCode": "8486.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machines and apparatus for the manufacture of semiconductor devices or of electronic integrated circuits",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.88.70. "
      ],
      "flags": []
    },
    {
      "htsCode": "8486.30.0000",
      "rawHtsCode": "8486.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machines and apparatus for the manufacture of flat panel displays",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8486.40.00",
      "rawHtsCode": "8486.40.00",
      "superior": null,
      "indent": "1",
      "description": "Machines and apparatus specified in note 11(C) to this chapter",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8486.40.0010",
      "rawHtsCode": "8486.40.00.10",
      "superior": null,
      "indent": "2",
      "description": "For the manufacture or repair of masks and reticles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8486.40.0020",
      "rawHtsCode": "8486.40.00.20",
      "superior": null,
      "indent": "2",
      "description": "For assembling semiconductor devices or electronic integrated circuits",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8486.40.0030",
      "rawHtsCode": "8486.40.00.30",
      "superior": null,
      "indent": "2",
      "description": "For lifting, handling, loading or unloading of boules, wafers, semiconductor devices, electronic integrated circuits and flat panel displays",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.70. "
      ],
      "flags": []
    },
    {
      "htsCode": "8486.90.0000",
      "rawHtsCode": "8486.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02.  "
      ],
      "flags": []
    },
    {
      "htsCode": "8487",
      "rawHtsCode": "8487",
      "superior": null,
      "indent": "0",
      "description": "Machinery parts, not containing electrical connectors, insulators, coils, contacts or other electrical features, and not specified or included elsewhere in this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8487.10.00",
      "rawHtsCode": "8487.10.00",
      "superior": null,
      "indent": "1",
      "description": "Ships' or boats' propellers and blades therefor",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8487.10.0040",
      "rawHtsCode": "8487.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Of copper",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8487.10.0080",
      "rawHtsCode": "8487.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8487.90.00",
      "rawHtsCode": "8487.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8487.90.0040",
      "rawHtsCode": "8487.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Oil seals, other than those of chapter 40",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8487.90.0080",
      "rawHtsCode": "8487.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501",
      "rawHtsCode": "8501",
      "superior": null,
      "indent": "0",
      "description": "Electric motors and generators (excluding generating sets):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.10",
      "rawHtsCode": "8501.10",
      "superior": null,
      "indent": "1",
      "description": "Motors of an output not exceeding 37.5 W:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.10.2000",
      "rawHtsCode": "8501.10.20.00",
      "superior": null,
      "indent": "3",
      "description": "Synchronous, valued not over $4 each",
      "units": [
        "No."
      ],
      "generalRate": "6.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.10.40",
      "rawHtsCode": "8501.10.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.10.4020",
      "rawHtsCode": "8501.10.40.20",
      "superior": null,
      "indent": "4",
      "description": "AC",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8501.10.4040",
      "rawHtsCode": "8501.10.40.40",
      "superior": null,
      "indent": "5",
      "description": "Brushless",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.10.4060",
      "rawHtsCode": "8501.10.40.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8501.10.4080",
      "rawHtsCode": "8501.10.40.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.10.60",
      "rawHtsCode": "8501.10.60",
      "superior": null,
      "indent": "2",
      "description": "Of 18.65 W or more but not exceeding 37.5 W",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.10.6020",
      "rawHtsCode": "8501.10.60.20",
      "superior": null,
      "indent": "3",
      "description": "AC",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.10.6040",
      "rawHtsCode": "8501.10.60.40",
      "superior": null,
      "indent": "4",
      "description": "Brushless",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.10.6060",
      "rawHtsCode": "8501.10.60.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.10.6080",
      "rawHtsCode": "8501.10.60.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8501.20",
      "rawHtsCode": "8501.20",
      "superior": null,
      "indent": "1",
      "description": "Universal AC/DC motors of an output exceeding 37.5 W:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.20.2000",
      "rawHtsCode": "8501.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 37.5 W but not exceeding <il>74.6 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.20.4000",
      "rawHtsCode": "8501.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>74.6 W</il> but not exceeding <il>735 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.20.5000",
      "rawHtsCode": "8501.20.50.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>735 W</il> but under <il>746 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.20.6000",
      "rawHtsCode": "8501.20.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.31",
      "rawHtsCode": "8501.31",
      "superior": null,
      "indent": "2",
      "description": "Of an output not exceeding <il>750 W:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.31.2000",
      "rawHtsCode": "8501.31.20.00",
      "superior": null,
      "indent": "4",
      "description": "Exceeding <il>37.5 W</il> but not exceeding <il>74.6 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.31.4000",
      "rawHtsCode": "8501.31.40.00",
      "superior": null,
      "indent": "4",
      "description": "Exceeding <il>74.6 W</il> but not exceeding <il>735 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.31.5000",
      "rawHtsCode": "8501.31.50.00",
      "superior": null,
      "indent": "4",
      "description": "Exceeding <il>735 W</il> but under <il>746 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.31.6000",
      "rawHtsCode": "8501.31.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.31.8100",
      "rawHtsCode": "8501.31.81.00",
      "superior": null,
      "indent": "3",
      "description": "Generators",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.32",
      "rawHtsCode": "8501.32",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>750 W</il> but not exceeding <il>75 kW</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.32.2000",
      "rawHtsCode": "8501.32.20.00",
      "superior": null,
      "indent": "4",
      "description": "Exceeding <il>750 W</il> but not exceeding <il>14.92 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.32.4500",
      "rawHtsCode": "8501.32.45.00",
      "superior": null,
      "indent": "5",
      "description": "Electric motors of a kind used as the primary source of mechanical power for electrically powered vehicles of subheadings 8703.40, 8703.50, 8703.60, 8703.70 or 8703.80",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8501.32.55",
      "rawHtsCode": "8501.32.55",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8501.32.5520",
      "rawHtsCode": "8501.32.55.20",
      "superior": null,
      "indent": "6",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See General Note 6."
      ],
      "flags": []
    },
    {
      "htsCode": "8501.32.5540",
      "rawHtsCode": "8501.32.55.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.32.6100",
      "rawHtsCode": "8501.32.61.00",
      "superior": null,
      "indent": "3",
      "description": "Generators",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.33",
      "rawHtsCode": "8501.33",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>75 kW</il> but not exceeding <il>375 kW</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.33.20",
      "rawHtsCode": "8501.33.20",
      "superior": null,
      "indent": "4",
      "description": "Exceeding <il>75 kW</il> but under <il>149.2 kW</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8501.33.2040",
      "rawHtsCode": "8501.33.20.40",
      "superior": null,
      "indent": "5",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See General Note 6."
      ],
      "flags": []
    },
    {
      "htsCode": "8501.33.2080",
      "rawHtsCode": "8501.33.20.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.33.3000",
      "rawHtsCode": "8501.33.30.00",
      "superior": null,
      "indent": "4",
      "description": "<il>149.2 kW</il> or more but not exceeding <il>150 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.33.40",
      "rawHtsCode": "8501.33.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.33.4040",
      "rawHtsCode": "8501.33.40.40",
      "superior": null,
      "indent": "5",
      "description": "Not exceeding <il>373 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.33.4060",
      "rawHtsCode": "8501.33.40.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.33.6100",
      "rawHtsCode": "8501.33.61.00",
      "superior": null,
      "indent": "3",
      "description": "Generators",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.34",
      "rawHtsCode": "8501.34",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>375 kW</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.34.3000",
      "rawHtsCode": "8501.34.30.00",
      "superior": null,
      "indent": "3",
      "description": "Motors",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.34.6100",
      "rawHtsCode": "8501.34.61.00",
      "superior": null,
      "indent": "3",
      "description": "Generators",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.40",
      "rawHtsCode": "8501.40",
      "superior": null,
      "indent": "1",
      "description": "Other AC motors, single-phase:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.40.20",
      "rawHtsCode": "8501.40.20",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding 37.5 W but not exceeding <il>74.6 W</il>",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.40.2020",
      "rawHtsCode": "8501.40.20.20",
      "superior": null,
      "indent": "3",
      "description": "Gear motors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.40.2040",
      "rawHtsCode": "8501.40.20.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.40.40",
      "rawHtsCode": "8501.40.40",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>74.6 W</il> but not exceeding <il>735 W</il>",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.40.4020",
      "rawHtsCode": "8501.40.40.20",
      "superior": null,
      "indent": "3",
      "description": "Gear motors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8501.40.4040",
      "rawHtsCode": "8501.40.40.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69.                               "
      ],
      "flags": []
    },
    {
      "htsCode": "8501.40.50",
      "rawHtsCode": "8501.40.50",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>735 W</il> but under <il>746 W</il>",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.40.5020",
      "rawHtsCode": "8501.40.50.20",
      "superior": null,
      "indent": "3",
      "description": "Gear motors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.40.5040",
      "rawHtsCode": "8501.40.50.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.40.60",
      "rawHtsCode": "8501.40.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.40.6020",
      "rawHtsCode": "8501.40.60.20",
      "superior": null,
      "indent": "3",
      "description": "Gear motors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.40.6040",
      "rawHtsCode": "8501.40.60.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.51",
      "rawHtsCode": "8501.51",
      "superior": null,
      "indent": "2",
      "description": "Of an output not exceeding <il>750 W:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.51.20",
      "rawHtsCode": "8501.51.20",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>37.5 W</il> but not exceeding <il>74.6 W</il>",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.51.2020",
      "rawHtsCode": "8501.51.20.20",
      "superior": null,
      "indent": "4",
      "description": "Gear motors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.51.2040",
      "rawHtsCode": "8501.51.20.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.51.40",
      "rawHtsCode": "8501.51.40",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>74.6 W</il> but not exceeding <il>735 W</il>",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.51.4020",
      "rawHtsCode": "8501.51.40.20",
      "superior": null,
      "indent": "4",
      "description": "Gear motors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.51.4040",
      "rawHtsCode": "8501.51.40.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8501.51.50",
      "rawHtsCode": "8501.51.50",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>735 W</il> but under <il>746 W</il>",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.51.5020",
      "rawHtsCode": "8501.51.50.20",
      "superior": null,
      "indent": "4",
      "description": "Gear motors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.51.5040",
      "rawHtsCode": "8501.51.50.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.51.60",
      "rawHtsCode": "8501.51.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.51.6020",
      "rawHtsCode": "8501.51.60.20",
      "superior": null,
      "indent": "4",
      "description": "Gear motors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.51.6040",
      "rawHtsCode": "8501.51.60.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.52",
      "rawHtsCode": "8501.52",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>750 W</il> but not exceeding <il>75 kW</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.52.4000",
      "rawHtsCode": "8501.52.40.00",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>750 W</il> but not exceeding <il>14.92 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.52.80",
      "rawHtsCode": "8501.52.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8501.52.8020",
      "rawHtsCode": "8501.52.80.20",
      "superior": null,
      "indent": "4",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See General Note 6."
      ],
      "flags": []
    },
    {
      "htsCode": "8501.52.8040",
      "rawHtsCode": "8501.52.80.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.53",
      "rawHtsCode": "8501.53",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>75 kW</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.53.40",
      "rawHtsCode": "8501.53.40",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>75 kW</il> but under <il>149.2 kW</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8501.53.4040",
      "rawHtsCode": "8501.53.40.40",
      "superior": null,
      "indent": "4",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See General Note 6."
      ],
      "flags": []
    },
    {
      "htsCode": "8501.53.4080",
      "rawHtsCode": "8501.53.40.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.53.6000",
      "rawHtsCode": "8501.53.60.00",
      "superior": null,
      "indent": "3",
      "description": "<il>149.2 kW</il> or more but not exceeding <il>150 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.53.80",
      "rawHtsCode": "8501.53.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.53.8040",
      "rawHtsCode": "8501.53.80.40",
      "superior": null,
      "indent": "4",
      "description": "Not exceeding <il>373 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8501.53.8060",
      "rawHtsCode": "8501.53.80.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.61.0100",
      "rawHtsCode": "8501.61.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of an output not exceeding 75 kVA",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.62.0100",
      "rawHtsCode": "8501.62.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>75 kVA</il> but not exceeding <il>375 kVA</il>",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.63.0100",
      "rawHtsCode": "8501.63.01.00",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>375 kVA</il> but not exceeding <il>750 kVA</il>",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.64.01",
      "rawHtsCode": "8501.64.01",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>750 kVA</il>",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.64.0110",
      "rawHtsCode": "8501.64.01.10",
      "superior": null,
      "indent": "3",
      "description": "For wind-powered generating sets classified within 8502.31.00",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.64.0125",
      "rawHtsCode": "8501.64.01.25",
      "superior": null,
      "indent": "4",
      "description": "Exceeding 750 kVA but not exceeding 10,000 kVA",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.64.0135",
      "rawHtsCode": "8501.64.01.35",
      "superior": null,
      "indent": "4",
      "description": "Exceeding 10,000 kVA but not exceeding 40,000 kVA",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.64.0155",
      "rawHtsCode": "8501.64.01.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.71.0000",
      "rawHtsCode": "8501.71.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of an output not exceeding 50 W",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.72",
      "rawHtsCode": "8501.72",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding 50 W:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.72.1000",
      "rawHtsCode": "8501.72.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of an output not exceeding 750 W",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.72.2000",
      "rawHtsCode": "8501.72.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of an output exceeding 750 W but not exceeding 75 kW",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.72.3000",
      "rawHtsCode": "8501.72.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of an output exceeding 75 kW but not exceeding 375 kW",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.72.9000",
      "rawHtsCode": "8501.72.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.80",
      "rawHtsCode": "8501.80",
      "superior": null,
      "indent": "1",
      "description": "Photovoltaic AC generators:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8501.80.1000",
      "rawHtsCode": "8501.80.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of an output not exceeding 75 kVA",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.80.2000",
      "rawHtsCode": "8501.80.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>75 kVA</il> but not exceeding <il>375 kVA</il>",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.80.3000",
      "rawHtsCode": "8501.80.30.00",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>375 kVA</il> but not exceeding <il>750 kVA</il>",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8501.80.9000",
      "rawHtsCode": "8501.80.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8502",
      "rawHtsCode": "8502",
      "superior": null,
      "indent": "0",
      "description": "Electric generating sets and rotary converters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8502.11.0000",
      "rawHtsCode": "8502.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of an output not exceeding <il>75 kVA</il>",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8502.12.0000",
      "rawHtsCode": "8502.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>75 kVA</il> but not exceeding <il>375 kVA</il>",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8502.13.00",
      "rawHtsCode": "8502.13.00",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>375 kVA</il>",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8502.13.0020",
      "rawHtsCode": "8502.13.00.20",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>375 kVA</il> but not exceeding <il>1,000 kVA</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8502.13.0040",
      "rawHtsCode": "8502.13.00.40",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>1,000 kVA</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8502.20.00",
      "rawHtsCode": "8502.20.00",
      "superior": null,
      "indent": "1",
      "description": "Generating sets with spark-ignition internal combustion piston engines",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8502.20.0030",
      "rawHtsCode": "8502.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Of an output not exceeding <il>1.875 kVA</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8502.20.0060",
      "rawHtsCode": "8502.20.00.60",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>1.875 kVA</il> but not exceeding <il>6.25 kVA</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8502.20.0070",
      "rawHtsCode": "8502.20.00.70",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>6.25 kVA</il> but not exceeding <il>75 kVA</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8502.20.0085",
      "rawHtsCode": "8502.20.00.85",
      "superior": null,
      "indent": "2",
      "description": "Of an output exceeding <il>75 kVA</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8502.31.0000",
      "rawHtsCode": "8502.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Wind-powered",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8502.39.00",
      "rawHtsCode": "8502.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8502.39.0040",
      "rawHtsCode": "8502.39.00.40",
      "superior": null,
      "indent": "3",
      "description": "Powered by steam turbine",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8502.39.0080",
      "rawHtsCode": "8502.39.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8502.40.0000",
      "rawHtsCode": "8502.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Electric rotary converters",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8503.00",
      "rawHtsCode": "8503.00",
      "superior": null,
      "indent": "0",
      "description": "Parts suitable for use solely or principally with the machines of heading 8501 or 8502:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8503.00.2000",
      "rawHtsCode": "8503.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Commutators",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8503.00.3500",
      "rawHtsCode": "8503.00.35.00",
      "superior": null,
      "indent": "2",
      "description": "For motors of under 18.65 W",
      "units": [
        "No."
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8503.00.4500",
      "rawHtsCode": "8503.00.45.00",
      "superior": null,
      "indent": "2",
      "description": "For generators suitable for use on aircraft",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8503.00.6500",
      "rawHtsCode": "8503.00.65.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8503.00.7500",
      "rawHtsCode": "8503.00.75.00",
      "superior": null,
      "indent": "2",
      "description": "For motors of under 18.65 W",
      "units": [
        "No."
      ],
      "generalRate": "6.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8503.00.9000",
      "rawHtsCode": "8503.00.90.00",
      "superior": null,
      "indent": "2",
      "description": "For generators suitable for use on aircraft",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8503.00.95",
      "rawHtsCode": "8503.00.95",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8503.00.9520",
      "rawHtsCode": "8503.00.95.20",
      "superior": null,
      "indent": "3",
      "description": "Parts of motors",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8503.00.9546",
      "rawHtsCode": "8503.00.95.46",
      "superior": null,
      "indent": "4",
      "description": "For AC generators (alternators) classified in statistical reporting number 8501.64.0110",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8503.00.9550",
      "rawHtsCode": "8503.00.95.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8503.00.9570",
      "rawHtsCode": "8503.00.95.70",
      "superior": null,
      "indent": "4",
      "description": "Parts of wind-powered generating sets classified in subheading 8502.31.00",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8503.00.9580",
      "rawHtsCode": "8503.00.95.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504",
      "rawHtsCode": "8504",
      "superior": null,
      "indent": "0",
      "description": "Electrical transformers, static converters (for example, rectifiers) and inductors; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.10.0000",
      "rawHtsCode": "8504.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ballasts for discharge lamps or tubes",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8504.21.00",
      "rawHtsCode": "8504.21.00",
      "superior": null,
      "indent": "2",
      "description": "Having a power handling capacity not exceeding <il>650 kVA</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8504.21.0020",
      "rawHtsCode": "8504.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Having a power handling capacity not exceeding <il>50 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.21.0040",
      "rawHtsCode": "8504.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Having a power handling capacity exceeding <il>50 kVA</il> but not exceeding <il>100 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.21.0060",
      "rawHtsCode": "8504.21.00.60",
      "superior": null,
      "indent": "3",
      "description": "Having a power handling capacity exceeding <il>100 kVA</il> but not exceeding <il>500 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.21.0080",
      "rawHtsCode": "8504.21.00.80",
      "superior": null,
      "indent": "3",
      "description": "Having a power handling capacity exceeding <il>500 kVA</il> but not exceeding <il>650 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.22.00",
      "rawHtsCode": "8504.22.00",
      "superior": null,
      "indent": "2",
      "description": "Having a power handling capacity exceeding <il>650 kVA</il> but not exceeding <il>10,000 kVA</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8504.22.0040",
      "rawHtsCode": "8504.22.00.40",
      "superior": null,
      "indent": "3",
      "description": "Having a power handling capacity exceeding <il>650 kVA</il> but not exceeding <il>2,500 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.22.0080",
      "rawHtsCode": "8504.22.00.80",
      "superior": null,
      "indent": "3",
      "description": "Having a power handling capacity exceeding <il>2,500 kVA</il> but not exceeding <il>10,000 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.23.00",
      "rawHtsCode": "8504.23.00",
      "superior": null,
      "indent": "2",
      "description": "Having a power handling capacity exceeding <il>10,000 kVA</il>",
      "units": [],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8504.23.0041",
      "rawHtsCode": "8504.23.00.41",
      "superior": null,
      "indent": "3",
      "description": "Having a power handling capacity exceeding <il>10,000 kVA</il> but not exceeding <il>59,999 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.23.0045",
      "rawHtsCode": "8504.23.00.45",
      "superior": null,
      "indent": "3",
      "description": "Having a power handling capacity exceeding <il>59,999 kVA</il> but not exceeding <il>100,000 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.23.0080",
      "rawHtsCode": "8504.23.00.80",
      "superior": null,
      "indent": "3",
      "description": "Having a power handling capacity exceeding <il>100,000 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.31",
      "rawHtsCode": "8504.31",
      "superior": null,
      "indent": "2",
      "description": "Having a power handling capacity not exceeding <il>1 kVA</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.31.2000",
      "rawHtsCode": "8504.31.20.00",
      "superior": null,
      "indent": "3",
      "description": "Unrated",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8504.31.40",
      "rawHtsCode": "8504.31.40",
      "superior": null,
      "indent": "4",
      "description": "Having a power handling capacity less than <il>1 kVA</il>",
      "units": [],
      "generalRate": "6.6%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8504.31.4035",
      "rawHtsCode": "8504.31.40.35",
      "superior": null,
      "indent": "5",
      "description": "Having a power handling capacity less than <il>40 VA</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.31.4065",
      "rawHtsCode": "8504.31.40.65",
      "superior": null,
      "indent": "5",
      "description": "Having a power handling capacity <il>40 VA</il> or greater",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.31.6000",
      "rawHtsCode": "8504.31.60.00",
      "superior": null,
      "indent": "4",
      "description": "Having a power handling capacity of <il>1 kVA</il>",
      "units": [
        "No."
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8504.32.0000",
      "rawHtsCode": "8504.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Having a power handling capacity exceeding <il>1 kVA</il> but not exceeding <il>16 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8504.33.00",
      "rawHtsCode": "8504.33.00",
      "superior": null,
      "indent": "2",
      "description": "Having a power handling capacity exceeding <il>16 kVA</il> but not exceeding <il>500 kVA</il>",
      "units": [],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8504.33.0020",
      "rawHtsCode": "8504.33.00.20",
      "superior": null,
      "indent": "3",
      "description": "Having a power handling capacity exceeding <il>16 kVA</il> but not exceeding <il>50 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.33.0040",
      "rawHtsCode": "8504.33.00.40",
      "superior": null,
      "indent": "3",
      "description": "Having a power handling capacity exceeding <il>50 kVA</il> but not exceeding <il>500 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.34.0000",
      "rawHtsCode": "8504.34.00.00",
      "superior": null,
      "indent": "2",
      "description": "Having a power handling capacity exceeding <il>500 kVA</il>",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8504.40",
      "rawHtsCode": "8504.40",
      "superior": null,
      "indent": "1",
      "description": "Static converters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.4000",
      "rawHtsCode": "8504.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "Speed drive controllers for electric motors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8504.40.60",
      "rawHtsCode": "8504.40.60",
      "superior": null,
      "indent": "3",
      "description": "Suitable for physical incorporation into automatic data processing machines or units thereof of heading 8471",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8504.40.6001",
      "rawHtsCode": "8504.40.60.01",
      "superior": null,
      "indent": "4",
      "description": "With a power output not exceeding <il>50 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.6007",
      "rawHtsCode": "8504.40.60.07",
      "superior": null,
      "indent": "4",
      "description": "With a power output exceeding <il>50 W</il> but not exceeding <il>150 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.6012",
      "rawHtsCode": "8504.40.60.12",
      "superior": null,
      "indent": "4",
      "description": "With a power output exceeding <il>150 W</il> but not exceeding <il>500 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.6018",
      "rawHtsCode": "8504.40.60.18",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.70",
      "rawHtsCode": "8504.40.70",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8504.40.7001",
      "rawHtsCode": "8504.40.70.01",
      "superior": null,
      "indent": "4",
      "description": "With a power output not exceeding <il>50 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.7007",
      "rawHtsCode": "8504.40.70.07",
      "superior": null,
      "indent": "4",
      "description": "With a power output exceeding <il>50 W</il> but not exceeding <il>150 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.7012",
      "rawHtsCode": "8504.40.70.12",
      "superior": null,
      "indent": "4",
      "description": "With a power output exceeding <il>150 W</il> but not exceeding <il>500 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.7018",
      "rawHtsCode": "8504.40.70.18",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.8500",
      "rawHtsCode": "8504.40.85.00",
      "superior": null,
      "indent": "2",
      "description": "For telecommunication apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8504.40.95",
      "rawHtsCode": "8504.40.95",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8504.40.9510",
      "rawHtsCode": "8504.40.95.10",
      "superior": null,
      "indent": "5",
      "description": "With a power output not exceeding <il>50 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.9520",
      "rawHtsCode": "8504.40.95.20",
      "superior": null,
      "indent": "5",
      "description": "With a power output exceeding <il>50 W</il> but not exceeding <il>150 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.9530",
      "rawHtsCode": "8504.40.95.30",
      "superior": null,
      "indent": "5",
      "description": "With a power output exceeding <il>150 W</il> but not exceeding <il>500 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.9540",
      "rawHtsCode": "8504.40.95.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.9550",
      "rawHtsCode": "8504.40.95.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.9570",
      "rawHtsCode": "8504.40.95.70",
      "superior": null,
      "indent": "3",
      "description": "Inverters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.40.9580",
      "rawHtsCode": "8504.40.95.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8504.50",
      "rawHtsCode": "8504.50",
      "superior": null,
      "indent": "1",
      "description": "Other inductors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.50.4000",
      "rawHtsCode": "8504.50.40.00",
      "superior": null,
      "indent": "2",
      "description": "For power supplies for automatic data processing machines or units thereof of heading 8471; power supplies for goods of subheading 8443.31 or 8443.32; power supplies for monitors of subheading 8528.42 or 8528.52 or projectors of subheading 8528.62; for telecommunication apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8504.50.8000",
      "rawHtsCode": "8504.50.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8504.90",
      "rawHtsCode": "8504.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.90.2000",
      "rawHtsCode": "8504.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8504.90.4100",
      "rawHtsCode": "8504.90.41.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8504.90.6500",
      "rawHtsCode": "8504.90.65.00",
      "superior": null,
      "indent": "4",
      "description": "Of the goods of subheading 8504.40 or 8504.50 for telecommunication apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8504.90.7500",
      "rawHtsCode": "8504.90.75.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8504.90.96",
      "rawHtsCode": "8504.90.96",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8504.90.9610",
      "rawHtsCode": "8504.90.96.10",
      "superior": null,
      "indent": "5",
      "description": "For transformers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.90.9630",
      "rawHtsCode": "8504.90.96.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.90.9634",
      "rawHtsCode": "8504.90.96.34",
      "superior": null,
      "indent": "6",
      "description": "Laminations for incorporation into stacked cores",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.90.9638",
      "rawHtsCode": "8504.90.96.38",
      "superior": null,
      "indent": "6",
      "description": "Stacked cores for incorporation into transformers",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.90.9642",
      "rawHtsCode": "8504.90.96.42",
      "superior": null,
      "indent": "6",
      "description": "Wound cores for incorporation into transformers",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.90.9646",
      "rawHtsCode": "8504.90.96.46",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.90.9650",
      "rawHtsCode": "8504.90.96.50",
      "superior": null,
      "indent": "5",
      "description": "Of static converters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8504.90.9690",
      "rawHtsCode": "8504.90.96.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8505",
      "rawHtsCode": "8505",
      "superior": null,
      "indent": "0",
      "description": "Electromagnets; permanent magnets and articles intended to become permanent magnets after magnetization; electromagnetic or permanent magnet chucks, clamps and similar holding devices; electromagnetic couplings, clutches and brakes; electromagnetic lifting heads; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8505.11.00",
      "rawHtsCode": "8505.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of metal",
      "units": [],
      "generalRate": "2.1%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.06. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8505.11.0010",
      "rawHtsCode": "8505.11.00.10",
      "superior": null,
      "indent": "3",
      "description": "Alnico",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8505.11.0030",
      "rawHtsCode": "8505.11.00.30",
      "superior": null,
      "indent": "3",
      "description": "Ceramic",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8505.11.0050",
      "rawHtsCode": "8505.11.00.50",
      "superior": null,
      "indent": "3",
      "description": "Sintered samarium-cobalt",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8505.11.0070",
      "rawHtsCode": "8505.11.00.70",
      "superior": null,
      "indent": "3",
      "description": "Sintered neodymium-iron-boron",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8505.11.0090",
      "rawHtsCode": "8505.11.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8505.19",
      "rawHtsCode": "8505.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8505.19.1000",
      "rawHtsCode": "8505.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Flexible magnets",
      "units": [
        "No."
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8505.19.2000",
      "rawHtsCode": "8505.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Composite good containing flexible magnets",
      "units": [
        "No."
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8505.19.3000",
      "rawHtsCode": "8505.19.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8505.20.0000",
      "rawHtsCode": "8505.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Electromagnetic couplings, clutches and brakes",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8505.90",
      "rawHtsCode": "8505.90",
      "superior": null,
      "indent": "1",
      "description": "Other, including parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8505.90.3000",
      "rawHtsCode": "8505.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Electromagnetic lifting heads",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8505.90.4000",
      "rawHtsCode": "8505.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Work holders and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8505.90.7000",
      "rawHtsCode": "8505.90.70.00",
      "superior": null,
      "indent": "2",
      "description": "Electromagnets of a kind used solely or principally for magnetic resonance imaging apparatus, other than apparatus of heading 9018",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8505.90.7501",
      "rawHtsCode": "8505.90.75.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8506",
      "rawHtsCode": "8506",
      "superior": null,
      "indent": "0",
      "description": "Primary cells and primary batteries; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.10.00",
      "rawHtsCode": "8506.10.00",
      "superior": null,
      "indent": "1",
      "description": "Manganese dioxide",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8506.10.0010",
      "rawHtsCode": "8506.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Button and coin cell batteries",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.10.0090",
      "rawHtsCode": "8506.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.30",
      "rawHtsCode": "8506.30",
      "superior": null,
      "indent": "1",
      "description": "Mercuric oxide:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.30.1000",
      "rawHtsCode": "8506.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Having an external volume not exceeding <il>300 cm<sup>3</sup></il>",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8506.30.5000",
      "rawHtsCode": "8506.30.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8506.40",
      "rawHtsCode": "8506.40",
      "superior": null,
      "indent": "1",
      "description": "Silver oxide:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.40.10",
      "rawHtsCode": "8506.40.10",
      "superior": null,
      "indent": "2",
      "description": "Having an external volume not exceeding <il>300 cm<sup>3</sup></il>",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8506.40.1010",
      "rawHtsCode": "8506.40.10.10",
      "superior": null,
      "indent": "3",
      "description": "Button and coin cell batteries ",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.40.1090",
      "rawHtsCode": "8506.40.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.40.5000",
      "rawHtsCode": "8506.40.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8506.50.00",
      "rawHtsCode": "8506.50.00",
      "superior": null,
      "indent": "1",
      "description": "Lithium",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8506.50.0010",
      "rawHtsCode": "8506.50.00.10",
      "superior": null,
      "indent": "2",
      "description": "Button and coin cell batteries",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.50.0090",
      "rawHtsCode": "8506.50.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.60.00",
      "rawHtsCode": "8506.60.00",
      "superior": null,
      "indent": "1",
      "description": "Air-zinc",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8506.60.0010",
      "rawHtsCode": "8506.60.00.10",
      "superior": null,
      "indent": "2",
      "description": "Button and coin cell batteries",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.60.0090",
      "rawHtsCode": "8506.60.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.80.00",
      "rawHtsCode": "8506.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other primary cells and primary batteries",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8506.80.0010",
      "rawHtsCode": "8506.80.00.10",
      "superior": null,
      "indent": "2",
      "description": "Button and coin cell batteries",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.80.0090",
      "rawHtsCode": "8506.80.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8506.90.0000",
      "rawHtsCode": "8506.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8507",
      "rawHtsCode": "8507",
      "superior": null,
      "indent": "0",
      "description": "Electric storage batteries, including separators therefor, whether or not rectangular (including square); parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.10.00",
      "rawHtsCode": "8507.10.00",
      "superior": null,
      "indent": "1",
      "description": "Lead-acid storage batteries, of a kind used for starting piston engines",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8507.10.0030",
      "rawHtsCode": "8507.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "Not exceeding 6 kg in weight",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.10.0060",
      "rawHtsCode": "8507.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Exceeding 6 kg in weight",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.10.0090",
      "rawHtsCode": "8507.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.20",
      "rawHtsCode": "8507.20",
      "superior": null,
      "indent": "1",
      "description": "Other lead-acid storage batteries:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.20.4000",
      "rawHtsCode": "8507.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used as the primary source of electrical power for electrically powered vehicles of subheadings 8703.40, 8703.50, 8703.60, 8703.70 or 8703.80",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8507.20.80",
      "rawHtsCode": "8507.20.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8507.20.8010",
      "rawHtsCode": "8507.20.80.10",
      "superior": null,
      "indent": "3",
      "description": "Of a kind described in subheading 9903.45.25",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.20.8031",
      "rawHtsCode": "8507.20.80.31",
      "superior": null,
      "indent": "4",
      "description": "6 V batteries",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.20.8041",
      "rawHtsCode": "8507.20.80.41",
      "superior": null,
      "indent": "4",
      "description": "12 V batteries",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.20.8061",
      "rawHtsCode": "8507.20.80.61",
      "superior": null,
      "indent": "4",
      "description": "36 V batteries",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.20.8091",
      "rawHtsCode": "8507.20.80.91",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.30",
      "rawHtsCode": "8507.30",
      "superior": null,
      "indent": "1",
      "description": "Nickel-cadmium storage batteries:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.30.4000",
      "rawHtsCode": "8507.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used as the primary source of electrical power for electrically powered vehicles of subheadings 8703.40, 8703.50, 8703.60, 8703.70 or 8703.80",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8507.30.80",
      "rawHtsCode": "8507.30.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8507.30.8010",
      "rawHtsCode": "8507.30.80.10",
      "superior": null,
      "indent": "3",
      "description": "Sealed",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.30.8090",
      "rawHtsCode": "8507.30.80.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.50.0000",
      "rawHtsCode": "8507.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Nickel-metal hydride batteries",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8507.60.00",
      "rawHtsCode": "8507.60.00",
      "superior": null,
      "indent": "1",
      "description": "Lithium-ion batteries",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15 and 9903.91.06. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8507.60.0010",
      "rawHtsCode": "8507.60.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used as the primary source of electrical power for electrically powered vehicles of subheadings 8703.40, 8703.50, 8703.60, 8703.70 or 8703.80",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.60.0030",
      "rawHtsCode": "8507.60.00.30",
      "superior": null,
      "indent": "3",
      "description": "Battery energy storage systems fully encased within a housing, as described in statistical note 2 to this chapter",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.60.0090",
      "rawHtsCode": "8507.60.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.80",
      "rawHtsCode": "8507.80",
      "superior": null,
      "indent": "1",
      "description": "Other storage batteries:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.80.4100",
      "rawHtsCode": "8507.80.41.00",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used as the primary source of electrical power for electrically powered vehicles of subheadings 8703.40, 8703.50, 8703.60, 8703.70 or 8703.80",
      "units": [
        "No."
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8507.80.8200",
      "rawHtsCode": "8507.80.82.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8507.90",
      "rawHtsCode": "8507.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8507.90.4000",
      "rawHtsCode": "8507.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of lead-acid storage batteries",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8507.90.8000",
      "rawHtsCode": "8507.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8508",
      "rawHtsCode": "8508",
      "superior": null,
      "indent": "0",
      "description": "Vacuum cleaners; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8508.11.0000",
      "rawHtsCode": "8508.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of a power not exceeding <il>1,500 W</il> and having a dust bag or other receptacle capacity not exceeding 20 l",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8508.19.0000",
      "rawHtsCode": "8508.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8508.60.0000",
      "rawHtsCode": "8508.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other vacuum cleaners",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8508.70.0000",
      "rawHtsCode": "8508.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8509",
      "rawHtsCode": "8509",
      "superior": null,
      "indent": "0",
      "description": "Electromechanical domestic appliances, with self-contained electric motor, other than vacuum cleaners of heading 8508; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.40.00",
      "rawHtsCode": "8509.40.00",
      "superior": null,
      "indent": "1",
      "description": "Food grinders, processors and mixers; fruit or vegetable juice extractors",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8509.40.0015",
      "rawHtsCode": "8509.40.00.15",
      "superior": null,
      "indent": "2",
      "description": "Blenders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.40.0025",
      "rawHtsCode": "8509.40.00.25",
      "superior": null,
      "indent": "2",
      "description": "Other food mixers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.40.0030",
      "rawHtsCode": "8509.40.00.30",
      "superior": null,
      "indent": "2",
      "description": "Juice extractors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.40.0040",
      "rawHtsCode": "8509.40.00.40",
      "superior": null,
      "indent": "2",
      "description": "Food grinders and processors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.80",
      "rawHtsCode": "8509.80",
      "superior": null,
      "indent": "1",
      "description": "Other appliances:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.80.1000",
      "rawHtsCode": "8509.80.10.00",
      "superior": null,
      "indent": "2",
      "description": "Floor polishers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.80.2000",
      "rawHtsCode": "8509.80.20.00",
      "superior": null,
      "indent": "2",
      "description": "Kitchen waste disposers (disposals)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8509.80.50",
      "rawHtsCode": "8509.80.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8509.80.5040",
      "rawHtsCode": "8509.80.50.40",
      "superior": null,
      "indent": "3",
      "description": "Can openers (including combination units)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.80.5045",
      "rawHtsCode": "8509.80.50.45",
      "superior": null,
      "indent": "3",
      "description": "Electric toothbrushes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.80.5050",
      "rawHtsCode": "8509.80.50.50",
      "superior": null,
      "indent": "4",
      "description": "Evaporative",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.80.5070",
      "rawHtsCode": "8509.80.50.70",
      "superior": null,
      "indent": "5",
      "description": "Ultrasonic",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.80.5080",
      "rawHtsCode": "8509.80.50.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.80.5095",
      "rawHtsCode": "8509.80.50.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.90",
      "rawHtsCode": "8509.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8509.90.2500",
      "rawHtsCode": "8509.90.25.00",
      "superior": null,
      "indent": "3",
      "description": "Housings",
      "units": [
        "No."
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8509.90.3500",
      "rawHtsCode": "8509.90.35.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8509.90.4500",
      "rawHtsCode": "8509.90.45.00",
      "superior": null,
      "indent": "3",
      "description": "Housings",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8509.90.5500",
      "rawHtsCode": "8509.90.55.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8510",
      "rawHtsCode": "8510",
      "superior": null,
      "indent": "0",
      "description": "Shavers, hair clippers and hair-removing appliances, with self-contained electric motor; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8510.10.0000",
      "rawHtsCode": "8510.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Shavers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8510.20",
      "rawHtsCode": "8510.20",
      "superior": null,
      "indent": "1",
      "description": "Hair clippers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8510.20.1000",
      "rawHtsCode": "8510.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Hair clippers to be used for agricultural or horticultural purposes",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8510.20.9000",
      "rawHtsCode": "8510.20.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8510.30.0000",
      "rawHtsCode": "8510.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hair-removing appliances",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8510.90",
      "rawHtsCode": "8510.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8510.90.1000",
      "rawHtsCode": "8510.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Blades and cutting heads",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8510.90.2000",
      "rawHtsCode": "8510.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other parts of shavers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8510.90.3001",
      "rawHtsCode": "8510.90.30.01",
      "superior": null,
      "indent": "3",
      "description": "Parts of hair clippers to be used for agricultural or horticultural purposes",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8510.90.4000",
      "rawHtsCode": "8510.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other parts of hair clippers",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8510.90.5500",
      "rawHtsCode": "8510.90.55.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8511",
      "rawHtsCode": "8511",
      "superior": null,
      "indent": "0",
      "description": "Electrical ignition or starting equipment of a kind used for spark-ignition or compression-ignition internal combustion engines (for example, ignition magnetos, magneto-dynamos, ignition coils, spark plugs and glow plugs, starter motors); generators (for example, dynamos, alternators) and cut-outs of a kind used in conjunction with such engines; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8511.10.0000",
      "rawHtsCode": "8511.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Spark plugs",
      "units": [
        "hundreds"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8511.20.0000",
      "rawHtsCode": "8511.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ignition magnetos; magneto-dynamos; magnetic flywheels",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8511.30.00",
      "rawHtsCode": "8511.30.00",
      "superior": null,
      "indent": "1",
      "description": "Distributors; ignition coils",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8511.30.0040",
      "rawHtsCode": "8511.30.00.40",
      "superior": null,
      "indent": "2",
      "description": "Distributors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8511.30.0080",
      "rawHtsCode": "8511.30.00.80",
      "superior": null,
      "indent": "2",
      "description": "Ignition coils",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8511.40.0000",
      "rawHtsCode": "8511.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Starter motors and dual purpose starter-generators",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8511.50.0000",
      "rawHtsCode": "8511.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other generators",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8511.80",
      "rawHtsCode": "8511.80",
      "superior": null,
      "indent": "1",
      "description": "Other equipment:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8511.80.2000",
      "rawHtsCode": "8511.80.20.00",
      "superior": null,
      "indent": "3",
      "description": "Designed for use on 6, 12 or 24 V systems",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8511.80.4000",
      "rawHtsCode": "8511.80.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8511.80.6000",
      "rawHtsCode": "8511.80.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8511.90",
      "rawHtsCode": "8511.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8511.90.2000",
      "rawHtsCode": "8511.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Designed for use on 6, 12 or 24 V systems",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8511.90.4000",
      "rawHtsCode": "8511.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8511.90.60",
      "rawHtsCode": "8511.90.60",
      "superior": null,
      "indent": "2",
      "description": "Other parts",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8511.90.6020",
      "rawHtsCode": "8511.90.60.20",
      "superior": null,
      "indent": "3",
      "description": "Distributor contact (breaker point) sets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8511.90.6040",
      "rawHtsCode": "8511.90.60.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512",
      "rawHtsCode": "8512",
      "superior": null,
      "indent": "0",
      "description": "Electrical lighting or signaling equipment (excluding articles of heading 8539), windshield wipers, defrosters and demisters, of a kind used for cycles or motor vehicles; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512.10",
      "rawHtsCode": "8512.10",
      "superior": null,
      "indent": "1",
      "description": "Lighting or visual signaling equipment of a kind used on bicycles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512.10.2000",
      "rawHtsCode": "8512.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Lighting equipment",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8512.10.4000",
      "rawHtsCode": "8512.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Visual signaling equipment",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8512.20",
      "rawHtsCode": "8512.20",
      "superior": null,
      "indent": "1",
      "description": "Other lighting or visual signaling equipment:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512.20.20",
      "rawHtsCode": "8512.20.20",
      "superior": null,
      "indent": "2",
      "description": "Lighting equipment",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8512.20.2040",
      "rawHtsCode": "8512.20.20.40",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or heading 8702, 8703, 8704, 8705 or 8711",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512.20.2080",
      "rawHtsCode": "8512.20.20.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512.20.40",
      "rawHtsCode": "8512.20.40",
      "superior": null,
      "indent": "2",
      "description": "Visual signaling equipment",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8512.20.4040",
      "rawHtsCode": "8512.20.40.40",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or heading 8702, 8703, 8704, 8705 or 8711",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512.20.4080",
      "rawHtsCode": "8512.20.40.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512.30.00",
      "rawHtsCode": "8512.30.00",
      "superior": null,
      "indent": "1",
      "description": "Sound signaling equipment",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8512.30.0020",
      "rawHtsCode": "8512.30.00.20",
      "superior": null,
      "indent": "2",
      "description": "Horns",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512.30.0030",
      "rawHtsCode": "8512.30.00.30",
      "superior": null,
      "indent": "2",
      "description": "Radar detectors of a kind used in motor vehicles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512.30.0040",
      "rawHtsCode": "8512.30.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512.40",
      "rawHtsCode": "8512.40",
      "superior": null,
      "indent": "1",
      "description": "Windshield wipers, defrosters and demisters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512.40.2000",
      "rawHtsCode": "8512.40.20.00",
      "superior": null,
      "indent": "2",
      "description": "Defrosters and demisters",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8512.40.4000",
      "rawHtsCode": "8512.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "Windshield wipers",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8512.90",
      "rawHtsCode": "8512.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8512.90.2000",
      "rawHtsCode": "8512.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of signaling equipment",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8512.90.4000",
      "rawHtsCode": "8512.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used on bicycles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8512.90.6000",
      "rawHtsCode": "8512.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8512.90.7000",
      "rawHtsCode": "8512.90.70.00",
      "superior": null,
      "indent": "2",
      "description": "Of defrosters and demisters",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8512.90.9000",
      "rawHtsCode": "8512.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8513",
      "rawHtsCode": "8513",
      "superior": null,
      "indent": "0",
      "description": "Portable electric lamps designed to function by their own source of energy (for example, dry batteries, storage batteries, magnetos), other than lighting equipment of heading 8512; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8513.10",
      "rawHtsCode": "8513.10",
      "superior": null,
      "indent": "1",
      "description": "Lamps:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8513.10.2000",
      "rawHtsCode": "8513.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Flashlights",
      "units": [
        "No."
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8513.10.4000",
      "rawHtsCode": "8513.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8513.90",
      "rawHtsCode": "8513.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8513.90.2000",
      "rawHtsCode": "8513.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of flashlights",
      "units": [
        "kg"
      ],
      "generalRate": "12.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8513.90.4000",
      "rawHtsCode": "8513.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8514",
      "rawHtsCode": "8514",
      "superior": null,
      "indent": "0",
      "description": "Industrial or laboratory electric furnaces and ovens (including those functioning by induction or dielectric loss); other industrial or laboratory equipment for the heat treatment of materials by induction or dielectric loss; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8514.11.0000",
      "rawHtsCode": "8514.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Hot isostatic presses",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8514.19.0000",
      "rawHtsCode": "8514.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8514.20",
      "rawHtsCode": "8514.20",
      "superior": null,
      "indent": "1",
      "description": "Furnaces and ovens functioning by induction or dielectric loss:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8514.20.4000",
      "rawHtsCode": "8514.20.40.00",
      "superior": null,
      "indent": "3",
      "description": "For making hot drinks, or for cooking or heating food",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8514.20.6000",
      "rawHtsCode": "8514.20.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8514.20.8000",
      "rawHtsCode": "8514.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8514.31",
      "rawHtsCode": "8514.31",
      "superior": null,
      "indent": "2",
      "description": "Electron beam furnaces:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8514.31.1000",
      "rawHtsCode": "8514.31.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used solely or principally for the manufacture of printed circuits or printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8514.31.9000",
      "rawHtsCode": "8514.31.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8514.32",
      "rawHtsCode": "8514.32",
      "superior": null,
      "indent": "2",
      "description": "Plasma and vacuum arc furnaces:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8514.32.1000",
      "rawHtsCode": "8514.32.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used solely or principally for the manufacture of printed circuits or printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8514.32.9000",
      "rawHtsCode": "8514.32.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8514.39",
      "rawHtsCode": "8514.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8514.39.1000",
      "rawHtsCode": "8514.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used solely or principally for the manufacture of printed circuits or printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8514.39.9000",
      "rawHtsCode": "8514.39.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8514.40.0000",
      "rawHtsCode": "8514.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other equipment for the heat treatment of materials by induction or dielectric loss",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8514.90",
      "rawHtsCode": "8514.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8514.90.4000",
      "rawHtsCode": "8514.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of microwave ovens",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8514.90.8000",
      "rawHtsCode": "8514.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8515",
      "rawHtsCode": "8515",
      "superior": null,
      "indent": "0",
      "description": "Electric (including electrically heated gas), laser or other light or photon beam, ultrasonic, electron beam, magnetic pulse or plasma arc soldering, brazing or welding machines and apparatus, whether or not capable of cutting; electric machines and apparatus for hot spraying of metals or cermets; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8515.11.0000",
      "rawHtsCode": "8515.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Soldering irons and guns",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8515.19.0000",
      "rawHtsCode": "8515.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8515.21.0000",
      "rawHtsCode": "8515.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fully or partly automatic",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8515.29.0000",
      "rawHtsCode": "8515.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8515.31.0000",
      "rawHtsCode": "8515.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fully or partly automatic",
      "units": [
        "No."
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8515.39.00",
      "rawHtsCode": "8515.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8515.39.0020",
      "rawHtsCode": "8515.39.00.20",
      "superior": null,
      "indent": "4",
      "description": "AC transformer type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8515.39.0040",
      "rawHtsCode": "8515.39.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8515.39.0060",
      "rawHtsCode": "8515.39.00.60",
      "superior": null,
      "indent": "3",
      "description": "Rotating type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8515.80.00",
      "rawHtsCode": "8515.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other machines and apparatus",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8515.80.0040",
      "rawHtsCode": "8515.80.00.40",
      "superior": null,
      "indent": "2",
      "description": "Ultrasonic welding machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8515.80.0080",
      "rawHtsCode": "8515.80.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8515.90",
      "rawHtsCode": "8515.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8515.90.2000",
      "rawHtsCode": "8515.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of welding machines and apparatus",
      "units": [
        "No."
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8515.90.4000",
      "rawHtsCode": "8515.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8516",
      "rawHtsCode": "8516",
      "superior": null,
      "indent": "0",
      "description": "Electric instantaneous or storage water heaters and immersion heaters; electric space heating apparatus and soil heating apparatus; electrothermic hairdressing apparatus (for example, hair dryers, hair curlers, curling tong heaters) and hand dryers; electric flatirons; other electrothermic appliances of a kind used for domestic purposes; electric heating resistors, other than those of heading 8545; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.10.00",
      "rawHtsCode": "8516.10.00",
      "superior": null,
      "indent": "1",
      "description": "Electric instantaneous or storage water heaters and immersion heaters",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8516.10.0040",
      "rawHtsCode": "8516.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Storage water heaters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.10.0080",
      "rawHtsCode": "8516.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other water heaters and immersion heaters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.21.0000",
      "rawHtsCode": "8516.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Storage heating radiators",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8516.29.00",
      "rawHtsCode": "8516.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.29.0030",
      "rawHtsCode": "8516.29.00.30",
      "superior": null,
      "indent": "4",
      "description": "Fan-forced",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.29.0060",
      "rawHtsCode": "8516.29.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.29.0090",
      "rawHtsCode": "8516.29.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8516.31.0000",
      "rawHtsCode": "8516.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Hair dryers",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.32.00",
      "rawHtsCode": "8516.32.00",
      "superior": null,
      "indent": "2",
      "description": "Other hairdressing apparatus",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.32.0020",
      "rawHtsCode": "8516.32.00.20",
      "superior": null,
      "indent": "3",
      "description": "Curlers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.32.0040",
      "rawHtsCode": "8516.32.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.33.0000",
      "rawHtsCode": "8516.33.00.00",
      "superior": null,
      "indent": "2",
      "description": "Hand-drying apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8516.40",
      "rawHtsCode": "8516.40",
      "superior": null,
      "indent": "1",
      "description": "Electric flatirons:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.40.2000",
      "rawHtsCode": "8516.40.20.00",
      "superior": null,
      "indent": "2",
      "description": "Travel type",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.40.4000",
      "rawHtsCode": "8516.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.50.00",
      "rawHtsCode": "8516.50.00",
      "superior": null,
      "indent": "1",
      "description": "Microwave ovens",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.50.0030",
      "rawHtsCode": "8516.50.00.30",
      "superior": null,
      "indent": "2",
      "description": "Having a capacity not exceeding 22.5 liters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.50.0060",
      "rawHtsCode": "8516.50.00.60",
      "superior": null,
      "indent": "2",
      "description": "Having a capacity exceeding 22.5 liters but not exceeding 31.0 liters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.50.0090",
      "rawHtsCode": "8516.50.00.90",
      "superior": null,
      "indent": "2",
      "description": "Having a capacity exceeding 31.0 liters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.60",
      "rawHtsCode": "8516.60",
      "superior": null,
      "indent": "1",
      "description": "Other ovens; cooking stoves, ranges, cooking plates, boiling rings, grillers and roasters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.60.40",
      "rawHtsCode": "8516.60.40",
      "superior": null,
      "indent": "2",
      "description": "Cooking stoves, ranges and ovens",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8516.60.4060",
      "rawHtsCode": "8516.60.40.60",
      "superior": null,
      "indent": "3",
      "description": "Microwave oven combinations",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.60.4070",
      "rawHtsCode": "8516.60.40.70",
      "superior": null,
      "indent": "4",
      "description": "Portable",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.60.4074",
      "rawHtsCode": "8516.60.40.74",
      "superior": null,
      "indent": "5",
      "description": "Of a maximum width not exceeding <il>70 centimeters</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.60.4078",
      "rawHtsCode": "8516.60.40.78",
      "superior": null,
      "indent": "6",
      "description": "Containing a gas fueled cooktop",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.60.4082",
      "rawHtsCode": "8516.60.40.82",
      "superior": null,
      "indent": "6",
      "description": "Containing a radiant heated cooktop",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.60.4086",
      "rawHtsCode": "8516.60.40.86",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.60.6000",
      "rawHtsCode": "8516.60.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.71.00",
      "rawHtsCode": "8516.71.00",
      "superior": null,
      "indent": "2",
      "description": "Coffee or tea makers",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.71.0020",
      "rawHtsCode": "8516.71.00.20",
      "superior": null,
      "indent": "4",
      "description": "Automatic drip and pump type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.71.0040",
      "rawHtsCode": "8516.71.00.40",
      "superior": null,
      "indent": "4",
      "description": "Percolator",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.71.0060",
      "rawHtsCode": "8516.71.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.71.0080",
      "rawHtsCode": "8516.71.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.72.0000",
      "rawHtsCode": "8516.72.00.00",
      "superior": null,
      "indent": "2",
      "description": "Toasters",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.79.0000",
      "rawHtsCode": "8516.79.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.80",
      "rawHtsCode": "8516.80",
      "superior": null,
      "indent": "1",
      "description": "Electric heating resistors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.80.4000",
      "rawHtsCode": "8516.80.40.00",
      "superior": null,
      "indent": "2",
      "description": "Assembled only with simple insulated former and electrical connections, used for anti-icing or deicing",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8516.80.8000",
      "rawHtsCode": "8516.80.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8516.90",
      "rawHtsCode": "8516.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.90.0500",
      "rawHtsCode": "8516.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "Of heaters or heating apparatus of subheading 8516.10, 8516.21 or 8516.29",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.90.1500",
      "rawHtsCode": "8516.90.15.00",
      "superior": null,
      "indent": "2",
      "description": "Housings for the hand-drying apparatus of subheading 8516.33",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.90.2500",
      "rawHtsCode": "8516.90.25.00",
      "superior": null,
      "indent": "2",
      "description": "Housings and steel bases for the electric flatirons of subheading 8516.40",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.90.3500",
      "rawHtsCode": "8516.90.35.00",
      "superior": null,
      "indent": "3",
      "description": "Assemblies, incorporating more than one of the following: cooking chamber; structural supporting chassis; door; outer case",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8516.90.4500",
      "rawHtsCode": "8516.90.45.00",
      "superior": null,
      "indent": "3",
      "description": "Printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8516.90.5000",
      "rawHtsCode": "8516.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.  "
      ],
      "flags": []
    },
    {
      "htsCode": "8516.90.5500",
      "rawHtsCode": "8516.90.55.00",
      "superior": null,
      "indent": "3",
      "description": "Cooking chambers, whether or not assembled",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8516.90.6500",
      "rawHtsCode": "8516.90.65.00",
      "superior": null,
      "indent": "3",
      "description": "Top surface panels with or without heating elements or controls",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8516.90.7500",
      "rawHtsCode": "8516.90.75.00",
      "superior": null,
      "indent": "3",
      "description": "Door assemblies, incorporating more than one of the following: inner panel; outer panel; window; insulation",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8516.90.80",
      "rawHtsCode": "8516.90.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.  "
      ],
      "flags": []
    },
    {
      "htsCode": "8516.90.8010",
      "rawHtsCode": "8516.90.80.10",
      "superior": null,
      "indent": "4",
      "description": "Shelving and racks for cooking stoves and ranges",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.90.8050",
      "rawHtsCode": "8516.90.80.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8516.90.8500",
      "rawHtsCode": "8516.90.85.00",
      "superior": null,
      "indent": "2",
      "description": "Housings for toasters",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8516.90.9000",
      "rawHtsCode": "8516.90.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8517",
      "rawHtsCode": "8517",
      "superior": null,
      "indent": "0",
      "description": "Telephone sets, including smartphones and other telephones for cellular networks or for other wireless networks; other apparatus for the transmission or reception of voice, images or other data, including apparatus for communication in a wired or wireless network (such as a local or wide area network), other than transmission or reception apparatus of heading 8443, 8525, 8527 or 8528; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.11.0000",
      "rawHtsCode": "8517.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Line telephone sets with cordless handsets",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8517.13.0000",
      "rawHtsCode": "8517.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Smartphones",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.14.00",
      "rawHtsCode": "8517.14.00",
      "superior": null,
      "indent": "2",
      "description": "Other telephones for cellular networks or for other wireless networks",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.14.0020",
      "rawHtsCode": "8517.14.00.20",
      "superior": null,
      "indent": "3",
      "description": "Radio telephones designed for installation in motor vehicles for the Public Cellular Radiotelecommunication Service",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.14.0050",
      "rawHtsCode": "8517.14.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other radio telephones designed for the Public Cellular Radiotelecommunication Service",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.14.0080",
      "rawHtsCode": "8517.14.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.18.00",
      "rawHtsCode": "8517.18.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.18.0010",
      "rawHtsCode": "8517.18.00.10",
      "superior": null,
      "indent": "3",
      "description": "Videophones",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.18.0020",
      "rawHtsCode": "8517.18.00.20",
      "superior": null,
      "indent": "3",
      "description": "Multiline telephones (including key, call director and consoles)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.18.0050",
      "rawHtsCode": "8517.18.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.61.0000",
      "rawHtsCode": "8517.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Base stations",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8517.62.00",
      "rawHtsCode": "8517.62.00",
      "superior": null,
      "indent": "2",
      "description": "Machines for the reception, conversion and transmission or regeneration of voice, images or other data, including switching and routing apparatus",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.04 and 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8517.62.0010",
      "rawHtsCode": "8517.62.00.10",
      "superior": null,
      "indent": "3",
      "description": "Modems, of a kind used with data processing machines of heading 8471",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.62.0020",
      "rawHtsCode": "8517.62.00.20",
      "superior": null,
      "indent": "3",
      "description": "Switching and routing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.62.0090",
      "rawHtsCode": "8517.62.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8517.69.0000",
      "rawHtsCode": "8517.69.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8517.71.0000",
      "rawHtsCode": "8517.71.00.00",
      "superior": null,
      "indent": "2",
      "description": "Aerials and aerial reflectors of all kinds; parts suitable for use therewith",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.  "
      ],
      "flags": []
    },
    {
      "htsCode": "8517.79.0000",
      "rawHtsCode": "8517.79.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.  "
      ],
      "flags": []
    },
    {
      "htsCode": "8518",
      "rawHtsCode": "8518",
      "superior": null,
      "indent": "0",
      "description": "Microphones and stands therefor; loudspeakers, whether or not mounted in their enclosures; headphones and earphones, whether or not combined with a microphone, and sets consisting of a microphone and one or more loudspeakers; audio-frequency electric amplifiers; electric sound amplifier sets; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8518.10",
      "rawHtsCode": "8518.10",
      "superior": null,
      "indent": "1",
      "description": "Microphones and stands therefor:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8518.10.4000",
      "rawHtsCode": "8518.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Microphones having a frequency range of <il>300 Hz</il> to <il>3.4 kHz</il> with a diameter of not exceeding <il>10 mm</il> and a height not exceeding <il>3 mm</il>, for telecommunication use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8518.10.80",
      "rawHtsCode": "8518.10.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8518.10.8030",
      "rawHtsCode": "8518.10.80.30",
      "superior": null,
      "indent": "3",
      "description": "Microphones",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8518.10.8040",
      "rawHtsCode": "8518.10.80.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8518.21.0000",
      "rawHtsCode": "8518.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Single loudspeakers, mounted in their enclosures",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8518.22.0000",
      "rawHtsCode": "8518.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Multiple loudspeakers, mounted in the same enclosure",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8518.29",
      "rawHtsCode": "8518.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8518.29.4000",
      "rawHtsCode": "8518.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "Without housing, having a frequency range of <il>300 Hz</il> to <il>3.4 kHz</il> with a diameter of not exceeding <il>50 mm</il>, for telecommunication use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8518.29.8000",
      "rawHtsCode": "8518.29.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8518.30",
      "rawHtsCode": "8518.30",
      "superior": null,
      "indent": "1",
      "description": "Headphones and earphones, whether or not combined with a microphone, and sets consisting of a microphone and one or more loudspeakers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8518.30.1000",
      "rawHtsCode": "8518.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "Line telephone handsets",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8518.30.2000",
      "rawHtsCode": "8518.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8518.40",
      "rawHtsCode": "8518.40",
      "superior": null,
      "indent": "1",
      "description": "Audio-frequency electric amplifiers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8518.40.1000",
      "rawHtsCode": "8518.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "For use as repeaters in line telephony",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8518.40.2000",
      "rawHtsCode": "8518.40.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8518.50.0000",
      "rawHtsCode": "8518.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Electric sound amplifier sets",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8518.90",
      "rawHtsCode": "8518.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8518.90.2000",
      "rawHtsCode": "8518.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Printed circuit assemblies of line telephone handsets; parts of repeaters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8518.90.4100",
      "rawHtsCode": "8518.90.41.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8518.90.6000",
      "rawHtsCode": "8518.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Printed circuit assemblies of the articles of subheading 8518.10.40 or 8518.29.40",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8518.90.8100",
      "rawHtsCode": "8518.90.81.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8519",
      "rawHtsCode": "8519",
      "superior": null,
      "indent": "0",
      "description": "Sound recording or reproducing apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.20.0000",
      "rawHtsCode": "8519.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Apparatus operated by coins, banknotes, bank cards, tokens or by other means of payment",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8519.30",
      "rawHtsCode": "8519.30",
      "superior": null,
      "indent": "1",
      "description": "Turntables (record-decks):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.30.1000",
      "rawHtsCode": "8519.30.10.00",
      "superior": null,
      "indent": "2",
      "description": "With automatic record changing mechanism",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8519.30.2000",
      "rawHtsCode": "8519.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.81",
      "rawHtsCode": "8519.81",
      "superior": null,
      "indent": "2",
      "description": "Using magnetic, optical or semiconductor media:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.81.1000",
      "rawHtsCode": "8519.81.10.00",
      "superior": null,
      "indent": "4",
      "description": "Transcribing machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8519.81.2000",
      "rawHtsCode": "8519.81.20.00",
      "superior": null,
      "indent": "5",
      "description": "Designed exclusively for motor- vehicle installation",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.81.2500",
      "rawHtsCode": "8519.81.25.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.81.30",
      "rawHtsCode": "8519.81.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8519.81.3010",
      "rawHtsCode": "8519.81.30.10",
      "superior": null,
      "indent": "5",
      "description": "Optical disc (including compact disc) players",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.81.3020",
      "rawHtsCode": "8519.81.30.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.81.41",
      "rawHtsCode": "8519.81.41",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.81.4105",
      "rawHtsCode": "8519.81.41.05",
      "superior": null,
      "indent": "4",
      "description": "Telephone answering machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.81.4110",
      "rawHtsCode": "8519.81.41.10",
      "superior": null,
      "indent": "4",
      "description": "Magnetic tape recorders incorporating sound reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.81.4120",
      "rawHtsCode": "8519.81.41.20",
      "superior": null,
      "indent": "4",
      "description": "Optical disc recorders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.81.4150",
      "rawHtsCode": "8519.81.41.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.89",
      "rawHtsCode": "8519.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.89.1000",
      "rawHtsCode": "8519.89.10.00",
      "superior": null,
      "indent": "4",
      "description": "Without loudspeaker",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8519.89.2000",
      "rawHtsCode": "8519.89.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8519.89.3000",
      "rawHtsCode": "8519.89.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8521",
      "rawHtsCode": "8521",
      "superior": null,
      "indent": "0",
      "description": "Video recording or reproducing apparatus, whether or not incorporating a video tuner:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8521.10",
      "rawHtsCode": "8521.10",
      "superior": null,
      "indent": "1",
      "description": "Magnetic tape-type:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8521.10.3000",
      "rawHtsCode": "8521.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Not capable of recording",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8521.10.6000",
      "rawHtsCode": "8521.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8521.10.9000",
      "rawHtsCode": "8521.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8521.90.0000",
      "rawHtsCode": "8521.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8522",
      "rawHtsCode": "8522",
      "superior": null,
      "indent": "0",
      "description": "Parts and accessories suitable for use solely or principally with the apparatus of heading 8519 or 8521:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8522.10.0000",
      "rawHtsCode": "8522.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Pickup cartridges",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8522.90",
      "rawHtsCode": "8522.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8522.90.2500",
      "rawHtsCode": "8522.90.25.00",
      "superior": null,
      "indent": "3",
      "description": "Printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8522.90.3600",
      "rawHtsCode": "8522.90.36.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8522.90.4500",
      "rawHtsCode": "8522.90.45.00",
      "superior": null,
      "indent": "3",
      "description": "Printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8522.90.58",
      "rawHtsCode": "8522.90.58",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8522.90.5840",
      "rawHtsCode": "8522.90.58.40",
      "superior": null,
      "indent": "4",
      "description": "Magnetic recording and reproducing heads",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8522.90.5880",
      "rawHtsCode": "8522.90.58.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8522.90.6500",
      "rawHtsCode": "8522.90.65.00",
      "superior": null,
      "indent": "3",
      "description": "Printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8522.90.80",
      "rawHtsCode": "8522.90.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8522.90.8040",
      "rawHtsCode": "8522.90.80.40",
      "superior": null,
      "indent": "4",
      "description": "Magnetic recording and reproducing heads",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8522.90.8081",
      "rawHtsCode": "8522.90.80.81",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523",
      "rawHtsCode": "8523",
      "superior": null,
      "indent": "0",
      "description": "Discs, tapes, solid-state non-volatile storage devices, \"smart cards\" and other media for the recording of sound or of other phenomena, whether or not recorded, including matrices and masters for the production of discs, but excluding products of Chapter 37:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.21.0000",
      "rawHtsCode": "8523.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cards incorporating a magnetic stripe",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8523.29",
      "rawHtsCode": "8523.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.29.1000",
      "rawHtsCode": "8523.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "Unrecorded magnetic media",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.29.2000",
      "rawHtsCode": "8523.29.20.00",
      "superior": null,
      "indent": "4",
      "description": "Magnetic tapes for reproducing phenomena other than sound or image",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "<il>86.1¢/m<sup>2</sup></il> of recording surface",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.29.3000",
      "rawHtsCode": "8523.29.30.00",
      "superior": null,
      "indent": "6",
      "description": "News sound recordings relating to current events",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.29.40",
      "rawHtsCode": "8523.29.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "86.1¢/m<sup>2</sup>of recording surface",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.29.4010",
      "rawHtsCode": "8523.29.40.10",
      "superior": null,
      "indent": "7",
      "description": "Sound recordings on cassette tapes",
      "units": [
        "No.",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.29.4020",
      "rawHtsCode": "8523.29.40.20",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No.",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.29.50",
      "rawHtsCode": "8523.29.50",
      "superior": null,
      "indent": "6",
      "description": "Video tape recordings",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.3¢/lin. m",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.29.5010",
      "rawHtsCode": "8523.29.50.10",
      "superior": null,
      "indent": "7",
      "description": "In cassettes",
      "units": [
        "lin. m",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.29.5020",
      "rawHtsCode": "8523.29.50.20",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "lin. m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.29.6000",
      "rawHtsCode": "8523.29.60.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "86.1¢/m<sup>2</sup> of recording surface",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.29.70",
      "rawHtsCode": "8523.29.70",
      "superior": null,
      "indent": "6",
      "description": "Video tape recordings",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "3.3¢/lin. m",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.29.7010",
      "rawHtsCode": "8523.29.70.10",
      "superior": null,
      "indent": "7",
      "description": "Of a width not exceeding 16 mm, in cassettes",
      "units": [
        "lin. m",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.29.7020",
      "rawHtsCode": "8523.29.70.20",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "lin. m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.29.8000",
      "rawHtsCode": "8523.29.80.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "86.1¢/m<sup>2</sup> of recording surface",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.29.9000",
      "rawHtsCode": "8523.29.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "86.1¢/m<sup>2</sup> of recording surface",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.41.0000",
      "rawHtsCode": "8523.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unrecorded",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.49",
      "rawHtsCode": "8523.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.49.20",
      "rawHtsCode": "8523.49.20",
      "superior": null,
      "indent": "3",
      "description": "For reproducing phenomena other than sound or image",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "86.1¢/m<sup>2</sup> of recording surface",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.49.2010",
      "rawHtsCode": "8523.49.20.10",
      "superior": null,
      "indent": "4",
      "description": "Prepackaged software for automatic data processing machines, of a kind sold at retail",
      "units": [
        "No.",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.49.2020",
      "rawHtsCode": "8523.49.20.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.49.3000",
      "rawHtsCode": "8523.49.30.00",
      "superior": null,
      "indent": "3",
      "description": "For reproducing sound only",
      "units": [
        "No.",
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "86.1¢/m<sup>2</sup> of recording surface",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.49.4000",
      "rawHtsCode": "8523.49.40.00",
      "superior": null,
      "indent": "4",
      "description": "For reproducing representations of instructions, data, sound, and image, recorded in a machine readable binary form, and capable of being manipulated or providing interactivity to a user, by means of an automatic data processing machine; proprietary format recorded discs",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8523.49.5000",
      "rawHtsCode": "8523.49.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.51.0000",
      "rawHtsCode": "8523.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Solid-state non-volatile storage devices",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.52.00",
      "rawHtsCode": "8523.52.00",
      "superior": null,
      "indent": "2",
      "description": "\"Smart cards\"",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8523.52.0010",
      "rawHtsCode": "8523.52.00.10",
      "superior": null,
      "indent": "3",
      "description": "Unrecorded",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.52.0090",
      "rawHtsCode": "8523.52.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.59.0000",
      "rawHtsCode": "8523.59.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.80",
      "rawHtsCode": "8523.80",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8523.80.1000",
      "rawHtsCode": "8523.80.10.00",
      "superior": null,
      "indent": "2",
      "description": "Phonograph records",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8523.80.2000",
      "rawHtsCode": "8523.80.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8524",
      "rawHtsCode": "8524",
      "superior": null,
      "indent": "0",
      "description": "Flat panel display modules, whether or not incorporating touch-sensitive screens:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8524.11",
      "rawHtsCode": "8524.11",
      "superior": null,
      "indent": "2",
      "description": "Of liquid crystals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8524.11.1000",
      "rawHtsCode": "8524.11.10.00",
      "superior": null,
      "indent": "3",
      "description": "Flat panel display modules, other than flat panel display modules for articles of subheadings 8528.59, 8528.69, 8528.72 and 8528.73",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8524.11.9000",
      "rawHtsCode": "8524.11.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU, BH,CL, CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8524.12.0000",
      "rawHtsCode": "8524.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of organic light-emitting diodes (OLED)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8524.19.0000",
      "rawHtsCode": "8524.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8524.91",
      "rawHtsCode": "8524.91",
      "superior": null,
      "indent": "2",
      "description": "Of liquid crystals:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8524.91.1000",
      "rawHtsCode": "8524.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Flat panel display modules, other than flat panel display modules for articles of subheadings 8528.59, 8528.69, 8528.72 and 8528.73",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8524.91.9000",
      "rawHtsCode": "8524.91.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU, BH,CL, CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8524.92.0000",
      "rawHtsCode": "8524.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of organic light-emitting diodes (OLED)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8524.99.0000",
      "rawHtsCode": "8524.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525",
      "rawHtsCode": "8525",
      "superior": null,
      "indent": "0",
      "description": "Transmission apparatus for radio-broadcasting or television, whether or not incorporating reception apparatus or sound recording or reproducing apparatus; television cameras, digital cameras and video camera recorders:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.50",
      "rawHtsCode": "8525.50",
      "superior": null,
      "indent": "1",
      "description": "Transmission apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.50.1000",
      "rawHtsCode": "8525.50.10.00",
      "superior": null,
      "indent": "3",
      "description": "Set top boxes which have a communication function",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.50.30",
      "rawHtsCode": "8525.50.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525.50.3015",
      "rawHtsCode": "8525.50.30.15",
      "superior": null,
      "indent": "4",
      "description": "Apparatus for the reception of television signals relayed by television satellite",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.50.3035",
      "rawHtsCode": "8525.50.30.35",
      "superior": null,
      "indent": "5",
      "description": "Converters, decoders, preamplifiers, line amplifiers, distribution amplifiers and other amplifiers; directional couplers and other couplers; all the foregoing designed for cable or closed-circuit television applications",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.50.3040",
      "rawHtsCode": "8525.50.30.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.50.70",
      "rawHtsCode": "8525.50.70",
      "superior": null,
      "indent": "2",
      "description": "For radiobroadcasting",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525.50.7010",
      "rawHtsCode": "8525.50.70.10",
      "superior": null,
      "indent": "3",
      "description": "Transmitters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.50.7050",
      "rawHtsCode": "8525.50.70.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.60",
      "rawHtsCode": "8525.60",
      "superior": null,
      "indent": "1",
      "description": "Transmission apparatus incorporating reception apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.60.10",
      "rawHtsCode": "8525.60.10",
      "superior": null,
      "indent": "2",
      "description": "Transceivers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525.60.1010",
      "rawHtsCode": "8525.60.10.10",
      "superior": null,
      "indent": "3",
      "description": "Citizens Band (CB)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.60.1020",
      "rawHtsCode": "8525.60.10.20",
      "superior": null,
      "indent": "3",
      "description": "Low-power radiotelephonic transceivers operating on frequencies from 49.82 to <il>49.90 MHz</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.60.1030",
      "rawHtsCode": "8525.60.10.30",
      "superior": null,
      "indent": "4",
      "description": "Hand-held",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.60.1040",
      "rawHtsCode": "8525.60.10.40",
      "superior": null,
      "indent": "5",
      "description": "Marine VHF-FM",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.60.1050",
      "rawHtsCode": "8525.60.10.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.60.2000",
      "rawHtsCode": "8525.60.20.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525.81.0000",
      "rawHtsCode": "8525.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "High-speed goods as specified in subheading note 1 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525.82.0000",
      "rawHtsCode": "8525.82.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, radiation-hardened or radiation-tolerant goods as specified in subheading note 2 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525.83.0000",
      "rawHtsCode": "8525.83.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, night vision goods as specified in subheading note 3 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525.89",
      "rawHtsCode": "8525.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.89.1000",
      "rawHtsCode": "8525.89.10.00",
      "superior": null,
      "indent": "4",
      "description": "Gyrostabilized television cameras",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525.89.2000",
      "rawHtsCode": "8525.89.20.00",
      "superior": null,
      "indent": "4",
      "description": "Studio television cameras excluding shoulder-carried and other portable cameras ",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525.89.3000",
      "rawHtsCode": "8525.89.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525.89.4000",
      "rawHtsCode": "8525.89.40.00",
      "superior": null,
      "indent": "3",
      "description": "Digital still image video cameras ",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525.89.50",
      "rawHtsCode": "8525.89.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8525.89.5030",
      "rawHtsCode": "8525.89.50.30",
      "superior": null,
      "indent": "4",
      "description": "Camcorders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8525.89.5050",
      "rawHtsCode": "8525.89.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8526",
      "rawHtsCode": "8526",
      "superior": null,
      "indent": "0",
      "description": "Radar apparatus, radio navigational aid apparatus and radio remote control apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8526.10.00",
      "rawHtsCode": "8526.10.00",
      "superior": null,
      "indent": "1",
      "description": "Radar apparatus",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8526.10.0020",
      "rawHtsCode": "8526.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Designed for boat or ship installation",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8526.10.0040",
      "rawHtsCode": "8526.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8526.91.00",
      "rawHtsCode": "8526.91.00",
      "superior": null,
      "indent": "2",
      "description": "Radio navigational aid apparatus",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8526.91.0020",
      "rawHtsCode": "8526.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Reception only apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8526.91.0040",
      "rawHtsCode": "8526.91.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8526.92",
      "rawHtsCode": "8526.92",
      "superior": null,
      "indent": "2",
      "description": "Radio remote control apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8526.92.1000",
      "rawHtsCode": "8526.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "Radio remote control apparatus for video game consoles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8526.92.5000",
      "rawHtsCode": "8526.92.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8527",
      "rawHtsCode": "8527",
      "superior": null,
      "indent": "0",
      "description": "Reception apparatus for radiobroadcasting, whether or not combined, in the same housing, with sound recording or reproducing apparatus or a clock:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.12.0000",
      "rawHtsCode": "8527.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Pocket-size radio cassette players",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.13",
      "rawHtsCode": "8527.13",
      "superior": null,
      "indent": "2",
      "description": "Other apparatus combined with sound recording or reproducing apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.13.1100",
      "rawHtsCode": "8527.13.11.00",
      "superior": null,
      "indent": "3",
      "description": "Combinations incorporating tape players which are incapable of recording",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.13.20",
      "rawHtsCode": "8527.13.20",
      "superior": null,
      "indent": "4",
      "description": "Radio-tape recorder combinations",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.13.2015",
      "rawHtsCode": "8527.13.20.15",
      "superior": null,
      "indent": "5",
      "description": "Cassette type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.13.2025",
      "rawHtsCode": "8527.13.20.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.13.4000",
      "rawHtsCode": "8527.13.40.00",
      "superior": null,
      "indent": "4",
      "description": "Radio-phonograph combinations",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.13.60",
      "rawHtsCode": "8527.13.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.13.6040",
      "rawHtsCode": "8527.13.60.40",
      "superior": null,
      "indent": "5",
      "description": "Incorporating optical disc (including compact disc) players or recorders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.13.6080",
      "rawHtsCode": "8527.13.60.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.19",
      "rawHtsCode": "8527.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.19.1000",
      "rawHtsCode": "8527.19.10.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $40 each, incorporating a clock or clock-timer, not in combination with any other article, and not designed for motor vehicle installation",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.19.50",
      "rawHtsCode": "8527.19.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.19.5010",
      "rawHtsCode": "8527.19.50.10",
      "superior": null,
      "indent": "4",
      "description": "FM only or AM/FM only",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.19.5025",
      "rawHtsCode": "8527.19.50.25",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.21",
      "rawHtsCode": "8527.21",
      "superior": null,
      "indent": "2",
      "description": "Combined with sound recording or reproducing apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.21.1500",
      "rawHtsCode": "8527.21.15.00",
      "superior": null,
      "indent": "4",
      "description": "Combined with sound recording or reproducing apparatus capable of receiving and decoding digital radio data system signals",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8527.21.25",
      "rawHtsCode": "8527.21.25",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8527.21.2510",
      "rawHtsCode": "8527.21.25.10",
      "superior": null,
      "indent": "5",
      "description": "Incorporating optical disc (including compact disc) players or recorders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.21.2525",
      "rawHtsCode": "8527.21.25.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.21.40",
      "rawHtsCode": "8527.21.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8527.21.4040",
      "rawHtsCode": "8527.21.40.40",
      "superior": null,
      "indent": "4",
      "description": "Incorporating optical disc (including compact disc) players or recorders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.21.4080",
      "rawHtsCode": "8527.21.40.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.29",
      "rawHtsCode": "8527.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.29.4000",
      "rawHtsCode": "8527.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "FM only or AM/FM only",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8527.29.8000",
      "rawHtsCode": "8527.29.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8527.91",
      "rawHtsCode": "8527.91",
      "superior": null,
      "indent": "2",
      "description": "Combined with sound recording or reproducing apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.91.0500",
      "rawHtsCode": "8527.91.05.00",
      "superior": null,
      "indent": "3",
      "description": "Articles designed for connection to telegraphic or telephonic apparatus or instruments or to telegraphic or telephonic networks",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.91.4000",
      "rawHtsCode": "8527.91.40.00",
      "superior": null,
      "indent": "4",
      "description": "Combinations incorporating tape players which are incapable of recording",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.91.5000",
      "rawHtsCode": "8527.91.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other combinations incorporating tape recorders",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8527.91.60",
      "rawHtsCode": "8527.91.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8527.91.6040",
      "rawHtsCode": "8527.91.60.40",
      "superior": null,
      "indent": "5",
      "description": "Incorporating optical disc (including compact disc) players or recorders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.91.6080",
      "rawHtsCode": "8527.91.60.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.92",
      "rawHtsCode": "8527.92",
      "superior": null,
      "indent": "2",
      "description": "Not combined with sound recording or reproducing apparatus but combined with a clock:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.92.1000",
      "rawHtsCode": "8527.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $40 each",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.92.5000",
      "rawHtsCode": "8527.92.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.99",
      "rawHtsCode": "8527.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.99.1000",
      "rawHtsCode": "8527.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Infant nursery monitor systems, each consisting in the same package of a radio transmitter, an electrical adapter, and a radio receiver",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8527.99.1500",
      "rawHtsCode": "8527.99.15.00",
      "superior": null,
      "indent": "3",
      "description": "Other radio receivers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8527.99.4000",
      "rawHtsCode": "8527.99.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528",
      "rawHtsCode": "8528",
      "superior": null,
      "indent": "0",
      "description": "Monitors and projectors, not incorporating television reception apparatus; reception apparatus for television, whether or not incorporating radio-broadcast receivers or sound or video recording or reproducing apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.42.0000",
      "rawHtsCode": "8528.42.00.00",
      "superior": null,
      "indent": "2",
      "description": "Capable of directly connecting to and designed for use with an automatic data processing machine of heading 8471",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49",
      "rawHtsCode": "8528.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.49.0500",
      "rawHtsCode": "8528.49.05.00",
      "superior": null,
      "indent": "5",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.1000",
      "rawHtsCode": "8528.49.10.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.1500",
      "rawHtsCode": "8528.49.15.00",
      "superior": null,
      "indent": "6",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.2000",
      "rawHtsCode": "8528.49.20.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.2500",
      "rawHtsCode": "8528.49.25.00",
      "superior": null,
      "indent": "6",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.3000",
      "rawHtsCode": "8528.49.30.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.3500",
      "rawHtsCode": "8528.49.35.00",
      "superior": null,
      "indent": "5",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.4000",
      "rawHtsCode": "8528.49.40.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.4500",
      "rawHtsCode": "8528.49.45.00",
      "superior": null,
      "indent": "5",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.5000",
      "rawHtsCode": "8528.49.50.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.6000",
      "rawHtsCode": "8528.49.60.00",
      "superior": null,
      "indent": "5",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.6500",
      "rawHtsCode": "8528.49.65.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.7000",
      "rawHtsCode": "8528.49.70.00",
      "superior": null,
      "indent": "5",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.7500",
      "rawHtsCode": "8528.49.75.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.49.8000",
      "rawHtsCode": "8528.49.80.00",
      "superior": null,
      "indent": "3",
      "description": "Black and white or other monochrome",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.52.0000",
      "rawHtsCode": "8528.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "Capable of directly connecting to and designed for use with an automatic data processing machine of heading 8471",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.59",
      "rawHtsCode": "8528.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.59.0500",
      "rawHtsCode": "8528.59.05.00",
      "superior": null,
      "indent": "5",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.59.1000",
      "rawHtsCode": "8528.59.10.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.59.1500",
      "rawHtsCode": "8528.59.15.00",
      "superior": null,
      "indent": "6",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.59.2300",
      "rawHtsCode": "8528.59.23.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.59.2500",
      "rawHtsCode": "8528.59.25.00",
      "superior": null,
      "indent": "6",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.59.33",
      "rawHtsCode": "8528.59.33",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.59.3310",
      "rawHtsCode": "8528.59.33.10",
      "superior": null,
      "indent": "7",
      "description": "Plasma-type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.59.3350",
      "rawHtsCode": "8528.59.33.50",
      "superior": null,
      "indent": "7",
      "description": "LCD-type (direct view)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.59.3370",
      "rawHtsCode": "8528.59.33.70",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.59.3500",
      "rawHtsCode": "8528.59.35.00",
      "superior": null,
      "indent": "6",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.59.4000",
      "rawHtsCode": "8528.59.40.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.59.4500",
      "rawHtsCode": "8528.59.45.00",
      "superior": null,
      "indent": "6",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.59.5000",
      "rawHtsCode": "8528.59.50.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.59.6000",
      "rawHtsCode": "8528.59.60.00",
      "superior": null,
      "indent": "3",
      "description": "Black and white or other monochrome",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.62.0000",
      "rawHtsCode": "8528.62.00.00",
      "superior": null,
      "indent": "2",
      "description": "Capable of directly connecting to and designed for use with an automatic data processing machine of heading 8471",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.69",
      "rawHtsCode": "8528.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.69.0500",
      "rawHtsCode": "8528.69.05.00",
      "superior": null,
      "indent": "5",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.69.1000",
      "rawHtsCode": "8528.69.10.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.69.1500",
      "rawHtsCode": "8528.69.15.00",
      "superior": null,
      "indent": "5",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.69.2000",
      "rawHtsCode": "8528.69.20.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.69.2500",
      "rawHtsCode": "8528.69.25.00",
      "superior": null,
      "indent": "5",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.69.3000",
      "rawHtsCode": "8528.69.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.69.3500",
      "rawHtsCode": "8528.69.35.00",
      "superior": null,
      "indent": "6",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.69.4000",
      "rawHtsCode": "8528.69.40.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.69.4500",
      "rawHtsCode": "8528.69.45.00",
      "superior": null,
      "indent": "6",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.69.5000",
      "rawHtsCode": "8528.69.50.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.69.5500",
      "rawHtsCode": "8528.69.55.00",
      "superior": null,
      "indent": "5",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.69.6000",
      "rawHtsCode": "8528.69.60.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.69.7000",
      "rawHtsCode": "8528.69.70.00",
      "superior": null,
      "indent": "3",
      "description": "Black and white or other monochrome",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.71",
      "rawHtsCode": "8528.71",
      "superior": null,
      "indent": "2",
      "description": "Not designed to incorporate a video display or screen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.71.1000",
      "rawHtsCode": "8528.71.10.00",
      "superior": null,
      "indent": "3",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.71.2000",
      "rawHtsCode": "8528.71.20.00",
      "superior": null,
      "indent": "4",
      "description": "Set top boxes which have a communications function",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.71.3000",
      "rawHtsCode": "8528.71.30.00",
      "superior": null,
      "indent": "4",
      "description": "Printed circuit assemblies incorporating a tuner, of a kind used with data processing machines of heading 8471",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.71.4000",
      "rawHtsCode": "8528.71.40.00",
      "superior": null,
      "indent": "5",
      "description": "Color",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.71.4500",
      "rawHtsCode": "8528.71.45.00",
      "superior": null,
      "indent": "5",
      "description": "Black and white or other monochrome",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.72",
      "rawHtsCode": "8528.72",
      "superior": null,
      "indent": "2",
      "description": "Other, color:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.72.0400",
      "rawHtsCode": "8528.72.04.00",
      "superior": null,
      "indent": "4",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.72.0800",
      "rawHtsCode": "8528.72.08.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.72.1200",
      "rawHtsCode": "8528.72.12.00",
      "superior": null,
      "indent": "5",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.72.1600",
      "rawHtsCode": "8528.72.16.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.2000",
      "rawHtsCode": "8528.72.20.00",
      "superior": null,
      "indent": "5",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8528.72.2400",
      "rawHtsCode": "8528.72.24.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.2800",
      "rawHtsCode": "8528.72.28.00",
      "superior": null,
      "indent": "4",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.3200",
      "rawHtsCode": "8528.72.32.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.3600",
      "rawHtsCode": "8528.72.36.00",
      "superior": null,
      "indent": "4",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.4000",
      "rawHtsCode": "8528.72.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.4400",
      "rawHtsCode": "8528.72.44.00",
      "superior": null,
      "indent": "4",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.4800",
      "rawHtsCode": "8528.72.48.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.5200",
      "rawHtsCode": "8528.72.52.00",
      "superior": null,
      "indent": "4",
      "description": "Incorporating video recording or reproducing apparatus",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.5600",
      "rawHtsCode": "8528.72.56.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.6200",
      "rawHtsCode": "8528.72.62.00",
      "superior": null,
      "indent": "5",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.72.64",
      "rawHtsCode": "8528.72.64",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.6420",
      "rawHtsCode": "8528.72.64.20",
      "superior": null,
      "indent": "7",
      "description": "Not exceeding 75 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.72.6430",
      "rawHtsCode": "8528.72.64.30",
      "superior": null,
      "indent": "7",
      "description": "Exceeding 75 cm but not exceeding 88 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.72.6440",
      "rawHtsCode": "8528.72.64.40",
      "superior": null,
      "indent": "7",
      "description": "Exceeding 88 cm but not exceeding 113 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.72.6460",
      "rawHtsCode": "8528.72.64.60",
      "superior": null,
      "indent": "7",
      "description": "Exceeding 113 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.72.6800",
      "rawHtsCode": "8528.72.68.00",
      "superior": null,
      "indent": "5",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.72.72",
      "rawHtsCode": "8528.72.72",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.7220",
      "rawHtsCode": "8528.72.72.20",
      "superior": null,
      "indent": "7",
      "description": "Not exceeding 75 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.72.7230",
      "rawHtsCode": "8528.72.72.30",
      "superior": null,
      "indent": "7",
      "description": "Exceeding 75 cm but not exceeding 88 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.72.7240",
      "rawHtsCode": "8528.72.72.40",
      "superior": null,
      "indent": "7",
      "description": "Exceeding 88 cm but not exceeding 113 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.72.7260",
      "rawHtsCode": "8528.72.72.60",
      "superior": null,
      "indent": "7",
      "description": "Exceeding 113 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.72.7290",
      "rawHtsCode": "8528.72.72.90",
      "superior": null,
      "indent": "6",
      "description": "Other, including plasma-type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8528.72.7600",
      "rawHtsCode": "8528.72.76.00",
      "superior": null,
      "indent": "5",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.72.8000",
      "rawHtsCode": "8528.72.80.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.72.8400",
      "rawHtsCode": "8528.72.84.00",
      "superior": null,
      "indent": "5",
      "description": "With a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8528.72.9700",
      "rawHtsCode": "8528.72.97.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8528.73.0000",
      "rawHtsCode": "8528.73.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, monochrome",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8529",
      "rawHtsCode": "8529",
      "superior": null,
      "indent": "0",
      "description": "Parts suitable for use solely or principally with the apparatus of headings 8524 to 8528:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.10",
      "rawHtsCode": "8529.10",
      "superior": null,
      "indent": "1",
      "description": "Antennas and antenna reflectors of all kinds; parts suitable for use therewith:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.10.21",
      "rawHtsCode": "8529.10.21",
      "superior": null,
      "indent": "2",
      "description": "Television",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8529.10.2120",
      "rawHtsCode": "8529.10.21.20",
      "superior": null,
      "indent": "4",
      "description": "Receiving only",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.10.2150",
      "rawHtsCode": "8529.10.21.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.10.2190",
      "rawHtsCode": "8529.10.21.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.10.40",
      "rawHtsCode": "8529.10.40",
      "superior": null,
      "indent": "2",
      "description": "Radar, radio navigational aid and radio remote control",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8529.10.4040",
      "rawHtsCode": "8529.10.40.40",
      "superior": null,
      "indent": "3",
      "description": "Antennas",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.10.4080",
      "rawHtsCode": "8529.10.40.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.10.9100",
      "rawHtsCode": "8529.10.91.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90",
      "rawHtsCode": "8529.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.0400",
      "rawHtsCode": "8529.90.04.00",
      "superior": null,
      "indent": "4",
      "description": "Tuners",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.0500",
      "rawHtsCode": "8529.90.05.00",
      "superior": null,
      "indent": "5",
      "description": "Entered with components enumerated in additional U.S. note 4 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "Report quantity as indicated in additional U.S. note 4(b) to this chapter. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.0600",
      "rawHtsCode": "8529.90.06.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01.",
        "Report quantity as indicated in additional U.S. note 4(b) to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.0900",
      "rawHtsCode": "8529.90.09.00",
      "superior": null,
      "indent": "5",
      "description": "For television cameras",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.1300",
      "rawHtsCode": "8529.90.13.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.16",
      "rawHtsCode": "8529.90.16",
      "superior": null,
      "indent": "4",
      "description": "Assemblies and subassemblies, consisting of 2 or more parts or pieces fastened or joined together",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.1620",
      "rawHtsCode": "8529.90.16.20",
      "superior": null,
      "indent": "5",
      "description": "Of radar apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.1640",
      "rawHtsCode": "8529.90.16.40",
      "superior": null,
      "indent": "5",
      "description": "Of radio navigational aid apparatus (except radar)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.1660",
      "rawHtsCode": "8529.90.16.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.19",
      "rawHtsCode": "8529.90.19",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.1920",
      "rawHtsCode": "8529.90.19.20",
      "superior": null,
      "indent": "5",
      "description": "Of radar apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.1940",
      "rawHtsCode": "8529.90.19.40",
      "superior": null,
      "indent": "5",
      "description": "Of radio navigational aid apparatus (except radar)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.1960",
      "rawHtsCode": "8529.90.19.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.2100",
      "rawHtsCode": "8529.90.21.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.2401",
      "rawHtsCode": "8529.90.24.01",
      "superior": null,
      "indent": "2",
      "description": "Transceiver assemblies for the apparatus of subheading 8526.10, other than printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.2900",
      "rawHtsCode": "8529.90.29.00",
      "superior": null,
      "indent": "3",
      "description": "Tuners",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.3300",
      "rawHtsCode": "8529.90.33.00",
      "superior": null,
      "indent": "4",
      "description": "Entered with components enumerated in additional U.S. note 4 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "Report quantity as indicated in additional U.S. note 4(b) to this chapter.",
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.3600",
      "rawHtsCode": "8529.90.36.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "Report quantity as indicated in additional U.S. note 4(b) to this chapter.",
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.3900",
      "rawHtsCode": "8529.90.39.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.4300",
      "rawHtsCode": "8529.90.43.00",
      "superior": null,
      "indent": "4",
      "description": "Entered with components enumerated in additional U.S. note 4 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "Report quantity as indicated in additional U.S. note 4(b) to this chapter.",
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.4600",
      "rawHtsCode": "8529.90.46.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "Report quantity as indicated in additional U.S. note 4(b) to this chapter.",
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.4900",
      "rawHtsCode": "8529.90.49.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.5500",
      "rawHtsCode": "8529.90.55.00",
      "superior": null,
      "indent": "2",
      "description": "Flat panel screen assemblies for the apparatus of subheadings 8528.59.15, 8528.59.23, 8528.59.25, 8528.59.33, 8528.69.35, 8525.69.40, 8528.69.45, 8528.69.50, 8528.72.62, 8528.72.64, 8528.72.68 and 8528.72.72",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.6300",
      "rawHtsCode": "8529.90.63.00",
      "superior": null,
      "indent": "4",
      "description": "For television cameras",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.6800",
      "rawHtsCode": "8529.90.68.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.7300",
      "rawHtsCode": "8529.90.73.00",
      "superior": null,
      "indent": "3",
      "description": "Of radar, radio navigational aid or radio remote control apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.7700",
      "rawHtsCode": "8529.90.77.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.7800",
      "rawHtsCode": "8529.90.78.00",
      "superior": null,
      "indent": "5",
      "description": "Mounted lenses suitable for use in, and entered separately from, closed-circuit television cameras, with or without attached electrical or non-electrical closed-circuit television camera connectors, and with or without attached motors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.8100",
      "rawHtsCode": "8529.90.81.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.8300",
      "rawHtsCode": "8529.90.83.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.8700",
      "rawHtsCode": "8529.90.87.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.8800",
      "rawHtsCode": "8529.90.88.00",
      "superior": null,
      "indent": "5",
      "description": "Entered with components enumerated in additional U.S. note 4 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.",
        "Report quantity as indicated in additional U.S. note 4(b) to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.8900",
      "rawHtsCode": "8529.90.89.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "Report quantity as indicated in additional U.S. note 4(b) to this chapter.",
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.93",
      "rawHtsCode": "8529.90.93",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.9345",
      "rawHtsCode": "8529.90.93.45",
      "superior": null,
      "indent": "5",
      "description": "Convergence assemblies, focus coils and degaussing coils",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.9380",
      "rawHtsCode": "8529.90.93.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.95",
      "rawHtsCode": "8529.90.95",
      "superior": null,
      "indent": "4",
      "description": "Assemblies and subassemblies, consisting of 2 or more parts or pieces fastened or joined together",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.9520",
      "rawHtsCode": "8529.90.95.20",
      "superior": null,
      "indent": "5",
      "description": "Of radar apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.9540",
      "rawHtsCode": "8529.90.95.40",
      "superior": null,
      "indent": "5",
      "description": "Of radio navigational aid apparatus (except radar)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.9560",
      "rawHtsCode": "8529.90.95.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.97",
      "rawHtsCode": "8529.90.97",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8529.90.9720",
      "rawHtsCode": "8529.90.97.20",
      "superior": null,
      "indent": "5",
      "description": "Of radar apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.9740",
      "rawHtsCode": "8529.90.97.40",
      "superior": null,
      "indent": "5",
      "description": "Of radio navigational aid apparatus (except radar)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.9760",
      "rawHtsCode": "8529.90.97.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8529.90.9800",
      "rawHtsCode": "8529.90.98.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8530",
      "rawHtsCode": "8530",
      "superior": null,
      "indent": "0",
      "description": "Electrical signaling, safety or traffic control equipment for railways, streetcar lines, subways, roads, inland waterways, parking facilities, port installations or airfields (other than those of heading 8608); parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8530.10.0000",
      "rawHtsCode": "8530.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Equipment for railways, streetcar lines or subways",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8530.80.0000",
      "rawHtsCode": "8530.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other equipment",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8530.90.0000",
      "rawHtsCode": "8530.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8531",
      "rawHtsCode": "8531",
      "superior": null,
      "indent": "0",
      "description": "Electric sound or visual signaling apparatus (for example, bells, sirens, indicator panels, burglar or fire alarms), other than those of heading 8512 or 8530; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.10.00",
      "rawHtsCode": "8531.10.00",
      "superior": null,
      "indent": "1",
      "description": "Burglar or fire alarms and similar apparatus",
      "units": [],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8531.10.0015",
      "rawHtsCode": "8531.10.00.15",
      "superior": null,
      "indent": "3",
      "description": "Battery powered",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.10.0025",
      "rawHtsCode": "8531.10.00.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.10.0035",
      "rawHtsCode": "8531.10.00.35",
      "superior": null,
      "indent": "3",
      "description": "Burglar alarms",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.10.0045",
      "rawHtsCode": "8531.10.00.45",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.20.00",
      "rawHtsCode": "8531.20.00",
      "superior": null,
      "indent": "1",
      "description": "Indicator panels incorporating liquid crystal devices (LCD's) or light emitting diodes (LED)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8531.20.0020",
      "rawHtsCode": "8531.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Incorporating LCD's",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.20.0040",
      "rawHtsCode": "8531.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.80",
      "rawHtsCode": "8531.80",
      "superior": null,
      "indent": "1",
      "description": "Other apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.80.1500",
      "rawHtsCode": "8531.80.15.00",
      "superior": null,
      "indent": "2",
      "description": "Doorbells, chimes, buzzers and similar apparatus",
      "units": [
        "kg"
      ],
      "generalRate": "1.3%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8531.80.90",
      "rawHtsCode": "8531.80.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8531.80.9005",
      "rawHtsCode": "8531.80.90.05",
      "superior": null,
      "indent": "4",
      "description": "Incorporating electric discharge (fluorescent) devices",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.80.9026",
      "rawHtsCode": "8531.80.90.26",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.80.9031",
      "rawHtsCode": "8531.80.90.31",
      "superior": null,
      "indent": "3",
      "description": "Horns",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.80.9041",
      "rawHtsCode": "8531.80.90.41",
      "superior": null,
      "indent": "3",
      "description": "Other sound signaling apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.80.9051",
      "rawHtsCode": "8531.80.90.51",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.90",
      "rawHtsCode": "8531.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8531.90.1500",
      "rawHtsCode": "8531.90.15.00",
      "superior": null,
      "indent": "3",
      "description": "Of the panels of subheading 8531.20",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8531.90.3000",
      "rawHtsCode": "8531.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8531.90.7500",
      "rawHtsCode": "8531.90.75.00",
      "superior": null,
      "indent": "3",
      "description": "Of the panels of subheading 8531.20",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8531.90.9001",
      "rawHtsCode": "8531.90.90.01",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8532",
      "rawHtsCode": "8532",
      "superior": null,
      "indent": "0",
      "description": "Electrical capacitors, fixed, variable or adjustable (pre-set); parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.10.0000",
      "rawHtsCode": "8532.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Fixed capacitors designed for use in <il>50/60 Hz</il> circuits and having a reactive power handling capacity of not less than <il>0.5 kvar (power capacitors)</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8532.21.00",
      "rawHtsCode": "8532.21.00",
      "superior": null,
      "indent": "2",
      "description": "Tantalum",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8532.21.0020",
      "rawHtsCode": "8532.21.00.20",
      "superior": null,
      "indent": "3",
      "description": "Metal case",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.21.0040",
      "rawHtsCode": "8532.21.00.40",
      "superior": null,
      "indent": "4",
      "description": "Dipped",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.21.0050",
      "rawHtsCode": "8532.21.00.50",
      "superior": null,
      "indent": "4",
      "description": "Designed for surface mounting (SMD) by contact",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.21.0080",
      "rawHtsCode": "8532.21.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.22.00",
      "rawHtsCode": "8532.22.00",
      "superior": null,
      "indent": "2",
      "description": "Aluminum electrolytic",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8532.22.0020",
      "rawHtsCode": "8532.22.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not exceeding 18 mm in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 6 to this chapter. "
      ],
      "flags": []
    },
    {
      "htsCode": "8532.22.0040",
      "rawHtsCode": "8532.22.00.40",
      "superior": null,
      "indent": "3",
      "description": "Exceeding 18 mm but not exceeding 35 mm in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 6 to this chapter. "
      ],
      "flags": []
    },
    {
      "htsCode": "8532.22.0055",
      "rawHtsCode": "8532.22.00.55",
      "superior": null,
      "indent": "3",
      "description": "Exceeding 35 mm but not exceeding 51 mm in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 6 to this chapter.  "
      ],
      "flags": []
    },
    {
      "htsCode": "8532.22.0085",
      "rawHtsCode": "8532.22.00.85",
      "superior": null,
      "indent": "3",
      "description": "Exceeding 51 mm in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 6 to this chapter. "
      ],
      "flags": []
    },
    {
      "htsCode": "8532.23.00",
      "rawHtsCode": "8532.23.00",
      "superior": null,
      "indent": "2",
      "description": "Ceramic dielectric, single layer",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8532.23.0020",
      "rawHtsCode": "8532.23.00.20",
      "superior": null,
      "indent": "3",
      "description": "Chips",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.23.0040",
      "rawHtsCode": "8532.23.00.40",
      "superior": null,
      "indent": "4",
      "description": "Axial leads",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.23.0060",
      "rawHtsCode": "8532.23.00.60",
      "superior": null,
      "indent": "4",
      "description": "Radial leads",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.24.00",
      "rawHtsCode": "8532.24.00",
      "superior": null,
      "indent": "2",
      "description": "Ceramic dielectric, multilayer",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8532.24.0020",
      "rawHtsCode": "8532.24.00.20",
      "superior": null,
      "indent": "3",
      "description": "Chips",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.24.0040",
      "rawHtsCode": "8532.24.00.40",
      "superior": null,
      "indent": "4",
      "description": "Axial leads",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.24.0060",
      "rawHtsCode": "8532.24.00.60",
      "superior": null,
      "indent": "4",
      "description": "Radial leads",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.25.00",
      "rawHtsCode": "8532.25.00",
      "superior": null,
      "indent": "2",
      "description": "Dielectric of paper or plastics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8532.25.0010",
      "rawHtsCode": "8532.25.00.10",
      "superior": null,
      "indent": "4",
      "description": "Less than 300 V",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.25.0020",
      "rawHtsCode": "8532.25.00.20",
      "superior": null,
      "indent": "4",
      "description": "300 V or greater, but less than <il>600 V</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.25.0030",
      "rawHtsCode": "8532.25.00.30",
      "superior": null,
      "indent": "4",
      "description": "600 V or greater, but less than <il>1,000 V</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.25.0040",
      "rawHtsCode": "8532.25.00.40",
      "superior": null,
      "indent": "4",
      "description": "<il>1,000 V</il> or greater",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.25.0045",
      "rawHtsCode": "8532.25.00.45",
      "superior": null,
      "indent": "5",
      "description": "Designed for surface mounting (SMD) by contact",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.25.0055",
      "rawHtsCode": "8532.25.00.55",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.25.0060",
      "rawHtsCode": "8532.25.00.60",
      "superior": null,
      "indent": "4",
      "description": "Axial leads",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.25.0070",
      "rawHtsCode": "8532.25.00.70",
      "superior": null,
      "indent": "4",
      "description": "Radial leads",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.25.0080",
      "rawHtsCode": "8532.25.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.29.00",
      "rawHtsCode": "8532.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8532.29.0020",
      "rawHtsCode": "8532.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Mica dielectric",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.29.0040",
      "rawHtsCode": "8532.29.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.30.00",
      "rawHtsCode": "8532.30.00",
      "superior": null,
      "indent": "1",
      "description": "Variable or adjustable (pre-set) capacitors",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8532.30.0010",
      "rawHtsCode": "8532.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Mica, ceramic or glass dielectric",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.30.0090",
      "rawHtsCode": "8532.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8532.90.0000",
      "rawHtsCode": "8532.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8533",
      "rawHtsCode": "8533",
      "superior": null,
      "indent": "0",
      "description": "Electrical resistors (including rheostats and potentiometers), other than heating resistors; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.10.00",
      "rawHtsCode": "8533.10.00",
      "superior": null,
      "indent": "1",
      "description": "Fixed carbon resistors, composition or film types",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8533.10.0020",
      "rawHtsCode": "8533.10.00.20",
      "superior": null,
      "indent": "3",
      "description": "Having more than two terminals (resistor networks)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.10.0042",
      "rawHtsCode": "8533.10.00.42",
      "superior": null,
      "indent": "3",
      "description": "Having two terminals",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.10.0057",
      "rawHtsCode": "8533.10.00.57",
      "superior": null,
      "indent": "2",
      "description": "Having more than two leads (resistor networks)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.10.0060",
      "rawHtsCode": "8533.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Carbon composition",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.10.0065",
      "rawHtsCode": "8533.10.00.65",
      "superior": null,
      "indent": "3",
      "description": "Carbon film",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.21.00",
      "rawHtsCode": "8533.21.00",
      "superior": null,
      "indent": "2",
      "description": "For a power handling capacity not exceeding <il>20 W</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8533.21.0010",
      "rawHtsCode": "8533.21.00.10",
      "superior": null,
      "indent": "5",
      "description": "Dual-in-line package",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.21.0020",
      "rawHtsCode": "8533.21.00.20",
      "superior": null,
      "indent": "5",
      "description": "Other (including flat packs)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.21.0030",
      "rawHtsCode": "8533.21.00.30",
      "superior": null,
      "indent": "5",
      "description": "Flat resistor chips",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.21.0040",
      "rawHtsCode": "8533.21.00.40",
      "superior": null,
      "indent": "5",
      "description": "Cylindrical leadless resistors (including metal film, metal oxide and thick cement film)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.21.0050",
      "rawHtsCode": "8533.21.00.50",
      "superior": null,
      "indent": "4",
      "description": "Single-in-line",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.21.0060",
      "rawHtsCode": "8533.21.00.60",
      "superior": null,
      "indent": "4",
      "description": "Dual-in-line",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.21.0070",
      "rawHtsCode": "8533.21.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.21.0080",
      "rawHtsCode": "8533.21.00.80",
      "superior": null,
      "indent": "4",
      "description": "Wirewound",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.21.0090",
      "rawHtsCode": "8533.21.00.90",
      "superior": null,
      "indent": "4",
      "description": "Other (including metal film, metal oxide and thick cement film)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.29.0000",
      "rawHtsCode": "8533.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8533.31.0000",
      "rawHtsCode": "8533.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "For a power handling capacity not exceeding <il>20 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8533.39.00",
      "rawHtsCode": "8533.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8533.39.0040",
      "rawHtsCode": "8533.39.00.40",
      "superior": null,
      "indent": "3",
      "description": "Dimmers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.39.0080",
      "rawHtsCode": "8533.39.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.40",
      "rawHtsCode": "8533.40",
      "superior": null,
      "indent": "1",
      "description": "Other variable resistors, including rheostats and potentiometers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.40.4000",
      "rawHtsCode": "8533.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "Metal oxide varistors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8533.40.80",
      "rawHtsCode": "8533.40.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8533.40.8040",
      "rawHtsCode": "8533.40.80.40",
      "superior": null,
      "indent": "3",
      "description": "Rheostat and resistor type motor starters and controllers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.40.8050",
      "rawHtsCode": "8533.40.80.50",
      "superior": null,
      "indent": "4",
      "description": "Cermet",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.40.8060",
      "rawHtsCode": "8533.40.80.60",
      "superior": null,
      "indent": "4",
      "description": "Metal glaze",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.40.8070",
      "rawHtsCode": "8533.40.80.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.90",
      "rawHtsCode": "8533.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8533.90.4000",
      "rawHtsCode": "8533.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "For the goods of subheading 8533.40, of ceramic or metallic materials, electrically or mechanically reactive to changes in temperature",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8533.90.8000",
      "rawHtsCode": "8533.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8534.00.00",
      "rawHtsCode": "8534.00.00",
      "superior": null,
      "indent": "0",
      "description": "Printed circuits",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8534.00.0020",
      "rawHtsCode": "8534.00.00.20",
      "superior": null,
      "indent": "3",
      "description": "With 3 or more layers of conducting materials",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8534.00.0040",
      "rawHtsCode": "8534.00.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8534.00.0050",
      "rawHtsCode": "8534.00.00.50",
      "superior": null,
      "indent": "2",
      "description": "Having a base wholly of impregnated paper",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8534.00.0070",
      "rawHtsCode": "8534.00.00.70",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8534.00.0080",
      "rawHtsCode": "8534.00.00.80",
      "superior": null,
      "indent": "2",
      "description": "Flexible type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8534.00.0085",
      "rawHtsCode": "8534.00.00.85",
      "superior": null,
      "indent": "2",
      "description": "Other, having a ceramic base",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8534.00.0095",
      "rawHtsCode": "8534.00.00.95",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8535",
      "rawHtsCode": "8535",
      "superior": null,
      "indent": "0",
      "description": "Electrical apparatus for switching or protecting electrical circuits, or for making connections to or in electrical circuits (for example, switches, fuses, lightning arresters, voltage limiters, surge suppressors, plugs and other connectors, junction boxes), for a voltage exceeding <il>1,000 V</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8535.10.00",
      "rawHtsCode": "8535.10.00",
      "superior": null,
      "indent": "1",
      "description": "Fuses",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8535.10.0020",
      "rawHtsCode": "8535.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "In circuits of 2,300 V or more",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8535.10.0040",
      "rawHtsCode": "8535.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8535.21.0000",
      "rawHtsCode": "8535.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "For a voltage of less than <il>72.5 kV</il>",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8535.29.00",
      "rawHtsCode": "8535.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8535.29.0020",
      "rawHtsCode": "8535.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "In circuits of <il>345 kV</il> or more",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8535.29.0040",
      "rawHtsCode": "8535.29.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8535.30.00",
      "rawHtsCode": "8535.30.00",
      "superior": null,
      "indent": "1",
      "description": "Isolating switches and make-and-break switches",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8535.30.0040",
      "rawHtsCode": "8535.30.00.40",
      "superior": null,
      "indent": "2",
      "description": "Knife",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8535.30.0080",
      "rawHtsCode": "8535.30.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8535.40.0000",
      "rawHtsCode": "8535.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Lightning arresters, voltage limiters and surge suppressors",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8535.90",
      "rawHtsCode": "8535.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8535.90.4000",
      "rawHtsCode": "8535.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Motor starters and motor overload protectors",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8535.90.80",
      "rawHtsCode": "8535.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8535.90.8020",
      "rawHtsCode": "8535.90.80.20",
      "superior": null,
      "indent": "3",
      "description": "Terminals, electrical splices and electrical couplings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8535.90.8040",
      "rawHtsCode": "8535.90.80.40",
      "superior": null,
      "indent": "3",
      "description": "Other connectors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8535.90.8060",
      "rawHtsCode": "8535.90.80.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536",
      "rawHtsCode": "8536",
      "superior": null,
      "indent": "0",
      "description": "Electrical apparatus for switching or protecting electrical circuits, or for making connections to or in electrical circuits (for example, switches, relays, fuses, surge suppressors, plugs, sockets, lamp-holders and other connectors, junction boxes), for a voltage not exceeding <il>1,000 V</il>; connectors for optical fibers, optical fiber bundles or cables:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.10.00",
      "rawHtsCode": "8536.10.00",
      "superior": null,
      "indent": "1",
      "description": "Fuses",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8536.10.0020",
      "rawHtsCode": "8536.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Glass cartridge",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.10.0040",
      "rawHtsCode": "8536.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.20.00",
      "rawHtsCode": "8536.20.00",
      "superior": null,
      "indent": "1",
      "description": "Automatic circuit breakers",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8536.20.0020",
      "rawHtsCode": "8536.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Molded case",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.20.0040",
      "rawHtsCode": "8536.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.30",
      "rawHtsCode": "8536.30",
      "superior": null,
      "indent": "1",
      "description": "Other apparatus for protecting electrical circuits:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.30.4000",
      "rawHtsCode": "8536.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Motor overload protectors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8536.30.8000",
      "rawHtsCode": "8536.30.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8536.41.00",
      "rawHtsCode": "8536.41.00",
      "superior": null,
      "indent": "2",
      "description": "For a voltage not exceeding 60 V",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8536.41.0005",
      "rawHtsCode": "8536.41.00.05",
      "superior": null,
      "indent": "3",
      "description": "Automotive signaling flashers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.41.0020",
      "rawHtsCode": "8536.41.00.20",
      "superior": null,
      "indent": "5",
      "description": "Electromechanical",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.41.0030",
      "rawHtsCode": "8536.41.00.30",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.41.0045",
      "rawHtsCode": "8536.41.00.45",
      "superior": null,
      "indent": "5",
      "description": "Contactors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.41.0050",
      "rawHtsCode": "8536.41.00.50",
      "superior": null,
      "indent": "6",
      "description": "Electromechanical",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.41.0060",
      "rawHtsCode": "8536.41.00.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.49.00",
      "rawHtsCode": "8536.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8536.49.0050",
      "rawHtsCode": "8536.49.00.50",
      "superior": null,
      "indent": "4",
      "description": "Electromechanical",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.49.0055",
      "rawHtsCode": "8536.49.00.55",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.49.0065",
      "rawHtsCode": "8536.49.00.65",
      "superior": null,
      "indent": "4",
      "description": "Contactors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.49.0075",
      "rawHtsCode": "8536.49.00.75",
      "superior": null,
      "indent": "5",
      "description": "Electromechanical",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.49.0080",
      "rawHtsCode": "8536.49.00.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.50",
      "rawHtsCode": "8536.50",
      "superior": null,
      "indent": "1",
      "description": "Other switches:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.50.4000",
      "rawHtsCode": "8536.50.40.00",
      "superior": null,
      "indent": "2",
      "description": "Motor starters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8536.50.7000",
      "rawHtsCode": "8536.50.70.00",
      "superior": null,
      "indent": "3",
      "description": "Electronic AC switches consisting of optically coupled input and output circuits (insulated thyristor AC switches); electronic switches, including temperature protected switches, consisting of a transistor and a logic chip (chip-on-chip technology); electromechanical snap-action switches for a current not exceeding 11 amps",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8536.50.90",
      "rawHtsCode": "8536.50.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8536.50.9020",
      "rawHtsCode": "8536.50.90.20",
      "superior": null,
      "indent": "5",
      "description": "Rated at not over 5 A",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.50.9025",
      "rawHtsCode": "8536.50.90.25",
      "superior": null,
      "indent": "5",
      "description": "Rated at over 5 A",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.50.9031",
      "rawHtsCode": "8536.50.90.31",
      "superior": null,
      "indent": "6",
      "description": "Momentary contact",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.50.9032",
      "rawHtsCode": "8536.50.90.32",
      "superior": null,
      "indent": "6",
      "description": "Other, gang switches",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.50.9033",
      "rawHtsCode": "8536.50.90.33",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.50.9035",
      "rawHtsCode": "8536.50.90.35",
      "superior": null,
      "indent": "5",
      "description": "Rated at over 5 A",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.50.9040",
      "rawHtsCode": "8536.50.90.40",
      "superior": null,
      "indent": "4",
      "description": "Snap-action, other than limit",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.50.9045",
      "rawHtsCode": "8536.50.90.45",
      "superior": null,
      "indent": "4",
      "description": "Knife",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.50.9050",
      "rawHtsCode": "8536.50.90.50",
      "superior": null,
      "indent": "4",
      "description": "Slide",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.50.9055",
      "rawHtsCode": "8536.50.90.55",
      "superior": null,
      "indent": "4",
      "description": "Limit",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.50.9065",
      "rawHtsCode": "8536.50.90.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.61.0000",
      "rawHtsCode": "8536.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Lamp-holders",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8536.69",
      "rawHtsCode": "8536.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.69.40",
      "rawHtsCode": "8536.69.40",
      "superior": null,
      "indent": "3",
      "description": "Coaxial connectors; cylindrical multicontact connectors; rack and panel connectors; printed circuit connectors; ribbon or flat cable connectors",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8536.69.4010",
      "rawHtsCode": "8536.69.40.10",
      "superior": null,
      "indent": "4",
      "description": "Coaxial connectors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.69.4020",
      "rawHtsCode": "8536.69.40.20",
      "superior": null,
      "indent": "4",
      "description": "Cylindrical multicontact connectors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.69.4030",
      "rawHtsCode": "8536.69.40.30",
      "superior": null,
      "indent": "4",
      "description": "Rack and panel connectors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.69.4040",
      "rawHtsCode": "8536.69.40.40",
      "superior": null,
      "indent": "4",
      "description": "Printed circuit connectors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.69.4051",
      "rawHtsCode": "8536.69.40.51",
      "superior": null,
      "indent": "4",
      "description": "Ribbon or flat cable connectors",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.69.8000",
      "rawHtsCode": "8536.69.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8536.70.0000",
      "rawHtsCode": "8536.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Connectors for optical fibers, optical fiber bundles or cables",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8536.90",
      "rawHtsCode": "8536.90",
      "superior": null,
      "indent": "1",
      "description": "Other apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.90.4000",
      "rawHtsCode": "8536.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Terminals, electrical splices and electrical couplings; wafer probers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8536.90.6000",
      "rawHtsCode": "8536.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Battery clamps of a kind used in motor vehicles of heading 8702, 8703, 8704 or 8711",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8536.90.85",
      "rawHtsCode": "8536.90.85",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8536.90.8510",
      "rawHtsCode": "8536.90.85.10",
      "superior": null,
      "indent": "3",
      "description": "Electrical distribution ducts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.90.8530",
      "rawHtsCode": "8536.90.85.30",
      "superior": null,
      "indent": "3",
      "description": "Junction boxes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8536.90.8585",
      "rawHtsCode": "8536.90.85.85",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8537",
      "rawHtsCode": "8537",
      "superior": null,
      "indent": "0",
      "description": "Boards, panels, consoles, desks, cabinets and other bases, equipped with two or more apparatus of heading 8535 or 8536, for electric control or the distribution of electricity, including those incorporating instruments or apparatus of chapter 90, and numerical control apparatus, other than switching apparatus of heading 8517:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8537.10",
      "rawHtsCode": "8537.10",
      "superior": null,
      "indent": "1",
      "description": "For a voltage not exceeding <il>1,000 V</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8537.10.3000",
      "rawHtsCode": "8537.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Assembled with outer housing or supports, for the goods of headings 8421, 8422, 8450 or 8516",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8537.10.6000",
      "rawHtsCode": "8537.10.60.00",
      "superior": null,
      "indent": "2",
      "description": "Motor control centers",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8537.10.8000",
      "rawHtsCode": "8537.10.80.00",
      "superior": null,
      "indent": "3",
      "description": "Touch-sensitive data input devices (so-called \"touch screens\") without display capabilities, for incorporation into apparatus having a display, which function by detecting the presence and location of a touch within the display area (such sensing may be obtained by means of resistance, electrostatic capacity, acoustic pulse recognition, infra-red lights or other touch-sensitive technology)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8537.10.91",
      "rawHtsCode": "8537.10.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8537.10.9120",
      "rawHtsCode": "8537.10.91.20",
      "superior": null,
      "indent": "4",
      "description": "Switchgear assemblies and switchboards",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8537.10.9130",
      "rawHtsCode": "8537.10.91.30",
      "superior": null,
      "indent": "4",
      "description": "Numerical controls for controlling machine tools",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8537.10.9150",
      "rawHtsCode": "8537.10.91.50",
      "superior": null,
      "indent": "5",
      "description": "Panel boards and distribution boards",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8537.10.9160",
      "rawHtsCode": "8537.10.91.60",
      "superior": null,
      "indent": "5",
      "description": "Programmable controllers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8537.10.9170",
      "rawHtsCode": "8537.10.91.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8537.20.00",
      "rawHtsCode": "8537.20.00",
      "superior": null,
      "indent": "1",
      "description": "For a voltage exceeding <il>1,000 V</il>",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8537.20.0020",
      "rawHtsCode": "8537.20.00.20",
      "superior": null,
      "indent": "2",
      "description": "Switchgear assemblies and switchboards",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8537.20.0040",
      "rawHtsCode": "8537.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8538",
      "rawHtsCode": "8538",
      "superior": null,
      "indent": "0",
      "description": "Parts suitable for use solely or principally with the apparatus of heading 8535, 8536 or 8537:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8538.10.0000",
      "rawHtsCode": "8538.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Boards, panels, consoles, desks, cabinets and other bases for the goods of heading 8537, not equipped with their apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8538.90",
      "rawHtsCode": "8538.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8538.90.1000",
      "rawHtsCode": "8538.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of an article of heading 8537 for one of the articles described in additional U.S. note 11 to chapter 85",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8538.90.3000",
      "rawHtsCode": "8538.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8538.90.4000",
      "rawHtsCode": "8538.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other, for the articles of subheading 8535.90.40, 8536.30.40 or 8536.50.40, of ceramic or metallic materials, electrically or mechanically reactive to changes in temperature",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8538.90.6000",
      "rawHtsCode": "8538.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Molded parts",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8538.90.81",
      "rawHtsCode": "8538.90.81",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8538.90.8120",
      "rawHtsCode": "8538.90.81.20",
      "superior": null,
      "indent": "4",
      "description": "Of automatic circuit breakers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8538.90.8140",
      "rawHtsCode": "8538.90.81.40",
      "superior": null,
      "indent": "5",
      "description": "Metal contacts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8538.90.8160",
      "rawHtsCode": "8538.90.81.60",
      "superior": null,
      "indent": "5",
      "description": "Other parts of switchgear, switchboards, panel boards and distribution boards",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8538.90.8180",
      "rawHtsCode": "8538.90.81.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539",
      "rawHtsCode": "8539",
      "superior": null,
      "indent": "0",
      "description": "Electrical filament or discharge lamps, including sealed beam lamp units and ultraviolet or infrared lamps; arc lamps; light-emitting diode (LED) light sources; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.10.00",
      "rawHtsCode": "8539.10.00",
      "superior": null,
      "indent": "1",
      "description": "Sealed beam lamp units",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.10.0010",
      "rawHtsCode": "8539.10.00.10",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or heading 8702, 8703, 8704, 8705 or 8711",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.10.0030",
      "rawHtsCode": "8539.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.10.0050",
      "rawHtsCode": "8539.10.00.50",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or heading 8702, 8703, 8704, 8705 or 8711",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.10.0060",
      "rawHtsCode": "8539.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.21",
      "rawHtsCode": "8539.21",
      "superior": null,
      "indent": "2",
      "description": "Tungsten halogen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.21.20",
      "rawHtsCode": "8539.21.20",
      "superior": null,
      "indent": "3",
      "description": "Designed for a voltage not exceeding <il>100 V</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8539.21.2040",
      "rawHtsCode": "8539.21.20.40",
      "superior": null,
      "indent": "4",
      "description": "For vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or heading 8702, 8703, 8704, 8705 or 8711",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.21.2080",
      "rawHtsCode": "8539.21.20.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.21.40",
      "rawHtsCode": "8539.21.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.21.4040",
      "rawHtsCode": "8539.21.40.40",
      "superior": null,
      "indent": "4",
      "description": "Of a power less than <il>500 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.21.4080",
      "rawHtsCode": "8539.21.40.80",
      "superior": null,
      "indent": "4",
      "description": "Of a power <il>500 W</il> or more",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.22",
      "rawHtsCode": "8539.22",
      "superior": null,
      "indent": "2",
      "description": "Other, of a power not exceeding <il>200 W</il> and for a voltage exceeding <il>100 V:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.22.4000",
      "rawHtsCode": "8539.22.40.00",
      "superior": null,
      "indent": "3",
      "description": "Christmas-tree lamps",
      "units": [
        "No."
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.22.80",
      "rawHtsCode": "8539.22.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.22.8010",
      "rawHtsCode": "8539.22.80.10",
      "superior": null,
      "indent": "5",
      "description": "3-way",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.22.8030",
      "rawHtsCode": "8539.22.80.30",
      "superior": null,
      "indent": "5",
      "description": "Decorative",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.22.8040",
      "rawHtsCode": "8539.22.80.40",
      "superior": null,
      "indent": "6",
      "description": "Of a power 15 W or more but not exceeding <il>150 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.22.8060",
      "rawHtsCode": "8539.22.80.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.22.8070",
      "rawHtsCode": "8539.22.80.70",
      "superior": null,
      "indent": "4",
      "description": "Of a power exceeding <il>150 W</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.29",
      "rawHtsCode": "8539.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.29.1000",
      "rawHtsCode": "8539.29.10.00",
      "superior": null,
      "indent": "4",
      "description": "Christmas-tree lamps",
      "units": [
        "No."
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)2.9% (JP)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.29.2000",
      "rawHtsCode": "8539.29.20.00",
      "superior": null,
      "indent": "4",
      "description": "Lamps having glass envelopes not over 6.35 mm in maximum diameter and suitable for use in cystoscopes and other surgical instruments",
      "units": [
        "No."
      ],
      "generalRate": "5.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)2.6% (JP)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.29.30",
      "rawHtsCode": "8539.29.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8539.29.3020",
      "rawHtsCode": "8539.29.30.20",
      "superior": null,
      "indent": "5",
      "description": "Flashlight lamps",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.29.3050",
      "rawHtsCode": "8539.29.30.50",
      "superior": null,
      "indent": "6",
      "description": "Designed for a voltage of 12 V or more but not exceeding 14 V",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.29.3060",
      "rawHtsCode": "8539.29.30.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.29.4000",
      "rawHtsCode": "8539.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "Designed for a voltage exceeding <il>100 V</il>",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.31.00",
      "rawHtsCode": "8539.31.00",
      "superior": null,
      "indent": "2",
      "description": "Fluorescent, hot cathode",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.31.0040",
      "rawHtsCode": "8539.31.00.40",
      "superior": null,
      "indent": "3",
      "description": "1.2 m, straight tube, of a power 30 W or more but not exceeding 40 W",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.31.0050",
      "rawHtsCode": "8539.31.00.50",
      "superior": null,
      "indent": "4",
      "description": "With a single plug-in base",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.31.0060",
      "rawHtsCode": "8539.31.00.60",
      "superior": null,
      "indent": "4",
      "description": "With a single screw-in base",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.31.0070",
      "rawHtsCode": "8539.31.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.32.00",
      "rawHtsCode": "8539.32.00",
      "superior": null,
      "indent": "2",
      "description": "Mercury or sodium vapor lamps; metal halide lamps",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.32.0020",
      "rawHtsCode": "8539.32.00.20",
      "superior": null,
      "indent": "3",
      "description": "Sodium vapor",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.32.0040",
      "rawHtsCode": "8539.32.00.40",
      "superior": null,
      "indent": "3",
      "description": "Mercury vapor",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.32.0090",
      "rawHtsCode": "8539.32.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.39",
      "rawHtsCode": "8539.39",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.39.1000",
      "rawHtsCode": "8539.39.10.00",
      "superior": null,
      "indent": "3",
      "description": "Cold-cathode fluorescent lamps (CCFLs) for backlighting of flat panel displays",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8539.39.9000",
      "rawHtsCode": "8539.39.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.41.0000",
      "rawHtsCode": "8539.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Arc lamps",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.49.00",
      "rawHtsCode": "8539.49.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.49.0040",
      "rawHtsCode": "8539.49.00.40",
      "superior": null,
      "indent": "3",
      "description": "Ultraviolet lamps",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.49.0080",
      "rawHtsCode": "8539.49.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.51.0000",
      "rawHtsCode": "8539.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Light-emitting diode (LED) modules",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8539.52.00",
      "rawHtsCode": "8539.52.00",
      "superior": null,
      "indent": "2",
      "description": "Light-emitting diode (LED) lamps",
      "units": [],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8539.52.0010",
      "rawHtsCode": "8539.52.00.10",
      "superior": null,
      "indent": "3",
      "description": "Of a type specified in statistical note 8(a) to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.52.0020",
      "rawHtsCode": "8539.52.00.20",
      "superior": null,
      "indent": "3",
      "description": "Of a type specified in statistical note 8(b) to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.52.0030",
      "rawHtsCode": "8539.52.00.30",
      "superior": null,
      "indent": "3",
      "description": "Of a type specified in statistical note 8(c) to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.52.0040",
      "rawHtsCode": "8539.52.00.40",
      "superior": null,
      "indent": "3",
      "description": "Of a type specified in statistical note 8(d) to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.52.0051",
      "rawHtsCode": "8539.52.00.51",
      "superior": null,
      "indent": "3",
      "description": "Straight linear tubes or U-shaped tubes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.52.0091",
      "rawHtsCode": "8539.52.00.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8539.90.0000",
      "rawHtsCode": "8539.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540",
      "rawHtsCode": "8540",
      "superior": null,
      "indent": "0",
      "description": "Thermionic, cold cathode or photocathode tubes (for example, vacuum or vapor or gas filled tubes, mercury arc rectifying tubes, cathode-ray tubes, television camera tubes); parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.11",
      "rawHtsCode": "8540.11",
      "superior": null,
      "indent": "2",
      "description": "Color:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.11.10",
      "rawHtsCode": "8540.11.10",
      "superior": null,
      "indent": "3",
      "description": "Non-high definition, non-projection, having a video display diagonal exceeding <il>35.56 cm</il>",
      "units": [],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.11.1030",
      "rawHtsCode": "8540.11.10.30",
      "superior": null,
      "indent": "5",
      "description": "Not exceeding <il>39 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.11.1040",
      "rawHtsCode": "8540.11.10.40",
      "superior": null,
      "indent": "5",
      "description": "Exceeding <il>39 cm</il> but not exceeding <il>45 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.11.1050",
      "rawHtsCode": "8540.11.10.50",
      "superior": null,
      "indent": "5",
      "description": "Exceeding <il>45 cm</il> but not exceeding <il>50 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.11.1055",
      "rawHtsCode": "8540.11.10.55",
      "superior": null,
      "indent": "5",
      "description": "Exceeding <il>50 cm</il> but not exceeding <il>63 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.11.1085",
      "rawHtsCode": "8540.11.10.85",
      "superior": null,
      "indent": "5",
      "description": "Exceeding 63 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.11.2401",
      "rawHtsCode": "8540.11.24.01",
      "superior": null,
      "indent": "4",
      "description": "Having a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.11.2801",
      "rawHtsCode": "8540.11.28.01",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.11.3000",
      "rawHtsCode": "8540.11.30.00",
      "superior": null,
      "indent": "3",
      "description": "High definition, having a video display diagonal exceeding <il>35.56 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.11.4401",
      "rawHtsCode": "8540.11.44.01",
      "superior": null,
      "indent": "4",
      "description": "Having a video display diagonal not exceeding <il>34.29 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.11.4801",
      "rawHtsCode": "8540.11.48.01",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.11.5000",
      "rawHtsCode": "8540.11.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "15%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.12",
      "rawHtsCode": "8540.12",
      "superior": null,
      "indent": "2",
      "description": "Monochrome:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.12.1000",
      "rawHtsCode": "8540.12.10.00",
      "superior": null,
      "indent": "4",
      "description": "Non-high definition",
      "units": [
        "No."
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.12.2000",
      "rawHtsCode": "8540.12.20.00",
      "superior": null,
      "indent": "4",
      "description": "High definition",
      "units": [
        "No."
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.12.50",
      "rawHtsCode": "8540.12.50",
      "superior": null,
      "indent": "4",
      "description": "Non-high definition",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.12.5040",
      "rawHtsCode": "8540.12.50.40",
      "superior": null,
      "indent": "5",
      "description": "Projection",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.12.5080",
      "rawHtsCode": "8540.12.50.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.12.7000",
      "rawHtsCode": "8540.12.70.00",
      "superior": null,
      "indent": "4",
      "description": "High definition",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.20",
      "rawHtsCode": "8540.20",
      "superior": null,
      "indent": "1",
      "description": "Television camera tubes; image converters and intensifiers; other photocathode tubes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.20.20",
      "rawHtsCode": "8540.20.20",
      "superior": null,
      "indent": "2",
      "description": "Cathode-ray tubes",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.20.2040",
      "rawHtsCode": "8540.20.20.40",
      "superior": null,
      "indent": "3",
      "description": "Color",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.20.2080",
      "rawHtsCode": "8540.20.20.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.20.4000",
      "rawHtsCode": "8540.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.40.10",
      "rawHtsCode": "8540.40.10",
      "superior": null,
      "indent": "1",
      "description": "Data/graphic display tubes, monochrome; data/graphic display tubes, color, with a phosphor dot screen pitch smaller than 0.4 mm",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.40.1010",
      "rawHtsCode": "8540.40.10.10",
      "superior": null,
      "indent": "2",
      "description": "Color",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.40.1050",
      "rawHtsCode": "8540.40.10.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.60.00",
      "rawHtsCode": "8540.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other cathode-ray tubes",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.60.0020",
      "rawHtsCode": "8540.60.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not exceeding <il>30 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.60.0065",
      "rawHtsCode": "8540.60.00.65",
      "superior": null,
      "indent": "3",
      "description": "Exceeding 30 cm but not exceeding 36 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.60.0080",
      "rawHtsCode": "8540.60.00.80",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>36 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.71",
      "rawHtsCode": "8540.71",
      "superior": null,
      "indent": "2",
      "description": "Magnetrons:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.71.2000",
      "rawHtsCode": "8540.71.20.00",
      "superior": null,
      "indent": "3",
      "description": "Modified for use as parts of microwave ovens",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8540.71.4000",
      "rawHtsCode": "8540.71.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.79",
      "rawHtsCode": "8540.79",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.79.1000",
      "rawHtsCode": "8540.79.10.00",
      "superior": null,
      "indent": "3",
      "description": "Klystrons",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.79.2000",
      "rawHtsCode": "8540.79.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.81.0000",
      "rawHtsCode": "8540.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "Receiver or amplifier tubes",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.89.00",
      "rawHtsCode": "8540.89.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.89.0020",
      "rawHtsCode": "8540.89.00.20",
      "superior": null,
      "indent": "3",
      "description": "Gas and vapor electron tubes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.89.0040",
      "rawHtsCode": "8540.89.00.40",
      "superior": null,
      "indent": "3",
      "description": "Diodes, triodes and tetrodes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.89.0060",
      "rawHtsCode": "8540.89.00.60",
      "superior": null,
      "indent": "3",
      "description": "Light-sensing tubes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.89.0080",
      "rawHtsCode": "8540.89.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.91",
      "rawHtsCode": "8540.91",
      "superior": null,
      "indent": "2",
      "description": "Of cathode-ray tubes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.91.1500",
      "rawHtsCode": "8540.91.15.00",
      "superior": null,
      "indent": "3",
      "description": "Front panel assemblies",
      "units": [
        "No."
      ],
      "generalRate": "5.4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.91.2000",
      "rawHtsCode": "8540.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "Deflection coils",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8540.91.5000",
      "rawHtsCode": "8540.91.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "5.4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8540.99",
      "rawHtsCode": "8540.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8540.99.4000",
      "rawHtsCode": "8540.99.40.00",
      "superior": null,
      "indent": "3",
      "description": "Electron guns; radio frequency (RF) interaction structures for microwave tubes of subheadings 8540.71 through 8540.79, inclusive",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8540.99.8000",
      "rawHtsCode": "8540.99.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541",
      "rawHtsCode": "8541",
      "superior": null,
      "indent": "0",
      "description": "Semiconductor devices (for example, diodes, transistors, semiconductor-based transducers); photosensitive semiconductor devices, including photovoltaic cells whether or not assembled in modules or made up into panels; light-emitting diodes (LED), whether or not assembled with other light-emitting diodes (LED); mounted piezo-electric crystals; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.10.00",
      "rawHtsCode": "8541.10.00",
      "superior": null,
      "indent": "1",
      "description": "Diodes, other than photosensitive or light-emitting diodes (LED)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.10.0040",
      "rawHtsCode": "8541.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Unmounted chips, dice and wafers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.10.0050",
      "rawHtsCode": "8541.10.00.50",
      "superior": null,
      "indent": "3",
      "description": "Zener",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.10.0060",
      "rawHtsCode": "8541.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Microwave",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.10.0070",
      "rawHtsCode": "8541.10.00.70",
      "superior": null,
      "indent": "4",
      "description": "With a maximum current of 0.5 A or less",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.10.0080",
      "rawHtsCode": "8541.10.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.21.00",
      "rawHtsCode": "8541.21.00",
      "superior": null,
      "indent": "2",
      "description": "With a dissipation rate of less than 1 W",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.21.0040",
      "rawHtsCode": "8541.21.00.40",
      "superior": null,
      "indent": "3",
      "description": "Unmounted chips, dice and wafers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.21.0075",
      "rawHtsCode": "8541.21.00.75",
      "superior": null,
      "indent": "4",
      "description": "With an operating frequency not less than <il>100 MHz</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.21.0095",
      "rawHtsCode": "8541.21.00.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.29.00",
      "rawHtsCode": "8541.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.29.0040",
      "rawHtsCode": "8541.29.00.40",
      "superior": null,
      "indent": "3",
      "description": "Unmounted chips, dice and wafers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.29.0055",
      "rawHtsCode": "8541.29.00.55",
      "superior": null,
      "indent": "4",
      "description": "With an operating frequency less than <il>30 MHz</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.29.0065",
      "rawHtsCode": "8541.29.00.65",
      "superior": null,
      "indent": "4",
      "description": "With an operating frequency 30 MHz or greater but less than 30,000 MHz",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.29.0085",
      "rawHtsCode": "8541.29.00.85",
      "superior": null,
      "indent": "4",
      "description": "With an operating frequency 30,000 MHz or greater",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.30.00",
      "rawHtsCode": "8541.30.00",
      "superior": null,
      "indent": "1",
      "description": "Thyristors, diacs and triacs, other than photosensitive devices",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.30.0040",
      "rawHtsCode": "8541.30.00.40",
      "superior": null,
      "indent": "2",
      "description": "Unmounted chips, dice and wafers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.30.0080",
      "rawHtsCode": "8541.30.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.41.0000",
      "rawHtsCode": "8541.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Light-emitting diodes (LED)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.42.00",
      "rawHtsCode": "8541.42.00",
      "superior": null,
      "indent": "2",
      "description": "Photovoltaic cells not assembled in modules or made up into panels ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.42.0010",
      "rawHtsCode": "8541.42.00.10",
      "superior": null,
      "indent": "3",
      "description": "Crystalline silicon photovoltaic cells of a kind described in statistical note 12 to this chapter",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.42.0080",
      "rawHtsCode": "8541.42.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.43.00",
      "rawHtsCode": "8541.43.00",
      "superior": null,
      "indent": "2",
      "description": "Photovoltaic cells assembled in modules or made up into panels",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.43.0010",
      "rawHtsCode": "8541.43.00.10",
      "superior": null,
      "indent": "3",
      "description": "Crystalline silicon photovoltaic cells of a kind described in statistical note 12 to this chapter",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.43.0080",
      "rawHtsCode": "8541.43.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "W"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.49",
      "rawHtsCode": "8541.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.49.10",
      "rawHtsCode": "8541.49.10",
      "superior": null,
      "indent": "3",
      "description": "Other diodes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.49.1010",
      "rawHtsCode": "8541.49.10.10",
      "superior": null,
      "indent": "4",
      "description": "Unmounted chips, dice and wafers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.49.1050",
      "rawHtsCode": "8541.49.10.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.49.70",
      "rawHtsCode": "8541.49.70",
      "superior": null,
      "indent": "3",
      "description": "Transistors",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.49.7040",
      "rawHtsCode": "8541.49.70.40",
      "superior": null,
      "indent": "4",
      "description": "Unmounted chips, dice and wafers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.49.7080",
      "rawHtsCode": "8541.49.70.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.49.8000",
      "rawHtsCode": "8541.49.80.00",
      "superior": null,
      "indent": "4",
      "description": "Optical coupled isolators",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.49.9500",
      "rawHtsCode": "8541.49.95.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.51.0000",
      "rawHtsCode": "8541.51.00.00",
      "superior": null,
      "indent": "2",
      "description": "Semiconductor-based transducers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.59.00",
      "rawHtsCode": "8541.59.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.59.0040",
      "rawHtsCode": "8541.59.00.40",
      "superior": null,
      "indent": "3",
      "description": "Unmounted chips, dice and wafers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.59.0080",
      "rawHtsCode": "8541.59.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.60.00",
      "rawHtsCode": "8541.60.00",
      "superior": null,
      "indent": "1",
      "description": "Mounted piezoelectric crystals",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8541.60.0010",
      "rawHtsCode": "8541.60.00.10",
      "superior": null,
      "indent": "3",
      "description": "<il>32.768 kHz</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.60.0020",
      "rawHtsCode": "8541.60.00.20",
      "superior": null,
      "indent": "3",
      "description": "Not exceeding <il>1 MHz</il>, except <il>32.768 kHz</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.60.0030",
      "rawHtsCode": "8541.60.00.30",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>1 MHz</il>, but not exceeding <il>5 MHZ</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.60.0050",
      "rawHtsCode": "8541.60.00.50",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>5 MHZ</il>, but not exceeding <il>20 MHz</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.60.0060",
      "rawHtsCode": "8541.60.00.60",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>20 MHZ</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.60.0080",
      "rawHtsCode": "8541.60.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.90.00",
      "rawHtsCode": "8541.90.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8541.90.0010",
      "rawHtsCode": "8541.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Frames for photovoltaic cells assembled in modules or made up into panels (as covered by subheading 8541.43.00)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8541.90.0080",
      "rawHtsCode": "8541.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542",
      "rawHtsCode": "8542",
      "superior": null,
      "indent": "0",
      "description": "Electronic integrated circuits; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.00",
      "rawHtsCode": "8542.31.00",
      "superior": null,
      "indent": "2",
      "description": "Processors and controllers, whether or not combined with memories, converters, logic circuits, amplifiers, clock and timing circuits, or other circuits",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8542.31.0015",
      "rawHtsCode": "8542.31.00.15",
      "superior": null,
      "indent": "4",
      "description": "8-bit",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.0020",
      "rawHtsCode": "8542.31.00.20",
      "superior": null,
      "indent": "4",
      "description": "16-bit",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.0025",
      "rawHtsCode": "8542.31.00.25",
      "superior": null,
      "indent": "4",
      "description": "32-bit",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.0030",
      "rawHtsCode": "8542.31.00.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.0035",
      "rawHtsCode": "8542.31.00.35",
      "superior": null,
      "indent": "4",
      "description": "Digital signal processors (DSPs)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.0040",
      "rawHtsCode": "8542.31.00.40",
      "superior": null,
      "indent": "4",
      "description": "Graphics processing units (GPUs)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.0045",
      "rawHtsCode": "8542.31.00.45",
      "superior": null,
      "indent": "4",
      "description": "Central processing units (CPUs)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.0050",
      "rawHtsCode": "8542.31.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.0055",
      "rawHtsCode": "8542.31.00.55",
      "superior": null,
      "indent": "4",
      "description": "Complex programmable logic devices (CPLDs)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.0060",
      "rawHtsCode": "8542.31.00.60",
      "superior": null,
      "indent": "4",
      "description": "Field programmable gate arrays (FPGAs)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.0065",
      "rawHtsCode": "8542.31.00.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.0070",
      "rawHtsCode": "8542.31.00.70",
      "superior": null,
      "indent": "3",
      "description": "System on chip (SoCs)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.31.0075",
      "rawHtsCode": "8542.31.00.75",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.32.00",
      "rawHtsCode": "8542.32.00",
      "superior": null,
      "indent": "2",
      "description": "Memories",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8542.32.0002",
      "rawHtsCode": "8542.32.00.02",
      "superior": null,
      "indent": "4",
      "description": "Not over 128 megabits",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.32.0024",
      "rawHtsCode": "8542.32.00.24",
      "superior": null,
      "indent": "4",
      "description": "Over 128 megabits but not over 256 megabits",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.32.0028",
      "rawHtsCode": "8542.32.00.28",
      "superior": null,
      "indent": "4",
      "description": "Over 256 megabits but not over 512 megabits",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.32.0032",
      "rawHtsCode": "8542.32.00.32",
      "superior": null,
      "indent": "4",
      "description": "Over 512 megabits but not over 1 gigabit",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.32.0036",
      "rawHtsCode": "8542.32.00.36",
      "superior": null,
      "indent": "4",
      "description": "Over 1 gigabit",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.32.0041",
      "rawHtsCode": "8542.32.00.41",
      "superior": null,
      "indent": "3",
      "description": "Static read-write random access (SRAM)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.32.0051",
      "rawHtsCode": "8542.32.00.51",
      "superior": null,
      "indent": "3",
      "description": "Electrically erasable programmable read-only memory (EEPROM)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.32.0061",
      "rawHtsCode": "8542.32.00.61",
      "superior": null,
      "indent": "3",
      "description": "Erasable (except electrically) programmable read-only memory (EPROM)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.32.0071",
      "rawHtsCode": "8542.32.00.71",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.33.0001",
      "rawHtsCode": "8542.33.00.01",
      "superior": null,
      "indent": "2",
      "description": "Amplifiers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8542.39.00",
      "rawHtsCode": "8542.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8542.39.0010",
      "rawHtsCode": "8542.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "RF transceivers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.39.0020",
      "rawHtsCode": "8542.39.00.20",
      "superior": null,
      "indent": "3",
      "description": "Active filters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.39.0030",
      "rawHtsCode": "8542.39.00.30",
      "superior": null,
      "indent": "4",
      "description": "Analog to digital converters (ADCs)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.39.0040",
      "rawHtsCode": "8542.39.00.40",
      "superior": null,
      "indent": "4",
      "description": "Digital to analog converters (DACs)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.39.0050",
      "rawHtsCode": "8542.39.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.39.0070",
      "rawHtsCode": "8542.39.00.70",
      "superior": null,
      "indent": "3",
      "description": "With adjustable performance characteristics, not elsewhere specified or included",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.39.0090",
      "rawHtsCode": "8542.39.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8542.90.0000",
      "rawHtsCode": "8542.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.05. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543",
      "rawHtsCode": "8543",
      "superior": null,
      "indent": "0",
      "description": "Electrical machines and apparatus, having individual functions, not specified or included elsewhere in this chapter; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.10.0000",
      "rawHtsCode": "8543.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Particle accelerators",
      "units": [
        "No."
      ],
      "generalRate": "1.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8543.20.0000",
      "rawHtsCode": "8543.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Signal generators",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.30",
      "rawHtsCode": "8543.30",
      "superior": null,
      "indent": "1",
      "description": "Machines and apparatus for electroplating, electrolysis or electrophoresis:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.30.2000",
      "rawHtsCode": "8543.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used solely or principally for the manufacture of printed circuits",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.30.90",
      "rawHtsCode": "8543.30.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        ""
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8543.30.9040",
      "rawHtsCode": "8543.30.90.40",
      "superior": null,
      "indent": "3",
      "description": "Magnesium anodes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.30.9080",
      "rawHtsCode": "8543.30.90.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.40.00",
      "rawHtsCode": "8543.40.00",
      "superior": null,
      "indent": "1",
      "description": "Electronic cigarettes and similar personal electric vaporizing devices",
      "units": [
        ""
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8543.40.0030",
      "rawHtsCode": "8543.40.00.30",
      "superior": null,
      "indent": "2",
      "description": "With substances containing nicotine",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.40.0040",
      "rawHtsCode": "8543.40.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.70",
      "rawHtsCode": "8543.70",
      "superior": null,
      "indent": "1",
      "description": "Other machines and apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.70.2000",
      "rawHtsCode": "8543.70.20.00",
      "superior": null,
      "indent": "2",
      "description": "Physical vapor deposition apparatus",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8543.70.4200",
      "rawHtsCode": "8543.70.42.00",
      "superior": null,
      "indent": "3",
      "description": "Flight data recorders",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.70.4500",
      "rawHtsCode": "8543.70.45.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8543.70.6000",
      "rawHtsCode": "8543.70.60.00",
      "superior": null,
      "indent": "2",
      "description": "Articles designed for connection to telegraphic or telephonic apparatus or instruments or to telegraphic or telephonic networks",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.70.7100",
      "rawHtsCode": "8543.70.71.00",
      "superior": null,
      "indent": "2",
      "description": "Electric luminescent lamps",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8543.70.8000",
      "rawHtsCode": "8543.70.80.00",
      "superior": null,
      "indent": "3",
      "description": "Microwave amplifiers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8543.70.8500",
      "rawHtsCode": "8543.70.85.00",
      "superior": null,
      "indent": "4",
      "description": "For electrical nerve stimulation",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.70.8800",
      "rawHtsCode": "8543.70.88.00",
      "superior": null,
      "indent": "4",
      "description": "Electrical machines with translation or dictionary functions; video game console controllers which use infrared transmissions to operate or access the various functions and capabilities of the console",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.70.8900",
      "rawHtsCode": "8543.70.89.00",
      "superior": null,
      "indent": "4",
      "description": "Other portable battery operated electronic readers for recording and reproducing text, still images or audio files",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.70.9100",
      "rawHtsCode": "8543.70.91.00",
      "superior": null,
      "indent": "4",
      "description": "Digital signal processing apparatus capable of connecting to a wired or wireless network for the mixing of sound",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.70.9301",
      "rawHtsCode": "8543.70.93.01",
      "superior": null,
      "indent": "4",
      "description": "Portable interactive electronic education devices primarily designed for children",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.70.9500",
      "rawHtsCode": "8543.70.95.00",
      "superior": null,
      "indent": "4",
      "description": "Touch-sensitive data input devices (so-called \"touch screens\") without display capabilities, for incorporation into apparatus having a display, which function by detecting the presence and location of a touch within the display area (such sensing may be obtained by means of resistance, electrostatic capacity, acoustic pulse recognition, infra-red lights or other touch-sensitive technology)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.70.9700",
      "rawHtsCode": "8543.70.97.00",
      "superior": null,
      "indent": "4",
      "description": "Plasma cleaner machines that remove organic contaminants from electron microscopy specimens and specimen holders",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.70.98",
      "rawHtsCode": "8543.70.98",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8543.70.9810",
      "rawHtsCode": "8543.70.98.10",
      "superior": null,
      "indent": "5",
      "description": "Amplifiers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.70.9820",
      "rawHtsCode": "8543.70.98.20",
      "superior": null,
      "indent": "5",
      "description": "Special effects pedals for use with musical instruments",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.70.9860",
      "rawHtsCode": "8543.70.98.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.90",
      "rawHtsCode": "8543.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.90.1200",
      "rawHtsCode": "8543.90.12.00",
      "superior": null,
      "indent": "2",
      "description": "Of physical vapor deposition apparatus of subheading 8543.70",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.90.1500",
      "rawHtsCode": "8543.90.15.00",
      "superior": null,
      "indent": "3",
      "description": "Printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.90.3500",
      "rawHtsCode": "8543.90.35.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.90.6500",
      "rawHtsCode": "8543.90.65.00",
      "superior": null,
      "indent": "4",
      "description": "Of flat panel displays other than for articles of heading 8528, except for subheadings 8528.52 or 8528.62",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.90.6800",
      "rawHtsCode": "8543.90.68.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.90.8500",
      "rawHtsCode": "8543.90.85.00",
      "superior": null,
      "indent": "4",
      "description": "Of flat panel displays other than for articles of heading 8528, except for subheadings 8528.52 or 8528.62",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.90.88",
      "rawHtsCode": "8543.90.88",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8543.90.8845",
      "rawHtsCode": "8543.90.88.45",
      "superior": null,
      "indent": "5",
      "description": "Of particle accelerators",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.90.8865",
      "rawHtsCode": "8543.90.88.65",
      "superior": null,
      "indent": "5",
      "description": "Of electronic cigarettes and similar personal electric vaporizing devices",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8543.90.8885",
      "rawHtsCode": "8543.90.88.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8544",
      "rawHtsCode": "8544",
      "superior": null,
      "indent": "0",
      "description": "Insulated (including enameled or anodized) wire, cable (including coaxial cable) and other insulated electric conductors, whether or not fitted with connectors; optical fiber cables, made up of individually sheathed fibers, whether or not assembled with electric conductors or fitted with connectors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8544.11.00",
      "rawHtsCode": "8544.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of copper",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8544.11.0020",
      "rawHtsCode": "8544.11.00.20",
      "superior": null,
      "indent": "3",
      "description": "33 AWG (0.18 mm in diameter) and finer",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8544.11.0030",
      "rawHtsCode": "8544.11.00.30",
      "superior": null,
      "indent": "3",
      "description": "22 AWG (0.643 mm in diameter) and finer but larger than 33 AWG (0.18 mm in diameter)",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8544.11.0050",
      "rawHtsCode": "8544.11.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8544.19.0000",
      "rawHtsCode": "8544.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8544.20.0000",
      "rawHtsCode": "8544.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Coaxial cable and other coaxial electric conductors",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8544.30.0000",
      "rawHtsCode": "8544.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ignition wiring sets and other wiring sets of a kind used in vehicles, aircraft or ships",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8544.42",
      "rawHtsCode": "8544.42",
      "superior": null,
      "indent": "2",
      "description": "Fitted with connectors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8544.42.1000",
      "rawHtsCode": "8544.42.10.00",
      "superior": null,
      "indent": "3",
      "description": "Fitted with modular telephone connectors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8544.42.2000",
      "rawHtsCode": "8544.42.20.00",
      "superior": null,
      "indent": "4",
      "description": "Of a kind used for telecommunications",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8544.42.90",
      "rawHtsCode": "8544.42.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        ""
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8544.42.9010",
      "rawHtsCode": "8544.42.90.10",
      "superior": null,
      "indent": "5",
      "description": "Extension cords as defined in statistical note 7 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8544.42.9090",
      "rawHtsCode": "8544.42.90.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8544.49",
      "rawHtsCode": "8544.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8544.49.1000",
      "rawHtsCode": "8544.49.10.00",
      "superior": null,
      "indent": "4",
      "description": "Of a kind used for telecommunications",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8544.49.2000",
      "rawHtsCode": "8544.49.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8544.49.30",
      "rawHtsCode": "8544.49.30",
      "superior": null,
      "indent": "4",
      "description": "Of copper",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8544.49.3040",
      "rawHtsCode": "8544.49.30.40",
      "superior": null,
      "indent": "5",
      "description": "For a voltage exceeding <il>600 V</il>",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8544.49.3080",
      "rawHtsCode": "8544.49.30.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8544.49.9000",
      "rawHtsCode": "8544.49.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8544.60",
      "rawHtsCode": "8544.60",
      "superior": null,
      "indent": "1",
      "description": "Other electric conductors, for a voltage exceeding <il>1,000 V</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8544.60.2000",
      "rawHtsCode": "8544.60.20.00",
      "superior": null,
      "indent": "2",
      "description": "Fitted with connectors",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8544.60.4000",
      "rawHtsCode": "8544.60.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of copper",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8544.60.6000",
      "rawHtsCode": "8544.60.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8544.70.0000",
      "rawHtsCode": "8544.70.00.00",
      "superior": null,
      "indent": "1",
      "description": "Optical fiber cables",
      "units": [
        "Fiber m"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8545",
      "rawHtsCode": "8545",
      "superior": null,
      "indent": "0",
      "description": "Carbon electrodes, carbon brushes, lamp carbons, battery carbons and other articles of graphite or other carbon, with or without metal, of a kind used for electrical purposes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8545.11.00",
      "rawHtsCode": "8545.11.00",
      "superior": null,
      "indent": "2",
      "description": "Of a kind used for furnaces",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8545.11.0010",
      "rawHtsCode": "8545.11.00.10",
      "superior": null,
      "indent": "4",
      "description": "Not exceeding 425 mm in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8545.11.0020",
      "rawHtsCode": "8545.11.00.20",
      "superior": null,
      "indent": "4",
      "description": "Exceeding 425 mm in diameter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8545.11.0050",
      "rawHtsCode": "8545.11.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8545.19",
      "rawHtsCode": "8545.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8545.19.2000",
      "rawHtsCode": "8545.19.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of a kind used for electrolytic purposes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8545.19.4000",
      "rawHtsCode": "8545.19.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8545.20.0000",
      "rawHtsCode": "8545.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Brushes",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8545.90",
      "rawHtsCode": "8545.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8545.90.2000",
      "rawHtsCode": "8545.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Arc light carbons",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8545.90.4000",
      "rawHtsCode": "8545.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8546",
      "rawHtsCode": "8546",
      "superior": null,
      "indent": "0",
      "description": "Electrical insulators of any material:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8546.10.0000",
      "rawHtsCode": "8546.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of glass",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8546.20.00",
      "rawHtsCode": "8546.20.00",
      "superior": null,
      "indent": "1",
      "description": "Of ceramics",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8546.20.0030",
      "rawHtsCode": "8546.20.00.30",
      "superior": null,
      "indent": "3",
      "description": "Commonly known as suspension, pin-type or line post insulators",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8546.20.0060",
      "rawHtsCode": "8546.20.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8546.20.0090",
      "rawHtsCode": "8546.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8546.90.0000",
      "rawHtsCode": "8546.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "8547",
      "rawHtsCode": "8547",
      "superior": null,
      "indent": "0",
      "description": "Insulating fittings for electrical machines, appliances or equipment, being fittings wholly of insulating material apart from any minor components of metal (for example, threaded sockets) incorporated during molding solely for the purposes of assembly, other than insulators of heading 8546; electrical conduit tubing and joints therefor, of base metal lined with insulating material:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8547.10",
      "rawHtsCode": "8547.10",
      "superior": null,
      "indent": "1",
      "description": "Insulating fittings of ceramics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8547.10.4000",
      "rawHtsCode": "8547.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Ceramic insulators to be used in the production of spark plugs for natural gas-fueled, stationary, internal combustion engines",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8547.10.8000",
      "rawHtsCode": "8547.10.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8547.20.0000",
      "rawHtsCode": "8547.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Insulating fittings of plastics",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8547.90.00",
      "rawHtsCode": "8547.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "4.6%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8547.90.0010",
      "rawHtsCode": "8547.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Other insulating fittings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8547.90.0020",
      "rawHtsCode": "8547.90.00.20",
      "superior": null,
      "indent": "3",
      "description": "Conduit tubing",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8547.90.0030",
      "rawHtsCode": "8547.90.00.30",
      "superior": null,
      "indent": "4",
      "description": "Threaded",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8547.90.0040",
      "rawHtsCode": "8547.90.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8548.00.0000",
      "rawHtsCode": "8548.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Electrical parts of machinery or apparatus, not specified or included elsewhere in this chapter",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549",
      "rawHtsCode": "8549",
      "superior": null,
      "indent": "0",
      "description": "Electrical and electronic waste and scrap:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8549.11",
      "rawHtsCode": "8549.11",
      "superior": null,
      "indent": "2",
      "description": "Waste and scrap of lead-acid accumulators; spent lead-acid accumulators:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8549.11.10",
      "rawHtsCode": "8549.11.10",
      "superior": null,
      "indent": "3",
      "description": "For recovery of lead",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549.11.1040",
      "rawHtsCode": "8549.11.10.40",
      "superior": null,
      "indent": "4",
      "description": "Lead-acid storage batteries, of a kind used for starting engines",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8549.11.1080",
      "rawHtsCode": "8549.11.10.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8549.11.9000",
      "rawHtsCode": "8549.11.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549.12",
      "rawHtsCode": "8549.12",
      "superior": null,
      "indent": "2",
      "description": "Other, containing lead, cadmium or mercury:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8549.12.4000",
      "rawHtsCode": "8549.12.40.00",
      "superior": null,
      "indent": "3",
      "description": "For recovery of lead",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "11.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549.12.8000",
      "rawHtsCode": "8549.12.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549.13.0000",
      "rawHtsCode": "8549.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Sorted by chemical type and not containing lead, cadmium or mercury",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549.14.0000",
      "rawHtsCode": "8549.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Unsorted and not containing lead, cadmium or mercury",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549.19.0000",
      "rawHtsCode": "8549.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549.21.0000",
      "rawHtsCode": "8549.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing primary cells, primary batteries, electric accumulators, mercury-switches, glass from cathode-ray tubes or other activated glass, or electrical or electronic components containing cadmium, mercury, lead or polychlorinated biphenyls (PCBs)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549.29.0000",
      "rawHtsCode": "8549.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549.31.0000",
      "rawHtsCode": "8549.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing primary cells, primary batteries, electric accumulators, mercury-switches, glass from cathode-ray tubes or other activated glass, or electrical or electronic components containing cadmium, mercury, lead or polychlorinated biphenyls (PCBs)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549.39.0000",
      "rawHtsCode": "8549.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549.91.0000",
      "rawHtsCode": "8549.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Containing primary cells, primary batteries, electric accumulators, mercury-switches, glass from cathode-ray tubes or other activated glass, or electrical or electronic components containing cadmium, mercury, lead or polychlorinated biphenyls (PCBs)",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8549.99.0000",
      "rawHtsCode": "8549.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8601",
      "rawHtsCode": "8601",
      "superior": null,
      "indent": "0",
      "description": "Rail locomotives powered from an external source of electricity or by electric accumulators (batteries):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8601.10.0000",
      "rawHtsCode": "8601.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Powered from an external source of electricity",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8601.20.0000",
      "rawHtsCode": "8601.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Powered by electric accumulators (batteries)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8602",
      "rawHtsCode": "8602",
      "superior": null,
      "indent": "0",
      "description": "Other rail locomotives; locomotive tenders:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8602.10.0000",
      "rawHtsCode": "8602.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Diesel-electric locomotives",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8602.90.0000",
      "rawHtsCode": "8602.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8603",
      "rawHtsCode": "8603",
      "superior": null,
      "indent": "0",
      "description": "Self-propelled railway or tramway coaches, vans and trucks, other than those of heading 8604:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8603.10.0000",
      "rawHtsCode": "8603.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Powered from an external source of electricity",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8603.90.0000",
      "rawHtsCode": "8603.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8604.00.0000",
      "rawHtsCode": "8604.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Railway or tramway maintenance or service vehicles, whether or not self-propelled (for example, workshops, cranes, ballast tampers, trackliners, testing coaches and track inspection vehicles)",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8605.00.0000",
      "rawHtsCode": "8605.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Railway or tramway passenger coaches, not self- propelled; luggage vans, post office coaches and other special purpose railway or tramway coaches, not self- propelled (excluding those of heading 8604)",
      "units": [
        "No."
      ],
      "generalRate": "14%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8606",
      "rawHtsCode": "8606",
      "superior": null,
      "indent": "0",
      "description": "Railway or tramway freight cars, not self-propelled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8606.10.0000",
      "rawHtsCode": "8606.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tank cars and the like",
      "units": [
        "No."
      ],
      "generalRate": "14%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8606.30.0000",
      "rawHtsCode": "8606.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Self-discharging cars, other than those of subheading 8606.10",
      "units": [
        "No."
      ],
      "generalRate": "14%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8606.91.0000",
      "rawHtsCode": "8606.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Covered and closed",
      "units": [
        "No."
      ],
      "generalRate": "14%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8606.92.0000",
      "rawHtsCode": "8606.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Open, with non-removable sides of a height exceeding 60 cm",
      "units": [
        "No."
      ],
      "generalRate": "14%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8606.99.01",
      "rawHtsCode": "8606.99.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "14%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8606.99.0130",
      "rawHtsCode": "8606.99.01.30",
      "superior": null,
      "indent": "3",
      "description": "Flatcars having a flat floor or deck laid on the underframe, with no roof and with no raised sides or ends",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8606.99.0160",
      "rawHtsCode": "8606.99.01.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607",
      "rawHtsCode": "8607",
      "superior": null,
      "indent": "0",
      "description": "Parts of railway or tramway locomotives or rolling stock:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607.11.0000",
      "rawHtsCode": "8607.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Truck assemblies for self-propelled vehicles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8607.12.0000",
      "rawHtsCode": "8607.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other truck assemblies",
      "units": [
        "No."
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8607.19",
      "rawHtsCode": "8607.19",
      "superior": null,
      "indent": "2",
      "description": "Other, including parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607.19.0300",
      "rawHtsCode": "8607.19.03.00",
      "superior": null,
      "indent": "4",
      "description": "Axles",
      "units": [
        "kg"
      ],
      "generalRate": "0.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8607.19.0600",
      "rawHtsCode": "8607.19.06.00",
      "superior": null,
      "indent": "4",
      "description": "Parts of axles",
      "units": [
        "kg"
      ],
      "generalRate": "0.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8607.19.1200",
      "rawHtsCode": "8607.19.12.00",
      "superior": null,
      "indent": "4",
      "description": "Wheels, whether or not fitted with axles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8607.19.1500",
      "rawHtsCode": "8607.19.15.00",
      "superior": null,
      "indent": "4",
      "description": "Parts of wheels",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2.2¢/kg",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8607.19.30",
      "rawHtsCode": "8607.19.30",
      "superior": null,
      "indent": "3",
      "description": "Parts of truck assemblies of vehicles of heading 8605 or 8606",
      "units": [],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8607.19.3010",
      "rawHtsCode": "8607.19.30.10",
      "superior": null,
      "indent": "4",
      "description": "Bolsters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607.19.3020",
      "rawHtsCode": "8607.19.30.20",
      "superior": null,
      "indent": "4",
      "description": "Side frames",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607.19.3090",
      "rawHtsCode": "8607.19.30.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607.19.9000",
      "rawHtsCode": "8607.19.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8607.21",
      "rawHtsCode": "8607.21",
      "superior": null,
      "indent": "2",
      "description": "Air brakes and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607.21.1000",
      "rawHtsCode": "8607.21.10.00",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of heading 8605 or 8606",
      "units": [
        "kg"
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8607.21.5000",
      "rawHtsCode": "8607.21.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8607.29",
      "rawHtsCode": "8607.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607.29.1000",
      "rawHtsCode": "8607.29.10.00",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of heading 8605 or 8606",
      "units": [
        "kg"
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8607.29.5000",
      "rawHtsCode": "8607.29.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8607.30",
      "rawHtsCode": "8607.30",
      "superior": null,
      "indent": "1",
      "description": "Hooks and other coupling devices, buffers, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607.30.10",
      "rawHtsCode": "8607.30.10",
      "superior": null,
      "indent": "2",
      "description": "For vehicles of heading 8605 or 8606",
      "units": [],
      "generalRate": "3.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8607.30.1010",
      "rawHtsCode": "8607.30.10.10",
      "superior": null,
      "indent": "3",
      "description": "Assembled freight rail couplers",
      "units": [
        "kg"
      ],
      "generalRate": "\n",
      "specialRate": "\n",
      "otherRate": "\n",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607.30.1050",
      "rawHtsCode": "8607.30.10.50",
      "superior": null,
      "indent": "3",
      "description": "Freight rail coupler parts",
      "units": [
        "kg"
      ],
      "generalRate": "\n",
      "specialRate": "\n",
      "otherRate": "\n",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607.30.1090",
      "rawHtsCode": "8607.30.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "\n",
      "specialRate": "\n",
      "otherRate": "\n",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607.30.5000",
      "rawHtsCode": "8607.30.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8607.91.0000",
      "rawHtsCode": "8607.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of locomotives",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8607.99",
      "rawHtsCode": "8607.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8607.99.1000",
      "rawHtsCode": "8607.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of heading 8605 or 8606, except brake regulators",
      "units": [
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8607.99.5000",
      "rawHtsCode": "8607.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8608.00.0000",
      "rawHtsCode": "8608.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Railway or tramway track fixtures and fittings; mechanical (including electro-mechanical) signaling, safety or traffic control equipment for railways, tramways, roads, inland waterways, parking facilities, port installations or airfields; parts of the foregoing",
      "units": [
        "kg"
      ],
      "generalRate": "3.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8609.00.0000",
      "rawHtsCode": "8609.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Containers (including containers for the transport of fluids) specially designed and equipped for carriage by one or more modes of transport",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8701",
      "rawHtsCode": "8701",
      "superior": null,
      "indent": "0",
      "description": "Tractors (other than tractors of heading 8709):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.10.0100",
      "rawHtsCode": "8701.10.01.00",
      "superior": null,
      "indent": "1",
      "description": "Single axle tractors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8701.21.00",
      "rawHtsCode": "8701.21.00",
      "superior": null,
      "indent": "2",
      "description": "With only compression-ignition internal combustion piston engine (diesel or semi-diesel)",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8701.21.0015",
      "rawHtsCode": "8701.21.00.15",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. not exceeding <il>36,287 kg</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.21.0045",
      "rawHtsCode": "8701.21.00.45",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>36,287 kg</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.21.0080",
      "rawHtsCode": "8701.21.00.80",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.22.00",
      "rawHtsCode": "8701.22.00",
      "superior": null,
      "indent": "2",
      "description": "With both compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motor as motors for propulsion",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8701.22.0015",
      "rawHtsCode": "8701.22.00.15",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. not exceeding <il>36,287 kg</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.22.0045",
      "rawHtsCode": "8701.22.00.45",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>36,287 kg</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.22.0080",
      "rawHtsCode": "8701.22.00.80",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.23.00",
      "rawHtsCode": "8701.23.00",
      "superior": null,
      "indent": "2",
      "description": "With both spark-ignition internal combustion piston engine and electric motor as motors for propulsion",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8701.23.0015",
      "rawHtsCode": "8701.23.00.15",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. not exceeding <il>36,287 kg</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.23.0045",
      "rawHtsCode": "8701.23.00.45",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>36,287 kg</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.23.0080",
      "rawHtsCode": "8701.23.00.80",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.24.00",
      "rawHtsCode": "8701.24.00",
      "superior": null,
      "indent": "2",
      "description": "With only electric motor for propulsion",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8701.24.0015",
      "rawHtsCode": "8701.24.00.15",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. not exceeding <il>36,287 kg</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.24.0045",
      "rawHtsCode": "8701.24.00.45",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>36,287 kg</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.24.0080",
      "rawHtsCode": "8701.24.00.80",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.29.00",
      "rawHtsCode": "8701.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8701.29.0015",
      "rawHtsCode": "8701.29.00.15",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. not exceeding <il>36,287 kg</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.29.0045",
      "rawHtsCode": "8701.29.00.45",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>36,287 kg</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.29.0080",
      "rawHtsCode": "8701.29.00.80",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30",
      "rawHtsCode": "8701.30",
      "superior": null,
      "indent": "1",
      "description": "Track-laying tractors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30.10",
      "rawHtsCode": "8701.30.10",
      "superior": null,
      "indent": "2",
      "description": "Suitable for agricultural use",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8701.30.1015",
      "rawHtsCode": "8701.30.10.15",
      "superior": null,
      "indent": "4",
      "description": "With a net engine power of less than <il>93.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30.1030",
      "rawHtsCode": "8701.30.10.30",
      "superior": null,
      "indent": "4",
      "description": "With a net engine power of <il>93.3 kW</il> or more but less than 119.4 kW",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30.1045",
      "rawHtsCode": "8701.30.10.45",
      "superior": null,
      "indent": "4",
      "description": "With a net engine power of 119.4 kW or more but less than 194 kW",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30.1060",
      "rawHtsCode": "8701.30.10.60",
      "superior": null,
      "indent": "4",
      "description": "With a net engine power of 194 kW or more but less than 257.4 kW",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30.1075",
      "rawHtsCode": "8701.30.10.75",
      "superior": null,
      "indent": "4",
      "description": "With a net engine power of 257.4 kW or more",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30.1090",
      "rawHtsCode": "8701.30.10.90",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30.50",
      "rawHtsCode": "8701.30.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8701.30.5015",
      "rawHtsCode": "8701.30.50.15",
      "superior": null,
      "indent": "4",
      "description": "With a net engine power of less than <il>93.3 kW</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30.5030",
      "rawHtsCode": "8701.30.50.30",
      "superior": null,
      "indent": "4",
      "description": "With a net engine power of <il>93.3 kW</il> or more but less than 119.4 kW",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30.5045",
      "rawHtsCode": "8701.30.50.45",
      "superior": null,
      "indent": "4",
      "description": "With a net engine power of 119.4 kW or more but less than 194 kW",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30.5060",
      "rawHtsCode": "8701.30.50.60",
      "superior": null,
      "indent": "4",
      "description": "With a net engine power of 194 kW or more but less than 257.4 kW",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30.5075",
      "rawHtsCode": "8701.30.50.75",
      "superior": null,
      "indent": "4",
      "description": "With a net engine power of 257.4 kW or more",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.30.5090",
      "rawHtsCode": "8701.30.50.90",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.91",
      "rawHtsCode": "8701.91",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 18 kW:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.91.1000",
      "rawHtsCode": "8701.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "For agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8701.91.5000",
      "rawHtsCode": "8701.91.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8701.92",
      "rawHtsCode": "8701.92",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 18 kW but not exceeding 37 kW:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.92.1000",
      "rawHtsCode": "8701.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "Suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8701.92.5000",
      "rawHtsCode": "8701.92.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8701.93",
      "rawHtsCode": "8701.93",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 37 kW but not exceeding 75 kW:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.93.1000",
      "rawHtsCode": "8701.93.10.00",
      "superior": null,
      "indent": "3",
      "description": "Suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8701.93.5000",
      "rawHtsCode": "8701.93.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8701.94",
      "rawHtsCode": "8701.94",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 75 kW but not exceeding 130 kW:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.94.1000",
      "rawHtsCode": "8701.94.10.00",
      "superior": null,
      "indent": "3",
      "description": "Suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8701.94.5000",
      "rawHtsCode": "8701.94.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8701.95",
      "rawHtsCode": "8701.95",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 130 kW:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8701.95.1000",
      "rawHtsCode": "8701.95.10.00",
      "superior": null,
      "indent": "3",
      "description": "Suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8701.95.5000",
      "rawHtsCode": "8701.95.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8702",
      "rawHtsCode": "8702",
      "superior": null,
      "indent": "0",
      "description": "Motor vehicles for the transport of ten or more persons, including the driver:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8702.10",
      "rawHtsCode": "8702.10",
      "superior": null,
      "indent": "1",
      "description": "With only compression-ignition internal combustion piston engine (diesel or semi-diesel):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8702.10.3100",
      "rawHtsCode": "8702.10.31.00",
      "superior": null,
      "indent": "2",
      "description": "Designed for the transport of 16 or more persons, including the driver",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8702.10.6100",
      "rawHtsCode": "8702.10.61.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8702.20",
      "rawHtsCode": "8702.20",
      "superior": null,
      "indent": "1",
      "description": "With both compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motor as motors for propulsion:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8702.20.3100",
      "rawHtsCode": "8702.20.31.00",
      "superior": null,
      "indent": "2",
      "description": "Designed for the transport of 16 or more  persons, including the driver",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8702.20.6100",
      "rawHtsCode": "8702.20.61.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8702.30",
      "rawHtsCode": "8702.30",
      "superior": null,
      "indent": "1",
      "description": "With both spark-ignition internal combustion piston engine and electric motor as motors for propulsion:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8702.30.3100",
      "rawHtsCode": "8702.30.31.00",
      "superior": null,
      "indent": "2",
      "description": "Designed for the transport of 16 or more  persons, including the driver",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8702.30.6100",
      "rawHtsCode": "8702.30.61.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8702.40",
      "rawHtsCode": "8702.40",
      "superior": null,
      "indent": "1",
      "description": "With only electric motor for propulsion:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8702.40.3100",
      "rawHtsCode": "8702.40.31.00",
      "superior": null,
      "indent": "2",
      "description": "Designed for the transport of 16 or more persons, including the driver",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8702.40.6100",
      "rawHtsCode": "8702.40.61.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8702.90",
      "rawHtsCode": "8702.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8702.90.3100",
      "rawHtsCode": "8702.90.31.00",
      "superior": null,
      "indent": "2",
      "description": "Designed for the transport of 16 or more persons, including the driver",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8702.90.6100",
      "rawHtsCode": "8702.90.61.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703",
      "rawHtsCode": "8703",
      "superior": null,
      "indent": "0",
      "description": "Motor cars and other motor vehicles principally designed for the transport of persons (other than those of heading 8702), including station wagons and racing cars:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.10",
      "rawHtsCode": "8703.10",
      "superior": null,
      "indent": "1",
      "description": "Vehicles specially designed for traveling on snow; golf carts and similar vehicles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.10.1000",
      "rawHtsCode": "8703.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Vehicles specially designed for traveling on snow",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.10.50",
      "rawHtsCode": "8703.10.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.10.5030",
      "rawHtsCode": "8703.10.50.30",
      "superior": null,
      "indent": "3",
      "description": "Golf carts",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.10.5060",
      "rawHtsCode": "8703.10.50.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.21.01",
      "rawHtsCode": "8703.21.01",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity not exceeding 1,000 cc",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.21.0110",
      "rawHtsCode": "8703.21.01.10",
      "superior": null,
      "indent": "4",
      "description": "With label indicating that vehicle is for operation only by persons at least 16 years of age",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.21.0130",
      "rawHtsCode": "8703.21.01.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.21.0150",
      "rawHtsCode": "8703.21.01.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.22.01",
      "rawHtsCode": "8703.22.01",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity exceeding 1,000 cc but not exceeding 1,500 cc",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.22.0110",
      "rawHtsCode": "8703.22.01.10",
      "superior": null,
      "indent": "3",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.22.0190",
      "rawHtsCode": "8703.22.01.90",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.23.01",
      "rawHtsCode": "8703.23.01",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity exceeding 1,500 cc but not exceeding 3,000 cc",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.23.0110",
      "rawHtsCode": "8703.23.01.10",
      "superior": null,
      "indent": "3",
      "description": "Motor homes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.23.0120",
      "rawHtsCode": "8703.23.01.20",
      "superior": null,
      "indent": "7",
      "description": "Station wagons under 160 cm in height",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.23.0130",
      "rawHtsCode": "8703.23.01.30",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.23.0140",
      "rawHtsCode": "8703.23.01.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.23.0160",
      "rawHtsCode": "8703.23.01.60",
      "superior": null,
      "indent": "5",
      "description": "Having engines with more than 4 cylinders but not more than 6 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.23.0170",
      "rawHtsCode": "8703.23.01.70",
      "superior": null,
      "indent": "5",
      "description": "Having engines with more than 6 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.23.0190",
      "rawHtsCode": "8703.23.01.90",
      "superior": null,
      "indent": "4",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.24.01",
      "rawHtsCode": "8703.24.01",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity exceeding 3,000 cc",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.24.0110",
      "rawHtsCode": "8703.24.01.10",
      "superior": null,
      "indent": "3",
      "description": "Ambulances, hearses and prison vans",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.24.0130",
      "rawHtsCode": "8703.24.01.30",
      "superior": null,
      "indent": "3",
      "description": "Motor homes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.24.0140",
      "rawHtsCode": "8703.24.01.40",
      "superior": null,
      "indent": "5",
      "description": "Having engines with not more than 4 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.24.0150",
      "rawHtsCode": "8703.24.01.50",
      "superior": null,
      "indent": "5",
      "description": "Having engines with more than 4 cylinders but not more than 6 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.24.0160",
      "rawHtsCode": "8703.24.01.60",
      "superior": null,
      "indent": "5",
      "description": "Having engines with more than 6 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.24.0190",
      "rawHtsCode": "8703.24.01.90",
      "superior": null,
      "indent": "4",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.31.0100",
      "rawHtsCode": "8703.31.01.00",
      "superior": null,
      "indent": "2",
      "description": " Of a cylinder capacity not exceeding 1,500 cc",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.32.01",
      "rawHtsCode": "8703.32.01",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity exceeding 1,500 cc but not exceeding 2,500 cc",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.32.0110",
      "rawHtsCode": "8703.32.01.10",
      "superior": null,
      "indent": "3",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.32.0150",
      "rawHtsCode": "8703.32.01.50",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.33.01",
      "rawHtsCode": "8703.33.01",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity exceeding 2,500 cc",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.33.0110",
      "rawHtsCode": "8703.33.01.10",
      "superior": null,
      "indent": "3",
      "description": "Ambulances, hearses, and prison vans",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.33.0130",
      "rawHtsCode": "8703.33.01.30",
      "superior": null,
      "indent": "3",
      "description": "Motor homes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.33.0145",
      "rawHtsCode": "8703.33.01.45",
      "superior": null,
      "indent": "4",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.33.0185",
      "rawHtsCode": "8703.33.01.85",
      "superior": null,
      "indent": "4",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.00",
      "rawHtsCode": "8703.40.00",
      "superior": null,
      "indent": "1",
      "description": "Other vehicles, with both spark-ignition internal combustion piston engine and electric motor as motors for propulsion, other than those capable of being charged by plugging to external source of electric power",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.40.0005",
      "rawHtsCode": "8703.40.00.05",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity not exceeding 1,000 cc",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.0010",
      "rawHtsCode": "8703.40.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity exceeding 1,000 cc but not exceeding 1.500 cc",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.0015",
      "rawHtsCode": "8703.40.00.15",
      "superior": null,
      "indent": "3",
      "description": "Motor homes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.0020",
      "rawHtsCode": "8703.40.00.20",
      "superior": null,
      "indent": "5",
      "description": "Having engines with not more than 4 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.0030",
      "rawHtsCode": "8703.40.00.30",
      "superior": null,
      "indent": "5",
      "description": "Having engines with more than 4 cylinders but not more than 6 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.0040",
      "rawHtsCode": "8703.40.00.40",
      "superior": null,
      "indent": "5",
      "description": "Having engines with more than 6 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.0045",
      "rawHtsCode": "8703.40.00.45",
      "superior": null,
      "indent": "4",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.0050",
      "rawHtsCode": "8703.40.00.50",
      "superior": null,
      "indent": "3",
      "description": "Ambulances, hearses and prison vans",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.0055",
      "rawHtsCode": "8703.40.00.55",
      "superior": null,
      "indent": "3",
      "description": "Motor homes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.0060",
      "rawHtsCode": "8703.40.00.60",
      "superior": null,
      "indent": "5",
      "description": "Having engines with not more than 4 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.0070",
      "rawHtsCode": "8703.40.00.70",
      "superior": null,
      "indent": "5",
      "description": "Having engines with more than 4 cylinders but not more than 6 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.0080",
      "rawHtsCode": "8703.40.00.80",
      "superior": null,
      "indent": "5",
      "description": "Having engines with more than 6 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.40.0090",
      "rawHtsCode": "8703.40.00.90",
      "superior": null,
      "indent": "4",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.50.00",
      "rawHtsCode": "8703.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other vehicles, with both compression-ignition internal combustion piston engine and electric motor as motors for propulsion, other than those capable of being charged by plugging to external source of electric power",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.50.0010",
      "rawHtsCode": "8703.50.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity not exceeding 1,500 cc",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.50.0030",
      "rawHtsCode": "8703.50.00.30",
      "superior": null,
      "indent": "3",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.50.0050",
      "rawHtsCode": "8703.50.00.50",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.50.0060",
      "rawHtsCode": "8703.50.00.60",
      "superior": null,
      "indent": "3",
      "description": "Ambulances, hearses and prison vans",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.50.0065",
      "rawHtsCode": "8703.50.00.65",
      "superior": null,
      "indent": "3",
      "description": "Motor homes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.50.0070",
      "rawHtsCode": "8703.50.00.70",
      "superior": null,
      "indent": "4",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.50.0090",
      "rawHtsCode": "8703.50.00.90",
      "superior": null,
      "indent": "4",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.00",
      "rawHtsCode": "8703.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other vehicles, with both spark-ignition internal combustion piston engine and electric motor as motors for propulsion, capable of being charged by plugging to external source of electric power",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.60.0005",
      "rawHtsCode": "8703.60.00.05",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity not exceeding 1,000 cc",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.0010",
      "rawHtsCode": "8703.60.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity exceeding 1,000 cc but not exceeding 1,500 cc",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.0015",
      "rawHtsCode": "8703.60.00.15",
      "superior": null,
      "indent": "3",
      "description": "Motor homes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.0020",
      "rawHtsCode": "8703.60.00.20",
      "superior": null,
      "indent": "5",
      "description": "Having engines with not more than 4 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.0030",
      "rawHtsCode": "8703.60.00.30",
      "superior": null,
      "indent": "5",
      "description": "Having engines with more than 4 cylinders but not more than 6 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.0040",
      "rawHtsCode": "8703.60.00.40",
      "superior": null,
      "indent": "5",
      "description": "Having engines with more than 6 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.0045",
      "rawHtsCode": "8703.60.00.45",
      "superior": null,
      "indent": "4",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.0050",
      "rawHtsCode": "8703.60.00.50",
      "superior": null,
      "indent": "3",
      "description": "Ambulances, hearses and prison vans",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.0055",
      "rawHtsCode": "8703.60.00.55",
      "superior": null,
      "indent": "3",
      "description": "Motor homes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.0060",
      "rawHtsCode": "8703.60.00.60",
      "superior": null,
      "indent": "5",
      "description": "Having engines with not more than 4 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.0070",
      "rawHtsCode": "8703.60.00.70",
      "superior": null,
      "indent": "5",
      "description": "Having engines with more than 4 cylinders but not more than 6 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.0080",
      "rawHtsCode": "8703.60.00.80",
      "superior": null,
      "indent": "5",
      "description": "Having engines with more than 6 cylinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.60.0090",
      "rawHtsCode": "8703.60.00.90",
      "superior": null,
      "indent": "4",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.70.00",
      "rawHtsCode": "8703.70.00",
      "superior": null,
      "indent": "1",
      "description": "Other vehicles, with both  compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motor as motors for propulsion, capable of being charged by plugging to external source of electric power:",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.70.0010",
      "rawHtsCode": "8703.70.00.10",
      "superior": null,
      "indent": "2",
      "description": "Of a cylinder capacity not exceeding 1,500 cc",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.70.0030",
      "rawHtsCode": "8703.70.00.30",
      "superior": null,
      "indent": "3",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.70.0050",
      "rawHtsCode": "8703.70.00.50",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.70.0060",
      "rawHtsCode": "8703.70.00.60",
      "superior": null,
      "indent": "3",
      "description": "Ambulances, hearses and prison vans",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.70.0065",
      "rawHtsCode": "8703.70.00.65",
      "superior": null,
      "indent": "3",
      "description": "Motor homes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.70.0070",
      "rawHtsCode": "8703.70.00.70",
      "superior": null,
      "indent": "4",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.70.0090",
      "rawHtsCode": "8703.70.00.90",
      "superior": null,
      "indent": "4",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.80.00",
      "rawHtsCode": "8703.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other vehicles, with only electric motors for propulsion",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8703.80.0020",
      "rawHtsCode": "8703.80.00.20",
      "superior": null,
      "indent": "3",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.80.0045",
      "rawHtsCode": "8703.80.00.45",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.80.0060",
      "rawHtsCode": "8703.80.00.60",
      "superior": null,
      "indent": "3",
      "description": "New",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.80.0080",
      "rawHtsCode": "8703.80.00.80",
      "superior": null,
      "indent": "3",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8703.90.0100",
      "rawHtsCode": "8703.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704",
      "rawHtsCode": "8704",
      "superior": null,
      "indent": "0",
      "description": "Motor vehicles for the transport of goods:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.10",
      "rawHtsCode": "8704.10",
      "superior": null,
      "indent": "1",
      "description": "Dumpers designed for off-highway use:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.10.1000",
      "rawHtsCode": "8704.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Cab chassis",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8704.10.50",
      "rawHtsCode": "8704.10.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8704.10.5020",
      "rawHtsCode": "8704.10.50.20",
      "superior": null,
      "indent": "4",
      "description": "With a capacity of <il>40.8 metric tons</il> or less",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.10.5030",
      "rawHtsCode": "8704.10.50.30",
      "superior": null,
      "indent": "4",
      "description": "With a capacity exceeding <il>40.8 metric tons</il> but not exceeding <il>63.5 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.10.5040",
      "rawHtsCode": "8704.10.50.40",
      "superior": null,
      "indent": "4",
      "description": "With a capacity exceeding <il>63.5 metric tons</il> but not exceeding <il>90.7 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.10.5050",
      "rawHtsCode": "8704.10.50.50",
      "superior": null,
      "indent": "4",
      "description": "With a capacity exceeding <il>90.7 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.10.5060",
      "rawHtsCode": "8704.10.50.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.21.0100",
      "rawHtsCode": "8704.21.01.00",
      "superior": null,
      "indent": "2",
      "description": "G.V.W. not exceeding <il>5 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,MA,OM,P,PA,PE,S,SG)25% (KR)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704.22",
      "rawHtsCode": "8704.22",
      "superior": null,
      "indent": "2",
      "description": "G.V.W. exceeding <il>5 metric tons</il> but not exceeding <il>20 metric tons:</il>",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.22.11",
      "rawHtsCode": "8704.22.11",
      "superior": null,
      "indent": "3",
      "description": "Cab chassis",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704.22.1120",
      "rawHtsCode": "8704.22.11.20",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>5 metric tons</il> but not exceeding <il>9 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.22.1140",
      "rawHtsCode": "8704.22.11.40",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>9 metric tons</il> but not exceeding <il>12 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.22.1160",
      "rawHtsCode": "8704.22.11.60",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>12 metric tons</il> but not exceeding <il>15 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.22.1180",
      "rawHtsCode": "8704.22.11.80",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>15 metric tons</il> but not exceeding <il>20 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.22.51",
      "rawHtsCode": "8704.22.51",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,MA,OM,P,PA,PE,S,SG)25% (KR)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704.22.5120",
      "rawHtsCode": "8704.22.51.20",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>5 metric tons</il> but not exceeding <il>9 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.22.5140",
      "rawHtsCode": "8704.22.51.40",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>9 metric tons</il> but not exceeding <il>12 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.22.5160",
      "rawHtsCode": "8704.22.51.60",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>12 metric tons</il> but not exceeding <il>15 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.22.5180",
      "rawHtsCode": "8704.22.51.80",
      "superior": null,
      "indent": "4",
      "description": "G.V.W. exceeding <il>15 metric tons</il> but not exceeding <il>20 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.23.0100",
      "rawHtsCode": "8704.23.01.00",
      "superior": null,
      "indent": "2",
      "description": "G.V.W. exceeding <il>20 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,MA,OM,P,PA,PE,S,SG)25% (KR)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704.31.01",
      "rawHtsCode": "8704.31.01",
      "superior": null,
      "indent": "2",
      "description": "G.V.W. not exceeding <il>5 metric tons</il>",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,MA,OM,P,PA,PE,S,SG)25% (KR)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704.31.0120",
      "rawHtsCode": "8704.31.01.20",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. not exceeding <il>2.5 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.31.0140",
      "rawHtsCode": "8704.31.01.40",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding 2.5 metric tons but not exceeding 5 metric tons",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.32.01",
      "rawHtsCode": "8704.32.01",
      "superior": null,
      "indent": "2",
      "description": "G.V.W. exceeding <il>5 metric tons</il>",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,MA,OM,P,PA,PE,S,SG)25% (KR)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704.32.0110",
      "rawHtsCode": "8704.32.01.10",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding <il>5 metric tons</il> but not exceeding <il>9 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.32.0120",
      "rawHtsCode": "8704.32.01.20",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding <il>9 metric tons</il> but not exceeding <il>12 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.32.0130",
      "rawHtsCode": "8704.32.01.30",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding <il>12 metric tons</il> but not exceeding <il>15 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.32.0140",
      "rawHtsCode": "8704.32.01.40",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding <il>15 metric tons</il> but not exceeding <il>20 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.32.0150",
      "rawHtsCode": "8704.32.01.50",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding <il>20 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.41.0000",
      "rawHtsCode": "8704.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "G.V.W. not exceeding <il>5 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,MA,OM,P,PA,PE,S,SG)25% (KR)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704.42.00",
      "rawHtsCode": "8704.42.00",
      "superior": null,
      "indent": "2",
      "description": "G.V.W. exceeding 5 metric tons but not exceeding 20 metric tons",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,MA,OM,P,PA,PE,S,SG)25% (KR)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704.42.0020",
      "rawHtsCode": "8704.42.00.20",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding 5 metric tons but not exceeding 9 metric tons",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.42.0040",
      "rawHtsCode": "8704.42.00.40",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding <il>9 metric tons</il> but not exceeding <il>12 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.42.0060",
      "rawHtsCode": "8704.42.00.60",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding 12 metric tons but not exceeding 15 metric tons",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.42.0080",
      "rawHtsCode": "8704.42.00.80",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding 15 metric tons but not exceeding 20 metric tons",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.43.0000",
      "rawHtsCode": "8704.43.00.00",
      "superior": null,
      "indent": "2",
      "description": "G.V.W. exceeding 20 metric tons ",
      "units": [
        "No."
      ],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,MA,OM,P,PA,PE,S,SG)25% (KR)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704.51.00",
      "rawHtsCode": "8704.51.00",
      "superior": null,
      "indent": "2",
      "description": "G.V.W. not exceeding 5 metric tons ",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,MA,OM,P,PA,PE,S,SG)25% (KR)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704.51.0020",
      "rawHtsCode": "8704.51.00.20",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. not exceeding 2.5 metric tons ",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.51.0040",
      "rawHtsCode": "8704.51.00.40",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding 2.5 metric tons but not exceeding 5 metric tons",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.52.00",
      "rawHtsCode": "8704.52.00",
      "superior": null,
      "indent": "2",
      "description": "G.V.W. exceeding 5 metric tons ",
      "units": [],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,MA,OM,P,PA,PE,S,SG)25% (KR)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704.52.0010",
      "rawHtsCode": "8704.52.00.10",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding 5 metric tons but not exceeding 9 metric tons",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.52.0020",
      "rawHtsCode": "8704.52.00.20",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding <il>9 metric tons</il> but not exceeding <il>12 metric tons</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.52.0030",
      "rawHtsCode": "8704.52.00.30",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding 12 metric tons but not exceeding 15 metric tons",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.52.0040",
      "rawHtsCode": "8704.52.00.40",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding 15 metric tons but not exceeding 20 metric tons",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.52.0050",
      "rawHtsCode": "8704.52.00.50",
      "superior": null,
      "indent": "3",
      "description": "G.V.W. exceeding 20 metric tons",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8704.60.0000",
      "rawHtsCode": "8704.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other, with only electric motor for propulsion",
      "units": [
        "No."
      ],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,MA,OM,P,PA,PE,S,SG)25% (KR)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8704.90.0100",
      "rawHtsCode": "8704.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "25%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,MA,OM,P,PA,PE,S,SG)25% (KR)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8705",
      "rawHtsCode": "8705",
      "superior": null,
      "indent": "0",
      "description": "Special purpose motor vehicles, other than those principally designed for the transport of persons or goods (for example, wreckers, mobile cranes, fire fighting vehicles, concrete mixers, road sweepers, spraying vehicles, mobile workshops, mobile radiological units):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8705.10.00",
      "rawHtsCode": "8705.10.00",
      "superior": null,
      "indent": "1",
      "description": "Mobile cranes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8705.10.0010",
      "rawHtsCode": "8705.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Cable operated",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8705.10.0050",
      "rawHtsCode": "8705.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8705.20.0000",
      "rawHtsCode": "8705.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mobile drilling derricks",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "8705.30.0000",
      "rawHtsCode": "8705.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Fire fighting vehicles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8705.40.0000",
      "rawHtsCode": "8705.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Concrete mixers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8705.90.00",
      "rawHtsCode": "8705.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8705.90.0010",
      "rawHtsCode": "8705.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Mobile radiological units",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8705.90.0020",
      "rawHtsCode": "8705.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Mobile medical clinics",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8705.90.0080",
      "rawHtsCode": "8705.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8706.00",
      "rawHtsCode": "8706.00",
      "superior": null,
      "indent": "0",
      "description": "Chassis fitted with engines, for the motor vehicles of headings 8701 to 8705:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8706.00.0300",
      "rawHtsCode": "8706.00.03.00",
      "superior": null,
      "indent": "2",
      "description": "For vehicles of subheading 8704.21 or 8704.31",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8706.00.05",
      "rawHtsCode": "8706.00.05",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8706.00.0520",
      "rawHtsCode": "8706.00.05.20",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8706.00.0540",
      "rawHtsCode": "8706.00.05.40",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of heading 8702",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8706.00.0575",
      "rawHtsCode": "8706.00.05.75",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of heading 8704",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8706.00.15",
      "rawHtsCode": "8706.00.15",
      "superior": null,
      "indent": "1",
      "description": "For vehicles of heading 8703",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8706.00.1520",
      "rawHtsCode": "8706.00.15.20",
      "superior": null,
      "indent": "2",
      "description": "For passenger automobiles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8706.00.1540",
      "rawHtsCode": "8706.00.15.40",
      "superior": null,
      "indent": "2",
      "description": "For other vehicles of heading 8703",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8706.00.2500",
      "rawHtsCode": "8706.00.25.00",
      "superior": null,
      "indent": "1",
      "description": "For vehicles of heading 8705",
      "units": [
        "No."
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8706.00.3000",
      "rawHtsCode": "8706.00.30.00",
      "superior": null,
      "indent": "2",
      "description": "For tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8706.00.5000",
      "rawHtsCode": "8706.00.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8707",
      "rawHtsCode": "8707",
      "superior": null,
      "indent": "0",
      "description": "Bodies (including cabs), for the motor vehicles of headings 8701 to 8705:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8707.10.00",
      "rawHtsCode": "8707.10.00",
      "superior": null,
      "indent": "1",
      "description": "For vehicles of heading 8703",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8707.10.0020",
      "rawHtsCode": "8707.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "For passenger automobiles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8707.10.0040",
      "rawHtsCode": "8707.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "For other vehicles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8707.90",
      "rawHtsCode": "8707.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8707.90.1000",
      "rawHtsCode": "8707.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "For tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8707.90.50",
      "rawHtsCode": "8707.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8707.90.5020",
      "rawHtsCode": "8707.90.50.20",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8707.90.5040",
      "rawHtsCode": "8707.90.50.40",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of heading 8702",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8707.90.5060",
      "rawHtsCode": "8707.90.50.60",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of heading 8704",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8707.90.5080",
      "rawHtsCode": "8707.90.50.80",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of heading 8705",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8707.90.5090",
      "rawHtsCode": "8707.90.50.90",
      "superior": null,
      "indent": "3",
      "description": "For other vehicles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708",
      "rawHtsCode": "8708",
      "superior": null,
      "indent": "0",
      "description": "Parts and accessories of the motor vehicles of headings 8701 to 8705:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.10",
      "rawHtsCode": "8708.10",
      "superior": null,
      "indent": "1",
      "description": "Bumpers and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.10.30",
      "rawHtsCode": "8708.10.30",
      "superior": null,
      "indent": "2",
      "description": "Bumpers",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.10.3020",
      "rawHtsCode": "8708.10.30.20",
      "superior": null,
      "indent": "4",
      "description": "Of steel",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.10.3030",
      "rawHtsCode": "8708.10.30.30",
      "superior": null,
      "indent": "4",
      "description": "Of aluminum",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.10.3040",
      "rawHtsCode": "8708.10.30.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.10.3050",
      "rawHtsCode": "8708.10.30.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.10.60",
      "rawHtsCode": "8708.10.60",
      "superior": null,
      "indent": "2",
      "description": "Parts of bumpers",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.10.6010",
      "rawHtsCode": "8708.10.60.10",
      "superior": null,
      "indent": "3",
      "description": "Stampings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.10.6050",
      "rawHtsCode": "8708.10.60.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.21.0000",
      "rawHtsCode": "8708.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Safety seat belts",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.22.0000",
      "rawHtsCode": "8708.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Front windscreens (windshields), rear windows and  other windows specified in subheading note 1 to this chapter",
      "units": [
        "No.",
        "m<sup>2</sup>"
      ],
      "generalRate": "2.5% <u></u>",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.29",
      "rawHtsCode": "8708.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.29.1500",
      "rawHtsCode": "8708.29.15.00",
      "superior": null,
      "indent": "3",
      "description": "Door assemblies",
      "units": [
        "No."
      ],
      "generalRate": "2.5% <u></u>",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.29.21",
      "rawHtsCode": "8708.29.21",
      "superior": null,
      "indent": "4",
      "description": "For tractors suitable for agricultural use",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8708.29.2120",
      "rawHtsCode": "8708.29.21.20",
      "superior": null,
      "indent": "5",
      "description": "Of steel",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.29.2130",
      "rawHtsCode": "8708.29.21.30",
      "superior": null,
      "indent": "5",
      "description": "Of aluminum",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.29.2140",
      "rawHtsCode": "8708.29.21.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.29.2500",
      "rawHtsCode": "8708.29.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.5%<u></u>",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.29.51",
      "rawHtsCode": "8708.29.51",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.5% <u></u>",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.29.5110",
      "rawHtsCode": "8708.29.51.10",
      "superior": null,
      "indent": "4",
      "description": "Stampings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.29.5125",
      "rawHtsCode": "8708.29.51.25",
      "superior": null,
      "indent": "4",
      "description": "Truck caps",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.29.5160",
      "rawHtsCode": "8708.29.51.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.30",
      "rawHtsCode": "8708.30",
      "superior": null,
      "indent": "1",
      "description": "Brakes and servo-brakes; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.30.10",
      "rawHtsCode": "8708.30.10",
      "superior": null,
      "indent": "2",
      "description": "For tractors suitable for agricultural use",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.30.1010",
      "rawHtsCode": "8708.30.10.10",
      "superior": null,
      "indent": "3",
      "description": "Mounted brake linings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.30.1090",
      "rawHtsCode": "8708.30.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.30.50",
      "rawHtsCode": "8708.30.50",
      "superior": null,
      "indent": "2",
      "description": "For other vehicles",
      "units": [],
      "generalRate": "2.5% <u></u>",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.30.5020",
      "rawHtsCode": "8708.30.50.20",
      "superior": null,
      "indent": "3",
      "description": "Brake drums",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.30.5030",
      "rawHtsCode": "8708.30.50.30",
      "superior": null,
      "indent": "3",
      "description": "Brake rotors (discs)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.30.5040",
      "rawHtsCode": "8708.30.50.40",
      "superior": null,
      "indent": "3",
      "description": "Mounted brake linings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.30.5090",
      "rawHtsCode": "8708.30.50.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.40",
      "rawHtsCode": "8708.40",
      "superior": null,
      "indent": "1",
      "description": "Gear boxes and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.40.11",
      "rawHtsCode": "8708.40.11",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or heading 8702, 8703 or 8704",
      "units": [],
      "generalRate": "2.5%<u></u>",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.40.1110",
      "rawHtsCode": "8708.40.11.10",
      "superior": null,
      "indent": "4",
      "description": "For vehicles of heading 8703",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.40.1150",
      "rawHtsCode": "8708.40.11.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.40.3000",
      "rawHtsCode": "8708.40.30.00",
      "superior": null,
      "indent": "3",
      "description": "For tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8708.40.5000",
      "rawHtsCode": "8708.40.50.00",
      "superior": null,
      "indent": "3",
      "description": "For other vehicles",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.40.6000",
      "rawHtsCode": "8708.40.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.40.6500",
      "rawHtsCode": "8708.40.65.00",
      "superior": null,
      "indent": "3",
      "description": "Of other tractors (except road tractors)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8708.40.7000",
      "rawHtsCode": "8708.40.70.00",
      "superior": null,
      "indent": "4",
      "description": "Of cast iron",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8708.40.75",
      "rawHtsCode": "8708.40.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.40.7570",
      "rawHtsCode": "8708.40.75.70",
      "superior": null,
      "indent": "5",
      "description": "Steel forgings",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8708.40.7580",
      "rawHtsCode": "8708.40.75.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.50",
      "rawHtsCode": "8708.50",
      "superior": null,
      "indent": "1",
      "description": "Drive-axles with differential, whether or not provided with other transmission components, and non-driving axles; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.50.11",
      "rawHtsCode": "8708.50.11",
      "superior": null,
      "indent": "4",
      "description": "For tractors suitable for agricultural use",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.50.1110",
      "rawHtsCode": "8708.50.11.10",
      "superior": null,
      "indent": "5",
      "description": "Drive axles with differential, whether or not provided with other transmission components",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.50.1150",
      "rawHtsCode": "8708.50.11.50",
      "superior": null,
      "indent": "5",
      "description": "Non-driving axles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.50.31",
      "rawHtsCode": "8708.50.31",
      "superior": null,
      "indent": "4",
      "description": "For other tractors",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.50.3110",
      "rawHtsCode": "8708.50.31.10",
      "superior": null,
      "indent": "5",
      "description": "Drive axles with differential, whether or not provided with other transmission components",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.50.3150",
      "rawHtsCode": "8708.50.31.50",
      "superior": null,
      "indent": "5",
      "description": "Non-driving axles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.50.51",
      "rawHtsCode": "8708.50.51",
      "superior": null,
      "indent": "3",
      "description": "For vehicles of heading 8703",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.50.5110",
      "rawHtsCode": "8708.50.51.10",
      "superior": null,
      "indent": "4",
      "description": "Drive axles with differential, whether or not provided with other transmission components",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.50.5150",
      "rawHtsCode": "8708.50.51.50",
      "superior": null,
      "indent": "4",
      "description": "Non-driving axles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.50.6100",
      "rawHtsCode": "8708.50.61.00",
      "superior": null,
      "indent": "4",
      "description": "Drive axles with differential, whether or not provided with other transmission components",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.50.6500",
      "rawHtsCode": "8708.50.65.00",
      "superior": null,
      "indent": "4",
      "description": "Non-driving axles",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.50.7000",
      "rawHtsCode": "8708.50.70.00",
      "superior": null,
      "indent": "4",
      "description": "For tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.50.7500",
      "rawHtsCode": "8708.50.75.00",
      "superior": null,
      "indent": "4",
      "description": "For other tractors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.50.7900",
      "rawHtsCode": "8708.50.79.00",
      "superior": null,
      "indent": "4",
      "description": "Parts of non-driving axles",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.50.8100",
      "rawHtsCode": "8708.50.81.00",
      "superior": null,
      "indent": "5",
      "description": "Of cast iron",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8708.50.8500",
      "rawHtsCode": "8708.50.85.00",
      "superior": null,
      "indent": "6",
      "description": "Half-shafts",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.50.8900",
      "rawHtsCode": "8708.50.89.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.50.91",
      "rawHtsCode": "8708.50.91",
      "superior": null,
      "indent": "4",
      "description": "Parts of non-driving axles",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.50.9110",
      "rawHtsCode": "8708.50.91.10",
      "superior": null,
      "indent": "5",
      "description": "Spindles",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.50.9150",
      "rawHtsCode": "8708.50.91.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.50.9300",
      "rawHtsCode": "8708.50.93.00",
      "superior": null,
      "indent": "5",
      "description": "Of cast iron",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.50.9500",
      "rawHtsCode": "8708.50.95.00",
      "superior": null,
      "indent": "6",
      "description": "Half-shafts",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.50.9900",
      "rawHtsCode": "8708.50.99.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.70",
      "rawHtsCode": "8708.70",
      "superior": null,
      "indent": "1",
      "description": "Road wheels and parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.70.0500",
      "rawHtsCode": "8708.70.05.00",
      "superior": null,
      "indent": "4",
      "description": "Road wheels",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.70.1500",
      "rawHtsCode": "8708.70.15.00",
      "superior": null,
      "indent": "4",
      "description": "Parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.70.2500",
      "rawHtsCode": "8708.70.25.00",
      "superior": null,
      "indent": "4",
      "description": "Road wheels",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.70.3500",
      "rawHtsCode": "8708.70.35.00",
      "superior": null,
      "indent": "4",
      "description": "Parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.70.45",
      "rawHtsCode": "8708.70.45",
      "superior": null,
      "indent": "3",
      "description": "Road wheels",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.70.4530",
      "rawHtsCode": "8708.70.45.30",
      "superior": null,
      "indent": "4",
      "description": "For vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or heading 8702, 8704 or 8705",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.70.4546",
      "rawHtsCode": "8708.70.45.46",
      "superior": null,
      "indent": "6",
      "description": "Wheels having a diameter of at least 57 cm but not more than 63 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.70.4548",
      "rawHtsCode": "8708.70.45.48",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.70.4560",
      "rawHtsCode": "8708.70.45.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.70.60",
      "rawHtsCode": "8708.70.60",
      "superior": null,
      "indent": "3",
      "description": "Parts and accessories",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.70.6030",
      "rawHtsCode": "8708.70.60.30",
      "superior": null,
      "indent": "4",
      "description": "Wheel rims for vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or heading 8702, 8703, 8704, or 8705",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.70.6045",
      "rawHtsCode": "8708.70.60.45",
      "superior": null,
      "indent": "4",
      "description": "Wheel covers and hubcaps for vehicles of subheading 8701.21, 8701.22, 8701.23, 8701.24 or 8701.29 or heading 8702, 8703, 8704 or 8705",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.70.6060",
      "rawHtsCode": "8708.70.60.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.80",
      "rawHtsCode": "8708.80",
      "superior": null,
      "indent": "1",
      "description": "Suspension systems and parts thereof (including shock absorbers):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.80.0300",
      "rawHtsCode": "8708.80.03.00",
      "superior": null,
      "indent": "4",
      "description": "McPherson struts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.80.0500",
      "rawHtsCode": "8708.80.05.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.80.1300",
      "rawHtsCode": "8708.80.13.00",
      "superior": null,
      "indent": "4",
      "description": "McPherson struts",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.80.1600",
      "rawHtsCode": "8708.80.16.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.80.5100",
      "rawHtsCode": "8708.80.51.00",
      "superior": null,
      "indent": "3",
      "description": "Of tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.80.5500",
      "rawHtsCode": "8708.80.55.00",
      "superior": null,
      "indent": "3",
      "description": "Of other tractors (except road tractors)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.80.6000",
      "rawHtsCode": "8708.80.60.00",
      "superior": null,
      "indent": "4",
      "description": "Of cast iron",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.80.65",
      "rawHtsCode": "8708.80.65",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "2.5% <u></u>",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.80.6510",
      "rawHtsCode": "8708.80.65.10",
      "superior": null,
      "indent": "5",
      "description": "Beam hanger brackets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.80.6590",
      "rawHtsCode": "8708.80.65.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.91",
      "rawHtsCode": "8708.91",
      "superior": null,
      "indent": "2",
      "description": "Radiators and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.91.1000",
      "rawHtsCode": "8708.91.10.00",
      "superior": null,
      "indent": "4",
      "description": "For tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.91.5000",
      "rawHtsCode": "8708.91.50.00",
      "superior": null,
      "indent": "4",
      "description": "For other vehicles",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.91.6000",
      "rawHtsCode": "8708.91.60.00",
      "superior": null,
      "indent": "4",
      "description": "For tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.91.6500",
      "rawHtsCode": "8708.91.65.00",
      "superior": null,
      "indent": "4",
      "description": "For other tractors (except road tractors)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.91.7000",
      "rawHtsCode": "8708.91.70.00",
      "superior": null,
      "indent": "5",
      "description": "Of cast iron",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.91.75",
      "rawHtsCode": "8708.91.75",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.91.7510",
      "rawHtsCode": "8708.91.75.10",
      "superior": null,
      "indent": "6",
      "description": "Radiator cores",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.91.7550",
      "rawHtsCode": "8708.91.75.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.92",
      "rawHtsCode": "8708.92",
      "superior": null,
      "indent": "2",
      "description": "Mufflers and exhaust pipes; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.92.1000",
      "rawHtsCode": "8708.92.10.00",
      "superior": null,
      "indent": "4",
      "description": "For tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8708.92.5000",
      "rawHtsCode": "8708.92.50.00",
      "superior": null,
      "indent": "4",
      "description": "For other vehicles",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.92.6000",
      "rawHtsCode": "8708.92.60.00",
      "superior": null,
      "indent": "4",
      "description": "For tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.92.6500",
      "rawHtsCode": "8708.92.65.00",
      "superior": null,
      "indent": "4",
      "description": "For other tractors (except road tractors)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.92.7000",
      "rawHtsCode": "8708.92.70.00",
      "superior": null,
      "indent": "5",
      "description": "Of cast iron",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.92.7500",
      "rawHtsCode": "8708.92.75.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.93",
      "rawHtsCode": "8708.93",
      "superior": null,
      "indent": "2",
      "description": "Clutches and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.93.1500",
      "rawHtsCode": "8708.93.15.00",
      "superior": null,
      "indent": "4",
      "description": "Clutches",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.93.3000",
      "rawHtsCode": "8708.93.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.93.6000",
      "rawHtsCode": "8708.93.60.00",
      "superior": null,
      "indent": "4",
      "description": "Clutches",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.93.7500",
      "rawHtsCode": "8708.93.75.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.94",
      "rawHtsCode": "8708.94",
      "superior": null,
      "indent": "2",
      "description": "Steering wheels, steering columns and steering boxes; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.94.1000",
      "rawHtsCode": "8708.94.10.00",
      "superior": null,
      "indent": "4",
      "description": "For tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.94.5000",
      "rawHtsCode": "8708.94.50.00",
      "superior": null,
      "indent": "4",
      "description": "For other vehicles",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.94.6000",
      "rawHtsCode": "8708.94.60.00",
      "superior": null,
      "indent": "4",
      "description": "For tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.94.6500",
      "rawHtsCode": "8708.94.65.00",
      "superior": null,
      "indent": "4",
      "description": "For other tractors (except road tractors)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.94.7000",
      "rawHtsCode": "8708.94.70.00",
      "superior": null,
      "indent": "5",
      "description": "Of cast iron",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8708.94.75",
      "rawHtsCode": "8708.94.75",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "2.5% <u></u>",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.94.7510",
      "rawHtsCode": "8708.94.75.10",
      "superior": null,
      "indent": "6",
      "description": "Steering shaft assemblies incorporating universal joints",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.94.7550",
      "rawHtsCode": "8708.94.75.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.95",
      "rawHtsCode": "8708.95",
      "superior": null,
      "indent": "2",
      "description": "Safety airbags with inflater system; parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.95.0500",
      "rawHtsCode": "8708.95.05.00",
      "superior": null,
      "indent": "3",
      "description": "Inflaters and modules for airbags",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.95.1000",
      "rawHtsCode": "8708.95.10.00",
      "superior": null,
      "indent": "4",
      "description": "For tractors suitable for agricultural use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.95.1500",
      "rawHtsCode": "8708.95.15.00",
      "superior": null,
      "indent": "4",
      "description": "For other tractors (except road tractors)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.95.2000",
      "rawHtsCode": "8708.95.20.00",
      "superior": null,
      "indent": "4",
      "description": "For other vehicles",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.99",
      "rawHtsCode": "8708.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.99.0300",
      "rawHtsCode": "8708.99.03.00",
      "superior": null,
      "indent": "4",
      "description": "Vibration control goods containing rubber",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.99.0600",
      "rawHtsCode": "8708.99.06.00",
      "superior": null,
      "indent": "4",
      "description": "Double flanged wheel hub units incorporating ball bearings",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.99.1600",
      "rawHtsCode": "8708.99.16.00",
      "superior": null,
      "indent": "4",
      "description": "Other parts for power trains",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.99.2300",
      "rawHtsCode": "8708.99.23.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.99.2700",
      "rawHtsCode": "8708.99.27.00",
      "superior": null,
      "indent": "4",
      "description": "Vibration control goods containing rubber",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.99.3100",
      "rawHtsCode": "8708.99.31.00",
      "superior": null,
      "indent": "4",
      "description": "Double flanged wheel hub units incorporating ball bearings",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8708.99.4100",
      "rawHtsCode": "8708.99.41.00",
      "superior": null,
      "indent": "4",
      "description": "Other parts for power trains",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8708.99.48",
      "rawHtsCode": "8708.99.48",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8708.99.4810",
      "rawHtsCode": "8708.99.48.10",
      "superior": null,
      "indent": "5",
      "description": "Tracklinks for track-laying tractors",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.99.4850",
      "rawHtsCode": "8708.99.48.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.99.5300",
      "rawHtsCode": "8708.99.53.00",
      "superior": null,
      "indent": "4",
      "description": "Of cast-iron",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8708.99.5500",
      "rawHtsCode": "8708.99.55.00",
      "superior": null,
      "indent": "5",
      "description": "Vibration control goods containing rubber",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.99.5800",
      "rawHtsCode": "8708.99.58.00",
      "superior": null,
      "indent": "5",
      "description": "Double flanged wheel hub units incorporating ball bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.99.68",
      "rawHtsCode": "8708.99.68",
      "superior": null,
      "indent": "6",
      "description": "Other parts for power trains",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.99.6805",
      "rawHtsCode": "8708.99.68.05",
      "superior": null,
      "indent": "7",
      "description": "Drive shafts",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.99.6810",
      "rawHtsCode": "8708.99.68.10",
      "superior": null,
      "indent": "7",
      "description": "Forged universal joints for vehicles of heading 8703",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.99.6820",
      "rawHtsCode": "8708.99.68.20",
      "superior": null,
      "indent": "7",
      "description": "Forged universal joints for vehicles of heading 8704",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.99.6890",
      "rawHtsCode": "8708.99.68.90",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.99.81",
      "rawHtsCode": "8708.99.81",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8708.99.8105",
      "rawHtsCode": "8708.99.81.05",
      "superior": null,
      "indent": "7",
      "description": "Brake hoses of plastics, with attached fittings",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.99.8115",
      "rawHtsCode": "8708.99.81.15",
      "superior": null,
      "indent": "7",
      "description": "Double flanged wheel hub units not incorporating ball bearings",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.99.8130",
      "rawHtsCode": "8708.99.81.30",
      "superior": null,
      "indent": "7",
      "description": "Slide-in campers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.99.8160",
      "rawHtsCode": "8708.99.81.60",
      "superior": null,
      "indent": "7",
      "description": "Cable traction devices",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8708.99.8180",
      "rawHtsCode": "8708.99.81.80",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8709",
      "rawHtsCode": "8709",
      "superior": null,
      "indent": "0",
      "description": "Works trucks, self-propelled, not fitted with lifting or handling equipment, of the type used in factories, warehouses, dock areas or airports for short distance transport of goods; tractors of the type used on railway station platforms; parts of the foregoing vehicles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8709.11.00",
      "rawHtsCode": "8709.11.00",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8709.11.0030",
      "rawHtsCode": "8709.11.00.30",
      "superior": null,
      "indent": "3",
      "description": "Operator riding",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8709.11.0060",
      "rawHtsCode": "8709.11.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8709.19.00",
      "rawHtsCode": "8709.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8709.19.0030",
      "rawHtsCode": "8709.19.00.30",
      "superior": null,
      "indent": "3",
      "description": "Operator riding",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8709.19.0060",
      "rawHtsCode": "8709.19.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8709.90.00",
      "rawHtsCode": "8709.90.00",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8709.90.0010",
      "rawHtsCode": "8709.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Road wheels",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8709.90.0020",
      "rawHtsCode": "8709.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Wheel and tire assemblies",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8709.90.0090",
      "rawHtsCode": "8709.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8710.00.00",
      "rawHtsCode": "8710.00.00",
      "superior": null,
      "indent": "0",
      "description": "Tanks and other armored fighting vehicles, motorized, whether or not fitted with weapons, and parts of such vehicles",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8710.00.0030",
      "rawHtsCode": "8710.00.00.30",
      "superior": null,
      "indent": "2",
      "description": "Tracked (including half-tracked)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8710.00.0060",
      "rawHtsCode": "8710.00.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8710.00.0090",
      "rawHtsCode": "8710.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711",
      "rawHtsCode": "8711",
      "superior": null,
      "indent": "0",
      "description": "Motorcycles (including mopeds) and cycles fitted with an auxiliary motor, with or without side-cars; side-cars:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.10.0000",
      "rawHtsCode": "8711.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "With internal combustion piston engine of a cylinder capacity not exceeding <il>50 cc</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8711.20.00",
      "rawHtsCode": "8711.20.00",
      "superior": null,
      "indent": "1",
      "description": "With internal combustion piston engine of a cylinder capacity exceeding <il>50 cc</il> but not exceeding <il>250 cc</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8711.20.0030",
      "rawHtsCode": "8711.20.00.30",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>50 cc</il> but not exceeding <il>90 cc</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.20.0060",
      "rawHtsCode": "8711.20.00.60",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>90 cc</il> but not exceeding <il>190 cc</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.20.0090",
      "rawHtsCode": "8711.20.00.90",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>190 cc</il> but not exceeding <il>250 cc</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.30.00",
      "rawHtsCode": "8711.30.00",
      "superior": null,
      "indent": "1",
      "description": "With internal combustion piston engine of a cylinder capacity exceeding <il>250 cc</il> but not exceeding <il>500 cc</il>",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8711.30.0030",
      "rawHtsCode": "8711.30.00.30",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>250 cc</il> but not exceeding <il>290 cc</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.30.0060",
      "rawHtsCode": "8711.30.00.60",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>290 cc</il> but not exceeding <il>490 cc</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.30.0090",
      "rawHtsCode": "8711.30.00.90",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>490 cc</il> but not exceeding <il>500 cc</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.40",
      "rawHtsCode": "8711.40",
      "superior": null,
      "indent": "1",
      "description": "With internal combustion piston engine of a cylinder capacity exceeding <il>500 cc</il> but not exceeding <il>800 cc</il>:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.40.3000",
      "rawHtsCode": "8711.40.30.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>500 cc</il> but not exceeding <il>700 cc</il>",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8711.40.60",
      "rawHtsCode": "8711.40.60",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>700 cc</il> but not exceeding <il>800 cc</il>",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8711.40.6030",
      "rawHtsCode": "8711.40.60.30",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>700 cc</il> but not exceeding <il>790 cc</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.40.6060",
      "rawHtsCode": "8711.40.60.60",
      "superior": null,
      "indent": "3",
      "description": "Exceeding <il>790 cc</il> but not exceeding <il>800 cc</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.50.00",
      "rawHtsCode": "8711.50.00",
      "superior": null,
      "indent": "1",
      "description": "With internal combustion piston engine of a cylinder capacity exceeding <il>800 cc</il>",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8711.50.0030",
      "rawHtsCode": "8711.50.00.30",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>800 cc</il> but not exceeding <il>970 cc</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.50.0060",
      "rawHtsCode": "8711.50.00.60",
      "superior": null,
      "indent": "2",
      "description": "Exceeding <il>970 cc</il>",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.60.00",
      "rawHtsCode": "8711.60.00",
      "superior": null,
      "indent": "1",
      "description": "With electric motor for propulsion",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "8711.60.0050",
      "rawHtsCode": "8711.60.00.50",
      "superior": null,
      "indent": "2",
      "description": "Of an output not exceeding 250 W",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.60.0090",
      "rawHtsCode": "8711.60.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8711.90.0100",
      "rawHtsCode": "8711.90.01.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8712.00",
      "rawHtsCode": "8712.00",
      "superior": null,
      "indent": "0",
      "description": "Bicycles and other cycles (including delivery tricycles), not motorized:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8712.00.15",
      "rawHtsCode": "8712.00.15",
      "superior": null,
      "indent": "1",
      "description": "Bicycles having both wheels not exceeding <il>63.5 cm</il> in diameter",
      "units": [],
      "generalRate": "11%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 5.5% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8712.00.1510",
      "rawHtsCode": "8712.00.15.10",
      "superior": null,
      "indent": "2",
      "description": "Having both wheels not exceeding <il>50 cm</il> in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8712.00.1520",
      "rawHtsCode": "8712.00.15.20",
      "superior": null,
      "indent": "2",
      "description": "Having both wheels exceeding <il>50 cm</il> but not exceeding <il>55 cm</il> in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8712.00.1550",
      "rawHtsCode": "8712.00.15.50",
      "superior": null,
      "indent": "2",
      "description": "Having both wheels exceeding <il>55 cm</il> but not exceeding <il>63.5 cm</il> in diameter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8712.00.2500",
      "rawHtsCode": "8712.00.25.00",
      "superior": null,
      "indent": "2",
      "description": "If weighing less than <il>16.3 kg</il> complete without accessories and not designed for use with tires having a cross-sectional diameter exceeding <il>4.13 cm</il>",
      "units": [
        "No."
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)2.75% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8712.00.3500",
      "rawHtsCode": "8712.00.35.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "11%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 5.5% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8712.00.4400",
      "rawHtsCode": "8712.00.44.00",
      "superior": null,
      "indent": "1",
      "description": "Bicycles having a front wheel exceeding <il>55 cm</il> but not exceeding <il>63.5 cm</il> in diameter and a rear wheel exceeding <il>63.5 cm</il> in diameter, weighing less than <il>16.3 kg</il> complete without accessories and not designed for use with tires having a cross-sectional diameter exceeding <il>4.13 cm</il>, valued $200 or more each",
      "units": [
        "No."
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)2.75% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8712.00.4800",
      "rawHtsCode": "8712.00.48.00",
      "superior": null,
      "indent": "1",
      "description": "Other bicycles",
      "units": [
        "No."
      ],
      "generalRate": "11%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 5.5% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8712.00.5000",
      "rawHtsCode": "8712.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Other cycles",
      "units": [
        "No."
      ],
      "generalRate": "3.7% <u></u>",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8713",
      "rawHtsCode": "8713",
      "superior": null,
      "indent": "0",
      "description": "Carriages for disabled persons, whether or not motorized or otherwise mechanically propelled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8713.10.0000",
      "rawHtsCode": "8713.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Not mechanically propelled",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8713.90.00",
      "rawHtsCode": "8713.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8713.90.0030",
      "rawHtsCode": "8713.90.00.30",
      "superior": null,
      "indent": "2",
      "description": "Three-wheeled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8713.90.0060",
      "rawHtsCode": "8713.90.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714",
      "rawHtsCode": "8714",
      "superior": null,
      "indent": "0",
      "description": "Parts and accessories of vehicles of headings 8711 to 8713:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.10.00",
      "rawHtsCode": "8714.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of motorcycles (including mopeds)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8714.10.0010",
      "rawHtsCode": "8714.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Saddles and seats",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.10.0020",
      "rawHtsCode": "8714.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Wheels",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.10.0050",
      "rawHtsCode": "8714.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.20.0000",
      "rawHtsCode": "8714.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of carriages for disabled persons",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.91",
      "rawHtsCode": "8714.91",
      "superior": null,
      "indent": "2",
      "description": "Frames and forks, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.91.2000",
      "rawHtsCode": "8714.91.20.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $600 each",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8714.91.3000",
      "rawHtsCode": "8714.91.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8714.91.5000",
      "rawHtsCode": "8714.91.50.00",
      "superior": null,
      "indent": "3",
      "description": "Sets of steel tubing cut to exact length and each set having the number of tubes needed for the assembly (with other parts) into the frame and fork of one bicycle",
      "units": [
        "kg"
      ],
      "generalRate": "6% <u></u>",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)3% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8714.91.9000",
      "rawHtsCode": "8714.91.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8714.92",
      "rawHtsCode": "8714.92",
      "superior": null,
      "indent": "2",
      "description": "Wheel rims and spokes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.92.1000",
      "rawHtsCode": "8714.92.10.00",
      "superior": null,
      "indent": "3",
      "description": "Wheel rims",
      "units": [
        "kg"
      ],
      "generalRate": "5% <u></u>",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8714.92.5000",
      "rawHtsCode": "8714.92.50.00",
      "superior": null,
      "indent": "3",
      "description": "Spokes",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 5% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8714.93",
      "rawHtsCode": "8714.93",
      "superior": null,
      "indent": "2",
      "description": "Hubs, other than coaster braking hubs and hub brakes, and free-wheel sprocket-wheels:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.93.0500",
      "rawHtsCode": "8714.93.05.00",
      "superior": null,
      "indent": "4",
      "description": "Aluminum alloy hubs with a hollow axle and lever-operated quick release mechanism",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8714.93.1500",
      "rawHtsCode": "8714.93.15.00",
      "superior": null,
      "indent": "5",
      "description": "Three speed",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8714.93.2400",
      "rawHtsCode": "8714.93.24.00",
      "superior": null,
      "indent": "6",
      "description": "Two speed",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8714.93.2800",
      "rawHtsCode": "8714.93.28.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A+,AU,BH,CL, CO,D,E,IL,JO,JP,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8714.93.3500",
      "rawHtsCode": "8714.93.35.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 5% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8714.93.70",
      "rawHtsCode": "8714.93.70",
      "superior": null,
      "indent": "3",
      "description": "Free-wheel sprocket-wheels",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8714.93.7030",
      "rawHtsCode": "8714.93.70.30",
      "superior": null,
      "indent": "4",
      "description": "Multiple free-wheel sprockets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.93.7060",
      "rawHtsCode": "8714.93.70.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.94",
      "rawHtsCode": "8714.94",
      "superior": null,
      "indent": "2",
      "description": "Brakes, including coaster braking hubs and hub brakes, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.94.30",
      "rawHtsCode": "8714.94.30",
      "superior": null,
      "indent": "3",
      "description": "Drum brakes, caliper and cantilever bicycle brakes, and coaster brakes; parts thereof (including cable or inner wire therefor, fitted with fittings)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8714.94.3020",
      "rawHtsCode": "8714.94.30.20",
      "superior": null,
      "indent": "4",
      "description": "Caliper and cantilever bicycle brakes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.94.3040",
      "rawHtsCode": "8714.94.30.40",
      "superior": null,
      "indent": "5",
      "description": "Designed for single-speed bicycles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.94.3050",
      "rawHtsCode": "8714.94.30.50",
      "superior": null,
      "indent": "6",
      "description": "Designed for three-speed bicycles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.94.3060",
      "rawHtsCode": "8714.94.30.60",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.94.3080",
      "rawHtsCode": "8714.94.30.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.94.9000",
      "rawHtsCode": "8714.94.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "10% <u></u>",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 5% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8714.95.0000",
      "rawHtsCode": "8714.95.00.00",
      "superior": null,
      "indent": "2",
      "description": "Saddles",
      "units": [
        "No."
      ],
      "generalRate": "8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 4% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8714.96",
      "rawHtsCode": "8714.96",
      "superior": null,
      "indent": "2",
      "description": "Pedals and crank-gear, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.96.1000",
      "rawHtsCode": "8714.96.10.00",
      "superior": null,
      "indent": "3",
      "description": "Pedals and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 4% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8714.96.5000",
      "rawHtsCode": "8714.96.50.00",
      "superior": null,
      "indent": "3",
      "description": "Cotterless-type crank sets and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8714.96.9000",
      "rawHtsCode": "8714.96.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other crank-gear and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 5% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8714.99",
      "rawHtsCode": "8714.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8714.99.1000",
      "rawHtsCode": "8714.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Click twist grips and click stick levers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8714.99.5000",
      "rawHtsCode": "8714.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Derailleurs and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8714.99.6000",
      "rawHtsCode": "8714.99.60.00",
      "superior": null,
      "indent": "3",
      "description": "Trigger and twist grip controls for three speed hubs, and parts thereof; bicycle handlebar stems wholly of aluminum alloy (including their hardware of any material), valued over $2.15 each; and bicycle handlebar stem rotor assemblies",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8714.99.8000",
      "rawHtsCode": "8714.99.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "10%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 5% (JP)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8715.00.00",
      "rawHtsCode": "8715.00.00",
      "superior": null,
      "indent": "0",
      "description": "Baby carriages (including strollers) and parts thereof",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8715.00.0020",
      "rawHtsCode": "8715.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Baby carriages (including strollers)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8715.00.0040",
      "rawHtsCode": "8715.00.00.40",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716",
      "rawHtsCode": "8716",
      "superior": null,
      "indent": "0",
      "description": "Trailers and semi-trailers; other vehicles, not mechanically propelled; and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.10.00",
      "rawHtsCode": "8716.10.00",
      "superior": null,
      "indent": "1",
      "description": "Trailers and semi-trailers for housing or camping",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8716.10.0030",
      "rawHtsCode": "8716.10.00.30",
      "superior": null,
      "indent": "2",
      "description": "Less than 10.6 m in length",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.10.0075",
      "rawHtsCode": "8716.10.00.75",
      "superior": null,
      "indent": "2",
      "description": "10.6 m or more in length",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.20.0000",
      "rawHtsCode": "8716.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Self-loading or self-unloading trailers and semi-trailers for agricultural purposes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8716.31.0000",
      "rawHtsCode": "8716.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tanker trailers and tanker semi-trailers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8716.39.00",
      "rawHtsCode": "8716.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8716.39.0010",
      "rawHtsCode": "8716.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Agricultural",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.39.0020",
      "rawHtsCode": "8716.39.00.20",
      "superior": null,
      "indent": "3",
      "description": "For use with the vehicles of heading 8709",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.39.0030",
      "rawHtsCode": "8716.39.00.30",
      "superior": null,
      "indent": "4",
      "description": "For use with the vehicles of heading 8703",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.39.0040",
      "rawHtsCode": "8716.39.00.40",
      "superior": null,
      "indent": "5",
      "description": "Van type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.39.0050",
      "rawHtsCode": "8716.39.00.50",
      "superior": null,
      "indent": "5",
      "description": "Platform type",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.39.0090",
      "rawHtsCode": "8716.39.00.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.40.0000",
      "rawHtsCode": "8716.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other trailers and semi-trailers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "8716.80",
      "rawHtsCode": "8716.80",
      "superior": null,
      "indent": "1",
      "description": "Other vehicles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.80.1000",
      "rawHtsCode": "8716.80.10.00",
      "superior": null,
      "indent": "2",
      "description": "Farm wagons and carts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8716.80.50",
      "rawHtsCode": "8716.80.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8716.80.5010",
      "rawHtsCode": "8716.80.50.10",
      "superior": null,
      "indent": "3",
      "description": "Industrial hand trucks",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.80.5020",
      "rawHtsCode": "8716.80.50.20",
      "superior": null,
      "indent": "4",
      "description": "Portable luggage carts",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.80.5090",
      "rawHtsCode": "8716.80.50.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.90",
      "rawHtsCode": "8716.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.90.10",
      "rawHtsCode": "8716.90.10",
      "superior": null,
      "indent": "2",
      "description": "Parts of farm wagons and carts:",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8716.90.1010",
      "rawHtsCode": "8716.90.10.10",
      "superior": null,
      "indent": "3",
      "description": "Road wheels",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.90.1020",
      "rawHtsCode": "8716.90.10.20",
      "superior": null,
      "indent": "3",
      "description": "Wheel and tire assemblies",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.90.1090",
      "rawHtsCode": "8716.90.10.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.90.3000",
      "rawHtsCode": "8716.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Castors, other than those of heading 8302",
      "units": [
        "kg"
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8716.90.50",
      "rawHtsCode": "8716.90.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8716.90.5010",
      "rawHtsCode": "8716.90.50.10",
      "superior": null,
      "indent": "3",
      "description": "Axles and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.90.5035",
      "rawHtsCode": "8716.90.50.35",
      "superior": null,
      "indent": "4",
      "description": "Steel wheels measuring 30 to <il>42 cm</il> in diameter, whether or not assembled",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.90.5046",
      "rawHtsCode": "8716.90.50.46",
      "superior": null,
      "indent": "7",
      "description": "Of aluminum",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.90.5047",
      "rawHtsCode": "8716.90.50.47",
      "superior": null,
      "indent": "7",
      "description": "Of steel",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.90.5048",
      "rawHtsCode": "8716.90.50.48",
      "superior": null,
      "indent": "6",
      "description": "Other wheels",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.90.5056",
      "rawHtsCode": "8716.90.50.56",
      "superior": null,
      "indent": "6",
      "description": "Wheels with tires for off-the-highway use",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.90.5059",
      "rawHtsCode": "8716.90.50.59",
      "superior": null,
      "indent": "6",
      "description": "Wheels with other tires",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8716.90.5060",
      "rawHtsCode": "8716.90.50.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8801.00.00",
      "rawHtsCode": "8801.00.00",
      "superior": null,
      "indent": "0",
      "description": "Balloons and dirigibles; gliders, hang gliders and other non-powered aircraft",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8801.00.0010",
      "rawHtsCode": "8801.00.00.10",
      "superior": null,
      "indent": "2",
      "description": "Hang gliders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8801.00.0020",
      "rawHtsCode": "8801.00.00.20",
      "superior": null,
      "indent": "2",
      "description": "Gliders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8801.00.0050",
      "rawHtsCode": "8801.00.00.50",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802",
      "rawHtsCode": "8802",
      "superior": null,
      "indent": "0",
      "description": "Other aircraft (for example, helicopters, airplanes, except unmanned aircraft of heading 8806); spacecraft (including satellites) and suborbital and spacecraft launch vehicles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.11.01",
      "rawHtsCode": "8802.11.01",
      "superior": null,
      "indent": "2",
      "description": "Of an unladen weight not exceeding 2,000 kg",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8802.11.0115",
      "rawHtsCode": "8802.11.01.15",
      "superior": null,
      "indent": "4",
      "description": "Military",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.11.0130",
      "rawHtsCode": "8802.11.01.30",
      "superior": null,
      "indent": "5",
      "description": "Of an unladen weight not exceeding 998 kg",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.11.0145",
      "rawHtsCode": "8802.11.01.45",
      "superior": null,
      "indent": "5",
      "description": "Of an unladen weight exceeding 998 but not exceeding 2,000 kg",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.11.0160",
      "rawHtsCode": "8802.11.01.60",
      "superior": null,
      "indent": "4",
      "description": "Military",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.11.0190",
      "rawHtsCode": "8802.11.01.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.12.01",
      "rawHtsCode": "8802.12.01",
      "superior": null,
      "indent": "2",
      "description": "Of an unladen weight exceeding 2,000 kg",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8802.12.0120",
      "rawHtsCode": "8802.12.01.20",
      "superior": null,
      "indent": "4",
      "description": "Military",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.12.0140",
      "rawHtsCode": "8802.12.01.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.12.0160",
      "rawHtsCode": "8802.12.01.60",
      "superior": null,
      "indent": "4",
      "description": "Military",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.12.0180",
      "rawHtsCode": "8802.12.01.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.20.01",
      "rawHtsCode": "8802.20.01",
      "superior": null,
      "indent": "1",
      "description": "Airplanes and other aircraft, of an unladen weight not exceeding 2,000 kg",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8802.20.0115",
      "rawHtsCode": "8802.20.01.15",
      "superior": null,
      "indent": "2",
      "description": "Of an unladen weight not exceeding 450 kg",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.20.0120",
      "rawHtsCode": "8802.20.01.20",
      "superior": null,
      "indent": "5",
      "description": "Airplanes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.20.0130",
      "rawHtsCode": "8802.20.01.30",
      "superior": null,
      "indent": "5",
      "description": "Other aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.20.0140",
      "rawHtsCode": "8802.20.01.40",
      "superior": null,
      "indent": "5",
      "description": "Single engine airplanes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.20.0150",
      "rawHtsCode": "8802.20.01.50",
      "superior": null,
      "indent": "5",
      "description": "Multiple engine airplanes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.20.0160",
      "rawHtsCode": "8802.20.01.60",
      "superior": null,
      "indent": "5",
      "description": "Other aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.20.0170",
      "rawHtsCode": "8802.20.01.70",
      "superior": null,
      "indent": "4",
      "description": "Military aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.20.0180",
      "rawHtsCode": "8802.20.01.80",
      "superior": null,
      "indent": "4",
      "description": "Other aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.30.01",
      "rawHtsCode": "8802.30.01",
      "superior": null,
      "indent": "1",
      "description": "Airplanes and other aircraft, of an unladen weight exceeding 2,000 kg but not exceeding 15,000 kg",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8802.30.0110",
      "rawHtsCode": "8802.30.01.10",
      "superior": null,
      "indent": "4",
      "description": "Fighters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.30.0120",
      "rawHtsCode": "8802.30.01.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.30.0130",
      "rawHtsCode": "8802.30.01.30",
      "superior": null,
      "indent": "5",
      "description": "Of an unladen weight exceeding 2,000 but not exceeding 4,536 kg",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.30.0140",
      "rawHtsCode": "8802.30.01.40",
      "superior": null,
      "indent": "6",
      "description": "Turbofan powered",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.30.0150",
      "rawHtsCode": "8802.30.01.50",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.30.0160",
      "rawHtsCode": "8802.30.01.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.30.0170",
      "rawHtsCode": "8802.30.01.70",
      "superior": null,
      "indent": "3",
      "description": "Military aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.30.0180",
      "rawHtsCode": "8802.30.01.80",
      "superior": null,
      "indent": "3",
      "description": "Other aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.40.01",
      "rawHtsCode": "8802.40.01",
      "superior": null,
      "indent": "1",
      "description": "Airplanes and other aircraft, of an unladen weight exceeding 15,000 kg",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8802.40.0115",
      "rawHtsCode": "8802.40.01.15",
      "superior": null,
      "indent": "4",
      "description": "Fighters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.40.0120",
      "rawHtsCode": "8802.40.01.20",
      "superior": null,
      "indent": "4",
      "description": "Cargo transports",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.40.0130",
      "rawHtsCode": "8802.40.01.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.40.0140",
      "rawHtsCode": "8802.40.01.40",
      "superior": null,
      "indent": "4",
      "description": "Passenger transports",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.40.0160",
      "rawHtsCode": "8802.40.01.60",
      "superior": null,
      "indent": "4",
      "description": "Cargo transports",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.40.0170",
      "rawHtsCode": "8802.40.01.70",
      "superior": null,
      "indent": "4",
      "description": "Other (including passenger/cargo combinations)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.40.0180",
      "rawHtsCode": "8802.40.01.80",
      "superior": null,
      "indent": "3",
      "description": "Military aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.40.0190",
      "rawHtsCode": "8802.40.01.90",
      "superior": null,
      "indent": "3",
      "description": "Other aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.60",
      "rawHtsCode": "8802.60",
      "superior": null,
      "indent": "1",
      "description": "Spacecraft (including satellites) and suborbital and spacecraft launch vehicles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.60.3000",
      "rawHtsCode": "8802.60.30.00",
      "superior": null,
      "indent": "2",
      "description": "Communications satellites",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8802.60.90",
      "rawHtsCode": "8802.60.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8802.60.9020",
      "rawHtsCode": "8802.60.90.20",
      "superior": null,
      "indent": "3",
      "description": "Military",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8802.60.9040",
      "rawHtsCode": "8802.60.90.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8804.00.0000",
      "rawHtsCode": "8804.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Parachutes (including dirigible parachutes and paragliders) and rotochutes; parts thereof and accessories thereto",
      "units": [
        "kg"
      ],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8805",
      "rawHtsCode": "8805",
      "superior": null,
      "indent": "0",
      "description": "Aircraft launching gear; deck-arrestor or similar gear; ground flying trainers; parts of the foregoing articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8805.10.0000",
      "rawHtsCode": "8805.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Aircraft launching gear and parts thereof; deck- arrestors or similar gear and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8805.21.0000",
      "rawHtsCode": "8805.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Air combat simulators and parts thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8805.29.0000",
      "rawHtsCode": "8805.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "8806",
      "rawHtsCode": "8806",
      "superior": null,
      "indent": "0",
      "description": "Unmanned aircraft:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8806.10.0000",
      "rawHtsCode": "8806.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Designed for the carriage of passengers ",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8806.21.0000",
      "rawHtsCode": "8806.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "With maximum take-off weight not more than 250 g",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8806.22.0000",
      "rawHtsCode": "8806.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "With maximum take-off weight more than 250 g but not more than 7 kg",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8806.23.0000",
      "rawHtsCode": "8806.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "With maximum take-off weight more than 7 kg but not more than 25 kg",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8806.24.0000",
      "rawHtsCode": "8806.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "With maximum take-off weight more than 25 kg but not more than 150 kg",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8806.29.0000",
      "rawHtsCode": "8806.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8806.91.0000",
      "rawHtsCode": "8806.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "With maximum take-off weight not more than 250 g",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8806.92.0000",
      "rawHtsCode": "8806.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "With maximum take-off weight more than 250 g but not more than 7 kg",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8806.93.0000",
      "rawHtsCode": "8806.93.00.00",
      "superior": null,
      "indent": "2",
      "description": "With maximum take-off weight more than 7 kg but not more than 25 kg",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8806.94.0000",
      "rawHtsCode": "8806.94.00.00",
      "superior": null,
      "indent": "2",
      "description": "With maximum take-off weight more than 25 kg but not more than 150 kg",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8806.99.0000",
      "rawHtsCode": "8806.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8807",
      "rawHtsCode": "8807",
      "superior": null,
      "indent": "0",
      "description": "Parts of goods of heading 8801, 8802 or 8806:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8807.10.00",
      "rawHtsCode": "8807.10.00",
      "superior": null,
      "indent": "1",
      "description": "Propellers and rotors and parts thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.10.0015",
      "rawHtsCode": "8807.10.00.15",
      "superior": null,
      "indent": "3",
      "description": "For use by the Department of Defense or the United States Coast Guard",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See general note 6. "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.10.0030",
      "rawHtsCode": "8807.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See general note 6. "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.10.0060",
      "rawHtsCode": "8807.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8807.20.00",
      "rawHtsCode": "8807.20.00",
      "superior": null,
      "indent": "1",
      "description": "Undercarriages and parts thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.20.0015",
      "rawHtsCode": "8807.20.00.15",
      "superior": null,
      "indent": "3",
      "description": "For use by the Department of Defense or the United States Coast Guard",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See general note 6. "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.20.0030",
      "rawHtsCode": "8807.20.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See general note 6. "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.20.0060",
      "rawHtsCode": "8807.20.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8807.30.00",
      "rawHtsCode": "8807.30.00",
      "superior": null,
      "indent": "1",
      "description": "Other parts of airplanes, helicopters or unmanned aircraft",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.30.0015",
      "rawHtsCode": "8807.30.00.15",
      "superior": null,
      "indent": "3",
      "description": "For use by the Department of Defense or the United States Coast Guard",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See general note 6. "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.30.0030",
      "rawHtsCode": "8807.30.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See general note 6. "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.30.0060",
      "rawHtsCode": "8807.30.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8807.90",
      "rawHtsCode": "8807.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8807.90.3000",
      "rawHtsCode": "8807.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Parts of communications satellites",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.90.90",
      "rawHtsCode": "8807.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.90.9015",
      "rawHtsCode": "8807.90.90.15",
      "superior": null,
      "indent": "4",
      "description": "For use by the Department of Defense or the United States Coast Guard",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See general note 6. "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.90.9030",
      "rawHtsCode": "8807.90.90.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See general note 6. "
      ],
      "flags": []
    },
    {
      "htsCode": "8807.90.9060",
      "rawHtsCode": "8807.90.90.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8901",
      "rawHtsCode": "8901",
      "superior": null,
      "indent": "0",
      "description": "Cruise ships, excursion boats, ferry boats, cargo ships, barges and similar vessels for the transport of persons or goods:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8901.10.0000",
      "rawHtsCode": "8901.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cruise ships, excursion boats and similar vessels principally designed for the transport of persons; ferry boats of all kinds",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01"
      ],
      "flags": []
    },
    {
      "htsCode": "8901.20.0000",
      "rawHtsCode": "8901.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Tankers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01"
      ],
      "flags": []
    },
    {
      "htsCode": "8901.30.0000",
      "rawHtsCode": "8901.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Refrigerated vessels, other than those of subheading 8901.20",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02"
      ],
      "flags": []
    },
    {
      "htsCode": "8901.90.0000",
      "rawHtsCode": "8901.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other vessels for the transport of goods and other vessels for the transport of both persons and goods",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01"
      ],
      "flags": []
    },
    {
      "htsCode": "8902.00.0000",
      "rawHtsCode": "8902.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Fishing vessels; factory ships and other vessels for processing or preserving fishery products",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01"
      ],
      "flags": []
    },
    {
      "htsCode": "8903",
      "rawHtsCode": "8903",
      "superior": null,
      "indent": "0",
      "description": "Yachts and other vessels for pleasure or sports; row boats and canoes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.11.00",
      "rawHtsCode": "8903.11.00",
      "superior": null,
      "indent": "2",
      "description": "Fitted or designed to be fitted with a motor, unladen (net) weight (excluding the motor) not exceeding 100 kg",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free(A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.11.0015",
      "rawHtsCode": "8903.11.00.15",
      "superior": null,
      "indent": "4",
      "description": "With attached rigid hull",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.11.0020",
      "rawHtsCode": "8903.11.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.11.0060",
      "rawHtsCode": "8903.11.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.12.00",
      "rawHtsCode": "8903.12.00",
      "superior": null,
      "indent": "2",
      "description": "Not designed for use with a motor and unladen (net) weight not exceeding 100 kg ",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "Free(A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.12.0015",
      "rawHtsCode": "8903.12.00.15",
      "superior": null,
      "indent": "4",
      "description": "With attached rigid hull",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.12.0020",
      "rawHtsCode": "8903.12.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.12.0060",
      "rawHtsCode": "8903.12.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.19.0000",
      "rawHtsCode": "8903.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.4%",
      "specialRate": "Free(A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.21.00",
      "rawHtsCode": "8903.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of a length not exceeding 7.5 m",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "Free(A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.21.0010",
      "rawHtsCode": "8903.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "With auxiliary motor",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.21.0030",
      "rawHtsCode": "8903.21.00.30",
      "superior": null,
      "indent": "4",
      "description": "Of a length not exceeding 4 m",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.21.0035",
      "rawHtsCode": "8903.21.00.35",
      "superior": null,
      "indent": "4",
      "description": "Of a length exceeding 4 m but not exceeding 6.5 m",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.21.0040",
      "rawHtsCode": "8903.21.00.40",
      "superior": null,
      "indent": "4",
      "description": "Of a length exceeding 6.5 m but not exceeding 7.5 m",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.22.00",
      "rawHtsCode": "8903.22.00",
      "superior": null,
      "indent": "2",
      "description": "Of a length exceeding 7.5 m but not exceeding 24 m",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "Free(A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.22.0015",
      "rawHtsCode": "8903.22.00.15",
      "superior": null,
      "indent": "4",
      "description": "Of a length exceeding 7.5 m but not exceeding 9.2 m",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.22.0020",
      "rawHtsCode": "8903.22.00.20",
      "superior": null,
      "indent": "4",
      "description": "Of a length exceeding 9.2 m",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.22.0025",
      "rawHtsCode": "8903.22.00.25",
      "superior": null,
      "indent": "4",
      "description": "Of a length exceeding 7.5 m but not exceeding 9.2 m",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.22.0060",
      "rawHtsCode": "8903.22.00.60",
      "superior": null,
      "indent": "4",
      "description": "Of a length exceeding 9.2 m",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.23.00",
      "rawHtsCode": "8903.23.00",
      "superior": null,
      "indent": "2",
      "description": "Of a length exceeding 24 m",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "Free(A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.23.0015",
      "rawHtsCode": "8903.23.00.15",
      "superior": null,
      "indent": "3",
      "description": "With auxiliary motor",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.23.0020",
      "rawHtsCode": "8903.23.00.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.31.00",
      "rawHtsCode": "8903.31.00",
      "superior": null,
      "indent": "2",
      "description": "Of a length not exceeding 7.5 m",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "Free(A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.31.0015",
      "rawHtsCode": "8903.31.00.15",
      "superior": null,
      "indent": "4",
      "description": "Cabin cruisers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.31.0020",
      "rawHtsCode": "8903.31.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.31.0025",
      "rawHtsCode": "8903.31.00.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.32.00",
      "rawHtsCode": "8903.32.00",
      "superior": null,
      "indent": "2",
      "description": "Of a length exceeding 7.5 m but not exceeding 24 m",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "Free(A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.32.0015",
      "rawHtsCode": "8903.32.00.15",
      "superior": null,
      "indent": "4",
      "description": "Cabin cruisers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.32.0020",
      "rawHtsCode": "8903.32.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.32.0025",
      "rawHtsCode": "8903.32.00.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.33.00",
      "rawHtsCode": "8903.33.00",
      "superior": null,
      "indent": "2",
      "description": "Of a length exceeding 24 m",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "Free(A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.33.0015",
      "rawHtsCode": "8903.33.00.15",
      "superior": null,
      "indent": "4",
      "description": "Cabin cruisers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.33.0020",
      "rawHtsCode": "8903.33.00.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.33.0025",
      "rawHtsCode": "8903.33.00.25",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.93",
      "rawHtsCode": "8903.93",
      "superior": null,
      "indent": "2",
      "description": "Of a length not exceeding 7.5 m:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.93.0500",
      "rawHtsCode": "8903.93.05.00",
      "superior": null,
      "indent": "4",
      "description": "Canoes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8903.93.1500",
      "rawHtsCode": "8903.93.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.93.20",
      "rawHtsCode": "8903.93.20",
      "superior": null,
      "indent": "3",
      "description": "Outboard motorboats",
      "units": [],
      "generalRate": "1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.93.2015",
      "rawHtsCode": "8903.93.20.15",
      "superior": null,
      "indent": "5",
      "description": "Not exceeding 5 m in length",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.93.2030",
      "rawHtsCode": "8903.93.20.30",
      "superior": null,
      "indent": "5",
      "description": "Exceeding 5 m in length",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.93.2045",
      "rawHtsCode": "8903.93.20.45",
      "superior": null,
      "indent": "5",
      "description": "Not exceeding 5 m in length",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.93.2060",
      "rawHtsCode": "8903.93.20.60",
      "superior": null,
      "indent": "5",
      "description": "Exceeding 5 m in length",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.93.2075",
      "rawHtsCode": "8903.93.20.75",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.93.9000",
      "rawHtsCode": "8903.93.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.99",
      "rawHtsCode": "8903.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.99.0600",
      "rawHtsCode": "8903.99.06.00",
      "superior": null,
      "indent": "4",
      "description": "Canoes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "8903.99.1600",
      "rawHtsCode": "8903.99.16.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.99.21",
      "rawHtsCode": "8903.99.21",
      "superior": null,
      "indent": "3",
      "description": "Outboard motorboats",
      "units": [],
      "generalRate": "1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8903.99.2110",
      "rawHtsCode": "8903.99.21.10",
      "superior": null,
      "indent": "4",
      "description": "With hulls of metal",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.99.2120",
      "rawHtsCode": "8903.99.21.20",
      "superior": null,
      "indent": "4",
      "description": "With hulls of reinforced plastics",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.99.2190",
      "rawHtsCode": "8903.99.21.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8903.99.9100",
      "rawHtsCode": "8903.99.91.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "8904.00.0000",
      "rawHtsCode": "8904.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Tugs and pusher craft",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01"
      ],
      "flags": []
    },
    {
      "htsCode": "8905",
      "rawHtsCode": "8905",
      "superior": null,
      "indent": "0",
      "description": "Light-vessels, fire-floats, dredgers, floating cranes, and other vessels the navigability of which is subsidiary to their main function; floating docks; floating or submersible drilling or production platforms:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8905.10.0000",
      "rawHtsCode": "8905.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Dredgers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01"
      ],
      "flags": []
    },
    {
      "htsCode": "8905.20.0000",
      "rawHtsCode": "8905.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Floating or submersible drilling or production platforms",
      "units": [
        "t",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01"
      ],
      "flags": []
    },
    {
      "htsCode": "8905.90",
      "rawHtsCode": "8905.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8905.90.1000",
      "rawHtsCode": "8905.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Floating docks",
      "units": [
        "t",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8905.90.5000",
      "rawHtsCode": "8905.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01"
      ],
      "flags": []
    },
    {
      "htsCode": "8906",
      "rawHtsCode": "8906",
      "superior": null,
      "indent": "0",
      "description": "Other vessels, including warships and lifeboats other than row boats:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8906.10.0000",
      "rawHtsCode": "8906.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Warships",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8906.90.00",
      "rawHtsCode": "8906.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01"
      ],
      "flags": []
    },
    {
      "htsCode": "8906.90.0010",
      "rawHtsCode": "8906.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Hulls",
      "units": [
        "t",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8906.90.0090",
      "rawHtsCode": "8906.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8907",
      "rawHtsCode": "8907",
      "superior": null,
      "indent": "0",
      "description": "Other floating structures (for example, rafts, tanks, cofferdams, landing-stages, buoys and beacons):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8907.10.0000",
      "rawHtsCode": "8907.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Inflatable rafts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "8907.90.00",
      "rawHtsCode": "8907.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "8907.90.0030",
      "rawHtsCode": "8907.90.00.30",
      "superior": null,
      "indent": "2",
      "description": "Buoys",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8907.90.0060",
      "rawHtsCode": "8907.90.00.60",
      "superior": null,
      "indent": "2",
      "description": "Tanks",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8907.90.0090",
      "rawHtsCode": "8907.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "8908.00.0000",
      "rawHtsCode": "8908.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Vessels and other floating structures for breaking up (scrapping)",
      "units": [
        "t"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01"
      ],
      "flags": []
    },
    {
      "htsCode": "9001",
      "rawHtsCode": "9001",
      "superior": null,
      "indent": "0",
      "description": "Optical fibers and optical fiber bundles; optical fiber cables other than those of heading 8544; sheets and plates of polarizing material; lenses (including contact lenses), prisms, mirrors and other optical elements, of any material, unmounted, other than such elements of glass not optically worked:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9001.10.00",
      "rawHtsCode": "9001.10.00",
      "superior": null,
      "indent": "1",
      "description": "Optical fibers, optical fiber bundles and cables",
      "units": [],
      "generalRate": "6.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9001.10.0030",
      "rawHtsCode": "9001.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "For transmission of voice, data or video communications",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9001.10.0050",
      "rawHtsCode": "9001.10.00.50",
      "superior": null,
      "indent": "4",
      "description": "Plastic optical fibers",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9001.10.0070",
      "rawHtsCode": "9001.10.00.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9001.10.0075",
      "rawHtsCode": "9001.10.00.75",
      "superior": null,
      "indent": "3",
      "description": "Plastic optical fiber bundles and cables",
      "units": [
        "Fiber m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9001.10.0085",
      "rawHtsCode": "9001.10.00.85",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "Fiber m"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9001.20.0000",
      "rawHtsCode": "9001.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sheets and plates of polarizing material",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "9001.30.0000",
      "rawHtsCode": "9001.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Contact lenses",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9001.40.0000",
      "rawHtsCode": "9001.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Spectacle lenses of glass",
      "units": [
        "prs."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9001.50.0000",
      "rawHtsCode": "9001.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Spectacle lenses of other materials",
      "units": [
        "prs."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9001.90",
      "rawHtsCode": "9001.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9001.90.4000",
      "rawHtsCode": "9001.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Lenses",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9001.90.5000",
      "rawHtsCode": "9001.90.50.00",
      "superior": null,
      "indent": "2",
      "description": "Prisms",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9001.90.6000",
      "rawHtsCode": "9001.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Mirrors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9001.90.8000",
      "rawHtsCode": "9001.90.80.00",
      "superior": null,
      "indent": "3",
      "description": "Halftone screens designed for use in engraving or photographic processes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9001.90.9000",
      "rawHtsCode": "9001.90.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "85%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9002",
      "rawHtsCode": "9002",
      "superior": null,
      "indent": "0",
      "description": "Lenses, prisms, mirrors and other optical elements, of any material, mounted, being parts of or fittings for instruments or apparatus, other than such elements of glass not optically worked; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9002.11",
      "rawHtsCode": "9002.11",
      "superior": null,
      "indent": "2",
      "description": "For cameras, projectors or photographic enlargers or reducers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9002.11.4000",
      "rawHtsCode": "9002.11.40.00",
      "superior": null,
      "indent": "3",
      "description": "Projection",
      "units": [
        "No."
      ],
      "generalRate": "2.45%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9002.11.6000",
      "rawHtsCode": "9002.11.60.00",
      "superior": null,
      "indent": "4",
      "description": "Mounted lenses suitable for use in, and entered separately from, closed-circuit television cameras, with or without attached electrical or non-electrical closed-circuit television camera connectors, and with or without attached motors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9002.11.9000",
      "rawHtsCode": "9002.11.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9002.19.0000",
      "rawHtsCode": "9002.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9002.20",
      "rawHtsCode": "9002.20",
      "superior": null,
      "indent": "1",
      "description": "Filters and parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9002.20.4000",
      "rawHtsCode": "9002.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Photographic",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "9002.20.8000",
      "rawHtsCode": "9002.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9002.90",
      "rawHtsCode": "9002.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9002.90.2000",
      "rawHtsCode": "9002.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Prisms",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9002.90.4000",
      "rawHtsCode": "9002.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Mirrors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9002.90.7000",
      "rawHtsCode": "9002.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "Halftone screens designed for use in engraving or photographic processes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9002.90.8500",
      "rawHtsCode": "9002.90.85.00",
      "superior": null,
      "indent": "3",
      "description": "Mounted lenses suitable for use in, and entered separately from, closed-circuit television cameras, with or without attached electrical or non-electrical closed-circuit television camera connectors, and with or without attached motors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9002.90.9500",
      "rawHtsCode": "9002.90.95.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9003",
      "rawHtsCode": "9003",
      "superior": null,
      "indent": "0",
      "description": "Frames and mountings for spectacles, goggles or the like, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9003.11.0000",
      "rawHtsCode": "9003.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of plastics",
      "units": [
        "doz."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9003.19.0000",
      "rawHtsCode": "9003.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of other materials",
      "units": [
        "doz."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9003.90.0000",
      "rawHtsCode": "9003.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9004",
      "rawHtsCode": "9004",
      "superior": null,
      "indent": "0",
      "description": "Spectacles, goggles and the like, corrective, protective or other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9004.10.0000",
      "rawHtsCode": "9004.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sunglasses",
      "units": [
        "doz."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9004.90.00",
      "rawHtsCode": "9004.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9004.90.0010",
      "rawHtsCode": "9004.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Safety glasses or safety goggles",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9004.90.0090",
      "rawHtsCode": "9004.90.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9005",
      "rawHtsCode": "9005",
      "superior": null,
      "indent": "0",
      "description": "Binoculars, monoculars, other optical telescopes, and mountings therefor; other astronomical instruments and mountings therefor, but not including instruments for radio-astronomy; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9005.10.00",
      "rawHtsCode": "9005.10.00",
      "superior": null,
      "indent": "1",
      "description": "Binoculars",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9005.10.0020",
      "rawHtsCode": "9005.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Prism binoculars for use with infrared light",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9005.10.0040",
      "rawHtsCode": "9005.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other prism binoculars",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9005.10.0080",
      "rawHtsCode": "9005.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9005.80",
      "rawHtsCode": "9005.80",
      "superior": null,
      "indent": "1",
      "description": "Other instruments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9005.80.40",
      "rawHtsCode": "9005.80.40",
      "superior": null,
      "indent": "2",
      "description": "Optical telescopes",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9005.80.4020",
      "rawHtsCode": "9005.80.40.20",
      "superior": null,
      "indent": "3",
      "description": "For use with infrared light",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9005.80.4040",
      "rawHtsCode": "9005.80.40.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9005.80.6000",
      "rawHtsCode": "9005.80.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9005.90",
      "rawHtsCode": "9005.90",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories (including mountings):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9005.90.4000",
      "rawHtsCode": "9005.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Incorporating goods of heading 9001 or 9002",
      "units": [
        "No."
      ],
      "generalRate": "The rate applicable to the article of which it is a part or accessory",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to the article of which it is a part or accessory",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9005.90.8001",
      "rawHtsCode": "9005.90.80.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "The rate applicable to the article of which it is a part or accessory",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to the article of which it is a part or accessory",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9006",
      "rawHtsCode": "9006",
      "superior": null,
      "indent": "0",
      "description": "Photographic (other than cinematographic) cameras; photographic flashlight apparatus and flashbulbs other than discharge lamps of heading 8539; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.30.0000",
      "rawHtsCode": "9006.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cameras specially designed for underwater use, for aerial survey, or for medical or surgical examination of internal organs; comparison cameras for forensic or criminological purposes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9006.40",
      "rawHtsCode": "9006.40",
      "superior": null,
      "indent": "1",
      "description": "Instant print cameras:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.40.4000",
      "rawHtsCode": "9006.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "Fixed focus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9006.40.6000",
      "rawHtsCode": "9006.40.60.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $10 each",
      "units": [
        "No."
      ],
      "generalRate": "6.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9006.40.9000",
      "rawHtsCode": "9006.40.90.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $10 each",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.53.02",
      "rawHtsCode": "9006.53.02",
      "superior": null,
      "indent": "2",
      "description": "For roll film of a width of 35 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9006.53.0205",
      "rawHtsCode": "9006.53.02.05",
      "superior": null,
      "indent": "3",
      "description": "With through-the-lens viewfinder (single lens reflex (SLR))",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.53.0210",
      "rawHtsCode": "9006.53.02.10",
      "superior": null,
      "indent": "5",
      "description": "With built-in electronic stroboscopic flash",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.53.0220",
      "rawHtsCode": "9006.53.02.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.53.0250",
      "rawHtsCode": "9006.53.02.50",
      "superior": null,
      "indent": "5",
      "description": "With built-in electronic stroboscopic flash",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.53.0270",
      "rawHtsCode": "9006.53.02.70",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.59",
      "rawHtsCode": "9006.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.59.01",
      "rawHtsCode": "9006.59.01",
      "superior": null,
      "indent": "4",
      "description": "With through-the-lens viewfinder (single lens reflex (SLR))",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9006.59.0160",
      "rawHtsCode": "9006.59.01.60",
      "superior": null,
      "indent": "5",
      "description": "For magnetically sensitized roll film of a width of 24 mm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.59.0190",
      "rawHtsCode": "9006.59.01.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.59.05",
      "rawHtsCode": "9006.59.05",
      "superior": null,
      "indent": "7",
      "description": "110 cameras",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9006.59.0520",
      "rawHtsCode": "9006.59.05.20",
      "superior": null,
      "indent": "8",
      "description": "With built-in electronic stroboscopic flash",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.59.0540",
      "rawHtsCode": "9006.59.05.40",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.59.0800",
      "rawHtsCode": "9006.59.08.00",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free(A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9006.59.1000",
      "rawHtsCode": "9006.59.10.00",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9006.59.1200",
      "rawHtsCode": "9006.59.12.00",
      "superior": null,
      "indent": "6",
      "description": "Valued not over $10 each",
      "units": [
        "No."
      ],
      "generalRate": "6.8%",
      "specialRate": "Free(A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9006.59.15",
      "rawHtsCode": "9006.59.15",
      "superior": null,
      "indent": "6",
      "description": "Valued over $10 each",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9006.59.1520",
      "rawHtsCode": "9006.59.15.20",
      "superior": null,
      "indent": "9",
      "description": "With built-in electronic stroboscopic flash",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.59.1540",
      "rawHtsCode": "9006.59.15.40",
      "superior": null,
      "indent": "9",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.59.1560",
      "rawHtsCode": "9006.59.15.60",
      "superior": null,
      "indent": "8",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.59.1580",
      "rawHtsCode": "9006.59.15.80",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.59.2000",
      "rawHtsCode": "9006.59.20.00",
      "superior": null,
      "indent": "4",
      "description": "Cameras of a kind used for preparing printing plates or cylinders",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9006.59.40",
      "rawHtsCode": "9006.59.40",
      "superior": null,
      "indent": "4",
      "description": "Fixed focus",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9006.59.4040",
      "rawHtsCode": "9006.59.40.40",
      "superior": null,
      "indent": "5",
      "description": "Disc cameras",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.59.4060",
      "rawHtsCode": "9006.59.40.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.59.6000",
      "rawHtsCode": "9006.59.60.00",
      "superior": null,
      "indent": "5",
      "description": "Valued not over $10 each",
      "units": [
        "No."
      ],
      "generalRate": "6.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9006.59.9100",
      "rawHtsCode": "9006.59.91.00",
      "superior": null,
      "indent": "5",
      "description": "Valued over $10 each",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9006.61.00",
      "rawHtsCode": "9006.61.00",
      "superior": null,
      "indent": "2",
      "description": "Discharge lamp (\"electronic\") flashlight apparatus",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9006.61.0020",
      "rawHtsCode": "9006.61.00.20",
      "superior": null,
      "indent": "4",
      "description": "Capable of automatically controlling flash duration",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.61.0040",
      "rawHtsCode": "9006.61.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.61.0060",
      "rawHtsCode": "9006.61.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.69.01",
      "rawHtsCode": "9006.69.01",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.69.0110",
      "rawHtsCode": "9006.69.01.10",
      "superior": null,
      "indent": "3",
      "description": "Flashbulbs, flashcubes and the like",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.69.0150",
      "rawHtsCode": "9006.69.01.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9006.91.0001",
      "rawHtsCode": "9006.91.00.01",
      "superior": null,
      "indent": "2",
      "description": "For cameras",
      "units": [
        "No."
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9006.99.0000",
      "rawHtsCode": "9006.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9007",
      "rawHtsCode": "9007",
      "superior": null,
      "indent": "0",
      "description": "Cinematographic cameras and projectors, whether or not incorporating sound recording or reproducing apparatus; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9007.10.0000",
      "rawHtsCode": "9007.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cameras",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9007.20",
      "rawHtsCode": "9007.20",
      "superior": null,
      "indent": "1",
      "description": "Projectors:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9007.20.2000",
      "rawHtsCode": "9007.20.20.00",
      "superior": null,
      "indent": "3",
      "description": "With sound recording and reproducing systems; and those capable of projecting only sound motion pictures",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9007.20.4000",
      "rawHtsCode": "9007.20.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9007.20.60",
      "rawHtsCode": "9007.20.60",
      "superior": null,
      "indent": "3",
      "description": "With sound recording and reproducing systems; and those capable of projecting only sound motion pictures",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9007.20.6040",
      "rawHtsCode": "9007.20.60.40",
      "superior": null,
      "indent": "4",
      "description": "16 mm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9007.20.6080",
      "rawHtsCode": "9007.20.60.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9007.20.8000",
      "rawHtsCode": "9007.20.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9007.91",
      "rawHtsCode": "9007.91",
      "superior": null,
      "indent": "2",
      "description": "For cameras:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9007.91.4000",
      "rawHtsCode": "9007.91.40.00",
      "superior": null,
      "indent": "3",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "9007.91.8001",
      "rawHtsCode": "9007.91.80.01",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9007.92.0000",
      "rawHtsCode": "9007.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "For projectors",
      "units": [
        "kg"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9008",
      "rawHtsCode": "9008",
      "superior": null,
      "indent": "0",
      "description": "Image projectors, other than cinematographic; photographic (other than cinematographic) enlargers and reducers; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9008.50",
      "rawHtsCode": "9008.50",
      "superior": null,
      "indent": "1",
      "description": "Projectors, enlargers and reducers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9008.50.1000",
      "rawHtsCode": "9008.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Slide projectors",
      "units": [
        "No."
      ],
      "generalRate": "7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9008.50.2000",
      "rawHtsCode": "9008.50.20.00",
      "superior": null,
      "indent": "3",
      "description": "Capable of producing copies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9008.50.3000",
      "rawHtsCode": "9008.50.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9008.50.4000",
      "rawHtsCode": "9008.50.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other image projectors",
      "units": [
        "No."
      ],
      "generalRate": "4.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9008.50.5000",
      "rawHtsCode": "9008.50.50.00",
      "superior": null,
      "indent": "2",
      "description": "Photographic (other than cinematographic) enlargers and reducers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9008.90",
      "rawHtsCode": "9008.90",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9008.90.4000",
      "rawHtsCode": "9008.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of image projectors, other than cinematographic",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9008.90.8000",
      "rawHtsCode": "9008.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9010",
      "rawHtsCode": "9010",
      "superior": null,
      "indent": "0",
      "description": "Apparatus and equipment for photographic (including cinematographic) laboratories, not specified or included elsewhere in this chapter; negatoscopes; projection screens; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9010.10.0000",
      "rawHtsCode": "9010.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Apparatus and equipment for automatically developing photographic (including cinematographic) film or paper in rolls or for automatically exposing developed film to rolls of photographic paper",
      "units": [
        "kg"
      ],
      "generalRate": "2.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9010.50",
      "rawHtsCode": "9010.50",
      "superior": null,
      "indent": "1",
      "description": "Other apparatus and equipment for photographic (including cinematographic) laboratories; negatoscopes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9010.50.1000",
      "rawHtsCode": "9010.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Contact printers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9010.50.2000",
      "rawHtsCode": "9010.50.20.00",
      "superior": null,
      "indent": "2",
      "description": "Developing tanks",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9010.50.3000",
      "rawHtsCode": "9010.50.30.00",
      "superior": null,
      "indent": "4",
      "description": "Editors and combination editor-splicers, for cinematographic film",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9010.50.4000",
      "rawHtsCode": "9010.50.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9010.50.5000",
      "rawHtsCode": "9010.50.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9010.50.6000",
      "rawHtsCode": "9010.50.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9010.60.0000",
      "rawHtsCode": "9010.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Projection screens",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9010.90",
      "rawHtsCode": "9010.90",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9010.90.8500",
      "rawHtsCode": "9010.90.85.00",
      "superior": null,
      "indent": "2",
      "description": "Parts and accessories of articles of subheadings 9010.50 and 9010.60",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9010.90.9500",
      "rawHtsCode": "9010.90.95.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9011",
      "rawHtsCode": "9011",
      "superior": null,
      "indent": "0",
      "description": "Compound optical microscopes, including those for photomicrography, cinemicrography or microprojection; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9011.10",
      "rawHtsCode": "9011.10",
      "superior": null,
      "indent": "1",
      "description": "Stereoscopic microscopes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9011.10.4000",
      "rawHtsCode": "9011.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Provided with a means for photographing the image",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9011.10.8000",
      "rawHtsCode": "9011.10.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9011.20",
      "rawHtsCode": "9011.20",
      "superior": null,
      "indent": "1",
      "description": "Other microscopes, for photomicrography, cinemicrography or microprojection:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9011.20.4000",
      "rawHtsCode": "9011.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Provided with a means for photographing the image",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9011.20.8000",
      "rawHtsCode": "9011.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9011.80.0000",
      "rawHtsCode": "9011.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other microscopes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9011.90.0000",
      "rawHtsCode": "9011.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9012",
      "rawHtsCode": "9012",
      "superior": null,
      "indent": "0",
      "description": "Microscopes other than optical microscopes; diffraction apparatus; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9012.10.0000",
      "rawHtsCode": "9012.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Microscopes other than optical microscopes; diffraction apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9012.90.0000",
      "rawHtsCode": "9012.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9013",
      "rawHtsCode": "9013",
      "superior": null,
      "indent": "0",
      "description": "Lasers, other than laser diodes; other optical appliances and instruments, not specified or included elsewhere in this chapter:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9013.10",
      "rawHtsCode": "9013.10",
      "superior": null,
      "indent": "1",
      "description": "Telescopic sights for fitting to arms; periscopes; telescopes designed to form parts of machines, appliances, instruments or apparatus of this chapter or section XVI:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9013.10.1000",
      "rawHtsCode": "9013.10.10.00",
      "superior": null,
      "indent": "3",
      "description": "Not designed for use with infrared light",
      "units": [
        "No."
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 7.45% (JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9013.10.3000",
      "rawHtsCode": "9013.10.30.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9013.10.4500",
      "rawHtsCode": "9013.10.45.00",
      "superior": null,
      "indent": "3",
      "description": "Telescopes designed to form parts of machines, appliances, instruments or apparatus of this chapter of section XVI",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9013.10.5000",
      "rawHtsCode": "9013.10.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9013.20.0000",
      "rawHtsCode": "9013.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Lasers, other than laser diodes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9013.80",
      "rawHtsCode": "9013.80",
      "superior": null,
      "indent": "1",
      "description": "Other devices, appliances and instruments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9013.80.2000",
      "rawHtsCode": "9013.80.20.00",
      "superior": null,
      "indent": "2",
      "description": "Hand magnifiers, magnifying glasses, loupes, thread counters and similar apparatus",
      "units": [
        "No."
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9013.80.4000",
      "rawHtsCode": "9013.80.40.00",
      "superior": null,
      "indent": "2",
      "description": "Door viewers (door eyes)",
      "units": [
        "No."
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9013.80.9100",
      "rawHtsCode": "9013.80.91.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9013.90",
      "rawHtsCode": "9013.90",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9013.90.2000",
      "rawHtsCode": "9013.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of telescopic sights for rifles",
      "units": [
        "No."
      ],
      "generalRate": "16%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9013.90.7000",
      "rawHtsCode": "9013.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other parts and accessories, other than for telescopic sights for fitting to arms or for periscopes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9013.90.8000",
      "rawHtsCode": "9013.90.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03 and U.S. note 19 to subchapter III, chapter 99. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9014",
      "rawHtsCode": "9014",
      "superior": null,
      "indent": "0",
      "description": "Direction finding compasses; other navigational instruments and appliances; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9014.10",
      "rawHtsCode": "9014.10",
      "superior": null,
      "indent": "1",
      "description": "Direction finding compasses:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9014.10.1000",
      "rawHtsCode": "9014.10.10.00",
      "superior": null,
      "indent": "2",
      "description": "Optical instruments",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9014.10.6000",
      "rawHtsCode": "9014.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Gyroscopic compasses, other than electrical",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9014.10.70",
      "rawHtsCode": "9014.10.70",
      "superior": null,
      "indent": "4",
      "description": "Electrical",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9014.10.7030",
      "rawHtsCode": "9014.10.70.30",
      "superior": null,
      "indent": "5",
      "description": "Gyroscopic compasses",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9014.10.7060",
      "rawHtsCode": "9014.10.70.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9014.10.9000",
      "rawHtsCode": "9014.10.90.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "9014.20",
      "rawHtsCode": "9014.20",
      "superior": null,
      "indent": "1",
      "description": "Instruments and appliances for aeronautical or space navigation (other than compasses):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9014.20.2000",
      "rawHtsCode": "9014.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Optical instruments and appliances",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9014.20.4000",
      "rawHtsCode": "9014.20.40.00",
      "superior": null,
      "indent": "3",
      "description": "Automatic pilots",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9014.20.6000",
      "rawHtsCode": "9014.20.60.00",
      "superior": null,
      "indent": "4",
      "description": "Electrical",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9014.20.80",
      "rawHtsCode": "9014.20.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "9014.20.8040",
      "rawHtsCode": "9014.20.80.40",
      "superior": null,
      "indent": "5",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See General Note 6."
      ],
      "flags": []
    },
    {
      "htsCode": "9014.20.8080",
      "rawHtsCode": "9014.20.80.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9014.80",
      "rawHtsCode": "9014.80",
      "superior": null,
      "indent": "1",
      "description": "Other instruments and appliances:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9014.80.1000",
      "rawHtsCode": "9014.80.10.00",
      "superior": null,
      "indent": "2",
      "description": "Optical instruments",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9014.80.2000",
      "rawHtsCode": "9014.80.20.00",
      "superior": null,
      "indent": "3",
      "description": "Ships' logs and depth-sounding apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9014.80.4000",
      "rawHtsCode": "9014.80.40.00",
      "superior": null,
      "indent": "4",
      "description": "Electrical",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9014.80.5000",
      "rawHtsCode": "9014.80.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "9014.90",
      "rawHtsCode": "9014.90",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9014.90.1000",
      "rawHtsCode": "9014.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of articles covered by subheading 9014.20.40",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9014.90.20",
      "rawHtsCode": "9014.90.20",
      "superior": null,
      "indent": "2",
      "description": "Of articles covered by subheading 9014.20.80",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9014.90.2040",
      "rawHtsCode": "9014.90.20.40",
      "superior": null,
      "indent": "3",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See General Note 6."
      ],
      "flags": []
    },
    {
      "htsCode": "9014.90.2080",
      "rawHtsCode": "9014.90.20.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9014.90.4000",
      "rawHtsCode": "9014.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of articles covered by subheading 9014.80.50",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9014.90.6000",
      "rawHtsCode": "9014.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9015",
      "rawHtsCode": "9015",
      "superior": null,
      "indent": "0",
      "description": "Surveying (including photogrammetrical surveying), hydrographic, oceanographic, hydrological, meteorological or geophysical instruments and appliances, excluding compasses; rangefinders; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.10",
      "rawHtsCode": "9015.10",
      "superior": null,
      "indent": "1",
      "description": "Rangefinders:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.10.4000",
      "rawHtsCode": "9015.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9015.10.8000",
      "rawHtsCode": "9015.10.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9015.20",
      "rawHtsCode": "9015.20",
      "superior": null,
      "indent": "1",
      "description": "Theodolites and tachymeters (tacheometers):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.20.4000",
      "rawHtsCode": "9015.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9015.20.8000",
      "rawHtsCode": "9015.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9015.30",
      "rawHtsCode": "9015.30",
      "superior": null,
      "indent": "1",
      "description": "Levels:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.30.4000",
      "rawHtsCode": "9015.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9015.30.8000",
      "rawHtsCode": "9015.30.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9015.40",
      "rawHtsCode": "9015.40",
      "superior": null,
      "indent": "1",
      "description": "Photogrammetrical surveying instruments and appliances:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.40.4000",
      "rawHtsCode": "9015.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9015.40.8000",
      "rawHtsCode": "9015.40.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9015.80",
      "rawHtsCode": "9015.80",
      "superior": null,
      "indent": "1",
      "description": "Other instruments and appliances:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.80.2000",
      "rawHtsCode": "9015.80.20.00",
      "superior": null,
      "indent": "2",
      "description": "Optical instruments and appliances",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9015.80.6000",
      "rawHtsCode": "9015.80.60.00",
      "superior": null,
      "indent": "3",
      "description": "Seismographs",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9015.80.80",
      "rawHtsCode": "9015.80.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9015.80.8040",
      "rawHtsCode": "9015.80.80.40",
      "superior": null,
      "indent": "4",
      "description": "Geophysical instruments and appliances",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.80.8080",
      "rawHtsCode": "9015.80.80.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9015.90.01",
      "rawHtsCode": "9015.90.01",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable to the article of which it is a part or accessory",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9015.90.0110",
      "rawHtsCode": "9015.90.01.10",
      "superior": null,
      "indent": "2",
      "description": "Of rangefinders",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.90.0120",
      "rawHtsCode": "9015.90.01.20",
      "superior": null,
      "indent": "2",
      "description": "Of theodolites and tachymeters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.90.0130",
      "rawHtsCode": "9015.90.01.30",
      "superior": null,
      "indent": "2",
      "description": "Of levels",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.90.0140",
      "rawHtsCode": "9015.90.01.40",
      "superior": null,
      "indent": "2",
      "description": "Of photogrammetrical surveying instruments and apparatus",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.90.0150",
      "rawHtsCode": "9015.90.01.50",
      "superior": null,
      "indent": "2",
      "description": "Of seismographs",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.90.0160",
      "rawHtsCode": "9015.90.01.60",
      "superior": null,
      "indent": "2",
      "description": "Of other geophysical instruments and appliances",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9015.90.0190",
      "rawHtsCode": "9015.90.01.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9016.00",
      "rawHtsCode": "9016.00",
      "superior": null,
      "indent": "0",
      "description": "Balances of a sensitivity of 5 cg or better, with or without weights; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9016.00.2000",
      "rawHtsCode": "9016.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Electrical balances and parts and accessories thereof",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9016.00.4000",
      "rawHtsCode": "9016.00.40.00",
      "superior": null,
      "indent": "2",
      "description": "Jewelers' balances and parts and accessories thereof",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9016.00.6000",
      "rawHtsCode": "9016.00.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9017",
      "rawHtsCode": "9017",
      "superior": null,
      "indent": "0",
      "description": "Drawing, marking-out or mathematical calculating instruments (for example, drafting machines, pantographs, protractors, drawing sets, slide rules, disc calculators); instruments for measuring length, for use in the hand (for example, measuring rods and tapes, micrometers, calipers), not specified or included elsewhere in this chapter; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.10",
      "rawHtsCode": "9017.10",
      "superior": null,
      "indent": "1",
      "description": "Drafting tables and machines, whether or not automatic:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.10.4000",
      "rawHtsCode": "9017.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Plotters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9017.10.8000",
      "rawHtsCode": "9017.10.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9017.20",
      "rawHtsCode": "9017.20",
      "superior": null,
      "indent": "1",
      "description": "Other drawing, marking-out or mathematical calculating instruments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.20.4000",
      "rawHtsCode": "9017.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Disc calculators, slide rules and other mathematical calculating instruments",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9017.20.7000",
      "rawHtsCode": "9017.20.70.00",
      "superior": null,
      "indent": "2",
      "description": "Plotters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9017.20.80",
      "rawHtsCode": "9017.20.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9017.20.8040",
      "rawHtsCode": "9017.20.80.40",
      "superior": null,
      "indent": "3",
      "description": "Hand operated input devices which transmit position data to computer processors or displays (digitizers)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.20.8080",
      "rawHtsCode": "9017.20.80.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.30",
      "rawHtsCode": "9017.30",
      "superior": null,
      "indent": "1",
      "description": "Micrometers, calipers and gauges:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.30.4000",
      "rawHtsCode": "9017.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Micrometers and calipers",
      "units": [
        "No."
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9017.30.8000",
      "rawHtsCode": "9017.30.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9017.80.0000",
      "rawHtsCode": "9017.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other instruments",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.65%(JP)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9017.90.01",
      "rawHtsCode": "9017.90.01",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories",
      "units": [],
      "generalRate": "The rate applicable to the article of which it is a part or accessory",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to the article of which it is a part or accessory",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9017.90.0105",
      "rawHtsCode": "9017.90.01.05",
      "superior": null,
      "indent": "2",
      "description": "Of articles of subheading 9017.10.40",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.90.0115",
      "rawHtsCode": "9017.90.01.15",
      "superior": null,
      "indent": "2",
      "description": "Of articles of subheading 9017.10.80",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.90.0120",
      "rawHtsCode": "9017.90.01.20",
      "superior": null,
      "indent": "2",
      "description": "Of articles of subheading 9017.20.40",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.90.0132",
      "rawHtsCode": "9017.90.01.32",
      "superior": null,
      "indent": "2",
      "description": "Of articles of subheading 9017.20.70",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.90.0136",
      "rawHtsCode": "9017.90.01.36",
      "superior": null,
      "indent": "2",
      "description": "Of articles of subheading 9017.20.80",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.90.0140",
      "rawHtsCode": "9017.90.01.40",
      "superior": null,
      "indent": "2",
      "description": "Of articles of subheading 9017.30.40",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.90.0150",
      "rawHtsCode": "9017.90.01.50",
      "superior": null,
      "indent": "2",
      "description": "Of articles of subheading 9017.30.80",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9017.90.0160",
      "rawHtsCode": "9017.90.01.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018",
      "rawHtsCode": "9018",
      "superior": null,
      "indent": "0",
      "description": "Instruments and appliances used in medical, surgical, dental or veterinary sciences, including scintigraphic apparatus, other electro-medical apparatus and sight-testing instruments; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.11",
      "rawHtsCode": "9018.11",
      "superior": null,
      "indent": "2",
      "description": "Electrocardiographs, and parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.11.3000",
      "rawHtsCode": "9018.11.30.00",
      "superior": null,
      "indent": "3",
      "description": "Electrocardiographs",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9018.11.6000",
      "rawHtsCode": "9018.11.60.00",
      "superior": null,
      "indent": "3",
      "description": "Printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.11.9000",
      "rawHtsCode": "9018.11.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.12.0000",
      "rawHtsCode": "9018.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Ultrasonic scanning apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.13.0000",
      "rawHtsCode": "9018.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Magnetic resonance imaging apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9018.14.0000",
      "rawHtsCode": "9018.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Scintigraphic apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9018.19",
      "rawHtsCode": "9018.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.19.4000",
      "rawHtsCode": "9018.19.40.00",
      "superior": null,
      "indent": "3",
      "description": "Apparatus for functional exploratory examination, and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.19.5500",
      "rawHtsCode": "9018.19.55.00",
      "superior": null,
      "indent": "4",
      "description": "Patient monitoring systems",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.19.7500",
      "rawHtsCode": "9018.19.75.00",
      "superior": null,
      "indent": "4",
      "description": "Printed circuit assemblies for parameter acquisition modules",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.19.95",
      "rawHtsCode": "9018.19.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9018.19.9530",
      "rawHtsCode": "9018.19.95.30",
      "superior": null,
      "indent": "5",
      "description": "Basal metabolism and blood pressure apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.19.9535",
      "rawHtsCode": "9018.19.95.35",
      "superior": null,
      "indent": "5",
      "description": "Electroencephalographs (EEG) and electromyographs (EMG)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.19.9550",
      "rawHtsCode": "9018.19.95.50",
      "superior": null,
      "indent": "5",
      "description": "Other apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.19.9560",
      "rawHtsCode": "9018.19.95.60",
      "superior": null,
      "indent": "5",
      "description": "Parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.20.00",
      "rawHtsCode": "9018.20.00",
      "superior": null,
      "indent": "1",
      "description": "Ultraviolet or infrared ray apparatus, and parts and accessories thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9018.20.0040",
      "rawHtsCode": "9018.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Therapeutic",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.20.0080",
      "rawHtsCode": "9018.20.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.31.00",
      "rawHtsCode": "9018.31.00",
      "superior": null,
      "indent": "2",
      "description": "Syringes, with or without needles; parts and accessories thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.31.0040",
      "rawHtsCode": "9018.31.00.40",
      "superior": null,
      "indent": "4",
      "description": "Hypodermic",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.31.0080",
      "rawHtsCode": "9018.31.00.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.31.0090",
      "rawHtsCode": "9018.31.00.90",
      "superior": null,
      "indent": "3",
      "description": "Parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.32.0000",
      "rawHtsCode": "9018.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Tubular metal needles and needles for sutures and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.91.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.39.00",
      "rawHtsCode": "9018.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.39.0020",
      "rawHtsCode": "9018.39.00.20",
      "superior": null,
      "indent": "4",
      "description": "Rubber catheters",
      "units": [
        "doz."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.39.0040",
      "rawHtsCode": "9018.39.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.39.0050",
      "rawHtsCode": "9018.39.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.41.0000",
      "rawHtsCode": "9018.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Dental drill engines, whether or not combined on a single base with other dental equipment, and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.49",
      "rawHtsCode": "9018.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.49.4000",
      "rawHtsCode": "9018.49.40.00",
      "superior": null,
      "indent": "3",
      "description": "Dental burs",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.49.80",
      "rawHtsCode": "9018.49.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.49.8040",
      "rawHtsCode": "9018.49.80.40",
      "superior": null,
      "indent": "4",
      "description": "Dental hand instruments and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.49.8080",
      "rawHtsCode": "9018.49.80.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.50.0000",
      "rawHtsCode": "9018.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other ophthalmic instruments and appliances and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90",
      "rawHtsCode": "9018.90",
      "superior": null,
      "indent": "1",
      "description": "Other instruments and appliances and parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.1000",
      "rawHtsCode": "9018.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Mirrors and reflectors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.2000",
      "rawHtsCode": "9018.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.90.3000",
      "rawHtsCode": "9018.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Anesthetic instruments and appliances and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.90.4000",
      "rawHtsCode": "9018.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Percussion hammers, stethoscopes and parts of stethoscopes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.50",
      "rawHtsCode": "9018.90.50",
      "superior": null,
      "indent": "3",
      "description": "Sphygmomanometers, tensimeters and oscillometers; all the foregoing and parts and accessories thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.5040",
      "rawHtsCode": "9018.90.50.40",
      "superior": null,
      "indent": "4",
      "description": "Sphygmomanometers and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.5080",
      "rawHtsCode": "9018.90.50.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.6000",
      "rawHtsCode": "9018.90.60.00",
      "superior": null,
      "indent": "4",
      "description": "Electro-surgical instruments and appliances, other than extracorporeal shock wave lithotripters; all the foregoing and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9018.90.6400",
      "rawHtsCode": "9018.90.64.00",
      "superior": null,
      "indent": "5",
      "description": "Defibrillators",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.6800",
      "rawHtsCode": "9018.90.68.00",
      "superior": null,
      "indent": "5",
      "description": "Printed circuit assemblies for the defibrillators of subheading 9018.90.64",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.75",
      "rawHtsCode": "9018.90.75",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9018.90.7520",
      "rawHtsCode": "9018.90.75.20",
      "superior": null,
      "indent": "6",
      "description": "Dialysis instruments and apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.7540",
      "rawHtsCode": "9018.90.75.40",
      "superior": null,
      "indent": "7",
      "description": "Ultrasonic",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.7560",
      "rawHtsCode": "9018.90.75.60",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.7570",
      "rawHtsCode": "9018.90.75.70",
      "superior": null,
      "indent": "6",
      "description": "Parts and accessories of dialysis instruments and apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.7580",
      "rawHtsCode": "9018.90.75.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9018.90.8000",
      "rawHtsCode": "9018.90.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019",
      "rawHtsCode": "9019",
      "superior": null,
      "indent": "0",
      "description": "Mechano-therapy appliances; massage apparatus; psychological aptitude-testing apparatus; ozone therapy, oxygen therapy, aerosol therapy, artificial respiration or other therapeutic respiration apparatus; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019.10",
      "rawHtsCode": "9019.10",
      "superior": null,
      "indent": "1",
      "description": "Mechano-therapy appliances; massage apparatus; psychological aptitude-testing apparatus; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019.10.20",
      "rawHtsCode": "9019.10.20",
      "superior": null,
      "indent": "2",
      "description": "Mechano-therapy appliances and massage apparatus; parts and accessories thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019.10.2010",
      "rawHtsCode": "9019.10.20.10",
      "superior": null,
      "indent": "3",
      "description": "Mechano-therapy appliances",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019.10.2020",
      "rawHtsCode": "9019.10.20.20",
      "superior": null,
      "indent": "6",
      "description": "Handheld",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019.10.2030",
      "rawHtsCode": "9019.10.20.30",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019.10.2035",
      "rawHtsCode": "9019.10.20.35",
      "superior": null,
      "indent": "6",
      "description": "Powered by AC adapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019.10.2045",
      "rawHtsCode": "9019.10.20.45",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019.10.2050",
      "rawHtsCode": "9019.10.20.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019.10.2090",
      "rawHtsCode": "9019.10.20.90",
      "superior": null,
      "indent": "3",
      "description": "Parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019.10.4000",
      "rawHtsCode": "9019.10.40.00",
      "superior": null,
      "indent": "3",
      "description": "Electrically operated apparatus and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019.10.6000",
      "rawHtsCode": "9019.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9019.20.0000",
      "rawHtsCode": "9019.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ozone therapy, oxygen therapy, aerosol therapy, artificial respiration or other therapeutic respiration apparatus; parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9020.00",
      "rawHtsCode": "9020.00",
      "superior": null,
      "indent": "0",
      "description": "Other breathing appliances and gas masks, excluding protective masks having neither mechanical parts nor replaceable filters; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9020.00.4000",
      "rawHtsCode": "9020.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Underwater breathing devices designed as a complete unit to be carried on the person and not requiring attendants",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9020.00.6000",
      "rawHtsCode": "9020.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other breathing appliances and gas masks",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9020.00.9000",
      "rawHtsCode": "9020.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9021",
      "rawHtsCode": "9021",
      "superior": null,
      "indent": "0",
      "description": "Orthopedic appliances, including crutches, surgical belts and trusses; splints and other fracture appliances; artificial parts of the body; hearing aids and other appliances which are worn or carried, or implanted in the body, to compensate for a defect or disability; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.10.00",
      "rawHtsCode": "9021.10.00",
      "superior": null,
      "indent": "1",
      "description": "Orthopedic or fracture appliances, and parts and accessories thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.10.0050",
      "rawHtsCode": "9021.10.00.50",
      "superior": null,
      "indent": "2",
      "description": "Bone plates, screws and nails, and other internal fixation devices or appliances",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.10.0090",
      "rawHtsCode": "9021.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.21",
      "rawHtsCode": "9021.21",
      "superior": null,
      "indent": "2",
      "description": "Artificial teeth and parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.21.4000",
      "rawHtsCode": "9021.21.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of plastics",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.21.8000",
      "rawHtsCode": "9021.21.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.29",
      "rawHtsCode": "9021.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.29.4000",
      "rawHtsCode": "9021.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of plastics",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.29.8000",
      "rawHtsCode": "9021.29.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.31.0000",
      "rawHtsCode": "9021.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Artificial joints and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.39.0000",
      "rawHtsCode": "9021.39.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.40.0000",
      "rawHtsCode": "9021.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Hearing aids, excluding parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.50.0000",
      "rawHtsCode": "9021.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Pacemakers for stimulating heart muscles, excluding parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9021.90",
      "rawHtsCode": "9021.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.90.40",
      "rawHtsCode": "9021.90.40",
      "superior": null,
      "indent": "2",
      "description": "Parts and accessories for hearing aids and for pacemakers for stimulating heart muscles",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.90.4040",
      "rawHtsCode": "9021.90.40.40",
      "superior": null,
      "indent": "3",
      "description": "For hearing aids",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.90.4080",
      "rawHtsCode": "9021.90.40.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9021.90.8100",
      "rawHtsCode": "9021.90.81.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9022",
      "rawHtsCode": "9022",
      "superior": null,
      "indent": "0",
      "description": "Apparatus based on the use of X-rays or of alpha, beta, gamma or other ionizing radiations, whether or not for medical, surgical, dental or veterinary uses, including radiography or radiotherapy apparatus, X-ray tubes and other X-ray generators, high tension generators, control panels and desks, screens, examination or treatment tables, chairs and the like; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9022.12.0000",
      "rawHtsCode": "9022.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Computed tomography apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9022.13.0000",
      "rawHtsCode": "9022.13.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, for dental uses",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9022.14.0000",
      "rawHtsCode": "9022.14.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, for medical, surgical or veterinary uses",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9022.19.0000",
      "rawHtsCode": "9022.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "For other uses",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9022.21.0000",
      "rawHtsCode": "9022.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "For medical, surgical, dental or veterinary uses",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9022.29",
      "rawHtsCode": "9022.29",
      "superior": null,
      "indent": "2",
      "description": "For other uses:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9022.29.4000",
      "rawHtsCode": "9022.29.40.00",
      "superior": null,
      "indent": "3",
      "description": "Smoke detectors, ionization type",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9022.29.8000",
      "rawHtsCode": "9022.29.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9022.30.0000",
      "rawHtsCode": "9022.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "X-ray tubes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9022.90",
      "rawHtsCode": "9022.90",
      "superior": null,
      "indent": "1",
      "description": "Other, including parts and accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9022.90.0500",
      "rawHtsCode": "9022.90.05.00",
      "superior": null,
      "indent": "2",
      "description": "Radiation generator units",
      "units": [
        "No."
      ],
      "generalRate": "0.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9022.90.1500",
      "rawHtsCode": "9022.90.15.00",
      "superior": null,
      "indent": "2",
      "description": "Radiation beam delivery units",
      "units": [
        "No."
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9022.90.2500",
      "rawHtsCode": "9022.90.25.00",
      "superior": null,
      "indent": "3",
      "description": "Other apparatus",
      "units": [
        "No."
      ],
      "generalRate": "0.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9022.90.4000",
      "rawHtsCode": "9022.90.40.00",
      "superior": null,
      "indent": "4",
      "description": "Of X-ray tubes",
      "units": [
        "No."
      ],
      "generalRate": "0.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9022.90.6000",
      "rawHtsCode": "9022.90.60.00",
      "superior": null,
      "indent": "5",
      "description": "Of apparatus based on the use of X-rays",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9022.90.7000",
      "rawHtsCode": "9022.90.70.00",
      "superior": null,
      "indent": "5",
      "description": "Of smoke detectors, ionization type",
      "units": [
        "No."
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9022.90.9500",
      "rawHtsCode": "9022.90.95.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9023.00.0000",
      "rawHtsCode": "9023.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Instruments, apparatus and models, designed for demonstrational purposes (for example, in education or exhibitions), unsuitable for other uses, and parts and accessories thereof",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "9024",
      "rawHtsCode": "9024",
      "superior": null,
      "indent": "0",
      "description": "Machines and appliances for testing the hardness, strength, compressibility, elasticity or other mechanical properties of materials (for example, metals, wood, textiles, paper, plastics), and parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9024.10.0000",
      "rawHtsCode": "9024.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machines and appliances for testing metals",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9024.80.0000",
      "rawHtsCode": "9024.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other machines and appliances",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9024.90.00",
      "rawHtsCode": "9024.90.00",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9024.90.0040",
      "rawHtsCode": "9024.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Of machines and appliances for testing metals",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9024.90.0080",
      "rawHtsCode": "9024.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9025",
      "rawHtsCode": "9025",
      "superior": null,
      "indent": "0",
      "description": "Hydrometers and similar floating instruments, thermometers, pyrometers, barometers, hygrometers and psychrometers, recording or not, and any combination of these instruments; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9025.11",
      "rawHtsCode": "9025.11",
      "superior": null,
      "indent": "2",
      "description": "Liquid-filled, for direct reading:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9025.11.2000",
      "rawHtsCode": "9025.11.20.00",
      "superior": null,
      "indent": "3",
      "description": "Clinical",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "85%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9025.11.4000",
      "rawHtsCode": "9025.11.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "85%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9025.19",
      "rawHtsCode": "9025.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9025.19.4000",
      "rawHtsCode": "9025.19.40.00",
      "superior": null,
      "indent": "3",
      "description": "Pyrometers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "9025.19.80",
      "rawHtsCode": "9025.19.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "9025.19.8010",
      "rawHtsCode": "9025.19.80.10",
      "superior": null,
      "indent": "5",
      "description": "Infrared thermometers of a kind described in statistical note 2 of this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9025.19.8020",
      "rawHtsCode": "9025.19.80.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69.           "
      ],
      "flags": []
    },
    {
      "htsCode": "9025.19.8060",
      "rawHtsCode": "9025.19.80.60",
      "superior": null,
      "indent": "5",
      "description": "Infrared thermometers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9025.19.8085",
      "rawHtsCode": "9025.19.80.85",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9025.80",
      "rawHtsCode": "9025.80",
      "superior": null,
      "indent": "1",
      "description": "Other instruments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9025.80.1000",
      "rawHtsCode": "9025.80.10.00",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [
        "No."
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9025.80.1500",
      "rawHtsCode": "9025.80.15.00",
      "superior": null,
      "indent": "3",
      "description": "Barometers, not combined with other instruments",
      "units": [
        "No."
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9025.80.2000",
      "rawHtsCode": "9025.80.20.00",
      "superior": null,
      "indent": "3",
      "description": "Hydrometers and similar floating instruments, whether or not incorporating a thermometer, non-recording",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "85%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9025.80.3500",
      "rawHtsCode": "9025.80.35.00",
      "superior": null,
      "indent": "3",
      "description": "Hygrometers and psychrometers, non-recording",
      "units": [
        "No."
      ],
      "generalRate": "1.4%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9025.80.4000",
      "rawHtsCode": "9025.80.40.00",
      "superior": null,
      "indent": "3",
      "description": "Thermographs, barographs, hygrographs and other recording instruments",
      "units": [
        "No."
      ],
      "generalRate": "1%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9025.80.5000",
      "rawHtsCode": "9025.80.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.6%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9025.90.0600",
      "rawHtsCode": "9025.90.06.00",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable to the article of which it is a part or accessory",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9026",
      "rawHtsCode": "9026",
      "superior": null,
      "indent": "0",
      "description": "Instruments and apparatus for measuring or checking the flow, level, pressure or other variables of liquids or gases (for example, flow meters, level gauges, manometers, heat meters), excluding instruments and apparatus of heading 9014, 9015, 9028 or 9032; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9026.10",
      "rawHtsCode": "9026.10",
      "superior": null,
      "indent": "1",
      "description": "For measuring or checking the flow or level of liquids:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9026.10.20",
      "rawHtsCode": "9026.10.20",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9026.10.2040",
      "rawHtsCode": "9026.10.20.40",
      "superior": null,
      "indent": "3",
      "description": "Flow meters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9026.10.2080",
      "rawHtsCode": "9026.10.20.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9026.10.4000",
      "rawHtsCode": "9026.10.40.00",
      "superior": null,
      "indent": "3",
      "description": "Flow meters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9026.10.6000",
      "rawHtsCode": "9026.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9026.20",
      "rawHtsCode": "9026.20",
      "superior": null,
      "indent": "1",
      "description": "For measuring or checking pressure:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9026.20.4000",
      "rawHtsCode": "9026.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9026.20.8000",
      "rawHtsCode": "9026.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9026.80",
      "rawHtsCode": "9026.80",
      "superior": null,
      "indent": "1",
      "description": "Other instruments and apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9026.80.2000",
      "rawHtsCode": "9026.80.20.00",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9026.80.4000",
      "rawHtsCode": "9026.80.40.00",
      "superior": null,
      "indent": "3",
      "description": "Heat meters incorporating liquid supply meters, and anemometers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9026.80.6000",
      "rawHtsCode": "9026.80.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9026.90",
      "rawHtsCode": "9026.90",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9026.90.2000",
      "rawHtsCode": "9026.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of electrical instruments and apparatus",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9026.90.4000",
      "rawHtsCode": "9026.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of flow meters, heat meters incorporating liquid supply meters and anemometers",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9026.90.6000",
      "rawHtsCode": "9026.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027",
      "rawHtsCode": "9027",
      "superior": null,
      "indent": "0",
      "description": "Instruments and apparatus for physical or chemical analysis (for example, polarimeters, refractometers, spectrometers, gas or smoke analysis apparatus); instruments and apparatus for measuring or checking viscosity, porosity, expansion, surface tension or the like; instruments and apparatus for measuring or checking quantities of heat, sound or light (including exposure meters); microtomes; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.10",
      "rawHtsCode": "9027.10",
      "superior": null,
      "indent": "1",
      "description": "Gas or smoke analysis apparatus:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.10.2000",
      "rawHtsCode": "9027.10.20.00",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.10.4000",
      "rawHtsCode": "9027.10.40.00",
      "superior": null,
      "indent": "3",
      "description": "Optical instruments and apparatus",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.10.6000",
      "rawHtsCode": "9027.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.20",
      "rawHtsCode": "9027.20",
      "superior": null,
      "indent": "1",
      "description": "Chromatographs and electrophoresis instruments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.20.50",
      "rawHtsCode": "9027.20.50",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9027.20.5030",
      "rawHtsCode": "9027.20.50.30",
      "superior": null,
      "indent": "3",
      "description": "Electrophoresis instruments",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.20.5050",
      "rawHtsCode": "9027.20.50.50",
      "superior": null,
      "indent": "3",
      "description": "Gas chromatographs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.20.5060",
      "rawHtsCode": "9027.20.50.60",
      "superior": null,
      "indent": "3",
      "description": "Liquid chromatographs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.20.5080",
      "rawHtsCode": "9027.20.50.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.20.80",
      "rawHtsCode": "9027.20.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9027.20.8030",
      "rawHtsCode": "9027.20.80.30",
      "superior": null,
      "indent": "3",
      "description": "Gas chromatographs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.20.8060",
      "rawHtsCode": "9027.20.80.60",
      "superior": null,
      "indent": "3",
      "description": "Liquid chromatographs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.20.8090",
      "rawHtsCode": "9027.20.80.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.30",
      "rawHtsCode": "9027.30",
      "superior": null,
      "indent": "1",
      "description": "Spectrometers, spectrophotometers and spectrographs using optical radiations (ultraviolet, visible, infrared):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.30.40",
      "rawHtsCode": "9027.30.40",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9027.30.4040",
      "rawHtsCode": "9027.30.40.40",
      "superior": null,
      "indent": "3",
      "description": "Spectrophotometers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.30.4080",
      "rawHtsCode": "9027.30.40.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.30.80",
      "rawHtsCode": "9027.30.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9027.30.8020",
      "rawHtsCode": "9027.30.80.20",
      "superior": null,
      "indent": "3",
      "description": "Spectroscopes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.30.8080",
      "rawHtsCode": "9027.30.80.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.50",
      "rawHtsCode": "9027.50",
      "superior": null,
      "indent": "1",
      "description": "Other instruments and apparatus using optical radiations (ultraviolet, visible, infrared):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.50.1000",
      "rawHtsCode": "9027.50.10.00",
      "superior": null,
      "indent": "2",
      "description": "Exposure meters",
      "units": [
        "No."
      ],
      "generalRate": "1.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9027.50.40",
      "rawHtsCode": "9027.50.40",
      "superior": null,
      "indent": "3",
      "description": "Electrical",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9027.50.4015",
      "rawHtsCode": "9027.50.40.15",
      "superior": null,
      "indent": "4",
      "description": "Chemical analysis instruments and apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.50.4020",
      "rawHtsCode": "9027.50.40.20",
      "superior": null,
      "indent": "4",
      "description": "Thermal analysis instruments and apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.50.4050",
      "rawHtsCode": "9027.50.40.50",
      "superior": null,
      "indent": "4",
      "description": "Photometers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.50.4060",
      "rawHtsCode": "9027.50.40.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.50.80",
      "rawHtsCode": "9027.50.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9027.50.8015",
      "rawHtsCode": "9027.50.80.15",
      "superior": null,
      "indent": "4",
      "description": "Chemical analysis instruments and apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.50.8020",
      "rawHtsCode": "9027.50.80.20",
      "superior": null,
      "indent": "4",
      "description": "Thermal analysis instruments and apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.50.8060",
      "rawHtsCode": "9027.50.80.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.81.0000",
      "rawHtsCode": "9027.81.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mass spectrometers",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.89",
      "rawHtsCode": "9027.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.89.2500",
      "rawHtsCode": "9027.89.25.00",
      "superior": null,
      "indent": "3",
      "description": "Nuclear magnetic resonance instruments",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.89.45",
      "rawHtsCode": "9027.89.45",
      "superior": null,
      "indent": "4",
      "description": "Electrical",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.89.4530",
      "rawHtsCode": "9027.89.45.30",
      "superior": null,
      "indent": "5",
      "description": "Chemical analysis instruments and apparatus",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.89.4560",
      "rawHtsCode": "9027.89.45.60",
      "superior": null,
      "indent": "5",
      "description": "Physical analysis instruments and apparatus",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.89.4590",
      "rawHtsCode": "9027.89.45.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.89.80",
      "rawHtsCode": "9027.89.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.89.8030",
      "rawHtsCode": "9027.89.80.30",
      "superior": null,
      "indent": "5",
      "description": "Chemical analysis instruments and apparatus",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.89.8060",
      "rawHtsCode": "9027.89.80.60",
      "superior": null,
      "indent": "5",
      "description": "Physical analysis instruments and apparatus",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.89.8090",
      "rawHtsCode": "9027.89.80.90",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.90",
      "rawHtsCode": "9027.90",
      "superior": null,
      "indent": "1",
      "description": "Microtomes; parts and accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.90.2000",
      "rawHtsCode": "9027.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Microtomes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.90.4500",
      "rawHtsCode": "9027.90.45.00",
      "superior": null,
      "indent": "4",
      "description": "Printed circuit assemblies for the goods of subheading 9027.81 or 9027.89",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.90.5400",
      "rawHtsCode": "9027.90.54.00",
      "superior": null,
      "indent": "5",
      "description": "Of electrophoresis instruments not incorporating an optical or other measuring device",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.90.56",
      "rawHtsCode": "9027.90.56",
      "superior": null,
      "indent": "5",
      "description": "Of instruments and apparatus of subheading 9027.20, 9027.30, 9027.50, 9027.81 or 9027.89",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.90.5625",
      "rawHtsCode": "9027.90.56.25",
      "superior": null,
      "indent": "6",
      "description": "Of articles of subheading 9027.20.50",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.90.5630",
      "rawHtsCode": "9027.90.56.30",
      "superior": null,
      "indent": "6",
      "description": "Of articles of subheading 9027.30.40",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.90.5640",
      "rawHtsCode": "9027.90.56.40",
      "superior": null,
      "indent": "6",
      "description": "Of articles of subheading 9027.50.10",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.90.5650",
      "rawHtsCode": "9027.90.56.50",
      "superior": null,
      "indent": "6",
      "description": "Of articles of subheading 9027.50.40",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.90.5695",
      "rawHtsCode": "9027.90.56.95",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.90.59",
      "rawHtsCode": "9027.90.59",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.90.5910",
      "rawHtsCode": "9027.90.59.10",
      "superior": null,
      "indent": "6",
      "description": "Of articles of subheading 9027.10.20",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.90.5995",
      "rawHtsCode": "9027.90.59.95",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9027.90.6400",
      "rawHtsCode": "9027.90.64.00",
      "superior": null,
      "indent": "5",
      "description": "Of instruments and apparatus of subheading 9027.20, 9027.30, 9027.50, 9027.81 or 9027.89",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.90.6800",
      "rawHtsCode": "9027.90.68.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.90.8400",
      "rawHtsCode": "9027.90.84.00",
      "superior": null,
      "indent": "5",
      "description": "Of instruments and apparatus of subheading 9027.20, 9027.30, 9027.50, 9027.81 or 9027.89",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9027.90.8800",
      "rawHtsCode": "9027.90.88.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9028",
      "rawHtsCode": "9028",
      "superior": null,
      "indent": "0",
      "description": "Gas, liquid or electricity supply or production meters, including calibrating meters thereof; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9028.10.0000",
      "rawHtsCode": "9028.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Gas meters",
      "units": [
        "No."
      ],
      "generalRate": "16¢ each + 2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9028.20.0000",
      "rawHtsCode": "9028.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Liquid meters",
      "units": [
        "No."
      ],
      "generalRate": "16¢ each + 2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9028.30.0000",
      "rawHtsCode": "9028.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Electricity meters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "9028.90.00",
      "rawHtsCode": "9028.90.00",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9028.90.0040",
      "rawHtsCode": "9028.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Of electricity meters",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9028.90.0080",
      "rawHtsCode": "9028.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9029",
      "rawHtsCode": "9029",
      "superior": null,
      "indent": "0",
      "description": "Revolution counters, production counters, taximeters, odometers, pedometers and the like; speedometers and tachometers, other than those of heading 9014 or 9015; stroboscopes; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9029.10",
      "rawHtsCode": "9029.10",
      "superior": null,
      "indent": "1",
      "description": "Revolution counters, production counters, taximeters, odometers, pedometers and the like:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9029.10.4000",
      "rawHtsCode": "9029.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Taximeters",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "85%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9029.10.8000",
      "rawHtsCode": "9029.10.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9029.20",
      "rawHtsCode": "9029.20",
      "superior": null,
      "indent": "1",
      "description": "Speedometers and tachometers; stroboscopes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9029.20.2000",
      "rawHtsCode": "9029.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Bicycle speedometers",
      "units": [
        "No."
      ],
      "generalRate": "6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9029.20.40",
      "rawHtsCode": "9029.20.40",
      "superior": null,
      "indent": "2",
      "description": "Other speedometers and tachometers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "9029.20.4040",
      "rawHtsCode": "9029.20.40.40",
      "superior": null,
      "indent": "3",
      "description": "For use in civil aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See General Note 6."
      ],
      "flags": []
    },
    {
      "htsCode": "9029.20.4080",
      "rawHtsCode": "9029.20.40.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9029.20.6000",
      "rawHtsCode": "9029.20.60.00",
      "superior": null,
      "indent": "2",
      "description": "Stroboscopes",
      "units": [
        "No."
      ],
      "generalRate": "16¢ each + 2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9029.90",
      "rawHtsCode": "9029.90",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9029.90.2000",
      "rawHtsCode": "9029.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Of taximeters",
      "units": [
        "kg"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "85%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9029.90.4000",
      "rawHtsCode": "9029.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of bicycle speedometers",
      "units": [
        "kg"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9029.90.6000",
      "rawHtsCode": "9029.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Of stroboscopes",
      "units": [
        "kg"
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9029.90.80",
      "rawHtsCode": "9029.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02."
      ],
      "flags": []
    },
    {
      "htsCode": "9029.90.8040",
      "rawHtsCode": "9029.90.80.40",
      "superior": null,
      "indent": "3",
      "description": "Of speedometers and tachometers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9029.90.8080",
      "rawHtsCode": "9029.90.80.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9030",
      "rawHtsCode": "9030",
      "superior": null,
      "indent": "0",
      "description": "Oscilloscopes, spectrum analyzers and other instruments and apparatus for measuring or checking electrical quantities, excluding meters of heading 9028; instruments and apparatus for measuring or detecting alpha, beta, gamma, X-ray, cosmic or other ionizing radiations; parts and accessories thereof:​",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9030.10.0000",
      "rawHtsCode": "9030.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Instruments and apparatus for measuring or detecting ionizing radiations",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9030.20",
      "rawHtsCode": "9030.20",
      "superior": null,
      "indent": "1",
      "description": "Oscilloscopes and oscillographs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9030.20.0500",
      "rawHtsCode": "9030.20.05.00",
      "superior": null,
      "indent": "2",
      "description": "Specially designed for telecommunications",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9030.20.1000",
      "rawHtsCode": "9030.20.10.00",
      "superior": null,
      "indent": "2",
      "description": "Other oscilloscopes and oscillographs",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.31.0000",
      "rawHtsCode": "9030.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Multimeters, without a recording device",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.32.0000",
      "rawHtsCode": "9030.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Multimeters, with a recording device",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.33",
      "rawHtsCode": "9030.33",
      "superior": null,
      "indent": "2",
      "description": "Other, without a recording device:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9030.33.3400",
      "rawHtsCode": "9030.33.34.00",
      "superior": null,
      "indent": "3",
      "description": "Resistance measuring instruments",
      "units": [
        "No."
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9030.33.3800",
      "rawHtsCode": "9030.33.38.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.39.0100",
      "rawHtsCode": "9030.39.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other, with a recording device",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.40.0000",
      "rawHtsCode": "9030.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other instruments and apparatus, specially designed for telecommunications (for example, cross-talk meters, gain measuring instruments, distortion factor meters, psophometers)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.82.0000",
      "rawHtsCode": "9030.82.00.00",
      "superior": null,
      "indent": "2",
      "description": "For measuring or checking semiconductor wafers or devices (including integrated circuits)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.84.0000",
      "rawHtsCode": "9030.84.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other, with a recording device",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.89.0100",
      "rawHtsCode": "9030.89.01.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.90",
      "rawHtsCode": "9030.90",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9030.90.2500",
      "rawHtsCode": "9030.90.25.00",
      "superior": null,
      "indent": "3",
      "description": "Printed circuit assemblies",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.90.4600",
      "rawHtsCode": "9030.90.46.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. ",
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.90.6600",
      "rawHtsCode": "9030.90.66.00",
      "superior": null,
      "indent": "4",
      "description": "Of instruments and apparatus of subheading 9030.40 or 9030.82",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.90.6800",
      "rawHtsCode": "9030.90.68.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.90.8400",
      "rawHtsCode": "9030.90.84.00",
      "superior": null,
      "indent": "4",
      "description": "Of instruments and apparatus of subheading 9030.82",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9030.90.89",
      "rawHtsCode": "9030.90.89",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9030.90.8911",
      "rawHtsCode": "9030.90.89.11",
      "superior": null,
      "indent": "5",
      "description": "Of articles of subheading 9030.20",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9030.90.8921",
      "rawHtsCode": "9030.90.89.21",
      "superior": null,
      "indent": "5",
      "description": "Of articles of subheading 9030.31",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9030.90.8922",
      "rawHtsCode": "9030.90.89.22",
      "superior": null,
      "indent": "5",
      "description": "Of articles of subheading 9030.32",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9030.90.8923",
      "rawHtsCode": "9030.90.89.23",
      "superior": null,
      "indent": "5",
      "description": "Of articles of subheading 9030.33",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9030.90.8931",
      "rawHtsCode": "9030.90.89.31",
      "superior": null,
      "indent": "5",
      "description": "Of articles of subheading 9030.39",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9030.90.8940",
      "rawHtsCode": "9030.90.89.40",
      "superior": null,
      "indent": "5",
      "description": "Of articles of subheading 9030.40",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9030.90.8956",
      "rawHtsCode": "9030.90.89.56",
      "superior": null,
      "indent": "5",
      "description": "Of articles of subheading 9030.84",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9030.90.8961",
      "rawHtsCode": "9030.90.89.61",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031",
      "rawHtsCode": "9031",
      "superior": null,
      "indent": "0",
      "description": "Measuring or checking instruments, appliances and machines, not specified or included elsewhere in this chapter; profile projectors; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031.10.0000",
      "rawHtsCode": "9031.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Machines for balancing mechanical parts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9031.20.0000",
      "rawHtsCode": "9031.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Test benches",
      "units": [
        "No."
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9031.41.00",
      "rawHtsCode": "9031.41.00",
      "superior": null,
      "indent": "2",
      "description": "For inspecting semiconductor wafers or devices (including integrated circuits) or for inspecting photomasks or reticles used in manufacturing semiconductor devices (including integrated circuits)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9031.41.0020",
      "rawHtsCode": "9031.41.00.20",
      "superior": null,
      "indent": "3",
      "description": "For inspecting photomasks or reticles used in manufacturing semiconductor devices",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031.41.0040",
      "rawHtsCode": "9031.41.00.40",
      "superior": null,
      "indent": "4",
      "description": "For wafers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031.41.0060",
      "rawHtsCode": "9031.41.00.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031.49",
      "rawHtsCode": "9031.49",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031.49.1000",
      "rawHtsCode": "9031.49.10.00",
      "superior": null,
      "indent": "3",
      "description": "Profile projectors",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9031.49.4000",
      "rawHtsCode": "9031.49.40.00",
      "superior": null,
      "indent": "3",
      "description": "Coordinate-measuring machines",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9031.49.7000",
      "rawHtsCode": "9031.49.70.00",
      "superior": null,
      "indent": "3",
      "description": "For inspecting masks (other than photomasks) used in manufacturing semiconductor devices; for measuring surface particulate contamination on semiconductor devices",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9031.49.9000",
      "rawHtsCode": "9031.49.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9031.80",
      "rawHtsCode": "9031.80",
      "superior": null,
      "indent": "1",
      "description": "Other instruments, appliances and machines:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031.80.4000",
      "rawHtsCode": "9031.80.40.00",
      "superior": null,
      "indent": "2",
      "description": "Electron beam microscopes fitted with equipment specifically designed for the handling and transport of semiconductor wafers or reticles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9031.80.80",
      "rawHtsCode": "9031.80.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9817.84.01 and 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9031.80.8060",
      "rawHtsCode": "9031.80.80.60",
      "superior": null,
      "indent": "4",
      "description": "For testing electrical characteristics",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031.80.8070",
      "rawHtsCode": "9031.80.80.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031.80.8085",
      "rawHtsCode": "9031.80.80.85",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031.90",
      "rawHtsCode": "9031.90",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031.90.2100",
      "rawHtsCode": "9031.90.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of profile projectors",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9031.90.4500",
      "rawHtsCode": "9031.90.45.00",
      "superior": null,
      "indent": "3",
      "description": "Bases and frames for the coordinate-measuring machines of subheading 9031.49.40",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9031.90.5400",
      "rawHtsCode": "9031.90.54.00",
      "superior": null,
      "indent": "3",
      "description": "Of optical instruments and appliances of subheading 9031.41 or 9031.49.70",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9031.90.5900",
      "rawHtsCode": "9031.90.59.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9031.90.7000",
      "rawHtsCode": "9031.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "Of articles of subheading 9031.80.40",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9031.90.91",
      "rawHtsCode": "9031.90.91",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01 and U.S. note 19 to subchapter III, chapter 99. "
      ],
      "flags": []
    },
    {
      "htsCode": "9031.90.9130",
      "rawHtsCode": "9031.90.91.30",
      "superior": null,
      "indent": "4",
      "description": "Of machines for balancing mechanical parts",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031.90.9160",
      "rawHtsCode": "9031.90.91.60",
      "superior": null,
      "indent": "4",
      "description": "Of test benches",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9031.90.9195",
      "rawHtsCode": "9031.90.91.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032",
      "rawHtsCode": "9032",
      "superior": null,
      "indent": "0",
      "description": "Automatic regulating or controlling instruments and apparatus; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.10.00",
      "rawHtsCode": "9032.10.00",
      "superior": null,
      "indent": "1",
      "description": "Thermostats",
      "units": [],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9032.10.0030",
      "rawHtsCode": "9032.10.00.30",
      "superior": null,
      "indent": "3",
      "description": "Designed for wall mounting",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9032.10.0060",
      "rawHtsCode": "9032.10.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.10.0090",
      "rawHtsCode": "9032.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.20.0000",
      "rawHtsCode": "9032.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Manostats",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9032.81.00",
      "rawHtsCode": "9032.81.00",
      "superior": null,
      "indent": "2",
      "description": "Hydraulic and pneumatic",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01."
      ],
      "flags": []
    },
    {
      "htsCode": "9032.81.0020",
      "rawHtsCode": "9032.81.00.20",
      "superior": null,
      "indent": "4",
      "description": "Hydraulic",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.81.0060",
      "rawHtsCode": "9032.81.00.60",
      "superior": null,
      "indent": "4",
      "description": "Pneumatic",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.81.0080",
      "rawHtsCode": "9032.81.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.89",
      "rawHtsCode": "9032.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.89.2000",
      "rawHtsCode": "9032.89.20.00",
      "superior": null,
      "indent": "4",
      "description": "Designed for use in a 6, 12 or 24 V system",
      "units": [
        "No."
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9032.89.4000",
      "rawHtsCode": "9032.89.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9032.89.60",
      "rawHtsCode": "9032.89.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9032.89.6015",
      "rawHtsCode": "9032.89.60.15",
      "superior": null,
      "indent": "5",
      "description": "Complete systems",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.89.6025",
      "rawHtsCode": "9032.89.60.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.89.6030",
      "rawHtsCode": "9032.89.60.30",
      "superior": null,
      "indent": "5",
      "description": "Complete systems",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.89.6040",
      "rawHtsCode": "9032.89.60.40",
      "superior": null,
      "indent": "6",
      "description": "Temperature control instruments",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.89.6050",
      "rawHtsCode": "9032.89.60.50",
      "superior": null,
      "indent": "6",
      "description": "Pressure and draft control instruments",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.89.6060",
      "rawHtsCode": "9032.89.60.60",
      "superior": null,
      "indent": "6",
      "description": "Flow and liquid level control instruments",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.89.6070",
      "rawHtsCode": "9032.89.60.70",
      "superior": null,
      "indent": "6",
      "description": "Humidity control instruments",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.89.6075",
      "rawHtsCode": "9032.89.60.75",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.89.6085",
      "rawHtsCode": "9032.89.60.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.90",
      "rawHtsCode": "9032.90",
      "superior": null,
      "indent": "1",
      "description": "Parts and accessories:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.90.2100",
      "rawHtsCode": "9032.90.21.00",
      "superior": null,
      "indent": "3",
      "description": "Designed for use in a 6, 12 or 24 V system",
      "units": [
        "kg"
      ],
      "generalRate": "1.1%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9032.90.4100",
      "rawHtsCode": "9032.90.41.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9032.90.61",
      "rawHtsCode": "9032.90.61",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "1.7%",
      "specialRate": "Free (A,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9032.90.6120",
      "rawHtsCode": "9032.90.61.20",
      "superior": null,
      "indent": "3",
      "description": "Of thermostats",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.90.6140",
      "rawHtsCode": "9032.90.61.40",
      "superior": null,
      "indent": "3",
      "description": "Of manostats",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.90.6160",
      "rawHtsCode": "9032.90.61.60",
      "superior": null,
      "indent": "3",
      "description": "Of instruments and apparatus of subheading 9032.81",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9032.90.6180",
      "rawHtsCode": "9032.90.61.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9033.00",
      "rawHtsCode": "9033.00",
      "superior": null,
      "indent": "0",
      "description": "Parts and accessories (not specified or included elsewhere in this chapter) for machines, appliances, instruments or apparatus of chapter 90:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9033.00.2000",
      "rawHtsCode": "9033.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Light-emitting diode (LED) backlights modules, the foregoing which are lighting sources that consist of one or more LEDs and one or more connectors and are mounted on a printed circuit or other similar substrate, and other passive components, whether or not combined with optical components or protective diodes, and used as backlights illumination for liquid crystal displays (LCDs)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9033.00.3000",
      "rawHtsCode": "9033.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Touch-sensitive data input devices (so-called “touch screens”) without display capabilities, for incorporation into apparatus having a display, which function by detecting the presence and location of a touch within the display area (such sensing may be obtained by means of resistance, electrostatic capacity, acoustic pulse recognition, infrared lights or other touch-sensitive technology)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": []
    },
    {
      "htsCode": "9033.00.9000",
      "rawHtsCode": "9033.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101",
      "rawHtsCode": "9101",
      "superior": null,
      "indent": "0",
      "description": "Wrist watches, pocket watches and other watches, including stop watches, with case of precious metal or of metal clad with precious metal:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9101.11",
      "rawHtsCode": "9101.11",
      "superior": null,
      "indent": "2",
      "description": "With mechanical display only:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9101.11.40",
      "rawHtsCode": "9101.11.40",
      "superior": null,
      "indent": "3",
      "description": "Having no jewels or only one jewel in the movement",
      "units": [],
      "generalRate": "51¢ each + 6.25% on the case and strap, band or bracelet + 5.3% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,R,S, SG)",
      "otherRate": "$2.25 each + 45% on the case +80% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15.  "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.11.80",
      "rawHtsCode": "9101.11.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "87¢ each + 6.25% on the case and strap, band or bracelet + 5.3% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,R,S, SG)",
      "otherRate": "$3.25 each + 45% on the case +80% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.19",
      "rawHtsCode": "9101.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9101.19.20",
      "rawHtsCode": "9101.19.20",
      "superior": null,
      "indent": "3",
      "description": "With opto-electronic display only.",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9101.19.2020",
      "rawHtsCode": "9101.19.20.20",
      "superior": null,
      "indent": "5",
      "description": "Of textile material or of base metal, whether or not gold- or silver-plated",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9101.19.2040",
      "rawHtsCode": "9101.19.20.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9101.19.2080",
      "rawHtsCode": "9101.19.20.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9101.19.40",
      "rawHtsCode": "9101.19.40",
      "superior": null,
      "indent": "3",
      "description": "Other, having no jewels or only one jewel in the movement",
      "units": [],
      "generalRate": "41¢ each + 5% on case and strap, band or bracelet + 4.2% on the battery",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$2.25 each + 45% on the case +80% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.19.80",
      "rawHtsCode": "9101.19.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "61¢ each + 4.4% on case and strap, band or bracelet + 3.7% on the battery",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$3.25 each + 45% on the case +80% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.21",
      "rawHtsCode": "9101.21",
      "superior": null,
      "indent": "2",
      "description": "With automatic winding:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9101.21.1000",
      "rawHtsCode": "9101.21.10.00",
      "superior": null,
      "indent": "5",
      "description": "Of textile material or of base metal, whether or not gold- or silver-plated",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.21.3000",
      "rawHtsCode": "9101.21.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.21.50",
      "rawHtsCode": "9101.21.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$11.50 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9101.21.80",
      "rawHtsCode": "9101.21.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "$1.61 each + 4.4% on the case and strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$5.75 each + 45% on the case +80% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.29",
      "rawHtsCode": "9101.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9101.29.10",
      "rawHtsCode": "9101.29.10",
      "superior": null,
      "indent": "3",
      "description": "Having no jewels or only one jewel in the movement",
      "units": [],
      "generalRate": "40¢ each + 5% on the case and strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,R,S, SG)",
      "otherRate": "$2.25 each + 45% on the case +80% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.29.20",
      "rawHtsCode": "9101.29.20",
      "superior": null,
      "indent": "3",
      "description": "Having over 1 jewel but not over 7 jewels in the movement",
      "units": [],
      "generalRate": "61¢ each + 4.4% on the case and strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,R,S, SG)",
      "otherRate": "$3.25 each + 45% on the case +80% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.29.30",
      "rawHtsCode": "9101.29.30",
      "superior": null,
      "indent": "5",
      "description": "With movement measuring not over 15.2 mm",
      "units": [],
      "generalRate": "$2.28 each + 5% on the case and strap, band or bracelet",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$4.75 each + 45% on the case + 80% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.29.40",
      "rawHtsCode": "9101.29.40",
      "superior": null,
      "indent": "5",
      "description": "With movement measuring over 15.2 mm",
      "units": [],
      "generalRate": "$1.92 each + 5% on the case and strap, band or bracelet",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$4.75 each + 45% on the case + 80% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.29.50",
      "rawHtsCode": "9101.29.50",
      "superior": null,
      "indent": "4",
      "description": "With movement valued over $15 each",
      "units": [],
      "generalRate": "90¢ each + 4.4% on the case and strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,R,S, SG)",
      "otherRate": "$4.75 each + 45% on the case + 80% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.29.7000",
      "rawHtsCode": "9101.29.70.00",
      "superior": null,
      "indent": "5",
      "description": "Of textile material or of base metal, whether or not gold- or silver-plated",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P, PA,PE,R,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.29.8000",
      "rawHtsCode": "9101.29.80.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.29.90",
      "rawHtsCode": "9101.29.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$11.50 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9101.91",
      "rawHtsCode": "9101.91",
      "superior": null,
      "indent": "2",
      "description": "Electrically operated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9101.91.2000",
      "rawHtsCode": "9101.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "With opto-electronic display only",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9101.91.40",
      "rawHtsCode": "9101.91.40",
      "superior": null,
      "indent": "4",
      "description": "Having no jewels or only one jewel in the movement",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.25 each + 45% on the case + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": []
    },
    {
      "htsCode": "9101.91.80",
      "rawHtsCode": "9101.91.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$3.25 each + 45% on the case + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9101.99",
      "rawHtsCode": "9101.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9101.99.20",
      "rawHtsCode": "9101.99.20",
      "superior": null,
      "indent": "3",
      "description": "Having no jewels or not over 7 jewels in the movement",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.25 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9101.99.40",
      "rawHtsCode": "9101.99.40",
      "superior": null,
      "indent": "4",
      "description": "With movement valued not over $15 each",
      "units": [],
      "generalRate": "98¢ each + 3% on the case",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$4.75 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9101.99.60",
      "rawHtsCode": "9101.99.60",
      "superior": null,
      "indent": "4",
      "description": "With movement valued over $15 each",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$4.75 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9101.99.80",
      "rawHtsCode": "9101.99.80",
      "superior": null,
      "indent": "3",
      "description": "Having over 17 jewels in the movement",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$11.50 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9102",
      "rawHtsCode": "9102",
      "superior": null,
      "indent": "0",
      "description": "Wrist watches, pocket watches and other watches, including stop watches, other than those of heading 9101:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9102.11",
      "rawHtsCode": "9102.11",
      "superior": null,
      "indent": "2",
      "description": "With mechanical display only:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9102.11.10",
      "rawHtsCode": "9102.11.10",
      "superior": null,
      "indent": "5",
      "description": "With gold- or silver-plated case",
      "units": [],
      "generalRate": "44¢ each + 6% on the case + 14% on the strap, band or bracelet + 5.3% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.90 each + 45% on the case + 110% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.11.25",
      "rawHtsCode": "9102.11.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "40¢ each + 8.5% on the case + 14% on the strap, band or bracelet + 5.3% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.70 each + 45% on the case + 110% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.11.30",
      "rawHtsCode": "9102.11.30",
      "superior": null,
      "indent": "5",
      "description": "With gold- or silver-plated case",
      "units": [],
      "generalRate": "44¢ each + 6% on the case + 2.8% on the strap, band or bracelet + 5.3% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.90 each + 45% on the case + 35% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.11.45",
      "rawHtsCode": "9102.11.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "40¢ each + 8.5% on the case + 2.8% on the strap, band or bracelet + 5.3% on the battery",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$1.70 each + 45% on the case + 35% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.11.50",
      "rawHtsCode": "9102.11.50",
      "superior": null,
      "indent": "5",
      "description": "With gold- or silver-plated case",
      "units": [],
      "generalRate": "80¢ each + 6% on the case + 14% on the strap, band or bracelet + 5.3% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$2.90 each + 45% on the case + 110% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.11.65",
      "rawHtsCode": "9102.11.65",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "76¢ each + 8.5% on the case + 14% on the strap, band or bracelet + 5.3% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$2.70 each + 45% on the case + 110% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.11.70",
      "rawHtsCode": "9102.11.70",
      "superior": null,
      "indent": "5",
      "description": "With gold- or silver-plated case",
      "units": [],
      "generalRate": "80¢ each + 6% on the case + 2.8% on the strap, band or bracelet + 5.3% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$2.90 each + 45% on the case + 35% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.11.95",
      "rawHtsCode": "9102.11.95",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "76¢ each + 8.5% on the case + 2.8% on the strap, band or bracelet + 5.3% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$2.70 each + 45% on the case + 35% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.12",
      "rawHtsCode": "9102.12",
      "superior": null,
      "indent": "2",
      "description": "With opto-electronic display only:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9102.12.2000",
      "rawHtsCode": "9102.12.20.00",
      "superior": null,
      "indent": "4",
      "description": "Of textile material or of base metal, whether or not gold- or silver-plated",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9102.12.4000",
      "rawHtsCode": "9102.12.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9102.12.8000",
      "rawHtsCode": "9102.12.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9102.19",
      "rawHtsCode": "9102.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9102.19.20",
      "rawHtsCode": "9102.19.20",
      "superior": null,
      "indent": "4",
      "description": "With strap, band or bracelet of textile material or of base metal, whether or not gold-or silver-plated",
      "units": [],
      "generalRate": "32¢ each + 4.8% on the case + 11% on the strap, band or bracelet + 4.2% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.70 each + 45% on the case + 110% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.19.40",
      "rawHtsCode": "9102.19.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "32¢ each + 4.8% on the case + 2.2% on the strap, band or bracelet + 4.2% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.70 each + 45% on the case + 35% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.19.60",
      "rawHtsCode": "9102.19.60",
      "superior": null,
      "indent": "4",
      "description": "With strap, band or bracelet of textile material or of base metal, whether or not gold-or silver-plated",
      "units": [],
      "generalRate": "57¢ each + 4.5% on the case + 10.6% on the strap, band or bracelet + 4% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$2.70 each + 45% on the case + 110% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.19.80",
      "rawHtsCode": "9102.19.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "57¢ each + 4.5% on the case + 2.1% on the strap, band or bracelet + 4% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$2.70 each + 45% on the case + 35% on the strap, band or bracelet + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.21",
      "rawHtsCode": "9102.21",
      "superior": null,
      "indent": "2",
      "description": "With automatic winding:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9102.21.10",
      "rawHtsCode": "9102.21.10",
      "superior": null,
      "indent": "4",
      "description": "With strap, band or bracelet of textile material or of base metal, whether or not gold- or silver-plated",
      "units": [],
      "generalRate": "75¢ each + 6% on the case + 14% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$2.70 each + 45% on the case + 110% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.21.25",
      "rawHtsCode": "9102.21.25",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "75¢ each + 6% on the case + 2.8% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$2.70 each + 45% on the case + 35% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.21.30",
      "rawHtsCode": "9102.21.30",
      "superior": null,
      "indent": "4",
      "description": "With strap, band or bracelet of textile material or of base metal, whether or not gold- or silver-plated",
      "units": [],
      "generalRate": "$1.75 each + 4.8% on the case + 11.2% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$5.20 each + 45% on the case + 110% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.21.50",
      "rawHtsCode": "9102.21.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "$1.75 each + 4.8% on the case + 2.2% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$5.20 each + 45% on the case + 35% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.21.70",
      "rawHtsCode": "9102.21.70",
      "superior": null,
      "indent": "4",
      "description": "With strap, band or bracelet of textile material or of base metal, whether or not gold- or silver-plated",
      "units": [],
      "generalRate": "$1.53 each + 4.2% on the case + 9.8% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$10.95 each + 45% on the case + 110% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.21.90",
      "rawHtsCode": "9102.21.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "$1.53 each + 4.2% on the case + 2% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$10.95 each + 45% on the case + 35% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29",
      "rawHtsCode": "9102.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9102.29.0200",
      "rawHtsCode": "9102.29.02.00",
      "superior": null,
      "indent": "5",
      "description": "Straps, bands or bracelets entered with watches of subheading 9102.29.04 and classifiable therewith pursuant to additional U.S. note 2 to this chapter; all the foregoing whether or not attached to such watches at the time of entry",
      "units": [
        "No."
      ],
      "generalRate": "14%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29.04",
      "rawHtsCode": "9102.29.04",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "40¢ each + 6% on the case",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$1.70 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29.10",
      "rawHtsCode": "9102.29.10",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "40¢ each + 6% on the case + 2.8% on the strap, band or bracelet",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$1.70 each + 45% on the case + 35% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29.15",
      "rawHtsCode": "9102.29.15",
      "superior": null,
      "indent": "4",
      "description": "With strap, band or bracelet of textile material or of base metal, whether or not gold- or silver-plated",
      "units": [],
      "generalRate": "58¢ each + 4.6% on the case + 10.6% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$2.70 each + 45% on the case + 110% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29.20",
      "rawHtsCode": "9102.29.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "56¢ each + 4.4% on the case + 2% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$2.70 each + 45% on the case + 35% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29.25",
      "rawHtsCode": "9102.29.25",
      "superior": null,
      "indent": "6",
      "description": "With strap, band or bracelet of textile material or of base metal, whether or not gold- or silver- plated",
      "units": [],
      "generalRate": "$2.19 each + 4.8% on the case + 11.2% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$4.20 each + 45% on the case + 110% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29.30",
      "rawHtsCode": "9102.29.30",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "$2.19 each + 4.8% on the case + 2.2% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$4.20 each + 45% on the case + 35% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29.35",
      "rawHtsCode": "9102.29.35",
      "superior": null,
      "indent": "6",
      "description": "With strap, band or bracelet of textile material or of base metal, whether or not gold- or silver- plated",
      "units": [],
      "generalRate": "$1.61 each + 4.2% on the case + 9.8% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$4.20 each + 45% on the case + 110% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29.40",
      "rawHtsCode": "9102.29.40",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [],
      "generalRate": "$1.83 each + 4.8% on the case + 2.2% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$4.20 each + 45% on the case + 35% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29.45",
      "rawHtsCode": "9102.29.45",
      "superior": null,
      "indent": "5",
      "description": "With strap, band or bracelet of textile material or of base metal, whether or not gold- or silver-plated",
      "units": [],
      "generalRate": "93¢ each + 4.8% on the case + 11.2% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$4.20 each + 45% on the case + 110% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29.50",
      "rawHtsCode": "9102.29.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "93¢ each + 4.8% on the case + 2.2% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$4.20 each + 45% on the case + 35% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29.55",
      "rawHtsCode": "9102.29.55",
      "superior": null,
      "indent": "4",
      "description": "With strap, band or bracelet of textile material or of base metal, whether or not gold-or silver-plated",
      "units": [],
      "generalRate": "$1.55 each + 4.2% on the case + 9.9% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$10.95 each + 45% on the case + 110% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.29.60",
      "rawHtsCode": "9102.29.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "$1.75 each + 4.8% on the case + 2.2% on the strap, band or bracelet",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$10.95 each + 45% on the case + 35% on the strap, band or bracelet",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.91",
      "rawHtsCode": "9102.91",
      "superior": null,
      "indent": "2",
      "description": "Electrically operated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9102.91.20",
      "rawHtsCode": "9102.91.20",
      "superior": null,
      "indent": "3",
      "description": "With opto-electronic display only",
      "units": [],
      "generalRate": "3.9% on the movement and case + 5.3% on the battery",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.91.40",
      "rawHtsCode": "9102.91.40",
      "superior": null,
      "indent": "4",
      "description": "Having no jewels or only one jewel in the movement",
      "units": [],
      "generalRate": "40¢ each + 6% on the case + 5.3% on the battery",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$1.70 each + 45% on the case + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.91.80",
      "rawHtsCode": "9102.91.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "76¢ each + 6% on the case + 5.3% on the battery",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$2.70 each + 45% on the case + 35% on thebattery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.99",
      "rawHtsCode": "9102.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9102.99.20",
      "rawHtsCode": "9102.99.20",
      "superior": null,
      "indent": "3",
      "description": "Having no jewels or not over 7 jewels in the movement",
      "units": [],
      "generalRate": "20¢ each + 3% on the case",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$1.70 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.99.40",
      "rawHtsCode": "9102.99.40",
      "superior": null,
      "indent": "4",
      "description": "With movement valued not over $15 each",
      "units": [],
      "generalRate": "92¢ each + 3% on the case",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$4.20 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.99.60",
      "rawHtsCode": "9102.99.60",
      "superior": null,
      "indent": "4",
      "description": "With movement valued over $15 each",
      "units": [],
      "generalRate": "$1.16 each + 6% on the case",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$4.20 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9102.99.80",
      "rawHtsCode": "9102.99.80",
      "superior": null,
      "indent": "3",
      "description": "Having over 17 jewels in the movement",
      "units": [],
      "generalRate": "$2.19 each + 6% on the case",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$10.95 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9103",
      "rawHtsCode": "9103",
      "superior": null,
      "indent": "0",
      "description": "Clocks with watch movements, excluding clocks of heading 9104:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9103.10",
      "rawHtsCode": "9103.10",
      "superior": null,
      "indent": "1",
      "description": "Electrically operated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9103.10.20",
      "rawHtsCode": "9103.10.20",
      "superior": null,
      "indent": "2",
      "description": "With opto-electronic display only",
      "units": [],
      "generalRate": "2.6% on the movement and case + 3.6% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9103.10.40",
      "rawHtsCode": "9103.10.40",
      "superior": null,
      "indent": "3",
      "description": "Having no jewels or only one jewel in the movement",
      "units": [],
      "generalRate": "24¢ each + 4.5% on the case + 3.5% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.50 each + 45% on the case + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9103.10.80",
      "rawHtsCode": "9103.10.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "48¢ each + 4.6% on the case + 3.5% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$2.50 each + 45% on the case + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9103.90.00",
      "rawHtsCode": "9103.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "24¢ each + 4.6% on the case",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.50 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9104.00",
      "rawHtsCode": "9104.00",
      "superior": null,
      "indent": "0",
      "description": "Instrument panel clocks and clocks of a similar type for vehicles, aircraft, spacecraft or vessels:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9104.00.05",
      "rawHtsCode": "9104.00.05",
      "superior": null,
      "indent": "3",
      "description": "With opto-electronic display only",
      "units": [],
      "generalRate": "2.6% on the movement and case + 3.5% on the battery",
      "specialRate": "Free (A+,AU,B,BH, C,CL,CO,D,E, IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter.",
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9104.00.10",
      "rawHtsCode": "9104.00.10",
      "superior": null,
      "indent": "4",
      "description": "Electric (including battery operated)",
      "units": [],
      "generalRate": "20¢ each + 4.3% on the movement and case + 3.5% on the battery",
      "specialRate": "Free (A+,AU,B,BH, C,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "$3 each + 65% on the movement and case + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter.",
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9104.00.2000",
      "rawHtsCode": "9104.00.20.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "30¢ each + 6.4%",
      "specialRate": "Free (A+,AU,B,BH, C,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "$3 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9104.00.25",
      "rawHtsCode": "9104.00.25",
      "superior": null,
      "indent": "3",
      "description": "With opto-electronic display only",
      "units": [],
      "generalRate": "3.9% on the movement and case + 5.3% on the battery",
      "specialRate": "Free (A+,AU,B,BH, C,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter.",
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9104.00.30",
      "rawHtsCode": "9104.00.30",
      "superior": null,
      "indent": "4",
      "description": "Electric (including battery operated)",
      "units": [],
      "generalRate": "30¢ each + 4.3% on the movement and case + 3.5% on the battery",
      "specialRate": "Free (A+,AU,B,BH, C,CL,CO,D, E,IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65% on the movement and case + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter.",
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9104.00.4000",
      "rawHtsCode": "9104.00.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "30¢ each + 4.3%",
      "specialRate": "Free (A+,AU,B,BH, C,CL,CO,D, E,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9104.00.45",
      "rawHtsCode": "9104.00.45",
      "superior": null,
      "indent": "2",
      "description": "With opto-electronic display only",
      "units": [],
      "generalRate": "2.6% on the movement and case + 3.5% on the battery",
      "specialRate": "Free (A+,AU,B,BH, C,CL,CO,D, E,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter.",
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9104.00.50",
      "rawHtsCode": "9104.00.50",
      "superior": null,
      "indent": "3",
      "description": "Electric (including battery operated)",
      "units": [],
      "generalRate": "20¢ each + 4.6% on the case + 3.5% on the battery",
      "specialRate": "Free (A+,AU,B,BH, C,CL,CO,D, E,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "75¢ each + 45% on the case + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter.",
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9104.00.60",
      "rawHtsCode": "9104.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "19¢ each + 4.5% on the case",
      "specialRate": "Free (A+,AU,B,BH, C,CL,CO,D, E,IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "75¢ each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105",
      "rawHtsCode": "9105",
      "superior": null,
      "indent": "0",
      "description": "Other clocks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9105.11",
      "rawHtsCode": "9105.11",
      "superior": null,
      "indent": "2",
      "description": "Electrically operated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9105.11.40",
      "rawHtsCode": "9105.11.40",
      "superior": null,
      "indent": "3",
      "description": "With opto-electronic display only",
      "units": [],
      "generalRate": "3.9% on the movement and case + 5.3% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.11.80",
      "rawHtsCode": "9105.11.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "30¢ each + 6.9% on the case + 5.3% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75¢ each + 45% on the case + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.19",
      "rawHtsCode": "9105.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9105.19.10",
      "rawHtsCode": "9105.19.10",
      "superior": null,
      "indent": "4",
      "description": "Not constructed or designed to operate for over 47 hours without rewinding",
      "units": [],
      "generalRate": "30¢ each + 6.9% on the case",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "75¢ each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.19.20",
      "rawHtsCode": "9105.19.20",
      "superior": null,
      "indent": "5",
      "description": "Having no jewels or only one jewel",
      "units": [],
      "generalRate": "60¢ each + 6.9% on the case",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "$1.75 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.19.30",
      "rawHtsCode": "9105.19.30",
      "superior": null,
      "indent": "5",
      "description": "Having over one jewel",
      "units": [],
      "generalRate": "43¢ each + 2.8¢/jewel over 7 + 3.7% on the case",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR, MA,OM,P, PA,PE,S,SG)",
      "otherRate": "$2.25 each + 15¢/jewel over 7 + 60% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.19.4000",
      "rawHtsCode": "9105.19.40.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "15¢ each + 6.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.19.5000",
      "rawHtsCode": "9105.19.50.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "23¢ each + 3.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.21",
      "rawHtsCode": "9105.21",
      "superior": null,
      "indent": "2",
      "description": "Electrically operated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9105.21.40",
      "rawHtsCode": "9105.21.40",
      "superior": null,
      "indent": "3",
      "description": "With opto-electronic display only",
      "units": [],
      "generalRate": "3.9% on the movement and case+ 5.3% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.21.80",
      "rawHtsCode": "9105.21.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "30¢ each + 6.9% on the case + 5.3% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "75¢ each + 45% on the case + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.29",
      "rawHtsCode": "9105.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9105.29.10",
      "rawHtsCode": "9105.29.10",
      "superior": null,
      "indent": "4",
      "description": "Not constructed or designed to operate for over 47 hours without rewinding",
      "units": [],
      "generalRate": "20¢ each + 4.6% on the case",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "75¢ each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.29.20",
      "rawHtsCode": "9105.29.20",
      "superior": null,
      "indent": "5",
      "description": "Having no jewels or only one jewel",
      "units": [],
      "generalRate": "40¢ each + 4.6% on the case",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.75 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.29.30",
      "rawHtsCode": "9105.29.30",
      "superior": null,
      "indent": "5",
      "description": "Having over one jewel",
      "units": [],
      "generalRate": "57¢ each + 3.7¢/jewel over 7 + 4.9% on the case",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$2.25 each + 15¢/jewel over 7 + 60% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.29.4000",
      "rawHtsCode": "9105.29.40.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "15¢ each + 6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.29.5000",
      "rawHtsCode": "9105.29.50.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "30¢ each + 4.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.91",
      "rawHtsCode": "9105.91",
      "superior": null,
      "indent": "2",
      "description": "Electrically operated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9105.91.40",
      "rawHtsCode": "9105.91.40",
      "superior": null,
      "indent": "3",
      "description": "With opto-electronic display only",
      "units": [],
      "generalRate": "3.9% on the movement and case+ 5.3% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.91.80",
      "rawHtsCode": "9105.91.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "30¢ each + 6.9% on the case + 5.3% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "75¢ each + 45% on the case + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.99",
      "rawHtsCode": "9105.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9105.99.1000",
      "rawHtsCode": "9105.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Standard marine chronometers having spring-detent escapements",
      "units": [
        "No.",
        "Jwls."
      ],
      "generalRate": "17¢ each + 2.5% + 1¢/jewel",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65% + 25¢/jewel",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.99.20",
      "rawHtsCode": "9105.99.20",
      "superior": null,
      "indent": "4",
      "description": "Not constructed or designed to operate for over 47 hours without rewinding",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "75¢ each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9105.99.30",
      "rawHtsCode": "9105.99.30",
      "superior": null,
      "indent": "5",
      "description": "Having no jewels or only one jewel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1.75 each + 45% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9105.99.40",
      "rawHtsCode": "9105.99.40",
      "superior": null,
      "indent": "5",
      "description": "Having over one jewel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$2.25 each + 15¢/jewel over 7 + 60% on the case",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9105.99.5000",
      "rawHtsCode": "9105.99.50.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "7.5¢ each + 3.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9105.99.6000",
      "rawHtsCode": "9105.99.60.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "23¢ each + 3.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9106",
      "rawHtsCode": "9106",
      "superior": null,
      "indent": "0",
      "description": "Time of day recording apparatus and apparatus for measuring, recording or otherwise indicating intervals of time, with clock or watch movement or with synchronous motor (for example, time registers, time-recorders):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9106.10.0000",
      "rawHtsCode": "9106.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Time registers; time-recorders",
      "units": [
        "No.",
        "Jwls."
      ],
      "generalRate": "36¢ each + 5.6% + 2¢/jewel",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65% + 25¢/jewel",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9106.90",
      "rawHtsCode": "9106.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9106.90.2000",
      "rawHtsCode": "9106.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Parking meters",
      "units": [
        "No.",
        "Jwls."
      ],
      "generalRate": "36¢ each + 5.6% + 2¢/jewel",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65% + 25¢/jewel",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9106.90.4000",
      "rawHtsCode": "9106.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Time locks valued over $10 each",
      "units": [
        "No.",
        "Jwls."
      ],
      "generalRate": "36¢ each + 5.6% + 2¢/jewel",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65% + 25¢/jewel",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9106.90.55",
      "rawHtsCode": "9106.90.55",
      "superior": null,
      "indent": "4",
      "description": "With opto-electronic display only",
      "units": [],
      "generalRate": "3.9% on the apparatus + 5.3% on the battery",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.",
        "See statistical note 1 to this chapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9106.90.6500",
      "rawHtsCode": "9106.90.65.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "Jwls."
      ],
      "generalRate": "15¢ each + 2.3% + 0.8¢/jewel",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65% + 25¢/jewel",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9106.90.7500",
      "rawHtsCode": "9106.90.75.00",
      "superior": null,
      "indent": "4",
      "description": "Apparatus for measuring, recording or otherwise indicating intervals of time, with clock or watch movements, AC powered and with opto-electronic display only",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9106.90.8500",
      "rawHtsCode": "9106.90.85.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "Jwls."
      ],
      "generalRate": "15¢ each + 2.3% + 0.8¢/jewel",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65% + 25¢/jewel",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9107.00",
      "rawHtsCode": "9107.00",
      "superior": null,
      "indent": "0",
      "description": "Time switches with clock or watch movement or with synchronous motor:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9107.00.40",
      "rawHtsCode": "9107.00.40",
      "superior": null,
      "indent": "1",
      "description": "Valued not over $5 each",
      "units": [],
      "generalRate": "15¢ each + 4% + 2.5¢/jewel",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.50 each + 65% + 25¢/jewel",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9107.00.4040",
      "rawHtsCode": "9107.00.40.40",
      "superior": null,
      "indent": "2",
      "description": "Time switches that operate on a fixed-time cycle, of a type used in household type refrigerators and combined refrigerator-freezers, to alternately control the operations of the compressor and the defrost unit (defrost timers)",
      "units": [
        "No.",
        "Jwls."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9107.00.4080",
      "rawHtsCode": "9107.00.40.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No.",
        "Jwls."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9107.00.8000",
      "rawHtsCode": "9107.00.80.00",
      "superior": null,
      "indent": "1",
      "description": "Valued over $5 each",
      "units": [
        "No.",
        "Jwls."
      ],
      "generalRate": "45¢ each + 6.4% + 2.5¢/jewel",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65% + 25¢/jewel",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108",
      "rawHtsCode": "9108",
      "superior": null,
      "indent": "0",
      "description": "Watch movements, complete and assembled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9108.11",
      "rawHtsCode": "9108.11",
      "superior": null,
      "indent": "2",
      "description": "With mechanical display only or with a device to which a mechanical display can be incorporated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9108.11.40",
      "rawHtsCode": "9108.11.40",
      "superior": null,
      "indent": "3",
      "description": "Having no jewels or only one jewel",
      "units": [],
      "generalRate": "36¢ each + 5.3% on the battery",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$1.50 each + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.11.80",
      "rawHtsCode": "9108.11.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "72¢ each + 5.3% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$2.50 each + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.12.00",
      "rawHtsCode": "9108.12.00",
      "superior": null,
      "indent": "2",
      "description": "With opto-electronic display only",
      "units": [],
      "generalRate": "3.1% on the movement + 4.2% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.19",
      "rawHtsCode": "9108.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9108.19.40",
      "rawHtsCode": "9108.19.40",
      "superior": null,
      "indent": "3",
      "description": "Having no jewels or only one jewel",
      "units": [],
      "generalRate": "28¢ each + 4.2% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$1.50 each + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.19.80",
      "rawHtsCode": "9108.19.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "53¢ each + 3.9% on the battery",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$2.50 each + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.20",
      "rawHtsCode": "9108.20",
      "superior": null,
      "indent": "1",
      "description": "With automatic winding:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9108.20.4000",
      "rawHtsCode": "9108.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Having over 17 jewels",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$10.75 each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9108.20.8000",
      "rawHtsCode": "9108.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$5.00 each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9108.90",
      "rawHtsCode": "9108.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9108.90.1000",
      "rawHtsCode": "9108.90.10.00",
      "superior": null,
      "indent": "3",
      "description": "Measuring 33.8 mm or less",
      "units": [
        "No."
      ],
      "generalRate": "29¢ each",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.50 each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.90.2000",
      "rawHtsCode": "9108.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "25¢ each",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$1.50 each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.90.3000",
      "rawHtsCode": "9108.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "Measuring 33.8 mm or less",
      "units": [
        "No."
      ],
      "generalRate": "57¢ each",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$2.50 each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.90.4000",
      "rawHtsCode": "9108.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "25¢ each",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE, R,S,SG)",
      "otherRate": "$1.50 each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.90.5000",
      "rawHtsCode": "9108.90.50.00",
      "superior": null,
      "indent": "5",
      "description": "Measuring not over 15.2 mm",
      "units": [
        "No."
      ],
      "generalRate": "$2.16 each",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$4 each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.90.6000",
      "rawHtsCode": "9108.90.60.00",
      "superior": null,
      "indent": "5",
      "description": "Measuring over 15.2 mm",
      "units": [
        "No."
      ],
      "generalRate": "$1.80 each",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$4 each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.90.7000",
      "rawHtsCode": "9108.90.70.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $15 each",
      "units": [
        "No."
      ],
      "generalRate": "90¢ each",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$4 each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.90.8000",
      "rawHtsCode": "9108.90.80.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $15 each",
      "units": [
        "No."
      ],
      "generalRate": "$1.44 each",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "$4 each",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.90.8500",
      "rawHtsCode": "9108.90.85.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $15 each",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$4 each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9108.90.9000",
      "rawHtsCode": "9108.90.90.00",
      "superior": null,
      "indent": "3",
      "description": "Measuring 33.8 mm or less",
      "units": [
        "No."
      ],
      "generalRate": "$1.50 each",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$10.75 each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9108.90.9500",
      "rawHtsCode": "9108.90.95.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "$1.72 each",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "$10.75 each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9109",
      "rawHtsCode": "9109",
      "superior": null,
      "indent": "0",
      "description": "Clock movements, complete and assembled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9109.10",
      "rawHtsCode": "9109.10",
      "superior": null,
      "indent": "1",
      "description": "Electrically operated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9109.10.10",
      "rawHtsCode": "9109.10.10",
      "superior": null,
      "indent": "3",
      "description": "With opto-electronic display only",
      "units": [],
      "generalRate": "3.9% on the movement + 5.3% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9109.10.20",
      "rawHtsCode": "9109.10.20",
      "superior": null,
      "indent": "4",
      "description": "Measuring not over 50 mm in width or diameter",
      "units": [],
      "generalRate": "30¢ each + 5.3% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "75¢ each + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9109.10.30",
      "rawHtsCode": "9109.10.30",
      "superior": null,
      "indent": "5",
      "description": "Valued not over $5 each",
      "units": [],
      "generalRate": "7.5¢ each + 3.2% on the movement + 2.6% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO, KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$1.50 each + 65% on the movement + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9109.10.40",
      "rawHtsCode": "9109.10.40",
      "superior": null,
      "indent": "5",
      "description": "Valued over $5 each",
      "units": [],
      "generalRate": "22¢ each + 3.2% on the movement + 2.6% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65% on the movement + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9109.10.50",
      "rawHtsCode": "9109.10.50",
      "superior": null,
      "indent": "3",
      "description": "With opto-electronic display only",
      "units": [],
      "generalRate": "3.9% on the movement + 5.3% on the battery",
      "specialRate": "Free (A+,AU,BH, C,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG) ",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9109.10.60",
      "rawHtsCode": "9109.10.60",
      "superior": null,
      "indent": "4",
      "description": "Measuring not over 50 mm in width or diameter",
      "units": [],
      "generalRate": "20¢ each + 3.5% on the battery",
      "specialRate": "Free (A+,AU,BH, C,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG) ",
      "otherRate": "75¢ each + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9109.10.70",
      "rawHtsCode": "9109.10.70",
      "superior": null,
      "indent": "5",
      "description": "Valued not over $5 each",
      "units": [],
      "generalRate": "12¢ each + 5.1% on the movement + 4.2% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.50 each + 65% on the movement + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9109.10.80",
      "rawHtsCode": "9109.10.80",
      "superior": null,
      "indent": "5",
      "description": "Valued over $5 each",
      "units": [],
      "generalRate": "30¢ each + 4.3% on the movement + 3.5% on the battery",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S, SG) ",
      "otherRate": "$4.50 each + 65% on the movement + 35% on the battery",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter. ",
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9109.90",
      "rawHtsCode": "9109.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9109.90.2000",
      "rawHtsCode": "9109.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Measuring not over 50 mm in width or diameter",
      "units": [
        "No."
      ],
      "generalRate": "20¢ each",
      "specialRate": "Free (A+,AU,B,BH, C,CL,CO,D,E, IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "75¢ each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9109.90.4000",
      "rawHtsCode": "9109.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "15¢ each + 6.4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9109.90.6000",
      "rawHtsCode": "9109.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $5 each",
      "units": [
        "No."
      ],
      "generalRate": "30¢ each + 4.3%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$4.50 each + 65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9110",
      "rawHtsCode": "9110",
      "superior": null,
      "indent": "0",
      "description": "Complete watch or clock movements, unassembled or partly assembled (movement sets); incomplete watch or clock movements, assembled; rough watch or clock movements:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9110.11.0000",
      "rawHtsCode": "9110.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Complete movements, unassembled or partly assembled (movement sets)",
      "units": [
        "No."
      ],
      "generalRate": "The rate applicable to the complete, assembled movement",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "The rate applicable to the complete, assembled",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9110.12.0000",
      "rawHtsCode": "9110.12.00.00",
      "superior": null,
      "indent": "2",
      "description": "Incomplete movements, assembled",
      "units": [
        "No."
      ],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9110.19.0000",
      "rawHtsCode": "9110.19.00.00",
      "superior": null,
      "indent": "2",
      "description": "Rough movements",
      "units": [
        "No."
      ],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9110.90",
      "rawHtsCode": "9110.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9110.90.2000",
      "rawHtsCode": "9110.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Complete movements, unassembled or partly assembled (movement sets)",
      "units": [
        "No."
      ],
      "generalRate": "The rate applicable to the complete, assembled movement",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to the complete, assembled movement",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9110.90.4000",
      "rawHtsCode": "9110.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Consisting of two or more pieces or parts fastened or joined together",
      "units": [
        "No."
      ],
      "generalRate": "4.3% + 1.7¢/jewel + 0.2¢ for each other piece or part, but if consisting in part of a plate or a set of plates the total duty shall not exceed the duty for the complete movement",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "65% + 25¢/jewel + 3¢ for each other piece or part, but if consisting in part of a plate or a set of plates the total duty shall not exceed the duty for the complete movement",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9110.90.6000",
      "rawHtsCode": "9110.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9111",
      "rawHtsCode": "9111",
      "superior": null,
      "indent": "0",
      "description": "Watch cases and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9111.10.0000",
      "rawHtsCode": "9111.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Cases of precious metal or of metal clad with precious metal",
      "units": [
        "No."
      ],
      "generalRate": "12¢ each + 4.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "75¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9111.20",
      "rawHtsCode": "9111.20",
      "superior": null,
      "indent": "1",
      "description": "Cases of base metal, whether or not gold- or silver-plated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9111.20.2000",
      "rawHtsCode": "9111.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Gold- or silver-plated",
      "units": [
        "No."
      ],
      "generalRate": "7¢ each + 5.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "40¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9111.20.4000",
      "rawHtsCode": "9111.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.6¢ each + 7.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "20¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9111.80.0000",
      "rawHtsCode": "9111.80.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other cases",
      "units": [
        "No."
      ],
      "generalRate": "3.6¢ each + 7.6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "20¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9111.90",
      "rawHtsCode": "9111.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9111.90.4000",
      "rawHtsCode": "9111.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of precious metal or of metal clad with precious metal",
      "units": [
        "No."
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "75¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9111.90.5000",
      "rawHtsCode": "9111.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Bezels, backs and centers",
      "units": [
        "No."
      ],
      "generalRate": "1.6¢ each + 6.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "10¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9111.90.7000",
      "rawHtsCode": "9111.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "6.4%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9112",
      "rawHtsCode": "9112",
      "superior": null,
      "indent": "0",
      "description": "Clock cases and cases of a similar type for other goods of this chapter, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9112.20",
      "rawHtsCode": "9112.20",
      "superior": null,
      "indent": "1",
      "description": "Cases:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9112.20.4000",
      "rawHtsCode": "9112.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Cases of metal",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9112.20.8000",
      "rawHtsCode": "9112.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other cases",
      "units": [
        "No."
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9112.90.0000",
      "rawHtsCode": "9112.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "kg"
      ],
      "generalRate": "5.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9113",
      "rawHtsCode": "9113",
      "superior": null,
      "indent": "0",
      "description": "Watch straps, watch bands and watch bracelets, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9113.10.0000",
      "rawHtsCode": "9113.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of precious metal or of metal clad with precious metal",
      "units": [
        "doz."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9113.20",
      "rawHtsCode": "9113.20",
      "superior": null,
      "indent": "1",
      "description": "Of base metal, whether or not gold- or silver-plated:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9113.20.2000",
      "rawHtsCode": "9113.20.20.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $5 per dozen",
      "units": [
        "doz."
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9113.20.4000",
      "rawHtsCode": "9113.20.40.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $5 per dozen",
      "units": [
        "doz."
      ],
      "generalRate": "11.2%",
      "specialRate": "Free (AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9113.20.6000",
      "rawHtsCode": "9113.20.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of watch bracelets, valued not over $12 per dozen",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9113.20.9000",
      "rawHtsCode": "9113.20.90.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9113.90",
      "rawHtsCode": "9113.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9113.90.4000",
      "rawHtsCode": "9113.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Of textile material",
      "units": [
        "doz."
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9113.90.8000",
      "rawHtsCode": "9113.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "doz."
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,R,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9114",
      "rawHtsCode": "9114",
      "superior": null,
      "indent": "0",
      "description": "Other clock or watch parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9114.30",
      "rawHtsCode": "9114.30",
      "superior": null,
      "indent": "1",
      "description": "Dials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9114.30.4000",
      "rawHtsCode": "9114.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Not exceeding 50 mm in width",
      "units": [
        "No."
      ],
      "generalRate": "0.4¢ each + 7.2%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "5¢ each + 45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9114.30.8000",
      "rawHtsCode": "9114.30.80.00",
      "superior": null,
      "indent": "2",
      "description": "Exceeding 50 mm in width",
      "units": [
        "No."
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9114.40",
      "rawHtsCode": "9114.40",
      "superior": null,
      "indent": "1",
      "description": "Plates and bridges:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9114.40.2000",
      "rawHtsCode": "9114.40.20.00",
      "superior": null,
      "indent": "2",
      "description": "Watch movement bottom or pillar plates or their equivalent",
      "units": [
        "No."
      ],
      "generalRate": "12¢ each",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "75¢ each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9114.40.4000",
      "rawHtsCode": "9114.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "Any plate, or set of plates, suitable for assembling thereon a clock movement",
      "units": [
        "No."
      ],
      "generalRate": "10¢ each",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "38¢ each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9114.40.6000",
      "rawHtsCode": "9114.40.60.00",
      "superior": null,
      "indent": "3",
      "description": "For watches",
      "units": [
        "No."
      ],
      "generalRate": "7.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9114.40.8000",
      "rawHtsCode": "9114.40.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9114.90",
      "rawHtsCode": "9114.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9114.90.1000",
      "rawHtsCode": "9114.90.10.00",
      "superior": null,
      "indent": "2",
      "description": "Jewels",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9114.90.1500",
      "rawHtsCode": "9114.90.15.00",
      "superior": null,
      "indent": "3",
      "description": "For watch movements",
      "units": [
        "kg"
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9114.90.3000",
      "rawHtsCode": "9114.90.30.00",
      "superior": null,
      "indent": "3",
      "description": "For clock movements",
      "units": [
        "kg"
      ],
      "generalRate": "6% + 2.3¢/jewel + 0.2¢ for each other piece or part, but if consisting in part of a plate or a set of plates the total duty shall not exceed the duty for the complete movement",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,S,SG)",
      "otherRate": "65% + 25¢/jewel + 3¢ for each other piece or part, but if consisting in part of a plate or a set of plates the total duty shall not exceed the duty for the complete movement",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9114.90.3400",
      "rawHtsCode": "9114.90.34.00",
      "superior": null,
      "indent": "3",
      "description": "For watches",
      "units": [
        "No."
      ],
      "generalRate": "7.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9114.90.3800",
      "rawHtsCode": "9114.90.38.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9114.90.4000",
      "rawHtsCode": "9114.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "For watches",
      "units": [
        "kg"
      ],
      "generalRate": "8.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P, PA,PE,R,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9114.90.5000",
      "rawHtsCode": "9114.90.50.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9201",
      "rawHtsCode": "9201",
      "superior": null,
      "indent": "0",
      "description": "Pianos, including player pianos; harpsichords and other keyboard stringed instruments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9201.10.00",
      "rawHtsCode": "9201.10.00",
      "superior": null,
      "indent": "1",
      "description": "Upright pianos",
      "units": [],
      "generalRate": "4.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9201.10.0005",
      "rawHtsCode": "9201.10.00.05",
      "superior": null,
      "indent": "2",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9201.10.0011",
      "rawHtsCode": "9201.10.00.11",
      "superior": null,
      "indent": "3",
      "description": "Containing a case measuring less than 111.76 cm in height",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9201.10.0021",
      "rawHtsCode": "9201.10.00.21",
      "superior": null,
      "indent": "3",
      "description": "Containing a case measuring 111.76 cm or more but less than 121.92 cm in height",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9201.10.0031",
      "rawHtsCode": "9201.10.00.31",
      "superior": null,
      "indent": "3",
      "description": "Containing a case measuring 121.92 cm or more but less than 129.54 cm in height",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9201.10.0041",
      "rawHtsCode": "9201.10.00.41",
      "superior": null,
      "indent": "3",
      "description": "Containing a case measuring 129.54 cm or more in height",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9201.20.00",
      "rawHtsCode": "9201.20.00",
      "superior": null,
      "indent": "1",
      "description": "Grand pianos",
      "units": [],
      "generalRate": "4.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9201.20.0005",
      "rawHtsCode": "9201.20.00.05",
      "superior": null,
      "indent": "2",
      "description": "Used",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9201.20.0011",
      "rawHtsCode": "9201.20.00.11",
      "superior": null,
      "indent": "3",
      "description": "Containing a case measuring less than 152.40 cm in length",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9201.20.0021",
      "rawHtsCode": "9201.20.00.21",
      "superior": null,
      "indent": "3",
      "description": "Containing a case measuring 152.40 cm or more but less than 167.64 cm in length",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9201.20.0031",
      "rawHtsCode": "9201.20.00.31",
      "superior": null,
      "indent": "3",
      "description": "Containing a case measuring 167.64 cm or more but less than 180.34 cm in length",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9201.20.0041",
      "rawHtsCode": "9201.20.00.41",
      "superior": null,
      "indent": "3",
      "description": "Containing a case measuring 180.34 cm or more but less than 195.58 cm in length",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9201.20.0051",
      "rawHtsCode": "9201.20.00.51",
      "superior": null,
      "indent": "3",
      "description": "Containing a case measuring 195.58 cm or more in length",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9201.90.0000",
      "rawHtsCode": "9201.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9202",
      "rawHtsCode": "9202",
      "superior": null,
      "indent": "0",
      "description": "Other string musical instruments (for example, guitars, violins, harps):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9202.10.0000",
      "rawHtsCode": "9202.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Played with a bow",
      "units": [
        "No."
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "37.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9202.90",
      "rawHtsCode": "9202.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9202.90.2000",
      "rawHtsCode": "9202.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $100 each, excluding the value of the case",
      "units": [
        "No."
      ],
      "generalRate": "4.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9202.90.4000",
      "rawHtsCode": "9202.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "8.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9202.90.6000",
      "rawHtsCode": "9202.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9205",
      "rawHtsCode": "9205",
      "superior": null,
      "indent": "0",
      "description": "Wind musical instruments (for example, keyboard pipe organs, accordions, clarinets, trumpets, bagpipes), other than fairground organs and mechanical street organs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9205.10.00",
      "rawHtsCode": "9205.10.00",
      "superior": null,
      "indent": "1",
      "description": "Brass-wind instruments",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9205.10.0040",
      "rawHtsCode": "9205.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Valued not over $10 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9205.10.0080",
      "rawHtsCode": "9205.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Valued over $10 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9205.90",
      "rawHtsCode": "9205.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9205.90.1200",
      "rawHtsCode": "9205.90.12.00",
      "superior": null,
      "indent": "3",
      "description": "Keyboard pipe organs",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9205.90.1400",
      "rawHtsCode": "9205.90.14.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9205.90.1500",
      "rawHtsCode": "9205.90.15.00",
      "superior": null,
      "indent": "4",
      "description": "Piano accordions",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9205.90.1800",
      "rawHtsCode": "9205.90.18.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9205.90.1900",
      "rawHtsCode": "9205.90.19.00",
      "superior": null,
      "indent": "3",
      "description": "Mouth organs",
      "units": [
        "doz."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9205.90.2000",
      "rawHtsCode": "9205.90.20.00",
      "superior": null,
      "indent": "3",
      "description": "Bagpipes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9205.90.40",
      "rawHtsCode": "9205.90.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9205.90.4020",
      "rawHtsCode": "9205.90.40.20",
      "superior": null,
      "indent": "4",
      "description": "Clarinets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9205.90.4040",
      "rawHtsCode": "9205.90.40.40",
      "superior": null,
      "indent": "4",
      "description": "Saxophones",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9205.90.4060",
      "rawHtsCode": "9205.90.40.60",
      "superior": null,
      "indent": "4",
      "description": "Flutes and piccolos (except bamboo)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9205.90.4080",
      "rawHtsCode": "9205.90.40.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9205.90.6000",
      "rawHtsCode": "9205.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9206.00",
      "rawHtsCode": "9206.00",
      "superior": null,
      "indent": "0",
      "description": "Percussion musical instruments (for example, drums, xylophones, cymbals, castanets, maracas):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9206.00.2000",
      "rawHtsCode": "9206.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Drums",
      "units": [
        "No."
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9206.00.4000",
      "rawHtsCode": "9206.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Cymbals",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9206.00.6000",
      "rawHtsCode": "9206.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Sets of tuned bells known as chimes, peals or carillons",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9206.00.8000",
      "rawHtsCode": "9206.00.80.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9207",
      "rawHtsCode": "9207",
      "superior": null,
      "indent": "0",
      "description": "Musical instruments, the sound of which is produced, or must be amplified, electrically (for example, organs, guitars, accordions):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9207.10.00",
      "rawHtsCode": "9207.10.00",
      "superior": null,
      "indent": "1",
      "description": "Keyboard instruments, other than accordions",
      "units": [],
      "generalRate": "5.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.7% (JP)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9207.10.0005",
      "rawHtsCode": "9207.10.00.05",
      "superior": null,
      "indent": "3",
      "description": "Valued under $100 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9207.10.0010",
      "rawHtsCode": "9207.10.00.10",
      "superior": null,
      "indent": "3",
      "description": "Valued $100 or over each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9207.10.0045",
      "rawHtsCode": "9207.10.00.45",
      "superior": null,
      "indent": "4",
      "description": "Valued under $200 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9207.10.0055",
      "rawHtsCode": "9207.10.00.55",
      "superior": null,
      "indent": "4",
      "description": "Valued $200 or over each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9207.10.0060",
      "rawHtsCode": "9207.10.00.60",
      "superior": null,
      "indent": "4",
      "description": "Hand-held",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9207.10.0065",
      "rawHtsCode": "9207.10.00.65",
      "superior": null,
      "indent": "5",
      "description": "Valued under $100 each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9207.10.0075",
      "rawHtsCode": "9207.10.00.75",
      "superior": null,
      "indent": "5",
      "description": "Valued $100 or over each",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9207.90.00",
      "rawHtsCode": "9207.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9207.90.0040",
      "rawHtsCode": "9207.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Fretted stringed instruments",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9207.90.0080",
      "rawHtsCode": "9207.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9208",
      "rawHtsCode": "9208",
      "superior": null,
      "indent": "0",
      "description": "Music boxes, fairground organs, mechanical street organs, mechanical singing birds, musical saws and other musical instruments not falling within any other heading of this chapter; decoy calls of all kinds; whistles, call horns and other mouth-blown sound signaling instruments:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9208.10.0000",
      "rawHtsCode": "9208.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Music boxes",
      "units": [
        "No."
      ],
      "generalRate": "3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9208.90.00",
      "rawHtsCode": "9208.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9208.90.0040",
      "rawHtsCode": "9208.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Musical instruments",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9208.90.0080",
      "rawHtsCode": "9208.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9209",
      "rawHtsCode": "9209",
      "superior": null,
      "indent": "0",
      "description": "Parts (for example, mechanisms for music boxes) and accessories (for example, cards, discs and rolls for mechanical instruments) of musical instruments; metronomes, tuning forks and pitch pipes of all kinds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9209.30.0000",
      "rawHtsCode": "9209.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Musical instrument strings",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9209.91",
      "rawHtsCode": "9209.91",
      "superior": null,
      "indent": "2",
      "description": "Parts and accessories for pianos:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9209.91.4000",
      "rawHtsCode": "9209.91.40.00",
      "superior": null,
      "indent": "3",
      "description": "Tuning pins",
      "units": [
        "thousands"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "$1/1,000 pins + 35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9209.91.8000",
      "rawHtsCode": "9209.91.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9209.92",
      "rawHtsCode": "9209.92",
      "superior": null,
      "indent": "2",
      "description": "Parts and accessories for the musical instruments of heading 9202:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9209.92.2000",
      "rawHtsCode": "9209.92.20.00",
      "superior": null,
      "indent": "3",
      "description": "Mutes, collapsible musical instrument stands and music holders for attachment to musical instruments",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9209.92.4000",
      "rawHtsCode": "9209.92.40.00",
      "superior": null,
      "indent": "3",
      "description": "Tuning pins",
      "units": [
        "thousands"
      ],
      "generalRate": "10¢/1,000 pins + 3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1/1,000 pins + 35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9209.92.6000",
      "rawHtsCode": "9209.92.60.00",
      "superior": null,
      "indent": "3",
      "description": "Bows, parts of bows, bow hair, chin rests and other parts and accessories for string instruments played with a bow",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9209.92.8000",
      "rawHtsCode": "9209.92.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9209.94",
      "rawHtsCode": "9209.94",
      "superior": null,
      "indent": "2",
      "description": "Parts and accessories for the musical instruments of heading 9207:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9209.94.4000",
      "rawHtsCode": "9209.94.40.00",
      "superior": null,
      "indent": "3",
      "description": "Collapsible musical instrument stands",
      "units": [
        "No."
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9209.94.8000",
      "rawHtsCode": "9209.94.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9209.99",
      "rawHtsCode": "9209.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9209.99.0500",
      "rawHtsCode": "9209.99.05.00",
      "superior": null,
      "indent": "3",
      "description": "Metronomes, tuning forks and pitch pipes",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9209.99.1000",
      "rawHtsCode": "9209.99.10.00",
      "superior": null,
      "indent": "3",
      "description": "Mutes for musical instruments; pedals, dampers and spurs for drums; pedals and holders for cymbals; lyres and other music holders for attachment to musical instruments; and collapsible stands for holding music or for holding musical instruments",
      "units": [
        "No."
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9209.99.1600",
      "rawHtsCode": "9209.99.16.00",
      "superior": null,
      "indent": "4",
      "description": "For pipe organs of subheading 9205.90.12",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9209.99.1800",
      "rawHtsCode": "9209.99.18.00",
      "superior": null,
      "indent": "4",
      "description": "For instruments of subheading 9205.90.14",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9209.99.2000",
      "rawHtsCode": "9209.99.20.00",
      "superior": null,
      "indent": "4",
      "description": "For bagpipes",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9209.99.40",
      "rawHtsCode": "9209.99.40",
      "superior": null,
      "indent": "4",
      "description": "For other woodwind and brass wind musical instruments",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9209.99.4040",
      "rawHtsCode": "9209.99.40.40",
      "superior": null,
      "indent": "5",
      "description": "For woodwind musical instruments",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9209.99.4080",
      "rawHtsCode": "9209.99.40.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9209.99.6100",
      "rawHtsCode": "9209.99.61.00",
      "superior": null,
      "indent": "4",
      "description": "For music boxes",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9209.99.8000",
      "rawHtsCode": "9209.99.80.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9301",
      "rawHtsCode": "9301",
      "superior": null,
      "indent": "0",
      "description": "Military weapons, other than revolvers, pistols and the arms of heading 9307:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9301.10.00",
      "rawHtsCode": "9301.10.00",
      "superior": null,
      "indent": "1",
      "description": "Artillery weapons (for example, guns, howitzers and mortars)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9301.10.0010",
      "rawHtsCode": "9301.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Self propelled",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9301.10.0080",
      "rawHtsCode": "9301.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9301.20.0000",
      "rawHtsCode": "9301.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Rocket launchers; flame-throwers; grenade launchers; torpedo tubes and similar projectors",
      "units": [
        "No"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9301.90",
      "rawHtsCode": "9301.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9301.90.30",
      "rawHtsCode": "9301.90.30",
      "superior": null,
      "indent": "2",
      "description": "Rifles",
      "units": [],
      "generalRate": "4.7% on the value of the rifle + 20% on the value of the telescopic sight, if any",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9301.90.3010",
      "rawHtsCode": "9301.90.30.10",
      "superior": null,
      "indent": "3",
      "description": "Telescopic sights imported with rifles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9301.90.3020",
      "rawHtsCode": "9301.90.30.20",
      "superior": null,
      "indent": "3",
      "description": "Rifles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9301.90.6000",
      "rawHtsCode": "9301.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Shotguns",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9301.90.90",
      "rawHtsCode": "9301.90.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9301.90.9030",
      "rawHtsCode": "9301.90.90.30",
      "superior": null,
      "indent": "3",
      "description": "Machine guns",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9301.90.9090",
      "rawHtsCode": "9301.90.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9302.00.00",
      "rawHtsCode": "9302.00.00",
      "superior": null,
      "indent": "0",
      "description": "Revolvers and pistols, other than those of heading 9303 or 9304",
      "units": [],
      "generalRate": "14¢ each + 3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "$3.50 each + 55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9302.00.0020",
      "rawHtsCode": "9302.00.00.20",
      "superior": null,
      "indent": "1",
      "description": "Revolvers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9302.00.0040",
      "rawHtsCode": "9302.00.00.40",
      "superior": null,
      "indent": "1",
      "description": "Semiautomatic pistols",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9302.00.0090",
      "rawHtsCode": "9302.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9303",
      "rawHtsCode": "9303",
      "superior": null,
      "indent": "0",
      "description": "Other firearms and similar devices which operate by the firing of an explosive charge (for example, sporting shot- guns and rifles, muzzle-loading firearms, Very pistols and other devices designed to project only signal flares, pistols and revolvers for firing blank ammunition, captive-bolt humane killers, line-throwing guns):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9303.10.0000",
      "rawHtsCode": "9303.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Muzzle-loading firearms",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9303.20.00",
      "rawHtsCode": "9303.20.00",
      "superior": null,
      "indent": "1",
      "description": "Other sporting, hunting or target-shooting shotguns, including combination shotgun-rifles",
      "units": [],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9303.20.0020",
      "rawHtsCode": "9303.20.00.20",
      "superior": null,
      "indent": "3",
      "description": "Autoloading",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9303.20.0030",
      "rawHtsCode": "9303.20.00.30",
      "superior": null,
      "indent": "3",
      "description": "Pump action",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9303.20.0040",
      "rawHtsCode": "9303.20.00.40",
      "superior": null,
      "indent": "3",
      "description": "Over and under",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9303.20.0065",
      "rawHtsCode": "9303.20.00.65",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9303.20.0080",
      "rawHtsCode": "9303.20.00.80",
      "superior": null,
      "indent": "2",
      "description": "Combination shotgun-rifles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9303.30",
      "rawHtsCode": "9303.30",
      "superior": null,
      "indent": "1",
      "description": "Other sporting, hunting or target-shooting rifles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9303.30.40",
      "rawHtsCode": "9303.30.40",
      "superior": null,
      "indent": "2",
      "description": "Valued over $25 but not over $50 each",
      "units": [],
      "generalRate": "3.8% on the value of the rifle + 10% on the value of the telescopic sight, if any",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9303.30.4010",
      "rawHtsCode": "9303.30.40.10",
      "superior": null,
      "indent": "3",
      "description": "Telescopic sights imported with rifles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9303.30.4020",
      "rawHtsCode": "9303.30.40.20",
      "superior": null,
      "indent": "4",
      "description": "Centerfire",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9303.30.4030",
      "rawHtsCode": "9303.30.40.30",
      "superior": null,
      "indent": "4",
      "description": "Rimfire",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9303.30.80",
      "rawHtsCode": "9303.30.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "3.1% on the value of the rifle + 13% on the value of the telescopic sight, if any",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9303.30.8005",
      "rawHtsCode": "9303.30.80.05",
      "superior": null,
      "indent": "3",
      "description": "Telescopic sights imported with rifles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9303.30.8010",
      "rawHtsCode": "9303.30.80.10",
      "superior": null,
      "indent": "5",
      "description": "Autoloading",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9303.30.8012",
      "rawHtsCode": "9303.30.80.12",
      "superior": null,
      "indent": "6",
      "description": "Single shot",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9303.30.8017",
      "rawHtsCode": "9303.30.80.17",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9303.30.8025",
      "rawHtsCode": "9303.30.80.25",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9303.30.8030",
      "rawHtsCode": "9303.30.80.30",
      "superior": null,
      "indent": "4",
      "description": "Rimfire",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this chapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9303.90",
      "rawHtsCode": "9303.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9303.90.4000",
      "rawHtsCode": "9303.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Pistols and revolvers designed to fire only blank cartridges or blank ammunition",
      "units": [
        "No."
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "105%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9303.90.8000",
      "rawHtsCode": "9303.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9304.00",
      "rawHtsCode": "9304.00",
      "superior": null,
      "indent": "0",
      "description": "Other arms (for example, spring, air or gas guns and pistols, truncheons), excluding those of heading 9307:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9304.00.2000",
      "rawHtsCode": "9304.00.20.00",
      "superior": null,
      "indent": "2",
      "description": "Rifles",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9304.00.4000",
      "rawHtsCode": "9304.00.40.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "9304.00.6000",
      "rawHtsCode": "9304.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9305",
      "rawHtsCode": "9305",
      "superior": null,
      "indent": "0",
      "description": "Parts and accessories of articles of headings 9301 to 9304:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.10",
      "rawHtsCode": "9305.10",
      "superior": null,
      "indent": "1",
      "description": "Of revolvers or pistols:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.10.20",
      "rawHtsCode": "9305.10.20",
      "superior": null,
      "indent": "2",
      "description": "Of heading 9302",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "105%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9305.10.2010",
      "rawHtsCode": "9305.10.20.10",
      "superior": null,
      "indent": "3",
      "description": "Frames and receivers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.10.2080",
      "rawHtsCode": "9305.10.20.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.10.4000",
      "rawHtsCode": "9305.10.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of revolvers or pistols designed to fire only blank cartridges or blank ammunition",
      "units": [
        "kg"
      ],
      "generalRate": "4.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "105%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9305.10.6000",
      "rawHtsCode": "9305.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Of muzzle-loading revolvers and pistols",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9305.10.8000",
      "rawHtsCode": "9305.10.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9305.20",
      "rawHtsCode": "9305.20",
      "superior": null,
      "indent": "1",
      "description": "Of shotguns or rifles of heading 9303:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.20.0500",
      "rawHtsCode": "9305.20.05.00",
      "superior": null,
      "indent": "2",
      "description": "Rifle stocks",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "69.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9305.20.80",
      "rawHtsCode": "9305.20.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "73.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "9305.20.8004",
      "rawHtsCode": "9305.20.80.04",
      "superior": null,
      "indent": "4",
      "description": "Of muzzle-loading shotguns",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.20.8008",
      "rawHtsCode": "9305.20.80.08",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.20.8020",
      "rawHtsCode": "9305.20.80.20",
      "superior": null,
      "indent": "3",
      "description": "Other parts of muzzle-loading shotguns or rifles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.20.8031",
      "rawHtsCode": "9305.20.80.31",
      "superior": null,
      "indent": "5",
      "description": "Stocks",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.20.8033",
      "rawHtsCode": "9305.20.80.33",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.20.8060",
      "rawHtsCode": "9305.20.80.60",
      "superior": null,
      "indent": "4",
      "description": "Of rifles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.91",
      "rawHtsCode": "9305.91",
      "superior": null,
      "indent": "2",
      "description": "Of military weapons of heading 9301:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.91.1000",
      "rawHtsCode": "9305.91.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of rifles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9305.91.2000",
      "rawHtsCode": "9305.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of shotguns",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9305.91.30",
      "rawHtsCode": "9305.91.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9305.91.3010",
      "rawHtsCode": "9305.91.30.10",
      "superior": null,
      "indent": "4",
      "description": "Of artillery weapons of 9301.10",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.91.3030",
      "rawHtsCode": "9305.91.30.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.99",
      "rawHtsCode": "9305.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.99.4000",
      "rawHtsCode": "9305.99.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of articles of heading 9303 other than shotguns or rifles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "27.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.99.50",
      "rawHtsCode": "9305.99.50",
      "superior": null,
      "indent": "3",
      "description": "Of articles of subheading 9304.00.20 or 9304.00.40",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9305.99.5010",
      "rawHtsCode": "9305.99.50.10",
      "superior": null,
      "indent": "4",
      "description": "Parts and accessories of paintball markers",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.99.5050",
      "rawHtsCode": "9305.99.50.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9305.99.6000",
      "rawHtsCode": "9305.99.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9306",
      "rawHtsCode": "9306",
      "superior": null,
      "indent": "0",
      "description": "Bombs, grenades, torpedoes, mines, missiles and similar munitions of war and parts thereof; cartridges and other ammunition and projectiles and parts thereof, including shot and cartridgewads:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.21.0000",
      "rawHtsCode": "9306.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Cartridges",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "9306.29.0000",
      "rawHtsCode": "9306.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9306.30",
      "rawHtsCode": "9306.30",
      "superior": null,
      "indent": "1",
      "description": "Other cartridges and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.30.41",
      "rawHtsCode": "9306.30.41",
      "superior": null,
      "indent": "2",
      "description": "Cartridges and empty cartridge shells",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08.   "
      ],
      "flags": []
    },
    {
      "htsCode": "9306.30.4110",
      "rawHtsCode": "9306.30.41.10",
      "superior": null,
      "indent": "5",
      "description": ".22 caliber",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.30.4120",
      "rawHtsCode": "9306.30.41.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.30.4130",
      "rawHtsCode": "9306.30.41.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.30.4138",
      "rawHtsCode": "9306.30.41.38",
      "superior": null,
      "indent": "3",
      "description": "Cartridges for riveting or similar tools or for captive-bolt humane killers and parts thereof",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.30.4140",
      "rawHtsCode": "9306.30.41.40",
      "superior": null,
      "indent": "4",
      "description": "For rifles or pistols",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.30.4150",
      "rawHtsCode": "9306.30.41.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.30.4160",
      "rawHtsCode": "9306.30.41.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.30.8000",
      "rawHtsCode": "9306.30.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9306.90.00",
      "rawHtsCode": "9306.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9306.90.0020",
      "rawHtsCode": "9306.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Guided missiles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.90.0041",
      "rawHtsCode": "9306.90.00.41",
      "superior": null,
      "indent": "3",
      "description": "Paintballs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.90.0050",
      "rawHtsCode": "9306.90.00.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.90.0060",
      "rawHtsCode": "9306.90.00.60",
      "superior": null,
      "indent": "2",
      "description": "Parts for guided missiles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9306.90.0080",
      "rawHtsCode": "9306.90.00.80",
      "superior": null,
      "indent": "2",
      "description": "Parts for bombs, grenades, torpedoes, mines and similar munitions of war; parts of other ammunition and projectiles",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9307.00.0000",
      "rawHtsCode": "9307.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Swords, cutlasses, bayonets, lances and similar arms and parts thereof and scabbards and sheaths therefor",
      "units": [
        "kg"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9401",
      "rawHtsCode": "9401",
      "superior": null,
      "indent": "0",
      "description": "Seats (other than those of heading 9402), whether or not convertible into beds, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.10",
      "rawHtsCode": "9401.10",
      "superior": null,
      "indent": "1",
      "description": "Seats of a kind used for aircraft:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.10.4000",
      "rawHtsCode": "9401.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Leather upholstered",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.10.8000",
      "rawHtsCode": "9401.10.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.20.0000",
      "rawHtsCode": "9401.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Seats of a kind used for motor vehicles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.31.0000",
      "rawHtsCode": "9401.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of wood",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.39.00",
      "rawHtsCode": "9401.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.39.0010",
      "rawHtsCode": "9401.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.39.0030",
      "rawHtsCode": "9401.39.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.41.0000",
      "rawHtsCode": "9401.41.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of wood",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.49.0000",
      "rawHtsCode": "9401.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.52.0000",
      "rawHtsCode": "9401.52.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of bamboo ",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9401.53.0000",
      "rawHtsCode": "9401.53.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of rattan",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9401.59.0000",
      "rawHtsCode": "9401.59.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9401.61",
      "rawHtsCode": "9401.61",
      "superior": null,
      "indent": "2",
      "description": "Upholstered:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.61.20",
      "rawHtsCode": "9401.61.20",
      "superior": null,
      "indent": "4",
      "description": "Of teak",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9401.61.2011",
      "rawHtsCode": "9401.61.20.11",
      "superior": null,
      "indent": "6",
      "description": "Of plantation-harvested teak ",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.61.2015",
      "rawHtsCode": "9401.61.20.15",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.61.2031",
      "rawHtsCode": "9401.61.20.31",
      "superior": null,
      "indent": "6",
      "description": "Of plantation-harvested teak ",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.61.2035",
      "rawHtsCode": "9401.61.20.35",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.61.40",
      "rawHtsCode": "9401.61.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.04 and its associated definitional note (U.S. note 20(g) in subchapter III of chapter 99). "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.61.4001",
      "rawHtsCode": "9401.61.40.01",
      "superior": null,
      "indent": "5",
      "description": "Chairs for children, including highchairs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.61.4011",
      "rawHtsCode": "9401.61.40.11",
      "superior": null,
      "indent": "5",
      "description": "Other household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.61.4031",
      "rawHtsCode": "9401.61.40.31",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.61.60",
      "rawHtsCode": "9401.61.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9401.61.6001",
      "rawHtsCode": "9401.61.60.01",
      "superior": null,
      "indent": "4",
      "description": "Stationary activity centers for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.61.6005",
      "rawHtsCode": "9401.61.60.05",
      "superior": null,
      "indent": "4",
      "description": "Other seats for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.61.6011",
      "rawHtsCode": "9401.61.60.11",
      "superior": null,
      "indent": "4",
      "description": "Other household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.61.6031",
      "rawHtsCode": "9401.61.60.31",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69",
      "rawHtsCode": "9401.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.20",
      "rawHtsCode": "9401.69.20",
      "superior": null,
      "indent": "3",
      "description": "Bent-wood seats",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "42.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9401.69.2010",
      "rawHtsCode": "9401.69.20.10",
      "superior": null,
      "indent": "4",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.2030",
      "rawHtsCode": "9401.69.20.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.40",
      "rawHtsCode": "9401.69.40",
      "superior": null,
      "indent": "5",
      "description": "Of teak",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9401.69.4011",
      "rawHtsCode": "9401.69.40.11",
      "superior": null,
      "indent": "7",
      "description": "Of plantation-harvested teak",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.4015",
      "rawHtsCode": "9401.69.40.15",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.4031",
      "rawHtsCode": "9401.69.40.31",
      "superior": null,
      "indent": "7",
      "description": "Of plantation-harvested teak",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.4035",
      "rawHtsCode": "9401.69.40.35",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.60",
      "rawHtsCode": "9401.69.60",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.04 and its associated definitional note (U.S. note 20(g)  in subchapter III of chapter 99)  and 9903.88.15 and its associated definitional note (U.S. note 20(s)(ii) in subchapter III of chapter 99). "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.69.6001",
      "rawHtsCode": "9401.69.60.01",
      "superior": null,
      "indent": "6",
      "description": "Chairs for children including highchairs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.6011",
      "rawHtsCode": "9401.69.60.11",
      "superior": null,
      "indent": "6",
      "description": "Other household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.6031",
      "rawHtsCode": "9401.69.60.31",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.80",
      "rawHtsCode": "9401.69.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.69.8001",
      "rawHtsCode": "9401.69.80.01",
      "superior": null,
      "indent": "5",
      "description": "Stationary activity centers for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.8005",
      "rawHtsCode": "9401.69.80.05",
      "superior": null,
      "indent": "5",
      "description": "Other seats for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.8011",
      "rawHtsCode": "9401.69.80.11",
      "superior": null,
      "indent": "5",
      "description": "Other household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.8066",
      "rawHtsCode": "9401.69.80.66",
      "superior": null,
      "indent": "7",
      "description": "Of plantation-harvested teak",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.8068",
      "rawHtsCode": "9401.69.80.68",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.69.8090",
      "rawHtsCode": "9401.69.80.90",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.71.00",
      "rawHtsCode": "9401.71.00",
      "superior": null,
      "indent": "2",
      "description": "Upholstered",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.04 and its associated definitional note (U.S. note 20(g) in subchapter III of chapter 99) and 9903.88.15 and its associated definitional note (U.S. note 20(s)(ii) in subchapter III of chapter 99). "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.71.0001",
      "rawHtsCode": "9401.71.00.01",
      "superior": null,
      "indent": "3",
      "description": "Highchairs and booster seats",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.71.0005",
      "rawHtsCode": "9401.71.00.05",
      "superior": null,
      "indent": "3",
      "description": "Infant walkers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.71.0006",
      "rawHtsCode": "9401.71.00.06",
      "superior": null,
      "indent": "3",
      "description": "Bouncers with seats",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.71.0007",
      "rawHtsCode": "9401.71.00.07",
      "superior": null,
      "indent": "3",
      "description": "Swings for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.71.0008",
      "rawHtsCode": "9401.71.00.08",
      "superior": null,
      "indent": "3",
      "description": "Stationary activity centers for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.71.0011",
      "rawHtsCode": "9401.71.00.11",
      "superior": null,
      "indent": "3",
      "description": "Other household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.71.0031",
      "rawHtsCode": "9401.71.00.31",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.79.00",
      "rawHtsCode": "9401.79.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.04 and its associated definitional note (U.S. note 20(g) in subchapter III of chapter 99). "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.79.0001",
      "rawHtsCode": "9401.79.00.01",
      "superior": null,
      "indent": "3",
      "description": "Highchairs and booster seats",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.79.0002",
      "rawHtsCode": "9401.79.00.02",
      "superior": null,
      "indent": "3",
      "description": "Infant walkers",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.79.0003",
      "rawHtsCode": "9401.79.00.03",
      "superior": null,
      "indent": "3",
      "description": "Bouncers with seats",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.79.0004",
      "rawHtsCode": "9401.79.00.04",
      "superior": null,
      "indent": "3",
      "description": "Swings for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.79.0006",
      "rawHtsCode": "9401.79.00.06",
      "superior": null,
      "indent": "3",
      "description": "Stationary activity centers for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.79.0011",
      "rawHtsCode": "9401.79.00.11",
      "superior": null,
      "indent": "6",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.79.0015",
      "rawHtsCode": "9401.79.00.15",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.79.0025",
      "rawHtsCode": "9401.79.00.25",
      "superior": null,
      "indent": "6",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.79.0035",
      "rawHtsCode": "9401.79.00.35",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.79.0046",
      "rawHtsCode": "9401.79.00.46",
      "superior": null,
      "indent": "5",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.79.0050",
      "rawHtsCode": "9401.79.00.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80",
      "rawHtsCode": "9401.80",
      "superior": null,
      "indent": "1",
      "description": "Other seats:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.20",
      "rawHtsCode": "9401.80.20",
      "superior": null,
      "indent": "3",
      "description": "Of reinforced or laminated plastics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.04 and its associated definitional note (U.S. note 20(g) in subchapter III of chapter 99). "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.80.2001",
      "rawHtsCode": "9401.80.20.01",
      "superior": null,
      "indent": "4",
      "description": "Childrenʼs highchairs and booster seats except for motor vehicle; bath seats, infant walkers, bouncers with seats, swings for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.2005",
      "rawHtsCode": "9401.80.20.05",
      "superior": null,
      "indent": "4",
      "description": "Stationary activity centers for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.2011",
      "rawHtsCode": "9401.80.20.11",
      "superior": null,
      "indent": "4",
      "description": "Other household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.2031",
      "rawHtsCode": "9401.80.20.31",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.40",
      "rawHtsCode": "9401.80.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.04 and its associated definitional note (U.S. note 20(g) in subchapter III of chapter 99). "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.80.4001",
      "rawHtsCode": "9401.80.40.01",
      "superior": null,
      "indent": "4",
      "description": "Childrenʼs highchairs and booster seats except for motor vehicle; bath seats, infant walkers, bouncers with seats, swings for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.4004",
      "rawHtsCode": "9401.80.40.04",
      "superior": null,
      "indent": "4",
      "description": "Stationary activity centers for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.4006",
      "rawHtsCode": "9401.80.40.06",
      "superior": null,
      "indent": "7",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.4015",
      "rawHtsCode": "9401.80.40.15",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.4026",
      "rawHtsCode": "9401.80.40.26",
      "superior": null,
      "indent": "7",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.4035",
      "rawHtsCode": "9401.80.40.35",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.4046",
      "rawHtsCode": "9401.80.40.46",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.60",
      "rawHtsCode": "9401.80.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.04 and its associated definitional note (U.S. note 20(g) in subchapter III of chapter 99). "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.80.6021",
      "rawHtsCode": "9401.80.60.21",
      "superior": null,
      "indent": "4",
      "description": "With detachable hard-shell seat",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.6023",
      "rawHtsCode": "9401.80.60.23",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.6024",
      "rawHtsCode": "9401.80.60.24",
      "superior": null,
      "indent": "3",
      "description": "Stationary activity centers for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.6025",
      "rawHtsCode": "9401.80.60.25",
      "superior": null,
      "indent": "3",
      "description": "Other seats for children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.6028",
      "rawHtsCode": "9401.80.60.28",
      "superior": null,
      "indent": "3",
      "description": "Other household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.80.6030",
      "rawHtsCode": "9401.80.60.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.91",
      "rawHtsCode": "9401.91",
      "superior": null,
      "indent": "2",
      "description": "Of wood:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.91.1500",
      "rawHtsCode": "9401.91.15.00",
      "superior": null,
      "indent": "3",
      "description": "Of seats of a kind used for motor vehicles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.88.69. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.91.2000",
      "rawHtsCode": "9401.91.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of bent wood seats",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "42.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.91.90",
      "rawHtsCode": "9401.91.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.91.9010",
      "rawHtsCode": "9401.91.90.10",
      "superior": null,
      "indent": "4",
      "description": "For children’s highchairs, booster seats, and similar seats",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.91.9090",
      "rawHtsCode": "9401.91.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.99",
      "rawHtsCode": "9401.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.99.10",
      "rawHtsCode": "9401.99.10",
      "superior": null,
      "indent": "3",
      "description": "Of seats of a kind used for motor vehicles",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.99.1010",
      "rawHtsCode": "9401.99.10.10",
      "superior": null,
      "indent": "4",
      "description": "Of leather, cut to shape",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.99.1020",
      "rawHtsCode": "9401.99.10.20",
      "superior": null,
      "indent": "4",
      "description": "Of textile material, cut to shape",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.99.1085",
      "rawHtsCode": "9401.99.10.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.99.25",
      "rawHtsCode": "9401.99.25",
      "superior": null,
      "indent": "3",
      "description": "Of cane, osier, bamboo or similar materials",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.99.2540",
      "rawHtsCode": "9401.99.25.40",
      "superior": null,
      "indent": "4",
      "description": "Of rattan",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.99.2580",
      "rawHtsCode": "9401.99.25.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.99.35",
      "rawHtsCode": "9401.99.35",
      "superior": null,
      "indent": "3",
      "description": "Of rubber or plastics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.99.3510",
      "rawHtsCode": "9401.99.35.10",
      "superior": null,
      "indent": "4",
      "description": "For children’s highchairs, booster seats except for motor vehicle and similar seats",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.99.3580",
      "rawHtsCode": "9401.99.35.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.99.90",
      "rawHtsCode": "9401.99.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9401.99.9005",
      "rawHtsCode": "9401.99.90.05",
      "superior": null,
      "indent": "4",
      "description": "For children’s highchairs, booster seats and similar seats",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.99.9021",
      "rawHtsCode": "9401.99.90.21",
      "superior": null,
      "indent": "4",
      "description": "Other of textile material, cut to shape",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.99.9030",
      "rawHtsCode": "9401.99.90.30",
      "superior": null,
      "indent": "4",
      "description": "Mechanically collapsible sofa bed seat deck components, covered or uncovered as described in statistical note 2 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.99.9040",
      "rawHtsCode": "9401.99.90.40",
      "superior": null,
      "indent": "4",
      "description": "Of seats of a kind used for aircraft",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9401.99.9085",
      "rawHtsCode": "9401.99.90.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9402",
      "rawHtsCode": "9402",
      "superior": null,
      "indent": "0",
      "description": "Medical, surgical, dental or veterinary furniture (for example, operating tables, examination tables, hospital beds with mechanical fittings, dentists' chairs); barbers' chairs and similar chairs, having rotating as well as both reclining and elevating movements; parts of the foregoing articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9402.10.0000",
      "rawHtsCode": "9402.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Dentists', barbers' or similar chairs and parts thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9402.90.00",
      "rawHtsCode": "9402.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9402.90.0010",
      "rawHtsCode": "9402.90.00.10",
      "superior": null,
      "indent": "2",
      "description": "Hospital beds",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9402.90.0020",
      "rawHtsCode": "9402.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403",
      "rawHtsCode": "9403",
      "superior": null,
      "indent": "0",
      "description": "Other furniture and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.10.00",
      "rawHtsCode": "9403.10.00",
      "superior": null,
      "indent": "1",
      "description": "Metal furniture of a kind used in offices",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.           "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.10.0020",
      "rawHtsCode": "9403.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Filing cabinets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.10.0040",
      "rawHtsCode": "9403.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.00",
      "rawHtsCode": "9403.20.00",
      "superior": null,
      "indent": "1",
      "description": "Other metal furniture",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.20.0011",
      "rawHtsCode": "9403.20.00.11",
      "superior": null,
      "indent": "3",
      "description": "Floor-standing, metal-top ironing boards",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.0016",
      "rawHtsCode": "9403.20.00.16",
      "superior": null,
      "indent": "4",
      "description": "Cribs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.0017",
      "rawHtsCode": "9403.20.00.17",
      "superior": null,
      "indent": "4",
      "description": "Toddler beds, bassinets, cradles, play yards and other enclosures for confining children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.0035",
      "rawHtsCode": "9403.20.00.35",
      "superior": null,
      "indent": "4",
      "description": "Mechanically adjustable bed or mattress base, not foldable, having the characteristics of a bed or bed frame, of a width exceeding 91.44 cm, of a length exceeding 184.15 cm, and of a depth exceeding 8.89 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.0040",
      "rawHtsCode": "9403.20.00.40",
      "superior": null,
      "indent": "4",
      "description": "Mattress bases with legs, not foldable, having the characteristics of a stationary (not mechanically adjustable) bed frame, of a width exceeding 91.44 cm, of a length exceeding 184.15 cm and of a depth exceeding 8.89 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.0046",
      "rawHtsCode": "9403.20.00.46",
      "superior": null,
      "indent": "5",
      "description": "Mechanically adjustable",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.0048",
      "rawHtsCode": "9403.20.00.48",
      "superior": null,
      "indent": "5",
      "description": "Stationary (not mechanically adjustable)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.0050",
      "rawHtsCode": "9403.20.00.50",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.0075",
      "rawHtsCode": "9403.20.00.75",
      "superior": null,
      "indent": "4",
      "description": "Boltless or press-fit steel shelving units prepackaged for sale as described in statistical note 4 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.0078",
      "rawHtsCode": "9403.20.00.78",
      "superior": null,
      "indent": "4",
      "description": "Storage lockers, other than exchange lockers as described in statistical note 5 to this chapter",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.0082",
      "rawHtsCode": "9403.20.00.82",
      "superior": null,
      "indent": "4",
      "description": "Steel racks, other than those described in statistical reporting number 9403.20.0075",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.0086",
      "rawHtsCode": "9403.20.00.86",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.20.0090",
      "rawHtsCode": "9403.20.00.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.30",
      "rawHtsCode": "9403.30",
      "superior": null,
      "indent": "1",
      "description": "Wooden furniture of a kind used in offices:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.30.4000",
      "rawHtsCode": "9403.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Bent-wood furniture",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "42.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.30.80",
      "rawHtsCode": "9403.30.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        ""
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.30.8001",
      "rawHtsCode": "9403.30.80.01",
      "superior": null,
      "indent": "3",
      "description": "Of Padauk (Padouk) or Narra (<u>Pterocarpus </u>spp.)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.30.8005",
      "rawHtsCode": "9403.30.80.05",
      "superior": null,
      "indent": "3",
      "description": "Of Rosewood, Palissander, Cocobolo, Bois de Rose, Kingwood, Tulipwood or Blackwood (<u>Dalbergia </u>spp.)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.30.8021",
      "rawHtsCode": "9403.30.80.21",
      "superior": null,
      "indent": "3",
      "description": "Of teak (<u>Tectona </u>spp.)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.30.8031",
      "rawHtsCode": "9403.30.80.31",
      "superior": null,
      "indent": "3",
      "description": "Of Wenge (<u>Millettia </u>spp.)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.30.8090",
      "rawHtsCode": "9403.30.80.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.40",
      "rawHtsCode": "9403.40",
      "superior": null,
      "indent": "1",
      "description": "Wooden furniture of a kind used in the kitchen:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.40.4000",
      "rawHtsCode": "9403.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "Bent-wood furniture",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "42.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.40.6000",
      "rawHtsCode": "9403.40.60.00",
      "superior": null,
      "indent": "3",
      "description": "Designed for motor vehicle use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.40.90",
      "rawHtsCode": "9403.40.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9403.40.9040",
      "rawHtsCode": "9403.40.90.40",
      "superior": null,
      "indent": "4",
      "description": "Dining tables",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.40.9060",
      "rawHtsCode": "9403.40.90.60",
      "superior": null,
      "indent": "4",
      "description": "Cabinets designed for permanent installation",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.40.9080",
      "rawHtsCode": "9403.40.90.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.50",
      "rawHtsCode": "9403.50",
      "superior": null,
      "indent": "1",
      "description": "Wooden furniture of a kind used in the bedroom:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.50.4000",
      "rawHtsCode": "9403.50.40.00",
      "superior": null,
      "indent": "2",
      "description": "Bent-wood furniture",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "42.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.50.6000",
      "rawHtsCode": "9403.50.60.00",
      "superior": null,
      "indent": "3",
      "description": "Designed for motor vehicle use",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.50.90",
      "rawHtsCode": "9403.50.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9403.50.9041",
      "rawHtsCode": "9403.50.90.41",
      "superior": null,
      "indent": "5",
      "description": "Cribs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.50.9042",
      "rawHtsCode": "9403.50.90.42",
      "superior": null,
      "indent": "5",
      "description": "Toddler beds, bassinets, and cradles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.50.9045",
      "rawHtsCode": "9403.50.90.45",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.50.9080",
      "rawHtsCode": "9403.50.90.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.60",
      "rawHtsCode": "9403.60",
      "superior": null,
      "indent": "1",
      "description": "Other wooden furniture:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.60.4000",
      "rawHtsCode": "9403.60.40.00",
      "superior": null,
      "indent": "2",
      "description": "Bent-wood furniture",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "42.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.60.80",
      "rawHtsCode": "9403.60.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9403.60.8010",
      "rawHtsCode": "9403.60.80.10",
      "superior": null,
      "indent": "3",
      "description": "Play yards and other enclosures for confining children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.60.8040",
      "rawHtsCode": "9403.60.80.40",
      "superior": null,
      "indent": "3",
      "description": "Dining tables",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.60.8089",
      "rawHtsCode": "9403.60.80.89",
      "superior": null,
      "indent": "4",
      "description": "Of teak (<u>Tectona</u> spp.)",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.60.8093",
      "rawHtsCode": "9403.60.80.93",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70",
      "rawHtsCode": "9403.70",
      "superior": null,
      "indent": "1",
      "description": "Furniture of plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70.40",
      "rawHtsCode": "9403.70.40",
      "superior": null,
      "indent": "2",
      "description": "Of reinforced or laminated plastics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.04 and its associated definitional note (U.S. note 20(g) in subchapter III of chapter 99). "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.70.4001",
      "rawHtsCode": "9403.70.40.01",
      "superior": null,
      "indent": "3",
      "description": "Cribs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70.4002",
      "rawHtsCode": "9403.70.40.02",
      "superior": null,
      "indent": "3",
      "description": "Toddler beds, bassinets and cradles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70.4003",
      "rawHtsCode": "9403.70.40.03",
      "superior": null,
      "indent": "3",
      "description": "Play yards and other enclosures for confining children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70.4015",
      "rawHtsCode": "9403.70.40.15",
      "superior": null,
      "indent": "3",
      "description": "Other household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70.4020",
      "rawHtsCode": "9403.70.40.20",
      "superior": null,
      "indent": "3",
      "description": "Office",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70.4031",
      "rawHtsCode": "9403.70.40.31",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70.80",
      "rawHtsCode": "9403.70.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.04 and its associated definitional note (U.S. note 20(g) in subchapter III of chapter 99). ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.70.8001",
      "rawHtsCode": "9403.70.80.01",
      "superior": null,
      "indent": "3",
      "description": "Cribs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70.8002",
      "rawHtsCode": "9403.70.80.02",
      "superior": null,
      "indent": "3",
      "description": "Toddler beds, bassinets and cradles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70.8003",
      "rawHtsCode": "9403.70.80.03",
      "superior": null,
      "indent": "3",
      "description": "Play yards and other enclosures for confining children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70.8015",
      "rawHtsCode": "9403.70.80.15",
      "superior": null,
      "indent": "3",
      "description": "Other household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70.8020",
      "rawHtsCode": "9403.70.80.20",
      "superior": null,
      "indent": "3",
      "description": "Office",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.70.8031",
      "rawHtsCode": "9403.70.80.31",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.82.00",
      "rawHtsCode": "9403.82.00",
      "superior": null,
      "indent": "2",
      "description": "Of bamboo",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9403.82.0001",
      "rawHtsCode": "9403.82.00.01",
      "superior": null,
      "indent": "3",
      "description": "Cribs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.82.0002",
      "rawHtsCode": "9403.82.00.02",
      "superior": null,
      "indent": "3",
      "description": "Toddler beds, bassinets, and cradles; play yards and other enclosures for confining children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.82.0015",
      "rawHtsCode": "9403.82.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.82.0030",
      "rawHtsCode": "9403.82.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other ",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.83.00",
      "rawHtsCode": "9403.83.00",
      "superior": null,
      "indent": "2",
      "description": "Of rattan",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9403.83.0001",
      "rawHtsCode": "9403.83.00.01",
      "superior": null,
      "indent": "3",
      "description": "Cribs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.83.0002",
      "rawHtsCode": "9403.83.00.02",
      "superior": null,
      "indent": "3",
      "description": "Toddler beds, bassinets, and cradles; play yards and other enclosures for confining children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.83.0015",
      "rawHtsCode": "9403.83.00.15",
      "superior": null,
      "indent": "3",
      "description": "Other household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.83.0030",
      "rawHtsCode": "9403.83.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other ",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.89",
      "rawHtsCode": "9403.89",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.89.30",
      "rawHtsCode": "9403.89.30",
      "superior": null,
      "indent": "3",
      "description": "Of cane, osier or similar materials",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9403.89.3010",
      "rawHtsCode": "9403.89.30.10",
      "superior": null,
      "indent": "4",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.89.3020",
      "rawHtsCode": "9403.89.30.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.89.60",
      "rawHtsCode": "9403.89.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9403.89.6003",
      "rawHtsCode": "9403.89.60.03",
      "superior": null,
      "indent": "4",
      "description": "Cribs, toddler beds, bassinets, and cradles; play yards and other enclosures for confining children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.89.6015",
      "rawHtsCode": "9403.89.60.15",
      "superior": null,
      "indent": "4",
      "description": "Other household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.89.6020",
      "rawHtsCode": "9403.89.60.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.91.00",
      "rawHtsCode": "9403.91.00",
      "superior": null,
      "indent": "2",
      "description": "Of wood",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.91.0005",
      "rawHtsCode": "9403.91.00.05",
      "superior": null,
      "indent": "3",
      "description": "For toddler beds, cribs, bassinets and cradles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.91.0010",
      "rawHtsCode": "9403.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "For play yards and other enclosures for confining children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.91.0080",
      "rawHtsCode": "9403.91.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99",
      "rawHtsCode": "9403.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.10",
      "rawHtsCode": "9403.99.10",
      "superior": null,
      "indent": "3",
      "description": "Of furniture of a kind used for motor vehicles",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.           ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.99.1040",
      "rawHtsCode": "9403.99.10.40",
      "superior": null,
      "indent": "4",
      "description": "Of metal",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.1050",
      "rawHtsCode": "9403.99.10.50",
      "superior": null,
      "indent": "4",
      "description": "Of textile material, cut to shape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.1085",
      "rawHtsCode": "9403.99.10.85",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.20",
      "rawHtsCode": "9403.99.20",
      "superior": null,
      "indent": "4",
      "description": "Of cane, osier, bamboo or similar materials",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.99.2040",
      "rawHtsCode": "9403.99.20.40",
      "superior": null,
      "indent": "5",
      "description": "Of rattan",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.2080",
      "rawHtsCode": "9403.99.20.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.30",
      "rawHtsCode": "9403.99.30",
      "superior": null,
      "indent": "5",
      "description": "Of reinforced or laminated plastics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.99.3005",
      "rawHtsCode": "9403.99.30.05",
      "superior": null,
      "indent": "6",
      "description": "For toddler beds, cribs, bassinets and cradles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.3010",
      "rawHtsCode": "9403.99.30.10",
      "superior": null,
      "indent": "6",
      "description": "For play yards and other enclosures for confining children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.3080",
      "rawHtsCode": "9403.99.30.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.40",
      "rawHtsCode": "9403.99.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.99.4005",
      "rawHtsCode": "9403.99.40.05",
      "superior": null,
      "indent": "6",
      "description": "For toddler beds, cribs, bassinets and cradles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.4010",
      "rawHtsCode": "9403.99.40.10",
      "superior": null,
      "indent": "6",
      "description": "For play yards and other enclosures for confining children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.4080",
      "rawHtsCode": "9403.99.40.80",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.50",
      "rawHtsCode": "9403.99.50",
      "superior": null,
      "indent": "4",
      "description": "Of textile material, except cotton",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.99.5005",
      "rawHtsCode": "9403.99.50.05",
      "superior": null,
      "indent": "5",
      "description": "For toddler beds, cribs, bassinets and cradles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.99.5010",
      "rawHtsCode": "9403.99.50.10",
      "superior": null,
      "indent": "5",
      "description": "For play yards and other enclosures for confining children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.5080",
      "rawHtsCode": "9403.99.50.80",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.90",
      "rawHtsCode": "9403.99.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.           "
      ],
      "flags": []
    },
    {
      "htsCode": "9403.99.9010",
      "rawHtsCode": "9403.99.90.10",
      "superior": null,
      "indent": "5",
      "description": "For toddler beds, cribs, bassinets and cradles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.9015",
      "rawHtsCode": "9403.99.90.15",
      "superior": null,
      "indent": "5",
      "description": "For play yards and other enclosures for confining children",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.9020",
      "rawHtsCode": "9403.99.90.20",
      "superior": null,
      "indent": "7",
      "description": "Welded wire rack, whether or  not galvanized, plated or coated",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.9040",
      "rawHtsCode": "9403.99.90.40",
      "superior": null,
      "indent": "7",
      "description": "Parts for steel racks of statistical reporting number 9403.20.0082",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.9045",
      "rawHtsCode": "9403.99.90.45",
      "superior": null,
      "indent": "7",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.9051",
      "rawHtsCode": "9403.99.90.51",
      "superior": null,
      "indent": "6",
      "description": "Of cotton, cut to shape",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9403.99.9061",
      "rawHtsCode": "9403.99.90.61",
      "superior": null,
      "indent": "6",
      "description": "Other",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404",
      "rawHtsCode": "9404",
      "superior": null,
      "indent": "0",
      "description": "Mattress supports; articles of bedding and similar furnishing (for example, mattresses, quilts, eiderdowns, cushions, pouffes and pillows) fitted with springs or stuffed or internally fitted with any material or of cellular rubber or plastics, whether or not covered:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.10.0000",
      "rawHtsCode": "9404.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Mattress supports",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9404.21.00",
      "rawHtsCode": "9404.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of cellular rubber or plastics, whether or not covered",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9404.21.0010",
      "rawHtsCode": "9404.21.00.10",
      "superior": null,
      "indent": "3",
      "description": "For use in a crib or toddler bed",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.21.0013",
      "rawHtsCode": "9404.21.00.13",
      "superior": null,
      "indent": "3",
      "description": "Of a width exceeding 91 cm, of a length exceeding 184 cm, and a depth exceeding 8 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.21.0095",
      "rawHtsCode": "9404.21.00.95",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.29",
      "rawHtsCode": "9404.29",
      "superior": null,
      "indent": "2",
      "description": "Of other materials:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.29.10",
      "rawHtsCode": "9404.29.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9404.29.1005",
      "rawHtsCode": "9404.29.10.05",
      "superior": null,
      "indent": "4",
      "description": "For use in a crib or toddler bed",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.29.1013",
      "rawHtsCode": "9404.29.10.13",
      "superior": null,
      "indent": "4",
      "description": "Of a width exceeding 91 cm, of a length exceeding 184 cm, and a depth exceeding 8 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.29.1095",
      "rawHtsCode": "9404.29.10.95",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.29.90",
      "rawHtsCode": "9404.29.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9404.29.9005",
      "rawHtsCode": "9404.29.90.05",
      "superior": null,
      "indent": "5",
      "description": "For use in a crib or toddler bed",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.29.9013",
      "rawHtsCode": "9404.29.90.13",
      "superior": null,
      "indent": "5",
      "description": "Of a width exceeding 91 cm, of a length exceeding 184 cm, and of a depth exceeding 8 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.29.9050",
      "rawHtsCode": "9404.29.90.50",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.29.9085",
      "rawHtsCode": "9404.29.90.85",
      "superior": null,
      "indent": "5",
      "description": "For use in a crib or toddler bed",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.29.9087",
      "rawHtsCode": "9404.29.90.87",
      "superior": null,
      "indent": "5",
      "description": "Of a width exceeding 91 cm, of a length exceeding 184 cm, and a depth exceeding 8 cm",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.29.9095",
      "rawHtsCode": "9404.29.90.95",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.30",
      "rawHtsCode": "9404.30",
      "superior": null,
      "indent": "1",
      "description": "Sleeping bags:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.30.4000",
      "rawHtsCode": "9404.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Containing 20 percent or more by weight of feathers and/or down",
      "units": [
        "No."
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9404.30.8000",
      "rawHtsCode": "9404.30.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "9%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9404.40",
      "rawHtsCode": "9404.40",
      "superior": null,
      "indent": "1",
      "description": "Quilts, bedspreads, eiderdowns and duvets (comforters):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.40.1000",
      "rawHtsCode": "9404.40.10.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton, not containing any embroidery, lace, braid, edging, trimming, piping exceeding 6.35 mm or applique work (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9404.40.90",
      "rawHtsCode": "9404.40.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "12.8%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9404.40.9005",
      "rawHtsCode": "9404.40.90.05",
      "superior": null,
      "indent": "3",
      "description": "With outer shell of cotton (362)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.40.9022",
      "rawHtsCode": "9404.40.90.22",
      "superior": null,
      "indent": "3",
      "description": "With outer shell of man-made fibers (666)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.40.9023",
      "rawHtsCode": "9404.40.90.23",
      "superior": null,
      "indent": "4",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.40.9036",
      "rawHtsCode": "9404.40.90.36",
      "superior": null,
      "indent": "4",
      "description": "Other (899)",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.90",
      "rawHtsCode": "9404.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.90.10",
      "rawHtsCode": "9404.90.10",
      "superior": null,
      "indent": "3",
      "description": "Of cotton (369)",
      "units": [
        "",
        "\n"
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9404.90.1030",
      "rawHtsCode": "9404.90.10.30",
      "superior": null,
      "indent": "5",
      "description": "Foam fill (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.90.1060",
      "rawHtsCode": "9404.90.10.60",
      "superior": null,
      "indent": "5",
      "description": "Other fill (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9404.90.1090",
      "rawHtsCode": "9404.90.10.90",
      "superior": null,
      "indent": "4",
      "description": "Other (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.69. "
      ],
      "flags": []
    },
    {
      "htsCode": "9404.90.20",
      "rawHtsCode": "9404.90.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        ""
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9404.90.2030",
      "rawHtsCode": "9404.90.20.30",
      "superior": null,
      "indent": "5",
      "description": "Foam fill",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.90.2060",
      "rawHtsCode": "9404.90.20.60",
      "superior": null,
      "indent": "5",
      "description": "Other fill",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.90.2090",
      "rawHtsCode": "9404.90.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.90.8100",
      "rawHtsCode": "9404.90.81.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton, not containing any embroidery, lace, braid, edging, trimming, piping exceeding 6.35 mm or applique work (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (AU,BH,CL, CO,E*,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9404.90.96",
      "rawHtsCode": "9404.90.96",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9404.90.9605",
      "rawHtsCode": "9404.90.96.05",
      "superior": null,
      "indent": "4",
      "description": "With outer shell of cotton (369)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.90.9622",
      "rawHtsCode": "9404.90.96.22",
      "superior": null,
      "indent": "4",
      "description": "With outer shell of man-made fibers (666)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.90.9623",
      "rawHtsCode": "9404.90.96.23",
      "superior": null,
      "indent": "5",
      "description": "Containing 85 percent or more by weight of silk or silk waste",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.90.9636",
      "rawHtsCode": "9404.90.96.36",
      "superior": null,
      "indent": "5",
      "description": "Other (899)",
      "units": [
        "No.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9404.90.9670",
      "rawHtsCode": "9404.90.96.70",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405",
      "rawHtsCode": "9405",
      "superior": null,
      "indent": "0",
      "description": "Luminaires and lighting fittings including searchlights and spotlights and parts thereof, not elsewhere specified or included; illuminated signs, illuminated nameplates and the like, having a permanently fixed light source, and parts thereof not elsewhere specified or included:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.11",
      "rawHtsCode": "9405.11",
      "superior": null,
      "indent": "2",
      "description": "Designed for use solely with light-emitting diode (LED) light sources:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.11.40",
      "rawHtsCode": "9405.11.40",
      "superior": null,
      "indent": "4",
      "description": "Of brass",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.11.4010",
      "rawHtsCode": "9405.11.40.10",
      "superior": null,
      "indent": "5",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.11.4020",
      "rawHtsCode": "9405.11.40.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.11.60",
      "rawHtsCode": "9405.11.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "7.6%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.11.6010",
      "rawHtsCode": "9405.11.60.10",
      "superior": null,
      "indent": "5",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.11.6020",
      "rawHtsCode": "9405.11.60.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.11.80",
      "rawHtsCode": "9405.11.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.11.8010",
      "rawHtsCode": "9405.11.80.10",
      "superior": null,
      "indent": "4",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.11.8020",
      "rawHtsCode": "9405.11.80.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.19",
      "rawHtsCode": "9405.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.19.40",
      "rawHtsCode": "9405.19.40",
      "superior": null,
      "indent": "4",
      "description": "Of brass",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.19.4010",
      "rawHtsCode": "9405.19.40.10",
      "superior": null,
      "indent": "5",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.19.4020",
      "rawHtsCode": "9405.19.40.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.19.60",
      "rawHtsCode": "9405.19.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "7.6%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.19.6010",
      "rawHtsCode": "9405.19.60.10",
      "superior": null,
      "indent": "5",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.19.6020",
      "rawHtsCode": "9405.19.60.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.19.80",
      "rawHtsCode": "9405.19.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.19.8010",
      "rawHtsCode": "9405.19.80.10",
      "superior": null,
      "indent": "4",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.19.8020",
      "rawHtsCode": "9405.19.80.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.21",
      "rawHtsCode": "9405.21",
      "superior": null,
      "indent": "2",
      "description": "Designed for use solely with light-emitting diode (LED) light sources:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.21.40",
      "rawHtsCode": "9405.21.40",
      "superior": null,
      "indent": "4",
      "description": "Of brass",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.21.4010",
      "rawHtsCode": "9405.21.40.10",
      "superior": null,
      "indent": "5",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.21.4020",
      "rawHtsCode": "9405.21.40.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.21.60",
      "rawHtsCode": "9405.21.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.21.6010",
      "rawHtsCode": "9405.21.60.10",
      "superior": null,
      "indent": "5",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.21.6020",
      "rawHtsCode": "9405.21.60.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.21.80",
      "rawHtsCode": "9405.21.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.21.8010",
      "rawHtsCode": "9405.21.80.10",
      "superior": null,
      "indent": "4",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.21.8020",
      "rawHtsCode": "9405.21.80.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.29",
      "rawHtsCode": "9405.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.29.40",
      "rawHtsCode": "9405.29.40",
      "superior": null,
      "indent": "4",
      "description": "Of brass",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.29.4010",
      "rawHtsCode": "9405.29.40.10",
      "superior": null,
      "indent": "5",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.29.4020",
      "rawHtsCode": "9405.29.40.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.29.60",
      "rawHtsCode": "9405.29.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.29.6010",
      "rawHtsCode": "9405.29.60.10",
      "superior": null,
      "indent": "5",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.29.6020",
      "rawHtsCode": "9405.29.60.20",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.29.80",
      "rawHtsCode": "9405.29.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.29.8010",
      "rawHtsCode": "9405.29.80.10",
      "superior": null,
      "indent": "4",
      "description": "Household",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.29.8020",
      "rawHtsCode": "9405.29.80.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.31.00",
      "rawHtsCode": "9405.31.00",
      "superior": null,
      "indent": "2",
      "description": "Designed for use solely with light-emitting diode (LED) light sources",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.31.0010",
      "rawHtsCode": "9405.31.00.10",
      "superior": null,
      "indent": "3",
      "description": "Miniature series wired sets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.31.0040",
      "rawHtsCode": "9405.31.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.39.00",
      "rawHtsCode": "9405.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.39.0010",
      "rawHtsCode": "9405.39.00.10",
      "superior": null,
      "indent": "3",
      "description": "Miniature series wired sets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.39.0040",
      "rawHtsCode": "9405.39.00.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.41",
      "rawHtsCode": "9405.41",
      "superior": null,
      "indent": "2",
      "description": "Photovoltaic, designed for use solely with light- emitting diode (LED) light sources:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.41.4000",
      "rawHtsCode": "9405.41.40.00",
      "superior": null,
      "indent": "4",
      "description": "Of brass",
      "units": [
        "No."
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.41.6000",
      "rawHtsCode": "9405.41.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.41.8200",
      "rawHtsCode": "9405.41.82.00",
      "superior": null,
      "indent": "4",
      "description": "Light-emitting diode (LED) backlights modules, the foregoing which are lighting sources that consist of one or more LEDs and one or more connectors and are mounted on a printed circuit or other similar substrate, and other passive components, whether or not combined with optical components or protective diodes, and used as backlights illumination for liquid crystal displays(LCDs)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9405.41.84",
      "rawHtsCode": "9405.41.84",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.41.8410",
      "rawHtsCode": "9405.41.84.10",
      "superior": null,
      "indent": "5",
      "description": "Other lighting sets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.41.8440",
      "rawHtsCode": "9405.41.84.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.42",
      "rawHtsCode": "9405.42",
      "superior": null,
      "indent": "2",
      "description": "Other, designed for use solely with light-emitting diode (LED) light sources:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.42.4000",
      "rawHtsCode": "9405.42.40.00",
      "superior": null,
      "indent": "4",
      "description": "Of brass",
      "units": [
        "No."
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.42.6000",
      "rawHtsCode": "9405.42.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.42.8200",
      "rawHtsCode": "9405.42.82.00",
      "superior": null,
      "indent": "4",
      "description": "Light-emitting diode (LED) backlights modules, the foregoing which are lighting sources that consist of one or more LEDs and one or more connectors and are mounted on a printed circuit or other similar substrate, and other passive components, whether or not combined with optical components or protective diodes, and used as backlights illumination for liquid crystal displays(LCDs)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9405.42.84",
      "rawHtsCode": "9405.42.84",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.42.8410",
      "rawHtsCode": "9405.42.84.10",
      "superior": null,
      "indent": "5",
      "description": "Other lighting sets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.42.8440",
      "rawHtsCode": "9405.42.84.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.49.0000",
      "rawHtsCode": "9405.49.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.50",
      "rawHtsCode": "9405.50",
      "superior": null,
      "indent": "1",
      "description": "Non-electrical luminaires and lighting fittings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.50.2000",
      "rawHtsCode": "9405.50.20.00",
      "superior": null,
      "indent": "2",
      "description": "Incandescent luminaires designed to be operated by  propane or other gas, or by compressed air and  kerosene or gasoline",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.50.3000",
      "rawHtsCode": "9405.50.30.00",
      "superior": null,
      "indent": "3",
      "description": "Of brass",
      "units": [
        "No."
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.50.4000",
      "rawHtsCode": "9405.50.40.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.61",
      "rawHtsCode": "9405.61",
      "superior": null,
      "indent": "2",
      "description": "Designed for use solely with light-emitting diode (LED) light sources:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.61.2000",
      "rawHtsCode": "9405.61.20.00",
      "superior": null,
      "indent": "4",
      "description": "Of brass",
      "units": [
        "No."
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.61.4000",
      "rawHtsCode": "9405.61.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.61.6000",
      "rawHtsCode": "9405.61.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.69",
      "rawHtsCode": "9405.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.69.2000",
      "rawHtsCode": "9405.69.20.00",
      "superior": null,
      "indent": "4",
      "description": "Of brass",
      "units": [
        "No."
      ],
      "generalRate": "5.7%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.69.4000",
      "rawHtsCode": "9405.69.40.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.69.6000",
      "rawHtsCode": "9405.69.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.91",
      "rawHtsCode": "9405.91",
      "superior": null,
      "indent": "2",
      "description": "Of glass:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.91.1000",
      "rawHtsCode": "9405.91.10.00",
      "superior": null,
      "indent": "4",
      "description": "Of lead crystal",
      "units": [
        "No."
      ],
      "generalRate": "12%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.91.3000",
      "rawHtsCode": "9405.91.30.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "12%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.91.4000",
      "rawHtsCode": "9405.91.40.00",
      "superior": null,
      "indent": "3",
      "description": "Chimneys",
      "units": [
        "doz."
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.91.60",
      "rawHtsCode": "9405.91.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.91.6040",
      "rawHtsCode": "9405.91.60.40",
      "superior": null,
      "indent": "4",
      "description": "Prisms and other glass articles of a kind used in chandeliers and wall brackets, and articles thereof",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.91.6080",
      "rawHtsCode": "9405.91.60.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.92.0000",
      "rawHtsCode": "9405.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of plastics",
      "units": [
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.99",
      "rawHtsCode": "9405.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.99.2000",
      "rawHtsCode": "9405.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of brass",
      "units": [
        "kg"
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.           "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.99.40",
      "rawHtsCode": "9405.99.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9405.99.4010",
      "rawHtsCode": "9405.99.40.10",
      "superior": null,
      "indent": "4",
      "description": "Lampposts and bases for lampposts, of cast iron",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.99.4020",
      "rawHtsCode": "9405.99.40.20",
      "superior": null,
      "indent": "4",
      "description": "Lampposts and bases for lampposts, of aluminum",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9405.99.4090",
      "rawHtsCode": "9405.99.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "kg",
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9406",
      "rawHtsCode": "9406",
      "superior": null,
      "indent": "0",
      "description": "Prefabricated buildings:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9406.10.0000",
      "rawHtsCode": "9406.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of wood",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9406.20.0000",
      "rawHtsCode": "9406.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Modular building units, of steel",
      "units": [
        "No.",
        "m<sup>2</sup>"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9406.90.01",
      "rawHtsCode": "9406.90.01",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03.           "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9406.90.0110",
      "rawHtsCode": "9406.90.01.10",
      "superior": null,
      "indent": "4",
      "description": "Commercial",
      "units": [
        "No.",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9406.90.0120",
      "rawHtsCode": "9406.90.01.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No.",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9406.90.0130",
      "rawHtsCode": "9406.90.01.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No.",
        "m<sup>2</sup>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9406.90.0150",
      "rawHtsCode": "9406.90.01.50",
      "superior": null,
      "indent": "3",
      "description": "Animal sheds of plastic",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9406.90.0190",
      "rawHtsCode": "9406.90.01.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9503.00.00",
      "rawHtsCode": "9503.00.00",
      "superior": null,
      "indent": "0",
      "description": "Tricycles, scooters, pedal cars and similar wheeled toys; dollsʼ carriages; dolls, other toys; reduced-scale (“scaleˮ) models and similar recreational models, working or not; puzzles of all kinds; parts and accessories thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9503.00.0011",
      "rawHtsCode": "9503.00.00.11",
      "superior": null,
      "indent": "4",
      "description": "Under 3 years of age",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9503.00.0013",
      "rawHtsCode": "9503.00.00.13",
      "superior": null,
      "indent": "4",
      "description": "3 to 12 years of age",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9503.00.0071",
      "rawHtsCode": "9503.00.00.71",
      "superior": null,
      "indent": "4",
      "description": "Under 3 years of age",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9503.00.0073",
      "rawHtsCode": "9503.00.00.73",
      "superior": null,
      "indent": "4",
      "description": "3 to 12 years of age",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9503.00.0090",
      "rawHtsCode": "9503.00.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504",
      "rawHtsCode": "9504",
      "superior": null,
      "indent": "0",
      "description": "Video game consoles and machines, table or parlor games, including pinball machines, billiards, special tables for casino games and automatic bowling equipment, amusement machines operated by coins, banknotes, bank cards, tokens or by any other means of payment:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.20",
      "rawHtsCode": "9504.20",
      "superior": null,
      "indent": "1",
      "description": "Articles and accessories for billiards of all kinds:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.20.2000",
      "rawHtsCode": "9504.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Balls",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.  "
      ],
      "flags": []
    },
    {
      "htsCode": "9504.20.4000",
      "rawHtsCode": "9504.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Chalk",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9504.20.6000",
      "rawHtsCode": "9504.20.60.00",
      "superior": null,
      "indent": "2",
      "description": "Tables",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.20.8000",
      "rawHtsCode": "9504.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other, including parts and accessories",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9504.30.00",
      "rawHtsCode": "9504.30.00",
      "superior": null,
      "indent": "1",
      "description": "Other games, operated by coins, banknotes, bank cards, tokens or by any other means of payment, other than automatic bowling alley equipment; parts and accessories thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9504.30.0010",
      "rawHtsCode": "9504.30.00.10",
      "superior": null,
      "indent": "2",
      "description": "Video",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.30.0020",
      "rawHtsCode": "9504.30.00.20",
      "superior": null,
      "indent": "4",
      "description": "Pinball machines and bell-type machines and consoles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.30.0040",
      "rawHtsCode": "9504.30.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.30.0060",
      "rawHtsCode": "9504.30.00.60",
      "superior": null,
      "indent": "3",
      "description": "Parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.40.0000",
      "rawHtsCode": "9504.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Playing cards",
      "units": [
        "pack"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10¢/pack + 20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9504.50.0000",
      "rawHtsCode": "9504.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Video game consoles and machines, other than those of subheading 9504.30, and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.90",
      "rawHtsCode": "9504.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.90.4000",
      "rawHtsCode": "9504.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Game machines, other than those operated by coins, banknotes (paper currency), discs or similar articles; parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.90.6000",
      "rawHtsCode": "9504.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Chess, checkers, parchisi, backgammon, darts and other games played on boards of a special design, all the foregoing games and parts there of (including their boards); mah-jong and dominoes; any of the foregoing games in combination with each other, or with other games, packaged together as a unit in immediate containers of a type used in retail sales; poker chips and dice",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.90.90",
      "rawHtsCode": "9504.90.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9504.90.9040",
      "rawHtsCode": "9504.90.90.40",
      "superior": null,
      "indent": "4",
      "description": "Bowling balls",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.90.9060",
      "rawHtsCode": "9504.90.90.60",
      "superior": null,
      "indent": "4",
      "description": "Bowling equipment and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9504.90.9080",
      "rawHtsCode": "9504.90.90.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505",
      "rawHtsCode": "9505",
      "superior": null,
      "indent": "0",
      "description": "Festive, carnival or other entertainment articles, including magic tricks and practical joke articles; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505.10",
      "rawHtsCode": "9505.10",
      "superior": null,
      "indent": "1",
      "description": "Articles for Christmas festivities and parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505.10.1000",
      "rawHtsCode": "9505.10.10.00",
      "superior": null,
      "indent": "3",
      "description": "Of glass",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9505.10.1500",
      "rawHtsCode": "9505.10.15.00",
      "superior": null,
      "indent": "4",
      "description": "Of wood",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9505.10.2500",
      "rawHtsCode": "9505.10.25.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9505.10.3000",
      "rawHtsCode": "9505.10.30.00",
      "superior": null,
      "indent": "2",
      "description": "Nativity scenes and figures thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505.10.40",
      "rawHtsCode": "9505.10.40",
      "superior": null,
      "indent": "3",
      "description": "Of plastics",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505.10.4010",
      "rawHtsCode": "9505.10.40.10",
      "superior": null,
      "indent": "4",
      "description": "Artificial Christmas trees",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505.10.4020",
      "rawHtsCode": "9505.10.40.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505.10.50",
      "rawHtsCode": "9505.10.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505.10.5010",
      "rawHtsCode": "9505.10.50.10",
      "superior": null,
      "indent": "4",
      "description": "Artificial Christmas trees",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505.10.5020",
      "rawHtsCode": "9505.10.50.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505.90",
      "rawHtsCode": "9505.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505.90.2000",
      "rawHtsCode": "9505.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Magic tricks and practical joke articles; parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505.90.4000",
      "rawHtsCode": "9505.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Confetti, paper spirals or streamers, party favors and noisemakers; parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9505.90.6000",
      "rawHtsCode": "9505.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506",
      "rawHtsCode": "9506",
      "superior": null,
      "indent": "0",
      "description": "Articles and equipment for general physical exercise, gymnastics, athletics, other sports (including table-tennis) or outdoor games, not specified or included elsewhere in this chapter; swimming pools and wading pools; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.11",
      "rawHtsCode": "9506.11",
      "superior": null,
      "indent": "2",
      "description": "Skis and parts and accessories thereof, except ski poles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.11.2000",
      "rawHtsCode": "9506.11.20.00",
      "superior": null,
      "indent": "3",
      "description": "Cross-country skis",
      "units": [
        "prs."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.11.40",
      "rawHtsCode": "9506.11.40",
      "superior": null,
      "indent": "3",
      "description": "Other skis",
      "units": [],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.11.4010",
      "rawHtsCode": "9506.11.40.10",
      "superior": null,
      "indent": "4",
      "description": "Snowboards",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.11.4080",
      "rawHtsCode": "9506.11.40.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.11.6000",
      "rawHtsCode": "9506.11.60.00",
      "superior": null,
      "indent": "3",
      "description": "Parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.12",
      "rawHtsCode": "9506.12",
      "superior": null,
      "indent": "2",
      "description": "Ski bindings and parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.12.4000",
      "rawHtsCode": "9506.12.40.00",
      "superior": null,
      "indent": "3",
      "description": "Cross-country",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.12.8000",
      "rawHtsCode": "9506.12.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.19",
      "rawHtsCode": "9506.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.19.4000",
      "rawHtsCode": "9506.19.40.00",
      "superior": null,
      "indent": "3",
      "description": "Cross-country",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.19.80",
      "rawHtsCode": "9506.19.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.19.8040",
      "rawHtsCode": "9506.19.80.40",
      "superior": null,
      "indent": "4",
      "description": "Ski poles and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.19.8080",
      "rawHtsCode": "9506.19.80.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.21",
      "rawHtsCode": "9506.21",
      "superior": null,
      "indent": "2",
      "description": "Sailboards and parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.21.4000",
      "rawHtsCode": "9506.21.40.00",
      "superior": null,
      "indent": "3",
      "description": "Sailboards",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.21.8000",
      "rawHtsCode": "9506.21.80.00",
      "superior": null,
      "indent": "3",
      "description": "Parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.29.00",
      "rawHtsCode": "9506.29.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.29.0020",
      "rawHtsCode": "9506.29.00.20",
      "superior": null,
      "indent": "3",
      "description": "Water skis",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.29.0030",
      "rawHtsCode": "9506.29.00.30",
      "superior": null,
      "indent": "3",
      "description": "Surf boards",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.29.0080",
      "rawHtsCode": "9506.29.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.31.0000",
      "rawHtsCode": "9506.31.00.00",
      "superior": null,
      "indent": "2",
      "description": "Golf clubs, complete",
      "units": [
        "No."
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.32.0000",
      "rawHtsCode": "9506.32.00.00",
      "superior": null,
      "indent": "2",
      "description": "Balls",
      "units": [
        "doz."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.39.00",
      "rawHtsCode": "9506.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.39.0060",
      "rawHtsCode": "9506.39.00.60",
      "superior": null,
      "indent": "3",
      "description": "Parts of golf clubs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.39.0080",
      "rawHtsCode": "9506.39.00.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.40.0000",
      "rawHtsCode": "9506.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Articles and equipment for table-tennis, and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.51",
      "rawHtsCode": "9506.51",
      "superior": null,
      "indent": "2",
      "description": "Lawn-tennis rackets, whether or not strung, and parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.51.2000",
      "rawHtsCode": "9506.51.20.00",
      "superior": null,
      "indent": "3",
      "description": "Rackets, strung",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.51.4000",
      "rawHtsCode": "9506.51.40.00",
      "superior": null,
      "indent": "3",
      "description": "Rackets, not strung",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.51.6000",
      "rawHtsCode": "9506.51.60.00",
      "superior": null,
      "indent": "3",
      "description": "Parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.           "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.59",
      "rawHtsCode": "9506.59",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.59.40",
      "rawHtsCode": "9506.59.40",
      "superior": null,
      "indent": "3",
      "description": "Badminton rackets and parts and accessories thereof",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.59.4040",
      "rawHtsCode": "9506.59.40.40",
      "superior": null,
      "indent": "4",
      "description": "Rackets and racket frames",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.59.4080",
      "rawHtsCode": "9506.59.40.80",
      "superior": null,
      "indent": "4",
      "description": "Other parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.59.80",
      "rawHtsCode": "9506.59.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.59.8020",
      "rawHtsCode": "9506.59.80.20",
      "superior": null,
      "indent": "4",
      "description": "Racquetball rackets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.59.8040",
      "rawHtsCode": "9506.59.80.40",
      "superior": null,
      "indent": "4",
      "description": "Squash rackets",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.59.8060",
      "rawHtsCode": "9506.59.80.60",
      "superior": null,
      "indent": "4",
      "description": "Other, including parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.61.0000",
      "rawHtsCode": "9506.61.00.00",
      "superior": null,
      "indent": "2",
      "description": "Lawn-tennis balls",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.62",
      "rawHtsCode": "9506.62",
      "superior": null,
      "indent": "2",
      "description": "Inflatable balls:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.62.40",
      "rawHtsCode": "9506.62.40",
      "superior": null,
      "indent": "3",
      "description": "Footballs and soccer balls",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.62.4040",
      "rawHtsCode": "9506.62.40.40",
      "superior": null,
      "indent": "4",
      "description": "Footballs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.62.4080",
      "rawHtsCode": "9506.62.40.80",
      "superior": null,
      "indent": "4",
      "description": "Soccer balls",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.62.80",
      "rawHtsCode": "9506.62.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.62.8020",
      "rawHtsCode": "9506.62.80.20",
      "superior": null,
      "indent": "4",
      "description": "Basketballs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.62.8040",
      "rawHtsCode": "9506.62.80.40",
      "superior": null,
      "indent": "4",
      "description": "Volleyballs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.62.8060",
      "rawHtsCode": "9506.62.80.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.69",
      "rawHtsCode": "9506.69",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.69.20",
      "rawHtsCode": "9506.69.20",
      "superior": null,
      "indent": "3",
      "description": "Baseballs and softballs",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.69.2040",
      "rawHtsCode": "9506.69.20.40",
      "superior": null,
      "indent": "4",
      "description": "Baseballs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.69.2080",
      "rawHtsCode": "9506.69.20.80",
      "superior": null,
      "indent": "4",
      "description": "Softballs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.69.4000",
      "rawHtsCode": "9506.69.40.00",
      "superior": null,
      "indent": "3",
      "description": "Noninflatable hollow balls not over 19 cm in diameter",
      "units": [
        "No."
      ],
      "generalRate": "5.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.69.60",
      "rawHtsCode": "9506.69.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.69.6010",
      "rawHtsCode": "9506.69.60.10",
      "superior": null,
      "indent": "4",
      "description": "Polo balls",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.69.6020",
      "rawHtsCode": "9506.69.60.20",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.70",
      "rawHtsCode": "9506.70",
      "superior": null,
      "indent": "1",
      "description": "Ice skates and roller skates, including skating boots with skates attached; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.70.20",
      "rawHtsCode": "9506.70.20",
      "superior": null,
      "indent": "2",
      "description": "Roller skates and parts and accessories thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.70.2010",
      "rawHtsCode": "9506.70.20.10",
      "superior": null,
      "indent": "3",
      "description": "Attached to boots",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.70.2090",
      "rawHtsCode": "9506.70.20.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.70.4000",
      "rawHtsCode": "9506.70.40.00",
      "superior": null,
      "indent": "2",
      "description": "Ice skates with footwear permanently attached",
      "units": [
        "prs."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.70.60",
      "rawHtsCode": "9506.70.60",
      "superior": null,
      "indent": "2",
      "description": "Other, including parts and accessories for ice skates with footwear permanently attached",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.70.6040",
      "rawHtsCode": "9506.70.60.40",
      "superior": null,
      "indent": "3",
      "description": "Ice skates",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.70.6080",
      "rawHtsCode": "9506.70.60.80",
      "superior": null,
      "indent": "3",
      "description": "Parts and accessories",
      "units": [
        "prs."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.91.00",
      "rawHtsCode": "9506.91.00",
      "superior": null,
      "indent": "2",
      "description": "Articles and equipment for general physical exercise, gymnastics or athletics; parts and accessories thereof",
      "units": [],
      "generalRate": "4.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.           "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.91.0010",
      "rawHtsCode": "9506.91.00.10",
      "superior": null,
      "indent": "3",
      "description": "Exercise cycles",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.91.0020",
      "rawHtsCode": "9506.91.00.20",
      "superior": null,
      "indent": "3",
      "description": "Exercise rowing machines",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.91.0030",
      "rawHtsCode": "9506.91.00.30",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.99",
      "rawHtsCode": "9506.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.99.05",
      "rawHtsCode": "9506.99.05",
      "superior": null,
      "indent": "3",
      "description": "Archery articles and equipment and parts and accessories thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.99.0510",
      "rawHtsCode": "9506.99.05.10",
      "superior": null,
      "indent": "4",
      "description": "Bows and bow parts",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.99.0520",
      "rawHtsCode": "9506.99.05.20",
      "superior": null,
      "indent": "4",
      "description": "Arrows and arrow parts",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.99.0530",
      "rawHtsCode": "9506.99.05.30",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.99.0800",
      "rawHtsCode": "9506.99.08.00",
      "superior": null,
      "indent": "4",
      "description": "Nets of cotton",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.99.1200",
      "rawHtsCode": "9506.99.12.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.99.1500",
      "rawHtsCode": "9506.99.15.00",
      "superior": null,
      "indent": "3",
      "description": "Baseball articles and equipment, except balls, and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.99.2000",
      "rawHtsCode": "9506.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Football, soccer and polo articles and equip- ment, except balls, and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.                     "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.99.25",
      "rawHtsCode": "9506.99.25",
      "superior": null,
      "indent": "3",
      "description": "Ice-hockey and field-hockey articles and equipment, except balls and skates, and parts and accessories thereof",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.           ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.99.2540",
      "rawHtsCode": "9506.99.25.40",
      "superior": null,
      "indent": "4",
      "description": "Ice-hockey sticks",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.99.2580",
      "rawHtsCode": "9506.99.25.80",
      "superior": null,
      "indent": "4",
      "description": "Other, including parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.99.2800",
      "rawHtsCode": "9506.99.28.00",
      "superior": null,
      "indent": "3",
      "description": "Lacrosse sticks",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.           "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.99.3000",
      "rawHtsCode": "9506.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "Lawn-tennis articles and equipment, except balls and rackets, and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "3.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.99.3500",
      "rawHtsCode": "9506.99.35.00",
      "superior": null,
      "indent": "3",
      "description": "Skeet targets",
      "units": [
        "doz."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.99.4000",
      "rawHtsCode": "9506.99.40.00",
      "superior": null,
      "indent": "4",
      "description": "Toboggans; bobsleds and luges of a kind used in international competition",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9506.99.4500",
      "rawHtsCode": "9506.99.45.00",
      "superior": null,
      "indent": "4",
      "description": "Other, including parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.99.5000",
      "rawHtsCode": "9506.99.50.00",
      "superior": null,
      "indent": "3",
      "description": "Snowshoes and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.99.5500",
      "rawHtsCode": "9506.99.55.00",
      "superior": null,
      "indent": "3",
      "description": "Swimming pools and wading pools and parts and accessories thereof",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.           "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.99.60",
      "rawHtsCode": "9506.99.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.           "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9506.99.6040",
      "rawHtsCode": "9506.99.60.40",
      "superior": null,
      "indent": "4",
      "description": "Nets not elsewhere specified or included",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9506.99.6080",
      "rawHtsCode": "9506.99.60.80",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9507",
      "rawHtsCode": "9507",
      "superior": null,
      "indent": "0",
      "description": "Fishing rods, fish hooks and other line fishing tackle; fish landing nets, butterfly nets and similar nets; decoy \"birds\" (other than those of heading 9208 or 9705) and similar hunting or shooting equipment; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9507.10.00",
      "rawHtsCode": "9507.10.00",
      "superior": null,
      "indent": "1",
      "description": "Fishing rods and parts and accessories thereof",
      "units": [],
      "generalRate": "6%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9507.10.0040",
      "rawHtsCode": "9507.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Fishing rods",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9507.10.0080",
      "rawHtsCode": "9507.10.00.80",
      "superior": null,
      "indent": "2",
      "description": "Parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9507.20",
      "rawHtsCode": "9507.20",
      "superior": null,
      "indent": "1",
      "description": "Fish hooks, whether or not snelled:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9507.20.4000",
      "rawHtsCode": "9507.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Snelled hooks",
      "units": [
        "kg"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9507.20.8000",
      "rawHtsCode": "9507.20.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "4.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9507.30",
      "rawHtsCode": "9507.30",
      "superior": null,
      "indent": "1",
      "description": "Fishing reels and parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9507.30.2000",
      "rawHtsCode": "9507.30.20.00",
      "superior": null,
      "indent": "3",
      "description": "Valued not over $2.70 each",
      "units": [
        "No."
      ],
      "generalRate": "9.2%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9507.30.4000",
      "rawHtsCode": "9507.30.40.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $2.70 but not over $8.45 each",
      "units": [
        "No."
      ],
      "generalRate": "24¢ each",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9507.30.6000",
      "rawHtsCode": "9507.30.60.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over $8.45 each",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.           "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9507.30.8000",
      "rawHtsCode": "9507.30.80.00",
      "superior": null,
      "indent": "2",
      "description": "Parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "5.4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.           "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9507.90",
      "rawHtsCode": "9507.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9507.90.2000",
      "rawHtsCode": "9507.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Fishing line put up and packaged for retail sale",
      "units": [
        "No."
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9507.90.4000",
      "rawHtsCode": "9507.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Fishing casts or leaders",
      "units": [
        "doz."
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 2.8% (JP)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9507.90.6000",
      "rawHtsCode": "9507.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Fish landing nets, butterfly nets and similar nets",
      "units": [
        "No."
      ],
      "generalRate": "5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9507.90.7000",
      "rawHtsCode": "9507.90.70.00",
      "superior": null,
      "indent": "3",
      "description": "Artificial baits and flies",
      "units": [
        "doz."
      ],
      "generalRate": "9%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 4.5% (JP)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9507.90.8000",
      "rawHtsCode": "9507.90.80.00",
      "superior": null,
      "indent": "3",
      "description": "Other, including parts and accessories",
      "units": [
        "No."
      ],
      "generalRate": "9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9508",
      "rawHtsCode": "9508",
      "superior": null,
      "indent": "0",
      "description": "Traveling circuses and traveling menageries; amusement park rides and water park amusements; fairground amusements, including shooting galleries; traveling theaters; parts and accessories thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9508.10.0000",
      "rawHtsCode": "9508.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Traveling circuses and traveling menageries",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9508.21.0000",
      "rawHtsCode": "9508.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Roller coasters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9508.22.0000",
      "rawHtsCode": "9508.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Carousels, swings and roundabouts",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9508.23.0000",
      "rawHtsCode": "9508.23.00.00",
      "superior": null,
      "indent": "2",
      "description": "Bumper (dodge’em) cars",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9508.24.0000",
      "rawHtsCode": "9508.24.00.00",
      "superior": null,
      "indent": "2",
      "description": "Motion simulators and moving theaters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9508.25.0000",
      "rawHtsCode": "9508.25.00.00",
      "superior": null,
      "indent": "2",
      "description": "Water rides",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9508.26.0000",
      "rawHtsCode": "9508.26.00.00",
      "superior": null,
      "indent": "2",
      "description": "Water park amusements",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9508.29.0000",
      "rawHtsCode": "9508.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9508.30.0000",
      "rawHtsCode": "9508.30.00.00",
      "superior": null,
      "indent": "1",
      "description": "Fairground amusements",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9508.40.0000",
      "rawHtsCode": "9508.40.00.00",
      "superior": null,
      "indent": "1",
      "description": "Traveling theaters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9601",
      "rawHtsCode": "9601",
      "superior": null,
      "indent": "0",
      "description": "Worked ivory, bone, tortoise-shell, horn, antlers, coral, mother-of-pearl and other animal carving material, and articles of these materials (including articles obtained by molding):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9601.10.0000",
      "rawHtsCode": "9601.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Worked ivory and articles of ivory",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9601.90",
      "rawHtsCode": "9601.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9601.90.2000",
      "rawHtsCode": "9601.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Worked shell and articles thereof",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9601.90.4000",
      "rawHtsCode": "9601.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Coral, cut but not set, and cameos, suitable for use in jewelry",
      "units": [
        "kg"
      ],
      "generalRate": "2.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9601.90.6000",
      "rawHtsCode": "9601.90.60.00",
      "superior": null,
      "indent": "2",
      "description": "Of bone, horn, hoof, whalebone, quill or any combination thereof",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9601.90.8000",
      "rawHtsCode": "9601.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "3.7%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9602.00",
      "rawHtsCode": "9602.00",
      "superior": null,
      "indent": "0",
      "description": "Worked vegetable or mineral carving material and articles of these materials; molded or carved articles of wax, of stearin, of natural gums or natural resins, of modeling pastes, and other molded or carved articles, not elsewhere specified or included; worked, unhardened gelatin (except gelatin of heading 3503) and articles of unhardened gelatin:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9602.00.10",
      "rawHtsCode": "9602.00.10",
      "superior": null,
      "indent": "1",
      "description": "Worked unhardened gelatin and articles thereof",
      "units": [],
      "generalRate": "3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9602.00.1040",
      "rawHtsCode": "9602.00.10.40",
      "superior": null,
      "indent": "2",
      "description": "Unfilled gelatin capsules",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9602.00.1080",
      "rawHtsCode": "9602.00.10.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9602.00.4000",
      "rawHtsCode": "9602.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Molded or carved articles of wax",
      "units": [
        "No."
      ],
      "generalRate": "1.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9602.00.50",
      "rawHtsCode": "9602.00.50",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9602.00.5010",
      "rawHtsCode": "9602.00.50.10",
      "superior": null,
      "indent": "2",
      "description": "Unfilled vegetable capsules",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9602.00.5080",
      "rawHtsCode": "9602.00.50.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603",
      "rawHtsCode": "9603",
      "superior": null,
      "indent": "0",
      "description": "Brooms, brushes (including brushes constituting parts of machines, appliances or vehicles), hand-operated mechanical floor sweepers, not motorized, mops and feather dusters; prepared knots and tufts for broom or brush making; paint pads and rollers; squeegees (other than roller squeegees):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.10",
      "rawHtsCode": "9603.10",
      "superior": null,
      "indent": "1",
      "description": "Brooms and brushes, consisting of twigs or other vegetable materials bound together, with or without handles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.10.0500",
      "rawHtsCode": "9603.10.05.00",
      "superior": null,
      "indent": "4",
      "description": "In any calendar year prior to the entry, or withdrawal from warehouse for comsumption, of 61,655 dozen whiskbrooms classifiable under subheadings 9603.10.05 to 9603.10.35, inclusive",
      "units": [
        "No."
      ],
      "generalRate": "8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.10.1500",
      "rawHtsCode": "9603.10.15.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "5¢ each",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "12¢ each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.10.3500",
      "rawHtsCode": "9603.10.35.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over 96¢ each",
      "units": [
        "No."
      ],
      "generalRate": "14%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "32%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.10.4000",
      "rawHtsCode": "9603.10.40.00",
      "superior": null,
      "indent": "4",
      "description": "In any calendar year prior to the entry, or withdrawal from warehouse for consumption, of 121,478 dozen brooms classifiable under subheadings 9603.10.40 to 9603.10.60, inclusive",
      "units": [
        "No."
      ],
      "generalRate": "8%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.10.5000",
      "rawHtsCode": "9603.10.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "32¢ each",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "32¢ each",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.10.6000",
      "rawHtsCode": "9603.10.60.00",
      "superior": null,
      "indent": "3",
      "description": "Valued over 96¢ each",
      "units": [
        "No."
      ],
      "generalRate": "32%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "32%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.10.9000",
      "rawHtsCode": "9603.10.90.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.21.0000",
      "rawHtsCode": "9603.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Toothbrushes, including dental-plate brushes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "2¢ each + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9603.29",
      "rawHtsCode": "9603.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.29.40",
      "rawHtsCode": "9603.29.40",
      "superior": null,
      "indent": "3",
      "description": "Valued not over 40¢ each",
      "units": [],
      "generalRate": "0.2¢ each + 7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1¢ each + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.29.4010",
      "rawHtsCode": "9603.29.40.10",
      "superior": null,
      "indent": "4",
      "description": "Hairbrushes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.29.4090",
      "rawHtsCode": "9603.29.40.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.29.80",
      "rawHtsCode": "9603.29.80",
      "superior": null,
      "indent": "3",
      "description": "Valued over 40¢ each",
      "units": [],
      "generalRate": "0.3¢ each + 3.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1¢ each + 50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.29.8010",
      "rawHtsCode": "9603.29.80.10",
      "superior": null,
      "indent": "4",
      "description": "Hairbrushes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.29.8090",
      "rawHtsCode": "9603.29.80.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.30",
      "rawHtsCode": "9603.30",
      "superior": null,
      "indent": "1",
      "description": "Artists' brushes, writing brushes and similar brushes for the application of cosmetics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.30.2000",
      "rawHtsCode": "9603.30.20.00",
      "superior": null,
      "indent": "2",
      "description": "Valued not over 5¢ each",
      "units": [
        "No."
      ],
      "generalRate": "2.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.30.4000",
      "rawHtsCode": "9603.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Valued over 5¢ but not over 10¢ each",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9603.30.6000",
      "rawHtsCode": "9603.30.60.00",
      "superior": null,
      "indent": "2",
      "description": "Valued over 10¢ each",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.40",
      "rawHtsCode": "9603.40",
      "superior": null,
      "indent": "1",
      "description": "Paint, distemper, varnish or similar brushes (other than brushes of subheading 9603.30); paint pads and rollers:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.40.2000",
      "rawHtsCode": "9603.40.20.00",
      "superior": null,
      "indent": "2",
      "description": "Paint rollers",
      "units": [
        "No."
      ],
      "generalRate": "7.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.40.40",
      "rawHtsCode": "9603.40.40",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.40.4020",
      "rawHtsCode": "9603.40.40.20",
      "superior": null,
      "indent": "3",
      "description": "Paint pads",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.40.4040",
      "rawHtsCode": "9603.40.40.40",
      "superior": null,
      "indent": "3",
      "description": "Natural bristle brushes",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.40.4060",
      "rawHtsCode": "9603.40.40.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.50.0000",
      "rawHtsCode": "9603.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other brushes constituting parts of machines, appliances or vehicles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9603.90",
      "rawHtsCode": "9603.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.90.4000",
      "rawHtsCode": "9603.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Feather dusters",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9603.90.80",
      "rawHtsCode": "9603.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15.           "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9603.90.8010",
      "rawHtsCode": "9603.90.80.10",
      "superior": null,
      "indent": "3",
      "description": "Whiskbrooms",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.90.8020",
      "rawHtsCode": "9603.90.80.20",
      "superior": null,
      "indent": "3",
      "description": "Upright brooms",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.90.8030",
      "rawHtsCode": "9603.90.80.30",
      "superior": null,
      "indent": "3",
      "description": "Push brooms, 41 cm or less in width",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.90.8040",
      "rawHtsCode": "9603.90.80.40",
      "superior": null,
      "indent": "3",
      "description": "Other brooms",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9603.90.8050",
      "rawHtsCode": "9603.90.80.50",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9604.00.0000",
      "rawHtsCode": "9604.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Hand sieves and hand riddles",
      "units": [
        "No."
      ],
      "generalRate": "4.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9605.00.0000",
      "rawHtsCode": "9605.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Travel sets for personal toilet, sewing or shoe or clothes cleaning (other than manicure and pedicure sets of heading 8214)",
      "units": [
        "No."
      ],
      "generalRate": "8.1%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9606",
      "rawHtsCode": "9606",
      "superior": null,
      "indent": "0",
      "description": "Buttons, press-fasteners, snap-fasteners and press-studs, button molds and other parts of these articles; button blanks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9606.10",
      "rawHtsCode": "9606.10",
      "superior": null,
      "indent": "1",
      "description": "Press-fasteners, snap-fasteners and press-studs and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9606.10.4000",
      "rawHtsCode": "9606.10.40.00",
      "superior": null,
      "indent": "2",
      "description": "Valued not over 20¢ per dozen pieces or parts",
      "units": [
        "gross"
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9606.10.8000",
      "rawHtsCode": "9606.10.80.00",
      "superior": null,
      "indent": "2",
      "description": "Valued over 20¢ per dozen pieces or parts",
      "units": [
        "gross"
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9606.21",
      "rawHtsCode": "9606.21",
      "superior": null,
      "indent": "2",
      "description": "Of plastics, not covered with textile material:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9606.21.2000",
      "rawHtsCode": "9606.21.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of casein",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9606.21.4000",
      "rawHtsCode": "9606.21.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of acrylic resin, of polyester resin or of both such resins",
      "units": [
        "gross",
        "gr.lines"
      ],
      "generalRate": "0.3¢/line/ gross + 4.6%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.5¢/line/ gross + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9606.21.6000",
      "rawHtsCode": "9606.21.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "4.7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9606.22.0000",
      "rawHtsCode": "9606.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Of base metal, not covered with textile material",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": []
    },
    {
      "htsCode": "9606.29",
      "rawHtsCode": "9606.29",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9606.29.2000",
      "rawHtsCode": "9606.29.20.00",
      "superior": null,
      "indent": "3",
      "description": "Of acrylic resin, of polyester resin or of both such resins, covered with textile material",
      "units": [
        "gross",
        "gr.lines"
      ],
      "generalRate": "0.3¢/line/ gross + 4.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.5¢/line/ gross + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9606.29.4000",
      "rawHtsCode": "9606.29.40.00",
      "superior": null,
      "indent": "4",
      "description": "Of pearl or shell",
      "units": [
        "gross",
        "gr.lines"
      ],
      "generalRate": "0.18¢/line/ gross + 2.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "1.75¢/line/ gross + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9606.29.6000",
      "rawHtsCode": "9606.29.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9606.30",
      "rawHtsCode": "9606.30",
      "superior": null,
      "indent": "1",
      "description": "Button molds and other parts of buttons; button blanks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9606.30.4000",
      "rawHtsCode": "9606.30.40.00",
      "superior": null,
      "indent": "2",
      "description": "Button blanks of casein",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9606.30.8000",
      "rawHtsCode": "9606.30.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9607",
      "rawHtsCode": "9607",
      "superior": null,
      "indent": "0",
      "description": "Slide fasteners and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9607.11.0000",
      "rawHtsCode": "9607.11.00.00",
      "superior": null,
      "indent": "2",
      "description": "Fitted with chain scoops of base metal",
      "units": [
        "No."
      ],
      "generalRate": "10%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9607.19.00",
      "rawHtsCode": "9607.19.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "13%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9607.19.0020",
      "rawHtsCode": "9607.19.00.20",
      "superior": null,
      "indent": "3",
      "description": "Fitted with chain scoops of plastic",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9607.19.0040",
      "rawHtsCode": "9607.19.00.40",
      "superior": null,
      "indent": "3",
      "description": "Fitted with continuous plastic filament",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9607.19.0060",
      "rawHtsCode": "9607.19.00.60",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9607.20.00",
      "rawHtsCode": "9607.20.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [],
      "generalRate": "11.5%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "66%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9607.20.0040",
      "rawHtsCode": "9607.20.00.40",
      "superior": null,
      "indent": "2",
      "description": "Sliders, with or without pulls",
      "units": [
        "thousands"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9607.20.0080",
      "rawHtsCode": "9607.20.00.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9608",
      "rawHtsCode": "9608",
      "superior": null,
      "indent": "0",
      "description": "Ball point pens; felt tipped and other porous-tipped pens and markers; fountain pens, stylograph pens and other pens; duplicating styli; propelling or sliding pencils (for example, mechanical pencils); pen-holders, pencil-holders and similar holders; parts (including caps and clips) of the foregoing articles, other than those of heading 9609:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9608.10.0000",
      "rawHtsCode": "9608.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ball point pens",
      "units": [
        "No."
      ],
      "generalRate": "0.8¢ each + 5.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6¢ each + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9608.20.0000",
      "rawHtsCode": "9608.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Felt tipped and other porous-tipped pens and markers",
      "units": [
        "gross"
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,JP,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9608.30.00",
      "rawHtsCode": "9608.30.00",
      "superior": null,
      "indent": "1",
      "description": "Fountain pens, stylograph pens and other pens",
      "units": [],
      "generalRate": "0.4¢ each + 2.7%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "6¢ each + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9608.30.0031",
      "rawHtsCode": "9608.30.00.31",
      "superior": null,
      "indent": "2",
      "description": "India ink drawing pens",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9608.30.0039",
      "rawHtsCode": "9608.30.00.39",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9608.40",
      "rawHtsCode": "9608.40",
      "superior": null,
      "indent": "1",
      "description": "Propelling or sliding pencils (for example, mechanical pencils):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9608.40.4000",
      "rawHtsCode": "9608.40.40.00",
      "superior": null,
      "indent": "2",
      "description": "With a mechanical action for extending, or for extending and retracting, the lead",
      "units": [
        "gross"
      ],
      "generalRate": "6.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.3% (JP)",
      "otherRate": "41.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9608.40.8000",
      "rawHtsCode": "9608.40.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9608.50.0000",
      "rawHtsCode": "9608.50.00.00",
      "superior": null,
      "indent": "1",
      "description": "Sets of articles from two or more of the subheadings 9608.10, 9608.20, 9608.30 or 9608.40",
      "units": [
        "No."
      ],
      "generalRate": "The rate applicable to each article in the absence of this subheading",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable, to each article in the absence of this subheading",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15, 9903.88.25, 9903.88.26, 9903.88.27 and 9903.88.28. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9608.60.0000",
      "rawHtsCode": "9608.60.00.00",
      "superior": null,
      "indent": "1",
      "description": "Refills for ball point pens, comprising the ball point and ink reservoir",
      "units": [
        "No."
      ],
      "generalRate": "0.4¢ each + 2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6¢ each + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9608.91.0000",
      "rawHtsCode": "9608.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Pen nibs and nib points",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20¢/gross",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9608.99",
      "rawHtsCode": "9608.99",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9608.99.2000",
      "rawHtsCode": "9608.99.20.00",
      "superior": null,
      "indent": "3",
      "description": "Refill cartridges",
      "units": [
        "No."
      ],
      "generalRate": "0.4¢ each + 2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "6¢ each + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9608.99.3000",
      "rawHtsCode": "9608.99.30.00",
      "superior": null,
      "indent": "3",
      "description": "Balls for ball point pens",
      "units": [
        "thousands"
      ],
      "generalRate": "20¢/thousand + 3.5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$2.50/thou- sand + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9608.99.4000",
      "rawHtsCode": "9608.99.40.00",
      "superior": null,
      "indent": "4",
      "description": "Parts of articles provided for in subheadings 9608.10 and 9608.30 (other than balls for ball point pens)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6¢ each + 40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9608.99.6000",
      "rawHtsCode": "9608.99.60.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9609",
      "rawHtsCode": "9609",
      "superior": null,
      "indent": "0",
      "description": "Pencils (other than those pencils of heading 9608), crayons, pencil leads, pastels, drawing charcoals, writing or drawing chalks and tailors' chalks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9609.10.0000",
      "rawHtsCode": "9609.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Pencils and crayons, with leads encased in a sheath",
      "units": [
        "gross"
      ],
      "generalRate": "14¢/gross + 4.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50¢/gross + 30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9609.20",
      "rawHtsCode": "9609.20",
      "superior": null,
      "indent": "1",
      "description": "Pencil leads, black or colored:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9609.20.2000",
      "rawHtsCode": "9609.20.20.00",
      "superior": null,
      "indent": "2",
      "description": "Not over 1.5 mm in maximum cross-sectional dimension",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "20¢/gross",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9609.20.4000",
      "rawHtsCode": "9609.20.40.00",
      "superior": null,
      "indent": "2",
      "description": "Over 1.5 mm in maximum cross-sectional dimension",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "6¢/gross",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9609.90",
      "rawHtsCode": "9609.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9609.90.4000",
      "rawHtsCode": "9609.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Tailors' chalks",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9609.90.8000",
      "rawHtsCode": "9609.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50¢/gross + 30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9610.00.0000",
      "rawHtsCode": "9610.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Slates and boards, with writing or drawing surfaces, whether or not framed",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9611.00.0000",
      "rawHtsCode": "9611.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Date, sealing or numbering stamps and the like, (including devices for printing or embossing labels), designed for operating in the hand; hand-operated composing sticks and hand printing sets incorporating such composing sticks",
      "units": [
        "No."
      ],
      "generalRate": "2.7%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9612",
      "rawHtsCode": "9612",
      "superior": null,
      "indent": "0",
      "description": "Typewriter or similar ribbons, inked or otherwise prepared for giving impressions, whether or not on spools or in cartridges; ink pads, whether or not inked, with or without boxes:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9612.10",
      "rawHtsCode": "9612.10",
      "superior": null,
      "indent": "1",
      "description": "Ribbons:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9612.10.10",
      "rawHtsCode": "9612.10.10",
      "superior": null,
      "indent": "2",
      "description": "Measuring less than 30 mm in width, permanently put up in plastic or metal cartridges (whether or not containing spools) of a kind used in typewriters, automatic data processing or other machines",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9612.10.1010",
      "rawHtsCode": "9612.10.10.10",
      "superior": null,
      "indent": "3",
      "description": "Woven, of man-made fibers",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9612.10.1020",
      "rawHtsCode": "9612.10.10.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9612.10.90",
      "rawHtsCode": "9612.10.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "7.9%",
      "specialRate": "Free (AU,BH,CL,CO,E*,IL,JO,KR,MA,OM,P,PA,PE,S,SG) 3.95% (JP)",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9612.10.9010",
      "rawHtsCode": "9612.10.90.10",
      "superior": null,
      "indent": "3",
      "description": "Woven, of man-made fibers (621)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9612.10.9030",
      "rawHtsCode": "9612.10.90.30",
      "superior": null,
      "indent": "4",
      "description": "Thermal transfer printing ribbons of coated polyethylene terephthalate film",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9612.10.9090",
      "rawHtsCode": "9612.10.90.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "doz.",
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9612.20.0000",
      "rawHtsCode": "9612.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Ink pads",
      "units": [
        "No."
      ],
      "generalRate": "3.5%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9613",
      "rawHtsCode": "9613",
      "superior": null,
      "indent": "0",
      "description": "Cigarette lighters and other lighters, whether or not mechanical or electrical, and parts thereof other than flints and wicks:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9613.10.0000",
      "rawHtsCode": "9613.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Pocket lighters, gas fueled, non-refillable",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9613.20.0000",
      "rawHtsCode": "9613.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Pocket lighters, gas fueled, refillable",
      "units": [
        "No."
      ],
      "generalRate": "9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9613.80",
      "rawHtsCode": "9613.80",
      "superior": null,
      "indent": "1",
      "description": "Other lighters:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9613.80.10",
      "rawHtsCode": "9613.80.10",
      "superior": null,
      "indent": "2",
      "description": "Table lighters",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9613.80.1040",
      "rawHtsCode": "9613.80.10.40",
      "superior": null,
      "indent": "3",
      "description": "Butane",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9613.80.1080",
      "rawHtsCode": "9613.80.10.80",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9613.80.20",
      "rawHtsCode": "9613.80.20",
      "superior": null,
      "indent": "3",
      "description": "Electrical",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9613.80.2010",
      "rawHtsCode": "9613.80.20.10",
      "superior": null,
      "indent": "4",
      "description": "Multipurpose lighters, including those used to light charcoal and gas grills and fireplaces",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9613.80.2090",
      "rawHtsCode": "9613.80.20.90",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9613.80.4000",
      "rawHtsCode": "9613.80.40.00",
      "superior": null,
      "indent": "4",
      "description": "Of precious metal (except silver), of precious or semiprecious stones or of such metal and such stones",
      "units": [
        "No."
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9613.80.6000",
      "rawHtsCode": "9613.80.60.00",
      "superior": null,
      "indent": "5",
      "description": "Valued not over $5 per dozen pieces",
      "units": [
        "doz."
      ],
      "generalRate": "8%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9613.80.8000",
      "rawHtsCode": "9613.80.80.00",
      "superior": null,
      "indent": "5",
      "description": "Valued over $5 per dozen pieces",
      "units": [
        "doz."
      ],
      "generalRate": "9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9613.90",
      "rawHtsCode": "9613.90",
      "superior": null,
      "indent": "1",
      "description": "Parts:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9613.90.4000",
      "rawHtsCode": "9613.90.40.00",
      "superior": null,
      "indent": "2",
      "description": "Electrical",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9613.90.8000",
      "rawHtsCode": "9613.90.80.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9614.00",
      "rawHtsCode": "9614.00",
      "superior": null,
      "indent": "0",
      "description": "Smoking pipes (including pipe bowls) and cigar or cigarette holders, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9614.00.2100",
      "rawHtsCode": "9614.00.21.00",
      "superior": null,
      "indent": "3",
      "description": "Roughly shaped blocks of wood or root, for the manufacture of pipes",
      "units": [
        "gross"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "10%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9614.00.2500",
      "rawHtsCode": "9614.00.25.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "0.4¢ each + 3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5¢ each + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9614.00.2600",
      "rawHtsCode": "9614.00.26.00",
      "superior": null,
      "indent": "2",
      "description": "Pipes and bowls wholly of clay and pipes with bowls wholly of clay",
      "units": [
        "No."
      ],
      "generalRate": "3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9614.00.28",
      "rawHtsCode": "9614.00.28",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "0.3¢ each + 3.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5¢ each + 60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9614.00.2810",
      "rawHtsCode": "9614.00.28.10",
      "superior": null,
      "indent": "3",
      "description": "Of glass",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9614.00.2830",
      "rawHtsCode": "9614.00.28.30",
      "superior": null,
      "indent": "3",
      "description": "Of plastics",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9614.00.2890",
      "rawHtsCode": "9614.00.28.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9614.00.9400",
      "rawHtsCode": "9614.00.94.00",
      "superior": null,
      "indent": "2",
      "description": "Of metal",
      "units": [
        "No."
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9614.00.98",
      "rawHtsCode": "9614.00.98",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "0.5¢ each + 3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "5¢ each + 60%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9614.00.9810",
      "rawHtsCode": "9614.00.98.10",
      "superior": null,
      "indent": "3",
      "description": "Of glass",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9614.00.9890",
      "rawHtsCode": "9614.00.98.90",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9615",
      "rawHtsCode": "9615",
      "superior": null,
      "indent": "0",
      "description": "Combs, hair-slides and the like; hairpins, curling pins, curling grips, hair-curlers and the like, other than those of heading 8516, and parts thereof:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9615.11",
      "rawHtsCode": "9615.11",
      "superior": null,
      "indent": "2",
      "description": "Of hard rubber or plastics:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9615.11.1000",
      "rawHtsCode": "9615.11.10.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $4.50 per gross",
      "units": [
        "gross"
      ],
      "generalRate": "14.4¢/gross + 2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.44/gross + 25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9615.11.2000",
      "rawHtsCode": "9615.11.20.00",
      "superior": null,
      "indent": "5",
      "description": "Of hard rubber",
      "units": [
        "gross"
      ],
      "generalRate": "5.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "36%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9615.11.3000",
      "rawHtsCode": "9615.11.30.00",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "gross"
      ],
      "generalRate": "28.8¢/gross + 4.6%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$2.88/gross + 35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9615.11.4000",
      "rawHtsCode": "9615.11.40.00",
      "superior": null,
      "indent": "4",
      "description": "Not set with imitation pearls or imitation gemstones",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9615.11.5000",
      "rawHtsCode": "9615.11.50.00",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9615.19",
      "rawHtsCode": "9615.19",
      "superior": null,
      "indent": "2",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9615.19.2000",
      "rawHtsCode": "9615.19.20.00",
      "superior": null,
      "indent": "4",
      "description": "Valued not over $4.50 per gross",
      "units": [
        "gross"
      ],
      "generalRate": "9.7¢/gross + 1.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$1.44/gross + 25%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9615.19.4000",
      "rawHtsCode": "9615.19.40.00",
      "superior": null,
      "indent": "4",
      "description": "Valued over $4.50 per gross",
      "units": [
        "gross"
      ],
      "generalRate": "28.8¢/gross + 4.6%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "$2.88/gross + 35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9615.19.6000",
      "rawHtsCode": "9615.19.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "11%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9615.90",
      "rawHtsCode": "9615.90",
      "superior": null,
      "indent": "1",
      "description": "Other:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9615.90.2000",
      "rawHtsCode": "9615.90.20.00",
      "superior": null,
      "indent": "2",
      "description": "Nonthermic, nonornamental devices for curling the hair",
      "units": [
        "No."
      ],
      "generalRate": "8.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9615.90.3000",
      "rawHtsCode": "9615.90.30.00",
      "superior": null,
      "indent": "2",
      "description": "Hair pins",
      "units": [
        "kg"
      ],
      "generalRate": "5.1%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9615.90.4000",
      "rawHtsCode": "9615.90.40.00",
      "superior": null,
      "indent": "3",
      "description": "Of rubber or plastics, not set with imitation pearls or imitation gemstones",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9615.90.6000",
      "rawHtsCode": "9615.90.60.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "11%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "110%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9616",
      "rawHtsCode": "9616",
      "superior": null,
      "indent": "0",
      "description": "Scent sprayers and similar toilet sprayers, and mounts and heads therefor; powder puffs and pads for the application of cosmetics or toilet preparations:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": "",
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9616.10.0000",
      "rawHtsCode": "9616.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Scent sprayers and similar toilet sprayers, and mounts and heads therefor",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9616.20.0000",
      "rawHtsCode": "9616.20.00.00",
      "superior": null,
      "indent": "1",
      "description": "Powder puffs and pads for the application of cosmetics or toilet preparations",
      "units": [
        "kg"
      ],
      "generalRate": "4.3%",
      "specialRate": "Free (A+,AU,BH,CL,CO,D,E, IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "78.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9617.00",
      "rawHtsCode": "9617.00",
      "superior": null,
      "indent": "0",
      "description": "Vacuum flasks and other vacuum vessels, complete; parts thereof other than glass inners:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9617.00.1000",
      "rawHtsCode": "9617.00.10.00",
      "superior": null,
      "indent": "2",
      "description": "Having a capacity not exceeding 1 liter",
      "units": [
        "No."
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55.5%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9617.00.3000",
      "rawHtsCode": "9617.00.30.00",
      "superior": null,
      "indent": "2",
      "description": "Having a capacity exceeding 1 liter but not exceeding 2 liters",
      "units": [
        "No."
      ],
      "generalRate": "6.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "52%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9617.00.4000",
      "rawHtsCode": "9617.00.40.00",
      "superior": null,
      "indent": "2",
      "description": "Having a capacity exceeding 2 liters",
      "units": [
        "No."
      ],
      "generalRate": "6.9%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "51%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9617.00.6000",
      "rawHtsCode": "9617.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Parts",
      "units": [
        "No."
      ],
      "generalRate": "7.2%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9618.00.0000",
      "rawHtsCode": "9618.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Tailors' dummies and other mannequins; automatons and other animated displays used for shopwindow dressing",
      "units": [
        "No."
      ],
      "generalRate": "4.4%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "56%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00",
      "rawHtsCode": "9619.00",
      "superior": null,
      "indent": "0",
      "description": "Sanitary pads (towels) and tampons, diapers (napkins), diaper liners and similar articles, of any material:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9619.00.0500",
      "rawHtsCode": "9619.00.05.00",
      "superior": null,
      "indent": "1",
      "description": "Of plastics",
      "units": [
        "kg"
      ],
      "generalRate": "5%",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.1100",
      "rawHtsCode": "9619.00.11.00",
      "superior": null,
      "indent": "1",
      "description": "Of paper pulp",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9619.00.15",
      "rawHtsCode": "9619.00.15",
      "superior": null,
      "indent": "1",
      "description": "Of paper, cellulose wadding or webs of cellulose fibers",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9619.00.1510",
      "rawHtsCode": "9619.00.15.10",
      "superior": null,
      "indent": "2",
      "description": "Sanitary napkins and tampons",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9619.00.1530",
      "rawHtsCode": "9619.00.15.30",
      "superior": null,
      "indent": "2",
      "description": "Diapers and diaper liners",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9619.00.1560",
      "rawHtsCode": "9619.00.15.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9619.00.2100",
      "rawHtsCode": "9619.00.21.00",
      "superior": null,
      "indent": "2",
      "description": "Of cotton (369)",
      "units": [
        "kg"
      ],
      "generalRate": "3.6%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.2500",
      "rawHtsCode": "9619.00.25.00",
      "superior": null,
      "indent": "2",
      "description": "Other (669)",
      "units": [
        "kg"
      ],
      "generalRate": "6.3%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "74%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.3100",
      "rawHtsCode": "9619.00.31.00",
      "superior": null,
      "indent": "3",
      "description": "Of knitted or crocheted textile fabric (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.3300",
      "rawHtsCode": "9619.00.33.00",
      "superior": null,
      "indent": "3",
      "description": "Other (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "9.3%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.4100",
      "rawHtsCode": "9619.00.41.00",
      "superior": null,
      "indent": "2",
      "description": "Of synthetic fibers (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.4300",
      "rawHtsCode": "9619.00.43.00",
      "superior": null,
      "indent": "2",
      "description": "Of artificial fibers (239)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.4600",
      "rawHtsCode": "9619.00.46.00",
      "superior": null,
      "indent": "3",
      "description": "Of knitted or crocheted textile fabric (839)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.4800",
      "rawHtsCode": "9619.00.48.00",
      "superior": null,
      "indent": "3",
      "description": "Other (839)",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH, CL,CO,E,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.6100",
      "rawHtsCode": "9619.00.61.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "10.8%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.6400",
      "rawHtsCode": "9619.00.64.00",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "14.9%",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR,MA,OM,P,PA, PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.6800",
      "rawHtsCode": "9619.00.68.00",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "5.6%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "60%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.7100",
      "rawHtsCode": "9619.00.71.00",
      "superior": null,
      "indent": "3",
      "description": "Of cotton",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "8.1%",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO,KR, MA,OM,P,PA, PE,S,SG)",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.7400",
      "rawHtsCode": "9619.00.74.00",
      "superior": null,
      "indent": "3",
      "description": "Of man-made fibers",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "16%",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "76%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.7800",
      "rawHtsCode": "9619.00.78.00",
      "superior": null,
      "indent": "4",
      "description": "Menʼs or boysʼ",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "2.8%",
      "specialRate": "Free (AU,BH, CL,CO,E*,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.7900",
      "rawHtsCode": "9619.00.79.00",
      "superior": null,
      "indent": "4",
      "description": "Womenʼs or girlsʼ",
      "units": [
        "doz.",
        "<u>kg</u>"
      ],
      "generalRate": "7.3%",
      "specialRate": "Free (AU,BH,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9619.00.9000",
      "rawHtsCode": "9619.00.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No.",
        "kg"
      ],
      "generalRate": "7%",
      "specialRate": "Free (A,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "40%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9620.00",
      "rawHtsCode": "9620.00",
      "superior": null,
      "indent": "0",
      "description": "Monopods, bipods, tripods and similar articles:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9620.00.1000",
      "rawHtsCode": "9620.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Accessories suitable for use solely or principally with the apparatus of heading 8519 or 8521",
      "units": [
        "No."
      ],
      "generalRate": "2%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9620.00.1500",
      "rawHtsCode": "9620.00.15.00",
      "superior": null,
      "indent": "1",
      "description": "Accessories for the articles of heading 9005",
      "units": [
        "No."
      ],
      "generalRate": "The rate applicable to the article of which it is an accessory",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to the article of which it is an accessory",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9620.00.2000",
      "rawHtsCode": "9620.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Accessories for photographic (other than cinematographic) cameras of heading 9006",
      "units": [
        "No."
      ],
      "generalRate": "5.8%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "20%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9620.00.2500",
      "rawHtsCode": "9620.00.25.00",
      "superior": null,
      "indent": "1",
      "description": "Accessories for cinematographic cameras of heading 9007",
      "units": [
        "No."
      ],
      "generalRate": "3.9%",
      "specialRate": "Free (A*,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9620.00.30",
      "rawHtsCode": "9620.00.30",
      "superior": null,
      "indent": "1",
      "description": "Accessories for the instruments and appliances, including rangefinders, of heading 9015",
      "units": [],
      "generalRate": "The rate applicable to the article of which it is an accessory",
      "specialRate": "Free (A,AU,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "The rate applicable to the article of which it is an accessory",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03, 9903.88.21, 9903.88.22, 9903.88.23 and 9903.88.24. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9620.00.3010",
      "rawHtsCode": "9620.00.30.10",
      "superior": null,
      "indent": "2",
      "description": "Of rangefinders",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9620.00.3020",
      "rawHtsCode": "9620.00.30.20",
      "superior": null,
      "indent": "2",
      "description": "Of theodolites and tachymeters",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9620.00.3030",
      "rawHtsCode": "9620.00.30.30",
      "superior": null,
      "indent": "2",
      "description": "Of levels",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9620.00.3040",
      "rawHtsCode": "9620.00.30.40",
      "superior": null,
      "indent": "2",
      "description": "Of photogrammetrical surveying instruments and apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9620.00.3050",
      "rawHtsCode": "9620.00.30.50",
      "superior": null,
      "indent": "2",
      "description": "Of seismographs",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9620.00.3060",
      "rawHtsCode": "9620.00.30.60",
      "superior": null,
      "indent": "2",
      "description": "Of other geophysical instruments and apparatus",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9620.00.3090",
      "rawHtsCode": "9620.00.30.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9620.00.5000",
      "rawHtsCode": "9620.00.50.00",
      "superior": null,
      "indent": "2",
      "description": "Of plastics",
      "units": [
        "No."
      ],
      "generalRate": "5.3%",
      "specialRate": "Free (A*,AU,B,BH,C,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "80%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9620.00.5500",
      "rawHtsCode": "9620.00.55.00",
      "superior": null,
      "indent": "2",
      "description": "Of wood",
      "units": [
        "No."
      ],
      "generalRate": "3.3%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "33 1/3%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9620.00.6000",
      "rawHtsCode": "9620.00.60.00",
      "superior": null,
      "indent": "2",
      "description": "Of graphite or other carbon",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": []
    },
    {
      "htsCode": "9620.00.6500",
      "rawHtsCode": "9620.00.65.00",
      "superior": null,
      "indent": "2",
      "description": "Of iron or steel",
      "units": [
        "No."
      ],
      "generalRate": "2.9%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9620.00.7000",
      "rawHtsCode": "9620.00.70.00",
      "superior": null,
      "indent": "2",
      "description": "Of aluminum",
      "units": [
        "No."
      ],
      "generalRate": "2.5%",
      "specialRate": "Free (A*,AU,B,BH,CL,CO,D,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "45%",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.03. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9701",
      "rawHtsCode": "9701",
      "superior": null,
      "indent": "0",
      "description": "Painting, drawings and pastels, executed entirely by hand, other than drawings of heading 4906 and other than hand-painted or hand-decorated manufacture articles; collages, mosaics and similar decorative plaques:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9701.21.0000",
      "rawHtsCode": "9701.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Paintings, drawings, and pastels",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9701.22.0000",
      "rawHtsCode": "9701.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mosaics",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9701.29.0000",
      "rawHtsCode": "9701.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9701.91.0000",
      "rawHtsCode": "9701.91.00.00",
      "superior": null,
      "indent": "2",
      "description": "Paintings, drawings, and pastels",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9701.92.0000",
      "rawHtsCode": "9701.92.00.00",
      "superior": null,
      "indent": "2",
      "description": "Mosaics",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9701.99.0000",
      "rawHtsCode": "9701.99.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9702",
      "rawHtsCode": "9702",
      "superior": null,
      "indent": "0",
      "description": "Original engravings, prints and lithographs:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9702.10.0000",
      "rawHtsCode": "9702.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of an age exceeding 100 years",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9702.90.0000",
      "rawHtsCode": "9702.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9703",
      "rawHtsCode": "9703",
      "superior": null,
      "indent": "0",
      "description": "Original sculptures and statuary, in any material:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9703.10.0000",
      "rawHtsCode": "9703.10.00.00",
      "superior": null,
      "indent": "1",
      "description": "Of an age exceeding 100 years",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9703.90.0000",
      "rawHtsCode": "9703.90.00.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9704.00.0000",
      "rawHtsCode": "9704.00.00.00",
      "superior": null,
      "indent": "0",
      "description": "Postage or revenue stamps, stamp-postmarks, first-day covers, postal stationery (stamped paper) and the like, used or unused, other than those of heading 4907",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9705",
      "rawHtsCode": "9705",
      "superior": null,
      "indent": "0",
      "description": "Collections and collectors’ pieces of archaeological, ethnographic, historical, zoological, botanical, mineralogical, anatomical, paleontological or numismatic interest:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9705.10.00",
      "rawHtsCode": "9705.10.00",
      "superior": null,
      "indent": "1",
      "description": "Collections and collectors’ pieces of archaeological, ethnographic or historical interest",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9705.10.0010",
      "rawHtsCode": "9705.10.00.10",
      "superior": null,
      "indent": "2",
      "description": "Archaeological pieces of a kind described in statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9705.10.0020",
      "rawHtsCode": "9705.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Ethnographic pieces of a kind described in statistical note 1 to this chapter",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9705.10.0090",
      "rawHtsCode": "9705.10.00.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9705.21.0000",
      "rawHtsCode": "9705.21.00.00",
      "superior": null,
      "indent": "2",
      "description": "Human specimens and parts thereof",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9705.22.0000",
      "rawHtsCode": "9705.22.00.00",
      "superior": null,
      "indent": "2",
      "description": "Extinct or endangered species and parts thereof",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9705.29.0000",
      "rawHtsCode": "9705.29.00.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.90.08. ",
        "See 9903.88.15. "
      ],
      "flags": []
    },
    {
      "htsCode": "9705.31.00",
      "rawHtsCode": "9705.31.00",
      "superior": null,
      "indent": "2",
      "description": "Of an age exceeding 100 years ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9705.31.0001",
      "rawHtsCode": "9705.31.00.01",
      "superior": null,
      "indent": "3",
      "description": "Coins made prior to the 14th century and not known to be the direct products of excavations, finds or archaeological sites",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9705.31.0010",
      "rawHtsCode": "9705.31.00.10",
      "superior": null,
      "indent": "5",
      "description": "Gold",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9705.31.0040",
      "rawHtsCode": "9705.31.00.40",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9705.31.0050",
      "rawHtsCode": "9705.31.00.50",
      "superior": null,
      "indent": "5",
      "description": "Gold",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9705.31.0065",
      "rawHtsCode": "9705.31.00.65",
      "superior": null,
      "indent": "5",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9705.39.00",
      "rawHtsCode": "9705.39.00",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9705.39.0010",
      "rawHtsCode": "9705.39.00.10",
      "superior": null,
      "indent": "4",
      "description": "Gold",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9705.39.0040",
      "rawHtsCode": "9705.39.00.40",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [
        "g"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9706",
      "rawHtsCode": "9706",
      "superior": null,
      "indent": "0",
      "description": "Antiques of an age exceeding 100 years:",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9706.10.00",
      "rawHtsCode": "9706.10.00",
      "superior": null,
      "indent": "1",
      "description": "Of an age exceeding 250 years",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9706.10.0020",
      "rawHtsCode": "9706.10.00.20",
      "superior": null,
      "indent": "2",
      "description": "Silverware",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9706.10.0040",
      "rawHtsCode": "9706.10.00.40",
      "superior": null,
      "indent": "2",
      "description": "Furniture",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9706.10.0060",
      "rawHtsCode": "9706.10.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9706.90.00",
      "rawHtsCode": "9706.90.00",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See 9903.88.15. ",
        "See 9903.90.08. "
      ],
      "flags": []
    },
    {
      "htsCode": "9706.90.0020",
      "rawHtsCode": "9706.90.00.20",
      "superior": null,
      "indent": "2",
      "description": "Silverware",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9706.90.0040",
      "rawHtsCode": "9706.90.00.40",
      "superior": null,
      "indent": "2",
      "description": "Furniture",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9706.90.0060",
      "rawHtsCode": "9706.90.00.60",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.10",
      "rawHtsCode": "9801.00.10",
      "superior": null,
      "indent": "0",
      "description": "Products of the United States when returned after having been exported, or any other products when returned within 3 years after having been exported, without having been advanced in value or improved in condition by any process of manufacture or other means while abroad",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1010",
      "rawHtsCode": "9801.00.10.10",
      "superior": null,
      "indent": "1",
      "description": "Articles previously exported with intent to reimport after temporary use abroad",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1012",
      "rawHtsCode": "9801.00.10.12",
      "superior": null,
      "indent": "1",
      "description": "Articles returned temporarily for repair, alteration, processing or the like, the foregoing to be reexported",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " The quantities reported should be in the units provided in chapters 1-97. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.1015",
      "rawHtsCode": "9801.00.10.15",
      "superior": null,
      "indent": "2",
      "description": "Meat and poultry products provided for in chapter 2 or 16",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1026",
      "rawHtsCode": "9801.00.10.26",
      "superior": null,
      "indent": "2",
      "description": "Peanuts provided for in heading 1202",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1027",
      "rawHtsCode": "9801.00.10.27",
      "superior": null,
      "indent": "2",
      "description": "Articles provided for in chapter 28",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1028",
      "rawHtsCode": "9801.00.10.28",
      "superior": null,
      "indent": "2",
      "description": "Articles provided for in chapter 30",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1029",
      "rawHtsCode": "9801.00.10.29",
      "superior": null,
      "indent": "2",
      "description": "Articles provided for in chapter 37",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " The quantities reported should be in the units provided in chapters 1-97. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.1030",
      "rawHtsCode": "9801.00.10.30",
      "superior": null,
      "indent": "2",
      "description": "Articles provided for in chapter 71",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " The quantities reported should be in the units provided in chapters 1-97. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.1031",
      "rawHtsCode": "9801.00.10.31",
      "superior": null,
      "indent": "2",
      "description": "Articles provided for in chapter 82",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " The quantities reported should be in the units provided in chapters 1-97. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.1035",
      "rawHtsCode": "9801.00.10.35",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in headings 8407.10, 8409.10, 8411 or 8412.10",
      "units": [
        "No. and kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1037",
      "rawHtsCode": "9801.00.10.37",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in subheadings 8419.33.10, 8419.34.00, 8424.41, 8424.49, 8424.82, 8424.90, 8429.11, 8429.19 or 8431.42 or headings 8432, 8433, 8434 or 8436",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1043",
      "rawHtsCode": "9801.00.10.43",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in headings 8470, 8471, 8472 or 8473",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1045",
      "rawHtsCode": "9801.00.10.45",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " The quantities reported should be in the units provided in chapters 1-97. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.1049",
      "rawHtsCode": "9801.00.10.49",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in headings 8501, 8502 or 8503",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1051",
      "rawHtsCode": "9801.00.10.51",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in heading 8504",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1053",
      "rawHtsCode": "9801.00.10.53",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in headings 8517, 8519, 8525, 8527 or 8529",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1055",
      "rawHtsCode": "9801.00.10.55",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " The quantities reported should be in the units provided in chapters 1-97. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.1059",
      "rawHtsCode": "9801.00.10.59",
      "superior": null,
      "indent": "2",
      "description": "Articles provided for in chapter 86",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1063",
      "rawHtsCode": "9801.00.10.63",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in heading 8701",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1064",
      "rawHtsCode": "9801.00.10.64",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in heading 8702",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1065",
      "rawHtsCode": "9801.00.10.65",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in heading 8703",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1066",
      "rawHtsCode": "9801.00.10.66",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in heading 8704",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1067",
      "rawHtsCode": "9801.00.10.67",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in headings 8706, 8707 or 8708",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1069",
      "rawHtsCode": "9801.00.10.69",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in headings 8705 or 8709",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1074",
      "rawHtsCode": "9801.00.10.74",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1075",
      "rawHtsCode": "9801.00.10.75",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in headings 8801 or 8802",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1077",
      "rawHtsCode": "9801.00.10.77",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in heading 8804",
      "units": [
        "kg"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1079",
      "rawHtsCode": "9801.00.10.79",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in headings 8805, 8806 or 8807",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " Report data using the unit of quantity in the applicable subheading of chapter 88. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.1089",
      "rawHtsCode": "9801.00.10.89",
      "superior": null,
      "indent": "2",
      "description": "Articles provided for in chapter 89",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1090",
      "rawHtsCode": "9801.00.10.90",
      "superior": null,
      "indent": "2",
      "description": "Articles provided for in chapter 90",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1092",
      "rawHtsCode": "9801.00.10.92",
      "superior": null,
      "indent": "3",
      "description": "Articles provided for in headings 9401, 9402 or 9403",
      "units": [
        "No."
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.1094",
      "rawHtsCode": "9801.00.10.94",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " The quantities reported should be in the units provided in chapters 1-97. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.1097",
      "rawHtsCode": "9801.00.10.97",
      "superior": null,
      "indent": "2",
      "description": "Articles provided for in chapter 97",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " The quantities reported should be in the units provided in chapters 1-97. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.1098",
      "rawHtsCode": "9801.00.10.98",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " The quantities reported should be in the units provided in chapters 1-97. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.1100",
      "rawHtsCode": "9801.00.11.00",
      "superior": null,
      "indent": "0",
      "description": "United States Government property, returned to the United States without having been advanced in value or improved in condition by any means while abroad, entered by the United States Government or a contractor to the United States Government, and certified by the importer as United States Government property",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.2000",
      "rawHtsCode": "9801.00.20.00",
      "superior": null,
      "indent": "0",
      "description": "Articles, previously imported, with respect to which the duty was paid upon such previous importation or which were previously free of duty pursuant to the Caribbean Basin Economic Recovery Act or Title V of the Trade Act of 1974, if (1) reimported, without having been advanced in value or improved in condition by any process of manufacture or other means while abroad, after having been exported under lease or similar use agreements, and (2) reimported by or for the account of the person who imported it into, and exported it from, the United States",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.2500",
      "rawHtsCode": "9801.00.25.00",
      "superior": null,
      "indent": "0",
      "description": "Articles, previously imported, with respect to which the duty was paid upon such previous importation if (1) exported within three years after the date of such previous importation, (2) reimported without having been advanced in value or improved in condition by any process of manufacture or other means while abroad, (3) reimported for the reason that such articles do not conform to sample or specifications, and (4) reimported by or for the account of the person who imported them into, and exported them from, the United States",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.2600",
      "rawHtsCode": "9801.00.26.00",
      "superior": null,
      "indent": "0",
      "description": "Articles, previously imported, with respect to which the duty was paid upon such previous importation, if: (1) exported within 3 years after the date of such previous importation; (2) sold for exportation and exported to individuals for personal use; (3) reimported without having been advanced in value or improved in condition by any process of manufacture or other means while abroad; (4) reimported as personal returns from those individuals, whether or not consolidated with other personal returns prior to reimportation; and (5) reimported by or for the account of the person who exported them from the United States within 1 year of such exportation",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.3000",
      "rawHtsCode": "9801.00.30.00",
      "superior": null,
      "indent": "0",
      "description": "Any aircraft engine or propeller, or any part or accessory of either, previously imported, with respect to which the duty was paid upon such previous importation, if (1) reimported without having been advanced in value or improved in condition by any process of manufacture or other means while abroad, after having been exported under loan, lease or rent to an aircraft owner or operator as a temporary replacement for an aircraft engine being overhauled, repaired, rebuilt or reconditioned in the United States, and (2) reimported by or for the account of the person who exported it from the United States",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.40",
      "rawHtsCode": "9801.00.40",
      "superior": null,
      "indent": "1",
      "description": "Exhibition, examination or experimentation, for scientific or educational purposes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.50",
      "rawHtsCode": "9801.00.50",
      "superior": null,
      "indent": "1",
      "description": "Exhibition in connection with any circus or menagerie",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.60",
      "rawHtsCode": "9801.00.60",
      "superior": null,
      "indent": "1",
      "description": "Exhibition or use at any public exposition, fair or conference",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.65",
      "rawHtsCode": "9801.00.65",
      "superior": null,
      "indent": "1",
      "description": "Rendition of geophysical or contracting services in connection with the exploration for, or the extraction or development of, natural resources",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.7000",
      "rawHtsCode": "9801.00.70.00",
      "superior": null,
      "indent": "1",
      "description": "Aircraft exported from the United States with benefit of drawback or heading 9813.00.05",
      "units": [
        "kg"
      ],
      "generalRate": "A duty equal to the duty upon the importation of like articles not previously exported, but in no case in excess of the sum of (a) any customs drawback proved to have been allowed upon such exportation, and (b) the duty which would have been payable on any articles used in the manufacture or production of such aircraft had they not been entered and exported under heading 9813.00.05",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "A duty equal to the duty upon the importation of like articles not previously exported, but in no case in excess of the sum of (a) any customs drawback proved to have been allowed upon such exportation, and (b) the duty which would have been payable on any articles used in the manufacture or production of such aircraft had they not been entered and exported under heading 9813.00.05",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9801.00.80",
      "rawHtsCode": "9801.00.80",
      "superior": null,
      "indent": "1",
      "description": "Other, except articles excluded by U.S. note 1(c) of this subchapter",
      "units": [],
      "generalRate": "A duty (in lieu of any other duty or tax) equal to the sum of any duty and internal- revenue tax imposed upon the importation of like articles not previously exported, but in no case in excess of the sum of (a) any customs drawback proved to have been allowed upon such exportation of the article, and (b) any internal- revenue tax imposed, at the time such article is entered, upon the importation of like articles not previously exported",
      "specialRate": "Free (AU,BH, CL,CO,IL,JO, KR,MA, OM,P,PA,PE,S, SG)",
      "otherRate": "A duty (in lieu of any other duty or tax) equal to the sum of any duty and internal- revenue tax imposed upon the importation of like articles not previously exported, but in no case in excess of the sum of (a) any customs drawback proved to have been allowed upon such exportation of the article, and (b) any internal- revenue tax imposed, at the time such article is entered, upon the importation of like articles not previously exported",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9801.00.8010",
      "rawHtsCode": "9801.00.80.10",
      "superior": null,
      "indent": "2",
      "description": "Nonalcoholic beer provided for in subheading 2202.91.00",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.8020",
      "rawHtsCode": "9801.00.80.20",
      "superior": null,
      "indent": "2",
      "description": "Alcohol provided for in headings 2203, 2204, 2205, 2206, 2207, and 2208",
      "units": [
        "liters"
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.8030",
      "rawHtsCode": "9801.00.80.30",
      "superior": null,
      "indent": "2",
      "description": "Tobacco and tobacco products provided for in chapter 24",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " The quantities reported should be in the units provided in chapters 1-97. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.8040",
      "rawHtsCode": "9801.00.80.40",
      "superior": null,
      "indent": "2",
      "description": "Cigarette paper provided for in heading 4813",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " The quantities reported should be in the units provided in chapters 1-97. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.8090",
      "rawHtsCode": "9801.00.80.90",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " The quantities reported should be in the units provided in chapters 1-97. "
      ],
      "flags": []
    },
    {
      "htsCode": "9801.00.8500",
      "rawHtsCode": "9801.00.85.00",
      "superior": null,
      "indent": "0",
      "description": "Professional books, implements, instruments, and tools of trade, occupation, or employment, when returned to the United States after having been exported for use temporarily abroad, if imported by or for the account of the person who exported such items",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9801.00.9000",
      "rawHtsCode": "9801.00.90.00",
      "superior": null,
      "indent": "0",
      "description": "Animals, domesticated, straying across the boundary line into any foreign country, or driven across such boundary line by the owner for temporary pasturage purpose only, together with their offspring; all the foregoing if brought back to the United States within 8 months",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9802.00.2000",
      "rawHtsCode": "9802.00.20.00",
      "superior": null,
      "indent": "0",
      "description": "Photographic films and dry plates manufactured in the United States (except motion-picture films to be used for commercial purposes) and exposed abroad, whether developed or not",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9802.00.40",
      "rawHtsCode": "9802.00.40",
      "superior": null,
      "indent": "2",
      "description": "Repairs or alterations made pursuant to a warranty",
      "units": [],
      "generalRate": "A duty upon the value of the repairs or alterations (see U.S. note 3 of this subchapter)",
      "specialRate": "Free (AU,B,BH,C,CL,CO,IL,JO, KR,MA,OM, P,PA,PE,S,SG)",
      "otherRate": "A duty upon the value of the repairs or alterations (see U.S. note 3 of this subchapter)",
      "quotaQuantity": null,
      "footnotesText": [
        "  See 9903.88.01 and 9903.88.02   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9802.00.4020",
      "rawHtsCode": "9802.00.40.20",
      "superior": null,
      "indent": "3",
      "description": "Internal combustion engines",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 2."
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.4040",
      "rawHtsCode": "9802.00.40.40",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 2."
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.50",
      "rawHtsCode": "9802.00.50",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "A duty upon the value of the repairs or alterations (see U.S. note 3 of this subchapter)",
      "specialRate": "Free (AU,BH,CL, CO,IL,JO,KR,MA,OM,P,PA, PE,S,SG) A duty upon the value of the repairs or alterations (see U.S. note 3 of this subchapter) (B,C)",
      "otherRate": "A duty upon the value of the repairs oralterations (see U.S. note 3 of this subchapter)",
      "quotaQuantity": null,
      "footnotesText": [
        " See 9903.88.01 and 9903.88.02 "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9802.00.5010",
      "rawHtsCode": "9802.00.50.10",
      "superior": null,
      "indent": "3",
      "description": "Articles for which duty free treatment is claimed under U.S. note 2(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See subchapter II statistical note 2."
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.5030",
      "rawHtsCode": "9802.00.50.30",
      "superior": null,
      "indent": "4",
      "description": "Internal combustion engines",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 2."
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.5060",
      "rawHtsCode": "9802.00.50.60",
      "superior": null,
      "indent": "4",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 2."
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.6000",
      "rawHtsCode": "9802.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Any article of metal (as defined in U.S. note 3(e) of this subchapter) manufactured in the United States or subjected to a process of manufacture in the United States, if exported for further processing, and if the exported article as processed outside the United States, or the article which results from the processing outside the United States, is returned to the United States for further processing",
      "units": [],
      "generalRate": "A duty upon the value of such processing outside the United States (see U.S. note 3 of this subchapter)",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,SG) A duty upon the value of such processing outside the United States (see U.S. note 3 of this subchapter) (B,C)",
      "otherRate": "A duty upon the value of such processing outside the United States (see U.S. note 3 of this subchapter)",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 2. ",
        " See subchapter II statistical note 1. ",
        " See 9903.88.01 and 9903.88.02 "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9802.00.80",
      "rawHtsCode": "9802.00.80",
      "superior": null,
      "indent": "0",
      "description": "Articles, except goods of heading 9802.00.91 and goods imported under provisions of subchapter XIX of this chapter and goods imported under provisions of subchapter XX, assembled abroad in whole or in part of fabricated components, the product of the United States, which (a) were exported in condition ready for assembly without further fabrication, (b) have not lost their physical identity in such articles by change in form, shape or otherwise, and (c) have not been advanced in value or improved in condition abroad except by being assembled and except by operations incidental to the assembly process such as cleaning, lubricating and painting",
      "units": [],
      "generalRate": "A duty upon the full value of the imported article, less the cost or value of such products of the United States (see U.S. Note 4 of this subchapter)",
      "specialRate": "Free (AU,BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S,SG) A duty upon the full value of the imported article, less the cost or value of such products of the United States (see U.S. note 4 of this subchapter) (B,C,E)",
      "otherRate": "A duty upon the full value of the imported article, less the cost or value of such products of the United States (see U.S. note 4 of this subchapter)",
      "quotaQuantity": null,
      "footnotesText": [
        " See 9903.88.01 and 9903.88.02 "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9802.00.8015",
      "rawHtsCode": "9802.00.80.15",
      "superior": null,
      "indent": "1",
      "description": "Articles eligible pursuant to bilateral textile agreements for entry under a Special Access Program and entered in compliance with procedures established by the Committee for the Implementation of Textile Agreements (CITA)",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 2.",
        "See subchapter II statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.8016",
      "rawHtsCode": "9802.00.80.16",
      "superior": null,
      "indent": "1",
      "description": "Articles eligible pursuant to bilateral textile agreements for entry under the Outward Processing Programs and entered in compliance with procedures established by the Committee for the Implementation of Textile Agreements (CITA)",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 2.",
        "See subchapter II statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.8040",
      "rawHtsCode": "9802.00.80.40",
      "superior": null,
      "indent": "1",
      "description": "Articles for which duty free treatment is claimed under U.S. note 2(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See subchapter II statistical note 2."
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.8042",
      "rawHtsCode": "9802.00.80.42",
      "superior": null,
      "indent": "1",
      "description": "Articles for which duty free treatment is claimed under U.S. note 7(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See subchapter II statistical note 2. "
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.8044",
      "rawHtsCode": "9802.00.80.44",
      "superior": null,
      "indent": "1",
      "description": "Articles for which duty free treatment is claimed under U.S. note 7(b)(i) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See subchapter II statistical note 2."
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.8046",
      "rawHtsCode": "9802.00.80.46",
      "superior": null,
      "indent": "1",
      "description": "Articles for which duty free treatment is claimed under U.S. note 7(b)(ii) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See subchapter II statistical note 2."
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.8048",
      "rawHtsCode": "9802.00.80.48",
      "superior": null,
      "indent": "1",
      "description": "Articles for which duty free treatment is claimed under U.S. note 7(c) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See subchapter II statistical note 2."
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.8069",
      "rawHtsCode": "9802.00.80.69",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 2. ",
        " See subchapter II statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9802.00.9100",
      "rawHtsCode": "9802.00.91.00",
      "superior": null,
      "indent": "0",
      "description": "Textile and apparel goods, assembled in Mexico in which all fabric components, excluding visible lining fabrics, were wholly formed and cut in the United States, provided that such fabric components, in whole or in part, (a) were exported in condition ready for assembly without further fabrication, (b) have not lost their physical identity in such articles by change in form, shape or otherwise, and (c) have not been advanced in value or improved in condition abroad except by being assembled and except by operations incidental to the assembly process; provided that the goods classifiable in chapters 61, 62 or 63 may have been subject to bleaching, garment dyeing, stone-washing, acid-washing or perma-pressing after assembly",
      "units": [
        "\n"
      ],
      "generalRate": "",
      "specialRate": "Free (See U.S. note 4 of this subchapter)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 2. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9803.00.50",
      "rawHtsCode": "9803.00.50",
      "superior": null,
      "indent": "0",
      "description": "Substantial containers and holders, if products of the United States (including shooks and staves of United States production when returned as boxes or barrels containing merchandise), or if of foreign production and previously imported and duty (if any) thereon paid, or if of a class specified by the Secretary of the Treasury as instruments of international traffic, repair components for containers of foreign production which are instruments of international traffic, and accessories and equipment for such containers, whether the accessories and equipment are imported with a container to be reexported separately or with another container, or imported separately to be reexported with a container",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.05",
      "rawHtsCode": "9804.00.05",
      "superior": null,
      "indent": "1",
      "description": "Books, libraries, usual and reasonable furniture and similar household effects, if actually used abroad by him or by him and his family not less than one year, and not intended for any other person, or for sale",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.10",
      "rawHtsCode": "9804.00.10",
      "superior": null,
      "indent": "1",
      "description": "Professional books, implements, instruments and tools of trade, occupation or employment, which have been taken abroad by him or for his account",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.15",
      "rawHtsCode": "9804.00.15",
      "superior": null,
      "indent": "1",
      "description": "Professional books, implements, instruments and tools of trade, occupation or employment (not including theatrical scenery, properties or apparel, and not including articles for use in any manufacturing establishment, for any other person or for sale), owned and used by him abroad",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.20",
      "rawHtsCode": "9804.00.20",
      "superior": null,
      "indent": "1",
      "description": "Wearing apparel, articles of personal adornment, toilet articles and similar personal effects; all the foregoing, if actually owned by and in the possession of such person abroad at the time of or prior to his departure for the United States, and if appropriate for his own personal use and intended only for such use and not for any other person nor for sale",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.25",
      "rawHtsCode": "9804.00.25",
      "superior": null,
      "indent": "1",
      "description": "Not over 50 cigars, or 200 cigarettes, or 2 kilograms of smoking tobacco or a proportionate amount of each, and not over 1 liter of alcoholic beverages, when brought in by an adult nonresident for his own consumption",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.30",
      "rawHtsCode": "9804.00.30",
      "superior": null,
      "indent": "1",
      "description": "Not exceeding $100 in value of articles (not including alcoholic beverages and cigarettes but including not more than 100 cigars) accompanying such person to be disposed of by him as bona fide gifts, if such person has not claimed an exemption under this subheading 9804.00.30 within the 6 months immediately preceding his arrival and he intends to remain in the United States for not less than 72 hours",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.35",
      "rawHtsCode": "9804.00.35",
      "superior": null,
      "indent": "1",
      "description": "Automobiles, trailers, aircraft, motorcycles, bicycles, baby carriages, boats, horse-drawn conveyances, horses and similar means of transportation, and the usual equipment accompanying the foregoing; any of the foregoing imported in connection with the arrival of such person and to be used in the United States only for the transportation of such person, his family and guests, and such incidental carriage of articles as may be appropriate to his personal use of the conveyance",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.40",
      "rawHtsCode": "9804.00.40",
      "superior": null,
      "indent": "1",
      "description": "Not exceeding $200 in value of articles (including not more than 4 liters of alcoholic beverages) accompanying such a person who is in transit to a place outside United States customs territory and who will take the articles with him to such place",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.45",
      "rawHtsCode": "9804.00.45",
      "superior": null,
      "indent": "1",
      "description": "All personal and household effects taken abroad by him or for his account",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.50",
      "rawHtsCode": "9804.00.50",
      "superior": null,
      "indent": "1",
      "description": "Articles of metal (including medals, trophies and prizes), bestowed upon him abroad, as honorary distinctions, by foreign countries or citizens of foreign countries",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.55",
      "rawHtsCode": "9804.00.55",
      "superior": null,
      "indent": "1",
      "description": "Game animals (including birds and fish) killed abroad by him and imported by him for noncommercial purposes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.60",
      "rawHtsCode": "9804.00.60",
      "superior": null,
      "indent": "1",
      "description": "Automobiles rented by any resident of the United States while abroad and imported for the transportation of such resident, his family and guests, and such incidental carriage of articles as may be appropriate to his personal use of the automobile",
      "units": [],
      "generalRate": "Free, for such temporary periods as the Secretary of the Treasury by regulation may prescribe",
      "specialRate": "Free (BH,CL, CO,IL,KR,MA, P,PA,PE,S,SG)",
      "otherRate": "Free, for such temporary periods as the Secretary of the Treasury by regulation may prescribe",
      "quotaQuantity": null,
      "footnotesText": [
        "  See chapter 98 statistical note 1.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9804.00.65",
      "rawHtsCode": "9804.00.65",
      "superior": null,
      "indent": "2",
      "description": "Articles, accompanying a person, not over $800 in aggregate fair retail value in the country of acquisition, including (but only in the case of an individual who has attained the age of 21) not more than 1 liter of alcoholic beverages and including not more than 200 cigarettes and 100 cigars",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.70",
      "rawHtsCode": "9804.00.70",
      "superior": null,
      "indent": "2",
      "description": "Articles whether or not accompanying a person, not over $1600 in aggregate fair market value in the country of acquisition, including:(a) but only in the case of an individual who has attained the age of 21, not more than 5 liters of alcoholic beverages, not more than 1 liter of which shall have been acquired elsewhere than in American Samoa, Guam or the Virgin Islands of the United States, and not more than 4 liters of which shall have been produced elsewhere than in such insular possessions, and (b) not more than 1,000 cigarettes, not more than 200 of which shall have been acquired elsewhere than in such insular possessions, and not more than 100 cigars, if such person arrives directly or indirectly from such insular possessions, not more than $800 of which shall have been acquired elsewhere than in such insular possessions (but this subheading does not permit the entry of articles not accompanying a person which were acquired elsewhere than in such insular possessions)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.72",
      "rawHtsCode": "9804.00.72",
      "superior": null,
      "indent": "2",
      "description": "Articles whether or not accompanying a person, not over $800 in aggregate fair market value in the country of acquisition, including- (a) but only in the case of an individual who has attained the age of 21, not more than 1 liter of alcoholic beverages or not more than 2 liters if at least one liter is the product of one or more beneficiary countries, and (b) not more than 200 cigarettes, and not more than 100 cigars, if such person arrives directly from a beneficiary country (but this item does not permit the entry of articles not accompanying a person which were acquired elsewhere than in beneficiary countries)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.75",
      "rawHtsCode": "9804.00.75",
      "superior": null,
      "indent": "1",
      "description": "Any article imported to replace a like article of comparable value previously exempted from duty under subheading 9804.00.70, if the article previously exempted shall have been exported, under such supervision as the Secretary may prescribe, within 60 days after its importation because it was found by the importer to be unsatisfactory",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.80",
      "rawHtsCode": "9804.00.80",
      "superior": null,
      "indent": "0",
      "description": "Articles (including not over 50 cigars, or 300 cigarettes, or 2 kilograms of smoking tobacco or a proportionate amount of each, and not over 1 liter of alcoholic beverages), reasonable and appropriate, and intended exclusively, for the bona fide personal use of, and (except for articles consumed in use) to be taken out of the United States by, any person arriving in the United States who is leaving a vessel, vehicle or aircraft, engaged in international traffic, on which he is employed, with the intention of resuming such employment",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9804.00.85",
      "rawHtsCode": "9804.00.85",
      "superior": null,
      "indent": "0",
      "description": "Personal and household effects, not stock in trade, the title to which at the time of importation is in the estate of a citizen of the United States who died abroad",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9805.00.50",
      "rawHtsCode": "9805.00.50",
      "superior": null,
      "indent": "0",
      "description": "The personal and household effects (with such limitation on the importation of alcoholic beverages and tobacco products as the Secretary of the Treasury may prescribe) of any person in the service of the United States who returns to the United States upon the termination of assignment to extended duty (as defined in regulations issued in connection with this provision) at a post or station outside the customs territory of the United States, or of returning members of his family who have resided with him at such post or station, or of any person evacuated to the United States under Government orders or instructions",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9806.00.05",
      "rawHtsCode": "9806.00.05",
      "superior": null,
      "indent": "1",
      "description": "Upon the request of the Department of State, ambassadors, ministers, charge d'affaires, secretaries, counselors, attaches and other representatives, officers and employees of foreign governments, accredited to the United States or en route to or from other countries to which accredited, and their immediate families, suites and servants",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9806.00.10",
      "rawHtsCode": "9806.00.10",
      "superior": null,
      "indent": "1",
      "description": "Upon the request of the Department of State, diplomatic couriers of foreign governments",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9806.00.15",
      "rawHtsCode": "9806.00.15",
      "superior": null,
      "indent": "1",
      "description": "Upon the request of the Department of State, representatives of foreign governments in or to, and officers and employees of, organizations designated by the President of the United States as public international organizations pursuant to section 1 of the International Organizations Immunities Act (22 U.S.C. 288), and their immediate families, suites and servants",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9806.00.20",
      "rawHtsCode": "9806.00.20",
      "superior": null,
      "indent": "1",
      "description": "Persons on duty in the United States as members of the armed forces of any foreign country and their immediate families",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9806.00.25",
      "rawHtsCode": "9806.00.25",
      "superior": null,
      "indent": "1",
      "description": "Upon the request of the Department of State, persons designated by the Department of State as high officials of foreign governments or distinguished foreign visitors and their immediate families",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9806.00.30",
      "rawHtsCode": "9806.00.30",
      "superior": null,
      "indent": "1",
      "description": "Upon the request of the Department of State, persons designated pursuant to statute or pursuant to treaties ratified by the United States Senate",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9806.00.35",
      "rawHtsCode": "9806.00.35",
      "superior": null,
      "indent": "0",
      "description": "Upon the request of the Department of State, personal effects and equipment of groups or delegations of foreign residents arriving in the United States on goodwill visits of short duration to participate in patriotic celebrations, festivals and other demonstrations of public interest and which will be exported or destroyed at the conclusion of the visit",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9806.00.40",
      "rawHtsCode": "9806.00.40",
      "superior": null,
      "indent": "1",
      "description": "Upon the request of the Department of State, ambassadors, ministers, charge d'affaires, secretaries, counselors and attaches of foreign embassies and legations",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9806.00.45",
      "rawHtsCode": "9806.00.45",
      "superior": null,
      "indent": "1",
      "description": "Members of the armed forces of any foreign country",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9806.00.50",
      "rawHtsCode": "9806.00.50",
      "superior": null,
      "indent": "1",
      "description": "Upon the request of the Department of State, other representatives, officers and employees of foreign governments",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9806.00.55",
      "rawHtsCode": "9806.00.55",
      "superior": null,
      "indent": "1",
      "description": "Upon the request of the Department of State, persons designated pursuant to statute or pursuant to treaties ratified by the United States Senate",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9807.00.40",
      "rawHtsCode": "9807.00.40",
      "superior": null,
      "indent": "0",
      "description": "Articles of metal (including medals, trophies and prizes), for bestowal on persons in the United States, as honorary distinctions, by foreign countries or citizens of foreign countries",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9807.00.50",
      "rawHtsCode": "9807.00.50",
      "superior": null,
      "indent": "0",
      "description": "Upon the request of the Department of State, articles from citizens of foreign countries for presentation to the President or Vice President of the United States",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9808.00.1000",
      "rawHtsCode": "9808.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Engravings, etchings, photographic prints, whether bound or unbound, recorded video tapes and exposed photographic films (including motion-picture films) whether or not developed; official government publications in the form of microfilm, microfiches, or similar film media",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9808.00.2000",
      "rawHtsCode": "9808.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Sound recordings and recorded video tapes for use by it in the program authorized by the United States Information and Educational Exchange Act of 1948 (22 U.S.C. 1431-1479)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9808.00.3000",
      "rawHtsCode": "9808.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Materials certified to the Commissioner of Customs by the authorized procuring agencies to be emergency war material purchased abroad",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See subchapter VIII statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9808.00.4000",
      "rawHtsCode": "9808.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Materials certified by it to the Commissioner of Customs to be strategic and critical materials procured under the Strategic and Critical Materials Stock Piling Act (50 U.S.C. 98-98h)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See subchapter VIII statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9808.00.5000",
      "rawHtsCode": "9808.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Materials certified by it to the Commissioner of Customs to be source materials the entry of which is necessary in the interest of the common defense and security",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See subchapter VIII statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9808.00.6000",
      "rawHtsCode": "9808.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Plants, seeds and all other material for planting",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9808.00.7000",
      "rawHtsCode": "9808.00.70.00",
      "superior": null,
      "indent": "1",
      "description": "Materials certified by it to the Commissioner of Customs to be strategic materials acquired by that agency as a result of barter or exchange of agricultural commodities or products",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See subchapter VIII statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9808.00.8000",
      "rawHtsCode": "9808.00.80.00",
      "superior": null,
      "indent": "1",
      "description": "Goods certified by it to the Commissioner of Customs to be imported for the use of the National Aeronautics and Space Administration or for the implementation of an international program of the National Aeronautics and Space Administration, including articles to be launched into space and parts thereof, ground support equipment and uniquely associated equipment for use in connection with an international program of the National Aeronautics and Space Administration, including launch services agreements",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9809.00.10",
      "rawHtsCode": "9809.00.10",
      "superior": null,
      "indent": "0",
      "description": "Public documents, whether or not in the form of microfilm, microfiches, or similar film media (including exposed and developed motion picture and other films, recorded video tapes and sound recordings) issued essentially at the instance and expense of a foreign government, of a political subdivision of a foreign country or of an international organization the membership of which includes two or more foreign countries",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9809.00.20",
      "rawHtsCode": "9809.00.20",
      "superior": null,
      "indent": "1",
      "description": "Upon the request of the Department of State, office supplies and equipment and other articles for the official use of representatives of foreign governments or of personnel of public international organizations, on duty in the United States",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9809.00.30",
      "rawHtsCode": "9809.00.30",
      "superior": null,
      "indent": "1",
      "description": "Articles for the official use of members of the armed forces of any foreign country on duty in the United States",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9809.00.40",
      "rawHtsCode": "9809.00.40",
      "superior": null,
      "indent": "1",
      "description": "Articles which, while in the United States, will remain the property of such government or of such organization and will be used only in connection with noncommercial functions of such government or of such organization, including exhibitions which are sponsored by or participated in by such government or such organization and which are not commercial in character or connected with commercial undertakings",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9809.00.50",
      "rawHtsCode": "9809.00.50",
      "superior": null,
      "indent": "1",
      "description": "Prosthetic appliances furnished by a foreign government to former members of its armed forces who reside in the United States",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9809.00.60",
      "rawHtsCode": "9809.00.60",
      "superior": null,
      "indent": "1",
      "description": "Headstones furnished by a foreign government for graves of its war veterans buried in the United States",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9809.00.70",
      "rawHtsCode": "9809.00.70",
      "superior": null,
      "indent": "1",
      "description": "Articles for presentation as gifts to the United States Government, to any State or local government or to any public institution organized in the United States",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9809.00.80",
      "rawHtsCode": "9809.00.80",
      "superior": null,
      "indent": "1",
      "description": "Printed matter, not containing advertising matter, for free distribution",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9810.00.0500",
      "rawHtsCode": "9810.00.05.00",
      "superior": null,
      "indent": "1",
      "description": "Drawings, engravings, etchings, lithographs, woodcuts, sound recordings, recorded video tapes and photographic and other prints, all the foregoing whether bound or unbound, and exposed photographic films (including motion-picture films) whether or not developed",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.1000",
      "rawHtsCode": "9810.00.10.00",
      "superior": null,
      "indent": "1",
      "description": "Painted, colored or stained glass windows and parts thereof, all the foregoing valued over $161 per square meter and designed by, and produced by or under the direction of, a professional artist",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.1500",
      "rawHtsCode": "9810.00.15.00",
      "superior": null,
      "indent": "1",
      "description": "Regalia",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.2000",
      "rawHtsCode": "9810.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Hand-woven fabrics, to be used by the institution in making religious vestments for its own use or for sale",
      "units": [
        "m<sup>2</sup>"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.2500",
      "rawHtsCode": "9810.00.25.00",
      "superior": null,
      "indent": "1",
      "description": "Altars, pulpits, communion tables, baptismal fonts, shrines, mosaics, iconostases, or parts, appurtenances or adjuncts of any of the foregoing, whether to be physically joined thereto or not, and statuary (except granite or marble cemetery headstones, granite or marble grave markers and granite or marble feature memorials, and except casts of plaster of Paris, or of compositions of paper or papier-mâché)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.3000",
      "rawHtsCode": "9810.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "Drawings and plans, reproductions thereof, engravings, etchings, lithographs, woodcuts, globes, sound recordings, recorded video tapes and photographic and other prints, all the foregoing whether bound or unbound, and exposed photographic films (including motion-picture films) whether or not developed",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.3500",
      "rawHtsCode": "9810.00.35.00",
      "superior": null,
      "indent": "1",
      "description": "Letters, numbers, and other symbols; number cards and other arithmetical materials; printed matter; blocks and other dimensional shapes; geometrical figures, plane or solid; geographical globes; tuned bells and basic materials for understanding music; model articles and figures of animate objects; puzzles and games; flags; dressing frames; dummy clocks; bottles, boxes, and other containers or holders; all the foregoing, whether or not in sets, fabricated to specification and designed for the classroom instruction of children; and containers or holders fabricated to specification and designed for the storage of such instructional articles when not in use",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable in the absence of this subheading",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.4000",
      "rawHtsCode": "9810.00.40.00",
      "superior": null,
      "indent": "1",
      "description": "Sculptures and statuary",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.4500",
      "rawHtsCode": "9810.00.45.00",
      "superior": null,
      "indent": "1",
      "description": "Regalia",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.5000",
      "rawHtsCode": "9810.00.50.00",
      "superior": null,
      "indent": "1",
      "description": "Any textile machine or machinery or part thereof, solely for the instruction of students",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.5500",
      "rawHtsCode": "9810.00.55.00",
      "superior": null,
      "indent": "1",
      "description": "Patterns and models exclusively for exhibition or educational use at any such institution",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.6000",
      "rawHtsCode": "9810.00.60.00",
      "superior": null,
      "indent": "1",
      "description": "Instruments and apparatus, if no instrument or apparatus of equivalent scientific value for the purposes for which the instrument or apparatus is intended to be used is being manufactured in the United States (see U.S. note 6 to this subchapter)",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.6500",
      "rawHtsCode": "9810.00.65.00",
      "superior": null,
      "indent": "1",
      "description": "Repair components for instruments or apparatus admitted under subheading 9810.00.60",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.6700",
      "rawHtsCode": "9810.00.67.00",
      "superior": null,
      "indent": "1",
      "description": "Tools specially designed to be used for the maintenance, checking, gauging or repair of instruments or apparatus admitted under subheading 9810.00.60",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.7000",
      "rawHtsCode": "9810.00.70.00",
      "superior": null,
      "indent": "0",
      "description": "Wild animals (including birds and fish) imported for use, or for sale for use, in any scientific public collection for exhibition for scientific or educational purposes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.7500",
      "rawHtsCode": "9810.00.75.00",
      "superior": null,
      "indent": "1",
      "description": "Lifeboats and life-saving apparatus",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.8000",
      "rawHtsCode": "9810.00.80.00",
      "superior": null,
      "indent": "1",
      "description": "Apparatus utilizing any radioactive substance in medical diagnosis or therapeutic treatment, including the radioactive material itself when contained in the apparatus as an integral element thereof, and parts or accessories of any of the foregoing",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.8500",
      "rawHtsCode": "9810.00.85.00",
      "superior": null,
      "indent": "0",
      "description": "Cellulosic plastics materials imported for use in artificial kidney machines or apparatus by a hospital or by a patient pursuant to prescription of a physician",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable in the absence of this heading",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.9000",
      "rawHtsCode": "9810.00.90.00",
      "superior": null,
      "indent": "0",
      "description": "Prayer shawls, bags for the keeping of prayer shawls and headwear of a kind used for public or private religious observances, whether or not any of the foregoing is imported for the use of a religious institution",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9810.00.9500",
      "rawHtsCode": "9810.00.95.00",
      "superior": null,
      "indent": "0",
      "description": "Scrolls or tablets of wood or paper, commonly known as Gohonzon, imported for use in public or private religious observances, whether or not any of the foregoing is imported for the use of a religious institution",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9811.00.20",
      "rawHtsCode": "9811.00.20",
      "superior": null,
      "indent": "0",
      "description": "Alcoholic beverage samples (each sample containing not more than 300 milliliters if a malt beverage, not more than 150 milliliters if a wine and not more than 100 milliliters if any other alcoholic beverage) to be used in the United States only for soliciting orders by persons importing alcoholic beverages in commercial quantities",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9811.00.40",
      "rawHtsCode": "9811.00.40",
      "superior": null,
      "indent": "0",
      "description": "Samples of tobacco products, and cigarette papers and tubes (each sample consisting of not more than (a) 3 cigars, (b) 3 cigarettes, (c) 3.5 grams of tobacco, (d) 3.5 grams of snuff, (e) 3 cigarette tubes or (f) 25 cigarette papers) to be used in the United States only for soliciting orders by persons importing tobacco products, cigarette papers or cigarette tubes in commercial quantities",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9811.00.60",
      "rawHtsCode": "9811.00.60",
      "superior": null,
      "indent": "0",
      "description": "Any sample (except samples covered by heading 9811.00.20 or 9811.00.40), valued not over $1 each, or marked, torn, perforated or otherwise treated so that it is unsuitable for sale or for use otherwise than as a sample, to be used in the United States only for soliciting orders for products of foreign countries",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9812.00.2000",
      "rawHtsCode": "9812.00.20.00",
      "superior": null,
      "indent": "0",
      "description": "Articles imported for exhibition by any institution or society established for the encouragement of agriculture, arts, education or science, or for such exhibition by any State or for a municipal corporation",
      "units": [
        "kg"
      ],
      "generalRate": "Free, under bond, as prescribed in U.S. note 2 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 2 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9812.00.4000",
      "rawHtsCode": "9812.00.40.00",
      "superior": null,
      "indent": "0",
      "description": "Articles imported by any institution, society or State, or for a municipal corporation, for the purpose of erecting a public monument",
      "units": [
        "kg"
      ],
      "generalRate": "Free, under bond, as prescribed in U.S. note 2 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 2 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.05",
      "rawHtsCode": "9813.00.05",
      "superior": null,
      "indent": "0",
      "description": "Articles to be repaired, altered or processed (including processes which result in articles manufactured or produced in the United States)",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        " See 9903.55.01. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.0520",
      "rawHtsCode": "9813.00.05.20",
      "superior": null,
      "indent": "1",
      "description": "Articles to be processed into articles manufactured or produced in the United States",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See subchapter XIII statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9813.00.0540",
      "rawHtsCode": "9813.00.05.40",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See subchapter XIII statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9813.00.10",
      "rawHtsCode": "9813.00.10",
      "superior": null,
      "indent": "0",
      "description": "Models of women's wearing apparel imported by manufacturers for use solely as models in their own establishments",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.15",
      "rawHtsCode": "9813.00.15",
      "superior": null,
      "indent": "0",
      "description": "Articles imported by illustrators and photographers for use solely as models in their own establishments, in the illustrating of catalogues, pamphlets or advertising matters",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.20",
      "rawHtsCode": "9813.00.20",
      "superior": null,
      "indent": "0",
      "description": "Samples solely for use in taking orders for merchandise",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.25",
      "rawHtsCode": "9813.00.25",
      "superior": null,
      "indent": "0",
      "description": "Articles solely for examination with a view to reproduction, or for such examination and reproduction (except photoengraved printing plates for examination and reproduction); and motion-picture advertising films",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.30",
      "rawHtsCode": "9813.00.30",
      "superior": null,
      "indent": "0",
      "description": "Articles intended solely for testing, experimental or review purposes, including specifications, photographs and similar articles for use in connection with experiments or for study",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.35",
      "rawHtsCode": "9813.00.35",
      "superior": null,
      "indent": "0",
      "description": "Automobiles, motorcycles, bicycles, airplanes, airships, balloons, boats, racing shells and similar vehicles and craft, and the usual equipment of the foregoing; all the foregoing which are brought temporarily into the United States by nonresidents for the purpose of taking part in races or other specific contests",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH,CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.40",
      "rawHtsCode": "9813.00.40",
      "superior": null,
      "indent": "0",
      "description": "Locomotives and other railroad equipment brought temporarily into the United States for use in clearing obstructions, fighting fires or making emergency repairs on railroads within the United States, or for use in transportation otherwise than in international traffic when the Secretary of the Treasury finds that the temporary use of foreign railroad equipment is necessary to meet an emergency",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        "  See chapter 98 statistical note 1.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.45",
      "rawHtsCode": "9813.00.45",
      "superior": null,
      "indent": "0",
      "description": "Containers for compressed gases, filled or empty, and containers or other articles in use for covering or holding merchandise (including personal or household effects) during transportation and suitable for reuse for that purpose",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        "  See chapter 98 statistical note 1.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.50",
      "rawHtsCode": "9813.00.50",
      "superior": null,
      "indent": "0",
      "description": "Professional equipment, tools of trade, repair components for equipment or tools admitted under this heading and camping equipment; all the foregoing imported by or for nonresidents sojourning temporarily in the United Statesand for the use of such nonresidents",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        "  See chapter 98 statistical note 1.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.55",
      "rawHtsCode": "9813.00.55",
      "superior": null,
      "indent": "0",
      "description": "Articles of special design for temporary use exclusively in connection with the manufacture or production of articles for export",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        "  See chapter 98 statistical note 1.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.60",
      "rawHtsCode": "9813.00.60",
      "superior": null,
      "indent": "0",
      "description": "Animals and poultry brought into the United States for the purpose of breeding, exhibition or competition for prizes, and the usual equipment therefor",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        "  See chapter 98 statistical note 1.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.70",
      "rawHtsCode": "9813.00.70",
      "superior": null,
      "indent": "0",
      "description": "Works of the free fine arts, engravings, photographic pictures and philosophical and scientific apparatus brought into the United States by professional artists, lecturers or scientists arriving from abroad for use by them for exhibition and in illustration, promotion and encouragement of art, science or industry in the United States",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        "  See chapter 98 statistical note 1.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9813.00.75",
      "rawHtsCode": "9813.00.75",
      "superior": null,
      "indent": "0",
      "description": "Automobiles, automobile chassis, automobile bodies, cutaway portions of any of the foregoing and parts for any of the foregoing, finished, unfinished or cutaway, when intended solely for show purposes",
      "units": [],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        "  See chapter 98 statistical note 1.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9814.00.5000",
      "rawHtsCode": "9814.00.50.00",
      "superior": null,
      "indent": "0",
      "description": "Tea, tea waste and tea siftings and sweepings, all the foregoing to be used solely for manufacturing theine, caffeine or other chemical products whereby the identity and character of the original material is entirely destroyed or changed",
      "units": [
        "kg"
      ],
      "generalRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "specialRate": "Free (AU,BH, CL,IL,JO,KR, MA,OM, P,PA,PE,S,SG)",
      "otherRate": "Free, under bond, as prescribed in U.S. note 1 to this subchapter",
      "quotaQuantity": null,
      "footnotesText": [
        "  Carryover legal note from the Tariff Schedule of the United States (TSUS). The Tea Importation Act (21 U.S.C. 41) was repealed, effective April 9, 1996.    "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9815.00.2000",
      "rawHtsCode": "9815.00.20.00",
      "superior": null,
      "indent": "0",
      "description": "Products of American fisheries (including fish, shellfish and other marine animals, spermaceti and marine animal oils), which have not been landed in a foreign country, or which, if so landed, have been landed solely for transshipment without change in condition",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9815.00.4000",
      "rawHtsCode": "9815.00.40.00",
      "superior": null,
      "indent": "0",
      "description": "Fish (except cod, cusk, haddock, hake, mackerel, pollock and swordfish), the product of American fisheries, landed in a foreign country and there processed by removal of heads, viscera or fins, or by chilling or freezing, or by any combination of these processes, but not otherwise processed",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9815.00.6000",
      "rawHtsCode": "9815.00.60.00",
      "superior": null,
      "indent": "0",
      "description": "Products of American fisheries, prepared or preserved by an American fishery on the treaty coasts of Labrador, Magdalen Islands and Newfoundland, as such coasts are defined in the convention of 1818 between the United States and Great Britain",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9816.00.20",
      "rawHtsCode": "9816.00.20",
      "superior": null,
      "indent": "1",
      "description": "Accompanying a person, arriving in the United States (exclusive of duty-free articles and articles acquired in American Samoa, Guam or the Virgin Islands of the United States)",
      "units": [],
      "generalRate": "3 percent of the fair retail value",
      "specialRate": "Free (BH,CL,CO,IL,JO,KR,MA,OM,P,PA,PE,S, SG)",
      "otherRate": "4 percent of the fair retail value",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9816.00.40",
      "rawHtsCode": "9816.00.40",
      "superior": null,
      "indent": "1",
      "description": "Imported by or for the account of a person (whether or not accompanying him) arriving directly or indirectly from American Samoa, Guam or the Virgin Islands of the United States, acquired in such insular possessions as an incident of such person's physical presence",
      "units": [],
      "generalRate": "1.5 percent of the fair retail value",
      "specialRate": "Free (BH,CL, CO,IL,JO,KR,MA,S,SG)",
      "otherRate": "2 percent of the fair retail value",
      "quotaQuantity": null,
      "footnotesText": [
        "  See chapter 98 statistical note 1.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9817.00.2000",
      "rawHtsCode": "9817.00.20.00",
      "superior": null,
      "indent": "1",
      "description": "Monofilament gill nets to be used for fish sampling",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9817.00.3000",
      "rawHtsCode": "9817.00.30.00",
      "superior": null,
      "indent": "1",
      "description": "To be used in taking wild birds under license issued by an appropriate Federal or State governmental authority",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9817.00.4000",
      "rawHtsCode": "9817.00.40.00",
      "superior": null,
      "indent": "0",
      "description": "Developed photographic film, including motion-picture film on which pictures or sound and pictures have been recorded; photographic slides; transparencies; sound recordings; recorded video tape; models (except toy models); charts; maps; globes; and posters; all of the foregoing which are determined to be visual or auditory materials in accordance with U.S. note 1(a) of this subchapter",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9817.00.4200",
      "rawHtsCode": "9817.00.42.00",
      "superior": null,
      "indent": "1",
      "description": "Holograms for laser projection; microfilm, microfiches and similar articles",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9817.00.4400",
      "rawHtsCode": "9817.00.44.00",
      "superior": null,
      "indent": "1",
      "description": "Motion-picture films in any form on which pictures, or sound and pictures, have been recorded, whether or not developed",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9817.00.4600",
      "rawHtsCode": "9817.00.46.00",
      "superior": null,
      "indent": "1",
      "description": "Sound recordings, combination sound and visual recordings, and magnetic recordings; video discs, video tapes and similar articles",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9817.00.4800",
      "rawHtsCode": "9817.00.48.00",
      "superior": null,
      "indent": "1",
      "description": "Patterns and wall charts; globes; mock-ups or visualizations of abstract concepts such as molecular structures or mathematical formulae; materials for programmed instruction; and kits containing printed materials and audio materials or any combination of two or more of the foregoing",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9817.00.5000",
      "rawHtsCode": "9817.00.50.00",
      "superior": null,
      "indent": "0",
      "description": "Machinery, equipment and implements to be used for agricultural or horticultural purposes",
      "units": [
        ""
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable in the absence of this heading",
      "quotaQuantity": null,
      "footnotesText": [
        "  "
      ],
      "flags": []
    },
    {
      "htsCode": "9817.00.6000",
      "rawHtsCode": "9817.00.60.00",
      "superior": null,
      "indent": "0",
      "description": "Parts to be used in articles provided for in headings 8432, 8433, 8434 and 8436, whether or not such parts are principally used as parts of such articles and whether or not covered by a specific provision within the meaning of additional U.S. rule of interpretation 1(c)",
      "units": [
        ""
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable in the absence of this heading",
      "quotaQuantity": null,
      "footnotesText": [
        " See subchapter XVII statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9817.00.7000",
      "rawHtsCode": "9817.00.70.00",
      "superior": null,
      "indent": "0",
      "description": "Animals, game, imported to be liberated in the United States for stocking purposes",
      "units": [
        "No."
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9817.00.80",
      "rawHtsCode": "9817.00.80",
      "superior": null,
      "indent": "1",
      "description": "Articles of copper",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable in the absence of this subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": []
    },
    {
      "htsCode": "9817.00.90",
      "rawHtsCode": "9817.00.90",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9817.00.9040",
      "rawHtsCode": "9817.00.90.40",
      "superior": null,
      "indent": "2",
      "description": "Pigs, ingots or billets",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9817.00.9060",
      "rawHtsCode": "9817.00.90.60",
      "superior": null,
      "indent": "2",
      "description": "Relaying or rerolling rails",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9817.00.9080",
      "rawHtsCode": "9817.00.90.80",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9817.00.92",
      "rawHtsCode": "9817.00.92",
      "superior": null,
      "indent": "2",
      "description": "Books, music and pamphlets, in raised print, used exclusively by or for them",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9817.00.94",
      "rawHtsCode": "9817.00.94",
      "superior": null,
      "indent": "2",
      "description": "Braille tablets, cubarithms, and special apparatus, machines, presses, and types for their use or benefit exclusively",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9817.00.96",
      "rawHtsCode": "9817.00.96",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9817.00.9800",
      "rawHtsCode": "9817.00.98.00",
      "superior": null,
      "indent": "0",
      "description": "Theatrical scenery, properties and apparel brought into the United States by proprietors or managers of theatrical, ballet, opera or similar productions arriving from abroad for temporary use by them in such productions",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable in the absence of this heading",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9817.22.05",
      "rawHtsCode": "9817.22.05",
      "superior": null,
      "indent": "0",
      "description": "Rum, tafia, liqueurs and spirituous beverages, of a type classifiable in subheading 2208.40 or 2208.90 and described in U.S. note 6 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9817.29.01",
      "rawHtsCode": "9817.29.01",
      "superior": null,
      "indent": "0",
      "description": "Cyclic organic chemical products in any physical form having an aromatic or modified aromatic structure, however provided for in chapter 29 (but excluding 2,3-dihydroxynaphthalene-6-sulfonic acid, sodium salt), to be used in the manufacture of photographic color couplers; photographic color couplers (but excluding 2,3-dihydroxynaphthalene-6-sulfonic acid, sodium salt) (all the foregoing goods however provided for in chapter 29 or in subheading 3707.90.31, 3707.90.32 or 3707.90.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable in the absence of this heading",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9817.29.02",
      "rawHtsCode": "9817.29.02",
      "superior": null,
      "indent": "0",
      "description": "Methanol (Methyl alcohol) produced from natural gas aboard a vessel on the high seas or in foreign waters",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "46%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9817.57.01",
      "rawHtsCode": "9817.57.01",
      "superior": null,
      "indent": "0",
      "description": "Needle-craft display models, primarily hand stitched, of completed mass-produced kits (provided for in subheading 5701.10.40, 5701.10.90, 5701.90.20, 5805.00.25, 5805.00.40, 6302.91, 6302.93.10, 6302.93.20, 6302.99.20, 6303.19, 6303.92.10, 6303.92.20, 6303.99, 6304.92, 6304.93, 6304.99.15, 6304.99.35, 6304.99.60, 6307.90.85 or 6307.90.98).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable in the absence of this heading",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9817.60.0000",
      "rawHtsCode": "9817.60.00.00",
      "superior": null,
      "indent": "0",
      "description": "Any of the following articles not intended for sale or distribution to the public: personal effects of aliens who are participants in, officials of, or accredited members of delegations to, an international athletic event held in the United States, such as the Olympics and Paralympics, the Goodwill Games, the Special Olympics World Games, the World Cup Soccer Games, or any similar international athletic event as the Secretary of the Treasury may determine, and of persons who are immediate family members of or servants to any of the foregoing persons; equipment and materials imported in connection with any such foregoing event by or on behalf of the foregoing persons or the organizing committee of such an event, articles to be used in exhibitions depicting the culture of a country participating in such an event; and, if consistent with the foregoing, such other articles as the Secretary of the Treasury may allow",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "Free",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9817.61.01",
      "rawHtsCode": "9817.61.01",
      "superior": null,
      "indent": "0",
      "description": "Articles of ski racing apparel which, because of their padding, construction, or other special features, are specially designed to protect against injuries from the sport of ski racing, such as blows caused by slalom gates or falls (provided for in subheading 6101.30.20, 6105.20.20, 6110.11, 6110.12.20, 6110.19, 6110.20.20, 6110.30.30, 6112.20.10, 6114.30.30, 6203.43.15 or 6203.43.35)",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "Free (AU,BH,CL,CO,JO,KR,MA,OM,P,PA,PE,S,SG) The rate applicable in the absence of this heading (A,D,E,IL)",
      "otherRate": "The rate applicable in the absence of this heading",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9817.64.01",
      "rawHtsCode": "9817.64.01",
      "superior": null,
      "indent": "0",
      "description": "Footwear, other than goods of heading 9021, of a kind for supporting or holding the foot following an illness, operation or injury, provided that such footwear is (1) made to measure and (2) presented singly and not in pairs and designed to fit either foot equally",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable in the absence of this heading",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9817.82.01",
      "rawHtsCode": "9817.82.01",
      "superior": null,
      "indent": "0",
      "description": "Mounted tool and drill bit blanks of polycrystalline diamond (provided for in subheadings 8207.19.60, 8207.50.40 or 8207.50.80) and mounted tool blanks of polycrystalline diamond (provided for in subheadings 8207.70.60, 8207.80.60, 8207.90.45 or 8207.90.75",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable in the absence of this heading",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9817.84.01",
      "rawHtsCode": "9817.84.01",
      "superior": null,
      "indent": "0",
      "description": "Wheelbuilding, wheel-trueing, rimpunching, tire fitting and similar machines (provided for in subheading 8462.22, 8462.23, 8462.24, 8462.25, 8462.26, 8462.29, 8462.42, 8462.49, 8462.51, 8462.59, 8479.83, 8479.89.95, 8485.10.01 or 9031.80), all the foregoing suitable for use in the manufacture of wheels for bicycles",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable in the absence of this heading",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": []
    },
    {
      "htsCode": "9817.85.01",
      "rawHtsCode": "9817.85.01",
      "superior": null,
      "indent": "0",
      "description": "Prototypes to be used exclusively for development, testing, product evaluation, or quality control purposes",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "The rate applicable in the absence of this heading",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9817.95.01",
      "rawHtsCode": "9817.95.01",
      "superior": null,
      "indent": "1",
      "description": "Utilitarian articles of a kind used in the home in the performance of specific religious or cultural ritual celebrations for religious or cultural holidays, or religious festive occasions, such as Seder plates, blessing cups, menorahs or kinaras",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": []
    },
    {
      "htsCode": "9817.95.05",
      "rawHtsCode": "9817.95.05",
      "superior": null,
      "indent": "1",
      "description": "Utilitarian articles in the form of a three-dimensional representation of a symbol or motif clearly associated with a specific holiday in the United States",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "25%",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": []
    },
    {
      "htsCode": "9818.00.0100",
      "rawHtsCode": "9818.00.01.00",
      "superior": null,
      "indent": "1",
      "description": "Any equipment, or any part of equipment, purchased for, or the repair parts or materials employed in, or the expense of repairs made in a foreign country with respect to, a LASH (Lighter Aboard Ship) barge utilized as a cargo container, upon first arrival of such barge in any port of the United States",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50 percent of the cost of such goods or repairs",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9818.00.0300",
      "rawHtsCode": "9818.00.03.00",
      "superior": null,
      "indent": "1",
      "description": "Spare repair parts or materials (other than nets or nettings) which the owner or master of a vessel certifies are intended for use aboard a cargo vessel, for installation or use on such vessel, as needed, in the United States, at sea, or in a foreign country, but only if duty is or has been paid under this schedule upon first entry into the United States of each such spare part or material purchased in, or imported from, a foreign country",
      "units": [
        "kg"
      ],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "50 percent of the cost of such parts or materials",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9818.00.0500",
      "rawHtsCode": "9818.00.05.00",
      "superior": null,
      "indent": "1",
      "description": "Spare parts necessarily installed before first entry into the United States, upon first entry into the United States of each such spare part purchased in, or imported from, a foreign country",
      "units": [],
      "generalRate": "The rate applicable in the absence of this subheading on the cost of such parts",
      "specialRate": "Free (AU,BH,C,CL,CO,E,IL,JO,KR,MA,OM,P,PA,PE,S,SG)",
      "otherRate": "50 percent of the cost of such parts",
      "quotaQuantity": null,
      "footnotesText": [
        "  See statistical note 1 to this subchapter.   "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9818.00.0700",
      "rawHtsCode": "9818.00.07.00",
      "superior": null,
      "indent": "1",
      "description": "Other, upon first arrival in any port of the United States of any vessel described in U.S. note 1 to this subchapter",
      "units": [
        "kg"
      ],
      "generalRate": "50 percent of the cost of such goods or repairs",
      "specialRate": "Free (AU,BH,C,CL,CO,E,IL, JO,KR,MA, OM,P,PA,PE,S,SG)",
      "otherRate": "50 percent of the cost of such goods or repairs",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9819.11.03",
      "rawHtsCode": "9819.11.03",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles of chapter 61 or 62 sewn or otherwise assembled in one or more such countries (except the Republic of Rwanda) from fabrics wholly formed and cut, or from components knit-to-shape, in the United States, from yarns wholly formed in the United States, or both (including fabrics not formed from yarns, if such fabrics are classifiable in heading 5602 or 5603 and are wholly formed and cut in the United States), the foregoing which (1) are embroidered or were subjected to stone-washing, enzyme-washing, acid washing, permapressing, oven-baking, bleaching, garment-dyeing, screen printing or other similar processes, and (2) but for such embroidery or processing are of a type otherwise described in heading 9802.00.80 of the tariff schedule",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9819.11.06",
      "rawHtsCode": "9819.11.06",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles sewn or otherwise assembled in one or more such countries (except the Republic of Rwanda) with thread formed in the United States from fabrics wholly formed in the United States and cut in one or more such countries from yarns wholly formed in the United States, or from components knit-to-shape in the United States from yarns wholly formed in the United States, or both (including fabrics not formed from yarns, if such fabrics are classifiable under heading 5602 or 5603 of the tariff schedule and are wholly formed in the United States)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9819.11.09",
      "rawHtsCode": "9819.11.09",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles wholly assembled in one or more such countries (except the Republic of Rwanda) from fabric wholly formed in one or more such countries from yarn originating in either the United States or one or more such countries (including fabrics not formed from yarns, if such fabrics are classifiable under heading 5602 or 5603 and are wholly formed and cut in one or more such countries), or from components knit-to-shape in one or more such countries from yarns originating in the United States or one or more such countries or former beneficiary sub-Saharan African countries (as defined in U.S. note 3(d) to this subchapter), or both, or apparel articles wholly formed on seamless knitting machines in such a country from yarns originating in the United States or one or more such countries or former beneficiary sub-Saharan African countries (as defined in U.S. note 3(d) to this subchapter), or both, whether or not the apparel articles are also made from any of the fabrics, fabric components formed, or components knit-to-shape described in U.S. note 2(e) to this subchapter (unless the apparel articles are made exclusively from any of the fabrics, fabric components formed, or components knit-to-shape described in such U.S. note 2(e)), subject to the provisions of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9819.11.12",
      "rawHtsCode": "9819.11.12",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles wholly assembled, or knit-to-shape and wholly assembled, or both, in one or more such lesser developed countries (except the Republic of Rwanda) enumerated in U.S. note 2(d) to this subchapter, subject to the provisions of U.S. note 2 to this subchapter, regardless of the country of origin of the fabric or the yarn used to make such articles, if entered during the period beginning on the date announced in a Federal Register notice issued by the United States Trade Representative and continuing through September 30, 2025, inclusive",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9819.11.15",
      "rawHtsCode": "9819.11.15",
      "superior": null,
      "indent": "1",
      "description": "Sweaters, in chief weight of cashmere, knit-to-shape in one or more such countries (except the Republic of Rwanda), the foregoing classifiable in subheading 6110.12",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9819.11.18",
      "rawHtsCode": "9819.11.18",
      "superior": null,
      "indent": "1",
      "description": "Sweaters containing 50 percent or more by weight of wool measuring 21.5 microns in diameter or finer, knit-to-shape in one or more such countries (except the Republic of Rwanda).",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9819.11.21",
      "rawHtsCode": "9819.11.21",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles both cut (or knit-to-shape) and sewn or otherwise assembled in one or more such countries (except the Republic of Rwanda), to the extent that apparel articles of such fabrics or yarns would be eligible for the tariff treatment provided in general note 11 to the tariff schedule, without regard to the source of the fabrics or yarns",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9819.11.24",
      "rawHtsCode": "9819.11.24",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles both cut (or knit-to-shape) and sewn or otherwise assembled in one or more such countries (except the Republic of Rwanda) from fabrics or yarn designated by the appropriate U.S. government authority in the <u>Federal Register</u> as fabrics or yarn not available in commercial quantities in the United States, under any terms as such authority may provide",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9819.11.27",
      "rawHtsCode": "9819.11.27",
      "superior": null,
      "indent": "1",
      "description": "Handloomed, handmade, folklore articles (except apparel articles the product of the Republic of Rwanda) or ethnic printed fabrics, under the provisions of U.S. note 4 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9819.11.30",
      "rawHtsCode": "9819.11.30",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles sewn or otherwise assembled in one or more such countries (except the Republic of Rwanda) with thread formed in the United States, the foregoing (i) from components cut in the United States and in one or more such countries or former beneficiary sub-Saharan African countries (as defined in U.S. note 3(d) to this subchapter) from fabric wholly formed in the United States from yarns wholly formed in the United States (including fabrics not formed from yarns, if such fabrics are classifiable under heading 5602 or 5603 of the tariff schedule), or (ii) from components knit-to-shape in the United States and one or more such countries from yarns wholly formed in the United States, or (iii) from any combination of two or more of the foregoing knitting-to-shape or cutting operations",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9819.11.33",
      "rawHtsCode": "9819.11.33",
      "superior": null,
      "indent": "0",
      "description": "Textile articles classifiable under chapters 50 through 60, inclusive, or chapter 63 of the tariff schedule, the foregoing articles that are products of a lesser developed beneficiary sub-Saharan African country (as defined in U.S. note 2(d) to this subchapter) and are wholly formed in one or more such countries from fibers, yarns, fabrics, fabric components or components knit-to-shape that are the product of one or more such countries",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.11.03",
      "rawHtsCode": "9820.11.03",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles of chapter 61 or 62 sewn or otherwise assembled in one or more such countries from fabrics wholly formed and cut, or from components knit-to-shape, in the United States, from yarns wholly formed in the United States (including fabrics not formed from yarns, if such fabrics are classifiable in heading 5602 or 5603 and are wholly formed and cut in the United States), the foregoing which (1) are embroidered or were subjected to stone-washing, enzyme-washing, acid washing, permapressing, oven-baking, bleaching, garment-dyeing, screen printing or other similar processes, (2) but for such embroidery or processing are of a type otherwise described in heading 9802.00.80 of the tariff schedule, and (3) meet the requirements of U.S. note 2(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.11.06",
      "rawHtsCode": "9820.11.06",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles sewn or otherwise assembled in one or more such countries with thread formed in the United States from fabrics wholly formed in the United States and cut in one or more such countries from yarns wholly formed in the United States, or from components knit-to-shape in the United States from yarns wholly formed in the United States, or both (including fabrics not formed from yarns, if such fabrics are classifiable under heading 5602 or 5603 of the tariff schedule and are wholly formed in the United States), under the terms of U.S. note 2(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.11.09",
      "rawHtsCode": "9820.11.09",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles (other than socks provided for in heading 6115 of the tariff schedule) knit to shape in such a country from yarns wholly formed in the United States; knitted or crocheted apparel articles (except t-shirts, other than underwear, classifiable in subheadings 6109.10.00 and 6109.90.10 and described in subheading 9820.11.12) cut and wholly assembled in one or more such countries from fabrics formed in one or more such countries or from fabrics formed in one or more such countries and the United States, all the foregoing from yarns wholly formed in the United States (including fabrics not formed from yarns, if such fabrics are classifiable in heading 5602 or 5603 of the tariff schedule and are formed in one or more such countries) and subject to the provisions of U.S. note 2(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.11.12",
      "rawHtsCode": "9820.11.12",
      "superior": null,
      "indent": "1",
      "description": "T-shirts, other than underwear, classifiable in subheadings 6109.10.00 and 6109.90.10 of the tariff schedule, made in one or more such countries from fabric formed in one or more such countries from yarns wholly formed in the United States, subject to the provisions of U.S. note 2(c) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.11.15",
      "rawHtsCode": "9820.11.15",
      "superior": null,
      "indent": "1",
      "description": "Brassieres classifiable in subheading 6212.10 of the tariff schedule, both cut and sewn or otherwise assembled in the United States or one or more such countries or both, subject to the provisions of U.S. note 2(d) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.11.18",
      "rawHtsCode": "9820.11.18",
      "superior": null,
      "indent": "1",
      "description": "Knitted or crocheted apparel articles cut and assembled in one or more such countries from fabrics wholly formed in the United States from yarns wholly formed in the United States, or from components knit-to-shape in the United States from yarns wholly formed in the United States, or both (including fabrics not formed from yarns, if such fabrics are classifiable in heading 5602 or 5603 of the tariff schedule and are formed wholly in the United States), if such assembly is with thread formed in the United States, and under the terms of U.S. note 2(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.11.21",
      "rawHtsCode": "9820.11.21",
      "superior": null,
      "indent": "1",
      "description": "Textile luggage assembled in such a country from fabric cut in a beneficiary country from fabric wholly formed in the United States from yarns wholly formed in the United States",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.11.24",
      "rawHtsCode": "9820.11.24",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles both cut (or knit-to-shape) and sewn or otherwise assembled in one or more such countries, provided that such apparel articles of such fabrics or yarn would be considered an originating good under the terms of general note 11(o) to the tariff schedule without regard to the source of the fabric or yarn if such apparel article had been imported from the territory of Canada or the territory of Mexico directly into the customs territory of the United States",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.11.27",
      "rawHtsCode": "9820.11.27",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles both cut (or knit-to-shape) and sewn or otherwise assembled in one or more such countries from fabrics or yarn designated by the appropriate U.S. government authority in the <u>Federal Register</u> as fabrics or yarn not available in commercial quantities in the United States, under any terms as such authority may provide",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.11.30",
      "rawHtsCode": "9820.11.30",
      "superior": null,
      "indent": "1",
      "description": "Handloomed, handmade or folklore textile and apparel goods, under the terms of U.S. note 4 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.11.33",
      "rawHtsCode": "9820.11.33",
      "superior": null,
      "indent": "1",
      "description": "Apparel articles sewn or otherwise assembled in one or more such countries with thread formed in the United States, the foregoing (i) from components cut in the United States and in one or more such countries from fabric wholly formed in the United States from yarns wholly formed in the United States (including fabrics not formed from yarns, if such fabrics are classifiable under heading 5602 or 5603 of the tariff schedule), or (ii) from components knit-to-shape in the United States and one or more such countries from yarns wholly formed in the United States, or (iii) from any combination of two or more of the foregoing knitting-to-shape or cutting operations, under the terms of U.S. note 2(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.42.05",
      "rawHtsCode": "9820.42.05",
      "superior": null,
      "indent": "0",
      "description": "Articles of heading 4202 described in U.S. note 6(l) to this subchapter and imported directly from Haiti or the Dominican Republic",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.61.25",
      "rawHtsCode": "9820.61.25",
      "superior": null,
      "indent": "0",
      "description": "Apparel articles described in U.S. note 6(c) to this subchapter imported directly from Haiti or the Dominican Republic during an applicable 1-year period specified in U.S. note 6(b)(ii) to this subchapter, subject to the limitations provided in U.S. note 6(g)(i) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.61.30",
      "rawHtsCode": "9820.61.30",
      "superior": null,
      "indent": "0",
      "description": "Apparel articles described in U.S. note 6(e) to this subchapter imported directly from Haiti or the Dominican Republic during an applicable 1-year period specified in U.S. note 6(b)(ii) to this subchapter, subject to the limitations provided in such U.S. note 6(g)(i) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.61.35",
      "rawHtsCode": "9820.61.35",
      "superior": null,
      "indent": "0",
      "description": "Apparel articles of chapter 61 described in U.S. note 6(j) to this subchapter and imported directly from Haiti or the Dominican Republic during any 1-year period specified in U.S. note 6(j)(iii) to this subchapter, subject to the limitations provided in such U.S. note 6(j)(iii)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.61.40",
      "rawHtsCode": "9820.61.40",
      "superior": null,
      "indent": "0",
      "description": "Apparel articles described in U.S. note 6(k) to this subchapter and imported directly from Haiti or the Dominican Republic",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.61.45",
      "rawHtsCode": "9820.61.45",
      "superior": null,
      "indent": "0",
      "description": "Apparel articles described in U.S. note 6(q) to this subchapter and imported directly from Haiti or the Dominican Republic",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.62.05",
      "rawHtsCode": "9820.62.05",
      "superior": null,
      "indent": "0",
      "description": "Apparel articles of chapter 62 to the tariff schedule, under the terms of U.S. note 6(h) to this subchapter and imported directly from Haiti or the Dominican Republic during an applicable 1-year period specified in U.S. note 6(h)(ii) to this subchapter, subject to the limitations provided in such U.S. note 6(h)(ii)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.62.12",
      "rawHtsCode": "9820.62.12",
      "superior": null,
      "indent": "0",
      "description": "Brassieres of subheading 6212.10, under the terms of U.S. note 6(i) to this subchapter and imported directly from Haiti or the Dominican Republic",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.62.20",
      "rawHtsCode": "9820.62.20",
      "superior": null,
      "indent": "0",
      "description": "Pajama bottoms and other sleepwear described in U.S. note 6(n) to this subchapter and imported directly from Haiti or the Dominican Republic",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.62.25",
      "rawHtsCode": "9820.62.25",
      "superior": null,
      "indent": "0",
      "description": "Apparel articles described in U.S. note 6(o) to this subchapter and imported directly from Haiti or the Dominican Republic",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.62.30",
      "rawHtsCode": "9820.62.30",
      "superior": null,
      "indent": "0",
      "description": "Apparel articles described in U.S. note 6(p) to this subchapter and imported directly from Haiti or the Dominican Republic",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.63.05",
      "rawHtsCode": "9820.63.05",
      "superior": null,
      "indent": "0",
      "description": "Made-up textile articles described in U.S. note 6(r) to this subchapter and imported directly from Haiti or the Dominican Republic",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.65.05",
      "rawHtsCode": "9820.65.05",
      "superior": null,
      "indent": "0",
      "description": "Articles described in U.S. note 6(m) to this subchapter and imported directly from Haiti or the Dominican Republic",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See statistical note 1 to this subchapter. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9820.85.44",
      "rawHtsCode": "9820.85.44",
      "superior": null,
      "indent": "0",
      "description": "Ignition wiring sets and other wiring sets of a kind used in vehicles, aircraft or ships, the foregoing the product of Haiti and entered under the terms of U.S. note 6 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See statistical note 1 to this subchapter."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.01.05",
      "rawHtsCode": "9822.01.05",
      "superior": null,
      "indent": "0",
      "description": "Goods eligible for temporary admission into the customs territory of the United States under the terms of U.S. note 1(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free, under the terms of U.S. note 1(b) to this subchapter",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.01.10",
      "rawHtsCode": "9822.01.10",
      "superior": null,
      "indent": "0",
      "description": "Vessels (together with equipment, parts or materials) regardless of origin, the foregoing exported temporarily from the United States and re-entered into the customs territory after undergoing repairs or alterations, under the terms of U.S. note 1(c) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free, under the terms of U.S. note 1(c) to this subchapter",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.01.25",
      "rawHtsCode": "9822.01.25",
      "superior": null,
      "indent": "0",
      "description": "Apparel goods described in U.S. note 2 to this subchapter and entered pursuant to its provision",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (SG)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.02.01",
      "rawHtsCode": "9822.02.01",
      "superior": null,
      "indent": "0",
      "description": "Goods of Chile, under the terms of general note 26 to the tariff schedule, provided for in subheading 1701.12.50, 1701.13.50, 1701.14.50, 1701.91.30, 1701.91.48, 1701.91.58, 1701.99.50, 1702.20.28, 1702.30.28, 1702.40.28, 1702.60.28, 1702.90.20, 1702.90.58, 1702.90.68, 1704.90.68, 1704.90.78, 1806.10.15, 1806.10.28, 1806.10.38, 1806.10.55, 1806.10.75, 1806.20.73, 1806.20.77, 1806.20.94, 1806.20.98, 1806.90.39, 1806.90.49, 1806.90.59, 1901.20.25, 1901.20.35, 1901.20.60, 1901.20.70, 1901.90.68,1901.90.71, 2101.12.38, 2101.12.48, 2101.12.58, 2101.20.38, 2101.20.48, 2101.20.58, 2103.90.78, 2106.90.46, 2106.90.72, 2106.90.76, 2106.90.80, 2106.90.91, 2106.90.94 or 2106.90.97 subject to the quantitative limits specified in U.S. note 3(b) to subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CL)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.02.02",
      "rawHtsCode": "9822.02.02",
      "superior": null,
      "indent": "0",
      "description": "Imports from Chile, in an aggregate annual quantity not to exceed 1,000,000 SME, of cotton or man-made fiber fabric goods provided for in subdivision (a) of U.S. note 4 to this subchapter that are wholly formed in Chile from yarn produced or obtained outside the territory of Chile or of the United States or in subdivision (b) of U.S. note 4 to this subchapter that are wholly formed in Chile from yarn spun in the territory of Chile or of the United States from fiber produced or obtained outside the territory of Chile or of the United States",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CL)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.02.03",
      "rawHtsCode": "9822.02.03",
      "superior": null,
      "indent": "0",
      "description": "Imports from Chile, in an aggregate annual quantity not to exceed 1,000,000 SME, of cotton or man-made fiber apparel goods or apparel goods subject to cotton or man-made fiber restraints provided for in U.S. note 5 to this subchapter that are both cut (or knit to shape) and sewn or otherwise assembled in Chile from fabric or yarn produced or obtained outside the territory of Chile or of the United States",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CL)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.03.01",
      "rawHtsCode": "9822.03.01",
      "superior": null,
      "indent": "0",
      "description": "Goods of Morocco, under the terms of general note 27 to the tariff schedule, provided for in subheading 1701.12.50, 1701.13.50, 1701.14.50, 1701.91.30, 1701.91.48, 1701.91.58, 1701.99.50, 1702.20.28, 1702.30.28, 1702.40.28, 1702.60.28, 1702.90.20, 1702.90.58, 1702.90.68, 1704.90.68, 1704.90.78, 1806.10.15, 1806.10.28, 1806.10.38, 1806.10.55, 1806.10.75, 1806.20.73, 1806.20.77, 1806.20.94, 1806.20.98, 1806.90.39, 1806.90.49, 1806.90.59, 1901.20.25, 1901.20.35, 1901.20.60, 1901.20.70, 1901.90.68, 1901.90.71, 2101.12.38, 2101.12.48, 2101.12.58, 2101.20.38, 2101.20.48, 2101.20.58, 2103.90.78, 2106.90.46, 2106.90.72, 2106.90.76, 2106.90.80, 2106.90.91, 2106.90.94, 2106.90.97 or 3006.93.20, subject to the quantitative limits specified in U.S. note 6(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (MA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.03.02",
      "rawHtsCode": "9822.03.02",
      "superior": null,
      "indent": "0",
      "description": "Imports from Morocco, in an aggregate quantity not to exceed an annual quantity of 1,067,257 kilograms, of textile or apparel goods provided for in U.S. note 7 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (MA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.01",
      "rawHtsCode": "9822.04.01",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 8(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.02",
      "rawHtsCode": "9822.04.02",
      "superior": null,
      "indent": "3",
      "description": "Subject to the provisions of U.S. note 8(c) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "17.1% (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.03",
      "rawHtsCode": "9822.04.03",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.05",
      "rawHtsCode": "9822.04.05",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 0401.40.25, 0401.50.25, 0403.90.16 or 2105.00.20 subject to the quantitative limits specified in U.S. note 9 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.10",
      "rawHtsCode": "9822.04.10",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 0401.50.75, 0402.21.90, 0403.90.65, 0403.90.78, 0405.10.20, 0405.20.30, 0405.90.20, 2106.90.26 or 2106.90.36 subject to the quantitative limits specified in U.S. note 10 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.15",
      "rawHtsCode": "9822.04.15",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 0402.10.50 or 0402.21.25 subject to the quantitative limits specified in U.S. note 11 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.20",
      "rawHtsCode": "9822.04.20",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 0402.21.50, 0403.90.45, 0403.90.55, 0404.10.90, 2309.90.28 or 2309.90.48 subject to the quantitative limits specified in U.S. note 12 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.25",
      "rawHtsCode": "9822.04.25",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 0402.29.50, 0402.99.90, 0403.20.50, 0403.90.95, 0404.10.15, 0404.90.50, 0405.20.70, 1517.90.60, 1704.90.58, 1806.20.26, 1806.20.28, 1806.20.36, 1806.20.38, 1806.20.82, 1806.20.83, 1806.20.87, 1806.20.89, 1806.32.06, 1806.32.08, 1806.32.16, 1806.32.18, 1806.32.70, 1806.32.80, 1806.90.08, 1806.90.10, 1806.90.18, 1806.90.20, 1806.90.28, 1806.90.30, 1901.10.30, 1901.10.40, 1901.10.75, 1901.10.85, 1901.20.15, 1901.20.50, 1901.90.43, 1901.90.47, 2105.00.40, 2106.90.09, 2106.90.66, 2106.90.87 or 2202.90.28 subject to the quantitative limits specified in U.S. note 13 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.30",
      "rawHtsCode": "9822.04.30",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 0402.91.70, 0402.91.90, 0402.99.45 or 0402.99.55 subject to the quantitative limits specified in U.S. note 14 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.35",
      "rawHtsCode": "9822.04.35",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 0406.10.08, 0406.10.88, 0406.20.91, 0406.30.91 or 0406.90.97 subject to the quantitative limits specified in U.S. note 15 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.40",
      "rawHtsCode": "9822.04.40",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 0406.10.18, 0406.10.48, 0406.10.58, 0406.10.68, 0406.20.28, 0406.20.48, 0406.20.53, 0406.20.63, 0406.20.75, 0406.20.79, 0406.20.83, 0406.30.18, 0406.30.48, 0406.30.53, 0406.30.63, 0406.30.75, 0406.30.79, 0406.30.83, 0406.40.70, 0406.90.18, 0406.90.32, 0406.90.37, 0406.90.42, 0406.90.68, 0406.90.74, 0406.90.88 or 0406.90.92 subject to the quantitative limits specified in U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.45",
      "rawHtsCode": "9822.04.45",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 0406.10.28, 0406.20.33, 0406.20.67, 0406.30.28, 0406.30.67, 0406.90.12 or 0406.90.78 subject to the quantitative limits specified in U.S. note 17 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.50",
      "rawHtsCode": "9822.04.50",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 0406.10.38, 0406.20.39, 0406.20.71, 0406.30.38, 0406.30.71, 0406.90.54 or 0406.90.84 subject to the quantitative limits specified in U.S. note 18 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.04.65",
      "rawHtsCode": "9822.04.65",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 0406.90.48 subject to the quantitative limits specified in U.S. note 19 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (AU)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.05.01",
      "rawHtsCode": "9822.05.01",
      "superior": null,
      "indent": "0",
      "description": "Textile or apparel goods described in U.S. note 20 to this subchapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.05.10",
      "rawHtsCode": "9822.05.10",
      "superior": null,
      "indent": "0",
      "description": "Textile and apparel goods of chapters 61 through 63 described in U.S. note 22 to this subchapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "A duty upon the full value of the imported article less the value of fabrics, components or materials of the United States (see U.S. note 22 of this subchapter)",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9822.05.11",
      "rawHtsCode": "9822.05.11",
      "superior": null,
      "indent": "1",
      "description": "If entered into the customs territory of the United States in aggregate quantities not to exceed the quantitative limit specified in U.S. note 21(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.05.13",
      "rawHtsCode": "9822.05.13",
      "superior": null,
      "indent": "1",
      "description": "Goods specified in U.S. note 21(c) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.05.15",
      "rawHtsCode": "9822.05.15",
      "superior": null,
      "indent": "2",
      "description": "Goods provided for in subheading 1701.12.10, 1701.13.10, 1701.14.10,1701.91.10, 1701.99.10, 1702.90.10 or 2106.90.44 subject to the quantitative limits specified in U.S. note 24 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.05.20",
      "rawHtsCode": "9822.05.20",
      "superior": null,
      "indent": "2",
      "description": "Goods provided for in subheading 1701.12.50, 1701.13.50, 1701.14.50, 1701.91.30, 1701.91.48, 1701.91.58, 1701.99.50, 1702.20.28, 1702.30.28, 1702.40.28, 1702.60.28, 1702.90.20, 1702.90.58, 1702.90.68, 1704.90.68, 1704.90.78, 1806.10.15, 1806.10.28, 1806.10.38, 1806.10.55, 1806.10.75, 1806.20.73, 1806.20.77, 1806.20.94, 1806.20.98, 1806.90.39, 1806.90.49, 1806.90.59, 1901.20.25, 1901.20.35, 1901.20.60, 1901.20.70, 1901.90.68, 1901.90.71, 2101.12.38, 2101.12.48, 2101.12.58, 2101.20.38, 2101.20.48, 2101.20.58, 2103.90.78, 2106.90.46, 2106.90.72, 2106.90.76, 2106.90.80, 2106.90.91, 2106.90.94, 2106.90.97 or 3006.93.20, subject to the quantitative limits specified in U.S. note 25 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.05.25",
      "rawHtsCode": "9822.05.25",
      "superior": null,
      "indent": "0",
      "description": "Goods described in U.S. note 26 to this subchapter of a party to the Agreement as defined in general note 29(a) to the tariff schedule",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.05.30",
      "rawHtsCode": "9822.05.30",
      "superior": null,
      "indent": "1",
      "description": "Goods classifiable in subheading 6202.20.11",
      "units": [],
      "generalRate": "The duty rate provided in such subheading minus 0.5%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9822.05.35",
      "rawHtsCode": "9822.05.35",
      "superior": null,
      "indent": "1",
      "description": "Goods classifiable in subheading 6203.31.90",
      "units": [],
      "generalRate": "The duty rate provided in such subheading minus 0.5%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9822.05.40",
      "rawHtsCode": "9822.05.40",
      "superior": null,
      "indent": "1",
      "description": "Goods classifiable in subheading 6203.33.10",
      "units": [],
      "generalRate": "The duty rate provided in such subheading minus 0.5%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9822.05.45",
      "rawHtsCode": "9822.05.45",
      "superior": null,
      "indent": "1",
      "description": "Goods classifiable in subheading 6203.41.18",
      "units": [],
      "generalRate": "The duty rate provided in such subheading minus 0.5%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9822.05.50",
      "rawHtsCode": "9822.05.50",
      "superior": null,
      "indent": "1",
      "description": "Goods classifiable in subheading 6203.42.40 or 6204.62.40",
      "units": [],
      "generalRate": "The duty rate provided in such subheading minus 0.5%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9822.05.55",
      "rawHtsCode": "9822.05.55",
      "superior": null,
      "indent": "1",
      "description": "Goods classifiable in subheading 6203.43.30",
      "units": [],
      "generalRate": "The duty rate provided in such subheading minus 0.5%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9822.05.60",
      "rawHtsCode": "9822.05.60",
      "superior": null,
      "indent": "1",
      "description": "Goods classifiable in subheading 6203.12.20 (for goods for boys only)",
      "units": [],
      "generalRate": "The duty rate provided in such subheading minus 2.0%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9822.05.65",
      "rawHtsCode": "9822.05.65",
      "superior": null,
      "indent": "1",
      "description": "Goods classifiable in subheading 6203.43.40",
      "units": [],
      "generalRate": "The duty rate provided in such subheading minus 2.0%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9822.05.70",
      "rawHtsCode": "9822.05.70",
      "superior": null,
      "indent": "1",
      "description": "Goods classifiable in subheading 6204.63.35",
      "units": [],
      "generalRate": "The duty rate provided in such subheading minus 2.0%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9822.06.05",
      "rawHtsCode": "9822.06.05",
      "superior": null,
      "indent": "0",
      "description": "Eligible apparel articles of chapter 62 assembled in the Dominican Republic and imported directly therefrom, under the terms of U.S. note 27 to this subchapter",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9822.06.10",
      "rawHtsCode": "9822.06.10",
      "superior": null,
      "indent": "0",
      "description": "Goods of Peru, under the terms of general note 32 to the tariff schedule, subject to the provisions of U.S. note 28 to this subchapter, provided for in subheading 1701.12.50, 1701.13.50, 1701.14.50,1701.91.30, 1701.91.48, 1701.91.58, 1701.99.50, 1702.20.28, 1702.30.28, 1702.40.28, 1702.60.28, 1702.90.20, 1702.90.58, 1702.90.68, 1704.90.68, 1704.90.78, 1806.10.15, 1806.10.28, 1806.10.38, 1806.10.55, 1806.10.75, 1806.20.73, 1806.20.77, 1806.20.94, 1806.20.98, 1806.90.39, 1806.90.49, 1806.90.59, 1901.20.25, 1901.20.35, 1901.20.60, 1901.20.70, 1901.90.68, 1901.90.71, 2101.12.38, 2101.12.48, 2101.12.58, 2101.20.38, 2101.20.48, 2101.20.58, 2103.90.78, 2106.90.46, 2106.90.72, 2106.90.76, 2106.90.80, 2106.90.91, 2106.90.94, 2106.90.97 or 3006.93.20, if entered in an aggregate quantity in any year not to exceed the quantity specified in U.S. note 28(c) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.06.15",
      "rawHtsCode": "9822.06.15",
      "superior": null,
      "indent": "0",
      "description": "Specialty sugars, the foregoing which are goods of Peru, under the terms of general note 32 to the tariff schedule, if entered in an aggregate quantity not to exceed 2,000 t in any year, provided for in subheading 1701.12.10, 1701.13.10, 1701.14.10, 1701.91.10, 1701.99.10, 1702.90.10 or 2106.90.44",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.06.20",
      "rawHtsCode": "9822.06.20",
      "superior": null,
      "indent": "0",
      "description": "Textile or apparel goods of Peru described in U.S. note 29 to this subchapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.06.25",
      "rawHtsCode": "9822.06.25",
      "superior": null,
      "indent": "0",
      "description": "Textile or apparel goods of Peru described in U.S. note 30 to this subchapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.07.10",
      "rawHtsCode": "9822.07.10",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 2402.20.10",
      "units": [],
      "generalRate": "",
      "specialRate": "The duty rate provided for originating goods of Korea in such subheading",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.07.15",
      "rawHtsCode": "9822.07.15",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 2402.20.80",
      "units": [],
      "generalRate": "",
      "specialRate": "The duty rate provided for originating goods of Korea in such subheading",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.07.25",
      "rawHtsCode": "9822.07.25",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 2402.20.90",
      "units": [],
      "generalRate": "",
      "specialRate": "The duty rate provided for originating goods of Korea in such subheading",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.08.01",
      "rawHtsCode": "9822.08.01",
      "superior": null,
      "indent": "0",
      "description": "Goods of Colombia described in U.S. note 32 to this subchapter, as defined in general note 34 to the tariff schedule and provided for in subheadings 1701.12.50, 1701.13.50, 1701.14.50, 1701.91.30, 1701.91.48, 1701.91.58, 1701.99.50, 1702.20.28, 1702.30.28, 1702.40.28, 1702.60.28, 1702.90.20, 1702.90.58, 1702.90.68, 1704.90.68, 1704.90.78, 1806.10.15, 1806.10.28, 1806.10.38, 1806.10.55, 1806.10.75, 1806.20.73, 1806.20.77, 1806.20.94, 1806.20.98, 1806.90.39, 1806.90.49, 1806.90.59, 1901.20.25, 1901.20.35, 1901.20.60, 1901.20.70, 1901.90.68, 1901.90.71, 2101.12.38, 2101.12.48, 2101.12.58, 2101.20.38, 2101.20.48, 2101.20.58, 2103.90.78, 2106.90.46, 2106.90.72, 2106.90.76, 2106.90.80, 2106.90.91, 2106.90.94 or 2106.90.97, subject to the quantitative limits specified in U.S. note 32 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.08.25",
      "rawHtsCode": "9822.08.25",
      "superior": null,
      "indent": "0",
      "description": "Textile or apparel goods of Colombia described in U.S. note 33 to this subchapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.08.35",
      "rawHtsCode": "9822.08.35",
      "superior": null,
      "indent": "0",
      "description": "Textile or apparel goods of Colombia described in U.S. note 34 to this subchapter and entered pursuant to its provisions .",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.09.17",
      "rawHtsCode": "9822.09.17",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 1701.12.50, 1701.13.50, 1701.14.50, 1701.91.30, 1701.91.48, 1701.91.58, 1701.99.50, 1702.20.28, 1702.30.28, 1702.40.28, 1702.60.28, 1702.90.20, 1702.90.58, 1702.90.68, 1704.90.68, 1704.90.78, 1806.10.15, 1806.10.28, 1806.10.38, 1806.10.55, 1806.10.75, 1806.20.73, 1806.20.77, 1806.20.94, 1806.20.98, 1806.90.39, 1806.90.49, 1806.90.59, 1901.20.25, 1901.20.35, 1901.20.60, 1901.20.70, 1901.90.68, 1901.90.71, 2101.12.38, 2101.12.48, 2101.12.58, 2101.20.38, 2101.20.48, 2101.20.58, 2103.90.78, 2106.90.46, 2106.90.72, 2106.90.76, 2106.90.80, 2106.90.91, 2106.90.94, 2106.90.97 or 3006.93.20, subject to the quantitative limits specified in U.S. note 35 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 98 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.09.18",
      "rawHtsCode": "9822.09.18",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 1701.13.50 or 1701.14.50, subject to the quantitative limits specified in U.S. note 36 to this subchapter.",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.09.20",
      "rawHtsCode": "9822.09.20",
      "superior": null,
      "indent": "1",
      "description": "Specialty sugars as provided for in additional U.S. note 5 to chapter 17, subject to the quantitative limits specified in U.S. note 38 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.09.22",
      "rawHtsCode": "9822.09.22",
      "superior": null,
      "indent": "2",
      "description": "Undenatured ethyl alcohol and other spirits of an alcoholic strength by volume of 80 percent vol. or higher, if such ethyl alcohol is to be used as a fuel or is suitable for use in producing a mixture of gasoline and alcohol, a mixture of a special fuel and alcohol or any other mixture to be used as a fuel",
      "units": [],
      "generalRate": "",
      "specialRate": "The rate provided for beneficiary countries in heading 9901.00.50 (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.09.24",
      "rawHtsCode": "9822.09.24",
      "superior": null,
      "indent": "2",
      "description": "Ethyl alcohol and other spirits, denatured of any strength if such ethyl alcohol is to be used as a fuel or is suitable for use in producing a mixture of gasoline and alcohol, a mixture of a special fuel and alcohol or any other mixture to be used as a fuel",
      "units": [],
      "generalRate": "",
      "specialRate": "The rate provided for beneficiary countries in heading 9901.00.50 (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.09.26",
      "rawHtsCode": "9822.09.26",
      "superior": null,
      "indent": "2",
      "description": "Other goods of subheadings 2207.10.60 or 2207.20.00",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.09.61",
      "rawHtsCode": "9822.09.61",
      "superior": null,
      "indent": "0",
      "description": "Textile and apparel goods of chapters 61 through 63 described in U.S. note 39 to this subchapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "",
      "specialRate": "A duty upon the full value of the import- ed article less the value of fabrics, components or materials of the United States (see U.S. note 39 to this subchapter)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.09.62",
      "rawHtsCode": "9822.09.62",
      "superior": null,
      "indent": "0",
      "description": "Textile and apparel goods of chapters 61 through 63 described in U.S. note 40 to this subchapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.09.63",
      "rawHtsCode": "9822.09.63",
      "superior": null,
      "indent": "0",
      "description": "Apparel goods described in U.S. note 41 to this subchapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.09.65",
      "rawHtsCode": "9822.09.65",
      "superior": null,
      "indent": "0",
      "description": "Goods described in U.S. note 42 to this subchapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9822.09.70",
      "rawHtsCode": "9822.09.70",
      "superior": null,
      "indent": "0",
      "description": "Textile or apparel goods of Panama described in U.S. note 43 to this subchapter and entered pursuant to its provisions",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 98 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.01.01",
      "rawHtsCode": "9823.01.01",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 1(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.01.02",
      "rawHtsCode": "9823.01.02",
      "superior": null,
      "indent": "03",
      "description": "Subject to the quantitative limits specified in U.S. note 1(b)(1) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.01.03",
      "rawHtsCode": "9823.01.03",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0401.40.25",
      "units": [],
      "generalRate": "",
      "specialRate": "77.2¢/liter (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.01.04",
      "rawHtsCode": "9823.01.04",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0401.50.25",
      "units": [],
      "generalRate": "",
      "specialRate": "77.2¢/liter (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.01.05",
      "rawHtsCode": "9823.01.05",
      "superior": null,
      "indent": "04",
      "description": "Goods provided for in subheading 0403.90.16",
      "units": [],
      "generalRate": "",
      "specialRate": "77.2¢/liter (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.01.06",
      "rawHtsCode": "9823.01.06",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2105.00.20",
      "units": [],
      "generalRate": "",
      "specialRate": "50.2¢/liter + 17% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.01.07",
      "rawHtsCode": "9823.01.07",
      "superior": null,
      "indent": "4",
      "description": "Goods provided in subheading 2202.99.28",
      "units": [],
      "generalRate": "",
      "specialRate": "23.5¢/liter + 14.9% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.02.01",
      "rawHtsCode": "9823.02.01",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 2(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.02.02",
      "rawHtsCode": "9823.02.02",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 2(b)(1) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.02.03",
      "rawHtsCode": "9823.02.03",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.10.50",
      "units": [],
      "generalRate": "",
      "specialRate": "86.5¢/liter (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.02.04",
      "rawHtsCode": "9823.02.04",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.21.25",
      "units": [],
      "generalRate": "",
      "specialRate": "86.5¢/liter (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.03.01",
      "rawHtsCode": "9823.03.01",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 3(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.03.02",
      "rawHtsCode": "9823.03.02",
      "superior": null,
      "indent": "4",
      "description": "Subject to the quantitative limits specified in U.S. note 3(b)(1) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.03.03",
      "rawHtsCode": "9823.03.03",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0401.50.75",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.646/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.03.04",
      "rawHtsCode": "9823.03.04",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.21.90",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.556/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.03.05",
      "rawHtsCode": "9823.03.05",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.90.65",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.556/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.03.06",
      "rawHtsCode": "9823.03.06",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.646/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.03.07",
      "rawHtsCode": "9823.03.07",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0405.10.20",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.541/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.03.08",
      "rawHtsCode": "9823.03.08",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0405.20.30",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.996/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.03.09",
      "rawHtsCode": "9823.03.09",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0405.20.70",
      "units": [],
      "generalRate": "",
      "specialRate": "70.4¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.03.10",
      "rawHtsCode": "9823.03.10",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0405.90.20",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.865/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.03.11",
      "rawHtsCode": "9823.03.11",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.26",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.996/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.03.12",
      "rawHtsCode": "9823.03.12",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.996/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.01",
      "rawHtsCode": "9823.04.01",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 4(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.02",
      "rawHtsCode": "9823.04.02",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 4(b)(1) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.03",
      "rawHtsCode": "9823.04.03",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.08",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.509/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.04",
      "rawHtsCode": "9823.04.04",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.18",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.269/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.05",
      "rawHtsCode": "9823.04.05",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.28",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.227/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.06",
      "rawHtsCode": "9823.04.06",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.38",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.055/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.07",
      "rawHtsCode": "9823.04.07",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.48",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.803/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.08",
      "rawHtsCode": "9823.04.08",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.58",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.146/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.09",
      "rawHtsCode": "9823.04.09",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.68",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.386/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.10",
      "rawHtsCode": "9823.04.10",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.78",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.128/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.11",
      "rawHtsCode": "9823.04.11",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.88",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.509/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.12",
      "rawHtsCode": "9823.04.12",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.28",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.269/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.13",
      "rawHtsCode": "9823.04.13",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.33",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.227/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.14",
      "rawHtsCode": "9823.04.14",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.39",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.055/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.15",
      "rawHtsCode": "9823.04.15",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.48",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.803/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.16",
      "rawHtsCode": "9823.04.16",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.53",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.146/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.17",
      "rawHtsCode": "9823.04.17",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.63",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.269/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.18",
      "rawHtsCode": "9823.04.18",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.67",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.227/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.19",
      "rawHtsCode": "9823.04.19",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.71",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.055/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.20",
      "rawHtsCode": "9823.04.20",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.75",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.803/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.21",
      "rawHtsCode": "9823.04.21",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.79",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.146/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.22",
      "rawHtsCode": "9823.04.22",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.83",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.386/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.23",
      "rawHtsCode": "9823.04.23",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.87",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.128/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.24",
      "rawHtsCode": "9823.04.24",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.20.91",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.509/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.25",
      "rawHtsCode": "9823.04.25",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30.18",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.269/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.26",
      "rawHtsCode": "9823.04.26",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30,28",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.227/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.27",
      "rawHtsCode": "9823.04.27",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30.38",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.055/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.28",
      "rawHtsCode": "9823.04.28",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30.48",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.803/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.29",
      "rawHtsCode": "9823.04.29",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30.53",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.386/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.30",
      "rawHtsCode": "9823.04.30",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30.63",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.269/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.31",
      "rawHtsCode": "9823.04.31",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30.67",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.227/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.32",
      "rawHtsCode": "9823.04.32",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30.71",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.055/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.33",
      "rawHtsCode": "9823.04.33",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30.75",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.803/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.34",
      "rawHtsCode": "9823.04.34",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30.79",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.146/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.35",
      "rawHtsCode": "9823.04.35",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30.83",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.386/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.36",
      "rawHtsCode": "9823.04.36",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30.87",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.128/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.37",
      "rawHtsCode": "9823.04.37",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.30.91",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.509/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.38",
      "rawHtsCode": "9823.04.38",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.40.70",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.269/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.39",
      "rawHtsCode": "9823.04.39",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.12",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.227/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.40",
      "rawHtsCode": "9823.04.40",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.18",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.803/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.41",
      "rawHtsCode": "9823.04.41",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.32",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.146/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.42",
      "rawHtsCode": "9823.04.42",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.37",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.146/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.43",
      "rawHtsCode": "9823.04.43",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.42",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.146/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.44",
      "rawHtsCode": "9823.04.44",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.48",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.877/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.45",
      "rawHtsCode": "9823.04.45",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.54",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.055/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.46",
      "rawHtsCode": "9823.04.46",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.146/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.47",
      "rawHtsCode": "9823.04.47",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.74",
      "units": [],
      "generalRate": "",
      "specialRate": "$2.269/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.48",
      "rawHtsCode": "9823.04.48",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.227/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.49",
      "rawHtsCode": "9823.04.49",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.84",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.055/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.50",
      "rawHtsCode": "9823.04.50",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.88",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.803/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.51",
      "rawHtsCode": "9823.04.51",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.92",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.386/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.52",
      "rawHtsCode": "9823.04.52",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.94",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.128/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.53",
      "rawHtsCode": "9823.04.53",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.97",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.509/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.04.54",
      "rawHtsCode": "9823.04.54",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.128/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.05.01",
      "rawHtsCode": "9823.05.01",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 5(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.05.02",
      "rawHtsCode": "9823.05.02",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 5(b)(1) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.05.03",
      "rawHtsCode": "9823.05.03",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.21.50",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.092/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.05.04",
      "rawHtsCode": "9823.05.04",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.29.50",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.104/kg + 14.9% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.05.05",
      "rawHtsCode": "9823.05.05",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2309.90.28",
      "units": [],
      "generalRate": "",
      "specialRate": "80.4¢/kg + 6.4% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.05.06",
      "rawHtsCode": "9823.05.06",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2309.90.48",
      "units": [],
      "generalRate": "",
      "specialRate": "80.4¢/kg +6.4% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.06.01",
      "rawHtsCode": "9823.06.01",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 6(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.06.02",
      "rawHtsCode": "9823.06.02",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 6(b)(1) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.06.03",
      "rawHtsCode": "9823.06.03",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.035/kg + 17% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.06.04",
      "rawHtsCode": "9823.06.04",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.90.45",
      "units": [],
      "generalRate": "",
      "specialRate": "87.6¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.06.05",
      "rawHtsCode": "9823.06.05",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.90.55",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.092/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.06.06",
      "rawHtsCode": "9823.06.06",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.90.95",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.034/kg + 17% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.06.07",
      "rawHtsCode": "9823.06.07",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0404.10.15",
      "units": [],
      "generalRate": "",
      "specialRate": "37.6¢/kg + 3.1% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.06.08",
      "rawHtsCode": "9823.06.08",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0404.10.90",
      "units": [],
      "generalRate": "",
      "specialRate": "31.9¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.06.09",
      "rawHtsCode": "9823.06.09",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0404.90.50",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.189/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.07.01",
      "rawHtsCode": "9823.07.01",
      "superior": null,
      "indent": "3",
      "description": "Goods of Mexico or goods of the United States provided for in note 7(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.07.02",
      "rawHtsCode": "9823.07.02",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 7(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.07.03",
      "rawHtsCode": "9823.07.03",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.91.70",
      "units": [],
      "generalRate": "",
      "specialRate": "31.3¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.07.04",
      "rawHtsCode": "9823.07.04",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.91.90",
      "units": [],
      "generalRate": "",
      "specialRate": "31.3¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.07.05",
      "rawHtsCode": "9823.07.05",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.99.45",
      "units": [],
      "generalRate": "",
      "specialRate": "49.6¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.07.06",
      "rawHtsCode": "9823.07.06",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.99.55",
      "units": [],
      "generalRate": "",
      "specialRate": "49.6¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.07.07",
      "rawHtsCode": "9823.07.07",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.99.90",
      "units": [],
      "generalRate": "",
      "specialRate": "46.3¢/kg + 14.9% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.01",
      "rawHtsCode": "9823.08.01",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 8(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.02",
      "rawHtsCode": "9823.08.02",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 8(b)(1) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.04",
      "rawHtsCode": "9823.08.04",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1704.90.58",
      "units": [],
      "generalRate": "",
      "specialRate": "40¢/kg + 10.4% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.05",
      "rawHtsCode": "9823.08.05",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.26",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 4.3% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.06",
      "rawHtsCode": "9823.08.06",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.28",
      "units": [],
      "generalRate": "",
      "specialRate": "52.8¢/kg + 4.3% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.07",
      "rawHtsCode": "9823.08.07",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.36",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 4.3% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.08",
      "rawHtsCode": "9823.08.08",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.38",
      "units": [],
      "generalRate": "",
      "specialRate": "52.8¢/kg + 4.3% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.09",
      "rawHtsCode": "9823.08.09",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.82",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.10",
      "rawHtsCode": "9823.08.10",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.83",
      "units": [],
      "generalRate": "",
      "specialRate": "52.8¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.11",
      "rawHtsCode": "9823.08.11",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.87",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.12",
      "rawHtsCode": "9823.08.12",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.89",
      "units": [],
      "generalRate": "",
      "specialRate": "52.8¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.13",
      "rawHtsCode": "9823.08.13",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.32.06",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 4.3% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.14",
      "rawHtsCode": "9823.08.14",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.32.08",
      "units": [],
      "generalRate": "",
      "specialRate": "52.8¢/kg + 4.3% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.15",
      "rawHtsCode": "9823.08.15",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.32.16",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 4.3% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.16",
      "rawHtsCode": "9823.08.16",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.32.18",
      "units": [],
      "generalRate": "",
      "specialRate": "52.8¢/kg  + 4.3% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.17",
      "rawHtsCode": "9823.08.17",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.32.70",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.18",
      "rawHtsCode": "9823.08.18",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.32.80",
      "units": [],
      "generalRate": "",
      "specialRate": "52.8¢/kg + 6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.19",
      "rawHtsCode": "9823.08.19",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.90.08",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.20",
      "rawHtsCode": "9823.08.20",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.90.10",
      "units": [],
      "generalRate": "",
      "specialRate": "52.8¢/kg + 6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.21",
      "rawHtsCode": "9823.08.21",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.90.18",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.22",
      "rawHtsCode": "9823.08.22",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.90.20",
      "units": [],
      "generalRate": "",
      "specialRate": "52.8¢/kg + 6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.23",
      "rawHtsCode": "9823.08.23",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.90.28",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.24",
      "rawHtsCode": "9823.08.24",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.90.30",
      "units": [],
      "generalRate": "",
      "specialRate": "52.8¢/kg + 6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.25",
      "rawHtsCode": "9823.08.25",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.10.16",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.035/kg + 14.9% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.26",
      "rawHtsCode": "9823.08.26",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.10.26",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.035/kg + 14.9% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.27",
      "rawHtsCode": "9823.08.27",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.10.36",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.035/kg  + 14.9% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.28",
      "rawHtsCode": "9823.08.28",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.10.44",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.035/kg + 14.9% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.29",
      "rawHtsCode": "9823.08.29",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.10.56",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.035/kg + 13.6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.30",
      "rawHtsCode": "9823.08.30",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.10.66",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.035/kg + 13.6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.31",
      "rawHtsCode": "9823.08.31",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.20.15",
      "units": [],
      "generalRate": "",
      "specialRate": "42.3¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.32",
      "rawHtsCode": "9823.08.32",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "42.3¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.33",
      "rawHtsCode": "9823.08.33",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.90.62",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.035/kg + 13.6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.34",
      "rawHtsCode": "9823.08.34",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.90.65",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.035/kg + 13.6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.35",
      "rawHtsCode": "9823.08.35",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2105.00.40",
      "units": [],
      "generalRate": "",
      "specialRate": "50.2¢/kg + 17% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.36",
      "rawHtsCode": "9823.08.36",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.09",
      "units": [],
      "generalRate": "",
      "specialRate": "86.2¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.37",
      "rawHtsCode": "9823.08.37",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.66",
      "units": [],
      "generalRate": "",
      "specialRate": "70.4¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.08.38",
      "rawHtsCode": "9823.08.38",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.87",
      "units": [],
      "generalRate": "",
      "specialRate": "28.8¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.09.01",
      "rawHtsCode": "9823.09.01",
      "superior": null,
      "indent": "2",
      "description": "Goods provided for in note 9(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.09.02",
      "rawHtsCode": "9823.09.02",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 9(b)(1) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.09.03",
      "rawHtsCode": "9823.09.03",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1701.12.50",
      "units": [],
      "generalRate": "",
      "specialRate": "35.74¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.09.04",
      "rawHtsCode": "9823.09.04",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1701.13.50",
      "units": [],
      "generalRate": "",
      "specialRate": "33.87¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.09.05",
      "rawHtsCode": "9823.09.05",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1701.14.50",
      "units": [],
      "generalRate": "",
      "specialRate": "33.87¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.09.06",
      "rawHtsCode": "9823.09.06",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1701.91.30",
      "units": [],
      "generalRate": "",
      "specialRate": "35.74¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.09.07",
      "rawHtsCode": "9823.09.07",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1701.99.50",
      "units": [],
      "generalRate": "",
      "specialRate": "35.74¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.09.08",
      "rawHtsCode": "9823.09.08",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1702.90.20",
      "units": [],
      "generalRate": "",
      "specialRate": "35.74¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.09.09",
      "rawHtsCode": "9823.09.09",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in note 9(b)(3) and subject to the quantitative limitations as determined by the U.S. Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.01",
      "rawHtsCode": "9823.10.01",
      "superior": null,
      "indent": "2",
      "description": "Goods provided for in note 10(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.02",
      "rawHtsCode": "9823.10.02",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in note 10(b)(1) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.03",
      "rawHtsCode": "9823.10.03",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1701.91.48",
      "units": [],
      "generalRate": "",
      "specialRate": "33.9¢/kg + 5.1% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.04",
      "rawHtsCode": "9823.10.04",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1701.91.58",
      "units": [],
      "generalRate": "",
      "specialRate": "33.9¢/kg + 5.1% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.05",
      "rawHtsCode": "9823.10.05",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1702.20.28",
      "units": [],
      "generalRate": "",
      "specialRate": "16.9¢/kg of total sugars + 5.1% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.06",
      "rawHtsCode": "9823.10.06",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1702.30.28",
      "units": [],
      "generalRate": "",
      "specialRate": "16.9¢/kg of total sugars + 5.1% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.07",
      "rawHtsCode": "9823.10.07",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1702.40.28",
      "units": [],
      "generalRate": "",
      "specialRate": "33.9¢/kg of total sugars + 5.1% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.08",
      "rawHtsCode": "9823.10.08",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1702.60.28",
      "units": [],
      "generalRate": "",
      "specialRate": "33.9¢/kg of total sugars + 5.1% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.09",
      "rawHtsCode": "9823.10.09",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1702.90.58",
      "units": [],
      "generalRate": "",
      "specialRate": "33.9¢/kg of total sugars + 5.1% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.10",
      "rawHtsCode": "9823.10.10",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1702.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "33.9¢/kg + 5.1% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.11",
      "rawHtsCode": "9823.10.11",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1704.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "40¢/kg + 10.4% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.12",
      "rawHtsCode": "9823.10.12",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1704.90.78 or 3006.93.20",
      "units": [],
      "generalRate": "",
      "specialRate": "40¢/kg + 10.4% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.13",
      "rawHtsCode": "9823.10.13",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.10.15",
      "units": [],
      "generalRate": "",
      "specialRate": "21.7¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.14",
      "rawHtsCode": "9823.10.14",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.10.28",
      "units": [],
      "generalRate": "",
      "specialRate": "33.6¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.15",
      "rawHtsCode": "9823.10.15",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.10.38",
      "units": [],
      "generalRate": "",
      "specialRate": "33.6¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.16",
      "rawHtsCode": "9823.10.16",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.10.55",
      "units": [],
      "generalRate": "",
      "specialRate": "33.6¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.17",
      "rawHtsCode": "9823.10.17",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.10.75",
      "units": [],
      "generalRate": "",
      "specialRate": "33.6¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.18",
      "rawHtsCode": "9823.10.18",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.73",
      "units": [],
      "generalRate": "",
      "specialRate": "30.5¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.19",
      "rawHtsCode": "9823.10.19",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.77",
      "units": [],
      "generalRate": "",
      "specialRate": "30.5¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.20",
      "rawHtsCode": "9823.10.20",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.94",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.21",
      "rawHtsCode": "9823.10.21",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.98",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.22",
      "rawHtsCode": "9823.10.22",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.90.39",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.23",
      "rawHtsCode": "9823.10.23",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.90.49",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.24",
      "rawHtsCode": "9823.10.24",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.90.59",
      "units": [],
      "generalRate": "",
      "specialRate": "37.2¢/kg + 6% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.25",
      "rawHtsCode": "9823.10.25",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.10.76",
      "units": [],
      "generalRate": "",
      "specialRate": "23.7¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.26",
      "rawHtsCode": "9823.10.26",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.20.25",
      "units": [],
      "generalRate": "",
      "specialRate": "42.3¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.27",
      "rawHtsCode": "9823.10.27",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.20.35",
      "units": [],
      "generalRate": "",
      "specialRate": "42.3¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.28",
      "rawHtsCode": "9823.10.28",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.20.60",
      "units": [],
      "generalRate": "",
      "specialRate": "42.3¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.29",
      "rawHtsCode": "9823.10.29",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.20.70",
      "units": [],
      "generalRate": "",
      "specialRate": "42.3¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.30",
      "rawHtsCode": "9823.10.30",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "23.7¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.31",
      "rawHtsCode": "9823.10.31",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.90.71",
      "units": [],
      "generalRate": "",
      "specialRate": "23.7¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.32",
      "rawHtsCode": "9823.10.32",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2101.12.38",
      "units": [],
      "generalRate": "",
      "specialRate": "30.5¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.33",
      "rawHtsCode": "9823.10.33",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2101.12.48",
      "units": [],
      "generalRate": "",
      "specialRate": "30.5¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.34",
      "rawHtsCode": "9823.10.34",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2101.12.58",
      "units": [],
      "generalRate": "",
      "specialRate": "30.5¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.35",
      "rawHtsCode": "9823.10.35",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2101.20.38",
      "units": [],
      "generalRate": "",
      "specialRate": "30.5¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.36",
      "rawHtsCode": "9823.10.36",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2101.20.48",
      "units": [],
      "generalRate": "",
      "specialRate": "30.5¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.37",
      "rawHtsCode": "9823.10.37",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2101.20.58",
      "units": [],
      "generalRate": "",
      "specialRate": "30.5¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.38",
      "rawHtsCode": "9823.10.38",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2103.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "30.5¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.39",
      "rawHtsCode": "9823.10.39",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.46",
      "units": [],
      "generalRate": "",
      "specialRate": "35.74¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.40",
      "rawHtsCode": "9823.10.40",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.72",
      "units": [],
      "generalRate": "",
      "specialRate": "70.4¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.41",
      "rawHtsCode": "9823.10.41",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.76",
      "units": [],
      "generalRate": "",
      "specialRate": "70.4¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.42",
      "rawHtsCode": "9823.10.42",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.80",
      "units": [],
      "generalRate": "",
      "specialRate": "70.4¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.43",
      "rawHtsCode": "9823.10.43",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.91",
      "units": [],
      "generalRate": "",
      "specialRate": "28.8¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.44",
      "rawHtsCode": "9823.10.44",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.94",
      "units": [],
      "generalRate": "",
      "specialRate": "28.8¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.10.45",
      "rawHtsCode": "9823.10.45",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.97",
      "units": [],
      "generalRate": "",
      "specialRate": "28.8¢/kg + 8.5% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.52.01",
      "rawHtsCode": "9823.52.01",
      "superior": null,
      "indent": "3",
      "description": "Cotton or man-made fiber apparel as provided in note 11(a)(I)(A) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.52.02",
      "rawHtsCode": "9823.52.02",
      "superior": null,
      "indent": "3",
      "description": "Wool apparel as provided in note 11(a)(i)(B) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.52.03",
      "rawHtsCode": "9823.52.03",
      "superior": null,
      "indent": "4",
      "description": "Men's or boy's wool suits of category 443 as provided in note 11(a)(i)(B)(I)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.52.04",
      "rawHtsCode": "9823.52.04",
      "superior": null,
      "indent": "2",
      "description": "Cotton or man-made fiber fabrics and made up goods as provided in note 11(a)(ii):",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.52.05",
      "rawHtsCode": "9823.52.05",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in note 11(a)(ii)(A)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.52.06",
      "rawHtsCode": "9823.52.06",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in note 11(a)(ii)(B)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.52.07",
      "rawHtsCode": "9823.52.07",
      "superior": null,
      "indent": "03",
      "description": "Goods as provided for in note 11(a)(iii)(A)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.52.08",
      "rawHtsCode": "9823.52.08",
      "superior": null,
      "indent": "3",
      "description": "Goods as provided for in note 11(a)(iii)(B)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.53.01",
      "rawHtsCode": "9823.53.01",
      "superior": null,
      "indent": "3",
      "description": "Cotton or man-made fiber apparel as provided for in note 11(b)(I)(B)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.53.02",
      "rawHtsCode": "9823.53.02",
      "superior": null,
      "indent": "3",
      "description": "Wool apparel as provided for in note 11(b)(I)(C)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.53.03",
      "rawHtsCode": "9823.53.03",
      "superior": null,
      "indent": "2",
      "description": "Cotton or man-made fiber fabrics and made-up goods as provided for in note 11(b)(ii):",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.53.04",
      "rawHtsCode": "9823.53.04",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in note 11(b)(ii)(A)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.53.05",
      "rawHtsCode": "9823.53.05",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in note 11(b)(ii)(B)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9823.53.06",
      "rawHtsCode": "9823.53.06",
      "superior": null,
      "indent": "2",
      "description": "Non-originating cotton or man-made fiber spun yarn goods as provided for in note 11(b)(iii)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9901.00.50",
      "rawHtsCode": "9901.00.50",
      "superior": null,
      "indent": "0",
      "description": "Ethyl alcohol (provided for in subheadings 2207.10.60 and 2207.20) or any mixture containing such ethyl alcohol (provided for in heading 2710 or 3824) if such ethyl alcohol or mixture is to be used as a fuel or in producing a mixture of gasoline and alcohol, a mixture of a special fuel and alcohol, or any other mixture to be used as fuel (including motor fuel provided for in subheading 2710.12.15, 2710.19.16, 2710.19.24 or 2710.20.15), or is suitable for any such uses",
      "units": [],
      "generalRate": "14.27¢/ liter",
      "specialRate": "No change (A) Free (CA,IL, MX) See U.S. note 3 to this sub- chapter (E) See U.S. note 3(e) (CO,PE)",
      "otherRate": "14.27¢/ liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1.",
        "See subchapter I, U.S. note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9901.00.52",
      "rawHtsCode": "9901.00.52",
      "superior": null,
      "indent": "0",
      "description": "Ethyl tertiary-butyl ether (provided for in subheading 2909.19.18) and any mixture containing ethyl tertiary-butyl ether",
      "units": [],
      "generalRate": "5.99¢/ liter",
      "specialRate": "No change (A,E) Free (CA,IL, MX) See U.S. note 3(e) (CO,PE)",
      "otherRate": "5.99¢/ liter",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1.",
        "See subchapter I, U.S. note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.01",
      "rawHtsCode": "9902.01.01",
      "superior": null,
      "indent": "0",
      "description": "Frozen, boiled glutinous corn (other than sweet corn), not reduced in size (provided for in subheading 0710.80.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.02",
      "rawHtsCode": "9902.01.02",
      "superior": null,
      "indent": "0",
      "description": "Mustard seed oil and its fractions, other than crude, not denatured, not chemically modified (provided for in subheading 1514.99.90).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.03",
      "rawHtsCode": "9902.01.03",
      "superior": null,
      "indent": "0",
      "description": "Cocoa powder, not containing added sugar or other sweetening matter (provided for in subheading 1805.00.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.04",
      "rawHtsCode": "9902.01.04",
      "superior": null,
      "indent": "0",
      "description": "Artichokes, prepared or preserved by vinegar or acetic acid (provided for in subheading 2001.90.25)",
      "units": [],
      "generalRate": "7.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.05",
      "rawHtsCode": "9902.01.05",
      "superior": null,
      "indent": "0",
      "description": "Pepperoncini, prepared or preserved by vinegar or acetic acid and presented in glass jars (provided for in subheading 2001.90.38)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.06",
      "rawHtsCode": "9902.01.06",
      "superior": null,
      "indent": "0",
      "description": "Pepperoncini, prepared or preserved by vinegar or acetic acid and presented in containers other than glass jars (provided for in subheading 2001.90.38)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.07",
      "rawHtsCode": "9902.01.07",
      "superior": null,
      "indent": "0",
      "description": "Olives, green in color, stuffed with minced pimiento, the foregoing in brine and presented in glass containers, other than place packed (provided for in subheading 2005.70.25) \n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.08",
      "rawHtsCode": "9902.01.08",
      "superior": null,
      "indent": "0",
      "description": "Pimientos, prepared or preserved otherwise than by vinegar or acetic acid, not frozen (provided for in subheading 2005.99.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.09",
      "rawHtsCode": "9902.01.09",
      "superior": null,
      "indent": "0",
      "description": "Pepperoncini, prepared or preserved otherwise than by vinegar or acetic acid, not frozen (provided for in subheading 2005.99.55)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.10",
      "rawHtsCode": "9902.01.10",
      "superior": null,
      "indent": "0",
      "description": "Artichokes, prepared or preserved otherwise than by vinegar or acetic acid, not frozen (provided for in subheading 2005.99.80)\n",
      "units": [],
      "generalRate": "12.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.11",
      "rawHtsCode": "9902.01.11",
      "superior": null,
      "indent": "0",
      "description": "Strawberries, brined and then oven-dried or tunnel-dried, the foregoing infused with sugar (provided for in subheading 2008.80.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.12",
      "rawHtsCode": "9902.01.12",
      "superior": null,
      "indent": "0",
      "description": "Edible powder containing conjugated linoleic acid (CAS Nos. 2540-56-9 and 2420-56-6) containing over 10 percent by weight of milk solids (provided for in subheading 2106.90.82)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.13",
      "rawHtsCode": "9902.01.13",
      "superior": null,
      "indent": "0",
      "description": "Gum containing nicotine and containing synthetic sweetening agents (e.g., saccharin) instead of sugar (provided for in subheading 2106.90.98)\n",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.14",
      "rawHtsCode": "9902.01.14",
      "superior": null,
      "indent": "0",
      "description": "Coconut water juice blends, not from concentrate, packaged for retail sale (provided for in subheading 2009.90.40).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.15",
      "rawHtsCode": "9902.01.15",
      "superior": null,
      "indent": "0",
      "description": "Coconut water, not from concentrate, not containing added sugar or other sweetening matter, packaged for retail sale in paper-based cartons (provided for in subheading 2009.89.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.16",
      "rawHtsCode": "9902.01.16",
      "superior": null,
      "indent": "0",
      "description": "Coconut water not from concentrate, flavored, packaged for retail sale (provided for in subheading 2009.89.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.17",
      "rawHtsCode": "9902.01.17",
      "superior": null,
      "indent": "0",
      "description": "Coconut water, not from concentrate, not containing added sugar or other sweetening, certified by the importer as from conventionally grown (non-organic) coconuts, packaged for retail sale in 500 milliliter polyethylene terephthalate bottles (provided for in subheading 2009.89.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.18",
      "rawHtsCode": "9902.01.18",
      "superior": null,
      "indent": "0",
      "description": "Light oil fractions containing more than 50 percent by weight of isododecane (CAS No. 93685-81-5) (provided for in subheading 2710.12.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.19",
      "rawHtsCode": "9902.01.19",
      "superior": null,
      "indent": "0",
      "description": "Medium oil fractions containing more than 50 percent by weight of isohexadecane (CAS No. 93685-80-4) (provided for in subheading 2710.19.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.20",
      "rawHtsCode": "9902.01.20",
      "superior": null,
      "indent": "0",
      "description": "Sodium, containing more than 200 ppm of calcium (CAS No. 7440-23-5) (provided for in subheading 2805.11.00)\n",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.21",
      "rawHtsCode": "9902.01.21",
      "superior": null,
      "indent": "0",
      "description": "Sodium, containing not more than 200 ppm of calcium (CAS No. 7440-23-5) (provided for in subheading 2805.11.00) \n",
      "units": [],
      "generalRate": "0.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.22",
      "rawHtsCode": "9902.01.22",
      "superior": null,
      "indent": "0",
      "description": "Nitrosylsulfuric acid (CAS. No. 7782-78-7) (provided for in subheading 2811.19.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.23",
      "rawHtsCode": "9902.01.23",
      "superior": null,
      "indent": "0",
      "description": "Hypophosphorous acid 50% (phosphinic acid) (CAS No. 6303-21-5) (provided for in subheading 2811.19.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.24",
      "rawHtsCode": "9902.01.24",
      "superior": null,
      "indent": "0",
      "description": "Sulfamic acid (CAS No. 5329-14-6) (provided for in subheading 2811.19.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.25",
      "rawHtsCode": "9902.01.25",
      "superior": null,
      "indent": "0",
      "description": "Dihydrogen hexafluorozirconate(2-) (Hexafluorozirconic acid) (CAS No. 12021-95-3) (provided for in subheading 2811.19.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.26",
      "rawHtsCode": "9902.01.26",
      "superior": null,
      "indent": "0",
      "description": "Dioxosilane (Silicon dioxide amorphous) (CAS No. 7631-86-9) entirely spherical micro-spheres of mean particle size of 0.005 mm or smaller, uniform particle size with a uniformity coefficient of 1.65 or less, trace metal impurities less than 70 ppm, specific electrical resistance of 50,000 Ohm cm (provided for in subheading 2811.22.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.27",
      "rawHtsCode": "9902.01.27",
      "superior": null,
      "indent": "0",
      "description": "Dioxosilane (Silicon dioxide amorphous) (CAS No. 7631-86-9) entirely spherical micro-spheres of mean particle size of between 0.007 and 0.020 mm, uniform particle size with a uniformity coefficient of 1.65 or less, trace metal impurities less than 70 ppm, specific electrical resistance of 50,000 Ohm cm (provided for in subheading 2811.22.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.28",
      "rawHtsCode": "9902.01.28",
      "superior": null,
      "indent": "0",
      "description": "Dioxosilane (Silicon dioxide amorphous) (CAS No. 7631-86-9) presented in the form of entirely spherical micro-spheres, certified by the importer as having a mean particle size of between 0.046 and 0.054 mm, uniform particle size with a uniformity coefficient of 1.65 or less and specific electrical resistance of 50,000 Ohm cm or more (provided for in subheading 2811.22.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.29",
      "rawHtsCode": "9902.01.29",
      "superior": null,
      "indent": "0",
      "description": "Silicon dioxide amorphous, certified by the importer as comprising entirely spherical micro-spheres with mean particle size of 28 to 45 micrometers (µm) and surface area 600 to 800 m²/g (CAS No. 7631-86-9) (provided for in subheading 2811.22.10)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.30",
      "rawHtsCode": "9902.01.30",
      "superior": null,
      "indent": "0",
      "description": "Amorphous silicon dioxide micro-spheres of mean particle size of 0.050-0.100 mm, and specific electrical resistance of 50,000 Ohm cm or more (CAS No. 7631-86-9) (provided for in subheading 2811.22.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.31",
      "rawHtsCode": "9902.01.31",
      "superior": null,
      "indent": "0",
      "description": "Amorphous silicon dioxide micro-spheres of mean particle size 0.003-0.018 mm, linseed oil absorption 30-40 ml/g, surface area less than 80 m²/g, and pore volume less than 0.1 ml/g (CAS No. 7631-86-9) (provided for in subheading 2811.22.10)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.32",
      "rawHtsCode": "9902.01.32",
      "superior": null,
      "indent": "0",
      "description": "Entirely spherical silicon dioxide micro-spheres, certified by the importer as having mean particle size of 3 to 18 micrometers (µm), linseed oil absorption 150 to 400 ml/g, microbial count less than 100 cfu/g, mold count less than 100 cfu/g, heavy metals less than 20 ppm, surface area 300 to 800 m²/g and pore volume of 0.8 to 2.5 ml/g (CAS No. 7631-86-9) (provided for in subheading 2811.22.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.33",
      "rawHtsCode": "9902.01.33",
      "superior": null,
      "indent": "0",
      "description": "Thionyl chloride (CAS No. 7719-09-7) (provided for in subheading 2812.17.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.34",
      "rawHtsCode": "9902.01.34",
      "superior": null,
      "indent": "0",
      "description": "Chromium(III) oxide (CAS No. 1308-38-9) (provided for in subheading 2819.90.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.35",
      "rawHtsCode": "9902.01.35",
      "superior": null,
      "indent": "0",
      "description": "Iron(III) oxide (Pigment red 101) (CAS No. 1309-37-1) (provided for in subheading 2821.10.00)\n",
      "units": [],
      "generalRate": "2.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.36",
      "rawHtsCode": "9902.01.36",
      "superior": null,
      "indent": "0",
      "description": "Hydroxylamine (CAS No. 7803-49-8) (provided for in subheading 2825.10.00)",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.37",
      "rawHtsCode": "9902.01.37",
      "superior": null,
      "indent": "0",
      "description": "Hydroxylamine sulfate (bis(hydroxylammonium) sulfate) (CAS No. 10039-54-0) (provided for in subheading 2825.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.38",
      "rawHtsCode": "9902.01.38",
      "superior": null,
      "indent": "0",
      "description": "Hydrazine, 64 percent solution in water (CAS No. 302-01-2) (provided for in subheading 2825.10.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.39",
      "rawHtsCode": "9902.01.39",
      "superior": null,
      "indent": "0",
      "description": "Germanium dioxide, powder form (CAS No. 1310-53-8) (provided for in subheading 2825.60.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.40",
      "rawHtsCode": "9902.01.40",
      "superior": null,
      "indent": "0",
      "description": "Tin(IV) oxide (stannic oxide) (Dioxostannane) (CAS No. 18282-10-5) (provided for in subheading 2825.90.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.41",
      "rawHtsCode": "9902.01.41",
      "superior": null,
      "indent": "0",
      "description": "Ammonium bifluoride (Ammonium fluoride hydrofluoride (1:1:1)) (CAS No. 1341-49-7) (provided for in subheading 2826.19.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.42",
      "rawHtsCode": "9902.01.42",
      "superior": null,
      "indent": "0",
      "description": "Sodium Fluoride (CAS No. 7681-49-4) (provided for in subheading 2826.19.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.43",
      "rawHtsCode": "9902.01.43",
      "superior": null,
      "indent": "0",
      "description": "Tin fluoride (CAS No. 7783-47-3) (provided for in subheading 2826.19.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.44",
      "rawHtsCode": "9902.01.44",
      "superior": null,
      "indent": "0",
      "description": "Sodium hydrogen difluoride (CAS No. 1333-83-1) (provided for in subheading 2826.19.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.45",
      "rawHtsCode": "9902.01.45",
      "superior": null,
      "indent": "0",
      "description": "Chromium(3+) trifluoride (CAS No. 7788-97-8) (provided for in subheading 2826.19.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.46",
      "rawHtsCode": "9902.01.46",
      "superior": null,
      "indent": "0",
      "description": "Potassium fluoride hydrofluoride (CAS No. 7789-29-9) (provided for in subheading 2826.19.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.47",
      "rawHtsCode": "9902.01.47",
      "superior": null,
      "indent": "0",
      "description": "Potassium fluoroborate (CAS No. 14075-53-7) (provided for in subheading 2826.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.48",
      "rawHtsCode": "9902.01.48",
      "superior": null,
      "indent": "0",
      "description": "Potassium fluotitanate (Dipotassium hexafluorotitanate(2-)) (CAS No. 16919-27-0) (provided for in subheading 2826.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.49",
      "rawHtsCode": "9902.01.49",
      "superior": null,
      "indent": "0",
      "description": "Potassium zirconate (CAS No.16923-95-8) (provided for in subheading 2826.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.50",
      "rawHtsCode": "9902.01.50",
      "superior": null,
      "indent": "0",
      "description": "Titanium trichloride (CAS No. 7705-07-9) (provided for in subheading 2827.39.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.51",
      "rawHtsCode": "9902.01.51",
      "superior": null,
      "indent": "0",
      "description": "Cobalt chloride (dichlorocobalt hydrate (1:1)) (CAS No. 7791-13-1) (provided for in subheading 2827.39.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.52",
      "rawHtsCode": "9902.01.52",
      "superior": null,
      "indent": "0",
      "description": "Cesium Chloride (CAS No. 7647-17-8) (provided for in subheading 2827.39.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.53",
      "rawHtsCode": "9902.01.53",
      "superior": null,
      "indent": "0",
      "description": "Cesium iodide (CAS No. 7789-17-5) (provided for in subheading 2827.60.51)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.54",
      "rawHtsCode": "9902.01.54",
      "superior": null,
      "indent": "0",
      "description": "Sodium sulfide (CAS No. 1313-82-2) (provided for in subheading 2830.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.55",
      "rawHtsCode": "9902.01.55",
      "superior": null,
      "indent": "0",
      "description": "Sodium Thiosulfate Pentahydrate (Sodium sulfurothioate hydrate (2:1.5)) (CAS No.10102-17-7) (provided for in subheading 2832.30.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.56",
      "rawHtsCode": "9902.01.56",
      "superior": null,
      "indent": "0",
      "description": "Barium dinitrate (CAS No. 10022-31-8) (provided for in subheading 2834.29.51)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.57",
      "rawHtsCode": "9902.01.57",
      "superior": null,
      "indent": "0",
      "description": "Sodium hypophosphite monohydrate (CAS No. 10039-56-2) (provided for in subheading 2835.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.58",
      "rawHtsCode": "9902.01.58",
      "superior": null,
      "indent": "0",
      "description": "Monopotassium phosphate (CAS No. 7778-77-0) (provided for in subheading 2835.24.00)\n",
      "units": [],
      "generalRate": "1.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.59",
      "rawHtsCode": "9902.01.59",
      "superior": null,
      "indent": "0",
      "description": "Ammonium polyphosphate (CAS No. 68333-79-9) (provided for in subheading 2835.39.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.60",
      "rawHtsCode": "9902.01.60",
      "superior": null,
      "indent": "0",
      "description": "Cobalt carbonate (cobalt(2+) carbonate hydrate (1:1:1)) (CAS No. 513-79-1) (provided for in subheading 2836.99.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.61",
      "rawHtsCode": "9902.01.61",
      "superior": null,
      "indent": "0",
      "description": "Zirconium basic carbonate (zirconium(4+) dicarbonate) \n (CAS No. 57219-64-4) (provided for in subheading 2836.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.62",
      "rawHtsCode": "9902.01.62",
      "superior": null,
      "indent": "0",
      "description": "Potassium Ferricyanide (CAS No.13746-66-2) (provided for in subheading 2837.20.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.63",
      "rawHtsCode": "9902.01.63",
      "superior": null,
      "indent": "0",
      "description": "Sodium Ferrocyanide (CAS No. 13601-19-9) (provided for in subheading 2837.20.51)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.64",
      "rawHtsCode": "9902.01.64",
      "superior": null,
      "indent": "0",
      "description": "Potassium Ferrocyanide (CAS No.14459-95-1) (provided for in subheading 2837.20.51)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.65",
      "rawHtsCode": "9902.01.65",
      "superior": null,
      "indent": "0",
      "description": "Sodium oxosilanediolate hydrate (2:1:9) (Sodium metasilicate nonahydrate) (CAS No. 13517-24-3) (provided for in subheading 2839.11.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.66",
      "rawHtsCode": "9902.01.66",
      "superior": null,
      "indent": "0",
      "description": "Potassium Tetraborate (CAS No. 12045-78-2) (provided for in subheading 2840.20.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.67",
      "rawHtsCode": "9902.01.67",
      "superior": null,
      "indent": "0",
      "description": "Disodium dioxido(dioxo)tungsten (disodium wolframate) (CAS No. 13472-45-2) (provided for in subheading 2841.80.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.68",
      "rawHtsCode": "9902.01.68",
      "superior": null,
      "indent": "0",
      "description": "Sodium thiocyanate (CAS No. 540-72-7) (provided for in subheading 2842.90.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.69",
      "rawHtsCode": "9902.01.69",
      "superior": null,
      "indent": "0",
      "description": "Silver sodium zirconium hydrogenphosphate (CAS No. 265647-11-8) (provided for in subheading 2843.29.01)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.70",
      "rawHtsCode": "9902.01.70",
      "superior": null,
      "indent": "0",
      "description": "Mixtures or coprecipitates of yttrium phosphate (CAS No. 13990-54-0) and cerium phosphate (CAS No. 13454-71-2) (provided for in subheadings 2846.10.00 and 2846.90.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.71",
      "rawHtsCode": "9902.01.71",
      "superior": null,
      "indent": "0",
      "description": "Lanthanum(III) oxide (CAS No. 1312-81-8) (provided for in subheading 2846.90.80)",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.72",
      "rawHtsCode": "9902.01.72",
      "superior": null,
      "indent": "0",
      "description": "Lanthanum carbonate (CAS No. 54451-24-0) (provided for in subheading 2846.90.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.73",
      "rawHtsCode": "9902.01.73",
      "superior": null,
      "indent": "0",
      "description": "Lutetium oxide (CAS No. 12032-20-1) (provided for in subheading 2846.90.80)",
      "units": [],
      "generalRate": "2.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.74",
      "rawHtsCode": "9902.01.74",
      "superior": null,
      "indent": "0",
      "description": "Lanthanum phosphate, cerium terbium-doped (CAS No. 95823-34-0) (provided for in subheading 2846.90.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.75",
      "rawHtsCode": "9902.01.75",
      "superior": null,
      "indent": "0",
      "description": "Yttrium oxides having a purity of at least 99.9 percent (CAS No. 1314-36-9)\n (provided for in subheading 2846.90.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.76",
      "rawHtsCode": "9902.01.76",
      "superior": null,
      "indent": "0",
      "description": "Ytterbium trifluoride powder (CAS No. 13760-80-0) with a median particle size of greater than 0.2 microns and less than 0.7 microns (provided for in subheading 2846.90.80)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.77",
      "rawHtsCode": "9902.01.77",
      "superior": null,
      "indent": "0",
      "description": "Titanium(2+) dihydride (Titanium hydride) (CAS No. 7704-98-5) (provided for in subheading 2850.00.07)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.78",
      "rawHtsCode": "9902.01.78",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing titanium dihydride pastes of a kind used for coating the interior of low-pressure mercury lamps (CAS No. 7704-98-5) (provided for in subheading 2850.00.07)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.79",
      "rawHtsCode": "9902.01.79",
      "superior": null,
      "indent": "0",
      "description": "Lithium tetrahydridoaluminate(1-) (Lithium aluminum hydride) (CAS No. 16853-85-3) (provided for in subheading 2850.00.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.80",
      "rawHtsCode": "9902.01.80",
      "superior": null,
      "indent": "0",
      "description": "Cyanamide (CAS No. 420-04-2) (provided for in subheading 2853.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.81",
      "rawHtsCode": "9902.01.81",
      "superior": null,
      "indent": "0",
      "description": "n-Butyl chloride (1-Chlorobutane) (CAS No. 109-69-3) (provided for in subheading 2903.19.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.82",
      "rawHtsCode": "9902.01.82",
      "superior": null,
      "indent": "0",
      "description": "1,6-Dichlorohexane (CAS No. 2163-00-0) (provided for in subheading 2903.19.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.83",
      "rawHtsCode": "9902.01.83",
      "superior": null,
      "indent": "0",
      "description": "Allyl Bromide (3-bromo-1-propene) (CAS No. 106-95-6) (provided for in subheading 2903.39.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.84",
      "rawHtsCode": "9902.01.84",
      "superior": null,
      "indent": "0",
      "description": "1,6,7,8,9,14,15,16,17,17,18,18-Dodecachloropentacy- clo[12.2.1.16,9.02,13.05,10]octadeca-7,15-diene (CAS No. 13560-89-9) (provided for in subheading 2903.89.31)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.85",
      "rawHtsCode": "9902.01.85",
      "superior": null,
      "indent": "0",
      "description": "Chlorobenzene (CAS No.108-90-7) (provided for in subheading 2903.91.10)",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.86",
      "rawHtsCode": "9902.01.86",
      "superior": null,
      "indent": "0",
      "description": "o-Dichlorobenzene (1,2-dichlorobenzene) (CAS No. 95-50-1) (provided for in subheading 2903.91.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.87",
      "rawHtsCode": "9902.01.87",
      "superior": null,
      "indent": "0",
      "description": "p-Dichlorobenzene (1,4-dichlorobenzene) (CAS No. 106-46-7) (provided for in subheading 2903.91.30)",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.88",
      "rawHtsCode": "9902.01.88",
      "superior": null,
      "indent": "0",
      "description": "1-Chloro-4-(trifluoromethyl) benzene (CAS No. 98-56-6) (provided for in subheading 2903.99.08)",
      "units": [],
      "generalRate": "4.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.89",
      "rawHtsCode": "9902.01.89",
      "superior": null,
      "indent": "0",
      "description": "1,2,4-Trichlorobenzene (CAS No. 120-82-1) (provided for in subheading 2903.99.10)",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.90",
      "rawHtsCode": "9902.01.90",
      "superior": null,
      "indent": "0",
      "description": "α,α,α-Trichlorotoluene (CAS No. 98-07-7) (provided for in subheading 2903.99.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.91",
      "rawHtsCode": "9902.01.91",
      "superior": null,
      "indent": "0",
      "description": "2-Chlorobenzyl chloride (CAS No. 611-19-8) (provided for in subheading 2903.99.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.92",
      "rawHtsCode": "9902.01.92",
      "superior": null,
      "indent": "0",
      "description": "Dichloromethylbenzene (CAS no. 29797-40-8) (provided for in subheading 2903.99.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.93",
      "rawHtsCode": "9902.01.93",
      "superior": null,
      "indent": "0",
      "description": "1-Chloro-2-chloromethyl-3-fluorobenzene (CAS No. 55117-15-2) (provided for in subheading 2903.99.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.94",
      "rawHtsCode": "9902.01.94",
      "superior": null,
      "indent": "0",
      "description": "2-Bromo-1,3-diethyl-5-methylbenzene (CAS No. 314084-61-2) (DEMBB) (provided for in subheading 2903.99.80)",
      "units": [],
      "generalRate": "2.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.95",
      "rawHtsCode": "9902.01.95",
      "superior": null,
      "indent": "0",
      "description": "2-Chlorotoluene (CAS No. 95-49-8) (provided for in subheading \n2903.99.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.96",
      "rawHtsCode": "9902.01.96",
      "superior": null,
      "indent": "0",
      "description": "1-(Chloromethyl)-3-methylbenzene (CAS No. 620-19-9) (provided for in subheading 2903.99.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.97",
      "rawHtsCode": "9902.01.97",
      "superior": null,
      "indent": "0",
      "description": "Benzenesulfonyl chloride (CAS No. 98-09-9) (provided for in subheading 2904.10.08)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.98",
      "rawHtsCode": "9902.01.98",
      "superior": null,
      "indent": "0",
      "description": "Lithium p-styrenesulfonate (CAS No. 4551-88-6) (provided for in subheading 2904.10.32)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.01.99",
      "rawHtsCode": "9902.01.99",
      "superior": null,
      "indent": "0",
      "description": "Sodium 4-vinylbenzenesulfonate (CAS No. 2695-37-6) (provided for in subheading 2904.10.37)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.01",
      "rawHtsCode": "9902.02.01",
      "superior": null,
      "indent": "0",
      "description": "p-Toluenesulfonic acid (4-methylbenzenesulfonic acid hydrate (1:1)) (CAS No. 6192-52-5) (provided for in subheading 2904.10.37)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.02",
      "rawHtsCode": "9902.02.02",
      "superior": null,
      "indent": "0",
      "description": "Methanesulfonic acid (CAS No. 75-75-2) (provided for in subheading 2904.10.50)",
      "units": [],
      "generalRate": "0.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.03",
      "rawHtsCode": "9902.02.03",
      "superior": null,
      "indent": "0",
      "description": "Methanesulfonyl chloride (CAS No. 124-63-0) (provided for in subheading 2904.10.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.04",
      "rawHtsCode": "9902.02.04",
      "superior": null,
      "indent": "0",
      "description": "4-Chloro-3,5-dinitro-α,α,α-trifluorotoluene (CAS No. 393-75-9) (provided for in subheading 2904.99.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.05",
      "rawHtsCode": "9902.02.05",
      "superior": null,
      "indent": "0",
      "description": "2-Methyl-5-nitrobenzenesulfonic acid (CAS No. 121-03-9) (provided for in subheading 2904.99.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.06",
      "rawHtsCode": "9902.02.06",
      "superior": null,
      "indent": "0",
      "description": "Triflic acid (trifluoromethanesulfonic acid) (CAS No.1493-13-6) (provided for in subheading 2904.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.07",
      "rawHtsCode": "9902.02.07",
      "superior": null,
      "indent": "0",
      "description": "Triflic anhydride (trifluoromethanesulfonic anhydride) (CAS No. 358-23-6) (provided for in subheading 2904.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.08",
      "rawHtsCode": "9902.02.08",
      "superior": null,
      "indent": "0",
      "description": "Potassium 2,2,3,3,4,4,5,5,6,6-decafluoro-1-(pentafluoroethyl)cy- clohexanesulfonate (CAS No. 67584-42-3) (provided for in subheading 2904.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.09",
      "rawHtsCode": "9902.02.09",
      "superior": null,
      "indent": "0",
      "description": "2-Octanol (CAS No. 123-96-6) (provided for in subheading 2905.16.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.10",
      "rawHtsCode": "9902.02.10",
      "superior": null,
      "indent": "0",
      "description": "16-Methyl-1-heptadecanol (Isostearyl alcohol) (CAS No. 27458-93-1) (provided for in subheading 2905.19.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.11",
      "rawHtsCode": "9902.02.11",
      "superior": null,
      "indent": "0",
      "description": "Sodium methylate powder (CAS No. 124-41-4) (provided for in subheading 2905.19.90) \n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.12",
      "rawHtsCode": "9902.02.12",
      "superior": null,
      "indent": "0",
      "description": "Magnesium bis(2-methyl-2-propanolate) (Magenesium tert-butoxide) (CAS No. 32149-57-8) (provided for in subheading 2905.19.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.13",
      "rawHtsCode": "9902.02.13",
      "superior": null,
      "indent": "0",
      "description": "2-Propyn-1-ol (propargyl alcohol) (CAS No. 107-19-7) (provided for in subheading 2905.29.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.14",
      "rawHtsCode": "9902.02.14",
      "superior": null,
      "indent": "0",
      "description": "cis-3-Hexen-1-ol (CAS No. 928-96-1) (provided for in subheading 2905.29.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.15",
      "rawHtsCode": "9902.02.15",
      "superior": null,
      "indent": "0",
      "description": "1,2-Pentanediol (CAS No. 5343-92-0) (provided for in subheading 2905.39.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.16",
      "rawHtsCode": "9902.02.16",
      "superior": null,
      "indent": "0",
      "description": "2,5-Dimethyl-2,5-hexanediol (CAS No. 110-03-2) (provided for in subheading 2905.39.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.17",
      "rawHtsCode": "9902.02.17",
      "superior": null,
      "indent": "0",
      "description": "d-Menthol (CAS No. 15356-60-2)(provided for in subheading 2906.11.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.19",
      "rawHtsCode": "9902.02.19",
      "superior": null,
      "indent": "0",
      "description": "α-Naphthol (CAS No. 90-15-3) (provided for in subheading 2907.15.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.20",
      "rawHtsCode": "9902.02.20",
      "superior": null,
      "indent": "0",
      "description": "Thymol (2-isopropyl-5-methylphenol) (CAS No. 89-83-8) (provided for in subheading 2907.19.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.21",
      "rawHtsCode": "9902.02.21",
      "superior": null,
      "indent": "0",
      "description": "2-Phenylphenol (CAS No. 90-43-7) (provided for in subheading 2907.19.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.22",
      "rawHtsCode": "9902.02.22",
      "superior": null,
      "indent": "0",
      "description": "2-Phenylphenol sodium salt (CAS No. 132-27-4) (provided for in subheading 2907.19.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.23",
      "rawHtsCode": "9902.02.23",
      "superior": null,
      "indent": "0",
      "description": "Resorcinol (CAS No. 108-46-3) (provided for in subheading 2907.21.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.24",
      "rawHtsCode": "9902.02.24",
      "superior": null,
      "indent": "0",
      "description": "Pyrogallol (Pyrogallic acid) (CAS No. 87-66-1) (provided for in subheading 2907.29.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.25",
      "rawHtsCode": "9902.02.25",
      "superior": null,
      "indent": "0",
      "description": "Leucoquinizarin as 1,4,9,10-tetrahydroxyanthracene (CAS No. 476-60-8), 2,3-dihydro-9,10-dihydroxyanthracene-1,4-dione (CAS No. 17648-03-2) or 2,3-dihydro-1,4-dihydroxy-9,10-anthracenedione (CAS No. 40498-13-3) (provided for in subheading 2907.29.90 or 2914.69.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.26",
      "rawHtsCode": "9902.02.26",
      "superior": null,
      "indent": "0",
      "description": "6,6'-Di-tert-butyl-2,2'-methylenedi-p-cresol (CAS No. 119-47-1) (provided for in subheading 2907.29.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.27",
      "rawHtsCode": "9902.02.27",
      "superior": null,
      "indent": "0",
      "description": "2,2'-(2-Methyl-1,1-propanediyl)bis(4,6-dimethylphenol) (CAS No. 33145-10-7) (provided for in subheading 2907.29.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.28",
      "rawHtsCode": "9902.02.28",
      "superior": null,
      "indent": "0",
      "description": "4,4'-(1,1-Butanediyl)bis[5-methyl-2-(2-methyl-2-propanyl)phenol] (CAS No. 85-60-9) (provided for in subheading 2907.29.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.29",
      "rawHtsCode": "9902.02.29",
      "superior": null,
      "indent": "0",
      "description": "2,5-Bis(2-methyl-2-butanyl)-1,4-benzenediol (CAS No. 79-74-3) (provided for in subheading 2907.29.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.30",
      "rawHtsCode": "9902.02.30",
      "superior": null,
      "indent": "0",
      "description": "4,4',4''-(1,1,3-Butanetriyl)tris[5-methyl-2-(2-methyl-2-propa- nyl)phenol] (CAS No. 1843-03-4) (provided for in subheading 2907.29.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.31",
      "rawHtsCode": "9902.02.31",
      "superior": null,
      "indent": "0",
      "description": "2,2'-Methylenebis[4-ethyl-6-(2-methyl-2-propanyl)phenol] (CAS No. 88-24-4) (provided for in subheading 2907.29.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.32",
      "rawHtsCode": "9902.02.32",
      "superior": null,
      "indent": "0",
      "description": "2-Nitrophenol (o-nitrophenol) (CAS No. 88-75-5) (provided for in subheading 2908.99.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.33",
      "rawHtsCode": "9902.02.33",
      "superior": null,
      "indent": "0",
      "description": "3-Trifluoromethyl-4-nitrophenol (CAS No. 88-30-2) (provided for in subheading 2908.99.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.34",
      "rawHtsCode": "9902.02.34",
      "superior": null,
      "indent": "0",
      "description": "2,5,8,11,14,17,20-Heptaoxadocosan-22-ol methanesulfonate (CAS No. 477775-57-8) (provided for in subheading 2909.19.60).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.35",
      "rawHtsCode": "9902.02.35",
      "superior": null,
      "indent": "0",
      "description": "2-Chloro-α,α,α-trifluoro-p-tolyl-3-ethoxy-4-nitrophenyl ether (Oxyfluorfen) (CAS No. 42874-03-3) (provided for in subheading 2909.30.30)",
      "units": [],
      "generalRate": "0.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.36",
      "rawHtsCode": "9902.02.36",
      "superior": null,
      "indent": "0",
      "description": "1-Methoxy-2,4-dinitrobenzene (2,4-Dinitroanisole) (CAS No. 119-27-7) (provided for in subheading 2909.30.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.37",
      "rawHtsCode": "9902.02.37",
      "superior": null,
      "indent": "0",
      "description": "2-(Hydroxymethyl)-2-(prop-2-enoxymethyl) propane-1,3-diol (CAS No. 91648-24-7) (provided for in subheading 2909.49.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.38",
      "rawHtsCode": "9902.02.38",
      "superior": null,
      "indent": "0",
      "description": "t-Butyl cumyl peroxide ({2-[(2-methyl-2-propanyl)peroxy]-2-propanyl}benzene) (CAS No. 3457-61-2) (provided for in subheading 2909.60.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.39",
      "rawHtsCode": "9902.02.39",
      "superior": null,
      "indent": "0",
      "description": "Bis(α,α-dimethylbenzyl) peroxide (dicumyl peroxide) (CAS No. 80-43-3) (provided for in subheading 2909.60.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.40",
      "rawHtsCode": "9902.02.40",
      "superior": null,
      "indent": "0",
      "description": "2-Phenyl-2-propanyl hydroperoxide (cumene hydroperoxide) (CAS No. 80-15-9) (provided for in subheading 2909.60.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.41",
      "rawHtsCode": "9902.02.41",
      "superior": null,
      "indent": "0",
      "description": "2,5-Dimethyl-2,5-bis[(2-methyl-2-propanyl)peroxy]hexane (CAS No. 78-63-7) (provided for in HTS subheading 2909.60.50).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.42",
      "rawHtsCode": "9902.02.42",
      "superior": null,
      "indent": "0",
      "description": "(2S)-2-[(Allyloxy)methyl]oxirane (CAS No. 106-92-3) (provided for in subheading 2910.90.91)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.43",
      "rawHtsCode": "9902.02.43",
      "superior": null,
      "indent": "0",
      "description": "2-Bromo-1,1-dimethoxyethane (CAS No. 7252-83-7) (provided for in subheading 2911.00.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.44",
      "rawHtsCode": "9902.02.44",
      "superior": null,
      "indent": "0",
      "description": "3,7-Dimethylocta-2,6-dienal (citral) (CAS No. 5392-40-5) (provided for in subheading 2912.19.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.45",
      "rawHtsCode": "9902.02.45",
      "superior": null,
      "indent": "0",
      "description": "Glyoxal (CAS No. 107-22-2) (provided for in subheading 2912.19.30)",
      "units": [],
      "generalRate": "0.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.46",
      "rawHtsCode": "9902.02.46",
      "superior": null,
      "indent": "0",
      "description": "4-Propylbenzaldehyde (CAS No. 28785-06-0) (provided for in subheading 2912.29.60)",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.47",
      "rawHtsCode": "9902.02.47",
      "superior": null,
      "indent": "0",
      "description": "Cyclobutanecarboxaldehyde (CAS No. 2987-17-9) (provided for in subheading 2912.29.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.48",
      "rawHtsCode": "9902.02.48",
      "superior": null,
      "indent": "0",
      "description": "2-Methyl-3-[4-(2-methyl-2-propanyl)phenyl]propanal (Lily aldehyde) (CAS No. 80-54-6) (provided for in subheading 2912.29.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.49",
      "rawHtsCode": "9902.02.49",
      "superior": null,
      "indent": "0",
      "description": "p-Anisaldehyde (4-methoxybenzaldehyde) (CAS No. 123-11-5) (provided for in subheading 2912.49.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.50",
      "rawHtsCode": "9902.02.50",
      "superior": null,
      "indent": "0",
      "description": "2-Methoxy-5-(2-methyl-2-propanyl)benzaldehyde (CAS No. 85943-26-6) (provided for in subheading 2912.49.26)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.51",
      "rawHtsCode": "9902.02.51",
      "superior": null,
      "indent": "0",
      "description": "7-Hydroxycitronellal (7-Hydroxy-3,7-dimethyloctanal) (CAS No. 107-75-5) (provided for in subheading 2912.49.55)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.52",
      "rawHtsCode": "9902.02.52",
      "superior": null,
      "indent": "0",
      "description": "2,4-Disulfobenzaldehyde (CAS No. 88-39-1) (provided for in subheading 2913.00.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.53",
      "rawHtsCode": "9902.02.53",
      "superior": null,
      "indent": "0",
      "description": "p-(Trifluoromethyl)benzaldehyde (CAS No. 455-19-6) (provided for in subheading 2913.00.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.54",
      "rawHtsCode": "9902.02.54",
      "superior": null,
      "indent": "0",
      "description": "3-Pentanone (Diethyl ketone) (CAS No. 96-22-0) (provided for in subheading 2914.19.00)",
      "units": [],
      "generalRate": "0.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.55",
      "rawHtsCode": "9902.02.55",
      "superior": null,
      "indent": "0",
      "description": "(3E)-4-(2,6,6-Trimethyl-2-cyclohexen-1-yl)-3-buten-2-one (CAS No. 79-77-6) (provided for in subheading 2914.23.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.56",
      "rawHtsCode": "9902.02.56",
      "superior": null,
      "indent": "0",
      "description": "3-Methyl-4-(2,6,6-trimethylcyclohex-2-enyl)but-3-en-2-one (Methylionone)(CAS No. 1335-46-2) (provided for in subheading 2914.23.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.57",
      "rawHtsCode": "9902.02.57",
      "superior": null,
      "indent": "0",
      "description": "1,3-Cyclohexanedione (CAS No. 504-02-9) (provided for in subheading 2914.29.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.58",
      "rawHtsCode": "9902.02.58",
      "superior": null,
      "indent": "0",
      "description": "3-[2-Chloro-4-(methylsulfonyl)benzoyl]-4-(phenylsul- fanyl)bicyclo[3.2.1]oct-3-en-2-one (Benzobicyclon) (CAS No. 156963-66-5) (provided for in subheading 2914.29.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.59",
      "rawHtsCode": "9902.02.59",
      "superior": null,
      "indent": "0",
      "description": "Cyclopentanone (CAS No. 120-92-3) (provided for in subheading 2914.29.50)",
      "units": [],
      "generalRate": "1.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.60",
      "rawHtsCode": "9902.02.60",
      "superior": null,
      "indent": "0",
      "description": "Benzophenone (CAS No. 119-61-9) (provided for in subheading 2914.39.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.61",
      "rawHtsCode": "9902.02.61",
      "superior": null,
      "indent": "0",
      "description": "5-Chloro-1-indanone (CAS No. 42348-86-7) (provided for in subheading 2914.39.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.62",
      "rawHtsCode": "9902.02.62",
      "superior": null,
      "indent": "0",
      "description": "p-Methylacetophenone (1-(4-Methylphenyl)ethanone) (CAS No. 122-00-9) (provided for in subheading 2914.39.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.63",
      "rawHtsCode": "9902.02.63",
      "superior": null,
      "indent": "0",
      "description": "1-Hydroxy-2-methylpentan-3-one (CAS No. 27970-79-2) (provided for in subheading 2914.40.90)",
      "units": [],
      "generalRate": "1.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.64",
      "rawHtsCode": "9902.02.64",
      "superior": null,
      "indent": "0",
      "description": "2,4-Dihydroxybenzophenone (CAS No. 131-56-6) (provided for in subheading 2914.50.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.65",
      "rawHtsCode": "9902.02.65",
      "superior": null,
      "indent": "0",
      "description": "4-(4-Hydroxyphenyl)butan-2-one (raspberry ketone) (CAS No. 5471-51-2) (provided for in subheading 2914.50.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.66",
      "rawHtsCode": "9902.02.66",
      "superior": null,
      "indent": "0",
      "description": "4,4-Dimethoxy-2-butanone (CAS No. 5436-21-5) (provided for in subheading 2914.50.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.67",
      "rawHtsCode": "9902.02.67",
      "superior": null,
      "indent": "0",
      "description": "2-tert-Amylanthraquinone (2-(2-methyl-2-butanyl)-9,10-anthraquinone) (CAS No. 32588-54-8) (provided for in subheading 2914.69.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.68",
      "rawHtsCode": "9902.02.68",
      "superior": null,
      "indent": "0",
      "description": "1-Nitroanthraquinone (1-nitroanthracene-9,10-dione) (CAS No. 82-34-8) (provided for in subheading 2914.79.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.69",
      "rawHtsCode": "9902.02.69",
      "superior": null,
      "indent": "0",
      "description": "1-(4-Chlorophenyl)-4,4-dimethylpentan-3-one (Alkylketone) (CAS No. 66346-01-8) (provided for in subheading 2914.79.40).",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.70",
      "rawHtsCode": "9902.02.70",
      "superior": null,
      "indent": "0",
      "description": "1,5-Dichloro-9,10-anthraquinone (CAS No. 82-46-2) (provided for in subheading 2914.79.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.71",
      "rawHtsCode": "9902.02.71",
      "superior": null,
      "indent": "0",
      "description": "(3E)-4-Ethoxy-1,1,1-trifluorobut-3-en-2-one (CAS No. 59938-06-6) (provided for in subheading 2914.79.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.72",
      "rawHtsCode": "9902.02.72",
      "superior": null,
      "indent": "0",
      "description": "(3-Bromo-6-methoxy-2-methylphenyl)(2,3,4-trimethoxy-6- methylphenyl)methanone (Metrafenone) (CAS No. 220899-03-6) (provided for in subheading 2914.79.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.73",
      "rawHtsCode": "9902.02.73",
      "superior": null,
      "indent": "0",
      "description": "cis-2-tert-Butylcyclohexyl acetate (Argumex) (CAS No. 20298-69-5) (provided for in subheading 2915.39.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.74",
      "rawHtsCode": "9902.02.74",
      "superior": null,
      "indent": "0",
      "description": "Dichloroacetyl chloride (DCAC) (CAS No. 79-36-7) (provided for in subheading 2915.40.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.75",
      "rawHtsCode": "9902.02.75",
      "superior": null,
      "indent": "0",
      "description": "Methyl 2-chloroacetate (CAS No. 96-34-4) (provided for in subheading 2915.40.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.76",
      "rawHtsCode": "9902.02.76",
      "superior": null,
      "indent": "0",
      "description": "Ethyl chloroacetate (CAS No. 105-39-5) (provided for in subheading 2915.40.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.78",
      "rawHtsCode": "9902.02.78",
      "superior": null,
      "indent": "0",
      "description": "Vinyl neodecanoate (vinyl 7,7-dimethyloctanoate) (CAS No. 51000-52-3) (provided for in subheading 2915.90.18)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.79",
      "rawHtsCode": "9902.02.79",
      "superior": null,
      "indent": "0",
      "description": "Dilauroyl peroxide (CAS No. 105-74-8) (provided for in subheading 2915.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.80",
      "rawHtsCode": "9902.02.80",
      "superior": null,
      "indent": "0",
      "description": "Triglyceryl octanoate (CAS No. 108777-93-1) (provided for in subheading 2915.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.81",
      "rawHtsCode": "9902.02.81",
      "superior": null,
      "indent": "0",
      "description": "t-Butyl acrylate (2-methyl-2-propanyl acrylate) (CAS No. 1663-39-4) (provided for in subheading 2916.12.50)",
      "units": [],
      "generalRate": "0.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.82",
      "rawHtsCode": "9902.02.82",
      "superior": null,
      "indent": "0",
      "description": "Allyl methacrylate (CAS No. 96-05-9) (provided for in subheading 2916.14.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.83",
      "rawHtsCode": "9902.02.83",
      "superior": null,
      "indent": "0",
      "description": "(2E,4E)-2,4-Hexadienoic acid (Sorbic acid) (CAS No. 110-44-1) (provided for in subheading 2916.19.20)",
      "units": [],
      "generalRate": "2.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.84",
      "rawHtsCode": "9902.02.84",
      "superior": null,
      "indent": "0",
      "description": "(E)-2-Butenoic acid (trans-crotonic acid) (CAS No. 107-93-7) (provided for in subheading 2916.19.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.85",
      "rawHtsCode": "9902.02.85",
      "superior": null,
      "indent": "0",
      "description": "Pinane hydroperoxide (2,6,6-trimethlybicyclo[3.1.1]heptyl hydroperoxide) (CAS No. 28324-52-9) (provided for in subheading 2916.20.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.86",
      "rawHtsCode": "9902.02.86",
      "superior": null,
      "indent": "0",
      "description": "2-Methylbiphenyl-3-ylmethyl (1RS,3RS)-3-[(Z)-2-chloro- 3,3,3-trifluoroprop-1-enyl]-2,2-dimethylcyclopropanecar- boxylate (Bifenthrin) (CAS No. 82657-04-3) (provided for in subheading 2916.20.50)",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.87",
      "rawHtsCode": "9902.02.87",
      "superior": null,
      "indent": "0",
      "description": "Benzoyl chloride (CAS No. 98-88-4) (provided for in subheading 2916.32.20)",
      "units": [],
      "generalRate": "2.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.88",
      "rawHtsCode": "9902.02.88",
      "superior": null,
      "indent": "0",
      "description": "4-Nitrobenzoyl chloride (CAS No.122-04-3) (provided for in subheading 2916.39.03)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.89",
      "rawHtsCode": "9902.02.89",
      "superior": null,
      "indent": "0",
      "description": "Methyl (2E)-3-phenylacrylate (Methyl cinnamate) (CAS No. 103-26-4) (provided for in subheading 2916.39.21)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.90",
      "rawHtsCode": "9902.02.90",
      "superior": null,
      "indent": "0",
      "description": "Bis(2,4-dichlorobenzoyl) peroxide (CAS No. 133-14-2) (provided for in subheading 2916.39.79)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.91",
      "rawHtsCode": "9902.02.91",
      "superior": null,
      "indent": "0",
      "description": "Oxalic acid (ethanedioic acid dihydrate) (CAS No. 6153-56-6) (provided for in subheading 2917.11.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.92",
      "rawHtsCode": "9902.02.92",
      "superior": null,
      "indent": "0",
      "description": "Dimethyl oxalate (CAS No. 553-90-2) (provided for in subheading 2917.11.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.93",
      "rawHtsCode": "9902.02.93",
      "superior": null,
      "indent": "0",
      "description": "Sebacic acid (CAS No. 111-20-6) (provided for in subheading 2917.13.00)",
      "units": [],
      "generalRate": "2.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.94",
      "rawHtsCode": "9902.02.94",
      "superior": null,
      "indent": "0",
      "description": "Dimethyl malonate (CAS No. 108-59-8) (provided for in subheading 2917.19.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.95",
      "rawHtsCode": "9902.02.95",
      "superior": null,
      "indent": "0",
      "description": "Itaconic acid (2-methylidenebutanedioic acid) (CAS No. 97-65-4) (provided for in subheading 2917.19.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.96",
      "rawHtsCode": "9902.02.96",
      "superior": null,
      "indent": "0",
      "description": "Himic anhydride (1,2,3,6-tetrahydro-3,6-methanophthalic anhydride) (CAS No. 826-62-0) (provided for in subheading 2917.20.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.97",
      "rawHtsCode": "9902.02.97",
      "superior": null,
      "indent": "0",
      "description": "Potassium 1,3-dioxo-1H,3H-benzo[de]isochromene-6-sulfonate (CAS No. 71501-16-1) (provided in subheading 2917.39.04)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.02.99",
      "rawHtsCode": "9902.02.99",
      "superior": null,
      "indent": "0",
      "description": "5,5'-Bi-2-benzofuran-1,1',3,3'-tetrone (CAS No. 2420-87-3) (provided for in subheading 2917.39.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.01",
      "rawHtsCode": "9902.03.01",
      "superior": null,
      "indent": "0",
      "description": "Naphthalene-1,8:4,5-tetracarboxylic dianhydride (CAS No. 81-30-1) (provided for in subheading 2917.39.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.02",
      "rawHtsCode": "9902.03.02",
      "superior": null,
      "indent": "0",
      "description": "Pyromellitic dianhydride (benzene-1,2:4,5-tetracarboxylic dianhydride) (CAS No. 89-32-7) (provided for in subheading 2917.39.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.03",
      "rawHtsCode": "9902.03.03",
      "superior": null,
      "indent": "0",
      "description": "Dimethyl 5-nitroisophthalate (CAS No. 13290-96-5) (provided for in subheading 2917.39.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.04",
      "rawHtsCode": "9902.03.04",
      "superior": null,
      "indent": "0",
      "description": "Isophthaloyl chloride (CAS No. 99-63-8) (provided for in subheading 2917.39.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.05",
      "rawHtsCode": "9902.03.05",
      "superior": null,
      "indent": "0",
      "description": "Terephthaloyl chloride (CAS No. 100-20-9) (provided for in subheading 2917.39.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.06",
      "rawHtsCode": "9902.03.06",
      "superior": null,
      "indent": "0",
      "description": "3-Hydroxy-2,2-dimethylpropyl-3-hydroxy-2,2-dimethylpropionate (CAS No. 1115-20-4) (provided for in subheading 2918.19.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.07",
      "rawHtsCode": "9902.03.07",
      "superior": null,
      "indent": "0",
      "description": "o-Acetylsalicylic acid (Aspirin) (CAS No. 50-78-2) (provided for in subheading 2918.22.10)",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.08",
      "rawHtsCode": "9902.03.08",
      "superior": null,
      "indent": "0",
      "description": "Methyl salicylate (CAS No. 119-36-8) (provided for in subheading 2918.23.20)",
      "units": [],
      "generalRate": "2.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.09",
      "rawHtsCode": "9902.03.09",
      "superior": null,
      "indent": "0",
      "description": "4-Hydroxybenzoic acid (CAS No. 99-96-7) (provided for in subheading 2918.29.22)",
      "units": [],
      "generalRate": "2.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.10",
      "rawHtsCode": "9902.03.10",
      "superior": null,
      "indent": "0",
      "description": "3,4,5-Trihydroxybenzoic acid monohydrate (Gallic acid monohydrate) (CAS No. 5995-86-8) (provided for in subheading 2918.29.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.11",
      "rawHtsCode": "9902.03.11",
      "superior": null,
      "indent": "0",
      "description": "C7-C9-Alkyl 3-(3,5-di-trans-butyl-4-hydroxyphenyl) propionate (CAS No. 125643-61-0) (provided in subheading 2918.29.65)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.12",
      "rawHtsCode": "9902.03.12",
      "superior": null,
      "indent": "0",
      "description": "Propyl 3,4,5-trihydroxybenzoate (Propyl gallate) (CAS No. 121-79-9) (provided for in subheading 2918.29.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.13",
      "rawHtsCode": "9902.03.13",
      "superior": null,
      "indent": "0",
      "description": "Octadecyl 3-(3,5-di-tert-butyl-4-hydroxyphenyl)propionate (CAS No. 2082-79-3) (provided for in subheading 2918.29.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.14",
      "rawHtsCode": "9902.03.14",
      "superior": null,
      "indent": "0",
      "description": "Pentaerythritol tetrakis(3-(3,5-di-tert-butyl-4-hydroxyphenyl)propionate) (CAS No. 6683-19-8) (provided for in subheading 2918.29.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.15",
      "rawHtsCode": "9902.03.15",
      "superior": null,
      "indent": "0",
      "description": "Ethyl 4-hydroxybenzoate (CAS No. 120-47-8) (provided for in subheading 2918.29.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.16",
      "rawHtsCode": "9902.03.16",
      "superior": null,
      "indent": "0",
      "description": "Methyl 4-hydroxybenzoate (CAS No. 99-76-3) (provided for in subheading 2918.29.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.17",
      "rawHtsCode": "9902.03.17",
      "superior": null,
      "indent": "0",
      "description": "Hexadecyl 4-hydroxy-3,5-bis(2-methyl-2-propanyl)benzoate (CAS No. 67845-93-6) (provided for in subheading 2918.29.75) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.18",
      "rawHtsCode": "9902.03.18",
      "superior": null,
      "indent": "0",
      "description": "2-Benzoylbenzoic acid (CAS No. 85-52-9) (provided for in subheading 2918.30.30)",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.19",
      "rawHtsCode": "9902.03.19",
      "superior": null,
      "indent": "0",
      "description": "Prohexadione-calcium (Calcium bis(3,5-dioxo-4-propionylcyclohexanecarboxylate)) (CAS No. 127277-53-6) (provided for in subheading 2918.30.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.20",
      "rawHtsCode": "9902.03.20",
      "superior": null,
      "indent": "0",
      "description": "Glyoxyl acid (Glyoxylic acid) (CAS No. 298-12-4) (provided for in subheading 2918.30.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.21",
      "rawHtsCode": "9902.03.21",
      "superior": null,
      "indent": "0",
      "description": "(+)-(R)-2-(2,4-Dichlorophenoxy)propanoic acid (Dichlorprop-p) (CAS No. 15165-67-0) (provided for in subheading 2918.99.18)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.22",
      "rawHtsCode": "9902.03.22",
      "superior": null,
      "indent": "0",
      "description": "4-(2,4-Dichlorophenoxy) butyric acid (2,4-DB) (CAS No.\n94-82-6) (provided for in subheading 2918.99.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.23",
      "rawHtsCode": "9902.03.23",
      "superior": null,
      "indent": "0",
      "description": "2-Methyl-4-chlorophenoxyacetic acid (MCPA) (CAS No. 94-74-6) (provided for in subheading 2918.99.20)",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.24",
      "rawHtsCode": "9902.03.24",
      "superior": null,
      "indent": "0",
      "description": "1-Ethoxy-1-oxo-2-propanyl 5-[2-chloro-4-(trifluoromethyl)phenoxy]-2-nitrobenzoate (Lactofen) (CAS No. 77501-63-4) (provided for in subheading 2918.99.20)",
      "units": [],
      "generalRate": "4.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.25",
      "rawHtsCode": "9902.03.25",
      "superior": null,
      "indent": "0",
      "description": "Triethylene glycol bis[3-(3-tert-butyl-4-hydroxy-5-methyl- phenyl)propionate] (CAS No. 36443-68-2) (provided for in subheading 2918.99.43)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.26",
      "rawHtsCode": "9902.03.26",
      "superior": null,
      "indent": "0",
      "description": "4,4ʹ-Oxydiphthalic anhydride (CAS No. 1823-59-2) (provided for in subheading 2918.99.43)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.27",
      "rawHtsCode": "9902.03.27",
      "superior": null,
      "indent": "0",
      "description": "2-Ethylhexyl 4-methoxycinnamate (CAS No. 5466-77-3) (provided for in subheading 2918.99.43)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.28",
      "rawHtsCode": "9902.03.28",
      "superior": null,
      "indent": "0",
      "description": "(R)-(+)-2-(4-Hydroxyphenoxy)propionic acid (CAS No. 94050-90-5)(provided for in subheading 2918.99.43)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.29",
      "rawHtsCode": "9902.03.29",
      "superior": null,
      "indent": "0",
      "description": "4,4’-Oxydibenzoyl chloride (CAS No. 7158-32-9) (provided for in subheading 2918.99.43)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.30",
      "rawHtsCode": "9902.03.30",
      "superior": null,
      "indent": "0",
      "description": "5,5'-Oxybis(2-benzofuran-1,3-dione) (CAS No.1823-59-2) (provided for in subheading 2918.99.43)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.31",
      "rawHtsCode": "9902.03.31",
      "superior": null,
      "indent": "0",
      "description": "Ethyl (RS)-4-cyclopropyl(hydroxy)methylene-3,5- dioxocyclohexanecarboxylate (Trinexapac-ethyl) (CAS No. 95266-40-3) (provided for in subheading 2918.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.32",
      "rawHtsCode": "9902.03.32",
      "superior": null,
      "indent": "0",
      "description": "Methyl methoxyacetate (CAS No. 6290-49-9) (provided for in subheading 2918.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.33",
      "rawHtsCode": "9902.03.33",
      "superior": null,
      "indent": "0",
      "description": "(2Z,4E)-5-[(1S)-1-Hydroxy-2,6,6-trimethyl-4-oxo-2-cy- clohexen-1-yl]-3-methyl-2,4-pentadienoic acid ((+)-Abscisic acid) (CAS No. 21293-29-8) (provided for in subheading 2918.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.34",
      "rawHtsCode": "9902.03.34",
      "superior": null,
      "indent": "0",
      "description": "Methoxyacetic acid (CAS No. 625-45-6) (provided for in subheading 2918.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.35",
      "rawHtsCode": "9902.03.35",
      "superior": null,
      "indent": "0",
      "description": "(Z)-2-Chloro-1-(2,4,5-trichlorophenyl)vinyl dimethyl phosphate (Tetrachlorvinfos) (CAS No. 22248-79-9) (provided for in subheading 2919.90.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.36",
      "rawHtsCode": "9902.03.36",
      "superior": null,
      "indent": "0",
      "description": "Bis(2,4-dichlorophenyl) phosphorochloridate (CAS No. 14254-41-2) (provided for in subheading 2919.90.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.37",
      "rawHtsCode": "9902.03.37",
      "superior": null,
      "indent": "0",
      "description": "Tris(2-ethylhexyl) phosphate (CAS No. 78-42-2) (provided for in subheading 2919.90.50)",
      "units": [],
      "generalRate": "0.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.38",
      "rawHtsCode": "9902.03.38",
      "superior": null,
      "indent": "0",
      "description": "O-(2,6-Dichloro-4-methylphenyl) O,O-dimethyl phosphorothioate (Tolclofos methyl) (CAS No. 57018-04-9) (provided for in subheading 2920.19.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.39",
      "rawHtsCode": "9902.03.39",
      "superior": null,
      "indent": "0",
      "description": "O,O-Diethyl phosphorochloridothioate (CAS No. 2524-04-1) (provided for in subheading 2920.19.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.40",
      "rawHtsCode": "9902.03.40",
      "superior": null,
      "indent": "0",
      "description": "Dimethyl phosphite (CAS No. 868-85-9) (provided for in subheading 2920.21.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.41",
      "rawHtsCode": "9902.03.41",
      "superior": null,
      "indent": "0",
      "description": "2-[4-(2-Methyl-2-propanyl)phenoxy]cyclohexyl 2-propyn-1-yl sulfite (Propargite) (CAS No. 2312-35-8) (provided for in subheading 2920.90.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.42",
      "rawHtsCode": "9902.03.42",
      "superior": null,
      "indent": "0",
      "description": "Tris(2,4-di-tert-butylphenyl) phosphite (CAS No. 31570-04-4) (provided for in subheading 2920.90.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1.",
        "The product referenced in this heading is likely classifiable in HTS subheading 2920.29.00, effective January 1, 2017; consult Customs for more information."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.43",
      "rawHtsCode": "9902.03.43",
      "superior": null,
      "indent": "0",
      "description": "Aluminum tris(ethyl phosphonate) (Fosetyl-Al) (CAS No. 39148-24-8) (provided for in subheading 2920.90.51)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.44",
      "rawHtsCode": "9902.03.44",
      "superior": null,
      "indent": "0",
      "description": "Bis(4-t-butylcyclohexyl)peroxydicarbonate (CAS No. 15520-11-3) (provided for in subheading 2920.90.51)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.45",
      "rawHtsCode": "9902.03.45",
      "superior": null,
      "indent": "0",
      "description": "2-Ethylhexyl nitrate (CAS No. 27247-96-7) (provided for in subheading 2920.90.51)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.46",
      "rawHtsCode": "9902.03.46",
      "superior": null,
      "indent": "0",
      "description": "Dimethyl carbonate (CAS No. 616-38-6) (provided for in subheading 2920.90.51)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.47",
      "rawHtsCode": "9902.03.47",
      "superior": null,
      "indent": "0",
      "description": "Bis(2-ethylhexyl) carbonate (diethylhexyl carbonate) (CAS No. 14858-73-2) (provided for in subheading 2920.90.51)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.48",
      "rawHtsCode": "9902.03.48",
      "superior": null,
      "indent": "0",
      "description": "2-Ethylhexylamine (CAS No. 104-75-6) (provided for in subheading 2921.19.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.49",
      "rawHtsCode": "9902.03.49",
      "superior": null,
      "indent": "0",
      "description": "Ditridecylamine (N-tridecyl-1-tridecanamine) (CAS No. 101012-97-9) (provided for in subheading 2921.19.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.50",
      "rawHtsCode": "9902.03.50",
      "superior": null,
      "indent": "0",
      "description": "C9-C15 Perfluorocarbon Amines (CAS No. 86508-42-1) (provided for in subheading 2921.19.61) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.51",
      "rawHtsCode": "9902.03.51",
      "superior": null,
      "indent": "0",
      "description": "N,N'-Bis(3-aminopropyl)ethylenediamine (CAS No. 10563-26-5) (provided for in subheading 2921.29.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.52",
      "rawHtsCode": "9902.03.52",
      "superior": null,
      "indent": "0",
      "description": "2,4,4-Trimethyl-1,6-hexanediamine (CAS No. 25620-58-0) (provided for in subheading 2921.29.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.53",
      "rawHtsCode": "9902.03.53",
      "superior": null,
      "indent": "0",
      "description": "N,N-Diethyl-1,3-propanediamine (CAS No. 104-78-9) (provided for in subheading 2921.29.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.54",
      "rawHtsCode": "9902.03.54",
      "superior": null,
      "indent": "0",
      "description": "2,4-Dichloroaniline (CAS No. 554-00-7) (provided for in subheading 2921.42.18)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.55",
      "rawHtsCode": "9902.03.55",
      "superior": null,
      "indent": "0",
      "description": "4-Chloro-2-nitroaniline (CAS No. 89-63-4) (provided for in subheading 2921.42.55)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.56",
      "rawHtsCode": "9902.03.56",
      "superior": null,
      "indent": "0",
      "description": "2-Nitroaniline (CAS No. 88-74-4) (provided for in subheading 2921.42.55)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.57",
      "rawHtsCode": "9902.03.57",
      "superior": null,
      "indent": "0",
      "description": "3,5-Difluoroaniline (CAS No. 372-39-4) (provided for in subheading 2921.42.65)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.58",
      "rawHtsCode": "9902.03.58",
      "superior": null,
      "indent": "0",
      "description": "2-Ethyl-N-[(2S)-1-methoxypropan-2-yl]-6-methylaniline (CAS No. 118604-70-9) (provided for in subheading 2921.42.65)",
      "units": [],
      "generalRate": "4.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.59",
      "rawHtsCode": "9902.03.59",
      "superior": null,
      "indent": "0",
      "description": "2,6-Dichloroaniline (CAS No. 608-31-1) (provided for in subheading 2921.42.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.60",
      "rawHtsCode": "9902.03.60",
      "superior": null,
      "indent": "0",
      "description": "N-Benzyl-N-ethylaniline (CAS No. 92-59-1) (provided for in subheading 2921.42.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.61",
      "rawHtsCode": "9902.03.61",
      "superior": null,
      "indent": "0",
      "description": "α-N-Ethylanilinotoluene-3-sulfonic acid (CAS No. 101-11-1) (provided for in subheading 2921.42.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.62",
      "rawHtsCode": "9902.03.62",
      "superior": null,
      "indent": "0",
      "description": "p-Chloroaniline (CAS No. 106-47-8) (provided for in subheading 2921.42.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.63",
      "rawHtsCode": "9902.03.63",
      "superior": null,
      "indent": "0",
      "description": "Sodium hydrogen 2-aminobenzene-1,4-disulfonate (CAS No. 24605-36-5) (provided for in subheading 2921.42.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.64",
      "rawHtsCode": "9902.03.64",
      "superior": null,
      "indent": "0",
      "description": "3-{[Ethyl(phenyl)amino]methyl}benzenesulfonic acid (CAS No. 101-11-1) (provided for in 2921.42.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.65",
      "rawHtsCode": "9902.03.65",
      "superior": null,
      "indent": "0",
      "description": "α,α,α-Trifluoro-2,6-dinitro-p-toluidine (Trifluralin) (CAS No. 1582-09-8) (provided for in subheading 2921.43.15)",
      "units": [],
      "generalRate": "4.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.66",
      "rawHtsCode": "9902.03.66",
      "superior": null,
      "indent": "0",
      "description": "N-Ethyl-N-(2-methyl-2-propenyl)-2,6-dinitro-4-(trifluor- omethyl)benzenamine (Ethalfluralin) (CAS No. 55283-68-6) (provided for in subheading 2921.43.22)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.67",
      "rawHtsCode": "9902.03.67",
      "superior": null,
      "indent": "0",
      "description": "p-Toluidine (CAS No. 106-49-0) (provided for in subheading 2921.43.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.68",
      "rawHtsCode": "9902.03.68",
      "superior": null,
      "indent": "0",
      "description": "N-Butyl-N-ethyl-α,α,α-trifluoro-2,6-dinitro-p-toluidine (Benfluralin) (CAS No. 1861-40-1) (provided for in subheading 2921.43.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.69",
      "rawHtsCode": "9902.03.69",
      "superior": null,
      "indent": "0",
      "description": "o-Chloro-p-toluidine (3-chloro-4-methylaniline) (CAS No. 95-74-9) (provided for in subheading 2921.43.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.70",
      "rawHtsCode": "9902.03.70",
      "superior": null,
      "indent": "0",
      "description": "m-Toluidine (CAS No.108-44-1) (provided for in subheading 2921.43.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.71",
      "rawHtsCode": "9902.03.71",
      "superior": null,
      "indent": "0",
      "description": "o-Toluidine (CAS No. 95-53-4) (provided for in subheading 2921.43.90)",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.72",
      "rawHtsCode": "9902.03.72",
      "superior": null,
      "indent": "0",
      "description": "N-sec-Butyl-4-(2-methyl-2-propanyl)-2,6-dinitroaniline (Butralin) (CAS No. 33629-47-9) (provided for in subheading 2921.43.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.73",
      "rawHtsCode": "9902.03.73",
      "superior": null,
      "indent": "0",
      "description": "4-Amino-3-methylbenzenesulfonic acid (CAS No. 98-33-9) (provided for in subheading 2921.43.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.74",
      "rawHtsCode": "9902.03.74",
      "superior": null,
      "indent": "0",
      "description": "2,4-Xylidine (CAS No. 95-68-1) (provided for in subheading 2921.49.10) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.75",
      "rawHtsCode": "9902.03.75",
      "superior": null,
      "indent": "0",
      "description": "Mixed xylidines (CAS No. 1300-73-8) (provided for in subheading 2921.49.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.76",
      "rawHtsCode": "9902.03.76",
      "superior": null,
      "indent": "0",
      "description": "Dodecylaniline branched isomers (CAS No. 68411-48-3) (provided for in subheading 2921.49.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.77",
      "rawHtsCode": "9902.03.77",
      "superior": null,
      "indent": "0",
      "description": "N-(2-Chloro-6-fluorobenzyl)-N-ethyl-α,α,α-trifluoro-\n2,6-dinitro-p-toluidine (Flumetralin) (CAS No. 62924-70-3) (provided for in subheading 2921.49.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.78",
      "rawHtsCode": "9902.03.78",
      "superior": null,
      "indent": "0",
      "description": "(1S)-1-Phenylethanamine (CAS No. 618-36-0) (provided for in subheading 2921.49.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.79",
      "rawHtsCode": "9902.03.79",
      "superior": null,
      "indent": "0",
      "description": "2-Ethyl-6-methylaniline (CAS No. 24549-06-2) (provided for in subheading 2921.49.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.80",
      "rawHtsCode": "9902.03.80",
      "superior": null,
      "indent": "0",
      "description": "m-Phenylenediamine (CAS No. 108-45-2) (provided for in subheading 2921.51.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1.",
        "Note that this provision and heading 9902.03.81 refer to products with the same CAS registry number. It is suggested that importers choose the heading that matches their shipment's invoice description, and consult U.S. Customs and Border Protection with any questions that arise."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.81",
      "rawHtsCode": "9902.03.81",
      "superior": null,
      "indent": "0",
      "description": "1,3-Benzenediamine (CAS No. 108-45-2) (provided for in subheading 2921.51.10)",
      "units": [],
      "generalRate": "4.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1.",
        "Note that this provision and heading 9902.03.80 refer to products with the same CAS registry number. It is suggested that importers choose the heading that matches their shipment's invoice description, and consult U.S. Customs and Border Protection with any questions that arise."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.82",
      "rawHtsCode": "9902.03.82",
      "superior": null,
      "indent": "0",
      "description": "N-Phenyl-p-phenylenediamine (CAS No. 101-54-2) (provided for in subheading 2921.51.50)",
      "units": [],
      "generalRate": "4.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.83",
      "rawHtsCode": "9902.03.83",
      "superior": null,
      "indent": "0",
      "description": "4,4' Methylenebis(2-chloroaniline) (CAS No. 101-14-4) (provided for in subheading 2921.59.08)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.84",
      "rawHtsCode": "9902.03.84",
      "superior": null,
      "indent": "0",
      "description": "4,4'-Diamino-2,2'-stilbenedisulfonic acid (CAS No. 81-11-8) (provided for in subheading 2921.59.20)",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.85",
      "rawHtsCode": "9902.03.85",
      "superior": null,
      "indent": "0",
      "description": "2,2'-Bis(trifluoromethyl)-4,4'-biphenyldiamine (CAS No. 341-58-2) (provided for in subheading 2921.59.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.86",
      "rawHtsCode": "9902.03.86",
      "superior": null,
      "indent": "0",
      "description": "2,2'-[[(1S,2S)-1,2-Diphenyl-1,2-ethanediyl]bis(im- inomethylene)]bis[6-(1,1-dimethylethylphenol] (CAS No. 481725-63-7) (provided for in subheading 2921.59.40) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.87",
      "rawHtsCode": "9902.03.87",
      "superior": null,
      "indent": "0",
      "description": "2,6-Dinitro-N,N-dipropyl-4-(trifluoromethyl)-1,3-benzenediamine (Prodiamine) (CAS No. 29091-21-2) (provided for in subheading 2921.59.80)",
      "units": [],
      "generalRate": "1.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.88",
      "rawHtsCode": "9902.03.88",
      "superior": null,
      "indent": "0",
      "description": "3,3'-Dichlorobenzidine dihydrochloride (3,3'-Dichloro-4,4'-biphenyldiamine dihydrochloride) (CAS No. 612-83-9) (provided for in subheading 2921.59.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.89",
      "rawHtsCode": "9902.03.89",
      "superior": null,
      "indent": "0",
      "description": "2-{[2,4,8,10-Tetrakis(2-methyl-2-propanyl)diben- zo[d,f][1,3,2]dioxaphosphepin-6-yl]oxy}-N,N-bis(2-{[2,4,8,10-tetra- kis(2-methyl-2-propanyl)dibenzo[d,f][1,3,2]dioxaphos- phepin-6-yl]oxy}ethyl)ethanamine (CAS No. 80410-33-9) (provided for in subheading 2922.19.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.90",
      "rawHtsCode": "9902.03.90",
      "superior": null,
      "indent": "0",
      "description": "4-Methyl-N,N-dipropoxyaniline (CAS No. 38668-48-3) (provided for in subheading 2922.19.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.91",
      "rawHtsCode": "9902.03.91",
      "superior": null,
      "indent": "0",
      "description": "Phytosphingosine ((2S,3S,4R)-2-amino-1,3,4-octadecanetriol) (CAS No. 13552-11-9) (provided for in subheading 2922.19.96)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.92",
      "rawHtsCode": "9902.03.92",
      "superior": null,
      "indent": "0",
      "description": "1-(Dimethylamino)-2-propanol (CAS No. 108-16-7) (provided for in subheading 2922.19.96) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.93",
      "rawHtsCode": "9902.03.93",
      "superior": null,
      "indent": "0",
      "description": "(2S,3S,4R)-2-Amino-1,3,4-octadecanetriol hydrochloride (Phytosphingosine HCl) (CAS No. 154801-32-8) (provided for in subheading 2922.19.96) \n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.94",
      "rawHtsCode": "9902.03.94",
      "superior": null,
      "indent": "0",
      "description": "2-Amino-4-methylphenol (CAS No. 95-84-1) (provided for in subheading 2922.29.10)",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.95",
      "rawHtsCode": "9902.03.95",
      "superior": null,
      "indent": "0",
      "description": "4,4'-[1,3-Phenylenebis(oxy)]dianiline (CAS No. 2479-46-1) (provided for in subheading 2922.29.61)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.96",
      "rawHtsCode": "9902.03.96",
      "superior": null,
      "indent": "0",
      "description": "4-Methoxy-2-methyl-N-phenylaniline (CAS No. 41317-15-1) (provided for in subheading 2922.29.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.97",
      "rawHtsCode": "9902.03.97",
      "superior": null,
      "indent": "0",
      "description": "N-(2,4-Dimethylphenyl)-4-methoxy-2-methylaniline (CAS No. 41374-20-3) (provided for in subheading 2922.29.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.98",
      "rawHtsCode": "9902.03.98",
      "superior": null,
      "indent": "0",
      "description": "p-Cresidinesulfonic acid (4-amino-5-methoxy-2-methylbenzenesulfonic acid) (CAS No. 6471-78-9) (provided for in subheading 2922.29.81)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.03.99",
      "rawHtsCode": "9902.03.99",
      "superior": null,
      "indent": "0",
      "description": "2-Methoxy-5-methylaniline (CAS No. 120-71-8) (provided for in subheading 2922.29.81.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1.",
        "Note: provision should probably refer only to the 8-digit subheading number."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.01",
      "rawHtsCode": "9902.04.01",
      "superior": null,
      "indent": "0",
      "description": "4,4'-Oxydianiline (CAS No. 101-80-4) (provided for in subheading 2922.29.81)",
      "units": [],
      "generalRate": "1.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.02",
      "rawHtsCode": "9902.04.02",
      "superior": null,
      "indent": "0",
      "description": "4-Amino-5-methoxy-2-methylbenzenesulfonic acid (CAS No. 6471-78-9) (provided for in 2922.29.81)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.03",
      "rawHtsCode": "9902.04.03",
      "superior": null,
      "indent": "0",
      "description": "l-Lysine hydrate (1:1) (CAS No. 39665-12-8) (provided for in subheading 2922.41.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.04",
      "rawHtsCode": "9902.04.04",
      "superior": null,
      "indent": "0",
      "description": "4-Chlorophenylglycine (CAS No. 6212-33-5) (provided for in subheading 2922.49.30)",
      "units": [],
      "generalRate": "0.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.05",
      "rawHtsCode": "9902.04.05",
      "superior": null,
      "indent": "0",
      "description": "2-Amino-5-sulfobenzoic acid (CAS No. 3577-63-7) (provided for in subheading 2922.49.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.06",
      "rawHtsCode": "9902.04.06",
      "superior": null,
      "indent": "0",
      "description": "3,4-Diaminobenzoic acid (CAS No. 619-05-6) (provided for in subheading 2922.49.30) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.07",
      "rawHtsCode": "9902.04.07",
      "superior": null,
      "indent": "0",
      "description": "Methyl 2-amino-3-chlorobenzoate (CAS No. 77820-58-7) (provided for in subheading 2922.49.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.08",
      "rawHtsCode": "9902.04.08",
      "superior": null,
      "indent": "0",
      "description": "11-Aminoundecanoic acid (CAS No. 2432-99-7) (provided for in subheading 2922.49.40)",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1.",
        "Subheading 2922.49.40 was deleted from the tariff schedule; subheading 2922.49.49 likely covers the product named in this heading. Consult U.S. Customs and Border Protection concerning the use of this duty reduction provision."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.09",
      "rawHtsCode": "9902.04.09",
      "superior": null,
      "indent": "0",
      "description": "Ethyl 3-amino-4,4,4-trifluorocrotonate (CAS No. 372-29-2) (provided for in subheading 2922.49.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.10",
      "rawHtsCode": "9902.04.10",
      "superior": null,
      "indent": "0",
      "description": "Manganese(2+) sodium 2,2',2'',2'''-(1,2-ethanediyldinitrilo)tetraacetate (1:2:1) (Manganese disodium ethylenediaminetetraacetate) (CAS No. 15375-84-5) (provided for in subheading 2922.49.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.11",
      "rawHtsCode": "9902.04.11",
      "superior": null,
      "indent": "0",
      "description": "Sarcosine, sodium salt (sodium (methylamino)acetate) (CAS No. 4316-73-8) (provided for in subheading 2922.49.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.12",
      "rawHtsCode": "9902.04.12",
      "superior": null,
      "indent": "0",
      "description": "Copper(2+) sodium 2,2',2'',2'''-(1,2-ethanediyldinitrilo)tetraacetate (1:2:1) (CAS No. 14025-15-1) (provided for in subheading 2922.49.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.13",
      "rawHtsCode": "9902.04.13",
      "superior": null,
      "indent": "0",
      "description": "Sodium 3-[(2-carboxyethyl)(dodecyl)amino]propanoate (CAS No. 14960-06-6) (provided for in subheading 2922.49.80)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.14",
      "rawHtsCode": "9902.04.14",
      "superior": null,
      "indent": "0",
      "description": "2-[4-(N-Ethyl-N-(4-methylphenyl)amino)-2-hydroxybenzoyl] benzoic acid (CAS No. 42530-36-9) (provided for in subheading 2922.50.35)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.15",
      "rawHtsCode": "9902.04.15",
      "superior": null,
      "indent": "0",
      "description": "2-[4-(Diethylamino)-2-hydroxybenzoyl] benzoic acid (CAS No. 5809-23-4) (provided for in subheading 2922.50.40)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.16",
      "rawHtsCode": "9902.04.16",
      "superior": null,
      "indent": "0",
      "description": "(2-Hydroxyethyl)trimethylammonium hydroxide (Choline hydroxide) (CAS No. 123-41-1) (provided for in subheading 2923.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.17",
      "rawHtsCode": "9902.04.17",
      "superior": null,
      "indent": "0",
      "description": "Lecithin derived from non-genetically modified rapeseed (CAS No. 8002-43-5) (provided for in subheading 2923.20.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.18",
      "rawHtsCode": "9902.04.18",
      "superior": null,
      "indent": "0",
      "description": "Lecithin derived from non-genetically modified sunflower seeds (CAS No. 8002-43-5) (provided for in subheading 2923.20.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.19",
      "rawHtsCode": "9902.04.19",
      "superior": null,
      "indent": "0",
      "description": "Lecithin derived from non-genetically modified soybean (CAS No. 8002-43-5) (provided for in subheading 2923.20.20)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.20",
      "rawHtsCode": "9902.04.20",
      "superior": null,
      "indent": "0",
      "description": "(Z)-N-Methyl-N-(1-oxo-9-octadecenyl)glycine (N-oleylsarcosine) (CAS No. 110-25-8) (provided for in subheading 2924.19.11)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.21",
      "rawHtsCode": "9902.04.21",
      "superior": null,
      "indent": "0",
      "description": "N-Ethenylformamide (N-vinylformamide) (CAS No. 13162-05-5) (provided for in subheading 2924.19.11)",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.22",
      "rawHtsCode": "9902.04.22",
      "superior": null,
      "indent": "0",
      "description": "3-Oxobutanamide (acetoacetamide) (CAS No. 5977-14-0) (provided for subheading 2924.19.11)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.23",
      "rawHtsCode": "9902.04.23",
      "superior": null,
      "indent": "0",
      "description": "N-[3-(Dimethylamino)propyl]-2-methylacrylamide (CAS No. 5205-93-6) (provided for in subheading 2924.19.11)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.24",
      "rawHtsCode": "9902.04.24",
      "superior": null,
      "indent": "0",
      "description": "1,1,3,3-Tetrabutylurea (CAS No. 4559-86-8) (provided for in subheading 2924.19.11)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.25",
      "rawHtsCode": "9902.04.25",
      "superior": null,
      "indent": "0",
      "description": "N-(2-Methyl-4-oxo-2-pentanyl)acrylamide (CAS No. 2873-97-4) (provided for in subheading 2924.19.11)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.26",
      "rawHtsCode": "9902.04.26",
      "superior": null,
      "indent": "0",
      "description": "N,N,N',N'-Tetrakis(2-hydroxypropyl)-adipamide (CAS No. 57843-53-5) (provided for in subheading 2924.19.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.27",
      "rawHtsCode": "9902.04.27",
      "superior": null,
      "indent": "0",
      "description": "N,N,N',N'-Tetrakis(2-2-hydroxyethyl)-adipamide (CAS No. 6334-25-4) (provided for in subheading 2924.19.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.28",
      "rawHtsCode": "9902.04.28",
      "superior": null,
      "indent": "0",
      "description": "2,2-Dichloro-N,N-bis(prop-2-enyl)acetamide (Dichlormid) (CAS No. 37764-25-3) (provided for in subheading 2924.19.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.30",
      "rawHtsCode": "9902.04.30",
      "superior": null,
      "indent": "0",
      "description": "3-(3,4-Dichlorophenyl)-1,1-dimethylurea (Diuron) (CAS No. 330-54-1) (provided for in subheading 2924.21.16)",
      "units": [],
      "generalRate": "0.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.31",
      "rawHtsCode": "9902.04.31",
      "superior": null,
      "indent": "0",
      "description": "3-(3,4-Dichlorophenyl)-1-methoxy-1-methylurea (CAS No. 330-55-2) (Linuron) (provided for in subheading 2924.21.16)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.32",
      "rawHtsCode": "9902.04.32",
      "superior": null,
      "indent": "0",
      "description": "N,N'-Hexamethylenebis(3,5-di-tert-butyl-4-hydroxyhydrocin- namamide) (3,3'-bis(3,5-di-tert-butyl-4-hydroxyphenyl)-N,N'-hexa- methylenedipropionamide) (CAS No. 23128-74-7) (provided for in subheading 2924.29.31)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.33",
      "rawHtsCode": "9902.04.33",
      "superior": null,
      "indent": "0",
      "description": "Isopropyl (3-chlorophenyl)carbamate (Chlorpropham) (CAS No. 101-21-3) (provided for in subheading 2924.29.43)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.34",
      "rawHtsCode": "9902.04.34",
      "superior": null,
      "indent": "0",
      "description": "Propoxur (2-(1-methylethoxy)phenyl N-methylcarbamate) (CAS No. 114-26-1) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.35",
      "rawHtsCode": "9902.04.35",
      "superior": null,
      "indent": "0",
      "description": "2-Chloro-N-(2-ethyl-6-methyl-phenyl)-N-(1-methoxypropan-2-yl) acetamide (Metolachlor) (CAS No. 51218-45-2) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.36",
      "rawHtsCode": "9902.04.36",
      "superior": null,
      "indent": "0",
      "description": "Methyl N-(2-methoxyacetyl)-N-(2,6-xylyl)-DL-alaninate (Metalaxyl)(CAS No. 57837-19-1) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.37",
      "rawHtsCode": "9902.04.37",
      "superior": null,
      "indent": "0",
      "description": "(RS)-3,5-dichloro-N-(3-chloro-1-ethyl-1-methyl-2-oxopro- pyl)-p-toluamide (Zoxamide) (CAS No. 156052-68-5) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.38",
      "rawHtsCode": "9902.04.38",
      "superior": null,
      "indent": "0",
      "description": "[3-(Methoxycarbonylamino)phenyl] N-(3-methylphenyl)carbamate (Phenmedipham) (CAS No. 13684-63-4) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.39",
      "rawHtsCode": "9902.04.39",
      "superior": null,
      "indent": "0",
      "description": "1-Naphthylenyl methylcarbamate (Carbaryl) (CAS No. 63-25-2) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.40",
      "rawHtsCode": "9902.04.40",
      "superior": null,
      "indent": "0",
      "description": "N-[3-(1-Methylethoxy)phenyl]-2-(trifluoromethyl)benzamide (CAS No. 66332-96-5) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.41",
      "rawHtsCode": "9902.04.41",
      "superior": null,
      "indent": "0",
      "description": "1-(2,4-Dichlorophenylcarbamoyl)cyclopropancarboxylic acid (Cyclanilide) (CAS No. 113136-77-9) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.42",
      "rawHtsCode": "9902.04.42",
      "superior": null,
      "indent": "0",
      "description": "Methyl N-(2,6-dimethylphenyl)-N-(methoxyacetyl)-D-alaninate (Metalaxyl-M and L-Metalaxyl) (CAS Nos. 70630-17-0 and 69516-34-3) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.43",
      "rawHtsCode": "9902.04.43",
      "superior": null,
      "indent": "0",
      "description": "2-Chloro-N-(2-ethyl-6-methylphenyl)-N-[(1S)-2-meth- oxy-1-methylethyl]acetamide ((S)-Metolachlor) (CAS No. 87392-12-9) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "6.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.44",
      "rawHtsCode": "9902.04.44",
      "superior": null,
      "indent": "0",
      "description": "(RS)-N,N-Diethyl-2-(1-nephthyloxy)propionamide (Napropamide) (CAS No. 15299-99-7) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.45",
      "rawHtsCode": "9902.04.45",
      "superior": null,
      "indent": "0",
      "description": "2-(4-Chlorophenyl)-N-{2-[3-methoxy-4-(2-propyn-1-yloxy)phe- nyl]ethyl}-2-(2-propyn-1-yloxy)acetamide (Mandipropamid) (CAS No. 374726-62-2) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.46",
      "rawHtsCode": "9902.04.46",
      "superior": null,
      "indent": "0",
      "description": "N-(2,3-Dichloro-4-hydroxyphenyl)-1-methylcyclohexanecar- boxamide (Fenhexamid) (CAS No. 126833-17-8) (provided for in subheading 2924.29.47)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.47",
      "rawHtsCode": "9902.04.47",
      "superior": null,
      "indent": "0",
      "description": "2-{2-[(2,5-Dimethylphenoxy)methyl]phenyl}-2-methoxy-N- methylacetamide (Mandestrobin) (CAS No. 173662-97-0) (provided for in subheading 2924.29.47)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.48",
      "rawHtsCode": "9902.04.48",
      "superior": null,
      "indent": "0",
      "description": "N-(4-Fluorophenyl)-2-hydroxy-N-(1-methylethyl)acetamide (CAS No. 54041-17-7) (provided for in subheading 2924.29.71)",
      "units": [],
      "generalRate": "3.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.49",
      "rawHtsCode": "9902.04.49",
      "superior": null,
      "indent": "0",
      "description": "2-(Trifluoromethyl)benzamide (CAS No. 360-64-5) (provided for in subheading 2924.29.71)",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.50",
      "rawHtsCode": "9902.04.50",
      "superior": null,
      "indent": "0",
      "description": "Methyl 2-amino-4-[(2,5-dichlorophenyl)carbamoyl]benzoate (CAS No. 59673-82-4) (provided for in subheading 2924.29.71)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.51",
      "rawHtsCode": "9902.04.51",
      "superior": null,
      "indent": "0",
      "description": "2,5-Bis(acetoacetylamino)benzenesulfonic acid (CAS No. 70185-87-4) (provided for in subheading 2924.29.71)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.52",
      "rawHtsCode": "9902.04.52",
      "superior": null,
      "indent": "0",
      "description": "Methyl (chlorocarbonyl)[4-(trifluoromethoxy)phenyl]carbamate (CAS No. 173903-15-6) (provided for in subheading 2924.29.71)\n",
      "units": [],
      "generalRate": "2.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.53",
      "rawHtsCode": "9902.04.53",
      "superior": null,
      "indent": "0",
      "description": "2'-Chloroacetoacetanilide (CAS No. 93-70-9) (provided for in subheading 2924.29.77)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.54",
      "rawHtsCode": "9902.04.54",
      "superior": null,
      "indent": "0",
      "description": "4'-Chloro-2',5'-dimethoxyacetoacetanilide (CAS No. 4433-79-8) (provided for in subheading 2924.29.77)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.55",
      "rawHtsCode": "9902.04.55",
      "superior": null,
      "indent": "0",
      "description": "p-Aminobenzamide (4-Aminobenzamide) (CAS No 2835-68-9) (provided for in subheading 2924.29.77) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.56",
      "rawHtsCode": "9902.04.56",
      "superior": null,
      "indent": "0",
      "description": "2-Amino-5-cyano-N,3-dimethylbenzamide (CAS No. 890707-29-6) (provided for in subheading 2924.29.77)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.57",
      "rawHtsCode": "9902.04.57",
      "superior": null,
      "indent": "0",
      "description": "trans-4-{[(2-Methyl-2-propanyl)oxy]carbonyl}cyclohex- anecarboxylic acid (CAS No. 53292-89-0) (provided for in subheading 2924.29.95)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.58",
      "rawHtsCode": "9902.04.58",
      "superior": null,
      "indent": "0",
      "description": "1,1'-[1,3-Phenylenebis(methylene)]bis(3-methyl-1H-pyr- role-2,5-dione) (CAS No. 119462-56-5) (provided for in subheading 2925.19.42)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.59",
      "rawHtsCode": "9902.04.59",
      "superior": null,
      "indent": "0",
      "description": "1-Dodecylguanidine acetate (Dodine) (CAS No. 2439-10-3) (provided for in subheading 2925.19.91)\n\n\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.60",
      "rawHtsCode": "9902.04.60",
      "superior": null,
      "indent": "0",
      "description": "1,1'-(1,3-Phenylene)bis(1H-pyrrole-2,5-dione) (CAS No. 3006-93-7) (provided for in subheading 2925.19.91)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.61",
      "rawHtsCode": "9902.04.61",
      "superior": null,
      "indent": "0",
      "description": "1,3-Diphenylguanidine (CAS No. 102-06-7) (provided for in subheading 2925.29.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.62",
      "rawHtsCode": "9902.04.62",
      "superior": null,
      "indent": "0",
      "description": "Pentyl [2-chloro-5-(1,3-dioxo-1,3,4,5,6,7-hexahydro-2H- isoindol-2-yl)-4-fluorophenoxy]acetate (Flumiclorac pentyl ester) (CAS No. 87546-18-7) (provided in subheading 2925.29.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.63",
      "rawHtsCode": "9902.04.63",
      "superior": null,
      "indent": "0",
      "description": "Creatine (N-carbamimidoyl-N-methylglycine) (CAS No. 57-00-1) (provided for in subheading 2925.29.90)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.64",
      "rawHtsCode": "9902.04.64",
      "superior": null,
      "indent": "0",
      "description": "N-Carbamimidoylglycine (Guanidinoacetic acid) (CAS No. 352-97-6) (provided for in subheading 2925.29.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.65",
      "rawHtsCode": "9902.04.65",
      "superior": null,
      "indent": "0",
      "description": "2,4,5,6-Tetrachloroisophthalonitrile (Chlorothalonil) (CAS No. 1897-45-6) (provided for in subheading 2926.90.21)",
      "units": [],
      "generalRate": "5.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.66",
      "rawHtsCode": "9902.04.66",
      "superior": null,
      "indent": "0",
      "description": "2-Methoxyethyl 2-cyano-2-[4-(2-methyl-2-propanyl)phe- nyl]-3-oxo-3-[2-(trifluoromethyl)phenyl]propanoate (Cyflumetafen) (CAS No. 400882-07-7) (provided for in subheading 2926.90.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.67",
      "rawHtsCode": "9902.04.67",
      "superior": null,
      "indent": "0",
      "description": "2,6-Dibromo-4-cyanophenyl octanoate (Bromoxynil octanoate) (CAS No. 1689-99-2) (provided for in subheading 2926.90.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.68",
      "rawHtsCode": "9902.04.68",
      "superior": null,
      "indent": "0",
      "description": "2,6-Dibromo-4-cyanophenyl heptanoate (Bromoxynil heptanoate) (CAS No. 56634-95-8) (provided for in subheading 2926.90.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.69",
      "rawHtsCode": "9902.04.69",
      "superior": null,
      "indent": "0",
      "description": "Butyl (2R)-2-[4-(4-cyano-2-fluorophenoxy)phenoxy]propanoate (Cyhalofop-butyl) (CAS No. 122008-85-9) (provided for in subheading 2926.90.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.70",
      "rawHtsCode": "9902.04.70",
      "superior": null,
      "indent": "0",
      "description": "(RS)-α-cyano-4-fluoro-3-phenoxybenzyl(1RS,3RS;1RS,3SR)-3- (2,2-dichlorovinyl)-2,2-dimethylcyclopropanecarboxylate (β-Cyfluthrin) (CAS No. 68359-37-5) (provided for in subheading 2926.90.30)",
      "units": [],
      "generalRate": "3.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.71",
      "rawHtsCode": "9902.04.71",
      "superior": null,
      "indent": "0",
      "description": "(S)-α-Cyano-3-phenoxybenzyl (1R,3R)-3- (2,2-dibromovinyl)-2,2-dimethylcyclopropanecarboxylate (Deltamethrin) (CAS No. 52918-63-5) (provided for in subheading 2926.90.30)",
      "units": [],
      "generalRate": "1.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.72",
      "rawHtsCode": "9902.04.72",
      "superior": null,
      "indent": "0",
      "description": "Cyano(4-fluoro-3-phenoxyphenyl)methyl 3-(2,2-dichloroethenyl)-2,2-dimethylcyclopropanecarboxylate (Cyfluthrin, excluding β-Cyfluthrin) (CAS No. 68359-37-5) (provided for in subheading 2926.90.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.73",
      "rawHtsCode": "9902.04.73",
      "superior": null,
      "indent": "0",
      "description": "Cyano(3-phenoxyphenyl)methyl 3-(2,2-dichloroethenyl)- 2,2-dimethylcyclopropanecarboxylate (Cypermethrin) (CAS No. 52315-07-8) (provided for in subheading 2926.90.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.74",
      "rawHtsCode": "9902.04.74",
      "superior": null,
      "indent": "0",
      "description": "(S)-Cyano(3-phenoxyphenyl)methyl(S)-4-chloro-α-(1-meth- ylethyl)benzeneacetate (Esfenvalerate) (CAS No. 66230-04-4) (provided for in subheading 2926.90.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.75",
      "rawHtsCode": "9902.04.75",
      "superior": null,
      "indent": "0",
      "description": "(R)-α-Cyano-3-phenoxybenzyl (1S,3S)-3-(2,2-dichlorovinyl)-2,2 dimethylcyclopropanecarboxylate and (S)-α-cyano-3-phenoxybenzyl (1R)-cis-3-(2,2-dichlorovinyl)-2,2-dimethylcyclopropanecar- boxylate isomers (α-cypermethrin technical) (CAS No. 67375-30-8) (provided for in subheading 2926.90.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.76",
      "rawHtsCode": "9902.04.76",
      "superior": null,
      "indent": "0",
      "description": "(S)-Cyano-(3-phenoxyphenyl)methyl (+)cis-3-(2,2 -dichloroetheny1)-2,2-dimethylcyclopropanecarboxylate and (S)-cyano-(3-phenoxyphenyl)methyl (+)trans-3-(2,2-dichloroetheny1)-2,2-dimethylcyclopropanecar- boxylate\n(Zeta-cypermethrin) (CAS No. 1315501-18-8) (provided for in subheading 2926.90.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.78",
      "rawHtsCode": "9902.04.78",
      "superior": null,
      "indent": "0",
      "description": "α-Cyano-3-phenoxyphenyl 2,2,3,3-tetramethylcyclopropanecarboxylate (Fenpropathrin) (CAS No. 39515-41-8) (provided in subheading 2926.90.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.79",
      "rawHtsCode": "9902.04.79",
      "superior": null,
      "indent": "0",
      "description": "1,2 Dicyanobenzene (phthalodinitrile) (CAS No. 91-15-6) (provided for in subheading 2926.90.43)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.80",
      "rawHtsCode": "9902.04.80",
      "superior": null,
      "indent": "0",
      "description": "2, 2-Diphenylacetonitrile (CAS No. 86-29-3) (provided for in subheading 2926.90.48)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.81",
      "rawHtsCode": "9902.04.81",
      "superior": null,
      "indent": "0",
      "description": "Isophthalonitrile (1,3-dicyanobenzene) (CAS No. 626-17-5) (as provided for in subheading 2926.90.48)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.82",
      "rawHtsCode": "9902.04.82",
      "superior": null,
      "indent": "0",
      "description": "3,4-Difluorobenzonitrile (CAS No. 64248-62-0) (provided for in subheading 2926.90.48)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.83",
      "rawHtsCode": "9902.04.83",
      "superior": null,
      "indent": "0",
      "description": "4-[(4-Aminophenyl)azo]-benzenesulfonic acid (CAS No. 104-23-4) (provided for in subheading 2927.00.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.84",
      "rawHtsCode": "9902.04.84",
      "superior": null,
      "indent": "0",
      "description": "N-(3,5-Dimethylbenzoyl)-3-methoxy-2-methyl-N-(2-methyl-2- propanyl)benzohydrazide (Methoxyfenozide) (CAS No. 161050-58-4) (provided for in subheading 2928.00.25)",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.85",
      "rawHtsCode": "9902.04.85",
      "superior": null,
      "indent": "0",
      "description": "Isopropyl 3-(4-methoxybiphenyl-3-yl)carbazate (Bifenazate) (CAS No. 149877-41-8) (provided for in subheading 2928.00.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.86",
      "rawHtsCode": "9902.04.86",
      "superior": null,
      "indent": "0",
      "description": "Methyl (E)-methoxyimino-{(E)-2-[1-(α,α,α-trifluoro-m-tolyl) ethylideneaminooxy]-o-tolyl}acetate (Trifloxystrobin) (CAS No. 141517-21-7) (provided for in subheading 2928.00.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.87",
      "rawHtsCode": "9902.04.87",
      "superior": null,
      "indent": "0",
      "description": "(1Z)-N-{(Z)-[(Cyclopropylmethoxy)imino][2,3-difluoro-6-(trifluor- omethyl)phenyl]methyl}-2-phenylethanimidic acid (Cyflufenamid) (CAS No. 180409-60-3) (provided for in subheading 2928.00.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.88",
      "rawHtsCode": "9902.04.88",
      "superior": null,
      "indent": "0",
      "description": "N-(4-Ethylbenzoyl)-3,5-dimethyl-N-(2-methyl-2-propanyl)ben- zohydrazide (Tebufenozide) (CAS No. 112410-23-8) (provided for in subheading 2928.00.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.89",
      "rawHtsCode": "9902.04.89",
      "superior": null,
      "indent": "0",
      "description": "Carbonohydrazide (CAS No. 497-18-7) (provided for in subheading 2928.00.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.90",
      "rawHtsCode": "9902.04.90",
      "superior": null,
      "indent": "0",
      "description": "2-(N-Ethoxypropanimidoyl)-3-hydroxy-5-mesityl-2-cyclohexen-1-one (tralkoxydim) (CAS No. 87820-88-0) (provided for in subheading 2928.00.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.91",
      "rawHtsCode": "9902.04.91",
      "superior": null,
      "indent": "0",
      "description": "4-(2,2-Dimethylhydrazinyl)-4-oxobutanoic acid (Daminozide) (CAS No. 1596-84-5) (provided for in subheading 2928.00.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.92",
      "rawHtsCode": "9902.04.92",
      "superior": null,
      "indent": "0",
      "description": "Aminoguanidine bicarbonate (CAS No. 2582-30-1) (provided for in subheading 2928.00.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.93",
      "rawHtsCode": "9902.04.93",
      "superior": null,
      "indent": "0",
      "description": "Adipic dihydrazide (Hexanedihydrazide) (CAS No. 1071-93-8) (provided for in subheading 2928.00.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.94",
      "rawHtsCode": "9902.04.94",
      "superior": null,
      "indent": "0",
      "description": "Bitolylene diisocyanate (3,3'-dimethylbiphenyl-4,4'-diyl diisocyanate ) (CAS No. 91-97-4) (provided for in subheading 2929.10.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.95",
      "rawHtsCode": "9902.04.95",
      "superior": null,
      "indent": "0",
      "description": "4-Chlorophenyl isocyanate (CAS No.104-12-1) (provided for in subheading 2929.10.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.96",
      "rawHtsCode": "9902.04.96",
      "superior": null,
      "indent": "0",
      "description": "Phenyl isocyanate (CAS No. 103-71-9) (provided for in subheading 2929.10.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.97",
      "rawHtsCode": "9902.04.97",
      "superior": null,
      "indent": "0",
      "description": "Ethyl [4-chloro-2-fluoro-5-[[[[methyl(1-methylethyl)a- mino]sulfonyl]amino]carbonyl]phenyl]carbamate (CAS No. 874909-61-2) (provided for in subheading 2929.90.15)",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.98",
      "rawHtsCode": "9902.04.98",
      "superior": null,
      "indent": "0",
      "description": "N-Butylthiophosphoric triamide (CAS No. 94317-64-3) (provided in subheading 2929.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.04.99",
      "rawHtsCode": "9902.04.99",
      "superior": null,
      "indent": "0",
      "description": "S-4-Chlorobenzyl diethylcarbamothioate (Thiobencarb) (CAS No. 28249-77-6) (provided in subheading 2930.20.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.01",
      "rawHtsCode": "9902.05.01",
      "superior": null,
      "indent": "0",
      "description": "S-Ethyl dipropyl(thiocarbamate) (EPTC) (CAS No. 759-94-4) (provided for in subheading 2930.20.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.02",
      "rawHtsCode": "9902.05.02",
      "superior": null,
      "indent": "0",
      "description": "O,O-Dimethyl S-phthalimidomethyl phosphorodithioate (Phosmet) (CAS No. 732-11-6) (provided for in subheading 2930.90.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.03",
      "rawHtsCode": "9902.05.03",
      "superior": null,
      "indent": "0",
      "description": "2-[4-(Methylsulfonyl)-2-nitrobenzoyl]-1,3-cyclohexanedione (Mesotrione) (CAS No. 104206-82-8) (provided for in subheading 2930.90.10)",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.04",
      "rawHtsCode": "9902.05.04",
      "superior": null,
      "indent": "0",
      "description": "O-4-Bromo-2-chlorophenyl O-ethyl S-propyl phosphorothioate (Profenofos) (CAS 41198-08-7) (provided for in 2930.90.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.05",
      "rawHtsCode": "9902.05.05",
      "superior": null,
      "indent": "0",
      "description": " 2-[1-({[(2E)-3-Chloro-2-propen-1-yl]oxy}amino)propyli- dene]-5-[2-(ethylsulfanyl)propyl]-1,3-cyclohex- anedione (Clethodim) (CAS No. 99129-21-2) (provided for in subheading 2930.90.10)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.06",
      "rawHtsCode": "9902.05.06",
      "superior": null,
      "indent": "0",
      "description": "Dimethyl (1,2-phenylenedicarbamothioyl)biscarbamate (Thiophanate methyl) (CAS No. 23564-05-8) (provided for in subheading 2930.90.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.07",
      "rawHtsCode": "9902.05.07",
      "superior": null,
      "indent": "0",
      "description": "2-Chloro-4-(methylsulfonyl)-3-((2,2,2-trifluoroethoxy)methyl) benzoic acid (CAS No. 120100-77-8) (provided for in subheading 2930.90.29)",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.08",
      "rawHtsCode": "9902.05.08",
      "superior": null,
      "indent": "0",
      "description": "2-(Methylthio)-4-(trifluoromethyl)benzoic acid (MTBA) (CAS No. 142994-05-6) (provided for in subheading 2930.90.29)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.09",
      "rawHtsCode": "9902.05.09",
      "superior": null,
      "indent": "0",
      "description": "Disodium 2,2'-[biphenyl-4,4'-diyldiethene-2,1-diyl]dibenzenesulfonate (CAS No. 27344-41-8) (provided for in subheading 2930.90.29)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.10",
      "rawHtsCode": "9902.05.10",
      "superior": null,
      "indent": "0",
      "description": "4,6-Bis(octylthiomethyl)-o-cresol (CAS No. 110553-27-0) (provided for in subheading 2930.90.29)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.11",
      "rawHtsCode": "9902.05.11",
      "superior": null,
      "indent": "0",
      "description": "4,4'-Sulfanediylbis[5-methyl-2-(2-methyl-2-propanyl)phenol] (CAS No. 96-69-5) (provided for in subheading 2930.90.29)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.12",
      "rawHtsCode": "9902.05.12",
      "superior": null,
      "indent": "0",
      "description": "1-(Octadecyldisulfanyl)octadecane (CAS No. 2500-88-1) (provided for in subheading 2930.90.29).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.13",
      "rawHtsCode": "9902.05.13",
      "superior": null,
      "indent": "0",
      "description": "2,2'-Sulfanediylbis[4-methyl-6-(2-methyl-2-propanyl)phenol] (CAS No. 90-66-4) (provided for in subheading 2930.90.29)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.14",
      "rawHtsCode": "9902.05.14",
      "superior": null,
      "indent": "0",
      "description": "Dichlorodiphenylsulfone (CAS 80-07-9) (provided for in subheading 2930.90.29)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.15",
      "rawHtsCode": "9902.05.15",
      "superior": null,
      "indent": "0",
      "description": "Methyl (1E)-N-[methyl-[methyl-[(E)-1-methyl- sulfanylethylideneamino]oxycarbonylamino]sulfanyl- carbamoyl]oxyethanimidothioate (Thiodicarb) (CAS No. 59669-26-0) (provided for in subheading 2930.90.43)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.16",
      "rawHtsCode": "9902.05.16",
      "superior": null,
      "indent": "0",
      "description": "O,S-Dimethyl acetylphosphoramidothioate (Acephate) (CAS No. 30560-19-1) (provided for in subheading 2930.90.43)",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.17",
      "rawHtsCode": "9902.05.17",
      "superior": null,
      "indent": "0",
      "description": "S,S-Di-sec-butyl O-ethyl phosphorodithioate (Cadusafos) (CAS No. 95465-99-9) (provided for in subheading 2930.90.43)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.18",
      "rawHtsCode": "9902.05.18",
      "superior": null,
      "indent": "0",
      "description": "Methyl (1E)-N-[(methylcarbamoyl)oxy]ethanimidothioate (Methomyl) (CAS No. 16752-77-5) (provided for in subheading 2930.90.43)\n",
      "units": [],
      "generalRate": "5.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.19",
      "rawHtsCode": "9902.05.19",
      "superior": null,
      "indent": "0",
      "description": "2-[(Trichloromethyl)sulfanyl]-3a,4,7,7a-tetrahydro-1H-isoin- dole-1,3(2H)-dione (Captan) (CAS No. 133-06-2) (provided for in subheading 2930.90.43)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.20",
      "rawHtsCode": "9902.05.20",
      "superior": null,
      "indent": "0",
      "description": "Thiourea dioxide (Amino(imino)methanesulfinic acid) (CAS No. 1758-73-2) (provided for in subheading 2930.90.49)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.21",
      "rawHtsCode": "9902.05.21",
      "superior": null,
      "indent": "0",
      "description": "Thioglycolic acid (Sulfanylacetic acid) (CAS No. 68-11-1) (provided for in subheading 2930.90.49) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.22",
      "rawHtsCode": "9902.05.22",
      "superior": null,
      "indent": "0",
      "description": "2-Mercaptoethanol (CAS No. 60-24-2) (provided for in subheading 2930.90.91)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.23",
      "rawHtsCode": "9902.05.23",
      "superior": null,
      "indent": "0",
      "description": "3-{[3-(Dodecylsulfanyl)propanoyl]oxy}-2,2-bis({[3-(dodecylsulfanyl)pro- panoyl]oxy}methyl)propyl 3-(dodecylsulfanyl)propanoate) (CAS No. 29598-76-3) (provided for in subheading 2930.90.91)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.24",
      "rawHtsCode": "9902.05.24",
      "superior": null,
      "indent": "0",
      "description": "2-Mercaptoethanol (2-sulfanylethanol) (CAS No. 60-24-2) (provided for in subheading 2930.90.91)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.25",
      "rawHtsCode": "9902.05.25",
      "superior": null,
      "indent": "0",
      "description": "Di-tert-nonyl polysulfide (CAS No. 68425-16-1) (provided for in subheading 2930.90.91)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.26",
      "rawHtsCode": "9902.05.26",
      "superior": null,
      "indent": "0",
      "description": "Allyl isothiocyanate (CAS No. 57-06-7) (provided for in subheading 2930.90.91)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.27",
      "rawHtsCode": "9902.05.27",
      "superior": null,
      "indent": "0",
      "description": "3-[Butoxy(methyl)phosphoryl]-1-cyanopropyl acetate (CAS No. 167004-78-6) (provided for in subheading 2931.39.00)",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.28",
      "rawHtsCode": "9902.05.28",
      "superior": null,
      "indent": "0",
      "description": "Butyl methylphosphinate (CAS No. 6172-80-1) (provided for in subheading 2931.39.00).",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.29",
      "rawHtsCode": "9902.05.29",
      "superior": null,
      "indent": "0",
      "description": "2,2'-[(Phosphonomethyl)imino]diacetic acid hydrate (1:1) (CAS No. 5994-61-6) (provided for in subheading 2931.39.00)\n",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.30",
      "rawHtsCode": "9902.05.30",
      "superior": null,
      "indent": "0",
      "description": "Triphenyl phosphine (CAS No. 603-35-0) (provided for in subheading 2931.39.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.31",
      "rawHtsCode": "9902.05.31",
      "superior": null,
      "indent": "0",
      "description": "Bis[tris(2-methyl-2-phenylpropyl)tin]oxide (Fenbutatin oxide) (CAS No. 13356-08-6) (provided for in subheading 2931.90.26)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.32",
      "rawHtsCode": "9902.05.32",
      "superior": null,
      "indent": "0",
      "description": "Triphenyltin hydroxide (CAS No. 76-87-9) (provided for in subheading 2931.90.26)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.33",
      "rawHtsCode": "9902.05.33",
      "superior": null,
      "indent": "0",
      "description": "(Triethoxysilyl)methyl anthracene-9-carboxylate (CAS No. 313482-99-4) (provided for in subheading 2931.90.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.34",
      "rawHtsCode": "9902.05.34",
      "superior": null,
      "indent": "0",
      "description": "4-Chloro-2-fluoro-3-methoxyphenylboronic acid (CAS No. 944129-07-1) (provided for in subheading 2931.90.30)",
      "units": [],
      "generalRate": "4.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.35",
      "rawHtsCode": "9902.05.35",
      "superior": null,
      "indent": "0",
      "description": "Phenylphosphinic acid (CAS No. 1779-48-2) (provided for in subheading 2931.90.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.36",
      "rawHtsCode": "9902.05.36",
      "superior": null,
      "indent": "0",
      "description": "(4-Morpholinylmethylene)bis(phosphonic acid) (CAS No. 32545-75-8) (provided for in subheading 2931.90.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.37",
      "rawHtsCode": "9902.05.37",
      "superior": null,
      "indent": "0",
      "description": "Ammonium (2RS)-2-amino-4-(methylphosphinato)butyric acid (Glufosinate Ammonium) (CAS No. 77182-82-2) (provided for in subheading 2931.39.00)",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.38",
      "rawHtsCode": "9902.05.38",
      "superior": null,
      "indent": "0",
      "description": "Sodium hydrogen methylarsonate (CAS No. 2163-80-6) (provided for in subheading 2931.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.39",
      "rawHtsCode": "9902.05.39",
      "superior": null,
      "indent": "0",
      "description": "Tetrakis(hydroxymethyl)phosphonium chloride (CAS No. 124-64-1) (provided for in subheading 2931.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.40",
      "rawHtsCode": "9902.05.40",
      "superior": null,
      "indent": "0",
      "description": "Tetrakis(hydroxymethyl)phosphonium sulfate (CAS No. 55566-30-8) (provided for in subheading 2931.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.41",
      "rawHtsCode": "9902.05.41",
      "superior": null,
      "indent": "0",
      "description": "N-(Phosphonomethyl)glycine (Glyphosate) (CAS No. 1071-83-6) (provided for in subheading 2931.90.90)",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1.",
        "Information received from U.S. Customs and Border Protection indicates that the product named in this heading may now be classified in subheading 2931.39.00, as a result of international tariff changes. Consult Customs officials concerning the use of this duty reduction provision."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.42",
      "rawHtsCode": "9902.05.42",
      "superior": null,
      "indent": "0",
      "description": "Bis[(2,2-dimethyloctanoyl)oxy](dimethyl)stannane (CAS No. 68928-76-7) (provided for in subheading 2931.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.43",
      "rawHtsCode": "9902.05.43",
      "superior": null,
      "indent": "0",
      "description": "(2-Chloroethyl)phosphonic acid (Ethephon) (CAS No.16672-87-0) (provided for in subheading 2931.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.44",
      "rawHtsCode": "9902.05.44",
      "superior": null,
      "indent": "0",
      "description": "Dimethyl, methyl (polyethylene oxide acetate-capped) siloxane (CAS No. 70914-12-4) (provided for in subheading 2931.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.45",
      "rawHtsCode": "9902.05.45",
      "superior": null,
      "indent": "0",
      "description": "2-Methyl-1-nitro-3-(tetrahydro-2-furanylmethyl)guanidine (Dinotefuran) (CAS No. 165252-70-0) (provided for in subheading 2932.19.51)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.46",
      "rawHtsCode": "9902.05.46",
      "superior": null,
      "indent": "0",
      "description": "3,6-Anhydro-1-O-octanoylhexitol (sorbitan caprylate) (CAS No. 60177-36-8) (provided for in subheading 2932.19.51)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.47",
      "rawHtsCode": "9902.05.47",
      "superior": null,
      "indent": "0",
      "description": "O-(3-Chloro-4-methyl-2-oxo-2H-chromen-7-yl) O,O-diethyl phosphorothioate (Coumaphos) (CAS No. 56-72-4) (provided for in subheading 2932.20.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.48",
      "rawHtsCode": "9902.05.48",
      "superior": null,
      "indent": "0",
      "description": "3-Mesityl-2-oxo-1-oxaspiro[4.4]non-3-en-4-yl 3,3-dimethylbutyrate (Spiromesifen) (CAS No. 283594-90-1) (provided for in subheading 2932.20.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.49",
      "rawHtsCode": "9902.05.49",
      "superior": null,
      "indent": "0",
      "description": "3-(2,4-Dichlorophenyl)-2-oxo-1-oxaspiro[4.5] dec-3-en-4-yl 2,2-dimethylbutanoate (Spirodiclofen) (CAS No. 148477-71-8) (provided for in subheading 2932.20.10)",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.50",
      "rawHtsCode": "9902.05.50",
      "superior": null,
      "indent": "0",
      "description": "4-Hydroxy-3-(3-(4'-bromo-4-biphenylyl)-1,2,3,4-tetrahydro-1-naph- thyl)coumarin (Brodifacoum) (CAS No. 56073-10-0) (provided for in subheading 2932.20.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.51",
      "rawHtsCode": "9902.05.51",
      "superior": null,
      "indent": "0",
      "description": "(4''R)-4''-Deoxy-4''-(methylamino)avermectin b1 benzoate (CAS No. 155569-91-8) (provided for in subheading 3824.99.92 or 2932.20.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.52",
      "rawHtsCode": "9902.05.52",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of gibberellic acid (CAS No. 77-06-5), gibberellin A4 (CAS No. 468-44-0) and gibberellin A7 (CAS No. 510-75-8) (provided for in subheading 2932.20.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.53",
      "rawHtsCode": "9902.05.53",
      "superior": null,
      "indent": "0",
      "description": "Erythorbic acid ((5R)-5-[(1R)-1,2-dihydroxyethyl]-3,4-dihydroxy-2(5H)-furanone) (CAS No. 89-65-6) (provided for in subheading 2932.20.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.54",
      "rawHtsCode": "9902.05.54",
      "superior": null,
      "indent": "0",
      "description": "Sodium erythorbate (sodium (2R)-2-[(2R)-4,5-dihydroxy- 3-oxo-2,3-dihydro-2-furanyl]-2-hydroxyethanolate) (CAS No. 6381-77-7) (provided for in subheading 2932.20.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.55",
      "rawHtsCode": "9902.05.55",
      "superior": null,
      "indent": "0",
      "description": "(RS)-2-Ethoxy-2,3-dihydro-3,3-dimethylbenzofuran-5-yl methanesulfonate (Ethofumesate) (CAS No. 26225-79-6) (provided for in subheading 2932.99.08)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.56",
      "rawHtsCode": "9902.05.56",
      "superior": null,
      "indent": "0",
      "description": "2,2-Dimethyl-2,3-dihydro-1-benzofuran-7-yl [(dibutylamino)sulfanyl]methylcarbamate (Carbosulfan Technical) (CAS No. 55285-14-8) (provided for in subheading 2932.99.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.57",
      "rawHtsCode": "9902.05.57",
      "superior": null,
      "indent": "0",
      "description": "3-(1,3-Benzodioxol-5-yl)-2-methylpropanal (Helional) (CAS No. 1205-17-0) (provided for in subheading 2932.99.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.58",
      "rawHtsCode": "9902.05.58",
      "superior": null,
      "indent": "0",
      "description": "Reaction mixture of (rel-2R,4R)-tetrahydro-4-methyl-2-(2-methylpropyl)-2H-pyran-4-ol and (rel-2R,4S)-tetrahydro-4-methyl-2-(2-methylpropyl)-2H-pyran-4-ol (CAS No. 63500-71-0) (provided for in subheading 2932.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.59",
      "rawHtsCode": "9902.05.59",
      "superior": null,
      "indent": "0",
      "description": "(2-Isobutyl-2-methyl-1,3-dioxolan-4-yl)methanol (CAS No. 5660-53-7) (provided for in subheading 2932.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.60",
      "rawHtsCode": "9902.05.60",
      "superior": null,
      "indent": "0",
      "description": "6-Isopropyl-9-methyl-1,4-dioxaspiro[4.5]decane-2-methanol (Menthone glyceryl ketal) (CAS No. 63187-91-7) (provided for in subheading 2932.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.61",
      "rawHtsCode": "9902.05.61",
      "superior": null,
      "indent": "0",
      "description": "tert-Butyl (E)-α-(1,3-dimethyl-5-phenoxypyrazol-4-ylmethyleneamino oxy)-p-toluate (Fenpyroximate (ISO)) (CAS No. 134098-61-6) (provided for in subheading 2933.19.23)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.62",
      "rawHtsCode": "9902.05.62",
      "superior": null,
      "indent": "0",
      "description": "1-(3-Chloro-4,5,6,7-tetrahydropyrazolo[1,5-a]pyridin-2-yl)-5- [methyl(prop-2-ynyl)amino]pyrazole-4-carbonitrile (Pyraclonil) (CAS No. 158353-15-2) (provided for in subheading 2933.19.23)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.63",
      "rawHtsCode": "9902.05.63",
      "superior": null,
      "indent": "0",
      "description": "Ethyl 2-chloro-5-(4-chloro-5-difluoromethoxy-1-methyl-1H-pyra- zol-3-yl)-4-fluorophenoxyacetate (Pyraflufen-ethyl) (CAS. No 129630-19-9) (provided for in subheading 2933.19.23)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.64",
      "rawHtsCode": "9902.05.64",
      "superior": null,
      "indent": "0",
      "description": "4-Chloro-3-ethyl-1-methyl-N-[4-(p-tolyloxy)benzyl] pyrazole-5-carboxamide (Tolfenpyrad) (CAS No. 129558-76-5) (provided for in subheading 2933.19.23)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.65",
      "rawHtsCode": "9902.05.65",
      "superior": null,
      "indent": "0",
      "description": "5-Fluoro-1,3-dimethyl-N-[2-(4-methylpentan-2-yl)phe- nyl]-1H-pyrazole-4-carboxamide (CAS No. 494793-67-8) (provided for in subheading 2933.19.23)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.66",
      "rawHtsCode": "9902.05.66",
      "superior": null,
      "indent": "0",
      "description": "(RS)-5-Amino-1-[2,6-dichloro-4-(trifluoromethyl)phe- nyl]-4-(trifluoromethysulfinyl)-1H-pyrazole-3-carbonitrile (Fipronil) (CAS No. 120068-37-3) (provided for in subheading 2933.19.23) \n   \n  \n",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.67",
      "rawHtsCode": "9902.05.67",
      "superior": null,
      "indent": "0",
      "description": "Methyl N-(2-[[1-(4-chlorophenyl)pyrazol-3-yl]oxymethyl]- phenyl)-(N-methoxy)carbamate (Pyraclostrobin) (CAS No. 175013-18-0) (provided for in subheading 2933.19.23)",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.68",
      "rawHtsCode": "9902.05.68",
      "superior": null,
      "indent": "0",
      "description": "N-[2-(2-Cyclopropylcyclopropyl)phenyl]-3-(difluoromethyl)- 1-methylpyrazole-4-carboxamide (Sedaxane) (CAS No. 874967-67-6) (provided for in subheading 2933.19.23)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.69",
      "rawHtsCode": "9902.05.69",
      "superior": null,
      "indent": "0",
      "description": "N-[9-(Dichloromethylidene)-1,2,3,4-tetrahydro-1,4-methano- naphthalen-5-yl]-3-(difluoromethyl)-1-methyl-1H-pyrazole-4-carboxamide (Benzovindiflupyr) (CAS No. 1072957-71-1) (provided for in subheading 2933.19.23)",
      "units": [],
      "generalRate": "4.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.70",
      "rawHtsCode": "9902.05.70",
      "superior": null,
      "indent": "0",
      "description": "S-Allyl 5-amino-2-isopropyl-4-(2-methylphenyl)-3-oxo-2,3- dihydro-1H-pyrazole-1-carbothioate (Fenpyrazamine) (CAS No. 473798-59-3) (provided for in subheading 2933.19.23)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.71",
      "rawHtsCode": "9902.05.71",
      "superior": null,
      "indent": "0",
      "description": "1-[[1-ethyl-4-[3-(2-methoxyethoxy)-2-methyl-4-(methylsul- fonyl)benzoyl]-1H-pyrazol-5-yl]oxy]ethyl methyl carbonate (Tolpyralate) (CAS No. 1101132-67-5) (provided for in subheading 2933.19.23)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.72",
      "rawHtsCode": "9902.05.72",
      "superior": null,
      "indent": "0",
      "description": "3-(Difluoromethyl)-1-methyl-N-(3',4',5'-trifluorobiphe- nyl-2-yl)pyrazole-4-carboxamide (Fluxapyroxad) (CAS No. 907204-31-3) (provided for in subheading 2933.19.37)",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.73",
      "rawHtsCode": "9902.05.73",
      "superior": null,
      "indent": "0",
      "description": "3-(3,5-Dichlorophenyl)-N-isopropyl-2,4-dioxoimidazoli- dine-1-carboxamide (Iprodione) (CAS No. 36734-19-7) (provided for in subheading 2933.21.00)",
      "units": [],
      "generalRate": "2.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.74",
      "rawHtsCode": "9902.05.74",
      "superior": null,
      "indent": "0",
      "description": "(E)-4-Chloro-α,α,α-trifluoro-N-(1-imidazol-1-yl-2- propoxyethylidene)-o-toluidine (Triflumizole) (CAS No. 99387-89-0) (provided for in subheading 2933.29.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.75",
      "rawHtsCode": "9902.05.75",
      "superior": null,
      "indent": "0",
      "description": "(S)-1-Anilino-4-methyl-2-methylthio-4-phenylimidazolin-5-one (Fenamidone) (CAS No. 161326-34-7) (provided for in subheading 2933.29.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.76",
      "rawHtsCode": "9902.05.76",
      "superior": null,
      "indent": "0",
      "description": "4-Chloro-1-(dimethylaminosulfonyl)-5-(p-tolyl)imida- zole-2-carbonitrile (Cyazofamid) (CAS No. 120116-88-3) (provided for in subheading 2933.29.43)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.77",
      "rawHtsCode": "9902.05.77",
      "superior": null,
      "indent": "0",
      "description": "Creatinine (2-amino-1-methyl-1,5-dihydro-4H-imidazol-4-one) (CAS No. 60-27-5) (provided for in subheading 2933.29.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.78",
      "rawHtsCode": "9902.05.78",
      "superior": null,
      "indent": "0",
      "description": "Bis(2,2,6,6-tetramethyl-4-piperidyl) sebacate (CAS No. 52829-07-9) (provided for in subheading 2933.39.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.79",
      "rawHtsCode": "9902.05.79",
      "superior": null,
      "indent": "0",
      "description": "2,6-Dichloro-N-[3-chloro-5-(trifluoromethyl)-2- pyridylmethyl]benzamide (Fluopicolide) (CAS No. 239110-15-7) (provided for in subheading 2933.39.21)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.80",
      "rawHtsCode": "9902.05.80",
      "superior": null,
      "indent": "0",
      "description": "N-[2-[3-Chloro-5-(trifluoromethyl)pyridin-2-yl]ethyl]-2- (trifluoromethyl)benzamide (Fluopyram) (CAS No. 658066-35-4) (provided for in subheading 2933.39.21)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.81",
      "rawHtsCode": "9902.05.81",
      "superior": null,
      "indent": "0",
      "description": "2-Chloro-N-(4'-chloro-biphenyl-2-yl)-nicotinamide (Boscalid) (CAS No. 188425-85-6) (provided for in subheading 2933.39.21)",
      "units": [],
      "generalRate": "5.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.82",
      "rawHtsCode": "9902.05.82",
      "superior": null,
      "indent": "0",
      "description": "N-[1-(4-Isopropoxy-2-methylphenyl)-2-methyl-1-oxopropan- 2-yl]-3-methylthiophene-2-carboxamide (Isofetamid) (CAS No. 875915-78-9) (provided for in subheading 2933.39.21)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.83",
      "rawHtsCode": "9902.05.83",
      "superior": null,
      "indent": "0",
      "description": "3-Chloro-N-[3-chloro-2,6-dinitro-4-(trifluoromethyl)phenyl]- 5-(trifluoromethyl)-2-pyridinamine (Fluazinam) (CAS No. 79622-59-6) (provided for in subheading 2933.39.21)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.84",
      "rawHtsCode": "9902.05.84",
      "superior": null,
      "indent": "0",
      "description": "(5-chloro-2-methoxy-4-methyl-3-pyridyl)(4,5,6-trimethoxy-o- tolyl)methanone (Pyriofenone) (CAS No. 688046-61-9) (provided for in subheading 2933.39.21) and any formulations containing such compound (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.85",
      "rawHtsCode": "9902.05.85",
      "superior": null,
      "indent": "0",
      "description": "o-Paraquat dichloride (CAS No. 1910-42-5) (provided for in subheading 2933.39.23)",
      "units": [],
      "generalRate": "3.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.86",
      "rawHtsCode": "9902.05.86",
      "superior": null,
      "indent": "0",
      "description": "5-Ethyl-2-[(RS)-4-isopropyl-4-methyl-5-oxo-2- imidazolin-2-yl]nicotinic acid (Imazethapyr) (CAS No. 81335-77-5) (provided for in subheading 2933.39.25)",
      "units": [],
      "generalRate": "2.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.87",
      "rawHtsCode": "9902.05.87",
      "superior": null,
      "indent": "0",
      "description": "1-Methyl-3-phenyl-5-[3-(trifluoromethyl)phenyl]-4(1H)-pyridinone (Fluridone) (CAS No. 59756-60-4) (provided for in subheading 2933.39.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.88",
      "rawHtsCode": "9902.05.88",
      "superior": null,
      "indent": "0",
      "description": "4-Hydroxy-3-[[2-[(2-methoxyethoxy)methyl]-6-(trifluor- omethyl)-3-pyridinyl]carbonyl]bicyclo[3.2.1]oct- 3-en-2-one (Bicyclopyrone) (CAS No. 352010-68-5) (provided for in subheading 2933.39.25)",
      "units": [],
      "generalRate": "4.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.89",
      "rawHtsCode": "9902.05.89",
      "superior": null,
      "indent": "0",
      "description": "3,6-Dichloro-2-pyridinecarboxylic acid (CAS No. 1702-17-6) (provided for in subheading 2933.39.25)",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.90",
      "rawHtsCode": "9902.05.90",
      "superior": null,
      "indent": "0",
      "description": "4-Amino-3,5,6-trichloro-2-pyridinecarboxylic acid (CAS No. 1918-02-1)(provided for in subheading 2933.39.25)",
      "units": [],
      "generalRate": "4.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.91",
      "rawHtsCode": "9902.05.91",
      "superior": null,
      "indent": "0",
      "description": "2-Propyn-1-yl (2R)-2-{4-[(5-chloro-3-fluoro-2- pyridinyl)oxy]phenoxy}propanoate (Clodinafop-propargyl) (CAS No. 105512-06-9) (provided for in subheading 2933.39.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.92",
      "rawHtsCode": "9902.05.92",
      "superior": null,
      "indent": "0",
      "description": "4-Amino-3,6-dichloro-2-pyridinecarboxylic acid (Aminopyralid) (CAS No. 150114-71-9) (provided for in subheading 2933.39.25)",
      "units": [],
      "generalRate": "4.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.93",
      "rawHtsCode": "9902.05.93",
      "superior": null,
      "indent": "0",
      "description": "[(3,5,6-Trichloro-2-pyridinyl)oxy]acetic acid (Triclopyr) (CAS No. 55335-06-3) (provided for in subheading 2933.39.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.94",
      "rawHtsCode": "9902.05.94",
      "superior": null,
      "indent": "0",
      "description": "2-Octanyl [(4-amino-3,5-dichloro-6-fluoro-2-pyridinyl)oxy]acetate (Fluroxypyr-meptyl) (CAS No. 81406-37-3) (provided for in subheading 2933.39.25)",
      "units": [],
      "generalRate": "1.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.95",
      "rawHtsCode": "9902.05.95",
      "superior": null,
      "indent": "0",
      "description": "Methyl 4-amino-3-chloro-6-(4-chloro-2-fluoro-3-methoxy- phenyl)-2-pyridinecarboxylate (Halauxifen-methyl) (CAS No. 943831-98-9) (provided for in subheading 2933.39.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.96",
      "rawHtsCode": "9902.05.96",
      "superior": null,
      "indent": "0",
      "description": "1,1-Dimethylpiperidinium chloride (Mepiquat chloride) (CAS No. 24307-26-4) (provided for in subheading 2933.39.27)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.97",
      "rawHtsCode": "9902.05.97",
      "superior": null,
      "indent": "0",
      "description": "N-[1-[(6-Chloropyridin-3-yl)methyl]-4,5-dihydroimidazol- 2-yl]nitramide (Imidacloprid) (CAS No. 138261-41-3) (provided for in subheading 2933.39.27)",
      "units": [],
      "generalRate": "4.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.98",
      "rawHtsCode": "9902.05.98",
      "superior": null,
      "indent": "0",
      "description": "1-Methylpropyl 2-(2-hydroxyethyl)piperidine-1-carboxylate (CAS No.119515-38-7) (provided for in subheading 2933.39.27)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.05.99",
      "rawHtsCode": "9902.05.99",
      "superior": null,
      "indent": "0",
      "description": "(E)-N1-[(6-Chloro-3-pyridyl)methyl]-N2-cyano-N1- methyl-acetamidine (Acetamiprid) (CAS No. 135410-20-7) (provided for in subheading 2933.39.27)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.01",
      "rawHtsCode": "9902.06.01",
      "superior": null,
      "indent": "0",
      "description": "2-Chloro-6-(trichloromethyl)pyridine (CAS No. 1929-82-4) (provided for in subheading 2933.39.27)",
      "units": [],
      "generalRate": "0.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.02",
      "rawHtsCode": "9902.06.02",
      "superior": null,
      "indent": "0",
      "description": "Copper(2+) bis(2-pyridinethiolate 1-oxide) (CAS No. 14915-37-8) (provided for in subheading 2933.39.27)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.03",
      "rawHtsCode": "9902.06.03",
      "superior": null,
      "indent": "0",
      "description": "2-(3-{2,6-Dichloro-4-[(3,3-dichloro-2-propen- 1-yl)oxy]phenoxy}propoxy)-5-(trifluor- omethyl)pyridine (Pyridalyl) (CAS No. 179101-81-6) (provided for in subheading 2933.39.27)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.04",
      "rawHtsCode": "9902.06.04",
      "superior": null,
      "indent": "0",
      "description": "2-{[1-(4-Phenoxyphenoxy)-2-propanyl]oxy}pyridine (Pyriproxyfen) (CAS No. 95737-68-1)(provided for in subheading 2933.39.27)",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.05",
      "rawHtsCode": "9902.06.05",
      "superior": null,
      "indent": "0",
      "description": "Methyl {(2S,3R)-1-[(2S)-2-{5-[(2R,5R)-1-{3,5-difluoro- 4-[4-(4-fluorophenyl)-1-piperidinyl]phenyl}-5-(6- fluoro-2-{(2S)-1-[N-(methoxycarbonyl)-O-methyl-L-threonyl]- 2-pyrrolidinyl}-1H-benzimidazol-5-yl)- 2-pyrrolidinyl]-6-fluoro-1H-benzimidazol-2-yl}-1- pyrrolidinyl]-3-methoxy-1-oxo-2-butanyl}carbamate (Pibrentasvir) (CAS No. 1353900-92-1) (provided for in subheading 2933.39.41)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.06",
      "rawHtsCode": "9902.06.06",
      "superior": null,
      "indent": "0",
      "description": "(2S,5R)-7-Oxo-N-(piperidin-4-yl)-6-(sulfooxy)-1,6-diaza- bicyclo[3.2.1]octane-2-carboxamide (CAS No.1174018-99-5) (provided for in subheading 2933.39.41)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.07",
      "rawHtsCode": "9902.06.07",
      "superior": null,
      "indent": "0",
      "description": "2,3-Dichloro-5-(trifluoromethyl)pyridine (CAS No. 69045-84-7) (provided for in subheading 2933.39.61)",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.08",
      "rawHtsCode": "9902.06.08",
      "superior": null,
      "indent": "0",
      "description": "2-Acetylnicotinic acid (CAS No. 89942-59-6) (provided for in subheading 2933.39.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.09",
      "rawHtsCode": "9902.06.09",
      "superior": null,
      "indent": "0",
      "description": "Bis(2,2,6,6-tetramethyl-1-octyloxy-4-piperidyl) sebacate (CAS No. 129757-67-1) (provided for in subheading 2933.39.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.10",
      "rawHtsCode": "9902.06.10",
      "superior": null,
      "indent": "0",
      "description": "5-Methylmethoxypyridine-2,3-dicarboxylic acid (CAS No. 143382-03-0) (provided for in subheading 2933.39.61)",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.11",
      "rawHtsCode": "9902.06.11",
      "superior": null,
      "indent": "0",
      "description": "Dimethyl 5-methylpyridine-2,3-dicarboxylate (CAS No. 112110-16-4) (provided for in subheading 2933.39.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.12",
      "rawHtsCode": "9902.06.12",
      "superior": null,
      "indent": "0",
      "description": "5-Methylpyridine-2,3-dicarboxylic acid (CAS No. 53636-65-0) (provided for in subheading 2933.39.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.13",
      "rawHtsCode": "9902.06.13",
      "superior": null,
      "indent": "0",
      "description": "2,3-Pyridinedicarboxylic acid (CAS No. 89-00-9) (provided for in subheading 2933.39.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.14",
      "rawHtsCode": "9902.06.14",
      "superior": null,
      "indent": "0",
      "description": "N,N'-1,6-Hexanediylbis(2,2,6,6-tetramethyl-4-piperidine- carboxamide (CAS No. 124172-53-8) (provided for in subheading 2933.39.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.15",
      "rawHtsCode": "9902.06.15",
      "superior": null,
      "indent": "0",
      "description": "Bis(1,2,2,6,6-pentamethyl-4-piperidyl)sebacate (CAS No. 41556-26-7) and methyl 1,2,2,6,6-pentamethyl-4-piperidyl sebacate (CAS No. 82919-37-7) (provided for in subheading 2933.39.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.16",
      "rawHtsCode": "9902.06.16",
      "superior": null,
      "indent": "0",
      "description": "N,N'-Bis(2,2,6,6-tetramethyl-4-piperidinyl)isophthalamide (CAS No. 42774-15-2) (provided for in subheading 2933.39.61).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.17",
      "rawHtsCode": "9902.06.17",
      "superior": null,
      "indent": "0",
      "description": "3-Dodecyl-1-(2,2,6,6-tetramethyl-4-piperidinyl)-2,5-pyr- rolidinedione (CAS No. 79720-19-7) (provided for in subheading 2933.39.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.18",
      "rawHtsCode": "9902.06.18",
      "superior": null,
      "indent": "0",
      "description": "1-(1-Acetyl-2,2,6,6-tetramethyl-4-piperidinyl)-3-dodecyl- 2,5-pyrrolidinedione (CAS No. 106917-31-1) (provided for in subheading 2933.39.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.19",
      "rawHtsCode": "9902.06.19",
      "superior": null,
      "indent": "0",
      "description": "2-Methoxy-4-(trifluoromethyl)pyridine (CAS No. 219715-34-1) (provided for in subheading 2933.39.61)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.20",
      "rawHtsCode": "9902.06.20",
      "superior": null,
      "indent": "0",
      "description": "2-Cyanopyridine (2-Pyridinecarbonitrile) (CAS No. 100-70-9) (provided for in subheading 2933.39.91)",
      "units": [],
      "generalRate": "2.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.21",
      "rawHtsCode": "9902.06.21",
      "superior": null,
      "indent": "0",
      "description": "N-Butyl-2,2,6,6-tetramethylpiperidin-4-amine (CAS No. 36177-92-1) (provided for in subheading 2933.39.91)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.22",
      "rawHtsCode": "9902.06.22",
      "superior": null,
      "indent": "0",
      "description": "Ethoxyquin (1,2-dihydro-6-ethoxy-2,2,4-trimethylquinoline) (CAS No. 91-53-2) (provided for in subheading 2933.49.10)",
      "units": [],
      "generalRate": "1.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.23",
      "rawHtsCode": "9902.06.23",
      "superior": null,
      "indent": "0",
      "description": "3,7-Dichloro-8-quinolinecarboxylic acid (Quinclorac) (CAS No. 84087-01-4) (provided for in subheading 2933.49.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.24",
      "rawHtsCode": "9902.06.24",
      "superior": null,
      "indent": "0",
      "description": "1-Methylhexyl [(5-chloroquinolin-8-yl)oxy]acetate (Cloquintocet-mexyl) (CAS No. 99607-70-2) (provided for in subheading 2933.49.60)",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.25",
      "rawHtsCode": "9902.06.25",
      "superior": null,
      "indent": "0",
      "description": "(5-Chloro-8-quinolyloxy)acetic acid (Cloquintocet) (CAS No. 88349-88-6) (provided for in subheading 2933.49.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.26",
      "rawHtsCode": "9902.06.26",
      "superior": null,
      "indent": "0",
      "description": "2-Methylquinoline (Quinaldine) (CAS No. 91-63-4) (provided for in subheading 2933.49.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.27",
      "rawHtsCode": "9902.06.27",
      "superior": null,
      "indent": "0",
      "description": "(2-Methyl-1-oxo-1-prop-2-enoxypropan-2-yl) 2-chloro-5-[3-methyl-2,6-dioxo-4-(trifluoro- methyl)pyrimidin-1-yl]benzoate (Butafenacil) (CAS No. 134605-64-4) (provided for in subheading 2933.59.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.28",
      "rawHtsCode": "9902.06.28",
      "superior": null,
      "indent": "0",
      "description": "3-tert-Butyl-5-chloro-6-methyluracil (Terbacil) (CAS No. 5902-51-2) (provided for in subheading 2933.59.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.29",
      "rawHtsCode": "9902.06.29",
      "superior": null,
      "indent": "0",
      "description": "Sodium 2,6-bis[(4,6-dimethoxypyrimidin-2-yl)oxy]benzoate (Bispyribac-sodium) (CAS No. 125401-92-5) (provided for in subheading 2933.59.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.30",
      "rawHtsCode": "9902.06.30",
      "superior": null,
      "indent": "0",
      "description": "Methyl (2E)-2-(2-{[6-(2-cyanophenoxy)pyrimidin-4- yl]oxy}phenyl)-3-methoxyacrylate (Azoxystrobin) (CAS No. 131860-33-8) (provided for in subheading 2933.59.15)",
      "units": [],
      "generalRate": "6.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.31",
      "rawHtsCode": "9902.06.31",
      "superior": null,
      "indent": "0",
      "description": "4-Cyclopropyl-6-methyl-N-phenylpyrimidin-2-amine (Cyprodinil) (CAS No. 121552-61-2) (provided for in subheading 2933.59.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.32",
      "rawHtsCode": "9902.06.32",
      "superior": null,
      "indent": "0",
      "description": "N-(4,6-Dimethylpyrimidin-2-yl)aniline (Pyrimethanil) (CAS No. 53112-28-0) (provided for in subheading 2933.59.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.33",
      "rawHtsCode": "9902.06.33",
      "superior": null,
      "indent": "0",
      "description": "N-Benzyl-3H-purin-6-amine (Benzyladenine) (CAS No.1214-39-7) (provided for in subheading 2933.59.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.34",
      "rawHtsCode": "9902.06.34",
      "superior": null,
      "indent": "0",
      "description": "5-Ethyl-6-octyl[1,2,4]triazolo[1,5-a]pyrimidin-7-amine (Ametoctradin) (CAS No. 865318-97-4) (provided for in subheading 2933.59.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.35",
      "rawHtsCode": "9902.06.35",
      "superior": null,
      "indent": "0",
      "description": "5-Bromo-3-sec-butyl-6-methyluracil (Bromacil) (CAS No. 314-40-9) (provided for in subheading 2933.59.18)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.36",
      "rawHtsCode": "9902.06.36",
      "superior": null,
      "indent": "0",
      "description": "O-(2-Diethylamino-6-methylpyrimidin-4-yl) O,O-dimethyl phosphorothioate (Pirimiphos-methyl) (CAS No. 29232-93-7) (provided for in subheading 2933.59.18)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.37",
      "rawHtsCode": "9902.06.37",
      "superior": null,
      "indent": "0",
      "description": "6-Amino-5-chloro-2-cyclopropyl-pyrimidine-4-carboxylic acid (Aminocyclopyrachlor) (CAS No. 858956-08-8) (provided for in subheading 2933.59.18)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.38",
      "rawHtsCode": "9902.06.38",
      "superior": null,
      "indent": "0",
      "description": "{(4S)-8-Fluoro-2-[4-(3-methoxyphenyl)-1-pipera- zinyl]-3-[2-methoxy-5-(trifluoromethyl)phenyl]- 3,4-dihydro-4-quinazolinyl}acetic acid (CAS No. 917389-32-3) (provided for in subheading 2933.59.36)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.39",
      "rawHtsCode": "9902.06.39",
      "superior": null,
      "indent": "0",
      "description": "3-[(1S,2S)-2-Hydroxycyclohexyl]-6-[(6-methyl-3- pyridinyl)methyl]benzo[h]quinazolin-4(3H)-one (CAS No.1227923-29-6) (provided for in subheading 2933.59.53)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.40",
      "rawHtsCode": "9902.06.40",
      "superior": null,
      "indent": "0",
      "description": "1-Acetyl-1,2,3,4-tetrahydro-3-[(3-pyridylmethyl)amino]- 6-[1,2,2,2-tetrafluoro-1-(trifluoromethyl) ethyl] quinazolin-2-one (Pyrifluquinazon) (CAS No. 337458-27-2) (provided for in subheading 2933.59.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.41",
      "rawHtsCode": "9902.06.41",
      "superior": null,
      "indent": "0",
      "description": "2,2'-Disulfanediylbis(5-ethoxy-7-fluoro[1,2,4]tri- azolo[1,5-c]pyrimidine) (CAS No. 166524-75-0) (provided for in subheading 2933.59.70)",
      "units": [],
      "generalRate": "0.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.42",
      "rawHtsCode": "9902.06.42",
      "superior": null,
      "indent": "0",
      "description": "Phenyl(4,6-dimethoxy-2-pyrimidinyl)carbamate (CAS No. 89392-03-0) (provided for in subheading 2933.59.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.43",
      "rawHtsCode": "9902.06.43",
      "superior": null,
      "indent": "0",
      "description": "1-[2-Fluoro-6-(trifluoromethyl)benzyl]-5-iodo-6- methyl-2,4(1H,3H)-pyrimidinedione (CAS No. 1150560-54-5) (provided for in subheading 2933.59.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.44",
      "rawHtsCode": "9902.06.44",
      "superior": null,
      "indent": "0",
      "description": "(RS)-2′-[(4,6-dimethoxypyrimidin-2-yl)(hydroxy)methyl]-1,1- difluoro-6′-(methoxymethyl)methanesulfonanilide (Pyrimisulfan) (CAS No. 221205-90-9) (provided for in subheading 2933.59.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.45",
      "rawHtsCode": "9902.06.45",
      "superior": null,
      "indent": "0",
      "description": "2,2-Dithiobis(8-fluoro-5-methoxy)-1,2,4-triazolo[1,5-c] pyrimidine (CAS No. 166524-74-9) (provided for in subheading 2933.59.95)",
      "units": [],
      "generalRate": "1.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.46",
      "rawHtsCode": "9902.06.46",
      "superior": null,
      "indent": "0",
      "description": "Triethylenediamine (1,4-diazabicyclo[2.2.2]octane) (CAS No. 280-57-9) (provided for in subheading 2933.59.95)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.47",
      "rawHtsCode": "9902.06.47",
      "superior": null,
      "indent": "0",
      "description": "5,8-Dimethoxy[1,2,4]triazolo[1,5-c]pyrimidin-2-amine (CAS No. 219715-62-5) (provided for in subheading 2933.59.95)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.48",
      "rawHtsCode": "9902.06.48",
      "superior": null,
      "indent": "0",
      "description": "4,6-Dimethyl-2-pyrimidinamine (CAS No. 767-15-7) (provided for in subheading 2933.59.95)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.49",
      "rawHtsCode": "9902.06.49",
      "superior": null,
      "indent": "0",
      "description": "2-Amino-5,7-dimethoxy-1,2,4-triazolo[1,5-a]pyrimidine (ADTP) (CAS No. 13223-43-3) (provided for in subheading 2933.59.95)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.50",
      "rawHtsCode": "9902.06.50",
      "superior": null,
      "indent": "0",
      "description": "Cyanuric chloride (2,4,6-trichloro-1,3,5-triazine) (CAS No. 108-77-0) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.51",
      "rawHtsCode": "9902.06.51",
      "superior": null,
      "indent": "0",
      "description": "4-Amino-6-tert-butyl-3-methylthio-1,2,4-triazin-5(4H)-one (Metribuzin) (CAS No. 21087-64-9) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.52",
      "rawHtsCode": "9902.06.52",
      "superior": null,
      "indent": "0",
      "description": "3-Cyclohexyl-6-dimethylamino-1-methyl-1,3,5-triazine- 2,4(1H,3H)-dione (Hexazinone) (CAS No. 51235-04-2) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.53",
      "rawHtsCode": "9902.06.53",
      "superior": null,
      "indent": "0",
      "description": "6-Methyl-4-{[(1E)-pyridin-3-ylmethylene]amino}-4,5- dihydro-1,2,4-triazin-3(2H)-one (Pymetrozine) (CAS No. 123312-89-0) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.54",
      "rawHtsCode": "9902.06.54",
      "superior": null,
      "indent": "0",
      "description": "6-Chloro-4-N-ethyl-2-N-propan-2-yl-1,3,5-triazine-2,4-diamine (Atrazine) (CAS No. 1912-24-9) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.55",
      "rawHtsCode": "9902.06.55",
      "superior": null,
      "indent": "0",
      "description": "6-Chloro-2-N,4-N-diethyl-1,3,5-triazine-2,4-diamine (Simazine) (CAS No. 122-34-9) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.56",
      "rawHtsCode": "9902.06.56",
      "superior": null,
      "indent": "0",
      "description": "1,3,5-Triazinane-2,4,6-trione—1,3,5-triazine-2,4,6-triamine (1:1) (CAS No. 37640-57-6) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.57",
      "rawHtsCode": "9902.06.57",
      "superior": null,
      "indent": "0",
      "description": "6-Chloro-2-N,4-N-di(propan-2-yl)-1,3,5-triazine-2,4-diamine (Propazine) (CAS No. 139-40-2) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.58",
      "rawHtsCode": "9902.06.58",
      "superior": null,
      "indent": "0",
      "description": "N-[(1R,2S)-2,6-Dimethyl-2,3-dihydro-1H-inden-1-yl]-6-[(1R)- 1-fluoroethyl]-1,3,5-triazine-2,4-diamine (Indaziflam) (CAS No. 950782-86-2) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.59",
      "rawHtsCode": "9902.06.59",
      "superior": null,
      "indent": "0",
      "description": "2-(4,6-Diphenyl-1,3,5-triazin-2-yl)-5-(hexyloxy)phenol (CAS No. 147315-50-2) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.60",
      "rawHtsCode": "9902.06.60",
      "superior": null,
      "indent": "0",
      "description": "2-[4,6-Di(4-biphenylyl)-1,3,5-triazin-2-yl]-5-[(2-ethylhexyl)oxy]phenol (CAS No. 204583-39-1) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.61",
      "rawHtsCode": "9902.06.61",
      "superior": null,
      "indent": "0",
      "description": "(4E)-4-(Ethylimino)-N-(2-methyl-2-propanyl)-6-(methylsulfanyl)- 1,4-dihydro-1,3,5-triazin-2-amine (terbutryn) (CAS No. 886-50-0) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.62",
      "rawHtsCode": "9902.06.62",
      "superior": null,
      "indent": "0",
      "description": "1,3,5-Tris(2-hydroxyethyl)-1,3,5-triazinane-2,4,6-trione (THEIC) (CAS No. 839-90-7) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.63",
      "rawHtsCode": "9902.06.63",
      "superior": null,
      "indent": "0",
      "description": "4-Methoxy-6-methyl-1,3,5-triazin-2-amine (CAS No. 1668-54-8) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.64",
      "rawHtsCode": "9902.06.64",
      "superior": null,
      "indent": "0",
      "description": "4-Methoxy-N,6-dimethyl-1,3,5-triazin-2-amine (CAS No. 5248-39-5) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.65",
      "rawHtsCode": "9902.06.65",
      "superior": null,
      "indent": "0",
      "description": "Triallyl cyanurate (2,4,6-tris(allyloxy)-1,3,5-triazine) (CAS No. 101-37-1) (provided for in subheading 2933.69.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.66",
      "rawHtsCode": "9902.06.66",
      "superior": null,
      "indent": "0",
      "description": "(4Z)-5-(4-Chlorophenyl)-2,2-dimethyl-4-(1H-1,2,4- triazol-1-yl)-4-hexen-3-ol (Uniconazole-P) (CAS No. 83657-17-4) (provided for in subheading 2933.69.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.67",
      "rawHtsCode": "9902.06.67",
      "superior": null,
      "indent": "0",
      "description": "(5s,8s)-3-(2,5-Dimethylphenyl)-8-methoxy-2-oxo- 1-azaspiro[4.5]dec-3-en-4-yl ethyl carbonate (Spirotetramat) (CAS No. 203313-25-1) (provided for in subheading 2933.79.08)",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.68",
      "rawHtsCode": "9902.06.68",
      "superior": null,
      "indent": "0",
      "description": "3-Chloro-5-({1-[(4-methyl-5-oxo-4,5-dihydro-1H- 1,2,4-triazol-3-yl)methyl]-2-oxo-4-(trifluoromethyl)- 1,2-dihydro-3-pyridinyl}oxy)benzonitrile (Doravirine INN) (CAS No. 1338225-97-0) (provided for in subheading 2933.79.08)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.69",
      "rawHtsCode": "9902.06.69",
      "superior": null,
      "indent": "0",
      "description": "N,Nʹ-(Methylenedi-p-phenylene)bis[hexahydro-2- oxo-1H-azepine-1-carboxamide] (CAS No. 54112-23-1) (provided for in subheading 2933.79.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.70",
      "rawHtsCode": "9902.06.70",
      "superior": null,
      "indent": "0",
      "description": "2-(4-Chlorophenyl)-2-(1H-1,2,4-triazol-1-ylmethyl)hexanenitrile (myclobutanil) (CAS No. 88671-89-0) (provided for in subheading 2933.99.06)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.71",
      "rawHtsCode": "9902.06.71",
      "superior": null,
      "indent": "0",
      "description": "4-(4-Chlorophenyl)-2-phenyl-2-(1H-1,2,4-triazol-1- ylmethyl)butanenitrile (Fenbuconazole) (CAS No. 114369-43-6) (provided for in subheading 2933.99.06)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.72",
      "rawHtsCode": "9902.06.72",
      "superior": null,
      "indent": "0",
      "description": "4-{2-[4-(2-Methyl-2-propanyl)phenyl]ethoxy}quinazoline (Fenazaquin) (CAS No. 120928-09-8) (provided for in subheading 2933.99.17)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.73",
      "rawHtsCode": "9902.06.73",
      "superior": null,
      "indent": "0",
      "description": "3-Bromo-N-[2-bromo-4-chloro-6-[[(1-cyclo- propylethyl)amino]carbonyl]phenyl]-1-(3-chloro-2- pyridinyl)-1H-pyrazole-5-carboxamide (Cyclaniliprole) (CAS No. 1031756-98-5) (provided for in subheading 2933.99.17)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.74",
      "rawHtsCode": "9902.06.74",
      "superior": null,
      "indent": "0",
      "description": "2-tert-Butyl-5-(4-tert-butylbenzylthio)-4- chloropyridazin-3(2H)-one (Pyridaben) (CAS No. 96489-71-3) (provided for in subheading 2933.99.22)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.75",
      "rawHtsCode": "9902.06.75",
      "superior": null,
      "indent": "0",
      "description": "1-(4-Chlorophenoxy)-3,3-dimethyl-1-(1H-1,2,4-triazol-1-yl)-2-butanone (Triadimefon) (CAS No. 43121-43-3) (provided for in subheading 2933.99.22).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.76",
      "rawHtsCode": "9902.06.76",
      "superior": null,
      "indent": "0",
      "description": "N-(3′,4′-Difluorobiphenyl-2-yl)-3-(trifluoromethyl)pyra- zine-2-carboxamide (Pyraziflumid) (CAS No. 942515-63-1) (provided for in subheading 2933.99.22)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.77",
      "rawHtsCode": "9902.06.77",
      "superior": null,
      "indent": "0",
      "description": "[α-(4-Chlorophenyl)-α-(1-cyclopropylethyl)-1H-1-1,2,4- triazole-1-ethanol (Cyproconazole) (CAS No. 94361-06-5) (provided for in subheading 2933.99.22)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.78",
      "rawHtsCode": "9902.06.78",
      "superior": null,
      "indent": "0",
      "description": "(RS)-1-p-Chlorophenyl-4,4-dimethyl-3-(1H-1,2,4-triazol-1- ylmethyl)pentan-3-ol (Tebuconazole) (CAS No. 107534-96-3) (provided for in subheading 2933.99.22)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.79",
      "rawHtsCode": "9902.06.79",
      "superior": null,
      "indent": "0",
      "description": "E-5-(4-Chlorobenzylidene)-2,2-dimethyl-1-(1H-1,2,4-triazol- 1-ylmethyl)cyclopentanol (Triticonazole) (CAS No. 131983-72-7) (provided for in subheading 2933.99.22)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.80",
      "rawHtsCode": "9902.06.80",
      "superior": null,
      "indent": "0",
      "description": "5-[(4-Chlorophenyl)methyl]-2,2-dimethyl-1-(1,2,4-triazol- 1-ylmethyl)cyclopentan-1-ol (Metconazole) (CAS No. 125116-23-6) (provided for in subheading 2933.99.22)",
      "units": [],
      "generalRate": "1.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.81",
      "rawHtsCode": "9902.06.81",
      "superior": null,
      "indent": "0",
      "description": "2-[(2RS)-2-(1-Chlorocyclopropyl)-3-(2-chlorophenyl)-2-hydrox- ypropyl]-2H-1,2,4-triazole-3(4H)-thione (Prothioconazole) (CAS No. 178928-70-6)(provided for in subheading 2933.99.22)",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.82",
      "rawHtsCode": "9902.06.82",
      "superior": null,
      "indent": "0",
      "description": "(2RS,3RS)-1-(4-Chlorophenyl)-4,4-dimethyl-2- (1H-1,2,4-triazol-1-yl)pentan-3-ol (Paclobutrazol) (CAS No. 76738-62-0) (provided for in subheading 2933.99.22)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.83",
      "rawHtsCode": "9902.06.83",
      "superior": null,
      "indent": "0",
      "description": "Methyl N-(1H-benzimidazol-2-yl)carbamate (Carbendazim) (CAS No. 10605-21-7) (provided for in subheading 2933.99.22)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.84",
      "rawHtsCode": "9902.06.84",
      "superior": null,
      "indent": "0",
      "description": "1-(2-Fluorophenyl)-1-(4-fluorophenyl)-2-(1H-1,2,4- triazol-1-yl)ethanol (Flutriafol) (CAS no. 76674-21-0) (provided for in subheading 2933.99.22)\n",
      "units": [],
      "generalRate": "0.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.85",
      "rawHtsCode": "9902.06.85",
      "superior": null,
      "indent": "0",
      "description": "(1R,2S,5R)-2-(4-Chlorobenzyl)-5-isopropyl-1-(1H-1,2,4- triazol-1-ylmethyl)cyclopentanol (Ipconazole) (CAS No. 125225-28-7) (provided for in subheading 2933.99.22)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.86",
      "rawHtsCode": "9902.06.86",
      "superior": null,
      "indent": "0",
      "description": "1-[2-(2,4-Dichlorophenyl)-3-(1,1,2,2-tetrafluoroethoxy)- propyl]-1H-1,2,4-triazole (Tetraconazole) (CAS No. 112281-77-3) (provided for in subheading 2933.99.22)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.87",
      "rawHtsCode": "9902.06.87",
      "superior": null,
      "indent": "0",
      "description": "Ethyl 2-chloro-3-{2-chloro-5-[4-(difluoromethyl)-3- methyl-5-oxo-4,5-dihydro-1H-1,2,4-triazol-1-yl]-4- fluorophenyl}propanoate (Carfentrazone-ethyl) (CAS No. 128639-02-1) (provided for in subheading 2933.99.22) and formulations thereof (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.88",
      "rawHtsCode": "9902.06.88",
      "superior": null,
      "indent": "0",
      "description": "4-Bromo-2-(4-chlorophenyl)-5-(trifluoromethyl)-1H-pyr- role-3-carbonitrile (Tralopyril) (CAS No. 122454-29-9) (provided for in subheading 2933.99.22).\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.89",
      "rawHtsCode": "9902.06.89",
      "superior": null,
      "indent": "0",
      "description": "2-(2H-Benzotriazol-2-yl)-4,6-di-tert-pentylphenol (CAS No. 25973-55-1) (provided for in subheading 2933.99.79)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.90",
      "rawHtsCode": "9902.06.90",
      "superior": null,
      "indent": "0",
      "description": "2-(2H-Benzotriazol-2-yl)-4,6-bis(1-methyl-1-phenylethyl)phenol (CAS No. 70321-86-7) (provided for in subheading 2933.99.79)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.91",
      "rawHtsCode": "9902.06.91",
      "superior": null,
      "indent": "0",
      "description": "2,5-Dichloro-3,6-bis[(9-ethylcarbazol-3-yl)amino]cyclo- hexa-2,5-diene-1,4-dione (Dianil) (CAS No. 80546-37-8) (provided for in subheading 2933.99.79)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.92",
      "rawHtsCode": "9902.06.92",
      "superior": null,
      "indent": "0",
      "description": "2-[3-(2H-Benzotriazol-2-yl)-4-hydroxyphenyl]ethyl methacrylate (CAS No. 96478-09-0) (provided for in subheading 2933.99.79)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.93",
      "rawHtsCode": "9902.06.93",
      "superior": null,
      "indent": "0",
      "description": "2-Phenylbenzimidazole-5-sulfonic acid (Ensulizole) (CAS No. 27503-81-7 ) (provided for in subheading 2933.99.79)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.94",
      "rawHtsCode": "9902.06.94",
      "superior": null,
      "indent": "0",
      "description": "9-Ethyl-9H-carbazol-3-amine (amino ethyl carbazole) (CAS No. 132-32-1) (provided for in subheading 2933.99.82)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.95",
      "rawHtsCode": "9902.06.95",
      "superior": null,
      "indent": "0",
      "description": "1H-Isoindole-1,3(2H)-diimine (1,3 diamino isoindoline) (CAS No. 3468-11-9) (provided for in subheading 2933.99.82)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.96",
      "rawHtsCode": "9902.06.96",
      "superior": null,
      "indent": "0",
      "description": "3-{[3-(1-Aziridinyl)propanoyl]oxy}-2-({[3-(1-aziridinyl)pro- panoyl]oxy}methyl)-2-(hydroxymethyl)propyl 3-(1-aziridinyl)propanoate (CAS No. 57116-45-7) (provided for in subheading 2933.99.97)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.97",
      "rawHtsCode": "9902.06.97",
      "superior": null,
      "indent": "0",
      "description": "1H-[1,2,4]Triazole (1,2,4-Triazole) (CAS No. 288-88-0) (provided for in subheading 2933.99.97)",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.98",
      "rawHtsCode": "9902.06.98",
      "superior": null,
      "indent": "0",
      "description": "5-Amino-1,2-dihydro-3H-1,2,4-triazole-3-thione (CAS No.16691-43-3) (provided for in subheading 2933.99.97)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.06.99",
      "rawHtsCode": "9902.06.99",
      "superior": null,
      "indent": "0",
      "description": "(4RS,5RS)-5-(4-chlorophenyl)-N-cyclohexyl-4-methyl-2- oxo-1,3-thiazolidine-3-carboxamide (Hexythiazox) (CAS No. 78587-05-0) (provided for in subheading 2934.10.10)",
      "units": [],
      "generalRate": "1.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.01",
      "rawHtsCode": "9902.07.01",
      "superior": null,
      "indent": "0",
      "description": "3-[(6-Chloro-3-pyridinyl)methyl]-1,3-thiazolidin-2- ylidenecyanamide (Thiacloprid) (CAS No. 111988-49-9) (provided for in subheading 2934.10.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.02",
      "rawHtsCode": "9902.07.02",
      "superior": null,
      "indent": "0",
      "description": "Methyl {(2S)-1-[(2S)-2-{5-[(6S)-6-(2-cyclopropyl-1,3- thiazol-5-yl)-1-fluoro-3-{2-[(2S)-1-{(2S)-2-[(methoxycar- bonyl)amino]-3-methylbutanoyl}-2-pyrrolidinyl]-1H-imidazol-5- yl}indolo[1,2-c][1,3]benzoxazin-10-yl]-1H-imidazol-2-yl}- 1-pyrrolidinyl]-3-methyl-1-oxo-2-butanyl}carbamate (Ruzasvir) (CAS No. 1613081-64-3) (provided for in subheading 2934.10.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.03",
      "rawHtsCode": "9902.07.03",
      "superior": null,
      "indent": "0",
      "description": "(2-{[(1-{1-[(2R,3R)-3-[4-(4-Cyanophenyl)-1,3-thiazol-2-yl]-2- (2,5-difluorophenyl)-2-hydroxybutyl]-1H-1,2,4- triazol-4-ium-4-yl}ethoxy)carbonyl](methyl)amino}-3- pyridinyl)methyl N-methylglycinate hydrogen sulfate (Isavuconazonium Sulfate) (CAS No. 946075-13-4) (provided for in subnheading 2934.10.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.04",
      "rawHtsCode": "9902.07.04",
      "superior": null,
      "indent": "0",
      "description": "4-[(2-bromo-5-chlorophenyl)methyl]-7-chloro-2-(2-cyclopropyl- 1,3-thiazol-5-yl)-5-fluoro-2H-3,1-benzoxazine (CAS No. 1855942-64-1) (provided for in subheading 2934.10.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.05",
      "rawHtsCode": "9902.07.05",
      "superior": null,
      "indent": "0",
      "description": "6-(2-Cyclopropylthiazol-5-yl)-1-fluoro-3,10-bis(4,4,5,5-tetra- methyl-1,3,2-dioxaborolan-2-yl)-6H-benzo[5,6][1,3]oxa- zino[3,4-a]indole (CAS No. 1620545-76-7) (provided for in subheading 2934.10.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.06",
      "rawHtsCode": "9902.07.06",
      "superior": null,
      "indent": "0",
      "description": "(E)-1-(2-Chloro-1,3-thiazol-5-ylmethyl)-3-methyl-2-nitro- guanidine (Clothianidin) (CAS No. 210880-92-5) (provided for in subheading 2934.10.90)",
      "units": [],
      "generalRate": "6.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.07",
      "rawHtsCode": "9902.07.07",
      "superior": null,
      "indent": "0",
      "description": "Thiamethoxam (3-(2-chloro-5-thiazolylmethyl)tetrahydro-5- methyl-N-nitro-1,3,5-oxadiazin-4-imine) (CAS No. 153719-23-4) (provided for in subheading 2934.10.90)",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.08",
      "rawHtsCode": "9902.07.08",
      "superior": null,
      "indent": "0",
      "description": "N-[Cyano(2-thienyl)methyl]-4-ethyl-2-(ethylamino)-1,3- thiazole-5-carboxamide (Ethaboxam) (CAS No. 162650-77-3) (provided for in subheading 2934.10.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.09",
      "rawHtsCode": "9902.07.09",
      "superior": null,
      "indent": "0",
      "description": "2-Mercaptobenzothiazole (benzothiazole-2-thiol) (CAS No. 149-30-4) (provided for in subheading 2934.20.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.10",
      "rawHtsCode": "9902.07.10",
      "superior": null,
      "indent": "0",
      "description": "2-(1,3-Benzothiazol-2-ylsulfanyl)succinic acid (CAS No. 95154-01-1) (provided for in subheading 2934.20.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.11",
      "rawHtsCode": "9902.07.11",
      "superior": null,
      "indent": "0",
      "description": "4-Methylbenzothiazol-2-ylamine (CAS No. 1477-42-5) (provided for in subheading 2934.20.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.12",
      "rawHtsCode": "9902.07.12",
      "superior": null,
      "indent": "0",
      "description": "Zinc bis(1,3-benzothiazole-2-thiolate) (CAS No. 155-04-4) (provided for in subheading 2934.20.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.13",
      "rawHtsCode": "9902.07.13",
      "superior": null,
      "indent": "0",
      "description": "3-[2,4-Dichloro-5-(1-methylethoxy)phenyl]-5-(1,1-dimethyl- ethyl)-1,3,4-oxadiazol-2(3H)-one (Oxadiazon) (CAS No. 19666-30-9) (provided for in subheading 2934.99.11)",
      "units": [],
      "generalRate": "1.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.14",
      "rawHtsCode": "9902.07.14",
      "superior": null,
      "indent": "0",
      "description": "1-({2-[2-Chloro-4-(4-chlorophenoxy)phenyl]-4-methyl-1,3- dioxolan-2-yl}methyl)-1H-1,2,4-triazole (Difenoconazole) (CAS No. 119446-68-3) (provided for in subheading 2934.99.12)",
      "units": [],
      "generalRate": "4.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.15",
      "rawHtsCode": "9902.07.15",
      "superior": null,
      "indent": "0",
      "description": "4-(2,2-Difluoro-1,3-benzodioxol-4-yl)-1H-pyrrole-3-carbonitrile (Fludioxonil (ISO)) (CAS No. 131341-86-1) (provided for in subheading 2934.99.12)",
      "units": [],
      "generalRate": "5.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.16",
      "rawHtsCode": "9902.07.16",
      "superior": null,
      "indent": "0",
      "description": "1-[[2-(2,4-Dichlorophenyl)-4-propyl-1,3-dioxolan-2-yl]- methyl]-1H-1,2,4-triazole (Propiconazole) (CAS No. 60207-90-1) (provided for in subheading 2934.99.12)",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.17",
      "rawHtsCode": "9902.07.17",
      "superior": null,
      "indent": "0",
      "description": "2-Methyl-N-phenyl-5,6-dihydro-1,4-oxathiine-3-carboxamide (Carboxin) (CAS No. 5234-68-4) (provided for in subheading 2934.99.12)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.18",
      "rawHtsCode": "9902.07.18",
      "superior": null,
      "indent": "0",
      "description": "2-Butyl-1,2-benzothiazol-3(2H)-one (CAS No. 4299-07-4) (provided for in subheading 2934.99.12)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.19",
      "rawHtsCode": "9902.07.19",
      "superior": null,
      "indent": "0",
      "description": "(2E)-3-(4-Chlorophenyl)-3-(3,4-dimethoxyphenyl)-1-(4- morpholinyl)-2-propen-1-one (CAS No. 110488-70-5) (provided for in subheading 2934.99.12)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.20",
      "rawHtsCode": "9902.07.20",
      "superior": null,
      "indent": "0",
      "description": "1-(4-{4-[5-(2,6-Difluorophenyl)-4,5-dihydro-1,2-oxazol- 3-yl]-1,3-thiazol-2-yl}-1-piperidinyl)-2-[5-methyl-3- (trifluoromethyl)-1H-pyrazol-1-yl]ethanone (Oxathiapiprolin) (CAS No. 1003318-67-9) (provided for in subheading 2934.99.12)",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " Compiler's note:  Probably should reference subheading 2934.10.10. Consult U.S. Customs and Border Protection for more assistance. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.21",
      "rawHtsCode": "9902.07.21",
      "superior": null,
      "indent": "0",
      "description": "(E)-{2-[6-(2-Chlorophenoxy)-5-fluoropyrimidin-4-yloxy] phenyl}(5,6-dihydro-1,4,2-dioxazin-3-yl)-N- methoxymethanimine (Fluoxastrobin) (CAS No. 361377-29-9) (provided for in subheading 2934.99.12)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.22",
      "rawHtsCode": "9902.07.22",
      "superior": null,
      "indent": "0",
      "description": "(5-Cyclopropyl-1,2-oxazol-4-yl)(α,α,α-trifluoro-2- mesyl-p-tolyl)methanone (Isoxaflutole) (CAS No. 141112-29-0) (provided for in subheading 2934.99.15).",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.23",
      "rawHtsCode": "9902.07.23",
      "superior": null,
      "indent": "0",
      "description": "3-Isopropyl-1H-2,1,3-benzothiadiazin-4(3H)-one-2,2-dioxide, sodium salt (Bentazon, sodium salt) (CAS No. 50723-80-3) (provided for in subheading 2934.99.15)",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.24",
      "rawHtsCode": "9902.07.24",
      "superior": null,
      "indent": "0",
      "description": "1-Phenyl-3-(1,2,3-thiadiazol-5-yl)urea (Thidiazuron) (CAS No. 51707-55-2) (provided for in subheading 2934.99.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.25",
      "rawHtsCode": "9902.07.25",
      "superior": null,
      "indent": "0",
      "description": "[3-(4,5-Dihydro-1,2-oxazol-3-yl)-4-mesyl-o-tolyl](5-hydroxy-1- methylpyrazol-4-yl)methanone (Topramezone) (CAS No. 210631-68-8) (provided for in subheading 2934.99.15)",
      "units": [],
      "generalRate": "4.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.26",
      "rawHtsCode": "9902.07.26",
      "superior": null,
      "indent": "0",
      "description": "8-(2,6-Diethyl-4-methylphenyl)-1,2,4,5-tetrahydro-7-oxo- 7H-pyrazolo[1,2-d][1,4,5]oxadiazepin-9-yl-2,2- dimethylpropanoate (Pinoxaden) (CAS No. 243973-20-8) (provided for in subheading 2934.99.15)",
      "units": [],
      "generalRate": "5.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.27",
      "rawHtsCode": "9902.07.27",
      "superior": null,
      "indent": "0",
      "description": "2,6-Dimethoxy-N-[3-(3-methyl-3-pentanyl)-1,2-oxazol-5- yl]benzamide (isoxaben) (CAS No. 82558-50-7) (provided for in subheading 2934.99.15)",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.28",
      "rawHtsCode": "9902.07.28",
      "superior": null,
      "indent": "0",
      "description": "2-(2-Chlorobenzyl)-4,4-dimethyl-1,2-oxazolidin-3-one (Clomazone) (CAS No. 81777-89-1) (provided for in subheading 2934.99.15) and any formulations containing such compound (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.29",
      "rawHtsCode": "9902.07.29",
      "superior": null,
      "indent": "0",
      "description": "Methyl [[2-chloro-4-fluoro-5[(tetrahydro-3-oxo-1H,3H-[1,3,4]thi- adiazolo[3,4-a]pyridazin-1- ylidene)amino]phenyl]thio]acetate (Fluthiacet-methyl technical) (CAS No. 117337-19-6) (provided for in subheading 2934.99.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.30",
      "rawHtsCode": "9902.07.30",
      "superior": null,
      "indent": "0",
      "description": "2-[7-Fluoro-3-oxo-4-(2-propyn-1-yl)-3,4-dihydro-2H- 1,4-benzoxazin-6-yl]-4,5,6,7-tetrahydro-1H- isoindole-1,3(2H)-dione (Flumioxazin) (CAS No. 103361-09-7) (provided for in subheading 2934.99.15)",
      "units": [],
      "generalRate": "6.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.31",
      "rawHtsCode": "9902.07.31",
      "superior": null,
      "indent": "0",
      "description": "(2Z)-3-Isopropyl-2-[(2-methyl-2-propanyl)imino]-5-phenyl- 1,3,5-thiadiazinan-4-one (Buprofezin) (CAS No. 69327-76-0 or 953030-84-7) (provided for in subheading 2934.99.16)",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.32",
      "rawHtsCode": "9902.07.32",
      "superior": null,
      "indent": "0",
      "description": "4-{[(6-Chloro-3-pyridinyl)methyl](2,2-difluoroethyl)amino}- 2(5H)-furanone (Flupyradifurone) (CAS No. 951659-40-8) (provided for in subheading 2934.99.16)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.33",
      "rawHtsCode": "9902.07.33",
      "superior": null,
      "indent": "0",
      "description": "4-[5-(3,5-Dichlorophenyl)-5-(trifluoromethyl)-4,5-dihydro- 1,2-oxazol-3-yl]-2-methyl-N-{2-oxo-2-[(2,2,2- trifluoroethyl)amino]ethyl}benzamide (Fluralaner) (CAS No. 864731-61-3) (provided in subheading 2934.99.16)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.34",
      "rawHtsCode": "9902.07.34",
      "superior": null,
      "indent": "0",
      "description": "10,10'-Oxybis(10H-phenoxarsinine) (CAS No. 58-36-6) (provided for in subheading 2934.99.18)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.35",
      "rawHtsCode": "9902.07.35",
      "superior": null,
      "indent": "0",
      "description": "2-(2,6-Difluorophenyl)-4-[2-ethoxy-4-(2-methyl-2-propanyl)phenyl]- 4,5-dihydro-1,3-oxazole (Etoxazole) (CAS No. 153233-91-1) (provided for in subheadling 2934.99.18)",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.36",
      "rawHtsCode": "9902.07.36",
      "superior": null,
      "indent": "0",
      "description": "3-Phenyl-5-(2-thienyl)-1,2,4-oxadiazole (Tioxazafen) (CAS No. 330459-31-9) (provided for in subheading 2934.99.18).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.37",
      "rawHtsCode": "9902.07.37",
      "superior": null,
      "indent": "0",
      "description": "4-[(1-Hydroxy-1,3-dihydro-2,1-benzoxaborol-5- yl)oxy]benzonitrile (Crisaborole) (CAS No. 906673-24-3) (provided for in subheading 2934.99.30)",
      "units": [],
      "generalRate": "6.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.38",
      "rawHtsCode": "9902.07.38",
      "superior": null,
      "indent": "0",
      "description": "1-{5′-[(5S)-5-(3,5-Dichloro-4-fluorophenyl)-4,5-dihydro-5- (trifluoromethyl)-1,2-oxazol-3-yl]-1H,3′H-spiro[azetidine-3,1′- [2]benzofuran]-1-yl}-2-mesylethanone (Sarolaner) (CAS No. 1398609-39-6) (provided for in subheading 2934.99.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.39",
      "rawHtsCode": "9902.07.39",
      "superior": null,
      "indent": "0",
      "description": "Methyl {(2S)-1-[(2S)-2-{4-[(6S)-3-{2-[(2S)-1-{(2S)-2- [(methoxycarbonyl)amino]-3-methylbutanoyl}-2-pyr- rolidinyl]-1H-imidazol-4-yl}-6-phenylindolo[1,2-c][1,3]ben- zoxazin-10-yl]-1H-imidazol-2-yl}-1-pyrrol idinyl]-3-methyl-1-oxo-2-butanyl}carbamate (Elbasvir) (CAS No. 1370468-36-2) (provided for in subheading 2934.99.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.40",
      "rawHtsCode": "9902.07.40",
      "superior": null,
      "indent": "0",
      "description": "Propan-2-yl (2R)-2-{((R)-({(2R,3R,4R,5R)-4-chloro- 5-(2,4-dioxo-3,4-dihydropyrimidin-1(2H)-yl)-3-hydroxy-4- methyloxolan-2-yl}methoxy)(phenoxy)phos- phoryl)amino}propanoate (Uprifosbuvir) (CAS No.1496551-77-9) (provided for in subheading 2934.99.30 or 2934.99.39)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.41",
      "rawHtsCode": "9902.07.41",
      "superior": null,
      "indent": "0",
      "description": "[(7R)-4-(5-Chloro-1,3-benzoxazol-2-yl)-7-methyl-1,4- diazepan-1-yl][5-methyl-2-(2H-1,2,3-triazol-2- yl)phenyl]methanone (Suvorexant) (CAS No. 1030377-33-3) (provided for in subheading 2934.99.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.42",
      "rawHtsCode": "9902.07.42",
      "superior": null,
      "indent": "0",
      "description": "(2S)-5-Oxopyrrolidine-2-carboxylic acid-(1S,2S,3S,4R,5S)-5- [4-chloro-3-(4-ethoxybenzyl)phenyl]-1-(hydroxymethyl)- 6,8-dioxabicyclo[3.2.1]octane-2,3,4-triol (1:1) (Ertugliflozin L-pyroglutamic acid) (CAS No. 1210344-83-4) (provided for in subheading 2934.99.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.43",
      "rawHtsCode": "9902.07.43",
      "superior": null,
      "indent": "0",
      "description": "Ethyl 5,5-diphenyl-4H-1,2-oxazole-3-carboxylate (Isoxadifen-ethyl) (CAS No. 163520-33-0) (provided for in subheading 2934.99.39)",
      "units": [],
      "generalRate": "4.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.44",
      "rawHtsCode": "9902.07.44",
      "superior": null,
      "indent": "0",
      "description": "Sodium 2-2'-methylene bis-(4,6-di-tert-butyl phenyl)phosphate (CAS No. 85209-91-2) (provided for in subheading 2934.99.39)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.45",
      "rawHtsCode": "9902.07.45",
      "superior": null,
      "indent": "0",
      "description": "2,2-(1,4-Phenylene)bis((4H-3,1-benzoxazine-4-one) (CAS No. 18600-59-4) (provided for in subheading 2934.99.39)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.46",
      "rawHtsCode": "9902.07.46",
      "superior": null,
      "indent": "0",
      "description": "2H-3,1-Benzoxazine-2,4(1H)-dione (CAS No. 118-48-9) (provided for in subheading 2934.99.44) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.47",
      "rawHtsCode": "9902.07.47",
      "superior": null,
      "indent": "0",
      "description": "(RS)-N-[2-(1,3-Dimethylbutyl)-3-thienyl]-1-methyl-3- (trifluoromethyl)pyrazole-4-carboxamide (Penthiopyrad) (CAS No. 183675-82-3) (provided for in subheading 2934.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.48",
      "rawHtsCode": "9902.07.48",
      "superior": null,
      "indent": "0",
      "description": "2-Amino-3-cyanothiophene (CAS No. 4651-82-5) (provided for in subheading 2934.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.49",
      "rawHtsCode": "9902.07.49",
      "superior": null,
      "indent": "0",
      "description": "1,3-Dimethyl-1-[5-(2-methyl-2-propanyl)-1,3,4-thiadiazol-2-yl]urea (Tebuthiuron) (CAS No. 34014-18-1) (provided for in subheading 2934.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.50",
      "rawHtsCode": "9902.07.50",
      "superior": null,
      "indent": "0",
      "description": "4-(4-Methylphenyl)-4-oxobutanoic acid - 4-ethylmorpholine (2:1) (CAS No. 171054-89-0) (provided for in subheading 2934.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.51",
      "rawHtsCode": "9902.07.51",
      "superior": null,
      "indent": "0",
      "description": "C1-C3 Perfluoroalkyl perfluoromorpholine (CAS No. 382-28-5) (provided for in subheading 2934.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.52",
      "rawHtsCode": "9902.07.52",
      "superior": null,
      "indent": "0",
      "description": "5-Ethoxy-3-(trichloromethyl)-1,2,4-thiadiazole (Etridiazole) (CAS No. 2593-15-9) (provided for in subheading 2934.99.90)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.53",
      "rawHtsCode": "9902.07.53",
      "superior": null,
      "indent": "0",
      "description": "3-({[5-(Difluoromethoxy)-1-methyl-3-(trifluoromethyl)-1H- pyrazol-4-yl]methyl}sulfonyl)-5,5-dimethyl-4,5- dihydro-1,2-oxazole (Pyroxasulfone) (CAS No. 447399-55-5) (provided for in subheading 2934.99.90)",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.54",
      "rawHtsCode": "9902.07.54",
      "superior": null,
      "indent": "0",
      "description": "2H-3,1-Benzoxazine-2,4(1H)-dione (Isatoic anhydride) (CAS No. 118-48-9) (provided for in subheading 2934.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.55",
      "rawHtsCode": "9902.07.55",
      "superior": null,
      "indent": "0",
      "description": "(1R,18R,20R,24S,27S)-N-{(1R,2S)-1-[(cyclopropyl- sulfonyl)carbamoyl]-2-vinylcyclopropyl}-7-methoxy-24-(2- methyl-2-propanyl)-22,25-dioxo-2,21-dioxa-4,11,23,26- tetra-azapentacyclo[24.2.1.03,12.05,10.018,20]nonacosa-3,5,7,9,11- pentaene-27-carboxamide (Grazoprevir) (CAS No. 1350514-68-9) (provided in subheading 2935.90.48)",
      "units": [],
      "generalRate": "4.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.56",
      "rawHtsCode": "9902.07.56",
      "superior": null,
      "indent": "0",
      "description": "N-{[4-(Cyclopropylcarbamoyl)phenyl]sulfonyl}-2-methoxybenzamide (Cyprosulfamide) (CAS No. 221667-31-8) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "5.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.57",
      "rawHtsCode": "9902.07.57",
      "superior": null,
      "indent": "0",
      "description": "2-(2-Chloroethoxy)-N-[(4-methoxy-6-methyl-1,3,5-triazin-2- yl)carbamoyl]benzenesulfonamide (Triasulfuron) (CAS No. 82097-50-5) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "0.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.58",
      "rawHtsCode": "9902.07.58",
      "superior": null,
      "indent": "0",
      "description": "Sodium 4,6-dimethoxy-2-[({[3-(2,2,2-trifluoro- ethoxy)pyridin-2-yl]sulfonyl}carbamoyl)imino]- 2H-pyrimidin-1-ide (Trifloxysulfuron-sodium) (CAS No. 199119-58-9) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "4.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.59",
      "rawHtsCode": "9902.07.59",
      "superior": null,
      "indent": "0",
      "description": "Toluene-4-sulfonohydrazide (CAS No. 1576-35-8) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.60",
      "rawHtsCode": "9902.07.60",
      "superior": null,
      "indent": "0",
      "description": "N-{2,4-Dichloro-5-[4-(difluoromethyl)-3-methyl-5-oxo- 4,5-dihydro-1H-1,2,4-triazol-1-yl]phenyl}meth- anesulfonamide (Sulfentrazone) (CAS No. 122836-35-5) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "5.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.61",
      "rawHtsCode": "9902.07.61",
      "superior": null,
      "indent": "0",
      "description": "Methyl 2-{[(4,6-dimethyl-2-pyrimidinyl)carbamoyl]sul- famoyl}benzoate (Sulfometuron-methyl) (CAS No. 74222-97-2) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.62",
      "rawHtsCode": "9902.07.62",
      "superior": null,
      "indent": "0",
      "description": "Methyl 2-[[[[[(4,6-dimethoxypyrimidin-2-yl)amino]car- bonyl]amino]sulfony]methyl]benzoate (Bensulfuron-methyl) (CAS No. 83055-99-6) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.63",
      "rawHtsCode": "9902.07.63",
      "superior": null,
      "indent": "0",
      "description": "4-Chloro-7-(4-methylphenylsulfonyl)-7H-pyrrolo[2,3-d] pyrimidine (CAS No. 479633-63-1) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.64",
      "rawHtsCode": "9902.07.64",
      "superior": null,
      "indent": "0",
      "description": "Sodium [(4-aminophenyl)sulfonyl](methoxycarbonyl)azanide (Asulam sodium salt) (CAS No. 2302-17-2) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.65",
      "rawHtsCode": "9902.07.65",
      "superior": null,
      "indent": "0",
      "description": "Sodium [(3-methoxy-4-methyl-5-oxo-4,5-dihydro-1H-1,2,4- triazol-1-yl)carbonyl]{[2-(trifluorometh- oxy)phenyl]sulfonyl}azanide (Flucarbazone-sodium) (CAS No. 181274-17-9) (provided for in subheading 2935.90.75)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.66",
      "rawHtsCode": "9902.07.66",
      "superior": null,
      "indent": "0",
      "description": "N-(5,7-dimethoxy[1,2,4]triazolo[1,5-a]pyrimidin-2-yl)-2- methoxy-4-(trifluoromethyl)-3-pyridine- sulfonamide (Pyroxsulam) (CAS No. 422556-08-9) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.67",
      "rawHtsCode": "9902.07.67",
      "superior": null,
      "indent": "0",
      "description": "Methyl 2-sulfamoylbenzoate (CAS No. 57683-71-3) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.68",
      "rawHtsCode": "9902.07.68",
      "superior": null,
      "indent": "0",
      "description": "Methyl 3-sulfamoyl-2-thiophenecarboxylate (CAS No. 59337-93-8) (provided for in subheading 2935.90.75) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.69",
      "rawHtsCode": "9902.07.69",
      "superior": null,
      "indent": "0",
      "description": "3-(Ethylsulfonyl)-2-pyridinesulfonamide (CAS No. 117671-01-9) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.70",
      "rawHtsCode": "9902.07.70",
      "superior": null,
      "indent": "0",
      "description": "Phenyl ((3-((dimethylamino)carbonyl)-2-pyridinyl)sulfonyl) carbamate (CAS No. 112006-94-7) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.71",
      "rawHtsCode": "9902.07.71",
      "superior": null,
      "indent": "0",
      "description": "2-Chloro-N-[(4,6-dimethoxy-2-pyrimidinyl)carba- moyl]imidazo[1,2-a]pyridine-3-sulfonamide (Imazosulfuron) (CAS No. 122548-33-8) (provided for in subheading 2935.90.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.72",
      "rawHtsCode": "9902.07.72",
      "superior": null,
      "indent": "0",
      "description": "N-{3-[(2R)-2-amino-1-(methylsulfamoyl)propan- 2-yl]-4-fluorophenyl}-5-fluoropyridine-2-carboxamide (CAS No.1877329-50-4) (provided for in subheading 2935.90.75)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.73",
      "rawHtsCode": "9902.07.73",
      "superior": null,
      "indent": "0",
      "description": "3,5-Dinitro-N'4,N'4-dipropylsulfanilamide (Oryzalin) (CAS No. 19044-88-3) (provided for in subheading 2935.90.95)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.74",
      "rawHtsCode": "9902.07.74",
      "superior": null,
      "indent": "0",
      "description": "13-[(2-O-β-D-Glucopyranosyl-α-D-glucopyranosyl)oxy]kaur- 16-en-18-oic acid β-D-glucopyranosyl ester (Stevioside) (CAS No. 57817-89-7) (provided for in subheading 2938.90.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.75",
      "rawHtsCode": "9902.07.75",
      "superior": null,
      "indent": "0",
      "description": "Purified steviol glycoside, rebaudioside A (19-O-ß-glucopyranosyl-13-O-(ß-glucopyranosyl(1-2)- ß-glucopyranosyl(1-3))-ß-glucopyranosyl-13-hydroxykaur-16- en-19-oic acid) (CAS No. 58543-16-1) (provided for in subheading 2938.90.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.76",
      "rawHtsCode": "9902.07.76",
      "superior": null,
      "indent": "0",
      "description": "(4-α)-13-[(O-β-D-Glucopyranosyl-(1-2)-O-[β-D- glucopyranosyl-(1-3)]-β-D-glucopyranosyl)oxy]-kaur-16- en-18-oic acid O-β-D-glucopyranosyl-(1-2)-O-[β-D-glucopyranosyl- (1-3)]-β-D-glucopyranosyl ester (Rebaudioside M) (CAS No. 1220616-44-3)(provided for in subheading 2938.90.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.77",
      "rawHtsCode": "9902.07.77",
      "superior": null,
      "indent": "0",
      "description": "(3S,4S,5S,6R)-6-(Hydroxymethyl)oxane-2,3,4,5-tetrol (D-Mannose) (CAS No. 3458-28-4) (provided for in subheading 2940.00.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.78",
      "rawHtsCode": "9902.07.78",
      "superior": null,
      "indent": "0",
      "description": "Trehalose (α-D-Glucopyranosyl α-D-glucopyranoside dihydrate) (CAS No. 6138-23-4)(provided in subheading 2940.00.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.79",
      "rawHtsCode": "9902.07.79",
      "superior": null,
      "indent": "0",
      "description": "Iron sodium ethylenediaminedihydroxyphenylacetic acid (sodium [[α,α'-(ethylenediimino)bis[2- hydroxybenzene-1-acetato]](4-)]ferrate(1-)) (CAS No. 16455-61-1) (provided for in subheading 2942.00.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.80",
      "rawHtsCode": "9902.07.80",
      "superior": null,
      "indent": "0",
      "description": "Chlorophyllin-copper complex (CAS No. 11006-34-1) (provided for in subheading 2942.00.50).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.81",
      "rawHtsCode": "9902.07.81",
      "superior": null,
      "indent": "0",
      "description": "Black carrot color concentrate (provided for in subheading 3203.00.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.82",
      "rawHtsCode": "9902.07.82",
      "superior": null,
      "indent": "0",
      "description": "Purple sweet potato color concentrate (provided for in subheading 3203.00.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.83",
      "rawHtsCode": "9902.07.83",
      "superior": null,
      "indent": "0",
      "description": "Red cabbage color concentrate (provided for in subheading 3203.00.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.84",
      "rawHtsCode": "9902.07.84",
      "superior": null,
      "indent": "0",
      "description": "Red radish color concentrate (provided for in subheading 3203.00.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.85",
      "rawHtsCode": "9902.07.85",
      "superior": null,
      "indent": "0",
      "description": "Disperse Blue 56 (1,5-Diamino-2-bromo-4,8-dihydroxy-9,10-anthraquinone) (CAS No. 68134-65-6) (provided for in 3204.11.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.86",
      "rawHtsCode": "9902.07.86",
      "superior": null,
      "indent": "0",
      "description": "Disperse Blue 284 (({4-[(E)-(3,5-Dinitro-2-thienyl)diazenyl]phe- nyl}imino)di-2,1-ethanediyl diacetate) (CAS No. 42783-06-2) (provided for in 3204.11.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.87",
      "rawHtsCode": "9902.07.87",
      "superior": null,
      "indent": "0",
      "description": "1,5-Diamino-4,8-dihydroxy-2-(4-hydroxyphenyl)-9,10- anthraquinone (Disperse blue 73) (CAS No. 12222-78-5) (provided for in subheading 3204.11.10)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.88",
      "rawHtsCode": "9902.07.88",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 4,11-diamino-2-(3-methoxypropyl)-1H-Naph- tho[2,3-f]isoindole-1,3,5,10(2H)-tetrone (Disperse Blue 60 M) (CAS No. 12217-80-0) and 4,11-Diamino-2-[3-(2-methoxyeth- oxy)propyl]-1H-naphtho[2,3-f]isoindole-1,3,5,10(2H)-tetrone (Disperse Blue 60 ME) (CAS No. 65059-45-2) (provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.89",
      "rawHtsCode": "9902.07.89",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 1-anilino-4,5-dihydroxy-8-nitro-9,10-anthraquinone (Disperse blue 77) (CAS No. 20241-76-3); 1,5-diamino-2-bromo-4,8-dihydroxy-9,10-anthraquinone (Disperse blue 56) (CAS No. 68134-65-6); 4,11-diamino-2-(3-methoxypropyl)-1H-naphtho[2,3- f]isoindole-1,3,5,10(2H)-tetrone (Disperse blue 60 M) (CAS No. 12217-80-0); and 4,11-diamino-2-[3-(2-methoxyethoxy)propyl]-1H- naphtho[2,3-f]isoindole-1,3,5,10(2H)-tetrone (Disperse blue 60 ME) (CAS No. 65059-45-2) (provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.90",
      "rawHtsCode": "9902.07.90",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 2-(4-Bromo-3-hydroxy-2-quinolinyl)-1H-indene-1,3(2H)-dione (Disperse yellow 64) (CAS No. 10319-14-9); 5-[(E)-(4-Chloro-2-nitrophenyl)diazenyl]-1-ethyl-6-hydroxy-4-methyl-2- oxo-1,2-dihydro-3-pyridinecarbonitrile (Disperse yellow 211) (CAS No. 70528-90-4); 4-Anilino-3-nitro-N-phenylbenzenesulfonamide (Disperse yellow 42) (CAS No. 5124-25-4); and 2-(3-Hydroxy-2-quinolinyl)-1H-indene-1,3(2H)-dione (Disperse yellow 54) (CAS No. 7576-65-0) (provided for in 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.91",
      "rawHtsCode": "9902.07.91",
      "superior": null,
      "indent": "0",
      "description": "Disperse Yellow 218 (CAS No. 75199-13-2) (provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.92",
      "rawHtsCode": "9902.07.92",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Disperse Yellow 163 (3,3'-({4-[(2,6-Dichloro-4- nitrophenyl)diazenyl]phenyl}imino)dipropanenitrile) (CAS No. 67923-43-7); Solvent Yellow 163 (1,8-Bis(phenylthio)anthracene-9,10-dione) (CAS No. 13676-91-0); Disperse Blue 56 (1,5-Diamino-2-bromo-4,8-dihydroxy-9,10-anthraquinone) (CAS No. 68134-65-6); Disperse Blue 77 (1-Anilino-4,5-dihydroxy-8-nitro-9,10-anthraquinone) (CAS No. 20241-76-3); Disperse Red 1042A (5-[2-(2-Cyano-4-nitrophenyl)diazenyl]-2-[[2-(2- hydroxyethoxy)ethyl]amino]-4-methyl-6-(phenyl- amino)-3-pyridinecarbonitrile) (CAS No. 149988-44-3); Disperse Red 1042B (5-[(2-cyano-4-nitrophenyl)diazenyl]-6-[[2-(2- hydroxyethoxy)ethyl]amino]-4-methyl-2- (phenylamino)-3-pyridine carbonitrile) (CAS No. 137428-29-6); Disperse Blue 60 M (4,11-Diamino-2-(3-methoxypropyl)- 1H-naphtho[2,3-f]isoindole-1,3,5,10(2H)-tetrone (CAS No. 12217-80-0); and Disperse Blue 60 ME (4,11-Diamino-2-[3-(2-methoxyeth- oxy)propyl]-1H-naphtho[2,3-f]isoindole-1,3,5,10(2H)-tetrone) (CAS No. 65059-45-2) (provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.93",
      "rawHtsCode": "9902.07.93",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Disperse Orange 288 (3-(Benzyl{4-[(4-nitrophenyl)diazenyl]phenyl}amino)propanenitrile) (CAS No. 96662-24-7); Disperse Blue 291:1 N-{2-[(E)-(2-Bromo-4,6-dinitrophenyl)diazenyl]-5-(diallylamino)-4- methoxyphenyl}acetamide) (CAS No. 51868-46-3); and Disperse Violet 93:1 (N-{2-[(E)-(2-Bromo-4,6-dinitro- phenyl)diazenyl]-5-(diethylamino)phenyl}acetamide) (CAS No. 52697-38-8) (provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.94",
      "rawHtsCode": "9902.07.94",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Solvent Yellow 163 (8-Bis(phenylsulfanyl)-9,10- anthraquinone) (CAS No. 13676-91-0); Disperse Blue 56 (1,5-Diamino-2-bromo-4,8-dihy- droxy-9,10-anthraquinone) (CAS No. 68134-65-6); Disperse Red 167:1 ({3-(acetylamino)-4-[(2-chloro-4-nitrophenyl)azo]phe- nyl}imino)diethane-2,1-diyl diacetate) (CAS No. 1533-78-4); Disperse Orange 29 (4-({2-Methoxy-4-[(4-nitrophenyl)di- azenyl]phenyl}dia-zenyl)phenol) (CAS No. 19800-42-1); Disperse Red 1042A (5-[2-(2-Cyano-4-nitrophenyl)diazenyl]-2- [[2- (2-hydroxyethoxy)ethyl]amino]-4-methyl-6-(phenylamino)-3- pyridinecarbonitrile) (CAS No. 149988-44-3); Disperse Red 1042B (5-[(2-cyano-4-nitrophenyl)diazenyl]-6-[[2-(2-hydroxy- ethoxy)ethyl]amino]-4-methyl-2-(phenylamino)-3-pyridine carbonitrile) (CAS No. 137428-29-6); Disperse Blue 60 M (4,11-diamino-2-(3-methoxypropyl)-1H-naph- tho[2,3-f]iso- indole-1,3,5,10(2H)-tetrone) (CAS No. 12217-80-0); and Disperse Blue 60 ME (4,11-Diamino-2-[3-(2-methoxyethoxy)pro- pyl]-1H- naphtho[2,3-f]isoindole-1,3,5,10(2H)-tetrone) (CAS No. 65059-45-2) (provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.95",
      "rawHtsCode": "9902.07.95",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Disperse Blue ANT (Br) (N-[5-(acetylamino)-4-[2-(2-bromo-4,6- dinitrophenyl)diazenyl]-2-methoxy- phenyl]-N-(2-methoxy-2-oxoethyl)-glycine, methyl ester) (CAS No. 88938-51-6); Disperse Green GNA (N-[5-(acetylamino)-2-methoxy- 4-[2-(5-nitro- 2,1-benzisothiazol-3-yl)diazenyl]phenyl]-N- (2-methoxy-2-oxoethyl)-glycine, methyl ester) (CAS No. 1235882-84-4); Disperse Yellow FC60954 (4-[2-(5-cyano-1,6-dihydro-2-hydroxy-1,4-dimethyl-6-oxo-3- pyridinyl)diazenyl]-benzoic acid, 2-phenoxyethyl ester) (CAS No. 88938-37-8); Disperse Red DYNS 2246 (N-[4-[2-(2-cyano-4-nitrophenyl)diazenyl]phe- nyl]-N-(phenylmethyl)-B-alanine, 2-oxopropyl ester) (CAS No. 1021394-33-1); and Disperse Yellow DYLA 1306 (1,2-dihydro-6-hydroxy-1,4- dimethyl-5-[2-[2-nitro-4-(phenyl- methoxy)phenyl]diazenyl]-2-oxo-3- pyridinecarbonitrile) (CAS No. 1613451-37-8) (provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.96",
      "rawHtsCode": "9902.07.96",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Disperse Blue 77 (1-Anilino-4,5-dihydroxy-8-nitro-9,10-anthraquinone) (CAS No. 20241-76-3) and Disperse Blue 60 M (4,11-Diamino-2-(3-methoxypropyl)-1H- naphtho[2,3-f]iso- indole-1,3,5,10(2H)-tetrone) (CAS No. 12217-80-0) (provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.97",
      "rawHtsCode": "9902.07.97",
      "superior": null,
      "indent": "0",
      "description": "Disperse Yellow 232 (3-(5-Chloro-2-benzoxazolyl)-7-(diethyl- amino)-2H-1-benzopyran-2-one) (CAS No. 35773-43-4) (provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.98",
      "rawHtsCode": "9902.07.98",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Disperse Blue ANT (Br) (N-[5-(acetylamino)-4-[2- (2-bromo-4,6-dinitrophenyl)diazenyl]-2-methoxyphenyl]-N- (2-methoxy-2-oxoethyl)-glycine, methyl ester) (CAS No. 88938-51-6); Disperse Green GNA (N-[5-(acetylamino)-2-methoxy-4-[2-(5-nitro-2,1- benzisothiazol-3-yl)diazenyl]phenyl]-N-(2-methoxy-2-oxoethyl)-glycine, methyl ester) (CAS No. 1235882-84-4); Disperse Yellow FC60954 (4-[2-(5-cyano-1,6-dihydro-2-hydroxy- 1,4-dimethyl-6-oxo-3-pyridinyl)diazenyl]-benzoic acid, 2-phenoxyethyl ester) (CAS No. 88938-37-8); and Disperse Red DYNS 2246 (N-[4-[2-(2-cyano-4-nitrophenyl)dia- zenyl]phenyl]-N-(phenylmethyl)-B-alanine, 2-oxopropyl ester ) (CAS No. 1021394-33-1) (provided for in 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.07.99",
      "rawHtsCode": "9902.07.99",
      "superior": null,
      "indent": "0",
      "description": "Disperse Orange FC84508 (Cyano[3-[(6-methoxy-2-benzothia- zolyl)amino]-1H-isoindol-1-ylidene]acetic acid, pentyl ester) (CAS No. 173285-74-0), (provided for in 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.01",
      "rawHtsCode": "9902.08.01",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Disperse Blue 60 M (4,11-Diamino-2-(3-methoxy- propyl)-1H-naphtho[2,3-f]isoindole-1,3,5,10(2H)-tetrone) (CAS No. 12217-80-0); Disperse Blue 60 ME (4,11-Diamino-2-[3-(2-methoxy- ethoxy)propyl]-1H-naphtho[2,3-f]isoindole-1,3,5,10(2H)-tetrone) (CAS No. 65059-45-2); and Disperse Blue 1771 (8E)-8-{[2-(Dibutylamino)-4-phenyl-1,3- thiazol-5-yl]imino}-2-(3-heptanyl)-7-methyl-5-oxo-5,8-dihydro[1,2,4]tri- azolo[1,5-a]pyridine-6-carbonitrile (CAS No. 169324-83-8) (provided for in 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.02",
      "rawHtsCode": "9902.08.02",
      "superior": null,
      "indent": "0",
      "description": "Disperse Yellow 71 (9(or 10)-Methoxy-7H-benzimidazo[2,1- a]benz[de]isoquinolin-7-one) (CAS No. 68296-59-3) (provided for in 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.03",
      "rawHtsCode": "9902.08.03",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Disperse Blue 77 (1-Anilino-4,5-dihydroxy-8-nitro-9,10-anthraquinone) (CAS No. 20241-76-3); Disperse Red 1042A (5-[2-(2-Cyano-4-nitrophenyl)diazenyl]-2- [[2-(2-hydroxyethoxy)ethyl]amino]-4-methyl-6- (phenylamino)-3-pyridinecarbonitrile) (CAS No. 149988-44-3); Disperse Red 1042B (5-[(2-cyano-4-nitrophenyl)diazenyl]-6- [[2-(2-hydroxyethoxy)ethyl]amino]-4-methyl-2- (phenylamino)-3-pyridine carbonitrile) (CAS No. 137428-29-6); and Disperse Orange FC84508 (Cyano[3-[(6-methoxy-2-benzothiazolyl)amino]-1H- isoindol-1-ylidene]acetic acid, pentyl ester) (CAS No. 173285-74-0) (provided for in 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.04",
      "rawHtsCode": "9902.08.04",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Disperse Yellow 163 (3,3'-({4-[(2,6-dichloro-4-nitrophenyl)diazenyl] phenyl} imino) dipropanenitrile) (CAS No. 67923-43-7); Disperse Red 167:1 ({3-(acetylamino)-4-[(2-chloro-4-nitrophenyl)azo]phenyl}imino) diethane-2,1-diyl diacetate) (CAS No. 1533-78-4); Disperse red 60 (1-amino-4-hydroxy-2-phenoxy-9,10-anthracenedione) (CAS No. 17418-58-5); Disperse Blue 77 (1-anilino-4,5-dihydroxy-8-nitro-9,10-anthraquinone) (CAS No. 20241-76-3); Disperse Blue 56 (1,5-diamino-2-bromo-4,8-dihydroxy-9,10-anthraquinone) (CAS No. 68134-65-6); Disperse Blue 214 E (4,8-diamino-2-(4-ethoxyphenyl)-1,5-dihydroxy-9,10-anthraquinone) (CAS No. 15114-15-5); and Disperse Blue 214 EE (4,8-diamino-2-[4-(2-ethoxyethoxy) phenyl]-1,5-dihydroxy-9,10-anthraquinone) (CAS No. 23119-35-9) (provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.05",
      "rawHtsCode": "9902.08.05",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Disperse Red 356 (3-phenyl-7-(4-propoxyphe- nyl)furo[2,3-f][1]benzofuran-2,6-dione) (CAS No. 79694-17-0); Disperse Red 367 ([4-(2,6-dihydro-2,6-dioxo-7-phenylbenzo[1,2- b:4,5-b’]difuran-3-yl)phenoxy]-acetic acid, 2-ethoxyethyl ester) (CAS No. 126877–05–2); and Disperse Red H1111030 ([4-[2,6-dihydro-2,6-dioxo-7-(4-propoxyphe- nyl)benzo[1,2-b:4,5-b’]difuran-3-yl]phenoxy]-acetic acid, 2-\nethoxyethyl ester) (CAS No. 126877-06-3) (provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.06",
      "rawHtsCode": "9902.08.06",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Disperse Red 1042A (5-[2-(2-cyano-4-nitro- phenyl)diazenyl]-2-[[2-(2-hydroxyethoxy)ethyl]amino]-4-methyl-6- (phenylamino)-3-pyridine carbonitrile) (CAS No. 149988-44-3) and Disperse Red 1042B (5-[(2-cyano-4-nitrophenyl)dia- zenyl]-6-[[2-(2-hydroxyethoxy)ethyl]amino]-4- methyl-2-(phenylamino)-3-pyridine carbonitrile) (CAS No. 137428-29-6)(provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.07",
      "rawHtsCode": "9902.08.07",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Disperse Blue 77 (1-Anilino-4,5-dihydroxy-8-nitro-9,10-anthraquinone) (CAS No. 20241-76-3); Disperse Blue 60 M (4,11-Diamino-2-(3-methoxypropyl)-1H- naphtho[2,3-f]isoindole-1,3,5,10(2H)-tetrone) (CAS No. 12217-80-0); and Disperse Yellow 71 (9 (or 10)-Methoxy-7H-benzimidazo[2,1-a]benz[de]iso- quinolin-7-one) (CAS No. 68296-59-3) (provided for in subheading 3204.11.35)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.08",
      "rawHtsCode": "9902.08.08",
      "superior": null,
      "indent": "0",
      "description": "Disperse Blue 60 (4,11-diamino-2-(3-methoxypropyl)-1H- naphtho[2,3-f]isoindole-1,3,5,10(2H)-tetrone) (CAS No. 12217-80-0) (provided for in subheading 3204.11.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.09",
      "rawHtsCode": "9902.08.09",
      "superior": null,
      "indent": "0",
      "description": "Disperse Blue 77 (1-anilino-4,5-dihydroxy-8-nitro-9,10-anthraquinone) (CAS No. 20241-76-3) (provided for in subheading 3204.11.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.10",
      "rawHtsCode": "9902.08.10",
      "superior": null,
      "indent": "0",
      "description": "Disperse blue 79:1 ({5-Acetamido-4-[(2-bromo- 4,6-dinitrophenyl)diazenyl]-2-methoxyphenyl}imino)di- 2,1-ethanediyl diacetate (CAS No. 3618-72-2) (provided for in subheading 3204.11.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.11",
      "rawHtsCode": "9902.08.11",
      "superior": null,
      "indent": "0",
      "description": "Disperse Red 60 (1-amino-4-hydroxy-2-phenoxy- 9,10-anthracenedione) (CAS No. 17418-58-5) (provided for in subheading 3204.11.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.12",
      "rawHtsCode": "9902.08.12",
      "superior": null,
      "indent": "0",
      "description": "Disperse Yellow 64 (2-(4-bromo-3-hydroxy-2-quinolinyl)-1H-indene-1,3(2H)-dione) (CAS No. 10319-14-9) (provided for in 3204.11.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.13",
      "rawHtsCode": "9902.08.13",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Disperse Blue 73 A (1,5-diamino-4,8-dihydroxy(4-methoxyphenyl)-9,10-anthracenedione) (CAS No. 31288-44-5) and Disperse Blue 73 P (1,5-diamino-4,8-dihydroxy(4-hydroxyphenyl)-9,10-anthracenedione) (CAS No. 31529–83–6) (provided for in subheading 3204.11.50)\n ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.14",
      "rawHtsCode": "9902.08.14",
      "superior": null,
      "indent": "0",
      "description": "Acid Red 92 (disodium 2,3,4,5-tetrachloro-6-(2,4,5,7-tetrabro- mo-6-oxido-3-oxo-3H-xanthen-9-yl)benzoate) (Phloxine B) (CAS No. 18472-87-2) (provided for in subheading 3204.12.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.15",
      "rawHtsCode": "9902.08.15",
      "superior": null,
      "indent": "0",
      "description": "Acid Blue 182 (Disodium 1-amino-9,10-dioxo-4-({4-[(2-oxopropyl)amino]-2- sulfonatophenyl}amino)-9,10-dihydro-2-anthracenesulfonate)) (CAS No. 72152-54-6) (provided for in subheading 3204.12.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.16",
      "rawHtsCode": "9902.08.16",
      "superior": null,
      "indent": "0",
      "description": "Acid Black 194 (CAS No. 61931-02-0) (provided for in subheading 3204.12.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.17",
      "rawHtsCode": "9902.08.17",
      "superior": null,
      "indent": "0",
      "description": "Acid Red 52 (sodium 4-[3,6-bis(diethylamino)-9-xantheniumyl]-1,3-benzenedisulfonate) (CAS No. 3520-42-1) (provided for in subheading 3204.12.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.18",
      "rawHtsCode": "9902.08.18",
      "superior": null,
      "indent": "0",
      "description": "(4E)-4-[(2,5-Dichlorophenyl)hydrazono]-3-oxo-3,4-dihydro-2-naph- thalenecarboxylic acid (Acid dye for Pigment Red 144) (CAS No. 51867-77-7) (provided for in subheading 3204.12.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.19",
      "rawHtsCode": "9902.08.19",
      "superior": null,
      "indent": "0",
      "description": "Tetrasodium [7-amino-3-[(3-chloro-2-hydroxy-5-nitrophenyl)azo]-4-hydroxy -2-naphthalenesulfonato(3-)][6-amino-4- hydroxy-3-[(2-hydroxy-5-nitro-3-sulfophenyl)azo]-2-naphthalene- sulfonato(4-)]-chromate(4-) (Sanodal Deep Black HBL) (CAS No. 184719-87-7) (provided for in subheading 3204.12.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.20",
      "rawHtsCode": "9902.08.20",
      "superior": null,
      "indent": "0",
      "description": "Acid Red 182 (sodium [4-(hydroxy-κO)-3-{[2- (hydroxy-κO)-1-naphthyl]diazenyl}benzenesulfon- amidato(2-)][4-hydroxy-3-{[2-(hydroxy-κO)-1-naphthyl]diazenyl}ben- zenesulfonamidato(2-)]cobaltate(1-)) (CAS No. 58302-43-5) (provided for in subheading 3204.12.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.21",
      "rawHtsCode": "9902.08.21",
      "superior": null,
      "indent": "0",
      "description": "Sodium 4-({3-[(E)-(2-methyl-4-{[(4-methylphenyl)sul- fonyl]oxy}phenyl)diazenyl]phenyl}amino)-3- nitrobenzenesulfonate (Acid orange 67) (CAS No. 12220-06-3) (provided for in subheading 3204.12.45)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.22",
      "rawHtsCode": "9902.08.22",
      "superior": null,
      "indent": "0",
      "description": "Sodium 4-[(3-acetamidophenyl)amino]-1-amino-9,10- dioxo-9,10-dihydro-2-anthracenesulfonate (Acid blue 324) (CAS No. 70571-81-2) (provided for in subheading 3204.12.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.23",
      "rawHtsCode": "9902.08.23",
      "superior": null,
      "indent": "0",
      "description": "Acid Blue 171 (Sodium [6-(amino-κN)-5-[2-[2-(hydroxy-κO)-4- nitrophenyl]diazenyl-κN1]-N-methyl-2-naphthalenesul- fonamidato(2-)][6-(amino-κN)-5-[2-[2-(hydroxy-κO)-4-nitro- phenyl]diazenyl-κN1]-2-naphthalenesulfonato(3-)]-Cobaltate(2-) (1:2) (1:2)) (CAS No. 75314-27-1) (provided for in subheading 3204.12.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.24",
      "rawHtsCode": "9902.08.24",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Acid Black 220 A (Chromate(2-), [3-hydroxy-4-[(2- hydroxy-1-naphthalenyl)azo]-7-nitro-1-naphthalenesulfonato(3-)] [1-(2- hydroxy-5-nitrophenyl)azo]-2-naphthalenolato(2-)]-, lithium sodium) (CAS No. 85828-76-8), and Acid Black 220 B (Chromate(2-), [3-hydroxy-4-[(2-hydroxy-1- naphthalenyl)azo]-7-nitro-1-naphthalenesulfonato(3-)] [N-[7-hydroxy-8-[(2- hydroxy-5-nitrophenyl)azo]-1-naphthalenyl]acetamidato(2-)]-, lithium sodium) (CAS No. 85828-75-7) (provided for in 3204.12.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.25",
      "rawHtsCode": "9902.08.25",
      "superior": null,
      "indent": "0",
      "description": "Acid Red 87 (eosine disodium salt) (disodium 2-(2,4,5,7-tetrabromo-6-oxido-3-oxoxanthen-9-yl)benzoate) (CAS No. 17372-87-1) (provided for in subheading 3204.12.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.26",
      "rawHtsCode": "9902.08.26",
      "superior": null,
      "indent": "0",
      "description": "Acid Brilliant Blue FCF FOOD Blue No. 1 (Acid Blue 9) (disodium 2-({4-[ethyl(3-sulfonatobenzyl)amino]phenyl} {4- [ethyl(3-sulfonatobenzyl)iminio]cyclohexa-2,5-dien-1-ylidene}methyl) ben- zenesulfonate) (CAS No. 3844-45-9) (provided for in subheading 3204.12.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.27",
      "rawHtsCode": "9902.08.27",
      "superior": null,
      "indent": "0",
      "description": "Acid Blue 80 (disodium 3,3'-[(9,10-dioxo-9,10-dihydroanthra- cene-1,4-diyl)diimino]bis(2,4,6-trimethyl- benzenesulfonate) (CAS No. 4474-24-2) (provided for in subheading 3204.12.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.28",
      "rawHtsCode": "9902.08.28",
      "superior": null,
      "indent": "0",
      "description": "Trisodium 5-oxo-1-(4-sulfonatophenyl)-4-[(E)-(4- sulfonatophenyl)diazenyl]-2,5-dihydro-1H-pyrazole-3- carboxylate (Acid Yellow 23) (CAS No. 1934-21-0) (provided for in subheading 3204.12.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.29",
      "rawHtsCode": "9902.08.29",
      "superior": null,
      "indent": "0",
      "description": "Basic Yellow 40 (2-[7-(diethylamino)-2-oxo-2H-chromen- 3-yl]-1,3-dimethyl-1H-3,1-benzimidazol-3-ium chloride) (CAS No. 29556-33-0) (provided for in subheading 3204.13.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.30",
      "rawHtsCode": "9902.08.30",
      "superior": null,
      "indent": "0",
      "description": "[4-[[4-(Dimethylamino)phenyl][4-(methylamino)phe- nyl]methylene]cyclohexa-2,5-dien-1-ylidene]di- methylammonium acetate (CAS No. 84434-47-9) (provided for in subheading 3204.13.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.31",
      "rawHtsCode": "9902.08.31",
      "superior": null,
      "indent": "0",
      "description": "Basic Red 1:1 (3,6-bis (ethylamino)-9-[2-(methoxycarbonyl) phenyl]-2,7-dimethylxanthenium chloride) (CAS No. 3068-39-1) (provided for in subheading 3204.13.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.32",
      "rawHtsCode": "9902.08.32",
      "superior": null,
      "indent": "0",
      "description": "Basic Green 1 ((4-(4-(diethylamino)benzhydrylene) cyclohexa-2,5-dien-1-ylidene) diethylammonium hydrogen sulphate) (CAS No. 633-03-4) (provided for in subheading 3204.13.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.33",
      "rawHtsCode": "9902.08.33",
      "superior": null,
      "indent": "0",
      "description": "9-(2-Carboxyphenyl)-6-(diethylamino)-N,N-diethyl-3H-xanthen-3-iminium acetate (Rhodamine Blue Shade dye liquid) (CAS No. 64381-99-3) (provided for in subheading 3204.13.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.34",
      "rawHtsCode": "9902.08.34",
      "superior": null,
      "indent": "0",
      "description": "Basic Violet 11:1 (Bis{6-(diethylamino)-N,N-diethyl-9-[2-(methoxycarbonyl) phenyl]-3H-xanthen-3-iminium} tetrachlorozincate(2-)) (CAS No. 73398-89-7).(CIN 45174) (provided for in subheading 3204.13.80) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.35",
      "rawHtsCode": "9902.08.35",
      "superior": null,
      "indent": "0",
      "description": "Direct Blue 71 (tetrasodium 3-[(E)-{4-[(E)-{4-[(E)-(6-amino-1-hydroxy-3-sulfonato-2-naphthyl) diazenyl]-6-sulfonato-1-naphthyl} diazenyl]-1-naphthyl}diazenyl]-1,5-naphthalenedisulfonate) (CAS No. 4399-55-7) (provided for in subheading 3204.14.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.36",
      "rawHtsCode": "9902.08.36",
      "superior": null,
      "indent": "0",
      "description": "Direct Blue 279 (4-N-(5,8-dimethoxy-2,4-dimethylquinolin-6-yl)-1-N,1-N-diethylpentane- 1,4-diamine) (CAS No. 72827-89-5) (provided for in subheading 3204.14.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.37",
      "rawHtsCode": "9902.08.37",
      "superior": null,
      "indent": "0",
      "description": "Disodium 7-anilino-3-[(E)-{4-[(E)-(2,4-dimethyl-6-sulfonatophenyl) diazenyl]-2-methoxy-5-methylphenyl} diazenyl]-4-hydroxy-2-naphthalenesulfonate (direct violet 51) (CAS No. 5489-77-0) (provided for in subheading 3204.14.50) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.38",
      "rawHtsCode": "9902.08.38",
      "superior": null,
      "indent": "0",
      "description": "Disodium 7-anilino-4-hydroxy-3-({2-methoxy-5-methyl-4-[(4-sulfonatophenyl) diazenyl] phenyl} diazenyl)-2-naphthalenesulfonate (Direct violet 9) (CAS No. 6227-14-1) (provided for in subheading 3204.14.50) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.39",
      "rawHtsCode": "9902.08.39",
      "superior": null,
      "indent": "0",
      "description": "Vat blue 1 (synthetic indigo) (2-(1,3-dihydro-3-oxo-2H-indazol-2-ylidene)-1,2-dihydro-3H-indol-3-one) (CAS No. 482-89-3) (provided for in subheading 3204.15.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.40",
      "rawHtsCode": "9902.08.40",
      "superior": null,
      "indent": "0",
      "description": "Pigment Orange 43/Vat Orange 7 (bisbenzimidazo[2,1-b:2',1'-i]benzo[lmn][3,8]phenanthroline-8,17-dione) (CAS No. 4424-06-0) (provided for in subheading 3204.15.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.41",
      "rawHtsCode": "9902.08.41",
      "superior": null,
      "indent": "0",
      "description": "Vat Red 15 (bisbenzimidazo[2,1-b:1',2'-j]benzo[lmn][3,8]phenanthroline-6,9-dione) (CAS No. 4216-02-8) (provided for in subheading 3204.15.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.42",
      "rawHtsCode": "9902.08.42",
      "superior": null,
      "indent": "0",
      "description": "Vat blue 66 (9,10-Anthracenedione,1,1ʹ-[(6-phenyl- 1,3,5-triazine-2,4-diyl)diimino]bis(3ʺ-acetyl-4-amino-)) (CAS No. 32220-82-9) (provided for in subheading 3204.15.30).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.43",
      "rawHtsCode": "9902.08.43",
      "superior": null,
      "indent": "0",
      "description": "Vat Blue 19 (Anthra[9,1,2-cde]benzo[rst]pentaphene-5,10-dione, bromo derivatives) (CAS No. 1328-18-3) (provided for in subheading 3204.15.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.44",
      "rawHtsCode": "9902.08.44",
      "superior": null,
      "indent": "0",
      "description": "Reduced Vat Blue 43 (CAS No. 85737-02-6) (provided for in subheading 3204.15.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.45",
      "rawHtsCode": "9902.08.45",
      "superior": null,
      "indent": "0",
      "description": "Reduced Vat Blue 1 ([2,2'-Bi-1H-indole]-3,3'-diol, potassium sodium salt) (CAS No. 207692-02-2) (provided for in subheading 3204.15.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.46",
      "rawHtsCode": "9902.08.46",
      "superior": null,
      "indent": "0",
      "description": "Isoviolanthrone (C.I. Vat Violet 10) (CAS No. 128-64-3) (provided for in subheading 3204.15.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.47",
      "rawHtsCode": "9902.08.47",
      "superior": null,
      "indent": "0",
      "description": "Vat Blue 4 (6,15-dihydro-5,9,14,18-anthrazinetetrone) (CAS No. 81-77-6) (provided for in subheading 3204.15.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.48",
      "rawHtsCode": "9902.08.48",
      "superior": null,
      "indent": "0",
      "description": "Reactive Blue 19 (Disodium 1-amino-9,10-dioxo-4-[(3-{[2-(sulfonatooxy)ethyl] sulfonyl} phenyl) amino]-9,10-dihydro-2-anthracenesulfonate) (CAS No. 2580-78-1)(provided for in subheading 3204.16.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.49",
      "rawHtsCode": "9902.08.49",
      "superior": null,
      "indent": "0",
      "description": "Reactive Red 195 (Pentasodium 2-{(E)-[8-({4-chloro-6-[(3-{[2-(sulfonatooxy)ethyl] sulfonyl} phenyl)amino]-1,3,5-triazin-2-yl} amino)-1-hydroxy-3,6-disulfonato-2-naphthyl] diazenyl}-1,5-naphthalenedisulfonate) (CAS No. 93050-79-4) (provided for in subheading 3204.16.30) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.50",
      "rawHtsCode": "9902.08.50",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Reactive Blue 19 (1-Amino-9,10-dihydro-9,10-dioxo-4-[[3-[[2-(sulfooxy)ethyl]sulfonyl] phenyl] amino]-2-anthracenesulfonic acid, sodium salt (1:2)) (CAS No. 2580-78-1); Reactive Blue 187 (1,1'-[(6,13-dichloro-4,11-disulfo-3,10-triphenodioxazinediyl) bis [imino-2,1-ethanediylimino[6-[(2,5-disulfophenyl) amino]-1,3,5-triazine-4,2-diyl]]] bis [3-carboxy-, bis(inner salt), hexasodium salt ) (CAS No. 79771-28-1) (provided for in subheading 3204.16.30).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.51",
      "rawHtsCode": "9902.08.51",
      "superior": null,
      "indent": "0",
      "description": "Reactive Blue FC75311 (Sodium [2-[2-[[2-[3-[[4-fluoro-6-[phenyl[2-[[2-(sulfooxy) ethyl]sulfonyl] ethyl]amino]-1,3,5-triazin-2-yl]amino]-2-(hydroxy-kO)-5-sulfophenyl] diazenyl-kN] phenylmethyl] diazenyl-kN]-4-sulfobenzoato (6-)-kO]-Cuprate(4-)  (CAS No.156830-72-7) (provided for in subheading 3204.16.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.52",
      "rawHtsCode": "9902.08.52",
      "superior": null,
      "indent": "0",
      "description": "Reactive Yellow F00-0155 (1H-Xantheno[2,1,9-def]isoquinoline-5,9-disulfonic acid, 2,3-dihydro-1,3-dioxo-2-[3-[[2-(sulfooxy)ethyl]sulfonyl]phenyl]-, sodium salt (1:?:?)) (CAS No. 1309975-18-5) (provided for in 3204.16.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.53",
      "rawHtsCode": "9902.08.53",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of Reactive Red 198 (5-[[4-Chloro-6-[(3-sulfophenyl) amino]-1,3,5-triazin-2-yl] amino]-4-hydroxy-3-[[4-[[2-(sulfoxy)ethyl] sulfonyl]phenyl]azo]-2,7- naphthalenedisulfonic acid, sodium salt (1:?)) (CAS No. 78952-61-1) and Reactive Red 239 (2-[2-[8-[[4-Chloro-6-[[4-[[2-(sulfooxy)ethyl] sulfonyl] phenyl]amino]-1,3,5-triazin-2-yl]amino]-1-hydroxy-3,6- disulfo-2-naphthalenyl]diazenyl]-1,5-naphthalenedisulfonic acid, sodium salt (1:5)) (CAS No. 89157-03-9) (as provided for in subheading 3204.16.30)  ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.54",
      "rawHtsCode": "9902.08.54",
      "superior": null,
      "indent": "0",
      "description": "Reactive Blue 187 (1,1'-[(6,13-Dichloro-4,11-disulfo-3,10-  triphenodioxazinediyl) bis [imino-2,1-ethanediylimino [6-[(2,5-disulfophenyl) amino]-1,3,5-triazine-4,2-diyl]]] bis [3-  carboxylatopyridinium], dihydroxide, bis (inner salt), hexasodium salt) (CAS No. 79771-28-1) (provided for in subheading 3204.16.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.55",
      "rawHtsCode": "9902.08.55",
      "superior": null,
      "indent": "0",
      "description": "Reactive Orange 131 (2,4-diamino-3-[4-(2-sulfoxyethylsulfonyl)-phenylazo] -5-[4-(2-sulfoxyethylsulfonyl)-2-sulfophenylazo]- benzenesulfonic acid, potassium sodium salt) (CAS No. 187026-95-5) (provided for in 3204.16.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.56",
      "rawHtsCode": "9902.08.56",
      "superior": null,
      "indent": "0",
      "description": "Reactive Black 5 (tetrasodium 4-amino-5-hydroxy-3,6-bis [(4-{[2-(sulfonatooxy)ethyl] sulfonyl} phenyl)diazenyl]-2,7-naphthalenedisulfonate) (CAS No. 17095-24-8) (provided for in subheading 3204.16.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.57",
      "rawHtsCode": "9902.08.57",
      "superior": null,
      "indent": "0",
      "description": "Reactive Red 180 (CAS No. 72828-03-6) (provided for in subheading 3204.16.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.58",
      "rawHtsCode": "9902.08.58",
      "superior": null,
      "indent": "0",
      "description": "Reactive Black 5 (CAS No. 17095-24-8) (provided for in subheading 3204.16.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.59",
      "rawHtsCode": "9902.08.59",
      "superior": null,
      "indent": "0",
      "description": "Copper phthalocyanine ((Phthalocyanato(2-))-copper), not ready for use as pigment (PCN Blue Crude) (CAS No 147-14-8) (provided for in subheading 3204.17.20)",
      "units": [],
      "generalRate": "3.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.60",
      "rawHtsCode": "9902.08.60",
      "superior": null,
      "indent": "0",
      "description": "Copper phthalocyanine monosulfonate (hydrogen [29H,31H-phthalocyaninesulphonato (3-)-N29, N30, N31, N32]cuprate(1-)), not ready for use as pigment (CAS No. 28901-96-4) (provided for in subheading 3204.17.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.61",
      "rawHtsCode": "9902.08.61",
      "superior": null,
      "indent": "0",
      "description": "Copper chlorophthalocyanine (30 to 35 percent pure) not ready for use as pigment (CAS Nos. 16040-69-0 (65-70 percent by weight) and 12239-87-1 (30-35 percent by weight)) (provided for in subheading 3204.17.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.62",
      "rawHtsCode": "9902.08.62",
      "superior": null,
      "indent": "0",
      "description": "Mixture of nonchlorinated copper phthalocyanine blue crude not ready for use as pigment (CAS No. 147-14-8) (30–40 percent by weight) and chlorinated copper phthalocyanine blue crude not ready for use as pigment (CAS No. 68987-63-3) (60–70 percent by weight) (provided for in subheading 3204.17.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.63",
      "rawHtsCode": "9902.08.63",
      "superior": null,
      "indent": "0",
      "description": "[1,2,3,4,8,9,10,11,15,16,17,18,22,23,25 - Pentadecachloro - 29,31-dihydro-5H, 26H-phthalocyaninato (2-) -κ2 N29, N31] copper (CAS No. 1328-53-6) (provided for in subheading 3204.17.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.64",
      "rawHtsCode": "9902.08.64",
      "superior": null,
      "indent": "0",
      "description": "Copper chlorophthalocyanine, crude not ready for use as pigment (CAS No. 12239-87-1) (provided for in subheading 3204.17.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.65",
      "rawHtsCode": "9902.08.65",
      "superior": null,
      "indent": "0",
      "description": "Solvent Orange 63 (14H-anthra[2,1,9-mna]thioxanthen-14-one) (CAS No. 16294-75-0) (CI No. 68550) (provided for in subheading 3204.19.11)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.66",
      "rawHtsCode": "9902.08.66",
      "superior": null,
      "indent": "0",
      "description": "Solvent Yellow 160:1 (CAS No. 35773-43-4) (provided for in subheading 3204.19.11)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.67",
      "rawHtsCode": "9902.08.67",
      "superior": null,
      "indent": "0",
      "description": "4-[(E)-Phenyldiazenyl]aniline (Solvent yellow 1) (CAS No. 60-09-3) (provided for in subheading 3204.19.11)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.69",
      "rawHtsCode": "9902.08.69",
      "superior": null,
      "indent": "0",
      "description": "Solvent Red 179 (14H-benzo[4,5]isoquino[2,1-a]perimidin-14-one) (CAS No. 6829-22-7) (CI No. 564150) (provided for in subheading 3204.19.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.70",
      "rawHtsCode": "9902.08.70",
      "superior": null,
      "indent": "0",
      "description": "Solvent Blue 104 (1,4-bis(mesitylamino)-9,10-anthraquinone) (CAS No.116-75-6) (provided for in subheading 3204.19.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.71",
      "rawHtsCode": "9902.08.71",
      "superior": null,
      "indent": "0",
      "description": "Solvent Violet 13 (1-hydroxy-4-(p-tolylamino)anthracene-9,10-dione) (CAS No. 81-48-1) (provided for in subheading 3204.19.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.72",
      "rawHtsCode": "9902.08.72",
      "superior": null,
      "indent": "0",
      "description": "Solvent Yellow 195 (CAS No. 440645-24-9) (provided for in subheading 3204.19.20) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.73",
      "rawHtsCode": "9902.08.73",
      "superior": null,
      "indent": "0",
      "description": "Solvent Yellow 163 (1,8-Bis(phenylthio)anthracene-9,10-dione) (CAS No. 13676-91-0) (provided for in subheading 3204.19.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.74",
      "rawHtsCode": "9902.08.74",
      "superior": null,
      "indent": "0",
      "description": "Solvent Red 227 (1-anilino-9,10-anthraquinone) (CAS No. 2944-28-7) (CI 60510) (provided for in subheading 3204.19.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.75",
      "rawHtsCode": "9902.08.75",
      "superior": null,
      "indent": "0",
      "description": "Solvent Red 169 (1-(isopropylamino)-9,10-anthraquinone) (CAS No. 27354-18-3) (provided for in subheading 3204.19.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.76",
      "rawHtsCode": "9902.08.76",
      "superior": null,
      "indent": "0",
      "description": "Solvent Yellow 114 (2-(3-hydroxy-2-quinolyl)-1H-indene-1,3(2H)-dione) (CAS No. 7576-65-0) (provided for in subheading 3204.19.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.77",
      "rawHtsCode": "9902.08.77",
      "superior": null,
      "indent": "0",
      "description": "Solvent Orange 60 (12H-isoindolo[2,1-a]perimidin-12-one) (CAS No. 6925-69-5) (provided for in subheading 3204.19.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.78",
      "rawHtsCode": "9902.08.78",
      "superior": null,
      "indent": "0",
      "description": "Solvent red 135 (8,9,10,11-Tetrachloro-12H-isoindolo[2,1-a]perimidin-12-one) (CAS No. 20749-68-2) (provided for in subheading 3204.19.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.79",
      "rawHtsCode": "9902.08.79",
      "superior": null,
      "indent": "0",
      "description": "Solvent Blue 35 (1,4-bis(butylamino)-9,10-anthraquinone) (CAS No. 17354-14-2) (CI No. 61554) (provided for in subheading 3204.19.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.80",
      "rawHtsCode": "9902.08.80",
      "superior": null,
      "indent": "0",
      "description": "Solvent Violet 11 (1,4-diaminoanthraquinone) (CAS No. 128-95-0) (provided for in subheading 3204.19.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.81",
      "rawHtsCode": "9902.08.81",
      "superior": null,
      "indent": "0",
      "description": "2,4-Dinitrophenol (Sulfur Black 1) (CAS No. 1326-82-5) (provided for in subheading 3204.19.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.82",
      "rawHtsCode": "9902.08.82",
      "superior": null,
      "indent": "0",
      "description": "Mono or diphthalimido methyl copper phthalocyanine ([2-(29H, 31H-phthalocyaninylmethyl) -1H -isoindole-1,3 (2H)-dionato (2-)-N29, N30, N31, N32] copper) (CAS No. 42739-64-0) (provided for in subheading 3204.19.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.83",
      "rawHtsCode": "9902.08.83",
      "superior": null,
      "indent": "0",
      "description": "Solubilized Sulphur Black 1 (CAS No.1326-83-6) (provided for in subheading 3204.19.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.84",
      "rawHtsCode": "9902.08.84",
      "superior": null,
      "indent": "0",
      "description": "2,2'-Thiene-2,5-diylbis(5-tert-butyl-1,3-benzoxazole) (CAS No. 7128-64-5) (provided for in subheading 3204.20.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.85",
      "rawHtsCode": "9902.08.85",
      "superior": null,
      "indent": "0",
      "description": "2,2'-(Vinylenedi-p-phenylene)bisbenzoxazole (CAS No. 1533-45-5) (provided for in subheading 3204.20.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.86",
      "rawHtsCode": "9902.08.86",
      "superior": null,
      "indent": "0",
      "description": "N, N-Dimethyl-N-octadecyl-1-octadecanaminium-(Sp-4-2)- [29H, 31H-phthalocyanine-2- sulfonato- N29, N30,N31, N32] cuprate (phthalocyanine blue additive) (CAS No. 70750-63-9) (provided for in subheading 3204.90.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.87",
      "rawHtsCode": "9902.08.87",
      "superior": null,
      "indent": "0",
      "description": "Organic luminescent pigments and dyes for security applications (provided for in subheading 3204.90.00), the foregoing excluding daylight fluorescent pigments and dyes and excluding the dyestuff bearing the CAS No. 6359-10-0",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.88",
      "rawHtsCode": "9902.08.88",
      "superior": null,
      "indent": "0",
      "description": "Phosphorescent pigment based on copper-doped zinc sulfide (CAS No. 68611-70-1) (provided for in subheading 3206.42.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.89",
      "rawHtsCode": "9902.08.89",
      "superior": null,
      "indent": "0",
      "description": "Pigment Yellow 184 (bismuth vanadium oxide) (CAS No. 14059-33-7) (provided for in subheading 3206.49.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.90",
      "rawHtsCode": "9902.08.90",
      "superior": null,
      "indent": "0",
      "description": "Yttrium oxide phosphor doped by europium, of a kind used as a luminophore. (CAS No. 68585-82-0) (provided for in subheading 3206.50.00)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.91",
      "rawHtsCode": "9902.08.91",
      "superior": null,
      "indent": "0",
      "description": "Lanthanum phosphate phosphor doped by cerium and terbium, of a kind used as a luminophore (CAS No. 95823-34-0) (provided for in subheading 3206.50.00).\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.92",
      "rawHtsCode": "9902.08.92",
      "superior": null,
      "indent": "0",
      "description": "Barium magnesium aluminate phosphor doped by europium, of a kind used as a luminophore (CAS Nos. 102110-17-8,1304-28-5,1309-48-4, 1344-28-1,1308-96-9, and 63774-55-0) (provided for in subheading 3206.50.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.93",
      "rawHtsCode": "9902.08.93",
      "superior": null,
      "indent": "0",
      "description": "Phosphor blend of yttrium oxide doped with europium and lanthanum phosphate. The range for each item is between 55-75 percent yttrium oxide europium-doped, and 45-25 percent phosphoric acid, lanthanum salt, cerium terbium-doped by weight, respectively. (CAS Nos. 68585-82-0 and 95823-34-0)  (provided for in subheading 3206.50.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.94",
      "rawHtsCode": "9902.08.94",
      "superior": null,
      "indent": "0",
      "description": "Calcium chloride fluoride phosphate, antimony- and manganese-doped, of a kind used as a luminophore (Calcium halo phosphate phosphor) (CAS No. 545386-98-9) (provided for in subheading 3206.50.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.95",
      "rawHtsCode": "9902.08.95",
      "superior": null,
      "indent": "0",
      "description": "Barium magnesium aluminate phosphor doped by europium and manganese, of a kind used as a luminophore (CAS Nos. 102110-17-8 ,1344-43-0, 1304-28-5, 1309-48-4, 1344-28-1, 1308-96-9, and 63774-55-0) (provided for in subheading 3206.50.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.96",
      "rawHtsCode": "9902.08.96",
      "superior": null,
      "indent": "0",
      "description": "Fritted barium borosilicate glass with a mean particle size between 0.4 and 10 microns, Young's modulus of 71GPa, a density of 2.8 grams per cubic centimeter, radiopacity of 4.2, a refractive index of 1.53, and chemical composition of 55 percent silicon dioxide, 25 percent barium oxide, 10 percent boron trioxide and 10 percent aluminum oxide by weight (provided for in subheading 3207.40.10)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.97",
      "rawHtsCode": "9902.08.97",
      "superior": null,
      "indent": "0",
      "description": "Prepared paint driers containing a mixture of cobalt hydroxide (CAS No. 21041-93-0), cobalt 2-ethylhexanoate (CAS No. 136-52-7), calcium propionate (CAS No. 4075-81-4), calcium 2-ethylhexanoate (CAS No. 136-51-6), hydrotreated heavy naphtha (CAS No. 64742-48-9), tripropylene glycol (CAS No. 24800-44-0) and tripropylene glycol methyl ether (CAS No. 25498-49-1) (provided for in subheading 3211.00.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.98",
      "rawHtsCode": "9902.08.98",
      "superior": null,
      "indent": "0",
      "description": "Resin cement based on calcium carbonate and silicone resins (CAS Nos. 471-34-1 and 68037-83-2) (provided for in subheading 3214.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.08.99",
      "rawHtsCode": "9902.08.99",
      "superior": null,
      "indent": "0",
      "description": "Cold-pressed orange oil (provided for in subheading 3301.12.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.01",
      "rawHtsCode": "9902.09.01",
      "superior": null,
      "indent": "0",
      "description": "Cold-pressed grapefruit oil (provided for in subheading 3301.19.10)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.02",
      "rawHtsCode": "9902.09.02",
      "superior": null,
      "indent": "0",
      "description": "Eucalyptus citriodora oil, hydrated, cyclized (CAS No. 1245629-80-4) (provided for in subheading 3301.29.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.03",
      "rawHtsCode": "9902.09.03",
      "superior": null,
      "indent": "0",
      "description": "Dispersions and suspensions of approximately 45 percent by weight propene, 1,1,2,3,3,3-hexafluoro-, telomer with chlorotrifluoroethene, oxidized, reduced, hydrolyzed, ammonium salts (CAS No. 220207-15-8) and 15 percent by weight 1-propene, 1,1,2,3,3,3-hexafluoro-, oxidized, polymerized (CAS No. 69991-67-9) in water (provided for in subheading 3402.11.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.04",
      "rawHtsCode": "9902.09.04",
      "superior": null,
      "indent": "0",
      "description": "Dispersions and suspensions of approximately 25 percent by weight 1-propene, 1,1,2,3,3,3-hexafluoro-, telomer with chlorotrifluoroethene, oxidized, reduced, hydrolyzed, ammonium salts (CAS No. 330809-92-2) in water (provided for in subheading 3402.11.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.05",
      "rawHtsCode": "9902.09.05",
      "superior": null,
      "indent": "0",
      "description": "Dispersions and suspensions of approximately 25 percent by weight 1-propene, 1,1,2,3,3,3-hexafluoro-, telomer with chlorotrifluoroethene, oxidized, reduced, hydrolyzed, ammonium salts (CAS No. 330809-92-2) and approximately 15-20 percent by weight 1-propene, 1,1,2,3,3,3-hexafluoro-, oxidized, polymerized (CAS No. 69991-67-9) in water (provided for in subheading 3402.11.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.06",
      "rawHtsCode": "9902.09.06",
      "superior": null,
      "indent": "0",
      "description": "Dispersions and suspensions of approximately 20 percent by weight 1-propene, 1,1,2,3,3,3-hexafluoro-, telomer with chlorotrifluoroethene, oxidized, reduced, ethyl ester, hydrolyzed, sodium salt (CAS No. 220207-15-8) in water (provided for in subheading 3402.11.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.07",
      "rawHtsCode": "9902.09.07",
      "superior": null,
      "indent": "0",
      "description": "Sodium petroleum sulfonate (CAS No. 68608-26-4) (provided for in subheading 3402.11.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.08",
      "rawHtsCode": "9902.09.08",
      "superior": null,
      "indent": "0",
      "description": "Alkyl (C16-C18)polyethyleneglycol tetra decylene glycol ether (CAS No. 96081-39-9) (provided for in subheading 3402.13.10)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.09",
      "rawHtsCode": "9902.09.09",
      "superior": null,
      "indent": "0",
      "description": "Surface-active preparations consisting of fatty acids, C16-C18 and C18 unsaturated, esters with pentaerythritol (CAS No. 85711-45-1); polysorbate 20 (CAS No. 9005-64-5); and polyoxyethylene dioleate (CAS No. 9005-07-6) (provided for in subheading 3402.13.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.10",
      "rawHtsCode": "9902.09.10",
      "superior": null,
      "indent": "0",
      "description": "3-Hydroxy-2,2-bis(hydroxymethyl)propyl (9Z)-9-octadecenoate (Pentaerythritol Monooleate) (CAS No. 10332-32-8) (provided for in subheading 3402.13.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.11",
      "rawHtsCode": "9902.09.11",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 1-butanol (CAS No. 71-36-3); 1-propoxy-2-propanol (mixed isomers) (CAS No. 1569-01-3); siloxanes and silicones, dimethyl, 3-hydroxypropyl methyl, ethoxylated propoxylated (CAS No. 68937-55-3); 2-methyloxirane, oxirane, 3-prop-2-enoxyprop-1-ene (CAS No. 9041-33-2); urea, polymer with formaldehyde, methylated (CAS No. 68071-45-4); 2-propanol (CAS No. 67-63-0); 2-amino-2-methyl-1-propanol (CAS No. 124-68-5); 2-methyl-2-(methylamino)-1-propanol (CAS No. 27646-80-6); methanol (CAS No. 67-56-1) and water (CAS No. 7732-18-5) (provided for in subheading 3402.19.50) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.12",
      "rawHtsCode": "9902.09.12",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of poly(oxy-1,2-ethanediyl), α-(2,4,6-tris(1-phenylethyl)phenyl)-ω-hydroxy-, phosphate, potassium salt (CAS No. 163436-84-8); poly(oxy-1,2-ethanediyl), α-(tris(1-phenylethyl)phenyl)-ω-hydroxy- (CAS No. 99734-09-5); and propane-1,2-diol (CAS No. 57-55-6) (provided for in subheading 3402.90.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.13",
      "rawHtsCode": "9902.09.13",
      "superior": null,
      "indent": "0",
      "description": "Plaster mold release agent made from propan-2-ol (CAS No. 67-63-0), 2-methylpropan-1-ol (CAS No. 78-83-1), 2-methoxy-methylethyl acetate (CAS No. 108-65-6), hexadecanoic acid (CAS No. 57-10-3), octadecanoic acid (CAS No. 57-11-4) and other ingredients (provided for in subheading 3403.99.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.14",
      "rawHtsCode": "9902.09.14",
      "superior": null,
      "indent": "0",
      "description": "Sparklers (Class 1.4G) (provided for in subheading 3604.10.90) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.15",
      "rawHtsCode": "9902.09.15",
      "superior": null,
      "indent": "0",
      "description": "Party Poppers (Class 1.4G) (Provided for in subheading 3604.90.00) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.16",
      "rawHtsCode": "9902.09.16",
      "superior": null,
      "indent": "0",
      "description": "Instant print film, for color photography (polychrome) (provided for in subheading 3701.20.00)",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.17",
      "rawHtsCode": "9902.09.17",
      "superior": null,
      "indent": "0",
      "description": "Glycerol ester of dimerized rosin acids, having softening point not less than 104˚ C and acid number measuring 3 or more but not over 8 (CAS No. 68475-37-6) (provided for in subheading 3806.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.18",
      "rawHtsCode": "9902.09.18",
      "superior": null,
      "indent": "0",
      "description": "Partially polymerized (dimerized) rosin, catalyzed with sulfuric acid, softening point not less than 92˚ C, acid number not less than 140 (CAS No. 65997-05-9) (provided for in subheading 3806.90.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.19",
      "rawHtsCode": "9902.09.19",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing (RS)-α-cyano-4-fluoro-3-phenoxybenzyl (1RS, 3RS; 1RS, 3SR)- 3 - (2,2-dichlorovinyl) - 2, 2-dimethylcyclopropanecarboxylate (β-Cyfluthrin) (CAS No. 68359-37-5) (provided for in subheading 3808.91.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.20",
      "rawHtsCode": "9902.09.20",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing 4-{[(6-chloro-3-pyridinyl)methyl](2,2-difluoroethyl)amino}-2(5H)-furanone (Flupyradifurone) (CAS No. 951659-40-8) (provided for in subheading 3808.91.25)",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.21",
      "rawHtsCode": "9902.09.21",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing 1-(6-chloro-3-pyridinyl)methyl-N-nitroimidazolidin-2-ylideneamine (Imidacloprid) (CAS No 138261-41-3) and (RS)-α-cyano-4-fluoro-3-phenoxybenzyl (1RS, 3RS;1RS, 3SR)- 3- (2,2-dichlorovinyl)-2,2-dimethylcyclopropanecarboxylate (β-Cyfluthrin) (CAS No. 68359-37-5) (provided for in subheading 3808.91.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.22",
      "rawHtsCode": "9902.09.22",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing 1-(6-chloro-3-pyridinyl)methyl-N-nitroimidazolidin-2-ylideneamine (Imidacloprid) (CAS No. 138261-41-3) and 3, 7, 9, 13-tetramethyl-5, 11-dioxa-2, 8, 14-trithia-4, 7, 9, 12-tetraazapentadeca-3, 12-diene-6, 10-dione (Thiodicarb) (CAS No. 59669-26-0) (provided for in subheading 3808.91.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.23",
      "rawHtsCode": "9902.09.23",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing 3-mesityl-2-oxo-1-oxaspiro[4.4]non-3-en-4-yl 3,3-dimethylbutyrate (Spiromesifen) (CAS No. 283594-90-1) (provided for in subheading 3808.91.25)",
      "units": [],
      "generalRate": "1.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.24",
      "rawHtsCode": "9902.09.24",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing (5s, 8s)-3-(2,5-dimethylphenyl)-8-methoxy-2-oxo-1-azaspiro [4.5] dec-3-en-4-yl ethyl carbonate (Spirotetramat) (CAS No. 203313-25-1) (provided for in subheading 3808.91.25)",
      "units": [],
      "generalRate": "5.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.25",
      "rawHtsCode": "9902.09.25",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing 1-(2-chloro-1,3-thiazol-5-ylmethyl)-3-methyl-2-nitroguanidine (Clothianidin) (CAS No. 210880-92-5) and (RS)-α-cyano-4-fluoro-3-phenoxybenzyl (1RS, 3RS; 1RS, 3SR) -3- (2,2-dichlorovinyl) -2,2- dimethylcyclopropanecarboxylate (β-Cyfluthrin) (CAS No. 68359-37-5) (provided for in subheading 3808.91.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.26",
      "rawHtsCode": "9902.09.26",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing (Z)-2-chloro-1-(2,4,5-trichlorophenyl)vinyl dimethylphosphate (Tetrachlorvinfos) (CAS No. 22248-79-9) (provided for in subheading 3808.91.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.27",
      "rawHtsCode": "9902.09.27",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 3,6-bis(2-chlorophenyl)-1,2,4,5-tetrazine (Clofentezine) (CAS No.74115-24-5) and application adjuvants (provided for in subheading 3808.91.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.28",
      "rawHtsCode": "9902.09.28",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of \t3-dodecyl-1,4-dioxo-1,4-dihydronaphthalen-2-yl acetate (CAS 57960-19-7) (Acequinocyl) and application adjuvants (provided for in subheading 3808.91.25)\n\n\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.29",
      "rawHtsCode": "9902.09.29",
      "superior": null,
      "indent": "0",
      "description": "N-(Cyanomethyl)-4-(trifluoromethyl)-3-pyridinecarboxamide (Flonicamid) (CAS No. 158062-67-0) (provided for in subheading 2933.39.27) and any formulations containing such compound (provided for in subheading 3808.91.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.30",
      "rawHtsCode": "9902.09.30",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing Cyano (3-phenoxyphenyl) methyl 3-[ (1Z)-2-chloro-3,3,3-trifluoro-1-propen-1-yl] -2,2-dimethylcyclopropanecarboxylate (gamma-cyhalothrin) and application adjuvants (CAS No. 76703-62-3) (provided for in subheading 3808.91.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.31",
      "rawHtsCode": "9902.09.31",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of (E)-N1-[(6-chloro-3-pyridyl)methyl]-N2-cyano-N1-methyl-acetamidine (Acetamiprid) (CAS No. 135410-20-7) and application adjuvants (provided for in subheading 3808.91.25)",
      "units": [],
      "generalRate": "0.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.32",
      "rawHtsCode": "9902.09.32",
      "superior": null,
      "indent": "0",
      "description": "Formulations containing zinc phosphide (trizinc diphosphide) (CAS No. 1314-84-7) (provided for in subheading 3808.91.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.33",
      "rawHtsCode": "9902.09.33",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing dimethyl (2aR, 3S, 4S, 4aR, 5S, 7aS, 8S, 10R, 10aS, 10bR)-10-acetoxy-3,5-dihydroxy-4[(1aR, 2S, 3aS, 6aS, 7S, 7aS)-6a-hydroxy-7a-methyl-3a,6a,7,7a-tetrahydro-2,7-methanofuro [2,3-b] oxireno[e]oxepin-1a(2H)-yl]-4-methyl-8-{[(2E)-2-methylbut-2-enoyl] oxy} octahydro-1H-naphtho [1,8a-c:4,5-b'c'] difuran-5,10a (8H)-dicarboxylate (Azadirachtin) (CAS No. 11141-17-6) (provided for in subheading 3808.91.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.34",
      "rawHtsCode": "9902.09.34",
      "superior": null,
      "indent": "0",
      "description": "Abamectin (mixture of Avermectin A1a and Avermectin A1b) (CAS No. 155569-91-8) (provided for in subheading 3808.91.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.35",
      "rawHtsCode": "9902.09.35",
      "superior": null,
      "indent": "0",
      "description": "Formulations of O,S-dimethyl acetylphosphoramidothioate (Acephate) (CAS No. 30560-19-1) (provided for in subheading 3808.91.50)",
      "units": [],
      "generalRate": "1.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.36",
      "rawHtsCode": "9902.09.36",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing 1-[(2-chloro-1,3-thiazol-5-yl)methyl]-2-methyl-3-nitroguanidine (Clothianidin) (CAS No. 210880-92-5) and Bacillus firmus (Strain I-1582) (provided for in subheading 3808.91.50).",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.37",
      "rawHtsCode": "9902.09.37",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 1-[(2-chloro-1,3-thiazol-5-yl)methyl]-2-methyl-3-nitroguanidine (Clothianidin) (CAS No. 210880-92-5) (provided for in subheading 3808.91.50)",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.38",
      "rawHtsCode": "9902.09.38",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 2-methyl-1-nitro-3-(tetrahydro-2-furanylmethyl)guanidine (Dinotefuran) (CAS No. 165252-70-0) with application adjuvants (provided for in subheading 3808.91.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.39",
      "rawHtsCode": "9902.09.39",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of methyl (1E)-N-[(methylcarbamoyl)oxy]ethanimidothioate (Methomyl) (CAS No. 16752-77-5) and application adjuvants (provided for in subheading 3808.91.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.40",
      "rawHtsCode": "9902.09.40",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing methyl N-(2-methoxyacetyl)-N-(2,6-xylyl)-DL-alaninate (Metalaxyl) (CAS No. 57837-19-1), 5 - fluoro-1,3-dimethyl - N-[2-(4-methylpentan-2-yl) phenyl] -1H-pyrazole-4-carboxamide (Penflufen) (CAS No. 494793-67-8) and 2-[(2RS)-2-(1-chlorocyclopropyl) -3-(2-chlorophenyl) -2-hydroxypropyl] - 2H-1,2,4-triazole-3(4H)-thione (Prothioconazole) (CAS No. 178928-70-6) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.41",
      "rawHtsCode": "9902.09.41",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing (E)-{2-[6-(2-chlorophenoxy)-5-fluoropyrimidin-4-yloxy] phenyl} (5,6-dihydro-1,4,2-dioxazin-3-yl) methanone O-methyloxime (Fluoxastrobin) (CAS No. 361377-29-9) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.42",
      "rawHtsCode": "9902.09.42",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing 1-(4-chlorophenoxy)-3,3-dimethyl-1-[1,2,4] triazol-1-yl-butan-2-one (Triadimefon) (CAS No. 43121-43-3) and methyl (E)-methoxyimino-{(E)-2-[1-(α,α,α-trifluoro-m-tolyl) ethylideneaminooxy]-o-tolyl} acetate (Trifloxystrobin) (CAS No. 141517-21-7) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.43",
      "rawHtsCode": "9902.09.43",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing 1-(4-chlorophenoxy)-3,3-dimethyl-1-(1H-1,2,4-triazol-1-yl)-2-butanone (Triadimefon) (CAS No. 43121-43-3) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.44",
      "rawHtsCode": "9902.09.44",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing N-[2-(1,3-dimethylbutyl) phenyl]-5-fluoro-1,3-dimethyl-1H-pyrazole-4-carboxamide (Penflufen) (CAS No. 494793-67-8) and 2-[(2RS)-2-(1-chlorocyclopropyl)-3-(2-chlorophenyl) -2- hydroxypropyl] - 2H-1, 2, 4-triazole-3(4H)-thione (Prothioconazole) (CAS No. 178928-70-6) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.45",
      "rawHtsCode": "9902.09.45",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing 1-(6-chloro-3-pyridinyl) methyl-N-nitroimidazolidin-2-ylideneamine (Imidacloprid) (CAS No. 138261-41-3), methyl N-(2-methoxyacetyl) - N - (2,6-xylyl) - DL-alaninate (Metalaxyl) (CAS No. 57837-19-1), 2-[(2RS)-2-(1-chlorocyclopropyl)-3- (2-chlorophenyl)-2-hydroxypropyl] - 2H-1,2,4-triazole-3 (4H)-thione (Prothioconazole) (CAS No. 178928-70-6) and (RS)-1-p-chlorophenyl-4,4-dimethyl-3-(1H-1,2,4-triazol-1-ylmethyl)pentan-3-ol (Tebuconazole) (CAS No. 107534-96-3) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.46",
      "rawHtsCode": "9902.09.46",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of N- [9-(dichloromethylidene)-1,2,3,4-tetrahydro-1,4-methanonaphthalen-5-yl] -3-(difluoromethyl) -1-methyl-1H-pyrazole-4-carboxamide (Benzovindiflupyr) (CAS No. 1072957-71-1) and methyl (2E) -2-(2- {[6-(2-cyanophenoxy) pyrimidin-4-yl] oxy} phenyl)-3-methoxyacrylate (Azoxystrobin) (CAS No. 131860-33-8) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.47",
      "rawHtsCode": "9902.09.47",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 1-[4-[4-[5-(2,6-difluorophenyl)-4,5-dihydro-1,2-oxazol-3-yl]-1,3-thiazol-2-yl] piperidin-1-yl]-2-[5-methyl-3-(trifluoromethyl) pyrazol-1-yl] ethanone (Oxathiapiprolin) (CAS No. 1003318-67-9) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.48",
      "rawHtsCode": "9902.09.48",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing N-{2-[3-chloro-5-(trifluoromethyl)-2-pyridinyl]ethyl}-2-(trifluoromethyl) benzamide (Fluopyram) (CAS No. 658066-35-4) and 1-(4-chlorophenyl)-4,4-dimethyl-3-(1H-1,2,4-triazol-1-ylmethyl) pentan-3-ol (Tebuconazole) (CAS No. 107534-96-3) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.49",
      "rawHtsCode": "9902.09.49",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing N-[2-[3-chloro-5-(trifluoromethyl) pyridin-2-yl]ethyl]-2-(trifluoromethyl) benzamide (Fluopyram) (CAS No. 658066-35-4) and Bacillus firmus (Strain I-1582) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "0.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.50",
      "rawHtsCode": "9902.09.50",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing 2-[(2RS)-2-(1-chlorocyclopropyl)-3-(2-chlorophenyl) -2-hydroxypropyl]-2H-1,2,4-triazole-3 (4H)-thione (Prothioconazole) (CAS No. 178928-70-6) and (RS)-1-p-chlorophenyl-4,4-dimethyl-3-(1H-1,2,4-triazol-1-ylmethyl) pentan-3-ol (Tebuconazole) (CAS No. 107534-96-3) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "4.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.51",
      "rawHtsCode": "9902.09.51",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing methyl (E)-methoxyimino-{(E)-2-[1-(α,α,α-trifluoro-m-tolyl) ethylideneaminooxy]-o-tolyl}acetate (Trifloxystrobin) (CAS No. 141517-21-7) and 2-[(2RS)-2-(1-chlorocyclopropyl)-3-(2-chlorophenyl) -2-hydroxypropyl]-2H-1,2,4-triazole-3(4H)-thione (Prothioconazole) (CAS No. 178928-70-6) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "4.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.52",
      "rawHtsCode": "9902.09.52",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing 1-(6-chloro-3-pyridinyl)methyl-N-nitroimidazolidin-2-ylideneamine (Imidacloprid) (CAS No. 138261-41-3), methyl N-(2-methoxyacetyl)-N-(2,6-xylyl)-DL-alaninate (Metalaxyl) (CAS No. 57837-19-1) and (RS)-1-p-chlorophenyl-4,4-dimethyl-3-(1H-1,2,4-triazol-1-ylmethyl) pentan-3-ol (Tebuconazole) (CAS No. 107534-96-3) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.53",
      "rawHtsCode": "9902.09.53",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing methyl (E)-methoxyimino-{(E)-2-[1-(α,α,α-trifluoro-m-tolyl) ethylideneaminooxy]-o-tolyl}acetate (Trifloxystrobin) (CAS No. 141517-21-7) and (RS)-1-p-chlorophenyl-4,4-dimethyl-3-(1H-1,2,4-triazol-1-ylmethyl) pentan-3-ol (Tebuconazole) (CAS No. 107534-96-3) (provided for in subheading 3808.92.15) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.54",
      "rawHtsCode": "9902.09.54",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing N-[2-[3-chloro-5-(trifluoromethyl)pyridin-2-yl]ethyl]-2-(trifluoromethyl) benzamide (Fluopyram) (CAS No. 658066-35-4) and 4,6-dimethyl-N-phenyl-2-pyrimidinamine (Pyrimethanil) (CAS No. 53112-28-0) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.55",
      "rawHtsCode": "9902.09.55",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing N-[2-[3-chloro-5-(trifluoromethyl)pyridin-2-yl]ethyl]-2-(trifluoromethyl) benzamide (Fluopyram) (CAS No. 658066-35-4) and methyl (E)-methoxyimino-{(E)-2-[1-(α,α,α-trifluoro-m-tolyl) ethylideneaminooxy]-o-tolyl} acetate (Trifloxystrobin) (CAS No. 141517-21-7) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.56",
      "rawHtsCode": "9902.09.56",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing methyl (E)-methoxyimino-{(E)-2-[1-(α,α,α-trifluoro-m-tolyl) ethylideneaminooxy]-o-tolyl}acetate (Trifloxystrobin) (CAS No. 141517-21-7) and cis-trans-1-[2-(2,4-dichlorophenyl)-4-propyl-1,3-dioxolan-2-ylmethyl] -1H-1,2,4-triazole (Propiconazole) (CAS No. 60207-90-1) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.57",
      "rawHtsCode": "9902.09.57",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing methyl (2E)-(methoxyimino)[2-({[(E)-{1-[3-trifluoromethyl) phenyl]ethylidene}amino]oxy}methyl)phenyl]acetate (Trifloxystrobin) (CAS No. 141517-21-7) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.58",
      "rawHtsCode": "9902.09.58",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing N-[2-[3-chloro-5-(trifluoromethyl)pyridin-2-yl]ethyl]-2-(trifluoromethyl) benzamide (Fluopyram) (CAS No. 658066-35-4) and (RS)-2-[2-(1-chlorocyclopropyl)-3-(2-chlorophenyl)-2-hydroxypropyl] -2,4-dihydro-1,2,4-triazole-3-thione (Prothioconazole) (CAS No. 178928-70-6) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.59",
      "rawHtsCode": "9902.09.59",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing 2-[2-(1-chlorocyclopropyl)-3-(2-chlorophenyl)-2-hydroxypropyl] -1,2-dihydro-3H-1,2,4-triazole-3-thione (Prothioconazole) (CAS No. 178928-70-6) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.60",
      "rawHtsCode": "9902.09.60",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing N-(2,3-dichloro-4-hydroxyphenyl)-1-methylcyclohexanecarboxamide (Fenhexamid) (CAS No. 126833-17-8) and application adjuvants (provided for in subheading 3808.92.15)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.61",
      "rawHtsCode": "9902.09.61",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of N-[2-[3-chloro-5-(trifluoromethyl) pyridin-2-yl]ethyl]-2-(trifluoromethyl) benzamide (Fluopyram) (CAS No. 658066-35-4) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.62",
      "rawHtsCode": "9902.09.62",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of N-[2-[3-chloro-5-(trifluoromethyl) pyridin-2-yl]ethyl]-2-(trifluoromethyl) benzamide (Fluopyram) (CAS No. 658066-35-4) and N-[1-[(6-chloropyridin-3-yl)methyl]-4,5-dihydroimidazol-2-yl] nitramide (Imidacloprid) (CAS No. 138261-41-3) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.63",
      "rawHtsCode": "9902.09.63",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of (1-[2-(allyloxy)-2-(2,4-dichlorophenyl)ethyl]-1H-imidazole) (Imazalil) (CAS No. 35554-44-0) and application adjuvants (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.64",
      "rawHtsCode": "9902.09.64",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 1-[2-(2,4-dichlorophenyl)-2-(prop-2-en-1-yloxy)ethyl]-1H-imidazole sulfate (Imazalil sulfate) (CAS No. 58594-72-2) and application adjuvants (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.65",
      "rawHtsCode": "9902.09.65",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 4,6-dimethyl-N-phenyl-2-pyrimidinamine (Pyrimethanil) (CAS No. 53112-28-0) and application adjuvants (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.66",
      "rawHtsCode": "9902.09.66",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 5,7-dichloro-4-(4-fluorophenoxy)quinoline (Quinoxyfen) (CAS No. 124495-18-7) and application adjuvants (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "1.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.67",
      "rawHtsCode": "9902.09.67",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 3-anilino-5-methyl-5-(4-phenoxyphenyl)-1,3-oxazolidine-2,4-dione (Famoxadone) (CAS No. 131807-57-3), 2-cyano-N-(ethylcarbamoyl)-2-(methoxyimino)acetamide (Cymoxanil) (CAS No. 57966-95-7) and application adjuvants (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.68",
      "rawHtsCode": "9902.09.68",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing methyl (2E)-(methoxyimino)[2-({[(E)-{1-[3-(trifluoromethyl) phenyl]ethylidene}amino]oxy}methyl)phenyl] acetate (Trifloxystrobin) (CAS No. 141517-21-7) and 2-(4-chlorophenyl)-3-cyclopropyl-1-(1H-1,2,4-triazol-1-yl)-2-butanol (Cyproconazole) (CAS No. 94361-06-5) and application adjuvants (provided for in subheading 3808.92.15).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.69",
      "rawHtsCode": "9902.09.69",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing N-[2-[3-Chloro-5-(trifluoromethyl)pyridin-2-yl] ethyl]-2-(trifluoromethyl) benzamide (Fluopyram) (CAS No. 658066-35-4) and (E)-1-(2-Chloro-1,3-thiazol-5-ylmethyl)-3-methyl-2-nitroguanidine (Clothianidin) (CAS No. 210880-92-5) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.70",
      "rawHtsCode": "9902.09.70",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing 3-(3,5-dichlorophenyl)-N-isopropyl-2,4-dioxo-1-imidazolidinecarboxamide (Iprodione) (CAS No. 36734-19-7) and methyl (2E)-(methoxyimino) [2-({[(E)-{1-[3-(trifluoromethyl) phenyl]ethylidene}amino]oxy}methyl)phenyl] acetate (Trifloxystrobin) (CAS No. 141517-21-7) (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.71",
      "rawHtsCode": "9902.09.71",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 1-[2-(2,4-dichlorophenyl)-3-(1,1,2,2-tetrafluoroethoxy)-propyl] -1H-1,2,4-triazole (Tetraconazole) (CAS No. 112281-77-3); methyl (2E)-2-(2-{[6-(2-cyanophenoxy)-4-pyrimidinyl]oxy} phenyl)-3-methoxyacrylate (Azoxystrobin) (CAS No. 131860-33-8); and application adjuvants (provided for in subheading 3808.92.15) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.72",
      "rawHtsCode": "9902.09.72",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 1-[2-(2,4-dichlorophenyl)-3-(1,1,2,2-tetrafluoroethoxy)-propyl] -1H-1,2,4-triazole (Tetraconazole) (CAS No. 112281-77-3); 2,4,5,6-tetrachloroisophthalonitrile (Chlorothalonil) (CAS No. 1897-45-6); and application adjuvants (provided for in subheading 3808.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.73",
      "rawHtsCode": "9902.09.73",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of zinc bis(dimethyldithiocarbamate) (Ziram) and application adjuvants (CAS No. 137-30-4) (provided for in subheading 3808.92.28)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.74",
      "rawHtsCode": "9902.09.74",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of [disulfanediylbis(carbonothioylnitrilo)]tetramethane (Thiram) (CAS No. 137-26-8) and application adjuvants (provided for in subheading 3808.92.28)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.75",
      "rawHtsCode": "9902.09.75",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of at least 95 percent by weight allyl isothiocyanate (3-isothiocyanato-1-propene) (CAS No. 57-06-7), and application adjuvants (provided for in subheading 3808.92.28)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.76",
      "rawHtsCode": "9902.09.76",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of copper oxychloride (CAS No. 1332-40-7) and copper hydroxide (CAS No. 20427-59-2) (provided for in subheading 3808.92.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.77",
      "rawHtsCode": "9902.09.77",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of copper dihydroxide (cupric hydroxide) (CAS No. 20427-59-2) and application adjuvants (provided for in subheading 3808.92.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.78",
      "rawHtsCode": "9902.09.78",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing (1S,2R,3S,4R,5S,6S)-2,3,4,5,6-Pentahydroxycyclohexyl 2-amino-4-{[carboxy(imino) methyl]amino}-2,3,4,6-tetradeoxy-α-D-arabino-hexopyranoside (CAS No. 19408-46-9) (Kasugamycin) and application adjuvants (provided for in subheading 3808.92.50)  ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.79",
      "rawHtsCode": "9902.09.79",
      "superior": null,
      "indent": "0",
      "description": "Formulations of zinc 1-{(2R, 3R, 4S, 5R)-5-[(S)-{[(2S, 3S, 4S)-2-amino-5-(carbamoyloxy) -3,4-dihydroxypentanoyl] amino}(carboxylato)methyl] -3,4-dihydroxytetrahydro-2-furanyl}-2,4-dioxo-1,2,3,4-tetrahydro -5-pyrimidinecarboxylate (Polyoxin D Zinc Salt) (CAS No. 146659-78-1) (provided for in subheading 3808.92.50) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.80",
      "rawHtsCode": "9902.09.80",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of N,N-dimethyl-3-[(propoxycarbonyl)amino]-1-propanaminium chloride (Propamocarb hydrochloride) (CAS No. 25606-41-1) and application adjuvants (provided for in subheading 3808.92.50)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.81",
      "rawHtsCode": "9902.09.81",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing β-conglutin and application adjuvants used as a fungicide (provided for in subheading 3808.92.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.82",
      "rawHtsCode": "9902.09.82",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 1-dodecylguanidine acetate (1:1) (Dodine) (CAS No. 2439-10-3) and application adjuvants (provided for in subheading 3808.92.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.83",
      "rawHtsCode": "9902.09.83",
      "superior": null,
      "indent": "0",
      "description": "Formulated fungicide kit consisting of individual packs of tetra-n-butylammonium fluoride (CAS No. 87749-50-6), dimethylsulfoxide (CAS No. 67-68-5), 2-(butyldimethylsilyl)-1-methylcyclopropanol-1-methanesulfonate (CAS No. 1446996-86-6), and sodium hydroxide solution (CAS No. 1310-73-2) (provided for in subheading 3808.92.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.84",
      "rawHtsCode": "9902.09.84",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing 5-methyl-1,2-oxazol-3(2H)-one (Hymexazol) (CAS No. 10004-44-1) (provided for in subheading 3808.92.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.85",
      "rawHtsCode": "9902.09.85",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing sodium {[2-(methoxycarbonyl) phenyl]sulfonyl} [(4,5-dihydro-4-methyl-5-oxo-3-propoxy-1H-1,2,4-triazol-1-yl) carbonyl] azanide (Propoxycarbazone sodium) (CAS No. 181274-15-7) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.86",
      "rawHtsCode": "9902.09.86",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing (5-hydroxy-1,3-dimethyl-1H-pyrazol-4-yl)[2-(methylsulfonyl)-4-(trifluoromethyl) phenyl] methanone (Pyrasulfotole) (CAS No. 365400-11-9); 2,4-dibromo-6-cyanophenyl octanoate (Bromoxynil Octanoate) (CAS No. 1689-99-2); 2,6-dibromo-4-cyanophenyl heptanoate (Bromoxynil Heptanoate) (CAS No. 56634-95-8); and diethyl 1-(2,4-dichlorophenyl)-5-methyl-4,5-dihydro-1H-pyrazole-3,5-dicarboxylate (Mefenpyr-diethyl) (CAS No. 135590-91-9) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.87",
      "rawHtsCode": "9902.09.87",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of benzamide, 2-[[[[(4,6-dimethoxy-2-pyrimidinyl)-amino]carbonyl]amino]sulfonyl]-4-(formylamino) -N,N- methyl- (Foramsulfuron) (CAS No. 173159-57-4) and application adjuvants (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.88",
      "rawHtsCode": "9902.09.88",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing methyl 2-[({[(4,6-dimethoxy-2-pyrimidinyl)amino] carbonyl}amino) sulfonyl]-4-[(mesylamino) methyl] benzoate (Mesosulfuron-methyl) (CAS No. 208465-21-8) (provided for in subheading 3808.93.15)         ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.89",
      "rawHtsCode": "9902.09.89",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing (5-cyclopropyl-1,2-oxazol-4-yl)[2-(methylsulfonyl)-4-(trifluoromethyl) phenyl] methanone (Isoxaflutole) (CAS No. 141112-29-0) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.90",
      "rawHtsCode": "9902.09.90",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing N-[(1R,2S)-2,6-dimethyl-2,3-dihydro-1H-inden-1-yl]-6-[(1R)-1-fluoroethyl] -1,3,5-triazine-2,4-diamine (Indaziflam) (CAS No. 950782-86-2) and N-[(4,6-dimethoxy-2-pyrimidinyl) carbamoyl] -3-(ethylsulfonyl)-2-pyridinesulfonamide (Rimsulfuron) (CAS No. 122931-48-0) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.91",
      "rawHtsCode": "9902.09.91",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of ethyl 2-chloro-5-(4-chloro-5-difluoromethoxy-1-methyl-1H-pyrazol-3-yl) -4-fluorophenoxyacetate (Pyraflufen-ethyl) (CAS No. 129630-19-9) and application adjuvants (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.92",
      "rawHtsCode": "9902.09.92",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of (2RS, 3RS)-1-(4-chlorophenyl)-4,4-dimethyl-2-(1H-1,2,4-triazol-1-yl) pentan-3-ol (Paclobutrazol) (CAS No. 76738-62-0) and application adjuvants (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.93",
      "rawHtsCode": "9902.09.93",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of N-[(4-methoxy-6-methyl-1,3,5-triazin-2-yl)carbamoyl]-2-(3,3,3-trifluoropropyl) benzenesulfonamide (Prosulfuron) (CAS No. 94125-34-5) and application adjuvants (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.94",
      "rawHtsCode": "9902.09.94",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 1,1′-dimethyl-4,4′-bipyridinium dichloride (Paraquat Dichloride Technical) (CAS No. 1910-42-5) and 2-amino-4,5-dihydro-6-methyl-4-propyl-s-triazole-[1,5-a]pyrimidin-5-one (Emetic PP796) (CAS No. 27277-00-5) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "4.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.95",
      "rawHtsCode": "9902.09.95",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing 5-(2-chloro-4-(trifluoromethyl)phenoxy)-2-nitrobenzoic acid (Acifluorfen MUP) (CAS No. 62476-59-9) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.96",
      "rawHtsCode": "9902.09.96",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of methylsulfanilycarbamate, sodium salt (Asulam sodium salt) (CAS No. 2302-17-2) and application adjuvants (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "2.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.97",
      "rawHtsCode": "9902.09.97",
      "superior": null,
      "indent": "0",
      "description": "(RS)-N,N-Diethyl-2-(1-naphthyloxy)propionamide formulations (Napropamide) (CAS No. 15299-99-7) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.98",
      "rawHtsCode": "9902.09.98",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing methyl 2-{[(4,6-dimethyl-2-pyrimidinyl)carbamoyl]sulfamoyl}benzoate (Sulfometuron-methyl) (CAS No. 74222-97-2) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.09.99",
      "rawHtsCode": "9902.09.99",
      "superior": null,
      "indent": "0",
      "description": "Formulations of 3-isopropyl-1H-2,1,3-benzothiadiazin-4(3H)-one, 2,2-dioxide (Bentazone) (CAS No. 25057-89-0) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.01",
      "rawHtsCode": "9902.10.01",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing 5-cyclopropyl-4-(2-mesyl-4-trifluoromethylbenzoyl) isoxazole (Isoxaflutole) (CAS No. 141112-29-0) and N-({4-[(cyclopropylamino) carbonyl]phenyl} sulfonyl)-2-methoxybenzamide (Cyprosulfamide) (CAS No. 221667-31-8) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.02",
      "rawHtsCode": "9902.10.02",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing ethyl 5,5-diphenyl-4H-1,2-oxazole-3-carboxylate (Isoxadifen-ethyl) (CAS No. 163520-33-0) and 2-{2-chloro-4-(methylsulfonyl)-3-[(2,2,2-trifluoroethoxy)methyl]benzoyl} -1,3-cyclohexanedione (Tembotrione) (CAS No. 335104-84-2) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "1.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.03",
      "rawHtsCode": "9902.10.03",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of N-[[(4,6-dimethoxy-2-pyrimidinyl) amino] carbonyl]-3-(ethylsulfonyl)-2-pyridinesulfonamide (Rimsulfuron) (CAS No. 122931-48-0) and application adjuvants (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.04",
      "rawHtsCode": "9902.10.04",
      "superior": null,
      "indent": "0",
      "description": "Product mixtures containing methyl 4-{[(3-methoxy-4-methyl-5-oxo-4,5-dihydro-1H-1,2,4-triazol-1-yl)carbonyl] sulfamoyl}-5-methyl-3-thiophenecarboxylate (Thiencarbazone-methyl) (CAS No. 317815-83-1), methyl 2-{[(4,6-dimethoxy-2-pyrimidinyl) carbamoyl] sulfamoyl}-4-{[(methylsulfonyl)amino]methyl} benzoate (Mesosulfuron-methyl) (CAS No. 208465-21-8) and diethyl 1-(2,4-dichlorophenyl)-5-methyl-4,5-dihydro-1H-pyrazole -3,5-dicarboxylate (Mefenpyr-diethyl) (CAS No. 135590-91-9) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.05",
      "rawHtsCode": "9902.10.05",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 1-(2-methylcyclohexyl)-3-phenylurea (Siduron) (CAS No. 1982-49-6) and inert ingredients (provided for in subheading 3808.93.15)\n\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.06",
      "rawHtsCode": "9902.10.06",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of N-{2,4-dichloro-5-[4-(difluoromethyl)-3-methyl-5-oxo-4,5-dihydro-1H -1,2,4-triazol-1-yl] phenyl} methanesulfonamide (Sulfentrazone) (CAS No. 122836-35-5) and application adjuvants (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.07",
      "rawHtsCode": "9902.10.07",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of sodium-2-chloro-6-[(4,6-dimethoxypyrimidin-2-yl)thio]benzoate (Pyrithiobac-sodium) (CAS No. 123343-16-8) and application adjuvants (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "1.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.08",
      "rawHtsCode": "9902.10.08",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of methyl 2-[[[4-(dimethylamino)-6-(2,2,2-trifluoroethoxy)-1,3,5-triazin-2-yl] carbamoyl] sulfamoyl]-3-methylbenzoate (CAS No. 126535-15-7) and application adjuvants (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.09",
      "rawHtsCode": "9902.10.09",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing N-[(1R,2S)-2,6-dimethyl-2,3-dihydro-1H-inden-1-yl]-6-[(1R)-1-fluoroethyl] -1,3,5-triazine-2,4-diamine (Indazaflam) and application adjuvants (CAS No. 950782-86-2) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "5.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.10",
      "rawHtsCode": "9902.10.10",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing (5-hydroxy-1,3-dimethyl-1H-pyrazol-4-yl)[2-(methylsulfonyl)-4- (trifluoromethyl) phenyl] methanone (Pyrasulfotole) (CAS No. 365400-11-9); 2,4-dibromo-6-cyanophenyl octanoate (Bromoxynil Octanoate) (CAS No. 1689-99-2); methyl 4-{[(3-methoxy-4-methyl-5-oxo-4,5-dihydro -1H-1,2,4-triazol-1-yl) carbonyl] sulfamoyl}-5-methyl-3-thiophenecarboxylate (Thiencarbazone-Methyl) (CAS No. 317815-83-1); and diethyl 1-(2,4-dichlorophenyl)-5-methyl-4,5-dihydro-1H-pyrazole -3,5-dicarboxylate (Mefenpyr-diethyl) (CAS No. 135590-91-9) (provided for in subheading 3808.93.15)",
      "units": [],
      "generalRate": "3.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.11",
      "rawHtsCode": "9902.10.11",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing methyl 4-{[(3-methoxy-4-methyl-5-oxo-4,5-dihydro-1H-1,2,4-triazol-1-yl) carbonyl] sulfamoyl}-5-methyl-3-thiophenecarboxylate (Thiencarbazone-methyl) (CAS No. 317815-83-1); 2-{[(4,6-Dimethoxy-2-pyrimidinyl) carbamoyl] sulfamoyl}-4-formamido-N,N-dimethylbenzamide (Foramsulfuron) (CAS No. 173159-57-4); and methyl 3-chloro-5-{[(4,6-dimethoxy-2-pyrimidinyl) carbamoyl] sulfamoyl}-1-methyl -1H-pyrazole-4-carboxylate (Halosulfuron-methyl) (CAS No. 100784-20-1) and application adjuvants (provided for in subheading 3808.93.15).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.12",
      "rawHtsCode": "9902.10.12",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 1-(4,6-dimethoxypyrimidin-2-yl)-3-[2-dimethylcarbamoyl) phenylsulfamoyl] urea (Orthosulfamuron) (CAS No. 213464-77-8) and application adjuvants (provided for in subheading 3808.93.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.13",
      "rawHtsCode": "9902.10.13",
      "superior": null,
      "indent": "0",
      "description": "(RS)-5-Amino-1-[2,6-dichloro-4-(trifluoromethyl) phenyl]-4-(trifluoromethysulfinyl)-1H-pyrazole-3-carbonitrile (Fipronil) (CAS No. 120068-37-3) (provided for in subheading 3808.93.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.14",
      "rawHtsCode": "9902.10.14",
      "superior": null,
      "indent": "0",
      "description": "(2-Chloroethyl)trimethylammonium chloride (CAS No. 999-81-5) (provided for in subheading 3808.93.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.15",
      "rawHtsCode": "9902.10.15",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of S-(2,3,3-trichloro-2-propen-1-yl) diisopropylcarbamothioate (Triallate) (CAS No. 2303-17-5) (provided for in subheading 3808.93.50) \n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.16",
      "rawHtsCode": "9902.10.16",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of S-(2,3,3-trichloro-2-propen-1-yl) diisopropylcarbamothioate (Triallate) (CAS No. 2303-17-5) and 2,6-dinitro-N,N-dipropyl-4-(trifluoromethyl)aniline (Trifluralin) (CAS No. 1582-09-8) (provided for in subheading 3808.93.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.17",
      "rawHtsCode": "9902.10.17",
      "superior": null,
      "indent": "0",
      "description": "Formulations of 1-(4,6-dimethoxypyrimidin-2-yl)-3-[3-(trifluoromethyl)pyridin-2-yl] sulfonylurea (Flazasulfuron) (CAS No. 104040-78-0) (provided for in subheading 3808.93.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.18",
      "rawHtsCode": "9902.10.18",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of ammonium ethyl carbamoylphosphonate (Fosamine-ammonium) (CAS No. 25954-13-6) and application adjuvants (provided for in subheading 3808.93.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.19",
      "rawHtsCode": "9902.10.19",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing 2-[4-(2-methyl-2-propanyl)phenoxy]cyclohexyl 2-propyn-1-yl sulfite (CAS No. 2312-35-8) (Propargite) and application adjuvants (as provided for in subheading 3808.99.95)\n\n\n ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.20",
      "rawHtsCode": "9902.10.20",
      "superior": null,
      "indent": "0",
      "description": "Preparations containing 5-amino-1,3-dihydro-2H-benzimidazol-2-one (CAS No. 95-23-8) (provided for in subheading 3809.91.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.21",
      "rawHtsCode": "9902.10.21",
      "superior": null,
      "indent": "0",
      "description": "Preparations containing 12-hydroxy-9-octadecenoic acid (Ricinoleic acid) of a kind used as a diluent in lubricants (CAS No. 141-22-0) (provided for in subheading 3811.21.00)",
      "units": [],
      "generalRate": "4.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.22",
      "rawHtsCode": "9902.10.22",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of hydrotreated neutral petroleum oils C20 - C50, of a kind used as viscosity improvers (CAS No. 72623-87-1) (provided for in subheading 3811.21.00).\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.23",
      "rawHtsCode": "9902.10.23",
      "superior": null,
      "indent": "0",
      "description": "Isobutyl 3-(diisobutoxy-thiophosphorylsulfanyl)-2-methyl-propanoate) (CAS No. 268567-32-4) (provided for in subheading 3811.29.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.24",
      "rawHtsCode": "9902.10.24",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing poly(ethylene-co-ethenyl acetate) of a kind used as fuel additives (CAS No. 24937-78-8) (provided for in subheading 3811.90.00)",
      "units": [],
      "generalRate": "0.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.25",
      "rawHtsCode": "9902.10.25",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of tall oil mono-, di-, and triglycerides of a kind used as lubricity improvers (CAS No. 97722-02-6) (provided for in subheading 3811.90.00)",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.26",
      "rawHtsCode": "9902.10.26",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of caprolactam disulfide (CAS No. 23847-08-7) with an elastomer binder of ethylene-propylene-diene monomer and ethyl vinyl acetate, and dispersing agents (provided for in subheading 3812.10.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.27",
      "rawHtsCode": "9902.10.27",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 3-(3,4-dichlorophenyl)-1,1-dimethylurea (CAS No. 330-54-1) with acrylate rubber (provided for in subheading 3812.10.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.28",
      "rawHtsCode": "9902.10.28",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of zinc dicyanato diamine ((T-4)-diamminebis(cyanato-κN)-zinc) (CAS No. 122012-52-6) with an elastomer binder of ethylene-propylene-diene monomer and ethyl vinyl acetate, and dispersing agents (provided for in subheading 3812.10.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.29",
      "rawHtsCode": "9902.10.29",
      "superior": null,
      "indent": "0",
      "description": "Plasticizers containing diphenyl cresyl phosphate (CAS No. 26444-49-5), triphenyl phosphate (CAS No. 115-86-6), tricresyl phosphate (CAS No. 1330-78-5), and phenyl dicresyl phosphate (CAS No. 26446-73-1) (provided for in subheading 3812.20.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.30",
      "rawHtsCode": "9902.10.30",
      "superior": null,
      "indent": "0",
      "description": "Mixture of phenyl esters of C10-C18 alkylsulfonic acids (CAS No. 70775-94-9) (provided for in subheading 3812.20.10)",
      "units": [],
      "generalRate": "3.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.31",
      "rawHtsCode": "9902.10.31",
      "superior": null,
      "indent": "0",
      "description": "Zinc 4-methyl-1H-benzimidazole-2-thiolate (CAS No. 61617-00-3) (provided for in subheading 3812.39.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.32",
      "rawHtsCode": "9902.10.32",
      "superior": null,
      "indent": "0",
      "description": "2,4-Dimethyl-6-(1-methylpentadecyl)phenol (CAS No. 134701-20-5) (provided for in subheading 3812.39.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.33",
      "rawHtsCode": "9902.10.33",
      "superior": null,
      "indent": "0",
      "description": "1,3-Propanediamine, N,N” -1,2-ethanediylbis-, polymer with 2,4,6-trichloro-1,3,5-triazine,reaction products with N-butyl-2,2,6,6-tetramethyl-4-piperidinamine (CAS No. 136504-96-6) (provided for in subheading 3812.39.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.34",
      "rawHtsCode": "9902.10.34",
      "superior": null,
      "indent": "0",
      "description": "Preparations containing tetrakis[2,4-bis(2-methyl-2-propanyl)phenyl] 4,4'-biphenyldiylbis(phosphonite) (CAS No. 119345-01-6) (provided for in subheading 3812.39.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.35",
      "rawHtsCode": "9902.10.35",
      "superior": null,
      "indent": "0",
      "description": "4-Methylphenol - tricyclo[5.2.2.02,6]undecane (1:1) (CAS No. 68610-51-5) (provided for in subheading 3812.39.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.36",
      "rawHtsCode": "9902.10.36",
      "superior": null,
      "indent": "0",
      "description": "1,6-Hexanediamine,N1,N6-bis(2,2,6,6-tetramethyl-4-piperidinyl)-, polymer with 2,4,6-trichloro-1,3,5-triazine, reaction products with 3-bromo-1-propene,N-butyl-1-butanamine and N-butyl-2,2,6,6-tetramethyl-4-piperidinamine, oxidized, hydrogenated (CAS No. 247243-62-5) (provided for in subheading 3812.39.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.37",
      "rawHtsCode": "9902.10.37",
      "superior": null,
      "indent": "0",
      "description": "Magnesium aluminum hydroxide carbonate (synthetic hydrotalcite) (CAS No. 11097-59-9) (provided for in subheading 2842.90.90); and magnesium aluminum hydroxide carbonate (synthetic hydrotalcite) (CAS No. 11097-59-9) coated with stearic acid (CAS No. 57-11-4) (provided for in subheading 3812.39.90) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.38",
      "rawHtsCode": "9902.10.38",
      "superior": null,
      "indent": "0",
      "description": "Potassium methylate solution (CAS No. 865-33-8) (provided for in subheading 3815.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.39",
      "rawHtsCode": "9902.10.39",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of polyethylene glycol (CAS No. 25322-68-3), (acetate) pentammine cobalt dinitrate (CAS No. 14854-63-8), and zinc carbonate (CAS No. 3486-35-9) (provided for in subheading 3815.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.40",
      "rawHtsCode": "9902.10.40",
      "superior": null,
      "indent": "0",
      "description": "Mixture of precipitated silica gel (CAS No. 112926-00-8) and (4-hydroxy-2,2,6,6-tetramethyl-1-piperidinyl)oxidanyl (CAS No. 2226-96-2) of a kind used as polymerization inhibitors (provided for in subheading 3815.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.41",
      "rawHtsCode": "9902.10.41",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of (acetato) pentammine cobalt dinitrate (CAS No. 14854-63-8) with a polymeric or paraffinic carrier (provided for in subheading 3815.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.42",
      "rawHtsCode": "9902.10.42",
      "superior": null,
      "indent": "0",
      "description": "Branched chain C24 mixed alkylbenzenes (CAS No. 68081-77-6) (provided for in subheading 3817.00.15)",
      "units": [],
      "generalRate": "1.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.43",
      "rawHtsCode": "9902.10.43",
      "superior": null,
      "indent": "0",
      "description": "α-Hydro-ω-hydroxypoly(oxy-1,2-ethanediyl)borate (CAS No. 71243-41-9) (provided for in subheading 3819.00.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.44",
      "rawHtsCode": "9902.10.44",
      "superior": null,
      "indent": "0",
      "description": "Monocarboxylic fatty acids derived from palm oil (provided for in subheading 3823.19.20)",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.45",
      "rawHtsCode": "9902.10.45",
      "superior": null,
      "indent": "0",
      "description": "Conjugated linoleic acids ((9Z,11E)-9,11-octadecadienoic acid and (10E,12Z)-10,12-octadecadienoic acid) (CAS Nos. 2540-56-9 and 2420-56-6) (provided for in subheading 3823.19.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.46",
      "rawHtsCode": "9902.10.46",
      "superior": null,
      "indent": "0",
      "description": "Lauryl-cetyl alcohol (alcohol, C12-C16) (CAS No. 68855-56-1) (provided for in subheading 3823.70.40)",
      "units": [],
      "generalRate": "0.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.47",
      "rawHtsCode": "9902.10.47",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of barium carbonate (CAS No. 513-77-9), strontium carbonate (CAS No. 1633-05-2), calcium carbonate (CAS No. 471-34-1), and 1-methoxy-2-propanyl acetate (CAS No. 108-65-6), of a kind for use as emitter suspension cathode coating (provided for in subheading 3824.90.92) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1.",
        "Subheading 3824.90.92 was deleted from the tariff schedule; subheading 3824.99.92 likely covers the product named in this heading. Consult U.S. Customs and Border Protection concerning the use of this duty suspension provision."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.48",
      "rawHtsCode": "9902.10.48",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing 88 percent or more by weight of poly[oxy(dimethylsilanediyl)] bis[omega-butoxypoly(oxypropylene)] ether (CAS No. 67762-96-3), 8 percent or less by weight α-butyl-ω-hydroxylpoly(oxypropylene) (CAS No. 9003-13-8) and less than 4 percent by weight silica dimethylsilylate (CAS No. 68611-44-9) (provided for in subheading 3824.90.92) ",
      "units": [],
      "generalRate": "0.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1.",
        "Subheading 3824.90.92 was deleted from the tariff schedule; subheading 3824.99.92 likely covers the product named in this heading. Consult U.S. Customs and Border Protection concerning the use of this duty reduction provision."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.49",
      "rawHtsCode": "9902.10.49",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 2-amino-2,3-dimethylbutanenitrile (CAS No. 13893-53-3) and toluene (provided for in subheading 3824.99.28)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.50",
      "rawHtsCode": "9902.10.50",
      "superior": null,
      "indent": "0",
      "description": "Preparations based on N-(2-ethoxyphenyl)-N'-[4-(10-methylundecyl)phenyl] ethanediamide (CAS No. 82493-14-9) (provided for in subheading 3824.99.28) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.52",
      "rawHtsCode": "9902.10.52",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of polymers based on tall oil fatty acids, phthalic anhydride, glycerin and rosin (CAS No. 68015-39-4); poly(isobutyl vinyl ether) (CAS No. 9003-44-5); zinc 2-ethylhexanoate (CAS No. 136-53-8); and more than 50 percent by weight of a hydrocarbon-based solvent (provided for in subheading 3208.10.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.53",
      "rawHtsCode": "9902.10.53",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of methyl esters of C16-C18 and C18 unsaturated fatty acids (CAS No. 67762-38-3) and methyl hexadecanoate (Methyl Palmitate) (CAS No. 112-39-0) (provided for in subheading 3824.99.41) derived from coconut, palm-kernel or palm oil, used other than as a fuel",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.54",
      "rawHtsCode": "9902.10.54",
      "superior": null,
      "indent": "0",
      "description": "N-Propylphosphorothioic triamide (CAS No. 916809-14-8) (provided for in subheading 3824.99.92)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.55",
      "rawHtsCode": "9902.10.55",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of sodium salts of iminodisuccinic acid (CAS No. 144538-83-0), whether or not in water (provided for in subheading 3824.99.92)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.56",
      "rawHtsCode": "9902.10.56",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of N,N'-1,2-ethanediylbis(N-acetylacetamide) with organic binders (CAS No. 10543-57-4) (provided for in subheading 3824.99.92)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.57",
      "rawHtsCode": "9902.10.57",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of C5-C18 perfluorocarbon alkanes, perfluorocarbon amines, and/or perfluorocarbon ethers (CAS No. 86508-42-1) (provided for in subheading 3824.99.92)  ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.58",
      "rawHtsCode": "9902.10.58",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 2-methyl-N-[2-(2-oxoimidazolidin-1-yl)ethyl]prop-2-enamide (CAS No. 3089-19-8), 2-methylprop-2-enoic acid (CAS No. 79-41-4), 1-(2-aminoethyl)imidazolidin-2-one (CAS No. 6281-42-1) and benzene-1,4-diol (CAS No. 123-31-9) (provided for in subheading 3824.99.92)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.59",
      "rawHtsCode": "9902.10.59",
      "superior": null,
      "indent": "0",
      "description": "Amorphous synthetic silica gel, silanized (CAS No. \t112926-00-8) (provided for in subheading 3824.99.92)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.60",
      "rawHtsCode": "9902.10.60",
      "superior": null,
      "indent": "0",
      "description": "Sodium ethylate (sodium ethanolate) (CAS No. 141-52-6), solution in ethanol (CAS No. 64-17-5) (provided for in subheading 3824.99.92)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.61",
      "rawHtsCode": "9902.10.61",
      "superior": null,
      "indent": "0",
      "description": "Siloxanes and silicones, di-Me, polymers with Me silsesquioxanes and polypropylene glycol mono-Bu ether (CAS No. 68554-65-4), greater than 70 percent by weight, with less than 8 percent percent by weight siloxanes and silicones, di-Me, polymers with Me silsesquioxanes and polyethylene-polypropylene glycol mono-Bu ether, less than 8 percent by weight poly(oxy(methyl-1,2-ethanediyl)), α-butyl-ω hydroxyl (CAS No. 9003-13-8), less than 2 percent by weight oxirane, methyl-, polymer with oxirane, monobutylether (CAS No. 9038-95-3), less than 8 percent by weight silanamine, 1,1,1, trimethyl (CAS No. 68909-20-6) and less than 1 percent by weight silicon dioxide (CAS No. 7631-86-9) (provided for in subheading 3824.99.92)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.62",
      "rawHtsCode": "9902.10.62",
      "superior": null,
      "indent": "0",
      "description": "1-O-Stearoyl-β-D-fructofuranosyl α-D-glucopyranoside (Sucrose stearate) (CAS No. 25168-73-4) (provided for in subheading 3824.99.92)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.63",
      "rawHtsCode": "9902.10.63",
      "superior": null,
      "indent": "0",
      "description": "Acid washed beta zeolite powder composed of mixtures of aluminum, silicon and sodium oxides, tetraethylammonium-hydroxide, and organic compounds (CAS No. 1318-02-1) (provided for in subheading 3824.99.92)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.64",
      "rawHtsCode": "9902.10.64",
      "superior": null,
      "indent": "0",
      "description": "2-Propenoic acid, C12-C14-alkyl esters, telomers with ethylene, 2-ethylhexyl acrylate, propanal and vinyl acetate (CAS No. 923958-45-6) (provided for in subheading 3901.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.65",
      "rawHtsCode": "9902.10.65",
      "superior": null,
      "indent": "0",
      "description": "Polypropylene in pellet form, containing 18 percent or more but not over 22 percent by weight of mineral filler (talc) (CAS No. 9003-07-0) (provided for in subheading 3902.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.66",
      "rawHtsCode": "9902.10.66",
      "superior": null,
      "indent": "0",
      "description": "Poly(isobutylene) hydroformylation products, reaction products with ammonia (CAS No. 337367-30-3) (provided for in subheading 3902.20.50)",
      "units": [],
      "generalRate": "5.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.67",
      "rawHtsCode": "9902.10.67",
      "superior": null,
      "indent": "0",
      "description": "Poly(2-methylpropene) (polyisobutylene), other than elastomeric (CAS No. 9003-27-4) (provided for in subheading 3902.20.50)",
      "units": [],
      "generalRate": "5.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.68",
      "rawHtsCode": "9902.10.68",
      "superior": null,
      "indent": "0",
      "description": "Poly(propylene-co-ethylene) (CAS No. 9010-79-1) (provided for in subheading 3902.30.00)",
      "units": [],
      "generalRate": "5.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.69",
      "rawHtsCode": "9902.10.69",
      "superior": null,
      "indent": "0",
      "description": "Silane, ethenyltrimethoxy-, reaction products with 1-butene-ethylene-propene polymer (CAS No. 832150-35-3) (provided for in subheading 3902.30.00)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.70",
      "rawHtsCode": "9902.10.70",
      "superior": null,
      "indent": "0",
      "description": "Poly(propylene-co-1-butene-co-ethylene) (CAS No. 25895-47-0) (provided for in subheading 3902.30.00) \n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.71",
      "rawHtsCode": "9902.10.71",
      "superior": null,
      "indent": "0",
      "description": "C12-C18 alkenes, polymers with 4-methyl-1-pentene (CAS Nos. 25155-83-3, 81229-87-0 and 103908-22-1) (provided for in subheading 3902.90.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.72",
      "rawHtsCode": "9902.10.72",
      "superior": null,
      "indent": "0",
      "description": "alpha-Alkenes (C20 -C24) maleic anhydride-4-amino-2,2,6,6-tetramethylpiperidine, polymer (CAS No. 152261-33-1) (provided for in subheading 3902.90.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.73",
      "rawHtsCode": "9902.10.73",
      "superior": null,
      "indent": "0",
      "description": "Oligomeric poly(butadiene) (CAS No. 68441-52-1) (provided for in subheading 3902.90.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.75",
      "rawHtsCode": "9902.10.75",
      "superior": null,
      "indent": "0",
      "description": "Poly(vinyl acetate-co-vinyl chloride) (CAS No. 9003-22-9) (provided for in subheading 3904.30.60) \n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.76",
      "rawHtsCode": "9902.10.76",
      "superior": null,
      "indent": "0",
      "description": "Poly(fumaric acid-co-vinyl acetate-co-vinyl chloride) (CAS No. 32650-26-3) (provided for in subheading 3904.30.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.77",
      "rawHtsCode": "9902.10.77",
      "superior": null,
      "indent": "0",
      "description": "Poly(dibutyl (2Z)-2-butenedioate-co-vinyl chloride-co-2-hydroxypropyl acrylate) (CAS No. 114653-42-8) (provided for in subheading 3904.40.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.78",
      "rawHtsCode": "9902.10.78",
      "superior": null,
      "indent": "0",
      "description": "Poly(vinyl chloride-co-hydroxypropyl acrylate) (CAS No. 53710-52-4) (provided for in subheading 3904.40.00) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.79",
      "rawHtsCode": "9902.10.79",
      "superior": null,
      "indent": "0",
      "description": "Poly(1,1,2,2-tetrafluoro-2-[(trifluoroethenyl)oxy]ethanesulfonyl fluoride-co-tetrafluoroethylene) (CAS No. 1163733-25-2) (provided for in subheading 3904.69.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.80",
      "rawHtsCode": "9902.10.80",
      "superior": null,
      "indent": "0",
      "description": "Poly(1,1,2,2-tetrafluoro-2-[(trifluoroethenyl)oxy]ethanesulfonyl fluoride-co-tetrafluoroethylene) SO2F form (CAS No. 69462-70-0) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.81",
      "rawHtsCode": "9902.10.81",
      "superior": null,
      "indent": "0",
      "description": "Poly(1,1,2,2-tetrafluoro-2-[(trifluoroethenyl)oxy]ethanesulfonyl fluoride-co-tetrafluoroethylene) lithium salt (CAS No. 1687740-67-5) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.82",
      "rawHtsCode": "9902.10.82",
      "superior": null,
      "indent": "0",
      "description": "Poly(1,1,2,2-tetrafluoro-2-[(trifluoroethenyl)oxy]ethanesulfonyl fluoride-co-tetrafluoroethylene) ammonium salt (CAS No. 1126091-34-6) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.83",
      "rawHtsCode": "9902.10.83",
      "superior": null,
      "indent": "0",
      "description": "1,1,2-Trifluoroethene - 1,1-difluoroethene (1:1) (Vinylidene fluoride-trifluoroethylene copolymer) (CAS No. 28960-88-5) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.84",
      "rawHtsCode": "9902.10.84",
      "superior": null,
      "indent": "0",
      "description": "Poly(1,1-difluoroethene-co-1-chloro-1,2,2-trifluoroethene-co -1,1,2-trifluoroethene) (CAS No. 81197-12-8) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.85",
      "rawHtsCode": "9902.10.85",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of approximately 25 percent propanoic acid, 3-hydroxy-2-(hydroxymethyl)-2, methyl polymers with 5-isocyanato-1-(isocyanatomethyl)-1,3,3-trimethylcyclohexane and reduced methyl esters of reduced polymerized, oxidized tetrafluoroethylene, compounds with trimethylamine (CAS No. 328389-91-9), less than 1 percent 2-propanol (CAS No. 67-63-0) and less than 1 percent 2-butanone (CAS No. 78-93-3), remaining content water (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.86",
      "rawHtsCode": "9902.10.86",
      "superior": null,
      "indent": "0",
      "description": "Perfluoropolymethylisopropyl ether having a boiling point above 170 degrees Celsius (CAS No. 69991-67-9) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.87",
      "rawHtsCode": "9902.10.87",
      "superior": null,
      "indent": "0",
      "description": "Mixture of poly(1-[difluoro(trifluoromethoxy)methoxy]-1,1,2,2-tetrafluoro -2-(trifluoromethoxy)ethane) (CAS No. 69991-61-3) and Perfluoropolymethylisopropyl ether (CAS No. 69991-67-9) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.88",
      "rawHtsCode": "9902.10.88",
      "superior": null,
      "indent": "0",
      "description": "1,1,2,2 Tetrafluoroethene, oxidized, polymerized (CAS No. 69991-61-3) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.89",
      "rawHtsCode": "9902.10.89",
      "superior": null,
      "indent": "0",
      "description": "Ethene, 1,1,2,2-tetrafluoro-, oxidized, polymerized, reduced, ethyl esters, reduced, N-[2-[(2-methyl-1-oxo-2-propen-1-yl) oxy] ethyl] carbamates (CAS No. 1385773-87-4) (provided for in subheading 3904.69.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.90",
      "rawHtsCode": "9902.10.90",
      "superior": null,
      "indent": "0",
      "description": "1-Propene, 1,1,2,3,3,3-Hexafluoro-, oxidzed, polymd., reduced, hydrolized reaction products with ammonia (CAS No. 370097-12-4) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.91",
      "rawHtsCode": "9902.10.91",
      "superior": null,
      "indent": "0",
      "description": "1-Propene, 1,1,2,3,3,3-hexafluoro-, oxidized, polymerized, reduced, hydrolyzed (CAS No. 161075-14-5) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.92",
      "rawHtsCode": "9902.10.92",
      "superior": null,
      "indent": "0",
      "description": "Ethene, 1,1,2,2-tetrafluoro-, oxidized, polymerized, reduced, methyl esters, reduced, 2,3-dihydroxypropyl ethers (CAS No. 925918-64-5) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.93",
      "rawHtsCode": "9902.10.93",
      "superior": null,
      "indent": "0",
      "description": "Polyperfluoroethoxymethoxydifluoroethyl polyethylene glycol ether (CAS No. 88645-29-8) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "2.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.94",
      "rawHtsCode": "9902.10.94",
      "superior": null,
      "indent": "0",
      "description": "Methoxycarbonyl-terminated perfluorinated polyoxymethylene-polyoxyethylene (CAS No. 107852-49-3) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.95",
      "rawHtsCode": "9902.10.95",
      "superior": null,
      "indent": "0",
      "description": "Ethene, tetrafluoro, oxidized, polymerized, reduced, methyl esters, reduced, ethoxylated (CAS No. 162492-15-1) (provided for in subheading 3904.69.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.96",
      "rawHtsCode": "9902.10.96",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of 95 percent perfluoropolyether polyethoxy alcohol (CAS No. 1260733-08-1) and 5 percent 2,2'-[oxybis(2,1-ethanediyloxy)]diethanol (Tetraethylene glycol) (CAS No. 112-60-7) (provided for in subheading 3904.69.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.97",
      "rawHtsCode": "9902.10.97",
      "superior": null,
      "indent": "0",
      "description": "1-Propamine, 3-(triethoxysilyl)-, reaction products with Etesters of reduced polymd. oxidized poly(tetrafluoroethylene) (CAS No. 223557-70-8) (provided for in subheading 3904.69.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.98",
      "rawHtsCode": "9902.10.98",
      "superior": null,
      "indent": "0",
      "description": "Poly(vinyl acetate), of a kind used in food preparations (CAS No. 9003-20-7) (provided for in subheading 3905.19.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.10.99",
      "rawHtsCode": "9902.10.99",
      "superior": null,
      "indent": "0",
      "description": "Poly(vinyl acetate-co-crotonic acid) (CAS No. 25609-89-6) (provided for in subheading 3905.19.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.01",
      "rawHtsCode": "9902.11.01",
      "superior": null,
      "indent": "0",
      "description": "Ethylene-vinyl acetate copolymers (other than those in aqueous dispersions), containing 50 percent or more by weight of vinyl acetate monomer (CAS No. 24937-78-8) (provided for in subheading 3905.29.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.02",
      "rawHtsCode": "9902.11.02",
      "superior": null,
      "indent": "0",
      "description": "Polyvinyl formal resin (ethenol; [(ethenyloxy)methoxy]ethene (CAS Nos. 63450-15-7, 63148-64-1, and 9003-33-2) (provided for in subheading 3905.91.10) \n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.03",
      "rawHtsCode": "9902.11.03",
      "superior": null,
      "indent": "0",
      "description": "Aqueous mixtures of poly(vinyl alcohol) (CAS No. 110532-37-1) and poly(vinylpyrrolidone) (CAS No. 9003-39-8) (provided for in subheading 3905.99.80) \n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.04",
      "rawHtsCode": "9902.11.04",
      "superior": null,
      "indent": "0",
      "description": "Poly(acrylic acid-co-(sodium 2-(acryloylamino)-2-methyl-1-propanesulfonate) sodium salt) (CAS No. 136903-34-9) in granulated form (provided for in subheading 3906.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.05",
      "rawHtsCode": "9902.11.05",
      "superior": null,
      "indent": "0",
      "description": "Poly(ammonium acryloyldimethyl taurate-co-vinyl pyrrolidone) (CAS No. 335383-60-3) (provided for in subheading 3906.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.06",
      "rawHtsCode": "9902.11.06",
      "superior": null,
      "indent": "0",
      "description": "Poly(acrylamide-co-sodium polyacrylate) (CAS No. 25085-02-3) (provided for in subheading 3906.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.07",
      "rawHtsCode": "9902.11.07",
      "superior": null,
      "indent": "0",
      "description": "Poly(butyl methacrylate-co-(2-dimethylaminoethyl) methacrylate-co-methyl methacrylate) 1:2:1 (CAS No. 24938-16-7) (provided for in subheading 3906.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.08",
      "rawHtsCode": "9902.11.08",
      "superior": null,
      "indent": "0",
      "description": "Poly(ethyl acrylate-co-methyl methacrylate-co-trimethylammonioethyl methacrylate chloride) (CAS No. 33434-24-1) (provided for in subheading 3906.90.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.09",
      "rawHtsCode": "9902.11.09",
      "superior": null,
      "indent": "0",
      "description": "Poly(methacrylic acid-co-methyl methacrylate) (CAS No. 25086-15-1) (provided for in subheading 3906.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.10",
      "rawHtsCode": "9902.11.10",
      "superior": null,
      "indent": "0",
      "description": "Poly(methyl acrylate-co-methyl methacrylate-co-methacrylic acid) 7:3:1 (CAS No. 26936-24-3) (provided for in subheading 3906.90.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.11",
      "rawHtsCode": "9902.11.11",
      "superior": null,
      "indent": "0",
      "description": "Starch-g-poly (propenamide-co-2-propenoic acid) potassium salt (CAS No. 863132-14-3) (Zeba) (provided for in subheading 3906.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.12",
      "rawHtsCode": "9902.11.12",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of α-(3-(3-(2H-benzotriazol-2-yl)-5-(1,1-dimethylethyl)-4-hydroxyphenyl) -1-oxopropyl)-ω-hydroxy-poly (oxy-1,2-ethanediyl) (CAS No. 104810-48-2); α-(3-(3-(2H-benzotriazol-2-yl)-5-(1,1-dimethylethyl)-4-hydroxyphenyl) -1-oxopropyl)-ω- (3-(3-(2H-benzotriazol-2-yl) -5-(1,1-dimethylethyl) -4-hydroxyphenyl) -1-oxopropoxy)-poly (oxy-1,2-ethanediyl) (CAS No. 104810-47-1); and polyethylene glycol (CAS No. 25322-68-3) (provided for in subheading 3907.20.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.13",
      "rawHtsCode": "9902.11.13",
      "superior": null,
      "indent": "0",
      "description": " Oxirane, 2-methyl-, polymer with oxirane, monoether with 1,2-propanediol mono(2-methyl-2-propenoate) (CAS No. 220846-90-2) (provided for in subheading 3907.20.00)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.14",
      "rawHtsCode": "9902.11.14",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of approximately 20 percent or less diphosphoric acid, polymers with ethoxylated reduced methyl esters of reduced polymerized oxidized tetrafluoroethylene (CAS No. 200013-65-6) and less than 10 percent 2-(2-methoxypropoxy)-1-propanol (CAS No. 34590-94-8), remaining content is water (provided for in subheading 3907.20.00)",
      "units": [],
      "generalRate": "0.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.15",
      "rawHtsCode": "9902.11.15",
      "superior": null,
      "indent": "0",
      "description": "Heat-curable epoxy resin mixture containing more than 30 percent by weight of 4,4'-(9H-fluorene-9,9-diyl)bis(2-chloroaniline) (CAS No. 107934-68-9) as a curing agent (provided for in subheading 3907.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.16",
      "rawHtsCode": "9902.11.16",
      "superior": null,
      "indent": "0",
      "description": "Mixtures of ethanaminium, 2-hydroxy-N-(2-hydroxyethyl)-N,N-dimethyl-, methyl sulfate (1:1), polymer with 2-(chloromethyl)oxirane, 1,3-diisocyanatomethylbenzene, a-hydro-w-hydroxypoly[oxy(methyl-1,2-ethanediyl)] and 1,2,3-propanetriol (CAS No. 82294-81-3); Phenol, 4,4'-(1-methylethylidene)bis-, polymer with 2-(chloromethyl)oxirane (CAS No. 25068-38-6); and Formamide, N,N-dimethyl-(CAS No. 68-12-2) (provided for in subheading 3907.30.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.17",
      "rawHtsCode": "9902.11.17",
      "superior": null,
      "indent": "0",
      "description": "1,2-Bis-O-(2-oxiranylmethyl)-D-glucitol (CAS No. 68412-01-1) (provided for in subheading 3907.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.18",
      "rawHtsCode": "9902.11.18",
      "superior": null,
      "indent": "0",
      "description": "Sulfonated polyethylene terephthalate (CAS No. 63534-56-5) (provided for in subheading 3907.60.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1.",
        "Subheading 3907.60.00 was deleted from the tariff schedule; the product named in the heading may be classifiable in subheading 3907.61.00 or 3907.69.00. Consult U.S. Customs and Border Protection relating to the use of this duty suspension provision."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.19",
      "rawHtsCode": "9902.11.19",
      "superior": null,
      "indent": "0",
      "description": "Poly(dimethyl carbonate-co-1,6-hexanediol) (CAS No. 101325-00-2) (provided for in subheading 3907.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.20",
      "rawHtsCode": "9902.11.20",
      "superior": null,
      "indent": "0",
      "description": "Dimethyl carbonate polymer with 1,6-hexanediol copolymer and 2-oxepanone (CAS No. 282534-15-0) (provided for in subheading 3907.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.21",
      "rawHtsCode": "9902.11.21",
      "superior": null,
      "indent": "0",
      "description": "Poly[(dimethyl butanedioate-co-1-(2-hydroxyethyl)-2,2,6,6-tetramethylpiperidin-4-ol)] (CAS No. 65447-77-0) (provided for in subheading 3907.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.23",
      "rawHtsCode": "9902.11.23",
      "superior": null,
      "indent": "0",
      "description": "Polymer of 1,4-benzenedicarboxylic acid with 1,4-butanediol and hexanedioic acid (CAS No. 60961-73-1) (provided for in subheading 3907.99.50) \n",
      "units": [],
      "generalRate": "1.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.24",
      "rawHtsCode": "9902.11.24",
      "superior": null,
      "indent": "0",
      "description": "1,4-Benzenedicarboxylic acid, polymer with 1,4 butanediol and decanedioc acid (CAS No. 28205-74-5) (provided for in subheading 3907.99.50)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.26",
      "rawHtsCode": "9902.11.26",
      "superior": null,
      "indent": "0",
      "description": "1,4-Benzenedicarboxylic acid, polymer with 1,4-butanediol, hexanedioic acid and nonanedioic acid (CAS No. 83064-08-8) (provided for in subheading 3907.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.27",
      "rawHtsCode": "9902.11.27",
      "superior": null,
      "indent": "0",
      "description": "1,4-Benzenedicarboxylic acid, polymer with 1,4-butanediol, decanedioic acid and hexanedioic acid (CAS No.109586-86-9) (provided for in subheading 3907.99.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.28",
      "rawHtsCode": "9902.11.28",
      "superior": null,
      "indent": "0",
      "description": " 1,2-Benzenedicarboxylic acid, 3,4,5,6-tetrabromo-, polymer with 2-ethyl-2-(hydroxymethyl)-1,3-propanediol, hexanedioic acid, 2,2-((1-methylethylidene)bis(4,1-phenyleneoxymethylene)) bis(oxirane) and 1,2-propanediol in toluene (CAS No. 68568-64-9) (provided for in subheading 3907.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.29",
      "rawHtsCode": "9902.11.29",
      "superior": null,
      "indent": "0",
      "description": "Poly(1,4-benzenedicarboxylic acid-co-1,4-butanediol-co-nonanedioic acid) (CAS No. 26590-80-7) (provided for in subheading 3907.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.30",
      "rawHtsCode": "9902.11.30",
      "superior": null,
      "indent": "0",
      "description": "Dodecanedioic acid, polymer with 4,4ʹ-methylenebis(2- methylcyclohexanamine) (CAS No. 163800-66-6) (provided for in subheading 3908.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.31",
      "rawHtsCode": "9902.11.31",
      "superior": null,
      "indent": "0",
      "description": "Micro-porous, ultrafine, spherical polyamide powders of polyamide 6 (CAS No. 356040-79-4), polyamide-12 (CAS No. 338462-62-7) and polyamide 6, 12 (CAS No. 356040-89-6) (provided for in subheading 3908.10.00 or 3908.90.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.32",
      "rawHtsCode": "9902.11.32",
      "superior": null,
      "indent": "0",
      "description": "Poly{(azacyclotridecan-2-one)-co-(1,3-benzenedicarboxylic acid; 1,4-benzenedicarboxylic acid)-alt-(1,6-hexanediamine; 4,4'-methylenebis[cyclohexanamine]; 4,4'-methylenebis[2-methylcyclohexanamine])} (CAS No. 1030611-14-3) (provided for in subheading 3908.90.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.33",
      "rawHtsCode": "9902.11.33",
      "superior": null,
      "indent": "0",
      "description": "Poly{(azacyclotridecan-2-one)-co-(1,3-benzenedicarboxylic acid; 1,4-benzenedicarboxylic acid)-alt-(4,4'-methylenebis[2-methylcyclohexanamine])} (CAS No. 62694-40-0) (provided for in subheading 3908.90.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.34",
      "rawHtsCode": "9902.11.34",
      "superior": null,
      "indent": "0",
      "description": "Mixtures containing 40 to 60 percent by weight formaldehyde polymers with aniline (CAS No. 25214-70-4) and 60 to 40 percent by weight 4,4'-methylendianiline (CAS No. 101-77-9) (provided for in subheading 3909.39.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.35",
      "rawHtsCode": "9902.11.35",
      "superior": null,
      "indent": "0",
      "description": "Poly(phenol-co-formaldehyde-co-4-(1,1-dimethylethyl)phenol) (CAS No. 28453-20-5) (provided for in subheading 3909.40.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.36",
      "rawHtsCode": "9902.11.36",
      "superior": null,
      "indent": "0",
      "description": "4-tert-Butylphenol; formaldehyde; 4-[2-(4-hydroxyphenyl)propyl]phenol (CAS No. 54579-44-1) (provided for in subheading 3909.40.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.37",
      "rawHtsCode": "9902.11.37",
      "superior": null,
      "indent": "0",
      "description": "Mixture of polymers of formaldehyde-1,3-benzenediol (1:1) (CAS No. 24969-11-7) and unreacted 1,3-Benzenediol (CAS No. 108-46-3) (provided for in subheading 3909.40.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.38",
      "rawHtsCode": "9902.11.38",
      "superior": null,
      "indent": "0",
      "description": "2-Oxepanone polymer with 1,4-butanediol and 5- isocyanato-1-(isocyanatomethyl)-1,3,3- trimethylcyclohexane, 2-ethyl-1-hexanol-blocked (CAS No. 189020-69-7) (provided for in subheading 3909.50.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.39",
      "rawHtsCode": "9902.11.39",
      "superior": null,
      "indent": "0",
      "description": "Hexanedioic acid, dihydrazide, polymer with 5-amino-1,3,3-trimethylcyclohexanemethanamine, 1,3-butanediol and 1,1'-methylenebis[4-isocyanatocyclohexane], methyl ethyl ketone oxime- and polyethylene glycol mono-methyl ether-blocked in aqueous solution (CAS No. 200295-51-8) (provided for in subheading 3909.50.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.40",
      "rawHtsCode": "9902.11.40",
      "superior": null,
      "indent": "0",
      "description": "Oxirane, 2-methyl-, polymer with oxirane, ether with 1,2,3-propanetriol (3:1), polymer with 2,4-diisocyanato-1-methylbenzene and α-hydro-ω-hydroxypoly[oxy(methyl-1,2-ethanediyl)] ether with 2-ethyl-2-(hydroxymethyl)-1,3-propanediol (3:1), caprolactam-blocked (CAS No. 936346-53-1) (provided for in subheading 3909.50.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.41",
      "rawHtsCode": "9902.11.41",
      "superior": null,
      "indent": "0",
      "description": "1,3 Benzenedicarboxylic acid, polymer with 2-ethyl-2-(hydroxymethyl)-1,3-propanediol, hexanedioic acid, 1,6-hexanediol, 1,3-isobenzofurandione and 1,1'-methylenebis[4-isocyanatobenzene], di-ethyl malonate-blocked (CAS No. 200414-59-1) (provided for in subheading 3909.50.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.42",
      "rawHtsCode": "9902.11.42",
      "superior": null,
      "indent": "0",
      "description": "Poly[oxy(methyl-1,2-ethanediyl)],α-hydro-ω-hydroxy- and 5- isocyanato-1-(isocyanatomethyl)-1,3,3- trimethylcyclohexane (Isophorone diisocyanate) (CAS No. 1012318-97-6) (provided for in 3909.50.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.43",
      "rawHtsCode": "9902.11.43",
      "superior": null,
      "indent": "0",
      "description": "1,4:5,8-Dimethanonaphthalene, 2-ethylidene-1,2,3,4,4a,5,8,8a-octahydro-, polymer with 3a,4,7,7a-tetrahydro-4,7-methano-1H-indene, hydrogenated (CAS No. 881025-72-5), presented in pellet form (provided for in subheading 3911.90.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.44",
      "rawHtsCode": "9902.11.44",
      "superior": null,
      "indent": "0",
      "description": "Polyethylenimine (CAS No. 9002-98-6), refrigerated, in containers not holding over 1 L (provided for in subheading 3911.90.25)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.45",
      "rawHtsCode": "9902.11.45",
      "superior": null,
      "indent": "0",
      "description": "Polyethylenimine (CAS No. 9002-98-6), of a kind used as a component for further manufacturing into a finished medical device (provided for in subheading 3911.90.25) \n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.46",
      "rawHtsCode": "9902.11.46",
      "superior": null,
      "indent": "0",
      "description": "1,6-diisocyanatohexane; 2,4-diisocyanato-1-methylbenzene polymer (CAS No. 26426-91-5) in n-butyl acetate (provided for in subheading 3911.90.45)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.47",
      "rawHtsCode": "9902.11.47",
      "superior": null,
      "indent": "0",
      "description": "Poly(toluene diisocyanate) (CAS No. 26006-20-2) (provided for in subheading 3911.90.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.48",
      "rawHtsCode": "9902.11.48",
      "superior": null,
      "indent": "0",
      "description": "Water-dispersible polyisocyanate products based on poly(hexamethylene diisocyanate) (CAS No. 28182-81-2) and dimethyldicyclohexylamine compounds with 3-(cyclohexylamino)-1-propanesulfonic acid-poly(1,6-diisocyanatohexane) (CAS No. 666723-27-9) (provided for in subheading 3911.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.49",
      "rawHtsCode": "9902.11.49",
      "superior": null,
      "indent": "0",
      "description": "Poly(1,6-diisocyanatohexane)-block-polyethylene-block-poly (1-butoxypropan-2-ol) (CAS no. 125252-47-3) (provided for in subheading 3911.90.90) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.50",
      "rawHtsCode": "9902.11.50",
      "superior": null,
      "indent": "0",
      "description": "N,N',N''-[(2,4,6-Trioxo-1,3,5-triazine-1,3,5(2H,4H,6H)-triyl) tris [methylene(3,5,5-trimethyl-3,1-cyclohexanediyl)]] tris [hexahydro-2-oxo-1H-azepine-1-carboxamide] (CAS No. 68975-83-7) in organic solvent (provided for in subheading 3911.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.51",
      "rawHtsCode": "9902.11.51",
      "superior": null,
      "indent": "0",
      "description": "3,5-Dimethyl-1H-pyrazole-oligo(hexamethylene diisocyanate) in solvents (CAS No. 163206-31-3) (provided for in subheading 3911.90.90).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.52",
      "rawHtsCode": "9902.11.52",
      "superior": null,
      "indent": "0",
      "description": "α-Alkenes, C14-C20, polymers with maleic anhydride, 2-(1-piperazinyl) ethylimides, plasticized with diisononyl phthalate (CAS No. 28553-12-0) and bis(1-methylethyl)-naphthalene (CAS No. 38640-62-9) (provided for in subheading 3911.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.53",
      "rawHtsCode": "9902.11.53",
      "superior": null,
      "indent": "0",
      "description": "2,4-Diisocyanato-1-methylbenzene; 5-(1,3-dioxo-2-benzofuran-5-carbonyl)-2-benzofuran-1,3-dione; 1-isocyanato-4-[(4-isocyanatophenyl)methyl]benzene (CAS No. 58698-66-1) (provided for in subheading 3911.90.90) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.54",
      "rawHtsCode": "9902.11.54",
      "superior": null,
      "indent": "0",
      "description": "Poly(ethylene-ran-(2-norbornene)) (CAS No. 26007-43-2), comprising 64 (plus or minus 3) percent by weight ethylene (CAS No. 74-85-1), having a glass transition temperature of 78 (plus or minus 4) °C, and containing not less than 3 percent by weight polyethylene (CAS No. 9002-88-4) (provided for in subheading 3911.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.55",
      "rawHtsCode": "9902.11.55",
      "superior": null,
      "indent": "0",
      "description": "1,6-Hexanediamine, N,N'-bis(2,2,6,6-tetramethyl-4-piperidinyl)-polymer with 2,4,6-trichloro-1,3,5-triazine, reaction products with N-butyl-1-butanamine and N-buty-2,2,6,6-tetramethyl-4-piperidinamine (CAS No. 192268-64-7)(provided for in subheading 3911.90.90)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.56",
      "rawHtsCode": "9902.11.56",
      "superior": null,
      "indent": "0",
      "description": "Poly(divinylbenzene-co-ethylstyrene) (CAS No. 9043-77-0) (provided for in subheading 3911.90.90) \n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.57",
      "rawHtsCode": "9902.11.57",
      "superior": null,
      "indent": "0",
      "description": "Industrial grade nitrocellulose, having a nitrogen content of less than 12.4 percent on a dry weight basis, damped with an alcohol content of 28 to 32 percent by weight (CAS No. 9004-70-0), presented in fiber drums each containing 85 kg, 100 kg, 110 kg or 120 kg of such nitrocellulose, certified by the importer as made from at least 50 percent cotton linter or wood pulp and as having each such drum lined with an antistatic plastic bag and equipped with a coupling for mechanical unloading (provided for in subheading 3912.20.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.58",
      "rawHtsCode": "9902.11.58",
      "superior": null,
      "indent": "0",
      "description": "Industrial grade nitrocellulose, having a nitrogen content of less than 12.4 percent on a dry weight basis, damped with an alcohol content of 33 to 37 percent by weight (CAS No. 9004-70-0), presented in fiber drums each containing 85 kg, 100 kg, 110 kg or 120 kg of such nitrocellulose, the foregoing certified by the importer as made from at least 80 percent cotton linters, wood pulp and ethanol, with such fiber drums each lined with an antistatic plastic bag and equipped with a coupling for mechanical unloading (provided for in subheading 3912.20.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.59",
      "rawHtsCode": "9902.11.59",
      "superior": null,
      "indent": "0",
      "description": "Sodium alginate (CAS No. 9005-38-3) (provided for in subheading 3913.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.60",
      "rawHtsCode": "9902.11.60",
      "superior": null,
      "indent": "0",
      "description": "Propylene glycol alginates (CAS No. 9005-37-2) (provided for in subheading 3913.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.61",
      "rawHtsCode": "9902.11.61",
      "superior": null,
      "indent": "0",
      "description": "Alginic acid (CAS No. 9005-32-7), ammonium alginate (CAS No. 9005-34-9), potassium alginate (CAS No. 9005-36-1), calcium alginate (CAS No. 9005-35-0) and magnesium alginate (CAS No. 37251-44-8) (provided for in subheading 3913.10.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.62",
      "rawHtsCode": "9902.11.62",
      "superior": null,
      "indent": "0",
      "description": "Sodium alginate (CAS No. 9005-38-3) containing citrate (provided for in subheading 3913.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.63",
      "rawHtsCode": "9902.11.63",
      "superior": null,
      "indent": "0",
      "description": "Sodium hyaluronate (CAS No. 9067-32-7) (provided for in subheading 3913.90.20)\n",
      "units": [],
      "generalRate": "4.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.64",
      "rawHtsCode": "9902.11.64",
      "superior": null,
      "indent": "0",
      "description": "Ion-exchange resin, copolymerized from acrylonitrile with divinylbenzene, ethylvinylbenzene and 1,7-octadiene, hydrolyzed (CAS No. 130353-60-5) (provided for in subheading 3914.00.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.65",
      "rawHtsCode": "9902.11.65",
      "superior": null,
      "indent": "0",
      "description": "Ion-exchange resin consisting of poly(acrylic acid-co-2,2'-oxydiethanol-co-ethenoxyethene), acid form (CAS No. 359785-58-3) (provided for in subheading 3914.00.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.66",
      "rawHtsCode": "9902.11.66",
      "superior": null,
      "indent": "0",
      "description": "Ion-exchange resin comprised of divinylbenzene co-polymerized with styrene and ethylstyrene (CAS No. 9052-95-3) in spherical beads with a mean particle size between 0.30 and 1.20 mm (provided for in subheading 3914.00.60)\n\n\n",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.67",
      "rawHtsCode": "9902.11.67",
      "superior": null,
      "indent": "0",
      "description": "Ion-exchange resin comprised of a copolymer of methacrylic acid cross-linked with divinylbenzene, in the hydrogen ionic form (CAS No. 50602-21-6) (provided for in subheading 3914.00.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.68",
      "rawHtsCode": "9902.11.68",
      "superior": null,
      "indent": "0",
      "description": "Ion-exchange resin utilizing a type I quaternary ammonium functional group consisting of benzene (chloromethyl)​ethenyl-​, polymer with diethenylbenzene, compound with N,​N-​diethylethanamine (CAS No. 63453-90-7) in spherical beads with a mean particle size between 0.30 and 1.20 mm (provided for in subheading 3914.00.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.69",
      "rawHtsCode": "9902.11.69",
      "superior": null,
      "indent": "0",
      "description": "Ion-exchange resin, free base form, utilizing a tertiary amine functional group consisting of 2-​propenamide, N-​[3-​(dimethylamino)​propyl]​-​, polymer with diethenylbenzene and 1,​1'-​[oxybis(2,​1-​ethanediyloxy)​]​bis[ethene] (CAS No. 65899-87-8) in spherical beads with a mean particle size between 0.30 and 1.20 mm (provided for in subheading 3914.00.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.70",
      "rawHtsCode": "9902.11.70",
      "superior": null,
      "indent": "0",
      "description": "Ion-exchange resin, chloride form, utilizing a quarternary ammonium functional group, consisting of 1,2-bis(ethenyl)benzene; 4-[(E)-2-[(E)-2-but-3-enoxyethenoxy]ethenoxy]but-1-ene; trimethyl-[3-(prop-2-enoylamino)propyl]azanium; chloride (CAS No. 65997-24-2) in spherical beads with a mean particle size between 0.30 and 1.20 mm (provided for in subheading 3914.00.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.71",
      "rawHtsCode": "9902.11.71",
      "superior": null,
      "indent": "0",
      "description": "Ion-exchange resin comprising sodium salts of sulfonated poly(divinylbenzene-co-ethylstyrene-co-styrene) (CAS No. 69011-22-9) (provided for in subheading 3914.00.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.72",
      "rawHtsCode": "9902.11.72",
      "superior": null,
      "indent": "0",
      "description": "Anion ion-exchange resin, hydroxide form, chloromethylated, and 2-​(dimethylamino)​ethanol-​quaternized hydroxide of poly(divinylbenzene-co-styrene-co-ethylstyrene) (CAS No. 69011-16-1) in spherical beads with a mean particle size between 0.30 and 1.20 mm (provided for in subheading 3914.00.60)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.73",
      "rawHtsCode": "9902.11.73",
      "superior": null,
      "indent": "0",
      "description": "Chloromethylated, trimethylamine-​quaternized poly(divinylbenzene-co-styrene-co-ethylstyrene) (CAS No. 69011-19-4) (provided for in subheading 3914.00.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.74",
      "rawHtsCode": "9902.11.74",
      "superior": null,
      "indent": "0",
      "description": "Poly(divinylbenzene-co-acrylic acid) (CAS No. 9052-45-3) (provided for in subheading 3914.00.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.75",
      "rawHtsCode": "9902.11.75",
      "superior": null,
      "indent": "0",
      "description": "Iminidiacetic acid ion-exchange resin (sodium 2,2'-[(4-vinylbenzyl)imino]diacetate - 1,4-divinylbenzene (2:1:1) (CAS no. 70660-50-3) in spherical beads with a mean particle size between 0.425 and 1.20 mm (provided for in subheading 3914.00.60)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.76",
      "rawHtsCode": "9902.11.76",
      "superior": null,
      "indent": "0",
      "description": "Ion-exchange resin and chelating resin, with a isothiouronium functional group, iminodiacetic acid ion-exchange resin (CAS No. 109945-55-3) in spherical beads with a mean particle size between 0.30 and 1.20 mm (provided for in subheading 3914.00.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.77",
      "rawHtsCode": "9902.11.77",
      "superior": null,
      "indent": "0",
      "description": "Ion-exchange resin and chelating resin with an aminophosphoric functional group, polystyrene resin with aminophosphonic acid groups (CAS No. 125935-42-4) in spherical beads with a mean particle size between 0.30 and 1.20 mm (provided for in subheading 3914.00.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.78",
      "rawHtsCode": "9902.11.78",
      "superior": null,
      "indent": "0",
      "description": "Potassium methacrylate-divinylbenzene copolymer (Polacrilin potassium) (CAS No. 65405-55-2) (provided for in subheading 3914.00.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.79",
      "rawHtsCode": "9902.11.79",
      "superior": null,
      "indent": "0",
      "description": "Strips wholly of expanded poly(tetrafluoroethylene) (PTFE) (CAS No. 9002-84-0), noncellular, with adhesive backing, of a thickness greater than 3 mm but not over 30 mm, presented rolled in spools, certified by the importer as having a tensile strength of 24.1 MPa (3,500 psi) or higher per American Society for Testing and Materials (ASTM) F-152 (provided for in subheading 3916.90.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.80",
      "rawHtsCode": "9902.11.80",
      "superior": null,
      "indent": "0",
      "description": "Insulated tubes of plastics, not reinforced, without fittings, presented in the form of hose, the foregoing tubes having polyethylene pipes inserted therein and suitable for use in hot water supply or heating systems (provided for in subheading 3917.32.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.81",
      "rawHtsCode": "9902.11.81",
      "superior": null,
      "indent": "0",
      "description": "Polyethylene micro-tubes, having an interior diameter of 0.01 mm and wall thickness of 0.05 mm (provided for in subheading 3917.32.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.82",
      "rawHtsCode": "9902.11.82",
      "superior": null,
      "indent": "0",
      "description": "Plastic elbows, holding pins, bend supports, anchor clips, staples of a kind used in construction applications (provided for in subheading 3917.40.00)",
      "units": [],
      "generalRate": "5.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.83",
      "rawHtsCode": "9902.11.83",
      "superior": null,
      "indent": "0",
      "description": "Transparent polypropylene coextruded flat film in rolls with a thickness between 162-198µm and a width between 396-398 mm (provided for in subheading 3920.20.00).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.84",
      "rawHtsCode": "9902.11.84",
      "superior": null,
      "indent": "0",
      "description": "Sheets of plastics of poly(methyl methacrylate), noncellular and not reinforced, laminated, supported or similarly combined with other materials, not flexible, the foregoing of a kind used to produce counter tops or edging, cabinet tops, faces or edges for home or office furnishings (provided for in subheading 3920.51.50)",
      "units": [],
      "generalRate": "3.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.85",
      "rawHtsCode": "9902.11.85",
      "superior": null,
      "indent": "0",
      "description": "Flexible film of acrylic polymers, other than poly(methyl methacrylate) (provided for in subheading 3920.59.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.86",
      "rawHtsCode": "9902.11.86",
      "superior": null,
      "indent": "0",
      "description": "Poly(vinyl butyral) film (CAS No. 27360-07-2), certified by the importer to be used in aircraft (provided for in subheading 3920.91.00)",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.87",
      "rawHtsCode": "9902.11.87",
      "superior": null,
      "indent": "0",
      "description": "Sheets of regenerated cellulose, cellular, nonadhesive, rectangular in shape and measuring 750 mm or more but not over 885 mm in length, 765 mm or more but not over 885 mm in width and 0.9 mm or more but not over 1.9 mm in thickness (provided in for subheading 3921.14.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.88",
      "rawHtsCode": "9902.11.88",
      "superior": null,
      "indent": "0",
      "description": "Expanded poly(tetrafluoroethylene) (PTFE) nonadhesive cellular sheets, of a thickness greater than 1.5 mm but not more than 3.0 mm, certified by the importer as having a tensile strength of at least 48.3 MPa (7,000 psi) per ASTM F-152 (CAS No. 9002-84-0) (provided for in subheading 3921.19.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.89",
      "rawHtsCode": "9902.11.89",
      "superior": null,
      "indent": "0",
      "description": "Expanded poly(tetrafluoroethylene) (PTFE) nonadhesive cellular sheets, of a thickness greater than 3.0 mm but not more than 6.0 mm, certified by the importer as having a tensile strength of at least 48.3 MPa (7,000 psi) per ASTM F-152 (CAS No. 9002-84-0) (provided for in subheading 3921.19.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.90",
      "rawHtsCode": "9902.11.90",
      "superior": null,
      "indent": "0",
      "description": "Injection molded thermoplastic dental restorative product containers, designed for use in a dispensing system, each container with capacity not over 50 ml (provided for in subheading 3923.30.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.91",
      "rawHtsCode": "9902.11.91",
      "superior": null,
      "indent": "0",
      "description": "Plug-type closures of polyethylene, suitable for use in capping specimen tubes and measuring 15 mm in length; each closure having an upper portion designed to extend beyond the specimen tube to permit holding of the closure, such upper portion having a diameter of 15.5 mm and thickness of 3.3 mm and having a notched groove; with the bottom portion of such closure designed for insertion into a specimen tube having a diameter measuring approximately 11.7 mm; the foregoing closures certified by the importer as for use in an automated insertion system (provided for in subheading 3923.50.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.92",
      "rawHtsCode": "9902.11.92",
      "superior": null,
      "indent": "0",
      "description": "Injection molded thermoplastic dental restorative product dispenser closures fitting containers with capacity less than or equal to 50 ml (provided for in subheading 3923.50.00)\n",
      "units": [],
      "generalRate": "1.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.93",
      "rawHtsCode": "9902.11.93",
      "superior": null,
      "indent": "0",
      "description": "Plastic lids certified by the importer for use on food storage containers (provided for in 3923.50.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.94",
      "rawHtsCode": "9902.11.94",
      "superior": null,
      "indent": "0",
      "description": "Plastic cap for sport water bottle of the squeezable type (provided for in 3923.50.00)",
      "units": [],
      "generalRate": "0.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.95",
      "rawHtsCode": "9902.11.95",
      "superior": null,
      "indent": "0",
      "description": "Cutlery of plastics, each piece individually wrapped in polypropylene film, presented with such wrapped cutlery joined together by skewers for ease of loading in a fully enclosed dispensing system (provided for in subheading 3924.10.40)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.96",
      "rawHtsCode": "9902.11.96",
      "superior": null,
      "indent": "0",
      "description": "Cutlery of plastics, presented with quantities of identical cutlery items joined together by paper wrapping or paper banding designed for ease of loading in a fully enclosed dispensing system (provided for in subheading 3924.10.40)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.97",
      "rawHtsCode": "9902.11.97",
      "superior": null,
      "indent": "0",
      "description": "Disposable cutlery of plastics, containing by weight over 96 percent of polypropylene, presented without being individually wrapped, grouped, banded or skewered for ease of loading in a fully enclosed dispensing system (provided for in subheading 3924.10.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.98",
      "rawHtsCode": "9902.11.98",
      "superior": null,
      "indent": "0",
      "description": "Pans or inserts of plastics, of a type designed for pet crates of metal wire as inserts to create a solid interior surface (provided for in subheading 3924.90.56)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.11.99",
      "rawHtsCode": "9902.11.99",
      "superior": null,
      "indent": "0",
      "description": "Plastic ornamentation designed for aquariums that house fish, reptiles or small pets (provided for in subheading 3924.90.56)",
      "units": [],
      "generalRate": "0.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.01",
      "rawHtsCode": "9902.12.01",
      "superior": null,
      "indent": "0",
      "description": "Boxing and mixed martial arts gloves of plastics (provided for in subheading 3926.20.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.02",
      "rawHtsCode": "9902.12.02",
      "superior": null,
      "indent": "0",
      "description": "Handles of plastics for coolers of heading 9403 (provided for in subheading 3926.30.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.03",
      "rawHtsCode": "9902.12.03",
      "superior": null,
      "indent": "0",
      "description": "Belting, for machinery, of plastic, containing textile components, in which man-made or vegetable fiber do not predominate by weight over any other textile fiber, of a width exceeding 120 cm, but not more than 171 cm (provided for in subheading 3926.90.59)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.04",
      "rawHtsCode": "9902.12.04",
      "superior": null,
      "indent": "0",
      "description": "Fasteners of nylon or of polypropylene, with a filament length of 6 mm or more but not over 127 mm, presented on clips each holding the quantity of 25, 50 or 100 pieces, suitable for use in a mechanical attaching device (provided for in subheading 3926.90.85)\n",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.05",
      "rawHtsCode": "9902.12.05",
      "superior": null,
      "indent": "0",
      "description": "Plastic components of a kind used as one-piece internal top and bottom dividers for golf bags (provided for in subheading 3926.90.99)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.06",
      "rawHtsCode": "9902.12.06",
      "superior": null,
      "indent": "0",
      "description": "Vinyl rings, slitted on one side to attach to bottom of toilet brush caddies, valued no greater than $0.083 each (provided for in subheading 3926.90.99)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.07",
      "rawHtsCode": "9902.12.07",
      "superior": null,
      "indent": "0",
      "description": "Cut-to-shape pieces or profiles of polyvinyl chloride plastics, the foregoing designed to be attached to the edge of a dust pan tray having contact with the floor or other surface, rigid and flexible in form, each measuring 24.77 cm to 30 cm in length and 1.35 cm to 1.87 cm in width, valued not over $0.09 each (provided for in subheading 3926.90.99)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.08",
      "rawHtsCode": "9902.12.08",
      "superior": null,
      "indent": "0",
      "description": "Adjustable squeeze-trigger bar clamps of plastics (provided for in subheading 3926.90.99)",
      "units": [],
      "generalRate": "0.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.09",
      "rawHtsCode": "9902.12.09",
      "superior": null,
      "indent": "0",
      "description": "Back-shell style smartphone cases of hard plastics, each incorporating flexible rubber over command buttons and specially fitted rigid plastic clip with adjustable neoprene fabric armband (provided for in subheading 3926.90.99).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.10",
      "rawHtsCode": "9902.12.10",
      "superior": null,
      "indent": "0",
      "description": "Rectangular plastic block filled with a polymer based freezer gel, designed to attach to reusable food storage containers (provided for in 3926.90.99)\n",
      "units": [],
      "generalRate": "1.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.11",
      "rawHtsCode": "9902.12.11",
      "superior": null,
      "indent": "0",
      "description": "Accessories of plastics for cameras of subheading 8525.80.40, each incorporating a handheld camera grip, folding extension arms and a tripod screwed into the base of the handle the foregoing measuring between 50 and 53 cm when fully extended without the tripod, 62 to 65 cm when fully extended with the tripod and 18 to 21 cm when folded and collapsed (provided for in subheading 3926.90.99). \n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.12",
      "rawHtsCode": "9902.12.12",
      "superior": null,
      "indent": "0",
      "description": "Mounts of plastics, designed to secure cameras of subheading 8525.80.40 to a person's head; each mount incorporating an adjustable head-strap designed to encircle the forehead, a strap designed to cross the top of the user's head, a plastic mount designed to clip the camera to the head strap, a thumbscrew to allow the mounting of the camera and the adjustment of the viewing direction of the camera on a pivot (provided for in subheading 3926.90.99)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.13",
      "rawHtsCode": "9902.12.13",
      "superior": null,
      "indent": "0",
      "description": "Accessories of plastics, designed for use with cameras of subheading 8525.80.40; such goods measuring between 14 cm and 17 cm in length, buoyant in water, each incorporating a handle designed to allow a user to grip with the hand, an adjustable hand-strap and an adjustable thumb screw designed to permit mounting of the camera and adjusting the viewing angle of the camera on a pivot (provided for in subheading 3926.90.99).\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.14",
      "rawHtsCode": "9902.12.14",
      "superior": null,
      "indent": "0",
      "description": "Mounts of plastics, engineered to attach to cameras of subheading 8525.80.40; designed to attach to flat surfaces by means of a round suction cup measuring between 8 and 10 cm in diameter; each incorporating x, y and z-directional pivots to adjust the camera's viewpoint (provided for in subheading 3926.90.99).\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.15",
      "rawHtsCode": "9902.12.15",
      "superior": null,
      "indent": "0",
      "description": "Camera mounts of plastics, designed to clamp to tubes measuring 10 to 23 mm, each mount designed to hold two cameras in such positions as to permit the user to take photos with immersive front-facing and rear-facing perspectives (provided for in subheading 3926.90.99)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.16",
      "rawHtsCode": "9902.12.16",
      "superior": null,
      "indent": "0",
      "description": "Mounting frame enclosures for digital still image video cameras of subheading 8525.80.40, incorporating openings for camera microSD, micro HDMI and USB ports, camera latching mechanism, and glass protective screen (provided for in subheading 3926.90.99)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.17",
      "rawHtsCode": "9902.12.17",
      "superior": null,
      "indent": "0",
      "description": "Camera mounts of plastics, engineered to operate with cameras of subheading 8525.80.40 and facilitate mounting of cameras onto tubes measuring 3.5 to 6.35 cm in diameter, the foregoing incorporating a base capable of rotating the camera 360 degrees on a plane (provided for in subheading 3926.90.99)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.18",
      "rawHtsCode": "9902.12.18",
      "superior": null,
      "indent": "0",
      "description": " Mounting frame enclosures of plastics, designed for digital still image video cameras of subheading 8525.80.40, the foregoing incorporating an adhesive circular base of a diameter of 15 cm (provided for in subheading 3926.90.99)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.19",
      "rawHtsCode": "9902.12.19",
      "superior": null,
      "indent": "0",
      "description": "Plastic screen protectors having dimensions not exceeding 40 mm by 60 mm but at least 35 mm by 50 mm for digital still image video cameras of 8525.80.40 (provided for in subheading 3926.90.99)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.20",
      "rawHtsCode": "9902.12.20",
      "superior": null,
      "indent": "0",
      "description": "Replacement doors of plastics, designed for use on waterproof camera housings (provided for in subheading 3926.90.99)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.21",
      "rawHtsCode": "9902.12.21",
      "superior": null,
      "indent": "0",
      "description": "Replacement side doors of plastics, designed for housings for digital still image video cameras of subheading 8525.80.40 (provided for in subheading 3926.90.99)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.22",
      "rawHtsCode": "9902.12.22",
      "superior": null,
      "indent": "0",
      "description": "Camera mounts of plastics, designed to attach cameras of subheading 8525.80.40 securely onto tubes measuring 9 to 35 mm in diameter, each incorporating a base capable of rotating the camera 360 degrees on a plane (provided for in subheading 3926.90.99)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.23",
      "rawHtsCode": "9902.12.23",
      "superior": null,
      "indent": "0",
      "description": "Camera mounts of plastics, designed to hold cameras of subheading 8525.80.40, each mount measuring 4 and 10 cm in length, 3 to 5 cm in width and less than 2 cm in height, incorporating adhesive pads to attach the mount to flat surfaces (provided for in subheading 3926.90.99)\n\n\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.24",
      "rawHtsCode": "9902.12.24",
      "superior": null,
      "indent": "0",
      "description": "Camera mounts each designed to clip a camera of subheading 8525.80.40 to a surfboard, such mounts of plastics, designed to be inserted into a cross-sectional hole drilled into the surfboard and held thereto by screws (provided for in 3926.90.99)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.25",
      "rawHtsCode": "9902.12.25",
      "superior": null,
      "indent": "0",
      "description": "Anchors suitable for use with cameras of subheading 8525.80.40, designed to be affixed to cameras by means of an adhesive, incorporating tethers that may be tied to the anchors (provided for in subheading 3926.90.99)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.26",
      "rawHtsCode": "9902.12.26",
      "superior": null,
      "indent": "0",
      "description": "Camera mounts of plastics, each with an elongated, segmented plastic neck composed of 6 to 8 ball joints, incorporating a base that clips into other types of mounts but not incorporating a clamp, engineered to mount cameras of subheading 8525.80.40 (provided for in subheading 3926.90.99).\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.27",
      "rawHtsCode": "9902.12.27",
      "superior": null,
      "indent": "0",
      "description": "Sets each containing five camera mounts of plastics, designed for cameras of subheading 8525.80.40; such sets each containing mounts having various different profile configurations including but not limited to rectangular, curved or raised profiles (provided for in subheading 3926.90.99)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.28",
      "rawHtsCode": "9902.12.28",
      "superior": null,
      "indent": "0",
      "description": "Camera mounts of plastics, designed for mounting cameras of subheading 8525.80.40 to musical instruments or microphone stands; each incorporating a spring-loaded clamp and a folding extension arm (provided for in subheading 3926.90.99)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.29",
      "rawHtsCode": "9902.12.29",
      "superior": null,
      "indent": "0",
      "description": "Conveyor belting of vulcanized rubber, reinforced with textile components in which man-made fibers predominate by weight over any other single textile fiber, of a width exceeding 120 cm but not over 171 cm (provided for in subheading 4010.12.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.30",
      "rawHtsCode": "9902.12.30",
      "superior": null,
      "indent": "0",
      "description": "Gaskets, washers and other seals, of vulcanized rubber other than hard rubber, of a kind in the automotive goods of chapter 87 (provided for in subheading 4016.93.10)",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.31",
      "rawHtsCode": "9902.12.31",
      "superior": null,
      "indent": "0",
      "description": "Toys for pets made of noncellular vulcanized rubber, other than hard rubber, with felt textile covering, without holes (provided for in subheading 4016.99.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.32",
      "rawHtsCode": "9902.12.32",
      "superior": null,
      "indent": "0",
      "description": "Camera flotation devices of vulcanized rubber other than hard rubber, cellular rubber or natural rubber, such devices measuring 6 to 9 cm in length, 4 to 6 cm in width and 2 to 6 cm in depth; the foregoing whether designed to encase the camera or to be attached to the camera by means of an adhesive pad (provided for in subheading 4016.99.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.33",
      "rawHtsCode": "9902.12.33",
      "superior": null,
      "indent": "0",
      "description": "Flotation devices of vulcanized rubber other than of hard rubber, designed for use with cameras of subheading 8525.80.40, such devices with length, width and height dimensions all smaller than 50 mm and either designed to encase the camera or to attach to the camera by an adhesive pad (provided for in 4016.99.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.34",
      "rawHtsCode": "9902.12.34",
      "superior": null,
      "indent": "0",
      "description": "Whole, tanned bovine hides, full grain unsplit or grain splits, in the dry state, not further prepared after tanning or crusting, having a unit surface area of 5.11 m2 or more but not over 6.04 m2, certified by the importer for use in the production of upholstery (provided for in subheading 4104.41.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.35",
      "rawHtsCode": "9902.12.35",
      "superior": null,
      "indent": "0",
      "description": "Life jackets designed for pets, such jackets of neoprene and ripstop fabrics and with attached reflectors and handles (provided for in subheading 4201.00.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.37",
      "rawHtsCode": "9902.12.37",
      "superior": null,
      "indent": "0",
      "description": "Doll diaper bags, with an outer surface of cotton textile material, each measuring not over 25 cm in width, 22 cm in height exclusive of handles and 10 cm in depth; such bags designed to hold and carry doll diapers and other doll-related accessories and having an attached flap designed to serve as a diaper changing mat for dolls (provided for in subheading 4202.92.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.38",
      "rawHtsCode": "9902.12.38",
      "superior": null,
      "indent": "0",
      "description": "Sleeping bag carrying bags (“stuff sacks”), of woven taffeta fabric of polyester with 160 or more but not over 210 thread count, formed from 22 or more but not over 112 decitex yarns; such bags or sacks each weighing 25 g/m2 or more but not over 250 g/m2, having a drawstring closure, measuring 77.5 cm or more but not over 127.7 cm in circumference, valued not over $2 each, not presented with or containing sleeping bags (provided for in subheading 4202.92.31) \n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.39",
      "rawHtsCode": "9902.12.39",
      "superior": null,
      "indent": "0",
      "description": "Backpacks or totes, each with an outer surface of man-made fiber textile material, specially designed for carrying dolls and containing straps, sleeves, netting or other restraints specifically designed to hold a doll in place, incorporating one or more exterior windows through which a doll can be viewed (provided for in subheading 4202.92.31)",
      "units": [],
      "generalRate": "4.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.40",
      "rawHtsCode": "9902.12.40",
      "superior": null,
      "indent": "0",
      "description": "Backpacks or totes, each with an outer surface of man-made fiber textile material, specially designed for carrying dolls and containing straps, sleeves, netting or other restraints specifically designed to hold a doll in place, not incorporating any exterior windows through which a doll can be viewed (provided for in subheading 4202.92.31)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.41",
      "rawHtsCode": "9902.12.41",
      "superior": null,
      "indent": "0",
      "description": "Shopping bags with outer surface of spun-bonded fabric of polypropylene or nonwoven fabric of polypropylene (provided for in subheading 4202.92.31)",
      "units": [],
      "generalRate": "16.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.42",
      "rawHtsCode": "9902.12.42",
      "superior": null,
      "indent": "0",
      "description": "Backpacks of man-made fibers, each containing a padded compartment designed for a laptop or tablet, with hard molded plastic shell in the shape of a shield on one outer surface (provided for in subheading 4202.92.31)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.43",
      "rawHtsCode": "9902.12.43",
      "superior": null,
      "indent": "0",
      "description": "Backpacks of man-made fibers, each containing a padded compartment designed for a laptop or tablet, with hard molded plastic shell in the shape of one or more animals or animal parts on one outer surface (provided for in subheading 4202.92.31)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.44",
      "rawHtsCode": "9902.12.44",
      "superior": null,
      "indent": "0",
      "description": "Backpacks of man-made fibers, each containing a padded compartment designed for a laptop ortablet, with hard molded plastic shell in a shape other than a shield or animals or animal parts on one outer surface (provided for in subheading 4202.92.31)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.45",
      "rawHtsCode": "9902.12.45",
      "superior": null,
      "indent": "0",
      "description": "Backpacks with outer surface of 230 decitex fabric of nylon and with laminated polyester knitted backing inner surface; such backpacks each weighing 0.85 kg but not over 1 kg, measuring 0.018 m3 but not over 0.022 m3 in volume; valued $14 or more but not over $21 each; the foregoing each presented with a detachable front pouch having its own shoulder strap (provided for in subheading 4202.92.31)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.46",
      "rawHtsCode": "9902.12.46",
      "superior": null,
      "indent": "0",
      "description": "Binocular carrying cases with outer surface of camouflage-printed woven fabric of man-made fibers coated with plastics, each with a padded interior and both a zipper and magnetic closures, designed to be carried on the front side of the body and supported by shoulder straps stabilized with a back harness, weighing no more than 382.544 g, valued $20 or more (provided for in subheading 4202.92.91)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.47",
      "rawHtsCode": "9902.12.47",
      "superior": null,
      "indent": "0",
      "description": "Bags of man-made fibers, with outer surface of textile materials, the foregoing designed for use on janitorial, cleaning and housekeeping carts (provided for in subheading 4202.92.91) \n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.48",
      "rawHtsCode": "9902.12.48",
      "superior": null,
      "indent": "0",
      "description": "Drawstring bags with outer surface of sheeting of plastic or of textile materials, such bags of nylon, presented packaged in sets of 5 bags per set and labeled for retail sale, each bag with capacity of less than 1 liter in volume (provided for in subheading 4202.92.91)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.49",
      "rawHtsCode": "9902.12.49",
      "superior": null,
      "indent": "0",
      "description": "Cases or containers with outer surface of sheeting of plastics or of man-made fibers, the foregoing specially shaped or fitted for, and with labeling, logo or other descriptive information on the exterior of the case or container or retail packaging indicating its intention to be used for, electronic games of heading 9504 or accessories thereof (provided for in subheadings 4202.92.91 and 4202.92.97)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.50",
      "rawHtsCode": "9902.12.50",
      "superior": null,
      "indent": "0",
      "description": "Carrying cases of hard plastics, each with handle and door of plastics and with no door of metal, the foregoing designed for use for reptiles or amphibians and not for the housing or transport of mammals, measuring not over 381 mm on any side (provided for in subheading 4202.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.51",
      "rawHtsCode": "9902.12.51",
      "superior": null,
      "indent": "0",
      "description": "Camera cases of transparent polycarbonate plastics, designed to encase cameras of subheading 8525.80.40; each incorporating buttons for the operation of the camera, an opaque plastic base that clips into a camera mount, a thumb-screw on the base mount that allows for adjustment of the camera viewing angle on a pivot, a silicon gasket in the door of the case that allows for waterproof operation of the camera at a depth of more than 40 m but not more than 60 m, a flat and optically-coated glass lens and a heat sink to dissipate camera heat (provided for in subheading 4202.99.90).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.52",
      "rawHtsCode": "9902.12.52",
      "superior": null,
      "indent": "0",
      "description": "Cases of clear polycarbonate plastics, designed for use with cameras of subheading 8525.80.40 to affix camera to the user's wrist; such housings waterproof at a depth up to 60 m, each incorporating buttons for operation of the camera, a silicon gasket designed for waterproofing, a flat and optically-coated glass lens, an aluminum heat sink and adjustable neoprene/hook and loop closures on its wrist straps (provided for in subheading 4202.99.90).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.53",
      "rawHtsCode": "9902.12.53",
      "superior": null,
      "indent": "0",
      "description": "Cases or containers of injection-molded acrylonitrile-butadiene-styrene (ABS), polypropylene (PP) or polycarbonate (PC) plastics, the foregoing specially shaped or fitted for, and with labeling, logo or other descriptive information on the exterior of the case or container, its zipper pull or its retail packaging indicating such cases are designed for use as holders for electronic games of subheading 9504 or accessories thereof (provided for in subheading 4202.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.54",
      "rawHtsCode": "9902.12.54",
      "superior": null,
      "indent": "0",
      "description": "Camera cases with outer surface of transparent molded polycarbonate plastics, designed for cameras of subheading 8525.80.40; the foregoing each incorporating buttons for the operation of the camera, an opaque plastic base that clips into a camera mount, a thumb-screw on the base mount that allows for adjustment of the camera viewing angle on a pivot, a silicon gasket in the door of the case that allows for waterproof operation of the camera at a depth of not more than 40 m, a flat, optically-coated, glass lens and a heat sink to dissipate camera heat (provided for in subheading 4202.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.55",
      "rawHtsCode": "9902.12.55",
      "superior": null,
      "indent": "0",
      "description": "Camera cases of molded polycarbonate plastics, such cases designed to hold cameras of subheading 8525.80.40, each case incorporating buttons for the operation of the camera, a plastic clip attached to a base mount, a thumb-screw on the base mount that allows adjustment of the viewing angle on a pivot, a flat and optically-coated glass lens and open spaces that allow air and sound to enter (provided for in subheading 4202.99.90).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.56",
      "rawHtsCode": "9902.12.56",
      "superior": null,
      "indent": "0",
      "description": "Camera cases designed to contain cameras of subheading 8525.80.40; such cases of opaque molded polycarbonate plastics in a solid color and with nonreflective surface; each incorporating buttons for the operation of the camera, a plastic clip attached to a base mount, a thumb-screw on the base mount designed to facilitate the adjustment of its viewing angle on a pivot, a silicon gasket in the door of the housing designed to allow for waterproof operation of the camera at a depth of more than 40 m but not more than 60 m; each incorporating a flat, optically-coated glass lens and a heat sink to dissipate camera heat (provided for in subheading 4202.99.90).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.57",
      "rawHtsCode": "9902.12.57",
      "superior": null,
      "indent": "0",
      "description": "Women's leather jackets, other than anoraks, each having a full frontal opening with no closure, of waist-length and valued not over $125 (provided for in subheading 4203.10.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.58",
      "rawHtsCode": "9902.12.58",
      "superior": null,
      "indent": "0",
      "description": "Batting gloves of leather, each having a strap designed to wrap around the wrist and back of the hand and secure the glove on the wearer's wrist (provided for in subheading 4203.21.20)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.59",
      "rawHtsCode": "9902.12.59",
      "superior": null,
      "indent": "0",
      "description": "Full-fingered gloves, each with a palm side of leather and a back side comprising a camouflage-printed knitted fabric wholly of polyester and coated with expanded polytetrafluoroethylene (EPTFE), such gloves with insulation comprising 40 percent by weight of synthetic microfiber and 60 percent by weight of duck down; each having a mitt sewn to the back of the glove as a flap, with leather tips for each finger and thumb designed to improve grip, such mitt designed to cover the fingers for additional warmth; the foregoing gloves designed for use in the sport of hunting (provided for in subheading 4203.21.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.60",
      "rawHtsCode": "9902.12.60",
      "superior": null,
      "indent": "0",
      "description": "Boxing and mixed martial arts gloves, of leather or of composition leather (provided for in subheading 4203.21.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.61",
      "rawHtsCode": "9902.12.61",
      "superior": null,
      "indent": "0",
      "description": "Gloves of horsehide or cowhide (except calfskin) leather, not specially designed for use in sports, not wholly of leather, the foregoing with fourchettes or sidewalls which, at a minimum, extend from fingertip to fingertip between each of the four fingers (provided for in subheading 4203.29.15)\n",
      "units": [],
      "generalRate": "9.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.62",
      "rawHtsCode": "9902.12.62",
      "superior": null,
      "indent": "0",
      "description": "Gloves of horsehide or cowhide (except calfskin) leather, not specially designed for use in sports, not wholly of leather, such gloves without fourchettes or sidewalls (provided for in subheading 4203.29.18)\n",
      "units": [],
      "generalRate": "13.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.63",
      "rawHtsCode": "9902.12.63",
      "superior": null,
      "indent": "0",
      "description": "Men's full-fingered gloves with a palm side of leather and a backside of woven fabric comprising 89 percent or more but not over 95 percent by weight of man-made fibers and 5 percent or more but not over 11 percent by weight of elastomeric fibers, such fabric coated with plastics; such gloves stuffed with synthetic microfiber for thermal insulation, with elasticized wrist and valued at $18 or more per pair; the foregoing other than gloves specially designed for use in sports (provided for in subheading 4203.29.30) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.64",
      "rawHtsCode": "9902.12.64",
      "superior": null,
      "indent": "0",
      "description": "Women’s belts of leather or of composition leather, each valued at $7.00 or more (provided for in subheading 4203.30.00)",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.65",
      "rawHtsCode": "9902.12.65",
      "superior": null,
      "indent": "0",
      "description": "Belts of furskin, other than of mink (provided for in subheading 4303.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.66",
      "rawHtsCode": "9902.12.66",
      "superior": null,
      "indent": "0",
      "description": "Plaiting materials and products of plaiting materials, suitable for use in window shades, presented in rolls each having an area measuring 27.85 m2 or more but not over 46.46 m2, of bamboo reeds and/or bamboo slats each measuring 1 mm or more but not over 13 mm in width and/or bamboo cane measuring over 2 mm but not over 5 mm in cross section, the foregoing woven with yarn of polyester into a repeating pattern, such pattern whether or not including grass, paper strips or jute (provided for in subheading 4601.92.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.67",
      "rawHtsCode": "9902.12.67",
      "superior": null,
      "indent": "0",
      "description": "Plaiting materials and products of plaiting materials, of wood, suitable for use in window shades, presented in rolls each having an area measuring over 27.85 m2 but less than 46.46 m2, containing any combination of wood slats each measuring 6 mm or more but not over 8 mm in width or 22 mm or more but not over 25 mm in width and measuring 1 mm or more but not over 2 mm in thickness, bamboo reeds measuring 1 mm or more but not over 2.5 mm in width, marupa wood rods measuring 1.5 mm or more but not over 3 mm in diameter and/or paper rope, the foregoing woven with yarns of polyester into a repeating pattern, whether or not such pattern also contains jute or paper (provided for in subheading 4601.94.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.68",
      "rawHtsCode": "9902.12.68",
      "superior": null,
      "indent": "0",
      "description": "Flatgoods of rattan, of a kind normally carried in the pocket or in the handbag, with or without shoulder straps or handles (provided for in subheading 4602.12.23)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.69",
      "rawHtsCode": "9902.12.69",
      "superior": null,
      "indent": "0",
      "description": "Fine animal hair of Kashmir (cashmere) goats, processed beyond the degreased or carbonized condition (provided for in subheading 5102.11.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.70",
      "rawHtsCode": "9902.12.70",
      "superior": null,
      "indent": "0",
      "description": "Camel hair, not processed in any manner beyond the degreased or carbonized condition (provided for in subheading 5102.19.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.71",
      "rawHtsCode": "9902.12.71",
      "superior": null,
      "indent": "0",
      "description": "Camel hair, processed beyond the carbonized condition (provided for in subheading 5102.19.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.72",
      "rawHtsCode": "9902.12.72",
      "superior": null,
      "indent": "0",
      "description": "Noils of camel hair (provided for in subheading 5103.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.73",
      "rawHtsCode": "9902.12.73",
      "superior": null,
      "indent": "0",
      "description": "Fine animal hair of Kashmir (cashmere) goats, carded or combed (provided for in subheading 5105.31.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.74",
      "rawHtsCode": "9902.12.74",
      "superior": null,
      "indent": "0",
      "description": "Camel hair, carded or combed (provided for in subheading 5105.39.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.75",
      "rawHtsCode": "9902.12.75",
      "superior": null,
      "indent": "0",
      "description": "Yarn of carded hair of Kashmir (cashmere) goats, having a yarn count of 19.35 metric or higher (provided for in subheading 5108.10.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.76",
      "rawHtsCode": "9902.12.76",
      "superior": null,
      "indent": "0",
      "description": "Yarn of carded hair of Kashmir (cashmere) goats, having a yarn count less than 19.35 metric, not put up for retail sale (provided for in subheading 5108.10.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.77",
      "rawHtsCode": "9902.12.77",
      "superior": null,
      "indent": "0",
      "description": "Yarn of carded camel hair (provided for in subheading 5108.10.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.78",
      "rawHtsCode": "9902.12.78",
      "superior": null,
      "indent": "0",
      "description": "Yarn of combed cashmere or yarn of camel hair, not put up for retail sale (provided for in subheading 5108.20.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.79",
      "rawHtsCode": "9902.12.79",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of carded vicuna hair, containing 85 percent or more by weight of vicuna hair and of a weight not exceeding 300 g/m2 (provided for in subheading 5111.11.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.80",
      "rawHtsCode": "9902.12.80",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of carded vicuna hair, containing 85 percent or more by weight of vicuna hair and of a weight exceeding 300 g/m2 (provided for in subheading 5111.19.60).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.81",
      "rawHtsCode": "9902.12.81",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of combed vicuna hair, such fabrics containing 85 percent or more by weight of vicuna hair, of a weight not exceeding 200 g/m2 (provided for in subheading 5112.11.60).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.82",
      "rawHtsCode": "9902.12.82",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of combed vicuna hair, such fabrics containing 85 percent or more by weight of vicuna hair and of a weight exceeding 200 g/m2 (provided for in subheading 5112.19.95).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.83",
      "rawHtsCode": "9902.12.83",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of cotton, bleached, of yarn numbers 43 to 68, put up in continuous rolls measuring 74 cm or more but not over 184 cm in width and 1640 m or more but not over 6500 m in length (provided for in subheading 5208.21.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.84",
      "rawHtsCode": "9902.12.84",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of cotton, containing more than 50 percent but less than 85 percent by weight of cotton and containing polyester, bleached, pique weave, measuring 290 cm or greater in width (provided for in subheading 5211.20.29)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.85",
      "rawHtsCode": "9902.12.85",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of cotton, containing over 50 percent but less than 85 percent by weight of cotton and containing polyester, dyed, pique weave, measuring 290 cm or greater in width (provided for in subheading 5211.39.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.86",
      "rawHtsCode": "9902.12.86",
      "superior": null,
      "indent": "0",
      "description": "Monofilament yarn of nylon, of 53 decitex or more but not over 58 decitex, with no cross-sectional dimension exceeding 1 mm; untwisted or with twist of fewer than 5 turns/m, not put up for retail sale, fully oriented; the foregoing with consistent diameter to be suitable for silk-screening (provided for in subheading 5402.45.90) \n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.87",
      "rawHtsCode": "9902.12.87",
      "superior": null,
      "indent": "0",
      "description": "Synthetic (polyvinyl alcohol) filament yarn, untwisted, measuring from 1100 to 1330 decitex (dtex) and consisting of 200 filaments, certified by the importer as having from 6.8 to 8.2 cN/dtex tenacity and with elongation at break from 7.7 to 13.5 percent (provided for in subheading 5402.49.91)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.88",
      "rawHtsCode": "9902.12.88",
      "superior": null,
      "indent": "0",
      "description": "Synthetic filament yarn (other than sewing thread) not put up for retail sale, single, with a twist exceeding 50 turns/m, of nylon or other polyamides, measuring 23 or more but not over 840 decitex, each formed from 4 to 68 filaments and containing 10 percent or more by weight of nylon 12 (provided for in subheading 5402.51.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.89",
      "rawHtsCode": "9902.12.89",
      "superior": null,
      "indent": "0",
      "description": "High tenacity single yarn of viscose rayon, with a decitex equal to or greater than 1,000, the foregoing not put up for retail sale and other than sewing thread (provided for in subheading 5403.10.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.90",
      "rawHtsCode": "9902.12.90",
      "superior": null,
      "indent": "0",
      "description": "High tenacity single yarn of viscose rayon, with a decitex less than 1,000 (provided for in subheading 5403.10.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.91",
      "rawHtsCode": "9902.12.91",
      "superior": null,
      "indent": "0",
      "description": "High tenacity multiple (folded) or cabled yarn of viscose rayon (provided for in subheading 5403.10.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.92",
      "rawHtsCode": "9902.12.92",
      "superior": null,
      "indent": "0",
      "description": "Single filament yarn of viscose rayon (other than sewing thread), not put up for retail sale, untwisted or with a twist not exceeding 120 turns per meter (provided for in subheading 5403.31.00) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.93",
      "rawHtsCode": "9902.12.93",
      "superior": null,
      "indent": "0",
      "description": "Single filament yarn of viscose rayon, with a twist exceeding 120 turns/m (provided for in subheading 5403.32.00) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.94",
      "rawHtsCode": "9902.12.94",
      "superior": null,
      "indent": "0",
      "description": "Synthetic monofilament of polypropylene, of 67 decitex or more and of which no cross-sectional dimension exceeds 1 mm (provided for in subheading 5404.19.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.95",
      "rawHtsCode": "9902.12.95",
      "superior": null,
      "indent": "0",
      "description": "Monofilament of nylon, of 67 decitex or more and with no cross-sectional dimension exceeding 1 mm, the foregoing without consistent diameter (provided for in subheading 5404.19.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.96",
      "rawHtsCode": "9902.12.96",
      "superior": null,
      "indent": "0",
      "description": "Monofilament of nylon, of 67 decitex or more and of which no cross-sectional dimension exceeds 1 mm; designed with consistent diameter to be suitable for silk-screening (provided for in subheading 5404.19.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.97",
      "rawHtsCode": "9902.12.97",
      "superior": null,
      "indent": "0",
      "description": "Fabrics containing 85 percent or more by weight of textured polyester filaments, plain woven, of yarns of different colors, weighing 96 g/m2 or more but less than 170 g/m2, measuring 142.2 cm or more in width; such fabric with weft yarns of polybutylene terephthalate (PBT) giving the fabric sideways stretch, with 31 or more but not over 36 single yarns per cm dyed light beige in the warp and 14 or more but not over 18 single yarns per cm dyed light brown in the weft (provided for in subheading 5407.53.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.98",
      "rawHtsCode": "9902.12.98",
      "superior": null,
      "indent": "0",
      "description": "Acrylic fiber tow containing at least 85 percent but not more than 92 percent by weight of acrylonitrile units, containing a minimum of 35 percent by weight of water, presented in the form of raw white (undyed) filament with an average filament measure between 2 and 5 decitex per filament and an aggregate measure in the tow bundle between 660,000 and 1,200,000 decitex, with a length greater than 2 meters (provided for in subheading 5501.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.12.99",
      "rawHtsCode": "9902.12.99",
      "superior": null,
      "indent": "0",
      "description": "Acrylic filament tow containing 85 percent or more by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, raw white (undyed), crimped, with an average decitex of 2.2 (plus or minus 10 percent) and an aggregate filament measure in the tow bundle between 660,000 and 1,200,000 decitex, with a length greater than 2 m (provided for in subheading 5501.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.01",
      "rawHtsCode": "9902.13.01",
      "superior": null,
      "indent": "0",
      "description": "Acrylic fiber tow containing 85 percent or more by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, raw white (undyed), crimped, with an average decitex of 3.3 (plus or minus 10 percent) and an aggregate filament measure in the tow bundle between 660,000 and 1,200,000 decitex, with a length greater than 2 meters (provided for in subheading 5501.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.02",
      "rawHtsCode": "9902.13.02",
      "superior": null,
      "indent": "0",
      "description": "Acrylic filament tow (polyacrylonitrile tow), containing by weight 92 percent or more of polyacrylonitrile, not more than 0.01 percent of zinc and 2 percent or more but not over 8 percent of water, dyed, presented in the form of bundles of crimped product each containing 214,000 filaments (plus or minus 10 percent) with an average decitex of 2.75 (plus or minus 10 percent) and length greater than 2 meters (provided for in subheading 5501.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.03",
      "rawHtsCode": "9902.13.03",
      "superior": null,
      "indent": "0",
      "description": "Acrylic filament tow (polyacrylonitrile tow) containing by weight 92 percent or more of polyacrylonitrile, not more than 0.01 percent of zinc and 2 percent or more but not over 8 percent of water, dyed, presented in the form of bundles of crimped product each containing 214,000 filaments (plus or minus 10 percent) with an average decitex of 3.3 (plus or minus 10 percent) and length greater than 2 meters (provided for in subheading 5501.30.00)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.04",
      "rawHtsCode": "9902.13.04",
      "superior": null,
      "indent": "0",
      "description": "Acrylic filament tow containing 85 percent or more by weight of acrylonitrile units and 2 percent or more but not more than 8 percent of water, dyed, such tow with a decitex of 5.0 to 5.6, an aggregate filament measure in the tow bundle between 660,000 and 1,200,000 and a length greater than 2 m (provided for in subheading 5501.30.00)  ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.05",
      "rawHtsCode": "9902.13.05",
      "superior": null,
      "indent": "0",
      "description": "Acrylic filament tow containing by weight 92 percent or more of polyacrylonitrile, not more than 0.01 percent of zinc and 2 percent or more but not over 8 percent of water, such tow dyed and presented in the form of bundles of crimped product each containing 315,000 to 360,000 filaments, with each filament of 3.3 decitex and with a length greater than 2 m (provided for in subheading 5501.30.00) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.06",
      "rawHtsCode": "9902.13.06",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers (polyacrylonitrile staple) containing at least 85 percent by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, colored, crimped, with an average decitex of 3.0 (plus or minus 10 percent) and fiber length of 50 mm (plus or minus 10 percent) (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.07",
      "rawHtsCode": "9902.13.07",
      "superior": null,
      "indent": "0",
      "description": "Modacrylic staple fibers containing 35 percent or more but not over 85 percent by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, not pigmented (ecru), crimped, with an average decitex of 2.2 (plus or minus 10 percent) and fiber length of 38 mm (plus or minus 10 percent) (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.08",
      "rawHtsCode": "9902.13.08",
      "superior": null,
      "indent": "0",
      "description": "Modacrylic staple fibers containing 35 percent or more but not over 85 percent by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, not pigmented (ecru), crimped, with an average decitex of 2.2 (plus or minus 10 percent) and fiber length of 51 mm (plus or minus 10 percent) (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.09",
      "rawHtsCode": "9902.13.09",
      "superior": null,
      "indent": "0",
      "description": "Modacrylic staple fibers containing 35 percent or more but not over 85 percent by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, not pigmented (ecru), crimped, with an average decitex of 1.7 (plus or minus 10 percent) and fiber length of 51 mm (plus or minus 10 percent) (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.10",
      "rawHtsCode": "9902.13.10",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers containing at least 85 percent by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, raw white (undyed), crimped, with an average decitex of 1.3 (plus or minus 10 percent) and fiber length of 38 mm (plus or minus 10 percent) (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.11",
      "rawHtsCode": "9902.13.11",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers (polyacrylonitrile staple) containing 85 percent or more by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, dyed (not pigmented), crimped, with an average decitex of 1.3 (plus or minus 10 percent) and fiber length of 40 mm (plus or minus 10 percent) (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.12",
      "rawHtsCode": "9902.13.12",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers (polyacrylonitrile staple) containing 85 percent or more by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, non-pigmented (ecru), crimped, with a decitex between 1.98 and 2.42 and fiber length between 48 and 60 mm (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.13",
      "rawHtsCode": "9902.13.13",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers (polyacrylonitrile staple) containing 85 percent or more by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, colored, crimped, with a decitex between 1.98 and 2.42 and fiber length between 40 and 47.5 mm, certified by the importer as having a solar reflectance index less than 10 (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.14",
      "rawHtsCode": "9902.13.14",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers (polyacrylonitrile staple) containing 85 percent or more by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, colored, crimped, with a decitex between 1.98 and 2.42 and fiber length between 40 and 47.5 mm, certified by the importer as having a solar reflectance index between 10 and 30 (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.15",
      "rawHtsCode": "9902.13.15",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers (polyacrylonitrile staple) containing 85 percent or more by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, colored, crimped, with a decitex between 1.98 and 2.42 and fiber length between 40 and 47.5 mm, certified by the importer as having a solar reflectance index greater than 30 (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.16",
      "rawHtsCode": "9902.13.16",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers (polyacrylonitrile staple) containing 85 percent or more by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, colored, crimped, with a decitex between 1.98 and 2.42 and fiber length between 48 and 60 mm, certified by the importer as having a solar reflectance index less than 10 (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.17",
      "rawHtsCode": "9902.13.17",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers (polyacrylonitrile staple) containing 85 percent or more by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, colored, crimped, with a decitex between 1.98 and 2.42 and fiber length between 48 and 60 mm, certified by the importer as having a solar reflectance index between 10 and 30 (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.18",
      "rawHtsCode": "9902.13.18",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers (polyacrylonitrile staple) containing 85 percent or more by weight of acrylonitrile units and 2 percent or more but not over 3 percent of water, colored, crimped, with a decitex between 1.98 and 2.42 and fiber length between 48 and 60mm, certified by the importer as having a solar reflectance index greater than 30 (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.19",
      "rawHtsCode": "9902.13.19",
      "superior": null,
      "indent": "0",
      "description": "Modacrylic staple fibers containing by weight 2 percent or more but not over 3 percent of water, not pigmented (ecru), crimped, with a decitex of 1.7 and fiber length of 38 mm (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.20",
      "rawHtsCode": "9902.13.20",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers (polyacrylonitrile staple), not dyed and not carded, combed or otherwise processed for spinning, containing by weight 92 percent or more of polyacrylonitrile, not more than 0.01 percent of zinc and 2 percent or more but not over 8 percent of water, with a decitex of 5.0 to 5.6 , with a fiber shrinkage of 0 to 22 percent and with a cut fiber length of 80 mm to 150 mm (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.21",
      "rawHtsCode": "9902.13.21",
      "superior": null,
      "indent": "0",
      "description": "Modacrylic staple fibers, not carded, combed or otherwise processed for spinning, containing over 35 percent and less than 85 percent by weight of acrylonitrile, 2.7 decitex (plus or minus 2 percent), natural in color, with fiber length between 38 mm and 120 mm (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.22",
      "rawHtsCode": "9902.13.22",
      "superior": null,
      "indent": "0",
      "description": "Modacrylic staple fibers, not carded, combed or otherwise processed for spinning, containing over 35 percent and less than 85 percent by weight of acrylonitrile, 3.9 decitex (plus or minus 2 percent), natural in color, with fiber length between 38 mm and 120 mm (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.23",
      "rawHtsCode": "9902.13.23",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fiber (polyacrylonitrile staple), dyed, not carded, combed or otherwise processed for spinning, the foregoing containing by weight 92 percent or more of polyacrylonitrile, not more than 0.01 percent of zinc and 2 percent or more but not over 8 percent of water, with a decitex of 3.3 to 5.6, a fiber shrinkage of from 0 to 22 percent (provided for in subheading 5503.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.24",
      "rawHtsCode": "9902.13.24",
      "superior": null,
      "indent": "0",
      "description": "Artificial staple fibers of viscose rayon, not carded, combed or otherwise processed for spinning and containing 28 percent or more but not over 33 percent by weight of silica (provided for in subheading 5504.10.00); the foregoing other than fibers measuring 2.2 decitex in lengths of 38 mm, measuring 4.7 decitex in lengths of 51 mm or measuring 3.3, 4.7 or 5.0 decitex in lengths of 60 mm",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.25",
      "rawHtsCode": "9902.13.25",
      "superior": null,
      "indent": "0",
      "description": "Staple fibers of viscose rayon, not carded, combed or otherwise processed for spinning, measuring 0.90 or more but not over 1.30 decitex and having a fiber length each measuring 20 mm or more but not over 150 mm (provided for in subheading 5504.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.26",
      "rawHtsCode": "9902.13.26",
      "superior": null,
      "indent": "0",
      "description": "Artificial staple fibers of viscose rayon, not carded, combed or otherwise processed for spinning, measuring 0.5 or more but not over 1.0 decitex and having a fiber length each measuring 4 mm or more but not over 20 mm (provided for in subheading 5504.10.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.27",
      "rawHtsCode": "9902.13.27",
      "superior": null,
      "indent": "0",
      "description": "Flame resistant viscose rayon fibers suitable for yarn spinning, with minimum fiber tenacity of 25 cN/tex, based on modal fiber derived from beechwood and containing 20 to 22 percent by weight of phosphorus-based flame retardant agent (provided for in subheading 5504.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.28",
      "rawHtsCode": "9902.13.28",
      "superior": null,
      "indent": "0",
      "description": "Viscose rayon staple fibers having a decitex of less than 5.0 and a trilobal multi-limbed cross-section, the limbs having a length-to-width aspect ratio of at least 2:1, suitable for use in producing goods of heading 9619 (provided for in subheading 5504.10.00)",
      "units": [],
      "generalRate": "1.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.29",
      "rawHtsCode": "9902.13.29",
      "superior": null,
      "indent": "0",
      "description": "Artificial staple fibers of viscose rayon, not carded, combed or otherwise processed for spinning, such fibers containing between 28 percent and 33 percent by weight of silica, measuring 4.7 decitex in lengths of 60 mm (provided for in subheading 5504.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.30",
      "rawHtsCode": "9902.13.30",
      "superior": null,
      "indent": "0",
      "description": "Artificial staple fibers of viscose rayon, not carded, combed or otherwise processed for spinning, such fibers containing between 28 percent to 33 percent by weight of silica, measuring 3.3 decitex, in lengths of 60 mm (provided for in subheading 5504.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.31",
      "rawHtsCode": "9902.13.31",
      "superior": null,
      "indent": "0",
      "description": "Artificial staple fibers, not carded, combed or otherwise processed for spinning, of viscose rayon, containing between 28 percent and 33 percent by weight of silica, measuring 5.0 decitex in lengths of 60 mm (provided for in subheading 5504.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.32",
      "rawHtsCode": "9902.13.32",
      "superior": null,
      "indent": "0",
      "description": "Artificial staple fibers, not carded, combed or otherwise processed for spinning; of viscose rayon, such fibers containing between 28 percent and 33 percent by weight of silica, measuring 2.2 decitex in 38 mm lengths (provided for in subheading 5504.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.33",
      "rawHtsCode": "9902.13.33",
      "superior": null,
      "indent": "0",
      "description": "Artificial staple fibers of viscose rayon, not carded, combed or otherwise processed for spinning, containing between 28 and 33 percent by weight of silica, measuring 4.7 decitex in 51 mm lengths (provided for in subheading 5504.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.34",
      "rawHtsCode": "9902.13.34",
      "superior": null,
      "indent": "0",
      "description": "Artificial staple fibers of lyocell, not carded, combed or otherwise processed for spinning, measuring 1.7 or more but not over 3.3 decitex and having a fiber length each measuring 25 mm or more but not over 51 mm and containing 25 percent by weight of kaolin (provided for in subheading 5504.90.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.35",
      "rawHtsCode": "9902.13.35",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers, carded, combed or otherwise processed for spinning (provided for in subheading 5506.30.00); the foregoing other than such acrylic staple fibers containing by weight 92 percent or more of polyacrylonitrile, not more than 0.01 percent of zinc and 2 percent or more but not over 8 percent of water, dyed or raw white (undyed), with an average decitex of 2.75 to 3.30 or of 11 (plus or minus 10 percent) or if dyed with an average decitex of 5.0 to 5.6",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.36",
      "rawHtsCode": "9902.13.36",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers, carded, combed or otherwise processed for spinning, containing by weight 92 percent or more of polyacrylonitrile, not more than 0.01 percent of zinc and 2 percent or more but not over 8 percent of water, dyed or raw white (undyed), with an average decitex of 2.75 to 3.30 (plus or minus 10 percent) (provided for in subheading   5506.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.37",
      "rawHtsCode": "9902.13.37",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers, carded, combed or otherwise processed for spinning, containing by weight 92 percent or more of polyacrylonitrile, not more than 0.01 percent of zinc and 2 percent or more but not over 8 percent of water, such fibers dyed or raw white (undyed), such fibers with an average decitex of 11.0 (plus or minus 10 percent) (provided for in subheading 5506.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.38",
      "rawHtsCode": "9902.13.38",
      "superior": null,
      "indent": "0",
      "description": "Acrylic staple fibers, carded, combed or otherwise processed for spinning, containing by weight 92 percent or more of polyacrylonitrile, not more than 0.01 percent of zinc and 2 percent or more but not over 8 percent of water, dyed, with an average decitex of 5.0 to 5.6 (provided for in subheading 5506.30.00)  ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.39",
      "rawHtsCode": "9902.13.39",
      "superior": null,
      "indent": "0",
      "description": "Staple fibers of rayon, carded, combed or otherwise processed for spinning, the foregoing presented in the form of top (provided for in subheading 5507.00.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.40",
      "rawHtsCode": "9902.13.40",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of synthetic staple fibers, containing 85 percent or more by weight of polyvinyl alcohol staple fibers and up to 15 percent of polynosic rayon fibers (provided for in subheading 5512.99.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.41",
      "rawHtsCode": "9902.13.41",
      "superior": null,
      "indent": "0",
      "description": "Woven fabrics of modal staple rayon fibers, containing over 50 percent but less than 85 percent by weight of such fibers, dyed, mixed mainly or solely with cotton, such fabrics weighing more than 270 g/m2 but not more than 340 g/m2, of yarns of number 42 or lower number, of a thread count of 150 to 160 per cm2, napped (provided for in subheading 5516.42.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.42",
      "rawHtsCode": "9902.13.42",
      "superior": null,
      "indent": "0",
      "description": "Carpets and other textile floor coverings, tufted, whether or not made up, of wool or fine animal hair, hand-hooked, that is, in which the tufts were inserted by hand or by means of a hand tool that is not power-driven (provided for in subheading 5703.10.20)",
      "units": [],
      "generalRate": "5.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.43",
      "rawHtsCode": "9902.13.43",
      "superior": null,
      "indent": "0",
      "description": "Polyethylene Terephthalate (PET) heat exchange capillary material consisting of parallel PET tubes arranged and secured in a knitted fabric of PET threads (provided for in subheading 6003.30.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.44",
      "rawHtsCode": "9902.13.44",
      "superior": null,
      "indent": "0",
      "description": "Men's shirts of man-made fibers, knitted or crocheted, with textile- or polymer-based electrodes knitted into or attached to the fabric, incorporating two snaps designed to secure a module to transmit heart rate information from the electrodes to a compatible monitor (provided for in subheading   6105.20.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.45",
      "rawHtsCode": "9902.13.45",
      "superior": null,
      "indent": "0",
      "description": "Tank tops of knitted fabric of man-made fibers, containing elastomeric fibers, each such top with textile or polymer-based electrodes knitted into or attached to the fabric and that incorporates two snaps designed to secure a module designed to transmit heart rate information from the electrodes to a compatible monitor (provided for in subheading 6109.90.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.46",
      "rawHtsCode": "9902.13.46",
      "superior": null,
      "indent": "0",
      "description": "Women's or girls' knitted or crocheted vests of man-made fibers, containing 23 percent or more by weight of wool, each with fabric stitch count greater than 9/2 cm, measured in the direction the stitches are formed (provided for in subheading 6110.30.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.47",
      "rawHtsCode": "9902.13.47",
      "superior": null,
      "indent": "0",
      "description": "Vests (other than sweater vests) for men, knitted or crocheted, of man-made fibers, with textile or polymer-based electrodes knitted into or attached to the fabric and incorporating two snaps designed to secure a module to transmit heart rate information from the electrodes to a compatible monitor (provided for subheadings 6110.30.30)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.48",
      "rawHtsCode": "9902.13.48",
      "superior": null,
      "indent": "0",
      "description": "Men's or boys' knitted or crocheted pullovers and cardigans, containing 70 percent or more by weight of silk, each with more than 9 stitches/2 cm, measured in the direction the stitches were formed, and an average of less than 10 stitches/linear cm in each direction counted on an area measuring at least 10 cm by 10 cm, such apparel articles that reach the waist (provided for in subheading 6110.90.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.49",
      "rawHtsCode": "9902.13.49",
      "superior": null,
      "indent": "0",
      "description": "Men's or boys' knitted or crocheted sweaters of linen, each with 9 or fewer stitches per 2 centimeters measured in the direction the stitches were formed (provided for in subheading 6110.90.90).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.50",
      "rawHtsCode": "9902.13.50",
      "superior": null,
      "indent": "0",
      "description": "Girls' knitted or crocheted coveralls or jumpsuits, of cotton (provided for in subheading 6114.20.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.51",
      "rawHtsCode": "9902.13.51",
      "superior": null,
      "indent": "0",
      "description": "Socks with uppers comprising neoprene measuring 2.5 mm in thickness and covered on both sides with jersey knitted fabric of nylon; such socks with underfoots of breathable neoprene measuring 2.5 to 3 mm in thickness and covered on both sides with a jersey knitted fabric of nylon; the foregoing each formed anatomically so as to be designed for the wearer's left or right foot (provided for in subheading 6115.96.90)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.52",
      "rawHtsCode": "9902.13.52",
      "superior": null,
      "indent": "0",
      "description": "Socks of synthetic fibers, with uppers of neoprene measuring 3.5 mm in thickness and covered on both surfaces with knitted jersey fabric of nylon; each such sock having an integrated fold-down cuff of knitted jersey fabric of nylon, each cuff with a molded hook to allow connection to wading boot and designed to prevent debris and gravel from getting inside wading boot, such socks anatomically formed (provided for in subheading 6115.96.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.53",
      "rawHtsCode": "9902.13.53",
      "superior": null,
      "indent": "0",
      "description": "Training gloves of vulcanized rubber other than of hard rubber (provided for in subheading 4015.19.50) or of synthetic textile materials (provided for in subheading 6116.93.08), such gloves of textile materials knitted or crocheted\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.54",
      "rawHtsCode": "9902.13.54",
      "superior": null,
      "indent": "0",
      "description": "Hand muffs of knitted fabrics of polyester coated with plastics, such muffs stuffed with synthetic microfiber for thermal insulation, each with side openings having elastic closures, with one exterior pocket with zipper closure and weighing not more than 453.592 g (provided for in subheading   6117.80.95) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.55",
      "rawHtsCode": "9902.13.55",
      "superior": null,
      "indent": "0",
      "description": "Boys' woven man-made fiber coats, containing 36 percent or more by weight of wool, thigh length or longer, with sleeves, with or without closure and with full front opening (provided for in subheading 6201.13.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.57",
      "rawHtsCode": "9902.13.57",
      "superior": null,
      "indent": "0",
      "description": "Men's or boys' jackets of woven cotton corduroy, less than mid-thigh in length, with long sleeves, with full or partial front opening (provided for in subheading 6201.92.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.58",
      "rawHtsCode": "9902.13.58",
      "superior": null,
      "indent": "0",
      "description": "Boys' woven jackets of man-made fibers, containing 36 percent or more by weight of wool, less than mid-thigh in length, with long sleeves, with full or partial front opening (provided for in subheading 6201.93.55)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.59",
      "rawHtsCode": "9902.13.59",
      "superior": null,
      "indent": "0",
      "description": "Women's or girls' woven padded sleeveless jackets (including vests) of wool, less than mid-thigh in length, with full opening (provided for in subheading 6202.91.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.60",
      "rawHtsCode": "9902.13.60",
      "superior": null,
      "indent": "0",
      "description": "Girls' woven jackets of man-made fibers, containing 36 percent or more by weight of wool, less than mid-thigh in length, with long sleeves, with full or partial front opening (provided for in subheading 6202.93.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.61",
      "rawHtsCode": "9902.13.61",
      "superior": null,
      "indent": "0",
      "description": "Women's dresses, woven, wholly of silk (provided for in subheading 6204.49.10)\n",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.63",
      "rawHtsCode": "9902.13.63",
      "superior": null,
      "indent": "0",
      "description": "Women's skirts and divided skirts, wholly of silk (provided for in subheading 6204.59.40)\n\n",
      "units": [],
      "generalRate": "1.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.64",
      "rawHtsCode": "9902.13.64",
      "superior": null,
      "indent": "0",
      "description": "Women's blouses, shirts and shirt-blouses, woven, wholly of silk (provided for in subheading 6206.10.00)\n\n",
      "units": [],
      "generalRate": "6.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.65",
      "rawHtsCode": "9902.13.65",
      "superior": null,
      "indent": "0",
      "description": "Men's or boys' woven sleepwear of man-made fibers, the foregoing comprising tops and sleepwear bottoms presented separately and not in sets, the foregoing designed to be worn in bed (provided for in subheading 6207.99.85)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.66",
      "rawHtsCode": "9902.13.66",
      "superior": null,
      "indent": "0",
      "description": "Babies' woven trousers of artificial fibers, other than those imported as parts of sets (provided for in subheading 6209.90.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.67",
      "rawHtsCode": "9902.13.67",
      "superior": null,
      "indent": "0",
      "description": "Babies' woven apparel of linen (provided for in subheading 6209.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.68",
      "rawHtsCode": "9902.13.68",
      "superior": null,
      "indent": "0",
      "description": "Women’s sports bras of knitted or woven fabric containing elastomeric fibers but not containing lace, net or embroidery, such goods whether assembled or knitted/crocheted in the piece, each with textile or polymer-based electrodes knitted into or attached to the fabric and incorporating two snaps designed to secure a module designed to transmit heart rate information from the electrodes to a compatible monitor (provided for in subheading 6212.10.90) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.69",
      "rawHtsCode": "9902.13.69",
      "superior": null,
      "indent": "0",
      "description": "Women's shawls, scarves and similar goods, wholly of silk (provided for in subheading 6214.10.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.70",
      "rawHtsCode": "9902.13.70",
      "superior": null,
      "indent": "0",
      "description": "Batting gloves of man-made fibers, specially designed for use in the sport of baseball, with a strap that wraps around the wrist and the back of the hand to secure the glove to the wrist (provided for in subheading 6216.00.46)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.71",
      "rawHtsCode": "9902.13.71",
      "superior": null,
      "indent": "0",
      "description": "Mechanics' work gloves, not knit, of man-made fibers, with fourchettes, the foregoing not containing 36 percent or more by weight of wool or fine animal hair (provided for in subheading 6216.00.58)\n",
      "units": [],
      "generalRate": "9.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.72",
      "rawHtsCode": "9902.13.72",
      "superior": null,
      "indent": "0",
      "description": "Pocket pouches with outer shell of woven textile fabric laminated to an inner layer of knitted fabric, each such pouch with a zippered cargo pocket and other pockets designed to organize tippets and leaders and with dual entry zippers; the foregoing designed to be zipped into fishing waders (provided for in subheading 6217.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.73",
      "rawHtsCode": "9902.13.73",
      "superior": null,
      "indent": "0",
      "description": "Sacks and bags, of undyed woven fabric of nylon multifilament yarns, such yarns not exceeding 10 decitex, the foregoing bags designed for use for packing wool for transport, storage or sale (provided for in subheading 6305.39.00) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.80",
      "rawHtsCode": "9902.13.80",
      "superior": null,
      "indent": "0",
      "description": "Sleeping bag shells, unfilled, of woven taffeta fabric of polyester with thread count between 160 and 210 and formed from yarns between 22 and 112 decitex; such shells each weighing 25 g/m2 or more but not over 250 g/m2; measuring 152 cm to 305 cm in length, with zipper closure, valued not over $7 each (provided for in subheading 6307.90.98) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.82",
      "rawHtsCode": "9902.13.82",
      "superior": null,
      "indent": "0",
      "description": "Nonwoven radial segment and chordal orientation brake segments of oxidized polyacrylonitrile fibers, made up and presented as cut otherwise than into squares or rectangles, such segments formed by needling web and unidirectional tow fabrics together, the foregoing designed for use in aircraft braking systems (provided for in subheading 6307.90.98)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.83",
      "rawHtsCode": "9902.13.83",
      "superior": null,
      "indent": "0",
      "description": "Bins of laminated woven fabric of polypropylene, rectangular or square in shape, collapsible and stackable, measuring 28 liters or more but not over 256 liters in volume and 63.5 cm or less in height, each with sewn-in cardboard inserts and fabric top panel with sewn-in cardboard insert, such panel secured to the bin with cut-to-length strips of hook-and-loop material, such bins each having a fold-down fabric panel with sewn-in cardboard insert, such panel sewn into the interior of the bin; such bins certified by the importer as meeting ASTM D642-15 standards (provided for in subheading 6307.90.98)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.84",
      "rawHtsCode": "9902.13.84",
      "superior": null,
      "indent": "0",
      "description": "Smartphone cases, each attached to integral adjustable armbands wholly of textile materials, with such case of polyester-laminated neoprene, incorporating a clear plastic window for visual access to the smartphone screen and a small opening for headphone wires, whether or not with decorative plastic overlay (provided for in subheading 6307.90.98)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.85",
      "rawHtsCode": "9902.13.85",
      "superior": null,
      "indent": "0",
      "description": "Portable and foldable water or food bowls of textile materials, designed for use by pets (provided for in subheading 6307.90.98)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.86",
      "rawHtsCode": "9902.13.86",
      "superior": null,
      "indent": "0",
      "description": "Agricultural control nets specially designed to protect mandarin trees from bee pollination, such nets of high density polypropylene monofilament, with interspersed eye knots at regular intervals; each net measuring approximately 441.5 m by 12.8 m or 274.3 m x 12.8 m, having finished edges, presented in rolls (provided for in subheading 6307.90.98)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.87",
      "rawHtsCode": "9902.13.87",
      "superior": null,
      "indent": "0",
      "description": "Chest harnesses of textile materials, each designed for attaching cameras of subheading 8525.80.40 to a user's chest; incorporating a waist belt and shoulder straps, each with a plastic connector and thumb screw designed for camera mounting or adjustment (provided for in subheading 6307.90.98)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.88",
      "rawHtsCode": "9902.13.88",
      "superior": null,
      "indent": "0",
      "description": "Adjustable straps of textile materials, designed with small plastic mounts intended to secure cameras of subheading 8525.80.40 to helmets or to other articles (provided for in subheading 6307.90.98)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.89",
      "rawHtsCode": "9902.13.89",
      "superior": null,
      "indent": "0",
      "description": "Textile bags of woven fabric of polyester and coated with thermoplastic polyurethane, each pleated and attached to a ring of plastics and/or metal with internal threads, with a washer and a plastic cap with external threads that screws into the ring to form an expandable circular shaped bag, designed to hold ice and/or cold water (provided for in subheading 6307.90.98)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.90",
      "rawHtsCode": "9902.13.90",
      "superior": null,
      "indent": "0",
      "description": "Mounts of textile materials, designed to attach cameras of subheading 8525.80.40 to a user's wrist, arm or leg; such mounts incorporating hook-and-loop adjustable straps and designed to permit adjustment of the camera viewing angle 360 degrees on the mounted plane and of the camera tilt against that plane (provided for in subheading 6307.90.98)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.91",
      "rawHtsCode": "9902.13.91",
      "superior": null,
      "indent": "0",
      "description": "Made-up color swatches, of cotton, rectangular in shape and each measuring approximately 5.08 cm by 20.32 cm, with pinked edges, such swatches dyed using certified dye colors and each having a bar code to specify its color (provided for in 6307.90.98)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.92",
      "rawHtsCode": "9902.13.92",
      "superior": null,
      "indent": "0",
      "description": "Sports footwear, with outer soles and uppers of rubber or plastics, valued over $12/pair, for men (provided for in subheading 6402.19.90)",
      "units": [],
      "generalRate": "8.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.93",
      "rawHtsCode": "9902.13.93",
      "superior": null,
      "indent": "0",
      "description": "Sports footwear, with outer soles and uppers of rubber or plastics, valued over $12/pair, other than for men (provided for in subheading 6402.19.90)",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.94",
      "rawHtsCode": "9902.13.94",
      "superior": null,
      "indent": "0",
      "description": "Men's work footwear with outer soles and uppers of rubber or plastics, covering the ankle and having an oil-resistant and slip-resistant outer sole (provided for in subheading 6402.91.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.95",
      "rawHtsCode": "9902.13.95",
      "superior": null,
      "indent": "0",
      "description": "Protective active footwear for men (except footwear with waterproof molded bottoms, including bottoms comprising an outer sole and all or part of the upper and except footwear with insulation that provides protection against cold weather) whose height from the bottom of the outer sole to the top of the upper does not exceed 15.34 cm (provided for in subheading 6402.91.42)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.96",
      "rawHtsCode": "9902.13.96",
      "superior": null,
      "indent": "0",
      "description": "Protective active footwear for women, with outer soles and uppers of rubber or plastics (except footwear with waterproof molded bottoms, including bottoms comprising an outer sole and all or part of the upper and except footwear with insulation that provides protection against cold weather) whose height from the bottom of the outer sole to the top of the upper does not exceed 15.34 cm (provided for in subheading 6402.91.42), such footwear, if valued at $26/pr or higher, without openings in the sole or upper designed to vent moisture ",
      "units": [],
      "generalRate": "1.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.97",
      "rawHtsCode": "9902.13.97",
      "superior": null,
      "indent": "0",
      "description": "Protective active footwear for women, with outer soles and uppers of rubber or plastics (except footwear with waterproof molded bottoms, including bottoms comprising an outer sole and all or part of the upper ,and except footwear with insulation that provides protection against cold weather), whose height from the bottom of the outer sole to the top of the upper does not exceed 15.34 cm, covering the ankle, valued over $26/pr; where such protection is imparted by the use of a laminated textile fabric, such footwear with openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to vent moisture (provided for in subheading 6402.91.42)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.98",
      "rawHtsCode": "9902.13.98",
      "superior": null,
      "indent": "0",
      "description": "Footwear for men, with outer soles and uppers of rubber or plastics (except vulcanized footwear and footwear with waterproof molded or vulcanized bottoms, including bottoms comprising an outer sole and all or part of the upper, and except footwear designed to be protective that is incomplete in its condition as imported), valued over $25/pair, whose height from the bottom of the outer sole to the top of the upper does not exceed 25.4 cm, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection includes protection against water that is imparted by the use of a laminated, but not coated, textile fabric; such footwear, if valued over $27, without openings in the bottom and/or side of the sole or covered opening in the upper designed to permit moisture vapor transport from under the foot (provided for in subheading 6402.91.50)\n",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.13.99",
      "rawHtsCode": "9902.13.99",
      "superior": null,
      "indent": "0",
      "description": "Footwear for men, with outer soles and uppers of rubber or plastics (except vulcanized footwear and footwear with waterproof molded or vulcanized bottoms, including bottoms comprising an outer sole and all or part of the upper; and except footwear designed to be protective that is incomplete in its condition as imported), valued over $27/pair, whose height from the bottom of the outer sole to the top of the upper does not exceed 25.4 cm, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection is imparted by the use of a laminated, but not coated, textile fabric; such footwear with openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to permit moisture vapor transport from under the foot (provided for in subheading 6402.91.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.01",
      "rawHtsCode": "9902.14.01",
      "superior": null,
      "indent": "0",
      "description": "Footwear for men with outer soles and uppers of rubber or plastics, such uppers of neoprene measuring 7 mm in thickness, injected with polyurethane on the exterior and covered with knitted fabric wholly of polyester on the interior, with rubber lug bottoms laminated with cement to the upper; such footwear covering the ankle, whose height does not exceed 35.56 cm; waterproof, valued not over $36/pair and designed to be permanently affixed to fishing waders (provided for in subheading 6402.91.50) \n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.02",
      "rawHtsCode": "9902.14.02",
      "superior": null,
      "indent": "0",
      "description": "Footwear for men, with outer soles and uppers of rubber or plastics (except vulcanized footwear and footwear with waterproof molded or vulcanized bottoms, including bottoms comprising an outer sole and all or part of the upper, and except footwear designed to be protective that is incomplete in its condition as imported), valued over $25/pair, whose height from the bottom of the outer sole to the top of the upper does not exceed 25.4 cm, covering the ankle, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection includes protection against water that is imparted by the use of a coated, but not laminated, textile fabric greater than or equal to 9 microns in thickness (provided for in subheading 6402.91.50)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.03",
      "rawHtsCode": "9902.14.03",
      "superior": null,
      "indent": "0",
      "description": "Men's footwear with outer soles and uppers of rubber or plastics, with foxing or foxing-like band, covering the ankle, closed toe or heel, valued over $3 but not over $6.50 per pair, the foregoing other than sports footwear and protective, waterproof or slip-on type footwear (provided for in subheading 6402.91.70)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.04",
      "rawHtsCode": "9902.14.04",
      "superior": null,
      "indent": "0",
      "description": "Men's footwear with outer soles and uppers of rubber or plastics (other than sports footwear), with foxing or foxing like band, covering the ankle, closed toe or heel, valued over $6.50 but not over $12.00 per pair, not of the protective, waterproof or slip-on type (provided for in subheading 6402.91.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.05",
      "rawHtsCode": "9902.14.05",
      "superior": null,
      "indent": "0",
      "description": "Footwear with outer soles and uppers of rubber or plastics, having uppers of which over 90 percent of the external surface area is rubber or plastics, made on a base or platform of wood (provided for in subheading 6402.99.23)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.06",
      "rawHtsCode": "9902.14.06",
      "superior": null,
      "indent": "0",
      "description": "Footwear with outer soles and uppers of rubber or plastics, not covering the ankle, having uppers of which over 90 percent of the external surface area is rubber or plastics, other than tennis shoes, basketball shoes, gym shoes, training shoes and the like, such footwear for women (and other than work footwear), valued $15/pair or higher (provided for in subheading 6402.99.31)",
      "units": [],
      "generalRate": "5.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.07",
      "rawHtsCode": "9902.14.07",
      "superior": null,
      "indent": "0",
      "description": "Work footwear for women, with outer soles and uppers of rubber or plastics, not covering the ankle (provided for in subheading 6402.99.31), the foregoing other than house slippers and other than tennis shoes, basketball shoes, gym shoes, training shoes and the like",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.08",
      "rawHtsCode": "9902.14.08",
      "superior": null,
      "indent": "0",
      "description": "Work footwear for men, with outer soles and uppers of rubber or plastics, not covering the ankle (provided for in subheading 6402.99.31), the foregoing other than house slippers and other than tennis shoes, basketball shoes, gym shoes, training shoes and the like ",
      "units": [],
      "generalRate": "3.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.09",
      "rawHtsCode": "9902.14.09",
      "superior": null,
      "indent": "0",
      "description": "Footwear excluded from classification in subheading 6402.20.00 (zoris) because the thickest point of the sole is more than 9.53 mm thicker than the thinnest point or more than 35 percent thicker than the thinnest point; such footwear otherwise meeting the requirements for classification in subheading 6402.20.00 (provided for in subheading 6402.99.31)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.10",
      "rawHtsCode": "9902.14.10",
      "superior": null,
      "indent": "0",
      "description": "Women’s footwear with outer soles of rubber or plastics measuring not over 14 mm in thickness and with uppers of plastics, such footwear designed for use in cheerleading activities, valued over $15/pair and weighing no more than 0.5 kg/pair (provided for in subheading 6402.99.31)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.11",
      "rawHtsCode": "9902.14.11",
      "superior": null,
      "indent": "0",
      "description": "Protective active footwear for men, with outer soles and uppers of rubber or plastics, not covering the ankle, valued over $24/pair (provided for in subheading 6402.99.32)",
      "units": [],
      "generalRate": "9.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.12",
      "rawHtsCode": "9902.14.12",
      "superior": null,
      "indent": "0",
      "description": "Protective active footwear for women, with outer soles and uppers of rubber or plastics, not covering the ankle, valued over $24/pair (provided for in subheading 6402.99.32); the foregoing footwear, if valued over $26/pair, other than footwear which provides protection against water that is imparted by the use of a laminated textile fabric and with openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to vent moisture ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.13",
      "rawHtsCode": "9902.14.13",
      "superior": null,
      "indent": "0",
      "description": "Protective active footwear for women, with outer soles and uppers of rubber or plastics, not covering the ankle, which provides protection against water that is imparted by the use of a laminated textile fabric and with openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to vent moisture; the forgoing footwear valued over $26/pair (provided for in subheading 6402.99.32)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.14",
      "rawHtsCode": "9902.14.14",
      "superior": null,
      "indent": "0",
      "description": "Footwear for women, with outer soles and uppers of rubber or plastics (except vulcanized footwear and footwear with waterproof molded bottoms or vulcanized bottoms, including bottoms comprising an outer sole and all or part of the upper, and except footwear designed to be protective that is incomplete in its condition as imported), not covering the ankle or having a protective metal-toe cap, valued over $25/pair, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection includes protection against water that is imparted by the use of a laminated textile fabric (provided for in subheading 6402.99.33)\n\n",
      "units": [],
      "generalRate": "0.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.15",
      "rawHtsCode": "9902.14.15",
      "superior": null,
      "indent": "0",
      "description": "Footwear for women, with outer soles and uppers of rubber or plastics (except vulcanized footwear and footwear with waterproof molded bottoms or vulcanized bottoms, including bottoms comprising an outer sole and all or part of the upper, and except footwear designed to be protective that is incomplete in its condition as imported), not covering the ankle or having a protective metal-toe cap, valued over $27/pair, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection is imparted by the use of a laminated textile and has openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to permit moisture vapor transport from under the foot (provided for in subheading 6402.99.33)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.16",
      "rawHtsCode": "9902.14.16",
      "superior": null,
      "indent": "0",
      "description": "Footwear for other persons, with outer soles and uppers of rubber or plastics (except vulcanized footwear and footwear with waterproof molded bottoms or vulcanized bottoms, including bottoms comprising an outer sole and all or part of the upper, and except footwear designed to be protective that is incomplete in its condition as imported), not covering the ankle or having a protective metal-toe cap, valued over $18/pair, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection is imparted by the use of a laminated textile and has openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to permit moisture vapor transport from under the foot (provided for in subheading 6402.99.33)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.17",
      "rawHtsCode": "9902.14.17",
      "superior": null,
      "indent": "0",
      "description": "Footwear for women, with outer soles and uppers of rubber or plastics (except vulcanized footwear and footwear with waterproof molded bottoms or vulcanized bottoms, including bottoms comprising an outer sole and all or part of the upper, and except footwear designed to be protective that is incomplete in its condition as imported); the foregoing not covering the ankle or having a protective metal-toe cap, valued over $25/pair, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection includes protection against water that is imparted by the use of a coated textile fabric greater than or equal to 9 microns in thickness (provided for in subheading 6402.99.33)",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.18",
      "rawHtsCode": "9902.14.18",
      "superior": null,
      "indent": "0",
      "description": "Women’s footwear with outer soles and uppers of rubber or plastics, each sole measuring not over 12 mm in thickness, the foregoing footwear designed for use in cheerleading activities, valued over $19/pair and weighing not over 0.5 kg/pair (provided for in subheading 6402.99.90) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.19",
      "rawHtsCode": "9902.14.19",
      "superior": null,
      "indent": "0",
      "description": "Golf shoes for men, youths and boys, with outer soles of rubber, plastics, leather or composition leather and uppers of leather (except pigskin uppers), not welt, the foregoing with spikes, sprigs, cleats, stops, clips, bars or the like intended to enhance traction and grip; such footwear designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather, where such protection is imparted by the use of a laminated textile and has openings in the bottom and/or side of the sole or covered openings in the upper above the sole, or a combination thereof, designed to vent moisture (provided for in subheading 6403.19.30)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.20",
      "rawHtsCode": "9902.14.20",
      "superior": null,
      "indent": "0",
      "description": "Footwear for women, with outer soles of rubber or plastics and uppers of leather, made on a base or platform of wood (provided for in subheading 6403.99.20)",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.21",
      "rawHtsCode": "9902.14.21",
      "superior": null,
      "indent": "0",
      "description": "Work footwear for men, with outer soles of rubber or plastics and uppers of leather, not covering the ankle, incorporating a protective toe cap of materials other than metal (provided for in subheading 6403.99.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.22",
      "rawHtsCode": "9902.14.22",
      "superior": null,
      "indent": "0",
      "description": "House slippers with outer soles of rubber or plastics and uppers of leather, for men, youths and boys (provided for in subheading 6403.99.60) \n",
      "units": [],
      "generalRate": "5.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.23",
      "rawHtsCode": "9902.14.23",
      "superior": null,
      "indent": "0",
      "description": "Footwear for men, with uppers of leather (other than of pigskin) and outer soles of rubber or plastics (the foregoing other than house slippers, work footwear, tennis shoes, basketball shoes, gym shoes, training shoes and the like, and other than slip-on footwear); such footwear not covering the ankle, valued $29/pair or higher, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection is imparted by the use of a laminated textile and has openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to vent moisture (provided for in subheading 6403.99.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.24",
      "rawHtsCode": "9902.14.24",
      "superior": null,
      "indent": "0",
      "description": "Footwear for men, with uppers of leather (other than of pigskin) and outer soles of rubber or plastics; the foregoing other than house slippers, work footwear, tennis shoes, basketball shoes, gym shoes, training shoes and the like, and other than slip-on footwear; such footwear not covering the ankle, valued $27/pair or higher, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection includes protection against water that is imparted by the use of a laminated textile fabric (provided for in subheading    6403.99.60) ",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.25",
      "rawHtsCode": "9902.14.25",
      "superior": null,
      "indent": "0",
      "description": "Work footwear for women, with outer soles of rubber, plastics, leather or composition leather and uppers of leather, the foregoing not covering the ankle, incorporating a protective toe cap of materials other than metal, valued over $2.50 per pair (provided for in subheading 6403.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.26",
      "rawHtsCode": "9902.14.26",
      "superior": null,
      "indent": "0",
      "description": "Footwear for other persons, with uppers of leather (other than of pigskin) and outer soles of rubber or plastics (other than house slippers, work footwear, tennis shoes, basketball shoes, gym shoes, training shoes and the like and other than slip-on footwear), not covering the ankle, valued $20/pair or higher, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection is imparted by the use of a laminated textile and has openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit or a combination thereof, designed to vent moisture; the foregoing, if for women, other than such footwear valued over $29/pair (provided for in subheading 6403.99.90) \n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.27",
      "rawHtsCode": "9902.14.27",
      "superior": null,
      "indent": "0",
      "description": "Footwear for women, with uppers of leather (other than of pigskin) and outer soles of rubber or plastics (other than house slippers, work footwear, tennis shoes, basketball shoes, gym shoes, training shoes and the like and other than slip-on footwear); such footwear not covering the ankle, valued $29/pair or higher, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection is imparted by the use of a laminated textile and has openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to vent moisture (provided for in subheading 6403.99.90)\n",
      "units": [],
      "generalRate": "2.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.28",
      "rawHtsCode": "9902.14.28",
      "superior": null,
      "indent": "0",
      "description": "House slippers with outer soles of rubber or plastics and uppers of leather, valued over $2.50/pair, for women (provided for in subheading 6403.99.90)",
      "units": [],
      "generalRate": "7.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.29",
      "rawHtsCode": "9902.14.29",
      "superior": null,
      "indent": "0",
      "description": "Footwear for women, with uppers of leather (other than of pigskin) and outer soles of rubber or plastics (other than house slippers, work footwear, tennis shoes, basketball shoes, gym shoes, training shoes and the like and other than slip-on footwear); such footwear not covering the ankle, valued $27/pair or higher, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection includes protection against water that is imparted by the use of a laminated textile fabric); the foregoing, if valued $29/pair or higher, other than footwear with openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to vent moisture (provided for in subheading 6403.99.90) ",
      "units": [],
      "generalRate": "6.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.30",
      "rawHtsCode": "9902.14.30",
      "superior": null,
      "indent": "0",
      "description": "Footwear for other persons, with uppers of leather (other than of pigskin) and outer soles of rubber or plastics (other than house slippers, work footwear, tennis shoes, basketball shoes, gym shoes, training shoes and the like and other than slip-on footwear), not covering the ankle, valued $18/pair or higher; such footwear designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection includes protection against water that is imparted by the use of a laminated textile fabric; the foregoing other than footwear for women either (i) valued over $27 per pair, or (ii) if valued over $20/pair, having openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to vent moisture (provided for in subheading 6403.99.90)",
      "units": [],
      "generalRate": "8.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.31",
      "rawHtsCode": "9902.14.31",
      "superior": null,
      "indent": "0",
      "description": "Women’s footwear with uppers of leather and outer soles of rubber or plastics, such soles measuring not over 9 mm in thickness, the foregoing designed for use in cheerleading activities, valued over $19/pair and weighing no more than 0.5 kg/pair (provided for in subheading 6403.99.90) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.32",
      "rawHtsCode": "9902.14.32",
      "superior": null,
      "indent": "0",
      "description": "Women's sports footwear; tennis shoes, basketball shoes, gym shoes, training shoes and the like, with outer soles of rubber or plastics and uppers textile materials, such uppers of which over 50 percent of the external surface area (including any leather accessories or reinforcements such as those mentioned in note 4(a) to ch. 64) is leather (provided for in subheading 6404.11.20) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.33",
      "rawHtsCode": "9902.14.33",
      "superior": null,
      "indent": "0",
      "description": "Footwear other than for men or women, with uppers of textile materials and outer soles of rubber or plastics, of an athletic type, exclusively of adhesive construction, without a foxing or foxing-like band; such footwear valued over $3 but not over $6.50 per pair (provided for in subheading 6404.11.69)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.34",
      "rawHtsCode": "9902.14.34",
      "superior": null,
      "indent": "0",
      "description": "Ski boots, cross country ski footwear or snowboard boots, constructed with a forward-leaning upper or designed to attach securely to skis or a snowboard by means of bindings, the foregoing valued over $12/pair, with outer soles of rubber, plastics, leather or composition leather and uppers of textile materials (provided for in subheading 6404.11.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.35",
      "rawHtsCode": "9902.14.35",
      "superior": null,
      "indent": "0",
      "description": "Sports footwear for women, with outer soles of rubber or plastics and uppers of textile materials, valued over $20/pair, other than ski boots, cross country ski footwear and snowboard boots; such footwear designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection is imparted by the use of a laminated textile and has openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to vent moisture (provided for in subheading 6404.11.90)",
      "units": [],
      "generalRate": "12.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.36",
      "rawHtsCode": "9902.14.36",
      "superior": null,
      "indent": "0",
      "description": "Sports footwear for men, with outer soles of rubber or plastics and uppers of textile materials, valued over $20/pair, other than ski boots, cross country ski footwear and snowboard boots; such footwear designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection is imparted by the use of a laminated textile and has openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to vent moisture (provided for in subheading 6404.11.90)\n",
      "units": [],
      "generalRate": "14.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.37",
      "rawHtsCode": "9902.14.37",
      "superior": null,
      "indent": "0",
      "description": "Footwear for men, with vulcanized uppers of neoprene measuring 7 mm in thickness, covered with a polyester knit fleece on the interior and coated with rubber on the exterior, such footwear measuring in height (from the base of the inner sole to the top of the upper) 20.32 cm or more but not over 25.4 cm, with a cemented rubber sole; the foregoing waterproof, valued per pair at $40 or higher, with each boot having a slit in the top of upper collar designed to allow boot to be affixed to a fishing wader (provided for in subheading 6404.19.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.38",
      "rawHtsCode": "9902.14.38",
      "superior": null,
      "indent": "0",
      "description": "Footwear for women, with outer soles of rubber, plastics, leather or composition leather and uppers of textile materials (except vulcanized footwear and footwear with waterproof molded or vulcanized bottoms, including bottoms comprising an outer sole and all or part of the upper, work footwear and footwear designed to be protective that is incomplete in its condition as imported); such footwear valued over $25/pair, not covering the ankle, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection includes protection against water that is imparted by the use of a laminated textile fabric (provided for in subheading 6404.19.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.39",
      "rawHtsCode": "9902.14.39",
      "superior": null,
      "indent": "0",
      "description": "Footwear for women, with outer soles of rubber, plastics, leather or composition leather and uppers of textile materials (except vulcanized footwear and footwear with waterproof molded or vulcanized bottoms, including bottoms comprising an outer sole and all or part of the upper, work footwear, and except footwear designed to be protective that is incomplete in its condition as imported), valued over $27/pair, not covering the ankle, designed to be worn in lieu of, but not over, other footwear as a protection against water, oil, grease or chemicals or cold or inclement weather where such protection is imparted by the use of a laminated textile and has openings in the bottom and/or side of the sole, or covered openings in the upper above the sole unit, or a combination thereof, designed to vent moisture (provided for in subheading 6404.19.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.40",
      "rawHtsCode": "9902.14.40",
      "superior": null,
      "indent": "0",
      "description": "Footwear for women, with uppers of vegetable fibers, with open toes or open heels, having uppers of which at least 30 percent of the external surface area (including any sheepskin accessories or reinforcements such as those mentioned in note 4(a) to chapter 64) is sheepskin; the foregoing having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to chapter 64 (provided for in subheading 6404.19.36)",
      "units": [],
      "generalRate": "5.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.41",
      "rawHtsCode": "9902.14.41",
      "superior": null,
      "indent": "0",
      "description": "Footwear (other than for women) with uppers of vegetable fibers, with open toes or open heels, having uppers of which at least 30 percent of the external surface area (including any sheepskin accessories or reinforcements such as those mentioned in note 4(a) to chapter 64) is sheepskin; the foregoing having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to chapter 64 (provided for in subheading 6404.19.36)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.42",
      "rawHtsCode": "9902.14.42",
      "superior": null,
      "indent": "0",
      "description": "Footwear with outer soles of rubber or plastics, with uppers of textile material other than vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional note U.S. note 5 to chapter 64, with open toes or open heels or of the slip-on type, weighing 10 percent or more of rubber or plastics, valued $15/pair or higher; the foregoing for women (other than house slippers) (provided for in subheading 6404.19.37)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.43",
      "rawHtsCode": "9902.14.43",
      "superior": null,
      "indent": "0",
      "description": "Footwear with outer soles of rubber or plastics, with uppers of textile material other than vegetable fibers and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional note U.S. note 5 to chapter 64, with open toes or open heels or of the slip-on type, weighing 10 percent or more of rubber or plastics, valued at $10 or more but not over $14.99/pair; the foregoing for women (other than house slippers) (provided for in subheading 6404.19.37)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.44",
      "rawHtsCode": "9902.14.44",
      "superior": null,
      "indent": "0",
      "description": "Footwear (other than footwear for men) with outer soles of rubber or plastics and uppers of textile materials other than vegetable fibers, with open toes or open heels, having uppers in which at least 30 percent of the external surface area (including any sheepskin accessories or reinforcements such as those mentioned in note 4(a) to chapter 64) is sheepskin and having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to chapter 64 (provided for in subheading 6404.19.37)",
      "units": [],
      "generalRate": "10.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.45",
      "rawHtsCode": "9902.14.45",
      "superior": null,
      "indent": "0",
      "description": "Footwear for women, with open toes or open heels, containing 10 percent or more by weight of rubber or plastics, with uppers of textile materials and having uppers in which at least 30 percent of the external surface area (including any sheepskin accessories or reinforcements such as those mentioned in note 4(a) to chapter 64) is sheepskin; the foregoing with outer soles of rubber or plastics and not having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to chapter 64 (provided for in subheading 6404.19.39)",
      "units": [],
      "generalRate": "34.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.46",
      "rawHtsCode": "9902.14.46",
      "superior": null,
      "indent": "0",
      "description": "Footwear (other than for women) with open toes or open heels, containing 10 percent or more by weight of rubber or plastics, with uppers of textile materials and having uppers in which at least 30 percent of the external surface area (including any sheepskin accessories or reinforcements such as those mentioned in note 4(a) to chapter 64) is sheepskin; the foregoing with outer soles of rubber or plastics and not having outer soles with textile materials having the greatest surface area in contact with the ground, but not taken into account under the terms of additional U.S. note 5 to chapter 64 (provided for in subheading 6404.19.39)",
      "units": [],
      "generalRate": "31.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.47",
      "rawHtsCode": "9902.14.47",
      "superior": null,
      "indent": "0",
      "description": "Footwear with uppers of vegetable fibers (other than such footwear for men or women), whether with outer soles of rubber or plastics (provided for in subheading 6404.11.41, 6404.11.51, 6404.11.61, 6404.11.71, 6404.11.81, 6404.19.36, 6404.19.42, 6404.19.52, 6404.19.72 or 6404.19.82) or with outer soles of materials other than leather or composition leather (provided for in subheading 6405.20.30)",
      "units": [],
      "generalRate": "7.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.48",
      "rawHtsCode": "9902.14.48",
      "superior": null,
      "indent": "0",
      "description": "House slippers with outer soles of rubber or plastics and uppers of textile materials other than vegetable fibers, valued over $6.50 but not over $12/pair, such outer soles with textile materials having the greatest surface area in contact with the ground but not taken into account under the terms of additional U.S. note 5 to chapter 64 (provided for in subheading 6404.19.87)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.49",
      "rawHtsCode": "9902.14.49",
      "superior": null,
      "indent": "0",
      "description": "Footwear for men, valued over $24/pair, covering the ankle but not covering the knee, with outer soles of rubber or plastics and uppers of textile materials (provided for in subheading 6404.19.90)",
      "units": [],
      "generalRate": "8.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.50",
      "rawHtsCode": "9902.14.50",
      "superior": null,
      "indent": "0",
      "description": "Footwear for men or women, with outer soles of rubber or plastics and uppers of textile materials, not covering the ankle, valued over $12/pair, incorporating a protective toe cap of materials other than metal (provided for in subheading 6404.19.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.51",
      "rawHtsCode": "9902.14.51",
      "superior": null,
      "indent": "0",
      "description": "Footwear for women with outer soles of leather or composition leather and uppers of textile materials, not elsewhere specified or included, valued not over $20.00 per pair, the foregoing other than footwear containing less than 10 percent by weight of rubber or plastics and other than containing 50 percent or less by weight of textile materials and rubber or plastics with at least 10 percent by weight being rubber or plastics (provided for in subheading 6404.20.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.52",
      "rawHtsCode": "9902.14.52",
      "superior": null,
      "indent": "0",
      "description": "Footwear for women, with outer soles of leather or composition leather and uppers of textile materials, not elsewhere specified or included, valued over $20.00 per pair; the foregoing other than footwear containing less than 10 percent by weight of rubber or plastics and other than containing 50 percent or less by weight of textile materials and rubber or plastics with at least 10 percent by weight being rubber or plastics (provided for in subheading 6404.20.60) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.53",
      "rawHtsCode": "9902.14.53",
      "superior": null,
      "indent": "0",
      "description": "Footwear for men, with vulcanized uppers of neoprene measuring 7 mm in thickness, covered with a polyester knit fleece on the interior and coated with rubber on the exterior; such footwear measuring (from the base of the inner sole to the top of the upper) 20.32 cm or more but not over 25.4 cm in height, with felt outsoles; the foregoing waterproof, valued at $40 per pair or higher and with each boot having with a slit in the top of upper collar to allow boot to be affixed to a fishing wader (provided for in subheading 6405.20.90)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.54",
      "rawHtsCode": "9902.14.54",
      "superior": null,
      "indent": "0",
      "description": "House slippers with outer soles and uppers of textile materials, each with anti-slip traction dots on the outer sole, incorporating a battery-operated sound or light device (provided for in subheading 6405.20.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.55",
      "rawHtsCode": "9902.14.55",
      "superior": null,
      "indent": "0",
      "description": "Footwear for men, with uppers of which over 50 percent of the external surface is polyurethane measuring 1.4 mm in thickness and with cemented outer soles of which over 50 percent of the external surface is felt, having the characteristics required for normal use, including durability and strength; the foregoing not covering the ankle and valued $20 per pair or higher (provided for in subheading 6405.90.90) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.56",
      "rawHtsCode": "9902.14.56",
      "superior": null,
      "indent": "0",
      "description": "Detachable footwear gravel guards with uppers of 3 mm neoprene, nylon jersey face and underside, each measuring 17.78 cm or more but not over 20.32 cm in height, with tapered fit, designed to be held to the shoe with a hook-and-loop fastener strip and loop wrap to affix together (provided for in subheading 6406.90.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.57",
      "rawHtsCode": "9902.14.57",
      "superior": null,
      "indent": "0",
      "description": "Removable insoles of rubber or plastics, the foregoing designed to provide foot support (provided for in subheading 6406.90.30)",
      "units": [],
      "generalRate": "4.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.58",
      "rawHtsCode": "9902.14.58",
      "superior": null,
      "indent": "0",
      "description": "Hats and headgear of vegetable fibers, of unspun fibrous vegetable materials, of paper yarn or of any combination thereof, plaited but not of plaited strips, sewed (provided for in subheading 6504.00.30)",
      "units": [],
      "generalRate": "4.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.59",
      "rawHtsCode": "9902.14.59",
      "superior": null,
      "indent": "0",
      "description": "Hats and headgear of vegetable fibers, of unspun fibrous vegetable materials, of paper yarn or of any combination thereof, made by assembling strips and sewed (provided for in subheading 6504.00.30)",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.60",
      "rawHtsCode": "9902.14.60",
      "superior": null,
      "indent": "0",
      "description": "Hats and headgear of vegetable fibers, of unspun fibrous vegetable materials, of paper yarn or of any combination thereof, plaited, but not of plaited strips and not sewed (provided for in subheading 6504.00.60)",
      "units": [],
      "generalRate": "3.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.61",
      "rawHtsCode": "9902.14.61",
      "superior": null,
      "indent": "0",
      "description": "Hats and headgear of vegetable fibers, of unspun fibrous vegetable materials, of paper yarn or of any combination thereof, of plaited strips or made by assembling strips and not sewed (provided for in subheading 6504.00.60)",
      "units": [],
      "generalRate": "1.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.62",
      "rawHtsCode": "9902.14.62",
      "superior": null,
      "indent": "0",
      "description": "Hats and other headgear, knitted, or made up in the piece from lace, felt or other textile fabric (but not in strips), of cotton and containing 23 percent or more by weight of wool, the foregoing other than for babies and other than visors, or other headgear which provides no covering for the crown of the head (provided for in subheading 6505.00.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.63",
      "rawHtsCode": "9902.14.63",
      "superior": null,
      "indent": "0",
      "description": "Hats and other headgear, knitted, or made up in the piece from lace, felt or other textile fabric (but not in strips), of cotton and containing less than 23 percent by weight of wool, the foregoing other than for babies, and other than visors, or other headgear that provides no covering for the crown of the head (provided for in subheading 6505.00.15)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.64",
      "rawHtsCode": "9902.14.64",
      "superior": null,
      "indent": "0",
      "description": "Hats and headgear, of man-made fibers, knitted or crocheted or made up from knitted or crocheted fabrics in the piece (but not in strips), not in part of braid, each valued at $5.00 or more (provided for in subheading 6505.00.60)",
      "units": [],
      "generalRate": "6.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.65",
      "rawHtsCode": "9902.14.65",
      "superior": null,
      "indent": "0",
      "description": "Babies' woven hats of man-made fibers, not in part of braid (provided for in subheading 6505.00.80) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.66",
      "rawHtsCode": "9902.14.66",
      "superior": null,
      "indent": "0",
      "description": "Umbrella frames, not presented with bases, the foregoing with aluminum center support poles of a length greater than 2.133 m, whether or not including a tilt function (provided for in subheading 6603.20.90) ",
      "units": [],
      "generalRate": "2.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.67",
      "rawHtsCode": "9902.14.67",
      "superior": null,
      "indent": "0",
      "description": "Foliage and flowers of plastics, representing desert or underwater plants and not exceeding 45.72 cm in height, each assembled by gluing and inserted into a base or suction cup, the foregoing presented put up for retail sale as goods designed for a household terrarium or aquarium (provided for in subheading 6702.10.20)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.68",
      "rawHtsCode": "9902.14.68",
      "superior": null,
      "indent": "0",
      "description": "Foliage and flowers of plastics, representing desert or underwater plants, each inserted directly into a base or suction cup, measuring not over 20.32 cm in height, not assembled by gluing or similar means or by binding with flexible materials such as wire, paper, textile materials or foil; the foregoing presented put up for retail sale as goods designed for a household terrarium or aquarium (provided for in subheading 6702.10.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.69",
      "rawHtsCode": "9902.14.69",
      "superior": null,
      "indent": "0",
      "description": "Polycrystalline fibers containing by weight over 70 percent of alumina and less than 30 percent of silica, the foregoing containing no alkaline oxides or boric oxide, presented in bulk (provided for in subheading 6806.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.70",
      "rawHtsCode": "9902.14.70",
      "superior": null,
      "indent": "0",
      "description": "Catalytic converter needled blanket mats of ceramic fibers, containing over 65 percent by weight of aluminum oxide and not over 3 percent of acrylic latex organic binder, of a basis weight greater than or equal to 1745 g/m2, measuring 10.0 mm or more in thickness; the foregoing presented in bulk, sheets or rolls, designed for use in motor vehicles of heading 8703 (provided for in subheading 6806.10.00).\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.71",
      "rawHtsCode": "9902.14.71",
      "superior": null,
      "indent": "0",
      "description": "Catalytic converter needled blanket mats of ceramic fibers, containing over 65 percent by weight of aluminum oxide and not over 3 percent by weight of acrylic latex organic binder, of a basis weight less than 1745 g/m2, measuring 5.0 mm or more but not over 9.9 mm in thickness; presented in bulk, sheets or rolls, designed for use in motor vehicles of heading 8703 (provided for in subheading 6806.10.00).\n",
      "units": [],
      "generalRate": "0.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.72",
      "rawHtsCode": "9902.14.72",
      "superior": null,
      "indent": "0",
      "description": "Catalytic converter needled blanket mats of ceramic fibers containing over 65 percent by weight of aluminum oxide, containing an acrylic latex organic binder of greater than 3 percent and less than 7 percent by weight, of a basis weight less than 1745 g/m2, measuring at least 5.0 mm or no more than 9.9 mm in thickness, in bulk, sheets or rolls, designed for motor vehicles of heading 8703 (provided for in subheading 6806.10.00).\n",
      "units": [],
      "generalRate": "2.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.73",
      "rawHtsCode": "9902.14.73",
      "superior": null,
      "indent": "0",
      "description": "Catalytic converter needled blanket mats of ceramic fibers, containing over 65 percent by weight of aluminum oxide and 3 percent or more but less than 7 percent by weight of acrylic latex organic binder, measuring 10.0 mm or more in thickness, of a basis weight greater than or equal to 1745 g/m2; presented in bulk, sheets or rolls, designed for use in motor vehicles of heading 8703 (provided for in subheading 6806.10.00).\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.74",
      "rawHtsCode": "9902.14.74",
      "superior": null,
      "indent": "0",
      "description": "Stoneware ceramic slabs each measuring at least 320 cm in length by 144 cm in width (provided for in subheading 6914.90.80)",
      "units": [],
      "generalRate": "4.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.75",
      "rawHtsCode": "9902.14.75",
      "superior": null,
      "indent": "0",
      "description": "Glass in balls (other than microspheres of heading 7018), unworked and not comprising made-up articles, each measuring over 3 mm but not over 6 mm in diameter (provided for in subheading 7002.10.10)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.76",
      "rawHtsCode": "9902.14.76",
      "superior": null,
      "indent": "0",
      "description": "Wired rolled glass, surface ground and polished but not further worked, presented in rectangular shapes and with a thickness of 6.35 mm or more, designed to retain glass fragments within wired sashes when shattered due to exposure to fire or impact (provided for in subheading 7005.30.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.77",
      "rawHtsCode": "9902.14.77",
      "superior": null,
      "indent": "0",
      "description": "Discs of drawn glass, each measuring between 1.4 m and 1.7 m in diameter, between 40 and 50 mm in thickness and between 200 and 250 kg in weight, the foregoing having been machined so as to render one surface concave in shape and the opposite surface convex in shape, the foregoing not framed or fitted with other materials and not designed to manipulate light to create an optical effect (provided for in subheading 7006.00.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.78",
      "rawHtsCode": "9902.14.78",
      "superior": null,
      "indent": "0",
      "description": "Tempered glass covers for cooking ware, such covers produced by automatic machine (provided for in subheading 7010.20.20)",
      "units": [],
      "generalRate": "0.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.79",
      "rawHtsCode": "9902.14.79",
      "superior": null,
      "indent": "0",
      "description": "Kitchenware of glass-ceramics, non-glazed and greater than 75 percent by volume crystalline (provided for in subheading 7013.10.10)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.80",
      "rawHtsCode": "9902.14.80",
      "superior": null,
      "indent": "0",
      "description": "Opaque cooking ware of glass-ceramics (provided for in subheading 7013.10.50)",
      "units": [],
      "generalRate": "7.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.81",
      "rawHtsCode": "9902.14.81",
      "superior": null,
      "indent": "0",
      "description": "Sets of coasters of glass, not pressed or toughened (specially tempered), each printed with a cross-sectional image of an object after formation of the glass which, when the coasters in any set are stacked, depict a three-dimensional image of such object; each coaster with attached protective rubber feet and valued over $0.30 each but not over $3 each (provided for in subheading 7013.99.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.82",
      "rawHtsCode": "9902.14.82",
      "superior": null,
      "indent": "0",
      "description": "Vases of blown glass, not pressed or toughened (specially tempered), with blown-in color, the foregoing with no decoration from glass, metal flecking, pictorial scenes or thread- or ribbon-like effects embedded or introduced into the body of such goods prior to solidification; measuring at least 15.2 cm but not over 20.4 cm in height, with an opening at least 11.4 cm but not more than 12.7 cm wide, valued not over $3.00 each; presented without seeds or stones (provided for in subheading 7013.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.83",
      "rawHtsCode": "9902.14.83",
      "superior": null,
      "indent": "0",
      "description": "Vases of blown glass, not pressed or toughened (specially tempered), with blown-in color, the foregoing with no decoration from glass, metal flecking, pictorial scenes or thread- or ribbon-like effects embedded or introduced into the body of such goods prior to solidification; measuring over 20.4 cm but not over 25.4 cm in height, with an opening at least 11.4 cm but not more than 12.7 cm wide, valued not over $3.00 each; presented without seeds or stones (provided for in subheading 7013.99.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.84",
      "rawHtsCode": "9902.14.84",
      "superior": null,
      "indent": "0",
      "description": "Mouth-blown decorative figures of birds, of glass, valued over $15.00 each and identifiable by a pontil mark (provided for in subheading 7013.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.85",
      "rawHtsCode": "9902.14.85",
      "superior": null,
      "indent": "0",
      "description": "Chopped strands of glass, of a length greater than 50 mm, containing over 90 percent silica by weight (provided for in subheading 7019.19.30)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.86",
      "rawHtsCode": "9902.14.86",
      "superior": null,
      "indent": "0",
      "description": "Slivers of glass, containing over 90 percent silica by weight (provided for in subheading 7019.19.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.87",
      "rawHtsCode": "9902.14.87",
      "superior": null,
      "indent": "0",
      "description": "Liquid-filled glass bulbs designed for use in sprinkler systems and other release devices (provided for in subheading 7020.00.60)",
      "units": [],
      "generalRate": "1.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.88",
      "rawHtsCode": "9902.14.88",
      "superior": null,
      "indent": "0",
      "description": "Silver wire, containing 90 percent or more by weight of silver, but not more than 93 percent by weight of silver, and containing 6 percent or more by weight of tin oxide, but not more than 9 percent by weight of tin oxide (provided for in subheading 7106.92.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.89",
      "rawHtsCode": "9902.14.89",
      "superior": null,
      "indent": "0",
      "description": "Silver in semimanufactured form, containing by weight 87 to 89 percent of silver, 11 to 13 percent of tin and 0.1 to 0.7 percent of copper oxide, presented in the form of strip and certified by the importer as suitable for use in electrical contact systems intended for the manufacture of switches and relays (provided for in subheading 7106.92.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.90",
      "rawHtsCode": "9902.14.90",
      "superior": null,
      "indent": "0",
      "description": "Gauzes containing platinum, palladium and rhodium (provided for in subheading 7115.10.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.91",
      "rawHtsCode": "9902.14.91",
      "superior": null,
      "indent": "0",
      "description": "Clad strips of silver, further worked than semimanufactured, each containing 54 percent or more but not over 56 percent by weight of silver; having three layers with one layer containing 87 percent or more but not over 89 percent by weight of silver and 11 percent or more but not over 3 percent of tin, a second layer containing 99.9 percent or more by weight of silver, and a third layer containing 14.5 percent or more but not over 15.5 percent by weight of silver, 79 percent or more but not over 81 percent of copper and 4.8 percent or more but not over 5.2 percent of phosphorus; measuring 15.65 mm in width and 0.95 mm in thickness, presented in coils (provided for in subheading 7115.90.40)\n\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.92",
      "rawHtsCode": "9902.14.92",
      "superior": null,
      "indent": "0",
      "description": "Pins and metal inserts of iron, fully plated in gold, silver or bronze color, engraved or shaped to memorialize current year, replicate school mascots or symbolize academic, sport, fine arts and guard achievements, such pins or inserts valued not more than $0.20 each (provided for in subheading 7117.19.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.93",
      "rawHtsCode": "9902.14.93",
      "superior": null,
      "indent": "0",
      "description": "Ferroboron to be used for manufacturing amorphous metal strip (provided for in subheading 7202.99.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.94",
      "rawHtsCode": "9902.14.94",
      "superior": null,
      "indent": "0",
      "description": "Self-tapping screw anchors of steel (provided for in 7318.14.50), each having a shank (body) measuring 6.35 mm in diameter and an internally threaded hex washer head measuring 9.53 mm, having cut threads (provided for in subheading 7318.14.50)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.95",
      "rawHtsCode": "9902.14.95",
      "superior": null,
      "indent": "0",
      "description": "Portable propane gas camping stoves, each with one adjustable burner rated to generate up to 7,650 British thermal units (BTUs) of power, with casing of steel and pan support of steel covered with porcelain, the foregoing valued $4 or more but not over $20 each (provided for in subheading 7321.11.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.96",
      "rawHtsCode": "9902.14.96",
      "superior": null,
      "indent": "0",
      "description": "Handles of stainless steel, the foregoing comprising parts of cooking ware (provided for in subheading 7323.93.00)",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.97",
      "rawHtsCode": "9902.14.97",
      "superior": null,
      "indent": "0",
      "description": "Insulated thermal pitchers, each with stainless steel interior and exterior, with hinged stainless steel lid and a capacity not exceeding 1 liter (provided for in subheading 7323.93.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.98",
      "rawHtsCode": "9902.14.98",
      "superior": null,
      "indent": "0",
      "description": "Wire crates of iron or steel, designed for dogs, the foregoing that can be folded down, less than or equal to 0.76 m in length (provided for in subheading 7323.99.90)",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.14.99",
      "rawHtsCode": "9902.14.99",
      "superior": null,
      "indent": "0",
      "description": "Wire crates of iron or steel, designed for dogs, the foregoing that can be folded down, greater than 0.76 but less than 1.37 m in length (provided for in subheading 7323.99.90)",
      "units": [],
      "generalRate": "1.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.01",
      "rawHtsCode": "9902.15.01",
      "superior": null,
      "indent": "0",
      "description": "Wire cages of iron or steel, each with attached tray of plastics or of steel, such cages with one or two hinged doors for access to inside of cage, the foregoing designed for small pets other than dogs and for use in the home (provided for in subheading 7323.99.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.02",
      "rawHtsCode": "9902.15.02",
      "superior": null,
      "indent": "0",
      "description": "Fire escape ladders no taller than 4.3 m when fully extended, tested to support 510.3 kg of weight and designed to be hung from a window measuring 15 cm or more but not over 25 cm; such ladders each composed of window brackets and rungs (stairs) of steel and rope of man-made fibers that connects the rungs to each other and to the window bracket; with slip resistant rungs and stabilizers, the foregoing for residential use, valued not over $19 each (provided for in subheading 7326.90.86)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.03",
      "rawHtsCode": "9902.15.03",
      "superior": null,
      "indent": "0",
      "description": "Fire escape ladders measuring 4.4 m or more but not more than 7.4 m tall when fully extended, tested to support 510.3 kg of weight and designed to be hung from a window measuring 15 cm or more but not over 25 cm; such ladders each composed of window brackets and rungs (stairs) of steel and rope of man-made fibers that connects the rungs to each other and to the window bracket; with slip resistant rungs and stabilizers, the foregoing for residential use, valued not over $34.50 each (provided for in subheading 7326.90.86)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.04",
      "rawHtsCode": "9902.15.04",
      "superior": null,
      "indent": "0",
      "description": "Belts and bandoliers of iron or steel, not coated or plated with precious metal, the foregoing presented with or without buckle (provided for in subheading 7326.90.86)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.05",
      "rawHtsCode": "9902.15.05",
      "superior": null,
      "indent": "0",
      "description": "Side press wringer handles of steel (provided for in subheading 7326.90.86)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.06",
      "rawHtsCode": "9902.15.06",
      "superior": null,
      "indent": "0",
      "description": "Riser joints of iron or steel, designed to connect drilling rigs to subsea riser containment packages, the foregoing certified by the importer as designed for high bending moments and tension at the bottom and top of riser (provided for in subheading 7326.90.86)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.07",
      "rawHtsCode": "9902.15.07",
      "superior": null,
      "indent": "0",
      "description": "Cold-formed profiles of nickel alloys, having the symmetrical cross section of an isosceles triangle, with a total width between 2.9 mm and 3.1 mm and a height between 3.8 mm and 4.3 mm (provided for in subheading 7505.12.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.08",
      "rawHtsCode": "9902.15.08",
      "superior": null,
      "indent": "0",
      "description": "Cold-formed wire of nickel-titanium alloy, presented in coils, with round cross section, with a diameter of 0.1778 mm or more but not over 0.6350 mm (provided for in subheading 7505.22.10)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.09",
      "rawHtsCode": "9902.15.09",
      "superior": null,
      "indent": "0",
      "description": "Machined loupe mountings of cast aluminum, with polytetrafluoroethylene coating (provided for in subheading 7616.99.51)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.10",
      "rawHtsCode": "9902.15.10",
      "superior": null,
      "indent": "0",
      "description": "Zinc die-cast interior punches, each with a plastic exterior casing (provided for in subheading 7907.00.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.11",
      "rawHtsCode": "9902.15.11",
      "superior": null,
      "indent": "0",
      "description": "Sintered tungsten bars containing 99.95 percent or more by weight of tungsten, in 0.004 mm (4 micron) size, each measuring 49.78 cm to 64.14 cm in length, 19.56 cm to 23.5 cm in width and 3.99 cm to 4.11 cm in thickness (provided for in subheading 8101.94.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.12",
      "rawHtsCode": "9902.15.12",
      "superior": null,
      "indent": "0",
      "description": "Gallium, unwrought and in solid form (provided for in subheading 8112.92.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.13",
      "rawHtsCode": "9902.15.13",
      "superior": null,
      "indent": "0",
      "description": "Ingots of germanium, unwrought, each weighing 0.5 kg or more but less than 2 kg (provided for in subheading 8112.92.60).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.14",
      "rawHtsCode": "9902.15.14",
      "superior": null,
      "indent": "0",
      "description": "Ingots and monocrystalline crystals of germanium, each classifiable as unwrought goods under the terms of additional U.S. note to section XV of the tariff schedule and containing 99.999 percent by weight of germanium (provided for in subheading 8112.92.60), the foregoing other than ingots of germanium, unwrought, each weighing 0.5 kg or more but less than 2 kg\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.15",
      "rawHtsCode": "9902.15.15",
      "superior": null,
      "indent": "0",
      "description": "Secateurs and similar one-handed pruners and shears, each with a gear-driven rotatable handle which provides increased leverage and control to the movement of the blade (provided for in subheading 8201.50.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.16",
      "rawHtsCode": "9902.15.16",
      "superior": null,
      "indent": "0",
      "description": "Two-handed pruning and hedge shears, each with blades articulated around a non-circular gear mechanism (provided for in subheading 8201.60.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.17",
      "rawHtsCode": "9902.15.17",
      "superior": null,
      "indent": "0",
      "description": "Grass shears, each with steel cutting blades articulated on a swivel head for horizontal trimming and vertical edging (provided for in subheading 8201.90.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.18",
      "rawHtsCode": "9902.15.18",
      "superior": null,
      "indent": "0",
      "description": "Tweezers (provided for in subheading 8203.20.20) ",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.20",
      "rawHtsCode": "9902.15.20",
      "superior": null,
      "indent": "0",
      "description": "Hand tools designed for attaching tags to garments with plastic fasteners, each comprising a steel feed mechanism housed in a plastic body and a replaceable hollow needle through which the fastener is fed, then inserted through the garment material (provided for in subheading 8205.59.55)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.21",
      "rawHtsCode": "9902.15.21",
      "superior": null,
      "indent": "0",
      "description": "Steel bench vises, each weighing less than 9 kg, bolt mounted with a 180 degree swivel base and with reversible jaw faces having a jaw width (opening) measuring between 11 and 12 cm (provided for in subheading 8205.70.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.22",
      "rawHtsCode": "9902.15.22",
      "superior": null,
      "indent": "0",
      "description": "Steel bench vises, weighing less than 13.5 kg, bolt mounted with a 180 degree swivel base and reversible jaw faces, having a jaw width (opening) between 13 and 14 cm (provided for in subheading 8205.70.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.23",
      "rawHtsCode": "9902.15.23",
      "superior": null,
      "indent": "0",
      "description": "Steel bench vises, each weighing less than 18.75 kg, bolt mounted with a 180 degree swivel base and with reversible jaw faces, having a jaw width (opening) of between 17 and 18 cm (provided for in subheading 8205.70.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.24",
      "rawHtsCode": "9902.15.24",
      "superior": null,
      "indent": "0",
      "description": "Rotary rock drill bits, each with cutting part containing by weight over 0.2 percent of chromium, molybdenum or tungsten or over 0.1 percent of vanadium (provided for in subheading 8207.19.30), designed for use with rock drilling and earth boring tools of heading 8430 ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.25",
      "rawHtsCode": "9902.15.25",
      "superior": null,
      "indent": "0",
      "description": "Rotary or fixed cutter drill bits, each with cutting part of precious or semiprecious stones (natural, synthetic or reconstructed) on a substrate of base metal or metal carbide mounted to a base metal body, the foregoing designed for use with rock drilling and earth boring tools of heading 8430 (provided for in subheading 8207.19.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.26",
      "rawHtsCode": "9902.15.26",
      "superior": null,
      "indent": "0",
      "description": "Vacuum insulated coffee servers with liners of steel, each with a capacity over 2 liters, containing a brew-through lid and hole at bottom of server for lever faucet attachment (provided for in subheading 8210.00.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.27",
      "rawHtsCode": "9902.15.27",
      "superior": null,
      "indent": "0",
      "description": "Vacuum insulated coffee servers, each with outer layer and liner of steel, with a capacity over 2 liters, with tightly fitted hinged lid with a center hole designed to allow brewed beverages to pass directly into such server with top lever action for dispensing (provided for in subheading 8210.00.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.28",
      "rawHtsCode": "9902.15.28",
      "superior": null,
      "indent": "0",
      "description": "Vacuum insulated coffee servers with liners of steel, each with a capacity over 2 liters, with base but no lid and a hole at bottom of server for lever faucet attachment at time of importation (provided for in subheading 8210.00.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.30",
      "rawHtsCode": "9902.15.30",
      "superior": null,
      "indent": "0",
      "description": "Scissors, valued over $1.75/dozen, designed for use in pet grooming and presented with attached retail labeling or put up for retail sale as goods designed to cut pet hair (provided for in subheading 8213.00.90)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.31",
      "rawHtsCode": "9902.15.31",
      "superior": null,
      "indent": "0",
      "description": "Scissors, valued over $1.75/dozen, each with stainless steel blades, one small loop handle and one larger loop handle and with an overall length of less than 17 cm, the foregoing other than those scissors designed for use in pet grooming and presented with attached retail labeling or put up for retail sale as goods designed to cut pet hair (provided for in subheading 8213.00.90)",
      "units": [],
      "generalRate": "4.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.32",
      "rawHtsCode": "9902.15.32",
      "superior": null,
      "indent": "0",
      "description": "Nail clippers with stainless steel blades,each having one or both blades with rounded edged cut-outs and designed for use in cutting nails of dogs, cats or other small pets (including birds, rabbits, ferrets, hamsters, guinea pigs or gerbils) (provided for in subheading 8214.20.30).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.33",
      "rawHtsCode": "9902.15.33",
      "superior": null,
      "indent": "0",
      "description": "Nail nippers and clippers and nail files, the foregoing other than nail nippers and clippers with one or both blades having rounded edged cut-outs and designed for use in cutting nails of dogs, cats or other small pets (including birds, rabbits, ferrets, hamsters, guinea pigs or gerbils) (provided for in subheading 8214.20.30)",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.34",
      "rawHtsCode": "9902.15.34",
      "superior": null,
      "indent": "0",
      "description": "Manicure and pedicure sets, each set containing clippers, files and similar manicure or pedicure products; the foregoing not in leather containers (provided for in subheading 8214.20.90)",
      "units": [],
      "generalRate": "1.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.35",
      "rawHtsCode": "9902.15.35",
      "superior": null,
      "indent": "0",
      "description": "Padlocks of base metal, of cylinder or pin tumbler construction, each measuring over 3.8 cm but not over 6.4 cm in width, not put up for retail sale (provided for in subheading 8301.10.80)",
      "units": [],
      "generalRate": "2.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.36",
      "rawHtsCode": "9902.15.36",
      "superior": null,
      "indent": "0",
      "description": "Manual door closers of base metal, suitable for use on buildings, such closers with adjustable latch speed tension to suit individual needs; designed with side mount activation button which reduces user damage during activation (provided for in subheading 8302.41.30) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.37",
      "rawHtsCode": "9902.15.37",
      "superior": null,
      "indent": "0",
      "description": "Armored safes of welded steel; each weighing 11.8 kg or less, valued $24 or more but not over $36, with digital lock. (provided for in heading 8303.00.00)",
      "units": [],
      "generalRate": "1.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.38",
      "rawHtsCode": "9902.15.38",
      "superior": null,
      "indent": "0",
      "description": "Economizers comprising auxiliary plant for use with boilers of heading 8402, with a pressure capacity of 10686.87 kPa, certified by the importer as for use in the pulp and paper industry (provided for in subheading 8404.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.39",
      "rawHtsCode": "9902.15.39",
      "superior": null,
      "indent": "0",
      "description": "Stationary steam turbines, condensing type, direct drive, suited for use with a generator, having an output of 60 MW or more but not over 120 MW, with a rotational speed more than 3500 RPM (provided for in subheading 8406.81.10)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.40",
      "rawHtsCode": "9902.15.40",
      "superior": null,
      "indent": "0",
      "description": "Steam turbines, multi-stage, condensing type, direct drive, suitable for use with a generator, having an output of 27 MW or more but not over 40 MW, with an operating rotational speed more than 3500 RPM (provided for in subheading 8406.82.10)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.41",
      "rawHtsCode": "9902.15.41",
      "superior": null,
      "indent": "0",
      "description": "Used compression-ignition internal combustion piston engines to be installed in vehicles of subheading 8701.20 or heading 8704 (provided for in subheading 8408.20.20)",
      "units": [],
      "generalRate": "1.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.42",
      "rawHtsCode": "9902.15.42",
      "superior": null,
      "indent": "0",
      "description": "Engine blocks, each weighing over 272 kg but not over 317 kg, for compression-ignition internal combustion piston engines (diesel or semi-diesel engines) having a cylinder capacity of approximately 12.4 liters for vehicles of subheading 8701.20 (provided for in subheading 8409.99.91)",
      "units": [],
      "generalRate": "0.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.43",
      "rawHtsCode": "9902.15.43",
      "superior": null,
      "indent": "0",
      "description": "High silicon molybdenum exhaust manifolds for use in compression-ignition internal combustion piston engines (diesel or semi-diesel engines) with cylinder capacity of 2,300 cc or more but not exceeding 20,000 cc, each manifold measuring at least 80 cm but not exceeding 200 cm in length, at least 10 cm but not over 200 cm in width, and at least 10 cm but not exceeding 200 cm in height (provided for in subheading 8409.99.91)",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.44",
      "rawHtsCode": "9902.15.44",
      "superior": null,
      "indent": "0",
      "description": "Connecting rods designed for use in compression-ignition internal combustion piston engines (diesel or semi-diesel engines) for vehicles of subheading 8701.20 or heading 8702, 8703, or 8704, each rod measuring at least 20 cm but not exceeding 120 cm in length, at least 10 cm but not exceeding 60 cm in width, and at least 5 cm but not exceeding 90 cm in height (provided for in subheading 8409.99.91)",
      "units": [],
      "generalRate": "0.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.45",
      "rawHtsCode": "9902.15.45",
      "superior": null,
      "indent": "0",
      "description": "Cast iron crankcases, suitable for use solely or principally with marine propulsion engines, each crankcase measuring more than 1.1 m in length (provided for in subheading 8409.99.92)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.46",
      "rawHtsCode": "9902.15.46",
      "superior": null,
      "indent": "0",
      "description": "Cast-iron cylinder heads suitable for use solely or principally with marine compression-ignition engines, such parts with cylinder bore over 125 mm and weighing over 32 kg each (provided for in subheading 8409.99.92)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.47",
      "rawHtsCode": "9902.15.47",
      "superior": null,
      "indent": "0",
      "description": "Pistons suitable for use solely or principally with marine propulsion engines, such pistons each having a cast steel crown and aluminum body, weighing 12 kg or more (provided for in subheading 8409.99.92)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.48",
      "rawHtsCode": "9902.15.48",
      "superior": null,
      "indent": "0",
      "description": "Fuel-injection pump assemblies, designed for compression-ignition internal combustion engines with a capacity of 6.4 liters and with output of less than 1000 kW of power (provided for in subheading 8413.30.10), the foregoing other than used goods",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.49",
      "rawHtsCode": "9902.15.49",
      "superior": null,
      "indent": "0",
      "description": "Fuel-injection pumps, designed for compression-ignition engines having an output of 1000 kW or greater, each pump weighing 60 kg or more and capable of generating a pressure greater than 1200 bar, such pumps designed for use in a common rail fuel system (provided for in subheading 8413.30.10), the foregoing other than used goods",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.50",
      "rawHtsCode": "9902.15.50",
      "superior": null,
      "indent": "0",
      "description": "Used fuel, lubricating or cooling medium pumps designed for internal combustion piston engines (provided for in subheading 8413.30.10 or 8413.30.90)",
      "units": [],
      "generalRate": "0.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.51",
      "rawHtsCode": "9902.15.51",
      "superior": null,
      "indent": "0",
      "description": "New fuel pumps for compression-ignition engines, other than fuel-injection pumps, such pumps measuring 2 cm or more but not over 163 cm in length, 2 cm or more but less than 127 cm in width and 2 cm or more but less than 95 cm in height (provided for in subheading 8413.30.90)",
      "units": [],
      "generalRate": "0.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.52",
      "rawHtsCode": "9902.15.52",
      "superior": null,
      "indent": "0",
      "description": "High pressure fuel pumps, each incorporating a default open or closed solenoid valve, certified by the importer to be used in regulating the fuel supply into the fuel rail, designed for use in gasoline direct injection (GDI) spark-ignition internal combustion piston engines (provided for in subheading 8413.30.90); the foregoing other than used goods",
      "units": [],
      "generalRate": "1.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.53",
      "rawHtsCode": "9902.15.53",
      "superior": null,
      "indent": "0",
      "description": "Vacuum pumps, each having a steel casing and outer shell of plastics to permit cooling; such pumps measuring approximately 22 cm in height and 16 cm in width, having an aperture to connect with a HEPA filter and a power output rating exceeding 850 W but not over 1050 W, valued no more than $24 each (provided for in subheading 8414.10.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.54",
      "rawHtsCode": "9902.15.54",
      "superior": null,
      "indent": "0",
      "description": "Exhaust fans for permanent ceiling installation designed to be used in the bathroom, each containing an electric motor with an output wattage not exceeding 125 W, with or without a light, with volume flow between 1.35 m3 and 2.04 m3 per minute and having a sound level greater than 2.2 sones but not exceeding 6.8 sones (provided for in subheading 8414.51.30)",
      "units": [],
      "generalRate": "4.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.55",
      "rawHtsCode": "9902.15.55",
      "superior": null,
      "indent": "0",
      "description": "Exhaust fans designed for permanent ceiling installation in bathrooms, each with a self-contained electric DC brush-less motor with an output wattage not exceeding 125 W, with or without a light, such fans having a sound level rating greater than 0.1 sone but not exceeding 1.2 sones (provided for in subheading 8414.51.30)",
      "units": [],
      "generalRate": "3.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.56",
      "rawHtsCode": "9902.15.56",
      "superior": null,
      "indent": "0",
      "description": "Blower subassemblies, each consisting of an electric A/C or D/C motor with an output wattage over 18.5 W but not exceeding 38.5 W, a metal or plastic blower wheel and a base plate, designed to be incorporated in ceiling fans for permanent installation of subheading 8414.51.30 or in heating units combining a heater, fan and lights for permanent installation, of subheading 8516.29.00 (provided for in subheading 8414.59.65)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.57",
      "rawHtsCode": "9902.15.57",
      "superior": null,
      "indent": "0",
      "description": "Chimney range hoods, island range hoods or under-the-cabinet range hoods, of a kind normally used in the household, designed for permanent installation to a wall or ceiling, each such hood measuring over 121 cm on its maximum horizontal side, presented with or without a blower; the foregoing, if presented without blower, incorporating other ventilating equipment (provided in subheading 8414.80.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.58",
      "rawHtsCode": "9902.15.58",
      "superior": null,
      "indent": "0",
      "description": "Pedestal column assemblies comprising parts for oscillating electric fans, presented in the assembled condition, each consisting of upper and lower tubes of steel, with thermoplastic collet (sleeve) covering the connection point of such tubes together with accompanying collet insert and allowing the two tubes to be locked at adjustable intervals (provided for in subheading 8414.90.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.59",
      "rawHtsCode": "9902.15.59",
      "superior": null,
      "indent": "0",
      "description": "Plastic grilles (provided for in subheading 8414.90.10), each incorporating a light-emitting diode (LED) light on the exterior perimeter capable of providing continuous light, certified by the importer as designed to be used with exhaust fans for permanent installation and generating 2.83 m3 per minute, such fans of a kind for residential use and described in subheading 8414.51.30",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.62",
      "rawHtsCode": "9902.15.62",
      "superior": null,
      "indent": "0",
      "description": "Air conditioning machines, incorporating a refrigerating unit, mounted on wheels or castors, exceeding 17.58 kW per hour (provided for in 8415.82.01)",
      "units": [],
      "generalRate": "0.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.63",
      "rawHtsCode": "9902.15.63",
      "superior": null,
      "indent": "0",
      "description": "Air conditioning machines, each incorporating a refrigerating unit, mounted on wheels or castors, rated at less than 3.52 kW per hour (provided for in 8415.82.01)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.64",
      "rawHtsCode": "9902.15.64",
      "superior": null,
      "indent": "0",
      "description": "Self-contained, portable air conditioning machines, not designed to be fixed to a window, wall, ceiling or floor, with cooling capacity rated at 3.52 kW per hour or more but less than 17.58 kW per hour (provided for in subheading 8415.82.01)",
      "units": [],
      "generalRate": "1.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.66",
      "rawHtsCode": "9902.15.66",
      "superior": null,
      "indent": "0",
      "description": "Pressure distillation columns, designed to liquefy air and its component gases, the foregoing containing brazed aluminum plate-fin heat exchangers (provided for in subheading 8419.60.10)",
      "units": [],
      "generalRate": "2.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.67",
      "rawHtsCode": "9902.15.67",
      "superior": null,
      "indent": "0",
      "description": "Shell and tube oil coolers designed for compression-ignition engines, such coolers measuring 50 cm or more but not over 180 cm in length, 10 cm or more but not over 70 cm in width and 15 cm or more but not over 70 cm in height (provided for in subheading 8419.89.95)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.68",
      "rawHtsCode": "9902.15.68",
      "superior": null,
      "indent": "0",
      "description": "Self-propelled sprinklers for agricultural or horticultural purposes, other than center pivot type (provided for in subheading 8424.82.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.69",
      "rawHtsCode": "9902.15.69",
      "superior": null,
      "indent": "0",
      "description": "Flexographic printing machinery, having continuous roll feed, designed for printing on paperboard (whether or not such paperboard is coated), with a printing speed less than 184 m/minute, and a print width of 101 cm or more but less than 280 cm (provided for in subheading 8443.16.00).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.70",
      "rawHtsCode": "9902.15.70",
      "superior": null,
      "indent": "0",
      "description": "Flexographic printing machinery, having continuous roll feed, designed for printing on paperboard (whether or not such paperboard is coated), having a printing speed of 599 m/minute or more but not more than 801 m/minute and a print width of 106 cm or more but not more than 178 cm (provided for in subheading 8443.16.00) ",
      "units": [],
      "generalRate": "0.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.71",
      "rawHtsCode": "9902.15.71",
      "superior": null,
      "indent": "0",
      "description": "Weaving machines (power looms), shuttleless, rapier type, for weaving fabrics of a width exceeding 30 cm but not exceeding 4.9 m (provided for in subheading 8446.30.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.72",
      "rawHtsCode": "9902.15.72",
      "superior": null,
      "indent": "0",
      "description": "Weaving machines (power looms), shuttleless, jet type, for weaving fabrics of a width exceeding 30 cm but not exceeding 4.9 m (provided for in subheading 8446.30.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.73",
      "rawHtsCode": "9902.15.73",
      "superior": null,
      "indent": "0",
      "description": "Miter sawing machines, power operated, not numerically controlled, for working metal, with safety cut off switch (provided for in subheading 8461.50.80)",
      "units": [],
      "generalRate": "3.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.74",
      "rawHtsCode": "9902.15.74",
      "superior": null,
      "indent": "0",
      "description": "Table saws for working wood, cork, bone, hard rubber, hard plastics or similar hard materials, each with blade measuring 25.4 cm (provided for in subheading 8465.91.00), such saws excluding (i) tilting arbor table saws, non-laser guided, each with a 25.4 cm blade and of a weight not exceeding 220 kg, and (ii) laser-guided tilting arbor table saws, each with 25.4 cm blade and detachable base with casters, weighing less than 31 kg ",
      "units": [],
      "generalRate": "1.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.75",
      "rawHtsCode": "9902.15.75",
      "superior": null,
      "indent": "0",
      "description": "Benchtop band saws, for working wood, cork, bone, hard rubber, hard plastics or similar hard materials, the foregoing with a cutting depth between 25 and 36 cm, valued under $1,000 each (provided for in subheading 8465.91.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.76",
      "rawHtsCode": "9902.15.76",
      "superior": null,
      "indent": "0",
      "description": "Floor standing (stationary) band saws, each with a cutting depth between 25 and 36 cm, valued under $1,000 each (provided for in subheading 8465.91.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.77",
      "rawHtsCode": "9902.15.77",
      "superior": null,
      "indent": "0",
      "description": "Tilting arbor table saws, non-laser guided, each with a 25.4 cm blade and of a weight not exceeding 220 kg (provided for in subheading 8465.91.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.78",
      "rawHtsCode": "9902.15.78",
      "superior": null,
      "indent": "0",
      "description": "Laser-guided tilting arbor table saws, each with 25.4 cm blade and presented with a detachable base with casters, the foregoing weighing less than 31 kg (provided for in subheading 8465.91.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.79",
      "rawHtsCode": "9902.15.79",
      "superior": null,
      "indent": "0",
      "description": "Miter sawing machines, power operated, not numerically controlled, for working wood, cork, bone, hard rubber, hard plastics or similar hard materials, with 25.4 cm blade, capable of adjusting bevel of cut, without laser guides (provided for in subheading 8465.91.00)",
      "units": [],
      "generalRate": "2.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.80",
      "rawHtsCode": "9902.15.80",
      "superior": null,
      "indent": "0",
      "description": "Drill presses, valued under $1,000 each (provided for in subheading 8465.95.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.81",
      "rawHtsCode": "9902.15.81",
      "superior": null,
      "indent": "0",
      "description": "Rotary drill, hammer and chiseling tools with self-contained electric motor (provided for in 8467.21.00), each with pneumatic hammering mechanism that engages with slotted drive drill-bits and an electromechanical mechanism that separates the drive from the internal gearings, with rated amperage that does not exceed 15 A and with triaxial vibration values, measured in accordance with European Norm 60745, that do not exceed 9 m/s2",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.82",
      "rawHtsCode": "9902.15.82",
      "superior": null,
      "indent": "0",
      "description": "Machinery for molding, assembling or otherwise forming uncured, unvulcanized rubber (green) tires (provided for in subheading 8477.59.01), the foregoing to be used in production of new pneumatic tires designed in all sizes for motor cars (such tires in subheadings 4011.10.10 and 4011.10.50), buses and trucks (such tires in subheadings 4011.20.10 and 4011.20.50), motorcycles (such tires in subheading 4011.40.00) and agricultural, forestry, construction or industrial vehicles (such tires of subheadings 4011.70.00, 4011.80.10, 4011.80.20, 4011.80.80, 4011.90.10, 4011.90.20, and 4011.90.80)",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.83",
      "rawHtsCode": "9902.15.83",
      "superior": null,
      "indent": "0",
      "description": "Electromechanical \"hide and seek\" toys, designed for use by cats or dogs, each with an electrically powered fast-moving feather wand that changes direction randomly; such wand mechanism positioned in a round enclosure of plastics, designed to allow the wand to shoot out; such toys each containing a carpeted scratching area on top (provided for in subheading 8479.89.94)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.84",
      "rawHtsCode": "9902.15.84",
      "superior": null,
      "indent": "0",
      "description": "Electromechanical pet toys, each with a plastic butterfly attached to a wire cable that revolves around a plastic base when in use, such toy designed to simulate the flying motion of a butterfly (provided for in subheading 8479.89.94)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.85",
      "rawHtsCode": "9902.15.85",
      "superior": null,
      "indent": "0",
      "description": "Vehicle stability control actuator assemblies (provided for in subheading 8479.89.94)",
      "units": [],
      "generalRate": "2.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.86",
      "rawHtsCode": "9902.15.86",
      "superior": null,
      "indent": "0",
      "description": "Subsea joinable connection devices rated at 68947.57 kPa, each certified by the importer as having high strength bend resistance and designed to interconnect subsea trees, manifolds and pipeline terminates to route production flow to a flow line (provided for in subheading 8479.89.94)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.87",
      "rawHtsCode": "9902.15.87",
      "superior": null,
      "indent": "0",
      "description": "Electromechanical cat toys, each depicting a bird in a cage, such toy bird of textile materials with magnet inside its body and suspended by a string from the top of a cage comprising plastic ribs; such cage sitting on a base of plastics that contains the electrical components; with cage base having a magnetic coil designed to switch polarity and cause the bird to be in a state of continuous motion (provided for in subheading 8479.89.94)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.88",
      "rawHtsCode": "9902.15.88",
      "superior": null,
      "indent": "0",
      "description": "Electromechanical cat toys, with electrical function supplying power to the moving parts and supporting the mechanical function, each unit comprising an electrical/mechanical \"mouse\" of plastics enclosed in an approximately 0.61 m diameter textile fabric \"pouch,\" with such \"mouse\" designed to randomly move around the inside of the pouch (provided for in subheading 8479.89.94)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.89",
      "rawHtsCode": "9902.15.89",
      "superior": null,
      "indent": "0",
      "description": "Optical telescope mirror segment support assemblies, each presented without mirrors (provided for in subheading 8479.89.94)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.90",
      "rawHtsCode": "9902.15.90",
      "superior": null,
      "indent": "0",
      "description": "Segmented compression-type molds designed to be used for molding / forming and curing \"green tires\" with a rim diameter measuring over 63.5 cm (provided for in subheading 8480.79.90), such tires for off-the-road use",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.91",
      "rawHtsCode": "9902.15.91",
      "superior": null,
      "indent": "0",
      "description": "Valve-type fuel injectors, each functional in a common rail fuel system with a pressure greater than 120 Mpa (1200 bar) (provided for in subheading 8481.80.90), the foregoing other than used goods",
      "units": [],
      "generalRate": "0.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.92",
      "rawHtsCode": "9902.15.92",
      "superior": null,
      "indent": "0",
      "description": "Dosing module injectors, comprising parts of compression-ignition engine after-combustion treatment systems, measuring 30 cm or more but not over 50 cm in length, 30 cm or more but not over 50 cm in width and 10 cm or more but not over 30 cm in height (provided for in subheading 8481.80.90), such injectors other than used ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.93",
      "rawHtsCode": "9902.15.93",
      "superior": null,
      "indent": "0",
      "description": "Used self-operating regulator valves, such valves designed for controlling variables such as temperature, pressure or flow (provided for in subheading 8481.80.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.94",
      "rawHtsCode": "9902.15.94",
      "superior": null,
      "indent": "0",
      "description": "Fuel Injectors, other than used, each incorporating a valve and a micro-stamped orifice hole, certified by the importer as designed to deliver fuel to the combustion chamber of a gasoline engine with a pressure not exceeding 120 Mpa (1200 bar) (provided for in subheading 8481.80.90)",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.95",
      "rawHtsCode": "9902.15.95",
      "superior": null,
      "indent": "0",
      "description": "Valves, capable of operating at pressures of 68.94 MPa or more (provided for in subheading 8481.80.90), for controlling production flow through a subsea tree, each mounted in a module that can be removed and replaced by a remotely operated underwater vehicle (ROV)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.96",
      "rawHtsCode": "9902.15.96",
      "superior": null,
      "indent": "0",
      "description": "New crankshafts of forged steel designed for use solely or principally with compression-ignition internal combustion piston engines, other than for vehicles of chapter 87, each measuring more than 1.86 m in length and weighing 453 kg or more (provided for in subheading 8483.10.30)",
      "units": [],
      "generalRate": "0.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.97",
      "rawHtsCode": "9902.15.97",
      "superior": null,
      "indent": "0",
      "description": "Used camshafts and crankshafts, designed for use solely or principally with compression-ignition internal combustion piston engines (other than spark-ignition internal combustion engines) (provided for in subheading 8483.10.30)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.98",
      "rawHtsCode": "9902.15.98",
      "superior": null,
      "indent": "0",
      "description": "New crankshafts designed for use solely or principally with compression-ignition internal combustion piston engines of a cylinder capacity exceeding 19,000 cc, such crankshafts measuring 200 cm or more but not over 900 cm in length, 100 cm or more but not over 200 cm in width and 50 cm or more but not over 200 cm in height (provided for in subheading 8483.10.30), the foregoing except such new crankshafts of forged steel, other than for vehicles of chapter 87, each measuring more than 1.86 m in length and weighing 453 kg or more",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.15.99",
      "rawHtsCode": "9902.15.99",
      "superior": null,
      "indent": "0",
      "description": "Plain shaft sputter bearings without housing (the foregoing other than spherical bearings), each weighing 200 g or more and with journal diameter measuring 117 mm or more (provided for in subheading 8483.30.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.01",
      "rawHtsCode": "9902.16.01",
      "superior": null,
      "indent": "0",
      "description": "Used fixed ratio speed changers (provided for in subheading 8483.40.50), other than transmissions for the vehicles of headings 8701, 8702, 8703, 8704, and 8705",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.02",
      "rawHtsCode": "9902.16.02",
      "superior": null,
      "indent": "0",
      "description": "Flexplates designed for use in compression-ignition engines of a cylinder capacity equal to or greater than 6,000 cc but not exceeding 20,000 cc, such flexplates measuring 5 cm or more but not over 150 cm in length, 22 cm or more but not over 150 cm in width and 2 cm or more but not over 150 cm in height (provided for in subheading 8483.60.80)",
      "units": [],
      "generalRate": "1.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.03",
      "rawHtsCode": "9902.16.03",
      "superior": null,
      "indent": "0",
      "description": "Flexplates designed for use in compression ignition engines with cylinder capacity ranging between 1000 cc to 5900 cc, such flexplates measuring 35 cm or more but not over 50 cm in length, 35 cm or more but not over 50 cm in width and 2 cm or more but not over 10 cm in height (provided for in subheading 8483.60.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.04",
      "rawHtsCode": "9902.16.04",
      "superior": null,
      "indent": "0",
      "description": "Ring gears, with diameter 30 cm or more but not over 200 cm and height of 6 cm or more but not over 30 cm, the foregoing to be assembled onto the periphery of a flexplate or flywheel for a diesel engine ranging in cylinder capacity equal to or greater than 5,000 cc but not exceeding 95,000 cc (provided for in subheading 8483.90.50)",
      "units": [],
      "generalRate": "1.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.05",
      "rawHtsCode": "9902.16.05",
      "superior": null,
      "indent": "0",
      "description": "Electromechanical rotational actuators, each with attached actuator arm and pin (such arm measuring between 12 mm and 15 mm in length and with pin diameter of 8 mm), of an output of 36 W (provided for in subheading 8501.10.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.06",
      "rawHtsCode": "9902.16.06",
      "superior": null,
      "indent": "0",
      "description": "Power back door (liftgate) actuator assemblies for the motor vehicles of headings 8701 to 8705, each consisting of a brushless electric DC motor that generates between 350 and 400 W, an electromagnetic clutch, a clutch magnet, a clutch flywheel, a clutch plate, a sensor and a housing (provided for in subheading 8501.31.40)",
      "units": [],
      "generalRate": "1.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.07",
      "rawHtsCode": "9902.16.07",
      "superior": null,
      "indent": "0",
      "description": "DC motors of an output between 190 W and 290 W, weighing less than 1 kg, each in a cylindrical housing with height of approximately 55 mm and a radius of approximately 45 mm (provided for in subheading 8501.31.40)",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.08",
      "rawHtsCode": "9902.16.08",
      "superior": null,
      "indent": "0",
      "description": "AC electric motors of an output exceeding 37.5 W but not exceeding 74.6 W, single phase, each equipped with a capacitor, rotary speed control mechanism and a motor mounting cooling ring (provided for in subheading 8501.40.20).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.09",
      "rawHtsCode": "9902.16.09",
      "superior": null,
      "indent": "0",
      "description": "AC electric motors of an output exceeding 37.5w but not exceeding 72w, single phase, each equipped with a capacitor, a speed control mechanism, and a motor mount of plastics and a self-contained gear mechanism for oscillation (provided for in subheading 8501.40.20).",
      "units": [],
      "generalRate": "2.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.10",
      "rawHtsCode": "9902.16.10",
      "superior": null,
      "indent": "0",
      "description": "AC electric motors, single-phase, of an output exceeding 50 W but not exceeding 74.6 W, each equipped with a capacitor and a three-speed control switch (provided for in subheading 8501.40.20)",
      "units": [],
      "generalRate": "0.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.11",
      "rawHtsCode": "9902.16.11",
      "superior": null,
      "indent": "0",
      "description": "AC electric motors of an output exceeding 74.6 W but not exceeding 95 W, single phase, each equipped with a capacitor and a speed control mechanism (provided for in subheading 8501.40.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.12",
      "rawHtsCode": "9902.16.12",
      "superior": null,
      "indent": "0",
      "description": "AC electric motors, single phase, of an output exceeding 74.6 W but not exceeding 95 W, such motors each equipped with a capacitor and a three-speed control switch (provided for in subheading 8501.40.40) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.13",
      "rawHtsCode": "9902.16.13",
      "superior": null,
      "indent": "0",
      "description": "Submersible multi-phase motors designed for use with pumps, such motors cylindrical in shape, each having a diameter exceeding 12 cm but not exceeding 18 cm and a length exceeding 63 cm but not exceeding 80 cm, the foregoing having a power output exceeding 3 kW but not exceeding 14.92 kW (provided for in subheading 8501.52.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.14",
      "rawHtsCode": "9902.16.14",
      "superior": null,
      "indent": "0",
      "description": "Submersible multi-phase motors designed for use with pumps, such motors cylindrical in shape, each having a diameter exceeding 22 cm but not exceeding 35 cm and a length exceeding 150 cm but not exceeding 230 cm, the foregoing with a power output exceeding 149.2 kW but not exceeding 150 kW (provided for in subheading 8501.53.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.15",
      "rawHtsCode": "9902.16.15",
      "superior": null,
      "indent": "0",
      "description": "AC electric generators, each with a flywheel and an eddy-current loading device, the load being controlled magnetically (provided for in subheading 8501.61.00), designed for use in exercise equipment of subheading 9506.91",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.16",
      "rawHtsCode": "9902.16.16",
      "superior": null,
      "indent": "0",
      "description": "Electric generating sets, each with spark-ignition internal combustion piston engine fueled by natural gas (provided for in subheading 8502.20.00)",
      "units": [],
      "generalRate": "1.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.17",
      "rawHtsCode": "9902.16.17",
      "superior": null,
      "indent": "0",
      "description": "Stator core and rotor core laminations, imported in pairs each comprising one stator core lamination and one rotor core lamination; with such stator core laminations having an exterior diameter of 26.42 cm and an inner diameter of 20.35 cm, weighing 4.14 kg or more but not over 6.72 kg; such rotor core laminations having an exterior diameter of 20.2 cm and an inner diameter of 14.0 cm, weighing 3.3 kg or more but not over 5.3 kg; the foregoing certified by the importer as designed to be used in the manufacture of generator motors for charging the battery of hybrid vehicles and of electric motors for propulsion of hybrid vehicles (provided for in subheading 8503.00.95)   ",
      "units": [],
      "generalRate": "0.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.18",
      "rawHtsCode": "9902.16.18",
      "superior": null,
      "indent": "0",
      "description": "Power adapters designed for use with standard car cigarette lighter sockets having dual USB output ports with 12 W output per port (provided for in subheading 8504.40.95)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.19",
      "rawHtsCode": "9902.16.19",
      "superior": null,
      "indent": "0",
      "description": "Fuel shutoff solenoids designed for compression-ignition diesel engines with cylinder capacity ranging between 2,000 cc and 20,000 cc, such solenoids measuring 5 cm or more but not over 800 cm in length, 3 cm but not over 500 cm in width and 3 cm but not over 200 cm in height (provided for in subheading 8505.90.75)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.20",
      "rawHtsCode": "9902.16.20",
      "superior": null,
      "indent": "0",
      "description": "Rechargeable lithium batteries, certified by the importer as having a polymer electrolyte layer and composite cathode, designed to complete 800 cumulative battery lifetime hours and operate at sustained temperatures between 45 degrees Celsius and 130 degrees Celsius continuously for a minimum of 1 hour between recharges (provided for in subheading 8507.60.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.21",
      "rawHtsCode": "9902.16.21",
      "superior": null,
      "indent": "0",
      "description": "Lithium thionyl chloride (LTC) batteries, annular in shape, measuring 30.48 mm or more but not over 152.4 mm in length, with an outer diameter of 10.16 cm or more but not over 127 mm and an inner diameter of 55.88 mm or more but not over 88.9 mm, certified by the importer as containing a lithium anode and a liquid cathode comprising a porous carbon current collector filled with thionyl chloride (SOCl2) (provided for in subheading 8507.60.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.22",
      "rawHtsCode": "9902.16.22",
      "superior": null,
      "indent": "0",
      "description": "Lithium thionyl chloride batteries, cylindrical in shape, measuring 30.48 mm or more but not over 152.4 cm in length, having an outer diameter of 10.16 mm or more but not over 127 mm, each certified by the importer as containing a lithium anode and a liquid cathode comprising a porous carbon current collector filled with thionyl chloride (SOCl2) (provided for in subheading 8507.60.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.23",
      "rawHtsCode": "9902.16.23",
      "superior": null,
      "indent": "0",
      "description": "Electromechanical burr coffee grinders, with self-contained electric motor, each presented with one clear glass top storage vessel and one clear glass bottom storage vessel (provided for in subheading 8509.40.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.24",
      "rawHtsCode": "9902.16.24",
      "superior": null,
      "indent": "0",
      "description": "Electromechanical domestic appliances, each with self-contained electric motor, such appliances designed for peeling, coring and slicing fruits and vegetables and capable of cutting such food into spiral shapes, the foregoing each having more than five interchangeable cutting blades (provided for in subheading 8509.40.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.25",
      "rawHtsCode": "9902.16.25",
      "superior": null,
      "indent": "0",
      "description": "Electromechanical cylindrical coffee grinders, each operated by pushing the plastic cover into the base, the foregoing having a removable stainless steel bowl with a capacity of more than 0.1 liter and not exceeding 0.2 liter (provided for in subheading 8509.40.00).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.26",
      "rawHtsCode": "9902.16.26",
      "superior": null,
      "indent": "0",
      "description": "Electromechanical knives, each with self-contained electric motor, valued $8 or more but not more than $40 each (provided for in subheading 8509.80.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.27",
      "rawHtsCode": "9902.16.27",
      "superior": null,
      "indent": "0",
      "description": "Litterboxes, each with self-contained electric motor powered by an external adapter that plugs into a wall socket or electrical outlet and may have batteries for back-up, such devices which rake and/or disperse cat waste into a compartment after a certain amount of time has passed once the mechanism is triggered by cat entering the litterbox; the foregoing designed for domestic use (provided for in subheading 8509.80.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.28",
      "rawHtsCode": "9902.16.28",
      "superior": null,
      "indent": "0",
      "description": "Feeders, each with a self-contained electric motor powered by an external adapter that plugs into a wall socket or electrical outlet or uses batteries, such devices which can be programmed to disperse various quantities of food at pre-set times, designed for domestic use by dogs and cats (provided for in subheading 8509.80.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.29",
      "rawHtsCode": "9902.16.29",
      "superior": null,
      "indent": "0",
      "description": "Waterers, each with a self-contained electric motor powered through an external adapter that plugs into a wall socket or electrical outlet or uses batteries, such devices which filter a continuously flowing water fountain or replenish water when volume is below a certain fill level, the foregoing designed for domestic use by dogs and cats (provided for in subheading 8509.80.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.30",
      "rawHtsCode": "9902.16.30",
      "superior": null,
      "indent": "0",
      "description": "Feeders designed for use with fish, each with a self-contained electric motor powered by batteries, with retaining clips or clamps to attach to a household aquarium, the foregoing which can be programmed to disperse various quantities of food at preset times (provided for in subheading 8509.80.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.31",
      "rawHtsCode": "9902.16.31",
      "superior": null,
      "indent": "0",
      "description": "Electromechanical knives, each with self-contained electric motor (provided for in subheading 8509.80.50), the foregoing only if valued either less than $8 or more than $40 each ",
      "units": [],
      "generalRate": "0.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.32",
      "rawHtsCode": "9902.16.32",
      "superior": null,
      "indent": "0",
      "description": "Hand-held battery-operated automatic can openers, each with self-contained electric motor, such can operners weighing not over 20 kg exclusive of extra interchangeable parts or detachable auxiliary devices (provided for in subheading 8509.80.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.33",
      "rawHtsCode": "9902.16.33",
      "superior": null,
      "indent": "0",
      "description": "Stainless steel food beaters, designed for use solely on electromechanical hand-held food mixers suitable for domestic purposes (provided for in subheading 8509.90.55).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.34",
      "rawHtsCode": "9902.16.34",
      "superior": null,
      "indent": "0",
      "description": "Stainless steel dough hooks designed for use solely on electromechanical food hand mixers suitable for domestic purposes (provided for in subheading 8509.90.55)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.35",
      "rawHtsCode": "9902.16.35",
      "superior": null,
      "indent": "0",
      "description": "Electrothermal bowls designed for use with electromechanical stand food mixers of a kind used for domestic purposes, each bowl having a control panel with digital display (provided for in subheading 8509.90.55)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.36",
      "rawHtsCode": "9902.16.36",
      "superior": null,
      "indent": "0",
      "description": "Stainless steel bowls designed for use on electromechanical stand food mixers, each having a capacity greater than 4.7 liters but not exceeding 8.6 liters (whether or not having a single stainless steel vertically oriented welded handle), the foregoing each having a rolled top edge and two welded stainless steel side brackets with circular holes (provided for in subheading 8509.90.55)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.37",
      "rawHtsCode": "9902.16.37",
      "superior": null,
      "indent": "0",
      "description": "Stainless steel bowls designed for use on electromechanical stand food mixers, each having a capacity greater than 3.3 liters but not exceeding 4.8 liters (whether or not having a single stainless steel vertically oriented welded handle), the foregoing each having a rolled top edge and welded stainless steel base with four protrusions designed to interlock with a stand food mixer base (provided for in subheading 8509.90.55)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.38",
      "rawHtsCode": "9902.16.38",
      "superior": null,
      "indent": "0",
      "description": "Used electric starter motors for spark ignition or compression ignition internal combustion engines (provided for in subheading 8511.40.00)",
      "units": [],
      "generalRate": "0.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.39",
      "rawHtsCode": "9902.16.39",
      "superior": null,
      "indent": "0",
      "description": "New alternators rated to produce voltage at 24 V and current at 500 A or more, designed to power military diesel engine components and supporting systems, such alternators each weighing less than 55 kg and measuring less than 300 mm in diameter (provided for in subheading 8511.50.00) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.40",
      "rawHtsCode": "9902.16.40",
      "superior": null,
      "indent": "0",
      "description": "Used generators (alternators) of a kind used in conjunction with spark ignition or compression ignition internal combustion engines (provided for in subheading 8511.50.00)",
      "units": [],
      "generalRate": "1.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.41",
      "rawHtsCode": "9902.16.41",
      "superior": null,
      "indent": "0",
      "description": "Parts of signaling equipment, each with pressed sealing on the flanges (provided for in subheading 8512.90.20)",
      "units": [],
      "generalRate": "1.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.42",
      "rawHtsCode": "9902.16.42",
      "superior": null,
      "indent": "0",
      "description": "Electric heating units designed for permanent ceiling installation, each containing a heater and one or two infrared bulbs, with or without a fan (provided for in subheading 8516.29.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.43",
      "rawHtsCode": "9902.16.43",
      "superior": null,
      "indent": "0",
      "description": "Heating units each combining a heater, a fan and a light for residential use, designed for permanent ceiling installation, each containing an adjustable louver mounted in the grille, such louver may be rotated 360 degrees for the flow of heat output to be manually self-positioned (provided for in subheading 8516.29.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.44",
      "rawHtsCode": "9902.16.44",
      "superior": null,
      "indent": "0",
      "description": "High-capacity heating units, designed to be permanently mounted into a wall and for use in residential households, each generating 1000 and 1500 W, containing a grille, with or without built-in thermostat (provided for in subheading 8516.29.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.45",
      "rawHtsCode": "9902.16.45",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic steam irons of a kind used for domestic purposes, capable of operating without power cord connected to mains, each with detachable base (provided in subheading 8516.40.40) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.46",
      "rawHtsCode": "9902.16.46",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic steam irons of a kind used for domestic purposes, each with a ceramic-coated cast aluminum sole plate (provided for in subheading 8516.40.40), the foregoing not capable of operating without power connected to mains",
      "units": [],
      "generalRate": "1.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.47",
      "rawHtsCode": "9902.16.47",
      "superior": null,
      "indent": "0",
      "description": "Microwave ovens with integral range hoods, of a kind used for domestic purposes, each having oven capacity greater than 48 liters but not exceeding 49 liters, the foregoing containing a glass turntable plate with a diameter greater than 30 cm but not exceeding 31 cm and with a door having an exterior molded plastic handle (provided for in subheading 8516.50.00)",
      "units": [],
      "generalRate": "0.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.48",
      "rawHtsCode": "9902.16.48",
      "superior": null,
      "indent": "0",
      "description": "Microwave ovens with integral range hoods, of a kind used for domestic purposes, each having oven capacity greater than 48 liters but not exceeding 49 liters, the foregoing having a glass turntable plate with a diameter greater than 30 cm but not exceeding 31 cm and a door with exterior metal handle (provided for in subheading 8516.50.00)",
      "units": [],
      "generalRate": "1.2%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.49",
      "rawHtsCode": "9902.16.49",
      "superior": null,
      "indent": "0",
      "description": "Microwave ovens with integral range hoods, of a kind used for domestic purposes, each having oven capacity greater than 53 liters but not exceeding 55 liters, the foregoing having a glass turntable plate with a diameter greater than 30 cm but not exceeding 31 cm (provided for in subheading 8516.50.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.50",
      "rawHtsCode": "9902.16.50",
      "superior": null,
      "indent": "0",
      "description": "Microwave ovens with integral range hoods, of a kind used for domestic purposes, each having an oven capacity of greater than 58 liters but not exceeding 60 liters, the foregoing having a glass turntable plate with a diameter greater than 30 cm but not exceeding 32 cm (provided for in subheading 8516.50.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.51",
      "rawHtsCode": "9902.16.51",
      "superior": null,
      "indent": "0",
      "description": "Microwave ovens with integral range hoods, of a kind used for domestic purposes, each having an oven capacity of greater than 58 liters but not exceeding 60 liters, the foregoing having a glass turntable plate with a diameter greater than 35 cm but not exceeding 37 cm (provided for in subheading 8516.50.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.52",
      "rawHtsCode": "9902.16.52",
      "superior": null,
      "indent": "0",
      "description": "Microwave ovens with integral range hoods, of a kind used for domestic purposes, each having oven capacity of greater than 53 liters but not exceeding 55 liters, the foregoing having a glass turntable plate with a diameter greater than 35 cm but not exceeding 37 cm (provided for in subheading 8516.50.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.53",
      "rawHtsCode": "9902.16.53",
      "superior": null,
      "indent": "0",
      "description": "Microwave ovens with integral range hoods, of a kind used for domestic purposes, each having oven capacity of 56 liters or more but not over 58 liters, having a glass turntable plate with a diameter measuring 30 cm or more but not over 31 cm (provided for in subheading 8516.50.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.54",
      "rawHtsCode": "9902.16.54",
      "superior": null,
      "indent": "0",
      "description": "Microwave ovens with integral range hoods, of a kind used for domestic purposes, each having oven capacity of greater than 56 liters but not exceeding 58 liters, the foregoing having a glass rectangular turntable plate (provided for in subheading 8516.50.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.55",
      "rawHtsCode": "9902.16.55",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic waffle makers, of a kind used for domestic purposes, with dual-sided plates positioned vertically and deep grids divided into equal quarters in a circular shape mold, with funnel on top; such appliances in stainless steel housing, with a spout including fill mark level and a release to open housing for waffle removal (provided for in subheading 8516.60.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.56",
      "rawHtsCode": "9902.16.56",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic multifunction grills of a kind used for domestic purposes, each incorporating a cooking plate for use as a grill, griddle or oven, with removable power cord with a thermostatic control (provided for in subheading 8516.60.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.57",
      "rawHtsCode": "9902.16.57",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic dual-grid sandwich grilling appliances of a kind used for domestic purposes, each with a locking latch and floating upper lid (provided for in subheading 8516.60.60), the foregoing without thermostatic control",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.58",
      "rawHtsCode": "9902.16.58",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic automatic drip coffee makers of a kind used for domestic purposes, each capable of brewing multiple servings and incorporating a removable water tank with a handle; the foregoing excluding coffee makers with dome-shaped housing or designed for permanent installation into a wall, cabinet or shelf, and excluding coffee makers designed to utilize coffee capsules or pods (provided for in subheading 8516.71.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.59",
      "rawHtsCode": "9902.16.59",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic automatic coffee makers of a kind used for domestic purposes, each having a dome-shaped housing over the brewing chamber, the foregoing capable of brewing multiple servings and designed to heat all water in separate heating chamber before releasing heated water into brewing chamber (provided for in subheading 8516.71.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.60",
      "rawHtsCode": "9902.16.60",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic siphon coffee brewers of a kind used for domestic purposes, each with upper globe-shaped chamber that seals to bottom carafe magnetically, the foregoing having an electronic control in base (provided for in subheading 8516.71.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.61",
      "rawHtsCode": "9902.16.61",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic tea kettles, of a kind used for domestic purposes, each with clear glass chamber, having a stainless steel tea steeper and hinged metal limescale filter, the foregoing having a base containing a temperature control lever (provided for in subheading 8516.71.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.62",
      "rawHtsCode": "9902.16.62",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic coffee machines of a kind used for domestic purposes, designed to brew using coffee capsules, each having a loading lever containing both stainless steel and plastic (provided for in subheading 8516.71.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.63",
      "rawHtsCode": "9902.16.63",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic espresso makers of a kind used for domestic purposes, each with hydraulically activated \"shower head\" spray with automatic tamping and retraction functionality and magnetic locking drawer style filter, the foregoing without bayonet locking tabs (provided for in subheading 8516.71.00)",
      "units": [],
      "generalRate": "0.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.64",
      "rawHtsCode": "9902.16.64",
      "superior": null,
      "indent": "0",
      "description": "Automatic drip coffee makers of a kind used for domestic purposes, each with an electronic programmable clock and with a front-access water reservoir and brew basket (provided for in subheading 8516.71.00); the foregoing other than coffee makers with removable water tank or with dome-shaped housing over brewing chamber",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.65",
      "rawHtsCode": "9902.16.65",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic automatic drip coffee makers of a kind used for domestic purposes, each with electronic clock and self-contained coffee holding chamber, the foregoing designed to be used without separate carafe (provided for in subheading 8516.71.00); the foregoing excluding coffee makers (i) designed for permanent installation in a wall, cabinet or shelf, (ii) with removable tank with a handle or (iii) with loading lever containing both stainless steel and plastics",
      "units": [],
      "generalRate": "0.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.66",
      "rawHtsCode": "9902.16.66",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic automatic coffee makers of a kind used for domestic purposes, each incorporated into a housing for permanent installation into a wall or cabinet or on a shelf and capable of remote operation via wireless connection to a smartphone or tablet (provided for in subheading 8516.71.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.67",
      "rawHtsCode": "9902.16.67",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic toaster ovens of a kind used for domestic purposes, each incorporating a single-slot toaster opening on top of the oven (provided for in subheading 8516.72.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.68",
      "rawHtsCode": "9902.16.68",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic painted metal dome-shaped kettles, of a kind used for domestic purposes, each with a circular thermometer display and a base containing a temperature control lever and power button (provided for in subheading 8516.79.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.69",
      "rawHtsCode": "9902.16.69",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic stainless steel cylindrical kettles, of a kind used for domestic purposes, each with a liquid crystal display and operational control buttons and display on top of the handle and having a translucent capacity indicator behind the handle (provided for in subheading 8516.79.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.70",
      "rawHtsCode": "9902.16.70",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic slow cookers of a kind used for domestic purposes with stainless steel or painted metal exterior, each with a glass lid and removable ceramic cooking pot with a capacity of 5.68 liters, such cooker having five cooking functions (slow cook, brown and saute, steam, bake and roast) controlled by a digital control panel (provided for in subheading 8516.79.00), the foregoing without a thermometer probe or boiling and simmering functions",
      "units": [],
      "generalRate": "1.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.71",
      "rawHtsCode": "9902.16.71",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic slow cookers of a kind used for domestic purposes, with stainless steel or painted metal exterior, each with a glass lid and removable ceramic cooking pot with a capacity of 5.68 liters, such cookers having three cooking functions (bake, saute and slow cooking) operated by a digital control panel (provided for in subheading 8516.79.00), the foregoing without a thermometer probe or boiling and simmering functions",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.72",
      "rawHtsCode": "9902.16.72",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic slow cookers of a kind used for domestic purposes, with stainless steel or painted metal exterior, each with one primary removable ceramic cooking pot with a capacity of 3.31 liters and with two removable ceramic cooking pots each having a capacity of 1.42 liters located above the primary unit and attached to swing arms that can move to the left and right of such primary unit, with separate knobs to control temperature of each cooking pot (provided for in subheading 8516.79.00), the foregoing without a thermometer probe or boiling and simmering functions ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.73",
      "rawHtsCode": "9902.16.73",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic sandwich cookers of a kind used for domestic purposes, designed to be used with round bread (provided for in subheading 8516.79.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.74",
      "rawHtsCode": "9902.16.74",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic multifunctional cookers (multicookers) of a kind used for domestic purposes, each incorporating a timer and designed to prepare foods by various methods, including boiling, simmering, baking, frying, roasting or stewing (provided for in subheading 8516.79.00), the foregoing without a thermometer probe ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.75",
      "rawHtsCode": "9902.16.75",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic programmable slow cookers of a kind used for domestic purposes, with thermometer probe (provided for in subheading 8516.79.00), the foregoing without boiling and simmering functions ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.76",
      "rawHtsCode": "9902.16.76",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic pressure cookers of a kind used for domestic purposes, with a capacity of not less than 5 liters, rated more than 1000 W but not more than 1200 W (provided for in subheading 8516.79.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.77",
      "rawHtsCode": "9902.16.77",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic rice cookers of a kind used for domestic purposes, rated 200 W or less, each with detachable power cord (provided for in subheading 8516.79.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.78",
      "rawHtsCode": "9902.16.78",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic pressure cookers of a kind used for domestic purposes, each with a capacity of not less than 5 liters and rated more than 1200 W but not more than 1400 W (provided for in subheading 8516.79.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.79",
      "rawHtsCode": "9902.16.79",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic pressure cookers of a kind used for domestic purposes, each with a capacity of less than 5 liters and rated from 800 W to 1000 W (provided for in subheading 8516.79.00)",
      "units": [],
      "generalRate": "0.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.80",
      "rawHtsCode": "9902.16.80",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic hot oil popcorn poppers of a kind used for domestic purposes, each with rotating metal wire stirring sticks and mechanical tumbler action (provided for in subheading 8516.79.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.81",
      "rawHtsCode": "9902.16.81",
      "superior": null,
      "indent": "0",
      "description": "Electrothermic plug-mounted room deodorizers of a kind used for domestic purposes, each with decorative non-plastic housing, not incorporating a rheostat; such appliances intended for use with fragrant wax, whether or not presented with wax (provided for in subheading 8516.79.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.82",
      "rawHtsCode": "9902.16.82",
      "superior": null,
      "indent": "0",
      "description": "Handheld electrothermic garment steamers of a kind used for domestic purposes, each with body of plastics, with output rated less than 1000 W, with retractable cord and weighing not more than 1 kg, whether or not packaged with a storage bag (provided for in subheading 8516.79.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.83",
      "rawHtsCode": "9902.16.83",
      "superior": null,
      "indent": "0",
      "description": "Vacuum insulated coffee carafes, with interior and exterior of stainless steel, each with a capacity over 1 liter but not over 2 liters and plastic brew-through lid for direct brewing (provided for in subheading 8516.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.84",
      "rawHtsCode": "9902.16.84",
      "superior": null,
      "indent": "0",
      "description": "Vacuum insulated thermal pitchers, each with stainless steel interior and exterior, with a capacity exceeding 1 liter but not exceeding 2 liters, measuring 27.94 cm or more but not over 30.48 cm in height, with plastic brew-through lid for direct brewing and plastic spout and handle for pouring (provided for in subheading 8516.90.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.85",
      "rawHtsCode": "9902.16.85",
      "superior": null,
      "indent": "0",
      "description": "Flat panel liquid crystal display (LCD) television reception apparatus, each including a television tuner, designed for incorporation into exercise equipment (provided for in subheading 8528.72.72)",
      "units": [],
      "generalRate": "3.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.86",
      "rawHtsCode": "9902.16.86",
      "superior": null,
      "indent": "0",
      "description": "15 Amp ground fault circuit interrupters (provided for in subheading 8536.30.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.87",
      "rawHtsCode": "9902.16.87",
      "superior": null,
      "indent": "0",
      "description": "Ground fault circuit interrupters rated at 20 A (provided for in subheading 8536.30.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.88",
      "rawHtsCode": "9902.16.88",
      "superior": null,
      "indent": "0",
      "description": "Arc fault circuit interrupters, including dual function arc/ground fault circuit interrupters (provided for in subheading 8536.30.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.89",
      "rawHtsCode": "9902.16.89",
      "superior": null,
      "indent": "0",
      "description": "Lamp-holder housings of porcelain, containing sockets (provided for subheading 8536.61.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.90",
      "rawHtsCode": "9902.16.90",
      "superior": null,
      "indent": "0",
      "description": "Assemblies each comprising a chassis or shelving of subheading 8517.70 combined with a backplane (panel/distribution board) equipped with two or more apparatus of heading 8535 or 8536, for electric control or the distribution of electricity, for a voltage not exceeding 1,000 V (provided for in subheading 8537.10.91)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.91",
      "rawHtsCode": "9902.16.91",
      "superior": null,
      "indent": "0",
      "description": "Printed circuit assemblies suitable for use solely with ground fault circuit interrupters (GFCIs) and arc fault circuit interrupters (AFCIs) of subheading 8536.30.80 (provided for in subheading 8538.90.30)    ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.92",
      "rawHtsCode": "9902.16.92",
      "superior": null,
      "indent": "0",
      "description": "Ultraviolet lamps filled with deuterium gas, each without radio-frequency identification device and valued over $300 (provided for in subheading 8539.49.00)",
      "units": [],
      "generalRate": "0.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.93",
      "rawHtsCode": "9902.16.93",
      "superior": null,
      "indent": "0",
      "description": "Ultraviolet lamps filled with deuterium gas, each with radio-frequency identification device and valued over $300 (provided for in subheading 8539.49.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.94",
      "rawHtsCode": "9902.16.94",
      "superior": null,
      "indent": "0",
      "description": "Cathode-ray data/graphic display tubes, color, with a phosphor dot screen pitch smaller than .4mm and with less than 90-degree deflection.(provided for in subheading 8540.40.10)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.95",
      "rawHtsCode": "9902.16.95",
      "superior": null,
      "indent": "0",
      "description": "Position sensors, each designed to emit digital pulses when rotated or moved linearly, consisting of an outer housing with dimensions of approximately 67 mm by 50 mm by 24 mm that contains an electrical connector and a printed circuit assembly, such sensors certified by the importer as designed for use in ground-based observatories (provided for in subheading 8543.70.45)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.96",
      "rawHtsCode": "9902.16.96",
      "superior": null,
      "indent": "0",
      "description": "Electrical cables and cable bundles for a voltage not exceeding 1,000 V, fitted with connectors (provided for in subheading 8544.42.90), the foregoing of a kind used with machines and apparatus for the manufacture or inspection of semiconductor devices of subheading 8486.20.00 or with optical instruments and appliances for inspecting semiconductor wafers of 9031.41.00",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.16.97",
      "rawHtsCode": "9902.16.97",
      "superior": null,
      "indent": "0",
      "description": "Motor chassis fitted with cabs, each consisting of a motor vehicle chassis fitted with only electric motor for propulsion and a cab, with G.V.W. exceeding 5 metric tons but not exceeding 20 metric tons and for the transport of goods (provided for in subheading 8704.90.00)",
      "units": [],
      "generalRate": "23.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.01",
      "rawHtsCode": "9902.17.01",
      "superior": null,
      "indent": "0",
      "description": "Used gear boxes for the vehicles of subheading 8701.20 or heading 8704 (provided for in subheading 8708.40.11)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.02",
      "rawHtsCode": "9902.17.02",
      "superior": null,
      "indent": "0",
      "description": "New gear boxes for the vehicles of headings 8702 or 8704, the foregoing gear boxes with six speeds and with peak torque rating of at least 69 kg-m but not greater than 110 kg-m (provided for in subheading 8708.40.11)",
      "units": [],
      "generalRate": "2.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.03",
      "rawHtsCode": "9902.17.03",
      "superior": null,
      "indent": "0",
      "description": "Used gear boxes for vehicles of subheadings 8701.30.50, 8701.91, 8701.92, 8701.93, 8701.94 and 8701.95 (provided for in subheading 8708.40.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.04",
      "rawHtsCode": "9902.17.04",
      "superior": null,
      "indent": "0",
      "description": "Differentials for vehicles of heading 8703, each incorporating a self-contained silicone-fluid filled reservoir, shear pump and progressively-locking clutch pack, the foregoing other than for tractors (except road tractors) (provided for in subheading 8708.50.89)",
      "units": [],
      "generalRate": "2.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.05",
      "rawHtsCode": "9902.17.05",
      "superior": null,
      "indent": "0",
      "description": "Suspension system stabilizer bars of alloy steel, weighing not more than 40 kg, designed for use in Class 7 and Class 8 heavy duty trucks only (provided for in subheading 8708.80.65)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.06",
      "rawHtsCode": "9902.17.06",
      "superior": null,
      "indent": "0",
      "description": "Mufflers and exhaust pipes for motor vehicles of headings 8701 to 8705 (other than for tractors suitable for agricultural use) (provided for in subheading 8708.92.50) and parts thereof (provided for in subheading 8708.92.75) ",
      "units": [],
      "generalRate": "2.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.07",
      "rawHtsCode": "9902.17.07",
      "superior": null,
      "indent": "0",
      "description": "Bicycles each with no seat, no seat tube and no seat stay, designed to be pedaled by a user in a standing position only, such bicycles having both wheels not exceeding 63.5 cm in diameter (provided for in subheading 8712.00.15).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.08",
      "rawHtsCode": "9902.17.08",
      "superior": null,
      "indent": "0",
      "description": "Cycles, each either with two wheels and having both wheels not exceeding 63.5 cm in diameter, or with three wheels; all the foregoing propelled by laterally mounted pedals designed to be pushed in an alternative elliptical step motion (provided for in subheading 8712.00.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.09",
      "rawHtsCode": "9902.17.09",
      "superior": null,
      "indent": "0",
      "description": "Unicycles (provided for in 8712.00.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.10",
      "rawHtsCode": "9902.17.10",
      "superior": null,
      "indent": "0",
      "description": "Disc brakes designed for bicycles, and parts thereof (provided for in 8714.94.90)",
      "units": [],
      "generalRate": "6.7%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.11",
      "rawHtsCode": "9902.17.11",
      "superior": null,
      "indent": "0",
      "description": "\"Z\"-shaped water bottle holders (cages) of alloy or composite material, designed for use on bicycles (provided for in 8714.99.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.12",
      "rawHtsCode": "9902.17.12",
      "superior": null,
      "indent": "0",
      "description": "Wide angle reflectors, designed for use on bicycles (provided for in 8714.99.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.13",
      "rawHtsCode": "9902.17.13",
      "superior": null,
      "indent": "0",
      "description": "One-piece baby strollers, each with non-detachable seat; with foldable, non-removable anchor points designed for car seat mounting and a folding mechanism designed to allow the backrest to collapse forward against the stroller seat (provided for in heading 8715.00.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.14",
      "rawHtsCode": "9902.17.14",
      "superior": null,
      "indent": "0",
      "description": "Baby strollers, each with chassis presented with removable seat and removable bassinet, with the seat designed to be attached to the chassis base plate, with the seat backrest designed to allow a child to be in a reclining position or to be supported at varying backrest angles; the foregoing not including any such stroller with a tilting or tilted seat only (provided for in heading 8715.00.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.15",
      "rawHtsCode": "9902.17.15",
      "superior": null,
      "indent": "0",
      "description": "Projection lenses, each with focal length of 1.13 m or more but not over 36.94 m and a throw ratio of 0.66 m or more but not over 9.23 m, the foregoing not exceeding 8 kg in weight (provided for in subheading 9002.11.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.16",
      "rawHtsCode": "9902.17.16",
      "superior": null,
      "indent": "0",
      "description": "Projection lenses, each with focal length of 19.68 mm or more but not over 132.0 mm, throw ratio of 0.28:1 or more but not over 7.10:1 and focus range optical 0.45 m or more but not over 40 m, the foregoing not exceeding 5.4 kg in weight (provided for in subheading 9002.11.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.17",
      "rawHtsCode": "9902.17.17",
      "superior": null,
      "indent": "0",
      "description": "Swim goggles, protective, with silicone head straps (provided for in subheading 9004.90.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.18",
      "rawHtsCode": "9902.17.18",
      "superior": null,
      "indent": "0",
      "description": "Projection screens, each measuring 11 m or more but not over 22 m in width, of acoustically transparent perforated material (provided for in subheading 9010.60.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.19",
      "rawHtsCode": "9902.17.19",
      "superior": null,
      "indent": "0",
      "description": "Liquid crystal display (LCD) television panel assemblies, each with a video display diagonal measuring not over 58.42 cm (provided for in subheading 9013.80.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.20",
      "rawHtsCode": "9902.17.20",
      "superior": null,
      "indent": "0",
      "description": "Liquid crystal display (LCD) television panel assemblies, each with a video display diagonal measuring over 58.42 cm but not over 78.74 cm (provided for in subheading 9013.80.90) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.21",
      "rawHtsCode": "9902.17.21",
      "superior": null,
      "indent": "0",
      "description": "Liquid crystal display (LCD) television panel assemblies, each with a video display diagonal measuring over 78.74 cm but not over 81.28 cm (provided for in subheading 9013.80.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.22",
      "rawHtsCode": "9902.17.22",
      "superior": null,
      "indent": "0",
      "description": "Liquid crystal display (LCD) television panel assemblies, each with a video display diagonal measuring over 81.28 cm but not over 99.06 cm (provided for in subheading 9013.80.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.23",
      "rawHtsCode": "9902.17.23",
      "superior": null,
      "indent": "0",
      "description": "Liquid crystal display (LCD) television panel assemblies, each with a video display diagonal measuring over 99.06 cm but not over 101.6 cm (provided for in subheading 9013.80.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.24",
      "rawHtsCode": "9902.17.24",
      "superior": null,
      "indent": "0",
      "description": "Liquid crystal display (LCD) television panel assemblies, each with a video display diagonal measuring over 101.6 cm but not over 124.46 cm (provided for in subheading 9013.80.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.25",
      "rawHtsCode": "9902.17.25",
      "superior": null,
      "indent": "0",
      "description": "Liquid crystal display (LCD) television panel assemblies, each with a video display diagonal measuring over 124.46 cm but not over 137.16 cm (provided for in subheading 9013.80.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.26",
      "rawHtsCode": "9902.17.26",
      "superior": null,
      "indent": "0",
      "description": "Liquid crystal display (LCD) television panel assemblies, each with a video display diagonal measuring over 137.16 cm (provided for in subheading 9013.80.90)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.27",
      "rawHtsCode": "9902.17.27",
      "superior": null,
      "indent": "0",
      "description": "Optical attenuators designed to reduce the power level of an optical signal, either in free space or in an optical fiber, such instruments or apparatus specifically designed for telecommunications (provided for in subheading 9013.80.90).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.28",
      "rawHtsCode": "9902.17.28",
      "superior": null,
      "indent": "0",
      "description": "Bicycle speedometers (provided for in 9029.20.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.29",
      "rawHtsCode": "9902.17.29",
      "superior": null,
      "indent": "0",
      "description": "Oscilloscopes and oscillographs, having a bandwidth range of 20 GHz to 90 GHz and a sampling rate range of 50 megabytes per second (50 Mbps) to 80 gigabytes per second (80 Gbps), each with 1 to 16 measurement channels, internal hard drive, 1 to 4 interchangeable measurement modules and a color touch screen measuring over 25 cm but not over 28 cm (provided for in subheading 9030.20.10), the foregoing other than hand-held",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.30",
      "rawHtsCode": "9902.17.30",
      "superior": null,
      "indent": "0",
      "description": "Hand-held oscilloscopes (provided for in subheading 9030.20.10)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.31",
      "rawHtsCode": "9902.17.31",
      "superior": null,
      "indent": "0",
      "description": "Multimeters, each without recording device, not intended to be hand-held, having either 4-1/2, 5-1/2, 6-1/2, 7-1/2 or 8-1/2 digits of measurement accuracy, with or without LXI (LAN extension for instruments) standard and with either a color or non-color single or dual display screen (provided for in subheading 9030.31.00).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.32",
      "rawHtsCode": "9902.17.32",
      "superior": null,
      "indent": "0",
      "description": "True RMS (root mean square) multimeters, without recording device, hand-held, each having either 3-1/2, 4 or 4-1/2 digits of measurement accuracy and either a liquid crystal display (LCD) or organic light emitting diode (OLED) display screen, designed to provide one or more of the following measurements: DCV, ACV, DCI, ACI, 2 and/or 4 wire resistance, frequency, continuity, diode test, capacitance, temperature, dB, switch counter, harmonic ratio, pulse width, delay cycle and/or 4 to 20 mA percent scale (provided for in subheading 9030.31.00).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.33",
      "rawHtsCode": "9902.17.33",
      "superior": null,
      "indent": "0",
      "description": "PXI 6-1/2 digit digital multimeters (DMM), each without recording device, not intended to be hand-held, having 6-1/2 digit of measurement accuracy, designed to provide basic measurements that may include DCV, ACV, DCI, ACI, 2 and 4 wire resistance, frequency, period, capacitance, temperature, duty cycle, counter and DC source (provided for in subheading 9030.31.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.34",
      "rawHtsCode": "9902.17.34",
      "superior": null,
      "indent": "0",
      "description": "Digital multimeters, each having 8.5 digit resolution and having a recording device, certified by the importer as having 3 ppm direct current volts (DCV) accuracy (provided for in subheading 9030.32.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.35",
      "rawHtsCode": "9902.17.35",
      "superior": null,
      "indent": "0",
      "description": "Impedance analyzers, having a frequency range of 20 Hz to 120 MHz and plus or minus 42 V peak maximum output, each with 1 to 4 measurement channels, a recording device and a color touch screen measuring over 25 cm but not over 28 cm (provided for in subheading 9030.84.00).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.36",
      "rawHtsCode": "9902.17.36",
      "superior": null,
      "indent": "0",
      "description": "Electromagnetic interference (EMI) receivers, each having a frequency band range from 3 Hz to 44 GHz, conforming to LXI (Local area network eXtension for Instruments) standard, with two radio frequency (RF) inputs and with a color display screen with a display diagonal exceeding 20 cm but not exceeding 23 cm (provided for in subheading 9030.84.00).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.37",
      "rawHtsCode": "9902.17.37",
      "superior": null,
      "indent": "0",
      "description": "Multifunction devices for calibrating electrical safety testers, each incorporating signal generator and multimeter, with a recording device (provided for in subheading 9030.84.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.38",
      "rawHtsCode": "9902.17.38",
      "superior": null,
      "indent": "0",
      "description": "Local area network (LAN) eXtensions for Instrumentation (LXI) data acquisition/switch units, each having both a universal serial bus (USB) and LAN terminal using the LXI standard, having a 3-slot mainframe in rear for plug-in modules, capable of measuring 11 different input signals and having a built-in digital multimeter (DMM) with 6-1/2 digits (22 bits) of resolution (provided for in subheading 9030.89.01).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.39",
      "rawHtsCode": "9902.17.39",
      "superior": null,
      "indent": "0",
      "description": "Signal generators, certified by the importer to be used for calibrating oscilloscopes, the foregoing each with five channels and no recording device (provided for in subheading 9030.89.01)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.40",
      "rawHtsCode": "9902.17.40",
      "superior": null,
      "indent": "0",
      "description": "Signal generators, certified by the importer to be used for calibrating radio frequency measurement equipment, each presented without a recording device (provided for in subheading 9030.89.01)\n\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.41",
      "rawHtsCode": "9902.17.41",
      "superior": null,
      "indent": "0",
      "description": "Output-only signal generators, each with configurable phases and harmonics designed for calibrating power and energy equipment, the foregoing without a recording device (provided for in subheading 9030.89.01).",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.42",
      "rawHtsCode": "9902.17.42",
      "superior": null,
      "indent": "0",
      "description": "Battery-operated chiming melody clock movements, complete and assembled, valued over $5 each, suitable for use in the production of grandfather clocks, wall clocks and mantel clocks (provided for in subheading 9109.10.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.43",
      "rawHtsCode": "9902.17.43",
      "superior": null,
      "indent": "0",
      "description": "Mechanical clock movements, presented complete and assembled, valued over $5 each, suitable for use in the production of grandfather clocks, wall clocks or mantel clocks (provided for in subheading 9109.90.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.44",
      "rawHtsCode": "9902.17.44",
      "superior": null,
      "indent": "0",
      "description": "Chime melody rod assemblies and parts thereof, the foregoing suitable for use in the production of grandfather clocks, wall clocks and mantel clocks (provided for in subheading 9114.90.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.45",
      "rawHtsCode": "9902.17.45",
      "superior": null,
      "indent": "0",
      "description": "Pillows, cushions and similar furnishings of cotton, each measuring over 4,000 cm² (provided for in subheading 9404.90.10)",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.46",
      "rawHtsCode": "9902.17.46",
      "superior": null,
      "indent": "0",
      "description": "Pillows, cushions and similar furnishings, the foregoing of materials other than cotton, each measuring over 4,000 cm² (provided for in subheading 9404.90.20)",
      "units": [],
      "generalRate": "5.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.47",
      "rawHtsCode": "9902.17.47",
      "superior": null,
      "indent": "0",
      "description": "Electric light emitting diode (LED) lighting fittings, of base metal other than of brass, whether ceiling (hanging) or wall mounted, each with LED light source concealed above a quartz cylinder and designed to create a total internal reflection (provided for in subheading 9405.10.60)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.48",
      "rawHtsCode": "9902.17.48",
      "superior": null,
      "indent": "0",
      "description": "Electric table or desk light-emitting diode (LED) task lamps, of base metal other than of brass, each with interchangeable mounting options including bases, clamps or other mounts (provided for in subheading 9405.20.60)",
      "units": [],
      "generalRate": "3.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.49",
      "rawHtsCode": "9902.17.49",
      "superior": null,
      "indent": "0",
      "description": "Electric table or desk light-emitting diode (LED) task lamps, of base metal other than of brass, each with ball joints to allow multiple positions of the lamp head relative to the base (provided for in subheading 9405.20.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.50",
      "rawHtsCode": "9902.17.50",
      "superior": null,
      "indent": "0",
      "description": "Electric table or desk light-emitting diode (LED) task lamps, of base metal other than of brass, each incorporating a reflector designed to reflect light from the LED in the stem of the lamp (provided for in subheading 9405.20.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.51",
      "rawHtsCode": "9902.17.51",
      "superior": null,
      "indent": "0",
      "description": "Light emitting diode (LED) motion-activated security lantern kits, of a kind used for exterior lighting, such lanterns of base metal and having antique bronze finish, each with frosted glass, with an integrated photocell and motion sensor, and with a wall mounting bracket (provided for in subheading 9405.40.60)",
      "units": [],
      "generalRate": "3.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.52",
      "rawHtsCode": "9902.17.52",
      "superior": null,
      "indent": "0",
      "description": "Emergency lights, of base metal other than of brass, round or elongated in shape, measuring between 6 and 12 cm in height, each containing incandescent lamp, lamp holder, reflector, clear glass lens with drain hole, pressure can and electrical pigtail with connector; the foregoing configured to be mounted to the exterior of an aircraft and designed for illuminating egress paths on or around the aircraft during an emergency evacuation (provided for in subheading 9405.40.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.53",
      "rawHtsCode": "9902.17.53",
      "superior": null,
      "indent": "0",
      "description": "Exterior lights, of base metal other than of brass, such lights round in shape, with a height of 11.5 cm or more but not over 12 cm and a weight not over 1.3 kg, each containing a halogen lamp, lamp holder, reflector, autotransformer and electrical connector, the foregoing configured to be mounted to the exterior of an aircraft and designed for illuminating the top surface, leading edge and engine nacelle areas of the aircraft wings for wing icing detection (provided for in subheading 9405.40.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.54",
      "rawHtsCode": "9902.17.54",
      "superior": null,
      "indent": "0",
      "description": "Clear or frosted columnar globes or shades, certified by the importer as of extruded borosilicate glass; the foregoing measuring 2.54 cm or more but not over 30.48 cm in length and 2.54 cm or more but not over 20.32 cm in diameter, each with circular openings at the top and bottom, designed for use on portable non-electrical lanterns for outdoor use (provided for in subheading 9405.91.40)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.55",
      "rawHtsCode": "9902.17.55",
      "superior": null,
      "indent": "0",
      "description": "Ski bindings (other than for cross-country skis), valued not over $55 each (provided for in subheading 9506.12.80) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.56",
      "rawHtsCode": "9902.17.56",
      "superior": null,
      "indent": "0",
      "description": "Golf club driver heads, each stamped or otherwise permanently marked to indicate a loft of 9.5 degrees (provided for in subheading 9506.39.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.57",
      "rawHtsCode": "9902.17.57",
      "superior": null,
      "indent": "0",
      "description": "Golf club driver heads, each stamped or otherwise permanently marked to indicate a loft over 9.5 degrees (provided for in subheading 9506.39.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.58",
      "rawHtsCode": "9902.17.58",
      "superior": null,
      "indent": "0",
      "description": "Golf club driver heads, each stamped or otherwise permanently marked to indicate a loft under 9.5 degrees (provided for in subheading 9506.39.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.59",
      "rawHtsCode": "9902.17.59",
      "superior": null,
      "indent": "0",
      "description": "Golf club heads designed for clubs designated as 1-irons, 2-irons, 3-irons, 4-irons or 5-irons (provided for in subheading 9506.39.00)",
      "units": [],
      "generalRate": "1.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.60",
      "rawHtsCode": "9902.17.60",
      "superior": null,
      "indent": "0",
      "description": "Golf club hybrid heads, each stamped or otherwise permanently marked as such (provided for in subheading 9506.39.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.61",
      "rawHtsCode": "9902.17.61",
      "superior": null,
      "indent": "0",
      "description": "Golf club wedge heads, each stamped or permanently marked to indicate a loft of 56 degrees or less (provided for in subheading 9506.39.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.62",
      "rawHtsCode": "9902.17.62",
      "superior": null,
      "indent": "0",
      "description": "Golf club heads designed for clubs designated as 6-irons and 7-irons (provided for in subheading 9506.39.00)",
      "units": [],
      "generalRate": "1.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.63",
      "rawHtsCode": "9902.17.63",
      "superior": null,
      "indent": "0",
      "description": "Golf club heads designed for clubs designated as 8-irons and 9-irons (provided for in subheading 9506.39.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.64",
      "rawHtsCode": "9902.17.64",
      "superior": null,
      "indent": "0",
      "description": "Golf club wedge heads, each stamped or otherwise permanently marked to indicate a loft of greater than 56 degrees (provided for in subheading 9506.39.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.65",
      "rawHtsCode": "9902.17.65",
      "superior": null,
      "indent": "0",
      "description": "Golf club putter heads (provided for in subheading 9506.39.00)",
      "units": [],
      "generalRate": "3.0%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.70",
      "rawHtsCode": "9902.17.70",
      "superior": null,
      "indent": "0",
      "description": "Tennis rackets, strung and packaged for retail sale (provided for in subheading 9506.51.20)",
      "units": [],
      "generalRate": "2.6%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.71",
      "rawHtsCode": "9902.17.71",
      "superior": null,
      "indent": "0",
      "description": "Lawn-tennis rackets, unstrung (provided for in subheading 9506.51.40)",
      "units": [],
      "generalRate": "0.4%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.72",
      "rawHtsCode": "9902.17.72",
      "superior": null,
      "indent": "0",
      "description": "Racquetball rackets (provided for in subheading 9506.59.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.73",
      "rawHtsCode": "9902.17.73",
      "superior": null,
      "indent": "0",
      "description": "Squash rackets (provided for in subheading 9506.59.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.74",
      "rawHtsCode": "9902.17.74",
      "superior": null,
      "indent": "0",
      "description": "Inflatable volleyballs (provided for in subheading 9506.62.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.75",
      "rawHtsCode": "9902.17.75",
      "superior": null,
      "indent": "0",
      "description": "Inflatable basketballs, each having an external surface other than of leather or of rubber (provided for in subheading 9506.62.80)",
      "units": [],
      "generalRate": "3.1%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.76",
      "rawHtsCode": "9902.17.76",
      "superior": null,
      "indent": "0",
      "description": "Inflatable basketballs with outer surface of leather (provided for in subheading 9506.62.80)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.77",
      "rawHtsCode": "9902.17.77",
      "superior": null,
      "indent": "0",
      "description": "Inflatable basketballs, each with an outer surface of rubber (provided for in subheading 9506.62.80)",
      "units": [],
      "generalRate": "2.5%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.78",
      "rawHtsCode": "9902.17.78",
      "superior": null,
      "indent": "0",
      "description": "Noninflatable hollow racquetballs, not over 19 cm in diameter (provided for in subheading 9506.69.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.79",
      "rawHtsCode": "9902.17.79",
      "superior": null,
      "indent": "0",
      "description": "Fitness equipment designed for circuit training, each unit comprising a steel frame and standing platform incorporating six handles attached to cables and pulleys with variable resistance levels, with an electronic control panel capable of the wireless exchange of data and having a multicolored light-emitting diode (LED) grid (provided for in subheading 9506.91.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.80",
      "rawHtsCode": "9902.17.80",
      "superior": null,
      "indent": "0",
      "description": "Fitness equipment designed for in-home use, each unit incorporating two independent treadmill decks with separately moving belts that rotate around a mechanical treadle and simultaneously move up and down during use, designed to allow progressive amounts of resistance and combine the functions of a treadmill, a stair climber and an elliptical machine (provided for in subheading 9506.91.00)",
      "units": [],
      "generalRate": "0.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.81",
      "rawHtsCode": "9902.17.81",
      "superior": null,
      "indent": "0",
      "description": "Fitness equipment, with pivoting handles and foot pedals that perform alternating movements which combine the motions of a stepper and an elliptical machine, driving simultaneously a radial fan and magnetic brake in the base, equipped with an electronic control console incapable of the wireless exchange of data, with non-backlit LCD display and presented with a heart-rate monitor chest strap (provided for in subheading 9506.91.00)",
      "units": [],
      "generalRate": "0.9%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.82",
      "rawHtsCode": "9902.17.82",
      "superior": null,
      "indent": "0",
      "description": "Exercise and yoga mats of synthetic material (provided for in subheading 9506.91.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.83",
      "rawHtsCode": "9902.17.83",
      "superior": null,
      "indent": "0",
      "description": "Fitness equipment, with pivoting handles and foot pedals that perform alternating movements which combine the motions of a stepper and an elliptical machine, driving simultaneously a radial fan and magnetic brake in the base, equipped with an electronic control console capable of the wireless exchange of data, with backlit LCD display and heart rate monitor (provided for in subheading 9506.91.00)",
      "units": [],
      "generalRate": "2.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.84",
      "rawHtsCode": "9902.17.84",
      "superior": null,
      "indent": "0",
      "description": "Speed bags, free standing heavy bags, heavy bag stands of steel, speed bags with inflatable balls and heavy bag shells (provided for in subheading 9506.91.00)",
      "units": [],
      "generalRate": "0.8%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.85",
      "rawHtsCode": "9902.17.85",
      "superior": null,
      "indent": "0",
      "description": "Upright, recumbent and semi-recumbent exercise cycles (provided for in subheading 9506.91.00)",
      "units": [],
      "generalRate": "4.3%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.86",
      "rawHtsCode": "9902.17.86",
      "superior": null,
      "indent": "0",
      "description": "Adjustable-weight fitness dumbbells, each ranging from 2 kg to not more than 30 kg, having the capability for wireless exchange of data, incorporating a rotating single handle grip that interlocks disks with weight plates supported by a fitted plastic base, whether or not presented packaged with units that are not capable of wireless exchange of data (provided for in subheading 9506.91.00).\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.87",
      "rawHtsCode": "9902.17.87",
      "superior": null,
      "indent": "0",
      "description": "Adjustable-weight fitness dumbbells without Bluetooth capability, each ranging from 2 kg to not more than 30 kg, certified by the importer as incorporating a rotating single handle grip that interlocks disks with weight plates, supported by a fitted plastic base (provided for in subheading 9506.91.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.88",
      "rawHtsCode": "9902.17.88",
      "superior": null,
      "indent": "0",
      "description": "Fitness equipment, each unit with pivoting handles and foot pedals with steel footbeds to allow the user to perform alternating movements (whether or not also with stationary handles), combining the motions of a stepper and an elliptical machine, and driving simultaneously a radial fan and magnetic brake in the base; with an electronic control console having a backlit liquid crystal display/light-emitting diode (LCD/LED) display and capable of the wireless exchange of data; having an integrated heart rate monitor with optional chest strap (provided for in subheading 9506.91.00) ",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.89",
      "rawHtsCode": "9902.17.89",
      "superior": null,
      "indent": "0",
      "description": "Adjustable-weight fitness dumbbells, each allowing the user to choose a weight from a range of either 2 kg or more but not over 26 kg or 4 kg or more but not over 46 kg, certified by the importer as incorporating rotating end dials that interlock disks with weight plates supported by a fitted plastic base (provided for in subheading 9506.91.00)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.90",
      "rawHtsCode": "9902.17.90",
      "superior": null,
      "indent": "0",
      "description": "Inflatable tetherballs, each with rope attachment (provided for in subheading 9506.99.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.91",
      "rawHtsCode": "9902.17.91",
      "superior": null,
      "indent": "0",
      "description": "Athletic mouth guards of plastics (provided for in subheading 9506.99.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.92",
      "rawHtsCode": "9902.17.92",
      "superior": null,
      "indent": "0",
      "description": "Boxing and mixed martial arts protective equipment, including shin guards, pads and shields (provided for in subheading 9506.99.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.93",
      "rawHtsCode": "9902.17.93",
      "superior": null,
      "indent": "0",
      "description": "Fishing rods of fiberglass and carbon fiber, one-piece, presented without fishing reels, such rods valued $5 or more but not over $50 each (provided for in subheading 9507.10.00)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.94",
      "rawHtsCode": "9902.17.94",
      "superior": null,
      "indent": "0",
      "description": "Fishing rods, each presented with a fishing reel valued over $2.70 but not more than $8.45 each and containing fishing line, the foregoing put up for retail sale as a complete kit each comprising one rod and one reel (whether or not containing other accessories), with each kit having an aggregate value of no more than $30 (provided for in 9507.30.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.95",
      "rawHtsCode": "9902.17.95",
      "superior": null,
      "indent": "0",
      "description": "Hair-slides, set with imitation pearls or imitation gem stones and not of hard rubber or plastics (provided for in subheading 9615.19.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.96",
      "rawHtsCode": "9902.17.96",
      "superior": null,
      "indent": "0",
      "description": "Hair-slides, the foregoing not set with imitation pearls or imitation gem stones, not of hard rubber or plastics (provided for in subheading 9615.19.60)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.97",
      "rawHtsCode": "9902.17.97",
      "superior": null,
      "indent": "0",
      "description": "Eyelash curlers (provided for in subheading 9615.90.20)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.98",
      "rawHtsCode": "9902.17.98",
      "superior": null,
      "indent": "0",
      "description": "Insulated coffee servers, each with exterior of stainless steel and vacuum liner of glass and a hinged brew-through lid with push-button dispensing; the foregoing with capacity over 2 liters (provided for in subheading 9617.00.40)\n",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.17.99",
      "rawHtsCode": "9902.17.99",
      "superior": null,
      "indent": "0",
      "description": "Coffee servers, each with exterior of stainless steel, vacuum glass liner, a hinged brew-through lid with top lever style pump and swivel base; the foregoing with capacity over 2 liters (provided for in subheading 9617.00.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.18.01",
      "rawHtsCode": "9902.18.01",
      "superior": null,
      "indent": "0",
      "description": "Vacuum coffee servers, each with lining of glass, a plastic exterior, top carrying handle, see-through contents window and a brew-through lid; the foregoing with a capacity over 2 liters (provided for in subheading 9617.00.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.18.02",
      "rawHtsCode": "9902.18.02",
      "superior": null,
      "indent": "0",
      "description": "Vacuum coffee servers, each with lining of stainless steel, a plastic exterior, top carrying handle, see-through contents window and a brew-through lid; the foregoing with a capacity over 2 liters (provided for in subheading 9617.00.40)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9902.18.03",
      "rawHtsCode": "9902.18.03",
      "superior": null,
      "indent": "0",
      "description": "Tripods of plastics designed for use with digital still image video cameras of subheading 8525.80.40, the foregoing measuring 12 cm or more but not over 20 cm in length (provided for in subheading 9620.00.50)",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.01",
      "rawHtsCode": "9903.01.01",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.02, 9903.01.03, 9903.01.04 and 9903.01.05 articles the product of Mexico, as provided for in U.S. note 2(a) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.02",
      "rawHtsCode": "9903.01.02",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Mexico that are donations, by persons subject to the jurisdiction of the United States, of articles, such as food, clothing, and medicine, intended to be used to relieve human suffering, as provided for in U.S. note 2(b) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.03",
      "rawHtsCode": "9903.01.03",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Mexico that are informational materials, including but not limited to, publications, films, posters, phonograph records, photographs, microfilms, microfiche, tapes, compact disks, CD ROMs, artworks, and news wire feeds",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.04",
      "rawHtsCode": "9903.01.04",
      "superior": null,
      "indent": "0",
      "description": "Articles that are entered free of duty under the terms of general note 11 to the HTSUS, including any treatment set forth in subchapter XXIII of chapter 98 and subchapter XXII of chapter 99 of the HTS, as related to the USMCA",
      "units": [],
      "generalRate": "No change",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.05",
      "rawHtsCode": "9903.01.05",
      "superior": null,
      "indent": "0",
      "description": "Potash that is a product of Mexico, as provided for in U.S. note 2(c) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.10",
      "rawHtsCode": "9903.01.10",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.11, 9903.01.12, 9903.01.13, 9903.01.14 or 9903.01.15, articles the product of Canada, as provided for in U.S. note 2(j) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 35%",
      "specialRate": "The duty provided in the applicable subheading + 35%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.11",
      "rawHtsCode": "9903.01.11",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Canada that are donations, by persons subject to the jurisdiction of the United States, of articles, such as food, clothing, and medicine, intended to be used to relieve human suffering, as provided for in U.S. note 2(k) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.12",
      "rawHtsCode": "9903.01.12",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Canada that are informational materials, including but not limited to, publications, films, posters, phonograph records, photographs, microfilms, microfiche, tapes, compact disks, CD ROMs, artworks, and news wire feeds",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.13",
      "rawHtsCode": "9903.01.13",
      "superior": null,
      "indent": "1",
      "description": "Crude oil, natural gas, lease condensates, natural gas liquids, refined petroleum products, uranium, coal, biofuels, geothermal heat, the kinetic movement of flowing water, and critical minerals, as defined by 30 U.S.C. 1606(a)(3)",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.14",
      "rawHtsCode": "9903.01.14",
      "superior": null,
      "indent": "0",
      "description": "Articles that are entered free of duty under the terms of general note 11 to the HTSUS, including any treatment set forth in subchapter XXIII of chapter 98 and subchapter XXII of chapter 99 of the HTS, as related to the USMCA.",
      "units": [],
      "generalRate": "No change",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.15",
      "rawHtsCode": "9903.01.15",
      "superior": null,
      "indent": "0",
      "description": "Potash that is a product of Canada, as provided for in U.S. note 2(I) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading +10%",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.16",
      "rawHtsCode": "9903.01.16",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in 9903.01.11, 9903.01.12, and 9903.01.14, articles the product of Canada as provided for in subdivision (m) to note 2 to this subchapter and determined by CBP to have been transshipped to evade applicable duties",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 40%",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.20",
      "rawHtsCode": "9903.01.20",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.21, 9903.01.22, or 9903.01.23 articles the product of China and Hong Kong, as provided for in U.S. note 2(s) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.21",
      "rawHtsCode": "9903.01.21",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China and Hong Kong that are donations, by persons subject to the jurisdiction of the United States, of articles, such as food, clothing, and medicine, intended to be used to relieve human suffering, as provided for in U.S. note 2(t) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.22",
      "rawHtsCode": "9903.01.22",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China and Hong Kong that are informational materials, including but not limited to, publications, films, posters, phonograph records, photographs, microfilms, microfiche, tapes, compact disks, CD ROMs, artworks, and news wire feeds",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.23",
      "rawHtsCode": "9903.01.23",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.21 and 9903.01.22, and other than products for personal use included in accompanied baggage of persons arriving in the United States, articles the product of China and Hong Kong that: (1) were loaded onto a vessel at the port of loading, or in transit on the final mode of transport prior to entry into the United States, before 12:01 a.m. eastern standard time on February 1, 2025; and (2) are entered for consumption, or withdrawn from warehouse for consumption, on or after 12:01 a.m. eastern standard time on February 4, 2025, and before 12:01 a.m. eastern standard time on March 7, 2025.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.24",
      "rawHtsCode": "9903.01.24",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.21, 9903.01.22, 9903.01.23, articles the product of China and Hong Kong, as provided for in U.S. note 2(u) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "No Change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.25",
      "rawHtsCode": "9903.01.25",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of any country, except for products described in headings 9903.01.26–9903.01.33, 9903.02.02–9903.02.91, 9903.96.01, and 9903.96.02, and except as provided for in headings 9903.01.34 and 9903.02.01, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.26",
      "rawHtsCode": "9903.01.26",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Canada, as provided for in subdivision (v)(iv) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.27",
      "rawHtsCode": "9903.01.27",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Mexico, as provided for in subdivision (v)(v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.28",
      "rawHtsCode": "9903.01.28",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of any country that (1) were loaded onto a vessel at the port of loading and in transit on the final mode of transit prior to entry into the United States, before 12:01 a.m. eastern daylight time on April 5, 2025; and (2) are entered for consumption, or withdrawn from warehouse for consumption after 12:01 a.m. eastern daylight time on April 5, 2025",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.29",
      "rawHtsCode": "9903.01.29",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of any country identified in general note 3(b)",
      "units": [],
      "generalRate": " ",
      "specialRate": " ",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.01.30",
      "rawHtsCode": "9903.01.30",
      "superior": null,
      "indent": "0",
      "description": "Articles that are donations, by persons subject to the jurisdiction of the United States, such as food, clothing, and medicine, intended to be used to relieve human suffering, as provided for in subdivision (v)(ii) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.31",
      "rawHtsCode": "9903.01.31",
      "superior": null,
      "indent": "0",
      "description": "Articles that are informational materials, including but not limited to, publications, films, posters, phonograph records, photographs, microfilms, microfiche, tapes, compact disks, CD ROMs, artworks, and news wire feeds",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.32",
      "rawHtsCode": "9903.01.32",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of any country, classified in the subheadings enumerated in subdivision (v)(iii)(a) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.33",
      "rawHtsCode": "9903.01.33",
      "superior": null,
      "indent": "0",
      "description": "Articles of iron or steel; derivative articles of iron or steel; articles of aluminum; derivative articles of aluminum; wood products; passenger vehicles (sedans, sport utility vehicles, crossover utility vehicles, minivans and cargo vans); light trucks; parts of passenger vehicles (sedans, sport utility vehicles, crossover utility vehicles, minivans and cargo vans) and light trucks; medium- and heavy-duty vehicles; parts of medium- and heavy-duty vehicles; semiconductor articles; semi-finished copper; and intensive copper derivative products, of any country, as provided in subdivisions (v)(vi) through (v)(xvi) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.34",
      "rawHtsCode": "9903.01.34",
      "superior": null,
      "indent": "0",
      "description": "The U.S. content of articles the product of any country, in which the U.S. content of the article provides at least 20 percent of the Customs value of the imported article, as provided for in subdivision (v)(xvii) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.43",
      "rawHtsCode": "9903.01.43",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Cameroon or the Democratic Republic of the Congo, as provided for in subdivision (v) of U.S. note 2 to this subchapter<b> [Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 11%",
      "specialRate": "The duty provided in the applicable subheading + 11%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.44",
      "rawHtsCode": "9903.01.44",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Chad or Equatorial Guinea, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 13%",
      "specialRate": "The duty provided in the applicable subheading + 13%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.45",
      "rawHtsCode": "9903.01.45",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Nigeria, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 14%",
      "specialRate": "The duty provided in the applicable subheading + 14%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.46",
      "rawHtsCode": "9903.01.46",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Norway or Venezuela, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.47",
      "rawHtsCode": "9903.01.47",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Mozambique, as provided for in subdivision (v) of U.S. note 2 to this subchapter<b> [Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 16%",
      "specialRate": "The duty provided in the applicable subheading + 16%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.48",
      "rawHtsCode": "9903.01.48",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Israel, Malawi, Philippines, or Zambia, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 17%",
      "specialRate": "The duty provided in the applicable subheading + 17%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.49",
      "rawHtsCode": "9903.01.49",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Nicaragua or Zimbabwe, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 18%",
      "specialRate": "The duty provided in the applicable subheading + 18%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.50",
      "rawHtsCode": "9903.01.50",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of the European Union or Jordan as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 20%",
      "specialRate": "The duty provided in the applicable subheading + 20%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.51",
      "rawHtsCode": "9903.01.51",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Côte d`Ivoire or Namibia, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 21%",
      "specialRate": "The duty provided in the applicable subheading + 21%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.52",
      "rawHtsCode": "9903.01.52",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Vanuatu, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 22%",
      "specialRate": "The duty provided in the applicable subheading + 22%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.53",
      "rawHtsCode": "9903.01.53",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Brunei, Japan, or Malaysia, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 24%",
      "specialRate": "The duty provided in the applicable subheading + 24%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.54",
      "rawHtsCode": "9903.01.54",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of South Korea, as provided for in subdivision (v) of U.S. note 2 to this subchapter<b> [Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.55",
      "rawHtsCode": "9903.01.55",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of India, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 26%",
      "specialRate": "The duty provided in the applicable subheading + 26%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.56",
      "rawHtsCode": "9903.01.56",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Kazakhstan, as provided for in subdivision (v) of U.S. note 2 to this subchapter<b> [Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 27%",
      "specialRate": "The duty provided in the applicable subheading + 27%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.57",
      "rawHtsCode": "9903.01.57",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Tunisia, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 28%",
      "specialRate": "The duty provided in the applicable subheading + 28%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.58",
      "rawHtsCode": "9903.01.58",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Pakistan, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 29%",
      "specialRate": "The duty provided in the applicable subheading + 29%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.59",
      "rawHtsCode": "9903.01.59",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Algeria, Nauru, or South Africa, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 30%",
      "specialRate": "The duty provided in the applicable subheading + 30%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.60",
      "rawHtsCode": "9903.01.60",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Libya, Moldova, or Switzerland, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 31%",
      "specialRate": "The duty provided in the applicable subheading + 31%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.61",
      "rawHtsCode": "9903.01.61",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Angola, Fiji, Indonesia, or Taiwan, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 32%",
      "specialRate": "The duty provided in the applicable subheading + 32%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.62",
      "rawHtsCode": "9903.01.62",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of North Macedonia, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 33%",
      "specialRate": "The duty provided in the applicable subheading + 33%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.63",
      "rawHtsCode": "9903.01.63",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 10, 2025, except for products described in headings 9903.01.28–9903.01.33, except as provided for in heading 9903.01.34, and except as provided for in U.S. note 2(w), articles the product of China, including Hong Kong and Macau, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision suspended. See 90 Fed. Reg. 50729.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 34%",
      "specialRate": "The duty provided in the applicable subheading + 34%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.64",
      "rawHtsCode": "9903.01.64",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Bosnia and Herzegovina, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 35%",
      "specialRate": "The duty provided in the applicable subheading + 35%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.65",
      "rawHtsCode": "9903.01.65",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Thailand, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 36%",
      "specialRate": "The duty provided in the applicable subheading + 36%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.66",
      "rawHtsCode": "9903.01.66",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Bangladesh, Botswana, Liechtenstein, or Serbia, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 37%",
      "specialRate": "The duty provided in the applicable subheading + 37%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.67",
      "rawHtsCode": "9903.01.67",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Guyana, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 38%",
      "specialRate": "The duty provided in the applicable subheading + 38%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.68",
      "rawHtsCode": "9903.01.68",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Iraq, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 39%",
      "specialRate": "The duty provided in the applicable subheading + 39%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.69",
      "rawHtsCode": "9903.01.69",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Mauritius, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 40%",
      "specialRate": "The duty provided in the applicable subheading + 40%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.70",
      "rawHtsCode": "9903.01.70",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Falkland Islands or Syria, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 41%",
      "specialRate": "The duty provided in the applicable subheading + 41%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.71",
      "rawHtsCode": "9903.01.71",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Myanmar (Burma) or Sri Lanka, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 44%",
      "specialRate": "The duty provided in the applicable subheading + 44%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.72",
      "rawHtsCode": "9903.01.72",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Vietnam, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 46%",
      "specialRate": "The duty provided in the applicable subheading + 46%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.73",
      "rawHtsCode": "9903.01.73",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Madagascar, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 47%",
      "specialRate": "The duty provided in the applicable subheading + 47%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.74",
      "rawHtsCode": "9903.01.74",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Laos, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 48%",
      "specialRate": "The duty provided in the applicable subheading + 48%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.75",
      "rawHtsCode": "9903.01.75",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Cambodia, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 49%",
      "specialRate": "The duty provided in the applicable subheading + 49%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.76",
      "rawHtsCode": "9903.01.76",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on April 9, 2025, except for products described in headings 9903.01.28-9903.01.33, and except as provided for in heading 9903.01.34, articles the product of Lesotho, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 50%",
      "specialRate": "The duty provided in the applicable subheading + 50%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.77",
      "rawHtsCode": "9903.01.77",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.78-9903.01.83 and 9903.01.90, articles the product of Brazil that are entered for consumption, or withdrawn from warehouse for consumption, after 12:01 a.m. eastern daylight time 7 days after the date of the executive order, excluding the day the executive order is signed, as provided for in subdivision (x) of U.S. note 2 to this subchapter <b>[Compiler’s note: Executive Order 14323 (90 Fed. Reg. 37739) was signed on July 30, 2025, and became effective on August 6, 2025.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 40%",
      "specialRate": "The duty provided in the applicable subheading + 40%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.78",
      "rawHtsCode": "9903.01.78",
      "superior": null,
      "indent": "0",
      "description": "<b></b>Articles the product of Brazil that (1) were loaded onto a vessel at the port of loading and in transit on the final mode of transit prior to entry into the United States, before 12:01 a.m. eastern day light time 7 days after the date of the executive order, excluding the day the executive order is signed; and (2) are entered for consumption, or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025 <b>[Compiler’s note: Executive Order 14323 (90 Fed. Reg. 37739) was signed on July 30, 2025, and became effective on August 6, 2025.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.79",
      "rawHtsCode": "9903.01.79",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Brazil that are donations, by persons subject to the jurisdiction of the United States, such as food, clothing, and medicine, intended to be used to relieve human suffering, as provided for in subdivision (x)(ii) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.80",
      "rawHtsCode": "9903.01.80",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Brazil that are informational materials, including but not limited to, publications, films, posters, phonograph records, photographs, microfilms, microfiche, tapes, compact disks, CD ROMs, artworks, and news wire feeds",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.81",
      "rawHtsCode": "9903.01.81",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Brazil, classified in the subheadings enumerated in subdivision (x)(iii)(a) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.82",
      "rawHtsCode": "9903.01.82",
      "superior": null,
      "indent": "0",
      "description": "Articles of civil aircraft (all aircraft other than military aircraft); their engines, parts, and components; their other parts, components, and subassemblies; and ground flight simulators and their parts and components of Brazil, classified in the subheadings enumerated in subdivision (x)(iv) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.83",
      "rawHtsCode": "9903.01.83",
      "superior": null,
      "indent": "0",
      "description": "Articles of iron or steel; derivative articles of iron or steel; articles of aluminum; derivative articles of aluminum; wood products; passenger vehicles (sedans, sport utility vehicles, crossover utility vehicles, minivans and cargo vans); light trucks; parts of passenger vehicles (sedans, sport utility vehicles, crossover utility vehicles, minivans and cargo vans) and light trucks; medium- and heavy-duty vehicles; parts of medium- and heavy-duty vehicles; semiconductor articles; semi-finished copper; and intensive copper derivative products, of Brazil, as provided in subdivisions (x)(v) through (x)(xv) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.84",
      "rawHtsCode": "9903.01.84",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.85-9903.01.89, articles the product of India that are entered for consumption, or withdrawn from warehouse for consumption, after 12:01 a.m. eastern daylight time on August 27, 2025, as provided for in subdivision (z) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated as of February 7, 2026.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.85",
      "rawHtsCode": "9903.01.85",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of India that (1) were loaded onto a vessel at the port of loading and in transit on the final mode of transit prior to entry into the United States, before 12:01 a.m. eastern daylight time on August 27, 2025; and (2) are entered for consumption, or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on September 17, 2025 <b>[Compiler's note: provision terminated as of February 7, 2026.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.86",
      "rawHtsCode": "9903.01.86",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of India, classified in the subheadings enumerated in subdivision (v)(iii) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated as of February 7, 2026.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.87",
      "rawHtsCode": "9903.01.87",
      "superior": null,
      "indent": "0",
      "description": "Articles of iron or steel; derivative articles of iron or steel; articles of aluminum; wood products; derivative articles of aluminum; passenger vehicles (sedans, sport utility vehicles, crossover utility vehicles, minivans, and cargo vans); light trucks; parts of passenger vehicles (sedans, sport utility vehicles, crossover utility vehicles, minivans, and cargo vans) and light trucks; medium- and heavy-duty vehicles; parts of medium- and heavy-duty vehicles; semiconductor articles; semi-finished copper; and intensive copper derivative products, of India, as provided in subdivisions (z)(iii) through (z)(xiii) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated as of February 7, 2026.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.88",
      "rawHtsCode": "9903.01.88",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of India that are donations, by persons subject to the jurisdiction of the United States, such as food, clothing, and medicine, intended to be used to relieve human suffering, as provided for in subdivision (z)(xiv) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated as of February 7, 2026.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.89",
      "rawHtsCode": "9903.01.89",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of India that are informational materials, including but not limited to, publications, films, posters, phonograph records, photographs, microfilms, microfiche, tapes, compact disks, CD ROMs, artworks, and news wire feeds <b>[Compiler's note: provision terminated as of February 7, 2026.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.01.90",
      "rawHtsCode": "9903.01.90",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Brazil, as provided for in subdivision (x)(iii)(b) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.01",
      "rawHtsCode": "9903.02.01",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of any country determined by U.S. Customs and Border Protection to have been transshipped to evade applicable duties under section 2 of Executive Order [Insert EO number], as amended [<b>Compiler's note: [Insert EO Number] refers to Executive Order 14326, 90 Fed. Reg. 37963.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 40%",
      "specialRate": "The duty provided in the applicable subheading + 40%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.02",
      "rawHtsCode": "9903.02.02",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Afghanistan, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.03",
      "rawHtsCode": "9903.02.03",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Algeria, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 30%",
      "specialRate": "The duty provided in the applicable subheading + 30%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.04",
      "rawHtsCode": "9903.02.04",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Angola, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.05",
      "rawHtsCode": "9903.02.05",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Bangladesh, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 20%",
      "specialRate": "The duty provided in the applicable subheading + 20%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.06",
      "rawHtsCode": "9903.02.06",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Bolivia, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.07",
      "rawHtsCode": "9903.02.07",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Bosnia and Herzegovina, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 30%",
      "specialRate": "The duty provided in the applicable subheading + 30%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.08",
      "rawHtsCode": "9903.02.08",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Botswana, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.09",
      "rawHtsCode": "9903.02.09",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Brazil, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.10",
      "rawHtsCode": "9903.02.10",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Brunei, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.11",
      "rawHtsCode": "9903.02.11",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Cambodia, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 19%",
      "specialRate": "The duty provided in the applicable subheading + 19%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.12",
      "rawHtsCode": "9903.02.12",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Cameroon, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.13",
      "rawHtsCode": "9903.02.13",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Chad, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.14",
      "rawHtsCode": "9903.02.14",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Costa Rica, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.15",
      "rawHtsCode": "9903.02.15",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Côte d’Ivoire, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.16",
      "rawHtsCode": "9903.02.16",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Democratic Republic of the Congo, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.17",
      "rawHtsCode": "9903.02.17",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Ecuador, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.18",
      "rawHtsCode": "9903.02.18",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Equatorial Guinea, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.19",
      "rawHtsCode": "9903.02.19",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025,except for products described in headings 9903.01.30–9903.01.33 and 9903.02.78 and 9903.02.74–9903.02.77, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of the European Union, with an ad valorem (or ad valorem equivalent) rate of duty under column 1-General equal to or greater than 15 percent, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.20",
      "rawHtsCode": "9903.02.20",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30–9903.01.33 and 9903.02.78 and 9903.02.74–9903.02.77, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of the European Union, with an ad valorem (or ad valorem equivalent) rate of duty under column 1-General less than 15 percent, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.21",
      "rawHtsCode": "9903.02.21",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Falkland Islands, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.22",
      "rawHtsCode": "9903.02.22",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Fiji, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.23",
      "rawHtsCode": "9903.02.23",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Ghana, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.24",
      "rawHtsCode": "9903.02.24",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Guyana, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.25",
      "rawHtsCode": "9903.02.25",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Iceland, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.26",
      "rawHtsCode": "9903.02.26",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of India, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.27",
      "rawHtsCode": "9903.02.27",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Indonesia, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 19%",
      "specialRate": "The duty provided in the applicable subheading + 19%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.28",
      "rawHtsCode": "9903.02.28",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Iraq, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 35%",
      "specialRate": "The duty provided in the applicable subheading + 35%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.29",
      "rawHtsCode": "9903.02.29",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Israel, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.30",
      "rawHtsCode": "9903.02.30",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Japan, as provided for in subdivision (v) of U.S. note 2 to this subchapter <b>[Compiler's note: provision terminated. See 90 Fed. Reg. 44638]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.31",
      "rawHtsCode": "9903.02.31",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Jordan, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.32",
      "rawHtsCode": "9903.02.32",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Kazakhstan, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.33",
      "rawHtsCode": "9903.02.33",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Laos, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 40%",
      "specialRate": "The duty provided in the applicable subheading + 40%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.34",
      "rawHtsCode": "9903.02.34",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Lesotho, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.35",
      "rawHtsCode": "9903.02.35",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Libya, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 30%",
      "specialRate": "The duty provided in the applicable subheading + 30%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.36",
      "rawHtsCode": "9903.02.36",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Liechtenstein, as provided for in subdivision (v) of U.S. note 2 to this subchapter<b> [Compiler's note: provision terminated. See 90 Fed. Reg. 59281.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.37",
      "rawHtsCode": "9903.02.37",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Madagascar, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.38",
      "rawHtsCode": "9903.02.38",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Malawi, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.39",
      "rawHtsCode": "9903.02.39",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Malaysia, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 19%",
      "specialRate": "The duty provided in the applicable subheading + 19%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.40",
      "rawHtsCode": "9903.02.40",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Mauritius, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.41",
      "rawHtsCode": "9903.02.41",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Moldova, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.42",
      "rawHtsCode": "9903.02.42",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Mozambique, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.43",
      "rawHtsCode": "9903.02.43",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Myanmar (Burma), as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 40%",
      "specialRate": "The duty provided in the applicable subheading + 40%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.44",
      "rawHtsCode": "9903.02.44",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Namibia, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.45",
      "rawHtsCode": "9903.02.45",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Nauru, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.46",
      "rawHtsCode": "9903.02.46",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of New Zealand, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.47",
      "rawHtsCode": "9903.02.47",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Nicaragua, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 18%",
      "specialRate": "The duty provided in the applicable subheading + 18%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.48",
      "rawHtsCode": "9903.02.48",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Nigeria, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.49",
      "rawHtsCode": "9903.02.49",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of North Macedonia, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.50",
      "rawHtsCode": "9903.02.50",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Norway, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.51",
      "rawHtsCode": "9903.02.51",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Pakistan, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 19%",
      "specialRate": "The duty provided in the applicable subheading + 19%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.52",
      "rawHtsCode": "9903.02.52",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Papua New Guinea, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.53",
      "rawHtsCode": "9903.02.53",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of the Philippines, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 19%",
      "specialRate": "The duty provided in the applicable subheading + 19%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.54",
      "rawHtsCode": "9903.02.54",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Serbia, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 35%",
      "specialRate": "The duty provided in the applicable subheading + 35%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.55",
      "rawHtsCode": "9903.02.55",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of South Africa, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 30%",
      "specialRate": "The duty provided in the applicable subheading + 30%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.56",
      "rawHtsCode": "9903.02.56",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of South Korea, as provided for in subdivision (v) of U.S. note 2 to this subchapter<b> [Compiler's note: This provision was terminated on November 14, 2025. See 90 Fed. Reg. 55964]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.57",
      "rawHtsCode": "9903.02.57",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Sri Lanka, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 20%",
      "specialRate": "The duty provided in the applicable subheading + 20%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.58",
      "rawHtsCode": "9903.02.58",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Switzerland, as provided for in subdivision (v) of U.S. note 2 to this subchapter<b> [Compiler's note: provision terminated. See 90 Fed. Reg. 59281.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 39%",
      "specialRate": "The duty provided in the applicable subheading + 39%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.59",
      "rawHtsCode": "9903.02.59",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Syria, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 41%",
      "specialRate": "The duty provided in the applicable subheading + 41%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.60",
      "rawHtsCode": "9903.02.60",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Taiwan, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 20%",
      "specialRate": "The duty provided in the applicable subheading + 20%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.61",
      "rawHtsCode": "9903.02.61",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Thailand, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 19%",
      "specialRate": "The duty provided in the applicable subheading + 19%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.62",
      "rawHtsCode": "9903.02.62",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Trinidad and Tobago, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.63",
      "rawHtsCode": "9903.02.63",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Tunisia, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.64",
      "rawHtsCode": "9903.02.64",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Turkey, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.65",
      "rawHtsCode": "9903.02.65",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Uganda, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.66",
      "rawHtsCode": "9903.02.66",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34, 9903.02.01, and 9903.96.01, articles the product of the United Kingdom, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.67",
      "rawHtsCode": "9903.02.67",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Vanuatu, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.68",
      "rawHtsCode": "9903.02.68",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Venezuela, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.69",
      "rawHtsCode": "9903.02.69",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Vietnam, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 20%",
      "specialRate": "The duty provided in the applicable subheading + 20%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.70",
      "rawHtsCode": "9903.02.70",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Zambia, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.71",
      "rawHtsCode": "9903.02.71",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Zimbabwe, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.72",
      "rawHtsCode": "9903.02.72",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34, 9903.02.01, and 9903.96.02, articles the product of Japan, with an ad valorem (or ad valorem equivalent) rate of duty under column 1 equal to or greater than 15 percent, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.73",
      "rawHtsCode": "9903.02.73",
      "superior": null,
      "indent": "0",
      "description": "Except for goods loaded onto a vessel at the port of loading and in transit on the final mode of transit before 12:01 a.m. eastern daylight time on August 7, 2025, and entered for consumption or withdrawn from warehouse for consumption before 12:01 a.m. eastern daylight time on October 5, 2025, except for products described in headings 9903.01.30-9903.01.33 and 9903.02.78, and except as provided for in headings 9903.01.34, 9903.02.01, and 9903.96.02, articles the product of Japan, with an ad valorem (or ad valorem equivalent) rate of duty under column 1 less than 15 percent, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.74",
      "rawHtsCode": "9903.02.74",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of the European Union, as provided for in subdivision (v)(xx) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.75",
      "rawHtsCode": "9903.02.75",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of the European Union, as provided for in subdivision (v)(xxi) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.76",
      "rawHtsCode": "9903.02.76",
      "superior": null,
      "indent": "0",
      "description": "Articles of civil aircraft (all aircraft other than military aircraft); their engines, parts, and components; their other parts, components, and subassemblies; and ground flight simulators and their parts and components of the European Union, excluding unmanned aircraft, provided for in subdivision (v)(xxii) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.77",
      "rawHtsCode": "9903.02.77",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of the European Union that are non-patented articles for use in pharmaceutical applications, provided for in subdivision (v)(xxiii) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1 "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.78",
      "rawHtsCode": "9903.02.78",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of any country, as provided for in subdivision (v)(iii)(b) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.79",
      "rawHtsCode": "9903.02.79",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.30–9903.01.33, 9903.02.78, and 9903.02.81, and except as provided for in headings 9903.01.34, 9903.02.01, articles the product of South Korea, with an ad valorem (or ad valorem equivalent) rate of duty under column 1-General or column 1-Special equal to or greater than 15 percent, as provided for in subdivision (v)(xxiv)(a) of U.S. note 2 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.80",
      "rawHtsCode": "9903.02.80",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.30–9903.01.33, 9903.02.78, and 9903.02.81, and except as provided for in headings 9903.01.34, 9903.02.01, articles the product of South Korea, with an ad valorem (or ad valorem equivalent) rate of duty under column 1-General or column 1-Special less than 15 percent, as provided for in subdivision (v)(xxiv)(a) of U.S. note 2 to this subchapter.",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.81",
      "rawHtsCode": "9903.02.81",
      "superior": null,
      "indent": "0",
      "description": "Articles of civil aircraft (all aircraft other than military aircraft); their engines, parts, and components; their other parts, components, and subassemblies; and ground flight simulators and their parts and components of South Korea, excluding unmanned aircraft, provided for in subdivision (v)(xxiv)(b) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.82",
      "rawHtsCode": "9903.02.82",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.30–9903.01.33, 9903.02.78, and 9903.02.84–9903.02.86, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Switzerland, with an ad valorem (or ad valorem equivalent) rate of duty under column 1-General equal to or greater than 15 percent, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.83",
      "rawHtsCode": "9903.02.83",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.30–9903.01.33, 9903.02.78, and 9903.02.84–9903.02.86, and except as provided for inheadings 9903.01.34 and 9903.02.01, articles the product of Switzerland, with an ad valorem (or ad valorem equivalent) rate of duty under column 1-General less than 15 percent, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.84",
      "rawHtsCode": "9903.02.84",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Switzerland, as provided for in subdivision (v)(xxv)(b) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.85",
      "rawHtsCode": "9903.02.85",
      "superior": null,
      "indent": "0",
      "description": "Articles of civil aircraft (all aircraft other than military aircraft); their engines, parts, and components; their other parts, components, and subassemblies; and ground flight simulators and their parts and components of Switzerland, excluding unmanned aircraft, provided for in subdivision (v)(xxv)(c) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.86",
      "rawHtsCode": "9903.02.86",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Switzerland that are non-patented articles for use in pharmaceutical applications, provided for in subdivision (v)(xxv)(d) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.87",
      "rawHtsCode": "9903.02.87",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.30–9903.01.33, 9903.02.78, and 9903.02.89–9903.02.91, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Liechtenstein, with an ad valorem (or ad valorem equivalent) rate of duty under column 1-General equal to or greater than 15 percent, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.88",
      "rawHtsCode": "9903.02.88",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.01.30–9903.01.33, 9903.02.78, and 9903.02.89–9903.02.91, and except as provided for in headings 9903.01.34 and 9903.02.01, articles the product of Liechtenstein, with an ad valorem (or ad valorem equivalent) rate of duty under column 1-General less than 15 percent, as provided for in subdivision (v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.89",
      "rawHtsCode": "9903.02.89",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Liechtenstein, as provided for in subdivision (v)(xxv)(b) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.90",
      "rawHtsCode": "9903.02.90",
      "superior": null,
      "indent": "0",
      "description": "Articles of civil aircraft (all aircraft other than military aircraft); their engines, parts, and components; their other parts, components, and subassemblies; and ground flight simulators and their parts and components of Liechtenstein, excluding unmanned aircraft, provided for in subdivision (v)(xxv)(c) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.02.91",
      "rawHtsCode": "9903.02.91",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Liechtenstein that are non-patented articles for use in pharmaceutical applications, provided for in subdivision (v)(xxv)(d) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.03.01",
      "rawHtsCode": "9903.03.01",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.03.02–9903.03.11, articles the product of any country, as provided for in subdivision (aa) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "The duty provided in the applicable subheading + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.03.02",
      "rawHtsCode": "9903.03.02",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of any country that (1) were loaded onto a vessel at the port of loading and in transit on the final mode of transit prior to entry into the United States, before 12:01 a.m. eastern standard time on February 24, 2026; and (2) are entered for consumption, or withdrawn from warehouse for consumption, before 12:01 a.m. eastern standard time on February 28, 2026",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.03.03",
      "rawHtsCode": "9903.03.03",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of any country, as provided for in subdivision (aa)(ii) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.03.04",
      "rawHtsCode": "9903.03.04",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of any country, as provided for in subdivision (aa)(iii) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.03.05",
      "rawHtsCode": "9903.03.05",
      "superior": null,
      "indent": "0",
      "description": "Articles of civil aircraft (all aircraft other than military aircraft); their engines, parts and components; their other parts, components and subassemblies; and ground flight simulators and their parts and components of any country, provided for in subdivision (aa)(iv) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.03.06",
      "rawHtsCode": "9903.03.06",
      "superior": null,
      "indent": "0",
      "description": "Articles of aluminum, of steel, or of copper or derivative aluminum or steel articles; passenger vehicles (sedans, sport utility vehicles, crossover utility vehicles, minivans, and cargo vans) and light trucks; parts of passenger vehicles (sedans, sport utility vehicles, crossover utility vehicles, minivans, and cargo vans) and light trucks; medium- and heavy-duty vehicles; parts of medium- and heavy-duty vehicles; wood products; and semiconductor articles, of any country, as provided in subdivision (aa)(v) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.03.07",
      "rawHtsCode": "9903.03.07",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Canada, as provided for in subdivision (aa)(vi) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.03.08",
      "rawHtsCode": "9903.03.08",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Mexico, as provided for in subdivision (aa)(vii) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.03.09",
      "rawHtsCode": "9903.03.09",
      "superior": null,
      "indent": "0",
      "description": "Articles of textiles or apparel the product of Costa Rica, the Dominican Republic, El Salvador, Guatemala, Honduras or Nicaragua, as provided for in subdivision (aa)(viii) of U.S. note 2 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.03.10",
      "rawHtsCode": "9903.03.10",
      "superior": null,
      "indent": "0",
      "description": "Articles that are donations, by persons subject to the jurisdiction of the United States, such as food, clothing and medicine, intended to be used to relieve human suffering",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.03.11",
      "rawHtsCode": "9903.03.11",
      "superior": null,
      "indent": "0",
      "description": "Articles that are informational materials, including but not limited to publications, films, posters, phonograph records, photographs, microfilms, microfiche, tapes, compact disks, CD ROMs, artworks and news wire feeds",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.04.05",
      "rawHtsCode": "9903.04.05",
      "superior": null,
      "indent": "1",
      "description": "In original loaves (provided for in subheading 0406.40.44, 0406.40.54, or 0406.40.70)",
      "units": [],
      "generalRate": "200%",
      "specialRate": "No change",
      "otherRate": "200%",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.04.10",
      "rawHtsCode": "9903.04.10",
      "superior": null,
      "indent": "1",
      "description": "Other (provided for in subheading 0406.20.15, 0406.20.24, 0406.20.28, 0406.30.05, 0406.30.14, 0406.30.18, 0406.40.48, 0406.40.58, or 0406.40.70)",
      "units": [],
      "generalRate": "200%",
      "specialRate": "No change",
      "otherRate": "200%",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.04.15",
      "rawHtsCode": "9903.04.15",
      "superior": null,
      "indent": "0",
      "description": "Edam and Gouda cheeses (provided for in subheading 0406.20.44, 0406.20.48, 0406.30.44, 0406.30.48, 0406.90.16 or 0406.90.18)",
      "units": [],
      "generalRate": "200%",
      "specialRate": "No change",
      "otherRate": "200%",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.04.20",
      "rawHtsCode": "9903.04.20",
      "superior": null,
      "indent": "0",
      "description": "Cheeses and substitutes for cheeses, valued over 11.3¢ per kg, containing, or processed from, Italian-type cheeses, made from cow's milk, not in original loaves (Romano made from cow's milk, Reggiano, Parmesan, Provolone, Provoletti, Sbrinz and Goya) (provided for in subheading 0406.20.77, 0406.20.79, 0406.30.77, 0406.30.79, 0406.90.66 or 0406.90.68)",
      "units": [],
      "generalRate": "200%",
      "specialRate": "No change",
      "otherRate": "200%",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.04.25",
      "rawHtsCode": "9903.04.25",
      "superior": null,
      "indent": "0",
      "description": "Endive, including Whitloof chicory, fresh, chilled, or frozen, not reduced in size nor otherwise prepared or preserved (provided for in subheading 0705.21 or 0705.29)",
      "units": [],
      "generalRate": "200%",
      "specialRate": "No change",
      "otherRate": "200%",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.04.30",
      "rawHtsCode": "9903.04.30",
      "superior": null,
      "indent": "0",
      "description": "Olives, prepared or preserved, in brine, not ripe and not pitted or stuffed, not green in color and not packed in airtight containers of glass, metal, or glass and metal (provided for in subheading 2005.70.75)",
      "units": [],
      "generalRate": "200%",
      "specialRate": "No change",
      "otherRate": "200%",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.04.35",
      "rawHtsCode": "9903.04.35",
      "superior": null,
      "indent": "0",
      "description": "Pork hams and shoulders, boned and cooked, packed in airtight containers holding less than 1.4 kg (provided for in subheading 1602.41.20 or 1602.42.20)",
      "units": [],
      "generalRate": "200%",
      "specialRate": "No change",
      "otherRate": "200%",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.04.40",
      "rawHtsCode": "9903.04.40",
      "superior": null,
      "indent": "0",
      "description": "Carrots (whether or not reduced in size), prepared or preserved, but not packed in salt, not in brine, nor pickled, in airtight containers (provided for in subheading 2005.99.10)",
      "units": [],
      "generalRate": "200%",
      "specialRate": "No change",
      "otherRate": "200%",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.04.45",
      "rawHtsCode": "9903.04.45",
      "superior": null,
      "indent": "0",
      "description": "White still wines produced from grapes, containing not over 14 percent of alcohol by volume, in containers each holding not over 3.8 liters, valued over $1.05 per liter (provided for in subheading 2204.21.20, 2204.21.40 or 2204.29.20)",
      "units": [],
      "generalRate": "200%",
      "specialRate": "No change",
      "otherRate": "200%",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.04.50",
      "rawHtsCode": "9903.04.50",
      "superior": null,
      "indent": "0",
      "description": "Brandy (other than pisco, singani and slivowitz), in containers each holding not over 3.8 liters, valued over $3.43 per liter (provided for in subheading 2208.20.40 or 2208.90.30)",
      "units": [],
      "generalRate": "200%",
      "specialRate": "No change",
      "otherRate": "200%",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.04.55",
      "rawHtsCode": "9903.04.55",
      "superior": null,
      "indent": "0",
      "description": "Gin, in containers each holding not over 3.8 liters (provided for in subheading 2208.50)",
      "units": [],
      "generalRate": "200%",
      "specialRate": "No change",
      "otherRate": "200%",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.08.04",
      "rawHtsCode": "9903.08.04",
      "superior": null,
      "indent": "1",
      "description": "Bath preparations, other than bath salts (provided for in subheading 3307.30.50)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.08.07",
      "rawHtsCode": "9903.08.07",
      "superior": null,
      "indent": "1",
      "description": "Handbags, whether or not with shoulder strap, including those without handle, with outer surface of sheeting of plastic (provided for in subheading 4202.22.15)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.08.08",
      "rawHtsCode": "9903.08.08",
      "superior": null,
      "indent": "1",
      "description": "Articles of a kind normally carried in the pocket or in the handbag, with outer surface of sheeting of plastic, of reinforced or laminated plastics (provided for in subheading 4202.32.10)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.08.09",
      "rawHtsCode": "9903.08.09",
      "superior": null,
      "indent": "1",
      "description": "Uncoated felt paper and paperboard in rolls or sheets (provided for in subheading 4805.50)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.08.10",
      "rawHtsCode": "9903.08.10",
      "superior": null,
      "indent": "1",
      "description": "Folding cartons, boxes and cases, of noncorrugated paper or paperboard (provided for in subheading 4819.20)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.08.11",
      "rawHtsCode": "9903.08.11",
      "superior": null,
      "indent": "1",
      "description": "Lithographs on paper or paperboard, not over 0.51 mm in thickness, printed not over 20 years at time of importation (provided for in subheading 4911.91.20)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.08.13",
      "rawHtsCode": "9903.08.13",
      "superior": null,
      "indent": "1",
      "description": "Bed linen, other than knit or crocheted, printed, of cotton, other than containing any embroidery, lace, braid, edging, trimming, piping or applique work, not napped (provided for in subheading 6302.21.90)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.08.14",
      "rawHtsCode": "9903.08.14",
      "superior": null,
      "indent": "1",
      "description": "Lead-acid storage batteries, other than of a kind used for starting piston engines or as the primary source of electrical power for electrically powered vehicles of subheading 8703.80.00 and 8703.90.01 (provided for in subheading 8507.20.80)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.08.15",
      "rawHtsCode": "9903.08.15",
      "superior": null,
      "indent": "1",
      "description": "Electrothermic coffee or tea makers, of a kind used for domestic purposes (provided for in subheading 8516.71)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.17.01",
      "rawHtsCode": "9903.17.01",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the first quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.02",
      "rawHtsCode": "9903.17.02",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the second quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.03",
      "rawHtsCode": "9903.17.03",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the third quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.04",
      "rawHtsCode": "9903.17.04",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the fourth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.05",
      "rawHtsCode": "9903.17.05",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the fifth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.06",
      "rawHtsCode": "9903.17.06",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the sixth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.07",
      "rawHtsCode": "9903.17.07",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the seven quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.08",
      "rawHtsCode": "9903.17.08",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the eighth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.09",
      "rawHtsCode": "9903.17.09",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the ninth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.10",
      "rawHtsCode": "9903.17.10",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the tenth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.21",
      "rawHtsCode": "9903.17.21",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the first quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.22",
      "rawHtsCode": "9903.17.22",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the second quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.23",
      "rawHtsCode": "9903.17.23",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the third quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.24",
      "rawHtsCode": "9903.17.24",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the fourth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.25",
      "rawHtsCode": "9903.17.25",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the fifth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.26",
      "rawHtsCode": "9903.17.26",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the sixth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.27",
      "rawHtsCode": "9903.17.27",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the seventh quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.28",
      "rawHtsCode": "9903.17.28",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the eighth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.29",
      "rawHtsCode": "9903.17.29",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the ninth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.30",
      "rawHtsCode": "9903.17.30",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the tenth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.31",
      "rawHtsCode": "9903.17.31",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the eleventh quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.32",
      "rawHtsCode": "9903.17.32",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the twelfth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.17.33",
      "rawHtsCode": "9903.17.33",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the thirteenth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.18.01",
      "rawHtsCode": "9903.18.01",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the first quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.18.02",
      "rawHtsCode": "9903.18.02",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the second quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.18.03",
      "rawHtsCode": "9903.18.03",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the third quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.18.04",
      "rawHtsCode": "9903.18.04",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the fourth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.18.05",
      "rawHtsCode": "9903.18.05",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the fifth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.18.06",
      "rawHtsCode": "9903.18.06",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the sixth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.18.07",
      "rawHtsCode": "9903.18.07",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the seventh quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.18.08",
      "rawHtsCode": "9903.18.08",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the eighth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.18.09",
      "rawHtsCode": "9903.18.09",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the ninth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.18.10",
      "rawHtsCode": "9903.18.10",
      "superior": null,
      "indent": "2",
      "description": "Eligible to be imported under the tenth quota period specified in a notice issued by the United States Trade Representative in any 12 month period commencing on October 1 in any year",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.19.19",
      "rawHtsCode": "9903.19.19",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheading 1901.10.16, 1901.10.26, 1901.10.36 or 1901.10.44",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " Effective July 21, 2022 through December 31, 2022. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.19.20",
      "rawHtsCode": "9903.19.20",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheading 1901.10.29 or 1901.10.49",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " Effective July 21, 2022 through December 31, 2022. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.19.21",
      "rawHtsCode": "9903.19.21",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheading 2106.90.97",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " Effective July 21, 2022 through December 31, 2022. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.19.22",
      "rawHtsCode": "9903.19.22",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheading 2106.90.99",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " Effective July 21, 2022 through December 31, 2022. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.19.23",
      "rawHtsCode": "9903.19.23",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheading 1901.90.62 [<b>Compiler's note: Subheading was enacted; expired at the close of Dec. 31, 2022</b>]",
      "units": [],
      "generalRate": "Free",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.27.01",
      "rawHtsCode": "9903.27.01",
      "superior": null,
      "indent": "1",
      "description": "Distillate and residual fuel oils (including blended fuel oils) and wastes of distillate and residual fuel oils (whether or not blended) (provided for in subheading 2710.19.06, 2710.19.11, 2710.20.05, 2710.20.10, 2710.99.05 or 2710.99.10)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.02",
      "rawHtsCode": "9903.27.02",
      "superior": null,
      "indent": "1",
      "description": "Rare gases, other than argon (provided for in subheading 2804.29.00)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.03",
      "rawHtsCode": "9903.27.03",
      "superior": null,
      "indent": "1",
      "description": "Germanium oxides and zirconium dioxide (provided for in subheading 2825.60.00)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.04",
      "rawHtsCode": "9903.27.04",
      "superior": null,
      "indent": "1",
      "description": "Carbides of silicon (provided for in subheading 2849.20.10 or 2849.20.20)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.05",
      "rawHtsCode": "9903.27.05",
      "superior": null,
      "indent": "1",
      "description": "Other mineral or chemical fertilizers, containing nitrates and phosphates (provided for in subheading 3105.51.00)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.06",
      "rawHtsCode": "9903.27.06",
      "superior": null,
      "indent": "1",
      "description": "Pigments and preparations based on titanium dioxide (provided for in subheading 3206.11.00 or 3206.19.00)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.07",
      "rawHtsCode": "9903.27.07",
      "superior": null,
      "indent": "1",
      "description": "Other uncoated, unbleached kraft paper and paperboard, in rolls or sheets, weighing 225 g/m2 or more (provided for in subheading 4804.51.00)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.08",
      "rawHtsCode": "9903.27.08",
      "superior": null,
      "indent": "1",
      "description": "Other footwear with outer soles of rubber, plastics or composition leather and uppers of leather (provided for in subheading 6403.99.60, 6403.99.75 or 6403.99.90)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.09",
      "rawHtsCode": "9903.27.09",
      "superior": null,
      "indent": "1",
      "description": "Other footwear with outer soles of rubber or plastics and uppers of textile materials, with open toes or open heels, or of the slip-on type (provided for in subheading 6404.19.35)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.10",
      "rawHtsCode": "9903.27.10",
      "superior": null,
      "indent": "1",
      "description": "Diamonds, unsorted (provided for in subheading 7102.10.00)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.11",
      "rawHtsCode": "9903.27.11",
      "superior": null,
      "indent": "1",
      "description": "Diamonds, nonindustrial (provided for in subheading 7102.31.00 or 7102.39.00)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.12",
      "rawHtsCode": "9903.27.12",
      "superior": null,
      "indent": "1",
      "description": "Catalysts in the form of wire cloth or grill, of platinum (provided for in subheading 7115.10.00)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.13",
      "rawHtsCode": "9903.27.13",
      "superior": null,
      "indent": "1",
      "description": "Unrefined copper; copper anodes for electrolytic refining (provided for in heading 7402.00.00)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.14",
      "rawHtsCode": "9903.27.14",
      "superior": null,
      "indent": "1",
      "description": "Other unwrought aluminum alloys (provided for in subheading 7601.20.90)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.27.15",
      "rawHtsCode": "9903.27.15",
      "superior": null,
      "indent": "1",
      "description": "Other refrigerating or freezing equipment; heat pumps (provided for in subheading 8418.69.00)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.40.05",
      "rawHtsCode": "9903.40.05",
      "superior": null,
      "indent": "1",
      "description": "Radial tires of a kind used on motor cars (other than racing cars), station wagons, sport utility vehicles, vans and on-the-highway light trucks (provided for in subheading 4011.10.10 or 4011.20.10)",
      "units": [],
      "generalRate": "25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.40.10",
      "rawHtsCode": "9903.40.10",
      "superior": null,
      "indent": "1",
      "description": "Other tires of a kind used on motor cars (other than racing cars), station wagons, sport utility vehicles, vans and on-the-highway light trucks (provided for in subheading 4011.10.50 or 4011.20.50)",
      "units": [],
      "generalRate": "25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.41.05",
      "rawHtsCode": "9903.41.05",
      "superior": null,
      "indent": "1",
      "description": "Bovine (including buffalo) and equine leather (provided for in heading 4104 or 4107); goat, kid, sheep and lamb leather, the foregoing dyed, colored, stamped or embossed (provided for in heading 4105, 4106, 4112 or 4113)",
      "units": [],
      "generalRate": "40%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.41.10",
      "rawHtsCode": "9903.41.10",
      "superior": null,
      "indent": "1",
      "description": "Footwear with outer soles of leather and uppers wholly or in part of leather, and footwear with outer soles of rubber or plastics and uppers having an exterior surface area predominantly of leather, the foregoing provided for in chapter 64, except (a) slip-on footwear of a type not suitable for outdoor use, without backs or backstraps, having outer soles with a thickness of less than 5 mm and with less than 20 mm difference between the thickness of the bottom at the ball of the foot and at the heel, and (b) footwear which is designed for a sporting activity and has, or has provision for, attached spikes, sprigs, stops, clips, bars or the like, and skating boots, ski-boots and cross-country ski footwear, wrestling boots, boxing boots and cycling shoes",
      "units": [],
      "generalRate": "40%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.41.15",
      "rawHtsCode": "9903.41.15",
      "superior": null,
      "indent": "1",
      "description": "Automatic data processing machines, of the type of which the constituent units are integrated in the same housing, whether finished or unfinished, which incorporate a microprocessor-based calculating mechanism, are capable of handling data words of at least 16-bits off the microprocessor, and are designed for use with a non-cathode-ray tube (non-CRT) display unit, whether or not capable of use without an external power source (provided for in subheading 8471.30 or 8471.41)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.41.20",
      "rawHtsCode": "9903.41.20",
      "superior": null,
      "indent": "2",
      "description": "Having a microprocessor-based calculating mechanism capable of directly handling memory of over 8 megabits (provided for in subheading 8471.49.10 or 8471.50)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.41.25",
      "rawHtsCode": "9903.41.25",
      "superior": null,
      "indent": "2",
      "description": "Having a microprocessor-based calculating mechanism capable of directly handling memory of not over 8 megabits (provided for in subheading 8471.49.10 or 8471.50)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.41.30",
      "rawHtsCode": "9903.41.30",
      "superior": null,
      "indent": "2",
      "description": "Electropneumatic rotary and percussion hammers (provided for in subheading 8467.29)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.41.35",
      "rawHtsCode": "9903.41.35",
      "superior": null,
      "indent": "2",
      "description": "Other (provided for in subheading 8467.21 or 8467.29)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.41.40",
      "rawHtsCode": "9903.41.40",
      "superior": null,
      "indent": "1",
      "description": "Complete color television receivers containing in a single housing apparatus for receiving and displaying off-the-air each standard U.S. broadcast channel, with or without external speakers, having a single picture tube intended for direct viewing, with a video display diagonal exceeding 45 cm but not exceeding 50 cm (provided for in subheading 8528.72.32 or 8528.72.48)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.41.45",
      "rawHtsCode": "9903.41.45",
      "superior": null,
      "indent": "1",
      "description": "Complete color television receivers containing in a single housing apparatus for receiving and displaying off-the-air each standard U.S. broadcast channel, with or without external speakers, having a single picture tube intended for direct viewing, with a video display diagonal exceeding 50 cm but not exceeding 52 cm (provided for in subheading 8528.72.32 or 8528.72.48)",
      "units": [],
      "generalRate": "100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": []
    },
    {
      "htsCode": "9903.45.01",
      "rawHtsCode": "9903.45.01",
      "superior": null,
      "indent": "1",
      "description": "If entered in an aggregate quantity, in any quarterly period specified in note 17(i) to this subchapter, not exceeding 300,000 units in any such quarterly period, under the terms of such note",
      "units": [],
      "generalRate": "14%",
      "specialRate": "",
      "otherRate": "55%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " See US note 17(d) for staged duty rates for 9903.45.01 and 17(e) for 9903.45.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.45.02",
      "rawHtsCode": "9903.45.02",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "30%",
      "specialRate": "",
      "otherRate": "85%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " See US note 17(d) for staged duty rates for 9903.45.01 and 17(e) for 9903.45.02. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.45.05",
      "rawHtsCode": "9903.45.05",
      "superior": null,
      "indent": "1",
      "description": "If entered in an annual aggregate quantity not exceeding the quantity specified in note 17(g) to this subchapter, under the terms of such note",
      "units": [],
      "generalRate": "No change",
      "specialRate": "",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.45.06",
      "rawHtsCode": "9903.45.06",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "30%",
      "specialRate": "",
      "otherRate": "90%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " See note 17(h) to this subchapter. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.45.21",
      "rawHtsCode": "9903.45.21",
      "superior": null,
      "indent": "1",
      "description": "If entered in an annual aggregate quantity not exceeding 12.5 gigawatts, under the terms of such note<b>[Compiler’s note: This subheading and its related note, U.S. note 18 to this subchapter, have expired. See 87 Fed. Reg. 7357.]</b>",
      "units": [],
      "generalRate": "No change",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.45.22",
      "rawHtsCode": "9903.45.22",
      "superior": null,
      "indent": "1",
      "description": "Other <b>[Compiler’s note: This subheading and its related note, U.S. note 18 to this subchapter, have expired. See 87 Fed. Reg. 7357.]</b>",
      "units": [],
      "generalRate": "30%",
      "specialRate": "",
      "otherRate": "65%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " See note 18(f) for staged duty rates for 9903.45.22 and 18(h) for 9903.45.25. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.45.25",
      "rawHtsCode": "9903.45.25",
      "superior": null,
      "indent": "0",
      "description": "Modules as defined in note 18(g) to this subchapter, when the product or originating good of a country other than a country described in note 18(b) to this subchapter, except as provided in heading 9903.45.27 or heading 9903.45.29 <b>[Compiler’s note: This heading and its related note, U.S. note 18 to this subchapter, have expired. See 87 Fed. Reg. 7357.]</b>",
      "units": [],
      "generalRate": "30%",
      "specialRate": "",
      "otherRate": "30%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " See note 18(f) for staged duty rates for 9903.45.22 and 18(h) for 9903.45.25. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.45.27",
      "rawHtsCode": "9903.45.27",
      "superior": null,
      "indent": "0",
      "description": "Crystalline silicon photovoltaic cells, as defined in note 18(c) to this subchapter, and modules as defined in note 18(g) to this subchapter, all the foregoing when the product and originating good of Canada <b>[Compiler’s note: This heading and its related note, U.S. note 18 to this subchapter, have expired. See 87 Fed. Reg. 7357.]</b>",
      "units": [],
      "generalRate": "No change",
      "specialRate": "No change",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.45.29",
      "rawHtsCode": "9903.45.29",
      "superior": null,
      "indent": "0",
      "description": "Bifacial solar panels, as defined in and meeting the conditions of U.S. note 18(j) to this subchapter, that absorb light and generate electricity on each side of the panel and that consist of only bifacial solar cells that absorb light and generate electricity on each side of the cells <b>[Compiler’s note: This heading and its related note, U.S. note 18 to this subchapter, have expired. See 87 Fed. Reg. 7357.]</b>",
      "units": [],
      "generalRate": "No change",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.52.00",
      "rawHtsCode": "9903.52.00",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Limited Global Import Quota Announcement",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.01",
      "rawHtsCode": "9903.52.01",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 1",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.02",
      "rawHtsCode": "9903.52.02",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 2",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.03",
      "rawHtsCode": "9903.52.03",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 3",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.04",
      "rawHtsCode": "9903.52.04",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 4",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.05",
      "rawHtsCode": "9903.52.05",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 5",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.06",
      "rawHtsCode": "9903.52.06",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 6",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.07",
      "rawHtsCode": "9903.52.07",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 7",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.08",
      "rawHtsCode": "9903.52.08",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 8",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.09",
      "rawHtsCode": "9903.52.09",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 9",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.10",
      "rawHtsCode": "9903.52.10",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 10",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.11",
      "rawHtsCode": "9903.52.11",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 11",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.12",
      "rawHtsCode": "9903.52.12",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 12",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.13",
      "rawHtsCode": "9903.52.13",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 13",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.14",
      "rawHtsCode": "9903.52.14",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 14",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.15",
      "rawHtsCode": "9903.52.15",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 15",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.16",
      "rawHtsCode": "9903.52.16",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 16",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.17",
      "rawHtsCode": "9903.52.17",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 17",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.18",
      "rawHtsCode": "9903.52.18",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 18",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.19",
      "rawHtsCode": "9903.52.19",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 19",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.20",
      "rawHtsCode": "9903.52.20",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 20",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.21",
      "rawHtsCode": "9903.52.21",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 21",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.22",
      "rawHtsCode": "9903.52.22",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 22",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.23",
      "rawHtsCode": "9903.52.23",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 23",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.24",
      "rawHtsCode": "9903.52.24",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 24",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.25",
      "rawHtsCode": "9903.52.25",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 25",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.52.26",
      "rawHtsCode": "9903.52.26",
      "superior": null,
      "indent": "1",
      "description": "Purchased and entered pursuant to the Secretary of Agriculture's Special Cotton Import Quota Announcement Number 26",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 2."
      ],
      "flags": [
        "QUOTA_OR_VISA"
      ]
    },
    {
      "htsCode": "9903.53.01",
      "rawHtsCode": "9903.53.01",
      "superior": null,
      "indent": "1",
      "description": "Softwood lumber products described in U.S. note 13 to this subchapter, whose Region of Origin is Manitoba, Ontario, Quebec or Saskatchewan",
      "units": [],
      "generalRate": "10%",
      "specialRate": "10% (CA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " The provisions of this heading and referenced note have expired. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.54.01",
      "rawHtsCode": "9903.54.01",
      "superior": null,
      "indent": "0",
      "description": "In addition to the aggregate quantity of beef of Argentina specified in Additional U.S. Note 3(a) to chapter 2 of the tariff schedule for any calendar year, an additional 80,000 metric tons of lean beef trimmings of Argentina may be entered for consumption, or withdrawn from warehouse for consumption, between 12:01 a.m. local port time on February 13, 2026, and 11:59 p.m. eastern time on December 31, 2026, under statistical reporting numbers 0201.30.5091, 0201.30.5097, 0202.30.5091, and 0202.30.5097, as provided in U.S. note 7 to this subchapter.",
      "units": [],
      "generalRate": "No change",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.55.01",
      "rawHtsCode": "9903.55.01",
      "superior": null,
      "indent": "1",
      "description": "Entered under temporary importation bond in aggregate quantities not exceeding the amount specified in U.S. note 32(a) to this subchapter for any period specified in such note, when the product of any country not exempt under U.S. note 32(b) to this subchapter",
      "units": [],
      "generalRate": "Free",
      "specialRate": "",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.74.01",
      "rawHtsCode": "9903.74.01",
      "superior": null,
      "indent": "0",
      "description": "Medium- and heavy-duty vehicles as provided for in subdivision (b) of U.S. note 38 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.74.02",
      "rawHtsCode": "9903.74.02",
      "superior": null,
      "indent": "0",
      "description": "Buses and other vehicles classified in HTSUS heading 8702 as provided for in subdivision (c) of U.S. note 38 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "The duty provided in the applicable subheading + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.74.03",
      "rawHtsCode": "9903.74.03",
      "superior": null,
      "indent": "0",
      "description": "Medium- and heavy-duty vehicles, as provided for in subdivision (d) of U.S. note 38 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + a duty of 25% upon the value of the non-U.S. content",
      "specialRate": "The duty provided in the applicable subheading + a duty of 25% upon the value of the non-U.S. content",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.74.05",
      "rawHtsCode": "9903.74.05",
      "superior": null,
      "indent": "0",
      "description": "Articles as provided for in subdivision (e) of U.S. note 38 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.74.06",
      "rawHtsCode": "9903.74.06",
      "superior": null,
      "indent": "0",
      "description": "Articles as provided for in subdivision (f) of U.S. note 38 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.74.07",
      "rawHtsCode": "9903.74.07",
      "superior": null,
      "indent": "0",
      "description": "Medium- and heavy-duty vehicles, as provided for in subdivision (g) of U.S. note 38 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.74.08",
      "rawHtsCode": "9903.74.08",
      "superior": null,
      "indent": "0",
      "description": "Medium- and heavy-duty vehicle parts, as provided for in subdivision (i) of U.S. note 38 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.74.09",
      "rawHtsCode": "9903.74.09",
      "superior": null,
      "indent": "0",
      "description": "Medium- and heavy-duty vehicle parts, as provided for in subdivision (j) of U.S. note 38 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.74.10",
      "rawHtsCode": "9903.74.10",
      "superior": null,
      "indent": "0",
      "description": "Articles as provided for in subdivision (k) of U.S. note 38 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.74.11",
      "rawHtsCode": "9903.74.11",
      "superior": null,
      "indent": "0",
      "description": "Articles as provided for in subdivision (l) of U.S. note 38 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.76.01",
      "rawHtsCode": "9903.76.01",
      "superior": null,
      "indent": "0",
      "description": "Softwood timber and lumber products provided for in subdivision (b) of U.S. note 37 of this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "The duty provided in the applicable subheading + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.76.02",
      "rawHtsCode": "9903.76.02",
      "superior": null,
      "indent": "0",
      "description": "Upholstered wooden furniture products provided for in subdivision (d) of U.S. note 37 of this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.76.03",
      "rawHtsCode": "9903.76.03",
      "superior": null,
      "indent": "0",
      "description": "Completed kitchen cabinets and vanities and parts of kitchen cabinets and vanities provided for in subdivision (f) of U.S. note 37 of this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.76.04",
      "rawHtsCode": "9903.76.04",
      "superior": null,
      "indent": "0",
      "description": "Articles as provided for in subdivision (g) of U.S. note 37 of this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.76.20",
      "rawHtsCode": "9903.76.20",
      "superior": null,
      "indent": "0",
      "description": "Wood products of the United Kingdom as provided for in subdivisions (d) and (f) of U.S. note 37 of this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.76.21",
      "rawHtsCode": "9903.76.21",
      "superior": null,
      "indent": "0",
      "description": "Wood products of Japan as provided for in subdivisions (d) and (f) of U.S. note 37 of this subchapter",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.76.22",
      "rawHtsCode": "9903.76.22",
      "superior": null,
      "indent": "0",
      "description": "Wood products of the European Union as provided for in subdivisions (d) and (f) of U.S. note 37 of this subchapter",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.76.23",
      "rawHtsCode": "9903.76.23",
      "superior": null,
      "indent": "0",
      "description": "Wood products of South Korea as provided for in subdivisions (d) and (f) of U.S. note 37 of this subchapter",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.79.01",
      "rawHtsCode": "9903.79.01",
      "superior": null,
      "indent": "0",
      "description": "Semiconductor articles as provided for in subdivisions (a) and (b) of U.S. note 39 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading +25%",
      "specialRate": "The duty provided in the applicable subheading +25%",
      "otherRate": "The duty provided in the applicable subheading +25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.79.02",
      "rawHtsCode": "9903.79.02",
      "superior": null,
      "indent": "0",
      "description": "Articles as provided for in subdivision (c) of U.S. note 39 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.79.03",
      "rawHtsCode": "9903.79.03",
      "superior": null,
      "indent": "0",
      "description": "Semiconductor articles, as defined in subdivision (b) of U.S. note 39 to this subchapter, that are for use in U.S. data centers, as defined in subdivision (d) of U.S. note 39 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.79.04",
      "rawHtsCode": "9903.79.04",
      "superior": null,
      "indent": "0",
      "description": "Semiconductor articles, as defined in subdivision (b) of U.S. note 39 to this subchapter, that are for repairs or replacement in the United States",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.79.05",
      "rawHtsCode": "9903.79.05",
      "superior": null,
      "indent": "0",
      "description": "Semiconductor articles, as defined in subdivision (b) of U.S. note 39 to this subchapter, that are for research and development in the United States, as defined in subdivision (d) of U.S. note 39 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.79.06",
      "rawHtsCode": "9903.79.06",
      "superior": null,
      "indent": "0",
      "description": "Semiconductor articles, as defined in subdivision (b) of U.S. note 39 to this subchapter, that are for use by startups in the United States, as defined in subdivision (d) of U.S. note 39 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.79.07",
      "rawHtsCode": "9903.79.07",
      "superior": null,
      "indent": "0",
      "description": "Semiconductor articles, as defined in subdivision (b) of U.S. note 39 to this subchapter, that are for use in non-data center consumer electronics applications in the United States",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.79.08",
      "rawHtsCode": "9903.79.08",
      "superior": null,
      "indent": "0",
      "description": "Semiconductor articles, as defined in subdivision (b) of U.S. note 39 to this subchapter, that are for use in non-data center civil industrial applications in the United States",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.79.09",
      "rawHtsCode": "9903.79.09",
      "superior": null,
      "indent": "0",
      "description": "Semiconductor articles, as defined in subdivision (b) of U.S. note 39 to this subchapter, that are for use in United States public sector applications",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.01",
      "rawHtsCode": "9903.82.01",
      "superior": null,
      "indent": "0",
      "description": "Articles provided for in subdivision (c) of U.S. note 16 to this subchapter that do not contain any aluminum, steel, or copper",
      "units": [],
      "generalRate": "No change",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.02",
      "rawHtsCode": "9903.82.02",
      "superior": null,
      "indent": "0",
      "description": "Except as provided for in headings 9903.82.14, 9903.85.67 and 9903.85.68, articles of aluminum, of steel or of copper and derivative aluminum or steel articles, as provided for in subdivisions (c)(i)–(v) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 50%",
      "specialRate": "The duty provided in the applicable subheading + 50%",
      "otherRate": "The duty provided in the applicable subheading + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.03",
      "rawHtsCode": "9903.82.03",
      "superior": null,
      "indent": "0",
      "description": "Except for articles classifiable in chapters 72, 73, 74 or 76, articles where the weight of the applicable metal is less than 15 percent of the weight of the imported article, as provided for in subdivision (c) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "No change",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.04",
      "rawHtsCode": "9903.82.04",
      "superior": null,
      "indent": "0",
      "description": "Articles of aluminum or of steel and derivative aluminum or steel articles the product of the United Kingdom, as provided for in subdivisions (c)(i)–(iv) and (d) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.05",
      "rawHtsCode": "9903.82.05",
      "superior": null,
      "indent": "0",
      "description": "Derivative aluminum or steel articles the product of the United Kingdom, as provided for in subdivisions (c)(vi)–(vii) and (d) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "The duty provided in the applicable subheading + 15%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.06",
      "rawHtsCode": "9903.82.06",
      "superior": null,
      "indent": "0",
      "description": "Except as provided for in headings 9903.82.15 and 9903.85.68, articles of copper and derivative aluminum and steel articles, as provided for in subdivisions (c)(ii), (iv), (vi)–(viii) and (e) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "The duty provided in the applicable subheading + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.07",
      "rawHtsCode": "9903.82.07",
      "superior": null,
      "indent": "0",
      "description": "Except as provided for in headings 9903.82.12, 9903.82.17 and 9903.85.68, derivative aluminum and steel articles with an ad valorem (or ad valorem equivalent) rate of duty under column 1 less than 10 percent, as provided for in subdivisions (c)(ix)–(x) and (e) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "10%",
      "specialRate": "10%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.08",
      "rawHtsCode": "9903.82.08",
      "superior": null,
      "indent": "0",
      "description": "Except as provided for in headings 9903.82.12, 9903.82.17 and 9903.85.68, derivative aluminum and steel articles with an ad valorem (or ad valorem equivalent) rate of duty under column 1 equal to or greater than 10 percent, as provided for in subdivisions (c)(ix)–(x) and (e) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "No change",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.09",
      "rawHtsCode": "9903.82.09",
      "superior": null,
      "indent": "0",
      "description": "Except as provided for in headings 9903.82.16 and 9903.85.68, articles of copper and derivative aluminum and steel articles, as provided for in subdivisions (c)(vi)–(viii) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.10",
      "rawHtsCode": "9903.82.10",
      "superior": null,
      "indent": "0",
      "description": "Except as provided for in headings 9903.82.12, 9903.82.17 and 9903.85.68, derivative aluminum and steel articles with an ad valorem (or ad valorem equivalent) rate of duty under column 1 less than 15 percent, as provided for in subdivision (f) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.11",
      "rawHtsCode": "9903.82.11",
      "superior": null,
      "indent": "0",
      "description": "Except as provided for in headings 9903.82.12, 9903.82.17 and 9903.85.68, derivative aluminum and steel articles with an ad valorem (or ad valorem equivalent) rate of duty under column 1 equal to or greater than 15 percent, as provided for in subdivision (f) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "No change",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.12",
      "rawHtsCode": "9903.82.12",
      "superior": null,
      "indent": "0",
      "description": "Except as provided for in headings 9903.82.17 and 9903.85.68, derivative aluminum and steel articles the product of any country identified in general note 3(b), as provided for in subdivisions (c)(ix)–(x) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.13",
      "rawHtsCode": "9903.82.13",
      "superior": null,
      "indent": "0",
      "description": "Motorcycle parts, as provided for in subdivision (g) of U.S. note 16 to the subchapter",
      "units": [],
      "generalRate": "No change",
      "specialRate": "No change",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.14",
      "rawHtsCode": "9903.82.14",
      "superior": null,
      "indent": "0",
      "description": "Articles of steel or of copper and derivative steel the product of the Russian Federation, as provided for in subdivisions (c)(iii)–(v) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 50%",
      "specialRate": "The duty provided in the applicable subheading + 50%",
      "otherRate": "The duty provided in the applicable subheading + 50%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.15",
      "rawHtsCode": "9903.82.15",
      "superior": null,
      "indent": "0",
      "description": "Articles of copper and derivative steel the product of the Russian Federation, as provided for in subdivisions (c)(iv), (vii), (viii) and (e) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "The duty provided in the applicable subheading + 10%",
      "otherRate": "The duty provided in the applicable subheading + 10%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.16",
      "rawHtsCode": "9903.82.16",
      "superior": null,
      "indent": "0",
      "description": "Articles of copper and derivative steel the product of the Russian Federation, as provided for in subdivisions (c)(vii)–(viii) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.17",
      "rawHtsCode": "9903.82.17",
      "superior": null,
      "indent": "0",
      "description": "Derivative steel articles the product of the Russian Federation, as provided for in subdivision (c)(x) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.18",
      "rawHtsCode": "9903.82.18",
      "superior": null,
      "indent": "0",
      "description": "Certain articles of steel, as provided for in subdivisions (c)(iii) and (h) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "no change",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "no change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.82.19",
      "rawHtsCode": "9903.82.19",
      "superior": null,
      "indent": "0",
      "description": "Certain articles of aluminum, as provided for in subdivision (c)(i) and subdivision (i) of U.S. note 16 to this subchapter",
      "units": [],
      "generalRate": "no change",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "no change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.85.67",
      "rawHtsCode": "9903.85.67",
      "superior": null,
      "indent": "0",
      "description": "Aluminum articles that are the product of Russia, or where any amount of primary aluminum used in the manufacture of the aluminum articles is smelted in Russia, or where the aluminum articles are cast in Russia, the foregoing under the terms of note 19(a)(vii)(A) to this subchapter, or note 19(m)(A) to this subchapter, as applicable per the date of entry for consumption or withdrawal from warehouse for consumption, except any exclusions that may be determined and announced by the Department of Commerce",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 200%",
      "specialRate": "The duty provided in the applicable subheading + 200% (AU, BH, CA, CL, CO, E, IL, JO, KR, MA, MX, OM, P, PA, PE, SG)",
      "otherRate": "The duty provided in the applicable subheading + 200%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.85.68",
      "rawHtsCode": "9903.85.68",
      "superior": null,
      "indent": "0",
      "description": "Derivative aluminum articles that are products of Russia, or where any amount of primary aluminum used in the manufacture of the derivative articles is smelted in Russia, or where the derivative aluminum articles are cast in Russia, when such derivative articles are provided for in the headings or subheadings enumerated in note 19(a)(iii) to this subchapter, or notes 19(i), 19(j) or 19(k) to this subchapter, as applicable per the date of entry for consumption or withdrawal from warehouse for consumption, except any exclusions that may be determined and announced by the Department of Commerce",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 200%",
      "specialRate": "The duty provided in the applicable subheading + 200% (AU, BH, CA, CL, CO, E, IL, JO, KR, MA, MX, OM, P, PA, PE, SG)",
      "otherRate": "The duty provided in the applicable subheading + 200%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.88.01",
      "rawHtsCode": "9903.88.01",
      "superior": null,
      "indent": "0",
      "description": "Except as provided in headings 9903.88.05, 9903.88.06, 9903.88.07, 9903.88.08, 9903.88.10, 9903.88.11, 9903.88.14, 9903.88.19, 9903.88.50, 9903.88.52, 9903.88.58, 9903.88.60, 9903.88.62, 9903.88.66, 9903.88.67, 9903.88.68, or 9903.88.69, articles the product of China, as provided for in U.S. note 20(a) to this subchapter and as provided for in the subheadings enumerated in U.S. note 20(b) [to this subchapter]",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading plus 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.02",
      "rawHtsCode": "9903.88.02",
      "superior": null,
      "indent": "0",
      "description": "Except as provided in headings 9903.88.12, 9903.88.17, 9903.88.20, 9903.88.54, 9903.88.59, 9903.88.61, 9903.88.63, 9903.88.66, 9903.88.67, 9903.88.68, 9903.88.69, or 9903.88.70, articles the product of China, as provided for in U.S. note 20(c) to this subchapter and as provided for in the subheadings enumerated in U.S. note 20(d)",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.03",
      "rawHtsCode": "9903.88.03",
      "superior": null,
      "indent": "0",
      "description": "Except as provided in headings 9903.88.13, 9903.88.18, 9903.88.33, 9903.88.34, 9903.88.35, 9903.88.36, 9903.88.37, 9903.88.38, 9903.88.40, 9903.88.41, 9903.88.43, 9903.88.45, 9903.88.46, 9903.88.48, 9903.88.56, 9903.88.64, 9903.88.66, 9903.88.67, 9903.88.68, or 9903.88.69, articles the product of China, as provided for in U.S. note 20(e) to this subchapter and as provided for in the subheadings enumerated in U.S. note 20(f)",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.04",
      "rawHtsCode": "9903.88.04",
      "superior": null,
      "indent": "0",
      "description": "Except as provided in headings 9903.88.33, 9903.88.34, 9903.88.36, 9903.88.37, 9903.88.38, 9903.88.40, 9903.88.46, 9903.88.48, 9903.88.56, 9903.88.64, 9903.88.66, 9903.88.67, or 9903.88.69, articles the product of China, as provided for in U.S. note 20(g) to this subchapter and as provided for in the subheadings enumerated in U.S. note 20(g)",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.05",
      "rawHtsCode": "9903.88.05",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(h) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " Effective period extended only for subdivisions (2), (7), (11), (29), (30) and (31) of note 20(h) to this subchapter. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.06",
      "rawHtsCode": "9903.88.06",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(i) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.07",
      "rawHtsCode": "9903.88.07",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(j) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.08",
      "rawHtsCode": "9903.88.08",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(k) to this subchapter, each covered by an exclusion granted by the United States Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.09",
      "rawHtsCode": "9903.88.09",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(l) to this subchapter and as provided for in the subheadings enumerated in U.S. notes 20(f) or 20(g) to this subchapter, if exported to the United States before May 10, 2019 and entered for consumption, or withdrawn from warehouse for consumption, on or after May 10, 2019, and before June 15, 2019",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 10%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.10",
      "rawHtsCode": "9903.88.10",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(m) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.11",
      "rawHtsCode": "9903.88.11",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(n) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.12",
      "rawHtsCode": "9903.88.12",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(o) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.13",
      "rawHtsCode": "9903.88.13",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(p) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.14",
      "rawHtsCode": "9903.88.14",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(q) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.15",
      "rawHtsCode": "9903.88.15",
      "superior": null,
      "indent": "0",
      "description": "Except as provided in headings 9903.88.39, 9903.88.42, 9903.88.44, 9903.88.47, 9903.88.49, 9903.88.51, 9903.88.53, 9903.88.55, 9903.88.57, 9903.88.65, 9903.88.66, 9903.88.67, 9903.88.68, or 9903.88.69, articles the product of China, as provided for in U.S. note 20(r) to this subchapter and as provided for in the subheadings enumerated in U.S. note 20(s)",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 7.5%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.16",
      "rawHtsCode": "9903.88.16",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(t) to this subchapter and as provided for in the subheadings enumerated in U.S. note 20(u) <b>[Compiler's note: provision suspended.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. ",
        " Subdivisions (t) and (u) of note 20 to this chapter and heading 9903.88.16 are suspended. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.17",
      "rawHtsCode": "9903.88.17",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(v) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.18",
      "rawHtsCode": "9903.88.18",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(w) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.19",
      "rawHtsCode": "9903.88.19",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(x) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.20",
      "rawHtsCode": "9903.88.20",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(y) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.21",
      "rawHtsCode": "9903.88.21",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(z) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.22",
      "rawHtsCode": "9903.88.22",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(aa) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.23",
      "rawHtsCode": "9903.88.23",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(bb) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.24",
      "rawHtsCode": "9903.88.24",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(cc) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.25",
      "rawHtsCode": "9903.88.25",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(dd) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.26",
      "rawHtsCode": "9903.88.26",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(ee) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.27",
      "rawHtsCode": "9903.88.27",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(ff) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.28",
      "rawHtsCode": "9903.88.28",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(gg) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.33",
      "rawHtsCode": "9903.88.33",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(ll) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.34",
      "rawHtsCode": "9903.88.34",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(mm) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.35",
      "rawHtsCode": "9903.88.35",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(nn) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.36",
      "rawHtsCode": "9903.88.36",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(oo) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.37",
      "rawHtsCode": "9903.88.37",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(pp) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.38",
      "rawHtsCode": "9903.88.38",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(qq) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.39",
      "rawHtsCode": "9903.88.39",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(rr) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.40",
      "rawHtsCode": "9903.88.40",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(ss) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.41",
      "rawHtsCode": "9903.88.41",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(tt) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.42",
      "rawHtsCode": "9903.88.42",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(uu) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.43",
      "rawHtsCode": "9903.88.43",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(vv) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.44",
      "rawHtsCode": "9903.88.44",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(ww) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.45",
      "rawHtsCode": "9903.88.45",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(xx) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.46",
      "rawHtsCode": "9903.88.46",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(yy) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.47",
      "rawHtsCode": "9903.88.47",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(zz) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.48",
      "rawHtsCode": "9903.88.48",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(aaa) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.49",
      "rawHtsCode": "9903.88.49",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(bbb) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.50",
      "rawHtsCode": "9903.88.50",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after June 4, 2020, and through December 31, 2020, articles the product of China, as provided for in U.S. note 20(ccc) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.51",
      "rawHtsCode": "9903.88.51",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(ddd) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.52",
      "rawHtsCode": "9903.88.52",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after July 9, 2020, and through December 31, 2020, articles the product of China, as provided for in U.S. note 20(eee) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.53",
      "rawHtsCode": "9903.88.53",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(fff) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.54",
      "rawHtsCode": "9903.88.54",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after July 31, 2020, and through December 31, 2020, articles the product of China, as provided for in U.S. note 20(ggg) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.55",
      "rawHtsCode": "9903.88.55",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of China, as provided for in U.S. note 20(hhh) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.56",
      "rawHtsCode": "9903.88.56",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after August 7, 2020, and through December 31, 2020, articles the product of China, as provided for in U.S. note 20(iii) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.57",
      "rawHtsCode": "9903.88.57",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after September 1, 2020, and through December 31, 2020, articles the product of China, as provided for in U.S. note 20(jjj) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.58",
      "rawHtsCode": "9903.88.58",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after September 20, 2020, and through December 31, 2020, articles the product of China, as provided for in U.S. note 20(kkk) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.59",
      "rawHtsCode": "9903.88.59",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after September 20, 2020, and through December 31, 2020, articles the product of China, as provided for in U.S. note 20(lll) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.60",
      "rawHtsCode": "9903.88.60",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after October 2, 2020, and through December 31, 2020, articles the product of China, as provided for in U.S. note 20(mmm) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.61",
      "rawHtsCode": "9903.88.61",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after October 2, 2020, and through December 31, 2020, articles the product of China, as provided for in U.S. note 20(nnn) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.62",
      "rawHtsCode": "9903.88.62",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after January 1, 2021, and through November 30, 2021, articles the product of China, as provided for in U.S. note 20(ooo) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.63",
      "rawHtsCode": "9903.88.63",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after January 1, 2021, and through November 30, 2021, articles the product of China, as provided for in U.S. note 20(ppp) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.64",
      "rawHtsCode": "9903.88.64",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after January 1, 2021, and through November 30, 2021, articles the product of China, as provided for in U.S. note 20(qqq) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.65",
      "rawHtsCode": "9903.88.65",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after January 1, 2021, and through November 30, 2021, articles the product of China, as provided for in U.S. note 20(rrr) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.66",
      "rawHtsCode": "9903.88.66",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after December 1, 2021, and before June 1, 2023, articles the product of China, as provided for in U.S. note 20(sss) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.67",
      "rawHtsCode": "9903.88.67",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after October 12, 2021 and through June 14, 2024, articles the product of China, as provided for in U.S. note 20(ttt) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.68",
      "rawHtsCode": "9903.88.68",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after June 1, 2023, and before June 15, 2024, articles the product of China, as provided for in U.S. note 20(uuu) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.69",
      "rawHtsCode": "9903.88.69",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after June 15, 2024 and through November 9, 2026, articles the product of China, as provided for in U.S. note 20(vvv) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.88.70",
      "rawHtsCode": "9903.88.70",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after January 1, 2024, and through November 9, 2026, articles the product of China, as provided in U.S. note 20(www) to this subchapter, each covered by an exclusion granted by the U.S. Trade Representative",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.01",
      "rawHtsCode": "9903.89.01",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of Nicaragua, as provided for in U.S. note 29 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 0%",
      "specialRate": "No change",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.89.05",
      "rawHtsCode": "9903.89.05",
      "superior": null,
      "indent": "1",
      "description": "New airplanes and other new aircraft, as defined in U.S. note 21(b) to this subchapter (other than military airplanes or other military aircraft), of an unladen weight exceeding 30,000 kg (described in statistical reporting numbers 8802.40.0040, 8802.40.0060 or 8802.40.0070)",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.07",
      "rawHtsCode": "9903.89.07",
      "superior": null,
      "indent": "1",
      "description": "Airplanes and other aircraft, of an unladen weight exceeding 15,000 kg (provided for in subheading 8802.40.00), the foregoing not described in subheading 9903.89.05",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.10",
      "rawHtsCode": "9903.89.10",
      "superior": null,
      "indent": "1",
      "description": "Provided for in the subheadings enumerated in U.S. note 21(c) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.13",
      "rawHtsCode": "9903.89.13",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(d) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.16",
      "rawHtsCode": "9903.89.16",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(e) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.19",
      "rawHtsCode": "9903.89.19",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(f) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.22",
      "rawHtsCode": "9903.89.22",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(g) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.25",
      "rawHtsCode": "9903.89.25",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(h) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.28",
      "rawHtsCode": "9903.89.28",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(i) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.31",
      "rawHtsCode": "9903.89.31",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(j) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.34",
      "rawHtsCode": "9903.89.34",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(k) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.37",
      "rawHtsCode": "9903.89.37",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(l) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.40",
      "rawHtsCode": "9903.89.40",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(m) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.43",
      "rawHtsCode": "9903.89.43",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(n) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.46",
      "rawHtsCode": "9903.89.46",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(o) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.49",
      "rawHtsCode": "9903.89.49",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(p) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.50",
      "rawHtsCode": "9903.89.50",
      "superior": null,
      "indent": "1",
      "description": "Irish and Scotch Whiskies (provided for in subheading 2208.30.30), the foregoing not described in subheading 9903.89.49",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.52",
      "rawHtsCode": "9903.89.52",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(q) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.55",
      "rawHtsCode": "9903.89.55",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(r) to this subchapter",
      "units": [],
      "generalRate": "The duty provided inthe applicable subheading+ 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.57",
      "rawHtsCode": "9903.89.57",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheadings enumerated in U.S. note 21(s) to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.59",
      "rawHtsCode": "9903.89.59",
      "superior": null,
      "indent": "1",
      "description": "Spirits obtained by distilling grape wine or grape marc (grape brandy), other than Pisco and Singani, in containers each holding not over 4 liters, valued over $3.43/liter (provided for in subheading 2208.20.40), the foregoing not described in subheading 9903.89.57",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.61",
      "rawHtsCode": "9903.89.61",
      "superior": null,
      "indent": "1",
      "description": "Fuselages and fuselage sections, wings and wing assemblies (other than wings having exterior surfaces of carbon composite material), horizontal stabilizers, and vertical stabilizers as defined in U.S. note 21(t), suitable for use solely or principally with new airplanes and other aircraft of an unladen weight over 30,000 kg as described in subheading 9903.89.05 (described in statistical reporting number 8803.30.0030)",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 15%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.89.63",
      "rawHtsCode": "9903.89.63",
      "superior": null,
      "indent": "1",
      "description": "Other parts of airplanes or helicopters (provided for <b>[described]</b>in statistical reporting number 8803.30.0030), the foregoing not described <b>[provided for]</b>in subheading 9903.89.61",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.90.08",
      "rawHtsCode": "9903.90.08",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of the Russian Federation, as provided for in U.S. note 30(a) to this subchapter and as provided for in the subheadings enumerated in U.S. note 30(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "35%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.90.09",
      "rawHtsCode": "9903.90.09",
      "superior": null,
      "indent": "0",
      "description": "Articles the product of the Russian Federation, as provided for in U.S. note 30(c) to this subchapter and as provided for in the subheadings enumerated in U.S. note 30(d) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "70%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.01",
      "rawHtsCode": "9903.91.01",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after September 27, 2024, articles the product of China, as provided for in subdivision (b) of U.S. note 31 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.02",
      "rawHtsCode": "9903.91.02",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after September 27, 2024, articles the product of China, as provided for in subdivision (c) of U.S. note 31 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 50%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.03",
      "rawHtsCode": "9903.91.03",
      "superior": null,
      "indent": "0",
      "description": "Except as provided in heading 9903.91.10, effective with respect to entries on or after September 27, 2024, articles the product of China, as provided for in subdivision (d) of U.S. note 31 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.04",
      "rawHtsCode": "9903.91.04",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after January 1, 2025, and before January 1, 2026, articles the product of China, as provided for in subdivision (e) of U.S. note 31 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.05",
      "rawHtsCode": "9903.91.05",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after January 1, 2025, articles the product of China, as provided for in subdivision (f) of U.S. note 31 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 50%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.06",
      "rawHtsCode": "9903.91.06",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after January 1, 2026, articles the product of China, as provided for in subdivision (g) of U.S. note 31 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.07",
      "rawHtsCode": "9903.91.07",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after January 1, 2026, articles the product of China, as provided for in subdivision (h) of U.S. note 31 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 50%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.08",
      "rawHtsCode": "9903.91.08",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after January 1, 2026, articles the product of China, as provided for in subdivision (i) of U.S. note 31 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.09",
      "rawHtsCode": "9903.91.09",
      "superior": null,
      "indent": "0",
      "description": "Notwithstanding subheading 9903.92.10, effective with respect to entries, on or after September 27, 2024, of ship-to-shore gantry cranes, configured as a high- or low-profile steel superstructure and designed to unload intermodal containers from vessels with coupling devices for containers, including spreaders or twist-locks, articles the product of China (provided for in subheading 8426.19.00), that are fulfilling in whole or in part an executed contract for sale dated prior to May 14, 2024 for goods that are entered for consumption, or withdrawn from warehouse for consumption, in the United States prior to May 14, 2026",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.10",
      "rawHtsCode": "9903.91.10",
      "superior": null,
      "indent": "0",
      "description": "Notwithstanding heading 9903.91.03, effective with respect to entries of enteral syringes, of China, on or after September 27, 2024, and before January 1, 2026 (described in statistical reporting number 9018.31.0080)",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.11",
      "rawHtsCode": "9903.91.11",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after January 1, 2025, articles the product of China, as provided for in subdivision (j) of U.S. note 31 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.12",
      "rawHtsCode": "9903.91.12",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries, on or after November 10, 2026, of intermodal chassis, subassemblies thereof, and parts thereof (provided for in statistical reporting number 8716.39.0090, or in subheadings 8716.90.30 or 8716.90.50), articles the product of China, as provided for in subdivision (k)(i) of U.S. note 31 to this subchapter, except as provided in heading 9903.91.13.",
      "units": [],
      "generalRate": "The duty provided in subheadings 8716.39.00, 8716.90.30 or 8716.90.50 + 100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.13",
      "rawHtsCode": "9903.91.13",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries, on or after November 10, 2026, of articles the product of China, as provided for in subdivision (k)(ii) of U.S. note 31 to this subchapter (provided for in statistical reporting number 8716.39.0090, or subheadings 8716.90.30 or 8716.90.50), except as provided in heading 9903.91.12.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.14",
      "rawHtsCode": "9903.91.14",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries, on or after November 10, 2026, of ship-to-shore gantry cranes, configured as a high- or low-profile steel superstructure and designed to unload intermodal containers from vessels with coupling devices for containers, including spreaders or twist-locks (provided for in subheading 8426.19.00), as provided for in subdivision (l) of U.S. note 31 to this subchapter, except as provided in headings 9903.91.09, 9903.91.15 or 9903.91.16.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 100%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.15",
      "rawHtsCode": "9903.91.15",
      "superior": null,
      "indent": "0",
      "description": "Notwithstanding heading 9903.91.14, effective with respect to entries, on or after November 10, 2026, of ship-to-shore gantry cranes, configured as a high- or low-profile steel superstructure and designed to unload intermodal containers from vessels with coupling devices for containers, including spreaders or twist-locks (provided for in subheading 8426.19.00), attested by the importer that the ship-to-shore gantry cranes: (1) are not products of China; (2) are not manufactured, assembled, or made using components, assemblies or subassemblies that are products of China, as specified in subdivision (l)(ii) of note 31 to this subchapter; and (3) are not manufactured by a company or other entity that is owned or controlled by a Chinese person or legal entity, as specified by subdivision (l)(v) of note 31 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.91.16",
      "rawHtsCode": "9903.91.16",
      "superior": null,
      "indent": "0",
      "description": "Notwithstanding heading 9903.91.14, effective with respect to entries, on or after November 10, 2026, of ship-to-shore gantry cranes, configured as a high- or low-profile steel superstructure and designed to unload intermodal containers from vessels with coupling devices for containers, including spreaders or twist-locks (provided for in subheading 8426.19.00), that: (1) are products of China; (2) that are manufactured, assembled or made using components, assemblies or subassemblies that are products of China; or (3) that are manufactured by a company or other entity that is owned or controlled by a Chinese person or legal entity, as specified by subdivision (l) of U.S. note 31 to this subchapter, that are attested by the importer as fulfilling in whole or in part an executed contract for sale dated prior to April 17, 2025 for goods that are entered for consumption, or withdrawn from warehouse for consumption, in the United States prior to April 18, 2027.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.92",
      "rawHtsCode": "9903.92",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries, on or after September 27, 2024, of overhead traveling cranes, transporter cranes, gantry cranes, bridge cranes and mobile lifting frames, other than overhead traveling cranes on fixed support and other than mobile lifting frames on tires, articles the product of China (provided for in subheading 8426.19.00):",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [],
      "flags": []
    },
    {
      "htsCode": "9903.92.10",
      "rawHtsCode": "9903.92.10",
      "superior": null,
      "indent": "1",
      "description": "Except as provided in heading 9903.91.09, ship-to-shore gantry cranes, configured as a high- or low-profile steel superstructure and designed to unload intermodal containers from vessels with coupling devices for containers, including spreaders or twist-locks (provided for in subheading 8426.19.00)",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.92.80",
      "rawHtsCode": "9903.92.80",
      "superior": null,
      "indent": "1",
      "description": "Other (provided for in subheading 8426.19.00)",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": []
    },
    {
      "htsCode": "9903.94.01",
      "rawHtsCode": "9903.94.01",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.94.02, 9903.94.03, 9903.94.04, 9903.94.31, 9903.94.40, 9903.94.41, 9903.94.50, 9903.94.51, 9903.94.60, and 9903.94.61, passenger vehicles (sedans, sport utility vehicles, crossover utility vehicles, minivans, and cargo vans) and light trucks, as specified in note 33 to this subchapter, as provided for in subdivision (b) of U.S. note 33 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.02",
      "rawHtsCode": "9903.94.02",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after April 3, 2025, articles as provided for in subdivision (c) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.03",
      "rawHtsCode": "9903.94.03",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after April 3, 2025, certain passenger vehicles and light trucks, as provided for in subdivision (d) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + a duty of 25% upon the value of the non-U.S. content",
      "specialRate": "The duty provided in the applicable subheading + a duty of 25% upon the value of the non-U.S. content",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.04",
      "rawHtsCode": "9903.94.04",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after April 3, 2025, certain passenger vehicles and light trucks, as provided for in subdivision (e) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.05",
      "rawHtsCode": "9903.94.05",
      "superior": null,
      "indent": "0",
      "description": "Except for products described in headings 9903.94.06, 9903.94.32, 9903.94.33, 9903.94.42, 9903.94.43, 9903.94.44, 9903.94.45, 9903.94.52, 9903.94.53, 9903.94.54, 9903.94.55, 9903.94.62, and 9903.94.63, automobile parts, as provided for in subdivision (g) of U.S. note 33 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading +25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.06",
      "rawHtsCode": "9903.94.06",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after May 3, 2025, articles provided for in subdivision (h) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.07",
      "rawHtsCode": "9903.94.07",
      "superior": null,
      "indent": "0",
      "description": "Except as provided for in headings 9903.94.33, 9903.94.44, 9903.94.45, 9903.94.54, 9903.94.55, 9903.94.64, and 9903.94.65, automobile parts as provided for in subdivision (p) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 25%",
      "specialRate": "The duty provided in the applicable subheading + 25%",
      "otherRate": "The duty provided in the applicable subheading + 25%",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.31",
      "rawHtsCode": "9903.94.31",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after [ ], passenger vehicles that are products of the United Kingdom as specified in subdivision (i) of U.S. note 33 to this subchapter, when entered under the terms of subdivision (i) of U.S. note 33 to this subchapter.<b> [Compilers note: This heading is effective on or after June 30, 2025. For more information, see 90 Fed. Reg. 27851.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading + 7.5%",
      "specialRate": "No change.",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.32",
      "rawHtsCode": "9903.94.32",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after [ ], parts of passenger vehicles and light trucks of the United Kingdom, classified in the subheadings enumerated in subdivision (j) of U.S. note 33 to this subchapter. <b>[Compilers note: This heading is effective on or after June 30, 2025. For more information, see 90 Fed. Reg. 27851.]</b>",
      "units": [],
      "generalRate": "10%",
      "specialRate": "10%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.33",
      "rawHtsCode": "9903.94.33",
      "superior": null,
      "indent": "0",
      "description": "Automobile parts the product of the United Kingdom as provided for in subdivision (q) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "10%",
      "specialRate": "10%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.40",
      "rawHtsCode": "9903.94.40",
      "superior": null,
      "indent": "0",
      "description": "Passenger vehicles and light trucks that are products of Japan as provided for in subdivision (k) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent) rate of duty under column 1 equal to or greater than 15 percent as provided for in subdivision (m) of U.S. note 33 to this subchapter",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.41",
      "rawHtsCode": "9903.94.41",
      "superior": null,
      "indent": "0",
      "description": "Passenger vehicles and light trucks that are products of Japan provided for in subdivision (k) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent) rate of duty under column 1 less than 15 percent as provided for in subdivision (m) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.42",
      "rawHtsCode": "9903.94.42",
      "superior": null,
      "indent": "0",
      "description": "Parts of passenger vehicles and light trucks that are products of Japan as provided for subdivision (l) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent) rate of duty under column 1 equal to or greater than 15 percent as provided for in subdivision (m) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.43",
      "rawHtsCode": "9903.94.43",
      "superior": null,
      "indent": "0",
      "description": "Parts of passenger vehicles and light trucks that are products of Japan as provided for in subdivision (l) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent) rate of duty under column 1 less than 15 percent as provided for in subdivision (m) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.44",
      "rawHtsCode": "9903.94.44",
      "superior": null,
      "indent": "0",
      "description": "Automobile parts the product of the European Union with an <i>ad valorem</i> (or <i>ad valorem</i> equivalent) rate of duty under column 1 equal to or greater than 15 percent, as provided for in subdivision (r) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.45",
      "rawHtsCode": "9903.94.45",
      "superior": null,
      "indent": "0",
      "description": "Automobile parts the product of the European Union with an <i>ad valorem</i> (or <i>ad valorem</i> equivalent) rate of duty under column 1 less than 15 percent, as provided for in subdivision (r) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.50",
      "rawHtsCode": "9903.94.50",
      "superior": null,
      "indent": "0",
      "description": "Passenger vehicles and light trucks that are products of the European Union as specified in subdivision (n) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent as provided for in subdivision (m) of U.S. note 33 to this subchapter) rate of duty under column 1 equal to or greater than 15 percent.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.51",
      "rawHtsCode": "9903.94.51",
      "superior": null,
      "indent": "0",
      "description": "Passenger vehicles and light trucks that are products of the European Union as specified in subdivision (n) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent as provided for in subdivision (m) of U.S. note 33 to this subchapter) rate of duty under column 1 less than 15 percent",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.52",
      "rawHtsCode": "9903.94.52",
      "superior": null,
      "indent": "0",
      "description": "Parts of passenger vehicles and light trucks that are products of the European Union as specified in subdivision (o) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent as provided for in subdivision (m) of U.S. note 33 to this subchapter) rate of duty under column 1 equal to or greater than 15 percent.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.53",
      "rawHtsCode": "9903.94.53",
      "superior": null,
      "indent": "0",
      "description": "Parts of passenger vehicles and light trucks that are products of the European Union as specified in subdivision (o) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent as provided for in subdivision (m) of U.S. note 33 to this subchapter) rate of duty under column1 less than 15 percent.",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.54",
      "rawHtsCode": "9903.94.54",
      "superior": null,
      "indent": "0",
      "description": "Automobile parts the product of Japan with an <i>ad valorem</i> (or <i>ad valorem</i> equivalent) rate of duty under column 1 equal to or greater than 15 percent, as provided for in subdivision (r) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "The duty provided in the applicable subheading",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.55",
      "rawHtsCode": "9903.94.55",
      "superior": null,
      "indent": "0",
      "description": "Automobile parts the product of Japan with an <i>ad valorem</i> (or <i>ad valorem</i> equivalent) rate of duty under column 1 less than 15 percent, as provided for in subdivision (r) of U.S. note 33 to this subchapter.",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.60",
      "rawHtsCode": "9903.94.60",
      "superior": null,
      "indent": "0",
      "description": "Passenger vehicles and light trucks that are products of South Korea as specified in subdivision (s) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent as provided for in subdivision (m) of U.S. note 33 to this subchapter) rate of duty under column 1-General or column 1-Special equal to or greater than 15 percent",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.61",
      "rawHtsCode": "9903.94.61",
      "superior": null,
      "indent": "0",
      "description": "Passenger vehicles and light trucks that are products of South Korea as specified in subdivision (s) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent as provided for in subdivision (m) of U.S. note 33 to this subchapter) rate of duty under column 1-General or column 1-Special less than 15 percent",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.62",
      "rawHtsCode": "9903.94.62",
      "superior": null,
      "indent": "0",
      "description": "Parts of passenger vehicles and light trucks that are products of South Korea as specified in subdivisions (g) and (t) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent as provided for in subdivision (m) of U.S. note 33 to this subchapter) rate of duty under column 1-General or column 1-Special equal to or greater than 15 percent",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.63",
      "rawHtsCode": "9903.94.63",
      "superior": null,
      "indent": "0",
      "description": "Parts of passenger vehicles and light trucks that are products of South Korea as specified in subdivisions (g) and (t) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent as provided for in subdivision (m) of U.S. note 33 to this subchapter) rate of duty under column 1-General or column 1-Special less than 15 percent",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.64",
      "rawHtsCode": "9903.94.64",
      "superior": null,
      "indent": "0",
      "description": "Parts of passenger vehicles and light trucks that are products of South Korea as specified in subdivisions (r) and (t) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent as provided for in subdivision (m) of U.S. note 33 to this subchapter) rate of duty under column 1-General or column 1-Special equal to or greater than 15 percent",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.94.65",
      "rawHtsCode": "9903.94.65",
      "superior": null,
      "indent": "0",
      "description": "Parts of passenger vehicles and light trucks that are products of South Korea as specified in subdivisions (r) and (t) of U.S. note 33 to this subchapter, with an ad valorem (or ad valorem equivalent as provided for in subdivision (m) of U.S. note 33 to this subchapter) rate of duty under column 1-General or column 1-Special less than 15 percent",
      "units": [],
      "generalRate": "15%",
      "specialRate": "15%",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.96.01",
      "rawHtsCode": "9903.96.01",
      "superior": null,
      "indent": "0",
      "description": "Effective with respect to entries on or after [ ], articles of civil aircraft (all aircraft other than military aircraft); their engines, parts, and components; their other parts, components, and subassemblies; and ground flight simulators and their parts and components of the United Kingdom, classified in the subheadings enumerated in subdivision (a) of U.S. note 35 to this subchapter. <b>[Compilers note: This heading is effective on or after June 30, 2025. For more information, see 90 Fed. Reg. 27851.]</b>",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9903.96.02",
      "rawHtsCode": "9903.96.02",
      "superior": null,
      "indent": "0",
      "description": "Articles of civil aircraft (all aircraft other than military aircraft); their engines, parts, and components; their other parts, components, and subassemblies; and ground flight simulators and their parts and components of Japan, excluding unmanned aircraft, classified in the subheadings enumerated in subdivision (b) of U.S. note 35 to this subchapter.",
      "units": [],
      "generalRate": "The duty provided in the applicable subheading",
      "specialRate": "The duty provided in the applicable subheading",
      "otherRate": "No change.",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9904.02.01",
      "rawHtsCode": "9904.02.01",
      "superior": null,
      "indent": "4",
      "description": "Valued less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "66.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.02",
      "rawHtsCode": "9904.02.02",
      "superior": null,
      "indent": "4",
      "description": "Valued 25¢/kg or more but less than 45¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "49¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.03",
      "rawHtsCode": "9904.02.03",
      "superior": null,
      "indent": "4",
      "description": "Valued 45¢/kg or more but less than 65¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "35¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.04",
      "rawHtsCode": "9904.02.04",
      "superior": null,
      "indent": "4",
      "description": "Valued 65¢/kg or more but less than 85¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "24.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.05",
      "rawHtsCode": "9904.02.05",
      "superior": null,
      "indent": "4",
      "description": "Valued 85¢/kg or more but less than $1.05/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.06",
      "rawHtsCode": "9904.02.06",
      "superior": null,
      "indent": "4",
      "description": "Valued $1.05/kg or more but less than $1.25/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.07",
      "rawHtsCode": "9904.02.07",
      "superior": null,
      "indent": "4",
      "description": "Valued $1.25/kg or more but less than $1.45/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.08",
      "rawHtsCode": "9904.02.08",
      "superior": null,
      "indent": "4",
      "description": "Valued $1.45/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.02.09",
      "rawHtsCode": "9904.02.09",
      "superior": null,
      "indent": "4",
      "description": "Valued less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "80.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.10",
      "rawHtsCode": "9904.02.10",
      "superior": null,
      "indent": "4",
      "description": "Valued 15¢/kg or more but less than 35¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "62.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.11",
      "rawHtsCode": "9904.02.11",
      "superior": null,
      "indent": "4",
      "description": "Valued 35¢/kg or more but less than 55¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "46.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.12",
      "rawHtsCode": "9904.02.12",
      "superior": null,
      "indent": "4",
      "description": "Valued 55¢/kg or more but less than 75¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "33.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.13",
      "rawHtsCode": "9904.02.13",
      "superior": null,
      "indent": "4",
      "description": "Valued 75¢/kg or more but less than 95¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "23.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.14",
      "rawHtsCode": "9904.02.14",
      "superior": null,
      "indent": "4",
      "description": "Valued 95¢/kg or more but less than $1.15/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.15",
      "rawHtsCode": "9904.02.15",
      "superior": null,
      "indent": "4",
      "description": "Valued $1.15/kg or more but less than $1.35/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.16",
      "rawHtsCode": "9904.02.16",
      "superior": null,
      "indent": "4",
      "description": "Valued $1.35/kg or more but less than $1.55/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.17",
      "rawHtsCode": "9904.02.17",
      "superior": null,
      "indent": "4",
      "description": "Valued $1.55/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.02.27",
      "rawHtsCode": "9904.02.27",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "75.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.28",
      "rawHtsCode": "9904.02.28",
      "superior": null,
      "indent": "3",
      "description": "Valued 30¢/kg or more but less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "57.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.29",
      "rawHtsCode": "9904.02.29",
      "superior": null,
      "indent": "3",
      "description": "Valued 50¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "43.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.30",
      "rawHtsCode": "9904.02.30",
      "superior": null,
      "indent": "3",
      "description": "Valued 70¢/kg or more but less than 90¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "31.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.31",
      "rawHtsCode": "9904.02.31",
      "superior": null,
      "indent": "3",
      "description": "Valued 90¢/kg or more but less than $1.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "21.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.32",
      "rawHtsCode": "9904.02.32",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.10/kg or more but less than $1.30/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.33",
      "rawHtsCode": "9904.02.33",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.30/kg or more but less than $1.50/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.34",
      "rawHtsCode": "9904.02.34",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.50/kg or more but less than $1.70/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.02.35",
      "rawHtsCode": "9904.02.35",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.70/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.02.37",
      "rawHtsCode": "9904.02.37",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.8%",
      "flags": []
    },
    {
      "htsCode": "9904.02.60",
      "rawHtsCode": "9904.02.60",
      "superior": null,
      "indent": "0",
      "description": "Sheep meat, provided for in subheadings 0204.21.00, 0204.22.40, 0204.23.40, 0204.41.00, 0204.42.40 or 0204.43.40, if entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "0.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.01",
      "rawHtsCode": "9904.04.01",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 20¢/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "55.2¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.04.02",
      "rawHtsCode": "9904.04.02",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/liter or more but less than 40¢/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "38.4¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.04.03",
      "rawHtsCode": "9904.04.03",
      "superior": null,
      "indent": "2",
      "description": "Valued 40¢/liter or more but less than 60¢/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "25.1¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.04.04",
      "rawHtsCode": "9904.04.04",
      "superior": null,
      "indent": "2",
      "description": "Valued 60¢/liter or more but less than 80¢/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.1¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.04.05",
      "rawHtsCode": "9904.04.05",
      "superior": null,
      "indent": "2",
      "description": "Valued 80¢/liter or more but less than $1/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.3¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.04.06",
      "rawHtsCode": "9904.04.06",
      "superior": null,
      "indent": "2",
      "description": "Valued $1/liter or more but less than $1.20/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.3¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.04.07",
      "rawHtsCode": "9904.04.07",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.20/liter or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.04.08",
      "rawHtsCode": "9904.04.08",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "25.7¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.04.09",
      "rawHtsCode": "9904.04.09",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 60¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "90.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.10",
      "rawHtsCode": "9904.04.10",
      "superior": null,
      "indent": "2",
      "description": "Valued 60¢/kg or more but less than 80¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "74.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.11",
      "rawHtsCode": "9904.04.11",
      "superior": null,
      "indent": "2",
      "description": "Valued 80¢/kg or more but less than $1/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "60.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.12",
      "rawHtsCode": "9904.04.12",
      "superior": null,
      "indent": "2",
      "description": "Valued $1/kg or more but less than $1.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "48.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.13",
      "rawHtsCode": "9904.04.13",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.20/kg or more but less than $1.40/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "38.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.14",
      "rawHtsCode": "9904.04.14",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.40/kg or more but less than $1.60/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "28.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.15",
      "rawHtsCode": "9904.04.15",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.60/kg or more but less than $1.80/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "21¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.16",
      "rawHtsCode": "9904.04.16",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.80/kg or more but less than $2/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.17",
      "rawHtsCode": "9904.04.17",
      "superior": null,
      "indent": "2",
      "description": "Valued $2/kg or more but less than $2.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.18",
      "rawHtsCode": "9904.04.18",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.20/kg or more but less than $2.40/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.19",
      "rawHtsCode": "9904.04.19",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.40/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.04.20",
      "rawHtsCode": "9904.04.20",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 0401.50.75 or 0403.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "54.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.21",
      "rawHtsCode": "9904.04.21",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 0405.10.20",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "51.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.22",
      "rawHtsCode": "9904.04.22",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "35¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.23",
      "rawHtsCode": "9904.04.23",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "26.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.24",
      "rawHtsCode": "9904.04.24",
      "superior": null,
      "indent": "2",
      "description": "Valued 30¢/kg or more but less than 40¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "19.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.25",
      "rawHtsCode": "9904.04.25",
      "superior": null,
      "indent": "2",
      "description": "Valued 40¢/kg or more but less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.26",
      "rawHtsCode": "9904.04.26",
      "superior": null,
      "indent": "2",
      "description": "Valued 50¢/kg or more but less than 60¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.27",
      "rawHtsCode": "9904.04.27",
      "superior": null,
      "indent": "2",
      "description": "Valued 60¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "6.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.28",
      "rawHtsCode": "9904.04.28",
      "superior": null,
      "indent": "2",
      "description": "Valued 70¢/kg or more but less than 80¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.29",
      "rawHtsCode": "9904.04.29",
      "superior": null,
      "indent": "2",
      "description": "Valued 80¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.04.30",
      "rawHtsCode": "9904.04.30",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "28.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.31",
      "rawHtsCode": "9904.04.31",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "35.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.32",
      "rawHtsCode": "9904.04.32",
      "superior": null,
      "indent": "2",
      "description": "Valued 15¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "26.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.33",
      "rawHtsCode": "9904.04.33",
      "superior": null,
      "indent": "2",
      "description": "Valued 25¢/kg or more but less than 35¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "19.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.34",
      "rawHtsCode": "9904.04.34",
      "superior": null,
      "indent": "2",
      "description": "Valued 35¢/kg or more but less than 45¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.35",
      "rawHtsCode": "9904.04.35",
      "superior": null,
      "indent": "2",
      "description": "Valued 45¢/kg or more but less than 55¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.36",
      "rawHtsCode": "9904.04.36",
      "superior": null,
      "indent": "2",
      "description": "Valued 55¢/kg or more but less than 65¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.37",
      "rawHtsCode": "9904.04.37",
      "superior": null,
      "indent": "2",
      "description": "Valued 65¢/kg or more but less than 75¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.38",
      "rawHtsCode": "9904.04.38",
      "superior": null,
      "indent": "2",
      "description": "Valued 75¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.04.39",
      "rawHtsCode": "9904.04.39",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "36.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.40",
      "rawHtsCode": "9904.04.40",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 60¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "69.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.41",
      "rawHtsCode": "9904.04.41",
      "superior": null,
      "indent": "2",
      "description": "Valued 60¢/kg or more but less than 80¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "55.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.42",
      "rawHtsCode": "9904.04.42",
      "superior": null,
      "indent": "2",
      "description": "Valued 80¢/kg or more but less than $1/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "42.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.43",
      "rawHtsCode": "9904.04.43",
      "superior": null,
      "indent": "2",
      "description": "Valued $1/kg or more but less than $1.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "32.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.44",
      "rawHtsCode": "9904.04.44",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.20/kg or more but less than $1.40/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "22.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.45",
      "rawHtsCode": "9904.04.45",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.40/kg or more but less than $1.60/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.46",
      "rawHtsCode": "9904.04.46",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.60/kg or more but less than $1.80/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.47",
      "rawHtsCode": "9904.04.47",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.80/kg or more but less than $2/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.48",
      "rawHtsCode": "9904.04.48",
      "superior": null,
      "indent": "2",
      "description": "Valued $2/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.04.49",
      "rawHtsCode": "9904.04.49",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "51.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.50",
      "rawHtsCode": "9904.04.50",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 65¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "additionalDuties": "78.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.51",
      "rawHtsCode": "9904.04.51",
      "superior": null,
      "indent": "3",
      "description": "Valued 65¢/kg or more but less than 95¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "57.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.52",
      "rawHtsCode": "9904.04.52",
      "superior": null,
      "indent": "3",
      "description": "Valued 95¢/kg or more but less than $1.25/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "40.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.53",
      "rawHtsCode": "9904.04.53",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.25/kg or more but less than $1.55/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "25.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.54",
      "rawHtsCode": "9904.04.54",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.55/kg or more but less than $1.85/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.55",
      "rawHtsCode": "9904.04.55",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.85/kg or more but less than $2.05/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.56",
      "rawHtsCode": "9904.04.56",
      "superior": null,
      "indent": "3",
      "description": "Valued $2.05/kg or more but less than $2.25/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.58",
      "rawHtsCode": "9904.04.58",
      "superior": null,
      "indent": "3",
      "description": "Valued $2.25/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.04.59",
      "rawHtsCode": "9904.04.59",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "65.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.60",
      "rawHtsCode": "9904.04.60",
      "superior": null,
      "indent": "3",
      "description": "Valued 30¢/kg or more but less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "48.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.61",
      "rawHtsCode": "9904.04.61",
      "superior": null,
      "indent": "3",
      "description": "Valued 50¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "34.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.62",
      "rawHtsCode": "9904.04.62",
      "superior": null,
      "indent": "3",
      "description": "Valued 70¢/kg or more but less than 90¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "24.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.63",
      "rawHtsCode": "9904.04.63",
      "superior": null,
      "indent": "3",
      "description": "Valued 90¢/kg or more but less than $1.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.64",
      "rawHtsCode": "9904.04.64",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.10/kg or more but less than $1.30/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.65",
      "rawHtsCode": "9904.04.65",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.30/kg or more but less than $1.50/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.66",
      "rawHtsCode": "9904.04.66",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.50/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.04.67",
      "rawHtsCode": "9904.04.67",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "66.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.68",
      "rawHtsCode": "9904.04.68",
      "superior": null,
      "indent": "3",
      "description": "Valued 30¢/kg or more but less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "49.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.69",
      "rawHtsCode": "9904.04.69",
      "superior": null,
      "indent": "3",
      "description": "Valued 50¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "35.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.70",
      "rawHtsCode": "9904.04.70",
      "superior": null,
      "indent": "3",
      "description": "Valued 70¢/kg or more but less than 90¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "25.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.71",
      "rawHtsCode": "9904.04.71",
      "superior": null,
      "indent": "3",
      "description": "Valued 90¢/kg or more but less than $1.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.72",
      "rawHtsCode": "9904.04.72",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.10/kg or more but less than $1.30/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.73",
      "rawHtsCode": "9904.04.73",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.30/kg or more but less than $1.50/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.74",
      "rawHtsCode": "9904.04.74",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.50/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.04.75",
      "rawHtsCode": "9904.04.75",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 90¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "74.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.76",
      "rawHtsCode": "9904.04.76",
      "superior": null,
      "indent": "3",
      "description": "Valued 90¢/kg or more but less than $1.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "53.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.77",
      "rawHtsCode": "9904.04.77",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.20/kg or more but less than $1.50/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "38.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.78",
      "rawHtsCode": "9904.04.78",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.50/kg or more but less than $1.80/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "24.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.79",
      "rawHtsCode": "9904.04.79",
      "superior": null,
      "indent": "3",
      "description": "Valued $1.80/kg or more but less than $2.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.80",
      "rawHtsCode": "9904.04.80",
      "superior": null,
      "indent": "3",
      "description": "Valued $2.10/kg or more but less than $2.30/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.81",
      "rawHtsCode": "9904.04.81",
      "superior": null,
      "indent": "3",
      "description": "Valued $2.30/kg or more but less than $2.50/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.82",
      "rawHtsCode": "9904.04.82",
      "superior": null,
      "indent": "3",
      "description": "Valued $2.50/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.04.83",
      "rawHtsCode": "9904.04.83",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 0402.29.50",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "36.8¢/kg + 5%",
      "flags": []
    },
    {
      "htsCode": "9904.04.84",
      "rawHtsCode": "9904.04.84",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 0402.99.90",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.4¢/kg + 5%",
      "flags": []
    },
    {
      "htsCode": "9904.04.85",
      "rawHtsCode": "9904.04.85",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 0403.20.50 or 0403.90.95",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "additionalDuties": "34.5¢/kg + 5.7%",
      "flags": []
    },
    {
      "htsCode": "9904.04.86",
      "rawHtsCode": "9904.04.86",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 0404.10.15",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "34.5¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.04.87",
      "rawHtsCode": "9904.04.87",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 0404.90.50",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "39.6¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.04.88",
      "rawHtsCode": "9904.04.88",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1517.90.60",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "11.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.89",
      "rawHtsCode": "9904.04.89",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1704.90.58",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "13.3¢/kg + 3.5%",
      "flags": []
    },
    {
      "htsCode": "9904.04.90",
      "rawHtsCode": "9904.04.90",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.20.82",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.4¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.04.91",
      "rawHtsCode": "9904.04.91",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.20.83",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "17.6¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.04.92",
      "rawHtsCode": "9904.04.92",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1806.32.70 or 1806.90.08",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.4¢/kg + 2%",
      "flags": []
    },
    {
      "htsCode": "9904.04.93",
      "rawHtsCode": "9904.04.93",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1806.32.80 or 1806.90.10",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "17.6¢/kg + 2%",
      "flags": []
    },
    {
      "htsCode": "9904.04.94",
      "rawHtsCode": "9904.04.94",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1901.10.26 or 1901.10.44",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "34.5¢/kg + 5%",
      "flags": []
    },
    {
      "htsCode": "9904.04.95",
      "rawHtsCode": "9904.04.95",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1901.20.15 or 1901.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.1¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.04.96",
      "rawHtsCode": "9904.04.96",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1901.10.56, 1901.10.66, 1901.90.62 or 1901.90.65",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "34.5¢/kg + 4.5%",
      "flags": []
    },
    {
      "htsCode": "9904.04.97",
      "rawHtsCode": "9904.04.97",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 2105.00.40",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "16.7¢/kg + 5.7%",
      "flags": []
    },
    {
      "htsCode": "9904.04.98",
      "rawHtsCode": "9904.04.98",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 2106.90.09",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "28.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.04.99",
      "rawHtsCode": "9904.04.99",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 0405.20.70 or 2106.90.66",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "23.5¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.05.00",
      "rawHtsCode": "9904.05.00",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 2106.90.87",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.6¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.05.01",
      "rawHtsCode": "9904.05.01",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 2202.99.28",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "7.8¢/kg + 5%",
      "flags": []
    },
    {
      "htsCode": "9904.05.02",
      "rawHtsCode": "9904.05.02",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "23.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.03",
      "rawHtsCode": "9904.05.03",
      "superior": null,
      "indent": "3",
      "description": "Valued 15¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "19.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.04",
      "rawHtsCode": "9904.05.04",
      "superior": null,
      "indent": "3",
      "description": "Valued 20¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "16¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.05",
      "rawHtsCode": "9904.05.05",
      "superior": null,
      "indent": "3",
      "description": "Valued 25¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.06",
      "rawHtsCode": "9904.05.06",
      "superior": null,
      "indent": "3",
      "description": "Valued 30¢/kg or more but less than 40¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "7.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.07",
      "rawHtsCode": "9904.05.07",
      "superior": null,
      "indent": "3",
      "description": "Valued 40¢/kg or more but less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "4.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.08",
      "rawHtsCode": "9904.05.08",
      "superior": null,
      "indent": "3",
      "description": "Valued 50¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.05.09",
      "rawHtsCode": "9904.05.09",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "39¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.10",
      "rawHtsCode": "9904.05.10",
      "superior": null,
      "indent": "3",
      "description": "Valued 30¢/kg or more but less than 40¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "31.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.11",
      "rawHtsCode": "9904.05.11",
      "superior": null,
      "indent": "3",
      "description": "Valued 40¢/kg or more but less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "24.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.12",
      "rawHtsCode": "9904.05.12",
      "superior": null,
      "indent": "3",
      "description": "Valued 50¢/kg or more but less than 60¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "19.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.13",
      "rawHtsCode": "9904.05.13",
      "superior": null,
      "indent": "3",
      "description": "Valued 60¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.14",
      "rawHtsCode": "9904.05.14",
      "superior": null,
      "indent": "3",
      "description": "Valued 70¢/kg or more but less than 80¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.15",
      "rawHtsCode": "9904.05.15",
      "superior": null,
      "indent": "3",
      "description": "Valued 80¢/kg or more but less than 90¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "7.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.16",
      "rawHtsCode": "9904.05.16",
      "superior": null,
      "indent": "3",
      "description": "Valued 90¢/kg or more but less than $1/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "4.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.17",
      "rawHtsCode": "9904.05.17",
      "superior": null,
      "indent": "3",
      "description": "Valued $1/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.05.18",
      "rawHtsCode": "9904.05.18",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 0402.91.70 or 0402.91.90",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.19",
      "rawHtsCode": "9904.05.19",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 0402.99.45 or 0402.99.55",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "16.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.20",
      "rawHtsCode": "9904.05.20",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "29.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.21",
      "rawHtsCode": "9904.05.21",
      "superior": null,
      "indent": "3",
      "description": "Valued 20¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "22.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.22",
      "rawHtsCode": "9904.05.22",
      "superior": null,
      "indent": "3",
      "description": "Valued 30¢/kg or more but less than 40¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.23",
      "rawHtsCode": "9904.05.23",
      "superior": null,
      "indent": "3",
      "description": "Valued 40¢/kg or more but less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "11.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.24",
      "rawHtsCode": "9904.05.24",
      "superior": null,
      "indent": "3",
      "description": "Valued 50¢/kg or more but less than 60¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.25",
      "rawHtsCode": "9904.05.25",
      "superior": null,
      "indent": "3",
      "description": "Valued 60¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.26",
      "rawHtsCode": "9904.05.26",
      "superior": null,
      "indent": "3",
      "description": "Valued 70¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.05.28",
      "rawHtsCode": "9904.05.28",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 7¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "additionalDuties": "17.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.29",
      "rawHtsCode": "9904.05.29",
      "superior": null,
      "indent": "3",
      "description": "Valued 7¢/kg or more but less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.30",
      "rawHtsCode": "9904.05.30",
      "superior": null,
      "indent": "3",
      "description": "Valued 10¢/kg or more but less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "11.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.31",
      "rawHtsCode": "9904.05.31",
      "superior": null,
      "indent": "3",
      "description": "Valued 15¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.32",
      "rawHtsCode": "9904.05.32",
      "superior": null,
      "indent": "3",
      "description": "Valued 20¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.33",
      "rawHtsCode": "9904.05.33",
      "superior": null,
      "indent": "3",
      "description": "Valued 25¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.34",
      "rawHtsCode": "9904.05.34",
      "superior": null,
      "indent": "3",
      "description": "Valued 30¢/kg or more but less than 35¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.35",
      "rawHtsCode": "9904.05.35",
      "superior": null,
      "indent": "3",
      "description": "Valued 35¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.05.36",
      "rawHtsCode": "9904.05.36",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "29.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.37",
      "rawHtsCode": "9904.05.37",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 60¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "67.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.38",
      "rawHtsCode": "9904.05.38",
      "superior": null,
      "indent": "2",
      "description": "Valued 60¢/kg or more but less than 80¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "53.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.39",
      "rawHtsCode": "9904.05.39",
      "superior": null,
      "indent": "2",
      "description": "Valued 80¢/kg or more but less than $1/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "40.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.40",
      "rawHtsCode": "9904.05.40",
      "superior": null,
      "indent": "2",
      "description": "Valued $1/kg or more but less than $1.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "30.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.41",
      "rawHtsCode": "9904.05.41",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.20/kg or more but less than $1.40/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "21¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.42",
      "rawHtsCode": "9904.05.42",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.40/kg or more but less than $1.60/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.43",
      "rawHtsCode": "9904.05.43",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.60/kg or more but less than $1.80/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.44",
      "rawHtsCode": "9904.05.44",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.80/kg or more but less than $2/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.45",
      "rawHtsCode": "9904.05.45",
      "superior": null,
      "indent": "2",
      "description": "Valued $2/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.05.46",
      "rawHtsCode": "9904.05.46",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 0405.90.20",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "62.2¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.05.47",
      "rawHtsCode": "9904.05.47",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 0405.20.30, 2106.90.26 or 2106.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "66.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.48",
      "rawHtsCode": "9904.05.48",
      "superior": null,
      "indent": "2",
      "description": "Valued less than $1.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "$1.062/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.49",
      "rawHtsCode": "9904.05.49",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.20/kg or more but less than $1.50/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "85.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.50",
      "rawHtsCode": "9904.05.50",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.50/kg or more but less than $1.80/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "67.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.51",
      "rawHtsCode": "9904.05.51",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.80/kg or more but less than $2.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "52.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.52",
      "rawHtsCode": "9904.05.52",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.10/kg or more but less than $2.40/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "37.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.53",
      "rawHtsCode": "9904.05.53",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.40/kg or more but less than $2.70/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "28.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.54",
      "rawHtsCode": "9904.05.54",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.70/kg or more but less than $3/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "19.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.55",
      "rawHtsCode": "9904.05.55",
      "superior": null,
      "indent": "2",
      "description": "Valued $3/kg or more but less than $3.30/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.56",
      "rawHtsCode": "9904.05.56",
      "superior": null,
      "indent": "2",
      "description": "Valued $3.30/kg or more but less than $3.50/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "4.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.57",
      "rawHtsCode": "9904.05.57",
      "superior": null,
      "indent": "2",
      "description": "Valued $3.50/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.05.58",
      "rawHtsCode": "9904.05.58",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "75.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.59",
      "rawHtsCode": "9904.05.59",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 65¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "57.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.60",
      "rawHtsCode": "9904.05.60",
      "superior": null,
      "indent": "2",
      "description": "Valued 65¢/kg or more but less than 75¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "50.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.61",
      "rawHtsCode": "9904.05.61",
      "superior": null,
      "indent": "2",
      "description": "Valued 75¢/kg or more but less than 85¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "43.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.62",
      "rawHtsCode": "9904.05.62",
      "superior": null,
      "indent": "2",
      "description": "Valued 85¢/kg or more but less than 95¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "37.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.63",
      "rawHtsCode": "9904.05.63",
      "superior": null,
      "indent": "2",
      "description": "Valued 95¢/kg or more but less than $1.05/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "32.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.64",
      "rawHtsCode": "9904.05.64",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.05/kg or more but less than $1.15/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "27.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.65",
      "rawHtsCode": "9904.05.65",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.15/kg or more but less than $1.25/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "22.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.66",
      "rawHtsCode": "9904.05.66",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.25/kg or more but less than $1.35/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "18.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.67",
      "rawHtsCode": "9904.05.67",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.35/kg or more but less than $1.45/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.68",
      "rawHtsCode": "9904.05.68",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.45/kg or more but less than $1.55/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.69",
      "rawHtsCode": "9904.05.69",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.55/kg or more but less than $1.65/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.70",
      "rawHtsCode": "9904.05.70",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.65/kg or more but less than $1.75/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "6.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.71",
      "rawHtsCode": "9904.05.71",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.75/kg or more but less than $1.85/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.72",
      "rawHtsCode": "9904.05.72",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.85/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.05.73",
      "rawHtsCode": "9904.05.73",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "40.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.74",
      "rawHtsCode": "9904.05.74",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "53.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.75",
      "rawHtsCode": "9904.05.75",
      "superior": null,
      "indent": "2",
      "description": "Valued 50¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "39.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.76",
      "rawHtsCode": "9904.05.76",
      "superior": null,
      "indent": "2",
      "description": "Valued 70¢/kg or more but less than 90¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "28.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.77",
      "rawHtsCode": "9904.05.77",
      "superior": null,
      "indent": "2",
      "description": "Valued 90¢/kg or more but less than $1.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "18.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.78",
      "rawHtsCode": "9904.05.78",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.10/kg or more but less than $1.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.79",
      "rawHtsCode": "9904.05.79",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.20/kg or more but less than $1.40/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.80",
      "rawHtsCode": "9904.05.80",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.40/kg or more but less than $1.60/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.81",
      "rawHtsCode": "9904.05.81",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.60/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.05.82",
      "rawHtsCode": "9904.05.82",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "35.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.83",
      "rawHtsCode": "9904.05.83",
      "superior": null,
      "indent": "2",
      "description": "Valued less than $1.05/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "77¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.84",
      "rawHtsCode": "9904.05.84",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.05/kg or more but less than $1.25/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "63¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.85",
      "rawHtsCode": "9904.05.85",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.25/kg or more but less than $1.45/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "52.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.86",
      "rawHtsCode": "9904.05.86",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.45/kg or more but less than $1.65/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "42.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.87",
      "rawHtsCode": "9904.05.87",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.65/kg or more but less than $1.85/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "32.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.88",
      "rawHtsCode": "9904.05.88",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.85/kg or more but less than $2.05/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "25¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.89",
      "rawHtsCode": "9904.05.89",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.05/kg or more but less than $2.25/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "19¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.90",
      "rawHtsCode": "9904.05.90",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.25/kg or more but less than $2.45/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "13¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.91",
      "rawHtsCode": "9904.05.91",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.45/kg or more but less than $2.65/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.92",
      "rawHtsCode": "9904.05.92",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.65/kg or more but less than $2.75/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.93",
      "rawHtsCode": "9904.05.93",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.75/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.05.94",
      "rawHtsCode": "9904.05.94",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "60.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.95",
      "rawHtsCode": "9904.05.95",
      "superior": null,
      "indent": "2",
      "description": "Valued less than $1.15/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "98.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.96",
      "rawHtsCode": "9904.05.96",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.15/kg or more but less than $1.45/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "77.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.97",
      "rawHtsCode": "9904.05.97",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.45/kg or more but less than $1.75/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "61.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.98",
      "rawHtsCode": "9904.05.98",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.75/kg or more but less than $2.05/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "46.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.05.99",
      "rawHtsCode": "9904.05.99",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.05/kg or more but less than $2.35/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "32.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.00",
      "rawHtsCode": "9904.06.00",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.35/kg or more but less than $2.65/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "23.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.01",
      "rawHtsCode": "9904.06.01",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.65/kg or more but less than $2.95/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.02",
      "rawHtsCode": "9904.06.02",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.95/kg or more but less than $3.15/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.03",
      "rawHtsCode": "9904.06.03",
      "superior": null,
      "indent": "2",
      "description": "Valued $3.15/kg or more but less than $3.35/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.04",
      "rawHtsCode": "9904.06.04",
      "superior": null,
      "indent": "2",
      "description": "Valued $3.35/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.06.05",
      "rawHtsCode": "9904.06.05",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "71.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.06",
      "rawHtsCode": "9904.06.06",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 90¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "94¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.07",
      "rawHtsCode": "9904.06.07",
      "superior": null,
      "indent": "2",
      "description": "Valued 90¢/kg or more but less than $1.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "80¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.08",
      "rawHtsCode": "9904.06.08",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.10/kg or more but less than $1.30/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "66¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.09",
      "rawHtsCode": "9904.06.09",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.30/kg or more but less than $1.50/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "55.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.10",
      "rawHtsCode": "9904.06.10",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.50/kg or more but less than $1.70/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "45.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.11",
      "rawHtsCode": "9904.06.11",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.70/kg or more but less than $1.90/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "35.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.12",
      "rawHtsCode": "9904.06.12",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.90/kg or more but less than $2.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "27.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.13",
      "rawHtsCode": "9904.06.13",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.10/kg or more but less than $2.30/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "21.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.14",
      "rawHtsCode": "9904.06.14",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.30/kg or more but less than $2.50/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.15",
      "rawHtsCode": "9904.06.15",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.50/kg or more but less than $2.70/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.16",
      "rawHtsCode": "9904.06.16",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.70/kg or more but less than $2.90/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.17",
      "rawHtsCode": "9904.06.17",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.90/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.06.18",
      "rawHtsCode": "9904.06.18",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "62.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.19",
      "rawHtsCode": "9904.06.19",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "66.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.20",
      "rawHtsCode": "9904.06.20",
      "superior": null,
      "indent": "2",
      "description": "Valued 70¢/kg or more but less than 90¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "52.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.21",
      "rawHtsCode": "9904.06.21",
      "superior": null,
      "indent": "2",
      "description": "Valued 90¢/kg or more but less than $1.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "41.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.22",
      "rawHtsCode": "9904.06.22",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.10/kg or more but less than $1.30/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "31.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.23",
      "rawHtsCode": "9904.06.23",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.30/kg or more but less than $1.50/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "21.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.24",
      "rawHtsCode": "9904.06.24",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.50/kg or more but less than $1.70/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.25",
      "rawHtsCode": "9904.06.25",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.70/kg or more but less than $1.90/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.26",
      "rawHtsCode": "9904.06.26",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.90/kg or more but less than $2.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.27",
      "rawHtsCode": "9904.06.27",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.10/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.06.28",
      "rawHtsCode": "9904.06.28",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "46.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.29",
      "rawHtsCode": "9904.06.29",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "59.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.30",
      "rawHtsCode": "9904.06.30",
      "superior": null,
      "indent": "2",
      "description": "Valued 50¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "45.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.31",
      "rawHtsCode": "9904.06.31",
      "superior": null,
      "indent": "2",
      "description": "Valued 70¢/kg or more but less than 90¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "33¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.32",
      "rawHtsCode": "9904.06.32",
      "superior": null,
      "indent": "2",
      "description": "Valued 90¢/kg or more but less than $1.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "23¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.33",
      "rawHtsCode": "9904.06.33",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.10/kg or more but less than $1.30/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.34",
      "rawHtsCode": "9904.06.34",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.30/kg or more but less than $1.50/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.35",
      "rawHtsCode": "9904.06.35",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.50/kg or more but less than $1.70/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.36",
      "rawHtsCode": "9904.06.36",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.70/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.06.37",
      "rawHtsCode": "9904.06.37",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "37.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.38",
      "rawHtsCode": "9904.06.38",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "94.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.39",
      "rawHtsCode": "9904.06.39",
      "superior": null,
      "indent": "2",
      "description": "Valued 50¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "76.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.40",
      "rawHtsCode": "9904.06.40",
      "superior": null,
      "indent": "2",
      "description": "Valued 70¢/kg or more but less than 90¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "62.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.41",
      "rawHtsCode": "9904.06.41",
      "superior": null,
      "indent": "2",
      "description": "Valued 90¢/kg or more but less than $1.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "49.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.42",
      "rawHtsCode": "9904.06.42",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.10/kg or more but less than $1.30/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "39.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.43",
      "rawHtsCode": "9904.06.43",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.30/kg or more but less than $1.50/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "29.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.44",
      "rawHtsCode": "9904.06.44",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.50/kg or more but less than $1.70/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "21.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.45",
      "rawHtsCode": "9904.06.45",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.70/kg or more but less than $1.90/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.46",
      "rawHtsCode": "9904.06.46",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.90/kg or more but less than $2.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.47",
      "rawHtsCode": "9904.06.47",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.10/kg or more but less than $2.30/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.06.48",
      "rawHtsCode": "9904.06.48",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.30/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.06.49",
      "rawHtsCode": "9904.06.49",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "50.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.01",
      "rawHtsCode": "9904.12.01",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 5¢/kg",
      "units": [],
      "generalRate": "13.3¢/kg",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "additionalDuties": "13.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.02",
      "rawHtsCode": "9904.12.02",
      "superior": null,
      "indent": "3",
      "description": "Valued 5¢/kg or more but less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.03",
      "rawHtsCode": "9904.12.03",
      "superior": null,
      "indent": "3",
      "description": "Valued 10¢/kg or more but less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.04",
      "rawHtsCode": "9904.12.04",
      "superior": null,
      "indent": "3",
      "description": "Valued 15¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.05",
      "rawHtsCode": "9904.12.05",
      "superior": null,
      "indent": "3",
      "description": "Valued 20¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "1.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.06",
      "rawHtsCode": "9904.12.06",
      "superior": null,
      "indent": "3",
      "description": "Valued 25¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.12.07",
      "rawHtsCode": "9904.12.07",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "additionalDuties": "55.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.08",
      "rawHtsCode": "9904.12.08",
      "superior": null,
      "indent": "3",
      "description": "Valued 10¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "46.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.09",
      "rawHtsCode": "9904.12.09",
      "superior": null,
      "indent": "3",
      "description": "Valued 20¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "37.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.10",
      "rawHtsCode": "9904.12.10",
      "superior": null,
      "indent": "3",
      "description": "Valued 30¢/kg or more but less than 40¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "30.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.11",
      "rawHtsCode": "9904.12.11",
      "superior": null,
      "indent": "3",
      "description": "Valued 40¢/kg or more but less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "23.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.12",
      "rawHtsCode": "9904.12.12",
      "superior": null,
      "indent": "3",
      "description": "Valued 50¢/kg or more but less than 60¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "18.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.13",
      "rawHtsCode": "9904.12.13",
      "superior": null,
      "indent": "3",
      "description": "Valued 60¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "13.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.14",
      "rawHtsCode": "9904.12.14",
      "superior": null,
      "indent": "3",
      "description": "Valued 70¢/kg or more but less than 80¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.15",
      "rawHtsCode": "9904.12.15",
      "superior": null,
      "indent": "3",
      "description": "Valued 80¢/kg or more but less than 90¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "6.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.16",
      "rawHtsCode": "9904.12.16",
      "superior": null,
      "indent": "3",
      "description": "Valued 90¢/kg or more but less than $1/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.12.17",
      "rawHtsCode": "9904.12.17",
      "superior": null,
      "indent": "3",
      "description": "Valued $1/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.12.18",
      "rawHtsCode": "9904.12.18",
      "superior": null,
      "indent": "2",
      "description": "In shell, provided for in subheading 1202.41.80",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "54.6%",
      "flags": []
    },
    {
      "htsCode": "9904.12.19",
      "rawHtsCode": "9904.12.19",
      "superior": null,
      "indent": "2",
      "description": "Other, provided for in subheadings 1202.30.80, 1202.42.20, 1202.42.90 or 2008.11.61",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "additionalDuties": "43.9%",
      "flags": []
    },
    {
      "htsCode": "9904.17.01",
      "rawHtsCode": "9904.17.01",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 5¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.02",
      "rawHtsCode": "9904.17.02",
      "superior": null,
      "indent": "2",
      "description": "Valued 5¢/kg or more but less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.03",
      "rawHtsCode": "9904.17.03",
      "superior": null,
      "indent": "2",
      "description": "Valued 10¢/kg or more but less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.04",
      "rawHtsCode": "9904.17.04",
      "superior": null,
      "indent": "2",
      "description": "Valued 15¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.05",
      "rawHtsCode": "9904.17.05",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "1.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.06",
      "rawHtsCode": "9904.17.06",
      "superior": null,
      "indent": "2",
      "description": "Valued 25¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.17.07",
      "rawHtsCode": "9904.17.07",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "11.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.08",
      "rawHtsCode": "9904.17.08",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 5¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "21.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.09",
      "rawHtsCode": "9904.17.09",
      "superior": null,
      "indent": "2",
      "description": "Valued 5¢/kg or more but less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "17.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.10",
      "rawHtsCode": "9904.17.10",
      "superior": null,
      "indent": "2",
      "description": "Valued 10¢/kg or more but less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "13.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.11",
      "rawHtsCode": "9904.17.11",
      "superior": null,
      "indent": "2",
      "description": "Valued 15¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.12",
      "rawHtsCode": "9904.17.12",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "7.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.13",
      "rawHtsCode": "9904.17.13",
      "superior": null,
      "indent": "2",
      "description": "Valued 25¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "4.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.14",
      "rawHtsCode": "9904.17.14",
      "superior": null,
      "indent": "2",
      "description": "Valued 30¢/kg or more but less than 35¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.15",
      "rawHtsCode": "9904.17.15",
      "superior": null,
      "indent": "2",
      "description": "Valued 35¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.17.16",
      "rawHtsCode": "9904.17.16",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "11.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.17",
      "rawHtsCode": "9904.17.17",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 5¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "25.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.18",
      "rawHtsCode": "9904.17.18",
      "superior": null,
      "indent": "3",
      "description": "Valued 5¢/kg or more but less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "16.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.19",
      "rawHtsCode": "9904.17.19",
      "superior": null,
      "indent": "3",
      "description": "Valued 15¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.20",
      "rawHtsCode": "9904.17.20",
      "superior": null,
      "indent": "3",
      "description": "Valued 25¢/kg or more but less than 35¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.21",
      "rawHtsCode": "9904.17.21",
      "superior": null,
      "indent": "3",
      "description": "Valued 35¢/kg or more but less than 45¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.22",
      "rawHtsCode": "9904.17.22",
      "superior": null,
      "indent": "3",
      "description": "Valued 45¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.17.23",
      "rawHtsCode": "9904.17.23",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "36.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.24",
      "rawHtsCode": "9904.17.24",
      "superior": null,
      "indent": "3",
      "description": "Valued 10¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "27.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.25",
      "rawHtsCode": "9904.17.25",
      "superior": null,
      "indent": "3",
      "description": "Valued 20¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "20.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.26",
      "rawHtsCode": "9904.17.26",
      "superior": null,
      "indent": "3",
      "description": "Valued 30¢/kg or more but less than 40¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.27",
      "rawHtsCode": "9904.17.27",
      "superior": null,
      "indent": "3",
      "description": "Valued 40¢/kg or more but less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.28",
      "rawHtsCode": "9904.17.28",
      "superior": null,
      "indent": "3",
      "description": "Valued 50¢/kg or more but less than 60¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.29",
      "rawHtsCode": "9904.17.29",
      "superior": null,
      "indent": "3",
      "description": "Valued 60¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.30",
      "rawHtsCode": "9904.17.30",
      "superior": null,
      "indent": "3",
      "description": "Valued 70¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.17.31",
      "rawHtsCode": "9904.17.31",
      "superior": null,
      "indent": "3",
      "description": "Valued less than 5¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "20.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.32",
      "rawHtsCode": "9904.17.32",
      "superior": null,
      "indent": "3",
      "description": "Valued 5¢/kg or more but less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "16.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.33",
      "rawHtsCode": "9904.17.33",
      "superior": null,
      "indent": "3",
      "description": "Valued 10¢/kg or more but less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.34",
      "rawHtsCode": "9904.17.34",
      "superior": null,
      "indent": "3",
      "description": "Valued 15¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.35",
      "rawHtsCode": "9904.17.35",
      "superior": null,
      "indent": "3",
      "description": "Valued 20¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "6.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.36",
      "rawHtsCode": "9904.17.36",
      "superior": null,
      "indent": "3",
      "description": "Valued 25¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "4.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.37",
      "rawHtsCode": "9904.17.37",
      "superior": null,
      "indent": "3",
      "description": "Valued 30¢/kg or more but less than 35¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.38",
      "rawHtsCode": "9904.17.38",
      "superior": null,
      "indent": "3",
      "description": "Valued 35¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.17.39",
      "rawHtsCode": "9904.17.39",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1701.91.48 or 1702.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "11.3¢/kg +1.7%",
      "flags": []
    },
    {
      "htsCode": "9904.17.40",
      "rawHtsCode": "9904.17.40",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1704.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "13.3¢/kg + 3.5%",
      "flags": []
    },
    {
      "htsCode": "9904.17.41",
      "rawHtsCode": "9904.17.41",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1806.10.28 or 1806.10.55",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "11.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.42",
      "rawHtsCode": "9904.17.42",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.20.73",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.2¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.43",
      "rawHtsCode": "9904.17.43",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.90.49",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.4¢/kg + 2%",
      "flags": []
    },
    {
      "htsCode": "9904.17.44",
      "rawHtsCode": "9904.17.44",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1901.20.25 or 1901.20.60",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.1¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.45",
      "rawHtsCode": "9904.17.45",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1901.90.54",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "7.9¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.46",
      "rawHtsCode": "9904.17.46",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 2101.12.48 or 2101.20.48",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.2¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.47",
      "rawHtsCode": "9904.17.47",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 2106.90.76",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "23.5¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.48",
      "rawHtsCode": "9904.17.48",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 2106.90.94",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.6¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.49",
      "rawHtsCode": "9904.17.49",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 5¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "additionalDuties": "20.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.50",
      "rawHtsCode": "9904.17.50",
      "superior": null,
      "indent": "2",
      "description": "Valued 5¢/kg or more but less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "16.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.51",
      "rawHtsCode": "9904.17.51",
      "superior": null,
      "indent": "2",
      "description": "Valued 10¢/kg or more but less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.52",
      "rawHtsCode": "9904.17.52",
      "superior": null,
      "indent": "2",
      "description": "Valued 15¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.53",
      "rawHtsCode": "9904.17.53",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "6.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.54",
      "rawHtsCode": "9904.17.54",
      "superior": null,
      "indent": "2",
      "description": "Valued 25¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "4.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.55",
      "rawHtsCode": "9904.17.55",
      "superior": null,
      "indent": "2",
      "description": "Valued 30¢/kg or more but less than 35¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.56",
      "rawHtsCode": "9904.17.56",
      "superior": null,
      "indent": "2",
      "description": "Valued 35¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.17.57",
      "rawHtsCode": "9904.17.57",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1701.91.58",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "11.3¢/kg +1.7%",
      "flags": []
    },
    {
      "htsCode": "9904.17.58",
      "rawHtsCode": "9904.17.58",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1704.90.78 or 3006.93.20",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "additionalDuties": "13.3¢/kg + 3.5%",
      "flags": []
    },
    {
      "htsCode": "9904.17.59",
      "rawHtsCode": "9904.17.59",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1806.20.77, 2101.12.58 or 2101.20.58",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.2¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.60",
      "rawHtsCode": "9904.17.60",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.20.98",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.4¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.62",
      "rawHtsCode": "9904.17.62",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.90.59",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.4¢/kg + 2%",
      "flags": []
    },
    {
      "htsCode": "9904.17.63",
      "rawHtsCode": "9904.17.63",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1901.10.76 [or] 1901.90.71",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1.",
        "Compiler's note: Bracketed word inserted for clarity."
      ],
      "additionalDuties": "7.9¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.64",
      "rawHtsCode": "9904.17.64",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 2106.90.80",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "23.5¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.65",
      "rawHtsCode": "9904.17.65",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 2106.90.97",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.6¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.66",
      "rawHtsCode": "9904.17.66",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 5¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "18.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.67",
      "rawHtsCode": "9904.17.67",
      "superior": null,
      "indent": "2",
      "description": "Valued 5¢/kg or more but less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "13.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.68",
      "rawHtsCode": "9904.17.68",
      "superior": null,
      "indent": "2",
      "description": "Valued 10¢/kg or more but less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.69",
      "rawHtsCode": "9904.17.69",
      "superior": null,
      "indent": "2",
      "description": "Valued 15¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.70",
      "rawHtsCode": "9904.17.70",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "4.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.71",
      "rawHtsCode": "9904.17.71",
      "superior": null,
      "indent": "2",
      "description": "Valued 25¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.17.72",
      "rawHtsCode": "9904.17.72",
      "superior": null,
      "indent": "2",
      "description": "Valued 30¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.17.73",
      "rawHtsCode": "9904.17.73",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1702.20.28",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.6¢/kg of total sugars + 1.7%",
      "flags": []
    },
    {
      "htsCode": "9904.17.74",
      "rawHtsCode": "9904.17.74",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1702.30.28",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.6¢/kg of total sugars + 1.7%",
      "flags": []
    },
    {
      "htsCode": "9904.17.75",
      "rawHtsCode": "9904.17.75",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1702.40.28",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "11.3¢/kg of total sugars + 1.7%",
      "flags": []
    },
    {
      "htsCode": "9904.17.76",
      "rawHtsCode": "9904.17.76",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1702.60.28",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "11.3¢/kg of total sugars + 1.7%",
      "flags": []
    },
    {
      "htsCode": "9904.17.77",
      "rawHtsCode": "9904.17.77",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1702.90.58",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "11.3¢/kg of total sugars + 1.7%",
      "flags": []
    },
    {
      "htsCode": "9904.17.78",
      "rawHtsCode": "9904.17.78",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.20.94",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.4¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.80",
      "rawHtsCode": "9904.17.80",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.90.39",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.4¢/kg + 2%",
      "flags": []
    },
    {
      "htsCode": "9904.17.81",
      "rawHtsCode": "9904.17.81",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 2101.12.38",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.2¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.82",
      "rawHtsCode": "9904.17.82",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 2101.20.38",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.2¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.83",
      "rawHtsCode": "9904.17.83",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 2106.90.72",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "23.5¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.17.84",
      "rawHtsCode": "9904.17.84",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 2106.90.91",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.6¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.18.01",
      "rawHtsCode": "9904.18.01",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 5¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "25.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.02",
      "rawHtsCode": "9904.18.02",
      "superior": null,
      "indent": "2",
      "description": "Valued 5¢/kg or more but less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "16.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.03",
      "rawHtsCode": "9904.18.03",
      "superior": null,
      "indent": "2",
      "description": "Valued 15¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.04",
      "rawHtsCode": "9904.18.04",
      "superior": null,
      "indent": "2",
      "description": "Valued 25¢/kg or more but less than 35¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.05",
      "rawHtsCode": "9904.18.05",
      "superior": null,
      "indent": "2",
      "description": "Valued 35¢/kg or more but less than 45¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.06",
      "rawHtsCode": "9904.18.06",
      "superior": null,
      "indent": "2",
      "description": "Valued 45¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.18.07",
      "rawHtsCode": "9904.18.07",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.10.15",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "7.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.08",
      "rawHtsCode": "9904.18.08",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1806.10.38 or 1806.10.75",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "11.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.09",
      "rawHtsCode": "9904.18.09",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "46.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.10",
      "rawHtsCode": "9904.18.10",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/kg or more but less than 40¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "30.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.11",
      "rawHtsCode": "9904.18.11",
      "superior": null,
      "indent": "2",
      "description": "Valued 40¢/kg or more but less than 60¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "18.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.12",
      "rawHtsCode": "9904.18.12",
      "superior": null,
      "indent": "2",
      "description": "Valued 60¢/kg or more but less than 80¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.13",
      "rawHtsCode": "9904.18.13",
      "superior": null,
      "indent": "2",
      "description": "Valued 80¢/kg or more but less than $1/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.14",
      "rawHtsCode": "9904.18.14",
      "superior": null,
      "indent": "2",
      "description": "Valued $1/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.18.15",
      "rawHtsCode": "9904.18.15",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1806.20.26 or 1806.32.06",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.4¢/kg + 1.4%",
      "flags": []
    },
    {
      "htsCode": "9904.18.16",
      "rawHtsCode": "9904.18.16",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1806.20.28 or 1806.32.08",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "17.6¢/kg + 1.4%",
      "flags": []
    },
    {
      "htsCode": "9904.18.17",
      "rawHtsCode": "9904.18.17",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1806.90.18",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.4¢/kg + 2%",
      "flags": []
    },
    {
      "htsCode": "9904.18.18",
      "rawHtsCode": "9904.18.18",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.90.20",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "17.6¢/kg + 2%",
      "flags": []
    },
    {
      "htsCode": "9904.18.19",
      "rawHtsCode": "9904.18.19",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "48.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.20",
      "rawHtsCode": "9904.18.20",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/kg or more but less than 40¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "32.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.21",
      "rawHtsCode": "9904.18.21",
      "superior": null,
      "indent": "2",
      "description": "Valued 40¢/kg or more but less than 60¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "20.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.22",
      "rawHtsCode": "9904.18.22",
      "superior": null,
      "indent": "2",
      "description": "Valued 60¢/kg or more but less than 80¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.23",
      "rawHtsCode": "9904.18.23",
      "superior": null,
      "indent": "2",
      "description": "Valued 80¢/kg or more but less than $1/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "4.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.18.24",
      "rawHtsCode": "9904.18.24",
      "superior": null,
      "indent": "2",
      "description": "Valued $1/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.18.25",
      "rawHtsCode": "9904.18.25",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1806.20.36 or 1806.32.16",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.4¢/kg + 1.4%",
      "flags": []
    },
    {
      "htsCode": "9904.18.26",
      "rawHtsCode": "9904.18.26",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheadings 1806.20.38 or 1806.32.18",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "17.6¢/kg + 1.4%",
      "flags": []
    },
    {
      "htsCode": "9904.18.27",
      "rawHtsCode": "9904.18.27",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.20.87",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.4¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.18.28",
      "rawHtsCode": "9904.18.28",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.20.89",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "17.6¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.18.29",
      "rawHtsCode": "9904.18.29",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.90.28",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.4¢/kg + 2%",
      "flags": []
    },
    {
      "htsCode": "9904.18.30",
      "rawHtsCode": "9904.18.30",
      "superior": null,
      "indent": "2",
      "description": "Provided for in subheading 1806.90.30",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "17.6¢/kg + 2%",
      "flags": []
    },
    {
      "htsCode": "9904.19.01",
      "rawHtsCode": "9904.19.01",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 65¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "78.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.02",
      "rawHtsCode": "9904.19.02",
      "superior": null,
      "indent": "2",
      "description": "Valued 65¢/kg or more but less than 85¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "64.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.03",
      "rawHtsCode": "9904.19.03",
      "superior": null,
      "indent": "2",
      "description": "Valued 85¢/kg or more but less than $1.05¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "50.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.04",
      "rawHtsCode": "9904.19.04",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.05/kg or more but less than $1.25/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "40.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.05",
      "rawHtsCode": "9904.19.05",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.25/kg or more but less than $1.55/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "25.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.06",
      "rawHtsCode": "9904.19.06",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.55/kg or more but less than $1.85/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.07",
      "rawHtsCode": "9904.19.07",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.85/kg or more but less than $2.05/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.08",
      "rawHtsCode": "9904.19.08",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.05/kg or more but less than $2.25/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.09",
      "rawHtsCode": "9904.19.09",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.25/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.19.10",
      "rawHtsCode": "9904.19.10",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "34.5¢/kg + 5%",
      "flags": []
    },
    {
      "htsCode": "9904.19.11",
      "rawHtsCode": "9904.19.11",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "36.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.12",
      "rawHtsCode": "9904.19.12",
      "superior": null,
      "indent": "2",
      "description": "Valued 10¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "27.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.13",
      "rawHtsCode": "9904.19.13",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "20.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.14",
      "rawHtsCode": "9904.19.14",
      "superior": null,
      "indent": "2",
      "description": "Valued 30¢/kg or more but less than 40¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.15",
      "rawHtsCode": "9904.19.15",
      "superior": null,
      "indent": "2",
      "description": "Valued 40¢/kg or more but less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.16",
      "rawHtsCode": "9904.19.16",
      "superior": null,
      "indent": "2",
      "description": "Valued 50¢/kg or more but less than 60¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.17",
      "rawHtsCode": "9904.19.17",
      "superior": null,
      "indent": "2",
      "description": "Valued 60¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.19.18",
      "rawHtsCode": "9904.19.18",
      "superior": null,
      "indent": "2",
      "description": "Valued 70¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.19.19",
      "rawHtsCode": "9904.19.19",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.1¢/kg + 2.8%",
      "flags": []
    },
    {
      "htsCode": "9904.20.01",
      "rawHtsCode": "9904.20.01",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 5¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "43.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.20.02",
      "rawHtsCode": "9904.20.02",
      "superior": null,
      "indent": "2",
      "description": "Valued 5¢/kg or more but less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "34.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.20.03",
      "rawHtsCode": "9904.20.03",
      "superior": null,
      "indent": "2",
      "description": "Valued 15¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "25.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.20.04",
      "rawHtsCode": "9904.20.04",
      "superior": null,
      "indent": "2",
      "description": "Valued 25¢/kg or more but less than 35¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "18.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.20.05",
      "rawHtsCode": "9904.20.05",
      "superior": null,
      "indent": "2",
      "description": "Valued 35¢/kg or more but less than 45¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "13.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.20.06",
      "rawHtsCode": "9904.20.06",
      "superior": null,
      "indent": "2",
      "description": "Valued 45¢/kg or more but less than 55¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.20.07",
      "rawHtsCode": "9904.20.07",
      "superior": null,
      "indent": "2",
      "description": "Valued 55¢/kg or more but less than 65¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.20.08",
      "rawHtsCode": "9904.20.08",
      "superior": null,
      "indent": "2",
      "description": "Valued 65¢/kg or more but less than 75¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.20.09",
      "rawHtsCode": "9904.20.09",
      "superior": null,
      "indent": "2",
      "description": "Valued 75¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.20.10",
      "rawHtsCode": "9904.20.10",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "43.9%",
      "flags": []
    },
    {
      "htsCode": "9904.21.01",
      "rawHtsCode": "9904.21.01",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 5¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "20.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.21.02",
      "rawHtsCode": "9904.21.02",
      "superior": null,
      "indent": "2",
      "description": "Valued 5¢/kg or more but less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "16.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.21.03",
      "rawHtsCode": "9904.21.03",
      "superior": null,
      "indent": "2",
      "description": "Valued 10¢/kg or more but less than 15¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.21.04",
      "rawHtsCode": "9904.21.04",
      "superior": null,
      "indent": "2",
      "description": "Valued 15¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.21.05",
      "rawHtsCode": "9904.21.05",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/kg or more but less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "6.4¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.21.06",
      "rawHtsCode": "9904.21.06",
      "superior": null,
      "indent": "2",
      "description": "Valued 25¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "4.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.21.07",
      "rawHtsCode": "9904.21.07",
      "superior": null,
      "indent": "2",
      "description": "Valued 30¢/kg or more but less than 35¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.21.08",
      "rawHtsCode": "9904.21.08",
      "superior": null,
      "indent": "2",
      "description": "Valued 35¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.21.09",
      "rawHtsCode": "9904.21.09",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.2¢/kg + 2.1%",
      "flags": []
    },
    {
      "htsCode": "9904.21.10",
      "rawHtsCode": "9904.21.10",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 20¢/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "32.3¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.21.11",
      "rawHtsCode": "9904.21.11",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/liter or more but less than 30¢/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "24.5¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.21.12",
      "rawHtsCode": "9904.21.12",
      "superior": null,
      "indent": "2",
      "description": "Valued 30¢/liter or more but less than 40¢/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "17.8¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.21.13",
      "rawHtsCode": "9904.21.13",
      "superior": null,
      "indent": "2",
      "description": "Valued 40¢/liter or more but less than 50¢/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "12.8¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.21.14",
      "rawHtsCode": "9904.21.14",
      "superior": null,
      "indent": "2",
      "description": "Valued 50¢/liter or more but less than 60¢/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.2¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.21.15",
      "rawHtsCode": "9904.21.15",
      "superior": null,
      "indent": "2",
      "description": "Valued 60¢/liter or more but less than 70¢/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.2¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.21.16",
      "rawHtsCode": "9904.21.16",
      "superior": null,
      "indent": "2",
      "description": "Valued 70¢/liter or more but less than 80¢/liter",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.2¢/liter",
      "flags": []
    },
    {
      "htsCode": "9904.21.17",
      "rawHtsCode": "9904.21.17",
      "superior": null,
      "indent": "2",
      "description": "Valued 80¢/liter or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.21.18",
      "rawHtsCode": "9904.21.18",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "16.7¢/ liter + 5.7%",
      "flags": []
    },
    {
      "htsCode": "9904.23.01",
      "rawHtsCode": "9904.23.01",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 25¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "27.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.23.02",
      "rawHtsCode": "9904.23.02",
      "superior": null,
      "indent": "2",
      "description": "Valued 25¢/kg or more but less than 35¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "20.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.23.03",
      "rawHtsCode": "9904.23.03",
      "superior": null,
      "indent": "2",
      "description": "Valued 35¢/kg or more but less than 45¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.23.04",
      "rawHtsCode": "9904.23.04",
      "superior": null,
      "indent": "2",
      "description": "Valued 45¢/kg or more but less than 55¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.23.05",
      "rawHtsCode": "9904.23.05",
      "superior": null,
      "indent": "2",
      "description": "Valued 55¢/kg or more but less than 65¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "7.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.23.06",
      "rawHtsCode": "9904.23.06",
      "superior": null,
      "indent": "2",
      "description": "Valued 65¢/kg or more but less than 75¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.23.07",
      "rawHtsCode": "9904.23.07",
      "superior": null,
      "indent": "2",
      "description": "Valued 75¢/kg or more but less than 85¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.23.08",
      "rawHtsCode": "9904.23.08",
      "superior": null,
      "indent": "2",
      "description": "Valued 85¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.23.09",
      "rawHtsCode": "9904.23.09",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "26.8¢/kg + 2.1%",
      "flags": []
    },
    {
      "htsCode": "9904.52.01",
      "rawHtsCode": "9904.52.01",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 35¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "51.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.02",
      "rawHtsCode": "9904.52.02",
      "superior": null,
      "indent": "2",
      "description": "Valued 35¢/kg or more but less than 55¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "36.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.03",
      "rawHtsCode": "9904.52.03",
      "superior": null,
      "indent": "2",
      "description": "Valued 55¢/kg or more but less than 75¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "24.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.04",
      "rawHtsCode": "9904.52.04",
      "superior": null,
      "indent": "2",
      "description": "Valued 75¢/kg or more but less than 95¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.05",
      "rawHtsCode": "9904.52.05",
      "superior": null,
      "indent": "2",
      "description": "Valued 95¢/kg or more but less than $1.15/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.06",
      "rawHtsCode": "9904.52.06",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.15/kg or more but less than $1.25/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.07",
      "rawHtsCode": "9904.52.07",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.25/kg or more but less than $1.35/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.08",
      "rawHtsCode": "9904.52.08",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.35/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.52.09",
      "rawHtsCode": "9904.52.09",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.10",
      "rawHtsCode": "9904.52.10",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "49.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.11",
      "rawHtsCode": "9904.52.11",
      "superior": null,
      "indent": "2",
      "description": "Valued 10¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "31.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.12",
      "rawHtsCode": "9904.52.12",
      "superior": null,
      "indent": "2",
      "description": "Valued 30¢/kg or more but less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "18.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.13",
      "rawHtsCode": "9904.52.13",
      "superior": null,
      "indent": "2",
      "description": "Valued 50¢/kg or more but less than 70¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.14",
      "rawHtsCode": "9904.52.14",
      "superior": null,
      "indent": "2",
      "description": "Valued 70¢/kg or more but less than 90¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "3.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.15",
      "rawHtsCode": "9904.52.15",
      "superior": null,
      "indent": "2",
      "description": "Valued 90¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.52.16",
      "rawHtsCode": "9904.52.16",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.17",
      "rawHtsCode": "9904.52.17",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "44.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.18",
      "rawHtsCode": "9904.52.18",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/kg or more but less than 40¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "28.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.19",
      "rawHtsCode": "9904.52.19",
      "superior": null,
      "indent": "2",
      "description": "Valued 40¢/kg or more but less than 60¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "16.7¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.20",
      "rawHtsCode": "9904.52.20",
      "superior": null,
      "indent": "2",
      "description": "Valued 60¢/kg or more but less than 80¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.21",
      "rawHtsCode": "9904.52.21",
      "superior": null,
      "indent": "2",
      "description": "Valued 80¢/kg or more but less than $1/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.22",
      "rawHtsCode": "9904.52.22",
      "superior": null,
      "indent": "2",
      "description": "Valued $1/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.52.23",
      "rawHtsCode": "9904.52.23",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.24",
      "rawHtsCode": "9904.52.24",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "98.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.25",
      "rawHtsCode": "9904.52.25",
      "superior": null,
      "indent": "2",
      "description": "Valued 50¢/kg or more but less than 80¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "73.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.26",
      "rawHtsCode": "9904.52.26",
      "superior": null,
      "indent": "2",
      "description": "Valued 80¢/kg or more but less than $1.10/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "52.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.27",
      "rawHtsCode": "9904.52.27",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.10/kg or more but less than $1.40/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "37.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.28",
      "rawHtsCode": "9904.52.28",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.40/kg or more but less than $1.70/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "23.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.29",
      "rawHtsCode": "9904.52.29",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.70/kg or more but less than $2/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "14.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.30",
      "rawHtsCode": "9904.52.30",
      "superior": null,
      "indent": "2",
      "description": "Valued $2/kg or more but less than $2.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "8.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.31",
      "rawHtsCode": "9904.52.31",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.20/kg or more but less than $2.30/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.32",
      "rawHtsCode": "9904.52.32",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.30/kg or more but less than $2.40/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.3¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.33",
      "rawHtsCode": "9904.52.33",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.40/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.52.34",
      "rawHtsCode": "9904.52.34",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.35",
      "rawHtsCode": "9904.52.35",
      "superior": null,
      "indent": "2",
      "description": "Valued less than $1.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "$3.159/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.36",
      "rawHtsCode": "9904.52.36",
      "superior": null,
      "indent": "2",
      "description": "Valued $1.20/kg or more but less than $2.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "$2.291/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.37",
      "rawHtsCode": "9904.52.37",
      "superior": null,
      "indent": "2",
      "description": "Valued $2.20/kg or more but less than $3.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "$1.591/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.38",
      "rawHtsCode": "9904.52.38",
      "superior": null,
      "indent": "2",
      "description": "Valued $3.20/kg or more but less than $4.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "$1.079/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.39",
      "rawHtsCode": "9904.52.39",
      "superior": null,
      "indent": "2",
      "description": "Valued $4.20/kg or more but less than $5.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "64.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.40",
      "rawHtsCode": "9904.52.40",
      "superior": null,
      "indent": "2",
      "description": "Valued $5.20/kg or more but less than $6.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "34.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.41",
      "rawHtsCode": "9904.52.41",
      "superior": null,
      "indent": "2",
      "description": "Valued $6.20/kg or more but less than $7.20/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "4.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.42",
      "rawHtsCode": "9904.52.42",
      "superior": null,
      "indent": "2",
      "description": "Valued $7.20/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.52.43",
      "rawHtsCode": "9904.52.43",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.6¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.44",
      "rawHtsCode": "9904.52.44",
      "superior": null,
      "indent": "2",
      "description": "Valued less than 10¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "24.1¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.45",
      "rawHtsCode": "9904.52.45",
      "superior": null,
      "indent": "2",
      "description": "Valued 10¢/kg or more but less than 20¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "15.9¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.46",
      "rawHtsCode": "9904.52.46",
      "superior": null,
      "indent": "2",
      "description": "Valued 20¢/kg or more but less than 30¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "9.8¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.47",
      "rawHtsCode": "9904.52.47",
      "superior": null,
      "indent": "2",
      "description": "Valued 30¢/kg or more but less than 40¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "5.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.48",
      "rawHtsCode": "9904.52.48",
      "superior": null,
      "indent": "2",
      "description": "Valued 40¢/kg or more but less than 50¢/kg",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "2.2¢/kg",
      "flags": []
    },
    {
      "htsCode": "9904.52.49",
      "rawHtsCode": "9904.52.49",
      "superior": null,
      "indent": "2",
      "description": "Valued 50¢/kg or more",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "No additional duty",
      "flags": []
    },
    {
      "htsCode": "9904.52.50",
      "rawHtsCode": "9904.52.50",
      "superior": null,
      "indent": "1",
      "description": "If entered during the effective period of safeguards based upon quantity announced by the Secretary of Agriculture",
      "units": [],
      "generalRate": "",
      "specialRate": "",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "additionalDuties": "10.5¢/kg",
      "flags": []
    },
    {
      "htsCode": "9908.04.01",
      "rawHtsCode": "9908.04.01",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheading 0401.50.75, 0403.90.78 or 0405.10.20 and subject to the quantitative limits specified in U.S. note 3 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (IL)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9908.04.03",
      "rawHtsCode": "9908.04.03",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheading 0402.10.50 or 0402.21.25 and subject to the quantitative limits specified in U.S. note 4 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (IL)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9908.04.05",
      "rawHtsCode": "9908.04.05",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheading 0406.10.08, 0406.10.18, 0406.10.28, 0406.10.38, 0406.10.48, 0406.10.58, 0406.10.68, 0406.10.78, 0406.10.88, 0406.20.28, 0406.20.33, 0406.20.39, 0406.20.48, 0406.20.53, 0406.20.63, 0406.20.67, 0406.20.71, 0406.20.75, 0406.20.79, 0406.20.83, 0406.20.87, 0406.20.91, 0406.30.18, 0406.30.28, 0406.30.38, 0406.30.48, 0406.30.53, 0406.30.63, 0406.30.67, 0406.30.71, 0406.30.75, 0406.30.79, 0406.30.83, 0406.30.87, 0406.30.91, 0406.40.70, 0406.90.12, 0406.90.18, 0406.90.32, 0406.90.37, 0406.90.42, 0406.90.48, 0406.90.54, 0406.90.68, 0406.90.74, 0406.90.78, 0406.90.84, 0406.90.88, 0406.90.92, 0406.90.94, 0406.90.97 or 1901.90.36 and subject to the quantitative limits specified in U.S. note 5 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (IL)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9908.12.01",
      "rawHtsCode": "9908.12.01",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheading 1202.30.80, 1202.41.80, 1202.42.20, 1202.42.90 or 2008.11.61 and subject to the quantitative limits specified in U.S. note 6 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (IL)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9908.21.01",
      "rawHtsCode": "9908.21.01",
      "superior": null,
      "indent": "1",
      "description": "Provided for in subheading 2105.00.20 and subject to the quantitative limits specified in U.S. note 7 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (IL)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.02.05",
      "rawHtsCode": "9915.02.05",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 4 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.02.10",
      "rawHtsCode": "9915.02.10",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.01",
      "rawHtsCode": "9915.04.01",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 5(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.02",
      "rawHtsCode": "9915.04.02",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 5(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.03",
      "rawHtsCode": "9915.04.03",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.05",
      "rawHtsCode": "9915.04.05",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 6(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.06",
      "rawHtsCode": "9915.04.06",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0401.50.75",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.07",
      "rawHtsCode": "9915.04.07",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.21.90 or 0403.90.65",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.08",
      "rawHtsCode": "9915.04.08",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.09",
      "rawHtsCode": "9915.04.09",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0405.10.20",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.10",
      "rawHtsCode": "9915.04.10",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0405.20.30, 2106.90.26 or 2106.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.11",
      "rawHtsCode": "9915.04.11",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0405.90.20",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.12",
      "rawHtsCode": "9915.04.12",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0401.50.75",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.13",
      "rawHtsCode": "9915.04.13",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.21.90 or 0403.90.65",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.556/kg (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.14",
      "rawHtsCode": "9915.04.14",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.15",
      "rawHtsCode": "9915.04.15",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0405.10.20",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.16",
      "rawHtsCode": "9915.04.16",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0405.20.30, 2106.90.26 or 2106.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.17",
      "rawHtsCode": "9915.04.17",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0405.90.20",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.20",
      "rawHtsCode": "9915.04.20",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 7(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.21",
      "rawHtsCode": "9915.04.21",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.10.50 or 0402.21.25",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.22",
      "rawHtsCode": "9915.04.22",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.21.50 or 0403.90.55",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.23",
      "rawHtsCode": "9915.04.23",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.90.45 or 0404.10.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.24",
      "rawHtsCode": "9915.04.24",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2309.90.28 or 2309.90.48",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.25",
      "rawHtsCode": "9915.04.25",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.10.50 or 0402.21.25",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.26",
      "rawHtsCode": "9915.04.26",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.21.50 or 0403.90.55",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.27",
      "rawHtsCode": "9915.04.27",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.90.45 or 0404.10.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.28",
      "rawHtsCode": "9915.04.28",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2309.90.28 or 2309.90.48",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.30",
      "rawHtsCode": "9915.04.30",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 8(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.31",
      "rawHtsCode": "9915.04.31",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.29.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.32",
      "rawHtsCode": "9915.04.32",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.91.70 or 0402.91.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.33",
      "rawHtsCode": "9915.04.33",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.99.45 or 0402.99.55",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.34",
      "rawHtsCode": "9915.04.34",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.99.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.35",
      "rawHtsCode": "9915.04.35",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.36",
      "rawHtsCode": "9915.04.36",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.90.95",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.37",
      "rawHtsCode": "9915.04.37",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0404.10.15",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.38",
      "rawHtsCode": "9915.04.38",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0404.90.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.39",
      "rawHtsCode": "9915.04.39",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0405.20.70 or 2106.90.66",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.40",
      "rawHtsCode": "9915.04.40",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1517.90.60",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.41",
      "rawHtsCode": "9915.04.41",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1704.90.58",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.42",
      "rawHtsCode": "9915.04.42",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.26, 1806.20.36, 1806.32.06 or 1806.32.16",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.43",
      "rawHtsCode": "9915.04.43",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.28, 1806.20.38, 1806.32.08 or 1806.32.18",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.44",
      "rawHtsCode": "9915.04.44",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.82 or 1806.20.87",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.45",
      "rawHtsCode": "9915.04.45",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.83 or 1806.20.89",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.46",
      "rawHtsCode": "9915.04.46",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.32.70, 1806.90.08, 1806.90.18 or 1806.90.28",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.47",
      "rawHtsCode": "9915.04.47",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.32.80, 1806.90.10, 1806.90.20 or 1806.90.30",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.48",
      "rawHtsCode": "9915.04.48",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.10.16, 1901.10.26, 1901.10.36 or 1901.10.44",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.49",
      "rawHtsCode": "9915.04.49",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.20.15 or 1901.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.50",
      "rawHtsCode": "9915.04.50",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.10.56, 1901.10.66, 1901.90.62 or 1901.90.65",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.51",
      "rawHtsCode": "9915.04.51",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2105.00.40",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.52",
      "rawHtsCode": "9915.04.52",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.09",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.53",
      "rawHtsCode": "9915.04.53",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.87",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.54",
      "rawHtsCode": "9915.04.54",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2202.99.28",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.55",
      "rawHtsCode": "9915.04.55",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.29.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.56",
      "rawHtsCode": "9915.04.56",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.91.70 or 0402.91.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.57",
      "rawHtsCode": "9915.04.57",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.99.45 or 0402.99.55",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.58",
      "rawHtsCode": "9915.04.58",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0402.99.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.59",
      "rawHtsCode": "9915.04.59",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.60",
      "rawHtsCode": "9915.04.60",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0403.90.95",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.61",
      "rawHtsCode": "9915.04.61",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0404.10.15",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.62",
      "rawHtsCode": "9915.04.62",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0404.90.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.63",
      "rawHtsCode": "9915.04.63",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0405.20.70 or 2106.90.66",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.64",
      "rawHtsCode": "9915.04.64",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1517.90.60",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.65",
      "rawHtsCode": "9915.04.65",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1704.90.58",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.66",
      "rawHtsCode": "9915.04.66",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.26, 1806.20.36, 1806.32.06 or 1806.32.16",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.67",
      "rawHtsCode": "9915.04.67",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.28, 1806.20.38, 1806.32.08 or 1806.32.18",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.68",
      "rawHtsCode": "9915.04.68",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.82 or 1806.20.87",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.69",
      "rawHtsCode": "9915.04.69",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.20.83 or 1806.20.89",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.70",
      "rawHtsCode": "9915.04.70",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.32.70, 1806.90.08, 1806.90.18 or 1806.90.28",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.71",
      "rawHtsCode": "9915.04.71",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1806.32.80, 1806.90.10, 1806.90.20 or 1806.90.30",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.72",
      "rawHtsCode": "9915.04.72",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.10.16, 1901.10.26, 1901.10.36 or 1901.10.44",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.73",
      "rawHtsCode": "9915.04.73",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.20.15 or 1901.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.74",
      "rawHtsCode": "9915.04.74",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1901.10.56, 1901.10.66, 1901.90.62 or 1901.90.65",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.75",
      "rawHtsCode": "9915.04.75",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2105.00.40",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.76",
      "rawHtsCode": "9915.04.76",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.09",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.77",
      "rawHtsCode": "9915.04.77",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2106.90.87",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.78",
      "rawHtsCode": "9915.04.78",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 2202.99.28",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.79",
      "rawHtsCode": "9915.04.79",
      "superior": null,
      "indent": "2",
      "description": "Goods provided for in subheading 0402.91.70, 0402.91.90, 0402.99.45 or 0402.99.55 subject to the quantitative limits specified in U.S. note 9 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.80",
      "rawHtsCode": "9915.04.80",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 10(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.81",
      "rawHtsCode": "9915.04.81",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.08, 0406.10.88, 0406.20.91, 0406.30.91 or 0406.90.97",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.82",
      "rawHtsCode": "9915.04.82",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.18, 0406.20.28, 0406.20.63, 0406.30.18, 0406.30.63, 0406.40.70 or 0406.90.74",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.83",
      "rawHtsCode": "9915.04.83",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.28, 0406.20.33, 0406.20.67, 0406.30.28, 0406.30.67, 0406.90.12 or 0406.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.84",
      "rawHtsCode": "9915.04.84",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.38, 0406.20.39, 0406.20.71, 0406.30.38, 0406.30.71, 0406.90.54 or 0406.90.84",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.85",
      "rawHtsCode": "9915.04.85",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.48, 0406.20.48, 0406.20.75, 0406.30.48, 0406.30.75, 0406.90.18 or 0406.90.88",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.86",
      "rawHtsCode": "9915.04.86",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.58, 0406.20.53, 0406.20.79, 0406.30.79, 0406.90.32, 0406.90.37, 0406.90.42 or 0406.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.87",
      "rawHtsCode": "9915.04.87",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.68, 0406.20.83, 0406.30.53, 0406.30.83 or 0406.90.92",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.88",
      "rawHtsCode": "9915.04.88",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.78, 0406.20.87, 0406.30.87, 0406.90.94 or 1901.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.89",
      "rawHtsCode": "9915.04.89",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.48",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.90",
      "rawHtsCode": "9915.04.90",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.08, 0406.10.88, 0406.20.91, 0406.30.91 or 0406.90.97",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.91",
      "rawHtsCode": "9915.04.91",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.18, 0406.20.28, 0406.20.63, 0406.30.18, 0406.30.63, 0406.40.70 or 0406.90.74",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.92",
      "rawHtsCode": "9915.04.92",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.28, 0406.20.33, 0406.20.67, 0406.30.28, 0406.30.67, 0406.90.12 or 0406.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.93",
      "rawHtsCode": "9915.04.93",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.38, 0406.20.39, 0406.20.71, 0406.30.38, 0406.30.71, 0406.90.54 or 0406.90.84",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.94",
      "rawHtsCode": "9915.04.94",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.48, 0406.20.48, 0406.20.75, 0406.30.48, 0406.30.75, 0406.90.18 or 0406.90.88",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.95",
      "rawHtsCode": "9915.04.95",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.58, 0406.20.53, 0406.20.79, 0406.30.79, 0406.90.32, 0406.90.37, 0406.90.42 or 0406.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.96",
      "rawHtsCode": "9915.04.96",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.68, 0406.20.83, 0406.30.53, 0406.30.83 or 0406.90.92",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.97",
      "rawHtsCode": "9915.04.97",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.10.78, 0406.20.87, 0406.30.87, 0406.90.94 or 1901.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.98",
      "rawHtsCode": "9915.04.98",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 0406.90.48",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.04.99",
      "rawHtsCode": "9915.04.99",
      "superior": null,
      "indent": "2",
      "description": "Goods provided for in subheading 0406.10.08, 0406.10.88, 0406.20.91, 0406.30.91 or 0406.90.97 subject to the quantitative limits specified in U.S. note 11 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.12.05",
      "rawHtsCode": "9915.12.05",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 12(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.12.10",
      "rawHtsCode": "9915.12.10",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1202.41.80",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.12.20",
      "rawHtsCode": "9915.12.20",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1202.30.80, 1202.42.80, 2008.11.35 or 2008.11.60",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.12.30",
      "rawHtsCode": "9915.12.30",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1202.41.80",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.12.40",
      "rawHtsCode": "9915.12.40",
      "superior": null,
      "indent": "4",
      "description": "Goods provided for in subheading 1202.30.80, 1202.42.80, 2008.11.35 or 2008.11.60",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.20.05",
      "rawHtsCode": "9915.20.05",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 13(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.20.10",
      "rawHtsCode": "9915.20.10",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 13(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.20.20",
      "rawHtsCode": "9915.20.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.21.05",
      "rawHtsCode": "9915.21.05",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 14(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.21.10",
      "rawHtsCode": "9915.21.10",
      "superior": null,
      "indent": "3",
      "description": "Subject to the quantitative limits specified in U.S. note 14(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.21.20",
      "rawHtsCode": "9915.21.20",
      "superior": null,
      "indent": "3",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.50.01",
      "rawHtsCode": "9915.50.01",
      "superior": null,
      "indent": "0",
      "description": "Socks, stockings and other hosiery and footwear without applied soles, of cotton, knitted or crocheted (provided for in subheading 6115.95.60 or 6115.95.90, and including such goods eligible for entry under heading 9802.00.80 or 9822.05.10), the foregoing which are originating goods of Honduras under the terms of general note 29 to the tariff schedule and are entered during the period from July 1, 2008 through December 31, 2008, inclusive",
      "units": [],
      "generalRate": "No change",
      "specialRate": "5% on the full value of the imported article",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.61.01",
      "rawHtsCode": "9915.61.01",
      "superior": null,
      "indent": "0",
      "description": "Apparel goods of Nicaragua, of cotton or man-made fibers, or subject to cotton or man-made fiber restraints, the foregoing described in U.S. note 15(b) to this subchapter and imported into the customs territory of the United States in aggregate quantities not to exceed the quantities set forth in U.S. note 15(c) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.61.03",
      "rawHtsCode": "9915.61.03",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in HTS 6112.41.00 described in U.S. note 17 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.61.04",
      "rawHtsCode": "9915.61.04",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in HTS 6112.49.00 described in U.S. note 17 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.61.05",
      "rawHtsCode": "9915.61.05",
      "superior": null,
      "indent": "0",
      "description": "Originating trousers, breeches or shorts of Nicaragua, under the terms of general note 29 to the tariff schedule, as described in subdivision (d) of U.S. note 15 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (P)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.62.05",
      "rawHtsCode": "9915.62.05",
      "superior": null,
      "indent": "0",
      "description": "Apparel goods of Costa Rica, not knitted or crocheted, containing 36 percent or more by weight of wool or subject to wool restraints, the foregoing described in U.S. note 16(b) to this subchapter and imported in aggre- gate annual quantities not to exceed the quantities set forth in U.S. note 16(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9915.62.15",
      "rawHtsCode": "9915.62.15",
      "superior": null,
      "indent": "0",
      "description": "Apparel goods of Costa Rica made from wool fabric (except fabric of carded wool, or made from wool yarn having an average fiber diameter of not more than 18.5 microns), the foregoing described in U.S. note 16(d) to this subchapter and imported in aggregate annual quantities not to exceed the quantities set forth in U.S. note 16(c) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.10",
      "rawHtsCode": "9917.04.10",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 3 (a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.11",
      "rawHtsCode": "9917.04.11",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.91.70 or 0402.91.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.12",
      "rawHtsCode": "9917.04.12",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.99.45 or 0402.99.55",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.13",
      "rawHtsCode": "9917.04.13",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.91.70 or 0402.91.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.14",
      "rawHtsCode": "9917.04.14",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.99.45 or 0402.99.55",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.20",
      "rawHtsCode": "9917.04.20",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 4 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.21",
      "rawHtsCode": "9917.04.21",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.29.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.22",
      "rawHtsCode": "9917.04.22",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.99.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.23",
      "rawHtsCode": "9917.04.23",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0403.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.24",
      "rawHtsCode": "9917.04.24",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0403.90.95",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.25",
      "rawHtsCode": "9917.04.25",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0404.10.15",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.26",
      "rawHtsCode": "9917.04.26",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0404.90.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.27",
      "rawHtsCode": "9917.04.27",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0405.20.70 or 2106.90.66",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.28",
      "rawHtsCode": "9917.04.28",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1517.90.60",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.29",
      "rawHtsCode": "9917.04.29",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1704.90.58",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.30",
      "rawHtsCode": "9917.04.30",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1806.20.82",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.31",
      "rawHtsCode": "9917.04.31",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1806.20.83",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.32",
      "rawHtsCode": "9917.04.32",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1806.32.70 or 1806.90.08",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.33",
      "rawHtsCode": "9917.04.33",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1806.32.80 or 1806.90.10",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.34",
      "rawHtsCode": "9917.04.34",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1901.10.26 or 1901.10.44",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.35",
      "rawHtsCode": "9917.04.35",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1901.20.15 or 1901.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.36",
      "rawHtsCode": "9917.04.36",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1901.10.56, 1901.10.60, 1901.90.62 or 1901.90.65",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.37",
      "rawHtsCode": "9917.04.37",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 2105.00.40",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.38",
      "rawHtsCode": "9917.04.38",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 2106.90.09",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.39",
      "rawHtsCode": "9917.04.39",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 2106.90.87",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.40",
      "rawHtsCode": "9917.04.40",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 2202.99.28",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.50",
      "rawHtsCode": "9917.04.50",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 5(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.51",
      "rawHtsCode": "9917.04.51",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.08, 0406.10.88, 0406.20.91, 0406.30.91 or 0406.90.97",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.52",
      "rawHtsCode": "9917.04.52",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.18, 0406.20.28, 0406.20.63, 0406.30.18, 0406.30.63, 0406.40.70 or 0406.90.74",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.53",
      "rawHtsCode": "9917.04.53",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.28, 0406.20.33, 0406.20.67, 0406.30.28, 0406.30.67, 0406.90.12 or 0406.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.54",
      "rawHtsCode": "9917.04.54",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.38, 0406.20.39, 0406.20.71, 0406.30.38, 0406.30.71, 0406.90.54 or 0406.90.84",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.55",
      "rawHtsCode": "9917.04.55",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.48, 0406.20.48, 0406.20.75, 0406.30.48, 0406.30.75, 0406.90.18 or 0406.90.88",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.56",
      "rawHtsCode": "9917.04.56",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.58, 0406.20.53, 0406.20.79, 0406.30.79, 0406.90.32, 0406.90.37, 0406.90.42 or 0406.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.57",
      "rawHtsCode": "9917.04.57",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.68, 0406.20.83, 0406.30.53, 0406.30.83 or 0406.90.92",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.58",
      "rawHtsCode": "9917.04.58",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.78, 0406.20.87, 0406.30.87, 0406.90.94 or 1901.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.59",
      "rawHtsCode": "9917.04.59",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.90.48",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.61",
      "rawHtsCode": "9917.04.61",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.08, 0406.10.88, 0406.20.91, 0406.30.91 or 0406.90.97",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.62",
      "rawHtsCode": "9917.04.62",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.18, 0406.20.28, 0406.20.63, 0406.30.18, 0406.30.63, 0406.40.70 or 0406.90.74",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.63",
      "rawHtsCode": "9917.04.63",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.28, 0406.20.33, 0406.20.67, 0406.30.28, 0406.30.67, 0406.90.12 or 0406.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.64",
      "rawHtsCode": "9917.04.64",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.38, 0406.20.39, 0406.20.71, 0406.30.38, 0406.30.71, 0406.90.54 or 0406.90.84",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.65",
      "rawHtsCode": "9917.04.65",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.48, 0406.20.48, 0406.20.75, 0406.30.48, 0406.30.75, 0406.90.18 or 0406.90.88",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.66",
      "rawHtsCode": "9917.04.66",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.58, 0406.20.53, 0406.20.79, 0406.30.79, 0406.90.32, 0406.90.37, 0406.90.42 or 0406.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.67",
      "rawHtsCode": "9917.04.67",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.68, 0406.20.83, 0406.30.53, 0406.30.83 or 0406.90.92",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.68",
      "rawHtsCode": "9917.04.68",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.78, 0406.20.87, 0406.30.87, 0406.90.94 or 1901.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9917.04.69",
      "rawHtsCode": "9917.04.69",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.90.48",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PE)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.02.01",
      "rawHtsCode": "9918.02.01",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 3(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.02.02",
      "rawHtsCode": "9918.02.02",
      "superior": null,
      "indent": "2",
      "description": "U.S. note 3 (b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.02.03",
      "rawHtsCode": "9918.02.03",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.01",
      "rawHtsCode": "9918.04.01",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 4 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.02",
      "rawHtsCode": "9918.04.02",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.04",
      "rawHtsCode": "9918.04.04",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 5 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.05",
      "rawHtsCode": "9918.04.05",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0401.50.75 or 0403.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.06",
      "rawHtsCode": "9918.04.06",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0405.10.20",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.07",
      "rawHtsCode": "9918.04.07",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0405.20.30, 2106.90.26, or 2106.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.08",
      "rawHtsCode": "9918.04.08",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0405.90.20",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.50",
      "rawHtsCode": "9918.04.50",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 6 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.51",
      "rawHtsCode": "9918.04.51",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.08, 0406.10.88, 0406.20.91, 0406.30.91 or 0406.90.97",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.52",
      "rawHtsCode": "9918.04.52",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.18, 0406.20.28, 0406.20.63, 0406.30.18, 0406.30.63, 0406.40.70 or 0406.90.74",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.53",
      "rawHtsCode": "9918.04.53",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.28, 0406.20.33, 0406.20.67, 0406.30.28, 0406.30.67, 0406.90.12 or 0406.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.54",
      "rawHtsCode": "9918.04.54",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.38, 0406.20.39, 0406.20.71, 0406.30.38, 0406.30.71, 0406.90.54 or 0406.90.84",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.55",
      "rawHtsCode": "9918.04.55",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.48, 0406.20.48, 0406.20.75, 0406.30.48, 0406.30.75, 0406.90.18 or 0406.90.88",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.56",
      "rawHtsCode": "9918.04.56",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.58, 0406.20.53, 0406.20.79, 0406.30.79, 0406.90.32, 0406.90.37, 0406.90.42 or 0406.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.57",
      "rawHtsCode": "9918.04.57",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.68, 0406.20.83, 0406.30.53, 0406.30.83 or 0406.90.92",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.58",
      "rawHtsCode": "9918.04.58",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.78, 0406.20.87, 0406.30.87, 0406.90.94 or 1901.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.59",
      "rawHtsCode": "9918.04.59",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.90.48",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.60",
      "rawHtsCode": "9918.04.60",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 7 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.61",
      "rawHtsCode": "9918.04.61",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.29.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.62",
      "rawHtsCode": "9918.04.62",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.99.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.63",
      "rawHtsCode": "9918.04.63",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0403.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.64",
      "rawHtsCode": "9918.04.64",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0403.90.95",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.65",
      "rawHtsCode": "9918.04.65",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0404.10.15",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.66",
      "rawHtsCode": "9918.04.66",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0404.90.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.67",
      "rawHtsCode": "9918.04.67",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0405.20.70 or 2106.90.66",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.68",
      "rawHtsCode": "9918.04.68",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1517.90.60",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.69",
      "rawHtsCode": "9918.04.69",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1704.90.58",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.70",
      "rawHtsCode": "9918.04.70",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1806.20.82",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.71",
      "rawHtsCode": "9918.04.71",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1806.20.83",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.72",
      "rawHtsCode": "9918.04.72",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1806.32.70 or 1806.90.08",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.73",
      "rawHtsCode": "9918.04.73",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1806.32.80 or 1806.90.10",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.74",
      "rawHtsCode": "9918.04.74",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1901.10.16, 1901.10.26 1901.10.36, or 1901.10.44",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.75",
      "rawHtsCode": "9918.04.75",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1901.20.15 or 1901.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.76",
      "rawHtsCode": "9918.04.76",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1901.10.56, 1901.10.66, 1901.90.62 or 1901.90.65",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.77",
      "rawHtsCode": "9918.04.77",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 2105.00.40",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.78",
      "rawHtsCode": "9918.04.78",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 2106.90.09",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.79",
      "rawHtsCode": "9918.04.79",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 2106.90.87",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.04.80",
      "rawHtsCode": "9918.04.80",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 2202.99.28",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.21.10",
      "rawHtsCode": "9918.21.10",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 8 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.21.11",
      "rawHtsCode": "9918.21.11",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.24.10",
      "rawHtsCode": "9918.24.10",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 9 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.24.11",
      "rawHtsCode": "9918.24.11",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (CO)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.24.15",
      "rawHtsCode": "9918.24.15",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 2402.20.10, 2402.20.80, 2402.20.90 or 2402.90.00 or heading 2403 (other than subheading 2403.19.90 or 2403.99.90)",
      "units": [],
      "generalRate": "",
      "specialRate": "Free",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9918.24.20",
      "rawHtsCode": "9918.24.20",
      "superior": null,
      "indent": "1",
      "description": "Goods provided for in subheading 2403.19.90 or 2403.99.90 Other",
      "units": [],
      "generalRate": "",
      "specialRate": "The duty rate provided for origin- ating goods of Colombia in such subheading",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.02.01",
      "rawHtsCode": "9919.02.01",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 3 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.02.02",
      "rawHtsCode": "9919.02.02",
      "superior": null,
      "indent": "2",
      "description": "Other.",
      "units": [
        ""
      ],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.10",
      "rawHtsCode": "9919.04.10",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 4(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.11",
      "rawHtsCode": "9919.04.11",
      "superior": null,
      "indent": "3",
      "description": "0402.91.70 or 0402.91.90 .",
      "units": [],
      "generalRate": "",
      "specialRate": "7.8¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.12",
      "rawHtsCode": "9919.04.12",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.99.45 or 0402.99.55 .",
      "units": [],
      "generalRate": "",
      "specialRate": "12.4¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.13",
      "rawHtsCode": "9919.04.13",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.91.70 or 0402.91.90 .",
      "units": [],
      "generalRate": "",
      "specialRate": "19.5¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.14",
      "rawHtsCode": "9919.04.14",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.99.45 or 0402.99.55 .",
      "units": [],
      "generalRate": "",
      "specialRate": "31¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.40",
      "rawHtsCode": "9919.04.40",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 5(a) to this subchapter .",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.41",
      "rawHtsCode": "9919.04.41",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 5(b) to this subchapter .",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.42",
      "rawHtsCode": "9919.04.42",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.50",
      "rawHtsCode": "9919.04.50",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 6(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.51",
      "rawHtsCode": "9919.04.51",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.18, 0406.20.28, 0406.20.63, 0406.30.18, 0406.30.63, 0406.40.70 or 0406.90.74",
      "units": [],
      "generalRate": "",
      "specialRate": "56.7¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.52",
      "rawHtsCode": "9919.04.52",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.28, 0406.20.33, 0406.20.67, 0406.30.28, 0406.30.67, 0406.90.12 or 0406.90.78",
      "units": [],
      "generalRate": "",
      "specialRate": "30.7¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.53",
      "rawHtsCode": "9919.04.53",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.38, 0406.20.39, 0406.20.71, 0406.30.38, 0406.30.71, 0406.90.54 or 0406.90.84",
      "units": [],
      "generalRate": "",
      "specialRate": "26.4¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.54",
      "rawHtsCode": "9919.04.54",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.48, 0406.20.48, 0406.20.75, 0406.30.48, 0406.30.75, 0406.90.18 or 0406.90.88",
      "units": [],
      "generalRate": "",
      "specialRate": "45.1¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.55",
      "rawHtsCode": "9919.04.55",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.58, 0406.20.53, 0406.20.79, 0406.30.79, 0406.90.32, 0406.90.37, 0406.90.42 or 0406.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "53.7¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.56",
      "rawHtsCode": "9919.04.56",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.68, 0406.20.83, 0406.30.53, 0406.30.83 or 0406.90.92",
      "units": [],
      "generalRate": "",
      "specialRate": "34.7¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.57",
      "rawHtsCode": "9919.04.57",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.78, 0406.20.87, 0406.30.87, 0406.90.94 or 1901.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "28.2¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.58",
      "rawHtsCode": "9919.04.58",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.90.48",
      "units": [],
      "generalRate": "",
      "specialRate": "46.9¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.61",
      "rawHtsCode": "9919.04.61",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.18, 0406.20.28, 0406.20.63, 0406.30.18, 0406.30.63, 0406.40.70 or 0406.90.74",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.41/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.62",
      "rawHtsCode": "9919.04.62",
      "superior": null,
      "indent": "3",
      "description": "0406.10.28, 0406.20.33, 0406.20.67, 0406.30.28, 0406.30.67, 0406.90.12 or 0406.90.78 .",
      "units": [],
      "generalRate": "",
      "specialRate": "76.7¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.63",
      "rawHtsCode": "9919.04.63",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.38, 0406.20.39, 0406.20.71, 0406.30.38, 0406.30.71, 0406.90.54 or 0406.90.84",
      "units": [],
      "generalRate": "",
      "specialRate": "65.9¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.64",
      "rawHtsCode": "9919.04.64",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.48, 0406.20.48, 0406.20.75, 0406.30.48, 0406.30.75, 0406.90.18 or 0406.90.88",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.12/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.65",
      "rawHtsCode": "9919.04.65",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.58, 0406.20.53, 0406.20.79, 0406.30.79, 0406.90.32, 0406.90.37, 0406.90.42 or 0406.90.68",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.34/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.66",
      "rawHtsCode": "9919.04.66",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.68, 0406.20.83, 0406.30.53, 0406.30.83 or 0406.90.92",
      "units": [],
      "generalRate": "",
      "specialRate": "86.6¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.67",
      "rawHtsCode": "9919.04.67",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.10.78, 0406.20.87, 0406.30.87, 0406.90.94 or 1901.90.36",
      "units": [],
      "generalRate": "",
      "specialRate": "70.5¢/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.04.68",
      "rawHtsCode": "9919.04.68",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0406.90.48",
      "units": [],
      "generalRate": "",
      "specialRate": "$1.17/kg (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.21.10",
      "rawHtsCode": "9919.21.10",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 7(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.21.11",
      "rawHtsCode": "9919.21.11",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 7(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.21.12",
      "rawHtsCode": "9919.21.12",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.61.01",
      "rawHtsCode": "9919.61.01",
      "superior": null,
      "indent": "2",
      "description": "Goods other than babiesʼ socks and booties currently provided for in 6111.20.60, 6111.30.50, or 6111.90.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.61.02",
      "rawHtsCode": "9919.61.02",
      "superior": null,
      "indent": "2",
      "description": "Babiesʼ socks and booties provided for in subheading 6111.20.60 .",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.61.03",
      "rawHtsCode": "9919.61.03",
      "superior": null,
      "indent": "2",
      "description": "Babiesʼ socks and booties provided for in subheading 6111.30.50 .",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.61.04",
      "rawHtsCode": "9919.61.04",
      "superior": null,
      "indent": "2",
      "description": "Babiesʼ socks and booties provided for in subheading 6111.90.50 .",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.61.05",
      "rawHtsCode": "9919.61.05",
      "superior": null,
      "indent": "2",
      "description": "Goods other than socks",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.61.06",
      "rawHtsCode": "9919.61.06",
      "superior": null,
      "indent": "2",
      "description": "Socks provided for in subheading 6115.94.00",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.61.07",
      "rawHtsCode": "9919.61.07",
      "superior": null,
      "indent": "2",
      "description": "Socks provided for in subheading 6115.95.60",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.61.08",
      "rawHtsCode": "9919.61.08",
      "superior": null,
      "indent": "2",
      "description": "Socks provided for in subheadings 6115.95.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.61.09",
      "rawHtsCode": "9919.61.09",
      "superior": null,
      "indent": "2",
      "description": "Socks provided for in subheading 6115.96.60 or 6115.99.14",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.61.10",
      "rawHtsCode": "9919.61.10",
      "superior": null,
      "indent": "2",
      "description": "Socks provided for in subheadings 6115.96.90 : or 6115.99.19",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.61.11",
      "rawHtsCode": "9919.61.11",
      "superior": null,
      "indent": "2",
      "description": "Socks provided for in subheading 6115.99.40",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9919.61.12",
      "rawHtsCode": "9919.61.12",
      "superior": null,
      "indent": "2",
      "description": "Socks provided for in subheading 6115.99.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (PA)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.10",
      "rawHtsCode": "9920.04.10",
      "superior": null,
      "indent": "2",
      "description": "Subject to the quantitative limits specified in U.S. note 3 to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.11",
      "rawHtsCode": "9920.04.11",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.29.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.12",
      "rawHtsCode": "9920.04.12",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0402.99.90",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.13",
      "rawHtsCode": "9920.04.13",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0403.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.14",
      "rawHtsCode": "9920.04.14",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0403.90.95",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.15",
      "rawHtsCode": "9920.04.15",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0404.10.15",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.16",
      "rawHtsCode": "9920.04.16",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0404.90.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.17",
      "rawHtsCode": "9920.04.17",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 0405.20.70 or 2106.90.66",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.18",
      "rawHtsCode": "9920.04.18",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1517.90.60",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.19",
      "rawHtsCode": "9920.04.19",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1704.90.58",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.20",
      "rawHtsCode": "9920.04.20",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1806.20.82",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.21",
      "rawHtsCode": "9920.04.21",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1806.20.83",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.22",
      "rawHtsCode": "9920.04.22",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1806.32.70 or 1806.90.08",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.23",
      "rawHtsCode": "9920.04.23",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1806.32.80 or 1806.90.10",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.24",
      "rawHtsCode": "9920.04.24",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1901.10.26 or 1901.10.44",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.25",
      "rawHtsCode": "9920.04.25",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1901.20.15 or 1901.20.50",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.26",
      "rawHtsCode": "9920.04.26",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 1901.10.56, 1901.10.60, 1901.90.62 or 1901.90.65",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.27",
      "rawHtsCode": "9920.04.27",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 2105.00.40",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.28",
      "rawHtsCode": "9920.04.28",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 2106.90.09",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.29",
      "rawHtsCode": "9920.04.29",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 2106.90.87",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.04.30",
      "rawHtsCode": "9920.04.30",
      "superior": null,
      "indent": "3",
      "description": "Goods provided for in subheading 2202.99.28",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.38.01",
      "rawHtsCode": "9920.38.01",
      "superior": null,
      "indent": "2",
      "description": "Perhalogenated with both fluorine and chlorine, but not with any other halogens",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.38.02",
      "rawHtsCode": "9920.38.02",
      "superior": null,
      "indent": "2",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.85.01",
      "rawHtsCode": "9920.85.01",
      "superior": null,
      "indent": "2",
      "description": "Insulated electric conductors, for a voltage not exceeding 80 V, fitted with connectors",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9920.85.02",
      "rawHtsCode": "9920.85.02",
      "superior": null,
      "indent": "2",
      "description": "Insulated electric conductors, for a voltage exceeding 80 V but not exceeding 1,000 V, fitted with connectors",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (KR)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        "See chapter 99 statistical note 1."
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9921.01.01",
      "rawHtsCode": "9921.01.01",
      "superior": null,
      "indent": "1",
      "description": "Of automotive air conditioners",
      "units": [],
      "generalRate": "",
      "specialRate": "1.4% (JP)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9921.01.02",
      "rawHtsCode": "9921.01.02",
      "superior": null,
      "indent": "1",
      "description": "Other",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (JP)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.01.01",
      "rawHtsCode": "9922.01.01",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 1(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.01.02",
      "rawHtsCode": "9922.01.02",
      "superior": null,
      "indent": "2",
      "description": "Goods of Canada provided for in note 1(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "22% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.01.03",
      "rawHtsCode": "9922.01.03",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 1(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.01.04",
      "rawHtsCode": "9922.01.04",
      "superior": null,
      "indent": "2",
      "description": "Goods of Canada provided for in note 1(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "27.3% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.01.05",
      "rawHtsCode": "9922.01.05",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 1(A) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.01.06",
      "rawHtsCode": "9922.01.06",
      "superior": null,
      "indent": "2",
      "description": "Goods of Canada provided for in note 1(b) to thissubchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "22% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.01.07",
      "rawHtsCode": "9922.01.07",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 1(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.01.08",
      "rawHtsCode": "9922.01.08",
      "superior": null,
      "indent": "2",
      "description": "Goods of Canada provided for in note 1(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "22% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.01.09",
      "rawHtsCode": "9922.01.09",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 1(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.01.10",
      "rawHtsCode": "9922.01.10",
      "superior": null,
      "indent": "2",
      "description": "Goods of Canada provided for in note 1(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "22% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.01.11",
      "rawHtsCode": "9922.01.11",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 1(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.01.12",
      "rawHtsCode": "9922.01.12",
      "superior": null,
      "indent": "2",
      "description": "Goods of Canada provided for in note 1(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "22% (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.52.01",
      "rawHtsCode": "9922.52.01",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 2(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.52.02",
      "rawHtsCode": "9922.52.02",
      "superior": null,
      "indent": "2",
      "description": "Goods of Canada provided for in note 2(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "5.2¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.52.03",
      "rawHtsCode": "9922.52.03",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 2(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.52.04",
      "rawHtsCode": "9922.52.04",
      "superior": null,
      "indent": "2",
      "description": "Goods of Canada provided for in note 2(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "5.2¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.52.05",
      "rawHtsCode": "9922.52.05",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 2(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.52.06",
      "rawHtsCode": "9922.52.06",
      "superior": null,
      "indent": "2",
      "description": "Goods of Canada provided for in note 2(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "5.2¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.52.07",
      "rawHtsCode": "9922.52.07",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 2(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.52.08",
      "rawHtsCode": "9922.52.08",
      "superior": null,
      "indent": "2",
      "description": "Goods of Canada provided for in note 2(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "5.2¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.52.09",
      "rawHtsCode": "9922.52.09",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 2(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.52.10",
      "rawHtsCode": "9922.52.10",
      "superior": null,
      "indent": "2",
      "description": "Goods of Canada provided for in note 2(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "1.3¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.52.11",
      "rawHtsCode": "9922.52.11",
      "superior": null,
      "indent": "2",
      "description": "Goods of Mexico or goods of the United States provided for in note 2(a) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "Free (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    },
    {
      "htsCode": "9922.52.12",
      "rawHtsCode": "9922.52.12",
      "superior": null,
      "indent": "2",
      "description": "Goods of Canada provided for in note 2(b) to this subchapter",
      "units": [],
      "generalRate": "",
      "specialRate": "5.2¢/kg (S+)",
      "otherRate": "",
      "quotaQuantity": null,
      "footnotesText": [
        " See chapter 99 statistical note 1. "
      ],
      "flags": [
        "SPECIAL_PROGRAM_INDICATOR_ALLOWED"
      ]
    }
  ]
}